//Global Variables and Arrays
var divIDsArray = [];
var divAndChartsArray = []; 
var isChartCalled = 0;
var targetElementArray = [];
var newtargetElementAndOptionsArray = [];
var pieChartOptionsDataCountVariable = 0;
var pieChartOptionsDataArray = [];
var columnChartOptionsDataCountVariable = 0;
var columnChartOptionDataArray = [];
var receivedDataForTableFirstTime = []; // Sorting original data when table is called for first time.
var isTableCalledForOnce = false; // Setting this variable to false for first time when chart is called.

// Icon Buttons section variables.
var filterRangeValueOne = 0;
var filterRangeValueTwo = 0;
var isFilterClicked = false;
var filterRangeValueOneForColumnChart = 0;
var filterRangeValueTwoForColumnChart = 0;
var isFilterClickedForColumnChart = false;
var filterRangeValueOneForDoNutChart = 0;
var filterRangeValueTwoForDoNutChart = 0;
var isFilterClickedForDoNutChart = false;
var filterRangeValueOneForHorizontalChart = 0;
var filterRangeValueTwoForHorizontalChart = 0;
var isFilterClickedForHorizontalChart = false;

var isDashboardBool = true; // By default setting the charts request is from dashboard module

var acinfotech = {

    requestType: function(bool){
        isDashboardBool = bool;

        // Empty all stored divs id and chart div elements
        newtargetElementAndOptionsArray = [];
        targetElementArray = [];
        divAndChartsArray = [];
        divIDsArray = [];
    },

    smallColumnChart: function(targetElement, options){
        
        var newJson = [];
        options.data.forEach(function(d, i) {
            var temp = {};
            
            for(var i = 0; i < Object.keys(d).length; i++) {
                delete d['enabled'];
                temp[Object.keys(d)[i]] = d[Object.keys(d)[i]]
            }
            
            newJson.push(temp)
        });

        // Creating chart Title
        var chartTitlePanelForColumnChart =  targetElement.append("div").style("position","absolute").style('background-color',options.BGcolor).style("text-indent","10px")
        .style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 10 + "%"; })
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:10.0%; font-size:12px; font-family:inter; text-transform:uppercase; color:#00001c;">'+ options.keys.label + " vs " + options.keys.value+ '</div>')
        
        // Creating SVG holder for chart
        var svgPanelForSmallColumnChart = targetElement .append('svg').style("position","absolute") .style('background-color',options.BGcolor) .style('border-width',"1.0px")
        .style('border-color',"#e1e1e1") .style('border-style',"none")
        svgPanelForSmallColumnChart.attr('width', 100 + "%") .attr('height', 90 + "%") .style("top",10 + "%") .style('background-color',options.BGcolor).append('g')
            
        // Setting the Margins
        var margin = {top: 15 , right: 35, bottom: 65, left: 6},
        width = (300 - margin.left) - margin.right; 
        height = (125  - margin.top) - margin.bottom;
            
        var jsonData = options.data
        var valueArray = [];
        var labelArray = [];
        
        newJson.forEach(function(d, i) {
                                             
            d[options.keys.value] = d[options.keys.value];
            valueArray.push(d[options.keys.value])
            labelArray.push(d[options.keys.label])
                             
        })
        
        var x = d3.scale.linear() .domain([0, d3.max(newJson.map(function(d) { return +d[options.keys.value]; }))]) .range([0, width]);
        
        var y = d3.scale.linear() .domain([0, d3.max(newJson.map(function(d) { return +d[options.keys.value]; }))]) .range([height, 0]);
        
        var yAxis = d3.svg.axis() .scale(y) .orient("left") .ticks(5);
        
        var svg = svgPanelForSmallColumnChart .append("svg") .style('background-color',options.BGcolor).style("border-radius","0px")
        .style("border-width","1px") .style("border-color","#d4d4d4") .style("border-style","solid") .append("g") .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
        
        // Add the text label for the Y axis
        var yAxisVariable = svg.append("text") .attr("transform", "rotate(-90)") .attr("y", -80) .attr("x",0 - (height / 2)) .attr("dy", "1em") .style("text-anchor", "middle")
        .style("font-family","Verdana,sans-serif") .style("font-size","11.0px") .text(options.yAxisLable) .style('fill','#00001c') .style("text-transform","capitalize");
        
        var x1 = d3.scale.ordinal() .domain(newJson.map(function(d) { return d[options.keys.label]; })) .rangeRoundBands([0, width], 0.25);
        
        var xAxis = d3.svg.axis() .scale(x1) .orient("bottom")
        //.ticks(40);
        
        // Adding the X Axis
        svg.append("g").attr("class", "x axis").attr("transform", "translate(0," + height + ")") .call(xAxis)
        
        // Add the X Axis margin labels
        .selectAll("text") .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') .attr("transform", function(d) { return "rotate(-40)" })
        .style("font-size","10.0px").style("font-family","Verdana,sans-serif") 
        .style("font-family","Verdana,sans-serif")
        .text(function(d,i) {
            if(d.length > 9)
                return d.substring(0,9)+'...';
            else
                return d;
        })
        
        // Adding the text label for the X axis
        var xAxisVariable =  svg.append("text") .attr("transform", "translate(" + ((width/2) - 20) + " ," + (height+margin.bottom - 5) + ")")
        .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif") .style("font-weight","Bold") .style("font-size","10.0px") .text(options.xAxisLable) .style('fill','#00001c') .style("text-transform","uppercase");
        
        // ----------------------------------- Creating Bars -----------------------------------
        
        var xScale = d3.scale.ordinal() .domain(d3.range(newJson.map(function(d) { return +d[options.keys.value]; }).length)) .rangeRoundBands([0, width], 0.25);
        
        var yScale = d3.scale.linear() .domain([0, d3.max(newJson.map(function(d) { return +d[options.keys.value]; }), function(d) { return d; })]) .range([0, height]);
        
        var colors = d3.scale.ordinal() .range(["#ff6c3e", "#ffbb03", "#3fcb56", "#d05767", "#55bf9b", "#0095b3", "#7a92a9","#663399","#29b5eb","#ff9878","#CCCCCC","#008d8d"]);

        //Creating bars
        var verticalBarsForSmallColumnChart = svg.selectAll(".bar") .data(newJson.map(function(d) { return +d[options.keys.value]; })) .enter() .append("rect") .attr("class", "bar") //.attr("fill",function(d,i){  return colors(i);  }) //.style("fill-opacity", 0.62)
        .style("fill",function(d,i){return colors(i)}).style("fill-opacity",0.98)
        
        verticalBarsForSmallColumnChart.transition() .delay(function (d, i) { return i / valueArray.length * 200; }) .duration(200) .attr("x", function (d,i) {  return xScale(i);  }) .attr("y", function (d) { return height - yScale(d); })
        .attr("width", xScale.rangeBand())  .attr("height", function (d) { return yScale(d); });

        verticalBarsForSmallColumnChart.on("mouseover", function(d,i){
        verticalBarsForSmallColumnChart.style("cursor","auto")
        })

    },

    allCharts: function(targetElement,options,chartName){
    if(isDashboardBool){ // If the chart requests are from dashboard module
        
        var newTemp = {};
        newTemp["targetElement"] = targetElement
        newTemp["options"] = options
        newtargetElementAndOptionsArray.push(newTemp)
        for(var i = 0; i < newtargetElementAndOptionsArray.length; i++){
            for(var x = i + 1; x <newtargetElementAndOptionsArray.length; x++){
                if(newtargetElementAndOptionsArray[x].targetElement[0][0].id == newtargetElementAndOptionsArray[i].targetElement[0][0].id){
                newtargetElementAndOptionsArray.splice(x,1)
                --x;
            }
            }
        }
        
        targetElementArray.push(targetElement)
        
        
        for(var i = 0; i < targetElementArray.length; i++){
            for(var x = i + 1; x <targetElementArray.length; x++){
                if(targetElementArray[x][0][0].id == targetElementArray[i][0][0].id){
                    targetElementArray.splice(x,1)
                    --x;
                }
            }
        }
        
        var sampleIDS=targetElement[0];
        divIDsArray.push(sampleIDS[0].id)// = sampleIDS[0].id
        
        
        function filter(arr){
            var tmp = [];
            for(var i = 0; i < arr.length; i++){
                if(tmp.indexOf(arr[i]) == -1){
                    tmp.push(arr[i])
                    //divAndChartsArray[[i][i]] = arr[i]
                }
            }
            return tmp;
        }

        var filteredArray =  []
        filteredArray = filter(divIDsArray);
        
        for(var i=0; i<filteredArray.length; i++){
            
            if(filteredArray[i] === sampleIDS[0].id){
                
                var temp = {};
                temp["divID"] = filteredArray[i];
                temp["chartName"] = chartName;
                temp["optionsData"] = options.data;
                if(isChartCalled == 1){
                    divAndChartsArray.push(temp)
                    
                }
                
                if(isChartCalled > 1){
                    
                    for(var i = 0; i<divAndChartsArray.length; i++){
                        
                        if(divAndChartsArray[i].divID === temp.divID){
                            divAndChartsArray[i].chartName = temp.chartName;
                        }
                    }

                    divAndChartsArray.push(temp)
                }

                for(var i = 0; i < divAndChartsArray.length; i++){
                    for(var x = i + 1; x <divAndChartsArray.length; x++){
                        if(divAndChartsArray[x].divID == divAndChartsArray[i].divID){
                        divAndChartsArray.splice(x,1)
                        --x;
                    }
                    }
                }
            
            } //if(filteredArray[i] === sampleIDS[0].id)

            else{
                
            }
            
        } // for(var i=0; i<filteredArray.length; i++) ends here.

    }
    else { // If the chart requests are from create dashboard module
        
        var newTemp = {};
        newTemp["targetElement"] = targetElement
        newTemp["options"] = options
        newtargetElementAndOptionsArray.push(newTemp)
        /*for(var i = 0; i < newtargetElementAndOptionsArray.length; i++){
            for(var x = i + 1; x <newtargetElementAndOptionsArray.length; x++){
                if(newtargetElementAndOptionsArray[x].targetElement[0][0].id == newtargetElementAndOptionsArray[i].targetElement[0][0].id){
                newtargetElementAndOptionsArray.splice(x,1)
                --x;
            }
            }
        }*/ 
        
        targetElementArray.push(targetElement)
        
        
        /*for(var i = 0; i < targetElementArray.length; i++){
            for(var x = i + 1; x <targetElementArray.length; x++){
                if(targetElementArray[x][0][0].id == targetElementArray[i][0][0].id){
                    targetElementArray.splice(x,1)
                    --x;
                }
            }
        }*/
        
        var sampleIDS=targetElement[0];
        divIDsArray.push(sampleIDS[0].id)// = sampleIDS[0].id
        
        
        function filter(arr){
            var tmp = [];
            for(var i = 0; i < arr.length; i++){
                if(tmp.indexOf(arr[i]) == -1){
                    tmp.push(arr[i])
                    //divAndChartsArray[[i][i]] = arr[i]
                }
            }
            return tmp;
        }

        var filteredArray =  []
        filteredArray = filter(divIDsArray);
        
        for(var i=0; i<filteredArray.length; i++){
            
            if(filteredArray[i] === sampleIDS[0].id){
                
                var temp = {};
                temp["divID"] = filteredArray[i];
                temp["chartName"] = chartName;
                temp["optionsData"] = options.data;
                
                if(isChartCalled == 1){
                    divAndChartsArray.push(temp)
                    
                }
                
                if(isChartCalled > 1){
                    
                    for(var i = 0; i<divAndChartsArray.length; i++){
                        
                        if(divAndChartsArray[i].divID === temp.divID){
                            divAndChartsArray[i].chartName = temp.chartName;
                        }
                    }

                    divAndChartsArray.push(temp)
                }

                /*for(var i = 0; i < divAndChartsArray.length; i++){
                    for(var x = i + 1; x <divAndChartsArray.length; x++){
                        if(divAndChartsArray[x].divID == divAndChartsArray[i].divID){
                        divAndChartsArray.splice(x,1)
                        --x;
                    }
                    }
                }*/
            
            } //if(filteredArray[i] === sampleIDS[0].id)

            else{
                
            }
            
        } // for(var i=0; i<filteredArray.length; i++) ends here.

    }

    var d = document.getElementById(options.resizeButtonID).id
    d3.select("#"+ d ).on("click", resizeButtonClicked);
    function resizeButtonClicked(){
        
        for(var i = 0; i<divAndChartsArray.length; i++){
            
            if(divAndChartsArray[i].chartName === "PIECHART"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])

                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {
                    
                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    var newOptionsObjectForPieChart = {};
                    newOptionsObjectForPieChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForPieChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForPieChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptionsObjectForPieChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable
                    newOptionsObjectForPieChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForPieChart["legendSide"] = "right"//newtargetElementAndOptionsArray[i].options.legendSide;
                    newOptionsObjectForPieChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForPieChart["gradient"] = newtargetElementAndOptionsArray[i].options.gradient;
                    newOptionsObjectForPieChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForPieChart["showLegend"] = newtargetElementAndOptionsArray[i].options.showLegend
                    newOptionsObjectForPieChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForPieChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForPieChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForPieChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForPieChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForPieChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForPieChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForPieChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForPieChart;
                    acinfotech.pieChart(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
                
            }  
            else if(divAndChartsArray[i].chartName === "COLUMNCHART"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {

                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForColumnChart = {};
                    newOptionsObjectForColumnChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForColumnChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForColumnChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptionsObjectForColumnChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForColumnChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForColumnChart["xAxisLable"] = newtargetElementAndOptionsArray[i].options.keys.label;
                    newOptionsObjectForColumnChart["yAxisLable"] = newtargetElementAndOptionsArray[i].options.keys.value;
                    newOptionsObjectForColumnChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForColumnChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForColumnChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForColumnChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForColumnChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForColumnChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForColumnChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForColumnChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForColumnChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForColumnChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForColumnChart;
                    acinfotech.columnChart(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
                
            }
            else if(divAndChartsArray[i].chartName === "DONUTCHART"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {

                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForDoNutChart = {};
                    newOptionsObjectForDoNutChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForDoNutChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForDoNutChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptionsObjectForDoNutChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForDoNutChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForDoNutChart["legendSide"] = "right"//newtargetElementAndOptionsArray[i].options.legendSide;
                    newOptionsObjectForDoNutChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID
                    newOptionsObjectForDoNutChart["gradient"] = newtargetElementAndOptionsArray[i].options.gradient;
                    newOptionsObjectForDoNutChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForDoNutChart["showLegend"] =newtargetElementAndOptionsArray[i].options.showLegend
                    newOptionsObjectForDoNutChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForDoNutChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForDoNutChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForDoNutChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForDoNutChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForDoNutChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForDoNutChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForDoNutChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForDoNutChart;
                    acinfotech.donutChart(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }
            else if(divAndChartsArray[i].chartName === "HORIZONTALCHART"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {

                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForHorizontalChart = {};
                    newOptionsObjectForHorizontalChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForHorizontalChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForHorizontalChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptionsObjectForHorizontalChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForHorizontalChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForHorizontalChart["xAxisLable"] = newtargetElementAndOptionsArray[i].options.keys.value;
                    newOptionsObjectForHorizontalChart["yAxisLable"] = newtargetElementAndOptionsArray[i].options.keys.label;
                    newOptionsObjectForHorizontalChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForHorizontalChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForHorizontalChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForHorizontalChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForHorizontalChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForHorizontalChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForHorizontalChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForHorizontalChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForHorizontalChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForHorizontalChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForHorizontalChart;
                    acinfotech.horizontalChart(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }
            else if(divAndChartsArray[i].chartName === "MAPCHART"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {

                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForMapChart = {};
                    newOptionsObjectForMapChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForMapChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForMapChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForMapChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForMapChart["maximize"] = newtargetElementAndOptionsArray[i].options.maximize;
                    newOptionsObjectForMapChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForMapChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForMapChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForMapChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForMapChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForMapChart;
                    acinfotech.map(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }
            else if(divAndChartsArray[i].chartName === "COLUMNANDLINECHART"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {

                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForColAndLineChart = {};
                    newOptionsObjectForColAndLineChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForColAndLineChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForColAndLineChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptionsObjectForColAndLineChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForColAndLineChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForColAndLineChart["xAxisLable"] = newtargetElementAndOptionsArray[i].options.xAxisLable;
                    newOptionsObjectForColAndLineChart["yLeftAxisLable"] = newtargetElementAndOptionsArray[i].options.yLeftAxisLable;
                    newOptionsObjectForColAndLineChart["yRightAxisLable"] = newtargetElementAndOptionsArray[i].options.yRightAxisLable;
                    newOptionsObjectForColAndLineChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForColAndLineChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForColAndLineChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForColAndLineChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForColAndLineChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForColAndLineChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForColAndLineChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForColAndLineChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForColAndLineChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForColAndLineChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForColAndLineChart;
                    acinfotech.columnAndLineChart(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }

            else if(divAndChartsArray[i].chartName === "PERGAUGE"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {

                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForPerGauge = {};
                    newOptionsObjectForPerGauge["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForPerGauge["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForPerGauge["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForPerGauge["showTitle"] = true; 
                    newOptionsObjectForPerGauge["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor
                    newOptionsObjectForPerGauge["series"] = newtargetElementAndOptionsArray[i].options.series; 
                    newOptionsObjectForPerGauge["legend"] = newtargetElementAndOptionsArray[i].options.legend;  
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForPerGauge;
                    acinfotech.perGauge(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }

            else if(divAndChartsArray[i].chartName === "NUMBERGAUGE"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {

                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForNumberGauge = {};
                    newOptionsObjectForNumberGauge["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForNumberGauge["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForNumberGauge["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForNumberGauge["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForNumberGauge["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForNumberGauge["series"] = newtargetElementAndOptionsArray[i].options.series; 
                    newOptionsObjectForNumberGauge["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newOptionsObjectForNumberGauge["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;     
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForNumberGauge;
                    acinfotech.numberGauge(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }

            else if(divAndChartsArray[i].chartName === "LINECHART"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {

                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                        
                    var newOptionsObjectForLineChart = {};
                    newOptionsObjectForLineChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForLineChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForLineChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptionsObjectForLineChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForLineChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForLineChart["xAxisLable"] = newtargetElementAndOptionsArray[i].options.xAxisLable;
                    newOptionsObjectForLineChart["yAxisLable"] = newtargetElementAndOptionsArray[i].options.yLeftAxisLable;
                    newOptionsObjectForLineChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForLineChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForLineChart["lineStyle"] = newtargetElementAndOptionsArray[i].options.lineStyle;
                    newOptionsObjectForLineChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForLineChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForLineChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForLineChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForLineChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForLineChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForLineChart["series"] = newtargetElementAndOptionsArray[i].options.series; 
                    newOptionsObjectForLineChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;                        
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForLineChart;
                    acinfotech.lineChart(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                   
                } 
            }

            else if(divAndChartsArray[i].chartName === "AREACHART"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {

                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                        
                    var newOptionsObjectForAreaChart = {};
                    newOptionsObjectForAreaChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForAreaChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForAreaChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptionsObjectForAreaChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForAreaChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForAreaChart["xAxisLable"] = newtargetElementAndOptionsArray[i].options.xAxisLable;
                    newOptionsObjectForAreaChart["yAxisLable"] = newtargetElementAndOptionsArray[i].options.yLeftAxisLable;
                    newOptionsObjectForAreaChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForAreaChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForAreaChart["lineStyle"] = newtargetElementAndOptionsArray[i].options.lineStyle;
                    newOptionsObjectForAreaChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForAreaChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForAreaChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForAreaChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForAreaChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForAreaChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForAreaChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForAreaChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForAreaChart;
                    acinfotech.areaChart(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }

            else if(divAndChartsArray[i].chartName === "BUBBLECHART"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {

                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForBubbleChart = {};
                    newOptionsObjectForBubbleChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForBubbleChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForBubbleChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptionsObjectForBubbleChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForBubbleChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForBubbleChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForBubbleChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForBubbleChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForBubbleChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForBubbleChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForBubbleChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForBubbleChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForBubbleChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForBubbleChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForBubbleChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForBubbleChart;
                    acinfotech.bubbleChart(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }

            else if(divAndChartsArray[i].chartName === "PERGAUGEWITHFLIP"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {

                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForPerGaugeWithFlip = {};
                    newOptionsObjectForPerGaugeWithFlip["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForPerGaugeWithFlip["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForPerGaugeWithFlip["coveredCircularAreaText"] = newtargetElementAndOptionsArray[i].options.coveredCircularAreaText;
                    newOptionsObjectForPerGaugeWithFlip["unCoveredCircularAreaText"] = newtargetElementAndOptionsArray[i].options.unCoveredCircularAreaText;
                    newOptionsObjectForPerGaugeWithFlip["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForPerGaugeWithFlip["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForPerGaugeWithFlip["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor
                    newOptionsObjectForPerGaugeWithFlip["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForPerGaugeWithFlip["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForPerGaugeWithFlip;
                    acinfotech.perGaugeWithFlip(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }

            else if(divAndChartsArray[i].chartName === "STACKEDHORIZONTALBARCHART"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {

                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForStackedHoriBarChart = {};
                    newOptionsObjectForStackedHoriBarChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForStackedHoriBarChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForStackedHoriBarChart["dataForDrillDown"] = newtargetElementAndOptionsArray[i].options.dataForDrillDown;
                    newOptionsObjectForStackedHoriBarChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptionsObjectForStackedHoriBarChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForStackedHoriBarChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForStackedHoriBarChart["xAxisLable"] = newtargetElementAndOptionsArray[i].options.xAxisLable;
                    newOptionsObjectForStackedHoriBarChart["yAxisLable"] = newtargetElementAndOptionsArray[i].options.yAxisLable;
                    //newOptionsObjectForStackedHoriBarChart["dimensions"] = newtargetElementAndOptionsArray[i].options.dimensions;
                    //newOptionsObjectForStackedHoriBarChart["measures"] = newtargetElementAndOptionsArray[i].options.measures;
                    newOptionsObjectForStackedHoriBarChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForStackedHoriBarChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForStackedHoriBarChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForStackedHoriBarChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForStackedHoriBarChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForStackedHoriBarChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForStackedHoriBarChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForStackedHoriBarChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForStackedHoriBarChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForStackedHoriBarChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForStackedHoriBarChart;
                    acinfotech.stackedHorizontalBarChart(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }

            else if(divAndChartsArray[i].chartName === "STACKEDBARCHART"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {

                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForStackedBarChart = {};
                    newOptionsObjectForStackedBarChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForStackedBarChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForStackedBarChart["dataForDrillDown"] = newtargetElementAndOptionsArray[i].options.dataForDrillDown;
                    newOptionsObjectForStackedBarChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptionsObjectForStackedBarChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForStackedBarChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForStackedBarChart["xAxisLable"] = newtargetElementAndOptionsArray[i].options.xAxisLable;
                    newOptionsObjectForStackedBarChart["yAxisLable"] = newtargetElementAndOptionsArray[i].options.yAxisLable;
                    //newOptionsObjectForStackedBarChart["dimensions"] = newtargetElementAndOptionsArray[i].options.dimensions;
                    //newOptionsObjectForStackedBarChart["measures"] = newtargetElementAndOptionsArray[i].options.measures;
                    newOptionsObjectForStackedBarChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForStackedBarChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForStackedBarChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForStackedBarChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForStackedBarChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForStackedBarChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForStackedBarChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForStackedBarChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForStackedBarChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForStackedBarChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForStackedBarChart;
                    acinfotech.stackedBarChart(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }

            else if(divAndChartsArray[i].chartName === "GROUPEDBARCHART"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {

                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForGroupBarChart = {};
                    newOptionsObjectForGroupBarChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForGroupBarChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForGroupBarChart["dataForDrillDown"] = newtargetElementAndOptionsArray[i].options.dataForDrillDown;
                    newOptionsObjectForGroupBarChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptionsObjectForGroupBarChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForGroupBarChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForGroupBarChart["xAxisLable"] = newtargetElementAndOptionsArray[i].options.xAxisLable;
                    newOptionsObjectForGroupBarChart["yAxisLable"] = newtargetElementAndOptionsArray[i].options.yAxisLable;
                    //newOptionsObjectForStackedBarChart["dimensions"] = newtargetElementAndOptionsArray[i].options.dimensions;
                    //newOptionsObjectForStackedBarChart["measures"] = newtargetElementAndOptionsArray[i].options.measures;
                    newOptionsObjectForGroupBarChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForGroupBarChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForGroupBarChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForGroupBarChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForGroupBarChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForGroupBarChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForGroupBarChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForGroupBarChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForGroupBarChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForGroupBarChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForGroupBarChart;
                    acinfotech.groupedBarChart(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }

            else if(divAndChartsArray[i].chartName === "HORIZONTALGROUPEDBARCHART"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {

                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForHoriGrpBarChart = {};
                    newOptionsObjectForHoriGrpBarChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForHoriGrpBarChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForHoriGrpBarChart["dataForDrillDown"] = newtargetElementAndOptionsArray[i].options.dataForDrillDown;
                    newOptionsObjectForHoriGrpBarChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptionsObjectForHoriGrpBarChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForHoriGrpBarChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForHoriGrpBarChart["xAxisLable"] = newtargetElementAndOptionsArray[i].options.xAxisLable;
                    newOptionsObjectForHoriGrpBarChart["yAxisLable"] = newtargetElementAndOptionsArray[i].options.yAxisLable;
                    //newOptionsObjectForStackedBarChart["dimensions"] = newtargetElementAndOptionsArray[i].options.dimensions;
                    //newOptionsObjectForStackedBarChart["measures"] = newtargetElementAndOptionsArray[i].options.measures;
                    newOptionsObjectForHoriGrpBarChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForHoriGrpBarChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForHoriGrpBarChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForHoriGrpBarChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForHoriGrpBarChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForHoriGrpBarChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForHoriGrpBarChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForHoriGrpBarChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForHoriGrpBarChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForHoriGrpBarChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForHoriGrpBarChart;
                    acinfotech.horizontalGroupedBarChart(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }

            else if(divAndChartsArray[i].chartName === "BELLCURVECHART"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {

                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForBellCurveChart = {};
                    newOptionsObjectForBellCurveChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForBellCurveChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForBellCurveChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForBellCurveChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForBellCurveChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForBellCurveChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForBellCurveChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForBellCurveChart;
                    acinfotech.bellCurveChart(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }

            else if(divAndChartsArray[i].chartName === "TABLE"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {

                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForTable = {};
                    newOptionsObjectForTable["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForTable["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForTable["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForTable["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForTable["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForTable["fontStyle"] = newtargetElementAndOptionsArray[i].options.fontStyle;
                    newOptionsObjectForTable["fontWeight"] = newtargetElementAndOptionsArray[i].options.fontWeight;
                    newOptionsObjectForTable["fontFamily"] = newtargetElementAndOptionsArray[i].options.fontFamily;
                
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForTable;
                    acinfotech.table(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }
            
            else if(divAndChartsArray[i].chartName === "LINECHART2"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {
                    
                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForLineChart = {};
                    newOptionsObjectForLineChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForLineChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForLineChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptionsObjectForLineChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForLineChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForLineChart["xAxisLable"] = newtargetElementAndOptionsArray[i].options.xAxisLable;
                    newOptionsObjectForLineChart["yAxisLable"] = newtargetElementAndOptionsArray[i].options.yLeftAxisLable;
                    newOptionsObjectForLineChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForLineChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForLineChart["lineStyle"] = newtargetElementAndOptionsArray[i].options.lineStyle;
                    newOptionsObjectForLineChart["showTitle"] = true; //newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForLineChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForLineChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForLineChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForLineChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForLineChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForLineChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForLineChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForLineChart;
                    acinfotech.lineChart2(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }
                
            else if(divAndChartsArray[i].chartName === "AREACHART2"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {
                    
                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForAreaChart = {};
                    newOptionsObjectForAreaChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForAreaChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForAreaChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptionsObjectForAreaChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForAreaChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForAreaChart["xAxisLable"] = newtargetElementAndOptionsArray[i].options.xAxisLable;
                    newOptionsObjectForAreaChart["yAxisLable"] = newtargetElementAndOptionsArray[i].options.yLeftAxisLable;
                    newOptionsObjectForAreaChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForAreaChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForAreaChart["lineStyle"] = newtargetElementAndOptionsArray[i].options.lineStyle;
                    newOptionsObjectForAreaChart["showTitle"] = true; //newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForAreaChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForAreaChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForAreaChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForAreaChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForAreaChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForAreaChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForAreaChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForAreaChart;
                    acinfotech.areaChart2(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }
            else if(divAndChartsArray[i].chartName === "BUBBLECHART2"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {
                    
                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForBubbleChart = {};
                    newOptionsObjectForBubbleChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForBubbleChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForBubbleChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptionsObjectForBubbleChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForBubbleChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForBubbleChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForBubbleChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForBubbleChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForBubbleChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForBubbleChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForBubbleChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForBubbleChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForBubbleChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForBubbleChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForBubbleChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForBubbleChart;
                    acinfotech.bubbleChart2(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }
            
            else if(divAndChartsArray[i].chartName === "STACKEDHORIZONTALBARCHART2"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {
                   
                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForStackedHoriBarChart = {};
                    newOptionsObjectForStackedHoriBarChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForStackedHoriBarChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForStackedHoriBarChart["dataForDrillDown"] = newtargetElementAndOptionsArray[i].options.dataForDrillDown;
                    newOptionsObjectForStackedHoriBarChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptionsObjectForStackedHoriBarChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForStackedHoriBarChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForStackedHoriBarChart["xAxisLable"] = newtargetElementAndOptionsArray[i].options.xAxisLable;
                    newOptionsObjectForStackedHoriBarChart["yAxisLable"] = newtargetElementAndOptionsArray[i].options.yAxisLable;
                    newOptionsObjectForStackedHoriBarChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForStackedHoriBarChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForStackedHoriBarChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForStackedHoriBarChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForStackedHoriBarChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForStackedHoriBarChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForStackedHoriBarChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForStackedHoriBarChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForStackedHoriBarChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForStackedHoriBarChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForStackedHoriBarChart;
                    acinfotech.stackedHorizontalBarChart2(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }
            
            else if(divAndChartsArray[i].chartName === "STACKEDBARCHART2"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {
                    
                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForStackedBarChart = {};
                    newOptionsObjectForStackedBarChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForStackedBarChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForStackedBarChart["dataForDrillDown"] = newtargetElementAndOptionsArray[i].options.dataForDrillDown;
                    newOptionsObjectForStackedBarChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptionsObjectForStackedBarChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForStackedBarChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForStackedBarChart["xAxisLable"] = newtargetElementAndOptionsArray[i].options.xAxisLable;
                    newOptionsObjectForStackedBarChart["yAxisLable"] = newtargetElementAndOptionsArray[i].options.yAxisLable;
                    newOptionsObjectForStackedBarChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForStackedBarChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForStackedBarChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForStackedBarChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForStackedBarChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForStackedBarChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForStackedBarChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForStackedBarChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForStackedBarChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForStackedBarChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForStackedBarChart;
                    acinfotech.stackedBarChart2(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }
            
            else if(divAndChartsArray[i].chartName === "TREEMAP"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {
                    
                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForTreeMap = {};
                    newOptionsObjectForTreeMap["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForTreeMap["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForTreeMap["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptionsObjectForTreeMap["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForTreeMap["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForTreeMap["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForTreeMap["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForTreeMap["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForTreeMap["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForTreeMap["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForTreeMap["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForTreeMap["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForTreeMap["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForTreeMap;
                    acinfotech.treeMap(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }
            else if(divAndChartsArray[i].chartName === "STACKEDCIRCULARAREACHART"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {
                    
                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForStackedCirAreaChart = {};
                    newOptionsObjectForStackedCirAreaChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForStackedCirAreaChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForStackedCirAreaChart["dataForDrillDown"] = newtargetElementAndOptionsArray[i].options.dataForDrillDown;
                    newOptionsObjectForStackedCirAreaChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptionsObjectForStackedCirAreaChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForStackedCirAreaChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    //newOptionsObjectForStackedCirAreaChart["xAxisLable"] = newtargetElementAndOptionsArray[i].options.xAxisLable;
                    //newOptionsObjectForStackedCirAreaChart["yAxisLable"] = newtargetElementAndOptionsArray[i].options.yAxisLable;
                    newOptionsObjectForStackedCirAreaChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForStackedCirAreaChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForStackedCirAreaChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForStackedCirAreaChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForStackedCirAreaChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForStackedCirAreaChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForStackedCirAreaChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForStackedCirAreaChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForStackedCirAreaChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForStackedCirAreaChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForStackedCirAreaChart;
                    acinfotech.stackedCircularAreaChart(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }
            
            else if(divAndChartsArray[i].chartName === "PERCENTAGEAREACHART"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {
                    
                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForPerAreaChart = {};
                    newOptionsObjectForPerAreaChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForPerAreaChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForPerAreaChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptionsObjectForPerAreaChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForPerAreaChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForPerAreaChart["xAxisLable"] = newtargetElementAndOptionsArray[i].options.xAxisLable;
                    newOptionsObjectForPerAreaChart["yAxisLable"] = newtargetElementAndOptionsArray[i].options.yLeftAxisLable;
                    newOptionsObjectForPerAreaChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForPerAreaChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForPerAreaChart["lineStyle"] = newtargetElementAndOptionsArray[i].options.lineStyle;
                    newOptionsObjectForPerAreaChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForPerAreaChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForPerAreaChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForPerAreaChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForPerAreaChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForPerAreaChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newOptionsObjectForPerAreaChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForPerAreaChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForPerAreaChart;
                    acinfotech.percentageAreaChart(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }
            
            else if(divAndChartsArray[i].chartName === "TWOXAXISESGROUPEDBARCHART"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {
                    
                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForTwoXAxisesGrpBarChart = {};
                    newOptionsObjectForTwoXAxisesGrpBarChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForTwoXAxisesGrpBarChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForTwoXAxisesGrpBarChart["dataForDrillDown"] = newtargetElementAndOptionsArray[i].options.dataForDrillDown;
                    //newOptionsObjectForTwoXAxisesGrpBarChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    //newOptionsObjectForTwoXAxisesGrpBarChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForTwoXAxisesGrpBarChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForTwoXAxisesGrpBarChart["xAxisLables"] = newtargetElementAndOptionsArray[i].options.xAxisLables;
                    //newOptionsObjectForTwoXAxisesGrpBarChart["yAxisLable"] = newtargetElementAndOptionsArray[i].options.yAxisLable;
                    //newOptionsObjectForStackedBarChart["dimensions"] = newtargetElementAndOptionsArray[i].options.dimensions;
                    //newOptionsObjectForStackedBarChart["measures"] = newtargetElementAndOptionsArray[i].options.measures;
                    newOptionsObjectForTwoXAxisesGrpBarChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForTwoXAxisesGrpBarChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForTwoXAxisesGrpBarChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    //newOptionsObjectForTwoXAxisesGrpBarChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForTwoXAxisesGrpBarChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForTwoXAxisesGrpBarChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForTwoXAxisesGrpBarChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForTwoXAxisesGrpBarChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForTwoXAxisesGrpBarChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForTwoXAxisesGrpBarChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForTwoXAxisesGrpBarChart;
                    acinfotech.twoXAxisesGroupedBarChart(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }
            else if(divAndChartsArray[i].chartName === "THREEXAXISESGROUPEDBARCHART"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {
                    
                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForThreeXAxisesGrpBarChart = {};
                    newOptionsObjectForThreeXAxisesGrpBarChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForThreeXAxisesGrpBarChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    //newOptionsObjectForTwoXAxisesGrpBarChart["dataForDrillDown"] = newtargetElementAndOptionsArray[i].options.dataForDrillDown;
                    //newOptionsObjectForTwoXAxisesGrpBarChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    //newOptionsObjectForTwoXAxisesGrpBarChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForThreeXAxisesGrpBarChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForThreeXAxisesGrpBarChart["xAxisLables"] = newtargetElementAndOptionsArray[i].options.xAxisLables;
                    //newOptionsObjectForTwoXAxisesGrpBarChart["yAxisLable"] = newtargetElementAndOptionsArray[i].options.yAxisLable;
                    //newOptionsObjectForStackedBarChart["dimensions"] = newtargetElementAndOptionsArray[i].options.dimensions;
                    //newOptionsObjectForStackedBarChart["measures"] = newtargetElementAndOptionsArray[i].options.measures;
                    newOptionsObjectForThreeXAxisesGrpBarChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForThreeXAxisesGrpBarChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForThreeXAxisesGrpBarChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    //newOptionsObjectForTwoXAxisesGrpBarChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    //newOptionsObjectForTwoXAxisesGrpBarChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    //newOptionsObjectForTwoXAxisesGrpBarChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    //newOptionsObjectForTwoXAxisesGrpBarChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForThreeXAxisesGrpBarChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForThreeXAxisesGrpBarChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForThreeXAxisesGrpBarChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForThreeXAxisesGrpBarChart;
                    acinfotech.threeXAxisesGroupedBarChart(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }
            
            else if(divAndChartsArray[i].chartName === "COLUMNANDLINESCHART"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {
                    
                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForcolumnAndLinesChart = {};
                    newOptionsObjectForcolumnAndLinesChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForcolumnAndLinesChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForcolumnAndLinesChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptionsObjectForcolumnAndLinesChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForcolumnAndLinesChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForcolumnAndLinesChart["xAxisLable"] = newtargetElementAndOptionsArray[i].options.xAxisLable;
                    //newOptionsObjectForcolumnAndLinesChart["yAxisLable"] = newtargetElementAndOptionsArray[i].options.yLeftAxisLable;
                    newOptionsObjectForcolumnAndLinesChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForcolumnAndLinesChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForcolumnAndLinesChart["lineStyle"] = newtargetElementAndOptionsArray[i].options.lineStyle;
                    newOptionsObjectForcolumnAndLinesChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForcolumnAndLinesChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForcolumnAndLinesChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForcolumnAndLinesChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForcolumnAndLinesChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForcolumnAndLinesChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForcolumnAndLinesChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForcolumnAndLinesChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForcolumnAndLinesChart;
                    acinfotech.columnAndLinesChart(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }
            
            else if(divAndChartsArray[i].chartName === "BELLCURVECHARTWITHMINANDMAXRANGE"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {
                    
                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForBellCurveChartWithMinAndMaxRange = {};
                    newOptionsObjectForBellCurveChartWithMinAndMaxRange["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForBellCurveChartWithMinAndMaxRange["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForBellCurveChartWithMinAndMaxRange["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForBellCurveChartWithMinAndMaxRange["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForBellCurveChartWithMinAndMaxRange["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForBellCurveChartWithMinAndMaxRange["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForBellCurveChartWithMinAndMaxRange["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForBellCurveChartWithMinAndMaxRange["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForBellCurveChartWithMinAndMaxRange["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForBellCurveChartWithMinAndMaxRange;
                    acinfotech.bellCurveChartWithMinAndMaxRange(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }
            
            else if(divAndChartsArray[i].chartName === "GROUPEDBARSWITHLINECHART"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {
                    
                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForGrpBarsWithLineChart = {};
                    newOptionsObjectForGrpBarsWithLineChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForGrpBarsWithLineChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForGrpBarsWithLineChart["dataForDrillDown"] = newtargetElementAndOptionsArray[i].options.dataForDrillDown;
                    newOptionsObjectForGrpBarsWithLineChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptionsObjectForGrpBarsWithLineChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForGrpBarsWithLineChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForGrpBarsWithLineChart["xAxisLable"] = newtargetElementAndOptionsArray[i].options.xAxisLable;
                    newOptionsObjectForGrpBarsWithLineChart["yAxisLable"] = newtargetElementAndOptionsArray[i].options.yAxisLable;
                    newOptionsObjectForGrpBarsWithLineChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForGrpBarsWithLineChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForGrpBarsWithLineChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForGrpBarsWithLineChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForGrpBarsWithLineChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForGrpBarsWithLineChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForGrpBarsWithLineChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForGrpBarsWithLineChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForGrpBarsWithLineChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForGrpBarsWithLineChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForGrpBarsWithLineChart;
                    acinfotech.groupedBarsWithLineChart(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }
            else if(divAndChartsArray[i].chartName === "STACKEDGROUPEDBARCHART"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {
                    
                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForStkGrpBarChart = {};
                    newOptionsObjectForStkGrpBarChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForStkGrpBarChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    //newOptionsObjectForStkGrpBarChart["dataForDrillDown"] = newtargetElementAndOptionsArray[i].options.dataForDrillDown;
                    //newOptionsObjectForStkGrpBarChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    //newOptionsObjectForStkGrpBarChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForStkGrpBarChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForStkGrpBarChart["xAxisLable"] = newtargetElementAndOptionsArray[i].options.xAxisLable;
                    //newOptionsObjectForStkGrpBarChart["yAxisLable"] = newtargetElementAndOptionsArray[i].options.yAxisLable;
                    newOptionsObjectForStkGrpBarChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForStkGrpBarChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForStkGrpBarChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForStkGrpBarChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForStkGrpBarChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForStkGrpBarChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForStkGrpBarChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForStkGrpBarChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForStkGrpBarChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForStkGrpBarChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForStkGrpBarChart;
                    acinfotech.stackedGroupedBarChart(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }
            else if(divAndChartsArray[i].chartName === "STACKEDGROUPEDBARSWITHLINECHART"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {
                    
                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForStkGrpBarsWithLineChart = {};
                    newOptionsObjectForStkGrpBarsWithLineChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForStkGrpBarsWithLineChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    //newOptionsObjectForStkGrpBarChart["dataForDrillDown"] = newtargetElementAndOptionsArray[i].options.dataForDrillDown;
                    //newOptionsObjectForStkGrpBarChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    //newOptionsObjectForStkGrpBarChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForStkGrpBarsWithLineChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForStkGrpBarsWithLineChart["xAxisLable"] = newtargetElementAndOptionsArray[i].options.xAxisLable;
                    //newOptionsObjectForStkGrpBarChart["yAxisLable"] = newtargetElementAndOptionsArray[i].options.yAxisLable;
                    newOptionsObjectForStkGrpBarsWithLineChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForStkGrpBarsWithLineChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForStkGrpBarsWithLineChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForStkGrpBarsWithLineChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForStkGrpBarsWithLineChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForStkGrpBarsWithLineChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForStkGrpBarsWithLineChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForStkGrpBarsWithLineChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForStkGrpBarsWithLineChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForStkGrpBarsWithLineChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newOptionsObjectForStkGrpBarsWithLineChart[i].options = newOptionsObjectForStkGrpBarsWithLineChart;
                    acinfotech.stackedGroupedBarsWithLineChart(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }
            else if(divAndChartsArray[i].chartName === "STACKEDBARWITHLINESCHART"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {
                    
                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForStkBarWithLinesChart = {};
                    newOptionsObjectForStkBarWithLinesChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForStkBarWithLinesChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    //newOptionsObjectForStkBarWithLinesChart["dataForDrillDown"] = newtargetElementAndOptionsArray[i].options.dataForDrillDown;
                    newOptionsObjectForStkBarWithLinesChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptionsObjectForStkBarWithLinesChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForStkBarWithLinesChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForStkBarWithLinesChart["xAxisLable"] = newtargetElementAndOptionsArray[i].options.xAxisLable;
                    newOptionsObjectForStkBarWithLinesChart["yAxisLable"] = newtargetElementAndOptionsArray[i].options.yAxisLable;
                    newOptionsObjectForStkBarWithLinesChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForStkBarWithLinesChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptionsObjectForStkBarWithLinesChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForStkBarWithLinesChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForStkBarWithLinesChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForStkBarWithLinesChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForStkBarWithLinesChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForStkBarWithLinesChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForStkBarWithLinesChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForStkBarWithLinesChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForStkBarWithLinesChart;
                    acinfotech.stackedBarWithLinesChart(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }
            
            else if(divAndChartsArray[i].chartName === "TRAFFICLIGHTSCHART"){
            
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {

                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForTrafficLightsChart = {};
                    newOptionsObjectForTrafficLightsChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForTrafficLightsChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForTrafficLightsChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptionsObjectForTrafficLightsChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptionsObjectForTrafficLightsChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForTrafficLightsChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForTrafficLightsChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptionsObjectForTrafficLightsChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptionsObjectForTrafficLightsChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptionsObjectForTrafficLightsChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptionsObjectForTrafficLightsChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForTrafficLightsChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForTrafficLightsChart["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForTrafficLightsChart["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForTrafficLightsChart;
                    acinfotech.trafficLightsChart(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }
            
            else if(divAndChartsArray[i].chartName === "COLUMNCHARTWITHNEGATIVEVALUES"){
            
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {

                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptsObjForColChrtWitNegVals = {};
                    newOptsObjForColChrtWitNegVals["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptsObjForColChrtWitNegVals["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptsObjForColChrtWitNegVals["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptsObjForColChrtWitNegVals["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptsObjForColChrtWitNegVals["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptsObjForColChrtWitNegVals["xAxisLable"] = newtargetElementAndOptionsArray[i].options.keys.label;
                    newOptsObjForColChrtWitNegVals["yAxisLable"] = newtargetElementAndOptionsArray[i].options.keys.value;
                    newOptsObjForColChrtWitNegVals["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptsObjForColChrtWitNegVals["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptsObjForColChrtWitNegVals["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptsObjForColChrtWitNegVals["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptsObjForColChrtWitNegVals["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptsObjForColChrtWitNegVals["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptsObjForColChrtWitNegVals["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptsObjForColChrtWitNegVals["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptsObjForColChrtWitNegVals["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptsObjForColChrtWitNegVals["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptsObjForColChrtWitNegVals;
                    acinfotech.columnChartWithNegativeValues(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
                
            }
            else if(divAndChartsArray[i].chartName === "USMAPWITHPINS"){
                
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {
                    
                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForUSMapWithPins = {};
                    newOptionsObjectForUSMapWithPins["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptionsObjectForUSMapWithPins["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptionsObjectForUSMapWithPins["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptionsObjectForUSMapWithPins["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForUSMapWithPins["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForUSMapWithPins["showTable"] = newtargetElementAndOptionsArray[i].options.showTable
                    newOptionsObjectForUSMapWithPins["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptionsObjectForUSMapWithPins["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForUSMapWithPins["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForUSMapWithPins["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForUSMapWithPins;
                    acinfotech.USMapWithPins(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }
            else if(divAndChartsArray[i].chartName === "SENTIMENTANALYSISPERGAUGE"){
            
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {

                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForSentAnPerGauge = {};
                    newOptionsObjectForSentAnPerGauge["gaugeTitle"] = newtargetElementAndOptionsArray[i].options.gaugeTitle;
                    newOptionsObjectForSentAnPerGauge["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForSentAnPerGauge["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForSentAnPerGauge["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newOptionsObjectForSentAnPerGauge["series"] = newtargetElementAndOptionsArray[i].options.series;
                    newOptionsObjectForSentAnPerGauge["legend"] = newtargetElementAndOptionsArray[i].options.legend;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForSentAnPerGauge;
                    acinfotech.sentimentAnalysisPerGauge(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }
            else if(divAndChartsArray[i].chartName === "SPEEDOMETER"){
            
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {

                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptionsObjectForSpeedometer = {};
                    newOptionsObjectForSpeedometer["gaugeTitle"] = newtargetElementAndOptionsArray[i].options.gaugeTitle;
                    newOptionsObjectForSpeedometer["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptionsObjectForSpeedometer["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptionsObjectForSpeedometer["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newtargetElementAndOptionsArray[i].options = newOptionsObjectForSpeedometer;
                    acinfotech.speedometer(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }
            else if(divAndChartsArray[i].chartName === "VERTICALCONECHART"){
            
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {

                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptsObjForVertiConeBarChart = {};
                    newOptsObjForVertiConeBarChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptsObjForVertiConeBarChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptsObjForVertiConeBarChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptsObjForVertiConeBarChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptsObjForVertiConeBarChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptsObjForVertiConeBarChart["xAxisLable"] = newtargetElementAndOptionsArray[i].options.keys.label;
                    newOptsObjForVertiConeBarChart["yAxisLable"] = newtargetElementAndOptionsArray[i].options.keys.value;
                    newOptsObjForVertiConeBarChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptsObjForVertiConeBarChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptsObjForVertiConeBarChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptsObjForVertiConeBarChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptsObjForVertiConeBarChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptsObjForVertiConeBarChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptsObjForVertiConeBarChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptsObjForVertiConeBarChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newtargetElementAndOptionsArray[i].options = newOptsObjForVertiConeBarChart;
                    acinfotech.verticalConeChart(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            
            }
            else if(divAndChartsArray[i].chartName === "HORIZONTALPERPROGRESSBARCHART"){
            
                var sel = d3.select(newtargetElementAndOptionsArray[i].targetElement[0][0])
                
                var element =  document.getElementById(sel[0][0].id);
                if (typeof(element) != 'undefined' && element != null)
                {

                    d3.select(sel[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                    
                    var newOptsObjForHoriPerProgBarChart = {};
                    newOptsObjForHoriPerProgBarChart["chartTitle"] = newtargetElementAndOptionsArray[i].options.chartTitle;
                    newOptsObjForHoriPerProgBarChart["data"] = newtargetElementAndOptionsArray[i].options.data;
                    newOptsObjForHoriPerProgBarChart["dataForTable"] = newtargetElementAndOptionsArray[i].options.dataForTable;
                    newOptsObjForHoriPerProgBarChart["isDataDetailedForTable"] = newtargetElementAndOptionsArray[i].options.isDataDetailedForTable;
                    newOptsObjForHoriPerProgBarChart["keys"] = newtargetElementAndOptionsArray[i].options.keys;
                    newOptsObjForHoriPerProgBarChart["xAxisLable"] = newtargetElementAndOptionsArray[i].options.keys.value;
                    newOptsObjForHoriPerProgBarChart["yAxisLable"] = newtargetElementAndOptionsArray[i].options.keys.label;
                    newOptsObjForHoriPerProgBarChart["resizeButtonID"] = newtargetElementAndOptionsArray[i].options.resizeButtonID;
                    newOptsObjForHoriPerProgBarChart["colorSet"] = newtargetElementAndOptionsArray[i].options.colorSet;
                    newOptsObjForHoriPerProgBarChart["showTitle"] = true//newtargetElementAndOptionsArray[i].options.showTitle
                    newOptsObjForHoriPerProgBarChart["showTable"] = newtargetElementAndOptionsArray[i].options.showTable;
                    newOptsObjForHoriPerProgBarChart["showComments"] = newtargetElementAndOptionsArray[i].options.showComments;
                    newOptsObjForHoriPerProgBarChart["comments"] = newtargetElementAndOptionsArray[i].options.comments;
                    newOptsObjForHoriPerProgBarChart["drillDownColumnName"] = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
                    newOptsObjForHoriPerProgBarChart["BGcolor"] = newtargetElementAndOptionsArray[i].options.BGcolor;
                    newtargetElementAndOptionsArray[i].options = newOptsObjForHoriPerProgBarChart;
                    acinfotech.horizontalPerProgressBarChart(newtargetElementAndOptionsArray[i].targetElement,newtargetElementAndOptionsArray[i].options);
                }
            }
                
        }//for loop
        
    }// resizeButton Clicked Function
},


	chartsColorSetOne: d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]),
	chartsColorSetTwo: d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]),
	chartsColorSetThree: d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]),
	
	// ************************************************** Pie Chart  **************************************************
    pieChart: function(targetElement, options) {
		
        if(pieChartOptionsDataCountVariable == 0){
            pieChartOptionsDataArray = options.data
            pieChartOptionsDataCountVariable++;
        }
       
        isChartCalled++;

        var chartName = "PIECHART";
        
        acinfotech.allCharts(targetElement,options,chartName);
        
        var newJson = [];
        options.data.forEach(function(d, i) {
            var temp = {};
            
            for(var i = 0; i < Object.keys(d).length; i++) {
                delete d['enabled'];
                temp[Object.keys(d)[i]] = d[Object.keys(d)[i]]
            }
            
            newJson.push(temp)
        });
        targetElement.style("min-width", "350px").style("min-height", "350px").style("background-color", options.BGcolor)

        var showOrHideTableForPieChart;
        var showOrHideCommentsForPieChart;
        var showOrHideCommentsBtnForPieChart = true;

        // Show or Hide table 
        if((options.showTable == true) || (options.showTable == false)){
            showOrHideTableForPieChart = options.showTable;
        }
        else{
            showOrHideTableForPieChart = false;   
        }

        // Show or Hide comments
        if (options.showComments == true || false) {
            showOrHideCommentsForPieChart = options.showComments;
        }
        else {
            showOrHideCommentsForPieChart = false;
        }

        if (options.comments.length == 0){ // checking whether there is a comment or not
            showOrHideCommentsForPieChart = false;
            showOrHideCommentsBtnForPieChart = false;
        }
        

        if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == true)){
            showOrHideTableForPieChart = true;
            showOrHideCommentsForPieChart = false;
        }
        else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
            showOrHideTableForPieChart = false;
            showOrHideCommentsForPieChart = false;
        }

        //var width = targetElement.node().getBoundingClientRect().width;
        //var height = targetElement.node().getBoundingClientRect().height;
        
        // Global Variables
        var isResizedFunctionCalled = false;
        var newWidth1, newHeight1;
        var newWidth11, newHeight11;
        var newWidth111, newHeight111;
        var newWidth1111, newHeight1111;
        var divWidth,divHeight;
        
        // Chart Title Div
        var chartTitlePanelForPieChart = targetElement.append("div").style('background-color',options.BGcolor) .style('position',"absolute").style("text-indent","6px").style("border-style","none")
        
		var optionsButtonPanelForPieChart = targetElement.append('div').style('width',"25px").style('height',"305px").style('position','absolute')
        .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px")
        .style('right','0')
        .style("min-width","25px") .style("border-style","none").style("border-left", "solid #fcfcfc  1px")
		
        var bubbleButtonForPieChart = optionsButtonPanelForPieChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','133px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var bubbleBtnImgVar = document.createElement("IMG");
        bubbleBtnImgVar.src = "images/bubbleIcon.png";
        bubbleBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:15px; height:15px; opacity:0.9;")
        bubbleButtonForPieChart[0][0].appendChild(bubbleBtnImgVar)

        var colButtonForPieChart = optionsButtonPanelForPieChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','159px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var colBtnImgVar = document.createElement("IMG");
        colBtnImgVar.src = "images/columnIcon.png";
        colBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:15px; height:15px; opacity:0.9;")
        colButtonForPieChart[0][0].appendChild(colBtnImgVar)

        var donutButtonForPieChart = optionsButtonPanelForPieChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','184px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var dountBtnImgVar = document.createElement("IMG");
        dountBtnImgVar.src = "images/donutIcon.png";
        dountBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:15px; height:15px; opacity:0.8;")
        donutButtonForPieChart[0][0].appendChild(dountBtnImgVar)

        var horButtonForPieChart = optionsButtonPanelForPieChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','209px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var horiBtnImgVar = document.createElement("IMG");
        horiBtnImgVar.src = "images/horizontalIcon.png";
        horiBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:15px; height:15px; opacity:0.9;")
        horButtonForPieChart[0][0].appendChild(horiBtnImgVar)

        var filterButtonForPieChart = optionsButtonPanelForPieChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','234px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var filterBtnImgVar = document.createElement("IMG");
        filterBtnImgVar.src = "images/filterIcon.png";
        filterBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:15px; height:15px; opacity:0.8;")
        filterButtonForPieChart[0][0].appendChild(filterBtnImgVar)

        var refreshButtonForPieChart = optionsButtonPanelForPieChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','259px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var refreshBtnImgVar = document.createElement("IMG");
        refreshBtnImgVar.src = "images/refreshIcon.png";
        refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:15px; height:15px; opacity:0.8;")
        refreshButtonForPieChart[0][0].appendChild(refreshBtnImgVar)

        var commentsBtnForPieChart = optionsButtonPanelForPieChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','284px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var commentsBtnImgVariable = document.createElement("IMG");
        if(options.showComments == false){
            commentsBtnImgVariable.src = "images/showCommentsIcon.png";
        }
        else if(options.showComments == true){
            commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
        }
        commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:15px; height:15px; opacity:0.8;")
        commentsBtnForPieChart[0][0].appendChild(commentsBtnImgVariable)

        var menuButtonForPieChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','1px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var menuBtnImgVar = document.createElement("IMG");
        menuBtnImgVar.src = "images/menuIcon.png";
        menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:15px; height:15px; opacity:0.85;")
        menuButtonForPieChart[0][0].appendChild(menuBtnImgVar)

        if(showOrHideCommentsBtnForPieChart == true){
            bubbleButtonForPieChart.style('margin-left', "2px")
            colButtonForPieChart.style('margin-left', "2px")
            donutButtonForPieChart.style('margin-left', "2px")
            horButtonForPieChart.style('margin-left', "2px")
            filterButtonForPieChart.style('margin-left', "2px")
            refreshButtonForPieChart.style('margin-left', "2px")
            commentsBtnForPieChart.style('margin-left', "2px")
            // menuButtonForPieChart.style('right', '0')
            menuButtonForPieChart.style('right','0')
        }
        else if(showOrHideCommentsBtnForPieChart == false){
            bubbleButtonForPieChart.style('margin-left', "2px")
            colButtonForPieChart.style('margin-left', "2px")
            donutButtonForPieChart.style('margin-left', "2px")
            horButtonForPieChart.style('margin-left', "2px")
            filterButtonForPieChart.style('margin-left', "2px")
            refreshButtonForPieChart.style('margin-left', "2px")
            //commentsBtnForPieChart.style('margin-left', "2px")
            commentsBtnForPieChart.style('display','none')
            // menuButtonForPieChart.style('right', '0')
            menuButtonForPieChart.style('right','0')
        }

        var ismenuButtonOfPieChartClicked = false;
        menuButtonForPieChart.on('click', function() {

            if(ismenuButtonOfPieChartClicked == false){
                ismenuButtonOfPieChartClicked = true;
                optionsButtonPanelForPieChart.style("display","block")

                newFilterPanelForPieChart.style("display","none");
                newSettingPanelForPieChart.style("display","none");

            if(options.showLegend == true && options.showTitle == true){
            
            if(options.legendSide === "left"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("position","absolute").style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                     .style("left",0 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);
                    
                    svgPanelForPieChart.style("position","absolute").style('width', 65 + "%") .style('height', 70 + "%").style('background-color',options.BGcolor);
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("position","absolute").style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                     .style("left",0 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%") .style("left",30 + "%")
                    svgPanelForPieChart.style("position","absolute").style('background-color',options.BGcolor);
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("position","absolute").style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                     .style("left",0 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }

            }
            else if(options.legendSide === "right"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }

            }
            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 75 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                
            }
        }
        else if(options.showLegend == true && options.showTitle == false){
           
            if(options.legendSide === "left"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",0.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }

            }
            else if(options.legendSide === "right"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",0.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
            }
            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",0.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
            }
            
        }
        else if(options.showLegend == false){
				if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 0.0 + "%"; }) .style("height", function(d) { return 0  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 100 + "%") .style('height', 70 + "%").style("top",8.0  + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 0.0 + "%"; }) .style("height", function(d) { return 0  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",0.0  + "%");

                    svgPanelForPieChart.style('width', 100 + "%") .style('height', 52 + "%").style("top",8.0  + "%") .style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 0.0 + "%"; }) .style("height", function(d) { return 0  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 100 + "%") .style('height', 85 + "%").style("top",8.0  + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
        }

                resizedFuctionForPieChart();
            }
            else if(ismenuButtonOfPieChartClicked == true){
                ismenuButtonOfPieChartClicked = false
                optionsButtonPanelForPieChart.style("display","none")
            }
        })
   // var color='#F1F8F7';
        // SVG container for holding Pie-Chart
        var svgPanelForPieChart = targetElement .append('svg').attr("class","svgPanelClass").style('position',"absolute").style('bottom',"0px") .style('background-color',options.BGcolor)
        
        var commentsPanelDivForPieChart = targetElement.append("div") .attr("class","commentsPanelClassForPieChart") 
        .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
		.style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
		.style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)

        commentsPanelDivForPieChart.on('click',function(d){
            $('.commentsClassForPieChart' + targetElement[0][0].id).focus()
        })

        
        // Checking whether chart Title and Legend is choosen (true or flase) while library is called.
        if(options.showTitle == true && options.showLegend == true){
            chartTitlePanelForPieChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 8 + "%"; })
            .html('<div  style="width: 100%; height:0%; background-color:#ffffff; position: absolute; top:10.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')
            
            if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){

                var commentsForPiechart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify').attr('class','commentsClassForPieChart' + targetElement[0][0].id)

                   svgPanelForPieChart.style('width', 65 + "%") .style('height', 70 + "%") .style("left",75 + "%").style("top",8 + "%").style('background-color',options.BGcolor) .append('g'); 
                   commentsPanelDivForPieChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForPiechart[0].outerHTML.toString())

            }
            else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%") .style("left",75 + "%").style("top",8 + "%") .style('background-color',options.BGcolor).append('g');
                    commentsPanelDivForPieChart.style("width", function(d) {  return 0.0 + "%"; }) .style("height", function(d) { return 0 + "%"; }).style("display","none")
            }
            else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 85 + "%") .style("left",75 + "%").style("top",8 + "%") .style('background-color',options.BGcolor).append('g'); 
                    commentsPanelDivForPieChart.style("width", function(d) {  return 0.0 + "%"; }) .style("height", function(d) { return 0 + "%"; }).style("display","none")
            }

        }
        else if(options.showTitle == false && options.showLegend == true){
            
            chartTitlePanelForPieChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; });

            if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){

                var commentsForPiechart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify')

                   svgPanelForPieChart.style('width', 65 + "%") .style('height', 70 + "%") .style("left",75 + "%").style("top",8 + "%") .style('background-color',options.BGcolor).append('g');    
                   commentsPanelDivForPieChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForPiechart[0].outerHTML.toString())
            }
            else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                svgPanelForPieChart.style('width', 65 + "%") .style('height', 60 + "%") .style("left",75 + "%") .style("top",0 + "%").style('background-color',options.BGcolor) .append('g')
                commentsPanelDivForPieChart.style("width", function(d) {  return 0.0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                svgPanelForPieChart.style('width', 65 + "%") .style('height', 85 + "%") .style("left",75 + "%").style("top",8 + "%") .style('background-color',options.BGcolor).append('g');  
                commentsPanelDivForPieChart.style("width", function(d) {  return 0.0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }

        }
        else if(options.showTitle == false && options.showLegend == false){
            
            chartTitlePanelForPieChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; });

            if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                var commentsForPiechart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify')

                   svgPanelForPieChart.style('width', 100 + "%") .style('height', 70 + "%") .style("left",0 + "%").style("top",8 + "%") .append('g');    
                   commentsPanelDivForPieChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForPiechart[0].outerHTML.toString())
            }
            else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                svgPanelForPieChart.style('width', 100 + "%") .style('height', 60 + "%") .style("left",0 + "%") .append('g')
                commentsPanelDivForPieChart.style("width", function(d) {  return 0.0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                svgPanelForPieChart.style('width', 100 + "%") .style('height', 85 + "%") .style("left",0 + "%").style("top",8 + "%") .append('g');  
                commentsPanelDivForPieChart.style("width", function(d) {  return 0.0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none") 
            }

        }
        else if(options.showTitle == true && options.showLegend == false){
            chartTitlePanelForPieChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 8 + "%"; })
            .html('<div  style="width: 100%; height:0%; background-color:#ffffff; position: absolute; top:5.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')
            

            if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                var commentsForPiechart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify')

                   svgPanelForPieChart.style('width', 100 + "%") .style('height', 70 + "%") .style("left",0 + "%").style("top",8 + "%").style('background-color',options.BGcolor) .append('g');    
                   commentsPanelDivForPieChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForPiechart[0].outerHTML.toString())
            }
            else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                svgPanelForPieChart.style('width', 100 + "%") .style('height', 52 + "%") .style("left",0 + "%").style("top",8 + "%") .style('background-color',options.BGcolor).append('g');
                commentsPanelDivForPieChart.style("width", function(d) {  return 0.0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                svgPanelForPieChart.style('width', 100 + "%") .style('height', 75 + "%") .style("left",0 + "%").style("top",16 + "%") .style('background-color',options.BGcolor).append('g');  
                commentsPanelDivForPieChart.style("width", function(d) {  return 0.0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")    
            }

        }
        
        // --------------------- setting panel section starts here ---------------------

        var newSettingPanelForPieChart = targetElement.append('div').style('width',"100%").style('height',"40%")
        .style('position','absolute').style('margin-left', "0px").style('border-top',"1px solid #f0f0f0").style('border-bottom',"1px solid #e5e5e5")
        .style("background-color",'#fcfcfc').style("z-index",90) .style("display","none").style('top',"60%").style('height',"40%")

        var settingPanelTitle = newSettingPanelForPieChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','10px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#00001c")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; color:#00001c;">'+ "Settings" +'</div>')

        var cancelButtonForNewSettingsPanel = newSettingPanelForPieChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
        .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
        .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.88; background-color:#fcfcff")
        cancelButtonForNewSettingsPanel[0][0].appendChild(cancelBtnImgVar)

        cancelButtonForNewSettingsPanel.on('click', function() {
            newSettingPanelForPieChart.style("display","none")

            if(options.showLegend == true && options.showTitle == true){
            
            if(options.legendSide === "left"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style('background-color',options.BGcolor) ; 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%") .style("left",30 + "%")
                    svgPanelForPieChart.style("position","absolute").style('background-color',options.BGcolor) ;
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style('background-color',options.BGcolor) ; 
                }

            }
            else if(options.legendSide === "right"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style('background-color',options.BGcolor) ; 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor) ; 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style('background-color',options.BGcolor) ; 
                }

            }
            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor) ; 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor) ; 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor) ; 
                }
                
            }
        }
        else if(options.showLegend == true && options.showTitle == false){
           
            if(options.legendSide === "left"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style('background-color',options.BGcolor) ; 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",0.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor) ; 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style('background-color',options.BGcolor) ; 
                }

            }
            else if(options.legendSide === "right"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style('background-color',options.BGcolor) ; 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",0.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor) ; 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style('background-color',options.BGcolor) ; 
                }
            }
            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style('background-color',options.BGcolor) ; 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",0.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor) ; 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style('background-color',options.BGcolor) ; 
                }
            }
            
        }
        else if(options.showLegend == false){

            if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 0.0 + "%"; }) .style("height", function(d) { return 0  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 100 + "%") .style('height', 70 + "%").style("position","absolute").style('background-color',options.BGcolor) ; 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 0.0 + "%"; }) .style("height", function(d) { return 0  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",0.0  + "%");

                    svgPanelForPieChart.style('width', 100 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor) ; 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 0.0 + "%"; }) .style("height", function(d) { return 0  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 100 + "%") .style('height', 85 + "%").style("position","absolute").style('background-color',options.BGcolor) ; 
                }

        }

            resizedFuctionForPieChart();
        })

        var settingPanelDivForPieChangeColorTitle = newSettingPanelForPieChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#00001c")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Select color set " +'</div>')

        var formForChangeSettingsPanel = newSettingPanelForPieChart.append("form");
        formForChangeSettingsPanel.style("background-color","#fcfcfc").style("margin-top","67px").style("font-family","Verdana,sans-serif").style("font-size","12px")
        .style("position","absolute").attr("id","formForChangeColorSettingsPanel" + targetElement[0][0].id).style("font-weight","Bold").style("width","180px")
        .style("height","58px").style("padding","0px").style("border-radius","0px") .style("margin-left","10px")

        var svgPanelForColorSetOneForPieChart = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px").style("height","18px").style("margin-top","1px").style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetOneForPieChart = d3.scale.ordinal().range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        var colorSetOneRangeForPieChart = d3.range(12);

        var colorSetOneDotsForPieChart = svgPanelForColorSetOneForPieChart.append("g")
        colorSetOneDotsForPieChart.selectAll('rect') .data(colorSetOneRangeForPieChart) .enter().append('rect')
        .attr('transform', 'translate(' + (2) + ',' + (1) + ')') .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10)
        .attr("height",10) .style("fill", function(d,i){return colorSetOneForPieChart(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1)
        .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetOneForPieChart(i); })
        .style("cursor","auto") .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        var svgPanelForColorSetTwoForPieChart = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px").style("height","18px").style("margin-top","20px").style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetTwoForPieChart = d3.scale.ordinal().range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        var colorSetTwoRangeForPieChart = d3.range(12);

        var colorSetTwoDotsForPieChart = svgPanelForColorSetTwoForPieChart.append("g")
        colorSetTwoDotsForPieChart.selectAll('rect') .data(colorSetTwoRangeForPieChart) .enter().append('rect')
        .attr('transform', 'translate(' + (2) + ',' + (1) + ')') .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10)
        .attr("height",10) .style("cursor","auto") .style("fill", function(d,i){return colorSetTwoForPieChart(i)}) .style("fill-opacity",0.93)
        .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetTwoForPieChart(i);  })
        .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        var svgPanelForColorSetThreeForPieChart = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px").style("height","18px").style("margin-top","39px").style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetThreeForPieChart = d3.scale.ordinal().range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        var colorSetThreeRangeForPieChart = d3.range(12);

        var colorSetThreeDotsForPieChart = svgPanelForColorSetThreeForPieChart.append("g")
        colorSetThreeDotsForPieChart.selectAll('rect') .data(colorSetThreeRangeForPieChart) .enter().append('rect')
        .attr('transform', 'translate(' + (2) + ',' + (1) + ')') .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10)
        .attr("height",10) .style("cursor","auto") .style("fill", function(d,i){return colorSetThreeForPieChart(i)}) .style("fill-opacity",0.93)
        .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetThreeForPieChart(i);  })
        .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        if(options.colorSet.toString().toLowerCase() === "one"){
            svgPanelForColorSetOneForPieChart.style('border',"1px solid #808080")
            svgPanelForColorSetTwoForPieChart.style('border',"0px solid #808080")
            svgPanelForColorSetThreeForPieChart.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            svgPanelForColorSetOneForPieChart.style('border',"0px solid #808080")
            svgPanelForColorSetTwoForPieChart.style('border',"1px solid #808080")
            svgPanelForColorSetThreeForPieChart.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            svgPanelForColorSetOneForPieChart.style('border',"0px solid #808080")
            svgPanelForColorSetTwoForPieChart.style('border',"0px solid #808080")
            svgPanelForColorSetThreeForPieChart.style('border',"1px solid #808080")
        }
        else 
        {
            svgPanelForColorSetOneForPieChart.style('border',"1px solid #808080")
            svgPanelForColorSetTwoForPieChart.style('border',"0px solid #808080")
            svgPanelForColorSetThreeForPieChart.style('border',"0px solid #808080")
        }

        svgPanelForColorSetOneForPieChart.on('click',function(d){
            options.colorSet = "one"
            svgPanelForColorSetOneForPieChart.style('border',"1px solid #808080")
            svgPanelForColorSetTwoForPieChart.style('border',"0px solid #808080")
            svgPanelForColorSetThreeForPieChart.style('border',"0px solid #808080")

            var color = d3.scale.ordinal().range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
			
            pathForPieChart.style('fill', function(d, i) { return color(d.data[options.keys.label]); })
			
            legendGroup.style('fill', color).style('stroke', color)
        })
        svgPanelForColorSetTwoForPieChart.on('click',function(d){
            options.colorSet = "two"
            svgPanelForColorSetOneForPieChart.style('border',"0px solid #808080")
            svgPanelForColorSetTwoForPieChart.style('border',"1px solid #808080")
            svgPanelForColorSetThreeForPieChart.style('border',"0px solid #808080")

            var color = d3.scale.ordinal().range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
			
            pathForPieChart.style('fill', function(d, i) { return color(d.data[options.keys.label]); })
			
            legendGroup.style('fill', color).style('stroke', color) 
        })
        svgPanelForColorSetThreeForPieChart.on('click',function(d){
            options.colorSet = "three"
            svgPanelForColorSetOneForPieChart.style('border',"0px solid #808080")
            svgPanelForColorSetTwoForPieChart.style('border',"0px solid #808080")
            svgPanelForColorSetThreeForPieChart.style('border',"1px solid #808080")

            var color = d3.scale.ordinal().range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
			
            pathForPieChart.style('fill', function(d, i) { return color(d.data[options.keys.label]); })
			
            legendGroup.style('fill', color).style('stroke', color)
        })

        // Graident Effect 
        var changeGraidentEffectTitle = newSettingPanelForPieChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','190px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#00001c")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Select Effect " +'</div>')
        //fcfcfc
        var graidentEffectBtnDiv = newSettingPanelForPieChart.append("div")
        .style("background-color","#fcfcfc").style("margin-left","200px").style("margin-top","67px")
        .style("font-family","Verdana,sans-serif").style("font-size","12px")
        .style("position","absolute").style("font-weight","Bold").style("width","110px")
        .style("height","60px").style("padding","0px").style("border-radius","0px")
        
        var smoothButton = graidentEffectBtnDiv.append("div") .style("width","32px").style("height","26px").style('position','absolute')
        .style('background-color',"#ffffff").style('margin-left',"0px")
        .style('top','1px') .style("cursor","pointer").style("display","block") 
        .style("border-style", "none").style('padding',"0px") .style("border", "1px solid #a0a0a0").style("line-height","0px").style("box-sizing","border-box")
        var smoothBtnImgVar = document.createElement("IMG");
        smoothBtnImgVar.src = "images/smooth.png";
        smoothBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:20px; height:20px; opacity:0.8;")
        smoothButton[0][0].appendChild(smoothBtnImgVar)

        var elipticalButton = graidentEffectBtnDiv.append("div") .style("width","32px").style("height","26px").style('position','absolute')
        .style('background-color',"#ffffff").style('margin-left',"35px")
        .style('top','1px') .style("cursor","pointer").style("display","block") 
        .style("border-style", "none").style('padding',"0px").style("line-height","0px").style("box-sizing","border-box")
        var elipticalBtnImgVar = document.createElement("IMG");
        elipticalBtnImgVar.src = "images/eliptical.png";
        elipticalBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:20px; height:20px; opacity:0.8;")
        elipticalButton[0][0].appendChild(elipticalBtnImgVar)

        var circularButton = graidentEffectBtnDiv.append("div") .style("width","32px").style("height","26px").style('position','absolute')
        .style('background-color',"#ffffff").style('margin-left',"70px")
        .style('top','1px') .style("cursor","pointer").style("display","block") 
        .style("border-style", "none").style('padding',"0px").style("line-height","0px").style("box-sizing","border-box")
        var circulaBtnImgVar = document.createElement("IMG");
        circulaBtnImgVar.src = "images/circular.png";
        circulaBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:20px; height:20px; opacity:0.8;")
        circularButton[0][0].appendChild(circulaBtnImgVar)

        var radialButton = graidentEffectBtnDiv.append("div") .style("width","32px").style("height","26px").style('position','absolute')
        .style('background-color',"#ffffff").style('margin-left',"0px")
        .style('top', 32 + 'px') .style("cursor","pointer").style("display","block") 
        .style("border-style", "none").style('padding',"0px") .style("line-height","0px").style("box-sizing","border-box")
        var radialBtnImgVar = document.createElement("IMG");
        radialBtnImgVar.src = "images/radial.png";
        radialBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:20px; height:20px; opacity:0.8;")
        radialButton[0][0].appendChild(radialBtnImgVar)

        var noneButton = graidentEffectBtnDiv.append("div") .style("width","32px").style("height","26px").style('position','absolute')
        .style('background-color',"#ffffff").style('margin-left',"35px")
        .style('top', 32 + 'px') .style("cursor","pointer").style("display","block") 
        .style("border-style", "none").style('padding',"0px").style("line-height","0px").style("box-sizing","border-box")
        var noneBtnImgVar = document.createElement("IMG");
        noneBtnImgVar.src = "images/none.png";
        noneBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:20px; height:20px; opacity:0.8;")
        noneButton[0][0].appendChild(noneBtnImgVar)
        
        // selecting the radio button based on .html file input
        if(options.gradient === undefined){
            smoothButton.style('border',"0px solid #808080")
            elipticalButton.style('border',"0px solid #808080")
            circularButton.style('border',"0px solid #808080")
            radialButton.style('border',"0px solid #808080")
            noneButton.style('border',"1px solid #808080")
        }
        else if(options.gradient.toString().toLowerCase() === "smooth"){
            smoothButton.style('border',"1px solid #808080")
            elipticalButton.style('border',"0px solid #808080")
            circularButton.style('border',"0px solid #808080")
            radialButton.style('border',"0px solid #808080")
            noneButton.style('border',"0px solid #808080")
        }
        else if(options.gradient.toString().toLowerCase() === "elliptical"){
            smoothButton.style('border',"0px solid #808080")
            elipticalButton.style('border',"1px solid #808080")
            circularButton.style('border',"0px solid #808080")
            radialButton.style('border',"0px solid #808080")
            noneButton.style('border',"0px solid #808080")
        }
        else if(options.gradient.toString().toLowerCase() === "circular"){
            smoothButton.style('border',"0px solid #808080")
            elipticalButton.style('border',"0px solid #808080")
            circularButton.style('border',"1px solid #808080")
            radialButton.style('border',"0px solid #808080")
            noneButton.style('border',"0px solid #808080")
        }
        else if(options.gradient.toString().toLowerCase() === "radial"){
            smoothButton.style('border',"0px solid #808080")
            elipticalButton.style('border',"0px solid #808080")
            circularButton.style('border',"0px solid #808080")
            radialButton.style('border',"1px solid #808080")
            noneButton.style('border',"0px solid #808080")
        }
        else if(options.gradient.toString().toLowerCase() === "none"){
            smoothButton.style('border',"0px solid #808080")
            elipticalButton.style('border',"0px solid #808080")
            circularButton.style('border',"0px solid #808080")
            radialButton.style('border',"0px solid #808080")
            noneButton.style('border',"1px solid #808080")
        }
        else 
        {
            smoothButton.style('border',"0px solid #808080")
            elipticalButton.style('border',"0px solid #808080")
            circularButton.style('border',"0px solid #808080")
            radialButton.style('border',"0px solid #808080")
            noneButton.style('border',"1px solid #808080")
        }
        
        smoothButton.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var tooltipText = "Smooth";
            
            iconButtonTooltipForPieChart.style("width","72px").style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForPieChart.html('<div  style="width: 100%; height:0%; padding-left:16px; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; ">'+ tooltipText +'</div>')
        })
        smoothButton.on('mouseout', function(d,i) {
            iconButtonTooltipForPieChart.style("display","none")
        })

        elipticalButton.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var tooltipText = "Elliptical";
            
            iconButtonTooltipForPieChart.style("width","75px").style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForPieChart.html('<div  style="width: 100%; height:0%; padding-left:16px; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; ">'+ tooltipText +'</div>')
        })
        elipticalButton.on('mouseout', function(d,i) {
            iconButtonTooltipForPieChart.style("display","none")
        })

        circularButton.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var tooltipText = "Circular";
            
            iconButtonTooltipForPieChart.style("width","72px").style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForPieChart.html('<div  style="width: 100%; height:0%; padding-left:16px; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; ">'+ tooltipText +'</div>')
        })
        circularButton.on('mouseout', function(d,i) {
            iconButtonTooltipForPieChart.style("display","none")
        })

        radialButton.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var tooltipText = "Radial";
            
            iconButtonTooltipForPieChart.style("width","63px").style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForPieChart.html('<div  style="width: 100%; height:0%; padding-left:16px; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; ">'+ tooltipText +'</div>')
        })
        radialButton.on('mouseout', function(d,i) {
            iconButtonTooltipForPieChart.style("display","none")
        })

        noneButton.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var tooltipText = "None";
            
            iconButtonTooltipForPieChart.style("width","58px").style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForPieChart.html('<div  style="width: 100%; height:0%; padding-left:16px; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; ">'+ tooltipText +'</div>')
        })
        noneButton.on('mouseout', function(d,i) {
            iconButtonTooltipForPieChart.style("display","none")
        })

        // Gradient button on click

        smoothButton.on('click',function(d){
            options.gradient = "smooth";
            smoothButton.style('border',"1px solid #808080")
            elipticalButton.style('border',"0px solid #808080")
            circularButton.style('border',"0px solid #808080")
            radialButton.style('border',"0px solid #808080")
            noneButton.style('border',"0px solid #808080")
			
			var removeStop = radialGradient.selectAll("stop").remove();

            radialGradient.append("stop").attr("offset", "80%").style("stop-color", function(d, i) { return "#f0f0f0"; });
            radialGradient.append("stop").attr("offset", "85%").style("stop-color", "#fbfbfb");
            radialGradient.append("stop").attr("offset", "95%").style("stop-color", function(d, i) { return "#313131"; });
			
			pathForPieChart.style("fill-opacity", 0.8)

        })
        elipticalButton.on('click',function(d){
            options.gradient = "elliptical";
            smoothButton.style('border',"0px solid #808080")
            elipticalButton.style('border',"1px solid #808080")
            circularButton.style('border',"0px solid #808080")
            radialButton.style('border',"0px solid #808080")
            noneButton.style('border',"0px solid #808080")

            var removeStop = radialGradient.selectAll("stop").remove();
        
            radialGradient.append("stop").attr("offset", "25%").style("stop-color", function(d, i) { return "#f5f5f5"; });
            radialGradient.append("stop").attr("offset", "70%").style("stop-color", "#f0f0f0");
            radialGradient.append("stop").attr("offset", "95%").style("stop-color", function(d, i) { return "#313131"; });
			
			pathForPieChart.style("fill-opacity", 0.8)

        })
        circularButton.on('click',function(d){
            options.gradient = "circular";
            smoothButton.style('border',"0px solid #808080")
            elipticalButton.style('border',"0px solid #808080")
            circularButton.style('border',"1px solid #808080")
            radialButton.style('border',"0px solid #808080")
            noneButton.style('border',"0px solid #808080")

            var removeStop = radialGradient.selectAll("stop").remove();

            radialGradient.append("stop").attr("offset", "30%").style("stop-color", function(d, i) { return "#f8f8f8"; });
            radialGradient.append("stop").attr("offset", "97%").style("stop-color", "#2b2b2b");
            radialGradient.append("stop").attr("offset", "100%").style("stop-color", function(d, i) { return "#000000"; });
			
			pathForPieChart.style("fill-opacity", 0.8)

        })
        radialButton.on('click',function(d){
            options.gradient = "radial";
            smoothButton.style('border',"0px solid #808080")
            elipticalButton.style('border',"0px solid #808080")
            circularButton.style('border',"0px solid #808080")
            radialButton.style('border',"1px solid #808080")
            noneButton.style('border',"0px solid #808080")

            var removeStop = radialGradient.selectAll("stop").remove();

            radialGradient.append("stop").attr("offset", "30%").style("stop-color", function(d, i) { return "#000000"; });
            radialGradient.append("stop").attr("offset", "80%").style("stop-color", "#f0f0f0");
            radialGradient.append("stop").attr("offset", "95%").style("stop-color", function(d, i) { return "#313131"; });
			
			pathForPieChart.style("fill-opacity", 0.8)

        })
        noneButton.on('click',function(d){
            options.gradient = "none";
            smoothButton.style('border',"0px solid #808080")
            elipticalButton.style('border',"0px solid #808080")
            circularButton.style('border',"0px solid #808080")
            radialButton.style('border',"0px solid #808080")
            noneButton.style('border',"1px solid #808080")

            var removeStop = radialGradient.selectAll("stop").remove();
			
			pathForPieChart.style("fill-opacity", 1)

        })

        // ----------------------------------- Setting section ends here -------------------------------------------

        // ------------- Filter section starts here ---------------
        var minAndMaxValuesArrayForPieChart = []
            newJson.forEach(function(d, i) {
                var dd = parseFloat(d[options.keys.value])
                minAndMaxValuesArrayForPieChart.push(dd) 
            });
        
        var low = d3.min(minAndMaxValuesArrayForPieChart);
        var hig = d3.max(minAndMaxValuesArrayForPieChart);

        
        var disabledDivForPieChart = targetElement.append('div').style('width',targetElement[0][0].clientWidth + "px").style('height',targetElement[0][0].clientHeight + "px").style('position','absolute')
        .style("background-color",'#f3f3f3').style("z-index",2).style("display","none").style('top', 0.0 + "%").style('left', 0.0 + "%")
        .style("opacity",0.1).style("min-width","350px").style("min-height","350px")

        var newFilterPanelForPieChart = targetElement.append('div').style('width',"100%").style('height',"40%")
        .style('position','absolute').style('margin-left', "0px").style('border-top',"1px solid #f0f0f0").style('border-bottom',"1px solid #e5e5e5")
        .style("background-color",'#fcfcff').style("z-index",90) //001c3b
        .style("display","none").style("overflow-x","auto").style("overflow-y","hidden")
        .style('top',"60%").style('height',"40%")

        var searchDivForPieChartTitle = newFilterPanelForPieChart.append('div').style('background-color',"#ffffff").attr("font-family", "Verdana,sans-serif")
        .style('margin-left','10px').style('margin-top','10px').style('text-indent','5px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","90%").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:15.5%; font-size:14px; font-family:inter; color:#00001c;">'+ "Filter by " + options.keys.value +'</div>')
        
		var sliderBarForPieChart = newFilterPanelForPieChart.append('div').style('background-color',"#ffffff").attr("id",targetElement[0][0].id + "pieChartRangeSliderID")
        .style("width","215px").style('margin-top','87px').style('margin-left','39px').style('position',"absolute").attr("class","sliderBarForPieChartClass")
        
        var cancelButtonForNewFilterPanel = newFilterPanelForPieChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
        .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
        .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.88; background-color:#fcfcff")
        cancelButtonForNewFilterPanel[0][0].appendChild(cancelBtnImgVar)

        cancelButtonForNewFilterPanel.on('click',function(d){
            newFilterPanelForPieChart.style("display","none")

            if(options.showLegend == true && options.showTitle == true){
            
            if(options.legendSide === "left"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%") .style("left",30 + "%")
                    svgPanelForPieChart.style("position","absolute").style('background-color',options.BGcolor);
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }

            }
            else if(options.legendSide === "right"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }

            }
            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                
            }
        }
        else if(options.showLegend == true && options.showTitle == false){
           
            if(options.legendSide === "left"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",0.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }

            }
            else if(options.legendSide === "right"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",0.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
            }
            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",0.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
            }
            
        }
        else if(options.showLegend == false){

            if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 0.0 + "%"; }) .style("height", function(d) { return 0  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 100 + "%") .style('height', 70 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 0.0 + "%"; }) .style("height", function(d) { return 0  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",0.0  + "%");

                    svgPanelForPieChart.style('width', 100 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 0.0 + "%"; }) .style("height", function(d) { return 0  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 100 + "%") .style('height', 85 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
        }

            resizedFuctionForPieChart();
        })

        var textBoxOneForPieChart = newFilterPanelForPieChart.append('input').style("width","80px").style('margin-left','15px').style('margin-top','50px')
        .style('position',"absolute").style('height',"22px").style("border", "1.0px") .style("border-color", "#e6e6e6") .style("border-style", "solid").style('text-indent','5px')
        .attr("value",d3.min(minAndMaxValuesArrayForPieChart)).style("padding","0px").attr("disabled","disabled").style("color","#00001c")

        var toLableForPieChart = newFilterPanelForPieChart.append('div').style('background-color',"#fcfcff").attr("fant-family", "Verdana,sans-serif").style("font-weight", "Bold")
        .style('margin-top','52px').style('margin-left','139px').style('position',"absolute").style("width","25px").style("height","15px")
        .style("box-shadow", "1px 1px 1px #ffffff")
        .html('<div  style="width: 100%; height:100%; background-color:#fdfdfd; font-size:12px; position: absolute;  font-family:inter;  color:#00001c; font-weight:Bold;">'+ "-to-"+'</div>')

        var textBoxTwoForPieChart = newFilterPanelForPieChart.append('input').style("width","80px").style('margin-left','198px').style('margin-top','50px')
        .style('position',"absolute").style('height',"22px").style("border", "1.0px") .style("border-color", "#e6e6e6") .style("border-style", "solid")
        .style('text-indent','5px').attr("value",d3.max(minAndMaxValuesArrayForPieChart)) .attr("disabled","disabled").style("color","#00001c")
        .style("padding","0px")

        var searchAndRenderButton = newFilterPanelForPieChart.append("button").style("width","147px").style("height","22px") .style('position','absolute')
        .style('margin-left','75px').style('font-size','12px').style('margin-top','110px').style("box-shadow", "0px 1px 2px #d9d9d9") .style("border-style", "none")
        .style('background-color',"#2196f3").style("color","#ffffff") // d8ebff
        .style('text-align','center').attr("id","123")
        var textForSearchAndRenderButton = document.createTextNode("Apply Filter")
        searchAndRenderButton[0][0].appendChild(textForSearchAndRenderButton)

         $(function() { 
                    
                // Creating Range Slider Bar in Filter panel.
                $( '#' + targetElement[0][0].id + "pieChartRangeSliderID" ).slider({
                    orientation: "horizontal",
                    min: 0,//d3.min(minAndMaxValuesArrayForPieChart),
                    max: d3.max(minAndMaxValuesArrayForPieChart),
                    step: 1,
                    values: [low,hig],
                    animate: true,
                    range : true,
                    slide: function(event, ui) {
                        filterRangeValueOne = 0;
                        filterRangeValueTwo = 0
                        textBoxOneForPieChart.attr("value",ui.values[0])
                        textBoxTwoForPieChart.attr("value",ui.values[1])
                        filterRangeValueOne = ui.values[0]
                        filterRangeValueTwo = ui.values[1]

                    $('#' + targetElement[0][0].id + "pieChartRangeSliderID").slider().find(".ui-slider-range").css({
                            'background': '#001c3b'});
                    },

                });
            });
        
        var searchedDataArray = [];
        searchAndRenderButton.on('click', function() {
            searchedDataArray = [];
            
            var textBoxOneForPieChartValue = parseFloat(textBoxOneForPieChart[0][0].value) 
            var textBoxTwoForPieChartValue = parseFloat(textBoxTwoForPieChart[0][0].value)
            var toBeFetchedValue = options.keys.value
            
            textBoxOneForPieChart.attr("value","")
            textBoxTwoForPieChart.attr("value","")
            
            newJson.forEach(function(d, i) {
                
                if((+d[toBeFetchedValue] >= textBoxOneForPieChartValue) && (+d[toBeFetchedValue] <= textBoxTwoForPieChartValue) ){
                    
                    searchedDataArray.push(d)
                }
            });
        

            // Checking Filter array length and Displaying Alert. If the length is equal to 0.
            if(searchedDataArray.length == 0){

                var alertPageDisabledDivForPieChart =targetElement.append('div').style('width',100 + '%')
                .style('height',100 + "%").style('position','absolute').style('margin-left', '0px').style('top', '0px')
                .style("background-color",'#f3f3f3').style("z-index",99).style("opacity",0.2).style("display","block")

                var alertDivForPieChart = targetElement.append('div').style('width','350px')
                .style('height',"150px").style('position','absolute').style('left', ((targetElement[0][0].clientWidth/2) - 175) + "px").style('top', '1px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "solid").style("border-width","2px")
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","0px")
                .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Normal;">Sorry, no result found for selected range!</div>')

                var alertDivTitleForPieChart = alertDivForPieChart.append('div').style('width','340px').style('height',"30px").style('position','absolute')
                .style('margin-left', "0px").style('top', '0px').style("background-color",'#313131').style("z-index",99).style("border-color", "#181818")
                .style("border-style", "none").style("border-width","2px").style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","0px")
                .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; font-weight:Bold; text-indent:5px;  color:#e5e5e5; font-weight:Normal;">TimeBound</div>')

                var pieChartAlertOKButton = alertDivForPieChart.append("button") .style("width","40px") .style("height","20px") .style('position','absolute')
                .style('background-color',"#7cc15e") .style('margin-left','300px') .style('top', "120px").style("color","#ffffff")
                .style("display","block").style('padding-top',"0px").style("cursor","pointer").style("box-shadow", "1px 1px 1px #56973a") .style("border-style", "none")
                .style("font-family","Verdana,sans-serif").style("font-size","14px").style("text-align","center").style("vertical-align","middle").style("border-radius","0px")
                .style("z-index",999)
            
                var textForPieChartAlertOKButton = document.createTextNode("OK");
                pieChartAlertOKButton[0][0].appendChild(textForPieChartAlertOKButton)

                $("#"+targetElement[0][0].id).resizable('disable');

                pieChartAlertOKButton.on('click', function() {
                    alertDivForPieChart.remove();
                    alertPageDisabledDivForPieChart.remove()
                    $("#"+targetElement[0][0].id).resizable('enable');
                })

                filterButtonForPieChart.style("cursor","pointer")
                disabledDivForPieChart.style("display","none")
                
                newFilterPanelForPieChart.style("display","none")
                
                $(function() { 

                        textBoxOneForPieChart.attr("value",d3.min(minAndMaxValuesArrayForPieChart))
                        textBoxTwoForPieChart.attr("value",d3.max(minAndMaxValuesArrayForPieChart))
                            var $slide = $( '#' + targetElement[0][0].id + "pieChartRangeSliderID" ).slider({
                                range: true,
                                values: [low,hig],
                                min: 0,
                                 max: d3.max(minAndMaxValuesArrayForPieChart)
                            });
                        });

                if(showOrHideTableForPieChart == false){ 
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style('background-color',options.BGcolor)
                    legendPanelFront.style('width', 35 + "%") .style('height', 85 + "%").style("position","absolute")
                }   
                else if(showOrHideTableForPieChart == true){ 
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor)
                    legendPanelFront.style('width', 35 + "%") .style('height', 52 + "%").style("position","absolute")
                } 

                resizedFuctionForPieChart();
            }
            else if(searchedDataArray.length > 0){
                d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                options.data = searchedDataArray;
                acinfotech.pieChart(targetElement,options)
            }

        }) //searchAndRenderButton

        // Getting SVG container WIDTH and HEIGHT which holds Pie-Chart 
        var width1 = targetElement[0][0].clientWidth * (parseFloat(svgPanelForPieChart[0][0].style.width) / 70)
        var height1 = targetElement[0][0].clientHeight * (parseFloat(svgPanelForPieChart[0][0].style.height) / 77)

        // Calculating radius for Pie-Chart
        var radiusForPieChart = Math.min(width1, height1) / 3.0;
        
        // Again calculating radius for Pie-Chart based on Chart Title and Legend is choosen (true or false) while library is called.
        if(options.showTitle == false && options.showLegend == false){
             radiusForPieChart = Math.min(width1, height1) / 2.8;
        }
         else if(options.showTitle == true && options.showLegend == false){
             radiusForPieChart = Math.min(width1, height1) / 2.5;
        }

        // Creating ToolTip Div
        var tooltipPieForPieChart = targetElement .append('div') .attr('class', 'tooltipPie') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
        .style("color","#00001c") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
        .style("padding-right", "7px") .style("background", "#F8F8F8") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style("z-index",1000)
        .style("border", "1.0px") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","100px")
        tooltipPieForPieChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'label').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "12px") .style("font-weight", "Normal");
        tooltipPieForPieChart.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
        tooltipPieForPieChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "12px").style("font-weight", "Normal");
        
        // checking color set for pie slices and legend dots
        if(options.colorSet === undefined){
            options.colorSet = "one"
            var color = d3.scale.ordinal().range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "one"){
            options.colorSet = "one"
            var color = d3.scale.ordinal().range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            options.colorSet = "two"
             var color = d3.scale.ordinal().range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            options.colorSet = "three"
            var color = d3.scale.ordinal().range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        }
        else
        {
            options.colorSet = "one"
            var color = d3.scale.ordinal().range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }

        // Getting minimum and maximum values in the JSON array.
        var minAndMaxValuesArrayForPieChart = []
            newJson.forEach(function(d, i) {
                var dd = parseFloat(d[options.keys.value])
                minAndMaxValuesArrayForPieChart.push(dd) 
            });
        
        var low = d3.min(minAndMaxValuesArrayForPieChart);
        var hig = d3.max(minAndMaxValuesArrayForPieChart);

        /*---------- Creating set of buttons for Changing Chart, Refresh, Resize, Filter, Clear Filter, Search and Setting. ---------- */

        var searchChartButton = optionsButtonPanelForPieChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top','1px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        var searchBtnImgVar = document.createElement("IMG");
        searchBtnImgVar.src = "images/searchChart1.png";
        searchBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.82;")
        searchChartButton[0][0].appendChild(searchBtnImgVar)

        var threeDViewButtonForPieChart = optionsButtonPanelForPieChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top','27px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        var threeDViewBtnImgVar = document.createElement("IMG");
        threeDViewBtnImgVar.src = "images/3DView.png";
        threeDViewBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.82;")
        threeDViewButtonForPieChart[0][0].appendChild(threeDViewBtnImgVar)

        var tableButtonForPieChart = optionsButtonPanelForPieChart.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 53 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
        var tableBtnImgVar = document.createElement("IMG");
        if(showOrHideTableForPieChart == false){
            tableBtnImgVar.src = "images/showTableIcon.png";
            tableButtonForPieChart.attr("class","showTableClassForChartTable")
        }
        else if(showOrHideTableForPieChart == true){
            tableBtnImgVar.src = "images/cancelTableIcon.png";
            tableButtonForPieChart.attr("class","hideTableClassForChartTable")
        }
        tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
        tableButtonForPieChart[0][0].appendChild(tableBtnImgVar)
        
        var settingBtnForPieChart = optionsButtonPanelForPieChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 80 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        var settingBtnImgVar = document.createElement("IMG");
        settingBtnImgVar.src = "images/settingsIcon.png";
        settingBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.82;")
        settingBtnForPieChart[0][0].appendChild(settingBtnImgVar)
        
        var downloadBtnForPieChart = optionsButtonPanelForPieChart.append("div").attr("id","downloadBtnForPieChart-ID-" + targetElement[0][0].id).style("width","20px").style("height","20px")
        .style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff").style('margin-left','2px').style('top', 107 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        
        acinfotech.downloadFunctionality("downloadBtnForPieChart-ID-" + targetElement[0][0].id,targetElement)
        
		bubbleButtonForPieChart.on('click', function() {
            
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                                   
            var newOptions = {
                data: newJson,
                dataForTable: options.dataForTable,
                isDataDetailedForTable: options.isDataDetailedForTable,
                keys: {
                    label: options.keys.label,
                    value: options.keys.value
                },
                chartTitle: options.chartTitle,
                showTitle: options.showTitle,
                colorSet: options.colorSet,
                series:options.series,
                legend:options.legend,
                BGcolor:options.BGcolor,
                drillDownColumnName:options.drillDownColumnName,
                showTable: false,
                showComments: options.showComments,
                comments: options.comments,
                resizeButtonID: options.resizeButtonID
            }
            acinfotech.bubbleChart(targetElement, newOptions)

        })

        // Calling Column-Chart when columnChartButton clicked. (changing chart)
        colButtonForPieChart.on('click', function() {
            options.showTable = false;
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            var newOptions = {
                           data: newJson,
                           dataForTable: options.dataForTable,
                           isDataDetailedForTable: options.isDataDetailedForTable,
                           keys: {
                               label: options.keys.label,
                               value: options.keys.value
                           },
                           chartTitle:options.chartTitle,
                           xAxisLable:options.keys.label,
                           yAxisLable:options.keys.value,
                           showTitle:options.showTitle,
                           colorSet: options.colorSet,
                           BGcolor:options.BGcolor,
                           series:options.series,
                           legend:options.legend,
                           drillDownColumnName:options.drillDownColumnName,
                           showTable:options.showTable,
                           showComments: options.showComments,
                           comments: options.comments,
                           resizeButtonID: options.resizeButtonID
                       }
                       
                acinfotech.columnChart(targetElement, newOptions)
        })

        // Calling Donut-Chart when doNutChartButton clicked. (changing chart)
        donutButtonForPieChart.on('click', function() {
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            options.showTable = false;
            colorSet: options.colorSet;
            BGcolor:options.BGcolor;
            series:options.series;
            legend:options.legend;
            options.gradient = "none";
            acinfotech.donutChart(targetElement, options)
        })

        // Calling Horizontal-Chart when horizontalChartButton clicked. (changing chart)
        horButtonForPieChart.on('click', function() {
            options.showTable = false;
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            var newOptions = {
                   data: newJson,
                   dataForTable: options.dataForTable,
                   isDataDetailedForTable: options.isDataDetailedForTable,
                   keys: {
                       label: options.keys.label,
                       value: options.keys.value
                   },
                   chartTitle:options.chartTitle,
                   xAxisLable:options.keys.value,
                   yAxisLable:options.keys.label,
                   showTitle:options.showTitle,
                   colorSet: options.colorSet,
                   BGcolor:options.BGcolor,
                   series:options.series,
                   legend:options.legend,
                   drillDownColumnName:options.drillDownColumnName,
                   showTable:options.showTable,
                   showComments: options.showComments,
                   comments: options.comments,
                   resizeButtonID: options.resizeButtonID
               }
               acinfotech.horizontalChart(targetElement, newOptions)
        })

        // Refreshing Chart and Table (Pie-Chart) when reFreshChartButton clicked.
        refreshButtonForPieChart.on('click', function() {

            isFilterClicked = false

            if(isThreeDPieChartEnabled == true){
                backButtonForPieChart.remove();
            }

            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                }
            }
            acinfotech.pieChart(targetElement,options) 
        })

        // Filtering Chart and Table when filterChartButton clicked.
        filterButtonForPieChart.on('click', function() {
            isFilterClicked = false
           
            // Calling the resetTableWidthOldDataFunction to reset Table with old data before filtering it.
            resetTableWidthOldDataFunction() 
            
            iconButtonTooltipForPieChart.style("display","none") // To hide option button tool tip
                
            newFilterPanelForPieChart.style("display","block") // To display filter panel

            newSettingPanelForPieChart.style("display","none") // To hide setting panel

            ismenuButtonOfPieChartClicked = false; // Menu toggle button variable

            optionsButtonPanelForPieChart.style("display","none") // To hide options button panel

            if(isThreeDPieChartEnabled == true){ // Checking whether 3D Pie-Chart is enabled
                svgForHolding3DPieChart.remove();
                svgForHolding3DPieChartLegends.remove();
                backButtonForPieChart.remove();
                iconButtonTooltipForPieChart.style("display","none")
            }

            //svgPanelForPieChart.style('width', 70 + "%") .style('height', 52 + "%").style("position","absolute") // Decreasing the Chart panel height
            //legendPanelFront.style('width', 30 + "%") .style('height', 52 + "%").style("position","absolute") // Decreasing the Legend panel height

            if(options.showLegend == true && options.showTitle == true){
            
            if(options.legendSide === "left"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%") .style("left",35 + "%").style('background-color',options.BGcolor)
                    svgPanelForPieChart.style("position","absolute");
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }

            }
            else if(options.legendSide === "right"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }

            }
            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                
            }
        }
        else if(options.showLegend == true && options.showTitle == false){
           
            if(options.legendSide === "left"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",0.0  + "%").style('background-color',options.BGcolor);

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }

            }
            else if(options.legendSide === "right"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",0.0  + "%").style('background-color',options.BGcolor);

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
            }
            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",0.0  + "%").style('background-color',options.BGcolor);

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
            }
            
        }
        else if(options.showLegend == false){
            legendPanelFront.style("width", function(d) { return 0.0 + "%"; }) .style("height", function(d) { return 0.0  + "%"; })
            .style("position","absolute") .style("left",0 + "%") .style("top",0.0  + "%").style('background-color',options.BGcolor);
            svgPanelForPieChart.style('width', 100 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
        }

            resizedFuctionForPieChart(); // Calling the resize function

        }) //filterChartButton.on('click', function() )
        
        // showing/hidding chart table
        tableButtonForPieChart.on('click', function() {

            if(showOrHideTableForPieChart == false){ // Toggle logic for table button when table button is clicked
                options.showTable = true;
            }
            else if(showOrHideTableForPieChart == true){ // Toggle logic for table button when table button is clicked
                options.showTable = false;
            }

            isFilterClicked = false

            if(isThreeDPieChartEnabled == true){ // Checking if 3D Pie-Chart is enabled
                backButtonForPieChart.remove();
            }

            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove(); // Remove all elements within Parent DIV
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                    options.showComments = false;
                }
            }
            acinfotech.pieChart(targetElement,options)

        })

        
        settingBtnForPieChart.on('click', function() {
                
                ismenuButtonOfPieChartClicked = false; // Menu toggle button variable
                optionsButtonPanelForPieChart.style("display","none") // To hide options button panel

                iconButtonTooltipForPieChart.style("display","none") // Removing options button ToolTip
                settingBtnForPieChart.style("cursor","pointer")
                
                if(isThreeDPieChartEnabled == true){ // Checking if 3D Pie Chart enabled
                    svgForHolding3DPieChart.remove();
                    svgForHolding3DPieChartLegends.remove();
                    backButtonForPieChart.remove();
                    iconButtonTooltipForPieChart.style("display","none")
                }

                newSettingPanelForPieChart.style("display","block") // Showing settings panel

                 // Checking the Chart Title and Chart Legend choosen (true or false) when Library Called.
        if(options.showLegend == true && options.showTitle == true){
            
            if(options.legendSide === "left"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%") .style("left",35 + "%").style('background-color',options.BGcolor)
                    svgPanelForPieChart.style("position","absolute");
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }

            }
            else if(options.legendSide === "right"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }

            }
            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                
            }
        }
        else if(options.showLegend == true && options.showTitle == false){
           
            if(options.legendSide === "left"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",0.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }

            }
            else if(options.legendSide === "right"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",0.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
            }
            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",0.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
                }
            }
            
        }
        else if(options.showLegend == false){
            legendPanelFront.style("width", function(d) { return 0.0 + "%"; }) .style("height", function(d) { return 0.0  + "%"; })
            .style("position","absolute") .style("left",0 + "%") .style("top",0.0  + "%");
            svgPanelForPieChart.style('width', 100 + "%") .style('height', 52 + "%").style("position","absolute").style('background-color',options.BGcolor); 
        }

                resizedFuctionForPieChart(); // Calling resize function()

        })
    
        // showing/hidding chart comment panel
        commentsBtnForPieChart.on('click', function() {

            if(options.showComments == false){ 
                options.showComments = true;
            }
            else if(options.showComments == true){ 
                options.showComments = false;
            }

            isFilterClicked = false

            if(isThreeDPieChartEnabled == true){ // Checking if 3D Pie-Chart is enabled
                backButtonForPieChart.remove();
            }

            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove(); // Remove all elements within Parent DIV
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                    options.showTable = false;
                }
            }
            acinfotech.pieChart(targetElement,options)

        })
        
        downloadBtnForPieChart.on('click', function() {
                                  
          ismenuButtonOfPieChartClicked = false; // Changing menu button value to false
          optionsButtonPanelForPieChart.style("display","none") // Hiding option buttons panel
          
          iconButtonTooltipForPieChart.style("display","none") // Hiding button tooltip
          filterButtonForPieChart.style("cursor","pointer") // changing mouse pointer
                                  
        })
        
        // Creating DIV for holding Search Table (Temporary Table) when Search button is clicked.
        var tempDivTableForPieChart;
        var isSearchInTableButtonClicked = false;

        // to hold cancel button of search panel while resizing.
        var canBtnForSearchTableForPieChart;

        // Creaing left panel for holding Search Box and small Column Chart and on RHS Search Table (Temporary Table) when Search button is clicked.
        searchChartButton.on('click', function() {
            
            ismenuButtonOfPieChartClicked = false; // Menu toggle button variable
            optionsButtonPanelForPieChart.style("display","none") // To hide options button panel

            isSearchInTableButtonClicked = true;

            // Div for disabling whole Chart and Main Table expect Search panel and Search Table
            var disabledDivForPieChartForSearchTable = targetElement.append('div').style('width',100 + "%").style('height',100 + "%").style('position','absolute')
            .style("background-color",'#f3f3f3').style("z-index",2).style("display","none").style('top', 0.0 + "%").style('left', 0.0 + "%")
            .style("opacity",0.3).style("min-width","350px").style("min-height","350px") //005ec4

            //Creaing left panel for holding Search Box and small Column Chart
            var searchDivForPieChartForSearchTable = targetElement.append('div').style('width',100 + "%").attr("class", "searchDivForPieChartForSearchTableClass" + targetElement[0][0].id)
            .style('height',52 + "%").style('position','absolute').style('margin-left', "0px")//.style('top', parseFloat(chartTitlePanelForPieChart.style("height")) + 40 + 'px')
            .style("background-color",'#ffffff').style("z-index",90).style("border-color", "#ffffff")
            .style("display","block").style('top', 60.0 + "%").style('height', 40.0 + "%").style("border-top","1px solid #f0f0f0")

            // Title for Search panel
            var searchDivForPieChartForSearchTableTitle = searchDivForPieChartForSearchTable.append('div')/*.text("Search by " + options.keys.value)*/.style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif").style("font-weight", "Bold")
            .style('margin-left','0px').style('margin-top','20px').style('text-indent','3px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
            .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#00001c").style("font-family","Verdana,sans-serif").style("font-weight","Bold").style("display","none")
            .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter;  color:#00001c; font-weight:Bold;">'+ "Search" +'</div>')

            // DIV for holding small Column-Chart
            var smallChartAreaDivForPieChart = searchDivForPieChartForSearchTable.append('div').style('width',100 + "%").style('height',100 + "%").style('position','absolute')
            .style("background-color",'#f0f0f0').style("z-index",2).style("display","block").style('top', 0.0 + "px").style('left', 0.0 + "px")
            .style("opacity",1.0).attr("id","smallColumnChartIDForPieChart" + targetElement[0][0].id)
            
            // DIV for holding Search Table
            tempDivTableForPieChart = targetElement.append('div').style('width',100 + "%").style('height', 60.0 + "%").style('top', 0.0 + "%")
            .style('position','absolute').style('margin-left', "0px")
            .style("background-color",'#ffffff').style("z-index",90).style("border-color", "#ffffff")
            .style("display","block")
            
            // Title DIV for Search Table
            var searchResultTableDivTitleForPieChart = tempDivTableForPieChart.append('div').style('background-color',"#e9e9e9").attr("fant-family", "Verdana,sans-serif").style("font-weight", "Bold")
            .style('margin-left','0px').style('margin-top','0px').style('text-indent','3px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
            .style("width","100"+"%").style("height","15" + "%").style("color","#00001c")
            
            // Search Text Box for Search panel
            var searchTextBoxForPieChart = searchResultTableDivTitleForPieChart.append('input').style("width","220px").style('margin-left','1px').style('margin-top','2px')
            .style('position',"absolute").style('height',"26px").style("border", "1.0px") .style("border-color", "#e2e2e2") .style("border-style", "solid").style('text-indent','30px')
            .attr("placeholder","eg: sales").attr("id","autoSearchTextBoxForPieChart" + targetElement[0][0].id).style("font-size","14px").style("box-sizing","border-box")
            .style("background-image","url('images/searchChart2.png')").style("background-repeat","no-repeat").style("font-weight","Normal") 
            .style("background-size",'18px 18px').style("background-position",'5px 3px').style("display","block").style("line-height","Normal")
            .style('outline-width',"0px")
            
            canBtnForSearchTableForPieChart = searchResultTableDivTitleForPieChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
            .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
            .style('background-color',"#e9e9e9")
            .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
            .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
            var cancelBtnImgVar = document.createElement("IMG");
            cancelBtnImgVar.src = "images/closeIcon.png";
            cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.88; background-color:#e9e9e9")
            canBtnForSearchTableForPieChart[0][0].appendChild(cancelBtnImgVar)

            // Enabling whole Chart and Table and removing Search panel and Search Table, when Cancel button of Search panel is called.
            canBtnForSearchTableForPieChart.on('click', function() {

                disabledDivForPieChartForSearchTable.remove();
                searchDivForPieChartForSearchTable.remove();
                tempDivTableForPieChart.remove()

                if(isThreeDPieChartEnabled == true){
                    backButtonForPieChart.remove();
                }

                d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
                for(var i = 0; i<divAndChartsArray.length; i++){

                    if(targetElement[0][0].id === divAndChartsArray[i].divID){
                        options.data = divAndChartsArray[i].optionsData
                    }
                }
                acinfotech.pieChart(targetElement,options) 
            })

            // DIV for holing only Search Table
            var searchResultTablePanelForPieChart =  tempDivTableForPieChart.append("div")
            .attr("class", "searchResultTablePanelForPieChart" + targetElement[0][0].id)
            .style('background-color',"#ffffff") .style('position','absolute') .style("display","block") .style("overflow","auto")
            .style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 85 + "%"; }) .style("left",0 + "%")
            .style("top","15"+"%")

            // Creating Table (Search Table)
            searchResultTablePanelForPieChart.html('<table  border="0px" style=" width:99.9%; height:auto;   position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9px; border-collapse:collapse; border-color:#ebf5e6; " >'+
              '<thead  style="background-color:#DFF0D8;">' +'</thead>'+
              '<tbody class="myTBody" style="background-color:white; width:99.9%; height:auto;  ">'+'</tbody>'+
              '</table>'
              )
            searchResultTablePanelForPieChart.select("table").attr("id","searchTableIdForPieChart" + targetElement[0][0].id)

            // Setting colors for Search Column-bars
            var colors = d3.scale.ordinal() .range(["#ff6c3e", "#ffbb03", "#3fcb56", "#d05767", "#55bf9b", "#0095b3", "#7a92a9","#663399","#29b5eb","#ff9878","#CCCCCC","#008d8d"]);

            var thead = searchResultTablePanelForPieChart.select("thead").selectAll("th") .data(d3.keys(newJson[0]))
            .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1) + " "}).style("min-width","100px").style("color","#00001c")
        
            var tr = searchResultTablePanelForPieChart.select("tbody").selectAll("tr") .data(newJson).enter().append("tr") //.style("background-color",function(d,i){  return colors(i);})
        
            var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d})
            .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")

            // Filtering the Search Table 
            $(document).ready(function(){
                var tblBodyObj = document.getElementById("searchTableIdForPieChart" + targetElement[0][0].id).tBodies[0];
                
                for (var i=0; i<tblBodyObj.rows.length; i++) {

                    var newCell = tblBodyObj.rows[i].insertCell(-1)
                    newCell.style.minWidth = "20px";
                    newCell.style.maxWidth = "20px";
                    newCell.style.textAlign = "left"
                   
                    var div = document.createElement('div')
                    div.style.width = "15px";
                    div.style.height = "35%";
                    div.style.borderRadius = "0px";
                    div.style.opacity = 0.9;
                    div.style.minWidth = "15px"
                    div.style.maxWidth = "15px"
                    div.style.background = colors(i);
                    newCell.appendChild(div);
                }   
            });

            // Styling the Search Table Rows.
            searchResultTablePanelForPieChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
            .style("color","#00001c")
            .style("height","25px").style("border", "1px solid #e9e9ea").style("background-color","#f6f6f6") //.style("box-shadow","10px 10px 50px #007aff").style("z-index",9999)
            searchResultTablePanelForPieChart.selectAll('td').style("height","25px") .style("border", "1px solid #f8f8f8") .style("font-size","12px").style("font-weight","Normal")

            // Calling smallColumnChart with orignal data and limited options.
            var chartElement = d3.select("#smallColumnChartIDForPieChart" + targetElement[0][0].id);
            var smallColumnChartoptions = {
                           data: options.data,
                           series:options.series,
                           legend:options.legend,
                           BGcolor:options.BGcolor,
                           keys: {
                               label: options.keys.label,
                               value: options.keys.value
                           },
                           xAxisLable: options.keys.label,
            }
            acinfotech.smallColumnChart(chartElement,smallColumnChartoptions)    

                // Array to hold searched items (full object)
                var searchTextBoxArrayForPieChart = [];

                $(document).ready(function(){
                    $("#" + "autoSearchTextBoxForPieChart" + targetElement[0][0].id).off('input');
                    $("#" + "autoSearchTextBoxForPieChart" + targetElement[0][0].id).on('keyup', function(){
                        textChangedFunction(this.value)
                    });
                });
                 
                 // function to search data in original set of data with Search Box entered value.
                 function textChangedFunction (val) {
                    var textBoxValueLowerCased = val //this.value
                    searchTextBoxArrayForPieChart = [];
        
                    newJson.forEach(function(d, i) {
                        var dd = d3.values(d);
                        var eachObjectArray = [];
                        eachObjectArray.push(d3.values(d))
                        d[options.keys.value] = d[options.keys.value].toString();
                
                    for(var i = 0; i<Object.keys(d).length; i++){
                        var lower = d3.values(d)[i].toString().toLowerCase()
                        if ( lower.toLowerCase().indexOf(textBoxValueLowerCased.toLowerCase()) > -1 ) {
                            searchTextBoxArrayForPieChart.push(d)
                            break;
                        }
                    }
                });
                
                // clearing smallColumnChart DIV each time a keyboard key is hit.
                smallChartAreaDivForPieChart.selectAll("*").remove();    
                var chartElement = d3.select("#smallColumnChartIDForPieChart" + targetElement[0][0].id);
                var smallColumnChartoptions = {
                           data: searchTextBoxArrayForPieChart,
                           BGcolor:options.BGcolor,
                           series:options.series,
                           legend:options.legend,
                           keys: {
                               label: options.keys.label,
                               value: options.keys.value
                           },
                           chartTitle:"",
                           xAxisLable: options.keys.label,
                        }
                if(searchTextBoxArrayForPieChart.length == 0){
                    smallChartAreaDivForPieChart.selectAll("*").remove();     
                }
                else {
                    acinfotech.smallColumnChart(chartElement,smallColumnChartoptions)    
                }
            
            // Removing the Search Table Rows
            var table = searchResultTablePanelForPieChart.select('table');
            var rows = table.selectAll('tr')
            rows.remove();

            // Creating new Rows for Search Table based on Searched Result (using searchTextBoxArrayForPieChart array)
            var table = searchResultTablePanelForPieChart.select('table');
            var rows = table.selectAll('tr').data(searchTextBoxArrayForPieChart);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})

            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition()
            .delay(20) .duration(20) .style('opacity', 1.0) .style("color","#00001c");
            
            cells.text(function(d,i) {return d});

            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(20) .duration(20) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})

            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(20)
            .duration(20) .style('opacity', 1.0) .style("color","#00001c");

            // Adding new row for color dots in Search Table
            $(document).ready(function(){
                
                for (var i=0; i<table[0][0].rows.length; i++) {

                    var newCell = table[0][0].rows[i].insertCell(-1);
                    newCell.style.minWidth = "20px";
                    newCell.style.maxWidth = "20px";
                    newCell.style.textAlign = "left"
                   
                    var div = document.createElement('div')
                    div.style.width = "15px";
                    div.style.height = "35%";
                    div.style.borderRadius = "0px";
                    div.style.opacity = 0.9;
                    div.style.minWidth = "15px"
                    div.style.maxWidth = "15px"
                    div.style.background = colors(i);
                    newCell.appendChild(div);
                }
            });

            var t = document.getElementById("searchTableIdForPieChart" + targetElement[0][0].id).tBodies[0]
            
            cells_in_new_rows.text(function(d,i) {return d});

            rows.exit() .attr('class', 'exit') .transition() .delay(20) .duration(20) .style('opacity', 0.0) .remove();

            // Checking the Browser
            if(navigator.userAgent.indexOf("Firefox") != -1 ) 
            {
                table.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("text-align","left").style("padding-left","6px").style("color","#00001c")
                .style("height","25px") .style("border", "1px solid #b1da9f") 
            
                searchResultTablePanelForPieChart.selectAll('td').style("height","25px") .style("border", "1px solid #ffffff") .style("font-size","12px").style("padding-left","6px")
                .style("font-weight","Normal").style("color","#00001c")

            }

            else{
                searchResultTablePanelForPieChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("text-align","left").style("padding-left","6px").style("color","#00001c")
                .style("height","25px") .style("border", "1px solid #e9e9ea").style("background-color","#f6f6f6")  
            
                searchResultTablePanelForPieChart.selectAll('td').style("height","25px") .style("border", "1px solid #f8f8f8") .style("font-size","12px").style("padding-left","6px")
                .style("font-weight","Normal").style("color","#00001c")
            }

        }//textChangeFunction ends here
            
            // Disabling Browser page scrolling when Search left panel appears
            $( '.searchDivForPieChartForSearchTableClass' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
                var e0 = e.originalEvent,
                delta = e0.wheelDelta || -e0.detail;
    
                this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
                e.preventDefault();
            });

            // Disabling Browser page scrolling when Search Table appears
            $( '.searchResultTablePanelForPieChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
                var e0 = e.originalEvent,
                delta = e0.wheelDelta || -e0.detail;
    
                this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
                e.preventDefault();
            });

            // Removing options button ToolTip, changing mouse pointer, disabling Chart and Main Table and expanding Search panel and Search Table. 
            iconButtonTooltipForPieChart.style("display","none")
            
            if(options.showTitle == false){
                //searchDivForPieChartForSearchTable.style('top', 60.0 + "%").style('height', 60.0 + "%")
                //tempDivTableForPieChart.style("display","block").style('width', (targetElement[0][0].clientWidth - 260) + "px")
                //.style('height', 60.0 + "%").style('top', 0.0 + "%")//.transition().duration(200).delay(50)
            
            }
            else if(options.showTitle == true){
               // searchDivForPieChartForSearchTable.style('top', 8.0 + "%").style('height', 52.0 + "%")
                //tempDivTableForPieChart.style("display","block").style('width', (targetElement[0][0].clientWidth - 260) + "px")
                //.style('height', 52.0 + "%").style('top', 8.0 + "%")//.transition().duration(200).delay(50)
            
            }
            
            
        }) //searchChartButton.on('click', function()) ends here 

        var svgForHolding3DPieChart;
        var svgForHolding3DPieChartLegends;
        var svgForHolding3DPieChart_X;
        var svgForHolding3DPieChart_Y;
        var backButtonForPieChart;
        var legendFor3DPieChart;
        var isThreeDPieChartEnabled = false;
        var colorsForThreeDPieChart = d3.scale.ordinal() .range(["#DC3912", "#ffbb03", "#5d420b", "#4f9f00", "#9a270c", "#511414", "#808000","#307D7E","#AF7817","#00264e","#009bb9","#944c0d"]);

        threeDViewButtonForPieChart.on('click', function() {

            ismenuButtonOfPieChartClicked = false
            optionsButtonPanelForPieChart.style("display","none")

            if(isThreeDPieChartEnabled == true){
                svgForHolding3DPieChart.remove()
                svgForHolding3DPieChartLegends.remove()
                backButtonForPieChart.remove()
            }

            isThreeDPieChartEnabled = true

            // creating SVG for holding 3D view Pie-Chart
            svgForHolding3DPieChart = targetElement.append("svg").style("position","absolute").style("background-color",options.BGcolor).style("z-index",2)

            // creating SVG for holding 3D view Legends
            svgForHolding3DPieChartLegends = targetElement.append("svg").style("position","absolute").style("background-color",options.BGcolor)

            if(options.showTitle == true){

                if(showOrHideTableForPieChart == false){

                    svgForHolding3DPieChart.style("width",65 + "%").style("height",85 + "%").style("top",8+"%").style("left",0 + "%")
                    .style("background-color",options.BGcolor)//.attr("id","svgForHolding3DPieChartID" + targetElement[0][0].id)

                    svgForHolding3DPieChartLegends.style("width",35 + "%").style("height",85 + "%").style("top",8+"%").style("left",65 + "%")
                    .style("background-color",options.BGcolor)//.attr("id","svgForHolding3DPieChartID" + targetElement[0][0].id)

                }
                else if(showOrHideTableForPieChart == true){

                    svgForHolding3DPieChart.style("width",65 + "%").style("height",52 + "%").style("top",8+"%").style("left",0 + "%")
                    .style("background-color",options.BGcolor)//.attr("id","svgForHolding3DPieChartID" + targetElement[0][0].id)

                    svgForHolding3DPieChartLegends.style("width",35 + "%").style("height",52 + "%").style("top",8+"%").style("left",65 + "%")
                    .style("background-color",options.BGcolor)//.attr("id","svgForHolding3DPieChartID" + targetElement[0][0].id)    
                }

                svgForHolding3DPieChart_X = (targetElement[0][0].clientWidth * (parseFloat(svgForHolding3DPieChart[0][0].style.width) / 100))/2
                svgForHolding3DPieChart_Y = (targetElement[0][0].clientHeight * (parseFloat(svgForHolding3DPieChart[0][0].style.height) / 100))/2
                svgForHolding3DPieChart.append("g").attr("id","svgForHolding3DPieChart"+targetElement[0][0].id)
                
                var threeDPieChartRadius_rx = Math.min((svgForHolding3DPieChart_X * 2), (svgForHolding3DPieChart_Y * 2)) / 2.2
                var threeDPieChartRadius_ry = Math.min((svgForHolding3DPieChart_X * 2), (svgForHolding3DPieChart_Y * 2)) / 4.7

                threeDPieChartCallFunction("svgForHolding3DPieChart"+targetElement[0][0].id, options.data, svgForHolding3DPieChart_X, svgForHolding3DPieChart_Y, threeDPieChartRadius_rx, threeDPieChartRadius_ry, 25, 0.00)
                
            }
            else if(options.showTitle == false){
                svgForHolding3DPieChart.style("width",100 + "%").style("height",60 + "%").style("top",0+"%").style("lef",0 + "%")
                .style("background-color","007aff")
                threeDPieChartCallFunction()
            }

            backButtonForPieChart = targetElement.append("button").style("width","40px").style("height","23px").style('position','absolute').style('padding',"0px")
            .style("box-shadow", "0px 1px 1px #B8B8B8") .style('background-color',"#484848").style('margin-left','0px').style('top', parseFloat(chartTitlePanelForPieChart.style("height")) + (2) + 'px')
            .style("cursor","pointer").style("display","block").style("box-shadow", "0px 1px 1px #B8B8B8") .style("border-style", "none").style("font-family","Verdana,sans-serif")
            .style("color","#ffffff").style("border-radius","0px").style("z-index",2)
            var backButtononIconImageVariable = document.createElement("IMG");
            backButtononIconImageVariable.src = "images/backButton.png";
            backButtononIconImageVariable.style.width = "18px"
            backButtononIconImageVariable.style.height = "18px"
            backButtononIconImageVariable.style.marginLeft = "1px"
            backButtononIconImageVariable.style.marginTop = "1px"
            backButtonForPieChart[0][0].appendChild(backButtononIconImageVariable)
            

            backButtonForPieChart.on('mouseover', function(d,i) {
                var reloadButtonTooltipText = "Back to 2D View";
                var titleHeight = parseFloat(chartTitlePanelForPieChart.style("height"))
                iconButtonTooltipForPieChart.style("width","100px").style("height","50px").style("margin-left", (1) + "px").style("margin-top",(titleHeight + 35) + "px").style("display","block")
                iconButtonTooltipForPieChart.html('<div  style="width: 100%; height:0%; padding-left:9px; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; ">'+ reloadButtonTooltipText +'</div>')
            })
            backButtonForPieChart.on('mouseout', function(d,i) {
                iconButtonTooltipForPieChart.style("display","none")
            })

            backButtonForPieChart.on('click', function() {
                isThreeDPieChartEnabled = false
                svgForHolding3DPieChart.remove();
                svgForHolding3DPieChartLegends.remove();
                backButtonForPieChart.remove();

                iconButtonTooltipForPieChart.style("display","none")

                ismenuButtonOfPieChartClicked = false
                optionsButtonPanelForPieChart.style("display","none")

            })
            
            var _data = d3.layout.pie().sort(null).value(function(d) {return d[options.keys.value];});

            
            var legendRectSize = 11;
            var legendSpacing = 5;

            legendFor3DPieChart = svgForHolding3DPieChartLegends.selectAll('.legend') .data(colorsForThreeDPieChart.domain()) .enter() .append('g') .attr('class', 'legend')
            .attr('transform', function(d, i) {
              
				var height = legendRectSize + legendSpacing;
				var offset =  height * colorsForThreeDPieChart.domain().length / 2;
				var horz = 2;
				var vert = (i * height) + ((targetElement[0][0].clientHeight * (parseFloat(svgForHolding3DPieChart[0][0].style.height) / 100)) - (height * options.data.length))/2 ;
				return 'translate(' + horz + ',' + vert + ')';
              
			})

            // Creating Legends
            var legendGroup = legendFor3DPieChart.append('rect') .attr('width', legendRectSize + 0) .attr('height', legendRectSize) .style('fill', colorsForThreeDPieChart) .style('stroke', color) .attr("rx", 5.0) .attr("ry", 5.0)
            .style('stroke', colorsForThreeDPieChart) .attr("rx", 10.0) .attr("ry", 10.0).style("cursor","auto")

            var legendText = legendFor3DPieChart.append('text').data(pie(options.data)) .attr('x', legendRectSize + legendSpacing + 1) .attr('y', legendRectSize - (legendSpacing - 4.8)) .style("font-family","Verdana,sans-serif")
            .style("font-size", "14px").style("fill","#00001c")
            .text(function(d,i) {
             if(d.data[options.keys.label].length > 10){
                
                    return d.data[options.keys.label].substring(0,10)+'...'; //+ ' '+ ": "+ d.data[options.keys.value] +"";
                }
                   else{
                    
                    return d.data[options.keys.label] //+" ( "+ d.data[options.keys.value] +" ) ";
                }
            })
            
            var legendTextValue = legendFor3DPieChart.append('text').data(pie(newJson)) .attr('x', legendRectSize + legendSpacing + 130) .attr('y', legendRectSize - (legendSpacing - 4.8)) .style("font-family","Verdana,sans-serif") .style("font-size", "12px")
            .style('fill','#00001c') .style({"font-weight":"Normal","dispaly":"none"}).attr("class","legend_value").style("display",options.legend)
            .text(function(d,i) { 
                 
                if(d.data[options.keys.value].toString().indexOf('.') === -1)
                {
                    return d.data[options.keys.value].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
                else{
                        
                    return d.data[options.keys.value];
                }
            })

        }) // threeDViewButtonForPieChart.on('click', function()
        
        var threeDPieChart;
        var threeDPieChartPath;
        function threeDPieChartCallFunction (id, data, x /*center x*/, y/*center y*/, rx/*radius x*/, ry/*radius y*/, h/*height*/, ir/*inner radius*/) {
            
            var _data = d3.layout.pie().sort(null).value(function(d) {return d[options.keys.value];})(data);

            var slices = d3.select("#"+id).append("g").style("border","solid 1px white").attr("transform", "translate(" + x + "," + y + ")")
            .attr("class", "slices");
            
            threeDPieChart = slices;

            slices.selectAll(".innerSlice").data(_data).enter().append("path").attr("class", "innerSlice")
            //.style("fill", function(d) { return d3.hsl(d.data.color).darker(0.7); }) // original lines
            .style("fill", function(d,i) { return d3.hsl(colorsForThreeDPieChart(i)).darker(0.7); })
            .attr("d",function(d){ return pieInner(d, rx+0.5,ry+0.5, h, ir);}) .each(function(d){this._current=d;});
        
            slices.selectAll(".topSlice").data(_data).enter().append("path").attr("class", "topSlice")
            .style('fill', function(d, i) { return colorsForThreeDPieChart(i); })
            .style("fill-opacity",0.95) .style("stroke", function(d,i) { return colorsForThreeDPieChart(i); })
            .attr("stroke-width",0.5) .attr("d",function(d){ return pieTop(d, rx, ry, ir);}) .each(function(d){this._current=d;});
        
            slices.selectAll(".outerSlice").data(_data).enter().append("path").attr("class", "outerSlice")
            .style("fill", function(d,i) { return d3.hsl(colorsForThreeDPieChart(i)).darker(0.7); })
            .style("fill-opacity",1.0) .attr("d",function(d){ return pieOuter(d, rx-.5,ry-.5, h);}) .each(function(d){this._current=d;});

            slices.selectAll(".percent").data(_data).enter().append("text").attr("class", "percent")
            .attr("x",function(d){ return 0.75*rx*Math.cos(0.5*(d.startAngle+d.endAngle));})
            .attr("y",function(d){ return 0.75*ry*Math.sin(0.5*(d.startAngle+d.endAngle));})
            //.text(getPercent).each(function(d){this._current=d;})
            .text(getPercent).each(function(d){this._current=d;}) .style("fill","#ffffff").style("font-weight","Bold")
            .style("font-family","Verdana,sans-serif") .style("text-anchor","middle") .style("font-size","12px")
            
        } // function threeDPieChartCallFunction() ends here.

        $(function() {
            $('#' + targetElement[0][0].id).bind('resize', function(){
                
                if(isThreeDPieChartEnabled == true){

                    backButtonForPieChart.transition().duration(20).style('top', parseFloat(chartTitlePanelForPieChart.style("height")) + (2) + 'px')

                    var newWidth = (targetElement[0][0].clientWidth * (parseFloat(svgForHolding3DPieChart[0][0].style.width) / 100))/2
                    var newHeight = (targetElement[0][0].clientHeight * (parseFloat(svgForHolding3DPieChart[0][0].style.height) / 100))/2
                    
                    var newThreeDPieChartRadius_rx = Math.min(newWidth * 2, newHeight * 2) / 2.2
                    var newThreeDPieChartRadius_ry = Math.min(newWidth * 2, newHeight * 2) / 4.7
                
                    threeDPieChart.transition().duration(0).attr("transform", "translate(" + (newWidth) + "," + (newHeight) + ")")

                    var _data = d3.layout.pie().sort(null).value(function(d) {return d[options.keys.value];})(options.data);

                    threeDPieChart.selectAll(".innerSlice").data(_data)/*.attr("class", "innerSlice")*/.transition().duration(0)
                    .attr("d",function(d){ return pieInner(d, newThreeDPieChartRadius_rx+0.5,newThreeDPieChartRadius_ry+0.5,25, 0.00);})

                    threeDPieChart.selectAll(".topSlice").data(_data)/*.attr("class", "topSlice")*/.transition().duration(0)
                    .attr("d",function(d){ return pieTop(d, newThreeDPieChartRadius_rx, newThreeDPieChartRadius_ry, 0.00);})

                    threeDPieChart.selectAll(".outerSlice").data(_data)/*.attr("class", "outerSlice")*/.transition().duration(0)
                    .attr("d",function(d){ return pieOuter(d, newThreeDPieChartRadius_rx-.5,newThreeDPieChartRadius_ry-.5, 25);}) 

                    threeDPieChart.selectAll(".percent").data(_data)/*.attr("class", "percent")*/.transition().duration(0)
                    .attr("x",function(d){ return 0.75*newThreeDPieChartRadius_rx*Math.cos(0.5*(d.startAngle+d.endAngle));})
                    .attr("y",function(d){ return 0.75*newThreeDPieChartRadius_ry*Math.sin(0.5*(d.startAngle+d.endAngle));})

                    // Aligning Legend (vertically)
                    var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(svgForHolding3DPieChartLegends[0][0].style.width) / 100)
                    var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(svgForHolding3DPieChartLegends[0][0].style.height) / 100)

                    var legendRectSize = 11;
                    var legendSpacing = 5;
            
                    legendFor3DPieChart.transition().duration(50).attr('transform', function(d, i) {
                        var height = legendRectSize + legendSpacing;
                        var offset =  height * colorsForThreeDPieChart.domain().length / 2;
                        var horz = 2;
                        var vert = (i * height) + (legendPanelHeight - (height * options.data.length))/2 ;
                        return 'translate(' + horz + ',' + vert + ')';
                    })

                } //if(isThreeDPieChartEnabled == true) condition ends here.

            });

        })

        function pieTop(d, rx, ry, ir ){
        
            if(d.endAngle - d.startAngle == 0 ) return "M 0 0";
            var sx = rx*Math.cos(d.startAngle),
                sy = ry*Math.sin(d.startAngle),
                ex = rx*Math.cos(d.endAngle),
                ey = ry*Math.sin(d.endAngle);
            
            var ret =[];
            ret.push("M",sx,sy,"A",rx,ry,"0",(d.endAngle-d.startAngle > Math.PI? 1: 0),"1",ex,ey,"L",ir*ex,ir*ey);
            ret.push("A",ir*rx,ir*ry,"0",(d.endAngle-d.startAngle > Math.PI? 1: 0), "0",ir*sx,ir*sy,"z");
            return ret.join(" ");
        }

        function pieOuter(d, rx, ry, h ){
            var startAngle = (d.startAngle > Math.PI ? Math.PI : d.startAngle);
            var endAngle = (d.endAngle > Math.PI ? Math.PI : d.endAngle);
        
            var sx = rx*Math.cos(startAngle),
            sy = ry*Math.sin(startAngle),
            ex = rx*Math.cos(endAngle),
            ey = ry*Math.sin(endAngle);
            
            var ret =[];
            ret.push("M",sx,h+sy,"A",rx,ry,"0 0 1",ex,h+ey,"L",ex,ey,"A",rx,ry,"0 0 0",sx,sy,"z");
            return ret.join(" ");
        }

        function pieInner(d, rx, ry, h, ir ){
            var startAngle = (d.startAngle < Math.PI ? Math.PI : d.startAngle);
            var endAngle = (d.endAngle < Math.PI ? Math.PI : d.endAngle);
        
            var sx = ir*rx*Math.cos(startAngle),
            sy = ir*ry*Math.sin(startAngle),
            ex = ir*rx*Math.cos(endAngle),
            ey = ir*ry*Math.sin(endAngle);

            var ret =[];
            ret.push("M",sx, sy,"A",ir*rx,ir*ry,"0 0 1",ex,ey, "L",ex,h+ey,"A",ir*rx, ir*ry,"0 0 0",sx,h+sy,"z");
            return ret.join(" ");
        }

        function getPercent(d){
        
           return (d.endAngle-d.startAngle > 0.2 ? 
                Math.round(1000*(d.endAngle-d.startAngle)/(Math.PI*2))/10+'%' : '');
           
        }
        
        // Creating ToolTip for options button.
        var iconButtonTooltipForPieChart = targetElement.append('div').style('width','240px').attr("id","too") .style('height',"25px").style('position','absolute')
        .style("background-color",'#404040 ').style("z-index",999).style("border", "0.0px") .style("border-color", "#f80000") .style("border-style", "solid") // 004b9d
        .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none").attr("border", 0.0)

        bubbleButtonForPieChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var bubbleChartButtonTooltipText = "Switch to Bubble Chart";
            
            iconButtonTooltipForPieChart.style("width","142px").style("margin-left", (m[0] - 152) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForPieChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ bubbleChartButtonTooltipText +'</div>')

        })
        bubbleButtonForPieChart.on('mouseout', function(d,i) {
            iconButtonTooltipForPieChart.style("display","none")
        })
        
        colButtonForPieChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var columnChartButtonTooltipText = "Switch to Column Chart";
            
            iconButtonTooltipForPieChart.style("width","147px").style("margin-left", (m[0] - 157) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForPieChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ columnChartButtonTooltipText +'</div>')

        })
        colButtonForPieChart.on('mouseout', function(d,i) {
            iconButtonTooltipForPieChart.style("display","none")
        })

        donutButtonForPieChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var doNutChartButtonTooltipText = "Switch to Donut Chart";
            
            iconButtonTooltipForPieChart.style("width","137px").style("margin-left", (m[0] - 147) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForPieChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ doNutChartButtonTooltipText +'</div>')
        })
        donutButtonForPieChart.on('mouseout', function(d,i) {
            iconButtonTooltipForPieChart.style("display","none")
        })

        horButtonForPieChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var horizontalChartButtonTooltipText = "Switch to Horizontal Chart";
            
            iconButtonTooltipForPieChart.style("width","158px").style("margin-left", (m[0] - 168) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForPieChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ horizontalChartButtonTooltipText +'</div>')
        })
        horButtonForPieChart.on('mouseout', function(d,i) {
            iconButtonTooltipForPieChart.style("display","none")
        })

        refreshButtonForPieChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var refreshButtonTooltipText = "Refresh";
            
            iconButtonTooltipForPieChart.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForPieChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ refreshButtonTooltipText +'</div>')
        })
        refreshButtonForPieChart.on('mouseout', function(d,i) {
            iconButtonTooltipForPieChart.style("display","none")
        })

        filterButtonForPieChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var filterButtonTooltipText = "Filter";
            
            iconButtonTooltipForPieChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForPieChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center; ">'+ filterButtonTooltipText +'</div>')
        })
        filterButtonForPieChart.on('mouseout', function(d,i) {
            iconButtonTooltipForPieChart.style("display","none")
        })

        menuButtonForPieChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var filterButtonTooltipText = "Menu";
            
            iconButtonTooltipForPieChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForPieChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')
        })
        menuButtonForPieChart.on('mouseout', function(d,i) {
            iconButtonTooltipForPieChart.style("display","none")
        })

       searchChartButton.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var reloadButtonTooltipText = "Search";
            
            iconButtonTooltipForPieChart.style("width","60px").style("margin-left", (m[0] - 70) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForPieChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ reloadButtonTooltipText +'</div>')
        })
        searchChartButton.on('mouseout', function(d,i) {
            iconButtonTooltipForPieChart.style("display","none")
        })

        settingBtnForPieChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var reloadButtonTooltipText = "Settings";
            
            iconButtonTooltipForPieChart.style("width","67px").style("margin-left", (m[0] - 77) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForPieChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ reloadButtonTooltipText +'</div>')
        })
        settingBtnForPieChart.on('mouseout', function(d,i) {
            iconButtonTooltipForPieChart.style("display","none")
        })
        
        downloadBtnForPieChart.on('mousemove', function(d,i) {
              var root = targetElement
              var m = d3.mouse(root.node());
              m[0] += 0
              m[1] += 0
              var downloadButtonTooltipText = "Download";
              
              iconButtonTooltipForPieChart.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
              iconButtonTooltipForPieChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
        })
        downloadBtnForPieChart.on('mouseout', function(d,i) {
              iconButtonTooltipForPieChart.style("display","none")
        })
        
        threeDViewButtonForPieChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var reloadButtonTooltipText = "3D View";
            
            iconButtonTooltipForPieChart.style("width","67px").style("margin-left", (m[0] - 77) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForPieChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ reloadButtonTooltipText +'</div>')
        })
        threeDViewButtonForPieChart.on('mouseout', function(d,i) {
            iconButtonTooltipForPieChart.style("display","none")
        })

         tableButtonForPieChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                if(showOrHideTableForPieChart == false){
                    var tableButtonTooltipText = "Show Table";
                }
                else if(showOrHideTableForPieChart == true){
                    var tableButtonTooltipText = "Hide Table";
                }
            
            iconButtonTooltipForPieChart.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForPieChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ tableButtonTooltipText +'</div>')
        })
        tableButtonForPieChart.on('mouseout', function(d,i) {
            iconButtonTooltipForPieChart.style("display","none")
        })

        commentsBtnForPieChart.on('mousemove', function(d,i) {
            commentsPanelDivForPieChart.style('background-color','#fafafa')
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                if(options.showComments == false){
                    var commentButtonTooltipText = "Show Comments";
                }
                else if(options.showComments == true){
                    var commentButtonTooltipText = "Hide Comments";
                }
            
            
            iconButtonTooltipForPieChart.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForPieChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ commentButtonTooltipText +'</div>')
        })
        commentsBtnForPieChart.on('mouseout', function(d,i) {
            commentsPanelDivForPieChart.style('background-color','#ffffff')
            iconButtonTooltipForPieChart.style("display","none")
        })

        /*---------- Option Buttons MouseOver section ends here ----------*/

        // Below Fuction is called when Filter button is clicked.
        function resetTableWidthOldDataFunction(){
            
            textBoxOneForPieChart.attr("value",d3.min(minAndMaxValuesArrayForPieChart))
            textBoxTwoForPieChart.attr("value",d3.max(minAndMaxValuesArrayForPieChart))

            var table = tablePanelForPieChart.select('table');
            var rows = table.selectAll('tr')
            //rows.remove();

            pathForPieChart.transition() .attr("d", arc) .attr("stroke","none");

            thead.select('svg').select('#descendingIconIDForPieChart').style("visibility", "visible")
            thead.select('svg').select('#ascendingIconIDForPieChart').style("visibility", "visible")
            
            var table = tablePanelForPieChart.select('table');
            var rows = table.selectAll('tr')
            tablePanelForPieChart.select('table').selectAll('tr').style("background-color","#FFFFFF").style("color","#00001c")

            var table = tablePanelForPieChart.select('table');
            var rows = table.selectAll('tr').data(newJson);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition()
            .delay(20) .duration(20) .style('opacity', 1.0) .style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(20) .duration(20) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(20)
            .duration(20) .style('opacity', 1.0) .style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(20) .duration(20) .style('opacity', 0.0) .remove();

            tablePanelForPieChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
            .style("color","#00001c")
            .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4")
            tablePanelForPieChart.selectAll('td').style("height","25px") .style("border", "1px solid #dddddd") .style("font-size","12px").style("font-weight","Normal")

            //additionally 
            tablePanelForPieChart.selectAll('th').style('background-color',"#ffffff").style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
            tablePanelForPieChart.selectAll('td').style('background-color',"#ffffff").style("border-style","none").style("color","#00001c")
        
            tablePanelForPieChart.selectAll('table') . style("border-collapse","collapse")
            tablePanelForPieChart.selectAll('table tr:first-child th').style("border-top","0px")
            tablePanelForPieChart.selectAll('table tr:last-child td').style("border-bottom","0px")
            tablePanelForPieChart.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
            tablePanelForPieChart.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")

        } // function resetTableWithOldDataFunction() ends here.

        // SVG for holding Pie Slices
        var svgForPieChart = svgPanelForPieChart .append('svg') .style('background-color',options.BGcolor) .attr("class","svgForPieChartNewClass")
        .append('g') .attr('transform', 'translate(' + (width1/3) + ',' + (height1/3) + ')');
        
        svgForPieChart.append("g") .attr("class", "slices");
        svgForPieChart.append("g") .attr("class", "labels");
        svgForPieChart.append("g") .attr("class", "lines");
		
		
		// Creating the Gradient effect for Pie-Chart
        var radialGradient = svgForPieChart.append("defs") .append("radialGradient") .attr("id", "radial-gradient" + targetElement[0][0].id);
        
        svgForPieChart.append("circle") .attr("cx", 00) .attr("cy", 0) .attr("r", 0) .transition().delay(function(d, i) { return i * 100; })
        .duration(1200) .attr("r", radiusForPieChart/1.25) .ease("bounce") .attr("fill","url(#radial-gradient" + targetElement[0][0].id + ")").attr("class","series_value").style("display",options.series);
        
		
        var arc = d3.svg.arc() .outerRadius(radiusForPieChart * 0.8) .innerRadius(0);
        
        var outerArc = d3.svg.arc() .innerRadius(radiusForPieChart * 0.9) .outerRadius(radiusForPieChart * 0.9);
        
        //var key = function(d){ return d.data.label; };
        
        var pie = d3.layout.pie() .value(function(d) { return d[options.keys.value]; }) .sort(null);
        
        options.data.forEach(function(d, i) {
                             d[options.keys.value] = d[options.keys.value];
                             d.enabled = true;
                            });
		
		// Creating Pie Paths (slices, arcs)
        var pathForPieChart = svgForPieChart.selectAll('path').data(pie(options.data)).enter().append('path')
		.attr('fill', function(d, i) {  return color(d.data[options.keys.label]); }).style("fill-opacity", 0.1).style('stroke', 'white').style('stroke-width', 2)
		
		.each(function(d) { this._current = d; });
        
        pathForPieChart.transition() .delay(function(d, i) { return i * 100; }) .duration(400)
        
        .attrTween('d', function(d) {   var i = d3.interpolate(d.startAngle+0.1, d.endAngle);
                   return function(t) {     
                        d.endAngle = i(t);
                        return arc(d);
                        }
                   });
		
		// Checking Gradient effect name received from .html file
        if(options.gradient === undefined){
			radialGradient.selectAll("stop").remove();
			pathForPieChart.style("fill-opacity", 1)
        }
        else if(options.gradient.toString().toLowerCase() === "none"){
			radialGradient.selectAll("stop").remove();
			pathForPieChart.style("fill-opacity", 1)
        }
        else if(options.gradient.toString().toLowerCase() === "smooth"){
			radialGradient.append("stop").attr("offset", "80%").style("stop-color", function(d, i) { return "#f0f0f0"; });
            radialGradient.append("stop").attr("offset", "85%").style("stop-color", "#fbfbfb");
            radialGradient.append("stop").attr("offset", "95%").style("stop-color", function(d, i) { return "#313131"; });
			pathForPieChart.style("fill-opacity", 0.8)
        }
        else if(options.gradient.toString().toLowerCase() === "elliptical"){
			radialGradient.append("stop").attr("offset", "25%").style("stop-color", function(d, i) { return "#f5f5f5"; });
            radialGradient.append("stop").attr("offset", "70%").style("stop-color", "#f0f0f0");
            radialGradient.append("stop").attr("offset", "95%").style("stop-color", function(d, i) { return "#313131"; });
			pathForPieChart.style("fill-opacity", 0.8)
        }
        else if(options.gradient.toString().toLowerCase() === "circular"){
			radialGradient.append("stop").attr("offset", "30%").style("stop-color", function(d, i) { return "#f8f8f8"; });
            radialGradient.append("stop").attr("offset", "97%").style("stop-color", "#2b2b2b");
            radialGradient.append("stop").attr("offset", "100%").style("stop-color", function(d, i) { return "#000000"; });
			pathForPieChart.style("fill-opacity", 0.8)
        }
        else if(options.gradient.toString().toLowerCase() === "radial"){
			radialGradient.append("stop").attr("offset", "30%").style("stop-color", function(d, i) { return "#000000"; });
            radialGradient.append("stop").attr("offset", "80%").style("stop-color", "#f0f0f0");
            radialGradient.append("stop").attr("offset", "95%").style("stop-color", function(d, i) { return "#313131"; });
			pathForPieChart.style("fill-opacity", 0.8)
        }
        else {
			radialGradient.selectAll("stop").remove();
			pathForPieChart.style("fill-opacity", 1)
        }
		
		
        pathForPieChart.on('mouseover', function(d,i) {
            var format = d3.format(".2s")
            var toolTipLabel = options.keys.label.toUpperCase(); //.charAt(0).substr(3)
            var toolTipValue = options.keys.value.toUpperCase()
            var valueForPieChartToolTip;
            if(d.data[options.keys.value].toString().indexOf('.') === -1)
            {
                valueForPieChartToolTip = d.data[options.keys.value].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            else{
                        
                valueForPieChartToolTip = d.data[options.keys.value];
            }

            tooltipPieForPieChart.select('.label').html(options.keys.label + " : " + d.data[options.keys.label]);
            tooltipPieForPieChart.select('.count').html(options.keys.value + " : " + valueForPieChartToolTip )
            tooltipPieForPieChart.style('visibility', 'visible');
            tooltipPieForPieChart.select('hr').attr('class', 'dotColor').style("background-color", d3.select(this).style("fill"))
                
            this._current = this._current || d;
                
        });
        
        pathForPieChart.on('mouseout', function(d,i) {  tooltipPieForPieChart.style('visibility', 'hidden')  });
        
        var arcOver = d3.svg.arc() .outerRadius((radiusForPieChart * 0.9) + 0.05);
        
        pathForPieChart.on("mouseenter", function(d,i) {   d3.select(this) .transition() .ease("elastic") .duration(100) .attr("d", arcOver) .attr("stroke-width",0.5);  });
        
        pathForPieChart.on("mouseleave", function(d) {   d3.select(this).transition() .attr("d", arc) .attr("stroke-width",1);   });
        
        var newArrForDrillDownPie = [];
        var columnNames = d3.keys(newJson[0])
        var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
        
        for(var i = 0; i < columnNames.length ; i++){
            for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                    for(var k = 0; k < pathForPieChart[0].length; k++){
                        d3.select(pathForPieChart[0][k]).attr('data-drilldownkey', function(d,index){
                          var arr = JSON.stringify(newJson[k]).slice(1, -1).split('"'), arr1 = d3.select(arr)[0]
                          
                          for(var j = 0; j < arr1[0].length; j++){
                              if(arr1[0][j].toString() == ":"){
                                  var ch = arr1[0][j].toString().replace(":","|")
                                    newArrForDrillDownPie.push(ch)
                              }
                              else {
                                    newArrForDrillDownPie.push(arr1[0][j])
                              }
                          }
                          
                              //return JSON.stringify(newJson[k]).slice(1, -1).split('"').join("").split(':').join("|")
                              return newArrForDrillDownPie.join("");
                          })
                        newArrForDrillDownPie = []
                    }
                    
                }
                else {
                }
            }
        }
        
        //---------- Creating Legends section begins here ----------
        var legendPanelFront =  targetElement.append('div') .style('background-color',options.BGcolor) .attr("class","") //.attr("id","xyz")  //f2fbf1
        
        // Checking the Chart Title and Chart Legend choosen (true or false) when Library Called.
        if(options.showLegend == true && options.showTitle == true){                                ``
            
            if(options.legendSide === "left"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 70 + "%") .style("left",35 + "%").style('background-color',options.BGcolor)
                    svgPanelForPieChart.style("position","absolute");
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%") .style("left",35 + "%").style('background-color',options.BGcolor)
                    svgPanelForPieChart.style("position","absolute");
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 85 + "%") .style("left",35 + "%")
                    svgPanelForPieChart.style("position","absolute").style('background-color',options.BGcolor);
                }

            }
            else if(options.legendSide === "right"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 70 + "%") .style("left",0 + "%").style('background-color',options.BGcolor)
                    svgPanelForPieChart.style("position","absolute");
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%") .style("left",0 + "%").style('background-color',options.BGcolor)
                    svgPanelForPieChart.style("position","absolute");
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 85 + "%") .style("left",0 + "%").style('background-color',options.BGcolor)
                    svgPanelForPieChart.style("position","absolute");
                }

            }
            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 70 + "%") .style("left",0 + "%").style('background-color',options.BGcolor)
                    svgPanelForPieChart.style("position","absolute");
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 52 + "%") .style("left",0 + "%").style('background-color',options.BGcolor)
                    svgPanelForPieChart.style("position","absolute");
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);
                    
                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 85 + "%") .style("left",0 + "%").style('background-color',options.BGcolor)
                    svgPanelForPieChart.style("position","absolute");
                }
                //alert("Legend side not selected.");
            }
        }
        else if(options.showLegend == true && options.showTitle == false){
           
            if(options.legendSide === "left"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 70 + "%") .style("left",35 + "%").style('background-color',options.BGcolor)
                    svgPanelForPieChart.style("position","absolute");
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 60  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",0.0  + "%").style('background-color',options.BGcolor);

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 60 + "%") .style("left",35 + "%").style('background-color',options.BGcolor)
                    svgPanelForPieChart.style("position","absolute") ;
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 85 + "%") .style("left",35 + "%").style('background-color',options.BGcolor)
                    svgPanelForPieChart.style("position","absolute");
                }

            }
            else if(options.legendSide === "right"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 70 + "%") .style("left",0 + "%").style('background-color',options.BGcolor)
                    svgPanelForPieChart.style("position","absolute");
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 60  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",0.0  + "%").style('background-color',options.BGcolor);

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 60 + "%") .style("left",0 + "%").style('background-color',options.BGcolor)
                    svgPanelForPieChart.style("position","absolute");
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 85 + "%") .style("left",0 + "%").style('background-color',options.BGcolor)
                    svgPanelForPieChart.style("position","absolute");
                }
            }
            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                
                if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 70 + "%") .style("left",0 + "%").style('background-color',options.BGcolor)
                    svgPanelForPieChart.style("position","absolute");
                }
                else if ((showOrHideTableForPieChart == true) && (showOrHideCommentsForPieChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 60  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",0.0  + "%").style('background-color',options.BGcolor);

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 60 + "%") .style("left",0 + "%").style('background-color',options.BGcolor)
                    svgPanelForPieChart.style("position","absolute");
                }
                else if ((showOrHideTableForPieChart == false) && (showOrHideCommentsForPieChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);

                    svgPanelForPieChart.style('width', 65 + "%") .style('height', 85 + "%") .style("left",0 + "%").style('background-color',options.BGcolor)
                    svgPanelForPieChart.style("position","absolute");
                }
                
                //alert("Legend side not selected.");
            }
            
        }
        else if(options.showLegend == false){
            legendPanelFront.style("width", function(d) { return 0.0 + "%"; }) .style("height", function(d) { return 0.0  + "%"; })
            .style("position","absolute") .style("left",0 + "%") .style("top",0.0  + "%").style('background-color',options.BGcolor);
        }
        
        var legendPanelFrontSvg =  legendPanelFront.append('svg') .style('background-color',options.BGcolor).style("width", function(d) { return 100.0 + "%"; }) .style("height", function(d) { return 100  + "%"; }).style("position","absolute") .style("left",0 + "%") .style("top",0  + "%");
        
        var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(legendPanelFront[0][0].style.width) / 100)
        var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(legendPanelFront[0][0].style.height) / 100)

        var legendRectSize = 11;
        var legendSpacing = 5;
        
        // Legend alignment (vertically)
        var legend = legendPanelFrontSvg.selectAll('.legend').data(color.domain()) .enter() .append('g') .attr('class', 'legend').style('background-color',options.BGcolor)
        .attr('transform', function(d, i) {
              
			var height = legendRectSize + legendSpacing;
			var offset =  height * color.domain().length / 2;
			var horz = 2;
			var vert = (i * height) + (legendPanelHeight - (height * options.data.length))/2 ;
			return 'translate(' + horz + ',' + vert + ')';
              
		})
        
        // Creating Legends
        var legendGroup = legend.append('rect') .attr('width', legendRectSize ) .attr('height', legendRectSize) .style('fill', color) .style('stroke', color) .attr("rx", 5.0) .attr("ry", 5.0)
        .style('stroke', color) .attr("rx", 5.0) .attr("ry", 5.0) //.attr("rx", 5.0) .attr("ry", 5.0)
        .on('click', function(label) {
            
            var circles = svgForPieChart.selectAll('path')
            var circleAttributes = circles .attr('transform', 'translate(0,0)');
            
            var rect = d3.select(this);
            var enabled = true;
            var totalEnabled = d3.sum(options.data.map(function(d) {
                                                       return (d.enabled) ? 1 : 0;
                                                       }));
            
            if (rect.attr('class') === 'disabled') {  rect.attr('class', '');  }
            else {
            if (totalEnabled < 2) return;
                rect.attr('class', 'disabled');
                enabled = false;
            }
            
            pie.value(function(d) {
                      if (d[options.keys.label] === label) d.enabled = enabled;
                      return (d.enabled) ? d[options.keys.value] : 0;
                    });
            
            pathForPieChart = pathForPieChart.data(pie(options.data));
            
            pathForPieChart.transition().duration(450)
            .attrTween('d', function(d,i) {
                       if(d.value == 0){    d3.select(this).style("visibility", "hidden");  }
                       else {   d3.select(this).style("visibility", "visible");   }
                       var interpolate = d3.interpolate(this._current, d);
                       this._current = interpolate(0);
                       return function(t) { return arc(interpolate(t)); };
                    });
            
            function midAngle(d){  return d.startAngle + (d.endAngle - d.startAngle)/2;  }
            
            clicked()
            
        }); //legend.on('click", function(label)) function ends here.
        
        // Calling the clicked function when Pie-Chart is called every time.
        clicked()
        
        function midAngle(d){ return d.startAngle + (d.endAngle - d.startAngle)/2;  }
        
        var text;
        var polyline;
            
            // Moving the Pie Slices ToolTip
            pathForPieChart.on("mousemove",function(d,i) {
                
                var widthPanel = chartTitlePanelForPieChart[0][0].clientWidth
                var heightPanel = chartTitlePanelForPieChart[0][0].clientHeight
                
                var width11 = tooltipPieForPieChart[0][0].clientWidth
                var height11 = tooltipPieForPieChart[0][0].clientHeight
                
                var width111 = chartTitlePanelForPieChart[0][0].clientWidth
                var height111 = chartTitlePanelForPieChart[0][0].clientHeight
                
                var width1111 = targetElement[0][0].clientWidth * (parseFloat(legendPanelFront[0][0].style.width) / 100) 
                var height1111 = targetElement[0][0].clientHeight * (parseFloat(legendPanelFront[0][0].style.height) / 100)
                
                var newWidth11 = tooltipPieForPieChart[0][0].clientWidth
                var newHeight11 = tooltipPieForPieChart[0][0].clientHeight
                
                var root = targetElement
                var m = d3.mouse(root.node());
                
                m[0] += 0
                m[1] += 0
                
                if(isResizedFunctionCalled == false){
                
                  if(height1<=350){
                
                    if(m[1]< (height1/2) + heightPanel)
                    {
                        
                        if(options.showTitle == true){
                            if(options.legendSide === "right"){
                                tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + width1/2) - width11/2 )  + "px").style("top",(d3.mouse(this)[1] + (height111+height1/2) + 20) + "px")
                            }
                            else if(options.legendSide === "left"){
                                tooltipPieForPieChart.style("left", ( ((d3.mouse(this)[0] + width1/2) - width11/2 )) + width1111  + "px").style("top",(d3.mouse(this)[1] + (height111+height1/2) + 20) + "px")
                            }
                            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                                tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + width1/2) - width11/2 )  + "px").style("top",(d3.mouse(this)[1] + (height111+height1/2) + 20) + "px")
                            }
                        }
                        else if(options.showTitle == false){
                
                            if(options.legendSide === "right"){
                                tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + width1/2) - width11/2 )  + "px").style("top",(d3.mouse(this)[1] + (height111+height1/2) + 20) + "px")
                            }
                            else if(options.legendSide === "left"){
                                tooltipPieForPieChart.style("left", ( ((d3.mouse(this)[0] + width1/2) - width11/2 )) + width1111  + "px").style("top",(d3.mouse(this)[1] + (height111+height1/2) + 20) + "px")
                            }
                            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                                tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + width1/2) - width11/2 )  + "px").style("top",(d3.mouse(this)[1] + (height111+height1/2) + 20) + "px")
                            }
                        }
                
                    }//if(m[1]<(height1/2) + heightPanel)
                
                    else if(m[1]> (height1/2) + heightPanel){
                        
                        if(options.showTitle == true){
                
                            if(options.legendSide === "right"){
                                tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + width1/2) - width11/2  )  + "px").style("top",( d3.mouse(this)[1] + (height111+height1/2) - (height11 + 10) ) + "px")
                            }
                            else if(options.legendSide === "left"){
                                tooltipPieForPieChart.style("left", ( ((d3.mouse(this)[0] + width1/2) - width11/2 )) + width1111  + "px").style("top",( d3.mouse(this)[1] + (height111+height1/2) - (height11 + 10) ) + "px")
                            }
                            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                                tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + width1/2) - width11/2  )  + "px").style("top",( d3.mouse(this)[1] + (height111+height1/2) - (height11 + 10) ) + "px")
                            }
                        }
                        else if(options.showTitle == false){
                
                
                            if(options.legendSide === "right"){
                                tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + width1/2) - width11/2  )  + "px").style("top",( d3.mouse(this)[1] + (height111+height1/2) - (height11 + 10) ) + "px")
                            }
                            else if(options.legendSide === "left"){
                                tooltipPieForPieChart.style("left", ( ((d3.mouse(this)[0] + width1/2) - width11/2 )) + width1111  + "px").style("top",( d3.mouse(this)[1] + (height111+height1/2) - (height11 + 10) ) + "px")
                            }
                            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                               tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + width1/2) - width11/2  )  + "px").style("top",( d3.mouse(this)[1] + (height111+height1/2) - (height11 + 10) ) + "px") 
                            }
                
                        }
                    } // else if(m[1]> (height1/2) + heightPanel)
                
                  } // if(height1<350)
                  else if(height1>350){
                        
                        if(options.showTitle == true){
                
                            if(options.legendSide === "right"){
                                tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + width1/2) - width11/2  )  + "px").style("top",( d3.mouse(this)[1] + (height111+height1/2) - (height11 + 10) ) + "px")
                            }
                            else if(options.legendSide === "left"){
                                tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + width1/2) - width11/2 ) + width1111  + "px").style("top",( d3.mouse(this)[1] + (height111+height1/2) - (height11 + 10) ) + "px")
                            }
                            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                                tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + width1/2) - width11/2  )  + "px").style("top",( d3.mouse(this)[1] + (height111+height1/2) - (height11 + 10) ) + "px")
                            }
                        }
                        else if(options.showTitle == false){
                
                            if(options.legendSide === "right"){
                                tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + width1/2) - width11/2  )  + "px").style("top",( d3.mouse(this)[1] + (height111+height1/2) - (height11 + 10) ) + "px")
                            }
                            else if(options.legendSide === "left"){
                                tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + width1/2) - width11/2 ) + width1111  + "px").style("top",( d3.mouse(this)[1] + (height111+height1/2) - (height11 + 10) ) + "px")
                            }
                            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                                tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + width1/2) - width11/2  )  + "px").style("top",( d3.mouse(this)[1] + (height111+height1/2) - (height11 + 10) ) + "px")
                            }
                        }
                    } // if(height1>350)
                } // if(isResizedFunctionCalled == false)
                
                else if(isResizedFunctionCalled == true){
                
                    if(height1<=350){
                        if(m[1]< (height1/2) + newHeight111)
                        {
                            
                            if(options.showTitle == true){
                                
                                if(options.legendSide === "right"){
                                    tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2 )  + "px").style("top",(d3.mouse(this)[1] + (newHeight111+newHeight1/2) + 20) + "px")
                                }
                                else if(options.legendSide === "left"){
                                    tooltipPieForPieChart.style("left", ( ((d3.mouse(this)[0] + width1/2) - width11/2 )) + width1111  + "px").style("top",(d3.mouse(this)[1] + (height111+height1/2) + 20) + "px")
                                }
                                else if(options.legendSide !== "right" && options.legendSide !== "left"){
                                    tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2 )  + "px").style("top",(d3.mouse(this)[1] + (newHeight111+newHeight1/2) + 20) + "px")
                                }
                            }
                            else if(options.showTitle == false){
                
                                if(options.legendSide === "right"){
                                    tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2 )  + "px").style("top",(d3.mouse(this)[1] + (newHeight111+newHeight1/2) + 20) + "px")
                                }
                                else if(options.legendSide === "left"){
                                    tooltipPieForPieChart.style("left", ( ((d3.mouse(this)[0] + width1/2) - width11/2 )) + width1111  + "px").style("top",(d3.mouse(this)[1] + (height111+height1/2) + 20) + "px")
                                }
                                else if(options.legendSide !== "right" && options.legendSide !== "left"){
                                    tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2 )  + "px").style("top",(d3.mouse(this)[1] + (newHeight111+newHeight1/2) + 20) + "px")
                                }
                            }
                        } //if(m[1]< (height1/2) + newHeight111)
                
                        else if(m[1]> (height1/2) + newHeight111){
                            
                            if(options.showTitle == true){
                
                                if(options.legendSide === "right"){
                                    tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2  )  + "px").style("top",( d3.mouse(this)[1] + (newHeight111+newHeight1/2) - (newHeight11 + 10) ) + "px")
                                }
                                else if(options.legendSide === "left"){
                                    tooltipPieForPieChart.style("left", ( ((d3.mouse(this)[0] + width1/2) - width11/2 )) + width1111  + "px").style("top",( d3.mouse(this)[1] + (height111+height1/2) - (height11 + 10) ) + "px")
                                }
                                else if(options.legendSide !== "right" && options.legendSide !== "left"){
                                    tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2  )  + "px").style("top",( d3.mouse(this)[1] + (newHeight111+newHeight1/2) - (newHeight11 + 10) ) + "px")
                                }
                            }
                            else if(options.showTitle == false){
                
                                if(options.legendSide === "right"){
                                    tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2  )  + "px").style("top",( d3.mouse(this)[1] + (newHeight111+newHeight1/2) - (newHeight11 + 10) ) + "px")
                                }
                                else if(options.legendSide === "left"){
                                    tooltipPieForPieChart.style("left", ( ((d3.mouse(this)[0] + width1/2) - width11/2 )) + width1111  + "px").style("top",( d3.mouse(this)[1] + (height111+height1/2) - (height11 + 10) ) + "px")
                                }
                                else if(options.legendSide !== "right" && options.legendSide !== "left"){
                                    tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2  )  + "px").style("top",( d3.mouse(this)[1] + (newHeight111+newHeight1/2) - (newHeight11 + 10) ) + "px")
                                }
                            }
                        } //else if(m[1]> (height1/2) + newHeight111)
                    } // if(height<350)
                
                    else if(height1>350){
                        
                        if(options.showTitle == true){
                
                            if(options.legendSide === "right"){
                                tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2  )  + "px").style("top",( d3.mouse(this)[1] + (newHeight111+newHeight1/2) - (newHeight11 + 10) ) + "px")
                            }
                            else if(options.legendSide === "left"){
                                tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2 ) + newWidth1111  + "px").style("top",( d3.mouse(this)[1] + (newHeight111+newHeight1/2) - (newHeight11 + 10) ) + "px")
                            }
                            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                                tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2  )  + "px").style("top",( d3.mouse(this)[1] + (newHeight111+newHeight1/2) - (newHeight11 + 10) ) + "px")
                            }
                        }
                        else if(options.showTitle == false){
                
                            if(options.legendSide === "right"){
                                tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2  )  + "px").style("top",( d3.mouse(this)[1] + (newHeight111+newHeight1/2) - (newHeight11 + 10) ) + "px")
                            }
                            else if(options.legendSide === "left"){
                                tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2 ) + newWidth1111  + "px").style("top",( d3.mouse(this)[1] + (newHeight111+newHeight1/2) - (newHeight11 + 10) ) + "px")
                            }
                            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                                tooltipPieForPieChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2  )  + "px").style("top",( d3.mouse(this)[1] + (newHeight111+newHeight1/2) - (newHeight11 + 10) ) + "px")
                            }
                        }
                    } // else if(height1>350)
                
                } // else if(isResizedFunctionCalled == true){
                
            }); // pathForPieChart.on("mousemove",function(d,i) ends here.

        // This function helps in removing and re-adding Pie Slice when Legend Button is clicked.
        function clicked() {
            
            var format = d3.format(".2s")
            var total = 0;
            //var text = svgForPieChart.select(".labels").selectAll("text") .data(pie(options.data))
            text = svgForPieChart.selectAll("text") .data(pie(options.data))
            text.enter() .append("text") .attr("dy", ".35em") .style("font-family","Verdana,sans-serif") .style("font-size", "12px") 
            .attr("shape-rendering", "crispEdges") .style("font-weight","Normal") .style({"fill":"#00001c","display":"none"}).attr("class","series_value").style("display",options.series)
            
            text.text(function(d,i) {
                if(d.value == 0) { 
                    d3.select(this).style("visibility", "hidden");  
                }
                else {  
                    d3.select(this).style("visibility", "visible");
                    
                    if(d.data[options.keys.value].toString().indexOf('.') === -1)
                    {
                        return d.data[options.keys.value].toString();
                    }
                    else{
                        
                        return d.data[options.keys.value];
                    }
                }
            });
            
            
            text.transition().duration(1000)
            .attrTween("transform", function(d) {
                        this._current = this._current || d;
                           
                        var interpolate = d3.interpolate(this._current, d);
                        this._current = interpolate(0);
                        return function(t) {
                               var d2 = interpolate(t);
                               var pos = outerArc.centroid(d2);
                               return "translate("+ pos +")";
                              };
                        })
            .styleTween("text-anchor", function(d){
                        this._current = this._current || d;
                        var interpolate = d3.interpolate(this._current, d);
                        this._current = interpolate(0);
                        return function(t) {
                                var d2 = interpolate(t);
                                return midAngle(d2) < Math.PI ? "start":"end";
                                };
                        });
            
            polyline = svgForPieChart.select(".lines") .selectAll("polyline") .data(pie(options.data));
            polyline.enter().append("polyline") .style({"stroke-width": "1.0px","display":"none"}) .attr('stroke', function(d) {  return 'black' ;  })
            
            var sampleIDS=targetElement[0];
            var divWidth = document.getElementById(sampleIDS[0].id).clientWidth
            var divHeight = document.getElementById(sampleIDS[0].id).clientHeight
            if(divWidth <= 300 || divHeight <= 400){    polyline.style("display","none")   }
            else if(divWidth >300 || divHeight > 400){  polyline.style("display","none")  }
            
            polyline.transition().duration(1000)
            .attrTween("points", function(d){
                    this._current = this._current || d;
                       
                    var interpolate = d3.interpolate(this._current, d);
                       
                    this._current = interpolate(0);
                       
                    if(d.value == 0) {  d3.select(this).style("visibility", "hidden");  }
                    else {  d3.select(this).style("visibility", "visible");
                            return function(t) {
                                var c = arc.centroid(d),
                                x = c[0],
                                y = c[1],
                                // pythagorean theorem for hypotenuse
                                h = Math.sqrt(x*x + y*y);
                                var newArc = d3.svg.arc()
                                .innerRadius(radiusForPieChart - (radiusForPieChart/2))
                                .outerRadius(radiusForPieChart);
                                var d2 = interpolate(t);
                                var pos = outerArc.centroid(d2);
                                return [newArc.centroid(d2), outerArc.centroid(d2)];
                       
                            };
                    }
            });
            
        } // clicked function ends here.

        // Creating Legend Labels (Text after round button)
        var legendText = legend.append('text').data(pie(newJson)) .attr('x', legendRectSize + legendSpacing + 1) .attr('y', legendRectSize - (legendSpacing - 4.8)) .style("font-family","Verdana,sans-serif") .style("font-size", "14px")
        /*.text(function(d) { return d; })*/ .style('fill','#00001c') .style("font-weight","Normal")
        .text(function(d,i) {
             if(d.data[options.keys.label].length > 10){
                    return d.data[options.keys.label].substring(0,10)+'...';// + ' '+ " : "+ d.data[options.keys.value];
                }
                   else{
                    
                    return d.data[options.keys.label]; //+" : "+ d.data[options.keys.value];
                }
        })
        
        var legendTextValue = legend.append('text').data(pie(newJson)) .attr('x', legendRectSize + legendSpacing + 130) .attr('y', legendRectSize - (legendSpacing - 4.8)) .style("font-family","Verdana,sans-serif") .style("font-size", "12px")
        .style('fill','#00001c') .style({"font-weight":"Normal","display":"none"}).attr("class","legend_value").style("display",options.legend)
        .text(function(d,i) { 
            
            if(d.data[options.keys.value].toString().indexOf('.') === -1)
            {
                return d.data[options.keys.value].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            else{
                        
                return d.data[options.keys.value];
            }
        })
        
        if(options.showLegend==false){
            legendGroup.style("visibility", "hidden");
            legendText.style("visibility","hidden");
        }
        else if(options.showLegend==true){
            legendGroup.style("visibility", "visible");
            legendText.style("visibility","visible");
        }

        // DIV for holding Main Table
        var tablePanelForPieChart =  targetElement.append("div") .attr("id",targetElement[0][0].id + "holderForPieChartTableID")
        .attr("class","scrollingDivForTable-Class tableDivForPieChart" + targetElement[0][0].id) .style('background-color',"#ffffff") .style('position','absolute')
        .style("display","block") .style("overflow","auto") .style("width", function(d) {  return 100.0 + "%"; })
        .style("height", function(d) { return 40 + "%"; }) .style("left",0 + "%")

        // Disabling Browser page scrolling when user starts scrolling on Main Table.
        $( '.tableDivForPieChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        // Checking whether Chart Title and Chart Legend choosen (true or false) when library is called.
        if(options.showTitle == true && options.showLegend == true ){
           tablePanelForPieChart.style("top",60.0  + "%")
        }
        else if(options.showTitle == false && options.showLegend == true ){
            tablePanelForPieChart.style("top",60.0  + "%")
            
        }
        else if(options.showTitle == true && options.showLegend == false){
            tablePanelForPieChart.style("top",60  + "%")
        }
        else if(options.showTitle == false && options.showLegend == false){
            tablePanelForPieChart.style("top",60  + "%")
            
        }
        // Creating Main Table in Main Table DIV i.e. tablePanelForPieChart, using .html function
        tablePanelForPieChart.html('<table class = "tableClassForPieChart' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                   '<thead class = "theadClassForPieChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForPieChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                                   '<tbody class = "tBodyClassForPieChart' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                   '</table>'
                                   )

        tablePanelForPieChart.select('table').attr('id',targetElement[0][0].id + "tableID")

        // Show or Hide Table scroll bar when mouseover on widget.
        targetElement.on('mouseover',function(){ tablePanelForPieChart.style("overflow","auto") })
        targetElement.on('mouseout',function(d){ tablePanelForPieChart.style("overflow","hidden") })
        
        var tableDataForPieChart = [];
        if(options.dataForTable.length > 0){
            tableDataForPieChart = options.dataForTable;
        }
        else {
            tableDataForPieChart = newJson;
        }
        
        /*---------- Adding Table Headear, Row, Data, Sorting Buttons and Styling (CSS) for Main Table section begins here ----------*/
        var thead = tablePanelForPieChart.select("thead").selectAll("th") .data(d3.keys(tableDataForPieChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1) + " "}).style("cursor","pointer").style("min-width","100px").style("color","#00001c")
        
        var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") //.style("background-color","#DFF0D8")
        .style("position","relative")
        
        var thead1 = d3.select(".thead1ClassForPieChart" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tableDataForPieChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px").style("color","#00001c")
        
        var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") //.style("background-color","#DFF0D8")
        .style("position","relative")
        
        var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
            .attr("id", "ascendingIconIDForPieChart") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
        
        var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
            .attr("id", "descendingIconIDForPieChart") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
        
        
        var tr = tablePanelForPieChart.select("tbody").selectAll("tr") .data(tableDataForPieChart).enter().append("tr") .attr("id", function(d,i) { return "slice" + i })
        
        var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d})
        .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
        
        var $table = $('.tableClassForPieChart' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
        
        d3.select(".theadClassForPieChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                d.forEach(function(dd,j){
                            colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                })
        })
        
        $(".thead1ClassForPieChart" + targetElement[0][0].id).insertAfter('.tBodyClassForPieChart' + targetElement[0][0].id)
        
        $(".thead1ClassForPieChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForPieChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
        
        tablePanelForPieChart.select(".thead1ClassForPieChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
            d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
        })
        
        $('.tableDivForPieChart' + targetElement[0][0].id).scroll(function () {
                                                                 
            $(".thead1ClassForPieChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForPieChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
                                                                 
        })
        
        var selectedRowFromTableForPieChartArray = [];
        var filteredselectedRowFromTableForPieChartArray = [];
        
        // Sorting the Main Table Rows when Table Heading is clicked
        var sortOrder = false;
        thead1.on("click",function(k,index){
                 sortOrder = !sortOrder;
                 tablePanelForPieChart.select(".thead1ClassForPieChart" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                        if (sortOrder) {
                            if(i == index){
                                d3.select(this).select('svg').select('#descendingIconIDForPieChart').style("visibility", "hidden")
                                d3.select(this).select('svg').select('#ascendingIconIDForPieChart').style("visibility", "visible")
                            }
                            else {
                                d3.select(this).select('svg').select('#descendingIconIDForPieChart').style("visibility", "visible")
                                d3.select(this).select('svg').select('#ascendingIconIDForPieChart').style("visibility", "visible")
                            }
                        }
                        else{
                            if(i == index){
                                d3.select(this).select('svg').select('#descendingIconIDForPieChart').style("visibility", "visible")
                                d3.select(this).select('svg').select('#ascendingIconIDForPieChart').style("visibility", "hidden")
                            }
                            else {
                                d3.select(this).select('svg').select('#descendingIconIDForPieChart').style("visibility", "visible")
                                d3.select(this).select('svg').select('#ascendingIconIDForPieChart').style("visibility", "visible")
                            }
                        }
                  })
                 
                  var monthTruOrFalAryForPieChart = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
                  
                  tr.sort(function(a, b) {
                          
                          if (sortOrder) {
                                var monthsArrayForPieChart = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                          } else {
                                var monthsArrayForPieChart = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                          }
                          
                          monthTruOrFalAryForPieChart = []; gotMonthArray = [];
                          tableDataForPieChart.forEach(function(d,i){
                                                       
                                var da = d[k].toString().substring(0,3).toLowerCase()
                                    if(monthsArrayForPieChart.indexOf(da) >= 0){
                                        monthTruOrFalAryForPieChart.push(true)
                                        gotMonthArray.push(da);
                                    }
                                    else {
                                        monthTruOrFalAryForPieChart.push(false)
                                    }
                          })
                          
                          if(monthTruOrFalAryForPieChart.indexOf(false) == -1){ // true
                          
                          monthArray = []; monthArrayCount = [];
                          gotMonthArray.forEach(function(dd,j){
                                var index1 = monthsArrayForPieChart.indexOf(dd.substring(0,3))
                                    if(monthArrayCount.indexOf(index1) >= 0){
                                        index1 = 12 + index1;
                                    }
                                        monthArray.push(index1);
                                        monthArrayCount.push(index1)
                                    })
                          returnArray = []
                          monthArray.sort(function(aa, bb) {
                                    returnArray.push(+aa - +bb)
                                    return +aa - +bb;
                          })
                          
                          sortTableFunc()
                          return returnArray[ind++];
                          } //  if true (if jan feb if block)
                          else {
                                var data = +a[k];
                          
                                if(!isNaN(data)){
                          
                                    if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                                    else { return d3.descending(+a[k], +b[k]); }
                                }
                                else if(!isNaN(Date.parse(a[k]))){
                          
                                    if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                                    else { return new Date(b[k]) - new Date(a[k]) }
                                }
                                else {
                          
                                    if (sortOrder) { return d3.ascending(a[k], b[k]); }
                                    else { return d3.descending(a[k], b[k]); }
                                }
                          } // if not jan feb else block
                    }); // tr

        })
        
        function sortTableFunc(){

            var table = tablePanelForPieChart.select('table');
            var rows = table.selectAll('tr').data(tableDataForPieChart);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition()
            .delay(2900) .duration(500) .style('opacity', 1.0) .style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900)
            .duration(500) .style('opacity', 1.0) .style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();

        } // function sortTableFunc() ends here.
        
        if(options.dataForTable.length == 0){
            
            // Highlighting Main Table Row when Pie Slice is clicked.
            var selectedItem = "";
            pathForPieChart.on("click", function(d,i) {
               thead1.select('svg').select('#descendingIconIDForPieChart').style("visibility", "visible")
               thead1.select('svg').select('#ascendingIconIDForPieChart').style("visibility", "visible")
               sortTableFunc()
               selectedItem = i
               var val = d.value;
               var selectedSlice = i
               options.data.forEach(function(d,i) {
                    if(i == selectedItem){
                        tablePanelForPieChart.select("tbody").selectAll("tr")
                        .style("background-color", function(dTr, iTr) {
                           return i == iTr ? "#808080" : null;
                        })
                        .style("color", function(dTr, iTr) {
                           return i == iTr ? "#FFFFFF" : null;
                        })
                    
                    var row = $('#' + targetElement[0][0].id + "tableID").find('tr');
                    
                    if((row[0].clientHeight * selectedItem) > tablePanelForPieChart[0][0].clientHeight - 56 ){
                        // $("#" + targetElement[0][0].id + "holderForPieChartTableID").scrollTop( row[0].clientHeight * selectedItem );
                        $("#" + targetElement[0][0].id + "holderForPieChartTableID").animate({
                             scrollTop: row[0].clientHeight * selectedItem }, 350);
                        }
                        else{
                            $("#" + targetElement[0][0].id + "holderForPieChartTableID").animate({
                                 scrollTop: 0 }, 350);
                        }
                    } //if(i == selectedItem)
                });
               
           })
        }
        
        // Main Table Styling
        tablePanelForPieChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
        .style("color","#00001c")
        .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4")
        tablePanelForPieChart.selectAll('td').style("height","25px") .style("border", "1px solid #ffffff") .style("font-size","12px").style("font-weight","Normal")

        //additionally 
        tablePanelForPieChart.selectAll('th').style('background-color',options.BGcolor).style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
        tablePanelForPieChart.selectAll('td').style("border-style","none").style("color","#00001c")
        
        tablePanelForPieChart.selectAll('table') . style("border-collapse","collapse")
        tablePanelForPieChart.selectAll('table tr:first-child th').style("border-top","0px")
        tablePanelForPieChart.selectAll('table tr:last-child td').style("border-bottom","0px")
        tablePanelForPieChart.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
        tablePanelForPieChart.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")

        if(showOrHideTableForPieChart == false){ 
            tablePanelForPieChart.style("display","none")

        }   
        else if(showOrHideTableForPieChart == true){ 
            tablePanelForPieChart.style("display","block")
        }
        
        if(options.isDataDetailedForTable == false){
            
            var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
            
            // Adding underlines for selected drill-down column text
            var drillDownSectionsForPieChart = tablePanelForPieChart.select('table').selectAll('th')
            var drillDownSectionsFor_PieChart = drillDownSectionsForPieChart[0]
            
            var foundResult = [];
            for(var i = 0; i<drillDownSectionsForPieChart[0].length; i++){
                
                for(var j = 0; j<drillDownColumnNamesArray.length; j++){
                    if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForPieChart[0][i].__data__.toString().toLowerCase() ){
                        foundResult.push(i)
                    }
                }
            }
            
            var r = tablePanelForPieChart.select('table').selectAll('tr').selectAll('td')
            for(var i = 0; i<r.length; i++){
                for(var j = 0; j < foundResult.length; j++){
                    var row = r[i][foundResult[j]]
                    $(row).css("text-decoration", "underline")
                }
            }
        }
        
        //By default calling the resized function first time (to align table's th and td).
        //resizedFuctionForPieChart()
        
        window.addEventListener('resize', function(event){
            divWidth = $("#" + targetElement[0][0].id).width()
            divHeight = $("#" + targetElement[0][0].id).height()
            resizedFuctionForPieChart();
        });
        
        $(function() {
			$("#" + targetElement[0][0].id).resizable({
                resize: function(event, ui) {
					divWidth = ui.size.width;
					divHeight = ui.size.height;
					resizedFuctionForPieChart();
				},
			});
		});
        
        function resizedFuctionForPieChart(){
            
            // Showing Pie Chart Label Line based on Parent DIV Width and Height
            if(divWidth <= 300 || divHeight <= 300){    polyline.style("display","none")    }
            else if(divWidth >300 || divHeight > 300){  polyline.style("display","none")   }

            isResizedFunctionCalled = true
            
            if(showOrHideCommentsBtnForPieChart == true){
                bubbleButtonForPieChart.style('margin-left', "2px")
                colButtonForPieChart.style('margin-left', "2px")
                donutButtonForPieChart.style('margin-left', "2px")
                horButtonForPieChart.style('margin-left', "2px")
                filterButtonForPieChart.style('margin-left', "2px")
                refreshButtonForPieChart.style('margin-left', "2px")
                commentsBtnForPieChart.style('margin-left', "2px")
                // menuButtonForPieChart.style('right', '0')
                menuButtonForPieChart.style('right','0')

            }
            else if(showOrHideCommentsBtnForPieChart == false){
                bubbleButtonForPieChart.style('margin-left', "2px")
                colButtonForPieChart.style('margin-left', "2px")
                donutButtonForPieChart.style('margin-left', "2px")
                horButtonForPieChart.style('margin-left', "2px")
                filterButtonForPieChart.style('margin-left', "2px")
                refreshButtonForPieChart.style('margin-left', "2px")
                //commentsBtnForPieChart.style('margin-left', "2px")
                commentsBtnForPieChart.style('display','none')
                 // menuButtonForPieChart.style('right', '0')
                 menuButtonForPieChart.style('right','0')
            }

            // optionsButtonPanelForPieChart.style('right', '0')
            optionsButtonPanelForPieChart.style('right', '0')

            cancelButtonForNewFilterPanel.style('right', '0')

            cancelButtonForNewSettingsPanel.style('right', '0')

            if(isSearchInTableButtonClicked == true){
              canBtnForSearchTableForPieChart.style('right', '0')
            }
			
            var svgPanelClassWidthAndHeight = d3.select(targetElement[0][0]).select('svg').classed("svgPanelClass",true)

            // Getting new width and new height of SVG panel of Pie Chart and Legend and Chart Title Panel DIV
            width1 = targetElement[0][0].clientWidth * (parseFloat(svgPanelForPieChart[0][0].style.width) / 70)
            height1 = targetElement[0][0].clientHeight * (parseFloat(svgPanelForPieChart[0][0].style.height) / 70)

            newWidth1 = targetElement[0][0].clientWidth * (parseFloat(svgPanelForPieChart[0][0].style.width) / 70)
            newHeight1 = targetElement[0][0].clientHeight * (parseFloat(svgPanelForPieChart[0][0].style.height) / 70)
            
            newWidth111 = chartTitlePanelForPieChart[0][0].clientWidth
            newHeight111 = chartTitlePanelForPieChart[0][0].clientHeight
            
            newWidth1111 = targetElement[0][0].clientWidth * (parseFloat(legendPanelFront[0][0].style.width) / 100)
            newHeight1111 = targetElement[0][0].clientHeight * (parseFloat(legendPanelFront[0][0].style.height) / 100)

            // New Radius for Pie
            var newRadius = Math.min(width1, height1) / 3.0;
            
            newRadiusAfterResizingForPieChart = newRadius;

            // Againg checking whether the Chart Title and Chart Legend is choosen (true or false) when library is called.
            if(options.showTitle == false && options.showLegend == false){ newRadius = Math.min(width1, height1) / 2.8; }
            else if(options.showTitle == true && options.showLegend == false){  newRadius = Math.min(width1, height1) / 2.5;  }
            
            svgForPieChart.attr('transform', 'translate(' + (width1/3) + ',' + (height1 / 3) + ')');
            
            arc = d3.svg.arc() .outerRadius(newRadius * 0.8) .innerRadius(0);
            
            outerArc = d3.svg.arc() .innerRadius(newRadius * 0.9) .outerRadius(newRadius * 0.9);
            
            arc.innerRadius(0).outerRadius(newRadius * 0.8);
            
            pathForPieChart.transition().duration(500).attrTween("d", arcTween);

            // Resizing the Gradient Effect 
            svgForPieChart.select("circle").transition().duration(0).delay(0)
            .attr("r", newRadius/1.25);
            
            function arcTween(a) {
                var i = d3.interpolate(this._current, a);
                this._current = i(0);
                return function(t) {    return arc(i(t));   };
            }
            
            text.transition().duration(10).attrTween("d", textTween);
            
            function textTween(a) {
                text.transition().duration(500)
                .attrTween("transform", function(d) {
                    this._current = this._current || d;
                    var interpolate = d3.interpolate(this._current, d);
                    this._current = interpolate(0);
                    return function(t) {
                                var d2 = interpolate(t);
                                var pos = outerArc.centroid(d2);
                                return "translate("+ pos +")";
                            };
                })
            }
            
            polyline.transition().duration(500)
            .attrTween("points", function(d){
                this._current = this._current || d;
                var interpolate = d3.interpolate(this._current, d);
                this._current = interpolate(0);
                if(d.value == 0){   d3.select(this).style("visibility","hidden");   }
                       else {   d3.select(this).style("visibility","hidden");
                                return function(t) {
                                    var newArc = d3.svg.arc()
                                    .innerRadius(newRadius - (newRadius/2))
                                    .outerRadius(newRadius);
                                    var d2 = interpolate(t);
                                    var pos = outerArc.centroid(d2);
                                    return [newArc.centroid(d2), outerArc.centroid(d2)];
                                };
                            }
            });
            
            // Aligning Legend (vertically)
            var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(legendPanelFront[0][0].style.width) / 100)
            var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(legendPanelFront[0][0].style.height) / 100)

            var legendRectSize = 11;
            var legendSpacing = 5.0;
            
            legend.attr('transform', function(d, i) {
                var height = legendRectSize + legendSpacing;
                var offset =  height * color.domain().length / 2;
                var horz = 2;
                var vert = (i * height) + (legendPanelHeight - (height * options.data.length))/2;
                return 'translate(' + horz + ',' + vert + ')';
            })
            
            // Expanding Pie Slice with New Radius
            var arcOver = d3.svg.arc() .outerRadius((newRadius * 0.9) + 0.05);
            pathForPieChart.on("mouseenter", function(d,i) {   d3.select(this) .transition() .ease("elastic") .duration(100) .attr("d", arcOver) .attr("stroke-width",0.5);  });
            pathForPieChart.on("mouseleave", function(d) {   d3.select(this).transition() .attr("d", arc) .attr("stroke-width",1);   });
            
            colWidth = []; 
			
            d3.select(".theadClassForPieChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
				d.forEach(function(dd,j){
					colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
				})
            })
            
            tablePanelForPieChart.select(".thead1ClassForPieChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
            })
            
        } // resizedFunction ends here.
        
    }, //pieChart
    
    // ************************************************** Column Chart  **************************************************
    columnChart: function(targetElement, options){

        if(columnChartOptionsDataCountVariable == 0){
            columnChartOptionsDataArray = options.data
            columnChartOptionsDataCountVariable++;
        }
        // let key=options.xAxisFormatted;
		// 	let array=options.data.map(value => value[key]);
		// 	for(let i=0;i<array.length;i++){
		// 		if(array[i].length<5){
		// 			var labelStyle=
		// 		}
		// 	}
        
        isChartCalled++;
        var chartName = "COLUMNCHART";
        
        acinfotech.allCharts(targetElement,options,chartName);
        
        //options.data.sort(function(a,b) { return +a[options.keys.value] - +b[options.keys.value]; })
        
        var newJson = [];
        options.data.forEach(function(d, i) {
            var temp = {};
            
            for(var i = 0; i < Object.keys(d).length; i++) {
                delete d['enabled'];
                temp[Object.keys(d)[i]] = d[Object.keys(d)[i]]
            }
            
            newJson.push(temp)
        });

        targetElement.style("min-width", "350px").style("min-height", "350px").style("background-color", options.BGcolor)

        var showOrHideTableForColumnChart;
        var showOrHideCommentsForColumnChart;
        var showOrHideCommentsBtnForColumnChart = true;

        // Show or Hide Table
        if((options.showTable == false) || (options.showTable == true)){
            showOrHideTableForColumnChart = options.showTable    
        }
        else{
            showOrHideTableForColumnChart = false;
        }
        
        // Show or Hide comments
        if (options.showComments == true || false) {
            showOrHideCommentsForColumnChart = options.showComments;
        }
        else {
            showOrHideCommentsForColumnChart = false;
        }
        
        if (options.comments.length == 0){ // checking whether there is a comment or not
            showOrHideCommentsForColumnChart = false;
            showOrHideCommentsBtnForColumnChart = false;
        }

        if ((showOrHideTableForColumnChart == true) && (showOrHideCommentsForColumnChart == true)){
            showOrHideTableForColumnChart = true;
            showOrHideCommentsForColumnChart = false;
        }
        else if ((showOrHideTableForColumnChart == false) && (showOrHideCommentsForColumnChart == false)){
            showOrHideTableForColumnChart = false;
            showOrHideCommentsForColumnChart = false;
        }

        var divWidth, divHeight;
        
        var chartTitlePanelForColumnChart =  targetElement.append("div").style('position',"absolute").style("background-color", options.BGcolor) .style("text-indent","6px") .style("border", "none")
        
		var optionsButtonPanelForColumnChart = targetElement.append('div').style('width',"25px").style('height',"285px").style('position','absolute')
        .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px")
        .style('right', '0').style("min-width","25px")
        .style("border-style","none").style("border-left", "solid #fcfcfc  1px")//.style("top",71.5 + "px")
		
        var pieButtonForColumnChart = optionsButtonPanelForColumnChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','133px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var pieBtnImgVar = document.createElement("IMG");
        pieBtnImgVar.src = "images/pieIcon.png";
        pieBtnImgVar.setAttribute("style","position:absolute; left:2px; top:2px; width:15px; height:15px; opacity:0.8;")
        pieButtonForColumnChart[0][0].appendChild(pieBtnImgVar)

        var donutButtonForColumnChart = optionsButtonPanelForColumnChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','159px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        
        var dountBtnImgVar = document.createElement("IMG");
        dountBtnImgVar.src = "images/donutIcon.png";
        dountBtnImgVar.setAttribute("style","position:absolute; left:2px; top:2px; width:15px; height:15px; opacity:0.9;")
        donutButtonForColumnChart[0][0].appendChild(dountBtnImgVar)

        var horButtonForColumnChart = optionsButtonPanelForColumnChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','184px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        
        var horiBtnImgVar = document.createElement("IMG");
        horiBtnImgVar.src = "images/horizontalIcon.png";
        horiBtnImgVar.setAttribute("style","position:absolute; left:2px; top:2px; width:15px; height:15px; opacity:0.9;")
        horButtonForColumnChart[0][0].appendChild(horiBtnImgVar)
		
        var filterButtonForColumnChart = optionsButtonPanelForColumnChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','209px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var filterBtnImgVar = document.createElement("IMG");
        filterBtnImgVar.src = "images/filterIcon.png";
        filterBtnImgVar.setAttribute("style","position:absolute; left:2px; top:2px; width:15px; height:15px; opacity:0.8;")
        filterButtonForColumnChart[0][0].appendChild(filterBtnImgVar)

        var refreshButtonForColumnChart = optionsButtonPanelForColumnChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','234px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var refreshBtnImgVar = document.createElement("IMG");
        refreshBtnImgVar.src = "images/refreshIcon.png";
        refreshBtnImgVar.setAttribute("style","position:absolute; left:2px; top:2px; width:15px; height:15px; opacity:0.8;")
        refreshButtonForColumnChart[0][0].appendChild(refreshBtnImgVar)

        var commentsBtnForColumnChart = optionsButtonPanelForColumnChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','259px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var commentsBtnImgVariable = document.createElement("IMG");
        if(options.showComments == false){
            commentsBtnImgVariable.src = "images/showCommentsIcon.png";
        }
        else if(options.showComments == true){
            commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
        }
        commentsBtnImgVariable.setAttribute("style","position:absolute; left:2px; top:2px; width:15px; height:15px; opacity:0.8;")
        commentsBtnForColumnChart[0][0].appendChild(commentsBtnImgVariable)

        var menuButtonForColumnChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','1px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var menuBtnImgVar = document.createElement("IMG");
        menuBtnImgVar.src = "images/menuIcon.png";
        menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
        menuButtonForColumnChart[0][0].appendChild(menuBtnImgVar)
        
        if(showOrHideCommentsBtnForColumnChart == true){
            pieButtonForColumnChart.style('margin-left', "2px")
            donutButtonForColumnChart.style('margin-left', "2px")
            horButtonForColumnChart.style('margin-left', "2px")
            filterButtonForColumnChart.style('margin-left', "2px")
            refreshButtonForColumnChart.style('margin-left', "2px")
            commentsBtnForColumnChart.style('margin-left', "2px")
            // menuButtonForColumnChart.style('right', '0')
            menuButtonForColumnChart.style('right','0')
        }
        else if(showOrHideCommentsBtnForColumnChart == false){
            pieButtonForColumnChart.style('margin-left', "2px")
            donutButtonForColumnChart.style('margin-left', "2px")
            horButtonForColumnChart.style('margin-left', "2px")
            filterButtonForColumnChart.style('margin-left', "2px")
            refreshButtonForColumnChart.style('margin-left', "2px")
            //commentsBtnForColumnChart.style('right', '0')
            commentsBtnForColumnChart.style('display','none')
            // menuButtonForColumnChart.style('right', '0')
            menuButtonForColumnChart.style('right','0')
        }

        var ismenuButtonOfColumnChartClicked = false; // Menu toggle button variable
        menuButtonForColumnChart.on('click', function() {
            if(ismenuButtonOfColumnChartClicked == false){ // Checking if menu button is clicked
                ismenuButtonOfColumnChartClicked = true; // Menu toggle button variable
                optionsButtonPanelForColumnChart.style("display","block") // Showing option buttons menu panel

                searchDivForColumnChart.style("display","none") // Filter panel
                settingPanelDivForColumnChart.style("display","none") // Hiding setting panel

                //.style("display","none") // Hiding edit X & Y axis value panel 

            if(options.showTitle == true){
            
                if ((showOrHideTableForColumnChart == false) && (showOrHideCommentsForColumnChart == true)){
                    
                    svgPanelForColumnChart.style('width', 100 + "%") .style('height', 70 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForColumnChart == true) && (showOrHideCommentsForColumnChart == false)){
                    
                    svgPanelForColumnChart.style('width', 100 + "%") .style('height', 52 + "%") .style("position","absolute").style("background-color", options.BGcolor);
                }
                else if ((showOrHideTableForColumnChart == false) && (showOrHideCommentsForColumnChart == false)){
                     
                    svgPanelForColumnChart.style('width', 100 + "%") .style('height', 85 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }

            }
            else if(options.showTitle == false){
           
                if ((showOrHideTableForColumnChart == false) && (showOrHideCommentsForColumnChart == true)){
                    
                    svgPanelForColumnChart.style('width', 100 + "%") .style('height', 70 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForColumnChart == true) && (showOrHideCommentsForColumnChart == false)){
                    
                    svgPanelForColumnChart.style('width', 100 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForColumnChart == false) && (showOrHideCommentsForColumnChart == false)){
                     
                    svgPanelForColumnChart.style('width', 100 + "%") .style('height', 85 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
            }
        

                resizedFuctionForColumnChart(); // Calling resize function
            }
            else if(ismenuButtonOfColumnChartClicked == true){ // Checking if menu button is clicked
                ismenuButtonOfColumnChartClicked = false
                optionsButtonPanelForColumnChart.style("display","none") // Hiding option buttons panel 
            }
        })
        
        var svgPanelForColumnChart = targetElement .append('svg') 
        .attr("id","svgPanelIDForColumnChart" + targetElement[0][0].id).style("background-color", options.BGcolor).style("position","absolute")
        
        var commentsPanelDivForColumnChart = targetElement.append("div") .attr("class","commentsPanelClassForColChart") 
        .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
		.style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
        .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)

        commentsPanelDivForColumnChart.on('click',function(d){
            $('.commentsClassForColumnChart' + targetElement[0][0].id).focus()
        })

        if(options.showTitle == true){ 
            
            chartTitlePanelForColumnChart.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 8 + "%"; })
            .html('<div  style="width: 100%; height:0%; background-color:#ffffff; position: absolute; top:10.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')

            if ((showOrHideTableForColumnChart == false) && (showOrHideCommentsForColumnChart == true)){

                var commentsForColumnchart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify').attr('class','commentsClassForColumnChart' + targetElement[0][0].id)

                   svgPanelForColumnChart.attr('width', 100 + "%") .attr('height', 70 + "%") .style("top",8 + "%").style("background-color", options.BGcolor) .append('g')
                   commentsPanelDivForColumnChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForColumnchart[0].outerHTML.toString())

            }
            else if ((showOrHideTableForColumnChart == true) && (showOrHideCommentsForColumnChart == false)){

                    svgPanelForColumnChart.attr('width', 100 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .style("background-color", options.BGcolor).append('g')
                    commentsPanelDivForColumnChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForColumnChart == false) && (showOrHideCommentsForColumnChart == false)){
                    svgPanelForColumnChart.attr('width', 100 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .style("background-color", options.BGcolor).append('g')
                    commentsPanelDivForColumnChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }


            var margin = {top: 30 , right: 40, bottom: 80, left: 40}, //originally top: 42, left: 80
            width = (svgPanelForColumnChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = svgPanelForColumnChart.node().getBoundingClientRect().height - margin.top - margin.bottom;
            
        }
        else if(options.showTitle == false){

            chartTitlePanelForColumnChart.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });
            
            if ((showOrHideTableForColumnChart == false) && (showOrHideCommentsForColumnChart == true)){

                var commentsForColumnchart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify')

                   svgPanelForColumnChart.attr('width', 100 + "%") .attr('height', 70 + "%") .style("top",8 + "%").style("background-color", options.BGcolor) .append('g')
                   commentsPanelDivForColumnChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForColumnchart[0].outerHTML.toString())

            }
            else if ((showOrHideTableForColumnChart == true) && (showOrHideCommentsForColumnChart == false)){

                    svgPanelForColumnChart.attr('width', 100 + "%") .attr('height', 52 + "%") .style("top",8 + "%").style("background-color", options.BGcolor) .append('g')
                    commentsPanelDivForColumnChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForColumnChart == false) && (showOrHideCommentsForColumnChart == false)){
                    svgPanelForColumnChart.attr('width', 100 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .style("background-color", options.BGcolor).append('g')
                    commentsPanelDivForColumnChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }

            var margin = {top: 30, right: 40, bottom: 80, left: 40}, //originally top: 42, left: 80
            width = (svgPanelForColumnChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = svgPanelForColumnChart.node().getBoundingClientRect().height - margin.top - margin.bottom;
        }
        
        var colors;
        // checking color set for bars
        if(options.colorSet === undefined){
            options.colorSet = "one"
            colors = d3.scale.ordinal().range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "one"){
            options.colorSet = "one"
            
            colors = d3.scale.ordinal().range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            options.colorSet = "two"
            colors =  d3.scale.ordinal().range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            options.colorSet = "three"
            colors = d3.scale.ordinal().range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        }
        else
        {
            options.colorSet = "one"
            colors = d3.scale.ordinal().range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }

        /*------------------ Settings panel DIV and everything within it section begins here ------------------*/
        var settingDisabledDivForColumnChart = targetElement.append('div').style('width',targetElement[0][0].clientWidth + "px").style('height',targetElement[0][0].clientHeight + "px").style('position','absolute')
        .style("background-color",'#f3f3f3').style("z-index",2).style("display","none").style('top', 0.0 + "%").style('left', 0.0 + "%")
        .style("opacity",0.1).style("min-width","350px").style("min-height","350px") //005ec4

        var settingPanelDivForColumnChart = targetElement.append('div').style('width',"100%").style('height',"40%").attr("class","settingPanelDivForColumnChart" + targetElement[0][0].id)
        .style('position','absolute').style('margin-left', "0px").style('border-top',"1px solid #f0f0f0").style('border-bottom',"1px solid #e5e5e5")
        .style("background-color",'#fcfcfc').style("z-index",90) //001c3b
        .style("display","none").style("overflow-x","auto").style("overflow-y","hidden")
        .style('top',"60%").style('height',"40%")

        $( '.settingPanelDivForColumnChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        var settingPanelDivForColumnChartTitle = settingPanelDivForColumnChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','10px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; color:#00001c;">'+ "Settings" +'</div>')

        var settingPanelDivForColumnChangeColorTitle = settingPanelDivForColumnChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Select color set " +'</div>')

        var settingPanelCancelBtnForColumnChart = settingPanelDivForColumnChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
        .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid")
        .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.88; background-color:#fcfcff")
        settingPanelCancelBtnForColumnChart[0][0].appendChild(cancelBtnImgVar)

        settingPanelCancelBtnForColumnChart.on('click', function() {
            settingPanelDivForColumnChart.style("display","none") // Hiding setting panel

            if ((showOrHideTableForColumnChart == false) && (showOrHideCommentsForColumnChart == true)){
                    
                svgPanelForColumnChart.style('width', 100 + "%") .style('height', 70 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); 
            }
            else if ((showOrHideTableForColumnChart == true) && (showOrHideCommentsForColumnChart == false)){
                    
                svgPanelForColumnChart.style('width', 100 + "%") .style('height', 52 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForColumnChart == false) && (showOrHideCommentsForColumnChart == false)){
                     
                svgPanelForColumnChart.style('width', 100 + "%") .style('height', 85 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); 
            }

            resizedFuctionForColumnChart();
        })

        var formForChangeSettingsPanel = settingPanelDivForColumnChart.append("form");
        formForChangeSettingsPanel.style("background-color","#fcfcfc").style("margin-top","67px").style("font-family","Verdana,sans-serif").style("font-size","12px")
        .style("position","absolute") .attr("id","formForChangeColorSettingsPanel" + targetElement[0][0].id).style("font-weight","Bold").style("width","180px")
        .style("height","58px") .style("padding","0px") .style("border-radius","0px") .style("margin-left","10px")
        
        var svgPanelForColorSetOneForColChart = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("margin-top","1px")
        .style("margin-left","0px") .style("background-color","#fefefe").style("width","160px").style("height","18px") .style("box-sizing","border-box")
        
        var colorSetOneForColChart = d3.scale.ordinal().range(["#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f"]);
        var colorSetOneRangeForColChart = d3.range(12);

        var colorSetOneDotsForColChart = svgPanelForColorSetOneForColChart.append("g")
        colorSetOneDotsForColChart.selectAll('rect') .data(colorSetOneRangeForColChart) .enter().append('rect')
        .attr('transform', 'translate(' + (2) + ',' + (1) + ')') .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10)
        .attr("height",10) .style("fill", function(d,i){return colorSetOneForColChart(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1)
        .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetOneForColChart(i); }) .style("cursor","auto")
        .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        var svgPanelForColorSetTwoForColChart = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px").style("height","18px").style("margin-top","20px").style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetTwoForColChart = d3.scale.ordinal().range(["#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387"]);
        var colorSetTwoRangeForColChart = d3.range(12);

        var colorSetTwoDotsForColChart = svgPanelForColorSetTwoForColChart.append("g")
        colorSetTwoDotsForColChart.selectAll('rect') .data(colorSetTwoRangeForColChart) .enter().append('rect')
        .attr('transform', 'translate(' + (2) + ',' + (1) + ')') .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10)
        .attr("height",10) .style("cursor","auto") .style("fill", function(d,i){return colorSetTwoForColChart(i)}) .style("fill-opacity",0.93)
        .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetTwoForColChart(i); })
        .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        var svgPanelForColorSetThreeForColChart = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("margin-top","39px")
        .style("margin-left","0px") .style("background-color","#fefefe") .style("width","160px") .style("height","18px") .style("box-sizing","border-box")
        
        var colorSetThreeForColChart = d3.scale.ordinal().range(["#cc719f", "#cc719f", "#cc719f", "#cc719f", "#cc719f", "#cc719f", "#cc719f", "#cc719f", "#cc719f", "#cc719f", "#cc719f", "#cc719f"]);
        var colorSetThreeRangeForColChart = d3.range(12);

        var colorSetThreeDotsForColChart = svgPanelForColorSetThreeForColChart.append("g")
        colorSetThreeDotsForColChart.selectAll('rect') .data(colorSetThreeRangeForColChart) .enter().append('rect')
        .attr('transform', 'translate(' + (2) + ',' + (1) + ')') .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10)
        .attr("height",10) .style("cursor","auto") .style("fill", function(d,i){return colorSetThreeForColChart(i)}) .style("fill-opacity",0.93)
        .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetThreeForColChart(i);  })
        .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        if(options.colorSet.toString().toLowerCase() === "one"){
            svgPanelForColorSetOneForColChart.style('border',"1px solid #808080")
            svgPanelForColorSetTwoForColChart.style('border',"0px solid #808080")
            svgPanelForColorSetThreeForColChart.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            svgPanelForColorSetOneForColChart.style('border',"0px solid #808080")
            svgPanelForColorSetTwoForColChart.style('border',"1px solid #808080")
            svgPanelForColorSetThreeForColChart.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            svgPanelForColorSetOneForColChart.style('border',"0px solid #808080")
            svgPanelForColorSetTwoForColChart.style('border',"0px solid #808080")
            svgPanelForColorSetThreeForColChart.style('border',"1px solid #808080")
        }
        else 
        {
            svgPanelForColorSetOneForColChart.style('border',"1px solid #808080")
            svgPanelForColorSetTwoForColChart.style('border',"0px solid #808080")
            svgPanelForColorSetThreeForColChart.style('border',"0px solid #808080")
        }

        svgPanelForColorSetOneForColChart.on('click',function(d){
            options.colorSet = "one"
            svgPanelForColorSetOneForColChart.style('border',"1px solid #808080")
            svgPanelForColorSetTwoForColChart.style('border',"0px solid #808080")
            svgPanelForColorSetThreeForColChart.style('border',"0px solid #808080")

            var colorSetOne = d3.scale.ordinal().range(["#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f"]);
            colors = colorSetOne;
			verticalBars.style("fill",function(d,i){ return  colorSetOne(i) })

        })
        svgPanelForColorSetTwoForColChart.on('click',function(d){
            options.colorSet = "two"
            svgPanelForColorSetOneForColChart.style('border',"0px solid #808080")
            svgPanelForColorSetTwoForColChart.style('border',"1px solid #808080")
            svgPanelForColorSetThreeForColChart.style('border',"0px solid #808080")

            var colorSetTwo = d3.scale.ordinal().range(["#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387"]);
            colors = colorSetTwo;
            verticalBars.style("fill",function(d,i){  return colorSetTwo(i);  });

        })
        svgPanelForColorSetThreeForColChart.on('click',function(d){
            options.colorSet = "three"
            svgPanelForColorSetOneForColChart.style('border',"0px solid #808080")
            svgPanelForColorSetTwoForColChart.style('border',"0px solid #808080")
            svgPanelForColorSetThreeForColChart.style('border',"1px solid #808080")

            var colorSetThree = d3.scale.ordinal().range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
            colors = colorSetThree;
            verticalBars.style("fill",function(d,i){  return colorSetThree(i);  })
        })

        
        /*------------------ Settings panel DIV and everything inside it section ends here ------------------*/

        var jsonData = options.data
        var valueArray = [];
        var labelArray = [];
        
        options.data.forEach(function(d, i) {
            d[options.keys.value] = d[options.keys.value];
            valueArray.push(d[options.keys.value])
            labelArray.push(d[options.keys.label])
        })
        
        
        var x = d3.scale.linear() .domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.value]; }))]) .range([0, width]);
        
        var y = d3.scale.linear() .domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.value]; }))]) .range([height, 0]);
        
        var yAxis = d3.svg.axis() .scale(y) .orient("left") .ticks(5);
        
        var tip = d3.tip() .attr('class', 'd3-tip') .offset([-10, 0]) .style("font-family","Verdana,sans-serif").style("padding","4px").style("text-transform","capitalize").style("font-weight","Bold").style("font-size","12px").style("z-index",1000)
		.style("color","#00001c")
        .html(function(d, i) {
            var valueForColChartToolTip;
            if(valueArray[i].toString().indexOf('.') === -1)
            {
                valueForColChartToolTip = valueArray[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    }
            else{
                        
                valueForColChartToolTip = valueArray[i];
            }
              return options.keys.label + " : " + labelArray[i] + "<br>" + '<hr style="height:2px; width:100%px; margin:2px; border:none;color:#333;background-color:#E0E0E0;" />'+ options.keys.value +" : " + valueForColChartToolTip }); //valueArray[i] ; });
        
        var minAndMaxValuesArrayForColumnChart = []
            newJson.forEach(function(d, i) {
                var dd = parseFloat(d[options.keys.value])
                minAndMaxValuesArrayForColumnChart.push(dd) 
            });
        
        var low = d3.min(minAndMaxValuesArrayForColumnChart);
        var hig = d3.max(minAndMaxValuesArrayForColumnChart);
        
        var searchChartButton = optionsButtonPanelForColumnChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 0px 0px #888888") .style('background-color',"#ffffff").style('margin-left','2px').style('top','1px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #888888") .style("border-style", "none")
        //.style("border-bottom", "solid #e6e6e6  1px")
        var searchBtnImgVar = document.createElement("IMG");
        searchBtnImgVar.src = "images/searchChart1.png";
        searchBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.9;")
        searchChartButton[0][0].appendChild(searchBtnImgVar)

        var editChartButton = optionsButtonPanelForColumnChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 0px 0px #888888") .style('background-color',"#ffffff").style('margin-left','2px').style('top','27px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #888888") .style("border-style", "none")
        //.style("border-bottom", "solid #e6e6e6  1px")
        var editChartIconImgVar = document.createElement("IMG");
        editChartIconImgVar.src = "images/changeXAndYValuesIcon.png";
        editChartIconImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.9;")
        editChartButton[0][0].appendChild(editChartIconImgVar)

        var tableButtonForColumnChart = optionsButtonPanelForColumnChart.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 53 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
        var tableBtnImgVar = document.createElement("IMG");
        if(showOrHideTableForColumnChart == false){
            tableBtnImgVar.src = "images/showTableIcon.png";
            tableButtonForColumnChart.attr("class","showTableClassForChartTable")
        }
        else if(showOrHideTableForColumnChart == true){
            tableBtnImgVar.src = "images/cancelTableIcon.png";
            tableButtonForColumnChart.attr("class","hideTableClassForChartTable")
        }
        tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
        tableButtonForColumnChart[0][0].appendChild(tableBtnImgVar)

        var settingBtnForColChart = optionsButtonPanelForColumnChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 80 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        var settingBtnImgVar = document.createElement("IMG");
        settingBtnImgVar.src = "images/settingsIcon.png";
        settingBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.82;")
        settingBtnForColChart[0][0].appendChild(settingBtnImgVar)
        
        var downloadBtnForColChart = optionsButtonPanelForColumnChart.append("div").attr("id","downloadBtnForColumnChart-ID-" + targetElement[0][0].id).style("width","20px").style("height","20px")
        .style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 107 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        
		acinfotech.downloadFunctionality("downloadBtnForColumnChart-ID-" + targetElement[0][0].id,targetElement)
        
        pieButtonForColumnChart.on('click', function() {

            options.showTable = false;
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            var newOptions = {
                           data: options.data,
                           dataForTable: options.dataForTable,
                           isDataDetailedForTable: options.isDataDetailedForTable,
                           keys: {
                               label: options.keys.label,
                               value: options.keys.value
                           },
                           chartTitle: options.chartTitle,
                           showTitle: options.showTitle,
                           showLegend: true,
                           legendSide: "right", 
                           colorSet: options.colorSet,
                           BGcolor:options.BGcolor, 
                           series:options.series,
                           legend:options.legend,
                           gradient: "none",
                           drillDownColumnName:options.drillDownColumnName,
                           showTable: options.showTable,
                           showComments: options.showComments,
                           comments: options.comments,
                           resizeButtonID: options.resizeButtonID
                        }
                acinfotech.pieChart(targetElement, newOptions)
        })

        donutButtonForColumnChart.on('click', function() {

            options.showTable = false;
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            var newOptions = {
                           data: options.data,
                           dataForTable: options.dataForTable,
                           isDataDetailedForTable: options.isDataDetailedForTable,
                           keys: {
                               label: options.keys.label,
                               value: options.keys.value
                           },
                           chartTitle: options.chartTitle,
                           showTitle: options.showTitle,
                           showLegend: true,
                           legendSide: "right",
                           colorSet: options.colorSet,
                           BGcolor:options.BGcolor,
                           series:options.series,
                           legend:options.legend,
                           gradient:"none",
                           drillDownColumnName:options.drillDownColumnName,
                           showTable: options.showTable,
                           showComments: options.showComments,
                           comments: options.comments,
                           resizeButtonID: options.resizeButtonID
                        }
                acinfotech.donutChart(targetElement, newOptions)
        })

        horButtonForColumnChart.on('click', function() {
            options.showTable = false;
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
           var newOptions = {
                           data: options.data,
                           dataForTable: options.dataForTable,
                           isDataDetailedForTable: options.isDataDetailedForTable,
                           keys: {
                               label: options.keys.label,
                               value: options.keys.value
                           },
                           chartTitle:options.chartTitle,
                           xAxisLable:options.keys.value,
                           yAxisLable:options.keys.label,
                           showTitle:options.showTitle,
                           colorSet: options.colorSet,
                           BGcolor:options.BGcolor ,
                           series:options.series,
                           legend:options.legend,
                           drillDownColumnName:options.drillDownColumnName,
                           showTable:options.showTable,
                           showComments: options.showComments,
                           comments: options.comments,
                           resizeButtonID: options.resizeButtonID
                       }
                acinfotech.horizontalChart(targetElement, newOptions) 
        })

        refreshButtonForColumnChart.on('click', function() {

            isFilterClickedForColumnChart = false
            
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){
                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                }
            }
            acinfotech.columnChart(targetElement,options)

        })

         tableButtonForColumnChart.on('click', function() {
            
            if(options.showTable == false){ // Checking if table is shown or hidden
                options.showTable = true;
            }
            else if(options.showTable == true){ // Checking if table is shown or hidden
                options.showTable = false;
            }

            isFilterClickedForColumnChart = false; 
            
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){
                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                    options.showComments = false;
                }
            }
            acinfotech.columnChart(targetElement,options)

        })

        
        settingBtnForColChart.on('click', function() {
                
                ismenuButtonOfColumnChartClicked = false; // Setting menu button variable to false
                optionsButtonPanelForColumnChart.style("display","none") // Hiding the option buttons panel

                iconButtonTooltip.style("display","none"); // Removing options button ToolTip
                settingBtnForColChart.style("cursor","pointer") // Changing mouse pointer
                
                changeXAndYAxisValuesPanelForColumnChart.style("display","none") // Showing filter panel
                                 
                settingPanelDivForColumnChart.style("display","block") // Showing setting panel

                //svgPanelForColumnChart.attr('width', 100 + "%") .attr('height', 52 + "%").style("position","absolute") // Decreasing chart panel height

                if ((showOrHideTableForColumnChart == false) && (showOrHideCommentsForColumnChart == true)){
                    
                    svgPanelForColumnChart.style('width', 100 + "%") .style('height', 52 + "%") .style('top', 8 + "%") .style("background-color", options.BGcolor).style("position","absolute"); 
                }
                else if ((showOrHideTableForColumnChart == true) && (showOrHideCommentsForColumnChart == false)){
                    
                    svgPanelForColumnChart.style('width', 100 + "%") .style('height', 52 + "%") .style('top', 8 + "%").style("background-color", options.BGcolor) .style("position","absolute");
                }
                else if ((showOrHideTableForColumnChart == false) && (showOrHideCommentsForColumnChart == false)){
                     
                    svgPanelForColumnChart.style('width', 100 + "%") .style('height', 52 + "%") .style('top', 8 + "%") .style("background-color", options.BGcolor).style("position","absolute"); 
                }

            resizedFuctionForColumnChart(); 
                
        })

        filterButtonForColumnChart.on('click', function() {

            ismenuButtonOfColumnChartClicked = false; // Changing menu button value to false
            optionsButtonPanelForColumnChart.style("display","none") // Hiding option buttons panel

            changeXAndYAxisValuesPanelForColumnChart.style("display","none") // Hiding edit X & Y axis panel

            isFilterClickedForColumnChart = false
            
                $(function() { 
                    
                    $( '#' + targetElement[0][0].id + "columnChartRangeSliderID" ).slider({
                        orientation: "horizontal",
                        min: 0,//d3.min(minAndMaxValuesArrayForColumnChart),
                        max: d3.max(minAndMaxValuesArrayForColumnChart),
                        step: 1,
                        values: [low,hig],
                        animate: true,
                        range : true,
                        slide: function(event, ui) {
                            filterRangeValueOneForColumnChart = 0;
                            filterRangeValueTwoForColumnChart = 0;
                            textBoxOneForColumnChart.attr("value",ui.values[0])
                            textBoxTwoForColumnChart.attr("value",ui.values[1])
                            filterRangeValueOneForColumnChart = ui.values[0];
                            filterRangeValueTwoForColumnChart = ui.values[1];

                            $('#' + targetElement[0][0].id + "columnChartRangeSliderID").slider().find(".ui-slider-range").css({
                            'background': '#001c3b'});
                        },
                    });
                });

                //searchDivForColumnChart.style("display","block")
                resetTableWidthOldDataFunction()

                iconButtonTooltip.style("display","none") // Hiding button tooltip 
                filterButtonForColumnChart.style("cursor","pointer") // changing mouse pointer
                
                searchDivForColumnChart.style("display","block") // Showing filter panel
                settingPanelDivForColumnChart.style("display","none") //Hiding setting panel

                //svgPanelForColumnChart.attr('width', 100 + "%") .attr('height', 52 + "%") .attr("top",8 + "%") .style("position","absolute") //Decreasing chart SVG height

            if(options.showTitle == true){
            
                svgPanelForColumnChart.style('width', 100 + "%") .style('height', 52 + "%")  .attr("top",8 + "%").style("background-color", options.BGcolor).style("position","absolute"); 

            }
            else if(options.showTitle == false){
           
                svgPanelForColumnChart.style('width', 100 + "%") .style('height', 52 + "%") .attr("top",0 + "%") .style("background-color", options.BGcolor).style("position","absolute"); 

            }

                resizedFuctionForColumnChart();
				
        }) //filterChartButton.on('click', function() )
        
        // showing/hidding chart comment panel
        commentsBtnForColumnChart.on('click', function() {

            if(options.showComments == false){ 
                options.showComments = true;
            }
            else if(options.showComments == true){ 
                options.showComments = false;
            }

            isFilterClickedForColumnChart = false; 
            
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){
                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                    options.showTable = false;
                }
            }
            acinfotech.columnChart(targetElement,options)

        })
        
        downloadBtnForColChart.on('click', function() {
                                  
              ismenuButtonOfColumnChartClicked = false; // Changing menu button value to false
              optionsButtonPanelForColumnChart.style("display","none") // Hiding option buttons panel
              
              changeXAndYAxisValuesPanelForColumnChart.style("display","none") // Hiding edit X & Y axis panel
              
              iconButtonTooltip.style("display","none") // Hiding button tooltip
              filterButtonForColumnChart.style("cursor","pointer") // changing mouse pointer
              
              searchDivForColumnChart.style("display","none") // Showing filter panel
              settingPanelDivForColumnChart.style("display","none") //Hiding setting panel
                                  
              //downloadOptionsPanelDiv.style("display","block")
                                  
        })
        
        
        // Creating DIV for holding Search Table (Temporary Table) when Search button is clicked.
        var tempDivTableForColumnChart;
        var isSearchInTableButtonClicked = false;
        var canBtnForSearchTableForColumnChart;
        // Creating left panel for holding Search Box and small Column Chart and on RHS Search Table (Temporary Table) when Search button is clicked.
        searchChartButton.on('click', function() {
            
            ismenuButtonOfColumnChartClicked = false
            optionsButtonPanelForColumnChart.style("display","none")

            isSearchInTableButtonClicked = true;

            // Div for disabling whole Chart and Main Table expect Search panel and Search Table
            var disabledDivForColumnChartForSearchTable = targetElement.append('div').style('width',100 + "%").style('height',100 + "%").style('position','absolute')
            .style("background-color",'#f3f3f3').style("z-index",2).style("display","none").style('top', 0.0 + "%").style('left', 0.0 + "%")
            .style("opacity",0.3).style("min-width","350px").style("min-height","350px") //005ec4

            //Creaing panel for holding Search Box and small Column Chart
            var searchDivForColumnChartForSearchTable = targetElement.append('div').style('width',100 + "%").attr("class", "searchDivForColumnChartForSearchTableClass" + targetElement[0][0].id)
            .style('height',52 + "%") .style('position','absolute') .style('margin-left', "0px") .style("background-color",'#ffffff')
            .style("z-index",90) .style("border-color", "#ffffff") .style("display","block") .style('top', 60.0 + "%")
            .style('height', 40.0 + "%") .style("border-top","1px solid #f0f0f0").style('overflow',"hidden")
            
            // Title for Search panel
            var searchDivForColumnChartForSearchTableTitle = searchDivForColumnChartForSearchTable.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif").style("font-weight", "Bold")
            .style('margin-left','0px').style('margin-top','20px').style('text-indent','3px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
            .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000").style("font-family","Verdana,sans-serif").style("font-weight","Bold").style("display","none")
            .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter;  color:#00001c; font-weight:Bold;">'+ "Search" +'</div>')

            // DIV for holding small Column-Chart
            var smallChartAreaDivForColumnChart = searchDivForColumnChartForSearchTable.append('div').style('width',100 + "%").style('height',100 + "%").style('position','absolute')
            .style("background-color",'#ffffff').style("z-index",2).style("display","block").style('top', 0.0 + "px").style('left', 0.0 + "px")
            .style("opacity",1.0).attr("id","smallColumnChartIDForColumnChart" + targetElement[0][0].id)

            // DIV for holding Search Table
            tempDivTableForColumnChart = targetElement.append('div').style('width',100 + "%").style('height', 60.0 + "%").style('top', 0.0 + "%")
            .style('position','absolute').style('margin-left', "0px") .style("background-color",'#ffffff') .style("z-index",90)
            .style("border-color", "#ffffff") .style("display","block")
            
            // Title DIV for Search Table
            var searchResultTableDivTitleForColumnChart = tempDivTableForColumnChart.append('div').style('background-color',"#e9e9e9").attr("fant-family", "Verdana,sans-serif").style("font-weight", "Bold")
            .style('margin-left','0px').style('margin-top','0px').style('text-indent','3px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
            .style("width","100"+"%").style("height","15" + "%").style("color","#00001c")

            // Search Text Box for Search panel
            var searchTextBoxForColumnChart = searchResultTableDivTitleForColumnChart.append('input').style("width","220px").style('margin-left','1px').style('margin-top','2px')
            .style('position',"absolute").style('height',"26px").style("border", "1.0px") .style("border-color", "#e2e2e2") .style("border-style", "solid").style('text-indent','30px')
            .attr("placeholder","eg: sales").attr("id","autoSearchTextBoxForColumnChart" + targetElement[0][0].id).style("box-sizing","border-box")
            .style("background-image","url('images/searchChart.png')").style("background-repeat","no-repeat") .style("background-size",'18px 18px')
            .style("background-position",'5px 3px') .style("display","block") .style("font-size","14px").style("font-weight","Normal")
            .style("line-height","Normal") .style('outline-width','0px')

            canBtnForSearchTableForColumnChart = searchResultTableDivTitleForColumnChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
            .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
            .style('background-color',"#e9e9e9")
            .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
            .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
            var cancelBtnImgVar = document.createElement("IMG");
            cancelBtnImgVar.src = "images/closeIcon.png";
            cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.88; background-color:#e9e9e9")
            canBtnForSearchTableForColumnChart[0][0].appendChild(cancelBtnImgVar)

            // Enabling whole Chart and Table and removing Search panel and Search Table, when Cancel button of Search panel is called.
            canBtnForSearchTableForColumnChart.on('click', function() {
				
                searchDivForColumnChartForSearchTable.remove();
                tempDivTableForColumnChart.remove()

                d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
                for(var i = 0; i<divAndChartsArray.length; i++){
                    if(targetElement[0][0].id === divAndChartsArray[i].divID){
                        options.data = divAndChartsArray[i].optionsData
                    }
                }
                acinfotech.columnChart(targetElement,options)

            })
            
            // DIV for holing only Search Table
            var searchResultTablePanelForColumnChart =  tempDivTableForColumnChart.append("div")
            .attr("class", "searchResultTablePanelForColumnChart" + targetElement[0][0].id) .style('background-color',"#ffffff")
            .style('position','absolute') .style("display","block") .style("overflow","auto") .style("width", function(d) {  return 100.0 + "%"; }) 
            .style("height", function(d) { return 85 + "%"; }) .style("top","15"+"%") .style("left",0 + "%")
            
            // Creating Table (Search Table)
            searchResultTablePanelForColumnChart.html('<table  border="0px" style=" width:99.9%; height:auto;   position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9px; border-collapse:collapse; border-color:#ebf5e6; " >'+
              '<thead  style="background-color:#DFF0D8;">' +'</thead>'+
              '<tbody class="myTBody" style="background-color:white; width:99.9%; height:auto;  ">'+'</tbody>'+
              '</table>'
              )
            searchResultTablePanelForColumnChart.select("table").attr("id","searchTableIdForColumnChart" + targetElement[0][0].id)

            // Setting colors for Search Column-bars
            var colors = d3.scale.ordinal() .range(["#ff6c3e", "#ffbb03", "#3fcb56", "#d05767", "#55bf9b", "#0095b3", "#7a92a9","#663399","#29b5eb","#ff9878","#CCCCCC","#008d8d"]);

            var thead = searchResultTablePanelForColumnChart.select("thead").selectAll("th") .data(d3.keys(newJson[0]))
            .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1) + " "}).style("min-width","100px").style("color","#00001c")
        
            var tr = searchResultTablePanelForColumnChart.select("tbody").selectAll("tr") .data(newJson).enter().append("tr") //.style("background-color",function(d,i){  return colors(i);})
        
            var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d})
            .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")

            // Filtering the Search Table 
            $(document).ready(function(){
                var tblBodyObj = document.getElementById("searchTableIdForColumnChart" + targetElement[0][0].id).tBodies[0];
                
                for (var i=0; i<tblBodyObj.rows.length; i++) {

                    var newCell = tblBodyObj.rows[i].insertCell(-1);
                    newCell.style.minWidth = "20px";
                    newCell.style.maxWidth = "20px";
                    newCell.style.textAlign = "left"
                   
                    var div = document.createElement('div')
                    div.style.width = "15px";
                    div.style.height = "35%";
                    div.style.borderRadius = "0px";
                    div.style.opacity = 0.9;
                    div.style.minWidth = "15px"
                    div.style.maxWidth = "15px"
                    div.style.background = colors(i);
                    newCell.appendChild(div);
                }   
            });

            // Styling the Search Table Rows.
            searchResultTablePanelForColumnChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
            .style("color","#00001c").style("height","25px").style("border", "1px solid #e9e9ea").style("background-color","#f6f6f6") 
            searchResultTablePanelForColumnChart.selectAll('td').style("height","25px") .style("border", "1px solid #f8f8f8") .style("font-size","12px").style("font-weight","Normal") .style("color","#00001c")
        
            // Calling smallColumnChart with orignal data and limited options.
            var chartElement = d3.select("#smallColumnChartIDForColumnChart" + targetElement[0][0].id);
            var smallColumnChartoptions = {
                           data: options.data,
                           BGcolor:options.BGcolor,
                           keys: {
                               label: options.keys.label,
                               value: options.keys.value
                           },
                           xAxisLable: options.keys.label,
            }
            acinfotech.smallColumnChart(chartElement,smallColumnChartoptions)    

                // Array to hold searched items (full object)
                var searchTextBoxArrayForColumnChart = [];

                $(document).ready(function(){
                    $("#" + "autoSearchTextBoxForColumnChart" + targetElement[0][0].id).off('input');
                    $("#" + "autoSearchTextBoxForColumnChart" + targetElement[0][0].id).on('keyup', function(){
                        textChangedFunction(this.value)
                    });
                });
                 
                 // function to search data in original set of data with Search Box entered value.
                 function textChangedFunction (val) {
                    var textBoxValueLowerCased = val //this.value
                    searchTextBoxArrayForColumnChart = [];
                    
                    newJson.forEach(function(d, i) { //
                        var dd = d3.values(d);
                        var eachObjectArray = [];
                        eachObjectArray.push(d3.values(d))
                        d[options.keys.value] = d[options.keys.value].toString();
                
                    for(var i = 0; i<Object.keys(d).length; i++){
                        var lower = d3.values(d)[i].toString().toLowerCase()
                        if ( lower.toLowerCase().indexOf(textBoxValueLowerCased.toLowerCase()) > -1 ) {
                            searchTextBoxArrayForColumnChart.push(d)
                            break;
                        }
                    }
                });

                // clearing smallColumnChart DIV each time a keyboard key is hit.
                smallChartAreaDivForColumnChart.selectAll("*").remove();    
                var chartElement = d3.select("#smallColumnChartIDForColumnChart" + targetElement[0][0].id);
                var smallColumnChartoptions = {
                           data: searchTextBoxArrayForColumnChart,
                           BGcolor:options.BGcolor,
                           keys: {
                               label: options.keys.label,
                               value: options.keys.value
                           },
                           chartTitle:"",
                           xAxisLable: options.keys.label,
                        }
                if(searchTextBoxArrayForColumnChart.length == 0){
                    smallChartAreaDivForColumnChart.selectAll("*").remove();     
                }
                else {
                    acinfotech.smallColumnChart(chartElement,smallColumnChartoptions)    
                }
            
            // Removing the Search Table Rows
            var table = searchResultTablePanelForColumnChart.select('table');
            var rows = table.selectAll('tr')
            rows.remove();

            // Creating new Rows for Search Table based on Searched Result (using searchTextBoxArrayForPieChart array)
            var table = searchResultTablePanelForColumnChart.select('table');
            var rows = table.selectAll('tr').data(searchTextBoxArrayForColumnChart);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})

            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition()
            .delay(20) .duration(20) .style('opacity', 1.0) .style("color","#00001c");
            
            cells.text(function(d,i) {return d});

            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(20) .duration(20) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})

            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(20)
            .duration(20) .style('opacity', 1.0) .style("color","#00001c");

            // Adding new row for color dots in Search Table
            $(document).ready(function(){
                
                for (var i=0; i<table[0][0].rows.length; i++) {

                    var newCell = table[0][0].rows[i].insertCell(-1);
                    newCell.style.minWidth = "20px";
                    newCell.style.maxWidth = "20px";
                    newCell.style.textAlign = "left"
                   
                    var div = document.createElement('div')
                    div.style.width = "15px";
                    div.style.height = "35%";
                    div.style.borderRadius = "0px";
                    div.style.opacity = 0.9;
                    div.style.minWidth = "15px"
                    div.style.maxWidth = "15px"
                    div.style.background = colors(i);
                    newCell.appendChild(div);
                }
            });

            var t = document.getElementById("searchTableIdForColumnChart" + targetElement[0][0].id).tBodies[0]
            
            cells_in_new_rows.text(function(d,i) {return d});

            rows.exit() .attr('class', 'exit') .transition() .delay(20) .duration(20) .style('opacity', 0.0) .remove();

            // Checking the Browser
            if(navigator.userAgent.indexOf("Firefox") != -1 ) 
            {
                table.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("text-align","left").style("padding-left","6px").style("color","#00001c")
                .style("height","25px") .style("border", "1px solid #b1da9f") 
            
                searchResultTablePanelForColumnChart.selectAll('td').style("height","25px") .style("border", "1px solid #ffffff") .style("font-size","12px").style("padding-left","6px")
                .style("font-weight","Normal").style("color","#00001c")
            }

            else{
                searchResultTablePanelForColumnChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("text-align","left").style("padding-left","6px").style("color","#00001c")
                .style("height","25px") .style("border", "1px solid #e9e9ea").style("background-color","#f6f6f6")  
            
                searchResultTablePanelForColumnChart.selectAll('td').style("height","25px") .style("border", "1px solid #f8f8f8") .style("font-size","12px").style("padding-left","6px")
                .style("font-weight","Normal").style("color","#00001c")
            }

        }//textChangeFunction ends here
            
            // Disabling Browser page scrolling when Search left panel appears
            $( '.searchDivForColumnChartForSearchTableClass' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
                var e0 = e.originalEvent,
                delta = e0.wheelDelta || -e0.detail;
    
                this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
                e.preventDefault();
            });

            // Disabling Browser page scrolling when Search Table appears
            $( '.searchResultTablePanelForColumnChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
                var e0 = e.originalEvent,
                delta = e0.wheelDelta || -e0.detail;
    
                this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
                e.preventDefault();
            });

            // Removing options button ToolTip, changing mouse pointer
            iconButtonTooltip.style("display","none")
            
            searchDivForColumnChartForSearchTable.style("display","block")//.transition().style('width', 260 + "px").duration(50).delay(50)

            if(options.showTitle == false){
            }
            else if(options.showTitle == true){
            }

            //searchDivForColumnChartForSearchTable.style("border-right", "solid #c1e2b3  1px").style("overflow-y","scroll")

        }) //searchChartButton.on('click', function()

        // Creating icon tool tip
        var iconButtonTooltip = targetElement.append('div').style('width','240px') .style('height',"25px").style('position','absolute')
        .style("background-color",'#404040 ') .style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") 
        .style("border-style", "solid") .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none")

        pieButtonForColumnChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var columnChartButtonTooltipText = "Switch to Pie Chart";
            
            iconButtonTooltip.style("width","122px").style("margin-left", (m[0] - 132) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ columnChartButtonTooltipText +'</div>')
        })
        pieButtonForColumnChart.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        donutButtonForColumnChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var doNutChartButtonTooltipText = "Switch to Donut Chart";
            
            iconButtonTooltip.style("width","137px").style("margin-left", (m[0] - 147) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ doNutChartButtonTooltipText +'</div>')
        })
        donutButtonForColumnChart.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        horButtonForColumnChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var horizontalChartButtonTooltipText = "Switch to Horizontal Chart";
            
            iconButtonTooltip.style("width","160px").style("margin-left", (m[0] - 170) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ horizontalChartButtonTooltipText +'</div>')
        })
        horButtonForColumnChart.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        refreshButtonForColumnChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var refreshButtonTooltipText = "Refresh";
            
            iconButtonTooltip.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ refreshButtonTooltipText +'</div>')
        })
        refreshButtonForColumnChart.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        filterButtonForColumnChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var filterButtonTooltipText = "Filter";
            
            iconButtonTooltip.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')
        })
        filterButtonForColumnChart.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        searchChartButton.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var reloadButtonTooltipText = "Search";
            
            iconButtonTooltip.style("width","60px").style("margin-left", (m[0] - 70) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ reloadButtonTooltipText +'</div>')
        })
        searchChartButton.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        editChartButton.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var reloadButtonTooltipText = "Change X-Axis and Y-Axis";
            
            iconButtonTooltip.style("width","160px").style("margin-left", (m[0] - 170) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ reloadButtonTooltipText +'</div>')
        })
        editChartButton.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        tableButtonForColumnChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                if(showOrHideTableForColumnChart == false){
                    var tableButtonTooltipText = "Show Table";
                }
                else if(showOrHideTableForColumnChart == true){
                    var tableButtonTooltipText = "Hide Table";
                }
            
            
            iconButtonTooltip.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ tableButtonTooltipText +'</div>')
        })
        tableButtonForColumnChart.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        settingBtnForColChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var reloadButtonTooltipText = "Settings";
            
            iconButtonTooltip.style("width","67px").style("margin-left", (m[0] - 77) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ reloadButtonTooltipText +'</div>')
        })
        settingBtnForColChart.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })
        
        downloadBtnForColChart.on('mousemove', function(d,i) {
             var root = targetElement
             var m = d3.mouse(root.node());
             m[0] += 0
             m[1] += 0
             var downloadButtonTooltipText = "Download";
             
             iconButtonTooltip.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
             iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
        })
        downloadBtnForColChart.on('mouseout', function(d,i) {
             iconButtonTooltip.style("display","none")
        })
        
        commentsBtnForColumnChart.on('mousemove', function(d,i) {
            commentsPanelDivForColumnChart.style('background-color','#fafafa')
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                if(options.showComments == false){
                    var commentButtonTooltipText = "Show Comments";
                }
                else if(options.showComments == true){
                    var commentButtonTooltipText = "Hide Comments";
                }
            
            
            iconButtonTooltip.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ commentButtonTooltipText +'</div>')
        })
        commentsBtnForColumnChart.on('mouseout', function(d,i) {
            commentsPanelDivForColumnChart.style('background-color','#ffffff')
            iconButtonTooltip.style("display","none")
        })

        menuButtonForColumnChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var reloadButtonTooltipText = "Menu";
            
            iconButtonTooltip.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ reloadButtonTooltipText +'</div>')
        })
        menuButtonForColumnChart.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        // ----------------- Changing X-Axis and Y-Axis values panel and everything within it section begins here ----------------
        var changeXAndYAxisValuesPanelForColumnChart = targetElement.append('div').style('width',350 + "px") .attr("id","changeXAndYAxisValuesPanelForColumnChartClass" + targetElement[0][0].id)
        .style('height',52 + "%").style('position','absolute').style('margin-left', "0px") .style("background-color",'#fefefe').style("z-index",11)
        .style("border-color", "#ffffff").style("border-right", "solid #e5e5e5 1px")  .style("border-style", "solid") .style("box-shadow", "0px 0px 0px #eff8ec")
        .style("display","none").style("border-top", "solid #fdfdfd 1px").style("border-left","0px").style("border-bottom", "0px")
        .style('top', 0.0 + "%").style('height', 100.0 + "%").style('overflow-y',"scroll").style("overflow-x","hidden").style('box-sizing','border-box')

        var changeXAndYAxisValuesPanelForColumnChartTitle = changeXAndYAxisValuesPanelForColumnChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','20px').style('text-indent','5px').style("font-size", "14px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #007aff").style("width","350px").style("color","#00001c")
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; top:25.0%; font-size:14px; font-family:inter; color:#00001c;">'+ "Change X-Axis and Y-Axis" +'</div>')

        var measuresColumnTitle = changeXAndYAxisValuesPanelForColumnChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter;  color:#00001c; font-weight:Normal; text-align:left; text-indent:3px;">Available Measures</div>');

        var dimensionColumnTitle = changeXAndYAxisValuesPanelForColumnChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '203px')
        .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter;  color:#00001c; font-weight:Normal; text-align:left; text-indent:3px;">Available Dimensions</div>');

        var measuresVariables = changeXAndYAxisValuesPanelForColumnChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable1"+targetElement[0][0].id)
        .style("list-style-type","none")
        .style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '78px')
        .style('position','absolute')
        .style("width","155px").style("min-height","100px").style("max-height","100px").style("border", "#f0f0f0 1px solid")
        .style("max-width","155px").style("overflow-x","hidden").style("overflow-y","auto")
        measuresVariables.style("left",0.0 + "px").style("padding","2px")

        var dimesionsColumnsPanel = changeXAndYAxisValuesPanelForColumnChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable2"+targetElement[0][0].id)
        .style("list-style-type","none").style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '220px')
        .style('position','absolute').style("width","155px").style("min-height","100px").style("max-height","100px").style("border", "#f0f0f0 1px solid")
        .style("max-width","155px").style("overflow-x","hidden").style("overflow-y","auto")
        dimesionsColumnsPanel.style("left",0.0 + "px").style("padding","2px")

        $( "#changeXAndYAxisValuesPanelForColumnChartClass" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });


        var measuresArray = [];
        var dimensionArray = [];

        var measuresArrayLength = [];
        var dimensionsArrayLength = [];

        $.each(options.data,function(i,v){

        var object={};
            $.each(v,function(i1,val1){
                if((($.isNumeric(val1))) || (val1 == null) ){
                    object[i1]=val1
                    measuresArray.push(i1);
                }
                else {
                     //if (!/[^a-z _A-Z]/.test(val1)){
                        dimensionArray.push(i1);
                    //}
                }
            });
        });
        
        var uniqueMeasuresArrayKeys = [];
        $.each(measuresArray, function(i, el){
            if($.inArray(el, uniqueMeasuresArrayKeys) === -1){
                uniqueMeasuresArrayKeys.push(el);
            }
        });

        var uniqueDimensionArrayKeys = [];
        $.each(dimensionArray, function(i, el){
            if($.inArray(el, uniqueDimensionArrayKeys) === -1){
                uniqueDimensionArrayKeys.push(el);
            }
        });
        
        // setting lenght for arrays
        for(var i = 0; i<uniqueMeasuresArrayKeys.length; i++){
            measuresArrayLength.push(i);
        }

        for(var i = 0; i<uniqueDimensionArrayKeys.length; i++){
            dimensionsArrayLength.push(i);
        }

        var measuresVariables1 = measuresVariables.selectAll("li") 
        .data(measuresArrayLength)
        .enter()
        .append("li")
        .style("width","130px") .style("max-height","22px").style("cursor","move")
        .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#bcf1bc").style("font-weight","Normal")
        .style("list-style-type","none").style("border","1px #89e789 solid").style("color","#006600").style("font-family","Verdana,sans-serif")
        .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
        .text(function(d) {return uniqueMeasuresArrayKeys[d]})
        measuresVariables1.attr("class","MeasuresClass"+targetElement[0][0].id)
        
        var dimesionsColumns = dimesionsColumnsPanel.selectAll("li") 
        .data(dimensionsArrayLength)
        .enter()
        .append("li")
        .style("width","130px") .style("max-height","22px").style("cursor","move")
        .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#f8e9cd").style("font-weight","Normal")
        .style("list-style-type","none").style("border","1px #f2d199 solid").style("color","#9e6c14").style("font-family","Verdana,sans-serif")
        .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
        .text(function(d) {return uniqueDimensionArrayKeys[d]})
        dimesionsColumns.attr("class","DimesionsClass"+targetElement[0][0].id)

        var measuresColumnReceivedUI_TableTitle = changeXAndYAxisValuesPanelForColumnChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','170px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter;  color:#00001c; font-weight:Normal; text-align:left; ">Selected Measure</div>');

        var measuresColumnReceivedUI_Table = changeXAndYAxisValuesPanelForColumnChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable3"+targetElement[0][0].id)
        .style('background-color',"#ffffff").style('margin-left','170px').style('margin-top', '78px')
        .style("width","155px").style('position','absolute').style("padding","2px").style("min-height","100px")
        .style("border","1px #c1c1c1 dashed") .style("max-height","60px") .style("overflow-x","hidden") .style("overflow-y","auto")
        //.html('<div class=unsortable  style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:65.0%; font-size:14px; font-family:inter;  color:#99ea99; font-weight:Normal; text-align:center;">Drag and Drop Measures here from Available Measures List. </div>');
        .html('<img class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' src="images/dragIcon.png" style=" width:36px; height:36px; position:absolute; margin-left:65px; margin-top:15px; opacity:0.6"/>' 
        + '<div class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:65.0%; font-size:12px; font-family:inter;  color:#89d289; font-weight:Normal; text-align:center;">Drop Measure for Y-Axis. </div>');
        //.html('<div style="background-image: url(images/dragIcon.png); height: 64px; width: 64px; border: 1px solid black;"> </div>');

        var dimensionColumnReceivedUI_TableTitle = changeXAndYAxisValuesPanelForColumnChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','170px').style('margin-top', '203px')
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter;  color:#00001c; font-weight:Normal; text-align:left; ">Selected Dimension</div>');

        var dimensionColumnReceivedUI_Table = changeXAndYAxisValuesPanelForColumnChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable4"+targetElement[0][0].id)
        .style('background-color',"#ffffff").style('margin-left','170px').style('margin-top', '220px')//.style("list-style-type","none")
        .style("width","155px").style("max-width","300px").style('position','absolute').style("padding","2px").style("min-height","100px")
        .style("border","1px #c1c1c1 dashed") .style("max-height","60px") .style("overflow-x","hidden") .style("overflow-y","auto")
        .html('<img class=unMoveableIconAndTextClassDimensions'+targetElement[0][0].id+' src="images/dragIcon.png" style=" width:36px; height:36px; position:absolute; margin-left:65px; margin-top:15px; opacity:0.6;"/>' 
        + '<div class=unMoveableIconAndTextClassDimensions'+targetElement[0][0].id+' style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:65.0%; font-size:12px; font-family:inter;  color:#d8b479; font-weight:Normal; text-align:center;">Drop Dimension for X-Axis. </div>');

        var cancelButton = changeXAndYAxisValuesPanelForColumnChart.append("div") .style("width","22px").style("height","21px").style('position','absolute')
        .style('margin-left','308px').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
        .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.9; background-color:#fcfcff")
        cancelButton[0][0].appendChild(cancelBtnImgVar)

        cancelButton.on("click", function(){
            changeXAndYAxisValuesPanelForColumnChart.style("display","none")
        })

        var reRenderChartAndTableButton = changeXAndYAxisValuesPanelForColumnChart.append("button").style("width","120px").style("height","25px").style('position','absolute')
        .style('margin-left','105px').style('margin-top','350px') .style("border-style", "none").style('background-color',"#2196f3")
        .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','15px').style("border-style", "solid").style('color','#ffffff')
        .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 1px #9b9b9b").style("border-radius","0px")
        var textForReRenderButton = document.createTextNode("Apply Changes");
        reRenderChartAndTableButton[0][0].appendChild(textForReRenderButton)

        reRenderChartAndTableButton.on("click", function(){
            
            if(
                ( $("#sortable3"+targetElement[0][0].id).children("li").length == 0) || 
                ( $("#sortable4"+targetElement[0][0].id).children("li").length == 0) || 
                ( 
                  ($("#sortable3"+targetElement[0][0].id).children("li").length == 0) && 
                  ($("#sortable4"+targetElement[0][0].id).children("li").length == 0) 
                )
            ){
                var alertPageDisabledDivForColumnChart =targetElement.append('div').style('width',100 + '%')
                .style('height',100 + "%").style('position','absolute').style('margin-left', '0px').style('top', '0px')
                .style("background-color",'#f3f3f3').style("z-index",99)//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("opacity",0.2).style("display","block")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")

                var alertDivForColumnChart = targetElement.append('div').style('width','350px')
                .style('height',"150px").style('position','absolute').style('left', ((targetElement[0][0].clientWidth/2) - 175) + "px").style('top', '1px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "solid").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","0px")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
                //.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Bold;">Sorry, no result found for selected' + 'range!'+ '</br>' + '<label style=text-indent:10px;> Hello</label' +'</div>')
                .html('<p  style="width: 340px; height:0%; background-color:#c7c7c7; position: absolute; top:40.0%; font-size:14px; font-family:inter; font-weight:Bold; margin-left:10px;  color:#f8f8f8; font-weight:Normal;">Check whether the Selected Measure or Selected Dimension box is not empty!</p>')

                var alertDivTitleForColumnChart = alertDivForColumnChart.append('div').style('width','340px')
                .style('height',"30px").style('position','absolute').style('margin-left', "0px").style('top', '0px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "none").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","2px")
                .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; font-weight:Bold; text-indent:5px;  color:#e5e5e5; font-weight:Normal;">TimeBound</div>')

                var columnChartAlertOKButton = alertDivForColumnChart.append("button") .style("width","40px") .style("height","20px") .style('position','absolute') .style("box-shadow", "0px 1px 1px #B8B8B8") 
                .style('background-color',"#7cc15e") .style('margin-left','300px') .style('top', "120px").style("color","#ffffff")
                .style("display","block").style('padding-top',"0px").style("cursor","pointer").style("box-shadow", "1px 1px 1px #56973a") .style("border-style", "none")
                .style("font-family","Verdana,sans-serif").style("font-size","14px").style("text-align","center").style("vertical-align","middle").style("border-radius","0px")
                .style("z-index",999)
            
                var textForColumnChartAlertOKButton = document.createTextNode("OK");
                columnChartAlertOKButton[0][0].appendChild(textForColumnChartAlertOKButton)

                $("#"+targetElement[0][0].id).resizable('disable');

                columnChartAlertOKButton.on('click', function() {
                    alertDivForColumnChart.remove();
                    alertPageDisabledDivForColumnChart.remove()
                    $("#"+targetElement[0][0].id).resizable('enable');
                })

                filterButtonForColumnChart.style("cursor","pointer")
                disabledDivForColumnChart.style("display","none")
                searchDivForColumnChart.style("display","none")//.transition().style('width', 0 + "px").duration(200).delay(50)
            
                if(showOrHideTableForColumnChart == false){ 
                    svgPanelForColumnChart.attr('width', 100 + "%") .attr('height', 85 + "%").style("position","absolute");
                }
                else if(showOrHideTableForColumnChart == true){ 
                    svgPanelForColumnChart.attr('width', 100 + "%") .attr('height', 52 + "%").style("position","absolute")
                } 

                resizedFuctionForColumnChart();
            }
            else{

                var newOptions = {
                   data: options.data,
                   dataForTable: options.dataForTable,
                   isDataDetailedForTable: options.isDataDetailedForTable,
                   keys: {
                       label: $("#sortable4"+targetElement[0][0].id).children("li")[0].textContent.toString(),
                       value: $("#sortable3"+targetElement[0][0].id).children("li")[0].textContent.toString()
                   },
                   chartTitle:options.chartTitle,
                   xAxisLable: $("#sortable4"+targetElement[0][0].id).children("li")[0].textContent,
                   yAxisLable: $("#sortable3"+targetElement[0][0].id).children("li")[0].textContent,
                   dimensions: options.dimensions,
                   measures: options.measures,
                   showTitle: true,
                   colorSet: options.colorSet,
                   BGcolor:options.BGcolor,
                   series:options.series,
                   legend:options.legend,
                   drillDownColumnName:options.drillDownColumnName,
                   showTable: options.showTable,
                   showComments: options.showComments,
                   comments: options.comments,
                   resizeButtonID: options.resizeButtonID //document.getElementById("resizeBtn").id
                }
                        
                d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                acinfotech.columnChart(targetElement,newOptions)
            }
        })

        var textBoxForMeasureColumnFrom;
        var textBoxForMeasureColumnTo;
        var selectTitleDivForEachDimension;

       
        $( "ul.droptrue"+targetElement[0][0].id ).sortable({
            appendTo: document.body,
            helper: "clone",
            connectWith: ".droptrue"+targetElement[0][0].id,
            scroll: false,
            cancel: '.unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+','+' .unMoveableIconAndTextClassDimensions'+targetElement[0][0].id,
            revertDuration: 10,
            scrollSensitivity: 10,
            scrollSpeed: 1,
            dynamic: true,

            receive: function(e, ui) { 
                 
                if (($(this)[0].id == "sortable3"+targetElement[0][0].id) || ($(this)[0].id == "sortable1"+targetElement[0][0].id)) {

                        if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                            if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                                 (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                            }
                            else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                                (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                            }

                        }
                } // if (($(this)[0].id == "sortable3") || ($(this)[0].id == "sortable1")) 

                else if (($(this)[0].id == "sortable2"+targetElement[0][0].id) || ($(this)[0].id == "sortable4"+targetElement[0][0].id)) {
                    if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                            //ui.sender.sortable("cancel");

                            if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                                 (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                            }
                            else if(  ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                                (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                            }
                        }
                } //if (($(this)[0].id == "sortable2") || ($(this)[0].id == "sortable4")) {

                $(ui.item).css({ 'position': 'relative' });

                if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                    ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                }
                 
                else if ($(this)[0].id == "sortable3"+targetElement[0][0].id) { // checking if the dropped element is in Measures drop area
                    
                    if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                        ui.sender.sortable("cancel");
                    }
                    else {
                        ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                    }

                } // else if ($(this)[0].id == "sortable3") // checking if the dropped element is in Measures drop area ends here.

                else if ($(this)[0].id == "sortable4"+targetElement[0][0].id) { // checking if the dropped element is in Dimension drop area

                    if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                        ui.sender.sortable("cancel");
                    }
                    else {
                        ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                    }
                } //else if ($(this)[0].id == "sortable4")  // checking if the dropped element is in Dimension drop area ends here

                    if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                        
                        if ($(this)[0].id == "sortable1"+targetElement[0][0].id){
                            if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                            
                                if( ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                                    ui.sender.sortable("cancel");
                                } // if(  ui.sender.attr("id") === "sortable4")

                                else if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                                    ui.sender.sortable("cancel");
                                }
                            
                            } // if(ui.item.hasClass("DimesionsClass"))
                        }
                    if ($(this)[0].id == "sortable2"+targetElement[0][0].id){
                        if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                            
                            if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                                ui.sender.sortable("cancel");
                            }
                            else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                                ui.sender.sortable("cancel");
                               
                            }
                        }
                    }

                } //if ($(this)[0].id == "sortable1")

                if ( ($(this)[0].id == "sortable3"+targetElement[0][0].id) || ($(this)[0].id == "sortable4"+targetElement[0][0].id) ){
                    if ($(this).children('li').length > 1 ){
                        ui.sender.sortable("cancel");
                        ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                    }    
                }
                
            }, //receive ends here

            start:function(ev, ui) {
                
            },
            stop:function(ev, ui) {
               
            },
        });
      
        /* ----------------- Changing X-Axis and Y-Axis values panel and everything within it section ends here -----------------*/

        /* ----------------- Creating filter panel and everything within it begins below ----------------- */

        // Getting min and max value from options.data
        var minAndMaxValuesArrayForColumnChart = []
            newJson.forEach(function(d, i) {
                var dd = parseFloat(d[options.keys.value])
                minAndMaxValuesArrayForColumnChart.push(dd) 
            });
        
        var low = d3.min(minAndMaxValuesArrayForColumnChart);
        var hig = d3.max(minAndMaxValuesArrayForColumnChart);

        var disabledDivForColumnChart = targetElement.append('div').style('width',targetElement[0][0].clientWidth + "px").style('height',targetElement[0][0].clientHeight + "px").style('position','absolute')
        .style("background-color",'#f3f3f3').style("z-index",2).style("display","none").style('top', 0.0 + "%").style('left', 0.0 + "%")
        .style("opacity",0.1).style("min-width","350px").style("min-height","350px") //005ec4

        // Creating filter panel
        var searchDivForColumnChart = targetElement.append('div').style('width',"100%").style('height',"40%")
        .style('position','absolute').style('margin-left', "0px").style('border-top',"1px solid #f0f0f0").style('border-bottom',"1px solid #e5e5e5")
        .style("background-color",'#fcfcff').style("z-index",90) //001c3b
        .style("display","none").style("overflow-x","auto").style("overflow-y","hidden")
        .style('top',"60%").style('height',"40%")

        $( '.filterDivForColumnChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        var searchDivForColumnChartTitle = searchDivForColumnChart.append('div').style('background-color',"#ffffff").attr("font-family", "Verdana,sans-serif")
        .style('margin-left','10px').style('margin-top','10px').style('text-indent','5px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","90%").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:15.5%; font-size:14px; font-family:inter; color:#00001c;">'+ "Filter by " + options.keys.value +'</div>')

        var sliderBarForColumnChart = searchDivForColumnChart.append('div').style('background-color',"#ffffff")
        .attr("id",targetElement[0][0].id + "columnChartRangeSliderID").style("width","215px").style('margin-top','87px').style('margin-left','39px').style('position',"absolute")
        .attr("class","sliderBarForPieChartClass")

        var cancelButtonForFilterPanel = searchDivForColumnChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
        .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid")
        .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.88; background-color:#fcfcff")
        cancelButtonForFilterPanel[0][0].appendChild(cancelBtnImgVar)

        cancelButtonForFilterPanel.on('click',function(d){

            searchDivForColumnChart.style("display","none");

            if(options.showTitle == true){
            
                if ((showOrHideTableForColumnChart == false) && (showOrHideCommentsForColumnChart == true)){
                    
                    svgPanelForColumnChart.style('width', 100 + "%") .style('height', 70 + "%") .style('top', 8 + "%") .style("background-color", options.BGcolor).style("position","absolute"); 
                }
                else if ((showOrHideTableForColumnChart == true) && (showOrHideCommentsForColumnChart == false)){
                    
                    svgPanelForColumnChart.style('width', 100 + "%") .style('height', 52 + "%") .style('top', 8 + "%").style("background-color", options.BGcolor) .style("position","absolute");
                }
                else if ((showOrHideTableForColumnChart == false) && (showOrHideCommentsForColumnChart == false)){
                     
                    svgPanelForColumnChart.style('width', 100 + "%") .style('height', 85 + "%") .style('top', 8 + "%") .style("background-color", options.BGcolor).style("position","absolute"); 
                }

            }
            else if(options.showTitle == false){
           
             if ((showOrHideTableForColumnChart == false) && (showOrHideCommentsForColumnChart == true)){
                    
                    svgPanelForColumnChart.style('width', 100 + "%") .style('height', 70 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForColumnChart == true) && (showOrHideCommentsForColumnChart == false)){
                    
                    svgPanelForColumnChart.style('width', 100 + "%") .style('height', 52 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForColumnChart == false) && (showOrHideCommentsForColumnChart == false)){
                    
                    svgPanelForColumnChart.style('width', 100 + "%") .style('height', 85 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }

            }
        

            resizedFuctionForColumnChart();
        })

        var textBoxOneForColumnChart = searchDivForColumnChart.append('input').style("width","80px").style('margin-left','15px').style('margin-top','50px')
        .style('position',"absolute").style('height',"22px").style("border", "1.0px") .style("border-color", "#e6e6e6") .style("border-style", "solid").style('text-indent','5px')
        .attr("value",d3.min(minAndMaxValuesArrayForColumnChart)).style("padding","0px").attr("disabled","disabled").style("color","#00001c")

        var toLableForColumnChart = searchDivForColumnChart.append('div').style('background-color',"#fcfcff").attr("fant-family", "Verdana,sans-serif").style("font-weight", "Bold")
        .style('margin-top','52px').style('margin-left','139px').style('position',"absolute").style("width","25px").style("height","15px")
        .style("box-shadow", "1px 1px 1px #ffffff")
        .html('<div  style="width: 100%; height:100%; background-color:#fdfdfd; font-size:12px; position: absolute;  font-family:inter;  color:#00001c; font-weight:Bold;">'+ "-to-"+'</div>')

        var textBoxTwoForColumnChart = searchDivForColumnChart.append('input').style("width","80px").style('margin-left','198px').style('margin-top','50px')
        .style('position',"absolute").style('height',"22px").style("border", "1.0px") .style("border-color", "#e6e6e6") .style("border-style", "solid")
        .style('text-indent','5px').attr("value",d3.max(minAndMaxValuesArrayForColumnChart)) .attr("disabled","disabled").style("color","#00001c")
        .style("padding","0px")

        var searchAndRenderButton = searchDivForColumnChart.append("button").style("width","147px").style("height","22px") .style('position','absolute')
        .style('margin-left','75px').style('font-size','12px').style('margin-top','110px').style("box-shadow", "0px 1px 2px #d9d9d9") .style("border-style", "none")
        .style('background-color',"#2196f3").style("color","#ffffff") // d8ebff
        .style('text-align','center').attr("id","123")
        var textForSearchAndRenderButton = document.createTextNode("Apply Filter")
        searchAndRenderButton[0][0].appendChild(textForSearchAndRenderButton)

        /* ------------------------------------ Filter panel and everything within it ends here --------------------------- */

        searchAndRenderButton.on('click', function() {
            searchedDataArray = [];
            //searchDivForColumnChart.style("display","none")
            var textBoxOneForColumnChartValue = parseFloat(textBoxOneForColumnChart[0][0].value) 
            var textBoxTwoForColumnChartValue = parseFloat(textBoxTwoForColumnChart[0][0].value)
            var toBeFetchedValue = options.keys.value
            
            textBoxOneForColumnChart.attr("value","")
            textBoxTwoForColumnChart.attr("value","")
            
            newJson.forEach(function(d, i) {
                
                if((+d[toBeFetchedValue] >= textBoxOneForColumnChartValue) && (+d[toBeFetchedValue] <= textBoxTwoForColumnChartValue) ){
                    searchedDataArray.push(d)
                }
            });
            
            if(searchedDataArray.length == 0){
                //alert("Sorry, no result found for this search!")

                var alertPageDisabledDivForColumnChart =targetElement.append('div').style('width',100 + '%')
                .style('height',100 + "%").style('position','absolute').style('margin-left', '0px').style('top', '0px')
                .style("background-color",'#f3f3f3').style("z-index",99)//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("opacity",0.2).style("display","block")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")

                var alertDivForColumnChart = targetElement.append('div').style('width','350px')
                .style('height',"150px").style('position','absolute').style('left', ((targetElement[0][0].clientWidth/2) - 175) + "px").style('top', '1px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "solid").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","0px")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
                //.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Bold;">Sorry, no result found for selected' + 'range!'+ '</br>' + '<label style=text-indent:10px;> Hello</label' +'</div>')
                .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Normal;">Sorry, no result found for selected range!</div>')

                var alertDivTitleForColumnChart = alertDivForColumnChart.append('div').style('width','340px')
                .style('height',"30px").style('position','absolute').style('margin-left', "0px").style('top', '0px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "none").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","2px")
                .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; font-weight:Bold; text-indent:5px;  color:#e5e5e5; font-weight:Normal;">TimeBound</div>')

                var columnChartAlertOKButton = alertDivForColumnChart.append("button") .style("width","40px") .style("height","20px") .style('position','absolute') .style("box-shadow", "0px 1px 1px #B8B8B8") 
                .style('background-color',"#7cc15e") .style('margin-left','300px') .style('top', "120px").style("color","#ffffff")
                .style("display","block").style('padding-top',"0px").style("cursor","pointer").style("box-shadow", "1px 1px 1px #56973a") .style("border-style", "none")
                .style("font-family","Verdana,sans-serif").style("font-size","14px").style("text-align","center").style("vertical-align","middle").style("border-radius","0px")
                .style("z-index",999)
            
                var textForColumnChartAlertOKButton = document.createTextNode("OK");
                columnChartAlertOKButton[0][0].appendChild(textForColumnChartAlertOKButton)

                $("#"+targetElement[0][0].id).resizable('disable');

                columnChartAlertOKButton.on('click', function() {
                    alertDivForColumnChart.remove();
                    alertPageDisabledDivForColumnChart.remove()
                    $("#"+targetElement[0][0].id).resizable('enable');
                })

                filterButtonForColumnChart.style("cursor","pointer")
                disabledDivForColumnChart.style("display","none")
                searchDivForColumnChart.style("display","none")//.transition().style('width', 0 + "px").duration(200).delay(50)
            
                 if(options.showTitle == true){
                                 
                     if ((showOrHideTableForColumnChart == false) && (showOrHideCommentsForColumnChart == true)){
                     
                         svgPanelForColumnChart.style('width', 100 + "%") .style('height', 70 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor);
                     }
                     else if ((showOrHideTableForColumnChart == true) && (showOrHideCommentsForColumnChart == false)){
                     
                         svgPanelForColumnChart.style('width', 100 + "%") .style('height', 52 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor);
                     }
                     else if ((showOrHideTableForColumnChart == false) && (showOrHideCommentsForColumnChart == false)){
                     
                         svgPanelForColumnChart.style('width', 100 + "%") .style('height', 85 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor);
                     }
                     
                 }
                 else if(options.showTitle == false){
                     
                     if ((showOrHideTableForColumnChart == false) && (showOrHideCommentsForColumnChart == true)){
                     
                         svgPanelForColumnChart.style('width', 100 + "%") .style('height', 70 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor);
                     }
                     else if ((showOrHideTableForColumnChart == true) && (showOrHideCommentsForColumnChart == false)){
                     
                         svgPanelForColumnChart.style('width', 100 + "%") .style('height', 52 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor);
                     }
                     else if ((showOrHideTableForColumnChart == false) && (showOrHideCommentsForColumnChart == false)){
                     
                         svgPanelForColumnChart.style('width', 100 + "%") .style('height', 85 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor);
                     }
                                 
                }
                                 
                                 
                 resizedFuctionForColumnChart();

            }
            else if(searchedDataArray.length > 0){
                d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                options.data = searchedDataArray;
                acinfotech.columnChart(targetElement,options)
            }

        })// searchAndRenderButton.on('click', function()) function ends here.

        function resetTableWidthOldDataFunction(){
            
            textBoxOneForColumnChart.attr("value",d3.min(minAndMaxValuesArrayForColumnChart))
            textBoxTwoForColumnChart.attr("value",d3.max(minAndMaxValuesArrayForColumnChart))

            thead.select('svg').select('#descendingIconIDForColumnChart').style("visibility", "visible")
            thead.select('svg').select('#ascendingIconIDForColumnChart').style("visibility", "visible")
            
            var table = tablePanelForColumnChart.select('table'); 
            var rows = table.selectAll('tr')
            
            tablePanelForColumnChart.select('table').selectAll('tr').style("background-color","#FFFFFF").style("color","#00001c")

            var table = tablePanelForColumnChart.select('table');
            var rows = table.selectAll('tr').data(newJson);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition()
            .delay(20) .duration(20) .style('opacity', 1.0) .style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(20) .duration(20) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(20)
            .duration(20) .style('opacity', 1.0) .style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(20) .duration(20) .style('opacity', 0.0) .remove();

        } // function sortTableFunc() ends here.

        function searchDataTableFunc(){
            
            var table = tablePanelForColumnChart.select('table');
            var rows = table.selectAll('tr').data(searchedDataArray);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition()
            .delay(200) .duration(200) .style('opacity', 1.0) .style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(200) .duration(200) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900)
            .duration(200) .style('opacity', 1.0) .style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(200) .style('opacity', 0.0) .remove();

        } // function sortTableFunc() ends here.

        editChartButton.on('click', function() {

            ismenuButtonOfColumnChartClicked = false
            optionsButtonPanelForColumnChart.style("display","none")

            changeXAndYAxisValuesPanelForColumnChart.style("display","block")
        })


        // Creating SVG panel to hold columns
        var svg = svgPanelForColumnChart .append("svg") .style("background-color", options.BGcolor).style("border-radius","0px")
        .style("border-width","1px") .style("border-color","#d4d4d4") .style("border-style","solid") .append("g") .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
        svg.call(tip);
       
        // Adding the text label for the Y axis
        var yAxisVariable = svg.append("text") .attr("transform", "rotate(-90)") .attr("y", -25) .attr("x",0 - (height / 2)) .attr("dy", "1em") .style("text-anchor", "middle")
        .style("font-family","Verdana,sans-serif") .style("font-weight","Bold") .style("font-size","12px") .text(options.yAxisLable) .style('fill','#00001c') .style("text-transform","capitalize")
        .style("font-style","normal")        
        
        let key=options.xAxisLable;
        let array=options.data.map(value => value[key]);
        let ArrayValue=[];
        var RotateValue;
        for(let i=0;i<array.length;i++){
                ArrayValue[i]=array[i].length;
        }
        const numberGreaterThanLimit = ArrayValue.filter((v) => v > 5);

            
            var x1 = d3.scale.ordinal() .domain(options.data.map(function(d) { return d[options.keys.label]; })) .rangeRoundBands([0, width], 0.25);
        
            var xAxis = d3.svg.axis() .scale(x1) .orient("bottom")
                 // Adding the X Axis
                svg.append("g").attr("class", "x axis").attr("transform", "translate(0," + height + ")") .call(xAxis)
                
                // Adding the X Axis margin labels
                .selectAll("text") .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') 
                .attr("transform", function(d) {
                    if(numberGreaterThanLimit.length>0){return "rotate(-45)"}
                    else{
                    return "rotate(0)" }})
                .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
                .text(function(d,i) {
                    if(d.length > 9)
                        return d.substring(0,9)+'...';
                    else
                        return d;
                })    
                        // Adding the text label for the X axis
                var xAxisVariable =  svg.append("text") .attr("transform", "translate(" + ((width/2)) + " ," + (height+margin.bottom - 2) + ")")
                .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif") .style("font-weight","Bold") .style("font-size","12px") .text(options.xAxisLable) .style('fill','#00001c') 
                .style("text-transform","capitalize") .style("font-style","normal")
       
        
        
        
        
        // ----------------------------------- Creating Bars begins below-----------------------------------
        
        var xScale = d3.scale.ordinal() .domain(d3.range(options.data.map(function(d) { return +d[options.keys.value]; }).length)) .rangeRoundBands([0, width], 0.25);
        
        var yScale = d3.scale.linear() .domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.value]; }), function(d) { return d; })]) .range([0, height]);
        
        //Creating bars
        var verticalBars = svg.selectAll(".bar") .data(options.data.map(function(d) { return +d[options.keys.value]; })) .enter() .append("rect") .attr("class", "bar") .attr("fill",function(d,i){  return colors(i);  })
        .on('mouseover',tip.show)  .on('mouseout', tip.hide)
        
        //verticalBars.transition() .delay(function (d, i) { return i / valueArray.length * 750; }) .duration(500) .attr("x", function (d,i) {  return xScale(i);  }) .attr("y", function (d) { return height - yScale(d); }) .attr("width", xScale.rangeBand())  .attr("height", function (d) { return yScale(d); });
		
		verticalBars.attr("x", function (d,i) {  return xScale(i);  }).attr("width", xScale.rangeBand())
		.attr("y", function (d) { return height; })
		.attr("height", function (d) { return 0; })
		.transition() .delay(400) .duration(800)
		.attr("y", function (d) { return height - yScale(d); })
		.attr("height", function (d) { return yScale(d); })
        
        verticalBars.style("fill",function(d,i){ return  colors(i) }).style("cursor","default")

        var newArrForDrillDownCol = []
        var columnNames = d3.keys(newJson[0])
        var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
        
        for(var i = 0; i < columnNames.length ; i++){
            for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                    
                    for(var k = 0; k < verticalBars[0].length; k++){
                        d3.select(verticalBars[0][k]).attr('data-drilldownkey', function(d,index){
                           var arr = JSON.stringify(newJson[k]).slice(1, -1).split('"'), arr1 = d3.select(arr)[0]
                           
                           for(var j = 0; j < arr1[0].length; j++){
                               if(arr1[0][j].toString() == ":"){
                                   var ch = arr1[0][j].toString().replace(":","|")
                                     newArrForDrillDownCol.push(ch)
                               }
                               else {
                                     newArrForDrillDownCol.push(arr1[0][j])
                               }
                           }
                           
                               //return JSON.stringify(newJson[k]).slice(1, -1).split('"').join("").split(':').join("|")
                               return newArrForDrillDownCol.join("");
                           })
                        newArrForDrillDownCol = [];
                    }
                }
                else {
                }
            }
        }

        svg.selectAll(".bar") .data(options.data.map(function(d) { return +d[options.keys.value]; })).on("click", function(d) {    
            selectedItem = d });

        var yTextPadding = -3;
        var format = d3.format(".2s")
        var textOnBarsForColumnChart = svg.selectAll(".bartext") .data(options.data.map(function(d) { return +d[options.keys.value]; }))
        .enter() .append("text")  .attr("class", "bartext" ).style("text-anchor", "middle") .style("fill", "#00001c") .style("font-weight","Normal")
        .style("font-size","12px") .style("font-family","Verdana,sans-serif") .style("position","absolute").attr("class", "series_value" ).style("display", options.series) 
        .attr("x", function(d,i) { return xScale(i)+xScale.rangeBand()/2; })
        .attr("y", function (d) { return height; })
		.transition() .delay(400) .duration(800)
		.attr("y", function (d) { return height - yScale(d)+yTextPadding; })
		.text(function(d){ 
            if(d.toString().indexOf('.') === -1)
			{
                return d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            else {
                return d;
            }
        })

        // ----------------------------------- Creating Bars ends here -------------------------

        var width1 = svgPanelForColumnChart[0][0].clientWidth;
        var height1 = svgPanelForColumnChart[0][0].clientHeight;

        var root = targetElement;
        var scr = { x: window.scrollX, y: window.scrollY, w: svgPanelForColumnChart[0][0].clientWidth, h: svgPanelForColumnChart[0][0].clientHeight };
        var body_sel = d3.select('body');
        var body = { w: body_sel.node().offsetWidth, h: body_sel.node().offsetHeight };
        var doc = { w: width, h: height };
        var svgpos = root.node().parentNode
        
        var dist = { x: 20, y: 20 };
        
        verticalBars.on("mousemove", function(d,i){
                        
            tip.style("display","block")
                        
            var m = d3.mouse(root.node());
            scr.x = window.scrollX;
            scr.y = window.scrollY;
            m[0] += 0
            m[1] += 0
            tip.style("right", "");
            tip.style("left", "");
            tip.style("bottom", "");
            tip.style("top", "");
            
               tip.style("border-color", colors(i))
                        if(d3.mouse(this)[0] < scr.w/2){
                            
                            tip.style("left", (d3.event.pageX + 12 )  + "px");
                            tip.style("top", (d3.event.pageY - ( parseFloat(tip.style("height")) /2  ) )+ "px");
                        }
                        else if(d3.mouse(this)[0] > scr.w/2){
                            
                            tip.style("left", (d3.event.pageX) - (parseFloat(tip.style("width"), 10) + 20) + "px");
                            tip.style("top", (d3.event.pageY - ( parseFloat(tip.style("height")) /2  ) ) + "px");
                        }
                        else if(d3.mouse(this)[0] == scr.w/2){
                            
                            tip.style("left", (d3.event.pageX) - (parseFloat(tip.style("width"), 10) + 20) + "px");
                            tip.style("top", (d3.event.pageY - ( parseFloat(tip.style("height")) /2  ) ) + "px");
                        }
             });
        
        
        
        //------------------------Creating table begins here----------------------

        var tablePanelForColumnChart =  targetElement.append("div") .attr("id",targetElement[0][0].id + "holderForColumnChartTableID")
        .attr("class","scrollingDivForTable-Class tableDivForColumnChart" + targetElement[0][0].id) .style('background-color',"#ffffff") .style('position','absolute')
        .style("display","block") .style("overflow","hidden") .style("width", function(d) {  return 100+ "%"; })
        .style("height", function(d) { return 40 + "%"; }) .style("left",0 + "%")//.style("border-right","1px solid #e2e2e2")
        //.style("border-bottom","1px solid #e2e2e2")
        
        $( '.tableDivForColumnChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        if(options.showTitle == true ){
            tablePanelForColumnChart.style("top",60  + "%")
        }
        else if(options.showTitle == false  ){
            tablePanelForColumnChart.style("top",60  + "%")
            
        }
        tablePanelForColumnChart.html('<table class = "tableClassForColumnChart' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                      '<thead class = "theadClassForColumnChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForColumnChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                                      '<tbody class = "tBodyClassForColumnChart' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                      '</table>'
                                      )
        
        tablePanelForColumnChart.select('table').attr('id',targetElement[0][0].id + 'tableID')

        // Show or Hide Table scroll bar when mouseover on widget
        targetElement.on('mouseover',function(){ tablePanelForColumnChart.style("overflow","auto") })
        targetElement.on('mouseout',function(d){ tablePanelForColumnChart.style("overflow","hidden") })
        
        var tableDataForColumnChart = [];
        if(options.dataForTable.length > 0){
            tableDataForColumnChart = options.dataForTable;
        }
        else {
            tableDataForColumnChart = newJson;
        }
        
        var thead = tablePanelForColumnChart.select("thead").selectAll("th") .data(d3.keys(tableDataForColumnChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px").style("color","#00001c")
        
        var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff")//f4f4f4
        .style("position","relative")
        
        var thead1 = d3.select(".thead1ClassForColumnChart" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tableDataForColumnChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff")//f4f4f4
        .style("position","relative")
        
        var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
        .attr("id", "ascendingIconIDForColumnChart") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
        
        var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
        .attr("id", "descendingIconIDForColumnChart") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
        
        var tr = tablePanelForColumnChart.select("tbody").selectAll("tr") .data(tableDataForColumnChart).enter().append("tr")
        .attr("id", function(d,i) { return "slice" + i })
        
        // cells
        var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d}) 
        .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
        
        var $table = $('.tableClassForColumnChart' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
        
        d3.select(".theadClassForColumnChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                d.forEach(function(dd,j){
                    colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                })
        })
        
        
        $(".thead1ClassForColumnChart" + targetElement[0][0].id).insertAfter('.tBodyClassForColumnChart' + targetElement[0][0].id)
        
        $(".thead1ClassForColumnChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForColumnChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
        
        
        tablePanelForColumnChart.select(".theadClassForColumnChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
        })
        
        tablePanelForColumnChart.select(".thead1ClassForColumnChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                    d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
        })
        
        
        
        $('.tableDivForColumnChart' + targetElement[0][0].id).scroll(function () {
                                                                  
            $(".thead1ClassForColumnChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForColumnChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
                                                                  
        })
        
        
        
        var sortOrder = false;
        thead1.on("click",function(k, index){
                 
                 sortOrder = !sortOrder;
                 
                 tablePanelForColumnChart.select(".thead1ClassForColumnChart" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                                                 
                        if (sortOrder) {
                                                 
                            if(i == index){
                                d3.select(this).select('svg').select('#descendingIconIDForColumnChart').style("visibility", "hidden")
                                d3.select(this).select('svg').select('#ascendingIconIDForColumnChart').style("visibility", "visible")
                            }
                            else {
                                d3.select(this).select('svg').select('#descendingIconIDForColumnChart').style("visibility", "visible")
                                d3.select(this).select('svg').select('#ascendingIconIDForColumnChart').style("visibility", "visible")
                            }
                        }
                        else{
                                                 
                            if(i == index){
                                d3.select(this).select('svg').select('#descendingIconIDForColumnChart').style("visibility", "visible")
                                d3.select(this).select('svg').select('#ascendingIconIDForColumnChart').style("visibility", "hidden")
                            }
                            else {
                                d3.select(this).select('svg').select('#descendingIconIDForColumnChart').style("visibility", "visible")
                                d3.select(this).select('svg').select('#ascendingIconIDForColumnChart').style("visibility", "visible")
                            }
                        }
                 })
                 
                  var monthTruOrFalAryForColumnChart = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
                  
                  tr.sort(function(a, b) {
                          
                          if (sortOrder) {
                          var monthsArrayForColumnChart = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                          } else {
                          var monthsArrayForColumnChart = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                          }
                          
                          monthTruOrFalAryForColumnChart = []; gotMonthArray = [];
                          tableDataForColumnChart.forEach(function(d,i){
                               var da = d[k].toString().substring(0,3).toLowerCase()
                               if(monthsArrayForColumnChart.indexOf(da) >= 0){
                                   monthTruOrFalAryForColumnChart.push(true)
                                   gotMonthArray.push(da);
                               }
                               else {
                                   monthTruOrFalAryForColumnChart.push(false)
                               }
                           })
                          
                          if(monthTruOrFalAryForColumnChart.indexOf(false) == -1){ // true
                          
                          monthArray = []; monthArrayCount = [];
                          gotMonthArray.forEach(function(dd,j){
                                var index1 = monthsArrayForColumnChart.indexOf(dd.substring(0,3))
                                if(monthArrayCount.indexOf(index1) >= 0){
                                    index1 = 12 + index1;
                                }
                                monthArray.push(index1);
                                monthArrayCount.push(index1)
                            })
                          returnArray = []
                          monthArray.sort(function(aa, bb) {
                              returnArray.push(+aa - +bb)
                              return +aa - +bb;
                          })
                          
                          sortTableFunc()
                          return returnArray[ind++];
                          } //  if true (if jan feb if block)
                          else {
                          var data = +a[k];
                          
                          if(!isNaN(data)){
                          
                          if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                          else { return d3.descending(+a[k], +b[k]); }
                          }
                          else if(!isNaN(Date.parse(a[k]))){
                          
                          if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                          else { return new Date(b[k]) - new Date(a[k]) }
                          }
                          else {
                          
                          if (sortOrder) { return d3.ascending(a[k], b[k]); }
                          else { return d3.descending(a[k], b[k]); }
                          }
                          } // if not jan feb else block
				}); // tr
				
		})
        
        function sortTableFunc(){
            
            var table = tablePanelForColumnChart.select('table');
            var rows = table.selectAll('tr').data(tableDataForColumnChart);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0) .style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500)
            .style('opacity', 1.0) .style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
        }
        
        tablePanelForColumnChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
        .style("color","#00001c")
        .style("height","25px").style("border", "1px solid #dddddd").style('background-color',"#ffffff") 
        tablePanelForColumnChart.selectAll('td').style("height","25px") .style("border", "1px solid #ffffff") .style("font-size","12px").style("font-weight","Normal")
        .style("color","#00001c")

        //additionally 
        tablePanelForColumnChart.selectAll('th').style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
        tablePanelForColumnChart.selectAll('td').style("border-style","none").style("color","#00001c")

        tablePanelForColumnChart.selectAll('table') . style("border-collapse","collapse")
        tablePanelForColumnChart.selectAll('table tr:first-child th').style("border-top","0px")
        tablePanelForColumnChart.selectAll('table tr:last-child td').style("border-bottom","0px")
        tablePanelForColumnChart.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
        tablePanelForColumnChart.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")

        if(showOrHideTableForColumnChart == false){
            tablePanelForColumnChart.style("display","none")
        }
        else if(showOrHideTableForColumnChart == true){
            tablePanelForColumnChart.style("display","block")
        }
        
        if(options.isDataDetailedForTable == false){
        
            var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
        
            // Adding underlines for selected drill-down column text
            var drillDownSectionsForColumnChart = tablePanelForColumnChart.select('table').selectAll('th')
            var drillDownSectionsFor_ColumnChart = drillDownSectionsForColumnChart[0]
        
            var foundResult = [];
            for(var i = 0; i<drillDownSectionsForColumnChart[0].length; i++){
                for(var j = 0; j<drillDownColumnNamesArray.length; j++){
                    if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForColumnChart[0][i].__data__.toString().toLowerCase() ){
                        foundResult.push(i)
                    }
                }
            }
        
            var r = tablePanelForColumnChart.select('table').selectAll('tr').selectAll('td')
            for(var i = 0; i<r.length; i++){
                for(var j = 0; j < foundResult.length; j++){
                    var row = r[i][foundResult[j]]
                    $(row).css("text-decoration", "underline")
                }
            }
        }
        
        if(options.dataForTable.length == 0){
            
            // Scrolling table based on column click
            var selectedItem = "";
            verticalBars.on("click", function(d,i) {
                            
                tip.style("display","none");
                            
                thead1.select('svg').select('#descendingIconIDForColumnChart').style("visibility", "visible")
                thead1.select('svg').select('#ascendingIconIDForColumnChart').style("visibility", "visible")
                        
                sortTableFunc()
                
                selectedItem = i
                
                var val = d.value;
                var selectedSlice = i
                options.data.forEach(function(d,i) {
                                   
                        if(i == selectedItem){
                             tablePanelForColumnChart.select("tbody").selectAll("tr")
                             
                             .style("background-color", function(dTr, iTr) {
                                
                                    return i == iTr ? "#808080" : null;
                                    })
                             .style("color", function(dTr, iTr) {
                                
                                    return i == iTr ? "#FFFFFF" : null;
                                    })
                                var row = $('#' + targetElement[0][0].id + "tableID").find('tr');
                                if((row[0].clientHeight * selectedItem) > tablePanelForColumnChart[0][0].clientHeight - 56 ){
                                    $("#" + targetElement[0][0].id + "holderForColumnChartTableID").animate({
                                        scrollTop: row[0].clientHeight * selectedItem }, 350);
                                    }
                              else{
                
                                    $("#" + targetElement[0][0].id + "holderForColumnChartTableID").animate({
                                    scrollTop: 0 }, 350);
                            }
                                
                        } //if(i == selectedItem)
                    });
            })
        }
        else{
            verticalBars.on("click", function(d,i) {
                tip.style("display","none")
            })
        }
        
        //By default calling the resized function first time (to align table's th and td).
		setTimeout(function(){ resizedFuctionForColumnChart() },1000)
        
        window.addEventListener('resize', function(event){ resizedFuctionForColumnChart() });
        
        $(function() {
           $("#" + targetElement[0][0].id).resizable({
               resize: function(event, ui) {
                    divWidth = ui.size.width;
                    divHeight = ui.size.height;
                    resizedFuctionForColumnChart();
                }
            });
         });
        
        function resizedFuctionForColumnChart()
        {
            
            if((svgPanelForColumnChart.node().getBoundingClientRect().width) && (svgPanelForColumnChart.node().getBoundingClientRect().height) > 0){
			
                
                if(showOrHideCommentsBtnForColumnChart == true){
                    pieButtonForColumnChart.style('margin-left', "2px")
                    donutButtonForColumnChart.style('margin-left', "2px")
                    horButtonForColumnChart.style('margin-left', "2px")
                    filterButtonForColumnChart.style('margin-left', "2px")
                    refreshButtonForColumnChart.style('margin-left', "2px")
                    commentsBtnForColumnChart.style('margin-left', "2px")
                    // menuButtonForColumnChart.style('right', '0')
                    menuButtonForColumnChart.style('right','0')
                }
                else if(showOrHideCommentsBtnForColumnChart == false){
                    pieButtonForColumnChart.style('margin-left', "2px")
                    donutButtonForColumnChart.style('margin-left', "2px")
                    horButtonForColumnChart.style('margin-left', "2px")
                    filterButtonForColumnChart.style('margin-left', "2px")
                    refreshButtonForColumnChart.style('margin-left', "2px")
                    //commentsBtnForColumnChart.style('right', '0')
                    commentsBtnForColumnChart.style('display','none')
                    // menuButtonForColumnChart.style('right', '0')
                    menuButtonForColumnChart.style('right','0')
                }

                // optionsButtonPanelForColumnChart.style('right', '0')
                optionsButtonPanelForColumnChart.style('right', '0')
                
                //downloadOptionsPanelDiv.style('right', '0')

                cancelButtonForFilterPanel.style('right', '0')
                settingPanelCancelBtnForColumnChart.style('right', '0')

                if(isSearchInTableButtonClicked == true){
                    canBtnForSearchTableForColumnChart.style('right', '0')
                }
				
                var margin1 = {top: 30, right: 40, bottom: 80, left: 40}, // originally top: 42, left: 80
                width1 = (svgPanelForColumnChart.node().getBoundingClientRect().width) - margin1.left - margin1.right,
                height1 = (svgPanelForColumnChart.node().getBoundingClientRect().height) - margin1.top - margin1.bottom;
            
                var xx =  x.domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.value]; }))]) .range([0, width1]);
                var yy = y.domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.value]; }))]) .range([height1, 0]);
            
                yAxis.scale(yy) .orient("left") .ticks(5);
            
                x1.domain(options.data.map(function(d) { return d[options.keys.label]; })) .rangeRoundBands([0, width1], 0.25);
            
                xAxis.scale(x1) .orient("bottom") //.ticks(40);
            
                var svg1 = svg;
            
                svg1.select("svg") .attr("width", width1 + margin1.left + margin1.right) .attr("height", height1 + margin1.top + margin1.bottom);
            
                svg1.select(".y.axis") .call(yAxis)
            
                svg1.select(".x.axis") .attr("transform", "translate(0," + height1 + ")") .call(xAxis)
                
                // Add the X Axis margin labels
                .selectAll("text") .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') 
                .attr("transform", function(d) {
                    if(numberGreaterThanLimit.length>0){return "rotate(-45)"}
                    else{
                    return "rotate(0)" }})
                .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
                .text(function(d,i) {
                    if(d.length > 9)
                        return d.substring(0,9)+'...';
                    else
                        return d;
                })       
            
                yAxisVariable.attr("transform", "rotate(-90)") .attr("y", -25) .attr("x",0 - (height1 / 2)) .attr("dy", "1em")
            
                xAxisVariable.attr("transform", "translate(" + ((width1/2)) + " ," + (height1+margin1.bottom - 2) + ")")
            
                xScale.domain(d3.range(options.data.map(function(d) { return +d[options.keys.value]; }).length)) .rangeRoundBands([0, width1], 0.25);
            
                yScale.domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.value]; }), function(d) { return d; })]) .range([0, height1]);
            
                svg1.select(".y.axis") .call(yAxis)

                var ss = d3.select(svgPanelForColumnChart)
            
                svg1.selectAll(".bar") .attr("x", function(d, i) { return xScale(i); }) .attr("width", xScale.rangeBand())
                .attr("y", function(d) { return height1 - yScale(d); }) .attr("height", function(d) { return yScale(d); })

                svg.selectAll(".series_value")  .attr("x", function(d,i) { return xScale(i)+xScale.rangeBand()/2; })
                .attr("y", function(d,i) { return height1-yScale(d)+yTextPadding; })

                svg.selectAll(".bartext") .attr("x", function(d,i) { return xScale(i)+xScale.rangeBand()/2; })
                .attr("y", function(d,i) { return height1-yScale(d)+yTextPadding; })
                
                colWidth = []; 
				
                d3.select(".theadClassForColumnChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
					d.forEach(function(dd,j){
						colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
					})
                })
                
                tablePanelForColumnChart.select(".thead1ClassForColumnChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
					d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
                })
                
            } // checking svgPanelForColumnChart width & height panel size function ends here.
            
        } //resizedFuction() ends here
    }, //columnChart
    
    // ************************************************** Donut Chart  **************************************************
    donutChart: function(targetElement, options){

       isChartCalled++;
       var chartName = "DONUTCHART";
       var dropDownForDoNutChart;
       acinfotech.allCharts(targetElement,options,chartName)
        
        var newJson = [];
        options.data.forEach(function(d, i) {
            var temp = {};
            
            for(var i = 0; i < Object.keys(d).length; i++) {
                delete d['enabled'];
                temp[Object.keys(d)[i]] = d[Object.keys(d)[i]]
            }
            
            newJson.push(temp)
                            
        });
        
        targetElement.style("min-width", "350px").style("min-height", "350px").style("background-color", options.BGcolor)

        var showOrHideTableForDonutChart;
        var showOrHideCommentsForDonutChart;
        var showOrHideCommentsBtnForDonutChart = true;
        
        // Show or Hide table 
        if((options.showTable == false) || (options.showTable == true)){
            showOrHideTableForDonutChart = options.showTable;
        }
        else{
            showOrHideTableForDonutChart = false;   
        }

        // Show or Hide comments
        if (options.showComments == true || false) {
            showOrHideCommentsForDonutChart = options.showComments;
        }
        else {
            showOrHideCommentsForDonutChart = false;
        }

        if (options.comments.length == 0){ 
            showOrHideCommentsForDonutChart = false;
            showOrHideCommentsBtnForDonutChart = false;
        }
        
        if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == true)){
            showOrHideTableForDonutChart = true;
            showOrHideCommentsForDonutChart = false;
        }
        else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
            showOrHideTableForDonutChart = false;
            showOrHideCommentsForDonutChart = false;
        }

        var widthForDoNutChart = targetElement.node().getBoundingClientRect().width;
        var heightForDoNutChart = targetElement.node().getBoundingClientRect().height;
        //var radiusForDoNutChart = Math.min(widthForDoNutChart, heightForDoNutChart) / 3.5;
        
        var isResizedFunctionCalled = false;
        var newWidth1, newHeight1;
        var newWidth11, newHeight11;
        var newWidth111, newHeight111;
        var newWidth1111, newHeight1111;
        var divWidthForDoNutChart, divHeightForDoNutChart
        
        // Creating chart title
        var chartTitlePanel =  targetElement.append("div").style("background-color", options.BGcolor) .style('position',"absolute").style("text-indent","6px").style("border","none")
        
		var optionsButtonPanelForDonutChart = targetElement.append('div').style('width',"25px").style('height',"290px").style('position','absolute')
        .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px")
        .style('right', '0').style("min-width","25px") .style("min-width","25px")
        .style("border-style","none").style("border-left", "solid #fcfcfc  1px")
		
        var bubbleButtonForDonutChart = optionsButtonPanelForDonutChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','133px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var bubbleBtnImgVar = document.createElement("IMG");
        bubbleBtnImgVar.src = "images/bubbleIcon.png";
        bubbleBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:15px; height:15px; opacity:0.9;");
        bubbleButtonForDonutChart[0][0].appendChild(bubbleBtnImgVar)

        var pieButtonForDonuteChart = optionsButtonPanelForDonutChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','159px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        
        var pieBtnImgVar = document.createElement("IMG");
        pieBtnImgVar.src = "images/pieIcon.png";
        pieBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:15px; height:15px; opacity:0.9;")
        pieButtonForDonuteChart[0][0].appendChild(pieBtnImgVar)

        var colButtonForDonutChart = optionsButtonPanelForDonutChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','184px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        
        var colBtnImgVar = document.createElement("IMG");
        colBtnImgVar.src = "images/columnIcon.png";
        colBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:15px; height:15px; opacity:0.9;")
        colButtonForDonutChart[0][0].appendChild(colBtnImgVar)

         var horButtonForDonutChart = optionsButtonPanelForDonutChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','209px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        
        var horiBtnImgVar = document.createElement("IMG");
        horiBtnImgVar.src = "images/horizontalIcon.png";
        horiBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:15px; height:15px; opacity:0.9;")
        horButtonForDonutChart[0][0].appendChild(horiBtnImgVar)

        var filterButtonForDonutChart = optionsButtonPanelForDonutChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','234px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var filterBtnImgVar = document.createElement("IMG");
        filterBtnImgVar.src = "images/filterIcon.png";
        filterBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:15px; height:15px; opacity:0.8;")
        filterButtonForDonutChart[0][0].appendChild(filterBtnImgVar)

        var refreshButtonForDonutChart = optionsButtonPanelForDonutChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','259px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var refreshBtnImgVar = document.createElement("IMG");
        refreshBtnImgVar.src = "images/refreshIcon.png";
        refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:15px; height:15px; opacity:0.9;")
        refreshButtonForDonutChart[0][0].appendChild(refreshBtnImgVar)

        var commentsBtnForDonutChart = optionsButtonPanelForDonutChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','284px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var commentsBtnImgVariable = document.createElement("IMG");
        if(options.showComments == false){
            commentsBtnImgVariable.src = "images/showCommentsIcon.png";
        }
        else if(options.showComments == true){
            commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
        }
        commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:15px; height:15px; opacity:0.8;")
        commentsBtnForDonutChart[0][0].appendChild(commentsBtnImgVariable)

        var menuButtonForDonutChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','1px') .style("cursor","pointer").style("display","block") .style("box-sizing","border-box")
        .style('padding',"0px") 
        .style("border", "1px solid #f8f8f8").style("line-height","0px")
        var menuBtnImgVar = document.createElement("IMG");
        menuBtnImgVar.src = "images/menuIcon.png";
        menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
        menuButtonForDonutChart[0][0].appendChild(menuBtnImgVar)

        if(showOrHideCommentsBtnForDonutChart == true){
            bubbleButtonForDonutChart.style('margin-left', "2px")
            pieButtonForDonuteChart.style('margin-left', "2px")
            colButtonForDonutChart.style('margin-left', "2px")
            horButtonForDonutChart.style('margin-left', "2px")
            filterButtonForDonutChart.style('margin-left', "2px")
            refreshButtonForDonutChart.style('margin-left', "2px")
            commentsBtnForDonutChart.style('margin-left', "2px")
            // menuButtonForDonutChart.style('right', '0')
            menuButtonForDonutChart.style('right', '0')
        }
        else if(showOrHideCommentsBtnForDonutChart == false){
            bubbleButtonForDonutChart.style('margin-left', "2px")
            pieButtonForDonuteChart.style('margin-left', "2px")
            colButtonForDonutChart.style('margin-left', "2px")
            horButtonForDonutChart.style('margin-left', "2px")
            filterButtonForDonutChart.style('margin-left', "2px")
            refreshButtonForDonutChart.style('margin-left', "2px")
            //commentsBtnForDonutChart.style('right', '0')
            commentsBtnForDonutChart.style('display','none')
            // menuButtonForDonutChart.style('right', '0')
            menuButtonForDonutChart.style('right', '0')

        }
        // Creating SVG for hoding donut slices
        var svgPanel = targetElement .append('svg') 
        .attr("class","svgPanelClassForDoNut")
        .style("background-color", options.BGcolor)
        .style('position',"absolute") 
        var ismenuButtonOfDonutChartClicked = false; // Menu toggle button variable
        menuButtonForDonutChart.on('click', function() {
            if(ismenuButtonOfDonutChartClicked == false){ 
                ismenuButtonOfDonutChartClicked = true; // Menu toggle button variable
                optionsButtonPanelForDonutChart.style("display","block") // Showing option buttons panel

                searchDivForDoNutChart.style("display","none") // Hiding filter panel

                settingPanelDivForDonutChart.style("display","none") // Hiding setting panel

                

        if(options.showLegend == true && options.showTitle == true){
            
            if(options.legendSide === "left"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 70 + "%").style("top",8.0  + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("left",30 + "%") .style("top",8.0  + "%")
                    svgPanel.style("position","absolute").style("background-color", options.BGcolor);
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 85 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }

            }
            else if(options.legendSide === "right"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 70 + "%") .style("top",8.0  + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 85 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }

            }
            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 70 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 85 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                
            }
        }
        else if(options.showLegend == true && options.showTitle == false){
           
            if(options.legendSide === "left"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 70 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 85 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }

            }
            else if(options.legendSide === "right"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 70 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",0.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 85 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
            }
            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 70 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 85 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
            }
            
        }
        else if(options.showLegend == false){
            
             if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 0.0 + "%"; }) .style("height", function(d) { return 0  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 100 + "%") .style('height', 70 + "%").style("top",8.0  + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 0.0 + "%"; }) .style("height", function(d) { return 0  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 100 + "%") .style('height', 52 + "%").style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 0.0 + "%"; }) .style("height", function(d) { return 0  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 100 + "%") .style('height', 85 + "%").style("top",8.0  + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
        }

                resizedFuctionForDonutChart();
            }
            else if(ismenuButtonOfDonutChartClicked == true){  
                ismenuButtonOfDonutChartClicked = false; // Menu toggle button variable
                optionsButtonPanelForDonutChart.style("display","none") // Hiding option buttons panel
            }
        })
        
        // // Creating SVG for hoding donut slices
        // var svgPanel = targetElement .append('svg') 
        // .attr("class","svgPanelClassForDoNut")
        // .style("background-color", options.BGcolor)
        // .style('position',"absolute") 
        
        var commentsPanelDivForDonutChart = targetElement.append("div") .attr("class","commentsPanelClassForDonutChart") 
        .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
		.style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
        .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)

        commentsPanelDivForDonutChart.on('click',function(d){
            $('.commentsClassForDonutChart' + targetElement[0][0].id).focus()
        })

        // Checking whether chart Title and Legend is choosen (true or flase) while library is called.
        if(options.showTitle == true && options.showLegend == true){
            chartTitlePanel.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 8 + "%"; }).style("background-color", options.BGcolor)
            .html('<div  style="width: 100%; height:0%;  position: absolute; top:10.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>') //color 325922
            
            if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){

                var commentsForDonutchart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify') .attr('class','commentsClassForDonutChart' + targetElement[0][0].id)

                   svgPanel.style('width', 65 + "%") .style('height', 70 + "%") .style("left",75 + "%").style("top",8 + "%").style("background-color", options.BGcolor) .append('g'); 
                   commentsPanelDivForDonutChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForDonutchart[0].outerHTML.toString())

            }
            else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("left",75 + "%").style("top",8 + "%") .style("background-color", options.BGcolor).append('g');
                    commentsPanelDivForDonutChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; })
            }
            else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                    svgPanel.style('width', 65 + "%") .style('height', 85 + "%") .style("left",75 + "%").style("top",8 + "%").style("background-color", options.BGcolor) .append('g'); 
                    commentsPanelDivForDonutChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; })
            }

        }
        else if(options.showTitle == false && options.showLegend == true){
            
            chartTitlePanel.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; });

            if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){

                var commentsForDonutchart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify')

                   svgPanel.style('width', 65 + "%") .style('height', 70 + "%") .style("left",75 + "%").style("top",8 + "%") .style("background-color", options.BGcolor).append('g');    
                   commentsPanelDivForDonutChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForDonutchart[0].outerHTML.toString())
            }
            else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("left",75 + "%") .style("top",8 + "%") .style("background-color", options.BGcolor).append('g')
                commentsPanelDivForDonutChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                svgPanel.style('width', 65 + "%") .style('height', 85 + "%") .style("left",75 + "%").style("top",8 + "%") .style("background-color", options.BGcolor).append('g');  
                commentsPanelDivForDonutChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none") 
            }

        }
        else if(options.showTitle == false && options.showLegend == false){
            
            chartTitlePanel.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; });

            if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                var commentsForDonutchart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify')

                   svgPanel.style('width', 100 + "%") .style('height', 70 + "%") .style("left",0 + "%").style("top",8 + "%").style("background-color", options.BGcolor) .append('g');    
                   commentsPanelDivForDonutChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForDonutchart[0].outerHTML.toString())
            }
            else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                svgPanel.style('width', 100 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8 + "%").style("background-color", options.BGcolor).append('g')
                commentsPanelDivForDonutChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                svgPanel.style('width', 100 + "%") .style('height', 85 + "%") .style("left",0 + "%").style("top",8 + "%").style("background-color", options.BGcolor) .append('g');  
                commentsPanelDivForDonutChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")  
            }

        }
        else if(options.showTitle == true && options.showLegend == false){
            chartTitlePanel.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 8 + "%"; }).style("background-color", options.BGcolor)
            .html('<div  style="width: 100%; height:0%; position: absolute; top:5.0%; font-size:16px;font-family:inter;  color:#00001c;">'+ options.chartTitle + '</div>')
            

            if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                var commentsForDonutchart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify')

                   svgPanel.style('width', 100 + "%") .style('height', 70 + "%") .style("left",0 + "%").style("top",8 + "%") .style("background-color", options.BGcolor).append('g');    
                   commentsPanelDivForDonutChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForDonutchart[0].outerHTML.toString())
            }
            else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                svgPanel.style('width', 100 + "%") .style('height', 52 + "%") .style("left",0 + "%").style("top",8 + "%") .style("background-color", options.BGcolor).append('g');
                commentsPanelDivForDonutChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                svgPanel.style('width', 100 + "%") .style('height', 85 + "%") .style("left",0 + "%").style("top",8 + "%") .style("background-color", options.BGcolor).append('g');  
                commentsPanelDivForDonutChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")     
            }

        }
        
        // checking color set for donut slices and legend dots
        if(options.colorSet === undefined){
            options.colorSet = "one"
            var colorsForDoNutChart = d3.scale.ordinal().range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "one"){
            options.colorSet = "one"
            var colorsForDoNutChart = d3.scale.ordinal().range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            options.colorSet = "two"
             var colorsForDoNutChart = d3.scale.ordinal().range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            options.colorSet = "three"
            var colorsForDoNutChart = d3.scale.ordinal().range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        }
        else
        {
            options.colorSet = "one"
            var colorsForDoNutChart = d3.scale.ordinal().range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }

        /*------------------ Settings panel DIV and everything within it begins here ------------------*/
        var settingDisabledDivForDonutChart = targetElement.append('div').style('width',targetElement[0][0].clientWidth + "px").style('height',targetElement[0][0].clientHeight + "px").style('position','absolute')
        .style("background-color",'#f3f3f3').style("z-index",2).style("display","none").style('top', 0.0 + "%").style('left', 0.0 + "%")
        .style("opacity",0.1).style("min-width","350px").style("min-height","350px") //005ec4

        var settingPanelDivForDonutChart = targetElement.append('div').style('width',"100%").style('height',"40%")
        .style('position','absolute').style('margin-left', "0px").style('border-top',"1px solid #f0f0f0").style('border-bottom',"1px solid #e5e5e5")
        .style("background-color",'#fcfcfc').style("z-index",90).attr("class","settingPanelDivForDonutChart" + targetElement[0][0].id)
        .style("display","none").style('top',"60%").style('height',"40%")

        $( '.settingPanelDivForDonutChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        var settingPanelDivForDonutChartTitle = settingPanelDivForDonutChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','10px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; color:#00001c;">'+ "Settings" +'</div>')

        var settingPanelDivForDonutChangeColorTitle = settingPanelDivForDonutChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Select color set " +'</div>')

        var settingPanelCanBtnForDonutChart = settingPanelDivForDonutChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
        .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
        .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.9; background-color:#fcfcff")
        settingPanelCanBtnForDonutChart[0][0].appendChild(cancelBtnImgVar)
        
        var downloadBtnForDonutChart = optionsButtonPanelForDonutChart.append("div").attr("id","downloadBtnForDonutChart-ID-" + targetElement[0][0].id).style("width","20px").style("height","20px")
        .style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff").style('margin-left','2px').style('top', 107 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        
        acinfotech.downloadFunctionality("downloadBtnForDonutChart-ID-" + targetElement[0][0].id,targetElement)
        
        // Cancel button of Setting panel clicked
        settingPanelCanBtnForDonutChart.on('click', function() {
            
            settingBtnForDonutChart.style("cursor","pointer")

            settingPanelDivForDonutChart.style("display","none")//.transition().style('width', 0 + "px").duration(200).delay(50)
            //.style("overflow-y","hidden")

            if(options.showLegend == true && options.showTitle == true){
            
            if(options.legendSide === "left"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("left",30 + "%")
                    svgPanel.style("position","absolute").style("background-color", options.BGcolor);
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }

            }
            else if(options.legendSide === "right"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }

            }
            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                
            }
        }
        else if(options.showLegend == true && options.showTitle == false){
           
            if(options.legendSide === "left"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",0.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }

            }
            else if(options.legendSide === "right"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",0.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
            }
            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",0.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
            }
            
        }
        else if(options.showLegend == false){

            if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 0.0 + "%"; }) .style("height", function(d) { return 0  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 100 + "%") .style('height', 70 + "%").style("position","absolute").style("background-color", options.BGcolor); 
			}
			else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
				legendPanelFront.style("width", function(d) { return 0.0 + "%"; }) .style("height", function(d) { return 0  + "%"; })
				.style("position","absolute") .style("left",65 + "%") .style("top",0.0  + "%").style("background-color", options.BGcolor);

				svgPanel.style('width', 100 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor); 
			}
			else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
				 legendPanelFront.style("width", function(d) { return 0.0 + "%"; }) .style("height", function(d) { return 0  + "%"; })
				.style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

				svgPanel.style('width', 100 + "%") .style('height', 85 + "%").style("position","absolute").style("background-color", options.BGcolor); 
			}
    
        }

            resizedFuctionForDonutChart();

        })
        
        var formForChangeSettingsPanel = settingPanelDivForDonutChart.append("form");
        formForChangeSettingsPanel.style("background-color","#fcfcfc").style("margin-top","67px").style("font-family","Verdana,sans-serif").style("font-size","12px")
        .style("position","absolute").attr("id","formForChangeColorSettingsPanel" + targetElement[0][0].id).style("font-weight","Bold").style("width","180px")
        .style("height","58px").style("padding","0px").style("border-radius","0px")
        .style("margin-left","10px")

        var svgPanelForColorSetOneForDonutChart = formForChangeSettingsPanel.append("svg").style("position","absolute")
        .style("background-color","#fefefe").style("width","160px").style("height","18px").style("margin-top","1px").style("margin-left","0px")
        .style("box-sizing","border-box")
        
        var colorSetOneForDonutChart = d3.scale.ordinal().range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        var colorSetOneRangeForDonutChart = d3.range(12);

        var colorSetOneDotsForDonutChart = svgPanelForColorSetOneForDonutChart.append("g")
        colorSetOneDotsForDonutChart.selectAll('rect') .data(colorSetOneRangeForDonutChart) .enter().append('rect')
        .attr('transform', 'translate(' + (2) + ',' + (1) + ')') .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10)
        .attr("height",10) .style("fill", function(d,i){return colorSetOneForDonutChart(i)}) .style("fill-opacity",0.93)
        .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetOneForDonutChart(i);  })
        .style("cursor","auto") .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        var svgPanelForColorSetTwoForDonutChart = formForChangeSettingsPanel.append("svg").style("position","absolute")
        .style("background-color","#fefefe").style("width","160px").style("height","18px").style("margin-top","20px").style("margin-left","0px")
        .style("box-sizing","border-box")
        
        var colorSetTwoForDonutChart = d3.scale.ordinal().range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        var colorSetTwoRangeForDonutChart = d3.range(12);

        var colorSetTwoDotsForDonutChart = svgPanelForColorSetTwoForDonutChart.append("g")
        colorSetTwoDotsForDonutChart.selectAll('rect') .data(colorSetTwoRangeForDonutChart) .enter().append('rect')
        .attr('transform', 'translate(' + (2) + ',' + (1) + ')') .attr("x",function(d,i){ return i*13;}) .attr("y",2)
        .attr("width",10) .attr("height",10) .style("cursor","auto") .style("fill", function(d,i){return colorSetTwoForDonutChart(i)})
        .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
        .style("stroke",function(d,i){  return colorSetTwoForDonutChart(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        var svgPanelForColorSetThreeForDonutChart = formForChangeSettingsPanel.append("svg").style("position","absolute")
        .style("background-color","#fefefe").style("width","160px").style("height","18px").style("margin-top","39px").style("margin-left","0px")
        .style("box-sizing","border-box")
        
		var colorSetThreeForDonutChart = d3.scale.ordinal().range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        var colorSetThreeRangeForDonutChart = d3.range(12);

        var colorSetThreeDotsForDonutChart = svgPanelForColorSetThreeForDonutChart.append("g")
        colorSetThreeDotsForDonutChart.selectAll('rect') .data(colorSetThreeRangeForDonutChart) .enter().append('rect')
        .attr('transform', 'translate(' + (2) + ',' + (1) + ')') .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10)
        .attr("height",10) .style("cursor","auto") .style("fill", function(d,i){return colorSetThreeForDonutChart(i)})
        .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
        .style("stroke",function(d,i){  return colorSetThreeForDonutChart(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        if(options.colorSet.toString().toLowerCase() === "one"){
            svgPanelForColorSetOneForDonutChart.style('border',"1px solid #808080")
            svgPanelForColorSetTwoForDonutChart.style('border',"0px solid #808080")
            svgPanelForColorSetThreeForDonutChart.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            svgPanelForColorSetOneForDonutChart.style('border',"0px solid #808080")
            svgPanelForColorSetTwoForDonutChart.style('border',"1px solid #808080")
            svgPanelForColorSetThreeForDonutChart.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            svgPanelForColorSetOneForDonutChart.style('border',"0px solid #808080")
            svgPanelForColorSetTwoForDonutChart.style('border',"0px solid #808080")
            svgPanelForColorSetThreeForDonutChart.style('border',"1px solid #808080")
        }
        else 
        {
            svgPanelForColorSetOneForDonutChart.style('border',"1px solid #808080")
            svgPanelForColorSetTwoForDonutChart.style('border',"0px solid #808080")
            svgPanelForColorSetThreeForDonutChart.style('border',"0px solid #808080")
        }

        svgPanelForColorSetOneForDonutChart.on('click',function(d){
            options.colorSet = "one"
            svgPanelForColorSetOneForDonutChart.style('border',"1px solid #808080")
            svgPanelForColorSetTwoForDonutChart.style('border',"0px solid #808080")
            svgPanelForColorSetThreeForDonutChart.style('border',"0px solid #808080")

            var color = d3.scale.ordinal().range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
            pathForDoNutChart.style('fill', function(d, i) {  return color(d.data[options.keys.label]); })
            legendGroup.style('fill', color).style('stroke', color)

        })
        svgPanelForColorSetTwoForDonutChart.on('click',function(d){
            options.colorSet = "two"
            svgPanelForColorSetOneForDonutChart.style('border',"0px solid #808080")
            svgPanelForColorSetTwoForDonutChart.style('border',"1px solid #808080")
            svgPanelForColorSetThreeForDonutChart.style('border',"0px solid #808080")

            var color = d3.scale.ordinal().range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
            pathForDoNutChart.style('fill', function(d, i) {  return color(d.data[options.keys.label]); })
            legendGroup.style('fill', color).style('stroke', color) 

        })
        svgPanelForColorSetThreeForDonutChart.on('click',function(d){
            options.colorSet = "three"
            svgPanelForColorSetOneForDonutChart.style('border',"0px solid #808080")
            svgPanelForColorSetTwoForDonutChart.style('border',"0px solid #808080")
            svgPanelForColorSetThreeForDonutChart.style('border',"1px solid #808080")

            var color = d3.scale.ordinal().range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
            pathForDoNutChart.style('fill', function(d, i) {  return color(d.data[options.keys.label]);   })
            legendGroup.style('fill', color).style('stroke', color)
        })

        // Creating gradient effect
        var changeGraidentEffectTitle = settingPanelDivForDonutChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','190px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Select Effect " +'</div>')
        
        var graidentEffectBtnDiv = settingPanelDivForDonutChart.append("div")
        .style("background-color","#fcfcfc").style("margin-left","200px").style("margin-top","67px")
        .style("font-family","Verdana,sans-serif").style("font-size","12px")
        .style("position","absolute").style("font-weight","Bold").style("width","70px")
        .style("height","30px").style("padding","0px").style("border-radius","0px")
        
        var circularButton = graidentEffectBtnDiv.append("div") .style("width","32px").style("height","26px").style('position','absolute')
        .style('background-color',"#ffffff").style('margin-left',"0px")
        .style('top','1px') .style("cursor","pointer").style("display","block") 
        .style("border-style", "none").style('padding',"0px") .style("border", "1px solid #a0a0a0").style("line-height","0px").style("box-sizing","border-box")
        var circularBtnImgVar = document.createElement("IMG");
        circularBtnImgVar.src = "images/circular.png";
        circularBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:20px; height:20px; opacity:0.8;")
        circularButton[0][0].appendChild(circularBtnImgVar)

        var noneButton = graidentEffectBtnDiv.append("div") .style("width","32px").style("height","26px").style('position','absolute')
        .style('background-color',"#ffffff").style('margin-left',"35px")
        .style('top','1px') .style("cursor","pointer").style("display","block") 
        .style("border-style", "none").style('padding',"0px").style("line-height","0px").style("box-sizing","border-box")
        var noneBtnImgVar = document.createElement("IMG");
        noneBtnImgVar.src = "images/none.png";
        noneBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:20px; height:20px; opacity:0.8;")
        noneButton[0][0].appendChild(noneBtnImgVar)

        // selecting the radio button based on .html file input
        if(options.gradient === undefined){
            circularButton.style('border',"0px solid #808080")
            noneButton.style('border',"1px solid #808080")
        }
        else if(options.gradient.toString().toLowerCase() === "circular"){
            circularButton.style('border',"1px solid #808080")
            noneButton.style('border',"0px solid #808080")
        }
        else if(options.gradient.toString().toLowerCase() === "none"){
            circularButton.style('border',"0px solid #808080")
            noneButton.style('border',"1px solid #808080")
        }
        else 
        {
            circularButton.style('border',"0px solid #808080")
            noneButton.style('border',"1px solid #808080")
        }

        circularButton.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var tooltipText = "Circular";
            iconButtonTooltip.style("width","72px").style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; padding-left:16px; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; ">'+ tooltipText +'</div>')
        })
        circularButton.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        noneButton.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var tooltipText = "None";
            iconButtonTooltip.style("width","58px").style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; padding-left:16px; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; ">'+ tooltipText +'</div>')
        })
        noneButton.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        // Gradient button on click
        circularButton.on('click',function(d){
            options.gradient = "circular";
            circularButton.style('border',"1px solid #808080")
            noneButton.style('border',"0px solid #808080")

            var removeStop = radialGradient.selectAll("stop").remove();

            radialGradient.append("stop").attr("offset", "55%").style("stop-color", function(d, i) { return "#ffffff"; });
            radialGradient.append("stop").attr("offset", "88%").style("stop-color", "#404040");
            radialGradient.append("stop").attr("offset", "100%").style("stop-color", function(d, i) { return "#ffffff"; });
			
			pathForDoNutChart.style("fill-opacity", 0.8);

        })
        noneButton.on('click',function(d){
            options.gradient = "none";
            circularButton.style('border',"0px solid #808080")
            noneButton.style('border',"1px solid #808080")

            var removeStop = radialGradient.selectAll("stop").remove();
			
			pathForDoNutChart.style("fill-opacity", 1);
        
        })

        //------------------ Settings panel DIV and everything inside it ends here ------------------

        var width1ForDonutChart = targetElement[0][0].clientWidth * (parseFloat(svgPanel[0][0].style.width) / 100)
        var height1ForDonutChart = targetElement[0][0].clientHeight * (parseFloat(svgPanel[0][0].style.height) / 100)

        var radiusForDoNutChart = Math.min(width1ForDonutChart, height1ForDonutChart) / 3.0;
        
        if(options.showTitle == false && options.showLegend == false){
            radiusForDoNutChart = Math.min(width1ForDonutChart, height1ForDonutChart) / 2.8;
        }
        else if(options.showTitle == true && options.showLegend == false){
            radiusForDoNutChart = Math.min(width1ForDonutChart, height1ForDonutChart) / 2.5;
        }
        
        var toolTipForDonutChart = targetElement .append('div') .attr('class', 'tooltipClassForDonutChart') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
        .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
        .style("padding-right", "7px") .style("font", "12px sans-serif") .style("background", "#F8F8F8") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888")
        .style("border", "0.1em") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","100px").style("z-index",1000)
        
        toolTipForDonutChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'label').style("color","#000000").style("text-transform","capitalize").style("padding","1px").style("font-size", "12px").style("font-weight", "Bold") ;
        toolTipForDonutChart.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
        toolTipForDonutChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#000000").style("text-transform","capitalize").style("padding","1px").style("font-size", "12px").style("font-weight", "Bold") ;
        
        
        // Getting min and max value from options.data
        var minAndMaxValuesArrayForDoNutChart = []
            newJson.forEach(function(d, i) {
                var dd = parseFloat(d[options.keys.value])
                minAndMaxValuesArrayForDoNutChart.push(dd) 
        });
        
        var low = d3.min(minAndMaxValuesArrayForDoNutChart);
        var hig = d3.max(minAndMaxValuesArrayForDoNutChart);

        var searchChartButton = optionsButtonPanelForDonutChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff").style('margin-left','2px').style('top','1px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #888888") .style("border-style", "none")
        var searchBtnImgVar = document.createElement("IMG");
        searchBtnImgVar.src = "images/searchChart1.png";
        searchBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.8;")
        searchChartButton[0][0].appendChild(searchBtnImgVar)

        var threeDViewButtonForDonutChart = optionsButtonPanelForDonutChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff").style('margin-left','2px').style('top','27px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #888888") .style("border-style", "none")
        var threeDViewBtnImgVar = document.createElement("IMG");
        threeDViewBtnImgVar.src = "images/3DView.png";
        threeDViewBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.8;")
        threeDViewButtonForDonutChart[0][0].appendChild(threeDViewBtnImgVar)

        var tableButtonForDonutChart = optionsButtonPanelForDonutChart.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 53 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
        var tableBtnImgVar = document.createElement("IMG");
        if(showOrHideTableForDonutChart == false){
            tableBtnImgVar.src = "images/showTableIcon.png";
            tableButtonForDonutChart.attr("class","showTableClassForChartTable")
        }
        else if(showOrHideTableForDonutChart == true){
            tableBtnImgVar.src = "images/cancelTableIcon.png";
            tableButtonForDonutChart.attr("class","hideTableClassForChartTable")
        }
        tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
        tableButtonForDonutChart[0][0].appendChild(tableBtnImgVar)

        var settingBtnForDonutChart = optionsButtonPanelForDonutChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 80 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        var settingBtnImgVar = document.createElement("IMG");
        settingBtnImgVar.src = "images/settingsIcon.png";
        settingBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.82;")
        settingBtnForDonutChart[0][0].appendChild(settingBtnImgVar)
        
        // Calling Bubble-Chart (changing chart)
        bubbleButtonForDonutChart.on('click', function() {
            
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            
            var newOptions = {
                data: newJson,
                dataForTable: options.dataForTable,
                isDataDetailedForTable: options.isDataDetailedForTable,
                keys: {
                    label: options.keys.label,
                    value: options.keys.value
                },
                chartTitle: options.chartTitle,
                showTitle: options.showTitle,
                colorSet: options.colorSet,
                BGcolor:options.BGcolor,
                series:options.series,
                legend:options.legend,
                drillDownColumnName:options.drillDownColumnName,
                showTable: false,
                showComments: options.showComments,
                comments: options.comments,
                resizeButtonID: options.resizeButtonID
            }
            acinfotech.bubbleChart(targetElement, newOptions)
        })

        // Calling Pie-Chart (changing chart)
        pieButtonForDonuteChart.on('click', function() {
            options.showTable = false;
            colorSet: options.colorSet,
            options.gradient = "none";
            BGcolor:options.BGcolor;
            series:options.series;
                   legend:options.legend;
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            acinfotech.pieChart(targetElement, options)
        })

        // Calling Column-Chart (changing chart)
        colButtonForDonutChart.on('click', function() {
            options.showTable = false;
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            var newOptions = {
                   data: newJson,
                   dataForTable:options.dataForTable,
                   isDataDetailedForTable: options.isDataDetailedForTable,
                   keys: {
                       label: options.keys.label,
                       value: options.keys.value
                   },
                   chartTitle:options.chartTitle,
                   xAxisLable:options.keys.label,
                   yAxisLable:options.keys.value,
                   showTitle:options.showTitle,
                   colorSet: options.colorSet,
                   BGcolor:options.BGcolor,
                   series:options.series,
                   legend:options.legend,
                   drillDownColumnName:options.drillDownColumnName,
                   showTable:options.showTable,
                   showComments: options.showComments,
                   comments: options.comments,
                   resizeButtonID: options.resizeButtonID
               }
            acinfotech.columnChart(targetElement, newOptions)
        })

        // Calling Horizontal-Chart (changing chart)
        horButtonForDonutChart.on('click', function() {
            options.showTable = false;
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            //resetButton.remove();
           var newOptions = {
                   data: newJson,
                   dataForTable:options.dataForTable,
                   isDataDetailedForTable: options.isDataDetailedForTable,
                   keys: {
                       label: options.keys.label,
                       value: options.keys.value
                   },
                   chartTitle:options.chartTitle,
                   xAxisLable:options.keys.value,
                   yAxisLable:options.keys.label,
                   showTitle:options.showTitle,
                   colorSet: options.colorSet,
                   BGcolor:options.BGcolor,
                   series:options.series,
                   legend:options.legend,
                   drillDownColumnName:options.drillDownColumnName,
                   showTable:options.showTable,
                   showComments: options.showComments,
                   comments: options.comments,
                   resizeButtonID: options.resizeButtonID
               }
            acinfotech.horizontalChart(targetElement, newOptions)
        })

        // refreshing chart and table
        refreshButtonForDonutChart.on('click', function() {

            isFilterClickedForDoNutChart = false

            if(isThreeDDonutChartEnabled == true){
                backButtonForDonutChart.remove();
            }

            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData;
                }
            }
            acinfotech.donutChart(targetElement,options)

        })

        // showing/hidding chart table
        tableButtonForDonutChart.on('click', function() {

            if(showOrHideTableForDonutChart == false){
                options.showTable = true;
			}
            else if(showOrHideTableForDonutChart == true){
                options.showTable = false;
            }

            isFilterClickedForDoNutChart = false;

            if(isThreeDDonutChartEnabled == true){ // Checking if 3D Donut-Chart is enabled
                backButtonForDonutChart.remove();
            }

            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                    options.showComments = false;
                }
            }
            acinfotech.donutChart(targetElement,options)

        })

        // Showing setting panel
        settingBtnForDonutChart.on('click', function() {
                
                ismenuButtonOfDonutChartClicked = false
                optionsButtonPanelForDonutChart.style("display","none") // Hiding option buttons panel

                iconButtonTooltip.style("display","none") // Hiding options button ToolTip
                settingBtnForDonutChart.style("cursor","pointer") // Changing mouse pointer
                
                if(isThreeDDonutChartEnabled == true){ // checking if 3D Pie Chart enabled
                    svgForHolding3DDonutChart.remove();
                    svgForHolding3DDonutChartLegends.remove();
                    backButtonForPieChart.remove();
                    iconButtonTooltip.style("display","none")
                }

                settingPanelDivForDonutChart.style("display","block") // Showing setting panel

                if(options.showLegend == true && options.showTitle == true){
            
            if(options.legendSide === "left"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("left",30 + "%") .style("top",8.0  + "%")
                    svgPanel.style("position","absolute").style("background-color", options.BGcolor);
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }

            }
            else if(options.legendSide === "right"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }

            }
            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                
            }
        }
        else if(options.showLegend == true && options.showTitle == false){
           
            if(options.legendSide === "left"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }

            }
            else if(options.legendSide === "right"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
            }
            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
            }
            
        }
        else if(options.showLegend == false){
            legendPanelFront.style("width", function(d) { return 0.0 + "%"; }) .style("height", function(d) { return 0.0  + "%"; })
            .style("position","absolute") .style("left",0 + "%") .style("top",0.0  + "%").style("background-color", options.BGcolor);
            svgPanel.style('width', 100 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
        }

                resizedFuctionForDonutChart();

        })
        
        // showing/hidding chart comment panel
        commentsBtnForDonutChart.on('click', function() {

            if(options.showComments == false){ 
                options.showComments = true;
            }
            else if(options.showComments == true){ 
                options.showComments = false;
            }

            isFilterClickedForDoNutChart = false

            if(isThreeDDonutChartEnabled == true){ // Checking if 3D Donut-Chart is enabled
                backButtonForDonutChart.remove();
            }

            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove(); // Remove all elements within Parent DIV
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                    options.showTable = false;
                }
            }
            acinfotech.donutChart(targetElement,options)

        })
        
        downloadBtnForDonutChart.on('click', function() {
                                  
          ismenuButtonOfDonutChartClicked = false; // Changing menu button value to false
          optionsButtonPanelForDonutChart.style("display","none") // Hiding option buttons panel
          
          toolTipForDonutChart.style("display","none") // Hiding button tooltip
          
        })
        
        // Showing filter panel
        filterButtonForDonutChart.on('click', function() {

            ismenuButtonOfDonutChartClicked = false
            optionsButtonPanelForDonutChart.style("display","none") // Hiding option buttons panel
            
            isFilterClickedForDoNutChart = false
            $(function() { 
                    
                    $('#' + targetElement[0][0].id + "doNutChartRangeSliderID").css({
                            'background': '#ffffff'
                        });
                    
                    $( '#' + targetElement[0][0].id + "doNutChartRangeSliderID" ).slider({
                    orientation: "horizontal",
                    min: 0,//d3.min(minAndMaxValuesArrayForPieChart),
                    max: d3.max(minAndMaxValuesArrayForDoNutChart),
                    step: 1,
                    values: [low,hig],
                    animate: true,
                    range : true,
                    slide: function(event, ui) {
                        filterRangeValueOneForDoNutChart = 0;
                        filterRangeValueTwoForDoNutChart = 0
                        textBoxOneForDoNutChart.attr("value",ui.values[0])
                        textBoxTwoForDoNutChart.attr("value",ui.values[1])
                        filterRangeValueOneForDoNutChart = ui.values[0]
                        filterRangeValueTwoForDoNutChart = ui.values[1]

                        $('#' + targetElement[0][0].id + "doNutChartRangeSliderID").slider().find(".ui-slider-range").css({
                            'background': '#001c3b'});
                    },
                   
                });
            });
    
                //searchDivForDoNutChart.style("display","block")
                resetTableWidthOldDataFunction() 

                iconButtonTooltip.style("display","none") // Hiding icon tool tip
                filterButtonForDonutChart.style("cursor","pointer")
                
                searchDivForDoNutChart.style("display","block") // Showing filter panel
                settingPanelDivForDonutChart.style("display","none") // Hiding settings panel

                if(options.showLegend == true && options.showTitle == true){
            
            if(options.legendSide === "left"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("left",30 + "%") .style("top",8.0  + "%")
                    svgPanel.style("position","absolute").style("background-color", options.BGcolor);
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }

            }
            else if(options.legendSide === "right"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }

            }
            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                } 
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                
            }
        }
        else if(options.showLegend == true && options.showTitle == false){
           
            if(options.legendSide === "left"){http://localhost:64194/
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }

            }
            else if(options.legendSide === "right"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
            }
            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
            }
            
        }
        else if(options.showLegend == false){
            legendPanelFront.style("width", function(d) { return 0.0 + "%"; }) .style("height", function(d) { return 0.0  + "%"; })
            .style("position","absolute") .style("left",0 + "%") .style("top",0.0  + "%").style("background-color", options.BGcolor);
            svgPanel.style('width', 100 + "%") .style('height', 52 + "%") .style("top",8.0  + "%") .style("position","absolute").style("background-color", options.BGcolor); 
        }

                resizedFuctionForDonutChart();

                if(isThreeDDonutChartEnabled == true){ // checking if 3D Pie-Chart enabled
                    svgForHolding3DDonutChart.remove();
                    svgForHolding3DDonutChartLegends.remove();
                    backButtonForPieChart.remove();
                    iconButtonTooltip.style("display","none")
                }
            
        }) //filterChartButton.on('click', function() )
    
        // Creating DIV for holding Search Table (Temporary Table) when Search button is clicked.
        var tempDivTableForDonutChart;
        var isSearchInTableButtonClicked = false;

        var canBtnForSearchDivForSearchTableForDonutChart;

        // Creating left panel for holding Search Box and small Column Chart and on RHS Search Table (Temporary Table) when Search button is clicked.
        searchChartButton.on('click', function() {
            
            ismenuButtonOfDonutChartClicked = false
            optionsButtonPanelForDonutChart.style("display","none")

            isSearchInTableButtonClicked = true;

            // Div for disabling whole Chart and Main Table expect Search panel and Search Table
            var disabledDivForDonutChartForSearchTable = targetElement.append('div').style('width',100 + "%").style('height',100 + "%").style('position','absolute')
            .style("background-color",'#f3f3f3').style("z-index",2).style("display","none").style('top', 0.0 + "%").style('left', 0.0 + "%")
            .style("opacity",0.3).style("min-width","350px").style("min-height","350px") //005ec4

            //Creaing left panel for holding Search Box and small Column Chart
            var searchDivForDonutChartForSearchTable = targetElement.append('div').style('width',100 + "%").attr("class", "searchDivForDonutChartForSearchTableClass" + targetElement[0][0].id)
            .style('position','absolute').style('margin-left', "0px")
            .style("background-color",'#ffffff').style("z-index",90).style("border-color", "#ffffff")
            .style("display","block").style('top', 60.0 + "%").style('height', 40.0 + "%")
            .style("border-top","1px solid #f0f0f0")

            // Title for Search panel
            var searchDivForDonutChartForSearchTableTitle = searchDivForDonutChartForSearchTable.append('div').style('background-color',"#e9e9e9").attr("fant-family", "Verdana,sans-serif").style("font-weight", "Bold")
            .style('margin-left','0px').style('margin-top','0px').style('text-indent','3px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
            .style("width","100"+"%").style("height","15" + "%").style("color","#000000")
            //.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter;  color:#202f34; font-weight:Bold;">'+ "Search" +'</div>')

            // DIV for holding small Column-Chart
            var smallChartAreaDivForDonutChart =searchDivForDonutChartForSearchTable.append('div').style('width',100 + "%").style('height',100 + "%").style('position','absolute')
            .style("background-color",'#ffffff').style("z-index",2).style("display","block").style('top', 0.0 + "px").style('left', 0.0 + "px")
            .style("opacity",1.0).attr("id","smallColumnChartIDForDonutChart" + targetElement[0][0].id)

            // DIV for holding Search Table
            tempDivTableForDonutChart = targetElement.append('div').style('width',100 + "%").style('height', 60.0 + "%").style('top', 0.0 + "%")
            .style('position','absolute').style('margin-left', "0px")
            .style("background-color",'#ffffff').style("z-index",90).style("border-color", "#ffffff")
            .style("display","block")

            // Title DIV for Search Table
            var searchResultTableDivTitleForDonutChart = tempDivTableForDonutChart.append('div').style('background-color',"#e9e9e9").attr("fant-family", "Verdana,sans-serif").style("font-weight", "Bold")
            .style('margin-left','0px').style('margin-top','0px').style('text-indent','3px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
            .style("width","100"+"%").style("height","15" + "%").style("color","#000000")
            .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:14px; font-family:inter;  color:#ffffff; font-weight:Bold;">'+ "Search Result" +'</div>')

             // Search Text Box for Search panel
            var searchTextBoxForDonutChart = searchResultTableDivTitleForDonutChart.append('input').style("width","220px").style('margin-left','1px').style('margin-top','2px')
            .style('position',"absolute").style('height',"26px").style("border", "1.0px") .style("border-color", "#e8e8e8") .style("border-style", "solid").style('text-indent','30px')
            .attr("placeholder","eg: sales").attr("id","autoSearchTextBoxForDonutChart" + targetElement[0][0].id)
            .style("background-image","url('images/searchChart.png')").style("background-repeat","no-repeat")//.style("background-position","right")
            .style("background-size",'18px 18px').style("background-position",'5px 3px').style("display","block")
            .style("font-size","14px").style("font-weight","Normal").style("line-height","Normal") .style("box-sizing","border-box")
            .style('outline-width','0px')

            canBtnForSearchDivForSearchTableForDonutChart = searchResultTableDivTitleForDonutChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
            .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
            .style('background-color',"#e9e9e9")
            .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
            .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
            var cancelBtnImgVar = document.createElement("IMG");
            cancelBtnImgVar.src = "images/closeIcon.png";
            cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.87; background-color:#e9e9e9")
            canBtnForSearchDivForSearchTableForDonutChart[0][0].appendChild(cancelBtnImgVar)
            
            // Enabling whole Chart and Table and removing Search panel and Search Table, when Cancel button of Search panel is called.
            canBtnForSearchDivForSearchTableForDonutChart.on('click', function() {

                disabledDivForDonutChartForSearchTable.remove();
                searchDivForDonutChartForSearchTable.remove();
                tempDivTableForDonutChart.remove()

                if(isThreeDDonutChartEnabled == true){
                    backButtonForPieChart.remove();
                }

                d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            
                for(var i = 0; i<divAndChartsArray.length; i++){

                    if(targetElement[0][0].id === divAndChartsArray[i].divID){
                        options.data = divAndChartsArray[i].optionsData
                    }
                }
                acinfotech.donutChart(targetElement,options)
            })          
            
            // DIV for holing only Search Table
            var searchResultTablePanelForDonutChart =  tempDivTableForDonutChart.append("div")
            .attr("class", "searchResultTablePanelForPieChart" + targetElement[0][0].id)
            .style('background-color',"#ffffff") .style('position','absolute') .style("display","block") .style("overflow","auto")
            .style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 85 + "%"; }) .style("left",0 + "%")
            .style("top","15"+"%")

            // Creating Table (Search Table)
            searchResultTablePanelForDonutChart.html('<table  border="0px" style=" width:99.9%; height:auto;   position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9px; border-collapse:collapse; border-color:#ebf5e6; " >'+
              '<thead  style="background-color:#DFF0D8;">' +'</thead>'+
              '<tbody class="myTBody" style="background-color:white; width:99.9%; height:auto;  ">'+'</tbody>'+
              '</table>'
              )
            searchResultTablePanelForDonutChart.select("table").attr("id","searchTableIdForDonutChart" + targetElement[0][0].id)

            // Setting colors for Search Column-bars
            var colors = d3.scale.ordinal() .range(["#ff6c3e", "#ffbb03", "#3fcb56", "#d05767", "#55bf9b", "#0095b3", "#7a92a9","#663399","#29b5eb","#ff9878","#CCCCCC","#008d8d"]);

            var thead = searchResultTablePanelForDonutChart.select("thead").selectAll("th") .data(d3.keys(newJson[0]))
            .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1) + " "}).style("min-width","100px").style("color","#00001c")
        
            var tr = searchResultTablePanelForDonutChart.select("tbody").selectAll("tr") .data(newJson).enter().append("tr") //.style("background-color",function(d,i){  return colors(i);})
        
            var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d})
            .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")

            // Filtering the Search Table 
            $(document).ready(function(){
                var tblBodyObj = document.getElementById("searchTableIdForDonutChart" + targetElement[0][0].id).tBodies[0];
                
                for (var i=0; i<tblBodyObj.rows.length; i++) {

                    var newCell = tblBodyObj.rows[i].insertCell(-1);
                    newCell.style.minWidth = "20px";
                    newCell.style.maxWidth = "20px";
                    newCell.style.textAlign = "left"
                   
                    var div = document.createElement('div')
                    div.style.width = "15px";
                    div.style.height = "35%";
                    div.style.borderRadius = "0px";
                    div.style.opacity = 0.9;
                    div.style.minWidth = "15px"
                    div.style.maxWidth = "15px"
                    div.style.background = colors(i);
                    newCell.appendChild(div);
                }   
            });

            searchResultTablePanelForDonutChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
            .style("color","#00001c")
            .style("height","25px").style("border", "1px solid #e9e9ea").style("background-color","#f6f6f6")
            searchResultTablePanelForDonutChart.selectAll('td').style("height","25px") .style("border", "1px solid #f8f8f8") .style("font-size","12px").style("font-weight","Normal").style("color","#00001c")

            // Calling smallColumnChart with orignal data and limited options.
            var chartElement = d3.select("#smallColumnChartIDForDonutChart" + targetElement[0][0].id);
            var smallColumnChartoptions = {
                           data: options.data,
                           BGcolor:options.BGcolor,
                           keys: {
                               label: options.keys.label,
                               value: options.keys.value
                           },
                           xAxisLable: options.keys.label,
            }
            acinfotech.smallColumnChart(chartElement,smallColumnChartoptions)    

                // Array to hold searched items (full object)
                var searchTextBoxArrayForDonutChart = [];

                $(document).ready(function(){
                    $("#" + "autoSearchTextBoxForDonutChart" + targetElement[0][0].id).off('input');
                    $("#" + "autoSearchTextBoxForDonutChart" + targetElement[0][0].id).on('keyup', function(){
                        textChangedFunction(this.value)
                    });
                });
                 
                 // function to search data in original set of data with Search Box entered value.
                 function textChangedFunction (val) {
                    var textBoxValueLowerCased = val //this.value
                    searchTextBoxArrayForDonutChart = [];
        
                    newJson.forEach(function(d, i) { //--------------
                        var dd = d3.values(d);
                        var eachObjectArray = [];
                        eachObjectArray.push(d3.values(d))
                        d[options.keys.value] = d[options.keys.value].toString();
                
                    for(var i = 0; i<Object.keys(d).length; i++){
                        var lower = d3.values(d)[i].toString().toLowerCase()
                        if ( lower.toLowerCase().indexOf(textBoxValueLowerCased.toLowerCase()) > -1 ) {
                            searchTextBoxArrayForDonutChart.push(d)
                            break;
                        }
                    }
                });
                
                // clearing smallColumnChart DIV each time a keyboard key is hit.
                smallChartAreaDivForDonutChart.selectAll("*").remove();    
                var chartElement = d3.select("#smallColumnChartIDForDonutChart" + targetElement[0][0].id);
                var smallColumnChartoptions = {
                           data: searchTextBoxArrayForDonutChart,
                           BGcolor:options.BGcolor,
                           keys: {
                               label: options.keys.label,
                               value: options.keys.value
                           },
                           chartTitle:"Revenue by Region",
                           xAxisLable: options.keys.label,
                        }
                if(searchTextBoxArrayForDonutChart.length == 0){
                    smallChartAreaDivForDonutChart.selectAll("*").remove();     
                }
                else {
                    acinfotech.smallColumnChart(chartElement,smallColumnChartoptions)    
                }
            
            // Removing the Search Table Rows
            var table = searchResultTablePanelForDonutChart.select('table');
            var rows = table.selectAll('tr')
            rows.remove();

            // Creating new Rows for Search Table based on Searched Result (using searchTextBoxArrayForPieChart array)
            var table = searchResultTablePanelForDonutChart.select('table');
            var rows = table.selectAll('tr').data(searchTextBoxArrayForDonutChart);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})

            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(20) .duration(20) .style('opacity', 1.0) .style("color","#00001c");
            
            cells.text(function(d,i) {return d});

            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(20) .duration(20) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})

            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(20)
            .duration(20) .style('opacity', 1.0) .style("color","#00001c");

            // Adding new row for color dots in Search Table
            $(document).ready(function(){
                
                for (var i=0; i<table[0][0].rows.length; i++) {

                    var newCell = table[0][0].rows[i].insertCell(-1);
                    newCell.style.minWidth = "20px";
                    newCell.style.maxWidth = "20px";
                    newCell.style.textAlign = "left"
                   
                    var div = document.createElement('div')
                    div.style.width = "15px";
                    div.style.height = "35%";
                    div.style.borderRadius = "0px";
                    div.style.opacity = 0.9;
                    div.style.minWidth = "15px"
                    div.style.maxWidth = "15px"
                    div.style.background = colors(i);
                    newCell.appendChild(div);
                }
            });

            var t = document.getElementById("searchTableIdForDonutChart" + targetElement[0][0].id).tBodies[0]
            
            cells_in_new_rows.text(function(d,i) {return d});

            rows.exit() .attr('class', 'exit') .transition() .delay(20) .duration(20) .style('opacity', 0.0) .remove();

            // Checking the Browser
            if(navigator.userAgent.indexOf("Firefox") != -1 ) 
            {
                table.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("text-align","left").style("padding-left","6px").style("color","#00001c")
                .style("height","25px") .style("border", "1px solid #b1da9f") 
            
                searchResultTablePanelForDonutChart.selectAll('td').style("height","25px") .style("border", "1px solid #ffffff") .style("font-size","12px").style("padding-left","6px")
                .style("font-weight","Normal").style("color","#00001c")
            }

            else{
                
                searchResultTablePanelForDonutChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("text-align","left").style("padding-left","6px").style("color","#00001c")
                .style("height","25px") .style("border", "1px solid #e9e9ea").style("background-color","#f6f6f6")  
            
                searchResultTablePanelForDonutChart.selectAll('td').style("height","25px") .style("border", "1px solid #f8f8f8") .style("font-size","12px").style("padding-left","6px")
                .style("font-weight","Normal").style("color","#00001c")
            }

        }//textChangeFunction ends here
            
            // Disabling Browser page scrolling when Search left panel appears
            $( '.searchDivForDonutChartForSearchTableClass' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
                var e0 = e.originalEvent,
                delta = e0.wheelDelta || -e0.detail;
    
                this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
                e.preventDefault();
            });

            // Disabling Browser page scrolling when Search Table appears
            $( '.searchResultTablePanelForDonutChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
                var e0 = e.originalEvent,
                delta = e0.wheelDelta || -e0.detail;
    
                this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
                e.preventDefault();
            });

            // Removing options button ToolTip, changing mouse pointer, disabling Chart and Main Table and expanding Search panel and Search Table. 
            iconButtonTooltip.style("display","none")
            searchChartButton.style("cursor","auto")
            //disabledDivForDonutChartForSearchTable.style("display","block")
            searchDivForDonutChartForSearchTable.style("display","block")//.transition().style('width', 260 + "px").duration(50).delay(50)


        }) //searchChartButton.on('click', function()

        var isThreeDDonutChartEnabled = false;
        var svgForHolding3DDonutChart;
        var svgForHolding3DDonutChartLegends;
        var svgForHolding3DDonutChart_X;
        var svgForHolding3DDonutChart_Y;
        var backButtonForDonutChart;
        var legendFor3DDonutChart;
        var colorsForThreeDPieChart = d3.scale.ordinal() .range(["#DC3912", "#ffbb03", "#5d420b", "#4f9f00", "#9a270c", "#511414", "#808000","#307D7E","#AF7817","#00264e","#009bb9","#944c0d"]);
        threeDViewButtonForDonutChart.on('click', function() {

            ismenuButtonOfDonutChartClicked = false
            optionsButtonPanelForDonutChart.style("display","none") // Hiding option buttons panel 

            if(isThreeDDonutChartEnabled == true){ // Checking if 3D Pie-Chart enabled
                svgForHolding3DDonutChart.remove()
                svgForHolding3DDonutChartLegends.remove()
                backButtonForDonutChart.remove()
            }

            isThreeDDonutChartEnabled = true;

            // creating SVG for holding 3D view Pie-Chart
            svgForHolding3DDonutChart = targetElement.append("svg").style("position","absolute").style("background-color",options.BGcolor)

            // creating SVG for holding 3D view Legends
            svgForHolding3DDonutChartLegends = targetElement.append("svg").style("position","absolute").style("background-color",options.BGcolor)

            if(options.showTitle == true){
                
                if(showOrHideTableForDonutChart == false){ 
                    svgForHolding3DDonutChart.style("width",65 + "%").style("height",85 + "%").style("top",8+"%").style("left",0 + "%")
                    .style("background-color",options.BGcolor)//.attr("id","svgForHolding3DDonutChartID" + targetElement[0][0].id)

                    svgForHolding3DDonutChartLegends.style("width",35 + "%").style("height",85 + "%").style("top",8+"%").style("left",65 + "%")
                    .style("background-color",options.BGcolor)//.attr("id","svgForHolding3DDonutChartID" + targetElement[0][0].id)
                }   
                else if(showOrHideTableForDonutChart == true){ 
                    svgForHolding3DDonutChart.style("width",65 + "%").style("height",52 + "%").style("top",8+"%").style("left",0 + "%")
                    .style("background-color",options.BGcolor)//.attr("id","svgForHolding3DDonutChartID" + targetElement[0][0].id)

                    svgForHolding3DDonutChartLegends.style("width",35 + "%").style("height",52 + "%").style("top",8+"%").style("left",65 + "%")
                    .style("background-color",options.BGcolor)//.attr("id","svgForHolding3DDonutChartID" + targetElement[0][0].id)
                }

                svgForHolding3DDonutChart_X = (targetElement[0][0].clientWidth * (parseFloat(svgForHolding3DDonutChart[0][0].style.width) / 100))/2
                svgForHolding3DDonutChart_Y = (targetElement[0][0].clientHeight * (parseFloat(svgForHolding3DDonutChart[0][0].style.height) / 100))/2
                svgForHolding3DDonutChart.append("g").attr("id","svgForHolding3DDonutChart"+targetElement[0][0].id);

                var threeDPieChartRadius_rx = Math.min(svgForHolding3DDonutChart_X * 2, svgForHolding3DDonutChart_Y * 2) / 2.2
                var threeDPieChartRadius_ry = Math.min(svgForHolding3DDonutChart_X * 2,svgForHolding3DDonutChart_Y * 2) / 4.7
                
                threeDPieChartCallFunction("svgForHolding3DDonutChart"+targetElement[0][0].id, options.data, svgForHolding3DDonutChart_X,svgForHolding3DDonutChart_Y, threeDPieChartRadius_rx, threeDPieChartRadius_ry, 25, 0.40)
            }
            else if(options.showTitle == false){

                if(showOrHideTableForDonutChart == false){ 
                    svgForHolding3DDonutChart.style("width",100 + "%").style("height",85 + "%").style("top",0+"%").style("lef",0 + "%")
                    .style("background-color","007aff")
                }   
                else if(showOrHideTableForDonutChart == true){ 
                    svgForHolding3DDonutChart.style("width",100 + "%").style("height",60 + "%").style("top",0+"%").style("lef",0 + "%")
                    .style("background-color","007aff")
                }

                threeDPieChartCallFunction()
            }

            backButtonForDonutChart = targetElement.append("button").style("width","40px").style("height","23px").style('position','absolute').style('padding',"0px")
            .style("box-shadow", "0px 1px 1px #B8B8B8") .style('background-color',"#484848").style('margin-left','0px').style('top', parseFloat(chartTitlePanel.style("height")) + (2) + 'px')
            .style("cursor","pointer").style("display","block").style("box-shadow", "0px 1px 1px #B8B8B8") .style("border-style", "none").style("font-family","Verdana,sans-serif")
            .style("color","#ffffff").style("border-radius","0px")
            var backBtnImgVar = document.createElement("IMG");
            backBtnImgVar.src = "images/backButton.png";
            backBtnImgVar.setAttribute("style","position:absolute; left:10px; top:1px; width:18px; height:18px;")
            backButtonForDonutChart[0][0].appendChild(backBtnImgVar)
            
            backButtonForDonutChart.on('mouseover', function(d,i) {
                var reloadButtonTooltipText = "Back to 2D View";
                var titleHeight = parseFloat(chartTitlePanel.style("height"))
                iconButtonTooltip.style("width","100px").style("height","50px").style("margin-left", (1) + "px").style("margin-top",(titleHeight + 35) + "px").style("display","block")
                iconButtonTooltip.html('<div  style="width: 100%; height:0%; padding-left:9px; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; ">'+ reloadButtonTooltipText +'</div>')
            })
            backButtonForDonutChart.on('mouseout', function(d,i) {
                iconButtonTooltip.style("display","none")
            })

            backButtonForDonutChart.on('click', function() {
                isThreeDDonutChartEnabled = false;
                svgForHolding3DDonutChart.remove();
                svgForHolding3DDonutChartLegends.remove();
                backButtonForDonutChart.remove();
                iconButtonTooltip.style("display","none")

                ismenuButtonOfDonutChartClicked = false
                optionsButtonPanelForDonutChart.style("display","none")
            })
            
            var _data = d3.layout.pie().sort(null).value(function(d) {return d[options.keys.value];});

            var legendRectSize = 11;
            var legendSpacing = 5;

            legendFor3DDonutChart = svgForHolding3DDonutChartLegends.selectAll('.legend') .data(colorsForThreeDPieChart.domain()) .enter() .append('g') .attr('class', 'legend')
            .attr('transform', function(d, i) {
              
				var height = legendRectSize + legendSpacing;
				var offset =  height * colorsForThreeDPieChart.domain().length / 2;
				var horz = 2;
				var vert = (i * height) + ((targetElement[0][0].clientHeight * (parseFloat(svgForHolding3DDonutChart[0][0].style.height) / 100)) - (height * options.data.length))/2 ;
				return 'translate(' + horz + ',' + vert + ')';
              
			})
        
        // Creating Legends
        var legendGroup = legendFor3DDonutChart.append('rect') .attr('width', legendRectSize + 0) .attr('height', legendRectSize) .style('fill', colorsForThreeDPieChart) .style('stroke', colorsForThreeDPieChart) .attr("rx", 5.0) .attr("ry", 5.0)
        .style('stroke', colorsForThreeDPieChart) .attr("rx", 10.0) .attr("ry", 10.0).style("cursor","auto")

        var legendText = legendFor3DDonutChart.append('text').data(pieForDoNutChart(newJson)) .attr('x', legendRectSize + legendSpacing + 1) .attr('y', legendRectSize - (legendSpacing - 4.8)) .style("font-family","Verdana,sans-serif") .style("font-size", "14px")
		.style('fill','#00001c') .style("font-weight","Normal")
            .text(function(d,i) {
             if(d.data[options.keys.label].length > 10){
                    return d.data[options.keys.label].substring(0,10)+'...'; //+ ' '+ " : "+ d.data[options.keys.value] +"";
                }
                   else{
                    
                    return d.data[options.keys.label]; //+" "+ d.data[options.keys.value] +"";
                }
            }) // legendText 

            
            var legendTextValue = legendFor3DDonutChart.append('text').data(pieForDoNutChart(newJson)).attr('x', legendRectSize + legendSpacing + 130) .attr('y', legendRectSize - (legendSpacing - 4.8)) .style("font-family","Verdana,sans-serif") .style("font-size", "12px")
            .style('fill','#00001c') .style("font-weight","Normal").attr("class","legend_value").style("display","none")
            //.text(function(d,i) { return d.data[options.keys.value].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); })
            .text(function(d,i) { 
                if(d.data[options.keys.value].toString().indexOf('.') === -1)
                {
                    return d.data[options.keys.value].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
                else{
                        
                    return d.data[options.keys.value];
                }
            })

        }) // threeDViewButtonForPieChart.on('click', function()

        var threeDPieChart;
        var threeDPieChartPath;
        function threeDPieChartCallFunction (id, data, x /*center x*/, y/*center y*/, rx/*radius x*/, ry/*radius y*/, h/*height*/, ir/*inner radius*/) {
            
            var _data = d3.layout.pie().sort(null).value(function(d) {return d[options.keys.value];})(data);

            var slices = d3.select("#"+id).append("g").attr("transform", "translate(" + x + "," + y + ")")
            .attr("class", "slices");
            
            threeDPieChart = slices;

            slices.selectAll(".innerSlice").data(_data).enter().append("path").attr("class", "innerSlice")
            .style("fill", function(d,i) { return d3.hsl(colorsForThreeDPieChart(i)).darker(0.7); })
            .attr("d",function(d){ return pieInner(d, rx+0.5,ry+0.5, h, ir);}) .each(function(d){this._current=d;});
        
            slices.selectAll(".topSlice").data(_data).enter().append("path").attr("class", "topSlice")
            .style('fill', function(d, i) { return colorsForThreeDPieChart(i); }) .style("fill-opacity",0.95)
            .style("stroke", function(d,i) { return colorsForThreeDPieChart(i); }) .attr("stroke-width",0.5)
            .attr("d",function(d){ return pieTop(d, rx, ry, ir);}) .each(function(d){this._current=d;});
        
            slices.selectAll(".outerSlice").data(_data).enter().append("path").attr("class", "outerSlice")
            .style("fill", function(d,i) { return d3.hsl(colorsForThreeDPieChart(i)).darker(0.7); }) .style("fill-opacity",1.0)
            .attr("d",function(d){ return pieOuter(d, rx-.5,ry-.5, h);}) .each(function(d){this._current=d;});

            slices.selectAll(".percent").data(_data).enter().append("text").attr("class", "percent")
            .attr("x",function(d){ return 0.75*rx*Math.cos(0.5*(d.startAngle+d.endAngle));})
            .attr("y",function(d){ return 0.75*ry*Math.sin(0.5*(d.startAngle+d.endAngle));})
            .text(getPercent).each(function(d){this._current=d;})
            .style("fill","#ffffff").style("font-weight","Bold")
            .style("font-family","Verdana,sans-serif") .style("text-anchor","middle") .style("font-size","12px")
            
        } // function threeDPieChartCallFunction() ends here.

       
            $(function() {
            $('#' + targetElement[0][0].id).bind('resize', function(){
                
                 if(isThreeDDonutChartEnabled == true){
                    
                    backButtonForDonutChart.transition().duration(20).style('top', parseFloat(chartTitlePanel.style("height")) + (2) + 'px')

                    var newWidth = (targetElement[0][0].clientWidth * (parseFloat(svgForHolding3DDonutChart[0][0].style.width) / 100))/2
                    var newHeight = (targetElement[0][0].clientHeight * (parseFloat(svgForHolding3DDonutChart[0][0].style.height) / 100))/2

                    var newThreeDPieChartRadius_rx = Math.min((newWidth * 2), (newHeight * 2)) / 2.2
                    var newThreeDPieChartRadius_ry = Math.min((newWidth * 2), (newHeight * 2)) / 4.7
                
                    threeDPieChart.transition().duration(0).attr("transform", "translate(" + (newWidth) + "," + (newHeight) + ")")

                    var _data = d3.layout.pie().sort(null).value(function(d) {return d[options.keys.value];})(options.data);

                    threeDPieChart.selectAll(".innerSlice").data(_data)/*.attr("class", "innerSlice")*/.transition().duration(0)
                    .attr("d",function(d){ return pieInner(d, newThreeDPieChartRadius_rx+0.5,newThreeDPieChartRadius_ry+0.5,25, 0.40);})

                    threeDPieChart.selectAll(".topSlice").data(_data)/*.attr("class", "topSlice")*/.transition().duration(0)
                    .attr("d",function(d){ return pieTop(d, newThreeDPieChartRadius_rx, newThreeDPieChartRadius_ry, 0.40);})

                    threeDPieChart.selectAll(".outerSlice").data(_data)/*.attr("class", "outerSlice")*/.transition().duration(0)
                    .attr("d",function(d){ return pieOuter(d, newThreeDPieChartRadius_rx-.5,newThreeDPieChartRadius_ry-.5, 25);}) 

                    threeDPieChart.selectAll(".percent").data(_data)/*.attr("class", "percent")*/.transition().duration(0)
                    .attr("x",function(d){ return 0.75*newThreeDPieChartRadius_rx*Math.cos(0.5*(d.startAngle+d.endAngle));})
                    .attr("y",function(d){ return 0.75*newThreeDPieChartRadius_ry*Math.sin(0.5*(d.startAngle+d.endAngle));})

                     // Aligning Legend (vertically)
                    var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(svgForHolding3DDonutChartLegends[0][0].style.width) / 100)
                    var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(svgForHolding3DDonutChartLegends[0][0].style.height) / 100)

                    var legendRectSize = 11;
                    var legendSpacing = 5;
            
                    legendFor3DDonutChart.transition().duration(50).attr('transform', function(d, i) {
                        var height = legendRectSize + legendSpacing;
                        var offset =  height * colorsForThreeDPieChart.domain().length / 2;
                        var horz = 2;
                        var vert = (i * height) + (legendPanelHeight - (height * options.data.length))/2 ;
                        return 'translate(' + horz + ',' + vert + ')';
                    }) //legendFor3DDonutChart

                } // if(isThreeDDonutChartEnabled == true) condition ends here.

            });

        }) // $(function()) ends here

        function pieTop(d, rx, ry, ir ){
        
            if(d.endAngle - d.startAngle == 0 ) return "M 0 0";
            var sx = rx*Math.cos(d.startAngle),
                sy = ry*Math.sin(d.startAngle),
                ex = rx*Math.cos(d.endAngle),
                ey = ry*Math.sin(d.endAngle);
            
            var ret =[];
            ret.push("M",sx,sy,"A",rx,ry,"0",(d.endAngle-d.startAngle > Math.PI? 1: 0),"1",ex,ey,"L",ir*ex,ir*ey);
            ret.push("A",ir*rx,ir*ry,"0",(d.endAngle-d.startAngle > Math.PI? 1: 0), "0",ir*sx,ir*sy,"z");
            return ret.join(" ");
        }

        function pieOuter(d, rx, ry, h ){
            var startAngle = (d.startAngle > Math.PI ? Math.PI : d.startAngle);
            var endAngle = (d.endAngle > Math.PI ? Math.PI : d.endAngle);
        
            var sx = rx*Math.cos(startAngle),
            sy = ry*Math.sin(startAngle),
            ex = rx*Math.cos(endAngle),
            ey = ry*Math.sin(endAngle);
            
            var ret =[];
            ret.push("M",sx,h+sy,"A",rx,ry,"0 0 1",ex,h+ey,"L",ex,ey,"A",rx,ry,"0 0 0",sx,sy,"z");
            return ret.join(" ");
        }

        function pieInner(d, rx, ry, h, ir ){
            var startAngle = (d.startAngle < Math.PI ? Math.PI : d.startAngle);
            var endAngle = (d.endAngle < Math.PI ? Math.PI : d.endAngle);
        
            var sx = ir*rx*Math.cos(startAngle),
            sy = ir*ry*Math.sin(startAngle),
            ex = ir*rx*Math.cos(endAngle),
            ey = ir*ry*Math.sin(endAngle);

            var ret =[];
            ret.push("M",sx, sy,"A",ir*rx,ir*ry,"0 0 1",ex,ey, "L",ex,h+ey,"A",ir*rx, ir*ry,"0 0 0",sx,h+sy,"z");
            return ret.join(" ");
        }

        function getPercent(d){
            return (d.endAngle-d.startAngle > 0.2 ? 
                Math.round(1000*(d.endAngle-d.startAngle)/(Math.PI*2))/10+'%' : '');
        }

        // Create option buttons tool tip
        var iconButtonTooltip = targetElement.append('div').style('width','240px').attr("id","too")
        .style('height',"25px").style('position','absolute')//.style('margin-left', "0px").style('top','25px')
        .style("background-color",'#404040').style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid") // 004b9d
        .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none").attr("border", 0.0)

        bubbleButtonForDonutChart.on('mousemove', function(d,i) { 
             var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var bubbleChartButtonTooltipText = "Switch to Bubble Chart";
            
            iconButtonTooltip.style("width","142px").style("margin-left", (m[0] - 152) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ bubbleChartButtonTooltipText +'</div>')
        })
        bubbleButtonForDonutChart.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })
        
        pieButtonForDonuteChart.on('mousemove', function(d,i) {
             var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var columnChartButtonTooltipText = "Switch to Pie Chart";
            
            iconButtonTooltip.style("width","122px").style("margin-left", (m[0] - 132) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ columnChartButtonTooltipText +'</div>')
        })
        pieButtonForDonuteChart.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        colButtonForDonutChart.on('mousemove', function(d,i) {
             var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var doNutChartButtonTooltipText = "Switch to Column Chart";
            
            iconButtonTooltip.style("width","147px").style("margin-left", (m[0] - 157) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ doNutChartButtonTooltipText +'</div>')
        })
        colButtonForDonutChart.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        horButtonForDonutChart.on('mousemove', function(d,i) {
             var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var horizontalChartButtonTooltipText = "Switch to Horizontal Chart";
            
            iconButtonTooltip.style("width","160px").style("margin-left", (m[0] - 170) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ horizontalChartButtonTooltipText +'</div>')
        })
        horButtonForDonutChart.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        refreshButtonForDonutChart.on('mousemove', function(d,i) {
             var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var refreshButtonTooltipText = "Refresh";
            
            iconButtonTooltip.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ refreshButtonTooltipText +'</div>')
        })
        refreshButtonForDonutChart.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        filterButtonForDonutChart.on('mousemove', function(d,i) {
             var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var filterButtonTooltipText = "Filter";
            
            iconButtonTooltip.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')
        })
        filterButtonForDonutChart.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        searchChartButton.on('mousemove', function(d,i) {
             var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var reloadButtonTooltipText = "Search";
            
            iconButtonTooltip.style("width","60px").style("margin-left", (m[0] - 70) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ reloadButtonTooltipText +'</div>')
        })
        searchChartButton.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        settingBtnForDonutChart.on('mousemove', function(d,i) {
             var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var reloadButtonTooltipText = "Settings";
            
            iconButtonTooltip.style("width","67px").style("margin-left", (m[0] - 77) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ reloadButtonTooltipText +'</div>')
        })
        settingBtnForDonutChart.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })
        
        downloadBtnForDonutChart.on('mousemove', function(d,i) {
          var root = targetElement
          var m = d3.mouse(root.node());
          m[0] += 0
          m[1] += 0
          var downloadButtonTooltipText = "Download";
          
          iconButtonTooltip.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
          iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
        })
        downloadBtnForDonutChart.on('mouseout', function(d,i) {
          iconButtonTooltip.style("display","none")
        })
        
        threeDViewButtonForDonutChart.on('mousemove', function(d,i) {
             var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var reloadButtonTooltipText = "3D View";
            
            iconButtonTooltip.style("width","67px").style("margin-left", (m[0] - 77) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center; ">'+ reloadButtonTooltipText +'</div>')
        })
        threeDViewButtonForDonutChart.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })
        
        tableButtonForDonutChart.on('mousemove', function(d,i) {
             var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0

            if(showOrHideTableForDonutChart == false){
                var tableButtonTooltipText = "Show Table";
            }
            else if(showOrHideTableForDonutChart == true){
                var tableButtonTooltipText = "Hide Table";
            }
            
            iconButtonTooltip.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ tableButtonTooltipText +'</div>')
        })
        tableButtonForDonutChart.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        commentsBtnForDonutChart.on('mousemove', function(d,i) {
            commentsPanelDivForDonutChart.style('background-color','#fafafa')
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                if(options.showComments == false){
                    var commentButtonTooltipText = "Show Comments";
                }
                else if(options.showComments == true){
                    var commentButtonTooltipText = "Hide Comments";
                }
            
            
            iconButtonTooltip.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center; ">'+ commentButtonTooltipText +'</div>')
        })
        commentsBtnForDonutChart.on('mouseout', function(d,i) {
            commentsPanelDivForDonutChart.style('background-color','#ffffff')
            iconButtonTooltip.style("display","none")
        })

        menuButtonForDonutChart.on('mousemove', function(d,i) {
             var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var reloadButtonTooltipText = "Menu";
            
            iconButtonTooltip.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center; ">'+ reloadButtonTooltipText +'</div>')
        })
        menuButtonForDonutChart.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        var disabledDivForDonutChart = targetElement.append('div').style('width',targetElement[0][0].clientWidth + "px").style('height',targetElement[0][0].clientHeight + "px").style('position','absolute')
        .style("background-color",'#f3f3f3').style("z-index",2).style("display","none").style('top', 0.0 + "%").style('left', 0.0 + "%")
        .style("opacity",0.1).style("min-width","350px").style("min-height","350px") //005ec4

        var searchDivForDoNutChart = targetElement.append('div').style('width',"100%").style('height',"40%")
        .style('position','absolute').style('margin-left', "0px").style('border-top',"1px solid #f0f0f0").style('border-bottom',"1px solid #e5e5e5")
        .style("background-color",'#fcfcff').style("z-index",90) //001c3b
        .style("display","none")
        .style('top',"60%").style('height',"40%")

        $( '.filterDivForDonutChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        var searchDivForDoNutChartTitle = searchDivForDoNutChart.append('div').style('background-color',"#ffffff").attr("font-family", "Verdana,sans-serif")
        .style('margin-left','10px').style('margin-top','10px').style('text-indent','5px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","90%").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:15.5%; font-size:14px; font-family:inter; color:#00001c;">'+ "Filter by " + options.keys.value +'</div>')

        var sliderBarForDoNutChart = searchDivForDoNutChart.append('div').style('background-color',"#ffffff")
        .attr("id",targetElement[0][0].id + "doNutChartRangeSliderID").style("width","215px").style('margin-top','87px').style('margin-left','39px').style('position',"absolute")
        //.attr("class","sliderBarForPieChartClass")

        var cancelButtonForFilterPanelDonutChart = searchDivForDoNutChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
        .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
        .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.90; background-color:#fcfcff")
        cancelButtonForFilterPanelDonutChart[0][0].appendChild(cancelBtnImgVar)

        cancelButtonForFilterPanelDonutChart.on('click',function(d){

            if(options.showLegend == true && options.showTitle == true){
            
            if(options.legendSide === "left"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("left",30 + "%")
                    svgPanel.style("position","absolute").style("background-color", options.BGcolor);
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }

            }
            else if(options.legendSide === "right"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }

            }
            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                
            }
        }
        else if(options.showLegend == true && options.showTitle == false){
           
            if(options.legendSide === "left"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",0.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }

            }
            else if(options.legendSide === "right"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",0.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
            }
            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 70 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",0.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
            }
            
        }
        else if(options.showLegend == false){

            if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 0.0 + "%"; }) .style("height", function(d) { return 0  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 100 + "%") .style('height', 70 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 0.0 + "%"; }) .style("height", function(d) { return 0  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",0.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 100 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 0.0 + "%"; }) .style("height", function(d) { return 0  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 100 + "%") .style('height', 85 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
			
        }

            resizedFuctionForDonutChart();

            searchDivForDoNutChart.style("display","none")
        })

        var textBoxOneForDoNutChart = searchDivForDoNutChart.append('input').style("width","80px").style('margin-left','15px').style('margin-top','50px')
        .style('position',"absolute").style('height',"22px").style("border", "1.0px") .style("border-color", "#e6e6e6") .style("border-style", "solid").style('text-indent','5px')
        .attr("value",d3.min(minAndMaxValuesArrayForDoNutChart)).style("padding","0px").attr("disabled","disabled").style("color","#00001c")
        
        var toLableForDoNutChart = searchDivForDoNutChart.append('div').style('background-color',"#fcfcff").attr("fant-family", "Verdana,sans-serif").style("font-weight", "Bold")
        .style('margin-top','52px').style('margin-left','139px').style('position',"absolute").style("width","25px").style("height","15px")
        .style("box-shadow", "1px 1px 1px #ffffff")
        .html('<div  style="width: 100%; height:100%; background-color:#fdfdfd; font-size:12px; position: absolute;  font-family:inter;  color:#00001c; font-weight:Bold;">'+ "-to-"+'</div>')

        var textBoxTwoForDoNutChart = searchDivForDoNutChart.append('input').style("width","80px").style('margin-left','198px').style('margin-top','50px')
        .style('position',"absolute").style('height',"22px").style("border", "1.0px") .style("border-color", "#e6e6e6") .style("border-style", "solid")
        .style('text-indent','5px').attr("value",d3.max(minAndMaxValuesArrayForDoNutChart)) .attr("disabled","disabled").style("color","#00001c")
        .style("padding","0px")
        
        var searchedDataArray = [];
       
        var searchAndRenderButton = searchDivForDoNutChart.append("button").style("width","147px").style("height","22px") .style('position','absolute')
        .style('margin-left','75px').style('font-size','12px').style('margin-top','110px').style("box-shadow", "0px 1px 2px #d9d9d9") .style("border-style", "none")
        .style('background-color',"#2196f3").style("color","#ffffff") // d8ebff
        .style('text-align','center').attr("id","123")
        var textForSearchAndRenderButton = document.createTextNode("Apply Filter")
        searchAndRenderButton[0][0].appendChild(textForSearchAndRenderButton)

        searchAndRenderButton.on('click', function() {
            searchedDataArray = [];
            //searchDivForDoNutChart.style("display","none")
            var textBoxOneForDoNutChartValue = parseFloat(textBoxOneForDoNutChart[0][0].value) 
            var textBoxTwoForDoNutChartValue = parseFloat(textBoxTwoForDoNutChart[0][0].value)
            var toBeFetchedValue = options.keys.value
            
            textBoxOneForDoNutChart.attr("value","")
            textBoxTwoForDoNutChart.attr("value","")
            
            newJson.forEach(function(d, i) {
                
                if((+d[toBeFetchedValue] >= textBoxOneForDoNutChartValue) && (+d[toBeFetchedValue] <= textBoxTwoForDoNutChartValue) ){
                    
                    searchedDataArray.push(d)
                }
            });
            
            if(searchedDataArray.length == 0){
                //alert("Sorry, no result found for this search!")

                var alertPageDisabledDivForDonutChart =targetElement.append('div').style('width',100 + '%')
                .style('height',100 + "%").style('position','absolute').style('margin-left', '0px').style('top', '0px')
                .style("background-color",'#f3f3f3').style("z-index",99)//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("opacity",0.2).style("display","block")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")

                var alertDivForDonutChart = targetElement.append('div').style('width','350px')
                .style('height',"150px").style('position','absolute').style('left', ((targetElement[0][0].clientWidth/2) - 175) + "px").style('top', '1px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "solid").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","0px")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
                //.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Bold;">Sorry, no result found for selected' + 'range!'+ '</br>' + '<label style=text-indent:10px;> Hello</label' +'</div>')
                .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Normal; text-indent:10px;  color:#f8f8f8; font-weight:Normal;">Sorry, no result found for selected range!</div>')

                var alertDivTitleForDonutChart = alertDivForDonutChart.append('div').style('width','340px')
                .style('height',"30px").style('position','absolute').style('margin-left', "0px").style('top', '0px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "none").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","2px")
                .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; font-weight:Bold; text-indent:5px;  color:#e5e5e5; font-weight:Normal;">TimeBound</div>')

                var donutChartAlertOKButton = alertDivForDonutChart.append("button") .style("width","40px") .style("height","20px") .style('position','absolute') .style("box-shadow", "0px 1px 1px #B8B8B8") 
                .style('background-color',"#7cc15e") .style('margin-left','300px') .style('top', "120px").style("color","#ffffff")
                .style("display","block").style('padding-top',"0px").style("cursor","pointer").style("box-shadow", "1px 1px 1px #56973a") .style("border-style", "none")
                .style("font-family","Verdana,sans-serif").style("font-size","14px").style("text-align","center").style("vertical-align","middle").style("border-radius","0px")
                .style("z-index",999)
            
                var textForDonutChartAlertOKButton = document.createTextNode("OK");
                donutChartAlertOKButton[0][0].appendChild(textForDonutChartAlertOKButton)

                $("#"+targetElement[0][0].id).resizable('disable');

                donutChartAlertOKButton.on('click', function() {
                    alertDivForDonutChart.remove();
                    alertPageDisabledDivForDonutChart.remove()
                    $("#"+targetElement[0][0].id).resizable('enable');
                })


                filterButtonForDonutChart.style("cursor","pointer")
                disabledDivForDonutChart.style("display","none")
                searchDivForDoNutChart.style("display","none")//.transition().style('width', 0 + "px").duration(200).delay(50)
                //.style("overflow-y","hidden")

                if(showOrHideTableForDonutChart == false){ 
                    svgPanel.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute")
                    legendPanelFront.style('width', 35 + "%") .style('height', 85 + "%").style("position","absolute")
                }   
                else if(showOrHideTableForDonutChart == true){ 
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute")
                    legendPanelFront.style('width', 35 + "%") .style('height', 52 + "%").style("position","absolute")
                }
                resizedFuctionForDonutChart();

            }
            else if(searchedDataArray.length > 0){
                d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                options.data = searchedDataArray;
                acinfotech.donutChart(targetElement,options)
            }
            
        })// searchAndRenderButton.on('click', function()) function ends here.

        function resetTableWidthOldDataFunction(){
            
            textBoxOneForDoNutChart.attr("value",d3.min(minAndMaxValuesArrayForDoNutChart))
            textBoxTwoForDoNutChart.attr("value",d3.max(minAndMaxValuesArrayForDoNutChart))

            thead.select('svg').select('#descendingIconIDForDoNutChart').style("visibility", "visible")
            thead.select('svg').select('#ascendingIconIDForDoNutChart').style("visibility", "visible")
            
            tablePanelForDoNutChart.select('table').selectAll('tr').style("background-color","#FFFFFF").style("color","#000000")

            var table = tablePanelForDoNutChart.select('table');
            var rows = table.selectAll('tr').data(newJson);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition()
            .delay(20) .duration(20) .style('opacity', 1.0) .style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(20) .duration(20) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(20)
            .duration(20) .style('opacity', 1.0) .style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(20) .duration(20) .style('opacity', 0.0) .remove();

            tablePanelForDoNutChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
            .style("color","#00001c")
            .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4")
            tablePanelForDoNutChart.selectAll('td').style("height","25px") .style("border", "1px solid #dddddd") .style("font-size","12px").style("font-weight","Normal").style("color","#00001c")

            //additionally 
            tablePanelForDoNutChart.selectAll('th').style('background-color',"#ffffff").style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
            tablePanelForDoNutChart.selectAll('td').style('background-color',"#ffffff").style("border-style","none").style("color","#2c2c2c").style("color","#00001c")
        

            //b1da9f
            tablePanelForDoNutChart.selectAll('table') . style("border-collapse","collapse")
            tablePanelForDoNutChart.selectAll('table tr:first-child th').style("border-top","0px")
            tablePanelForDoNutChart.selectAll('table tr:last-child td').style("border-bottom","0px")
            tablePanelForDoNutChart.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
            tablePanelForDoNutChart.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")

        } // function resetTableWithOldDataFunction() ends here.
        
        var svgForDoNutChart = svgPanel .append('svg') .style("background-color", options.BGcolor) .style('border-width',"1px")
        .style('border-color',"#d4d4d4")  .style('border-style',"solid") .append('g')
        .attr('transform', 'translate(' + (width1ForDonutChart/2) + ',' + (height1ForDonutChart / 2) + ')');
        
        svgForDoNutChart.append("g") .attr("class", "slices");
        svgForDoNutChart.append("g") .attr("class", "labels");
        svgForDoNutChart.append("g") .attr("class", "lines");
        
		var radialGradient = svgForDoNutChart.append("defs") .append("radialGradient") .attr("id", "radial-gradient" + targetElement[0][0].id );
		
        var arcForDoNutChart = d3.svg.arc() .outerRadius(radiusForDoNutChart * 0.8) .innerRadius(radiusForDoNutChart * 0.45); //.cornerRadius(4);
        
        var outerArcForDoNutChart = d3.svg.arc() .innerRadius(radiusForDoNutChart * 0.9) .outerRadius(radiusForDoNutChart * 0.9);
        
        //var key = function(d){ return d.data.label; };
        
        var pieForDoNutChart = d3.layout.pie() .value(function(d) { return d[options.keys.value]; }) .sort(null) ;
        
        options.data.forEach(function(d, i) {
             d[options.keys.value] = d[options.keys.value];
             d.enabled = true;
        });
        
        svgForDoNutChart.append("circle") .attr("cx", 00) .attr("cy", 0) .attr("r", 0) .transition() .delay(function(d, i) { return i * 100; })
        .duration(1000) .attr("r", radiusForDoNutChart/1.25) .ease("bounce") .attr("fill", "url(#radial-gradient" + targetElement[0][0].id + ")")
        
		// Creating donut slices
        var pathForDoNutChart = svgForDoNutChart.selectAll('path') .data(pieForDoNutChart(options.data)) .enter() .append('path') 
		.attr('fill', function(d, i) {  return colorsForDoNutChart(d.data[options.keys.label]); }).style('stroke', 'white').style('stroke-width', 1)
        .each(function(d) { this._current = d; });
        
        pathForDoNutChart.transition().delay(function(d, i) {  return i * 400;  }) .duration(400)
		.attrTween('d', function(d) {
           var i = d3.interpolate(d.startAngle+0.1, d.endAngle);
           return function(t) {
                d.endAngle = i(t);
                return arcForDoNutChart(d);
                }
        });
		
		if(options.gradient === undefined){
            radialGradient.selectAll("stop").remove();
			pathForDoNutChart.style("fill-opacity", 1);
        }
        else if(options.gradient.toString().toLowerCase() === "none"){
            radialGradient.selectAll("stop").remove();
			pathForDoNutChart.style("fill-opacity", 1);
        }
        else if(options.gradient.toString().toLowerCase() === "circular"){
            
            radialGradient.append("stop").attr("offset", "55%").style("stop-color", function(d, i) { return "#ffffff"; });
            radialGradient.append("stop").attr("offset", "88%").style("stop-color", "#444444");
            radialGradient.append("stop").attr("offset", "100%").style("stop-color", function(d, i) { return "#ffffff"; });
			pathForDoNutChart.style("fill-opacity", 0.8)
        }
        else {
           radialGradient.selectAll("stop").remove();
		   pathForDoNutChart.style("fill-opacity", 1);
        }
		
        var newArrForDrillDownDon = [];
        var columnNames = d3.keys(newJson[0])
        var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
        
        for(var i = 0; i < columnNames.length ; i++){
            for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                    for(var k = 0; k < pathForDoNutChart[0].length; k++){
                        d3.select(pathForDoNutChart[0][k]).attr('data-drilldownkey', function(d,index){
                            var arr = JSON.stringify(newJson[k]).slice(1, -1).split('"'), arr1 = d3.select(arr)[0]
                            
                            for(var j = 0; j < arr1[0].length; j++){
                                if(arr1[0][j].toString() == ":"){
                                    var ch = arr1[0][j].toString().replace(":","|")
                                     newArrForDrillDownDon.push(ch)
                                }
                                else {
                                      newArrForDrillDownDon.push(arr1[0][j])
                                }
                            }
                            
                            //return JSON.stringify(newJson[k]).slice(1, -1).split('"').join("").split(':').join("|")
                            return newArrForDrillDownDon.join("");
                        })
                        newArrForDrillDownDon = []
                    }
                }
                else {
                }
            }
        }
        
        //--------------------------path.on('mouseover'), .on('mouseout') and so on ------------------------------
        
        pathForDoNutChart.on('mouseover', function(d) {
                             
            var format = d3.format(".2s")
            
            var valueForDonutChartToolTip;
            if( d.data[options.keys.value].toString().indexOf('.') === -1)
            {
                valueForDonutChartToolTip = d.data[options.keys.value].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            else{
                        
                valueForDonutChartToolTip =  d.data[options.keys.value];
            }

            toolTipForDonutChart.select('.label').html(options.keys.label + " : " + d.data[options.keys.label]);
            //toolTipForDonutChart.select('.count').html(options.keys.value + " : " + d.data[options.keys.value].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))//format(d.data[options.keys.value]));
            toolTipForDonutChart.select('.count').html(options.keys.value + " : " + valueForDonutChartToolTip); //format(d.data[options.keys.value]));
            toolTipForDonutChart.style('visibility', 'visible');
            toolTipForDonutChart.select('hr').attr('class', 'dotColor').style("background-color", d3.select(this).style("fill"))
                             
                this._current = this._current || d;
            });
        
        pathForDoNutChart.on('mouseout', function() {   toolTipForDonutChart.style('visibility', 'hidden') });
        
        
        var bnds =  targetElement.node().getBoundingClientRect()
        
        var arcOverForDoNutChart = d3.svg.arc()  .outerRadius((radiusForDoNutChart * 0.9) + 0.02) .innerRadius(radiusForDoNutChart * 0.45);
        
        pathForDoNutChart.on("mouseenter", function(d,i) {
            d3.select(this) .transition() .ease("elastic") .duration(100) .attr("d", arcOverForDoNutChart)
            .attr("stroke-width",0.5);
        })
        
        pathForDoNutChart.on("mouseleave", function(d) {
            d3.select(this).transition() .attr("d", arcForDoNutChart) .attr("stroke-width",1);
        });
        
        //------------------------------------------------------------------------------
        
        // Creating legend panel
        var legendPanelFront =  targetElement.append('div') .attr("class","classForLegentPanelDonut").style("background-color", options.BGcolor) .style("position","absolute")  //f2fbf1
        
        // Checking the Chart Title and Chart Legend choosen (true or false) when Library Called.
        if(options.showLegend == true && options.showTitle == true){
            
            if(options.legendSide === "left"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 70 + "%") .style("left",30 + "%")
                    svgPanel.style("position","absolute").style("background-color", options.BGcolor);
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("left",30 + "%")
                    svgPanel.style("position","absolute").style("background-color", options.BGcolor);
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 85 + "%") .style("left",30 + "%")
                    svgPanel.style("position","absolute").style("background-color", options.BGcolor);
                }

            }
            else if(options.legendSide === "right"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 70 + "%") .style("left",0 + "%").style('background-color',"#ffffff")
                    svgPanel.style("position","absolute").style("background-color", options.BGcolor);
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("left",0 + "%").style('background-color',"#ffffff")
                    svgPanel.style("position","absolute").style("background-color", options.BGcolor);
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 85 + "%") .style("left",0 + "%").style('background-color',"#ffffff")
                    svgPanel.style("position","absolute").style("background-color", options.BGcolor);
                }

            }
            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 70 + "%") .style("left",0 + "%").style('background-color',"#ffffff")
                    svgPanel.style("position","absolute").style("background-color", options.BGcolor);
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("left",0 + "%").style('background-color',"#ffffff")
                    svgPanel.style("position","absolute").style("background-color", options.BGcolor);
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanel.style('width', 65 + "%") .style('height', 85 + "%") .style("left",0 + "%").style('background-color',"#ffffff")
                    svgPanel.style("position","absolute").style("background-color", options.BGcolor);
                }
                //alert("Legend side not selected.");
            }
        }
        else if(options.showLegend == true && options.showTitle == false){
           
            if(options.legendSide === "left"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 70 + "%") .style("left",30 + "%") .style("top",8.0  + "%")
                    svgPanel.style("position","absolute").style("background-color", options.BGcolor);
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("left",30 + "%") .style("top",8.0  + "%")
                    svgPanel.style("position","absolute").style("background-color", options.BGcolor) ;
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 85 + "%") .style("left",30 + "%")
                    svgPanel.style("position","absolute").style("background-color", options.BGcolor);
                }

            }
            else if(options.legendSide === "right"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 70 + "%") .style("left",0 + "%")
                    svgPanel.style("position","absolute").style("background-color", options.BGcolor);
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    svgPanel.style("position","absolute").style("background-color", options.BGcolor);
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 85 + "%") .style("left",0 + "%")
                    svgPanel.style("position","absolute").style("background-color", options.BGcolor);
                }
            }
            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                
                if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == true)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 70 + "%") .style("left",0 + "%")
                    svgPanel.style("position","absolute").style("background-color", options.BGcolor);
                }
                else if ((showOrHideTableForDonutChart == true) && (showOrHideCommentsForDonutChart == false)){
                    legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    svgPanel.style("position","absolute").style("background-color", options.BGcolor);
                }
                else if ((showOrHideTableForDonutChart == false) && (showOrHideCommentsForDonutChart == false)){
                     legendPanelFront.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);

                    svgPanel.style('width', 65 + "%") .style('height', 85 + "%") .style("left",0 + "%")
                    svgPanel.style("position","absolute").style("background-color", options.BGcolor);
                }
                
                //alert("Legend side not selected.");
            }
            
        }
        else if(options.showLegend == false){
            legendPanelFront.style("width", function(d) { return 0.0 + "%"; }) .style("height", function(d) { return 0.0  + "%"; })
            .style("position","absolute") .style("left",0 + "%") .style("top",0.0  + "%").style("background-color", options.BGcolor);
        }
        
        var legendPanelFrontSvg =  legendPanelFront.append('svg') .style("background-color", options.BGcolor) .style("width", function(d) { return 100.0 + "%"; })
        .style("height", function(d) { return 100  + "%"; }).style("position","absolute") .style("left",0 + "%") .style("top",0  + "%");
        
        var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(legendPanelFront[0][0].style.width) / 100) 
        var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(legendPanelFront[0][0].style.height) / 100)

        var legendRectSizeForDoNutChart = 11;
        var legendSpacingForDoNutChart = 5;
        
        var legendForDoNutChart = legendPanelFrontSvg.selectAll('.legend') .data(colorsForDoNutChart.domain())  .enter() .append('g')  .attr('class', 'legend')
        .attr('transform', function(d, i) {
              var height = legendRectSizeForDoNutChart + legendSpacingForDoNutChart;
              var offset =  height * colorsForDoNutChart.domain().length / 2;
              var horz = 2;
              var vert = (i * height) + (legendPanelHeight - (height * options.data.length))/2 ;
              return 'translate(' + horz + ',' + vert + ')';
              
        })
        
        var legendGroup =  legendForDoNutChart.append('rect') .attr('width', legendRectSizeForDoNutChart) .attr('height', legendRectSizeForDoNutChart) .style('fill', colorsForDoNutChart) .style('stroke', colorsForDoNutChart)
        .attr("rx", 5.0) .attr("ry", 5.0)
        
        .on('click', function(label) {
            
            var circlesForDoNutChart = svgForDoNutChart.selectAll('path')
            var circleAttributesForDoNutChart = circlesForDoNutChart .attr('transform', 'translate(0,0)');
            
            var rectForDoNutChart = d3.select(this);
            var enabledForDoNutChart = true;
            var totalEnabledForDoNutChart = d3.sum(options.data.map(function(d) {  return (d.enabled) ? 1 : 0;  }));
            
            if (rectForDoNutChart.attr('class') === 'disabled') {  rectForDoNutChart.attr('class', '');  }
            else {
                    if (totalEnabledForDoNutChart < 2) return;
                    rectForDoNutChart.attr('class', 'disabled');
                    enabledForDoNutChart = false;
            }
            
            pieForDoNutChart.value(function(d) {    if (d[options.keys.label] === label) d.enabled = enabledForDoNutChart;
                                   return (d.enabled) ? d[options.keys.value] : 0;   });
            
            pathForDoNutChart = pathForDoNutChart.data(pieForDoNutChart(options.data));
            
            pathForDoNutChart.transition() .duration(450)
            .attrTween('d', function(d,i) {
                       
               if(d.value == 0) {
                    d3.select(this).style("visibility", "hidden");
               }
               else {
                    d3.select(this).style("visibility", "visible");
               }
               
               var interpolate = d3.interpolate(this._current, d);
               this._current = interpolate(0);
               return function(t) {
                    return arcForDoNutChart(interpolate(t));
                };
               });
            
            function midAngle(d){  return d.startAngle + (d.endAngle - d.startAngle)/2;  }
            
            clickedFunctionForDoNutChart()
            
            });
        
        clickedFunctionForDoNutChart()
        
        function midAngle(d){  return d.startAngle + (d.endAngle - d.startAngle)/2;  }
        
        var textForDoNutChart;
        var polylineForDoNutChart;
        
        pathForDoNutChart.on("mousemove",function(d,i) {
            
            var widthPanel = chartTitlePanel[0][0].clientWidth
            var heightPanel = chartTitlePanel[0][0].clientHeight
                             
            var width11 = toolTipForDonutChart[0][0].clientWidth;
            var height11 = toolTipForDonutChart[0][0].clientHeight;

            var width111 = chartTitlePanel[0][0].clientWidth
            var height111 = chartTitlePanel[0][0].clientHeight
                             
            var width1111 = targetElement[0][0].clientWidth * (parseFloat(legendPanelFront[0][0].style.width) / 100)
            var height1111 = targetElement[0][0].clientHeight * (parseFloat(legendPanelFront[0][0].style.height) / 100)
                             
            var newWidth11 = toolTipForDonutChart[0][0].clientWidth;
            var newHeight11 = toolTipForDonutChart[0][0].clientHeight;
              
            var root = targetElement
            var m = d3.mouse(root.node());
                             
            m[0] += 0
            m[1] += 0

            if(isResizedFunctionCalled == false){
                 
                if(height1ForDonutChart<=350){
                     
                    if(m[1]< (height1ForDonutChart/2) + heightPanel)
                    {
                        if(options.showTitle == true){
                             if(options.legendSide === "right"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + width1ForDonutChart/2) - width11/2 )  + "px").style("top",(d3.mouse(this)[1] + (height111+height1ForDonutChart/2) + 20) + "px")
                             }
                             else if(options.legendSide === "left"){
                                toolTipForDonutChart.style("left", ( ((d3.mouse(this)[0] + width1ForDonutChart/2) - width11/2 )) + width1111  + "px").style("top",(d3.mouse(this)[1] + (height111+height1ForDonutChart/2) + 20) + "px")
                             }
                             else if(options.legendSide !== "right" && options.legendSide !== "left"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + width1ForDonutChart/2) - width11/2 )  + "px").style("top",(d3.mouse(this)[1] + (height111+height1ForDonutChart/2) + 20) + "px")
                             }
                        }
                        else if(options.showTitle == false){
                             
                             if(options.legendSide === "right"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + width1ForDonutChart/2) - width11/2 )  + "px").style("top",(d3.mouse(this)[1] + (height111+height1ForDonutChart/2) + 20) + "px")
                             }
                             else if(options.legendSide === "left"){
                                toolTipForDonutChart.style("left", ( ((d3.mouse(this)[0] + width1ForDonutChart/2) - width11/2 )) + width1111  + "px").style("top",(d3.mouse(this)[1] + (height111+height1ForDonutChart/2) + 20) + "px")
                             }
                             else if(options.legendSide !== "right" && options.legendSide !== "left"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + width1ForDonutChart/2) - width11/2 )  + "px").style("top",(d3.mouse(this)[1] + (height111+height1ForDonutChart/2) + 20) + "px")
                             }
                        }
                             
                    }//if(m[1]<(height1/2) + heightPanel)
                             
                    else if(m[1]> (height1ForDonutChart/2) + heightPanel)
                    {
                        
                        if(options.showTitle == true){
                             
                             if(options.legendSide === "right"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + width1ForDonutChart/2) - width11/2  )  + "px").style("top",( d3.mouse(this)[1] + (height111+height1ForDonutChart/2) - (height11 + 10) ) + "px")
                             }
                             else if(options.legendSide === "left"){
                                toolTipForDonutChart.style("left", ( ((d3.mouse(this)[0] + width1ForDonutChart/2) - width11/2 )) + width1111  + "px").style("top",( d3.mouse(this)[1] + (height111+height1ForDonutChart/2) - (height11 + 10) ) + "px")
                             }
                             else if(options.legendSide !== "right" && options.legendSide !== "left"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + width1ForDonutChart/2) - width11/2  )  + "px").style("top",( d3.mouse(this)[1] + (height111+height1ForDonutChart/2) - (height11 + 10) ) + "px")
                             }
                        }
                        else if(options.showTitle == false){
                             
                             if(options.legendSide === "right"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + width1ForDonutChart/2) - width11/2  )  + "px").style("top",( d3.mouse(this)[1] + (height111+height1ForDonutChart/2) - (height11 + 10) ) + "px")
                             }
                             else if(options.legendSide === "left"){
                                toolTipForDonutChart.style("left", ( ((d3.mouse(this)[0] + width1ForDonutChart/2) - width11/2 )) + width1111  + "px").style("top",( d3.mouse(this)[1] + (height111+height1ForDonutChart/2) - (height11 + 10) ) + "px")
                             }
                             else if(options.legendSide !== "right" && options.legendSide !== "left"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + width1ForDonutChart/2) - width11/2  )  + "px").style("top",( d3.mouse(this)[1] + (height111+height1ForDonutChart/2) - (height11 + 10) ) + "px")
                             }
                             
                        }
                    } // else if(m[1]> (height1/2) + heightPanel)
                             
                } // if(height1<350)
                else if(height1ForDonutChart>350){
                                           
                        if(options.showTitle == true){
                             
                             if(options.legendSide === "right"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + width1ForDonutChart/2) - width11/2  )  + "px").style("top",( d3.mouse(this)[1] + (height111+height1ForDonutChart/2) - (height11 + 10) ) + "px")
                             }
                             else if(options.legendSide === "left"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + width1ForDonutChart/2) - width11/2 ) + width1111  + "px").style("top",( d3.mouse(this)[1] + (height111+height1ForDonutChart/2) - (height11 + 10) ) + "px")
                             }
                             else if(options.legendSide !== "right" && options.legendSide !== "left"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + width1ForDonutChart/2) - width11/2  )  + "px").style("top",( d3.mouse(this)[1] + (height111+height1ForDonutChart/2) - (height11 + 10) ) + "px")
                             }
                        }
                        else if(options.showTitle == false){
                             
                             if(options.legendSide === "right"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + width1ForDonutChart/2) - width11/2  )  + "px").style("top",( d3.mouse(this)[1] + (height111+height1ForDonutChart/2) - (height11 + 10) ) + "px")
                             }
                             else if(options.legendSide === "left"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + width1ForDonutChart/2) - width11/2 ) + width1111  + "px").style("top",( d3.mouse(this)[1] + (height111+height1ForDonutChart/2) - (height11 + 10) ) + "px")
                             }
                             else if(options.legendSide !== "right" && options.legendSide !== "left"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + width1ForDonutChart/2) - width11/2  )  + "px").style("top",( d3.mouse(this)[1] + (height111+height1ForDonutChart/2) - (height11 + 10) ) + "px")
                             }
                        }
                } // if(height1>350)
            } // if(isResizedFunctionCalled == false)
                             
            else if(isResizedFunctionCalled == true){
                             
                if(height1ForDonutChart<=350){
                        
                    if(m[1]< (height1ForDonutChart/2) + newHeight111)
                    {
                        if(options.showTitle == true){
                             
                             if(options.legendSide === "right"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2 )  + "px").style("top",(d3.mouse(this)[1] + (newHeight111+newHeight1/2) + 20) + "px")
                             }
                             else if(options.legendSide === "left"){
                                toolTipForDonutChart.style("left", ( ((d3.mouse(this)[0] + width1ForDonutChart/2) - width11/2 )) + width1111  + "px").style("top",(d3.mouse(this)[1] + (height111+height1ForDonutChart/2) + 20) + "px")
                             }
                             else if(options.legendSide !== "right" && options.legendSide !== "left"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2 )  + "px").style("top",(d3.mouse(this)[1] + (newHeight111+newHeight1/2) + 20) + "px")
                             }
                        }
                        else if(options.showTitle == false){
                             
                            if(options.legendSide === "right"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2 )  + "px").style("top",(d3.mouse(this)[1] + (newHeight111+newHeight1/2) + 20) + "px")
                            }
                            else if(options.legendSide === "left"){
                                    toolTipForDonutChart.style("left", ( ((d3.mouse(this)[0] + width1ForDonutChart/2) - width11/2 )) + width1111  + "px").style("top",(d3.mouse(this)[1] + (height111+height1ForDonutChart/2) + 20) + "px")
                            }
                            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2 )  + "px").style("top",(d3.mouse(this)[1] + (newHeight111+newHeight1/2) + 20) + "px")
                            }
                        }
                    } //if(m[1]< (height1/2) + newHeight111)
                             
                    else if(m[1]> (height1ForDonutChart/2) + newHeight111){
                        
                        if(options.showTitle == true){
                             
                            if(options.legendSide === "right"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2  )  + "px").style("top",( d3.mouse(this)[1] + (newHeight111+newHeight1/2) - (newHeight11 + 10) ) + "px")
                            }
                            else if(options.legendSide === "left"){
                                toolTipForDonutChart.style("left", ( ((d3.mouse(this)[0] + width1ForDonutChart/2) - width11/2 )) + width1111  + "px").style("top",( d3.mouse(this)[1] + (height111+height1ForDonutChart/2) - (height11 + 10) ) + "px")
                            }
                            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2  )  + "px").style("top",( d3.mouse(this)[1] + (newHeight111+newHeight1/2) - (newHeight11 + 10) ) + "px")
                            }
                        }
                        else if(options.showTitle == false){
                             
                            if(options.legendSide === "right"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2  )  + "px").style("top",( d3.mouse(this)[1] + (newHeight111+newHeight1/2) - (newHeight11 + 10) ) + "px")
                            }
                            else if(options.legendSide === "left"){
                                toolTipForDonutChart.style("left", ( ((d3.mouse(this)[0] + width1ForDonutChart/2) - width11/2 )) + width1111  + "px").style("top",( d3.mouse(this)[1] + (height111+height1ForDonutChart/2) - (height11 + 10) ) + "px")
                            }
                            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2  )  + "px").style("top",( d3.mouse(this)[1] + (newHeight111+newHeight1/2) - (newHeight11 + 10) ) + "px")
                            }
                        }
                    } //else if(m[1]> (height1/2) + newHeight111)
                } // if(height<350)
                             
                else if(height1ForDonutChart>350){
                        
                        if(options.showTitle == true){
                             
                            if(options.legendSide === "right"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2  )  + "px").style("top",( d3.mouse(this)[1] + (newHeight111+newHeight1/2) - (newHeight11 + 10) ) + "px")
                            }
                            else if(options.legendSide === "left"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2 ) + newWidth1111  + "px").style("top",( d3.mouse(this)[1] + (newHeight111+newHeight1/2) - (newHeight11 + 10) ) + "px")
                            }
                            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2  )  + "px").style("top",( d3.mouse(this)[1] + (newHeight111+newHeight1/2) - (newHeight11 + 10) ) + "px")
                            }
                        }
                        else if(options.showTitle == false){
                             
                            if(options.legendSide === "right"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2  )  + "px").style("top",( d3.mouse(this)[1] + (newHeight111+newHeight1/2) - (newHeight11 + 10) ) + "px")
                            }
                            else if(options.legendSide === "left"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2 ) + newWidth1111  + "px").style("top",( d3.mouse(this)[1] + (newHeight111+newHeight1/2) - (newHeight11 + 10) ) + "px")
                            }
                            else if(options.legendSide !== "right" && options.legendSide !== "left"){
                                toolTipForDonutChart.style("left", ( (d3.mouse(this)[0] + newWidth1/2) - newWidth11/2  )  + "px").style("top",( d3.mouse(this)[1] + (newHeight111+newHeight1/2) - (newHeight11 + 10) ) + "px")
                            }
                        }
                } // else if(height1>350)
                             
            } // else if(isResizedFunctionCalled == true){
            
        }); // path.on("mousemove",function(d,i) ends here.

        
        function clickedFunctionForDoNutChart() {
            
            var format = d3.format(".2s")
            textForDoNutChart = svgForDoNutChart.select(".labels").selectAll("text") .data(pieForDoNutChart(options.data))
            textForDoNutChart.enter() .append("text") .attr("dy", ".35em") .style("font-family","Verdana,sans-serif") .attr("font-size", "12px") .attr("shape-rendering", "crispEdges")
            .style("font-weight","Normal").style({"fill":"#00001c","display":"none"}).attr("class","series_value").style("display",options.series)
            
            textForDoNutChart.text(function(d,i) {
                if(d.value == 0) { 
                    d3.select(this).style("visibility", "hidden");  
                }
                else {  
                            
                    d3.select(this).style("visibility", "visible");
                    d3.select(this).style("visibility", "visible");


                    if(d.data[options.keys.value].toString().indexOf('.') === -1)
                    {
                        return d.data[options.keys.value].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    }
                    else {
                        
                        return d.data[options.keys.value]
                    }
                }
            });
            
            textForDoNutChart.transition().duration(1000)
            .attrTween("transform", function(d) {
                       this._current = this._current || d;
                       
                       var interpolate = d3.interpolate(this._current, d);
                       this._current = interpolate(0);
                       return function(t) {
                            //var d2 = interpolate(t);
                            //var pos = outerArcForDoNutChart.centroid(d2);
                            //pos[0] = radiusForDoNutChart * (midAngle(d2) < Math.PI ? 1 : -1);
                            var d2 = interpolate(t);
                            var pos = outerArcForDoNutChart.centroid(d2);
                            return "translate("+ pos +")";
                       };
                    })
            .styleTween("text-anchor", function(d){
                        this._current = this._current || d;
                        var interpolate = d3.interpolate(this._current, d);
                        this._current = interpolate(0);
                        return function(t) {
                            var d2 = interpolate(t);
                            return midAngle(d2) < Math.PI ? "start":"end";
                        };
                    });
            
            polylineForDoNutChart = svgForDoNutChart.select(".lines") .selectAll("polyline") .data(pieForDoNutChart(options.data));
            
            polylineForDoNutChart.enter() .append("polyline").style({"stroke-width": "1.0px","display":"none"}).attr('stroke', function(d) {  return 'black';  })
            
            var sampleIDS=targetElement[0];
            var divWidth = document.getElementById(sampleIDS[0].id).clientWidth
            var divHeight = document.getElementById(sampleIDS[0].id).clientHeight
            if(divWidth <= 300 || divHeight <= 400){    polylineForDoNutChart.style("display","none")    }
            else if(divWidth >300 || divHeight > 400){  polylineForDoNutChart.style("display","none")   }

            polylineForDoNutChart.transition() .duration(1000)
            .attrTween("points", function(d){
                       this._current = this._current || d;
                       
                       var interpolate = d3.interpolate(this._current, d);
                       
                       this._current = interpolate(0);
                       
                       if(d.value == 0) {
                            //this.remove();
                            d3.select(this).style("visibility","hidden");
                       }
                       else {
                            d3.select(this).style("visibility","hidden");
                            return function(t) {
                       
                                var newArcForDoNutChart = d3.svg.arc()
                                .innerRadius(radiusForDoNutChart - (radiusForDoNutChart/2))
                                .outerRadius(radiusForDoNutChart);
                       
                                var d2 = interpolate(t);
                                var pos = outerArcForDoNutChart.centroid(d2);
                       
                                return [newArcForDoNutChart.centroid(d2), outerArcForDoNutChart.centroid(d2)];
                          };
                       }
                   });
        }
        
        // Adding legend text
        var legendTextForDoNutChart = legendForDoNutChart.append('text') .data(pieForDoNutChart(newJson)).attr('x', legendRectSizeForDoNutChart + legendSpacingForDoNutChart + 1) .attr('y', legendRectSizeForDoNutChart - (legendSpacingForDoNutChart - 4.8)) 
        .style("font-family","Verdana,sans-serif") .style("font-size", "14px")  .style('fill','#00001c') .style("font-weight","Normal")
        .text(function(d,i) {
             if(d.data[options.keys.label].length > 10){
                    return d.data[options.keys.label].substring(0,10)+'...';//+ " : "+ d.data[options.keys.value];
                }
                   else{
                    
                    return d.data[options.keys.label]; //+" : "; //+ d.data[options.keys.value];
                }
        })
        
        var legendTextValue = legendForDoNutChart.append('text').data(pieForDoNutChart(newJson)) .attr('x', legendRectSizeForDoNutChart + legendSpacingForDoNutChart + 130) .attr('y', legendRectSizeForDoNutChart - (legendSpacingForDoNutChart - 4.8)) .style("font-family","Verdana,sans-serif") .style("font-size", "12px")
        .style('fill','#00001c') .style("font-weight","Normal").attr("class","legend_value").style("display",options.legend)
        .text(function(d,i) {
            if(d.data[options.keys.value].toString().indexOf('.') === -1)
            {
                return d.data[options.keys.value].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            else{
                
                return d.data[options.keys.value];
            }
             //return d.data[options.keys.value].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        })

        if(options.showLegend==false){
            legendGroup.style("visibility", "hidden");
            legendTextForDoNutChart.style("visibility","hidden");
        }
        else if(options.showLegend==true){
            legendGroup.style("visibility", "visible");
            legendTextForDoNutChart.style("visibility","visible");
        }

        // Creating table and everything within it
        var tablePanelForDoNutChart =  targetElement.append("div") .attr("id",targetElement[0][0].id + "holderForDonutChartTableID")
        .attr("class","scrollingDivForTable-Class tableDivForDonutChart" + targetElement[0][0].id) .style('background-color',"#ffffff") .style('position','absolute')
        .style("display","block") .style("overflow","hidden") .style("width", function(d) {  return 100.0 + "%"; })
        .style("height", function(d) { return 40 + "%"; }) .style("left",0 + "%")//.style("border-right","1px solid #e2e2e2").style("border-bottom","1px solid #e2e2e2")
        
        $( '.tableDivForDonutChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        if(options.showTitle == true && options.showLegend == true ){
            tablePanelForDoNutChart.style("top",60.0  + "%")
        }
        else if(options.showTitle == false && options.showLegend == true ){
            tablePanelForDoNutChart.style("top",60.0  + "%")
        }
        else if(options.showTitle == true && options.showLegend == false){
            tablePanelForDoNutChart.style("top",60.0  + "%")
        }
        else if(options.showTitle == false && options.showLegend == false){
            tablePanelForDoNutChart.style("top",60.0  + "%")
        }
        tablePanelForDoNutChart.html('<table class = "tableClassForDonutChart' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                     '<thead class = "theadClassForDonutChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForDonutChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                                     '<tbody class = "tBodyClassForDonutChart' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                     '</table>'
                                     )
        
        tablePanelForDoNutChart.select('table').attr("id",targetElement[0][0].id + 'tableID')

        // Show or Hide scroll bar when mouseover on widget
        targetElement.on('mouseover',function(){ tablePanelForDoNutChart.style("overflow","auto") })
        targetElement.on('mouseout',function(d){ tablePanelForDoNutChart.style("overflow","hidden") })
        
        var tableDataForDonutChart = [];
        if(options.dataForTable.length > 0){
            tableDataForDonutChart = options.dataForTable;
        }
        else {
            tableDataForDonutChart = newJson;
        }
        
        var thead = tablePanelForDoNutChart.select("thead").selectAll("th") .data(d3.keys(tableDataForDonutChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px").style("color","#00001c")
        
        var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff") //f4f4f4
        .style("position","relative")
        
        var thead1 = d3.select(".thead1ClassForDonutChart" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tableDataForDonutChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px").style("color","#00001c")
        
        var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff") //f4f4f4
        .style("position","relative")
        
        var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
        .attr("id", "ascendingIconIDForDoNutChart") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
        
        var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
        .attr("id", "descendingIconIDForDoNutChart") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')

        var tr = tablePanelForDoNutChart.select("tbody").selectAll("tr") .data(tableDataForDonutChart).enter().append("tr")
        .attr("id", function(d,i) { return "slice" + i })
        
        var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d})
        .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
        
        
        var $table = $('.tableClassForDonutChart' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
        
        /*colWidth = $bodyCells.map(function() { return $(this).width(); }).get();
        
        $table.find('thead tr').children().each(function(i, v) { $(v).width(colWidth[i]); });*/
        
        d3.select(".theadClassForDonutChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                d.forEach(function(dd,j){
                        colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                })
        })
        
        $(".thead1ClassForDonutChart" + targetElement[0][0].id).insertAfter('.tBodyClassForDonutChart' + targetElement[0][0].id)
        
        $(".thead1ClassForDonutChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForDonutChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
        
        tablePanelForDoNutChart.select(".thead1ClassForDonutChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
			d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
		})
        
        $('.tableDivForDonutChart' + targetElement[0][0].id).scroll(function () {
                                                                  
          $(".thead1ClassForDonutChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForDonutChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
          
        })
        
        var sortOrder = false;
        thead1.on("click",function(k,index){
                 
                 sortOrder = !sortOrder;
                 
                 tablePanelForDoNutChart.select(".thead1ClassForDonutChart" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                                                 
                        if (sortOrder) {
                                     
                            if(i == index){
                                d3.select(this).select('svg').select('#descendingIconIDForDoNutChart').style("visibility", "hidden")
                                d3.select(this).select('svg').select('#ascendingIconIDForDoNutChart').style("visibility", "visible")
                            }
                            else {
                                d3.select(this).select('svg').select('#descendingIconIDForDoNutChart').style("visibility", "visible")
                                d3.select(this).select('svg').select('#ascendingIconIDForDoNutChart').style("visibility", "visible")
                            }
                        }
                        else{
                                     
                            if(i == index){
                                d3.select(this).select('svg').select('#descendingIconIDForDoNutChart').style("visibility", "visible")
                                d3.select(this).select('svg').select('#ascendingIconIDForDoNutChart').style("visibility", "hidden")
                            }
                            else {
                                d3.select(this).select('svg').select('#descendingIconIDForDoNutChart').style("visibility", "visible")
                                d3.select(this).select('svg').select('#ascendingIconIDForDoNutChart').style("visibility", "visible")
                            }
                        }
                })
                  
                  var monthTruOrFalAryForDonutChart = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
                  
                  tr.sort(function(a, b) {
                          
                          if (sortOrder) {
                          var monthsArrayForDonutChart = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                          } else {
                          var monthsArrayForDonutChart = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                          }
                          
                          monthTruOrFalAryForDonutChart = []; gotMonthArray = [];
                          tableDataForDonutChart.forEach(function(d,i){
                              var da = d[k].toString().substring(0,3).toLowerCase()
                              if(monthsArrayForDonutChart.indexOf(da) >= 0){
                                  monthTruOrFalAryForDonutChart.push(true)
                                  gotMonthArray.push(da);
                              }
                              else {
                                  monthTruOrFalAryForDonutChart.push(false)
                              }
                          })
                          
                          if(monthTruOrFalAryForDonutChart.indexOf(false) == -1){ // true
                          
                          monthArray = []; monthArrayCount = [];
                          gotMonthArray.forEach(function(dd,j){
                                var index1 = monthsArrayForDonutChart.indexOf(dd.substring(0,3))
                                if(monthArrayCount.indexOf(index1) >= 0){
                                    index1 = 12 + index1;
                                }
                                monthArray.push(index1);
                                monthArrayCount.push(index1)
                          })
                          returnArray = []
                          monthArray.sort(function(aa, bb) {
                              returnArray.push(+aa - +bb)
                              return +aa - +bb;
                          })
                          
                          sortTableFunc()
                          return returnArray[ind++];
                          } //  if true (if jan feb if block)
                          else {
                          var data = +a[k];
                          
                          if(!isNaN(data)){
                          
                          if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                          else { return d3.descending(+a[k], +b[k]); }
                          }
                          else if(!isNaN(Date.parse(a[k]))){
                          
                          if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                          else { return new Date(b[k]) - new Date(a[k]) }
                          }
                          else {
                          
                          if (sortOrder) { return d3.ascending(a[k], b[k]); }
                          else { return d3.descending(a[k], b[k]); }
                          }
                    } // if not jan feb else block
                }); // tr
                
		})
        
        function sortTableFunc(){
            
            var table = tablePanelForDoNutChart.select('table');
            var rows = table.selectAll('tr').data(tableDataForDonutChart);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0) .style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500)
            .style('opacity', 1.0) .style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
            
        }
        
        if(options.dataForTable.length == 0){
            var selectedItem = "";
            pathForDoNutChart.on("click", function(d,i) {
                
                thead1.select('svg').select('#descendingIconIDForDoNutChart').style("visibility", "visible")
                thead1.select('svg').select('#ascendingIconIDForDoNutChart').style("visibility", "visible")
                             
                sortTableFunc()
                
                selectedItem = i
                
                var val = d.value;
                var selectedSlice = i
                options.data.forEach(function(d,i) {
                                     
                    if(i == selectedItem){
                        tablePanelForDoNutChart.select("tbody").selectAll("tr")
                        .style("background-color", function(dTr, iTr) {
                            return i == iTr ? "#909090" : null;
                        })
                        .style("color", function(dTr, iTr) {
                            return i == iTr ? "#FFFFFF" : null;
                        })
                        var row = $('#' + targetElement[0][0].id + "tableID").find('tr');
                        if((row[0].clientHeight * selectedItem) > tablePanelForDoNutChart[0][0].clientHeight - 56 ){
                            $("#" + targetElement[0][0].id + "holderForDonutChartTableID").animate({
                                scrollTop: row[0].clientHeight * selectedItem }, 350);
                        }
                        else {
                            $("#" + targetElement[0][0].id + "holderForDonutChartTableID").animate({
                                scrollTop: 0 }, 350);
                            }

                    }//if(i == selectedItem)
                });
            })
        }
        
        // Main Table Styling
        tablePanelForDoNutChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
        .style("color","#00001c")
        .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4")
        tablePanelForDoNutChart.selectAll('td').style("height","25px") .style("border", "1px solid #dddddd") .style("font-size","12px").style("font-weight","Normal").style("color","#00001c")

        //additionally 
        tablePanelForDoNutChart.selectAll('th').style('background-color',"#ffffff").style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
        tablePanelForDoNutChart.selectAll('td').style("border-style","none").style("color","#00001c")

        //b1da9f
        tablePanelForDoNutChart.selectAll('table') . style("border-collapse","collapse")
        tablePanelForDoNutChart.selectAll('table tr:first-child th').style("border-top","0px")
        tablePanelForDoNutChart.selectAll('table tr:last-child td').style("border-bottom","0px")
        tablePanelForDoNutChart.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
        tablePanelForDoNutChart.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")

        if(showOrHideTableForDonutChart == false){ 
            tablePanelForDoNutChart.style("display","none")    
        }   
        else if(showOrHideTableForDonutChart == true){ 
            tablePanelForDoNutChart.style("display","block")
        }
        
        if(options.isDataDetailedForTable == false){
        
            var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
        
            // Adding underlines for selected drill-down column text
            var drillDownSectionsForDonutChart = tablePanelForDoNutChart.select('table').selectAll('th')
            var drillDownSectionsFor_PieChart = drillDownSectionsForDonutChart[0]
        
            var foundResult = [];
            for(var i = 0; i<drillDownSectionsForDonutChart[0].length; i++){
            
                for(var j = 0; j<drillDownColumnNamesArray.length; j++){
                    if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForDonutChart[0][i].__data__.toString().toLowerCase() ){
                        foundResult.push(i)
                    }
                }
            }
        
            var r = tablePanelForDoNutChart.select('table').selectAll('tr').selectAll('td')
            for(var i = 0; i<r.length; i++){
                for(var j = 0; j < foundResult.length; j++){
                    var row = r[i][foundResult[j]]
                    $(row).css("text-decoration", "underline")
                }
            
                /*var row = r[i][foundResult[0]]
                 $(row).css("text-decoration", "underline")*/
            }
        }
        
        //By default calling the resized function first time (to align table's th and td).
        //resizedFuctionForDonutChart()
        
        window.addEventListener('resize', function(event){
            divWidthForDoNutChart = $("#" + targetElement[0][0].id).width()
            divHeightForDoNutChart = $("#" + targetElement[0][0].id).height()
            resizedFuctionForDonutChart()
        });
        
        $(function() {
          
			$("#" + targetElement[0][0].id).resizable({
                resize: function(event, ui) {
                    divWidthForDoNutChart = ui.size.width;
                    divHeightForDoNutChart = ui.size.height;
                    resizedFuctionForDonutChart();
                }
            });
        });
        
        function resizedFuctionForDonutChart(){
            
            if(divWidthForDoNutChart <= 300 || divHeightForDoNutChart <= 300){    polylineForDoNutChart.style("display","none")    }
            else if(divWidthForDoNutChart >300 || divHeightForDoNutChart > 300){  polylineForDoNutChart.style("display","none")   }

            isResizedFunctionCalled = true
            
            if(showOrHideCommentsBtnForDonutChart == true){
                bubbleButtonForDonutChart.style('margin-left', "2px")
                pieButtonForDonuteChart.style('margin-left', "2px")
                colButtonForDonutChart.style('margin-left', "2px")
                horButtonForDonutChart.style('margin-left', "2px")
                filterButtonForDonutChart.style('margin-left', "2px")
                refreshButtonForDonutChart.style('margin-left', "2px")
                commentsBtnForDonutChart.style('margin-left', "2px")
                // menuButtonForDonutChart.style('right', '0')
                menuButtonForDonutChart.style('right', '0')

            }
            else if(showOrHideCommentsBtnForDonutChart == false){
                bubbleButtonForDonutChart.style('margin-left', "2px")
                pieButtonForDonuteChart.style('margin-left', "2px")
                colButtonForDonutChart.style('margin-left', "2px")
                horButtonForDonutChart.style('margin-left', "2px")
                filterButtonForDonutChart.style('margin-left', "2px")
                refreshButtonForDonutChart.style('margin-left', "2px")
                //commentsBtnForDonutChart.style('right', '0')
                commentsBtnForDonutChart.style('display','none')
                // menuButtonForDonutChart.style('right', '0')
                menuButtonForDonutChart.style('right', '0')

            }

            optionsButtonPanelForDonutChart.style('right', '0')

            cancelButtonForFilterPanelDonutChart.style('right', '0')
            settingPanelCanBtnForDonutChart.style('right', '0')

            if(isSearchInTableButtonClicked == true){
                canBtnForSearchDivForSearchTableForDonutChart.style('right', '0')
            }
			
            width1 = targetElement[0][0].clientWidth * (parseFloat(svgPanel[0][0].style.width) / 100)
            height1 = targetElement[0][0].clientHeight * (parseFloat(svgPanel[0][0].style.height) / 100)

            width1ForDonutChart = targetElement[0][0].clientWidth * (parseFloat(svgPanel[0][0].style.width) / 100)
            height1ForDonutChart = targetElement[0][0].clientHeight * (parseFloat(svgPanel[0][0].style.height) / 100)

            newWidth1 = targetElement[0][0].clientWidth * (parseFloat(svgPanel[0][0].style.width) / 100)
            newHeight1 = targetElement[0][0].clientHeight * (parseFloat(svgPanel[0][0].style.height) / 100)
            
            newWidth111 = chartTitlePanel[0][0].clientWidth
            newHeight111 = chartTitlePanel[0][0].clientHeight
            
            newWidth1111 = targetElement[0][0].clientWidth * (parseFloat(legendPanelFront[0][0].style.width) / 100)
            newHeight1111 = targetElement[0][0].clientHeight * (parseFloat(legendPanelFront[0][0].style.height) / 100)
            
            var newRadius = Math.min(width1, height1) / 3.0;
            
            if(options.showTitle == false && options.showLegend == false){
                newRadius = Math.min(width1, height1) / 2.8;
            }
            else if(options.showTitle == true && options.showLegend == false){
                newRadius = Math.min(width1, height1) / 2.5;
            }
            
             // Resizing the Gradient Effect 
            svgForDoNutChart.select("circle").transition().duration(0).delay(0)
            .attr("r", newRadius/1.25);

            svgForDoNutChart.attr('transform', 'translate(' + (width1/2) + ',' + (height1 / 2) + ')');
            
            arcForDoNutChart = d3.svg.arc() .outerRadius(newRadius * 0.8) .innerRadius(newRadius * 0.45);
            
            outerArcForDoNutChart = d3.svg.arc() .innerRadius(newRadius * 0.9) .outerRadius(newRadius * 0.9);
            
            arcForDoNutChart.innerRadius(newRadius * 0.45).outerRadius(newRadius * 0.8);
            
            arcOverForDoNutChart = d3.svg.arc()  .outerRadius((newRadius * 0.9) + 0.02) .innerRadius(newRadius * 0.45);
            
            pathForDoNutChart.transition().duration(500).attrTween("d", arcTween);
            
            function arcTween(a) {
                var i = d3.interpolate(this._current, a);
                this._current = i(0);
                return function(t) {
                    return arcForDoNutChart(i(t));
                };
            }
            
            textForDoNutChart.transition().duration(10).attrTween("d", textTween);
            
            function textTween(a) {
                
                textForDoNutChart.transition().duration(500)
                .attrTween("transform", function(d) {
                   this._current = this._current || d;
                   
                   var interpolate = d3.interpolate(this._current, d);
                   this._current = interpolate(0);
                   return function(t) {
                        var d2 = interpolate(t);
                        var pos = outerArcForDoNutChart.centroid(d2);
                        return "translate("+ pos +")";
                   };
                })
            }
            
            
            polylineForDoNutChart.transition().duration(500)
            .attrTween("points", function(d){
               this._current = this._current || d;
               
               var interpolate = d3.interpolate(this._current, d);
               
               this._current = interpolate(0);
               
               if(d.value == 0){
                 d3.select(this).style("visibility","hidden");
               }
               else {
                 d3.select(this).style("visibility","hidden");
               return function(t) {
                    var newArcForDoNutChart = d3.svg.arc()
                    .innerRadius(newRadius - (newRadius/2))
                    .outerRadius(newRadius);
               
                    var d2 = interpolate(t);
                    var pos = outerArcForDoNutChart.centroid(d2);
               
                    return [newArcForDoNutChart.centroid(d2), outerArcForDoNutChart.centroid(d2)];
                    };
                }
           });
            
            var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(legendPanelFront[0][0].style.width) / 100)
            var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(legendPanelFront[0][0].style.height) / 100)
            
            var legendRectSize = 11;
            var legendSpacing = 5;
            
            legendForDoNutChart.attr('transform', function(d, i) {
                                                  
				var height = legendRectSize + legendSpacing;
				var offset =  height * colorsForDoNutChart.domain().length / 2;
				var horz = 2;
				var vert = (i * height) + (legendPanelHeight - (height * options.data.length))/2 ;
				return 'translate(' + horz + ',' + vert + ')';
                                     
			})
            
            //var arcOverForDoNutChart = d3.svg.arc() .outerRadius((newRadius * 0.9) + 0.05);
            
            pathForDoNutChart.on("mouseenter", function(d,i) {   d3.select(this) .attr("stroke","white") .transition() .ease("elastic") .duration(100) .attr("d", arcOverForDoNutChart) .attr("stroke-width",0.5);
			});
            
            pathForDoNutChart.on("mouseleave", function(d) {   d3.select(this).transition() .attr("d", arcForDoNutChart) .attr("stroke","none");   });
            
            colWidth = []; 
			
            d3.select(".theadClassForDonutChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                    d.forEach(function(dd,j){
                            colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                    })
            })
            
            tablePanelForDoNutChart.select(".thead1ClassForDonutChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                        d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
            })
            
           } // resizedFunction ends here.
    }, //donutChart
    
    // ************************************************** Horizontal Chart  **************************************************
    horizontalChart: function(targetElement, options){

        isChartCalled++;
        var chartName = "HORIZONTALCHART"
        var dropDownForHorizontalChart;
        acinfotech.allCharts(targetElement,options,chartName)

        var newJson = [];
        options.data.forEach(function(d, i) {
            var temp = {};
            
            for(var i = 0; i < Object.keys(d).length; i++) {
                delete d['enabled'];
                temp[Object.keys(d)[i]] = d[Object.keys(d)[i]]
            }
            
            newJson.push(temp)
        });

        targetElement.style("min-width", "350px").style("min-height", "350px").style("background-color", options.BGcolor)

        var showOrHideTableForHoriChart;
        var showOrHideCommentsForHoriChart;
        var showOrHideCommentsBtnForHoriChart = true;

        if((options.showTable == false) || (options.showTable == true)){
            showOrHideTableForHoriChart = options.showTable    
        }
        else{
            showOrHideTableForHoriChart = false;
        }

        // Show or Hide comments
        if (options.showComments == true || false) {
            showOrHideCommentsForHoriChart = options.showComments;
        }
        else {
            showOrHideCommentsForHoriChart = false;
        }
        
        if (options.comments.length == 0){ 
            showOrHideCommentsForHoriChart = false;
            showOrHideCommentsBtnForHoriChart = false;
        }

        if ((showOrHideTableForHoriChart == true) && (showOrHideCommentsForHoriChart == true)){
            showOrHideTableForHoriChart = true;
            showOrHideCommentsForHoriChart = false;
        }
        else if ((showOrHideTableForHoriChart == false) && (showOrHideCommentsForHoriChart == false)){
            showOrHideTableForHoriChart = false;
            showOrHideCommentsForHoriChart = false;
        }

        var divWidthForHoriChart, divHeightForHoriChart;
        
        // Creating chart title 
        var chartTitlePanelForHoriChart =  targetElement.append("div") .style("position","absolute").style("background-color", options.BGcolor) .style('position',"absolute")
        .style("border","none") .style("text-indent","6px")
		
		var optionsButtonPanelForHorizontalChart = targetElement.append('div').style('width',"25px").style('height', "285px").style('position','absolute')
        .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px")
        .style('right', '0')
        .style("min-width","25px") .style("border-style","none").style("border-left", "solid #fcfcfc  1px")
		
        var pieButtonForHorizontalChart = optionsButtonPanelForHorizontalChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','133px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var pieBtnImgVar = document.createElement("IMG");
        pieBtnImgVar.src = "images/pieIcon.png";
        pieBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:14px; height:14px; opacity:0.8;")
        pieButtonForHorizontalChart[0][0].appendChild(pieBtnImgVar)

        var columnButtonForHorizontalChart = optionsButtonPanelForHorizontalChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','159px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var columnBtnImgVar = document.createElement("IMG");
        columnBtnImgVar.src = "images/columnIcon.png";
        columnBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:14px; height:14px; opacity:0.9;")
        columnButtonForHorizontalChart[0][0].appendChild(columnBtnImgVar)

        var donutButtonForHorizontalChart = optionsButtonPanelForHorizontalChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','184px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var dountBtnImgVar = document.createElement("IMG");
        dountBtnImgVar.src = "images/donutIcon.png";
        dountBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:14px; height:14px; opacity:0.8;")
        donutButtonForHorizontalChart[0][0].appendChild(dountBtnImgVar)

        var filterButtonForHorizontalChart = optionsButtonPanelForHorizontalChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','209px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var filterBtnImgVar = document.createElement("IMG");
        filterBtnImgVar.src = "images/filterIcon.png";
        filterBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:14px; height:14px; opacity:0.8;")
        filterButtonForHorizontalChart[0][0].appendChild(filterBtnImgVar)

        var refreshButtonForHorizontalChart = optionsButtonPanelForHorizontalChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','234px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var refreshBtnImgVar = document.createElement("IMG");
        refreshBtnImgVar.src = "images/refreshIcon.png";
        refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:14px; height:14px; opacity:0.8;")
        refreshButtonForHorizontalChart[0][0].appendChild(refreshBtnImgVar)

        var commentsBtnForHoriChart = optionsButtonPanelForHorizontalChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','259px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var commentsBtnImgVariable = document.createElement("IMG");
        if(options.showComments == false){
            commentsBtnImgVariable.src = "images/showCommentsIcon.png";
        }
        else if(options.showComments == true){
            commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
        }
        commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:15px; height:15px; opacity:0.8;")
        commentsBtnForHoriChart[0][0].appendChild(commentsBtnImgVariable)

        var menuButtonForHorizontalChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','1px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        
        var menuBtnImgVar = document.createElement("IMG");
        menuBtnImgVar.src = "images/menuIcon.png";
        menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
        menuButtonForHorizontalChart[0][0].appendChild(menuBtnImgVar)

        if(showOrHideCommentsBtnForHoriChart == true){
            pieButtonForHorizontalChart.style('margin-left', "2px")
            columnButtonForHorizontalChart.style('margin-left', "2px")
            donutButtonForHorizontalChart.style('margin-left', "2px")
            filterButtonForHorizontalChart.style('margin-left', "2px")
            refreshButtonForHorizontalChart.style('margin-left', "2px")
            commentsBtnForHoriChart.style('margin-left', "2px")
            menuButtonForHorizontalChart.style('right', '0')
        }
        else if(showOrHideCommentsBtnForHoriChart == false){
            pieButtonForHorizontalChart.style('margin-left', "2px")
            columnButtonForHorizontalChart.style('margin-left', "2px")
            donutButtonForHorizontalChart.style('margin-left', "2px")
            filterButtonForHorizontalChart.style('margin-left', "2px")
            refreshButtonForHorizontalChart.style('margin-left', "2px")
            //commentsBtnForHoriChart.style('right', '0')
            commentsBtnForHoriChart.style('display','none')
            menuButtonForHorizontalChart.style('right', '0')
        }

        var ismenuButtonOfHorizontalChartClicked = false; // Menu toggle button variable
        menuButtonForHorizontalChart.on('click', function() {
            if(ismenuButtonOfHorizontalChartClicked == false){
                ismenuButtonOfHorizontalChartClicked = true; // Menu toggle button variable
                optionsButtonPanelForHorizontalChart.style("display","block") // Showing option buttons panel

                searchDivForHorizontalChart.style("display","none") // Hiding filter panel
                settingPanelDivForHorizontalChart.style("display","none") // Hiding setting panel

                if(options.showTitle == true){
            
                if ((showOrHideTableForHoriChart == false) && (showOrHideCommentsForHoriChart == true)){
                    
                    svgPanelForHoriChart.style('width', 100 + "%") .style('height', 70 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForHoriChart == true) && (showOrHideCommentsForHoriChart == false)){
                    
                    svgPanelForHoriChart.style('width', 100 + "%") .style('height', 52 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor);
                }
                else if ((showOrHideTableForHoriChart == false) && (showOrHideCommentsForHoriChart == false)){
                     
                    svgPanelForHoriChart.style('width', 100 + "%") .style('height', 85 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }

            }
            else if(options.showTitle == false){
           
                if ((showOrHideTableForHoriChart == false) && (showOrHideCommentsForHoriChart == true)){
                    
                    svgPanelForHoriChart.style('width', 100 + "%") .style('height', 70 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForHoriChart == true) && (showOrHideCommentsForHoriChart == false)){
                    
                    svgPanelForHoriChart.style('width', 100 + "%") .style('height', 52 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForHoriChart == false) && (showOrHideCommentsForHoriChart == false)){
                     
                    svgPanelForHoriChart.style('width', 100 + "%") .style('height', 85 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
            }

                resizedFuctionForHorizontalChart();
            }
            else if(ismenuButtonOfHorizontalChartClicked == true){
                ismenuButtonOfHorizontalChartClicked = false; // Menu toggle button variable
                optionsButtonPanelForHorizontalChart.style("display","none") // Hiding option buttons panel
            }
        })

        var svgPanelForHoriChart = targetElement .append('svg') 
        .attr("id","svgPanelIDForHoriChart" + targetElement[0][0].id).style("background-color", options.BGcolor) .style("position","absolute")
        
        var commentsPanelDivForHoriChart = targetElement.append("div") .attr("class","commentsPanelClassForHoriChart") 
        .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
		.style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
        .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)

        commentsPanelDivForHoriChart.on('click',function(d){
            $('.commentsClassForHoriChart' + targetElement[0][0].id).focus()
        })

        if(options.showTitle == true){
            
            chartTitlePanelForHoriChart.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 8 + "%"; }).style("background-color", options.BGcolor)
            .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:16.0%; font-size:16px; font-family:inter;  color:#00001c;">'+ options.chartTitle + '</div>')

            if ((showOrHideTableForHoriChart == false) && (showOrHideCommentsForHoriChart == true)){

                var commentsForHorichart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify') .attr('class','commentsClassForHoriChart' + targetElement[0][0].id)

                   svgPanelForHoriChart.attr('width', 100 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .style("background-color", options.BGcolor).append('g')
                   commentsPanelDivForHoriChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForHorichart[0].outerHTML.toString())

            }
            else if ((showOrHideTableForHoriChart == true) && (showOrHideCommentsForHoriChart == false)){

                    svgPanelForHoriChart.attr('width', 100 + "%") .attr('height', 52 + "%") .style("top",8 + "%").style("background-color", options.BGcolor) .append('g')
                    commentsPanelDivForHoriChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForHoriChart == false) && (showOrHideCommentsForHoriChart == false)){
                    svgPanelForHoriChart.attr('width', 100 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .style("background-color", options.BGcolor).append('g')
                    commentsPanelDivForHoriChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            
            var margin = {top: 20, right: 55, bottom: 30, left: 130}, //originally left: 85
            width = (svgPanelForHoriChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = svgPanelForHoriChart.node().getBoundingClientRect().height - margin.top - margin.bottom;
        }
        else if(options.showTitle == false){
            chartTitlePanelForHoriChart.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });

            if ((showOrHideTableForHoriChart == false) && (showOrHideCommentsForHoriChart == true)){

                var commentsForHorichart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify')

                   svgPanelForHoriChart.attr('width', 100 + "%") .attr('height', 70 + "%") .style("top",8 + "%").style("background-color", options.BGcolor) .append('g')
                   commentsPanelDivForHoriChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForHorichart[0].outerHTML.toString())

            }
            else if ((showOrHideTableForHoriChart == true) && (showOrHideCommentsForHoriChart == false)){

                    svgPanelForHoriChart.attr('width', 100 + "%") .attr('height', 52 + "%") .style("top",8 + "%").style("background-color", options.BGcolor) .append('g')
                    commentsPanelDivForHoriChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForHoriChart == false) && (showOrHideCommentsForHoriChart == false)){
                    svgPanelForHoriChart.attr('width', 100 + "%") .attr('height', 85 + "%") .style("top",8 + "%").style("background-color", options.BGcolor) .append('g')
                    commentsPanelDivForHoriChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }

            var margin = {top: 20, right: 55, bottom: 30, left: 130}, //originally left: 85
            width = (svgPanelForHoriChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = svgPanelForHoriChart.node().getBoundingClientRect().height - margin.top - margin.bottom;
        }
        
        var colors;
        // Checking color-set variable value as received from .html file
        if(options.colorSet === undefined){
            options.colorSet = "one"
            colors = d3.scale.ordinal().range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "one"){
            options.colorSet = "one"
            colors = d3.scale.ordinal().range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            options.colorSet = "two"
            colors = d3.scale.ordinal().range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            options.colorSet = "three"
            colors = d3.scale.ordinal().range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        }
        else
        {
            options.colorSet = "one"
            colors = d3.scale.ordinal().range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }

        /*------------------ Settings panel DIV and everything within it section begins here ------------------*/
        var settingDisabledDivForHorizontalChart = targetElement.append('div').style('width',targetElement[0][0].clientWidth + "px").style('height',targetElement[0][0].clientHeight + "px").style('position','absolute')
        .style("background-color",'#f3f3f3').style("z-index",2).style("display","none").style('top', 0.0 + "%").style('left', 0.0 + "%")
        .style("opacity",0.1).style("min-width","350px").style("min-height","350px") //005ec4

        var settingPanelDivForHorizontalChart = targetElement.append('div').style('width',"100%").style('height',"40%").attr("class","settingPanelDivForHorizontalChart" + targetElement[0][0].id)
        .style('position','absolute').style('margin-left', "0px").style('border-top',"1px solid #f0f0f0").style('border-bottom',"1px solid #e5e5e5")
        .style("background-color",'#fcfcfc').style("z-index",90)
        .style("display","none")
        .style('top',"60%").style('height',"40%")

        $( '.settingPanelDivForHorizontalChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        var settingPanelDivForHorizontalChartTitle = settingPanelDivForHorizontalChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','10px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; color:#00001c;">'+ "Settings" +'</div>')

        var settingPanelCancelButtonForHorizontalChart = settingPanelDivForHorizontalChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
        .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
        .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.90; background-color:#fcfcff")
        settingPanelCancelButtonForHorizontalChart[0][0].appendChild(cancelBtnImgVar)

        // Cancel button of Setting panel clicked
        settingPanelCancelButtonForHorizontalChart.on('click', function() {
            settingButton.style("cursor","pointer")
            settingPanelDivForHorizontalChart.style("display","none")

            if ((showOrHideTableForHoriChart == false) && (showOrHideCommentsForHoriChart == true)){
                    
                    svgPanelForHoriChart.style('width', 100 + "%") .style('height', 70 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForHoriChart == true) && (showOrHideCommentsForHoriChart == false)){
                    
                    svgPanelForHoriChart.style('width', 100 + "%") .style('height', 52 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor);
                }
                else if ((showOrHideTableForHoriChart == false) && (showOrHideCommentsForHoriChart == false)){
                     
                    svgPanelForHoriChart.style('width', 100 + "%") .style('height', 85 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }

            resizedFuctionForHorizontalChart();
        })
        
        var settingPanelDivForHorizontalChangeColorTitle = settingPanelDivForHorizontalChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Select color set " +'</div>')

        var formForChangeSettingsPanel = settingPanelDivForHorizontalChart.append("form");
        formForChangeSettingsPanel.style("background-color","#fcfcfc").style("margin-top","67px").style("font-family","Verdana,sans-serif").style("font-size","12px")
        .style("position","absolute").attr("id","formForChangeColorSettingsPanel" + targetElement[0][0].id).style("font-weight","Bold").style("width","180px")
        .style("height","58px").style("padding","0px").style("border-radius","0px") .style("margin-left","10px")

        var svgPanelForColorSetOneForHoriChart = formForChangeSettingsPanel.append("svg").style("position","absolute")
        .style("background-color","#fefefe").style("width","160px").style("height","18px").style("margin-top","1px").style("margin-left","0px")
        .style("box-sizing","border-box")
        
        var colorSetOneForHoriChart = d3.scale.ordinal().range(["#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f"]);
        var colorSetOneRangeForHoriChart = d3.range(12);

        var colorSetOneDotsForHoriChart = svgPanelForColorSetOneForHoriChart.append("g")
        colorSetOneDotsForHoriChart.selectAll('rect') .data(colorSetOneRangeForHoriChart) .enter().append('rect')
        .attr('transform', 'translate(' + (2) + ',' + (1) + ')') .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10)
        .attr("height",10) .style("fill", function(d,i){return colorSetOneForHoriChart(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1)
        .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetOneForHoriChart(i);  }) .style("cursor","auto")
        .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        var svgPanelForColorSetTwoForHoriChart = formForChangeSettingsPanel.append("svg").style("position","absolute")
        .style("background-color","#fefefe").style("width","160px").style("height","18px").style("margin-top","20px").style("margin-left","0px")
        .style("box-sizing","border-box")
        
        var colorSetTwoForHoriChart = d3.scale.ordinal().range(["#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387"]);
        var colorSetTwoRangeForHoriChart = d3.range(12);

        var colorSetTwoDotsForHoriChart = svgPanelForColorSetTwoForHoriChart.append("g")
        colorSetTwoDotsForHoriChart.selectAll('rect') .data(colorSetTwoRangeForHoriChart) .enter().append('rect')
        .attr('transform', 'translate(' + (2) + ',' + (1) + ')') .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10)
        .attr("height",10) .style("cursor","auto") .style("fill", function(d,i){return colorSetTwoForHoriChart(i)})
        .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
        .style("stroke",function(d,i){  return colorSetTwoForHoriChart(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        var svgPanelForColorSetThreeForHoriChart = formForChangeSettingsPanel.append("svg").style("position","absolute")
        .style("background-color","#fefefe").style("width","160px").style("height","18px").style("margin-top","39px").style("margin-left","0px")
        .style("box-sizing","border-box")
        
        var colorSetThreeForHoriChart = d3.scale.ordinal().range(["#cc719f", "#cc719f", "#cc719f", "#cc719f", "#cc719f", "#cc719f", "#cc719f", "#cc719f", "#cc719f", "#cc719f", "#cc719f", "#cc719f"]);
        var colorSetThreeRangeForHoriChart = d3.range(12);

        var colorSetThreeDotsForHoriChart = svgPanelForColorSetThreeForHoriChart.append("g")
        colorSetThreeDotsForHoriChart.selectAll('rect') .data(colorSetThreeRangeForHoriChart) .enter().append('rect')
        .attr('transform', 'translate(' + (2) + ',' + (1) + ')') .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10)
        .attr("height",10) .style("cursor","auto") .style("fill", function(d,i){return colorSetThreeForHoriChart(i)})
        .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
        .style("stroke",function(d,i){  return colorSetThreeForHoriChart(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        if(options.colorSet.toString().toLowerCase() === "one"){
            svgPanelForColorSetOneForHoriChart.style('border',"1px solid #808080")
            svgPanelForColorSetTwoForHoriChart.style('border',"0px solid #808080")
            svgPanelForColorSetThreeForHoriChart.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            svgPanelForColorSetOneForHoriChart.style('border',"0px solid #808080")
            svgPanelForColorSetTwoForHoriChart.style('border',"1px solid #808080")
            svgPanelForColorSetThreeForHoriChart.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            svgPanelForColorSetOneForHoriChart.style('border',"0px solid #808080")
            svgPanelForColorSetTwoForHoriChart.style('border',"0px solid #808080")
            svgPanelForColorSetThreeForHoriChart.style('border',"1px solid #808080")
        }
        else 
        {
            svgPanelForColorSetOneForHoriChart.style('border',"1px solid #808080")
            svgPanelForColorSetTwoForHoriChart.style('border',"0px solid #808080")
            svgPanelForColorSetThreeForHoriChart.style('border',"0px solid #808080")
        }

        svgPanelForColorSetOneForHoriChart.on('click',function(d){
            options.colorSet = "one"
            svgPanelForColorSetOneForHoriChart.style('border',"1px solid #808080")
            svgPanelForColorSetTwoForHoriChart.style('border',"0px solid #808080")
            svgPanelForColorSetThreeForHoriChart.style('border',"0px solid #808080")

            var colorSetOne = d3.scale.ordinal().range(["#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f", "#ff6e5f"]);
            colors = colorSetOne;
            horizontalBars.style("fill",function(d,i){ return  colorSetOne(i) })

        })
        svgPanelForColorSetTwoForHoriChart.on('click',function(d){
            options.colorSet = "two"
            svgPanelForColorSetOneForHoriChart.style('border',"0px solid #808080")
            svgPanelForColorSetTwoForHoriChart.style('border',"1px solid #808080")
            svgPanelForColorSetThreeForHoriChart.style('border',"0px solid #808080")

            var colorSetTwo = d3.scale.ordinal().range(["#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387", "#e2d387"]);
            colors = colorSetTwo;
            horizontalBars.style("fill",function(d,i){  return colorSetTwo(i); }); 

        })
        svgPanelForColorSetThreeForHoriChart.on('click',function(d){
            options.colorSet = "three"
            svgPanelForColorSetOneForHoriChart.style('border',"0px solid #808080")
            svgPanelForColorSetTwoForHoriChart.style('border',"0px solid #808080")
            svgPanelForColorSetThreeForHoriChart.style('border',"1px solid #808080")

            var colorSetThree = d3.scale.ordinal().range(["#cc719f", "#cc719f", "#cc719f", "#cc719f", "#cc719f", "#cc719f", "#cc719f", "#cc719f", "#cc719f", "#cc719f", "#cc719f", "#cc719f"]);
            colors = colorSetThree;
            horizontalBars.style("fill",function(d,i){  return colorSetThree(i); })
        })

        /*------------------ Settings panel DIV and everything inside it section ends here ------------------*/

        var jsonData = options.data
        var valueArray = [];
        var labelArray = [];
        
        options.data.forEach(function(d, i) {
             d[options.keys.value] = d[options.keys.value];
             valueArray.push(d[options.keys.value])
             labelArray.push(d[options.keys.label])
        })
        
        var x = d3.scale.linear() .domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.value]; }))]) .range([0, width]);
        
        var y = d3.scale.linear() .domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.value]; }))]) .range([height, 0]);
        
        var y1 = d3.scale.ordinal() .domain(options.data.map(function(d) { return d[options.keys.label]; })) .rangeRoundBands([0, height], 0.30);
        
        var tip = d3.tip() .attr('class', 'd3-tip') .offset([-10, 0]) .style("font-family","Verdana,sans-serif").style("padding","4px").style("text-transform","capitalize").style("font-weight","Bold").style("font-size","12px")
		.style("color","#00001c").style("z-index",1000)

        .html(function(d, i) {
            var valueForHoriChartToolTip;
            if(valueArray[i].toString().indexOf('.') === -1)
            {
                valueForHoriChartToolTip = valueArray[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            else{
                        
                valueForHoriChartToolTip = valueArray[i];
            }
            return options.keys.label + " : " + labelArray[i] + "<br>" + '<hr style="height:2px; width:100%px; margin:2px; border:none;color:#333;background-color:#E0E0E0;" />'+ options.keys.value +" : " + valueForHoriChartToolTip;
              //return options.keys.label + " : " + labelArray[i] + "<br>" + '<hr style="height:2px; width:100%px; margin:2px; border:none;color:#333;background-color:#E0E0E0;" />'+ options.keys.value +" : " + valueArray[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        });//valueArray[i] ; });

        var minAndMaxValuesArrayForHorizontalChart = []
            newJson.forEach(function(d, i) {
                var dd = parseFloat(d[options.keys.value])
                minAndMaxValuesArrayForHorizontalChart.push(dd) 
            });
        
        var low = d3.min(minAndMaxValuesArrayForHorizontalChart);
        var hig = d3.max(minAndMaxValuesArrayForHorizontalChart);  

        var searchChartButton = optionsButtonPanelForHorizontalChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff").style('margin-left','2px').style('top','1px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #888888") .style("border-style", "none")
        var searchBtnImgVar = document.createElement("IMG");
        searchBtnImgVar.src = "images/searchChart1.png";
        searchBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.82;")
        searchChartButton[0][0].appendChild(searchBtnImgVar)

        var editChartButton = optionsButtonPanelForHorizontalChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 0px 0px #888888") .style('background-color',"#ffffff").style('margin-left','2px').style('top','27px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #888888") .style("border-style", "none")
        var editChartIconImgVar = document.createElement("IMG");
        editChartIconImgVar.src = "images/changeXAndYValuesIcon.png";
        editChartIconImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.9;")
        editChartButton[0][0].appendChild(editChartIconImgVar)

        var tableButtonForHoriChart = optionsButtonPanelForHorizontalChart.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 53 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
        var tableBtnImgVar = document.createElement("IMG");
        if(showOrHideTableForHoriChart == false){
            tableBtnImgVar.src = "images/showTableIcon.png";
            tableButtonForHoriChart.attr("class","showTableClassForChartTable")
        }
        else if(showOrHideTableForHoriChart == true){
            tableBtnImgVar.src = "images/cancelTableIcon.png";
            tableButtonForHoriChart.attr("class","hideTableClassForChartTable")
        }
        tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
        tableButtonForHoriChart[0][0].appendChild(tableBtnImgVar)
        
        var settingButton = optionsButtonPanelForHorizontalChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff").style('margin-left','2px').style('top',  80 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #888888") .style("border-style", "none")
        var settingBtnImgVar = document.createElement("IMG");
        settingBtnImgVar.src = "images/settingsIcon.png";
        settingBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.82;")
        settingButton[0][0].appendChild(settingBtnImgVar)
        
        var downloadBtnForHorizontalChart = optionsButtonPanelForHorizontalChart.append("div").attr("id","downloadBtnForHorizontalChart-ID-" + targetElement[0][0].id).style("width","20px").style("height","20px")
        .style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff").style('margin-left','2px').style('top', 107 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        
        acinfotech.downloadFunctionality("downloadBtnForHorizontalChart-ID-" + targetElement[0][0].id,targetElement)
        
        pieButtonForHorizontalChart.on('click', function() {
            options.showTable = false;
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            var newOptions = {
                   data: options.data,
                   dataForTable:options.dataForTable,
                   isDataDetailedForTable: options.isDataDetailedForTable,
                   keys: {
                       label: options.keys.label,
                       value: options.keys.value
                   },
                   chartTitle: options.chartTitle,
                   showTitle: options.showTitle,
                   showLegend: true,
                   legendSide: "right",
                   series:options.series,
                   legend:options.legend,
                   colorSet: options.colorSet,
                   BGcolor:options.BGcolor,
                   gradient: "none",
                   drillDownColumnName:options.drillDownColumnName,
                   showTable:options.showTable,
                   showComments: options.showComments,
                   comments: options.comments,
                   resizeButtonID: options.resizeButtonID
                }
                acinfotech.pieChart(targetElement, newOptions)

        })

        donutButtonForHorizontalChart.on('click', function() {
            options.showTable = false;
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            var newOptions = {
                   data: options.data,
                   dataForTable:options.dataForTable,
                   isDataDetailedForTable: options.isDataDetailedForTable,
                   keys: {
                       label: options.keys.label,
                       value: options.keys.value
                   },
                   chartTitle: options.chartTitle,
                   showTitle: options.showTitle,
                   showLegend: true,
                   legendSide: "right",
                   series:options.series,
                   legend:options.legend,
                   colorSet: options.colorSet,
                   BGcolor:options.BGcolor,
                   gradient: "none",
                   drillDownColumnName:options.drillDownColumnName,
                   showTable: options.showTable,
                   showComments: options.showComments,
                   comments: options.comments,
                   resizeButtonID: options.resizeButtonID
                }
                acinfotech.donutChart(targetElement, newOptions)
        })

        columnButtonForHorizontalChart.on('click', function() {
            options.showTable = false;
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
           var newOptions = {
                   data: options.data,
                   dataForTable:options.dataForTable,
                   isDataDetailedForTable: options.isDataDetailedForTable,
                   keys: {
                       label: options.keys.label,
                       value: options.keys.value
                   },
                   chartTitle:options.chartTitle,
                   xAxisLable:options.keys.label,
                   yAxisLable:options.keys.value,
                   showTitle:options.showTitle,
                   colorSet: options.colorSet,
                   BGcolor:options.BGcolor,
                   series:options.series,
                   legend:options.legend,
                   drillDownColumnName:options.drillDownColumnName,
                   showTable:options.showTable,
                   showComments: options.showComments,
                   comments: options.comments,
                   resizeButtonID: options.resizeButtonID
               }
            acinfotech.columnChart(targetElement, newOptions)
        })

        refreshButtonForHorizontalChart.on('click', function() {

            isFilterClickedForHorizontalChart = false
            //options.data = columnChartOptionsDataArray; 
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){
                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                }
            }
            acinfotech.horizontalChart(targetElement,options)

        })

        // showing/hidding chart comment panel
        commentsBtnForHoriChart.on('click', function() {

            if(options.showComments == false){ 
                options.showComments = true;
            }
            else if(options.showComments == true){ 
                options.showComments = false;
            }

            isFilterClickedForHorizontalChart = false; 
            
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){
                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                    options.showTable = false;
                }
            }
            acinfotech.horizontalChart(targetElement,options)

        })

        tableButtonForHoriChart.on('click', function() {
            
            if(options.showTable == false){
                options.showTable = true;
            }
            else if(options.showTable == true){
                options.showTable = false;
            }

            isFilterClickedForHorizontalChart = false
            
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){
                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                    options.showComments = false;
                }
            }
            acinfotech.horizontalChart(targetElement,options)

        })

        filterButtonForHorizontalChart.on('click', function() {

            ismenuButtonOfHorizontalChartClicked = false
            optionsButtonPanelForHorizontalChart.style("display","none")

            isFilterClickedForColumnChart = false
            
                $(function() { 
                    
                    $( '#' + targetElement[0][0].id + "horizontalChartRangeSliderID" ).slider({
                        orientation: "horizontal",
                        min: 0,//d3.min(minAndMaxValuesArrayForColumnChart),
                        max: d3.max(minAndMaxValuesArrayForHorizontalChart),
                        step: 1,
                        values: [low,hig],
                        animate: true,
                        range : true,
                        slide: function(event, ui) {
                            filterRangeValueOneForHorizontalChart = 0;
                            filterRangeValueTwoForHorizontalChart = 0;
                            textBoxOneForHorizontalChart.attr("value",ui.values[0])
                            textBoxTwoForHorizontalChart.attr("value",ui.values[1])
                            filterRangeValueOneForHorizontalChart = ui.values[0];
                            filterRangeValueTwoForHorizontalChart = ui.values[1];

                            $('#' + targetElement[0][0].id + "horizontalChartRangeSliderID").slider().find(".ui-slider-range").css({
                            'background': '#001c3b'});
                        },
                    });
                });

                //searchDivForHorizontalChart.style("display","block")
                resetTableWidthOldDataFunction()

                iconButtonTooltip.style("display","none")
                filterButtonForHorizontalChart.style("cursor","pointer")
                //disabledDivForHorizontalChart.style("display","block")
                
                searchDivForHorizontalChart.style("display","block")
                settingPanelDivForHorizontalChart.style("display","none")

                //svgPanelForHoriChart.style('width', 100 + "%") .style('height', 52 + "%").style("position","absolute")

                if(options.showTitle == true){
            
                    svgPanelForHoriChart.style('width', 100 + "%") .style('height', 52 + "%")  .attr("top",8 + "%") .style("position","absolute").style("background-color", options.BGcolor); 

                }
                else if(options.showTitle == false){
           
                    svgPanelForHoriChart.style('width', 100 + "%") .style('height', 52 + "%") .attr("top",0 + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }

                resizedFuctionForHorizontalChart();
                
                if(options.showTitle == false){
                    //searchDivForHorizontalChart.style('top', 0.0 + "%").style('height', 60.0 + "%")
                }
                else if(options.showTitle == true){
                    //searchDivForHorizontalChart.style('top', 8.0 + "%").style('height', 52.0 + "%")
                }
                //searchDivForHorizontalChart.style("border-right", "solid #c1e2b3  1px").style("overflow-y","scroll")

           // }
            
        }) //filterChartButton.on('click', function() )
    
        // Creating DIV for holding Search Table (Temporary Table) when Search button is clicked.
        var tempDivTableForHorizontalChart;
        var isSearchInTableButtonClicked = false;

        var canBtnForSearchDivForSearchTableForHorizontalChart

        // Creating left panel for holding Search Box and small Column Chart and on RHS Search Table (Temporary Table) when Search button is clicked.
        searchChartButton.on('click', function() {
            
            ismenuButtonOfHorizontalChartClicked = false
            optionsButtonPanelForHorizontalChart.style("display","none")

            isSearchInTableButtonClicked = true;

            // Div for disabling whole Chart and Main Table expect Search panel and Search Table
            var disabledDivForHorizontalChartForSearchTable = targetElement.append('div').style('width',100 + "%").style('height',100 + "%").style('position','absolute')
            .style("background-color",'#f3f3f3').style("z-index",2).style("display","none").style('top', 0.0 + "%").style('left', 0.0 + "%")
            .style("opacity",0.3).style("min-width","350px").style("min-height","350px") //005ec4

            //Creaing left panel for holding Search Box and small Column Chart
            var searchDivForHorizontalChartForSearchTable = targetElement.append('div').style('width',100 + "%").attr("class", "searchDivForHorizontalChartForSearchTableClass" + targetElement[0][0].id)
            .style('position','absolute').style('margin-left', "0px")//.style('top', parseFloat(chartTitlePanelForPieChart.style("height")) + 40 + 'px')
            .style("background-color",'#ffffff').style("z-index",90).style("border-color", "#ffffff")
            .style("display","block").style('top', 60.0 + "%").style('height', 40.0 + "%")
            .style("border-top","1px solid #f0f0f0")

            // Title for Search panel
            var searchDivForHorizontalChartForSearchTableTitle = searchDivForHorizontalChartForSearchTable.append('div')/*.text("Search by " + options.keys.value)*/.style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif").style("font-weight", "Bold")
            .style('margin-left','0px').style('margin-top','20px').style('text-indent','3px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
            .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000").style("font-family","Verdana,sans-serif").style("font-weight","Bold").style("display","none")
            .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter;  color:#202f34; font-weight:Bold;">'+ "Search" +'</div>')

            // DIV for holding small Column-Chart
            var smallChartAreaDivForHorizontalChart = searchDivForHorizontalChartForSearchTable.append('div').style('width',100 + "%").style('height',100 + "%").style('position','absolute')
            .style("background-color",'#ffffff').style("z-index",2).style("display","block").style('top', 0.0 + "px").style('left', 0.0 + "px")
            .style("opacity",1.0).attr("id","smallColumnChartIDForHorizontalChart" + targetElement[0][0].id)

            // DIV for holding Search Table
            tempDivTableForHorizontalChart =  targetElement.append('div').style('width',100 + "%").style('height', 60.0 + "%").style('top', 0.0 + "%")
            .style('position','absolute').style('margin-left', "0px")
            .style("background-color",'#ffffff').style("z-index",90).style("border-color", "#ffffff")
            .style("display","block")

            // Title DIV for Search Table
            var searchResultTableDivTitleForHorizontalChart = tempDivTableForHorizontalChart.append('div').style('background-color',"#e9e9e9").attr("fant-family", "Verdana,sans-serif").style("font-weight", "Bold")
            .style('margin-left','0px').style('margin-top','0px').style('text-indent','3px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
            .style("width","100"+"%").style("height","15" + "%").style("color","#000000")
            //.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:14px; font-family:inter;  color:#ffffff; font-weight:Bold;">'+ "Search Result" +'</div>')

            // Search Text Box for Search panel
            var searchTextBoxForHorizontalChart = searchResultTableDivTitleForHorizontalChart.append('input').style("width","220px").style('margin-left','1px').style('margin-top','2px')
            .style('position',"absolute").style('height',"26px").style("border", "1.0px") .style("border-color", "#e8e8e8") .style("border-style", "solid").style('text-indent','30px')
            .attr("placeholder","eg: sales").attr("id","autoSearchTextBoxForHorizontalChart" + targetElement[0][0].id)
            .style("background-image","url('images/searchChart.png')").style("background-repeat","no-repeat")//.style("background-position","right")
            .style("background-size",'18px 18px').style("background-position",'5px 3px').style("display","block")
            .style("font-size","14px").style("font-weight","Normal").style("line-height","Normal").style("box-sizing","border-box")
            .style('outline-width','0px')//.style('outline-color',"#a6a6a6")

            
            canBtnForSearchDivForSearchTableForHorizontalChart = searchResultTableDivTitleForHorizontalChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
            .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
            .style('background-color',"#e9e9e9")
            .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
            .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
            var cancelBtnImgVar = document.createElement("IMG");
            cancelBtnImgVar.src = "images/closeIcon.png";
            cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.88; background-color:#e9e9e9")
            canBtnForSearchDivForSearchTableForHorizontalChart[0][0].appendChild(cancelBtnImgVar)

            // Enabling whole Chart and Table and removing Search panel and Search Table, when Cancel button of Search panel is called.
            canBtnForSearchDivForSearchTableForHorizontalChart.on('click', function() {

                //disabledDivForHorizontalChartForSearchTable.remove();
                searchDivForHorizontalChartForSearchTable.remove();
                tempDivTableForHorizontalChart.remove();

                d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
                for(var i = 0; i<divAndChartsArray.length; i++){
                    if(targetElement[0][0].id === divAndChartsArray[i].divID){
                        options.data = divAndChartsArray[i].optionsData
                    }
                }
                acinfotech.horizontalChart(targetElement,options)

            })

            // DIV for holing only Search Table
            var searchResultTablePanelForHorizontalChart =  tempDivTableForHorizontalChart.append("div")
            .attr("class", "searchResultTablePanelForHorizontalChart" + targetElement[0][0].id)
            .style('background-color',"#ffffff") .style('position','absolute') .style("display","block") .style("overflow","auto")
            .style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 85 + "%"; }) .style("left",0 + "%")
            .style("top","15"+"%")
            
            // Creating Table (Search Table)
            searchResultTablePanelForHorizontalChart.html('<table  border="0px" style=" width:99.9%; height:auto;   position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9px; border-collapse:collapse; border-color:#ebf5e6; " >'+
              '<thead  style="background-color:#DFF0D8;">' +'</thead>'+
              '<tbody class="myTBody" style="background-color:white; width:99.9%; height:auto;  ">'+'</tbody>'+
              '</table>'
              )
            searchResultTablePanelForHorizontalChart.select("table").attr("id","searchTableIdForHorizontalChart" + targetElement[0][0].id)

            // Setting colors for Search Column-bars
            var colors = d3.scale.ordinal() .range(["#ff6c3e", "#ffbb03", "#3fcb56", "#d05767", "#55bf9b", "#0095b3", "#7a92a9","#663399","#29b5eb","#ff9878","#CCCCCC","#008d8d"]);

            var thead = searchResultTablePanelForHorizontalChart.select("thead").selectAll("th") .data(d3.keys(newJson[0]))
            .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1) + " "}).style("min-width","100px").style("color","#00001c")
        
            var tr = searchResultTablePanelForHorizontalChart.select("tbody").selectAll("tr") .data(newJson).enter().append("tr") //.style("background-color",function(d,i){  return colors(i);})
        
            var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d})
            .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")

            // Filtering the Search Table 
            $(document).ready(function(){
                var tblBodyObj = document.getElementById("searchTableIdForHorizontalChart" + targetElement[0][0].id).tBodies[0];
                
                for (var i=0; i<tblBodyObj.rows.length; i++) {

                    var newCell = tblBodyObj.rows[i].insertCell(-1);
                    newCell.style.minWidth = "20px";
                    newCell.style.maxWidth = "20px";
                    newCell.style.textAlign = "left"
                   
                    var div = document.createElement('div')
                    div.style.width = "15px";
                    div.style.height = "35%";
                    div.style.borderRadius = "0px";
                    div.style.opacity = 0.9;
                    div.style.minWidth = "15px"
                    div.style.maxWidth = "15px"
                    div.style.background = colors(i);
                    newCell.appendChild(div);
                }   
            });

            // Styling the Search Table Rows.
            searchResultTablePanelForHorizontalChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
            .style("color","#00001c")
            .style("height","25px").style("border", "1px solid #e9e9ea").style("background-color","#f6f6f6")
            searchResultTablePanelForHorizontalChart.selectAll('td').style("height","25px") .style("border", "1px solid #f8f8f8") .style("font-size","12px").style("font-weight","Normal").style("color","#00001c")
        
            // Calling smallColumnChart with orignal data and limited options.
            var chartElement = d3.select("#smallColumnChartIDForHorizontalChart" + targetElement[0][0].id);
            var smallColumnChartoptions = {
                           data: options.data,
                           series:options.series,
                           legend:options.legend,
                           BGcolor:options.BGcolor,
                           keys: {
                               label: options.keys.label,
                               value: options.keys.value
                           },
                           xAxisLable: options.keys.label,
            }
            acinfotech.smallColumnChart(chartElement,smallColumnChartoptions)    

                // Array to hold searched items (full object)
                var searchTextBoxArrayForHorizontalChart = [];

                $(document).ready(function(){
                    $("#" + "autoSearchTextBoxForHorizontalChart" + targetElement[0][0].id).off('input');
                    $("#" + "autoSearchTextBoxForHorizontalChart" + targetElement[0][0].id).on('keyup', function(){
                        textChangedFunction(this.value)

                    });
                });
                 
                 // function to search data in original set of data with Search Box entered value.
                 function textChangedFunction (val) {
                    var textBoxValueLowerCased = val //this.value
                    searchTextBoxArrayForHorizontalChart = [];
        
                    newJson.forEach(function(d, i) { //--------------
                        var dd = d3.values(d);
                        var eachObjectArray = [];
                        eachObjectArray.push(d3.values(d))
                        d[options.keys.value] = d[options.keys.value].toString();
                
                    for(var i = 0; i<Object.keys(d).length; i++){
                        var lower = d3.values(d)[i].toString().toLowerCase()
                        if ( lower.toLowerCase().indexOf(textBoxValueLowerCased.toLowerCase()) > -1 ) {
                            searchTextBoxArrayForHorizontalChart.push(d)
                            break;
                        }
                    }
                });
                
                // clearing smallColumnChart DIV each time a keyboard key is hit.
                smallChartAreaDivForHorizontalChart.selectAll("*").remove();    
                var chartElement = d3.select("#smallColumnChartIDForHorizontalChart" + targetElement[0][0].id);
                var smallColumnChartoptions = {
                           data: searchTextBoxArrayForHorizontalChart,
                           series:options.series,
                           legend:options.legend,
                           BGcolor:options.BGcolor,
                           keys: {
                               label: options.keys.label,
                               value: options.keys.value
                           },
                           chartTitle:"Revenue by Region",
                           xAxisLable: options.keys.label,
                        }
                if(searchTextBoxArrayForHorizontalChart.length == 0){
                    smallChartAreaDivForHorizontalChart.selectAll("*").remove();     
                }
                else {
                    acinfotech.smallColumnChart(chartElement,smallColumnChartoptions)    
                }
            
            // Removing the Search Table Rows
            var table = searchResultTablePanelForHorizontalChart.select('table');
            var rows = table.selectAll('tr')
            rows.remove();

            // Creating new Rows for Search Table based on Searched Result (using searchTextBoxArrayForPieChart array)
            var table = searchResultTablePanelForHorizontalChart.select('table');
            var rows = table.selectAll('tr').data(searchTextBoxArrayForHorizontalChart);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})

            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition()
            .delay(20) .duration(20) .style('opacity', 1.0) .style("color","#00001c");
            
            cells.text(function(d,i) {return d});

            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(20) .duration(20) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})

            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(20)
            .duration(20) .style('opacity', 1.0) .style("color","#00001c");

            // Adding new row for color dots in Search Table
            $(document).ready(function(){
                
                for (var i=0; i<table[0][0].rows.length; i++) {

                    var newCell = table[0][0].rows[i].insertCell(-1);
                    newCell.style.minWidth = "20px";
                    newCell.style.maxWidth = "20px";
                    newCell.style.textAlign = "left"
                   
                    var div = document.createElement('div')
                    div.style.width = "15px";
                    div.style.height = "35%";
                    div.style.borderRadius = "0px";
                    div.style.opacity = 0.9;
                    div.style.minWidth = "15px"
                    div.style.maxWidth = "15px"
                    div.style.background = colors(i);
                    newCell.appendChild(div);
                }
            });

            var t = document.getElementById("searchTableIdForHorizontalChart" + targetElement[0][0].id).tBodies[0]
            
            cells_in_new_rows.text(function(d,i) {return d});

            rows.exit() .attr('class', 'exit') .transition() .delay(20) .duration(20) .style('opacity', 0.0) .remove();

            // Checking the Browser
            if(navigator.userAgent.indexOf("Firefox") != -1 ) 
            {
                table.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("text-align","left").style("padding-left","6px").style("color","#00001c")
                .style("height","25px") .style("border", "1px solid #b1da9f") 
            
                searchResultTablePanelForHorizontalChart.selectAll('td').style("height","25px") .style("border", "1px solid #ffffff") .style("font-size","12px").style("padding-left","6px")
                .style("font-weight","Normal").style("color","#00001c")
            }

            else{
                
                searchResultTablePanelForHorizontalChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("text-align","left").style("padding-left","6px").style("color","#00001c")
                .style("height","25px") .style("border", "1px solid #e9e9ea").style("background-color","#f6f6f6")  
            
                searchResultTablePanelForHorizontalChart.selectAll('td').style("height","25px") .style("border", "1px solid #f8f8f8") .style("font-size","12px").style("padding-left","6px")
                .style("font-weight","Normal").style("color","#00001c")
            }

        }//textChangeFunction ends here
            
            // Disabling Browser page scrolling when Search left panel appears
            $( '.searchDivForHorizontalChartForSearchTableClass' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
                var e0 = e.originalEvent,
                delta = e0.wheelDelta || -e0.detail;
    
                this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
                e.preventDefault();
            });

            // Disabling Browser page scrolling when Search Table appears
            $( '.searchResultTablePanelForHorizontalChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
                var e0 = e.originalEvent,
                delta = e0.wheelDelta || -e0.detail;
    
                this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
                e.preventDefault();
            });

            // Removing options button ToolTip, changing mouse pointer, disabling Chart and Main Table and expanding Search panel and Search Table. 
            iconButtonTooltip.style("display","none")
            searchChartButton.style("cursor","auto")
            
            searchDivForHorizontalChartForSearchTable.style("display","block")


        }) //searchChartButton.on('click', function()
        
        settingButton.on('click', function() {
                
                iconButtonTooltip.style("display","none") // Removing options button ToolTip
                settingButton.style("cursor","pointer") // Changing setting button mouse pointer
                
                ismenuButtonOfHorizontalChartClicked = false; // Menu toggle button variable
                optionsButtonPanelForHorizontalChart.style("display","none"); // Hiding option buttons panel

                settingPanelDivForHorizontalChart.style("display","block") // Showing setting panel 
                

                if ((showOrHideTableForHoriChart == false) && (showOrHideCommentsForHoriChart == true)){
                    
                    svgPanelForHoriChart.style('width', 100 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForHoriChart == true) && (showOrHideCommentsForHoriChart == false)){
                    
                    svgPanelForHoriChart.style('width', 100 + "%") .style('height', 52 + "%") .style("position","absolute").style("background-color", options.BGcolor);
                }
                else if ((showOrHideTableForHoriChart == false) && (showOrHideCommentsForHoriChart == false)){
                     
                    svgPanelForHoriChart.style('width', 100 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor); 
                }

                resizedFuctionForHorizontalChart();
                
        })
        
        downloadBtnForHorizontalChart.on('click', function() {
                                  
              ismenuButtonOfHorizontalChartClicked = false; // Changing menu button value to false
              optionsButtonPanelForHorizontalChart.style("display","none") // Hiding option buttons panel
              
              changeXAndYAxisValuesPanelForHoriChart.style("display","none") // Hiding edit X & Y axis panel
              
              iconButtonTooltip.style("display","none") // Hiding button tooltip
              filterButtonForHorizontalChart.style("cursor","pointer") // changing mouse pointer
              
              searchDivForHorizontalChart.style("display","none") // Showing filter panel
              settingPanelDivForHorizontalChart.style("display","none") //Hiding setting panel
                                  
        })
        
        // Showing change x-axis and y-axis panel
        editChartButton.on('click', function() {

            ismenuButtonOfHorizontalChartClicked = false
            optionsButtonPanelForHorizontalChart.style("display","none")

            changeXAndYAxisValuesPanelForHoriChart.style("display","block")
        })
        
        // Creating tool tip for option buttons 
        var iconButtonTooltip = targetElement.append('div').style('width','240px').attr("id","too").style("z-index",999)
        .style('height',"25px").style('position','absolute')//.style('margin-left', "0px").style('top','25px')
        .style("background-color",'#404040 ').style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid") // 004b9d
        .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none").attr("border", 0.0)

        pieButtonForHorizontalChart.on('mousemove', function(d,i) {
             var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var columnChartButtonTooltipText = "Switch to Pie Chart";
            
            iconButtonTooltip.style("width","127px").style("margin-left", (m[0] - 137) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ columnChartButtonTooltipText +'</div>')
        })
        pieButtonForHorizontalChart.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        donutButtonForHorizontalChart.on('mousemove', function(d,i) {
             var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var doNutChartButtonTooltipText = "Switch to Donut Chart";
            
            iconButtonTooltip.style("width","142px").style("margin-left", (m[0] - 152) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ doNutChartButtonTooltipText +'</div>')
        })
        donutButtonForHorizontalChart.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        columnButtonForHorizontalChart.on('mousemove', function(d,i) {
             var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var horizontalChartButtonTooltipText = "Switch to Column Chart";
            
            iconButtonTooltip.style("width","162px").style("margin-left", (m[0] - 172) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ horizontalChartButtonTooltipText +'</div>')
        })
        columnButtonForHorizontalChart.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        refreshButtonForHorizontalChart.on('mousemove', function(d,i) {
             var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var refreshButtonTooltipText = "Refresh";
            
            iconButtonTooltip.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ refreshButtonTooltipText +'</div>')
        })
        refreshButtonForHorizontalChart.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        filterButtonForHorizontalChart.on('mousemove', function(d,i) {
             var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var filterButtonTooltipText = "Filter";
            
            iconButtonTooltip.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')
        })
        filterButtonForHorizontalChart.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        searchChartButton.on('mousemove', function(d,i) {
             var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var reloadButtonTooltipText = "Search";
            
            iconButtonTooltip.style("width","60px").style("margin-left", (m[0] - 70) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ reloadButtonTooltipText +'</div>')
        })
        searchChartButton.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        editChartButton.on('mousemove', function(d,i) {
             var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var editButtonTooltipText = "Change X-Axis and Y-Axis";
            
            iconButtonTooltip.style("width","160px").style("margin-left", (m[0] - 170) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ editButtonTooltipText +'</div>')
        })
        editChartButton.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        tableButtonForHoriChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            if(showOrHideTableForHoriChart == false){
                var tableButtonTooltipText = "Show Table";
            }
            else if(showOrHideTableForHoriChart == true){
                var tableButtonTooltipText = "Hide Table";
            }
            
            iconButtonTooltip.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ tableButtonTooltipText +'</div>')
        })
        tableButtonForHoriChart.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

        settingButton.on('mousemove', function(d,i) {
             var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var reloadButtonTooltipText = "Settings";
            
            iconButtonTooltip.style("width","67px").style("margin-left", (m[0] - 77) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ reloadButtonTooltipText +'</div>')
        })
        settingButton.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })
        downloadBtnForHorizontalChart.on('mousemove', function(d,i) {
              var root = targetElement
              var m = d3.mouse(root.node());
              m[0] += 0
              m[1] += 0
              var downloadButtonTooltipText = "Download";
              
              iconButtonTooltip.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
              iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
        })
        downloadBtnForHorizontalChart.on('mouseout', function(d,i) {
              iconButtonTooltip.style("display","none")
        })
        commentsBtnForHoriChart.on('mousemove', function(d,i) {
            commentsPanelDivForHoriChart.style('background-color','#fafafa')
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                if(options.showComments == false){
                    var commentButtonTooltipText = "Show Comments";
                }
                else if(options.showComments == true){
                    var commentButtonTooltipText = "Hide Comments";
                }
            
            
            iconButtonTooltip.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ commentButtonTooltipText +'</div>')
        })
        commentsBtnForHoriChart.on('mouseout', function(d,i) {
            commentsPanelDivForHoriChart.style('background-color','#ffffff')
            iconButtonTooltip.style("display","none")
        })

        menuButtonForHorizontalChart.on('mousemove', function(d,i) {
             var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var reloadButtonTooltipText = "Menu";
            
            iconButtonTooltip.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ reloadButtonTooltipText +'</div>')
        })
        menuButtonForHorizontalChart.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })


        // ----------------- Changing X-Axis and Y-Axis values panel and everything within it section begins here ----------------
        var changeXAndYAxisValuesPanelForHoriChart = targetElement.append('div').style('width',350 + "px") .attr("id","changeXAndYAxisValuesPanelForHoriChartClass" + targetElement[0][0].id)
        .style('height',52 + "%").style('position','absolute').style('margin-left', "0px")
        .style("background-color",'#fefefe').style("z-index",11).style("border-color", "#ffffff").style("border-right", "solid #e5e5e5 1px")  .style("border-style", "solid") // 004b9d
        .style("box-shadow", "0px 0px 0px #eff8ec").style("display","none").style("border-top", "solid #fdfdfd 1px").style("border-left","0px").style("border-bottom", "0px")
        .style('top', 0.0 + "%").style('height', 100.0 + "%").style('overflow-y',"scroll").style("overflow-x","hidden").style('box-sizing','border-box')

        var changeXAndYAxisValuesPanelForHoriChartTitle = changeXAndYAxisValuesPanelForHoriChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','20px').style('text-indent','5px').style("font-size", "14px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #007aff").style("width","350px").style("color","#000000")
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; top:25.0%; font-size:14px; font-family:inter; color:#00001c;">'+ "Change X-Axis and Y-Axis" +'</div>')

        var measuresColumnTitle = changeXAndYAxisValuesPanelForHoriChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter;  color:#00001c; font-weight:Normal; text-align:left; text-indent:3px;">Available Measures</div>');

        var dimensionColumnTitle = changeXAndYAxisValuesPanelForHoriChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '203px')
        .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter;  color:#00001c; font-weight:Normal; text-align:left; text-indent:3px;">Available Dimensions</div>');

        var measuresVariables = changeXAndYAxisValuesPanelForHoriChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable1"+targetElement[0][0].id)
        .style("list-style-type","none")
        .style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '78px')
        .style('position','absolute')
        .style("width","155px").style("min-height","100px").style("max-height","100px").style("border", "#f0f0f0 1px solid")
        .style("max-width","155px").style("overflow-x","hidden").style("overflow-y","auto")
        measuresVariables.style("left",0.0 + "px").style("padding","2px")

        var dimesionsColumnsPanel = changeXAndYAxisValuesPanelForHoriChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable2"+targetElement[0][0].id)
        .style("list-style-type","none").style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '220px')
        .style('position','absolute').style("width","155px").style("min-height","100px").style("max-height","100px").style("border", "#f0f0f0 1px solid")
        .style("max-width","155px").style("overflow-x","hidden").style("overflow-y","auto")
        dimesionsColumnsPanel.style("left",0.0 + "px").style("padding","2px")

        $( "#changeXAndYAxisValuesPanelForHoriChartClass" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });


        var measuresArray = [];
        var dimensionArray = [];

        var measuresArrayLength = [];
        var dimensionsArrayLength = [];

        $.each(options.data,function(i,v){

        var object={};
            $.each(v,function(i1,val1){
                if((($.isNumeric(val1))) || (val1 == null) ){
                    object[i1]=val1
                    measuresArray.push(i1);
                }
                else {
                     //if (!/[^a-z _A-Z]/.test(val1)){
                        dimensionArray.push(i1);
                    //}
                }
            });
        });
        
        var uniqueMeasuresArrayKeys = [];
        $.each(measuresArray, function(i, el){
            if($.inArray(el, uniqueMeasuresArrayKeys) === -1){
                uniqueMeasuresArrayKeys.push(el);
            }
        });

        var uniqueDimensionArrayKeys = [];
        $.each(dimensionArray, function(i, el){
            if($.inArray(el, uniqueDimensionArrayKeys) === -1){
                uniqueDimensionArrayKeys.push(el);
            }
        });
        
        // setting lenght for arrays
        for(var i = 0; i<uniqueMeasuresArrayKeys.length; i++){
            measuresArrayLength.push(i);
        }

        for(var i = 0; i<uniqueDimensionArrayKeys.length; i++){
            dimensionsArrayLength.push(i);
        }

        var measuresVariables1 = measuresVariables.selectAll("li") 
        .data(measuresArrayLength)
        .enter()
        .append("li")
        .style("width","130px") .style("max-height","22px").style("cursor","move")
        .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#bcf1bc").style("font-weight","Normal")
        .style("list-style-type","none").style("border","1px #89e789 solid").style("color","#006600").style("font-family","Verdana,sans-serif")
        .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
        .text(function(d) {return uniqueMeasuresArrayKeys[d]})
        measuresVariables1.attr("class","MeasuresClass"+targetElement[0][0].id)
        
        var dimesionsColumns = dimesionsColumnsPanel.selectAll("li") 
        .data(dimensionsArrayLength)
        .enter()
        .append("li")
        .style("width","130px") .style("max-height","22px").style("cursor","move")
        .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#f8e9cd").style("font-weight","Normal")
        .style("list-style-type","none").style("border","1px #f2d199 solid").style("color","#9e6c14").style("font-family","Verdana,sans-serif")
        .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
        .text(function(d) {return uniqueDimensionArrayKeys[d]})
        dimesionsColumns.attr("class","DimesionsClass"+targetElement[0][0].id)

        var measuresColumnReceivedUI_TableTitle = changeXAndYAxisValuesPanelForHoriChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','170px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter;  color:#00001c; font-weight:Normal; text-align:left; ">Selected Measure</div>');

        var measuresColumnReceivedUI_Table = changeXAndYAxisValuesPanelForHoriChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable3"+targetElement[0][0].id)
        .style('background-color',"#ffffff").style('margin-left','170px').style('margin-top', '78px')
        .style("width","155px").style('position','absolute').style("padding","2px").style("min-height","100px")
        .style("border","1px #c1c1c1 dashed") .style("max-height","60px") .style("overflow-x","hidden") .style("overflow-y","auto")
        //.html('<div class=unsortable  style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:65.0%; font-size:14px; font-family:inter;  color:#99ea99; font-weight:Normal; text-align:center;">Drag and Drop Measures here from Available Measures List. </div>');
        .html('<img class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' src="images/dragIcon.png" style=" width:36px; height:36px; position:absolute; margin-left:65px; margin-top:15px; opacity:0.6"/>' 
        + '<div class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:65.0%; font-size:12px; font-family:inter;  color:#89d289; font-weight:Normal; text-align:center;">Drop Measure for Y-Axis. </div>');
        //.html('<div style="background-image: url(images/dragIcon.png); height: 64px; width: 64px; border: 1px solid black;"> </div>');

        var dimensionColumnReceivedUI_TableTitle = changeXAndYAxisValuesPanelForHoriChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','170px').style('margin-top', '203px')
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter;  color:#00001c; font-weight:Normal; text-align:left; ">Selected Dimension</div>');

        var dimensionColumnReceivedUI_Table = changeXAndYAxisValuesPanelForHoriChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable4"+targetElement[0][0].id)
        .style('background-color',"#ffffff").style('margin-left','170px').style('margin-top', '220px')//.style("list-style-type","none")
        .style("width","155px").style("max-width","300px").style('position','absolute').style("padding","2px").style("min-height","100px")
        .style("border","1px #c1c1c1 dashed") .style("max-height","60px") .style("overflow-x","hidden") .style("overflow-y","auto")
        .html('<img class=unMoveableIconAndTextClassDimensions'+targetElement[0][0].id+' src="images/dragIcon.png" style=" width:36px; height:36px; position:absolute; margin-left:65px; margin-top:15px; opacity:0.6;"/>' 
        + '<div class=unMoveableIconAndTextClassDimensions'+targetElement[0][0].id+' style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:65.0%; font-size:12px; font-family:inter;  color:#d8b479; font-weight:Normal; text-align:center;">Drop Dimension for X-Axis. </div>');

        var cancelButtonOfReRenderChanrtPanelForHoriChart = changeXAndYAxisValuesPanelForHoriChart.append("div") .style("width","22px").style("height","21px").style('position','absolute')
        .style('margin-left','308px').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
        .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.90; background-color:#fcfcff")
        cancelButtonOfReRenderChanrtPanelForHoriChart[0][0].appendChild(cancelBtnImgVar)

        cancelButtonOfReRenderChanrtPanelForHoriChart.on("click", function(){
            changeXAndYAxisValuesPanelForHoriChart.style("display","none")
        })

        var reRenderChartAndTableButtonForHoriChart = changeXAndYAxisValuesPanelForHoriChart.append("button").style("width","120px").style("height","25px").style('position','absolute')
        .style('margin-left','105px').style('margin-top','350px') .style("border-style", "none").style('background-color',"#2196f3")
        .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','15px').style("border-style", "solid").style('color','#ffffff')
        .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 1px #9b9b9b").style("border-radius","0px")
        var textForReRenderButton = document.createTextNode("Apply Changes");
        reRenderChartAndTableButtonForHoriChart[0][0].appendChild(textForReRenderButton)

        reRenderChartAndTableButtonForHoriChart.on("click", function(){
            
            if(
                ( $("#sortable3"+targetElement[0][0].id).children("li").length == 0) || 
                ( $("#sortable4"+targetElement[0][0].id).children("li").length == 0) || 
                ( 
                  ($("#sortable3"+targetElement[0][0].id).children("li").length == 0) && 
                  ($("#sortable4"+targetElement[0][0].id).children("li").length == 0) 
                )
            ){

                var alertPageDisabledDivForHoriChart =targetElement.append('div').style('width',100 + '%')
                .style('height',100 + "%").style('position','absolute').style('margin-left', '0px').style('top', '0px')
                .style("background-color",'#f3f3f3').style("z-index",99)//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("opacity",0.2).style("display","block")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")

                var alertDivForHoriChart = targetElement.append('div').style('width','350px')
                .style('height',"150px").style('position','absolute').style('left', ((targetElement[0][0].clientWidth/2) - 175) + "px").style('top', '1px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "solid").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","0px")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
                //.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Bold;">Sorry, no result found for selected' + 'range!'+ '</br>' + '<label style=text-indent:10px;> Hello</label' +'</div>')
                .html('<p  style="width: 340px; height:0%; background-color:#c7c7c7; position: absolute; top:40.0%; font-size:14px; font-family:inter; font-weight:Bold; margin-left:10px;  color:#f8f8f8; font-weight:Normal;">Check whether the Selected Measure or Selected Dimension box is not empty!</p>')

                var alertDivTitleForHoriChart = alertDivForHoriChart.append('div').style('width','340px')
                .style('height',"30px").style('position','absolute').style('margin-left', "0px").style('top', '0px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "none").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","2px")
                .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; font-weight:Bold; text-indent:5px;  color:#e5e5e5; font-weight:Normal;">TimeBound</div>')

                var horiChartAlertOKButton = alertDivForHoriChart.append("button") .style("width","40px") .style("height","20px") .style('position','absolute') .style("box-shadow", "0px 1px 1px #B8B8B8") 
                .style('background-color',"#7cc15e") .style('margin-left','300px') .style('top', "120px").style("color","#ffffff")
                .style("display","block").style('padding-top',"0px").style("cursor","pointer").style("box-shadow", "1px 1px 1px #56973a") .style("border-style", "none")
                .style("font-family","Verdana,sans-serif").style("font-size","14px").style("text-align","center").style("vertical-align","middle").style("border-radius","0px")
                .style("z-index",999)
            
                var textForHoriChartAlertOKButton = document.createTextNode("OK");
                horiChartAlertOKButton[0][0].appendChild(textForHoriChartAlertOKButton)

                $("#"+targetElement[0][0].id).resizable('disable');

                horiChartAlertOKButton.on('click', function() {
                    alertDivForHoriChart.remove();
                    alertPageDisabledDivForHoriChart.remove()
                    $("#"+targetElement[0][0].id).resizable('enable');
                })

                filterButtonForHorizontalChart.style("cursor","pointer")
                //disabledDivForHoriChart.style("display","none")
                searchDivForHorizontalChart.style("display","none")//.transition().style('width', 0 + "px").duration(200).delay(50)
            
                if(showOrHideTableForHoriChart == false){ 
                    svgPanelForHoriChart.attr('width', 100 + "%") .attr('height', 85 + "%").style("position","absolute")
                }   
                else if(showOrHideTableForHoriChart == true){ 
                    svgPanelForHoriChart.attr('width', 100 + "%") .attr('height', 52 + "%").style("position","absolute")
                } 

                resizedFuctionForHorizontalChart();
            }
            else{

                var newOptions = {
                   data: options.data,
                   dataForTable: options.dataForTable,
                   isDataDetailedForTable: options.isDataDetailedForTable,
                   keys: {
                       label: $("#sortable4"+targetElement[0][0].id).children("li")[0].textContent.toString(),
                       value: $("#sortable3"+targetElement[0][0].id).children("li")[0].textContent.toString()
                   },
                   chartTitle:options.chartTitle,
                   xAxisLable: $("#sortable3"+targetElement[0][0].id).children("li")[0].textContent,
                   yAxisLable: $("#sortable4"+targetElement[0][0].id).children("li")[0].textContent,
                   showTitle: true,
                   colorSet: options.colorSet,
                   series:options.series,
                   legend:options.legend,
                   drillDownColumnName:options.drillDownColumnName,
                   showTable: options.showTable,
                   showComments: options.showComments,
                   comments: options.comments,
                   resizeButtonID: options.resizeButtonID //document.getElementById("resizeBtn").id
                }
                        
                d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                acinfotech.horizontalChart(targetElement,newOptions)
            }
        })

        var textBoxForMeasureColumnFrom;
        var textBoxForMeasureColumnTo;
        var selectTitleDivForEachDimension;

       
        $( "ul.droptrue"+targetElement[0][0].id ).sortable({
            //connectWith: "ul",
            appendTo: document.body,
            helper: "clone",
            connectWith: ".droptrue"+targetElement[0][0].id,
            //containment: ".ui-splitselect",
            scroll: false,
            //items: "div:not(.unsortable)",
            //cancel: ".unMoveableIconAndTextClassMeasures, .unMoveableIconAndTextClassDimensions",
            cancel: '.unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+','+' .unMoveableIconAndTextClassDimensions'+targetElement[0][0].id,
            //revert: true,
           // revert: 'invalid', 
            revertDuration: 10,
            scrollSensitivity: 10,
            scrollSpeed: 1,
            dynamic: true,

            receive: function(e, ui) { 
                 
                if (($(this)[0].id == "sortable3"+targetElement[0][0].id) || ($(this)[0].id == "sortable1"+targetElement[0][0].id)) {

                        if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                            //ui.sender.sortable("cancel");

                            if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                                 (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                            }
                            else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                                (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                            }

                        }
                } // if (($(this)[0].id == "sortable3") || ($(this)[0].id == "sortable1")) 

                else if (($(this)[0].id == "sortable2"+targetElement[0][0].id) || ($(this)[0].id == "sortable4"+targetElement[0][0].id)) {
                    if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                            //ui.sender.sortable("cancel");

                            if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                                 (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                            }
                            else if(  ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                                (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                            }
                        }
                } //if (($(this)[0].id == "sortable2") || ($(this)[0].id == "sortable4")) {
                
                $(ui.item).css({ 'position': 'relative' });

                if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                    
                    ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                }
                 
                else if ($(this)[0].id == "sortable3"+targetElement[0][0].id) { // checking if the dropped element is in Measures drop area
                    

                    if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                        ui.sender.sortable("cancel");
                    }
                    else {
                        ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                      

                    }

                } // else if ($(this)[0].id == "sortable3") // checking if the dropped element is in Measures drop area ends here.

                else if ($(this)[0].id == "sortable4"+targetElement[0][0].id) { // checking if the dropped element is in Dimension drop area

                    if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                        ui.sender.sortable("cancel");
                    }
                    else {
                            ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                           
                    }
                } //else if ($(this)[0].id == "sortable4")  // checking if the dropped element is in Dimension drop area ends here

                    if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                        
                    if ($(this)[0].id == "sortable1"+targetElement[0][0].id){
                        if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                            
                            if( ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                                ui.sender.sortable("cancel");

                               
                            } // if(  ui.sender.attr("id") === "sortable4")

                            else if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                                ui.sender.sortable("cancel");
                            }
                            
                        } // if(ui.item.hasClass("DimesionsClass"))
                    }
                    if ($(this)[0].id == "sortable2"+targetElement[0][0].id){
                        if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                            //sui.sender.sortable("cancel");

                            if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                                ui.sender.sortable("cancel");
                            }
                            else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                                ui.sender.sortable("cancel");
                               
                            }

                        }
                    }

                } //if ($(this)[0].id == "sortable1")

                if ( ($(this)[0].id == "sortable3"+targetElement[0][0].id) || ($(this)[0].id == "sortable4"+targetElement[0][0].id) ){
                    if ($(this).children('li').length > 1 ){
                   
                   ui.sender.sortable("cancel");
                   ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                }    
                }
                

            }, //receive ends here

            start:function(ev, ui) {
                
            },
            stop:function(ev, ui) {
               
            },
           
        });
      

        /* ----------------- Changing X-Axis and Y-Axis values panel and everything within it section ends here -----------------*/

        // Creating Filter panel 
        var disabledDivForHorizontalChart = targetElement.append('div').style('width',targetElement[0][0].clientWidth + "px").style('height',targetElement[0][0].clientHeight + "px").style('position','absolute')
        .style("background-color",'#f3f3f3').style("z-index",2).style("display","none").style('top', 0.0 + "%").style('left', 0.0 + "%")
        .style("opacity",0.1).style("min-width","350px").style("min-height","350px") //005ec4

        var searchDivForHorizontalChart = targetElement.append('div').style('width',"100%").style('height',"40%")
        .style('position','absolute').style('margin-left', "0px").style('border-top',"1px solid #f0f0f0").style('border-bottom',"1px solid #e5e5e5")
        .style("background-color",'#fcfcff').style("z-index",90) //001c3b
        .style("display","none").style("overflow-x","auto").style("overflow-y","hidden")
        .style('top',"60%").style('height',"40%")

        $( '.filterDivForHorizontalChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        var searchDivForHorizontalChartTitle = searchDivForHorizontalChart.append('div').style('background-color',"#ffffff").attr("font-family", "Verdana,sans-serif")
        .style('margin-left','10px').style('margin-top','10px').style('text-indent','5px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","90%").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:15.5%; font-size:14px; font-family:inter; color:#00001c;">'+ "Filter by " + options.keys.value +'</div>')

        var sliderBarForHorizontalChart = searchDivForHorizontalChart.append('div').style('background-color',"#ffffff")
        .attr("id",targetElement[0][0].id + "horizontalChartRangeSliderID").style("width","215px").style('margin-top','87px').style('margin-left','39px').style('position',"absolute")

		
        var cancelButton = searchDivForHorizontalChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
        .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
        .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.90; background-color:#fcfcff")
        cancelButton[0][0].appendChild(cancelBtnImgVar)

        cancelButton.on('click', function() {
            searchDivForHorizontalChart.style("display","none")

            if(options.showTitle == true){
            
                if ((showOrHideTableForHoriChart == false) && (showOrHideCommentsForHoriChart == true)){
                    
                    svgPanelForHoriChart.style('width', 100 + "%") .style('height', 70 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForHoriChart == true) && (showOrHideCommentsForHoriChart == false)){
                    
                    svgPanelForHoriChart.style('width', 100 + "%") .style('height', 52 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor);
                }
                else if ((showOrHideTableForHoriChart == false) && (showOrHideCommentsForHoriChart == false)){
                     
                    svgPanelForHoriChart.style('width', 100 + "%") .style('height', 85 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }

            }
            else if(options.showTitle == false){
           
             if ((showOrHideTableForHoriChart == false) && (showOrHideCommentsForHoriChart == true)){
                    
                    svgPanelForHoriChart.style('width', 100 + "%") .style('height', 70 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForHoriChart == true) && (showOrHideCommentsForHoriChart == false)){
                    
                    svgPanelForHoriChart.style('width', 100 + "%") .style('height', 52 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTableForHoriChart == false) && (showOrHideCommentsForHoriChart == false)){
                    
                    svgPanelForHoriChart.style('width', 100 + "%") .style('height', 85 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }

            }

            resizedFuctionForHorizontalChart();
        })

        var textBoxOneForHorizontalChart = searchDivForHorizontalChart.append('input').style("width","80px").style('margin-left','15px').style('margin-top','50px')
        .style('position',"absolute").style('height',"22px").style("border", "1.0px") .style("border-color", "#e6e6e6") .style("border-style", "solid").style('text-indent','5px')
        .attr("value",d3.min(minAndMaxValuesArrayForHorizontalChart)).style("padding","0px").attr("disabled","disabled").style("color","#000000")
        
        var toLableForHorizontalChart = searchDivForHorizontalChart.append('div').style('background-color',"#fcfcff").attr("fant-family", "Verdana,sans-serif").style("font-weight", "Bold")
        .style('margin-top','52px').style('margin-left','139px').style('position',"absolute").style("width","25px").style("height","15px")
        .style("box-shadow", "1px 1px 1px #ffffff")
        .html('<div  style="width: 100%; height:100%; background-color:#fdfdfd; font-size:12px; position: absolute;  font-family:inter;  color:#000000; font-weight:Bold;">'+ "-to-"+'</div>')

        var textBoxTwoForHorizontalChart = searchDivForHorizontalChart.append('input').style("width","80px").style('margin-left','198px').style('margin-top','50px')
        .style('position',"absolute").style('height',"22px").style("border", "1.0px") .style("border-color", "#e6e6e6") .style("border-style", "solid")
        .style('text-indent','5px').attr("value",d3.max(minAndMaxValuesArrayForHorizontalChart)) .attr("disabled","disabled").style("color","#000000")
        .style("padding","0px")
        
        var searchAndRenderButton = searchDivForHorizontalChart.append("button").style("width","147px").style("height","22px") .style('position','absolute')
        .style('margin-left','75px').style('font-size','12px').style('margin-top','110px').style("box-shadow", "0px 1px 2px #d9d9d9") .style("border-style", "none")
        .style('background-color',"#2196f3").style("color","#ffffff") // d8ebff
        .style('text-align','center')
        var textForSearchAndRenderButton = document.createTextNode("Apply Filter")
        searchAndRenderButton[0][0].appendChild(textForSearchAndRenderButton)

        searchAndRenderButton.on('click', function() {
            searchedDataArray = [];
            //searchDivForHorizontalChart.style("display","none")
            var textBoxOneForHorizontalChartValue = parseFloat(textBoxOneForHorizontalChart[0][0].value) 
            var textBoxTwoForHorizontalChartValue = parseFloat(textBoxTwoForHorizontalChart[0][0].value)
            var toBeFetchedValue = options.keys.value
            
            textBoxOneForHorizontalChart.attr("value","")
            textBoxTwoForHorizontalChart.attr("value","")
            
            newJson.forEach(function(d, i) {
                
                if((+d[toBeFetchedValue] >= textBoxOneForHorizontalChartValue) && (+d[toBeFetchedValue] <= textBoxTwoForHorizontalChartValue) ){
                    searchedDataArray.push(d)
                }
            });
            
            if(searchedDataArray.length == 0){
                //alert("Sorry, no result found for this search!")

                var alertPageDisabledDivForHorizontalChart =targetElement.append('div').style('width',100 + '%')
                .style('height',100 + "%").style('position','absolute').style('margin-left', '0px').style('top', '0px')
                .style("background-color",'#f3f3f3').style("z-index",99)//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("opacity",0.2).style("display","block")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")

                var alertDivForHorizontalChart = targetElement.append('div').style('width','350px')
                .style('height',"150px").style('position','absolute').style('left', ((targetElement[0][0].clientWidth/2) - 175) + "px").style('top', '1px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "solid").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","0px")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
                //.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Bold;">Sorry, no result found for selected' + 'range!'+ '</br>' + '<label style=text-indent:10px;> Hello</label' +'</div>')
                .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Normal;">Sorry, no result found for selected range!</div>')

                var alertDivTitleForHorizontalChart = alertDivForHorizontalChart.append('div').style('width','340px')
                .style('height',"30px").style('position','absolute').style('margin-left', "0px").style('top', '0px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "none").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","2px")
                .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; font-weight:Bold; text-indent:5px;  color:#e5e5e5; font-weight:Normal;">TimeBound</div>')

                var horizontalChartAlertOKButton = alertDivTitleForHorizontalChart.append("button") .style("width","40px") .style("height","20px") .style('position','absolute') .style("box-shadow", "0px 1px 1px #B8B8B8") 
                .style('background-color',"#7cc15e") .style('margin-left','300px') .style('top', "120px").style("color","#ffffff")
                .style("display","block").style('padding-top',"0px").style("cursor","pointer").style("box-shadow", "1px 1px 1px #56973a") .style("border-style", "none")
                .style("font-family","Verdana,sans-serif").style("font-size","14px").style("text-align","center").style("vertical-align","middle").style("border-radius","0px")
                .style("z-index",999)
            
                var textForHorizontalChartAlertOKButton = document.createTextNode("OK");
                horizontalChartAlertOKButton[0][0].appendChild(textForHorizontalChartAlertOKButton)

                $("#"+targetElement[0][0].id).resizable('disable');

                horizontalChartAlertOKButton.on('click', function() {
                    alertDivForHorizontalChart.remove();
                    alertPageDisabledDivForHorizontalChart.remove()
                    $("#"+targetElement[0][0].id).resizable('enable');
                })

                filterButtonForHorizontalChart.style("cursor","pointer")
                disabledDivForHorizontalChart.style("display","none")
                searchDivForHorizontalChart.style("display","none")//.transition().style('width', 0 + "px").duration(200).delay(50)
                //.style("overflow-y","hidden")

                if(showOrHideTableForHoriChart == false){ 
                    svgPanelForHoriChart.style('width', 100 + "%") .style('height', 85 + "%").style("position","absolute")
                }   
                else if(showOrHideTableForHoriChart == true){ 
                    svgPanelForHoriChart.style('width', 100 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor)
                }
                resizedFuctionForHorizontalChart();

            }
            else if(searchedDataArray.length > 0){

                d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                options.data = searchedDataArray;
                acinfotech.horizontalChart(targetElement,options)
            }

        })// searchButton.on('click', function()) function ends here.

        function resetTableWidthOldDataFunction(){
            
            textBoxOneForHorizontalChart.attr("value",d3.min(minAndMaxValuesArrayForHorizontalChart))
            textBoxTwoForHorizontalChart.attr("value",d3.max(minAndMaxValuesArrayForHorizontalChart))

            thead.select('svg').select('#descendingIconIDForHorizontalChart').style("visibility", "visible")
            thead.select('svg').select('#ascendingIconIDForHorizontalChart').style("visibility", "visible")
            
            var table = tablePanelForHoriChart.select('table'); 
            var rows = table.selectAll('tr')
            
            tablePanelForHoriChart.select('table').selectAll('tr').style("background-color","#FFFFFF").style("color","#000000")

            var table = tablePanelForHoriChart.select('table');
            var rows = table.selectAll('tr').data(newJson);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition()
            .delay(20) .duration(20) .style('opacity', 1.0) .style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(20) .duration(20) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(20)
            .duration(20) .style('opacity', 1.0) .style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(20) .duration(20) .style('opacity', 0.0) .remove();

        } // function resetTableWidthOldDataFunction() ends here.

        // Inner SVG
        var svg = svgPanelForHoriChart .append("svg").style("background-color", options.BGcolor).style("border-radius","0px") .style("border-width","1px")
        .style("border-color","#d4d4d4") .style("border-style","solid") .append("g") .attr("transform","translate(" + margin.left + "," + margin.top + ")");
        
        svg.call(tip);
        
        var yAxis = d3.svg.axis() .scale(y1) .orient("left") .ticks(14);
        
        // Adding the Y Axis
        svg.append("g") .attr("class", "y axis") .call(yAxis) .selectAll("text") .style('fill','#00001c') .style("font-weight","normal") .style("font-family","Verdana,sans-serif")
		.style("font-size","12px")
        .text(function(d,i) {
            if(d.length > 9)
                        return d.substring(0,9)+'...';
                    else
                        return d;
        })
        
        // Adding the text label for the Y axis
        var yAxisVariable = svg.append("text") .attr("transform", "rotate(-90)") .attr("y", -115) .attr("x",0 - (height / 2.0)) .attr("dy", "1em") .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif")
        .style("font-size","11.0px") .text(options.yAxisLable) .style('fill','#00001c') .style("text-transform","capitalize") .style("font-weight","Bold")
        .style("font-style","normal")
        
        var xAxis = d3.svg.axis() .scale(x) .orient("bottom") .ticks(10);
        
        // Adding the text label for the X axis
        var xAxisVariable = svg.append("text") .attr("transform", "translate(" + ((width/2) - 20) + " ," + (height+margin.bottom - 6) + ")") .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif") .style("font-size","12px")
        .text(options.xAxisLable) .style('fill','#00001c') .style("text-transform","capitalize") .style("font-weight","Bold") .style("font-style","normal")
        
        // -------------------------------- Creating Bars section --------------------------------
        
        var xScale = d3.scale.ordinal() .domain(d3.range(options.data.map(function(d) { return +d[options.keys.value]; }).length)) .rangeRoundBands([0, height], 0.30);
        
        var yScale = d3.scale.linear() .domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.value]; }), function(d) { return d; })]) .range([0, height]);
        
        var widthScale = d3.scale.linear() .domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.value]; }))]) .range([0, width]);
        
        //Create bars
        var horizontalBars = svg.selectAll(".bar")  .data(options.data.map(function(d) { return +d[options.keys.value]; }))  .enter().append("rect") .attr("class", "bar")
        .on('mouseover', tip.show)  .on('mouseout', tip.hide);
        
        horizontalBars.attr("y", function(d,i) { return xScale(i); })
		.attr("width", 0).transition().delay(400).duration(800)
		.attr("width", function(d) { return widthScale(d); })
		.attr("height", xScale.rangeBand() )
        
		horizontalBars.style("fill",function(d,i){ return colors(i)}).style("cursor","default")

        var columnNames = d3.keys(newJson[0])
        var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
        var newArr = []
        for(var i = 0; i < columnNames.length ; i++){
            for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                    for(var k = 0; k < horizontalBars[0].length; k++){
                        d3.select(horizontalBars[0][k]).attr('data-drilldownkey', function(d,index){
                        var arr = JSON.stringify(newJson[k]).slice(1, -1).split('"'), arr1 = d3.select(arr)[0]
                                                             
                                for(var j = 0; j < arr1[0].length; j++){
                                    if(arr1[0][j].toString() == ":"){
                                        var ch = arr1[0][j].toString().replace(":","|")
                                            newArr.push(ch)
                                    }
                                    else {
                                        newArr.push(arr1[0][j])
                                    }
                                }
                            
                            //return JSON.stringify(newJson[k]).slice(1, -1).split('"').join("").split(':').join("|")
                            return newArr.join("");
                        })
                        newArr = []
                    }
                }
                else {
                }
            }
        }

        var xTextPadding = 3.5;
        var format = d3.format(".2s")
        var textOnBarsForHorizontalChart = svg.selectAll(".bartext") .data(options.data.map(function(d) { return +d[options.keys.value]; }))
        .enter() .append("text") .attr("class", "bartext").style("text-anchor", "start") .style("fill", "#00001c") .style("font-weight","Normal")
        .style("font-size","12px") .style("font-family","Verdana,sans-serif") .style("position","absolute").style("display","none") .attr("class", "series_value").style("display",options.series)
		.attr("x",0) .transition().delay(400).duration(800)
        .attr("x", function(d) { return  widthScale(d) + xTextPadding ; }) 
		.attr("y", function(d,i) { return xScale(i) + xScale.rangeBand()/2.5; }).attr("dy", ".35em")
        .text(function(d){
            if(d.toString().indexOf('.') === -1)
            {
                return d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            else{
                        
                return d;
            }
        })
        
        // -------------------------------- Creating Bars section ends here ------------------------
        
        var width1 = svgPanelForHoriChart[0][0].clientWidth;
        var height1 = svgPanelForHoriChart[0][0].clientHeight;

        var root = targetElement
        var scr = { x: window.scrollX, y: window.scrollY, w: svgPanelForHoriChart[0][0].clientWidth, h: svgPanelForHoriChart[0][0].clientHeight };
        var body_sel = d3.select('body');
        var body = { w: body_sel.node().offsetWidth, h: body_sel.node().offsetHeight };
        var doc = { w: width, h: height };
        var svgpos = root.node().parentNode
        var dist = { x: 20, y: 20 };
        
        horizontalBars.on("mousemove", function(d,i){
            tip.style("display","block")

			var m = d3.mouse(root.node());
			scr.x = window.scrollX;
			scr.y = window.scrollY;
			m[0] += 0
			m[1] += 0
			tip.style("right", "");
			tip.style("left", "");
			tip.style("bottom", "");
			tip.style("top", "");
			tip.style("position","absolute");
			tip.style("border-color", colors(i))

			if(d3.mouse(this)[0] < scr.w/2){
				tip.style("left", (d3.event.pageX + 12 )  + "px");
				tip.style("top", (d3.event.pageY - ( parseFloat(tip.style("height")) /2  ) )+ "px");
			}
			else if(d3.mouse(this)[0] > scr.w/2){
				tip.style("left", (d3.event.pageX) - (parseFloat(tip.style("width"), 10) + 20) + "px");
				tip.style("top", (d3.event.pageY - ( parseFloat(tip.style("height")) /2  ) ) + "px");
			}
			else if(d3.mouse(this)[0] == scr.w/2){
				tip.style("left", (d3.event.pageX) - (parseFloat(tip.style("width"), 10) + 20) + "px");
				tip.style("top", (d3.event.pageY - ( parseFloat(tip.style("height")) /2  ) ) + "px");
			}
        });
        
        // Creating table
        var tablePanelForHoriChart =  targetElement.append("div") .attr("id",targetElement[0][0].id + "holderForHorizontalChartTableID")
        .attr("class","scrollingDivForTable-Class tableDivForHorizontalChart" + targetElement[0][0].id) .style('background-color',"#ffffff") .style('position','absolute')
        .style("display","block") .style("overflow","hidden") .style("width", function(d) {  return 100.0 + "%"; })
        .style("height", function(d) { return 40 + "%"; }) .style("left",0 + "%")//.style("border-right","1px solid #e2e2e2")
        //.style("border-bottom","1px solid #e2e2e2")

        $( '.tableDivForHorizontalChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        if(options.showTitle == true ){
            tablePanelForHoriChart.style("top",60.0  + "%")
        }
        else if(options.showTitle == false  ){
            tablePanelForHoriChart.style("top",60.0  + "%")
            
        }
        tablePanelForHoriChart.html('<table class = "tableClassForHorizontalChart' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                    '<thead class = "theadClassForHorizontalChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForHorizontalChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                                    '<tbody class = "tBodyClassForHorizontalChart' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                    '</table>'
                                    )
        
        tablePanelForHoriChart.select('table').attr("id",targetElement[0][0].id + "tableID")

        // Show or Hide Table scroll bar when mouseover on widget
        targetElement.on('mouseover',function(){ tablePanelForHoriChart.style("overflow","auto") })
        targetElement.on('mouseout',function(d){ tablePanelForHoriChart.style("overflow","hidden") })
        
        var tableDataForHorizontalChart = [];
        if(options.dataForTable.length > 0){
            tableDataForHorizontalChart = options.dataForTable;
        }
        else {
            tableDataForHorizontalChart = newJson;
        }
        
        var thead = tablePanelForHoriChart.select("thead").selectAll("th") .data(d3.keys(tableDataForHorizontalChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px").style("color","#00001c")
        
        var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff") //f4f4f4
        .style("position","relative")
        
        var thead1 = d3.select(".thead1ClassForHorizontalChart" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tableDataForHorizontalChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px").style("color","#00001c")
        
        var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff") //f4f4f4
        .style("position","relative")
        
        var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
        .attr("id", "ascendingIconIDForHorizontalChart") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
        
        var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
        .attr("id", "descendingIconIDForHorizontalChart") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
        
        var tr = tablePanelForHoriChart.select("tbody").selectAll("tr") .data(tableDataForHorizontalChart).enter().append("tr")
        .attr("id", function(d,i) { return "slice" + i })
        
        // cells
        var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d})
        .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
        
        var $table = $('.tableClassForHorizontalChart' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
        
        d3.select(".theadClassForHorizontalChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                d.forEach(function(dd,j){
                  colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                })
        })
        
        $(".thead1ClassForHorizontalChart" + targetElement[0][0].id).insertAfter('.tBodyClassForHorizontalChart' + targetElement[0][0].id)
        
        $(".thead1ClassForHorizontalChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForHorizontalChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
        
        tablePanelForHoriChart.select(".thead1ClassForHorizontalChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
        })
        
        $('.tableDivForHorizontalChart' + targetElement[0][0].id).scroll(function () {
                                                                 
             $(".thead1ClassForHorizontalChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForHorizontalChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
             
         })
        
        var sortOrder = false;
        thead1.on("click",function(k,index){
                 
             sortOrder = !sortOrder;
             
             tablePanelForHoriChart.select(".thead1ClassForHorizontalChart" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                                                          
                if (sortOrder) {
                                  
                    if(i == index){
                        d3.select(this).select('svg').select('#descendingIconIDForHorizontalChart').style("visibility", "hidden")
                        d3.select(this).select('svg').select('#ascendingIconIDForHorizontalChart').style("visibility", "visible")
                    }
                    else {
                        d3.select(this).select('svg').select('#descendingIconIDForHorizontalChart').style("visibility", "visible")
                        d3.select(this).select('svg').select('#ascendingIconIDForHorizontalChart').style("visibility", "visible")
                    }
                }
                else{
                                  
                    if(i == index){
                        d3.select(this).select('svg').select('#descendingIconIDForHorizontalChart').style("visibility", "visible")
                        d3.select(this).select('svg').select('#ascendingIconIDForHorizontalChart').style("visibility", "hidden")
                    }
                    else {
                        d3.select(this).select('svg').select('#descendingIconIDForHorizontalChart').style("visibility", "visible")
                        d3.select(this).select('svg').select('#ascendingIconIDForHorizontalChart').style("visibility", "visible")
                    }
                }
            })
             
              var monthTruOrFalAryForHoriChart = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
              
              tr.sort(function(a, b) {
                      
                      if (sortOrder) {
                      var monthsArrayForHoriChart = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                      } else {
                      var monthsArrayForHoriChart = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                      }
                      
                      monthTruOrFalAryForHoriChart = []; gotMonthArray = [];
                      tableDataForHorizontalChart.forEach(function(d,i){
                         var da = d[k].toString().substring(0,3).toLowerCase()
                         if(monthsArrayForHoriChart.indexOf(da) >= 0){
                             monthTruOrFalAryForHoriChart.push(true)
                             gotMonthArray.push(da);
                         }
                         else {
                             monthTruOrFalAryForHoriChart.push(false)
                         }
                      })
                      
                      if(monthTruOrFalAryForHoriChart.indexOf(false) == -1){ // true
                      
                      monthArray = []; monthArrayCount = [];
                      gotMonthArray.forEach(function(dd,j){
                            var index1 = monthsArrayForHoriChart.indexOf(dd.substring(0,3))
                            if(monthArrayCount.indexOf(index1) >= 0){
                                index1 = 12 + index1;
                            }
                            monthArray.push(index1);
                            monthArrayCount.push(index1)
                       })
                      returnArray = []
                      monthArray.sort(function(aa, bb) {
                          returnArray.push(+aa - +bb)
                          return +aa - +bb;
                      })
                      
                      sortTableFunc()
                      return returnArray[ind++];
                      } //  if true (if jan feb if block)
                      else {
                      var data = +a[k];
                      
                      if(!isNaN(data)){
                      
                      if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                      else { return d3.descending(+a[k], +b[k]); }
                      }
                      else if(!isNaN(Date.parse(a[k]))){
                      
                      if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                      else { return new Date(b[k]) - new Date(a[k]) }
                      }
                      else {
                      
                      if (sortOrder) { return d3.ascending(a[k], b[k]); }
                      else { return d3.descending(a[k], b[k]); }
                      }
                      } // if not jan feb else block
                }); // tr
             
        })
        
        function sortTableFunc(){
            
            var table = tablePanelForHoriChart.select('table');
            var rows = table.selectAll('tr').data(tableDataForHorizontalChart);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0) .style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500)
            .style('opacity', 1.0) .style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
            
        }
        
        if(options.dataForTable.length == 0){
            
            var selectedItem = "";
            horizontalBars.on("click", function(d,i) {
                        
                tip.style("display","none")
                      
                thead1.select('svg').select('#descendingIconIDForHorizontalChart').style("visibility", "visible")
                thead1.select('svg').select('#ascendingIconIDForHorizontalChart').style("visibility", "visible")
                  
                sortTableFunc()
                
                selectedItem = i
                
                var val = d.value;
                var selectedSlice = i
                options.data.forEach(function(d,i) {
                                     
                     if(i == selectedItem){
                     tablePanelForHoriChart.select("tbody").selectAll("tr")
                     
                     .style("background-color", function(dTr, iTr) {
                            return i == iTr ? "#909090" : null;
                            })
                     .style("color", function(dTr, iTr) {
                            return i == iTr ? "#FFFFFF" : null;
                            })
                        
                        var row = $('#' + targetElement[0][0].id + "tableID").find('tr');
                        
                        
                        if((row[0].clientHeight * selectedItem) > tablePanelForHoriChart[0][0].clientHeight - 56 ){

                            $("#" + targetElement[0][0].id + "holderForHorizontalChartTableID").animate({
                            scrollTop: row[0].clientHeight * selectedItem }, 350);
                        }
                        else{

                            $("#" + targetElement[0][0].id + "holderForHorizontalChartTableID").animate({
                            scrollTop: 0 }, 350);
                        }

                     } //if(i == selectedItem)
                });
            })
        }
        else{
            horizontalBars.on("click", function(d,i) {
               tip.style("display","none")
            })
        }
        
        // Main Table Styling
        tablePanelForHoriChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
        .style("color","#00001c")
        .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4")
        tablePanelForHoriChart.selectAll('td').style("height","25px") .style("border", "1px solid #dddddd") .style("font-size","12px").style("font-weight","Normal") .style("color","#00001c")

        //additionally 
        tablePanelForHoriChart.selectAll('th').style('background-color',"#ffffff").style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
        tablePanelForHoriChart.selectAll('td').style("border-style","none").style("color","#00001c")

        //b1da9f
        tablePanelForHoriChart.selectAll('table').style("border-collapse","collapse")
        tablePanelForHoriChart.selectAll('table tr:first-child th').style("border-top","0px")
        tablePanelForHoriChart.selectAll('table tr:last-child td').style("border-bottom","0px")
        tablePanelForHoriChart.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
        tablePanelForHoriChart.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")
        
        if(showOrHideTableForHoriChart == false){
            tablePanelForHoriChart.style("display","none")        
        }
        else if(showOrHideTableForHoriChart == true){
            tablePanelForHoriChart.style("display","block")
        }
        
        if(options.isDataDetailedForTable == false){
        
            var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
        
            // Adding underlines for selected drill-down column text
            var drillDownSectionsForHoriChart = tablePanelForHoriChart.select('table').selectAll('th')
        
            var foundResult = [];
            for(var i = 0; i<drillDownSectionsForHoriChart[0].length; i++){
            
                for(var j = 0; j<drillDownColumnNamesArray.length; j++){
                    if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForHoriChart[0][i].__data__.toString().toLowerCase() ){
                        foundResult.push(i)
                    }
                }
            }
        
            var r = tablePanelForHoriChart.select('table').selectAll('tr').selectAll('td')
            for(var i = 0; i<r.length; i++){
                for(var j = 0; j < foundResult.length; j++){
                    var row = r[i][foundResult[j]]
                    $(row).css("text-decoration", "underline")
                }
            }
        }
        
        //By default calling the resized function first time (to align table's th and td).
        setTimeout(function(){ resizedFuctionForHorizontalChart() },1000)
        
        window.addEventListener('resize', function(event){ resizedFuctionForHorizontalChart() });
        
        $(function() {
          $("#" + targetElement[0][0].id).resizable({
                resize: function(event, ui) {
                    divWidthForHoriChart = ui.size.width;
                    divHeightForHoriChart = ui.size.height;
                    resizedFuctionForHorizontalChart();
                }
            });
          });
        
        function resizedFuctionForHorizontalChart()
        {
            if((svgPanelForHoriChart.node().getBoundingClientRect().width) && (svgPanelForHoriChart.node().getBoundingClientRect().height) > 0){

                if(showOrHideCommentsBtnForHoriChart == true){
                    pieButtonForHorizontalChart.style('margin-left', "2px")
                    columnButtonForHorizontalChart.style('margin-left', "2px")
                    donutButtonForHorizontalChart.style('margin-left', "2px")
                    filterButtonForHorizontalChart.style('margin-left', "2px")
                    refreshButtonForHorizontalChart.style('margin-left', "2px")
                    commentsBtnForHoriChart.style('margin-left', "2px")
                    menuButtonForHorizontalChart.style('right', '0')
                }
                else if(showOrHideCommentsBtnForHoriChart == false){
                    pieButtonForHorizontalChart.style('margin-left', "2px")
                    columnButtonForHorizontalChart.style('margin-left', "2px")
                    donutButtonForHorizontalChart.style('margin-left', "2px")
                    filterButtonForHorizontalChart.style('margin-left', "2px")
                    refreshButtonForHorizontalChart.style('margin-left', "2px")
                    //commentsBtnForHoriChart.style('right', '0')
                    commentsBtnForHoriChart.style('display','none')
                    menuButtonForHorizontalChart.style('right', '0')
                }

                optionsButtonPanelForHorizontalChart.style('right', '0')

                cancelButton.style('right', '0')

                settingPanelCancelButtonForHorizontalChart.style('right', '0')

                if(isSearchInTableButtonClicked == true){
                    canBtnForSearchDivForSearchTableForHorizontalChart.style('right', '0')
                }

                var margin1 = {top: 20, right: 55, bottom: 30, left: 130}, //originally left: 85
                width1 = (svgPanelForHoriChart.node().getBoundingClientRect().width) - margin1.left - margin1.right,
                height1 = (svgPanelForHoriChart.node().getBoundingClientRect().height) - margin1.top - margin1.bottom;

                var xx = x.domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.value]; }))]) .range([0, width1]);
            
                var yy = y.domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.value]; }))]) .range([height1, 0]);
            
                yAxis.scale(y1) .orient("left") .ticks(14);
            
                y1.domain(options.data.map(function(d) { return d[options.keys.label]; })) .rangeRoundBands([0, height1], 0.30);
            
                xAxis.scale(xx) .orient("bottom")
            
                var svg1 = svg;
            
                svg1.selectAll("svg") .attr("width", width1 + margin1.left + margin1.right)
                .attr("height", height1 + margin1.top + margin1.bottom);
            
                svg1.select(".y.axis") .call(yAxis) .selectAll("text") .style('fill','#00001c') .style("font-weight","normal") 
                .style("font-family","Verdana,sans-serif")
                .text(function(d,i) {
                if(d.length > 9)
                    return d.substring(0,9)+'...';
                else
                    return d;
                })//.attr("dx", "-.1em") .attr("dy", "-.45em")  .attr("transform", function(d) { return "rotate(-40)" })
            
                svg1.select(".x.axis") .attr("transform", "translate(0," + height1 + ")") .call(xAxis)
            
                yAxisVariable.attr("y", -115) .attr("x",0 - (height1 / 2.0)) .attr("dy", "1em")
            
                xAxisVariable.attr("transform", "translate(" + ((width1/2 - 20)) + " ," + (height1+margin1.bottom - 6) + ")")
            
                xScale.domain(d3.range(options.data.map(function(d) { return +d[options.keys.value]; }).length))
                .rangeRoundBands([0, height1], 0.30);
            
                yScale.domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.value]; }), function(d) {return d;})])
                .range([0, height1]);
            
                widthScale.domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.value]; }))])
                .range([0, width1]);
            
                svg1.selectAll(".bar") .attr("width", function(d) { return widthScale(d); }) .attr("height", xScale.rangeBand() )
                .attr("y", function(d,i) { return xScale(i); })

                svg.selectAll(".bartext").attr("x", function(d) { return  widthScale(d) + xTextPadding ; })
                .attr("y", function(d,i) { return xScale(i) + xScale.rangeBand()/2.5; }) .attr("dy", ".35em")

                svg.selectAll(".series_value").attr("x", function(d) { return  widthScale(d) + xTextPadding ; })
                .attr("y", function(d,i) { return xScale(i) + xScale.rangeBand()/2.5; }) .attr("dy", ".35em")
                
                colWidth = []; 
				
                d3.select(".theadClassForHorizontalChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                    d.forEach(function(dd,j){
                        colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                    })
                })
                
                tablePanelForHoriChart.select(".thead1ClassForHorizontalChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                    d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
                })
                
            } // checking svg panel width & height greater than zero function ends here.

        } // resizedFunction ends here.

    }, //horizontalChart
    
    // ************************************************** Map  **************************************************
    map: function(targetElement,options){
        isChartCalled++;
        var chartName = "MAPCHART"
        
        targetElement.style("min-width","350px").style("min-height","350px").style("background-color", options.BGcolor)
       

        var chartTitlePanelForMap =  targetElement.append("div").style("background-color", options.BGcolor).style('position',"absolute").style("text-indent","6px").style("border-style","none")
        var downloadBtnForUSMap = targetElement.append("div").attr("id","downloadBtnForUSMap-ID-" + targetElement[0][0].id).style("width","20px").style("height","20px")
        .style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff")
        .style('right', '0').style('top', 2 + 'px').style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8")
        .style("border", "1px solid #f8f8f8")
        acinfotech.downloadFunctionality("downloadBtnForUSMap-ID-" + targetElement[0][0].id,targetElement)
       
       
        
                // Creating ToolTip for options button.
        var iconBtnTooltipForUSMap = targetElement.append('div').style('width','240px').style('height',"25px").style('position','absolute').style("background-color",'#404040 ')
        .style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid").style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8")
        .style("display","none").attr("border", 0.0)
        
        downloadBtnForUSMap.on('mousemove', function(d,i) {
              var root = targetElement
              var m = d3.mouse(root.node());
              m[0] += 0
              m[1] += 0
              var downloadButtonTooltipText = "Download";
              iconBtnTooltipForUSMap.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
              iconBtnTooltipForUSMap.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
        })
        downloadBtnForUSMap.on('mouseout', function(d,i) {
              iconBtnTooltipForUSMap.style("display","none")
        })
    //     var maximizeBtnForMap = targetElement.append("div").attr("id","maximieBtnForUSMap-ID-" + targetElement[0][0].id).style("width","20px").style("height","20px")
    //     .style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff")
    //     .style('margin-left',(targetElement[0][0].clientWidth - 54) + "px").style('top', 2 + 'px').style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8")
    //     .style("border", "1px solid #f8f8f8")

    //     var maxBtnImgVar = document.createElement("IMG");

    //     maxBtnImgVar.src = "images/fullview.png";
    //     maxBtnImgVar.setAttribute("style","position:absolute; left:1px; top:6px; width:14px; height:14px; opacity:0.8;")
    //     maximizeBtnForMap[0][0].appendChild(maxBtnImgVar)
    //     var  maxBtnTooltipForUSMap=targetElement.append('div').style('width','240px').style('height',"25px").style('position','absolute').style("background-color",'#404040 ')
    //     .style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid").style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8")
    //     .style("display","none").attr("border", 0.0).on("click",function() {
    //         var width = window.innerWidth;
    //         var height = window.innerHeight;
    //         var svgWidth = targetElement[0][0].clientWidth
    //         var svgHeight = targetElement[0][0].clientHeight
    //         // targetElement[0][0].clientHeight=height;
    //         // targetElement[0][0].clientWidth=width;
    //         // acinfotech.map(targetElement,options) 
    //         d3.select(targetElement).style("width",width).style("height",height)
    //     })
    //     maximizeBtnForMap.on('mousemove', function(d,i) {
    //         var root = targetElement
    //         var m = d3.mouse(root.node());
    //         m[0] += 0
    //         m[1] += 0
    //         var maximizeButtonTooltipText = "Maximize";
    //         maxBtnTooltipForUSMap.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
    //         maxBtnTooltipForUSMap.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ maximizeButtonTooltipText +'</div>')
    //   })
    //   maximizeBtnForMap.on('mouseout', function(d,i) {
    //         maxBtnTooltipForUSMap.style("display","none")
    //   })
      //acinfotech.maximizeFunctionality("maximieBtnForUSMap-ID-" + targetElement[0][0].id,targetElement)
        // var zoom = d3.behavior.zoom().scaleExtent([1, Infinity]).on("zoom", function () {
        //         svgPanelForMap.attr("transform", "translate(" + d3.event.translate + ")" + " scale(" + d3.event.scale + ")")
        //       });
        var svgPanelForMap = targetElement .append('div').attr("class","svgDiv").append('svg').attr("id","stateSvgID" + targetElement[0][0].id)
        .attr("class","svgPanelClassForMap") .style("background-color", options.BGcolor) .style("position","absolute");
       // svgPanelForMap.call(zoom);
       
        
        if(options.showTitle == true){
            
            chartTitlePanelForMap.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 8 + "%"; }).style("background-color", options.BGcolor)
            .html('<div  style="width: 100%; height:0%;  position: absolute; top:10.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>') //color 325922
            svgPanelForMap.attr('width', 100 + "%") .attr('height', 92 + "%") .style("left",0 + "%").style("top",8 + "%") .style("background-color", options.BGcolor).append('g')
            
        }
        else if(options.showTitle == false){
            chartTitlePanelForMap.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });
            svgPanelForMap.attr('width', 100 + "%") .attr('height', 92 + "%") .style("left",0 + "%").style("top",8 + "%").style("background-color", options.BGcolor) .append('g')
            
        }

         // Creating ToolTip DIV
        var tooltipForMap = targetElement .append('div') .attr('class', 'tooltipPie') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
        .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
        .style("padding-right", "7px") .style("background", "#F8F8F8") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style("z-index",1000)
        .style("border", "1.0px") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","80px")
        tooltipForMap.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'label').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "14px") .style("font-weight", "normal");
        tooltipForMap.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
        tooltipForMap.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");

        var color = d3.scale.ordinal() .range(["#c40500", "#eeae00", "#4f9f00", "#6a4449", "#008080", "#abab58", "#434343","#EE9A4D","#AF7817","#6F4E37","#8c2100","#008d8d"]);

        var sampleData ={}; 
            
		["HI", "AK", "FL", "NH", "MI", "VT", "ME", "RI", "NY", "PA", "NJ",
		"DE", "MD", "VA", "WV", "OH", "IN", "IL", "CT", "WI", "NC", "DC", 
		"MA", "TN", "AR", "MO", "GA", "SC", "KY", "AL", "LS", "MS", "IA", 
		"MN", "OK", "TX", "NM", "KS", "NE", "SD", "ND", "WY", "MT", "CO", 
		"ID", "UT", "AZ", "NV", "OR","WA","CA"]
		.forEach(function(d,i){ 
			var stateNames = d;
		
			var val = 0;
			options.data.forEach(function(d,i){
				if(stateNames.toLowerCase() == d[options.keys.label].toLowerCase()) { val = d[options.keys.value] }
					return true;
			})
			if(val >=0 && val<100){
                //sampleData[d]={value:val,color:d3.interpolate("#8dc0e5", "#5DA5DA")(val/99)}
                sampleData[d]={value:val,color:d3.interpolate("#AEAEAE", "#2b8cbe")(val/20)}
            }
            else if(val>=100 && val<1000){
                sampleData[d]={value:val,color:d3.interpolate("#e5f5f9", "#99d8c9")(val/200)}
            }
            else if(val>=1000 && val<10000){
                sampleData[d]={value:val,color:d3.interpolate("#ffeda0", "#f03b20")(val/5000)}
            }
            else if(val>=10000 && val<50000){
                sampleData[d]={value:val,color:d3.interpolate("#e0ecf4", "#8856a7")(val/10000)}
            }
            else if(val>50000){
                sampleData[d]={value:val,color:d3.interpolate("#fee0d2", "#de2d26")(val/50000)}
            }
		});
        var uStatePaths=[
        {id:"HI",n:"Hawaii",d:"M233.08751,519.30948L235.02744,515.75293L237.2907,515.42961L237.61402,516.23791L235.51242,519.30948L233.08751,519.30948ZM243.27217,515.59127L249.4153,518.17784L251.51689,517.85452L253.1335,513.97465L252.48686,510.57977L248.28366,510.09479L244.24213,511.87306L243.27217,515.59127ZM273.9878,525.61427L277.706,531.11074L280.13092,530.78742L281.26255,530.30244L282.7175,531.59573L286.43571,531.43407L287.40568,529.97912L284.49577,528.20085L282.55584,524.48263L280.45424,520.92609L274.63444,523.83599L273.9878,525.61427ZM294.19545,534.50564L295.48874,532.5657L300.17691,533.53566L300.82356,533.05068L306.96668,533.69732L306.64336,534.99062L304.05678,536.44556L299.69193,536.12224L294.19545,534.50564ZM299.53027,539.67879L301.47021,543.55866L304.54176,542.42703L304.86509,540.81041L303.24848,538.70882L299.53027,538.3855L299.53027,539.67879ZM306.4817,538.54716L308.74496,535.63726L313.43313,538.06218L317.79798,539.19381L322.16284,541.94205L322.16284,543.88198L318.6063,545.66026L313.75645,546.63022L311.33154,545.17527L306.4817,538.54716ZM323.13281,554.06663L324.74942,552.77335L328.14431,554.38997L335.74238,557.94651L339.13727,560.0481L340.75387,562.47302L342.69381,566.83787L346.73534,569.42445L346.41202,570.71775L342.53215,573.95097L338.32896,575.40592L336.87401,574.75928L333.80244,576.53754L331.37753,579.77077L329.11427,582.68067L327.33599,582.51901L323.77945,579.93243L323.45613,575.40592L324.10277,572.981L322.48616,567.32286L320.38456,565.54458L320.2229,562.958L322.48616,561.98804L324.58776,558.91648L325.07274,557.94651L323.45613,556.16823L323.13281,554.06663Z"},
        {id:"AK",n:"Alaska",d:"M158.07671,453.67502L157.75339,539.03215L159.36999,540.00211L162.44156,540.16377L163.8965,539.03215L166.48308,539.03215L166.64475,541.94205L173.59618,548.73182L174.08117,551.3184L177.47605,549.37846L178.1227,549.2168L178.44602,546.14524L179.90096,544.52863L181.0326,544.36697L182.97253,542.91201L186.04409,545.01361L186.69074,547.92352L188.63067,549.05514L189.7623,551.48006L193.64218,553.25833L197.03706,559.2398L199.78529,563.11966L202.04855,565.86791L203.50351,569.58611L208.515,571.36439L213.68817,573.46598L214.65813,577.83084L215.14311,580.9024L214.17315,584.29729L212.39487,586.56054L210.77826,585.75224L209.32331,582.68067L206.57507,581.22573L204.7968,580.09409L203.98849,580.9024L205.44344,583.65065L205.6051,587.36885L204.47347,587.85383L202.53354,585.9139L200.43195,584.62061L200.91693,586.23722L202.21021,588.0155L201.40191,588.8238C201.40191,588.8238,200.59361,588.50048,200.10863,587.85383C199.62363,587.20719,198.00703,584.45895,198.00703,584.45895L197.03706,582.19569C197.03706,582.19569,196.71374,583.48898,196.06709,583.16565C195.42044,582.84233,194.7738,581.71071,194.7738,581.71071L196.55207,579.77077L195.09712,578.31582L195.09712,573.30432L194.28882,573.30432L193.48052,576.6992L192.34888,577.1842L191.37892,573.46598L190.73227,569.74777L189.92396,569.26279L190.24729,574.92094L190.24729,576.05256L188.79233,574.75928L185.23579,568.77781L183.13419,568.29283L182.48755,564.57462L180.87094,561.66472L179.25432,560.53308L179.25432,558.26983L181.35592,556.97654L180.87094,556.65322L178.28436,557.29986L174.88947,554.87495L172.30289,551.96504L167.45306,549.37846L163.41152,546.79188L164.70482,543.55866L164.70482,541.94205L162.92654,543.55866L160.01664,544.69029L156.29843,543.55866L150.64028,541.13375L145.14381,541.13375L144.49717,541.61873L138.03072,537.73885L135.92912,537.41553L133.18088,531.59573L129.62433,531.91905L126.06778,533.374L126.55277,537.90052L127.68439,534.99062L128.65437,535.31394L127.19941,539.67879L130.43263,536.93055L131.07928,538.54716L127.19941,542.91201L125.90612,542.58869L125.42114,540.64875L124.12785,539.84045L122.83456,540.97208L120.08632,539.19381L117.01475,541.29541L115.23649,543.397L111.8416,545.4986L107.15342,545.33693L106.66844,543.23534L110.38664,542.58869L110.38664,541.29541L108.12338,540.64875L109.09336,538.22384L111.35661,534.34397L111.35661,532.5657L111.51827,531.75739L115.88313,529.49413L116.85309,530.78742L119.60134,530.78742L118.30805,528.20085L114.58983,527.87752L109.57834,530.62576L107.15342,534.02064L105.37515,536.60723L104.24352,538.87049L100.04033,540.32543L96.96876,542.91201L96.645439,544.52863L98.908696,545.4986L99.717009,547.60018L96.96876,550.83341L90.502321,555.03661L82.742574,559.2398L80.640977,560.37142L75.306159,561.50306L69.971333,563.76631L71.749608,565.0596L70.294654,566.51455L69.809672,567.64618L67.061434,566.67621L63.828214,566.83787L63.019902,569.10113L62.049939,569.10113L62.37326,566.67621L58.816709,567.96951L55.90681,568.93947L52.511924,567.64618L49.602023,569.58611L46.368799,569.58611L44.267202,570.87941L42.65059,571.68771L40.548995,571.36439L37.962415,570.23276L35.699158,570.87941L34.729191,571.84937L33.112578,570.71775L33.112578,568.77781L36.184142,567.48452L42.488929,568.13117L46.853782,566.51455L48.955378,564.41296L51.86528,563.76631L53.643553,562.958L56.391794,563.11966L58.008406,564.41296L58.978369,564.08964L61.241626,561.3414L64.313196,560.37142L67.708076,559.72478L69.00137,559.40146L69.648012,559.88644L70.456324,559.88644L71.749608,556.16823L75.791141,554.71329L77.731077,550.99508L79.994336,546.46856L81.610951,545.01361L81.934272,542.42703L80.317657,543.72032L76.922764,544.36697L76.276122,541.94205L74.982838,541.61873L74.012865,542.58869L73.851205,545.4986L72.39625,545.33693L70.941306,539.51713L69.648012,540.81041L68.516388,540.32543L68.193068,538.3855L64.151535,538.54716L62.049939,539.67879L59.463361,539.35547L60.918305,537.90052L61.403286,535.31394L60.756645,533.374L62.211599,532.40404L63.504883,532.24238L62.858241,530.4641L62.858241,526.09925L61.888278,525.12928L61.079966,526.58423L54.936843,526.58423L53.481892,525.29094L52.835247,521.41108L50.733651,517.85452L50.733651,516.88456L52.835247,516.07625L52.996908,513.97465L54.128536,512.84303L53.320231,512.35805L52.026941,512.84303L50.895313,510.09479L51.86528,505.08328L56.391794,501.85007L58.978369,500.23345L60.918305,496.51525L63.666554,495.22195L66.253132,496.35359L66.576453,498.77851L69.00137,498.45517L72.23459,496.03026L73.851205,496.67691L74.821167,497.32355L76.437782,497.32355L78.701041,496.03026L79.509354,491.6654C79.509354,491.6654,79.832675,488.75551,80.479317,488.27052C81.125959,487.78554,81.44928,487.30056,81.44928,487.30056L80.317657,485.36062L77.731077,486.16893L74.497847,486.97723L72.557911,486.49225L69.00137,484.71397L63.989875,484.55231L60.433324,480.83411L60.918305,476.95424L61.564957,474.52932L59.463361,472.75105L57.523423,469.03283L58.008406,468.22453L64.798177,467.73955L66.899773,467.73955L67.869736,468.70951L68.516388,468.70951L68.354728,467.0929L72.23459,466.44626L74.821167,466.76958L76.276122,467.90121L74.821167,470.00281L74.336186,471.45775L77.084435,473.07437L82.095932,474.85264L83.874208,473.88268L81.610951,469.51783L80.640977,466.2846L81.610951,465.47629L78.21606,463.53636L77.731077,462.40472L78.21606,460.78812L77.407756,456.90825L74.497847,452.22007L72.072929,448.01688L74.982838,446.07694L78.21606,446.07694L79.994336,446.72359L84.197528,446.56193L87.915733,443.00539L89.047366,439.93382L92.765578,437.5089L94.382182,438.47887L97.130421,437.83222L100.84863,435.73062L101.98027,435.56896L102.95023,436.37728L107.47674,436.21561L110.22498,433.14405L111.35661,433.14405L114.91316,435.56896L116.85309,437.67056L116.36811,438.80219L117.01475,439.93382L118.63137,438.31721L122.51124,438.64053L122.83456,442.35873L124.7745,443.81369L131.88759,444.46033L138.19238,448.66352L139.64732,447.69356L144.82049,450.28014L146.92208,449.6335L148.86202,448.82518L153.71185,450.76512L158.07671,453.67502ZM42.973913,482.61238L45.075509,487.9472L44.913847,488.91717L42.003945,488.59384L40.225672,484.55231L38.447399,483.09737L36.02248,483.09737L35.86082,480.51078L37.639093,478.08586L38.770722,480.51078L40.225672,481.96573L42.973913,482.61238ZM40.387333,516.07625L44.105542,516.88456L47.823749,517.85452L48.632056,518.8245L47.015444,522.5427L43.94388,522.38104L40.548995,518.8245L40.387333,516.07625ZM19.694697,502.01173L20.826327,504.5983L21.957955,506.21492L20.826327,507.02322L18.72473,503.95166L18.72473,502.01173L19.694697,502.01173ZM5.9534943,575.0826L9.3483796,572.81934L12.743265,571.84937L15.329845,572.17269L15.814828,573.7893L17.754763,574.27429L19.694697,572.33436L19.371375,570.71775L22.119616,570.0711L25.029518,572.65768L23.897889,574.43595L19.533037,575.56758L16.784795,575.0826L13.066588,573.95097L8.7017347,575.40592L7.0851227,575.72924L5.9534943,575.0826ZM54.936843,570.55609L56.553455,572.49602L58.655048,570.87941L57.2001,569.58611L54.936843,570.55609ZM57.846745,573.62764L58.978369,571.36439L61.079966,571.68771L60.271663,573.62764L57.846745,573.62764ZM81.44928,571.68771L82.904234,573.46598L83.874208,572.33436L83.065895,570.39442L81.44928,571.68771ZM90.17899,559.2398L91.310623,565.0596L94.220522,565.86791L99.232017,562.958L103.59687,560.37142L101.98027,557.94651L102.46525,555.52159L100.36365,556.81488L97.453752,556.00657L99.070357,554.87495L101.01029,555.68325L104.89016,553.90497L105.37515,552.45003L102.95023,551.64172L103.75853,549.70178L101.01029,551.64172L96.322118,555.19827L91.472284,558.10817L90.17899,559.2398ZM132.53423,539.35547L134.95915,537.90052L133.98918,536.12224L132.21091,537.09221L132.53423,539.35547Z"},
        {id:"FL",n:"Florida",d:"M759.8167,439.1428L762.08236,446.4614L765.81206,456.20366L771.14685,465.57996L774.86504,471.88472L779.71486,477.38118L783.75637,481.09937L785.37297,484.00926L784.24135,485.30254L783.43305,486.59582L786.34293,494.03221L789.25282,496.94209L791.83939,502.27689L795.39592,508.09667L799.92241,516.34135L801.2157,523.93939L801.70068,535.90227L802.34732,537.68053L802.024,541.0754L799.59909,542.36869L799.92241,544.30861L799.27577,546.24854L799.59909,548.67344L800.08407,550.61337L797.33585,553.84658L794.2643,555.30152L790.38445,555.46318L788.9295,557.07979L786.5046,558.04975L785.21131,557.56477L784.07969,556.59481L783.75637,553.68492L782.94806,550.29005L779.55319,545.11691L775.99666,542.85367L772.11681,542.53035L771.30851,543.82363L768.23696,539.4588L767.59032,535.90227L765.00375,531.86076L763.22549,530.72913L761.60888,532.83072L759.83062,532.5074L757.72903,527.49592L754.81914,523.61607L751.90925,518.28128L749.32269,515.20973L745.76616,511.49154L747.86774,509.06663L751.10095,503.57017L750.93929,501.95357L746.4128,500.98361L744.79619,501.63025L745.11952,502.27689L747.70608,503.24685L746.25114,507.77335L745.44284,508.25833L743.66457,504.21682L742.37129,499.367L742.04797,496.61877L743.50291,491.93062L743.50291,482.39265L740.43136,478.67446L739.13808,475.60291L733.96494,474.30963L732.02502,473.66299L730.40841,471.07642L727.01354,469.45981L725.88192,466.06494L723.13369,465.09498L720.70878,461.37679L716.50561,459.92185L713.59572,458.4669L711.00916,458.4669L706.96764,459.27521L706.80598,461.21513L707.61429,462.18509L707.1293,463.31672L704.05776,463.15506L700.33957,466.71159L696.78303,468.65151L692.90318,468.65151L689.66997,469.9448L689.34665,467.19657L687.73005,465.25664L684.82016,464.12502L683.20356,462.67007L675.12053,458.79022L667.52249,457.01196L663.15766,457.6586L657.17622,458.14358L651.19478,460.24517L647.71554,460.85813L647.47762,452.80838L644.89105,450.86846L643.11278,449.09019L643.4361,446.01863L653.62072,444.72535L679.16312,441.81546L685.95287,441.16882L691.38887,441.44909L693.97544,445.32895L695.43038,446.78389L703.52854,447.29911L714.34829,446.65247L735.86068,445.35918L741.3064,444.68481L746.41398,444.88932L746.84081,447.79921L749.07381,448.60751L749.30875,443.97751L747.78053,439.80456L749.08893,438.36473L754.64356,438.81948L759.8167,439.1428ZM772.36211,571.54788L774.78703,570.90124L776.08031,570.65875L777.53527,568.31466L779.87935,566.69805L781.17264,567.18304L782.87008,567.50636L783.27423,568.55715L779.79853,569.76961L775.59533,571.22456L773.25125,572.43702L772.36211,571.54788ZM785.86081,566.53639L787.07327,567.58719L789.82151,565.4856L795.15632,561.28241L798.87452,557.40254L801.38027,550.77444L802.35024,549.077L802.5119,545.68212L801.78442,546.1671L800.81446,548.99617L799.3595,553.6035L796.12628,558.8575L791.76144,563.06068L788.36656,565.00061L785.86081,566.53639Z"},
        {id:"NH",n:"New Hampshire",d:"M880.79902,142.42476L881.66802,141.34826L882.75824,138.05724L880.21516,137.14377L879.73017,134.07221L875.85032,132.94059L875.527,130.19235L868.25225,106.75153L863.65083,92.208542L862.75375,92.203482L862.10711,93.820087L861.46047,93.335106L860.4905,92.365143L859.03556,94.305068L858.98709,99.337122L859.29874,105.00434L861.23866,107.75258L861.23866,111.7941L857.52046,116.85688L854.93389,117.98852L854.93389,119.12014L856.06552,120.89841L856.06552,129.46643L855.25721,138.6811L855.09555,143.53092L856.06552,144.82422L855.90386,149.35071L855.41887,151.12899L856.38768,151.83821L873.17535,147.41366L875.35022,146.81121L877.19379,144.03788L880.79902,142.42476Z"},
        {id:"MI",n:"Michigan",d:"M581.61931,82.059006L583.4483,80.001402L585.62022,79.201221L590.99286,75.314624L593.27908,74.743065L593.73634,75.200319L588.59232,80.344339L585.27728,82.287628L583.21967,83.202124L581.61931,82.059006ZM667.79369,114.18719L668.44033,116.69293L671.67355,116.85459L672.96684,115.64213C672.96684,115.64213,672.88601,114.18719,672.56269,114.02552C672.23936,113.86386,670.94608,112.16642,670.94608,112.16642L668.76366,112.40891L667.14704,112.57057L666.82372,113.7022L667.79369,114.18719ZM567.49209,111.21318L568.20837,110.63278L570.9566,109.82447L574.51313,107.56123L574.51313,106.59126L575.15978,105.94462L581.14121,104.97466L583.56612,103.03473L587.93095,100.93315L588.09261,99.639864L590.03254,96.729975L591.8108,95.921673L593.10409,94.143408L595.36733,91.880161L599.73217,89.455254L604.42032,88.970273L605.55194,90.101896L605.22862,91.071859L601.51043,92.041822L600.05549,95.113371L597.79224,95.921673L597.30726,98.34658L594.88235,101.57979L594.55903,104.16636L595.36733,104.65134L596.3373,103.51972L599.89383,100.60983L601.18711,101.90311L603.45036,101.90311L606.68357,102.87307L608.13851,104.0047L609.59345,107.07625L612.34168,109.82447L616.22153,109.66281L617.67648,108.69285L619.29308,109.98613L620.90969,110.47112L622.20297,109.66281L623.33459,109.66281L624.9512,108.69285L628.99271,105.13632L632.38758,104.0047L639.01566,103.68138L643.54215,101.74145L646.12872,100.44817L647.58367,100.60983L647.58367,106.26794L648.06865,106.59126L650.97853,107.39957L652.91846,106.91458L659.06156,105.29798L660.19318,104.16636L661.64813,104.65134L661.64813,111.60274L664.88134,114.67429L666.17462,115.32093L667.4679,116.29089L666.17462,116.61421L665.36632,116.29089L661.64813,115.80591L659.54654,116.45255L657.28329,116.29089L654.05008,117.74584L652.27182,117.74584L646.45204,116.45255L641.27891,116.61421L639.33898,119.20078L632.38758,119.84742L629.96267,120.65572L628.83105,123.72727L627.53777,124.8589L627.05279,124.69724L625.59784,123.08063L621.07135,125.50554L620.42471,125.50554L619.29308,123.88893L618.48478,124.05059L616.54486,128.41543L615.57489,132.45694L612.39377,139.45774L611.21701,138.42347L609.84527,137.39215L607.90449,127.10413L604.36001,125.73408L602.30743,123.44785L590.18707,120.70437L587.3318,119.67473L579.10138,117.50199L571.21139,116.35887L567.49209,111.21318ZM697.8,177.2L694.6,168.9L692.3,159.9L689.9,156.7L687.3,154.9L685.7,156L681.8,157.8L679.9,162.8L677.1,166.5L676,167.2L674.5,166.5C674.5,166.5,671.9,165.1,672.1,164.4C672.3,163.8,672.6,159.4,672.6,159.4L676,158.1L676.8,154.7L677.4,152.1L679.9,150.5L679.5,140.5L677.9,138.2L676.6,137.4L675.8,135.3L676.6,134.5L678.2,134.8L678.4,133.2L676,131L674.7,128.4L672.1,128.4L667.6,126.9L662.1,123.5L659.3,123.5L658.7,124.2L657.7,123.7L654.6,121.4L651.7,123.2L648.8,125.5L649.2,129L650.1,129.3L652.2,129.8L652.7,130.6L650.1,131.4L647.5,131.8L646.1,133.5L645.8,135.6L646.1,137.3L646.4,142.8L642.8,144.9L642.2,144.7L642.2,140.5L643.5,138.1L644.1,135.6L643.3,134.8L641.4,135.6L640.4,139.8L637.7,141L635.9,142.9L635.7,143.9L636.4,144.7L635.7,147.3L633.5,147.8L633.5,148.9L634.3,151.3L633.1,157.5L631.5,161.5L632.2,166.2L632.7,167.3L631.9,169.8L631.5,170.6L631.2,173.3L634.8,179.3L637.7,185.8L639.1,190.6L638.3,195.3L637.3,201.3L634.9,206.4L634.6,209.2L631.3,212.3L635.8,212.1L657.2,209.9L664.4,208.9L664.5,210.5L671.4,209.3L681.7,207.8L685.5,207.4L685.7,206.8L685.8,205.3L687.9,201.6L689.9,199.9L689.7,194.8L691.3,193.2L692.4,192.9L692.6,189.3L694.2,186.3L695.2,186.9L695.4,187.5L696.2,187.7L698.1,186.7L697.8,177.2Z"},
        {id:"VT",n:"Vermont",d:"M844.48416,154.05791L844.80086,148.71228L841.91015,137.92811L841.26351,137.60479L838.35361,136.3115L839.16191,133.40161L838.35361,131.30002L835.65356,126.66004L836.62353,122.78018L835.81522,117.60703L833.39031,111.14059L832.58474,106.21808L859.0041,99.48626L859.3128,105.00847L861.22906,107.7507L861.22906,111.79222L857.52191,116.85021L854.93534,117.99288L854.92429,119.11345L856.23426,120.63257L855.92333,128.73054L855.3139,137.9894L855.08595,143.54634L856.05591,144.83963L855.89425,149.41032L855.40927,151.10021L856.42345,151.82737L848.9859,153.33408L844.48416,154.05791Z"},
        {id:"ME",n:"Maine",d:"M922.83976,78.830719L924.77969,80.932305L927.04294,84.650496L927.04294,86.590422L924.94135,91.278575L923.00142,91.925217L919.60655,94.996766L914.75674,100.49322C914.75674,100.49322,914.1101,100.49322,913.46346,100.49322C912.81682,100.49322,912.49349,98.391636,912.49349,98.391636L910.71523,98.553296L909.74527,100.00824L907.32036,101.46319L906.3504,102.91813L907.967,104.37307L907.48202,105.01972L906.99704,107.76794L905.05711,107.60628L905.05711,105.98968L904.73379,104.69639L903.27885,105.01972L901.50058,101.78651L899.399,103.07979L900.69228,104.53473L901.0156,105.66636L900.2073,106.95964L900.53062,110.03119L900.69228,111.64779L899.07568,114.23436L896.16579,114.71934L895.84247,117.62923L890.50767,120.70078L889.21439,121.18576L887.59778,119.73082L884.52623,123.28735L885.4962,126.52056L884.04125,127.81384L883.87959,132.17867L882.75631,138.43803L880.29406,137.28208L879.80907,134.21052L875.92922,133.07889L875.6059,130.33065L868.33115,106.88983L863.63257,92.250088L865.05311,92.131923L866.5669,92.541822L866.5669,89.955254L867.8752,85.458798L870.46177,80.770645L871.91672,76.729133L869.97679,74.304226L869.97679,68.322789L870.78509,67.352826L871.5934,64.604598L871.43174,63.149654L871.27007,58.29984L873.04834,53.450026L875.95823,44.5587L878.05981,40.355528L879.3531,40.355528L880.64638,40.517188L880.64638,41.648811L881.93967,43.912058L884.68789,44.5587L885.4962,43.750397L885.4962,42.780435L889.53771,39.870546L891.31597,38.092281L892.77092,38.253942L898.75235,40.678849L900.69228,41.648811L909.74527,71.555998L915.7267,71.555998L916.53501,73.495924L916.69667,78.345738L919.60655,80.608984L920.41486,80.608984L920.57652,80.124003L920.09154,78.99238L922.83976,78.830719ZM901.90801,108.97825L903.44379,107.44247L904.81791,108.49327L905.38372,110.91819L903.68628,111.80732L901.90801,108.97825ZM908.61694,103.07763L910.39521,104.93673C910.39521,104.93673,911.6885,105.01755,911.6885,104.69423C911.6885,104.37091,911.93099,102.67347,911.93099,102.67347L912.82013,101.86517L912.01182,100.08689L909.99106,100.81437L908.61694,103.07763Z"},
        {id:"RI",n:"Rhode Island",d:"M874.07001,178.89536L870.37422,163.93937L876.6435,162.09423L878.83463,164.02135L882.14112,168.342L884.82902,172.74409L881.82968,174.36888L880.5364,174.20722L879.40478,175.98549L876.97987,177.92541L874.07001,178.89536Z"},
        {id:"NY",n:"New York",d:"M830.37944,188.7456L829.24781,187.77564L826.66123,187.61398L824.39799,185.67406L822.76738,179.54493L819.30892,179.63547L816.86521,176.92727L797.47989,181.30921L754.47811,190.0389L746.94846,191.26689L746.2103,184.79855L747.6384,183.67317L748.93168,182.54155L749.90165,180.92494L751.67991,179.79332L753.61984,178.01505L754.10482,176.39845L756.2064,173.65022L757.33803,172.68026L757.17637,171.71029L755.88308,168.63875L754.10482,168.47709L752.16489,162.33399L755.07478,160.55572L759.43961,159.10078L763.48113,157.80749L766.71434,157.32251L773.01909,157.16085L774.95902,158.45414L776.57562,158.6158L778.67721,157.32251L781.26378,156.19089L786.43691,155.70591L788.5385,153.92764L790.31676,150.69443L791.93337,148.75451L794.03495,148.75451L795.97488,147.62288L796.13654,145.35964L794.6816,143.25805L794.35828,141.80311L795.4899,139.70152L795.4899,138.24658L793.71163,138.24658L791.93337,137.43828L791.12507,136.30665L790.96341,133.72008L796.78318,128.22363L797.42982,127.41533L798.88477,124.50544L801.79466,119.97894L804.54289,116.26075L806.64447,113.83585L809.05957,112.01024L812.14093,110.7643L817.63738,109.47101L820.87059,109.63267L825.39709,108.17773L832.96228,106.10656L833.48207,111.08623L835.90699,117.55267L836.71529,122.72582L835.74533,126.60568L838.3319,131.13218L839.1402,133.23377L838.3319,136.14367L841.2418,137.43695L841.88844,137.76027L844.96,148.75321L844.42371,153.81288L843.93873,164.64415L844.74703,170.14062L845.55533,173.69716L847.01028,180.9719L847.01028,189.05494L845.87865,191.31819L847.71798,193.31098L848.51453,194.9894L846.57461,196.76767L846.89793,198.06095L848.19121,197.73763L849.64616,196.44435L851.9094,193.85778L853.04103,193.21114L854.65763,193.85778L856.92088,194.01944L864.84224,190.13959L867.75213,187.39136L869.04541,185.93642L873.24858,187.55302L869.85371,191.10955L865.97386,194.01944L858.8608,199.35423L856.27424,200.3242L850.45446,202.26412L846.41295,203.39575L845.23821,202.86282L844.99419,199.17429L845.47917,196.42605L845.31751,194.32447L842.504,192.62547L837.9775,191.6555L834.09764,190.52388L830.37944,188.7456Z"},
        {id:"PA",n:"Pennsylvania",d:"M825.1237,224.69205L826.43212,224.42105L828.76165,223.1678L829.97353,220.68473L831.59014,218.42148L834.82335,215.34992L834.82335,214.54162L832.39844,212.92502L828.8419,210.5001L827.87194,207.91353L825.1237,207.59021L824.96204,206.45858L824.15374,203.71035L826.417,202.57873L826.57866,200.15381L825.28536,198.86052L825.44702,197.24391L827.38696,194.17236L827.38696,191.1008L830.08459,188.45492L829.16431,187.77994L826.64023,187.58703L824.34574,185.64711L822.79582,179.53105L819.29124,179.63157L816.83601,176.92824L798.74502,181.12601L755.74324,189.8557L746.85189,191.31064L746.23122,184.78925L740.86869,189.8569L739.5754,190.34188L735.37311,193.35077L738.28387,212.48822L740.76553,222.21758L744.33733,241.47907L747.60664,240.84139L759.55022,239.33892L797.47685,231.67372L812.35306,228.8504L820.65341,227.22804L820.92052,226.98951L823.02212,225.37289L825.1237,224.69205Z"},
        {id:"NJ",n:"New Jersey",d:"M829.67942,188.46016L827.35687,191.19443L827.35687,194.26599L825.41693,197.33754L825.25527,198.95416L826.54857,200.24744L826.38691,202.67236L824.12365,203.80398L824.93195,206.55221L825.09361,207.68384L827.84185,208.00716L828.81181,210.59373L832.36835,213.01865L834.79326,214.63525L834.79326,215.44356L831.81005,218.14012L830.19344,220.40336L828.73849,223.1516L826.47524,224.44488L826.01279,226.04736L825.77029,227.25982L825.16106,229.86656L826.25333,232.11075L829.48654,235.02064L834.33635,237.28389L838.37786,237.93053L838.53952,239.38547L837.73122,240.35543L838.05454,243.10366L838.86284,243.10366L840.96443,240.67876L841.77273,235.82894L844.52096,231.78743L847.59251,225.32101L848.72413,219.82456L848.07749,218.69293L847.91583,209.31662L846.29922,205.92176L845.1676,206.73006L842.41937,207.05338L841.93439,206.5684L843.06602,205.59843L845.1676,203.65851L845.23066,202.56468L844.84627,199.13084L845.41964,196.3826L845.30217,194.41359L842.49463,192.66324L837.40249,191.48748L833.26505,190.10585L829.67942,188.46016Z"},
        {id:"DE",n:"Delaware",d:"M825.6261,228.2791L825.99441,226.13221L826.36948,224.44116L824.74648,224.83892L823.13102,225.30648L820.92476,227.07078L822.64488,232.11366L824.90814,237.77178L827.00972,247.47143L828.62634,253.77621L833.63782,253.61455L839.77994,252.43387L837.51571,245.0476L836.54574,245.53258L832.98921,243.10768L831.21095,238.41952L829.27102,234.86299L826.1239,231.99268L825.25974,229.89456L825.6261,228.2791Z"},
        {id:"MD",n:"Maryland",d:"M839.79175,252.41476L833.7832,253.6186L828.6403,253.73606L826.79674,246.81373L824.87193,237.64441L822.29931,231.45596L821.01093,227.05763L813.50491,228.67999L798.6287,231.50331L761.17727,239.05421L762.30857,244.06587L763.27853,249.72398L763.60185,249.40066L765.70345,246.97576L767.96669,244.3581L770.3916,243.74254L771.84656,242.28759L773.62482,239.70102L774.9181,240.34767L777.82799,240.02434L780.41457,237.92276L782.42146,236.46949L784.26669,235.98451L785.91104,237.11446L788.82093,238.5694L790.76085,240.34767L791.97331,241.88345L796.09566,243.58088L796.09566,246.49077L801.59212,247.78406L802.73656,248.32604L804.14846,246.29772L807.03043,248.26788L805.75226,250.74981L804.98699,254.73547L803.20873,257.32204L803.20873,259.42363L803.85537,261.2019L808.91932,262.55759L813.23042,262.49587L816.30196,263.46584L818.40355,263.78916L819.37351,261.68757L817.91857,259.58599L817.91857,257.80772L815.49366,255.70613L813.39208,250.20968L814.68536,244.87488L814.5237,242.7733L813.23042,241.48001C813.23042,241.48001,814.68536,239.86341,814.68536,239.21677C814.68536,238.57012,815.17034,237.11518,815.17034,237.11518L817.11027,235.8219L819.05019,234.20529L819.53517,235.17526L818.08023,236.79186L816.78695,240.51005L817.11027,241.64167L818.88853,241.96499L819.37351,247.46145L817.27193,248.43141L817.59525,251.98794L818.08023,251.82628L819.21185,249.88636L820.82846,251.66462L819.21185,252.95791L818.88853,256.35278L821.4751,259.74765L825.35495,260.23263L826.97156,259.42433L830.20811,263.60726L831.56646,264.14356L838.22013,261.34661L840.22771,257.32274L839.79175,252.41476ZM823.82217,261.44348L824.95379,263.94923L825.11545,265.7275L826.24708,267.5866C826.24708,267.5866,827.13622,266.69746,827.13622,266.37414C827.13622,266.05082,826.40875,263.30258,826.40875,263.30258L825.68127,260.95849L823.82217,261.44348Z"},
        {id:"VA",n:"Virginia",d:"M831.63885,266.06892L831.49494,264.12189L837.94837,261.57201L837.17796,264.78985L834.25801,268.56896L833.83992,273.15478L834.30167,276.54522L832.4737,281.52338L830.30943,283.43952L828.83909,278.79871L829.28498,273.3496L830.87198,269.16653L831.63885,266.06892ZM834.97904,294.37028L776.80486,306.94571L739.37789,312.22478L732.69956,311.8496L730.11431,313.77598L722.77518,313.99667L714.39307,314.97434L703.47811,316.58896L713.94754,310.97776L713.93442,308.90283L715.45447,306.7567L726.00825,295.25527L729.95497,299.73273L733.73798,300.69671L736.28144,299.55639L738.51866,298.24523L741.05527,299.58875L744.96944,298.16099L746.84617,293.60465L749.44709,294.14467L752.30233,292.01342L754.1016,292.50702L756.92881,288.83045L757.27706,286.74734L756.3134,285.47177L757.31617,283.60514L762.59044,271.32799L763.20721,265.59291L764.4361,265.06937L766.61463,267.51224L770.55049,267.21107L772.4797,259.63744L775.27369,259.07658L776.32344,256.33551L778.90326,253.98863L781.67509,248.29344L781.76002,243.22589L791.58153,247.04871C792.26238,247.38913,792.41441,241.99956,792.41441,241.99956L796.06697,243.59789L796.1353,246.53605L801.91955,247.83554L804.0525,249.01174L805.71242,251.06743L805.05787,254.7161L803.11043,257.30708L803.22028,259.36615L803.80924,261.21906L808.78799,262.48749L813.23926,262.52737L816.30809,263.48601L818.2516,263.79531L818.96641,266.88377L822.15685,267.2863L823.02492,268.48632L822.58543,273.1764L823.96016,274.27895L823.48121,276.20934L824.71062,276.99911L824.48882,278.38371L821.79483,278.28877L821.88379,279.90429L824.16478,281.44716L824.28632,282.85906L826.05943,284.64444L826.55122,287.16857L823.99818,288.54988L825.5704,290.04418L831.37142,288.35835L834.97904,294.37028Z"},
        {id:"WV",n:"West Virginia",d:"M761.18551,238.96731L762.29752,243.91184L763.38096,249.94317L765.51125,247.36283L767.77449,244.29127L770.31287,243.67572L771.76782,242.22078L773.54609,239.63421L774.99107,240.28085L777.90096,239.95753L780.48754,237.85594L782.49443,236.40268L784.33966,235.91769L785.64358,236.93416L789.28683,238.75579L791.22676,240.53406L792.60088,241.82734L791.83916,247.38228L786.00425,244.84106L781.759,243.21904L781.65786,248.39747L778.91022,253.9342L776.38019,256.36086L775.1881,259.11025L772.54452,259.61035L771.64668,263.21223L770.60345,267.1619L766.63521,267.50264L764.31148,265.06376L763.24033,265.62317L762.60765,271.09287L761.25736,274.62737L756.29896,285.58234L757.19565,286.74304L756.98979,288.65158L754.1811,292.53605L752.3726,291.99176L749.40455,294.1515L746.86217,293.57929L744.86294,298.13486C744.86294,298.13486,741.60363,299.56508,740.94003,299.50258C740.77952,299.48746,738.47093,298.25348,738.47093,298.25348L736.13441,299.63285L733.72461,300.67725L729.97992,299.78813L728.85852,298.61985L726.6663,295.59649L723.52371,293.60837L721.81214,289.98513L717.52726,286.51694L716.88061,284.25369L714.29404,282.79874L713.48573,281.18214L713.24324,275.92816L715.42566,275.84733L717.3656,275.03903L717.52726,272.2908L719.14386,270.83585L719.30552,265.82437L720.27548,261.94451L721.56877,261.29787L722.86205,262.42949L723.34704,264.20776L725.12531,263.23779L725.61029,261.62119L724.47867,259.84292L724.47867,257.41801L725.44863,256.12472L727.71188,252.72985L729.00516,251.27491L731.10676,251.75989L733.37,250.14327L736.44155,246.7484L738.70481,242.86854L739.02813,237.21043L739.51311,232.19894L739.51311,227.51078L738.38149,224.43923L739.35145,222.98427L740.63493,221.69099L744.12618,241.51811L748.75719,240.76696L761.18551,238.96731Z"},
        {id:"OH",n:"Ohio",d:"M735.32497,193.32832L729.23143,197.38167L725.35158,199.64492L721.95671,203.36311L717.9152,207.24296L714.68199,208.05126L711.7721,208.53624L706.27564,211.12281L704.17406,211.28447L700.77919,208.21292L695.60605,208.85957L693.01949,207.40462L690.63842,206.05379L685.74585,206.7572L675.56123,208.37381L664.35436,210.55854L665.64765,225.18882L667.42592,238.92999L670.01248,262.37079L670.5783,267.20196L674.70065,267.07294L677.12556,266.26463L680.48936,267.76777L682.55985,272.1326L687.69879,272.1155L689.59053,274.2342L691.3517,274.1689L693.89009,272.82744L696.39426,273.19894L701.81554,273.68162L703.54251,271.54894L705.88816,270.25566L707.95865,269.57481L708.60529,272.32305L710.38357,273.29301L713.85926,275.63708L716.04168,275.55626L717.3748,275.06378L717.55951,272.30225L719.14487,270.84729L719.24403,266.05457C719.24403,266.05457,720.26799,261.94551,720.26799,261.94551L721.56726,261.34423L722.88861,262.49197L723.42676,264.18899L725.14589,263.15157L725.58487,261.69082L724.46818,259.78776L724.53447,257.47333L725.28347,256.40102L727.43623,253.09454L728.48645,251.5512L730.58804,252.03618L732.85129,250.41957L735.92284,247.0247L738.69433,242.94597L739.01466,237.89046L739.49964,232.87897L739.32286,227.57209L738.36802,224.67731L738.71926,223.48753L740.52365,221.73742L738.23486,212.69009L735.32497,193.32832Z"},
        {id:"IN",n:"Indiana",d:"M619.56954,299.97132L619.63482,297.11274L620.11981,292.58623L622.38305,289.67635L624.16133,285.79648L626.74789,281.59331L626.26291,275.77352L624.48465,273.02529L624.16133,269.79208L624.96963,264.29561L624.48465,257.3442L623.19135,241.33979L621.89807,225.98203L620.9276,214.26201L623.99866,215.15152L625.45361,216.12148L626.58523,215.79816L628.68682,213.85824L631.51639,212.24125L636.60919,212.07921L658.59506,209.81595L664.17079,209.28279L665.67393,225.239L669.92528,262.08055L670.52374,267.85215L670.15224,270.1154L671.38022,271.91077L671.47661,273.28332L668.95532,274.88283L665.41589,276.43414L662.21376,276.98442L661.6153,281.85135L657.04061,285.16382L654.24419,289.17426L654.56751,291.55099L653.98617,293.08519L650.6597,293.08519L649.07417,291.46859L646.58086,292.73079L643.8979,294.23393L644.05957,297.28838L642.86578,297.54641L642.3979,296.52827L640.23102,295.02513L636.9807,296.36661L635.42939,299.37286L633.99155,298.56456L632.5366,296.96505L628.07226,297.45004L622.47943,298.42L619.56954,299.97132Z"},
        {id:"IL",n:"Illinois",d:"M619.54145,300.34244L619.5727,297.11273L620.14009,292.46677L622.47262,289.55091L624.33927,285.47515L626.57229,281.47982L626.20079,276.22742L624.19558,272.68485L624.0992,269.33817L624.79403,264.06866L623.96862,256.89029L622.90228,241.11284L621.609,226.0955L620.68672,214.4563L620.41421,213.53491L619.60591,210.94834L618.31263,207.23015L616.69602,205.45188L615.24108,202.86532L615.00751,197.37636L569.21108,199.97461L569.4397,202.34656L571.72593,203.03243L572.64041,204.17554L573.09766,206.00452L576.98424,209.43386L577.67012,211.72009L576.98424,215.14943L575.15526,218.80739L574.4694,221.32223L572.18317,223.15122L570.35419,223.83709L565.09587,225.20882L564.41,227.0378L563.72413,229.09541L564.41,230.46715L566.23898,232.06751L566.01036,236.18271L564.18137,237.78307L563.49551,239.38343L563.49551,242.1269L561.66653,242.58414L560.06617,243.72726L559.83755,245.099L560.06617,247.1566L558.3515,248.47117L557.3227,251.27181L557.77994,254.92976L560.06617,262.24569L567.3821,269.79024L572.86903,273.4482L572.64041,277.79203L573.55491,279.16377L579.95634,279.62101L582.69981,280.99275L582.01395,284.65071L579.72772,290.5949L579.04185,293.79562L581.32807,297.6822L587.72951,302.94052L592.30197,303.62639L594.35956,308.65609L596.41717,311.8568L595.50268,314.82889L597.10304,318.9441L598.93202,321.00171L600.34605,320.12102L601.25371,318.04623L603.46679,316.29903L605.59826,315.68463L608.20079,316.86443L611.82778,318.24013L613.01673,317.9419L613.2166,315.68345L611.9293,313.27166L612.23352,310.89494L614.07192,309.54749L617.09446,308.7372L618.35536,308.27868L617.74275,306.8918L616.95138,304.53743L618.38398,303.55647L619.54145,300.34244Z"},
        {id:"CT",n:"Connecticut",d:"M874.06831,178.86288L870.39088,163.98407L865.67206,164.90438L844.44328,169.64747L845.44347,172.87314L846.89842,180.14788L847.0752,189.1148L845.85518,191.28967L847.77597,193.22201L852.0475,189.31637L855.60403,186.08316L857.54395,183.98157L858.35226,184.62821L861.10048,183.17327L866.27362,182.04165L874.06831,178.86288Z"},
        {id:"WI",n:"Wisconsin",d:"M615.06589,197.36866L614.99915,194.21124L613.82004,189.68474L613.1734,183.54165L612.04178,181.11674L613.01174,178.04519L613.82004,175.1353L615.27499,172.54874L614.62834,169.15387L613.9817,165.59734L614.46668,163.81907L616.40661,161.39416L616.56827,158.64593L615.75997,157.35265L616.40661,154.76608L615.95409,150.59537L618.70232,144.93726L621.61221,138.14752L621.77387,135.88427L621.45055,134.91431L620.64224,135.39929L616.43907,141.70405L613.69084,145.74556L611.75092,147.52383L610.94262,149.78707L608.98767,150.59537L607.85605,152.5353L606.4011,152.21198L606.23944,150.43371L607.53273,148.00881L609.63431,143.32065L611.41258,141.70405L612.40341,139.3462L609.84296,137.44486L607.86814,127.07787L604.32067,125.73589L602.37441,123.42756L590.2447,120.70592L587.36881,119.69387L579.15569,117.52658L571.23777,116.36783L567.47261,111.23716L566.72221,111.79117L565.5243,111.62951L564.87765,110.49789L563.54364,110.79444L562.41201,110.9561L560.63375,111.92606L559.66378,111.27942L560.31043,109.33949L562.25035,106.26794L563.38197,105.13632L561.44205,103.68138L559.34046,104.48968L556.43057,106.4296L548.99419,109.66281L546.0843,110.30945L543.17442,109.82447L542.19269,108.94622L540.07599,111.7814L539.84737,114.52487L539.84737,122.9839L538.70425,124.58427L533.44593,128.47084L531.15971,134.41503L531.61695,134.64365L534.1318,136.70126L534.81766,139.90198L532.98868,143.10269L532.98868,146.98928L533.44593,153.61933L536.41802,156.59143L539.84737,156.59143L541.67635,159.79215L545.10568,160.24939L548.99227,165.96496L556.07957,170.08017L558.13717,172.82364L559.05167,180.25388L559.73753,183.5689L562.02376,185.16926L562.25238,186.541L560.19478,189.97033L560.4234,193.17106L562.93825,197.05764L565.4531,198.20075L568.42519,198.65799L569.76753,200.03811L615.06589,197.36866Z"},
        {id:"NC",n:"North Carolina",d:"M834.98153,294.31554L837.06653,299.23289L840.62306,305.69931L843.04796,308.12422L843.6946,310.38747L841.2697,310.54913L842.078,311.19577L841.75468,315.39894L839.16811,316.69222L838.52147,318.79381L837.22819,321.7037L833.50999,323.3203L831.08509,322.99698L829.63014,322.83532L828.01354,321.54204L828.33686,322.83532L828.33686,323.80529L830.27679,323.80529L831.08509,325.09857L829.14516,331.40333L833.34833,331.40333L833.99498,333.01993L836.25822,330.75669L837.55151,330.2717L835.61158,333.82823L832.54003,338.67805L831.24675,338.67805L830.11512,338.19307L827.3669,338.83971L822.19376,341.26462L815.72734,346.59941L812.33247,351.28756L810.39255,357.75398L809.90757,360.17889L805.21941,360.66387L799.76628,362.00053L789.81987,353.798L777.21033,346.19995L774.30044,345.39164L761.69091,346.84659L757.41445,347.59674L755.79785,344.36352L752.82749,342.24682L736.3381,342.7318L729.06336,343.5401L720.01037,348.06661L713.86726,350.65317L692.68971,353.23975L693.1898,349.18542L694.96807,347.73048L697.71631,347.08383L698.36295,343.36563L702.56613,340.61741L706.44598,339.16245L710.64917,335.60592L715.014,333.50433L715.66064,330.43277L719.5405,326.55292L720.18714,326.39126C720.18714,326.39126,720.18714,327.52289,720.99545,327.52289C721.80375,327.52289,722.93538,327.84621,722.93538,327.84621L725.19863,324.28967L727.30022,323.64302L729.56346,323.96635L731.18008,320.40982L734.08997,317.82324L734.57495,315.72165L734.76245,312.07346L739.03895,312.05094L746.23754,311.19515L761.99477,308.94272L777.13081,306.85615L798.77129,302.1368L818.75461,297.87823L829.93155,295.47242L834.98153,294.31554ZM839.25199,327.52211L841.83857,325.01636L844.99095,322.42978L846.52673,321.78314L846.68839,319.76238L846.04175,313.61926L844.5868,311.27518L843.94015,309.41608L844.66763,309.17358L847.41587,314.67006L847.82002,319.11573L847.65836,322.51062L844.26348,324.04639L841.43441,326.47131L840.30279,327.68377L839.25199,327.52211Z"},
        {id:"DC",n:"Washington DC",d:"M805.81945,250.84384L803.96117,249.01967L802.72854,248.33338L804.17155,246.31091L807.06064,248.25941L805.81945,250.84384Z"},
        {id:"MA",n:"Massachusets",d:"M899.62349,173.25394L901.79541,172.56806L902.25267,170.85339L903.28147,170.9677L904.31027,173.25394L903.05285,173.71118L899.16625,173.8255L899.62349,173.25394ZM890.24995,174.05412L892.53617,171.42495L894.13654,171.42495L895.96553,172.911L893.56499,173.9398L891.39307,174.9686L890.24995,174.05412ZM855.45082,152.06593L873.09769,147.42525L875.36095,146.77861L877.27503,143.9829L881.0118,142.31959L883.90104,146.73243L881.47613,151.90557L881.15281,153.36051L883.09274,155.94708L884.22436,155.13878L886.00263,155.13878L888.26587,157.72534L892.14573,163.70678L895.70226,164.19176L897.9655,163.2218L899.74377,161.44353L898.93546,158.69531L896.83388,157.0787L895.37893,157.887L894.40897,156.59372L894.89395,156.10874L896.99554,155.94708L898.7738,156.75538L900.71373,159.18029L901.68369,162.09018L902.00701,164.51508L897.80384,165.97003L893.92399,167.90995L890.04414,172.43645L888.10421,173.89139L888.10421,172.92143L890.52912,171.46648L891.0141,169.68822L890.2058,166.61667L887.29591,168.07161L886.48761,169.52656L886.97259,171.7898L884.90626,172.79023L882.15906,168.2631L878.76418,163.89826L876.69368,162.08579L870.16041,163.96199L865.06808,165.01278L844.39292,169.60499L843.72516,164.83714L844.3718,154.24837L848.66107,153.35923L855.45082,152.06593Z"},
        {id:"TN",n:"Tennessee",d:"M696.67788,318.25411L644.78479,323.2656L629.02523,325.04386L624.40403,325.55657L620.53568,325.52885L620.31471,329.62968L612.12933,329.89369L605.17792,330.54033L597.08709,330.41647L595.67331,337.48933L593.97708,342.96938L590.68391,345.72022L589.33517,350.10128L589.01185,352.68785L584.97033,354.95109L586.42527,358.50763L585.45531,362.87247L584.48693,363.66212L692.64548,353.25457L693.04875,349.29963L694.85948,347.80924L697.69363,347.05979L698.36556,343.34281L702.46416,340.63785L706.51109,339.14382L710.59467,335.57349L715.03076,333.54803L715.55202,330.48068L719.61662,326.49569L720.16742,326.38152C720.16742,326.38152,720.19867,327.51314,721.00697,327.51314C721.81527,327.51314,722.9469,327.86771,722.9469,327.86771L725.21015,324.27992L727.28049,323.63328L729.5556,323.92849L731.15391,320.39563L734.10916,317.75172L734.53084,315.81261L734.8398,312.10146L732.69325,311.90169L730.09157,313.93002L723.09826,313.95909L704.73897,316.34591L696.67788,318.25411Z"},
        {id:"AR",n:"Arkansas",d:"M593.82477,343.05296L589.84489,343.76966L584.73274,343.13563L585.15344,341.53356L588.13319,338.96687L589.07657,335.31062L587.24759,332.33852L508.83002,334.85337L510.43038,341.71206L510.43037,349.94248L511.80212,360.91647L512.03074,398.7534L514.31697,400.69669L517.28906,399.32496L520.03254,400.46807L520.71288,407.04137L576.33414,405.90077L577.47977,403.8104L577.19315,400.26089L575.36752,397.28879L576.96621,395.80358L575.36752,393.29208L576.05172,390.78225L577.42011,385.17682L579.9383,383.11419L579.25243,380.82963L582.9104,375.45784L585.65387,374.08945L585.54039,372.59587L585.19495,370.77023L588.0519,365.1715L590.45494,363.91491L590.83907,360.48728L592.60974,359.24558L589.46622,358.76131L588.12476,354.75087L590.92884,352.37416L591.4791,350.35496L592.75858,346.30835L593.82477,343.05296Z"},
        {id:"MO",n:"Missouri",d:"M558.44022,248.11316L555.92035,245.02591L554.77723,242.73968L490.42,245.14022L488.13374,245.25453L489.39117,247.76938L489.16255,250.0556L491.67739,253.94219L494.76379,258.0574L497.8502,260.80087L500.01143,261.02949L501.50816,261.94399L501.50816,264.91608L499.67919,266.51644L499.22193,268.80266L501.27954,272.23201L503.7944,275.2041L506.30924,277.03308L507.68097,288.69283L507.99511,324.76504L508.22373,329.45179L508.68097,334.8353L531.11396,333.96848L554.31999,333.28261L575.12465,332.4816L586.77939,332.2513L588.94879,335.6773L588.2646,338.9848L585.17735,341.38784L584.60496,343.22518L589.98345,343.68244L593.87841,342.99656L595.59559,337.50293L596.24701,331.64614L598.34504,329.09098L600.94107,327.60409L600.9925,324.55385L602.00852,322.61737L600.31429,320.0736L598.98336,321.05786L596.99074,318.83062L595.70571,314.07162L596.50672,311.55342L594.56259,308.12576L592.73195,303.54996L587.93254,302.75062L580.96374,297.15187L579.24488,293.03834L580.04423,289.83762L582.1035,283.77995L582.56242,280.91632L580.61328,279.88501L573.75794,279.08734L572.72997,277.37518L572.61817,273.14482L567.13123,269.71381L560.15572,261.94231L557.8695,254.62638L557.63921,250.40106L558.44022,248.11316Z"},
        {id:"GA",n:"Georgia",d:"M672.29229,355.5518L672.29229,357.73422L672.45395,359.83582L673.10059,363.23069L676.49547,371.15206L678.92038,381.01337L680.37532,387.15648L681.99193,392.00629L683.44688,398.9577L685.54847,405.26247L688.13504,408.65735L688.62002,412.05222L690.55995,412.86052L690.72161,414.96212L688.94334,419.81193L688.45836,423.04515L688.2967,424.98508L689.91331,429.34992L690.23663,434.68472L689.42832,437.10963L690.07497,437.91794L691.52992,438.72624L691.73462,441.94433L693.96763,445.29386L696.21807,447.45591L704.13945,447.61757L714.9592,446.97093L736.47159,445.67765L741.91731,445.00328L746.49456,445.03101L746.65622,447.9409L749.24279,448.7492L749.56611,444.38436L747.9495,439.85786L749.08113,438.24126L754.90091,439.04956L759.87832,439.36734L759.1029,433.06855L761.36614,423.0456L762.82109,418.84242L762.3361,416.25586L765.67051,410.01156L765.16021,408.65988L763.2468,409.36446L760.66024,408.07116L760.01359,405.96957L758.72031,402.41304L756.45705,400.31145L753.87049,399.66481L752.25388,394.81499L749.32887,388.47999L745.1257,386.54006L743.0241,384.60013L741.73081,382.01356L739.62923,380.07363L737.36598,378.78034L735.10273,375.87045L732.03118,373.60721L727.50467,371.82893L727.01969,370.37399L724.59478,367.4641L724.1098,366.00915L720.71492,361.03867L717.19505,361.13784L713.44014,358.7817L712.02186,357.48842L711.69854,355.71015L712.56934,353.77023L714.79598,352.66009L714.16204,350.56287L672.29229,355.5518Z"},
        {id:"SC",n:"South Carolina",d:"M764.94328,408.16488L763.16622,409.13438L760.57965,407.84109L759.93301,405.7395L758.63973,402.18297L756.37647,400.08137L753.7899,399.43473L752.1733,394.58492L749.42506,388.60347L745.22189,386.66353L743.12029,384.72361L741.82701,382.13704L739.72542,380.1971L737.46217,378.90382L735.19892,375.99393L732.12737,373.73069L727.60086,371.95241L727.11588,370.49747L724.69098,367.58758L724.20599,366.13262L720.81111,360.95949L717.41624,361.12115L713.37472,358.69623L712.08144,357.40295L711.75812,355.62468L712.56642,353.68476L714.82967,352.71478L714.31885,350.4257L720.08695,348.08913L729.20245,343.50013L736.97718,342.69182L753.09158,342.26934L755.72983,344.14677L757.40893,347.50499L761.71128,346.89501L774.32081,345.44005L777.2307,346.24836L789.84024,353.84642L799.94832,361.9681L794.52715,367.42644L791.94058,373.56954L791.4556,379.8743L789.839,380.6826L788.70737,383.43083L786.28247,384.07747L784.18088,387.634L781.43265,390.38223L779.16941,393.7771L777.5528,394.5854L773.99627,397.98027L771.08638,398.14193L772.05635,401.37514L767.04487,406.8716L764.94328,408.16488Z"},
        {id:"KY",n:"Kentucky",d:"M725.9944,295.2707L723.70108,297.67238L720.12289,301.66642L715.19834,307.13109L713.98257,308.84686L713.92007,310.94844L709.54021,313.11253L703.88209,316.50741L696.65022,318.30626L644.78233,323.20512L629.02277,324.98338L624.40157,325.49609L620.53322,325.46837L620.30627,329.68865L612.12686,329.83321L605.17545,330.47985L597.18797,330.41963L598.39575,329.09955L600.89529,327.5587L601.12392,324.35797L602.03841,322.52899L600.43159,319.99009L601.23342,318.08328L603.49668,316.30502L605.59826,315.65837L608.34649,316.95166L611.90303,318.24494L613.03466,317.92162L613.19632,315.65837L611.90303,313.23346L612.22635,310.97021L614.16628,309.51527L616.75286,308.86862L618.36946,308.22198L617.56116,306.44371L616.91452,304.50378L618.42114,303.50798C618.42442,303.47086,619.6751,299.98569,619.65943,299.85017L622.71265,298.37149L628.03244,297.40153L632.52648,296.91655L633.91892,298.54398L635.44719,299.41478L637.03796,296.30657L640.22504,295.02395L642.43013,296.50798L642.84069,297.50702L644.01421,297.24301L643.85254,294.29008L646.98341,292.54089L649.1315,291.46741L650.66086,293.12822L653.97901,293.08402L654.56634,291.51277L654.19883,289.24953L656.79936,285.25103L661.57591,281.81313L662.28186,276.97727L665.20688,276.52136L668.99834,274.87568L671.44166,273.16744L671.24333,271.60251L670.10088,270.14757L670.6667,267.15266L674.85155,267.03516L677.15146,266.28936L680.49885,267.71846L682.55296,272.0833L687.68525,272.09412L689.73626,274.30231L691.35171,274.15461L693.9534,272.87644L699.19046,273.44981L701.76538,273.66732L703.45296,271.61108L706.07091,270.1852L707.95269,269.4781L708.59933,272.31473L710.64276,273.37307L713.28552,275.45556L713.40299,281.1288L714.21129,282.70121L716.80101,284.25749L717.57265,286.552L721.73254,289.98894L723.53785,293.61218L725.9944,295.2707Z"},
        {id:"AL",n:"Alabama",d:"M631.30647,460.41572L629.81587,446.09422L627.06763,427.34158L627.22929,413.27709L628.03759,382.23824L627.87593,365.58718L628.04102,359.16812L672.5255,355.54867L672.3777,357.73109L672.53936,359.83269L673.18601,363.22756L676.58089,371.14893L679.00579,381.01024L680.46074,387.15335L682.07734,392.00317L683.5323,398.95458L685.63388,405.25934L688.22045,408.65423L688.70543,412.04909L690.64537,412.8574L690.80703,414.95899L689.02875,419.80881L688.54377,423.04203L688.38211,424.98195L689.99873,429.3468L690.32205,434.68159L689.51373,437.10651L690.16039,437.91481L691.61533,438.72311L691.94347,441.61193L686.34581,441.25838L679.55606,441.90503L654.01366,444.81491L643.6021,446.22168L643.38072,449.09908L645.15899,450.87735L647.74556,452.81727L648.32642,460.75271L642.78436,463.32561L640.03614,463.00229L642.78436,461.06236L642.78436,460.0924L639.71282,454.11096L637.44957,453.46432L635.99462,457.82915L634.70134,460.57738L634.0547,460.41572L631.30647,460.41572Z"},
        {id:"LS",n:"Louisiana",d:"M607.96706,459.16125L604.68245,455.99511L605.69236,450.49488L605.03101,449.6018L595.76934,450.60836L570.74102,451.06728L570.05683,448.6726L570.96964,440.2169L574.28552,434.27105L579.31688,425.58003L578.74281,423.18201L579.9994,422.50116L580.45833,420.54867L578.17209,418.49274L578.0603,416.55029L576.22964,412.20478L576.08259,405.86618L520.6088,406.79015L520.63737,416.36372L521.32324,425.73725L522.00911,429.62383L524.52396,433.73904L525.43845,438.76875L529.78228,444.25568L530.0109,447.4564L530.69677,448.14227L530.0109,456.60131L527.03881,461.631L528.63917,463.68861L527.95329,466.20345L527.26743,473.51938L525.89569,476.72009L526.01815,480.33654L530.70463,478.81639L542.81798,479.0234L553.16425,482.57993L559.63067,483.71156L563.34886,482.25661L566.58207,483.38824L569.81528,484.3582L570.62358,482.25661L567.39037,481.12499L564.8038,481.60997L562.05557,479.99337C562.05557,479.99337,562.21724,478.70008,562.86388,478.53842C563.51052,478.37676,565.93543,477.56846,565.93543,477.56846L567.71369,479.0234L569.49196,478.05344L572.72517,478.70008L574.18011,481.12499L574.50343,483.38824L579.02992,483.71156L580.80819,485.48982L579.99989,487.10643L578.7066,487.91473L580.32321,489.53133L588.72955,493.08786L592.28608,491.79458L593.25605,489.36967L595.84261,488.72303L597.62088,487.26809L598.91416,488.23805L599.72246,491.14794L597.45922,491.95624L598.10586,492.60288L601.50073,491.3096L603.76398,487.91473L604.57228,487.42975L602.47069,487.10643L603.27899,485.48982L603.11733,484.03488L605.21892,483.5499L606.35054,482.25661L606.99718,483.06491C606.99718,483.06491,606.83552,486.13646,607.64383,486.13646C608.45213,486.13646,611.847,486.78311,611.847,486.78311L615.88851,488.72303L616.85847,490.17798L619.76836,490.17798L620.89999,491.14794L623.16323,488.07639L623.16323,486.62144L621.86995,486.62144L618.47508,483.87322L612.6553,483.06491L609.42209,480.80167L610.55372,478.05344L612.81696,478.37676L612.97862,477.73012L611.20036,476.76016L611.20036,476.27517L614.43357,476.27517L616.21183,473.20363L614.91855,471.2637L614.59523,468.51547L613.14028,468.67713L611.20036,470.77872L610.55372,473.36529L607.48217,472.71864L606.5122,470.94038L608.29047,469.00045L610.1938,465.55485L609.1327,463.14258L607.96706,459.16125Z"},
        {id:"MS",n:"Mississippi",d:"M631.55882,459.34458L631.30456,460.60073L626.13142,460.60073L624.67648,459.79243L622.57489,459.46911L615.78515,461.40903L614.00689,460.60073L611.42032,464.8039L610.31778,465.58192L609.19395,463.09394L608.05083,459.20735L604.6215,456.00664L605.7646,450.46209L605.07874,449.5476L603.24976,449.77622L595.33184,450.64959L570.78534,451.02296L570.0156,448.7976L570.88897,440.4208L574.00581,434.74799L579.23288,425.60309L578.78714,423.17049L580.024,422.51424L580.45987,420.59477L578.14239,418.51579L578.02727,416.37431L576.19155,412.25322L576.08255,406.29045L577.41008,403.80948L577.18678,400.39373L575.41729,397.31114L576.94371,395.82893L575.3731,393.32939L575.83035,391.67718L577.40775,385.15081L579.8937,383.11446L579.25203,380.74749L582.91,375.44496L585.74186,374.08854L585.52089,372.41338L585.23276,370.73228L588.10882,365.16461L590.45454,363.9331L590.60617,363.04009L627.94965,359.15892L628.13451,365.44225L628.29617,382.09331L627.48787,413.13216L627.32621,427.19665L630.07445,445.94929L631.55882,459.34458Z"},
        {id:"IA",n:"Iowa",d:"M569.19154,199.5843L569.45592,202.3705L571.67964,202.94776L572.63358,204.17309L573.13359,206.02845L576.92643,209.3871L577.6123,211.7786L576.93796,215.20307L575.35565,218.43505L574.55631,221.17684L572.38356,222.77888L570.66805,223.35128L565.08903,225.21148L563.69757,229.06017L564.42621,230.43191L566.26672,232.1145L565.98379,236.15079L564.22064,237.68865L563.44923,239.33179L563.57645,242.10811L561.69014,242.56535L560.06469,243.67026L559.7859,245.02289L560.06469,247.13781L558.51367,248.25388L556.04314,245.1206L554.78057,242.67073L489.04475,245.18558L488.12672,245.35102L486.07432,240.83506L485.8457,234.20499L484.24534,230.08978L483.55948,224.83147L481.27325,221.1735L480.35877,216.37243L477.61529,208.82788L476.47218,203.45524L475.10044,201.28333L473.50008,198.53987L475.45406,193.69604L476.8258,187.98047L474.08233,185.92286L473.62508,183.17939L474.53958,180.66454L476.25425,180.66454L558.90825,179.39506L559.74251,183.57818L561.99469,185.13915L562.2514,186.56224L560.22186,189.95155L560.41227,193.15707L562.92713,196.95527L565.45392,198.24889L568.5332,198.75194L569.19154,199.5843Z"},
        {id:"MN",n:"Minnesota",d:"M475.23781,128.82439L474.78056,120.36535L472.95158,113.04943L471.1226,99.560705L470.66535,89.729927L468.83637,86.300584L467.23601,81.270889L467.23601,70.982869L467.92187,67.096282L466.10094,61.644615L496.23336,61.679886L496.55668,53.435202L497.20332,53.273541L499.46657,53.758523L501.40649,54.566825L502.21479,60.063281L503.66974,66.206379L505.28634,67.822984L510.13616,67.822984L510.45948,69.277928L516.76424,69.601249L516.76424,71.702835L521.61405,71.702835L521.93737,70.409551L523.06899,69.277928L525.33224,68.631286L526.62552,69.601249L529.53541,69.601249L533.41526,72.187816L538.75006,74.612723L541.17497,75.097705L541.65995,74.127742L543.11489,73.64276L543.59987,76.552649L546.18644,77.845933L546.67142,77.360951L547.96471,77.522612L547.96471,79.624198L550.55127,80.594161L553.62282,80.594161L555.23943,79.785858L558.47264,76.552649L561.0592,76.067668L561.86751,77.845933L562.35249,79.139216L563.32245,79.139216L564.29241,78.330914L573.18374,78.007593L574.962,81.079142L575.60865,81.079142L576.32226,79.994863L580.76217,79.624198L580.15007,81.903657L576.21135,83.740782L566.96557,87.80191L562.19083,89.808807L559.11928,92.395375L556.69437,95.951905L554.43113,99.831756L552.65286,100.64006L548.12637,105.65153L546.83308,105.81319L542.5053,108.57031L540.04242,111.77542L539.8138,114.96681L539.90816,123.01016L538.53212,124.69891L533.45058,128.45888L531.2205,134.44129L534.09225,136.675L534.77214,139.90198L532.9169,143.14091L533.08769,146.88893L533.45655,153.61933L536.4848,156.62132L539.8138,156.62132L541.70491,159.75392L545.08408,160.25719L548.94324,165.92866L556.03053,170.04541L558.17368,172.92053L558.84483,179.36004L477.63333,180.50483L477.29541,144.82798L476.83817,141.85589L472.72296,138.42655L471.57984,136.59757L471.57984,134.9972L473.63744,133.39685L475.00918,132.02511L475.23781,128.82439Z"},
        {id:"OK",n:"Oklahoma",d:"M380.34313,320.82146L363.65895,319.54815L362.77873,330.50058L383.24411,331.65746L415.29966,332.96106L412.96506,357.37971L412.50781,375.21228L412.73644,376.81264L417.08027,380.4706L419.13787,381.61371L419.82374,381.38509L420.50961,379.32748L421.88135,381.15647L423.93895,381.15647L423.93895,379.78473L426.68242,381.15647L426.22518,385.04305L430.34039,385.27167L432.85523,386.41479L436.97044,387.10066L439.48529,388.92964L441.77152,386.87204L445.20086,387.5579L447.71571,390.98724L448.63019,390.98724L448.63019,393.27347L450.91642,393.95933L453.20264,391.67311L455.03163,392.35897L457.54647,392.35897L458.46097,394.87383L464.76204,396.9528L466.13378,396.26694L467.96276,392.15173L469.10587,392.15173L470.24899,394.20933L474.3642,394.8952L478.02215,396.26694L480.99425,397.18143L482.82324,396.26694L483.5091,393.75209L487.85293,393.75209L489.91053,394.66658L492.654,392.60897L493.79712,392.60897L494.48299,394.20933L498.59819,394.20933L500.19855,392.15173L502.02754,392.60897L504.08514,395.12383L507.28585,396.9528L510.48658,397.8673L512.42766,398.98623L512.03856,361.76922L510.66681,350.79524L510.50635,341.9229L509.06646,335.38517L508.28826,328.20553L508.22012,324.38931L496.08328,324.70805L449.67324,324.25081L404.63433,322.19319L380.34313,320.82146Z"},
        {id:"TX",n:"Texas",d:"M361.46423,330.57358L384.15502,331.65952L415.24771,332.80264L412.9131,356.25844L412.61634,374.41196L412.68448,376.49375L417.02831,380.31218L419.01496,381.75934L420.19917,381.19965L420.57254,379.38193L421.71286,381.18555L423.8245,381.22948L423.82183,379.78239L425.49177,380.74966L426.63047,381.15853L426.2712,385.12618L430.35939,385.21969L433.28471,386.41686L437.23945,386.94224L439.62083,389.02122L441.74493,386.94505L445.46987,387.55996L447.69078,390.7849L448.76574,391.10586L448.60527,393.07113L450.81888,393.86342L453.14903,391.80862L455.28205,392.42354L457.51143,392.45902L458.4445,394.89446L464.77259,397.00891L466.36564,396.24198L467.85511,392.06427L468.19583,392.06427L469.10232,392.14591L470.33137,394.21454L474.26125,394.87982L477.59825,396.0027L481.02388,397.19867L482.86446,396.22367L483.57822,393.70883L488.03144,393.75303L489.84018,394.68381L492.63943,392.5773L493.74307,392.6215L494.59411,394.22657L498.64883,394.22657L500.1677,392.19795L502.03507,392.60519L503.9811,395.00847L507.50167,397.05262L510.36043,397.86243L511.87405,398.66227L514.32075,400.65959L517.36379,399.3318L520.05488,400.47068L520.61869,406.57662L520.57893,416.27879L521.26479,425.8128L521.96697,429.41791L524.6423,433.83777L525.54048,438.7885L529.75643,444.32652L529.95245,447.47146L530.69882,448.2573L529.96875,456.63737L527.09665,461.64387L528.62962,463.79674L527.99954,466.13482L527.32997,473.53914L525.82565,476.87714L526.12053,480.37949L520.45565,481.96467L510.59436,486.49117L509.6244,488.43109L507.03783,490.37102L504.93625,491.82596L503.64296,492.63426L497.98485,497.96906L495.23662,500.07065L489.90182,503.30385L484.24371,505.72876L477.93895,509.12363L476.16069,510.57858L470.34091,514.13511L466.94604,514.78175L463.06619,520.2782L459.02468,520.60153L458.05471,522.54145L460.31796,524.48138L458.86301,529.97783L457.56973,534.50433L456.43811,538.38418L455.62981,542.91067L456.43811,545.33558L458.21637,552.28698L459.18634,558.43007L460.9646,561.1783L459.99464,562.63325L456.92309,564.57317L451.26497,560.69332L445.76852,559.5617L444.47523,560.04668L441.24202,559.40004L437.03885,556.32849L431.86572,555.19687L424.26767,551.802L422.16609,547.92214L420.8728,541.45573L417.6396,539.5158L416.99295,537.25255L417.6396,536.60591L417.96292,533.21104L416.66963,532.5644L416.02299,531.59444L417.31627,527.2296L415.69967,524.96636L412.46646,523.67307L409.07159,519.30824L405.51506,512.68016L401.31189,510.09359L401.47355,508.15367L396.13875,495.86747L395.33045,491.6643L393.55219,489.72438L393.39053,488.26943L387.40909,482.93464L384.82252,479.86309L384.82252,478.73146L382.23595,476.62988L375.44621,475.49825L368.00983,474.85161L364.93828,472.58837L360.41179,474.36663L356.85526,475.82158L354.59201,479.05478L353.62205,482.77298L349.25722,488.91607L346.83231,491.34098L344.24574,490.37102L342.46748,489.23939L340.52755,488.59275L336.6477,486.32951L336.6477,485.68286L334.86944,483.74294L329.6963,481.64135L322.25992,473.88165L319.99667,469.1935L319.99667,461.11047L316.76346,454.64405L316.27848,451.89583L314.66188,450.92586L313.53025,448.82428L308.51878,446.72269L307.2255,445.10609L300.11243,437.18472L298.81915,433.95151L294.13099,431.68826L292.67604,427.32339L290.08945,424.41352L288.14954,423.92856L287.50031,419.25092L295.50218,419.93681L324.53717,422.68026L353.57225,424.28062L355.80578,404.8188L359.69233,349.26378L361.29272,330.51646L362.66446,330.54504M461.69381,560.20778L461.128,553.0947L458.37976,545.90078L457.81394,538.86853L459.34972,530.62382L462.66378,523.75323L466.13948,518.33758L469.29188,514.78103L469.93852,515.02353L465.16952,521.65163L460.80468,528.19891L458.78391,534.827L458.46059,540.00016L459.34972,546.14328L461.9363,553.3372L462.42128,558.51034L462.58294,559.9653L461.69381,560.20778Z"},
        {id:"NM",n:"New Mexico",d:"M288.15255,424.01315L287.37714,419.26505L296.02092,419.79045L326.19268,422.73635L353.46084,424.42624L355.67611,405.71877L359.53347,349.8428L361.27115,330.45357L362.84285,330.58213L363.66825,319.41874L259.6638,308.78279L242.16645,429.2176L257.62712,431.20675L258.9204,421.1838L288.15255,424.01315Z"},
        {id:"KS",n:"Kansas",d:"M507.88059,324.38028L495.26233,324.58471L449.17324,324.12748L404.61576,322.06985L379.98602,320.81244L383.87981,256.21747L405.96327,256.89264L446.2524,257.73404L490.55364,258.72162L495.64927,258.72162L497.83367,260.88402L499.85133,260.86264L501.49163,261.87511L501.42913,264.88434L499.60015,266.60971L499.2679,268.84188L501.11098,272.24421L504.06334,275.43927L506.39069,277.05373L507.69146,288.29455L507.88059,324.38028Z"},
        {id:"NE",n:"Nebraska",d:"M486.09787,240.70058L489.32848,247.72049L489.19985,250.02301L492.65907,255.51689L495.37836,258.66923L490.32888,258.66923L446.84632,257.73055L406.05946,256.84025L383.80724,256.05638L384.88001,234.72853L352.56177,231.80828L356.9056,187.79842L372.45193,188.82723L392.57072,189.97033L410.40329,191.11345L434.18005,192.25656L444.92531,191.79932L446.98291,194.08554L451.78399,197.05764L452.9271,197.97213L457.27093,196.60039L461.15752,196.14315L463.90099,195.91452L465.72997,197.28626L469.7874,198.88662L472.75949,200.48698L473.21674,202.08734L474.13123,204.14494L475.96021,204.14494L476.75819,204.19111L477.65242,208.87293L480.57268,217.34085L481.14521,221.09756L483.6687,224.87181L484.23829,229.98595L485.84553,234.22632L486.09787,240.70058Z"},
        {id:"SD",n:"South Dakota",d:"M476.44687,204.02465L476.39942,203.44378L473.50371,198.59834L475.36394,193.88623L476.85667,187.99969L474.0748,185.91998L473.68964,183.17652L474.48204,180.62217L477.67055,180.63738L477.54747,175.63124L477.21417,145.45699L476.59644,141.68941L472.52412,138.35848L471.54149,136.68152L471.47899,135.0727L473.50111,133.5433L475.03333,131.87763L475.27829,129.22084L417.0212,127.62049L362.22199,124.1714L356.89672,187.86259L371.48699,188.76639L391.43684,189.972L409.17989,190.90059L432.95665,192.20417L444.93935,191.77953L446.90565,194.02471L452.10029,197.27806L452.86418,198.00081L457.40562,196.548L463.94616,195.93309L465.62146,197.26936L469.82597,198.86549L472.77103,200.50132L473.17001,201.98513L474.2095,204.22601L476.44687,204.02465Z"},
        {id:"ND",n:"North Dakota",d:"M475.30528,128.91846L474.69037,120.48479L473.01342,113.66887L471.12193,100.64465L470.66469,89.657624L468.92523,86.580482L467.16862,81.386086L467.19987,70.941816L467.82323,67.117729L465.98913,61.649968L437.34688,61.085941L418.75593,60.439299L392.24361,59.146015L369.29727,57.012146L362.30403,124.18898L417.23627,127.53263L475.30528,128.91846Z"},
        {id:"WY",n:"Wyoming",d:"M360.37668,143.27587L253.63408,129.81881L239.5506,218.27684L352.81521,231.86233L360.37668,143.27587Z"},
        {id:"MT",n:"Montana",d:"M369.20952,56.969133L338.5352,54.1613L309.27465,50.60477L280.01411,46.563258L247.68201,41.228463L229.25272,37.833593L196.52907,30.900857L192.05005,52.248389L195.47939,59.79293L194.10765,64.365382L195.93663,68.937833L199.13736,70.309572L203.75818,81.079025L206.45328,84.255548L206.91052,85.398666L210.33986,86.541784L210.79711,88.599377L203.70981,106.20333L203.70981,108.71818L206.22466,111.91889L207.13914,111.91889L211.94021,108.9468L212.62609,107.80368L214.22645,108.48955L213.99782,113.74787L216.7413,126.32212L219.71339,128.83696L220.62787,129.52283L222.45686,131.80905L221.99961,135.2384L222.68548,138.66773L223.8286,139.58223L226.11482,137.296L228.85829,137.296L232.05901,138.89636L234.57386,137.98187L238.68907,137.98187L242.34702,139.58223L245.0905,139.12498L245.54774,136.15288L248.51983,135.46702L249.89157,136.83876L250.34882,140.03947L251.77469,140.87411L253.66164,129.83937L360.40731,143.26829L369.20952,56.969133Z"},
        {id:"CO",n:"Colarado",d:"M380.03242,320.96457L384.93566,234.63961L271.5471,221.99565L259.33328,309.93481L380.03242,320.96457Z"},
        {id:"ID",n:"Idaho",d:"M148.47881,176.48395L157.24968,141.26323L158.62142,137.03371L161.13626,131.08953L159.87884,128.8033L157.36398,128.91761L156.56381,127.88881L157.02106,126.7457L157.36398,123.65929L161.82213,118.17234L163.65111,117.7151L164.79422,116.57199L165.36578,113.37127L166.28026,112.68541L170.16685,106.85553L174.05344,102.5117L174.28206,98.739432L170.85272,96.110269L169.31717,91.709286L182.94208,28.367595L196.45967,30.895706L192.05159,52.278719L195.61194,59.764071L194.03083,64.424911L196.00068,69.066144L199.1389,70.321335L202.97424,79.877923L206.48693,84.315077L206.99418,85.458195L210.33513,86.601313L210.70398,88.698388L203.73297,106.07448L203.56779,108.64041L206.19891,111.96211L207.10399,111.91321L212.01528,108.88761L212.6927,107.79264L214.25501,108.4515L213.97657,113.80522L216.71582,126.38793L220.63365,129.56584L222.31483,131.73129L221.59822,135.81515L222.66444,138.62256L223.72607,139.71384L226.20536,137.36242L229.05352,137.41131L231.97277,138.74651L234.75279,138.06458L238.54705,137.9041L242.52595,139.50446L245.26943,139.2077L245.76617,136.17039L248.69876,135.40556L249.95893,136.92147L250.39986,139.86643L251.8242,141.07964L243.4382,194.6883C243.4382,194.6883,155.47221,177.98769,148.47881,176.48395Z"},
        {id:"UT",n:"Utah",d:"M259.49836,310.10509L175.74933,298.23284L196.33694,185.69149L243.11725,194.43663L241.63245,205.06705L239.32083,218.23971L247.12852,219.16808L263.53504,220.97287L271.74601,221.82851L259.49836,310.10509Z"},
        {id:"AZ",n:"Arizona",d:"M144.9112,382.62909L142.28419,384.78742L141.96087,386.24237L142.44585,387.21233L161.36012,397.88192L173.48466,405.47996L188.19576,414.04797L205.00845,424.07092L217.29465,426.49583L242.24581,429.20074L259.50142,310.07367L175.76579,298.15642L172.6734,314.56888L171.06711,314.58419L169.35244,317.21335L166.83759,317.09903L165.58017,314.35556L162.8367,314.01263L161.9222,312.86952L161.00772,312.86952L160.09322,313.44108L158.14993,314.46988L158.03563,321.44286L157.80699,323.15753L157.23545,335.73177L155.7494,337.90368L155.17784,341.21871L157.92131,346.1341L159.17873,351.96398L159.97892,352.99278L161.00772,353.56434L160.8934,355.85056L159.29305,357.22229L155.86371,358.93696L153.92042,360.88026L152.43437,364.53821L151.86281,369.4536L149.00503,372.19707L146.94743,372.88294L147.08312,373.71282L146.62587,375.42749L147.08312,376.22767L150.74108,376.79921L150.16952,379.54269L148.68347,381.7146L144.9112,382.62909Z"},
        {id:"NV",n:"Nevada",d:"M196.39273,185.57552L172.75382,314.39827L170.92158,314.74742L169.34882,317.1536L166.97588,317.16429L165.50393,314.42082L162.88546,314.0424L162.11454,312.93477L161.07671,312.88073L158.29834,314.52502L157.98808,321.3105L157.62599,327.08767L157.27742,335.68048L155.83032,337.76964L153.3914,336.69561L84.311514,232.49442L103.30063,164.90951L196.39273,185.57552Z"},
        {id:"OR",n:"Oregon",d:"M148.72184,175.53153L157.57154,140.73002L158.62233,136.5005L160.9767,130.87727L160.36119,129.71439L157.84633,129.66821L156.56473,127.99751L157.02197,126.53344L157.52538,123.28656L161.98353,117.79961L163.81251,116.70046L164.95562,115.55735L166.44166,111.99172L170.48872,106.32232L174.05435,102.45992L174.28297,99.008606L171.01411,96.539924L169.2307,91.897299L156.56693,88.285329L141.47784,84.741679L126.04582,84.855985L125.58858,83.484256L120.10163,85.54186L115.64349,84.970301L113.24295,83.36994L111.98553,84.055815L107.29877,83.827183L105.5841,82.455454L100.32578,80.39785L99.525598,80.512166L95.181768,79.02611L93.238477,80.855093L87.065665,80.512166L81.121482,76.396957L81.807347,75.596777L82.035968,67.823604L79.749743,63.937027L75.634535,63.365468L74.94867,60.850621L72.594738,60.384056L66.796213,62.44284L64.532966,68.909258L61.299757,78.932207L58.066547,85.398626L53.055073,99.463087L46.588654,113.04256L38.505631,125.65208L36.565705,128.56197L35.757403,137.12997L36.143498,149.2102L148.72184,175.53153Z"},
        {id:"WA",n:"Washington",d:"M102.07324,7.6117734L106.43807,9.0667177L116.1377,11.814946L124.7057,13.754871L144.7516,19.412988L167.70739,25.071104L182.93051,28.278277L169.29815,91.864088L156.85315,88.33877L141.34514,84.768091L126.11585,84.801329L125.66028,83.45663L120.06106,85.635923L115.46563,84.899179L113.31866,83.315125L112.00545,83.973101L107.26979,83.832858L105.57143,82.483225L100.30839,80.370922L99.573419,80.51784L95.184297,78.993392L93.290999,80.810771L87.025093,80.512038L81.099395,76.386336L81.878352,75.453573L81.999575,67.776121L79.717576,63.93642L75.602368,63.32938L74.924958,60.818764L72.649446,60.361832L69.094498,61.592408L66.831251,58.373161L67.154572,55.463272L69.9028,55.139951L71.519405,51.09844L68.932837,49.966816L69.094498,46.248625L73.459331,45.601984L70.711103,42.853756L69.256158,35.740695L69.9028,32.830807L69.9028,24.909444L68.124535,21.676234L70.387782,12.299927L72.489368,12.784908L74.914275,15.694797L77.662503,18.281364L80.895712,20.22129L85.422205,22.322876L88.493756,22.969518L91.403645,24.424462L94.798518,25.394425L97.061764,25.232765L97.061764,22.807857L98.355048,21.676234L100.45663,20.38295L100.77996,21.514574L101.10328,23.292839L98.840029,23.77782L98.516708,25.879406L100.29497,27.334351L101.4266,29.759258L102.07324,31.699183L103.52818,31.537523L103.68984,30.244239L102.71988,28.950955L102.2349,25.717746L103.0432,23.939481L102.39656,22.484537L102.39656,20.22129L104.17483,16.66476L103.0432,14.078192L100.61829,9.2283781L100.94162,8.4200758L102.07324,7.6117734ZM92.616548,13.590738L94.637312,13.429078L95.122294,14.803197L96.658073,13.186582L99.002155,13.186582L99.810458,14.722361L98.274678,16.419801L98.92133,17.228114L98.193853,19.248875L96.819734,19.653021C96.819734,19.653021,95.930596,19.733857,95.930596,19.410536C95.930596,19.087215,97.385551,16.823958,97.385551,16.823958L95.688111,16.258141L95.36479,17.713095L94.637312,18.359737L93.10153,16.09648L92.616548,13.590738Z"},
        {id:"CA",n:"California",d:"M144.69443,382.19813L148.63451,381.70951L150.12055,379.69807L150.66509,376.75698L147.11357,376.16686L146.5994,375.49864L147.0769,373.46633L146.91762,372.87666L148.84019,372.25707L151.88297,369.42439L152.46453,364.42929L153.84443,361.02718L155.78772,358.86092L159.30659,357.27125L160.96098,355.66642L161.02971,353.55758L160.03638,352.97757L159.01323,351.90484L157.85801,346.05639L155.17281,341.2263L155.73862,337.7213L153.31904,336.69199L84.257718,232.51359L103.15983,164.9121L36.079967,149.21414L34.573071,153.94738L34.41141,161.38376L29.238275,173.18497L26.166727,175.77154L25.843406,176.90316L24.06514,177.71147L22.610196,181.91464L21.801894,185.14785L24.550122,189.35102L26.166727,193.55419L27.29835,197.11072L26.975029,203.57714L25.196764,206.64869L24.550122,212.46847L23.580159,216.18666L25.358424,220.06651L28.106652,224.593L30.369899,229.44282L31.663182,233.48433L31.339862,236.71754L31.016541,237.20252L31.016541,239.3041L36.674657,245.60886L36.189676,248.03377L35.543034,250.29702L34.896392,252.23694L35.058052,260.48163L37.159638,264.19982L39.099564,266.78638L41.847792,267.27137L42.817755,270.01959L41.686132,273.57612L39.584545,275.19273L38.452922,275.19273L37.64462,279.07258L38.129601,281.98247L41.362811,286.3473L42.979415,291.6821L44.434359,296.37025L45.727643,299.4418L49.122513,305.26158L50.577457,307.84814L51.062439,310.75803L52.679043,311.72799L52.679043,314.1529L51.870741,316.09283L50.092476,323.20589L49.607494,325.14581L52.032402,327.89404L56.235574,328.37902L60.762067,330.15729L64.641918,332.25887L67.551807,332.25887L70.461695,335.33042L73.048262,340.18024L74.179886,342.44348L78.059737,344.54507L82.909551,345.35337L84.364495,347.45496L85.011137,350.68817L83.556193,351.33481L83.879514,352.30477L87.112725,353.11307L89.860953,353.27474L93.020842,351.58789L96.900696,355.79106L97.708998,358.05431L100.29557,362.25748L100.61889,365.49069L100.61889,374.867L101.10387,376.64526L111.12682,378.10021L130.84939,380.84843L144.69443,382.19813ZM56.559218,338.48145L57.852506,340.01723L57.690846,341.31052L54.457625,341.22969L53.891811,340.01723L53.245167,338.56228L56.559218,338.48145ZM58.49915,338.48145L59.711608,337.83481L63.268151,339.9364L66.339711,341.14885L65.450575,341.79551L60.924066,341.55301L59.307456,339.9364L58.49915,338.48145ZM79.191764,358.28493L80.970029,360.62901L81.778342,361.59898L83.314121,362.16479L83.879928,360.70984L82.909965,358.93157L80.242562,356.91081L79.191764,357.07247L79.191764,358.28493ZM77.736809,366.93379L79.515085,370.08618L80.727543,372.02612L79.272589,372.2686L77.979305,371.05615C77.979305,371.05615,77.251828,369.6012,77.251828,369.19704C77.251828,368.7929,77.251828,367.01462,77.251828,367.01462L77.736809,366.93379Z"}
        ];

        draw("#"+"stateSvgID" + targetElement[0][0].id, sampleData);

        var uStates={};
        var map;
        function draw(id, data){ 
        
            map = d3.select(id).selectAll(".state") .append('g') .data(uStatePaths) .enter() .append("path") .attr("class","state")
            .attr("d",function(d){ return d.d;})//.attr('stateid', function(d,i){ return d.id }) //.attr('data-drilldownkey', function(d,i){ return d.id })
            .style("fill",function(d){ return "#f1f1f1"; }) .style("stroke","#ffffff") .attr("stroke-width",2) .style("cursor","pointer").attr('class',"hoverMap")
			
            map.transition().delay(400).duration(800).style("fill",function(d){ return data[d.id].color }) 
			
            var columnNames = d3.keys(options.data[0])
            var drillDownColumnNamesInArray = options.drillDownColumnName.split(",");
            
            for(var i = 0; i < columnNames.length ; i++){
                for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                    if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                        var foundKey = columnNames[i];
                        for(var k = 0; k < map[0].length; k++){
                            for(l = 0; l < options.data.length; l++){
                                if(options.data[l][foundKey].toString().toLowerCase() === map[0][k].__data__.id.toString().toLowerCase()){
                                    d3.select(map[0][k]).attr('data-drilldownkey', function(d,index){
                                            return JSON.stringify(options.data[l]).slice(1, -1).split('"').join("").split(':').join("|")
                                    })
                                }
                            }
                            
                        }
                        
                    }
                    else {
                    }
                }
            }
            
            map.on("mousemove", mousemove).on("mouseout", mouseOut)
            
            function mousemove(d,i){

                var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                
                var valueForMapTooltip;
                if(data[d.id].value.toString().indexOf('.') === -1)
                {
                    valueForMapTooltip = data[d.id].value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
                else{
                        
                    valueForMapTooltip = data[d.id].value;
                }

                tooltipForMap.select('.label').html(d.n);
                tooltipForMap.select('.count').html(valueForMapTooltip);
                tooltipForMap.style('visibility', 'visible');
                tooltipForMap.select('hr').style("background-color", d3.select(this).style("fill"))
                tooltipForMap.style("margin-left", (m[0] + 15) + "px").style("margin-top",(m[1] - 20) + "px").style("display","block")
                //.transition().duration(400)
            }

            function mouseOut(d,i){
                tooltipForMap.style("display","none")
            }
        } // draw function ends here

        var path = svgPanelForMap.selectAll("path")

        var drillDownKeyArrayForMap = ["HI", "AK", "FL", "NH", "MI", "VT", "ME", "RI", "NY", "PA", "NJ",
            "DE", "MD", "VA", "WV", "OH", "IN", "IL", "CT", "WI", "NC", "DC", 
            "MA", "TN", "AR", "MO", "GA", "SC", "KY", "AL", "LS", "MS", "IA", 
            "MN", "OK", "TX", "NM", "KS", "NE", "SD", "ND", "WY", "MT", "CO", 
            "ID", "UT", "AZ", "NV", "OR","WA","CA"];

        var divWidth;
        var divHeight;

        divWidth = targetElement[0][0].clientWidth;
        divHeight = targetElement[0][0].clientHeight;

        var oldWidthScale = divWidth / 1025.41176471
        var oldHeightScale = divHeight / 665

        path.attr("transform", "scale(" + (oldWidthScale) + " ," + (oldHeightScale) + ")") 
        
        window.addEventListener('resize', function(event){
            divWidth = $("#" + targetElement[0][0].id).width()
            divHeight = $("#" + targetElement[0][0].id).height()
            resizedFuctionForMap()
        });
        
        $(function() {
          
			$("#" + targetElement[0][0].id).resizable({
                resize: function(event, ui) {
                        divWidth = ui.size.width;
                        divHeight = ui.size.height;
                        resizedFuctionForMap();
                    }
			});
		});
    
        // maximizeBtnForMap.on('click', function() {
        //     downloadBtnForUSMap.style('right', '0')
        //     //maximizeBtnForMap.style("display","none") 
        //     //maximizeBtnForMap.style('right', '0')
        //     var width = window.innerWidth;
        //     var height = window.innerHeight;
        //     var svgWidth = targetElement[0][0].clientWidth
        //     var svgHeight = targetElement[0][0].clientHeight
        //     targetElement.attr("transform", "scale(" + (width) + " ," + (height) + ")")
        // })
        
        function resizedFuctionForMap()
        {
            downloadBtnForUSMap.style('right', '0')
            
            var newWidthScale = divWidth / 1025.41176471
            var newHeightScale = divHeight / 665
            
            var svgWidth = targetElement[0][0].clientWidth
            var svgHeight = targetElement[0][0].clientHeight
            
            if ((parseFloat(svgWidth) == 350) && (parseFloat(svgHeight) == 350)){
                path .transition() .duration(0) .attr("transform", "scale(" + (0.3413) + " ," + (0.5263) + ")")
            }
            else if(parseFloat(svgWidth) == 350){
                path .transition() .duration(0) .attr("transform", "scale(" + (0.3413) + " ," + (newHeightScale) + ")")
            }
            else if(parseFloat(svgHeight) == 350){
                path .transition() .duration(0) .attr("transform", "scale(" + (newWidthScale) + " ," + (0.5263) + ")")
            }
            
            else{
                path .transition() .duration(0) .attr("transform", "scale(" + (newWidthScale) + " ," + (newHeightScale) + ")")
            }
        }
       

    }, //map

    // ************************************************** Column and Line Chart  **************************************************
    columnAndLineChart: function(targetElement, options){
        isChartCalled++;
        var chartName = "COLUMNANDLINECHART";

        acinfotech.allCharts(targetElement,options,chartName);

        targetElement.style("min-width", "350px").style("min-height", "350px").style("background-color", options.BGcolor)
        
        var showOrHideTabForColAndLineChart;
        var showOrHideCommentsForColAndLineChart;
        var showOrHideCommentsBtnForColAndLineChart = true;

        if((options.showTable == false) || (options.showTable == true)){
            showOrHideTabForColAndLineChart = options.showTable    
        }
        else{
            showOrHideTabForColAndLineChart = false;
        }

        // Show or Hide comments
        if (options.showComments == true || false) {
            showOrHideCommentsForColAndLineChart = options.showComments;
        }
        else {
            showOrHideCommentsForColAndLineChart = false;
        }
        
        if (options.comments.length == 0){ 
            showOrHideCommentsForColAndLineChart = false;
            showOrHideCommentsBtnForColAndLineChart = false;
        }

        if ((showOrHideTabForColAndLineChart == true) && (showOrHideCommentsForColAndLineChart == true)){
            showOrHideTabForColAndLineChart = true;
            showOrHideCommentsForColAndLineChart = false;
        }
        else if ((showOrHideTabForColAndLineChart == false) && (showOrHideCommentsForColAndLineChart == false)){
            showOrHideTabForColAndLineChart = false;
            showOrHideCommentsForColAndLineChart = false;
        }

        // Creating title
        var chartTitlePanelForColAndLineChart = targetElement.append("div") .style("position","absolute").style("background-color", options.BGcolor).style("text-indent","6px")
        
        // Creating chart panel
        var svgPanelForColAndLineChart = targetElement .append('svg') .attr("id","svgPanelIDForColAndLineChart" + targetElement[0][0].id)
        .style("background-color", options.BGcolor) .style("position","absolute")

        var commentsPanelDivForColAndLine = targetElement.append("div") .attr("class","commentsPanelClassForColAndLineChart")
        .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
		.style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
        .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)

        commentsPanelDivForColAndLine.on('click',function(d){
            $('.commentsClassForColAndLine' + targetElement[0][0].id).focus()
        })

        if(options.showTitle == true){
            
            chartTitlePanelForColAndLineChart.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 8 + "%"; }).style("background-color", options.BGcolor) 
            .html('<div  style="width: 100%; height:0%; position: absolute; top:25.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')

            if ((showOrHideTabForColAndLineChart == false) && (showOrHideCommentsForColAndLineChart == true)){

                var commentsForColAndLineChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify') .attr('class','commentsClassForColAndLine' + targetElement[0][0].id)

                   svgPanelForColAndLineChart.attr('width', 100 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .append('g')
                   commentsPanelDivForColAndLine.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForColAndLineChart[0].outerHTML.toString())

            }
            else if ((showOrHideTabForColAndLineChart == true) && (showOrHideCommentsForColAndLineChart == false)){

                    svgPanelForColAndLineChart.attr('width', 100 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .style("background-color", options.BGcolor).append('g')
                    commentsPanelDivForColAndLine.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTabForColAndLineChart == false) && (showOrHideCommentsForColAndLineChart == false)){
                    svgPanelForColAndLineChart.attr('width', 100 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .style("background-color", options.BGcolor).append('g')
                    commentsPanelDivForColAndLine.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            
            var margin = {top: 30 , right: 40, bottom: 80, left: 40}, //originally top: 42, left: 80
            width = (svgPanelForColAndLineChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = svgPanelForColAndLineChart.node().getBoundingClientRect().height - margin.top - margin.bottom;
            
        }
        else if(options.showTitle == false){
            chartTitlePanelForColAndLineChart.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });

            if ((showOrHideTabForColAndLineChart == false) && (showOrHideCommentsForColAndLineChart == true)){

                var commentsForHorichart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify')

                   svgPanelForColAndLineChart.attr('width', 100 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .style("background-color", options.BGcolor).append('g')
                   commentsPanelDivForColAndLine.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForHorichart[0].outerHTML.toString())

            }
            else if ((showOrHideTabForColAndLineChart == true) && (showOrHideCommentsForColAndLineChart == false)){

                    svgPanelForColAndLineChart.attr('width', 100 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .style("background-color", options.BGcolor).append('g')
                    commentsPanelDivForColAndLine.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTabForColAndLineChart == false) && (showOrHideCommentsForColAndLineChart == false)){
                    svgPanelForColAndLineChart.attr('width', 100 + "%") .attr('height', 85 + "%") .style("top",8 + "%").style("background-color", options.BGcolor) .append('g')
                    commentsPanelDivForColAndLine.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            
            var margin = {top: 30, right: 40, bottom: 65, left: 40}, //originally top: 42, left: 80
            width = (svgPanelForColAndLineChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = svgPanelForColAndLineChart.node().getBoundingClientRect().height - margin.top - margin.bottom;
        }

        var colors = [];
        // checking color set for pie slices and legend dots
        if(options.colorSet === undefined){
            options.colorSet = "one"
            
            colors[0] = "#00A9E9"; colors[1] = "#BC851C";
        }
        else if(options.colorSet.toString().toLowerCase() === "one"){
            options.colorSet = "one"
            
            colors[0] = "#00A9E9"; colors[1] = "#BC851C";
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            
            options.colorSet = "two"
            
            colors[0] = "#E95044"; colors[1] = "#F28A4C";
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            options.colorSet = "three"
            
            colors[0] = "#01204F"; colors[1] = "#006A8D";
        }
        else
        {
            options.colorSet = "one"
            
            colors[0] =  "#00A9E9"; colors[1] =  "#BC851C";
        }

        /*------------------ Settings panel DIV and everything within it section begins here ------------------*/
        
        var stgPanDivForColAndLineChart = targetElement.append('div').style('width',"100%").style('height',"40%").attr("class","stgPanDivForColAndLineChart" + targetElement[0][0].id)
        .style('position','absolute').style('margin-left', "0px").style('border-top',"1px solid #f0f0f0").style('border-bottom',"1px solid #e5e5e5")
        .style("background-color",'#fcfcfc').style("z-index",90) .style("display","none") .style('top',"60%").style('height',"40%")

        $( '.stgPanDivForColAndLineChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        var settingPanelTitle = stgPanDivForColAndLineChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','10px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; color:#00001c;">'+ "Settings" +'</div>')

        var stgPanDivForColAndLineChangeColorTitle = stgPanDivForColAndLineChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Select color set " +'</div>')

        var stgPanCanBtnForColAndLineChart = stgPanDivForColAndLineChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
        .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
        .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.90; background-color:#fcfcff")
        stgPanCanBtnForColAndLineChart[0][0].appendChild(cancelBtnImgVar)

        stgPanCanBtnForColAndLineChart.on('click', function() {
            stgPanDivForColAndLineChart.style("display","none") // Hiding setting panel

            if ((showOrHideTabForColAndLineChart == false) && (showOrHideCommentsForColAndLineChart == true)){
                    
                svgPanelForColAndLineChart.style('width', 100 + "%") .style('height', 70 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); 
            }
            else if ((showOrHideTabForColAndLineChart == true) && (showOrHideCommentsForColAndLineChart == false)){
                    
                svgPanelForColAndLineChart.style('width', 100 + "%") .style('height', 52 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTabForColAndLineChart == false) && (showOrHideCommentsForColAndLineChart == false)){
                     
                svgPanelForColAndLineChart.style('width', 100 + "%") .style('height', 85 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); 
            }

            resizedFuctionForColumnAndLineChart();

        })

        var formForChangeSettingsPanel = stgPanDivForColAndLineChart.append("form");
        formForChangeSettingsPanel.style("background-color","#fcfcfc").style("margin-top","67px").style("font-family","Verdana,sans-serif").style("font-size","12px")
        .style("position","absolute").attr("id","formForChangeColorSettingsPanel" + targetElement[0][0].id).style("font-weight","Bold").style("width","180px")
        .style("height","58px").style("padding","0px").style("border-radius","0px") .style("margin-left","10px")

        var svgPanelForCrSetOne = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
        .style("width","30px").style("height","18px").style("margin-top","1px").style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetOne = d3.scale.ordinal() .range(["#ff6e5f", "#141414"]);
        var colorSetOneRange = d3.range(2);

        var colorSetOneDots = svgPanelForCrSetOne.append("g")
        colorSetOneDots.selectAll('rect') .data(colorSetOneRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("fill", function(d,i){return colorSetOne(i)})
        .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)  .style("stroke",function(d,i){  return colorSetOne(i); })
        .style("cursor","auto") .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        var svgPanelForCrSetTwo = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
        .style("width","30px").style("height","18px").style("margin-top","20px").style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetTwo = d3.scale.ordinal() .range(["#e2d387", "#141414"]);
        var colorSetTwoRange = d3.range(2);

        var colorSetTwoDots = svgPanelForCrSetTwo.append("g")
        colorSetTwoDots.selectAll('rect') .data(colorSetTwoRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto")
        .style("fill", function(d,i){return colorSetTwo(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
        .style("stroke",function(d,i){  return colorSetTwo(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        var svgPanelForCrSetThree = formForChangeSettingsPanel.append("svg").style("position","absolute")
        .style("background-color","#fefefe").style("width","30px").style("height","18px").style("margin-top","39px").style("margin-left","0px")
        .style("box-sizing","border-box")
        
        var colorSetThree = d3.scale.ordinal() .range(["#cc719f", "#141414"]);
        var colorSetThreeRange = d3.range(2);

        var colorSetThreeDots = svgPanelForCrSetThree.append("g")
        colorSetThreeDots.selectAll('rect') .data(colorSetThreeRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto")
        .style("fill", function(d,i){return colorSetThree(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
        .style("stroke",function(d,i){  return colorSetThree(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        if(options.colorSet.toString().toLowerCase() === "one"){
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"1px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"1px solid #808080")
        }
        else 
        {
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }

        svgPanelForCrSetOne.on('click',function(d){
            options.colorSet = "one"
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")

            //var colorSetOne = d3.scale.ordinal() .range(["#00b85c", "#663333"]);
            colors[0] = "#ff6e5f"; colors[1] = "#141414";
            verticalBars.style("fill",function(d,i){ return  "#ff6e5f" })
			svg.selectAll(".bartext").style("fill", "#ff6e5f")
            //textOnBarsForColAndLineChart.style("fill", "#ff6e5f")

            circles.style("fill","#141414").style("stroke","#141414")
            textOnDotsForColAndLineChart.style("fill", "#141414")

            line.style("stroke","#141414").style('fill','none')
			
            yLeftAxisLabVar.style('fill','#ff6e5f')
            yRightAxisLabVar.style('fill','#141414')
        
        })
        svgPanelForCrSetTwo.on('click',function(d){
            options.colorSet = "two"
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"1px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")

            //var colorSetTwo = d3.scale.ordinal() .range(["#3359cc", "#a6cc33"]);
            colors[0] = "#e2d387"; colors[1] = "#141414";
            verticalBars.style("fill",function(d,i){  return "#e2d387"; })
			svg.selectAll(".bartext").style("fill", "#e2d387")
            //textOnBarsForColAndLineChart.style("fill", "#e2d387")

            circles.style("fill","#141414").style("stroke","#141414")
            textOnDotsForColAndLineChart.style("fill", "#141414")
            
            line.style("stroke","#141414").style('fill','none')

            yLeftAxisLabVar.style('fill','#e2d387')
            yRightAxisLabVar.style('fill','#141414')
        })
        svgPanelForCrSetThree.on('click',function(d){
            options.colorSet = "three"
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"1px solid #808080")

            //var colorSetThree = d3.scale.ordinal() .range(["#4c3e32", "#00b700"]);
            colors[0] = "#cc719f"; colors[1] = "#141414";
            verticalBars.style("fill",function(d,i){  return "#cc719f"; })
			svg.selectAll(".bartext").style("fill", "#cc719f")
            //textOnBarsForColAndLineChart.style("fill", "#cc719f")
            
            circles.style("fill","#141414").style("stroke","#141414")
            textOnDotsForColAndLineChart.style("fill", "#141414")

            line.style("stroke","#141414").style('fill','none')

            yLeftAxisLabVar.style('fill','#cc719f')
            yRightAxisLabVar.style('fill','#141414')
        })

        /*------------------ Settings panel DIV and everything inside it section ends here ------------------*/
		
		var optsBtnPanelForColAndLineChart = targetElement.append('div').style('width',"25px").style('height',"135px").style('position','absolute')
        .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px").style('right', '0')
        .style("min-width","25px").style("border-style","none").style("border-left", "solid #fcfcfc  1px")
		
        var refreshButtonForColAndLineChart = optsBtnPanelForColAndLineChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','81px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var refreshBtnImgVar = document.createElement("IMG");
        refreshBtnImgVar.src = "images/refreshIcon.png";
        refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        refreshButtonForColAndLineChart[0][0].appendChild(refreshBtnImgVar)

        var commentsBtnForColAndLineChart = optsBtnPanelForColAndLineChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','108px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var commentsBtnImgVariable = document.createElement("IMG");
        if(options.showComments == false){
            commentsBtnImgVariable.src = "images/showCommentsIcon.png";
        }
        else if(options.showComments == true){
            commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
        }
        commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        commentsBtnForColAndLineChart[0][0].appendChild(commentsBtnImgVariable)

        var menuButtonForColAndLineChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','1px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var menuBtnImgVar = document.createElement("IMG");
        menuBtnImgVar.src = "images/menuIcon.png";
        menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
        menuButtonForColAndLineChart[0][0].appendChild(menuBtnImgVar)

        if(showOrHideCommentsBtnForColAndLineChart == true){
            refreshButtonForColAndLineChart.style('margin-left', "2px")
            commentsBtnForColAndLineChart.style('margin-left', "2px")
            menuButtonForColAndLineChart.style('right', '0')
        }
        else if(showOrHideCommentsBtnForColAndLineChart == false){
            refreshButtonForColAndLineChart.style('margin-left', "2px")
            //commentsBtnForColAndLineChart.style('right', '0')
            commentsBtnForColAndLineChart.style('display','none')
            menuButtonForColAndLineChart.style('right', '0')
        }

        var ismenuBtnOfColLineChartClicked = false; // Menu toggle variable
        menuButtonForColAndLineChart.on('click', function() {
            if(ismenuBtnOfColLineChartClicked == false){
                ismenuBtnOfColLineChartClicked = true; // Menu toggle variable
                optsBtnPanelForColAndLineChart.style("display","block") // Showing option buttons panel

                stgPanDivForColAndLineChart.style("display","none") // Showing settings panel

                if ((showOrHideTabForColAndLineChart == false) && (showOrHideCommentsForColAndLineChart == true)){
                    
                    svgPanelForColAndLineChart.style('width', 100 + "%") .style('height', 70 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTabForColAndLineChart == true) && (showOrHideCommentsForColAndLineChart == false)){
                    
                    svgPanelForColAndLineChart.style('width', 100 + "%") .style('height', 52 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor);
                }
                else if ((showOrHideTabForColAndLineChart == false) && (showOrHideCommentsForColAndLineChart == false)){
                     
                    svgPanelForColAndLineChart.style('width', 100 + "%") .style('height', 85 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }

           }
           
            else if(ismenuBtnOfColLineChartClicked == true){
                ismenuBtnOfColLineChartClicked = false; // Menu toggle variable
                optsBtnPanelForColAndLineChart.style("display","none") // Hiding option buttons panel

                if ((showOrHideTabForColAndLineChart == false) && (showOrHideCommentsForColAndLineChart == true)){
                    
                    svgPanelForColAndLineChart.style('width', 100 + "%") .style('height', 70 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
                else if ((showOrHideTabForColAndLineChart == true) && (showOrHideCommentsForColAndLineChart == false)){
                    
                    svgPanelForColAndLineChart.style('width', 100 + "%") .style('height', 52 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor);
                }
                else if ((showOrHideTabForColAndLineChart == false) && (showOrHideCommentsForColAndLineChart == false)){
                     
                    svgPanelForColAndLineChart.style('width', 100 + "%") .style('height', 85 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); 
                }
            }

            resizedFuctionForColumnAndLineChart();
        })

        var tableButtonForColAndLine = optsBtnPanelForColAndLineChart.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top','1px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
        var tableBtnImgVar = document.createElement("IMG");
        if(showOrHideTabForColAndLineChart == false){
            tableBtnImgVar.src = "images/showTableIcon.png";
            tableButtonForColAndLine.attr("class","showTableClassForChartTable")
        }
        else if(showOrHideTabForColAndLineChart == true){
            tableBtnImgVar.src = "images/cancelTableIcon.png";
            tableButtonForColAndLine.attr("class","hideTableClassForChartTable")
        }
        tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
        tableButtonForColAndLine[0][0].appendChild(tableBtnImgVar)

        var settingBtnForColAndLineChart = optsBtnPanelForColAndLineChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 28 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        var settingBtnImgVar = document.createElement("IMG");
        settingBtnImgVar.src = "images/settingsIcon.png";
        settingBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.82;")
        settingBtnForColAndLineChart[0][0].appendChild(settingBtnImgVar)
        
        var downloadBtnForColAndLineChart = optsBtnPanelForColAndLineChart.append("div").attr("id","downloadBtnForColAndLineChart-ID-" + targetElement[0][0].id).style("width","20px")
        .style("height","20px").style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff").style('margin-left','2px')
        .style('top', 54 + 'px').style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        
        acinfotech.downloadFunctionality("downloadBtnForColAndLineChart-ID-" + targetElement[0][0].id,targetElement)
        
        // Creating ToolTip DIV
        var tooltipForColumAndLineChart = targetElement .append('div') .attr('class', 'tooltipPie') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
        .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
        .style("padding-right", "7px") .style("background", "#F8F8F8") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style("z-index",1000)
        .style("border", "1.0px") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","80px")
        tooltipForColumAndLineChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'label').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "14px") .style("font-weight", "normal");
        tooltipForColumAndLineChart.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
        tooltipForColumAndLineChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");

        refreshButtonForColAndLineChart.on('click', function() {

            //isFilterClickedForHorizontalChart = false
            //options.data = columnChartOptionsDataArray; 
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){
                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                }
            }
            acinfotech.columnAndLineChart(targetElement,options)

        })

        commentsBtnForColAndLineChart.on('click', function() {

            if(options.showComments == false){ 
                options.showComments = true;
            }
            else if(options.showComments == true){ 
                options.showComments = false;
            }

            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){
                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                    options.showTable = false;
                }
            }
            acinfotech.columnAndLineChart(targetElement,options)

          })  

        // showing/hidding chart table
        tableButtonForColAndLine.on('click', function() {

            if(showOrHideTabForColAndLineChart == false){
                options.showTable = true;
                //showOrHideTableForPieChart = true
            }
            else if(showOrHideTabForColAndLineChart == true){
                //showOrHideTableForPieChart = false
                options.showTable = false;
            }

            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                    options.showComments = false;
                }
            }
            acinfotech.columnAndLineChart(targetElement,options)

        })

        
        settingBtnForColAndLineChart.on('click', function() {
                
			ismenuBtnOfColLineChartClicked = false; // Menu toggle button variable
			optsBtnPanelForColAndLineChart.style("display","none") // To hide options button panel

			iconButtonTooltipForColAndLineChart.style("display","none") // Removing options button ToolTip
			settingBtnForColAndLineChart.style("cursor","pointer")
			
			stgPanDivForColAndLineChart.style("display","block") // Showing settings panel

			//svgPanelForColAndLineChart.style('width', 100 + "%") .style('height', 52 + "%").style("position","absolute"); // Decreasing chart panel

			if ((showOrHideTabForColAndLineChart == false) && (showOrHideCommentsForColAndLineChart == true)){
				
				svgPanelForColAndLineChart.style('width', 100 + "%") .style('height', 52 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); 
			}
			else if ((showOrHideTabForColAndLineChart == true) && (showOrHideCommentsForColAndLineChart == false)){
				
				svgPanelForColAndLineChart.style('width', 100 + "%") .style('height', 52 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor);
			}
			else if ((showOrHideTabForColAndLineChart == false) && (showOrHideCommentsForColAndLineChart == false)){
				 
				svgPanelForColAndLineChart.style('width', 100 + "%") .style('height', 52 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); 
			}

			resizedFuctionForColumnAndLineChart(); // Calling resize function()

        })
        
        downloadBtnForColAndLineChart.on('click', function() {
                                  
          ismenuBtnOfColLineChartClicked = false; // Changing menu button value to false
          optsBtnPanelForColAndLineChart.style("display","none") // Hiding option buttons panel
          
        })
        
        // Creating ToolTip for options button.
        var iconButtonTooltipForColAndLineChart = targetElement.append('div').style('width','240px').attr("id","too") .style('height',"25px")
        .style('position','absolute') .style("background-color",'#404040 ').style("z-index",999) .style("border", "0.0px")
        .style("border-color", "#278eff") .style("border-style", "solid")  .style("border-radius","0px") .style("box-shadow", "1px 1px 2px #d8d8d8")
        .style("display","none").attr("border", 0.0)

        // Adding tooltip for options button
        refreshButtonForColAndLineChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var refreshButtonTooltipText = "Refresh";
            
            iconButtonTooltipForColAndLineChart.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForColAndLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ refreshButtonTooltipText +'</div>')

        })
        refreshButtonForColAndLineChart.on('mouseout', function(d,i) {
            iconButtonTooltipForColAndLineChart.style("display","none")
        })

        commentsBtnForColAndLineChart.on('mousemove', function(d,i) {
            commentsPanelDivForColAndLine.style('background-color','#fafafa')
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                if(options.showComments == false){
                    var commentButtonTooltipText = "Show Comments";
                }
                else if(options.showComments == true){
                    var commentButtonTooltipText = "Hide Comments";
                }
            
            iconButtonTooltipForColAndLineChart.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForColAndLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ commentButtonTooltipText +'</div>')
        })
        commentsBtnForColAndLineChart.on('mouseout', function(d,i) {
            commentsPanelDivForColAndLine.style('background-color','#ffffff')
            iconButtonTooltipForColAndLineChart.style("display","none")
        })

        menuButtonForColAndLineChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var menuButtonTooltipText = "Menu";
            
            iconButtonTooltipForColAndLineChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForColAndLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ menuButtonTooltipText +'</div>')

        })
        menuButtonForColAndLineChart.on('mouseout', function(d,i) {
            iconButtonTooltipForColAndLineChart.style("display","none")
        })

        tableButtonForColAndLine.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            if(showOrHideTabForColAndLineChart == false){
                var tableButtonTooltipText = "Show Table";
            }
            else if(showOrHideTabForColAndLineChart){
                var tableButtonTooltipText = "Hide Table";
            }
            
            iconButtonTooltipForColAndLineChart.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForColAndLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ tableButtonTooltipText +'</div>')

        })
        tableButtonForColAndLine.on('mouseout', function(d,i) {
            iconButtonTooltipForColAndLineChart.style("display","none")
        })

        settingBtnForColAndLineChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var reloadButtonTooltipText = "Settings";
            
            iconButtonTooltipForColAndLineChart.style("width","67px").style("margin-left", (m[0] - 77) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForColAndLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ reloadButtonTooltipText +'</div>')
        })
        settingBtnForColAndLineChart.on('mouseout', function(d,i) {
            iconButtonTooltipForColAndLineChart.style("display","none")
        })
        
        downloadBtnForColAndLineChart.on('mousemove', function(d,i) {
          var root = targetElement
          var m = d3.mouse(root.node());
          m[0] += 0
          m[1] += 0
          var downloadButtonTooltipText = "Download";
          
          iconButtonTooltipForColAndLineChart.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
          iconButtonTooltipForColAndLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
        })
        downloadBtnForColAndLineChart.on('mouseout', function(d,i) {
          iconButtonTooltipForColAndLineChart.style("display","none")
        })
        
        var x = d3.scale.linear() .domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.label]; }))]) .range([0, width]);

        var yLeft = d3.scale.linear() .domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.valueForColumn]; }))]) .range([height, 0]);

        var yRight = d3.scale.linear() .domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.valueForLine]; }))]) .range([height, 0]);

        var yLeftAxis = d3.svg.axis() .scale(yLeft) .orient("left") .ticks(5);

        var yRightAxis = d3.svg.axis() .scale(yRight) .orient("right") .ticks(5);

        var labelArray = [];
        var leftValueArray = [];
        var rightValueArray = [];
        
        options.data.forEach(function(d, i) {

            d[options.keys.valueForColumn] = +d[options.keys.valueForColumn];
            d[options.keys.valueForLine] = +d[options.keys.valueForLine];
            leftValueArray.push(d[options.keys.valueForColumn])
            rightValueArray.push(d[options.keys.valueForLine])
            labelArray.push(d[options.keys.label])
                             
        })

        // Inner SVG
        var svg = svgPanelForColAndLineChart .append("svg") .style("background-color", options.BGcolor) .style("border-radius","0px") .style("border-width","0px")
        .style("border-color","#d4d4d4") .style("border-style","solid") .append("g") .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

        // Adding left Y-Axis label
        var yLeftAxisLabVar = svg.append("text") .attr("transform", "rotate(-90)") .attr("y", -25) .attr("x",0 - (height / 2)) .attr("dy", "1em") .style("text-anchor", "middle")
        .style("font-family","Verdana,sans-serif") .style("font-weight","Bold") .style("font-size","12px") .text(options.yLeftAxisLable) .style('fill',colors[0]) .style("text-transform","capitalize")
        .style("font-style","normal")
        
        // Adding right Y-Axis label
        var yRightAxisLabVar = svg.append("text").attr("transform", "translate(" + width + ",0)rotate(90)").attr("y", -25).attr("x",height/2) .attr("dy", "1em") .style("text-anchor", "middle")
        .style("font-family","Verdana,sans-serif") .style("font-weight","Bold") .style("font-size","12px") .text(options.yRightAxisLable) .style('fill',colors[1]) .style("text-transform","capitalize")
        .style("font-style","normal")
        //rotate(-90)
        let key=options.xAxisLable;
        let array=options.data.map(value => value[key]);
       
        let ArrayValue=[];
        var RotateValue;
        for(let i=0;i<array.length;i++){
                ArrayValue[i]=array[i].length;
        }
        const numberGreaterThanLimit = ArrayValue.filter((v) => v > 5);
        var x1 = d3.scale.ordinal() .domain(options.data.map(function(d) { return d[options.keys.label]; })) .rangeRoundBands([0, width], 0.25);
        
        var xAxis = d3.svg.axis() .scale(x1) .orient("bottom")
        
        // Adding the X Axis
        svg.append("g").attr("class", "x axis").attr("transform", "translate(0," + height + ")") .call(xAxis)
        
        // Add the X Axis margin labels
        .selectAll("text") .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') 
        .attr("transform", function(d) {
            if(numberGreaterThanLimit.length>0)
            {
                return "rotate(-45)"
            }
         else{
                    return "rotate(0)" 
            }})
        
        .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
        .text(function(d,i) {
            if(d.length > 9)
                        return d.substring(0,9)+'...';
                    else
                        return d;
        })
         // Adding the text label for the X axis
         var xAxisVariable =  svg.append("text") .attr("transform", "translate(" + (width/2) + " ," + (height+margin.bottom - 2) + ")")
         .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif") .style("font-weight","Bold") .style("font-size","12px") .text(options.xAxisLable) .style('fill','#00001c') 
         .style("text-transform","capitalize") .style("font-style","normal")
 
        //var colors = d3.scale.ordinal() .range(["#1F78B4", "#6A3D9A", "#3fcb56", "#bb4e5c", "#55bf9b", "#0095b3", "#7a92a9","#663399","#29b5eb","#ff9878","#CCCCCC","#008d8d"]);

        var xScale = d3.scale.ordinal() .domain(d3.range(options.data.map(function(d) { return +d[options.keys.valueForColumn]; }).length)) .rangeRoundBands([0, width], 0.25);
        
        var yScale = d3.scale.linear() .domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.valueForColumn]; }), function(d) { return d; })]) .range([0, height]);

        //Creating bars
        var verticalBars = svg.selectAll(".bar") .data(options.data.map(function(d) { return +d[options.keys.valueForColumn]; })) .enter() .append("rect") .attr("class", "bar") //.attr("fill",function(d,i){  return colors(i);  }) .style("fill-opacity", 0.9)//0.62
        //.on('mouseover', tip.show)  .on('mouseout', tip.hide);
        
		verticalBars.attr("x", function (d,i) {  return xScale(i);  })
		.attr("width", xScale.rangeBand())
		.attr("y", function (d) { return height; })
		.attr("height", function (d) { return 0; })
		.transition() .delay(400) .duration(800)
		.attr("y", function (d) { return height - yScale(d); })
		.attr("height", function (d) { return yScale(d); });
        
        verticalBars.style("fill",function(d,i){ return  colors[0]; }).style("cursor","auto")
        
		svg.selectAll(".bar") .data(options.data.map(function(d) { return +d[options.keys.valueForColumn]; })).on("click", function(d) {    
            selectedItem = d });

        // Creating Text on Columns 
        var yTextPadding = -3;
        var format = d3.format(".2s")//d3.format('s')
        var textOnBarsForColAndLineChart = svg.selectAll(".bartext")
        .data(options.data.map(function(d) { return +d[options.keys.valueForColumn]; })) .enter() .append("text") .attr("class", "bartext")
        .style("text-anchor", "middle") .style("fill",colors[0]) .style("font-weight","Normal") .style("font-size","12px") .style("font-family","Verdana,sans-serif")
        .style("position","absolute").attr("class","series_value").style("display",options.series)
		.attr("x", function(d,i) { return xScale(i)+xScale.rangeBand()/2; })
		.attr("y", function (d) { return height; })
		.transition() .delay(400) .duration(800)
		.attr("y", function(d,i) { return height-yScale(d)+yTextPadding; })
        .text(function(d){ 
            if(d.toString().indexOf('.') === -1)
            {
                return d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            else{
                        
                return d;
            } 
        })

        var x2 = d3.scale.ordinal().domain(options.data.map(function(d) { return d[options.keys.label];})).rangePoints([0, width],1.35);
        
        var y = d3.scale.linear() .domain([0, d3.max(options.data, function(d) { return d[options.keys.valueForLine]; })]) .range([height, 0]);

        // Creating Line 
        var valueline = d3.svg.line() .interpolate("cardinal") .x(function(d) { return x2(d[options.keys.label]); })
        .y(function(d) { return y(d[options.keys.valueForLine]); });

        var line = svg.append("path") .attr("d", valueline(options.data)) .attr("class", "line") .attr("stroke", colors) .style("stroke-width", 2)
        .style('stroke',colors[1]) .style('fill','none')

        // Creating Circles 
        var circles = svg.selectAll(".circle") .data(options.data) .enter() .append("svg:circle") .attr("class", "circle")
        .attr("cx", function (d, i) { return x2(d[options.keys.label]); }) .attr("cy", function (d, i) { return y(d[options.keys.valueForLine]); })
        .attr("r", 3.8) .style("fill",colors[1]) .style("stroke",colors[1]) .style("cursor","auto")
        //.attr('drilldownkey'+ targetElement[0][0].id, function(d,i){ return options.data[i][options.keys.label]; })        
        
        var columnNames = d3.keys(options.data[0])
        var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
        
        for(var i = 0; i < columnNames.length ; i++){
            for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                    for(var k = 0; k < verticalBars[0].length; k++){
                        d3.select(verticalBars[0][k]).attr('data-drilldownkey', function(d,index){
                            return JSON.stringify(options.data[k]).slice(1, -1).split('"').join("").split(':').join("|")
                        })
                    }
                    var circleLen = d3.select(svg[0][0]).selectAll('circle')
                    for(var l = 0; l < circleLen[0].length; l++){
                        var cir = d3.select(circleLen[0][l])[0][0]
                        d3.select(circleLen[0][l]).attr('data-drilldownkey', function(d,index){
                            return JSON.stringify(options.data[l]).slice(1, -1).split('"').join("").split(':').join("|")
                        })
                    }
                }
                else {
                }
            }
        }
        
        //var columnNames = d3.keys(options.data[0])
        

        // Creating Text on Circles 
        var format = d3.format('.2s')
        var xScaleForLineText = d3.scale.ordinal() .domain(d3.range(options.data.map(function(d) { return +d[options.keys.valueForLine]; }).length)) .rangeRoundBands([0, width], 0.25);
        var yScaleForLineText = d3.scale.linear() .domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.valueForLine]; }), function(d) { return d; })]) .range([0, height]);
        
        var textOnDotsForColAndLineChart = svg.selectAll(".circleText") .data(options.data.map(function(d) { return +d[options.keys.valueForLine]; }))
        .enter() .append("text") .attr("class", "circleText") .style("text-anchor", "middle") .style("fill", colors[1]) .style("font-weight","Normal")
        .style("font-size","12px") .style("font-family","Verdana,sans-serif") .style("position","absolute") .style("font-size","12px").attr("class","series_value").style("display",options.series)
        .attr("x", function(d,i) { return xScaleForLineText(i)+xScaleForLineText.rangeBand()/2; })
        .attr("y", function(d,i) { return height-yScaleForLineText(d)+15; })
        .text(function(d){ 
            if(d.toString().indexOf('.') === -1)
            {
                return d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            else{
                        
                return d;
            } 
        })

        var labelArray = options.data.map(function(d) { return d[options.keys.label]; })
        
        var valueArrayForColumn = options.data.map(function(d) { return +d[options.keys.valueForColumn]; })
        var toolTipForColChart = d3.tip() .attr('class', 'd3-tip') .offset([-10, 0]) .style("font-family","Verdana,sans-serif").style("padding","4px").style("text-transform","capitalize")
        .style("font-weight","Bold").style("font-size","12px").style("color","#00001c").style("z-index",1000)
        .html(function(d, i) {

            var valueForColAndLineChartToolTip_Col;
            if(valueArrayForColumn[i].toString().indexOf('.') === -1)
            {
                valueForColAndLineChartToolTip_Col = valueArrayForColumn[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            else{
                        
                valueForColAndLineChartToolTip_Col = valueArrayForColumn[i];
            }

            //return options.keys.label + " : " + labelArray[i] + "<br>" + '<hr style="height:2px; width:100%px; margin:2px; border:none;color:#333;background-color:#E0E0E0;" />'+ options.keys.valueForColumn + " : " + valueArrayForColumn[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            return options.keys.label + " : " + labelArray[i] + "<br>" + '<hr style="height:2px; width:100%px; margin:2px; border:none;color:#333;background-color:#E0E0E0;" />'+ options.keys.valueForColumn + " : " + valueForColAndLineChartToolTip_Col
        });            

        svg.call(toolTipForColChart);
        verticalBars.on('mouseover', toolTipForColChart.show)  .on('mouseout', toolTipForColChart.hide);
		
        var width1 = svgPanelForColAndLineChart[0][0].clientWidth;
        var height1 = svgPanelForColAndLineChart[0][0].clientHeight;

        var root = targetElement;
        var scr = { x: window.scrollX, y: window.scrollY, w: svgPanelForColAndLineChart[0][0].clientWidth, h: svgPanelForColAndLineChart[0][0].clientHeight };
        var body_sel = d3.select('body');
        var body = { w: body_sel.node().offsetWidth, h: body_sel.node().offsetHeight };
        var doc = { w: width, h: height };
        var svgpos = root.node().parentNode
        
        var dist = { x: 20, y: 20 };
        
        verticalBars.on("mousemove", function(d,i){
            
            toolTipForColChart.style("display","block")
                        
            var m = d3.mouse(root.node());
            scr.x = window.scrollX;
            scr.y = window.scrollY;
            m[0] += 0
            m[1] += 0
            toolTipForColChart.style("right", "");
            toolTipForColChart.style("left", "");
            toolTipForColChart.style("bottom", "");
            toolTipForColChart.style("top", "");
            
			toolTipForColChart.style("border-color", colors[0])
			if(d3.mouse(this)[0] < scr.w/2){
				
				toolTipForColChart.style("left", (d3.event.pageX + 12 )  + "px");
				toolTipForColChart.style("top", (d3.event.pageY - ( parseFloat(toolTipForColChart.style("height")) /2  ) )+ "px");
			}
			else if(d3.mouse(this)[0] > scr.w/2){
				
				toolTipForColChart.style("left", (d3.event.pageX) - (parseFloat(toolTipForColChart.style("width"), 10) + 20) + "px");
				toolTipForColChart.style("top", (d3.event.pageY - ( parseFloat(toolTipForColChart.style("height")) /2  ) ) + "px");
			}
			else if(d3.mouse(this)[0] == scr.w/2){
				
				toolTipForColChart.style("left", (d3.event.pageX) - (parseFloat(toolTipForColChart.style("width"), 10) + 20) + "px");
				toolTipForColChart.style("top", (d3.event.pageY - ( parseFloat(toolTipForColChart.style("height")) /2  ) ) + "px");
			}
		});
    
        var valueArrayForLine = options.data.map(function(d) { return +d[options.keys.valueForLine]; })
        var toolTipForLineChart = d3.tip() .attr('class', 'd3-tip') .offset([-10, 0]) .style("font-family","Verdana,sans-serif").style("padding","4px").style("text-transform","capitalize")
        .style("font-weight","Bold").style("font-size","12px").style("color","#00001c").style("z-index",1000)
        .html(function(d, i) {
            var valueForColAndLineChartToolTip_Line;
            if(valueArrayForLine[i].toString().indexOf('.') === -1)
            {
                valueForColAndLineChartToolTip_Line = valueArrayForLine[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            else{
                        
                valueForColAndLineChartToolTip_Line = valueArrayForLine[i];
            }
            return options.keys.label + " : " + labelArray[i] + "<br>" + '<hr style="height:2px; width:100%px; margin:2px; border:none;color:#333;background-color:#E0E0E0;" />'+ options.keys.valueForLine + " : " + valueForColAndLineChartToolTip_Line;
        });  

        svg.call(toolTipForLineChart);
        circles.on('mouseover', toolTipForLineChart.show)  .on('mouseout', toolTipForLineChart.hide);

        circles.on("mousemove", function(d,i){
            
            toolTipForLineChart.style("display","block")
            
            var m = d3.mouse(root.node());
            scr.x = window.scrollX;
            scr.y = window.scrollY;
            m[0] += 0
            m[1] += 0
            toolTipForLineChart.style("right", "");
            toolTipForLineChart.style("left", "");
            toolTipForLineChart.style("bottom", "");
            toolTipForLineChart.style("top", "");
            
			toolTipForLineChart.style("border-color", colors[1])
			if(d3.mouse(this)[0] < scr.w/2){
				
				toolTipForLineChart.style("left", (d3.event.pageX + 12 )  + "px");
				toolTipForLineChart.style("top", (d3.event.pageY - ( parseFloat(toolTipForLineChart.style("height")) /2  ) )+ "px");
			}
			else if(d3.mouse(this)[0] > scr.w/2){
				
				toolTipForLineChart.style("left", (d3.event.pageX) - (parseFloat(toolTipForLineChart.style("width"), 10) + 20) + "px");
				toolTipForLineChart.style("top", (d3.event.pageY - ( parseFloat(toolTipForLineChart.style("height")) /2  ) ) + "px");
			}
			else if(d3.mouse(this)[0] == scr.w/2){
				
				toolTipForLineChart.style("left", (d3.event.pageX) - (parseFloat(toolTipForLineChart.style("width"), 10) + 20) + "px");
				toolTipForLineChart.style("top", (d3.event.pageY - ( parseFloat(toolTipForLineChart.style("height")) /2  ) ) + "px");
			}
		});
        
        
            verticalBars.on("click", function(d,i) { toolTipForColChart.style("display","none") })
            circles.on("click", function(d,i) { toolTipForLineChart.style("display","none") })
        
        // Creating table 
        var tableDivForColAndLineChart = targetElement .append('div') .attr("class","scrollingDivForTable-Class tableDivForColAndLineChart" + targetElement[0][0].id)
            .style('background-color',"#ffffff") .style("position","absolute") .style("display","block") .style("overflow","hidden")
            //.style("border-right","1px solid #e2e2e2").style("border-bottom","1px solid #e2e2e2")

            $( '.tableDivForColAndLineChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
                var e0 = e.originalEvent,
                delta = e0.wheelDelta || -e0.detail;
    
                this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
                e.preventDefault();
            });
            
            if(options.showTitle == true){
                tableDivForColAndLineChart.style("width", 100 + "%") .style("height", 40 + "%") .style("top",60 + "%") 
                       
            }
            else if(options.showTitle == false){
                tableDivForColAndLineChart.style("width", 100 + "%") .style("height", 40 + "%") .style("top",60 + "%") 
            }


        tableDivForColAndLineChart.html('<table class = "tableClassForColAndLineChart' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                        '<thead class = "theadClassForColAndLineChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForColAndLineChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                                        '<tbody class = "tBodyClassForColAndLineChart' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                        '</table>'
                                        )
        
        tableDivForColAndLineChart.select('table').attr("id",targetElement[0][0].id + "tableID")

        // Show or Hide Table scroll bar when mouseover on widget
        targetElement.on('mouseover',function(){ tableDivForColAndLineChart.style("overflow","auto") })
        targetElement.on('mouseout',function(d){ tableDivForColAndLineChart.style("overflow","hidden") })
        
        var tableDataForColAndLineChart = [];
        if(options.dataForTable.length > 0){
            tableDataForColAndLineChart = options.dataForTable;
        }
        else {
            tableDataForColAndLineChart = options.data;
        }
        
        var thead = tableDivForColAndLineChart.select("thead").selectAll("th") .data(d3.keys(tableDataForColAndLineChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#fefdfd")//f6f6f6
        .style("position","relative").style("top","2px")
        
        var thead1 = d3.select(".thead1ClassForColAndLineChart" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tableDataForColAndLineChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#fefdfd")//f6f6f6
        .style("position","relative").style("top","2px")
        
        var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
        .attr("id", "ascendingIconIDForColAndLineChart") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
        
        var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
        .attr("id", "descendingIconIDForColAndLineChart") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
        
        var tr = tableDivForColAndLineChart.select("tbody").selectAll("tr") .data(tableDataForColAndLineChart).enter().append("tr")
        .attr("id", function(d,i) { return "slice" + i })
        
        // cells
        var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d})
        .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
        
        var $table = $('.tableClassForColAndLineChart' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
        
        d3.select(".theadClassForColAndLineChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                d.forEach(function(dd,j){
                    colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                })
        })
        
        $(".thead1ClassForColAndLineChart" + targetElement[0][0].id).insertAfter('.tBodyClassForColAndLineChart' + targetElement[0][0].id)
        
        $(".thead1ClassForColAndLineChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForColAndLineChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
        
        tableDivForColAndLineChart.select(".thead1ClassForColAndLineChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
             d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
         })
        
        $('.tableDivForColAndLineChart' + targetElement[0][0].id).scroll(function () {
                                                                  
          $(".thead1ClassForColAndLineChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForColAndLineChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
          
       })
        
        var sortOrder = false;
        thead1.on("click",function(k,index){
                 
             sortOrder = !sortOrder;
             
			tableDivForColAndLineChart.select(".thead1ClassForColAndLineChart" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                                                
				if (sortOrder) {
								  
					if(i == index){
						d3.select(this).select('svg').select('#descendingIconIDForColAndLineChart').style("visibility", "hidden")
						d3.select(this).select('svg').select('#ascendingIconIDForColAndLineChart').style("visibility", "visible")
					}
					else {
						d3.select(this).select('svg').select('#descendingIconIDForColAndLineChart').style("visibility", "visible")
						d3.select(this).select('svg').select('#ascendingIconIDForColAndLineChart').style("visibility", "visible")
					}
				}
				else{
								  
					if(i == index){
						d3.select(this).select('svg').select('#descendingIconIDForColAndLineChart').style("visibility", "visible")
						d3.select(this).select('svg').select('#ascendingIconIDForColAndLineChart').style("visibility", "hidden")
					}
					else {
						d3.select(this).select('svg').select('#descendingIconIDForColAndLineChart').style("visibility", "visible")
						d3.select(this).select('svg').select('#ascendingIconIDForColAndLineChart').style("visibility", "visible")
					}
				}
            })
             
			var monthTruOrFalAryForColAndLineChart = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
              
              tr.sort(function(a, b) {
                      
                      if (sortOrder) {
                      var monthsArrayForColAndLineChart = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                      } else {
                      var monthsArrayForColAndLineChart = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                      }
                      
                      monthTruOrFalAryForColAndLineChart = []; gotMonthArray = [];
                      tableDataForColAndLineChart.forEach(function(d,i){
                          var da = d[k].toString().substring(0,3).toLowerCase()
                          if(monthsArrayForColAndLineChart.indexOf(da) >= 0){
                              monthTruOrFalAryForColAndLineChart.push(true)
                              gotMonthArray.push(da);
                          }
                          else {
                              monthTruOrFalAryForColAndLineChart.push(false)
                          }
                      })
                      
                      if(monthTruOrFalAryForColAndLineChart.indexOf(false) == -1){ // true
                      
                      monthArray = []; monthArrayCount = [];
                      gotMonthArray.forEach(function(dd,j){
                            var index1 = monthsArrayForColAndLineChart.indexOf(dd.substring(0,3))
                            if(monthArrayCount.indexOf(index1) >= 0){
                                index1 = 12 + index1;
                            }
                            monthArray.push(index1);
                            monthArrayCount.push(index1)
                      })
                      returnArray = []
                      monthArray.sort(function(aa, bb) {
                          returnArray.push(+aa - +bb)
                          return +aa - +bb;
                      })
                      
                      sortTableFunc()
                      return returnArray[ind++];
                      } //  if true (if jan feb if block)
                      else {
                      var data = +a[k];
                      
                      if(!isNaN(data)){
                      
                      if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                      else { return d3.descending(+a[k], +b[k]); }
                      }
                      else if(!isNaN(Date.parse(a[k]))){
                      
                      if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                      else { return new Date(b[k]) - new Date(a[k]) }
                      }
                      else {
                      
                      if (sortOrder) { return d3.ascending(a[k], b[k]); }
                      else { return d3.descending(a[k], b[k]); }
                      }
                      } // if not jan feb else block
                }); // tr
             
         })
        
        function sortTableFunc(){
            
            var table = tableDivForColAndLineChart.select('table');
            var rows = table.selectAll('tr').data(tableDataForColAndLineChart);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0) .style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500)
            .style('opacity', 1.0) .style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
            
        }
        
        // Main Table Styling
        tableDivForColAndLineChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
        .style("color","#00001c")
        .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4")
        tableDivForColAndLineChart.selectAll('td').style("height","25px") .style("border", "1px solid #ffffff") .style("font-size","12px") .style("font-weight","Normal") .style("color","#00001c")

        //additionally 
        tableDivForColAndLineChart.selectAll('th').style('background-color',"#ffffff").style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
        tableDivForColAndLineChart.selectAll('td').style("border-style","none").style("color","#00001c")
        //tablePanelForPieChart.selectAll('td').style("height","25px") .style("border", "1px solid #fcfcfc") .style("font-size","12px").style("font-weight","Normal")

        tableDivForColAndLineChart.selectAll('table') . style("border-collapse","collapse")
        tableDivForColAndLineChart.selectAll('table tr:first-child th').style("border-top","0px")
        tableDivForColAndLineChart.selectAll('table tr:last-child td').style("border-bottom","0px")
        tableDivForColAndLineChart.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
        tableDivForColAndLineChart.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")

        if(showOrHideTabForColAndLineChart == false){
            tableDivForColAndLineChart.style("display","none") // Hiding table 
        }
        else if(showOrHideTabForColAndLineChart == true){
            tableDivForColAndLineChart.style("display","block") // Showing table
        }
        
        if(options.isDataDetailedForTable == false){
        
            var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
        
            // Adding underlines for selected drill-down column text
            var drillDownSectionsForColAndLineChart = tableDivForColAndLineChart.select('table').selectAll('th')
        
            var foundResult = [];
            for(var i = 0; i<drillDownSectionsForColAndLineChart[0].length; i++){
                for(var j = 0; j<drillDownColumnNamesArray.length; j++){
                    if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForColAndLineChart[0][i].__data__.toString().toLowerCase() ){
                        foundResult.push(i)
                    }
                }
            }
        
            var r = tableDivForColAndLineChart.select('table').selectAll('tr').selectAll('td')
            for(var i = 0; i<r.length; i++){
                for(var j = 0; j < foundResult.length; j++){
                    var row = r[i][foundResult[j]]
                        $(row).css("text-decoration", "underline")
                }
            
                /*var row = r[i][foundResult[0]]
                 $(row).css("text-decoration", "underline")*/
            }
        }

        //By default calling the resized function first time (to align table's th and td).
        setTimeout(function(){ resizedFuctionForColumnAndLineChart() },1000)
        
        var divWidth;
        var divHeight;

        window.addEventListener('resize', function(event){ resizedFuctionForColumnAndLineChart() });
        
        $(function() {
        	$("#" + targetElement[0][0].id).resizable({
				resize: function(event, ui) {
					divWidth = ui.size.width;
					divHeight = ui.size.height;
					resizedFuctionForColumnAndLineChart();
                }
			});
		});
            
        function resizedFuctionForColumnAndLineChart(){

            if((svgPanelForColAndLineChart.node().getBoundingClientRect().width) && (svgPanelForColAndLineChart.node().getBoundingClientRect().height) > 0){

                var margin1 = {top: 30 , right: 40, bottom: 80, left: 40}, //originally top: 42, left: 80
                width1 = (svgPanelForColAndLineChart.node().getBoundingClientRect().width) - margin1.left - margin1.right,
                height1 = svgPanelForColAndLineChart.node().getBoundingClientRect().height - margin1.top - margin1.bottom;
                
                if(showOrHideCommentsBtnForColAndLineChart == true){
                    refreshButtonForColAndLineChart.style('margin-left', "2px")
                    commentsBtnForColAndLineChart.style('margin-left', "2px")
                    menuButtonForColAndLineChart.style('right', '0')
                }
                else if(showOrHideCommentsBtnForColAndLineChart == false){
                    refreshButtonForColAndLineChart.style('margin-left', "2px")
                    //commentsBtnForColAndLineChart.style('right', '0')
                    commentsBtnForColAndLineChart.style('display','none')
                    menuButtonForColAndLineChart.style('right', '0')
                }
                optsBtnPanelForColAndLineChart.style('right', '0')

                stgPanCanBtnForColAndLineChart.style('right', '0') //  setting cancel button
            
                var xx = d3.scale.linear() .domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.label]; }))]) .range([0, width1]);

                var yyLeft = d3.scale.linear() .domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.valueForColumn]; }))]) .range([height1, 0]);

                var yyRight = d3.scale.linear() .domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.valueForLine]; }))]) .range([height1, 0]);
            
                yLeftAxis.scale(yyLeft) .orient("left") //.ticks(5);
            
                x1.domain(options.data.map(function(d) { return d[options.keys.label]; })) .rangeRoundBands([0, width1], 0.25);
            
                xAxis.scale(x1) .orient("bottom") //.ticks(40);

                var svg1 = svg//.transition();
            
                svg1.select("svg") .attr("width", width1 + margin1.left + margin1.right) .attr("height", height1 + margin1.top + margin1.bottom);
            
                svg1.select(".y.axis").call(yyLeft)
            
                svg1.select(".x.axis") .attr("transform", "translate(0," + height1 + ")") .call(xAxis)
            
                // Add the X Axis margin labels
                .selectAll("text") .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') 
                .attr("transform", function(d) { 
                    if(numberGreaterThanLimit.length>0){return "rotate(-45)"}
                else{
                return "rotate(0)" }})
            .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
            .text(function(d,i) {
                if(d.length > 20)
                    return d.substring(0,10)+'...';
                else
                    return d;
            })       
            
                yLeftAxisLabVar.attr("transform", "rotate(-90)").attr("y", -25).attr("x",0 - (height1 / 2)).attr("dy", "1em")

                xAxisVariable.attr("transform", "translate(" + (width1/2) + " ," + (height1+margin1.bottom - 2) + ")")

                yRightAxisLabVar.attr("transform", "translate(" + width1 + ",0)rotate(90)").attr("y", -25).attr("x",height1/2)

                xScale.domain(d3.range(options.data.map(function(d) { return +d[options.keys.label]; }).length)) .rangeRoundBands([0, width1], 0.25);
            
                yScale.domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.valueForColumn]; }), function(d) { return d; })]) .range([0, height1]);
				
                svg1.selectAll(".bar") .attr("x", function(d, i) { return xScale(i); }) .attr("width", xScale.rangeBand())
                .attr("y", function(d) { return height1 - yScale(d); }) .attr("height", function(d) { return yScale(d); })

                xScaleForLineText = d3.scale.ordinal() .domain(d3.range(options.data.map(function(d) { return +d[options.keys.label]; }).length)) .rangeRoundBands([0, width1], 0.25);
                yScaleForLineText = d3.scale.linear() .domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.valueForLine]; }), function(d) { return d; })]) .range([0, height1]);

                x2 = d3.scale.ordinal().domain(options.data.map(function(d) { return d[options.keys.label];})).rangePoints([0, width1],1.35);
        
                y = d3.scale.linear().domain([0, d3.max(options.data, function(d) { return d[options.keys.valueForLine]; })]).range([height1, 0]);

                svg1.selectAll(".circle") .attr("cx", function (d, i) { return x2(d[options.keys.label]); })
                .attr("cy", function (d, i) { return y(d[options.keys.valueForLine]); })
        
                valueline .x(function(d) { return x2(d[options.keys.label]); }) .y(function(d) { return y(d[options.keys.valueForLine]); });

                svg1.selectAll(".line") .attr("d", valueline(options.data))

                svg.selectAll(".series_value")  .attr("x", function(d,i) { return xScale(i)+xScale.rangeBand()/2; })
                .attr("y", function(d,i) { return height1-yScale(d)+yTextPadding; })
               
				
				svg.selectAll(".bartext") .attr("x", function(d,i) { return xScale(i)+xScale.rangeBand()/2; })
                .attr("y", function(d,i) { return height1-yScale(d)+yTextPadding; })

                textOnDotsForColAndLineChart .attr("x", function(d,i) { return xScaleForLineText(i)+xScaleForLineText.rangeBand()/2; })
                .attr("y", function(d,i) { return height1-yScaleForLineText(d)+15; })
                
                colWidth = []; 
				
                d3.select(".theadClassForColAndLineChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
					d.forEach(function(dd,j){
						colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
					})
                })
                tableDivForColAndLineChart.select(".thead1ClassForColAndLineChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
					d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
                })
                
            }// checking svg panel width & height is greater than zero function
        } // resize function ends here....

    }, //columnAndLineChart

    // ************************************************** Percentage Gauge  **************************************************
    perGauge: function(targetElement, options){

        isChartCalled++;

        var chartName = "PERGAUGE";
        
        acinfotech.allCharts(targetElement,options,chartName);
        
        targetElement.style("min-width", "350px").style("min-height", "350px").style("background-color", options.BGcolor)

        var chartTitlePanelForLiquidGauge =  targetElement.append("div").style("background-color", options.BGcolor).style("position","absolute").style("text-indent","6px")
        
        // additionally
        .style("background-color", options.BGcolor).style("border", "none")

        var svgPanelForLiquidGauge = targetElement .append('svg') 
        .attr("id","svgPanelForLiquidGauge" + targetElement[0][0].id) .style("background-color", options.BGcolor) .style("position","absolute")

        if(options.showTitle == true){
            
            chartTitlePanelForLiquidGauge.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 10 + "%"; })
            .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:10.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')
            svgPanelForLiquidGauge.attr('width', 100 + "%") .attr('height', 90 + "%") .style("top",10 + "%") .style("background-color", options.BGcolor).append('g')
            
        }
        else if(options.showTitle == false){
            chartTitlePanelForLiquidGauge.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });
            svgPanelForLiquidGauge.attr('width', 100 + "%") .attr('height', 100 + "%") .style("left",0 + "%") .style("background-color", options.BGcolor).append('g')
        }

        //var gauge1 = loadLiquidFillGauge("svgPanelForLiquidGauge", 55);
        var percentageConfig = liquidFillGaugeDefaultSettings();
        
        var gaugeGroupVar;

        if((options.data >= 0) && (options.data <= 25)){
            percentageConfig.circleColor = "#fd3a3a";
            percentageConfig.textColor = "#ff3333";
            percentageConfig.waveTextColor = "#ff3333";
            percentageConfig.waveColor = "#ffc4c4";
            percentageConfig.circleThickness = 0.2;
            percentageConfig.textVertPosition = 0.5;
            percentageConfig.waveAnimateTime = 1000;
        }
        else if((options.data > 25) && (options.data <= 75)){
            percentageConfig.circleColor = "#ff8000";
            percentageConfig.textColor = "#ff8227";
            percentageConfig.waveTextColor = "#ff8227";
            percentageConfig.waveColor = "#ffddc4";
            percentageConfig.circleThickness = 0.2;
            percentageConfig.textVertPosition = 0.5;
            percentageConfig.waveAnimateTime = 1000;
        }
        else if((options.data > 75) && (options.data <= 100)){
            percentageConfig.circleColor = "#51e597";
            percentageConfig.textColor = "#51e597";
            percentageConfig.waveTextColor = "#51e597";
            percentageConfig.waveColor = "#caffb8";
            percentageConfig.circleThickness = 0.2;
            percentageConfig.textVertPosition = 0.5;
            percentageConfig.waveAnimateTime = 1000;
        }
        
        var gauge2= loadLiquidFillGauge("svgPanelForLiquidGauge" + targetElement[0][0].id, options.data, percentageConfig);
        
        function liquidFillGaugeDefaultSettings(){
            return {
                minValue: 0, // The gauge minimum value.
                maxValue: 100, // The gauge maximum value.
                circleThickness: 0.05, // The outer circle thickness as a percentage of it's radius.
                circleFillGap: 0.05, // The size of the gap between the outer circle and wave circle as a percentage of the outer circles radius.
                circleColor: "#178BCA", // The color of the outer circle.
                waveHeight: 0.05, // The wave height as a percentage of the radius of the wave circle.
                waveCount: 1, // The number of full waves per width of the wave circle.
                waveRiseTime: 1000, // The amount of time in milliseconds for the wave to rise from 0 to it's final height.
                waveAnimateTime: 18000, // The amount of time in milliseconds for a full wave to enter the wave circle.
                waveRise: true, // Control if the wave should rise from 0 to it's full height, or start at it's full height.
                waveHeightScaling: true, // Controls wave size scaling at low and high fill percentages. When true, wave height reaches it's maximum at 50% fill, and minimum at 0% and 100% fill. This helps to prevent the wave from making the wave circle from appear totally full or empty when near it's minimum or maximum fill.
                waveAnimate: true, // Controls if the wave scrolls or is static.
                waveColor: "#178BCA", // The color of the fill wave.
                waveOffset: 0, // The amount to initially offset the wave. 0 = no offset. 1 = offset of one full wave.
                textVertPosition: .5, // The height at which to display the percentage text withing the wave circle. 0 = bottom, 1 = top.
                textSize: 1, // The relative height of the text to display in the wave circle. 1 = 50%
                valueCountUp: true, // If true, the displayed value counts up from 0 to it's final value upon loading. If false, the final value is displayed.
                displayPercent: true, // If true, a % symbol is displayed after the value.
                textColor: "#045681", // The color of the value text when the wave does not overlap it.
                waveTextColor: "#A4DBf8" // The color of the value text when the wave overlaps it.
            };
        }

        function loadLiquidFillGauge(elementId, value, config) {
            if(config == null) config = liquidFillGaugeDefaultSettings();

            var gauge = d3.select("#" + elementId);
            var radius = Math.min(parseInt(gauge.style("width")), parseInt(gauge.style("height")))/2.8;
            var locationX = parseInt(gauge.style("width"))/2 - radius;
            var locationY = parseInt(gauge.style("height"))/2 - radius;
            var fillPercent = Math.max(config.minValue, Math.min(config.maxValue, value))/config.maxValue;

            var waveHeightScale;
            if(config.waveHeightScaling){
                waveHeightScale = d3.scale.linear()
                    .range([0,config.waveHeight,0])
                    .domain([0,50,100]);
            } else {
                waveHeightScale = d3.scale.linear()
                    .range([config.waveHeight,config.waveHeight])
                    .domain([0,100]);
            }

            var textPixels = (config.textSize*radius/2);
            var textFinalValue = parseFloat(value).toFixed(2);
            var textStartValue = config.valueCountUp?config.minValue:textFinalValue;
            var percentText = config.displayPercent?"%":"";
            var circleThickness = config.circleThickness * radius;
            var circleFillGap = config.circleFillGap * radius;
            var fillCircleMargin = circleThickness + circleFillGap;
            var fillCircleRadius = radius - fillCircleMargin;
            var waveHeight = fillCircleRadius*waveHeightScale(fillPercent*100);

            var waveLength = fillCircleRadius*2/config.waveCount;
            var waveClipCount = 1+config.waveCount;
            var waveClipWidth = waveLength*waveClipCount;

            // Rounding functions so that the correct number of decimal places is always displayed as the value counts up.
            var textRounder = function(value){ return Math.round(value); };
            if(parseFloat(textFinalValue) != parseFloat(textRounder(textFinalValue))){
                textRounder = function(value){ return parseFloat(value).toFixed(1); };
            }
            if(parseFloat(textFinalValue) != parseFloat(textRounder(textFinalValue))){
                textRounder = function(value){ return parseFloat(value).toFixed(2); };
            }

            // Data for building the clip wave area.
            var data = [];
            for(var i = 0; i <= 40*waveClipCount; i++){
                data.push({x: i/(40*waveClipCount), y: (i/(40))});
            }

            // Scales for drawing the outer circle.
            var gaugeCircleX = d3.scale.linear().range([0,2*Math.PI]).domain([0,1]);
            var gaugeCircleY = d3.scale.linear().range([0,radius]).domain([0,radius]);

            // Scales for controlling the size of the clipping path.
            var waveScaleX = d3.scale.linear().range([0,waveClipWidth]).domain([0,1]);
            var waveScaleY = d3.scale.linear().range([0,waveHeight]).domain([0,1]);

            // Scales for controlling the position of the clipping path.
            var waveRiseScale = d3.scale.linear()
                // The clipping area size is the height of the fill circle + the wave height, so we position the clip wave
                // such that the it will overlap the fill circle at all when at 0%, and will totally cover the fill
                // circle at 100%.
                .range([(fillCircleMargin+fillCircleRadius*2+waveHeight),(fillCircleMargin-waveHeight)])
                .domain([0,1]);
            var waveAnimateScale = d3.scale.linear()
                .range([0, waveClipWidth-fillCircleRadius*2]) // Push the clip area one full wave then snap back.
                .domain([0,1]);

            // Scale for controlling the position of the text within the gauge.
            var textRiseScaleY = d3.scale.linear()
                .range([fillCircleMargin+fillCircleRadius*2,(fillCircleMargin+textPixels*0.7)])
                .domain([0,1]);

            // Center the gauge within the parent SVG.
            var gaugeGroup = gauge.append("g")
                .attr('transform','translate('+locationX+','+locationY+')');

            gaugeGroupVar = gaugeGroup;

            // Draw the outer circle.
            var gaugeCircleArc = d3.svg.arc()
                .startAngle(gaugeCircleX(0))
                .endAngle(gaugeCircleX(1))
                .outerRadius(gaugeCircleY(radius))
                .innerRadius(gaugeCircleY(radius-circleThickness));
            gaugeGroup.append("path")
                .attr("d", gaugeCircleArc)
                .style("fill", config.circleColor)
                .attr('transform','translate('+radius+','+radius+')');

            // Text where the wave does not overlap.
            var text1 = gaugeGroup.append("text")
                .text(textRounder(textFinalValue) + percentText)
                .attr("class", "liquidFillGaugeText" + targetElement[0][0].id)
                .attr("text-anchor", "middle")
                //.attr("font-size", textPixels + "px")
                .style("font-size", "35px")
                .style("fill", config.textColor).style("font-family","Verdana,sans-serif")
                .attr('transform','translate('+radius+','+textRiseScaleY(config.textVertPosition)+')')


            // The clipping wave area.
            var clipArea = d3.svg.area()
                .x(function(d) { return waveScaleX(d.x); } )
                .y0(function(d) { return waveScaleY(Math.sin(Math.PI*2*config.waveOffset*-1 + Math.PI*2*(1-config.waveCount) + d.y*2*Math.PI));} )
                .y1(function(d) { return (fillCircleRadius*2 + waveHeight); } );
            var waveGroup = gaugeGroup.append("defs")
                .append("clipPath")
                .attr("id", "clipWave" + elementId);
            var wave = waveGroup.append("path")
                .datum(data)
                .attr("d", clipArea)
                .attr("T", 0);

            // The inner circle with the clipping wave attached.
            var fillCircleGroup = gaugeGroup.append("g")
                .attr("clip-path", "url(#clipWave" + elementId + ")");
                fillCircleGroup.append("circle")
                .attr("cx", radius)
                .attr("cy", radius)
                .attr("r", fillCircleRadius)
                .style("fill", config.waveColor);

            // Text where the wave does overlap.
            var text2 = fillCircleGroup.append("text")
                .text(textRounder(textFinalValue) + percentText)
                .attr("class", "liquidFillGaugeText" + targetElement[0][0].id)
                .attr("text-anchor", "middle")
                .style("font-size", "34px")
                .style("fill", config.waveTextColor).style("font-family","Verdana,sans-serif")
                .attr('transform','translate('+radius+','+textRiseScaleY(config.textVertPosition)+')');
			
            // Make the wave rise. wave and waveGroup are separate so that horizontal and vertical movement can be controlled independently.
            var waveGroupXPosition = fillCircleMargin+fillCircleRadius*2-waveClipWidth;
            if(config.waveRise){
                waveGroup.attr('transform','translate('+waveGroupXPosition+','+waveRiseScale(0)+')')
                    .transition()
                    .duration(config.waveRiseTime)
                    .attr('transform','translate('+waveGroupXPosition+','+waveRiseScale(fillPercent)+')')
                    .each("start", function(){ wave.attr('transform','translate(1,0)'); }); // This transform is necessary to get the clip wave positioned correctly when waveRise=true and waveAnimate=false. The wave will not position correctly without this, but it's not clear why this is actually necessary.
            } else {
                waveGroup.attr('transform','translate('+waveGroupXPosition+','+waveRiseScale(fillPercent)+')');
            }

            if(config.waveAnimate) animateWave();

            function animateWave() {
                wave.attr('transform','translate('+waveAnimateScale(wave.attr('T'))+',0)');
                wave.transition()
                    .duration(config.waveAnimateTime * (1-wave.attr('T')))
                    .ease('linear')
                    .attr('transform','translate('+waveAnimateScale(1)+',0)')
                    .attr('T', 1)
                    .each('end', function(){
                        wave.attr('T', 0);
                        animateWave(config.waveAnimateTime);
                    });
            }

            function GaugeUpdater(){
                this.update = function(value){
                    var newFinalValue = parseFloat(value).toFixed(2);
                    var textRounderUpdater = function(value){ return Math.round(value); };
                    if(parseFloat(newFinalValue) != parseFloat(textRounderUpdater(newFinalValue))){
                        textRounderUpdater = function(value){ return parseFloat(value).toFixed(1); };
                    }
                    if(parseFloat(newFinalValue) != parseFloat(textRounderUpdater(newFinalValue))){
                        textRounderUpdater = function(value){ return parseFloat(value).toFixed(2); };
                    }

                    var textTween = function(){
                        var i = d3.interpolate(this.textContent, parseFloat(value).toFixed(2));
                        return function(t) { this.textContent = textRounderUpdater(i(t)) + percentText; }
                    };

                    text1.transition()
                        .duration(config.waveRiseTime)
                        .tween("text", textTween);
                    text2.transition()
                        .duration(config.waveRiseTime)
                        .tween("text", textTween);

                    var fillPercent = Math.max(config.minValue, Math.min(config.maxValue, value))/config.maxValue;
                    var waveHeight = fillCircleRadius*waveHeightScale(fillPercent*100);
                    var waveRiseScale = d3.scale.linear()
                        // The clipping area size is the height of the fill circle + the wave height, so we position the clip wave
                        // such that the it will overlap the fill circle at all when at 0%, and will totally cover the fill
                        // circle at 100%.
                        .range([(fillCircleMargin+fillCircleRadius*2+waveHeight),(fillCircleMargin-waveHeight)])
                        .domain([0,1]);
                    var newHeight = waveRiseScale(fillPercent);
                    var waveScaleX = d3.scale.linear().range([0,waveClipWidth]).domain([0,1]);
                    var waveScaleY = d3.scale.linear().range([0,waveHeight]).domain([0,1]);
                    var newClipArea;
                    if(config.waveHeightScaling){
                        newClipArea = d3.svg.area()
                            .x(function(d) { return waveScaleX(d.x); } )
                            .y0(function(d) { return waveScaleY(Math.sin(Math.PI*2*config.waveOffset*-1 + Math.PI*2*(1-config.waveCount) + d.y*2*Math.PI));} )
                            .y1(function(d) { return (fillCircleRadius*2 + waveHeight); } );
                    } else {
                        newClipArea = clipArea;
                    }

                    var newWavePosition = config.waveAnimate?waveAnimateScale(1):0;
                    wave.transition()
                        .duration(0)
                        .transition()
                        .duration(config.waveAnimate?(config.waveAnimateTime * (1-wave.attr('T'))):(config.waveRiseTime))
                        .ease('linear')
                        .attr('d', newClipArea)
                        .attr('transform','translate('+newWavePosition+',0)')
                        .attr('T','1')
                        .each("end", function(){
                            if(config.waveAnimate){
                                wave.attr('transform','translate('+waveAnimateScale(0)+',0)');
                                animateWave(config.waveAnimateTime);
                            }
                        });
                    waveGroup.transition()
                        .duration(config.waveRiseTime)
                        .attr('transform','translate('+waveGroupXPosition+','+newHeight+')')
                }
            }

            return new GaugeUpdater();
        }
        
        window.addEventListener('resize', function(event){ resizedFuctionForPerGauge() });
        
        $(function() {
			$("#" + targetElement[0][0].id).resizable({
                resize: function(event, ui) {
                    resizedFuctionForPerGauge();
                }
            });
		});
        
        function resizedFuctionForPerGauge(){
            if((svgPanelForLiquidGauge.node().getBoundingClientRect().width) && (svgPanelForLiquidGauge.node().getBoundingClientRect().height) > 0){
                
                d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                acinfotech.perGauge(targetElement,options)
            }
        }
        
    }, //perGauge
    
    // ************************************************** Number Gauge  **************************************************
    numberGauge: function(targetElement, options){

        isChartCalled++;

        var chartName = "NUMBERGAUGE";
        
        acinfotech.allCharts(targetElement,options,chartName);
        
        targetElement.style("min-width", "350px").style("min-height", "350px").style("background-color",options.BGcolor)
        
        var chartTitlePanelForNumberGauge =  targetElement.append("div").style("background-color","#ffbb03").style("position","absolute").style("text-indent","6px")
        .style("background-color",options.BGcolor).style("border", "none")

        var svgPanelForNumberGauge = targetElement .append('svg') 
        .attr("id","svgPanelForLiquidGauge" + targetElement[0][0].id) .style("background-color",options.BGcolor).style("position","absolute")

        if(options.showTitle == true){
            
            chartTitlePanelForNumberGauge.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 10 + "%"; }).style("background-color",options.BGcolor)
            .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:10.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')
            svgPanelForNumberGauge.attr('width', 100 + "%") .attr('height', 90 + "%") .style("top",10 + "%") .style("background-color",options.BGcolor).append('g')
            
        }
        else if(options.showTitle == false){
            chartTitlePanelForNumberGauge.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; }).style("background-color",options.BGcolor);
            svgPanelForNumberGauge.attr('width', 100 + "%") .attr('height', 100 + "%") .style("left",0 + "%").style("background-color",options.BGcolor) .append('g')
        }
        var colors = [];
        // checking color set for pie slices and legend dots
        if(options.colorSet === undefined){
            options.colorSet = "one"
            
            colors[0] = "#00A9E9"; colors[1] = "#BC851C";
        }
        else if(options.colorSet.toString().toLowerCase() === "one"){
            options.colorSet = "one"
            
            colors[0] = "#00A9E9"; colors[1] = "#BC851C";
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            
            options.colorSet = "two"
            
            colors[0] = "#E95044"; colors[1] = "#F28A4C";
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            options.colorSet = "three"
            
            colors[0] = "#01204F"; colors[1] = "#006A8D";
        }
        else
        {
            options.colorSet = "one"
            
            colors[0] =  "#00A9E9"; colors[1] =  "#BC851C";
        }
        var numberConfig = liquidFillGaugeDefaultSettings();
        numberConfig.circleThickness = 0.2;
        numberConfig.circleColor =colors[0]
        numberConfig.textColor = "#a2a2a5";
        numberConfig.waveTextColor = colors[0];
        numberConfig.waveColor =  "#11ffee00" ;
        numberConfig.textVertPosition = 0.52;
        numberConfig.waveAnimateTime = 5000;
        numberConfig.waveHeight = 0;
        numberConfig.waveAnimate = false;
        numberConfig.waveCount = 2.0;
        numberConfig.waveOffset = 0.25;
        numberConfig.textSize = 1.2;
        numberConfig.minValue = 30;
        numberConfig.maxValue = 150
        numberConfig.displayPercent = false;

    var gauge6 = loadLiquidFillGauge("svgPanelForLiquidGauge" + targetElement[0][0].id, options.data, numberConfig);
        
        function liquidFillGaugeDefaultSettings(){
            return {
                minValue: 0, // The gauge minimum value.
                maxValue: 100, // The gauge maximum value.
                circleThickness: 0.05, // The outer circle thickness as a percentage of it's radius.
                circleFillGap: 0.05, // The size of the gap between the outer circle and wave circle as a percentage of the outer circles radius.
                circleColor: "#178BCA", // The color of the outer circle.
                waveHeight: 0.05, // The wave height as a percentage of the radius of the wave circle.
                waveCount: 1, // The number of full waves per width of the wave circle.
                waveRiseTime: 1000, // The amount of time in milliseconds for the wave to rise from 0 to it's final height.
                waveAnimateTime: 18000, // The amount of time in milliseconds for a full wave to enter the wave circle.
                waveRise: true, // Control if the wave should rise from 0 to it's full height, or start at it's full height.
                waveHeightScaling: true, // Controls wave size scaling at low and high fill percentages. When true, wave height reaches it's maximum at 50% fill, and minimum at 0% and 100% fill. This helps to prevent the wave from making the wave circle from appear totally full or empty when near it's minimum or maximum fill.
                waveAnimate: true, // Controls if the wave scrolls or is static.
                waveColor: "#178BCA", // The color of the fill wave.
                waveOffset: 0, // The amount to initially offset the wave. 0 = no offset. 1 = offset of one full wave.
                textVertPosition: .5, // The height at which to display the percentage text withing the wave circle. 0 = bottom, 1 = top.
                textSize: 1, // The relative height of the text to display in the wave circle. 1 = 50%
                valueCountUp: true, // If true, the displayed value counts up from 0 to it's final value upon loading. If false, the final value is displayed.
                displayPercent: true, // If true, a % symbol is displayed after the value.
                textColor: "#045681", // The color of the value text when the wave does not overlap it.
                waveTextColor: "#A4DBf8" // The color of the value text when the wave overlaps it.
            };
        }

        function loadLiquidFillGauge(elementId, value, config) {
            
            if(config == null) config = liquidFillGaugeDefaultSettings();

            var gauge = d3.select("#" + elementId);
            var radius = Math.min(parseInt(gauge.style("width")), parseInt(gauge.style("height")))/2.8;
            var locationX = parseInt(gauge.style("width"))/2 - radius;
            var locationY = parseInt(gauge.style("height"))/2 - radius;
            var fillPercent = Math.max(config.minValue, Math.min(config.maxValue, value))/config.maxValue;

            var waveHeightScale;
            if(config.waveHeightScaling){
                waveHeightScale = d3.scale.linear()
                    .range([0,config.waveHeight,0])
                    .domain([0,50,100]);
            } else {
                waveHeightScale = d3.scale.linear()
                    .range([config.waveHeight,config.waveHeight])
                    .domain([0,100]);
            }

            var textPixels = (config.textSize*radius/2);
            var textFinalValue = value//.toFixed(2);
            var textStartValue = config.valueCountUp?config.minValue:textFinalValue;
            var percentText = config.displayPercent?"%":"";
            var circleThickness = config.circleThickness * radius;
            var circleFillGap = config.circleFillGap * radius;
            var fillCircleMargin = circleThickness + circleFillGap;
            var fillCircleRadius = radius - fillCircleMargin;
            var waveHeight = fillCircleRadius*waveHeightScale(fillPercent*100);

            var waveLength = fillCircleRadius*2/config.waveCount;
            var waveClipCount = 1+config.waveCount;
            var waveClipWidth = waveLength*waveClipCount;

            // Rounding functions so that the correct number of decimal places is always displayed as the value counts up.
            var textRounder = function(value){ return Math.round(value); };
            if(parseFloat(textFinalValue) != parseFloat(textRounder(textFinalValue))){
                textRounder = function(value){ return parseFloat(value).toFixed(1); };
            }
            if(parseFloat(textFinalValue) != parseFloat(textRounder(textFinalValue))){
                textRounder = function(value){ return parseFloat(value).toFixed(2); };
            }

            // Data for building the clip wave area.
            var data = [];
            for(var i = 0; i <= 40*waveClipCount; i++){
                data.push({x: i/(40*waveClipCount), y: (i/(40))});
            }

            // Scales for drawing the outer circle.
            var gaugeCircleX = d3.scale.linear().range([0,2*Math.PI]).domain([0,1]);
            var gaugeCircleY = d3.scale.linear().range([0,radius]).domain([0,radius]);

            // Scales for controlling the size of the clipping path.
            var waveScaleX = d3.scale.linear().range([0,waveClipWidth]).domain([0,1]);
            var waveScaleY = d3.scale.linear().range([0,waveHeight]).domain([0,1]);

            // Scales for controlling the position of the clipping path.
            var waveRiseScale = d3.scale.linear()
                // The clipping area size is the height of the fill circle + the wave height, so we position the clip wave
                // such that the it will overlap the fill circle at all when at 0%, and will totally cover the fill
                // circle at 100%.
                .range([(fillCircleMargin+fillCircleRadius*2+waveHeight),(fillCircleMargin-waveHeight)])
                .domain([0,1]);
            var waveAnimateScale = d3.scale.linear()
                .range([0, waveClipWidth-fillCircleRadius*2]) // Push the clip area one full wave then snap back.
                .domain([0,1]);

            // Scale for controlling the position of the text within the gauge.
            var textRiseScaleY = d3.scale.linear()
                .range([fillCircleMargin+fillCircleRadius*2,(fillCircleMargin+textPixels*0.7)])
                .domain([0,1]);

            // Center the gauge within the parent SVG.
            var gaugeGroup = gauge.append("g")
                .attr('transform','translate('+locationX+','+locationY+')');

            // Draw the outer circle.
            var gaugeCircleArc = d3.svg.arc()
                .startAngle(gaugeCircleX(0))
                .endAngle(gaugeCircleX(1))
                .outerRadius(gaugeCircleY(radius))
                .innerRadius(gaugeCircleY(radius-circleThickness));
            gaugeGroup.append("path")
                .attr("d", gaugeCircleArc)
                .style("fill", config.circleColor)
                .attr('transform','translate('+radius+','+radius+')');

            // Text where the wave does not overlap.
            var text1 = gaugeGroup.append("text")
                .text(textFinalValue + percentText)
                .attr("class", "liquidFillGaugeText" + targetElement[0][0].id)
                .attr("text-anchor", "middle")
                .style("font-size", "36px")
                .style("fill", config.textColor) .style("font-family","Verdana,sans-serif")
                .attr('transform','translate('+radius+','+textRiseScaleY(config.textVertPosition)+')');

            // The clipping wave area.
            var clipArea = d3.svg.area()
                .x(function(d) { return waveScaleX(d.x); } )
                .y0(function(d) { return waveScaleY(Math.sin(Math.PI*2*config.waveOffset*-1 + Math.PI*2*(1-config.waveCount) + d.y*2*Math.PI));} )
                .y1(function(d) { return (fillCircleRadius*2 + waveHeight); } );
            var waveGroup = gaugeGroup.append("defs")
                .append("clipPath")
                .attr("id", "clipWave" + elementId);
            var wave = waveGroup.append("path")
                .datum(data)
                .attr("d", clipArea)
                .attr("T", 0);

            // The inner circle with the clipping wave attached.
            var fillCircleGroup = gaugeGroup.append("g")
                .attr("clip-path", "url(#clipWave" + elementId + ")");
            fillCircleGroup.append("circle")
                .attr("cx", radius)
                .attr("cy", radius)
                .attr("r", fillCircleRadius)
                .style("fill", config.waveColor);

            // Text where the wave does overlap.
            var text2 = fillCircleGroup.append("text")
                .text(textFinalValue + percentText)
                .attr("class", "liquidFillGaugeText" + targetElement[0][0].id)
                .attr("text-anchor", "middle")
                .style("font-size", "36px")
                .style("fill", config.waveTextColor) .style("font-family","Verdana,sans-serif")
                //.style("text-decoration","underline")
                .attr('transform','translate('+radius+','+textRiseScaleY(config.textVertPosition)+')');
			
        }
        
        window.addEventListener('resize', function(event){ resizedFuctionForNumberGauge() });
        
        $(function() {
          $("#" + targetElement[0][0].id).resizable({
                resize: function(event, ui) {
                    resizedFuctionForNumberGauge();
                }
            });
          });
        
        function resizedFuctionForNumberGauge(){
            if((svgPanelForNumberGauge.node().getBoundingClientRect().width) && (svgPanelForNumberGauge.node().getBoundingClientRect().height) > 0){
                
                d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                acinfotech.numberGauge(targetElement,options)
            }
        }
        
    }, //numberGauge

    // ************************************************** Square Gauge  **************************************************
    squareGauge: function(targetElement, options){
        
        targetElement.style("min-width", "280px").style("min-height", "120px").style('background-color',options.BGcolor)
        
        var valuePanelForSmallWidget =  targetElement.append("div") .attr("class","") .style("position","absolute")
        .style("text-align", "left").style('background-color',options.BGcolor).style("text-indent","6px") .style("border", "none")
        
        var titlPanelForSmallWidget =  targetElement.append("div") .attr("class","chartTitlePanelClass") .style("position","absolute")
        .style("text-align", "left") .style('background-color',options.BGcolor) .style("text-indent","10px") .style("border", "none")
        
        //var gauge = d3.select("#" + elementId);
        //var radius = Math.min(parseInt(gauge.style("width")), parseInt(gauge.style("height")))/2.8;
        
        if(options.showTitle == true){
            valuePanelForSmallWidget.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 75 + "%"; })
            .style("left", function(d) { return 0 + "%"; }).style("top", function(d) { return 0 + "%"; })
            .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:'+ Math.min(parseInt(valuePanelForSmallWidget.style("width")), parseInt(valuePanelForSmallWidget.style("height")))/4 +'px; font-family:inter; color:#495057; font-weight:Bold;">'+ options.text + '</div>')
            
            titlPanelForSmallWidget.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 25 + "%"; })
            .style("left", function(d) { return 0 + "%"; }).style("top", function(d) { return 75 + "%"; }).style('background-color',options.BGcolor)
            .html('<div  style="width: 100%; height:45%;position: absolute; top:-291%; font-size:16px; font-family:inter;color:#00001c; font-weight:Normal;">'+ options.widgetTitle + '</div>') 
        }
        else if(options.showTitle == false){
            valuePanelForSmallWidget.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 100 + "%"; })
            .style("left", function(d) { return 0 + "%"; }).style("top", function(d) { return 0 + "%"; })
            .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:'+ Math.min(parseInt(valuePanelForSmallWidget.style("width")), parseInt(valuePanelForSmallWidget.style("height")))/4 +'px; font-family:inter; color:#495057; font-weight:Bold;">'+ options.text + '</div>')
            
            titlPanelForSmallWidget.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; })
            .style("left", function(d) { return 0 + "%"; }).style("top", function(d) { return 0 + "%"; })
        
        }
        
        window.addEventListener('resize', function(event){ resizedFuctionForSquareGauge() });
        
        $(function() {
          $("#" + targetElement[0][0].id).resizable({
                resize: function(event, ui) {
                    resizedFuctionForSquareGauge();
                }
            });
        });
        
        function resizedFuctionForSquareGauge(){
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            acinfotech.squareGauge(targetElement, options)
        }
        
    }, //squareGauge

    // ************************************************** Line Chart  **************************************************
    lineChart: function(targetElement, options){
        
        isChartCalled++;
 
         var chartName = "LINECHART";
         
         acinfotech.allCharts(targetElement,options,chartName);
         
         targetElement.style("min-width","350px").style("min-height","350px").style("background-color", options.BGcolor)
 
         var showOrHideTableForLineChart;
         var showOrHideCommentsForLineChart;
         var showOrHideCommentsBtnForLineChart = true;
 
         if((options.showTable == false) || (options.showTable == true)){
             showOrHideTableForLineChart = options.showTable    
         }
         else{
             showOrHideTableForLineChart = false;
         }
 
         // Show or Hide comments
         if (options.showComments == true || false) {
             showOrHideCommentsForLineChart = options.showComments;
         }
         else {
             showOrHideCommentsForLineChart = false;
         }
         
         if (options.comments.length == 0){ 
             showOrHideCommentsForLineChart = false;
             showOrHideCommentsBtnForLineChart = false;
         }
 
         if ((showOrHideTableForLineChart == true) && (showOrHideCommentsForLineChart == true)){
             showOrHideTableForLineChart = true;
             showOrHideCommentsForLineChart = false;
         }
         else if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == false)){
             showOrHideTableForLineChart = false;
             showOrHideCommentsForLineChart = false;
         }
 
         var divWidth, divHeight;
         
         var chartTitlePanelForLineChart = targetElement.append("div") .style("position","absolute").style("background-color", options.BGcolor) .style("text-indent","6px") .style("border", "none")
         
         var optsBtnPanelForLineChart = targetElement.append('div').style('width',"25px").style('height',"185px").style('position','absolute')
         .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px")
         .style('right', '0') .style("min-width","25px") .style("border-style","none")
         .style("border-left", "solid #fcfcfc  1px")
         
         var areaButtonForLineChart = optsBtnPanelForLineChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
         .style('background-color',"#ffffff").style("z-index",10)
         .style('top','80px') .style("cursor","pointer").style("display","block") 
         .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
         var areaBtnImgVar = document.createElement("IMG");
         areaBtnImgVar.src = "images/curveAreaIcon.png";
         areaBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:14px; opacity:0.74;")
         areaButtonForLineChart[0][0].appendChild(areaBtnImgVar)
 
         var filterButtonForLineChart = optsBtnPanelForLineChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
         .style('background-color',"#ffffff").style("z-index",10)
         .style('top','105px') .style("cursor","pointer").style("display","block") 
         .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
         var filterBtnImgVar = document.createElement("IMG");
         filterBtnImgVar.src = "images/filterIcon.png";
         filterBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
         filterButtonForLineChart[0][0].appendChild(filterBtnImgVar)
 
         var refreshButtonForLineChart = optsBtnPanelForLineChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
         .style('background-color',"#ffffff").style("z-index",10)
         .style('top','130px') .style("cursor","pointer").style("display","block") 
         .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
         var refreshBtnImgVar = document.createElement("IMG");
         refreshBtnImgVar.src = "images/refreshIcon.png";
         refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:15px; height:15px; opacity:0.8;")
         refreshButtonForLineChart[0][0].appendChild(refreshBtnImgVar)
 
         var commentsBtnForLineChart = optsBtnPanelForLineChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
         .style('background-color',"#ffffff").style("z-index",10)
         .style('top','155px') .style("cursor","pointer").style("display","block") 
         .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
         var commentsBtnImgVariable = document.createElement("IMG");
         if(options.showComments == false){
             commentsBtnImgVariable.src = "images/showCommentsIcon.png";
         }
         else if(options.showComments == true){
             commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
         }
         commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
         commentsBtnForLineChart[0][0].appendChild(commentsBtnImgVariable)
 
         var menuButtonForLineChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
         .style('background-color',"#ffffff").style("z-index",10)
         .style('top','1px') .style("cursor","pointer").style("display","block") 
         .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
         var menuBtnImgVar = document.createElement("IMG");
         menuBtnImgVar.src = "images/menuIcon.png";
         menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
         menuButtonForLineChart[0][0].appendChild(menuBtnImgVar)
 
         if(showOrHideCommentsBtnForLineChart == true){
             areaButtonForLineChart.style('margin-left', "2px")
             filterButtonForLineChart.style('margin-left', "2px")
             refreshButtonForLineChart.style('margin-left', "2px")
             commentsBtnForLineChart.style('margin-left', "2px")
             menuButtonForLineChart.style('right', '0')
         }
         else if(showOrHideCommentsBtnForLineChart == false){
             areaButtonForLineChart.style('margin-left', "2px")
             filterButtonForLineChart.style('margin-left', "2px")
             refreshButtonForLineChart.style('margin-left', "2px")
             //commentsBtnForLineChart.style('right', '0')
             commentsBtnForLineChart.style('display','none')
             menuButtonForLineChart.style('right', '0')
         }
 
         var ismenuBtnOfLineChartClicked = false;
         menuButtonForLineChart.on('click', function() {
 
             filterPanelForLineChart.style("display","none");
             stgPanDivForLineChart.style("display","none")
 
             if(ismenuBtnOfLineChartClicked == false){
                 ismenuBtnOfLineChartClicked = true;
                 optsBtnPanelForLineChart.style("display","block")
 
                 if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == true)){
                     divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                     .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                     
                     svgPanelForLineChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                     .style("position","absolute").style("background-color", options.BGcolor);
                 }
                 else if ((showOrHideTableForLineChart == true) && (showOrHideCommentsForLineChart == false)){
                     divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                     .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                     
                     svgPanelForLineChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                     .style("position","absolute").style("background-color", options.BGcolor);
                 }
                 else if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == false)){
                     divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                     .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                     
                     svgPanelForLineChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                     .style("position","absolute").style("background-color", options.BGcolor);
                 }
 
             }
             else if(ismenuBtnOfLineChartClicked == true){
                 ismenuBtnOfLineChartClicked = false
                 optsBtnPanelForLineChart.style("display","none")
 
                 if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == true)){
                     divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                     .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                     
                     svgPanelForLineChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                     .style("position","absolute").style("background-color", options.BGcolor);
                 }
                 else if ((showOrHideTableForLineChart == true) && (showOrHideCommentsForLineChart == false)){
                     divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                     .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                     
                     svgPanelForLineChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                     .style("position","absolute").style("background-color", options.BGcolor);
                 }
                 else if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == false)){
                     divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                     .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                     
                     svgPanelForLineChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                     .style("position","absolute").style("background-color", options.BGcolor);
                 }
             }
 
             resizedFunctionForLineChart();
         })
 
         var tableButtonForLineChart = optsBtnPanelForLineChart.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
         .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top','1px')
         .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
         var tableBtnImgVar = document.createElement("IMG");
         if(showOrHideTableForLineChart == false){
             tableBtnImgVar.src = "images/showTableIcon.png";
             tableButtonForLineChart.attr("class","showTableClassForChartTable")
         }
         else if(showOrHideTableForLineChart == true){
             tableBtnImgVar.src = "images/cancelTableIcon.png";
             tableButtonForLineChart.attr("class","hideTableClassForChartTable")
         }
         tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
         tableButtonForLineChart[0][0].appendChild(tableBtnImgVar)
 
         var settingBtnForLineChart = optsBtnPanelForLineChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
         .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 28 + 'px')
         .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
         var settingBtnImgVar = document.createElement("IMG");
         settingBtnImgVar.src = "images/settingsIcon.png";
         settingBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.82;")
         settingBtnForLineChart[0][0].appendChild(settingBtnImgVar)
         
         var downloadBtnForLineChart = optsBtnPanelForLineChart.append("div").attr("id","downloadBtnForLineChart-ID-" + targetElement[0][0].id).style("width","20px").style("height","20px")
         .style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff").style('margin-left','2px').style('top', 54 + 'px')
         .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
         
         acinfotech.downloadFunctionality("downloadBtnForLineChart-ID-" + targetElement[0][0].id,targetElement)
         
         var svgPanelForLineChart = targetElement .append('svg') 
         .attr("id","svgPanelIDForLineChart" + targetElement[0][0].id) .style('background-color',"#ffffff") .style("position","absolute")
         
         var commentsPanelDivForLineChart = targetElement.append("div") .attr("class","commentsPanelClassForLineChart") 
         .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
         .style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
         .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)
 
         commentsPanelDivForLineChart.on('click',function(d){
             $('.commentsClassForLineChart' + targetElement[0][0].id).focus()
         })
 
         if(options.showTitle == true){
             
             chartTitlePanelForLineChart.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 8 + "%"; })
             .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')
 
             if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == true)){
 
                 var commentsForLineChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                    .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                    .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                    .css('line-height','1.1em').css('text-align','justify') .attr('class','commentsClassForLineChart' + targetElement[0][0].id)
 
                    svgPanelForLineChart.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .append('g')
                    commentsPanelDivForLineChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                    .style("top",78 + "%")
                    .html(commentsForLineChart[0].outerHTML.toString())
 
             }
             else if ((showOrHideTableForLineChart == true) && (showOrHideCommentsForLineChart == false)){
 
                     svgPanelForLineChart.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .style("background-color", options.BGcolor).append('g')
                     commentsPanelDivForLineChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
             }
             else if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == false)){
                     svgPanelForLineChart.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .style("background-color", options.BGcolor).append('g')
                     commentsPanelDivForLineChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
             }
             
             var margin = {top: 30 , right: 10, bottom: 80, left: 50}, //originally top: 42, left: 80
             width = (svgPanelForLineChart.node().getBoundingClientRect().width) - margin.left - margin.right,
             height = (svgPanelForLineChart.node().getBoundingClientRect().height) - margin.top - margin.bottom;
             
         }
         else if(options.showTitle == false){
             chartTitlePanelForLineChart.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });
             
             if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == true)){
 
                 var commentsForLineChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                    .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                    .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                    .css('line-height','1.1em').css('text-align','justify')
 
                    svgPanelForLineChart.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%").style("background-color", options.BGcolor) .append('g')
                    commentsPanelDivForLineChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                    .style("top",78 + "%")
                    .html(commentsForLineChart[0].outerHTML.toString())
 
             }
             else if ((showOrHideTableForLineChart == true) && (showOrHideCommentsForLineChart == false)){
 
                     svgPanelForLineChart.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%").style("background-color", options.BGcolor) .append('g')
                     commentsPanelDivForLineChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
             }
             else if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == false)){
                     svgPanelForLineChart.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%").style("background-color", options.BGcolor) .append('g')
                     commentsPanelDivForLineChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
             }
             
             var margin = {top: 30 , right: 10, bottom: 80, left: 50}, //originally top: 42, left: 80
             width = (svgPanelForLineChart.node().getBoundingClientRect().width) - margin.left - margin.right,
             height = (svgPanelForLineChart.node().getBoundingClientRect().height) - margin.top - margin.bottom;
         }
 
         var colorscale; 
         // checking color set for pie slices and legend dots
         if(options.colorSet === undefined){
             options.colorSet = "one"
             colorscale = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
         }
         else if(options.colorSet.toString().toLowerCase() === "one"){
             options.colorSet = "one"
             colorscale = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
         }
         else if(options.colorSet.toString().toLowerCase() === "two"){
             options.colorSet = "two"
              colorscale = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
         }
         else if(options.colorSet.toString().toLowerCase() === "three"){
             options.colorSet = "three"
             colorscale = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
         }
         else
         {
             options.colorSet = "one"
             colorscale = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
         }
 
         if ((options.lineStyle.toString().toLowerCase() === "cardinal") || (options.lineStyle.toString().toLowerCase() === "linear") || (options.lineStyle.toString().toLowerCase() === "step")){
             options.lineStyle = options.lineStyle;   
         }
         else{
             options.lineStyle = "cardinal";
         }
 
         /*------------------ Settings panel DIV and everything within it section begins here ------------------*/
         
         var stgPanDivForLineChart = targetElement.append('div').style('width',"100%").style('height',"40%").attr("class","stgPanDivForLineChart" + targetElement[0][0].id)
         .style('position','absolute').style('margin-left', "0px").style('border-top',"1px solid #f0f0f0").style('border-bottom',"1px solid #e5e5e5")
         .style("background-color",'#fcfcfc').style("z-index",90) .style("display","none") .style('top',"60%").style('height',"40%")
 
         $( '.stgPanDivForLineChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
             var e0 = e.originalEvent,
             delta = e0.wheelDelta || -e0.detail;
     
             this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
             e.preventDefault();
         });
 
         var settingPanelTitle = stgPanDivForLineChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
         .style('margin-left','0px').style('margin-top','10px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
         .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
         .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; color:#00001c;">'+ "Settings" +'</div>')
 
         var stgPanDivForLineChangeColorTitle = stgPanDivForLineChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
         .style('margin-left','0px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
         .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
         .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Select color set " +'</div>')
 
         var stgPanCanBtnForLineChart = stgPanDivForLineChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
         .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
         .style('background-color',"#FCFCFF")
         .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
         .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
         var cancelBtnImgVar = document.createElement("IMG");
         cancelBtnImgVar.src = "images/closeIcon.png";
         cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.90; background-color:#fcfcff")
         stgPanCanBtnForLineChart[0][0].appendChild(cancelBtnImgVar)
 
         stgPanCanBtnForLineChart.on('click', function() {
             stgPanDivForLineChart.style("display","none") // Hiding setting panel
 
             if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == true)){
                 divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                 .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                     
                 svgPanelForLineChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                 .style("position","absolute").style("background-color", options.BGcolor);
             }
             else if ((showOrHideTableForLineChart == true) && (showOrHideCommentsForLineChart == false)){
                 divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                 .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                     
                 svgPanelForLineChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                 .style("position","absolute").style("background-color", options.BGcolor);
             }
             else if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == false)){
                 divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                 .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                     
                 svgPanelForLineChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                 .style("position","absolute").style("background-color", options.BGcolor);
             }
 
             resizedFunctionForLineChart();
         })
 
         var formForChangeSettingsPanel = stgPanDivForLineChart.append("form");
         formForChangeSettingsPanel.style("background-color","#fcfcfc").style("margin-top","67px").style("font-family","Verdana,sans-serif").style("font-size","12px")
         .style("position","absolute").attr("id","formForChangeColorSettingsPanel" + targetElement[0][0].id).style("font-weight","Bold").style("width","180px")
         .style("height","58px").style("padding","0px").style("border-radius","0px") .style("margin-left","10px")
 
         var svgPanelForCrSetOne = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
         .style("width","160px") .style("height","18px").style("margin-top","1px") .style("margin-left","0px") .style("box-sizing","border-box")
         
         var colorSetOne = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
         var colorSetOneRange = d3.range(12);
 
         var colorSetOneDots = svgPanelForCrSetOne.append("g")
         colorSetOneDots.selectAll('rect') .data(colorSetOneRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
         .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("fill", function(d,i){return colorSetOne(i)})
         .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetOne(i);  })
         .style("cursor","auto") .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
 
         var svgPanelForCrSetTwo = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
         .style("width","160px") .style("height","18px") .style("margin-top","20px") .style("margin-left","0px") .style("box-sizing","border-box")
         
         var colorSetTwo = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
         var colorSetTwoRange = d3.range(12);
 
         var colorSetTwoDots = svgPanelForCrSetTwo.append("g")
         colorSetTwoDots.selectAll('rect') .data(colorSetTwoRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
         .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto")
         .style("fill", function(d,i){return colorSetTwo(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
         .style("stroke",function(d,i){  return colorSetTwo(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
 
         var svgPanelForCrSetThree = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
         .style("width","160px") .style("height","18px") .style("margin-top","39px") .style("margin-left","0px") .style("box-sizing","border-box")
         
         var colorSetThree = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
         var colorSetThreeRange = d3.range(12);
 
         var colorSetThreeDots = svgPanelForCrSetThree.append("g")
         colorSetThreeDots.selectAll('rect') .data(colorSetThreeRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
         .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto") .style("fill", function(d,i){return colorSetThree(i)})
         .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetThree(i);  })
         .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
 
         if(options.colorSet.toString().toLowerCase() === "one"){
             svgPanelForCrSetOne.style('border',"1px solid #808080")
             svgPanelForCrSetTwo.style('border',"0px solid #808080")
             svgPanelForCrSetThree.style('border',"0px solid #808080")
         }
         else if(options.colorSet.toString().toLowerCase() === "two"){
             svgPanelForCrSetOne.style('border',"0px solid #808080")
             svgPanelForCrSetTwo.style('border',"1px solid #808080")
             svgPanelForCrSetThree.style('border',"0px solid #808080")
         }
         else if(options.colorSet.toString().toLowerCase() === "three"){
             svgPanelForCrSetOne.style('border',"0px solid #808080")
             svgPanelForCrSetTwo.style('border',"0px solid #808080")
             svgPanelForCrSetThree.style('border',"1px solid #808080")
         }
         else 
         {
             svgPanelForCrSetOne.style('border',"1px solid #808080")
             svgPanelForCrSetTwo.style('border',"0px solid #808080")
             svgPanelForCrSetThree.style('border',"0px solid #808080")
         }
 
         svgPanelForCrSetOne.on('click',function(d){
             options.colorSet = "one"
             svgPanelForCrSetOne.style('border',"1px solid #808080")
             svgPanelForCrSetTwo.style('border',"0px solid #808080")
             svgPanelForCrSetThree.style('border',"0px solid #808080")
 
             colorscale = "";
             colorscale = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
 
             lines.style("stroke", function (d,i) { return colorscale(i); })
             colorCount = 0;
             circle1.style("fill", function (d,i) {
                 if(i == 0){
                     colorCount++;
                 }
                 return colorscale(colorCount - 1);
             })
 
             legend.selectAll('rect').style("fill", function(d, i){ return colorscale(i);})
         
         })
         svgPanelForCrSetTwo.on('click',function(d){
             options.colorSet = "two"
             svgPanelForCrSetOne.style('border',"0px solid #808080")
             svgPanelForCrSetTwo.style('border',"1px solid #808080")
             svgPanelForCrSetThree.style('border',"0px solid #808080")
 
             colorscale = "";
             colorscale = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
 
             lines.style("stroke", function (d,i) { return colorscale(i); })
             colorCount = 0;
             circle1.style("fill", function (d,i) {
                 if(i == 0){
                     colorCount++;
                 }
                     return colorscale(colorCount - 1);
             })
             legend.selectAll('rect').style("fill", function(d, i){ return colorscale(i);})
         })
         svgPanelForCrSetThree.on('click',function(d){
             options.colorSet = "three"
             svgPanelForCrSetOne.style('border',"0px solid #808080")
             svgPanelForCrSetTwo.style('border',"0px solid #808080")
             svgPanelForCrSetThree.style('border',"1px solid #808080")
 
             colorscale = "";
             colorscale = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
 
             lines.style("stroke", function (d,i) { return colorscale(i); })
             colorCount = 0;
             circle1.style("fill", function (d,i) {
                 if(i == 0){
                     colorCount++;
                 }
                     return colorscale(colorCount - 1);
             })
             legend.selectAll('rect').style("fill", function(d, i){ return colorscale(i);})
         })
 
         var lineChangeStyleTitle = stgPanDivForLineChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
         .style('margin-left','190px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
         .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
         .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Line Style " +'</div>')
 
         var lineStyleDivForLineChart = stgPanDivForLineChart.append("div") .style("background-color","#fcfcfc") .style("margin-left","200px")
         .style("margin-top","67px") .style("font-family","Verdana,sans-serif") .style("font-size","12px") .style("position","absolute")
         .style("font-weight","Bold").style("width","110px") .style("height","30px") .style("padding","0px") .style("border-radius","0px")
         
         var cardinalButton = lineStyleDivForLineChart.append("div") .style("width","32px").style("height","26px").style('position','absolute')
         .style('background-color',"#ffffff").style('margin-left',"0px") .style('top','1px') .style("cursor","pointer") .style("display","block")
         .style("border-style", "none").style('padding',"0px") .style("border", "1px solid #a0a0a0").style("line-height","0px") .style("box-sizing","border-box")
         var cardinalBtnImgVar = document.createElement("IMG");
         cardinalBtnImgVar.src = "images/curveLineIcon.png";
         cardinalBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:24px; height:22px;")
         cardinalButton[0][0].appendChild(cardinalBtnImgVar)
 
         var linearButton = lineStyleDivForLineChart.append("div") .style("width","32px").style("height","26px").style('position','absolute')
         .style('background-color',"#ffffff").style('margin-left',"35px") .style('top','1px') .style("cursor","pointer") .style("display","block")
         .style("border-style", "none") .style('padding',"0px") .style("line-height","0px") .style("box-sizing","border-box")
         var linearBtnImgVar = document.createElement("IMG");
         linearBtnImgVar.src = "images/linearLineIcon.png";
         linearBtnImgVar.setAttribute("style","position:absolute; left:4px; top:1px; width:22px; height:22px;")
         linearButton[0][0].appendChild(linearBtnImgVar)
 
         var stepButton = lineStyleDivForLineChart.append("div") .style("width","32px") .style("height","26px") .style('position','absolute')
         .style('background-color',"#ffffff") .style('margin-left',"70px") .style('top','1px') .style("cursor","pointer") .style("display","block")
         .style("border-style", "none").style('padding',"0px").style("line-height","0px").style("box-sizing","border-box")
         var stepBtnImgVar = document.createElement("IMG");
         stepBtnImgVar.src = "images/stepLineIcon.png";
         stepBtnImgVar.setAttribute("style","position:absolute; left:3px; top:0px; width:24px; height:24px;")
         stepButton[0][0].appendChild(stepBtnImgVar)
 
         if(options.lineStyle.toString().toLowerCase() === "cardinal"){
             cardinalButton.style('border',"1px solid #808080")
             linearButton.style('border',"0px solid #808080")
             stepButton.style('border',"0px solid #808080")
         }
         else if(options.lineStyle.toString().toLowerCase() === "linear"){
             cardinalButton.style('border',"0px solid #808080")
             linearButton.style('border',"1px solid #808080")
             stepButton.style('border',"0px solid #808080")
         }
         else if(options.lineStyle.toString().toLowerCase() === "step"){
             cardinalButton.style('border',"0px solid #808080")
             linearButton.style('border',"0px solid #808080")
             stepButton.style('border',"1px solid #808080")
         }
         else 
         {
             cardinalButton.style('border',"1px solid #808080")
             linearButton.style('border',"0px solid #808080")
             stepButton.style('border',"0px solid #808080")
         }
 
         cardinalButton.on('click',function(d){
             options.lineStyle = "cardinal"
             cardinalButton.style('border',"1px solid #a0a0a0")
             linearButton.style('border',"0px solid #808080")
             stepButton.style('border',"0px solid #808080")
 
             line.interpolate(options.lineStyle) .x(function (d) { return x1(d['label']); }) .y(function (d) { return y(+d["value"]); });
 
             lines.attr("d", function (d,i) { return line(d.Data)})
 
             resizedFunctionForLineChart();
 
         })
         linearButton.on('click',function(d){
             options.lineStyle = "linear"
             cardinalButton.style('border',"0px solid #a0a0a0")
             linearButton.style('border',"1px solid #a0a0a0")
             stepButton.style('border',"0px solid #a0a0a0")
 
             line.interpolate(options.lineStyle) .x(function (d) { return x1(d['label']); }) .y(function (d) { return y(+d["value"]); });
 
             lines.attr("d", function (d,i) { return line(d.Data)})
 
             resizedFunctionForLineChart();
 
         })
         stepButton.on('click',function(d){
             options.lineStyle = "step"
             cardinalButton.style('border',"0px solid #a0a0a0")
             linearButton.style('border',"0px solid #a0a0a0")
             stepButton.style('border',"1px solid #a0a0a0")
 
             line.interpolate(options.lineStyle) .x(function (d) { return x1(d['label']); }) .y(function (d) { return y(+d["value"]); });
 
             lines.attr("d", function (d,i) { return line(d.Data)})
 
             resizedFunctionForLineChart();
         })
 
         //------------------ Settings panel DIV and everything inside it section ends here ------------------
 
         var divLegendPanelForLineChart = targetElement .append('div')  .attr("class","divLegendPanelClassForLineChart") .style('background-color',"#ffffff") .style('position',"absolute")
         .style('width', 25 + "%") .style('height', 92 + "%") .style("left",75 + "%").style("top",8 + "%") 
 
             if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == true)){
                 divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                 .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                     
                 svgPanelForLineChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                 .style("position","absolute").style("background-color", options.BGcolor);
             }
             else if ((showOrHideTableForLineChart == true) && (showOrHideCommentsForLineChart == false)){
                 divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                 .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                     
                 svgPanelForLineChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                 .style("position","absolute").style("background-color", options.BGcolor);
             }
             else if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == false)){
                 divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                 .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                     
                 svgPanelForLineChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                 .style("position","absolute").style("background-color", options.BGcolor);
             }
 
         //------------------ creating legend ------------------
         
         var legendPanelSvgForLineChart = divLegendPanelForLineChart .append('svg')  .attr("class","") .style("background-color", options.BGcolor) .style('position',"absolute")
         .style('width', 100 + "%") .style('height', 100 + "%") .style("left",0 + "%").style("top",0 + "%")
         
         var legend = legendPanelSvgForLineChart.append("g") .attr("class", "legend") .attr("height", "100%") .attr("width", "100%")
         .attr('transform', 'translate(0,20)') 
         
         //Create colour circles
         legend.selectAll('rect') .data(options.keys.lines) .enter() .append("rect") .attr("x", 5) .attr("y", function(d, i){ return i * 16;})
         .attr("width", 14) .attr("height", 14) .attr("rx",10) .attr("ry",10) .style("fill", function(d, i){ return colorscale(i);})
         .style("cursor","auto")
       
         //Create text next to circles
         legend.selectAll('text') .data(options.keys.lines) .enter() .append("text") .attr("x", 25) .attr("y", function(d, i){ return i * 16 + 11.7;})
         .text(function(d,i) {
            if(d.length > 10)
                return d.substring(0,10)+'...';
            else
                return d;
        }).style('font-size', '14px') .attr("fill","#00001c") .style("font-family","Verdana,sans-serif")
 
         // Aligning Legend (vertically)
         var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelForLineChart[0][0].style.width) / 100)
         var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelForLineChart[0][0].style.height) / 100)
 
         var legendRectSize = 11;
         var legendSpacing = 6;
             
         legend.attr('transform', function(d, i) {
         var eachRectHeight = legendRectSize + legendSpacing;
         var offset =  eachRectHeight * colorscale.domain().length / 2;
         var horz = 5;
         var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.lines.length))/2.0; // originally 2.0
             
             return 'translate(' + horz + ',' + vert + ')';
         })
         
         // Creating ToolTip for options button.
         var iconButtonTooltipForLineChart = targetElement.append('div').style('width','240px').attr("id","too")
         .style('height',"25px").style('position','absolute')//.style('margin-left', "0px").style('top','25px')
         .style("background-color",'#404040 ').style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid") // 004b9d
         .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none").attr("border", 0.0)
 
         areaButtonForLineChart.on('mousemove', function(d,i) {
             var root = targetElement
                 var m = d3.mouse(root.node());
                 m[0] += 0
                 m[1] += 0
             var areaButtonTooltipText = "Switch to Area Chart";
             iconButtonTooltipForLineChart.style("width","128px").style("margin-left", (m[0] - 138) + "px").style("margin-top",(m[1]) + "px").style("display","block")
             iconButtonTooltipForLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ areaButtonTooltipText +'</div>')
 
         })
         areaButtonForLineChart.on('mouseout', function(d,i) {
             iconButtonTooltipForLineChart.style("display","none")
         })
 
         filterButtonForLineChart.on('mousemove', function(d,i) {
             var root = targetElement
                 var m = d3.mouse(root.node());
                 m[0] += 0
                 m[1] += 0
             var filterButtonTooltipText = "Filter";
             iconButtonTooltipForLineChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
             iconButtonTooltipForLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')
 
         })
         filterButtonForLineChart.on('mouseout', function(d,i) {
             iconButtonTooltipForLineChart.style("display","none")
         })
 
         refreshButtonForLineChart.on('mousemove', function(d,i) {
             var root = targetElement
                 var m = d3.mouse(root.node());
                 m[0] += 0
                 m[1] += 0
             var refreshButtonTooltipText = "Refresh";
             iconButtonTooltipForLineChart.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
             iconButtonTooltipForLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ refreshButtonTooltipText +'</div>')
 
         })
         refreshButtonForLineChart.on('mouseout', function(d,i) {
             iconButtonTooltipForLineChart.style("display","none")
         })
 
         commentsBtnForLineChart.on('mousemove', function(d,i) {
             commentsPanelDivForLineChart.style('background-color','#fafafa')
             var root = targetElement
                 var m = d3.mouse(root.node());
                 m[0] += 0
                 m[1] += 0
                 if(options.showComments == false){
                     var commentButtonTooltipText = "Show Comments";
                 }
                 else if(options.showComments == true){
                     var commentButtonTooltipText = "Hide Comments";
                 }
             
             iconButtonTooltipForLineChart.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
             iconButtonTooltipForLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ commentButtonTooltipText +'</div>')
         })
         commentsBtnForLineChart.on('mouseout', function(d,i) {
             commentsPanelDivForLineChart.style('background-color','#ffffff')
             iconButtonTooltipForLineChart.style("display","none")
         })
 
         menuButtonForLineChart.on('mousemove', function(d,i) {
             var root = targetElement
                 var m = d3.mouse(root.node());
                 m[0] += 0
                 m[1] += 0
             var menuButtonTooltipText = "Menu";
             iconButtonTooltipForLineChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
             iconButtonTooltipForLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ menuButtonTooltipText +'</div>')
 
         })
         menuButtonForLineChart.on('mouseout', function(d,i) {
             iconButtonTooltipForLineChart.style("display","none")
         })
 
         tableButtonForLineChart.on('mousemove', function(d,i) {
             var root = targetElement
                 var m = d3.mouse(root.node());
                 m[0] += 0
                 m[1] += 0
             if(showOrHideTableForLineChart == false){
                 var tableButtonTooltipText = "Show Table";
             }
             else if(showOrHideTableForLineChart == true){
                 var tableButtonTooltipText = "Hide Table";
             }
             iconButtonTooltipForLineChart.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
             iconButtonTooltipForLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ tableButtonTooltipText +'</div>')
 
         })
         tableButtonForLineChart.on('mouseout', function(d,i) {
             iconButtonTooltipForLineChart.style("display","none")
         })
 
         settingBtnForLineChart.on('mousemove', function(d,i) {
             var root = targetElement
                 var m = d3.mouse(root.node());
                 m[0] += 0
                 m[1] += 0
             var settingTooltipText = "Settings";
             iconButtonTooltipForLineChart.style("width","67px").style("margin-left", (m[0] - 77) + "px").style("margin-top",(m[1]) + "px").style("display","block")
             iconButtonTooltipForLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ settingTooltipText +'</div>')
         })
         settingBtnForLineChart.on('mouseout', function(d,i) {
             iconButtonTooltipForLineChart.style("display","none")
         })
         
         downloadBtnForLineChart.on('mousemove', function(d,i) {
               var root = targetElement
               var m = d3.mouse(root.node());
               m[0] += 0
               m[1] += 0
               var downloadButtonTooltipText = "Download";
               iconButtonTooltipForLineChart.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
               iconButtonTooltipForLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
         })
         downloadBtnForLineChart.on('mouseout', function(d,i) {
               iconButtonTooltipForLineChart.style("display","none")
         })
         
         // ----------------- Filter panel and everything within it section begins here ----------------
         var filterPanelForLineChart = targetElement.append('div') .style('width',350 + "px") .attr("class","filterPanelForLineChartClass" + targetElement[0][0].id)
         .style('position','absolute') .style('margin-left', "0px") .style("background-color",'#fefefe') .style("z-index",11)
         .style("border-color", "#ffffff").style("border-right", "solid #e5e5e5 1px")  .style("border-style", "solid") .style("box-shadow", "2px 0px 1px #eff8ec")
         .style("display","none").style("border-top", "solid #fdfdfd 1px").style("border-left","0px").style("border-bottom", "0px")
         .style('top', 0.0 + "%").style('height', 100 + "%").style('overflow-y',"hidden").style("overflow-x","hidden")
         .style("border-bottom", "solid #e5e5e5 1px") .style("box-sizing","border-box")
 
         var filterPanelForStkBarChartTitle = filterPanelForLineChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
         .style('margin-left','0px').style('margin-top','20px').style('text-indent','5px').style("font-size", "14px").style('position',"absolute")
         .style("box-shadow", "1px 1px 1px #007aff").style("width","350px").style("color","#000000")
         .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; top:25.0%; font-size:14px; font-family:inter; color:#00001c;">'+ "Filter" +'</div>')
 
         var measuresColumnTitle = filterPanelForLineChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
         .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '60px')
         .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter;  color:#00001c; font-weight:Normal; text-align:left; text-indent:3px;">Available Measures</div>');
 
         var measuresVariables = filterPanelForLineChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable1"+targetElement[0][0].id)
         .style("list-style-type","none")
         .style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '78px')
         .style('position','absolute')
         .style("width","155px").style("min-height","190px").style("max-height","190px").style("border", "#f0f0f0 1px solid")
         .style("max-width","155px").style("overflow-x","hidden").style("overflow-y","auto")
         measuresVariables.style("left",0.0 + "px").style("padding","2px")
         
         $( ".filterPanelForLineChartClass" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
             var e0 = e.originalEvent,
             delta = e0.wheelDelta || -e0.detail;
     
             this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
             e.preventDefault();
         });
 
 
         var measuresArray = [];
         var dimensionArray = [];
 
         var measuresArrayLength = [];
         var dimensionsArrayLength = [];
 
         dimensionArray.push(options.keys.label);
         //measuresArray = options.keys.stackedBars;
 
         for(var i = 0; i<divAndChartsArray.length; i++){
             if(targetElement[0][0].id === divAndChartsArray[i].divID){
                     
                 //measuresArray = newtargetElementAndOptionsArray[i].options.keys.lines;
 
                 if(newtargetElementAndOptionsArray[i].options.keys.areas == undefined){
                     measuresArray = newtargetElementAndOptionsArray[i].options.keys.lines;
                 }
                 else{
                     measuresArray = newtargetElementAndOptionsArray[i].options.keys.areas;
                 }
             }
         }
         
         // filter process
         var uniqueMeasuresArrayKeys = [];
         $.each(measuresArray, function(i, el){
             if($.inArray(el, uniqueMeasuresArrayKeys) === -1){
                 uniqueMeasuresArrayKeys.push(el);
             }
         });
 
         var uniqueDimensionArrayKeys = [];
         $.each(dimensionArray, function(i, el){
             if($.inArray(el, uniqueDimensionArrayKeys) === -1){
                 uniqueDimensionArrayKeys.push(el);
             }
         });
         
         // setting lenght for arrays
         for(var i = 0; i<uniqueMeasuresArrayKeys.length; i++){
             measuresArrayLength.push(i);
         }
 
         for(var i = 0; i<uniqueDimensionArrayKeys.length; i++){
             dimensionsArrayLength.push(i);
         }
 
         var measuresVariables1 = measuresVariables.selectAll("li") .data(measuresArrayLength).enter().append("li")
         .style("width","130px") .style("max-height","22px").style("cursor","move")
         .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#bcf1bc").style("font-weight","Normal")
         .style("list-style-type","none").style("border","1px #89e789 solid").style("color","#006600").style("font-family","Verdana,sans-serif")
         .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
         .text(function(d) {return uniqueMeasuresArrayKeys[d]})
         measuresVariables1.attr("class","MeasuresClass"+targetElement[0][0].id)
         
         var measuresColumnReceivedUI_TableTitle = filterPanelForLineChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
         .style('background-color',"#fefefe").style('margin-left','180px').style('margin-top', '60px')
         .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; ">Selected Measures</div>');
 
         var measuresColumnReceivedUI_Table = filterPanelForLineChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable3"+targetElement[0][0].id)
         .style('background-color',"#ffffff").style('margin-left','180px').style('margin-top', '78px')
         .style("width","155px").style('position','absolute').style("padding","2px").style("min-height","190px")
         .style("border","1px #c1c1c1 dashed") .style("max-height","190px") .style("overflow-x","hidden") .style("overflow-y","auto")
         //.html('<div class=unsortable  style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:65.0%; font-size:14px; font-family:inter;  color:#99ea99; font-weight:Normal; text-align:center;">Drag and Drop Measures here from Available Measures List. </div>');
         .html('<img class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' src="images/dragIcon.png" style=" width:36px; height:36px; position:absolute; margin-left:65px; margin-top:60px; opacity:0.6"/>' 
         + '<div class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:60.0%; font-size:12px; font-family:inter;  color:#89d289; font-weight:Normal; text-align:center;">Drop Measures here. </div>');
         //.html('<div style="background-image: url(images/dragIcon.png); height: 64px; width: 64px; border: 1px solid black;"> </div>');
         
         var cancelButton = filterPanelForLineChart.append("div") .style("width","23px").style("height","21px").style('position','absolute')
         .style('margin-left','320px').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
         .style('background-color',"#FCFCFF")
         .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
         .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
         var cancelBtnImgVar = document.createElement("IMG");
         cancelBtnImgVar.src = "images/closeIcon.png";
         cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.90; background-color:#fcfcff")
         cancelButton[0][0].appendChild(cancelBtnImgVar)
 
         cancelButton.on("click", function(){
             filterPanelForLineChart.style("display","none")
 
             if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == true)){
                 divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                 .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                     
                 svgPanelForLineChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                 .style("position","absolute").style("background-color", options.BGcolor);
             }
             else if ((showOrHideTableForLineChart == true) && (showOrHideCommentsForLineChart == false)){
                 divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                 .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                     
                 svgPanelForLineChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                 .style("position","absolute").style("background-color", options.BGcolor);
             }
             else if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == false)){
                 divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                 .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                     
                 svgPanelForLineChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                 .style("position","absolute").style("background-color", options.BGcolor);
             }
         })
 
         var reRenderChartAndTableButton = filterPanelForLineChart.append("button").style("width","120px").style("height","25px").style('position','absolute')
         .style('margin-left','112px').style('margin-top','298px') .style("border-style", "none").style('background-color',"#2196f3")
         .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','15px').style("border-style", "solid").style('color','#ffffff')
         .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 1px #9b9b9b").style("border-radius","0px")
         var textForReRenderButton = document.createTextNode("Apply Changes");
         reRenderChartAndTableButton[0][0].appendChild(textForReRenderButton)
 
         reRenderChartAndTableButton.on("click", function(){
             
             if( $("#sortable3"+targetElement[0][0].id).children("li").length == 0 )
             {
 
                 var alertPageDisabledDivForLineChart =targetElement.append('div').style('width',100 + '%')
                 .style('height',100 + "%").style('position','absolute').style('margin-left', '0px').style('top', '0px')
                 .style("background-color",'#f3f3f3').style("z-index",99)//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                 .style("opacity",0.2).style("display","block")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
 
                 var alertDivForLineChart = targetElement.append('div').style('width','350px')
                 .style('height',"150px").style('position','absolute').style('left', ((targetElement[0][0].clientWidth/2) - 175) + "px").style('top', '1px')
                 .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "solid").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                 .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","0px")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
                 //.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Bold;">Sorry, no result found for selected' + 'range!'+ '</br>' + '<label style=text-indent:10px;> Hello</label' +'</div>')
                 .html('<p  style="width: 340px; height:0%; background-color:#c7c7c7; position: absolute; top:40.0%; font-size:14px; font-family:inter; font-weight:Bold; margin-left:10px;  color:#f8f8f8; font-weight:Normal;">Check whether the Selected Measures box is not empty!</p>')
 
                 var alertDivTitleForLineChart = alertDivForLineChart.append('div').style('width','340px')
                 .style('height',"30px").style('position','absolute').style('margin-left', "0px").style('top', '0px')
                 .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "none").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                 .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","2px")
                 .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; font-weight:Bold; text-indent:5px;  color:#e5e5e5; font-weight:Normal;">TimeBound</div>')
 
                 var lineChartAlertOKButton = alertDivForLineChart.append("button") .style("width","40px") .style("height","20px") .style('position','absolute') .style("box-shadow", "0px 1px 1px #B8B8B8") 
                 .style('background-color',"#7cc15e") .style('margin-left','300px') .style('top', "120px").style("color","#ffffff")
                 .style("display","block").style('padding-top',"0px").style("cursor","pointer").style("box-shadow", "1px 1px 1px #56973a") .style("border-style", "none")
                 .style("font-family","Verdana,sans-serif").style("font-size","14px").style("text-align","center").style("vertical-align","middle").style("border-radius","0px")
                 .style("z-index",999)
             
                 var textForLineChartAlertOKButton = document.createTextNode("OK");
                 lineChartAlertOKButton[0][0].appendChild(textForLineChartAlertOKButton)
 
                 $("#"+targetElement[0][0].id).resizable('disable');
 
                 lineChartAlertOKButton.on('click', function() {
                     alertDivForLineChart.remove();
                     alertPageDisabledDivForLineChart.remove()
                     $("#"+targetElement[0][0].id).resizable('enable');
                 })
 
                 filterButtonForLineChart.style("cursor","pointer")
                 
                 if(showOrHideTableForLineChart == false){ 
                     svgPanelForLineChart.style('width', 75 + "%") .style('height', 85 + "%").style("position","absolute").style("background-color", options.BGcolor)
                     divLegendPanelForLineChart.style('width', 25 + "%") .style('height', 85 + "%").style("position","absolute").style("background-color", options.BGcolor)
                 }   
                 else if(showOrHideTableForLineChart == true){ 
                     svgPanelForLineChart.style('width', 75 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor)
                     divLegendPanelForLineChart.style('width', 25 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor)
                 } 
 
                 resizedFunctionForLineChart();
             }
 
             else{
 
                 var selectedLineMeasures = [];
                 for(var i=0; i<$("#sortable3"+targetElement[0][0].id).children("li").length;i++){
                     selectedLineMeasures.push($("#sortable3"+targetElement[0][0].id).children("li")[i].textContent)
                 }
             
                 var newOptions = {
                            data: options.data,
                            dataForTable: options.dataForTable,
                            isDataDetailedForTable: options.isDataDetailedForTable,
                            keys: {
                                label: options.keys.label,
                                lines: selectedLineMeasures,
                            },
                            chartTitle:options.chartTitle,
                            xAxisLable: options.keys.label,
                            yAxisLable: "",
                            //dimensions: options.dimensions,
                            //measures: options.measures,
                            showTitle: true,
                            colorSet: options.colorSet,
                            BGcolor:options.BGcolor,
                            lineStyle: options.lineStyle,
                            series:options.series,
                            legend:options.legend,
                            drillDownColumnName:options.drillDownColumnName,
                            showTable: options.showTable,
                            showComments: options.showComments,
                            comments: options.comments,
                            resizeButtonID: options.resizeButtonID
                         }
                         
                         d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                         acinfotech.lineChart(targetElement,newOptions)
                 }
         })
 
         var textBoxForMeasureColumnFrom;
         var textBoxForMeasureColumnTo;
         var selectTitleDivForEachDimension;
 
         $( "ul.droptrue"+targetElement[0][0].id ).sortable({
             appendTo: document.body,
             helper: "clone",
             connectWith: ".droptrue"+targetElement[0][0].id,
             scroll: false,
             cancel: '.unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+','+' .unMoveableIconAndTextClassDimensions'+targetElement[0][0].id,
             revertDuration: 10,
             scrollSensitivity: 10,
             scrollSpeed: 1,
             dynamic: true,
 
             receive: function(e, ui) { 
                  
                 if (($(this)[0].id == "sortable3"+targetElement[0][0].id) || ($(this)[0].id == "sortable1"+targetElement[0][0].id)) {
 
                         if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                             if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                                  (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                             }
                             else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                                 (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                             }
 
                         }
                 } // if (($(this)[0].id == "sortable3") || ($(this)[0].id == "sortable1")) 
 
                 else if (($(this)[0].id == "sortable2"+targetElement[0][0].id) || ($(this)[0].id == "sortable4"+targetElement[0][0].id)) {
                     if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                             //ui.sender.sortable("cancel");
 
                             if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                                  (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                             }
                             else if(  ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                                 (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                             }
                         }
                 } //if (($(this)[0].id == "sortable2") || ($(this)[0].id == "sortable4")) {
 
                 $(ui.item).css({ 'position': 'relative' });
 
                 if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                     ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                 }
                  
                 else if ($(this)[0].id == "sortable3"+targetElement[0][0].id) { // checking if the dropped element is in Measures drop area
                     
                     if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                         ui.sender.sortable("cancel");
                     }
                     else {
                         //ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                     }
 
                 } // else if ($(this)[0].id == "sortable3") // checking if the dropped element is in Measures drop area ends here.
 
                 else if ($(this)[0].id == "sortable4"+targetElement[0][0].id) { // checking if the dropped element is in Dimension drop area
 
                     if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                         ui.sender.sortable("cancel");
                     }
                     else {
                         ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                     }
                 } //else if ($(this)[0].id == "sortable4")  // checking if the dropped element is in Dimension drop area ends here
 
                     if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                         
                         if ($(this)[0].id == "sortable1"+targetElement[0][0].id){
                             if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                             
                                 if( ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                                     ui.sender.sortable("cancel");
                                 } // if(  ui.sender.attr("id") === "sortable4")
 
                                 else if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                                     ui.sender.sortable("cancel");
                                 }
                             
                             } // if(ui.item.hasClass("DimesionsClass"))
                         }
                     if ($(this)[0].id == "sortable2"+targetElement[0][0].id){
                         if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                             
                             if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                                 ui.sender.sortable("cancel");
                             }
                             else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                                 ui.sender.sortable("cancel");
                                
                             }
                         }
                     }
 
                 } //if ($(this)[0].id == "sortable1")
 
                 if ($(this)[0].id == "sortable4"+targetElement[0][0].id){
                     if ($(this).children('li').length > 1 ){
                         ui.sender.sortable("cancel");
                         ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                     }    
                 }
 
             }, //receive ends here
 
             start:function(ev, ui) {
                 
             },
             stop:function(ev, ui) {
                
             },
         });
       
         // ----------------- Filter panel and everything within it section ends here -----------------
 
         areaButtonForLineChart.on('click', function() {
             
             d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
             var newOptions = {
                            data: options.data,
                            dataForTable: options.dataForTable,
                            isDataDetailedForTable: options.isDataDetailedForTable,
                            keys: {
                                label: options.keys.label,
                                areas: options.keys.lines,
                            },
                            chartTitle:options.chartTitle,
                            xAxisLable:options.keys.label,
                            yAxisLable:"",
                            showTitle:options.showTitle,
                            colorSet: options.colorSet,
                            BGcolor:options.BGcolor,
                            series:options.series,
                            legend:options.legend,
                            lineStyle: options.lineStyle,
                            drillDownColumnName:options.drillDownColumnName,
                            showTable:false,
                            showComments: options.showComments,
                            comments: options.comments,
                            resizeButtonID: options.resizeButtonID
                        }
                        for(var i = 0; i<divAndChartsArray.length; i++){
 
                            if(targetElement[0][0].id === divAndChartsArray[i].divID){
                                 newOptions.keys.areas = newtargetElementAndOptionsArray[i].options.keys.lines
                                 newtargetElementAndOptionsArray[i].options.keys = newOptions.keys;
                             }
                         }
                 acinfotech.areaChart(targetElement, newOptions)
 
         })
 
         filterButtonForLineChart.on('click', function() {
 
             filterPanelForLineChart.style("display","block");
 
             ismenuBtnOfLineChartClicked = false;
             optsBtnPanelForLineChart.style("display","none");
 
             stgPanDivForLineChart.style("display","none");
 
             if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == true)){
                 divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                 .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                     
                 svgPanelForLineChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                 .style("position","absolute").style("background-color", options.BGcolor);
             }
             else if ((showOrHideTableForLineChart == true) && (showOrHideCommentsForLineChart == false)){
                 divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                 .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                     
                 svgPanelForLineChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                 .style("position","absolute").style("background-color", options.BGcolor);
             }
             else if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == false)){
                 divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                 .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                     
                 svgPanelForLineChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                 .style("position","absolute").style("background-color", options.BGcolor);
             }
 
             resizedFunctionForLineChart();
 
         })
 
         // Refreshing Chart and Table 
         refreshButtonForLineChart.on('click', function() {
 
             //isFilterClicked = false
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
             
             for(var i = 0; i<divAndChartsArray.length; i++){
 
                 if(targetElement[0][0].id === divAndChartsArray[i].divID){
                     options.data = divAndChartsArray[i].optionsData;
                     //options.keys.lines = newtargetElementAndOptionsArray[i].options.keys.lines;
 
                     if(newtargetElementAndOptionsArray[i].options.keys.areas == undefined){
                         options.keys.lines = newtargetElementAndOptionsArray[i].options.keys.lines;
                     }
                     else{
                         options.keys.lines = newtargetElementAndOptionsArray[i].options.keys.areas;
                     }
                 }
             }
             acinfotech.lineChart(targetElement,options) 
 
         })
 
         // showing/hidding chart comments 
         commentsBtnForLineChart.on('click', function() {
 
             if(options.showComments == false){ 
                 options.showComments = true;
             }
             else if(options.showComments == true){ 
                 options.showComments = false;
             }
 
             d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
             
             for(var i = 0; i<divAndChartsArray.length; i++){
 
                 if(targetElement[0][0].id === divAndChartsArray[i].divID){
                     options.data = divAndChartsArray[i].optionsData
                     options.showTable = false;
                 }
             }
             acinfotech.lineChart(targetElement,options)
 
         })
 
         // showing/hidding chart table
         tableButtonForLineChart.on('click', function() {
 
             if(showOrHideTableForLineChart == false){
                 options.showTable = true;
                 //showOrHideTableForPieChart = true
             }
             else if(showOrHideTableForLineChart == true){
                 //showOrHideTableForPieChart = false
                 options.showTable = false;
             }
 
             d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
             
             for(var i = 0; i<divAndChartsArray.length; i++){
 
                 if(targetElement[0][0].id === divAndChartsArray[i].divID){
                     options.data = divAndChartsArray[i].optionsData
                     options.showComments = false;
                 }
             }
             acinfotech.lineChart(targetElement,options)
 
         })
 
         
         settingBtnForLineChart.on('click', function() {
                 
             ismenuBtnOfLineChartClicked = false; // Menu toggle button variable
             optsBtnPanelForLineChart.style("display","none") // To hide options button panel
 
             iconButtonTooltipForLineChart.style("display","none") // Removing options button ToolTip
             settingBtnForLineChart.style("cursor","pointer")
             
             stgPanDivForLineChart.style("display","block") // Showing settings panel
 
             svgPanelForLineChart.style('width', 75 + "%") .style('height', 52 + "%") .style('top', 8 + "%") .style("position","absolute"); // Decreasing chart panel
             divLegendPanelForLineChart.style('width', 25 + "%") .style('height', 52 + "%") .style('top', 8 + "%") .style("position","absolute"); // Decreasing chart panel
 
             resizedFunctionForLineChart(); // Calling resize function()
 
         })
         
         downloadBtnForLineChart.on('click', function() {
                                   
             ismenuBtnOfLineChartClicked = false; // Changing menu button value to false
             optsBtnPanelForLineChart.style("display","none") // Hiding option buttons panel
               
         })
         
         // Converting normal json array to nested json array
         var dataArray = [];
 
         options.data.forEach(function(d, i) {
             var temp = {};
             for (i = 0; i < options.keys.lines.length; i++) {
                 
                 for (j = 0; j < Object.keys(d).length; j++) {
                      
                     if(options.keys.lines[i] === Object.keys(d)[j]){
                         temp[Object.keys(d)[j]] = d[Object.keys(d)[j]]
                     }
                  }
             }
             
             dataArray.push(temp)
         });
 
         var finalArray = [];
         options.data.forEach(function(d, i) {
     
             var finalArrayTemp = {};
             finalArrayTemp[options.keys.label] = d[options.keys.label]
             finalArrayTemp["Data"] = dataArray[i];
             finalArray.push(finalArrayTemp)
         })
         
         var finalArrayNew = [];
         options.keys.lines.forEach(function(d, i) {
     
             var temp1 = {};
             temp1["line"] = options.keys.lines[i]
     
             finalArrayNew.push(temp1)
         })
         
         var finalNewNewArray = [];
         var dataArray1 = [];
         finalArrayNew.forEach(function(d, i) {
     
         var temp1 = {};
         temp1["line"] = options.keys.lines[i]
     
     
         for (j = 0; j < options.data.length; j++) {
        
             var tempTemp = {};
             tempTemp["label"] = options.data[j][options.keys.label];
             tempTemp["value"] = options.data[j][options.keys.lines[i]];
 
             dataArray1.push(tempTemp)
         }
      
         temp1["Data"] = dataArray1;
         dataArray1 = []
         finalNewNewArray.push(temp1)
     })
 
         var x = d3.scale.ordinal().domain(options.data.map(function(d,i) { return d[options.keys.label];})).rangePoints([0, width],0.65);
 
         var x1 = d3.scale.ordinal() .domain(options.data.map(function(d) { return d[options.keys.label]; })) .rangePoints([0, width], 0.65);
 
         var max = d3.max(finalArray, function(d) {
                     return d.Data[options.keys.lines[0]]
         });
     
     var maxArray = [];
     for (i = 0; i < options.keys.lines.length; i++) {
         var max = d3.max(finalArray, function(d) {
                     return +d.Data[options.keys.lines[i]]
         });
 
         maxArray.push(max)
     }
 
     var finallyMaxValue = d3.max(maxArray, function(d) { return +d; })
 
     var y = d3.scale.linear() .domain([0, d3.max(maxArray, function(d) { return +d; })] ) .range([height, 0]);
         
     var color = d3.scale.category10();
 
     var xAxis = d3.svg.axis() .scale(x) .orient("bottom");
     
     var yAxis = d3.svg.axis() .scale(y) .ticks(5) .orient("left");
      
     var hasDecimalPoint = false;
     for(var i = 0; i < options.keys.lines.length; i++){
         for(var j = 0; j < options.data.length; j++){
            if(options.data[j][options.keys.lines[i]].toString().indexOf('.') > -1){ hasDecimalPoint = true; break; }
         }
     }
     if(hasDecimalPoint == false){ yAxis.tickFormat(d3.format(".2s")) }
         
     var svg = svgPanelForLineChart.append("svg") .append("g") .attr("width", width + margin.left + margin.right) .attr("height", height + margin.top + margin.bottom)
             .attr("transform", "translate(" + margin.left + "," + margin.top + ")")
     let key=options.xAxisLable;
     let array=options.data.map(value => value[key]);
     let ArrayValue=[];
     var RotateValue;
     for(let i=0;i<array.length;i++){
         ArrayValue[i]=array[i].length;
     }
    const numberGreaterThanLimit = ArrayValue.filter((v) => v > 5);
     var xAxisLineAndMarginLabels = svg.append("g") .attr("class", "x axis") .attr("transform", "translate(0," + height + ")") .call(xAxis)
 
     // Add the X Axis margin labels
     .selectAll("text") .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') .attr("transform", function(d)
     {
             if(numberGreaterThanLimit.length>0)
             {
                 return "rotate(-45)"
             }
          else{
                     return "rotate(0)" 
             }})
     .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
     .text(function(d,i) {
         if(d.length > 9)
             return d.substring(0,9)+'...';
         else
             return d;
     })

     svg.append("g") .attr("class", "y axis") .call(yAxis) .selectAll("text") .style('fill','#00001c') .style("font-family","Verdana,sans-serif")
 
     color.domain(options.keys.lines.map(function (d) { return d; }));
       
     var minX = d3.min(finalNewNewArray, function (kv) { return d3.min(kv.Data, function (d) { return +d.value; }) });
     var maxX = d3.max(finalNewNewArray, function (kv) { return d3.max(kv.Data, function (d) { return +d.value; }) });
     var minY = d3.min(finalNewNewArray, function (kv) { return d3.min(kv.Data, function (d) { return +d.value; }) });
     var maxY = d3.max(finalNewNewArray, function (kv) { return d3.max(kv.Data, function (d) { return +d.value; }) });
 
     x.domain([minX, maxX]);
     y.domain([minY, maxY]);
 
     // Creating line data
         var line = d3.svg.line() .interpolate(options.lineStyle) .x(function (d) { return x1(d['label']); }) .y(function (d) { return y(+d["value"]); });
 
     // Creating lines
     var lines = svg.selectAll(".line") .data(finalNewNewArray) .enter() .append("g") .append("path") .attr("class", "line")
     .attr("d", function (d,i) { return line(d.Data); }) .style("stroke", function (d,i) { return colorscale(i); })
     .style("stroke-width",4) .style('fill','none') .style("stroke-linecap", "butt")
     
     // Creating circles on lines
     var colorCount = 0;
     var circle1 = svg.selectAll("g.dot") .data(finalNewNewArray) .enter() .append("g")
     .attr("class", "dot") .selectAll("circle") .data(function(d) { return d.Data; }) .enter() .append("circle") .attr("r", 2)
     .attr("cx", function(d,i) {  return x1(d['label']); }) .attr("cy", function(d,i) {  return y(+d["value"]); })
     .style("fill", function (d,i) {
         if(i == 0){
             colorCount++;
         }
         return colorscale(colorCount - 1);
     })
 
         var columnNames = d3.keys(options.data[0])
         var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
         
         for(var i = 0; i < columnNames.length ; i++){
             for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                 if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                     for(var k = 0; k < options.keys.lines.length; k++){
                         var len = d3.select(svg[0][0]).selectAll('g.dot')
                         for(var l = 0; l < d3.select(len[0][k]).selectAll('circle')[0].length; l++){
                             var cir = d3.select(len[0][k]).selectAll('circle')[0][l];
                             d3.select(cir).attr('data-drilldownkey', function(d,index){
                                     return JSON.stringify(options.data[l]).slice(1, -1).split('"').join("").split(':').join("|")
                                 })
                         }
                     }
                 }
                 else {
                 }
             }
         }
 
     
     // Adding the text label for the X axis
     var xAxisVariable =  svg.append("text") .attr("transform", "translate(" + ((width/2) - 0) + " ," + (height+margin.bottom - 2) + ")")
     .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif") .style("font-weight","Bold") .style("font-size","12px") .text(options.xAxisLable) .style('fill','#00001c') 
     .style("text-transform","capitalize") .style("font-style","normal")
 
     legend.selectAll('rect').on('mouseover',function(d,i){
         d3.select(lines[0][i]).style('stroke-width',2)
 
         var lineLen = lines.node().getTotalLength();
         var dashLen = options.data.length;
         var ddLen = dashLen ;
         var darray = dashLen;
         while(ddLen < lineLen){
             darray+=","+dashLen+","+dashLen;
             ddLen+=dashLen;
         }
 
         d3.select(lines[0][i]).attr("stroke-linecap", "round").attr("stroke-dasharray", darray + ","+lineLen) .attr("stroke-dashoffset", lineLen)
         .transition().duration(5000).ease("linear").attr("stroke-dashoffset", 0);
     })
 
     legend.selectAll('rect').on('mouseout',function(d,i){
         d3.select(lines[0][i]).style('stroke-width',4) .transition().duration(0)
         d3.select(lines[0][i]).attr("stroke-dasharray", options.data.length + ","+ 0)  .attr("stroke-dashoffset", 0)
     })
 
     var tooltipForLineChart = targetElement .append('div') .attr('class', 'tooltipPie') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
         .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
         .style("padding-right", "7px") .style("background", "#ffffff") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style("z-index",1000)
         .style("border", "1.0px") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","60px")
         tooltipForLineChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'label').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "14px") .style("font-weight", "normal");
         tooltipForLineChart.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
         tooltipForLineChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");
 
     
     circle1.on('mousemove', function (d,i){
                
             var root = targetElement
             var m = d3.mouse(root.node());
             m[0] += 0
             m[1] += 0
             
             var valueForLineChartToolTip;
             if(d.value.toString().indexOf('.') === -1)
             {
                 valueForLineChartToolTip = d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
             }
             else{
                     
                 valueForLineChartToolTip = d.value;
             }
 
             tooltipForLineChart.select('.label').html(d.label)
             //tooltipForLineChart.select('.count').html(d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
             tooltipForLineChart.select('.count').html(valueForLineChartToolTip)
             tooltipForLineChart.style('visibility', 'visible')
             tooltipForLineChart.select('hr').style("background-color", d3.select(this).style("fill") )
             tooltipForLineChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-20) + "px").style("display","block")
 
     })
     .on('mouseout', function(){ tooltipForLineChart.style("display","none"); })
 
         
         var tableDivForLineChart = targetElement .append('div')
         .attr("class","scrollingDivForTable-Class tableDivForLineChart" + targetElement[0][0].id) .style('background-color',"#ffffff") .style("position","absolute")
         .style("display","block") .style("overflow","hidden") //.style("border-right","1px solid #e2e2e2").style("border-bottom","1px solid #e2e2e2")
 
         $( '.tableDivForLineChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
             var e0 = e.originalEvent,
             delta = e0.wheelDelta || -e0.detail;
     
             this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
             e.preventDefault();
         });
             
         if(options.showTitle == true){
             tableDivForLineChart.style("width", 100 + "%") .style("height", 40 + "%") .style("top",60 + "%") 
                        
         }
         else if(options.showTitle == false){
             tableDivForLineChart.style("width", 100 + "%") .style("height", 40 + "%") .style("top",60 + "%") 
         }
 
         tableDivForLineChart.html('<table class = "tableClassForLineChart' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                   '<thead class = "theadClassForLineChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForLineChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                                   '<tbody class = "tBodyClassForLineChart' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                   '</table>'
                                   )
         
         tableDivForLineChart.select('table').attr("id",targetElement[0][0].id + "tableID")
 
         // Show or Hide Table scroll when mouseover on widget
         targetElement.on('mouseover',function(){ tableDivForLineChart.style("overflow","auto") })
         targetElement.on('mouseout',function(d){ tableDivForLineChart.style("overflow","hidden") })
         
         var tableDataForLineChart = [];
         if(options.dataForTable.length > 0){
             tableDataForLineChart = options.dataForTable;
         }
         else {
             tableDataForLineChart = options.data;
         }
 
         
         var thead = tableDivForLineChart.select("thead").selectAll("th") .data(d3.keys(tableDataForLineChart[0]))
         .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
         
         var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#fefdfd")//f6f6f6
         .style("position","relative").style("top","2px")
         
         var thead1 = d3.select(".thead1ClassForLineChart" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tableDataForLineChart[0]))
         .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
         
         var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#fefdfd")//f6f6f6
         .style("position","relative").style("top","2px")
         
         var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
         .attr("id", "ascendingIconIDForLineChart") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
         
         var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
         .attr("id", "descendingIconIDForLineChart") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
         
         var tr = tableDivForLineChart.select("tbody").selectAll("tr") .data(tableDataForLineChart).enter().append("tr")
         .attr("id", function(d,i) { return "slice" + i })
         
         // cells
         var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter() .append("td") .text(function(d) { return d})
         .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
         
         var $table = $('.tableClassForLineChart' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
         
         d3.select(".theadClassForLineChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                     d.forEach(function(dd,j){
                         colWidth[j] = d3.select(dd).node().getBoundingClientRect().width;
                     })
         })
         
         $(".thead1ClassForLineChart" + targetElement[0][0].id).insertAfter('.tBodyClassForLineChart' + targetElement[0][0].id)
         
         $(".thead1ClassForLineChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForLineChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
         
         tableDivForLineChart.select(".thead1ClassForLineChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                     d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
         })
         
         $('.tableDivForLineChart' + targetElement[0][0].id).scroll(function () {
                                                                   
             $(".thead1ClassForLineChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForLineChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
                                                                   
         })
         
         var sortOrder = false;
         thead1.on("click",function(k,index){
                  
              sortOrder = !sortOrder;
              
              tableDivForLineChart.select(".thead1ClassForLineChart" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                                                 
                     if (sortOrder) {
                                       
                         if(i == index){
                             d3.select(this).select('svg').select('#descendingIconIDForLineChart').style("visibility", "hidden")
                             d3.select(this).select('svg').select('#ascendingIconIDForLineChart').style("visibility", "visible")
                         }
                         else {
                             d3.select(this).select('svg').select('#descendingIconIDForLineChart').style("visibility", "visible")
                             d3.select(this).select('svg').select('#ascendingIconIDForLineChart').style("visibility", "visible")
                         }
                     }
                     else{
                                       
                         if(i == index){
                             d3.select(this).select('svg').select('#descendingIconIDForLineChart').style("visibility", "visible")
                             d3.select(this).select('svg').select('#ascendingIconIDForLineChart').style("visibility", "hidden")
                         }
                         else {
                             d3.select(this).select('svg').select('#descendingIconIDForLineChart').style("visibility", "visible")
                             d3.select(this).select('svg').select('#ascendingIconIDForLineChart').style("visibility", "visible")
                         }
                     }
                 })
              
               var monthTruOrFalAryForLineChart = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
               
               tr.sort(function(a, b) {
                       
                       if (sortOrder) {
                       var monthsArrayForLineChart = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                       } else {
                       var monthsArrayForLineChart = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                       }
                       
                       monthTruOrFalAryForLineChart = []; gotMonthArray = [];
                       tableDataForLineChart.forEach(function(d,i){
                           var da = d[k].toString().substring(0,3).toLowerCase()
                           if(monthsArrayForLineChart.indexOf(da) >= 0){
                               monthTruOrFalAryForLineChart.push(true)
                               gotMonthArray.push(da);
                           }
                           else {
                               monthTruOrFalAryForLineChart.push(false)
                           }
                       })
                       
                       if(monthTruOrFalAryForLineChart.indexOf(false) == -1){ // true
                       
                       monthArray = []; monthArrayCount = [];
                       gotMonthArray.forEach(function(dd,j){
                             var index1 = monthsArrayForLineChart.indexOf(dd.substring(0,3))
                             if(monthArrayCount.indexOf(index1) >= 0){
                                 index1 = 12 + index1;
                             }
                             monthArray.push(index1);
                             monthArrayCount.push(index1)
                        })
                       returnArray = []
                       monthArray.sort(function(aa, bb) {
                           returnArray.push(+aa - +bb)
                           return +aa - +bb;
                       })
                       
                       sortTableFunc()
                       return returnArray[ind++];
                       } //  if true (if jan feb if block)
                       else {
                       var data = +a[k];
                       
                       if(!isNaN(data)){
                       
                       if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                       else { return d3.descending(+a[k], +b[k]); }
                       }
                       else if(!isNaN(Date.parse(a[k]))){
                       
                       if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                       else { return new Date(b[k]) - new Date(a[k]) }
                       }
                       else {
                       
                       if (sortOrder) { return d3.ascending(a[k], b[k]); }
                       else { return d3.descending(a[k], b[k]); }
                       }
                       } // if not jan feb else block
             }); // tr
 
         })
         
         function sortTableFunc(){
             
             var table = tableDivForLineChart.select('table');
             var rows = table.selectAll('tr').data(tableDataForLineChart);
             var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
             cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0) .style("color","#00001c");
             
             cells.text(function(d,i) {return d});
             
             // Cells exit selection
             cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
             
             var cells_in_new_rows = rows.enter().append('tr')
             .selectAll('td') .data(function(d){ return d3.values(d)})
             
             cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500) .style('opacity', 1.0) .style("color","#00001c");
             
             cells_in_new_rows.text(function(d,i) {return d});
             
             rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
         }
         
         // Main Table Styling
         tableDivForLineChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
         .style("color","#00001c")
         .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4")
         tableDivForLineChart.selectAll('td').style("height","25px") .style("border", "1px solid #ffffff") .style("font-size","12px").style("font-weight","Normal") .style("color","#00001c")
 
         //additionally 
         tableDivForLineChart.selectAll('th').style('background-color',"#ffffff").style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
         tableDivForLineChart.selectAll('td').style("border-style","none").style("color","#00001c")
         //tablePanelForPieChart.selectAll('td').style("height","25px") .style("border", "1px solid #fcfcfc") .style("font-size","12px").style("font-weight","Normal")
 
         //b1da9f
         tableDivForLineChart.selectAll('table') . style("border-collapse","collapse")
         tableDivForLineChart.selectAll('table tr:first-child th').style("border-top","0px")
         tableDivForLineChart.selectAll('table tr:last-child td').style("border-bottom","0px")
         tableDivForLineChart.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
         tableDivForLineChart.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")
 
         if(showOrHideTableForLineChart == false){
             tableDivForLineChart.style("display","none")
         }
         else if(showOrHideTableForLineChart == true){
             tableDivForLineChart.style("display","block")
         }
         
         if(options.isDataDetailedForTable == false){
         
             var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
         
             // Adding underlines for selected drill-down column text
             var drillDownSectionsForLineChart = tableDivForLineChart.select('table').selectAll('th')
         
             var foundResult = [];
             for(var i = 0; i<drillDownSectionsForLineChart[0].length; i++){
                 for(var j = 0; j<drillDownColumnNamesArray.length; j++){
                     if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForLineChart[0][i].__data__.toString().toLowerCase() ){
                         foundResult.push(i)
                     }
                 }
             }
         
             var r = tableDivForLineChart.select('table').selectAll('tr').selectAll('td')
             for(var i = 0; i<r.length; i++){
                 for(var j = 0; j < foundResult.length; j++){
                     var row = r[i][foundResult[j]]
                     $(row).css("text-decoration", "underline")
                 }
             }
         }
 
         resizedFunctionForLineChart(); // calling resized function for the first time.
         
         window.addEventListener('resize', function(event){ resizedFunctionForLineChart(); });
         
         $(function() {
            $("#" + targetElement[0][0].id).resizable({
             resize: function(event, ui) {
                     divWidth = ui.size.width;
                     divHeight = ui.size.height;
                     resizedFunctionForLineChart();
                 }
             });
         });
 
         function resizedFunctionForLineChart()
         {
 
             if((svgPanelForLineChart.node().getBoundingClientRect().width) && (svgPanelForLineChart.node().getBoundingClientRect().height) > 0){
                 
                 if(showOrHideCommentsBtnForLineChart == true){
                     areaButtonForLineChart.style('margin-left', "2px")
                     filterButtonForLineChart.style('margin-left', "2px")
                     refreshButtonForLineChart.style('margin-left', "2px")
                     commentsBtnForLineChart.style('margin-left', "2px")
                     menuButtonForLineChart.style('right', '0')
                 }
                 else if(showOrHideCommentsBtnForLineChart == false){
                     areaButtonForLineChart.style('margin-left', "2px")
                     filterButtonForLineChart.style('margin-left', "2px")
                     refreshButtonForLineChart.style('margin-left', "2px")
                     //commentsBtnForLineChart.style('right', '0')
                     commentsBtnForLineChart.style('display','none')
                     menuButtonForLineChart.style('right', '0')
                 }
 
                 optsBtnPanelForLineChart.style('right', '0')
 
                 stgPanCanBtnForLineChart.style('right', '0') // setting panel cancel button.
             
                 var margin1 = {top: 30 , right: 10, bottom: 80, left: 50}, //originally top: 42, left: 80
                 width1 = (svgPanelForLineChart.node().getBoundingClientRect().width) - margin1.left - margin1.right,
                 height1 = (svgPanelForLineChart.node().getBoundingClientRect().height) - margin1.top - margin1.bottom;
                 // width1 = ($('#svgPanelIDForLineChart' + targetElement[0][0].id)[0].getBoundingClientRect().width) - margin1.left - margin1.right,
                 // height1 = ($('#svgPanelIDForLineChart' + targetElement[0][0].id)[0].getBoundingClientRect().height) - margin1.top - margin1.bottom;
 
                 x.domain(options.data.map(function(d,i) { return d[options.keys.label];})).rangePoints([0, width1],0.65);
 
                 x1.domain(options.data.map(function(d) { return d[options.keys.label]; })) .rangePoints([0, width1], 0.65);
 
                 var yy = d3.scale.linear().domain([0, d3.max(maxArray, function(d) { return +d; })] ).range([height1, 0]);
 
                 yAxis.scale(yy) .orient("left");
 
                 xAxis.scale(x) .orient("bottom")
                 
                 line.x(function (d) { return x(d['label']); }) .y(function (d) { return yy(+d["value"]); });
 
                 var svg1 = svg;
             
                 svg1.select("svg") .attr("width", width1 + margin1.left + margin1.right) .attr("height", height1 + margin1.top + margin1.bottom)
                 
                 svg1.select(".y.axis") .call(yAxis)
     
                 svg1.select(".x.axis") .attr("transform", "translate(0," + height1 + ")") .call(xAxis)
             
                 // Add the X Axis margin labels
                 .selectAll("text") .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') .attr("transform", function(d) 
                 {
                    if(numberGreaterThanLimit.length>0){return "rotate(-45)"}
                        else{
                        return "rotate(0)" }})
                 .text(function(d,i) {
                     if(d.length > 9)
                         return d.substring(0,9)+'...';
                     else
                         return d;
                 })
             
                 xAxisVariable.attr("transform", "translate(" + ((width1/2) - 0) + " ," + (height1+margin1.bottom - 2) + ")")
 
                 svg1.selectAll("circle") .transition() .delay(function (d, i) { return i / options.data.length * 50; }) .duration(900).ease("bounce")
                 .attr("cx", function(d,i) {  return x1(d['label']); }) .attr("cy", function(d,i) {  return yy(+d["value"]); })
             
                 svg1.selectAll(".line")
                 .attr("d", function (d,i) { return line(d.Data); })
         
                 // Aligning Legend (vertically)
                 var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelForLineChart[0][0].style.width) / 100)
                 var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelForLineChart[0][0].style.height) / 100)
 
                 var legendRectSize = 11;
                 var legendSpacing = 6;
             
                 legend.attr('transform', function(d, i) {
                 var eachRectHeight = legendRectSize + legendSpacing;
                 var offset =  eachRectHeight * colorscale.domain().length / 2;
                 var horz = 5;
                 var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.lines.length))/2.0; // originally 2.0
             
                     return 'translate(' + horz + ',' + vert + ')';
                 })
                 
                 colWidth = []; 
                 
                 d3.select(".theadClassForLineChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                         d.forEach(function(dd,j){
                                 colWidth[j] = d3.select(dd).node().getBoundingClientRect().width;
                         })
                 })
                 tableDivForLineChart.select(".thead1ClassForLineChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                         d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
                 })
                 
 
 
             } // checking svg panel width & height is greater than zero  
         }
     }, //lineChart

    // ************************************************** Area Chart  **************************************************
    areaChart: function(targetElement, options){

        isChartCalled++;

        var chartName = "AREACHART";
        
        acinfotech.allCharts(targetElement,options,chartName);
        
        targetElement.style("min-width","350px").style("min-height","350px").style("background-color", options.BGcolor)

        var showOrHideTableForAreaChart;
        var showOrHideCommentsForAreaChart;
        var showOrHideCommentsBtnForAreaChart = true;

        if((options.showTable == false) || (options.showTable == true)){
            showOrHideTableForAreaChart = options.showTable    
        }
        else{
            showOrHideTableForAreaChart = false;
        }

        // Show or Hide comments
        if (options.showComments == true || false) {
            showOrHideCommentsForAreaChart = options.showComments;
        }
        else {
            showOrHideCommentsForAreaChart = false;
        }
        
        if (options.comments.length == 0){ 
            showOrHideCommentsForAreaChart = false;
            showOrHideCommentsBtnForAreaChart = false;
        }

        if ((showOrHideTableForAreaChart == true) && (showOrHideCommentsForAreaChart == true)){
            showOrHideTableForStkBarChart = true;
            showOrHideCommentsForAreaChart = false;
        }
        else if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == false)){
            showOrHideTableForStkBarChart = false;
            showOrHideCommentsForAreaChart = false;
        }

        var divWidth, divHeight;
        
        var chartTitlePanelForAreaChart = targetElement.append("div") .style("position","absolute").style("background-color", options.BGcolor) .style("text-indent","6px") .style("border", "none")
		
		var optsBtnPanelForAreaChart = targetElement.append('div').style('width',"25px").style('height',"205px").style('position','absolute')
		.style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px").style('right', '0') 
		.style("min-width","25px").style("border-style","none").style("border-left", "solid #fcfcfc  1px")
        
        var perAreaBtnForAreaChart = optsBtnPanelForAreaChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','80px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var perAreaBtnImgVar = document.createElement("IMG");
        perAreaBtnImgVar.src = "images/percentageAreaIcon.png";
        perAreaBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:16px; height:16px; opacity:0.75;")
        perAreaBtnForAreaChart[0][0].appendChild(perAreaBtnImgVar)
        
        var lineButtonForAreaChart = optsBtnPanelForAreaChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','105px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var lineBtnImgVar = document.createElement("IMG");
        lineBtnImgVar.src = "images/linearLineIcon1.png";
        lineBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        lineButtonForAreaChart[0][0].appendChild(lineBtnImgVar)

        var filterButtonForAreaChart = optsBtnPanelForAreaChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','130px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var filterBtnImgVar = document.createElement("IMG");
        filterBtnImgVar.src = "images/filterIcon.png";
        filterBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        filterButtonForAreaChart[0][0].appendChild(filterBtnImgVar)

        var refreshButtonForAreaChart = optsBtnPanelForAreaChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','155px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var refreshBtnImgVar = document.createElement("IMG");
        refreshBtnImgVar.src = "images/refreshIcon.png";
        refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        refreshButtonForAreaChart[0][0].appendChild(refreshBtnImgVar)

        var commentsBtnForAreaChart = optsBtnPanelForAreaChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','180px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var commentsBtnImgVariable = document.createElement("IMG");
        if(options.showComments == false){
            commentsBtnImgVariable.src = "images/showCommentsIcon.png";
        }
        else if(options.showComments == true){
            commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
        }
        commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        commentsBtnForAreaChart[0][0].appendChild(commentsBtnImgVariable)

        var menuButtonForAreaChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','1px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var menuBtnImgVar = document.createElement("IMG");
        menuBtnImgVar.src = "images/menuIcon.png";
        menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
        menuButtonForAreaChart[0][0].appendChild(menuBtnImgVar)

        if(showOrHideCommentsBtnForAreaChart == true){
            perAreaBtnForAreaChart.style('margin-left', "2px")
            lineButtonForAreaChart.style('margin-left', "2px")
            filterButtonForAreaChart.style('margin-left', "2px")
            refreshButtonForAreaChart.style('margin-left', "2px")
            commentsBtnForAreaChart.style('margin-left', "2px")
            menuButtonForAreaChart.style('right', '0')
        }
        else if(showOrHideCommentsBtnForAreaChart == false){
            perAreaBtnForAreaChart.style('margin-left', "2px")
            lineButtonForAreaChart.style('margin-left', "2px")
            filterButtonForAreaChart.style('margin-left', "2px")
            refreshButtonForAreaChart.style('margin-left', "2px")
            //commentsBtnForAreaChart.style('right', '0')
            commentsBtnForAreaChart.style('display','none')
            menuButtonForAreaChart.style('right', '0')
        }

        var ismenuBtnOfAreaChartClicked = false;
        menuButtonForAreaChart.on('click', function() {

            filterPanelForAreaChart.style("display","none");
            stgPanDivForAreaChart.style("display","none") // Hiding setting panel

            if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == true)){
                divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                svgPanelForAreaChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForAreaChart == true) && (showOrHideCommentsForAreaChart == false)){
                divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                svgPanelForAreaChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == false)){
                divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                svgPanelForAreaChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color", options.BGcolor);
            }

            if(ismenuBtnOfAreaChartClicked == false){
                ismenuBtnOfAreaChartClicked = true;
                optsBtnPanelForAreaChart.style("display","block")

            }
            else if(ismenuBtnOfAreaChartClicked == true){
                ismenuBtnOfAreaChartClicked = false
                optsBtnPanelForAreaChart.style("display","none")
            }

            resizedFuctionForAreaChart();
        })

        var tableButtonForAreaChart = optsBtnPanelForAreaChart.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top','1px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
        var tableBtnImgVar = document.createElement("IMG");
        if(showOrHideTableForAreaChart == false){
            tableBtnImgVar.src = "images/showTableIcon.png";
            tableButtonForAreaChart.attr("class","showTableClassForChartTable")
        }
        else if(showOrHideTableForAreaChart == true){
            tableBtnImgVar.src = "images/cancelTableIcon.png";
            tableButtonForAreaChart.attr("class","hideTableClassForChartTable")
        }
        tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
        tableButtonForAreaChart[0][0].appendChild(tableBtnImgVar)

        var settingBtnForAreaChart = optsBtnPanelForAreaChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 28 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        var settingBtnImgVar = document.createElement("IMG");
        settingBtnImgVar.src = "images/settingsIcon.png";
        settingBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.82;")
        settingBtnForAreaChart[0][0].appendChild(settingBtnImgVar)
        
        var downloadBtnForAreaChart = optsBtnPanelForAreaChart.append("div").attr("id","downloadBtnForAreaChart-ID-" + targetElement[0][0].id).style("width","20px").style("height","20px")
        .style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff").style('margin-left','2px').style('top', 54 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        
        acinfotech.downloadFunctionality("downloadBtnForAreaChart-ID-" + targetElement[0][0].id,targetElement)

        var svgPanelForAreaChart = targetElement .append('svg') 
        .attr("id","svgPanelIDForLineChart" + targetElement[0][0].id) .style("background-color", options.BGcolor) .style("position","absolute")
        
        var commentsPanelDivForAreaChart = targetElement.append("div") .attr("class","commentsPanelClassForAreaChart") 
        .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
		.style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
        .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)

        commentsPanelDivForAreaChart.on('click',function(d){
            $('.commentsClassForAreaChart' + targetElement[0][0].id).focus()
        })

        if(options.showTitle == true){
            
            chartTitlePanelForAreaChart.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 8 + "%"; })
            .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')

            if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == true)){

                var commentsForAreaChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify') .attr('class','commentsClassForAreaChart' + targetElement[0][0].id)

                   svgPanelForAreaChart.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%").style("background-color", options.BGcolor) .append('g')
                   commentsPanelDivForAreaChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForAreaChart[0].outerHTML.toString())

            }
            else if ((showOrHideTableForAreaChart == true) && (showOrHideCommentsForAreaChart == false)){

                    svgPanelForAreaChart.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%").style("background-color", options.BGcolor) .append('g')
                    commentsPanelDivForAreaChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == false)){
                    svgPanelForAreaChart.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .style("background-color", options.BGcolor).append('g')
                    commentsPanelDivForAreaChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            
            var margin = {top: 30 , right: 10, bottom: 80, left: 50}, //originally top: 42, left: 80
            width = (svgPanelForAreaChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = (svgPanelForAreaChart.node().getBoundingClientRect().height) - margin.top - margin.bottom;
            
        }
        else if(options.showTitle == false){
            chartTitlePanelForAreaChart.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });
            
            if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == true)){

                var commentsForAreaChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',false).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify')

                   svgPanelForAreaChart.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .style("background-color", options.BGcolor).append('g')
                   commentsPanelDivForAreaChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForAreaChart[0].outerHTML.toString())

            }
            else if ((showOrHideTableForAreaChart == true) && (showOrHideCommentsForAreaChart == false)){

                    svgPanelForAreaChart.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%").style("background-color", options.BGcolor).append('g')
                    commentsPanelDivForAreaChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == false)){
                    svgPanelForAreaChart.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .style("background-color", options.BGcolor).append('g')
                    commentsPanelDivForAreaChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            
            var margin = {top: 30 , right: 10, bottom: 80, left: 50}, //originally top: 42, left: 80
            width = (svgPanelForAreaChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = (svgPanelForAreaChart.node().getBoundingClientRect().height) - margin.top - margin.bottom;
        }

        var colorscale; 
        // checking color set for pie slices and legend dots
        if(options.colorSet === undefined){
            options.colorSet = "one"
            colorscale = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "one"){
            options.colorSet = "one"
            colorscale = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            options.colorSet = "two"
             colorscale = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            options.colorSet = "three"
            colorscale = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        }
        else
        {
            options.colorSet = "one"
            colorscale = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }

        if ((options.lineStyle.toString().toLowerCase() === "cardinal") || (options.lineStyle.toString().toLowerCase() === "linear") || (options.lineStyle.toString().toLowerCase() === "step")){
            options.lineStyle = options.lineStyle;   
        }
        else{
            options.lineStyle = "cardinal";
        }

        //------------------ Settings panel DIV and everything within it section begins here ------------------
        
        var stgPanDivForAreaChart = targetElement.append('div').style('width',"100%").style('height',"40%").attr("class","stgPanDivForLineChart" + targetElement[0][0].id)
        .style('position','absolute').style('margin-left', "0px").style('border-top',"1px solid #f0f0f0").style('border-bottom',"1px solid #e5e5e5")
        .style("background-color",'#fcfcfc').style("z-index",90) .style("display","none") .style('top',"60%").style('height',"40%")

        $( '.stgPanDivForLineChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        var settingPanelTitle = stgPanDivForAreaChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','10px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; color:#00001c;">'+ "Settings" +'</div>')

        var stgPanDivForLineChangeColorTitle = stgPanDivForAreaChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Select color set " +'</div>')

        var stgPanCanBtnForAreaChart = stgPanDivForAreaChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
        .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
        .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.9; background-color:#fcfcff")
        stgPanCanBtnForAreaChart[0][0].appendChild(cancelBtnImgVar)

        stgPanCanBtnForAreaChart.on('click', function() {
            stgPanDivForAreaChart.style("display","none") // Hiding setting panel

            if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == true)){
                divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                svgPanelForAreaChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForAreaChart == true) && (showOrHideCommentsForAreaChart == false)){
                divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                svgPanelForAreaChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == false)){
                divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                svgPanelForAreaChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color", options.BGcolor);
            }

            resizedFuctionForAreaChart();
        })

        var formForChangeSettingsPanel = stgPanDivForAreaChart.append("form");
        formForChangeSettingsPanel.style("background-color","#fcfcfc").style("margin-top","67px").style("font-family","Verdana,sans-serif").style("font-size","12px")
        .style("position","absolute").attr("id","formForChangeColorSettingsPanel" + targetElement[0][0].id).style("font-weight","Bold").style("width","180px")
        .style("height","58px").style("padding","0px").style("border-radius","0px") .style("margin-left","10px")

        var svgPanelForCrSetOne = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px").style("margin-top","1px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetOne = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        var colorSetOneRange = d3.range(12);

        var colorSetOneDots = svgPanelForCrSetOne.append("g")
        colorSetOneDots.selectAll('rect') .data(colorSetOneRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("fill", function(d,i){return colorSetOne(i)})
        .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetOne(i);  })
        .style("cursor","auto") .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        var svgPanelForCrSetTwo = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px") .style("margin-top","20px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetTwo = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        var colorSetTwoRange = d3.range(12);

        var colorSetTwoDots = svgPanelForCrSetTwo.append("g")
        colorSetTwoDots.selectAll('rect') .data(colorSetTwoRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto")
        .style("fill", function(d,i){return colorSetTwo(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
        .style("stroke",function(d,i){  return colorSetTwo(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        var svgPanelForCrSetThree = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px") .style("margin-top","39px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetThree = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        var colorSetThreeRange = d3.range(12);

        var colorSetThreeDots = svgPanelForCrSetThree.append("g")
        colorSetThreeDots.selectAll('rect') .data(colorSetThreeRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto") .style("fill", function(d,i){return colorSetThree(i)})
        .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetThree(i);  })
        .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        if(options.colorSet.toString().toLowerCase() === "one"){
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"1px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"1px solid #808080")
        }
        else 
        {
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }

        svgPanelForCrSetOne.on('click',function(d){
            options.colorSet = "one"
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")

            colorscale = "";
            colorscale = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);

            areas.style("fill", function (d,i) { return colorscale(i); }).style("stroke", function (d,i) { return colorscale(i); })
            //colorCount = 0;
            // circle1.style("fill", function (d,i) {
            //     if(i == 0){
            //         colorCount++;
            //     }
            //     return colorscale(colorCount - 1);
            // })

            legend.selectAll('rect').style("fill", function(d, i){ return colorscale(i);})
        
        })
        svgPanelForCrSetTwo.on('click',function(d){
            options.colorSet = "two"
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"1px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")

            colorscale = "";
            colorscale = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);

            areas.style("fill", function (d,i) { return colorscale(i); }).style("stroke", function (d,i) { return colorscale(i); })
            // colorCount = 0;
            // circle1.style("fill", function (d,i) {
            //     if(i == 0){
            //         colorCount++;
            //     }
            //         return colorscale(colorCount - 1);
            // })
            legend.selectAll('rect').style("fill", function(d, i){ return colorscale(i);})
        })
        svgPanelForCrSetThree.on('click',function(d){
            options.colorSet = "three"
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"1px solid #808080")

            colorscale = "";
            colorscale = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);

            areas.style("fill", function (d,i) { return colorscale(i); }).style("stroke", function (d,i) { return colorscale(i); })
            // colorCount = 0;
            // circle1.style("fill", function (d,i) {
            //     if(i == 0){
            //         colorCount++;
            //     }
            //         return colorscale(colorCount - 1);
            // })
            legend.selectAll('rect').style("fill", function(d, i){ return colorscale(i);})
        })

        var areaStrokeChangeStyleTitle = stgPanDivForAreaChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','190px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Area Style " +'</div>')

        var lineStyleDivForAreaChart = stgPanDivForAreaChart.append("div") .style("background-color","#fcfcfc") .style("margin-left","200px")
        .style("margin-top","67px") .style("font-family","Verdana,sans-serif") .style("font-size","12px") .style("position","absolute")
        .style("font-weight","Bold").style("width","110px") .style("height","30px") .style("padding","0px") .style("border-radius","0px")
        
        var cardinalButton = lineStyleDivForAreaChart.append("div") .style("width","32px").style("height","26px").style('position','absolute')
        .style('background-color',"#ffffff").style('margin-left',"0px") .style('top','1px') .style("cursor","pointer") .style("display","block")
        .style("border-style", "none").style('padding',"0px") .style("border", "1px solid #a0a0a0").style("line-height","0px") .style("box-sizing","border-box")
        var cardinalBtnImgVar = document.createElement("IMG");
        cardinalBtnImgVar.src = "images/curveAreaIcon.png";
        cardinalBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:24px; height:19px; opacity:0.78;")
        cardinalButton[0][0].appendChild(cardinalBtnImgVar)

        var linearButton = lineStyleDivForAreaChart.append("div") .style("width","32px").style("height","26px").style('position','absolute')
        .style('background-color',"#ffffff").style('margin-left',"35px") .style('top','1px') .style("cursor","pointer") .style("display","block")
        .style("border-style", "none") .style('padding',"0px") .style("line-height","0px") .style("box-sizing","border-box")
        var linearBtnImgVar = document.createElement("IMG");
        linearBtnImgVar.src = "images/linearAreaIcon.png";
        linearBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:24px; height:19px; opacity:0.78;")
        linearButton[0][0].appendChild(linearBtnImgVar)

        var stepButton = lineStyleDivForAreaChart.append("div") .style("width","32px") .style("height","26px") .style('position','absolute')
        .style('background-color',"#ffffff") .style('margin-left',"70px") .style('top','1px') .style("cursor","pointer") .style("display","block")
        .style("border-style", "none").style('padding',"0px").style("line-height","0px").style("box-sizing","border-box")
        var stepBtnImgVar = document.createElement("IMG");
        stepBtnImgVar.src = "images/stepAreaIcon.png";
        stepBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:24px; height:21px; opacity:0.78;")
        stepButton[0][0].appendChild(stepBtnImgVar)

        if(options.lineStyle.toString().toLowerCase() === "cardinal"){
            cardinalButton.style('border',"1px solid #808080")
            linearButton.style('border',"0px solid #808080")
            stepButton.style('border',"0px solid #808080")
        }
        else if(options.lineStyle.toString().toLowerCase() === "linear"){
            cardinalButton.style('border',"0px solid #808080")
            linearButton.style('border',"1px solid #808080")
            stepButton.style('border',"0px solid #808080")
        }
        else if(options.lineStyle.toString().toLowerCase() === "step"){
            cardinalButton.style('border',"0px solid #808080")
            linearButton.style('border',"0px solid #808080")
            stepButton.style('border',"1px solid #808080")
        }
        else 
        {
            cardinalButton.style('border',"1px solid #808080")
            linearButton.style('border',"0px solid #808080")
            stepButton.style('border',"0px solid #808080")
        }

        cardinalButton.on('click',function(d){
            options.lineStyle = "cardinal"
            cardinalButton.style('border',"1px solid #a0a0a0")
            linearButton.style('border',"0px solid #808080")
            stepButton.style('border',"0px solid #808080")

            area.interpolate(options.lineStyle) .x(function (d) { return x1(d['label']); }) .y0(height) .y1(function (d) { return y(+d["value"]); });

            areas.attr("d", function (d,i) { return area(d.Data)})

            resizedFuctionForAreaChart();

        })
        linearButton.on('click',function(d){
            options.lineStyle = "linear"
            cardinalButton.style('border',"0px solid #a0a0a0")
            linearButton.style('border',"1px solid #a0a0a0")
            stepButton.style('border',"0px solid #a0a0a0")

            area.interpolate(options.lineStyle) .x(function (d) { return x1(d['label']); }).y0(height) .y1(function (d) { return y(+d["value"]); });

            areas.attr("d", function (d,i) { return area(d.Data)})

            resizedFuctionForAreaChart();

        })
        stepButton.on('click',function(d){
            options.lineStyle = "step"
            cardinalButton.style('border',"0px solid #a0a0a0")
            linearButton.style('border',"0px solid #a0a0a0")
            stepButton.style('border',"1px solid #a0a0a0")

            area.interpolate(options.lineStyle) .x(function (d) { return x1(d['label']); }) .y0(height) .y1(function (d) { return y(+d["value"]); });

            areas.attr("d", function (d,i) { return area(d.Data)})

            resizedFuctionForAreaChart();
        })

        //------------------ Settings panel DIV and everything inside it section ends here ------------------

        var divLegendPanelForAreaChart = targetElement .append('div')  .attr("class","divLegendPanelClassForAreaChart") .style("background-color", options.BGcolor).style('position',"absolute")
        .style('width', 25 + "%") .style('height', 92 + "%") .style("left",75 + "%").style("top",8 + "%") 

        if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == true)){
                divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                svgPanelForAreaChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForAreaChart == true) && (showOrHideCommentsForAreaChart == false)){
                divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                svgPanelForAreaChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == false)){
                divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                svgPanelForAreaChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color", options.BGcolor);
            }

        // Creating ToolTip for options button.
        var iconButtonTooltipForAreaChart = targetElement.append('div').style('width','240px').attr("id","too")
        .style('height',"25px").style('position','absolute')//.style('margin-left', "0px").style('top','25px')
        .style("background-color",'#404040 ').style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid") // 004b9d
        .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none").attr("border", 0.0)
        
        perAreaBtnForAreaChart.on('mousemove', function(d,i) {
            var root = targetElement
            var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var filterButtonTooltipText = "Percentage Area Chart";
            iconButtonTooltipForAreaChart.style("width","138px").style("margin-left", (m[0] - 148) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForAreaChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')
                                  
        })
        perAreaBtnForAreaChart.on('mouseout', function(d,i) {
            iconButtonTooltipForAreaChart.style("display","none")
        })
        
         lineButtonForAreaChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var filterButtonTooltipText = "Switch to Line Chart";
            iconButtonTooltipForAreaChart.style("width","126px").style("margin-left", (m[0] - 136) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForAreaChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')

        })
        lineButtonForAreaChart.on('mouseout', function(d,i) {
            iconButtonTooltipForAreaChart.style("display","none")
        })

        filterButtonForAreaChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var filterButtonTooltipText = "Filter";
            iconButtonTooltipForAreaChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForAreaChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')

        })
        filterButtonForAreaChart.on('mouseout', function(d,i) {
            iconButtonTooltipForAreaChart.style("display","none")
        })

        refreshButtonForAreaChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var refreshButtonTooltipText = "Refresh";
            iconButtonTooltipForAreaChart.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForAreaChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ refreshButtonTooltipText +'</div>')

        })
        refreshButtonForAreaChart.on('mouseout', function(d,i) {
            iconButtonTooltipForAreaChart.style("display","none")
        })

        commentsBtnForAreaChart.on('mousemove', function(d,i) {
            commentsPanelDivForAreaChart.style('background-color','#fafafa')
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                if(options.showComments == false){
                    var commentButtonTooltipText = "Show Comments";
                }
                else if(options.showComments == true){
                    var commentButtonTooltipText = "Hide Comments";
                }
            
            iconButtonTooltipForAreaChart.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForAreaChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ commentButtonTooltipText +'</div>')
        })
        commentsBtnForAreaChart.on('mouseout', function(d,i) {
            commentsPanelDivForAreaChart.style('background-color','#ffffff')
            iconButtonTooltipForAreaChart.style("display","none")
        })

        menuButtonForAreaChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var menuButtonTooltipText = "Menu";
            iconButtonTooltipForAreaChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForAreaChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ menuButtonTooltipText +'</div>')

        })
        menuButtonForAreaChart.on('mouseout', function(d,i) {
            iconButtonTooltipForAreaChart.style("display","none")
        })

        tableButtonForAreaChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            if(showOrHideTableForAreaChart == false){
                var tableButtonTooltipText = "Show Table";
            }
            else if(showOrHideTableForAreaChart == true){
                var tableButtonTooltipText = "Hide Table";
            }
            iconButtonTooltipForAreaChart.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForAreaChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ tableButtonTooltipText +'</div>')

        })
        tableButtonForAreaChart.on('mouseout', function(d,i) {
            iconButtonTooltipForAreaChart.style("display","none")
        })

        settingBtnForAreaChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var settingTooltipText = "Settings";
            iconButtonTooltipForAreaChart.style("width","67px").style("margin-left", (m[0] - 77) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForAreaChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ settingTooltipText +'</div>')
        })
        settingBtnForAreaChart.on('mouseout', function(d,i) {
            iconButtonTooltipForAreaChart.style("display","none")
        })
        
        downloadBtnForAreaChart.on('mousemove', function(d,i) {
              var root = targetElement
              var m = d3.mouse(root.node());
              m[0] += 0
              m[1] += 0
              var downloadButtonTooltipText = "Download";
              iconButtonTooltipForAreaChart.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
              iconButtonTooltipForAreaChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
        })
        downloadBtnForAreaChart.on('mouseout', function(d,i) {
              iconButtonTooltipForAreaChart.style("display","none")
        })
        
        // ----------------- Filter panel and everything within it section begins here ----------------
        var filterPanelForAreaChart = targetElement.append('div') .style('width',350 + "px") .attr("class","filterPanelForLineChartClass" + targetElement[0][0].id)
        .style('position','absolute') .style('margin-left', "0px") .style("background-color",'#fefefe') .style("z-index",11)
        .style("border-color", "#ffffff").style("border-right", "solid #e5e5e5 1px")  .style("border-style", "solid") .style("box-shadow", "2px 0px 1px #eff8ec")
        .style("display","none").style("border-top", "solid #fdfdfd 1px").style("border-left","0px").style("border-bottom", "0px")
        .style('top', 0.0 + "%").style('height', 100 + "%").style('overflow-y',"hidden").style("overflow-x","hidden")
        .style("border-bottom", "solid #e5e5e5 1px") .style("box-sizing","border-box")

        var filterPanelForStkBarChartTitle = filterPanelForAreaChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','20px').style('text-indent','5px').style("font-size", "14px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #007aff").style("width","350px").style("color","#000000")
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; top:25.0%; font-size:14px; font-family:inter; color:#00001c;">'+ "Filter" +'</div>')

        var measuresColumnTitle = filterPanelForAreaChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; text-indent:3px;">Available Measures</div>');

        var measuresVariables = filterPanelForAreaChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable1"+targetElement[0][0].id)
        .style("list-style-type","none") .style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '78px')
        .style('position','absolute') .style("width","155px").style("min-height","190px").style("max-height","190px").style("border", "#f0f0f0 1px solid")
        .style("max-width","155px").style("overflow-x","hidden").style("overflow-y","auto")
        measuresVariables.style("left",0.0 + "px").style("padding","2px")

        $( ".filterPanelForLineChartClass" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });


        var measuresArray = [];
        var dimensionArray = [];

        var measuresArrayLength = [];
        var dimensionsArrayLength = [];

        dimensionArray.push(options.keys.label);
        //measuresArray = options.keys.stackedBars;

        for(var i = 0; i<divAndChartsArray.length; i++){
            if(targetElement[0][0].id === divAndChartsArray[i].divID){
                
                if(newtargetElementAndOptionsArray[i].options.keys.areas == undefined){
                    measuresArray = newtargetElementAndOptionsArray[i].options.keys.lines;
                }
                else{
                    measuresArray = newtargetElementAndOptionsArray[i].options.keys.areas;
                }
            }
        }
        
        // filter process
        var uniqueMeasuresArrayKeys = [];
        $.each(measuresArray, function(i, el){
            if($.inArray(el, uniqueMeasuresArrayKeys) === -1){
                uniqueMeasuresArrayKeys.push(el);
            }
        });

        var uniqueDimensionArrayKeys = [];
        $.each(dimensionArray, function(i, el){
            if($.inArray(el, uniqueDimensionArrayKeys) === -1){
                uniqueDimensionArrayKeys.push(el);
            }
        });
        
        // setting lenght for arrays
        for(var i = 0; i<uniqueMeasuresArrayKeys.length; i++){
            measuresArrayLength.push(i);
        }

        for(var i = 0; i<uniqueDimensionArrayKeys.length; i++){
            dimensionsArrayLength.push(i);
        }

        var measuresVariables1 = measuresVariables.selectAll("li") .data(measuresArrayLength).enter().append("li")
        .style("width","130px") .style("max-height","22px").style("cursor","move")
        .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#bcf1bc").style("font-weight","Normal")
        .style("list-style-type","none").style("border","1px #89e789 solid").style("color","#006600").style("font-family","Verdana,sans-serif")
        .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
        .text(function(d) {return uniqueMeasuresArrayKeys[d]})
        measuresVariables1.attr("class","MeasuresClass"+targetElement[0][0].id)
        
        var measuresColumnReceivedUI_TableTitle = filterPanelForAreaChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','180px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; ">Selected Measures</div>');

        var measuresColumnReceivedUI_Table = filterPanelForAreaChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable3"+targetElement[0][0].id)
        .style('background-color',"#ffffff").style('margin-left','180px').style('margin-top', '78px')
        .style("width","155px").style('position','absolute').style("padding","2px").style("min-height","190px")
        .style("border","1px #c1c1c1 dashed") .style("max-height","190px") .style("overflow-x","hidden") .style("overflow-y","auto")
        //.html('<div class=unsortable  style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:65.0%; font-size:14px; font-family:inter;  color:#99ea99; font-weight:Normal; text-align:center;">Drag and Drop Measures here from Available Measures List. </div>');
        .html('<img class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' src="images/dragIcon.png" style=" width:36px; height:36px; position:absolute; margin-left:65px; margin-top:60px; opacity:0.6"/>' 
        + '<div class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:60.0%; font-size:12px; font-family:inter;  color:#89d289; font-weight:Normal; text-align:center;">Drop Measures here. </div>');
        //.html('<div style="background-image: url(images/dragIcon.png); height: 64px; width: 64px; border: 1px solid black;"> </div>');

        var cancelButton = filterPanelForAreaChart.append("div") .style("width","23px").style("height","21px").style('position','absolute')
        .style('margin-left','320px').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
        .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.9; background-color:#fcfcff")
        cancelButton[0][0].appendChild(cancelBtnImgVar)

        cancelButton.on("click", function(){
            filterPanelForAreaChart.style("display","none")

            if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == true)){
                divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                svgPanelForAreaChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForAreaChart == true) && (showOrHideCommentsForAreaChart == false)){
                divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                svgPanelForAreaChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == false)){
                divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                svgPanelForAreaChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color", options.BGcolor);
            }
        })

        var reRenderChartAndTableButton = filterPanelForAreaChart.append("button").style("width","120px").style("height","25px").style('position','absolute')
        .style('margin-left','112px').style('margin-top','298px') .style("border-style", "none").style('background-color',"#2196f3")
        .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','15px').style("border-style", "solid").style('color','#ffffff')
        .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 1px #9b9b9b").style("border-radius","0px")
        var textForReRenderButton = document.createTextNode("Apply Changes");
        reRenderChartAndTableButton[0][0].appendChild(textForReRenderButton)

        reRenderChartAndTableButton.on("click", function(){
            
            if( $("#sortable3"+targetElement[0][0].id).children("li").length == 0 )
            {

                var alertPageDisabledDivForAreaChart =targetElement.append('div').style('width',100 + '%')
                .style('height',100 + "%").style('position','absolute').style('margin-left', '0px').style('top', '0px')
                .style("background-color",'#f3f3f3').style("z-index",99)//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("opacity",0.2).style("display","block")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")

                var alertDivForAreaChart = targetElement.append('div').style('width','350px')
                .style('height',"150px").style('position','absolute').style('left', ((targetElement[0][0].clientWidth/2) - 175) + "px").style('top', '1px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "solid").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","0px")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
                //.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Bold;">Sorry, no result found for selected' + 'range!'+ '</br>' + '<label style=text-indent:10px;> Hello</label' +'</div>')
                .html('<p  style="width: 340px; height:0%; background-color:#c7c7c7; position: absolute; top:40.0%; font-size:14px; font-family:inter; font-weight:Bold; margin-left:10px;  color:#f8f8f8; font-weight:Normal;">Check whether the Selected Measures box is not empty!</p>')

                var alertDivTitleForAreaChart = alertDivForAreaChart.append('div').style('width','340px')
                .style('height',"30px").style('position','absolute').style('margin-left', "0px").style('top', '0px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "none").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","2px")
                .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; font-weight:Bold; text-indent:5px;  color:#e5e5e5; font-weight:Normal;">TimeBound</div>')

                var areaChartAlertOKButton = alertDivForAreaChart.append("button") .style("width","40px") .style("height","20px") .style('position','absolute') .style("box-shadow", "0px 1px 1px #B8B8B8") 
                .style('background-color',"#7cc15e") .style('margin-left','300px') .style('top', "120px").style("color","#ffffff")
                .style("display","block").style('padding-top',"0px").style("cursor","pointer").style("box-shadow", "1px 1px 1px #56973a") .style("border-style", "none")
                .style("font-family","Verdana,sans-serif").style("font-size","14px").style("text-align","center").style("vertical-align","middle").style("border-radius","0px")
                .style("z-index",999)
            
                var textForAreaChartAlertOKButton = document.createTextNode("OK");
                areaChartAlertOKButton[0][0].appendChild(textForAreaChartAlertOKButton)

                $("#"+targetElement[0][0].id).resizable('disable');

                areaChartAlertOKButton.on('click', function() {
                    alertDivForAreaChart.remove();
                    alertPageDisabledDivForAreaChart.remove()
                    $("#"+targetElement[0][0].id).resizable('enable');
                })

                filterButtonForAreaChart.style("cursor","pointer")
                
                if(showOrHideTableForAreaChart == false){ 
                    svgPanelForAreaChart.style('width', 75 + "%") .style('height', 85 + "%").style("position","absolute").style("background-color", options.BGcolor)
                    divLegendPanelForAreaChart.style('width', 25 + "%") .style('height', 85 + "%").style("position","absolute").style("background-color", options.BGcolor)
                }   
                else if(showOrHideTableForAreaChart == true){ 
                    svgPanelForAreaChart.style('width', 75 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor)
                    divLegendPanelForAreaChart.style('width', 25 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor)
                } 

                resizedFuctionForAreaChart();
            }

            else{

                var selectedAreaMeasures = [];
                for(var i=0; i<$("#sortable3"+targetElement[0][0].id).children("li").length;i++){
                    selectedAreaMeasures.push($("#sortable3"+targetElement[0][0].id).children("li")[i].textContent)
                }
            
                var newOptions = {
                           data: options.data,
                           dataForTable: options.dataForTable,
                           isDataDetailedForTable: options.isDataDetailedForTable,
                           keys: {
                               label: options.keys.label,
                               areas: selectedAreaMeasures,
                           },
                           chartTitle:options.chartTitle,
                           xAxisLable: options.keys.label,
                           yAxisLable: "",
                           //dimensions: options.dimensions,
                           //measures: options.measures,
                           showTitle: true,
                           colorSet: options.colorSet,
                           BGcolor:options.BGcolor,
                           series:options.series,
                           legend:options.legend,
                           lineStyle: options.lineStyle,
                           drillDownColumnName:options.drillDownColumnName,
                           showTable: options.showTable,
                           showComments: options.showComments,
                           comments: options.comments,
                           resizeButtonID: options.resizeButtonID //document.getElementById("resizeBtn").id
                        }
                        
                        d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                        acinfotech.areaChart(targetElement,newOptions)
                }
        })

        var textBoxForMeasureColumnFrom;
        var textBoxForMeasureColumnTo;
        var selectTitleDivForEachDimension;

        $( "ul.droptrue"+targetElement[0][0].id ).sortable({
            appendTo: document.body,
            helper: "clone",
            connectWith: ".droptrue"+targetElement[0][0].id,
            scroll: false,
            cancel: '.unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+','+' .unMoveableIconAndTextClassDimensions'+targetElement[0][0].id,
            revertDuration: 10,
            scrollSensitivity: 10,
            scrollSpeed: 1,
            dynamic: true,

            receive: function(e, ui) { 
                 
                if (($(this)[0].id == "sortable3"+targetElement[0][0].id) || ($(this)[0].id == "sortable1"+targetElement[0][0].id)) {

                        if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                            if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                                 (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                            }
                            else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                                (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                            }

                        }
                } // if (($(this)[0].id == "sortable3") || ($(this)[0].id == "sortable1")) 

                else if (($(this)[0].id == "sortable2"+targetElement[0][0].id) || ($(this)[0].id == "sortable4"+targetElement[0][0].id)) {
                    if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                            //ui.sender.sortable("cancel");

                            if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                                 (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                            }
                            else if(  ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                                (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                            }
                        }
                } //if (($(this)[0].id == "sortable2") || ($(this)[0].id == "sortable4")) {

                $(ui.item).css({ 'position': 'relative' });

                if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                    ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                }
                 
                else if ($(this)[0].id == "sortable3"+targetElement[0][0].id) { // checking if the dropped element is in Measures drop area
                    
                    if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                        ui.sender.sortable("cancel");
                    }
                    else {
                        //ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                    }

                } // else if ($(this)[0].id == "sortable3") // checking if the dropped element is in Measures drop area ends here.

                else if ($(this)[0].id == "sortable4"+targetElement[0][0].id) { // checking if the dropped element is in Dimension drop area

                    if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                        ui.sender.sortable("cancel");
                    }
                    else {
                        ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                    }
                } //else if ($(this)[0].id == "sortable4")  // checking if the dropped element is in Dimension drop area ends here

                    if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                        
                        if ($(this)[0].id == "sortable1"+targetElement[0][0].id){
                            if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                            
                                if( ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                                    ui.sender.sortable("cancel");
                                } // if(  ui.sender.attr("id") === "sortable4")

                                else if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                                    ui.sender.sortable("cancel");
                                }
                            
                            } // if(ui.item.hasClass("DimesionsClass"))
                        }
                    if ($(this)[0].id == "sortable2"+targetElement[0][0].id){
                        if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                            
                            if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                                ui.sender.sortable("cancel");
                            }
                            else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                                ui.sender.sortable("cancel");
                               
                            }
                        }
                    }

                } //if ($(this)[0].id == "sortable1")

                if ($(this)[0].id == "sortable4"+targetElement[0][0].id){
                    if ($(this).children('li').length > 1 ){
                        ui.sender.sortable("cancel");
                        ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                    }    
                }

            }, //receive ends here

            start:function(ev, ui) {
                
            },
            stop:function(ev, ui) {
               
            },
        });
      
        //----------------- Filter panel and everything within it section ends here -----------------
        
        perAreaBtnForAreaChart.on('click', function() {
                                  
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                                  
                for(var i = 0; i<divAndChartsArray.length; i++){
                                  
                    if(targetElement[0][0].id === divAndChartsArray[i].divID){
                        options.data = divAndChartsArray[i].optionsData;
                        options.keys = newtargetElementAndOptionsArray[i].options.keys;
                        options.showTable = false;
                        options.showComments = false;
                    }
                }
                                  
                acinfotech.percentageAreaChart(targetElement,options)
        })
        
         lineButtonForAreaChart.on('click', function() {
            
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            var newOptions = {
                           data: options.data,
                           dataForTable: options.dataForTable,
                           isDataDetailedForTable: options.isDataDetailedForTable,
                           keys: {
                               label: options.keys.label,
                               lines: options.keys.areas,
                           },
                           chartTitle:options.chartTitle,
                           xAxisLable:options.keys.label,
                           yAxisLable:"",
                           showTitle:options.showTitle,
                           colorSet: options.colorSet,
                           BGcolor:options.BGcolor,
                           series:options.series,
                           legend:options.legend,
                           lineStyle: options.lineStyle,
                           drillDownColumnName:options.drillDownColumnName,
                           showTable: false,
                           showComments: options.showComments,
                           comments: options.comments,
                           resizeButtonID: options.resizeButtonID
                       }
                       
                for(var i = 0; i<divAndChartsArray.length; i++){

                   if(targetElement[0][0].id === divAndChartsArray[i].divID){
                        newOptions.keys.lines = newtargetElementAndOptionsArray[i].options.keys.areas;
                        newtargetElementAndOptionsArray[i].options.keys = newOptions.keys;
                    }
                }

                acinfotech.lineChart(targetElement, newOptions)

        })

        filterButtonForAreaChart.on('click', function() {

            filterPanelForAreaChart.style("display","block");

            ismenuBtnOfAreaChartClicked = false;
            optsBtnPanelForAreaChart.style("display","none");

            stgPanDivForAreaChart.style("display","none");

            if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == true)){
                divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                svgPanelForAreaChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForAreaChart == true) && (showOrHideCommentsForAreaChart == false)){
                divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                svgPanelForAreaChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == false)){
                divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                svgPanelForAreaChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color", options.BGcolor);
            }

            resizedFuctionForAreaChart();

        })

        // Refreshing Chart and Table 
        refreshButtonForAreaChart.on('click', function() {

            //isFilterClicked = false
           d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData;
                    //options.keys.areas = newtargetElementAndOptionsArray[i].options.keys.areas;
                    if(newtargetElementAndOptionsArray[i].options.keys.areas == undefined){
                        options.keys.areas = newtargetElementAndOptionsArray[i].options.keys.lines;
                    }
                    else{
                        options.keys.areas = newtargetElementAndOptionsArray[i].options.keys.areas;
                    }
                }
            }
            acinfotech.areaChart(targetElement,options) 

        })

        // showing/hidding chart comments
        commentsBtnForAreaChart.on('click', function() {

            if(options.showComments == false){ 
                options.showComments = true;
            }
            else if(options.showComments == true){ 
                options.showComments = false;
            }

            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                    options.showTable = false;
                }
            }
            acinfotech.areaChart(targetElement,options)

        })

        // showing/hidding chart table
        tableButtonForAreaChart.on('click', function() {

            if(showOrHideTableForAreaChart == false){
                options.showTable = true;
                //showOrHideTableForPieChart = true
            }
            else if(showOrHideTableForAreaChart == true){
                //showOrHideTableForPieChart = false
                options.showTable = false;
            }

            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                    options.showComments = false;
                }
            }
            acinfotech.areaChart(targetElement,options)

        })

        
        settingBtnForAreaChart.on('click', function() {
                
            ismenuBtnOfAreaChartClicked = false; // Menu toggle button variable
            optsBtnPanelForAreaChart.style("display","none") // To hide options button panel

            iconButtonTooltipForAreaChart.style("display","none") // Removing options button ToolTip
            settingBtnForAreaChart.style("cursor","pointer")
            
            stgPanDivForAreaChart.style("display","block") // Showing settings panel

            svgPanelForAreaChart.style('width', 75 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor); // Decreasing chart panel
            divLegendPanelForAreaChart.style('width', 25 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor); // Decreasing chart panel

            resizedFuctionForAreaChart(); // Calling resize function()

        })

        // Converting normal json array to nested json array
        var dataArray = [];
        
        options.data.forEach(function(d, i) {
            var temp = {};
            for (i = 0; i < options.keys.areas.length; i++) {
                
                for (j = 0; j < Object.keys(d).length; j++) {
                     
                    if(options.keys.areas[i] === Object.keys(d)[j]){
                        temp[Object.keys(d)[j]] = d[Object.keys(d)[j]]
                    }
                 }
            }
            
            dataArray.push(temp)
        });
        
        downloadBtnForAreaChart.on('click', function() {
                                  
            ismenuBtnOfAreaChartClicked = false; // Changing menu button value to false
            optsBtnPanelForAreaChart.style("display","none") // Hiding option buttons panel
                                  
        })
        
        var finalArray = [];
        options.data.forEach(function(d, i) {
    
            var finalArrayTemp = {};
            finalArrayTemp[options.keys.label] = d[options.keys.label]
            finalArrayTemp["Data"] = dataArray[i];
            finalArray.push(finalArrayTemp)
        })
        
        var finalArrayNew = [];
        options.keys.areas.forEach(function(d, i) {
    
            var temp1 = {};
            temp1["line"] = options.keys.areas[i]
    
            finalArrayNew.push(temp1)
        })
        
        var finalNewNewArray = [];
        var dataArray1 = [];
        finalArrayNew.forEach(function(d, i) {
    
        var temp1 = {};
        temp1["line"] = options.keys.areas[i]
    
    
        for (j = 0; j < options.data.length; j++) {
       
            var tempTemp = {};
            tempTemp["label"] = options.data[j][options.keys.label];
            tempTemp["value"] = options.data[j][options.keys.areas[i]];

            dataArray1.push(tempTemp)
        }
     
        temp1["Data"] = dataArray1;
        dataArray1 = []
        finalNewNewArray.push(temp1)
    })

    var x = d3.scale.ordinal().domain(options.data.map(function(d,i) { return d[options.keys.label];})).rangePoints([0, width],0.65);

    var x1 = d3.scale.ordinal() .domain(options.data.map(function(d) { return d[options.keys.label]; })) .rangePoints([0, width], 0.65);

    var max = d3.max(finalArray, function(d) {
                    return d.Data[options.keys.areas[0]]
    });
    
    var ascAndDesArray = [];
    var maxArray = [];
    for (i = 0; i < options.keys.areas.length; i++) {
        var max = d3.max(finalArray, function(d) {
                    return +d.Data[options.keys.areas[i]]
        });
        var temp = {};
        temp['linesLabel'] = options.keys.areas[i];
        temp['linesMaxValue'] = max;
        ascAndDesArray.push(temp)
        maxArray.push(max)
    }

    var finallyMaxValue = d3.max(maxArray, function(d) { return +d; })

    ascAndDesArray.sort(function(x, y){
        return d3.descending(+x.linesMaxValue, +y.linesMaxValue);
    })

    var finalDesArray = [];

    for(var i = 0; i<ascAndDesArray.length; i++){
        for(var j = 0; j<finalNewNewArray.length; j++){
            if(ascAndDesArray[i].linesLabel.toLowerCase() === finalNewNewArray[j].line.toLowerCase()){
                finalDesArray.push(finalNewNewArray[j])
            }
        }
    }
    
    var y = d3.scale.linear() .domain([0, d3.max(maxArray, function(d) { return +d; })] ) .range([height, 0]);
        
    var color = d3.scale.category10();

    var xAxis = d3.svg.axis() .scale(x) .orient("bottom");

    var yAxis = d3.svg.axis() .scale(y) .ticks(5) .orient("left");
        
    var hasDecimalPoint = false;
    for(var i = 0; i < options.keys.areas.length; i++){
        for(var j = 0; j < options.data.length; j++){
            if(options.data[j][options.keys.areas[i]].toString().indexOf('.') > -1){ hasDecimalPoint = true; break; }
        }
    }
    if(hasDecimalPoint == false){ yAxis.tickFormat(d3.format(".2s")) }
        
    var svg = svgPanelForAreaChart.append("svg") .append("g") .attr("width", width + margin.left + margin.right) .attr("height", height + margin.top + margin.bottom)
            .attr("transform", "translate(" + margin.left + "," + margin.top + ")")
     let key=options.xAxisLable;
     let array=options.data.map(value => value[key]);
     let ArrayValue=[];
     var RotateValue;
     for(let i=0;i<array.length;i++){
         ArrayValue[i]=array[i].length;
     }
    const numberGreaterThanLimit = ArrayValue.filter((v) => v > 5);
    var xAxisLineAndMarginLabels = svg.append("g") .attr("class", "x axis") .attr("transform", "translate(0," + height + ")") .call(xAxis)

    // Add the X Axis margin labels
    .selectAll("text") .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') .attr("transform", function(d) 
    {
        if(numberGreaterThanLimit.length>0)
        {
            return "rotate(-45)"
        }
     else{
                return "rotate(0)" 
        }})
    .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
    .text(function(d,i) {
        if(d.length > 9)
            return d.substring(0,9)+'...';
        else
            return d;
    })

    svg.append("g") .attr("class", "y axis") .call(yAxis) .selectAll("text") .style('fill','#00001c') .style("font-family","Verdana,sans-serif")

    color.domain(options.keys.areas.map(function (d) { return d; }));

    var minX = d3.min(finalNewNewArray, function (kv) { return d3.min(kv.Data, function (d) { return +d.value; }) });
    var maxX = d3.max(finalNewNewArray, function (kv) { return d3.max(kv.Data, function (d) { return +d.value; }) });
    var minY = d3.min(finalNewNewArray, function (kv) { return d3.min(kv.Data, function (d) { return +d.value; }) });
    var maxY = d3.max(finalNewNewArray, function (kv) { return d3.max(kv.Data, function (d) { return +d.value; }) });

    x.domain([minX, maxX]);
    y.domain([minY, maxY]);

    // Creating line data
    var area = d3.svg.area() .interpolate(options.lineStyle) .x(function (d) { return x1(d['label']); }) .y0(height)
    .y1(function (d) { return y(+d["value"]); });

    // Creating lines
    var areas = svg.selectAll("area") .data(finalDesArray) .enter() .append("g") .append("path") .attr("class", "area")
    .attr("d", function (d,i) { return area(d.Data); }) .style("stroke-width",1.0) .style("stroke", function (d,i) { return colorscale(i); })
    .style("fill", function (d,i) { return colorscale(i); }) .style("stroke-linecap", "butt")
    //.style('fill-opacity',0.95)
    
    // Creating circles on lines
    // var colorCount = 0;
    // var circle1 = svg.selectAll("g.dot") .data(finalDesArray) .enter() .append("g")
    // .attr("class", "dot") .selectAll("circle") .data(function(d) { return d.Data; }) .enter() .append("circle") .attr("r", 2.5)
    // .attr("cx", function(d,i) {  return x1(d['label']); }) .attr("cy", function(d,i) {  return y(+d["value"]); })
    // .style("fill","#ffffff")
    // .style("stroke", function (d,i) {
    //     if(i == 0){
    //         colorCount++;
    //     }
    //     return colorscale(colorCount - 1);
    // })
    
        //------------------ creating legend ---------------
        
        var legendPanelSvgForAreaChart = divLegendPanelForAreaChart .append('svg')  .attr("class","").style("background-color", options.BGcolor).style('position',"absolute")
        .style('width', 100 + "%") .style('height', 100 + "%") .style("left",0 + "%").style("top",0 + "%")
        
        var legend = legendPanelSvgForAreaChart.append("g") .attr("class", "legend") .attr("height", "100%") .attr("width", "100%")
        .attr('transform', 'translate(0,20)') 
        
        //Create colour circles
        legend.selectAll('rect') .data(options.keys.areas) .enter() .append("rect") .attr("x", 5) .attr("y", function(d, i){ return i * 16;})
        .attr("width", 14) .attr("height", 14) .attr("rx",10) .attr("ry",10) .style("fill", function(d, i){ return colorscale(i);})
        .style("cursor","auto")
      
        //Create text next to circles
        legend.selectAll('text') .data(finalDesArray) .enter() .append("text") .attr("x", 25) .attr("y", function(d, i){ return i * 16 + 11.8;})
        .text(function(d,i) {
            if(d['line'].length > 10)
                return  d['line'].substring(0,10)+'...';
            else
                return  d['line'];;
        }) .style('font-size', '14px') .attr("fill","#00001c") .style("font-family","Verdana,sans-serif")

        // Aligning Legend (vertically)
        var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelForAreaChart[0][0].style.width) / 100)
        var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelForAreaChart[0][0].style.height) / 100)

        var legendRectSize = 11;
        var legendSpacing = 6;
            
        legend.attr('transform', function(d, i) {
            var eachRectHeight = legendRectSize + legendSpacing;
            var offset =  eachRectHeight * colorscale.domain().length / 2;
            var horz = 5;
            var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.areas.length))/2.0; // originally 2.0
                
            return 'translate(' + horz + ',' + vert + ')';
        })

    // Adding the text label for the X axis
    var xAxisVariable =  svg.append("text") .attr("transform", "translate(" + ((width/2) - 0) + " ," + (height+margin.bottom - 2) + ")")
    .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif") .style("font-weight","Bold") .style("font-size","12px") .text(options.xAxisLable) .style('fill','#00001c') 
    .style("text-transform","capitalize") .style("font-style","normal")

    legend.selectAll('rect').on('mouseover',function(d,i){
        d3.select(areas[0][i]).style('stroke-width',2.5)
        
        var lineLen = areas.node().getTotalLength();
        var dashLen = options.data.length;
        var ddLen = dashLen ;
        var darray = dashLen;
        while(ddLen < lineLen){
            darray+=","+dashLen+","+dashLen;
            ddLen+=dashLen;
        }

        d3.select(areas[0][i]).attr("stroke-linecap", "round").attr("stroke-dasharray", darray + ","+lineLen) .attr("stroke-dashoffset", lineLen)
        .transition().duration(8000).ease("linear").attr("stroke-dashoffset", 0)//.style('fill-opacity',0.78)
    })

    legend.selectAll('rect').on('mouseout',function(d,i){

        d3.select(areas[0][i]).style('stroke-width',1.0).transition().duration(0)
        d3.select(areas[0][i]).attr("stroke-dasharray", options.data.length + ","+ 0)  .attr("stroke-dashoffset", 0)
    })

    var tooltipForAreaChart = targetElement .append('div') .attr('class', 'tooltipPie') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
        .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
        .style("padding-right", "7px") .style("background", "#F8F8F8") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style("z-index",1000)
        .style("border", "1.0px") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","60px")
        tooltipForAreaChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'label').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "14px") .style("font-weight", "normal");
        tooltipForAreaChart.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
        tooltipForAreaChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");

    
        var tableDivForAreaChart = targetElement .append('div')
        .attr("class","scrollingDivForTable-Class tableDivForAreaChart" + targetElement[0][0].id) .style('background-color',"#ffffff") .style("position","absolute")
        .style("display","block") .style("overflow","hidden") //.style("border-right","1px solid #e2e2e2").style("border-bottom","1px solid #e2e2e2")

        $( '.tableDivForAreaChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });
            
        if(options.showTitle == true){
            tableDivForAreaChart.style("width", 100 + "%") .style("height", 40 + "%") .style("top",60 + "%") 
                       
        }
        else if(options.showTitle == false){
            tableDivForAreaChart.style("width", 100 + "%") .style("height", 40 + "%") .style("top",60 + "%") 
        }

        tableDivForAreaChart.html('<table class = "tableClassForAreaChart' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                  '<thead class = "theadClassForAreaChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForAreaChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                                  '<tbody class = "tBodyClassForAreaChart' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                  '</table>'
                                  )
        
        tableDivForAreaChart.select('table').attr("id",targetElement[0][0].id + "tableID")

        // Show or Hide Table scroll when mouseover on widget
        targetElement.on('mouseover',function(d){ tableDivForAreaChart.style("overflow","auto") })
        targetElement.on('mouseout',function(d){ tableDivForAreaChart.style("overflow","hidden") })
        
        var tableDataForAreaChart = [];
        if(options.dataForTable.length > 0){
            tableDataForAreaChart = options.dataForTable;
        }
        else {
            tableDataForAreaChart = options.data;
        }
        
        var thead = tableDivForAreaChart.select("thead").selectAll("th") .data(d3.keys(tableDataForAreaChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#fefdfd")//f6f6f6
        .style("position","relative").style("top","2px")
        
        var thead1 = d3.select(".thead1ClassForAreaChart" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tableDataForAreaChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#fefdfd")//f6f6f6
        .style("position","relative").style("top","2px")
        
        var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
        .attr("id", "ascendingIconIDForAreaChart") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
        
        var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
        .attr("id", "descendingIconIDForAreaChart") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
        
        var tr = tableDivForAreaChart.select("tbody").selectAll("tr") .data(tableDataForAreaChart).enter().append("tr")
        .attr("id", function(d,i) { return "slice" + i })
        
        // cells
        var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter() .append("td") .text(function(d) { return d})
        .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
        
        var $table = $('.tableClassForAreaChart' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
        
        d3.select(".theadClassForAreaChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
            d.forEach(function(dd,j){
                colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
            })
        })
        
        $(".thead1ClassForAreaChart" + targetElement[0][0].id).insertAfter('.tBodyClassForAreaChart' + targetElement[0][0].id)
        
        $(".thead1ClassForAreaChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForAreaChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
        
        tableDivForAreaChart.select(".thead1ClassForAreaChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
			d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
		})
        
        $('.tableDivForAreaChart' + targetElement[0][0].id).scroll(function () {
                                                                   
            $(".thead1ClassForAreaChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForAreaChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
                                                                   
        })
        
        var sortOrder = false;
        thead1.on("click",function(k,index){
                 
             sortOrder = !sortOrder;
             
             tableDivForAreaChart.select(".thead1ClassForAreaChart" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                                                
                if (sortOrder) {
                                  
                    if(i == index){
                        d3.select(this).select('svg').select('#descendingIconIDForAreaChart').style("visibility", "hidden")
                        d3.select(this).select('svg').select('#ascendingIconIDForAreaChart').style("visibility", "visible")
                    }
                    else {
                        d3.select(this).select('svg').select('#descendingIconIDForAreaChart').style("visibility", "visible")
                        d3.select(this).select('svg').select('#ascendingIconIDForAreaChart').style("visibility", "visible")
                    }
                }
                else{
                                  
                    if(i == index){
                        d3.select(this).select('svg').select('#descendingIconIDForAreaChart').style("visibility", "visible")
                        d3.select(this).select('svg').select('#ascendingIconIDForAreaChart').style("visibility", "hidden")
                    }
                    else {
                        d3.select(this).select('svg').select('#descendingIconIDForAreaChart').style("visibility", "visible")
                        d3.select(this).select('svg').select('#ascendingIconIDForAreaChart').style("visibility", "visible")
                    }
                }
            })
             
              var monthTruOrFalAryForAreaChart = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
              
              tr.sort(function(a, b) {
                      
                      if (sortOrder) {
                        var monthsArrayForAreaChart = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                      } else {
                        var monthsArrayForAreaChart = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                      }
                      
                      monthTruOrFalAryForAreaChart = []; gotMonthArray = [];
                      tableDataForAreaChart.forEach(function(d,i){
                            var da = d[k].toString().substring(0,3).toLowerCase()
                            if(monthsArrayForAreaChart.indexOf(da) >= 0){
                                monthTruOrFalAryForAreaChart.push(true)
                                gotMonthArray.push(da);
                            }
                            else {
                                monthTruOrFalAryForAreaChart.push(false)
                            }
                      })
                      
                      if(monthTruOrFalAryForAreaChart.indexOf(false) == -1){ // true
                      
                      monthArray = []; monthArrayCount = [];
                      gotMonthArray.forEach(function(dd,j){
                            var index1 = monthsArrayForAreaChart.indexOf(dd.substring(0,3))
                            if(monthArrayCount.indexOf(index1) >= 0){
                                index1 = 12 + index1;
                            }
                            monthArray.push(index1);
                            monthArrayCount.push(index1)
                      })
                      returnArray = []
                      monthArray.sort(function(aa, bb) {
                          returnArray.push(+aa - +bb)
                          return +aa - +bb;
                      })
                      
                      sortTableFunc()
                      return returnArray[ind++];
                      } //  if true (if jan feb if block)
                      else {
                      var data = +a[k];
                      
                      if(!isNaN(data)){
                      
                      if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                      else { return d3.descending(+a[k], +b[k]); }
                      }
                      else if(!isNaN(Date.parse(a[k]))){
                      
                      if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                      else { return new Date(b[k]) - new Date(a[k]) }
                      }
                      else {
                      
                      if (sortOrder) { return d3.ascending(a[k], b[k]); }
                      else { return d3.descending(a[k], b[k]); }
                      }
                      } // if not jan feb else block
                }); // tr

        })
        
        function sortTableFunc(){
            
            var table = tableDivForAreaChart.select('table');
            var rows = table.selectAll('tr').data(tableDataForAreaChart);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0) .style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr')
            .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500) .style('opacity', 1.0) .style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
        }
        
        // Main Table Styling
        tableDivForAreaChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
        .style("color","#00001c")
        .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4") //.style("box-shadow","10px 10px 50px #007aff").style("z-index",9999)
        tableDivForAreaChart.selectAll('td').style("height","25px") .style("border", "1px solid #ffffff") .style("font-size","12px").style("font-weight","Normal") .style("color","#00001c")

        //additionally 
        tableDivForAreaChart.selectAll('th').style('background-color',"#ffffff").style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
        tableDivForAreaChart.selectAll('td').style("border-style","none").style("color","#00001c")
        //tablePanelForPieChart.selectAll('td').style("height","25px") .style("border", "1px solid #fcfcfc") .style("font-size","12px").style("font-weight","Normal")

        //b1da9f
        tableDivForAreaChart.selectAll('table') . style("border-collapse","collapse")
        tableDivForAreaChart.selectAll('table tr:first-child th').style("border-top","0px")
        tableDivForAreaChart.selectAll('table tr:last-child td').style("border-bottom","0px")
        tableDivForAreaChart.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
        tableDivForAreaChart.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")

        if(showOrHideTableForAreaChart == false){
            tableDivForAreaChart.style("display","none")
        }
        else if(showOrHideTableForAreaChart == true){
            tableDivForAreaChart.style("display","block")
        }
        
        if(options.isDataDetailedForTable == false){
        
            var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
        
            // Adding underlines for selected drill-down column text
            var drillDownSectionsForAreaChart = tableDivForAreaChart.select('table').selectAll('th')
        
            var foundResult = [];
            for(var i = 0; i<drillDownSectionsForAreaChart[0].length; i++){
            
                for(var j = 0; j<drillDownColumnNamesArray.length; j++){
                    if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForAreaChart[0][i].__data__.toString().toLowerCase() ){
                        foundResult.push(i)
                    }
                }
            }
        
            var r = tableDivForAreaChart.select('table').selectAll('tr').selectAll('td')
            for(var i = 0; i<r.length; i++){
                for(var j = 0; j < foundResult.length; j++){
                    var row = r[i][foundResult[j]]
                    $(row).css("text-decoration", "underline")
                }
            }
        }
        
        resizedFuctionForAreaChart(); // calling the resize function for the first time.
        
        window.addEventListener('resize', function(event){ resizedFuctionForAreaChart() });

        $(function() {
           
         $("#" + targetElement[0][0].id).resizable({
           
         resize: function(event, ui) {
                    divWidth = ui.size.width;
                    divHeight = ui.size.height;
                    resizedFuctionForAreaChart();
                }
            });
         });

        function resizedFuctionForAreaChart()
        {

            if((svgPanelForAreaChart.node().getBoundingClientRect().width) && (svgPanelForAreaChart.node().getBoundingClientRect().height) > 0){
                
                if(showOrHideCommentsBtnForAreaChart == true){
                    perAreaBtnForAreaChart.style('margin-left', "2px")
                    lineButtonForAreaChart.style('margin-left', "2px")
                    filterButtonForAreaChart.style('margin-left', "2px")
                    refreshButtonForAreaChart.style('margin-left', "2px")
                    commentsBtnForAreaChart.style('margin-left', "2px")
                    menuButtonForAreaChart.style('right', '0')
                }
                else if(showOrHideCommentsBtnForAreaChart == false){
                    perAreaBtnForAreaChart.style('margin-left', "2px")
                    lineButtonForAreaChart.style('margin-left', "2px")
                    filterButtonForAreaChart.style('margin-left', "2px")
                    refreshButtonForAreaChart.style('margin-left', "2px")
                    //commentsBtnForAreaChart.style('right', '0')
                    commentsBtnForAreaChart.style('display','none')
                    menuButtonForAreaChart.style('right', '0')
                }

                optsBtnPanelForAreaChart.style('right', '0')

                stgPanCanBtnForAreaChart.style('right', '0') // setting panel cancel button.
            
                var margin1 = {top: 30 , right: 10, bottom: 80, left: 50}, //originally top: 42, left: 80
                width1 = (svgPanelForAreaChart.node().getBoundingClientRect().width) - margin1.left - margin1.right,
                height1 = (svgPanelForAreaChart.node().getBoundingClientRect().height) - margin1.top - margin1.bottom;
                // width1 = ($('#svgPanelIDForLineChart' + targetElement[0][0].id)[0].getBoundingClientRect().width) - margin1.left - margin1.right,
                // height1 = ($('#svgPanelIDForLineChart' + targetElement[0][0].id)[0].getBoundingClientRect().height) - margin1.top - margin1.bottom;

                x.domain(options.data.map(function(d,i) { return d[options.keys.label];})).rangePoints([0, width1],0.65);

                x1.domain(options.data.map(function(d) { return d[options.keys.label]; })) .rangePoints([0, width1], 0.65);

                var yy = d3.scale.linear().domain([0, d3.max(maxArray, function(d) { return +d; })] ).range([height1, 0]);

                yAxis.scale(yy) .orient("left");

                xAxis.scale(x) .orient("bottom")
                
                area.x(function (d) { return x(d['label']); }).y0(height1) .y1(function (d) { return yy(+d["value"]); });

                var svg1 = svg;
            
                svg1.select("svg") .attr("width", width1 + margin1.left + margin1.right) .attr("height", height1 + margin1.top + margin1.bottom)
                
                svg1.select(".y.axis") .call(yAxis)
    
                svg1.select(".x.axis") .attr("transform", "translate(0," + height1 + ")") .call(xAxis)
            
                // Add the X Axis margin labels
                .selectAll("text") .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') .attr("transform", function(d)
                {
                    if(numberGreaterThanLimit.length>0){return "rotate(-45)"}
                        else{
                        return "rotate(0)" }})
                .text(function(d,i) {
                    if(d.length > 9)
                        return d.substring(0,9)+'...';
                    else
                        return d;
                })
            
                xAxisVariable.attr("transform", "translate(" + ((width1/2) - 0) + " ," + (height1+margin1.bottom - 2) + ")")

                // svg1.selectAll("circle") .transition() .delay(function (d, i) { return i / options.data.length * 50; }) .duration(900).ease("bounce")
                // .attr("cx", function(d,i) {  return x1(d['label']); }) .attr("cy", function(d,i) {  return yy(+d["value"]); })
            
                svg1.selectAll(".area").attr("d", function (d,i) { return area(d.Data); })
                
                // Aligning Legend (vertically)
                var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelForAreaChart[0][0].style.width) / 100)
                var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelForAreaChart[0][0].style.height) / 100)

                var legendRectSize = 11;
                var legendSpacing = 6;
            
                legend.attr('transform', function(d, i) {
                var eachRectHeight = legendRectSize + legendSpacing;
                var offset =  eachRectHeight * colorscale.domain().length / 2;
                var horz = 5;
                var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.areas.length))/2.0; // originally 2.0
            
                    return 'translate(' + horz + ',' + vert + ')';
                })
                
                colWidth = []; 
				
                d3.select(".theadClassForAreaChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                        d.forEach(function(dd,j){
                            colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                        })
                })
                tableDivForAreaChart.select(".thead1ClassForAreaChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                        d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
                })

            } // checking svg panel width & height is greater than zero  
        }
    }, //areaChart

    // ************************************************** Bubble Chart  **************************************************
    bubbleChart: function(targetElement, options){

        isChartCalled++;

        var chartName = "BUBBLECHART";
        
        acinfotech.allCharts(targetElement,options,chartName);

        var newJson = [];
        options.data.forEach(function(d, i) {
            var temp = {};
            
            for(var i = 0; i < Object.keys(d).length; i++) {
                delete d['enabled'];
                temp[Object.keys(d)[i]] = d[Object.keys(d)[i]]
            }
            
            newJson.push(temp)
        });

        targetElement.style("min-width","350px").style("min-height","350px").style("background-color",options.BGcolor)

        var showOrHideTableForBubbleChart;
        var showOrHideCommentsForBubbleChart;
        var showOrHideCommentsBtnForBubbleChart = true;

        if((options.showTable == false) || (options.showTable == true)){
            showOrHideTableForBubbleChart = options.showTable    
        }
        else{
            showOrHideTableForBubbleChart = false;
        }

        // Show or Hide comments
        if (options.showComments == true || false) {
            showOrHideCommentsForBubbleChart = options.showComments;
        }
        else {
            showOrHideCommentsForBubbleChart = false;
        }
        
        if (options.comments.length == 0){ 
            showOrHideCommentsForBubbleChart = false;
            showOrHideCommentsBtnForBubbleChart = false;
        }

        if ((showOrHideTableForBubbleChart == true) && (showOrHideCommentsForBubbleChart == true)){
            showOrHideTableForBubbleChart = true;
            showOrHideCommentsForBubbleChart = false;
        }
        else if ((showOrHideTableForBubbleChart == false) && (showOrHideCommentsForBubbleChart == false)){
            showOrHideTableForBubbleChart = false;
            showOrHideCommentsForBubbleChart = false;
        }

        var chartTitlePanelForBubbleChart =  targetElement.append("div") .style("position","absolute").style("background-color",options.BGcolor) .style("text-indent","6px") .style("border", "none")
        
		var optionsBtnPanelForBubbleChart = targetElement.append('div').style('width',"25px").style('height',"230px").style('position','absolute')
        .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px")
        .style('right', '0') .style("min-width","25px") .style("border-style","none") 
        .style("border-left", "solid #fcfcfc  1px")
		
        var pieButtonForBubbleChart = optionsBtnPanelForBubbleChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','80px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var pieBtnImgVar = document.createElement("IMG");
        pieBtnImgVar.src = "images/pieIcon.png";
        pieBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        pieButtonForBubbleChart[0][0].appendChild(pieBtnImgVar)

        var donutButtonForBubbleChart = optionsBtnPanelForBubbleChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','105px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var dountBtnImgVar = document.createElement("IMG");
        dountBtnImgVar.src = "images/donutIcon.png";
        dountBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        donutButtonForBubbleChart[0][0].appendChild(dountBtnImgVar)

        var horButtonForBubbleChart = optionsBtnPanelForBubbleChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','130px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var horiBtnImgVar = document.createElement("IMG");
        horiBtnImgVar.src = "images/horizontalIcon.png";
        horiBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.9;")
        horButtonForBubbleChart[0][0].appendChild(horiBtnImgVar)

        var colButtonForBubbleChart = optionsBtnPanelForBubbleChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','155px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var colBtnImgVar = document.createElement("IMG");
        colBtnImgVar.src = "images/columnIcon.png";
        colBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.9;")
        colButtonForBubbleChart[0][0].appendChild(colBtnImgVar)

        var refreshButtonForBubbleChart = optionsBtnPanelForBubbleChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','180px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var refreshBtnImgVar = document.createElement("IMG");
        refreshBtnImgVar.src = "images/refreshIcon.png";
        refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        refreshButtonForBubbleChart[0][0].appendChild(refreshBtnImgVar)

        var commentsBtnForBubbleChart = optionsBtnPanelForBubbleChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','205px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var commentsBtnImgVariable = document.createElement("IMG");
        if(options.showComments == false){
            commentsBtnImgVariable.src = "images/showCommentsIcon.png";
        }
        else if(options.showComments == true){
            commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
        }
        commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        commentsBtnForBubbleChart[0][0].appendChild(commentsBtnImgVariable)

        var menuBtnForBubbleChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','1px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var menuBtnImgVar = document.createElement("IMG");
        menuBtnImgVar.src = "images/menuIcon.png";
        menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
        menuBtnForBubbleChart[0][0].appendChild(menuBtnImgVar)

        if(showOrHideCommentsBtnForBubbleChart == true){
            pieButtonForBubbleChart.style('margin-left', "2px")
            donutButtonForBubbleChart.style('margin-left', "2px")
            horButtonForBubbleChart.style('margin-left', "2px")
            colButtonForBubbleChart.style('margin-left', "2px")
            refreshButtonForBubbleChart.style('margin-left', "2px")
            commentsBtnForBubbleChart.style('margin-left', "2px")
            menuBtnForBubbleChart.style('right', '0')
        }
        else if(showOrHideCommentsBtnForBubbleChart == false){
            pieButtonForBubbleChart.style('margin-left', "2px")
            donutButtonForBubbleChart.style('margin-left', "2px")
            horButtonForBubbleChart.style('margin-left', "2px")
            colButtonForBubbleChart.style('margin-left', "2px")
            refreshButtonForBubbleChart.style('margin-left', "2px")
            //commentsBtnForBubbleChart.style('right', '0')
            commentsBtnForBubbleChart.style('display','none')
            menuBtnForBubbleChart.style('right', '0')
        }

        var ismenuBtnOfBubbleChartClicked = false;
        menuBtnForBubbleChart.on('click', function() {

            stgPanDivForBubbleChart.style('display',"none")

            if(ismenuBtnOfBubbleChartClicked == false){
                ismenuBtnOfBubbleChartClicked = true;
                optionsBtnPanelForBubbleChart.style("display","block")

                if ((showOrHideTableForBubbleChart == false) && (showOrHideCommentsForBubbleChart == true)){
                    svgLegendPanelBubbleChart.style('width', 35 + "%") .style('height', 70 + "%") .style("left",65 + "%").style("top",8 + "%") .style('position',"absolute").style("background-color",options.BGcolor)
                    
                    svgPanelForBubbleChart.style('width', 65 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                    .style("position","absolute").style("background-color",options.BGcolor);
                }
                else if ((showOrHideTableForBubbleChart == true) && (showOrHideCommentsForBubbleChart == false)){
                    svgLegendPanelBubbleChart.style('width', 35 + "%") .style('height', 52 + "%") .style("left",65 + "%").style("top",8 + "%") .style('position',"absolute") .style("background-color",options.BGcolor)      
                    
                    svgPanelForBubbleChart.style('width', 65 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute").style("background-color",options.BGcolor);
                }
                else if ((showOrHideTableForBubbleChart == false) && (showOrHideCommentsForBubbleChart == false)){
                    svgLegendPanelBubbleChart.style('width', 35 + "%") .style('height', 85 + "%") .style("left",65 + "%").style("top",8 + "%") .style('position',"absolute")  .style("background-color",options.BGcolor)     
                    
                    svgPanelForBubbleChart.style('width', 65 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute").style("background-color",options.BGcolor);
                }

            }
            else if(ismenuBtnOfBubbleChartClicked == true){
                ismenuBtnOfBubbleChartClicked = false
                optionsBtnPanelForBubbleChart.style("display","none")

                if ((showOrHideTableForBubbleChart == false) && (showOrHideCommentsForBubbleChart == true)){
                    svgLegendPanelBubbleChart.style('width', 35 + "%") .style('height', 70 + "%") .style("left",65 + "%").style("top",8 + "%") .style('position',"absolute").style("background-color",options.BGcolor)
                    
                    svgPanelForBubbleChart.style('width', 65 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                    .style("position","absolute").style("background-color",options.BGcolor);
                }
                else if ((showOrHideTableForBubbleChart == true) && (showOrHideCommentsForBubbleChart == false)){
                    svgLegendPanelBubbleChart.style('width', 35 + "%") .style('height', 52 + "%") .style("left",65 + "%").style("top",8 + "%") .style('position',"absolute").style("background-color",options.BGcolor)       
                    
                    svgPanelForBubbleChart.style('width', 65 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute").style("background-color",options.BGcolor);
                }
                else if ((showOrHideTableForBubbleChart == false) && (showOrHideCommentsForBubbleChart == false)){
                    svgLegendPanelBubbleChart.style('width', 35 + "%") .style('height', 85 + "%") .style("left",65 + "%").style("top",8 + "%") .style('position',"absolute") .style("background-color",options.BGcolor)      
                    
                    svgPanelForBubbleChart.style('width', 65 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute").style("background-color",options.BGcolor);
                }
            }

            resizedFuctionForBubbleChart();
        })

        var tableButtonForBubbleChart = optionsBtnPanelForBubbleChart.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top','1px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
        var tableBtnImgVar = document.createElement("IMG");
        if(showOrHideTableForBubbleChart == false){
            tableBtnImgVar.src = "images/showTableIcon.png";
            tableButtonForBubbleChart.attr("class","showTableClassForChartTable")
        }
        else if(showOrHideTableForBubbleChart == true){
            tableBtnImgVar.src = "images/cancelTableIcon.png";
            tableButtonForBubbleChart.attr("class","hideTableClassForChartTable")
        }
        tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
        tableButtonForBubbleChart[0][0].appendChild(tableBtnImgVar)

        var settingBtnForBubbleChart = optionsBtnPanelForBubbleChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 28 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        var settingBtnImgVar = document.createElement("IMG");
        settingBtnImgVar.src = "images/settingsIcon.png";
        settingBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.82;")
        settingBtnForBubbleChart[0][0].appendChild(settingBtnImgVar)
        
        var downloadBtnForBubbleChart = optionsBtnPanelForBubbleChart.append("div").attr("id","downloadBtnForBubbleChart-ID-" + targetElement[0][0].id).style("width","20px").style("height","20px")
        .style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff").style('margin-left','2px').style('top', 54 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        
        acinfotech.downloadFunctionality("downloadBtnForBubbleChart-ID-" + targetElement[0][0].id,targetElement)
        
        var svgPanelForBubbleChart = targetElement .append('svg') .attr("id","svgPanelIDForBubbleChart" + targetElement[0][0].id)
        .style("background-color",options.BGcolor) .style("position","absolute")
        
        var commentsPanelDivForBubbleChart = targetElement.append("div") .attr("class","commentsPanelClassForBubbleChart") 
        .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
		.style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
        .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)

        commentsPanelDivForBubbleChart.on('click',function(d){
            $('.commentsClassForBubbleChart' + targetElement[0][0].id).focus()
        })

        if(options.showTitle == true){
            
            chartTitlePanelForBubbleChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 8 + "%"; })
            .html('<div  style="width: 100%; height:0%; background-color:#ffffff; position: absolute; top:10.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>') //color 325922

            if ((showOrHideTableForBubbleChart == false) && (showOrHideCommentsForBubbleChart == true)){

                var commentsForBubbleChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify').attr('class','commentsClassForBubbleChart' + targetElement[0][0].id)

                   svgPanelForBubbleChart.attr('width', 65 + "%") .attr('height', 70 + "%") .style("top",8 + "%").style("background-color",options.BGcolor) .append('g')
                   commentsPanelDivForBubbleChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForBubbleChart[0].outerHTML.toString())

            }
            else if ((showOrHideTableForBubbleChart == true) && (showOrHideCommentsForBubbleChart == false)){

                    svgPanelForBubbleChart.attr('width', 65 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .style("background-color",options.BGcolor).append('g')
                    commentsPanelDivForBubbleChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForBubbleChart == false) && (showOrHideCommentsForBubbleChart == false)){
                    svgPanelForBubbleChart.attr('width', 65 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .style("background-color",options.BGcolor).append('g')
                    commentsPanelDivForBubbleChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            
        }
        else if(options.showTitle == false){

            chartTitlePanelForBubbleChart.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });

            if ((showOrHideTableForBubbleChart == false) && (showOrHideCommentsForBubbleChart == true)){

                var commentsForBubbleChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify')

                   svgPanelForBubbleChart.attr('width', 65 + "%") .attr('height', 70 + "%") .style("top",8 + "%").style("background-color",options.BGcolor) .append('g')
                   commentsPanelDivForBubbleChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForBubbleChart[0].outerHTML.toString())

            }
            else if ((showOrHideTableForBubbleChart == true) && (showOrHideCommentsForBubbleChart == false)){

                    svgPanelForBubbleChart.attr('width', 65 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .style("background-color",options.BGcolor).append('g')
                    commentsPanelDivForBubbleChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForBubbleChart == false) && (showOrHideCommentsForBubbleChart == false)){
                    svgPanelForBubbleChart.attr('width', 65 + "%") .attr('height', 85 + "%") .style("top",8 + "%").style("background-color",options.BGcolor) .append('g')
                    commentsPanelDivForBubbleChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
        }
        
        
         var svgLegendPanelBubbleChart = targetElement .append('div')  .attr("class","svgLegendPanelClassForBubbleChart").style("background-color",options.BGcolor).style('position',"absolute")
         .style('width', 30 + "%") .style('height', 92 + "%") .style("left",70 + "%").style("top",8 + "%")

            if ((showOrHideTableForBubbleChart == false) && (showOrHideCommentsForBubbleChart == true)){

                svgLegendPanelBubbleChart.style('width', 35 + "%") .style('height', 70 + "%") .style("left",65 + "%").style("top",8 + "%").style("background-color",options.BGcolor) 
            }
            else if ((showOrHideTableForBubbleChart == true) && (showOrHideCommentsForBubbleChart == false)){

                svgLegendPanelBubbleChart.style('width', 35 + "%") .style('height', 52 + "%") .style("left",65 + "%").style("top",8 + "%").style("background-color",options.BGcolor)        
            }
            else if ((showOrHideTableForBubbleChart == false) && (showOrHideCommentsForBubbleChart == false)){
               
                svgLegendPanelBubbleChart.style('width', 35 + "%") .style('height', 85 + "%") .style("left",65 + "%").style("top",8 + "%").style("background-color",options.BGcolor) 
            }
        
        var colors;
        // checking color set for bubbles and legend dots
        if(options.colorSet === undefined){
            options.colorSet = "one"
            colors = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "one"){
            options.colorSet = "one"
            colors = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            options.colorSet = "two"
             colors = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            options.colorSet = "three"
            colors = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        }
        else
        {
            options.colorSet = "one"
            colors = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }

        /*------------------ Settings panel DIV and everything within it section begins here ------------------*/
        
        var stgPanDivForBubbleChart = targetElement.append('div').style('width',"100%").style('height',"40%").attr("class","stgPanDivForBubbleChart" + targetElement[0][0].id)
        .style('position','absolute') .style('margin-left', "0px") .style('border-top',"1px solid #f0f0f0") .style('border-bottom',"1px solid #e5e5e5")
        .style("background-color",'#fcfcfc') .style("z-index",90)  .style("display","none") .style('top', 60.0 + "%") .style('height',40 + "%")

        $( '.stgPanDivForBubbleChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        var settingPanelTitle = stgPanDivForBubbleChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','10px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; color:#00001c;">'+ "Settings" +'</div>')

        var stgPanDivForLineChangeColorTitle = stgPanDivForBubbleChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Select color set " +'</div>')

        var stgPanCanBtnForBubbleChart = stgPanDivForBubbleChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
        .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
        .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.9; background-color:#fcfcff")
        stgPanCanBtnForBubbleChart[0][0].appendChild(cancelBtnImgVar)

        stgPanCanBtnForBubbleChart.on('click', function() {
            stgPanDivForBubbleChart.style("display","none") // Hiding setting panel

            if ((showOrHideTableForBubbleChart == false) && (showOrHideCommentsForBubbleChart == true)){
                    svgLegendPanelBubbleChart.style('width', 30 + "%") .style('height', 70 + "%") .style("left",70 + "%").style("top",8 + "%") .style('position',"absolute").style("background-color",options.BGcolor)
                    
                    svgPanelForBubbleChart.style('width', 70 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                    .style("position","absolute").style("background-color",options.BGcolor);
                }
                else if ((showOrHideTableForBubbleChart == true) && (showOrHideCommentsForBubbleChart == false)){
                    svgLegendPanelBubbleChart.style('width', 30 + "%") .style('height', 52 + "%") .style("left",70 + "%").style("top",8 + "%") .style('position',"absolute").style("background-color",options.BGcolor)       
                    
                    svgPanelForBubbleChart.style('width', 70 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute").style("background-color",options.BGcolor);
                }
                else if ((showOrHideTableForBubbleChart == false) && (showOrHideCommentsForBubbleChart == false)){
                    svgLegendPanelBubbleChart.style('width', 30 + "%") .style('height', 85 + "%") .style("left",70 + "%").style("top",8 + "%") .style('position',"absolute").style("background-color",options.BGcolor)       
                    
                    svgPanelForBubbleChart.style('width', 70 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute").style("background-color",options.BGcolor);
                }

            resizedFuctionForBubbleChart();
        })

        var formForChangeSettingsPanel = stgPanDivForBubbleChart.append("form");
        formForChangeSettingsPanel.style("background-color","#fcfcfc").style("margin-top","67px").style("font-family","Verdana,sans-serif").style("font-size","12px")
        .style("position","absolute").attr("id","formForChangeColorSettingsPanel" + targetElement[0][0].id).style("font-weight","Bold").style("width","180px")
        .style("height","58px").style("padding","0px").style("border-radius","0px") .style("margin-left","10px")

        var svgPanelForCrSetOne = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px") .style("margin-top","1px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetOne = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        var colorSetOneRange = d3.range(12);

        var colorSetOneDots = svgPanelForCrSetOne.append("g")
        colorSetOneDots.selectAll('rect') .data(colorSetOneRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("fill", function(d,i){return colorSetOne(i)})
        .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetOne(i);  })
        .style("cursor","auto") .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        var svgPanelForCrSetTwo = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px") .style("margin-top","20px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetTwo = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        var colorSetTwoRange = d3.range(12);

        var colorSetTwoDots = svgPanelForCrSetTwo.append("g")
        colorSetTwoDots.selectAll('rect') .data(colorSetTwoRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto")
        .style("fill", function(d,i){return colorSetTwo(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
        .style("stroke",function(d,i){  return colorSetTwo(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        var svgPanelForCrSetThree = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px").style("height","18px").style("margin-top","39px").style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetThree = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        var colorSetThreeRange = d3.range(12);

        var colorSetThreeDots = svgPanelForCrSetThree.append("g")
        colorSetThreeDots.selectAll('rect') .data(colorSetThreeRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto")
        .style("fill", function(d,i){return colorSetThree(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
        .style("stroke",function(d,i){  return colorSetThree(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        if(options.colorSet.toString().toLowerCase() === "one"){
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"1px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"1px solid #808080")
        }
        else 
        {
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }

        svgPanelForCrSetOne.on('click',function(d){
            options.colorSet = "one"
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")

            colors = "";
            colors = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);

            node.select('circle').style("fill", function(d,i) { return colors(i); })
            legendGroup.style("fill", function(d, i){ return colors(i);})
        
        })
        svgPanelForCrSetTwo.on('click',function(d){
            options.colorSet = "two"
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"1px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")

            colors = "";
            colors = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);

            node.select('circle').style("fill", function(d,i) { return colors(i); })
            legendGroup.style("fill", function(d, i){ return colors(i);})
        })
        svgPanelForCrSetThree.on('click',function(d){
            options.colorSet = "three"
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"1px solid #808080")

            colors = "";
            colors = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);

            node.select('circle').style("fill", function(d,i) { return colors(i); })
            legendGroup.style("fill", function(d, i){ return colors(i);})
        })

        
        /*------------------ Settings panel DIV and everything inside it section ends here ------------------*/

        // Calling Column-Chart  (changing chart)
        colButtonForBubbleChart.on('click', function() {

            options.showTable = false;
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            var newOptions = {
                           data: options.data,
                           dataForTable: options.dataForTable,
                           isDataDetailedForTable: options.isDataDetailedForTable,
                           keys: {
                               label: options.keys.label,
                               value: options.keys.value
                           },
                           chartTitle:options.chartTitle,
                           xAxisLable:options.keys.label,
                           yAxisLable:options.keys.value,
                           showTitle:options.showTitle,
                           colorSet: options.colorSet,
                           BGcolor:options.BGcolor,
                           series:options.series,
                           legend:options.legend,
                           drillDownColumnName:options.drillDownColumnName,
                           showTable:options.showTable,
                           showComments: options.showComments,
                           comments: options.comments,
                           resizeButtonID: options.resizeButtonID
                       }
                acinfotech.columnChart(targetElement, newOptions)
        })

        // Calling Donut-Chart  (changing chart)
        donutButtonForBubbleChart.on('click', function() {
            options.showTable = false;
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();

            var newOptions = {
                           data: options.data,
                           dataForTable: options.dataForTable,
                           isDataDetailedForTable: options.isDataDetailedForTable,
                           keys: {
                               label: options.keys.label,
                               value: options.keys.value
                           },
                           chartTitle:options.chartTitle,
                           showTitle: true,
                           showLegend: true,
                           legendSide: "right",
                           colorSet: options.colorSet,
                           BGcolor:options.BGcolor,
                           gradient: "none",
                           series:options.series,
                           legend:options.legend,
                           drillDownColumnName:options.drillDownColumnName,
                           showTable: options.showTable,
                           showComments: options.showComments,
                           comments: options.comments,
                           resizeButtonID: options.resizeButtonID
                        }

            acinfotech.donutChart(targetElement, newOptions)
        })

        // Calling Horizontal-Chart  (changing chart)
        horButtonForBubbleChart.on('click', function() {
            options.showTable = false;
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            var newOptions = {
                   data: options.data,
                   dataForTable: options.dataForTable,
                   isDataDetailedForTable: options.isDataDetailedForTable,
                   keys: {
                       label: options.keys.label,
                       value: options.keys.value
                   },
                   chartTitle:options.chartTitle,
                   xAxisLable:options.keys.value,
                   yAxisLable:options.keys.label,
                   showTitle:options.showTitle,
                   colorSet: options.colorSet,
                   BGcolor:options.BGcolor,
                   series:options.series,
                   legend:options.legend,
                   drillDownColumnName:options.drillDownColumnName,
                   showTable: options.showTable,
                   showComments: options.showComments,
                   comments: options.comments,
                   resizeButtonID: options.resizeButtonID
               }
            acinfotech.horizontalChart(targetElement, newOptions) 
        })

        // Calling Pie-Chart  (changing chart)
        pieButtonForBubbleChart.on('click', function() {
            options.showTable = false;
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();

            var newOptions = {
                   data: options.data,
                   dataForTable: options.dataForTable,
                   isDataDetailedForTable: options.isDataDetailedForTable,
                   keys: {
                       label: options.keys.label,
                       value: options.keys.value
                   },
                   chartTitle:options.chartTitle,
                   showTitle: true,
                   showLegend: true,
                   legendSide: "right",
                   colorSet: options.colorSet,
                   BGcolor:options.BGcolor,
                   gradient: "none",
                   series:options.series,
                   legend:options.legend,
                   drillDownColumnName:options.drillDownColumnName,
                   showTable: options.showTable,
                   showComments: options.showComments,
                   comments: options.comments,
                   resizeButtonID: options.resizeButtonID
            }

            acinfotech.pieChart(targetElement, newOptions)
        })

        // Refreshing Chart and Table
        refreshButtonForBubbleChart.on('click', function() {

            //isFilterClicked = false
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                }
            }
            acinfotech.bubbleChart(targetElement,options) 
        })

        commentsBtnForBubbleChart.on('click', function() {

            if(options.showComments == false){ 
                options.showComments = true;
            }
            else if(options.showComments == true){ 
                options.showComments = false;
            }

            //isFilterClicked = false
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                    options.showTable = false;
                }
            }
            acinfotech.bubbleChart(targetElement,options) 
        })

        // showing/hidding chart table
        tableButtonForBubbleChart.on('click', function() {

            if(showOrHideTableForBubbleChart == false){
                options.showTable = true;
            }
            else if(showOrHideTableForBubbleChart == true){
                options.showTable = false;
            }

            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                    options.showComments = false;
                }
            }
            acinfotech.bubbleChart(targetElement,options)
        })

        
        settingBtnForBubbleChart.on('click', function() {
                
            ismenuBtnOfBubbleChartClicked = false; // Menu toggle button variable
            optionsBtnPanelForBubbleChart.style("display","none") // To hide options button panel

            iconButtonTooltipForBubbleChart.style("display","none") // Removing options button ToolTip
            settingBtnForBubbleChart.style("cursor","pointer")
            
            stgPanDivForBubbleChart.style("display","block") // Showing settings panel

            svgPanelForBubbleChart.style('width', 70 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color",options.BGcolor); // Decreasing chart panel
            svgLegendPanelBubbleChart.style('width', 30 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color",options.BGcolor); // Decreasing chart panel

            resizedFuctionForBubbleChart(); // Calling resize function()

        })
        
        downloadBtnForBubbleChart.on('click', function() {
                                  
            ismenuBtnOfBubbleChartClicked = false; // Changing menu button value to false
            optionsBtnPanelForBubbleChart.style("display","none") // Hiding option buttons panel
                                  
        })
        
        // Creating ToolTip for options button.
        var iconButtonTooltipForBubbleChart = targetElement.append('div').style('width','240px').attr("id","too") .style('height',"25px")
        .style('position','absolute') .style("background-color",'#404040 ') .style("z-index",999).style("border", "0.0px") 
        .style("border-color", "#278eff") .style("border-style", "solid") .style("border-radius","0px") .style("box-shadow", "1px 1px 2px #d8d8d8")
        .style("display","none").attr("border", 0.0)

        colButtonForBubbleChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var columnChartButtonTooltipText = "Switch to Column Chart";
            
            iconButtonTooltipForBubbleChart.style("width","147px").style("margin-left", (m[0] - 157) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForBubbleChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ columnChartButtonTooltipText +'</div>')

        })
        colButtonForBubbleChart.on('mouseout', function(d,i) {
            iconButtonTooltipForBubbleChart.style("display","none")
        })

        donutButtonForBubbleChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var donutChartButtonTooltipText = "Switch to Donut Chart";
            
            iconButtonTooltipForBubbleChart.style("width","137px").style("margin-left", (m[0] - 147) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForBubbleChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ donutChartButtonTooltipText +'</div>')

        })
        donutButtonForBubbleChart.on('mouseout', function(d,i) {
            iconButtonTooltipForBubbleChart.style("display","none")
        })

        horButtonForBubbleChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var horiChartButtonTooltipText = "Switch to Horizontal Chart";
            
            iconButtonTooltipForBubbleChart.style("width","157px").style("margin-left", (m[0] - 167) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForBubbleChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ horiChartButtonTooltipText +'</div>')

        })
        horButtonForBubbleChart.on('mouseout', function(d,i) {
            iconButtonTooltipForBubbleChart.style("display","none")
        })

        pieButtonForBubbleChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var pieChartButtonTooltipText = "Switch to Pie Chart";
            
            iconButtonTooltipForBubbleChart.style("width","122px").style("margin-left", (m[0] - 132) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForBubbleChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ pieChartButtonTooltipText +'</div>')

        })
        pieButtonForBubbleChart.on('mouseout', function(d,i) {
            iconButtonTooltipForBubbleChart.style("display","none")
        })

        refreshButtonForBubbleChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var refreshChartButtonTooltipText = "Refresh";
            
            iconButtonTooltipForBubbleChart.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForBubbleChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ refreshChartButtonTooltipText +'</div>')

        })
        refreshButtonForBubbleChart.on('mouseout', function(d,i) {
            iconButtonTooltipForBubbleChart.style("display","none")
        })

        commentsBtnForBubbleChart.on('mousemove', function(d,i) {
            commentsPanelDivForBubbleChart.style('background-color','#fafafa')
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                if(options.showComments == false){
                    var commentButtonTooltipText = "Show Comments";
                }
                else if(options.showComments == true){
                    var commentButtonTooltipText = "Hide Comments";
                }
            
            iconButtonTooltipForBubbleChart.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForBubbleChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ commentButtonTooltipText +'</div>')
        })
        commentsBtnForBubbleChart.on('mouseout', function(d,i) {
            commentsPanelDivForBubbleChart.style('background-color','#ffffff')
            iconButtonTooltipForBubbleChart.style("display","none")
        })

        tableButtonForBubbleChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            if(showOrHideTableForBubbleChart == false){
                var tableBtnTooltipText = "Show Table";
            }
            else if(showOrHideTableForBubbleChart == true){
                var tableBtnTooltipText = "Hide Table";
            }
            
            
            iconButtonTooltipForBubbleChart.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForBubbleChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ tableBtnTooltipText +'</div>')

        })
        tableButtonForBubbleChart.on('mouseout', function(d,i) {
            iconButtonTooltipForBubbleChart.style("display","none")
        })
        
        settingBtnForBubbleChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var settingTooltipText = "Settings";
            
            iconButtonTooltipForBubbleChart.style("width","67px").style("margin-left", (m[0] - 77) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForBubbleChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ settingTooltipText +'</div>')
        })
        settingBtnForBubbleChart.on('mouseout', function(d,i) {
            iconButtonTooltipForBubbleChart.style("display","none")
        })
        
        downloadBtnForBubbleChart.on('mousemove', function(d,i) {
          var root = targetElement
          var m = d3.mouse(root.node());
          m[0] += 0
          m[1] += 0
          var downloadButtonTooltipText = "Download";
          
          iconButtonTooltipForBubbleChart.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
          iconButtonTooltipForBubbleChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
        })
        downloadBtnForBubbleChart.on('mouseout', function(d,i) {
          iconButtonTooltipForBubbleChart.style("display","none")
        })
        
         menuBtnForBubbleChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var menuButtonTooltipText = "Menu";
            
            iconButtonTooltipForBubbleChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForBubbleChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ menuButtonTooltipText +'</div>')
        })
        menuBtnForBubbleChart.on('mouseout', function(d,i) {
            iconButtonTooltipForBubbleChart.style("display","none")
        })

        //-------- creating tooltip --------

        var tooltipForBubbleChart = targetElement .append('div') .attr('class', 'tooltipbubble') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
        .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
        .style("padding-right", "7px") .style("background", "#F8F8F8") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style("z-index",1000)
        .style("border", "1.0px") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","80px")
        tooltipForBubbleChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'label').style("color","#000000") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "12px") .style("font-weight", "Bold");
        tooltipForBubbleChart.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
        tooltipForBubbleChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#000000") .style("text-transform","capitalize").style("padding","1px").style("font-size", "12px").style("font-weight", "Bold");

        var diameterWidth = document.getElementById("svgPanelIDForBubbleChart" + targetElement[0][0].id).getBoundingClientRect().width;//svgPanelForBubbleChart[0][0].clientWidth;
        var diameterHeight = document.getElementById("svgPanelIDForBubbleChart" + targetElement[0][0].id).getBoundingClientRect().height;//svgPanelForBubbleChart[0][0].clientHeight;

        var bubbleLayout = d3.layout.pack()
        .sort(null) // HERE
        .size([diameterWidth,diameterHeight])
        .padding(1.5);
        
        var bubbleChartSVG = svgPanelForBubbleChart.append("svg")
        .attr("width" , diameterWidth)
        .attr("height", diameterHeight)
        
        var filteredArray = [];
        newJson.forEach(function(d,i){ 
            var temp = {};
            temp[options.keys.label] = d[options.keys.label]
            temp["value"] = d[options.keys.value]
            filteredArray.push(temp)
        })
        
        var selection = bubbleChartSVG.selectAll("g.node")
        .data(bubbleLayout.nodes({children: filteredArray}).filter(function(d) { return !d.children; }) );

        var node = selection.enter().append("g").attr("class", "node")
        .attr("transform", function(d) { return "translate(" + d.x + ", " + d.y + ")"; }).filter( function(d,i){if(d.value == 0){ d.value = 0.000000000000001;
        d3.select(selection[0][i]).style("display","none"); }; return d.value > 0; }) //HERE
        
        /*var bubbles = node.append("circle") .transition()
        .delay(function (d, i) { return i / bubbleLayout.nodes({children: filteredArray}).filter(function(d) { return !d.children; }).length * 300; }) .duration(10)
        .attr("r", function(d) { return d.r; }) .style("fill", function(d,i) { return colors(i) }) .style('fill-opacity',0.885)*/
		
		var bubbles = node.append("circle").style("fill", function(d,i) { return colors(i) })
		.attr("r", function(d) { return 0; }).transition()
        .delay(400).duration(800).attr("r", function(d) { return d.r; })
        
        /*node.append("text") .transition()
        .delay(function (d, i) { return i / bubbleLayout.nodes({children: filteredArray}).filter(function(d) { return !d.children; }).length * 300; }) .duration(10)
        .attr("dy", ".3em") .style("text-anchor", "middle") .style("font-size", "12px") .style("fill",function(d,i){ return "#f0f0f0" })
        .style("font-weight","Normal") .text(function(d) {return d[options.keys.label].substring(0, d.r / 3.5); }) .style("font-family", "Verdana,sans-serif")*/
		
		node.append("text").attr("dy", ".3em").style("text-anchor", "middle").style("font-size", "12px") .style("fill",function(d,i){ return "#f0f0f0" })
        .style("font-weight","Normal") .text(function(d) {return d[options.keys.label].substring(0, d.r / 3.5); }) .style("font-family", "Verdana,sans-serif")
		.style("display","none").transition().delay(1400).duration(800).style("display","none").attr("class","series_value").style("display",options.series)
		
        node.on('mousemove', function (d,i){
                    
            var root = targetElement
            var m = d3.mouse(root.node());
            m[0] += 0
            m[1] += 0
            
            var valueForBubbleChartToolTip;
            if(options.data[i][options.keys.value].toString().indexOf('.') === -1)
            {
                valueForBubbleChartToolTip = options.data[i][options.keys.value].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            else{
                    
                valueForBubbleChartToolTip = options.data[i][options.keys.value];
            }

            tooltipForBubbleChart.select('.label').html(options.keys.label + " : " + d[options.keys.label])
            //tooltipForBubbleChart.select('.count').html(options.keys.value + " : " + options.data[i][options.keys.value].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
            tooltipForBubbleChart.select('.count').html(options.keys.value + " : " + valueForBubbleChartToolTip)
            tooltipForBubbleChart.style('visibility', 'visible')
            tooltipForBubbleChart.select('hr').style("background-color", function(d){ return colors(i) })
            tooltipForBubbleChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-20) + "px").style("display","block")

        })
        .on('mouseout', function(){ tooltipForBubbleChart.style("display","none") })

        var columnNames = d3.keys(options.data[0])
        var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
        
        for(var i = 0; i < columnNames.length ; i++){
            for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                    for(var k = 0; k < node[0].length; k++){
                        d3.select(node[0][k]).attr('data-drilldownkey', function(d,index){
                            return JSON.stringify(newJson[k]).slice(1, -1).split('"').join("").split(':').join("|")
                        })
                        d3.select(node[0][k]).select('circle').attr('data-drilldownkey', function(d,index){
                            return JSON.stringify(newJson[k]).slice(1, -1).split('"').join("").split(':').join("|")
                        })
                    }
                }
                else {
                }
            }
        }

        //--------- creating legend-----------
        
        var legendPanelSvgForBubbleChart = svgLegendPanelBubbleChart .append('svg')  .attr("class","") .style("background-color",options.BGcolor) .style('position',"absolute")
        .style('width', 100 + "%") .style('height', 100 + "%") .style("left",0 + "%").style("top",0 + "%")
        
        var legend = legendPanelSvgForBubbleChart.selectAll('.legend') .data(newJson)  .enter() .append('g') .attr("class", "legend")
        .attr("height", "100%") .attr("width", "100%") //.attr('transform', 'translate(0,20)')
        
        //Create colour circles
        var legendGroup = legend .data(newJson) .append("rect") .attr("x", 0) .attr("y", function(d, i){ return i * 2;}) .attr("width", 13)
        .attr("height", 13) .attr("rx",10) .attr("ry",10) .style("fill", function(d, i){ return colors(i);}) .style("cursor","auto")
      
        //Create text next to circles
        var legendText = legend .data(newJson) .append("text") .attr("x", 18) .attr("y", function(d, i){ return i * 2 + 12;})
        .style("font-family","Verdana,sans-serif") .text(function(d) { return d[options.keys.label]; })
        .text(function(d,i) {
            
            if(d[options.keys.label].length > 10){
                
                return d[options.keys.label].substring(0,10)+'...'; //" : "+ d[options.keys.value];
            }
            else{
                
                return d[options.keys.label]; //+" : "; //+ d[options.keys.value];
            }
        })
        .style("font-size", "14px") .attr("fill","#00001c") .style("font-weight","Normal")

        var legendTextValue = legend.append('text').data(newJson) .attr('x', (17 + 130)) .attr("y", function(d, i){ return i * 2 + 12;}) .style("font-family","Verdana,sans-serif") .style("font-size", "12px")
        .style('fill','#00001c') .style("font-weight","Normal").attr("class","legend_value").style("display",options.legend)
        .text(function(d,i) {
           // return d[options.keys.value].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            if(d[options.keys.value].toString().indexOf('.') === -1)
            {
                return d[options.keys.value].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            else{
                        
                return d[options.keys.value];
            }
        })

        // var legendTextValue = legend.append('text').data((newJson) .attr('x',  90) .attr('y', function(d, i){ return i * 2 + 12;}) .style("font-family","Verdana") .style("font-size", "12px")
        // .style('fill','#666666') .style("font-weight","Normal")
        // .text(function(d,i) {
            
        //      return d[options.keys.value].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        // })
        
        // var arcOver = d3.svg.arc() .outerRadius((radiusForPieChart * 0.9) + 0.05);
        
        // pathForPieChart.on("mouseenter", function(d,i) {   d3.select(this) .attr("stroke","white") .transition() .ease("elastic") .duration(100) .attr("d", arcOver) .attr("stroke-width",0.5);  });
        
        // pathForPieChart.on("mouseleave", function(d) {   d3.select(this).transition() .attr("d", arc) .attr("stroke","none");   });

        node.on('mouseenter',function(d,i){
            d3.select(this).select('circle') .transition() .ease("bounce") .duration(600) .attr("r", function(d) { return (d.r) + 15; });
        })
        node.on('mouseleave',function(d,i){
            d3.select(this).select('circle') .transition() .ease("bounce") .duration(600) .attr("r", function(d) { return (d.r); });
        })

        legendGroup.on('mouseenter',function(d,i){
            d3.select(node[0][i]).select('circle').transition() .ease("bounce") .duration(600) .attr("r", function(d) { return (d.r) + 15; })
        })
        legendGroup.on('mouseleave',function(d,i){
            d3.select(node[0][i]).select('circle').transition() .ease("bounce") .duration(600) .attr("r", function(d) { return (d.r); })
        })

        // Aligning Legend (vertically)
        var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(svgLegendPanelBubbleChart[0][0].style.width) / 100)
        var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(svgLegendPanelBubbleChart[0][0].style.height) / 100)

        var legendRectSize = 11;
        var legendSpacing = 4;
            
        legend.transition().duration(0).attr('transform', function(d, i) {
            var eachRectHeight = legendRectSize + legendSpacing;
            var offset =  eachRectHeight * colors.domain().length / 2;
            var horz = 1;
            var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * newJson.length))/2.1; // originally 2.0
            return 'translate(' + horz + ',' + vert + ')';
        })
        
        

        var tableDivForBubbleChart = targetElement .append('div') 
            .attr("class","scrollingDivForTable-Class tableDivForBubbleChart" + targetElement[0][0].id) .style('background-color',"#ffffff") .style("position","absolute")
            .style("display","block") .style("overflow","hidden") //.style("border-right","1px solid #e2e2e2").style("border-bottom","1px solid #e2e2e2")

            $( '.tableDivForBubbleChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
                var e0 = e.originalEvent,
                delta = e0.wheelDelta || -e0.detail;
    
                this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
                e.preventDefault();
            });
            
            if(options.showTitle == true){
                tableDivForBubbleChart.style("width", 100 + "%") .style("height", 40 + "%") .style("top",60 + "%") 
            }
            else if(options.showTitle == false){
                tableDivForBubbleChart.style("width", 100 + "%") .style("height", 40 + "%") .style("top",60 + "%") 
            }

        tableDivForBubbleChart.html('<table class = "tableClassForBubbleChart' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                    '<thead class = "theadClassForBubbleChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForBubbleChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                                    '<tbody class = "tBodyClassForBubbleChart' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                    '</table>'
                                    )
        
        tableDivForBubbleChart.select('table').attr("id",targetElement[0][0].id + "tableID")

        // Show or Hide Table scroll bar when mouseover on widget
        targetElement.on('mouseover',function(){ tableDivForBubbleChart.style("overflow","auto") })
        targetElement.on('mouseout',function(d){ tableDivForBubbleChart.style("overflow","hidden") })
        
        var tableDataForBubbleChart = [];
        if(options.dataForTable.length > 0){
            tableDataForBubbleChart = options.dataForTable;
        }
        else {
            tableDataForBubbleChart = newJson;
        }
        
        var thead = tableDivForBubbleChart.select("thead").selectAll("th") .data(d3.keys(tableDataForBubbleChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#fefdfd")//f6f6f6
        .style("position","relative").style("top","2px")
        
        var thead1 = d3.select(".thead1ClassForBubbleChart" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tableDataForBubbleChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#fefdfd")//f6f6f6
        .style("position","relative").style("top","2px")
        
        var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
        .attr("id", "ascendingIconIDForBubbleChart") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
        
        var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
        .attr("id", "descendingIconIDForBubbleChart") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
        
        var tr = tableDivForBubbleChart.select("tbody").selectAll("tr") .data(tableDataForBubbleChart).enter().append("tr")
        .attr("id", function(d,i) { return "slice" + i })
        
        // cells
        var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d; })
        .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
        
        var $table = $('.tableClassForBubbleChart' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
        
        d3.select(".theadClassForBubbleChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                d.forEach(function(dd,j){
                    colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                })
        })
        
        $(".thead1ClassForBubbleChart" + targetElement[0][0].id).insertAfter('.tBodyClassForBubbleChart' + targetElement[0][0].id)
        
        $(".thead1ClassForBubbleChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForBubbleChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
        
        tableDivForBubbleChart.select(".thead1ClassForBubbleChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
			d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
		})
        
        $('.tableDivForBubbleChart' + targetElement[0][0].id).scroll(function () {
                                                                  
            $(".thead1ClassForBubbleChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForBubbleChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
                                                                  
        })
        
        var sortOrder = false;
        thead1.on("click",function(k,index){
                 
             sortOrder = !sortOrder;
             
             tableDivForBubbleChart.select(".thead1ClassForBubbleChart" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                                                
                    if (sortOrder) {
                                      
                        if(i == index){
                            d3.select(this).select('svg').select('#descendingIconIDForBubbleChart').style("visibility", "hidden")
                            d3.select(this).select('svg').select('#ascendingIconIDForBubbleChart').style("visibility", "visible")
                        }
                        else {
                            d3.select(this).select('svg').select('#descendingIconIDForBubbleChart').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForBubbleChart').style("visibility", "visible")
                        }
                    }
                    else{
                                      
                        if(i == index){
                            d3.select(this).select('svg').select('#descendingIconIDForBubbleChart').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForBubbleChart').style("visibility", "hidden")
                        }
                        else {
                            d3.select(this).select('svg').select('#descendingIconIDForBubbleChart').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForBubbleChart').style("visibility", "visible")
                        }
                    }
                })
             
              var monthTruOrFalAryForBubbleChart = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
              
              tr.sort(function(a, b) {
                      
                      if (sortOrder) {
                      var monthsArrayForBubbleChart = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                      } else {
                      var monthsArrayForBubbleChart = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                      }
                      
                      monthTruOrFalAryForBubbleChart = []; gotMonthArray = [];
                      tableDataForBubbleChart.forEach(function(d,i){
                          var da = d[k].toString().substring(0,3).toLowerCase()
                          if(monthsArrayForBubbleChart.indexOf(da) >= 0){
                              monthTruOrFalAryForBubbleChart.push(true)
                              gotMonthArray.push(da);
                          }
                          else {
                              monthTruOrFalAryForBubbleChart.push(false)
                          }
                      })
                      
                      if(monthTruOrFalAryForBubbleChart.indexOf(false) == -1){ // true
                      
                      monthArray = []; monthArrayCount = [];
                      gotMonthArray.forEach(function(dd,j){
                            var index1 = monthsArrayForBubbleChart.indexOf(dd.substring(0,3))
                            if(monthArrayCount.indexOf(index1) >= 0){
                                index1 = 12 + index1;
                            }
                            monthArray.push(index1);
                            monthArrayCount.push(index1)
                      })
                      returnArray = []
                      monthArray.sort(function(aa, bb) {
                          returnArray.push(+aa - +bb)
                          return +aa - +bb;
                      })
                      
                      sortTableFunc()
                      return returnArray[ind++];
                      } //  if true (if jan feb if block)
                      else {
                      var data = +a[k];
                      
                      if(!isNaN(data)){
                      
                      if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                      else { return d3.descending(+a[k], +b[k]); }
                      }
                      else if(!isNaN(Date.parse(a[k]))){
                      
                      if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                      else { return new Date(b[k]) - new Date(a[k]) }
                      }
                      else {
                      
                      if (sortOrder) { return d3.ascending(a[k], b[k]); }
                      else { return d3.descending(a[k], b[k]); }
                      }
                      } // if not jan feb else block
                      }); // tr
             
         })
        
        function sortTableFunc(){
            
            var table = tableDivForBubbleChart.select('table');
            var rows = table.selectAll('tr').data(tableDataForBubbleChart);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0) .style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500)
            .style('opacity', 1.0) .style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
        }
        
        // Main Table Styling
        tableDivForBubbleChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
        .style("color","#00001c")
        .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4") //.style("box-shadow","10px 10px 50px #007aff").style("z-index",9999)
        tableDivForBubbleChart.selectAll('td').style("height","25px") .style("border", "1px solid #ffffff").style("font-size","12px").style("font-weight","Normal").style("color","#00001c")

        //additionally 
        tableDivForBubbleChart.selectAll('th').style('background-color',"#ffffff").style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
        tableDivForBubbleChart.selectAll('td').style("border-style","none").style("color","#00001c")
        //tablePanelForPieChart.selectAll('td').style("height","25px") .style("border", "1px solid #fcfcfc") .style("font-size","12px").style("font-weight","Normal")

        //b1da9f
        tableDivForBubbleChart.selectAll('table') . style("border-collapse","collapse")
        tableDivForBubbleChart.selectAll('table tr:first-child th').style("border-top","0px")
        tableDivForBubbleChart.selectAll('table tr:last-child td').style("border-bottom","0px")
        tableDivForBubbleChart.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
        tableDivForBubbleChart.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")

        if(showOrHideTableForBubbleChart == false){
            tableDivForBubbleChart.style("display","none")
        }
        else if(showOrHideTableForBubbleChart == true){
            tableDivForBubbleChart.style("display","block")
        }
        
        
        if(options.isDataDetailedForTable == false){
        
            var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
        
            // Adding underlines for selected drill-down column text
            var drillDownSectionsForBubbleChart = tableDivForBubbleChart.select('table').selectAll('th')
        
            var foundResult = [];
            for(var i = 0; i<drillDownSectionsForBubbleChart[0].length; i++){
                for(var j = 0; j<drillDownColumnNamesArray.length; j++){
                    if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForBubbleChart[0][i].__data__.toString().toLowerCase() ){
                        foundResult.push(i)
                    }
                }
            }
        
            var r = tableDivForBubbleChart.select('table').selectAll('tr').selectAll('td')
            for(var i = 0; i<r.length; i++){
                for(var j = 0; j < foundResult.length; j++){
                    var row = r[i][foundResult[j]]
                    $(row).css("text-decoration", "underline")
                }
            }
        }
        
        //By default calling the resized function first time (to align table's th and td).
        setTimeout(function(){ resizedFuctionForBubbleChart() },1000)

        window.addEventListener('resize', function(event){ resizedFuctionForBubbleChart() });
        
        $(function() {
          
          $("#" + targetElement[0][0].id).resizable({
                resize: function(event, ui) {
                        //divWidth = ui.size.width;
                        //divHeight = ui.size.height;
                        resizedFuctionForBubbleChart();
                }
             });
          });
        
        function resizedFuctionForBubbleChart()
        {
            
            if((svgPanelForBubbleChart.node().getBoundingClientRect().width) && (svgPanelForBubbleChart.node().getBoundingClientRect().height) > 0){

                if(showOrHideCommentsBtnForBubbleChart == true){
                    pieButtonForBubbleChart.style('margin-left', "2px")
                    donutButtonForBubbleChart.style('margin-left', "2px")
                    horButtonForBubbleChart.style('margin-left', "2px")
                    colButtonForBubbleChart.style('margin-left', "2px")
                    refreshButtonForBubbleChart.style('margin-left', "2px")
                    commentsBtnForBubbleChart.style('margin-left', "2px")
                    menuBtnForBubbleChart.style('right', '0')
                }
                else if(showOrHideCommentsBtnForBubbleChart == false){
                    pieButtonForBubbleChart.style('margin-left', "2px")
                    donutButtonForBubbleChart.style('margin-left', "2px")
                    horButtonForBubbleChart.style('margin-left', "2px")
                    colButtonForBubbleChart.style('margin-left', "2px")
                    refreshButtonForBubbleChart.style('margin-left', "2px")
                    //commentsBtnForBubbleChart.style('right', '0')
                    commentsBtnForBubbleChart.style('display','none')
                    menuBtnForBubbleChart.style('right', '0')
                }

                optionsBtnPanelForBubbleChart.style('right', '0')

                stgPanCanBtnForBubbleChart.style('right', '0')

                var diameterWidthNew = document.getElementById("svgPanelIDForBubbleChart" + targetElement[0][0].id).getBoundingClientRect().width//svgPanelForBubbleChart[0][0].clientWidth;
                var diameterHeightNew = document.getElementById("svgPanelIDForBubbleChart" + targetElement[0][0].id).getBoundingClientRect().height//svgPanelForBubbleChart[0][0].clientHeight;

                // var diameterWidthNew = ($('#svgPanelIDForBubbleChart' + targetElement[0][0].id)[0].getBoundingClientRect().width)
                // var diameterHeightNew = ($('#svgPanelIDForBubbleChart' + targetElement[0][0].id)[0].getBoundingClientRect().height)

                var bubbleLayoutNew = d3.layout.pack() .sort(null) .size([diameterWidthNew,diameterHeightNew]) .padding(1.5);

                //var bubbleChartSVG = svgPanelForBubbleChart.append("svg")//.style("background","#606060")
                bubbleChartSVG .attr("width" , diameterWidthNew) .attr("height", diameterHeightNew)

                var filteredArrayNew = [];
                newJson.forEach(function(d,i){ 
                    var temp = {};
                    temp[options.keys.label] = d[options.keys.label]
                    temp["value"] = d[options.keys.value]
                    filteredArrayNew.push(temp)
                })

                var selectionNew = bubbleChartSVG.selectAll("g.node")
                .data(bubbleLayoutNew.nodes({children: filteredArrayNew}).filter(function(d) { return !d.children; }) ); 

                //node .attr("transform", function(d) { return "translate(" + d.x + ", " + d.y + ")"; }).filter(function(d){ return d.value > 0;})
                //.select("circle") .attr("r", function(d) { return d.r; })
                
                node .attr("transform", function(d) { return "translate(" + d.x + ", " + d.y + ")"; }).filter( function(d,i){if(d.value == 0){ d.value = 0.000000000000001;
                d3.select(selection[0][i]).style("display","none"); }; return d.value > 0; }).select("circle") .attr("r", function(d) { return d.r; })

                var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(svgLegendPanelBubbleChart[0][0].style.width) / 100)
                var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(svgLegendPanelBubbleChart[0][0].style.height) / 100)
                
                var legendRectSize = 11;
                var legendSpacing = 4;
                
                legend.attr('transform', function(d, i) {
                                                      
					var height = legendRectSize + legendSpacing;
					var offset =  height * colors.domain().length / 2;
					var horz = 1;
					var vert = (i * height) + (legendPanelHeight - (height * newJson.length))/2.1 ;
					return 'translate(' + horz + ',' + vert + ')';
                            
                })
                
                colWidth = []; 
				
                d3.select(".theadClassForBubbleChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                    d.forEach(function(dd,j){
                            colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                    })
                })
                tableDivForBubbleChart.select(".thead1ClassForBubbleChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                    d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
                })

            }// checking svg panel width & height greater that zero function

        }

    }, //bubbleChart

    // ************************************************** Per Gauge with Filp **************************************************
    perGaugeWithFlip: function(targetElement, options){
        
        isChartCalled++;

        var chartName = "PERGAUGEWITHFLIP";
        
        acinfotech.allCharts(targetElement,options,chartName);
        
        targetElement.style("min-width", "200px").style("min-height", "200px").style("background-color", options.BGcolor)

        //var textPixels = (config.textSize*radius/2);
        var textFinalValue = parseFloat(options.data).toFixed(2);
        //var textStartValue = config.valueCountUp?config.minValue:textFinalValue;
        //var percentText = config.displayPercent?"%":"";
        //var circleThickness = config.circleThickness * radius;
        //var circleFillGap = config.circleFillGap * radius;
        //var fillCircleMargin = circleThickness + circleFillGap;
        //var fillCircleRadius = radius - fillCircleMargin;
        //var waveHeight = fillCircleRadius*waveHeightScale(fillPercent*100);

        // var waveLength = fillCircleRadius*2/config.waveCount;
        // var waveClipCount = 1+config.waveCount;
        // var waveClipWidth = waveLength*waveClipCount;

        // Rounding functions so that the correct number of decimal places is always displayed as the value counts up.
        var textRounder = function(value){ return Math.round(value); };
        if(parseFloat(textFinalValue) != parseFloat(textRounder(textFinalValue))){
            textRounder = function(value){ return parseFloat(value).toFixed(1); };
        }
        if(parseFloat(textFinalValue) != parseFloat(textRounder(textFinalValue))){
            textRounder = function(value){ return parseFloat(value).toFixed(2); };
        }
    
        var chartTitlePanelForPerGaugeWithFlip =  targetElement.append("div").style("background-color", options.BGcolor).style("position","absolute") .style("text-indent","6px")
        
        // additionally
        .style("background-color", options.BGcolor).style("border", "none")

        var svgPanelForPerGaugeWithFlip = targetElement .append('svg') 
        .attr("id","svgPanelForPerGaugeWithFlip" + targetElement[0][0].id) .style("background-color", options.BGcolor) .style("position","absolute")

        if(options.showTitle == true){
            
            chartTitlePanelForPerGaugeWithFlip.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 10 + "%"; })
            .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:10.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')
            svgPanelForPerGaugeWithFlip.attr('width', 100 + "%") .attr('height', 90 + "%") .style("top",10 + "%") .style("background-color", options.BGcolor).append('g')
            
        }
        else if(options.showTitle == false){
            chartTitlePanelForPerGaugeWithFlip.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });
            svgPanelForPerGaugeWithFlip.attr('width', 100 + "%") .attr('height', 100 + "%") .style("left",0 + "%") .style("background-color", options.BGcolor).append('g')
        }

        var svgWidth = d3.select("#" + "svgPanelForPerGaugeWithFlip" + targetElement[0][0].id);

        var theta = 2 * Math.PI,
        width = parseInt(svgWidth.style("width")),//svgPanelForPerGaugeWithFlip[0][0].clientWidth,
        height = parseInt(svgWidth.style("height")),//svgPanelForPerGaugeWithFlip[0][0].clientHeight,
        outerRadius = Math.min(width,height)/2.5,
        innerRadius = (outerRadius/5)*4,
        fontSize = 40//(Math.min(width,height)/4);

        //var grad = Math.PI / 180;
        var radius = Math.min(parseInt(svgWidth.style("width")), parseInt(svgWidth.style("height")))/2.8;

        var arc = d3.svg.arc() .innerRadius(innerRadius) .outerRadius(outerRadius) .startAngle(0);

        var svg = svgPanelForPerGaugeWithFlip.append("svg") .attr("width", '100%') .attr("height", '100%') .style("background-color", options.BGcolor).append("g")
        .attr("transform", "translate(" + width/2 + "," + Math.min(width,height) / 2 + ")");
        
        var count = 0;
        var text = svg.append("text") .text('0%') .attr("text-anchor", "middle") .style("font-size",fontSize+'px')
        .attr("dy",fontSize/2.5) .attr("dx",2) .style("cursor","pointer") .style("fill","#3399cc")
        .on("click", function() {
            if(count == 0){
                var newValue = 100 - options.data

                d3.select(this) .transition().duration(200) .attr("transform", "scale(0,1)") .transition() .duration(200)
                .attr("transform", "scale(1,1)")
                //.text("HEllo" + "%"); 

                foreground .transition() .duration(750) .call(arcTween, newValue/100 * theta);
                count = 1;
            }
            else if(count == 1){
                
                d3.select(this) .transition() .duration(200) .attr("transform", "scale(0,1)") .transition().duration(200)
                .attr("transform", "scale(1,1)")
                //.text(options.data + "%");

                foreground .transition() .duration(750) .call(arcTween, options.data/100 * theta);
                count = 0;
            }
        });
        
    var background = svg.append("path") .datum({endAngle: theta}) .style("fill", "#e5e5e5") .attr("d", arc) 
    .attr("id", function(d, i) { return "s" + i; })

    var midground = svg.append("path") .datum({endAngle: 0 * theta}) .style("fill", "lightblue") .attr("d", arc);

    var foreground = svg.append("path")
        .datum({endAngle: 0 * theta}) .style("fill", "#3399cc") .attr("d", arc) .attr("id", function(d, i) { return "s1" + i; })
        
    foreground.transition() .duration(750) .call(arcTween, options.data/100 * theta)
          
    //----.call(arcTween, 0.20 * theta);
          
    var circularText;
     var circularTextValue;
    if(parseFloat(options.data)>=35){
        
        circularText = svg.append("text") .style("fill","#3399cc") .style("font-size", "16px") .style("text-anchor","start") .append("textPath")
        .style("font-family","Verdana,sans-serif") .attr("xlink:href", function(d, i) { return "#s1" + i; })
        /*.attr("textLength", function(d, i) {
            return 50 - i * 5;
        })*/
        
        //circularTextValue = options.coveredCircularAreaText

        if(options.coveredCircularAreaText.length > 14){
            
            circularTextValue = options.coveredCircularAreaText.substring(0,14)+'...'
            circularText.style("font-size", "14px")
        }
        else{
            circularTextValue = options.coveredCircularAreaText
            circularText.style("font-size", "16px")
        }
    }
    else if((parseFloat(options.data))>= 25 && (parseFloat(options.data))< 35){
        
        circularText = svg.append("text") .style("fill","#3399cc") .style("font-size", "15px") .style("text-anchor","start") .append("textPath")
        .style("font-family","Verdana,sans-serif") .attr("xlink:href", function(d, i) { return "#s1" + i; })
        /*.attr("textLength", function(d, i) {
            return 50 - i * 5;
        })*/
        
        //circularTextValue = options.coveredCircularAreaText

        if(options.coveredCircularAreaText.length > 10){
            
            circularTextValue = options.coveredCircularAreaText.substring(0,10)+'...'
            circularText.style("font-size", "14px")
        }
        else{
            circularTextValue = options.coveredCircularAreaText
            circularText.style("font-size", "15px")
        }
        
    }
    else if( parseFloat(options.data) < 25 ) {
        circularText = svg.append("text") .style("fill","#3399cc") .style("font-size", "15px") .style("text-anchor","middle")
        .style("font-family","Verdana,sans-serif") .attr("dy",fontSize/1.2) .attr("dx",2)

        if(options.coveredCircularAreaText.length > 12){
            
            circularTextValue = options.coveredCircularAreaText.substring(0,12)+'...'
            circularText.style("font-size", "14px")
        }
        else{
            circularTextValue = options.coveredCircularAreaText
            circularText.style("font-size", "15px")
        }
        
    }
   
    function arcTween(transition, newAngle) {

        transition.attrTween("d", function(d) {
            
            var interpolate = d3.interpolate(d.endAngle, newAngle);
            
            return function(t) {
                
                d.endAngle = interpolate(t);
                
                if(count == 0){
                    text.text((options.data)).style("font-family","Verdana,sans-serif");
                    circularText.text(function(d, i) {
                        
                        return circularTextValue.toString();
                    })
                    
                }
                else if(count == 1){
                    var newValue = 100 - options.data
                     text.text(newValue +'%').style("font-family","Verdana,sans-serif");
                     circularText.text(function(d, i) {
                        return options.unCoveredCircularAreaText;
                    })
                }
                
                return arc(d);
            };
        });
    }
        
        window.addEventListener('resize', function(event){ resizedFuctionForPerGaugeWithFlip() });
        
        $(function() {
          $("#" + targetElement[0][0].id).resizable({
                resize: function(event, ui) {
                resizedFuctionForPerGaugeWithFlip();
            }
            });
        });
        
        function resizedFuctionForPerGaugeWithFlip(){
            if((svgPanelForPerGaugeWithFlip.node().getBoundingClientRect().width) && (svgPanelForPerGaugeWithFlip.node().getBoundingClientRect().height) > 0){
                
                d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                acinfotech.perGaugeWithFlip(targetElement,options)
            }
        }

    }, //perGaugeWithFlip

    // ************************************************** Stacked Horizontal Bar Chart  **************************************************
    stackedHorizontalBarChart: function(targetElement, options){

        isChartCalled++;

        var chartName = "STACKEDHORIZONTALBARCHART";
       
        acinfotech.allCharts(targetElement,options,chartName)

        targetElement.style("min-width", "350px") .style("min-height", "350px").style("background-color", options.BGcolor)

        var showOrHideTableForStkHoriChart;
        var showOrHideCommentsForStkHoriChart;
        var showOrHideCommentsBtnForStkHoriChart = true;

        if((options.showTable == false) || (options.showTable == true)){ 
            showOrHideTableForStkHoriChart = options.showTable; 
        }
        else{ 
            showOrHideTableForStkHoriChart = false; 
        }

        // Show or Hide comments
        if (options.showComments == true || false) {
            showOrHideCommentsForStkHoriChart = options.showComments;
        }
        else {
            showOrHideCommentsForStkHoriChart = false;
        }
        
        if (options.comments.length == 0){ 
            showOrHideCommentsForStkHoriChart = false;
            showOrHideCommentsBtnForStkHoriChart = false;
        }

        if ((showOrHideTableForStkHoriChart == true) && (showOrHideCommentsForStkHoriChart == true)){
            showOrHideTableForStkHoriChart = true;
            showOrHideCommentsForStkHoriChart = false;
        }
        else if ((showOrHideTableForStkHoriChart == false) && (showOrHideCommentsForStkHoriChart == false)){
            showOrHideTableForStkHoriChart = false;
            showOrHideCommentsForStkHoriChart = false;
        }

        var chartTitlePanelForStackedHoriBarChart =  targetElement.append("div").style("background-color", options.BGcolor).style("position","absolute").style('background-color',"#ffffff")
        .style("text-indent","6px")
        
		var optsBtnPanelForStkHorichart = targetElement.append('div').style('width',"25px").style('height',"160px").style('position','absolute')
        .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px") .style("min-width","25px")
        .style('right', '0') .style("border-style","none").style("border-left", "solid #fcfcfc  1px")
		
        var filterBtnForStackedHoriBarChart = optsBtnPanelForStkHorichart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','80px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var filterBtnImgVar = document.createElement("IMG");
        filterBtnImgVar.src = "images/filterIcon.png";
        filterBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        filterBtnForStackedHoriBarChart[0][0].appendChild(filterBtnImgVar)

        var refreshBtnForStackedHoriBarChart = optsBtnPanelForStkHorichart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','105px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var refreshBtnImgVar = document.createElement("IMG");
        refreshBtnImgVar.src = "images/refreshIcon.png";
        refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        refreshBtnForStackedHoriBarChart[0][0].appendChild(refreshBtnImgVar)

        var commentsBtnForStkHoriBarChart = optsBtnPanelForStkHorichart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','130px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var commentsBtnImgVariable = document.createElement("IMG");
        if(options.showComments == false){
            commentsBtnImgVariable.src = "images/showCommentsIcon.png";
        }
        else if(options.showComments == true){
            commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
        }
        commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        commentsBtnForStkHoriBarChart[0][0].appendChild(commentsBtnImgVariable)

        var menuBtnForStackedHoriBarChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','1px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var menuBtnImgVar = document.createElement("IMG");
        menuBtnImgVar.src = "images/menuIcon.png";
        menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
        menuBtnForStackedHoriBarChart[0][0].appendChild(menuBtnImgVar)

        if(showOrHideCommentsBtnForStkHoriChart == true){
            filterBtnForStackedHoriBarChart.style('margin-left', "2px")
            refreshBtnForStackedHoriBarChart.style('margin-left', "2px")
            commentsBtnForStkHoriBarChart.style('margin-left', "2px")
            menuBtnForStackedHoriBarChart.style('right', '0')
        }
        else if(showOrHideCommentsBtnForStkHoriChart == false){
            filterBtnForStackedHoriBarChart.style('margin-left', "2px")
            refreshBtnForStackedHoriBarChart.style('margin-left', "2px")
            //commentsBtnForStkHoriBarChart.style('right', '0')
            commentsBtnForStkHoriBarChart.style('display','none')
            menuBtnForStackedHoriBarChart.style('right', '0')
        }

		var ismenuBtnOfStkHoriChartClicked = false;
        menuBtnForStackedHoriBarChart.on('click', function() {

            filterPanelForStkHoriChart.style("display","none")

            stgPanDivForStkHoriChart.style('display','none')

            if ((showOrHideTableForStkHoriChart == false) && (showOrHideCommentsForStkHoriChart == true)){
                    divLegendPanelStackedHoriBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanelForStackedHoriBarChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                    .style("position","absolute").style("background-color", options.BGcolor);
                }
                else if ((showOrHideTableForStkHoriChart == true) && (showOrHideCommentsForStkHoriChart == false)){
                    divLegendPanelStackedHoriBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanelForStackedHoriBarChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute").style("background-color", options.BGcolor);
                }
                else if ((showOrHideTableForStkHoriChart == false) && (showOrHideCommentsForStkHoriChart == false)){
                    divLegendPanelStackedHoriBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanelForStackedHoriBarChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute").style("background-color", options.BGcolor);
                }

            if(ismenuBtnOfStkHoriChartClicked == false){
                ismenuBtnOfStkHoriChartClicked = true;
                optsBtnPanelForStkHorichart.style("display","block")

            }
            else if(ismenuBtnOfStkHoriChartClicked == true){
                ismenuBtnOfStkHoriChartClicked = false
                optsBtnPanelForStkHorichart.style("display","none")
            }

            resizedFuctionForStackedHoriChart()
        })

        var tableButtonForStkHoriChart = optsBtnPanelForStkHorichart.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top','1px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
        var tableBtnImgVar = document.createElement("IMG");
        if(showOrHideTableForStkHoriChart == false){
            tableBtnImgVar.src = "images/showTableIcon.png";
            tableButtonForStkHoriChart.attr("class","showTableClassForChartTable")
        }
        else if(showOrHideTableForStkHoriChart == true){
            tableBtnImgVar.src = "images/cancelTableIcon.png";
            tableButtonForStkHoriChart.attr("class","hideTableClassForChartTable")
        }
        tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
        tableButtonForStkHoriChart[0][0].appendChild(tableBtnImgVar)

        var settingBtnForStkHoriChart = optsBtnPanelForStkHorichart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 28 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        var settingBtnImgVar = document.createElement("IMG");
        settingBtnImgVar.src = "images/settingsIcon.png";
        settingBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.82;")
        settingBtnForStkHoriChart[0][0].appendChild(settingBtnImgVar)
        
        var downloadBtnForStkHoriChart = optsBtnPanelForStkHorichart.append("div").attr("id","downloadBtnForStkHoriChart-ID-" + targetElement[0][0].id).style("width","20px")
        .style("height","20px").style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff").style('margin-left','2px')
        .style('top', 54 + 'px').style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        
        acinfotech.downloadFunctionality("downloadBtnForStkHoriChart-ID-" + targetElement[0][0].id,targetElement)
        
        var svgPanelForStackedHoriBarChart = targetElement .append('svg') 
        .attr("id","svgPanelIDForStackedHoriBarChart" + targetElement[0][0].id) .style("background-color", options.BGcolor).style("position","absolute")
        .style("border","0px solid #d0d0d0")

        var commentsPanelDivForStkHoriChart = targetElement.append("div") .attr("class","commentsPanelClassForStkHoriChart") 
        .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
		.style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
        .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)

        commentsPanelDivForStkHoriChart.on('click',function(d){
            $('.commentsClassForStkHoriChart' + targetElement[0][0].id).focus()
        })

        if(options.showTitle == true){
            
            chartTitlePanelForStackedHoriBarChart.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 8 + "%"; }).style("background-color", options.BGcolor)
            .html('<div  style="width: 100%; height:0%;  position: absolute; top:25.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')

            if ((showOrHideTableForStkHoriChart == false) && (showOrHideCommentsForStkHoriChart == true)){

                var commentsForLineChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify') .attr('class','commentsClassForStkHoriChart' + targetElement[0][0].id)

                   svgPanelForStackedHoriBarChart.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%").style("background-color", options.BGcolor) .append('g')
                   commentsPanelDivForStkHoriChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForLineChart[0].outerHTML.toString())

            }
            else if ((showOrHideTableForStkHoriChart == true) && (showOrHideCommentsForStkHoriChart == false)){

                    svgPanelForStackedHoriBarChart.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .style("background-color", options.BGcolor).append('g')
                    commentsPanelDivForStkHoriChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForStkHoriChart == false) && (showOrHideCommentsForStkHoriChart == false)){
                    svgPanelForStackedHoriBarChart.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%").style("background-color", options.BGcolor) .append('g')
                    commentsPanelDivForStkHoriChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            
            var margin = {top: 10 , right: 20, bottom: 20, left: 130}, //originally top: 42, left: 80
            width = (svgPanelForStackedHoriBarChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = svgPanelForStackedHoriBarChart.node().getBoundingClientRect().height - margin.top - margin.bottom;
            
        }
        else if(options.showTitle == false){
            chartTitlePanelForStackedHoriBarChart.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });

            if ((showOrHideTableForStkHoriChart == false) && (showOrHideCommentsForStkHoriChart == true)){

                var commentsForLineChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify')

                   svgPanelForStackedHoriBarChart.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .style("background-color", options.BGcolor).append('g')
                   commentsPanelDivForStkHoriChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForLineChart[0].outerHTML.toString())

            }
            else if ((showOrHideTableForStkHoriChart == true) && (showOrHideCommentsForStkHoriChart == false)){

                    svgPanelForStackedHoriBarChart.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%").style("background-color", options.BGcolor).append('g')
                    commentsPanelDivForStkHoriChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForStkHoriChart == false) && (showOrHideCommentsForStkHoriChart == false)){
                    svgPanelForStackedHoriBarChart.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .style("background-color", options.BGcolor).append('g')
                    commentsPanelDivForStkHoriChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            
            var margin = {top: 10, right: 20, bottom: 20, left: 130}, //originally top: 42, left: 80
            width = (svgPanelForStackedHoriBarChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = svgPanelForStackedHoriBarChart.node().getBoundingClientRect().height - margin.top - margin.bottom;
        }

        var colours;
        // checking color set for pie slices and legend dots
        if(options.colorSet === undefined){
            options.colorSet = "one" // fdce58
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "one"){
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            options.colorSet = "two"
             colours = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            options.colorSet = "three"
            colours = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        }
        else
        {
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }

        //------------------ Settings panel DIV and everything within it section begins here ------------------
        
        var stgPanDivForStkHoriChart = targetElement.append('div').style('width',"100%").style('height',"40%").attr("class","stgPanDivForStkHoriChart" + targetElement[0][0].id)
        .style('position','absolute').style('margin-left', "0px").style('border-top',"1px solid #f0f0f0").style('border-bottom',"1px solid #e5e5e5")
        .style("background-color",'#fcfcfc').style("z-index",90) .style("display","none") .style('top',"60%").style('height',"40%")

        $( '.stgPanDivForStkHoriChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        var settingPanelTitle = stgPanDivForStkHoriChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','10px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; color:#00001c;">'+ "Settings" +'</div>')

        var stgPanDivForStkHoriChangeColorTitle = stgPanDivForStkHoriChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Select color set " +'</div>')

        var stgPanCanBtnForStkHoriChart = stgPanDivForStkHoriChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
        .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
        .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.9; background-color:#fcfcff")
        stgPanCanBtnForStkHoriChart[0][0].appendChild(cancelBtnImgVar)

        stgPanCanBtnForStkHoriChart.on('click', function() {
            stgPanDivForStkHoriChart.style("display","none") // Hiding setting panel

            if ((showOrHideTableForStkHoriChart == false) && (showOrHideCommentsForStkHoriChart == true)){
                divLegendPanelStackedHoriBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                svgPanelForStackedHoriBarChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForStkHoriChart == true) && (showOrHideCommentsForStkHoriChart == false)){
                divLegendPanelStackedHoriBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                svgPanelForStackedHoriBarChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForStkHoriChart == false) && (showOrHideCommentsForStkHoriChart == false)){
                divLegendPanelStackedHoriBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                svgPanelForStackedHoriBarChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color", options.BGcolor);
            }

            resizedFuctionForStackedHoriChart();
        })

        var formForChangeSettingsPanel = stgPanDivForStkHoriChart.append("form");
        formForChangeSettingsPanel.style("background-color","#fcfcfc").style("margin-top","67px").style("font-family","Verdana,sans-serif").style("font-size","12px")
        .style("position","absolute").attr("id","formForChangeColorSettingsPanel" + targetElement[0][0].id).style("font-weight","Bold").style("width","180px")
        .style("height","58px").style("padding","0px").style("border-radius","0px") .style("margin-left","10px")

        var svgPanelForCrSetOne = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px").style("height","18px").style("margin-top","1px").style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetOne = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        var colorSetOneRange = d3.range(12);

        var colorSetOneDots = svgPanelForCrSetOne.append("g")
        colorSetOneDots.selectAll('rect') .data(colorSetOneRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("fill", function(d,i){return colorSetOne(i)})
        .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)  .style("stroke",function(d,i){  return colorSetOne(i); })
        .style("cursor","auto") .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        var svgPanelForCrSetTwo = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px").style("height","18px").style("margin-top","20px").style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetTwo = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        var colorSetTwoRange = d3.range(12);

        var colorSetTwoDots = svgPanelForCrSetTwo.append("g")
        colorSetTwoDots.selectAll('rect') .data(colorSetTwoRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto")
        .style("fill", function(d,i){return colorSetTwo(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
        .style("stroke",function(d,i){  return colorSetTwo(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        var svgPanelForCrSetThree = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px") .style("margin-top","39px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetThree = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        var colorSetThreeRange = d3.range(12);

        var colorSetThreeDots = svgPanelForCrSetThree.append("g")
        colorSetThreeDots.selectAll('rect') .data(colorSetThreeRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto")
        .style("fill", function(d,i){return colorSetThree(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
        .style("stroke",function(d,i){  return colorSetThree(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        if(options.colorSet.toString().toLowerCase() === "one"){
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"1px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"1px solid #808080")
        }
        else 
        {
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }

        svgPanelForCrSetOne.on('click',function(d){
            options.colorSet = "one"
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")

            colours = "";
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);

            groupsForStackedHoriBarChart.style('fill', function (d, i) { return colours(i); })

            legendGroup.style("fill", function(d, i){ return colours(i);})
        
        })
        svgPanelForCrSetTwo.on('click',function(d){
            options.colorSet = "two"
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"1px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")

            colours = "";
            colours = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);

            groupsForStackedHoriBarChart.style('fill', function (d, i) { return colours(i); })
            legendGroup.style("fill", function(d, i){ return colours(i);})
        })
        svgPanelForCrSetThree.on('click',function(d){
            options.colorSet = "three"
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"1px solid #808080")

            colours = "";
            colours = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);

            groupsForStackedHoriBarChart.style('fill', function (d, i) { return colours(i); })
            legendGroup.style("fill", function(d, i){ return colours(i);})
        })

        //------------------ Settings panel DIV and everything inside it section ends here ------------------

        //----------- adding legend section -----------
        var divLegendPanelStackedHoriBarChart = targetElement .append('div')  .attr("class","divLegendPanelClassForStackedHoriBarChart") .style("background-color", options.BGcolor) .style('position',"absolute")
        //.style('width', 25 + "%") .style('height', 92 + "%") .style("left",75 + "%").style("top",8 + "%") 

        if ((showOrHideTableForStkHoriChart == false) && (showOrHideCommentsForStkHoriChart == true)){
            divLegendPanelStackedHoriBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
            svgPanelForStackedHoriBarChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
            .style("position","absolute").style("background-color", options.BGcolor);
        }
        else if ((showOrHideTableForStkHoriChart == true) && (showOrHideCommentsForStkHoriChart == false)){
            divLegendPanelStackedHoriBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
            svgPanelForStackedHoriBarChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute").style("background-color", options.BGcolor);
        }
        else if ((showOrHideTableForStkHoriChart == false) && (showOrHideCommentsForStkHoriChart == false)){
            divLegendPanelStackedHoriBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
            svgPanelForStackedHoriBarChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute").style("background-color", options.BGcolor);
        }

        // -------------- creating legend --------------
        
        var legendPanelSvgForStackedHoriBarChart = divLegendPanelStackedHoriBarChart .append('svg')  .attr("class","").style("background-color", options.BGcolor) .style('position',"absolute")
        .style('width', 100 + "%") .style('height', 100 + "%") .style("left",0 + "%").style("top",0 + "%")
        
        var legend = legendPanelSvgForStackedHoriBarChart.append("g") .attr("class", "legend") .attr("height", "100%") .attr("width", "100%")
        .attr('transform', 'translate(0,20)') 
        
        //Create colour squares
        var legendGroup = legend.selectAll('rect') .data(options.keys.stackedBars) .enter() .append("rect")
        .attr("x", 5) .attr("y", function(d, i){ return i * 16;}) .attr("width", 14) .attr("height", 14) .attr("rx",10) .attr("ry",10)
        .style("fill", function(d, i){ return colours(i);}) .style("cursor","auto")
      
        //Create text next to squares
        legend.selectAll('text') .data(options.keys.stackedBars) .enter() .append("text") .attr("x", 25) .attr("y", function(d, i){ return i * 16 + 11.6;})
        .attr("fill", "#00001c").text(function(d,i) {  if(d.length > 10)
            return d.substring(0,10)+'...';
        else
            return d;}) .style('font-size', '14px') .attr("fill","#00001c") .style("font-family","Verdana,sans-serif")
        //.text(function(d) { return d; })
        

        // Aligning Legend (vertically)
        var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelStackedHoriBarChart[0][0].style.width) / 100)
        var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelStackedHoriBarChart[0][0].style.height) / 100)

        var legendRectSize = 11;
        var legendSpacing = 4;
            
        legend.transition().duration(0).attr('transform', function(d, i) {
        var eachRectHeight = legendRectSize + legendSpacing;
        var offset =  eachRectHeight * colours.domain().length / 2;
        var horz = 5;
        var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.stackedBars.length))/2.0; // originally 2.0
            
            return 'translate(' + horz + ',' + vert + ')';
        })

        legendGroup.on('mouseover',function(d,i){
            
            if(options.keys.stackedBars.length > 1){ // to check if the stack set is more than 1
                if(xScale1GlobalVar == undefined){ // to check whether the widget is being resized or not (to save new xScale)
                    xScale1GlobalVar = xScale;
                }

                textOnStackedHoriBarChart.style('display','none')
                
                d3.select(groupsForStackedHoriBarChart[0][i]).selectAll('text').style('display','block')
                .transition().duration(1000).ease('bounce').attr("x", function(d,i) {return xScale1GlobalVar(d.x) + 5;  })
                .style("fill", "#00001c") .style("text-shadow","0px 0px 0px rgba(34,34,34,0.6)")
                .text(function(d){
           
                    if(d.x.toString().toString().indexOf('.') === -1)
                    {
                        return d.x.toString().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    //return format1(d.x)
                    }
                    else{
                        
                        return d.x.toString();
                    }
                //return format1(d.x);
                })
                
                groupsForStackedHoriBarChart.selectAll('rect').style('display','none')
                var g = d3.select(groupsForStackedHoriBarChart[0][i]).selectAll('rect').style('display','block')
                .transition().duration(1000).ease('bounce')
                .attr("x", function(d,i) {return 0; })
            }
        })

        legendGroup.on('mouseout',function(d,i){
            
            if(xScale1GlobalVar == undefined){
                xScale1GlobalVar = xScale;
            }

            textOnStackedHoriBarChart.style('display','block')

            d3.select(groupsForStackedHoriBarChart[0][i]).selectAll('text').style('display','block')
            .transition().duration(1000).ease('bounce').attr("x", function(d,i) {return (xScale1GlobalVar(d.x0)) + 2  })
            .style("fill", "#ffffff") .style("text-shadow","1px 0px 1px rgba(34,34,34,0.6)")
            .text(function(d){
                  if(d.x.toString().indexOf('.') === -1)
                  {
                    if(d.x.toString().length <= 3){
                        return d.x;
                    }
                    else{
                        return format1(d.x);
                    }
                  }
                  else{
                    return d.x;
                  }
            })
            
            groupsForStackedHoriBarChart.selectAll('rect').style('display','block')
            var g = d3.select(groupsForStackedHoriBarChart[0][i]).selectAll('rect').transition().duration(1000).ease('bounce')
            .attr("x", function(d,i) {return (xScale1GlobalVar(d.x0))  })
                
        })

        // Creating ToolTip for options button.
        var iconButtonTooltipForStackedHoriChart = targetElement.append('div').style('width','240px').attr("id","too")
        .style('height',"25px").style('position','absolute')//.style('margin-left', "0px").style('top','25px')
        .style("background-color",'#404040 ').style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid") // 004b9d
        .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none").attr("border", 0.0)

        filterBtnForStackedHoriBarChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var filterButtonTooltipText = "Filter";
            
            iconButtonTooltipForStackedHoriChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForStackedHoriChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')

        })
        filterBtnForStackedHoriBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForStackedHoriChart.style("display","none")
        })

        refreshBtnForStackedHoriBarChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var refreshButtonTooltipText = "Refresh";
            
            iconButtonTooltipForStackedHoriChart.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForStackedHoriChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ refreshButtonTooltipText +'</div>')

        })
        refreshBtnForStackedHoriBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForStackedHoriChart.style("display","none")
        })

        commentsBtnForStkHoriBarChart.on('mousemove', function(d,i) {
            commentsPanelDivForStkHoriChart.style('background-color','#fafafa')
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                if(options.showComments == false){
                    var commentButtonTooltipText = "Show Comments";
                }
                else if(options.showComments == true){
                    var commentButtonTooltipText = "Hide Comments";
                }
            
            iconButtonTooltipForStackedHoriChart.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForStackedHoriChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ commentButtonTooltipText +'</div>')
        })
        commentsBtnForStkHoriBarChart.on('mouseout', function(d,i) {
            commentsPanelDivForStkHoriChart.style('background-color','#ffffff')
            iconButtonTooltipForStackedHoriChart.style("display","none")
        })

        menuBtnForStackedHoriBarChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var menuButtonTooltipText = "Menu";
            
            iconButtonTooltipForStackedHoriChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForStackedHoriChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ menuButtonTooltipText +'</div>')

        })
        menuBtnForStackedHoriBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForStackedHoriChart.style("display","none")
        })

        tableButtonForStkHoriChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            if(showOrHideTableForStkHoriChart == false){
                var tableBtnTooltipText = "Show Table";
            }
            else if(showOrHideTableForStkHoriChart == true){
                var tableBtnTooltipText = "Hide Table";
            }
            
            iconButtonTooltipForStackedHoriChart.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForStackedHoriChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ tableBtnTooltipText +'</div>')

        })
        tableButtonForStkHoriChart.on('mouseout', function(d,i) {
            iconButtonTooltipForStackedHoriChart.style("display","none")
        })

        settingBtnForStkHoriChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var settingTooltipText = "Settings";
            
            iconButtonTooltipForStackedHoriChart.style("width","67px").style("margin-left", (m[0] - 77) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForStackedHoriChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; padding-left:12px; ">'+ settingTooltipText +'</div>')
        })
        settingBtnForStkHoriChart.on('mouseout', function(d,i) {
            iconButtonTooltipForStackedHoriChart.style("display","none")
        })
        
        downloadBtnForStkHoriChart.on('mousemove', function(d,i) {
              var root = targetElement
              var m = d3.mouse(root.node());
              m[0] += 0
              m[1] += 0
              var downloadButtonTooltipText = "Download";
              
              iconButtonTooltipForStackedHoriChart.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
              iconButtonTooltipForStackedHoriChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
        })
        downloadBtnForStkHoriChart.on('mouseout', function(d,i) {
              iconButtonTooltipForStackedHoriChart.style("display","none")
        })
        
        // ----------------- Filter panel and everything within it section begins here ----------------
        var filterPanelForStkHoriChart = targetElement.append('div').style('width',350 + "px") .attr("class","filterPanelForStkHoriChartClass" + targetElement[0][0].id)
        .style('position','absolute').style('margin-left', "0px")
        .style("background-color",'#fefefe').style("z-index",11).style("border-color", "#ffffff").style("border-right", "solid #e5e5e5 1px")  .style("border-style", "solid") // 004b9d
        .style("box-shadow", "2px 0px 1px #eff8ec").style("display","none").style("border-top", "solid #fdfdfd 1px").style("border-left","0px").style("border-bottom", "0px")
        .style('top', 0.0 + "%").style('height', 100 + "%").style('overflow-y',"hidden").style("overflow-x","hidden")
        .style("border-bottom", "solid #e5e5e5 1px") .style("box-sizing","border-box")

        var filterPanelForStkHoriChartTitle = filterPanelForStkHoriChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','20px').style('text-indent','5px').style("font-size", "14px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #007aff").style("width","350px").style("color","#000000")
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; top:25.0%; font-size:14px; font-family:inter; color:#00001c;">'+ "Filter" +'</div>')

        var measuresColumnTitle = filterPanelForStkHoriChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; text-indent:3px;">Available Measures</div>');

        var measuresVariables = filterPanelForStkHoriChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable1"+targetElement[0][0].id)
        .style("list-style-type","none")
        .style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '78px')
        .style('position','absolute')
        .style("width","155px").style("min-height","190px").style("max-height","190px").style("border", "#f0f0f0 1px solid")
        .style("max-width","155px").style("overflow-x","hidden").style("overflow-y","auto")
        measuresVariables.style("left",0.0 + "px").style("padding","2px")

        $( ".filterPanelForStkHoriChartClass" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });


        var measuresArray = [];
        var dimensionArray = [];
        
        var measuresArrayLength = [];
        var dimensionsArrayLength = [];

        dimensionArray.push(options.keys.label);
        //measuresArray = options.keys.stackedBars;
        for(var i = 0; i<divAndChartsArray.length; i++){
            if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    
                measuresArray = newtargetElementAndOptionsArray[i].options.keys.stackedBars;
            }
        }
        
        // filter process
        var uniqueMeasuresArrayKeys = [];
        $.each(measuresArray, function(i, el){
            if($.inArray(el, uniqueMeasuresArrayKeys) === -1){
                uniqueMeasuresArrayKeys.push(el);
            }
        });

        var uniqueDimensionArrayKeys = [];
        $.each(dimensionArray, function(i, el){
            if($.inArray(el, uniqueDimensionArrayKeys) === -1){
                uniqueDimensionArrayKeys.push(el);
            }
        });
        
        // setting lenght for arrays
        for(var i = 0; i<uniqueMeasuresArrayKeys.length; i++){
            measuresArrayLength.push(i);
        }

        for(var i = 0; i<uniqueDimensionArrayKeys.length; i++){
            dimensionsArrayLength.push(i);
        }

        var measuresVariables1 = measuresVariables.selectAll("li").data(measuresArrayLength).enter().append("li")
        .style("width","130px") .style("max-height","22px").style("cursor","move")
        .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#bcf1bc").style("font-weight","Normal")
        .style("list-style-type","none").style("border","1px #89e789 solid").style("color","#006600").style("font-family","Verdana,sans-serif")
        .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
        .text(function(d) {return uniqueMeasuresArrayKeys[d]})
        measuresVariables1.attr("class","MeasuresClass"+targetElement[0][0].id)
        
        var measuresColumnReceivedUI_TableTitle = filterPanelForStkHoriChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','180px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; ">Selected Measures</div>');

        var measuresColumnReceivedUI_Table = filterPanelForStkHoriChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable3"+targetElement[0][0].id)
        .style('background-color',"#ffffff").style('margin-left','180px').style('margin-top', '78px')
        .style("width","155px").style('position','absolute').style("padding","2px").style("min-height","190px")
        .style("border","1px #c1c1c1 dashed") .style("max-height","190px") .style("overflow-x","hidden") .style("overflow-y","auto")
        //.html('<div class=unsortable  style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:65.0%; font-size:14px; font-family:inter;  color:#99ea99; font-weight:Normal; text-align:center;">Drag and Drop Measures here from Available Measures List. </div>');
        .html('<img class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' src="images/dragIcon.png" style=" width:36px; height:36px; position:absolute; margin-left:65px; margin-top:60px; opacity:0.6"/>' 
        + '<div class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:60.0%; font-size:12px; font-family:inter;  color:#89d289; font-weight:Normal; text-align:center;">Drop Measures here. </div>');
        //.html('<div style="background-image: url(images/dragIcon.png); height: 64px; width: 64px; border: 1px solid black;"> </div>');

        var cancelButton = filterPanelForStkHoriChart.append("div") .style("width","23px").style("height","21px").style('position','absolute')
        .style('margin-left','320px').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
        .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.9; background-color:#fcfcff")
        cancelButton[0][0].appendChild(cancelBtnImgVar)

        cancelButton.on("click", function(){
            filterPanelForStkHoriChart.style("display","none")
        })

        var reRenderChartAndTableBtn = filterPanelForStkHoriChart.append("button").style("width","120px").style("height","25px").style('position','absolute')
        .style('margin-left','112px').style('margin-top','298px') .style("border-style", "none").style('background-color',"#2196f3")
        .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','15px').style("border-style", "solid").style('color','#ffffff')
        .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 1px #9b9b9b").style("border-radius","0px")
        var textForReRenderButton = document.createTextNode("Apply Changes");
        reRenderChartAndTableBtn[0][0].appendChild(textForReRenderButton)

        reRenderChartAndTableBtn.on("click", function(){

            if( $("#sortable3"+targetElement[0][0].id).children("li").length == 0 )
            {

                var alertPageDisabledDivForStkHoriChart =targetElement.append('div').style('width',100 + '%')
                .style('height',100 + "%").style('position','absolute').style('margin-left', '0px').style('top', '0px')
                .style("background-color",'#f3f3f3').style("z-index",99)//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("opacity",0.2).style("display","block")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")

                var alertDivForStkHoriChart = targetElement.append('div').style('width','350px')
                .style('height',"150px").style('position','absolute').style('left', ((targetElement[0][0].clientWidth/2) - 175) + "px").style('top', '1px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "solid").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","0px")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
                //.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Bold;">Sorry, no result found for selected' + 'range!'+ '</br>' + '<label style=text-indent:10px;> Hello</label' +'</div>')
                .html('<p  style="width: 340px; height:0%; background-color:#c7c7c7; position: absolute; top:40.0%; font-size:14px; font-family:inter; font-weight:Bold; margin-left:10px;  color:#f8f8f8; font-weight:Normal;">Check whether the Selected Measures box is not empty!</p>')

                var alertDivTitleForStkHoriChart = alertDivForStkHoriChart.append('div').style('width','340px')
                .style('height',"30px").style('position','absolute').style('margin-left', "0px").style('top', '0px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "none").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","2px")
                .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; font-weight:Bold; text-indent:5px;  color:#e5e5e5; font-weight:Normal;">TimeBound</div>')

                var stkHoriChartAlertOKButton = alertDivForStkHoriChart.append("button") .style("width","40px") .style("height","20px") .style('position','absolute') .style("box-shadow", "0px 1px 1px #B8B8B8") 
                .style('background-color',"#7cc15e") .style('margin-left','300px') .style('top', "120px").style("color","#ffffff")
                .style("display","block").style('padding-top',"0px").style("cursor","pointer").style("box-shadow", "1px 1px 1px #56973a") .style("border-style", "none")
                .style("font-family","Verdana,sans-serif").style("font-size","14px").style("text-align","center").style("vertical-align","middle").style("border-radius","0px")
                .style("z-index",999)
            
                var textForStkHoriChartAlertOKButton = document.createTextNode("OK");
                stkHoriChartAlertOKButton[0][0].appendChild(textForStkHoriChartAlertOKButton)

                $("#"+targetElement[0][0].id).resizable('disable');

                stkHoriChartAlertOKButton.on('click', function() {
                    alertDivForStkHoriChart.remove();
                    alertPageDisabledDivForStkHoriChart.remove()
                    $("#"+targetElement[0][0].id).resizable('enable');
                })

                filterBtnForStackedHoriBarChart.style("cursor","pointer")
                
                if(showOrHideTableForStkHoriChart == false){ 
                    svgPanelForStackedHoriBarChart.style('width', 75 + "%") .style('height', 85 + "%").style("position","absolute").style("background-color", options.BGcolor)
                    divLegendPanelStackedHoriBarChart.style('width', 25 + "%") .style('height', 85 + "%").style("position","absolute").style("background-color", options.BGcolor)
                }      
                else if(showOrHideTableForStkHoriChart == true){ 
                    svgPanelForStackedHoriBarChart.style('width', 75 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor)
                    divLegendPanelStackedHoriBarChart.style('width', 25 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color", options.BGcolor)
                } 

                resizedFuctionForStackedHoriChart();
            }

            else{

                var selectedStackMeasures = [];
                for(var i=0; i<$("#sortable3"+targetElement[0][0].id).children("li").length;i++){
                    selectedStackMeasures.push($("#sortable3"+targetElement[0][0].id).children("li")[i].textContent.toString())
                }
            
                var newOptions = {
                           data: options.data,
                           dataForDrillDown: options.dataForDrillDown,
                           dataForTable: options.dataForTable,
                           isDataDetailedForTable: options.isDataDetailedForTable,
                           keys: {
                               label: options.keys.label,//$("#sortable4"+targetElement[0][0].id).children("li")[0].textContent.toString(),
                               stackedBars: selectedStackMeasures,
                           },
                           chartTitle:options.chartTitle,
                           xAxisLable: "",
                           yAxisLable: options.keys.label,//$("#sortable4"+targetElement[0][0].id).children("li")[0].textContent,
                           //dimensions: options.dimensions,
                           //measures: options.measures,
                           showTitle: true,
                           colorSet: options.colorSet,
                           BGcolor:options.BGcolor,
                           drillDownColumnName:options.drillDownColumnName,
                           showTable: options.showTable,
                           showComments: options.showComments,
                           comments: options.comments,
                           resizeButtonID: options.resizeButtonID //document.getElementById("resizeBtn").id
                        }
                        
                        d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                        acinfotech.stackedHorizontalBarChart(targetElement,newOptions)
            }
        })

        var textBoxForMeasureColumnFrom;
        var textBoxForMeasureColumnTo;
        var selectTitleDivForEachDimension;

       
        $( "ul.droptrue"+targetElement[0][0].id ).sortable({
            appendTo: document.body,
            helper: "clone",
            connectWith: ".droptrue"+targetElement[0][0].id,
            scroll: false,
            cancel: '.unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+','+' .unMoveableIconAndTextClassDimensions'+targetElement[0][0].id,
            revertDuration: 10,
            scrollSensitivity: 10,
            scrollSpeed: 1,
            dynamic: true,

            receive: function(e, ui) { 
                 
                if (($(this)[0].id == "sortable3"+targetElement[0][0].id) || ($(this)[0].id == "sortable1"+targetElement[0][0].id)) {

                        if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                            if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                                 (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                            }
                            else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                                (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                            }

                        }
                } // if (($(this)[0].id == "sortable3") || ($(this)[0].id == "sortable1")) 

                else if (($(this)[0].id == "sortable2"+targetElement[0][0].id) || ($(this)[0].id == "sortable4"+targetElement[0][0].id)) {
                    if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                            //ui.sender.sortable("cancel");

                            if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                                 (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                            }
                            else if(  ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                                (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                            }
                        }
                } //if (($(this)[0].id == "sortable2") || ($(this)[0].id == "sortable4")) {

                $(ui.item).css({ 'position': 'relative' });

                if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                    ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                }
                 
                else if ($(this)[0].id == "sortable3"+targetElement[0][0].id) { // checking if the dropped element is in Measures drop area
                    
                    if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                        ui.sender.sortable("cancel");
                    }
                    else {
                        //ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                    }

                } // else if ($(this)[0].id == "sortable3") // checking if the dropped element is in Measures drop area ends here.

                else if ($(this)[0].id == "sortable4"+targetElement[0][0].id) { // checking if the dropped element is in Dimension drop area

                    if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                        ui.sender.sortable("cancel");
                    }
                    else {
                        ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                    }
                } //else if ($(this)[0].id == "sortable4")  // checking if the dropped element is in Dimension drop area ends here

                    if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                        
                        if ($(this)[0].id == "sortable1"+targetElement[0][0].id){
                            if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                            
                                if( ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                                    ui.sender.sortable("cancel");
                                } // if(  ui.sender.attr("id") === "sortable4")

                                else if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                                    ui.sender.sortable("cancel");
                                }
                            
                            } // if(ui.item.hasClass("DimesionsClass"))
                        }
                    if ($(this)[0].id == "sortable2"+targetElement[0][0].id){
                        if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                            
                            if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                                ui.sender.sortable("cancel");
                            }
                            else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                                ui.sender.sortable("cancel");
                               
                            }
                        }
                    }

                } //if ($(this)[0].id == "sortable1")

                if ($(this)[0].id == "sortable4"+targetElement[0][0].id){
                    if ($(this).children('li').length > 1 ){
                        ui.sender.sortable("cancel");
                        ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                    }    
                }

            }, //receive ends here

            start:function(ev, ui) {
                
            },
            stop:function(ev, ui) {
               
            },
        });
      
        /* ----------------- Filter panel and everything within it section ends here -----------------*/
        
        // // Filter
        filterBtnForStackedHoriBarChart.on('click', function() {

            filterPanelForStkHoriChart.style("display","block");

            ismenuBtnOfStkHoriChartClicked = false;
            optsBtnPanelForStkHorichart.style("display","none");

            stgPanDivForStkHoriChart.style("display","none");

            if ((showOrHideTableForStkHoriChart == false) && (showOrHideCommentsForStkHoriChart == true)){
                divLegendPanelStackedHoriBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                svgPanelForStackedHoriBarChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForStkHoriChart == true) && (showOrHideCommentsForStkHoriChart == false)){
                divLegendPanelStackedHoriBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                svgPanelForStackedHoriBarChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForStkHoriChart == false) && (showOrHideCommentsForStkHoriChart == false)){
                divLegendPanelStackedHoriBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                svgPanelForStackedHoriBarChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color", options.BGcolor);
            }

            resizedFuctionForStackedHoriChart();
        })

        // Refreshing Chart and Table
        refreshBtnForStackedHoriBarChart.on('click', function() {
            for(var i = 0; i<divAndChartsArray.length; i++){
				if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData;
                    options.keys.stackedBars = newtargetElementAndOptionsArray[i].options.keys.stackedBars;
                }
            }
			
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,button').remove();
            acinfotech.stackedHorizontalBarChart(targetElement,options) 

        })
    
        // showing/hidding chart comments 
        commentsBtnForStkHoriBarChart.on('click', function() {

            if(options.showComments == false){ 
                options.showComments = true;
            }
            else if(options.showComments == true){ 
                options.showComments = false;
            }

            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                    options.showTable = false;
                }
            }
            acinfotech.stackedHorizontalBarChart(targetElement,options)

        })

        // showing/hidding chart table
        tableButtonForStkHoriChart.on('click', function() {

            if(showOrHideTableForStkHoriChart == false){
                options.showTable = true;
                //showOrHideTableForPieChart = true
            }
            else if(showOrHideTableForStkHoriChart == true){
                //showOrHideTableForPieChart = false
                options.showTable = false;
            }

            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                    options.showComments = false;
                }
            }
            acinfotech.stackedHorizontalBarChart(targetElement,options)

        })

        settingBtnForStkHoriChart.on('click', function() {
                
            ismenuBtnOfStkHoriChartClicked = false; // Menu toggle button variable
            optsBtnPanelForStkHorichart.style("display","none") // To hide options button panel

            iconButtonTooltipForStackedHoriChart.style("display","none") // Removing options button ToolTip
            settingBtnForStkHoriChart.style("cursor","pointer")
            
            stgPanDivForStkHoriChart.style("display","block") // Showing settings panel

            svgPanelForStackedHoriBarChart.style('width', 75 + "%") .style('height', 52 + "%").style("position","absolute"); // Decreasing chart panel
            divLegendPanelStackedHoriBarChart.style('width', 25 + "%") .style('height', 52 + "%").style("position","absolute"); // Decreasing chart panel

            resizedFuctionForStackedHoriChart(); // Calling resize function()

        })
        
        downloadBtnForStkHoriChart.on('click', function() {
                                  
              ismenuBtnOfStkHoriChartClicked = false; // Changing menu button value to false
              optsBtnPanelForStkHorichart.style("display","none") // Hiding option buttons panel
              
        })
        
        var dataArray = [];
        
        options.data.forEach(function(d, i) {
            var temp = {};
            for (i = 0; i < options.keys.stackedBars.length; i++) {
                
                for (j = 0; j < Object.keys(d).length; j++) {
                     
                    if(options.keys.stackedBars[i] === Object.keys(d)[j]){
                        temp[Object.keys(d)[j]] = d[Object.keys(d)[j]]
                    }
                 }
            }
            
            dataArray.push(temp)
        });

        var finalArray = [];
        options.data.forEach(function(d, i) {
    
            var finalArrayTemp = {};
            finalArrayTemp[options.keys.label] = d[options.keys.label]
            finalArrayTemp["data"] = dataArray[i];
            finalArray.push(finalArrayTemp)
        })
        
        var finalArrayNew = [];
        options.keys.stackedBars.forEach(function(d, i) {
    
            var temp1 = {};
            temp1["name"] = options.keys.stackedBars[i]
    
            finalArrayNew.push(temp1)
        })
        
        var finalNewNewArray = [];
        var dataArray1 = [];
        finalArrayNew.forEach(function(d, i) {
    
            var temp1 = {};
            temp1["name"] = options.keys.stackedBars[i]
    
            for (j = 0; j < options.data.length; j++) {
                
                var tempTemp = {};
                tempTemp["label"] = options.data[j][options.keys.label];
                tempTemp["value"] = +options.data[j][options.keys.stackedBars[i]];

                dataArray1.push(tempTemp)
                
            }
                temp1["data"] = dataArray1;
                dataArray1 = []
                finalNewNewArray.push(temp1)
        })
        
        var margins = {
            top: 12,
            left: 48,
            right: 24,
            bottom: 24
        },
        
        width = (svgPanelForStackedHoriBarChart.node().getBoundingClientRect().width) - margin.left - margin.right,
        height = (svgPanelForStackedHoriBarChart.node().getBoundingClientRect().height) - margin.top - margin.bottom
   
        dataset = finalNewNewArray,
        series = dataset.map(function (d) {
            return d.name;
        }),
        dataset = dataset.map(function (d) {
            return d.data.map(function (o, i) {
            
                return {
                    y: o.value,
                    x: o.label
                };
            });
        }),
        stack = d3.layout.stack();

        stack(dataset);

        var dataset = dataset.map(function (group) {
        return group.map(function (d) {
            // Invert the x and y values, and y0 becomes x0
            return {
                    x: +d.y,
                    y: d.x,
                    x0: +d.y0
                };
            });
        }),
        svgForStackedHoriBarChart = svgPanelForStackedHoriBarChart //svgForStackedHoriBarChart is svg group
        .append('svg').append('g') .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'),
        xMax = d3.max(dataset, function (group) { return d3.max(group, function (d) { return (+d.x) + (+d.x0); });
        }),
        xScale = d3.scale.linear() .domain([0, xMax]) .range([0, width]),
        months = dataset[0].map(function (d) { return d.y; }),
    
        yScale = d3.scale.ordinal() .domain(months) .rangeRoundBands([0, height], .20), // 18

        xAxis = d3.svg.axis().scale(xScale) .orient('bottom'),
        yAxis = d3.svg.axis().scale(yScale) .orient('left'),
    
        groupsForStackedHoriBarChart = svgForStackedHoriBarChart.selectAll('g') .data(dataset) .enter() .append('g') //.style("fill-opacity",0.99)
        .style('fill', function (d, i) { return colours(i); }),
        //---------------------

        rectsForStackedHoriBarChart = groupsForStackedHoriBarChart.selectAll('rect') .data(function (d) { return d; }).enter().append('rect')
		
		groupsForStackedHoriBarChart.selectAll('rect') 
		.attr('x', function (d) { return 0; })
		.attr('y', function (d, i) { return yScale(d.y); })
		.attr("width", 0).transition().delay(400).duration(800)
		.attr('x', function (d) { return xScale(d.x0); })
		.attr('width', function (d) { return xScale(d.x); })
		.attr('height', function (d) { return yScale.rangeBand(); })
		.style("cursor","auto")
        
        if(options.dataForDrillDown.length == 0){
            var columnNames = d3.keys(options.data[0])
            var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
            
            for(var i = 0; i < columnNames.length ; i++){
                for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                    if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                        for(var k = 0; k < options.keys.stackedBars.length; k++){
                            var len = d3.select(groupsForStackedHoriBarChart[0][k]).selectAll('rect')
                            for(var l = 0; l < len[0].length; l++){
                                d3.select(len[0][l]).attr('data-drilldownkey', function(d,index){
                                    return JSON.stringify(options.data[l]).slice(1, -1).split('"').join("").split(':').join("|")
                                })
                            }
                        }
                    }
                    else {
                    }
                }
            }
        }
        else if(options.dataForDrillDown.length > 0){
            
            options.keys.stackedBars.forEach(function(measures, i) { 
                 var bars = d3.select(groupsForStackedHoriBarChart[0][i]).selectAll('rect')
                 bars[0].forEach(function(d, index) { 
                     var dd = d3.select(d)[0]
                     options.dataForDrillDown.forEach(function(val, i) { 
                        var key, keys = Object.keys(val), n = keys.length, newObj={}
                        while (n--) { key = keys[n]; newObj[key.toLowerCase()] = val[key];  
                            var optKeysLabVal = options.keys.label.toString().toLowerCase(); }
                            if(dd[0].__data__.y.toString().toLowerCase() === newObj[optKeysLabVal].toString().toLowerCase()){
								//if(dd[0].__data__.x == val[measures]){
								
								if(dd[0].__data__.x == newObj[measures.toLowerCase()]){ 
							
									d3.select(dd[0]).attr('data-drilldownkey', function(d,index){
										return JSON.stringify(val).slice(1, -1).split('"').join("").split(':').join("|")
									})
                                }
                            }
                    })
                })
            })
        }
        
        /*else if(options.dataForDrillDown.length > 0){
            
            options.keys.stackedBars.forEach(function(measures, i) {
                                             
                                             var bars = d3.select(groupsForStackedHoriBarChart[0][i]).selectAll('rect')
                                             bars[0].forEach(function(d, index) {
                                                             
                                                            var dd = d3.select(d)[0]
                                                             options.dataForDrillDown.forEach(function(val, i) {
                                                                    var key, keys = Object.keys(val), n = keys.length, newObj={}
                                                                    while (n--) { key = keys[n]; newObj[key.toLowerCase()] = val[key]; }
                                                                    var optKeysLabVal = options.keys.label.toString().toLowerCase();
                                                                    if(dd[0].__data__.y.toString().toLowerCase() === val[optKeysLabVal].toString().toLowerCase()){
                                                                    //if(dd[0].__data__.x == val[measures]){
                                                                    if(dd[0].__data__.x == newObj[measures.toLowerCase()]){
                                                                        d3.select(dd[0]).attr('data-drilldownkey', function(d,index){
                                                                                              return JSON.stringify(val).slice(1, -1).split('"').join("").split(':').join("|")
                                                                        })
                                                                    }
                                                                }
                                                            })
                                            })
                        })
        }*/
        
        var yTextPadding = 10;
        var format1 = d3.format('.3s')
        var textOnStackedHoriBarChart = groupsForStackedHoriBarChart.selectAll(".text")
        .data(function (d) { return d; })

        textOnStackedHoriBarChart.enter() .append("text").attr("class","text series_value");

        textOnStackedHoriBarChart.style("text-anchor", "start") .style("font-family", "Verdana,sans-serif")  .style("font-size", "12px").attr("class","series_value").style("display",options.series)
		.style("fill", "#ffffff") .style("text-shadow","1px 0px 1px rgba(34,34,34,0.6)")
		.attr("x",0).transition().delay(400).duration(800)
        .attr("x", function(d,i) {return (xScale(d.x0)) + 2  })
		.attr("y", function(d) { return ((yScale(d.y) + (yScale.rangeBand()/2))) + 4 })
        .text(function(d){
           if(d.x.toString().indexOf('.') === -1)
              {
                if(d.x.toString().length <= 3){
                    return d.x;
                }
                else{
                    return format1(d.x);
                }
              }
              else{
                return d.x;
              }
        })

        svgForStackedHoriBarChart.append('g') .attr("class", "x axis") .attr('transform', 'translate(0,' + height + ')')
        //.call(xAxis);

        svgForStackedHoriBarChart.append('g') .attr("class", "y axis") .call(yAxis)

        .selectAll("text") .style('fill','#00001c') .style("font-weight","normal") .style("font-family","Verdana,sans-serif") .style("font-size","12px")
        .text(function(d,i) {
            if(d.length >10)
                return d.substring(0,10)+'...';
            else
                return d;
        })

        // Add the text label for the Y axis
        var yAxisVariable = svgForStackedHoriBarChart.append("text") .attr("transform", "rotate(-90)") .attr("y", -115) .attr("x",0 - (height / 2.0)) .attr("dy", "1em") .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif")
        .style("font-size","12px") .text(options.yAxisLable) .style('fill','#00001c') .style("text-transform","capitalize") .style("font-weight","Bold")
        .style("font-style","normal")

        //Creating tooltip----
        var tooltipForStackedHoriChart = targetElement .append('div') .attr('class', 'tooltipPie') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
        .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
        .style("padding-right", "7px") .style("background", "#F8F8F8") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style("z-index",1000)
        .style("border", "1.0px") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","60px")
        //tooltipForStackedHoriChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'label').style("color","#000000") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "12px") .style("font-weight", "Bold");
        tooltipForStackedHoriChart.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
        tooltipForStackedHoriChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");

        rectsForStackedHoriBarChart.on('mousemove', function (d,i){
               
                var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                
                var valueForStkHoriChartToolTip;
                if(d.x.toString().toString().indexOf('.') === -1)
                {
                    valueForStkHoriChartToolTip = d.x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
                else{
                        
                    valueForStkHoriChartToolTip = d.x.toString();
                }

                //tooltipForStackedHoriChart.select('.label').html(options.keys.label + " : " + d.y)
                //tooltipForStackedHoriChart.select('.count').html(d.x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
                tooltipForStackedHoriChart.select('.count').html(valueForStkHoriChartToolTip)
                tooltipForStackedHoriChart.style('visibility', 'visible')
                tooltipForStackedHoriChart.select('hr').style("background-color", d3.select(this).style("fill") )
                tooltipForStackedHoriChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-10) + "px").style("display","block")

        })
        .on('mouseout', function(){
                    
                tooltipForStackedHoriChart.style("display","none")
        })

        textOnStackedHoriBarChart.on('mousemove', function (d,i){
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                
                //tooltipForStackedHoriChart.select('.label').html(options.keys.label + " : " + d.y)
                tooltipForStackedHoriChart.select('.count').html(d.x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
                tooltipForStackedHoriChart.style('visibility', 'visible')
                //tooltipForStackedHoriChart.select('hr').style("background-color", d3.select(this).style("fill") )
                tooltipForStackedHoriChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-10) + "px").style("display","block")
        })
        .on('mouseout', function(){
                    
                tooltipForStackedHoriChart.style("display","none")
        })

        // ----------------------- Adding Table  ------------------
        var tablePanelForStackedHoriChart =  targetElement.append("div") .attr("id",targetElement[0][0].id + "holderForStackedHoriChartTableID")
        .attr("class","scrollingDivForTable-Class tableDivForStackedHoriChart" + targetElement[0][0].id) .style('background-color',"#ffffff") .style('position','absolute')
        .style("display","block") .style("overflow","hidden") .style("width", function(d) {  return 100.0 + "%"; })
        .style("height", function(d) { return 40 + "%"; }) .style("left",0 + "%").style("z-index",10)

        $( '.tableDivForStackedHoriChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        if(options.showTitle == true ){
            tablePanelForStackedHoriChart.style("top",60.0  + "%")
        }
        else if(options.showTitle == false  ){
            tablePanelForStackedHoriChart.style("top",60.0  + "%")
            
        }
        tablePanelForStackedHoriChart.html('<table class = "tableClassForStkHoriBarChart' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                           '<thead class = "theadClassForStkHoriBarChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForStkHoriBarChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                                           '<tbody class = "tBodyClassForStkHoriBarChart' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                           '</table>'
                                           )
        
        tablePanelForStackedHoriChart.select('table').attr("id",targetElement[0][0].id + "tableID")

        // Show or Hide Table scroll bar when mouseover on widget
        targetElement.on('mouseover',function(){ tablePanelForStackedHoriChart.style("overflow","auto") })
        targetElement.on('mouseout',function(d){ tablePanelForStackedHoriChart.style("overflow","hidden") })
        
        var tableDataForStkHoriBarChart = [];
        if(options.dataForTable.length > 0){
            tableDataForStkHoriBarChart = options.dataForTable;
        }
        else {
            tableDataForStkHoriBarChart = options.data;
        }
        
        var thead = tablePanelForStackedHoriChart.select("thead").selectAll("th") .data(d3.keys(tableDataForStkHoriBarChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff") //f4f4f4
        .style("position","relative")
        
        var thead1 = d3.select(".thead1ClassForStkHoriBarChart" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tableDataForStkHoriBarChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff") //f4f4f4
        .style("position","relative")
        
        var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
        .attr("id", "ascendingIconIDForStackedHoriChart") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
        
        var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
        .attr("id", "descendingIconIDForStackedHoriChart") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
        
        var tr = tablePanelForStackedHoriChart.select("tbody").selectAll("tr") .data(tableDataForStkHoriBarChart).enter().append("tr")
        .attr("id", function(d,i) { return "slice" + i })
        
        // cells
        var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d})
        .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
        
        
        var $table = $('.tableClassForStkHoriBarChart' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
        
        d3.select(".theadClassForStkHoriBarChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
            d.forEach(function(dd,j){
                colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
            })
        })
        
        $(".thead1ClassForStkHoriBarChart" + targetElement[0][0].id).insertAfter('.tBodyClassForStkHoriBarChart' + targetElement[0][0].id)
        
        $(".thead1ClassForStkHoriBarChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForStackedHoriChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
        
        tablePanelForStackedHoriChart.select(".thead1ClassForStkHoriBarChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
        })
        
        $('.tableDivForStackedHoriChart' + targetElement[0][0].id).scroll(function () {
                                                                   
            $(".thead1ClassForStkHoriBarChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForStackedHoriChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
                                                                   
        })
        
        var sortOrder = false;
        thead1.on("click",function(k,index){
                 
                 sortOrder = !sortOrder;
                 
                 tablePanelForStackedHoriChart.select(".thead1ClassForStkHoriBarChart" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                                                              
                        if (sortOrder) {
                                          
                            if(i == index){
                                d3.select(this).select('svg').select('#descendingIconIDForStackedHoriChart').style("visibility", "hidden")
                                d3.select(this).select('svg').select('#ascendingIconIDForStackedHoriChart').style("visibility", "visible")
                            }
                            else {
                                d3.select(this).select('svg').select('#descendingIconIDForStackedHoriChart').style("visibility", "visible")
                                d3.select(this).select('svg').select('#ascendingIconIDForStackedHoriChart').style("visibility", "visible")
                            }
                        }
                        else{
                                          
                            if(i == index){
                                d3.select(this).select('svg').select('#descendingIconIDForStackedHoriChart').style("visibility", "visible")
                                d3.select(this).select('svg').select('#ascendingIconIDForStackedHoriChart').style("visibility", "hidden")
                            }
                            else {
                                d3.select(this).select('svg').select('#descendingIconIDForStackedHoriChart').style("visibility", "visible")
                                d3.select(this).select('svg').select('#ascendingIconIDForStackedHoriChart').style("visibility", "visible")
                            }
                        }
                })
                 
                  var monthTruOrFalAryForStkHoriBarChart = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
                  
                  tr.sort(function(a, b) {
                          
                          if (sortOrder) {
                          var monthsArrayForStkHoriBarChart = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                          } else {
                          var monthsArrayForStkHoriBarChart = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                          }
                          
                          monthTruOrFalAryForStkBarChart = []; gotMonthArray = [];
                          tableDataForStkHoriBarChart.forEach(function(d,i){
                                 var da = d[k].toString().substring(0,3).toLowerCase()
                                 if(monthsArrayForStkHoriBarChart.indexOf(da) >= 0){
                                     monthTruOrFalAryForStkHoriBarChart.push(true)
                                     gotMonthArray.push(da);
                                 }
                                 else {
                                     monthTruOrFalAryForStkHoriBarChart.push(false)
                                 }
                          })
                          
                          if(monthTruOrFalAryForStkHoriBarChart.indexOf(false) == -1){ // true
                          
                          monthArray = []; monthArrayCount = [];
                          gotMonthArray.forEach(function(dd,j){
                                var index1 = monthsArrayForStkHoriBarChart.indexOf(dd.substring(0,3))
                                if(monthArrayCount.indexOf(index1) >= 0){
                                    index1 = 12 + index1;
                                }
                                monthArray.push(index1);
                                monthArrayCount.push(index1)
                          })
                          returnArray = []
                          monthArray.sort(function(aa, bb) {
                              returnArray.push(+aa - +bb)
                              return +aa - +bb;
                          })
                          
                          sortTableFunc()
                          return returnArray[ind++];
                          } //  if true (if jan feb if block)
                          else {
                          var data = +a[k];
                          
                          if(!isNaN(data)){
                          
                          if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                          else { return d3.descending(+a[k], +b[k]); }
                          }
                          else if(!isNaN(Date.parse(a[k]))){
                          
                          if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                          else { return new Date(b[k]) - new Date(a[k]) }
                          }
                          else {
                          
                          if (sortOrder) { return d3.ascending(a[k], b[k]); }
                          else { return d3.descending(a[k], b[k]); }
                          }
                          } // if not jan feb else block
                    }); // tr

                })
        
        function sortTableFunc(){
            
            var table = tablePanelForStackedHoriChart.select('table');
            var rows = table.selectAll('tr').data(tableDataForStkHoriBarChart);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0).style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500)
            .style('opacity', 1.0).style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
        }
        
        // Main Table Styling
        tablePanelForStackedHoriChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
        .style("color","#00001c")
        .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4") //.style("box-shadow","10px 10px 50px #007aff").style("z-index",9999)
        tablePanelForStackedHoriChart.selectAll('td').style("height","25px") .style("border", "1px solid #dddddd") .style("font-size","12px").style("font-weight","Normal").style("color","#00001c")

        //additionally 
        tablePanelForStackedHoriChart.selectAll('th').style('background-color',"#ffffff").style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
        tablePanelForStackedHoriChart.selectAll('td').style('background-color',"#ffffff").style("border-style","none").style("color","#00001c").style("color","#00001c")

        //b1da9f
        tablePanelForStackedHoriChart.selectAll('table') . style("border-collapse","collapse")
        tablePanelForStackedHoriChart.selectAll('table tr:first-child th').style("border-top","0px")
        tablePanelForStackedHoriChart.selectAll('table tr:last-child td').style("border-bottom","0px")
        tablePanelForStackedHoriChart.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
        tablePanelForStackedHoriChart.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")

        if(showOrHideTableForStkHoriChart == false){
            tablePanelForStackedHoriChart.style("display","none")
        }
        else if(showOrHideTableForStkHoriChart == true){
            tablePanelForStackedHoriChart.style("display","block")
        }

        if(options.isDataDetailedForTable == false){
        
            var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
        
            // Adding underlines for selected drill-down column text
            var drillDownSectionsForStackedChart = tablePanelForStackedHoriChart.select('table').selectAll('th')
        
            var foundResult = [];
            for(var i = 0; i<drillDownSectionsForStackedChart[0].length; i++){
            
                for(var j = 0; j<drillDownColumnNamesArray.length; j++){
                    if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForStackedChart[0][i].__data__.toString().toLowerCase() ){
                        foundResult.push(i)
                    }
                }
            }
        
            var r = tablePanelForStackedHoriChart.select('table').selectAll('tr').selectAll('td')
            for(var i = 0; i<r.length; i++){
                for(var j = 0; j < foundResult.length; j++){
                    var row = r[i][foundResult[j]]
                    $(row).css("text-decoration", "underline")
                }
            }
        }
        
        //By default calling the resized function first time (to align table's th and td).
        setTimeout(function(){ resizedFuctionForStackedHoriChart() },1000)
        
        window.addEventListener('resize', function(event){ resizedFuctionForStackedHoriChart() });
        
        var xScale1GlobalVar;
        var sampleIDForStackedHoriBarChart=targetElement[0];
        
        $(function() {
          
          $("#" + sampleIDForStackedHoriBarChart[0].id).resizable({
                                             
                resize: function(event, ui) {
                    //divWidthForHoriChart = ui.size.width;
                    //divHeightForHoriChart = ui.size.height;
                    resizedFuctionForStackedHoriChart();
                }
            });
          });
        
        function resizedFuctionForStackedHoriChart()
        {
            if((svgPanelForStackedHoriBarChart.node().getBoundingClientRect().width) && (svgPanelForStackedHoriBarChart.node().getBoundingClientRect().height) > 0){

                if(showOrHideCommentsBtnForStkHoriChart == true){
                    filterBtnForStackedHoriBarChart.style('margin-left', "2px")
                    refreshBtnForStackedHoriBarChart.style('margin-left', "2px")
                    commentsBtnForStkHoriBarChart.style('margin-left', "2px")
                    menuBtnForStackedHoriBarChart.style('right', '0')
                }
                else if(showOrHideCommentsBtnForStkHoriChart == false){
                    filterBtnForStackedHoriBarChart.style('margin-left', "2px")
                    refreshBtnForStackedHoriBarChart.style('margin-left', "2px")
                    //commentsBtnForStkHoriBarChart.style('right', '0')
                    commentsBtnForStkHoriBarChart.style('display','none')
                    menuBtnForStackedHoriBarChart.style('right', '0')
                }
                optsBtnPanelForStkHorichart.style('right', '0')

                stgPanCanBtnForStkHoriChart.style('right', '0')

                var margin1 = {top: 10 , right: 20, bottom: 20, left: 130}, //originally top: 42, left: 80
                width1 = (svgPanelForStackedHoriBarChart.node().getBoundingClientRect().width) - margin1.left - margin1.right,
                height1 = (svgPanelForStackedHoriBarChart.node().getBoundingClientRect().height) - margin1.top - margin1.bottom;
                // width1 = ($('#svgPanelIDForStackedHoriBarChart' + targetElement[0][0].id)[0].getBoundingClientRect().width) - margin1.left - margin1.right,
                // height1 = ($('#svgPanelIDForStackedHoriBarChart' + targetElement[0][0].id)[0].getBoundingClientRect().height) - margin1.top - margin1.bottom;

                var xMax1 = d3.max(dataset, function (group) {
                    return d3.max(group, function (d) {
                        return (+d.x) + (+d.x0);
                    });
                })
                var xScale1 = d3.scale.linear() .domain([0, xMax1])
                .range([0, width1]),
                    months = dataset[0].map(function (d) {
                        return d.y;
                })
                xScale1GlobalVar = xScale1;
                var yScale1 = d3.scale.ordinal() .domain(months) .rangeRoundBands([0, height1], .20) // 18

                yAxis.scale(yScale1) .orient("left") .ticks(14);

                var svg1 = svgForStackedHoriBarChart;

                svg1.select("svg")
                //.attr("width", width1 + margin1.left + margin1.right)
                //.attr("height", height1 + margin1.top + margin1.bottom);

                svg1.select(".y.axis") .call(yAxis)
                .selectAll("text") .style('fill','#00001c') .style("font-weight","normal") .style("font-family","Verdana,sans-serif")
                .text(function(d,i) {
                    if(d.length > 9)
                        return d.substring(0,9)+'...';
                    else
                        return d;
                })

                yAxisVariable.attr("transform", "rotate(-90)") .attr("y", -115) .attr("x",0 - (height1 / 2.0)) .attr("dy", "1em")

                rectsForStackedHoriBarChart.attr('x', function (d) { return xScale1(d.x0); })
                .attr('y', function (d, i) { return yScale1(d.y); })
                .attr('height', function (d) { return yScale1.rangeBand(); }) .attr('width', function (d) { return xScale1(d.x); })

                textOnStackedHoriBarChart
                //.attr("x", function(d,i) { return (xScale1(d.x) + (xScale1(d.x0))) - 2  })
                .attr("x", function(d,i) { return (xScale1(d.x0)) + 2  })
                .attr("y", function(d) { return ((yScale1(d.y) + (yScale1.rangeBand()/2))) + 4 })
                
                // Aligning Legend (vertically)
                var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelStackedHoriBarChart[0][0].style.width) / 100)
                var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelStackedHoriBarChart[0][0].style.height) / 100)

                var legendRectSize = 11;
                var legendSpacing = 4;
                
                legend.attr('transform', function(d, i) {
                var eachRectHeight = legendRectSize + legendSpacing;
                var offset =  eachRectHeight * colours.domain().length / 2;
                var horz = 5;
                var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.stackedBars.length))/2.0; // originally 2.0
                
                    return 'translate(' + horz + ',' + vert + ')';
                })
                
                colWidth = []; 
				
                d3.select(".theadClassForStkHoriBarChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                        d.forEach(function(dd,j){
                            colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                        })
                })
                tablePanelForStackedHoriChart.select(".thead1ClassForStkHoriBarChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                        d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
                })
                
            }// checking svg panel widht & height greater than zero function
        } // resize function()
    }, //stackedHorizontalBarChart

    // ************************************************** Stacked Bar Chart  **************************************************
    stackedBarChart: function(targetElement, options){
        
        isChartCalled++;

        var chartName = "STACKEDBARCHART";
       
        acinfotech.allCharts(targetElement,options,chartName)

        targetElement.style("min-width", "350px").style("min-height", "350px").style("background-color",options.BGcolor)

        var showOrHideTableForStkBarChart;
        var showOrHideCommentsForStkBarChart;
        var showOrHideCommentsBtnForStkBarChart = true;

        if((options.showTable == false) || (options.showTable == true)){
            showOrHideTableForStkBarChart = options.showTable    
        }
        else{
            showOrHideTableForStkBarChart = false;
        }

        // Show or Hide comments
        if (options.showComments == true || false) {
            showOrHideCommentsForStkBarChart = options.showComments;
        }
        else {
            showOrHideCommentsForStkBarChart = false;
        }
        
        if (options.comments.length == 0){ 
            showOrHideCommentsForStkBarChart = false;
            showOrHideCommentsBtnForStkBarChart = false;
        }

        if ((showOrHideTableForStkBarChart == true) && (showOrHideCommentsForStkBarChart == true)){
            showOrHideTableForStkBarChart = true;
            showOrHideCommentsForStkBarChart = false;
        }
        else if ((showOrHideTableForStkBarChart == false) && (showOrHideCommentsForStkBarChart == false)){
            showOrHideTableForStkBarChart = false;
            showOrHideCommentsForStkBarChart = false;
        }

        var chartTitlePanelForStackedBarChart =  targetElement.append("div") .style("background-color",options.BGcolor) .style("position","absolute").style('background-color',"#ffffff")
        .style("text-indent","6px")
        
		var optsBtnPanelForStkBarchart = targetElement.append('div').style('width',"25px").style('height',"160px").style('position','absolute')
        .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px")
        .style('right', '0')
        .style("min-width","25px")
        .style("border-style","none").style("border-left", "solid #fcfcfc  1px")
		
        var filterBtnForStackedBarChart = optsBtnPanelForStkBarchart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','80px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var filterBtnImgVar = document.createElement("IMG");
        filterBtnImgVar.src = "images/filterIcon.png";
        filterBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        filterBtnForStackedBarChart[0][0].appendChild(filterBtnImgVar)

        var refreshBtnForStackedBarChart = optsBtnPanelForStkBarchart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','105px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var refreshBtnImgVar = document.createElement("IMG");
        refreshBtnImgVar.src = "images/refreshIcon.png";
        refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        refreshBtnForStackedBarChart[0][0].appendChild(refreshBtnImgVar)

        var commentsBtnForStkBarChart = optsBtnPanelForStkBarchart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','130px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var commentsBtnImgVariable = document.createElement("IMG");
        if(options.showComments == false){
            commentsBtnImgVariable.src = "images/showCommentsIcon.png";
        }
        else if(options.showComments == true){
            commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
        }
        commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        commentsBtnForStkBarChart[0][0].appendChild(commentsBtnImgVariable)

        var menuBtnForStackedBarChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','1px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var menuBtnImgVar = document.createElement("IMG");
        menuBtnImgVar.src = "images/menuIcon.png";
        menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
        menuBtnForStackedBarChart[0][0].appendChild(menuBtnImgVar)

        if(showOrHideCommentsBtnForStkBarChart == true){
            filterBtnForStackedBarChart.style('margin-left', "2px")
            refreshBtnForStackedBarChart.style('margin-left', "2px")
            commentsBtnForStkBarChart.style('margin-left', "2px")
            menuBtnForStackedBarChart.style('right', '0')
        }
        else if(showOrHideCommentsBtnForStkBarChart == false){
            filterBtnForStackedBarChart.style('margin-left', "2px")
            refreshBtnForStackedBarChart.style('margin-left', "2px")
            //commentsBtnForStkBarChart.style('right', '0')
            commentsBtnForStkBarChart.style('display','none')
            menuBtnForStackedBarChart.style('right', '0')
        }

        var ismenuBtnOfStkBarChartClicked = false;
        menuBtnForStackedBarChart.on('click', function() {

            filterPanelForStkBarChart.style("display","none");

            stgPanDivForStkBarChart.style("display","none") // Hiding setting panel

            if ((showOrHideTableForStkBarChart == false) && (showOrHideCommentsForStkBarChart == true)){
                    divLegendPanelStackedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForStackedBarChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                    .style("position","absolute");
            }
            else if ((showOrHideTableForStkBarChart == true) && (showOrHideCommentsForStkBarChart == false)){
                    divLegendPanelStackedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForStackedBarChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute");
            }
            else if ((showOrHideTableForStkBarChart == false) && (showOrHideCommentsForStkBarChart == false)){
                    divLegendPanelStackedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForStackedBarChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute");
            }


            if(ismenuBtnOfStkBarChartClicked == false){
                ismenuBtnOfStkBarChartClicked = true;
                optsBtnPanelForStkBarchart.style("display","block")

            }
            else if(ismenuBtnOfStkBarChartClicked == true){
                ismenuBtnOfStkBarChartClicked = false
                optsBtnPanelForStkBarchart.style("display","none")
            }

            resizedFuctionForStackedBarChart();
        })

        var tableButtonForStkBarChart = optsBtnPanelForStkBarchart.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top','1px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
        var tableBtnImgVar = document.createElement("IMG");
        if(showOrHideTableForStkBarChart == false){
            tableBtnImgVar.src = "images/showTableIcon.png";
            tableButtonForStkBarChart.attr("class","showTableClassForChartTable")
        }
        else if(showOrHideTableForStkBarChart == true){
            tableBtnImgVar.src = "images/cancelTableIcon.png";
            tableButtonForStkBarChart.attr("class","hideTableClassForChartTable")
        }
        tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
        tableButtonForStkBarChart[0][0].appendChild(tableBtnImgVar)

        var settingBtnForStkBarChart = optsBtnPanelForStkBarchart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 28 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        var settingBtnImgVar = document.createElement("IMG");
        settingBtnImgVar.src = "images/settingsIcon.png";
        settingBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.82;")
        settingBtnForStkBarChart[0][0].appendChild(settingBtnImgVar)
        
        var downloadBtnForStkBarChart = optsBtnPanelForStkBarchart.append("div").attr("id","downloadBtnForStkBarChart-ID-" + targetElement[0][0].id).style("width","20px").style("height","20px")
        .style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff").style('margin-left','2px').style('top', 54 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        
        acinfotech.downloadFunctionality("downloadBtnForStkBarChart-ID-" + targetElement[0][0].id,targetElement)
        
        var svgPanelForStackedBarChart = targetElement .append('svg') 
        .attr("id","svgPanelIDForStackedBarChart" + targetElement[0][0].id)  .style("position","absolute")
        .style("border","0px solid #d0d0d0").style("background-color",options.BGcolor)

        var commentsPanelDivForStkBarChart = targetElement.append("div") .attr("class","commentsPanelClassForStkBarChart") 
        .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
		.style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
        .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)

        commentsPanelDivForStkBarChart.on('click',function(d){
            $('.commentsClassForStkBarChart' + targetElement[0][0].id).focus()
        })

        if(options.showTitle == true){
            
            chartTitlePanelForStackedBarChart.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 8 + "%"; }).style("background-color",options.BGcolor)
            .html('<div  style="width: 100%; height:0%;position: absolute; top:25.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')
                
            if ((showOrHideTableForStkBarChart == false) && (showOrHideCommentsForStkBarChart == true)){

                var commentsForStkBarChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify') .attr('class','commentsClassForStkBarChart' + targetElement[0][0].id)

                   svgPanelForStackedBarChart.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .append('g')
                   commentsPanelDivForStkBarChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForStkBarChart[0].outerHTML.toString())

            }
            else if ((showOrHideTableForStkBarChart == true) && (showOrHideCommentsForStkBarChart == false)){

                    svgPanelForStackedBarChart.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .append('g')
                    commentsPanelDivForStkBarChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForStkBarChart == false) && (showOrHideCommentsForStkBarChart == false)){
                    svgPanelForStackedBarChart.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .append('g')
                    commentsPanelDivForStkBarChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            
            var margin = {top: 10 , right: 55, bottom: 80, left: 50}, //originally top: 42, left: 80
            width = (svgPanelForStackedBarChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = (svgPanelForStackedBarChart.node().getBoundingClientRect().height) - margin.top - margin.bottom;
            
        }
        else if(options.showTitle == false){
            chartTitlePanelForStackedBarChart.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });
            
            if ((showOrHideTableForStkBarChart == false) && (showOrHideCommentsForStkBarChart == true)){

                var commentsForStkBarChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify')

                   svgPanelForStackedBarChart.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .append('g')
                   commentsPanelDivForStkBarChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForStkBarChart[0].outerHTML.toString())

            }
            else if ((showOrHideTableForStkBarChart == true) && (showOrHideCommentsForStkBarChart == false)){

                    svgPanelForStackedBarChart.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .append('g')
                    commentsPanelDivForStkBarChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForStkBarChart == false) && (showOrHideCommentsForStkBarChart == false)){
                    svgPanelForStackedBarChart.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .append('g')
                    commentsPanelDivForStkBarChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }

            var margin = {top: 10 , right: 20, bottom: 80, left: 50}, //originally top: 42, left: 80
            width = (svgPanelForStackedBarChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = svgPanelForStackedBarChart.node().getBoundingClientRect().height - margin.top - margin.bottom;
        }

        var colours;

        // checking color set for bubbles and legend dots
        if(options.colorSet === undefined){
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "one"){
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            options.colorSet = "two"
            colours = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            options.colorSet = "three"
            colours = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        }
        else
        {
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }

        //------------------ Settings panel DIV and everything within it section begins here ------------------
        
        var stgPanDivForStkBarChart = targetElement.append('div').style('width',"100%").style('height',"40%").attr("class","stgPanDivForStkHoriChart" + targetElement[0][0].id)
        .style('position','absolute').style('margin-left', "0px").style('border-top',"1px solid #f0f0f0").style('border-bottom',"1px solid #e5e5e5")
        .style("background-color",'#fcfcfc').style("z-index",90) .style("display","none") .style('top', 60.0 + "%") .style('height',40 + "%")

        $( '.stgPanDivForStkHoriChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        var settingPanelTitle = stgPanDivForStkBarChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','10px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; color:#00001c;">'+ "Settings" +'</div>')

        var stgPanDivForStkChangeColorTitle = stgPanDivForStkBarChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Select color set " +'</div>')

        var stgPanCanBtnForStkBarChart = stgPanDivForStkBarChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
        .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
        .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.9; background-color:#fcfcff")
        stgPanCanBtnForStkBarChart[0][0].appendChild(cancelBtnImgVar)

        stgPanCanBtnForStkBarChart.on('click', function() {
            stgPanDivForStkBarChart.style("display","none") // Hiding setting panel

            if ((showOrHideTableForStkBarChart == false) && (showOrHideCommentsForStkBarChart == true)){
                    divLegendPanelStackedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForStackedBarChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                    .style("position","absolute");
            }
            else if ((showOrHideTableForStkBarChart == true) && (showOrHideCommentsForStkBarChart == false)){
                    divLegendPanelStackedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForStackedBarChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute");
            }
            else if ((showOrHideTableForStkBarChart == false) && (showOrHideCommentsForStkBarChart == false)){
                    divLegendPanelStackedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForStackedBarChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute");
            }

            resizedFuctionForStackedBarChart();
        })

        var formForChangeSettingsPanel = stgPanDivForStkBarChart.append("form");
        formForChangeSettingsPanel.style("background-color","#fcfcfc").style("margin-top","67px").style("font-family","Verdana,sans-serif").style("font-size","12px")
        .style("position","absolute").attr("id","formForChangeColorSettingsPanel" + targetElement[0][0].id).style("font-weight","Bold").style("width","180px")
        .style("height","58px").style("padding","0px").style("border-radius","0px") .style("margin-left","10px")

        var svgPanelForCrSetOne = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px").style("height","18px").style("margin-top","1px").style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetOne = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        var colorSetOneRange = d3.range(12);

        var colorSetOneDots = svgPanelForCrSetOne.append("g")
        colorSetOneDots.selectAll('rect') .data(colorSetOneRange) .enter() .append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("fill", function(d,i){return colorSetOne(i)})
        .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetOne(i); })
        .style("cursor","auto") .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        var svgPanelForCrSetTwo = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px") .style("margin-top","20px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetTwo = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        var colorSetTwoRange = d3.range(12);

        var colorSetTwoDots = svgPanelForCrSetTwo.append("g")
        colorSetTwoDots.selectAll('rect') .data(colorSetTwoRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto")
        .style("fill", function(d,i){return colorSetTwo(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
        .style("stroke",function(d,i){  return colorSetTwo(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        var svgPanelForCrSetThree = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px") .style("margin-top","39px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetThree = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        var colorSetThreeRange = d3.range(12);

        var colorSetThreeDots = svgPanelForCrSetThree.append("g")
        colorSetThreeDots.selectAll('rect') .data(colorSetThreeRange) .enter().append('rect')
        .attr('transform', 'translate(' + (2) + ',' + (1) + ')') .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10)
        .attr("height",10) .style("cursor","auto") .style("fill", function(d,i){return colorSetThree(i)}) .style("fill-opacity",0.93)
        .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetThree(i);  })
        .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        if(options.colorSet.toString().toLowerCase() === "one"){
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"1px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"1px solid #808080")
        }
        else 
        {
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }

        svgPanelForCrSetOne.on('click',function(d){
            options.colorSet = "one"
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")

            colours = "";
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);

            groupsForStackedBarChart.style('fill', function (d, i) {
                return colours(i);
            })

            legendGroup.style("fill", function(d, i){ return colours(i);})
        
        })
        svgPanelForCrSetTwo.on('click',function(d){
            options.colorSet = "two"
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"1px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")

            colours = "";
            colours = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);

            groupsForStackedBarChart.style('fill', function (d, i) {
                return colours(i);
            })
            legendGroup.style("fill", function(d, i){ return colours(i);})
        })
        svgPanelForCrSetThree.on('click',function(d){
            options.colorSet = "three"
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"1px solid #808080")

            colours = "";
            colours = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);

            groupsForStackedBarChart.style('fill', function (d, i) {
                return colours(i);
            })
            legendGroup.style("fill", function(d, i){ return colours(i);})
        })

        
        //------------------ Settings panel DIV and everything inside it section ends here ------------------

        // Filter
        filterBtnForStackedBarChart.on('click', function() {

            filterPanelForStkBarChart.style("display","block");

            ismenuBtnOfStkBarChartClicked = false;
            optsBtnPanelForStkBarchart.style("display","none");

            stgPanDivForStkBarChart.style("display","none");

            if ((showOrHideTableForStkBarChart == false) && (showOrHideCommentsForStkBarChart == true)){
                divLegendPanelStackedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                svgPanelForStackedBarChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute");
            }
            else if ((showOrHideTableForStkBarChart == true) && (showOrHideCommentsForStkBarChart == false)){
                divLegendPanelStackedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                svgPanelForStackedBarChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute");
            }
            else if ((showOrHideTableForStkBarChart == false) && (showOrHideCommentsForStkBarChart == false)){
                divLegendPanelStackedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                svgPanelForStackedBarChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute");
            }

            resizedFuctionForStackedBarChart();

        })

        // Refreshing Chart and Table 
        refreshBtnForStackedBarChart.on('click', function() {

            //isFilterClicked = false
           d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData;
                    options.keys.stackedBars = newtargetElementAndOptionsArray[i].options.keys.stackedBars;
                }
            }
            acinfotech.stackedBarChart(targetElement,options) 

        })

        // Refreshing Chart and Table 
        commentsBtnForStkBarChart.on('click', function() {

            if(options.showComments == false){ 
                options.showComments = true;
            }
            else if(options.showComments == true){ 
                options.showComments = false;
            }

            //isFilterClicked = false
           d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData;
                    options.keys.stackedBars = newtargetElementAndOptionsArray[i].options.keys.stackedBars;
                    options.showTable = false;
                }
            }
            acinfotech.stackedBarChart(targetElement,options) 

        })

        // showing/hidding chart table
        tableButtonForStkBarChart.on('click', function() {

            if(showOrHideTableForStkBarChart == false){
                options.showTable = true;
                //showOrHideTableForPieChart = true
            }
            else if(showOrHideTableForStkBarChart == true){
                //showOrHideTableForPieChart = false
                options.showTable = false;
            }

            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                    options.showComments = false;
                }
            }
            acinfotech.stackedBarChart(targetElement,options)

        })

        
        settingBtnForStkBarChart.on('click', function() {
                
            ismenuBtnOfStkBarChartClicked = false; // Menu toggle button variable
            optsBtnPanelForStkBarchart.style("display","none") // To hide options button panel

            iconButtonTooltipForStackedChart.style("display","none") // Removing options button ToolTip
            settingBtnForStkBarChart.style("cursor","pointer")
            
            stgPanDivForStkBarChart.style("display","block") // Showing settings panel

            svgPanelForStackedBarChart.style('width', 75 + "%") .style('height', 52 + "%").style("position","absolute"); // Decreasing chart panel
            divLegendPanelStackedBarChart.style('width', 25 + "%") .style('height', 52 + "%").style("position","absolute"); // Decreasing chart panel

            resizedFuctionForStackedBarChart(); // Calling resize function()

        })
        
        downloadBtnForStkBarChart.on('click', function() {
                                  
            ismenuBtnOfStkBarChartClicked = false; // Changing menu button value to false
            optsBtnPanelForStkBarchart.style("display","none") // Hiding option buttons panel
              
        })
        
        // Creating ToolTip for options button.
        var iconButtonTooltipForStackedChart = targetElement.append('div').style('width','240px').attr("id","too")
        .style('height',"25px").style('position','absolute')//.style('margin-left', "0px").style('top','25px')
        .style("background-color",'#404040 ').style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid") // 004b9d
        .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none").attr("border", 0.0)

        filterBtnForStackedBarChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var filterButtonTooltipText = "Filter";
            
            iconButtonTooltipForStackedChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForStackedChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')

        })
        filterBtnForStackedBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForStackedChart.style("display","none")
        })

        refreshBtnForStackedBarChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var refreshButtonTooltipText = "Refresh";
            
            iconButtonTooltipForStackedChart.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForStackedChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center; ">'+ refreshButtonTooltipText +'</div>')

        })
        refreshBtnForStackedBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForStackedChart.style("display","none")
        })

        commentsBtnForStkBarChart.on('mousemove', function(d,i) {
            commentsPanelDivForStkBarChart.style('background-color','#fafafa')
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                if(options.showComments == false){
                    var commentButtonTooltipText = "Show Comments";
                }
                else if(options.showComments == true){
                    var commentButtonTooltipText = "Hide Comments";
                }
            
            
            iconButtonTooltipForStackedChart.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForStackedChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center; ">'+ commentButtonTooltipText +'</div>')
        })
        commentsBtnForStkBarChart.on('mouseout', function(d,i) {
            commentsPanelDivForStkBarChart.style('background-color','#ffffff')
            iconButtonTooltipForStackedChart.style("display","none")
        })

        menuBtnForStackedBarChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var menuButtonTooltipText = "Menu";
            
            iconButtonTooltipForStackedChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForStackedChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center; ">'+ menuButtonTooltipText +'</div>')

        })
        menuBtnForStackedBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForStackedChart.style("display","none")
        })

        tableButtonForStkBarChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                if(showOrHideTableForStkBarChart ==  false){
                    var refreshButtonTooltipText = "Show Table";
                }
                else if(showOrHideTableForStkBarChart == true){
                    var refreshButtonTooltipText = "Hide Table";
                }
            
            
            iconButtonTooltipForStackedChart.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForStackedChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ refreshButtonTooltipText +'</div>')

        })
        tableButtonForStkBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForStackedChart.style("display","none")
        })

        settingBtnForStkBarChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var settingTooltipText = "Settings";
            
            iconButtonTooltipForStackedChart.style("width","67px").style("margin-left", (m[0] - 77) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForStackedChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ settingTooltipText +'</div>')
        })
        settingBtnForStkBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForStackedChart.style("display","none")
        })
        
        downloadBtnForStkBarChart.on('mousemove', function(d,i) {
              var root = targetElement
              var m = d3.mouse(root.node());
              m[0] += 0
              m[1] += 0
              var downloadButtonTooltipText = "Download";
              
              iconButtonTooltipForStackedChart.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
              iconButtonTooltipForStackedChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
        })
        downloadBtnForStkBarChart.on('mouseout', function(d,i) {
              iconButtonTooltipForStackedChart.style("display","none")
        })
        
        // ----------------- Filter panel and everything within it section begins here ----------------
        var filterPanelForStkBarChart = targetElement.append('div').style('width',350 + "px") .attr("class","filterPanelForStkBarChartClass" + targetElement[0][0].id)
        .style('position','absolute').style('margin-left', "0px")
        .style("background-color",'#fefefe').style("z-index",11).style("border-color", "#ffffff").style("border-right", "solid #e5e5e5 1px")  .style("border-style", "solid") // 004b9d
        .style("box-shadow", "2px 0px 1px #eff8ec").style("display","none").style("border-top", "solid #fdfdfd 1px").style("border-left","0px").style("border-bottom", "0px")
        .style('top', 0.0 + "%").style('height', 100 + "%").style('overflow-y',"hidden").style("overflow-x","hidden")
        .style("border-bottom", "solid #e5e5e5 1px") .style("box-sizing","border-box")

        var filterPanelForStkBarChartTitle = filterPanelForStkBarChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','20px').style('text-indent','5px').style("font-size", "14px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #007aff").style("width","350px").style("color","#000000")
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; top:25.0%; font-size:14px; font-family:inter; color:#00001c;">'+ "Filter" +'</div>')

        var measuresColumnTitle = filterPanelForStkBarChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; text-indent:3px;">Available Measures</div>');
		
        var measuresVariables = filterPanelForStkBarChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable1"+targetElement[0][0].id)
        .style("list-style-type","none")
        .style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '78px')
        .style('position','absolute')
        .style("width","155px").style("min-height","190px").style("max-height","190px").style("border", "#f0f0f0 1px solid")
        .style("max-width","155px").style("overflow-x","hidden").style("overflow-y","auto")
        measuresVariables.style("left",0.0 + "px").style("padding","2px")

        $( ".filterPanelForStkBarChartClass" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });


        var measuresArray = [];
        var dimensionArray = [];

        var measuresArrayLength = [];
        var dimensionsArrayLength = [];

        dimensionArray.push(options.keys.label);
        //measuresArray = options.keys.stackedBars;

        for(var i = 0; i<divAndChartsArray.length; i++){
            if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    
                measuresArray = newtargetElementAndOptionsArray[i].options.keys.stackedBars;
            }
        }
        
        // filter process
        var uniqueMeasuresArrayKeys = [];
        $.each(measuresArray, function(i, el){
            if($.inArray(el, uniqueMeasuresArrayKeys) === -1){
                uniqueMeasuresArrayKeys.push(el);
            }
        });

        var uniqueDimensionArrayKeys = [];
        $.each(dimensionArray, function(i, el){
            if($.inArray(el, uniqueDimensionArrayKeys) === -1){
                uniqueDimensionArrayKeys.push(el);
            }
        });
        
        // setting lenght for arrays
        for(var i = 0; i<uniqueMeasuresArrayKeys.length; i++){
            measuresArrayLength.push(i);
        }

        for(var i = 0; i<uniqueDimensionArrayKeys.length; i++){
            dimensionsArrayLength.push(i);
        }

        var measuresVariables1 = measuresVariables.selectAll("li") .data(measuresArrayLength).enter().append("li")
        .style("width","130px") .style("max-height","22px").style("cursor","move")
        .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#bcf1bc").style("font-weight","Normal")
        .style("list-style-type","none").style("border","1px #89e789 solid").style("color","#006600").style("font-family","Verdana,sans-serif")
        .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
        .text(function(d) {return uniqueMeasuresArrayKeys[d]})
        measuresVariables1.attr("class","MeasuresClass"+targetElement[0][0].id)
        
        var measuresColumnReceivedUI_TableTitle = filterPanelForStkBarChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','180px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; ">Selected Measures</div>');

        var measuresColumnReceivedUI_Table = filterPanelForStkBarChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable3"+targetElement[0][0].id)
        .style('background-color',"#ffffff").style('margin-left','180px').style('margin-top', '78px')
        .style("width","155px").style('position','absolute').style("padding","2px").style("min-height","190px")
        .style("border","1px #c1c1c1 dashed") .style("max-height","190px") .style("overflow-x","hidden") .style("overflow-y","auto")
        //.html('<div class=unsortable  style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:65.0%; font-size:14px; font-family:inter;  color:#99ea99; font-weight:Normal; text-align:center;">Drag and Drop Measures here from Available Measures List. </div>');
        .html('<img class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' src="images/dragIcon.png" style=" width:36px; height:36px; position:absolute; margin-left:65px; margin-top:60px; opacity:0.6"/>' 
        + '<div class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:60.0%; font-size:12px; font-family:inter;  color:#89d289; font-weight:Normal; text-align:center;">Drop Measures here. </div>');
        //.html('<div style="background-image: url(images/dragIcon.png); height: 64px; width: 64px; border: 1px solid black;"> </div>');

        var cancelButton = filterPanelForStkBarChart.append("div") .style("width","23px").style("height","21px").style('position','absolute')
        .style('margin-left','320px').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
        .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.9; background-color:#fcfcff")
        cancelButton[0][0].appendChild(cancelBtnImgVar)

        cancelButton.on("click", function(){
            filterPanelForStkBarChart.style("display","none")

            if ((showOrHideTableForStkBarChart == false) && (showOrHideCommentsForStkBarChart == true)){
                divLegendPanelStackedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                svgPanelForStackedBarChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute");
            }
            else if ((showOrHideTableForStkBarChart == true) && (showOrHideCommentsForStkBarChart == false)){
                divLegendPanelStackedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                svgPanelForStackedBarChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute");
            }
            else if ((showOrHideTableForStkBarChart == false) && (showOrHideCommentsForStkBarChart == false)){
                divLegendPanelStackedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                svgPanelForStackedBarChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute");
            }
        })

        var reRenderChartAndTableButton = filterPanelForStkBarChart.append("button").style("width","120px").style("height","25px").style('position','absolute')
        .style('margin-left','112px').style('margin-top','298px') .style("border-style", "none").style('background-color',"#2196f3")
        .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','15px').style("border-style", "solid").style('color','#ffffff')
        .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 1px #9b9b9b").style("border-radius","0px")
        var textForReRenderButton = document.createTextNode("Apply Changes");
        reRenderChartAndTableButton[0][0].appendChild(textForReRenderButton)

        reRenderChartAndTableButton.on("click", function(){

            if( $("#sortable3"+targetElement[0][0].id).children("li").length == 0 )
            {

                var alertPageDisabledDivForStkBarChart =targetElement.append('div').style('width',100 + '%')
                .style('height',100 + "%").style('position','absolute').style('margin-left', '0px').style('top', '0px')
                .style("background-color",'#f3f3f3').style("z-index",99)//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("opacity",0.2).style("display","block")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")

                var alertDivForStkBarChart = targetElement.append('div').style('width','350px')
                .style('height',"150px").style('position','absolute').style('left', ((targetElement[0][0].clientWidth/2) - 175) + "px").style('top', '1px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "solid").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","0px")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
                //.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Bold;">Sorry, no result found for selected' + 'range!'+ '</br>' + '<label style=text-indent:10px;> Hello</label' +'</div>')
                .html('<p  style="width: 340px; height:0%; background-color:#c7c7c7; position: absolute; top:40.0%; font-size:14px; font-family:inter; font-weight:Bold; margin-left:10px;  color:#f8f8f8; font-weight:Normal;">Check whether the Selected Measures box is not empty!</p>')

                var alertDivTitleForStkBarChart = alertDivForStkBarChart.append('div').style('width','340px')
                .style('height',"30px").style('position','absolute').style('margin-left', "0px").style('top', '0px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "none").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","2px")
                .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; font-weight:Bold; text-indent:5px;  color:#e5e5e5; font-weight:Normal;">TimeBound</div>')

                var stkBarChartAlertOKButton = alertDivForStkBarChart.append("button") .style("width","40px") .style("height","20px") .style('position','absolute') .style("box-shadow", "0px 1px 1px #B8B8B8") 
                .style('background-color',"#7cc15e") .style('margin-left','300px') .style('top', "120px").style("color","#ffffff")
                .style("display","block").style('padding-top',"0px").style("cursor","pointer").style("box-shadow", "1px 1px 1px #56973a") .style("border-style", "none")
                .style("font-family","Verdana,sans-serif").style("font-size","14px").style("text-align","center").style("vertical-align","middle").style("border-radius","0px")
                .style("z-index",999)
            
                var textForStkBarChartAlertOKButton = document.createTextNode("OK");
                stkBarChartAlertOKButton[0][0].appendChild(textForStkBarChartAlertOKButton)

                $("#"+targetElement[0][0].id).resizable('disable');

                stkBarChartAlertOKButton.on('click', function() {
                    alertDivForStkBarChart.remove();
                    alertPageDisabledDivForStkBarChart.remove()
                    $("#"+targetElement[0][0].id).resizable('enable');
                })

                filterBtnForStackedBarChart.style("cursor","pointer")
                
                if(showOrHideTableForStkBarChart == false){ 
                    svgPanelForStackedBarChart.style('width', 75 + "%") .style('height', 85 + "%").style("position","absolute")
                    divLegendPanelStackedBarChart.style('width', 25 + "%") .style('height', 85 + "%").style("position","absolute")
                }   
                else if(showOrHideTableForStkBarChart == true){ 
                    svgPanelForStackedBarChart.style('width', 75 + "%") .style('height', 52 + "%").style("position","absolute")
                    divLegendPanelStackedBarChart.style('width', 25 + "%") .style('height', 52 + "%").style("position","absolute")
                } 

                resizedFuctionForStackedBarChart();
            }

            else{

                var selectedStackMeasures = [];
                for(var i=0; i<$("#sortable3"+targetElement[0][0].id).children("li").length;i++){
                    selectedStackMeasures.push($("#sortable3"+targetElement[0][0].id).children("li")[i].textContent)
                }
            
                var newOptions = {
                           data: options.data,
                           dataForDrillDown:options.dataForDrillDown,
                           dataForTable:options.dataForTable,
                           isDataDetailedForTable: options.isDataDetailedForTable,
                           keys: {
                               label: options.keys.label,//$("#sortable4"+targetElement[0][0].id).children("li")[0].textContent.toString(),
                               stackedBars: selectedStackMeasures,
                           },
                           chartTitle:options.chartTitle,
                           xAxisLable: options.keys.label,//$("#sortable4"+targetElement[0][0].id).children("li")[0].textContent,
                           yAxisLable: "",
                           //dimensions: options.dimensions,
                           //measures: options.measures,
                           showTitle: true,
                           colorSet: options.colorSet,
                           series:options.series,
                           legend:options.legend,
                           BGcolor:options.BGcolor,
                           drillDownColumnName:options.drillDownColumnName,
                           showTable: options.showTable,
                           showComments: options.showComments,
                           comments: options.comments,
                           resizeButtonID: options.resizeButtonID //document.getElementById("resizeBtn").id
                        }
                        
                        d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                        acinfotech.stackedBarChart(targetElement,newOptions)
                }
            
            })

        var textBoxForMeasureColumnFrom;
        var textBoxForMeasureColumnTo;
        var selectTitleDivForEachDimension;

       
        $( "ul.droptrue"+targetElement[0][0].id ).sortable({
            appendTo: document.body,
            helper: "clone",
            connectWith: ".droptrue"+targetElement[0][0].id,
            scroll: false,
            cancel: '.unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+','+' .unMoveableIconAndTextClassDimensions'+targetElement[0][0].id,
            revertDuration: 10,
            scrollSensitivity: 10,
            scrollSpeed: 1,
            dynamic: true,

            receive: function(e, ui) { 
                 
                if (($(this)[0].id == "sortable3"+targetElement[0][0].id) || ($(this)[0].id == "sortable1"+targetElement[0][0].id)) {

                        if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                            if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                                 (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                            }
                            else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                                (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                            }

                        }
                } // if (($(this)[0].id == "sortable3") || ($(this)[0].id == "sortable1")) 

                else if (($(this)[0].id == "sortable2"+targetElement[0][0].id) || ($(this)[0].id == "sortable4"+targetElement[0][0].id)) {
                    if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                            //ui.sender.sortable("cancel");

                            if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                                 (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                            }
                            else if(  ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                                (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                            }
                        }
                } //if (($(this)[0].id == "sortable2") || ($(this)[0].id == "sortable4")) {

                $(ui.item).css({ 'position': 'relative' });

                if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                    ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                }
                 
                else if ($(this)[0].id == "sortable3"+targetElement[0][0].id) { // checking if the dropped element is in Measures drop area
                    
                    if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                        ui.sender.sortable("cancel");
                    }
                    else {
                        //ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                    }

                } // else if ($(this)[0].id == "sortable3") // checking if the dropped element is in Measures drop area ends here.

                else if ($(this)[0].id == "sortable4"+targetElement[0][0].id) { // checking if the dropped element is in Dimension drop area

                    if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                        ui.sender.sortable("cancel");
                    }
                    else {
                        ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                    }
                } //else if ($(this)[0].id == "sortable4")  // checking if the dropped element is in Dimension drop area ends here

                    if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                        
                        if ($(this)[0].id == "sortable1"+targetElement[0][0].id){
                            if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                            
                                if( ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                                    ui.sender.sortable("cancel");
                                } // if(  ui.sender.attr("id") === "sortable4")

                                else if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                                    ui.sender.sortable("cancel");
                                }
                            
                            } // if(ui.item.hasClass("DimesionsClass"))
                        }
                    if ($(this)[0].id == "sortable2"+targetElement[0][0].id){
                        if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                            
                            if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                                ui.sender.sortable("cancel");
                            }
                            else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                                ui.sender.sortable("cancel");
                               
                            }
                        }
                    }

                } //if ($(this)[0].id == "sortable1")

                if ($(this)[0].id == "sortable4"+targetElement[0][0].id){
                    if ($(this).children('li').length > 1 ){
                        ui.sender.sortable("cancel");
                        ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                    }    
                }

            }, //receive ends here

            start:function(ev, ui) {
                
            },
            stop:function(ev, ui) {
               
            },
        });
      
        // ----------------- Filter panel and everything within it section ends here -----------------

        var finalArrayNew = [];
        options.keys.stackedBars.forEach(function(d, i) {
    
            var temp1 = {};
            temp1["name"] = options.keys.stackedBars[i]
    
            finalArrayNew.push(temp1)
        })
        
        var finalNewNewArray = [];
        var dataArray1 = [];
        finalArrayNew.forEach(function(d, i) {
    
            var temp1 = {};
            temp1["name"] = options.keys.stackedBars[i]
    
            for (j = 0; j < options.data.length; j++) {
                
                var tempTemp = {};
                tempTemp["label"] = options.data[j][options.keys.label];
                tempTemp["value"] = +options.data[j][options.keys.stackedBars[i]];

                dataArray1.push(tempTemp)
            }
            
                temp1["data"] = dataArray1;
                dataArray1 = []
                finalNewNewArray.push(temp1)
        })
        
        var margins = {
            top: 12,
            left: 48,
            right: 24,
            bottom: 24
        },
    
    width = (svgPanelForStackedBarChart.node().getBoundingClientRect().width) - margin.left - margin.right,
    height = (svgPanelForStackedBarChart.node().getBoundingClientRect().height) - margin.top - margin.bottom
    
    dataset = finalNewNewArray,
    series = dataset.map(function (d) { return d.name; }),
    dataset = dataset.map(function (d) {
        return d.data.map(function (o, i) {
            // Structure it so that your numeric
            // axis (the stacked amount) is y
            return {
                y: o.value,
                x: o.label
            };
        });
    }),
    stack = d3.layout.stack();

    stack(dataset);

    var dataset = dataset.map(function (group) {
        return group.map(function (d) {
            // Invert the x and y values, and y0 becomes x0
        
            return {
                x: +d.y,
                y: d.x,
                x0: +d.y0
            };
        });
    }),
    svgStackedBarChart = svgPanelForStackedBarChart  .append('svg') .append('g') 
    .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'),
    xMax = d3.max(dataset, function (group) {
        
        return d3.max(group, function (d) {
            return (+d.x) + (+d.x0);
        });
    }),
    months = dataset[0].map(function (d) { return d.y; }),

    xScale = d3.scale.ordinal() .domain(months) .rangeRoundBands([0, width], .20),
    
    yScale = d3.scale.linear() .domain([0, xMax]) .range([height, 0]),
    
    xAxis = d3.svg.axis() .scale(xScale) .orient('bottom'),
    yAxis = d3.svg.axis() .scale(yScale) .orient('left'),
    
    groupsForStackedBarChart = svgStackedBarChart.selectAll('g') .data(dataset) .enter() .append('g')
    .style('fill', function (d, i) { return colours(i); }),
    
    xScale1 = d3.scale.ordinal() .domain(months) .rangeRoundBands([0, width], .20),
        
    yScale1 = d3.scale.linear() .domain([0, xMax]) .range([0, height]),
    months = dataset[0].map(function (d) { return d.y; }),

    rectsForStackedBarChart = groupsForStackedBarChart.selectAll('rect') .data(function (d) { return d; }) .enter() .append('rect')
    
	groupsForStackedBarChart.selectAll('rect')
	.attr('x', function (d,i) { return xScale1(d.y); })
	.attr("width", xScale1.rangeBand())
	.attr("y", function (d) { return height; })
	.attr("height", function (d) { return 0; })
	.transition() .delay(400) .duration(800)
	.attr('y', function (d, i) { return height - yScale1(d.x0) - yScale1(d.x) })
	.attr("height", function (d) { return yScale1(d.x); }) .style("cursor","auto")
	    
        if(options.dataForDrillDown.length == 0){
            
            var columnNames = d3.keys(options.data[0])
            var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
            
            for(var i = 0; i < columnNames.length ; i++){
                for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                    if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                        for(var k = 0; k < options.keys.stackedBars.length; k++){
                            var len = d3.select(groupsForStackedBarChart[0][k]).selectAll('rect')
                            for(var l = 0; l < len[0].length; l++){
                                d3.select(len[0][l]).attr('data-drilldownkey', function(d,index){
                                        return JSON.stringify(options.data[l]).slice(1, -1).split('"').join("").split(':').join("|")
                                    })
                            }
                        }
                    }
                    else {
                    }
                }
            }
            
        }
        else if(options.dataForDrillDown.length > 0){
            
            options.keys.stackedBars.forEach(function(measures, i) {
                 var bars = d3.select(groupsForStackedBarChart[0][i]).selectAll('rect')
                 bars[0].forEach(function(d, index) {
                     var dd = d3.select(d)[0]
                     options.dataForDrillDown.forEach(function(val, i) {
                            var key, keys = Object.keys(val), n = keys.length, newObj={}
                            while (n--) { key = keys[n]; newObj[key.toLowerCase()] = val[key]; }
                            var optKeysLabVal = options.keys.label.toString().toLowerCase();
                            if(dd[0].__data__.y.toString().toLowerCase() === newObj[optKeysLabVal].toString().toLowerCase()){
                                    //if(dd[0].__data__.x == val[measures]){
                                if(dd[0].__data__.x == newObj[measures.toLowerCase()]){
                                    d3.select(dd[0]).attr('data-drilldownkey', function(d,index){
                                        return JSON.stringify(val).slice(1, -1).split('"').join("").split(':').join("|")
                                    })
                                }
                            }
                      })
                 })
             })
        }
        
		var yTextPadding = 10;
		var format1 = d3.format('.2s')
		var textOnStackedBarChart = groupsForStackedBarChart.selectAll(".text") .data(function (d) { return d; })

		textOnStackedBarChart.enter() .append("text") .attr("class","text series_value").style("display",options.series)

		textOnStackedBarChart.style("text-anchor", "middle").attr("class", "series_value").style("display",options.series)
		.attr("x", function(d,i) { return xScale1(d.y)+xScale1.rangeBand()/2; })
		.attr("y", function (d) { return height; })
		.transition() .delay(400) .duration(800)
		.attr("y", function(d) { return (height -yScale1(d.x0) - yScale1(d.x))+(yScale1(d.x)/1.5);})
		.style("font-family", "Verdana,sans-serif").style("font-size", "12px") .style("fill", "#ffffff") 
		.style("text-shadow","1px 0px 1px rgba(34,34,34,0.6)")
		.text(function(d){
			
			if(d.x.toString().indexOf('.') === -1)
			{
			  if(d.x.toString().length <= 3){
				return d.x;
			  }
			  else{
				return format1(d.x)
			  }
			}
			else{
			  
				return d.x.toString();
			}
		})
         // Adding the text label for the x axis
         let key=options.xAxisLable;
         let array=options.data.map(value => value[key]);
         let ArrayValue=[];
         var RotateValue;
         for(let i=0;i<array.length;i++){
                 ArrayValue[i]=array[i].length;
         }
         const numberGreaterThanLimit = ArrayValue.filter((v) => v > 5);
         var xtext=options.xAxisLable.toLowerCase();
         var xAxisVariable =  svgStackedBarChart.append("text") .attr("transform", "translate(" + ((width/2) - 2) + " ," + (height+margin.bottom - 5) + ")")
         .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif") .style("font-weight","Bold") .style("font-size","12px") .text(xtext).style('fill','#00001c') 
         .style("font-style","normal").style('text-transform','capitalize')
        
		svgStackedBarChart.append('g') .attr("class", "x axis") .attr('transform', 'translate(0,' + height + ')') .call(xAxis)
		.selectAll("text") .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') .attr("transform", function(d) { 
            if(numberGreaterThanLimit.length>0)
            {
                return "rotate(-45)"
            }
         else{
                    return "rotate(0)" 
            }})
		
		.text(function(d,i) {
			if(d.length > 9)
				return d.substring(0,9)+'...';
			else
				return d;
		})

        // // Add the text label for the Y axis
        // var yAxisVariable = svg.append("text") .attr("transform", "rotate(-90)") .attr("y", -15) .attr("x",0 - (height / 2.0)) .attr("dy", "1em") .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif")
        // .style("font-size","11.0px") .text(options.yAxisLable) .style('fill','#00001c') .style("text-transform","capitalize") .style("font-weight","Bold")
        // .style("font-style","normal")
        
       
         //------------ adding legend section -----------
        var divLegendPanelStackedBarChart = targetElement .append('div')  .attr("class","divLegendPanelClassForStackedBarChart")
        .style("background-color",options.BGcolor) .style('position',"absolute") 
        //.style('width', 25 + "%") .style('height', 92 + "%") .style("left",75 + "%").style("top",8 + "%") 

        if(options.showTitle == true){

            if ((showOrHideTableForStkBarChart == false) && (showOrHideCommentsForStkBarChart == true)){
                    divLegendPanelStackedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForStackedBarChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                    .style("position","absolute");
            }
            else if ((showOrHideTableForStkBarChart == true) && (showOrHideCommentsForStkBarChart == false)){
                    divLegendPanelStackedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForStackedBarChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute");
            }
            else if ((showOrHideTableForStkBarChart == false) && (showOrHideCommentsForStkBarChart == false)){
                    divLegendPanelStackedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForStackedBarChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute");
            }
            
        }
        else if(options.showTitle == false){

            if ((showOrHideTableForStkBarChart == false) && (showOrHideCommentsForStkBarChart == true)){
                    divLegendPanelStackedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForStackedBarChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                    .style("position","absolute");
            }
            else if ((showOrHideTableForStkBarChart == true) && (showOrHideCommentsForStkBarChart == false)){
                    divLegendPanelStackedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForStackedBarChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute");
            }
            else if ((showOrHideTableForStkBarChart == false) && (showOrHideCommentsForStkBarChart == false)){
                    divLegendPanelStackedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForStackedBarChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute");
            }
        }
        
        var legendPanelSVGForStackedBarChart = divLegendPanelStackedBarChart .append('svg')  .attr("class","")
        .style("background-color",options.BGcolor) .style('position',"absolute").style('width', 100 + "%") .style('height', 100 + "%") .style("left",0 + "%").style("top",0 + "%")
        
        var legend = legendPanelSVGForStackedBarChart.append("g") .attr("class", "legend") .attr("height", "100%") .attr("width", "100%")
        .attr('transform', 'translate(0,20)') 
        
        //Create colour squares
        var legendGroup = legend.selectAll('rect') .data(options.keys.stackedBars) .enter() .append("rect") .attr("x", 5)
        .attr("y", function(d, i){ return i * 16;}) .attr("width", 14) .attr("height", 14) .attr("rx",10) .attr("ry",10)
        .style("fill", function(d, i){ return colours(i);}) .style("cursor","auto")
      

        //Create text next to squares
        legend.selectAll('text') .data(options.keys.stackedBars) .enter() .append("text") .attr("x", 25) .attr("y", function(d, i){ return i * 16 + 11.4;})
        .attr("fill", "#00001c") .text(function(d,i) {  if(d.length > 10)
            return d.substring(0,10)+'...';
        else
            return d; }) .style('font-size', '14px') .attr("fill","#00001c") .style("font-family","Verdana,sans-serif")

        // Aligning Legend (vertically)
        var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelStackedBarChart[0][0].style.width) / 100)
        var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelStackedBarChart[0][0].style.height) / 100)

        var legendRectSize = 11;
        var legendSpacing = 4;
            
        legend.transition().duration(0).attr('transform', function(d, i) {
        var eachRectHeight = legendRectSize + legendSpacing;
        var offset =  eachRectHeight * colours.domain().length / 2;
        var horz = 5;
        var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.stackedBars.length))/2.0; // originally 2.0
            
            return 'translate(' + horz + ',' + vert + ')';
        })

        /*legendGroup.on('mouseover',function(d,i){
            
            if(options.keys.stackedBars.length > 1){ // to check if the stack set is more than 1
                
                // to check whether the widget is being resized or not (to save new xScale)

                if(xScale1GlobalVar == undefined){ xScale1GlobalVar = xScale1; }
                if(yScale1GlobalVar == undefined){ yScale1GlobalVar = yScale1; }

                if(newHeightVar == undefined){ newHeightVar = height }

                textOnStackedBarChart.style('display','none')

                d3.select(groupsForStackedBarChart[0][i]).selectAll('text').style('display','block')
                .transition().duration(0).ease('bounce')//.attr("y", function(d,i) { return (newHeightVar - yScale1GlobalVar(d.x)) - 6 })
                .style("fill", "#909090") .style("text-shadow","0px 0px 0px rgba(34,34,34,0.6)") .style('font-size',"12px")
                .style("text-anchor", "start")
                //.attr("x", function(d,i) { return (newHeightVar - yScale1GlobalVar(d.x)) - 6 ; })
                .attr("x", function(d,i) { return  ((yScale1GlobalVar(i) - newHeightVar) + yScale1GlobalVar(d.x)) + 5; })
                .attr("y", function(d) { return  (xScale1GlobalVar(d.y)+xScale1GlobalVar.rangeBand()/2) + 4;})
                       
                       //.attr("x", function(d,i) { return xScale1(d.y)+xScale1.rangeBand()/2; })
                       //.attr("y", function(d) { return (height -yScale1(d.x0) - yScale1(d.x))+(yScale1(d.x)/1.5);}) .style("font-family", "Verdana")
                       
                .attr("transform", "rotate(-90)")
                       //.attr("x", function(d,i) { return xScale1GlobalVar(d.y)+xScale1GlobalVar.rangeBand()/3.0; })
                       //.attr("y", function(d) { return (height -yScale1GlobalVar(d.x0) - yScale1GlobalVar(d.x))+(yScale1GlobalVar(d.x)/1.5);}) .style("font-family", "Verdana")
                       
                       //.attr("x", function(d,i) { return xScale1(d.y)+xScale1.rangeBand()/2; })
                       //.attr("y", function(d) { return (height -yScale1(d.x0) - yScale1(d.x))+(yScale1(d.x)/1.5);})
                       
                .text(function(d,i){
                    if(d.x.toString().indexOf('.') === -1)
                    {
                        return d.x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    }
                    else{
                        
                        return d.x;
                    }
                })
                
                groupsForStackedBarChart.selectAll('rect').style('display','none')
                var g = d3.select(groupsForStackedBarChart[0][i]).selectAll('rect').style('display','block')
                .transition().duration(1000).ease('bounce')
                .attr("y", function(d,i) { return newHeightVar - yScale1GlobalVar(d.x) })  
            }
        })

        legendGroup.on('mouseout',function(d,i){
            
            if(yScale1GlobalVar == undefined){ yScale1GlobalVar = yScale1; }

            if(newHeightVar == undefined){ newHeightVar = height; }

            textOnStackedBarChart.style('display','block')

            d3.select(groupsForStackedBarChart[0][i]).selectAll('text').style('display','block').style('font-size',"10px").style("text-anchor", "middle")
            .transition().duration(0).ease('bounce') .style("fill", "#ffffff") .style("text-shadow","1px 0px 1px rgba(34,34,34,0.6)")
            .attr("x", function(d) { return  xScale1GlobalVar(d.y)+xScale1GlobalVar.rangeBand()/2;})
            .attr("y", function(d) { return (newHeightVar - yScale1GlobalVar(d.x0) - yScale1GlobalVar(d.x))+(yScale1GlobalVar(d.x)/1.5);})
            .attr("transform", "rotate(0)")
            .text(function(d){
                  if(d.x.toString().indexOf('.') === -1)
                  {
                    if(d.x.toString().length <= 2){
                        return d.x;
                    }
                    else{
                        return format1(d.x)
                    }
                  }
                  else{
                        return d.x.toString();
                  }
            })
            
            groupsForStackedBarChart.selectAll('rect').style('display','block')
            var g = d3.select(groupsForStackedBarChart[0][i]).selectAll('rect').transition().duration(1000).ease('bounce')
            .attr("y", function(d,i) { return newHeightVar - yScale1GlobalVar(d.x0) - yScale1GlobalVar(d.x) })
        })*/
        
        legendGroup.on('mouseover',function(d,i){
                       
           if(options.keys.stackedBars.length > 1){ // to check if the stack set is more than 1
           
           // to check whether the widget is being resized or not (to save new xScale)
           if(yScale1GlobalVar == undefined){ yScale1GlobalVar = yScale1; }
           
           if(newHeightVar == undefined){ newHeightVar = height }
           
           textOnStackedBarChart.attr("class","text series_value").style('display','none')
           d3.select(groupsForStackedBarChart[0][i]).selectAll('text').style('display','block')
           .transition().duration(1000).ease('bounce').attr("y", function(d,i) { return (newHeightVar - yScale1GlobalVar(d.x)) - 6 })
           .style("fill", "#00001c") .style("text-shadow","0px 0px 0px rgba(34,34,34,0.6)") .style('font-size',"12px")
           
           
           groupsForStackedBarChart.selectAll('rect').style('display','none')
           var g = d3.select(groupsForStackedBarChart[0][i]).selectAll('rect').style('display','block')
           .transition().duration(1000).ease('bounce')
           .attr("y", function(d,i) { return newHeightVar - yScale1GlobalVar(d.x) })
           }
        })
        
        legendGroup.on('mouseout',function(d,i){
                       
           if(yScale1GlobalVar == undefined){ yScale1GlobalVar = yScale1; }
           
           if(newHeightVar == undefined){ newHeightVar = height; }
           
        textOnStackedBarChart.attr("class","text series_value").style('display','block')
           
           d3.select(groupsForStackedBarChart[0][i]).selectAll('text').style('display','block').style('font-size',"12px")
           .transition().duration(1000).ease('bounce') .style("fill", "#ffffff") .style("text-shadow","1px 0px 1px rgba(34,34,34,0.6)")
           .attr("y", function(d) { return (newHeightVar - yScale1GlobalVar(d.x0) - yScale1GlobalVar(d.x))+(yScale1GlobalVar(d.x)/1.5);})
           
           
           groupsForStackedBarChart.selectAll('rect').style('display','block')
           var g = d3.select(groupsForStackedBarChart[0][i]).selectAll('rect').transition().duration(1000).ease('bounce')
           .attr("y", function(d,i) { return newHeightVar - yScale1GlobalVar(d.x0) - yScale1GlobalVar(d.x) })
        })


        //---------creating tooltip----
        var tooltipForStackedBarChart = targetElement .append('div') .attr('class', 'tooltipPie') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
        .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
        .style("padding-right", "7px") .style("background", "#F8F8F8") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style("z-index",1000)
        .style("border", "1.0px") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","60px")
        tooltipForStackedBarChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'label').style("color","#000000") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "12px") .style("font-weight", "Bold");
        tooltipForStackedBarChart.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
        tooltipForStackedBarChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");
		
		rectsForStackedBarChart.on('mousemove', function (d,i){
               
                var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                
                tooltipForStackedBarChart.select('.label').html(options.keys.label + " : " + d.y)
                tooltipForStackedBarChart.select('.count').html(d.x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
                tooltipForStackedBarChart.style('visibility', 'visible')
                tooltipForStackedBarChart.select('hr').style("background-color", d3.select(this).style("fill") )
                tooltipForStackedBarChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-10) + "px").style("display","block")

        })

        // groupsForStackedBarChart.selectAll('rect').on('mousemove', function (d,i){
                    
        //     var root = targetElement
        //     var m = d3.mouse(root.node());
        //     m[0] += 0
        //     m[1] += 0
                
        //          groupsForStackedBarChart.on('mousemove', function (dd,j){
        //             tooltipForStackedBarChart.select('.label').html(finalNewNewArray[j].name)
        //             tooltipForStackedBarChart.select('.count').html(d.x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
        //             tooltipForStackedBarChart.style('visibility', 'visible')
        //             tooltipForStackedBarChart.select('hr').style("background-color", function(d){ return colours(j) })
        //             tooltipForStackedBarChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-20) + "px").style("display","block")
        //         })
        
        // })

        .on('mouseout', function(){ tooltipForStackedBarChart.style("display","none") })

        textOnStackedBarChart.on('mousemove', function (d,i){
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                
                tooltipForStackedHoriChart.select('.label').html(options.keys.label + " : " + d.y)
                tooltipForStackedBarChart.select('.count').html(d.x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
                tooltipForStackedBarChart.style('visibility', 'visible')
                tooltipForStackedHoriChart.select('hr').style("background-color", d3.select(this).style("fill") )
                tooltipForStackedBarChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-10) + "px").style("display","block")
        })
        .on('mouseout', function(){ tooltipForStackedBarChart.style("display","none") })

        // ----------------------- adding table section ------------------
        var tablePanelForStackedChart =  targetElement.append("div") .attr("id",targetElement[0][0].id + "holderForStackedChartTableID")
        .attr("class","scrollingDivForTable-Class tableDivForStackedBarChart" + targetElement[0][0].id)  .style('background-color',options.BGcolor)  .style('position','absolute')
        .style("display","block") .style("overflow","hidden") .style("width", function(d) {  return 100.0 + "%"; })
        .style("height", function(d) { return 40 + "%"; }) .style("left",0 + "%").style("z-index",10)
        
        $( '.tableDivForStackedBarChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        if(options.showTitle == true ){
            tablePanelForStackedChart.style("top",60.0  + "%")
        }
        else if(options.showTitle == false  ){
            tablePanelForStackedChart.style("top",60.0  + "%")
            
        }
        tablePanelForStackedChart.html('<table class = "tableClassForStackedChart' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                       '<thead class = "theadClassForStackedChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForStackedChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                                       '<tbody class = "tBodyClassForStackedChart' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                       '</table>'
                                       )
        
        tablePanelForStackedChart.select('table').attr("id",targetElement[0][0].id + "tableID")

        // Show or Hide Table scroll bar when mouseover on widget
        targetElement.on('mouseover',function(){ tablePanelForStackedChart.style("overflow","auto") })
        targetElement.on('mouseout',function(d){ tablePanelForStackedChart.style("overflow","hidden") })
        
        var tableDataForStkBarChart = [];
        if(options.dataForTable.length > 0){
            tableDataForStkBarChart = options.dataForTable;
        }
        else {
            tableDataForStkBarChart = options.data;
        }
        
        var thead = tablePanelForStackedChart.select("thead").selectAll("th") .data(d3.keys(tableDataForStkBarChart[0]))
        .enter().append("th") .text(function(d){return d.charAt(0) .toUpperCase() + d.substr(1)}) .style("cursor","pointer") .style("min-width","100px")
        
        var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff") //f4f4f4
        .style("position","relative")
        
        var thead1 = d3.select(".thead1ClassForStackedChart" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tableDataForStkBarChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff") //f4f4f4
        .style("position","relative")
        
        var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
        .attr("id", "ascendingIconIDForStackedBarChart") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
        
        var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
        .attr("id", "descendingIconIDForStackedBarChart") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
        
        var tr = tablePanelForStackedChart.select("tbody").selectAll("tr") .data(tableDataForStkBarChart).enter().append("tr")
        .attr("id", function(d,i) { return "slice" + i })
        
        // cells
        var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d})
        .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
        
        
        var $table = $('.tableClassForStackedChart' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
        
        d3.select(".theadClassForStackedChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
            d.forEach(function(dd,j){
                    colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
            })
        })
        
        $(".thead1ClassForStackedChart" + targetElement[0][0].id).insertAfter('.tBodyClassForStackedChart' + targetElement[0][0].id)
        
        $(".thead1ClassForStackedChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForStackedBarChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
        
        tablePanelForStackedChart.select(".thead1ClassForStackedChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                        d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
        })
        
        $('.tableDivForStackedBarChart' + targetElement[0][0].id).scroll(function () {
                                                                   
            $(".thead1ClassForStackedChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForStackedBarChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
                                                                   
        })
        
        var sortOrder = false;
        thead1.on("click",function(k,index){
                 
                 sortOrder = !sortOrder;
                 
                 tablePanelForStackedChart.select(".thead1ClassForStackedChart" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                                                              
                    if (sortOrder) {
                                      
                        if(i == index){
                            d3.select(this).select('svg').select('#descendingIconIDForStackedBarChart').style("visibility", "hidden")
                            d3.select(this).select('svg').select('#ascendingIconIDForStackedBarChart').style("visibility", "visible")
                        }
                        else {
                            d3.select(this).select('svg').select('#descendingIconIDForStackedBarChart').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForStackedBarChart').style("visibility", "visible")
                        }
                    }
                    else{
                                      
                        if(i == index){
                            d3.select(this).select('svg').select('#descendingIconIDForStackedBarChart').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForStackedBarChart').style("visibility", "hidden")
                        }
                        else {
                            d3.select(this).select('svg').select('#descendingIconIDForStackedBarChart').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForStackedBarChart').style("visibility", "visible")
                        }
                    }
                })
                 
                  var monthTruOrFalAryForStkBarChart = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
                  
                  tr.sort(function(a, b) {
                          
                          if (sortOrder) {
                          var monthsArrayForStkBarChart = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                          } else {
                          var monthsArrayForStkBarChart = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                          }
                          
                          monthTruOrFalAryForStkBarChart = []; gotMonthArray = [];
                          tableDataForStkBarChart.forEach(function(d,i){
                                  var da = d[k].toString().substring(0,3).toLowerCase()
                                  if(monthsArrayForStkBarChart.indexOf(da) >= 0){
                                      monthTruOrFalAryForStkBarChart.push(true)
                                      gotMonthArray.push(da);
                                  }
                                  else {
                                      monthTruOrFalAryForStkBarChart.push(false)
                                  }
                           })
                          
                          if(monthTruOrFalAryForStkBarChart.indexOf(false) == -1){ // true
                          
                          monthArray = []; monthArrayCount = [];
                          gotMonthArray.forEach(function(dd,j){
                                var index1 = monthsArrayForStkBarChart.indexOf(dd.substring(0,3))
                                if(monthArrayCount.indexOf(index1) >= 0){
                                    index1 = 12 + index1;
                                }
                                monthArray.push(index1);
                                monthArrayCount.push(index1)
                          })
                          returnArray = []
                          monthArray.sort(function(aa, bb) {
                                          returnArray.push(+aa - +bb)
                                          return +aa - +bb;
                                          })
                          
                          sortTableFunc()
                          return returnArray[ind++];
                          } //  if true (if jan feb if block)
                          else {
                          var data = +a[k];
                          
                          if(!isNaN(data)){
                          
                          if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                          else { return d3.descending(+a[k], +b[k]); }
                          }
                          else if(!isNaN(Date.parse(a[k]))){
                          
                          if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                          else { return new Date(b[k]) - new Date(a[k]) }
                          }
                          else {
                          
                          if (sortOrder) { return d3.ascending(a[k], b[k]); }
                          else { return d3.descending(a[k], b[k]); }
                          }
                          } // if not jan feb else block
                    }); // tr
                
		})
        
        function sortTableFunc(){
            
            var table = tablePanelForStackedChart.select('table');
            var rows = table.selectAll('tr').data(tableDataForStkBarChart);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0).style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500)
            .style('opacity', 1.0).style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
        }
        
        // Main Table Styling
        tablePanelForStackedChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
        .style("color","#00001c")
        .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4")
        tablePanelForStackedChart.selectAll('td').style("height","25px") .style("border", "1px solid #dddddd") .style("font-size","12px").style("font-weight","Normal").style("color","#00001c")

        //additionally 
        tablePanelForStackedChart.selectAll('th').style('background-color',"#ffffff").style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
        tablePanelForStackedChart.selectAll('td').style('background-color',"#ffffff").style("border-style","none").style("color","#2c2c2c").style("color","#00001c")

        //b1da9f
        tablePanelForStackedChart.selectAll('table') . style("border-collapse","collapse")
        tablePanelForStackedChart.selectAll('table tr:first-child th').style("border-top","0px")
        tablePanelForStackedChart.selectAll('table tr:last-child td').style("border-bottom","0px")
        tablePanelForStackedChart.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
        tablePanelForStackedChart.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")

        if(showOrHideTableForStkBarChart == false){
            tablePanelForStackedChart.style("display","none")
        }
        else if(showOrHideTableForStkBarChart == true){
            tablePanelForStackedChart.style("display","block")
        }

        if(options.isDataDetailedForTable == false){

            var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
        
            // Adding underlines for selected drill-down column text
            var drillDownSectionsForStackedChart = tablePanelForStackedChart.select('table').selectAll('th')
        
            var foundResult = [];
            for(var i = 0; i<drillDownSectionsForStackedChart[0].length; i++){
            
                for(var j = 0; j<drillDownColumnNamesArray.length; j++){
                    if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForStackedChart[0][i].__data__.toString().toLowerCase() ){
                        foundResult.push(i)
                    }
                }
            }
        
            var r = tablePanelForStackedChart.select('table').selectAll('tr').selectAll('td')
            for(var i = 0; i<r.length; i++){
                for(var j = 0; j < foundResult.length; j++){
                    var row = r[i][foundResult[j]]
                    $(row).css("text-decoration", "underline")
                }
            }
        }
        
        //By default calling the resized function first time (to align table's th and td).
        //resizedFuctionForStackedBarChart()
		
		setTimeout(function(){ resizedFuctionForStackedBarChart() },1000)
        
        window.addEventListener('resize', function(event){ resizedFuctionForStackedBarChart() });
        
        var xScale1GlobalVar; // storing the new yScale when parent div is resized.
        var yScale1GlobalVar; // storing the new yScale when parent div is resized.
        var newHeightVar; // storing the new height when parent div is resized.

        $(function() {
          
          $("#" + targetElement[0][0].id).resizable({
                    resize: function(event, ui) {
                        //divWidthForHoriChart = ui.size.width;
                        //divHeightForHoriChart = ui.size.height;
                        resizedFuctionForStackedBarChart();
                    }
                });
          });
        
        function resizedFuctionForStackedBarChart()
        {
            
            if((svgPanelForStackedBarChart.node().getBoundingClientRect().width) && (svgPanelForStackedBarChart.node().getBoundingClientRect().height) > 0){

                if(showOrHideCommentsBtnForStkBarChart == true){
                    filterBtnForStackedBarChart.style('margin-left', "2px")
                    refreshBtnForStackedBarChart.style('margin-left', "2px")
                    commentsBtnForStkBarChart.style('margin-left', "2px")
                    menuBtnForStackedBarChart.style('right', '0')
                }
                else if(showOrHideCommentsBtnForStkBarChart == false){
                    filterBtnForStackedBarChart.style('margin-left', "2px")
                    refreshBtnForStackedBarChart.style('margin-left', "2px")
                    //commentsBtnForStkBarChart.style('right', '0')
                    commentsBtnForStkBarChart.style('display','none')
                    menuBtnForStackedBarChart.style('right', '0')
                }

                optsBtnPanelForStkBarchart.style('right', '0')

                stgPanCanBtnForStkBarChart.style('right', '0')

               if(options.showTitle == true){
                
                    var margin1 = {top: 10 , right: 20, bottom: 80, left: 50}, //originally top: 42, left: 80
                    width1 = (svgPanelForStackedBarChart.node().getBoundingClientRect().width) - margin.left - margin.right,
                    height1 = (svgPanelForStackedBarChart.node().getBoundingClientRect().height) - margin.top - margin.bottom;
                    newHeightVar = height1
                }
                else if(options.showTitle == false){
                
                    var margin1 = {top: 10 , right: 20, bottom: 80, left: 50}, //originally top: 42, left: 80
                    width1 = (svgPanelForStackedBarChart.node().getBoundingClientRect().width) - margin.left - margin.right,
                    height1 = svgPanelForStackedBarChart.node().getBoundingClientRect().height - margin.top - margin.bottom;
                    newHeightVar = height1
                }

                var xMax1 =  d3.max(dataset, function (group) {
                    
                    return d3.max(group, function (d) {
                        return (+d.x) + (+d.x0);
                    });
                })

                var xScale2 = d3.scale.ordinal() .domain(months) .rangeRoundBands([0, width1], .20)
            
                var yScale2 = d3.scale.linear() .domain([0, xMax1]) .range([0, height1])
            
                xScale1GlobalVar = xScale2;
                yScale1GlobalVar = yScale2;

                xAxis.scale(xScale2) .orient('bottom')

                var svg1 = svgPanelForStackedBarChart;

                svg1.select("svg")
                //.attr("width", width1 + margin1.left + margin1.right)
                //.attr("height", height1 + margin1.top + margin1.bottom);

                svg1.select(".x.axis") .attr('transform', 'translate(0,' + height1 + ')') .call(xAxis)
                .selectAll("text") .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') 
                .attr("transform", function(d) 
                    { 
                        if(numberGreaterThanLimit.length>0){return "rotate(-45)"}
                    else{
                    return "rotate(0)" }}) 
                    .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
                    .text(function(d,i) {
                          if(d.length > 9)
                          return d.substring(0,9)+'...';
                          else
                          return d;
                          })
               

                xAxisVariable.attr("transform", "translate(" + ((width1/2) - 0) + " ," + (height1+margin1.bottom - 2) + ")")

                //rectsForStackedBarChart = groupsForStackedBarChart.selectAll('rect')
                //svg1.selectAll(".bar")
                groupsForStackedBarChart.selectAll('rect')
                .attr('x', function (d,i) { return xScale2(d.y); })
                .attr('y', function (d, i) { return height1 -yScale2(d.x0) - yScale2(d.x) })
                .attr("width", xScale2.rangeBand())
                .attr("height", function (d) { return yScale2(d.x); });
	
                textOnStackedBarChart
                .attr("x", function(d,i) { return xScale2(d.y)+xScale2.rangeBand()/2; })
                .attr("y", function(d) { return (height1 - yScale2(d.x0) - yScale2(d.x))+(yScale2(d.x)/1.5);})
            
                // Aligning Legend (vertically)
                var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelStackedBarChart[0][0].style.width) / 100)
                var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelStackedBarChart[0][0].style.height) / 100)

                var legendRectSize = 11;
                var legendSpacing = 4;
                
                legend.attr('transform', function(d, i) {
                var eachRectHeight = legendRectSize + legendSpacing;
                var offset =  eachRectHeight * colours.domain().length / 2;
                var horz = 5;
                var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.stackedBars.length))/2.0; // originally 2.0
                    
                    return 'translate(' + horz + ',' + vert + ')';
                })
                
                colWidth = []; 
				
                d3.select(".theadClassForStackedChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                        d.forEach(function(dd,j){
                            colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                        })
                })
                tablePanelForStackedChart.select(".thead1ClassForStackedChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                        d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
                })
                
            }// checking svg panel width & height greater than zero function

        }
    }, //stackedBarChart

    
    // ************************************************** Grouped Bar Chart  **************************************************
    groupedBarChart: function(targetElement, options){
        
        isChartCalled++;

        var chartName = "GROUPEDBARCHART";
       
        acinfotech.allCharts(targetElement,options,chartName)

        targetElement.style("min-width", "350px").style("min-height", "350px").style("background-color",options.BGcolor)
        var showOrHideTableForGroupedBarChart;
        var showOrHideCommentsForGroupedBarChart;
        var showOrHideCommentsBtnForGroupedBarChart = true;

        if((options.showTable == false) || (options.showTable == true)){
            showOrHideTableForGroupedBarChart = options.showTable    
        }
        else{
            showOrHideTableForGroupedBarChart = false;
        }

        // Show or Hide comments
        if (options.showComments == true || false) {
            showOrHideCommentsForGroupedBarChart = options.showComments;
        }
        else {
            showOrHideCommentsForGroupedBarChart = false;
        }

        if (options.comments.length == 0){ 
            showOrHideCommentsForGroupedBarChart = false;
            showOrHideCommentsBtnForGroupedBarChart = false;
        }
        
        if ((showOrHideTableForGroupedBarChart == true) && (showOrHideCommentsForGroupedBarChart == true)){
            showOrHideTableForGroupedBarChart = true;
            showOrHideCommentsForGroupedBarChart = false;
        }
        else if ((showOrHideTableForGroupedBarChart == false) && (showOrHideCommentsForGroupedBarChart == false)){
            showOrHideTableForGroupedBarChart = false;
            showOrHideCommentsForGroupedBarChart = false;
        }

        var chartTitlePanelForGroupedBarChart =  targetElement.append("div") .style("background-color",options.BGcolor) .style("position","absolute").style("text-indent","6px")
        
		var optsBtnPanelForGroupedBarChart = targetElement.append('div').style('width',"25px").style('height',"210px").style('position','absolute')
        .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px").style('right', '0')
        .style("min-width","25px").style("border-style","none").style("border-left", "solid #fcfcfc  1px")
		
        var stkCirAreaBtnForGrpBarChart = optsBtnPanelForGroupedBarChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','80px') .style("cursor","pointer").style("display","block")
        .style("border-style", "none").style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px") .style("box-sizing","border-box")
        var stkCirAreaBtnImgVar = document.createElement("IMG");
        stkCirAreaBtnImgVar.src = "images/circularAreaIcon.png";
        stkCirAreaBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.76;")
        stkCirAreaBtnForGrpBarChart[0][0].appendChild(stkCirAreaBtnImgVar)
        
        //If data set length is one
        if(options.data.length <= 1){
            stkCirAreaBtnForGrpBarChart.style("display","none")
        }
        
        var horiGrpBarBtnForGrpBarChart = optsBtnPanelForGroupedBarChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','105px') .style("cursor","pointer").style("display","block")
        .style("border-style", "none").style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px") .style("box-sizing","border-box")
        var horiGrpBarBtnImgVar = document.createElement("IMG");
        horiGrpBarBtnImgVar.src = "images/horiGrpBarIcon.png";
        horiGrpBarBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.9;")
        horiGrpBarBtnForGrpBarChart[0][0].appendChild(horiGrpBarBtnImgVar)

        var filterBtnForGroupedBarChart = optsBtnPanelForGroupedBarChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','130px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var filterBtnImgVar = document.createElement("IMG");
        filterBtnImgVar.src = "images/filterIcon.png";
        filterBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        filterBtnForGroupedBarChart[0][0].appendChild(filterBtnImgVar)

        var refreshBtnForGroupedBarChart = optsBtnPanelForGroupedBarChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','155px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var refreshBtnImgVar = document.createElement("IMG");
        refreshBtnImgVar.src = "images/refreshIcon.png";
        refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        refreshBtnForGroupedBarChart[0][0].appendChild(refreshBtnImgVar)

        var commentsBtnForGroupedBarChart = optsBtnPanelForGroupedBarChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','180px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var commentsBtnImgVariable = document.createElement("IMG");
        if(options.showComments == false){
            commentsBtnImgVariable.src = "images/showCommentsIcon.png";
        }
        else if(options.showComments == true){
            commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
        }
        commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        commentsBtnForGroupedBarChart[0][0].appendChild(commentsBtnImgVariable)

        var menuBtnForGroupedBarChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','1px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var menuBtnImgVar = document.createElement("IMG");
        menuBtnImgVar.src = "images/menuIcon.png";
        menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
        menuBtnForGroupedBarChart[0][0].appendChild(menuBtnImgVar)

        if(showOrHideCommentsBtnForGroupedBarChart == true){
            stkCirAreaBtnForGrpBarChart.style('margin-left', "2px")
            horiGrpBarBtnForGrpBarChart.style('margin-left', "2px")
            filterBtnForGroupedBarChart.style('margin-left', "2px")
            refreshBtnForGroupedBarChart.style('margin-left', "2px")
            commentsBtnForGroupedBarChart.style('margin-left', "2px")
            menuBtnForGroupedBarChart.style('right', '0')
        }
        else if(showOrHideCommentsBtnForGroupedBarChart == false){
            stkCirAreaBtnForGrpBarChart.style('margin-left', "2px")
            horiGrpBarBtnForGrpBarChart.style('margin-left', "2px")
            filterBtnForGroupedBarChart.style('margin-left', "2px")
            refreshBtnForGroupedBarChart.style('margin-left', "2px")
            //commentsBtnForGroupedBarChart.style('right', '0')
            commentsBtnForGroupedBarChart.style('display','none')
            menuBtnForGroupedBarChart.style('right', '0')
        }

        var ismenuBtnOfGroupedBarChartClicked = false;
        menuBtnForGroupedBarChart.on('click', function() {

            filterPanelForGroupedBarChart.style("display","none");
            stgPanDivForGroupedBarChart.style("display","none");

            stgPanDivForGroupedBarChart.style("display","none");

            if ((showOrHideTableForGroupedBarChart == false) && (showOrHideCommentsForGroupedBarChart == true)){
                divLegendPanelForGroupedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForGroupedBarChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
            }
            else if ((showOrHideTableForGroupedBarChart == true) && (showOrHideCommentsForGroupedBarChart == false)){
                divLegendPanelForGroupedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForGroupedBarChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
            }
            else if ((showOrHideTableForGroupedBarChart == false) && (showOrHideCommentsForGroupedBarChart == false)){
                divLegendPanelForGroupedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForGroupedBarChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
            }

            if(ismenuBtnOfGroupedBarChartClicked == false){
                ismenuBtnOfGroupedBarChartClicked = true;
                optsBtnPanelForGroupedBarChart.style("display","block")

            }
            else if(ismenuBtnOfGroupedBarChartClicked == true){
                ismenuBtnOfGroupedBarChartClicked = false
                optsBtnPanelForGroupedBarChart.style("display","none")
            }

            resizedFuctionForGroupedBarChart();
        })

        var tableButtonForGroupedBarChart = optsBtnPanelForGroupedBarChart.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top','1px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
        var tableBtnImgVar = document.createElement("IMG");
        if(showOrHideTableForGroupedBarChart == false){
            tableBtnImgVar.src = "images/showTableIcon.png";
            tableButtonForGroupedBarChart.attr("class","showTableClassForChartTable")
        }
        else if(showOrHideTableForGroupedBarChart == true){
            tableBtnImgVar.src = "images/cancelTableIcon.png";
            tableButtonForGroupedBarChart.attr("class","hideTableClassForChartTable")
        }
        tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
        tableButtonForGroupedBarChart[0][0].appendChild(tableBtnImgVar)

        var settingBtnForGroupedBarChart = optsBtnPanelForGroupedBarChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 28 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        var settingBtnImgVar = document.createElement("IMG");
        settingBtnImgVar.src = "images/settingsIcon.png";
        settingBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.82;")
        settingBtnForGroupedBarChart[0][0].appendChild(settingBtnImgVar)
        
        var downloadBtnForGroupedBarChart = optsBtnPanelForGroupedBarChart.append("div").attr("id","downloadBtnForGroupedBarChart-ID-" + targetElement[0][0].id)
        .style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff")
        .style('margin-left','2px').style('top', 54 + 'px').style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        
        acinfotech.downloadFunctionality("downloadBtnForGroupedBarChart-ID-" + targetElement[0][0].id,targetElement)
        
        var svgPanelForGroupedBarChart = targetElement .append('svg') 
        .attr("id","svgPanelIDForGroupedBarChart" + targetElement[0][0].id) .style("background-color",options.BGcolor).style("position","absolute")
        .style("border","0px solid #d0d0d0")

        var commentsPanelDivForGroupedBarChart = targetElement.append("div") .attr("class","commentsPanelClassForGrpBChart") 
        .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
		.style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
        .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)

        commentsPanelDivForGroupedBarChart.on('click',function(d){
            $('.commentsClassForGroupedBarChart' + targetElement[0][0].id).focus()
        })

        if(options.showTitle == true){
            
            chartTitlePanelForGroupedBarChart.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 8 + "%"; })
            .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')
                
            if ((showOrHideTableForGroupedBarChart == false) && (showOrHideCommentsForGroupedBarChart == true)){

                var commentsForGroupedBarChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                .css('line-height','1.1em').css('text-align','justify') .attr('class','commentsClassForGroupedBarChart' + targetElement[0][0].id)

                svgPanelForGroupedBarChart.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .style("background-color",options.BGcolor).append('g')
                commentsPanelDivForGroupedBarChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                .style("top",78 + "%")
                .html(commentsForGroupedBarChart[0].outerHTML.toString())

            }
            else if ((showOrHideTableForGroupedBarChart == true) && (showOrHideCommentsForGroupedBarChart == false)){

                svgPanelForGroupedBarChart.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .style("background-color",options.BGcolor).append('g')
                commentsPanelDivForGroupedBarChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForGroupedBarChart == false) && (showOrHideCommentsForGroupedBarChart == false)){

                svgPanelForGroupedBarChart.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .style("background-color",options.BGcolor).append('g')
                commentsPanelDivForGroupedBarChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            
            var margin = {top: 50 , right: 20, bottom: 80, left: 50}, //originally top: 42, left: 80
            width = (svgPanelForGroupedBarChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = (svgPanelForGroupedBarChart.node().getBoundingClientRect().height) - margin.top - margin.bottom;
            
        }
        else if(options.showTitle == false){
            chartTitlePanelForGroupedBarChart.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });
            
            if ((showOrHideTableForGroupedBarChart == false) && (showOrHideCommentsForGroupedBarChart == true)){

                var commentsForGroupedBarChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                .attr('contenteditable',false).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                .css('line-height','1.1em').css('text-align','justify')

                svgPanelForGroupedBarChart.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .style("background-color",options.BGcolor).append('g')
                commentsPanelDivForGroupedBarChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                .style("top",78 + "%")
                .html(commentsForGroupedBarChart[0].outerHTML.toString())

            }
            else if ((showOrHideTableForGroupedBarChart == true) && (showOrHideCommentsForGroupedBarChart == false)){

                svgPanelForGroupedBarChart.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%").style("background-color",options.BGcolor) .append('g')
                commentsPanelDivForGroupedBarChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForGroupedBarChart == false) && (showOrHideCommentsForGroupedBarChart == false)){

                svgPanelForGroupedBarChart.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%").style("background-color",options.BGcolor) .append('g')
                commentsPanelDivForGroupedBarChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }

            var margin = {top: 50, right: 20, bottom: 80, left: 50}, //originally top: 42, left: 80
            width = (svgPanelForGroupedBarChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = svgPanelForGroupedBarChart.node().getBoundingClientRect().height - margin.top - margin.bottom;
        }

        var colours;

        // checking color set for bars and legend dots
        if(options.colorSet === undefined){
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "one"){
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            options.colorSet = "two"
            colours = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            options.colorSet = "three"
            colours = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        }
        else
        {
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }

        /*------------------ Settings panel DIV and everything within it section begins here ------------------*/
        
        var stgPanDivForGroupedBarChart = targetElement.append('div').style('width',"100%").style('height',"40%").attr("class","stgPanDivForGroupedBarChart" + targetElement[0][0].id)
        .style('position','absolute').style('margin-left', "0px").style('border-top',"1px solid #f0f0f0").style('border-bottom',"1px solid #e5e5e5")
        .style("background-color",'#fcfcfc').style("z-index",90) .style("display","none") .style('top', 60.0 + "%") .style('height',40 + "%")

        $( '.stgPanDivForGroupedBarChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        var settingPanelTitle = stgPanDivForGroupedBarChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','10px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; color:#00001c;">'+ "Settings" +'</div>')

        var stgPanDivForGrpChangeColorTitle = stgPanDivForGroupedBarChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Select color set " +'</div>')

        var stgPanCanBtnForGroupedBarChart = stgPanDivForGroupedBarChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
        .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
        .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.9; background-color:#fcfcff")
        stgPanCanBtnForGroupedBarChart[0][0].appendChild(cancelBtnImgVar)

        stgPanCanBtnForGroupedBarChart.on('click', function() {
            stgPanDivForGroupedBarChart.style("display","none") // Hiding setting panel

            if ((showOrHideTableForGroupedBarChart == false) && (showOrHideCommentsForGroupedBarChart == true)){
                divLegendPanelForGroupedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForGroupedBarChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
            }
            else if ((showOrHideTableForGroupedBarChart == true) && (showOrHideCommentsForGroupedBarChart == false)){
                divLegendPanelForGroupedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForGroupedBarChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
            }
            else if ((showOrHideTableForGroupedBarChart == false) && (showOrHideCommentsForGroupedBarChart == false)){
                divLegendPanelForGroupedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForGroupedBarChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
            }

            resizedFuctionForGroupedBarChart();
        })

        var formForChangeSettingsPanel = stgPanDivForGroupedBarChart.append("form");
        formForChangeSettingsPanel.style("background-color","#fcfcfc").style("margin-top","67px").style("font-family","Verdana,sans-serif").style("font-size","12px")
        .style("position","absolute").attr("id","formForChangeColorSettingsPanel" + targetElement[0][0].id).style("font-weight","Bold").style("width","180px")
        .style("height","58px").style("padding","0px").style("border-radius","0px") .style("margin-left","10px")

        var svgPanelForCrSetOne = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px").style("height","18px").style("margin-top","1px").style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetOne = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        var colorSetOneRange = d3.range(12);

        var colorSetOneDots = svgPanelForCrSetOne.append("g")
        colorSetOneDots.selectAll('rect') .data(colorSetOneRange) .enter() .append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("fill", function(d,i){return colorSetOne(i)})
        .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetOne(i); })
        .style("cursor","auto") .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        var svgPanelForCrSetTwo = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px") .style("margin-top","20px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetTwo = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        var colorSetTwoRange = d3.range(12);

        var colorSetTwoDots = svgPanelForCrSetTwo.append("g")
        colorSetTwoDots.selectAll('rect') .data(colorSetTwoRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto")
        .style("fill", function(d,i){return colorSetTwo(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
        .style("stroke",function(d,i){  return colorSetTwo(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        var svgPanelForCrSetThree = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px") .style("margin-top","39px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetThree = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        var colorSetThreeRange = d3.range(12);

        var colorSetThreeDots = svgPanelForCrSetThree.append("g")
        colorSetThreeDots.selectAll('rect') .data(colorSetThreeRange) .enter().append('rect')
        .attr('transform', 'translate(' + (2) + ',' + (1) + ')') .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10)
        .attr("height",10) .style("cursor","auto") .style("fill", function(d,i){return colorSetThree(i)}) .style("fill-opacity",0.93)
        .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetThree(i);  })
        .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        if(options.colorSet.toString().toLowerCase() === "one"){
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"1px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"1px solid #808080")
        }
        else 
        {
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }

        svgPanelForCrSetOne.on('click',function(d){
            options.colorSet = "one"
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")

            colours = "";
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);

            groups.style('fill', function (d, i) {
                return colours(i);
            })

            legendGroup.style("fill", function(d, i){ return colours(i);})
        
        })
        svgPanelForCrSetTwo.on('click',function(d){
            options.colorSet = "two"
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"1px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")

            colours = "";
            colours = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);

            groups.style('fill', function (d, i) {
                return colours(i);
            })
            legendGroup.style("fill", function(d, i){ return colours(i);})
        })
        svgPanelForCrSetThree.on('click',function(d){
            options.colorSet = "three"
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"1px solid #808080")

            colours = "";
            colours = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);

            groups.style('fill', function (d, i) {
                return colours(i);
            })
            legendGroup.style("fill", function(d, i){ return colours(i);})
        })
        // setting panel ends here 
        
        stkCirAreaBtnForGrpBarChart.on('click', function() {
                                       
            //isFilterClicked = false
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                                       
            var newOptions = {
                data: options.data,
                dataForDrillDown: options.dataForDrillDown,
                dataForTable: options.dataForTable,
                isDataDetailedForTable: options.isDataDetailedForTable,
                keys: {
                    label: options.keys.label,
                    stackedAreas: options.keys.groupBars,
                },
                chartTitle: options.chartTitle,
                //xAxisLable: options.xAxisLable,
                //yAxisLable: "",
                showTitle: options.showTitle,
                colorSet: options.colorSet,
                BGcolor:options.BGcolor,
                drillDownColumnName:options.drillDownColumnName,
                showTable: false,
                showComments: false,
                comments: options.comments,
                resizeButtonID: options.resizeButtonID
                                    
                }
            
            acinfotech.stackedCircularAreaChart(targetElement, newOptions)
        })
        
        // Horizontal Grouped Bar Chart and Table 
        horiGrpBarBtnForGrpBarChart.on('click', function() {

            //isFilterClicked = false
           d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData;
                    //options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.groupBars;
                    if(newtargetElementAndOptionsArray[i].options.keys.groupBars == undefined){
                        options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.stackedAreas;
                    }
                    else {
                        options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.groupBars;
                    }
                    options.yAxisLable = options.xAxisLable;
                    options.xAxisLable = "";
                    options.showTable = false;
                    options.showComments = false;
                    options.BGcolor=options.BGcolor;
                }
            }
            
            acinfotech.horizontalGroupedBarChart(targetElement,options) 

        })

        // Filter
        filterBtnForGroupedBarChart.on('click', function() {

            filterPanelForGroupedBarChart.style("display","block");

            ismenuBtnOfGroupedBarChartClicked = false;
            optsBtnPanelForGroupedBarChart.style("display","none");

            stgPanDivForGroupedBarChart.style("display","none");

            if ((showOrHideTableForGroupedBarChart == false) && (showOrHideCommentsForGroupedBarChart == true)){
                divLegendPanelForGroupedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForGroupedBarChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
            }
            else if ((showOrHideTableForGroupedBarChart == true) && (showOrHideCommentsForGroupedBarChart == false)){
                divLegendPanelForGroupedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForGroupedBarChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
            }
            else if ((showOrHideTableForGroupedBarChart == false) && (showOrHideCommentsForGroupedBarChart == false)){
                divLegendPanelForGroupedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForGroupedBarChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
            }

            resizedFuctionForGroupedBarChart();

        })

        // Refreshing Chart and Table 
        refreshBtnForGroupedBarChart.on('click', function() {

            //isFilterClicked = false
           d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData;
                    //options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.groupBars;
                                        
                    if(newtargetElementAndOptionsArray[i].options.keys.groupBars == undefined){
                        options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.stackedAreas;
                    }
                    else {
                        options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.groupBars;
                    }
                }
            }
            acinfotech.groupedBarChart(targetElement,options) 

        })

        commentsBtnForGroupedBarChart.on('click', function() {

            if(options.showComments == false){
                options.showComments = true;
            }
            else if(options.showComments == true){
                options.showComments = false;
            }

            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                                         
                    if(newtargetElementAndOptionsArray[i].options.keys.groupBars == undefined){
                        options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.stackedAreas;
                    }
                    else {
                        options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.groupBars;
                    }
                    options.showTable = false;
                }
            }
            acinfotech.groupedBarChart(targetElement,options)

        })

        // showing/hidding chart table
        tableButtonForGroupedBarChart.on('click', function() {

            if(showOrHideTableForGroupedBarChart == false){
                options.showTable = true;
                //showOrHideTableForPieChart = true
            }
            else if(showOrHideTableForGroupedBarChart == true){
                //showOrHideTableForPieChart = false
                options.showTable = false;
            }

            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                                         
                    if(newtargetElementAndOptionsArray[i].options.keys.groupBars == undefined){
                        options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.stackedAreas;
                    }
                    else {
                        options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.groupBars;
                    }
                                         
                    options.showComments = false;
                }
            }
            acinfotech.groupedBarChart(targetElement,options)

        })

        
        settingBtnForGroupedBarChart.on('click', function() {
                
			ismenuBtnOfGroupedBarChartClicked = false; // Menu toggle button variable
			optsBtnPanelForGroupedBarChart.style("display","none") // To hide options button panel

			iconButtonTooltipForGroupedBarChart.style("display","none") // Removing options button ToolTip
			settingBtnForGroupedBarChart.style("cursor","pointer")
			
			stgPanDivForGroupedBarChart.style("display","block") // Showing settings panel

			svgPanelForGroupedBarChart.style('width', 75 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color",options.BGcolor); // Decreasing chart panel
			divLegendPanelForGroupedBarChart.style('width', 25 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color",options.BGcolor); // Decreasing chart panel

			resizedFuctionForGroupedBarChart(); // Calling resize function()

        })
        
        downloadBtnForGroupedBarChart.on('click', function() {
                                  
            ismenuBtnOfGroupedBarChartClicked = false; // Changing menu button value to false
            optsBtnPanelForGroupedBarChart.style("display","none") // Hiding option buttons panel
                                  
        })
        
        // Creating ToolTip for options button.
        var iconButtonTooltipForGroupedBarChart = targetElement.append('div').style('width','240px').attr("id","too")
        .style('height',"25px").style('position','absolute')//.style('margin-left', "0px").style('top','25px')
        .style("background-color",'#404040 ').style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid") // 004b9d
        .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none").attr("border", 0.0)
        
        stkCirAreaBtnForGrpBarChart.on('mousemove', function(d,i) {
               var root = targetElement
               var m = d3.mouse(root.node());
               m[0] += 0
               m[1] += 0
               var horiGrpBtnTooltipText = "Stacked Circular Area Chart";
               
               iconButtonTooltipForGroupedBarChart.style("width","176px").style("margin-left", (m[0] - 186) + "px").style("margin-top",(m[1]) + "px").style("display","block")
               iconButtonTooltipForGroupedBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ horiGrpBtnTooltipText +'</div>')
                                       
		})
        stkCirAreaBtnForGrpBarChart.on('mouseout', function(d,i) {
               iconButtonTooltipForGroupedBarChart.style("display","none")
		})
        
        horiGrpBarBtnForGrpBarChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var horiGrpBtnTooltipText = "Horizontal Grouped Bar Chart";
            
            iconButtonTooltipForGroupedBarChart.style("width","176px").style("margin-left", (m[0] - 186) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForGroupedBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ horiGrpBtnTooltipText +'</div>')

        })
        horiGrpBarBtnForGrpBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForGroupedBarChart.style("display","none")
        })

        filterBtnForGroupedBarChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var filterButtonTooltipText = "Filter";
            
            iconButtonTooltipForGroupedBarChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForGroupedBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')

        })
        filterBtnForGroupedBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForGroupedBarChart.style("display","none")
        })

        refreshBtnForGroupedBarChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var refreshButtonTooltipText = "Refresh";
            
            iconButtonTooltipForGroupedBarChart.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForGroupedBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ refreshButtonTooltipText +'</div>')

        })
        refreshBtnForGroupedBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForGroupedBarChart.style("display","none")
        })
        
        commentsBtnForGroupedBarChart.on('mousemove', function(d,i) {
            commentsPanelDivForGroupedBarChart.style('background-color','#fafafa')
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                if(options.showComments == false){
                    var commentButtonTooltipText = "Show Comments";
                }
                else if(options.showComments == true){
                    var commentButtonTooltipText = "Hide Comments";
                }
            
            
            iconButtonTooltipForGroupedBarChart.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForGroupedBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ commentButtonTooltipText +'</div>')
        })
        commentsBtnForGroupedBarChart.on('mouseout', function(d,i) {
            commentsPanelDivForGroupedBarChart.style('background-color','#ffffff')
            iconButtonTooltipForGroupedBarChart.style("display","none")
        })

        menuBtnForGroupedBarChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var menuButtonTooltipText = "Menu";
            
            iconButtonTooltipForGroupedBarChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForGroupedBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ menuButtonTooltipText +'</div>')

        })
        menuBtnForGroupedBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForGroupedBarChart.style("display","none")
        })

        tableButtonForGroupedBarChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                if(showOrHideTableForGroupedBarChart ==  false){
                    var tableButtonTooltipText = "Show Table";
                }
                else if(showOrHideTableForGroupedBarChart == true){
                    var tableButtonTooltipText = "Hide Table";
                }
            
            
            iconButtonTooltipForGroupedBarChart.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForGroupedBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ tableButtonTooltipText +'</div>')

        })
        tableButtonForGroupedBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForGroupedBarChart.style("display","none")
        })

        settingBtnForGroupedBarChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var settingTooltipText = "Settings";
            
            iconButtonTooltipForGroupedBarChart.style("width","67px").style("margin-left", (m[0] - 77) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForGroupedBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ settingTooltipText +'</div>')
        })
        settingBtnForGroupedBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForGroupedBarChart.style("display","none")
        })

        downloadBtnForGroupedBarChart.on('mousemove', function(d,i) {
              var root = targetElement
              var m = d3.mouse(root.node());
              m[0] += 0
              m[1] += 0
              var downloadButtonTooltipText = "Download";
              
              iconButtonTooltipForGroupedBarChart.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
              iconButtonTooltipForGroupedBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
        })
        downloadBtnForGroupedBarChart.on('mouseout', function(d,i) {
              iconButtonTooltipForGroupedBarChart.style("display","none")
        })
        
         // ----------------- Filter panel and everything within it section begins here ----------------
        var filterPanelForGroupedBarChart = targetElement.append('div').style('width',350 + "px") .attr("class","filterPanelForGrpBarChartClass" + targetElement[0][0].id)
        .style('position','absolute').style('margin-left', "0px")
        .style("background-color",'#fefefe').style("z-index",11).style("border-color", "#ffffff").style("border-right", "solid #e5e5e5 1px")  .style("border-style", "solid") // 004b9d
        .style("box-shadow", "2px 0px 1px #eff8ec").style("display","none").style("border-top", "solid #fdfdfd 1px").style("border-left","0px").style("border-bottom", "0px")
        .style('top', 0.0 + "%").style('height', 100 + "%").style('overflow-y',"hidden").style("overflow-x","hidden")
        .style("border-bottom", "solid #e5e5e5 1px") .style("box-sizing","border-box")

        var filterPanelForGrpBarChartTitle = filterPanelForGroupedBarChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','20px').style('text-indent','5px').style("font-size", "14px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #007aff").style("width","350px").style("color","#000000")
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; top:25.0%; font-size:14px; font-family:inter; color:#00001c;">'+ "Filter" +'</div>')

        var measuresColumnTitle = filterPanelForGroupedBarChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; text-indent:3px;">Available Measures</div>');

        var measuresVariables = filterPanelForGroupedBarChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable1"+targetElement[0][0].id)
        .style("list-style-type","none")
        .style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '78px')
        .style('position','absolute')
        .style("width","155px").style("min-height","190px").style("max-height","190px").style("border", "#f0f0f0 1px solid")
        .style("max-width","155px").style("overflow-x","hidden").style("overflow-y","auto")
        measuresVariables.style("left",0.0 + "px").style("padding","2px")

        $( ".filterPanelForGrpBarChartClass" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        var measuresArray = [];
        var dimensionArray = [];

        var measuresArrayLength = [];
        var dimensionsArrayLength = [];

        dimensionArray.push(options.keys.label);
        //measuresArray = options.keys.stackedBars;

        for(var i = 0; i<divAndChartsArray.length; i++){
            if(targetElement[0][0].id === divAndChartsArray[i].divID){
                
                //measuresArray = newtargetElementAndOptionsArray[i].options.keys.groupBars;
                if(newtargetElementAndOptionsArray[i].options.keys.groupBars == undefined){
                    measuresArray = newtargetElementAndOptionsArray[i].options.keys.stackedAreas;
                }
                else {
                    measuresArray = newtargetElementAndOptionsArray[i].options.keys.groupBars;
                }
            }
        }
        
        // filter process
        var uniqueMeasuresArrayKeys = [];
        $.each(measuresArray, function(i, el){
            if($.inArray(el, uniqueMeasuresArrayKeys) === -1){
                uniqueMeasuresArrayKeys.push(el);
            }
        });

        var uniqueDimensionArrayKeys = [];
        $.each(dimensionArray, function(i, el){
            if($.inArray(el, uniqueDimensionArrayKeys) === -1){
                uniqueDimensionArrayKeys.push(el);
            }
        });
        
        // setting lenght for arrays
        for(var i = 0; i<uniqueMeasuresArrayKeys.length; i++){
            measuresArrayLength.push(i);
        }

        for(var i = 0; i<uniqueDimensionArrayKeys.length; i++){
            dimensionsArrayLength.push(i);
        }

        var measuresVariables1 = measuresVariables.selectAll("li") .data(measuresArrayLength).enter().append("li")
        .style("width","130px") .style("max-height","22px").style("cursor","move")
        .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#bcf1bc").style("font-weight","Normal")
        .style("list-style-type","none").style("border","1px #89e789 solid").style("color","#006600").style("font-family","Verdana,sans-serif")
        .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
        .text(function(d) {return uniqueMeasuresArrayKeys[d]})
        measuresVariables1.attr("class","MeasuresClass"+targetElement[0][0].id)
        
        var measuresColumnReceivedUI_TableTitle = filterPanelForGroupedBarChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','180px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; ">Selected Measures</div>');

        var measuresColumnReceivedUI_Table = filterPanelForGroupedBarChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable3"+targetElement[0][0].id)
        .style('background-color',"#ffffff").style('margin-left','180px').style('margin-top', '78px')
        .style("width","155px").style('position','absolute').style("padding","2px").style("min-height","190px")
        .style("border","1px #c1c1c1 dashed") .style("max-height","190px") .style("overflow-x","hidden") .style("overflow-y","auto")
        //.html('<div class=unsortable  style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:65.0%; font-size:14px; font-family:inter;  color:#99ea99; font-weight:Normal; text-align:center;">Drag and Drop Measures here from Available Measures List. </div>');
        .html('<img class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' src="images/dragIcon.png" style=" width:36px; height:36px; position:absolute; margin-left:65px; margin-top:60px; opacity:0.6"/>' 
        + '<div class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:60.0%; font-size:12px; font-family:inter;  color:#89d289; font-weight:Normal; text-align:center;">Drop Measures here. </div>');
        //.html('<div style="background-image: url(images/dragIcon.png); height: 64px; width: 64px; border: 1px solid black;"> </div>');

        var cancelButton = filterPanelForGroupedBarChart.append("div") .style("width","23px").style("height","21px").style('position','absolute')
        .style('margin-left','320px').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
        .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.9; background-color:#fcfcff")
        cancelButton[0][0].appendChild(cancelBtnImgVar)

        cancelButton.on("click", function(){
            filterPanelForGroupedBarChart.style("display","none")

            if ((showOrHideTableForGroupedBarChart == false) && (showOrHideCommentsForGroupedBarChart == true)){
                divLegendPanelForGroupedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForGroupedBarChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
            }
            else if ((showOrHideTableForGroupedBarChart == true) && (showOrHideCommentsForGroupedBarChart == false)){
                divLegendPanelForGroupedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForGroupedBarChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
            }
            else if ((showOrHideTableForGroupedBarChart == false) && (showOrHideCommentsForGroupedBarChart == false)){
                divLegendPanelForGroupedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForGroupedBarChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
            }

        })

        var reRenderChartAndTableButton = filterPanelForGroupedBarChart.append("button").style("width","120px").style("height","25px").style('position','absolute')
        .style('margin-left','112px').style('margin-top','298px') .style("border-style", "none").style('background-color',"#2196f3")
        .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','15px').style("border-style", "solid").style('color','#ffffff')
        .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 1px #9b9b9b").style("border-radius","0px")
        var textForReRenderButton = document.createTextNode("Apply Changes");
        reRenderChartAndTableButton[0][0].appendChild(textForReRenderButton)

        reRenderChartAndTableButton.on("click", function(){

            if( $("#sortable3"+targetElement[0][0].id).children("li").length == 0 )
            {

                var alertPageDisabledDivForGrpBarChart =targetElement.append('div').style('width',100 + '%')
                .style('height',100 + "%").style('position','absolute').style('margin-left', '0px').style('top', '0px')
                .style("background-color",'#f3f3f3').style("z-index",99)//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("opacity",0.2).style("display","block")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")

                var alertDivForGrpBarChart = targetElement.append('div').style('width','350px')
                .style('height',"150px").style('position','absolute').style('left', ((targetElement[0][0].clientWidth/2) - 175) + "px").style('top', '1px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "solid").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","0px")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
                //.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Bold;">Sorry, no result found for selected' + 'range!'+ '</br>' + '<label style=text-indent:10px;> Hello</label' +'</div>')
                .html('<p  style="width: 340px; height:0%; background-color:#c7c7c7; position: absolute; top:40.0%; font-size:14px; font-family:inter; font-weight:Bold; margin-left:10px;  color:#f8f8f8; font-weight:Normal;">Check whether the Selected Measures box is not empty!</p>')

                var alertDivTitleForGrpBarChart = alertDivForGrpBarChart.append('div').style('width','340px')
                .style('height',"30px").style('position','absolute').style('margin-left', "0px").style('top', '0px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "none").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","2px")
                .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; font-weight:Bold; text-indent:5px;  color:#e5e5e5; font-weight:Normal;">TimeBound</div>')

                var grpBarChartAlertOKButton = alertDivForGrpBarChart.append("button") .style("width","40px") .style("height","20px") .style('position','absolute') .style("box-shadow", "0px 1px 1px #B8B8B8") 
                .style('background-color',"#7cc15e") .style('margin-left','300px') .style('top', "120px").style("color","#ffffff")
                .style("display","block").style('padding-top',"0px").style("cursor","pointer").style("box-shadow", "1px 1px 1px #56973a") .style("border-style", "none")
                .style("font-family","Verdana,sans-serif").style("font-size","14px").style("text-align","center").style("vertical-align","middle").style("border-radius","0px")
                .style("z-index",999)
            
                var textForGrpBarChartAlertOKButton = document.createTextNode("OK");
                grpBarChartAlertOKButton[0][0].appendChild(textForGrpBarChartAlertOKButton)

                $("#"+targetElement[0][0].id).resizable('disable');

                grpBarChartAlertOKButton.on('click', function() {
                    alertDivForGrpBarChart.remove();
                    alertPageDisabledDivForGrpBarChart.remove()
                    $("#"+targetElement[0][0].id).resizable('enable');
                })

                filterBtnForGroupedBarChart.style("cursor","pointer")
                
                if(showOrHideTableForGroupedBarChart == false){ 
                    svgPanelForGroupedBarChart.style('width', 75 + "%") .style('height', 85 + "%").style("position","absolute").style("background-color",options.BGcolor)
                    divLegendPanelForGroupedBarChart.style('width', 25 + "%") .style('height', 85 + "%").style("position","absolute").style("background-color",options.BGcolor)
                }   
                else if(showOrHideTableForGroupedBarChart == true){ 
                    svgPanelForGroupedBarChart.style('width', 75 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color",options.BGcolor)
                    divLegendPanelForGroupedBarChart.style('width', 25 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color",options.BGcolor)
                } 

                resizedFuctionForGroupedBarChart();
            }

            else{

                var selectedGroupMeasures = [];
                for(var i=0; i<$("#sortable3"+targetElement[0][0].id).children("li").length;i++){
                    selectedGroupMeasures.push($("#sortable3"+targetElement[0][0].id).children("li")[i].textContent)
                }
            
                var newOptions = {
                           data: options.data,
                           dataForDrillDown: options.dataForDrillDown,
                           dataForTable: options.dataForTable,
                           isDataDetailedForTable: options.isDataDetailedForTable,
                           keys: {
                               label: options.keys.label,//$("#sortable4"+targetElement[0][0].id).children("li")[0].textContent.toString(),
                               groupBars: selectedGroupMeasures,
                           },
                           chartTitle:options.chartTitle,
                           xAxisLable: options.keys.label,//$("#sortable4"+targetElement[0][0].id).children("li")[0].textContent,
                           yAxisLable: options.yAxisLable,
                           //dimensions: options.dimensions,
                           //measures: options.measures,
                           showTitle: true,
                           colorSet: options.colorSet,
                           BGcolor:BGcolor,
                           drillDownColumnName:options.drillDownColumnName,
                           showTable: options.showTable,
                           showComments: options.showComments,
                           comments: options.comments,
                           resizeButtonID: options.resizeButtonID //document.getElementById("resizeBtn").id
                        }
                        
                        d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                        acinfotech.groupedBarChart(targetElement,newOptions)
                }
            
		})

        var textBoxForMeasureColumnFrom;
        var textBoxForMeasureColumnTo;
        var selectTitleDivForEachDimension;

       
        $( "ul.droptrue"+targetElement[0][0].id ).sortable({
            appendTo: document.body,
            helper: "clone",
            connectWith: ".droptrue"+targetElement[0][0].id,
            scroll: false,
            cancel: '.unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+','+' .unMoveableIconAndTextClassDimensions'+targetElement[0][0].id,
            revertDuration: 10,
            scrollSensitivity: 10,
            scrollSpeed: 1,
            dynamic: true,

            receive: function(e, ui) { 
                 
                if (($(this)[0].id == "sortable3"+targetElement[0][0].id) || ($(this)[0].id == "sortable1"+targetElement[0][0].id)) {

                        if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                            if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                                 (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                            }
                            else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                                (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                            }

                        }
                } // if (($(this)[0].id == "sortable3") || ($(this)[0].id == "sortable1")) 

                else if (($(this)[0].id == "sortable2"+targetElement[0][0].id) || ($(this)[0].id == "sortable4"+targetElement[0][0].id)) {
                    if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                            //ui.sender.sortable("cancel");

                            if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                                 (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                            }
                            else if(  ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                                (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                            }
                        }
                } //if (($(this)[0].id == "sortable2") || ($(this)[0].id == "sortable4")) {

                $(ui.item).css({ 'position': 'relative' });

                if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                    ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                }
                 
                else if ($(this)[0].id == "sortable3"+targetElement[0][0].id) { // checking if the dropped element is in Measures drop area
                    
                    if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                        ui.sender.sortable("cancel");
                    }
                    else {
                        //ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                    }

                } // else if ($(this)[0].id == "sortable3") // checking if the dropped element is in Measures drop area ends here.

                else if ($(this)[0].id == "sortable4"+targetElement[0][0].id) { // checking if the dropped element is in Dimension drop area

                    if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                        ui.sender.sortable("cancel");
                    }
                    else {
                        ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                    }
                } //else if ($(this)[0].id == "sortable4")  // checking if the dropped element is in Dimension drop area ends here

                    if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                        
                        if ($(this)[0].id == "sortable1"+targetElement[0][0].id){
                            if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                            
                                if( ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                                    ui.sender.sortable("cancel");
                                } // if(  ui.sender.attr("id") === "sortable4")

                                else if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                                    ui.sender.sortable("cancel");
                                }
                            
                            } // if(ui.item.hasClass("DimesionsClass"))
                        }
                    if ($(this)[0].id == "sortable2"+targetElement[0][0].id){
                        if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                            
                            if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                                ui.sender.sortable("cancel");
                            }
                            else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                                ui.sender.sortable("cancel");
                               
                            }
                        }
                    }

                } //if ($(this)[0].id == "sortable1")

                if ($(this)[0].id == "sortable4"+targetElement[0][0].id){
                    if ($(this).children('li').length > 1 ){
                        ui.sender.sortable("cancel");
                        ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                    }    
                }

            }, //receive ends here

            start:function(ev, ui) {
                
            },
            stop:function(ev, ui) {
               
            },
        });
      
        /* ----------------- Filter panel and everything within it section ends here -----------------*/

        //-------- creating tooltip --------

        var tooltipForGroupedBarChart = targetElement .append('div') .attr('class', 'tooltipPie') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
        .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
        .style("padding-right", "7px") .style("background", "#F8F8F8") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style('z-index',1000)
        .style("border", "1.0px") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","80px")
        tooltipForGroupedBarChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'label').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "14px") .style("font-weight", "normal");
        tooltipForGroupedBarChart.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
        tooltipForGroupedBarChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");
        
        
        // if chart is changed (before or after resize button click)
        var optionsKey = {};
        if(options.keys.groupBars == undefined){
            optionsKey["label"] = options.keys.label;
            optionsKey["groupBars"] = options.keys.stackedAreas;
            
            options.keys = {};
            options.keys["label"] = optionsKey.label;
            options.keys["groupBars"] = optionsKey.groupBars;
            options.xAxisLable = optionsKey.label;
        }
        
        
        var finalArrayNew = [];
        options.keys.groupBars.forEach(function(d, i) {
    
            var temp1 = {};
            temp1["name"] = options.keys.groupBars[i]
    
            finalArrayNew.push(temp1)
        })
        
        var finalNewNewArray = [];
        var dataArray1 = [];
        finalArrayNew.forEach(function(d, i) {
    
            var temp1 = {};
            temp1["name"] = options.keys.groupBars[i]
    
            for (j = 0; j < options.data.length; j++) {
                
                var tempTemp = {};
                tempTemp["label"] = options.data[j][options.keys.label];
                tempTemp["value"] = +options.data[j][options.keys.groupBars[i]];

                dataArray1.push(tempTemp)
            }
            
                temp1["data"] = dataArray1;
                dataArray1 = []
                finalNewNewArray.push(temp1)
        })


        var dataset = finalNewNewArray.map(function (d) {
        return d.data.map(function (o, i) {
                // Structure it so that your numeric
                // axis (the stacked amount) is y
                return {
                    y: o.value,
                    x: o.label
                };
            });
        }),
        xMax = d3.max(dataset, function (group) {
            return d3.max(group, function (d) {
                return d.y
            });
        })

        var xAxisLabels = dataset[0].map(function (d) { return d.x; });

        var y = d3.scale.linear() .domain([0, xMax]) .range([height, 0]);

        var x0 = d3.scale.ordinal() .domain(d3.range(xAxisLabels.length)) .rangeBands([0, width], .28);

        var x1 = d3.scale.ordinal() .domain(d3.range(finalNewNewArray.length)) .rangeBands([0, x0.rangeBand()]);

        var xAxis = d3.svg.axis() .scale(x0) .orient("bottom");

        var yAxis = d3.svg.axis() .scale(y) .ticks(5) .orient("left");
        
        var hasDecimalPoint = false;
        for(var i = 0; i < options.keys.groupBars.length; i++){
            for(var j = 0; j < options.data.length; j++){
                if(options.data[j][options.keys.groupBars[i]].toString().indexOf('.') > -1){ hasDecimalPoint = true; break; }
            }
        }
        if(hasDecimalPoint == false){ yAxis.tickFormat(d3.format(".2s")) }
        let key=options.xAxisLable;
        let array=options.data.map(value => value[key]);
        let ArrayValue=[];
        var RotateValue;
        for(let i=0;i<array.length;i++){
                ArrayValue[i]=array[i].length;
        }
        const numberGreaterThanLimit = ArrayValue.filter((v) => v > 5);
        var svg = svgPanelForGroupedBarChart.append("svg:g") .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

        svg.append("g") .attr("class", "y axis") .call(yAxis).selectAll("text") .style("fill","#00001c").style("font-family","Verdana,sans-serif");

        svg.append('g') .attr("class", "x axis") .attr('transform', 'translate(0,' + height + ')') .call(xAxis)
    
        .selectAll("text").data(xAxisLabels) .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') 
        .attr("transform", function(d) {
            if(numberGreaterThanLimit.length>0)
            {
                return "rotate(-45)"
            }
         else{
                    return "rotate(0)" 
            }})
        .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
        .text(function(d,i) {
            if(d.length > 12)
            return d.substring(0,12)+'...';
            else
            return d;
            })

        var groups = svg.append("g").selectAll("g") .data(dataset)
		
		var groups1 = groups.enter().append("g")
        .style("fill", function(d, i) { return colours(i); })
        .attr("transform", function(d, i) {return "translate(" + x1(i) + ",0)"; })
        .selectAll("rect")
        .data(function(d) { return d; })
        .enter().append("rect").attr("x", function(d, i) {   return x0(i); })
        .attr("y", height).attr("width", x1.rangeBand()).attr("height", 0)
		.transition().delay(400).duration(800)
		.attr("y", function (d) { return  y(d.y); })
		.attr("height", function (d) { return height - y(d.y); })
        .style('cursor','auto')
        
        if(options.dataForDrillDown.length == 0){
            
            // adding drill down column values to bars
            var columnNames = d3.keys(options.data[0])
            var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
            
            for(var i = 0; i < columnNames.length ; i++){
                for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                    if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                        for(var k = 0; k < options.keys.groupBars.length; k++){
                            var len = d3.select(groups[0][k]).selectAll('rect')
                            for(var l = 0; l < len[0].length; l++){
                                d3.select(len[0][l]).attr('data-drilldownkey', function(d,index){
                                    return JSON.stringify(options.data[l]).slice(1, -1).split('"').join("").split(':').join("|")
                                })
                            }
                        }
                    }
                    else {
                    }
                }
            }
        }
        else if(options.dataForDrillDown.length > 0){
           
            options.keys.groupBars.forEach(function(measures, i) {
                   var bars = d3.select(groups[0][i]).selectAll('rect')
                   bars[0].forEach(function(d, index) {
                       var dd = d3.select(d)[0]
                       
                       options.dataForDrillDown.forEach(function(val, i) {
                            var key, keys = Object.keys(val), n = keys.length, newObj={}
                            while (n--) { key = keys[n]; newObj[key.toLowerCase()] = val[key]; }
                                var optKeysLabVal = options.keys.label.toString().toLowerCase();
                                if(dd[0].__data__.x.toString().toLowerCase() === newObj[optKeysLabVal].toString().toLowerCase()){
                                    //if(dd[0].__data__.y == val[measures]){
                                    if(dd[0].__data__.y == newObj[measures.toLowerCase()]){
                                        d3.select(dd[0]).attr('data-drilldownkey', function(d,index){
                                              return JSON.stringify(val).slice(1, -1).split('"').join("").split(':').join("|")
                                        })
                                    }
                                }
                       })
                  })
            })
        }
        
        
        
        var format1 = d3.format('.3s')
        // var textOnGroupBarChart = groups.selectAll(".text")
        // .data(function (d) { return d; })

        // textOnGroupBarChart.enter() .append("text").attr("class","text");
        //.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        var textOnGroupBarChart = groups.selectAll("text")
        .data(function(d) { return d; })
        .enter().append("text").attr("class","text")
        .text(function(d, i) { 
            //return format1(d.y); 
            if(d.y.toString().indexOf('.') === -1)
            {
              if(d.y.toString().length <= 3){
                return d.y;
              }
              else{
                return format1(d.y);
              }
            }
            else{
              
                return format1(d.y);
            }
        })
        .attr("x", function(d,i) { return 4 - y(d.y); })
        //.attr("y", function(d,i) { return (x0(i)) + 8.5; }).style("font-family", "Verdana")  .style("font-size", "12px")
        .attr("y", function(d,i) {textWidth = d3.select("text").node().getBoundingClientRect().height; 
            computedWidth =  (x1.rangeBand() / 2) - (textWidth / 2)   
            if(computedWidth > 0){
                return (x0(i)) + (computedWidth + textWidth / 1.4);
            }
            else {
                return (x0(i)) + 10.0;
                //return x0(i) + ((x0.rangeBand() / 2.0) - (this.getBBox().height / 2))
            }
        }).attr("transform", "rotate(-90)")
        .style("font-family", "Verdana,sans-serif")  .style("font-size", "12px").style("text-anchor", "start")
        .style("fill", "#00001c").style('display','none').transition().delay(1400).style('display','none').attr("class","series_value").style("display",options.series)
  
		// Adding the text label for the x axis
        var xAxisVariable =  svg.append("text") .attr("transform", "translate(" + ((width/2) - 20) + " ," + (height+margin.bottom - 2) + ")")
        .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif") .style("font-weight","Bold") .style("font-size","12px") .text(options.xAxisLable) .style('fill','#00001c') 
        .style("text-transform","capitalize") .style("font-style","normal")

        groups.selectAll('.text').on('mousemove', function (d,i){
            
            var root = targetElement
            var m = d3.mouse(root.node());
            m[0] += 0
            m[1] += 0
            
            var valueForGrpBarChartToolTip;
            if(d.y.toString().indexOf('.') === -1)
            {
                valueForGrpBarChartToolTip = d.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            else{
                        
                valueForGrpBarChartToolTip = d.y;
            }

                groups.on('mousemove', function (dd,j){
                    
                    tooltipForGroupedBarChart.select('.label').html(finalNewNewArray[j].name)
                    tooltipForGroupedBarChart.select('.count').html(valueForGrpBarChartToolTip)
                    tooltipForGroupedBarChart.style('visibility', 'visible')
                    tooltipForGroupedBarChart.select('hr').style("background-color", function(d){ return colours(j) })
                    tooltipForGroupedBarChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-20) + "px").style("display","block")
                })
        })
        .on('mouseout', function(){ tooltipForGroupedBarChart.style("display","none") })

        groups.selectAll('rect').on('mousemove', function (d,i){
                    
            var root = targetElement
            var m = d3.mouse(root.node());
            m[0] += 0
            m[1] += 0
            
            var valueForGrpBarChartToolTip;
            if(d.y.toString().indexOf('.') === -1)
            {
                valueForGrpBarChartToolTip = d.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            else{
                        
                valueForGrpBarChartToolTip = d.y;
            }

                groups.on('mousemove', function (dd,j){
                    
                    tooltipForGroupedBarChart.select('.label').html(finalNewNewArray[j].name)
                    tooltipForGroupedBarChart.select('.count').html(valueForGrpBarChartToolTip)
                    tooltipForGroupedBarChart.style('visibility', 'visible')
                    tooltipForGroupedBarChart.select('hr').style("background-color", function(d){ return colours(j) })
                    tooltipForGroupedBarChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-20) + "px").style("display","block")
                })
                // textOnGroupBarChart.on('mousemove', function (d,i){
                
                //     tooltipForGroupedBarChart.style('visibility', 'hidden')
                // })
            
        })
        .on('mouseout', function(){ tooltipForGroupedBarChart.style("display","none") })

        
        
        //------------ adding legend section -----------
        var divLegendPanelForGroupedBarChart = targetElement .append('div')  .attr("class","divLegendPanelClassForGroupedBarChart")
        .style("background-color",options.BGcolor).style('position',"absolute") 
        //.style('width', 25 + "%") .style('height', 92 + "%") .style("left",75 + "%").style("top",8 + "%") 

        if ((showOrHideTableForGroupedBarChart == false) && (showOrHideCommentsForGroupedBarChart == true)){
                divLegendPanelForGroupedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForGroupedBarChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
        }
        else if ((showOrHideTableForGroupedBarChart == true) && (showOrHideCommentsForGroupedBarChart == false)){
                divLegendPanelForGroupedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);
                    
                svgPanelForGroupedBarChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style('background-color',options.BGcolor);
        }
        else if ((showOrHideTableForGroupedBarChart == false) && (showOrHideCommentsForGroupedBarChart == false)){
                divLegendPanelForGroupedBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style('background-color',options.BGcolor);
                    
                svgPanelForGroupedBarChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style('background-color',options.BGcolor);
        }
        
        var legendPanelSvgForGroupedBarChart = divLegendPanelForGroupedBarChart .append('svg')  .attr("class","")
        .style('background-color',options.BGcolor) .style('position',"absolute")
        .style('width', 100 + "%") .style('height', 100 + "%") .style("left",0 + "%").style("top",0 + "%")
        
        var legend = legendPanelSvgForGroupedBarChart.append("g") .attr("class", "legend") .attr("height", "100%") .attr("width", "100%")
        .attr('transform', 'translate(0,20)') 
        
        //Create colour squares
        var legendGroup = legend.selectAll('rect') .data(options.keys.groupBars) .enter() .append("rect") .attr("x", 5)
        .attr("y", function(d, i){ return i * 16;}) .attr("width", 14) .attr("height", 14) .attr("rx",10) .attr("ry",10)
        .style("fill", function(d, i){ return colours(i);}) .style("cursor","auto")
      

        //Create text next to squares
        legend.selectAll('text') .data(options.keys.groupBars) .enter() .append("text") .attr("x", 25) .attr("y", function(d, i){ return i * 16 + 11.8;})
        .attr("fill", "#00001c") .text(function(d,i) {  if(d.length > 10)
            return d.substring(0,10)+'...';
        else
            return d; }) .style('font-size', '14px') .attr("fill","#00001c") .style("font-family","Verdana,sans-serif")

        // Aligning Legend (vertically)
        var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelForGroupedBarChart[0][0].style.width) / 100)
        var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelForGroupedBarChart[0][0].style.height) / 100)

        var legendRectSize = 11;
        var legendSpacing = 4;
            
        legend.transition().duration(0).attr('transform', function(d, i) {
        var eachRectHeight = legendRectSize + legendSpacing;
        var offset =  eachRectHeight * colours.domain().length / 2;
        var horz = 0;
        var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.groupBars.length))/2.0; // originally 2.0
            
            return 'translate(' + horz + ',' + vert + ')';
        })

        legendGroup.on('mouseover',function(d,i){
            groups.selectAll('rect').transition().style('fill-opacity',0.04)
            d3.select(groups[0][i]).selectAll('rect').transition().duration(400).style('fill-opacity',1)
            
        })
        legendGroup.on('mouseout',function(d,i){
            groups.selectAll('rect').transition().style('fill-opacity',1).style('stroke-width',0)
        })
        
        legendGroup.on('mouseover',function(d,i){
            
            //if(options.keys.groupBars.length > 1){ // to check if the group Bars set is more than 1
                if(xScale1GlobalVar == undefined){ // to check whether the widget is being resized or not (to save new xScale)
                    xScale1GlobalVar = x0;
                }

                groups.selectAll('.text').style('display','none')
                
                d3.select(groups[0][i]).selectAll('text').style('display','block')
                .transition().duration(0).ease('bounce') .attr("x", function(d,i) { return 4 - y(d.y); })
                .attr("y", function(d,i) {textWidth = d3.select("text").node().getBoundingClientRect().height; 
                computedWidth =  (x1.rangeBand() / 2) - (textWidth / 2)   
                if(computedWidth > 0){
                    return (x0(i)) + (computedWidth + textWidth / 1.4);
                }
                else {
                    return (x0(i)) + 10.0;
                }
                }) .style("fill", "#00001c")
                .text(function(d,i){
                    if(d.y.toString().indexOf('.') === -1)
                    {
                        return d.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    }
                    else{
                        
                        return d.y;
                    }
                })
                
                groups.selectAll('rect').transition().style('fill-opacity',0.035)
                d3.select(groups[0][i]).selectAll('rect').transition().duration(400).style('fill-opacity',1)
            //}
            
            //var txt = d3.select(groups[0][i]).selectAll('text')
            
        })

        legendGroup.on('mouseout',function(d,i){
            
            if(xScale1GlobalVar == undefined){
                xScale1GlobalVar = x0;
            }

            groups.selectAll('.text').style('display','block').transition().duration(0).attr("x", function(d,i) { return 4 - y(d.y); })
            .attr("y", function(d,i) {textWidth = d3.select("text").node().getBoundingClientRect().height; 
            computedWidth =  (x1.rangeBand() / 2) - (textWidth / 2)   
                if(computedWidth > 0){
                    return (x0(i)) + (computedWidth + textWidth / 1.4);
                }
                else {
                    return (x0(i)) + 10.0;
                }
            })
            .text(function(d,i){
                  if(d.y.toString().indexOf('.') === -1)
                  {
                    if(d.y.toString().length <= 3){
                        return d.y;
                    }
                    else{
                        return format1(d.y);
                    }
                  }
                  else{
                        return d.y;
                  }
                })
            groups.selectAll('rect').transition().style('fill-opacity',1).style('stroke-width',0)
                
        })

        // ----------------------- adding table section ------------------
        var tablePanelForGroupedBarChart =  targetElement.append("div") .attr("id",targetElement[0][0].id + "holderForGroupedChartTableID")
        .attr("class","scrollingDivForTable-Class tableDivForGroupedBarChart" + targetElement[0][0].id) .style('background-color',"#ffffff") .style('position','absolute')
        .style("display","block") .style("overflow","hidden") .style("width", function(d) {  return 100.0 + "%"; })
        .style("height", function(d) { return 40 + "%"; }) .style("left",0 + "%").style("z-index",10)
        
        $( '.tableDivForGroupedBarChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        if(options.showTitle == true ){
            tablePanelForGroupedBarChart.style("top",60.0  + "%")
        }
        else if(options.showTitle == false  ){
            tablePanelForGroupedBarChart.style("top",60.0  + "%")
            
        }
        tablePanelForGroupedBarChart.html('<table class = "tableClassForGroupedBarChart' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                          '<thead class = "theadClassForGroupedBarChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForGroupedBarChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                                          '<tbody class = "tBodyClassForGroupedBarChart' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                          '</table>'
                                          )
        
        tablePanelForGroupedBarChart.select('table').attr("id",targetElement[0][0].id + "tableID")

        // Show or Hide Table scroll bar when mouseover on widget
        targetElement.on('mouseover',function(){ tablePanelForGroupedBarChart.style("overflow","auto") })
        targetElement.on('mouseout',function(d){ tablePanelForGroupedBarChart.style("overflow","hidden") })
        
        var tableDataForGrpBarChart = [];
        if(options.dataForTable.length > 0){
            tableDataForGrpBarChart = options.dataForTable;
        }
        else {
            tableDataForGrpBarChart = options.data;
        }
        
        var thead = tablePanelForGroupedBarChart.select("thead").selectAll("th") .data(d3.keys(tableDataForGrpBarChart[0]))
        .enter().append("th") .text(function(d){return d.charAt(0) .toUpperCase() + d.substr(1)}) .style("cursor","pointer") .style("min-width","100px")
        
        var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff") //f4f4f4
        .style("position","relative")
        
        var thead1 = d3.select(".thead1ClassForGroupedBarChart" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tableDataForGrpBarChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff") //f4f4f4
        .style("position","relative")
        
        var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
        .attr("id", "ascendingIconIDForGroupedBarChart") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
        
        var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
        .attr("id", "descendingIconIDForGroupedBarChart") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
        
        var tr = tablePanelForGroupedBarChart.select("tbody").selectAll("tr") .data(tableDataForGrpBarChart).enter().append("tr")
        .attr("id", function(d,i) { return "slice" + i })
        
        // cells
        var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d})
        .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
        
        var $table = $('.tableClassForGroupedBarChart' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
        
        d3.select(".theadClassForGroupedBarChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                d.forEach(function(dd,j){
                    colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                })
        })
        
        $(".thead1ClassForGroupedBarChart" + targetElement[0][0].id).insertAfter('.tBodyClassForGroupedBarChart' + targetElement[0][0].id)
        
        $(".thead1ClassForGroupedBarChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForGroupedBarChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
        
        tablePanelForGroupedBarChart.select(".thead1ClassForGroupedBarChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
        })
        
        $('.tableDivForGroupedBarChart' + targetElement[0][0].id).scroll(function () {
                                                                   
            $(".thead1ClassForGroupedBarChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForGroupedBarChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
                                                                   
        })
        
        var sortOrder = false;
        thead1.on("click",function(k,index){
                 
         sortOrder = !sortOrder;
         
         tablePanelForGroupedBarChart.select(".thead1ClassForGroupedBarChart" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                                                      
            if (sortOrder) {
                              
                if(i == index){
                    d3.select(this).select('svg').select('#descendingIconIDForGroupedBarChart').style("visibility", "hidden")
                    d3.select(this).select('svg').select('#ascendingIconIDForGroupedBarChart').style("visibility", "visible")
                }
                else {
                    d3.select(this).select('svg').select('#descendingIconIDForGroupedBarChart').style("visibility", "visible")
                    d3.select(this).select('svg').select('#ascendingIconIDForGroupedBarChart').style("visibility", "visible")
                }
            }
            else{
                              
                if(i == index){
                    d3.select(this).select('svg').select('#descendingIconIDForGroupedBarChart').style("visibility", "visible")
                    d3.select(this).select('svg').select('#ascendingIconIDForGroupedBarChart').style("visibility", "hidden")
                }
                else {
                    d3.select(this).select('svg').select('#descendingIconIDForGroupedBarChart').style("visibility", "visible")
                    d3.select(this).select('svg').select('#ascendingIconIDForGroupedBarChart').style("visibility", "visible")
                }
            }
        })
         
          
          var monthTruOrFalAryForGrpBarChart = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
          
          tr.sort(function(a, b) {
                  
                  if (sortOrder) {
                    var monthsArrayForGrpBarChart = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                  } else {
                    var monthsArrayForGrpBarChart = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                  }
                  
                  monthTruOrFalAryForGrpBarChart = []; gotMonthArray = [];
                  tableDataForGrpBarChart.forEach(function(d,i){
                    var da = d[k].toString().substring(0,3).toLowerCase()
                        if(monthsArrayForGrpBarChart.indexOf(da) >= 0){
                              monthTruOrFalAryForGrpBarChart.push(true)
                              gotMonthArray.push(da);
                        }
                        else {
                             monthTruOrFalAryForGrpBarChart.push(false)
                        }
                  })
                  
                  if(monthTruOrFalAryForGrpBarChart.indexOf(false) == -1){ // true
                  
                  monthArray = []; monthArrayCount = [];
                  gotMonthArray.forEach(function(dd,j){
                        var index1 = monthsArrayForGrpBarChart.indexOf(dd.substring(0,3))
                        if(monthArrayCount.indexOf(index1) >= 0){
                            index1 = 12 + index1;
                        }
                        monthArray.push(index1);
                        monthArrayCount.push(index1)
                  })
                  returnArray = []
                  monthArray.sort(function(aa, bb) {
                      returnArray.push(+aa - +bb)
                      return +aa - +bb;
                  })
                  
                  sortTableFunc()
                  return returnArray[ind++];
                  } //  if true (if jan feb if block)
                  else {
                  var data = +a[k];
                  
                  if(!isNaN(data)){
                  
                  if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                  else { return d3.descending(+a[k], +b[k]); }
                  }
                  else if(!isNaN(Date.parse(a[k]))){
                  
                  if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                  else { return new Date(b[k]) - new Date(a[k]) }
                  }
                  else {
                  
                  if (sortOrder) { return d3.ascending(a[k], b[k]); }
                  else { return d3.descending(a[k], b[k]); }
                  }
                  } // if not jan feb else block
            }); // tr
        })
        
        function sortTableFunc(){
            
            var table = tablePanelForGroupedBarChart.select('table');
            var rows = table.selectAll('tr').data(tableDataForGrpBarChart);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0).style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500)
            .style('opacity', 1.0).style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
        }
        
        // Main Table Styling
        tablePanelForGroupedBarChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
        .style("color","#00001c")
        .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4") //.style("box-shadow","10px 10px 50px #007aff").style("z-index",9999)
        tablePanelForGroupedBarChart.selectAll('td').style("height","25px") .style("border", "1px solid #dddddd") .style("font-size","12px").style("font-weight","Normal").style("color","#00001c")

        //additionally 
        tablePanelForGroupedBarChart.selectAll('th').style('background-color',"#ffffff").style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
        tablePanelForGroupedBarChart.selectAll('td').style('background-color',"#ffffff").style("border-style","none").style("color","#2c2c2c").style("color","#00001c")

        //b1da9f
        tablePanelForGroupedBarChart.selectAll('table') . style("border-collapse","collapse")
        tablePanelForGroupedBarChart.selectAll('table tr:first-child th').style("border-top","0px")
        tablePanelForGroupedBarChart.selectAll('table tr:last-child td').style("border-bottom","0px")
        tablePanelForGroupedBarChart.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
        tablePanelForGroupedBarChart.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")

        if(showOrHideTableForGroupedBarChart == false){
            tablePanelForGroupedBarChart.style("display","none")
        }
        else if(showOrHideTableForGroupedBarChart == true){
            tablePanelForGroupedBarChart.style("display","block")
        }

        if(options.isDataDetailedForTable == false){
        
            var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
        
            // Adding underlines for selected drill-down column text
            var drillDownSectionsForGroupedBarChart = tablePanelForGroupedBarChart.select('table').selectAll('th')
        
            var foundResult = [];
            for(var i = 0; i<drillDownSectionsForGroupedBarChart[0].length; i++){
                for(var j = 0; j<drillDownColumnNamesArray.length; j++){
                    if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForGroupedBarChart[0][i].__data__.toString().toLowerCase() ){
                        foundResult.push(i)
                    }
                }
            }
        
            var r = tablePanelForGroupedBarChart.select('table').selectAll('tr').selectAll('td')
            for(var i = 0; i<r.length; i++){
                for(var j = 0; j < foundResult.length; j++){
                    var row = r[i][foundResult[j]]
                    $(row).css("text-decoration", "underline")
                }
            }
        }
        
        //By default calling the resized function first time (to align table's th and td).
        setTimeout(function(){ resizedFuctionForGroupedBarChart() },1000)
        
        window.addEventListener('resize', function(event){ resizedFuctionForGroupedBarChart() });
        
        var xScale1GlobalVar;
        var yScale1GlobalVar;
        var newHeightVar; // storing the new height when parent div is resized.

        $(function() {
          
          $("#" + targetElement[0][0].id).resizable({
                resize: function(event, ui) {
                    //divWidthForHoriChart = ui.size.width;
                    //divHeightForHoriChart = ui.size.height;
                    resizedFuctionForGroupedBarChart();
                }
            });
          });
        
        function resizedFuctionForGroupedBarChart()
        {
            
            if((svgPanelForGroupedBarChart.node().getBoundingClientRect().width) && (svgPanelForGroupedBarChart.node().getBoundingClientRect().height) > 0){

                if(showOrHideCommentsBtnForGroupedBarChart == true){
                    stkCirAreaBtnForGrpBarChart.style('margin-left', "2px")
                    horiGrpBarBtnForGrpBarChart.style('margin-left', "2px")
                    filterBtnForGroupedBarChart.style('margin-left', "2px")
                    refreshBtnForGroupedBarChart.style('margin-left', "2px")
                    commentsBtnForGroupedBarChart.style('margin-left', "2px")
                    menuBtnForGroupedBarChart.style('right', '0')
                }
                else if(showOrHideCommentsBtnForGroupedBarChart == false){
                    stkCirAreaBtnForGrpBarChart.style('margin-left', "2px")
                    horiGrpBarBtnForGrpBarChart.style('margin-left', "2px")
                    filterBtnForGroupedBarChart.style('margin-left', "2px")
                    refreshBtnForGroupedBarChart.style('margin-left', "2px")
                    //commentsBtnForGroupedBarChart.style('right', '0')
                    commentsBtnForGroupedBarChart.style('display','none')
                    menuBtnForGroupedBarChart.style('right', '0')
                }

                optsBtnPanelForGroupedBarChart.style('right', '0')

                stgPanCanBtnForGroupedBarChart.style('right', '0')
                
                if(options.showTitle == true){
                
                    var margin1 = {top: 50 , right: 20, bottom: 80, left: 50}, //originally top: 42, left: 80
                    width1 = (svgPanelForGroupedBarChart.node().getBoundingClientRect().width) - margin.left - margin.right,
                    height1 = (svgPanelForGroupedBarChart.node().getBoundingClientRect().height) - margin.top - margin.bottom;
                    newHeightVar = height1
                }
                else if(options.showTitle == false){
                
                    var margin1 = {top: 50 , right: 20, bottom: 80, left: 50}, //originally top: 42, left: 80
                    width1 = (svgPanelForGroupedBarChart.node().getBoundingClientRect().width) - margin.left - margin.right,
                    height1 = svgPanelForGroupedBarChart.node().getBoundingClientRect().height - margin.top - margin.bottom;
                    newHeightVar = height1
                }

                

                var xMax1 =  d3.max(dataset, function (group) {
                    
                    return d3.max(group, function (d) {
                        
                        return d.y;
                    });
                })

                //var xAxisLabels1 = dataset[0].map(function (d) { return d.x; });

                xScale1GlobalVar = x0 .domain(d3.range(xAxisLabels.length)) .rangeBands([0, width1], .28);

                x1.domain(d3.range(finalNewNewArray.length)) .rangeBands([0, x0.rangeBand()]);

                yScale1GlobalVar = y.domain([0, xMax]) .range([height1, 0]);

                xAxis.scale(x0) .orient("bottom");

                yAxis.scale(y) .orient("left");
                
                var svg1 = svg;
            
                svg1.select("svg") .attr("width", width1 + margin1.left + margin1.right) .attr("height", height1 + margin1.top + margin1.bottom)
                
                svg1.select(".y.axis") .call(yAxis)
    
                svg1.select(".x.axis") .attr("transform", "translate(0," + height1 + ")") .call(xAxis)
            
                .selectAll("text").data(xAxisLabels) .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') 
                .attr("transform", function(d) 
                    { 
                        if(numberGreaterThanLimit.length>0){return "rotate(-45)"}
                    else{
                    return "rotate(0)" }}) 
                    .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
                    .text(function(d,i) {
                          if(d.length > 12)
                          return d.substring(0,12)+'...';
                          else
                          return d;
                          })
               

                var groupsArray = [];
                groups.selectAll('rect').data(function(d,i) { groupsArray[i] = x1(i); return d; })
                .attr("width", x1.rangeBand())
                .attr("height", function(d) { return height1 - y(d.y) })
                .attr("x", function(d, i) { return x0(i); })
                .attr("y", function(d) { return  y(d.y); })//.select('g')
                
                for(var i=0;i<groups[0].length;i++){
                    var gg = groupsArray[i];
                    d3.select(groups[0][i])
                    .attr("transform", function(d, i) { return "translate(" + gg + ",0)"; })
                }

                groups.selectAll('.text').attr("x", function(d,i) { return 4 - y(d.y); })
                .attr("y", function(d,i) {textWidth = d3.select("text").node().getBoundingClientRect().height; 
                    computedWidth =  (x1.rangeBand() / 2) - (textWidth / 2)   
                    if(computedWidth > 0){
                        return (x0(i)) + (computedWidth + textWidth / 1.4);
                    }
                    else {
                        return (x0(i)) + 10.0;
                    }
                })
                groups.selectAll('.series_value').attr("x", function(d,i) { return 4 - y(d.y); })
                .attr("y", function(d,i) {textWidth = d3.select(".series_value").node().getBoundingClientRect().height; 
                    computedWidth =  (x1.rangeBand() / 2) - (textWidth / 2)   
                    if(computedWidth > 0){
                        return (x0(i)) + (computedWidth + textWidth / 1.4);
                    }
                    else {
                        return (x0(i)) + 10.0;
                    }
                })


                xAxisVariable.attr("transform", "translate(" + ((width1/2) - 20) + " ," + (height1+margin1.bottom - 2) + ")")
                
                // Aligning Legend (vertically)
                var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelForGroupedBarChart[0][0].style.width) / 100)
                var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelForGroupedBarChart[0][0].style.height) / 100)

                var legendRectSize = 11;
                var legendSpacing = 4;
                
                legend.attr('transform', function(d, i) {
                var eachRectHeight = legendRectSize + legendSpacing;
                var offset =  eachRectHeight * colours.domain().length / 2;
                var horz = 0;
                var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.groupBars.length))/2.0; // originally 2.0
                    
                    return 'translate(' + horz + ',' + vert + ')';
                })
                
                colWidth = []; 
				
                d3.select(".theadClassForGroupedBarChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                        d.forEach(function(dd,j){
                            colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                        })
                })
                tablePanelForGroupedBarChart.select(".thead1ClassForGroupedBarChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                        d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
                })
                
            }// checking svg panel width & height greater than zero function
        }
    }, //groupedBarChart

    // ************************************************** Horizontal Grouped Bar Chart  **************************************************
    horizontalGroupedBarChart: function(targetElement, options){

        isChartCalled++;

        var chartName = "HORIZONTALGROUPEDBARCHART";
       
        acinfotech.allCharts(targetElement,options,chartName)

        targetElement.style("min-width", "350px").style("min-height", "350px").style("background-color",options.BGcolor)

        var showOrHideTabForHoriGrpBarChart;
        var showOrHideCommentsForHoriGrpBarChart;
        var showOrHideCommentsBtnForHoriGrpBarChart = true;

        if((options.showTable == false) || (options.showTable == true)){
            showOrHideTabForHoriGrpBarChart = options.showTable    
        }
        else{
            showOrHideTabForHoriGrpBarChart = false;
        }

        // Show or Hide comments
        if (options.showComments == true || false) {
            showOrHideCommentsForHoriGrpBarChart = options.showComments;
        }
        else {
            showOrHideCommentsForHoriGrpBarChart = false;
        }
        
        if (options.comments.length == 0){ 
            showOrHideCommentsForHoriGrpBarChart = false;
            showOrHideCommentsBtnForHoriGrpBarChart = false;
        }

        if ((showOrHideTabForHoriGrpBarChart == true) && (showOrHideCommentsForHoriGrpBarChart == true)){
            showOrHideTabForHoriGrpBarChart = true;
            showOrHideCommentsForHoriGrpBarChart = false;
        }
        else if ((showOrHideTabForHoriGrpBarChart == false) && (showOrHideCommentsForHoriGrpBarChart == false)){
            showOrHideTabForHoriGrpBarChart = false;
            showOrHideCommentsForHoriGrpBarChart = false;
        }

        var chartTitlePanelForHoriGrpBarChart =  targetElement.append("div").style("background-color",options.BGcolor).style("position","absolute") .style("text-indent","6px")
        
		var optsBtnPanelForHoriGrpBarChart = targetElement.append('div').style('width',"25px").style('height',"205px").style('position','absolute')
        .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px")
        .style('right', '0')
        .style("min-width","25px").style("border-style","none").style("border-left", "solid #fcfcfc  1px")
		
        var stkCirAreaBtnForHoriGrpBarChart = optsBtnPanelForHoriGrpBarChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','80px') .style("cursor","pointer").style("display","block")
        .style("border-style", "none").style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px") .style("box-sizing","border-box")
        var stkCirAreaBtnImgVar = document.createElement("IMG");
        stkCirAreaBtnImgVar.src = "images/circularAreaIcon.png";
        stkCirAreaBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.76;")
        stkCirAreaBtnForHoriGrpBarChart[0][0].appendChild(stkCirAreaBtnImgVar)
        
        //If data set length is one
        if(options.data.length <= 1){
            stkCirAreaBtnForHoriGrpBarChart.style("display","none")
        }
        
        var grpBarBtnForHoriGrpBarChart = optsBtnPanelForHoriGrpBarChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','105px') .style("cursor","pointer").style("display","block") 
        .style("border-style", "none").style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px") .style("box-sizing","border-box")
        var grpBarBtnImgVar = document.createElement("IMG");
        grpBarBtnImgVar.src = "images/grpBarIcon.png";
        grpBarBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.9;")
        grpBarBtnForHoriGrpBarChart[0][0].appendChild(grpBarBtnImgVar)

        var filterBtnForHoriGrpBarChart = optsBtnPanelForHoriGrpBarChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','130px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var filterBtnImgVar = document.createElement("IMG");
        filterBtnImgVar.src = "images/filterIcon.png";
        filterBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        filterBtnForHoriGrpBarChart[0][0].appendChild(filterBtnImgVar)

        var refreshBtnForHoriGrpBarChart = optsBtnPanelForHoriGrpBarChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','155px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var refreshBtnImgVar = document.createElement("IMG");
        refreshBtnImgVar.src = "images/refreshIcon.png";
        refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        refreshBtnForHoriGrpBarChart[0][0].appendChild(refreshBtnImgVar)

        var commentsBtnForHoriGrpBarChart = optsBtnPanelForHoriGrpBarChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','180px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var commentsBtnImgVariable = document.createElement("IMG");
        if(options.showComments == false){
            commentsBtnImgVariable.src = "images/showCommentsIcon.png";
        }
        else if(options.showComments == true){
            commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
        }
        commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        commentsBtnForHoriGrpBarChart[0][0].appendChild(commentsBtnImgVariable)

        var menuBtnForHoriGrpBarChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','1px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var menuBtnImgVar = document.createElement("IMG");
        menuBtnImgVar.src = "images/menuIcon.png";
        menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
        menuBtnForHoriGrpBarChart[0][0].appendChild(menuBtnImgVar)

        if(showOrHideCommentsBtnForHoriGrpBarChart == true){
            stkCirAreaBtnForHoriGrpBarChart.style('margin-left', "2px")
            grpBarBtnForHoriGrpBarChart.style('margin-left', "2px")
            filterBtnForHoriGrpBarChart.style('margin-left', "2px")
            refreshBtnForHoriGrpBarChart.style('margin-left', "2px")
            commentsBtnForHoriGrpBarChart.style('margin-left', "2px")
            menuBtnForHoriGrpBarChart.style('right', '0')
        }
        else if(showOrHideCommentsBtnForHoriGrpBarChart == false){
            stkCirAreaBtnForHoriGrpBarChart.style('margin-left', "2px")
            grpBarBtnForHoriGrpBarChart.style('margin-left', "2px")
            filterBtnForHoriGrpBarChart.style('margin-left', "2px")
            refreshBtnForHoriGrpBarChart.style('margin-left', "2px")
            //commentsBtnForHoriGrpBarChart.style('right', '0')
            commentsBtnForHoriGrpBarChart.style('display','none')
            menuBtnForHoriGrpBarChart.style('right', '0')
        }

        var ismenuBtnOfGroupedBarChartClicked = false;
        menuBtnForHoriGrpBarChart.on('click', function() {

            filterPanelForHoriGrpBarChart.style("display","none");
            stgPanDivForHoriGrpBarChart.style("display","none");

            if ((showOrHideTabForHoriGrpBarChart == false) && (showOrHideCommentsForHoriGrpBarChart == true)){
                divLegendPanelForHoriGrpBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForHoriGrpBarChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
            }
            else if ((showOrHideTabForHoriGrpBarChart == true) && (showOrHideCommentsForHoriGrpBarChart == false)){
                divLegendPanelForHoriGrpBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForHoriGrpBarChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
            }
            else if ((showOrHideTabForHoriGrpBarChart == false) && (showOrHideCommentsForHoriGrpBarChart == false)){
                divLegendPanelForHoriGrpBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForHoriGrpBarChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
            }

            if(ismenuBtnOfGroupedBarChartClicked == false){
                ismenuBtnOfGroupedBarChartClicked = true;
                optsBtnPanelForHoriGrpBarChart.style("display","block")

            }
            else if(ismenuBtnOfGroupedBarChartClicked == true){
                ismenuBtnOfGroupedBarChartClicked = false
                optsBtnPanelForHoriGrpBarChart.style("display","none")
            }

            resizedFunctionForHoriGrpBarChart();
        })

        var tableButtonForHoriGrpBarChart = optsBtnPanelForHoriGrpBarChart.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top','1px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
        var tableBtnImgVar = document.createElement("IMG");

        if(showOrHideTabForHoriGrpBarChart == false){
            tableBtnImgVar.src = "images/showTableIcon.png";
            tableButtonForHoriGrpBarChart.attr("class","showTableClassForChartTable")
        }
        else if(showOrHideTabForHoriGrpBarChart == true){
            tableBtnImgVar.src = "images/cancelTableIcon.png";
            tableButtonForHoriGrpBarChart.attr("class","hideTableClassForChartTable")
        }
        tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
        tableButtonForHoriGrpBarChart[0][0].appendChild(tableBtnImgVar)

        var settingBtnForHoriGrpBarChart = optsBtnPanelForHoriGrpBarChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 28 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        var settingBtnImgVar = document.createElement("IMG");
        settingBtnImgVar.src = "images/settingsIcon.png";
        settingBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.82;")
        settingBtnForHoriGrpBarChart[0][0].appendChild(settingBtnImgVar)
        
        var downloadBtnForHoriGrpBarChart = optsBtnPanelForHoriGrpBarChart.append("div").attr("id","downloadBtnForHoriGrpBarChart-ID-" + targetElement[0][0].id)
        .style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff")
        .style('margin-left','2px').style('top', 54 + 'px').style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        
        acinfotech.downloadFunctionality("downloadBtnForHoriGrpBarChart-ID-" + targetElement[0][0].id,targetElement)
        
        var svgPanelForHoriGrpBarChart = targetElement .append('svg') 
        .attr("id","svgPanelIDForHoriGrpBarChart" + targetElement[0][0].id).style("background-color",options.BGcolor).style("position","absolute")
        .style("border","0px solid #d0d0d0")

        var commentsPanelDivForHoriGrpBarChart = targetElement.append("div") .attr("class","commentsPanelClassForHGBChart") 
        .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
		.style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
        .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)

        commentsPanelDivForHoriGrpBarChart.on('click',function(d){
            $('.commentsClassForHoriGrpBarChart' + targetElement[0][0].id).focus()
        })

        if(options.showTitle == true){
            
            chartTitlePanelForHoriGrpBarChart.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 8 + "%"; })
            .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')
                
            if ((showOrHideTabForHoriGrpBarChart == false) && (showOrHideCommentsForHoriGrpBarChart == true)){

                var commentsForHoriGrpBarChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                .css('line-height','1.1em').css('text-align','justify') .attr('class','commentsClassForHoriGrpBarChart' + targetElement[0][0].id)

                svgPanelForHoriGrpBarChart.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .style("background-color",options.BGcolor).append('g')
                commentsPanelDivForHoriGrpBarChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                .style("top",78 + "%")
                .html(commentsForHoriGrpBarChart[0].outerHTML.toString())

            }
            else if ((showOrHideTabForHoriGrpBarChart == true) && (showOrHideCommentsForHoriGrpBarChart == false)){

                svgPanelForHoriGrpBarChart.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .style("background-color",options.BGcolor).append('g')
                commentsPanelDivForHoriGrpBarChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTabForHoriGrpBarChart == false) && (showOrHideCommentsForHoriGrpBarChart == false)){

                svgPanelForHoriGrpBarChart.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .style("background-color",options.BGcolor).append('g')
                commentsPanelDivForHoriGrpBarChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            
            var margin = {top: 15 , right: 40, bottom: 20, left: 130}, //originally top: 42, left: 80
            width = (svgPanelForHoriGrpBarChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = (svgPanelForHoriGrpBarChart.node().getBoundingClientRect().height) - margin.top - margin.bottom;
            
        }
        else if(options.showTitle == false){
            chartTitlePanelForHoriGrpBarChart.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });
            
            if ((showOrHideTabForHoriGrpBarChart == false) && (showOrHideCommentsForHoriGrpBarChart == true)){

                var commentsForHoriGrpBarChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                .attr('contenteditable',false).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                .css('line-height','1.1em').css('text-align','justify')

                svgPanelForHoriGrpBarChart.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%").style("background-color",options.BGcolor) .append('g')
                commentsPanelDivForHoriGrpBarChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                .style("top",78 + "%")
                .html(commentsForHoriGrpBarChart[0].outerHTML.toString())

            }
            else if ((showOrHideTabForHoriGrpBarChart == true) && (showOrHideCommentsForHoriGrpBarChart == false)){

                svgPanelForHoriGrpBarChart.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .style("background-color",options.BGcolor).append('g')
                commentsPanelDivForHoriGrpBarChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTabForHoriGrpBarChart == false) && (showOrHideCommentsForHoriGrpBarChart == false)){

                svgPanelForHoriGrpBarChart.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%").style("background-color",options.BGcolor) .append('g')
                commentsPanelDivForHoriGrpBarChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }

            var margin = {top: 15, right: 40, bottom: 20, left: 130}, //originally top: 42, left: 80
            width = (svgPanelForHoriGrpBarChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = svgPanelForHoriGrpBarChart.node().getBoundingClientRect().height - margin.top - margin.bottom;
        }

        var colours;

        // checking color set for bubbles and legend dots
        if(options.colorSet === undefined){
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "one"){
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            options.colorSet = "two"
            colours = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            options.colorSet = "three"
            colours = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        }
        else
        {
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }

        /*------------------ Settings panel DIV and everything within it section begins here ------------------*/
        
        var stgPanDivForHoriGrpBarChart = targetElement.append('div').style('width',"100%").style('height',"40%").attr("class","stgPanDivForHoriGrpBarChart" + targetElement[0][0].id)
        .style('position','absolute').style('margin-left', "0px").style('border-top',"1px solid #f0f0f0").style('border-bottom',"1px solid #e5e5e5")
        .style("background-color",'#fcfcfc').style("z-index",90) .style("display","none") .style('top', 60.0 + "%") .style('height',40 + "%")

        $( '.stgPanDivForHoriGrpBarChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        var settingPanelTitle = stgPanDivForHoriGrpBarChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','10px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; color:#00001c;">'+ "Settings" +'</div>')

        var stgPanDivForGrpChangeColorTitle = stgPanDivForHoriGrpBarChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Select color set " +'</div>')

        var stgPanCanBtnForGroupedBarChart = stgPanDivForHoriGrpBarChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
        .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
        .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.9; background-color:#fcfcff")
        stgPanCanBtnForGroupedBarChart[0][0].appendChild(cancelBtnImgVar)

        stgPanCanBtnForGroupedBarChart.on('click', function() {
            stgPanDivForHoriGrpBarChart.style("display","none") // Hiding setting panel

            if ((showOrHideTabForHoriGrpBarChart == false) && (showOrHideCommentsForHoriGrpBarChart == true)){
                divLegendPanelForHoriGrpBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForHoriGrpBarChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
            }
            else if ((showOrHideTabForHoriGrpBarChart == true) && (showOrHideCommentsForHoriGrpBarChart == false)){
                divLegendPanelForHoriGrpBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForHoriGrpBarChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
            }
            else if ((showOrHideTabForHoriGrpBarChart == false) && (showOrHideCommentsForHoriGrpBarChart == false)){
                divLegendPanelForHoriGrpBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForHoriGrpBarChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
            }

            resizedFunctionForHoriGrpBarChart();
        })

        var formForChangeSettingsPanel = stgPanDivForHoriGrpBarChart.append("form");
        formForChangeSettingsPanel.style("background-color","#fcfcfc").style("margin-top","67px").style("font-family","Verdana,sans-serif").style("font-size","12px")
        .style("position","absolute").attr("id","formForChangeColorSettingsPanel" + targetElement[0][0].id).style("font-weight","Bold").style("width","180px")
        .style("height","58px").style("padding","0px").style("border-radius","0px") .style("margin-left","10px")

        var svgPanelForCrSetOne = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px").style("height","18px").style("margin-top","1px").style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetOne = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        var colorSetOneRange = d3.range(12);

        var colorSetOneDots = svgPanelForCrSetOne.append("g")
        colorSetOneDots.selectAll('rect') .data(colorSetOneRange) .enter() .append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("fill", function(d,i){return colorSetOne(i)})
        .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetOne(i); })
        .style("cursor","auto") .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        var svgPanelForCrSetTwo = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px") .style("margin-top","20px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetTwo = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        var colorSetTwoRange = d3.range(12);

        var colorSetTwoDots = svgPanelForCrSetTwo.append("g")
        colorSetTwoDots.selectAll('rect') .data(colorSetTwoRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto")
        .style("fill", function(d,i){return colorSetTwo(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
        .style("stroke",function(d,i){  return colorSetTwo(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        var svgPanelForCrSetThree = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px") .style("margin-top","39px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetThree = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        var colorSetThreeRange = d3.range(12);

        var colorSetThreeDots = svgPanelForCrSetThree.append("g")
        colorSetThreeDots.selectAll('rect') .data(colorSetThreeRange) .enter().append('rect')
        .attr('transform', 'translate(' + (2) + ',' + (1) + ')') .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10)
        .attr("height",10) .style("cursor","auto") .style("fill", function(d,i){return colorSetThree(i)}) .style("fill-opacity",0.93)
        .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetThree(i);  })
        .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        if(options.colorSet.toString().toLowerCase() === "one"){
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"1px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"1px solid #808080")
        }
        else 
        {
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }

        svgPanelForCrSetOne.on('click',function(d){
            options.colorSet = "one"
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")

            colours = "";
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);

            groupsForHoriGrpBarChart.style('fill', function (d, i) {
                return colours(i);
            })

            legendGrpForHoriGrpBarChart.style("fill", function(d, i){ return colours(i);})
        
        })
        svgPanelForCrSetTwo.on('click',function(d){
            options.colorSet = "two"
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"1px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")

            colours = "";
            colours = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);

            groupsForHoriGrpBarChart.style('fill', function (d, i) {
                return colours(i);
            })
            legendGrpForHoriGrpBarChart.style("fill", function(d, i){ return colours(i);})
        })
        svgPanelForCrSetThree.on('click',function(d){
            options.colorSet = "three"
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"1px solid #808080")

            colours = "";
            colours = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);

            groupsForHoriGrpBarChart.style('fill', function (d, i) {
                return colours(i);
            })
            legendGrpForHoriGrpBarChart.style("fill", function(d, i){ return colours(i);})
        })
        // setting panel ends here 

        grpBarBtnForHoriGrpBarChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var grpBtnTooltipText = "Grouped Bar Chart";
            
            iconButtonTooltipForHoriGrpBarChart.style("width","117px").style("margin-left", (m[0] - 127) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForHoriGrpBarChart.html('<div  style="width: 100%; height:0%; padding-left:10px; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; ">'+ grpBtnTooltipText +'</div>')

        })
        grpBarBtnForHoriGrpBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForHoriGrpBarChart.style("display","none")
        })
        
        stkCirAreaBtnForHoriGrpBarChart.on('click', function() {
                                       
               //isFilterClicked = false
               d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
               
               var newOptions = {
                   data: options.data,
                   dataForDrillDown: options.dataForDrillDown,
                   dataForTable: options.dataForTable,
                   isDataDetailedForTable: options.isDataDetailedForTable,
                   keys: {
                       label: options.keys.label,
                       stackedAreas: options.keys.groupBars,
                   },
                   chartTitle: options.chartTitle,
                   //xAxisLable: options.xAxisLable,
                   //yAxisLable: "",
                   showTitle: options.showTitle,
                   colorSet: options.colorSet,
                   BGcolor:options.BGcolor,
                   series:options.series,
                   legend:options.legend,
                   drillDownColumnName:options.drillDownColumnName,
                   showTable: false,
                   showComments: false,
                   comments: options.comments,
                   resizeButtonID: options.resizeButtonID
               
               }
               
               acinfotech.stackedCircularAreaChart(targetElement, newOptions)
        })
        
        // Horizontal Grouped Bar Chart and Table 
        grpBarBtnForHoriGrpBarChart.on('click', function() {

            //isFilterClicked = false
           d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData;
                    //options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.groupBars;
                    if(newtargetElementAndOptionsArray[i].options.keys.groupBars == undefined){
                        options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.stackedAreas;
                    }
                    else {
                        options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.groupBars;
                    }
                    options.xAxisLable = options.yAxisLable;
                    options.yAxisLable = "";
                    options.showTable = false;
                    options.showComments = false;
                }
            }
            
            acinfotech.groupedBarChart(targetElement,options) 
        })

        // Filter
        filterBtnForHoriGrpBarChart.on('click', function() {

            filterPanelForHoriGrpBarChart.style("display","block");

            ismenuBtnOfGroupedBarChartClicked = false;
            optsBtnPanelForHoriGrpBarChart.style("display","none");

            stgPanDivForHoriGrpBarChart.style("display","none");

            if ((showOrHideTabForHoriGrpBarChart == false) && (showOrHideCommentsForHoriGrpBarChart == true)){
                divLegendPanelForHoriGrpBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForHoriGrpBarChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
            }
            else if ((showOrHideTabForHoriGrpBarChart == true) && (showOrHideCommentsForHoriGrpBarChart == false)){
                divLegendPanelForHoriGrpBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForHoriGrpBarChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
            }
            else if ((showOrHideTabForHoriGrpBarChart == false) && (showOrHideCommentsForHoriGrpBarChart == false)){
                divLegendPanelForHoriGrpBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForHoriGrpBarChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
            }

            resizedFunctionForHoriGrpBarChart();

        })

        // Refreshing Chart and Table 
        refreshBtnForHoriGrpBarChart.on('click', function() {

            //isFilterClicked = false
           d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData;
                    //options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.groupBars;
                    if(newtargetElementAndOptionsArray[i].options.keys.groupBars == undefined){
                        options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.stackedAreas;
                    }
                    else {
                        options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.groupBars;
                    }
                }
            }
            acinfotech.horizontalGroupedBarChart(targetElement,options) 

        })

        // showing/hidding chart comments
        commentsBtnForHoriGrpBarChart.on('click', function() {

            if(options.showComments == false){
                options.showComments = true;
            }
            else if(options.showComments == true){
                options.showComments = false;
            }

            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData;
                    //options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.groupBars;
                    if(newtargetElementAndOptionsArray[i].options.keys.groupBars == undefined){
                        options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.stackedAreas;
                    }
                    else {
                        options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.groupBars;
                    }
                    options.showTable = false;
                }
            }
            acinfotech.horizontalGroupedBarChart(targetElement,options)

        })

        // showing/hidding chart table
        tableButtonForHoriGrpBarChart.on('click', function() {

            if(showOrHideTabForHoriGrpBarChart == false){
                options.showTable = true;
                //showOrHideTableForPieChart = true
            }
            else if(showOrHideTabForHoriGrpBarChart == true){
                //showOrHideTableForPieChart = false
                options.showTable = false;
            }

            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData;
                    //options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.groupBars;
                    if(newtargetElementAndOptionsArray[i].options.keys.groupBars == undefined){
                        options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.stackedAreas;
                    }
                    else {
                        options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.groupBars;
                    }
                    options.showComments = false;
                }
            }
            acinfotech.horizontalGroupedBarChart(targetElement,options)

        })

        
        settingBtnForHoriGrpBarChart.on('click', function() {
                
			ismenuBtnOfGroupedBarChartClicked = false; // Menu toggle button variable
			optsBtnPanelForHoriGrpBarChart.style("display","none") // To hide options button panel

			iconButtonTooltipForHoriGrpBarChart.style("display","none") // Removing options button ToolTip
			settingBtnForHoriGrpBarChart.style("cursor","pointer")

			stgPanDivForHoriGrpBarChart.style("display","block") // Showing settings panel

			svgPanelForHoriGrpBarChart.style('width', 75 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color",options.BGcolor); // Decreasing chart panel
			divLegendPanelForHoriGrpBarChart.style('width', 25 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color",options.BGcolor); // Decreasing chart panel

			resizedFunctionForHoriGrpBarChart(); // Calling resize function()

        })
        
        downloadBtnForHoriGrpBarChart.on('click', function() {
                                  
			ismenuBtnOfGroupedBarChartClicked = false; // Changing menu button value to false
			optsBtnPanelForHoriGrpBarChart.style("display","none") // Hiding option buttons panel
                                  
        })
        
        // Creating ToolTip for options button.
        var iconButtonTooltipForHoriGrpBarChart = targetElement.append('div').style('width','240px').attr("id","too")
        .style('height',"25px").style('position','absolute')//.style('margin-left', "0px").style('top','25px')
        .style("background-color",'#404040 ').style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid") // 004b9d
        .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none").attr("border", 0.0)
        
        stkCirAreaBtnForHoriGrpBarChart.on('mousemove', function(d,i) {
            var root = targetElement
            var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var stkCirAreaBtnTooltipText = "Stacked Circular Area Chart";
                                       
                iconButtonTooltipForHoriGrpBarChart.style("width","176px").style("margin-left", (m[0] - 186) + "px").style("margin-top",(m[1]) + "px").style("display","block")
                iconButtonTooltipForHoriGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ stkCirAreaBtnTooltipText +'</div>')
                                       
        })
        stkCirAreaBtnForHoriGrpBarChart.on('mouseout', function(d,i) {
                iconButtonTooltipForHoriGrpBarChart.style("display","none")
        })
        
        filterBtnForHoriGrpBarChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var filterButtonTooltipText = "Filter";
            
            iconButtonTooltipForHoriGrpBarChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForHoriGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')

        })
        filterBtnForHoriGrpBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForHoriGrpBarChart.style("display","none")
        })

        refreshBtnForHoriGrpBarChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var refreshButtonTooltipText = "Refresh";
            
            iconButtonTooltipForHoriGrpBarChart.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForHoriGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ refreshButtonTooltipText +'</div>')

        })
        refreshBtnForHoriGrpBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForHoriGrpBarChart.style("display","none")
        })

        commentsBtnForHoriGrpBarChart.on('mousemove', function(d,i) {
            commentsPanelDivForHoriGrpBarChart.style('background-color','#fafafa')
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                if(options.showComments == false){
                    var commentButtonTooltipText = "Show Comments";
                }
                else if(options.showComments == true){
                    var commentButtonTooltipText = "Hide Comments";
                }
            
            
            
            iconButtonTooltipForHoriGrpBarChart.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForHoriGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ commentButtonTooltipText +'</div>')
        })
        commentsBtnForHoriGrpBarChart.on('mouseout', function(d,i) {
            commentsPanelDivForHoriGrpBarChart.style('background-color','#ffffff')
            iconButtonTooltipForHoriGrpBarChart.style("display","none")
        })

        menuBtnForHoriGrpBarChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var menuButtonTooltipText = "Menu";
            
            iconButtonTooltipForHoriGrpBarChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForHoriGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ menuButtonTooltipText +'</div>')

        })
        menuBtnForHoriGrpBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForHoriGrpBarChart.style("display","none")
        })

        tableButtonForHoriGrpBarChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                if(showOrHideTabForHoriGrpBarChart ==  false){
                    var refreshButtonTooltipText = "Show Table";
                }
                else if(showOrHideTabForHoriGrpBarChart == true){
                    var refreshButtonTooltipText = "Hide Table";
                }
            
            
            iconButtonTooltipForHoriGrpBarChart.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForHoriGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ refreshButtonTooltipText +'</div>')

        })
        tableButtonForHoriGrpBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForHoriGrpBarChart.style("display","none")
        })

        settingBtnForHoriGrpBarChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var settingTooltipText = "Settings";
            
            iconButtonTooltipForHoriGrpBarChart.style("width","67px").style("margin-left", (m[0] - 77) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForHoriGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ settingTooltipText +'</div>')
        })
        settingBtnForHoriGrpBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForHoriGrpBarChart.style("display","none")
        })
        
        downloadBtnForHoriGrpBarChart.on('mousemove', function(d,i) {
              var root = targetElement
              var m = d3.mouse(root.node());
              m[0] += 0
              m[1] += 0
              var downloadButtonTooltipText = "Download";
              
              iconButtonTooltipForHoriGrpBarChart.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
              iconButtonTooltipForHoriGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
        })
        downloadBtnForHoriGrpBarChart.on('mouseout', function(d,i) {
              iconButtonTooltipForHoriGrpBarChart.style("display","none")
        })

         // ----------------- Filter panel and everything within it section begins here ----------------
        var filterPanelForHoriGrpBarChart = targetElement.append('div').style('width',350 + "px") .attr("class","filterPanelForHoriGrpBarChartClass" + targetElement[0][0].id)
        .style('position','absolute').style('margin-left', "0px")
        .style("background-color",'#fefefe').style("z-index",11).style("border-color", "#ffffff").style("border-right", "solid #e5e5e5 1px")  .style("border-style", "solid") // 004b9d
        .style("box-shadow", "2px 0px 1px #eff8ec").style("display","none").style("border-top", "solid #fdfdfd 1px").style("border-left","0px").style("border-bottom", "0px")
        .style('top', 0.0 + "%").style('height', 100 + "%").style('overflow-y',"hidden").style("overflow-x","hidden")
        .style("border-bottom", "solid #e5e5e5 1px") .style("box-sizing","border-box")

        var filterPanelForGrpBarChartTitle = filterPanelForHoriGrpBarChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','20px').style('text-indent','5px').style("font-size", "14px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #007aff").style("width","350px").style("color","#000000")
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; top:25.0%; font-size:14px; font-family:inter; color:#00001c;">'+ "Filter" +'</div>')

        var measuresColumnTitle = filterPanelForHoriGrpBarChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; text-indent:3px;">Available Measures</div>');

        var measuresVariables = filterPanelForHoriGrpBarChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable1"+targetElement[0][0].id)
        .style("list-style-type","none")
        .style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '78px')
        .style('position','absolute')
        .style("width","155px").style("min-height","190px").style("max-height","190px").style("border", "#f0f0f0 1px solid")
        .style("max-width","155px").style("overflow-x","hidden").style("overflow-y","auto")
        measuresVariables.style("left",0.0 + "px").style("padding","2px")

        $( ".filterPanelForHoriGrpBarChartClass" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });


        var measuresArray = [];
        var dimensionArray = [];

        var measuresArrayLength = [];
        var dimensionsArrayLength = [];

        dimensionArray.push(options.keys.label);
        //measuresArray = options.keys.stackedBars;

        for(var i = 0; i<divAndChartsArray.length; i++){
            if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    
                //measuresArray = newtargetElementAndOptionsArray[i].options.keys.groupBars;
                if(newtargetElementAndOptionsArray[i].options.keys.groupBars == undefined){
                    measuresArray = newtargetElementAndOptionsArray[i].options.keys.stackedAreas;
                }
                else {
                    measuresArray = newtargetElementAndOptionsArray[i].options.keys.groupBars;
                }
            }
        }
        
        // filter process
        var uniqueMeasuresArrayKeys = [];
        $.each(measuresArray, function(i, el){
            if($.inArray(el, uniqueMeasuresArrayKeys) === -1){
                uniqueMeasuresArrayKeys.push(el);
            }
        });

        var uniqueDimensionArrayKeys = [];
        $.each(dimensionArray, function(i, el){
            if($.inArray(el, uniqueDimensionArrayKeys) === -1){
                uniqueDimensionArrayKeys.push(el);
            }
        });
        
        // setting lenght for arrays
        for(var i = 0; i<uniqueMeasuresArrayKeys.length; i++){
            measuresArrayLength.push(i);
        }

        for(var i = 0; i<uniqueDimensionArrayKeys.length; i++){
            dimensionsArrayLength.push(i);
        }

        var measuresVariables1 = measuresVariables.selectAll("li") .data(measuresArrayLength).enter().append("li")
        .style("width","130px") .style("max-height","22px").style("cursor","move")
        .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#bcf1bc").style("font-weight","Normal")
        .style("list-style-type","none").style("border","1px #89e789 solid").style("color","#006600").style("font-family","Verdana,sans-serif")
        .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
        .text(function(d) {return uniqueMeasuresArrayKeys[d]})
        measuresVariables1.attr("class","MeasuresClass"+targetElement[0][0].id)
        
        var measuresColumnReceivedUI_TableTitle = filterPanelForHoriGrpBarChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','180px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; ">Selected Measures</div>');

        var measuresColumnReceivedUI_Table = filterPanelForHoriGrpBarChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable3"+targetElement[0][0].id)
        .style('background-color',"#ffffff").style('margin-left','180px').style('margin-top', '78px')
        .style("width","155px").style('position','absolute').style("padding","2px").style("min-height","190px")
        .style("border","1px #c1c1c1 dashed") .style("max-height","190px") .style("overflow-x","hidden") .style("overflow-y","auto")
        //.html('<div class=unsortable  style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:65.0%; font-size:14px; font-family:inter;  color:#99ea99; font-weight:Normal; text-align:center;">Drag and Drop Measures here from Available Measures List. </div>');
        .html('<img class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' src="images/dragIcon.png" style=" width:36px; height:36px; position:absolute; margin-left:65px; margin-top:60px; opacity:0.6"/>' 
        + '<div class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:60.0%; font-size:12px; font-family:inter;  color:#89d289; font-weight:Normal; text-align:center;">Drop Measures here. </div>');
        //.html('<div style="background-image: url(images/dragIcon.png); height: 64px; width: 64px; border: 1px solid black;"> </div>');

        var cancelButton = filterPanelForHoriGrpBarChart.append("div") .style("width","23px").style("height","21px").style('position','absolute')
        .style('margin-left','320px').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
        .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.9; background-color:#fcfcff")
        cancelButton[0][0].appendChild(cancelBtnImgVar)

        cancelButton.on("click", function(){
            filterPanelForHoriGrpBarChart.style("display","none")

            if ((showOrHideTabForHoriGrpBarChart == false) && (showOrHideCommentsForHoriGrpBarChart == true)){
                divLegendPanelForHoriGrpBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForHoriGrpBarChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
            }
            else if ((showOrHideTabForHoriGrpBarChart == true) && (showOrHideCommentsForHoriGrpBarChart == false)){
                divLegendPanelForHoriGrpBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForHoriGrpBarChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
            }
            else if ((showOrHideTabForHoriGrpBarChart == false) && (showOrHideCommentsForHoriGrpBarChart == false)){
                divLegendPanelForHoriGrpBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForHoriGrpBarChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
            }
        })

        var reRenderChartAndTableButton = filterPanelForHoriGrpBarChart.append("button").style("width","120px").style("height","25px").style('position','absolute')
        .style('margin-left','112px').style('margin-top','298px') .style("border-style", "none").style('background-color',"#2196f3")
        .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','15px').style("border-style", "solid").style('color','#ffffff')
        .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 1px #9b9b9b").style("border-radius","0px")
        var textForReRenderButton = document.createTextNode("Apply Changes");
        reRenderChartAndTableButton[0][0].appendChild(textForReRenderButton)

        reRenderChartAndTableButton.on("click", function(){

            if( $("#sortable3"+targetElement[0][0].id).children("li").length == 0 )
            {

                var alertPageDisabledDivForHoriGrpBarChart = targetElement.append('div').style('width',100 + '%')
                .style('height',100 + "%").style('position','absolute').style('margin-left', '0px').style('top', '0px')
                .style("background-color",'#f3f3f3').style("z-index",99)//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("opacity",0.2).style("display","block")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")

                var alertDivForHoriGrpBarChart = targetElement.append('div').style('width','350px')
                .style('height',"150px").style('position','absolute').style('left', ((targetElement[0][0].clientWidth/2) - 175) + "px").style('top', '1px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "solid").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","0px")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
                //.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Bold;">Sorry, no result found for selected' + 'range!'+ '</br>' + '<label style=text-indent:10px;> Hello</label' +'</div>')
                .html('<p  style="width: 340px; height:0%; background-color:#c7c7c7; position: absolute; top:40.0%; font-size:14px; font-family:inter; font-weight:Bold; margin-left:10px;  color:#f8f8f8; font-weight:Normal;">Check whether the Selected Measures box is not empty!</p>')

                var alertDivTitleForHoriGrpBarChart = alertDivForHoriGrpBarChart.append('div').style('width','340px')
                .style('height',"30px").style('position','absolute').style('margin-left', "0px").style('top', '0px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "none").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","2px")
                .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; font-weight:Bold; text-indent:5px;  color:#e5e5e5; font-weight:Normal;">TimeBound</div>')

                var horiGrpBarChartAlertOKButton = alertDivForHoriGrpBarChart.append("button") .style("width","40px") .style("height","20px") .style('position','absolute') .style("box-shadow", "0px 1px 1px #B8B8B8") 
                .style('background-color',"#7cc15e") .style('margin-left','300px') .style('top', "120px").style("color","#ffffff")
                .style("display","block").style('padding-top',"0px").style("cursor","pointer").style("box-shadow", "1px 1px 1px #56973a") .style("border-style", "none")
                .style("font-family","Verdana,sans-serif").style("font-size","14px").style("text-align","center").style("vertical-align","middle").style("border-radius","0px")
                .style("z-index",999)
            
                var textForAlertOKButton = document.createTextNode("OK");
                horiGrpBarChartAlertOKButton[0][0].appendChild(textForAlertOKButton)

                $("#"+targetElement[0][0].id).resizable('disable');

                horiGrpBarChartAlertOKButton.on('click', function() {
                    alertDivForHoriGrpBarChart.remove();
                    alertPageDisabledDivForHoriGrpBarChart.remove()
                    $("#"+targetElement[0][0].id).resizable('enable');
                })

                filterBtnForHoriGrpBarChart.style("cursor","pointer")
                
                if(showOrHideTabForHoriGrpBarChart == false){ 
                    svgPanelForHoriGrpBarChart.style('width', 75 + "%") .style('height', 85 + "%").style("position","absolute").style("background-color",options.BGcolor)
                    divLegendPanelForHoriGrpBarChart.style('width', 25 + "%") .style('height', 85 + "%").style("position","absolute").style("background-color",options.BGcolor)
                }   
                else if(showOrHideTabForHoriGrpBarChart == true){ 
                    svgPanelForHoriGrpBarChart.style('width', 75 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color",options.BGcolor)
                    divLegendPanelForHoriGrpBarChart.style('width', 25 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color",options.BGcolor)
                } 

                resizedFunctionForHoriGrpBarChart();
            }

            else{

                var selectedGroupMeasures = [];
                for(var i=0; i<$("#sortable3"+targetElement[0][0].id).children("li").length;i++){
                    selectedGroupMeasures.push($("#sortable3"+targetElement[0][0].id).children("li")[i].textContent)
                }
            
                var newOptions = {
                           data: options.data,
                           dataForDrillDown: options.dataForDrillDown,
                           dataForTable: options.dataForTable,
                           isDataDetailedForTable: options.isDataDetailedForTable,
                           keys: {
                               label: options.keys.label,//$("#sortable4"+targetElement[0][0].id).children("li")[0].textContent.toString(),
                               groupBars: selectedGroupMeasures,
                           },
                           chartTitle:options.chartTitle,
                           xAxisLable: "",//$("#sortable4"+targetElement[0][0].id).children("li")[0].textContent,
                           yAxisLable: options.keys.label,
                           showTitle: true,
                           colorSet: options.colorSet,
                           BGcolor:options.BGcolor,
                           drillDownColumnName:options.drillDownColumnName,
                           showTable: options.showTable,
                           showComments: options.showComments,
                           comments: options.comments,
                           series:options.series,
                           legend:options.legend,
                           resizeButtonID: options.resizeButtonID //document.getElementById("resizeBtn").id
                        }
                        
                        d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                        acinfotech.horizontalGroupedBarChart(targetElement,newOptions)
                }
            
            })

        var textBoxForMeasureColumnFrom;
        var textBoxForMeasureColumnTo;
        var selectTitleDivForEachDimension;

       
        $( "ul.droptrue"+targetElement[0][0].id ).sortable({
            appendTo: document.body,
            helper: "clone",
            connectWith: ".droptrue"+targetElement[0][0].id,
            scroll: false,
            cancel: '.unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+','+' .unMoveableIconAndTextClassDimensions'+targetElement[0][0].id,
            revertDuration: 10,
            scrollSensitivity: 10,
            scrollSpeed: 1,
            dynamic: true,

            receive: function(e, ui) { 
                 
                if (($(this)[0].id == "sortable3"+targetElement[0][0].id) || ($(this)[0].id == "sortable1"+targetElement[0][0].id)) {

                        if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                            if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                                 (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                            }
                            else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                                (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                            }

                        }
                } // if (($(this)[0].id == "sortable3") || ($(this)[0].id == "sortable1")) 

                else if (($(this)[0].id == "sortable2"+targetElement[0][0].id) || ($(this)[0].id == "sortable4"+targetElement[0][0].id)) {
                    if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                            //ui.sender.sortable("cancel");

                            if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                                 (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                            }
                            else if(  ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                                (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                            }
                        }
                } //if (($(this)[0].id == "sortable2") || ($(this)[0].id == "sortable4")) {

                $(ui.item).css({ 'position': 'relative' });

                if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                    ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                }
                 
                else if ($(this)[0].id == "sortable3"+targetElement[0][0].id) { // checking if the dropped element is in Measures drop area
                    
                    if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                        ui.sender.sortable("cancel");
                    }
                    else {
                        //ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                    }

                } // else if ($(this)[0].id == "sortable3") // checking if the dropped element is in Measures drop area ends here.

                else if ($(this)[0].id == "sortable4"+targetElement[0][0].id) { // checking if the dropped element is in Dimension drop area

                    if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                        ui.sender.sortable("cancel");
                    }
                    else {
                        ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                    }
                } //else if ($(this)[0].id == "sortable4")  // checking if the dropped element is in Dimension drop area ends here

                    if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                        
                        if ($(this)[0].id == "sortable1"+targetElement[0][0].id){
                            if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                            
                                if( ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                                    ui.sender.sortable("cancel");
                                } // if(  ui.sender.attr("id") === "sortable4")

                                else if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                                    ui.sender.sortable("cancel");
                                }
                            
                            } // if(ui.item.hasClass("DimesionsClass"))
                        }
                    if ($(this)[0].id == "sortable2"+targetElement[0][0].id){
                        if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                            
                            if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                                ui.sender.sortable("cancel");
                            }
                            else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                                ui.sender.sortable("cancel");
                               
                            }
                        }
                    }

                } //if ($(this)[0].id == "sortable1")

                if ($(this)[0].id == "sortable4"+targetElement[0][0].id){
                    if ($(this).children('li').length > 1 ){
                        ui.sender.sortable("cancel");
                        ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                    }    
                }

            }, //receive ends here

            start:function(ev, ui) {
                
            },
            stop:function(ev, ui) {
               
            },
        });
      
        /* ----------------- Filter panel and everything within it section ends here -----------------*/

        //-------- creating tooltip --------

        var tooltipForHoriGrpBarChart = targetElement .append('div') .attr('class', 'tooltipPie') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
        .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
        .style("padding-right", "7px") .style("background", "#F8F8F8") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style('z-index',1000)
        .style("border", "1.0px") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","80px")
        tooltipForHoriGrpBarChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'label').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "14px") .style("font-weight", "normal");
        tooltipForHoriGrpBarChart.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
        tooltipForHoriGrpBarChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");
        
        
        // if chart is changed (before or after resize button click)
        var optionsKey = {};
        if(options.keys.groupBars == undefined){
            optionsKey["label"] = options.keys.label;
            optionsKey["groupBars"] = options.keys.stackedAreas;
            
            options.keys = {};
            options.keys["label"] = optionsKey.label;
            options.keys["groupBars"] = optionsKey.groupBars;
            options.yAxisLable = optionsKey.label;
        }
        
        var dataArray = [];
        options.data.forEach(function(d, i) {
            var temp = {};
            for (i = 0; i < options.keys.groupBars.length; i++) {
                
                for (j = 0; j < Object.keys(d).length; j++) {
                     
                    if(options.keys.groupBars[i] === Object.keys(d)[j]){
                        temp[Object.keys(d)[j]] = d[Object.keys(d)[j]]
                    }
                 }
            }
            
            dataArray.push(temp)
        });

        var finalArray = [];
        options.data.forEach(function(d, i) {
    
            var finalArrayTemp = {};
            finalArrayTemp[options.keys.label] = d[options.keys.label]
            finalArrayTemp["data"] = dataArray[i];
            finalArray.push(finalArrayTemp)
        })
        
        var finalArrayNew = [];
        options.keys.groupBars.forEach(function(d, i) {
    
            var temp1 = {};
            temp1["name"] = options.keys.groupBars[i]
    
            finalArrayNew.push(temp1)
        })
        
        var finalNewNewArray = [];
        var dataArray1 = [];
        finalArrayNew.forEach(function(d, i) {
    
            var temp1 = {};
            temp1["name"] = options.keys.groupBars[i]
    
            for (j = 0; j < options.data.length; j++) {
                
                var tempTemp = {};
                tempTemp["label"] = options.data[j][options.keys.label];
                tempTemp["value"] = +options.data[j][options.keys.groupBars[i]];

                dataArray1.push(tempTemp)
                
            }
                temp1["data"] = dataArray1;
                dataArray1 = []
                finalNewNewArray.push(temp1)
        })
        
        var dataset = finalNewNewArray,
        series = dataset.map(function (d) {
            return d.name;
        }),
        dataset = dataset.map(function (d) {
            return d.data.map(function (o, i) {
            
                return {
                    y: o.label,
                    x: o.value
                };
            });
        })

        var xMax = d3.max(dataset, function (group) {
            return d3.max(group, function (d) {
                return d.x
            });
        })

        var yAxisLabels = dataset[0].map(function (d) { return d.y; });
        
        var x = d3.scale.linear() .domain([0, xMax]) .range([0, width])
        
        var y0 = d3.scale.ordinal() .domain(yAxisLabels) .rangeBands([0, height], .20) // 18

        var y1 = d3.scale.ordinal() .domain(d3.range(finalNewNewArray.length)) .rangeBands([0, y0.rangeBand()]);

        var xAxis = d3.svg.axis() .scale(x) .ticks(5) .orient("bottom");

        var yAxis = d3.svg.axis() .scale(y0) .orient("left");
        
        var hasDecimalPoint = false;
        for(var i = 0; i < options.keys.groupBars.length; i++){
            for(var j = 0; j < options.data.length; j++){
                if(options.data[j][options.keys.groupBars[i]].toString().indexOf('.') > -1){ hasDecimalPoint = true; break; }
            }
        }
        if(hasDecimalPoint == false){ xAxis.tickFormat(d3.format(".2s")) }
        
        var svg = svgPanelForHoriGrpBarChart.append("svg:g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

        svg.append("g") .attr("class", "y axis") .call(yAxis).selectAll("text").data(yAxisLabels) .style("text-anchor", "end")
        .style('fill','#00001c') .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
        .text(function(d,i) {
            if(d.length > 12){
                return d.substring(0,12)+'...';
            }
            else{
                return d;
            }
        })

        svg.append('g') .attr("class", "x axis") .attr('transform', 'translate(0,' + height + ')') .call(xAxis) .style("fill","#00001c").style("font-family","Verdana,sans-serif")

        var groupsForHoriGrpBarChart = svg.append("g").selectAll("g") .data(dataset)
		
		var groups1ForHoriGrpBarChart = groupsForHoriGrpBarChart.enter().append("g")
        .style("fill", function(d, i) { return colours(i); })
        .attr("transform", function(d, i) {return "translate(0,"+ y1(i) +")"; })
        .selectAll("rect").data(function(d) { return d; })
        .enter().append("rect").attr("width", 0)
        .attr("height", function(d) { return y1.rangeBand() })
        .attr("x", function(d, i) { return 0; }) 
        .attr("y", function(d) { return  y0(d.y); })
		.transition() .delay(400) .duration(800).attr("width", function(d) { return x(d.x); })
		.style('cursor','auto')

        if(options.dataForDrillDown.length == 0){
            
            var columnNames = d3.keys(options.data[0])
            var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
            
            for(var i = 0; i < columnNames.length ; i++){
                for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                    if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                        for(var k = 0; k < options.keys.groupBars.length; k++){
                            var len = d3.select(groupsForHoriGrpBarChart[0][k]).selectAll('rect')
                            for(var l = 0; l < len[0].length; l++){
                                d3.select(len[0][l]).attr('data-drilldownkey', function(d,index){
                                    return JSON.stringify(options.data[l]).slice(1, -1).split('"').join("").split(':').join("|")
                                })
                            }
                        }
                    }
                    else {
                    }
                }
            }
            
        }
        else if(options.dataForDrillDown.length > 0){
            
            options.keys.groupBars.forEach(function(measures, i) {
               var bars = d3.select(groupsForHoriGrpBarChart[0][i]).selectAll('rect')
               bars[0].forEach(function(d, index) {
                               var dd = d3.select(d)[0]
                               options.dataForDrillDown.forEach(function(val, i) {
                                    var key, keys = Object.keys(val), n = keys.length, newObj={}
                                    while (n--) { key = keys[n]; newObj[key.toLowerCase()] = val[key]; }
                                    var optKeysLabVal = options.keys.label.toString().toLowerCase();
                                    if(dd[0].__data__.y.toString().toLowerCase() === newObj[optKeysLabVal].toString().toLowerCase()){
                                        //if(dd[0].__data__.x == val[measures]){
                                        if(dd[0].__data__.x == newObj[measures.toLowerCase()]){
                                            d3.select(dd[0]).attr('data-drilldownkey', function(d,index){
                                                return JSON.stringify(val).slice(1, -1).split('"').join("").split(':').join("|")
                                            })
                                        }
                                    }
                                })
                        })
               })
        }
        
        

        // horizontalBars.transition().delay(function (d, i) { return i / valueArray.length * 750; }) .attr("width", function(d) { return widthScale(d); })  .attr("height", xScale.rangeBand() )
        // //.attr("x", function(d, i) {return xScale(i); })
        // .attr("y", function(d,i) { return xScale(i); });

        var format1 = d3.format('.3s')
        var textOnHoriGrpBarChart = groupsForHoriGrpBarChart.selectAll(".text")
        .data(function (d) { return d; })

        textOnHoriGrpBarChart.enter() .append("text").attr("class","text");

        textOnHoriGrpBarChart .transition() .duration(250) .style("text-anchor", "start") .attr("class", "series_value").style("display",options.series)
        .attr("x", function(d,i) { return x(d.x) + 5;  })
        .attr("y", function(d) { textHeight = d3.select("text").node().getBoundingClientRect().height;  
            computedWidth = (y1.rangeBand() / 2) - (textHeight / 2.7)
            if(computedWidth > 0){
                return (y0(d.y)) + (computedWidth + textHeight / 1.6);
            }
            else {
                return (y0(d.y)) + 7.0;
            }

        }) 
        .style("font-family", "Verdana,sans-serif")  .style("font-size", "12px")
        .style("fill", "#00001c") .transition().delay(1400)
        .text(function(d){
            
              if(d.x.toString().indexOf('.') === -1)
              {
                if(d.x.toString().length <= 3){
                    return d.x;
                }
                else{
                    return format1(d.x);
                }
              }
              else{
                return d.x;
              }
        })

        // Add the text label for the Y axis
        var yAxisVariable = svg.append("text") .attr("transform", "rotate(-90)") .attr("y", -115) .attr("x",0 - (height / 2.0)) .attr("dy", "1em") .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif")
        .style("font-size","12px") .text(options.yAxisLable) .style('fill','#00001c') .style("text-transform","capitalize") .style("font-weight","Bold")
        .style("font-style","normal")

        groupsForHoriGrpBarChart.selectAll('.text').on('mousemove', function (d,i){
            
            var root = targetElement
            var m = d3.mouse(root.node());
            m[0] += 0
            m[1] += 0
            
            var valueForHoriGrpChartToolTip;
            if(d.x.toString().indexOf('.') === -1)
            {
                valueForHoriGrpChartToolTip = d.x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            else{
                        
                valueForHoriGrpChartToolTip = d.x;
            }

                groupsForHoriGrpBarChart.on('mousemove', function (dd,j){
                    tooltipForHoriGrpBarChart.select('.label').html(finalNewNewArray[j].name)
                    tooltipForHoriGrpBarChart.select('.count').html(valueForHoriGrpChartToolTip)
                    tooltipForHoriGrpBarChart.style('visibility', 'visible')
                    tooltipForHoriGrpBarChart.select('hr').style("background-color", function(d){ return colours(j) })
                    tooltipForHoriGrpBarChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-20) + "px").style("display","block")
                })
        })
        .on('mouseout', function(){ tooltipForHoriGrpBarChart.style("display","none") })

        groupsForHoriGrpBarChart.selectAll('rect').on('mousemove', function (d,i){
                    
            var root = targetElement
            var m = d3.mouse(root.node());
            m[0] += 0
            m[1] += 0
                
            var valueForHoriGrpChartToolTip;
            if(d.x.toString().indexOf('.') === -1)
            {
                valueForHoriGrpChartToolTip = d.x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            else{
                        
                valueForHoriGrpChartToolTip = d.x;
            }

                groupsForHoriGrpBarChart.on('mousemove', function (dd,j){
                    tooltipForHoriGrpBarChart.select('.label').html(finalNewNewArray[j].name)
                    tooltipForHoriGrpBarChart.select('.count').html(valueForHoriGrpChartToolTip)
                    tooltipForHoriGrpBarChart.style('visibility', 'visible')
                    tooltipForHoriGrpBarChart.select('hr').style("background-color", function(d){ return colours(j) })
                    tooltipForHoriGrpBarChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-20) + "px").style("display","block")
                })
        })
        .on('mouseout', function(){ tooltipForHoriGrpBarChart.style("display","none") })

        //------------ adding legend section ------------
        var divLegendPanelForHoriGrpBarChart = targetElement .append('div')  .attr("class","divLegendPanelClassForHoriGrpBarChart")
        .style('background-color',"#ffffff") .style('position',"absolute") 
        //.style('width', 25 + "%") .style('height', 92 + "%") .style("left",75 + "%").style("top",8 + "%") 

        if ((showOrHideTabForHoriGrpBarChart == false) && (showOrHideCommentsForHoriGrpBarChart == true)){
                divLegendPanelForHoriGrpBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForHoriGrpBarChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
        }
        else if ((showOrHideTabForHoriGrpBarChart == true) && (showOrHideCommentsForHoriGrpBarChart == false)){
                divLegendPanelForHoriGrpBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForHoriGrpBarChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
        }
        else if ((showOrHideTabForHoriGrpBarChart == false) && (showOrHideCommentsForHoriGrpBarChart == false)){
                divLegendPanelForHoriGrpBarChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
                    
                svgPanelForHoriGrpBarChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color",options.BGcolor);
        }
        
        var legendPanelSvgForHoriGrpBarChart = divLegendPanelForHoriGrpBarChart .append('svg')  .attr("class","")
        .style("background-color",options.BGcolor) .style('position',"absolute").style('width', 100 + "%") .style('height', 100 + "%") .style("left",0 + "%").style("top",0 + "%")
        
        var legendForHoriGrpBarChart = legendPanelSvgForHoriGrpBarChart.append("g") .attr("class", "legend") .attr("height", "100%") .attr("width", "100%")
        .attr('transform', 'translate(0,20)')
        
        //Create colour squares
        var legendGrpForHoriGrpBarChart = legendForHoriGrpBarChart.selectAll('rect') .data(options.keys.groupBars) .enter() .append("rect") .attr("x", 5)
        .attr("y", function(d, i){ return i * 16;}) .attr("width", 14) .attr("height", 14) .attr("rx",10) .attr("ry",10)
        .style("fill", function(d, i){ return colours(i);}) .style("cursor","auto")
      

        //Create text next to squares
        legendForHoriGrpBarChart.selectAll('text') .data(options.keys.groupBars) .enter() .append("text") .attr("x", 25) .attr("y", function(d, i){ return i * 16 + 12;})
        .attr("fill", "#00001c") .text(function(d,i) { if(d.length > 10){
            return d.substring(0,10)+'...';
        }
        else{
            return d;
        } }) .style('font-size', '14px') .attr("fill","#00001c") .style("font-family","Verdana,sans-serif")

        // Aligning Legend (vertically)
        var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelForHoriGrpBarChart[0][0].style.width) / 100)
        var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelForHoriGrpBarChart[0][0].style.height) / 100)

        var legendRectSize = 11;
        var legendSpacing = 4;
            
        legendForHoriGrpBarChart.transition().duration(0).attr('transform', function(d, i) {
        var eachRectHeight = legendRectSize + legendSpacing;
        var offset =  eachRectHeight * colours.domain().length / 2;
        var horz = 0;
        var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.groupBars.length))/2.0; // originally 2.0
            
            return 'translate(' + horz + ',' + vert + ')';
        })

        legendGrpForHoriGrpBarChart.on('mouseover',function(d,i){
            groupsForHoriGrpBarChart.selectAll('rect').transition().style('fill-opacity',0.04)
            d3.select(groupsForHoriGrpBarChart[0][i]).selectAll('rect').transition().duration(400).style('fill-opacity',0.95)
        })
        legendGrpForHoriGrpBarChart.on('mouseout',function(d,i){
            groupsForHoriGrpBarChart.selectAll('rect').transition().style('fill-opacity',0.88).style('stroke-width',0)
        })
        
        legendGrpForHoriGrpBarChart.on('mouseover',function(d,i){
            
            
                if(yScale1GlobalVar == undefined){ // to check whether the widget is being resized or not (to save new y)
                    yScale1GlobalVar = y0;
                }

                textOnHoriGrpBarChart.style('display','none')
                
                d3.select(groupsForHoriGrpBarChart[0][i]).selectAll('text').style('display','block')
                .transition().duration(0).ease('bounce')//.attr("x", function(d,i) { return x(d.x) + 5;  })
                //.attr("y", function(d) { return yScale1GlobalVar(d.y) + 7.5; }) .style("fill", "#585858") 
                .attr("x", function(d,i) { return x(d.x) + 5;  })
                .attr("y", function(d) { textHeight = d3.select("text").node().getBoundingClientRect().height;  
                    computedWidth = (y1.rangeBand() / 2) - (textHeight / 2.7)
                    if(computedWidth > 0){
                        return (y0(d.y)) + (computedWidth + textHeight / 1.6);
                    }       
                    else {
                        return (y0(d.y)) + 7.0;
                    }
                })
                .text(function(d){
            
                    if(d.x.toString().indexOf('.') === -1)
                    {
                        return d.x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    }
                    else {
                        
                        return d.x;
                    }
                })
       
                groupsForHoriGrpBarChart.selectAll('rect').transition().style('fill-opacity',0.025)
                d3.select(groupsForHoriGrpBarChart[0][i]).selectAll('rect').transition().duration(400).style('fill-opacity',0.95)
            
        })

        legendGrpForHoriGrpBarChart.on('mouseout',function(d,i){
            
            if(yScale1GlobalVar == undefined){
                yScale1GlobalVar = y0;
            }

            if(newWidthVar == undefined){ // to check whether the widget is being resized or not (to save new width)
                    newWidthVar = width;
                }

            textOnHoriGrpBarChart .style('display','block') .transition() .duration(0) //.attr("x", function(d,i) { return x(d.x) + 5; })
            //.attr("y", function(d) { return y0(d.y) + 7.5; })
            .attr("x", function(d,i) { return x(d.x) + 5;  })
            .attr("y", function(d) { textHeight = d3.select("text").node().getBoundingClientRect().height;
                computedWidth = (y1.rangeBand() / 2) - (textHeight / 2.7)
                if(computedWidth > 0){
                    return (y0(d.y)) + (computedWidth + textHeight / 1.6);
                }
                else {
                    return (y0(d.y)) + 7.0;
                }

            })
            .text(function(d){
            
                  if(d.x.toString().indexOf('.') === -1)
                  {
                    if(d.x.toString().length <= 3){
                        return d.x;
                    }
                    else{
                        return format1(d.x);
                    }
                  }
                  else{
                    return d.x;
                  }
            })

            groupsForHoriGrpBarChart.selectAll('rect').transition().style('fill-opacity',0.88).style('stroke-width',0)
                
        })

        // ----------------------- adding table section ------------------
        var tablePanelForHoriGrpBarChart =  targetElement.append("div") .attr("id",targetElement[0][0].id + "holderForGroupedChartTableID")
        .attr("class","scrollingDivForTable-Class tableDivForHoriGrpBarChart" + targetElement[0][0].id) .style('background-color',"#ffffff") .style('position','absolute')
        .style("display","block") .style("overflow","hidden") .style("width", function(d) {  return 100.0 + "%"; })
        .style("height", function(d) { return 40 + "%"; }) .style("left",0 + "%").style("z-index",10)
        
        $( '.tableDivForHoriGrpBarChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        if(options.showTitle == true ){
            tablePanelForHoriGrpBarChart.style("top",60.0  + "%")
        }
        else if(options.showTitle == false  ){
            tablePanelForHoriGrpBarChart.style("top",60.0  + "%")
            
        }
        tablePanelForHoriGrpBarChart.html('<table class = "tableClassForHoriGroupedBarChart' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                          '<thead class = "theadClassForHoriGroupedBarChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForHoriGroupedBarChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                                          '<tbody class = "tBodyClassForHoriGroupedBarChart' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                          '</table>'
                                          )
        
        tablePanelForHoriGrpBarChart.select('table').attr("id",targetElement[0][0].id + "tableID")

        // Show or Hide Table scroll bar when mouseover on widget
        targetElement.on('mouseover',function(){ tablePanelForHoriGrpBarChart.style("overflow","auto") })
        targetElement.on('mouseout',function(d){ tablePanelForHoriGrpBarChart.style("overflow","hidden") })
        
        var tableDataForHoriGrpBarChart = [];
        if(options.dataForTable.length > 0){
            tableDataForHoriGrpBarChart = options.dataForTable;
        }
        else {
            tableDataForHoriGrpBarChart = options.data;
        }
        
        var thead = tablePanelForHoriGrpBarChart.select("thead").selectAll("th") .data(d3.keys(tableDataForHoriGrpBarChart[0]))
        .enter().append("th") .text(function(d){return d.charAt(0) .toUpperCase() + d.substr(1)}) .style("cursor","pointer") .style("min-width","100px")
        
        var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff") //f4f4f4
        .style("position","relative")
        
        var thead1 = d3.select(".thead1ClassForHoriGroupedBarChart" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tableDataForHoriGrpBarChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff") //f4f4f4
        .style("position","relative")
        
        var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
        .attr("id", "ascendingIconIDForGroupedBarChart") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
        
        var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
        .attr("id", "descendingIconIDForGroupedBarChart") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
        
        var tr = tablePanelForHoriGrpBarChart.select("tbody").selectAll("tr") .data(tableDataForHoriGrpBarChart).enter().append("tr")
        .attr("id", function(d,i) { return "slice" + i })
        
        // cells
        var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d})
        .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
        
        var $table = $('.tableClassForHoriGroupedBarChart' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
        
        d3.select(".theadClassForHoriGroupedBarChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
            d.forEach(function(dd,j){
                colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
            })
        })
        
        $(".thead1ClassForHoriGroupedBarChart" + targetElement[0][0].id).insertAfter('.tBodyClassForHoriGroupedBarChart' + targetElement[0][0].id)
        
        $(".thead1ClassForHoriGroupedBarChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForHoriGrpBarChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
        
        tablePanelForHoriGrpBarChart.select(".thead1ClassForHoriGroupedBarChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
        })
        
        $('.tableDivForHoriGrpBarChart' + targetElement[0][0].id).scroll(function () {
                                                                   
            $(".thead1ClassForHoriGroupedBarChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForHoriGrpBarChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
                                                                   
        })

        
        var sortOrder = false;
        thead1.on("click",function(k,index){
                 
                 sortOrder = !sortOrder;
                 
                 tablePanelForHoriGrpBarChart.select(".thead1ClassForHoriGroupedBarChart" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                                                              
                        if (sortOrder) {
                                          
                            if(i == index){
                                d3.select(this).select('svg').select('#descendingIconIDForGroupedBarChart').style("visibility", "hidden")
                                d3.select(this).select('svg').select('#ascendingIconIDForGroupedBarChart').style("visibility", "visible")
                            }
                            else {
                                d3.select(this).select('svg').select('#descendingIconIDForGroupedBarChart').style("visibility", "visible")
                                d3.select(this).select('svg').select('#ascendingIconIDForGroupedBarChart').style("visibility", "visible")
                            }
                        }
                        else{
                                          
                            if(i == index){
                                d3.select(this).select('svg').select('#descendingIconIDForGroupedBarChart').style("visibility", "visible")
                                d3.select(this).select('svg').select('#ascendingIconIDForGroupedBarChart').style("visibility", "hidden")
                            }
                            else {
                                d3.select(this).select('svg').select('#descendingIconIDForGroupedBarChart').style("visibility", "visible")
                                d3.select(this).select('svg').select('#ascendingIconIDForGroupedBarChart').style("visibility", "visible")
                            }
                        }
                })
                 
                  var monthTruOrFalAryForHoriGrpBarChart = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
                  
                  tr.sort(function(a, b) {
                          
                          if (sortOrder) {
                          var monthsArrayForHoriGrpBarChart = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                          } else {
                          var monthsArrayForHoriGrpBarChart = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                          }
                          
                          monthTruOrFalAryForHoriGrpBarChart = []; gotMonthArray = [];
                          tableDataForHoriGrpBarChart.forEach(function(d,i){
                              var da = d[k].toString().substring(0,3).toLowerCase()
                              if(monthsArrayForHoriGrpBarChart.indexOf(da) >= 0){
                                  monthTruOrFalAryForHoriGrpBarChart.push(true)
                                  gotMonthArray.push(da);
                              }
                              else {
                                  monthTruOrFalAryForHoriGrpBarChart.push(false)
                              }
                          })
                          
                          if(monthTruOrFalAryForHoriGrpBarChart.indexOf(false) == -1){ // true
                          
                          monthArray = []; monthArrayCount = [];
                          gotMonthArray.forEach(function(dd,j){
                                var index1 = monthsArrayForHoriGrpBarChart.indexOf(dd.substring(0,3))
                                if(monthArrayCount.indexOf(index1) >= 0){
                                    index1 = 12 + index1;
                                }
                                monthArray.push(index1);
                                monthArrayCount.push(index1)
                          })
                          returnArray = []
                          monthArray.sort(function(aa, bb) {
                              returnArray.push(+aa - +bb)
                              return +aa - +bb;
                          })
                          
                          sortTableFunc()
                          return returnArray[ind++];
                          } //  if true (if jan feb if block)
                          else {
                          var data = +a[k];
                          
                          if(!isNaN(data)){
                          
                          if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                          else { return d3.descending(+a[k], +b[k]); }
                          }
                          else if(!isNaN(Date.parse(a[k]))){
                          
                          if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                          else { return new Date(b[k]) - new Date(a[k]) }
                          }
                          else {
                          
                          if (sortOrder) { return d3.ascending(a[k], b[k]); }
                          else { return d3.descending(a[k], b[k]); }
                          }
                          } // if not jan feb else block
                    }); // tr

		})
        
        function sortTableFunc(){
            
            var table = tablePanelForHoriGrpBarChart.select('table');
            var rows = table.selectAll('tr').data(tableDataForHoriGrpBarChart);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0).style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500)
            .style('opacity', 1.0).style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
        }
        
        // Main Table Styling
        tablePanelForHoriGrpBarChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
        .style("color","#00001c")
        .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4")
        tablePanelForHoriGrpBarChart.selectAll('td').style("height","25px") .style("border", "1px solid #dddddd") .style("font-size","12px").style("font-weight","Normal").style("color","#00001c")

        //additionally 
        tablePanelForHoriGrpBarChart.selectAll('th').style('background-color',"#ffffff").style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
        tablePanelForHoriGrpBarChart.selectAll('td').style('background-color',"#ffffff").style("border-style","none").style("color","#2c2c2c").style("color","#00001c")

        //b1da9f
        tablePanelForHoriGrpBarChart.selectAll('table') . style("border-collapse","collapse")
        tablePanelForHoriGrpBarChart.selectAll('table tr:first-child th').style("border-top","0px")
        tablePanelForHoriGrpBarChart.selectAll('table tr:last-child td').style("border-bottom","0px")
        tablePanelForHoriGrpBarChart.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
        tablePanelForHoriGrpBarChart.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")

        if(showOrHideTabForHoriGrpBarChart == false){
            tablePanelForHoriGrpBarChart.style("display","none")
        }
        else if(showOrHideTabForHoriGrpBarChart == true){
            tablePanelForHoriGrpBarChart.style("display","block")
        }

        if(options.isDataDetailedForTable == false){
        
            var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
        
            // Adding underlines for selected drill-down column text
            var drillDownSectionsForGroupedBarChart = tablePanelForHoriGrpBarChart.select('table').selectAll('th')
        
            var foundResult = [];
            for(var i = 0; i<drillDownSectionsForGroupedBarChart[0].length; i++){
            
                for(var j = 0; j<drillDownColumnNamesArray.length; j++){
                    if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForGroupedBarChart[0][i].__data__.toString().toLowerCase() ){
                        foundResult.push(i)
                    }
                }
            }
        
            var r = tablePanelForHoriGrpBarChart.select('table').selectAll('tr').selectAll('td')
            for(var i = 0; i<r.length; i++){
                for(var j = 0; j < foundResult.length; j++){
                    var row = r[i][foundResult[j]]
                    $(row).css("text-decoration", "underline")
                }
            }
        }
        
        //By default calling the resized function first time (to align table's th and td).
        setTimeout(function(){ resizedFunctionForHoriGrpBarChart() },1000)
        
        window.addEventListener('resize', function(event){ resizedFunctionForHoriGrpBarChart() });
        
		var yScale1GlobalVar;
		var newHeightVar; // storing the new height when parent div is resized.
		var newWidthVar; // storing the new height when parent div is resized.

        $(function() {
          
          $("#" + targetElement[0][0].id).resizable({
                resize: function(event, ui) {
                    resizedFunctionForHoriGrpBarChart();
                }
            });
          });
        
        function resizedFunctionForHoriGrpBarChart()
        {
            
            if((svgPanelForHoriGrpBarChart.node().getBoundingClientRect().width) && (svgPanelForHoriGrpBarChart.node().getBoundingClientRect().height) > 0){

                if(showOrHideCommentsBtnForHoriGrpBarChart == true){
                    stkCirAreaBtnForHoriGrpBarChart.style('margin-left', "2px")
                    grpBarBtnForHoriGrpBarChart.style('margin-left', "2px")
                    filterBtnForHoriGrpBarChart.style('margin-left', "2px")
                    refreshBtnForHoriGrpBarChart.style('margin-left', "2px")
                    commentsBtnForHoriGrpBarChart.style('margin-left', "2px")
                    menuBtnForHoriGrpBarChart.style('right', '0')
                }
                else if(showOrHideCommentsBtnForHoriGrpBarChart == false){
                    stkCirAreaBtnForHoriGrpBarChart.style('margin-left', "2px")
                    grpBarBtnForHoriGrpBarChart.style('margin-left', "2px")
                    filterBtnForHoriGrpBarChart.style('margin-left', "2px")
                    refreshBtnForHoriGrpBarChart.style('margin-left', "2px")
                    //commentsBtnForHoriGrpBarChart.style('right', '0')
                    commentsBtnForHoriGrpBarChart.style('display','none')
                    menuBtnForHoriGrpBarChart.style('right', '0')
                }

                optsBtnPanelForHoriGrpBarChart.style('right', '0')

                stgPanCanBtnForGroupedBarChart.style('right', '0')
                
                if(options.showTitle == true){
                
                    var margin1 = {top: 15, right: 40, bottom: 20, left: 130}, 
                    width1 = (svgPanelForHoriGrpBarChart.node().getBoundingClientRect().width) - margin1.left - margin1.right,
                    height1 = (svgPanelForHoriGrpBarChart.node().getBoundingClientRect().height) - margin1.top - margin1.bottom;
                    newWidthVar = width1;
                    newHeightVar = height1;
                }
                else if(options.showTitle == false){
                
                    var margin1 = {top: 15, right: 40, bottom: 20, left: 130}, 
                    width1 = (svgPanelForHoriGrpBarChart.node().getBoundingClientRect().width) - margin1.left - margin1.right,
                    height1 = svgPanelForHoriGrpBarChart.node().getBoundingClientRect().height - margin1.top - margin1.bottom;
                    newWidthVar = width1;
                    newHeightVar = height1
                }

                x.domain([0, xMax]) .range([0, width1])
        
                yScale1GlobalVar = y0.domain(yAxisLabels) .rangeBands([0, height1], .20) // 18

                y1.domain(d3.range(finalNewNewArray.length)) .rangeBands([0, y0.rangeBand()]);

                yAxis.scale(y0) .orient("left");

                xAxis.scale(x) .orient("bottom")

                svg.selectAll(".series_value").attr("x", function(d,i) { return x(d.x) + 5;  })
                .attr("y", function(d) { textHeight = d3.select("text").node().getBoundingClientRect().height;  
                    computedWidth = (y1.rangeBand() / 2) - (textHeight / 2.7)
                    if(computedWidth > 0){
                        return (y0(d.y)) + (computedWidth + textHeight / 1.6);
                    }
                    else {
                        return (y0(d.y)) + 7.0;
                    }
                }).style("fill","#00001c").style("font-family","Verdana,sans-serif")
                var svg1 = svg;
            
                svg1.select("svg") .attr("width", width1 + margin1.left + margin1.right) .attr("height", height1 + margin1.top + margin1.bottom)
                
                svg1.select(".y.axis") .call(yAxis).selectAll("text").data(yAxisLabels) .style("text-anchor", "end")
                .style('fill','#00001c') .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
                .text(function(d,i) {
                    if(d.length > 9){
                        return d.substring(0,9)+'...';
                    }
                    else{
                        return d;
                    }
                })
    
                svg1.select(".x.axis") .attr("transform", "translate(0," + height1 + ")") .call(xAxis) .style('fill','#00001c')
				
                var groupsArrayForHoriGrpBarChart = [];
                groupsForHoriGrpBarChart.selectAll('rect').data(function(d,i) { groupsArrayForHoriGrpBarChart[i] = y1(i); return d; })
                .attr("width", function(d) { return x(d.x); })
                .attr("height", function(d) { return y1.rangeBand() })
                .attr("x", function(d, i) {   return 0; })
                .attr("y", function(d) { return  y0(d.y); }).style('cursor','auto')
                
                for(var i=0;i<groupsForHoriGrpBarChart[0].length;i++){
                    var gg = groupsArrayForHoriGrpBarChart[i];
                    d3.select(groupsForHoriGrpBarChart[0][i])
                    .attr("transform", function(d, i) {return "translate(0,"+ gg +")"; })
                }

                
                textOnHoriGrpBarChart.attr("x", function(d,i) { return x(d.x) + 5;  })
                .attr("y", function(d) { textHeight = d3.select("text").node().getBoundingClientRect().height;  
                    computedWidth = (y1.rangeBand() / 2) - (textHeight / 2.7)
                    if(computedWidth > 0){
                        return (y0(d.y)) + (computedWidth + textHeight / 1.6);
                    }
                    else {
                        return (y0(d.y)) + 7.0;
                    }
                }).style("fill","#00001c").style("font-family","Verdana,sans-serif")
		
                yAxisVariable.attr("transform", "rotate(-90)") .attr("y", -115) .attr("x",0 - (height1 / 2.0)) .attr("dy", "1em")
                
                // Aligning Legend (vertically)
                var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelForHoriGrpBarChart[0][0].style.width) / 100)
                var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelForHoriGrpBarChart[0][0].style.height) / 100)

                var legendRectSize = 11;
                var legendSpacing = 4;
                
                legendForHoriGrpBarChart.attr('transform', function(d, i) {
                var eachRectHeight = legendRectSize + legendSpacing;
                var offset =  eachRectHeight * colours.domain().length / 2;
                var horz = 0;
                var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.groupBars.length))/2.0; // originally 2.0
                    
                    return 'translate(' + horz + ',' + vert + ')';
                })
                
                colWidth = []; 
				
                d3.select(".theadClassForHoriGroupedBarChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                        d.forEach(function(dd,j){
                                colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                        })
                })
                tablePanelForHoriGrpBarChart.select(".thead1ClassForHoriGroupedBarChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                        d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
                })
                
            }// checking svg panel width & height greater than zero function
        }
    }, //horizontalGroupedBarChart
    
    // ************************************************** Bell Curve Chart  **************************************************
    bellCurveChart: function(targetElement, options){
        
        //targetElement.style("min-width", "92%").style("min-height", "350px").style("max-width", "92%").style("max-height", "350px")
        
        var chartName = "BELLCURVECHART";
        
        acinfotech.allCharts(targetElement,options,chartName);
        
        targetElement.style("min-width", "350px").style("min-height", "350px").style("background-color", options.BGcolor)
        
        var titlePanelForBellCurveChart =  targetElement.append("div").style("background-color", options.BGcolor) .style("position","absolute")
        .style("padding","0px") .style("text-align", "left") .style('background-color',"#ffffff") .style("text-indent","6px")
        
        var optionsButtonPanelForBellCurveChart = targetElement.append('div').style('width',"25px").style('height',"80px").style('position','absolute')
        .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px")
        .style('right', '0').style("min-width","25px")
        .style("border-style","none").style("border-left", "solid #fcfcfc  1px")//.style("top",71.5 + "px")
        
        var filterButtonForBellCurveChart = optionsButtonPanelForBellCurveChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10).style('right', '0')
        .style('top','30px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var filterBtnImgVar = document.createElement("IMG");
        filterBtnImgVar.src = "images/filterIcon.png";
        filterBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        filterButtonForBellCurveChart[0][0].appendChild(filterBtnImgVar)
        
        var refreshButtonForBellCurveChart = optionsButtonPanelForBellCurveChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10).style('right', '0')
        .style('top','55px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var refreshBtnImgVar = document.createElement("IMG");
        refreshBtnImgVar.src = "images/refreshIcon.png";
        refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        refreshButtonForBellCurveChart[0][0].appendChild(refreshBtnImgVar)
        
        var menuButtonForBellCurveChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10).style('right', '0')
        .style('top','1px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var menuBtnImgVar = document.createElement("IMG");
        menuBtnImgVar.src = "images/menuIcon.png";
        menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
        menuButtonForBellCurveChart[0][0].appendChild(menuBtnImgVar)
        
        var ismenuButtonOfBellCurveChartClicked = false; // Menu toggle button variable
        menuButtonForBellCurveChart.on('click', function() {
                                            
        filterPanelForBellCurveChart.style("display","none");
        
        if(ismenuButtonOfBellCurveChartClicked == false){ // Checking if menu button is clicked
        ismenuButtonOfBellCurveChartClicked = true; // Menu toggle button variable
        optionsButtonPanelForBellCurveChart.style("display","block") // Showing option buttons menu panel
        }
        else if(ismenuButtonOfBellCurveChartClicked == true){ // Checking if menu button is clicked
        ismenuButtonOfBellCurveChartClicked = false
        optionsButtonPanelForBellCurveChart.style("display","none") // Hiding option buttons panel
        }
                                            
        })
        
        var downloadBtnForBellCurveChart = optionsButtonPanelForBellCurveChart.append("div").attr("id","downloadBtnForBellCurveChart-ID-" + targetElement[0][0].id)
        .style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff")
        .style('margin-left','2px').style('top','1px').style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        
        acinfotech.downloadFunctionality("downloadBtnForBellCurveChart-ID-" + targetElement[0][0].id,targetElement)
        
        var svgPanelForBellCurveChart = targetElement .append('svg') 
        .attr("class","bellCurve").style("background-color", options.BGcolor).style("position","absolute")
        
        if(options.showTitle == true){
            
            titlePanelForBellCurveChart.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 8 + "%"; })
            .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')
            svgPanelForBellCurveChart.attr('width', 100 + "%") .attr('height', 92 + "%") .style("top",8 + "%") .style("background-color", options.BGcolor).append('g')
            
            var margin = {top: 10 , right: 40, bottom: 80, left: 45}, //originally top: 42, left: 80
            width = (svgPanelForBellCurveChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = (svgPanelForBellCurveChart.node().getBoundingClientRect().height) - margin.top - margin.bottom;
            
        }
        else if(options.showTitle == false){
            titlePanelForBellCurveChart.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });
            svgPanelForBellCurveChart.attr('width', 100 + "%") .attr('height', 100 + "%") .style("left",0 + "%") .style("background-color", options.BGcolor).append('g')
            
            var margin = {top: 10, right: 40, bottom: 80, left: 45}, //originally top: 42, left: 80
            width = (svgPanelForBellCurveChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = svgPanelForBellCurveChart.node().getBoundingClientRect().height - margin.top - margin.bottom;
        }
        
        var colors;
        // checking color set for curves and dots
        if(options.colorSet === undefined){
            options.colorSet = "one"
            colors = d3.scale.ordinal() .range(["#aeaeaf","#ff6e5f"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "one"){
            options.colorSet = "one"
            colors = d3.scale.ordinal() .range(["#aeaeaf","#ff6e5f"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            options.colorSet = "two"
            colors =  d3.scale.ordinal() .range(["#aeaeaf","#e2d387"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            options.colorSet = "three"
            colors = d3.scale.ordinal() .range(["#aeaeaf","#cc719f"]);
        }
        else
        {
            options.colorSet = "one"
            colors = d3.scale.ordinal() .range(["#aeaeaf","#ff6e5f"]);
        }
        
        var data = [];
        options.data.forEach(function(d){
            data.push(+d[options.keys.value])
        })
        
        var normal = function(mean, variance) {
            var predicate = 1 / Math.sqrt(variance * 2 * Math.PI);
            
            return function(x) {
                return predicate * Math.exp( -Math.pow(x - mean, 2) / (2 * variance));
            };
        };
        
        // Calculate the sample variance of a data series.
        var variance = function(series) {
            var mean = d3.mean(series);
            return d3.sum(series.map(function(element) {
            return Math.pow(element - mean, 2);
            })) / (series.length - 1);
        };
        
        min = Math.floor(d3.min(data)),
        max = Math.ceil(d3.max(data));
        
        var normalTransform = normal(d3.mean(data), variance(data));
        var xSeries = [];
        
        /*if((max-min).toString().length < 4){
            for (var i = min; i <= max; i++) { xSeries.push(i); }
        }
        else if(((max-min).toString().length >= 4) && (max-min).toString().length < 5){
            for (var i = min; i <= max; i = i + 1000) { xSeries.push(i); }
        }
        else if(((max-min).toString().length >= 5) && (max-min).toString().length < 6){
            for (var i = min; i <= max; i = i + 575) { xSeries.push(i); }
        }
        else if(((max-min).toString().length >= 6) && (max-min).toString().length < 7){
            for (var i = min; i <= max; i = i + 1000) { xSeries.push(i); }
        }
        else if((max-min).toString().length >= 7){
            for (var i = min; i <= max; i = i + 2000) { xSeries.push(i); }
        }*/
        
        if((max-min).toString().length < 4){
            for (var i = min; i <= max; i++) { xSeries.push(i); }
        }
        else if(((max-min).toString().length >= 4) && (max-min).toString().length < 5){
            var increment=(max-min)/100;
            for (var i = min; i <= max; i = i + increment) { xSeries.push(i); }
        }
        else if(((max-min).toString().length >= 5) && (max-min).toString().length < 6){
            var increment=(max-min)/100;
            for (var i = min; i <= max; i = i + increment) { xSeries.push(i); }
        }
        else if(((max-min).toString().length >= 6) && (max-min).toString().length < 7){
            var increment=(max-min)/100;
            for (var i = min; i <= max; i = i + increment) { xSeries.push(i); }
        }
        else if((max-min).toString().length >= 7){
            var increment=(max-min)/1000;
            for (var i = min; i <= max; i = i + increment) { xSeries.push(i); }
        }
        
        //for (var i = min; i <= max; i++) { xSeries.push(i); } // originally
        //for (var i = min; i <= max; i = i + 10) { xSeries.push(i); }
        //for (var i = min; i <= max; i++) { xSeries.push(i); }
        
        var ySeries = xSeries.map(normalTransform);
        
        var combinedSeries = d3.zip(xSeries, ySeries);
        
        var width = targetElement[0][0].clientWidth - margin.left - margin.right,
        height = targetElement[0][0].clientHeight - margin.top - margin.bottom;
        
        var x = d3.scale.linear().range([0, width]);
        
        var y = d3.scale.linear().range([height, 0]);
        
        var xAxis = d3.svg.axis().scale(x).orient("bottom").tickFormat(d3.format(".3s")).ticks(0)//.tickSize(6, 0, 0)//.tickSubdivide(1).tickSize(0, 6, 0);
        
        var yAxis = d3.svg.axis().scale(y).orient("left").tickFormat(d3.format(".2s")).ticks(0)
        
        var line = d3.svg.line()
        .x(function(d) {
        return x(d[0]);
        })
        .y(function(d) {
        return y(d[1]);
        });
        
        var svgForBellCurveChart = svgPanelForBellCurveChart.append("svg") .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom) .append("g") .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
        
        x.domain(d3.extent(combinedSeries, function(d) { return d[0]; }));
        y.domain(d3.extent(combinedSeries, function(d) { return d[1]; }));
        
        var meanArray = [];
        for(var i = 0; i < options.data.length; i++){
            meanArray.push(options.data[i][options.keys.value])
        }
        
        var ticks = x.ticks()
        ticks = x.ticks()
        ticks.push(d3.sum(meanArray)/options.data.length)
        xAxis.tickValues(ticks)
        
        //var finallyMaxValue = d3.max(options.data, function(d) { return +d[options.keys.label]; })
        // y.domain([0, d3.max(options.data, function(d) { return +d[options.keys.label]; })] ).range([height, 0]);
        
        var zerothAxis = 0;
        var s = svgForBellCurveChart.call(xAxis).selectAll(".tick")
        .each(function(data) {
            
            var tick = d3.select(this);
            var transform = d3.transform(tick.attr("transform")).translate;
            if(data === d3.sum(meanArray)/options.data.length){
                zerothAxis = transform[0]
            
            }
        })
        
        var y1 = d3.scale.linear().range([height, 0]);
        var yAxis1 = d3.svg.axis().scale(y1).orient("left").tickFormat(d3.format(".2s")).ticks(0)
        y1.domain([0, d3.max(options.data, function(d) { return +d[options.keys.label]; })] ).range([height, 0]);
        svgForBellCurveChart.append("g") .attr("transform", "translate("+zerothAxis+",0)")
        .attr("class", ".y axis") .call(yAxis1) .style("font-weight","bold").style("fill","#00001c")
        svgForBellCurveChart.select(".axis").select("path").style("stroke-width","2px") // manually setting the thickness of y-axis
        svgPanelForBellCurveChart.select('path').remove();
        s.remove();
        
        svgForBellCurveChart.append("g") .attr("class", ".x axis") .attr("transform", "translate(0," + height + ")") .call(xAxis).selectAll("text").style("font-family","Verdana,sans-serif").style("font-weight","Normal").style("fill","#00001c");
        var xx = svgForBellCurveChart.selectAll(".axis")
        d3.select(xx[0][1]).select("path").style("stroke-width","2px")
        svgForBellCurveChart.append("g") .attr("transform", "translate("+zerothAxis+",0)") .attr("class", ".y axis")
        .style("font-weight","bold").style("fill","#00001c")
        
        svgForBellCurveChart.append("path") .datum(combinedSeries) .attr("class", "line") .attr("d", line) .style("stroke",colors(0)) // 009966
        .style("stroke-width","2px") .style("fill","none")
        
        
        svgForBellCurveChart.selectAll(".tick")
        .filter(function(d){ return d == d3.sum(meanArray)/options.data.length;} ) .select('line').style("stroke-width","2px") .attr('y2',function(d){ return 20 ;})
        
        svgForBellCurveChart.selectAll(".tick")
        .filter(function(d){ return d == d3.sum(meanArray)/options.data.length;} ).select('text') .attr('y',function(d){ return 24 ;})
        
        var curveDots = svgForBellCurveChart.append('g').selectAll('circle')
        .data(options.data)
        .enter()
        .append('circle').attr('fill',colors(1))
        .attr('cx', function (d) { return x(d[options.keys.value]);})
        //.attr('cy', function (d) { return 0;})
        //.transition().duration(2000).ease("bounce")
        .attr('cy', function (d) { return y(normalTransform(d[options.keys.value]));})
        .attr('r', 4).style("pointer","default")
        
        
        // Creating ToolTip for options button.
        var iconButtonTooltipForBellCurveChart = targetElement.append('div').style('width','240px').attr("id","too")
        .style('height',"25px").style('position','absolute')//.style('margin-left', "0px").style('top','25px')
        .style("background-color",'#404040 ').style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid") // 004b9d
        .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none").attr("border", 0.0)
        
        filterButtonForBellCurveChart.on('mousemove', function(d,i) {
            var root = targetElement
            var m = d3.mouse(root.node());
            m[0] += 0
            m[1] += 0
            var filterButtonTooltipText = "Filter";
            iconButtonTooltipForBellCurveChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForBellCurveChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')
                                    
        })
        filterButtonForBellCurveChart.on('mouseout', function(d,i) {
            iconButtonTooltipForBellCurveChart.style("display","none")
        })
        
        refreshButtonForBellCurveChart.on('mousemove', function(d,i) {
            var root = targetElement
            var m = d3.mouse(root.node());
            m[0] += 0
            m[1] += 0
            var refreshButtonTooltipText = "Refresh";
            iconButtonTooltipForBellCurveChart.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForBellCurveChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ refreshButtonTooltipText +'</div>')
                                    
        })
        refreshButtonForBellCurveChart.on('mouseout', function(d,i) {
            iconButtonTooltipForBellCurveChart.style("display","none")
        })
        
        menuButtonForBellCurveChart.on('mousemove', function(d,i) {
            var root = targetElement
            var m = d3.mouse(root.node());
            m[0] += 0
            m[1] += 0
            var refreshButtonTooltipText = "Menu";
            iconButtonTooltipForBellCurveChart.style("width","53px").style("margin-left", (m[0] - 63) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForBellCurveChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ refreshButtonTooltipText +'</div>')
                                        
        })
        menuButtonForBellCurveChart.on('mouseout', function(d,i) {
            iconButtonTooltipForBellCurveChart.style("display","none")
        })
        
        downloadBtnForBellCurveChart.on('mousemove', function(d,i) {
            var root = targetElement
            var m = d3.mouse(root.node());
            m[0] += 0
            m[1] += 0
            var downloadButtonTooltipText = "Download";
            
            iconButtonTooltipForBellCurveChart.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForBellCurveChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
        })
        downloadBtnForBellCurveChart.on('mouseout', function(d,i) {
            iconButtonTooltipForBellCurveChart.style("display","none")
        })

        
        // ----------------- Filter panel and everything within it section begins here ----------------
        var filterPanelForBellCurveChart = targetElement.append('div') .style('width',350 + "px") .attr("class","filterPanelForBellCurveChartClass" + targetElement[0][0].id)
        .style('position','absolute') .style('margin-left', "0px") .style("background-color",'#fefefe') .style("z-index",11)
        .style("border-color", "#ffffff").style("border-right", "solid #e5e5e5 1px")  .style("border-style", "solid") .style("box-shadow", "2px 0px 1px #eff8ec")
        .style("display","none").style("border-top", "solid #fdfdfd 1px").style("border-left","0px").style("border-bottom", "0px")
        .style('top', 0.0 + "%").style('height', 100 + "%").style('overflow-y',"hidden").style("overflow-x","hidden")
        .style("border-bottom", "solid #e5e5e5 1px") .style("box-sizing","border-box")
        
        var filterPanelForStkBarChartTitle = filterPanelForBellCurveChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','20px').style('text-indent','5px').style("font-size", "14px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #007aff").style("width","350px").style("color","#000000")
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; top:25.0%; font-size:14px; font-family:inter; color:#00001c;">'+ "Filter" +'</div>')
        
        var measuresColumnTitle = filterPanelForBellCurveChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter;  color:#00001c; font-weight:Normal; text-align:left; text-indent:3px;">Available Measures</div>');
        
        var measuresVariables = filterPanelForBellCurveChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable1"+targetElement[0][0].id)
        .style("list-style-type","none")
        .style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '78px')
        .style('position','absolute')
        .style("width","155px").style("min-height","190px").style("max-height","190px").style("border", "#f0f0f0 1px solid")
        .style("max-width","155px").style("overflow-x","hidden").style("overflow-y","auto")
        measuresVariables.style("left",0.0 + "px").style("padding","2px")
        
        $( ".filterPanelForBellCurveChartClass" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
            
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });
        
        
        var measuresArray = ["Below the mean","Above the mean"];
        var measuresArrayLength = [0,1];
        
        var measuresVariables1 = measuresVariables.selectAll("li") .data(measuresArrayLength).enter().append("li")
        .style("width","130px") .style("max-height","22px").style("cursor","move")
        .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#bcf1bc").style("font-weight","Normal")
        .style("list-style-type","none").style("border","1px #89e789 solid").style("color","#006600").style("font-family","Verdana,sans-serif")
        .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
        .text(function(d) {return measuresArray[d]})
        measuresVariables1.attr("class","MeasuresClass"+targetElement[0][0].id)
        
        var measuresColumnReceivedUI_TableTitle = filterPanelForBellCurveChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','180px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; ">Selected Measure</div>');
        
        var measuresColumnReceivedUI_Table = filterPanelForBellCurveChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable3"+targetElement[0][0].id)
        .style('background-color',"#ffffff").style('margin-left','180px').style('margin-top', '78px')
        .style("width","155px").style('position','absolute').style("padding","2px").style("min-height","190px")
        .style("border","1px #c1c1c1 dashed") .style("max-height","190px") .style("overflow-x","hidden") .style("overflow-y","auto")
        //.html('<div class=unsortable  style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:65.0%; font-size:14px; font-family:inter;  color:#99ea99; font-weight:Normal; text-align:center;">Drag and Drop Measures here from Available Measures List. </div>');
        .html('<img class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' src="images/dragIcon.png" style=" width:36px; height:36px; position:absolute; margin-left:65px; margin-top:60px; opacity:0.6"/>'
            + '<div class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:60.0%; font-size:12px; font-family:inter;  color:#89d289; font-weight:Normal; text-align:center;">Drop a Measure here. </div>');
        //.html('<div style="background-image: url(images/dragIcon.png); height: 64px; width: 64px; border: 1px solid black;"> </div>');
        
        var cancelButton = filterPanelForBellCurveChart.append("div") .style("width","23px").style("height","21px").style('position','absolute')
        .style('margin-left','320px').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white')
        .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.9; background-color:#fcfcff")
        cancelButton[0][0].appendChild(cancelBtnImgVar)
        
        cancelButton.on("click", function(){
            filterPanelForBellCurveChart.style("display","none")
        })
        
        var reRenderChartAndTableButton = filterPanelForBellCurveChart.append("button").style("width","120px").style("height","25px").style('position','absolute')
        .style('margin-left','112px').style('margin-top','298px') .style("border-style", "none").style('background-color',"#2196f3")
        .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','15px').style("border-style", "solid").style('color','#ffffff')
        .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 1px #9b9b9b").style("border-radius","0px")
        var textForReRenderButton = document.createTextNode("Apply Changes");
        reRenderChartAndTableButton[0][0].appendChild(textForReRenderButton)
        
        reRenderChartAndTableButton.on("click", function(){
                                    
        if( $("#sortable3"+targetElement[0][0].id).children("li").length == 0 )
        {
                
                var alertPageDisabledDivForLineChart =targetElement.append('div').style('width',100 + '%')
                .style('height',100 + "%").style('position','absolute').style('margin-left', '0px').style('top', '0px')
                .style("background-color",'#f3f3f3').style("z-index",99)//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("opacity",0.2).style("display","block")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
                
                var alertDivForLineChart = targetElement.append('div').style('width','350px')
                .style('height',"150px").style('position','absolute').style('left', ((targetElement[0][0].clientWidth/2) - 175) + "px").style('top', '1px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "solid").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","0px")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
                //.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Bold;">Sorry, no result found for selected' + 'range!'+ '</br>' + '<label style=text-indent:10px;> Hello</label' +'</div>')
                .html('<p  style="width: 340px; height:0%; background-color:#c7c7c7; position: absolute; top:40.0%; font-size:14px; font-family:inter; font-weight:Bold; margin-left:10px;  color:#f8f8f8; font-weight:Normal;">Check whether the Selected Measures box is not empty!</p>')
                
                var alertDivTitleForLineChart = alertDivForLineChart.append('div').style('width','340px')
                .style('height',"30px").style('position','absolute').style('margin-left', "0px").style('top', '0px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "none").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","2px")
                .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; font-weight:Bold; text-indent:5px;  color:#e5e5e5; font-weight:Normal;">TimeBound</div>')
                
                var lineChartAlertOKButton = alertDivForLineChart.append("button") .style("width","40px") .style("height","20px") .style('position','absolute') .style("box-shadow", "0px 1px 1px #B8B8B8")
                .style('background-color',"#7cc15e") .style('margin-left','300px') .style('top', "120px").style("color","#ffffff")
                .style("display","block").style('padding-top',"0px").style("cursor","pointer").style("box-shadow", "1px 1px 1px #56973a") .style("border-style", "none")
                .style("font-family","Verdana,sans-serif").style("font-size","14px").style("text-align","center").style("vertical-align","middle").style("border-radius","0px")
                .style("z-index",999)
                
                var textForLineChartAlertOKButton = document.createTextNode("OK");
                lineChartAlertOKButton[0][0].appendChild(textForLineChartAlertOKButton)
                
                $("#"+targetElement[0][0].id).resizable('disable');
                
                lineChartAlertOKButton.on('click', function() {
                        alertDivForLineChart.remove();
                        alertPageDisabledDivForLineChart.remove()
                        $("#"+targetElement[0][0].id).resizable('enable');
                    })
                
                filterButtonForBellCurveChart.style("cursor","pointer")
                
        }
                
        else {
                
            var selectedLineMeasures = [];
            for(var i=0; i<$("#sortable3"+targetElement[0][0].id).children("li").length;i++){
                selectedLineMeasures.push($("#sortable3"+targetElement[0][0].id).children("li")[i].textContent)
            }
                                
            var meanArray = [];
            for(var i = 0; i < options.data.length; i++){
                meanArray.push(+options.data[i][options.keys.value])
            }
                
            var filteredDataArray = []
            if(selectedLineMeasures.length == 1){
                if(selectedLineMeasures[0].toString().toLowerCase() === "below the mean"){
                    options.data.forEach(function(d, i) {
                            if(d[options.keys.value] <= d3.mean(meanArray)){
                                filteredDataArray.push(d)
                            }
                                            
                        });

                }
                else if(selectedLineMeasures.toString().toLowerCase() === "above the mean"){
                    options.data.forEach(function(d, i) {
                            if(d[options.keys.value] >= d3.mean(meanArray)){
                                filteredDataArray.push(d)
                            }
                                            
                        });
                }
            }
            else {
                filteredDataArray = options.data;
            }
            
                var newOptions = {
                data: filteredDataArray,
                keys: {
                    label: options.keys.label,
                    value: options.keys.value,
                    toolTipLabel: options.keys.toolTipLabel
                },
                chartTitle: options.chartTitle,
                showTitle: options.showTitle,
                BGcolor:options.BGcolor,
                colorSet: options.colorSet, //"one" or "two" or "three";
                resizeButtonID: options.resizeButtonID
            }   
            
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            acinfotech.bellCurveChart(targetElement, newOptions)
        }
        })
        
        var textBoxForMeasureColumnFrom;
        var textBoxForMeasureColumnTo;
        var selectTitleDivForEachDimension;
        
        $( "ul.droptrue"+targetElement[0][0].id ).sortable({
            appendTo: document.body,
            helper: "clone",
            connectWith: ".droptrue"+targetElement[0][0].id,
            scroll: false,
            cancel: '.unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+','+' .unMoveableIconAndTextClassDimensions'+targetElement[0][0].id,
            revertDuration: 10,
            scrollSensitivity: 10,
            scrollSpeed: 1,
            dynamic: true,
            
            receive: function(e, ui) {
            
            if (($(this)[0].id == "sortable3"+targetElement[0][0].id) || ($(this)[0].id == "sortable1"+targetElement[0][0].id)) {
            
            if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
            if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
            (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
            }
            else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
            (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
            }
            
            }
            } // if (($(this)[0].id == "sortable3") || ($(this)[0].id == "sortable1"))
            
            else if (($(this)[0].id == "sortable2"+targetElement[0][0].id) || ($(this)[0].id == "sortable4"+targetElement[0][0].id)) {
            if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
            //ui.sender.sortable("cancel");
            
            if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
            (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
            }
            else if(  ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
            (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
            }
            }
            } //if (($(this)[0].id == "sortable2") || ($(this)[0].id == "sortable4")) {
            
            $(ui.item).css({ 'position': 'relative' });
            
            if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
            ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
            }
            
            else if ($(this)[0].id == "sortable3"+targetElement[0][0].id) { // checking if the dropped element is in Measures drop area
            
            if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
            ui.sender.sortable("cancel");
            }
            else {
            //ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
            }
            
            } // else if ($(this)[0].id == "sortable3") // checking if the dropped element is in Measures drop area ends here.
            
            else if ($(this)[0].id == "sortable4"+targetElement[0][0].id) { // checking if the dropped element is in Dimension drop area
            
            if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
            ui.sender.sortable("cancel");
            }
            else {
            ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
            }
            } //else if ($(this)[0].id == "sortable4")  // checking if the dropped element is in Dimension drop area ends here
            
            if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
            
            if ($(this)[0].id == "sortable1"+targetElement[0][0].id){
            if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
            
            if( ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
            ui.sender.sortable("cancel");
            } // if(  ui.sender.attr("id") === "sortable4")
            
            else if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
            ui.sender.sortable("cancel");
            }
            
            } // if(ui.item.hasClass("DimesionsClass"))
            }
            if ($(this)[0].id == "sortable2"+targetElement[0][0].id){
            if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
            
            if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
            ui.sender.sortable("cancel");
            }
            else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
            ui.sender.sortable("cancel");
            
            }
            }
            }
            
            } //if ($(this)[0].id == "sortable1")
            
            // if ( ($(this)[0].id == "sortable3"+targetElement[0][0].id) || ($(this)[0].id == "sortable4"+targetElement[0][0].id) ){
            //     if ($(this).children('li').length > 1 ){
            //         ui.sender.sortable("cancel");
            //         ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
            //     }    
            // }
            
            if ($(this)[0].id == "sortable4"+targetElement[0][0].id){
            if ($(this).children('li').length > 1 ){
            ui.sender.sortable("cancel");
            ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
            }    
            }
            
            }, //receive ends here
            
            start:function(ev, ui) {
            
            },
            stop:function(ev, ui) {
            
            },
        });
        
        /* ----------------- Filter panel and everything within it section ends here -----------------*/
        
        filterButtonForBellCurveChart.on('click', function() {
                                    
            filterPanelForBellCurveChart.style("display","block");
                                    
        })
        
        // Refreshing Chart and Table
        refreshButtonForBellCurveChart.on('click', function() {
                                    
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){
            
                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData;
                }
            }
            acinfotech.bellCurveChart(targetElement,options)
                                    
        })
        
        downloadBtnForBellCurveChart.on('click', function() {
                                
            ismenuButtonOfBellCurveChartClicked= false; // Changing menu button value to false
            optionsButtonPanelForBellCurveChart.style("display","none") // Hiding option buttons panel
                                
        })
        
        var tip = d3.tip() .attr('class', 'd3-tip') .offset([-10, 0]) .style("font-family","Verdana,sans-serif").style("padding","4px").style("text-transform","capitalize")
        .style("font-weight","Bold").style("font-size","12px").style("color","#00001c").style("z-index",1000)
        .html(function(d, i) {
            var valueForBellCurveChartToolTip;
            if(d[options.keys.value].toString().indexOf('.') === -1)
            {
                valueForBellCurveChartToolTip = d[options.keys.value].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            else {
            
                valueForBellCurveChartToolTip = d[options.keys.value];
            }
            
            if(options.keys.toolTipLabel.length === 0){
                return options.keys.label + " : " + options.data[i][options.keys.label] + "<br>" + '<hr style="height:2px; width:100%px; margin:2px; border:none;color:#333;background-color:#E0E0E0;" />'+ options.keys.value +" : " + valueForBellCurveChartToolTip;
            }
            else {
            
                var toolTipInfoStrForBellCurveChart = "";
                for(var ind = 0; ind < options.keys.toolTipLabel.length; ind++){
                
                    toolTipInfoStrForBellCurveChart += "<br>" + '<hr style="height:1px; width:100%px; margin:2px; border:none;color:#333;background-color:#E0E0E0;" />' + options.keys.toolTipLabel[ind] + " : " + options.data[i][options.keys.toolTipLabel[ind]]
                
                }
                
                return options.keys.label + " : " + options.data[i][options.keys.label] + "<br>" + '<hr style="height:2px; width:100%px; margin:2px; border:none;color:#333;background-color:#E0E0E0;" />'+ options.keys.value +" : " + valueForBellCurveChartToolTip + toolTipInfoStrForBellCurveChart;
            }
            
        });
        svgForBellCurveChart.call(tip);
        curveDots.on('mouseover', tip.show)  .on('mouseout', tip.hide);
        
        /*var chart11 = document.getElementsByClassName("d3-tip")[0];
        var width11 = chart11.getClientRects()[0].width;
        var height11 = chart11.getClientRects()[0].height;*/
        
        var width1 = svgPanelForBellCurveChart[0][0].clientWidth;
        var height1 = svgPanelForBellCurveChart[0][0].clientHeight;
        
        //var width111 = chartTitlePanelForColumnChart[0][0].clientWidth
        //var height111 = chartTitlePanelForColumnChart[0][0].clientHeight
        
        var root = targetElement;
        var scr = { x: window.scrollX, y: window.scrollY, w: svgPanelForBellCurveChart[0][0].clientWidth, h: svgPanelForBellCurveChart[0][0].clientHeight };
        var body_sel = d3.select('body');
        var body = { w: body_sel.node().offsetWidth, h: body_sel.node().offsetHeight };
        //var doc = { w: width, h: height };
        var svgpos = root.node().parentNode
        
        var dist = { x: 20, y: 20 };
        
        curveDots.on("mousemove", function(d,i){
            var m = d3.mouse(root.node());
            scr.x = window.scrollX;
            scr.y = window.scrollY;
            m[0] += 0
            m[1] += 0
            tip.style("right", "");
            tip.style("left", "");
            tip.style("bottom", "");
            tip.style("top", "");
            
            tip.style("border-color", d3.select(this).style("fill"))
            
            if(d3.mouse(this)[0] < scr.w/2){
            
                tip.style("left", (d3.event.pageX + 12 )  + "px");
                tip.style("top", (d3.event.pageY - ( parseFloat(tip.style("height")) /2  ) )+ "px");
            }
            else if(d3.mouse(this)[0] > scr.w/2){
            
                tip.style("left", (d3.event.pageX) - (parseFloat(tip.style("width"), 10) + 20) + "px");
                tip.style("top", (d3.event.pageY - ( parseFloat(tip.style("height")) /2  ) ) + "px");
            }
            else if(d3.mouse(this)[0] == scr.w/2){
                
                tip.style("left", (d3.event.pageX) - (parseFloat(tip.style("width"), 10) + 20) + "px");
                tip.style("top", (d3.event.pageY - ( parseFloat(tip.style("height")) /2  ) ) + "px");
            }
        });
        
        // Adding the text label for the Y axis

        var yAxisVariable = svgPanelForBellCurveChart.append("text") .attr("transform", "rotate(-90)") .attr("y", 5) .attr("x",0 - (height / 2.0)) .attr("dy", "1em") .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif")
        .style("font-size","12px") .text(options.yAxisLable) .style('fill','#00001c') .style("text-transform","capitalize") .style("font-weight","Bold")
        .style("font-style","normal")
        
        // Adding the text label for the X axis
        var xAxisVariable =  svgPanelForBellCurveChart.append("text") .attr("transform", "translate(" + ((width/2)+20) + " ," + (height + 50) + ")")
        .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif") .style("font-weight","Bold") .style("font-size","12px") .text(options.xAxisLable) .style('fill','#00001c')
        .style("text-transform","capitalize") .style("font-style","normal")
        
        var sampleIDForStackedBarChart=targetElement[0];
        
        window.addEventListener('resize', function(event){ resizedFuctionForBellCurve(); });
        
        $(function() {
        
            $("#" + sampleIDForStackedBarChart[0].id).resizable({
                resize: function(event, ui) {
                    resizedFuctionForBellCurve();
                }
            });
        });
        
        function resizedFuctionForBellCurve()
        {
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            acinfotech.bellCurveChart(targetElement,options)
        }
        
    },
    
    // ************************************************** Table (Grid) *************************************************
    table: function(targetElement, options){
        
        isChartCalled++;

        var chartName = "TABLE";
        
        acinfotech.allCharts(targetElement,options,chartName);

        // if(isTableCalledForOnce == false){
        //     receivedDataForTableFirstTime = options.data
        //     isTableCalledForOnce = true    
        // }
        
        var newJson = [];
        options.data.forEach(function(d, i) {
             var temp = {};
             
             for(var i = 0; i < Object.keys(d).length; i++) {
             delete d['enabled'];
             temp[Object.keys(d)[i]] = d[Object.keys(d)[i]]
             }
             
             newJson.push(temp)
         });
        options.data = [];
        options.data = newJson;
        
        targetElement.style("min-width","350px").style("min-height","350px").style("background-color", "#ffffff")
        
        var targetElementWidthOfTable = targetElement[0][0].clientWidth
        var targetElementHeightOfTable = targetElement[0][0].clientHeight
        
        var chartTitlePanelForTable =  targetElement.append("div").style("background-color","#001d3b").style("position","absolute").style("text-align","center").style("min-height","40px").style('background-color',"#fefdfd")
        .style("border-bottom", "solid #e6e6e6  1px")
        
        var menuButtonForTable = targetElement.append("div") .style("width","25px").style("height","20px").style('position','absolute')
        .style('background-color',"#fdfdfd").style('margin-left','2px').style("z-index",10)
        .style('top', 7 + 'px') .style("cursor","pointer").style("display","block") 
        .style("border-style", "none").style('padding',"0px") //.style("border", "solid #e6e6e6  1px")
        var menuBtnImgVar = document.createElement("IMG");
        menuBtnImgVar.src = "images/menuIcon.png";
        menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:1px; width:16px; height:16px; opacity:0.8;")
        menuButtonForTable[0][0].appendChild(menuBtnImgVar)

        // var now = new Date();
        // var day = ("0" + now.getDate()).slice(-2);
        // var month = ("0" + (now.getMonth() + 1)).slice(-2);
        // //var today = now.getFullYear() + "-" + (month) + "-" + (day);
        // var today =  (month) + "/" + (day) + "/" + now.getFullYear();
        
        // var dateAndTimeDivForTable =  targetElement.append("div").style("width","auto").style("height","20px").style("min-width","80px")
        // .style("position","absolute")
        // .style("text-align", "left") .style('background-color',"#fefdfd") .style('margin-left','34px') .style('top', 10 + 'px').style("z-index",10)
        // .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; padding-left:6px; top:20.0%; font-size:12px; font-family:inter; color:#005281; font-weight:Bold;">'+ today + '</div>')

        var logoDivForTable = targetElement.append("div") .style("width","120px").style("height", 38 + "px").style('position','absolute')
        .style('background-color',"#fdfdfd").style('right', '0').style("z-index",10)
        .style('top','1px') .style("display","none")
        // var logoImgVar = document.createElement("IMG");
        // logoImgVar.src = "images/Final-logo-c.svg";
        // logoImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:120px; height:32px;")
        // logoDivForTable[0][0].appendChild(logoImgVar)

        var menuDivForTable = targetElement.append("div") .style("width","0px").style("height", (targetElementHeightOfTable - 40) + "px").style('position','absolute')
        .style('background-color',"#fefdfd").style('left',0 + "px").style('top', 40 + 'px').style("z-index",10) //001d3b
        .style("border-right", "solid #e9e9e9  1px").style("display","none")

        var searchButonForTable = menuDivForTable.append("div") .style("width","24px").style("height","24px").style('position','absolute')
        .style('background-color',"#fefdfd").style('margin-left','4px').style("z-index",10)
        .style('top', 5 + 'px') .style("cursor","pointer").style("display","block")
        .style("border-style", "none").style('padding',"0px")
        var searchBtnImgVar = document.createElement("IMG");
        searchBtnImgVar.src = "images/searchChart1.png";
        searchBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:22px; height:22px;")
        searchButonForTable[0][0].appendChild(searchBtnImgVar)

        var refreshButonForTable = menuDivForTable.append("div") .style("width","24px").style("height","24px").style('position','absolute')
        .style('background-color',"#fefdfd").style('margin-left','4px').style("z-index",10)
        .style('top', 34 + 'px') .style("cursor","pointer").style("display","block")
        .style("border-style", "none").style('padding',"0px")
        var refreshBtnImgVar = document.createElement("IMG");
        refreshBtnImgVar.src = "images/refreshIcon.png";
        refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:22px; height:22px;")
        refreshButonForTable[0][0].appendChild(refreshBtnImgVar)

        var deleteTabColButtonForTable = menuDivForTable.append("div") .style("width","24px").style("height","24px").style('position','absolute')
        .style('background-color',"#fefdfd").style('margin-left','4px').style("z-index",10)
        .style('top', 63 + 'px') .style("cursor","pointer").style("display","block")
        .style("border-style", "none").style('padding',"0px")//.style("border-bottom", "solid #e5e5e5  1px")
        var deleteTabColBtnImgVar = document.createElement("IMG");
        deleteTabColBtnImgVar.src = "images/delectTableColumnIcon.png";
        deleteTabColBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:22px; height:22px;")
		deleteTabColButtonForTable[0][0].appendChild(deleteTabColBtnImgVar)
        
        var downloadBtnForTable = targetElement.append("div").attr("id","downloadBtnForTable-ID-" + targetElement[0][0].id).style("width","20px").style("height","20px")
        .style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff").style('right','5px').style('top','5px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        
        acinfotech.downloadFunctionality("downloadBtnForTable-ID-" + targetElement[0][0].id,targetElement)
        
        // Creating ToolTip for options button.
        var iconButtonTooltipForTable = targetElement.append('div').style('width','240px')//.attr("id","too")
        .style('height',"25px").style('position','absolute')//.style('margin-left', "0px").style('top','25px')
        .style("background-color",'#404040 ').style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid") // 004b9d
        .style("border-radius","1px").style("box-shadow", "1px 1px 1px #888888").style("display","none").attr("border", 0.0)

        searchButonForTable.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var searchButonForTableTooltipText = "Search";
            
            iconButtonTooltipForTable.style("width","56px").style("margin-left", (m[0] + 15) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForTable.html('<div  style="width: 100%; height:0%; padding-left:10px; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:Arial;  color:#ffffff; ">'+ searchButonForTableTooltipText +'</div>')

        })
        searchButonForTable.on('mouseout', function(d,i) {
            iconButtonTooltipForTable.style("display","none")
        })

        refreshButonForTable.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var refreshButonForTableTooltipText = "Refresh";
            
            iconButtonTooltipForTable.style("width","60px").style("margin-left", (m[0] + 15) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForTable.html('<div  style="width: 100%; height:0%; padding-left:10px; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:Arial;  color:#ffffff; ">'+ refreshButonForTableTooltipText +'</div>')

        })
        refreshButonForTable.on('mouseout', function(d,i) {
            iconButtonTooltipForTable.style("display","none")
        })

        deleteTabColButtonForTable.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var deleteTabColForTableTooltipText = "Delete a Table Column";
            
            iconButtonTooltipForTable.style("width","144px").style("margin-left", (m[0] + 15) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForTable.html('<div  style="width: 100%; height:0%; padding-left:10px; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:Arial;  color:#ffffff; ">'+ deleteTabColForTableTooltipText +'</div>')

        })
        deleteTabColButtonForTable.on('mouseout', function(d,i) {
            iconButtonTooltipForTable.style("display","none")
        })

        downloadBtnForTable.on('mousemove', function(d,i) {
              var root = targetElement
              var m = d3.mouse(root.node());
              m[0] += 0
              m[1] += 0
              var downloadButtonTooltipText = "Download";
              iconButtonTooltipForTable.style("width","74px").style("margin-left", (m[0] + 15) + "px").style("margin-top",(m[1]) + "px").style("display","block")
              iconButtonTooltipForTable.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
        })
        downloadBtnForTable.on('mouseout', function(d,i) {
              iconButtonTooltipForTable.style("display","none")
        })
        
        var isMenuButtonClicked = false;
        menuButtonForTable.on('click', function() {
                              
            leftPanelDivForSearchForTable.style("display","none")
            tempDivTableForPieChart.style("display","none")
            leftPanelDivForRemoveTableColumn.style("display","none")
                              
            if(isMenuButtonClicked == false){
                isMenuButtonClicked = true;

                 // To hide option button tool tip, change cursor pointer and disable the whole Chart and Table expect Filter panel.
                iconButtonTooltipForTable.style("display","none")
                menuDivForTable.style("display","block")

                //filterButonForTable.transition().style('width', 24 + "px").duration(100).delay(100).style("display","block")
                searchButonForTable.transition().style('width', 24 + "px").duration(100).delay(100).style("display","block")
                refreshButonForTable.transition().style('width', 24 + "px").duration(100).delay(100).style("display","block")
                deleteTabColButtonForTable.transition().style('width', 24 + "px").duration(100).delay(100).style("display","block")
                // downloadBtnForTable.transition().style('width', 20 + "px").duration(100).delay(100).style("display","block")

                if(options.showTitle == false){
                    menuDivForTable.transition().duration(200).delay(200).style('top', 0 + "px").style('height', 100.0 + "%").style("width","32px")
                }
                else if(options.showTitle == true){
                    menuDivForTable.style('top', 40.0 + "px").style('height', (targetElementHeightOfTable - 40) + "px").style("width","32px")
                }
                menuDivForTable.transition().duration(200).delay(200).style("border-right", "solid #e7e7e7  1px")
            }
            else if(isMenuButtonClicked == true){
                isMenuButtonClicked = false;

                menuDivForTable.style("display","block").transition().style('width', 0 + "px").duration(200).delay(50)
                //filterButonForTable.transition().duration(170).delay(100).style("display","none")
                searchButonForTable.transition().duration(170).delay(100).style("display","none")
                refreshButonForTable.transition().duration(170).delay(100).style("display","none")
                deleteTabColButtonForTable.transition().duration(170).delay(100).style("display","none")
                // downloadBtnForTable.transition().duration(170).delay(100).style("display","none")
            }
           
        }) //filterChartButton.on('click', function() )

        searchButonForTable.on('click', function() {
           
            isSearchInTableButtonClicked = true;
                               
            menuDivForTable.style("display","none");
            isMenuButtonClicked = false;

            leftPanelDivForSearchForTable.style("display","block").style('width', 260 + "px")//.duration(200).delay(50)
                if(options.showTitle == false){
                    leftPanelDivForSearchForTable.style('top', 0 + "px").style('height', 100.0 + "%")
                }
                else if(options.showTitle == true){
                    leftPanelDivForSearchForTable.style('top', 40 + "px").style('height', (targetElementHeightOfTable - 40) + "px")
                }
            tempDivTableForPieChart.style("display","block")

            if(options.showTitle == false){
                //searchDivForPieChartForSearchTable.style('top', 0.0 + "%").style('height', 60.0 + "%")
                tempDivTableForPieChart.style("display","block").style('width', (targetElement[0][0].clientWidth - 260) + "px")
                .style('height', 100.0 + "%").style('top', 0 + "px")//.transition().duration(200).delay(50)
            
            }
            else if(options.showTitle == true){
                //searchDivForPieChartForSearchTable.style('top', 8.0 + "%").style('height', 52.0 + "%")
                tempDivTableForPieChart.style("display","block").style('width', (targetElement[0][0].clientWidth - 260) + "px")
                .style('height', (targetElementHeightOfTable - 40) + "px").style('top', 40 + "px")
            }

        });

        refreshButonForTable.on('click', function() {
            /*d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            options.data = receivedDataForTableFirstTime;
            acinfotech.table(targetElement,options)*/

            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                }
            }
            acinfotech.table(targetElement,options) 

        });

        deleteTabColButtonForTable.on('click', function() {
            menuDivForTable.style("display","none");
            isMenuButtonClicked = false;
                                      
            leftPanelDivForRemoveTableColumn.style("display","block")
        });
        
        downloadBtnForTable.on('click', function() {
                                  
           isMenuButtonClicked = false; // Changing menu button value to false
           menuDivForTable.style("display","none") // Hiding option buttons panel
        })
        
        // ------------------------------------------ Search Table creating left panel section begins here --------------------------------------------------

        var leftPanelDivForSearchForTable = targetElement.append("div") .style("width","260px").style("height",(targetElementHeightOfTable - 40) + "%").style('position','absolute')
        .style('background-color',"#ffffff").style('margin-left','0px').style("z-index",10).attr("class","searchPanelClassForTable" + targetElement[0][0].id)
        .style('top', 40 + 'px') .style("display","none") .style("overflow","auto").style("overflow-x","hidden")
        .style('padding',"0px") .style("border-right", "solid #e6e6e6  1px") .style("border-top", "solid #e9e9e9  1px") .style("box-sizing","border-box")

        if(options.showTitle == true){
            leftPanelDivForSearchForTable.style('width', 0 + "px") .style('height', (targetElementHeightOfTable - 40) + "%") .style("top",40 + "px") 
        }
        else if(options.showTitle == false){
            leftPanelDivForSearchForTable.style('width', 0 + "px") .style('height', 100 + "%") .style("top",0 + "px") 
        }
        
        $( '.searchPanelClassForTable' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        var leftPanelDivForSearchForTableTitle = leftPanelDivForSearchForTable.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif").style("font-weight", "Bold")
        .style('margin-left','0px').style('margin-top','12px').style('text-indent','5px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000").style("display","block")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:15.5%; font-size:16px; font-family:Arial;  color:#005281; font-weight:Bold;">'+ "Search"+'</div>')

         var cancelButtonForSearchForTable = leftPanelDivForSearchForTable.append("div") .style("width","23px").style("height","21px").style('position','absolute')
         .style('margin-left',"231px").style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
         .style('background-color',"#FCFCFF")
         .style("border", "0.0px") .style("border-style", "1px solid rgb(246, 246, 246)").style('color','white')
         .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
         var cancelBtnImgVar = document.createElement("IMG");
         cancelBtnImgVar.src = "images/closeIcon.png";
         cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.88; background-color:#fcfcff")
         cancelButtonForSearchForTable[0][0].appendChild(cancelBtnImgVar)
         
        cancelButtonForSearchForTable.on('click', function() {
            isSearchInTableButtonClicked = false;
            document.getElementById("dropDownIDForSearchPanelForTable" + targetElement[0][0].id).selectedIndex = "0";
            document.getElementById("autoSearchTextBoxForSearchPanel_Table" + targetElement[0][0].id).value= "";
            leftPanelDivForSearchForTable.style("display","none")
            tempDivTableForPieChart.style("display","none")
            //searchTextBoxArrayForPieChart = [];
                                         
            letterCount = 0; // resetting the letterCount variable;
            textChangedFunction("") // sending null to textChangedFunction so that table should reload with full data.
            
            // second text box elements
            wantToSearchMoreLable_Table.style("display","none")
            searchTextBox2ForSearchPanel_Table.style("display","none")
            leftPanelDivForSearchForTableFoundRecordsTxtBox2.style("display","none")
            $("#" + "autoSearchTextBox1ForSearchPanel_Table" + targetElement[0][0].id).val("")
            leftPanelDivForSearchForTableFoundRecordsTxtBox2.selectAll("*").remove();
            letterCount1 = 0; // resetting the letterCount variable;
            textChangedFunction1("") // sending null to textChangedFunction so that table should reload with full data.
        });
        
        var leftPanelDivForSearchForTableTotalRecords = leftPanelDivForSearchForTable.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif").style("font-weight", "Bold")
        .style('margin-left','2px').style('margin-top','55px').style('text-indent','5px').style("font-size", "17px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#00001c").style("display","block")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:15.5%; font-size:12px; font-family:inter;  color:#00001c; font-weight:Normal;">'+ "Total records : " + options.data.length.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +'</div>')
        
        var searchTextBoxForSearchPanel_Table = leftPanelDivForSearchForTable.append('input').style("width","220px").style('margin-left','5px').style('margin-top','85px')
        .style('position',"absolute").style('height',"22px").style("border", "1.0px") .style("border-color", "#e7e7e7") .style("border-style", "solid").style('text-indent','30px')
        .attr("placeholder","eg: sales").attr("id","autoSearchTextBoxForSearchPanel_Table" + targetElement[0][0].id) .style("outline-width","1px")
        .style("background-image","url('images/searchChart.png')").style("background-repeat","no-repeat")//.style("background-position","right")
        .style("background-size",'18px 18px').style("background-position",'5px 3px').style("font-size","14px").style("font-weight","Normal").style("line-height","Normal")
        
        var leftPanelDivForSearchForTableFoundRecords = leftPanelDivForSearchForTable.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif").style("font-weight", "Bold")
        .style('margin-left','2px').style('margin-top','128px').style('text-indent','5px').style("font-size", "17px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000").style("display","block")
        
        // Text box 2 elements
        var wantToSearchMoreLable_Table = leftPanelDivForSearchForTable.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif").style("font-weight", "Bold")
        .style('margin-left','2px').style('margin-top','180px').style('text-indent','5px').style("font-size", "17px").style('position',"absolute")
        .style("border", "0px solid #606060").style("width","230px").style("color","#00001c").style("display","none")
        .html('<div  style="width: 100%; height:auto; background-color:#ffffff; position: absolute; top:15.5%; font-size:12px; font-family:inter;  color:#00001c; font-weight:Normal;">Want to search more in found records?</div>')
        
        var searchTextBox2ForSearchPanel_Table = leftPanelDivForSearchForTable.append('input').style("width","220px").style('margin-left','5px').style('margin-top','195px')
        .style('position',"absolute").style('height',"22px").style("border", "1.0px") .style("border-color", "#e7e7e7") .style("border-style", "solid").style('text-indent','30px')
        .attr("placeholder","eg: sales").attr("id","autoSearchTextBox1ForSearchPanel_Table" + targetElement[0][0].id) .style("outline-width","1px")
        .style("background-image","url('images/searchChart.png')").style("background-repeat","no-repeat")
        .style("background-size",'18px 18px').style("background-position",'5px 3px').style("font-size","14px").style("font-weight","Normal").style("line-height","Normal")
        .style("display","none")
        
        var leftPanelDivForSearchForTableFoundRecordsTxtBox2 = leftPanelDivForSearchForTable.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif").style("font-weight", "Bold")
        .style('margin-left','2px').style('margin-top','237px').style('text-indent','5px').style("font-size", "17px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000").style("display","none")
        
        // Spinner
        var spinnerDivForTable = leftPanelDivForSearchForTable.append("div") .style('left',"38%").style('top',"70%") .style("width","60px").style("height","60px").style('position','absolute') .style('border',"0px solid #f0f0f0") .style("display","none")
        //.html('<img class=img'+' src="images/spinnerIcon.png" style=" width:36px; height:36px; position:absolute; margin-left:14px; margin-top:12px; opacity:0.9;"/>' + '<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; left: 0px; top:40.0%; font-size:14px; font-family:inter;  color:#606060; font-weight:Normal; text-align:center; "></div>');
        
        var arcForSpinner = d3.svg.arc().innerRadius(20*0.6).outerRadius(20*0.9).startAngle(7.5)
        var spinnerSvgPanelForTable = spinnerDivForTable.append("svg").attr("width", 60) .attr("height", 60) .style("display","block")
        spinnerSvgPanelForTable.append("g").attr("transform", "translate(" + (30) + "," + (30) + ")").append("path").datum({endAngle: 0.45*(2*Math.PI)}) .attr("d", arcForSpinner).style("fill","#808080").call(spin, 1500)
        
        function spin(selection, duration) {
            selection.transition().ease("linear").duration(duration)
            .attrTween("transform", function() { return d3.interpolateString("rotate(0)", "rotate(360)"); });
            setTimeout(function() { spin(selection, duration); }, duration);
        }
        
        // ------------------------------------------ Search Table creating left panel section ends here --------------------------------------------------

        // ------------------------------------------ Creating Search Table (Temprorary Table) section begins here --------------------

        // Creating DIV for holding Search Table (Temporary Table) when Search button is clicked.
        var tempDivTableForPieChart;
        var isSearchInTableButtonClicked = false; // this turns into true when search button is clicked

            // DIV for holding Search Table
            tempDivTableForPieChart = targetElement.append('div').style('width','0px')
            .style('height',"0px").style('position','absolute').style('margin-left', "260px")
            .style("background-color",'#ffffff').style("z-index",90).style("border-color", "#ffffff").style("border-right", "solid #c1e2b3 0px")  .style("border-style", "solid") // 004b9d
            .style("box-shadow", "0px 0px 0px #eff8ec").style("display","none").style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
            .style('top', 8.0 + "%").style('height', (targetElementHeightOfTable - 40) + "px")//.style('overflow-y',"scroll").style("overflow-x","hidden")

            if(options.showTitle == false){
                //searchDivForPieChartForSearchTable.style('top', 0.0 + "%").style('height', 60.0 + "%")
                tempDivTableForPieChart.style("display","none").style('width', (targetElementWidthOfTable - 260) + "px")
                .style('height', 100.0 + "%").style('top', 0 + "px")//.transition().duration(200).delay(50)
            
            }
            else if(options.showTitle == true){
                //searchDivForPieChartForSearchTable.style('top', 8.0 + "%").style('height', 52.0 + "%")
                tempDivTableForPieChart.style("display","none").style('width', (targetElementWidthOfTable - 260) + "px")
                .style('height', (targetElementHeightOfTable - 40) + "px").style('top', 40.0 + "px")
            
            }

            // DIV for holding only Search Table
            var searchResultTablePanelForPieChart =  tempDivTableForPieChart.append("div")
            .attr("class", "searchResultTablePanelForPieChart" + targetElement[0][0].id)
            .style('background-color',"#ffffff") .style('position','absolute') .style("display","block") .style("overflow","auto")
            .style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 100 + "%"; }) .style("left",0 + "%")
            .style("top","0"+"%")
        
            $( '.searchResultTablePanelForPieChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
                    var e0 = e.originalEvent,
                    delta = e0.wheelDelta || -e0.detail;
                                                                      
                    this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
                    e.preventDefault();
            });
        
            // Creating Table (Search Table)
            searchResultTablePanelForPieChart.html('<table  border="0px" style=" width:99.9%; height:auto;   position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9px; border-collapse:collapse; border-color:#ebf5e6; " >'+
              '<thead  style="background-color:#f6f6f6;">' +'</thead>'+
              '<tbody class="myTBody" style="background-color:white; width:99.9%; height:auto;  ">'+'</tbody>'+
              '</table>'
              )
            searchResultTablePanelForPieChart.select("table").attr("id","searchTableIdForPieChart" + targetElement[0][0].id)

            var thead = searchResultTablePanelForPieChart.select("thead").selectAll("th") .data(d3.keys(options.data[0]))
            .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1) + " "}).style("min-width","100px")
        
            var tr = searchResultTablePanelForPieChart.select("tbody").selectAll("tr") .data(options.data).enter().append("tr") //.style("background-color",function(d,i){  return colors(i);})
        
            var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d})
            .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
        
        // Styling the Search Table Rows.
        searchResultTablePanelForPieChart.selectAll('th').style("font-size","12px").style("font-family", "Arial").style("text-align","left").style("padding-left","6px").style("color","#005281")
        .style("height","25px") .style("border", "1px solid #e9e9e9")
        searchResultTablePanelForPieChart.selectAll('td').style("height","25px") .style("border", "1px solid #f0f0f0") .style("font-size","12px") .style("font-weight","Bold")
        .style("color","#005281")
        
        //d3.select(".theadClassForSearchTable_Table" + targetElement[0][0].id).selectAll('th').style("border","1px solid #f4f4f4")
        
            // Array to hold searched items (full object)
            var searchTextBoxArrayForPieChart = []; // Globally declared
            var searchTextBoxArrayToHoldSearchByColumnValues = [];
        
        // disabledDivForSearch_Table
        var disabledDivForSearch_Table = targetElement.append("div") .style("background-color","rgba(236, 236, 237, 0.1)") .style('left',"0%").style('top',"0%") .style("width","100%").style("height","100%").style("position","absolute") .style("z-index",1000) .style("display","none")
        .html('<div  style="width: auto; height:auto; position: absolute; top:50.0%; font-size:16px; font-family:inter;color:#00001c; font-weight:Bold; text-align:center; padding-left:55%;">Searching...</div>')
        
        // ------------------------------------------ First text box calculation begins here ----------------------------------------------
        
        var isDataLessThanTrueOrFalse = false;
        
        if(options.data.length <= 150){
            isDataLessThanTrueOrFalse = true;
            $(document).ready(function(){
                $("#" + "autoSearchTextBoxForSearchPanel_Table" + targetElement[0][0].id).off('input');
                $("#" + "autoSearchTextBoxForSearchPanel_Table" + targetElement[0][0].id).on('keyup', function(e){
                          
                        wantToSearchMoreLable_Table.style("display","none")
                        searchTextBox2ForSearchPanel_Table.style("display","none")
                        leftPanelDivForSearchForTableFoundRecordsTxtBox2.style("display","none")
                        $("#" + "autoSearchTextBox1ForSearchPanel_Table" + targetElement[0][0].id).val("")
                        leftPanelDivForSearchForTableFoundRecordsTxtBox2.selectAll("*").remove();
                        letterCount1 = 0
                                                                                             
                         textChangedFunction(this.value)
                });
                $("#" + "autoSearchTextBoxForSearchPanel_Table" + targetElement[0][0].id).on('keydown', function () { });
                              
            });
        }
        
        else if(options.data.length > 150) {
            
            var letterCount = 0;
            $("#" + "autoSearchTextBoxForSearchPanel_Table" + targetElement[0][0].id).keyup(function(e){
            
                    wantToSearchMoreLable_Table.style("display","none")
                    searchTextBox2ForSearchPanel_Table.style("display","none")
                    leftPanelDivForSearchForTableFoundRecordsTxtBox2.style("display","none")
                    $("#" + "autoSearchTextBox1ForSearchPanel_Table" + targetElement[0][0].id).val("")
                    leftPanelDivForSearchForTableFoundRecordsTxtBox2.selectAll("*").remove();
                    letterCount1 = 0
                                                                                            
            if ((e.keyCode >= 9 && e.keyCode <= 31) || (e.keyCode >= 33 && e.keyCode <= 46) || (e.keyCode >= 91 && e.keyCode <= 93) || (e.keyCode >= 112 && e.keyCode <= 123)
                || (e.keyCode == 0) ) {
                    if(this.value.length == 0){ letterCount = 0; }
                    fun(this.value)
            }
            else {
                                                                                            
                disabledDivForSearch_Table.style("display","block")
                spinnerDivForTable.style("top","50%")
                spinnerDivForTable.style("display","block")
                                                                                            
               if(this.value.length == 0){ letterCount = 0; }
               if(e.keyCode == 8){
                    if(letterCount > 0){
                        letterCount--;
                    }
                }
                else {
                        letterCount++;
                }
                fun(this.value)
            }
            })
        
            $("#" + "autoSearchTextBoxForSearchPanel_Table" + targetElement[0][0].id).on("paste", function(e){
                if(!e.keyCode){ letterCount = e.originalEvent.clipboardData.getData('text').length - 1;}
                else{ letterCount = e.originalEvent.clipboardData.getData('text').length - 1; }
                fun(this.value)
            })
        
            /*$("#" + "autoSearchTextBoxForSearchPanel_Table" + targetElement[0][0].id).bind('input propertychange', function(e) {
                fun(this.value)
            });*/
        
            function fun(val){
                setTimeout(function() { textChangedFunction(val); }, 2000);
            }
        
        } // else if(options.data.length > 150) else block
        
        var BreakException = {};
        var forLoopTrueOrFalse = false;
          function textChangedFunction(val) {
              
                    var textBoxValueLowerCased = val //this.value
                    searchTextBoxArrayForPieChart = [];
                    searchTextBoxArrayToHoldSearchByColumnValues = [];
              try {
                  options.data.forEach(function loop(d, index) {
                    if(val.length < letterCount) throw BreakException;
                        for(var i = 0; i<Object.keys(d).length; i++){ // Search by every column for loop
                            if(val.length < letterCount) { break; }
                                //var lower = d3.values(d)[i].replace(/\s+/g, ' ').toString().toLowerCase()
                                var lower = JSON.stringify(d3.values(d)[i]).toLowerCase()
                                
                                if ( lower.toLowerCase().indexOf(textBoxValueLowerCased.toLowerCase()) > -1 ) {
                                       searchTextBoxArrayForPieChart.push(d)
                                       break;
                                }
                                 
                        }
                                       if(index == options.data.length - 1){
                                            forLoopTrueOrFalse = true; disabledDivForSearch_Table.style("display","none");
                                            if($("#" + "autoSearchTextBoxForSearchPanel_Table" + targetElement[0][0].id).val().length > 0){
                                                if(searchTextBoxArrayForPieChart.length >=100){ // checking if the text box 1 found result is more that 100
                                       
                                                    wantToSearchMoreLable_Table.style("display","block")
                                                    searchTextBox2ForSearchPanel_Table.transition().style("display","block")
                                                    leftPanelDivForSearchForTableFoundRecordsTxtBox2.style("display","block")
                                                }
                                            }
                                       }
                                       else { forLoopTrueOrFalse = false; disabledDivForSearch_Table.style("display","block") }
                                       
                    }); // options.data.forEach(function(d, index)
              }
              catch(e) {
                  if (e!==BreakException) throw e;
              }
              
               if(val.length >= letterCount){
                  //disabledDivForSearch_Table.style("display","none")
                  spinnerDivForTable.style("display","none");
                  leftPanelDivForSearchForTableFoundRecords.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:15.5%; font-size:12px; font-family:inter;  color:#00001c; font-weight:Normal;">'+ "Found records : " + searchTextBoxArrayForPieChart.length.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +'</div>')
                }
        
                if($("#" + "autoSearchTextBoxForSearchPanel_Table" + targetElement[0][0].id).val().length == 0){
                    searchTextBox2ForSearchPanel_Table.transition().style("display","none")
                    leftPanelDivForSearchForTableFoundRecords.selectAll("*").remove();
                }
              
                if(isDataLessThanTrueOrFalse == true){ // if data is less that 150 records
                    spinnerDivForTable.style("display","none");
                    leftPanelDivForSearchForTableFoundRecords.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:15.5%; font-size:12px; font-family:inter;  color:#00001c; font-weight:Normal;">'+ "Found records : " + searchTextBoxArrayForPieChart.length.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +'</div>')
                  
                    if($("#" + "autoSearchTextBoxForSearchPanel_Table" + targetElement[0][0].id).val().length == 0){
                      searchTextBox2ForSearchPanel_Table.transition().style("display","none")
                      leftPanelDivForSearchForTableFoundRecords.selectAll("*").remove();
                    }
                }
              
                // Removing the Search Table Rows
                var table = searchResultTablePanelForPieChart.select('table');
                var rows = table.selectAll('tr')
                rows.remove();

                // Creating new Rows for Search Table based on Searched Result (using searchTextBoxArrayForPieChart array)
                var table = searchResultTablePanelForPieChart.select('table');
                var rows = table.selectAll('tr').data(searchTextBoxArrayForPieChart);
                var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})

                cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition()
                .delay(20) .duration(20) .style('opacity', 1.0).style("color","#00001c");
            
                cells.text(function(d,i) {return d});

                // Cells exit selection
                cells.exit() .attr('class', 'exit') .transition() .delay(20) .duration(20) .style('opacity', 0.0) .remove();
            
                var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})

                cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(20)
                .duration(20) .style('opacity', 1.0).style("color","#00001c");

                var t = document.getElementById("searchTableIdForPieChart" + targetElement[0][0].id).tBodies[0]
            
                cells_in_new_rows.text(function(d,i) {return d});

                rows.exit() .attr('class', 'exit') .transition() .delay(20) .duration(20) .style('opacity', 0.0) .remove();

                // Checking the Browser
                if(navigator.userAgent.indexOf("Firefox") != -1 )
                {
                    table.selectAll('th').style("font-size","12px").style("font-family", "Arial").style("text-align","left").style("padding-left","6px").style("color","#005281")
                    .style("height","25px") .style("border", "1px solid #e9e9e9")

                    table.selectAll('td').style("height","25px") .style("border", "1px solid #f0f0f0") .style("font-size","12px") .style("font-weight","Bold").style("padding-left","6px")
                    .style("color","#005281")
                    
                    //d3.select(".theadClassForSearchTable_Table" + targetElement[0][0].id).selectAll('th').style("border","1px solid #f4f4f4")
                }

                else {
                    
                    table.selectAll('th').style("font-size","12px").style("font-family", "Arial").style("text-align","left").style("padding-left","6px").style("color","#005281")
                    .style("height","25px") .style("border", "1px solid #e9e9e9")

                    table.selectAll('td').style("height","25px") .style("border", "1px solid #f0f0f0") .style("font-size","12px") .style("font-weight","Bold").style("padding-left","6px")
                    .style("color","#005281")
                    
                    //d3.select(".theadClassForSearchTable_Table" + targetElement[0][0].id).selectAll('th').style("border","1px solid #f4f4f4")
                }
              
            }//textChangeFunction ends here
     
        // ------------------------------------------ First text box calculation ends here ----------------------------------------------
        
        var isDataLessThanTrueOrFalse1 = false;
        var letterCount1 = 0;
        $("#" + "autoSearchTextBox1ForSearchPanel_Table" + targetElement[0][0].id).keyup(function(e){
            
            if ((e.keyCode >= 9 && e.keyCode <= 31) || (e.keyCode >= 33 && e.keyCode <= 46) || (e.keyCode >= 91 && e.keyCode <= 93) || (e.keyCode >= 112 && e.keyCode <= 123)
                                                                                             || (e.keyCode == 0) ) {
                if(this.value.length == 0){ letterCount1 = 0; }
                    fun1(this.value)
            }
            else {
                disabledDivForSearch_Table.style("display","block")
                spinnerDivForTable.style("top","70%")
                spinnerDivForTable.style("display","block")
                if(this.value.length == 0){ letterCount1 = 0; }
                    if(e.keyCode == 8){
                        if(letterCount1 > 0){
                            letterCount1--;
                        }
                    }
                else {
                    letterCount1++;
                }
                fun1(this.value)
            }
        })
        
        $("#" + "autoSearchTextBox1ForSearchPanel_Table" + targetElement[0][0].id).on("paste", function(e){
            if(!e.keyCode){ letterCount1 = e.originalEvent.clipboardData.getData('text').length - 1;}
            else{ letterCount1 = e.originalEvent.clipboardData.getData('text').length - 1; }
            fun1(this.value)
        })
        
        function fun1(val){
            
            setTimeout(function() { textChangedFunction1(val); }, 2000);
        }
        
        var searchTextBoxArrayForPieChart1 = [];
        var BreakException1 = {};
        var forLoopTrueOrFalse1 = false;
        function textChangedFunction1(val) {
            
            var textBoxValueLowerCased1 = val //this.value
            searchTextBoxArrayForPieChart1 = [];
            searchTextBoxArrayToHoldSearchByColumnValues = [];
            try {
                searchTextBoxArrayForPieChart.forEach(function loop(d, index) {
                        if(val.length < letterCount1) throw BreakException1;
                                for(var i = 0; i<Object.keys(d).length; i++){ // Search by every column for loop
                                    if(val.length < letterCount1) { break; }
                                        //var lower = d3.values(d)[i].replace(/\s+/g, ' ').toString().toLowerCase()
                                    var lower1 = JSON.stringify(d3.values(d)[i]).toLowerCase()
                                        
                                    if ( lower1.toLowerCase().indexOf(textBoxValueLowerCased1.toLowerCase()) > -1 ) {
                                        searchTextBoxArrayForPieChart1.push(d)
                                        break;
                                    }
                                                      
                                }
                            if(index == searchTextBoxArrayForPieChart.length - 1){ forLoopTrueOrFalse1 = true; disabledDivForSearch_Table.style("display","none")}
                                else { forLoopTrueOrFalse1 = false; disabledDivForSearch_Table.style("display","block") }
                                                      
                }); // searchTextBoxArrayForPieChart.forEach(function(d, index)
            }
            catch(e) {
                if (e!==BreakException1) throw e;
            }
            
            if(val.length >= letterCount1){
                //disabledDivForSearch_Table.style("display","none")
                spinnerDivForTable.style("display","none");
                leftPanelDivForSearchForTableFoundRecordsTxtBox2.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:15.5%; font-size:12px; font-family:inter;  color:#00001c; font-weight:Normal;">'+ "Found records : " + searchTextBoxArrayForPieChart1.length.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +'</div>')
            }
            
            if($("#" + "autoSearchTextBox1ForSearchPanel_Table" + targetElement[0][0].id).val().length == 0){
                leftPanelDivForSearchForTableFoundRecordsTxtBox2.selectAll("*").remove();
            }
            
            if(isDataLessThanTrueOrFalse1 == true){ // if data is less that 150 records
                spinnerDivForTable.style("display","none");
                leftPanelDivForSearchForTableFoundRecordsTxtBox2.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:15.5%; font-size:12px; font-family:inter;  color:#00001c; font-weight:Normal;">'+ "Found records : " + searchTextBoxArrayForPieChart1.length.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +'</div>')
                
                if($("#" + "autoSearchTextBox1ForSearchPanel_Table" + targetElement[0][0].id).val().length == 0){
                    leftPanelDivForSearchForTableFoundRecordsTxtBox2.selectAll("*").remove();
                }
            }
            
            // Removing the Search Table Rows
            var table = searchResultTablePanelForPieChart.select('table');
            var rows = table.selectAll('tr')
            rows.remove();
            
            // Creating new Rows for Search Table based on Searched Result (using searchTextBoxArrayForPieChart array)
            var table = searchResultTablePanelForPieChart.select('table');
            var rows = table.selectAll('tr').data(searchTextBoxArrayForPieChart1);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition()
            .delay(20) .duration(20) .style('opacity', 1.0).style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(20) .duration(20) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(20)
            .duration(20) .style('opacity', 1.0).style("color","#00001c");
            
            var t = document.getElementById("searchTableIdForPieChart" + targetElement[0][0].id).tBodies[0]
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(20) .duration(20) .style('opacity', 0.0) .remove();
            
            // Checking the Browser
            if(navigator.userAgent.indexOf("Firefox") != -1 )
            {
                table.selectAll('th').style("font-size","12px").style("font-family", "Arial").style("text-align","left").style("padding-left","6px").style("color","#005281")
                .style("height","25px") .style("border", "1px solid #e9e9e9")
                
                table.selectAll('td').style("height","25px") .style("border", "1px solid #f0f0f0") .style("font-size","12px") .style("font-weight","Bold").style("padding-left","6px")
                .style("color","#005281")
                
                //d3.select(".theadClassForSearchTable_Table" + targetElement[0][0].id).selectAll('th').style("border","1px solid #f4f4f4")
            }
            
            else {
                
                table.selectAll('th').style("font-size","12px").style("font-family", "Arial").style("text-align","left").style("padding-left","6px").style("color","#005281")
                .style("height","25px") .style("border", "1px solid #e9e9e9")
                
                table.selectAll('td').style("height","25px") .style("border", "1px solid #f0f0f0") .style("font-size","12px") .style("font-weight","Bold").style("padding-left","6px")
                .style("color","#005281")
                
                //d3.select(".theadClassForSearchTable_Table" + targetElement[0][0].id).selectAll('th').style("border","1px solid #f4f4f4")
            }
            
        }//textChangeFunction ends here
        
        //-------------------------------------------------- Second Text Box -----------------------------------------------------------------
        
        // ------------------------------------------ Creating Search Table (Temprorary Table) section ends here ----------------------

        // ------------------------------------------ Remove Table column panel section begins here ---------------------------------------

        var leftPanelDivForRemoveTableColumn = targetElement.append("div") .style("width","280px").style("height",92+ "%").style('position','absolute')
        .style('background-color',"#ffffff").style('margin-left','0px').style("z-index",10).attr("class","removeTableColumnPanelClass" + targetElement[0][0].id)
        .style("display","none") .style("overflow","auto").style("overflow-x","hidden")
        .style('padding',"0px") .style("border-right", "solid #e6e6e6  1px") .style("border-top", "solid #e9e9e9  1px")

        if(options.showTitle == true){
            leftPanelDivForRemoveTableColumn.style('width', 260 + "px") .style('height', (targetElementHeightOfTable - 40) + "px") .style("top",40 + "px")
        }
        else if(options.showTitle == false){
            leftPanelDivForRemoveTableColumn.style('width', 260 + "px") .style('height', 100 + "%") .style("top",0 + "px") 
        }
        
        $( '.removeTableColumnPanelClass' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        var leftPanelDivForRemoveTableColumnTitle = leftPanelDivForRemoveTableColumn.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif").style("font-weight", "Bold")
        .style('margin-left','0px').style('margin-top','12px').style('text-indent','5px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000").style("display","block") 
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:15.5%; font-size:16px; font-family:Arial;  color:#005281; font-weight:Bold;">'+ "Remove Table Column"+'</div>')

        var leftPanelDivForRemoveTableColumnCancelBtn = leftPanelDivForRemoveTableColumn.append("div") .style("width","23px").style("height","21px").style('position','absolute')
        .style('margin-left',"231px").style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white')
        .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.88; background-color:#fcfcff")
        leftPanelDivForRemoveTableColumnCancelBtn[0][0].appendChild(cancelBtnImgVar)

        leftPanelDivForRemoveTableColumnCancelBtn.on('click', function() {
            leftPanelDivForRemoveTableColumn.style("display","none")
        });

        var dropDownForChooseColumnForRemoveTableColumn_Table;

        var dropDownLabelsForChooseColumnForRemoveColumn = ["Choose Column"];

        var arrayToHoldTableColumnNamesForRemoveTableColumn = d3.keys(options.data[0])

        //dropDownLabels.push(d3.keys(options.data[0]))
        var dropDownLengthForChooseColumnForRemoveTableColumn = [0]; // assinging 0 for Choose Column

        for(var i = 0; i < d3.keys(options.data[0]).length; i++){
            dropDownLengthForChooseColumnForRemoveTableColumn[i+1] = i+1; // pushing ith value
            dropDownLabelsForChooseColumnForRemoveColumn[i+1] = arrayToHoldTableColumnNamesForRemoveTableColumn[i]
        }
        
        dropDownForChooseColumnForRemoveTableColumn_Table = leftPanelDivForRemoveTableColumn.append("select").attr("id","dropDownIDForSearchPanelForTable" + targetElement[0][0].id)
        
        dropDownForChooseColumnForRemoveTableColumn_Table.style("left",5.0 + "px") .style("top",60 + "px") .style("position","absolute")
        .style("border", "1.0px") .style("border-color", "#D0D0D0") .style("border-style", "solid").style("display","block")
        .style("border-color", "#89c2ff") .style("min-width","142px") .style("height","22px") .style("outline-width","0px")
        .on("change", dropDownForChooseColumnForRemoveColumnFunction)
        
        var dropDownOptionsForChooseColumnForRemoveColumn = dropDownForChooseColumnForRemoveTableColumn_Table.selectAll("option")
        .data(dropDownLengthForChooseColumnForRemoveTableColumn)
        .enter()
        .append("option")
        dropDownOptionsForChooseColumnForRemoveColumn.text(function(d) {return dropDownLabelsForChooseColumnForRemoveColumn[d]})
        .attr("value",function(d) { return dropDownLabelsForChooseColumnForRemoveColumn[d]})

        var variableToHoldChooseColumnDropDownChangedValue_RemoveColumn = "Choose Column"; // Considered as Global variable.
        function dropDownForChooseColumnForRemoveColumnFunction(){
            variableToHoldChooseColumnDropDownChangedValue_RemoveColumn = d3.event.target.value
            //alert(variableToHoldChooseColumnDropDownChangedValue_Search)
        }

        var removeButtonInRemoveTableColumnPanel = leftPanelDivForRemoveTableColumn.append("button").style("width","90px").style("height","22px").style('position','absolute')
        .style('margin-left','5px').style('font-size','14px').style('margin-top','94px').style("box-shadow", "1px 1px 1px #888888")/*9b9b9b*/ .style("border-style", "none")
        .style('background-color',"#00264e").style("color","#ffffff").style("font-weight","Normal").style("font-family","Arial").style("font-style","normal")
        .style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid").style('text-align','center').style("display","block") 
        var textRemoveButtonInRemoveTableColumnPanel = document.createTextNode("Remove"); //d8ebff
        removeButtonInRemoveTableColumnPanel[0][0].appendChild(textRemoveButtonInRemoveTableColumnPanel)

        removeButtonInRemoveTableColumnPanel.on('click', function() {
            var newJsonArray = []; // array to hold json objects after removing selected column
            options.data.forEach(function(d, i) {
                var temp = {};
            
                for(var i = 0; i < Object.keys(d).length; i++) {
                    delete d[variableToHoldChooseColumnDropDownChangedValue_RemoveColumn];
                    temp[Object.keys(d)[i]] = d[Object.keys(d)[i]]
                }
            
                newJsonArray.push(temp)
            });
            
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            options.data = newJsonArray;
            acinfotech.table(targetElement,options)
        })

        //---------------------------------------- Creating Table section starts here ----------------------------
        
        var tablePanelForHoriChart = targetElement .append('div') .attr("class","scrollingDivForTable-Class tableDivClass" + targetElement[0][0].id) .style('background-color',"#fdfdfd")
        .style("position","absolute") .style("display","block") .style("overflow","hidden") //.style("border-bottom","1px solid #f0f0f0")

        // Show or Hide Table scroll bar when mouseover on widget
        targetElement.on('mouseover',function(){ tablePanelForHoriChart.style("overflow","auto") })
        targetElement.on('mouseout',function(d){ tablePanelForHoriChart.style("overflow","hidden") })

         $( '.tableDivClass' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });
        
        if(options.showTitle == true){
            
            chartTitlePanelForTable.style("width", 90 + "%") .style("height", 40 + "px") .style("margin-top", 0 + "px") .style("left",0 + "px")
            .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:20.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')
            chartTitlePanelForTable.selectAll('div').style("font-style", options.fontStyle).style("font-weight",options.fontWeight).style("font-family",options.fontFamily)
        }
        else if(options.showTitle == false){
            chartTitlePanelForTable.style("width", "0px") .style("height", "0px").style("margin-top", "0px") .style("left", "0px")
        }
        
        // Globally getting width and height of Table Title
        var tableTitleWidth = chartTitlePanelForTable[0][0].clientWidth
        var tableTitleHeight = chartTitlePanelForTable[0][0].clientHeight
        
        if(options.showTitle == true){
            tablePanelForHoriChart.style('width', targetElementWidthOfTable + "px") .style('height', (targetElementHeightOfTable - 40) + "px") .style("margin-top", 40 + "px") .style("left",0 + "px")
        }
        else if(options.showTitle == false){
            tablePanelForHoriChart.style('width', 100 + "%") .style('height', 100 + "%") .style("margin-top", 0 + "px") .style("left",0 + "%") 
        }
        
        tablePanelForHoriChart.html('<table class = "tableClassForTable' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                    '<thead class = "theadClassForTable' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForTable' + targetElement[0][0].id + '"' +'style="background-color:#ffffff;">'+'</thead>' +
                                    '<tbody class = "tBodyClassForTable' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                    '</table>'
                                    )
        
        tablePanelForHoriChart.select('table').attr("id",targetElement[0][0].id + "tableID")
        
        var disableDivForTable = targetElement.append("div") .style("background-color","rgba(236, 237, 237, 0.1)") .style('left',"0%").style('top',"0%") .style("width","100%").style("height","100%").style("position","absolute") .style("z-index",1000) .style("display","none")
        .html('<div  style="width: 100%; height:auto; position: absolute; top:50.0%; font-size:16px; font-family:inter;color:#00001c; font-weight:Bold; text-align:center; ">Just a moment...</div>')
        
        var thead = tablePanelForHoriChart.select("thead").selectAll("th") .data(d3.keys(options.data[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        //.enter().append("th").text(function(d){ return "" }).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#f4f4f4")//f6f6f6
        .style("position","relative").style("top","2px")
        
        var thead1 = d3.select(".thead1ClassForTable" + targetElement[0][0].id).selectAll("th") .data(d3.keys(options.data[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff")//f6f6f6
        .style("position","relative").style("top","2px")
        
        var ascendingIcon = svgSelection1.append("image")
        .attr("xlink:href", "images/ascending.png")
        .attr({ width: 10,height: 7 })
        .attr("id", "ascendingIconIDForHorizontalChart")
        .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
        
        var descendingIcon = svgSelection1.append("image")
        .attr("xlink:href", "images/descending.png")
        .attr({ width: 10,height: 7 })
        .attr("id", "descendingIconIDForHorizontalChart")
        .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
        
        var tr = tablePanelForHoriChart.select("tbody").selectAll("tr")
        .data(options.data).enter().append("tr")
        .attr("id", function(d,i) { return "slice" + i })
        
        // cells
        var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d }) 
		.style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
        
        var $table = $('.tableClassForTable' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
        
        d3.select(".theadClassForTable" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                d.forEach(function(dd,j){
                        colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                })
        })
        
        $(".thead1ClassForTable" + targetElement[0][0].id).insertAfter('.tBodyClassForTable' + targetElement[0][0].id)
        
        $(".thead1ClassForTable" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivClass' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
        
        tablePanelForHoriChart.select(".thead1ClassForTable" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
            d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
        })
        
        /*$('.tableDivClass' + targetElement[0][0].id).scroll(function () {
                                                                   
                $(".thead1ClassForTable" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivClass' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
        })*/
        
        $('.tableDivClass' + targetElement[0][0].id).scroll(function() {
            clearTimeout($.data(this, 'scrollTimer'));
            $.data(this, 'scrollTimer', setTimeout(function() {
                move($('.tableDivClass' + targetElement[0][0].id).scrollTop() + 'px')
            }, 1200));
        });
        
        function move(d){
            $(".thead1ClassForTable" + targetElement[0][0].id) .animate({top:d},250,"linear")
        }
        
        /*$('.tableDivClass' + targetElement[0][0].id).scroll(function () {
                //$(".thead1ClassForTable" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivClass' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
                //$(".thead1ClassForTable" + targetElement[0][0].id).css({ position:'absolute', top: $('.tableDivClass' + targetElement[0][0].id).scrollTop() + 'px'});
                //d3.select(".thead1ClassForTable" + targetElement[0][0].id).transition()//.style("top",$('.tableDivClass' + targetElement[0][0].id).scrollTop() + 'px')
                //$(".thead1ClassForTable" + targetElement[0][0].id).css({top:$(this).scrollTop()})
                
        })*/
        
        var sortOrder = false;
        thead1.on("click",function(k,index){
                  
            if(options.data.length >= 750){ disableDivForTable.style("display","block") }
            
               
            setTimeout(function(){trSortingFunction()},100)
                  
            function trSortingFunction(){
                  sortOrder = !sortOrder;
                 
                 tablePanelForHoriChart.select(".thead1ClassForTable" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                                                              
                    if (sortOrder) {
                                      
                        if(i == index){
                            d3.select(this).select('svg').select('#descendingIconIDForHorizontalChart').style("visibility", "hidden")
                            d3.select(this).select('svg').select('#ascendingIconIDForHorizontalChart').style("visibility", "visible")
                        }
                        else {
                            d3.select(this).select('svg').select('#descendingIconIDForHorizontalChart').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForHorizontalChart').style("visibility", "visible")
                        }
                    }
                    else{
                                      
                        if(i == index){
                            d3.select(this).select('svg').select('#descendingIconIDForHorizontalChart').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForHorizontalChart').style("visibility", "hidden")
                        }
                        else {
                            d3.select(this).select('svg').select('#descendingIconIDForHorizontalChart').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForHorizontalChart').style("visibility", "visible")
                        }
                    }
                })
                 
                  var monthTruOrFalAryForTable = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
                  
                  tr.sort(function(a, b) {
                          
                          if (sortOrder) {
                          var monthsArrayForTable = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                          } else {
                          var monthsArrayForTable = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                          }
                          
                          monthTruOrFalAryForTable = []; gotMonthArray = [];
                          options.data.forEach(function(d,i){
                              var da = d[k].toString().substring(0,3).toLowerCase()
                              if(monthsArrayForTable.indexOf(da) >= 0){
                              monthTruOrFalAryForTable.push(true)
                              gotMonthArray.push(da);
                              }
                              else {
                              monthTruOrFalAryForTable.push(false)
                              }
                          })
                          
                          if(monthTruOrFalAryForTable.indexOf(false) == -1){ // true
                          
                          monthArray = []; monthArrayCount = [];
                          gotMonthArray.forEach(function(dd,j){
                                var index1 = monthsArrayForTable.indexOf(dd.substring(0,3))
                                if(monthArrayCount.indexOf(index1) >= 0){
                                index1 = 12 + index1;
                                }
                                monthArray.push(index1);
                                monthArrayCount.push(index1)
                          })
                          returnArray = []
                          monthArray.sort(function(aa, bb) {
                              returnArray.push(+aa - +bb)
                              return +aa - +bb;
                          })
                          
                          sortTableFunc()
                          return returnArray[ind++];
                          } //  if true (if jan feb if block)
                          else {
                          var data = +a[k];
                          
                          if(!isNaN(data)){
                          
                          if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                          else { return d3.descending(+a[k], +b[k]); }
                          }
                          else if(!isNaN(Date.parse(a[k]))){
                          
                          if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                          else { return new Date(b[k]) - new Date(a[k]) }
                          }
                          else {
                          
                          if (sortOrder) { return d3.ascending(a[k], b[k]); }
                          else { return d3.descending(a[k], b[k]); }
                          }
                          } // if not jan feb else block
                    }); // tr
                  
                  disableDivForTable.style("display","none")
                  
                }
                 
        })
        
        function sortTableFunc(){
            
            var table = tablePanelForHoriChart.select('table');
            var rows = table.selectAll('tr').data(options.data);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0).style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500) .style('opacity', 1.0).style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
        }
        
        
        tablePanelForHoriChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("text-align","left").style("padding-left","6px").style("color","#005281")
        .style("height","25px") .style("border", "1px solid #f5f5f5")  //e9e9e9
        tablePanelForHoriChart.selectAll('td').style("height","25px") .style("border", "1px solid #fafafa") .style("font-size","12px") .style("font-weight","Bold")
        .style("color","#005281").style("font-family","Verdana,sans-serif")  .style("border","none") .style("border-bottom", "1px solid #fafafa")     

        tablePanelForHoriChart.selectAll('th').style("font-style", options.fontStyle).style("font-weight",options.fontWeight).style("font-family",options.fontFamily)
        tablePanelForHoriChart.selectAll('td').style("font-style", options.fontStyle).style("font-weight",options.fontWeight).style("font-family",options.fontFamily).style("color","#00001c")

        tablePanelForHoriChart.selectAll('table') . style("border-collapse","collapse")
        tablePanelForHoriChart.selectAll('table tr:first-child th').style("border-top","0px")
        tablePanelForHoriChart.selectAll('table tr:last-child td').style("border-bottom","0px")
        tablePanelForHoriChart.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
        tablePanelForHoriChart.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")
        
        
        var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
        
        // Adding underlines for selected drill-down column text
        var drillDownSectionsForGrid = tablePanelForHoriChart.select('table').selectAll('th')
        
        var foundResult = [];
        for(var i = 0; i<drillDownSectionsForGrid[0].length; i++){
            
            for(var j = 0; j<drillDownColumnNamesArray.length; j++){
                if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForGrid[0][i].__data__.toString().toLowerCase() ){
                    foundResult.push(i)
                }
            }
        }
        
        var r = tablePanelForHoriChart.select('table').selectAll('tr').selectAll('td')
        for(var i = 0; i<r.length; i++){
            for(var j = 0; j < foundResult.length; j++){
                var row = r[i][foundResult[j]]
                $(row).css("text-decoration", "underline")
            }
        }
        
        //By default calling the resized function first time (to align table's th and td).
        resizedFuctionForTable()
        
        window.addEventListener('resize', function(event){ resizedFuctionForTable() });
        
        var newWidthOfTargetElement_Table = 0;
        var newHeightOfTargetElement_Table = 0;
        $(function() {
          
          $("#" + targetElement[0][0].id).resizable({
                minWidth: 350,
                minHeight: 350,
                resize: function(event, ui) {
                    //newWidthOfTargetElement_Table = ui.size.width;
                    //newHeightOfTargetElement_Table = ui.size.height;
                    targetElementWidthOfTable = ui.size.width;
                    targetElementHeightOfTable = ui.size.height;
                    resizedFuctionForTable();
                }
            });
          });
        
        function resizedFuctionForTable()
        {
            
            targetElementWidthOfTable = targetElement[0][0].clientWidth
            targetElementHeightOfTable = targetElement[0][0].clientHeight
            
            logoDivForTable.style('right', '0')
            
            //targetElementWidthOfTable = targetElement[0][0].id
            //targetElementHeightOfTable = targetElement[0][0].id

            targetElement.style("min-width","350px") .style("min-height","350px")

            if(tableTitleHeight < 40){
                tableTitleHeight = 40;
            }
            
            if(options.showTitle == false){
                    menuDivForTable.transition().duration(200).delay(200).style('top', 0 + "px").style('height', 100.0 + "%").style("width","32px")
            }
            else if(options.showTitle == true){
                    menuDivForTable.style('top', 40.0 + "px").style('height', (targetElementHeightOfTable - 40) + "px").style("width","32px")
            }
                

            if(options.showTitle == true){
            
                chartTitlePanelForTable.style("width", "90%") .style("height", 40 + "px") .style("margin-top", 0 + "px") .style("left",0 + "px")
                chartTitlePanelForTable.selectAll('div').style("font-style", options.fontStyle).style("font-weight",options.fontWeight).style("font-family",options.fontFamily)
            }
            else if(options.showTitle == false){
                chartTitlePanelForTable.style("width", "0px") .style("height", "0px") .style("margin-top", "0px") .style("left", "0px")
            }

            if(options.showTitle == true){
                tablePanelForHoriChart.style('width', targetElementWidthOfTable + "px") .style('height', (targetElementHeightOfTable - 40) + "px") .style("margin-top", 40 + "px") .style("left",0 + "px")
            }
            else if(options.showTitle == false){
                tablePanelForHoriChart.style('width', targetElementWidthOfTable + "px") .style('height', targetElementHeightOfTable + "px") .style("margin-top", 0 + "px") .style("left",0 + "px") 
            }
            
            if(isSearchInTableButtonClicked == true){
                if(options.showTitle == false){
                    leftPanelDivForSearchForTable.style('top', 0 + "px").style('width', 260 + "px").style('height', 100.0 + "%")
                    tempDivTableForPieChart.style("display","block").style('width', (targetElementWidthOfTable - 260) + "px")
                    .style('height', 100.0 + "%").style("margin-top", 40 + "px").style("margin-left","260px")
                }
                else if(options.showTitle == true){
                    leftPanelDivForSearchForTable.style('top', 40 + "px").style('width', 260 + "px")
                    .style('height', (targetElementHeightOfTable - 40) + "px")
                    tempDivTableForPieChart.style("display","block").style('width', (targetElementWidthOfTable - 260) + "px")
                    .style('height', (targetElementHeightOfTable - 40) + "px").style('top', 40 + "px")
                }
            } //if(isSearchInTableButtonClicked == true)
            
            
            if(options.showTitle == true){
                tablePanelForHoriChart.style('width', targetElementWidthOfTable + "px") .style('height', (targetElementHeightOfTable - 40) + "px") .style("margin-top", 40 + "px") .style("left",0 + "px")
            }
            else if(options.showTitle == false){
                tablePanelForHoriChart.style('width', 100 + "%") .style('height', 100 + "%") .style("margin-top", 0 + "px") .style("left",0 + "%")
            }
            
            /*if(options.showTitle == false){
                leftPanelDivForTable.style('top', 0.0 + "px").style('height', 100.0 + "%")
            }
            else if(options.showTitle == true){
                leftPanelDivForTable.style('top', 40.0 + "px").style('height', (targetElementHeightOfTable - 40) + "px")
            }

            if(isFilterInTableButtonClicked == true){
                if(options.showTitle == true){
            
                    //tablePanelForHoriChart.style('width', 100 + "%") .style('height', 92 + "%") .style("top",8 + "%")
                    tablePanelForHoriChart.style('width', (targetElementWidthOfTable - 280) + "px") 
                    .style('height', (targetElementHeightOfTable - 40) + "px") .style("margin-top", 40 + "px") .style('margin-left', 280 + "px")
                }

                else if(options.showTitle == false){
                    //tablePanelForHoriChart.style('width', 100 + "%") .style('height', 100 + "%") .style("left",0 + "%") 
                    tablePanelForHoriChart.style('width', (targetElementWidthOfTable - 280) + "px")
                    .style('height', targetElementHeightOfTable + "px") .style("margin-top", 0 + "px") .style('margin-left', 280 + "px")
                }
            } //if(isFilterInTableButtonClicked == true)

            else if(isFilterInTableButtonClicked == false){
                if(options.showTitle == true){
            
                    //tablePanelForHoriChart.style('width', 100 + "%") .style('height', 92 + "%") .style("top",8 + "%")
                    tablePanelForHoriChart.style('width', targetElementWidthOfTable + "px") .style('height', (targetElementHeightOfTable - 40) + "px") .style("margin-top", 40 + "px") .style("left",0 + "px")
                }

                else if(options.showTitle == false){
                    //tablePanelForHoriChart.style('width', 100 + "%") .style('height', 100 + "%") .style("left",0 + "%") 
                    tablePanelForHoriChart.style('width', targetElementWidthOfTable + "px").style('height', targetElementHeightOfTable + "px") .style("margin-top", 40 + "px") .style("left",0 + "px")
                }
            } //else if(isFilterInTableButtonClicked == false) */

            if(options.showTitle == true){
                leftPanelDivForRemoveTableColumn.style('width', 260 + "px") .style('height', (targetElementHeightOfTable - 40) + "px") .style("top",40 + "px")
            }
            else if(options.showTitle == false){
                leftPanelDivForRemoveTableColumn.style('width', 260 + "px") .style('height', 100 + "%") .style("top",0 + "px") 
            }
            
            colWidth = []; 
			
            d3.select(".theadClassForTable" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                d.forEach(function(dd,j){
                    colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                })
            })
            tablePanelForHoriChart.select(".thead1ClassForTable" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
            })
            
        } // function resizedFunction() ends here.

    }, 
    //table
 
    // ************************************************** Line Chart 2 **************************************************
    lineChart2: function(targetElement, options){
    
    
        var labelLength = options.keys.label.length;
        var mainArray = [];
        var arrayToHoldLineNamesForLineChart = [];
        
        options.data.forEach(function(d, index) {
             var temp = {};
             var tempArray = [];
             
             for(var i = 0; i<labelLength; i++){
             tempArray.push(d[options.keys.label[i]])
             }
             
             temp["line"] = d[options.keys.lines];
             temp["data"] = tempArray;
             
             mainArray.push(temp)
         })
        
        isChartCalled++;
        
        var chartName = "LINECHART2";
        
        acinfotech.allCharts(targetElement,options,chartName);
        
        targetElement.style("min-width","350px").style("min-height","350px").style("background-color", options.BGcolor)
        
        var showOrHideTableForLineChart;
        var showOrHideCommentsForLineChart;
        var showOrHideCommentsBtnForLineChart = true;
        
        if((options.showTable == false) || (options.showTable == true)){
            showOrHideTableForLineChart = options.showTable
        }
        else{
            showOrHideTableForLineChart = false;
        }
        
        // Show or Hide comments
        if (options.showComments == true || false) {
            showOrHideCommentsForLineChart = options.showComments;
        }
        else {
            showOrHideCommentsForLineChart = false;
        }
        
        if (options.comments.length == 0){
            showOrHideCommentsForLineChart = false;
            showOrHideCommentsBtnForLineChart = false;
        }
        
        if ((showOrHideTableForLineChart == true) && (showOrHideCommentsForLineChart == true)){
            showOrHideTableForLineChart = true;
            showOrHideCommentsForLineChart = false;
        }
        else if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == false)){
            showOrHideTableForLineChart = false;
            showOrHideCommentsForLineChart = false;
        }
        
        var divWidth, divHeight;
        
        var chartTitlePanelForLineChart = targetElement.append("div") .style("position","absolute").style("background-color", options.BGcolor) .style("text-indent","6px") .style("border", "none")
        
        var optsBtnPanelForLineChart = targetElement.append('div').style('width',"25px").style('height',"185px").style('position','absolute')
        .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px")
        .style('right', '0') .style("min-width","25px") .style("border-style","none")
        .style("border-left", "solid #fcfcfc  1px")
        
        var areaButtonForLineChart = optsBtnPanelForLineChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','80px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var areaBtnImgVar = document.createElement("IMG");
        areaBtnImgVar.src = "images/curveAreaIcon.png";
        areaBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:14px; opacity:0.74;")
        areaButtonForLineChart[0][0].appendChild(areaBtnImgVar)
        
        var filterButtonForLineChart = optsBtnPanelForLineChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','105px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var filterBtnImgVar = document.createElement("IMG");
        filterBtnImgVar.src = "images/filterIcon.png";
        filterBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        filterButtonForLineChart[0][0].appendChild(filterBtnImgVar)
        
        var refreshButtonForLineChart = optsBtnPanelForLineChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','130px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var refreshBtnImgVar = document.createElement("IMG");
        refreshBtnImgVar.src = "images/refreshIcon.png";
        refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        refreshButtonForLineChart[0][0].appendChild(refreshBtnImgVar)
        
        var commentsBtnForLineChart = optsBtnPanelForLineChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','155px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var commentsBtnImgVariable = document.createElement("IMG");
        if(options.showComments == false){
            commentsBtnImgVariable.src = "images/showCommentsIcon.png";
        }
        else if(options.showComments == true){
            commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
        }
        commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        commentsBtnForLineChart[0][0].appendChild(commentsBtnImgVariable)
        
        var menuButtonForLineChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','1px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var menuBtnImgVar = document.createElement("IMG");
        menuBtnImgVar.src = "images/menuIcon.png";
        menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
        menuButtonForLineChart[0][0].appendChild(menuBtnImgVar)
        
        if(showOrHideCommentsBtnForLineChart == true){
            areaButtonForLineChart.style('margin-left', "2px")
            filterButtonForLineChart.style('margin-left', "2px")
            refreshButtonForLineChart.style('margin-left', "2px")
            commentsBtnForLineChart.style('margin-left', "2px")
            menuButtonForLineChart.style('right', '0')
        }
        else if(showOrHideCommentsBtnForLineChart == false){
            areaButtonForLineChart.style('margin-left', "2px")
            filterButtonForLineChart.style('margin-left', "2px")
            refreshButtonForLineChart.style('margin-left', "2px")
            //commentsBtnForLineChart.style('right', '0')
            commentsBtnForLineChart.style('display','none')
            menuButtonForLineChart.style('right', '0')
        }
        
        var ismenuBtnOfLineChartClicked = false;
        menuButtonForLineChart.on('click', function() {
                                  
              filterPanelForLineChart.style("display","none");
              stgPanDivForLineChart.style("display","none")
              
              if(ismenuBtnOfLineChartClicked == false){
                  ismenuBtnOfLineChartClicked = true;
                  optsBtnPanelForLineChart.style("display","block")
                  
                  if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == true)){
                  divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                  .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                  
                  svgPanelForLineChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                  .style("position","absolute").style("background-color", options.BGcolor);
                  }
                  else if ((showOrHideTableForLineChart == true) && (showOrHideCommentsForLineChart == false)){
                  divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                  .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                  
                  svgPanelForLineChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                  .style("position","absolute").style("background-color", options.BGcolor);
                  }
                  else if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == false)){
                  divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                  .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                  
                  svgPanelForLineChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                  .style("position","absolute").style("background-color", options.BGcolor);
                  }
              
              }
              else if(ismenuBtnOfLineChartClicked == true){
                  ismenuBtnOfLineChartClicked = false
                  optsBtnPanelForLineChart.style("display","none")
                  
                  if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == true)){
                  divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                  .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                  
                  svgPanelForLineChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                  .style("position","absolute").style("background-color", options.BGcolor);
                  }
                  else if ((showOrHideTableForLineChart == true) && (showOrHideCommentsForLineChart == false)){
                  divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                  .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                  
                  svgPanelForLineChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                  .style("position","absolute").style("background-color", options.BGcolor);
                  }
                  else if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == false)){
                  divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                  .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                  
                  svgPanelForLineChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                  .style("position","absolute").style("background-color", options.BGcolor);
                  }
              }
              
              resizedFunctionForLineChart();
        })
        
        var tableButtonForLineChart = optsBtnPanelForLineChart.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top','1px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
        var tableBtnImgVar = document.createElement("IMG");
        if(showOrHideTableForLineChart == false){
            tableBtnImgVar.src = "images/showTableIcon.png";
            tableButtonForLineChart.attr("class","showTableClassForChartTable")
        }
        else if(showOrHideTableForLineChart == true){
            tableBtnImgVar.src = "images/cancelTableIcon.png";
            tableButtonForLineChart.attr("class","hideTableClassForChartTable")
        }
        tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
        tableButtonForLineChart[0][0].appendChild(tableBtnImgVar)
        
        var settingBtnForLineChart = optsBtnPanelForLineChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 28 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        var settingBtnImgVar = document.createElement("IMG");
        settingBtnImgVar.src = "images/settingsIcon.png";
        settingBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.82;")
        settingBtnForLineChart[0][0].appendChild(settingBtnImgVar)
        
        var downloadBtnForLineChart2 = optsBtnPanelForLineChart.append("div").attr("id","downloadBtnForLineChart2-ID-" + targetElement[0][0].id).style("width","20px").style("height","20px")
        .style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff").style('margin-left','2px').style('top', 54 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        
        acinfotech.downloadFunctionality("downloadBtnForLineChart2-ID-" + targetElement[0][0].id,targetElement)
            
        var svgPanelForLineChart = targetElement .append('svg') 
        .attr("id","svgPanelIDForLineChart" + targetElement[0][0].id) .style("background-color", options.BGcolor) .style("position","absolute")
        
        var commentsPanelDivForLineChart = targetElement.append("div") .attr("class","commentsPanelClassForLineChart2")
        .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
        .style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
        .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)
        
        commentsPanelDivForLineChart.on('click',function(d){
            $('.commentsClassForLineChart' + targetElement[0][0].id).focus()
        })
        
        if(options.showTitle == true){
            
            chartTitlePanelForLineChart.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 8 + "%"; })
            .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')
            
            if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == true)){
                
                var commentsForLineChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                .css('line-height','1.1em').css('text-align','justify') .attr('class','commentsClassForLineChart' + targetElement[0][0].id)
                
                svgPanelForLineChart.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .style("background-color", options.BGcolor).append('g')
                commentsPanelDivForLineChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                .style("top",78 + "%")
                .html(commentsForLineChart[0].outerHTML.toString())
                
            }
            else if ((showOrHideTableForLineChart == true) && (showOrHideCommentsForLineChart == false)){
                
                svgPanelForLineChart.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%").style("background-color", options.BGcolor) .append('g')
                commentsPanelDivForLineChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == false)){
                svgPanelForLineChart.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .style("background-color", options.BGcolor).append('g')
                commentsPanelDivForLineChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            
            var margin = {top: 30 , right: 10, bottom: 80, left: 50}, //originally top: 42, left: 80
            width = (svgPanelForLineChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = (svgPanelForLineChart.node().getBoundingClientRect().height) - margin.top - margin.bottom;
            
        }
        else if(options.showTitle == false){
            chartTitlePanelForLineChart.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });
            
            if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == true)){
                
                var commentsForLineChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                .css('line-height','1.1em').css('text-align','justify')
                
                svgPanelForLineChart.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .style("background-color", options.BGcolor).append('g')
                commentsPanelDivForLineChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                .style("top",78 + "%")
                .html(commentsForLineChart[0].outerHTML.toString())
                
            }
            else if ((showOrHideTableForLineChart == true) && (showOrHideCommentsForLineChart == false)){
                
                svgPanelForLineChart.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%").style("background-color", options.BGcolor) .append('g')
                commentsPanelDivForLineChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == false)){
                svgPanelForLineChart.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%").style("background-color", options.BGcolor) .append('g')
                commentsPanelDivForLineChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            
            var margin = {top: 30 , right: 10, bottom: 80, left: 50}, //originally top: 42, left: 80
            width = (svgPanelForLineChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = (svgPanelForLineChart.node().getBoundingClientRect().height) - margin.top - margin.bottom;
        }
        
        var colorscale;
        // checking color set for pie slices and legend dots
        if(options.colorSet === undefined){
            options.colorSet = "one"
            colorscale = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "one"){
            options.colorSet = "one"
            colorscale = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            options.colorSet = "two"
            colorscale = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            options.colorSet = "three"
            colorscale = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        }
        else
        {
            options.colorSet = "one"
            colorscale = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        
        if ((options.lineStyle.toString().toLowerCase() === "cardinal") || (options.lineStyle.toString().toLowerCase() === "linear") || (options.lineStyle.toString().toLowerCase() === "step")){
            options.lineStyle = options.lineStyle;
        }
        else{
            options.lineStyle = "cardinal";
        }
        
        //------------------ Settings panel DIV and everything within it section begins here --------------------
        
        var stgPanDivForLineChart = targetElement.append('div').style('width',"100%").style('height',"40%").attr("class","stgPanDivForLineChart" + targetElement[0][0].id)
        .style('position','absolute').style('margin-left', "0px").style('border-top',"1px solid #f0f0f0").style('border-bottom',"1px solid #e5e5e5")
        .style("background-color",'#fcfcfc').style("z-index",90) .style("display","none") .style('top',"60%").style('height',"40%")
        
        $( '.stgPanDivForLineChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
               var e0 = e.originalEvent,
               delta = e0.wheelDelta || -e0.detail;
               
               this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
               e.preventDefault();
       });
        
        var settingPanelTitle = stgPanDivForLineChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','10px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; color:#00001c;">'+ "Settings" +'</div>')
        
        var stgPanDivForLineChangeColorTitle = stgPanDivForLineChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Select color set " +'</div>')
        
        var stgPanCanBtnForLineChart = stgPanDivForLineChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
        .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white')
        .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.9; background-color:#fcfcff")
        stgPanCanBtnForLineChart[0][0].appendChild(cancelBtnImgVar)
        
        stgPanCanBtnForLineChart.on('click', function() {
            stgPanDivForLineChart.style("display","none") // Hiding setting panel
            
            if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == true)){
            divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
            
            svgPanelForLineChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
            .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForLineChart == true) && (showOrHideCommentsForLineChart == false)){
            divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
            
            svgPanelForLineChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == false)){
            divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
            
            svgPanelForLineChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute").style("background-color", options.BGcolor);
            }
            
            resizedFunctionForLineChart();
        })
        
        var formForChangeSettingsPanel = stgPanDivForLineChart.append("form");
        formForChangeSettingsPanel.style("background-color","#fcfcfc").style("margin-top","67px").style("font-family","Verdana,sans-serif").style("font-size","12px")
        .style("position","absolute").attr("id","formForChangeColorSettingsPanel" + targetElement[0][0].id).style("font-weight","Bold").style("width","180px")
        .style("height","58px").style("padding","0px").style("border-radius","0px") .style("margin-left","10px")
        
        var svgPanelForCrSetOne = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px").style("margin-top","1px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetOne = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        var colorSetOneRange = d3.range(12);
        
        var colorSetOneDots = svgPanelForCrSetOne.append("g")
        colorSetOneDots.selectAll('rect') .data(colorSetOneRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("fill", function(d,i){return colorSetOne(i)})
        .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetOne(i);  })
        .style("cursor","auto") .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
        
        var svgPanelForCrSetTwo = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px") .style("margin-top","20px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetTwo = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        var colorSetTwoRange = d3.range(12);
        
        var colorSetTwoDots = svgPanelForCrSetTwo.append("g")
        colorSetTwoDots.selectAll('rect') .data(colorSetTwoRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto")
        .style("fill", function(d,i){return colorSetTwo(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
        .style("stroke",function(d,i){  return colorSetTwo(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
        
        var svgPanelForCrSetThree = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px") .style("margin-top","39px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetThree = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        var colorSetThreeRange = d3.range(12);
        
        var colorSetThreeDots = svgPanelForCrSetThree.append("g")
        colorSetThreeDots.selectAll('rect') .data(colorSetThreeRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto") .style("fill", function(d,i){return colorSetThree(i)})
        .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetThree(i);  })
        .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
        
        if(options.colorSet.toString().toLowerCase() === "one"){
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"1px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"1px solid #808080")
        }
        else
        {
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        
            svgPanelForCrSetOne.on('click',function(d){
                   options.colorSet = "one"
                   svgPanelForCrSetOne.style('border',"1px solid #808080")
                   svgPanelForCrSetTwo.style('border',"0px solid #808080")
                   svgPanelForCrSetThree.style('border',"0px solid #808080")
                   
                   colorscale = "";
                   colorscale = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
                   
                   lines.style("stroke", function (d,i) { return colorscale(i); })
                   colorCount = 0;
                   circle1.style("fill", function (d,i) {
                         if(i == 0){
                             colorCount++;
                         }
                         return colorscale(colorCount - 1);
                   })
                   
                   legend.selectAll('rect').style("fill", function(d, i){ return colorscale(i);})
                   
            })
            svgPanelForCrSetTwo.on('click',function(d){
                   options.colorSet = "two"
                   svgPanelForCrSetOne.style('border',"0px solid #808080")
                   svgPanelForCrSetTwo.style('border',"1px solid #808080")
                   svgPanelForCrSetThree.style('border',"0px solid #808080")
                   
                   colorscale = "";
                   colorscale = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
                   
                   lines.style("stroke", function (d,i) { return colorscale(i); })
                   colorCount = 0;
                   circle1.style("fill", function (d,i) {
                         if(i == 0){
                         colorCount++;
                         }
                         return colorscale(colorCount - 1);
                    })
                   legend.selectAll('rect').style("fill", function(d, i){ return colorscale(i);})
            })
            svgPanelForCrSetThree.on('click',function(d){
                     options.colorSet = "three"
                     svgPanelForCrSetOne.style('border',"0px solid #808080")
                     svgPanelForCrSetTwo.style('border',"0px solid #808080")
                     svgPanelForCrSetThree.style('border',"1px solid #808080")
                     
                     colorscale = "";
                     colorscale = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
                     
                     lines.style("stroke", function (d,i) { return colorscale(i); })
                     colorCount = 0;
                     circle1.style("fill", function (d,i) {
                           if(i == 0){
                           colorCount++;
                           }
                           return colorscale(colorCount - 1);
                     })
                     legend.selectAll('rect').style("fill", function(d, i){ return colorscale(i);})
            })
        
        var lineChangeStyleTitle = stgPanDivForLineChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','190px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Line Style " +'</div>')
        
        var lineStyleDivForLineChart = stgPanDivForLineChart.append("div") .style("background-color","#fcfcfc") .style("margin-left","200px")
        .style("margin-top","67px") .style("font-family","Verdana,sans-serif") .style("font-size","12px") .style("position","absolute")
        .style("font-weight","Bold").style("width","110px") .style("height","30px") .style("padding","0px") .style("border-radius","0px")
        
        var cardinalButton = lineStyleDivForLineChart.append("div") .style("width","32px").style("height","26px").style('position','absolute')
        .style('background-color',"#ffffff").style('margin-left',"0px") .style('top','1px') .style("cursor","pointer") .style("display","block")
        .style("border-style", "none").style('padding',"0px") .style("border", "1px solid #a0a0a0").style("line-height","0px") .style("box-sizing","border-box")
        var cardinalBtnImgVar = document.createElement("IMG");
        cardinalBtnImgVar.src = "images/curveLineIcon.png";
        cardinalBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:24px; height:22px;")
        cardinalButton[0][0].appendChild(cardinalBtnImgVar)
        
        var linearButton = lineStyleDivForLineChart.append("div") .style("width","32px").style("height","26px").style('position','absolute')
        .style('background-color',"#ffffff").style('margin-left',"35px") .style('top','1px') .style("cursor","pointer") .style("display","block")
        .style("border-style", "none") .style('padding',"0px") .style("line-height","0px") .style("box-sizing","border-box")
        var linearBtnImgVar = document.createElement("IMG");
        linearBtnImgVar.src = "images/linearLineIcon.png";
        linearBtnImgVar.setAttribute("style","position:absolute; left:4px; top:1px; width:22px; height:22px;")
        linearButton[0][0].appendChild(linearBtnImgVar)
        
        var stepButton = lineStyleDivForLineChart.append("div") .style("width","32px") .style("height","26px") .style('position','absolute')
        .style('background-color',"#ffffff") .style('margin-left',"70px") .style('top','1px') .style("cursor","pointer") .style("display","block")
        .style("border-style", "none").style('padding',"0px").style("line-height","0px").style("box-sizing","border-box")
        var stepBtnImgVar = document.createElement("IMG");
        stepBtnImgVar.src = "images/stepLineIcon.png";
        stepBtnImgVar.setAttribute("style","position:absolute; left:3px; top:0px; width:24px; height:24px;")
        stepButton[0][0].appendChild(stepBtnImgVar)
        
        if(options.lineStyle.toString().toLowerCase() === "cardinal"){
            cardinalButton.style('border',"1px solid #808080")
            linearButton.style('border',"0px solid #808080")
            stepButton.style('border',"0px solid #808080")
        }
        else if(options.lineStyle.toString().toLowerCase() === "linear"){
            cardinalButton.style('border',"0px solid #808080")
            linearButton.style('border',"1px solid #808080")
            stepButton.style('border',"0px solid #808080")
        }
        else if(options.lineStyle.toString().toLowerCase() === "step"){
            cardinalButton.style('border',"0px solid #808080")
            linearButton.style('border',"0px solid #808080")
            stepButton.style('border',"1px solid #808080")
        }
        else
        {
            cardinalButton.style('border',"1px solid #808080")
            linearButton.style('border',"0px solid #808080")
            stepButton.style('border',"0px solid #808080")
        }
        
        cardinalButton.on('click',function(d){
              options.lineStyle = "cardinal"
              cardinalButton.style('border',"1px solid #a0a0a0")
              linearButton.style('border',"0px solid #808080")
              stepButton.style('border',"0px solid #808080")
              
              line.interpolate(options.lineStyle) .x(function (d) { return x1(d['label']); }) .y(function (d) { return y(+d["value"]); });
              
              lines.attr("d", function (d,i) { return line(d.Data)})
              
              resizedFunctionForLineChart();
                  
        })
        linearButton.on('click',function(d){
                options.lineStyle = "linear"
                cardinalButton.style('border',"0px solid #a0a0a0")
                linearButton.style('border',"1px solid #a0a0a0")
                stepButton.style('border',"0px solid #a0a0a0")
                
                line.interpolate(options.lineStyle) .x(function (d) { return x1(d['label']); }) .y(function (d) { return y(+d["value"]); });
                
                lines.attr("d", function (d,i) { return line(d.Data)})
                
                resizedFunctionForLineChart();
                
        })
        stepButton.on('click',function(d){
              options.lineStyle = "step"
              cardinalButton.style('border',"0px solid #a0a0a0")
              linearButton.style('border',"0px solid #a0a0a0")
              stepButton.style('border',"1px solid #a0a0a0")
              
              line.interpolate(options.lineStyle) .x(function (d) { return x1(d['label']); }) .y(function (d) { return y(+d["value"]); });
              
              lines.attr("d", function (d,i) { return line(d.Data)})
              
              resizedFunctionForLineChart();
        })
    
        //------------------ Settings panel DIV and everything inside it section ends here ------------------
        
        var divLegendPanelForLineChart = targetElement .append('div')  .attr("class","divLegendPanelClassForLineChart") .style('background-color',"#ffffff") .style('position',"absolute")
        .style('width', 25 + "%") .style('height', 92 + "%") .style("left",75 + "%").style("top",8 + "%")
        
        if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == true)){
            divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
            
            svgPanelForLineChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
            .style("position","absolute").style("background-color", options.BGcolor);
        }
        else if ((showOrHideTableForLineChart == true) && (showOrHideCommentsForLineChart == false)){
            divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
            
            svgPanelForLineChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute").style("background-color", options.BGcolor);
        }
        else if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == false)){
            divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
            
            svgPanelForLineChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute").style("background-color", options.BGcolor);
        }
        
        //------------------ creating legend panel and everything within it -----------
            
        var legendPanelSvgForLineChart = divLegendPanelForLineChart .append('svg')  .attr("class","") .style("background-color", options.BGcolor) .style('position',"absolute")
        .style('width', 100 + "%") .style('height', 100 + "%") .style("left",0 + "%").style("top",0 + "%")
            
        var legend = legendPanelSvgForLineChart.append("g") .attr("class", "legend") .attr("height", "100%") .attr("width", "100%")
        .attr('transform', 'translate(0,20)')
        
        //Create colour circles
        legend.selectAll('rect') .data(options.data) .enter() .append("rect") .attr("x", 5) .attr("y", function(d, i){ return i * 16;})
        .attr("width", 14) .attr("height", 14) .attr("rx",10) .attr("ry",10) .style("fill", function(d, i){ return colorscale(i);})
        .style("cursor","auto")
        
        //Create text next to circles
        legend.selectAll('text') .data(options.data) .enter() .append("text") .attr("x", 25) .attr("y", function(d, i){ return i * 16 + 11.8;})
        .text(function(d,i) {
            if(d[options.keys.lines].length > 10)
            return d[options.keys.lines].substring(0,10)+'...';
            else
            return d[options.keys.lines];
            }).style('font-size', '14px') .attr("fill","#00001c") .style("font-family","Verdana,sans-serif")
        
        // Aligning Legend (vertically)
        var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelForLineChart[0][0].style.width) / 100)
        var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelForLineChart[0][0].style.height) / 100)
        
        var legendRectSize = 11;
        var legendSpacing = 6;
        
        legend.attr('transform', function(d, i) {
                    var eachRectHeight = legendRectSize + legendSpacing;
                    var offset =  eachRectHeight * colorscale.domain().length / 2;
                    var horz = 5;
                    var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.data.length))/2.0; // originally 2.0
                    
                    return 'translate(' + horz + ',' + vert + ')';
                    })
        
            // Creating ToolTip for options button.
            var iconButtonTooltipForLineChart = targetElement.append('div').style('width','240px').attr("id","too")
            .style('height',"25px").style('position','absolute')//.style('margin-left', "0px").style('top','25px')
            .style("background-color",'#404040 ').style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid") // 004b9d
            .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none").attr("border", 0.0)
    
            areaButtonForLineChart.on('mousemove', function(d,i) {
                  var root = targetElement
                  var m = d3.mouse(root.node());
                  m[0] += 0
                  m[1] += 0
                  var areaButtonTooltipText = "Switch to Area Chart";
                  iconButtonTooltipForLineChart.style("width","128px").style("margin-left", (m[0] - 138) + "px").style("margin-top",(m[1]) + "px").style("display","block")
                  iconButtonTooltipForLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ areaButtonTooltipText +'</div>')
                  
            })
            areaButtonForLineChart.on('mouseout', function(d,i) {
                  iconButtonTooltipForLineChart.style("display","none")
            })
    
            filterButtonForLineChart.on('mousemove', function(d,i) {
                    var root = targetElement
                    var m = d3.mouse(root.node());
                    m[0] += 0
                    m[1] += 0
                    var filterButtonTooltipText = "Filter";
                    iconButtonTooltipForLineChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
                    iconButtonTooltipForLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')
                    
            })
            filterButtonForLineChart.on('mouseout', function(d,i) {
                    iconButtonTooltipForLineChart.style("display","none")
            })
    
            refreshButtonForLineChart.on('mousemove', function(d,i) {
                     var root = targetElement
                     var m = d3.mouse(root.node());
                     m[0] += 0
                     m[1] += 0
                     var refreshButtonTooltipText = "Refresh";
                     iconButtonTooltipForLineChart.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
                     iconButtonTooltipForLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ refreshButtonTooltipText +'</div>')
                     
             })
            refreshButtonForLineChart.on('mouseout', function(d,i) {
                     iconButtonTooltipForLineChart.style("display","none")
             })
    
            commentsBtnForLineChart.on('mousemove', function(d,i) {
                   commentsPanelDivForLineChart.style('background-color','#fafafa')
                   var root = targetElement
                   var m = d3.mouse(root.node());
                   m[0] += 0
                   m[1] += 0
                   if(options.showComments == false){
                   var commentButtonTooltipText = "Show Comments";
                   }
                   else if(options.showComments == true){
                   var commentButtonTooltipText = "Hide Comments";
                   }
                   
                   
                   iconButtonTooltipForLineChart.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
                   iconButtonTooltipForLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ commentButtonTooltipText +'</div>')
           })
            commentsBtnForLineChart.on('mouseout', function(d,i) {
                   commentsPanelDivForLineChart.style('background-color','#ffffff')
                   iconButtonTooltipForLineChart.style("display","none")
           })
    
            menuButtonForLineChart.on('mousemove', function(d,i) {
                  var root = targetElement
                  var m = d3.mouse(root.node());
                  m[0] += 0
                  m[1] += 0
                  var menuButtonTooltipText = "Menu";
                  iconButtonTooltipForLineChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
                  iconButtonTooltipForLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ menuButtonTooltipText +'</div>')
                  
          })
            menuButtonForLineChart.on('mouseout', function(d,i) {
                  iconButtonTooltipForLineChart.style("display","none")
          })
    
            tableButtonForLineChart.on('mousemove', function(d,i) {
                   var root = targetElement
                   var m = d3.mouse(root.node());
                   m[0] += 0
                   m[1] += 0
                   if(showOrHideTableForLineChart == false){
                   var tableButtonTooltipText = "Show Table";
                   }
                   else if(showOrHideTableForLineChart == true){
                   var tableButtonTooltipText = "Hide Table";
                   }
                   iconButtonTooltipForLineChart.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
                   iconButtonTooltipForLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ tableButtonTooltipText +'</div>')
                   
           })
            tableButtonForLineChart.on('mouseout', function(d,i) {
                   iconButtonTooltipForLineChart.style("display","none")
           })
    
            settingBtnForLineChart.on('mousemove', function(d,i) {
                  var root = targetElement
                  var m = d3.mouse(root.node());
                  m[0] += 0
                  m[1] += 0
                  var settingTooltipText = "Settings";
                  iconButtonTooltipForLineChart.style("width","67px").style("margin-left", (m[0] - 77) + "px").style("margin-top",(m[1]) + "px").style("display","block")
                  iconButtonTooltipForLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ settingTooltipText +'</div>')
          })
            settingBtnForLineChart.on('mouseout', function(d,i) {
                  iconButtonTooltipForLineChart.style("display","none")
          })
        
            downloadBtnForLineChart2.on('mousemove', function(d,i) {
                  var root = targetElement
                  var m = d3.mouse(root.node());
                  m[0] += 0
                  m[1] += 0
                  var downloadButtonTooltipText = "Download";
                  iconButtonTooltipForLineChart.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
                  iconButtonTooltipForLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
            })
            downloadBtnForLineChart2.on('mouseout', function(d,i) {
                  iconButtonTooltipForLineChart.style("display","none")
            })
            
        
        // ----------------- Filter panel and everything within it section begins here ----------------
        var filterPanelForLineChart = targetElement.append('div') .style('width',350 + "px") .attr("class","filterPanelForLineChartClass" + targetElement[0][0].id)
        .style('position','absolute') .style('margin-left', "0px") .style("background-color",'#fefefe') .style("z-index",11)
        .style("border-color", "#ffffff").style("border-right", "solid #e5e5e5 1px")  .style("border-style", "solid") .style("box-shadow", "2px 0px 1px #eff8ec")
        .style("display","none").style("border-top", "solid #fdfdfd 1px").style("border-left","0px").style("border-bottom", "0px")
        .style('top', 0.0 + "%").style('height', 100 + "%").style('overflow-y',"hidden").style("overflow-x","hidden")
        .style("border-bottom", "solid #e5e5e5 1px") .style("box-sizing","border-box")
        
        var filterPanelForStkBarChartTitle = filterPanelForLineChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','20px').style('text-indent','5px').style("font-size", "14px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #007aff").style("width","350px").style("color","#000000")
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; top:25.0%; font-size:14px; font-family:inter; color:#00001c;">'+ "Filter" +'</div>')
        
        var measuresColumnTitle = filterPanelForLineChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; text-indent:3px;">Available Measures</div>');
        
        var measuresVariables = filterPanelForLineChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable1"+targetElement[0][0].id)
        .style("list-style-type","none")
        .style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '78px')
        .style('position','absolute')
        .style("width","155px").style("min-height","190px").style("max-height","190px").style("border", "#f0f0f0 1px solid")
        .style("max-width","155px").style("overflow-x","hidden").style("overflow-y","auto")
        measuresVariables.style("left",0.0 + "px").style("padding","2px")
        
        $( ".filterPanelForLineChartClass" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });
        
        
        var measuresArray = [];
        var dimensionArray = [];
        
        var measuresArrayLength = [];
        var dimensionsArrayLength = [];
        
        dimensionArray.push(options.keys.label);
        //measuresArray = options.keys.stackedBars;
        
        for(var i = 0; i<divAndChartsArray.length; i++){
            if(targetElement[0][0].id === divAndChartsArray[i].divID){
                
                //measuresArray = newtargetElementAndOptionsArray[i].options.keys.lines;
                
                if(newtargetElementAndOptionsArray[i].options.keys.areas == undefined){
                    //measuresArray = newtargetElementAndOptionsArray[i].options.keys.label;
                    options.data.forEach(function(d, index) {
                         measuresArray.push(d[newtargetElementAndOptionsArray[i].options.keys.lines])
                     });
                }
                else{
                    //measuresArray = newtargetElementAndOptionsArray[i].options.keys.label;
                    options.data.forEach(function(d, index) {
                         measuresArray.push(d[newtargetElementAndOptionsArray[i].options.keys.areas])
                     });
                }
            }
        }
        
        // filter process
        var uniqueMeasuresArrayKeys = [];
        $.each(measuresArray, function(i, el){
           if($.inArray(el, uniqueMeasuresArrayKeys) === -1){
               uniqueMeasuresArrayKeys.push(el);
           }
        });
        
        var uniqueDimensionArrayKeys = [];
        $.each(dimensionArray, function(i, el){
           if($.inArray(el, uniqueDimensionArrayKeys) === -1){
               uniqueDimensionArrayKeys.push(el);
           }
        });
        
        // setting lenght for arrays
        for(var i = 0; i <uniqueMeasuresArrayKeys.length; i++){
            measuresArrayLength.push(i);
        }
        
        for(var i = 0; i <uniqueDimensionArrayKeys.length; i++){
            dimensionsArrayLength.push(i);
        }
        
        var measuresVariables1 = measuresVariables.selectAll("li") .data(measuresArrayLength).enter().append("li")
        .style("width","130px") .style("max-height","22px").style("cursor","move")
        .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#bcf1bc").style("font-weight","Normal")
        .style("list-style-type","none").style("border","1px #89e789 solid").style("color","#006600").style("font-family","Verdana,sans-serif")
        .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
        .text(function(d) {return uniqueMeasuresArrayKeys[d]})
        measuresVariables1.attr("class","MeasuresClass"+targetElement[0][0].id)
        
        var measuresColumnReceivedUI_TableTitle = filterPanelForLineChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','180px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; ">Selected Measures</div>');
        
        var measuresColumnReceivedUI_Table = filterPanelForLineChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable3"+targetElement[0][0].id)
        .style('background-color',"#ffffff").style('margin-left','180px').style('margin-top', '78px')
        .style("width","155px").style('position','absolute').style("padding","2px").style("min-height","190px")
        .style("border","1px #c1c1c1 dashed") .style("max-height","190px") .style("overflow-x","hidden") .style("overflow-y","auto")
        //.html('<div class=unsortable  style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:65.0%; font-size:14px; font-family:inter;  color:#99ea99; font-weight:Normal; text-align:center;">Drag and Drop Measures here from Available Measures List. </div>');
        .html('<img class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' src="images/dragIcon.png" style=" width:36px; height:36px; position:absolute; margin-left:65px; margin-top:60px; opacity:0.6"/>'
              + '<div class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:60.0%; font-size:12px; font-family:inter;  color:#89d289; font-weight:Normal; text-align:center;">Drop Measures here. </div>');
        //.html('<div style="background-image: url(images/dragIcon.png); height: 64px; width: 64px; border: 1px solid black;"> </div>');
        
        var cancelButton = filterPanelForLineChart.append("div") .style("width","23px").style("height","21px").style('position','absolute')
        .style('margin-left','320px').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white')
        .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.90; background-color:#fcfcff")
        cancelButton[0][0].appendChild(cancelBtnImgVar)
        
        cancelButton.on("click", function(){
            filterPanelForLineChart.style("display","none")
            
            if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == true)){
            divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
            
            svgPanelForLineChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
            .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForLineChart == true) && (showOrHideCommentsForLineChart == false)){
            divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
            
            svgPanelForLineChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == false)){
            divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
            
            svgPanelForLineChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute").style("background-color", options.BGcolor);
            }
        })
        
        var reRenderChartAndTableButton = filterPanelForLineChart.append("button").style("width","120px").style("height","25px").style('position','absolute')
        .style('margin-left','112px').style('margin-top','298px') .style("border-style", "none").style('background-color',"#2196f3")
        .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','15px').style("border-style", "solid").style('color','#ffffff')
        .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 1px #9b9b9b").style("border-radius","0px")
        var textForReRenderButton = document.createTextNode("Apply Changes");
        reRenderChartAndTableButton[0][0].appendChild(textForReRenderButton)
        
        reRenderChartAndTableButton.on("click", function(){
                                       
               if( $("#sortable3"+targetElement[0][0].id).children("li").length == 0 )
               {
               
                   var alertPageDisabledDivForLineChart =targetElement.append('div').style('width',100 + '%')
                   .style('height',100 + "%").style('position','absolute').style('margin-left', '0px').style('top', '0px')
                   .style("background-color",'#f3f3f3').style("z-index",99)//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                   .style("opacity",0.2).style("display","block")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
                   
                   var alertDivForLineChart = targetElement.append('div').style('width','350px')
                   .style('height',"150px").style('position','absolute').style('left', ((targetElement[0][0].clientWidth/2) - 175) + "px").style('top', '1px')
                   .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "solid").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                   .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","0px")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
                   //.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Bold;">Sorry, no result found for selected' + 'range!'+ '</br>' + '<label style=text-indent:10px;> Hello</label' +'</div>')
                   .html('<p  style="width: 340px; height:0%; background-color:#c7c7c7; position: absolute; top:40.0%; font-size:14px; font-family:inter; font-weight:Bold; margin-left:10px;  color:#f8f8f8; font-weight:Normal;">Check whether the Selected Measures box is not empty!</p>')
                   
                   var alertDivTitleForLineChart = alertDivForLineChart.append('div').style('width','340px')
                   .style('height',"30px").style('position','absolute').style('margin-left', "0px").style('top', '0px')
                   .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "none").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                   .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","2px")
                   .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; font-weight:Bold; text-indent:5px;  color:#e5e5e5; font-weight:Normal;">TimeBound</div>')
                   
                   var lineChartAlertOKButton = alertDivForLineChart.append("button") .style("width","40px") .style("height","20px") .style('position','absolute') .style("box-shadow", "0px 1px 1px #B8B8B8")
                   .style('background-color',"#7cc15e") .style('margin-left','300px') .style('top', "120px").style("color","#ffffff")
                   .style("display","block").style('padding-top',"0px").style("cursor","pointer").style("box-shadow", "1px 1px 1px #56973a") .style("border-style", "none")
                   .style("font-family","Verdana,sans-serif").style("font-size","14px").style("text-align","center").style("vertical-align","middle").style("border-radius","0px")
                   .style("z-index",999)
                   
                   var textForLineChartAlertOKButton = document.createTextNode("OK");
                   lineChartAlertOKButton[0][0].appendChild(textForLineChartAlertOKButton)
                   
                   $("#"+targetElement[0][0].id).resizable('disable');
                   
                   lineChartAlertOKButton.on('click', function() {
                         alertDivForLineChart.remove();
                         alertPageDisabledDivForLineChart.remove()
                         $("#"+targetElement[0][0].id).resizable('enable');
                     })
                   
                   filterButtonForLineChart.style("cursor","pointer")
                   
                   if(showOrHideTableForLineChart == false){
                   svgPanelForLineChart.style('width', 75 + "%") .style('height', 85 + "%").style("position","absolute")
                   divLegendPanelForLineChart.style('width', 25 + "%") .style('height', 85 + "%").style("position","absolute")
                   }
                   else if(showOrHideTableForLineChart == true){
                   svgPanelForLineChart.style('width', 75 + "%") .style('height', 52 + "%").style("position","absolute")
                   divLegendPanelForLineChart.style('width', 25 + "%") .style('height', 52 + "%").style("position","absolute")
                   }
                   
                   resizedFunctionForLineChart();
               }
               
               else {
               
                   var selectedLineMeasures = [];
                   var newFilteredDataSetForLineChart = [];
                   for(var i=0; i<$("#sortable3"+targetElement[0][0].id).children("li").length;i++){
                       selectedLineMeasures.push($("#sortable3"+targetElement[0][0].id).children("li")[i].textContent)
                       //if($("#sortable3"+targetElement[0][0].id).children("li")[i].textContent.toString().toLowerCase() === )
                       options.data.forEach(function(d, index) {
                            if(d[options.keys.lines].toString().toLowerCase() === $("#sortable3"+targetElement[0][0].id).children("li")[i].textContent.toString().toLowerCase()){
                                newFilteredDataSetForLineChart.push(d)
                            }
                        })
                   } // for loop ends here
                   
                   var newOptions = {
                        data: newFilteredDataSetForLineChart,
                        dataForTable: options.dataForTable,
                        isDataDetailedForTable: options.isDataDetailedForTable,
                        keys: {
                            label: options.keys.label,
                            lines: options.keys.lines,
                        },
                        chartTitle:options.chartTitle,
                        xAxisLable: options.xAxisLable,
                        yAxisLable: "",
                        //dimensions: options.dimensions,
                        //measures: options.measures,
                        showTitle: true,
                        colorSet: options.colorSet,
                        lineStyle: options.lineStyle,
                        BGcolor:options.BGcolor,
                        series:options.series,
                        legend:options.legend,
                        drillDownColumnName:options.drillDownColumnName,
                        showTable: options.showTable,
                        showComments: options.showComments,
                        comments: options.comments,
                        resizeButtonID: options.resizeButtonID //document.getElementById("resizeBtn").id
                   }
                   
                   d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                   acinfotech.lineChart2(targetElement,newOptions)
               }
            })
        
        var textBoxForMeasureColumnFrom;
        var textBoxForMeasureColumnTo;
        var selectTitleDivForEachDimension;
        
        $( "ul.droptrue"+targetElement[0][0].id ).sortable({
               appendTo: document.body,
               helper: "clone",
               connectWith: ".droptrue"+targetElement[0][0].id,
               scroll: false,
               cancel: '.unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+','+' .unMoveableIconAndTextClassDimensions'+targetElement[0][0].id,
               revertDuration: 10,
               scrollSensitivity: 10,
               scrollSpeed: 1,
               dynamic: true,
               
               receive: function(e, ui) {
               
                   if (($(this)[0].id == "sortable3"+targetElement[0][0].id) || ($(this)[0].id == "sortable1"+targetElement[0][0].id)) {
                   
                   if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                   if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                   (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                   }
                   else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                   (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                   }
                   
                   }
                   } // if (($(this)[0].id == "sortable3") || ($(this)[0].id == "sortable1"))
                   
                   else if (($(this)[0].id == "sortable2"+targetElement[0][0].id) || ($(this)[0].id == "sortable4"+targetElement[0][0].id)) {
                   if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                   //ui.sender.sortable("cancel");
                   
                   if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                   (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                   }
                   else if(  ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                   (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                   }
                   }
                   } //if (($(this)[0].id == "sortable2") || ($(this)[0].id == "sortable4")) {
                   
                   $(ui.item).css({ 'position': 'relative' });
                   
                   if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                   ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                   }
                   
                   else if ($(this)[0].id == "sortable3"+targetElement[0][0].id) { // checking if the dropped element is in Measures drop area
                   
                   if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                   ui.sender.sortable("cancel");
                   }
                   else {
                   //ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                   }
                   
                   } // else if ($(this)[0].id == "sortable3") // checking if the dropped element is in Measures drop area ends here.
                   
                   else if ($(this)[0].id == "sortable4"+targetElement[0][0].id) { // checking if the dropped element is in Dimension drop area
                   
                   if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                   ui.sender.sortable("cancel");
                   }
                   else {
                   ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                   }
                   } //else if ($(this)[0].id == "sortable4")  // checking if the dropped element is in Dimension drop area ends here
                   
                   if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                   
                   if ($(this)[0].id == "sortable1"+targetElement[0][0].id){
                   if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                   
                   if( ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                   ui.sender.sortable("cancel");
                   } // if(  ui.sender.attr("id") === "sortable4")
                   
                   else if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                   ui.sender.sortable("cancel");
                   }
                   
                   } // if(ui.item.hasClass("DimesionsClass"))
                   }
                   if ($(this)[0].id == "sortable2"+targetElement[0][0].id){
                   if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                   
                   if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                   ui.sender.sortable("cancel");
                   }
                   else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                   ui.sender.sortable("cancel");
                   
                   }
                   }
                   }
                   
                   } //if ($(this)[0].id == "sortable1")
                   
                   if ($(this)[0].id == "sortable4"+targetElement[0][0].id){
                   if ($(this).children('li').length > 1 ){
                   ui.sender.sortable("cancel");
                   ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                   }
                   }
               
               }, //receive ends here
               
               start:function(ev, ui) {
               
               },
               stop:function(ev, ui) {
               
               },
       });
        
        /* ----------------- Filter panel and everything within it section ends here -----------------*/
        
        areaButtonForLineChart.on('click', function() {
                  
              d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
              var newOptions = {
                    data: options.data,
                    dataForTable: options.dataForTable,
                    isDataDetailedForTable: options.isDataDetailedForTable,
                    keys: {
                        label: options.keys.label,
                        areas: options.keys.lines,
                    },
                    chartTitle:options.chartTitle,
                    xAxisLable:options.xAxisLable,
                    yAxisLable:"",
                    showTitle:options.showTitle,
                    colorSet: options.colorSet,
                    BGcolor:options.BGcolor,
                    lineStyle: options.lineStyle,
                    series:options.series,
                    legend:options.legend,
                    drillDownColumnName:options.drillDownColumnName,
                    showTable:false,
                    showComments: options.showComments,
                    comments: options.comments,
                    resizeButtonID: options.resizeButtonID
              }
              for(var i = 0; i<divAndChartsArray.length; i++){
              
              if(targetElement[0][0].id === divAndChartsArray[i].divID){
              newOptions.keys.areas = newtargetElementAndOptionsArray[i].options.keys.lines
              newtargetElementAndOptionsArray[i].options.keys = newOptions.keys;
              }
              }
              acinfotech.areaChart2(targetElement, newOptions)
                  
            })
    
        filterButtonForLineChart.on('click', function() {
                    
            filterPanelForLineChart.style("display","block");
            
            ismenuBtnOfLineChartClicked = false;
            optsBtnPanelForLineChart.style("display","none");
            
            stgPanDivForLineChart.style("display","none");
            
            if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == true)){
            divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
            
            svgPanelForLineChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
            .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForLineChart == true) && (showOrHideCommentsForLineChart == false)){
            divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
            
            svgPanelForLineChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForLineChart == false) && (showOrHideCommentsForLineChart == false)){
            divLegendPanelForLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
            
            svgPanelForLineChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute").style("background-color", options.BGcolor);
            }
            
            resizedFunctionForLineChart();
                    
        })
    
        // Refreshing Chart and Table
        refreshButtonForLineChart.on('click', function() {
                     
             //isFilterClicked = false
             d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
             
             for(var i = 0; i<divAndChartsArray.length; i++){
             
             if(targetElement[0][0].id === divAndChartsArray[i].divID){
             options.data = divAndChartsArray[i].optionsData;
             //options.keys.lines = newtargetElementAndOptionsArray[i].options.keys.lines;
             
             if(newtargetElementAndOptionsArray[i].options.keys.areas == undefined){
             options.keys.lines = newtargetElementAndOptionsArray[i].options.keys.lines;
             }
             else{
             options.keys.lines = newtargetElementAndOptionsArray[i].options.keys.areas;
             }
             }
             }
             acinfotech.lineChart2(targetElement,options)
                     
         })
    
        // showing/hidding chart comments
        commentsBtnForLineChart.on('click', function() {
                   
               if(options.showComments == false){ 
               options.showComments = true;
               }
               else if(options.showComments == true){ 
               options.showComments = false;
               }
               
               d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
               
               for(var i = 0; i<divAndChartsArray.length; i++){
               
               if(targetElement[0][0].id === divAndChartsArray[i].divID){
               options.data = options.data; //divAndChartsArray[i].optionsData
               options.showTable = false;
               }
               }
               acinfotech.lineChart2(targetElement,options)
                   
           })
    
        // showing/hidding chart table
        tableButtonForLineChart.on('click', function() {
                   
               if(showOrHideTableForLineChart == false){
               options.showTable = true;
               //showOrHideTableForPieChart = true
               }
               else if(showOrHideTableForLineChart == true){
               //showOrHideTableForPieChart = false
               options.showTable = false;
               }
               
               d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
               
               for(var i = 0; i<divAndChartsArray.length; i++){
               
               if(targetElement[0][0].id === divAndChartsArray[i].divID){
               options.data = options.data;//divAndChartsArray[i].optionsData
               options.showComments = false;
               }
               }
               acinfotech.lineChart2(targetElement,options)
                   
           })
    
    
        settingBtnForLineChart.on('click', function() {
                  
            ismenuBtnOfLineChartClicked = false; // Menu toggle button variable
            optsBtnPanelForLineChart.style("display","none") // To hide options button panel
    
            iconButtonTooltipForLineChart.style("display","none") // Removing options button ToolTip
            settingBtnForLineChart.style("cursor","pointer")
    
            stgPanDivForLineChart.style("display","block") // Showing settings panel
    
            svgPanelForLineChart.style('width', 75 + "%") .style('height', 52 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); // Decreasing chart panel
            divLegendPanelForLineChart.style('width', 25 + "%") .style('height', 52 + "%") .style('top', 8 + "%") .style("position","absolute").style("background-color", options.BGcolor); // Decreasing chart panel
    
            resizedFunctionForLineChart(); // Calling resize function()
                  
        })
        
        downloadBtnForLineChart2.on('click', function() {
                                      
            ismenuBtnOfLineChartClicked = false; // Changing menu button value to false
            optsBtnPanelForLineChart.style("display","none") // Hiding option buttons panel
                                      
        })
            
        var x = d3.scale.ordinal().domain(options.keys.label.map(function(d,i) { return d;})).rangePoints([0, width],0.65);
        
        var x1 = d3.scale.ordinal() .domain(options.keys.label.map(function(d) { return d; })) .rangePoints([0, width], 0.65);
        
        var maxArray = [];
        for (i = 0; i < options.data.length; i++) {
            
            var max = d3.max(mainArray[i].data, function(d) {
                             return +d;
                             })
            
            maxArray.push(max)
        }
        
        var finalNewNewArray = [];
        var dataArray1 = [];
        mainArray.forEach(function(d, i) {
                          
              var temp1 = {};
              temp1["line"] = d["line"]
              
              
              for (j = 0; j < options.keys.label.length; j++) {
              
              var tempTemp = {};
              tempTemp["label"] = options.keys.label[j];
              tempTemp["value"] = d.data[j];
              
              dataArray1.push(tempTemp)
              }
              
              temp1["Data"] = dataArray1;
              dataArray1 = []
              finalNewNewArray.push(temp1)
                          
          })
        
        var finallyMaxValue = d3.max(maxArray, function(d) { return +d; })
        
        var y = d3.scale.linear() .domain([0, d3.max(maxArray, function(d) { return +d; })] ) .range([height, 0]);
        
        var color = d3.scale.category10();
        
        var xAxis = d3.svg.axis() .scale(x) .orient("bottom");
        
        var yAxis = d3.svg.axis() .scale(y) .ticks(5) .orient("left");
        
        var hasDecimalPoint = false;
        for(var i = 0; i < options.keys.label.length; i++){
            for(var j = 0; j < options.data.length; j++){
                if(options.data[j][options.keys.label[i]].toString().indexOf('.') > -1){ hasDecimalPoint = true; break; }
            }
        }
        if(hasDecimalPoint == false){ yAxis.tickFormat(d3.format(".2s")) }
            
        var svg = svgPanelForLineChart.append("svg") .append("g") .attr("width", width + margin.left + margin.right) .attr("height", height + margin.top + margin.bottom)
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")")
        let key=options.xAxisLable;
        let array=options.data.map(value => value[key]);
        let ArrayValue=[];
        var RotateValue;
        for(let i=0;i<array.length;i++){
                ArrayValue[i]=array[i].length;
        }
        const numberGreaterThanLimit = ArrayValue.filter((v) => v > 5);
        var xAxisLineAndMarginLabels = svg.append("g") .attr("class", "x axis") .attr("transform", "translate(0," + height + ")") .call(xAxis)
        
        // Add the X Axis margin labels
        .selectAll("text") .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') .attr("transform", function(d) 
        {
            if(numberGreaterThanLimit.length>0)
            {
                return "rotate(-45)"
            }
         else{
                    return "rotate(0)" 
            }})
        
        .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
        .text(function(d,i) {
            if(d.length > 9)
            return d.substring(0,9)+'...';
            else
            return d;
            })
        
        svg.append("g") .attr("class", "y axis") .call(yAxis) .selectAll("text") .style('fill','#00001c') .style("font-family","Verdana,sans-serif")
        
        var minX = d3.min(finalNewNewArray, function (kv) { return d3.min(kv.Data, function (d) { return +d.value; }) });
        var maxX = d3.max(finalNewNewArray, function (kv) { return d3.max(kv.Data, function (d) { return +d.value; }) });
        var minY = d3.min(finalNewNewArray, function (kv) { return d3.min(kv.Data, function (d) { return +d.value; }) });
        var maxY = d3.max(finalNewNewArray, function (kv) { return d3.max(kv.Data, function (d) { return +d.value; }) });
        
        x.domain([minX, maxX]);
        y.domain([minY, maxY]);
        
        // Creating line data
        var line = d3.svg.line() .interpolate(options.lineStyle) .x(function (d) { return x1(d['label']); }) .y(function (d) { return y(+d["value"]); });
        
        // Creating lines
        var lines = svg.selectAll(".line") .data(finalNewNewArray) .enter() .append("g") .append("path") .attr("class", "line")
        .attr("d", function (d,i) { return line(d.Data); }) .style("stroke", function (d,i) { return colorscale(i); })
        .style("stroke-width",1.0) .style('fill','none') .style("stroke-linecap", "butt")
        
        // Creating circles on lines
        var colorCount = 0;
        var circle1 = svg.selectAll("g.dot") .data(finalNewNewArray) .enter() .append("g")
        .attr("class", "dot") .selectAll("circle") .data(function(d) { return d.Data; }) .enter() .append("circle") .attr("r", 4.5)
        .attr("cx", function(d,i) {  return x1(d['label']); }) .attr("cy", function(d,i) {  return y(+d["value"]); })
        .style("fill", function (d,i) {
               if(i == 0){
               colorCount++;
               }
               return colorscale(colorCount - 1);
               })
        
        var columnNames = d3.keys(options.data[0])
        var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
        
        for(var i = 0; i < columnNames.length ; i++){
            for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                    for(var k = 0; k < options.data.length; k++){
                        var len = d3.select(svg[0][0]).selectAll('g.dot')
                        for(var l = 0; l < d3.select(len[0][k]).selectAll('circle')[0].length; l++){
                            var cir = d3.select(len[0][k]).selectAll('circle')[0][l];
                            d3.select(cir).attr('data-drilldownkey', function(d,index){
                                                return JSON.stringify(options.data[k]).slice(1, -1).split('"').join("").split(':').join("|")
                                                })
                        }
                    }
                }
                
            }
        }
        
        // Adding the text label for the X axis
        var xAxisVariable =  svg.append("text") .attr("transform", "translate(" + ((width/2) - 0) + " ," + (height+margin.bottom - 2) + ")")
        .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif") .style("font-weight","Bold") .style("font-size","12px") .text(options.xAxisLable) .style('fill','#00001c')
        .style("text-transform","capitalize") .style("font-style","normal")
        
        legend.selectAll('rect').on('mouseover',function(d,i){
                d3.select(lines[0][i]).style('stroke-width',2)
                
                var lineLen = lines.node().getTotalLength();
                var dashLen = options.data.length;
                var ddLen = dashLen ;
                var darray = dashLen;
                while(ddLen < lineLen){
                darray+=","+dashLen+","+dashLen;
                ddLen+=dashLen;
                }
                
                d3.select(lines[0][i]).attr("stroke-linecap", "round").attr("stroke-dasharray", darray + ","+lineLen) .attr("stroke-dashoffset", lineLen)
                .transition().duration(5000).ease("linear").attr("stroke-dashoffset", 0);
        })
        
        legend.selectAll('rect').on('mouseout',function(d,i){
                d3.select(lines[0][i]).style('stroke-width',1) .transition().duration(0)
                d3.select(lines[0][i]).attr("stroke-dasharray", options.data.length + ","+ 0)  .attr("stroke-dashoffset", 0)
        })
        
        var tooltipForLineChart = targetElement .append('div') .attr('class', 'tooltipPie') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
        .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
        .style("padding-right", "7px") .style("background", "#F8F8F8") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style("z-index",1000)
        .style("border", "1.0px") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","60px")
        tooltipForLineChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'label').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "14px") .style("font-weight", "normal");
        tooltipForLineChart.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
        tooltipForLineChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");
        
        
        circle1.on('mousemove', function (d,i){
                   
           var root = targetElement
           var m = d3.mouse(root.node());
           m[0] += 0
           m[1] += 0
           
           var valueForLineChartToolTip;
           if(d.value.toString().indexOf('.') === -1)
           {
           valueForLineChartToolTip = d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
           }
           else{
           
           valueForLineChartToolTip = d.value;
           }
           
           tooltipForLineChart.select('.label').html(d.label)
           //tooltipForLineChart.select('.count').html(d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
           tooltipForLineChart.select('.count').html(valueForLineChartToolTip)
           tooltipForLineChart.style('visibility', 'visible')
           tooltipForLineChart.select('hr').style("background-color", d3.select(this).style("fill") )
           tooltipForLineChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-20) + "px").style("display","block")
                   
       })
        .on('mouseout', function(){ tooltipForLineChart.style("display","none"); })
        
        
        var tableDivForLineChart = targetElement .append('div')
        .attr("class","scrollingDivForTable-Class tableDivForLineChart" + targetElement[0][0].id) .style('background-color',"#ffffff") .style("position","absolute")
        .style("display","block") .style("overflow","hidden") //.style("border-right","1px solid #e2e2e2").style("border-bottom","1px solid #e2e2e2")
        
        $( '.tableDivForLineChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
                  var e0 = e.originalEvent,
                  delta = e0.wheelDelta || -e0.detail;
                  
                  this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
                  e.preventDefault();
          });
        
        if(options.showTitle == true){
            tableDivForLineChart.style("width", 100 + "%") .style("height", 40 + "%") .style("top",60 + "%")
            
        }
        else if(options.showTitle == false){
            tableDivForLineChart.style("width", 100 + "%") .style("height", 40 + "%") .style("top",60 + "%")
        }
        
        tableDivForLineChart.html('<table class = "tableClassForLineChart2' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                  '<thead class = "theadClassForLineChart2' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForLineChart2' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                                  '<tbody class = "tBodyClassForLineChart2' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                  '</table>'
                                  )
        
        tableDivForLineChart.select('table').attr("id",targetElement[0][0].id + "tableID")
        
        // Show or Hide Table scroll when mouseover on widget
        targetElement.on('mouseover',function(){ tableDivForLineChart.style("overflow","auto") })
        targetElement.on('mouseout',function(d){ tableDivForLineChart.style("overflow","hidden") })
        
        var tableDataForLineChart2 = [];
        if(options.dataForTable.length > 0){
            tableDataForLineChart2 = options.dataForTable;
        }
        else {
            tableDataForLineChart2 = options.data;
        }
        
        var thead = tableDivForLineChart.select("thead").selectAll("th") .data(d3.keys(tableDataForLineChart2[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#fefdfd")//f6f6f6
        .style("position","relative").style("top","2px")
        
        var thead1 = d3.select(".thead1ClassForLineChart2" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tableDataForLineChart2[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#fefdfd")//f6f6f6
        .style("position","relative").style("top","2px")
        
        var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
        .attr("id", "ascendingIconIDForLineChart") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
        
        var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
        .attr("id", "descendingIconIDForLineChart") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
        
        var tr = tableDivForLineChart.select("tbody").selectAll("tr") .data(tableDataForLineChart2).enter().append("tr")
        .attr("id", function(d,i) { return "slice" + i })
        
        // cells
        var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter() .append("td") .text(function(d) { return d})
        .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
        
        var $table = $('.tableClassForLineChart2' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
        
        d3.select(".theadClassForLineChart2" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                d.forEach(function(dd,j){
                    colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                })
        })
        
        $(".thead1ClassForLineChart2" + targetElement[0][0].id).insertAfter('.tBodyClassForLineChart2' + targetElement[0][0].id)
        
        $(".thead1ClassForLineChart2" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForLineChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
        
        tableDivForLineChart.select(".thead1ClassForLineChart2" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
             d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
         })
        
        $('.tableDivForLineChart' + targetElement[0][0].id).scroll(function () {
                                                                   
           $(".thead1ClassForLineChart2" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForLineChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
        })
        
        var sortOrder = false;
        thead1.on("click",function(k,index){
                 
                 sortOrder = !sortOrder;
                 
                 tableDivForLineChart.select(".thead1ClassForLineChart2" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                       
                       if (sortOrder) {
                       
                           if(i == index){
                               d3.select(this).select('svg').select('#descendingIconIDForLineChart').style("visibility", "hidden")
                               d3.select(this).select('svg').select('#ascendingIconIDForLineChart').style("visibility", "visible")
                           }
                           else {
                               d3.select(this).select('svg').select('#descendingIconIDForLineChart').style("visibility", "visible")
                               d3.select(this).select('svg').select('#ascendingIconIDForLineChart').style("visibility", "visible")
                           }
                       }
                       else{
                       
                           if(i == index){
                               d3.select(this).select('svg').select('#descendingIconIDForLineChart').style("visibility", "visible")
                               d3.select(this).select('svg').select('#ascendingIconIDForLineChart').style("visibility", "hidden")
                           }
                           else {
                               d3.select(this).select('svg').select('#descendingIconIDForLineChart').style("visibility", "visible")
                               d3.select(this).select('svg').select('#ascendingIconIDForLineChart').style("visibility", "visible")
                           }
                       }
                  })
                  
                  var monthTruOrFalAryForLineChart2 = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
                  
                  tr.sort(function(a, b) {
                          
                          if (sortOrder) {
                          var monthsArrayForLineChart2 = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                          } else {
                          var monthsArrayForLineChart2 = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                          }
                          
                          monthTruOrFalAryForLineChart2 = []; gotMonthArray = [];
                          tableDataForLineChart2.forEach(function(d,i){
                                    var da = d[k].toString().substring(0,3).toLowerCase()
                                    if(monthsArrayForLineChart2.indexOf(da) >= 0){
                                        monthTruOrFalAryForLineChart2.push(true)
                                        gotMonthArray.push(da);
                                    }
                                    else {
                                        monthTruOrFalAryForLineChart2.push(false)
                                    }
                           })
                          
                          if(monthTruOrFalAryForLineChart2.indexOf(false) == -1){ // true
                          
                          monthArray = []; monthArrayCount = [];
                          gotMonthArray.forEach(function(dd,j){
                                var index1 = monthsArrayForLineChart2.indexOf(dd.substring(0,3))
                                if(monthArrayCount.indexOf(index1) >= 0){
                                index1 = 12 + index1;
                                }
                                monthArray.push(index1);
                                monthArrayCount.push(index1)
                          })
                          returnArray = []
                          monthArray.sort(function(aa, bb) {
                              returnArray.push(+aa - +bb)
                              return +aa - +bb;
                          })
                          
                          sortTableFunc()
                          return returnArray[ind++];
                          } //  if true (if jan feb if block)
                          else {
                          var data = +a[k];
                          
                          if(!isNaN(data)){
                          
                          if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                          else { return d3.descending(+a[k], +b[k]); }
                          }
                          else if(!isNaN(Date.parse(a[k]))){
                          
                          if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                          else { return new Date(b[k]) - new Date(a[k]) }
                          }
                          else {
                          
                          if (sortOrder) { return d3.ascending(a[k], b[k]); }
                          else { return d3.descending(a[k], b[k]); }
                          }
                          } // if not jan feb else block
                          }); // tr
                
            })
        
        function sortTableFunc(){
            
            var table = tableDivForLineChart.select('table');
            var rows = table.selectAll('tr').data(tableDataForLineChart2);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0).style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr')
            .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500) .style('opacity', 1.0).style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
        }
        
        // Main Table Styling
        tableDivForLineChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
        .style("color","#00001c")
        .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4") //.style("box-shadow","10px 10px 50px #007aff").style("z-index",9999)
        tableDivForLineChart.selectAll('td').style("height","25px") .style("border", "1px solid #ffffff") .style("font-size","12px").style("font-weight","Normal").style("color","#00001c")
        
        //additionally
        tableDivForLineChart.selectAll('th').style('background-color',"#ffffff").style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
        tableDivForLineChart.selectAll('td').style("border-style","none").style("color","#00001c")
        //tablePanelForPieChart.selectAll('td').style("height","25px") .style("border", "1px solid #fcfcfc") .style("font-size","12px").style("font-weight","Normal")
        
        //b1da9f
        tableDivForLineChart.selectAll('table') . style("border-collapse","collapse")
        tableDivForLineChart.selectAll('table tr:first-child th').style("border-top","0px")
        tableDivForLineChart.selectAll('table tr:last-child td').style("border-bottom","0px")
        tableDivForLineChart.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
        tableDivForLineChart.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")
        
        if(showOrHideTableForLineChart == false){
            tableDivForLineChart.style("display","none")
        }
        else if(showOrHideTableForLineChart == true){
            tableDivForLineChart.style("display","block")
        }
        
        if(options.isDataDetailedForTable == false){
        
            var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
        
            // Adding underlines for selected drill-down column text
            var drillDownSectionsForLineChart = tableDivForLineChart.select('table').selectAll('th')
        
            var foundResult = [];
            for(var i = 0; i<drillDownSectionsForLineChart[0].length; i++){
                for(var j = 0; j<drillDownColumnNamesArray.length; j++){
                    if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForLineChart[0][i].__data__.toString().toLowerCase() ){
                        foundResult.push(i)
                    }
                }
            }
        
            var r = tableDivForLineChart.select('table').selectAll('tr').selectAll('td')
            for(var i = 0; i<r.length; i++){
                for(var j = 0; j < foundResult.length; j++){
                    var row = r[i][foundResult[j]]
                    $(row).css("text-decoration", "underline")
                }
            }
        }
        
        resizedFunctionForLineChart(); // calling the resize function for the first time.
        
        window.addEventListener('resize', function(event){ resizedFunctionForLineChart() });
        
        $(function() {
          
          $("#" + targetElement[0][0].id).resizable({
                resize: function(event, ui) {
                    divWidth = ui.size.width;
                    divHeight = ui.size.height;
                   resizedFunctionForLineChart();
                }
            });
          });
        
        function resizedFunctionForLineChart()
        {
            
            if((svgPanelForLineChart.node().getBoundingClientRect().width) && (svgPanelForLineChart.node().getBoundingClientRect().height) > 0){
                
                if(showOrHideCommentsBtnForLineChart == true){
                    areaButtonForLineChart.style('margin-left', "2px")
                    filterButtonForLineChart.style('margin-left', "2px")
                    refreshButtonForLineChart.style('margin-left', "2px")
                    commentsBtnForLineChart.style('margin-left', "2px")
                    menuButtonForLineChart.style('right', '0')
                }
                else if(showOrHideCommentsBtnForLineChart == false){
                    areaButtonForLineChart.style('margin-left', "2px")
                    filterButtonForLineChart.style('margin-left', "2px")
                    refreshButtonForLineChart.style('margin-left', "2px")
                    //commentsBtnForLineChart.style('right', '0')
                    commentsBtnForLineChart.style('display','none')
                    menuButtonForLineChart.style('right', '0')
                }
                
                optsBtnPanelForLineChart.style('right', '0')
                
                stgPanCanBtnForLineChart.style('right', '0') // setting panel cancel button.
                
                var margin1 = {top: 30 , right: 10, bottom: 80, left: 50}, //originally top: 42, left: 80
                width1 = (svgPanelForLineChart.node().getBoundingClientRect().width) - margin1.left - margin1.right,
                height1 = (svgPanelForLineChart.node().getBoundingClientRect().height) - margin1.top - margin1.bottom;
                // width1 = ($('#svgPanelIDForLineChart' + targetElement[0][0].id)[0].getBoundingClientRect().width) - margin1.left - margin1.right,
                // height1 = ($('#svgPanelIDForLineChart' + targetElement[0][0].id)[0].getBoundingClientRect().height) - margin1.top - margin1.bottom;
                
                x.domain(options.keys.label.map(function(d,i) { return d;})).rangePoints([0, width1],0.65);
                
                x1.domain(options.keys.label.map(function(d,i) { return d;})).rangePoints([0, width1],0.65);
                
                var yy = d3.scale.linear().domain([0, d3.max(maxArray, function(d) { return +d; })] ).range([height1, 0]);
                
                yAxis.scale(yy) .orient("left");
                
                xAxis.scale(x) .orient("bottom")
                
                line.x(function (d) { return x(d['label']); }) .y(function (d) { return yy(+d["value"]); });
                
                var svg1 = svg;
                
                svg1.select("svg") .attr("width", width1 + margin1.left + margin1.right) .attr("height", height1 + margin1.top + margin1.bottom)
                
                svg1.select(".y.axis") .call(yAxis)
                
                svg1.select(".x.axis") .attr("transform", "translate(0," + height1 + ")") .call(xAxis)
                
                // Add the X Axis margin labels
                .selectAll("text") .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') .attr("transform", function(d) 
                { 
                    if(numberGreaterThanLimit.length>0){return "rotate(-45)"}
                else{
                return "rotate(0)" }})
                .text(function(d,i) {
                      if(d.length > 9)
                      return d.substring(0,9)+'...';
                      else
                      return d;
                      })
                
                xAxisVariable.attr("transform", "translate(" + ((width1/2) - 0) + " ," + (height1+margin1.bottom - 2) + ")")
                
                svg1.selectAll("circle") .transition() .delay(function (d, i) { return i / options.data.length * 50; }) .duration(900).ease("bounce")
                .attr("cx", function(d,i) {  return x1(d['label']); }) .attr("cy", function(d,i) {  return yy(+d["value"]); })
                
                svg1.selectAll(".line")
                .attr("d", function (d,i) { return line(d.Data); })
                
                // Aligning Legend (vertically)
                var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelForLineChart[0][0].style.width) / 100)
                var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelForLineChart[0][0].style.height) / 100)
                
                var legendRectSize = 11;
                var legendSpacing = 6;
                
                legend.attr('transform', function(d, i) {
                    var eachRectHeight = legendRectSize + legendSpacing;
                    var offset =  eachRectHeight * colorscale.domain().length / 2;
                    var horz = 5;
                    var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.data.length))/2.0; // originally 2.0
                    
                    return 'translate(' + horz + ',' + vert + ')';
                })
                
                colWidth = []; 
                
                d3.select(".theadClassForLineChart2" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                        d.forEach(function(dd,j){
                            colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                        })
                })
                tableDivForLineChart.select(".thead1ClassForLineChart2" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                    d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
                })
                
            } // checking svg panel width & height is greater than zero
        }
        }, //lineChart2
    
    // ************************************************** Area Chart 2 **************************************************
    areaChart2: function(targetElement, options){
    
    var labelLength = options.keys.label.length;
    var mainArray = [];
    var arrayToHoldAreaNamesForAreaChart = [];
    
    options.data.forEach(function(d, index) {
         var temp = {};
         var tempArray = [];
         
         for(var i = 0; i<labelLength; i++){
         tempArray.push(d[options.keys.label[i]])
         }
         
         temp["line"] = d[options.keys.areas];
         temp["data"] = tempArray;
         
         mainArray.push(temp)
     })
    
    isChartCalled++;
    
    var chartName = "AREACHART2";
    
    acinfotech.allCharts(targetElement,options,chartName);
    
    targetElement.style("min-width","350px").style("min-height","350px").style("background-color", options.BGcolor)
    
    var showOrHideTableForAreaChart;
    var showOrHideCommentsForAreaChart;
    var showOrHideCommentsBtnForAreaChart = true;
    
    if((options.showTable == false) || (options.showTable == true)){
        showOrHideTableForAreaChart = options.showTable
    }
    else{
        showOrHideTableForAreaChart = false;
    }
    
    // Show or Hide comments
    if (options.showComments == true || false) {
        showOrHideCommentsForAreaChart = options.showComments;
    }
    else {
        showOrHideCommentsForAreaChart = false;
    }
    
    if (options.comments.length == 0){
        showOrHideCommentsForAreaChart = false;
        showOrHideCommentsBtnForAreaChart = false;
    }
    
    if ((showOrHideTableForAreaChart == true) && (showOrHideCommentsForAreaChart == true)){
        showOrHideTableForStkBarChart = true;
        showOrHideCommentsForAreaChart = false;
    }
    else if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == false)){
        showOrHideTableForStkBarChart = false;
        showOrHideCommentsForAreaChart = false;
    }
    
    var divWidth, divHeight;
    
    var chartTitlePanelForAreaChart = targetElement.append("div") .style("position","absolute").style("background-color", options.BGcolor) .style("text-indent","6px") .style("border", "none")
    
	var optsBtnPanelForAreaChart = targetElement.append('div').style('width',"25px").style('height',"180px").style('position','absolute')
    .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px")
    .style('right', '0') .style("min-width","25px") .style("border-style","none")
    .style("border-left", "solid #fcfcfc  1px")
	
    var lineButtonForAreaChart = optsBtnPanelForAreaChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
    .style('background-color',"#ffffff").style("z-index",10)
    .style('top','80px') .style("cursor","pointer").style("display","block")
    .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
    var areaBtnImgVar = document.createElement("IMG");
    areaBtnImgVar.src = "images/linearLineIcon1.png";
    areaBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
    lineButtonForAreaChart[0][0].appendChild(areaBtnImgVar)
    
    var filterButtonForAreaChart = optsBtnPanelForAreaChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
    .style('background-color',"#ffffff").style("z-index",10)
    .style('top','105px') .style("cursor","pointer").style("display","block")
    .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
    var filterBtnImgVar = document.createElement("IMG");
    filterBtnImgVar.src = "images/filterIcon.png";
    filterBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
    filterButtonForAreaChart[0][0].appendChild(filterBtnImgVar)
    
    var refreshButtonForAreaChart = optsBtnPanelForAreaChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
    .style('background-color',"#ffffff").style("z-index",10)
    .style('top','130px') .style("cursor","pointer").style("display","block")
    .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
    var refreshBtnImgVar = document.createElement("IMG");
    refreshBtnImgVar.src = "images/refreshIcon.png";
    refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
    refreshButtonForAreaChart[0][0].appendChild(refreshBtnImgVar)
    
    var commentsBtnForAreaChart = optsBtnPanelForAreaChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
    .style('background-color',"#ffffff").style("z-index",10)
    .style('top','155px') .style("cursor","pointer").style("display","block")
    .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
    var commentsBtnImgVariable = document.createElement("IMG");
    if(options.showComments == false){
        commentsBtnImgVariable.src = "images/showCommentsIcon.png";
    }
    else if(options.showComments == true){
        commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
    }
    commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
    commentsBtnForAreaChart[0][0].appendChild(commentsBtnImgVariable)
    
    var menuButtonForAreaChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
    .style('background-color',"#ffffff").style("z-index",10)
    .style('top','1px') .style("cursor","pointer").style("display","block")
    .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
    var menuBtnImgVar = document.createElement("IMG");
    menuBtnImgVar.src = "images/menuIcon.png";
    menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
    menuButtonForAreaChart[0][0].appendChild(menuBtnImgVar)
    
    if(showOrHideCommentsBtnForAreaChart == true){
        lineButtonForAreaChart.style('margin-left', "2px")
        filterButtonForAreaChart.style('margin-left', "2px")
        refreshButtonForAreaChart.style('margin-left', "2px")
        commentsBtnForAreaChart.style('margin-left', "2px")
        menuButtonForAreaChart.style('right', '0')
    }
    else if(showOrHideCommentsBtnForAreaChart == false){
        lineButtonForAreaChart.style('margin-left', "2px")
        filterButtonForAreaChart.style('margin-left', "2px")
        refreshButtonForAreaChart.style('margin-left', "2px")
        //commentsBtnForAreaChart.style('right', '0')
        commentsBtnForAreaChart.style('display','none')
        menuButtonForAreaChart.style('right', '0')
    }
    
    var ismenuBtnOfAreaChartClicked = false;
    menuButtonForAreaChart.on('click', function() {
                              
          filterPanelForAreaChart.style("display","none");
          stgPanDivForAreaChart.style("display","none") // Hiding setting panel
          
          if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == true)){
          divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
          .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
          
          svgPanelForAreaChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
          .style("position","absolute").style("background-color", options.BGcolor);
          }
          else if ((showOrHideTableForAreaChart == true) && (showOrHideCommentsForAreaChart == false)){
          divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
          .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
          
          svgPanelForAreaChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
          .style("position","absolute").style("background-color", options.BGcolor);
          }
          else if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == false)){
          divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
          .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
          
          svgPanelForAreaChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
          .style("position","absolute").style("background-color", options.BGcolor);
          }
          
          if(ismenuBtnOfAreaChartClicked == false){
          ismenuBtnOfAreaChartClicked = true;
          optsBtnPanelForAreaChart.style("display","block")
          
          }
          else if(ismenuBtnOfAreaChartClicked == true){
          ismenuBtnOfAreaChartClicked = false
          optsBtnPanelForAreaChart.style("display","none")
          }
          
          resizedFuctionForAreaChart();
    })
    
    var tableButtonForAreaChart = optsBtnPanelForAreaChart.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
    .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top','1px')
    .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
    var tableBtnImgVar = document.createElement("IMG");
    if(showOrHideTableForAreaChart == false){
        tableBtnImgVar.src = "images/showTableIcon.png";
        tableButtonForAreaChart.attr("class","showTableClassForChartTable")
    }
    else if(showOrHideTableForAreaChart == true){
        tableBtnImgVar.src = "images/cancelTableIcon.png";
        tableButtonForAreaChart.attr("class","hideTableClassForChartTable")
    }
    tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
    tableButtonForAreaChart[0][0].appendChild(tableBtnImgVar)
    
    var settingBtnForAreaChart = optsBtnPanelForAreaChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
    .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 28 + 'px')
    .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
    var settingBtnImgVar = document.createElement("IMG");
    settingBtnImgVar.src = "images/settingsIcon.png";
    settingBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.82;")
    settingBtnForAreaChart[0][0].appendChild(settingBtnImgVar)
    
    var downloadBtnForAreaChart2 = optsBtnPanelForAreaChart.append("div").attr("id","downloadBtnForAreaChart2-ID-" + targetElement[0][0].id).style("width","20px").style("height","20px")
    .style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff").style('margin-left','2px').style('top', 54 + 'px')
    .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
    
    acinfotech.downloadFunctionality("downloadBtnForAreaChart2-ID-" + targetElement[0][0].id,targetElement)
        
    var svgPanelForAreaChart = targetElement .append('svg') 
    .attr("id","svgPanelIDForLineChart" + targetElement[0][0].id) .style("background-color", options.BGcolor) .style("position","absolute")
    
    var commentsPanelDivForAreaChart = targetElement.append("div") .attr("class","commentsPanelClassForAreaChart2")
    .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
	.style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
    .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)
    
    commentsPanelDivForAreaChart.on('click',function(d){
            $('.commentsClassForAreaChart' + targetElement[0][0].id).focus()
    })
    
    if(options.showTitle == true){
        
        chartTitlePanelForAreaChart.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 8 + "%"; })
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')
        
        if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == true)){
            
            var commentsForAreaChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
            .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
            .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
            .css('line-height','1.1em').css('text-align','justify') .attr('class','commentsClassForAreaChart' + targetElement[0][0].id)
            
            svgPanelForAreaChart.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .append('g')
            commentsPanelDivForAreaChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
            .style("top",78 + "%")
            .html(commentsForAreaChart[0].outerHTML.toString())
            
        }
        else if ((showOrHideTableForAreaChart == true) && (showOrHideCommentsForAreaChart == false)){
            
            svgPanelForAreaChart.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .append('g')
            commentsPanelDivForAreaChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
        }
        else if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == false)){
            svgPanelForAreaChart.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .append('g')
            commentsPanelDivForAreaChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
        }
        
        var margin = {top: 30 , right: 10, bottom: 80, left: 50}, //originally top: 42, left: 80
        width = (svgPanelForAreaChart.node().getBoundingClientRect().width) - margin.left - margin.right,
        height = (svgPanelForAreaChart.node().getBoundingClientRect().height) - margin.top - margin.bottom;
        
    }
    else if(options.showTitle == false){
        chartTitlePanelForAreaChart.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });
        
        if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == true)){
            
            var commentsForAreaChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
            .attr('contenteditable',false).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
            .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
            .css('line-height','1.1em').css('text-align','justify')
            
            svgPanelForAreaChart.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .append('g')
            commentsPanelDivForAreaChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
            .style("top",78 + "%")
            .html(commentsForAreaChart[0].outerHTML.toString())
            
        }
        else if ((showOrHideTableForAreaChart == true) && (showOrHideCommentsForAreaChart == false)){
            
            svgPanelForAreaChart.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .append('g')
            commentsPanelDivForAreaChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
        }
        else if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == false)){
            svgPanelForAreaChart.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .append('g')
            commentsPanelDivForAreaChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
        }
        
        var margin = {top: 30 , right: 10, bottom: 80, left: 50}, //originally top: 42, left: 80
        width = (svgPanelForAreaChart.node().getBoundingClientRect().width) - margin.left - margin.right,
        height = (svgPanelForAreaChart.node().getBoundingClientRect().height) - margin.top - margin.bottom;
    }
    
    var colorscale;
    // checking color set for pie slices and legend dots
    if(options.colorSet === undefined){
        options.colorSet = "one"
        colorscale = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
    }
    else if(options.colorSet.toString().toLowerCase() === "one"){
        options.colorSet = "one"
        colorscale = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
    }
    else if(options.colorSet.toString().toLowerCase() === "two"){
        options.colorSet = "two"
        colorscale = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
    }
    else if(options.colorSet.toString().toLowerCase() === "three"){
        options.colorSet = "three"
        colorscale = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
    }
    else
    {
        options.colorSet = "one"
        colorscale = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
    }
    
    if ((options.lineStyle.toString().toLowerCase() === "cardinal") || (options.lineStyle.toString().toLowerCase() === "linear") || (options.lineStyle.toString().toLowerCase() === "step")){
        options.lineStyle = options.lineStyle;
    }
    else{
        options.lineStyle = "cardinal";
    }
    
    //------------------ Settings panel DIV and everything within it section begins here ------------------
    
    var stgPanDivForAreaChart = targetElement.append('div').style('width',"100%").style('height',"40%").attr("class","stgPanDivForLineChart" + targetElement[0][0].id)
    .style('position','absolute').style('margin-left', "0px").style('border-top',"1px solid #f0f0f0").style('border-bottom',"1px solid #e5e5e5")
    .style("background-color",'#fcfcfc').style("z-index",90) .style("display","none") .style('top',"60%").style('height',"40%")
    
    $( '.stgPanDivForLineChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
           var e0 = e.originalEvent,
           delta = e0.wheelDelta || -e0.detail;
           
           this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
           e.preventDefault();
   });
    
    var settingPanelTitle = stgPanDivForAreaChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
    .style('margin-left','0px').style('margin-top','10px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
    .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
    .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; color:#00001c;">'+ "Settings" +'</div>')
    
    var stgPanDivForLineChangeColorTitle = stgPanDivForAreaChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
    .style('margin-left','0px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
    .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
    .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Select color set " +'</div>')
    
    var stgPanCanBtnForAreaChart = stgPanDivForAreaChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
    .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
    .style('background-color',"#FCFCFF")
    .style("border", "0.0px") .style("border-style", "solid").style('color','white')
    .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
    var cancelBtnImgVar = document.createElement("IMG");
    cancelBtnImgVar.src = "images/closeIcon.png";
    cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.9; background-color:#fcfcff")
    stgPanCanBtnForAreaChart[0][0].appendChild(cancelBtnImgVar)
    
    stgPanCanBtnForAreaChart.on('click', function() {
            stgPanDivForAreaChart.style("display","none") // Hiding setting panel
            
            if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == true)){
            divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
            
            svgPanelForAreaChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
            .style("position","absolute");
            }
            else if ((showOrHideTableForAreaChart == true) && (showOrHideCommentsForAreaChart == false)){
            divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
            
            svgPanelForAreaChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute");
            }
            else if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == false)){
            divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
            
            svgPanelForAreaChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute");
            }
            
            resizedFuctionForAreaChart();
     })
    
    var formForChangeSettingsPanel = stgPanDivForAreaChart.append("form");
    formForChangeSettingsPanel.style("background-color","#fcfcfc").style("margin-top","67px").style("font-family","Verdana,sans-serif").style("font-size","12px")
    .style("position","absolute").attr("id","formForChangeColorSettingsPanel" + targetElement[0][0].id).style("font-weight","Bold").style("width","180px")
    .style("height","58px").style("padding","0px").style("border-radius","0px") .style("margin-left","10px")
    
    var svgPanelForCrSetOne = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
    .style("width","160px") .style("height","18px").style("margin-top","1px") .style("margin-left","0px") .style("box-sizing","border-box")
    
    var colorSetOne = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
    var colorSetOneRange = d3.range(12);
    
    var colorSetOneDots = svgPanelForCrSetOne.append("g")
    colorSetOneDots.selectAll('rect') .data(colorSetOneRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
    .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("fill", function(d,i){return colorSetOne(i)})
    .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetOne(i);  })
    .style("cursor","auto") .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
    
    var svgPanelForCrSetTwo = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
    .style("width","160px") .style("height","18px") .style("margin-top","20px") .style("margin-left","0px") .style("box-sizing","border-box")
    
    var colorSetTwo = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
    var colorSetTwoRange = d3.range(12);
    
    var colorSetTwoDots = svgPanelForCrSetTwo.append("g")
    colorSetTwoDots.selectAll('rect') .data(colorSetTwoRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
    .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto")
    .style("fill", function(d,i){return colorSetTwo(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
    .style("stroke",function(d,i){  return colorSetTwo(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
    
    var svgPanelForCrSetThree = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
    .style("width","160px") .style("height","18px") .style("margin-top","39px") .style("margin-left","0px") .style("box-sizing","border-box")
    
    var colorSetThree = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
    var colorSetThreeRange = d3.range(12);
    
    var colorSetThreeDots = svgPanelForCrSetThree.append("g")
    colorSetThreeDots.selectAll('rect') .data(colorSetThreeRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
    .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto") .style("fill", function(d,i){return colorSetThree(i)})
    .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetThree(i);  })
    .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
    
    if(options.colorSet.toString().toLowerCase() === "one"){
        svgPanelForCrSetOne.style('border',"1px solid #808080")
        svgPanelForCrSetTwo.style('border',"0px solid #808080")
        svgPanelForCrSetThree.style('border',"0px solid #808080")
    }
    else if(options.colorSet.toString().toLowerCase() === "two"){
        svgPanelForCrSetOne.style('border',"0px solid #808080")
        svgPanelForCrSetTwo.style('border',"1px solid #808080")
        svgPanelForCrSetThree.style('border',"0px solid #808080")
    }
    else if(options.colorSet.toString().toLowerCase() === "three"){
        svgPanelForCrSetOne.style('border',"0px solid #808080")
        svgPanelForCrSetTwo.style('border',"0px solid #808080")
        svgPanelForCrSetThree.style('border',"1px solid #808080")
    }
    else
    {
        svgPanelForCrSetOne.style('border',"1px solid #808080")
        svgPanelForCrSetTwo.style('border',"0px solid #808080")
        svgPanelForCrSetThree.style('border',"0px solid #808080")
    }
    
    svgPanelForCrSetOne.on('click',function(d){
           options.colorSet = "one"
           svgPanelForCrSetOne.style('border',"1px solid #808080")
           svgPanelForCrSetTwo.style('border',"0px solid #808080")
           svgPanelForCrSetThree.style('border',"0px solid #808080")
           
           colorscale = "";
           colorscale = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
           
           areas.style("fill", function (d,i) { return colorscale(i); }).style("stroke", function (d,i) { return colorscale(i); })
           //colorCount = 0;
           // circle1.style("fill", function (d,i) {
           //     if(i == 0){
           //         colorCount++;
           //     }
           //     return colorscale(colorCount - 1);
           // })
           
           legend.selectAll('rect').style("fill", function(d, i){ return colorscale(i);})
           
    })
    svgPanelForCrSetTwo.on('click',function(d){
           options.colorSet = "two"
           svgPanelForCrSetOne.style('border',"0px solid #808080")
           svgPanelForCrSetTwo.style('border',"1px solid #808080")
           svgPanelForCrSetThree.style('border',"0px solid #808080")
           
           colorscale = "";
           colorscale = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
           
           areas.style("fill", function (d,i) { return colorscale(i); }).style("stroke", function (d,i) { return colorscale(i); })
           // colorCount = 0;
           // circle1.style("fill", function (d,i) {
           //     if(i == 0){
           //         colorCount++;
           //     }
           //         return colorscale(colorCount - 1);
           // })
           legend.selectAll('rect').style("fill", function(d, i){ return colorscale(i);})
    })
    svgPanelForCrSetThree.on('click',function(d){
             options.colorSet = "three"
             svgPanelForCrSetOne.style('border',"0px solid #808080")
             svgPanelForCrSetTwo.style('border',"0px solid #808080")
             svgPanelForCrSetThree.style('border',"1px solid #808080")
             
             colorscale = "";
             colorscale = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
             
             areas.style("fill", function (d,i) { return colorscale(i); }).style("stroke", function (d,i) { return colorscale(i); })
             // colorCount = 0;
             // circle1.style("fill", function (d,i) {
             //     if(i == 0){
             //         colorCount++;
             //     }
             //         return colorscale(colorCount - 1);
             // })
             legend.selectAll('rect').style("fill", function(d, i){ return colorscale(i);})
     })
    
    var areaStrokeChangeStyleTitle = stgPanDivForAreaChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
    .style('margin-left','190px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
    .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
    .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Area Style " +'</div>')
    
    var lineStyleDivForAreaChart = stgPanDivForAreaChart.append("div") .style("background-color","#fcfcfc") .style("margin-left","200px")
    .style("margin-top","67px") .style("font-family","Verdana,sans-serif") .style("font-size","12px") .style("position","absolute")
    .style("font-weight","Bold").style("width","110px") .style("height","30px") .style("padding","0px") .style("border-radius","0px")
    
    var cardinalButton = lineStyleDivForAreaChart.append("div") .style("width","32px").style("height","26px").style('position','absolute')
    .style('background-color',"#ffffff").style('margin-left',"0px") .style('top','1px') .style("cursor","pointer") .style("display","block")
    .style("border-style", "none").style('padding',"0px") .style("border", "1px solid #a0a0a0").style("line-height","0px") .style("box-sizing","border-box")
    var cardinalBtnImgVar = document.createElement("IMG");
    cardinalBtnImgVar.src = "images/curveAreaIcon.png";
    cardinalBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:24px; height:19px; opacity:0.78;")
    cardinalButton[0][0].appendChild(cardinalBtnImgVar)
    
    var linearButton = lineStyleDivForAreaChart.append("div") .style("width","32px").style("height","26px").style('position','absolute')
    .style('background-color',"#ffffff").style('margin-left',"35px") .style('top','1px') .style("cursor","pointer") .style("display","block")
    .style("border-style", "none") .style('padding',"0px") .style("line-height","0px") .style("box-sizing","border-box")
    var linearBtnImgVar = document.createElement("IMG");
    linearBtnImgVar.src = "images/linearAreaIcon.png";
    linearBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:24px; height:19px; opacity:0.78;")
    linearButton[0][0].appendChild(linearBtnImgVar)
    
    var stepButton = lineStyleDivForAreaChart.append("div") .style("width","32px") .style("height","26px") .style('position','absolute')
    .style('background-color',"#ffffff") .style('margin-left',"70px") .style('top','1px') .style("cursor","pointer") .style("display","block")
    .style("border-style", "none").style('padding',"0px").style("line-height","0px").style("box-sizing","border-box")
    var stepBtnImgVar = document.createElement("IMG");
    stepBtnImgVar.src = "images/stepAreaIcon.png";
    stepBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:24px; height:21px; opacity:0.78;")
    stepButton[0][0].appendChild(stepBtnImgVar)
    
    if(options.lineStyle.toString().toLowerCase() === "cardinal"){
        cardinalButton.style('border',"1px solid #808080")
        linearButton.style('border',"0px solid #808080")
        stepButton.style('border',"0px solid #808080")
    }
    else if(options.lineStyle.toString().toLowerCase() === "linear"){
        cardinalButton.style('border',"0px solid #808080")
        linearButton.style('border',"1px solid #808080")
        stepButton.style('border',"0px solid #808080")
    }
    else if(options.lineStyle.toString().toLowerCase() === "step"){
        cardinalButton.style('border',"0px solid #808080")
        linearButton.style('border',"0px solid #808080")
        stepButton.style('border',"1px solid #808080")
    }
    else
    {
        cardinalButton.style('border',"1px solid #808080")
        linearButton.style('border',"0px solid #808080")
        stepButton.style('border',"0px solid #808080")
    }
    
    cardinalButton.on('click',function(d){
          options.lineStyle = "cardinal"
          cardinalButton.style('border',"1px solid #a0a0a0")
          linearButton.style('border',"0px solid #808080")
          stepButton.style('border',"0px solid #808080")
          
          area.interpolate(options.lineStyle) .x(function (d) { return x1(d['label']); }) .y0(height) .y1(function (d) { return y(+d["value"]); });
          
          areas.attr("d", function (d,i) { return area(d.Data)})
          
          resizedFuctionForAreaChart();
          
    })
    linearButton.on('click',function(d){
            options.lineStyle = "linear"
            cardinalButton.style('border',"0px solid #a0a0a0")
            linearButton.style('border',"1px solid #a0a0a0")
            stepButton.style('border',"0px solid #a0a0a0")
            
            area.interpolate(options.lineStyle) .x(function (d) { return x1(d['label']); }).y0(height) .y1(function (d) { return y(+d["value"]); });
            
            areas.attr("d", function (d,i) { return area(d.Data)})
            
            resizedFuctionForAreaChart();
        
    })
    stepButton.on('click',function(d){
          options.lineStyle = "step"
          cardinalButton.style('border',"0px solid #a0a0a0")
          linearButton.style('border',"0px solid #a0a0a0")
          stepButton.style('border',"1px solid #a0a0a0")
          
          area.interpolate(options.lineStyle) .x(function (d) { return x1(d['label']); }) .y0(height) .y1(function (d) { return y(+d["value"]); });
          
          areas.attr("d", function (d,i) { return area(d.Data)})
          
          resizedFuctionForAreaChart();
    })
    
    //------------------ Settings panel DIV and everything inside it section ends here ------------------
    
    var divLegendPanelForAreaChart = targetElement .append('div')  .attr("class","divLegendPanelClassForAreaChart") .style('background-color',options.BGcolor) .style('position',"absolute")
    .style('width', 25 + "%") .style('height', 92 + "%") .style("left",75 + "%").style("top",8 + "%")
    
    if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == true)){
        divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
        .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
        
        svgPanelForAreaChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
        .style("position","absolute");
    }
    else if ((showOrHideTableForAreaChart == true) && (showOrHideCommentsForAreaChart == false)){
        divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
        .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
        
        svgPanelForAreaChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
        .style("position","absolute");
    }
    else if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == false)){
        divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
        .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
        
        svgPanelForAreaChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
        .style("position","absolute");
    }
    
    // Creating ToolTip for options button.
    var iconButtonTooltipForAreaChart = targetElement.append('div').style('width','240px').attr("id","too")
    .style('height',"25px").style('position','absolute')//.style('margin-left', "0px").style('top','25px')
    .style("background-color",'#404040 ').style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid") // 004b9d
    .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none").attr("border", 0.0)
    
    lineButtonForAreaChart.on('mousemove', function(d,i) {
          var root = targetElement
          var m = d3.mouse(root.node());
          m[0] += 0
          m[1] += 0
          var filterButtonTooltipText = "Switch to Line Chart";
          iconButtonTooltipForAreaChart.style("width","126px").style("margin-left", (m[0] - 136) + "px").style("margin-top",(m[1]) + "px").style("display","block")
          iconButtonTooltipForAreaChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')
          
    })
    lineButtonForAreaChart.on('mouseout', function(d,i) {
          iconButtonTooltipForAreaChart.style("display","none")
    })

    filterButtonForAreaChart.on('mousemove', function(d,i) {
            var root = targetElement
            var m = d3.mouse(root.node());
            m[0] += 0
            m[1] += 0
            var filterButtonTooltipText = "Filter";
            iconButtonTooltipForAreaChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForAreaChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')
            
    })
    filterButtonForAreaChart.on('mouseout', function(d,i) {
            iconButtonTooltipForAreaChart.style("display","none")
    })

    refreshButtonForAreaChart.on('mousemove', function(d,i) {
             var root = targetElement
             var m = d3.mouse(root.node());
             m[0] += 0
             m[1] += 0
             var refreshButtonTooltipText = "Refresh";
             iconButtonTooltipForAreaChart.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
             iconButtonTooltipForAreaChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ refreshButtonTooltipText +'</div>')
             
    })
    refreshButtonForAreaChart.on('mouseout', function(d,i) {
             iconButtonTooltipForAreaChart.style("display","none")
    })

    commentsBtnForAreaChart.on('mousemove', function(d,i) {
           commentsPanelDivForAreaChart.style('background-color','#fafafa')
           var root = targetElement
           var m = d3.mouse(root.node());
           m[0] += 0
           m[1] += 0
           if(options.showComments == false){
           var commentButtonTooltipText = "Show Comments";
           }
           else if(options.showComments == true){
           var commentButtonTooltipText = "Hide Comments";
           }
           
           
           iconButtonTooltipForAreaChart.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
           iconButtonTooltipForAreaChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ commentButtonTooltipText +'</div>')
    })
    commentsBtnForAreaChart.on('mouseout', function(d,i) {
           commentsPanelDivForAreaChart.style('background-color','#ffffff')
           iconButtonTooltipForAreaChart.style("display","none")
    })

    menuButtonForAreaChart.on('mousemove', function(d,i) {
          var root = targetElement
          var m = d3.mouse(root.node());
          m[0] += 0
          m[1] += 0
          var menuButtonTooltipText = "Menu";
          iconButtonTooltipForAreaChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
          iconButtonTooltipForAreaChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ menuButtonTooltipText +'</div>')
          
    })
    menuButtonForAreaChart.on('mouseout', function(d,i) {
          iconButtonTooltipForAreaChart.style("display","none")
    })

    tableButtonForAreaChart.on('mousemove', function(d,i) {
           var root = targetElement
           var m = d3.mouse(root.node());
           m[0] += 0
           m[1] += 0
           if(showOrHideTableForAreaChart == false){
           var tableButtonTooltipText = "Show Table";
           }
           else if(showOrHideTableForAreaChart == true){
           var tableButtonTooltipText = "Hide Table";
           }
           iconButtonTooltipForAreaChart.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
           iconButtonTooltipForAreaChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ tableButtonTooltipText +'</div>')
           
    })
    tableButtonForAreaChart.on('mouseout', function(d,i) {
           iconButtonTooltipForAreaChart.style("display","none")
    })

    settingBtnForAreaChart.on('mousemove', function(d,i) {
          var root = targetElement
          var m = d3.mouse(root.node());
          m[0] += 0
          m[1] += 0
          var settingTooltipText = "Settings";
          iconButtonTooltipForAreaChart.style("width","67px").style("margin-left", (m[0] - 77) + "px").style("margin-top",(m[1]) + "px").style("display","block")
          iconButtonTooltipForAreaChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ settingTooltipText +'</div>')
    })
    settingBtnForAreaChart.on('mouseout', function(d,i) {
          iconButtonTooltipForAreaChart.style("display","none")
    })
    
    downloadBtnForAreaChart2.on('mousemove', function(d,i) {
          var root = targetElement
          var m = d3.mouse(root.node());
          m[0] += 0
          m[1] += 0
          var downloadButtonTooltipText = "Download";
          iconButtonTooltipForAreaChart.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
          iconButtonTooltipForAreaChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
    })
    downloadBtnForAreaChart2.on('mouseout', function(d,i) {
          iconButtonTooltipForAreaChart.style("display","none")
    })
        
    // ----------------- Filter panel and everything within it section begins here ----------------
    var filterPanelForAreaChart = targetElement.append('div') .style('width',350 + "px") .attr("class","filterPanelForLineChartClass" + targetElement[0][0].id)
    .style('position','absolute') .style('margin-left', "0px") .style("background-color",'#fefefe') .style("z-index",11)
    .style("border-color", "#ffffff").style("border-right", "solid #e5e5e5 1px")  .style("border-style", "solid") .style("box-shadow", "2px 0px 1px #eff8ec")
    .style("display","none").style("border-top", "solid #fdfdfd 1px").style("border-left","0px").style("border-bottom", "0px")
    .style('top', 0.0 + "%").style('height', 100 + "%").style('overflow-y',"hidden").style("overflow-x","hidden")
    .style("border-bottom", "solid #e5e5e5 1px") .style("box-sizing","border-box")
    
    var filterPanelForStkBarChartTitle = filterPanelForAreaChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
    .style('margin-left','0px').style('margin-top','20px').style('text-indent','5px').style("font-size", "14px").style('position',"absolute")
    .style("box-shadow", "1px 1px 1px #007aff").style("width","350px").style("color","#000000")
    .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; top:25.0%; font-size:16px; font-family:inter; color:#00001c;">'+ "Filter" +'</div>')
    
    var measuresColumnTitle = filterPanelForAreaChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
    .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '60px')
    .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; text-indent:3px;">Available Measures</div>');
    
    var measuresVariables = filterPanelForAreaChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable1"+targetElement[0][0].id)
    .style("list-style-type","none") .style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '78px')
    .style('position','absolute') .style("width","155px").style("min-height","190px").style("max-height","190px").style("border", "#f0f0f0 1px solid")
    .style("max-width","155px").style("overflow-x","hidden").style("overflow-y","auto")
    measuresVariables.style("left",0.0 + "px").style("padding","2px")
    
    $( ".filterPanelForLineChartClass" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
		var e0 = e.originalEvent,
		delta = e0.wheelDelta || -e0.detail;

		this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
		e.preventDefault();
    });
    
    
    var measuresArray = [];
    var dimensionArray = [];
    
    var measuresArrayLength = [];
    var dimensionsArrayLength = [];
    
    dimensionArray.push(options.keys.label);
    //measuresArray = options.keys.stackedBars;
    
    for(var i = 0; i<divAndChartsArray.length; i++){
        if(targetElement[0][0].id === divAndChartsArray[i].divID){
            
            if(newtargetElementAndOptionsArray[i].options.keys.areas == undefined){
                //measuresArray = newtargetElementAndOptionsArray[i].options.keys.lines;
                options.data.forEach(function(d, index) {
                     measuresArray.push(d[newtargetElementAndOptionsArray[i].options.keys.lines])
                });
            }
            else{
                //measuresArray = newtargetElementAndOptionsArray[i].options.keys.areas;
                options.data.forEach(function(d, index) {
                     measuresArray.push(d[newtargetElementAndOptionsArray[i].options.keys.areas])
                });
            }
        }
    }
    
    // filter process
    var uniqueMeasuresArrayKeys = [];
    $.each(measuresArray, function(i, el){
       if($.inArray(el, uniqueMeasuresArrayKeys) === -1){
           uniqueMeasuresArrayKeys.push(el);
       }
    });
    
    var uniqueDimensionArrayKeys = [];
    $.each(dimensionArray, function(i, el){
       if($.inArray(el, uniqueDimensionArrayKeys) === -1){
           uniqueDimensionArrayKeys.push(el);
       }
    });
    
    // setting lenght for arrays
    for(var i = 0; i<uniqueMeasuresArrayKeys.length; i++){
        measuresArrayLength.push(i);
    }
    
    for(var i = 0; i<uniqueDimensionArrayKeys.length; i++){
        dimensionsArrayLength.push(i);
    }
    
    var measuresVariables1 = measuresVariables.selectAll("li") .data(measuresArrayLength).enter().append("li")
    .style("width","130px") .style("max-height","22px").style("cursor","move")
    .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#bcf1bc").style("font-weight","Normal")
    .style("list-style-type","none").style("border","1px #89e789 solid").style("color","#006600").style("font-family","Verdana,sans-serif")
    .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
    .text(function(d) {return uniqueMeasuresArrayKeys[d]})
    measuresVariables1.attr("class","MeasuresClass"+targetElement[0][0].id)
    
    var measuresColumnReceivedUI_TableTitle = filterPanelForAreaChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
    .style('background-color',"#fefefe").style('margin-left','180px').style('margin-top', '60px')
    .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; ">Selected Measures</div>');
    
    var measuresColumnReceivedUI_Table = filterPanelForAreaChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable3"+targetElement[0][0].id)
    .style('background-color',"#ffffff").style('margin-left','180px').style('margin-top', '78px')
    .style("width","155px").style('position','absolute').style("padding","2px").style("min-height","190px")
    .style("border","1px #c1c1c1 dashed") .style("max-height","190px") .style("overflow-x","hidden") .style("overflow-y","auto")
    //.html('<div class=unsortable  style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:65.0%; font-size:14px; font-family:inter;  color:#99ea99; font-weight:Normal; text-align:center;">Drag and Drop Measures here from Available Measures List. </div>');
    .html('<img class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' src="images/dragIcon.png" style=" width:36px; height:36px; position:absolute; margin-left:65px; margin-top:60px; opacity:0.6"/>'
          + '<div class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:60.0%; font-size:12px; font-family:inter;  color:#89d289; font-weight:Normal; text-align:center;">Drop Measures here. </div>');
    //.html('<div style="background-image: url(images/dragIcon.png); height: 64px; width: 64px; border: 1px solid black;"> </div>');
    
    var cancelButton = filterPanelForAreaChart.append("div") .style("width","23px").style("height","21px").style('position','absolute')
    .style('margin-left','320px').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
    .style('background-color',"#FCFCFF")
    .style("border", "0.0px") .style("border-style", "solid").style('color','white')
    .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
    var cancelBtnImgVar = document.createElement("IMG");
    cancelBtnImgVar.src = "images/closeIcon.png";
    cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.9; background-color:#fcfcff")
    cancelButton[0][0].appendChild(cancelBtnImgVar)
    
    cancelButton.on("click", function(){
        filterPanelForAreaChart.style("display","none")
        
        if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == true)){
        divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
        .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
        
        svgPanelForAreaChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
        .style("position","absolute");
        }
        else if ((showOrHideTableForAreaChart == true) && (showOrHideCommentsForAreaChart == false)){
        divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
        .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
        
        svgPanelForAreaChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
        .style("position","absolute");
        }
        else if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == false)){
        divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
        .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
        
        svgPanelForAreaChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
        .style("position","absolute");
        }
    })
        
    var reRenderChartAndTableButton = filterPanelForAreaChart.append("button").style("width","120px").style("height","25px").style('position','absolute')
    .style('margin-left','112px').style('margin-top','298px') .style("border-style", "none").style('background-color',"#2196f3")
    .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','15px').style("border-style", "solid").style('color','#ffffff')
    .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 1px #9b9b9b").style("border-radius","0px")
    var textForReRenderButton = document.createTextNode("Apply Changes");
    reRenderChartAndTableButton[0][0].appendChild(textForReRenderButton)
    
    reRenderChartAndTableButton.on("click", function(){
                                   
           if( $("#sortable3"+targetElement[0][0].id).children("li").length == 0 )
           {
               
               var alertPageDisabledDivForAreaChart =targetElement.append('div').style('width',100 + '%')
               .style('height',100 + "%").style('position','absolute').style('margin-left', '0px').style('top', '0px')
               .style("background-color",'#f3f3f3').style("z-index",99)//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
               .style("opacity",0.2).style("display","block")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
               
               var alertDivForAreaChart = targetElement.append('div').style('width','350px')
               .style('height',"150px").style('position','absolute').style('left', ((targetElement[0][0].clientWidth/2) - 175) + "px").style('top', '1px')
               .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "solid").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
               .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","0px")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
               //.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Bold;">Sorry, no result found for selected' + 'range!'+ '</br>' + '<label style=text-indent:10px;> Hello</label' +'</div>')
               .html('<p  style="width: 340px; height:0%; background-color:#c7c7c7; position: absolute; top:40.0%; font-size:14px; font-family:inter; font-weight:Bold; margin-left:10px;  color:#f8f8f8; font-weight:Normal;">Check whether the Selected Measures box is not empty!</p>')
               
               var alertDivTitleForAreaChart = alertDivForAreaChart.append('div').style('width','340px')
               .style('height',"30px").style('position','absolute').style('margin-left', "0px").style('top', '0px')
               .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "none").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
               .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","2px")
               .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; font-weight:Bold; text-indent:5px;  color:#e5e5e5; font-weight:Normal;">TimeBound</div>')
               
               var areaChartAlertOKButton = alertDivForAreaChart.append("button") .style("width","40px") .style("height","20px") .style('position','absolute') .style("box-shadow", "0px 1px 1px #B8B8B8")
               .style('background-color',"#7cc15e") .style('margin-left','300px') .style('top', "120px").style("color","#ffffff")
               .style("display","block").style('padding-top',"0px").style("cursor","pointer").style("box-shadow", "1px 1px 1px #56973a") .style("border-style", "none")
               .style("font-family","Verdana,sans-serif").style("font-size","14px").style("text-align","center").style("vertical-align","middle").style("border-radius","0px")
               .style("z-index",999)
               
               var textForAreaChartAlertOKButton = document.createTextNode("OK");
               areaChartAlertOKButton[0][0].appendChild(textForAreaChartAlertOKButton)
               
               $("#"+targetElement[0][0].id).resizable('disable');
               
               areaChartAlertOKButton.on('click', function() {
                 alertDivForAreaChart.remove();
                 alertPageDisabledDivForAreaChart.remove()
                 $("#"+targetElement[0][0].id).resizable('enable');
                })
               
               filterButtonForAreaChart.style("cursor","pointer")
               
               if(showOrHideTableForAreaChart == false){
               svgPanelForAreaChart.style('width', 75 + "%") .style('height', 85 + "%").style("position","absolute")
               divLegendPanelForAreaChart.style('width', 25 + "%") .style('height', 85 + "%").style("position","absolute")
               }
               else if(showOrHideTableForAreaChart == true){
               svgPanelForAreaChart.style('width', 75 + "%") .style('height', 52 + "%").style("position","absolute")
               divLegendPanelForAreaChart.style('width', 25 + "%") .style('height', 52 + "%").style("position","absolute")
               }
               
               resizedFuctionForAreaChart();
           }
               
           else{
               
               var selectedLineMeasures = [];
               var newFilteredDataSetForAreaChart = [];
               for(var i=0; i<$("#sortable3"+targetElement[0][0].id).children("li").length;i++){
                   selectedLineMeasures.push($("#sortable3"+targetElement[0][0].id).children("li")[i].textContent)
                   options.data.forEach(function(d, index) {
                        if(d[options.keys.areas].toString().toLowerCase() === $("#sortable3"+targetElement[0][0].id).children("li")[i].textContent.toString().toLowerCase()){
                            newFilteredDataSetForAreaChart.push(d)
                        }
                   })
               }
               
               var newOptions = {
                    data: newFilteredDataSetForAreaChart,
                    dataForTable: options.dataForTable,
                    isDataDetailedForTable: options.isDataDetailedForTable,
                    keys: {
                        label: options.keys.label,
                        areas: options.keys.areas,
                    },
                    chartTitle:options.chartTitle,
                    xAxisLable: options.xAxisLable,
                    yAxisLable: "",
                    //dimensions: options.dimensions,
                    //measures: options.measures,
                    showTitle: true,
                    series:options.series,
                    legend:options.legend,
                    colorSet: options.colorSet,
                    lineStyle: options.lineStyle,
                    drillDownColumnName:options.drillDownColumnName,
                    showTable: options.showTable,
                    showComments: options.showComments,
                    comments: options.comments,
                    resizeButtonID: options.resizeButtonID //document.getElementById("resizeBtn").id
                }
               
               d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
               acinfotech.areaChart2(targetElement,newOptions)
           }
    })
    
    var textBoxForMeasureColumnFrom;
    var textBoxForMeasureColumnTo;
    var selectTitleDivForEachDimension;
    
    $( "ul.droptrue"+targetElement[0][0].id ).sortable({
           appendTo: document.body,
           helper: "clone",
           connectWith: ".droptrue"+targetElement[0][0].id,
           scroll: false,
           cancel: '.unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+','+' .unMoveableIconAndTextClassDimensions'+targetElement[0][0].id,
           revertDuration: 10,
           scrollSensitivity: 10,
           scrollSpeed: 1,
           dynamic: true,
           
           receive: function(e, ui) {
           
               if (($(this)[0].id == "sortable3"+targetElement[0][0].id) || ($(this)[0].id == "sortable1"+targetElement[0][0].id)) {
               
               if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
               if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
               (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
               }
               else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
               (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
               }
               
               }
               } // if (($(this)[0].id == "sortable3") || ($(this)[0].id == "sortable1"))
               
               else if (($(this)[0].id == "sortable2"+targetElement[0][0].id) || ($(this)[0].id == "sortable4"+targetElement[0][0].id)) {
               if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
               //ui.sender.sortable("cancel");
               
               if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
               (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
               }
               else if(  ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
               (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
               }
               }
               } //if (($(this)[0].id == "sortable2") || ($(this)[0].id == "sortable4")) {
               
               $(ui.item).css({ 'position': 'relative' });
               
               if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
               ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
               }
               
               else if ($(this)[0].id == "sortable3"+targetElement[0][0].id) { // checking if the dropped element is in Measures drop area
               
               if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
               ui.sender.sortable("cancel");
               }
               else {
               //ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
               }
               
               } // else if ($(this)[0].id == "sortable3") // checking if the dropped element is in Measures drop area ends here.
               
               else if ($(this)[0].id == "sortable4"+targetElement[0][0].id) { // checking if the dropped element is in Dimension drop area
               
               if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
               ui.sender.sortable("cancel");
               }
               else {
               ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
               }
               } //else if ($(this)[0].id == "sortable4")  // checking if the dropped element is in Dimension drop area ends here
               
               if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
               
               if ($(this)[0].id == "sortable1"+targetElement[0][0].id){
               if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
               
               if( ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
               ui.sender.sortable("cancel");
               } // if(  ui.sender.attr("id") === "sortable4")
               
               else if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
               ui.sender.sortable("cancel");
               }
               
               } // if(ui.item.hasClass("DimesionsClass"))
               }
               if ($(this)[0].id == "sortable2"+targetElement[0][0].id){
               if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
               
               if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
               ui.sender.sortable("cancel");
               }
               else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
               ui.sender.sortable("cancel");
               
               }
               }
               }
               
               } //if ($(this)[0].id == "sortable1")
               
               if ($(this)[0].id == "sortable4"+targetElement[0][0].id){
               if ($(this).children('li').length > 1 ){
               ui.sender.sortable("cancel");
               ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
               }
               }
           
           }, //receive ends here
           
           start:function(ev, ui) {
           
           },
           stop:function(ev, ui) {
           
           },
       });
    
    // ----------------- Filter panel and everything within it section ends here -----------------
    
        lineButtonForAreaChart.on('click', function() {
              
              d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
              var newOptions = {
              data: options.data,
              dataForTable: options.dataForTable,
              isDataDetailedForTable: options.isDataDetailedForTable,
              keys: {
                    label: options.keys.label,
                    lines: options.keys.areas,
              },
              chartTitle:options.chartTitle,
              xAxisLable:options.xAxisLable,
              yAxisLable:"",
              showTitle:options.showTitle,
              series:options.series,
              legend:options.legend,
              colorSet: options.colorSet,
              lineStyle: options.lineStyle,
              drillDownColumnName:options.drillDownColumnName,
              showTable: false,
              showComments: options.showComments,
              comments: options.comments,
              resizeButtonID: options.resizeButtonID
              }
              
              for(var i = 0; i<divAndChartsArray.length; i++){
              
                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    newOptions.keys.lines = newtargetElementAndOptionsArray[i].options.keys.areas;
                    newtargetElementAndOptionsArray[i].options.keys = newOptions.keys;
                }
              }
              
              acinfotech.lineChart2(targetElement, newOptions)
              
        })

        filterButtonForAreaChart.on('click', function() {
                
                filterPanelForAreaChart.style("display","block");
                
                ismenuBtnOfAreaChartClicked = false;
                optsBtnPanelForAreaChart.style("display","none");
                
                stgPanDivForAreaChart.style("display","none");
                
                if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == true)){
                divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                
                svgPanelForAreaChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute");
                }
                else if ((showOrHideTableForAreaChart == true) && (showOrHideCommentsForAreaChart == false)){
                divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                
                svgPanelForAreaChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute");
                }
                else if ((showOrHideTableForAreaChart == false) && (showOrHideCommentsForAreaChart == false)){
                divLegendPanelForAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                
                svgPanelForAreaChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute");
                }
                
                resizedFuctionForAreaChart();
                
        })

        // Refreshing Chart and Table
        refreshButtonForAreaChart.on('click', function() {
                 
             //isFilterClicked = false
             d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
             
             for(var i = 0; i<divAndChartsArray.length; i++){
             
                 if(targetElement[0][0].id === divAndChartsArray[i].divID){
                     options.data = divAndChartsArray[i].optionsData;
                     //options.keys.areas = newtargetElementAndOptionsArray[i].options.keys.areas;
                     if(newtargetElementAndOptionsArray[i].options.keys.areas == undefined){
                         options.keys.areas = newtargetElementAndOptionsArray[i].options.keys.lines;
                     }
                     else{
                         options.keys.areas = newtargetElementAndOptionsArray[i].options.keys.areas;
                     }
                 }
             }
             acinfotech.areaChart2(targetElement,options)
                 
        })

        // showing/hidding chart comments
        commentsBtnForAreaChart.on('click', function() {
               
               if(options.showComments == false){ 
                   options.showComments = true;
               }
               else if(options.showComments == true){ 
                   options.showComments = false;
               }
               
               d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
               
               for(var i = 0; i<divAndChartsArray.length; i++){
               
                   if(targetElement[0][0].id === divAndChartsArray[i].divID){
                       options.data = options.data; //divAndChartsArray[i].optionsData
                       options.showTable = false;
                   }
               }
               acinfotech.areaChart2(targetElement,options)
               
        })
    
    // showing/hidding chart table
    tableButtonForAreaChart.on('click', function() {
       
       if(showOrHideTableForAreaChart == false){
           options.showTable = true;
           //showOrHideTableForPieChart = true
       }
       else if(showOrHideTableForAreaChart == true){
           //showOrHideTableForPieChart = false
           options.showTable = false;
       }
       
       d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
       
       for(var i = 0; i<divAndChartsArray.length; i++){
       
           if(targetElement[0][0].id === divAndChartsArray[i].divID){
               options.data = options.data; //divAndChartsArray[i].optionsData
               options.showComments = false;
           }
       }
       acinfotech.areaChart2(targetElement,options)
                               
   })
    
    
    settingBtnForAreaChart.on('click', function() {
                              
		ismenuBtnOfAreaChartClicked = false; // Menu toggle button variable
		optsBtnPanelForAreaChart.style("display","none") // To hide options button panel

		iconButtonTooltipForAreaChart.style("display","none") // Removing options button ToolTip
		settingBtnForAreaChart.style("cursor","pointer")

		stgPanDivForAreaChart.style("display","block") // Showing settings panel

		svgPanelForAreaChart.style('width', 75 + "%") .style('height', 52 + "%").style("position","absolute"); // Decreasing chart panel
		divLegendPanelForAreaChart.style('width', 25 + "%") .style('height', 52 + "%").style("position","absolute"); // Decreasing chart panel

		resizedFuctionForAreaChart(); // Calling resize function()
                              
    })
    
    downloadBtnForAreaChart2.on('click', function() {
                              
		ismenuBtnOfAreaChartClicked = false; // Changing menu button value to false
		optsBtnPanelForAreaChart.style("display","none") // Hiding option buttons panel
                              
    })
    
    var x = d3.scale.ordinal().domain(options.keys.label.map(function(d,i) { return d;})).rangePoints([0, width],0.65);
    
    var x1 = d3.scale.ordinal() .domain(options.keys.label.map(function(d) { return d; })) .rangePoints([0, width], 0.65);
    
    var maxArray = [];
    for (i = 0; i < options.data.length; i++) {
        
        var max = d3.max(mainArray[i].data, function(d) {
                         return +d;
                         })
        
        maxArray.push(max)
    }
    
    var finalNewNewArray = [];
    var dataArray1 = [];
    mainArray.forEach(function(d, i) {
                      
          var temp1 = {};
          temp1["line"] = d["line"]
          
          
          for (j = 0; j < options.keys.label.length; j++) {
          
          var tempTemp = {};
          tempTemp["label"] = options.keys.label[j];
          tempTemp["value"] = d.data[j];
          
          dataArray1.push(tempTemp)
          }
          
          temp1["Data"] = dataArray1;
          dataArray1 = []
          finalNewNewArray.push(temp1)
                      
    })
    
    var finallyMaxValue = d3.max(maxArray, function(d) { return +d; })
    
    var y = d3.scale.linear() .domain([0, d3.max(maxArray, function(d) { return +d; })] ) .range([height, 0]);
    
    var color = d3.scale.category10();
    
    var xAxis = d3.svg.axis() .scale(x) .orient("bottom");
    
    var yAxis = d3.svg.axis() .scale(y) .ticks(5) .orient("left");
    
    var hasDecimalPoint = false;
    for(var i = 0; i < options.keys.label.length; i++){
        for(var j = 0; j < options.data.length; j++){
            if(options.data[j][options.keys.label[i]].toString().indexOf('.') > -1){ hasDecimalPoint = true; break; }
        }
    }
    if(hasDecimalPoint == false){ yAxis.tickFormat(d3.format(".2s")) }
        
    var svg = svgPanelForAreaChart.append("svg") .append("g") .attr("width", width + margin.left + margin.right) .attr("height", height + margin.top + margin.bottom)
    .attr("transform", "translate(" + margin.left + "," + margin.top + ")")
    let key=options.xAxisLable;
                    let array=options.data.map(value => value[key]);
                    let ArrayValue=[];
                    var RotateValue;
                    for(let i=0;i<array.length;i++){
                            ArrayValue[i]=array[i].length;
                    }
                    const numberGreaterThanLimit = ArrayValue.filter((v) => v > 5);
                
    var xAxisLineAndMarginLabels = svg.append("g") .attr("class", "x axis") .attr("transform", "translate(0," + height + ")") .call(xAxis)
    
    // Add the X Axis margin labels
    .selectAll("text") .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') .attr("transform", function(d)
    {
        if(numberGreaterThanLimit.length>0){return "rotate(-45)"}
        else{
        return "rotate(0)" }})
    .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
    .text(function(d,i) {
          if(d.length > 9)
          return d.substring(0,9)+'...';
          else
          return d;
          })
    
    svg.append("g") .attr("class", "y axis") .call(yAxis) .selectAll("text") .style('fill','#00001c') .style("font-family","Verdana,sans-serif")
    
    //color.domain(options.keys.areas.map(function (d) { return d; }));
    
    var minX = d3.min(finalNewNewArray, function (kv) { return d3.min(kv.Data, function (d) { return +d.value; }) });
    var maxX = d3.max(finalNewNewArray, function (kv) { return d3.max(kv.Data, function (d) { return +d.value; }) });
    var minY = d3.min(finalNewNewArray, function (kv) { return d3.min(kv.Data, function (d) { return +d.value; }) });
    var maxY = d3.max(finalNewNewArray, function (kv) { return d3.max(kv.Data, function (d) { return +d.value; }) });
    
    x.domain([minX, maxX]);
    y.domain([minY, maxY]);
    // Creating line data
    var area = d3.svg.area() .interpolate(options.lineStyle) .x(function (d) { return x1(d['label']); }) .y0(height)
    .y1(function (d) { return y(+d["value"]); });
    
    // Creating lines
    var areas = svg.selectAll("area") .data(finalNewNewArray) .enter() .append("g") .append("path") .attr("class", "area")
    .attr("d", function (d,i) { return area(d.Data); }) .style("stroke", function (d,i) { return colorscale(i); })
    .style("stroke-width",1.0) .style("fill", function (d,i) { return colorscale(i); }) .style("stroke-linecap", "butt")
    
    //------------------ creating legend -----------------
        
    var legendPanelSvgForAreaChart = divLegendPanelForAreaChart .append('svg')  .attr("class","") .style("background-color", options.BGcolor) .style('position',"absolute")
    .style('width', 100 + "%") .style('height', 100 + "%") .style("left",0 + "%").style("top",0 + "%")
        
    var legend = legendPanelSvgForAreaChart.append("g") .attr("class", "legend") .attr("height", "100%") .attr("width", "100%")
    .attr('transform', 'translate(0,20)')
    
    //Create colour circles
    legend.selectAll('rect') .data(options.data) .enter() .append("rect") .attr("x", 5) .attr("y", function(d, i){ return i * 16;})
    .attr("width", 14) .attr("height", 14) .attr("rx",10) .attr("ry",10) .style("fill", function(d, i){ return colorscale(i);})
    .style("cursor","auto")
    
    //Create text next to circles
    legend.selectAll('text') .data(options.data) .enter() .append("text") .attr("x", 25) .attr("y", function(d, i){ return i * 16 + 11.7;})
    .text(function(d,i) { if(d[options.keys.areas].length > 10)
        return d[options.keys.areas].substring(0,10)+'...';
        else
        return d[options.keys.areas];}) .style('font-size', '14px') .attr("fill","#00001c") .style("font-family","Verdana,sans-serif")
    
    // Aligning Legend (vertically)
    var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelForAreaChart[0][0].style.width) / 100)
    var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelForAreaChart[0][0].style.height) / 100)
    
    var legendRectSize = 11;
    var legendSpacing = 6;
    
    legend.attr('transform', function(d, i) {
        var eachRectHeight = legendRectSize + legendSpacing;
        var offset =  eachRectHeight * colorscale.domain().length / 2;
        var horz = 5;
        var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.data.length))/2.0; // originally 2.0
        
        return 'translate(' + horz + ',' + vert + ')';
    })
    
    // Adding the text label for the X axis
    var xAxisVariable =  svg.append("text") .attr("transform", "translate(" + ((width/2) - 0) + " ," + (height+margin.bottom - 2) + ")")
    .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif") .style("font-weight","Bold") .style("font-size","12px") .text(options.xAxisLable) .style('fill','#00001c')
    .style("text-transform","capitalize") .style("font-style","normal")
    
    legend.selectAll('rect').on('mouseover',function(d,i){
        d3.select(areas[0][i]).style('stroke-width',2.5)
        
        var lineLen = areas.node().getTotalLength();
        var dashLen = options.data.length;
        var ddLen = dashLen ;
        var darray = dashLen;
        while(ddLen < lineLen){
        darray+=","+dashLen+","+dashLen;
        ddLen+=dashLen;
        }
        
        d3.select(areas[0][i]).attr("stroke-linecap", "round").attr("stroke-dasharray", darray + ","+lineLen) .attr("stroke-dashoffset", lineLen)
        .transition().duration(8000).ease("linear").attr("stroke-dashoffset", 0)//.style('fill-opacity',0.78)
    })
    
    legend.selectAll('rect').on('mouseout',function(d,i){
                                
        d3.select(areas[0][i]).style('stroke-width',1.0).transition().duration(0)
        d3.select(areas[0][i]).attr("stroke-dasharray", options.data.length + ","+ 0)  .attr("stroke-dashoffset", 0)
    })
    
    var tooltipForAreaChart = targetElement .append('div') .attr('class', 'tooltipPie') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
    .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
    .style("padding-right", "7px") .style("background", "#F8F8F8") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style("z-index",1000)
    .style("border", "1.0px") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","60px")
    tooltipForAreaChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'label').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "14px") .style("font-weight", "normal");
    tooltipForAreaChart.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
    tooltipForAreaChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");
    
    
    var tableDivForAreaChart = targetElement .append('div')
    .attr("class","scrollingDivForTable-Class tableDivForAreaChart" + targetElement[0][0].id) .style('background-color',"#ffffff") .style("position","absolute")
    .style("display","block") .style("overflow","hidden") //.style("border-right","1px solid #e2e2e2").style("border-bottom","1px solid #e2e2e2")
    
    $( '.tableDivForAreaChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
          var e0 = e.originalEvent,
          delta = e0.wheelDelta || -e0.detail;
          
          this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
          e.preventDefault();
    });
    
    if(options.showTitle == true){
        tableDivForAreaChart.style("width", 100 + "%") .style("height", 40 + "%") .style("top",60 + "%")
        
    }
    else if(options.showTitle == false){
        tableDivForAreaChart.style("width", 100 + "%") .style("height", 40 + "%") .style("top",60 + "%")
    }
    
    tableDivForAreaChart.html('<table class = "tableClassForAreaChart2' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                              '<thead class = "theadClassForAreaChart2' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForAreaChart2' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                              '<tbody class = "tBodyClassForAreaChart2' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                              '</table>'
                              )
    
    tableDivForAreaChart.select('table').attr("id",targetElement[0][0].id + "tableID")
    
    // Show or Hide Table scroll when mouseover on widget
    targetElement.on('mouseover',function(d){ tableDivForAreaChart.style("overflow","auto") })
    targetElement.on('mouseout',function(d){ tableDivForAreaChart.style("overflow","hidden") })
    
    var tableDataForAreaChart2 = [];
    if(options.dataForTable.length > 0){
        tableDataForAreaChart2 = options.dataForTable;
    }
    else {
        tableDataForAreaChart2 = options.data;
    }
    
    var thead = tableDivForAreaChart.select("thead").selectAll("th") .data(d3.keys(tableDataForAreaChart2[0]))
    .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
    
    var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#fefdfd")//f6f6f6
    .style("position","relative").style("top","2px")
    
    var thead1 = d3.select(".thead1ClassForAreaChart2" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tableDataForAreaChart2[0]))
    .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
    
    var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#fefdfd")//f6f6f6
    .style("position","relative").style("top","2px")
    
    var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
    .attr("id", "ascendingIconIDForAreaChart") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
    
    var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
    .attr("id", "descendingIconIDForAreaChart") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
    
    var tr = tableDivForAreaChart.select("tbody").selectAll("tr") .data(tableDataForAreaChart2).enter().append("tr")
    .attr("id", function(d,i) { return "slice" + i })
    
    // cells
    var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter() .append("td") .text(function(d) { return d})
    .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
    
    var $table = $('.tableClassForAreaChart2' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
    
    d3.select(".theadClassForAreaChart2" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
        d.forEach(function(dd,j){
            colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
        })
    })
    
    $(".thead1ClassForAreaChart2" + targetElement[0][0].id).insertAfter('.tBodyClassForAreaChart2' + targetElement[0][0].id)
    
    $(".thead1ClassForAreaChart2" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForAreaChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
    
    tableDivForAreaChart.select(".thead1ClassForAreaChart2" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
             d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
     })
    
    $('.tableDivForAreaChart' + targetElement[0][0].id).scroll(function () {
                                                               
           $(".thead1ClassForAreaChart2" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForAreaChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
           
           })
    
    var sortOrder = false;
    thead1.on("click",function(k,index){
             
         sortOrder = !sortOrder;
         
         tableDivForAreaChart.select(".thead1ClassForAreaChart2" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                                                   
               if (sortOrder) {
               
                   if(i == index){
                       d3.select(this).select('svg').select('#descendingIconIDForAreaChart').style("visibility", "hidden")
                       d3.select(this).select('svg').select('#ascendingIconIDForAreaChart').style("visibility", "visible")
                   }
                   else {
                       d3.select(this).select('svg').select('#descendingIconIDForAreaChart').style("visibility", "visible")
                       d3.select(this).select('svg').select('#ascendingIconIDForAreaChart').style("visibility", "visible")
                   }
               }
               else{
               
                   if(i == index){
                       d3.select(this).select('svg').select('#descendingIconIDForAreaChart').style("visibility", "visible")
                       d3.select(this).select('svg').select('#ascendingIconIDForAreaChart').style("visibility", "hidden")
                   }
                   else {
                       d3.select(this).select('svg').select('#descendingIconIDForAreaChart').style("visibility", "visible")
                       d3.select(this).select('svg').select('#ascendingIconIDForAreaChart').style("visibility", "visible")
                   }
               }
            })
          
          var monthTruOrFalAryForAreaChart2 = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
          
          tr.sort(function(a, b) {
                  
                  if (sortOrder) {
                  var monthsArrayForAreaChart2 = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                  } else {
                  var monthsArrayForAreaChart2 = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                  }
                  
                  monthTruOrFalAryForAreaChart2 = []; gotMonthArray = [];
                  tableDataForAreaChart2.forEach(function(d,i){
                         var da = d[k].toString().substring(0,3).toLowerCase()
                         if(monthsArrayForAreaChart2.indexOf(da) >= 0){
                             monthTruOrFalAryForAreaChart2.push(true)
                             gotMonthArray.push(da);
                         }
                         else {
                             monthTruOrFalAryForAreaChart2.push(false)
                         }
                  })
                  
                  if(monthTruOrFalAryForAreaChart2.indexOf(false) == -1){ // true
                  
                  monthArray = []; monthArrayCount = [];
                  gotMonthArray.forEach(function(dd,j){
                        var index1 = monthsArrayForAreaChart2.indexOf(dd.substring(0,3))
                        if(monthArrayCount.indexOf(index1) >= 0){
                            index1 = 12 + index1;
                        }
                        monthArray.push(index1);
                        monthArrayCount.push(index1)
                  })
                  returnArray = []
                  monthArray.sort(function(aa, bb) {
                      returnArray.push(+aa - +bb)
                      return +aa - +bb;
                  })
                  
                  sortTableFunc()
                  return returnArray[ind++];
                  } //  if true (if jan feb if block)
                  else {
                  var data = +a[k];
                  
                  if(!isNaN(data)){
                  
                  if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                  else { return d3.descending(+a[k], +b[k]); }
                  }
                  else if(!isNaN(Date.parse(a[k]))){
                  
                  if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                  else { return new Date(b[k]) - new Date(a[k]) }
                  }
                  else {
                  
                  if (sortOrder) { return d3.ascending(a[k], b[k]); }
                  else { return d3.descending(a[k], b[k]); }
                  }
                  } // if not jan feb else block
        }); // tr

    })

    function sortTableFunc(){
        
        var table = tableDivForAreaChart.select('table');
        var rows = table.selectAll('tr').data(tableDataForAreaChart2);
        var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
        cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0).style("color","#00001c");
        
        cells.text(function(d,i) {return d});
        
        // Cells exit selection
        cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
        
        var cells_in_new_rows = rows.enter().append('tr')
        .selectAll('td') .data(function(d){ return d3.values(d)})
        
        cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500) .style('opacity', 1.0).style("color","#00001c");
        
        cells_in_new_rows.text(function(d,i) {return d});
        
        rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
    }
    
    // Main Table Styling
    tableDivForAreaChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
    .style("color","#00001c")
    .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4") //.style("box-shadow","10px 10px 50px #007aff").style("z-index",9999)
    tableDivForAreaChart.selectAll('td').style("height","25px") .style("border", "1px solid #ffffff") .style("font-size","12px").style("font-weight","Normal") .style("color","#00001c")
    
    //additionally
    tableDivForAreaChart.selectAll('th').style('background-color',"#ffffff").style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
    tableDivForAreaChart.selectAll('td').style("border-style","none").style("color","#00001c")
    //tablePanelForPieChart.selectAll('td').style("height","25px") .style("border", "1px solid #fcfcfc") .style("font-size","12px").style("font-weight","Normal")
    
    //b1da9f
    tableDivForAreaChart.selectAll('table') . style("border-collapse","collapse")
    tableDivForAreaChart.selectAll('table tr:first-child th').style("border-top","0px")
    tableDivForAreaChart.selectAll('table tr:last-child td').style("border-bottom","0px")
    tableDivForAreaChart.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
    tableDivForAreaChart.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")
    
    if(showOrHideTableForAreaChart == false){
        tableDivForAreaChart.style("display","none")
    }
    else if(showOrHideTableForAreaChart == true){
        tableDivForAreaChart.style("display","block")
    }
    
    if(options.isDataDetailedForTable == false){
    
        var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
    
        // Adding underlines for selected drill-down column text
        var drillDownSectionsForAreaChart = tableDivForAreaChart.select('table').selectAll('th')
    
        var foundResult = [];
        for(var i = 0; i<drillDownSectionsForAreaChart[0].length; i++){
        
            for(var j = 0; j<drillDownColumnNamesArray.length; j++){
                if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForAreaChart[0][i].__data__.toString().toLowerCase() ){
                    foundResult.push(i)
                }
            }
        }
    
        var r = tableDivForAreaChart.select('table').selectAll('tr').selectAll('td')
        for(var i = 0; i<r.length; i++){
            for(var j = 0; j < foundResult.length; j++){
                var row = r[i][foundResult[j]]
                $(row).css("text-decoration", "underline")
            }
        }
    }
    
    resizedFuctionForAreaChart();
    
	window.addEventListener('resize', function(event){ resizedFuctionForAreaChart() });
    
    $(function() {
      
      $("#" + targetElement[0][0].id).resizable({
                                         
            resize: function(event, ui) {
                                         
                divWidth = ui.size.width;
                divHeight = ui.size.height;
                resizedFuctionForAreaChart();
            }
        });
      });
    
    function resizedFuctionForAreaChart()
    {
        
        if((svgPanelForAreaChart.node().getBoundingClientRect().width) && (svgPanelForAreaChart.node().getBoundingClientRect().height) > 0){
            
            if(showOrHideCommentsBtnForAreaChart == true){
                lineButtonForAreaChart.style('margin-left', "2px")
                filterButtonForAreaChart.style('margin-left', "2px")
                refreshButtonForAreaChart.style('margin-left', "2px")
                commentsBtnForAreaChart.style('margin-left', "2px")
                menuButtonForAreaChart.style('right', '0')
            }
            else if(showOrHideCommentsBtnForAreaChart == false){
                lineButtonForAreaChart.style('margin-left', "2px")
                filterButtonForAreaChart.style('margin-left', "2px")
                refreshButtonForAreaChart.style('margin-left', "2px")
                //commentsBtnForAreaChart.style('right', '0')
                commentsBtnForAreaChart.style('display','none')
                menuButtonForAreaChart.style('right', '0')
            }
            
            optsBtnPanelForAreaChart.style('right', '0')
            
            stgPanCanBtnForAreaChart.style('right', '0') // setting panel cancel button.
            
            var margin1 = {top: 30 , right: 10, bottom: 80, left: 50}, //originally top: 42, left: 80
            width1 = (svgPanelForAreaChart.node().getBoundingClientRect().width) - margin1.left - margin1.right,
            height1 = (svgPanelForAreaChart.node().getBoundingClientRect().height) - margin1.top - margin1.bottom;
            // width1 = ($('#svgPanelIDForLineChart' + targetElement[0][0].id)[0].getBoundingClientRect().width) - margin1.left - margin1.right,
            // height1 = ($('#svgPanelIDForLineChart' + targetElement[0][0].id)[0].getBoundingClientRect().height) - margin1.top - margin1.bottom;
            
            x.domain(options.keys.label.map(function(d,i) { return d;})).rangePoints([0, width1],0.65);
            
            x1.domain(options.keys.label.map(function(d) { return d; })) .rangePoints([0, width1], 0.65);
            
            var yy = d3.scale.linear().domain([0, d3.max(maxArray, function(d) { return +d; })] ).range([height1, 0]);
            
            yAxis.scale(yy) .orient("left");
            
            xAxis.scale(x) .orient("bottom")
            
            area.x(function (d) { return x(d['label']); }).y0(height1) .y1(function (d) { return yy(+d["value"]); });
            
            var svg1 = svg;
            
            svg1.select("svg") .attr("width", width1 + margin1.left + margin1.right) .attr("height", height1 + margin1.top + margin1.bottom)
            
            svg1.select(".y.axis") .call(yAxis)
            
            svg1.select(".x.axis") .attr("transform", "translate(0," + height1 + ")") .call(xAxis)
            
            // Add the X Axis margin labels
            .selectAll("text") .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') .attr("transform", function(d)
            { 
                if(numberGreaterThanLimit.length>0){return "rotate(-45)"}
            else{
            return "rotate(0)" }})
            .text(function(d,i) {
                if(d.length > 9)
                return d.substring(0,9)+'...';
                else
                return d;
                })
            
            xAxisVariable.attr("transform", "translate(" + ((width1/2) - 0) + " ," + (height1+margin1.bottom - 2) + ")")
            
            // svg1.selectAll("circle") .transition() .delay(function (d, i) { return i / options.data.length * 50; }) .duration(900).ease("bounce")
            // .attr("cx", function(d,i) {  return x1(d['label']); }) .attr("cy", function(d,i) {  return yy(+d["value"]); })
            
            svg1.selectAll(".area").attr("d", function (d,i) { return area(d.Data); })
            
            // Aligning Legend (vertically)
            var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelForAreaChart[0][0].style.width) / 100)
            var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelForAreaChart[0][0].style.height) / 100)
            
            var legendRectSize = 11;
            var legendSpacing = 6;
            
            legend.attr('transform', function(d, i) {
                var eachRectHeight = legendRectSize + legendSpacing;
                var offset =  eachRectHeight * colorscale.domain().length / 2;
                var horz = 5;
                var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.data.length))/2.0; // originally 2.0
                
                return 'translate(' + horz + ',' + vert + ')';
            })
           
            colWidth = [];
			
            d3.select(".theadClassForAreaChart2" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                    d.forEach(function(dd,j){
                        colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                    })
            })
            tableDivForAreaChart.select(".thead1ClassForAreaChart2" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
            })

            
        } // checking svg panel width & height is greater than zero
    }
    }, //areaChart2

    // ************************************************** Dot Gauge **************************************************
    dotGauge: function(targetElement,options) {
    
        targetElement.style("min-width","350px").style("min-height","350px").style("background-color",options.BGcolor)
        
        var chartTitlePanelForDotGauge =  targetElement.append("div").style('position',"absolute").style("background-color",options.BGcolor).style("text-indent","6px")
        .style("border-bottom", "1px solid #f8f8f8").style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 20 + "px"; })
        .html('<div  style="width: 100%; height:0%;position: absolute; top:2.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')
        
        var svgPanelForDotChart = targetElement
        .append("svg") .attr("width", 200 + "px").attr("height", 200 + "px") .style("left","0px") .style("top","20px")
        .style("position","absolute").style("background-color",options.BGcolor)
        
        var width = (svgPanelForDotChart.node().getBoundingClientRect().width)
        height = (svgPanelForDotChart.node().getBoundingClientRect().height) ;
        
        var color;
        if(options.data <= 25){ color = "#D43838" }
        else if(options.data > 25 && options.data <= 50){ color = "#FF9900" }
        else if(options.data > 50 && options.data <=75){ color = "#00CC33" }
        else if(options.data > 75){ color = "#00CC33" }
        
        var xCount = 0, lineCount = height - 20, iCount = 0;
        for(var i = 1; i <= options.data; i++){
            if(iCount == 10){
                iCount = 0; lineCount = lineCount - 20; xCount = 0;
            }
            svgPanelForDotChart .append("rect") .style("position","absolute").attr("width", 20)  .attr("height", 20) .attr("x", function (d,i) {  return xCount;  })
            .attr("y", function (d) { return  lineCount;}) .attr("stroke-width", 0.0) .style("stroke-opacity",0.4) .style("stroke",function(d,i){  return color;  })
            .attr("fill",function(d,i){  return color;  }) .style("fill-opacity",0.6) .style("cursor","default")
            
            iCount += 1; xCount += 20;
        }
        
        // Adding the text label for the X axis
        var valueText =  svgPanelForDotChart.append("text") .attr("transform", "translate(" + ((width/2)) + " ," + (height/1.8) + ")")
        .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif") .style("font-weight","Bold") .style("font-size","40px")
        .text(options.data + "%") .style('fill','#303030')
    
    }, //dotGauge

    // ************************************************** Bubble Chart 2  **************************************************
    bubbleChart2: function(targetElement, options){
    
    isChartCalled++;
    
    var chartName = "BUBBLECHART2";
    
    acinfotech.allCharts(targetElement,options,chartName);
    
    var newJson = [];
    options.data.forEach(function(d, i) {
         var temp = {};
         
         for(var i = 0; i < Object.keys(d).length; i++) {
         delete d['enabled'];
         temp[Object.keys(d)[i]] = d[Object.keys(d)[i]]
         }
         
         newJson.push(temp)
     });
    
    targetElement.style("min-width","350px").style("min-height","350px").style("background-color",options.BGcolor)
    
    var showOrHideTableForBubbleChart2;
    var showOrHideCommentsForBubbleChart2;
    var showOrHideCommentsBtnForBubbleChart2 = true;
    
    if((options.showTable == false) || (options.showTable == true)){
        showOrHideTableForBubbleChart2 = options.showTable
    }
    else{
        showOrHideTableForBubbleChart2 = false;
    }
    
    // Show or Hide comments
    if (options.showComments == true || false) {
        showOrHideCommentsForBubbleChart2 = options.showComments;
    }
    else {
        showOrHideCommentsForBubbleChart2 = false;
    }
    
    if (options.comments.length == 0){
        showOrHideCommentsForBubbleChart2 = false;
        showOrHideCommentsBtnForBubbleChart2 = false;
    }
    
    if ((showOrHideTableForBubbleChart2 == true) && (showOrHideCommentsForBubbleChart2 == true)){
        showOrHideTableForBubbleChart2 = true;
        showOrHideCommentsForBubbleChart2 = false;
    }
    else if ((showOrHideTableForBubbleChart2 == false) && (showOrHideCommentsForBubbleChart2 == false)){
        showOrHideTableForBubbleChart2 = false;
        showOrHideCommentsForBubbleChart2 = false;
    }
    
    var chartTitlePanelForBubbleChart2 =  targetElement.append("div") .style("position","absolute").style("background-color",options.BGcolor).style("text-indent","6px") .style("border", "none")
    
	var optionsBtnPanelForBubbleChart2 = targetElement.append('div').style('width',"25px") .style('height', "180px")
    .style('position','absolute').style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px")
    .style('right', '0') .style("min-width","25px") .style("border-style","none")
    .style("border-left", "solid #fcfcfc  1px")
	
    var treeMapBtnForBubbleChart = optionsBtnPanelForBubbleChart2.append("div") .style("width","20px").style("height","20px").style('position','absolute')
    .style('background-color',"#ffffff").style("z-index",10)
    .style('top','1px') .style("cursor","pointer").style("display","block")
    .style('padding',"80px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
    var treeMapBtnImgVar = document.createElement("IMG");
    treeMapBtnImgVar.src = "images/squareBubbleIcon.png";
    treeMapBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.75;")
    treeMapBtnForBubbleChart[0][0].appendChild(treeMapBtnImgVar)
        
    var filterButtonForBubbleChart2 = optionsBtnPanelForBubbleChart2.append("div") .style("width","20px").style("height","20px").style('position','absolute')
    .style('background-color',"#ffffff").style("z-index",10)
    .style('top','1px') .style("cursor","pointer").style("display","block")
    .style('padding',"105px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
    var filterBtnImgVar = document.createElement("IMG");
    filterBtnImgVar.src = "images/filterIcon.png";
    filterBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
    filterButtonForBubbleChart2[0][0].appendChild(filterBtnImgVar)
    
    var refreshButtonForBubbleChart2 = optionsBtnPanelForBubbleChart2.append("div") .style("width","20px").style("height","20px").style('position','absolute')
    .style('background-color',"#ffffff").style("z-index",10)
    .style('top','1px') .style("cursor","pointer").style("display","block")
    .style('padding',"130px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
    var refreshBtnImgVar = document.createElement("IMG");
    refreshBtnImgVar.src = "images/refreshIcon.png";
    refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
    refreshButtonForBubbleChart2[0][0].appendChild(refreshBtnImgVar)
    
    var commentsBtnForBubbleChart2 = optionsBtnPanelForBubbleChart2.append("div") .style("width","20px").style("height","20px").style('position','absolute')
    .style('background-color',"#ffffff").style("z-index",10)
    .style('top','1px') .style("cursor","pointer").style("display","block")
    .style('padding',"155px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
    var commentsBtnImgVariable = document.createElement("IMG");
    if(options.showComments == false){
        commentsBtnImgVariable.src = "images/showCommentsIcon.png";
    }
    else if(options.showComments == true){
        commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
    }
    commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
    commentsBtnForBubbleChart2[0][0].appendChild(commentsBtnImgVariable)
    
    var menuBtnForBubbleChart2 = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
    .style('background-color',"#ffffff").style("z-index",10)
    .style('top','1px') .style("cursor","pointer").style("display","block")
    .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
    var menuBtnImgVar = document.createElement("IMG");
    menuBtnImgVar.src = "images/menuIcon.png";
    menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
    menuBtnForBubbleChart2[0][0].appendChild(menuBtnImgVar)
    
    if(showOrHideCommentsBtnForBubbleChart2 == true){
        treeMapBtnForBubbleChart.style('margin-left', "2px")
        filterButtonForBubbleChart2.style('margin-left', "2px")
        refreshButtonForBubbleChart2.style('margin-left', "2px")
        commentsBtnForBubbleChart2.style('margin-left', "2px")
        menuBtnForBubbleChart2.style('right', '0')
    }
    else if(showOrHideCommentsBtnForBubbleChart2 == false){
        treeMapBtnForBubbleChart.style('margin-left', "2px")
        filterButtonForBubbleChart2.style('margin-left', "2px")
        refreshButtonForBubbleChart2.style('margin-left', "2px")
        //commentsBtnForBubbleChart2.style('right', '0')
        commentsBtnForBubbleChart2.style('display','none')
        menuBtnForBubbleChart2.style('right', '0')
    }
    
    var ismenuBtnOfBubbleChart2Clicked = false;
    menuBtnForBubbleChart2.on('click', function() {
                              
              filterPanelForBubbleChart2.style('display',"none")
              stgPanDivForBubbleChart2.style('display',"none")
              
          if(ismenuBtnOfBubbleChart2Clicked == false){
              ismenuBtnOfBubbleChart2Clicked = true;
              optionsBtnPanelForBubbleChart2.style("display","block")
              
              if ((showOrHideTableForBubbleChart2 == false) && (showOrHideCommentsForBubbleChart2 == true)){
              lgdPanDivForBubbleChart2.style('width', 35 + "%") .style('height', 70 + "%") .style("left",65 + "%").style("top",8 + "%") .style('position',"absolute").style("background-color",options.BGcolor)
              
              svgPanelForBubbleChart2.style('width', 65 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%").style("background-color",options.BGcolor)
              .style("position","absolute");
              }
              else if ((showOrHideTableForBubbleChart2 == true) && (showOrHideCommentsForBubbleChart2 == false)){
              lgdPanDivForBubbleChart2.style('width', 35 + "%") .style('height', 52 + "%") .style("left",65 + "%").style("top",8 + "%") .style('position',"absolute").style("background-color",options.BGcolor)
              
              svgPanelForBubbleChart2.style('width', 65 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor)
              .style("position","absolute");
              }
              else if ((showOrHideTableForBubbleChart2 == false) && (showOrHideCommentsForBubbleChart2 == false)){
              lgdPanDivForBubbleChart2.style('width', 35 + "%") .style('height', 92 + "%") .style("left",65 + "%").style("top",8 + "%") .style('position',"absolute").style("background-color",options.BGcolor)
              
              svgPanelForBubbleChart2.style('width', 65 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor)
              .style("position","absolute");
              }
              
          }
          else if(ismenuBtnOfBubbleChart2Clicked == true){
              ismenuBtnOfBubbleChart2Clicked = false
              optionsBtnPanelForBubbleChart2.style("display","none")
              
              if ((showOrHideTableForBubbleChart2 == false) && (showOrHideCommentsForBubbleChart2 == true)){
              lgdPanDivForBubbleChart2.style('width', 35 + "%") .style('height', 70 + "%") .style("left",65 + "%").style("top",8 + "%") .style('position',"absolute").style("background-color",options.BGcolor)
              
              svgPanelForBubbleChart2.style('width', 65 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
              .style("position","absolute").style("background-color",options.BGcolor);
              }
              else if ((showOrHideTableForBubbleChart2 == true) && (showOrHideCommentsForBubbleChart2 == false)){
              lgdPanDivForBubbleChart2.style('width', 35 + "%") .style('height', 52 + "%") .style("left",65 + "%").style("top",8 + "%") .style('position',"absolute").style("background-color",options.BGcolor)
              
              svgPanelForBubbleChart2.style('width', 65 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor)
              .style("position","absolute");
              }
              else if ((showOrHideTableForBubbleChart2 == false) && (showOrHideCommentsForBubbleChart2 == false)){
              lgdPanDivForBubbleChart2.style('width', 35 + "%") .style('height', 92 + "%") .style("left",65 + "%").style("top",8 + "%") .style('position',"absolute").style("background-color",options.BGcolor)
              
              svgPanelForBubbleChart2.style('width', 65 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor)
              .style("position","absolute");
              }
          }
              
            resizedFuctionForBubbleChart2();
      })
    
    var tableButtonForBubbleChart2 = optionsBtnPanelForBubbleChart2.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
    .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top','1px')
    .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
    var tableBtnImgVar = document.createElement("IMG");
    if(showOrHideTableForBubbleChart2 == false){
        tableBtnImgVar.src = "images/showTableIcon.png";
        tableButtonForBubbleChart2.attr("class","showTableClassForChartTable")
    }
    else if(showOrHideTableForBubbleChart2 == true){
        tableBtnImgVar.src = "images/cancelTableIcon.png";
        tableButtonForBubbleChart2.attr("class","hideTableClassForChartTable")
    }
    tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
    tableButtonForBubbleChart2[0][0].appendChild(tableBtnImgVar)
    
    var settingBtnForBubbleChart2 = optionsBtnPanelForBubbleChart2.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
    .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 28 + 'px')
    .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
    var settingBtnImgVar = document.createElement("IMG");
    settingBtnImgVar.src = "images/settingsIcon.png";
    settingBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.82;")
    settingBtnForBubbleChart2[0][0].appendChild(settingBtnImgVar)
    
    var downloadBtnForBubbleChart2 = optionsBtnPanelForBubbleChart2.append("div").attr("id","downloadBtnForBubbleChart2-ID-" + targetElement[0][0].id).style("width","20px").style("height","20px")
    .style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff").style('margin-left','2px').style('top', 54 + 'px')
    .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
    
    acinfotech.downloadFunctionality("downloadBtnForBubbleChart2-ID-" + targetElement[0][0].id,targetElement)
        
    var svgPanelForBubbleChart2 = targetElement .append('svg') .attr("id","svgPanelIDForBubbleChart2" + targetElement[0][0].id)
    .style('background-color',"#ffffff") .style("position","absolute")
    
    var commentsPanelDivForBubbleChart2 = targetElement.append("div") .attr("class","commentsPanelClassForBubbleChart2")
    .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
	.style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
    .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)
    
    commentsPanelDivForBubbleChart2.on('click',function(d){
           $('.commentsClassForBubbleChart2' + targetElement[0][0].id).focus()
    })
        
    if(options.showTitle == true){
        
        chartTitlePanelForBubbleChart2.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 8 + "%"; }).style("background-color",options.BGcolor)
        .html('<div  style="width: 100%; height:0%;position: absolute; top:10.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>') //color 325922
        
        if ((showOrHideTableForBubbleChart2 == false) && (showOrHideCommentsForBubbleChart2 == true)){
            
            var commentsForBubbleChart2 = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
            .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
            .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
            .css('line-height','1.1em').css('text-align','justify').attr('class','commentsClassForBubbleChart2' + targetElement[0][0].id)
            
            svgPanelForBubbleChart2.attr('width', 65 + "%") .attr('height', 70 + "%") .style("top",8 + "%").style("background-color",options.BGcolor) .append('g')
            commentsPanelDivForBubbleChart2.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
            .style("top",78 + "%")
            .html(commentsForBubbleChart2[0].outerHTML.toString())
            
        }
        else if ((showOrHideTableForBubbleChart2 == true) && (showOrHideCommentsForBubbleChart2 == false)){
            
            svgPanelForBubbleChart2.attr('width', 65 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .style("background-color",options.BGcolor).append('g')
            commentsPanelDivForBubbleChart2.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
        }
        else if ((showOrHideTableForBubbleChart2 == false) && (showOrHideCommentsForBubbleChart2 == false)){
            svgPanelForBubbleChart2.attr('width', 65 + "%") .attr('height', 85 + "%") .style("top",8 + "%").style("background-color",options.BGcolor) .append('g')
            commentsPanelDivForBubbleChart2.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
        }
        
    }
    else if(options.showTitle == false){
        
        chartTitlePanelForBubbleChart2.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });
        
        if ((showOrHideTableForBubbleChart2 == false) && (showOrHideCommentsForBubbleChart2 == true)){
            
            var commentsForBubbleChart2 = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
            .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
            .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
            .css('line-height','1.1em').css('text-align','justify')
            
            svgPanelForBubbleChart2.attr('width', 65 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .style("background-color",options.BGcolor).append('g')
            commentsPanelDivForBubbleChart2.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
            .style("top",78 + "%")
            .html(commentsForBubbleChart2[0].outerHTML.toString())
            
        }
        else if ((showOrHideTableForBubbleChart2 == true) && (showOrHideCommentsForBubbleChart2 == false)){
            
            svgPanelForBubbleChart2.attr('width', 65 + "%") .attr('height', 52 + "%") .style("top",8 + "%").style("background-color",options.BGcolor) .append('g')
            commentsPanelDivForBubbleChart2.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
        }
        else if ((showOrHideTableForBubbleChart2 == false) && (showOrHideCommentsForBubbleChart2 == false)){
            svgPanelForBubbleChart2.attr('width', 65 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .style("background-color",options.BGcolor).append('g')
            commentsPanelDivForBubbleChart2.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
        }
    }
    
    var lgdPanDivForBubbleChart2 = targetElement .append('div') .style("background-color",options.BGcolor) .style('position',"absolute")
    .style('width', 30 + "%") .style('height', 92 + "%") .style("left",70 + "%").style("top",8 + "%") .style("display","block")
    .style("overflow-y","scroll")
    
    /* var svgLegendPanelBubbleChart2 = targetElement .append('svg')  .attr("class","svgLegendPanelClassForBubbleChart2") .style('background-color',"#ffffff") .style('position',"absolute")
     .style('width', 30 + "%") .style('height', 92 + "%") .style("left",70 + "%").style("top",8 + "%") .style("display","none")*/
    
    if ((showOrHideTableForBubbleChart2 == false) && (showOrHideCommentsForBubbleChart2 == true)){
        
        lgdPanDivForBubbleChart2.style('width', 35 + "%") .style('height', 70 + "%") .style("left",65 + "%").style("top",8 + "%").style("background-color",options.BGcolor)
    }
    else if ((showOrHideTableForBubbleChart2 == true) && (showOrHideCommentsForBubbleChart2 == false)){
        
        lgdPanDivForBubbleChart2.style('width', 35 + "%") .style('height', 52 + "%") .style("left",65 + "%").style("top",8 + "%").style("background-color",options.BGcolor)
    }
    else if ((showOrHideTableForBubbleChart2 == false) && (showOrHideCommentsForBubbleChart2 == false)){
        
        lgdPanDivForBubbleChart2.style('width', 35 + "%") .style('height', 92 + "%") .style("left",65 + "%").style("top",8 + "%").style("background-color",options.BGcolor)
    }
    
    var svgLegendPanelBubbleChart2 = lgdPanDivForBubbleChart2 .append('svg')  .attr("class","svgLegendPanelClassForBubbleChart2") .style("background-color",options.BGcolor) .style('position',"absolute")
    .style('width', 98 + "%") .style('height', (options.data.length * 17) + "px") .style("left",0 + "%").style("top",0 + "%") .style("display","block")
    
    var colors;
    // checking color set for bubbles and legend dots
    if(options.colorSet === undefined){
        options.colorSet = "one"
        colors = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
    }
    else if(options.colorSet.toString().toLowerCase() === "one"){
        options.colorSet = "one"
        colors = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
    }
    else if(options.colorSet.toString().toLowerCase() === "two"){
        options.colorSet = "two"
        colors = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
    }
    else if(options.colorSet.toString().toLowerCase() === "three"){
        options.colorSet = "three"
        colors = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
    }
    else
    {
        options.colorSet = "one"
        colors = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
    }
    /*------------------ Settings panel DIV and everything within it section begins here ------------------*/
    
    var stgPanDivForBubbleChart2 = targetElement.append('div').style('width',"100%").style('height',"40%").attr("class","stgPanDivForBubbleChart2" + targetElement[0][0].id)
    .style('position','absolute') .style('margin-left', "0px") .style('border-top',"1px solid #f0f0f0") .style('border-bottom',"1px solid #e5e5e5")
    .style("background-color",'#fcfcfc') .style("z-index",90)  .style("display","none") .style('top', 60.0 + "%") .style('height',40 + "%")
    
    $( '.stgPanDivForBubbleChart2' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
              var e0 = e.originalEvent,
              delta = e0.wheelDelta || -e0.detail;
              
              this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
              e.preventDefault();
      });
    
    var settingPanelTitle = stgPanDivForBubbleChart2.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
    .style('margin-left','0px').style('margin-top','10px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
    .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
    .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; color:#00001c;">'+ "Settings" +'</div>')
    
    var stgPanDivForLineChangeColorTitle = stgPanDivForBubbleChart2.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
    .style('margin-left','0px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
    .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
    .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Select color set " +'</div>')
    
    var stgPanCanBtnForBubbleChart2 = stgPanDivForBubbleChart2.append("div") .style("width","18px").style("height","17px").style('position','absolute')
    .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
    .style('background-color',"#FCFCFF")
    .style("border", "0.0px") .style("border-style", "solid").style('color','white')
    .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
    var cancelBtnImgVar = document.createElement("IMG");
    cancelBtnImgVar.src = "images/closeIcon.png";
    cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.9; background-color:#fcfcff")
    stgPanCanBtnForBubbleChart2[0][0].appendChild(cancelBtnImgVar)
    
    stgPanCanBtnForBubbleChart2.on('click', function() {
           stgPanDivForBubbleChart2.style("display","none") // Hiding setting panel
           
           if ((showOrHideTableForBubbleChart2 == false) && (showOrHideCommentsForBubbleChart2 == true)){
               lgdPanDivForBubbleChart2.style('width', 35 + "%") .style('height', 70 + "%") .style("left",65 + "%").style("top",8 + "%") .style("background-color",options.BGcolor).style('position',"absolute")
               
               svgPanelForBubbleChart2.style('width', 65 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%").style("background-color",options.BGcolor)
               .style("position","absolute");
           }
           else if ((showOrHideTableForBubbleChart2 == true) && (showOrHideCommentsForBubbleChart2 == false)){
               lgdPanDivForBubbleChart2.style('width', 35 + "%") .style('height', 52 + "%") .style("left",65 + "%").style("top",8 + "%") .style('position',"absolute").style("background-color",options.BGcolor)
               
               svgPanelForBubbleChart2.style('width', 65 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor)
               .style("position","absolute");
           }
           else if ((showOrHideTableForBubbleChart2 == false) && (showOrHideCommentsForBubbleChart2 == false)){
               lgdPanDivForBubbleChart2.style('width', 35 + "%") .style('height', 92 + "%") .style("left",65 + "%").style("top",8 + "%") .style('position',"absolute").style("background-color",options.BGcolor)
               
               svgPanelForBubbleChart2.style('width', 65 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor)
               .style("position","absolute");
           }
           
           resizedFuctionForBubbleChart2();
        })
    
    var formForChangeSettingsPanel = stgPanDivForBubbleChart2.append("form");
    formForChangeSettingsPanel.style("background-color","#fcfcfc").style("margin-top","67px").style("font-family","Verdana,sans-serif").style("font-size","12px")
    .style("position","absolute").attr("id","formForChangeColorSettingsPanel" + targetElement[0][0].id).style("font-weight","Bold").style("width","180px")
    .style("height","58px").style("padding","0px").style("border-radius","0px") .style("margin-left","10px")
    
    var svgPanelForCrSetOne = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
    .style("width","160px") .style("height","18px") .style("margin-top","1px") .style("margin-left","0px") .style("box-sizing","border-box")
    
    var colorSetOne = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"])
    var colorSetOneRange = d3.range(12);
    
    var colorSetOneDots = svgPanelForCrSetOne.append("g")
    colorSetOneDots.selectAll('rect') .data(colorSetOneRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
    .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("fill", function(d,i){return colorSetOne(i)})
    .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetOne(i);  })
    .style("cursor","auto") .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
    
    var svgPanelForCrSetTwo = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
    .style("width","160px") .style("height","18px") .style("margin-top","20px") .style("margin-left","0px") .style("box-sizing","border-box")
    
    var colorSetTwo = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
    var colorSetTwoRange = d3.range(12);
    
    var colorSetTwoDots = svgPanelForCrSetTwo.append("g")
    colorSetTwoDots.selectAll('rect') .data(colorSetTwoRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
    .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto")
    .style("fill", function(d,i){return colorSetTwo(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
    .style("stroke",function(d,i){  return colorSetTwo(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
    
    var svgPanelForCrSetThree = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
    .style("width","160px").style("height","18px").style("margin-top","39px").style("margin-left","0px") .style("box-sizing","border-box")
    
    var colorSetThree = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
    var colorSetThreeRange = d3.range(12);
    
    var colorSetThreeDots = svgPanelForCrSetThree.append("g")
    colorSetThreeDots.selectAll('rect') .data(colorSetThreeRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
    .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto")
    .style("fill", function(d,i){return colorSetThree(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
    .style("stroke",function(d,i){  return colorSetThree(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
    
    if(options.colorSet.toString().toLowerCase() === "one"){
        svgPanelForCrSetOne.style('border',"1px solid #808080")
        svgPanelForCrSetTwo.style('border',"0px solid #808080")
        svgPanelForCrSetThree.style('border',"0px solid #808080")
    }
    else if(options.colorSet.toString().toLowerCase() === "two"){
        svgPanelForCrSetOne.style('border',"0px solid #808080")
        svgPanelForCrSetTwo.style('border',"1px solid #808080")
        svgPanelForCrSetThree.style('border',"0px solid #808080")
    }
    else if(options.colorSet.toString().toLowerCase() === "three"){
        svgPanelForCrSetOne.style('border',"0px solid #808080")
        svgPanelForCrSetTwo.style('border',"0px solid #808080")
        svgPanelForCrSetThree.style('border',"1px solid #808080")
    }
    else
    {
        svgPanelForCrSetOne.style('border',"1px solid #808080")
        svgPanelForCrSetTwo.style('border',"0px solid #808080")
        svgPanelForCrSetThree.style('border',"0px solid #808080")
    }
    
        svgPanelForCrSetOne.on('click',function(d){
           options.colorSet = "one"
           svgPanelForCrSetOne.style('border',"1px solid #808080")
           svgPanelForCrSetTwo.style('border',"0px solid #808080")
           svgPanelForCrSetThree.style('border',"0px solid #808080")
           
           colors = "";
           colors = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"])
           
           mainArray = [];
           uniqueArray.forEach(function(d,i){
               options.data.forEach(function(data,j){
                    if(d.toString() == data[options.keys.legendItems].toString())
                    {
                        data["colorCode"] = colors(i);
                        mainArray.push(data)
                    }
                })
           })
           
           filteredArray = [];
           mainArray.forEach(function(d,i){
                 var temp = {};
                 temp[options.keys.label] = d[options.keys.label]
                 temp["value"] = d[options.keys.value]
                 temp["legendItems"] = d[options.keys.legendItems]
                 temp["colorCode"] = d.colorCode
                 filteredArray.push(temp)
            })
           
           node.select('circle').style("fill", function(d,i) { return filteredArray[i]["colorCode"]; })
           legendGroup.style("fill", function(d, i){ return filteredArray[i]["colorCode"]; })
               
       })
        svgPanelForCrSetTwo.on('click',function(d){
           options.colorSet = "two"
           svgPanelForCrSetOne.style('border',"0px solid #808080")
           svgPanelForCrSetTwo.style('border',"1px solid #808080")
           svgPanelForCrSetThree.style('border',"0px solid #808080")
           
           colors = "";
           colors = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
           
           mainArray = [];
           uniqueArray.forEach(function(d,i){
               options.data.forEach(function(data,j){
                    if(d.toString() == data[options.keys.legendItems].toString())
                    {
                        data["colorCode"] = colors(i);
                        mainArray.push(data)
                    }
                })
           })
           
           filteredArray = [];
           mainArray.forEach(function(d,i){
                 var temp = {};
                 temp[options.keys.label] = d[options.keys.label]
                 temp["value"] = d[options.keys.value]
                 temp["legendItems"] = d[options.keys.legendItems]
                 temp["colorCode"] = d.colorCode
                 filteredArray.push(temp)
           })
           
           node.select('circle').style("fill", function(d,i) { return mainArray[i]["colorCode"]; })
           legendGroup.style("fill", function(d, i){ return mainArray[i]["colorCode"];})
               
       })
        svgPanelForCrSetThree.on('click',function(d){
             options.colorSet = "three"
             svgPanelForCrSetOne.style('border',"0px solid #808080")
             svgPanelForCrSetTwo.style('border',"0px solid #808080")
             svgPanelForCrSetThree.style('border',"1px solid #808080")
             
             colors = "";
             colors = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
             
             mainArray = [];
             uniqueArray.forEach(function(d,i){
                    options.data.forEach(function(data,j){
                        if(d.toString() == data[options.keys.legendItems].toString())
                        {
                            data["colorCode"] = colors(i);
                            mainArray.push(data)
                        }
                    })
             })
             
             filteredArray = [];
             mainArray.forEach(function(d,i){
                   var temp = {};
                   temp[options.keys.label] = d[options.keys.label]
                   temp["value"] = d[options.keys.value]
                   temp["legendItems"] = d[options.keys.legendItems]
                   temp["colorCode"] = d.colorCode
                   filteredArray.push(temp)
             })
             
             node.select('circle').style("fill", function(d,i) { return mainArray[i]["colorCode"];; })
             legendGroup.style("fill", function(d, i){ return mainArray[i]["colorCode"];})
         })
    
    
    /*------------------ Settings panel DIV and everything inside it section ends here ------------------*/

        treeMapBtnForBubbleChart.on('click', function() {
                      
              d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
              
              var newOptions = {
                  data: options.data,
                  dataForTable: options.dataForTable,
                  isDataDetailedForTable: options.isDataDetailedForTable,
                  keys: {
                      label: options.keys.label,
                      value: options.keys.value,
                  legendItems: options.keys.legendItems
                  },
                  chartTitle: options.chartTitle,
                  showTitle: options.showTitle,
                  colorSet: options.colorSet,
                  BGcolor:options.BGcolor,
                  drillDownColumnName:options.drillDownColumnName,
                  showTable: false,
                  showComments: options.showComments,
                  comments: options.comments,
                  resizeButtonID: options.resizeButtonID
              }
              acinfotech.treeMap(targetElement, newOptions)
                      
        })

        // Refreshing Chart and Table
        refreshButtonForBubbleChart2.on('click', function() {
                        
            //isFilterClicked = false
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){
            
                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                }
            }
            acinfotech.bubbleChart2(targetElement,options)
        })

        commentsBtnForBubbleChart2.on('click', function() {
                      
              if(options.showComments == false){ 
                  options.showComments = true;
              }
              else if(options.showComments == true){ 
                  options.showComments = false;
              }
              
              //isFilterClicked = false
              d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
              
              for(var i = 0; i<divAndChartsArray.length; i++){
              
                  if(targetElement[0][0].id === divAndChartsArray[i].divID){
                      options.data = divAndChartsArray[i].optionsData
                      options.showTable = false;
                  }
              }
              acinfotech.bubbleChart2(targetElement,options)
        })

        // showing/hidding chart table
        tableButtonForBubbleChart2.on('click', function() {
                      
              if(showOrHideTableForBubbleChart2 == false){
                  options.showTable = true;
              }
              else if(showOrHideTableForBubbleChart2 == true){
                  options.showTable = false;
              }
              
              d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
              
              for(var i = 0; i<divAndChartsArray.length; i++){
              
                  if(targetElement[0][0].id === divAndChartsArray[i].divID){
                      options.data = divAndChartsArray[i].optionsData
                      options.showComments = false;
                  }
              }
              acinfotech.bubbleChart2(targetElement,options)
        })


        settingBtnForBubbleChart2.on('click', function() {
                     
			ismenuBtnOfBubbleChart2Clicked = false; // Menu toggle button variable
			optionsBtnPanelForBubbleChart2.style("display","none") // To hide options button panel

			iconButtonTooltipForBubbleChart2.style("display","none") // Removing options button ToolTip
			settingBtnForBubbleChart2.style("cursor","pointer")

			stgPanDivForBubbleChart2.style("display","block") // Showing settings panel

			svgPanelForBubbleChart2.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute"); // Decreasing chart panel
			lgdPanDivForBubbleChart2.style('width', 35 + "%") .style('height', 52 + "%").style("position","absolute"); // Decreasing chart panel

			resizedFuctionForBubbleChart2(); // Calling resize function()
                     
        })
        
        downloadBtnForBubbleChart2.on('click', function() {
                                  
			ismenuBtnOfBubbleChart2Clicked = false; // Changing menu button value to false
			optionsBtnPanelForBubbleChart2.style("display","none") // Hiding option buttons panel
                                  
        })
        
        // Creating ToolTip for options button.
        var iconButtonTooltipForBubbleChart2 = targetElement.append('div').style('width','240px').attr("id","too") .style('height',"25px")
        .style('position','absolute') .style("background-color",'#404040 ') .style("z-index",999).style("border", "0.0px")
        .style("border-color", "#278eff") .style("border-style", "solid") .style("border-radius","0px") .style("box-shadow", "1px 1px 2px #d8d8d8")
        .style("display","none").attr("border", 0.0)

        treeMapBtnForBubbleChart.on('mousemove', function(d,i) {
               var root = targetElement
               var m = d3.mouse(root.node());
               m[0] += 0
               m[1] += 0
               var treeMapButtonTooltipText = "Switch to Tree Map";
               
               iconButtonTooltipForBubbleChart2.style("width","132px").style("margin-left", (m[0] - 142) + "px").style("margin-top",(m[1]) + "px").style("display","block")
               iconButtonTooltipForBubbleChart2.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ treeMapButtonTooltipText +'</div>')
               
        })
        treeMapBtnForBubbleChart.on('mouseout', function(d,i) {
           iconButtonTooltipForBubbleChart2.style("display","none")
        })

        filterButtonForBubbleChart2.on('mousemove', function(d,i) {
               var root = targetElement
               var m = d3.mouse(root.node());
               m[0] += 0
               m[1] += 0
               var filterChartButtonTooltipText = "Filter";
               
               iconButtonTooltipForBubbleChart2.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
               iconButtonTooltipForBubbleChart2.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ filterChartButtonTooltipText +'</div>')
               
        })
        filterButtonForBubbleChart2.on('mouseout', function(d,i) {
           iconButtonTooltipForBubbleChart2.style("display","none")
        })

        refreshButtonForBubbleChart2.on('mousemove', function(d,i) {
                var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                var refreshChartButtonTooltipText = "Refresh";
                
                iconButtonTooltipForBubbleChart2.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
                iconButtonTooltipForBubbleChart2.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ refreshChartButtonTooltipText +'</div>')
                
        })
        refreshButtonForBubbleChart2.on('mouseout', function(d,i) {
                iconButtonTooltipForBubbleChart2.style("display","none")
        })

        commentsBtnForBubbleChart2.on('mousemove', function(d,i) {
              commentsPanelDivForBubbleChart2.style('background-color','#fafafa')
              var root = targetElement
              var m = d3.mouse(root.node());
              m[0] += 0
              m[1] += 0
              if(options.showComments == false){
              var commentButtonTooltipText = "Show Comments";
              }
              else if(options.showComments == true){
              var commentButtonTooltipText = "Hide Comments";
              }
              
              
              iconButtonTooltipForBubbleChart2.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
              iconButtonTooltipForBubbleChart2.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ commentButtonTooltipText +'</div>')
        })
        commentsBtnForBubbleChart2.on('mouseout', function(d,i) {
              commentsPanelDivForBubbleChart2.style('background-color','#ffffff')
              iconButtonTooltipForBubbleChart2.style("display","none")
        })

        tableButtonForBubbleChart2.on('mousemove', function(d,i) {
              var root = targetElement
              var m = d3.mouse(root.node());
              m[0] += 0
              m[1] += 0
              if(showOrHideTableForBubbleChart2 == false){
              var tableBtnTooltipText = "Show Table";
              }
              else if(showOrHideTableForBubbleChart2 == true){
              var tableBtnTooltipText = "Hide Table";
              }
              
              
              iconButtonTooltipForBubbleChart2.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
              iconButtonTooltipForBubbleChart2.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ tableBtnTooltipText +'</div>')
              
        })
        tableButtonForBubbleChart2.on('mouseout', function(d,i) {
              iconButtonTooltipForBubbleChart2.style("display","none")
        })

        settingBtnForBubbleChart2.on('mousemove', function(d,i) {
             var root = targetElement
             var m = d3.mouse(root.node());
             m[0] += 0
             m[1] += 0
             var settingTooltipText = "Settings";
             
             iconButtonTooltipForBubbleChart2.style("width","67px").style("margin-left", (m[0] - 77) + "px").style("margin-top",(m[1]) + "px").style("display","block")
             iconButtonTooltipForBubbleChart2.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ settingTooltipText +'</div>')
        })
        settingBtnForBubbleChart2.on('mouseout', function(d,i) {
             iconButtonTooltipForBubbleChart2.style("display","none")
        })
        
        downloadBtnForBubbleChart2.on('mousemove', function(d,i) {
              var root = targetElement
              var m = d3.mouse(root.node());
              m[0] += 0
              m[1] += 0
              var downloadButtonTooltipText = "Download";
              
              iconButtonTooltipForBubbleChart2.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
              iconButtonTooltipForBubbleChart2.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
        })
        downloadBtnForBubbleChart2.on('mouseout', function(d,i) {
              iconButtonTooltipForBubbleChart2.style("display","none")
        })
        
        menuBtnForBubbleChart2.on('mousemove', function(d,i) {
              var root = targetElement
              var m = d3.mouse(root.node());
              m[0] += 0
              m[1] += 0
              var menuButtonTooltipText = "Menu";
              
              iconButtonTooltipForBubbleChart2.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
              iconButtonTooltipForBubbleChart2.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ menuButtonTooltipText +'</div>')
        })
        menuBtnForBubbleChart2.on('mouseout', function(d,i) {
              iconButtonTooltipForBubbleChart2.style("display","none")
        })
    
    filterButtonForBubbleChart2.on('click', function() {
                                   
           filterPanelForBubbleChart2.style("display","block");
           
           ismenuBtnOfBubbleChart2Clicked = false;
           optionsBtnPanelForBubbleChart2.style("display","none");
           
           stgPanDivForBubbleChart2.style("display","none");
           
           if ((showOrHideTableForBubbleChart2 == false) && (showOrHideCommentsForBubbleChart2 == true)){
           lgdPanDivForBubbleChart2.style("width", function(d) { return 30 + "%"; }) .style("height", function(d) { return 70  + "%"; })
           .style("position","absolute") .style("left",70 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
           
           svgPanelForBubbleChart2.style('width', 70 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
           .style("position","absolute").style("background-color",options.BGcolor);
           }
           else if ((showOrHideTableForBubbleChart2 == true) && (showOrHideCommentsForBubbleChart2 == false)){
           lgdPanDivForBubbleChart2.style("width", function(d) { return 30 + "%"; }) .style("height", function(d) { return 52  + "%"; })
           .style("position","absolute") .style("left",70 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
           
           svgPanelForBubbleChart2.style('width', 70 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
           .style("position","absolute").style("background-color",options.BGcolor);
           }
           else if ((showOrHideTableForBubbleChart2 == false) && (showOrHideCommentsForBubbleChart2 == false)){
           lgdPanDivForBubbleChart2.style("width", function(d) { return 30 + "%"; }) .style("height", function(d) { return 92  + "%"; })
           .style("position","absolute") .style("left",70 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
           
           svgPanelForBubbleChart2.style('width', 70 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
           .style("position","absolute").style("background-color",options.BGcolor);
           }
           
           resizedFuctionForBubbleChart2();
    })
    
    //-------- creating tooltip --------
    
    var tooltipForBubbleChart2 = targetElement .append('div') .attr('class', 'tooltipPie') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
    .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
    .style("padding-right", "7px") .style("background", "#F8F8F8") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style("z-index",1000)
    .style("border", "1.0px") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","80px")
    tooltipForBubbleChart2.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'label').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "14px") .style("font-weight", "normal");
    tooltipForBubbleChart2.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
    tooltipForBubbleChart2.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");
    
    var diameterWidth = document.getElementById("svgPanelIDForBubbleChart2" + targetElement[0][0].id).getBoundingClientRect().width;//svgPanelForBubbleChart2[0][0].clientWidth;
    var diameterHeight = document.getElementById("svgPanelIDForBubbleChart2" + targetElement[0][0].id).getBoundingClientRect().height;//svgPanelForBubbleChart2[0][0].clientHeight;
    
    var bubble_layout = d3.layout.pack()
    .sort(null) // HERE
    .size([diameterWidth,diameterHeight])
    .padding(1.5);
    
    var bubbleChart2SVG = svgPanelForBubbleChart2.append("svg")
    .attr("width" , diameterWidth)
    .attr("height", diameterHeight)
    
    var mainArray = [];
    var legendItemArray = [];
    options.data.forEach(function(d,i){
     legendItemArray.push(d[options.keys.legendItems])
    })
    
    var uniqueArray = [];
    $.each(legendItemArray, function(i, el){
       if($.inArray(el, uniqueArray) === -1){
           uniqueArray.push(el);
       }
    });
    
    uniqueArray.forEach(function(d,i){
        options.data.forEach(function(data,j){
                             
             if(data[options.keys.legendItems] == null){
                data[options.keys.legendItems] = ""
             }
             
             if(d === data[options.keys.legendItems])
             {
                data["colorCode"] = colors(i);
                mainArray.push(data)
             }
        })
    })
    
    var filteredArray = [];
    
    mainArray.forEach(function(d,i){
          var temp = {};
          temp[options.keys.label] = d[options.keys.label]
          temp["value"] = d[options.keys.value]
          temp["legendItems"] = d[options.keys.legendItems]
          temp["colorCode"] = d.colorCode
          filteredArray.push(temp)
    })
    
    var selection = bubbleChart2SVG.selectAll("g.node")
    .data(bubble_layout.nodes({children: filteredArray}).filter(function(d) { return !d.children; }) );
    
    /*var node = selection.enter().append("g")
    .attr("class", "node")
    .attr("transform", function(d) { return "translate(" + d.x + ", " + d.y + ")"; }).filter(function(d){ return d.value > 0;
                                                                                             })  // HERE*/
    var node = selection.enter().append("g") .attr("class", "node")
    .attr("transform", function(d) { return "translate(" + d.x + ", " + d.y + ")"; }).filter( function(d,i){if(d.value == 0){ d.value = 0.000000000000001;
                                                                                             d3.select(selection[0][i]).style("display","none"); }; return d.value > 0; }) //HERE
    
    /*var bubbles = node.append("circle") .transition()
    .delay(function (d, i) { return i / bubble_layout.nodes({children: filteredArray}).filter(function(d) { return !d.children; }).length * 300; }) .duration(10)
    .attr("r", function(d) { return d.r; }) .style("fill", function(d,i) { return mainArray[i]["colorCode"] })*/
    
	var bubbles = node.append("circle").style("fill", function(d,i) { return mainArray[i]["colorCode"] })
	.attr("r", function(d) { return 0; }).transition().delay(400).duration(800).attr("r", function(d) { return d.r; })
	
    /*node.append("text") .transition()
    .delay(function (d, i) { return i / bubble_layout.nodes({children: filteredArray}).filter(function(d) { return !d.children; }).length * 300; }) .duration(10)
    .attr("dy", ".3em") .style("text-anchor", "middle") .style("font-size", "12px") .style("fill",function(d,i){ return "#f0f0f0" })
    .style("font-weight","Normal")
    .text(function(d) {
          if(d[options.keys.label] == null || d[options.keys.label] == undefined){ return ""; }
          else { return d[options.keys.label].substring(0, d.r / 3.5); }
    }) .style("font-family", "Verdana,sans-serif")*/
	
	node.append("text").attr("dy", ".3em").style("text-anchor", "middle").style("font-size", "12px") .style("fill",function(d,i){ return "#f0f0f0" })
	.style("font-weight","Normal").style("font-family", "Verdana,sans-serif")
	.text(function(d) {
          if(d[options.keys.label] == null || d[options.keys.label] == undefined){ return ""; }
          else { return d[options.keys.label].substring(0, d.r / 3.5); }
    })
	.style("display","none").transition().delay(1400).duration(800).style("display","block")
    
    node.on('mousemove', function (d,i){
            
            mainArray = [];
            uniqueArray.forEach(function(d,i){
                options.data.forEach(function(data,j){
                     if(d == data[options.keys.legendItems])
                     {
                         data["colorCode"] = colors(i);
                         mainArray.push(data)
                     }
                })
            })
            
            var filteredArrayForToolTip = []
            filteredArray.forEach(function(d,i){
                  var temp = {};
                  temp[options.keys.label] = d[options.keys.label];
                  temp[options.keys.value] = d.value;
                  temp[options.keys.legendItems] = d.legendItems;
                  filteredArrayForDrillDown.push(temp);
            })
            
            var root = targetElement
            var m = d3.mouse(root.node());
            m[0] += 0
            m[1] += 0
            
            var valueForBubbleChart2ToolTip;
            if(d.value.toString().indexOf('.') === -1)
            {
                valueForBubbleChart2ToolTip = d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            else{
            
                valueForBubbleChart2ToolTip = d.value;
            }
            
            tooltipForBubbleChart2.select('.label').html(options.keys.label + " : " + d[options.keys.label])
            //tooltipForBubbleChart2.select('.count').html(options.keys.value + " : " + options.data[i][options.keys.value].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
            tooltipForBubbleChart2.select('.count').html(options.keys.value + " : " + valueForBubbleChart2ToolTip)
            tooltipForBubbleChart2.style('visibility', 'visible')
            tooltipForBubbleChart2.select('hr').style("background-color", function(d){ return mainArray[i]["colorCode"] })
            tooltipForBubbleChart2.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-20) + "px").style("display","block")
            
            })
    .on('mouseout', function(){ tooltipForBubbleChart2.style("display","none") })
    
    var filteredArrayForDrillDown = []
    filteredArray.forEach(function(d,i){
          var temp = {};
          temp[options.keys.label] = d[options.keys.label];
          temp[options.keys.value] = d.value;
          temp[options.keys.legendItems] = d.legendItems;
          filteredArrayForDrillDown.push(temp);
    })
    
    var columnNames = d3.keys(options.data[0])
    var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
    
    for(var i = 0; i < columnNames.length ; i++){
        for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
            
            if(columnNames[i].toLowerCase().toString() === drillDownColumnNamesInArray[j].toLowerCase().toString()){
                
                for(var k = 0; k < node[0].length; k++){
                    
                   d3.select(node[0][k]).attr('data-drilldownkey', function(d,index){
                       return JSON.stringify(filteredArrayForDrillDown[k]).slice(1, -1).split('"').join("").split(':').join("|")
                   })
                    d3.select(node[0][k]).select('circle').attr('data-drilldownkey', function(d,index){
                        return JSON.stringify(filteredArrayForDrillDown[k]).slice(1, -1).split('"').join("").split(':').join("|")
                    })
                }
            }
            else {
            }
        }
    }
    
    
    // ----------------- Filter panel and everything within it section begins here ----------------
    var filterPanelForBubbleChart2 = targetElement.append('div') .style('width',350 + "px") .attr("class","filterPanelForBubbleChart2Class" + targetElement[0][0].id)
    .style('position','absolute') .style('margin-left', "0px") .style("background-color",'#fefefe') .style("z-index",11)
    .style("border-color", "#ffffff").style("border-right", "solid #e5e5e5 1px")  .style("border-style", "solid") .style("box-shadow", "2px 0px 1px #eff8ec")
    .style("display","none").style("border-top", "solid #fdfdfd 1px").style("border-left","0px").style("border-bottom", "0px")
    .style('top', 0.0 + "%").style('height', 100 + "%").style('overflow-y',"hidden").style("overflow-x","hidden")
    .style("border-bottom", "solid #e5e5e5 1px") .style("box-sizing","border-box")
    
    var filterPanelForBubbleChart2Title = filterPanelForBubbleChart2.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
    .style('margin-left','0px').style('margin-top','20px').style('text-indent','5px').style("font-size", "14px").style('position',"absolute")
    .style("box-shadow", "1px 1px 1px #007aff").style("width","350px").style("color","#000000")
    .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; top:25.0%; font-size:14px; font-family:inter; color:#00001c;">'+ "Filter" +'</div>')
    
    var measuresColumnTitle = filterPanelForBubbleChart2.append("div") .style("width","140px").style("height","18px").style('position','absolute')
    .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '60px')
    .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; text-indent:3px;">Available Measures</div>');
    
    var measuresVariables = filterPanelForBubbleChart2.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable1"+targetElement[0][0].id)
    .style("list-style-type","none")
    .style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '78px')
    .style('position','absolute')
    .style("width","155px").style("min-height","190px").style("max-height","190px").style("border", "#f0f0f0 1px solid")
    .style("max-width","155px").style("overflow-x","hidden").style("overflow-y","auto")
    measuresVariables.style("left",0.0 + "px").style("padding","2px")
    
    $( ".filterPanelForBubbleChart2Class" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
         var e0 = e.originalEvent,
         delta = e0.wheelDelta || -e0.detail;
         
         this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
         e.preventDefault();
     });
    
    
    var measuresArray = [];
    var dimensionArray = [];
    
    var measuresArrayLength = [];
    var dimensionsArrayLength = [];
    
    dimensionArray.push(options.keys.label);
    
    for(var i = 0; i<divAndChartsArray.length; i++){ if(targetElement[0][0].id === divAndChartsArray[i].divID){ } }
    
    // filter process
    var uniqueMeasuresArrayKeys = uniqueArray
    
    // setting lenght for arrays
    for(var i = 0; i<uniqueMeasuresArrayKeys.length; i++){
        measuresArrayLength.push(i);
    }
    
    var measuresVariables1 = measuresVariables.selectAll("li") .data(measuresArrayLength).enter().append("li")
    .style("width","130px") .style("max-height","22px").style("cursor","move")
    .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#bcf1bc").style("font-weight","Normal")
    .style("list-style-type","none").style("border","1px #89e789 solid").style("color","#006600").style("font-family","Verdana,sans-serif")
    .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
    .text(function(d) {return uniqueMeasuresArrayKeys[d]})
    measuresVariables1.attr("class","MeasuresClass"+targetElement[0][0].id)
    
    var measuresColumnReceivedUI_TableTitle = filterPanelForBubbleChart2.append("div") .style("width","140px").style("height","18px").style('position','absolute')
    .style('background-color',"#fefefe").style('margin-left','180px').style('margin-top', '60px')
    .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; ">Selected Measures</div>');
    
    var measuresColumnReceivedUI_Table = filterPanelForBubbleChart2.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable3"+targetElement[0][0].id)
    .style('background-color',"#ffffff").style('margin-left','180px').style('margin-top', '78px')
    .style("width","155px").style('position','absolute').style("padding","2px").style("min-height","190px")
    .style("border","1px #c1c1c1 dashed") .style("max-height","190px") .style("overflow-x","hidden") .style("overflow-y","auto")
    //.html('<div class=unsortable  style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:65.0%; font-size:14px; font-family:inter;  color:#99ea99; font-weight:Normal; text-align:center;">Drag and Drop Measures here from Available Measures List. </div>');
    .html('<img class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' src="images/dragIcon.png" style=" width:36px; height:36px; position:absolute; margin-left:65px; margin-top:60px; opacity:0.6"/>'
          + '<div class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:60.0%; font-size:12px; font-family:inter;  color:#89d289; font-weight:Normal; text-align:center;">Drop Measures here. </div>');
    //.html('<div style="background-image: url(images/dragIcon.png); height: 64px; width: 64px; border: 1px solid black;"> </div>');
    
    var cancelButton = filterPanelForBubbleChart2.append("div") .style("width","23px").style("height","21px").style('position','absolute')
    .style('margin-left','320px').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
    .style('background-color',"#FCFCFF")
    .style("border", "0.0px") .style("border-style", "solid").style('color','white')
    .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
    var cancelBtnImgVar = document.createElement("IMG");
    cancelBtnImgVar.src = "images/closeIcon.png";
    cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.90; background-color:#fcfcff")
    cancelButton[0][0].appendChild(cancelBtnImgVar)
    
    cancelButton.on("click", function(){
            filterPanelForBubbleChart2.style("display","none")
            
            if ((showOrHideTableForBubbleChart2 == false) && (showOrHideCommentsForBubbleChart2 == true)){
            lgdPanDivForBubbleChart2.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
            .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
            
            svgPanelForBubbleChart2.style('width', 65 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
            .style("position","absolute").style("background-color",options.BGcolor);
            }
            else if ((showOrHideTableForBubbleChart2 == true) && (showOrHideCommentsForBubbleChart2 == false)){
            lgdPanDivForBubbleChart2.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
            .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
            
            svgPanelForBubbleChart2.style('width', 65 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute").style("background-color",options.BGcolor);
            }
            else if ((showOrHideTableForBubbleChart2 == false) && (showOrHideCommentsForBubbleChart2 == false)){
            lgdPanDivForBubbleChart2.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 92  + "%"; })
            .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%").style("background-color",options.BGcolor);
            
            svgPanelForBubbleChart2.style('width', 65 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute").style("background-color",options.BGcolor);
            }
    })
    
    var reRenderChartAndTableButton = filterPanelForBubbleChart2.append("button").style("width","120px").style("height","25px").style('position','absolute')
    .style('margin-left','112px').style('margin-top','298px') .style("border-style", "none").style('background-color',"#2196f3")
    .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','15px').style("border-style", "solid").style('color','#ffffff')
    .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 1px #9b9b9b").style("border-radius","0px")
    var textForReRenderButton = document.createTextNode("Apply Changes");
    reRenderChartAndTableButton[0][0].appendChild(textForReRenderButton)
    
    reRenderChartAndTableButton.on("click", function(){
                                   
       if( $("#sortable3"+targetElement[0][0].id).children("li").length == 0 )
       {
       
               var alertPageDisabledDivForBubbleChart2 =targetElement.append('div').style('width',100 + '%')
               .style('height',100 + "%").style('position','absolute').style('margin-left', '0px').style('top', '0px')
               .style("background-color",'#f3f3f3').style("z-index",99)//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
               .style("opacity",0.2).style("display","block")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
               
               var alertDivForBubbleChart2 = targetElement.append('div').style('width','350px')
               .style('height',"150px").style('position','absolute').style('left', ((targetElement[0][0].clientWidth/2) - 175) + "px").style('top', '1px')
               .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "solid").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
               .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","0px")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
               //.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Bold;">Sorry, no result found for selected' + 'range!'+ '</br>' + '<label style=text-indent:10px;> Hello</label' +'</div>')
               .html('<p  style="width: 340px; height:0%; background-color:#c7c7c7; position: absolute; top:40.0%; font-size:14px; font-family:inter; font-weight:Bold; margin-left:10px;  color:#f8f8f8; font-weight:Normal;">Check whether the Selected Measures box is not empty!</p>')
               
               var alertDivTitleForBubbleChart2 = alertDivForBubbleChart2.append('div').style('width','340px')
               .style('height',"30px").style('position','absolute').style('margin-left', "0px").style('top', '0px')
               .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "none").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
               .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","2px")
               .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; font-weight:Bold; text-indent:5px;  color:#e5e5e5; font-weight:Normal;">TimeBound</div>')
               
               var bubbleChart2AlertOKButton = alertDivForBubbleChart2.append("button") .style("width","40px") .style("height","20px") .style('position','absolute') .style("box-shadow", "0px 1px 1px #B8B8B8")
               .style('background-color',"#7cc15e") .style('margin-left','300px') .style('top', "120px").style("color","#ffffff")
               .style("display","block").style('padding-top',"0px").style("cursor","pointer").style("box-shadow", "1px 1px 1px #56973a") .style("border-style", "none")
               .style("font-family","Verdana,sans-serif").style("font-size","14px").style("text-align","center").style("vertical-align","middle").style("border-radius","0px")
               .style("z-index",999)
               
               var textForBubbleChart2AlertOKButton = document.createTextNode("OK");
               bubbleChart2AlertOKButton[0][0].appendChild(textForBubbleChart2AlertOKButton)
               
               $("#"+targetElement[0][0].id).resizable('disable');
               
               bubbleChart2AlertOKButton.on('click', function() {
                    alertDivForBubbleChart2.remove();
                    alertPageDisabledDivForBubbleChart2.remove()
                    $("#"+targetElement[0][0].id).resizable('enable');
                })
               
               filterButtonForBubbleChart2.style("cursor","pointer")
               
               if(showOrHideTableForBubbleChart2 == false){
               svgPanelForBubbleChart2.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute").style("background-color",options.BGcolor)
               lgdPanDivForBubbleChart2.style('width', 35 + "%") .style('height', 92 + "%").style("position","absolute").style("background-color",options.BGcolor)
               }
               else if(showOrHideTableForBubbleChart2 == true){
               svgPanelForBubbleChart2.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color",options.BGcolor)
               lgdPanDivForBubbleChart2.style('width', 35 + "%") .style('height', 52 + "%").style("position","absolute").style("background-color",options.BGcolor)
               }
               
               resizedFuctionForBubbleChart2();
       }
       
           else {
           
                       var selectedLgdItemsMeasures = [];
                       for(var i=0; i<$("#sortable3"+targetElement[0][0].id).children("li").length;i++){
                           selectedLgdItemsMeasures.push(($("#sortable3"+targetElement[0][0].id).children("li")[i].textContent))
                       }
                       
                       var newArr = []
                       selectedLgdItemsMeasures.forEach(function(d,i){
                            options.data.forEach(function(data,j){
                                 if(d.toString() == data[options.keys.legendItems].toString())
                                 {
                                     newArr.push(data)
                                 }
                             })
                                                        
                        })
                       var newOptions = {
                            data: newArr,
                            dataForTable: options.dataForTable,
                            isDataDetailedForTable: options.isDataDetailedForTable,
                            keys: {
                                label: options.keys.label,
                                value: options.keys.value,
                                legendItems:options.keys.legendItems,
                            },
                            chartTitle:options.chartTitle,
                            xAxisLable: options.keys.label,
                            yAxisLable: "",
                            showTitle: true,
                            colorSet: options.colorSet,
                            BGcolor:options.BGcolor,
                            lineStyle: options.lineStyle,
                            drillDownColumnName:options.drillDownColumnName,
                            showTable: options.showTable,
                            showComments: options.showComments,
                            comments: options.comments,
                            resizeButtonID: options.resizeButtonID
                        }
           
                       d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                       acinfotech.bubbleChart2(targetElement,newOptions)
           }
       })
    
    var textBoxForMeasureColumnFrom;
    var textBoxForMeasureColumnTo;
    var selectTitleDivForEachDimension;
    
    $( "ul.droptrue"+targetElement[0][0].id ).sortable({
               appendTo: document.body,
               helper: "clone",
               connectWith: ".droptrue"+targetElement[0][0].id,
               scroll: false,
               cancel: '.unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+','+' .unMoveableIconAndTextClassDimensions'+targetElement[0][0].id,
               revertDuration: 10,
               scrollSensitivity: 10,
               scrollSpeed: 1,
               dynamic: true,
               
               receive: function(e, ui) {
                   
                   if (($(this)[0].id == "sortable3"+targetElement[0][0].id) || ($(this)[0].id == "sortable1"+targetElement[0][0].id)) {
                   
                   if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                   if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                   (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                   }
                   else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                   (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                   }
                   
                   }
                   } // if (($(this)[0].id == "sortable3") || ($(this)[0].id == "sortable1"))
                   
                   else if (($(this)[0].id == "sortable2"+targetElement[0][0].id) || ($(this)[0].id == "sortable4"+targetElement[0][0].id)) {
                   if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                   //ui.sender.sortable("cancel");
                   
                   if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                   (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                   }
                   else if(  ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                   (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                   }
                   }
                   } //if (($(this)[0].id == "sortable2") || ($(this)[0].id == "sortable4")) {
                   
                   $(ui.item).css({ 'position': 'relative' });
                   
                   if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                   ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                   }
                   
                   else if ($(this)[0].id == "sortable3"+targetElement[0][0].id) { // checking if the dropped element is in Measures drop area
                   
                   if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                   ui.sender.sortable("cancel");
                   }
                   else {
                   //ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                   }
                   
                   } // else if ($(this)[0].id == "sortable3") // checking if the dropped element is in Measures drop area ends here.
                   
                   else if ($(this)[0].id == "sortable4"+targetElement[0][0].id) { // checking if the dropped element is in Dimension drop area
                   
                   if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                   ui.sender.sortable("cancel");
                   }
                   else {
                   ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                   }
                   } //else if ($(this)[0].id == "sortable4")  // checking if the dropped element is in Dimension drop area ends here
                   
                   if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                   
                   if ($(this)[0].id == "sortable1"+targetElement[0][0].id){
                   if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                   
                   if( ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                   ui.sender.sortable("cancel");
                   } // if(  ui.sender.attr("id") === "sortable4")
                   
                   else if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                   ui.sender.sortable("cancel");
                   }
                   
                   } // if(ui.item.hasClass("DimesionsClass"))
                   }
                   if ($(this)[0].id == "sortable2"+targetElement[0][0].id){
                   if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                   
                   if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                   ui.sender.sortable("cancel");
                   }
                   else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                   ui.sender.sortable("cancel");
                   
                   }
                   }
                   }
                   
                   } //if ($(this)[0].id == "sortable1")
                   
                   // if ( ($(this)[0].id == "sortable3"+targetElement[0][0].id) || ($(this)[0].id == "sortable4"+targetElement[0][0].id) ){
                   //     if ($(this).children('li').length > 1 ){
                   //         ui.sender.sortable("cancel");
                   //         ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                   //     }
                   // }
                   
                   if ($(this)[0].id == "sortable4"+targetElement[0][0].id){
                   if ($(this).children('li').length > 1 ){
                   ui.sender.sortable("cancel");
                   ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                   }
                   }
               
               }, //receive ends here
               
               start:function(ev, ui) {
               
               },
               stop:function(ev, ui) {
               
               },
        });
    
    /* ----------------- Filter panel and everything within it section ends here -----------------*/
    
    //--------- creating legend-----------
    var legend = svgLegendPanelBubbleChart2.selectAll('.legend') .data(filteredArray)  .enter() .append('g') .attr("class", "legend").style("background-color",options.BGcolor)
    .attr("height", "100%") .attr("width", "100%") .attr('transform', 'translate(0,20)')
    
    //Create colour circles
    var legendGroup = legend .data(filteredArray) .append("rect") .attr("x", 1) .attr("y", function(d, i){ return i * 2;}) .attr("width", 14)
    .attr("height", 14) .attr("rx",10) .attr("ry",10) .style("fill", function(d, i){ return mainArray[i]["colorCode"];}) .style("cursor","auto")
    
    //Create text next to circles
    var legendText = legend .data(filteredArray) .append("text") .attr("x", 18) .attr("y", function(d, i){ return i * 2 + 12;})
    .style("font-family","Verdana,sans-serif") .style('font-size', '14px') .attr("fill","#00001c")
    .text(function(d,i) {
          if(d.legendItems == null || d.legendItems == undefined){
            return "";
          }
          else {
            if(targetElement[0][0].clientWidth >= 800){
                if(d.legendItems.length > 20){ return d.legendItems.substring(0,20)+'...'; }
                else { return d.legendItems; }
            }
            else if(targetElement[0][0].clientWidth < 800){
                if(d.legendItems.length > 20){ return d.legendItems.substring(0,20)+'...'; }
                else { return d.legendItems; }
            }
          }
    })
    
    var xMargin;
    if(targetElement[0][0].clientWidth >= 800){ xMargin = 185; }
    else if(targetElement[0][0].clientWidth < 800){ xMargin = 135; }
    
    var legendTextValue = legend.append('text').data(filteredArray) .attr('x',  xMargin) .attr("y", function(d, i){ return i * 2 + 12;}) .style("font-family","Verdana,sans-serif") .style("font-size", "12px")
    .style('fill','#00001c') .style("font-weight","Normal").attr("class","legend_value").style("display",options.legend)
    .text(function(d,i) {
          if(d.value.toString() === "1e-15"){ return "0"; }
          else {
            if(d.value.toString().indexOf('.') === -1) { return d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); }
            else { return d.value; }
          }
        })
    
    node.on('mouseenter',function(d,i){
        d3.select(this).select('circle') .transition() .ease("bounce") .duration(600) .attr("r", function(d) { return (d.r) + 15; });
    })
    node.on('mouseleave',function(d,i){
        d3.select(this).select('circle') .transition() .ease("bounce") .duration(600) .attr("r", function(d) { return (d.r); });
    })
    
    legendGroup.on('mouseenter',function(d,i){
        d3.select(node[0][i]).select('circle').transition() .ease("bounce") .duration(600) .attr("r", function(d) { return (d.r) + 15; })
    })
    legendGroup.on('mouseleave',function(d,i){
         d3.select(node[0][i]).select('circle').transition() .ease("bounce") .duration(600) .attr("r", function(d) { return (d.r); })
    })
    
    // Aligning Legend (vertically)
    var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(svgLegendPanelBubbleChart2[0][0].style.width) / 100)
    var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(svgLegendPanelBubbleChart2[0][0].style.height) / 100)
    
    var legendRectSize = 11;
    var legendSpacing = 4;
    
    legend.transition().duration(0).attr('transform', function(d, i) {
         var eachRectHeight = legendRectSize + legendSpacing;
         var offset =  eachRectHeight * colors.domain().length / 2;
         var horz = 5;
         //var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.data.length))/2.0; // originally 2.0
         var vert = (i * eachRectHeight)
         return 'translate(' + horz + ',' + vert + ')';
     })
    
    var newDataForBubbleChart2Table = [];
    options.data.forEach(function(d, i) {
         var temp = {};
         
         for(var i = 0; i < Object.keys(d).length; i++) {
         delete d['colorCode'];
         temp[Object.keys(d)[i]] = d[Object.keys(d)[i]]
         }
         
         newDataForBubbleChart2Table.push(temp)
    });
    
    var tableDivForBubbleChart2 = targetElement .append('div')
    .attr("class","scrollingDivForTable-Class tableDivForBubbleChart2" + targetElement[0][0].id) .style('background-color',"#ffffff") .style("position","absolute")
    .style("display","block") .style("overflow","hidden") //.style("border-right","1px solid #e2e2e2").style("border-bottom","1px solid #e2e2e2")
    
    $( '.tableDivForBubbleChart2' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
         var e0 = e.originalEvent,
         delta = e0.wheelDelta || -e0.detail;
         
         this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
         e.preventDefault();
     });
    
    if(options.showTitle == true){
        tableDivForBubbleChart2.style("width", 100 + "%") .style("height", 40 + "%") .style("top",60 + "%")
    }
    else if(options.showTitle == false){
        tableDivForBubbleChart2.style("width", 100 + "%") .style("height", 40 + "%") .style("top",60 + "%")
    }
    
    tableDivForBubbleChart2.html('<table class = "tableClassForBubbleChart2' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                 '<thead class = "theadClassForBubbleChart2' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForBubbleChart2' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                                 '<tbody class = "tBodyClassForBubbleChart2' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                 '</table>'
                                 )
    
    tableDivForBubbleChart2.select('table').attr("id",targetElement[0][0].id + "tableID")
    
    // Show or Hide Table scroll bar when mouseover on widget
    targetElement.on('mouseover',function(){ tableDivForBubbleChart2.style("overflow","auto") })
    targetElement.on('mouseout',function(d){ tableDivForBubbleChart2.style("overflow","hidden") })
    
    var dataSetForBubbleChart2Table = [];
    if(options.dataForTable.length > 0){
        dataSetForBubbleChart2Table = options.dataForTable;
    }
    else {
        dataSetForBubbleChart2Table = newDataForBubbleChart2Table;
    }
    
    var thead = tableDivForBubbleChart2.select("thead").selectAll("th") .data(d3.keys(dataSetForBubbleChart2Table[0]))
    .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
    
    var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#fefdfd")//f6f6f6
    .style("position","relative").style("top","2px")
    
    var thead1 = d3.select(".thead1ClassForBubbleChart2" + targetElement[0][0].id).selectAll("th") .data(d3.keys(dataSetForBubbleChart2Table[0]))
    .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
    
    var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#fefdfd")//f6f6f6
    .style("position","relative").style("top","2px")
    
    var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
    .attr("id", "ascendingIconIDForBubbleChart2") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
    
    var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
    .attr("id", "descendingIconIDForBubbleChart2") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
    
    var tr = tableDivForBubbleChart2.select("tbody").selectAll("tr") .data(dataSetForBubbleChart2Table).enter().append("tr")
    .attr("id", function(d,i) { return "slice" + i })
    
    // cells
    var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d; })
    .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
    
    var $table = $('.tableClassForBubbleChart2' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
    
    d3.select(".theadClassForBubbleChart2" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
        d.forEach(function(dd,j){
                colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
        })
    })
    
    $(".thead1ClassForBubbleChart2" + targetElement[0][0].id).insertAfter('.tBodyClassForBubbleChart2' + targetElement[0][0].id)
    
    $(".thead1ClassForBubbleChart2" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForBubbleChart2' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
    
    tableDivForBubbleChart2.select(".thead1ClassForBubbleChart2" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                                                                                                                   
            d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
    })
    
    $('.tableDivForBubbleChart2' + targetElement[0][0].id).scroll(function () {
                                                               
        $(".thead1ClassForBubbleChart2" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForBubbleChart2' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
                                                               
    })
    
    var sortOrder = false;
    thead1.on("click",function(k,index){
             
         sortOrder = !sortOrder;
         
         tableDivForBubbleChart2.select(".thead1ClassForBubbleChart2" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                                                      
              if (sortOrder) {
              
                 if(i == index){
                      d3.select(this).select('svg').select('#descendingIconIDForBubbleChart2').style("visibility", "hidden")
                      d3.select(this).select('svg').select('#ascendingIconIDForBubbleChart2').style("visibility", "visible")
                  }
                  else {
                      d3.select(this).select('svg').select('#descendingIconIDForBubbleChart2').style("visibility", "visible")
                      d3.select(this).select('svg').select('#ascendingIconIDForBubbleChart2').style("visibility", "visible")
                  }
                }
              else{
              
                  if(i == index){
                      d3.select(this).select('svg').select('#descendingIconIDForBubbleChart2').style("visibility", "visible")
                      d3.select(this).select('svg').select('#ascendingIconIDForBubbleChart2').style("visibility", "hidden")
                  }
                  else {
                      d3.select(this).select('svg').select('#descendingIconIDForBubbleChart2').style("visibility", "visible")
                      d3.select(this).select('svg').select('#ascendingIconIDForBubbleChart2').style("visibility", "visible")
                  }
              }
         })
         
          var monthTruOrFalAryForBubbleChart2 = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
          
          tr.sort(function(a, b) {
                  
                  if (sortOrder) {
                  var monthsArrayForBubbleChart2 = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                  } else {
                  var monthsArrayForBubbleChart2 = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                  }
                  
                  monthTruOrFalAryForBubbleChart2 = []; gotMonthArray = [];
                  dataSetForBubbleChart2Table.forEach(function(d,i){
                      var da = d[k].toString().substring(0,3).toLowerCase()
                      if(monthsArrayForBubbleChart2.indexOf(da) >= 0){
                          monthTruOrFalAryForBubbleChart2.push(true)
                          gotMonthArray.push(da);
                      }
                      else {
                          monthTruOrFalAryForBubbleChart2.push(false)
                      }
                  })
                  
                  if(monthTruOrFalAryForBubbleChart2.indexOf(false) == -1){ // true
                  
                  monthArray = []; monthArrayCount = [];
                  gotMonthArray.forEach(function(dd,j){
                        var index1 = monthsArrayForBubbleChart2.indexOf(dd.substring(0,3))
                        if(monthArrayCount.indexOf(index1) >= 0){
                            index1 = 12 + index1;
                        }
                        monthArray.push(index1);
                        monthArrayCount.push(index1)
                    })
                  returnArray = []
                  monthArray.sort(function(aa, bb) {
                      returnArray.push(+aa - +bb)
                      return +aa - +bb;
                  })
                  
                  sortTableFunc()
                  return returnArray[ind++];
                  } //  if true (if jan feb if block)
                  else {
                  var data = +a[k];
                  
                  if(!isNaN(data)){
                  
                  if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                    else { return d3.descending(+a[k], +b[k]); }
                  }
                  else if(!isNaN(Date.parse(a[k]))){
                  
                  if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                    else { return new Date(b[k]) - new Date(a[k]) }
                  }
                  else {
                  
                  if (sortOrder) { return d3.ascending(a[k], b[k]); }
                    else { return d3.descending(a[k], b[k]); }
                  }
                  } // if not jan feb else block
            }); // tr

    })
    
    function sortTableFunc(){
        
        var table = tableDivForBubbleChart2.select('table');
        var rows = table.selectAll('tr').data(dataSetForBubbleChart2Table);
        var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
        cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0) .style("color","#00001c");
        
        cells.text(function(d,i) {return d});
        
        // Cells exit selection
        cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
        
        var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
        
        cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500)
        .style('opacity', 1.0).style("color","#00001c");
        
        cells_in_new_rows.text(function(d,i) {return d});
        
        rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
    }
    
    // Main Table Styling
    tableDivForBubbleChart2.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
    .style("color","#00001c")
    .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4") //.style("box-shadow","10px 10px 50px #007aff").style("z-index",9999)
    tableDivForBubbleChart2.selectAll('td').style("height","25px") .style("border", "1px solid #ffffff") .style("font-size","12px").style("font-weight","Normal").style("color","#00001c")
    
    //additionally 
    tableDivForBubbleChart2.selectAll('th').style('background-color',"#ffffff").style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
    tableDivForBubbleChart2.selectAll('td').style("border-style","none").style("color","#00001c")
    //tablePanelForPieChart.selectAll('td').style("height","25px") .style("border", "1px solid #fcfcfc") .style("font-size","12px").style("font-weight","Normal")
    
    //b1da9f
    tableDivForBubbleChart2.selectAll('table') . style("border-collapse","collapse")
    tableDivForBubbleChart2.selectAll('table tr:first-child th').style("border-top","0px")
    tableDivForBubbleChart2.selectAll('table tr:last-child td').style("border-bottom","0px")
    tableDivForBubbleChart2.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
    tableDivForBubbleChart2.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")
    
    if(showOrHideTableForBubbleChart2 == false){
        tableDivForBubbleChart2.style("display","none")
    }
    else if(showOrHideTableForBubbleChart2 == true){
        tableDivForBubbleChart2.style("display","block")
    }
    
    if(options.isDataDetailedForTable == false){
        
        var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
        
        // Adding underlines for selected drill-down column text
        var drillDownSectionsForBubbleChart = tableDivForBubbleChart2.select('table').selectAll('th')
        
        var foundResult = [];
        for(var i = 0; i<drillDownSectionsForBubbleChart[0].length; i++){
            for(var j = 0; j<drillDownColumnNamesArray.length; j++){
                if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForBubbleChart[0][i].__data__.toString().toLowerCase() ){
                    foundResult.push(i)
                }
            }
        }
        
        var r = tableDivForBubbleChart2.select('table').selectAll('tr').selectAll('td')
        for(var i = 0; i<r.length; i++){
            for(var j = 0; j < foundResult.length; j++){
                var row = r[i][foundResult[j]]
                $(row).css("text-decoration", "underline")
            }
        }
    }
    
    //By default calling the resized function first time (to align table's th and td).
    setTimeout(function(){ resizedFuctionForBubbleChart2() },1000)
      
    window.addEventListener('resize', function(event){ resizedFuctionForBubbleChart2() });
    
    $(function() {
      $("#" + targetElement[0][0].id).resizable({
            resize: function(event, ui) {
                resizedFuctionForBubbleChart2();
            }
        });
      });
    
    function resizedFuctionForBubbleChart2()
    {
        
        if((svgPanelForBubbleChart2.node().getBoundingClientRect().width) && (svgPanelForBubbleChart2.node().getBoundingClientRect().height) > 0){
            
            if(showOrHideCommentsBtnForBubbleChart2 == true){
                treeMapBtnForBubbleChart.style('margin-left', "2px")
                filterButtonForBubbleChart2.style('margin-left', "2px")
                refreshButtonForBubbleChart2.style('margin-left', "2px")
                commentsBtnForBubbleChart2.style('margin-left', "2px")
                menuBtnForBubbleChart2.style('right', '0')
            }
            else if(showOrHideCommentsBtnForBubbleChart2 == false){
                treeMapBtnForBubbleChart.style('margin-left', "2px")
                filterButtonForBubbleChart2.style('margin-left', "2px")
                refreshButtonForBubbleChart2.style('margin-left', "2px")
                //commentsBtnForBubbleChart2.style('right', '0')
                commentsBtnForBubbleChart2.style('display','none')
                menuBtnForBubbleChart2.style('right', '0')
            }
            
            
            optionsBtnPanelForBubbleChart2.style('right', '0')
            
            stgPanCanBtnForBubbleChart2.style('right', '0')
            
            var diameterWidthNew = document.getElementById("svgPanelIDForBubbleChart2" + targetElement[0][0].id).getBoundingClientRect().width//svgPanelForBubbleChart2[0][0].clientWidth;
            var diameterHeightNew = document.getElementById("svgPanelIDForBubbleChart2" + targetElement[0][0].id).getBoundingClientRect().height//svgPanelForBubbleChart2[0][0].clientHeight;
            
            // var diameterWidthNew = ($('#svgPanelIDForBubbleChart2' + targetElement[0][0].id)[0].getBoundingClientRect().width)
            // var diameterHeightNew = ($('#svgPanelIDForBubbleChart2' + targetElement[0][0].id)[0].getBoundingClientRect().height)
            
            var bubble_layoutNew = d3.layout.pack() .sort(null) .size([diameterWidthNew,diameterHeightNew]) .padding(1.5);
            
            //var BubbleChart2SVG = svgPanelForBubbleChart2.append("svg")//.style("background","#606060")
            bubbleChart2SVG .attr("width" , diameterWidthNew) .attr("height", diameterHeightNew)
            
            var filteredArrayNew = [];
            newJson.forEach(function(d,i){ 
                var temp = {};
                temp[options.keys.label] = d[options.keys.label]
                temp["value"] = d[options.keys.value]
                filteredArrayNew.push(temp)
            })
            
            var selectionNew = bubbleChart2SVG.selectAll("g.node")
            .data(bubble_layoutNew.nodes({children: filteredArray}).filter(function(d) { return !d.children; }) ); 
            
            node .attr("transform", function(d) { return "translate(" + d.x + ", " + d.y + ")"; }).filter( function(d,i){if(d.value == 0){ d.value = 0.000000000000001;
                                                                                                          d3.select(selection[0][i]).style("display","none"); }; return d.value > 0; }).select("circle") .attr("r", function(d) { return d.r; })
            
            legendText.transition().text(function(d,i) {
             if(targetElement[0][0].clientWidth >= 800){
                 if(d.legendItems.length > 20){ return d.legendItems.substring(0,20)+'...'; }
                    else { return d.legendItems; }
             }
             else if(targetElement[0][0].clientWidth < 800){
                 if(d.legendItems.length > 20){ return d.legendItems.substring(0,20)+'...'; }
                 else { return d.legendItems; }
             }
            })
            
            
            if(targetElement[0][0].clientWidth >= 800){ xMargin = 185 }
            else if(targetElement[0][0].clientWidth < 800){ xMargin = 135 }
            legendTextValue.transition().attr('x',  xMargin)
            
            var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(svgLegendPanelBubbleChart2[0][0].style.width) / 100)
            var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(svgLegendPanelBubbleChart2[0][0].style.height) / 100)
            
            var legendRectSize = 11;
            var legendSpacing = 4;
            
            legend.attr('transform', function(d, i) {
                var eachRectHeight = legendRectSize + legendSpacing;
                var height = legendRectSize + legendSpacing;
                var offset =  height * colors.domain().length / 2;
                var horz = 5;
                //var vert = (i * height) + (legendPanelHeight - (height * newJson.length))/2 ;
                //var vert = 10;
                var vert = (i * eachRectHeight)
                return 'translate(' + horz + ',' + vert + ')';
            })
            
            colWidth = []; 
			
            d3.select(".theadClassForBubbleChart2" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                    d.forEach(function(dd,j){
                        colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                    })
            })
            tableDivForBubbleChart2.select(".thead1ClassForBubbleChart2" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
            })
            
        }// checking svg panel width & height greater that zero function
        
    }
    }, //bubbleChart2
    
    // ************************************************** Stacked Horizontal Bar Chart 2 **************************************************
    stackedHorizontalBarChart2: function(targetElement, options){
    
    isChartCalled++;
    
    var chartName = "STACKEDHORIZONTALBARCHART2";
    
    acinfotech.allCharts(targetElement,options,chartName)
    
    targetElement.style("min-width", "350px") .style("min-height", "350px").style("background-color", options.BGcolor)
    
    var showOrHideTableForStkHoriChart2;
    var showOrHideCommentsForStkHoriChart2;
    var showOrHideCommentsBtnForStkHoriChart2 = true;
    
    if((options.showTable == false) || (options.showTable == true)){
        showOrHideTableForStkHoriChart2 = options.showTable;
    }
    else{
        showOrHideTableForStkHoriChart2 = false;
    }
    
    // Show or Hide comments
    if (options.showComments == true || false) {
        showOrHideCommentsForStkHoriChart2 = options.showComments;
    }
    else {
        showOrHideCommentsForStkHoriChart2 = false;
    }
    
    if (options.comments.length == 0){
        showOrHideCommentsForStkHoriChart2 = false;
        showOrHideCommentsBtnForStkHoriChart2 = false;
    }
    
    if ((showOrHideTableForStkHoriChart2 == true) && (showOrHideCommentsForStkHoriChart2 == true)){
        showOrHideTableForStkHoriChart2 = true;
        showOrHideCommentsForStkHoriChart2 = false;
    }
    else if ((showOrHideTableForStkHoriChart2 == false) && (showOrHideCommentsForStkHoriChart2 == false)){
        showOrHideTableForStkHoriChart2 = false;
        showOrHideCommentsForStkHoriChart2 = false;
    }
    
    var chartTitlePanelForStackedHoriBarChart2 =  targetElement.append("div").style("background-color", options.BGcolor).style("position","absolute").style("text-align", "left")
    .style("text-indent","6px")
    
	var optsBtnPanelForStkHoriChart2 = targetElement.append('div').style('width',"25px").style('height',"160px").style('position','absolute')
    .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px") .style("min-width","25px")
    .style('right', '0') .style("border-style","none").style("border-left", "solid #fcfcfc  1px")
	
    var filterBtnForStackedHoriBarChart2 = optsBtnPanelForStkHoriChart2.append("div") .style("width","20px").style("height","20px").style('position','absolute')
    .style('background-color',"#ffffff").style("z-index",10)
    .style('top','80px') .style("cursor","pointer").style("display","block")
    .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
    var filterBtnImgVar = document.createElement("IMG");
    filterBtnImgVar.src = "images/filterIcon.png";
    filterBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
    filterBtnForStackedHoriBarChart2[0][0].appendChild(filterBtnImgVar)
    
    var refreshBtnForStackedHoriBarChart2 = optsBtnPanelForStkHoriChart2.append("div") .style("width","20px").style("height","20px").style('position','absolute')
    .style('background-color',"#ffffff").style("z-index",10)
    .style('top','105px') .style("cursor","pointer").style("display","block")
    .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
    var refreshBtnImgVar = document.createElement("IMG");
    refreshBtnImgVar.src = "images/refreshIcon.png";
    refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
    refreshBtnForStackedHoriBarChart2[0][0].appendChild(refreshBtnImgVar)
    
    var commentsBtnForStkHoriBarChart2 = optsBtnPanelForStkHoriChart2.append("div") .style("width","20px").style("height","20px").style('position','absolute')
    .style('background-color',"#ffffff").style("z-index",10)
    .style('top','130px') .style("cursor","pointer").style("display","block")
    .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
    var commentsBtnImgVariable = document.createElement("IMG");
    if(options.showComments == false){
        commentsBtnImgVariable.src = "images/showCommentsIcon.png";
    }
    else if(options.showComments == true){
        commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
    }
    commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
    commentsBtnForStkHoriBarChart2[0][0].appendChild(commentsBtnImgVariable)
    
    var menuBtnForStackedHoriBarChart2 = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
    .style('background-color',"#ffffff").style("z-index",10)
    .style('top','1px') .style("cursor","pointer").style("display","block")
    .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
    var menuBtnImgVar = document.createElement("IMG");
    menuBtnImgVar.src = "images/menuIcon.png";
    menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
    menuBtnForStackedHoriBarChart2[0][0].appendChild(menuBtnImgVar)
    
    if(showOrHideCommentsBtnForStkHoriChart2 == true){
        filterBtnForStackedHoriBarChart2.style('margin-left', "2px")
        refreshBtnForStackedHoriBarChart2.style('margin-left', "2px")
        commentsBtnForStkHoriBarChart2.style('margin-left', "2px")
        menuBtnForStackedHoriBarChart2.style('right', '0')
    }
    else if(showOrHideCommentsBtnForStkHoriChart2 == false){
        filterBtnForStackedHoriBarChart2.style('margin-left', "2px")
        refreshBtnForStackedHoriBarChart2.style('margin-left', "2px")
        //commentsBtnForStkHoriBarChart2.style('right', '0')
        commentsBtnForStkHoriBarChart2.style('display','none')
        menuBtnForStackedHoriBarChart2.style('right', '0')
    }
    
    var ismenuBtnOfStkHoriChart2Clicked = false;
    menuBtnForStackedHoriBarChart2.on('click', function() {
                                      
          filterPanelForStkHoriChart2.style("display","none")
          
          stgPanDivForStkHoriChart2.style('display','none')
          
          if ((showOrHideTableForStkHoriChart2 == false) && (showOrHideCommentsForStkHoriChart2 == true)){
          divLegendPanelStackedHoriBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
          .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
          
          svgPanelForStackedHoriBarChart2.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
          .style("position","absolute").style("background-color", options.BGcolor);
          }
          else if ((showOrHideTableForStkHoriChart2 == true) && (showOrHideCommentsForStkHoriChart2 == false)){
          divLegendPanelStackedHoriBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
          .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
          
          svgPanelForStackedHoriBarChart2.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
          .style("position","absolute").style("background-color", options.BGcolor);
          }
          else if ((showOrHideTableForStkHoriChart2 == false) && (showOrHideCommentsForStkHoriChart2 == false)){
          divLegendPanelStackedHoriBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
          .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
          
          svgPanelForStackedHoriBarChart2.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
          .style("position","absolute").style("background-color", options.BGcolor);
          }
          
          if(ismenuBtnOfStkHoriChart2Clicked == false){
          ismenuBtnOfStkHoriChart2Clicked = true;
          optsBtnPanelForStkHoriChart2.style("display","block")
          
          }
          else if(ismenuBtnOfStkHoriChart2Clicked == true){
          ismenuBtnOfStkHoriChart2Clicked = false
          optsBtnPanelForStkHoriChart2.style("display","none")
          }
          
          resizedFuctionForStackedHoriChart2()
    })
    
    var tableButtonForStkHoriChart2 = optsBtnPanelForStkHoriChart2.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
    .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top','1px')
    .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
    var tableBtnImgVar = document.createElement("IMG");
    if(showOrHideTableForStkHoriChart2 == false){
        tableBtnImgVar.src = "images/showTableIcon.png";
        tableButtonForStkHoriChart2.attr("class","showTableClassForChartTable")
    }
    else if(showOrHideTableForStkHoriChart2 == true){
        tableBtnImgVar.src = "images/cancelTableIcon.png";
        tableButtonForStkHoriChart2.attr("class","hideTableClassForChartTable")
    }
    tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
    tableButtonForStkHoriChart2[0][0].appendChild(tableBtnImgVar)
    
    var settingBtnForStkHoriChart2 = optsBtnPanelForStkHoriChart2.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
    .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 28 + 'px')
    .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
    var settingBtnImgVar = document.createElement("IMG");
    settingBtnImgVar.src = "images/settingsIcon.png";
    settingBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.82;")
    settingBtnForStkHoriChart2[0][0].appendChild(settingBtnImgVar)
    
    var downloadBtnForStkHoriChart2 = optsBtnPanelForStkHoriChart2.append("div").attr("id","downloadBtnForStkHoriChart2-ID-" + targetElement[0][0].id).style("width","20px").style("height","20px")
    .style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff").style('margin-left','2px').style('top', 54 + 'px')
    .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
    
    acinfotech.downloadFunctionality("downloadBtnForStkHoriChart2-ID-" + targetElement[0][0].id,targetElement)
        
    var svgPanelForStackedHoriBarChart2 = targetElement .append('svg') 
    .attr("id","svgPanelIDForStackedHoriBarChart2" + targetElement[0][0].id) .style("background-color", options.BGcolor) .style("position","absolute")
    .style("border","0px solid #d0d0d0")
    
    var commentsPanelDivForStkHoriChart2 = targetElement.append("div") .attr("class","commentsPanelClassForSHBChart2")
    .style("background-color", options.BGcolor) .style('position',"absolute").style("text-indent","8px")
	.style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
    .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)
    
    commentsPanelDivForStkHoriChart2.on('click',function(d){
        $('.commentsClassForStkHoriChart2' + targetElement[0][0].id).focus()
    })
    
    if(options.showTitle == true){
        
        chartTitlePanelForStackedHoriBarChart2.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 8 + "%"; })
        .html('<div  style="width: 100%; height:0%; background-color:options.BGcolor; position: absolute; top:25.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')
        
        if ((showOrHideTableForStkHoriChart2 == false) && (showOrHideCommentsForStkHoriChart2 == true)){
            
            var commentsForLineChart2 = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
            .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
            .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
            .css('line-height','1.1em').css('text-align','justify') .attr('class','commentsClassForStkHoriChart2' + targetElement[0][0].id)
            
            svgPanelForStackedHoriBarChart2.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .append('g')
            commentsPanelDivForStkHoriChart2.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
            .style("top",78 + "%")
            .html(commentsForLineChart2[0].outerHTML.toString())
            
        }
        else if ((showOrHideTableForStkHoriChart2 == true) && (showOrHideCommentsForStkHoriChart2 == false)){
            
            svgPanelForStackedHoriBarChart2.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .append('g')
            commentsPanelDivForStkHoriChart2.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
        }
        else if ((showOrHideTableForStkHoriChart2 == false) && (showOrHideCommentsForStkHoriChart2 == false)){
            svgPanelForStackedHoriBarChart2.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .append('g')
            commentsPanelDivForStkHoriChart2.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
        }
        
        var margin = {top: 10 , right: 20, bottom: 20, left: 130}, //originally top: 42, left: 80
        width = (svgPanelForStackedHoriBarChart2.node().getBoundingClientRect().width) - margin.left - margin.right,
        height = svgPanelForStackedHoriBarChart2.node().getBoundingClientRect().height - margin.top - margin.bottom;
        
    }
    else if(options.showTitle == false){
        chartTitlePanelForStackedHoriBarChart2.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });
        
        if ((showOrHideTableForStkHoriChart2 == false) && (showOrHideCommentsForStkHoriChart2 == true)){
            
            var commentsForStkHoriChart2 = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
            .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
            .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
            .css('line-height','1.1em').css('text-align','justify')
            
            svgPanelForStackedHoriBarChart2.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .append('g')
            commentsPanelDivForStkHoriChart2.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
            .style("top",78 + "%")
            .html(commentsForStkHoriChart2[0].outerHTML.toString())
            
        }
        else if ((showOrHideTableForStkHoriChart2 == true) && (showOrHideCommentsForStkHoriChart2 == false)){
            
            svgPanelForStackedHoriBarChart2.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .append('g')
            commentsPanelDivForStkHoriChart2.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
        }
        else if ((showOrHideTableForStkHoriChart2 == false) && (showOrHideCommentsForStkHoriChart2 == false)){
            svgPanelForStackedHoriBarChart2.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .append('g')
            commentsPanelDivForStkHoriChart2.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
        }
        
        var margin = {top: 10, right: 20, bottom: 20, left: 130}, //originally top: 42, left: 80
        width = (svgPanelForStackedHoriBarChart2.node().getBoundingClientRect().width) - margin.left - margin.right,
        height = svgPanelForStackedHoriBarChart2.node().getBoundingClientRect().height - margin.top - margin.bottom;
    }
    
    var colours;
    // checking color set for pie slices and legend dots
    if(options.colorSet === undefined){
        options.colorSet = "one" // fdce58
        colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
    }
    else if(options.colorSet.toString().toLowerCase() === "one"){
        options.colorSet = "one"
        colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
    }
    else if(options.colorSet.toString().toLowerCase() === "two"){
        options.colorSet = "two"
        colours = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
    }
    else if(options.colorSet.toString().toLowerCase() === "three"){
        options.colorSet = "three"
        colours = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
    }
    else
    {
        options.colorSet = "one"
        colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
    }
    /*------------------ Settings panel DIV and everything within it section begins here ------------------*/
    
    var stgPanDivForStkHoriChart2 = targetElement.append('div').style('width',"100%").style('height',"40%").attr("class","stgPanDivForStkHoriChart2" + targetElement[0][0].id)
    .style('position','absolute').style('margin-left', "0px").style('border-top',"1px solid #f0f0f0").style('border-bottom',"1px solid #e5e5e5")
    .style("background-color",'#fcfcfc').style("z-index",90) .style("display","none") .style('top',"60%").style('height',"40%")
    
    $( '.stgPanDivForStkHoriChart2' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
           var e0 = e.originalEvent,
           delta = e0.wheelDelta || -e0.detail;
           
           this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
           e.preventDefault();
    });
    
    var settingPanelTitle = stgPanDivForStkHoriChart2.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
    .style('margin-left','0px').style('margin-top','10px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
    .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
    .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; color:#00001c;">'+ "Settings" +'</div>')
    
    var stgPanDivForStkHoriChangeColorTitle = stgPanDivForStkHoriChart2.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
    .style('margin-left','0px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
    .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
    .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Select color set " +'</div>')
    
    var stgPanCanBtnForStkHoriChart2 = stgPanDivForStkHoriChart2.append("div") .style("width","18px").style("height","17px").style('position','absolute')
    .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
    .style('background-color',"#FCFCFF")
    .style("border", "0.0px") .style("border-style", "solid").style('color','white')
    .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
    var cancelBtnImgVar = document.createElement("IMG");
    cancelBtnImgVar.src = "images/closeIcon.png";
    cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.9; background-color:#fcfcff")
    stgPanCanBtnForStkHoriChart2[0][0].appendChild(cancelBtnImgVar)
    
    stgPanCanBtnForStkHoriChart2.on('click', function() {
            stgPanDivForStkHoriChart2.style("display","none") // Hiding setting panel
                                    
            if ((showOrHideTableForStkHoriChart2 == false) && (showOrHideCommentsForStkHoriChart2 == true)){
            divLegendPanelStackedHoriBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
            
            svgPanelForStackedHoriBarChart2.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
            .style("position","absolute");
            }
            else if ((showOrHideTableForStkHoriChart2 == true) && (showOrHideCommentsForStkHoriChart2 == false)){
            divLegendPanelStackedHoriBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
            
            svgPanelForStackedHoriBarChart2.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute");
            }
            else if ((showOrHideTableForStkHoriChart2 == false) && (showOrHideCommentsForStkHoriChart2 == false)){
            divLegendPanelStackedHoriBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
            
            svgPanelForStackedHoriBarChart2.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute");
            }
            
            resizedFuctionForStackedHoriChart2();
    })
    
    var formForChangeSettingsPanel = stgPanDivForStkHoriChart2.append("form");
    formForChangeSettingsPanel.style("background-color","#fcfcfc").style("margin-top","67px").style("font-family","Verdana,sans-serif").style("font-size","12px")
    .style("position","absolute").attr("id","formForChangeColorSettingsPanel" + targetElement[0][0].id).style("font-weight","Bold").style("width","180px")
    .style("height","58px").style("padding","0px").style("border-radius","0px") .style("margin-left","10px")
    
    var svgPanelForCrSetOne = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
    .style("width","160px").style("height","18px").style("margin-top","1px").style("margin-left","0px") .style("box-sizing","border-box")
    
    var colorSetOne = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
    var colorSetOneRange = d3.range(12);
    
    var colorSetOneDots = svgPanelForCrSetOne.append("g")
    colorSetOneDots.selectAll('rect') .data(colorSetOneRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
    .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("fill", function(d,i){return colorSetOne(i)})
    .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)  .style("stroke",function(d,i){  return colorSetOne(i); })
    .style("cursor","auto") .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
    
    var svgPanelForCrSetTwo = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
    .style("width","160px").style("height","18px").style("margin-top","20px").style("margin-left","0px") .style("box-sizing","border-box")
    
    var colorSetTwo = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
    var colorSetTwoRange = d3.range(12);
    
    var colorSetTwoDots = svgPanelForCrSetTwo.append("g")
    colorSetTwoDots.selectAll('rect') .data(colorSetTwoRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
    .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto")
    .style("fill", function(d,i){return colorSetTwo(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
    .style("stroke",function(d,i){  return colorSetTwo(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
    
    var svgPanelForCrSetThree = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
    .style("width","160px") .style("height","18px") .style("margin-top","39px") .style("margin-left","0px") .style("box-sizing","border-box")
    
    var colorSetThree = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
    var colorSetThreeRange = d3.range(12);
    
    var colorSetThreeDots = svgPanelForCrSetThree.append("g")
    colorSetThreeDots.selectAll('rect') .data(colorSetThreeRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
    .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto")
    .style("fill", function(d,i){return colorSetThree(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
    .style("stroke",function(d,i){  return colorSetThree(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
    
    if(options.colorSet.toString().toLowerCase() === "one"){
        svgPanelForCrSetOne.style('border',"1px solid #808080")
        svgPanelForCrSetTwo.style('border',"0px solid #808080")
        svgPanelForCrSetThree.style('border',"0px solid #808080")
    }
    else if(options.colorSet.toString().toLowerCase() === "two"){
        svgPanelForCrSetOne.style('border',"0px solid #808080")
        svgPanelForCrSetTwo.style('border',"1px solid #808080")
        svgPanelForCrSetThree.style('border',"0px solid #808080")
    }
    else if(options.colorSet.toString().toLowerCase() === "three"){
        svgPanelForCrSetOne.style('border',"0px solid #808080")
        svgPanelForCrSetTwo.style('border',"0px solid #808080")
        svgPanelForCrSetThree.style('border',"1px solid #808080")
    }
    else
    {
        svgPanelForCrSetOne.style('border',"1px solid #808080")
        svgPanelForCrSetTwo.style('border',"0px solid #808080")
        svgPanelForCrSetThree.style('border',"0px solid #808080")
    }
    
    svgPanelForCrSetOne.on('click',function(d){
       options.colorSet = "one"
       svgPanelForCrSetOne.style('border',"1px solid #808080")
       svgPanelForCrSetTwo.style('border',"0px solid #808080")
       svgPanelForCrSetThree.style('border',"0px solid #808080")
       
       colours = "";
       colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
       
       groupsForStackedHoriBarChart2.style('fill', function (d, i) { return colours(i); })
       
       legendGroup.style("fill", function(d, i){ return colours(i);})
                           
    })
    svgPanelForCrSetTwo.on('click',function(d){
       options.colorSet = "two"
       svgPanelForCrSetOne.style('border',"0px solid #808080")
       svgPanelForCrSetTwo.style('border',"1px solid #808080")
       svgPanelForCrSetThree.style('border',"0px solid #808080")
       
       colours = "";
       colours = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
       
       groupsForStackedHoriBarChart2.style('fill', function (d, i) { return colours(i); })
       legendGroup.style("fill", function(d, i){ return colours(i);})
    })
    svgPanelForCrSetThree.on('click',function(d){
         options.colorSet = "three"
         svgPanelForCrSetOne.style('border',"0px solid #808080")
         svgPanelForCrSetTwo.style('border',"0px solid #808080")
         svgPanelForCrSetThree.style('border',"1px solid #808080")
         
         colours = "";
         colours = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
         
         groupsForStackedHoriBarChart2.style('fill', function (d, i) { return colours(i); })
         legendGroup.style("fill", function(d, i){ return colours(i);})
    })
    
    //------------------ Settings panel DIV and everything inside it section ends here ------------------
    
    //------------- adding legend section ------------
    var divLegendPanelStackedHoriBarChart2 = targetElement .append('div')  .attr("class","divLegendPanelClassForStackedHoriBarChart2").style("background-color", options.BGcolor).style('position',"absolute")
    //.style('width', 25 + "%") .style('height', 92 + "%") .style("left",75 + "%").style("top",8 + "%")
    
    if ((showOrHideTableForStkHoriChart2 == false) && (showOrHideCommentsForStkHoriChart2 == true)){
        divLegendPanelStackedHoriBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
        .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
        
        svgPanelForStackedHoriBarChart2.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
        .style("position","absolute");
    }
    else if ((showOrHideTableForStkHoriChart2 == true) && (showOrHideCommentsForStkHoriChart2 == false)){
        divLegendPanelStackedHoriBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
        .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
        
        svgPanelForStackedHoriBarChart2.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
        .style("position","absolute");
    }
    else if ((showOrHideTableForStkHoriChart2 == false) && (showOrHideCommentsForStkHoriChart2 == false)){
        divLegendPanelStackedHoriBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
        .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
        
        svgPanelForStackedHoriBarChart2.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
        .style("position","absolute");
    }
    
    // ------------ creating legend -----------
    var legendPanelSvgForStackedHoriBarChart2 = divLegendPanelStackedHoriBarChart2 .append('svg')  .attr("class","") .style('background-color',"#ffffff") .style('position',"absolute")
    .style('width', 100 + "%") .style('height', 100 + "%") .style("left",0 + "%").style("top",0 + "%")
        
    var legend = legendPanelSvgForStackedHoriBarChart2.append("g") .attr("class", "legend") .attr("height", "100%") .attr("width", "100%")
    .attr('transform', 'translate(0,20)')
    
    //Create colour squares
    var legendGroup = legend.selectAll('rect') .data(options.data) .enter() .append("rect")
    .attr("x", 5) .attr("y", function(d, i){ return i * 16;}) .attr("width", 14) .attr("height", 14) .attr("rx",10) .attr("ry",10)
    .style("fill", function(d, i){ return colours(i);}) .style("cursor","auto")
    
    //Create text next to squares
    legend.selectAll('text') .data(options.data) .enter() .append("text") .attr("x", 25) .attr("y", function(d, i){ return i * 16 + 11.8;})
    .attr("fill", "#737373").text(function(d,i) {
        if(d[options.keys.stackedBars].length>10){
        return d[options.keys.stackedBars].substring(0,10)+'...';
            } 
        else{return d[options.keys.stackedBars];} }) .style('font-size', '14px') .attr("fill","#00001c").style("font-family","Verdana,sans-serif")
    //.text(function(d) { return d; })
    
    
    // Aligning Legend (vertically)
    var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelStackedHoriBarChart2[0][0].style.width) / 100)
    var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelStackedHoriBarChart2[0][0].style.height) / 100)
    
    var legendRectSize = 11;
    var legendSpacing = 4;
    
    legend.transition().duration(0).attr('transform', function(d, i) {
         var eachRectHeight = legendRectSize + legendSpacing;
         var offset =  eachRectHeight * colours.domain().length / 2;
         var horz = 5;
         var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.data.length))/2.0; // originally 2.0
         
         return 'translate(' + horz + ',' + vert + ')';
    })
    
    legendGroup.on('mouseover',function(d,i){
                   
       if(options.keys.stackedBars.length > 1){ // to check if the stack set is more than 1
           if(xScale1GlobalVar == undefined){ // to check whether the widget is being resized or not (to save new xScale)
               xScale1GlobalVar = xScale;
           }
           
           textOnStackedHoriBarChart2.style('display','none')
           
           d3.select(groupsForStackedHoriBarChart2[0][i]).selectAll('text').style('display','block')
           .transition().duration(1000).ease('bounce').attr("x", function(d,i) {return xScale1GlobalVar(d.x) + 5;  })
           .style("fill", "#00001c") .style("text-shadow","0px 0px 0px rgba(34,34,34,0.6)")
           .text(function(d){
                 
                 if(d.x.toString().toString().indexOf('.') === -1)
                 {
                     return d.x.toString().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                     //return format1(d.x)
                 }
                 else{
                 
                     return d.x.toString();
                 }
                     //return format1(d.x);
            })
           
           groupsForStackedHoriBarChart2.selectAll('rect').style('display','none')
           var g = d3.select(groupsForStackedHoriBarChart2[0][i]).selectAll('rect').style('display','block')
           .transition().duration(1000).ease('bounce')
           .attr("x", function(d,i) {return 0; })
       }
    })
    
    legendGroup.on('mouseout',function(d,i){
       
       if(xScale1GlobalVar == undefined){
           xScale1GlobalVar = xScale;
       }
       
       textOnStackedHoriBarChart2.style('display','block')
       
       d3.select(groupsForStackedHoriBarChart2[0][i]).selectAll('text').style('display','block')
       .transition().duration(1000).ease('bounce').attr("x", function(d,i) {return (xScale1GlobalVar(d.x0)) + 2  })
       .style("fill", "#ffffff") .style("text-shadow","1px 0px 1px rgba(34,34,34,0.6)")
       .text(function(d){
             if(d.x.toString().indexOf('.') === -1)
             {
                 if(d.x.toString().length <= 3){
                     return d.x;
                 }
                 else{
                     return format1(d.x);
                 }
             }
             else{
                 return d.x;
             }
        })
                   
       groupsForStackedHoriBarChart2.selectAll('rect').style('display','block')
       var g = d3.select(groupsForStackedHoriBarChart2[0][i]).selectAll('rect').transition().duration(1000).ease('bounce')
       .attr("x", function(d,i) {return (xScale1GlobalVar(d.x0))  })
       
    })
    
    // Creating ToolTip for options button.
    var iconButtonTooltipForStackedHoriChart2 = targetElement.append('div').style('width','240px').attr("id","too")
    .style('height',"25px").style('position','absolute')//.style('margin-left', "0px").style('top','25px')
    .style("background-color",'#404040 ').style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid") // 004b9d
    .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none").attr("border", 0.0)
    
    filterBtnForStackedHoriBarChart2.on('mousemove', function(d,i) {
        var root = targetElement
        var m = d3.mouse(root.node());
        m[0] += 0
        m[1] += 0
        var filterButtonTooltipText = "Filter";
        
        iconButtonTooltipForStackedHoriChart2.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
        iconButtonTooltipForStackedHoriChart2.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')
        
    })
    filterBtnForStackedHoriBarChart2.on('mouseout', function(d,i) {
        iconButtonTooltipForStackedHoriChart2.style("display","none")
    })
    
    refreshBtnForStackedHoriBarChart2.on('mousemove', function(d,i) {
         var root = targetElement
         var m = d3.mouse(root.node());
         m[0] += 0
         m[1] += 0
         var refreshButtonTooltipText = "Refresh";
         
         iconButtonTooltipForStackedHoriChart2.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
         iconButtonTooltipForStackedHoriChart2.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ refreshButtonTooltipText +'</div>')
                                         
     })
    refreshBtnForStackedHoriBarChart2.on('mouseout', function(d,i) {
         iconButtonTooltipForStackedHoriChart2.style("display","none")
     })
    
    commentsBtnForStkHoriBarChart2.on('mousemove', function(d,i) {
          commentsPanelDivForStkHoriChart2.style('background-color','#fafafa')
          var root = targetElement
          var m = d3.mouse(root.node());
          m[0] += 0
          m[1] += 0
          if(options.showComments == false){
          var commentButtonTooltipText = "Show Comments";
          }
          else if(options.showComments == true){
          var commentButtonTooltipText = "Hide Comments";
          }
          
          
          iconButtonTooltipForStackedHoriChart2.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
          iconButtonTooltipForStackedHoriChart2.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ commentButtonTooltipText +'</div>')
    })
    commentsBtnForStkHoriBarChart2.on('mouseout', function(d,i) {
          commentsPanelDivForStkHoriChart2.style('background-color','#ffffff')
          iconButtonTooltipForStackedHoriChart2.style("display","none")
    })
    
    menuBtnForStackedHoriBarChart2.on('mousemove', function(d,i) {
          var root = targetElement
          var m = d3.mouse(root.node());
          m[0] += 0
          m[1] += 0
          var menuButtonTooltipText = "Menu";
          
          iconButtonTooltipForStackedHoriChart2.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
          iconButtonTooltipForStackedHoriChart2.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ menuButtonTooltipText +'</div>')
                                      
    })
    menuBtnForStackedHoriBarChart2.on('mouseout', function(d,i) {
        iconButtonTooltipForStackedHoriChart2.style("display","none")
    })
    
    tableButtonForStkHoriChart2.on('mousemove', function(d,i) {
       var root = targetElement
       var m = d3.mouse(root.node());
       m[0] += 0
       m[1] += 0
       if(showOrHideTableForStkHoriChart2 == false){
       var tableBtnTooltipText = "Show Table";
       }
       else if(showOrHideTableForStkHoriChart2 == true){
       var tableBtnTooltipText = "Hide Table";
       }
       
       iconButtonTooltipForStackedHoriChart2.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
       iconButtonTooltipForStackedHoriChart2.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ tableBtnTooltipText +'</div>')
       
    })
    tableButtonForStkHoriChart2.on('mouseout', function(d,i) {
           iconButtonTooltipForStackedHoriChart2.style("display","none")
   })
    
    settingBtnForStkHoriChart2.on('mousemove', function(d,i) {
          var root = targetElement
          var m = d3.mouse(root.node());
          m[0] += 0
          m[1] += 0
          var settingTooltipText = "Settings";
          
          iconButtonTooltipForStackedHoriChart2.style("width","67px").style("margin-left", (m[0] - 77) + "px").style("margin-top",(m[1]) + "px").style("display","block")
          iconButtonTooltipForStackedHoriChart2.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ settingTooltipText +'</div>')
      })
    settingBtnForStkHoriChart2.on('mouseout', function(d,i) {
          iconButtonTooltipForStackedHoriChart2.style("display","none")
      })
    
    downloadBtnForStkHoriChart2.on('mousemove', function(d,i) {
          var root = targetElement
          var m = d3.mouse(root.node());
          m[0] += 0
          m[1] += 0
          var downloadButtonTooltipText = "Download";
          
          iconButtonTooltipForStackedHoriChart2.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
          iconButtonTooltipForStackedHoriChart2.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
    })
    downloadBtnForStkHoriChart2.on('mouseout', function(d,i) {
          iconButtonTooltipForStackedHoriChart2.style("display","none")
    })
        
    // ----------------- Filter panel and everything within it section begins here ----------------
    var filterPanelForStkHoriChart2 = targetElement.append('div').style('width',350 + "px") .attr("class","filterPanelForStkHoriChart2Class" + targetElement[0][0].id)
    .style('position','absolute').style('margin-left', "0px")
    .style("background-color",'#fefefe').style("z-index",11).style("border-color", "#ffffff").style("border-right", "solid #e5e5e5 1px")  .style("border-style", "solid") // 004b9d
    .style("box-shadow", "2px 0px 1px #eff8ec").style("display","none").style("border-top", "solid #fdfdfd 1px").style("border-left","0px").style("border-bottom", "0px")
    .style('top', 0.0 + "%").style('height', 100 + "%").style('overflow-y',"hidden").style("overflow-x","hidden")
    .style("border-bottom", "solid #e5e5e5 1px") .style("box-sizing","border-box")
    
    var filterPanelForStkHoriChart2Title = filterPanelForStkHoriChart2.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
    .style('margin-left','0px').style('margin-top','20px').style('text-indent','5px').style("font-size", "14px").style('position',"absolute")
    .style("box-shadow", "1px 1px 1px #007aff").style("width","350px").style("color","#000000")
    .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; top:25.0%; font-size:14px; font-family:inter; color:#00001c;">'+ "Filter" +'</div>')
    
    var measuresColumnTitle = filterPanelForStkHoriChart2.append("div") .style("width","140px").style("height","18px").style('position','absolute')
    .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '60px')
    .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; text-indent:3px;">Available Measures</div>');
    
    var measuresVariables = filterPanelForStkHoriChart2.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable1"+targetElement[0][0].id)
    .style("list-style-type","none")
    .style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '78px')
    .style('position','absolute')
    .style("width","155px").style("min-height","190px").style("max-height","190px").style("border", "#f0f0f0 1px solid")
    .style("max-width","155px").style("overflow-x","hidden").style("overflow-y","auto")
    measuresVariables.style("left",0.0 + "px").style("padding","2px")
    
    $( ".filterPanelForStkHoriChart2Class" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
          var e0 = e.originalEvent,
          delta = e0.wheelDelta || -e0.detail;
          
          this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
          e.preventDefault();
    });
    
    
    var measuresArray = [];
    var dimensionArray = [];
    
    var measuresArrayLength = [];
    var dimensionsArrayLength = [];
    
    dimensionArray.push(options.keys.label);
    //measuresArray = options.keys.stackedBars;
    for(var i = 0; i<divAndChartsArray.length; i++){
        if(targetElement[0][0].id === divAndChartsArray[i].divID){
            var stkHoriBarChart2MeasuresArray = [];
            newtargetElementAndOptionsArray[i].options.data.forEach(function(d,i){
				stkHoriBarChart2MeasuresArray.push(d[options.keys.stackedBars])
            })
            
            measuresArray = stkHoriBarChart2MeasuresArray;
            //measuresArray = newtargetElementAndOptionsArray[i].options.keys.stackedBars;
        }
    }
    
    // filter process
    var uniqueMeasuresArrayKeys = [];
    $.each(measuresArray, function(i, el){
       if($.inArray(el, uniqueMeasuresArrayKeys) === -1){
           uniqueMeasuresArrayKeys.push(el);
       }
   });
    
    var uniqueDimensionArrayKeys = [];
    $.each(dimensionArray, function(i, el){
       if($.inArray(el, uniqueDimensionArrayKeys) === -1){
           uniqueDimensionArrayKeys.push(el);
       }
   });
    
    // setting lenght for arrays
    for(var i = 0; i<uniqueMeasuresArrayKeys.length; i++){
        measuresArrayLength.push(i);
    }
    
    for(var i = 0; i<uniqueDimensionArrayKeys.length; i++){
        dimensionsArrayLength.push(i);
    }
    
    var measuresVariables1 = measuresVariables.selectAll("li").data(measuresArrayLength).enter().append("li")
    .style("width","130px") .style("max-height","22px").style("cursor","move")
    .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#bcf1bc").style("font-weight","Normal")
    .style("list-style-type","none").style("border","1px #89e789 solid").style("color","#006600").style("font-family","Verdana,sans-serif")
    .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
    .text(function(d) {return uniqueMeasuresArrayKeys[d]})
    measuresVariables1.attr("class","MeasuresClass"+targetElement[0][0].id)
    
    var measuresColumnReceivedUI_TableTitle = filterPanelForStkHoriChart2.append("div") .style("width","140px").style("height","18px").style('position','absolute')
    .style('background-color',"#fefefe").style('margin-left','180px').style('margin-top', '60px')
    .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; ">Selected Measures</div>');
    
    var measuresColumnReceivedUI_Table = filterPanelForStkHoriChart2.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable3"+targetElement[0][0].id)
    .style('background-color',"#ffffff").style('margin-left','180px').style('margin-top', '78px')
    .style("width","155px").style('position','absolute').style("padding","2px").style("min-height","190px")
    .style("border","1px #c1c1c1 dashed") .style("max-height","190px") .style("overflow-x","hidden") .style("overflow-y","auto")
    //.html('<div class=unsortable  style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:65.0%; font-size:14px; font-family:inter;  color:#99ea99; font-weight:Normal; text-align:center;">Drag and Drop Measures here from Available Measures List. </div>');
    .html('<img class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' src="images/dragIcon.png" style=" width:36px; height:36px; position:absolute; margin-left:65px; margin-top:60px; opacity:0.6"/>'
          + '<div class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:60.0%; font-size:12px; font-family:inter;  color:#89d289; font-weight:Normal; text-align:center;">Drop Measures here. </div>');
    //.html('<div style="background-image: url(images/dragIcon.png); height: 64px; width: 64px; border: 1px solid black;"> </div>');
    
    var cancelButton = filterPanelForStkHoriChart2.append("div") .style("width","23px").style("height","21px").style('position','absolute')
    .style('margin-left','320px').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
    .style('background-color',"#FCFCFF")
    .style("border", "0.0px") .style("border-style", "solid").style('color','white')
    .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
    var cancelBtnImgVar = document.createElement("IMG");
    cancelBtnImgVar.src = "images/closeIcon.png";
    cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.90; background-color:#fcfcff")
    cancelButton[0][0].appendChild(cancelBtnImgVar)
    
    cancelButton.on("click", function(){
        filterPanelForStkHoriChart2.style("display","none")
    })
    
    var reRenderChartAndTableBtn = filterPanelForStkHoriChart2.append("button").style("width","120px").style("height","25px").style('position','absolute')
    .style('margin-left','112px').style('margin-top','298px') .style("border-style", "none").style('background-color',"#2196f3")
    .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','15px').style("border-style", "solid").style('color','#ffffff')
    .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 1px #9b9b9b").style("border-radius","0px")
    var textForReRenderButton = document.createTextNode("Apply Changes");
    reRenderChartAndTableBtn[0][0].appendChild(textForReRenderButton)
    
    reRenderChartAndTableBtn.on("click", function(){
                                
        if( $("#sortable3"+targetElement[0][0].id).children("li").length == 0 )
        {
        
            var alertPageDisabledDivForStkHoriChart2 =targetElement.append('div').style('width',100 + '%')
            .style('height',100 + "%").style('position','absolute').style('margin-left', '0px').style('top', '0px')
            .style("background-color",'#f3f3f3').style("z-index",99)//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
            .style("opacity",0.2).style("display","block")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
            
            var alertDivForStkHoriChart2 = targetElement.append('div').style('width','350px')
            .style('height',"150px").style('position','absolute').style('left', ((targetElement[0][0].clientWidth/2) - 175) + "px").style('top', '1px')
            .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "solid").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
            .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","0px")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
            //.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Bold;">Sorry, no result found for selected' + 'range!'+ '</br>' + '<label style=text-indent:10px;> Hello</label' +'</div>')
            .html('<p  style="width: 340px; height:0%; background-color:#c7c7c7; position: absolute; top:40.0%; font-size:14px; font-family:inter; font-weight:Bold; margin-left:10px;  color:#f8f8f8; font-weight:Normal;">Check whether the Selected Measures box is not empty!</p>')
            
            var alertDivTitleForStkHoriChart2 = alertDivForStkHoriChart2.append('div').style('width','340px')
            .style('height',"30px").style('position','absolute').style('margin-left', "0px").style('top', '0px')
            .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "none").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
            .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","2px")
            .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; font-weight:Bold; text-indent:5px;  color:#e5e5e5; font-weight:Normal;">TimeBound</div>')
            
            var stkHoriChartAlertOKButton = alertDivForStkHoriChart2.append("button") .style("width","40px") .style("height","20px") .style('position','absolute') .style("box-shadow", "0px 1px 1px #B8B8B8")
            .style('background-color',"#7cc15e") .style('margin-left','300px') .style('top', "120px").style("color","#ffffff")
            .style("display","block").style('padding-top',"0px").style("cursor","pointer").style("box-shadow", "1px 1px 1px #56973a") .style("border-style", "none")
            .style("font-family","Verdana,sans-serif").style("font-size","14px").style("text-align","center").style("vertical-align","middle").style("border-radius","0px")
            .style("z-index",999)
            
            var textForStkHoriChartAlertOKButton = document.createTextNode("OK");
            stkHoriChartAlertOKButton[0][0].appendChild(textForStkHoriChartAlertOKButton)
            
            $("#"+targetElement[0][0].id).resizable('disable');
            
            stkHoriChartAlertOKButton.on('click', function() {
                 alertDivForStkHoriChart2.remove();
                 alertPageDisabledDivForStkHoriChart2.remove()
                 $("#"+targetElement[0][0].id).resizable('enable');
             })
            
            filterBtnForStackedHoriBarChart2.style("cursor","pointer")
            
            if(showOrHideTableForStkHoriChart2 == false){
                svgPanelForStackedHoriBarChart2.style('width', 75 + "%") .style('height', 85 + "%").style("position","absolute")
                divLegendPanelStackedHoriBarChart2.style('width', 25 + "%") .style('height', 85 + "%").style("position","absolute")
            }
            else if(showOrHideTableForStkHoriChart2 == true){
                svgPanelForStackedHoriBarChart2.style('width', 75 + "%") .style('height', 52 + "%").style("position","absolute")
                divLegendPanelStackedHoriBarChart2.style('width', 25 + "%") .style('height', 52 + "%").style("position","absolute")
            }
            
            resizedFuctionForStackedHoriChart2();
            }
            
            else{
            
            var selectedStackMeasures = [];
            for(var i=0; i<$("#sortable3"+targetElement[0][0].id).children("li").length;i++){
                selectedStackMeasures.push($("#sortable3"+targetElement[0][0].id).children("li")[i].textContent.toString())
            }
            
            var newFilteredData = [];
            selectedStackMeasures.forEach(function(d,i){
				for(var j = 0; j<divAndChartsArray.length; j++){
					if(targetElement[0][0].id === divAndChartsArray[j].divID){
					  newtargetElementAndOptionsArray[j].options.data.forEach(function(data,k){
						if(data[options.keys.stackedBars].toString().toLowerCase() === selectedStackMeasures[i].toString().toLowerCase()){
							newFilteredData.push(data)
						}
					  })
					}
				}
			})
            
            var newOptions = {
                data: newFilteredData,
                dataForDrillDown: options.dataForDrillDown,
                dataForTable: options.dataForTable,
                isDataDetailedForTable: options.isDataDetailedForTable,
                keys: {
                    label: options.keys.label,//$("#sortable4"+targetElement[0][0].id).children("li")[0].textContent.toString(),
                    stackedBars: options.keys.stackedBars,
                },
                chartTitle:options.chartTitle,
                xAxisLable: "",
                yAxisLable: options.yAxisLable,//$("#sortable4"+targetElement[0][0].id).children("li")[0].textContent,
                showTitle: true,
                colorSet: options.colorSet,
                BGcolor:options.BGcolor,
                series:options.series,
                legend:options.legend,
                drillDownColumnName:options.drillDownColumnName,
                showTable: options.showTable,
                showComments: options.showComments,
                comments: options.comments,
                resizeButtonID: options.resizeButtonID //document.getElementById("resizeBtn").id
            }
            
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            acinfotech.stackedHorizontalBarChart2(targetElement,newOptions)
        }
    })
    
    var textBoxForMeasureColumnFrom;
    var textBoxForMeasureColumnTo;
    var selectTitleDivForEachDimension;
    
    
    $( "ul.droptrue"+targetElement[0][0].id ).sortable({
           appendTo: document.body,
           helper: "clone",
           connectWith: ".droptrue"+targetElement[0][0].id,
           scroll: false,
           cancel: '.unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+','+' .unMoveableIconAndTextClassDimensions'+targetElement[0][0].id,
           revertDuration: 10,
           scrollSensitivity: 10,
           scrollSpeed: 1,
           dynamic: true,
           
           receive: function(e, ui) {
           
               if (($(this)[0].id == "sortable3"+targetElement[0][0].id) || ($(this)[0].id == "sortable1"+targetElement[0][0].id)) {
               
               if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
               if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                   (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
               }
               else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                   (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
               }
               
               }
               } // if (($(this)[0].id == "sortable3") || ($(this)[0].id == "sortable1"))
               
               else if (($(this)[0].id == "sortable2"+targetElement[0][0].id) || ($(this)[0].id == "sortable4"+targetElement[0][0].id)) {
               if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
               //ui.sender.sortable("cancel");
               
               if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                   (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
               }
               else if(  ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                   (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
               }
               }
               } //if (($(this)[0].id == "sortable2") || ($(this)[0].id == "sortable4")) {
               
               $(ui.item).css({ 'position': 'relative' });
               
                   if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                   ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
               }
               
               else if ($(this)[0].id == "sortable3"+targetElement[0][0].id) { // checking if the dropped element is in Measures drop area
               
                   if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                   ui.sender.sortable("cancel");
               }
               else {
               //ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
               }
               
               } // else if ($(this)[0].id == "sortable3") // checking if the dropped element is in Measures drop area ends here.
               
               else if ($(this)[0].id == "sortable4"+targetElement[0][0].id) { // checking if the dropped element is in Dimension drop area
               
                   if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                   ui.sender.sortable("cancel");
               }
               else {
               ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
               }
               } //else if ($(this)[0].id == "sortable4")  // checking if the dropped element is in Dimension drop area ends here
               
               if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
               
               if ($(this)[0].id == "sortable1"+targetElement[0][0].id){
               if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
               
                   if( ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                   ui.sender.sortable("cancel");
               } // if(  ui.sender.attr("id") === "sortable4")
               
               else if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
               ui.sender.sortable("cancel");
               }
               
               } // if(ui.item.hasClass("DimesionsClass"))
               }
               if ($(this)[0].id == "sortable2"+targetElement[0][0].id){
               if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
               
               if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                   ui.sender.sortable("cancel");
               }
               else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                   ui.sender.sortable("cancel");
               
               }
               }
               }
               
            } //if ($(this)[0].id == "sortable1")
               
            if ($(this)[0].id == "sortable4"+targetElement[0][0].id){
				if ($(this).children('li').length > 1 ){
					ui.sender.sortable("cancel");
					ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
				}
			}
           
       }, //receive ends here
           
        start:function(ev, ui) {
           
        },
        stop:function(ev, ui) {
           
        },
    });
    
    /* ----------------- Filter panel and everything within it section ends here -----------------*/
    
    // // Filter
    filterBtnForStackedHoriBarChart2.on('click', function() {
                                        
            filterPanelForStkHoriChart2.style("display","block");
            
            ismenuBtnOfStkHoriChart2Clicked = false;
            optsBtnPanelForStkHoriChart2.style("display","none");
            
            stgPanDivForStkHoriChart2.style("display","none");
            
            if ((showOrHideTableForStkHoriChart2 == false) && (showOrHideCommentsForStkHoriChart2 == true)){
            divLegendPanelStackedHoriBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
            
            svgPanelForStackedHoriBarChart2.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
            .style("position","absolute");
            }
            else if ((showOrHideTableForStkHoriChart2 == true) && (showOrHideCommentsForStkHoriChart2 == false)){
            divLegendPanelStackedHoriBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
            
            svgPanelForStackedHoriBarChart2.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute");
            }
            else if ((showOrHideTableForStkHoriChart2 == false) && (showOrHideCommentsForStkHoriChart2 == false)){
            divLegendPanelStackedHoriBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
            
            svgPanelForStackedHoriBarChart2.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute");
            }
            
            resizedFuctionForStackedHoriChart2();
        })
    
    
    refreshBtnForStackedHoriBarChart2.on('click', function() {
                                         
        for(var i = 0; i<divAndChartsArray.length; i++){
         
         if(targetElement[0][0].id === divAndChartsArray[i].divID){
             options.data = divAndChartsArray[i].optionsData;
             options.keys.stackedBars = newtargetElementAndOptionsArray[i].options.keys.stackedBars;
             // options.keys = newtargetElementAndOptionsArray[i].options.keys;
             // options.chartTitle = newtargetElementAndOptionsArray[i].options.chartTitle;
             // options.xAxisLable = newtargetElementAndOptionsArray[i].options.xAxisLable;
             // options.yAxisLable = newtargetElementAndOptionsArray[i].options.yAxisLable;
             // options.showTitle = newtargetElementAndOptionsArray[i].options.showTitle;
             // options.colorSet = newtargetElementAndOptionsArray[i].options.colorSet;
             // options.drillDownColumnName = newtargetElementAndOptionsArray[i].options.drillDownColumnName;
             // options.showTable = newtargetElementAndOptionsArray[i].options.showTable;
             // options.resizeButtonID = newtargetElementAndOptionsArray[i].options.resizeButtonID;
         }
         }
         d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,button').remove();
         acinfotech.stackedHorizontalBarChart2(targetElement,options)
         
    })
    
    // showing/hidding chart comments
    commentsBtnForStkHoriBarChart2.on('click', function() {
          
          if(options.showComments == false){ 
              options.showComments = true;
          }
          else if(options.showComments == true){ 
              options.showComments = false;
          }
          
          d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
          
          for(var i = 0; i<divAndChartsArray.length; i++){
          
              if(targetElement[0][0].id === divAndChartsArray[i].divID){
                  options.data = divAndChartsArray[i].optionsData
                  options.showTable = false;
              }
          }
          acinfotech.stackedHorizontalBarChart2(targetElement,options)
                                      
      })
    
    // showing/hidding chart table
    tableButtonForStkHoriChart2.on('click', function() {
                                   
           if(showOrHideTableForStkHoriChart2 == false){
               options.showTable = true;
               //showOrHideTableForPieChart2 = true
           }
           else if(showOrHideTableForStkHoriChart2 == true){
               //showOrHideTableForPieChart2 = false
               options.showTable = false;
           }
           
           d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
           
           for(var i = 0; i<divAndChartsArray.length; i++){
           
               if(targetElement[0][0].id === divAndChartsArray[i].divID){
                   options.data = divAndChartsArray[i].optionsData
                   options.showComments = false;
               }
           }
           acinfotech.stackedHorizontalBarChart2(targetElement,options)
                                   
       })
    
    
    settingBtnForStkHoriChart2.on('click', function() {
          
		ismenuBtnOfStkHoriChart2Clicked = false; // Menu toggle button variable
		optsBtnPanelForStkHoriChart2.style("display","none") // To hide options button panel

		iconButtonTooltipForStackedHoriChart2.style("display","none") // Removing options button ToolTip
		settingBtnForStkHoriChart2.style("cursor","pointer")

		stgPanDivForStkHoriChart2.style("display","block") // Showing settings panel

		svgPanelForStackedHoriBarChart2.style('width', 75 + "%") .style('height', 52 + "%").style("position","absolute"); // Decreasing Chart2 panel
		divLegendPanelStackedHoriBarChart2.style('width', 25 + "%") .style('height', 52 + "%").style("position","absolute"); // Decreasing Chart2 panel

		resizedFuctionForStackedHoriChart2(); // Calling resize function()
                                  
	})
    
	downloadBtnForStkHoriChart2.on('click', function() {
          
		ismenuBtnOfStkHoriChart2Clicked = false; // Changing menu button value to false
		optsBtnPanelForStkHoriChart2.style("display","none") // Hiding option buttons panel
          
	})
        
    var finalArrayNew = [];
    options.data.forEach(function(d, i) {
                         
         var temp1 = {};
         temp1["name"] = d[options.keys.stackedBars]
         
         finalArrayNew.push(temp1)
	})
    
    var finalNewNewArray = [];
    var dataArray1 = [];
    finalArrayNew.forEach(function(d, i) {
    	var temp1 = {};
		temp1["name"] = d["name"]

		for (j = 0; j < options.keys.label.length; j++) {
			var tempTemp = {};
			tempTemp["label"] = options.keys.label[j];
			tempTemp["value"] = +options.data[i][options.keys.label[j]]

			dataArray1.push(tempTemp)
		}

		temp1["data"] = dataArray1;
		dataArray1 = []
		finalNewNewArray.push(temp1)
	})
    
    var margins = {
    top: 12,
    left: 48,
    right: 24,
    bottom: 24
    },
    
    width = (svgPanelForStackedHoriBarChart2.node().getBoundingClientRect().width) - margin.left - margin.right,
    height = (svgPanelForStackedHoriBarChart2.node().getBoundingClientRect().height) - margin.top - margin.bottom
    
    dataset = finalNewNewArray,
    series = dataset.map(function (d) {
                         return d.name;
                         }),
    dataset = dataset.map(function (d) {
                          return d.data.map(function (o, i) {
                        
                        return {
                        y: o.value,
                        x: o.label
                        };
                        });
              }),
    stack = d3.layout.stack();
    
    stack(dataset);
    
    var dataset = dataset.map(function (group) {
                              return group.map(function (d) {
                                               // Invert the x and y values, and y0 becomes x0
                       return {
                       x: +d.y,
                       y: d.x,
                       x0: +d.y0
                       };
                       });
        }),
    svgForStackedHoriBarChart2 = svgPanelForStackedHoriBarChart2 //svgForStackedHoriBarChart2 is svg group
    .append('svg').append('g') .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'),
    xMax = d3.max(dataset, function (group) { return d3.max(group, function (d) { return (+d.x) + (+d.x0); });
                  }),
    xScale = d3.scale.linear() .domain([0, xMax]) .range([0, width]),
    months = dataset[0].map(function (d) { return d.y; }),
    
    yScale = d3.scale.ordinal() .domain(months) .rangeRoundBands([0, height], .20), // 18
    
    xAxis = d3.svg.axis().scale(xScale) .orient('bottom'),
    yAxis = d3.svg.axis().scale(yScale) .orient('left'),
    
    groupsForStackedHoriBarChart2 = svgForStackedHoriBarChart2.selectAll('g') .data(dataset) .enter() .append('g')
    .style('fill', function (d, i) { return colours(i); }),
    //---------------------
    
    rectsForStackedHoriBarChart2 = groupsForStackedHoriBarChart2.selectAll('rect') .data(function (d) { return d; }).enter().append('rect')
	
	groupsForStackedHoriBarChart2.selectAll('rect') 
	.attr('x', function (d) { return 0; })
	.attr('y', function (d, i) { return yScale(d.y); })
	.attr("width", 0).transition().delay(400).duration(800)
	.attr('x', function (d) { return xScale(d.x0); })
	.attr('width', function (d) { return xScale(d.x); })
	.attr('height', function (d) { return yScale.rangeBand(); })
	.style("cursor","auto")
    
    var columnNames = d3.keys(options.data[0])
    var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
    
    if(options.dataForDrillDown.length == 0){
        
        for(var i = 0; i < columnNames.length ; i++){
            for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                    for(var k = 0; k < options.data.length; k++){
                        var len = d3.select(groupsForStackedHoriBarChart2[0][k]).selectAll('rect')
                        for(var l = 0; l < options.keys.label.length; l++){
                            d3.select(len[0][l]).attr('data-drilldownkey', function(d,index){
								return JSON.stringify(options.data[k]).slice(1, -1).split('"').join("").split(':').join("|")
							})
                        }
                    }
                }
                else {
                }
            }
        }
    }
    
    else if(options.dataForDrillDown.length > 0){
        
        options.data.forEach(function(d, i) {
                             
            options.dataForDrillDown.forEach(function(val, j) {
                    var optKeysLabVal = options.keys.stackedBars.toString().toLowerCase();
                    var key, keys = Object.keys(val), n = keys.length, newObj={}
                    while (n--) { key = keys[n]; newObj[key.toLowerCase()] = val[key]; }
                    if(d[options.keys.stackedBars].toString().toLowerCase() === newObj[optKeysLabVal].toString().toLowerCase()){
                       options.keys.label.forEach(function(measures, k) {
                       var optKeysStkVal = measures.toString().toLowerCase();
                       if(d[measures] == newObj[optKeysStkVal]) {
                         var bars = d3.select(groupsForStackedHoriBarChart2[0])
                         bars[0].forEach(function(g, index) {
                            var dd = d3.select(g)[0]
                            dd[0].forEach(function(rect, index1) {
                                var ddd = d3.select(rect)[0]
                                if(+ddd[0].__data__[k].x == +d[measures]){
                                    var r = d3.select(ddd[0]).selectAll("rect")
                                    var rr = r[0][k]
                                    d3.select(rr).attr('data-drilldownkey', function(d,index){ return JSON.stringify(val).slice(1, -1).split('"').join("").split(':').join("|") })
                                } // if(+ddd[0].__data__[k].x == +d[measures])
                            }) //dd[0]
                         }) // bars[0]
                       } // if(d[measures] == newObj[optKeysStkVal])
                    }) // options.keys.label.forEach(function(measures, k)
                   } // if(d[options.keys.stackedBars].toString().toLowerCase() === newObj[optKeysLabVal].toString().toLowerCase())
                }) // options.dataForDrillDown.forEach(function(val, j)
        }) // options.data.forEach(function(d, i)
    }

    
    var format1 = d3.format('.3s')
    var textOnStackedHoriBarChart2 = groupsForStackedHoriBarChart2.selectAll(".text")
    .data(function (d) { return d; })
    
    textOnStackedHoriBarChart2.enter() .append("text").attr("class","text");
    
    textOnStackedHoriBarChart2.style("text-anchor", "start").style("font-family", "Verdana,sans-serif").style("font-size", "12px")
	.style("fill", "#ffffff") .style("text-shadow","1px 0px 1px rgba(34,34,34,0.6)")
	.attr("y", function(d) { return ((yScale(d.y) + (yScale.rangeBand()/2))) + 4 }) 
	.attr("x", 0).transition().delay(400).duration(800)
	.attr("x", function(d,i) {return (xScale(d.x0)) + 2  })
    .attr("y", function(d) { return ((yScale(d.y) + (yScale.rangeBand()/2))) + 4 }) 
    .text(function(d){
		if(d.x.toString().indexOf('.') === -1)
		{
			if(d.x.toString().length <= 3){ return d.x; }
			else { return format1(d.x); }
		}
		else {
			return d.x;
		}
    })
    
    svgForStackedHoriBarChart2.append('g') .attr("class", "x axis") .attr('transform', 'translate(0,' + height + ')')
    //.call(xAxis);
    
    svgForStackedHoriBarChart2.append('g') .attr("class", "y axis") .call(yAxis)
	.selectAll("text") .style('fill','#00001c') .style("font-weight","normal") .style("font-family","Verdana,sans-serif").style("font-size","12px")
    .text(function(d,i) {
		if(d.length > 9)
			return d.substring(0,9)+'...';
		else
			return d;
	})
    
    // Add the text label for the Y axis
    var yAxisVariable = svgForStackedHoriBarChart2.append("text") .attr("transform", "rotate(-90)") .attr("y", -115) .attr("x",0 - (height / 2.0)) .attr("dy", "1em") .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif")
    .style("font-size","12px") .text(options.yAxisLable) .style('fill','#00001c') .style("text-transform","capitalize") .style("font-weight","Bold")
    .style("font-style","normal")
    
    //Creating tooltip----
    var tooltipForStackedHoriChart2 = targetElement .append('div') .attr('class', 'tooltipPie') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
    .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
    .style("padding-right", "7px") .style("background", "#F8F8F8") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style("z-index",1000)
    .style("border", "1.0px") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","60px")
    //tooltipForStackedHoriChart2.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'label').style("color","#000000") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "12px") .style("font-weight", "Bold");
    tooltipForStackedHoriChart2.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
    tooltipForStackedHoriChart2.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");
    
    rectsForStackedHoriBarChart2.on('mousemove', function (d,i){
                                    
            var root = targetElement
            var m = d3.mouse(root.node());
            m[0] += 0
            m[1] += 0
            
            var valueForStkHoriChart2ToolTip;
            if(d.x.toString().toString().indexOf('.') === -1)
            {
                valueForStkHoriChart2ToolTip = d.x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            else{
            
                valueForStkHoriChart2ToolTip = d.x.toString();
            }
            
            //tooltipForStackedHoriChart2.select('.label').html(options.keys.label + " : " + d.y)
            //tooltipForStackedHoriChart2.select('.count').html(d.x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
            tooltipForStackedHoriChart2.select('.count').html(valueForStkHoriChart2ToolTip)
            tooltipForStackedHoriChart2.style('visibility', 'visible')
            tooltipForStackedHoriChart2.select('hr').style("background-color", d3.select(this).style("fill") )
            tooltipForStackedHoriChart2.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-10) + "px").style("display","block")
                                    
    })
    .on('mouseout', function(){
        
        tooltipForStackedHoriChart2.style("display","none")
    })
    
    textOnStackedHoriBarChart2.on('mousemove', function (d,i){
              var root = targetElement
              var m = d3.mouse(root.node());
              m[0] += 0
              m[1] += 0
              
              //tooltipForStackedHoriChart2.select('.label').html(options.keys.label + " : " + d.y)
              tooltipForStackedHoriChart2.select('.count').html(d.x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
              tooltipForStackedHoriChart2.style('visibility', 'visible')
              //tooltipForStackedHoriChart2.select('hr').style("background-color", d3.select(this).style("fill") )
              tooltipForStackedHoriChart2.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-10) + "px").style("display","block")
     })
    .on('mouseout', function(){
        
        tooltipForStackedHoriChart2.style("display","none")
    })
    
    // ----------------------- Adding Table  ------------------
    var tablePanelForStackedHoriChart2 =  targetElement.append("div") .attr("id",targetElement[0][0].id + "holderForStackedHoriChart2TableID")
    .attr("class","scrollingDivForTable-Class tableDivForStackedHoriChart2" + targetElement[0][0].id) .style('background-color',"#ffffff") .style('position','absolute')
    .style("display","block") .style("overflow","hidden") .style("width", function(d) {  return 100.0 + "%"; })
    .style("height", function(d) { return 40 + "%"; }) .style("left",0 + "%").style("z-index",10)
    
    $( '.tableDivForStackedHoriChart2' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
          var e0 = e.originalEvent,
          delta = e0.wheelDelta || -e0.detail;
          
          this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
          e.preventDefault();
    });
    
    if(options.showTitle == true ){
        tablePanelForStackedHoriChart2.style("top",60.0  + "%")
    }
    else if(options.showTitle == false  ){
        tablePanelForStackedHoriChart2.style("top",60.0  + "%")
        
    }
    tablePanelForStackedHoriChart2.html('<table class = "tableClassForStkHoriBarChart2' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                        '<thead class = "theadClassForStkHoriBarChart2' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForStkHoriBarChart2' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                                        '<tbody class = "tBodyClassForStkHoriBarChart2' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                        '</table>'
                                        )
    
    tablePanelForStackedHoriChart2.select('table').attr("id",targetElement[0][0].id + "tableID")
    
    // Show or Hide Table scroll bar when mouseover on widget
    targetElement.on('mouseover',function(){ tablePanelForStackedHoriChart2.style("overflow","auto") })
    targetElement.on('mouseout',function(d){ tablePanelForStackedHoriChart2.style("overflow","hidden") })
    
    var tableDataForStkHoriBarChart2 = [];
    if(options.dataForTable.length > 0){
        tableDataForStkHoriBarChart2 = options.dataForTable;
    }
    else {
        tableDataForStkHoriBarChart2 = options.data;
    }
    
    var thead = tablePanelForStackedHoriChart2.select("thead").selectAll("th") .data(d3.keys(tableDataForStkHoriBarChart2[0]))
    .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
    
    var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff") //f4f4f4
    .style("position","relative")
    
    var thead1 = d3.select(".thead1ClassForStkHoriBarChart2" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tableDataForStkHoriBarChart2[0]))
    .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
    
    var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff") //f4f4f4
    .style("position","relative")
    
    var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
    .attr("id", "ascendingIconIDForStackedHoriChart2") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
    
    var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
    .attr("id", "descendingIconIDForStackedHoriChart2") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
    
    var tr = tablePanelForStackedHoriChart2.select("tbody").selectAll("tr") .data(tableDataForStkHoriBarChart2).enter().append("tr")
    .attr("id", function(d,i) { return "slice" + i })
    
    // cells
    var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d})
    .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
    
    var $table = $('.tableClassForStkHoriBarChart2' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
    
    d3.select(".theadClassForStkHoriBarChart2" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
        d.forEach(function(dd,j){
            colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
        })
    })
    
    $(".thead1ClassForStkHoriBarChart2" + targetElement[0][0].id).insertAfter('.tBodyClassForStkHoriBarChart2' + targetElement[0][0].id)
    
    $(".thead1ClassForStkHoriBarChart2" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForStackedHoriChart2' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
    
    tablePanelForStackedHoriChart2.select(".thead1ClassForStkHoriBarChart2" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
    })
    
    $('.tableDivForStackedHoriChart2' + targetElement[0][0].id).scroll(function () {
                                                               
        $(".thead1ClassForStkHoriBarChart2" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForStackedHoriChart2' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
                                                               
    })
    
    var sortOrder = false;
    thead1.on("click",function(k,index){
             
             sortOrder = !sortOrder;
             
             tablePanelForStackedHoriChart2.select(".thead1ClassForStkHoriBarChart2" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                                                                 
                 if (sortOrder) {
                 
                     if(i == index){
                     d3.select(this).select('svg').select('#descendingIconIDForStackedHoriChart2').style("visibility", "hidden")
                     d3.select(this).select('svg').select('#ascendingIconIDForStackedHoriChart2').style("visibility", "visible")
                     }
                     else {
                     d3.select(this).select('svg').select('#descendingIconIDForStackedHoriChart2').style("visibility", "visible")
                     d3.select(this).select('svg').select('#ascendingIconIDForStackedHoriChart2').style("visibility", "visible")
                     }
                     }
                     else{
                     
                     if(i == index){
                     d3.select(this).select('svg').select('#descendingIconIDForStackedHoriChart2').style("visibility", "visible")
                     d3.select(this).select('svg').select('#ascendingIconIDForStackedHoriChart2').style("visibility", "hidden")
                     }
                     else {
                     d3.select(this).select('svg').select('#descendingIconIDForStackedHoriChart2').style("visibility", "visible")
                     d3.select(this).select('svg').select('#ascendingIconIDForStackedHoriChart2').style("visibility", "visible")
                     }
                 }
            })
             
              var monthTruOrFalAryForStkHoriBarChart2 = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
              
              tr.sort(function(a, b) {
                      
                      if (sortOrder) {
                      var monthsArrayForStkHoriBarChart2 = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                      } else {
                      var monthsArrayForStkHoriBarChart2 = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                      }
                      
                      monthTruOrFalAryForStkHoriBarChart2 = []; gotMonthArray = [];
                      tableDataForStkHoriBarChart2.forEach(function(d,i){
                          var da = d[k].toString().substring(0,3).toLowerCase()
                          if(monthsArrayForStkHoriBarChart2.indexOf(da) >= 0){
                              monthTruOrFalAryForStkHoriBarChart2.push(true)
                              gotMonthArray.push(da);
                          }
                          else {
                              monthTruOrFalAryForStkHoriBarChart2.push(false)
                          }
                      })
                      
                      if(monthTruOrFalAryForStkHoriBarChart2.indexOf(false) == -1){ // true
                      
                      monthArray = []; monthArrayCount = [];
                      gotMonthArray.forEach(function(dd,j){
                        var index1 = monthsArrayForStkHoriBarChart2.indexOf(dd.substring(0,3))
                        if(monthArrayCount.indexOf(index1) >= 0){
                            index1 = 12 + index1;
                        }
                        monthArray.push(index1);
                        monthArrayCount.push(index1)
                      })
                      returnArray = []
                      monthArray.sort(function(aa, bb) {
                          returnArray.push(+aa - +bb)
                          return +aa - +bb;
                      })
                      
                      sortTableFunc()
                      return returnArray[ind++];
                      } //  if true (if jan feb if block)
                      else {
                      var data = +a[k];
                      
                      if(!isNaN(data)){
                      
                          if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                          else { return d3.descending(+a[k], +b[k]); }
                      }
                      else if(!isNaN(Date.parse(a[k]))){
                      
                          if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                          else { return new Date(b[k]) - new Date(a[k]) }
                      }
                      else {
                      
                          if (sortOrder) { return d3.ascending(a[k], b[k]); }
                          else { return d3.descending(a[k], b[k]); }
                      }
                  } // if not jan feb else block
                }); // tr

	})
    
    function sortTableFunc(){
        
        var table = tablePanelForStackedHoriChart2.select('table');
        var rows = table.selectAll('tr').data(tableDataForStkHoriBarChart2);
        var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
        cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0).style("color","#00001c");
        
        cells.text(function(d,i) {return d});
        
        // Cells exit selection
        cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
        
        var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
        
        cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500)
        .style('opacity', 1.0).style("color","#00001c");
        
        cells_in_new_rows.text(function(d,i) {return d});
        
        rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
    }
    
    // Main Table Styling
    tablePanelForStackedHoriChart2.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
    .style("color","#00001c")
    .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4") //.style("box-shadow","10px 10px 50px #007aff").style("z-index",9999)
    tablePanelForStackedHoriChart2.selectAll('td').style("height","25px") .style("border", "1px solid #dddddd") .style("font-size","12px").style("font-weight","Normal").style("color","#00001c")
    
    //additionally 
    tablePanelForStackedHoriChart2.selectAll('th').style('background-color',"#ffffff").style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
    tablePanelForStackedHoriChart2.selectAll('td').style('background-color',"#ffffff").style("border-style","none").style("color","#00001c")
    
    //b1da9f
    tablePanelForStackedHoriChart2.selectAll('table') . style("border-collapse","collapse")
    tablePanelForStackedHoriChart2.selectAll('table tr:first-child th').style("border-top","0px")
    tablePanelForStackedHoriChart2.selectAll('table tr:last-child td').style("border-bottom","0px")
    tablePanelForStackedHoriChart2.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
    tablePanelForStackedHoriChart2.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")
    
    if(showOrHideTableForStkHoriChart2 == false){
        tablePanelForStackedHoriChart2.style("display","none")
    }
    else if(showOrHideTableForStkHoriChart2 == true){
        tablePanelForStackedHoriChart2.style("display","block")
    }
    
    if(options.isDataDetailedForTable == false){
        
        var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
        
        // Adding underlines for selected drill-down column text
        var drillDownSectionsForStkHoriChart = tablePanelForStackedHoriChart2.select('table').selectAll('th')
        
        var foundResult = [];
        for(var i = 0; i<drillDownSectionsForStkHoriChart[0].length; i++){
            
            for(var j = 0; j<drillDownColumnNamesArray.length; j++){
                if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForStkHoriChart[0][i].__data__.toString().toLowerCase() ){
                    foundResult.push(i)
                }
            }
        }
        
        var r = tablePanelForStackedHoriChart2.select('table').selectAll('tr').selectAll('td')
        for(var i = 0; i<r.length; i++){
            for(var j = 0; j < foundResult.length; j++){
                var row = r[i][foundResult[j]]
                $(row).css("text-decoration", "underline")
            }
        }
    }
    
    //By default calling the resized function first time (to align table's th and td).
    setTimeout(function(){ resizedFuctionForStackedHoriChart2() },1000)
    
    window.addEventListener('resize', function(event){ resizedFuctionForStackedHoriChart2() });
    
    var xScale1GlobalVar;
    
    $(function() {
      $("#" + targetElement[0][0].id).resizable({
            resize: function(event, ui) {
                //divWidthForHoriChart2 = ui.size.width;
                //divHeightForHoriChart2 = ui.size.height;
               resizedFuctionForStackedHoriChart2();
            }
        });
      });
    
    function resizedFuctionForStackedHoriChart2()
    {
        if((svgPanelForStackedHoriBarChart2.node().getBoundingClientRect().width) && (svgPanelForStackedHoriBarChart2.node().getBoundingClientRect().height) > 0){
            
            if(showOrHideCommentsBtnForStkHoriChart2 == true){
                filterBtnForStackedHoriBarChart2.style('margin-left', "2px")
                refreshBtnForStackedHoriBarChart2.style('margin-left', "2px")
                commentsBtnForStkHoriBarChart2.style('margin-left', "2px")
                menuBtnForStackedHoriBarChart2.style('right', '0')
            }
            else if(showOrHideCommentsBtnForStkHoriChart2 == false){
                filterBtnForStackedHoriBarChart2.style('margin-left', "2px")
                refreshBtnForStackedHoriBarChart2.style('margin-left', "2px")
                //commentsBtnForStkHoriBarChart2.style('right', '0')
                commentsBtnForStkHoriBarChart2.style('display','none')
                menuBtnForStackedHoriBarChart2.style('right', '0')
            }
            optsBtnPanelForStkHoriChart2.style('right', '0')
            
            stgPanCanBtnForStkHoriChart2.style('right', '0')
            
            var margin1 = {top: 10 , right: 20, bottom: 20, left: 130}, //originally top: 42, left: 80
            width1 = (svgPanelForStackedHoriBarChart2.node().getBoundingClientRect().width) - margin1.left - margin1.right,
            height1 = (svgPanelForStackedHoriBarChart2.node().getBoundingClientRect().height) - margin1.top - margin1.bottom;
            // width1 = ($('#svgPanelIDForStackedHoriBarChart2' + targetElement[0][0].id)[0].getBoundingClientRect().width) - margin1.left - margin1.right,
            // height1 = ($('#svgPanelIDForStackedHoriBarChart2' + targetElement[0][0].id)[0].getBoundingClientRect().height) - margin1.top - margin1.bottom;
            
            var xMax1 = d3.max(dataset, function (group) {
                       return d3.max(group, function (d) {
                                     return (+d.x) + (+d.x0);
                                     });
                       })
            var xScale1 = d3.scale.linear() .domain([0, xMax1])
            .range([0, width1]),
            months = dataset[0].map(function (d) {
                                    return d.y;
                                    })
            xScale1GlobalVar = xScale1;
            var yScale1 = d3.scale.ordinal() .domain(months) .rangeRoundBands([0, height1], .20) // 18
            
            yAxis.scale(yScale1) .orient("left") .ticks(14);
            
            var svg1 = svgForStackedHoriBarChart2;
            
            svg1.select("svg")
            //.attr("width", width1 + margin1.left + margin1.right)
            //.attr("height", height1 + margin1.top + margin1.bottom);
            
            svg1.select(".y.axis") .call(yAxis)
            .selectAll("text") .style('fill','#00001c') .style("font-weight","Bold") .style("font-family","Verdana,sans-serif")
            .text(function(d,i) {
                  if(d.length > 9)
                  return d.substring(0,9)+'...';
                  else
                  return d;
                  })
            
            yAxisVariable.attr("transform", "rotate(-90)") .attr("y", -115) .attr("x",0 - (height1 / 2.0)) .attr("dy", "1em")
            
            rectsForStackedHoriBarChart2.attr('x', function (d) { return xScale1(d.x0); })
            .attr('y', function (d, i) { return yScale1(d.y); })
            .attr('height', function (d) { return yScale1.rangeBand(); }) .attr('width', function (d) { return xScale1(d.x); })
            
            textOnStackedHoriBarChart2
            //.attr("x", function(d,i) { return (xScale1(d.x) + (xScale1(d.x0))) - 2  })
            .attr("x", function(d,i) { return (xScale1(d.x0)) + 2  })
            .attr("y", function(d) { return ((yScale1(d.y) + (yScale1.rangeBand()/2))) + 4 })
            
            // Aligning Legend (vertically)
            var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelStackedHoriBarChart2[0][0].style.width) / 100)
            var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelStackedHoriBarChart2[0][0].style.height) / 100)
            
            var legendRectSize = 11;
            var legendSpacing = 4;
            
            legend.attr('transform', function(d, i) {
                var eachRectHeight = legendRectSize + legendSpacing;
                var offset =  eachRectHeight * colours.domain().length / 2;
                var horz = 5;
                var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.data.length))/2.0; // originally 2.0
                
                return 'translate(' + horz + ',' + vert + ')';
            })
            
            colWidth = [];
			
            d3.select(".theadClassForStkHoriBarChart2" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                d.forEach(function(dd,j){
                        colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                })
            })
            tablePanelForStackedHoriChart2.select(".thead1ClassForStkHoriBarChart2" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                    d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
            })
            
        }// checking svg panel widht & height greater than zero function
    } // resize function()
    }, //stackedHorizontalBarChart2
    
    // ************************************************** Stacked Bar Chart 2 **************************************************
    stackedBarChart2: function(targetElement, options){
    
    isChartCalled++;
    
    var chartName = "STACKEDBARCHART2";
    
    acinfotech.allCharts(targetElement,options,chartName)
    
    targetElement.style("min-width", "350px").style("min-height", "350px").style("background-color", options.BGcolor)
    
    var showOrHideTableForStkBarChart2;
    var showOrHideCommentsForStkBarChart2;
    var showOrHideCommentsBtnForStkBarChart2 = true;
    
    if((options.showTable == false) || (options.showTable == true)){
        showOrHideTableForStkBarChart2 = options.showTable
    }
    else{
        showOrHideTableForStkBarChart2 = false;
    }
    
    // Show or Hide comments
    if (options.showComments == true || false) {
        showOrHideCommentsForStkBarChart2 = options.showComments;
    }
    else {
        showOrHideCommentsForStkBarChart2 = false;
    }
    
    if (options.comments.length == 0){
        showOrHideCommentsForStkBarChart2 = false;
        showOrHideCommentsBtnForStkBarChart2 = false;
    }
    
    if ((showOrHideTableForStkBarChart2 == true) && (showOrHideCommentsForStkBarChart2 == true)){
        showOrHideTableForStkBarChart2 = true;
        showOrHideCommentsForStkBarChart2 = false;
    }
    else if ((showOrHideTableForStkBarChart2 == false) && (showOrHideCommentsForStkBarChart2 == false)){
        showOrHideTableForStkBarChart2 = false;
        showOrHideCommentsForStkBarChart2 = false;
    }
    
    var chartTitlePanelForStackedBarChart2 =  targetElement.append("div") .style("background-color",options.BGcolor) .style("position","absolute").style('background-color',"#ffffff")
    .style("text-indent","6px")
    
	var optsBtnPanelForStkBarChart2 = targetElement.append('div').style('width',"25px").style('height',"160px").style('position','absolute')
    .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px")
    .style('right', '0').style("min-width","25px")
	.style("border-style","none").style("border-left", "solid #fcfcfc  1px")
	
    var filterBtnForStackedBarChart2 = optsBtnPanelForStkBarChart2.append("div") .style("width","20px").style("height","20px").style('position','absolute')
    .style('background-color',"#ffffff").style("z-index",10)
    .style('top','80px') .style("cursor","pointer").style("display","block")
    .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
    var filterBtnImgVar = document.createElement("IMG");
    filterBtnImgVar.src = "images/filterIcon.png";
    filterBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
    filterBtnForStackedBarChart2[0][0].appendChild(filterBtnImgVar)
    
    var refreshBtnForStackedBarChart2 = optsBtnPanelForStkBarChart2.append("div") .style("width","20px").style("height","20px").style('position','absolute')
    .style('background-color',"#ffffff").style("z-index",10)
    .style('top','105px') .style("cursor","pointer").style("display","block")
    .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
    var refreshBtnImgVar = document.createElement("IMG");
    refreshBtnImgVar.src = "images/refreshIcon.png";
    refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
    refreshBtnForStackedBarChart2[0][0].appendChild(refreshBtnImgVar)
    
    var commentsBtnForStkBarChart2 = optsBtnPanelForStkBarChart2.append("div") .style("width","20px").style("height","20px").style('position','absolute')
    .style('background-color',"#ffffff").style("z-index",10)
    .style('top','130px') .style("cursor","pointer").style("display","block")
    .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
    var commentsBtnImgVariable = document.createElement("IMG");
    if(options.showComments == false){
        commentsBtnImgVariable.src = "images/showCommentsIcon.png";
    }
    else if(options.showComments == true){
        commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
    }
    commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
    commentsBtnForStkBarChart2[0][0].appendChild(commentsBtnImgVariable)
    
    var menuBtnForStackedBarChart2 = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
    .style('background-color',"#ffffff").style("z-index",10)
    .style('top','1px') .style("cursor","pointer").style("display","block")
    .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
    var menuBtnImgVar = document.createElement("IMG");
    menuBtnImgVar.src = "images/menuIcon.png";
    menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
    menuBtnForStackedBarChart2[0][0].appendChild(menuBtnImgVar)
    
    if(showOrHideCommentsBtnForStkBarChart2 == true){
        filterBtnForStackedBarChart2.style('margin-left', "2px")
        refreshBtnForStackedBarChart2.style('margin-left', "2px")
        commentsBtnForStkBarChart2.style('margin-left', "2px")
        menuBtnForStackedBarChart2.style('right', '0')
    }
    else if(showOrHideCommentsBtnForStkBarChart2 == false){
        filterBtnForStackedBarChart2.style('margin-left', "2px")
        refreshBtnForStackedBarChart2.style('margin-left', "2px")
        //commentsBtnForStkBarChart2.style('right', '0')
        commentsBtnForStkBarChart2.style('display','none')
        menuBtnForStackedBarChart2.style('right', '0')
    }
    
    var ismenuBtnOfStkBarChart2Clicked = false;
    menuBtnForStackedBarChart2.on('click', function() {
                                  
		filterPanelForStkBarChart2.style("display","none");

		stgPanDivForStkBarChart2.style("display","none") // Hiding setting panel

		if ((showOrHideTableForStkBarChart2 == false) && (showOrHideCommentsForStkBarChart2 == true)){
			divLegendPanelStackedBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
			.style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");

			svgPanelForStackedBarChart2.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
			.style("position","absolute");
		}
		else if ((showOrHideTableForStkBarChart2 == true) && (showOrHideCommentsForStkBarChart2 == false)){
			divLegendPanelStackedBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
			.style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");

			svgPanelForStackedBarChart2.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
			.style("position","absolute");
		}
		else if ((showOrHideTableForStkBarChart2 == false) && (showOrHideCommentsForStkBarChart2 == false)){
			divLegendPanelStackedBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
			.style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");

			svgPanelForStackedBarChart2.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
			.style("position","absolute");
		}
		
		if(ismenuBtnOfStkBarChart2Clicked == false){
			ismenuBtnOfStkBarChart2Clicked = true;
			optsBtnPanelForStkBarChart2.style("display","block")
		}
		else if(ismenuBtnOfStkBarChart2Clicked == true){
			ismenuBtnOfStkBarChart2Clicked = false
			optsBtnPanelForStkBarChart2.style("display","none")
		}

		resizedFuctionForStackedBarChart2();
	})
    
    var tableButtonForStkBarChart2 = optsBtnPanelForStkBarChart2.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
    .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top','1px')
    .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
    var tableBtnImgVar = document.createElement("IMG");
    if(showOrHideTableForStkBarChart2 == false){
        tableBtnImgVar.src = "images/showTableIcon.png";
        tableButtonForStkBarChart2.attr("class","showTableClassForChartTable")
    }
    else if(showOrHideTableForStkBarChart2 == true){
        tableBtnImgVar.src = "images/cancelTableIcon.png";
        tableButtonForStkBarChart2.attr("class","hideTableClassForChartTable")
    }
    tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
    tableButtonForStkBarChart2[0][0].appendChild(tableBtnImgVar)
    
    var settingBtnForStkBarChart2 = optsBtnPanelForStkBarChart2.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
    .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 28 + 'px')
    .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
    var settingBtnImgVar = document.createElement("IMG");
    settingBtnImgVar.src = "images/settingsIcon.png";
    settingBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.82;")
    settingBtnForStkBarChart2[0][0].appendChild(settingBtnImgVar)
    
    var downloadBtnForStkBarChart2 = optsBtnPanelForStkBarChart2.append("div").attr("id","downloadBtnForStkBarChart2-ID-" + targetElement[0][0].id).style("width","20px").style("height","20px")
    .style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff").style('margin-left','2px').style('top', 54 + 'px')
    .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
    
    acinfotech.downloadFunctionality("downloadBtnForStkBarChart2-ID-" + targetElement[0][0].id,targetElement)
        
    var svgPanelForStackedBarChart2 = targetElement .append('svg') 
    .attr("id","svgPanelIDForStackedBarChart2" + targetElement[0][0].id).style("background-color",options.BGcolor) .style("position","absolute")
    .style("border","0px solid #d0d0d0")
    
    var commentsPanelDivForStkBarChart2 = targetElement.append("div") .attr("class","commentsPanelClassForSHBChart2")
    .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
	.style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
    .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)
    
    commentsPanelDivForStkBarChart2.on('click',function(d){
        $('.commentsClassForStkBarChart2' + targetElement[0][0].id).focus()
    })
    
    if(options.showTitle == true){
        
        chartTitlePanelForStackedBarChart2.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 8 + "%"; }).style("background-color",options.BGcolor)
        .html('<div  style="width: 100%; height:0%; position: absolute; top:25.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')
        
        if ((showOrHideTableForStkBarChart2 == false) && (showOrHideCommentsForStkBarChart2 == true)){
            
            var commentsForStkBarChart2 = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
            .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
            .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
            .css('line-height','1.1em').css('text-align','justify') .attr('class','commentsClassForStkBarChart2' + targetElement[0][0].id)
            
            svgPanelForStackedBarChart2.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%").style("background-color",options.BGcolor) .append('g')
            commentsPanelDivForStkBarChart2.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
            .style("top",78 + "%")
            .html(commentsForStkBarChart2[0].outerHTML.toString())
            
        }
        else if ((showOrHideTableForStkBarChart2 == true) && (showOrHideCommentsForStkBarChart2 == false)){
            
            svgPanelForStackedBarChart2.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .append('g')
            commentsPanelDivForStkBarChart2.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
        }
        else if ((showOrHideTableForStkBarChart2 == false) && (showOrHideCommentsForStkBarChart2 == false)){
            svgPanelForStackedBarChart2.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .append('g')
            commentsPanelDivForStkBarChart2.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
        }
        
        var margin = {top: 10 , right: 20, bottom: 80, left: 20}, //originally top: 42, left: 80
        width = (svgPanelForStackedBarChart2.node().getBoundingClientRect().width) - margin.left - margin.right,
        height = (svgPanelForStackedBarChart2.node().getBoundingClientRect().height) - margin.top - margin.bottom;
        
    }
    else if(options.showTitle == false){
        chartTitlePanelForStackedBarChart2.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });
        
        if ((showOrHideTableForStkBarChart2 == false) && (showOrHideCommentsForStkBarChart2 == true)){
            
            var commentsForStkBarChart2 = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
            .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
            .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
            .css('line-height','1.1em').css('text-align','justify')
            
            svgPanelForStackedBarChart2.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .style("background-color",options.BGcolor).append('g')
            commentsPanelDivForStkBarChart2.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
            .style("top",78 + "%")
            .html(commentsForStkBarChart2[0].outerHTML.toString())
            
        }
        else if ((showOrHideTableForStkBarChart2 == true) && (showOrHideCommentsForStkBarChart2 == false)){
            
            svgPanelForStackedBarChart2.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .style("background-color",options.BGcolor).append('g')
            commentsPanelDivForStkBarChart2.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
        }
        else if ((showOrHideTableForStkBarChart2 == false) && (showOrHideCommentsForStkBarChart2 == false)){
            svgPanelForStackedBarChart2.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .append('g')
            commentsPanelDivForStkBarChart2.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
        }
        
        var margin = {top: 10 , right: 20, bottom: 80, left: 20}, //originally top: 42, left: 80
        width = (svgPanelForStackedBarChart2.node().getBoundingClientRect().width) - margin.left - margin.right,
        height = svgPanelForStackedBarChart2.node().getBoundingClientRect().height - margin.top - margin.bottom;
    }
    
    var colours;
    
    // checking color set for bubbles and legend dots
    if(options.colorSet === undefined){
        options.colorSet = "one"
        colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
    }
    else if(options.colorSet.toString().toLowerCase() === "one"){
        options.colorSet = "one"
        colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
    }
    else if(options.colorSet.toString().toLowerCase() === "two"){
        options.colorSet = "two"
        colours = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
    }
    else if(options.colorSet.toString().toLowerCase() === "three"){
        options.colorSet = "three"
        colours = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
    }
    else
    {
        options.colorSet = "one"
        colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
    }
    
    //------------------ Settings panel DIV and everything within it section begins here ------------------
    
    var stgPanDivForStkBarChart2 = targetElement.append('div').style('width',"100%").style('height',"40%").attr("class","stgPanDivForStkHoriChart" + targetElement[0][0].id)
    .style('position','absolute').style('margin-left', "0px").style('border-top',"1px solid #f0f0f0").style('border-bottom',"1px solid #e5e5e5")
    .style("background-color",'#fcfcfc').style("z-index",90) .style("display","none") .style('top', 60.0 + "%") .style('height',40 + "%")
    
    $( '.stgPanDivForStkHoriChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
              var e0 = e.originalEvent,
              delta = e0.wheelDelta || -e0.detail;
              
              this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
              e.preventDefault();
    });
    
    var settingPanelTitle = stgPanDivForStkBarChart2.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
    .style('margin-left','0px').style('margin-top','10px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
    .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
    .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; color:#00001c;">'+ "Settings" +'</div>')
    
    var stgPanDivForStkChangeColorTitle = stgPanDivForStkBarChart2.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
    .style('margin-left','0px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
    .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
    .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Select color set " +'</div>')
    
    var stgPanCanBtnForStkBarChart2 = stgPanDivForStkBarChart2.append("div") .style("width","18px").style("height","17px").style('position','absolute')
    .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
    .style('background-color',"#FCFCFF")
    .style("border", "0.0px") .style("border-style", "solid").style('color','white')
    .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
    var cancelBtnImgVar = document.createElement("IMG");
    cancelBtnImgVar.src = "images/closeIcon.png";
    cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.9; background-color:#fcfcff")
    stgPanCanBtnForStkBarChart2[0][0].appendChild(cancelBtnImgVar)
    
    stgPanCanBtnForStkBarChart2.on('click', function() {
		stgPanDivForStkBarChart2.style("display","none") // Hiding setting panel

		if ((showOrHideTableForStkBarChart2 == false) && (showOrHideCommentsForStkBarChart2 == true)){
			divLegendPanelStackedBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
			.style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");

			svgPanelForStackedBarChart2.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
			.style("position","absolute");
		}
		else if ((showOrHideTableForStkBarChart2 == true) && (showOrHideCommentsForStkBarChart2 == false)){
			divLegendPanelStackedBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
			.style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");

			svgPanelForStackedBarChart2.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
			.style("position","absolute");
		}
		else if ((showOrHideTableForStkBarChart2 == false) && (showOrHideCommentsForStkBarChart2 == false)){
			divLegendPanelStackedBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
			.style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");

			svgPanelForStackedBarChart2.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
			.style("position","absolute");
		}
		resizedFuctionForStackedBarChart2();
    })
    
    var formForChangeSettingsPanel = stgPanDivForStkBarChart2.append("form");
    formForChangeSettingsPanel.style("background-color","#fcfcfc").style("margin-top","67px").style("font-family","Verdana,sans-serif").style("font-size","12px")
    .style("position","absolute").attr("id","formForChangeColorSettingsPanel" + targetElement[0][0].id).style("font-weight","Bold").style("width","180px")
    .style("height","58px").style("padding","0px").style("border-radius","0px") .style("margin-left","10px")
    
    var svgPanelForCrSetOne = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
    .style("width","160px").style("height","18px").style("margin-top","1px").style("margin-left","0px") .style("box-sizing","border-box")
    
    var colorSetOne = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
    var colorSetOneRange = d3.range(12);
    
    var colorSetOneDots = svgPanelForCrSetOne.append("g")
    colorSetOneDots.selectAll('rect') .data(colorSetOneRange) .enter() .append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
    .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("fill", function(d,i){return colorSetOne(i)})
    .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetOne(i); })
    .style("cursor","auto") .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
    
    var svgPanelForCrSetTwo = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
    .style("width","160px") .style("height","18px") .style("margin-top","20px") .style("margin-left","0px") .style("box-sizing","border-box")
    
    var colorSetTwo = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
    var colorSetTwoRange = d3.range(12);
    
    var colorSetTwoDots = svgPanelForCrSetTwo.append("g")
    colorSetTwoDots.selectAll('rect') .data(colorSetTwoRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
    .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto")
    .style("fill", function(d,i){return colorSetTwo(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
    .style("stroke",function(d,i){  return colorSetTwo(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
    
    var svgPanelForCrSetThree = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
    .style("width","160px") .style("height","18px") .style("margin-top","39px") .style("margin-left","0px") .style("box-sizing","border-box")
    
    var colorSetThree = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
    var colorSetThreeRange = d3.range(12);
    
    var colorSetThreeDots = svgPanelForCrSetThree.append("g")
    colorSetThreeDots.selectAll('rect') .data(colorSetThreeRange) .enter().append('rect')
    .attr('transform', 'translate(' + (2) + ',' + (1) + ')') .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10)
    .attr("height",10) .style("cursor","auto") .style("fill", function(d,i){return colorSetThree(i)}) .style("fill-opacity",0.93)
    .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetThree(i);  })
    .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
    
    if(options.colorSet.toString().toLowerCase() === "one"){
        svgPanelForCrSetOne.style('border',"1px solid #808080")
        svgPanelForCrSetTwo.style('border',"0px solid #808080")
        svgPanelForCrSetThree.style('border',"0px solid #808080")
    }
    else if(options.colorSet.toString().toLowerCase() === "two"){
        svgPanelForCrSetOne.style('border',"0px solid #808080")
        svgPanelForCrSetTwo.style('border',"1px solid #808080")
        svgPanelForCrSetThree.style('border',"0px solid #808080")
    }
    else if(options.colorSet.toString().toLowerCase() === "three"){
        svgPanelForCrSetOne.style('border',"0px solid #808080")
        svgPanelForCrSetTwo.style('border',"0px solid #808080")
        svgPanelForCrSetThree.style('border',"1px solid #808080")
    }
    else
    {
        svgPanelForCrSetOne.style('border',"1px solid #808080")
        svgPanelForCrSetTwo.style('border',"0px solid #808080")
        svgPanelForCrSetThree.style('border',"0px solid #808080")
    }
    
    svgPanelForCrSetOne.on('click',function(d){
           options.colorSet = "one"
           svgPanelForCrSetOne.style('border',"1px solid #808080")
           svgPanelForCrSetTwo.style('border',"0px solid #808080")
           svgPanelForCrSetThree.style('border',"0px solid #808080")
           
           colours = "";
           colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
           
           groupsForStackedBarChart2.style('fill', function (d, i) { return colours(i); })
           
           legendGroup.style("fill", function(d, i){ return colours(i);})
                           
   })
    svgPanelForCrSetTwo.on('click',function(d){
           options.colorSet = "two"
           svgPanelForCrSetOne.style('border',"0px solid #808080")
           svgPanelForCrSetTwo.style('border',"1px solid #808080")
           svgPanelForCrSetThree.style('border',"0px solid #808080")
           
           colours = "";
           colours = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
           
           groupsForStackedBarChart2.style('fill', function (d, i) { return colours(i); })
		   
           legendGroup.style("fill", function(d, i){ return colours(i);})
    })
    svgPanelForCrSetThree.on('click',function(d){
         options.colorSet = "three"
         svgPanelForCrSetOne.style('border',"0px solid #808080")
         svgPanelForCrSetTwo.style('border',"0px solid #808080")
         svgPanelForCrSetThree.style('border',"1px solid #808080")
         
         colours = "";
         colours = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
         
         groupsForStackedBarChart2.style('fill', function (d, i) {
                                         return colours(i);
                                         })
         legendGroup.style("fill", function(d, i){ return colours(i);})
     })
    
    
    //------------------ Settings panel DIV and everything inside it section ends here ------------------
    
    // Filter
    filterBtnForStackedBarChart2.on('click', function() {
                                    
            filterPanelForStkBarChart2.style("display","block");
            
            ismenuBtnOfStkBarChart2Clicked = false;
            optsBtnPanelForStkBarChart2.style("display","none");
            
            stgPanDivForStkBarChart2.style("display","none");
            
            if ((showOrHideTableForStkBarChart2 == false) && (showOrHideCommentsForStkBarChart2 == true)){
            divLegendPanelStackedBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
            
            svgPanelForStackedBarChart2.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
            .style("position","absolute");
            }
            else if ((showOrHideTableForStkBarChart2 == true) && (showOrHideCommentsForStkBarChart2 == false)){
            divLegendPanelStackedBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
            
            svgPanelForStackedBarChart2.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute");
            }
            else if ((showOrHideTableForStkBarChart2 == false) && (showOrHideCommentsForStkBarChart2 == false)){
            divLegendPanelStackedBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
            
            svgPanelForStackedBarChart2.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute");
            }
            
            resizedFuctionForStackedBarChart2();
                                    
    })
    
    // Refreshing Chart and Table
    refreshBtnForStackedBarChart2.on('click', function() {
                                     
             //isFilterClicked = false
             d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
             
             for(var i = 0; i<divAndChartsArray.length; i++){
             
                 if(targetElement[0][0].id === divAndChartsArray[i].divID){
                     options.data = divAndChartsArray[i].optionsData;
                     options.keys.stackedBars = newtargetElementAndOptionsArray[i].options.keys.stackedBars;
                 }
             }
             acinfotech.stackedBarChart2(targetElement,options)
                                     
     })
    
    // Refreshing Chart and Table
    commentsBtnForStkBarChart2.on('click', function() {
                                  
		if(options.showComments == false){ 
		  options.showComments = true;
		}
		else if(options.showComments == true){ 
		  options.showComments = false;
		}

		//isFilterClicked = false
		d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();

		for(var i = 0; i<divAndChartsArray.length; i++){

		  if(targetElement[0][0].id === divAndChartsArray[i].divID){
			  options.data = divAndChartsArray[i].optionsData;
			  options.keys.stackedBars = newtargetElementAndOptionsArray[i].options.keys.stackedBars;
			  options.showTable = false;
		  }
		}
		acinfotech.stackedBarChart2(targetElement,options)
                                  
	})
    
    // showing/hidding chart table
    tableButtonForStkBarChart2.on('click', function() {
                                  
		if(showOrHideTableForStkBarChart2 == false){
			options.showTable = true;
		}
		else if(showOrHideTableForStkBarChart2 == true){
			options.showTable = false;
		}
          
		d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();

		for(var i = 0; i<divAndChartsArray.length; i++){

			if(targetElement[0][0].id === divAndChartsArray[i].divID){
				options.data = divAndChartsArray[i].optionsData
				options.showComments = false;
			}
		}
		acinfotech.stackedBarChart2(targetElement,options)
                                  
	})
    
    settingBtnForStkBarChart2.on('click', function() {
                                 
         ismenuBtnOfStkBarChart2Clicked = false; // Menu toggle button variable
         optsBtnPanelForStkBarChart2.style("display","none") // To hide options button panel
         
         iconButtonTooltipForStackedChart.style("display","none") // Removing options button ToolTip
         settingBtnForStkBarChart2.style("cursor","pointer")
         
         stgPanDivForStkBarChart2.style("display","block") // Showing settings panel
         
         svgPanelForStackedBarChart2.style('width', 75 + "%") .style('height', 52 + "%").style("position","absolute"); // Decreasing chart panel
         divLegendPanelStackedBarChart2.style('width', 25 + "%") .style('height', 52 + "%").style("position","absolute"); // Decreasing chart panel
         
         resizedFuctionForStackedBarChart2(); // Calling resize function()
                                 
    })
    
    downloadBtnForStkBarChart2.on('click', function() {
      
      ismenuBtnOfStkBarChart2Clicked = false; // Changing menu button value to false
      optsBtnPanelForStkBarChart2.style("display","none") // Hiding option buttons panel
      
    })
        
    // Creating ToolTip for options button.
    var iconButtonTooltipForStackedChart = targetElement.append('div').style('width','240px').attr("id","too")
    .style('height',"25px").style('position','absolute')//.style('margin-left', "0px").style('top','25px')
    .style("background-color",'#404040 ').style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid") // 004b9d
    .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none").attr("border", 0.0)
    
    filterBtnForStackedBarChart2.on('mousemove', function(d,i) {
        var root = targetElement
        var m = d3.mouse(root.node());
        m[0] += 0
        m[1] += 0
        var filterButtonTooltipText = "Filter";
        
        iconButtonTooltipForStackedChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
        iconButtonTooltipForStackedChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')
                                    
    })
    filterBtnForStackedBarChart2.on('mouseout', function(d,i) {
        iconButtonTooltipForStackedChart.style("display","none")
    })
    
    refreshBtnForStackedBarChart2.on('mousemove', function(d,i) {
         var root = targetElement
         var m = d3.mouse(root.node());
         m[0] += 0
         m[1] += 0
         var refreshButtonTooltipText = "Refresh";
         
         iconButtonTooltipForStackedChart.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
         iconButtonTooltipForStackedChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ refreshButtonTooltipText +'</div>')
                                     
     })
    refreshBtnForStackedBarChart2.on('mouseout', function(d,i) {
         iconButtonTooltipForStackedChart.style("display","none")
     })
    
    commentsBtnForStkBarChart2.on('mousemove', function(d,i) {
          commentsPanelDivForStkBarChart2.style('background-color','#fafafa')
          var root = targetElement
          var m = d3.mouse(root.node());
          m[0] += 0
          m[1] += 0
          if(options.showComments == false){
			var commentButtonTooltipText = "Show Comments";
          }
          else if(options.showComments == true){
			var commentButtonTooltipText = "Hide Comments";
          }
          
          iconButtonTooltipForStackedChart.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
          iconButtonTooltipForStackedChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ commentButtonTooltipText +'</div>')
    })
    commentsBtnForStkBarChart2.on('mouseout', function(d,i) {
          commentsPanelDivForStkBarChart2.style('background-color','#ffffff')
          iconButtonTooltipForStackedChart.style("display","none")
    })
    
    menuBtnForStackedBarChart2.on('mousemove', function(d,i) {
          var root = targetElement
          var m = d3.mouse(root.node());
          m[0] += 0
          m[1] += 0
          var menuButtonTooltipText = "Menu";
          
          iconButtonTooltipForStackedChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
          iconButtonTooltipForStackedChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ menuButtonTooltipText +'</div>')
                                  
    })
    menuBtnForStackedBarChart2.on('mouseout', function(d,i) {
          iconButtonTooltipForStackedChart.style("display","none")
    })
    
    tableButtonForStkBarChart2.on('mousemove', function(d,i) {
		var root = targetElement
		var m = d3.mouse(root.node());
		m[0] += 0
		m[1] += 0
		if(showOrHideTableForStkBarChart2 ==  false){
			var tableButtonTooltipText = "Show Table";
		}
		else if(showOrHideTableForStkBarChart2 == true){
			var tableButtonTooltipText = "Hide Table";
		}

		iconButtonTooltipForStackedChart.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
		iconButtonTooltipForStackedChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ tableButtonTooltipText +'</div>')
                                  
    })
    tableButtonForStkBarChart2.on('mouseout', function(d,i) {
		iconButtonTooltipForStackedChart.style("display","none")
    })
    
    settingBtnForStkBarChart2.on('mousemove', function(d,i) {
		var root = targetElement
		var m = d3.mouse(root.node());
		m[0] += 0
		m[1] += 0
		var settingTooltipText = "Settings";

		iconButtonTooltipForStackedChart.style("width","67px").style("margin-left", (m[0] - 77) + "px").style("margin-top",(m[1]) + "px").style("display","block")
		iconButtonTooltipForStackedChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ settingTooltipText +'</div>')
	})
    settingBtnForStkBarChart2.on('mouseout', function(d,i) {
         iconButtonTooltipForStackedChart.style("display","none")
    })
    
    downloadBtnForStkBarChart2.on('mousemove', function(d,i) {
		var root = targetElement
		var m = d3.mouse(root.node());
		m[0] += 0
		m[1] += 0
		var downloadButtonTooltipText = "Download";

		iconButtonTooltipForStackedChart.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
		iconButtonTooltipForStackedChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
    })
    downloadBtnForStkBarChart2.on('mouseout', function(d,i) {
       iconButtonTooltipForStackedChart.style("display","none")
    })
        
    // ----------------- Filter panel and everything within it section begins here ----------------
    var filterPanelForStkBarChart2 = targetElement.append('div').style('width',350 + "px") .attr("class","filterPanelForStkBarChart2Class" + targetElement[0][0].id)
    .style('position','absolute').style('margin-left', "0px")
    .style("background-color",'#fefefe').style("z-index",11).style("border-color", "#ffffff").style("border-right", "solid #e5e5e5 1px")  .style("border-style", "solid") // 004b9d
    .style("box-shadow", "2px 0px 1px #eff8ec").style("display","none").style("border-top", "solid #fdfdfd 1px").style("border-left","0px").style("border-bottom", "0px")
    .style('top', 0.0 + "%").style('height', 100 + "%").style('overflow-y',"hidden").style("overflow-x","hidden")
    .style("border-bottom", "solid #e5e5e5 1px") .style("box-sizing","border-box")
    
    var filterPanelForStkBarChart2Title = filterPanelForStkBarChart2.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
    .style('margin-left','0px').style('margin-top','20px').style('text-indent','5px').style("font-size", "14px").style('position',"absolute")
    .style("box-shadow", "1px 1px 1px #007aff").style("width","350px").style("color","#000000")
    .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; top:25.0%; font-size:14px; font-family:inter; color:#00001c; font-weight:Bold;">'+ "Filter" +'</div>')
    
    var measuresColumnTitle = filterPanelForStkBarChart2.append("div") .style("width","140px").style("height","18px").style('position','absolute')
    .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '60px')
    .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; text-indent:3px;">Available Measures</div>');
    
    var measuresVariables = filterPanelForStkBarChart2.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable1"+targetElement[0][0].id)
    .style("list-style-type","none")
    .style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '78px')
    .style('position','absolute')
    .style("width","155px").style("min-height","190px").style("max-height","190px").style("border", "#f0f0f0 1px solid")
    .style("max-width","155px").style("overflow-x","hidden").style("overflow-y","auto")
    measuresVariables.style("left",0.0 + "px").style("padding","2px")
    
    $( ".filterPanelForStkBarChart2Class" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
         var e0 = e.originalEvent,
         delta = e0.wheelDelta || -e0.detail;
         
         this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
         e.preventDefault();
    });
    
    
    var measuresArray = [];
    var dimensionArray = [];
    
    var measuresArrayLength = [];
    var dimensionsArrayLength = [];
    
    dimensionArray.push(options.keys.label);
    //measuresArray = options.keys.stackedBars;
    
    for(var i = 0; i<divAndChartsArray.length; i++){
        if(targetElement[0][0].id === divAndChartsArray[i].divID){
            var stkBarChart2MeasuresArray = [];
            newtargetElementAndOptionsArray[i].options.data.forEach(function(d,i){
                stkBarChart2MeasuresArray.push(d[options.keys.stackedBars])
            })
            
            measuresArray = stkBarChart2MeasuresArray; //newtargetElementAndOptionsArray[i].options.keys.label;
        }
    }
    
    // filter process
    var uniqueMeasuresArrayKeys = [];
    $.each(measuresArray, function(i, el){
       if($.inArray(el, uniqueMeasuresArrayKeys) === -1){
           uniqueMeasuresArrayKeys.push(el);
       }
   });
    
    var uniqueDimensionArrayKeys = [];
    $.each(dimensionArray, function(i, el){
       if($.inArray(el, uniqueDimensionArrayKeys) === -1){
           uniqueDimensionArrayKeys.push(el);
       }
   });
    
    // setting lenght for arrays
    for(var i = 0; i<uniqueMeasuresArrayKeys.length; i++){
        measuresArrayLength.push(i);
    }
    
    for(var i = 0; i<uniqueDimensionArrayKeys.length; i++){
        dimensionsArrayLength.push(i);
    }
    
    var measuresVariables1 = measuresVariables.selectAll("li") .data(measuresArrayLength).enter().append("li")
    .style("width","130px") .style("max-height","22px").style("cursor","move")
    .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#bcf1bc").style("font-weight","Normal")
    .style("list-style-type","none").style("border","1px #89e789 solid").style("color","#006600").style("font-family","Verdana,sans-serif")
    .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
    .text(function(d) {return uniqueMeasuresArrayKeys[d]})
    measuresVariables1.attr("class","MeasuresClass"+targetElement[0][0].id)
    
    var measuresColumnReceivedUI_TableTitle = filterPanelForStkBarChart2.append("div") .style("width","140px").style("height","18px").style('position','absolute')
    .style('background-color',"#fefefe").style('margin-left','180px').style('margin-top', '60px')
    .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; ">Selected Measures</div>');
    
    var measuresColumnReceivedUI_Table = filterPanelForStkBarChart2.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable3"+targetElement[0][0].id)
    .style('background-color',"#ffffff").style('margin-left','180px').style('margin-top', '78px')
    .style("width","155px").style('position','absolute').style("padding","2px").style("min-height","190px")
    .style("border","1px #c1c1c1 dashed") .style("max-height","190px") .style("overflow-x","hidden") .style("overflow-y","auto")
    //.html('<div class=unsortable  style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:65.0%; font-size:14px; font-family:inter;  color:#99ea99; font-weight:Normal; text-align:center;">Drag and Drop Measures here from Available Measures List. </div>');
    .html('<img class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' src="images/dragIcon.png" style=" width:36px; height:36px; position:absolute; margin-left:65px; margin-top:60px; opacity:0.6"/>'
          + '<div class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:60.0%; font-size:12px; font-family:inter;  color:#89d289; font-weight:Normal; text-align:center;">Drop Measures here. </div>');
    //.html('<div style="background-image: url(images/dragIcon.png); height: 64px; width: 64px; border: 1px solid black;"> </div>');
    
    var cancelButton = filterPanelForStkBarChart2.append("div") .style("width","23px").style("height","21px").style('position','absolute')
    .style('margin-left','320px').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
    .style('background-color',"#FCFCFF")
    .style("border", "0.0px") .style("border-style", "solid").style('color','white')
    .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
    var cancelBtnImgVar = document.createElement("IMG");
    cancelBtnImgVar.src = "images/closeIcon.png";
    cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.9; background-color:#fcfcff")
    cancelButton[0][0].appendChild(cancelBtnImgVar)
    
    cancelButton.on("click", function(){
        filterPanelForStkBarChart2.style("display","none")
        
        if ((showOrHideTableForStkBarChart2 == false) && (showOrHideCommentsForStkBarChart2 == true)){
        divLegendPanelStackedBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
        .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
        
        svgPanelForStackedBarChart2.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
        .style("position","absolute");
        }
        else if ((showOrHideTableForStkBarChart2 == true) && (showOrHideCommentsForStkBarChart2 == false)){
        divLegendPanelStackedBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
        .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
        
        svgPanelForStackedBarChart2.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
        .style("position","absolute");
        }
        else if ((showOrHideTableForStkBarChart2 == false) && (showOrHideCommentsForStkBarChart2 == false)){
        divLegendPanelStackedBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
        .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
        
        svgPanelForStackedBarChart2.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
        .style("position","absolute");
        }
    })
    
    var reRenderChartAndTableButton = filterPanelForStkBarChart2.append("button").style("width","120px").style("height","25px").style('position','absolute')
    .style('margin-left','112px').style('margin-top','298px') .style("border-style", "none").style('background-color',"#2196f3")
    .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','15px').style("border-style", "solid").style('color','#ffffff')
    .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 1px #9b9b9b").style("border-radius","0px")
    var textForReRenderButton = document.createTextNode("Apply Changes");
    reRenderChartAndTableButton[0][0].appendChild(textForReRenderButton)
    
    reRenderChartAndTableButton.on("click", function(){
                           
           if( $("#sortable3"+targetElement[0][0].id).children("li").length == 0 )
           {
           
               var alertPageDisabledDivForStkBarChart2 =targetElement.append('div').style('width',100 + '%')
               .style('height',100 + "%").style('position','absolute').style('margin-left', '0px').style('top', '0px')
               .style("background-color",'#f3f3f3').style("z-index",99)//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
               .style("opacity",0.2).style("display","block")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
               
               var alertDivForStkBarChart2 = targetElement.append('div').style('width','350px')
               .style('height',"150px").style('position','absolute').style('left', ((targetElement[0][0].clientWidth/2) - 175) + "px").style('top', '1px')
               .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "solid").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
               .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","0px")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
               //.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Bold;">Sorry, no result found for selected' + 'range!'+ '</br>' + '<label style=text-indent:10px;> Hello</label' +'</div>')
               .html('<p  style="width: 340px; height:0%; background-color:#c7c7c7; position: absolute; top:40.0%; font-size:14px; font-family:inter; font-weight:Bold; margin-left:10px;  color:#f8f8f8; font-weight:Normal;">Check whether the Selected Measures box is not empty!</p>')
               
               var alertDivTitleForStkBarChart2 = alertDivForStkBarChart2.append('div').style('width','340px')
               .style('height',"30px").style('position','absolute').style('margin-left', "0px").style('top', '0px')
               .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "none").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
               .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","2px")
               .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; font-weight:Bold; text-indent:5px;  color:#e5e5e5; font-weight:Normal;">TimeBound</div>')
               
               var stkBarChart2AlertOKButton = alertDivForStkBarChart2.append("button") .style("width","40px") .style("height","20px") .style('position','absolute') .style("box-shadow", "0px 1px 1px #B8B8B8")
               .style('background-color',"#7cc15e") .style('margin-left','300px') .style('top', "120px").style("color","#ffffff")
               .style("display","block").style('padding-top',"0px").style("cursor","pointer").style("box-shadow", "1px 1px 1px #56973a") .style("border-style", "none")
               .style("font-family","Verdana,sans-serif").style("font-size","14px").style("text-align","center").style("vertical-align","middle").style("border-radius","0px")
               .style("z-index",999)
               
               var textForStkBarChart2AlertOKButton = document.createTextNode("OK");
               stkBarChart2AlertOKButton[0][0].appendChild(textForStkBarChart2AlertOKButton)
               
               $("#"+targetElement[0][0].id).resizable('disable');
               
               stkBarChart2AlertOKButton.on('click', function() {
                    alertDivForStkBarChart2.remove();
                    alertPageDisabledDivForStkBarChart2.remove()
                    $("#"+targetElement[0][0].id).resizable('enable');
                })
               
               filterBtnForStackedBarChart2.style("cursor","pointer")
               
               if(showOrHideTableForStkBarChart2 == false){
                   svgPanelForStackedBarChart2.style('width', 75 + "%") .style('height', 85 + "%").style("position","absolute")
                   divLegendPanelStackedBarChart2.style('width', 25 + "%") .style('height', 85 + "%").style("position","absolute")
               }
               else if(showOrHideTableForStkBarChart2 == true){
                   svgPanelForStackedBarChart2.style('width', 75 + "%") .style('height', 52 + "%").style("position","absolute")
                   divLegendPanelStackedBarChart2.style('width', 25 + "%") .style('height', 52 + "%").style("position","absolute")
               }
               
                   resizedFuctionForStackedBarChart2();
               }
               
               else{
               
               var selectedStackMeasures = [];
               for(var i=0; i<$("#sortable3"+targetElement[0][0].id).children("li").length;i++){
                   selectedStackMeasures.push($("#sortable3"+targetElement[0][0].id).children("li")[i].textContent)
               }
               
               var newFilteredData = [];
               selectedStackMeasures.forEach(function(d,i){
                     for(var j = 0; j<divAndChartsArray.length; j++){
                         if(targetElement[0][0].id === divAndChartsArray[j].divID){
                             newtargetElementAndOptionsArray[j].options.data.forEach(function(data,k){
                                 if(data[options.keys.stackedBars].toString().toLowerCase() === selectedStackMeasures[i].toString().toLowerCase()){
                                     newFilteredData.push(data)
                                 }
                               })
                         }
                     }
                })
               
               var newOptions = {
                data: newFilteredData,
                dataForDrillDown: options.dataForDrillDown,
                dataForTable: options.dataForTable,
                isDataDetailedForTable: options.isDataDetailedForTable,
                keys: {
                    label: options.keys.label,//$("#sortable4"+targetElement[0][0].id).children("li")[0].textContent.toString(),
                    stackedBars: options.keys.stackedBars,
                },
                chartTitle:options.chartTitle,
                xAxisLable: options.xAxisLable,//$("#sortable4"+targetElement[0][0].id).children("li")[0].textContent,
                yAxisLable: "",
                showTitle: true,
                colorSet: options.colorSet,
                series:options.series,
                legend:options.legend,
                BGcolor:options.BGcolor,
                drillDownColumnName:options.drillDownColumnName,
                showTable: options.showTable,
                showComments: options.showComments,
                comments: options.comments,
                resizeButtonID: options.resizeButtonID //document.getElementById("resizeBtn").id
                }
                d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                acinfotech.stackedBarChart2(targetElement,newOptions)
           }
                                   
       })
    
    var textBoxForMeasureColumnFrom;
    var textBoxForMeasureColumnTo;
    var selectTitleDivForEachDimension;
    
    
    $( "ul.droptrue"+targetElement[0][0].id ).sortable({
               appendTo: document.body,
               helper: "clone",
               connectWith: ".droptrue"+targetElement[0][0].id,
               scroll: false,
               cancel: '.unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+','+' .unMoveableIconAndTextClassDimensions'+targetElement[0][0].id,
               revertDuration: 10,
               scrollSensitivity: 10,
               scrollSpeed: 1,
               dynamic: true,
               
               receive: function(e, ui) {
               
                   if (($(this)[0].id == "sortable3"+targetElement[0][0].id) || ($(this)[0].id == "sortable1"+targetElement[0][0].id)) {
                   
                   if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                   if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                   (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                   }
                   else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                   (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                   }
                   
                   }
                   } // if (($(this)[0].id == "sortable3") || ($(this)[0].id == "sortable1"))
                   
                   else if (($(this)[0].id == "sortable2"+targetElement[0][0].id) || ($(this)[0].id == "sortable4"+targetElement[0][0].id)) {
                   if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                   //ui.sender.sortable("cancel");
                   
                   if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                   (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                   }
                   else if(  ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                   (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                   }
                   }
                   } //if (($(this)[0].id == "sortable2") || ($(this)[0].id == "sortable4")) {
                   
                   $(ui.item).css({ 'position': 'relative' });
                   
                   if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                   ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                   }
                   
                   else if ($(this)[0].id == "sortable3"+targetElement[0][0].id) { // checking if the dropped element is in Measures drop area
                   
                   if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                   ui.sender.sortable("cancel");
                   }
                   else {
                   //ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                   }
                   
                   } // else if ($(this)[0].id == "sortable3") // checking if the dropped element is in Measures drop area ends here.
                   
                   else if ($(this)[0].id == "sortable4"+targetElement[0][0].id) { // checking if the dropped element is in Dimension drop area
                   
                   if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                   ui.sender.sortable("cancel");
                   }
                   else {
                   ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                   }
                   } //else if ($(this)[0].id == "sortable4")  // checking if the dropped element is in Dimension drop area ends here
                   
                   if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                   
                   if ($(this)[0].id == "sortable1"+targetElement[0][0].id){
                   if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                   
                   if( ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                   ui.sender.sortable("cancel");
                   } // if(  ui.sender.attr("id") === "sortable4")
                   
                   else if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                   ui.sender.sortable("cancel");
                   }
                   
                   } // if(ui.item.hasClass("DimesionsClass"))
                   }
                   if ($(this)[0].id == "sortable2"+targetElement[0][0].id){
                   if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                   
                   if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                   ui.sender.sortable("cancel");
                   }
                   else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                   ui.sender.sortable("cancel");
                   
                   }
                   }
                   }
                   
                   } //if ($(this)[0].id == "sortable1")
                   
                   if ($(this)[0].id == "sortable4"+targetElement[0][0].id){
                   if ($(this).children('li').length > 1 ){
                   ui.sender.sortable("cancel");
                   ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                   }
                   }
                   
               }, //receive ends here
               
				start:function(ev, ui) { },
				stop:function(ev, ui) { },
	});
    
    /* ----------------- Filter panel and everything within it section ends here -----------------*/
    
    var finalArrayNew = [];
    options.data.forEach(function(d, i) {
                         
		var temp1 = {};
		temp1["name"] = d[options.keys.stackedBars]

		finalArrayNew.push(temp1)
	})
    
    var finalNewNewArray = [];
    var dataArray1 = [];
    finalArrayNew.forEach(function(d, i) {
                          
		var temp1 = {};
		temp1["name"] = d["name"]

		for (j = 0; j < options.keys.label.length; j++) {

			var tempTemp = {};
			tempTemp["label"] = options.keys.label[j];
			tempTemp["value"] = +options.data[i][options.keys.label[j]]

			dataArray1.push(tempTemp)
		}

		temp1["data"] = dataArray1;
		dataArray1 = []
		finalNewNewArray.push(temp1)
	})
    
    var margins = {
    top: 12,
    left: 48,
    right: 24,
    bottom: 24
    },
    
    width = (svgPanelForStackedBarChart2.node().getBoundingClientRect().width) - margin.left - margin.right,
    height = (svgPanelForStackedBarChart2.node().getBoundingClientRect().height) - margin.top - margin.bottom
    
    dataset = finalNewNewArray,
    series = dataset.map(function (d) { return d.name; }),
    dataset = dataset.map(function (d) {
                          return d.data.map(function (o, i) {
                                            return {
                                            y: o.value,
                                            x: o.label
                                            };
                                            });
                          }),
    stack = d3.layout.stack();
    
    stack(dataset);
    
    var dataset = dataset.map(function (group) {
                              return group.map(function (d) {
                                               // Invert the x and y values, and y0 becomes x0
                                               
                                               return {
                                               x: +d.y,
                                               y: d.x,
                                               x0: +d.y0
                                               };
                                               });
                              }),
    svgStackedBarChart2 = svgPanelForStackedBarChart2 .append('svg') .append('g')
    .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'),
    xMax = d3.max(dataset, function (group) {
                  
                  return d3.max(group, function (d) {
                                return (+d.x) + (+d.x0);
                                });
                  }),
    months = dataset[0].map(function (d) { return d.y; }),
    
    xScale = d3.scale.ordinal() .domain(months) .rangeRoundBands([0, width], .20),
    
    yScale = d3.scale.linear() .domain([0, xMax]) .range([height, 0]),
    
    xAxis = d3.svg.axis() .scale(xScale) .orient('bottom'),
    yAxis = d3.svg.axis() .scale(yScale) .orient('left'),
    
    groupsForStackedBarChart2 = svgStackedBarChart2.selectAll('g') .data(dataset) .enter() .append('g')
    .style('fill', function (d, i) { return colours(i); }),
    
    xScale1 = d3.scale.ordinal() .domain(months) .rangeRoundBands([0, width], .20),
    
    yScale1 = d3.scale.linear() .domain([0, xMax]) .range([0, height]),
    months = dataset[0].map(function (d) { return d.y; }),
    
    rectsForStackedBarChart2 = groupsForStackedBarChart2.selectAll('rect') .data(function (d) { return d; }) .enter() .append('rect')
    
	groupsForStackedBarChart2.selectAll('rect')
	.attr('x', function (d,i) { return xScale1(d.y); })
	.attr("width", xScale1.rangeBand())
	.attr("y", function (d) { return height; })
	.attr("height", function (d) { return 0; })
	.transition() .delay(400) .duration(800)
	.attr('y', function (d, i) { return height - yScale1(d.x0) - yScale1(d.x) })
	.attr("height", function (d) { return yScale1(d.x); }) .style("cursor","auto")
    
    if(options.dataForDrillDown.length == 0){
    
        var columnNames = d3.keys(options.data[0])
        var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
    
        for(var i = 0; i < columnNames.length ; i++){
            for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                    for(var k = 0; k < options.data.length; k++){
                        var len = d3.select(groupsForStackedBarChart2[0][k]).selectAll('rect')
                        for(var l = 0; l < options.keys.label.length; l++){
                            d3.select(len[0][l]).attr('data-drilldownkey', function(d,index){
                                return JSON.stringify(options.data[k]).slice(1, -1).split('"').join("").split(':').join("|")
                            })
                        }
                    }
                }
                else {
                }
            }
        }
    }
    
    else if(options.dataForDrillDown.length > 0){
        
        options.data.forEach(function(d, i) {

            options.dataForDrillDown.forEach(function(val, j) {
                  var optKeysLabVal = options.keys.stackedBars.toString().toLowerCase();
                  var key, keys = Object.keys(val), n = keys.length, newObj={}
                  while (n--) { key = keys[n]; newObj[key.toLowerCase()] = val[key]; }
                  if(d[options.keys.stackedBars].toString().toLowerCase() === newObj[optKeysLabVal].toString().toLowerCase()){
                  options.keys.label.forEach(function(measures, k) {
                                             var optKeysStkVal = measures.toString().toLowerCase();
                                             if(d[measures] == newObj[optKeysStkVal]) {
                                             var bars = d3.select(groupsForStackedBarChart2[0])
                                             bars[0].forEach(function(g, index) {
                                                             var dd = d3.select(g)[0]
                                                             dd[0].forEach(function(rect, index1) {
                                                                           var ddd = d3.select(rect)[0]
                                                                           if(+ddd[0].__data__[k].x == +d[measures]){
                                                                           var r = d3.select(ddd[0]).selectAll("rect")
                                                                           var rr = r[0][k]
                                                                           d3.select(rr).attr('data-drilldownkey', function(d,index){ return JSON.stringify(val).slice(1, -1).split('"').join("").split(':').join("|") })
                                                                           } // if(+ddd[0].__data__[k].x == +d[measures])
                                                                           }) //dd[0]
                                                             }) // bars[0]
                                             } // if(d[measures] == newObj[optKeysStkVal])
                                             }) // options.keys.label.forEach(function(measures, k)
                  } // if(d[options.keys.stackedBars].toString().toLowerCase() === newObj[optKeysLabVal].toString().toLowerCase())
            }) // options.dataForDrillDown.forEach(function(val, j)
        }) // options.data.forEach(function(d, i)
    }
    
    var format1 = d3.format('.2s')
    var textOnStackedBarChart2 = groupsForStackedBarChart2.selectAll(".text") .data(function (d) { return d; })
    
    textOnStackedBarChart2.enter() .append("text") .attr("class","text");
    
    textOnStackedBarChart2.style("text-anchor", "middle").style("font-family", "Verdana,sans-serif").style("font-size", "12px")
	.style("fill", "#ffffff").style("text-shadow","1px 0px 1px rgba(34,34,34,0.6)")
	.attr("x", function(d,i) { return xScale1(d.y)+xScale1.rangeBand()/2; })
	.attr("y", function (d) { return height; })
	.transition() .delay(400) .duration(800)
	.attr("y", function(d) { return (height -yScale1(d.x0) - yScale1(d.x))+(yScale1(d.x)/1.5);})
    .text(function(d){
        if(d.x.toString().indexOf('.') === -1)
		{
			if(d.x.toString().length <= 3){ return d.x; }
			else { return format1(d.x) }
		}
		else {
			return d.x.toString();
		}
	})
    let key=options.xAxisLable;
    let array=options.data.map(value => value[key]);
    let ArrayValue=[];
    var RotateValue;
    for(let i=0;i<array.length;i++){
            ArrayValue[i]=array[i].length;
    }
    const numberGreaterThanLimit = ArrayValue.filter((v) => v > 5); 
        // Adding the text label for the x axis
    var xAxisVariable =  svgStackedBarChart2.append("text") .attr("transform", "translate(" + ((width/2) - 2) + " ," + (height+margin.bottom - 2) + ")")
    .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif") .style("font-weight","Bold") .style("font-size","12px") .text(options.xAxisLable) .style('fill','#00001c')
    .style("text-transform","capitalize") .style("font-style","normal")

    svgStackedBarChart2.append('g') .attr("class", "x axis") .attr('transform', 'translate(0,' + height + ')') .call(xAxis)
    .selectAll("text") .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') .attr("transform", function(d) 
    { if(numberGreaterThanLimit.length>0){return "rotate(-45)"}
    else{
    return "rotate(0)" }})
    .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
    .text(function(d,i) {
        if(d.length > 9)
        return d.substring(0,9)+'...';
        else
        return d;
        })
    
    
    
    //------------- adding legend section --------------
    var divLegendPanelStackedBarChart2 = targetElement .append('div')  .attr("class","divLegendPanelClassForStackedBarChart2")
    .style("background-color",options.BGcolor) .style('position',"absolute")
    //.style('width', 25 + "%") .style('height', 92 + "%") .style("left",75 + "%").style("top",8 + "%")
    
    if(options.showTitle == true){
        
        if ((showOrHideTableForStkBarChart2 == false) && (showOrHideCommentsForStkBarChart2 == true)){
            divLegendPanelStackedBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%") .style("background-color",options.BGcolor) ;
            
            svgPanelForStackedBarChart2.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
            .style("position","absolute");
        }
        else if ((showOrHideTableForStkBarChart2 == true) && (showOrHideCommentsForStkBarChart2 == false)){
            divLegendPanelStackedBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%") .style("background-color",options.BGcolor) ;
            
            svgPanelForStackedBarChart2.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute");
        }
        else if ((showOrHideTableForStkBarChart2 == false) && (showOrHideCommentsForStkBarChart2 == false)){
            divLegendPanelStackedBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%") .style("background-color",options.BGcolor) ;
            
            svgPanelForStackedBarChart2.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute");
        }
        
    }
    else if(options.showTitle == false){
        
        if ((showOrHideTableForStkBarChart2 == false) && (showOrHideCommentsForStkBarChart2 == true)){
            divLegendPanelStackedBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
            
            svgPanelForStackedBarChart2.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
            .style("position","absolute");
        }
        else if ((showOrHideTableForStkBarChart2 == true) && (showOrHideCommentsForStkBarChart2 == false)){
            divLegendPanelStackedBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
            
            svgPanelForStackedBarChart2.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute");
        }
        else if ((showOrHideTableForStkBarChart2 == false) && (showOrHideCommentsForStkBarChart2 == false)){
            divLegendPanelStackedBarChart2.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
            
            svgPanelForStackedBarChart2.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute");
        }
    }
    
    var legendPanelSvgStackedBarChart2 = divLegendPanelStackedBarChart2 .append('svg')  .attr("class","").style("background-color",options.BGcolor).style('position',"absolute")
    .style('width', 100 + "%") .style('height', 100 + "%") .style("left",0 + "%").style("top",0 + "%")
        
    var legend = legendPanelSvgStackedBarChart2.append("g") .attr("class", "legend").style("background-color",options.BGcolor) .attr("height", "100%") .attr("width", "100%")
    .attr('transform', 'translate(0,20)')  
    
    //Create colour squares
    var legendGroup = legend.selectAll('rect') .data(options.data) .enter() .append("rect") .attr("x", 5)
    .attr("y", function(d, i){ return i * 16;}) .attr("width", 14) .attr("height", 14) .attr("rx",10) .attr("ry",10)
    .style("fill", function(d, i){ return colours(i);}) .style("cursor","auto")
    
    //Create text next to squares
    legend.selectAll('text') .data(options.data) .enter() .append("text") .attr("x", 25) .attr("y", function(d, i){ return i * 16 + 12;})
    .attr("fill", "#00001c") .text(function(d,i) {if(d[options.keys.stackedBars].length > 10)
        return d[options.keys.stackedBars].substring(0,10)+'...';
    else
        return d[options.keys.stackedBars];}) .style('font-size', '14px') .attr("fill","#00001c") .style("font-family","Verdana,sans-serif")
    
    // Aligning Legend (vertically)
    var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelStackedBarChart2[0][0].style.width) / 100)
    var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelStackedBarChart2[0][0].style.height) / 100)
    
    var legendRectSize = 11;
    var legendSpacing = 4;
    
        legend.transition().duration(0).attr('transform', function(d, i) {
			var eachRectHeight = legendRectSize + legendSpacing;
			var offset =  eachRectHeight * colours.domain().length / 2;
			var horz = 5;
			var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.data.length))/2.0; // originally 2.0

			return 'translate(' + horz + ',' + vert + ')';
        })

        legendGroup.on('mouseover',function(d,i){
               
			if(options.keys.stackedBars.length > 1){ // to check if the stack set is more than 1
               
				// to check whether the widget is being resized or not (to save new xScale)
				if(yScale1GlobalVar == undefined){ yScale1GlobalVar = yScale1; }

				if(newHeightVar == undefined){ newHeightVar = height }

				textOnStackedBarChart2.style('display','none')

				d3.select(groupsForStackedBarChart2[0][i]).selectAll('text').style('display','block')
				.transition().duration(1000).ease('bounce').attr("y", function(d,i) { return (newHeightVar - yScale1GlobalVar(d.x)) - 5 })
				.style("fill", "#00001c") .style("text-shadow","0px 0px 0px rgba(34,34,34,0.6)") .style('font-size',"12px")


				groupsForStackedBarChart2.selectAll('rect').style('display','none')
				var g = d3.select(groupsForStackedBarChart2[0][i]).selectAll('rect').style('display','block')
				.transition().duration(1000).ease('bounce')
				.attr("y", function(d,i) { return newHeightVar - yScale1GlobalVar(d.x) })
			}
        })

        legendGroup.on('mouseout',function(d,i){
               
			if(yScale1GlobalVar == undefined){ yScale1GlobalVar = yScale1; }

			if(newHeightVar == undefined){ newHeightVar = height; }

			textOnStackedBarChart2.style('display','block')

			d3.select(groupsForStackedBarChart2[0][i]).selectAll('text').style('display','block').style('font-size',"10px")
			.transition().duration(1000).ease('bounce') .style("fill", "#ffffff") .style("text-shadow","1px 0px 1px rgba(34,34,34,0.6)")
			.attr("y", function(d) { return (newHeightVar - yScale1GlobalVar(d.x0) - yScale1GlobalVar(d.x))+(yScale1GlobalVar(d.x)/1.5);})


			groupsForStackedBarChart2.selectAll('rect').style('display','block')
			var g = d3.select(groupsForStackedBarChart2[0][i]).selectAll('rect').transition().duration(1000).ease('bounce')
			.attr("y", function(d,i) { return newHeightVar - yScale1GlobalVar(d.x0) - yScale1GlobalVar(d.x) })
        })
    
    //---------creating tooltip----
    var tooltipForStackedBarChart2 = targetElement .append('div') .attr('class', 'tooltipPie') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
    .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
    .style("padding-right", "7px") .style("background", "#F8F8F8") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style("z-index",1000)
    .style("border", "1.0px") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","60px")
    
    tooltipForStackedBarChart2.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
    tooltipForStackedBarChart2.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");
    
    
    rectsForStackedBarChart2.on('mousemove', function (d,i){
            
        var root = targetElement
        var m = d3.mouse(root.node());
        m[0] += 0
        m[1] += 0
        
        //tooltipForStackedBarChart2.select('.label').html(options.keys.label + " : " + d.y)
        tooltipForStackedBarChart2.select('.count').html(d.x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
        tooltipForStackedBarChart2.style('visibility', 'visible')
        tooltipForStackedBarChart2.select('hr').style("background-color", d3.select(this).style("fill") )
        tooltipForStackedBarChart2.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-10) + "px").style("display","block")
            
    })
    .on('mouseout', function(){ tooltipForStackedBarChart2.style("display","none") })
    
    textOnStackedBarChart2.on('mousemove', function (d,i){
		var root = targetElement
		var m = d3.mouse(root.node());
		m[0] += 0
		m[1] += 0

		//tooltipForStackedHoriChart.select('.label').html(options.keys.label + " : " + d.y)
		tooltipForStackedBarChart2.select('.count').html(d.x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
		tooltipForStackedBarChart2.style('visibility', 'visible')
		//tooltipForStackedHoriChart.select('hr').style("background-color", d3.select(this).style("fill") )
		tooltipForStackedBarChart2.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-10) + "px").style("display","block")
    })
    .on('mouseout', function(){ tooltipForStackedBarChart2.style("display","none") })
    
    // ----------------------- adding table section ------------------
    var tablePanelForStackedChart =  targetElement.append("div") .attr("id",targetElement[0][0].id + "holderForStackedChartTableID")
    .attr("class","scrollingDivForTable-Class tableDivForStackedBarChart2" + targetElement[0][0].id) .style('background-color',options.BGcolor) .style('position','absolute')
    .style("display","block") .style("overflow","hidden") .style("width", function(d) {  return 100.0 + "%"; })
    .style("height", function(d) { return 40 + "%"; }) .style("left",0 + "%").style("z-index",10)
    
    $( '.tableDivForStackedBarChart2' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
		var e0 = e.originalEvent,
		delta = e0.wheelDelta || -e0.detail;

		this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
		e.preventDefault();
	});
    
    if(options.showTitle == true ){
        tablePanelForStackedChart.style("top",60.0  + "%")
    }
    else if(options.showTitle == false  ){
        tablePanelForStackedChart.style("top",60.0  + "%")
        
    }
    tablePanelForStackedChart.html('<table class = "tableClassForStkBarChart2' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                   '<thead class = "theadClassForStkBarChart2' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForStkBarChart2' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                                   '<tbody class = "tBodyClassForStkBarChart2' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                   '</table>'
                                   )
    
    tablePanelForStackedChart.select('table').attr("id",targetElement[0][0].id + "tableID")
    
    // Show or Hide Table scroll bar when mouseover on widget
    targetElement.on('mouseover',function(){ tablePanelForStackedChart.style("overflow","auto") })
    targetElement.on('mouseout',function(d){ tablePanelForStackedChart.style("overflow","hidden") })
    
    var tableDataForStkBarChart2 = [];
    if(options.dataForTable.length > 0){
        tableDataForStkBarChart2 = options.dataForTable;
    }
    else {
        tableDataForStkBarChart2 = options.data;
    }
    
    var tableDataForStkBarChart2 = [];
    if(options.dataForTable.length > 0){
        tableDataForStkBarChart2 = options.dataForTable;
    }
    else {
        tableDataForStkBarChart2 = options.data;
    }
    
    var thead = tablePanelForStackedChart.select("thead").selectAll("th") .data(d3.keys(tableDataForStkBarChart2[0]))
    .enter().append("th") .text(function(d){return d.charAt(0) .toUpperCase() + d.substr(1)}) .style("cursor","pointer") .style("min-width","100px")
    
    var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff") //f4f4f4
    .style("position","relative")
    
    var thead1 = d3.select(".thead1ClassForStkBarChart2" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tableDataForStkBarChart2[0]))
    .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
    
    var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff") //f4f4f4
    .style("position","relative")
    
    var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
    .attr("id", "ascendingIconIDForStackedBarChart2") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
    
    var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
    .attr("id", "descendingIconIDForStackedBarChart2") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
    
    var tr = tablePanelForStackedChart.select("tbody").selectAll("tr") .data(tableDataForStkBarChart2).enter().append("tr")
    .attr("id", function(d,i) { return "slice" + i })
    
    // cells
    var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d})
    .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
    
    var $table = $('.tableClassForStkBarChart2' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
    
    d3.select(".theadClassForStkBarChart2" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
        d.forEach(function(dd,j){
            colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
        })
    })
    
    $(".thead1ClassForStkBarChart2" + targetElement[0][0].id).insertAfter('.tBodyClassForStkBarChart2' + targetElement[0][0].id)
    
    $(".thead1ClassForStkBarChart2" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForStackedBarChart2' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
    
    tablePanelForStackedChart.select(".thead1ClassForStkBarChart2" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
		d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
    })
    
    $('.tableDivForStackedBarChart2' + targetElement[0][0].id).scroll(function () {
                                                               
        $(".thead1ClassForStkBarChart2" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForStackedBarChart2' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
                                                               
    })
    
    var sortOrder = false;
    thead1.on("click",function(k,index){
             
             sortOrder = !sortOrder;
             
             tablePanelForStackedChart.select(".thead1ClassForStkBarChart2" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                                                            
                if (sortOrder) {
                
                if(i == index){
                    d3.select(this).select('svg').select('#descendingIconIDForStackedBarChart2').style("visibility", "hidden")
                    d3.select(this).select('svg').select('#ascendingIconIDForStackedBarChart2').style("visibility", "visible")
                }
                else {
                    d3.select(this).select('svg').select('#descendingIconIDForStackedBarChart2').style("visibility", "visible")
                    d3.select(this).select('svg').select('#ascendingIconIDForStackedBarChart2').style("visibility", "visible")
                }
                }
                else{
                
                if(i == index){
                    d3.select(this).select('svg').select('#descendingIconIDForStackedBarChart2').style("visibility", "visible")
                    d3.select(this).select('svg').select('#ascendingIconIDForStackedBarChart2').style("visibility", "hidden")
                }
                else {
                    d3.select(this).select('svg').select('#descendingIconIDForStackedBarChart2').style("visibility", "visible")
                    d3.select(this).select('svg').select('#ascendingIconIDForStackedBarChart2').style("visibility", "visible")
                }
                }
            })
             
              var monthTruOrFalAryForStkBarChart2 = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
              
              tr.sort(function(a, b) {
                      
                      if (sortOrder) {
                      var monthsArrayForStkBarChart2 = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                      } else {
                      var monthsArrayForStkBarChart2 = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                      }
                      
                      monthTruOrFalAryForStkBarChart2 = []; gotMonthArray = [];
                      tableDataForStkBarChart2.forEach(function(d,i){
                           var da = d[k].toString().substring(0,3).toLowerCase()
                           if(monthsArrayForStkBarChart2.indexOf(da) >= 0){
                           monthTruOrFalAryForStkBarChart2.push(true)
                           gotMonthArray.push(da);
                           }
                           else {
                           monthTruOrFalAryForStkBarChart2.push(false)
                           }
                       })
                      
                      if(monthTruOrFalAryForStkBarChart2.indexOf(false) == -1){ // true
                      
                      monthArray = []; monthArrayCount = [];
                      gotMonthArray.forEach(function(dd,j){
                            var index1 = monthsArrayForStkBarChart2.indexOf(dd.substring(0,3))
                            if(monthArrayCount.indexOf(index1) >= 0){
                            index1 = 12 + index1;
                            }
                            monthArray.push(index1);
                            monthArrayCount.push(index1)
                      })
                      returnArray = []
                      monthArray.sort(function(aa, bb) {
                          returnArray.push(+aa - +bb)
                          return +aa - +bb;
                      })
                      
                      sortTableFunc()
                      return returnArray[ind++];
                      } //  if true (if jan feb if block)
                      else {
                      var data = +a[k];
                      
                      if(!isNaN(data)){
                      
                      if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                      else { return d3.descending(+a[k], +b[k]); }
                      }
                      else if(!isNaN(Date.parse(a[k]))){
                      
                      if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                      else { return new Date(b[k]) - new Date(a[k]) }
                      }
                      else {
                      
                      if (sortOrder) { return d3.ascending(a[k], b[k]); }
                      else { return d3.descending(a[k], b[k]); }
                      }
                      } // if not jan feb else block
                }); // tr
             
	})
    
    function sortTableFunc(){
        
        var table = tablePanelForStackedChart.select('table');
        var rows = table.selectAll('tr').data(tableDataForStkBarChart2);
        var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
        cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0).style("color","#00001c");
        
        cells.text(function(d,i) {return d});
        
        // Cells exit selection
        cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
        
        var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
        
        cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500)
        .style('opacity', 1.0).style("color","#00001c");
        
        cells_in_new_rows.text(function(d,i) {return d});
        
        rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
    }
    
    // Main Table Styling
    tablePanelForStackedChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
    .style("color","#00001c")
    .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4") //.style("box-shadow","10px 10px 50px #007aff").style("z-index",9999)
    tablePanelForStackedChart.selectAll('td').style("height","25px") .style("border", "1px solid #dddddd") .style("font-size","12px").style("font-weight","Normal").style("color","#00001c")
    
    //additionally
    tablePanelForStackedChart.selectAll('th').style('background-color',"#ffffff").style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
    tablePanelForStackedChart.selectAll('td').style('background-color',"#ffffff").style("border-style","none").style("color","#00001c")
    
    //b1da9f
    tablePanelForStackedChart.selectAll('table') . style("border-collapse","collapse")
    tablePanelForStackedChart.selectAll('table tr:first-child th').style("border-top","0px")
    tablePanelForStackedChart.selectAll('table tr:last-child td').style("border-bottom","0px")
    tablePanelForStackedChart.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
    tablePanelForStackedChart.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")
    
    if(showOrHideTableForStkBarChart2 == false){
        tablePanelForStackedChart.style("display","none")
    }
    else if(showOrHideTableForStkBarChart2 == true){
        tablePanelForStackedChart.style("display","block")
    }
    
    if(options.isDataDetailedForTable == false){
        
        var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
        
        // Adding underlines for selected drill-down column text
        var drillDownSectionsForStackedChart2 = tablePanelForStackedChart.select('table').selectAll('th')
        
        var foundResult = [];
        for(var i = 0; i<drillDownSectionsForStackedChart2[0].length; i++){
            
            for(var j = 0; j<drillDownColumnNamesArray.length; j++){
                if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForStackedChart2[0][i].__data__.toString().toLowerCase() ){
                    foundResult.push(i)
                }
            }
        }
        
        var r = tablePanelForStackedChart.select('table').selectAll('tr').selectAll('td')
        for(var i = 0; i<r.length; i++){
            for(var j = 0; j < foundResult.length; j++){
                var row = r[i][foundResult[j]]
                $(row).css("text-decoration", "underline")
            }
        }
    }
    
    //By default calling the resized function first time (to align table's th and td).
    setTimeout(function(){ resizedFuctionForStackedBarChart2() },1000)
    
    window.addEventListener('resize', function(event){ resizedFuctionForStackedBarChart2() });
    
    var xScale1GlobalVar; // storing the new yScale when parent div is resized.
    var yScale1GlobalVar; // storing the new yScale when parent div is resized.
    var newHeightVar; // storing the new height when parent div is resized.
    
    $(function() {
      $("#" + targetElement[0][0].id).resizable({
                resize: function(event, ui) {
                    //divWidthForHoriChart = ui.size.width;
                    //divHeightForHoriChart = ui.size.height;
                    resizedFuctionForStackedBarChart2();
                }
            });
      });
    
    function resizedFuctionForStackedBarChart2()
    {
        
        if((svgPanelForStackedBarChart2.node().getBoundingClientRect().width) && (svgPanelForStackedBarChart2.node().getBoundingClientRect().height) > 0){
            
            if(showOrHideCommentsBtnForStkBarChart2 == true){
                filterBtnForStackedBarChart2.style('margin-left', "2px")
                refreshBtnForStackedBarChart2.style('margin-left', "2px")
                commentsBtnForStkBarChart2.style('margin-left', "2px")
                menuBtnForStackedBarChart2.style('right', '0')
            }
            else if(showOrHideCommentsBtnForStkBarChart2 == false){
                filterBtnForStackedBarChart2.style('margin-left', "2px")
                refreshBtnForStackedBarChart2.style('margin-left', "2px")
                //commentsBtnForStkBarChart2.style('right', '0')
                commentsBtnForStkBarChart2.style('display','none')
                menuBtnForStackedBarChart2.style('right', '0')
            }
            
            optsBtnPanelForStkBarChart2.style('right', '0')
            
            stgPanCanBtnForStkBarChart2.style('right', '0')
            
            if(options.showTitle == true){
                
                var margin1 = {top: 10 , right: 20, bottom: 80, left: 20}, //originally top: 42, left: 80
                width1 = (svgPanelForStackedBarChart2.node().getBoundingClientRect().width) - margin.left - margin.right,
                height1 = (svgPanelForStackedBarChart2.node().getBoundingClientRect().height) - margin.top - margin.bottom;
                newHeightVar = height1
            }
            else if(options.showTitle == false){
                
                var margin1 = {top: 10 , right: 20, bottom: 80, left: 20}, //originally top: 42, left: 80
                width1 = (svgPanelForStackedBarChart2.node().getBoundingClientRect().width) - margin.left - margin.right,
                height1 = svgPanelForStackedBarChart2.node().getBoundingClientRect().height - margin.top - margin.bottom;
                newHeightVar = height1
            }
            
            var xMax1 =  d3.max(dataset, function (group) {
                                
                return d3.max(group, function (d) {
                              return (+d.x) + (+d.x0);
                              });
            })
            
            var xScale2 = d3.scale.ordinal() .domain(months) .rangeRoundBands([0, width1], .20)
            
            var yScale2 = d3.scale.linear() .domain([0, xMax1]) .range([0, height1])
            
            xScale1GlobalVar = xScale2;
            yScale1GlobalVar = yScale2;
            
            xAxis.scale(xScale2) .orient('bottom')
            
            var svg1 = svgPanelForStackedBarChart2;
            
            svg1.select("svg")
            //.attr("width", width1 + margin1.left + margin1.right)
            //.attr("height", height1 + margin1.top + margin1.bottom);
            
            svg1.select(".x.axis") .attr('transform', 'translate(0,' + height1 + ')') .call(xAxis)
            .selectAll("text") .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') .attr("transform", function(d) { 
                    if(numberGreaterThanLimit.length>0){return "rotate(-45)"}
                    else{
                    return "rotate(0)" }})
            .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
            .text(function(d,i) {
                if(d.length > 9)
                return d.substring(0,9)+'...';
                else
                return d;
            })
            
            xAxisVariable.attr("transform", "translate(" + ((width1/2) - 0) + " ," + (height1+margin1.bottom - 2) + ")")
            
            //rectsForStackedBarChart2 = groupsForStackedBarChart2.selectAll('rect')
            //svg1.selectAll(".bar")
            groupsForStackedBarChart2.selectAll('rect')
            .attr('x', function (d,i) { return xScale2(d.y); })
            .attr('y', function (d, i) { return height1 -yScale2(d.x0) - yScale2(d.x) })
            .attr("width", xScale2.rangeBand())
            .attr("height", function (d) { return yScale2(d.x); });
            
            textOnStackedBarChart2
            .attr("x", function(d,i) { return xScale2(d.y)+xScale2.rangeBand()/2; })
            .attr("y", function(d) { return (height1 -yScale2(d.x0) - yScale2(d.x))+(yScale2(d.x)/1.5);})
            
            // Aligning Legend (vertically)
            var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelStackedBarChart2[0][0].style.width) / 100)
            var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelStackedBarChart2[0][0].style.height) / 100)
            
            var legendRectSize = 11;
            var legendSpacing = 4;
            
            legend.attr('transform', function(d, i) {
                var eachRectHeight = legendRectSize + legendSpacing;
                var offset =  eachRectHeight * colours.domain().length / 2;
                var horz = 5;
                var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.data.length))/2.0; // originally 2.0
                
                return 'translate(' + horz + ',' + vert + ')';
            })
            
            
            d3.select(".theadClassForStkBarChart2" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                d.forEach(function(dd,j){
                    colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                })
            })
            tablePanelForStackedChart.select(".thead1ClassForStkBarChart2" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
            })
            
        }// checking svg panel width & height greater than zero function
        
    }
    }, // stackedBarChart2
    
    // ************************************************** Tree Map  **************************************************
    treeMap: function(targetElement, options){
        
        isChartCalled++;
        
        var chartName = "TREEMAP";
        
        acinfotech.allCharts(targetElement,options,chartName)
        
        targetElement.style("min-width", "350px").style("min-height", "350px").style("background-color", options.BGcolor)
        
        var showOrHideTableForTreeMap;
        var showOrHideCommentsForTreeMap;
        var showOrHideCommentsBtnForTreeMap = true;
        
        if((options.showTable == false) || (options.showTable == true)){
            showOrHideTableForTreeMap = options.showTable
        }
        else{
            showOrHideTableForTreeMap = false;
        }
        
        // Show or Hide comments
        if (options.showComments == true || false) {
            showOrHideCommentsForTreeMap = options.showComments;
        }
        else {
            showOrHideCommentsForTreeMap = false;
        }
        
        if (options.comments.length == 0){
            showOrHideCommentsForTreeMap = false;
            showOrHideCommentsBtnForTreeMap = false;
        }
        
        if ((showOrHideTableForTreeMap == true) && (showOrHideCommentsForTreeMap == true)){
            showOrHideTableForTreeMap = true;
            showOrHideCommentsForTreeMap = false;
        }
        else if ((showOrHideTableForTreeMap == false) && (showOrHideCommentsForTreeMap == false)){
            showOrHideTableForTreeMap = false;
            showOrHideCommentsForTreeMap = false;
        }
        
        var chartTitlePanelForTreeMap =  targetElement.append("div") .style("background-color","#ffffff") .style("position","absolute").style('background-color',"#ffffff")
        .style("text-indent","6px")
        
		var optsBtnPanelForTreeMap = targetElement.append('div').style('width',"25px").style('height',180 + "px").style('position','absolute')
        .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px").style('right', '0')
        .style("min-width","25px").style("border-style","none").style("border-left", "solid #fcfcfc  1px")
		
        var bubbleButtonForTreeMap = optsBtnPanelForTreeMap.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','80px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var bubbleBtnImgVar = document.createElement("IMG");
        bubbleBtnImgVar.src = "images/bubbleIcon.png";
        bubbleBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.9;")
        bubbleButtonForTreeMap[0][0].appendChild(bubbleBtnImgVar)
        
        var filterBtnForTreeMap = optsBtnPanelForTreeMap.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','105px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var filterBtnImgVar = document.createElement("IMG");
        filterBtnImgVar.src = "images/filterIcon.png";
        filterBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        filterBtnForTreeMap[0][0].appendChild(filterBtnImgVar)
        
        var refreshBtnForTreeMap = optsBtnPanelForTreeMap.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','130px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var refreshBtnImgVar = document.createElement("IMG");
        refreshBtnImgVar.src = "images/refreshIcon.png";
        refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        refreshBtnForTreeMap[0][0].appendChild(refreshBtnImgVar)
        
        var commentsBtnForTreeMap = optsBtnPanelForTreeMap.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','155px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var commentsBtnImgVariable = document.createElement("IMG");
        if(options.showComments == false){
            commentsBtnImgVariable.src = "images/showCommentsIcon.png";
        }
        else if(options.showComments == true){
            commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
        }
        commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:15px; height:15px; opacity:0.8;")
        commentsBtnForTreeMap[0][0].appendChild(commentsBtnImgVariable)
        
        var menuBtnForTreeMap = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','1px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var menuBtnImgVar = document.createElement("IMG");
        menuBtnImgVar.src = "images/menuIcon.png";
        menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
        menuBtnForTreeMap[0][0].appendChild(menuBtnImgVar)
        
        if(showOrHideCommentsBtnForTreeMap == true){
            bubbleButtonForTreeMap.style('margin-left', "2px")
            filterBtnForTreeMap.style('margin-left', "2px")
            refreshBtnForTreeMap.style('margin-left', "2px")
            commentsBtnForTreeMap.style('margin-left', "2px")
            menuBtnForTreeMap.style('right', '0')
        }
        else if(showOrHideCommentsBtnForTreeMap == false){
            bubbleButtonForTreeMap.style('margin-left', "2px")
            filterBtnForTreeMap.style('margin-left', "2px")
            refreshBtnForTreeMap.style('margin-left', "2px")
            //commentsBtnForTreeMap.style('right', '0')
            commentsBtnForTreeMap.style('display','none')
            menuBtnForTreeMap.style('right', '0')
        }
        
        var ismenuBtnOfTreeMapClicked = false;
        menuBtnForTreeMap.on('click', function() {
                                 
             //filterPanelForTreeMap.style("display","none");
             
             stgPanDivForTreeMap.style("display","none") // Hiding setting panel
             
             if ((showOrHideTableForTreeMap == false) && (showOrHideCommentsForTreeMap == true)){
             divLegendPanelForTreeMap.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
             .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
             
             divPanelForTreeMap.style('width', 65 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
             .style("position","absolute");
             }
             else if ((showOrHideTableForTreeMap == true) && (showOrHideCommentsForTreeMap == false)){
             divLegendPanelForTreeMap.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
             .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
             
             divPanelForTreeMap.style('width', 65 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
             .style("position","absolute");
             }
             else if ((showOrHideTableForTreeMap == false) && (showOrHideCommentsForTreeMap == false)){
             divLegendPanelForTreeMap.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
             .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
             
             divPanelForTreeMap.style('width', 65 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
             .style("position","absolute");
             }
             
             
             if(ismenuBtnOfTreeMapClicked == false){
             ismenuBtnOfTreeMapClicked = true;
             optsBtnPanelForTreeMap.style("display","block")
             
             }
             else if(ismenuBtnOfTreeMapClicked == true){
             ismenuBtnOfTreeMapClicked = false
             optsBtnPanelForTreeMap.style("display","none")
             }
             
             resizedFunctionForTreeMap();
        })
        
        var tableButtonForTreeMap = optsBtnPanelForTreeMap.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top','1px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
        var tableBtnImgVar = document.createElement("IMG");
        if(showOrHideTableForTreeMap == false){
            tableBtnImgVar.src = "images/showTableIcon.png";
            tableButtonForTreeMap.attr("class","showTableClassForChartTable")
        }
        else if(showOrHideTableForTreeMap == true){
            tableBtnImgVar.src = "images/cancelTableIcon.png";
            tableButtonForTreeMap.attr("class","hideTableClassForChartTable")
        }
        tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
        tableButtonForTreeMap[0][0].appendChild(tableBtnImgVar)
        
        var settingBtnForTreeMap = optsBtnPanelForTreeMap.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 28 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        var settingBtnImgVar = document.createElement("IMG");
        settingBtnImgVar.src = "images/settingsIcon.png";
        settingBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.82;")
        settingBtnForTreeMap[0][0].appendChild(settingBtnImgVar)
        
        var downloadBtnForTreeMap = optsBtnPanelForTreeMap.append("div").attr("id","downloadBtnForTreeMap-ID-" + targetElement[0][0].id).style("width","20px").style("height","20px")
        .style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff").style('margin-left','2px').style('top', 54 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        
        acinfotech.downloadFunctionality("downloadBtnForTreeMap-ID-" + targetElement[0][0].id,targetElement)
        
        var divPanelForTreeMap = targetElement .append('div')
        .attr("id","divPanelIDForTreeMap" + targetElement[0][0].id) .style('background-color',"#ffffff") .style("position","absolute")
        .style("border","0px solid #d0d0d0")
        
        var commentsPanelDivForTreeMap = targetElement.append("div") .attr("class","commentsPanelClassForTreeMap")
        .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
		.style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
        .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)
        
        commentsPanelDivForTreeMap.on('click',function(d){
            $('.commentsClassForTreeMap' + targetElement[0][0].id).focus()
		})
        
        if(options.showTitle == true){
            
            chartTitlePanelForTreeMap.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 8 + "%"; })
            .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')
            
            if ((showOrHideTableForTreeMap == false) && (showOrHideCommentsForTreeMap == true)){
                
                var commentsForTreeMap = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                .css('line-height','1.1em').css('text-align','justify') .attr('class','commentsClassForTreeMap' + targetElement[0][0].id)
                
                divPanelForTreeMap.style('width', 65 + "%") .style('height', 70 + "%") .style("top",8 + "%")
                commentsPanelDivForTreeMap.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                .style("top",78 + "%")
                .html(commentsForTreeMap[0].outerHTML.toString())
                
            }
            else if ((showOrHideTableForTreeMap == true) && (showOrHideCommentsForTreeMap == false)){
                
                divPanelForTreeMap.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8 + "%")
                commentsPanelDivForTreeMap.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForTreeMap == false) && (showOrHideCommentsForTreeMap == false)){
                divPanelForTreeMap.style('width', 65 + "%") .style('height', 85 + "%") .style("top",8 + "%")
                commentsPanelDivForTreeMap.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            
            var margin = {top: 0, right: 0, bottom: 0, left: 0},
            width = (divPanelForTreeMap.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = (divPanelForTreeMap.node().getBoundingClientRect().height) - margin.top - margin.bottom;
            
        }
        else if(options.showTitle == false){
            chartTitlePanelForTreeMap.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });
            
            if ((showOrHideTableForTreeMap == false) && (showOrHideCommentsForTreeMap == true)){
                
                var commentsForTreeMap = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                .css('line-height','1.1em').css('text-align','justify')
                
                divPanelForTreeMap.style('width', 65 + "%") .style('height', 70 + "%") .style("top",8 + "%")
                commentsPanelDivForTreeMap.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                .style("top",78 + "%")
                .html(commentsForTreeMap[0].outerHTML.toString())
                
            }
            else if ((showOrHideTableForTreeMap == true) && (showOrHideCommentsForTreeMap == false)){
                
                divPanelForTreeMap.style('width', 65 + "%") .style('height', 52 + "%") .style("top",8 + "%")
                commentsPanelDivForTreeMap.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForTreeMap == false) && (showOrHideCommentsForTreeMap == false)){
                divPanelForTreeMap.style('width', 65 + "%") .style('height', 85 + "%") .style("top",8 + "%")
                commentsPanelDivForTreeMap.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            
            var margin = {top: 0, right: 0, bottom: 0, left: 0},
            width = (divPanelForTreeMap.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = divPanelForTreeMap.node().getBoundingClientRect().height - margin.top - margin.bottom;
        }
        
        var divLegendPanelForTreeMap = targetElement .append('div')  .attr("class","divLegendPanelClassForTreeMap") .style('background-color',"#ffffff") .style('position',"absolute")
        .style('width', 30 + "%") .style('height', 92 + "%") .style("left",70 + "%").style("top",8 + "%")
        
        if ((showOrHideTableForTreeMap == false) && (showOrHideCommentsForTreeMap == true)){
            
            divLegendPanelForTreeMap.style('width', 35 + "%") .style('height', 70 + "%") .style("left",65 + "%").style("top",8 + "%")
        }
        else if ((showOrHideTableForTreeMap == true) && (showOrHideCommentsForTreeMap == false)){
            
            divLegendPanelForTreeMap.style('width', 35 + "%") .style('height', 52 + "%") .style("left",65 + "%").style("top",8 + "%")
        }
        else if ((showOrHideTableForTreeMap == false) && (showOrHideCommentsForTreeMap == false)){
            
            divLegendPanelForTreeMap.style('width', 35 + "%") .style('height', 85 + "%") .style("left",65 + "%").style("top",8 + "%")
        }
        
        var colours;
        
        // checking color set for bubbles and legend dots
        if(options.colorSet === undefined){
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "one"){
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            options.colorSet = "two"
            colours = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            options.colorSet = "three"
            colours = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        }
        else
        {
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        
        //------------------ Settings panel DIV and everything within it section begins here ------------------
        
        var stgPanDivForTreeMap = targetElement.append('div').style('width',"100%").style('height',"40%").attr("class","stgPanDivForTreeMap" + targetElement[0][0].id)
        .style('position','absolute').style('margin-left', "0px").style('border-top',"1px solid #f0f0f0").style('border-bottom',"1px solid #e5e5e5")
        .style("background-color",'#fcfcfc').style("z-index",90) .style("display","none") .style('top', 60.0 + "%") .style('height',40 + "%")
        
        $( '.stgPanDivForTreeMap' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
             var e0 = e.originalEvent,
             delta = e0.wheelDelta || -e0.detail;
             
             this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
             e.preventDefault();
         });
        
        var settingPanelTitle = stgPanDivForTreeMap.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','10px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; color:#00001c;">'+ "Settings" +'</div>')
        
        var stgPanDivForStkChangeColorTitle = stgPanDivForTreeMap.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Select color set " +'</div>')
        
        var stgPanCanBtnForTreeMap = stgPanDivForTreeMap.append("div") .style("width","18px").style("height","17px").style('position','absolute')
        .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white')
        .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.9; background-color:#fcfcff")
        stgPanCanBtnForTreeMap[0][0].appendChild(cancelBtnImgVar)
        
        stgPanCanBtnForTreeMap.on('click', function() {
              stgPanDivForTreeMap.style("display","none") // Hiding setting panel
              
              if ((showOrHideTableForTreeMap == false) && (showOrHideCommentsForTreeMap == true)){
              divLegendPanelForTreeMap.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
              .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
              
              divPanelForTreeMap.style('width', 65 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
              .style("position","absolute");
              }
              else if ((showOrHideTableForTreeMap == true) && (showOrHideCommentsForTreeMap == false)){
              divLegendPanelForTreeMap.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
              .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
              
              divPanelForTreeMap.style('width', 65 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
              .style("position","absolute");
              }
              else if ((showOrHideTableForTreeMap == false) && (showOrHideCommentsForTreeMap == false)){
              divLegendPanelForTreeMap.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
              .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
              
              divPanelForTreeMap.style('width', 65 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
              .style("position","absolute");
              }
              
              resizedFunctionForTreeMap();
          })
        
        var formForChangeSettingsPanel = stgPanDivForTreeMap.append("form");
        formForChangeSettingsPanel.style("background-color","#fcfcfc").style("margin-top","67px").style("font-family","Verdana,sans-serif").style("font-size","12px")
        .style("position","absolute").attr("id","formForChangeColorSettingsPanel" + targetElement[0][0].id).style("font-weight","Bold").style("width","180px")
        .style("height","58px").style("padding","0px").style("border-radius","0px") .style("margin-left","10px")
        
        var svgPanelForCrSetOne = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px").style("height","18px").style("margin-top","1px").style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetOne = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        var colorSetOneRange = d3.range(12);
        
        var colorSetOneDots = svgPanelForCrSetOne.append("g")
        colorSetOneDots.selectAll('rect') .data(colorSetOneRange) .enter() .append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("fill", function(d,i){return colorSetOne(i)})
        .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetOne(i); })
        .style("cursor","auto") .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
        
        var svgPanelForCrSetTwo = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px") .style("margin-top","20px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetTwo = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        var colorSetTwoRange = d3.range(12);
        
        var colorSetTwoDots = svgPanelForCrSetTwo.append("g")
        colorSetTwoDots.selectAll('rect') .data(colorSetTwoRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto")
        .style("fill", function(d,i){return colorSetTwo(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
        .style("stroke",function(d,i){  return colorSetTwo(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
        
        var svgPanelForCrSetThree = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px") .style("margin-top","39px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetThree = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        var colorSetThreeRange = d3.range(12);
        
        var colorSetThreeDots = svgPanelForCrSetThree.append("g")
        colorSetThreeDots.selectAll('rect') .data(colorSetThreeRange) .enter().append('rect')
        .attr('transform', 'translate(' + (2) + ',' + (1) + ')') .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10)
        .attr("height",10) .style("cursor","auto") .style("fill", function(d,i){return colorSetThree(i)}) .style("fill-opacity",0.93)
        .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetThree(i);  })
        .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
        
        if(options.colorSet.toString().toLowerCase() === "one"){
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"1px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"1px solid #808080")
        }
        else
        {
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        
        svgPanelForCrSetOne.on('click',function(d,i){
               options.colorSet = "one"
               svgPanelForCrSetOne.style('border',"1px solid #808080")
               svgPanelForCrSetTwo.style('border',"0px solid #808080")
               svgPanelForCrSetThree.style('border',"0px solid #808080")
               
               colours = "";
               colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
               
               legendGroup.style("fill", function(d, i){ return colours(d.key);})
               divPanelForTreeMap.selectAll(".node").style("background-color", function(d,i) { if(i == 0){ return "#ffffff"} else { return d.children ? colours(d.name) : null; } })
               
        })
        svgPanelForCrSetTwo.on('click',function(d){
               options.colorSet = "two"
               svgPanelForCrSetOne.style('border',"0px solid #808080")
               svgPanelForCrSetTwo.style('border',"1px solid #808080")
               svgPanelForCrSetThree.style('border',"0px solid #808080")
               
               colours = "";
               colours = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
               
               legendGroup.style("fill", function(d, i){ return colours(d.key);})
               divPanelForTreeMap.selectAll(".node").style("background-color", function(d,i) { if(i == 0){ return "#ffffff"} else { return d.children ? colours(d.name) : null; } })
               
       })
        svgPanelForCrSetThree.on('click',function(d){
                 options.colorSet = "three"
                 svgPanelForCrSetOne.style('border',"0px solid #808080")
                 svgPanelForCrSetTwo.style('border',"0px solid #808080")
                 svgPanelForCrSetThree.style('border',"1px solid #808080")
                 
                 colours = "";
                 colours = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
                 
                 legendGroup.style("fill", function(d, i){ return colours(d.key);})
                 divPanelForTreeMap.selectAll(".node").style("background-color", function(d,i) { if(i == 0){ return "#ffffff"} else { return d.children ? colours(d.name) : null; } })
                 
         })
        
        
        //------------------ Settings panel DIV and everything inside it section ends here ------------------
        
        bubbleButtonForTreeMap.on('click', function() {
                                   
           d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
          
           var newOptions = {
           data: options.data,
           dataForTable: options.dataForTable,
           isDataDetailedForTable: options.isDataDetailedForTable,
           keys: {
            label: options.keys.label,
            value: options.keys.value,
            legendItems: options.keys.legendItems
           },
           chartTitle: options.chartTitle,
           showTitle: options.showTitle,
           colorSet: options.colorSet,
           drillDownColumnName:options.drillDownColumnName,
           showTable: false,
           showComments: options.showComments,
           comments: options.comments,
           resizeButtonID: options.resizeButtonID
           }
           acinfotech.bubbleChart2(targetElement, newOptions)
                                  
       })
        
        filterBtnForTreeMap.on('click', function() {
                                        
            filterPanelForTreeMap.style("display","block");
            
            ismenuBtnOfTreeMapClicked = false;
            optsBtnPanelForTreeMap.style("display","none");
            
            stgPanDivForTreeMap.style("display","none");
            
            if ((showOrHideTableForTreeMap == false) && (showOrHideCommentsForTreeMap == true)){
            divLegendPanelForTreeMap.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
            .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
   
            divPanelForTreeMap.style('width', 65 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
            .style("position","absolute");
            }
            else if ((showOrHideTableForTreeMap == true) && (showOrHideCommentsForTreeMap == false)){
            divLegendPanelForTreeMap.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
            .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
            
            divPanelForTreeMap.style('width', 65 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute");
            }
            else if ((showOrHideTableForTreeMap == false) && (showOrHideCommentsForTreeMap == false)){
            divLegendPanelForTreeMap.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
            .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
            
            divPanelForTreeMap.style('width', 65 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute");
            }
            
            resizedFunctionForTreeMap();
                               
        })
        
        // Refreshing Chart and Table
        refreshBtnForTreeMap.on('click', function() {
                
                //isFilterClicked = false
                d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                
                for(var i = 0; i<divAndChartsArray.length; i++){
                
                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                options.data = divAndChartsArray[i].optionsData
                }
                }
                acinfotech.treeMap(targetElement,options)
        })

        commentsBtnForTreeMap.on('click', function() {
                 
                 if(options.showComments == false){ 
                 options.showComments = true;
                 }
                 else if(options.showComments == true){ 
                 options.showComments = false;
                 }
                 
                 //isFilterClicked = false
                 d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                 
                 for(var i = 0; i<divAndChartsArray.length; i++){
                 
                 if(targetElement[0][0].id === divAndChartsArray[i].divID){
                 options.data = divAndChartsArray[i].optionsData
                 options.showTable = false;
                 }
                 }
                 acinfotech.treeMap(targetElement,options)
         })

        // showing/hidding chart table
        tableButtonForTreeMap.on('click', function() {
                 
                 if(showOrHideTableForTreeMap == false){
                 options.showTable = true;
                 }
                 else if(showOrHideTableForTreeMap == true){
                 options.showTable = false;
                 }
                 
                 d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                 
                 for(var i = 0; i<divAndChartsArray.length; i++){
                 
                 if(targetElement[0][0].id === divAndChartsArray[i].divID){
                 options.data = divAndChartsArray[i].optionsData
                 options.showComments = false;
                 }
                 }
                 acinfotech.treeMap(targetElement,options)
         })


        settingBtnForTreeMap.on('click', function() {
                
                ismenuBtnOfTreeMapClicked = false; // Menu toggle button variable
                optsBtnPanelForTreeMap.style("display","none") // To hide options button panel
                
                iconButtonTooltipForTreeMap.style("display","none") // Removing options button ToolTip
                settingBtnForTreeMap.style("cursor","pointer")
                
                stgPanDivForTreeMap.style("display","block") // Showing settings panel
                
                divPanelForTreeMap.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute"); // Decreasing chart panel
                divLegendPanelForTreeMap.style('width', 35 + "%") .style('height', 52 + "%").style("position","absolute"); // Decreasing chart panel
                
                resizedFunctionForTreeMap(); // Calling resize function()
                
        })
        
        downloadBtnForTreeMap.on('click', function() {
                                  
              ismenuBtnOfTreeMapClicked = false; // Changing menu button value to false
              optsBtnPanelForTreeMap.style("display","none") // Hiding option buttons panel
                  
        })
        
        // Creating ToolTip for options button.
        var iconButtonTooltipForTreeMap = targetElement.append('div').style('width','240px').attr("id","too") .style('height',"25px")
        .style('position','absolute') .style("background-color",'#404040 ') .style("z-index",999).style("border", "0.0px")
        .style("border-color", "#278eff") .style("border-style", "solid") .style("border-radius","0px") .style("box-shadow", "1px 1px 2px #d8d8d8")
        .style("display","none").attr("border", 0.0)
            
        bubbleButtonForTreeMap.on('mousemove', function(d,i) {
            var root = targetElement
            var m = d3.mouse(root.node());
            m[0] += 0
            m[1] += 0
            var bubbleButtonTooltipText = "Switch to Bubble Chart";
            
            iconButtonTooltipForTreeMap.style("width","142px").style("margin-left", (m[0] - 152) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForTreeMap.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ bubbleButtonTooltipText +'</div>')
            
        })
        bubbleButtonForTreeMap.on('mouseout', function(d,i) {
            iconButtonTooltipForTreeMap.style("display","none")
        })

        refreshBtnForTreeMap.on('mousemove', function(d,i) {
                var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                var refreshChartButtonTooltipText = "Refresh";
                
                iconButtonTooltipForTreeMap.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
                iconButtonTooltipForTreeMap.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ refreshChartButtonTooltipText +'</div>')
                
        })
        refreshBtnForTreeMap.on('mouseout', function(d,i) {
                iconButtonTooltipForTreeMap.style("display","none")
        })

        commentsBtnForTreeMap.on('mousemove', function(d,i) {
                 commentsPanelDivForTreeMap.style('background-color','#fafafa')
                 var root = targetElement
                 var m = d3.mouse(root.node());
                 m[0] += 0
                 m[1] += 0
                 if(options.showComments == false){
                 var commentButtonTooltipText = "Show Comments";
                 }
                 else if(options.showComments == true){
                 var commentButtonTooltipText = "Hide Comments";
                 }
                 
                 iconButtonTooltipForTreeMap.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
                 iconButtonTooltipForTreeMap.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ commentButtonTooltipText +'</div>')
         })
        commentsBtnForTreeMap.on('mouseout', function(d,i) {
                 commentsPanelDivForTreeMap.style('background-color','#ffffff')
                 iconButtonTooltipForTreeMap.style("display","none")
         })

        menuBtnForTreeMap.on('mousemove', function(d,i) {
             var root = targetElement
             var m = d3.mouse(root.node());
             m[0] += 0
             m[1] += 0
             var menuButtonTooltipText = "Menu";
             
             iconButtonTooltipForTreeMap.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
             iconButtonTooltipForTreeMap.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ menuButtonTooltipText +'</div>')
         })
        menuBtnForTreeMap.on('mouseout', function(d,i) {
             iconButtonTooltipForTreeMap.style("display","none")
         })

        tableButtonForTreeMap.on('mousemove', function(d,i) {
                 var root = targetElement
                 var m = d3.mouse(root.node());
                 m[0] += 0
                 m[1] += 0
                 if(showOrHideTableForTreeMap == false){
                 var tableButtonTooltipText = "Show Table";
                 }
                 else if(showOrHideTableForTreeMap == true){
                 var tableButtonTooltipText = "Hide Table";
                 }
                 
                 iconButtonTooltipForTreeMap.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
                 iconButtonTooltipForTreeMap.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ tableButtonTooltipText +'</div>')
         })
        tableButtonForTreeMap.on('mouseout', function(d,i) {
                 iconButtonTooltipForTreeMap.style("display","none")
         })

        settingBtnForTreeMap.on('mousemove', function(d,i) {
                var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                var reloadButtonTooltipText = "Settings";
                
                iconButtonTooltipForTreeMap.style("width","67px").style("margin-left", (m[0] - 77) + "px").style("margin-top",(m[1]) + "px").style("display","block")
                iconButtonTooltipForTreeMap.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ reloadButtonTooltipText +'</div>')
        })
        settingBtnForTreeMap.on('mouseout', function(d,i) {
                iconButtonTooltipForTreeMap.style("display","none")
        })
        
        downloadBtnForTreeMap.on('mousemove', function(d,i) {
              var root = targetElement
              var m = d3.mouse(root.node());
              m[0] += 0
              m[1] += 0
              var downloadButtonTooltipText = "Download";
              
              iconButtonTooltipForTreeMap.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
              iconButtonTooltipForTreeMap.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
        })
        downloadBtnForTreeMap.on('mouseout', function(d,i) {
              iconButtonTooltipForTreeMap.style("display","none")
        })

        
        // ----------------- Filter panel and everything within it section begins here ----------------
        var filterPanelForTreeMap = targetElement.append('div') .style('width',350 + "px") .attr("class","filterPanelForTreeMapClass" + targetElement[0][0].id)
        .style('position','absolute') .style('margin-left', "0px") .style("background-color",'#fefefe') .style("z-index",11)
        .style("border-color", "#ffffff").style("border-right", "solid #e5e5e5 1px")  .style("border-style", "solid") .style("box-shadow", "2px 0px 1px #eff8ec")
        .style("display","none").style("border-top", "solid #fdfdfd 1px").style("border-left","0px").style("border-bottom", "0px")
        .style('top', 0.0 + "%").style('height', 100 + "%").style('overflow-y',"hidden").style("overflow-x","hidden")
        .style("border-bottom", "solid #e5e5e5 1px") .style("box-sizing","border-box")
        
        var filterPanelForStkBarChartTitle = filterPanelForTreeMap.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','20px').style('text-indent','5px').style("font-size", "14px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #007aff").style("width","350px").style("color","#000000")
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; top:25.0%; font-size:14px; font-family:inter; color:#00001c;">'+ "Filter" +'</div>')
        
        var measuresColumnTitle = filterPanelForTreeMap.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; text-indent:3px;">Available Measures</div>');
        
        var measuresVariables = filterPanelForTreeMap.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable1"+targetElement[0][0].id)
        .style("list-style-type","none")
        .style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '78px')
        .style('position','absolute')
        .style("width","155px").style("min-height","190px").style("max-height","190px").style("border", "#f0f0f0 1px solid")
        .style("max-width","155px").style("overflow-x","hidden").style("overflow-y","auto")
        measuresVariables.style("left",0.0 + "px").style("padding","2px")
        
        $( ".filterPanelForTreeMapClass" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
              var e0 = e.originalEvent,
              delta = e0.wheelDelta || -e0.detail;
              
              this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
              e.preventDefault();
        });
        
        
        var measuresArray = [];
        var dimensionArray = [];
        
        var measuresArrayLength = [];
        var dimensionsArrayLength = [];
        
        dimensionArray.push(options.keys.label);
        
        for(var i = 0; i<divAndChartsArray.length; i++){
            if(targetElement[0][0].id === divAndChartsArray[i].divID){
                
                var legendItemsArray = []
                newtargetElementAndOptionsArray[i].options.data.forEach(function(d,i){ legendItemsArray.push(d[options.keys.legendItems]) })
                
                var uniqueLegendItemsArray = [];
                $.each(legendItemsArray, function(i, el){ if($.inArray(el, uniqueLegendItemsArray) === -1) uniqueLegendItemsArray.push(el); });
                
            }
        }
        
        // filter process
        var uniqueMeasuresArrayKeys = uniqueLegendItemsArray
        
        // setting lenght for arrays
        for(var i = 0; i<uniqueMeasuresArrayKeys.length; i++){
            measuresArrayLength.push(i);
        }
        
        var measuresVariables1 = measuresVariables.selectAll("li") .data(measuresArrayLength).enter().append("li")
        .style("width","130px") .style("max-height","22px").style("cursor","move")
        .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#bcf1bc").style("font-weight","Normal")
        .style("list-style-type","none").style("border","1px #89e789 solid").style("color","#006600").style("font-family","Verdana,sans-serif")
        .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
        .text(function(d) {return uniqueMeasuresArrayKeys[d]})
        measuresVariables1.attr("class","MeasuresClass"+targetElement[0][0].id)
        
        var measuresColumnReceivedUI_TableTitle = filterPanelForTreeMap.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','180px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; ">Selected Measures</div>');
        
        var measuresColumnReceivedUI_Table = filterPanelForTreeMap.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable3"+targetElement[0][0].id)
        .style('background-color',"#ffffff").style('margin-left','180px').style('margin-top', '78px')
        .style("width","155px").style('position','absolute').style("padding","2px").style("min-height","190px")
        .style("border","1px #c1c1c1 dashed") .style("max-height","190px") .style("overflow-x","hidden") .style("overflow-y","auto")
        //.html('<div class=unsortable  style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:65.0%; font-size:14px; font-family:inter;  color:#99ea99; font-weight:Normal; text-align:center;">Drag and Drop Measures here from Available Measures List. </div>');
        .html('<img class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' src="images/dragIcon.png" style=" width:36px; height:36px; position:absolute; margin-left:65px; margin-top:60px; opacity:0.6"/>'
              + '<div class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:60.0%; font-size:12px; font-family:inter;  color:#89d289; font-weight:Normal; text-align:center;">Drop Measures here. </div>');
        //.html('<div style="background-image: url(images/dragIcon.png); height: 64px; width: 64px; border: 1px solid black;"> </div>');
        
        var cancelButton = filterPanelForTreeMap.append("div") .style("width","23px").style("height","21px").style('position','absolute')
        .style('margin-left','320px').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white')
        .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.9; background-color:#fcfcff")
        cancelButton[0][0].appendChild(cancelBtnImgVar)
        
        cancelButton.on("click", function(){
            filterPanelForTreeMap.style("display","none")
            
            if ((showOrHideTableForTreeMap == false) && (showOrHideCommentsForTreeMap == true)){
                divLegendPanelForTreeMap.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
                
                divPanelForTreeMap.style('width', 65 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute");
            }
            else if ((showOrHideTableForTreeMap == true) && (showOrHideCommentsForTreeMap == false)){
                divLegendPanelForTreeMap.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
                
                divPanelForTreeMap.style('width', 65 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute");
            }
            else if ((showOrHideTableForTreeMap == false) && (showOrHideCommentsForTreeMap == false)){
                divLegendPanelForTreeMap.style("width", function(d) { return 35.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",65 + "%") .style("top",8.0  + "%");
                
                divPanelForTreeMap.style('width', 65 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute");
            }
        })
        
        var reRenderChartAndTableButton = filterPanelForTreeMap.append("button").style("width","120px").style("height","25px").style('position','absolute')
        .style('margin-left','112px').style('margin-top','298px') .style("border-style", "none").style('background-color',"#2196f3")
        .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','15px').style("border-style", "solid").style('color','#ffffff')
        .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 1px #9b9b9b").style("border-radius","0px")
        var textForReRenderButton = document.createTextNode("Apply Changes");
        reRenderChartAndTableButton[0][0].appendChild(textForReRenderButton)
        
        reRenderChartAndTableButton.on("click", function(){
                                   
           if( $("#sortable3"+targetElement[0][0].id).children("li").length == 0 )
           {
               
               var alertPageDisabledDivForTreeMap =targetElement.append('div').style('width',100 + '%')
               .style('height',100 + "%").style('position','absolute').style('margin-left', '0px').style('top', '0px')
               .style("background-color",'#f3f3f3').style("z-index",99)//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
               .style("opacity",0.2).style("display","block")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
               
               var alertDivForTreeMap = targetElement.append('div').style('width','350px')
               .style('height',"150px").style('position','absolute').style('left', ((targetElement[0][0].clientWidth/2) - 175) + "px").style('top', '1px')
               .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "solid").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
               .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","0px")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
               //.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Bold;">Sorry, no result found for selected' + 'range!'+ '</br>' + '<label style=text-indent:10px;> Hello</label' +'</div>')
               .html('<p  style="width: 340px; height:0%; background-color:#c7c7c7; position: absolute; top:40.0%; font-size:14px; font-family:inter; font-weight:Bold; margin-left:10px;  color:#f8f8f8; font-weight:Normal;">Check whether the Selected Measures box is not empty!</p>')
               
               var alertDivTitleForTreeMap = alertDivForTreeMap.append('div').style('width','340px')
               .style('height',"30px").style('position','absolute').style('margin-left', "0px").style('top', '0px')
               .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "none").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
               .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","2px")
               .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; font-weight:Bold; text-indent:5px;  color:#e5e5e5; font-weight:Normal;">TimeBound</div>')
               
               var treeMapAlertOKButton = alertDivForTreeMap.append("button") .style("width","40px") .style("height","20px") .style('position','absolute') .style("box-shadow", "0px 1px 1px #B8B8B8")
               .style('background-color',"#7cc15e") .style('margin-left','300px') .style('top', "120px").style("color","#ffffff")
               .style("display","block").style('padding-top',"0px").style("cursor","pointer").style("box-shadow", "1px 1px 1px #56973a") .style("border-style", "none")
               .style("font-family","Verdana,sans-serif").style("font-size","14px").style("text-align","center").style("vertical-align","middle").style("border-radius","0px")
               .style("z-index",999)
               
               var textForTreeMapAlertOKButton = document.createTextNode("OK");
               treeMapAlertOKButton[0][0].appendChild(textForTreeMapAlertOKButton)
               
               $("#"+targetElement[0][0].id).resizable('disable');
               
               treeMapAlertOKButton.on('click', function() {
                     alertDivForTreeMap.remove();
                     alertPageDisabledDivForTreeMap.remove()
                     $("#"+targetElement[0][0].id).resizable('enable');
                 })
               
               filterBtnForTreeMap.style("cursor","pointer")
               
               if(showOrHideTableForTreeMap == false){
               divPanelForTreeMap.style('width', 65 + "%") .style('height', 85 + "%").style("position","absolute")
               divLegendPanelForTreeMap.style('width', 35 + "%") .style('height', 85 + "%").style("position","absolute")
               }
               else if(showOrHideTableForTreeMap == true){
               divPanelForTreeMap.style('width', 65 + "%") .style('height', 52 + "%").style("position","absolute")
               divLegendPanelForTreeMap.style('width', 35 + "%") .style('height', 52 + "%").style("position","absolute")
               }
               
               resizedFunctionForTreeMap();
           }
           
           else {
           
               for(var i = 0; i<divAndChartsArray.length; i++){
                   if(targetElement[0][0].id === divAndChartsArray[i].divID){
                   
                       var selectedTreeMeasures = [];
                       var newFilteredDataSetForTreeMap = [];
                       for(var j=0; j<$("#sortable3"+targetElement[0][0].id).children("li").length;j++){
                           selectedTreeMeasures.push($("#sortable3"+targetElement[0][0].id).children("li")[j].textContent)
                           
                           newtargetElementAndOptionsArray[i].options.data.forEach(function(d, index) {
                               if(d[options.keys.legendItems].toString().toLowerCase() === $("#sortable3"+targetElement[0][0].id).children("li")[j].textContent.toString().toLowerCase()){
                                   newFilteredDataSetForTreeMap.push(d)
                           }
                                                                               })
                       } // for(var j=0; j<$("#sortable3"+targetElement[0][0].id).children("li").length;j++)
                   } // if conditions
               } // for(var i = 0; i<divAndChartsArray.length; i++)
               
               var newOptions = {
                   data: newFilteredDataSetForTreeMap,
                   dataForTable: options.dataForTable,
                   isDataDetailedForTable: options.isDataDetailedForTable,
                   keys: {
                       label: options.keys.label,
                       value: options.keys.value,
                       legendItems: options.keys.legendItems
                   },
                   chartTitle:options.chartTitle,
                   showTitle: true,
                   colorSet: options.colorSet,
                   drillDownColumnName:options.drillDownColumnName,
                   showTable: options.showTable,
                   showComments: options.showComments,
                   comments: options.comments,
                   resizeButtonID: options.resizeButtonID //document.getElementById("resizeBtn").id
               }
               
               d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
               acinfotech.treeMap(targetElement,newOptions)
           }
		})
        
        var textBoxForMeasureColumnFrom;
        var textBoxForMeasureColumnTo;
        var selectTitleDivForEachDimension;
        
        $( "ul.droptrue"+targetElement[0][0].id ).sortable({
               appendTo: document.body,
               helper: "clone",
               connectWith: ".droptrue"+targetElement[0][0].id,
               scroll: false,
               cancel: '.unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+','+' .unMoveableIconAndTextClassDimensions'+targetElement[0][0].id,
               revertDuration: 10,
               scrollSensitivity: 10,
               scrollSpeed: 1,
               dynamic: true,
               
               receive: function(e, ui) {
               
                   if (($(this)[0].id == "sortable3"+targetElement[0][0].id) || ($(this)[0].id == "sortable1"+targetElement[0][0].id)) {
                   
                       if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                           if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                               (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                           }
                           else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                               (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                           }
                       
                       }
                   } // if (($(this)[0].id == "sortable3") || ($(this)[0].id == "sortable1"))
                   
                    else if (($(this)[0].id == "sortable2"+targetElement[0][0].id) || ($(this)[0].id == "sortable4"+targetElement[0][0].id)) {
                           if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                               //ui.sender.sortable("cancel");
                           
                           if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                               (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                           }
                           else if(  ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                               (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                           }
                       }
                   } //if (($(this)[0].id == "sortable2") || ($(this)[0].id == "sortable4")) {
                   
                   $(ui.item).css({ 'position': 'relative' });
                   
                   if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                       ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                   }
                   
                   else if ($(this)[0].id == "sortable3"+targetElement[0][0].id) { // checking if the dropped element is in Measures drop area
                       
                       if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                           ui.sender.sortable("cancel");
                       }
                       else {
                       //ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                       }
                   
                   } // else if ($(this)[0].id == "sortable3") // checking if the dropped element is in Measures drop area ends here.
                   
                   else if ($(this)[0].id == "sortable4"+targetElement[0][0].id) { // checking if the dropped element is in Dimension drop area
                       
                       if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                           ui.sender.sortable("cancel");
                       }
                       else {
                           ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                       }
                   } //else if ($(this)[0].id == "sortable4")  // checking if the dropped element is in Dimension drop area ends here
                   
                   if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                   
                       if ($(this)[0].id == "sortable1"+targetElement[0][0].id){
                           if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                           
                               if( ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                                   ui.sender.sortable("cancel");
                               } // if(  ui.sender.attr("id") === "sortable4")
                               
                               else if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                                   ui.sender.sortable("cancel");
                               }
                           
                           } // if(ui.item.hasClass("DimesionsClass"))
                       }
                       if ($(this)[0].id == "sortable2"+targetElement[0][0].id){
                           if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                       
                               if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                                   ui.sender.sortable("cancel");
                               }
                               else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                                   ui.sender.sortable("cancel");
                       
                               }
                           }
                       }
                   
					} //if ($(this)[0].id == "sortable1")
                   
                   // if ( ($(this)[0].id == "sortable3"+targetElement[0][0].id) || ($(this)[0].id == "sortable4"+targetElement[0][0].id) ){
                   //     if ($(this).children('li').length > 1 ){
                   //         ui.sender.sortable("cancel");
                   //         ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                   //     }
                   // }
                   
                   if ($(this)[0].id == "sortable4"+targetElement[0][0].id){
                       if ($(this).children('li').length > 1 ){
                           ui.sender.sortable("cancel");
                           ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                       }
                   }
               
               }, //receive ends here
               
               start:function(ev, ui) {
               
               },
               stop:function(ev, ui) {
               
               },
           });
        
        // ----------------- Filter panel and everything within it section ends here -----------------

        
        //------------ creating tooltip ------------
        var tooltipForTreeMap = targetElement .append('div') .attr('class', 'tooltiptreemap') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
        .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
        .style("padding-right", "7px") .style("background", "#F8F8F8") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style("z-index",1000)
        .style("border", "1.0px") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","80px").style("z-index",1000)
        tooltipForTreeMap.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'label').style("color","#000000") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "12px") .style("font-weight", "Bold");
        tooltipForTreeMap.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
        tooltipForTreeMap.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#000000") .style("text-transform","capitalize").style("padding","1px").style("font-size", "12px").style("font-weight", "Bold");
        tooltipForTreeMap.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count1').style("color","#000000") .style("text-transform","capitalize").style("padding","1px").style("font-size", "12px").style("font-weight", "Bold");
        
        var treeMap = d3.layout.treemap().size([width, height]).sticky(true).value(function(d) { return d.size; });
        
        var nestedData = d3.nest() .key(function(d) { return d[options.keys.legendItems]; }) .entries(options.data);
        
        var array = [],temp = {},array1 = [],temp1 = {};
        nestedData.forEach(function(val1,i){
                temp["name"] = val1.key
                val1.values.forEach(function(val2,j){
                    temp1["name"] = val2[options.keys.label];
                    temp1["size"] = val2[options.keys.value];
                    array1.push(temp1);
                    temp1 = {};
                })
                temp["children"] = array1
                array1= [];
                array.push(temp)
                temp = {};
        })
        
        var nestedArray = {},temp = {};
        nestedArray["name"] = "Main"
        nestedArray["children"] = array
        
        var node = divPanelForTreeMap.datum(nestedArray).selectAll(".node").data(treeMap.nodes) .enter().append("div") .attr("class", "node") .call(position).style("position","absolute")
        //.style("background-color", function(d) { if(d.hasOwnProperty('parent') == true){ return d.children ? colours(d.name) : null; } }).style("border","1px solid #ffffff").style("line-height","12px")
        //.style("background-color", function(d,i) { return d.children ? colours(d.name) : null; }).style("border","1px solid #ffffff").style("line-height","12px")
        .style("background-color", function(d,i) { if(i == 0){ return "#ffffff"} else { return d.children ? colours(d.name) : null; } }).style("border","1px solid #ffffff").style("line-height","12px")
        .style("overflow","hidden").style("color","#fcfcfc").style("text-align","center").style("font-size","9px").style("font-family","Verdana,sans-serif").style("font-weight","bold")
        .text(function(d) { return d.children ? null : d.name; });
        
        function position() {
            this.style("left", function(d) { return d.x + "px"; }).style("top", function(d) { return d.y + "px"; }).transition().delay(400).duration(800)//.ease("bounce")
            .style("width", function(d) { return Math.max(0, d.dx - 1) + "px"; }).style("height", function(d) { return Math.max(0, d.dy - 1) + "px"; });
        }
        
        node.on("mousemove",function(d,i){
            var root = targetElement
            var m = d3.mouse(root.node());
            m[0] += 0
            m[1] += 0
    
            var valueForTreeMapToolTip;
            if(d.value.toString().indexOf('.') === -1)
            {
                valueForTreeMapToolTip = d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            else{
        
                valueForTreeMapToolTip = d.value;
            }
    
            tooltipForTreeMap.select('.label').html(options.keys.label + " : " + d.name)
            tooltipForTreeMap.select('.count').html(options.keys.value + " : " + valueForTreeMapToolTip)
            tooltipForTreeMap.style('visibility', 'visible')
            tooltipForTreeMap.select('hr').style("background-color", function(obj){ return colours(d.parent.name); })
            tooltipForTreeMap.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-20) + "px").style("display","block")
                
        })
        .on('mouseout', function(){ tooltipForTreeMap.style("display","none") })
        
        // Converting all json object's key pair value to string
        var tempArray = [], temp = {};
        options.data.forEach(function(d,i){
             for(var k = 0; k < d3.keys(d).length; k++){
                 temp[String(d3.keys(d)[k])] = String(d3.values(d)[k])
             }
             tempArray.push(temp)
             temp = {};
         })
        
        options.data = []
        options.data = tempArray
        
        var drillDownDataArrayForTreeMap = [];
        for(var i = 0; i < node[0].length; i++){
            
            drillDownDataArrayForTreeMap[i] = 0
            if(d3.select(node[0][i])[0][0].__data__.children == undefined){
                drillDownDataArrayForTreeMap[i] = "child"
               
            }
        }
        
        var drillDownDataArrayForTreeMap1 = [];
        options.data.forEach(function(d,i){
            
            for(var j = 0; j < drillDownDataArrayForTreeMap.length; j++){
                if(drillDownDataArrayForTreeMap[j] == "child"){
                    drillDownDataArrayForTreeMap[j] = d;
                    break;
                }
            }
        })
        
        var columnNames = d3.keys(options.data[0])
        var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
        
        for(var i = 0; i < columnNames.length ; i++){
            for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                
                if(columnNames[i].toLowerCase().toString() === drillDownColumnNamesInArray[j].toLowerCase().toString()){
                    
                    for(var k = 0; k < node[0].length; k++){
                        
                        d3.select(node[0][k]).attr('data-drilldownkey', function(d,index){
                                return JSON.stringify(drillDownDataArrayForTreeMap[k]).slice(1, -1).split('"').join("").split(':').join("|")
                        })
                        
                    }
                    
                }
                else {
                }
            }
        }
        
        
        //------------- creating legend ---------------
        var legendPanelSvgForTreeMap = divLegendPanelForTreeMap .append('svg')  .attr("class","") .style('background-color',"#ffffff") .style('position',"absolute")
        .style('width', 100 + "%") .style('height', 100 + "%") .style("left",0 + "%").style("top",0 + "%")
        
        var legend = legendPanelSvgForTreeMap.selectAll('.legend') .data(nestedData)  .enter() .append('g') .attr("class", "legend")
        .attr("height", "100%") .attr("width", "100%") .attr('transform', 'translate(0,20)')
        
        //Create colour circles
        var legendGroup = legend.data(nestedData) .append("rect") .attr("x", 1) .attr("y", function(d, i){ return i * 2;}) .attr("width", 14)
        .attr("height", 14) .attr("rx",10) .attr("ry",10) .style("fill", function(d, i){ return colours(d.key); }) .style("cursor","auto")
        
        //Create text next to circles
        var legendText = legend .data(nestedData) .append("text") .attr("x", 24) .attr("y", function(d, i){ return i * 2 + 12;})
        .style("font-family","Verdana,sans-serif")
        .text(function(d,i) {
              
              if(d.key.length > 10){
              
              return d.key.substring(0,10)+'...';
              }
              else{
              
              return d.key;
              }
        })
        .style('font-size', '14px') .attr("fill","#00001c")
        
        // Aligning Legend (vertically)
        var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelForTreeMap[0][0].style.width) / 100)
        var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelForTreeMap[0][0].style.height) / 100)
        
        var legendRectSize = 11;
        var legendSpacing = 4;
        
        legend.attr('transform', function(d, i) {
			var height = legendRectSize + legendSpacing;
			var offset =  height * colours(d.key).length / 2;
			var horz = 5;
			var vert = (i * height) + (legendPanelHeight - (height * nestedData.length))/2;
			return 'translate(' + horz + ',' + vert + ')';
		})
        
        globalWidthForTreeMap = width; globalHeightForTreeMap = height;
        
        var tableDivForTreeMap = targetElement .append('div')
        .attr("class","scrollingDivForTable-Class tableDivForTreeMap" + targetElement[0][0].id) .style('background-color',"#ffffff") .style("position","absolute")
        .style("display","block") .style("overflow","hidden") //.style("border-right","1px solid #e2e2e2").style("border-bottom","1px solid #e2e2e2")
        
        $( '.tableDivForTreeMap' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
                var e0 = e.originalEvent,
                delta = e0.wheelDelta || -e0.detail;
                
                this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
                e.preventDefault();
        });
        
        if(options.showTitle == true){
            tableDivForTreeMap.style("width", 100 + "%") .style("height", 40 + "%") .style("top",60 + "%")
        }
        else if(options.showTitle == false){
            tableDivForTreeMap.style("width", 100 + "%") .style("height", 40 + "%") .style("top",60 + "%")
        }
        
        tableDivForTreeMap.html('<table class = "tableClassForTreeMap' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                    '<thead class = "theadClassForTreeMap' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForTreeMap' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                                    '<tbody class = "tBodyClassForTreeMap' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                    '</table>'
                                    )
        
        tableDivForTreeMap.select('table').attr("id",targetElement[0][0].id + "tableID")
        
        // Show or Hide Table scroll bar when mouseover on widget
        targetElement.on('mouseover',function(){ tableDivForTreeMap.style("overflow","auto") })
        targetElement.on('mouseout',function(d){ tableDivForTreeMap.style("overflow","hidden") })
        
        var tableDataForTreeMap = [];
        if(options.dataForTable.length > 0){
            tableDataForTreeMap = options.dataForTable;
        }
        else {
            tableDataForTreeMap = options.data;
        }
        
        var thead = tableDivForTreeMap.select("thead").selectAll("th") .data(d3.keys(tableDataForTreeMap[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#fefdfd")//f6f6f6
        .style("position","relative").style("top","2px")
        
        var thead1 = d3.select(".thead1ClassForTreeMap" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tableDataForTreeMap[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#fefdfd")//f6f6f6
        .style("position","relative").style("top","2px")
        
        var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
        .attr("id", "ascendingIconIDForTreeMap") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
        
        var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
        .attr("id", "descendingIconIDForTreeMap") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
        
        var tr = tableDivForTreeMap.select("tbody").selectAll("tr") .data(tableDataForTreeMap).enter().append("tr")
        .attr("id", function(d,i) { return "slice" + i })
        
        // cells
        var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d; })
        .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
        
        var $table = $('.tableClassForTreeMap' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
        
        d3.select(".theadClassForTreeMap" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                d.forEach(function(dd,j){
                  colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                })
        })
        
        $(".thead1ClassForTreeMap" + targetElement[0][0].id).insertAfter('.tBodyClassForTreeMap' + targetElement[0][0].id)
        
        $(".thead1ClassForTreeMap" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForTreeMap' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
        
        tableDivForTreeMap.select(".thead1ClassForTreeMap" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
        })
        
        $('.tableDivForTreeMap' + targetElement[0][0].id).scroll(function () {
            $(".thead1ClassForTreeMap" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForTreeMap' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
                                                                     
        })
        
        var sortOrder = false;
        thead1.on("click",function(k,index){
                  
                  sortOrder = !sortOrder;
                  
                  tableDivForTreeMap.select(".thead1ClassForTreeMap" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                                                                                                                            
                    if (sortOrder) {
                                                                                                    
                        if(i == index){
                            d3.select(this).select('svg').select('#descendingIconIDForTreeMap').style("visibility", "hidden")
                            d3.select(this).select('svg').select('#ascendingIconIDForTreeMap').style("visibility", "visible")
                        }
                        else {
                            d3.select(this).select('svg').select('#descendingIconIDForTreeMap').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForTreeMap').style("visibility", "visible")
                        }
                    }
                    else{
                                                                                                                    
                       if(i == index){
                            d3.select(this).select('svg').select('#descendingIconIDForTreeMap').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForTreeMap').style("visibility", "hidden")
                        }
                        else {
                            d3.select(this).select('svg').select('#descendingIconIDForTreeMap').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForBubbleChart').style("visibility", "visible")
                        }
                    }
                })
                  
                  var monthTruOrFalAryForTreeMap = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
                  
                  tr.sort(function(a, b) {
                          
                          if (sortOrder) {
                          var monthsArrayForTreeMap = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                          } else {
                          var monthsArrayForTreeMap = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                          }
                          
                          monthTruOrFalAryForTreeMap = []; gotMonthArray = [];
                          tableDataForTreeMap.forEach(function(d,i){
                              var da = d[k].toString().substring(0,3).toLowerCase()
                              if(monthsArrayForTreeMap.indexOf(da) >= 0){
                                  monthTruOrFalAryForTreeMap.push(true)
                                  gotMonthArray.push(da);
                              }
                              else {
                                  monthTruOrFalAryForTreeMap.push(false)
                              }
                          })
                          
                          if(monthTruOrFalAryForTreeMap.indexOf(false) == -1){ // true
                          
                          monthArray = []; monthArrayCount = [];
                          gotMonthArray.forEach(function(dd,j){
                            var index1 = monthsArrayForTreeMap.indexOf(dd.substring(0,3))
                            if(monthArrayCount.indexOf(index1) >= 0){
                                index1 = 12 + index1;
                            }
                                monthArray.push(index1);
                                monthArrayCount.push(index1)
                            })
                          returnArray = []
                          monthArray.sort(function(aa, bb) {
                                          returnArray.push(+aa - +bb)
                                          return +aa - +bb;
                                          })
                          
                          sortTableFunc()
                          return returnArray[ind++];
                          } //  if true (if jan feb if block)
                          else {
                              var data = +a[k];
                              
                              if(!isNaN(data)){
                              
                                  if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                                  else { return d3.descending(+a[k], +b[k]); }
                              }
                              else if(!isNaN(Date.parse(a[k]))){
                                  
                                if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                                  else { return new Date(b[k]) - new Date(a[k]) }
                              }
                              else {
                          
                                if (sortOrder) { return d3.ascending(a[k], b[k]); }
                                  else { return d3.descending(a[k], b[k]); }
                              }
                            } // if not jan feb else block
                    }); // tr
                  
		})
        
        function sortTableFunc(){
            
            var table = tableDivForTreeMap.select('table');
            var rows = table.selectAll('tr').data(tableDataForTreeMap);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0).style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500)
            .style('opacity', 1.0).style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
        }
        
        // Main Table Styling
        tableDivForTreeMap.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
        .style("color","#00001c")
        .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4") //.style("box-shadow","10px 10px 50px #007aff").style("z-index",9999)
        tableDivForTreeMap.selectAll('td').style("height","25px") .style("border", "1px solid #ffffff") .style("font-size","12px").style("font-weight","Normal").style("color","#00001c")
        
        //additionally
        tableDivForTreeMap.selectAll('th').style('background-color',"#ffffff").style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
        tableDivForTreeMap.selectAll('td').style("border-style","none").style("color","#00001c")
        //tablePanelForPieChart.selectAll('td').style("height","25px") .style("border", "1px solid #fcfcfc") .style("font-size","12px").style("font-weight","Normal")
        
        //b1da9f
        tableDivForTreeMap.selectAll('table') . style("border-collapse","collapse")
        tableDivForTreeMap.selectAll('table tr:first-child th').style("border-top","0px")
        tableDivForTreeMap.selectAll('table tr:last-child td').style("border-bottom","0px")
        tableDivForTreeMap.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
        tableDivForTreeMap.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")
        
        if(showOrHideTableForTreeMap == false){
            tableDivForTreeMap.style("display","none")
        }
        else if(showOrHideTableForTreeMap == true){
            tableDivForTreeMap.style("display","block")
        }
        
        
        if(options.isDataDetailedForTable == false){
            
            var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
            
            // Adding underlines for selected drill-down column text
            var drillDownSectionsForTreeMap = tableDivForTreeMap.select('table').selectAll('th')
            
            var foundResult = [];
            for(var i = 0; i<drillDownSectionsForTreeMap[0].length; i++){
                for(var j = 0; j<drillDownColumnNamesArray.length; j++){
                    if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForTreeMap[0][i].__data__.toString().toLowerCase() ){
                        foundResult.push(i)
                    }
                }
            }
            
            var r = tableDivForTreeMap.select('table').selectAll('tr').selectAll('td')
            for(var i = 0; i<r.length; i++){
                for(var j = 0; j < foundResult.length; j++){
                    var row = r[i][foundResult[j]]
                    $(row).css("text-decoration", "underline")
                }
            }
        }
        
        //By default calling the resized function first time (to align table's th and td).
        setTimeout(function(){ resizedFunctionForTreeMap() },1000)
        
        window.addEventListener('resize', function(event){ resizedFunctionForTreeMap() });
        
        var globalWidthForTreeMap,globalHeightForTreeMap;
        $(function() {
          $("#" + targetElement[0][0].id).resizable({
                resize: function(event, ui) {
                //globalWidthForTreeMap = ui.size.width;
                //globalHeightForTreeMap = ui.size.height;
                resizedFunctionForTreeMap();
                }
            });
          });
        
        function resizedFunctionForTreeMap()
        {
            
            if((divPanelForTreeMap.node().getBoundingClientRect().width) && (divPanelForTreeMap.node().getBoundingClientRect().height) > 0){
                
                if(showOrHideCommentsBtnForTreeMap == true){
                    bubbleButtonForTreeMap.style('margin-left', "2px")
                    filterBtnForTreeMap.style('margin-left', "2px")
                    refreshBtnForTreeMap.style('margin-left', "2px")
                    commentsBtnForTreeMap.style('margin-left', "2px")
                    menuBtnForTreeMap.style('right', '0')
                }
                else if(showOrHideCommentsBtnForTreeMap == false){
                    bubbleButtonForTreeMap.style('margin-left', "2px")
                    filterBtnForTreeMap.style('margin-left', "2px")
                    refreshBtnForTreeMap.style('margin-left', "2px")
                    //commentsBtnForPieChart.style('right', '0')
                    commentsBtnForTreeMap.style('display','none')
                    menuBtnForTreeMap.style('right', '0')
                }
                
                optsBtnPanelForTreeMap.style('right', '0')
                
                stgPanCanBtnForTreeMap.style('right', '0') // setting panel cancel button.
                
                var margin = {top: 0, right: 0, bottom: 0, left: 0},
                width = (divPanelForTreeMap.node().getBoundingClientRect().width) - margin.left - margin.right,
                height = divPanelForTreeMap.node().getBoundingClientRect().height - margin.top - margin.bottom;
                
                globalWidthForTreeMap = (divPanelForTreeMap.node().getBoundingClientRect().width) - margin.left - margin.right,
                globalHeightForTreeMap = divPanelForTreeMap.node().getBoundingClientRect().height - margin.top - margin.bottom;
                
                treeMap.size([width, height])//.sticky(true).value(function(d) { return d.size; });
                
                divPanelForTreeMap.datum(nestedArray).selectAll(".node").data(treeMap.nodes).call(newPositionFunction).style("background-color", function(d,i) { if(i == 0){ return "#ffffff"} else { return d.children ? colours(d.name) : null; } }) .style("overflow","hidden") .text(function(d) { return d.children ? null : d.name; });
                
                function newPositionFunction() {
                    this.style("left", function(d) { return d.x + "px"; }).style("top", function(d) { return d.y + "px"; }).style("width", function(d) { return Math.max(0, d.dx - 1) + "px"; })
                    .style("height", function(d) { return Math.max(0, d.dy - 1) + "px"; });
                }
                
                // Aligning Legend (vertically)
                var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelForTreeMap[0][0].style.width) / 100)
                var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelForTreeMap[0][0].style.height) / 100)
                
                var legendRectSize = 11;
                var legendSpacing = 4;
                
                legend.attr('transform', function(d, i) {
                            
                    var height = legendRectSize + legendSpacing;
                    var offset =  height * colours(d.key).length / 2;
                    var horz = 5;
                    var vert = (i * height) + (legendPanelHeight - (height * nestedData.length))/2;
                    return 'translate(' + horz + ',' + vert + ')';
                            
                })
                
            colWidth = []; 
			
            d3.select(".theadClassForTreeMap" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                d.forEach(function(dd,j){
                            colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                })
            })
            tableDivForTreeMap.select(".thead1ClassForTreeMap" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                    d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
            })
        }
      }

    }, // treeMap

    // ************************************************** Stacked Circular Area Chart  **************************************************
    stackedCircularAreaChart: function(targetElement, options){
        
        isChartCalled++;
        
        var chartName = "STACKEDCIRCULARAREACHART";
        
        acinfotech.allCharts(targetElement,options,chartName)
        
        targetElement.style("min-width", "350px").style("min-height", "350px").style("background-color", options.BGcolor)
        
        var showOrHideTableForStkCirAreaChart;
        var showOrHideCommentsForStkCirAreaChart;
        var showOrHideCommentsBtnForStkCirAreaChart = true;
        
        if((options.showTable == false) || (options.showTable == true)){
            showOrHideTableForStkCirAreaChart = options.showTable
        }
        else{
            showOrHideTableForStkCirAreaChart = false;
        }
        
        // Show or Hide comments
        if (options.showComments == true || false) {
            showOrHideCommentsForStkCirAreaChart = options.showComments;
        }
        else {
            showOrHideCommentsForStkCirAreaChart = false;
        }
        
        if (options.comments.length == 0){
            showOrHideCommentsForStkCirAreaChart = false;
            showOrHideCommentsBtnForStkCirAreaChart = false;
        }
        
        if ((showOrHideTableForStkCirAreaChart == true) && (showOrHideCommentsForStkCirAreaChart == true)){
            showOrHideTableForStkCirAreaChart = true;
            showOrHideCommentsForStkCirAreaChart = false;
        }
        else if ((showOrHideTableForStkCirAreaChart == false) && (showOrHideCommentsForStkCirAreaChart == false)){
            showOrHideTableForStkCirAreaChart = false;
            showOrHideCommentsForStkCirAreaChart = false;
        }
        
        var chartTitlePanelForStkCirAreaChart =  targetElement.append("div") .style("background-color","#ffffff") .style("position","absolute").style('background-color',"#ffffff")
        .style("text-indent","6px")
        
		var optsBtnPanelForStkCirAreaChart = targetElement.append('div').style('width',"25px").style('height',"210px").style('position','absolute')
        .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px")
        .style('right', '0')
        .style("min-width","25px").style("border-style","none").style("border-left", "solid #fcfcfc  1px")
		
        var grpBarBtnForStkCirAreaChart = optsBtnPanelForStkCirAreaChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','80px') .style("cursor","pointer").style("display","block")
        .style("border-style", "none").style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px") .style("box-sizing","border-box")
        var grpBarBtnImgVar = document.createElement("IMG");
        grpBarBtnImgVar.src = "images/grpBarIcon.png";
        grpBarBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:16px; opacity:0.9;")
        grpBarBtnForStkCirAreaChart[0][0].appendChild(grpBarBtnImgVar)
        
        var horiGrpBarBtnForStkCirAreaChart = optsBtnPanelForStkCirAreaChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','105px') .style("cursor","pointer").style("display","block")
        .style("border-style", "none").style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px") .style("box-sizing","border-box")
        var horiGrpBarBtnImgVar = document.createElement("IMG");
        horiGrpBarBtnImgVar.src = "images/horiGrpBarIcon.png";
        horiGrpBarBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:16px; opacity:0.9;")
        horiGrpBarBtnForStkCirAreaChart[0][0].appendChild(horiGrpBarBtnImgVar)
        
        var filterBtnForStkCirAreaChart = optsBtnPanelForStkCirAreaChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','130px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var filterBtnImgVar = document.createElement("IMG");
        filterBtnImgVar.src = "images/filterIcon.png";
        filterBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        filterBtnForStkCirAreaChart[0][0].appendChild(filterBtnImgVar)
        
        var refreshBtnForStkCirAreaChart = optsBtnPanelForStkCirAreaChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','155px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var refreshBtnImgVar = document.createElement("IMG");
        refreshBtnImgVar.src = "images/refreshIcon.png";
        refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        refreshBtnForStkCirAreaChart[0][0].appendChild(refreshBtnImgVar)
        
        var commentsBtnForStkCirAreaChart = optsBtnPanelForStkCirAreaChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','180px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var commentsBtnImgVariable = document.createElement("IMG");
        if(options.showComments == false){
            commentsBtnImgVariable.src = "images/showCommentsIcon.png";
        }
        else if(options.showComments == true){
            commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
        }
        commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        commentsBtnForStkCirAreaChart[0][0].appendChild(commentsBtnImgVariable)
        
        var menuBtnForStkCirAreaChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','1px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var menuBtnImgVar = document.createElement("IMG");
        menuBtnImgVar.src = "images/menuIcon.png";
        menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
        menuBtnForStkCirAreaChart[0][0].appendChild(menuBtnImgVar)
        
        if(showOrHideCommentsBtnForStkCirAreaChart == true){
            grpBarBtnForStkCirAreaChart.style('margin-left', "2px")
            horiGrpBarBtnForStkCirAreaChart.style('margin-left', "2px")
            filterBtnForStkCirAreaChart.style('margin-left', "2px")
            refreshBtnForStkCirAreaChart.style('margin-left', "2px")
            commentsBtnForStkCirAreaChart.style('margin-left', "2px")
            menuBtnForStkCirAreaChart.style('right', '0')
        }
        else if(showOrHideCommentsBtnForStkCirAreaChart == false){
            grpBarBtnForStkCirAreaChart.style('margin-left', "2px")
            horiGrpBarBtnForStkCirAreaChart.style('margin-left', "2px")
            filterBtnForStkCirAreaChart.style('margin-left', "2px")
            refreshBtnForStkCirAreaChart.style('margin-left', "2px")
            //commentsBtnForStkCirAreaChart.style('right', '0')
            commentsBtnForStkCirAreaChart.style('display','none')
            menuBtnForStkCirAreaChart.style('right', '0')
        }
        
        var ismenuBtnOfStkCirAreaChartClicked = false;
        menuBtnForStkCirAreaChart.on('click', function() {
                                     
             filterPanelForStkCirAreaChart.style("display","none");
             
             stgPanDivForStkCirAreaChart.style("display","none") // Hiding setting panel
             
             if ((showOrHideTableForStkCirAreaChart == false) && (showOrHideCommentsForStkCirAreaChart == true)){
                 divLegendPanelStkCirAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                 .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                 
                 svgPanelForStkCirAreaChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                 .style("position","absolute");
             }
             else if ((showOrHideTableForStkCirAreaChart == true) && (showOrHideCommentsForStkCirAreaChart == false)){
                 divLegendPanelStkCirAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                 .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                 
                 svgPanelForStkCirAreaChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                 .style("position","absolute");
             }
             else if ((showOrHideTableForStkCirAreaChart == false) && (showOrHideCommentsForStkCirAreaChart == false)){
                 divLegendPanelStkCirAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                 .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                 
                 svgPanelForStkCirAreaChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                 .style("position","absolute");
             }
             
             
             if(ismenuBtnOfStkCirAreaChartClicked == false){
                 ismenuBtnOfStkCirAreaChartClicked = true;
                 optsBtnPanelForStkCirAreaChart.style("display","block")
             
             }
             else if(ismenuBtnOfStkCirAreaChartClicked == true){
                 ismenuBtnOfStkCirAreaChartClicked = false
                 optsBtnPanelForStkCirAreaChart.style("display","none")
             }
             
             resizedFuctionForStkCirAreaChart();
        })
        
        var tableButtonForStkCirAreaChart = optsBtnPanelForStkCirAreaChart.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top','1px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
        var tableBtnImgVar = document.createElement("IMG");
        if(showOrHideTableForStkCirAreaChart == false){
            tableBtnImgVar.src = "images/showTableIcon.png";
            tableButtonForStkCirAreaChart.attr("class","showTableClassForChartTable")
        }
        else if(showOrHideTableForStkCirAreaChart == true){
            tableBtnImgVar.src = "images/cancelTableIcon.png";
            tableButtonForStkCirAreaChart.attr("class","hideTableClassForChartTable")
        }
        tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
        tableButtonForStkCirAreaChart[0][0].appendChild(tableBtnImgVar)
        
        var settingBtnForStkCirAreaChart = optsBtnPanelForStkCirAreaChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 28 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        var settingBtnImgVar = document.createElement("IMG");
        settingBtnImgVar.src = "images/settingsIcon.png";
        settingBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.82;")
        settingBtnForStkCirAreaChart[0][0].appendChild(settingBtnImgVar)
        
        var downloadBtnForStkCirAreaChart = optsBtnPanelForStkCirAreaChart.append("div").attr("id","downloadBtnForStkCirAreaChart-ID-" + targetElement[0][0].id).style("width","20px")
        .style("height","20px").style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff").style('margin-left','2px')
        .style('top', 54 + 'px').style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        
        acinfotech.downloadFunctionality("downloadBtnForStkCirAreaChart-ID-" + targetElement[0][0].id,targetElement)
        
        var svgPanelForStkCirAreaChart = targetElement .append('svg') 
        .attr("id","svgPanelIDForStkCirAreaChart" + targetElement[0][0].id) .style('background-color',"#ffffff") .style("position","absolute")
        .style("border","0px solid #d0d0d0")
        
        var commentsPanelDivForStkCirAreaChart = targetElement.append("div") .attr("class","commentsPanelClassForSCAChart")
        .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
		.style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
        .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)
        
        commentsPanelDivForStkCirAreaChart.on('click',function(d){
			$('.commentsClassForStkCirAreaChart' + targetElement[0][0].id).focus()
		})
        
        if(options.showTitle == true){
            
            chartTitlePanelForStkCirAreaChart.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 8 + "%"; })
            .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')
            
            if ((showOrHideTableForStkCirAreaChart == false) && (showOrHideCommentsForStkCirAreaChart == true)){
                
                var commentsForStkCirAreaChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                .css('line-height','1.1em').css('text-align','justify') .attr('class','commentsClassForStkCirAreaChart' + targetElement[0][0].id)
                
                svgPanelForStkCirAreaChart.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .append('g')
                commentsPanelDivForStkCirAreaChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                .style("top",78 + "%")
                .html(commentsForStkCirAreaChart[0].outerHTML.toString())
                
            }
            else if ((showOrHideTableForStkCirAreaChart == true) && (showOrHideCommentsForStkCirAreaChart == false)){
                
                svgPanelForStkCirAreaChart.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .append('g')
                commentsPanelDivForStkCirAreaChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForStkCirAreaChart == false) && (showOrHideCommentsForStkCirAreaChart == false)){
                svgPanelForStkCirAreaChart.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .append('g')
                commentsPanelDivForStkCirAreaChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            
            var margin = {top: 0 , right: 0, bottom: 0, left: 0},
            width = (svgPanelForStkCirAreaChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = (svgPanelForStkCirAreaChart.node().getBoundingClientRect().height) - margin.top - margin.bottom;
            
        }
        else if(options.showTitle == false){
            chartTitlePanelForStkCirAreaChart.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });
            
            if ((showOrHideTableForStkCirAreaChart == false) && (showOrHideCommentsForStkCirAreaChart == true)){
                
                var commentsForStkCirAreaChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                .css('line-height','1.1em').css('text-align','justify')
                
                svgPanelForStkCirAreaChart.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .append('g')
                commentsPanelDivForStkCirAreaChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                .style("top",78 + "%")
                .html(commentsForStkCirAreaChart[0].outerHTML.toString())
                
            }
            else if ((showOrHideTableForStkCirAreaChart == true) && (showOrHideCommentsForStkCirAreaChart == false)){
                
                svgPanelForStkCirAreaChart.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .append('g')
                commentsPanelDivForStkCirAreaChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForStkCirAreaChart == false) && (showOrHideCommentsForStkCirAreaChart == false)){
                svgPanelForStkCirAreaChart.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .append('g')
                commentsPanelDivForStkCirAreaChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            
            var margin = {top: 0 , right: 0, bottom: 0, left: 0},
            width = (svgPanelForStkCirAreaChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = svgPanelForStkCirAreaChart.node().getBoundingClientRect().height - margin.top - margin.bottom;
        }
        
        var colours;
        
        // checking color set for bubbles and legend dots
        if(options.colorSet === undefined){
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "one"){
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            options.colorSet = "two"
            colours = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            options.colorSet = "three"
            colours = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        }
        else
        {
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        
        //------------------ Settings panel DIV and everything within it section begins here -------------------
        
        var stgPanDivForStkCirAreaChart = targetElement.append('div').style('width',"100%").style('height',"40%").attr("class","stgPanDivForStkHoriChart" + targetElement[0][0].id)
        .style('position','absolute').style('margin-left', "0px").style('border-top',"1px solid #f0f0f0").style('border-bottom',"1px solid #e5e5e5")
        .style("background-color",'#fcfcfc').style("z-index",90) .style("display","none") .style('top', 60.0 + "%") .style('height',40 + "%")
        
        $( '.stgPanDivForStkHoriChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
                  var e0 = e.originalEvent,
                  delta = e0.wheelDelta || -e0.detail;
                  
                  this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
                  e.preventDefault();
          });
        
        var settingPanelTitle = stgPanDivForStkCirAreaChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','10px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; color:#00001c;">'+ "Settings" +'</div>')
        
        var stgPanDivForStkChangeColorTitle = stgPanDivForStkCirAreaChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Select color set " +'</div>')
        
        var stgPanCanBtnForStkCirAreaChart = stgPanDivForStkCirAreaChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
        .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white')
        .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.9; background-color:#fcfcff")
        stgPanCanBtnForStkCirAreaChart[0][0].appendChild(cancelBtnImgVar)
        
        stgPanCanBtnForStkCirAreaChart.on('click', function() {
              stgPanDivForStkCirAreaChart.style("display","none") // Hiding setting panel
              
              if ((showOrHideTableForStkCirAreaChart == false) && (showOrHideCommentsForStkCirAreaChart == true)){
              divLegendPanelStkCirAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
              .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
              
              svgPanelForStkCirAreaChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
              .style("position","absolute");
              }
              else if ((showOrHideTableForStkCirAreaChart == true) && (showOrHideCommentsForStkCirAreaChart == false)){
              divLegendPanelStkCirAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
              .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
              
              svgPanelForStkCirAreaChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
              .style("position","absolute");
              }
              else if ((showOrHideTableForStkCirAreaChart == false) && (showOrHideCommentsForStkCirAreaChart == false)){
              divLegendPanelStkCirAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
              .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
              
              svgPanelForStkCirAreaChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
              .style("position","absolute");
              }
              
              resizedFuctionForStkCirAreaChart();
          })
        
        var formForChangeSettingsPanel = stgPanDivForStkCirAreaChart.append("form");
        formForChangeSettingsPanel.style("background-color","#fcfcfc").style("margin-top","67px").style("font-family","Verdana,sans-serif").style("font-size","12px")
        .style("position","absolute").attr("id","formForChangeColorSettingsPanel" + targetElement[0][0].id).style("font-weight","Bold").style("width","180px")
        .style("height","58px").style("padding","0px").style("border-radius","0px") .style("margin-left","10px")
        
        var svgPanelForCrSetOne = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px").style("height","18px").style("margin-top","1px").style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetOne = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        var colorSetOneRange = d3.range(12);
        
        var colorSetOneDots = svgPanelForCrSetOne.append("g")
        colorSetOneDots.selectAll('rect') .data(colorSetOneRange) .enter() .append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("fill", function(d,i){return colorSetOne(i)})
        .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetOne(i); })
        .style("cursor","auto") .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
        
        var svgPanelForCrSetTwo = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px") .style("margin-top","20px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetTwo = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        var colorSetTwoRange = d3.range(12);
        
        var colorSetTwoDots = svgPanelForCrSetTwo.append("g")
        colorSetTwoDots.selectAll('rect') .data(colorSetTwoRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto")
        .style("fill", function(d,i){return colorSetTwo(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
        .style("stroke",function(d,i){  return colorSetTwo(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
        
        var svgPanelForCrSetThree = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px") .style("margin-top","39px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetThree = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        var colorSetThreeRange = d3.range(12);
        
        var colorSetThreeDots = svgPanelForCrSetThree.append("g")
        colorSetThreeDots.selectAll('rect') .data(colorSetThreeRange) .enter().append('rect')
        .attr('transform', 'translate(' + (2) + ',' + (1) + ')') .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10)
        .attr("height",10) .style("cursor","auto") .style("fill", function(d,i){return colorSetThree(i)}) .style("fill-opacity",0.93)
        .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetThree(i);  })
        .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
        
        if(options.colorSet.toString().toLowerCase() === "one"){
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"1px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"1px solid #808080")
        }
        else
        {
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        
            svgPanelForCrSetOne.on('click',function(d){
                   options.colorSet = "one"
                   svgPanelForCrSetOne.style('border',"1px solid #808080")
                   svgPanelForCrSetTwo.style('border',"0px solid #808080")
                   svgPanelForCrSetThree.style('border',"0px solid #808080")
                   
                   colours = "";
                   colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
                   
                   svg.selectAll(".layer").style('fill', function (d, i) { return colours(i); })
                   
                   legendGroup.style("fill", function(d, i){ return colours(i);})
                   
           })
            svgPanelForCrSetTwo.on('click',function(d){
                   options.colorSet = "two"
                   svgPanelForCrSetOne.style('border',"0px solid #808080")
                   svgPanelForCrSetTwo.style('border',"1px solid #808080")
                   svgPanelForCrSetThree.style('border',"0px solid #808080")
                   
                   colours = "";
                   colours = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
                   
                   svg.selectAll(".layer").style('fill', function (d, i) { return colours(i);})
				   
                   legendGroup.style("fill", function(d, i){ return colours(i);})
           })
            svgPanelForCrSetThree.on('click',function(d){
                     options.colorSet = "three"
                     svgPanelForCrSetOne.style('border',"0px solid #808080")
                     svgPanelForCrSetTwo.style('border',"0px solid #808080")
                     svgPanelForCrSetThree.style('border',"1px solid #808080")
                     
                     colours = "";
                     colours = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
                     
                    svg.selectAll(".layer").style('fill', function (d, i) { return colours(i); })
					 
                    legendGroup.style("fill", function(d, i){ return colours(i);})
             })
        
        
        //------------------ Settings panel DIV and everything inside it section ends here ------------------
        
        grpBarBtnForStkCirAreaChart.on('click', function() {
                                       
               //isFilterClicked = false
               d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
               
               var newOptions = {
                   data: options.data,
                   dataForDrillDown: [], //options.dataForDrillDown,
                   dataForTable: options.dataForTable,
                   isDataDetailedForTable: options.isDataDetailedForTable,
                   keys: {
                       label: options.keys.label,
                       groupBars: options.keys.stackedAreas,
                   },
                   chartTitle: options.chartTitle,
                   xAxisLable: options.keys.label,
                   yAxisLable: "",
                   showTitle: options.showTitle,
                   colorSet: options.colorSet,
                   drillDownColumnName: "", //options.drillDownColumnName,
                   showTable: false,
                   showComments: false,
                   comments: options.comments,
                   resizeButtonID: options.resizeButtonID
               
               }
               
               acinfotech.groupedBarChart(targetElement, newOptions)
        })
        
        horiGrpBarBtnForStkCirAreaChart.on('click', function() {
                                       
           //isFilterClicked = false
           d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
           
           var newOptions = {
               data: options.data,
               dataForDrillDown: [], //options.dataForDrillDown,
               dataForTable: options.dataForTable,
               isDataDetailedForTable: options.isDataDetailedForTable,
               keys: {
                   label: options.keys.label,
                   groupBars: options.keys.stackedAreas,
               },
               chartTitle: options.chartTitle,
               xAxisLable: "",
               yAxisLable: options.keys.label,
               showTitle: options.showTitle,
               colorSet: options.colorSet,
               drillDownColumnName: "", //options.drillDownColumnName,
               showTable: false,
               showComments: false,
               comments: options.comments,
               resizeButtonID: options.resizeButtonID
           
           }
           
           acinfotech.horizontalGroupedBarChart(targetElement, newOptions)
        })
        
        // Filter
        filterBtnForStkCirAreaChart.on('click', function() {
                                       
               filterPanelForStkCirAreaChart.style("display","block");
               
               ismenuBtnOfStkCirAreaChartClicked = false;
               optsBtnPanelForStkCirAreaChart.style("display","none");
               
               stgPanDivForStkCirAreaChart.style("display","none");
               
               if ((showOrHideTableForStkCirAreaChart == false) && (showOrHideCommentsForStkCirAreaChart == true)){
                   divLegendPanelStkCirAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                   .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                   
                   svgPanelForStkCirAreaChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                   .style("position","absolute");
               }
               else if ((showOrHideTableForStkCirAreaChart == true) && (showOrHideCommentsForStkCirAreaChart == false)){
                   divLegendPanelStkCirAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                   .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                   
                   svgPanelForStkCirAreaChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                   .style("position","absolute");
               }
               else if ((showOrHideTableForStkCirAreaChart == false) && (showOrHideCommentsForStkCirAreaChart == false)){
                   divLegendPanelStkCirAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                   .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                   
                   svgPanelForStkCirAreaChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                   .style("position","absolute");
               }
               
               resizedFuctionForStkCirAreaChart();
                                       
       })
        
        // Refreshing Chart and Table
        refreshBtnForStkCirAreaChart.on('click', function() {
                                        
            //isFilterClicked = false
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                                
            for(var i = 0; i<divAndChartsArray.length; i++){
                                
                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData;
                                
                    if(newtargetElementAndOptionsArray[i].options.keys.stackedAreas == undefined){
                        options.keys.stackedAreas = newtargetElementAndOptionsArray[i].options.keys.groupBars;
                    }
                    else {
                        options.keys.stackedAreas = newtargetElementAndOptionsArray[i].options.keys.stackedAreas;
                    }
                                
                }
            }
            acinfotech.stackedCircularAreaChart(targetElement,options)
                                        
        })
        
        // Refreshing Chart and Table
        commentsBtnForStkCirAreaChart.on('click', function() {
                     
                if(options.showComments == false){ 
                    options.showComments = true;
                }
                else if(options.showComments == true){ 
                    options.showComments = false;
                }
                     
                 //isFilterClicked = false
                 d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                     
                for(var i = 0; i<divAndChartsArray.length; i++){
                     
                     if(targetElement[0][0].id === divAndChartsArray[i].divID){
                       options.data = divAndChartsArray[i].optionsData;
                       //options.keys.stackedAreas = newtargetElementAndOptionsArray[i].options.keys.stackedAreas;
                         
                        if(newtargetElementAndOptionsArray[i].options.keys.stackedAreas == undefined){
                             options.keys.stackedAreas = newtargetElementAndOptionsArray[i].options.keys.groupBars;
                        }
                        else {
                             options.keys.stackedAreas = newtargetElementAndOptionsArray[i].options.keys.stackedAreas;
                        }
                         
                       options.showTable = false;
                     }
                }
                acinfotech.stackedCircularAreaChart(targetElement,options)
                                     
        })
        
        // showing/hidding chart table
        tableButtonForStkCirAreaChart.on('click', function() {
                 
                 if(showOrHideTableForStkCirAreaChart == false){
                     options.showTable = true;
                     //showOrHideTableForPieChart = true
                 }
                 else if(showOrHideTableForStkCirAreaChart == true){
                     //showOrHideTableForPieChart = false
                     options.showTable = false;
                 }
                 
                 d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
                 
                 for(var i = 0; i<divAndChartsArray.length; i++){
                 
                     if(targetElement[0][0].id === divAndChartsArray[i].divID){
                         options.data = divAndChartsArray[i].optionsData
                         options.showComments = false;
                         
                         if(newtargetElementAndOptionsArray[i].options.keys.stackedAreas == undefined){
                            options.keys.stackedAreas = newtargetElementAndOptionsArray[i].options.keys.groupBars;
                         }
                         else {
                            options.keys.stackedAreas = newtargetElementAndOptionsArray[i].options.keys.stackedAreas;
                         }
                     }
                 }
                 acinfotech.stackedCircularAreaChart(targetElement,options)
        })
        
        
        settingBtnForStkCirAreaChart.on('click', function() {
                                    
            ismenuBtnOfStkCirAreaChartClicked = false; // Menu toggle button variable
            optsBtnPanelForStkCirAreaChart.style("display","none") // To hide options button panel
            
            iconButtonTooltipForStackedChart.style("display","none") // Removing options button ToolTip
            settingBtnForStkCirAreaChart.style("cursor","pointer")
            
            stgPanDivForStkCirAreaChart.style("display","block") // Showing settings panel
            
            svgPanelForStkCirAreaChart.style('width', 75 + "%") .style('height', 52 + "%").style("position","absolute"); // Decreasing chart panel
            divLegendPanelStkCirAreaChart.style('width', 25 + "%") .style('height', 52 + "%").style("position","absolute"); // Decreasing chart panel
            
            resizedFuctionForStkCirAreaChart(); // Calling resize function()
                                    
        })
        
        downloadBtnForStkCirAreaChart.on('click', function() {
                                  
          ismenuBtnOfStkCirAreaChartClicked = false; // Changing menu button value to false
          optsBtnPanelForStkCirAreaChart.style("display","none") // Hiding option buttons panel
                                  
        })
        
        // Creating ToolTip for options button.
        var iconButtonTooltipForStackedChart = targetElement.append('div').style('width','240px').attr("id","too")
        .style('height',"25px").style('position','absolute')//.style('margin-left', "0px").style('top','25px')
        .style("background-color",'#404040 ').style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid") // 004b9d
        .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none").attr("border", 0.0)
        
            grpBarBtnForStkCirAreaChart.on('mousemove', function(d,i) {
               var root = targetElement
               var m = d3.mouse(root.node());
               m[0] += 0
               m[1] += 0
               var grpBtnTooltipText = "Grouped Bar Chart";
               
               iconButtonTooltipForStackedChart.style("width","117px").style("margin-left", (m[0] - 127) + "px").style("margin-top",(m[1]) + "px").style("display","block")
               iconButtonTooltipForStackedChart.html('<div  style="width: 100%; height:0%; padding-left:10px; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; ">'+ grpBtnTooltipText +'</div>')
                       
            })
            grpBarBtnForStkCirAreaChart.on('mouseout', function(d,i) {
                   iconButtonTooltipForStackedChart.style("display","none")
            })

            horiGrpBarBtnForStkCirAreaChart.on('mousemove', function(d,i) {
               var root = targetElement
               var m = d3.mouse(root.node());
               m[0] += 0
               m[1] += 0
               var grpBtnTooltipText = "Horizontla Grouped Bar Chart";
               
               iconButtonTooltipForStackedChart.style("width","175px").style("margin-left", (m[0] - 185) + "px").style("margin-top",(m[1]) + "px").style("display","block")
               iconButtonTooltipForStackedChart.html('<div  style="width: 100%; height:0%; padding-left:10px; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; ">'+ grpBtnTooltipText +'</div>')
                       
            })
            horiGrpBarBtnForStkCirAreaChart.on('mouseout', function(d,i) {
               iconButtonTooltipForStackedChart.style("display","none")
            })

            filterBtnForStkCirAreaChart.on('mousemove', function(d,i) {
               var root = targetElement
               var m = d3.mouse(root.node());
               m[0] += 0
               m[1] += 0
               var filterButtonTooltipText = "Filter";
               
               iconButtonTooltipForStackedChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
               iconButtonTooltipForStackedChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')
                       
            })
            filterBtnForStkCirAreaChart.on('mouseout', function(d,i) {
               iconButtonTooltipForStackedChart.style("display","none")
            })

            refreshBtnForStkCirAreaChart.on('mousemove', function(d,i) {
                var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                var refreshButtonTooltipText = "Refresh";
                
                iconButtonTooltipForStackedChart.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
                iconButtonTooltipForStackedChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center; ">'+ refreshButtonTooltipText +'</div>')
                        
            })
            refreshBtnForStkCirAreaChart.on('mouseout', function(d,i) {
                iconButtonTooltipForStackedChart.style("display","none")
            })

            commentsBtnForStkCirAreaChart.on('mousemove', function(d,i) {
                     commentsPanelDivForStkCirAreaChart.style('background-color','#fafafa')
                     var root = targetElement
                     var m = d3.mouse(root.node());
                     m[0] += 0
                     m[1] += 0
                     if(options.showComments == false){
                     var commentButtonTooltipText = "Show Comments";
                     }
                     else if(options.showComments == true){
                     var commentButtonTooltipText = "Hide Comments";
                     }
                     
                     
                     iconButtonTooltipForStackedChart.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
                     iconButtonTooltipForStackedChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center; ">'+ commentButtonTooltipText +'</div>')
             })
            commentsBtnForStkCirAreaChart.on('mouseout', function(d,i) {
                     commentsPanelDivForStkCirAreaChart.style('background-color','#ffffff')
                     iconButtonTooltipForStackedChart.style("display","none")
             })

            menuBtnForStkCirAreaChart.on('mousemove', function(d,i) {
                     var root = targetElement
                     var m = d3.mouse(root.node());
                     m[0] += 0
                     m[1] += 0
                     var menuButtonTooltipText = "Menu";
                     
                     iconButtonTooltipForStackedChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
                     iconButtonTooltipForStackedChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center; ">'+ menuButtonTooltipText +'</div>')
                     
             })
            menuBtnForStkCirAreaChart.on('mouseout', function(d,i) {
                     iconButtonTooltipForStackedChart.style("display","none")
             })

            tableButtonForStkCirAreaChart.on('mousemove', function(d,i) {
                     var root = targetElement
                     var m = d3.mouse(root.node());
                     m[0] += 0
                     m[1] += 0
                     if(showOrHideTableForStkCirAreaChart ==  false){
                     var refreshButtonTooltipText = "Show Table";
                     }
                     else if(showOrHideTableForStkCirAreaChart == true){
                     var refreshButtonTooltipText = "Hide Table";
                     }
                     
                     iconButtonTooltipForStackedChart.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
                     iconButtonTooltipForStackedChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ refreshButtonTooltipText +'</div>')
                     
             })
            tableButtonForStkCirAreaChart.on('mouseout', function(d,i) {
                     iconButtonTooltipForStackedChart.style("display","none")
             })

            settingBtnForStkCirAreaChart.on('mousemove', function(d,i) {
                    var root = targetElement
                    var m = d3.mouse(root.node());
                    m[0] += 0
                    m[1] += 0
                    var settingTooltipText = "Settings";
                    
                    iconButtonTooltipForStackedChart.style("width","67px").style("margin-left", (m[0] - 77) + "px").style("margin-top",(m[1]) + "px").style("display","block")
                    iconButtonTooltipForStackedChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ settingTooltipText +'</div>')
            })
            settingBtnForStkCirAreaChart.on('mouseout', function(d,i) {
                    iconButtonTooltipForStackedChart.style("display","none")
            })
        
            downloadBtnForStkCirAreaChart.on('mousemove', function(d,i) {
                  var root = targetElement
                  var m = d3.mouse(root.node());
                  m[0] += 0
                  m[1] += 0
                  var downloadButtonTooltipText = "Download";
                  
                  iconButtonTooltipForStackedChart.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
                  iconButtonTooltipForStackedChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
            })
            downloadBtnForStkCirAreaChart.on('mouseout', function(d,i) {
                  iconButtonTooltipForStackedChart.style("display","none")
            })
        
        // ----------------- Filter panel and everything within it section begins here ----------------
        var filterPanelForStkCirAreaChart = targetElement.append('div').style('width',350 + "px") .attr("class","filterPanelForStkCirAreaChartClass" + targetElement[0][0].id)
        .style('position','absolute').style('margin-left', "0px")
        .style("background-color",'#fefefe').style("z-index",11).style("border-color", "#ffffff").style("border-right", "solid #e5e5e5 1px")  .style("border-style", "solid") // 004b9d
        .style("box-shadow", "2px 0px 1px #eff8ec").style("display","none").style("border-top", "solid #fdfdfd 1px").style("border-left","0px").style("border-bottom", "0px")
        .style('top', 0.0 + "%").style('height', 100 + "%").style('overflow-y',"hidden").style("overflow-x","hidden")
        .style("border-bottom", "solid #e5e5e5 1px") .style("box-sizing","border-box")
        
        var filterPanelForStkCirAreaChartTitle = filterPanelForStkCirAreaChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','20px').style('text-indent','5px').style("font-size", "14px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #007aff").style("width","350px").style("color","#000000")
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; top:25.0%; font-size:14px; font-family:inter; color:#00001c;">'+ "Filter" +'</div>')
        
        var measuresColumnTitle = filterPanelForStkCirAreaChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; text-indent:3px;">Available Measures</div>');
        
        var measuresVariables = filterPanelForStkCirAreaChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable1"+targetElement[0][0].id)
        .style("list-style-type","none")
        .style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '78px')
        .style('position','absolute')
        .style("width","155px").style("min-height","190px").style("max-height","190px").style("border", "#f0f0f0 1px solid")
        .style("max-width","155px").style("overflow-x","hidden").style("overflow-y","auto")
        measuresVariables.style("left",0.0 + "px").style("padding","2px")
        
        $( ".filterPanelForStkCirAreaChartClass" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
                var e0 = e.originalEvent,
                delta = e0.wheelDelta || -e0.detail;
                
                this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
                e.preventDefault();
        });
        
        
        var measuresArray = [];
        var dimensionArray = [];
        
        var measuresArrayLength = [];
        var dimensionsArrayLength = [];
        
        dimensionArray.push(options.keys.label);
        //measuresArray = options.keys.stackedBars;
        
        for(var i = 0; i<divAndChartsArray.length; i++){
            if(targetElement[0][0].id === divAndChartsArray[i].divID){
                
                if(newtargetElementAndOptionsArray[i].options.keys.stackedAreas == undefined){
                    measuresArray = newtargetElementAndOptionsArray[i].options.keys.groupBars;
                }
                else {
                    measuresArray = newtargetElementAndOptionsArray[i].options.keys.stackedAreas;
                }
            }
        }
        
        // filter process
        var uniqueMeasuresArrayKeys = [];
        $.each(measuresArray, function(i, el){
           if($.inArray(el, uniqueMeasuresArrayKeys) === -1){
               uniqueMeasuresArrayKeys.push(el);
           }
        });
        
        var uniqueDimensionArrayKeys = [];
        $.each(dimensionArray, function(i, el){
           if($.inArray(el, uniqueDimensionArrayKeys) === -1){
               uniqueDimensionArrayKeys.push(el);
           }
        });
        
        // setting lenght for arrays
        for(var i = 0; i<uniqueMeasuresArrayKeys.length; i++){
            measuresArrayLength.push(i);
        }
        
        for(var i = 0; i<uniqueDimensionArrayKeys.length; i++){
            dimensionsArrayLength.push(i);
        }
        
        var measuresVariables1 = measuresVariables.selectAll("li") .data(measuresArrayLength).enter().append("li")
        .style("width","130px") .style("max-height","22px").style("cursor","move")
        .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#bcf1bc").style("font-weight","Normal")
        .style("list-style-type","none").style("border","1px #89e789 solid").style("color","#006600").style("font-family","Verdana,sans-serif")
        .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
        .text(function(d) {return uniqueMeasuresArrayKeys[d]})
        measuresVariables1.attr("class","MeasuresClass"+targetElement[0][0].id)
        
        var measuresColumnReceivedUI_TableTitle = filterPanelForStkCirAreaChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','180px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; ">Selected Measures</div>');
        
        var measuresColumnReceivedUI_Table = filterPanelForStkCirAreaChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable3"+targetElement[0][0].id)
        .style('background-color',"#ffffff").style('margin-left','180px').style('margin-top', '78px')
        .style("width","155px").style('position','absolute').style("padding","2px").style("min-height","190px")
        .style("border","1px #c1c1c1 dashed") .style("max-height","190px") .style("overflow-x","hidden") .style("overflow-y","auto")
        //.html('<div class=unsortable  style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:65.0%; font-size:14px; font-family:inter;  color:#99ea99; font-weight:Normal; text-align:center;">Drag and Drop Measures here from Available Measures List. </div>');
        .html('<img class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' src="images/dragIcon.png" style=" width:36px; height:36px; position:absolute; margin-left:65px; margin-top:60px; opacity:0.6"/>'
              + '<div class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:60.0%; font-size:12px; font-family:inter;  color:#89d289; font-weight:Normal; text-align:center;">Drop Measures here. </div>');
        //.html('<div style="background-image: url(images/dragIcon.png); height: 64px; width: 64px; border: 1px solid black;"> </div>');
        
        var cancelButton = filterPanelForStkCirAreaChart.append("div") .style("width","23px").style("height","21px").style('position','absolute')
        .style('margin-left','320px').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white')
        .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.9; background-color:#fcfcff")
        cancelButton[0][0].appendChild(cancelBtnImgVar)
        
        cancelButton.on("click", function(){
            filterPanelForStkCirAreaChart.style("display","none")
            
            if ((showOrHideTableForStkCirAreaChart == false) && (showOrHideCommentsForStkCirAreaChart == true)){
                divLegendPanelStkCirAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                
                svgPanelForStkCirAreaChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute");
            }
            else if ((showOrHideTableForStkCirAreaChart == true) && (showOrHideCommentsForStkCirAreaChart == false)){
                divLegendPanelStkCirAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                
                svgPanelForStkCirAreaChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute");
            }
            else if ((showOrHideTableForStkCirAreaChart == false) && (showOrHideCommentsForStkCirAreaChart == false)){
                divLegendPanelStkCirAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                
                svgPanelForStkCirAreaChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute");
            }
        })
        
        var reRenderChartAndTableButton = filterPanelForStkCirAreaChart.append("button").style("width","120px").style("height","25px").style('position','absolute')
        .style('margin-left','112px').style('margin-top','298px') .style("border-style", "none").style('background-color',"#2196f3")
        .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','15px').style("border-style", "solid").style('color','#ffffff')
        .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 1px #9b9b9b").style("border-radius","0px")
        var textForReRenderButton = document.createTextNode("Apply Changes");
        reRenderChartAndTableButton[0][0].appendChild(textForReRenderButton)
        
        reRenderChartAndTableButton.on("click", function(){
                                       
               if( $("#sortable3"+targetElement[0][0].id).children("li").length == 0 )
               {
                   
                   var alertPageDisabledDivForStkCirAreaChart =targetElement.append('div').style('width',100 + '%')
                   .style('height',100 + "%").style('position','absolute').style('margin-left', '0px').style('top', '0px')
                   .style("background-color",'#f3f3f3').style("z-index",99)//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                   .style("opacity",0.2).style("display","block")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
                   
                   var alertDivForStkCirAreaChart = targetElement.append('div').style('width','350px')
                   .style('height',"150px").style('position','absolute').style('left', ((targetElement[0][0].clientWidth/2) - 175) + "px").style('top', '1px')
                   .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "solid").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                   .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","0px")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
                   //.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Bold;">Sorry, no result found for selected' + 'range!'+ '</br>' + '<label style=text-indent:10px;> Hello</label' +'</div>')
                   .html('<p  style="width: 340px; height:0%; background-color:#c7c7c7; position: absolute; top:40.0%; font-size:14px; font-family:inter; font-weight:Bold; margin-left:10px;  color:#f8f8f8; font-weight:Normal;">Check whether the Selected Measures box is not empty!</p>')
                   
                   var alertDivTitleForStkCirAreaChart = alertDivForStkCirAreaChart.append('div').style('width','340px')
                   .style('height',"30px").style('position','absolute').style('margin-left', "0px").style('top', '0px')
                   .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "none").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                   .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","2px")
                   .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; font-weight:Bold; text-indent:5px;  color:#e5e5e5; font-weight:Normal;">TimeBound</div>')
                   
                   var StkCirAreaChartAlertOKButton = alertDivForStkCirAreaChart.append("button") .style("width","40px") .style("height","20px") .style('position','absolute') .style("box-shadow", "0px 1px 1px #B8B8B8")
                   .style('background-color',"#7cc15e") .style('margin-left','300px') .style('top', "120px").style("color","#ffffff")
                   .style("display","block").style('padding-top',"0px").style("cursor","pointer").style("box-shadow", "1px 1px 1px #56973a") .style("border-style", "none")
                   .style("font-family","Verdana,sans-serif").style("font-size","14px").style("text-align","center").style("vertical-align","middle").style("border-radius","0px")
                   .style("z-index",999)
                   
                   var textForStkCirAreaChartAlertOKButton = document.createTextNode("OK");
                   StkCirAreaChartAlertOKButton[0][0].appendChild(textForStkCirAreaChartAlertOKButton)
                   
                   $("#"+targetElement[0][0].id).resizable('disable');
                   
                   StkCirAreaChartAlertOKButton.on('click', function() {
                       alertDivForStkCirAreaChart.remove();
                       alertPageDisabledDivForStkCirAreaChart.remove()
                       $("#"+targetElement[0][0].id).resizable('enable');
                   })
                   
                   filterBtnForStkCirAreaChart.style("cursor","pointer")
                   
                   if(showOrHideTableForStkCirAreaChart == false){
                       svgPanelForStkCirAreaChart.style('width', 75 + "%") .style('height', 85 + "%").style("position","absolute")
                       divLegendPanelStkCirAreaChart.style('width', 25 + "%") .style('height', 85 + "%").style("position","absolute")
                   }
                   else if(showOrHideTableForStkCirAreaChart == true){
                       svgPanelForStkCirAreaChart.style('width', 75 + "%") .style('height', 52 + "%").style("position","absolute")
                       divLegendPanelStkCirAreaChart.style('width', 25 + "%") .style('height', 52 + "%").style("position","absolute")
                   }
                   
                   resizedFuctionForStkCirAreaChart();
               }
                   
               else{
                   
                   var selectedStackMeasures = [];
                   for(var i=0; i<$("#sortable3"+targetElement[0][0].id).children("li").length;i++){
                       selectedStackMeasures.push($("#sortable3"+targetElement[0][0].id).children("li")[i].textContent)
                   }
                   
                   var newOptions = {
                       data: options.data,
                       dataForDrillDown:options.dataForDrillDown,
                       dataForTable:options.dataForTable,
                       isDataDetailedForTable: options.isDataDetailedForTable,
                       keys: {
                           label: options.keys.label,//$("#sortable4"+targetElement[0][0].id).children("li")[0].textContent.toString(),
                           stackedAreas: selectedStackMeasures,
                       },
                       chartTitle:options.chartTitle,
                       xAxisLable: options.keys.label,//$("#sortable4"+targetElement[0][0].id).children("li")[0].textContent,
                       yAxisLable: "",
                       showTitle: true,
                       colorSet: options.colorSet,
                       drillDownColumnName:options.drillDownColumnName,
                       showTable: options.showTable,
                       showComments: options.showComments,
                       comments: options.comments,
                       resizeButtonID: options.resizeButtonID //document.getElementById("resizeBtn").id
                   }
                   
                   d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                   acinfotech.stackedCircularAreaChart(targetElement,newOptions)
               }
                                       
           })
        
        var textBoxForMeasureColumnFrom;
        var textBoxForMeasureColumnTo;
        var selectTitleDivForEachDimension;
        
        
        $( "ul.droptrue"+targetElement[0][0].id ).sortable({
               appendTo: document.body,
               helper: "clone",
               connectWith: ".droptrue"+targetElement[0][0].id,
               scroll: false,
               cancel: '.unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+','+' .unMoveableIconAndTextClassDimensions'+targetElement[0][0].id,
               revertDuration: 10,
               scrollSensitivity: 10,
               scrollSpeed: 1,
               dynamic: true,
               
               receive: function(e, ui) {
               
               if (($(this)[0].id == "sortable3"+targetElement[0][0].id) || ($(this)[0].id == "sortable1"+targetElement[0][0].id)) {
               
                   if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                       if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                           (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                       }
                       else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                           (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                       }
               
                   }
                } // if (($(this)[0].id == "sortable3") || ($(this)[0].id == "sortable1"))
               
               else if (($(this)[0].id == "sortable2"+targetElement[0][0].id) || ($(this)[0].id == "sortable4"+targetElement[0][0].id)) {
                   if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                   //ui.sender.sortable("cancel");
               
                       if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                           (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                       }
                       else if(  ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                           (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                       }
                   }
               } //if (($(this)[0].id == "sortable2") || ($(this)[0].id == "sortable4")) {
               
               $(ui.item).css({ 'position': 'relative' });
               
               if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                   ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
               }
               
               else if ($(this)[0].id == "sortable3"+targetElement[0][0].id) { // checking if the dropped element is in Measures drop area
               
                   if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                   ui.sender.sortable("cancel");
               }
               else {
                   //ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
               }
               
               } // else if ($(this)[0].id == "sortable3") // checking if the dropped element is in Measures drop area ends here.
               
               else if ($(this)[0].id == "sortable4"+targetElement[0][0].id) { // checking if the dropped element is in Dimension drop area
               
                   if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                       ui.sender.sortable("cancel");
                   }
                   else {
                       ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                   }
               } //else if ($(this)[0].id == "sortable4")  // checking if the dropped element is in Dimension drop area ends here
               
               if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
               
                   if ($(this)[0].id == "sortable1"+targetElement[0][0].id){
                       if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
               
                           if( ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                               ui.sender.sortable("cancel");
                           } // if(  ui.sender.attr("id") === "sortable4")
               
                           else if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                               ui.sender.sortable("cancel");
                           }
               
                       } // if(ui.item.hasClass("DimesionsClass"))
                   }
                   if ($(this)[0].id == "sortable2"+targetElement[0][0].id){
                       if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                   
                           if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                               ui.sender.sortable("cancel");
                           }
                           else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                               ui.sender.sortable("cancel");
                   
                           }
                       }
                   }
               
               } //if ($(this)[0].id == "sortable1")
               
				if ($(this)[0].id == "sortable4"+targetElement[0][0].id){
					if ($(this).children('li').length > 1 ){
						ui.sender.sortable("cancel");
						ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
					}
                }
               
               }, //receive ends here
               
               start:function(ev, ui) {
               
               },
               stop:function(ev, ui) {
               
               },
           });
        
        // ----------------- Filter panel and everything within it section ends here -----------------
        
        // if chart is changed (before or after resize button click)
        var optionsKey = {};
        if(options.keys.stackedAreas == undefined){
            optionsKey["label"] = options.keys.label;
            optionsKey["stackedAreas"] = options.keys.groupBars;
            
            options.keys = {};
            options.keys["label"] = optionsKey.label
            options.keys["stackedAreas"] = optionsKey.stackedAreas
        }
        
        var data = [], temp = {};
        for(var i = 0; i < options.keys.stackedAreas.length; i++){
            options.data.forEach(function(d,j){
                temp["key"] = options.keys.stackedAreas[i];
                temp["value"] = +d[options.keys.stackedAreas[i]];
                temp["axis"] = j;
                temp["colorCount"] = i;
                data.push(temp);
                temp = {};
                })
        }
        
        
        var outerRadius = Math.min(width, height) / 2.40, innerRadius = 0;
        
        if(options.data.length <= 2){ var angle = d3.scale.linear() .domain([0, d3.max(data.map(function(d) { return +d.value; }))]).range([0, 1 * Math.PI]); }
        else { var angle = d3.scale.linear() .domain([0, d3.max(data.map(function(d) { return +d.value; }))]).range([0, 2 * Math.PI]); }
        
        var radius = d3.scale.linear().domain([0, d3.max(data.map(function(d) { return +d.value; }))]).range([innerRadius, outerRadius]);
        
        var stack = d3.layout.stack().offset("zero") .values(function(d) { return d.values; }) .x(function(d) { return d.axis; }) .y(function(d) { return d.value; });
        
        var nest = d3.nest() .key(function(d) { return d.key; });
        
        var line = d3.svg.line.radial() .interpolate("cardinal-closed") .angle(function(d) { return angle(d.axis); }) .radius(function(d) { return radius(d.y0 + d.y); });
        
        if(options.data.length <= 2){
            var area = d3.svg.area.radial() .interpolate("linear") .angle(function(d) { return angle(d.axis); }) .innerRadius(function(d) { return radius(d.y0); })
            .outerRadius(function(d) { return radius(d.y0 + d.y); });
        }
        else {
            var area = d3.svg.area.radial() .interpolate("cardinal-closed") .angle(function(d) { return angle(d.axis); }) .innerRadius(function(d) { return radius(d.y0); })
            .outerRadius(function(d) { return radius(d.y0 + d.y); });
        }
        
        var svg = svgPanelForStkCirAreaChart.append("svg") .attr("width", "100%") .attr("height", "100%") .append("g") .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");
        
        var yScale = d3.scale.linear() .domain([0, d3.max(data.map(function(d) { return +d.value }))]) .range([innerRadius, outerRadius]);
        var layers = stack(nest.entries(data));
        
        angle.domain([0, d3.max(data, function(d) { return d.axis + 1; })]);
        radius.domain([0, d3.max(data, function(d) { return d.y0 + d.y; })]);
        
        var areas = svg.selectAll(".layer")
        .data(layers)
        .enter().append("path")
        .attr("class", "layer")
        .attr("d", function(d) { return area(d.values); })
        .style("fill", function(d, i) { return "#f8f8f8"; })
		.transition().delay(400).duration(800)
        .style("fill", function(d, i) { return colours(i); });
        
        svg.selectAll(".axis")
        .data(d3.range(options.data.length))
        .enter().append("g")
        .attr("class", "axis")//.transition() .duration(1800)
        .attr("transform", function(d) { return "rotate(" + angle(d) * 180 / Math.PI + ")"; });
        svg.selectAll(".axis")
        .call(d3.svg.axis()
              .scale(yScale.copy().range([-innerRadius, -outerRadius])).ticks(5)
              .orient("left")).style("fill","#00001c").style("font-family","Verdana,sans-serif")
        
        var circularText = svg.selectAll(".axis").append("text")
        .attr("y", (-innerRadius - innerRadius) - (outerRadius + 15))
        .attr("dy", ".71em")
        .attr("text-anchor", "middle")
        .text(function(d,i) { return options.data[i][options.keys.label].toString().substring(0,15); }).style("fill","#00001c").style("font-weight","bold");
        
        svg.selectAll(".axis path").style("stroke-width","1px")
        svg.selectAll(".axis + .axis g text").style("display","none")
        
        // Creating Circles
        var circles = svg.selectAll(".circle") .data(data) .enter() .append("svg:circle") .attr("class", "circle")
        .attr("cx", function (d, i) { return 0; }) .attr("cy", function (d, i) { return radius( d.y + d.y0 ); })
        .attr("transform", function(d) { return "rotate(" + angle(d.axis + (options.data.length/2)) * 180 / Math.PI + ")"; })
        .attr("r", 0.0) .style("fill","#ffffff") .style("stroke", function(d, i) { return "#ffffff"; }) .style("cursor","auto")
        
        /*if(options.dataForDrillDown.length == 0){
         
            var columnNames = d3.keys(options.data[0])
            var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
         
            for(var i = 0; i < columnNames.length ; i++){
                for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                    if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                        for(var k = 0; k < options.keys.stackedBars.length; k++){
                            var len = d3.select(groupsForStkCirAreaChart[0][k]).selectAll('rect')
                            for(var l = 0; l < len[0].length; l++){
                                d3.select(len[0][l]).attr('data-drilldownkey', function(d,index){
                                    return JSON.stringify(options.data[l]).slice(1, -1).split('"').join("").split(':').join("|")
                                })
                            }
                        }
                    }
                    else {
                    }
                }
            }
            
        }
        else if(options.dataForDrillDown.length > 0){
            
            options.keys.stackedBars.forEach(function(measures, i) {
                                             var bars = d3.select(groupsForStkCirAreaChart[0][i]).selectAll('rect')
                                             bars[0].forEach(function(d, index) {
                                                             var dd = d3.select(d)[0]
                                                             options.dataForDrillDown.forEach(function(val, i) {
                                                                                              var key, keys = Object.keys(val), n = keys.length, newObj={}
                                                                                              while (n--) { key = keys[n]; newObj[key.toLowerCase()] = val[key]; }
                                                                                              var optKeysLabVal = options.keys.label.toString().toLowerCase();
                                                                                              if(dd[0].__data__.y.toString().toLowerCase() === newObj[optKeysLabVal].toString().toLowerCase()){
                                                                                              //if(dd[0].__data__.x == val[measures]){
                                                                                              if(dd[0].__data__.x == newObj[measures.toLowerCase()]){
                                                                                              d3.select(dd[0]).attr('data-drilldownkey', function(d,index){
                                                                                                                    return JSON.stringify(val).slice(1, -1).split('"').join("").split(':').join("|")
                                                                                                                    })
                                                                                              }
                                                                                              }
                                                                                              })
                                                             })
                                             })
        }*/
        
        
        //----------- adding legend section ----------
        var divLegendPanelStkCirAreaChart = targetElement .append('div')  .attr("class","divLegendPanelClassForStkCirAreaChart")
        .style('background-color',"#ffffff") .style('position',"absolute")
        //.style('width', 25 + "%") .style('height', 92 + "%") .style("left",75 + "%").style("top",8 + "%")
        
        if(options.showTitle == true){
            
            if ((showOrHideTableForStkCirAreaChart == false) && (showOrHideCommentsForStkCirAreaChart == true)){
                divLegendPanelStkCirAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                
                svgPanelForStkCirAreaChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute");
            }
            else if ((showOrHideTableForStkCirAreaChart == true) && (showOrHideCommentsForStkCirAreaChart == false)){
                divLegendPanelStkCirAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                
                svgPanelForStkCirAreaChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute");
            }
            else if ((showOrHideTableForStkCirAreaChart == false) && (showOrHideCommentsForStkCirAreaChart == false)){
                divLegendPanelStkCirAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                
                svgPanelForStkCirAreaChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute");
            }
            
        }
        else if(options.showTitle == false){
            
            if ((showOrHideTableForStkCirAreaChart == false) && (showOrHideCommentsForStkCirAreaChart == true)){
                divLegendPanelStkCirAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                
                svgPanelForStkCirAreaChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute");
            }
            else if ((showOrHideTableForStkCirAreaChart == true) && (showOrHideCommentsForStkCirAreaChart == false)){
                divLegendPanelStkCirAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                
                svgPanelForStkCirAreaChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute");
            }
            else if ((showOrHideTableForStkCirAreaChart == false) && (showOrHideCommentsForStkCirAreaChart == false)){
                divLegendPanelStkCirAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                
                svgPanelForStkCirAreaChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute");
            }
        }
        
        var legendPanelSvgForStkCirAreaChart = divLegendPanelStkCirAreaChart .append('svg')  .attr("class","").style('background-color',"#ffffff") .style('position',"absolute")
        .style('width', 100 + "%") .style('height', 100 + "%") .style("left",0 + "%").style("top",0 + "%")

        var legend = legendPanelSvgForStkCirAreaChart.append("g") .attr("class", "legend") .attr("height", "100%") .attr("width", "100%")
        .attr('transform', 'translate(0,20)')
        
        //Create colour squares
        var legendGroup = legend.selectAll('rect') .data(options.keys.stackedAreas) .enter() .append("rect") .attr("x", 5)
        .attr("y", function(d, i){ return i * 16;}) .attr("width", 14) .attr("height", 14) .attr("rx",10) .attr("ry",10)
        .style("fill", function(d, i){ return colours(i);}) .style("cursor","auto")
        
        
        //Create text next to squares
        legend.selectAll('text') .data(options.keys.stackedAreas) .enter() .append("text") .attr("x", 25) .attr("y", function(d, i){ return i * 16 + 12;})
        .attr("fill", "#00001c") .text(function(d,i) { if(d.length > 10)
            return d.substring(0,10)+'...';
            else
            return d;}) .style('font-size', '14px') .attr("fill","#00001c") .style("font-family","Verdana,sans-serif")
        
        // Aligning Legend (vertically)
        var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelStkCirAreaChart[0][0].style.width) / 100)
        var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelStkCirAreaChart[0][0].style.height) / 100)
        
        var legendRectSize = 11;
        var legendSpacing = 4;
        
        legend.transition().duration(0).attr('transform', function(d, i) {
             var eachRectHeight = legendRectSize + legendSpacing;
             var offset =  eachRectHeight * colours.domain().length / 2;
             var horz = 0;
             var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.stackedAreas.length))/2.0; // originally 2.0
             
             return 'translate(' + horz + ',' + vert + ')';
         })
        
        legendGroup.on('mouseover',function(d,i){
            for(var j = 0; j < areas[0].length; j++){
                if(j == i){ d3.select(areas[0][j]).style("fill-opacity",1) }
                else { d3.select(areas[0][j]).style("fill-opacity",0.2) }
            }
        })
        
        legendGroup.on('mouseout',function(d,i){
            for(var j = 0; j < areas[0].length; j++){
                d3.select(areas[0][j]).style("fill-opacity",1)
            }
        })
        
        
        //---------creating tooltip----
        var tooltipForStkCirAreaChart = targetElement .append('div') .attr('class', 'tooltipPie') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
        .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
        .style("padding-right", "7px") .style("background", "#F8F8F8") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style("z-index",1000)
        .style("border", "1.0px") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","60px")
        tooltipForStkCirAreaChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'label').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "14px") .style("font-weight", "normal");
        tooltipForStkCirAreaChart.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
        tooltipForStkCirAreaChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");
        
        
        circles.on('mousemove', function (d,i){
               var colorCode = colours(d.colorCount);
               var root = targetElement
               var m = d3.mouse(root.node());
               m[0] += 0
               m[1] += 0

                var valueForStkCirAreaChartToolTip;
                if(d.value.toString().indexOf('.') === -1)
                {
                    valueForStkCirAreaChartToolTip = d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
                else{

                    valueForStkCirAreaChartToolTip = d.value;
                }

               tooltipForStkCirAreaChart.select('.label').html(d.key)
               //tooltipForStkCirAreaChart.select('.count').html(d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
               tooltipForStkCirAreaChart.select('.count').html(valueForStkCirAreaChartToolTip)
               tooltipForStkCirAreaChart.style('visibility', 'visible')
               tooltipForStkCirAreaChart.select('hr').style("background-color", function(d,i){ return colorCode;} )
               tooltipForStkCirAreaChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-10) + "px").style("display","block")
                   
        })
        
        .on('mouseout', function(){ tooltipForStkCirAreaChart.style("display","none") })
        
        // ----------------------- adding table section ------------------
        var tablePanelForStackedChart =  targetElement.append("div") .attr("id",targetElement[0][0].id + "holderForStackedChartTableID")
        .attr("class","scrollingDivForTable-Class tableDivForStkCirAreaChart" + targetElement[0][0].id) .style('background-color',options.BGcolor)  .style('position','absolute')
        .style("display","block") .style("overflow","hidden") .style("width", function(d) {  return 100.0 + "%"; })
        .style("height", function(d) { return 40 + "%"; }) .style("left",0 + "%").style("z-index",10)
        
        $( '.tableDivForStkCirAreaChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
                var e0 = e.originalEvent,
                delta = e0.wheelDelta || -e0.detail;
                
                this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
                e.preventDefault();
        });
        
        if(options.showTitle == true ){
            tablePanelForStackedChart.style("top",60.0  + "%")
        }
        else if(options.showTitle == false  ){
            tablePanelForStackedChart.style("top",60.0  + "%")
            
        }
        tablePanelForStackedChart.html('<table class = "tableClassForStackedChart' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                       '<thead class = "theadClassForStackedChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForStackedChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                                       '<tbody class = "tBodyClassForStackedChart' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                       '</table>'
                                       )
        
        tablePanelForStackedChart.select('table').attr("id",targetElement[0][0].id + "tableID")
        
        // Show or Hide Table scroll bar when mouseover on widget
        targetElement.on('mouseover',function(){ tablePanelForStackedChart.style("overflow","auto") })
        targetElement.on('mouseout',function(d){ tablePanelForStackedChart.style("overflow","hidden") })
        
        var tableDataForStkCirAreaChart = [];
        if(options.dataForTable.length > 0){
            tableDataForStkCirAreaChart = options.dataForTable;
        }
        else {
            tableDataForStkCirAreaChart = options.data;
        }
        
        var thead = tablePanelForStackedChart.select("thead").selectAll("th") .data(d3.keys(tableDataForStkCirAreaChart[0]))
        .enter().append("th") .text(function(d){return d.charAt(0) .toUpperCase() + d.substr(1)}) .style("cursor","pointer") .style("min-width","100px")
        
        var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff") //f4f4f4
        .style("position","relative")
        
        var thead1 = d3.select(".thead1ClassForStackedChart" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tableDataForStkCirAreaChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff") //f4f4f4
        .style("position","relative")
        
        var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
        .attr("id", "ascendingIconIDForStkCirAreaChart") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
        
        var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
        .attr("id", "descendingIconIDForStkCirAreaChart") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
        
        var tr = tablePanelForStackedChart.select("tbody").selectAll("tr") .data(tableDataForStkCirAreaChart).enter().append("tr")
        .attr("id", function(d,i) { return "slice" + i })
        
        // cells
        var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d})
        .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
        
        var $table = $('.tableClassForStackedChart' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
        
        d3.select(".theadClassForStackedChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
            d.forEach(function(dd,j){
				colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
			})
		})
        
        $(".thead1ClassForStackedChart" + targetElement[0][0].id).insertAfter('.tBodyClassForStackedChart' + targetElement[0][0].id)
        
        $(".thead1ClassForStackedChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForStkCirAreaChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
        
        tablePanelForStackedChart.select(".thead1ClassForStackedChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                 d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
             })
        
        $('.tableDivForStkCirAreaChart' + targetElement[0][0].id).scroll(function () {
                                                                         
                 $(".thead1ClassForStackedChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForStkCirAreaChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
                 
         })
        
        var sortOrder = false;
        thead1.on("click",function(k,index){
                  
                  sortOrder = !sortOrder;
                  
                  tablePanelForStackedChart.select(".thead1ClassForStackedChart" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                                                                                                                                
                        if (sortOrder) {
                        
                        if(i == index){
                            d3.select(this).select('svg').select('#descendingIconIDForStkCirAreaChart').style("visibility", "hidden")
                            d3.select(this).select('svg').select('#ascendingIconIDForStkCirAreaChart').style("visibility", "visible")
                        }
                        else {
                            d3.select(this).select('svg').select('#descendingIconIDForStkCirAreaChart').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForStkCirAreaChart').style("visibility", "visible")
                        }
                        }
                        else{
                        
                        if(i == index){
                            d3.select(this).select('svg').select('#descendingIconIDForStkCirAreaChart').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForStkCirAreaChart').style("visibility", "hidden")
                        }
                        else {
                            d3.select(this).select('svg').select('#descendingIconIDForStkCirAreaChart').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForStkCirAreaChart').style("visibility", "visible")
                        }
                        }
                })
                  
                  var monthTruOrFalAryForStkCirAreaChart = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
                  
                  tr.sort(function(a, b) {
                          
                          if (sortOrder) {
                              var monthsArrayForStkCirAreaChart = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                          } else {
                              var monthsArrayForStkCirAreaChart = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                          }
                          
                          monthTruOrFalAryForStkCirAreaChart = []; gotMonthArray = [];
                          tableDataForStkCirAreaChart.forEach(function(d,i){
                              var da = d[k].toString().substring(0,3).toLowerCase()
                              if(monthsArrayForStkCirAreaChart.indexOf(da) >= 0){
                                  monthTruOrFalAryForStkCirAreaChart.push(true)
                                  gotMonthArray.push(da);
                              }
                              else {
                                  monthTruOrFalAryForStkCirAreaChart.push(false)
                              }
                          })
                          
                          if(monthTruOrFalAryForStkCirAreaChart.indexOf(false) == -1){ // true
                          
                          monthArray = []; monthArrayCount = [];
                          gotMonthArray.forEach(function(dd,j){
                            var index1 = monthsArrayForStkCirAreaChart.indexOf(dd.substring(0,3))
                            if(monthArrayCount.indexOf(index1) >= 0){
                                index1 = 12 + index1;
                            }
                            monthArray.push(index1);
                            monthArrayCount.push(index1)
                            })
                          returnArray = []
                          monthArray.sort(function(aa, bb) {
                              returnArray.push(+aa - +bb)
                              return +aa - +bb;
                          })
                          
                          sortTableFunc()
                          return returnArray[ind++];
                          } //  if true (if jan feb if block)
                          else {
                               var data = +a[k];
                              
                              if(!isNaN(data)){
                              
                                  if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                                  else { return d3.descending(+a[k], +b[k]); }
                              }
                              else if(!isNaN(Date.parse(a[k]))){
                              
                                  if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                                  else { return new Date(b[k]) - new Date(a[k]) }
                              }
                              else {
                              
                                  if (sortOrder) { return d3.ascending(a[k], b[k]); }
                                  else { return d3.descending(a[k], b[k]); }
                              }
                          } // if not jan feb else block
                  }); // tr

		})
        
        function sortTableFunc(){
            
            var table = tablePanelForStackedChart.select('table');
            var rows = table.selectAll('tr').data(tableDataForStkCirAreaChart);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0).style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500)
            .style('opacity', 1.0).style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
        }
        
        // Main Table Styling
        tablePanelForStackedChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
        .style("color","#00001c")
        .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4") //.style("box-shadow","10px 10px 50px #007aff").style("z-index",9999)
        tablePanelForStackedChart.selectAll('td').style("height","25px") .style("border", "1px solid #dddddd") .style("font-size","12px").style("font-weight","Normal").style("color","#00001c")
        
        //additionally 
        tablePanelForStackedChart.selectAll('th').style('background-color',"#ffffff").style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
        tablePanelForStackedChart.selectAll('td').style('background-color',"#ffffff").style("border-style","none").style("color","#00001c")
        
        //b1da9f
        tablePanelForStackedChart.selectAll('table') . style("border-collapse","collapse")
        tablePanelForStackedChart.selectAll('table tr:first-child th').style("border-top","0px")
        tablePanelForStackedChart.selectAll('table tr:last-child td').style("border-bottom","0px")
        tablePanelForStackedChart.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
        tablePanelForStackedChart.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")
        
        if(showOrHideTableForStkCirAreaChart == false){
            tablePanelForStackedChart.style("display","none")
        }
        else if(showOrHideTableForStkCirAreaChart == true){
            tablePanelForStackedChart.style("display","block")
        }
        
        if(options.isDataDetailedForTable == false){
            
            var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
            
            // Adding underlines for selected drill-down column text
            var drillDownSectionsForStackedChart = tablePanelForStackedChart.select('table').selectAll('th')
            
            var foundResult = [];
            for(var i = 0; i<drillDownSectionsForStackedChart[0].length; i++){
                
                for(var j = 0; j<drillDownColumnNamesArray.length; j++){
                    if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForStackedChart[0][i].__data__.toString().toLowerCase() ){
                        foundResult.push(i)
                    }
                }
            }
            
            var r = tablePanelForStackedChart.select('table').selectAll('tr').selectAll('td')
            for(var i = 0; i<r.length; i++){
                for(var j = 0; j < foundResult.length; j++){
                    var row = r[i][foundResult[j]]
                    $(row).css("text-decoration", "underline")
                }
            }
        }
        
        //By default calling the resized function first time (to align table's th and td).
        setTimeout(function(){ resizedFuctionForStkCirAreaChart() },1000)
        
        window.addEventListener('resize', function(event){ resizedFuctionForStkCirAreaChart() });
        
        var xScale1GlobalVar;
        var yScale1GlobalVar;
        var newHeightVar;
        
        $(function() {
          
          $("#" + targetElement[0][0].id).resizable({
                resize: function(event, ui) {
                    //divWidthForHoriChart = ui.size.width;
                    //divHeightForHoriChart = ui.size.height;
                    resizedFuctionForStkCirAreaChart();
                }
          });
        });
        
        function resizedFuctionForStkCirAreaChart()
        {
            
            if((svgPanelForStkCirAreaChart.node().getBoundingClientRect().width) && (svgPanelForStkCirAreaChart.node().getBoundingClientRect().height) > 0){
                
                if(showOrHideCommentsBtnForStkCirAreaChart == true){
                    grpBarBtnForStkCirAreaChart.style('margin-left', "2px")
                    horiGrpBarBtnForStkCirAreaChart.style('margin-left', "2px")
                    filterBtnForStkCirAreaChart.style('margin-left', "2px")
                    refreshBtnForStkCirAreaChart.style('margin-left', "2px")
                    commentsBtnForStkCirAreaChart.style('margin-left', "2px")
                    menuBtnForStkCirAreaChart.style('right', '0')
                }
                else if(showOrHideCommentsBtnForStkCirAreaChart == false){
                    grpBarBtnForStkCirAreaChart.style('margin-left', "2px")
                    horiGrpBarBtnForStkCirAreaChart.style('margin-left', "2px")
                    filterBtnForStkCirAreaChart.style('margin-left', "2px")
                    refreshBtnForStkCirAreaChart.style('margin-left', "2px")
                    //commentsBtnForStkCirAreaChart.style('right', '0')
                    commentsBtnForStkCirAreaChart.style('display','none')
                    menuBtnForStkCirAreaChart.style('right', '0')
                }
                
                optsBtnPanelForStkCirAreaChart.style('right', '0')
                
                stgPanCanBtnForStkCirAreaChart.style('right', '0')
                
                if(options.showTitle == true){
                    
                    var margin1 = {top: 0 , right: 0, bottom: 0, left: 0}, //originally top: 42, left: 80
                    width = (svgPanelForStkCirAreaChart.node().getBoundingClientRect().width) - margin.left - margin.right,
                    height = (svgPanelForStkCirAreaChart.node().getBoundingClientRect().height) - margin.top - margin.bottom;
                    //newHeightVar = height
                }
                else if(options.showTitle == false){
                    
                    var margin1 = {top: 0 , right: 0, bottom: 0, left: 0}, //originally top: 42, left: 80
                    width = (svgPanelForStkCirAreaChart.node().getBoundingClientRect().width) - margin.left - margin.right,
                    height = svgPanelForStkCirAreaChart.node().getBoundingClientRect().height - margin.top - margin.bottom;
                    //newHeightVar = height
                }
                
                outerRadius = Math.min(width, height) / 2.40;
                innerRadius = 0;
                
                svg.attr("transform", "translate(" + width / 2 + "," + height / 2 + ")")
                
                //angle.domain([0, d3.max(data.map(function(d) { return +d.value; }))]).range([0, 2 * Math.PI]);
                if(options.data.length <= 2){ angle.domain([0, d3.max(data.map(function(d) { return +d.value; }))]).range([0, 1 * Math.PI]) }
                else { angle.domain([0, d3.max(data.map(function(d) { return +d.value; }))]).range([0, 2 * Math.PI]) }
                
                radius.domain([0, d3.max(data.map(function(d) { return +d.value; }))]).range([innerRadius, outerRadius]);
                
                line.angle(function(d) { return angle(d.axis); }) .radius(function(d) { return radius(d.y0 + d.y); });
                
                area.angle(function(d) { return angle(d.axis); }) .innerRadius(function(d) { return radius(d.y0); }) .outerRadius(function(d) { return radius(d.y0 + d.y); });
                
                yScale.domain([0, d3.max(data.map(function(d) { return +d.value }))]) .range([innerRadius, outerRadius]);
                layers = stack(nest.entries(data));
                
                angle.domain([0, d3.max(data, function(d) { return d.axis + 1; })]);
                radius.domain([0, d3.max(data, function(d) { return d.y0 + d.y; })]);
                
                svg.selectAll(".layer").attr("d", function(d) { return area(d.values); })
                
                svg.selectAll(".axis").attr("transform", function(d) { return "rotate(" + angle(d) * 180 / Math.PI + ")"; })
                .call(d3.svg.axis().scale(yScale.copy().range([-innerRadius, -outerRadius])).ticks(5).orient("left"))
                
                circularText.attr("y", (-innerRadius - innerRadius) - (outerRadius + 15)).attr("dy", ".71em")
                
                circles.attr("cx", function (d, i) { return 0; }) .attr("cy", function (d, i) { return radius( d.y + d.y0 ); })
                .attr("transform", function(d) { return "rotate(" + angle(d.axis + (options.data.length/2)) * 180 / Math.PI + ")"; })
                
                
                // Aligning Legend (vertically)
                var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelStkCirAreaChart[0][0].style.width) / 100)
                var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelStkCirAreaChart[0][0].style.height) / 100)
                
                var legendRectSize = 11;
                var legendSpacing = 4;
                
                legend.attr('transform', function(d, i) {
                    var eachRectHeight = legendRectSize + legendSpacing;
                    var offset =  eachRectHeight * colours.domain().length / 2;
                    var horz = 0;
                    var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.stackedAreas.length))/2.0; // originally 2.0
                    
                    return 'translate(' + horz + ',' + vert + ')';
                })
                
                colWidth = []; 
				
                d3.select(".theadClassForStackedChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                    d.forEach(function(dd,j){
                        colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                    })
                })
                tablePanelForStackedChart.select(".thead1ClassForStackedChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                        d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
                })
                
            }// checking svg panel width & height greater than zero function
            
        }
    }, //StkCirAreaChart
    
    // ************************************************** Percentage Area Chart  **************************************************
    percentageAreaChart: function(targetElement, options){
        
        isChartCalled++;
        
        var chartName = "PERCENTAGEAREACHART";
        
        acinfotech.allCharts(targetElement,options,chartName);
        
        targetElement.style("min-width","350px").style("min-height","350px").style("background-color", options.BGcolor)
        
        var showOrHideTableForPerAreaChart;
        var showOrHideCommentsForPerAreaChart;
        var showOrHideCommentsBtnForPerAreaChart = true;
        
        if((options.showTable == false) || (options.showTable == true)){
            showOrHideTableForPerAreaChart = options.showTable
        }
        else{
            showOrHideTableForPerAreaChart = false;
        }
        
        // Show or Hide comments
        if (options.showComments == true || false) {
            showOrHideCommentsForPerAreaChart = options.showComments;
        }
        else {
            showOrHideCommentsForPerAreaChart = false;
        }
        
        if (options.comments.length == 0){
            showOrHideCommentsForPerAreaChart = false;
            showOrHideCommentsBtnForPerAreaChart = false;
        }
        
        if ((showOrHideTableForPerAreaChart == true) && (showOrHideCommentsForPerAreaChart == true)){
            showOrHideTableForStkBarChart = true;
            showOrHideCommentsForPerAreaChart = false;
        }
        else if ((showOrHideTableForPerAreaChart == false) && (showOrHideCommentsForPerAreaChart == false)){
            showOrHideTableForStkBarChart = false;
            showOrHideCommentsForPerAreaChart = false;
        }
        
        var divWidth, divHeight;
        
        var chartTitlePanelForPerAreaChart = targetElement.append("div") .style("position","absolute").style("background-color", options.BGcolor) .style("text-indent","6px") .style("border", "none")
        
		var optsBtnPanelForPerAreaChart = targetElement.append('div').style('width',"25px").style('height',"180px").style('position','absolute')
        .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px")
        .style('right', '0') .style("min-width","25px") .style("border-style","none")
        .style("border-left", "solid #fcfcfc  1px")
		
        var areaButtonForPerAreaChart = optsBtnPanelForPerAreaChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style("background-color", options.BGcolor).style("z-index",10)
        .style('top','80px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var areaBtnImgVar = document.createElement("IMG");
        areaBtnImgVar.src = "images/curveAreaIcon.png";
        areaBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:15px; opacity:0.8;")
        areaButtonForPerAreaChart[0][0].appendChild(areaBtnImgVar)
        
        var filterButtonForPerAreaChart = optsBtnPanelForPerAreaChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','105px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var filterBtnImgVar = document.createElement("IMG");
        filterBtnImgVar.src = "images/filterIcon.png";
        filterBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        filterButtonForPerAreaChart[0][0].appendChild(filterBtnImgVar)
        
        var refreshButtonForPerAreaChart = optsBtnPanelForPerAreaChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','130px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var refreshBtnImgVar = document.createElement("IMG");
        refreshBtnImgVar.src = "images/refreshIcon.png";
        refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        refreshButtonForPerAreaChart[0][0].appendChild(refreshBtnImgVar)
        
        var commentsBtnForPerAreaChart = optsBtnPanelForPerAreaChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','155px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var commentsBtnImgVariable = document.createElement("IMG");
        if(options.showComments == false){
            commentsBtnImgVariable.src = "images/showCommentsIcon.png";
        }
        else if(options.showComments == true){
            commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
        }
        commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        commentsBtnForPerAreaChart[0][0].appendChild(commentsBtnImgVariable)
        
        var menuButtonForPerAreaChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','1px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var menuBtnImgVar = document.createElement("IMG");
        menuBtnImgVar.src = "images/menuIcon.png";
        menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
        menuButtonForPerAreaChart[0][0].appendChild(menuBtnImgVar)
        
        if(showOrHideCommentsBtnForPerAreaChart == true){
            areaButtonForPerAreaChart.style('margin-left', "2px")
            filterButtonForPerAreaChart.style('margin-left', "2px")
            refreshButtonForPerAreaChart.style('margin-left', "2px")
            commentsBtnForPerAreaChart.style('margin-left', "2px")
            menuButtonForPerAreaChart.style('right', '0')
        }
        else if(showOrHideCommentsBtnForPerAreaChart == false){
            areaButtonForPerAreaChart.style('margin-left', "2px")
            filterButtonForPerAreaChart.style('margin-left', "2px")
            refreshButtonForPerAreaChart.style('margin-left', "2px")
            //commentsBtnForPerAreaChart.style('right', '0')
            commentsBtnForPerAreaChart.style('display','none')
            menuButtonForPerAreaChart.style('right', '0')
        }
        
        var ismenuBtnOfPerAreaChartClicked = false;
        menuButtonForPerAreaChart.on('click', function() {
                                  
              filterPanelForPerAreaChart.style("display","none");
              stgPanDivForPerAreaChart.style("display","none") // Hiding setting panel
              
              if ((showOrHideTableForPerAreaChart == false) && (showOrHideCommentsForPerAreaChart == true)){
                  divLegendPanelForPerAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                  .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                  
                  svgPanelForPerAreaChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                  .style("position","absolute");
              }
              else if ((showOrHideTableForPerAreaChart == true) && (showOrHideCommentsForPerAreaChart == false)){
                  divLegendPanelForPerAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                  .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                  
                  svgPanelForPerAreaChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                  .style("position","absolute");
              }
              else if ((showOrHideTableForPerAreaChart == false) && (showOrHideCommentsForPerAreaChart == false)){
                  divLegendPanelForPerAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                  .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                  
                  svgPanelForPerAreaChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                  .style("position","absolute");
              }
              
              if(ismenuBtnOfPerAreaChartClicked == false){
                  ismenuBtnOfPerAreaChartClicked = true;
                  optsBtnPanelForPerAreaChart.style("display","block")
              
              }
              else if(ismenuBtnOfPerAreaChartClicked == true){
                  ismenuBtnOfPerAreaChartClicked = false
                  optsBtnPanelForPerAreaChart.style("display","none")
              }
              
              resizedFuctionForPerAreaChart();
          })
        
        var tableButtonForPerAreaChart = optsBtnPanelForPerAreaChart.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top','1px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
        var tableBtnImgVar = document.createElement("IMG");
        if(showOrHideTableForPerAreaChart == false){
            tableBtnImgVar.src = "images/showTableIcon.png";
            tableButtonForPerAreaChart.attr("class","showTableClassForChartTable")
        }
        else if(showOrHideTableForPerAreaChart == true){
            tableBtnImgVar.src = "images/cancelTableIcon.png";
            tableButtonForPerAreaChart.attr("class","hideTableClassForChartTable")
        }
        tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
        tableButtonForPerAreaChart[0][0].appendChild(tableBtnImgVar)
        
        var settingBtnForPerAreaChart = optsBtnPanelForPerAreaChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 28 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        var settingBtnImgVar = document.createElement("IMG");
        settingBtnImgVar.src = "images/settingsIcon.png";
        settingBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.82;")
        settingBtnForPerAreaChart[0][0].appendChild(settingBtnImgVar)
        
        var downloadBtnForPerAreaChart = optsBtnPanelForPerAreaChart.append("div").attr("id","downloadBtnForPerAreaChart-ID-" + targetElement[0][0].id).style("width","20px").style("height","20px")
        .style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff").style('margin-left','2px').style('top', 54 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        
        acinfotech.downloadFunctionality("downloadBtnForPerAreaChart-ID-" + targetElement[0][0].id,targetElement)
        
        var svgPanelForPerAreaChart = targetElement .append('svg') 
        .attr("id","svgPanelIDForLineChart" + targetElement[0][0].id) .style("background-color", options.BGcolor) .style("position","absolute")
        
        var commentsPanelDivForPerAreaChart = targetElement.append("div") .attr("class","commentsPanelClassForPAChart")
        .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
		.style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
        .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)
        
        commentsPanelDivForPerAreaChart.on('click',function(d){
                                        $('.commentsClassForPerAreaChart' + targetElement[0][0].id).focus()
                                        })
        
        if(options.showTitle == true){
            
            chartTitlePanelForPerAreaChart.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 8 + "%"; })
            .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')
            
            if ((showOrHideTableForPerAreaChart == false) && (showOrHideCommentsForPerAreaChart == true)){
                
                var commentsForPerAreaChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                .css('line-height','1.1em').css('text-align','justify') .attr('class','commentsClassForPerAreaChart' + targetElement[0][0].id)
                
                svgPanelForPerAreaChart.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .append('g')
                commentsPanelDivForPerAreaChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                .style("top",78 + "%")
                .html(commentsForPerAreaChart[0].outerHTML.toString())
                
            }
            else if ((showOrHideTableForPerAreaChart == true) && (showOrHideCommentsForPerAreaChart == false)){
                
                svgPanelForPerAreaChart.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .append('g')
                commentsPanelDivForPerAreaChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForPerAreaChart == false) && (showOrHideCommentsForPerAreaChart == false)){
                svgPanelForPerAreaChart.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .append('g')
                commentsPanelDivForPerAreaChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            
            var margin = {top: 30 , right: 10, bottom: 80, left: 55}, //originally top: 42, left: 80
            width = (svgPanelForPerAreaChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = (svgPanelForPerAreaChart.node().getBoundingClientRect().height) - margin.top - margin.bottom;
            
        }
        else if(options.showTitle == false){
            chartTitlePanelForPerAreaChart.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });
            
            if ((showOrHideTableForPerAreaChart == false) && (showOrHideCommentsForPerAreaChart == true)){
                
                var commentsForPerAreaChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                .attr('contenteditable',false).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                .css('line-height','1.1em').css('text-align','justify')
                
                svgPanelForPerAreaChart.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .append('g')
                commentsPanelDivForPerAreaChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                .style("top",78 + "%")
                .html(commentsForPerAreaChart[0].outerHTML.toString())
                
            }
            else if ((showOrHideTableForPerAreaChart == true) && (showOrHideCommentsForPerAreaChart == false)){
                
                svgPanelForPerAreaChart.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .append('g')
                commentsPanelDivForPerAreaChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForPerAreaChart == false) && (showOrHideCommentsForPerAreaChart == false)){
                svgPanelForPerAreaChart.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .append('g')
                commentsPanelDivForPerAreaChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            
            var margin = {top: 30 , right: 10, bottom: 80, left: 55}, //originally top: 42, left: 80
            width = (svgPanelForPerAreaChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = (svgPanelForPerAreaChart.node().getBoundingClientRect().height) - margin.top - margin.bottom;
        }
        
        var colorscale;
        // checking color set for pie slices and legend dots
        if(options.colorSet === undefined){
            options.colorSet = "one"
            colorscale = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "one"){
            options.colorSet = "one"
            colorscale = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            options.colorSet = "two"
            colorscale = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            options.colorSet = "three"
            colorscale = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        }
        else
        {
            options.colorSet = "one"
            colorscale = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        
        if ((options.lineStyle.toString().toLowerCase() === "cardinal") || (options.lineStyle.toString().toLowerCase() === "linear") || (options.lineStyle.toString().toLowerCase() === "step")){
            options.lineStyle = options.lineStyle;
        }
        else{
            options.lineStyle = "cardinal";
        }
        
        /*------------------ Settings panel DIV and everything within it section begins here ------------------*/
        
        var stgPanDivForPerAreaChart = targetElement.append('div').style('width',"100%").style('height',"40%").attr("class","stgPanDivForLineChart" + targetElement[0][0].id)
        .style('position','absolute').style('margin-left', "0px").style('border-top',"1px solid #f0f0f0").style('border-bottom',"1px solid #e5e5e5")
        .style("background-color",'#fcfcfc').style("z-index",90) .style("display","none") .style('top',"60%").style('height',"40%")
        
        $( '.stgPanDivForLineChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
			var e0 = e.originalEvent,
			delta = e0.wheelDelta || -e0.detail;

			this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
			e.preventDefault();
        });
        
        var settingPanelTitle = stgPanDivForPerAreaChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','10px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; color:#00001c;">'+ "Settings" +'</div>')
        
        var stgPanDivForLineChangeColorTitle = stgPanDivForPerAreaChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Select color set " +'</div>')
        
        var stgPanCanBtnForPerAreaChart = stgPanDivForPerAreaChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
        .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white')
        .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.9; background-color:#fcfcff")
        stgPanCanBtnForPerAreaChart[0][0].appendChild(cancelBtnImgVar)
        
        stgPanCanBtnForPerAreaChart.on('click', function() {
                stgPanDivForPerAreaChart.style("display","none") // Hiding setting panel
                
                if ((showOrHideTableForPerAreaChart == false) && (showOrHideCommentsForPerAreaChart == true)){
                divLegendPanelForPerAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                
                svgPanelForPerAreaChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute");
                }
                else if ((showOrHideTableForPerAreaChart == true) && (showOrHideCommentsForPerAreaChart == false)){
                divLegendPanelForPerAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                
                svgPanelForPerAreaChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute");
                }
                else if ((showOrHideTableForPerAreaChart == false) && (showOrHideCommentsForPerAreaChart == false)){
                divLegendPanelForPerAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                
                svgPanelForPerAreaChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute");
                }
                
                resizedFuctionForPerAreaChart();
            })
        
        var formForChangeSettingsPanel = stgPanDivForPerAreaChart.append("form");
        formForChangeSettingsPanel.style("background-color","#fcfcfc").style("margin-top","67px").style("font-family","Verdana,sans-serif").style("font-size","12px")
        .style("position","absolute").attr("id","formForChangeColorSettingsPanel" + targetElement[0][0].id).style("font-weight","Bold").style("width","180px")
        .style("height","58px").style("padding","0px").style("border-radius","0px") .style("margin-left","10px")
        
        var svgPanelForCrSetOne = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px").style("margin-top","1px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetOne = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        var colorSetOneRange = d3.range(12);
        
        var colorSetOneDots = svgPanelForCrSetOne.append("g")
        colorSetOneDots.selectAll('rect') .data(colorSetOneRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("fill", function(d,i){return colorSetOne(i)})
        .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetOne(i);  })
        .style("cursor","auto") .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
        
        var svgPanelForCrSetTwo = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px") .style("margin-top","20px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetTwo = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        var colorSetTwoRange = d3.range(12);
        
        var colorSetTwoDots = svgPanelForCrSetTwo.append("g")
        colorSetTwoDots.selectAll('rect') .data(colorSetTwoRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto")
        .style("fill", function(d,i){return colorSetTwo(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
        .style("stroke",function(d,i){  return colorSetTwo(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
        
        var svgPanelForCrSetThree = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px") .style("margin-top","39px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetThree = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        var colorSetThreeRange = d3.range(12);
        
        var colorSetThreeDots = svgPanelForCrSetThree.append("g")
        colorSetThreeDots.selectAll('rect') .data(colorSetThreeRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto") .style("fill", function(d,i){return colorSetThree(i)})
        .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetThree(i);  })
        .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
        
        if(options.colorSet.toString().toLowerCase() === "one"){
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"1px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"1px solid #808080")
        }
        else
        {
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        
        svgPanelForCrSetOne.on('click',function(d){
           options.colorSet = "one"
           svgPanelForCrSetOne.style('border',"1px solid #808080")
           svgPanelForCrSetTwo.style('border',"0px solid #808080")
           svgPanelForCrSetThree.style('border',"0px solid #808080")
           
           colorscale = "";
           colorscale = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
           
           areas.style("fill", function (d,i) { return colorscale(i); }).style("stroke", function (d,i) { return colorscale(i); })
           legend.selectAll('rect').style("fill", function(d, i){ return colorscale(i);})
                               
       })
        svgPanelForCrSetTwo.on('click',function(d){
           options.colorSet = "two"
           svgPanelForCrSetOne.style('border',"0px solid #808080")
           svgPanelForCrSetTwo.style('border',"1px solid #808080")
           svgPanelForCrSetThree.style('border',"0px solid #808080")
           
           colorscale = "";
           colorscale = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
           
           areas.style("fill", function (d,i) { return colorscale(i); }).style("stroke", function (d,i) { return colorscale(i); })
           legend.selectAll('rect').style("fill", function(d, i){ return colorscale(i);})
                               
           })
        svgPanelForCrSetThree.on('click',function(d){
             options.colorSet = "three"
             svgPanelForCrSetOne.style('border',"0px solid #808080")
             svgPanelForCrSetTwo.style('border',"0px solid #808080")
             svgPanelForCrSetThree.style('border',"1px solid #808080")
             
             colorscale = "";
             colorscale = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
             
             areas.style("fill", function (d,i) { return colorscale(i); }).style("stroke", function (d,i) { return colorscale(i); })
             legend.selectAll('rect').style("fill", function(d, i){ return colorscale(i);})
                                 
         })
        
        var areaStrokeChangeStyleTitle = stgPanDivForPerAreaChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','190px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Area Style " +'</div>')
        
        var lineStyleDivForPerAreaChart = stgPanDivForPerAreaChart.append("div") .style("background-color","#fcfcfc") .style("margin-left","200px")
        .style("margin-top","67px") .style("font-family","Verdana,sans-serif") .style("font-size","12px") .style("position","absolute")
        .style("font-weight","Bold").style("width","110px") .style("height","30px") .style("padding","0px") .style("border-radius","0px")
        
        var cardinalButton = lineStyleDivForPerAreaChart.append("div") .style("width","32px").style("height","26px").style('position','absolute')
        .style('background-color',"#ffffff").style('margin-left',"0px") .style('top','1px') .style("cursor","pointer") .style("display","block")
        .style("border-style", "none").style('padding',"0px") .style("border", "1px solid #a0a0a0").style("line-height","0px") .style("box-sizing","border-box")
        var cardinalBtnImgVar = document.createElement("IMG");
        cardinalBtnImgVar.src = "images/curveAreaIcon.png";
        cardinalBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:24px; height:19px; opacity:0.78;")
        cardinalButton[0][0].appendChild(cardinalBtnImgVar)
        
        var linearButton = lineStyleDivForPerAreaChart.append("div") .style("width","32px").style("height","26px").style('position','absolute')
        .style('background-color',"#ffffff").style('margin-left',"35px") .style('top','1px') .style("cursor","pointer") .style("display","block")
        .style("border-style", "none") .style('padding',"0px") .style("line-height","0px") .style("box-sizing","border-box")
        var linearBtnImgVar = document.createElement("IMG");
        linearBtnImgVar.src = "images/linearAreaIcon.png";
        linearBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:24px; height:19px; opacity:0.78;")
        linearButton[0][0].appendChild(linearBtnImgVar)
        
        var stepButton = lineStyleDivForPerAreaChart.append("div") .style("width","32px") .style("height","26px") .style('position','absolute')
        .style('background-color',"#ffffff") .style('margin-left',"70px") .style('top','1px') .style("cursor","pointer") .style("display","block")
        .style("border-style", "none").style('padding',"0px").style("line-height","0px").style("box-sizing","border-box")
        var stepBtnImgVar = document.createElement("IMG");
        stepBtnImgVar.src = "images/stepAreaIcon.png";
        stepBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:24px; height:21px; opacity:0.78;")
        stepButton[0][0].appendChild(stepBtnImgVar)
        
        if(options.lineStyle.toString().toLowerCase() === "cardinal"){
            cardinalButton.style('border',"1px solid #808080")
            linearButton.style('border',"0px solid #808080")
            stepButton.style('border',"0px solid #808080")
        }
        else if(options.lineStyle.toString().toLowerCase() === "linear"){
            cardinalButton.style('border',"0px solid #808080")
            linearButton.style('border',"1px solid #808080")
            stepButton.style('border',"0px solid #808080")
        }
        else if(options.lineStyle.toString().toLowerCase() === "step"){
            cardinalButton.style('border',"0px solid #808080")
            linearButton.style('border',"0px solid #808080")
            stepButton.style('border',"1px solid #808080")
        }
        else
        {
            cardinalButton.style('border',"1px solid #808080")
            linearButton.style('border',"0px solid #808080")
            stepButton.style('border',"0px solid #808080")
        }
        
        cardinalButton.on('click',function(d){
              options.lineStyle = "cardinal"
              cardinalButton.style('border',"1px solid #a0a0a0")
              linearButton.style('border',"0px solid #808080")
              stepButton.style('border',"0px solid #808080")
              
              area.interpolate(options.lineStyle) .x(function(d) { return x(d.x); }).y0(function(d) { return y(d.y0); }).y1(function(d) { return y(d.y + d.y0); });
              
              areas.attr("d", function (d,i) { return area(d)})
              
              resizedFuctionForPerAreaChart();
                          
          })
        linearButton.on('click',function(d){
            options.lineStyle = "linear"
            cardinalButton.style('border',"0px solid #a0a0a0")
            linearButton.style('border',"1px solid #a0a0a0")
            stepButton.style('border',"0px solid #a0a0a0")
            
            area.interpolate(options.lineStyle) .x(function(d) { return x(d.x); }).y0(function(d) { return y(d.y0); }).y1(function(d) { return y(d.y + d.y0); });
            
            areas.attr("d", function (d,i) { return area(d)})
            
            resizedFuctionForPerAreaChart();
                        
        })
        stepButton.on('click',function(d){
              options.lineStyle = "step"
              cardinalButton.style('border',"0px solid #a0a0a0")
              linearButton.style('border',"0px solid #a0a0a0")
              stepButton.style('border',"1px solid #a0a0a0")
              
              area.interpolate(options.lineStyle) .x(function(d) { return x(d.x); }).y0(function(d) { return y(d.y0); }).y1(function(d) { return y(d.y + d.y0); });
              
              areas.attr("d", function (d,i) { return area(d)})
              
              resizedFuctionForPerAreaChart();
          })
        
        //------------------ Settings panel DIV and everything inside it section ends here ------------------
        
        var divLegendPanelForPerAreaChart = targetElement .append('div')  .attr("class","divLegendPanelClassForAreaChart") .style("background-color", options.BGcolor) .style('position',"absolute")
        .style('width', 25 + "%") .style('height', 92 + "%") .style("left",75 + "%").style("top",8 + "%")
        
        if ((showOrHideTableForPerAreaChart == false) && (showOrHideCommentsForPerAreaChart == true)){
            divLegendPanelForPerAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
            
            svgPanelForPerAreaChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
            .style("position","absolute");
        }
        else if ((showOrHideTableForPerAreaChart == true) && (showOrHideCommentsForPerAreaChart == false)){
            divLegendPanelForPerAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
            
            svgPanelForPerAreaChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute");
        }
        else if ((showOrHideTableForPerAreaChart == false) && (showOrHideCommentsForPerAreaChart == false)){
            divLegendPanelForPerAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
            
            svgPanelForPerAreaChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute");
        }
        
        // Creating ToolTip for options button.
        var iconButtonTooltipForPerAreaChart = targetElement.append('div').style('width','240px').attr("id","too")
        .style('height',"25px").style('position','absolute')//.style('margin-left', "0px").style('top','25px')
        .style("background-color",'#404040 ').style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid") // 004b9d
        .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none").attr("border", 0.0)
        
            areaButtonForPerAreaChart.on('mousemove', function(d,i) {
              var root = targetElement
              var m = d3.mouse(root.node());
              m[0] += 0
              m[1] += 0
              var filterButtonTooltipText = "Switch to Area Chart";
              iconButtonTooltipForPerAreaChart.style("width","126px").style("margin-left", (m[0] - 136) + "px").style("margin-top",(m[1]) + "px").style("display","block")
              iconButtonTooltipForPerAreaChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')
              
            })
            areaButtonForPerAreaChart.on('mouseout', function(d,i) {
              iconButtonTooltipForPerAreaChart.style("display","none")
            })

            filterButtonForPerAreaChart.on('mousemove', function(d,i) {
                var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                var filterButtonTooltipText = "Filter";
                iconButtonTooltipForPerAreaChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
                iconButtonTooltipForPerAreaChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')
                        
            })
            filterButtonForPerAreaChart.on('mouseout', function(d,i) {
                iconButtonTooltipForPerAreaChart.style("display","none")
            })

            refreshButtonForPerAreaChart.on('mousemove', function(d,i) {
                 var root = targetElement
                 var m = d3.mouse(root.node());
                 m[0] += 0
                 m[1] += 0
                 var refreshButtonTooltipText = "Refresh";
                 iconButtonTooltipForPerAreaChart.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
                 iconButtonTooltipForPerAreaChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ refreshButtonTooltipText +'</div>')
                         
             })
            refreshButtonForPerAreaChart.on('mouseout', function(d,i) {
                 iconButtonTooltipForPerAreaChart.style("display","none")
             })

            commentsBtnForPerAreaChart.on('mousemove', function(d,i) {
               commentsPanelDivForPerAreaChart.style('background-color','#fafafa')
               var root = targetElement
               var m = d3.mouse(root.node());
               m[0] += 0
               m[1] += 0
               if(options.showComments == false){
               var commentButtonTooltipText = "Show Comments";
               }
               else if(options.showComments == true){
               var commentButtonTooltipText = "Hide Comments";
               }
               
               iconButtonTooltipForPerAreaChart.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
               iconButtonTooltipForPerAreaChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ commentButtonTooltipText +'</div>')
           })
            commentsBtnForPerAreaChart.on('mouseout', function(d,i) {
               commentsPanelDivForPerAreaChart.style('background-color','#ffffff')
               iconButtonTooltipForPerAreaChart.style("display","none")
           })

            menuButtonForPerAreaChart.on('mousemove', function(d,i) {
              var root = targetElement
              var m = d3.mouse(root.node());
              m[0] += 0
              m[1] += 0
              var menuButtonTooltipText = "Menu";
              iconButtonTooltipForPerAreaChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
              iconButtonTooltipForPerAreaChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ menuButtonTooltipText +'</div>')
              
              })
            menuButtonForPerAreaChart.on('mouseout', function(d,i) {
              iconButtonTooltipForPerAreaChart.style("display","none")
            })

            tableButtonForPerAreaChart.on('mousemove', function(d,i) {
               var root = targetElement
               var m = d3.mouse(root.node());
               m[0] += 0
               m[1] += 0
               if(showOrHideTableForPerAreaChart == false){
               var tableButtonTooltipText = "Show Table";
               }
               else if(showOrHideTableForPerAreaChart == true){
               var tableButtonTooltipText = "Hide Table";
               }
               iconButtonTooltipForPerAreaChart.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
               iconButtonTooltipForPerAreaChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ tableButtonTooltipText +'</div>')
                       
            })
            tableButtonForPerAreaChart.on('mouseout', function(d,i) {
               iconButtonTooltipForPerAreaChart.style("display","none")
            })

            settingBtnForPerAreaChart.on('mousemove', function(d,i) {
                  var root = targetElement
                  var m = d3.mouse(root.node());
                  m[0] += 0
                  m[1] += 0
                  var settingTooltipText = "Settings";
                  iconButtonTooltipForPerAreaChart.style("width","67px").style("margin-left", (m[0] - 77) + "px").style("margin-top",(m[1]) + "px").style("display","block")
                  iconButtonTooltipForPerAreaChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ settingTooltipText +'</div>')
            })
            settingBtnForPerAreaChart.on('mouseout', function(d,i) {
                  iconButtonTooltipForPerAreaChart.style("display","none")
             })
        
            downloadBtnForPerAreaChart.on('mousemove', function(d,i) {
                  var root = targetElement
                  var m = d3.mouse(root.node());
                  m[0] += 0
                  m[1] += 0
                  var downloadButtonTooltipText = "Download";
                  
                  iconButtonTooltipForPerAreaChart.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
                  iconButtonTooltipForPerAreaChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
                  })
            downloadBtnForPerAreaChart.on('mouseout', function(d,i) {
                  iconButtonTooltipForPerAreaChart.style("display","none")
            })
        
        // ----------------- Filter panel and everything within it section begins here ----------------
        var filterPanelForPerAreaChart = targetElement.append('div') .style('width',350 + "px") .attr("class","filterPanelForLineChartClass" + targetElement[0][0].id)
        .style('position','absolute') .style('margin-left', "0px") .style("background-color",'#fefefe') .style("z-index",11)
        .style("border-color", "#ffffff").style("border-right", "solid #e5e5e5 1px")  .style("border-style", "solid") .style("box-shadow", "2px 0px 1px #eff8ec")
        .style("display","none").style("border-top", "solid #fdfdfd 1px").style("border-left","0px").style("border-bottom", "0px")
        .style('top', 0.0 + "%").style('height', 100 + "%").style('overflow-y',"hidden").style("overflow-x","hidden")
        .style("border-bottom", "solid #e5e5e5 1px") .style("box-sizing","border-box")
        
        var filterPanelForStkBarChartTitle = filterPanelForPerAreaChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','20px').style('text-indent','5px').style("font-size", "14px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #007aff").style("width","350px").style("color","#000000")
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; top:25.0%; font-size:16px; font-family:inter; color:#00001c;">'+ "Filter" +'</div>')
        
        var measuresColumnTitle = filterPanelForPerAreaChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; text-indent:3px;">Available Measures</div>');
        
        var measuresVariables = filterPanelForPerAreaChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable1"+targetElement[0][0].id)
        .style("list-style-type","none") .style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '78px')
        .style('position','absolute') .style("width","155px").style("min-height","190px").style("max-height","190px").style("border", "#f0f0f0 1px solid")
        .style("max-width","155px").style("overflow-x","hidden").style("overflow-y","auto")
        measuresVariables.style("left",0.0 + "px").style("padding","2px")
        
        $( ".filterPanelForLineChartClass" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
			var e0 = e.originalEvent,
			delta = e0.wheelDelta || -e0.detail;

			this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
			e.preventDefault();
        });
        
        var measuresArray = [];
        var dimensionArray = [];
        
        var measuresArrayLength = [];
        var dimensionsArrayLength = [];
        
        dimensionArray.push(options.keys.label);
        //measuresArray = options.keys.stackedBars;
        
        for(var i = 0; i<divAndChartsArray.length; i++){
            if(targetElement[0][0].id === divAndChartsArray[i].divID){
                
                if(newtargetElementAndOptionsArray[i].options.keys.areas == undefined){
                    measuresArray = newtargetElementAndOptionsArray[i].options.keys.lines;
                }
                else{
                    measuresArray = newtargetElementAndOptionsArray[i].options.keys.areas;
                }
            }
        }
        
        // filter process
        var uniqueMeasuresArrayKeys = [];
        $.each(measuresArray, function(i, el){
           if($.inArray(el, uniqueMeasuresArrayKeys) === -1){
               uniqueMeasuresArrayKeys.push(el);
           }
        });
        
        var uniqueDimensionArrayKeys = [];
        $.each(dimensionArray, function(i, el){
           if($.inArray(el, uniqueDimensionArrayKeys) === -1){
               uniqueDimensionArrayKeys.push(el);
           }
       });
        
        // setting lenght for arrays
        for(var i = 0; i<uniqueMeasuresArrayKeys.length; i++){
            measuresArrayLength.push(i);
        }
        
        for(var i = 0; i<uniqueDimensionArrayKeys.length; i++){
            dimensionsArrayLength.push(i);
        }
        
        var measuresVariables1 = measuresVariables.selectAll("li") .data(measuresArrayLength).enter().append("li")
        .style("width","130px") .style("max-height","22px").style("cursor","move")
        .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#bcf1bc").style("font-weight","Normal")
        .style("list-style-type","none").style("border","1px #89e789 solid").style("color","#006600").style("font-family","Verdana,sans-serif")
        .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
        .text(function(d) {return uniqueMeasuresArrayKeys[d]})
        measuresVariables1.attr("class","MeasuresClass"+targetElement[0][0].id)
        
        var measuresColumnReceivedUI_TableTitle = filterPanelForPerAreaChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','180px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; ">Selected Measures</div>');
        
        var measuresColumnReceivedUI_Table = filterPanelForPerAreaChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable3"+targetElement[0][0].id)
        .style('background-color',"#ffffff").style('margin-left','180px').style('margin-top', '78px')
        .style("width","155px").style('position','absolute').style("padding","2px").style("min-height","190px")
        .style("border","1px #c1c1c1 dashed") .style("max-height","190px") .style("overflow-x","hidden") .style("overflow-y","auto")
        //.html('<div class=unsortable  style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:65.0%; font-size:14px; font-family:inter;  color:#99ea99; font-weight:Normal; text-align:center;">Drag and Drop Measures here from Available Measures List. </div>');
        .html('<img class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' src="images/dragIcon.png" style=" width:36px; height:36px; position:absolute; margin-left:65px; margin-top:60px; opacity:0.6"/>'
              + '<div class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:60.0%; font-size:12px; font-family:inter;  color:#89d289; font-weight:Normal; text-align:center;">Drop Measures here. </div>');
        //.html('<div style="background-image: url(images/dragIcon.png); height: 64px; width: 64px; border: 1px solid black;"> </div>');
        
        var cancelButton = filterPanelForPerAreaChart.append("div") .style("width","23px").style("height","21px").style('position','absolute')
        .style('margin-left','320px').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white')
        .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.9; background-color:#fcfcff")
        cancelButton[0][0].appendChild(cancelBtnImgVar)
        
        cancelButton.on("click", function(){
            filterPanelForPerAreaChart.style("display","none")
            
            if ((showOrHideTableForPerAreaChart == false) && (showOrHideCommentsForPerAreaChart == true)){
                divLegendPanelForPerAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                
                svgPanelForPerAreaChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute");
            }
            else if ((showOrHideTableForPerAreaChart == true) && (showOrHideCommentsForPerAreaChart == false)){
                divLegendPanelForPerAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                
                svgPanelForPerAreaChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute");
            }
            else if ((showOrHideTableForPerAreaChart == false) && (showOrHideCommentsForPerAreaChart == false)){
                divLegendPanelForPerAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                
                svgPanelForPerAreaChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute");
            }
        })
        
        var reRenderChartAndTableButton = filterPanelForPerAreaChart.append("button").style("width","120px").style("height","25px").style('position','absolute')
        .style('margin-left','112px').style('margin-top','298px') .style("border-style", "none").style('background-color',"#2196f3")
        .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','15px').style("border-style", "solid").style('color','#ffffff')
        .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 1px #9b9b9b").style("border-radius","0px")
        var textForReRenderButton = document.createTextNode("Apply Changes");
        reRenderChartAndTableButton[0][0].appendChild(textForReRenderButton)
        
        reRenderChartAndTableButton.on("click", function(){
                                       
               if( $("#sortable3"+targetElement[0][0].id).children("li").length == 0 )
               {
               
                   var alertPageDisabledDivForPerAreaChart =targetElement.append('div').style('width',100 + '%')
                   .style('height',100 + "%").style('position','absolute').style('margin-left', '0px').style('top', '0px')
                   .style("background-color",'#f3f3f3').style("z-index",99)//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                   .style("opacity",0.2).style("display","block")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
                   
                   var alertDivForPerAreaChart = targetElement.append('div').style('width','350px')
                   .style('height',"150px").style('position','absolute').style('left', ((targetElement[0][0].clientWidth/2) - 175) + "px").style('top', '1px')
                   .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "solid").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                   .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","0px")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
                   //.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Bold;">Sorry, no result found for selected' + 'range!'+ '</br>' + '<label style=text-indent:10px;> Hello</label' +'</div>')
                   .html('<p  style="width: 340px; height:0%; background-color:#c7c7c7; position: absolute; top:40.0%; font-size:14px; font-family:inter; font-weight:Bold; margin-left:10px;  color:#f8f8f8; font-weight:Normal;">Check whether the Selected Measures box is not empty!</p>')
                   
                   var alertDivTitleForPerAreaChart = alertDivForPerAreaChart.append('div').style('width','340px')
                   .style('height',"30px").style('position','absolute').style('margin-left', "0px").style('top', '0px')
                   .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "none").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                   .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","2px")
                   .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; font-weight:Bold; text-indent:5px;  color:#e5e5e5; font-weight:Normal;">TimeBound</div>')
                   
                   var perAreaChartAlertOKButton = alertDivForPerAreaChart.append("button") .style("width","40px") .style("height","20px") .style('position','absolute') .style("box-shadow", "0px 1px 1px #B8B8B8")
                   .style('background-color',"#7cc15e") .style('margin-left','300px') .style('top', "120px").style("color","#ffffff")
                   .style("display","block").style('padding-top',"0px").style("cursor","pointer").style("box-shadow", "1px 1px 1px #56973a") .style("border-style", "none")
                   .style("font-family","Verdana,sans-serif").style("font-size","14px").style("text-align","center").style("vertical-align","middle").style("border-radius","0px")
                   .style("z-index",999)
                   
                   var textForPerAreaChartAlertOKButton = document.createTextNode("OK");
                   perAreaChartAlertOKButton[0][0].appendChild(textForPerAreaChartAlertOKButton)
                   
                   $("#"+targetElement[0][0].id).resizable('disable');
                   
                   perAreaChartAlertOKButton.on('click', function() {
                         alertDivForPerAreaChart.remove();
                         alertPageDisabledDivForPerAreaChart.remove()
                         $("#"+targetElement[0][0].id).resizable('enable');
                     })
                   
                   filterButtonForPerAreaChart.style("cursor","pointer")
                   
                   if(showOrHideTableForPerAreaChart == false){
                       svgPanelForPerAreaChart.style('width', 75 + "%") .style('height', 85 + "%").style("position","absolute")
                       divLegendPanelForPerAreaChart.style('width', 25 + "%") .style('height', 85 + "%").style("position","absolute")
                   }
                   else if(showOrHideTableForPerAreaChart == true){
                       svgPanelForPerAreaChart.style('width', 75 + "%") .style('height', 52 + "%").style("position","absolute")
                       divLegendPanelForPerAreaChart.style('width', 25 + "%") .style('height', 52 + "%").style("position","absolute")
                   }
                   
                       resizedFuctionForPerAreaChart();
                   }
                   
                   else{
                   
                       var selectedAreaMeasures = [];
                       for(var i=0; i<$("#sortable3"+targetElement[0][0].id).children("li").length;i++){
                           selectedAreaMeasures.push($("#sortable3"+targetElement[0][0].id).children("li")[i].textContent)
                       }
                       
                       var newOptions = {
                           data: options.data,
                           dataForTable: options.dataForTable,
                           isDataDetailedForTable: options.isDataDetailedForTable,
                           keys: {
                               label: options.keys.label,
                               areas: selectedAreaMeasures,
                           },
                           chartTitle:options.chartTitle,
                           xAxisLable: options.keys.label,
                           yAxisLable: "",
                           //dimensions: options.dimensions,
                           //measures: options.measures,
                           showTitle: true,
                           colorSet: options.colorSet,
                           series:options.series,
                           BGcolor:options.BGcolor,
                           legend:options.series,
                           lineStyle: options.lineStyle,
                           drillDownColumnName:options.drillDownColumnName,
                           showTable: options.showTable,
                           showComments: options.showComments,
                           comments: options.comments,
                           resizeButtonID: options.resizeButtonID //document.getElementById("resizeBtn").id
                       }
                       
                       d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                       acinfotech.percentageAreaChart(targetElement,newOptions)
               }
		})
        
        var textBoxForMeasureColumnFrom;
        var textBoxForMeasureColumnTo;
        var selectTitleDivForEachDimension;
        
        $( "ul.droptrue"+targetElement[0][0].id ).sortable({
               appendTo: document.body,
               helper: "clone",
               connectWith: ".droptrue"+targetElement[0][0].id,
               scroll: false,
               cancel: '.unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+','+' .unMoveableIconAndTextClassDimensions'+targetElement[0][0].id,
               revertDuration: 10,
               scrollSensitivity: 10,
               scrollSpeed: 1,
               dynamic: true,
               
               receive: function(e, ui) {
               
               if (($(this)[0].id == "sortable3"+targetElement[0][0].id) || ($(this)[0].id == "sortable1"+targetElement[0][0].id)) {
               
                   if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                       if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                           (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                       }
                       else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                           (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                       }
               
                   }
               } // if (($(this)[0].id == "sortable3") || ($(this)[0].id == "sortable1"))
               
               else if (($(this)[0].id == "sortable2"+targetElement[0][0].id) || ($(this)[0].id == "sortable4"+targetElement[0][0].id)) {
                   if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                       //ui.sender.sortable("cancel");
                       
                       if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                           (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                       }
                       else if(  ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                           (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                       }
                   }
               } //if (($(this)[0].id == "sortable2") || ($(this)[0].id == "sortable4")) {
               
               $(ui.item).css({ 'position': 'relative' });
               
               if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
               ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
               }
               
               else if ($(this)[0].id == "sortable3"+targetElement[0][0].id) { // checking if the dropped element is in Measures drop area
               
               if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
               ui.sender.sortable("cancel");
               }
               else {
               //ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
               }
               
               } // else if ($(this)[0].id == "sortable3") // checking if the dropped element is in Measures drop area ends here.
               
               else if ($(this)[0].id == "sortable4"+targetElement[0][0].id) { // checking if the dropped element is in Dimension drop area
               
               if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
               ui.sender.sortable("cancel");
               }
               else {
               ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
               }
               } //else if ($(this)[0].id == "sortable4")  // checking if the dropped element is in Dimension drop area ends here
               
               if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
               
               if ($(this)[0].id == "sortable1"+targetElement[0][0].id){
               if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
               
               if( ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
               ui.sender.sortable("cancel");
               } // if(  ui.sender.attr("id") === "sortable4")
               
               else if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
               ui.sender.sortable("cancel");
               }
               
               } // if(ui.item.hasClass("DimesionsClass"))
               }
               if ($(this)[0].id == "sortable2"+targetElement[0][0].id){
               if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
               
               if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
               ui.sender.sortable("cancel");
               }
               else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
               ui.sender.sortable("cancel");
               
               }
               }
               }
               
               } //if ($(this)[0].id == "sortable1")
               
				if ($(this)[0].id == "sortable4"+targetElement[0][0].id){
					if ($(this).children('li').length > 1 ){
						ui.sender.sortable("cancel");
						ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
					}
				}
               
               }, //receive ends here
               
               start:function(ev, ui) {
               
               },
               stop:function(ev, ui) {
               
               },
           });
        
        //----------------- Filter panel and everything within it section ends here -----------------
        
        areaButtonForPerAreaChart.on('click', function() {
                                  
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                                     
            for(var i = 0; i<divAndChartsArray.length; i++){
                                     
                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData;
                    options.keys = newtargetElementAndOptionsArray[i].options.keys;
                    options.showTable = false;
                    options.showComments = false;
                }
            }
                                     
            acinfotech.areaChart(targetElement,options)
                                  
        })
        
        filterButtonForPerAreaChart.on('click', function() {
                                    
            filterPanelForPerAreaChart.style("display","block");
            
            ismenuBtnOfPerAreaChartClicked = false;
            optsBtnPanelForPerAreaChart.style("display","none");
            
            stgPanDivForPerAreaChart.style("display","none");
            
            if ((showOrHideTableForPerAreaChart == false) && (showOrHideCommentsForPerAreaChart == true)){
            divLegendPanelForPerAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
            
            svgPanelForPerAreaChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
            .style("position","absolute");
            }
            else if ((showOrHideTableForPerAreaChart == true) && (showOrHideCommentsForPerAreaChart == false)){
            divLegendPanelForPerAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
            
            svgPanelForPerAreaChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute");
            }
            else if ((showOrHideTableForPerAreaChart == false) && (showOrHideCommentsForPerAreaChart == false)){
            divLegendPanelForPerAreaChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
            .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
            
            svgPanelForPerAreaChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
            .style("position","absolute");
            }
            
            resizedFuctionForPerAreaChart();
                                    
        })
        
        // Refreshing Chart and Table
        refreshButtonForPerAreaChart.on('click', function() {
                                     
             //isFilterClicked = false
             d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
             
             for(var i = 0; i<divAndChartsArray.length; i++){
             
                 if(targetElement[0][0].id === divAndChartsArray[i].divID){
                     options.data = divAndChartsArray[i].optionsData;
                     //options.keys.areas = newtargetElementAndOptionsArray[i].options.keys.areas;
                     if(newtargetElementAndOptionsArray[i].options.keys.areas == undefined){
                        options.keys.areas = newtargetElementAndOptionsArray[i].options.keys.lines;
                     }
                     else{
                        options.keys.areas = newtargetElementAndOptionsArray[i].options.keys.areas;
                     }
                 }
             }
             acinfotech.percentageAreaChart(targetElement,options)
                                     
         })
        
        // showing/hidding chart comments
        commentsBtnForPerAreaChart.on('click', function() {
                                   
               if(options.showComments == false){ 
                   options.showComments = true;
               }
               else if(options.showComments == true){ 
                   options.showComments = false;
               }
               
               d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
               
               for(var i = 0; i<divAndChartsArray.length; i++){
               
                   if(targetElement[0][0].id === divAndChartsArray[i].divID){
                        options.data = divAndChartsArray[i].optionsData
                        options.showTable = false;
                   }
               }
               acinfotech.percentageAreaChart(targetElement,options)
           
           })
        
        // showing/hidding chart table
        tableButtonForPerAreaChart.on('click', function() {
                                   
               if(showOrHideTableForPerAreaChart == false){
                   options.showTable = true;
                   //showOrHideTableForPieChart = true
                   }
                   else if(showOrHideTableForPerAreaChart == true){
                   //showOrHideTableForPieChart = false
                   options.showTable = false;
                   }
               
                   d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
               
                   for(var i = 0; i<divAndChartsArray.length; i++){
               
                   if(targetElement[0][0].id === divAndChartsArray[i].divID){
                        options.data = divAndChartsArray[i].optionsData
                        options.showComments = false;
                   }
               }
               acinfotech.percentageAreaChart(targetElement,options)
           
           })
        
        
        settingBtnForPerAreaChart.on('click', function() {
                                  
			ismenuBtnOfPerAreaChartClicked = false; // Menu toggle button variable
			optsBtnPanelForPerAreaChart.style("display","none") // To hide options button panel

			iconButtonTooltipForPerAreaChart.style("display","none") // Removing options button ToolTip
			settingBtnForPerAreaChart.style("cursor","pointer")

			stgPanDivForPerAreaChart.style("display","block") // Showing settings panel

			svgPanelForPerAreaChart.style('width', 75 + "%") .style('height', 52 + "%").style("position","absolute"); // Decreasing chart panel
			divLegendPanelForPerAreaChart.style('width', 25 + "%") .style('height', 52 + "%").style("position","absolute"); // Decreasing chart panel

			resizedFuctionForPerAreaChart(); // Calling resize function()
          
        })
        
        downloadBtnForPerAreaChart.on('click', function() {
                                  
			ismenuBtnOfPerAreaChartClicked = false; // Changing menu button value to false
			optsBtnPanelForPerAreaChart.style("display","none") // Hiding option buttons panel
              
        })
        
        var sortedArray = [], temp = {};
        options.data.forEach(function(d,i){
            temp[options.keys.label] = d[options.keys.label]
            for(var j = 0; j < options.keys.areas.length; j++){
               for(var k = 0; k < Object.keys(d).length; k++){
                   if(options.keys.areas[j].toString().toLowerCase() == d3.keys(d)[k].toString().toLowerCase()){
                        temp[options.keys.areas[j]] = +d[options.keys.areas[j]]
                        break;
                    }
                }
            }
            sortedArray.push(temp);
            temp = {};
                             
        })
        
        var totalArray = [], temp1 = {}, dataArray = [];
        sortedArray.forEach(function(d,i){
            for(var j = 0; j < Object.keys(d).length; j++){
                for(var k = 0; k < options.keys.areas.length; k++){
                    if(options.keys.areas[k].toString().toLowerCase() == d3.keys(d)[j].toString().toLowerCase()){
                        totalArray.push(+d3.values(d)[j])
                        break;
                    }
                }
            }
            temp1[options.keys.label] = d[options.keys.label]
                for(var l = 0; l < options.keys.areas.length; l++){
					if(isNaN(totalArray[l] / d3.sum(totalArray))){
						temp1[options.keys.areas[l]] = 0
					}
					else {
						temp1[options.keys.areas[l]] = +d3.round((totalArray[l] / d3.sum(totalArray)) * 100,1)
					}
                } 
                dataArray.push(temp1)
                totalArray = []
                temp1 = {}
        })
        
        var newDataArray = options.keys.areas.map(function(n){
                return dataArray.map(function(d, i){ 
                                    return { x: d[options.keys.label], y: d[n], y0: 0 };
                });
        });
        
        d3.layout.stack()(newDataArray);
        
        var x = d3.scale.ordinal().domain(options.data.map(function(d,i) { return d[options.keys.label];})).rangePoints([0, width],0.65);
        
        //var x1 = d3.scale.ordinal() .domain(options.data.map(function(d) { return d[options.keys.label]; })) .rangePoints([0, width], 0.65);
        
        var y = d3.scale.linear().domain([0,100]).range([height,0]);
        
        var xAxis = d3.svg.axis() .scale(x) .orient("bottom");
        
        var yAxis = d3.svg.axis().scale(y).orient("left")//.tickFormat(d3.format(".0%"));
        
        var svg = svgPanelForPerAreaChart.append("svg") .append("g") .attr("width", width + margin.left + margin.right) .attr("height", height + margin.top + margin.bottom)
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")")
        let key=options.xAxisLable;
        let array=options.data.map(value => value[key]);
        let ArrayValue=[];
        var RotateValue;
        for(let i=0;i<array.length;i++){
                ArrayValue[i]=array[i].length;
        }
        const numberGreaterThanLimit = ArrayValue.filter((v) => v > 5);
        svg.append("g") .attr("class", "x axis") .attr("transform", "translate(0," + height + ")") .call(xAxis)
        
        // Add the X Axis margin labels
        .selectAll("text") .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') .attr("transform", function(d)
        {
            if(numberGreaterThanLimit.length>0){return "rotate(-45)"}
            else{
            return "rotate(0)" }})
        .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
        .text(function(d,i) {
            if(d.length > 9)
            return d.substring(0,9)+'...';
            else
            return d;
            })
        
        svg.append("g") .attr("class", "y axis") .call(yAxis) .selectAll("text") .style('fill','#00001c') .style("font-family","Verdana,sans-serif")//.text(function(d,i) { return d + "%" })
        
        // Add the text label for the Y axis
        var yAxisVariable = svg.append("text") .attr("transform", "rotate(-90)") .attr("y", -50) .attr("x",0 - (height / 2.0)) .attr("dy", "1em") .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif")
        .style("font-size","12px") .text("Percentage (%)") .style('fill','#00001c') .style("text-transform","capitalize") .style("font-weight","Bold")
        .style("font-style","normal")
        
        var area = d3.svg.area().interpolate(options.lineStyle).x(function(d) { return x(d.x); }).y0(function(d) { return y(d.y0); }).y1(function(d) { return y(d.y + d.y0); });
        
        var areas = svg.selectAll("area") .data(newDataArray) .enter() .append("g") .append("path") .attr("class", "area")
        .attr("d", function (d,i) { return area(d); }) .style("stroke", function (d,i) { return colorscale(i); })
        .style("stroke-width",1.0) .style("fill", function (d,i) { return colorscale(i); }) .style("stroke-linecap", "butt")
        //.style('fill-opacity',0.78)
        
        //------------------ creating legend -----------------
        
        var legendPanelSvgForPerAreaChart = divLegendPanelForPerAreaChart .append('svg')  .attr("class","") .style('background-color',"#ffffff") .style('position',"absolute")
        .style('width', 100 + "%") .style('height', 100 + "%") .style("left",0 + "%").style("top",0 + "%")
        
        var legend = legendPanelSvgForPerAreaChart.append("g") .attr("class", "legend") .attr("height", "100%") .attr("width", "100%")
        .attr('transform', 'translate(0,20)')
        
        //Create colour circles
        legend.selectAll('rect') .data(options.keys.areas) .enter() .append("rect") .attr("x", 5) .attr("y", function(d, i){ return i * 16;})
        .attr("width", 14) .attr("height", 14) .attr("rx",10) .attr("ry",10) .style("fill", function(d, i){ return colorscale(i);})
        .style("cursor","auto")
        
        //Create text next to circles
        legend.selectAll('text') .data(options.keys.areas) .enter() .append("text") .attr("x", 25) .attr("y", function(d, i){ return i * 16 + 11.8;})
        .text(function(d,i) { if(d.length > 10)
            return d.substring(0,10)+'...';
            else
            return d; }) .style('font-size', '14px') .attr("fill","#00001c") .style("font-family","Verdana,sans-serif")
        
        // Aligning Legend (vertically)
        var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelForPerAreaChart[0][0].style.width) / 100)
        var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelForPerAreaChart[0][0].style.height) / 100)
        
        var legendRectSize = 11;
        var legendSpacing = 6;
        
        legend.attr('transform', function(d, i) {
            var eachRectHeight = legendRectSize + legendSpacing;
            var offset =  eachRectHeight * colorscale.domain().length / 2;
            var horz = 5;
            var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.areas.length))/2.0; // originally 2.0
            
            return 'translate(' + horz + ',' + vert + ')';
        })
        
        // Adding the text label for the X axis
        var xAxisVariable =  svg.append("text") .attr("transform", "translate(" + ((width/2) - 0) + " ," + (height+margin.bottom - 2) + ")")
        .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif") .style("font-weight","Bold") .style("font-size","12px") .text(options.xAxisLable) .style('fill','#00001c')
        .style("text-transform","capitalize") .style("font-style","normal")
        
        legend.selectAll('rect').on('mouseover',function(d,i){
            d3.select(areas[0][i]).style('stroke-width',2.5)
            
            var lineLen = areas.node().getTotalLength();
            var dashLen = options.data.length;
            var ddLen = dashLen ;
            var darray = dashLen;
            while(ddLen < lineLen){
            darray+=","+dashLen+","+dashLen;
            ddLen+=dashLen;
            }
            
            d3.select(areas[0][i]).attr("stroke-linecap", "round").attr("stroke-dasharray", darray + ","+lineLen) .attr("stroke-dashoffset", lineLen)
            .transition().duration(8000).ease("linear").attr("stroke-dashoffset", 0)//.style('fill-opacity',0.78)
        })
        
        legend.selectAll('rect').on('mouseout',function(d,i){
                                    
            d3.select(areas[0][i]).style('stroke-width',1.0).transition().duration(0)
            d3.select(areas[0][i]).attr("stroke-dasharray", options.data.length + ","+ 0)  .attr("stroke-dashoffset", 0)
        })
        
        var tooltipForPerAreaChart = targetElement .append('div') .attr('class', 'tooltipPie') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
        .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
        .style("padding-right", "7px") .style("background", "#F8F8F8") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style("z-index",1000)
        .style("border", "1.0px") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","60px")
        tooltipForPerAreaChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'label').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "14px") .style("font-weight", "normal");
        tooltipForPerAreaChart.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
        tooltipForPerAreaChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");
        
        
        var tableDivForPerAreaChart = targetElement .append('div')
        .attr("class","scrollingDivForTable-Class tableDivForPerAreaChart" + targetElement[0][0].id) .style('background-color',"#ffffff") .style("position","absolute")
        .style("display","block") .style("overflow","hidden") //.style("border-right","1px solid #e2e2e2").style("border-bottom","1px solid #e2e2e2")
        
        $( '.tableDivForPerAreaChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
              var e0 = e.originalEvent,
              delta = e0.wheelDelta || -e0.detail;
              
              this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
              e.preventDefault();
          });
        
        if(options.showTitle == true){
            tableDivForPerAreaChart.style("width", 100 + "%") .style("height", 40 + "%") .style("top",60 + "%")
            
        }
        else if(options.showTitle == false){
            tableDivForPerAreaChart.style("width", 100 + "%") .style("height", 40 + "%") .style("top",60 + "%")
        }
        
        tableDivForPerAreaChart.html('<table class = "tableClassForPerAreaChart' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                  '<thead class = "theadClassForPerAreaChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForPerAreaChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                                  '<tbody class = "tBodyClassForPerAreaChart' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                  '</table>'
                                  )
        
        tableDivForPerAreaChart.select('table').attr("id",targetElement[0][0].id + "tableID")
        
        // Show or Hide Table scroll when mouseover on widget
        targetElement.on('mouseover',function(d){ tableDivForPerAreaChart.style("overflow","auto") })
        targetElement.on('mouseout',function(d){ tableDivForPerAreaChart.style("overflow","hidden") })
        
        var tableDataForPerAreaChart = [];
        if(options.dataForTable.length > 0){
            tableDataForPerAreaChart = options.dataForTable;
        }
        else {
            tableDataForPerAreaChart = options.data;
        }
        
        var thead = tableDivForPerAreaChart.select("thead").selectAll("th") .data(d3.keys(tableDataForPerAreaChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#fefdfd")//f6f6f6
        .style("position","relative").style("top","2px")
        
        var thead1 = d3.select(".thead1ClassForPerAreaChart" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tableDataForPerAreaChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#fefdfd")//f6f6f6
        .style("position","relative").style("top","2px")
        
        var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
        .attr("id", "ascendingIconIDForPerAreaChart") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
        
        var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
        .attr("id", "descendingIconIDForPerAreaChart") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
        
        var tr = tableDivForPerAreaChart.select("tbody").selectAll("tr") .data(tableDataForPerAreaChart).enter().append("tr")
        .attr("id", function(d,i) { return "slice" + i })
        
        // cells
        var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter() .append("td") .text(function(d) { return d})
        .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
        
        var $table = $('.tableClassForPerAreaChart' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
        
        d3.select(".theadClassForPerAreaChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
			d.forEach(function(dd,j){
				colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
			})
		})
        
        $(".thead1ClassForPerAreaChart" + targetElement[0][0].id).insertAfter('.tBodyClassForPerAreaChart' + targetElement[0][0].id)
        
        $(".thead1ClassForPerAreaChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForPerAreaChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
        
        tableDivForPerAreaChart.select(".thead1ClassForPerAreaChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                 d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
         })
        
        $('.tableDivForPerAreaChart' + targetElement[0][0].id).scroll(function () {
                                                                   
               $(".thead1ClassForPerAreaChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForPerAreaChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
               
           })
        
        var sortOrder = false;
        thead1.on("click",function(k,index){
                  
              sortOrder = !sortOrder;
              
              tableDivForPerAreaChart.select(".thead1ClassForPerAreaChart" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                                                                                                                    
                if (sortOrder) {
                
                if(i == index){
                    d3.select(this).select('svg').select('#descendingIconIDForPerAreaChart').style("visibility", "hidden")
                    d3.select(this).select('svg').select('#ascendingIconIDForPerAreaChart').style("visibility", "visible")
                }
                else {
                    d3.select(this).select('svg').select('#descendingIconIDForPerAreaChart').style("visibility", "visible")
                    d3.select(this).select('svg').select('#ascendingIconIDForPerAreaChart').style("visibility", "visible")
                }
                }
                else{
                
                if(i == index){
                    d3.select(this).select('svg').select('#descendingIconIDForPerAreaChart').style("visibility", "visible")
                    d3.select(this).select('svg').select('#ascendingIconIDForPerAreaChart').style("visibility", "hidden")
                }
                else {
                    d3.select(this).select('svg').select('#descendingIconIDForPerAreaChart').style("visibility", "visible")
                    d3.select(this).select('svg').select('#ascendingIconIDForPerAreaChart').style("visibility", "visible")
                }
                }
            })
              
              var monthTruOrFalAryForPerAreaChart = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
              
              tr.sort(function(a, b) {
                      
                  if (sortOrder) {
                      var monthsArrayForPerAreaChart = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                  } else {
                      var monthsArrayForPerAreaChart = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                  }
                  
                  monthTruOrFalAryForPerAreaChart = []; gotMonthArray = [];
                  tableDataForPerAreaChart.forEach(function(d,i){
                        var da = d[k].toString().substring(0,3).toLowerCase()
                        if(monthsArrayForPerAreaChart.indexOf(da) >= 0){
                            monthTruOrFalAryForPerAreaChart.push(true)
                            gotMonthArray.push(da);
                        }
                        else {
                            monthTruOrFalAryForPerAreaChart.push(false)
                        }
                    })
                  
                  if(monthTruOrFalAryForPerAreaChart.indexOf(false) == -1){ // true
                  
                  monthArray = []; monthArrayCount = [];
                  gotMonthArray.forEach(function(dd,j){
                        var index1 = monthsArrayForPerAreaChart.indexOf(dd.substring(0,3))
                        if(monthArrayCount.indexOf(index1) >= 0){
                            index1 = 12 + index1;
                        }
                        monthArray.push(index1);
                        monthArrayCount.push(index1)
                    })
                  returnArray = []
                  monthArray.sort(function(aa, bb) {
                          returnArray.push(+aa - +bb)
                          return +aa - +bb;
                  })
                  
                  sortTableFunc()
                  return returnArray[ind++];
                  } //  if true (if jan feb if block)
                  else {
                  var data = +a[k];
                  
                  if(!isNaN(data)){
                  
                  if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                  else { return d3.descending(+a[k], +b[k]); }
                  }
                  else if(!isNaN(Date.parse(a[k]))){
                  
                  if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                  else { return new Date(b[k]) - new Date(a[k]) }
                  }
                  else {
                  
                  if (sortOrder) { return d3.ascending(a[k], b[k]); }
                  else { return d3.descending(a[k], b[k]); }
                  }
                  } // if not jan feb else block
              }); // tr

		})
        
        function sortTableFunc(){
            
            var table = tableDivForPerAreaChart.select('table');
            var rows = table.selectAll('tr').data(tableDataForPerAreaChart);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0).style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr')
            .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500) .style('opacity', 1.0).style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
        }
        
        // Main Table Styling
        tableDivForPerAreaChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
        .style("color","#00001c")
        .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4") //.style("box-shadow","10px 10px 50px #007aff").style("z-index",9999)
        tableDivForPerAreaChart.selectAll('td').style("height","25px") .style("border", "1px solid #ffffff") .style("font-size","12px").style("font-weight","Normal").style("color","#00001c")
        
        //additionally 
        tableDivForPerAreaChart.selectAll('th').style('background-color',"#ffffff").style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
        tableDivForPerAreaChart.selectAll('td').style("border-style","none").style("color","#00001c")
        //tablePanelForPieChart.selectAll('td').style("height","25px") .style("border", "1px solid #fcfcfc") .style("font-size","12px").style("font-weight","Normal")
        
        //b1da9f
        tableDivForPerAreaChart.selectAll('table').style("border-collapse","collapse")
        tableDivForPerAreaChart.selectAll('table tr:first-child th').style("border-top","0px")
        tableDivForPerAreaChart.selectAll('table tr:last-child td').style("border-bottom","0px")
        tableDivForPerAreaChart.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
        tableDivForPerAreaChart.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")
        
        if(showOrHideTableForPerAreaChart == false){
            tableDivForPerAreaChart.style("display","none")
        }
        else if(showOrHideTableForPerAreaChart == true){
            tableDivForPerAreaChart.style("display","block")
        }
        
        if(options.isDataDetailedForTable == false){
            
            var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
            
            // Adding underlines for selected drill-down column text
            var drillDownSectionsForPerAreaChart = tableDivForPerAreaChart.select('table').selectAll('th')
            
            var foundResult = [];
            for(var i = 0; i<drillDownSectionsForPerAreaChart[0].length; i++){
                
                for(var j = 0; j<drillDownColumnNamesArray.length; j++){
                    if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForPerAreaChart[0][i].__data__.toString().toLowerCase() ){
                        foundResult.push(i)
                    }
                }
            }
            
            var r = tableDivForPerAreaChart.select('table').selectAll('tr').selectAll('td')
            for(var i = 0; i<r.length; i++){
                for(var j = 0; j < foundResult.length; j++){
                    var row = r[i][foundResult[j]]
                    $(row).css("text-decoration", "underline")
                }
            }
        }
        
            //resizedFuctionForPerAreaChart(); // calling the resize function for the first time.
        
            //By default calling the resized function first time (to align table's th and td).
            resizedFuctionForPerAreaChart()
        
            window.addEventListener('resize', function(event){ resizedFuctionForPerAreaChart() });
			
            $(function() {
            	$("#" + targetElement[0][0].id).resizable({
                                                        
                    resize: function(event, ui) {
                    divWidth = ui.size.width;
                    divHeight = ui.size.height;
                    resizedFuctionForPerAreaChart();
                    }
                });
			});
        
        function resizedFuctionForPerAreaChart()
        {
            
            if((svgPanelForPerAreaChart.node().getBoundingClientRect().width) && (svgPanelForPerAreaChart.node().getBoundingClientRect().height) > 0){
                
                if(showOrHideCommentsBtnForPerAreaChart == true){
                    areaButtonForPerAreaChart.style('margin-left', "2px")
                    filterButtonForPerAreaChart.style('margin-left', "2px")
                    refreshButtonForPerAreaChart.style('margin-left', "2px")
                    commentsBtnForPerAreaChart.style('margin-left', "2px")
                    menuButtonForPerAreaChart.style('right', '0')
                }
                else if(showOrHideCommentsBtnForPerAreaChart == false){
                    areaButtonForPerAreaChart.style('margin-left', "2px")
                    filterButtonForPerAreaChart.style('margin-left', "2px")
                    refreshButtonForPerAreaChart.style('margin-left', "2px")
                    //commentsBtnForPerAreaChart.style('right', '0')
                    commentsBtnForPerAreaChart.style('display','none')
                    menuButtonForPerAreaChart.style('right', '0')
                }
                
                optsBtnPanelForPerAreaChart.style('right', '0')
                
                stgPanCanBtnForPerAreaChart.style('right', '0') // setting panel cancel button.
                
                var margin1 = {top: 30 , right: 10, bottom: 80, left: 55}, //originally top: 42, left: 80
                width1 = (svgPanelForPerAreaChart.node().getBoundingClientRect().width) - margin1.left - margin1.right,
                height1 = (svgPanelForPerAreaChart.node().getBoundingClientRect().height) - margin1.top - margin1.bottom;
                // width1 = ($('#svgPanelIDForLineChart' + targetElement[0][0].id)[0].getBoundingClientRect().width) - margin1.left - margin1.right,
                // height1 = ($('#svgPanelIDForLineChart' + targetElement[0][0].id)[0].getBoundingClientRect().height) - margin1.top - margin1.bottom;
                
                x.domain(options.data.map(function(d,i) { return d[options.keys.label];})).rangePoints([0, width1],0.65);
                
                y.domain([0,100]).range([height1,0]);
                
                xAxis.scale(x) .orient("bottom");
                
                yAxis.scale(y).orient("left")
                
                area.x(function(d) { return x(d.x); }).y0(function(d) { return y(d.y0); }).y1(function(d) { return y(d.y + d.y0); })
                
                var svg1 = svg;
                
                svg1.select("svg") .attr("width", width1 + margin1.left + margin1.right) .attr("height", height1 + margin1.top + margin1.bottom)
                
                svg1.select(".y.axis") .call(yAxis) //.text(function(d,i) { return d + "%" })
                
                svg1.select(".x.axis") .attr("transform", "translate(0," + height1 + ")") .call(xAxis)
                
                // Add the X Axis margin labels
                .selectAll("text") .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') .attr("transform", function(d) 
                {
                    if(numberGreaterThanLimit.length>0){return "rotate(-45)"}
                    else{
                    return "rotate(0)" }})
                .text(function(d,i) {
                      if(d.length > 9)
                      return d.substring(0,9)+'...';
                      else
                      return d;
                  })
                
                xAxisVariable.attr("transform", "translate(" + ((width1/2) - 0) + " ," + (height1+margin1.bottom - 2) + ")")
                
                yAxisVariable.attr("transform", "rotate(-90)") .attr("y", -50) .attr("x",0 - (height1 / 2.0))
                
                // svg1.selectAll("circle") .transition() .delay(function (d, i) { return i / options.data.length * 50; }) .duration(900).ease("bounce")
                // .attr("cx", function(d,i) {  return x1(d['label']); }) .attr("cy", function(d,i) {  return yy(+d["value"]); })
                
                svg1.selectAll(".area").attr("d", function (d,i) { return area(d); })
                
                // Aligning Legend (vertically)
                var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelForPerAreaChart[0][0].style.width) / 100)
                var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelForPerAreaChart[0][0].style.height) / 100)
                
                var legendRectSize = 11;
                var legendSpacing = 6;
                
                legend.attr('transform', function(d, i) {
                    var eachRectHeight = legendRectSize + legendSpacing;
                    var offset =  eachRectHeight * colorscale.domain().length / 2;
                    var horz = 5;
                    var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.areas.length))/2.0; // originally 2.0
                    
                    return 'translate(' + horz + ',' + vert + ')';
                })
                
                colWidth = []; 
				
                d3.select(".theadClassForPerAreaChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                      d.forEach(function(dd,j){
                        colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                    })
                })
                tableDivForPerAreaChart.select(".thead1ClassForPerAreaChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                     d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
                })
                
            } // checking svg panel width & height is greater than zero  
        }

    }, // Percentage area chart
    
    // ************************************************** Two X-Axises Grouped Bar Chart  **************************************************
    twoXAxisesGroupedBarChart: function(targetElement, options){
        
        isChartCalled++;
        
        var chartName = "TWOXAXISESGROUPEDBARCHART";
        
        acinfotech.allCharts(targetElement,options,chartName);
        
        var reversedDimsLabelArray = options.keys.labels.reverse()
        
        var selectedDimensionsArray = reversedDimsLabelArray;
        var selectedDimsValueArray = [];
        var tempArray = [];
        var finalSelectedDimsValueArray = []
        
        for(var i = 0; i < selectedDimensionsArray.length; i++){
            tempArray = []
            options.data.forEach(function(d,j){
                for(var k = 0; k<Object.keys(d).length; k++){
                    var lower = d3.keys(d)[k].toString().toLowerCase()
                        if (lower === selectedDimensionsArray[i].toString().toLowerCase()) {
                            tempArray.push(d3.values(d)[k])
                        }
                }
            })
            finalSelectedDimsValueArray.push(tempArray)
        }
        
        var finalSelectedDimsUniqueValuesArray = []
        for(var i = 0; i < finalSelectedDimsValueArray.length; i++){
            tempArray = []
            $.each(finalSelectedDimsValueArray[i], function(i, el){
                if($.inArray(el, tempArray) === -1) tempArray.push(el);
            });
           finalSelectedDimsUniqueValuesArray.push(tempArray)
        }
        
        var finalArray = [];
        var tempArray = [];
        
        var setOfDataArray = []; // Two hold each data
        
        for(var i = 0; i < finalSelectedDimsUniqueValuesArray[0].length; i++){
            tempArray = []
            for(var j = 0; j < finalSelectedDimsUniqueValuesArray[1].length; j++){
                options.data.forEach(function(d,l){
                    for(var n = 0; n < Object.keys(d).length; n++){
                        var lower = d3.keys(d)[n].toString().toLowerCase();
                            if(lower === selectedDimensionsArray[0].toString().toLowerCase()){
                                if(d3.values(d)[n].toString().toLowerCase() === finalSelectedDimsUniqueValuesArray[0][i].toString().toLowerCase()){
                                    for(var p = 0; p < Object.keys(d).length; p++){
                                        var lower = d3.keys(d)[p].toString().toLowerCase()
                                            if(lower === selectedDimensionsArray[1].toString().toLowerCase()){
                                                if(d3.values(d)[p].toString().toLowerCase() === finalSelectedDimsUniqueValuesArray[1][j].toString().toLowerCase()){
                                                    tempArray.push(d)
                                                    break;
                                                } // if
                                            } // if(lower)
                                    } // for(var p)
                                } //if(d3.values(d[n])
                            }// if(lower)
                    } // for(var n)
                }) // options.data
            } // for(var j)
            setOfDataArray.push(tempArray)
        }// for(var i)
			
		
		if(options.dataForDrillDown.length > 0){
			
			var selectedDimensionsArray1 = reversedDimsLabelArray;
			var selectedDimsValueArray1 = [];
			var tempArray1 = [];
			var finalSelectedDimsValueArray1 = []
			
			for(var i = 0; i < selectedDimensionsArray1.length; i++){
				tempArray1 = []
				options.dataForDrillDown.forEach(function(d,j){ 
					for(var k = 0; k<Object.keys(d).length; k++){
						var lower = d3.keys(d)[k].toString().toLowerCase()
							if (lower === selectedDimensionsArray1[i].toString().toLowerCase()) {
								tempArray1.push(d3.values(d)[k])
							}
					}
				})
				finalSelectedDimsValueArray1.push(tempArray1)
			}
			
			var finalSelectedDimsUniqueValuesArray1 = []
			for(var i = 0; i < finalSelectedDimsValueArray.length; i++){
				tempArray1 = []
				$.each(finalSelectedDimsValueArray[i], function(i, el){
					if($.inArray(el, tempArray1) === -1) tempArray1.push(el);
				});
			   finalSelectedDimsUniqueValuesArray1.push(tempArray1)
			}
			
			
			var finalArray1 = [];
			var tempArray1 = [];
			
			var setOfDataArray1 = []; // Two hold each data
			
			for(var i = 0; i < finalSelectedDimsUniqueValuesArray1[0].length; i++){
				tempArray1 = []
				for(var j = 0; j < finalSelectedDimsUniqueValuesArray1[1].length; j++){
					options.dataForDrillDown.forEach(function(d,l){
						for(var n = 0; n < Object.keys(d).length; n++){
							var lower = d3.keys(d)[n].toString().toLowerCase();
								if(lower === selectedDimensionsArray1[0].toString().toLowerCase()){
									if(d3.values(d)[n].toString().toLowerCase() === finalSelectedDimsUniqueValuesArray1[0][i].toString().toLowerCase()){
										for(var p = 0; p < Object.keys(d).length; p++){
											var lower = d3.keys(d)[p].toString().toLowerCase()
												if(lower === selectedDimensionsArray1[1].toString().toLowerCase()){
													if(d3.values(d)[p].toString().toLowerCase() === finalSelectedDimsUniqueValuesArray1[1][j].toString().toLowerCase()){
														tempArray1.push(d)
														break;
													} // if
												} // if(lower)
										} // for(var p)
									} //if(d3.values(d[n])
								}// if(lower)
						} // for(var n)
					}) // options.data
				} // for(var j)
				setOfDataArray1.push(tempArray1)
			}// for(var i)
			
		} // if(options.dataForDrillDown.length > 0)
		
		targetElement.style("min-width","350px").style("min-height","350px").style("background-color", options.BGcolor)
        
        var showOrHideCommentsForTwoAxisesGrpBarChart;
        var showOrHideCommentsBtnForTwoAxisesGrpBarChart = true;
        
        // Show or Hide comments
        if (options.showComments == true || false) {
            showOrHideCommentsForTwoAxisesGrpBarChart = options.showComments;
        }
        else {
            showOrHideCommentsForTwoAxisesGrpBarChart = false;
        }
        
        if (options.comments.length == 0){
            showOrHideCommentsForTwoAxisesGrpBarChart = false;
            showOrHideCommentsBtnForTwoAxisesGrpBarChart = false;
        }
        
        var yAxisDivForTwoAxisesGrpBarChart = targetElement.append("div").style("position","absolute").style("background-color", options.BGcolor)
        .style("width", function(d) {  return 10.00 + "%"; }) .style("height", function(d) { return 80 + "%"; }).style("top", function(d) {  return 10.00 + "%"; })
        .style("left", function(d) {  return 0.00 + "%"; })
        .style("border","none").style("border-bottom","0px solid #e6e6e6").style("box-sizing","border-box")
        
        var chartDivForTwoAxisesGrpBarChart = targetElement.append("div").style("position","absolute").style("background-color", options.BGcolor)
        .style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 80 + "%"; }).style("top", function(d) {  return 10.00 + "%"; })
        .style("left", function(d) {  return 10.00 + "%"; })
        .style("border","none").style("border-right","0px solid #808080").style("box-sizing","border-box")
        
        var legendDivForTwoAxisesGrpBarChart = targetElement.append("div").style("position","absolute").style("background-color", options.BGcolor)
        .style("width", function(d) {  return 20.00 + "%"; }) .style("height", function(d) { return 80 + "%"; }).style("top", function(d) {  return 10.00 + "%"; })
        .style("left", function(d) {  return 80.00 + "%"; })
        .style("border","none").style("border-bottom","0px solid #e6e6e6").style("box-sizing","border-box")
        
        var chartTitlePanelForTwoAxisesGrpBarChart =  targetElement.append("div").style("position","absolute").style("background-color", options.BGcolor).style("text-indent","10px")
        .style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 5 + "%"; }).style("top", function(d) {  return 0.00 + "%"; })
        .style("border","none").style("box-sizing","border-box")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:20.0%; font-size:14px; font-family:inter;color:#00001c;">'+ options.chartTitle +'</div>')
        
        //Reverse the order of options.keys.labels
        options.keys.labels.reverse()
        
        var chartTopPanelForTwoAxisesGrpBarChart =  targetElement.append("div").style("position","absolute").style("text-align", "center").style("background-color", options.BGcolor)
        .style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 5 + "%"; }).style("top", function(d) {  return 5.00 + "%"; })
        .style("left", function(d) {  return 10.00 + "%"; }).style("border","none").style("border-bottom","0px solid #e6e6e6").style("box-sizing","border-box")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:20.0%; font-size:12px; font-family:inter; text-transform:uppercase; color:#00001c; font-weight:Bold;">'+ options.keys.labels[1] +'</div>')
        
        var chartBottomPanelForTwoAxisesGrpBarChart =  targetElement.append("div").style("position","absolute").style("text-align", "center").style("background-color", options.BGcolor)
        .style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 5 + "%"; }).style("top", function(d) {  return 90.00 + "%"; })
        .style("left", function(d) {  return 10.00 + "%"; }).style("border","none").style("border-top","0px solid #e6e6e6").style("box-sizing","border-box")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:20.0%; font-size:12px; font-family:inter; text-transform:uppercase; color:#00001c; font-weight:Bold;">'+ options.keys.labels[0] +'</div>')
        
        //Reverse the order of options.keys.labels
        options.keys.labels.reverse()
        
        //-------- adding shuffle and refresh button --------
		
		var optionsButtonPanelForTwoAxisesGrpBarChart = targetElement.append('div').style('width',"25px").style('height',"160px").style('position','absolute')
        .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px")
        .style('right', '0').style("min-width","25px")
        .style("border-style","none").style("border-left", "solid #fcfcfc  1px")//.style("top",71.5 + "px")
		
        var shuffleBtnForTwoXAxisesGrpBarChart = optionsButtonPanelForTwoAxisesGrpBarChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','80px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var filterBtnImgVar = document.createElement("IMG");
        filterBtnImgVar.src = "images/shuffleIcon.png";
        filterBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.9;")
        shuffleBtnForTwoXAxisesGrpBarChart[0][0].appendChild(filterBtnImgVar)
        
        var refreshBtnForTwoXAxisesGrpBarChart = optionsButtonPanelForTwoAxisesGrpBarChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','105px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var refreshBtnImgVar = document.createElement("IMG");
        refreshBtnImgVar.src = "images/refreshIcon.png";
        refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.9;")
        refreshBtnForTwoXAxisesGrpBarChart[0][0].appendChild(refreshBtnImgVar)
        
        var commentsPanelDivForTwoAxisesGrpBarChart = targetElement.append("div") //.attr("class","commentsPanelClassForcommentsPanelDivForTwoAxisesGrpBarChart")
        .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
		.style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
        .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)
        
        commentsPanelDivForTwoAxisesGrpBarChart.on('click',function(d){
            $('.commentsClassForcommentsPanelDivForTwoAxisesGrpBarChart' + targetElement[0][0].id).focus()
        })
        
        var commentsBtnForTwoAxisesGrpBarChart = optionsButtonPanelForTwoAxisesGrpBarChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','130px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var commentsBtnImgVariable = document.createElement("IMG");
        if(options.showComments == false){
            commentsBtnImgVariable.src = "images/showCommentsIcon.png";
        }
        else if(options.showComments == true){
            commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
        }
        commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        commentsBtnForTwoAxisesGrpBarChart[0][0].appendChild(commentsBtnImgVariable)
        
        var menuButtonForTwoAxisesGrpBarChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','1px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var menuBtnImgVar = document.createElement("IMG");
        menuBtnImgVar.src = "images/menuIcon.png";
        menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
        menuButtonForTwoAxisesGrpBarChart[0][0].appendChild(menuBtnImgVar)
        
        var ismenuButtonOfTwoAxisesGrpBarChartClicked = false; // Menu toggle button variable
        menuButtonForTwoAxisesGrpBarChart.on('click', function() {
                
            shufflePanelForTwoXAxisesGrpBarChart.style("display","none");
                                             
            if(ismenuButtonOfTwoAxisesGrpBarChartClicked == false){ // Checking if menu button is clicked
                ismenuButtonOfTwoAxisesGrpBarChartClicked = true; // Menu toggle button variable
                optionsButtonPanelForTwoAxisesGrpBarChart.style("display","block") // Showing option buttons menu panel
            }
            else if(ismenuButtonOfTwoAxisesGrpBarChartClicked == true){ // Checking if menu button is clicked
                ismenuButtonOfTwoAxisesGrpBarChartClicked = false
                optionsButtonPanelForTwoAxisesGrpBarChart.style("display","none") // Hiding option buttons panel
            }
                                    
        })
        
        var searchChartButton = optionsButtonPanelForTwoAxisesGrpBarChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 0px 0px #888888") .style('background-color',"#ffffff").style('margin-left',2 + "px").style('top','1px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #888888") .style("border-style", "none")
        var searchBtnImgVar = document.createElement("IMG");
        searchBtnImgVar.src = "images/searchInChartIcon.png";
        searchBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.85;")
        searchChartButton[0][0].appendChild(searchBtnImgVar)
        
        var searchTableButton = optionsButtonPanelForTwoAxisesGrpBarChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 0px 0px #888888") .style('background-color',"#ffffff").style('margin-left',2 + "px").style('top','27px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #888888") .style("border-style", "none")
        var searchBtnImgVar = document.createElement("IMG");
        searchBtnImgVar.src = "images/searchInTableIcon.png";
        searchBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.80;")
        searchTableButton[0][0].appendChild(searchBtnImgVar)
        
        var downloadBtnForTwoAxisesGrpBarChart = optionsButtonPanelForTwoAxisesGrpBarChart.append("div").attr("id","downloadBtnForTwoAxisesGrpBarChart-ID-" + targetElement[0][0].id)
        .style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff")
        .style('margin-left','2px').style('top', 54 + 'px').style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        
        acinfotech.downloadFunctionality("downloadBtnForTwoAxisesGrpBarChart-ID-" + targetElement[0][0].id,targetElement)
        
        if ( showOrHideCommentsForTwoAxisesGrpBarChart == true ){
            
            yAxisDivForTwoAxisesGrpBarChart.style("left", function(d) {  return 0.00 + "%"; }).style("top", function(d) {  return 10.00 + "%"; }).style("width", function(d) {  return 10.00 + "%"; }) .style("height", function(d) { return 65 + "%"; })
            
            chartDivForTwoAxisesGrpBarChart.style("left", function(d) {  return 10.00 + "%"; }).style("top", function(d) {  return 10.00 + "%"; })
            .style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 65 + "%"; })
            
            chartBottomPanelForTwoAxisesGrpBarChart.style("left", function(d) {  return 10.00 + "%"; }).style("top", function(d) {  return 75.00 + "%"; }).style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 5 + "%"; })
            
            legendDivForTwoAxisesGrpBarChart.style("left", function(d) {  return 80.00 + "%"; }).style("top", function(d) {  return 10.00 + "%"; }).style("width", function(d) {  return 20.00 + "%"; }) .style("height", function(d) { return 65 + "%"; })
            
            var commentsForTwoAxisesGrpBarChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
             .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
             .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
             .css('line-height','1.1em').css('text-align','justify') .attr('class','commentsClassForTwoAxisesGrpBarChart' + targetElement[0][0].id)
             
             commentsPanelDivForTwoAxisesGrpBarChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 20 + "%"; })
             .style("top",80 + "%")
             .html(commentsForTwoAxisesGrpBarChart[0].outerHTML.toString())
            
        }
        else if ( showOrHideCommentsForTwoAxisesGrpBarChart == false ){
            
            yAxisDivForTwoAxisesGrpBarChart.style("left", function(d) {  return 0.00 + "%"; }).style("top", function(d) {  return 10.00 + "%"; }).style("width", function(d) {  return 10.00 + "%"; }) .style("height", function(d) { return 80 + "%"; })
            
            chartDivForTwoAxisesGrpBarChart.style("left", function(d) {  return 10.00 + "%"; }).style("top", function(d) {  return 10.00 + "%"; })
            .style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 80 + "%"; })
            
            chartBottomPanelForTwoAxisesGrpBarChart.style("left", function(d) {  return 10.00 + "%"; }).style("top", function(d) {  return 90.00 + "%"; }).style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 5 + "%"; })
            
            legendDivForTwoAxisesGrpBarChart.style("left", function(d) {  return 80.00 + "%"; }).style("top", function(d) {  return 10.00 + "%"; }).style("width", function(d) {  return 20.00 + "%"; }) .style("height", function(d) { return 80 + "%"; })
            
            commentsPanelDivForTwoAxisesGrpBarChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
        }
        
        if(showOrHideCommentsBtnForTwoAxisesGrpBarChart == true){
            shuffleBtnForTwoXAxisesGrpBarChart.style('margin-left', "2px")
            refreshBtnForTwoXAxisesGrpBarChart.style('margin-left', "2px")
            commentsBtnForTwoAxisesGrpBarChart.style('margin-left', "2px")
            menuButtonForTwoAxisesGrpBarChart.style('right', '0')
        }
        else if(showOrHideCommentsBtnForTwoAxisesGrpBarChart == false){
            //commentsBtnForGroupedBarChart.style('right', '0')
            shuffleBtnForTwoXAxisesGrpBarChart.style('margin-left', "2px")
            refreshBtnForTwoXAxisesGrpBarChart.style('margin-left', "2px")
            commentsBtnForTwoAxisesGrpBarChart.style('display','none')
			menuButtonForTwoAxisesGrpBarChart.style('right', '0')
        }
        
        var colours;
        
        // checking color set for Grouped Bars and legend dots
        if(options.colorSet === undefined){
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "one"){
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            options.colorSet = "two"
            colours = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            options.colorSet = "three"
            colours = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        }
        else
        {
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        
        
        var leftMar = 100/(setOfDataArray.length)
        
        var svgArray = [];
        var rectsGroupArray = [];
        var xAxisLabelsArray = []
        
        var yMaxValueArray = [];
        var maxArray = []
        for(var ii = 0; ii < options.keys.groupBars.length; ii++){
            maxArray = [];
            for(var jj = 0; jj < setOfDataArray.length; jj++){
                setOfDataArray[jj].forEach(function(d) { maxArray.push(+d[options.keys.groupBars[ii]])  })
            }
            yMaxValueArray.push(d3.max(maxArray))
        }
        
        //Adding svg for yAxis in Y-Axis div panel
        var svgPanelForYAxis = yAxisDivForTwoAxisesGrpBarChart .append('svg') .style("background-color", options.BGcolor)
        .style('border-color',"#e1e1e1") .style('border-style',"none") .style("position","absolute")
        .attr('width', 100 + "%") .attr('height', 100 + "%")
        .style("top",0 + "%").style("left",0 + "%").style("border","none").style("border","0px solid #e6e6e6").style("box-sizing","border-box") //.append('g')
        
        var margin = {top: 80 , right: 0, bottom: 80, left: svgPanelForYAxis.node().getBoundingClientRect().width - 1}, //originally top: 42, left: 80
        width = (svgPanelForYAxis.node().getBoundingClientRect().width) - margin.left - margin.right,
        height = svgPanelForYAxis.node().getBoundingClientRect().height - margin.top - margin.bottom;
        
        var yForYAxis = d3.scale.linear() .domain([0, d3.max(yMaxValueArray)]) .range([height, 0]); // for margin.top: 35 d3.max(yMaxValueArray) * 1.31
        
        var yAxis = d3.svg.axis() .scale(yForYAxis) .ticks(5) .orient("left");
        
        /*var hasDecimalPoint = false;
        for(var i = 0; i < options.keys.groupBars.length; i++){
            for(var indx = 0; indx < setOfDataArray.length; indx++){
                for(var j = 0; j < setOfDataArray[indx].length; j++){
                    if(setOfDataArray[indx][j][options.keys.groupBars[i]].toString().indexOf('.') > -1){ hasDecimalPoint = true; break; }
                }
            }
        }
        
        if(hasDecimalPoint == false){ yAxis.tickFormat(d3.format(".2s")) }*/
        
        var svgForYAxis = svgPanelForYAxis.append("svg:g") .style("position","absolute").attr("transform", "translate(" + margin.left + "," + margin.top + ")");
        svgForYAxis.append("g") .attr("class", "y axis") .call(yAxis).selectAll("text") .style("fill","#00001c").style("font-family","Verdana,sans-serif");
        
        //Reverse the order of options.keys.labels
        options.keys.labels.reverse()
        
        commentsBtnForTwoAxisesGrpBarChart.on('click', function() {
                                         
             if(options.showComments == false){
                 options.showComments = true;
             }
             else if(options.showComments == true){
                 options.showComments = false;
             }
             
             d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
             
             for(var i = 0; i<divAndChartsArray.length; i++){
             
                 if(targetElement[0][0].id === divAndChartsArray[i].divID){
                     options.data = divAndChartsArray[i].optionsData
                 }
             }
             acinfotech.twoXAxisesGroupedBarChart(targetElement,options)
                                         
         })
        
        var iconButtonTooltipForTwoXAxisesGrpBarChart = targetElement.append('div').style('width','240px').attr("id","too")
        .style('height',"25px").style('position','absolute')//.style('margin-left', "0px").style('top','25px')
        .style("background-color",'#404040 ').style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid") // 004b9d
        .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none").attr("border", 0.0)
        
        commentsBtnForTwoAxisesGrpBarChart.on('mousemove', function(d,i) {
             commentsPanelDivForTwoAxisesGrpBarChart.style('background-color','#fafafa')
             var root = targetElement
             var m = d3.mouse(root.node());
             m[0] += 0
             m[1] += 0
             if(options.showComments == false){
             var commentButtonTooltipText = "Show Comments";
             }
             else if(options.showComments == true){
             var commentButtonTooltipText = "Hide Comments";
             }
             
             
             iconButtonTooltipForTwoXAxisesGrpBarChart.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
             iconButtonTooltipForTwoXAxisesGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ commentButtonTooltipText +'</div>')
         })
        commentsBtnForTwoAxisesGrpBarChart.on('mouseout', function(d,i) {
             commentsPanelDivForTwoAxisesGrpBarChart.style('background-color','#ffffff')
             iconButtonTooltipForTwoXAxisesGrpBarChart.style("display","none")
         })
        
        //-------- creating tooltip --------
        var tooltipForTwoXAxisesGrpBarChart = targetElement .append('div') .attr('class', 'tooltipForTwoXAxisesGrpBarChartClass') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
        .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
        .style("padding-right", "7px") .style("background", "#ffffff") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style('z-index',1000)
        .style("border", "1.0px") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","80px")
        tooltipForTwoXAxisesGrpBarChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'tooltip-label1-class').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "14px") .style("font-weight", "normal");
        tooltipForTwoXAxisesGrpBarChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'tooltip-label2-class').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "14px") .style("font-weight", "normal");
        tooltipForTwoXAxisesGrpBarChart.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
        tooltipForTwoXAxisesGrpBarChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");
        
        if(options.keys.toolTipLabel.length > 0){
            
            for(toolTipInd = 0; toolTipInd < options.keys.toolTipLabel.length; toolTipInd++){
                tooltipForTwoXAxisesGrpBarChart.append('hr').style("height","1px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
                tooltipForTwoXAxisesGrpBarChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'tooltip-additional-label' + toolTipInd + '-class' ).style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");
            }
        }
        
        // ----------------- Shuffle panel and everything within it section begins here ----------------
        var shufflePanelForTwoXAxisesGrpBarChart = targetElement.append('div').style('width',350 + "px") .attr("class","shufflePanelForTwoXAxisesGrpBarChartClass" + targetElement[0][0].id)
        .style('position','absolute').style('margin-left', "0px")
        .style("background-color",'#fefefe').style("z-index",11).style("border-color", "#ffffff").style("border-right", "solid #e5e5e5 1px")  .style("border-style", "solid") // 004b9d
        .style("box-shadow", "2px 0px 1px #eff8ec").style("display","none").style("border-top", "solid #fdfdfd 1px").style("border-left","0px").style("border-bottom", "0px")
        .style('top', 0.0 + "%").style('height', 100 + "%").style('overflow-y',"hidden").style("overflow-x","hidden")
        .style("border-bottom", "solid #e5e5e5 1px") .style("box-sizing","border-box")
        
        var filterPanelTwoXAxisesGrpBarChartTitle = shufflePanelForTwoXAxisesGrpBarChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','20px').style('text-indent','5px').style("font-size", "14px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #007aff").style("width","350px").style("color","#000000")
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; top:25.0%; font-size:14px; font-family:inter; color:#00001c;">'+ "Shuffle" +'</div>')
        
        var dimensionsColumnTitle = shufflePanelForTwoXAxisesGrpBarChart.append("div") .style("width","170px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; font-weight:Normal; text-align:left; text-indent:3px;">Bottom X-Axis, Top X-Axis.</div>');
        
        var dimensionsVariables = shufflePanelForTwoXAxisesGrpBarChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable1"+targetElement[0][0].id)
        .style("list-style-type","none")
        .style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '78px')
        .style('position','absolute')
        .style("width","332px").style("min-height","57px").style("max-height","57px").style("border", "#f0f0f0 1px solid")
        .style("max-width","332px").style("overflow-x","hidden").style("overflow-y","auto")
        dimensionsVariables.style("left",0.0 + "px").style("padding","2px").style("padding-top","7px")
        
        $( ".shufflePanelForTwoXAxisesGrpBarChartClass" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
			var e0 = e.originalEvent,
			delta = e0.wheelDelta || -e0.detail;

			this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
			e.preventDefault();
        });
        
        var optionsLabels = options.keys.labels;
        //var shuffle = optionsLabels[0]
        var reversedLabels = [];
        reversedLabels.push(optionsLabels[1])
        reversedLabels.push(optionsLabels[0])
        
        var dimensionsVariables1 = dimensionsVariables.selectAll("li") .data(reversedLabels).enter().append("li")
        .style("width","324px") .style("max-height","22px").style("cursor","move")
        .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#f8e9cd").style("font-weight","Normal")
        .style("list-style-type","none").style("border","1px #f2d199 solid").style("color","#9e6c14").style("font-family","Verdana,sans-serif")
        .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
        .text(function(d,i) {return reversedLabels[i]})
        dimensionsVariables1.attr("class","DimensionsClass"+targetElement[0][0].id)
        
        var cancelButton = shufflePanelForTwoXAxisesGrpBarChart.append("div") .style("width","23px").style("height","21px").style('position','absolute')
        .style('margin-left','320px').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white')
        .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.9; background-color:#fcfcff")
        cancelButton[0][0].appendChild(cancelBtnImgVar)
        
        cancelButton.on("click", function(){
            shufflePanelForTwoXAxisesGrpBarChart.style("display","none")
        })
        
        var reRenderChartAndTableButton = shufflePanelForTwoXAxisesGrpBarChart.append("button").style("width","120px").style("height","25px").style('position','absolute')
        .style('margin-left','112px').style('margin-top','185px') .style("border-style", "none").style('background-color',"#2196f3")
        .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','15px').style("border-style", "solid").style('color','#ffffff')
        .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 1px #9b9b9b").style("border-radius","0px")
        var textForReRenderButton = document.createTextNode("Apply Changes");
        reRenderChartAndTableButton[0][0].appendChild(textForReRenderButton)
        
        
        reRenderChartAndTableButton.on("click", function(){
                                       
               var shuffledDimensions = [];
               for(var i=0; i<$("#sortable1"+targetElement[0][0].id).children("li").length;i++){
                   shuffledDimensions.push($("#sortable1"+targetElement[0][0].id).children("li")[i].textContent)
               }
                 
               var newOptions = {
               data: options.data,
			   dataForDrillDown: options.dataForDrillDown,
               keys: {
                   labels: shuffledDimensions.reverse(),
                   groupBars: options.keys.groupBars,
                   toolTipLabel: options.keys.toolTipLabel
               },
               chartTitle: options.chartTitle,
               xAxisLables: shuffledDimensions,
               //yAxisLable: options.yAxisLables,
               showTitle: options.showTitle,
               BGcolor:options.BGcolor,
               series:options.series,
               legend:options.legend,
               colorSet: options.colorSet, //"one" or "two" or "three";
               drillDownColumnName: options.drillDownColumnName,
               showComments: options.showComments,
               comments: options.comments,
               resizeButtonID: options.resizeButtonID
               
               }
               d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
               acinfotech.twoXAxisesGroupedBarChart(targetElement, newOptions)
               
           })
        
        $( "ul.droptrue"+targetElement[0][0].id ).sortable({
               appendTo: document.body,
               helper: "clone",
               connectWith: ".droptrue"+targetElement[0][0].id,
               scroll: false,
               cancel: '.unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+','+' .unMoveableIconAndTextClassDimensions'+targetElement[0][0].id,
               revertDuration: 10,
               scrollSensitivity: 10,
               scrollSpeed: 1,
               dynamic: true,
       });
        
        // ----------------- Shuffle panel and everything within it section ends here -----------------
        
        // Calling the shuffle panel on shuffle button click
        shuffleBtnForTwoXAxisesGrpBarChart.on('click', function() {
                                              
              ismenuButtonOfTwoAxisesGrpBarChartClicked = false
              optionsButtonPanelForTwoAxisesGrpBarChart.style("display","none") // Hiding options buttons panel
              iconButtonTooltipForTwoXAxisesGrpBarChart.style("display","none") // Hiding options tool-tip
                                              
            shufflePanelForTwoXAxisesGrpBarChart.style("display","block");
        })
        
        // Refreshing Chart and Table
        refreshBtnForTwoXAxisesGrpBarChart.on('click', function() {
                                                
            //isFilterClicked = false
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){
                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData;
                    options.keys.labels = newtargetElementAndOptionsArray[i].options.keys.labels;
                }
            }
            acinfotech.twoXAxisesGroupedBarChart(targetElement,options)
            
        })
        
        shuffleBtnForTwoXAxisesGrpBarChart.on('mousemove', function(d,i) {
            var root = targetElement
            var m = d3.mouse(root.node());
            m[0] += 0
            m[1] += 0
            var filterButtonTooltipText = "Shuffle";
            
            iconButtonTooltipForTwoXAxisesGrpBarChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForTwoXAxisesGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')
            
        })
        shuffleBtnForTwoXAxisesGrpBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForTwoXAxisesGrpBarChart.style("display","none")
        })
        
        refreshBtnForTwoXAxisesGrpBarChart.on('mousemove', function(d,i) {
            var root = targetElement
            var m = d3.mouse(root.node());
            m[0] += 0
            m[1] += 0
            var refreshButtonTooltipText = "Refresh";
            
            iconButtonTooltipForTwoXAxisesGrpBarChart.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForTwoXAxisesGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center; ">'+ refreshButtonTooltipText +'</div>')
            
        })
        refreshBtnForTwoXAxisesGrpBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForTwoXAxisesGrpBarChart.style("display","none")
        })
        
        menuButtonForTwoAxisesGrpBarChart.on('mousemove', function(d,i) {
              var root = targetElement
              var m = d3.mouse(root.node());
              m[0] += 0
              m[1] += 0
              var refreshButtonTooltipText = "Menu";
              iconButtonTooltipForTwoXAxisesGrpBarChart.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
              iconButtonTooltipForTwoXAxisesGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center; ">'+ refreshButtonTooltipText +'</div>')
                      
        })
        menuButtonForTwoAxisesGrpBarChart.on('mouseout', function(d,i) {
              iconButtonTooltipForTwoXAxisesGrpBarChart.style("display","none")
        })
        
        searchChartButton.on('mousemove', function(d,i) {
             var root = targetElement
             var m = d3.mouse(root.node());
             m[0] += 0
             m[1] += 0
             var searchChartButtonTooltipText = "Search in Chart";
             
             iconButtonTooltipForTwoXAxisesGrpBarChart.style("width","110px").style("margin-left", (m[0] - 120) + "px").style("margin-top",(m[1]) + "px").style("display","block")
             iconButtonTooltipForTwoXAxisesGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ searchChartButtonTooltipText +'</div>')
         })
        searchChartButton.on('mouseout', function(d,i) {
             iconButtonTooltipForTwoXAxisesGrpBarChart.style("display","none")
         })
        
        searchTableButton.on('mousemove', function(d,i) {
             var root = targetElement
             var m = d3.mouse(root.node());
             m[0] += 0
             m[1] += 0
             var searchTableButtonTooltipText = "Search in Table";
             
             iconButtonTooltipForTwoXAxisesGrpBarChart.style("width","110px").style("margin-left", (m[0] - 120) + "px").style("margin-top",(m[1]) + "px").style("display","block")
             iconButtonTooltipForTwoXAxisesGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ searchTableButtonTooltipText +'</div>')
         })
        searchTableButton.on('mouseout', function(d,i) {
             iconButtonTooltipForTwoXAxisesGrpBarChart.style("display","none")
         })
        
        downloadBtnForTwoAxisesGrpBarChart.on('mousemove', function(d,i) {
              var root = targetElement
              var m = d3.mouse(root.node());
              m[0] += 0
              m[1] += 0
              var downloadButtonTooltipText = "Download";
              
              iconButtonTooltipForTwoXAxisesGrpBarChart.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
              iconButtonTooltipForTwoXAxisesGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
        })
        downloadBtnForTwoAxisesGrpBarChart.on('mouseout', function(d,i) {
              iconButtonTooltipForTwoXAxisesGrpBarChart.style("display","none")
        })
        
        for(var ind = 0; ind < setOfDataArray.length; ind++){
            
            
            //Creating SVG Div holder for chart
            var svgDivPanelForTwoAxisesGrpBarChart = chartDivForTwoAxisesGrpBarChart .append('div') .style("position","absolute").style("left",function(d,index){ return (leftMar * ind )+ "%"; })
            .style("top",0 + "%").style('width', (100/(setOfDataArray.length)) + "%").style('height', 100 + "%").style("background-color", options.BGcolor)
            .style("border","none").style("border-right","0px solid #e6e6e6").style("box-sizing","border-box")
            
            //Creating SVG holder for chart
            var svgPanelForTwoAxisesGrpBarChart = svgDivPanelForTwoAxisesGrpBarChart .append('svg') .style("position","absolute").style("left",function(d,index){ return 0 + "%"; })
            .style("top",0 + "%").attr('width', 100 + "%").attr('height', 100 + "%").style("background-color", options.BGcolor)
            .style("border-right","1px solid #e6e6e6").style("box-sizing","border-box") //.append('g')
            
            var margin = {top: 80 , right: 0, bottom: 80, left: -1}, //originally top: 42, left: 80
            width = (svgPanelForTwoAxisesGrpBarChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = svgPanelForTwoAxisesGrpBarChart.node().getBoundingClientRect().height - margin.top - margin.bottom;
            
            var finalArrayNew = [];
            options.keys.groupBars.forEach(function(d, i) {
                var temp1 = {};
                    temp1["name"] = options.keys.groupBars[i]
                    finalArrayNew.push(temp1)
            })
            
            var finalNewNewArray = [];
            var dataArray1 = [];
            finalArrayNew.forEach(function(d, i) {
                var temp1 = {};
                    temp1["name"] = options.keys.groupBars[i]
                                  
                    for (j = 0; j < setOfDataArray[ind].length; j++) {
                                  
                        var tempTemp = {};
                            tempTemp["label"] = setOfDataArray[ind][j][options.keys.labels[0]];
                            tempTemp["value"] = +setOfDataArray[ind][j][options.keys.groupBars[i]];
                            dataArray1.push(tempTemp)
                    }
                                  
                    temp1["data"] = dataArray1;
                    dataArray1 = []
                    finalNewNewArray.push(temp1)
            })
            
            var dataset = finalNewNewArray.map(function (d,ii) {
                return d.data.map(function (o, index) {
                         
                  return {
                        y: o.value,
                        x: o.label,
                        rectTopLabel: setOfDataArray[ind][index][options.keys.labels[1]], // additionally added
                        rectBottomLabel: setOfDataArray[ind][index][options.keys.labels[0]], // additionally added
                        rectColor: colours(ii), // additionally added
                        rectName: d.name, // additionally added
                        groupIndex: ind // additionally added
                  };
            });
            }),
            xMax = d3.max(dataset, function (group) {
                   return d3.max(group, function (d) {
                       return d.y
                   });
            })
            
            var xAxisLabels = dataset[0].map(function (d) { return d.x; });
            
            var y = d3.scale.linear() .domain([0, d3.max(yMaxValueArray)]) .range([height, 0]);
            
            var x0 = d3.scale.ordinal() .domain(d3.range(xAxisLabels.length)) .rangeBands([0, width], .28);
            
            var x1 = d3.scale.ordinal() .domain(d3.range(finalNewNewArray.length)) .rangeBands([0, x0.rangeBand()]);
            
            var xAxis = d3.svg.axis() .scale(x0) .orient("bottom");
            
            var svg = svgPanelForTwoAxisesGrpBarChart.append("svg").append("g") .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            svg.append('g') .attr("class", "x axis bottomclass") .attr('transform', 'translate(0,' + height + ')') .call(xAxis)
            
            .selectAll("text").data(xAxisLabels) .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') .attr("transform", function(d) { return "rotate(-50)" })
            .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
            .text(function(d,i) {
                  if(d.length > 9){
                    return d.substring(0,9)+'...';
                  }
                  else{
                    return d;
                  }
            })
            
            var groups = svg.append("g").selectAll("g") .data(dataset)
            
			var groups1 = groups.enter().append("g").attr("class","each-bargrouped-class")
			.style("fill", function(d, i) { return colours(i); })
			.attr("transform", function(d, i) {return "translate(" + x1(i) + ",0)"; })
			.selectAll("rect")
			.data(function(d) { return d; })
			.enter().append("rect").attr("x", function(d, i) { return x0(i); })
			.attr("y", height).attr("width", x1.rangeBand()).attr("height", 0)
			.transition().delay(400).duration(800)
			.attr("y", function (d) { return  y(d.y); })
			.attr("height", function (d) { return height - y(d.y); })
			.style('cursor','auto')
            
            if(options.dataForDrillDown.length == 0){
                
                // adding drill down column values to bars
                var columnNames = d3.keys(setOfDataArray[ind][0])
                var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
                
                for(var i = 0; i < columnNames.length ; i++){
                    for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                        if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                            for(var k = 0; k < options.keys.groupBars.length; k++){
                                var len = d3.select(groups[0][k]).selectAll('rect')
								
								for(var l = 0; l < len[0].length; l++){
								
                                    d3.select(len[0][l]).attr('data-drilldownkey', function(d,index){
                                        return JSON.stringify(setOfDataArray[ind][l]).slice(1, -1).split('"').join("").split(':').join("|")
                                    })
                                }
                            }
                        }
                        else {
                        }
                    }
                }
            }
            else if(options.dataForDrillDown.length > 0){
                
				var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
				
				if(options.drillDownColumnName.length > 0){ 
					options.keys.groupBars.forEach(function(measures, i) {
												   var bars = d3.select(groups[0][i]).selectAll('rect')
												   bars[0].forEach(function(d, index) {
																   var dd = d3.select(d)[0]
																   
																   setOfDataArray1[ind].forEach(function(val, i) { 
																									var key, keys = Object.keys(val), n = keys.length, newObj={}; 
																									while (n--) { key = keys[n]; newObj[key.toLowerCase()] = val[key];}
																									var optKeysLabVal = options.keys.labels[0].toString().toLowerCase();
																									
																									if(dd[0].__data__.x.toString().toLowerCase() === newObj[optKeysLabVal].toString().toLowerCase()){
																										
																										//if(dd[0].__data__.y == val[measures]){
																										if(dd[0].__data__.y == newObj[measures.toLowerCase()]){ 
																										d3.select(dd[0]).attr('data-drilldownkey', function(d,index){
																														  return JSON.stringify(val).slice(1, -1).split('"').join("").split(':').join("|")
																														  })
																										}
																									}
																									})
																   })
												   })
				}
            }
            
            
            var format1 = d3.format('.3s')
            var textOnGroupBarChart = groups.selectAll("text")
            .data(function(d) { return d; })
            .enter().append("text").attr("class","text-on-each-bar-class-for-multi-dimension-chart")
            .text(function(d, i) {
                  if(d.y.toString().indexOf('.') === -1)
                  {
                    if(d.y.toString().length <= 3){ return d.y; }
                    else { return format1(d.y); }
                  }
                  else{
                    return format1(d.y);
                  }
            })
            .attr("x", function(d,i) { return 4 - y(d.y); })
            .attr("y", function(d,i) { 
				textWidth = d3.select("text").node().getBoundingClientRect().height;
				computedWidth =  (x1.rangeBand() / 1.4) - (textWidth / 1.4)
				if(computedWidth > 0){ return (x0(i)) + (computedWidth + textWidth / 1.4); }
				else { return (x0(i)) + 10.0; }
            }).attr("transform", "rotate(-90)")
            .style("font-family", "Verdana,sans-serif").style("font-size", "12px").style("text-anchor", "start")
            .style("fill", "#00001c").style('display','none').transition().delay(1400).style('display','none').attr("class","series_value").style("display",options.series)
            
            
            var x2 = d3.scale.ordinal() .domain(setOfDataArray[ind].map(function(d) { return d[options.keys.labels[1]]; })).rangeRoundBands([0, width], 0.25);
            var xAxisTop = d3.svg.axis() .scale(x2) .orient("top")
            
            // Adding the Top X Axis
            var topAxis = svg.append("g").attr("class", "x axis topclass").attr("transform", "translate(0," + -45 + ")") .call(xAxisTop)
            
            // Add the Top X Axis margin labels
            .selectAll("text") .style("text-anchor", "end") .style('fill','#00001c') .attr("transform", function(d) { return "rotate(0)" })
            .style("font-size","12px").style("font-family","Verdana,sans-serif") .style('text-anchor','middle')
            .style("font-family","Verdana,sans-serif").style("font-weight","normal")
            .text(function(d,i) {
				if(d.length > 9)
					return d.substring(0,9)+'...';
				else
					return d;
            })
            
            groups.selectAll('text').on('mousemove', function (d,i){
                                         
                 var root = targetElement
                 var m = d3.mouse(root.node());
                 m[0] += 0
                 m[1] += 0
                 
                 var valueForGrpBarChartToolTip;
                 if(d.y.toString().indexOf('.') === -1)
                 {
                     valueForGrpBarChartToolTip = d.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                 }
                 else{
                     valueForGrpBarChartToolTip = d.y;
                 }
                 
                tooltipForTwoXAxisesGrpBarChart.select('.tooltip-label1-class').html(options.keys.labels[1] + " : " + d.rectTopLabel)
                tooltipForTwoXAxisesGrpBarChart.select('.tooltip-label2-class').html(options.keys.labels[0] + " : " + d.rectBottomLabel)
                tooltipForTwoXAxisesGrpBarChart.select('.count').html(d.rectName + " : " + valueForGrpBarChartToolTip)
                tooltipForTwoXAxisesGrpBarChart.style('visibility', 'visible')
                tooltipForTwoXAxisesGrpBarChart.select('hr').style("background-color", d.rectColor)
                tooltipForTwoXAxisesGrpBarChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-20) + "px").style("display","block")
                                        
                if(options.keys.toolTipLabel.length > 0){
                    for(ind = 0; ind < options.keys.toolTipLabel.length; ind++){
                        tooltipForTwoXAxisesGrpBarChart.select('.tooltip-additional-label' + ind + '-class')
                        .html(options.keys.toolTipLabel[ind] + " : " + setOfDataArray[d.groupIndex][i][options.keys.toolTipLabel[ind]])
                    }
                }
                                        
             })
            .on('mouseout', function(){ tooltipForTwoXAxisesGrpBarChart.style("display","none") })
            
            groups.selectAll('rect').on('mousemove', function (d,i){
                                        
                var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                
                var valueForGrpBarChartToolTip;
                if(d.y.toString().indexOf('.') === -1)
                {
                valueForGrpBarChartToolTip = d.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
                else{
                
                valueForGrpBarChartToolTip = d.y;
                }
                    
                tooltipForTwoXAxisesGrpBarChart.select('.tooltip-label1-class').html(options.keys.labels[1] + " : " + d.rectTopLabel)
                tooltipForTwoXAxisesGrpBarChart.select('.tooltip-label2-class').html(options.keys.labels[0] + " : " + d.rectBottomLabel)
                tooltipForTwoXAxisesGrpBarChart.select('.count').html(d.rectName + " : " + valueForGrpBarChartToolTip)
                tooltipForTwoXAxisesGrpBarChart.style('visibility', 'visible')
                tooltipForTwoXAxisesGrpBarChart.select('hr').style("background-color", d.rectColor)
                tooltipForTwoXAxisesGrpBarChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-20) + "px").style("display","block")
                                        
                if(options.keys.toolTipLabel.length > 0){
                    for(ind = 0; ind < options.keys.toolTipLabel.length; ind++){
                        tooltipForTwoXAxisesGrpBarChart.select('.tooltip-additional-label' + ind + '-class')
                        .html(options.keys.toolTipLabel[ind] + " : " + setOfDataArray[d.groupIndex][i][options.keys.toolTipLabel[ind]])
                    }
                }
                                        
            })
            .on('mouseout', function(){ tooltipForTwoXAxisesGrpBarChart.style("display","none") })
            
            svgArray.push(svgPanelForTwoAxisesGrpBarChart)
            rectsGroupArray.push(groups)
            xAxisLabelsArray.push(xAxisLabels)
            
            //By default calling the resized function to align table's th and td is at the last of chart creating function.
            
            window.addEventListener('resize', function(event){ resizedFuctionForTwoXAxisesGrpBarChart() });
            
            $(function() {
				$("#" + targetElement[0][0].id).resizable({
                    resize: function(event, ui) {
                            divWidth = ui.size.width;
                            divHeight = ui.size.height;
                            resizedFuctionForTwoXAxisesGrpBarChart();
                    }
                });
            });
            
            function resizedFuctionForTwoXAxisesGrpBarChart()
            {
                
                if((svgPanelForYAxis.node().getBoundingClientRect().width) && (svgPanelForYAxis.node().getBoundingClientRect().height) > 0){
                    var marginsForYAxis = {top: 80 , right: 0, bottom: 80, left: svgPanelForYAxis.node().getBoundingClientRect().width - 1}, //originally top: 42, left: 80
                    widthsForYAxis = (svgPanelForYAxis.node().getBoundingClientRect().width) - marginsForYAxis.left - marginsForYAxis.right,
                    heightsForYAxis = (svgPanelForYAxis.node().getBoundingClientRect().height) - marginsForYAxis.top - marginsForYAxis.bottom;
                    
                    yForYAxis.domain([0, d3.max(yMaxValueArray)]) .range([heightsForYAxis, 0]); // for margin.top: 35 d3.max(yMaxValueArray) * 1.31
                    yAxis.scale(yForYAxis) .orient("left");
                    
                    svgPanelForYAxis.select("g") .attr("transform", "translate(" + marginsForYAxis.left + "," + marginsForYAxis.top + ")").style("position","absolute")
                    .call(yAxis)
                }
                
                if((svgPanelForTwoAxisesGrpBarChart.node().getBoundingClientRect().width) && (svgPanelForTwoAxisesGrpBarChart.node().getBoundingClientRect().height) > 0){
                    
                    if(showOrHideCommentsBtnForTwoAxisesGrpBarChart == true){
                        shuffleBtnForTwoXAxisesGrpBarChart.style('margin-left', "2px")
                        refreshBtnForTwoXAxisesGrpBarChart.style('margin-left', "2px")
                        commentsBtnForTwoAxisesGrpBarChart.style('margin-left', "2px")
                        menuButtonForTwoAxisesGrpBarChart.style('right', '0')
                    }
                    else if(showOrHideCommentsBtnForTwoAxisesGrpBarChart == false){
                        //commentsBtnForGroupedBarChart.style('right', '0')
                        shuffleBtnForTwoXAxisesGrpBarChart.style('margin-left', "2px")
                        refreshBtnForTwoXAxisesGrpBarChart.style('margin-left', "2px")
                        commentsBtnForTwoAxisesGrpBarChart.style('display','none')
						menuButtonForTwoAxisesGrpBarChart.style('right', '0')
                    }
                    
                    optionsButtonPanelForTwoAxisesGrpBarChart.style('right', '0')
                    
                    for(var j = 0; j < svgArray.length; j++){
                        var s = d3.select(svgArray[j][0][0])
                        var ss = svgArray[j][0][0]
                        
                        var margin1 = {top: 80 , right: 0, bottom: 80, left: -1}, //originally top: 42, left: 80
                        width1 = (svgPanelForTwoAxisesGrpBarChart.node().getBoundingClientRect().width) - margin1.left - margin1.right,
                        height1 = svgPanelForTwoAxisesGrpBarChart.node().getBoundingClientRect().height - margin1.top - margin1.bottom;
                        
                        y.domain([0, d3.max(yMaxValueArray)]) .range([height1, 0]);
                        
                        x0 .domain(d3.range(xAxisLabelsArray[j].length)) .rangeBands([0, width1], .28);
                        
                        x1.domain(d3.range(finalNewNewArray.length)) .rangeBands([0, x0.rangeBand()]);
                        
                        xAxis.scale(x0) .orient("bottom");
                        
                        var svg1 = s
                        //svg1.attr("transform", "translate(" + margin1.left + "," + margin1.top + ")");
                        
                        d3.select(svgArray[j][0][0]).select("svg").select(".x.axis.bottomclass") .attr('transform', 'translate(0,' + height1 + ')') .call(xAxis)
                        .selectAll("text").data(xAxisLabelsArray[j]) .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') .attr("transform", function(d) { return "rotate(-50)" })
                        .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
                        .text(function(d,i) {
                              if(d.length > 9){
                                return d.substring(0,9)+'...';
                              }
                              else{
                                return d;
                              }
                        })
                        
                        
                        x2.domain(setOfDataArray[j].map(function(d) { return d[options.keys.labels[1]]; })) .rangeRoundBands([0, width1], 0.25);
                        
                        xAxisTop.scale(x2) .orient("top")
                        
                        d3.select(svgArray[j][0][0]).select("svg").select(".x.axis.topclass").attr("transform", "translate(0," + -45 + ")") .call(xAxisTop)
                        
                        var groupsArray = [];
                        
                        var grp = rectsGroupArray[j][0]
                        
                        for(var ii = 0; ii < grp.length; ii++){
                            
                            d3.select(grp[ii]).selectAll("rect").data(function(d,i) { groupsArray[ii] = x1(ii); return d; })
                            .attr("width", x1.rangeBand())
                            .attr("height", function(d) { return height1 - y(d.y) })
                            .attr("x", function(d, i) {  return x0(i); })
                            .attr("y", function(d) { return  y(d.y); })
                            d3.select(grp[ii]).attr("transform", function(d, i) { return "translate(" + groupsArray[ii] + ",0)"; })
                            
                            d3.select(grp[ii]).selectAll("text.text-on-each-bar-class-for-multi-dimension-chart") .attr("x", function(d,i) { return 4 - y(d.y); })
                            .attr("y", function(d,i) {textWidth = d3.select("text").node().getBoundingClientRect().height;
                                  computedWidth =  (x1.rangeBand() / 1.4) - (textWidth / 1.4)
                                  if(computedWidth > 0){
                                    return (x0(i)) + (computedWidth + textWidth / 1.4);
                                  }
                                  else {
                                    return (x0(i)) + 10.0;
                                  }
                            }).attr("transform", "rotate(-90)")
                        }
                        
                        
                        // Aligning Legend (vertically)
                        var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(svgLegendPanelForTwoAxisesGrpBarChart[0][0].style.width) / 100)
                        var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(svgLegendPanelForTwoAxisesGrpBarChart[0][0].style.height) / 100)
                        
                        var legendRectSize = 11;
                        var legendSpacing = 4;
                        
                        if ( showOrHideCommentsForTwoAxisesGrpBarChart == true ){
                            legend.attr('transform', function(d, i) {
                                        var eachRectHeight = legendRectSize + legendSpacing;
                                        var offset =  eachRectHeight * colours.domain().length / 2;
                                        var horz = 0;
                                        var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.groupBars.length))/3.5; // originally 2.0
                                        
                                        return 'translate(' + horz + ',' + vert + ')';
                            })
                         
                        }
                        else if ( showOrHideCommentsForTwoAxisesGrpBarChart == false ){
                            legend.attr('transform', function(d, i) {
                                        var eachRectHeight = legendRectSize + legendSpacing;
                                        var offset =  eachRectHeight * colours.domain().length / 2;
                                        var horz = 0;
                                        var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.groupBars.length))/2.5; // originally 2.0
                                        
                                        return 'translate(' + horz + ',' + vert + ')';
                            })
                        }
                        
                        
                    } // svgArrary for loop
                } // checking svgPanelForColumnChart width & height panel size function ends here.
            } // resizedFuctionForTwoXAxisesGrpBarChart
            
        } // for(var ind = 0; ind < setOfDataArray.length; ind++) Creating SVGs for loop
        
        //-------------- Adding legend section ------------
        var svgLegendPanelForTwoAxisesGrpBarChart = legendDivForTwoAxisesGrpBarChart .append('svg').style('position',"absolute").style("left",0 + "%").style("top",0 + "%")
        .style('width', 100 + "%") .style('height', 100 + "%").style("background-color", options.BGcolor)
        
        var legend = svgLegendPanelForTwoAxisesGrpBarChart.append("g") .attr("class", "legend") .attr("width", "100%").attr("height", "100%")
        
        //Create colour squares
        var legendGroup = legend.selectAll('rect') .data(options.keys.groupBars) .enter() .append("rect") .attr("x", 5)
        .attr("y", function(d, i){ return i * 16;}) .attr("width", 14) .attr("height", 14) .attr("rx",10) .attr("ry",10)
        .style("fill", function(d, i){ return colours(i);}) .style("cursor","auto")
        
        //Create text next to squares
        legend.selectAll('text') .data(options.keys.groupBars) .enter() .append("text") .attr("x", 25) .attr("y", function(d, i){ return i * 16 + 11.8;})
        .attr("fill", "#00001c") .text(function(d,i) { if(d.length > 10)
            return d.substring(0,10)+'...';
            else
            return d;}) .style('font-size', '14px') .attr("fill","#00001c") .style("font-family","Verdana,sans-serif")
        
        // Aligning Legend (vertically)
        var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(svgLegendPanelForTwoAxisesGrpBarChart[0][0].style.width) / 100)
        var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(svgLegendPanelForTwoAxisesGrpBarChart[0][0].style.height) / 100)
        
        var legendRectSize = 11;
        var legendSpacing = 4;
        
        
        if ( showOrHideCommentsForTwoAxisesGrpBarChart == true ){
            legend.attr('transform', function(d, i) {
                var eachRectHeight = legendRectSize + legendSpacing;
                var offset =  eachRectHeight * colours.domain().length / 2;
                var horz = 0;
                var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.groupBars.length))/3.5; // originally 2.0
                
                return 'translate(' + horz + ',' + vert + ')';
            })
            
        }
        else if ( showOrHideCommentsForTwoAxisesGrpBarChart == false ){
            legend.attr('transform', function(d, i) {
                var eachRectHeight = legendRectSize + legendSpacing;
                var offset =  eachRectHeight * colours.domain().length / 2;
                var horz = 0;
                var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.groupBars.length))/2.5; // originally 2.0
                
                return 'translate(' + horz + ',' + vert + ')';
            })
        }
        
        legendGroup.on('mouseover',function(d,index){
           for(var i = 0; i<rectsGroupArray.length; i++){
                    var grp = rectsGroupArray[i][0]
                        for(var ii = 0; ii < grp.length; ii++){
                           d3.select(grp[ii]).selectAll("rect").transition().style('fill-opacity',0.04)
                           d3.select(grp[index]).selectAll("rect").transition().style('fill-opacity',0.95)
                           
                           d3.select(grp[ii]).selectAll("text").transition().style('fill-opacity',0.04)
                           d3.select(grp[index]).selectAll("text").transition().style('fill-opacity',1)
                        }
                }
        })
        
        legendGroup.on('mouseout',function(d,index){
           for(var i = 0; i<rectsGroupArray.length; i++){
                var grp = rectsGroupArray[i][0]
                    for(var ii = 0; ii < grp.length; ii++){
                       d3.select(grp[ii]).selectAll("rect").transition().style('fill-opacity',1)
                       d3.select(grp[ii]).selectAll("text").transition().style('fill-opacity',1)
                    }
            }
       })
        
        //By default calling the resized function first time (to align table's th and td).
        setTimeout(function(){ resizedFuctionForTwoXAxisesGrpBarChart() },1000)
        
        // Called when search in chart button clicked.
        searchChartButton.on('click', function() {
                             
            ismenuButtonOfTwoAxisesGrpBarChartClicked = false
            optionsButtonPanelForTwoAxisesGrpBarChart.style("display","none") // Hiding options buttons panel
            iconButtonTooltipForTwoXAxisesGrpBarChart.style("display","none") // Hiding options tool-tip
                             
            // DIV for holding Search Table
            var chartSearchDivForTwoXAxisesGrpBarChart = targetElement.append('div').style('width',100 + "%").style('height', 100.0 + "%").style('top', 0.0 + "%")
            .style('position','absolute').style('margin-left', "0px") .style("background-color",'#ffffff') .style("z-index",90)
            .style("border-color", "#ffffff") .style("display","block")
            
            // Title DIV for Search Chart
            var searchChartResultDivTitleForTwoXAxisesGrpBarChart = chartSearchDivForTwoXAxisesGrpBarChart.append('div').attr('class','chart-search-input-div-of-two-Xaxises-chart-class')
            .style('background-color',"#e9e9e9").attr("fant-family", "Verdana,sans-serif").style("font-weight", "Bold")
            .style('margin-left','0px').style('margin-top','0px').style('text-indent','3px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
            .style("width","100"+"%").style("height","10" + "%").style("color","#000000")
            
            // Search Text Box for Search panel
            var searchTextBoxForTwoXAxisesGrpBarChart = searchChartResultDivTitleForTwoXAxisesGrpBarChart.append('input').style("width","220px").style('margin-left','1px')
            .style('margin-top','2px')
            .style('position',"absolute").style('height',"26px").style("border", "1.0px") .style("border-color", "#e2e2e2") .style("border-style", "solid").style('text-indent','30px')
            .attr("placeholder","eg: "+ options.data[0][options.keys.labels[0]]).attr("id","autoSearchTextBoxIDForTwoXAxisesGrpBarChart" + targetElement[0][0].id).style("box-sizing","border-box")
            .style("background-image","url('images/searchChart.png')").style("background-repeat","no-repeat") .style("background-size",'18px 18px')
            .style("background-position",'5px 3px') .style("display","block") .style("font-size","14px").style("font-weight","Normal")
            .style("line-height","Normal") .style('outline-width','0px').style("z-index",10)
            
            var canBtnForSearchInChartForTwoXAxisesGrpBarChart = searchChartResultDivTitleForTwoXAxisesGrpBarChart.append("div")
            .attr('class','chart-search-cancel-button-div-of-two-Xaxises-chart-class')
            .style("width","18px").style("height","17px")
            .style('position','absolute')
            .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
            .style('background-color',"#e9e9e9")
            .style("border", "0.0px") .style("border-style", "solid").style('color','white')
            .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
            var cancelBtnImgVar = document.createElement("IMG");
            cancelBtnImgVar.src = "images/closeIcon.png";
            cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.87; background-color:#e9e9e9")
            canBtnForSearchInChartForTwoXAxisesGrpBarChart[0][0].appendChild(cancelBtnImgVar)
            
            // Enabling whole Chart and Table and removing Search panel and Search Table, when Cancel button of Search panel is called.
            canBtnForSearchInChartForTwoXAxisesGrpBarChart.on('click', function() {
                    
				d3.select(chartSearchDivForTwoXAxisesGrpBarChart[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove()
				chartSearchDivForTwoXAxisesGrpBarChart.remove()
                                                  
			})
                             
            //Calling the renderChart function with original data set
            renderChart(options.data)
                             
             // Array to hold searched items (full object)
             var searchResultArrayForTwoXAxisesGrpBarChart = [];
             
             $(document).ready(function(){
                   $("#" + "autoSearchTextBoxIDForTwoXAxisesGrpBarChart" + targetElement[0][0].id).off('input');
                   $("#" + "autoSearchTextBoxIDForTwoXAxisesGrpBarChart" + targetElement[0][0].id).on('keyup', function(){
                       textChangedFunction(this.value)
                   });
             });
                             
             // function to search data in original set of data with Search Box entered value.
             function textChangedFunction (val) {
                 var textBoxValueLowerCased = val //this.value
                 searchResultArrayForTwoXAxisesGrpBarChart = [];
                 
                 options.data.forEach(function(d, i) {
                     for(var i = 0; i<Object.keys(d).length; i++){
                         var lower = d3.values(d)[i].toString().toLowerCase()
                         if ( lower.toLowerCase().indexOf(textBoxValueLowerCased.toString().toLowerCase()) > -1 ) {
                             searchResultArrayForTwoXAxisesGrpBarChart.push(d)
                             break;
                         }
                     }
                 });
                
                  // removing all child element from chart search div
                 d3.select(chartSearchDivForTwoXAxisesGrpBarChart[0][0]).selectAll('div:not(.ui-resizable-handle):not(.chart-search-input-div-of-two-Xaxises-chart-class):not(.chart-search-cancel-button-div-of-two-Xaxises-chart-class),svg,select')
                             .remove();
                             
                renderChart(searchResultArrayForTwoXAxisesGrpBarChart)
             }
                             
     function renderChart(searchedData){
        var reversedDimsLabelArray = options.keys.labels.reverse()
        
        var selectedDimensionsArray = reversedDimsLabelArray;
        var selectedDimsValueArray = [];
        var tempArray = [];
        var finalSelectedDimsValueArray = []
        
        for(var i = 0; i < selectedDimensionsArray.length; i++){
            tempArray = []
            searchedData.forEach(function(d,j){
                for(var k = 0; k<Object.keys(d).length; k++){
                    var lower = d3.keys(d)[k].toString().toLowerCase()
                        if (lower === selectedDimensionsArray[i].toString().toLowerCase()) {
                            tempArray.push(d3.values(d)[k])
                        }
                }
            })
            finalSelectedDimsValueArray.push(tempArray)
        }
        
        var finalSelectedDimsUniqueValuesArray = []
        for(var i = 0; i < finalSelectedDimsValueArray.length; i++){
            tempArray = []
            $.each(finalSelectedDimsValueArray[i], function(i, el){
                if($.inArray(el, tempArray) === -1) tempArray.push(el);
            });
           finalSelectedDimsUniqueValuesArray.push(tempArray)
        }
        
        var finalArray = [];
        var tempArray = [];
        
        var setOfDataArray = []; // Two hold each data
        
        for(var i = 0; i < finalSelectedDimsUniqueValuesArray[0].length; i++){
            tempArray = []
            for(var j = 0; j < finalSelectedDimsUniqueValuesArray[1].length; j++){
                searchedData.forEach(function(d,l){
                    for(var n = 0; n < Object.keys(d).length; n++){
                        var lower = d3.keys(d)[n].toString().toLowerCase();
                            if(lower === selectedDimensionsArray[0].toString().toLowerCase()){
                                if(d3.values(d)[n].toString().toLowerCase() === finalSelectedDimsUniqueValuesArray[0][i].toString().toLowerCase()){
                                    for(var p = 0; p < Object.keys(d).length; p++){
                                        var lower = d3.keys(d)[p].toString().toLowerCase()
                                            if(lower === selectedDimensionsArray[1].toString().toLowerCase()){
                                                if(d3.values(d)[p].toString().toLowerCase() === finalSelectedDimsUniqueValuesArray[1][j].toString().toLowerCase()){
                                                    tempArray.push(d)
                                                    break;
                                                } // if
                                            } // if(lower)
                                    } // for(var p)
                                } //if(d3.values(d[n])
                            }// if(lower)
                    } // for(var n)
                }) // options.data
            } // for(var j)
            setOfDataArray.push(tempArray)
        }// for(var i)
        
        targetElement.style("min-width","350px").style("min-height","350px")
        
        var showOrHideCommentsForTwoAxisesGrpBarChart;
        var showOrHideCommentsBtnForTwoAxisesGrpBarChart = true;
        
        // Show or Hide comments
        if (options.showComments == true || false) {
            showOrHideCommentsForTwoAxisesGrpBarChart = options.showComments;
        }
        else {
            showOrHideCommentsForTwoAxisesGrpBarChart = false;
        }
        
        if (options.comments.length == 0){
            showOrHideCommentsForTwoAxisesGrpBarChart = false;
            showOrHideCommentsBtnForTwoAxisesGrpBarChart = false;
        }
        
        var yAxisDivForTwoAxisesGrpBarChart = chartSearchDivForTwoXAxisesGrpBarChart.append("div").style("position","absolute").style('background-color',"#f0f0f0")
        .style("width", function(d) {  return 10.00 + "%"; }) .style("height", function(d) { return 80 + "%"; }).style("top", function(d) {  return 10.00 + "%"; })
        .style("left", function(d) {  return 0.00 + "%"; })
        .style("border","none").style("border-bottom","0px solid #e6e6e6").style("box-sizing","border-box")
        
        var chartDivForTwoAxisesGrpBarChart = chartSearchDivForTwoXAxisesGrpBarChart.append("div").style("position","absolute").style('background-color',"#ffffff")
        .style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 80 + "%"; }).style("top", function(d) {  return 10.00 + "%"; })
        .style("left", function(d) {  return 10.00 + "%"; })
        .style("border","none").style("border-right","0px solid #808080").style("box-sizing","border-box")
        
        var legendDivForTwoAxisesGrpBarChart = chartSearchDivForTwoXAxisesGrpBarChart.append("div").style("position","absolute").style('background-color',"#fdfdfd")
        .style("width", function(d) {  return 20.00 + "%"; }) .style("height", function(d) { return 80 + "%"; }).style("top", function(d) {  return 10.00 + "%"; })
        .style("left", function(d) {  return 80.00 + "%"; })
        .style("border","none").style("border-bottom","0px solid #e6e6e6").style("box-sizing","border-box")
        
        /*var chartTitlePanelForTwoAxisesGrpBarChart =  chartSearchDivForTwoXAxisesGrpBarChart.append("div").style("position","absolute").style('background-color',"#ffffff")
        .style("text-indent","10px").style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 5 + "%"; }).style("top", function(d) {  return 0.00 + "%"; })
        .style("border","none").style("box-sizing","border-box")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:20.0%; font-size:12px; font-family:inter;color:#00001c;">'+ options.chartTitle +'</div>')*/
        
        //Reverse the order of options.keys.labels
        options.keys.labels.reverse()
        
        var chartTopPanelForTwoAxisesGrpBarChart =  chartSearchDivForTwoXAxisesGrpBarChart.append("div").style("position","absolute").style("text-align", "center").style('background-color',"#ffffff")
        .style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 5 + "%"; }).style("top", function(d) {  return 10.00 + "%"; })
        .style("left", function(d) {  return 10.00 + "%"; }).style("border","none").style("border-bottom","0px solid #e6e6e6").style("box-sizing","border-box")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:20.0%; font-size:12px; font-family:inter; text-transform:uppercase; color:#00001c; font-weight:Bold;">'+ options.keys.labels[1] +'</div>')
        
        var chartBottomPanelForTwoAxisesGrpBarChart =  chartSearchDivForTwoXAxisesGrpBarChart.append("div").style("position","absolute").style("text-align", "center").style('background-color',"#ffffff")
        .style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 5 + "%"; }).style("top", function(d) {  return 90.00 + "%"; })
        .style("left", function(d) {  return 10.00 + "%"; }).style("border","none").style("border-top","0px solid #e6e6e6").style("box-sizing","border-box")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:20.0%; font-size:12px; font-family:inter; text-transform:uppercase; color:#00001c; font-weight:Bold;">'+ options.keys.labels[0] +'</div>')
        
        //Reverse the order of options.keys.labels
        options.keys.labels.reverse()
        
        // Setting svg width, height, top, and left
        yAxisDivForTwoAxisesGrpBarChart.style("left", function(d) {  return 0.00 + "%"; }).style("top", function(d) {  return 15.00 + "%"; }).style("width", function(d) {  return 10.00 + "%"; }) .style("height", function(d) { return 80 + "%"; })
        
        chartDivForTwoAxisesGrpBarChart.style("left", function(d) {  return 10.00 + "%"; }).style("top", function(d) {  return 15.00 + "%"; })
        .style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 80 + "%"; })
        
        chartBottomPanelForTwoAxisesGrpBarChart.style("left", function(d) {  return 10.00 + "%"; }).style("top", function(d) {  return 95.00 + "%"; }).style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 5 + "%"; })
        
        legendDivForTwoAxisesGrpBarChart.style("left", function(d) {  return 80.00 + "%"; }).style("top", function(d) {  return 15.00 + "%"; }).style("width", function(d) {  return 20.00 + "%"; }) .style("height", function(d) { return 80 + "%"; })
        
        
        var leftMar = 100/(setOfDataArray.length)
        
        var svgArray = [];
        var rectsGroupArray = [];
        var xAxisLabelsArray = []
        
        var yMaxValueArray = [];
        var maxArray = []
        for(var ii = 0; ii < options.keys.groupBars.length; ii++){
            maxArray = [];
            for(var jj = 0; jj < setOfDataArray.length; jj++){
                setOfDataArray[jj].forEach(function(d) { maxArray.push(+d[options.keys.groupBars[ii]])  })
            }
            yMaxValueArray.push(d3.max(maxArray))
        }
        
        //Adding svg for yAxis in Y-Axis div panel
        var svgPanelForYAxis = yAxisDivForTwoAxisesGrpBarChart .append('svg') .style('background-color',"#ffffff")
        .style('border-color',"#e1e1e1") .style('border-style',"none") .style("position","absolute")
        .attr('width', 100 + "%") .attr('height', 100 + "%").style("top",0 + "%").style("left",0 + "%").style("border","none").style("border","0px solid #e6e6e6")
        .style("box-sizing","border-box") //.append('g')
        
        var margin = {top: 80 , right: 0, bottom: 55, left: svgPanelForYAxis.node().getBoundingClientRect().width - 1}, //originally top: 42, left: 80
        width = (svgPanelForYAxis.node().getBoundingClientRect().width) - margin.left - margin.right,
        height = svgPanelForYAxis.node().getBoundingClientRect().height - margin.top - margin.bottom;
        
        var yForYAxis = d3.scale.linear() .domain([0, d3.max(yMaxValueArray)]) .range([height, 0]); // for margin.top: 35 d3.max(yMaxValueArray) * 1.31
        
        var yAxis = d3.svg.axis() .scale(yForYAxis) .ticks(5) .orient("left");
        
        /*var hasDecimalPoint = false;
        for(var i = 0; i < options.keys.groupBars.length; i++){
            for(var indx = 0; indx < setOfDataArray.length; indx++){
                for(var j = 0; j < setOfDataArray[indx].length; j++){
                    if(setOfDataArray[indx][j][options.keys.groupBars[i]].toString().indexOf('.') > -1){ hasDecimalPoint = true; break; }
                }
            }
        }
        
        if(hasDecimalPoint == false){ yAxis.tickFormat(d3.format(".2s")) }*/
        
        var svgForYAxis = svgPanelForYAxis.append("svg:g") .style("position","absolute").attr("transform", "translate(" + margin.left + "," + margin.top + ")");
        svgForYAxis.append("g") .attr("class", "y axis") .call(yAxis).selectAll("text") .style("fill","#00001c").style("font-family","Verdana,sans-serif");
        
        //Reverse the order of options.keys.labels
        options.keys.labels.reverse()
        
        for(var ind = 0; ind < setOfDataArray.length; ind++){
            
            //Creating SVG holder for chart
            var svgPanelForTwoAxisesGrpBarChart = chartDivForTwoAxisesGrpBarChart .append('svg') .style("position","absolute").style("left",function(d,index){ return (leftMar * ind )+ "%"; })
            .style("top",0 + "%").attr('width', (100/(setOfDataArray.length)) + "%").attr('height', 100 + "%").style('background-color',"#ffffff")
            .style("border","none").style("border-right","1px solid #e6e6e6").style("box-sizing","border-box") //.append('g')
            
            var margin = {top: 80 , right: 0, bottom: 55, left: -1}, //originally top: 42, left: 80
            width = (svgPanelForTwoAxisesGrpBarChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = svgPanelForTwoAxisesGrpBarChart.node().getBoundingClientRect().height - margin.top - margin.bottom;
            
            var finalArrayNew = [];
            options.keys.groupBars.forEach(function(d, i) {
                var temp1 = {};
                    temp1["name"] = options.keys.groupBars[i]
                    finalArrayNew.push(temp1)
            })
            
            var finalNewNewArray = [];
            var dataArray1 = [];
            finalArrayNew.forEach(function(d, i) {
                var temp1 = {};
                    temp1["name"] = options.keys.groupBars[i]
                                  
                    for (j = 0; j < setOfDataArray[ind].length; j++) {
                                  
                        var tempTemp = {};
                            tempTemp["label"] = setOfDataArray[ind][j][options.keys.labels[0]];
                            tempTemp["value"] = +setOfDataArray[ind][j][options.keys.groupBars[i]];
                            dataArray1.push(tempTemp)
                    }
                                  
                    temp1["data"] = dataArray1;
                    dataArray1 = []
                    finalNewNewArray.push(temp1)
            })
            
            var dataset = finalNewNewArray.map(function (d,ii) {
                return d.data.map(function (o, index) {
                         
                  return {
                        y: o.value,
                        x: o.label,
                        rectTopLabel: setOfDataArray[ind][index][options.keys.labels[1]], // additionally added
                        rectBottomLabel: setOfDataArray[ind][index][options.keys.labels[0]], // additionally added
                        rectColor: colours(ii), // additionally added
                        rectName: d.name, // additionally added
                        groupIndex: ind // additionally added
                  };
            });
            }),
            xMax = d3.max(dataset, function (group) {
                   return d3.max(group, function (d) {
                       return d.y
                   });
            })
            
            var xAxisLabels = dataset[0].map(function (d) { return d.x; });
            
            var y = d3.scale.linear() .domain([0, d3.max(yMaxValueArray)]) .range([height, 0]);
            
            var x0 = d3.scale.ordinal() .domain(d3.range(xAxisLabels.length)) .rangeBands([0, width], .28);
            
            var x1 = d3.scale.ordinal() .domain(d3.range(finalNewNewArray.length)) .rangeBands([0, x0.rangeBand()]);
            
            var xAxis = d3.svg.axis() .scale(x0) .orient("bottom");
            
            var svg = svgPanelForTwoAxisesGrpBarChart.append("svg").append("g") .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            svg.append('g') .attr("class", "x axis bottomclass") .attr('transform', 'translate(0,' + height + ')') .call(xAxis)
            
            .selectAll("text").data(xAxisLabels) .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') .attr("transform", function(d) { return "rotate(-50)" })
            .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
            .text(function(d,i) {
                  if(d.length > 8){
                    return d.substring(0,8)+'...';
                  }
                  else{
                    return d;
                  }
            })
            
            var groups = svg.append("g").selectAll("g") .data(dataset)
            
            var groups1 = groups.enter().append("g").attr("class","each-bargrouped-class").style("fill", function(d, i) { return colours(i); })
            .attr("transform", function(d, i) {return "translate(" + x1(i) + ",0)"; }).selectAll("rect").data(function(d) { return d; })
            .enter().append("rect").transition() .delay(function (d, i) { return i / finalNewNewArray.length * 80; }) .duration(500)
            .attr("width", x1.rangeBand()).attr("height", function(d) { return height - y(d.y) }).attr("x", function(d, i) {   return x0(i); })
            .attr("y", function(d) { return  y(d.y); }).style('cursor','auto')
            
            var format1 = d3.format('.3s')
            var textOnGroupBarChart = groups.selectAll("text").data(function(d) { return d; })
            .enter().append("text").attr("class","text-on-each-bar-class-for-multi-dimension-chart")
            .text(function(d, i) {
                  if(d.y.toString().indexOf('.') === -1)
                  {
                    if(d.y.toString().length <= 3){
                        return d.y;
                    }
                    else{
                        return format1(d.y);
                    }
                  }
                  else{
                    return format1(d.y);
                  }
            })
            .attr("x", function(d,i) { return 4 - y(d.y); })
            .attr("y", function(d,i) {textWidth = d3.select("text").node().getBoundingClientRect().height;
                  computedWidth =  (x1.rangeBand() / 1.4) - (textWidth / 1.4)
                  if(computedWidth > 0){
                    return (x0(i)) + (computedWidth + textWidth / 1.4);
                  }
                  else {
                    return (x0(i)) + 10.0;
                  }
            }).attr("transform", "rotate(-90)") .style("font-family", "Verdana,sans-serif")  .style("font-size", "12px").style("text-anchor", "start").style("fill", "#00001c").style('display','none').attr("class","series_value").style("display",options.series)
            
            
            var x2 = d3.scale.ordinal() .domain(setOfDataArray[ind].map(function(d) { return d[options.keys.labels[1]]; })) .rangeRoundBands([0, width], 0.25);
            var xAxisTop = d3.svg.axis() .scale(x2) .orient("top")
            
            // Adding the Top X Axis
            var topAxis = svg.append("g").attr("class", "x axis topclass").attr("transform", "translate(0," + -45 + ")") .call(xAxisTop)
            
            // Add the Top X Axis margin labels
            .selectAll("text") .style("text-anchor", "end") .style('fill','#00001c') .attr("transform", function(d) { return "rotate(0)" })
            .style("font-size","12px").style("font-family","Verdana,sans-serif") .style('text-anchor','middle') .style("font-family","Verdana,sans-serif").style("font-weight","normal")
            .text(function(d,i) {
                  if(d.length > 9)
                    return d.substring(0,9)+'...';
                  else
                    return d;
            })
            
            svgArray.push(svgPanelForTwoAxisesGrpBarChart)
            rectsGroupArray.push(groups)
            xAxisLabelsArray.push(xAxisLabels)
            
            window.addEventListener('resize', function(event){ searchInChartResizedFuctionForTwoXAxisesGrpBarChart() });
            
            $(function() {
              $("#" + targetElement[0][0].id).resizable({
                    resize: function(event, ui) {
                            divWidth = ui.size.width;
                            divHeight = ui.size.height;
                            searchInChartResizedFuctionForTwoXAxisesGrpBarChart();
                            resizedFuctionForTwoXAxisesGrpBarChart();
                    }
                });
            });
            
            function searchInChartResizedFuctionForTwoXAxisesGrpBarChart()
            {
                
                if((svgPanelForYAxis.node().getBoundingClientRect().width) && (svgPanelForYAxis.node().getBoundingClientRect().height) > 0){
                    var marginsForYAxis = {top: 80 , right: 0, bottom: 55, left: svgPanelForYAxis.node().getBoundingClientRect().width - 1}, //originally top: 42, left: 80
                    widthsForYAxis = (svgPanelForYAxis.node().getBoundingClientRect().width) - marginsForYAxis.left - marginsForYAxis.right,
                    heightsForYAxis = (svgPanelForYAxis.node().getBoundingClientRect().height) - marginsForYAxis.top - marginsForYAxis.bottom;
                    
                    yForYAxis.domain([0, d3.max(yMaxValueArray)]) .range([heightsForYAxis, 0]); // for margin.top: 35 d3.max(yMaxValueArray) * 1.31
                    yAxis.scale(yForYAxis) .orient("left");
                    
                    svgPanelForYAxis.select("g") .attr("transform", "translate(" + marginsForYAxis.left + "," + marginsForYAxis.top + ")").style("position","absolute")
                    .call(yAxis)
                }
                
                if((svgPanelForTwoAxisesGrpBarChart.node().getBoundingClientRect().width) && (svgPanelForTwoAxisesGrpBarChart.node().getBoundingClientRect().height) > 0){
                    
                    canBtnForSearchInChartForTwoXAxisesGrpBarChart.style('right', '0')
                    
                    for(var j = 0; j < svgArray.length; j++){
                        var s = d3.select(svgArray[j][0][0])
                        var ss = svgArray[j][0][0]
                        
                        var margin1 = {top: 80 , right: 0, bottom: 55, left: -1}, //originally top: 42, left: 80
                        width1 = (svgPanelForTwoAxisesGrpBarChart.node().getBoundingClientRect().width) - margin1.left - margin1.right,
                        height1 = svgPanelForTwoAxisesGrpBarChart.node().getBoundingClientRect().height - margin1.top - margin1.bottom;
                        
                        y.domain([0, d3.max(yMaxValueArray)]) .range([height1, 0]);
                        
                        x0 .domain(d3.range(xAxisLabelsArray[j].length)) .rangeBands([0, width1], .28);
                        
                        x1.domain(d3.range(finalNewNewArray.length)) .rangeBands([0, x0.rangeBand()]);
                        
                        xAxis.scale(x0) .orient("bottom");
                        
                        var svg1 = s
                        //svg1.attr("transform", "translate(" + margin1.left + "," + margin1.top + ")");
                        
                        d3.select(svgArray[j][0][0]).select("svg").select(".x.axis.bottomclass") .attr('transform', 'translate(0,' + height1 + ')') .call(xAxis)
                        .selectAll("text").data(xAxisLabelsArray[j]) .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') .attr("transform", function(d) { return "rotate(-50)" })
                        .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
                        .text(function(d,i) {
                              if(d.length > 8){
                                return d.substring(0,8)+'...';
                              }
                              else{
                                return d;
                              }
                        })
                        
                        
                        x2.domain(setOfDataArray[j].map(function(d) { return d[options.keys.labels[1]]; })) .rangeRoundBands([0, width1], 0.25);
                        
                        xAxisTop.scale(x2) .orient("top")
                        
                        d3.select(svgArray[j][0][0]).select("svg").select(".x.axis.topclass").attr("transform", "translate(0," + -45 + ")") .call(xAxisTop)
                        
                        var groupsArray = [];
                        
                        var grp = rectsGroupArray[j][0]
                        
                        for(var ii = 0; ii < grp.length; ii++){
                            
                            d3.select(grp[ii]).selectAll("rect").data(function(d,i) { groupsArray[ii] = x1(ii); return d; }).attr("width", x1.rangeBand())
                            .attr("height", function(d) { return height1 - y(d.y) }).attr("x", function(d, i) {  return x0(i); }).attr("y", function(d) { return  y(d.y); })
                            d3.select(grp[ii]).attr("transform", function(d, i) { return "translate(" + groupsArray[ii] + ",0)"; })
                            
                            d3.select(grp[ii]).selectAll("text.text-on-each-bar-class-for-multi-dimension-chart") .attr("x", function(d,i) { return 4 - y(d.y); })
                            .attr("y", function(d,i) {textWidth = d3.select("text").node().getBoundingClientRect().height;
                                  computedWidth =  (x1.rangeBand() / 1.4) - (textWidth / 1.4)
                                  if(computedWidth > 0){
                                    return (x0(i)) + (computedWidth + textWidth / 1.4);
                                  }
                                  else {
                                    return (x0(i)) + 10.0;
                                  }
                            }).attr("transform", "rotate(-90)")
                        }
                        
                        
                        // Aligning Legend (vertically)
                        var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(svgLegendPanelForTwoAxisesGrpBarChart[0][0].style.width) / 100)
                        var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(svgLegendPanelForTwoAxisesGrpBarChart[0][0].style.height) / 100)
                        
                        var legendRectSize = 11;
                        var legendSpacing = 4;
                        
                        
                        legend.attr('transform', function(d, i) {
                            var eachRectHeight = legendRectSize + legendSpacing;
                            var offset =  eachRectHeight * colours.domain().length / 2;
                            var horz = 0;
                            var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.groupBars.length))/2.5; // originally 2.0
                            
                            return 'translate(' + horz + ',' + vert + ')';
                        })
                        
                    } // svgArrary for loop
                } // checking svgPanelForColumnChart width & height panel size function ends here.
            } // searchInChartResizedFuctionForTwoXAxisesGrpBarChart
            
        } // for(var ind = 0; ind < setOfDataArray.length; ind++) Creating SVGs for loop
        
        //------- Adding legend section ------
        var svgLegendPanelForTwoAxisesGrpBarChart = legendDivForTwoAxisesGrpBarChart .append('svg').style('position',"absolute").style("left",0 + "%").style("top",0 + "%")
        .style('width', 100 + "%") .style('height', 100 + "%").style('background-color',"#ffffff")
        
        var legend = svgLegendPanelForTwoAxisesGrpBarChart.append("g") .attr("class", "legend") .attr("width", "100%").attr("height", "100%")
        
        //Create colour squares
        var legendGroup = legend.selectAll('rect') .data(options.keys.groupBars) .enter() .append("rect") .attr("x", 5)
        .attr("y", function(d, i){ return i * 16;}) .attr("width", 14) .attr("height", 14) .attr("rx",10) .attr("ry",10)
        .style("fill", function(d, i){ return colours(i);}) .style("cursor","auto")
        
        //Create text next to squares
        legend.selectAll('text') .data(options.keys.groupBars) .enter() .append("text") .attr("x", 25) .attr("y", function(d, i){ return i * 16 + 11.8;})
        .attr("fill", "#00001c") .text(function(d,i) { if(d.length > 10)
            return d.substring(0,10)+'...';
            else
            return d;}) .style('font-size', '14px') .attr("fill","#00001c") .style("font-family","Verdana,sans-serif")
        
        // Aligning Legend (vertically)
        var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(svgLegendPanelForTwoAxisesGrpBarChart[0][0].style.width) / 100)
        var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(svgLegendPanelForTwoAxisesGrpBarChart[0][0].style.height) / 100)
        
        var legendRectSize = 11;
        var legendSpacing = 4;
        
        
        legend.attr('transform', function(d, i) {
            var eachRectHeight = legendRectSize + legendSpacing;
            var offset =  eachRectHeight * colours.domain().length / 2;
            var horz = 0;
            var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.groupBars.length))/2.5; // originally 2.0
            
            return 'translate(' + horz + ',' + vert + ')';
        })
        
        legendGroup.on('mouseover',function(d,index){
           for(var i = 0; i<rectsGroupArray.length; i++){
                var grp = rectsGroupArray[i][0]
                    for(var ii = 0; ii < grp.length; ii++){
                       d3.select(grp[ii]).selectAll("rect").transition().style('fill-opacity',0.04)
                       d3.select(grp[index]).selectAll("rect").transition().style('fill-opacity',0.95)
                       
                       d3.select(grp[ii]).selectAll("text").transition().style('fill-opacity',0.04)
                       d3.select(grp[index]).selectAll("text").transition().style('fill-opacity',1)
                    }
            }
        })
        
        legendGroup.on('mouseout',function(d,index){
           for(var i = 0; i<rectsGroupArray.length; i++){
                var grp = rectsGroupArray[i][0]
                for(var ii = 0; ii < grp.length; ii++){
                   d3.select(grp[ii]).selectAll("rect").transition().style('fill-opacity',1)
                   d3.select(grp[ii]).selectAll("text").transition().style('fill-opacity',1)
                }
            }
       })
        
        //By default calling the resized function first time (to align table's th and td).
        //resizedFuctionForTwoXAxisesGrpBarChart()
         } // renderChart()
      }) // chart search button click function

        // Called when search in table button clicked.
        searchTableButton.on('click', function() {
	
             ismenuButtonOfTwoAxisesGrpBarChartClicked = false
             optionsButtonPanelForTwoAxisesGrpBarChart.style("display","none") // Hiding options buttons panel
             iconButtonTooltipForTwoXAxisesGrpBarChart.style("display","none") // Hiding options tool-tip
             
             // DIV for holding Search Table
             var tableDivForTwoXAxisesGrpBarChart = targetElement.append('div').style('width',100 + "%").style('height', 100.0 + "%").style('top', 0.0 + "%")
             .style('position','absolute').style('margin-left', "0px") .style("background-color",'#ffffff') .style("z-index",90)
             .style("border-color", "#ffffff") .style("display","block")
             
             // Title DIV for Search Table
             var searchTableResultDivTitleForTwoXAxisesGrpBarChart = tableDivForTwoXAxisesGrpBarChart.append('div').attr('class','chart-search-input-div-of-two-Xaxises-chart-class')
             .style('background-color',"#e9e9e9").attr("fant-family", "Verdana,sans-serif").style("font-weight", "Bold")
             .style('margin-left','0px').style('margin-top','0px').style('text-indent','3px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
             .style("width","100"+"%").style("height","10" + "%").style("color","#000000")
             
             // Search Text Box for Search panel
             var searchTextBoxForTwoXAxisesGrpBarChart = searchTableResultDivTitleForTwoXAxisesGrpBarChart.append('input').style("width","220px").style('margin-left','1px')
             .style('margin-top','2px')
             .style('position',"absolute").style('height',"26px").style("border", "1.0px") .style("border-color", "#e2e2e2") .style("border-style", "solid").style('text-indent','30px')
             .attr("placeholder","eg: "+ options.data[0][options.keys.labels[0]]).attr("id","autoSearchTextBoxIDForTwoXAxisesGrpBarChart" + targetElement[0][0].id).style("box-sizing","border-box")
             .style("background-image","url('images/searchChart.png')").style("background-repeat","no-repeat") .style("background-size",'18px 18px')
             .style("background-position",'5px 3px') .style("display","block") .style("font-size","14px").style("font-weight","Normal")
             .style("line-height","Normal") .style('outline-width','0px').style("z-index",10)
             
             var canBtnForSearchInChartForTwoXAxisesGrpBarChart = searchTableResultDivTitleForTwoXAxisesGrpBarChart.append("div")
             .attr('class','chart-search-cancel-button-div-of-two-Xaxises-chart-class')
             .style("width","18px").style("height","17px")
             .style('position','absolute')
             .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
             .style('background-color',"#e9e9e9")
             .style("border", "0.0px") .style("border-style", "solid").style('color','white')
             .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
			 
             var cancelBtnImgVar = document.createElement("IMG");
             cancelBtnImgVar.src = "images/closeIcon.png";
             cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.87; background-color:#e9e9e9")
             canBtnForSearchInChartForTwoXAxisesGrpBarChart[0][0].appendChild(cancelBtnImgVar)
             
             // Enabling whole Chart and Table and removing Search panel and Search Table, when Cancel button of Search panel is called.
             canBtnForSearchInChartForTwoXAxisesGrpBarChart.on('click', function() {
                                                               
                   d3.select(tableDivForTwoXAxisesGrpBarChart[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove()
                   tableDivForTwoXAxisesGrpBarChart.remove()
                   
                   /*d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                    
                    for(var i = 0; i<divAndChartsArray.length; i++){
                    if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                    }
                    }
                    acinfotech.twoXAxisesGroupedBarChart(targetElement,options)*/
                                                               
               })
                             
            // DIV for holing only Search Table
            var searchResultTablePanelForColumnChart =  tableDivForTwoXAxisesGrpBarChart.append("div")
            .attr("class", "searchResultTablePanelForColumnChart" + targetElement[0][0].id) .style('background-color',"#ffffff")
            .style('position','absolute') .style("display","block") .style("overflow","auto") .style("width", function(d) {  return 100.0 + "%"; }) 
            .style("height", function(d) { return 90 + "%"; }) .style("top","10"+"%") .style("left",0 + "%")
            
            // Creating Table (Search Table)
            searchResultTablePanelForColumnChart.html('<table  border="0px" style=" width:99.9%; height:auto;   position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9px; border-collapse:collapse; border-color:#ebf5e6; " >'+
              '<thead  style="background-color:#DFF0D8;">' +'</thead>'+
              '<tbody class="myTBody" style="background-color:white; width:99.9%; height:auto;  ">'+'</tbody>'+
              '</table>'
              )
            searchResultTablePanelForColumnChart.select("table").attr("id","searchTableIdForTwoXAxisGrpBarChart" + targetElement[0][0].id)

           

            var thead = searchResultTablePanelForColumnChart.select("thead").selectAll("th") .data(d3.keys(options.data[0]))
            .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1) + " "}).style("min-width","100px")
        
            var tr = searchResultTablePanelForColumnChart.select("tbody").selectAll("tr") .data(options.data).enter().append("tr") //.style("background-color",function(d,i){  return colors(i);})
        
            var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d})
            .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")

            

            // Styling the Search Table Rows.
            searchResultTablePanelForColumnChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
            .style("color","#00001c").style("height","25px").style("border", "1px solid #e9e9ea").style("background-color","#f6f6f6") 
            searchResultTablePanelForColumnChart.selectAll('td').style("height","25px") .style("border", "1px solid #f8f8f8") .style("font-size","12px").style("font-weight","Normal").style("color","#00001c")
                             
             // Array to hold searched items (full object)
             var searchResultArrayForTwoXAxisesGrpBarChart = [];
             
             $(document).ready(function(){
                   $("#" + "autoSearchTextBoxIDForTwoXAxisesGrpBarChart" + targetElement[0][0].id).off('input');
                   $("#" + "autoSearchTextBoxIDForTwoXAxisesGrpBarChart" + targetElement[0][0].id).on('keyup', function(){
                      textChangedFunction(this.value)
                   });
             });
             
             // function to search data in original set of data with Search Box entered value.
             function textChangedFunction (val) {
                 var textBoxValueLowerCased = val //this.value
                 searchResultArrayForTwoXAxisesGrpBarChart = [];
                 
                 options.data.forEach(function(d, i) {
                      for(var i = 0; i<Object.keys(d).length; i++){
                          var lower = d3.values(d)[i].toString().toLowerCase()
                          if ( lower.toLowerCase().indexOf(textBoxValueLowerCased.toString().toLowerCase()) > -1 ) {
                              searchResultArrayForTwoXAxisesGrpBarChart.push(d)
                              break;
                          }
                      }
                  });
                 
                 // removing all child element from chart search div
                 //d3.select(tableDivForTwoXAxisesGrpBarChart[0][0]).selectAll('div:not(.ui-resizable-handle):not(.chart-search-input-div-of-two-Xaxises-chart-class):not(.chart-search-cancel-button-div-of-two-Xaxises-chart-class),svg,select')
                 //.remove();
                 
                 reRenderTable(searchResultArrayForTwoXAxisesGrpBarChart)
             }
                             
            function reRenderTable(searchResult){
            
                // Removing the Search Table Rows
                var table = searchResultTablePanelForColumnChart.select('table');
                var rows = table.selectAll('tr')
                rows.remove();

                // Creating new Rows for Search Table based on Searched Result (using searchTextBoxArrayForPieChart array)
                var table = searchResultTablePanelForColumnChart.select('table');
                var rows = table.selectAll('tr').data(searchResult);
                var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})

                cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition()
                .delay(20) .duration(20) .style('opacity', 1.0).style("color","#00001c");
                
                cells.text(function(d,i) {return d});

                // Cells exit selection
                cells.exit() .attr('class', 'exit') .transition() .delay(20) .duration(20) .style('opacity', 0.0) .remove();
                
                var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})

                cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(20)
                .duration(20) .style('opacity', 1.0).style("color","#00001c");

                

                var t = document.getElementById("searchTableIdForTwoXAxisGrpBarChart" + targetElement[0][0].id).tBodies[0]
                
                cells_in_new_rows.text(function(d,i) {return d});

                rows.exit() .attr('class', 'exit') .transition() .delay(20) .duration(20) .style('opacity', 0.0) .remove();
                             
             
                // Checking the Browser
                if(navigator.userAgent.indexOf("Firefox") != -1 )
                {
                    searchResultTablePanelForColumnChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("text-align","left").style("padding-left","6px").style("color","#00001c")
                    .style("height","25px") .style("border", "1px solid #e9e9ea").style("background-color","#f6f6f6")
                
                    searchResultTablePanelForColumnChart.selectAll('td').style("height","25px") .style("border", "1px solid #f8f8f8") .style("font-size","12px").style("padding-left","6px")
					.style("font-weight","Normal").style("color","#00001c")
                }

                else{
                    searchResultTablePanelForColumnChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("text-align","left").style("padding-left","6px").style("color","#00001c")
                    .style("height","25px") .style("border", "1px solid #e9e9ea").style("background-color","#f6f6f6")  
                
                    searchResultTablePanelForColumnChart.selectAll('td').style("height","25px") .style("border", "1px solid #f8f8f8") .style("font-size","12px").style("padding-left","6px")
                    .style("font-weight","Normal").style("color","#00001c")
                             
                }

            }
            
            // Disabling Browser page scrolling when Search left panel appears
            $( '.searchDivForColumnChartForSearchTableClass' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
                var e0 = e.originalEvent,
                delta = e0.wheelDelta || -e0.detail;
    
                this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
                e.preventDefault();
            });

            // Disabling Browser page scrolling when Search Table appears
            $( '.searchResultTablePanelForColumnChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
                var e0 = e.originalEvent,
                delta = e0.wheelDelta || -e0.detail;
    
                this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
                e.preventDefault();
            });
            
			window.addEventListener('resize', function(event){
				resizedFuctionForTwoXAxisesGrpBarChart()
				searchInTableResizedFuctionForTwoXAxisesGrpBarChart()
			});
             
             $(function() {
               $("#" + targetElement[0][0].id).resizable({
                     resize: function(event, ui) {
                         divWidth = ui.size.width;
                         divHeight = ui.size.height;
                         resizedFuctionForTwoXAxisesGrpBarChart()
                         searchInTableResizedFuctionForTwoXAxisesGrpBarChart();
                     }
                 });
               });
             
             function searchInTableResizedFuctionForTwoXAxisesGrpBarChart()
             {
                canBtnForSearchInChartForTwoXAxisesGrpBarChart.style('right', '0')
             }
                             
        }) // search table button
        
        downloadBtnForTwoAxisesGrpBarChart.on('click', function() {
                                  
          ismenuButtonOfTwoAxisesGrpBarChartClicked = false; // Changing menu button value to false
          optionsButtonPanelForTwoAxisesGrpBarChart.style("display","none") // Hiding option buttons panel
                                  
        })

    }, // twoXAxisesGroupedBarChart


    // ************************************************** Three X-Axises Grouped Bar Chart  **************************************************
    threeXAxisesGroupedBarChart: function(targetElement, options){
        
        isChartCalled++;
        
        var chartName = "THREEXAXISESGROUPEDBARCHART";
        
        acinfotech.allCharts(targetElement,options,chartName);
        
        targetElement.style("min-width","350px").style("min-height","350px").style("background-color", options.BGcolor)
        
        var reversedDimsLabelArray = options.keys.labels.reverse()
        
        var selectedDimensionsArray = reversedDimsLabelArray;
        var selectedDimsValueArray = [];
        var tempArray = [];
        var finalSelectedDimsValueArray = []
        
        for(var i = 0; i < selectedDimensionsArray.length; i++){
            tempArray = []
            options.data.forEach(function(d,j){
				for(var k = 0; k<Object.keys(d).length; k++){
					var lower = d3.keys(d)[k].toString().toLowerCase()
					if (lower === selectedDimensionsArray[i].toString().toLowerCase()) {
						tempArray.push(d3.values(d)[k])
					}
				}
			})
            finalSelectedDimsValueArray.push(tempArray)
        }
        
        var finalSelectedDimsUniqueValuesArray = []
        for(var i = 0; i < finalSelectedDimsValueArray.length; i++){
            tempArray = []
            $.each(finalSelectedDimsValueArray[i], function(i, el){
                   if($.inArray(el, tempArray) === -1) tempArray.push(el);
		    });
            finalSelectedDimsUniqueValuesArray.push(tempArray)
        }
        
        var finalArray = [];
        var tempArray = [];
        
        var setOfDataArray = []; // Two hold each data
        
        for(var i = 0; i < finalSelectedDimsUniqueValuesArray[0].length; i++){
            tempArray = []
            for(var j = 0; j < finalSelectedDimsUniqueValuesArray[1].length; j++){
                options.data.forEach(function(d,l){
                     for(var n = 0; n < Object.keys(d).length; n++){
                         var lower = d3.keys(d)[n].toString().toLowerCase();
                             if(lower === selectedDimensionsArray[0].toString().toLowerCase()){
                                 if(d3.values(d)[n].toString().toLowerCase() === finalSelectedDimsUniqueValuesArray[0][i].toString().toLowerCase()){
                                     for(var p = 0; p < Object.keys(d).length; p++){
                                        var lower = d3.keys(d)[p].toString().toLowerCase()
                                        if(lower === selectedDimensionsArray[1].toString().toLowerCase()){
                                            if(d3.values(d)[p].toString().toLowerCase() === finalSelectedDimsUniqueValuesArray[1][j].toString().toLowerCase()){
                                                tempArray.push(d)
                                                break;
                                            } // if
                                         } // if(lower)
                                     } // for(var p)
                                 } //if(d3.values(d[n])
                             }// if(lower)
                         } // for(var n)
                 }) // options.data
            } // for(var j)
            setOfDataArray.push(tempArray)
        }// for(var i)
        
        var thirdDimSetOfDataArray = [];
        var tempArray = []
        
        for(var i = 0; i < finalSelectedDimsUniqueValuesArray[2].length; i++){
            tempArray = [];
            for(var j = 0; j < setOfDataArray.length; j++){
                setOfDataArray[j].forEach(function(d,l){
                                          
                        for(var m = 0; m < Object.keys(d).length; m++){
                            var lower = d3.keys(d)[m].toString().toLowerCase();
                            if(lower === selectedDimensionsArray[2].toString().toLowerCase()){
                                if(d3.values(d)[m].toString().toLowerCase() === finalSelectedDimsUniqueValuesArray[2][i].toString().toLowerCase()){
                                    tempArray.push(d);
                                    break;
                                }
                            }
                        }
                    })
            }
            thirdDimSetOfDataArray.push(tempArray)
        }
        
        options.keys.labels.reverse()
        
        var shuffledArrayForThreeXAxisesGrpBarChart = [];
        for(var i = 0; i < thirdDimSetOfDataArray.length; i++){
            for(j = 0; j < thirdDimSetOfDataArray[i].length; j++){
                shuffledArrayForThreeXAxisesGrpBarChart.push(thirdDimSetOfDataArray[i][j])
            }
        }
        
        
        var colours;
        
        // checking color set for Grouped Bars and legend dots
        if(options.colorSet === undefined){
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "one"){
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            options.colorSet = "two"
            colours = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            options.colorSet = "three"
            colours = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        }
        else
        {
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        
        var chartTitlePanelForThreeAxisesGrpBarChart =  targetElement.append("div").style("position","absolute").style("background-color", options.BGcolor)
        .style("text-indent","10px").style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 5 + "%"; }).style("top", function(d) {  return 0.00 + "%"; })
        .style("border","none").style("box-sizing","border-box")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:20.0%; font-size:12px; font-family:inter;color:#00001c;">'+ options.chartTitle +'</div>')
        
        var chartDivForThreeAxisesGrpBarChart = targetElement.append("div").style("position","absolute").style("background-color", options.BGcolor).attr('class', 'scrollingDivForThreeXAxisesGrpBarChartClass' + targetElement[0][0].id)
        .style("left", function(d) {  return 0.00 + "%"; })
        .style("top",function(d,index){ return 5 + "%"; })
        .style("width", function(d) {  return 80.00 + "%"; })
        .style("height",function(d) {  return 90.00 + "%"; })
        .style("border","none").style("box-sizing","border-box").style("overflow-x","hidden").style("overflow-y","scroll")
        
        $( ".scrollingDivForThreeXAxisesGrpBarChartClass" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
             var e0 = e.originalEvent,
             delta = e0.wheelDelta || -e0.detail;
             
             this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
             e.preventDefault();
         });
        
        var legendDivForThreeAxisesGrpBarChart = targetElement.append("div").style("position","absolute").style("background-color", options.BGcolor)
        .style("left", function(d) {  return 81.00 + "%"; }).style("top", function(d) {  return 10.00 + "%"; }).style("width", function(d) {  return 19.00 + "%"; })
        .style("height", function(d) { return 80 + "%"; }).style("border","none").style("border-bottom","0px solid #e6e6e6").style("box-sizing","border-box")
        
        
        //-------- creating tooltip --------
        var tooltipForThreeXAxisesGrpBarChart = targetElement .append('div') .attr('class', 'tooltipForThreeXAxisesGrpBarChartClass') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
        .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
        .style("padding-right", "7px") .style("background", "#ffffff") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style('z-index',1000)
        .style("border", "1.0px") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","80px")
        tooltipForThreeXAxisesGrpBarChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'tooltip-label1-class').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "14px") .style("font-weight", "normal");
        tooltipForThreeXAxisesGrpBarChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'tooltip-label2-class').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "14px") .style("font-weight", "normal");
        tooltipForThreeXAxisesGrpBarChart.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
        tooltipForThreeXAxisesGrpBarChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");
        
        if(options.keys.toolTipLabel.length > 0){
            
            for(toolTipInd = 0; toolTipInd < options.keys.toolTipLabel.length; toolTipInd++){
                tooltipForThreeXAxisesGrpBarChart.append('hr').style("height","1px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
                tooltipForThreeXAxisesGrpBarChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'tooltip-additional-label' + toolTipInd + '-class' ).style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");
            }
        }
        
		var optionsButtonPanelForThreeAxisesGrpBarChart = targetElement.append('div').style('width',"25px").style('height',"80px").style('position','absolute')
        .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px")
        .style('right', '0').style("min-width","25px")
        .style("border-style","none").style("border-left", "solid #fcfcfc  1px")//.style("top",71.5 + "px")
		
        //-------- adding shuffle and refresh button --------
        var shuffleBtnForThreeXAxisesGrpBarChart = optionsButtonPanelForThreeAxisesGrpBarChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10).style('right', '0')
        .style('top','25px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var filterBtnImgVar = document.createElement("IMG");
        filterBtnImgVar.src = "images/shuffleIcon.png";
        filterBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.9;")
        shuffleBtnForThreeXAxisesGrpBarChart[0][0].appendChild(filterBtnImgVar)
        
        var refreshBtnForThreeXAxisesGrpBarChart = optionsButtonPanelForThreeAxisesGrpBarChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10).style('right', '0')
        .style('top','50px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var refreshBtnImgVar = document.createElement("IMG");
        refreshBtnImgVar.src = "images/refreshIcon.png";
        refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.9;")
        refreshBtnForThreeXAxisesGrpBarChart[0][0].appendChild(refreshBtnImgVar)
        
        var menuButtonForThreeAxisesGrpBarChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10).style('right', '0')
        .style('top','1px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var menuBtnImgVar = document.createElement("IMG");
        menuBtnImgVar.src = "images/menuIcon.png";
        menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
        menuButtonForThreeAxisesGrpBarChart[0][0].appendChild(menuBtnImgVar)
        
        var ismenuButtonOfThreeAxisesGrpBarChartClicked = false; // Menu toggle button variable
        menuButtonForThreeAxisesGrpBarChart.on('click', function() {
                                             
             shufflePanelForThreeXAxisesGrpBarChart.style("display","none");
             
             if(ismenuButtonOfThreeAxisesGrpBarChartClicked == false){ // Checking if menu button is clicked
                 ismenuButtonOfThreeAxisesGrpBarChartClicked = true; // Menu toggle button variable
                 optionsButtonPanelForThreeAxisesGrpBarChart.style("display","block") // Showing option buttons menu panel
             }
             else if(ismenuButtonOfThreeAxisesGrpBarChartClicked == true){ // Checking if menu button is clicked
                 ismenuButtonOfThreeAxisesGrpBarChartClicked = false
                 optionsButtonPanelForThreeAxisesGrpBarChart.style("display","none") // Hiding option buttons panel
             }
                                             
        })
        
        var downloadBtnForThreeAxisesGrpBarChart = optionsButtonPanelForThreeAxisesGrpBarChart.append("div").attr("id","downloadBtnForThreeAxisesGrpBarChart-ID-" + targetElement[0][0].id)
        .style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff")
        .style('margin-left','2px').style('top','1px').style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        
        acinfotech.downloadFunctionality("downloadBtnForThreeAxisesGrpBarChart-ID-" + targetElement[0][0].id,targetElement)
        
        // ----------------- Shuffle panel and everything within it section begins here ----------------
        var shufflePanelForThreeXAxisesGrpBarChart = targetElement.append('div').style('width',350 + "px") .attr("class","shufflePanelForThreeXAxisesGrpBarChartClass" + targetElement[0][0].id)
        .style('position','absolute').style('margin-left', "0px")
        .style("background-color",'#fefefe').style("z-index",11).style("border-color", "#ffffff").style("border-right", "solid #e5e5e5 1px")  .style("border-style", "solid") // 004b9d
        .style("box-shadow", "2px 0px 1px #eff8ec").style("display","none").style("border-top", "solid #fdfdfd 1px").style("border-left","0px").style("border-bottom", "0px")
        .style('top', 0.0 + "%").style('height', 100 + "%").style('overflow-y',"hidden").style("overflow-x","hidden")
        .style("border-bottom", "solid #e5e5e5 1px") .style("box-sizing","border-box")
        
        var filterPanelThreeXAxisesGrpBarChartTitle = shufflePanelForThreeXAxisesGrpBarChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','20px').style('text-indent','5px').style("font-size", "14px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #007aff").style("width","350px").style("color","#000000")
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; top:25.0%; font-size:14px; font-family:inter; color:#00001c;">'+ "Shuffle" +'</div>')
        
        var measuresColumnTitle = shufflePanelForThreeXAxisesGrpBarChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:12px; font-family:inter; color:#00001c; text-align:left; text-indent:3px;">'+ options.keys.labels[0].charAt(0).toUpperCase() + options.keys.labels[0].substr(1) + " " +'</div>');
        
        var dimensionsVariables = shufflePanelForThreeXAxisesGrpBarChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable1"+targetElement[0][0].id)
        .style("list-style-type","none")
        .style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '78px')
        .style('position','absolute')
        .style("width","296px").style("min-height","190px").style("max-height","190px").style("border", "#f0f0f0 1px solid")
        .style("max-width","296px").style("overflow-x","hidden").style("overflow-y","auto")
        dimensionsVariables.style("left",0.0 + "px").style("padding","2px")
        
        $( ".shufflePanelForThreeXAxisesGrpBarChartClass" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
            
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });
        
        var dimensionsVariables1 = dimensionsVariables.selectAll("li") .data(finalSelectedDimsUniqueValuesArray[2]).enter().append("li")
        .style("width","271px") .style("max-height","22px").style("cursor","move")
        .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#f8e9cd").style("font-weight","Normal")
        .style("list-style-type","none").style("border","1px #f2d199 solid").style("color","#9e6c14").style("font-family","Verdana,sans-serif")
        .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
        .text(function(d,i) {return finalSelectedDimsUniqueValuesArray[2][i]})
        dimensionsVariables1.attr("class","DimensionsClass"+targetElement[0][0].id)
        
        var cancelButton = shufflePanelForThreeXAxisesGrpBarChart.append("div") .style("width","23px").style("height","21px").style('position','absolute')
        .style('margin-left','320px').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white')
        .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.9; background-color:#fcfcff")
        cancelButton[0][0].appendChild(cancelBtnImgVar)
        
        cancelButton.on("click", function(){
            shufflePanelForThreeXAxisesGrpBarChart.style("display","none")
        })
        
        var reRenderChartAndTableButton = shufflePanelForThreeXAxisesGrpBarChart.append("button").style("width","120px").style("height","25px").style('position','absolute')
        .style('margin-left','112px').style('margin-top','298px') .style("border-style", "none").style('background-color',"#2196f3")
        .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','15px').style("border-style", "solid").style('color','#ffffff')
        .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 1px #9b9b9b").style("border-radius","0px")
        var textForReRenderButton = document.createTextNode("Apply Changes");
        reRenderChartAndTableButton[0][0].appendChild(textForReRenderButton)
        
        
        reRenderChartAndTableButton.on("click", function(){
                                       
           var selectedStackMeasures = [];
           for(var i=0; i<$("#sortable1"+targetElement[0][0].id).children("li").length;i++){
               selectedStackMeasures.push($("#sortable1"+targetElement[0][0].id).children("li")[i].textContent)
           }
           
                                       
               var thirdDimSetOfDataArray = [];
               var tempArray = []
                                   
               finalSelectedDimsUniqueValuesArray[2] = []
               finalSelectedDimsUniqueValuesArray[2] = selectedStackMeasures
               
                           
               for(var i = 0; i < finalSelectedDimsUniqueValuesArray[2].length; i++){
               tempArray = [];
               for(var j = 0; j < setOfDataArray.length; j++){
               setOfDataArray[j].forEach(function(d,l){
                                         
                     for(var m = 0; m < Object.keys(d).length; m++){
                     var lower = d3.keys(d)[m].toString().toLowerCase();
                     if(lower === options.keys.labels[0].toString().toLowerCase()){
                     if(d3.values(d)[m].toString().toLowerCase() === finalSelectedDimsUniqueValuesArray[2][i].toString().toLowerCase()){
                     tempArray.push(d);
                     break;
                     }
                     }
                     }
                 })
               }
               thirdDimSetOfDataArray.push(tempArray)
               }
                   
              var shuffledArrayForThreeXAxisesGrpBarChart = [];
               for(var i = 0; i < thirdDimSetOfDataArray.length; i++){
                   for(j = 0; j < thirdDimSetOfDataArray[i].length; j++){
                       shuffledArrayForThreeXAxisesGrpBarChart.push(thirdDimSetOfDataArray[i][j])
                   }
               }
                
               
               var newOptions = {
                   data: shuffledArrayForThreeXAxisesGrpBarChart,
                   keys: {
                       labels: options.keys.labels,
                       groupBars: options.keys.groupBars,
                       toolTipLabel: options.keys.toolTipLabel
                   },
                   chartTitle: options.chartTitle,
                   xAxisLables: options.xAxisLables,
                   yAxisLable: options.yAxisLables,
                   showTitle: options.showTitle,
                   colorSet: options.colorSet, //"one" or "two" or "three";
                   BGcolor:options.BGcolor,
                   //drillDownColumnName:"",
                   //showComments: false,
                   //comments: "",
                   resizeButtonID: options.resizeButtonID
               
               }
               d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
               acinfotech.threeXAxisesGroupedBarChart(targetElement, newOptions)
               
        })
        
        /*var textBoxForMeasureColumnFrom;
        var textBoxForMeasureColumnTo;
        var selectTitleDivForEachDimension;*/
        
        $( "ul.droptrue"+targetElement[0][0].id ).sortable({
               appendTo: document.body,
               helper: "clone",
               connectWith: ".droptrue"+targetElement[0][0].id,
               scroll: false,
               cancel: '.unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+','+' .unMoveableIconAndTextClassDimensions'+targetElement[0][0].id,
               revertDuration: 10,
               scrollSensitivity: 10,
               scrollSpeed: 1,
               dynamic: true,
        });
        
        //----------------- Shuffle panel and everything within it section ends here -----------------
        
        // Calling the shuffle panel on shuffle button click
        shuffleBtnForThreeXAxisesGrpBarChart.on('click', function() {
            shufflePanelForThreeXAxisesGrpBarChart.style("display","block");
        })
        
        // Refreshing Chart and Table
        refreshBtnForThreeXAxisesGrpBarChart.on('click', function() {
                                        
            //isFilterClicked = false
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){
                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData;
                }
            }
            acinfotech.threeXAxisesGroupedBarChart(targetElement,options)
                                        
        })
        
        downloadBtnForThreeAxisesGrpBarChart.on('click', function() {
                                  
          ismenuButtonOfThreeAxisesGrpBarChartClicked = false; // Changing menu button value to false
          optionsButtonPanelForThreeAxisesGrpBarChart.style("display","none") // Hiding option buttons panel
                                  
        })
        
        // Creating ToolTip for options button.
        var iconButtonTooltipForThreeXAxisesGrpBarChart = targetElement.append('div').style('width','240px')//.attr("id","too")
        .style('height',"25px").style('position','absolute')//.style('margin-left', "0px").style('top','25px')
        .style("background-color",'#404040 ').style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid") // 004b9d
        .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none").attr("border", 0.0)
        
        shuffleBtnForThreeXAxisesGrpBarChart.on('mousemove', function(d,i) {
           var root = targetElement
           var m = d3.mouse(root.node());
           m[0] += 0
           m[1] += 0
           var filterButtonTooltipText = "Shuffle";
           
           iconButtonTooltipForThreeXAxisesGrpBarChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
           iconButtonTooltipForThreeXAxisesGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')
                                       
        })
        shuffleBtnForThreeXAxisesGrpBarChart.on('mouseout', function(d,i) {
             iconButtonTooltipForThreeXAxisesGrpBarChart.style("display","none")
        })
        
        refreshBtnForThreeXAxisesGrpBarChart.on('mousemove', function(d,i) {
            var root = targetElement
            var m = d3.mouse(root.node());
            m[0] += 0
            m[1] += 0
            var refreshButtonTooltipText = "Refresh";
            
            iconButtonTooltipForThreeXAxisesGrpBarChart.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForThreeXAxisesGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center; ">'+ refreshButtonTooltipText +'</div>')
                                        
        })
        refreshBtnForThreeXAxisesGrpBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForThreeXAxisesGrpBarChart.style("display","none")
        })
        
        menuButtonForThreeAxisesGrpBarChart.on('mousemove', function(d,i) {
            var root = targetElement
            var m = d3.mouse(root.node());
            m[0] += 0
            m[1] += 0
            var refreshButtonTooltipText = "Menu";
            
            iconButtonTooltipForThreeXAxisesGrpBarChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForThreeXAxisesGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center; ">'+ refreshButtonTooltipText +'</div>')
                                                
        })
        menuButtonForThreeAxisesGrpBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForThreeXAxisesGrpBarChart.style("display","none")
        })
        
        downloadBtnForThreeAxisesGrpBarChart.on('mousemove', function(d,i) {
           var root = targetElement
           var m = d3.mouse(root.node());
           m[0] += 0
           m[1] += 0
           var downloadButtonTooltipText = "Download";
           
           iconButtonTooltipForThreeXAxisesGrpBarChart.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
           iconButtonTooltipForThreeXAxisesGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
        })
        downloadBtnForThreeAxisesGrpBarChart.on('mouseout', function(d,i) {
           iconButtonTooltipForThreeXAxisesGrpBarChart.style("display","none")
        })

        
        var yMaxValueArrayGlobal = []
        var svgPanelForLeftYAxisArrayGlobal = [];
        var svgPanelForRightYAxisArrayGlobal = [];
        var svgArrayGlobal = [];
        var rectsGroupArrayGlobal = [];
        var xAxisLabelsArrayGlobal = [];
        var finalNewNewArrayGlobal = []
        
        var topMar = 100/(thirdDimSetOfDataArray.length)
        
        for(var horiDivIndex = 0; horiDivIndex < thirdDimSetOfDataArray.length; horiDivIndex++){
            
            var svgArray = [];
            var rectsGroupArray = [];
            var xAxisLabelsArray = [];
            
            var yMaxValueArray = [];
            var maxArray = []
            for(var ii = 0; ii < options.keys.groupBars.length; ii++){
                maxArray = [];
                for(var jj = 0; jj < thirdDimSetOfDataArray[horiDivIndex].length; jj++){
                    thirdDimSetOfDataArray[horiDivIndex].forEach(function(d) { maxArray.push(+d[options.keys.groupBars[ii]])  })
                }
                yMaxValueArray.push(d3.max(maxArray))
            }
            
            yMaxValueArrayGlobal.push(d3.max(yMaxValueArray))
            
            
            // -----------------------------------------------------------------------------
            // Adding left Y-Axis
            var horiSvgContainerDivForLeftYAxis = chartDivForThreeAxisesGrpBarChart.append("div").style("position","absolute").style("background-color", options.BGcolor)
            .style("left", function(d) {  return 0.00 + "%"; })
            .style("top",function(d,index){ return (topMar * horiDivIndex )+ "%"; })
            .style("width", function(d) {  return 10.00 + "%"; })
            .style("height", function(d) { return (100/(thirdDimSetOfDataArray.length)) + "%" })
            .style("min-height",50 + "%") //.style("min-height",((100/180) * 100) + "%")
            .style("border","none").style("border-right","0px solid #e0e0e0").style("box-sizing","border-box")
            //horiSvgContainerDivForLeftYAxis.style("top",function(d,index){ return ((100/horiSvgContainerDivForLeftYAxis.node().getBoundingClientRect().height * 100) * horiDivIndex )+ "%"; })
            horiSvgContainerDivForLeftYAxis.style("top",function(d,index){ return (49 * horiDivIndex )+ "%"; })
            
            //Adding SVG for left Y-Axis
            var svgPanelForLeftYAxisForThreeAxisesGrpBarChart = horiSvgContainerDivForLeftYAxis .append('svg') .style("position","absolute").style("left",function(d){ return 0 + "%"; })
            .style("top",function(d,index){ return 10 + "%"; }).attr('width', 100 + "%").attr('height', 80 + "%").style("background-color", options.BGcolor)
            .style("border","none").style("border-right","0px solid #e6e6e6").style("box-sizing","border-box")
            
            var marginsForLeftYAxis = {top: 35 , right: 0, bottom: 22, left: svgPanelForLeftYAxisForThreeAxisesGrpBarChart.node().getBoundingClientRect().width + 0.1}, //originally top: 42, left: 80
            width = (svgPanelForLeftYAxisForThreeAxisesGrpBarChart.node().getBoundingClientRect().width) - marginsForLeftYAxis.left - marginsForLeftYAxis.right,
            height = svgPanelForLeftYAxisForThreeAxisesGrpBarChart.node().getBoundingClientRect().height - marginsForLeftYAxis.top - marginsForLeftYAxis.bottom;
            
            var yForLeftYAxis = d3.scale.linear() .domain([0, d3.max(yMaxValueArray)]) .range([height, 0]); // for margin.top: 35 d3.max(yMaxValueArray) * 1.31
             
            var yAxisForValues = d3.svg.axis() .scale(yForLeftYAxis) .ticks(4) .orient("left");
            
            var svgGroupForLeftYAxis = svgPanelForLeftYAxisForThreeAxisesGrpBarChart.append("g") .style("position","absolute").attr("transform", "translate(" + marginsForLeftYAxis.left + "," + marginsForLeftYAxis.top + ")");
            svgGroupForLeftYAxis.append("g") .attr("class", "y axis left-yaxis-class") .call(yAxisForValues).selectAll("text") .style("fill","#00001c").style("font-family","Verdana,sans-serif").style("font-weight","Normal")
            
            svgPanelForLeftYAxisArrayGlobal.push(svgPanelForLeftYAxisForThreeAxisesGrpBarChart)
            
            // -----------------------------------------------------------------------------
            
            
            // -----------------------------------------------------------------------------
            // Adding right Y-Axis
            var horiSvgContainerDivForRightYAxis = chartDivForThreeAxisesGrpBarChart.append("div").style("position","absolute").style('background-color',"#ffffff")
             .style("left", function(d) {  return 80.00 + "%"; })
             //.style("top",function(d,index){ return (topMar * horiDivIndex )+ "%"; })
             .style("width", function(d) {  return 20.00 + "%"; })
             .style("height", function(d) { return (100/(thirdDimSetOfDataArray.length)) + "%" })
             .style("min-height",50 + "%") //.style("min-height",((100/180) * 100) + "%")
             .style("box-sizing","border-box")
             .style("border","none").style("border-top","1px solid #c8c8c8").style("border-right","1px solid #c8c8c8").style("border-bottom","1px solid #c8c8c8")
             //horiSvgContainerDivForRightYAxis.style("top",function(d,index){ return ((100/horiSvgContainerDivForRightYAxis.node().getBoundingClientRect().height * 100) * horiDivIndex )+ "%"; })
             horiSvgContainerDivForRightYAxis.style("top",function(d,index){ return (49 * horiDivIndex )+ "%"; })
            
             //Adding SVG for right Y-Axis
             var svgPanelForRightYAxisForThreeAxisesGrpBarChart = horiSvgContainerDivForRightYAxis .append('svg') .style("position","absolute").style("left",function(d){ return 0 + "%"; })
             .style("top",function(d,index){ return 10 + "%"; }).attr('width', 100 + "%").attr('height', 80 + "%").style('background-color',"#ffffff")
             .style("border","none").style("border-right","0px solid #e6e6e6").style("box-sizing","border-box")
             
             var margin = {top: 25 , right: 0, bottom: 20, left: 5}, //originally top: 42, left: 80
             width = (svgPanelForRightYAxisForThreeAxisesGrpBarChart.node().getBoundingClientRect().width) - margin.left - margin.right,
             height = svgPanelForRightYAxisForThreeAxisesGrpBarChart.node().getBoundingClientRect().height - margin.top - margin.bottom;
            
            var yForYAxis = d3.scale.ordinal() .domain([finalSelectedDimsUniqueValuesArray[2][horiDivIndex]]) .rangeRoundBands([0, height], 0.25); // for margin.top: 35 d3.max(yMaxValueArray) * 1.31
            
            var yAxis = d3.svg.axis() .scale(yForYAxis) .ticks(1) .orient("right");
            
            var svgGroupForRightYAxis = svgPanelForRightYAxisForThreeAxisesGrpBarChart.append("svg:g") .style("position","absolute").attr("transform", "translate(" + -1 + "," + margin.top + ")");
            
            svgGroupForRightYAxis.append("g") .attr("class", "y axis right-yaxis-class") .call(yAxis).selectAll("text") .style("fill","#00001c").style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
            .text(function(d,i) {
                  if(d.length > 15)
                    return d.substring(0,15)+'...';
                  else
                    return d;
            });
            
            // Adding right Y-Axis label
            var yRightAxisLabVar = svgPanelForRightYAxisForThreeAxisesGrpBarChart.append("text").attr("transform", "translate(" + width + ",0)rotate(90)").attr("y", 0).attr("x",height/2 + 23)
            .attr("dy", "1em") .style("text-anchor", "middle").style("font-family","Verdana,sans-serif") .style("font-weight","Bold") .style("font-size","12px")
            .text(options.keys.labels[0]) .style('fill',"#00001c") .style("text-transform","capitalize").attr("class","right-axis-lable-class")
            
            svgPanelForRightYAxisArrayGlobal.push(svgPanelForRightYAxisForThreeAxisesGrpBarChart)
            // -----------------------------------------------------------------------------
            
            
            // -----------------------------------------------------------------------------
            // Adding each horizontal div
            var horiSvgContainerDiv = chartDivForThreeAxisesGrpBarChart.append("div").style("position","absolute").style('background-color',"#ffffff")
            .style("left", function(d) {  return 10.00 + "%"; })//.style("top",function(d,index){ return (topMar * horiDivIndex )+ "%"; })
            .style("width", function(d) {  return 70.00 + "%"; }).style("height", function(d) { return (100/(thirdDimSetOfDataArray.length)) + "%" })
            .style("min-height",50 + "%") // .style("min-height",((100/180) * 100) + "%")
            .style("border","none").style("border","1px solid #c8c8c8").style("box-sizing","border-box")
            //horiSvgContainerDiv.style("top",function(d,index){ return ((100/horiSvgContainerDiv.node().getBoundingClientRect().height * 100) * horiDivIndex )+ "%"; })
            horiSvgContainerDiv.style("top",function(d,index){ return (49 * horiDivIndex )+ "%"; })
            
            // Adding each horizontal div top title div
            var chartTopPanelForThreeAxisesGrpBarChart =  horiSvgContainerDiv.append("div").style("position","absolute").style("text-align", "center").style('background-color',"#ffffff")
            .style("left", function(d) {  return 0.00 + "%"; }).style("top", function(d) {  return 0.00 + "%"; }).style("width", function(d) {  return 100.00 + "%"; })
            .style("height", function(d) { return 10 + "%"; }).style("border","none").style("box-sizing","border-box")
            .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:10.0%; font-size:10px; font-family:inter; text-transform:uppercase; color:#00001c; font-weight:Bold;">'+ options.xAxisLables[2] +'</div>')
            
            // Adding each horizontal div bottom title div
            var chartBottomPanelForThreeAxisesGrpBarChart =  horiSvgContainerDiv.append("div").style("position","absolute").style("text-align", "center").style('background-color',"#ffffff")
            .style("left", function(d) {  return 0.00 + "%"; }).style("top", function(d) {  return 90.00 + "%"; }).style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 10 + "%"; }).style("border","none").style("box-sizing","border-box")
            .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:10.0%; font-size:10px; font-family:inter; text-transform:uppercase; color:#00001c; font-weight:Bold;">'+ options.xAxisLables[1] +'</div>')
            // -----------------------------------------------------------------------------
            
            
            for(var vertiSvgIndex = 0; vertiSvgIndex < thirdDimSetOfDataArray[horiDivIndex].length; vertiSvgIndex++){
                
                var leftMar = 100/(thirdDimSetOfDataArray[horiDivIndex].length)
                
                
                //Creating SVG Div holder for chart
                var svgDivPanelForThreeAxisesGrpBarChart = horiSvgContainerDiv .append('div') .style("position","absolute").style("left",function(d,index){ return (leftMar * vertiSvgIndex )+ "%"; })
                .style("top",10 + "%").style('width', (100/(thirdDimSetOfDataArray[horiDivIndex].length)) + "%").style('height', 80 + "%").style("background-color", options.BGcolor)
                .style("border","none").style("border-right","0px solid #e6e6e6").style("box-sizing","border-box")
                
                //Creating SVG holder for chart
                var svgPanelForThreeAxisesGrpBarChart = svgDivPanelForThreeAxisesGrpBarChart .append('svg') .style("position","absolute").style("left",function(d,index){ return 0 + "%"; })
                .style("top", 0 + "%").attr('width', 100 + "%").attr('height', 100 + "%").style("background-color", options.BGcolor)
                .style("border","none").style("border-right","1px solid #e6e6e6").style("box-sizing","border-box")
                
                if(vertiSvgIndex === (thirdDimSetOfDataArray[horiDivIndex].length - 1) ){ svgPanelForThreeAxisesGrpBarChart.style("border-right","none")}
                
                var margin = {top: 35 , right: 0, bottom: 20, left: - 1}, //originally top: 42, left: 80
                width = (svgPanelForThreeAxisesGrpBarChart.node().getBoundingClientRect().width) - margin.left - margin.right,
                height = svgPanelForThreeAxisesGrpBarChart.node().getBoundingClientRect().height - margin.top - margin.bottom;
                
                var finalArrayNew = [];
                options.keys.groupBars.forEach(function(d, i) {
                   var temp1 = {};
                       temp1["name"] = options.keys.groupBars[i]
                           finalArrayNew.push(temp1)
                })
                
                var finalNewNewArray = [];
                var dataArray1 = [];
                finalArrayNew.forEach(function(d, i) {
                  var temp1 = {};
                      temp1["name"] = options.keys.groupBars[i]
                                  
                      for (j = 0; j < [thirdDimSetOfDataArray[horiDivIndex][vertiSvgIndex]].length; j++) {
                                  
                          var tempTemp = {};
                              tempTemp["label"] = [thirdDimSetOfDataArray[horiDivIndex][vertiSvgIndex]][j][options.keys.labels[1]];
                              tempTemp["value"] = +[thirdDimSetOfDataArray[horiDivIndex][vertiSvgIndex]][j][options.keys.groupBars[i]];
                              dataArray1.push(tempTemp)
                      }
                                  
                      temp1["data"] = dataArray1;
                      dataArray1 = []
                      finalNewNewArray.push(temp1)
                })
                
                var dataset = finalNewNewArray.map(function (d,ind) {
                                                   
                        return d.data.map(function (o, i) {
                            return {
                                y: o.value,
                                x: o.label,
                                rectTopLabel: thirdDimSetOfDataArray[horiDivIndex][vertiSvgIndex][options.keys.labels[2]], // additionally added
                                rectBottomLabel: thirdDimSetOfDataArray[horiDivIndex][vertiSvgIndex][options.keys.labels[1]], // additionally added
                                rectColor: colours(ind), // additionally added
                                rectName: d.name, // additionally added
                                entireObject: thirdDimSetOfDataArray[horiDivIndex][vertiSvgIndex] // additionally added
                                          
                            };
                     });
                }),
                xMax = d3.max(dataset, function (group) {
                          return d3.max(group, function (d) {
                                return d.y
                        });
                })
                
                var xAxisLabels = dataset[0].map(function (d) { return d.x; });
                
                var y = d3.scale.linear() .domain([0, d3.max(yMaxValueArray)]) .range([height, 0]);
                
                var x0 = d3.scale.ordinal() .domain([0]) .rangeBands([0, width], .28);
                
                var x1 = d3.scale.ordinal() .domain(d3.range(finalNewNewArray.length)) .rangeBands([0, x0.rangeBand()]);
                
                var xAxis = d3.svg.axis() .scale(x0) .orient("bottom");
                
                var svg = svgPanelForThreeAxisesGrpBarChart.append("svg").append("g") .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
                
                svg.append('g') .attr("class", "x axis bottom-axis-class") .attr('transform', 'translate(0,' + height + ')') .call(xAxis)
                
                .selectAll("text").data([thirdDimSetOfDataArray[horiDivIndex][vertiSvgIndex][options.keys.labels[1]]]) .style("text-anchor", "middle") .style('fill','#00001c') .attr("transform", function(d) { return "rotate(0)" })
                .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
                .text(function(d,i) {
                    if(d.length > 12){ return d.substring(0,12)+'...'; }
                    else { return d; }
                })
                
                var x2 = d3.scale.ordinal() .domain([thirdDimSetOfDataArray[horiDivIndex][vertiSvgIndex][options.keys.labels[2]]]) .rangeRoundBands([0, width], 0.25);
                var xAxisTop = d3.svg.axis() .scale(x2) .orient("top")
                
                // Adding the Top X Axis
                var topAxis = svg.append("g").attr("class", "x axis top-axis-class").attr("transform", "translate(0," + -10 + ")") .call(xAxisTop)
                
                // Add the Top X Axis margin labels
                .selectAll("text") .style("text-anchor", "middle") .style('fill','#00001c') .attr("transform", function(d) { return "rotate(0)" })
                .style("font-size","12px").style("font-family","Verdana,sans-serif") .style('text-anchor','middle')
                .style("font-family","Verdana,sans-serif").style("font-weight","normal")
                .text(function(d,i) {
                    if(d.length > 12)
						return d.substring(0,12)+'...';
                    else
                        return d;
                })
                
                var groups = svg.append("g").selectAll("g") .data(dataset)
                
				var groups1 = groups.enter().append("g").attr("class","each-bargrouped-class")
				.style("fill", function(d, i) { return colours(i); })
				.attr("transform", function(d, i) {return "translate(" + x1(i) + ",0)"; })
				.selectAll("rect")
				.data(function(d) { return d; })
				.enter().append("rect").attr("x", function(d, i) { return x0(i); })
				.attr("y", height).attr("width", x1.rangeBand()).attr("height", 0)
				.transition().delay(400).duration(800)
				.attr("y", function (d) { return  y(d.y); })
				.attr("height", function (d) { return height - y(d.y); })
				.style('cursor','auto')
                
				groups.selectAll('rect').on('mousemove', function (d,i){
                        
                    var root = targetElement
                    var m = d3.mouse(root.node());
                    m[0] += 0
                    m[1] += 0
                    
                    var valueForGrpBarChartToolTip;
                    if(d.y.toString().indexOf('.') === -1)
                    {
                        valueForGrpBarChartToolTip = d.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    }
                    else{
                    
                        valueForGrpBarChartToolTip = d.y;
                    }
                    
                    tooltipForThreeXAxisesGrpBarChart.select('.tooltip-label1-class').html(options.keys.labels[2] + " : " + d.rectTopLabel)
                    tooltipForThreeXAxisesGrpBarChart.select('.tooltip-label2-class').html(options.keys.labels[1] + " : " + d.rectBottomLabel)
                    tooltipForThreeXAxisesGrpBarChart.select('.count').html(d.rectName + " : " + valueForGrpBarChartToolTip)
                    tooltipForThreeXAxisesGrpBarChart.style('visibility', 'visible')
                    tooltipForThreeXAxisesGrpBarChart.select('hr').style("background-color", d.rectColor)
                    //tooltipForThreeXAxisesGrpBarChart.select('hr').style("display","none")
                    tooltipForThreeXAxisesGrpBarChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-20) + "px").style("display","block")
                                            
                    if(options.keys.toolTipLabel.length > 0){
                        for(toolTipInd = 0; toolTipInd < options.keys.toolTipLabel.length; toolTipInd++){
                            tooltipForThreeXAxisesGrpBarChart.select('.tooltip-additional-label' + toolTipInd + '-class')
                            .html(options.keys.toolTipLabel[toolTipInd] + " : " + d.entireObject[options.keys.toolTipLabel[toolTipInd]])
                        }
                    }

                    
                })
                .on('mouseout', function(){ tooltipForThreeXAxisesGrpBarChart.style("display","none") })
                
                
                svgArray.push(svgPanelForThreeAxisesGrpBarChart)
                rectsGroupArray.push(groups)
                xAxisLabelsArray.push(xAxisLabels)
                
                //By default calling the resized function to align table's th and td is at the last of chart creating function.
                
                window.addEventListener('resize', function(event){ resizedFuctionForThreeXAxisesGrpBarChart() });
                
                $(function() {
                  $("#" + targetElement[0][0].id).resizable({
                        resize: function(event, ui) {
                        divWidth = ui.size.width;
                        divHeight = ui.size.height;
                        resizedFuctionForThreeXAxisesGrpBarChart();
                        }
                    });
                  });
                
                function resizedFuctionForThreeXAxisesGrpBarChart()
                {
                    if((svgPanelForLeftYAxisForThreeAxisesGrpBarChart.node().getBoundingClientRect().width) && (svgPanelForLeftYAxisForThreeAxisesGrpBarChart.node().getBoundingClientRect().height) > 0){
                        
                        var marginsForLeftYAxis = {top: 35 , right: 0, bottom: 22, left: svgPanelForLeftYAxisForThreeAxisesGrpBarChart.node().getBoundingClientRect().width + 0.1 }, //originally top: 42, left: 80
                        widthForLeftYAxis = (svgPanelForLeftYAxisForThreeAxisesGrpBarChart.node().getBoundingClientRect().width) - marginsForLeftYAxis.left - marginsForLeftYAxis.right,
                        heightForLeftYAxis = svgPanelForLeftYAxisForThreeAxisesGrpBarChart.node().getBoundingClientRect().height - marginsForLeftYAxis.top - marginsForLeftYAxis.bottom;
                        
                        for(i = 0; i < svgPanelForLeftYAxisArrayGlobal.length; i++){
                            
                            yForLeftYAxis.domain([0, yMaxValueArrayGlobal[i]]).range([heightForLeftYAxis, 0]); // for margin.top: 35 d3.max(yMaxValueArray) * 1.31
                            yAxisForValues.scale(yForLeftYAxis) .orient("left")
                            
                            svgPanelForLeftYAxisArrayGlobal[i].select("g").attr("transform", "translate(" + marginsForLeftYAxis.left + "," + marginsForLeftYAxis.top + ")") .call(yAxisForValues)
                        }
                    }
                    
                    if((svgPanelForThreeAxisesGrpBarChart.node().getBoundingClientRect().width) && (svgPanelForThreeAxisesGrpBarChart.node().getBoundingClientRect().height) > 0){
                        
                        shuffleBtnForThreeXAxisesGrpBarChart.style('margin-left', "2px")
                        refreshBtnForThreeXAxisesGrpBarChart.style('margin-left', "2px")
                        menuButtonForThreeAxisesGrpBarChart.style('right', '0')
                        optionsButtonPanelForThreeAxisesGrpBarChart.style('right', '0')
                        
                        for(j = 0; j < svgArrayGlobal.length; j++){
                            
                            for(jj = 0; jj < svgArrayGlobal[j].length; jj++){
                                
                                var margin1 = {top: 35 , right: 0, bottom: 20, left: - 1}, //originally top: 42, left: 80
                                width1 = (svgArrayGlobal[j][jj].node().getBoundingClientRect().width) - margin1.left - margin1.right,
                                height1 = (svgArrayGlobal[j][jj].node().getBoundingClientRect().height) - margin1.top - margin1.bottom;
                                
                                y.domain([0, yMaxValueArrayGlobal[j]]) .range([height1, 0]);
                                
                                x0 .domain(d3.range(xAxisLabelsArrayGlobal[j][jj].length)) .rangeBands([0, width1], .28);
                                
                                x1.domain(d3.range(finalNewNewArrayGlobal[j].length)) .rangeBands([0, x0.rangeBand()]);
                                
                                xAxis.scale(x0) .orient("bottom");
                                
                                var svg1 = svgArrayGlobal[j][jj].select("g")
                                svg1.attr("transform", "translate(" + margin1.left + "," + margin1.top + ")");
                                
                                svgArrayGlobal[j][jj].select(".x.axis.bottom-axis-class") .attr('transform', 'translate(0,' + height1 + ')') .call(xAxis)
                                .selectAll("text").data(xAxisLabelsArrayGlobal[j][jj]) .style("text-anchor", "middle").style('fill','#00001c')
                                .attr("transform", function(d) { return "rotate(0)" })
                                .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
                                .text(function(d,i) {
                                  if(d.length > 12){
                                      return d.substring(0,12)+'...';
                                  }
                                  else{
                                      return d;
                                  }
                                  })
                                
                                
                                x2.domain([thirdDimSetOfDataArray[j][jj][options.keys.labels[2]]]) .rangeRoundBands([0, width1], 0.25);
                                
                                xAxisTop.scale(x2) .orient("top")
                                
                                svgArrayGlobal[j][jj].select(".x.axis.top-axis-class").attr("transform", "translate(0," + -10 + ")") .call(xAxisTop)
                                .selectAll("text") .style("text-anchor", "middle") .style('fill','#00001c') .attr("transform", function(d) { return "rotate(0)" })
								.style("font-size","12px").style("font-family","Verdana,sans-serif") .style('text-anchor','middle')
								.style("font-family","Verdana,sans-serif").style("font-weight","normal")
								.text(function(d,i) {
									if(d.length > 12)
										return d.substring(0,12)+'...';
									else
										return d;
								})
                                
                                var groupsArray = [];
                                
                                var grp = rectsGroupArrayGlobal[j][jj][0]
                                
                                for(var ii = 0; ii < grp.length; ii++){
                                    d3.select(grp[ii]).selectAll("rect").data(function(d,i) { groupsArray[ii] = x1(ii); return d; })
                                    .attr("width", x1.rangeBand())
                                    .attr("height", function(d) { return height1 - y(d.y) })
                                    .attr("x", function(d, i) {  return x0(i); })
                                    .attr("y", function(d) { return  y(d.y); })
                                    d3.select(grp[ii]).attr("transform", function(d, i) { return "translate(" + groupsArray[ii] + ",0)"; })
                                } // for(var ii = 0)
                                
                                // Aligning Legend (vertically)
                                var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(svgLegendPanelForThreeAxisesGrpBarChart[0][0].style.width) / 100)
                                var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(svgLegendPanelForThreeAxisesGrpBarChart[0][0].style.height) / 100)
                                
                                var legendRectSize = 11;
                                var legendSpacing = 4;
                                
                                
                                legend.attr('transform', function(d, i) {
                                    var eachRectHeight = legendRectSize + legendSpacing;
                                    var offset =  eachRectHeight * colours.domain().length / 2;
                                    var horz = 0;
                                    var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.groupBars.length))/2.5; // originally 2.0
                                    
                                    return 'translate(' + horz + ',' + vert + ')';
                                })
                                
                            }// for(var jj = 0)
                            
                        }// for(var j = 0)
                    } // if(svgPanel)
                    
                    if((svgPanelForRightYAxisForThreeAxisesGrpBarChart.node().getBoundingClientRect().width) && (svgPanelForRightYAxisForThreeAxisesGrpBarChart.node().getBoundingClientRect().height) > 0){
                        
                        var marginsForRightYAxis = {top: 25 , right: 0, bottom: 20, left: 5}, //originally top: 42, left: 80
                        widthForRightYAxis = (svgPanelForRightYAxisForThreeAxisesGrpBarChart.node().getBoundingClientRect().width) - marginsForRightYAxis.left - marginsForRightYAxis.right,
                        heightForRightYAxis = svgPanelForRightYAxisForThreeAxisesGrpBarChart.node().getBoundingClientRect().height - marginsForRightYAxis.top - marginsForRightYAxis.bottom;
                        
                        for(i = 0; i < svgPanelForLeftYAxisArrayGlobal.length; i++){
                            
                            yForYAxis.domain([finalSelectedDimsUniqueValuesArray[2][i]]) .rangeRoundBands([0, heightForRightYAxis], 0.25); // for margin.top: 35 d3.max(yMaxValueArray) * 1.31
                            
                            yAxis.scale(yForYAxis) .ticks(1) .orient("right");
                            
                            svgPanelForRightYAxisArrayGlobal[i].select("g").attr("transform", "translate(" + -1 + "," + marginsForRightYAxis.top + ")").call(yAxis);
                            
                            svgPanelForRightYAxisArrayGlobal[i].select(".right-axis-lable-class").attr("transform", "translate(" + widthForRightYAxis + ",0)rotate(90)").attr("y", 0).attr("x",heightForRightYAxis/2 + 23) .attr("dy", "1em") .style("text-anchor", "middle")
                        }
                        
                    } // if(svgPanel)
                    
                } // resizedFuctionForThreeXAxisesGrpBarChart
                
            } // for(verti)
            
            svgArrayGlobal.push(svgArray)
            rectsGroupArrayGlobal.push(rectsGroupArray)
            xAxisLabelsArrayGlobal.push(xAxisLabelsArray)
            finalNewNewArrayGlobal.push(finalNewNewArray)
            
        } // for(hori)
        
        //------- Adding legend section ------
        var svgLegendPanelForThreeAxisesGrpBarChart = legendDivForThreeAxisesGrpBarChart .append('svg').style('position',"absolute").style("left",0 + "%").style("top",0 + "%")
        .style('width', 100 + "%") .style('height', 100 + "%").style('background-color',"#ffffff")
        
        var legend = svgLegendPanelForThreeAxisesGrpBarChart.append("g") .attr("class", "legend") .attr("width", "100%").attr("height", "100%")
        
        //Create colour squares
        var legendGroup = legend.selectAll('rect') .data(options.keys.groupBars) .enter() .append("rect") .attr("x", 5)
        .attr("y", function(d, i){ return i * 16;}) .attr("width", 14) .attr("height", 14) .attr("rx",10) .attr("ry",10)
        .style("fill", function(d, i){ return colours(i);}) .style("cursor","auto")
        
        //Create text next to squares
        legend.selectAll('text') .data(options.keys.groupBars) .enter() .append("text") .attr("x", 25) .attr("y", function(d, i){ return i * 16 + 11.8;})
        .attr("fill", "#00001c") .text(function(d,i) {  if(d.length > 10)
            return d.substring(0,10)+'...';
            else
            return d; }) .style('font-size', '14px') .attr("fill","#00001c") .style("font-family","Verdana,sans-serif")
        
        // Aligning Legend (vertically)
        var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(svgLegendPanelForThreeAxisesGrpBarChart[0][0].style.width) / 100)
        var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(svgLegendPanelForThreeAxisesGrpBarChart[0][0].style.height) / 100)
        
        var legendRectSize = 11;
        var legendSpacing = 4;
        
		legend.attr('transform', function(d, i) {
			var eachRectHeight = legendRectSize + legendSpacing;
			var offset =  eachRectHeight * colours.domain().length / 2;
			var horz = 0;
			var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.groupBars.length))/2.5; // originally 2.0

			return 'translate(' + horz + ',' + vert + ')';
		})
        
        legendGroup.on('mouseover',function(d,index){
            for(var i = 0; i<rectsGroupArrayGlobal.length; i++){
                var grp = rectsGroupArrayGlobal[i]
                    for(var ii = 0; ii < grp.length; ii++){
                       for(var iii = 0; iii < grp[ii].selectAll("rect").length; iii++){
                            d3.select(grp[ii].selectAll("rect")[iii][0]).transition().style('fill-opacity',0.04)
                           d3.select(grp[ii].selectAll("rect")[index][0]).transition().style('fill-opacity',0.95)
                        }
                    }
            }
        })
        
        legendGroup.on('mouseout',function(d,index){
            for(var i = 0; i<rectsGroupArrayGlobal.length; i++){
                var grp = rectsGroupArrayGlobal[i]
                    for(var ii = 0; ii < grp.length; ii++){
                       for(var iii = 0; iii < grp[ii].selectAll("rect").length; iii++){
                            d3.select(grp[ii].selectAll("rect")[iii][0]).transition().style('fill-opacity',1)
                       }
                    }
            }
        })
        
        //By default calling the resized function first time (to align table's th and td).
        setTimeout(function(){ resizedFuctionForThreeXAxisesGrpBarChart() },1000);
        
    }, // threeXAxisesGroupedBarChart
    
    //************************************************** Columns and Lines Chart  **************************************************
    columnAndLinesChart: function(targetElement, options){
        
       isChartCalled++;

        var chartName = "COLUMNANDLINESCHART";
        
        acinfotech.allCharts(targetElement,options,chartName);
        
        targetElement.style("min-width","350px").style("min-height","350px").style("background-color", options.BGcolor)

        var showOrHideTableForColAndLinesChart;
        var showOrHideCommentsForColAndLinesChart;
        var showOrHideCommentsBtnForColAndLinesChart = true;

        if((options.showTable == false) || (options.showTable == true)){
            showOrHideTableForColAndLinesChart = options.showTable    
        }
        else{
            showOrHideTableForColAndLinesChart = false;
        }

        // Show or Hide comments
        if (options.showComments == true || false) {
            showOrHideCommentsForColAndLinesChart = options.showComments;
        }
        else {
            showOrHideCommentsForColAndLinesChart = false;
        }
        
        if (options.comments.length == 0){ 
            showOrHideCommentsForColAndLinesChart = false;
            showOrHideCommentsBtnForColAndLinesChart = false;
        }

        if ((showOrHideTableForColAndLinesChart == true) && (showOrHideCommentsForColAndLinesChart == true)){
            showOrHideTableForColAndLinesChart = true;
            showOrHideCommentsForColAndLinesChart = false;
        }
        else if ((showOrHideTableForColAndLinesChart == false) && (showOrHideCommentsForColAndLinesChart == false)){
            showOrHideTableForColAndLinesChart = false;
            showOrHideCommentsForColAndLinesChart = false;
        }

        var divWidth, divHeight;
        
        var chartTitlePanelForColAndLinesChart = targetElement.append("div") .style("position","absolute").style("background-color", options.BGcolor).style("text-indent","6px") .style("border", "none")
        
		var optsBtnPanelForColAndLinesChart = targetElement.append('div').style('width',"25px").style('height',"105px").style('position','absolute')
        .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px")
        .style('right', '0') .style("min-width","25px") .style("border-style","none")
        .style("border-left", "solid #fcfcfc  1px")
		
        var areaButtonForColAndLinesChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','1px') .style("cursor","pointer").style("display","none")
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var areaBtnImgVar = document.createElement("IMG");
        areaBtnImgVar.src = "images/curveAreaIcon.png";
        areaBtnImgVar.setAttribute("style","position:absolute; left:4px; top:2px; width:17px; height:14px; opacity:0.74;")
        areaButtonForColAndLinesChart[0][0].appendChild(areaBtnImgVar)

        var filterButtonForColAndLinesChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','1px') .style("cursor","pointer").style("display","none")
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var filterBtnImgVar = document.createElement("IMG");
        filterBtnImgVar.src = "images/filterIcon.png";
        filterBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.8;")
        filterButtonForColAndLinesChart[0][0].appendChild(filterBtnImgVar)

        var refreshButtonForColAndLinesChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','1px') .style("cursor","pointer").style("display","none")
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var refreshBtnImgVar = document.createElement("IMG");
        refreshBtnImgVar.src = "images/refreshIcon.png";
        refreshBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.8;")
        refreshButtonForColAndLinesChart[0][0].appendChild(refreshBtnImgVar)

        var commentsBtnForColAndLinesChart = optsBtnPanelForColAndLinesChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','80px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var commentsBtnImgVariable = document.createElement("IMG");
        if(options.showComments == false){
            commentsBtnImgVariable.src = "images/showCommentsIcon.png";
        }
        else if(options.showComments == true){
            commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
        }
        commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        commentsBtnForColAndLinesChart[0][0].appendChild(commentsBtnImgVariable)

        var menuButtonForColAndLinesChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','1px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var menuBtnImgVar = document.createElement("IMG");
        menuBtnImgVar.src = "images/menuIcon.png";
        menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
        menuButtonForColAndLinesChart[0][0].appendChild(menuBtnImgVar)

        if(showOrHideCommentsBtnForColAndLinesChart == true){
            areaButtonForColAndLinesChart.style('right', '0')
            filterButtonForColAndLinesChart.style('right', '0')
            refreshButtonForColAndLinesChart.style('right', '0')
            commentsBtnForColAndLinesChart.style('margin-left', "2px")
            menuButtonForColAndLinesChart.style('right', '0')
        }
        else if(showOrHideCommentsBtnForColAndLinesChart == false){
            areaButtonForColAndLinesChart.style('right', '0')
            filterButtonForColAndLinesChart.style('right', '0')
            refreshButtonForColAndLinesChart.style('right', '0')
            //commentsBtnForColAndLinesChart.style('right', '0')
            commentsBtnForColAndLinesChart.style('display','none')
            menuButtonForColAndLinesChart.style('right', '0')
        }

        var ismenuBtnOfColAndLinesChartClicked = false;
        menuButtonForColAndLinesChart.on('click', function() {

            filterPanelForColAndLinesChart.style("display","none");
            stgPanDivForColAndLinesChart.style("display","none")

            if(ismenuBtnOfColAndLinesChartClicked == false){
                ismenuBtnOfColAndLinesChartClicked = true;
                optsBtnPanelForColAndLinesChart.style("display","block")

                if ((showOrHideTableForColAndLinesChart == false) && (showOrHideCommentsForColAndLinesChart == true)){
                    divLegendPanelForColAndLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForColAndLinesChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                    .style("position","absolute");
                }
                else if ((showOrHideTableForColAndLinesChart == true) && (showOrHideCommentsForColAndLinesChart == false)){
                    divLegendPanelForColAndLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForColAndLinesChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute");
                }
                else if ((showOrHideTableForColAndLinesChart == false) && (showOrHideCommentsForColAndLinesChart == false)){
                    divLegendPanelForColAndLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForColAndLinesChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute");
                }

            }
            else if(ismenuBtnOfColAndLinesChartClicked == true){
                ismenuBtnOfColAndLinesChartClicked = false
                optsBtnPanelForColAndLinesChart.style("display","none")

                if ((showOrHideTableForColAndLinesChart == false) && (showOrHideCommentsForColAndLinesChart == true)){
                    divLegendPanelForColAndLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForColAndLinesChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                    .style("position","absolute");
                }
                else if ((showOrHideTableForColAndLinesChart == true) && (showOrHideCommentsForColAndLinesChart == false)){
                    divLegendPanelForColAndLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForColAndLinesChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute");
                }
                else if ((showOrHideTableForColAndLinesChart == false) && (showOrHideCommentsForColAndLinesChart == false)){
                    divLegendPanelForColAndLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForColAndLinesChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute");
                }
            }

            resizedFunctionForColAndLinesChart();
        })

        var tableButtonForColAndLinesChart = optsBtnPanelForColAndLinesChart.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top','1px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
        var tableBtnImgVar = document.createElement("IMG");
        if(showOrHideTableForColAndLinesChart == false){
            tableBtnImgVar.src = "images/showTableIcon.png";
            tableButtonForColAndLinesChart.attr("class","showTableClassForChartTable")
        }
        else if(showOrHideTableForColAndLinesChart == true){
            tableBtnImgVar.src = "images/cancelTableIcon.png";
            tableButtonForColAndLinesChart.attr("class","hideTableClassForChartTable")
        }
        tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
        tableButtonForColAndLinesChart[0][0].appendChild(tableBtnImgVar)

        var settingBtnForColAndLinesChart = optsBtnPanelForColAndLinesChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 28 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        var settingBtnImgVar = document.createElement("IMG");
        settingBtnImgVar.src = "images/settingsIcon.png";
        settingBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.82;")
        settingBtnForColAndLinesChart[0][0].appendChild(settingBtnImgVar)
        
        var downloadBtnForColAndLinesChart = optsBtnPanelForColAndLinesChart.append("div").attr("id","downloadBtnForColAndLinesChart-ID-" + targetElement[0][0].id)
        .style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff")
        .style('margin-left','2px').style('top', 54 + 'px').style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        
        acinfotech.downloadFunctionality("downloadBtnForColAndLinesChart-ID-" + targetElement[0][0].id,targetElement)
        
        var svgPanelForColAndLinesChart = targetElement .append('svg') 
        .attr("id","svgPanelIDForColAndLinesChart" + targetElement[0][0].id) .style("background-color", options.BGcolor) .style("position","absolute")
        
        var commentsPanelDivForColAndLinesChart = targetElement.append("div") .attr("class","commentsPanelClassForColAndLinesChart") 
        .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
		.style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
        .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)

        commentsPanelDivForColAndLinesChart.on('click',function(d){
            $('.commentsClassForColAndLinesChart' + targetElement[0][0].id).focus()
        })

        if(options.showTitle == true){
            
            chartTitlePanelForColAndLinesChart.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 8 + "%"; })
            .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')

            if ((showOrHideTableForColAndLinesChart == false) && (showOrHideCommentsForColAndLinesChart == true)){

                var commentsForColAndLinesChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify') .attr('class','commentsClassForColAndLinesChart' + targetElement[0][0].id)

                   svgPanelForColAndLinesChart.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .append('g')
                   commentsPanelDivForColAndLinesChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForColAndLinesChart[0].outerHTML.toString())

            }
            else if ((showOrHideTableForColAndLinesChart == true) && (showOrHideCommentsForColAndLinesChart == false)){

                    svgPanelForColAndLinesChart.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .append('g')
                    commentsPanelDivForColAndLinesChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForColAndLinesChart == false) && (showOrHideCommentsForColAndLinesChart == false)){
                    svgPanelForColAndLinesChart.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .append('g')
                    commentsPanelDivForColAndLinesChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            
            var margin = {top: 30 , right: 50, bottom: 80, left: 75}, //originally top: 42, left: 80
            width = (svgPanelForColAndLinesChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = (svgPanelForColAndLinesChart.node().getBoundingClientRect().height) - margin.top - margin.bottom;
            
        }
        else if(options.showTitle == false){
            chartTitlePanelForColAndLinesChart.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });
            
            if ((showOrHideTableForColAndLinesChart == false) && (showOrHideCommentsForColAndLinesChart == true)){

                var commentsForColAndLinesChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify')

                   svgPanelForColAndLinesChart.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .append('g')
                   commentsPanelDivForColAndLinesChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForColAndLinesChart[0].outerHTML.toString())

            }
            else if ((showOrHideTableForColAndLinesChart == true) && (showOrHideCommentsForColAndLinesChart == false)){

                    svgPanelForColAndLinesChart.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .append('g')
                    commentsPanelDivForColAndLinesChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForColAndLinesChart == false) && (showOrHideCommentsForColAndLinesChart == false)){
                    svgPanelForColAndLinesChart.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .append('g')
                    commentsPanelDivForColAndLinesChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            
            var margin = {top: 30 , right: 50, bottom: 80, left: 75}, //originally top: 42, left: 80
            width = (svgPanelForColAndLinesChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = (svgPanelForColAndLinesChart.node().getBoundingClientRect().height) - margin.top - margin.bottom;
        }

        var colorscale; 
        // checking color set for pie slices and legend dots
        if(options.colorSet === undefined){
            options.colorSet = "one"
            colorscale = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "one"){
            options.colorSet = "one"
            colorscale = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            options.colorSet = "two"
             colorscale = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            options.colorSet = "three"
            colorscale = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        }
        else
        {
            options.colorSet = "one"
            colorscale = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }

        if ((options.lineStyle.toString().toLowerCase() === "cardinal") || (options.lineStyle.toString().toLowerCase() === "linear") || (options.lineStyle.toString().toLowerCase() === "step")){
            options.lineStyle = options.lineStyle;   
        }
        else{
            options.lineStyle = "cardinal";
        }

        //------------------ Settings panel DIV and everything within it section begins here ------------------
        
        var stgPanDivForColAndLinesChart = targetElement.append('div').style('width',"100%").style('height',"40%").attr("class","stgPanDivForColAndLinesChart" + targetElement[0][0].id)
        .style('position','absolute').style('margin-left', "0px").style('border-top',"1px solid #f0f0f0").style('border-bottom',"1px solid #e5e5e5")
        .style("background-color",'#fcfcfc').style("z-index",90) .style("display","none") .style('top',"60%").style('height',"40%")

        $( '.stgPanDivForColAndLinesChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        var settingPanelTitle = stgPanDivForColAndLinesChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','10px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; color:#00001c;">'+ "Settings" +'</div>')

        var stgPanDivForLineChangeColorTitle = stgPanDivForColAndLinesChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Select color set " +'</div>')

        var stgPanCanBtnForColAndLinesChart = stgPanDivForColAndLinesChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
        .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
        .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.9; background-color:#fcfcff")
        stgPanCanBtnForColAndLinesChart[0][0].appendChild(cancelBtnImgVar)

        stgPanCanBtnForColAndLinesChart.on('click', function() {
            stgPanDivForColAndLinesChart.style("display","none") // Hiding setting panel

            if ((showOrHideTableForColAndLinesChart == false) && (showOrHideCommentsForColAndLinesChart == true)){
                divLegendPanelForColAndLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                svgPanelForColAndLinesChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute");
            }
            else if ((showOrHideTableForColAndLinesChart == true) && (showOrHideCommentsForColAndLinesChart == false)){
                divLegendPanelForColAndLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                svgPanelForColAndLinesChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute");
            }
            else if ((showOrHideTableForColAndLinesChart == false) && (showOrHideCommentsForColAndLinesChart == false)){
                divLegendPanelForColAndLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                svgPanelForColAndLinesChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute");
            }

            resizedFunctionForColAndLinesChart();
        })

        var formForChangeSettingsPanel = stgPanDivForColAndLinesChart.append("form");
        formForChangeSettingsPanel.style("background-color","#fcfcfc").style("margin-top","67px").style("font-family","Verdana,sans-serif").style("font-size","12px")
        .style("position","absolute").attr("id","formForChangeColorSettingsPanel" + targetElement[0][0].id).style("font-weight","Bold").style("width","180px")
        .style("height","58px").style("padding","0px").style("border-radius","0px") .style("margin-left","10px")

        var svgPanelForCrSetOne = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px").style("margin-top","1px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetOne = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        var colorSetOneRange = d3.range(12);

        var colorSetOneDots = svgPanelForCrSetOne.append("g")
        colorSetOneDots.selectAll('rect') .data(colorSetOneRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("fill", function(d,i){return colorSetOne(i)})
        .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetOne(i);  })
        .style("cursor","auto") .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        var svgPanelForCrSetTwo = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px") .style("margin-top","20px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetTwo = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        var colorSetTwoRange = d3.range(12);

        var colorSetTwoDots = svgPanelForCrSetTwo.append("g")
        colorSetTwoDots.selectAll('rect') .data(colorSetTwoRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto")
        .style("fill", function(d,i){return colorSetTwo(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
        .style("stroke",function(d,i){  return colorSetTwo(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        var svgPanelForCrSetThree = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px") .style("margin-top","39px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetThree = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        var colorSetThreeRange = d3.range(12);

        var colorSetThreeDots = svgPanelForCrSetThree.append("g")
        colorSetThreeDots.selectAll('rect') .data(colorSetThreeRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto") .style("fill", function(d,i){return colorSetThree(i)})
        .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetThree(i);  })
        .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        if(options.colorSet.toString().toLowerCase() === "one"){
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"1px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"1px solid #808080")
        }
        else 
        {
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }

        svgPanelForCrSetOne.on('click',function(d){
            options.colorSet = "one"
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")

            colorscale = "";
            colorscale = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);

            lines.style("stroke", function (d,i) { return colorscale(i); })
            colorCount = 0;
            circle1.style("fill", function (d,i) {
                if(i == 0){
                    colorCount++;
                }
                return colorscale(colorCount - 1);
            })

            legend.selectAll('rect').style("fill", function(d, i){ return colorscale(i);})
        
        })
        svgPanelForCrSetTwo.on('click',function(d){
            options.colorSet = "two"
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"1px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")

            colorscale = "";
            colorscale = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);

            lines.style("stroke", function (d,i) { return colorscale(i); })
            colorCount = 0;
            circle1.style("fill", function (d,i) {
                if(i == 0){
                    colorCount++;
                }
                    return colorscale(colorCount - 1);
            })
            legend.selectAll('rect').style("fill", function(d, i){ return colorscale(i);})
        })
        svgPanelForCrSetThree.on('click',function(d){
            options.colorSet = "three"
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"1px solid #808080")

            colorscale = "";
            colorscale = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);

            lines.style("stroke", function (d,i) { return colorscale(i); })
            colorCount = 0;
            circle1.style("fill", function (d,i) {
                if(i == 0){
                    colorCount++;
                }
                    return colorscale(colorCount - 1);
            })
            legend.selectAll('rect').style("fill", function(d, i){ return colorscale(i);})
        })

        var lineChangeStyleTitle = stgPanDivForColAndLinesChart.append('div').style("background-color", options.BGcolor).attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','190px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Line Style " +'</div>')

        var lineStyleDivForColAndLinesChart = stgPanDivForColAndLinesChart.append("div") .style("background-color", options.BGcolor) .style("margin-left","200px")
        .style("margin-top","67px") .style("font-family","Verdana,sans-serif") .style("font-size","12px") .style("position","absolute")
        .style("font-weight","Bold").style("width","110px") .style("height","30px") .style("padding","0px") .style("border-radius","0px")
        
        var cardinalButton = lineStyleDivForColAndLinesChart.append("div") .style("width","32px").style("height","26px").style('position','absolute')
        .style('background-color',"#ffffff").style('margin-left',"0px") .style('top','1px') .style("cursor","pointer") .style("display","block")
        .style("border-style", "none").style('padding',"0px") .style("border", "1px solid #a0a0a0").style("line-height","0px") .style("box-sizing","border-box")
        var cardinalBtnImgVar = document.createElement("IMG");
        cardinalBtnImgVar.src = "images/curveLineIcon.png";
        cardinalBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:24px; height:22px;")
        cardinalButton[0][0].appendChild(cardinalBtnImgVar)

        var linearButton = lineStyleDivForColAndLinesChart.append("div") .style("width","32px").style("height","26px").style('position','absolute')
        .style('background-color',"#ffffff").style('margin-left',"35px") .style('top','1px') .style("cursor","pointer") .style("display","block")
        .style("border-style", "none") .style('padding',"0px") .style("line-height","0px") .style("box-sizing","border-box")
        var linearBtnImgVar = document.createElement("IMG");
        linearBtnImgVar.src = "images/linearLineIcon.png";
        linearBtnImgVar.setAttribute("style","position:absolute; left:4px; top:1px; width:22px; height:22px;")
        linearButton[0][0].appendChild(linearBtnImgVar)

        var stepButton = lineStyleDivForColAndLinesChart.append("div") .style("width","32px") .style("height","26px") .style('position','absolute')
        .style('background-color',"#ffffff") .style('margin-left',"70px") .style('top','1px') .style("cursor","pointer") .style("display","block")
        .style("border-style", "none").style('padding',"0px").style("line-height","0px").style("box-sizing","border-box")
        var stepBtnImgVar = document.createElement("IMG");
        stepBtnImgVar.src = "images/stepLineIcon.png";
        stepBtnImgVar.setAttribute("style","position:absolute; left:3px; top:0px; width:24px; height:24px;")
        stepButton[0][0].appendChild(stepBtnImgVar)

        if(options.lineStyle.toString().toLowerCase() === "cardinal"){
            cardinalButton.style('border',"1px solid #808080")
            linearButton.style('border',"0px solid #808080")
            stepButton.style('border',"0px solid #808080")
        }
        else if(options.lineStyle.toString().toLowerCase() === "linear"){
            cardinalButton.style('border',"0px solid #808080")
            linearButton.style('border',"1px solid #808080")
            stepButton.style('border',"0px solid #808080")
        }
        else if(options.lineStyle.toString().toLowerCase() === "step"){
            cardinalButton.style('border',"0px solid #808080")
            linearButton.style('border',"0px solid #808080")
            stepButton.style('border',"1px solid #808080")
        }
        else 
        {
            cardinalButton.style('border',"1px solid #808080")
            linearButton.style('border',"0px solid #808080")
            stepButton.style('border',"0px solid #808080")
        }

        cardinalButton.on('click',function(d){
            options.lineStyle = "cardinal"
            cardinalButton.style('border',"1px solid #a0a0a0")
            linearButton.style('border',"0px solid #808080")
            stepButton.style('border',"0px solid #808080")

            line.interpolate(options.lineStyle) .x(function (d) { return x1(d['label']); }) .y(function (d) { return y(+d["value"]); });

            lines.attr("d", function (d,i) { return line(d.Data)})

            resizedFunctionForColAndLinesChart();

        })
        linearButton.on('click',function(d){
            options.lineStyle = "linear"
            cardinalButton.style('border',"0px solid #a0a0a0")
            linearButton.style('border',"1px solid #a0a0a0")
            stepButton.style('border',"0px solid #a0a0a0")

            line.interpolate(options.lineStyle) .x(function (d) { return x1(d['label']); }) .y(function (d) { return y(+d["value"]); });

            lines.attr("d", function (d,i) { return line(d.Data)})

            resizedFunctionForColAndLinesChart();

        })
        stepButton.on('click',function(d){
            options.lineStyle = "step"
            cardinalButton.style('border',"0px solid #a0a0a0")
            linearButton.style('border',"0px solid #a0a0a0")
            stepButton.style('border',"1px solid #a0a0a0")

            line.interpolate(options.lineStyle) .x(function (d) { return x1(d['label']); }) .y(function (d) { return y(+d["value"]); });

            lines.attr("d", function (d,i) { return line(d.Data)})

            resizedFunctionForColAndLinesChart();
        })

        //------------------ Settings panel DIV and everything inside it section ends here ------------------

        var divLegendPanelForColAndLinesChart = targetElement .append('div')  .attr("class","") .style("background-color", options.BGcolor) .style('position',"absolute").style('width', 25 + "%") .style('height', 92 + "%") .style("left",75 + "%").style("top",8 + "%")

            if ((showOrHideTableForColAndLinesChart == false) && (showOrHideCommentsForColAndLinesChart == true)){
                divLegendPanelForColAndLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                svgPanelForColAndLinesChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForColAndLinesChart == true) && (showOrHideCommentsForColAndLinesChart == false)){
                divLegendPanelForColAndLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                svgPanelForColAndLinesChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForColAndLinesChart == false) && (showOrHideCommentsForColAndLinesChart == false)){
                divLegendPanelForColAndLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                svgPanelForColAndLinesChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute").style("background-color", options.BGcolor);
            }

        //------------------ creating legend -----------------
        
        var legendPanelSvgForColAndLinesChart = divLegendPanelForColAndLinesChart .append('svg')  .attr("class","").style("background-color", options.BGcolor)
        .style('position',"absolute").style('width', 100 + "%") .style('height', 100 + "%") .style("left",0 + "%").style("top",0 + "%")
        
        var legend = legendPanelSvgForColAndLinesChart.append("g") .attr("class", "legend") .attr("height", "100%") .attr("width", "100%")
        .attr('transform', 'translate(0,20)') 
        
        //Create colour circles
        legend.selectAll('rect') .data(options.keys.valueForLines) .enter() .append("rect") .attr("x", 5) .attr("y", function(d, i){ return i * 16;})
        .attr("width", 14) .attr("height", 14) .attr("rx",10) .attr("ry",10) .style("fill", function(d, i){ return colorscale(i);})
        .style("cursor","auto")
      
        //Create text next to circles
        legend.selectAll('text') .data(options.keys.valueForLines) .enter() .append("text") .attr("x", 25) .attr("y", function(d, i){ return i * 16 + 11.7;})
        .text(function(d) { return d; }) .text(function(d,i) {  if(d.length > 10)
            return d.substring(0,10)+'...';
            else
            return d; }) .style('font-size', '14px') .attr("fill","#00001c") .style("font-family","Verdana,sans-serif")

        // Aligning Legend (vertically)
        var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelForColAndLinesChart[0][0].style.width) / 100)
        var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelForColAndLinesChart[0][0].style.height) / 100)

        var legendRectSize = 11;
        var legendSpacing = 6;
            
        legend.attr('transform', function(d, i) {
        var eachRectHeight = legendRectSize + legendSpacing;
        var offset =  eachRectHeight * colorscale.domain().length / 2;
        var horz = 5;
        var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.valueForLines.length))/2.0; // originally 2.0
            
            return 'translate(' + horz + ',' + vert + ')';
        })
        
        // Creating ToolTip for options button.
        var iconButtonTooltipForColAndLinesChart = targetElement.append('div').style('width','240px').attr("id","too")
        .style('height',"25px").style('position','absolute')//.style('margin-left', "0px").style('top','25px')
        .style("background-color",'#404040 ').style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid") // 004b9d
        .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none").attr("border", 0.0)

        areaButtonForColAndLinesChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var areaButtonTooltipText = "Switch to Area Chart";
            iconButtonTooltipForColAndLinesChart.style("width","128px").style("margin-left", (m[0] - 138) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForColAndLinesChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ areaButtonTooltipText +'</div>')

        })
        areaButtonForColAndLinesChart.on('mouseout', function(d,i) {
            iconButtonTooltipForColAndLinesChart.style("display","none")
        })

        filterButtonForColAndLinesChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var filterButtonTooltipText = "Filter";
            iconButtonTooltipForColAndLinesChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForColAndLinesChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')

        })
        filterButtonForColAndLinesChart.on('mouseout', function(d,i) {
            iconButtonTooltipForColAndLinesChart.style("display","none")
        })

        refreshButtonForColAndLinesChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var refreshButtonTooltipText = "Refresh";
            iconButtonTooltipForColAndLinesChart.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForColAndLinesChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ refreshButtonTooltipText +'</div>')

        })
        refreshButtonForColAndLinesChart.on('mouseout', function(d,i) {
            iconButtonTooltipForColAndLinesChart.style("display","none")
        })

        commentsBtnForColAndLinesChart.on('mousemove', function(d,i) {
            commentsPanelDivForColAndLinesChart.style('background-color','#fafafa')
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                if(options.showComments == false){
                    var commentButtonTooltipText = "Show Comments";
                }
                else if(options.showComments == true){
                    var commentButtonTooltipText = "Hide Comments";
                }
            
            iconButtonTooltipForColAndLinesChart.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForColAndLinesChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ commentButtonTooltipText +'</div>')
        })
        commentsBtnForColAndLinesChart.on('mouseout', function(d,i) {
            commentsPanelDivForColAndLinesChart.style('background-color','#ffffff')
            iconButtonTooltipForColAndLinesChart.style("display","none")
        })

        menuButtonForColAndLinesChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var menuButtonTooltipText = "Menu";
            iconButtonTooltipForColAndLinesChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForColAndLinesChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ menuButtonTooltipText +'</div>')

        })
        menuButtonForColAndLinesChart.on('mouseout', function(d,i) {
            iconButtonTooltipForColAndLinesChart.style("display","none")
        })

        tableButtonForColAndLinesChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            if(showOrHideTableForColAndLinesChart == false){
                var tableButtonTooltipText = "Show Table";
            }
            else if(showOrHideTableForColAndLinesChart == true){
                var tableButtonTooltipText = "Hide Table";
            }
            iconButtonTooltipForColAndLinesChart.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForColAndLinesChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ tableButtonTooltipText +'</div>')

        })
        tableButtonForColAndLinesChart.on('mouseout', function(d,i) {
            iconButtonTooltipForColAndLinesChart.style("display","none")
        })

        settingBtnForColAndLinesChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var settingTooltipText = "Settings";
            iconButtonTooltipForColAndLinesChart.style("width","67px").style("margin-left", (m[0] - 77) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForColAndLinesChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ settingTooltipText +'</div>')
        })
        settingBtnForColAndLinesChart.on('mouseout', function(d,i) {
            iconButtonTooltipForColAndLinesChart.style("display","none")
        })
        
        downloadBtnForColAndLinesChart.on('mousemove', function(d,i) {
           var root = targetElement
           var m = d3.mouse(root.node());
           m[0] += 0
           m[1] += 0
           var downloadButtonTooltipText = "Download";
           iconButtonTooltipForColAndLinesChart.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
           iconButtonTooltipForColAndLinesChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
        })
        downloadBtnForColAndLinesChart.on('mouseout', function(d,i) {
              iconButtonTooltipForColAndLinesChart.style("display","none")
        })
        
        // ----------------- Filter panel and everything within it section begins here ----------------
        var filterPanelForColAndLinesChart = targetElement.append('div') .style('width',350 + "px") .attr("class","filterPanelForColAndLinesChartClass" + targetElement[0][0].id)
        .style('position','absolute') .style('margin-left', "0px") .style("background-color",'#fefefe') .style("z-index",11)
        .style("border-color", "#ffffff").style("border-right", "solid #e5e5e5 1px")  .style("border-style", "solid") .style("box-shadow", "2px 0px 1px #eff8ec")
        .style("display","none").style("border-top", "solid #fdfdfd 1px").style("border-left","0px").style("border-bottom", "0px")
        .style('top', 0.0 + "%").style('height', 100 + "%").style('overflow-y',"hidden").style("overflow-x","hidden")
        .style("border-bottom", "solid #e5e5e5 1px") .style("box-sizing","border-box")

        var filterPanelForStkBarChartTitle = filterPanelForColAndLinesChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif").style("font-weight", "Bold")
        .style('margin-left','0px').style('margin-top','20px').style('text-indent','5px').style("font-size", "14px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #007aff").style("width","350px").style("color","#000000")
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; top:25.0%; font-size:16px; font-family:inter;  color:#585858; font-weight:Bold;">'+ "Filter" +'</div>')

        var measuresColumnTitle = filterPanelForColAndLinesChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:14px; font-family:inter;  color:#606060; font-weight:Normal; text-align:left; text-indent:3px;">Available Measures</div>');

        var measuresVariables = filterPanelForColAndLinesChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable1"+targetElement[0][0].id)
        .style("list-style-type","none")
        .style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '78px')
        .style('position','absolute')
        .style("width","155px").style("min-height","190px").style("max-height","190px").style("border", "#f0f0f0 1px solid")
        .style("max-width","155px").style("overflow-x","hidden").style("overflow-y","auto")
        measuresVariables.style("left",0.0 + "px").style("padding","2px")

        $( ".filterPanelForColAndLinesChartClass" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });


        var measuresArray = [];
        var dimensionArray = [];

        var measuresArrayLength = [];
        var dimensionsArrayLength = [];

        dimensionArray.push(options.keys.label);
        //measuresArray = options.keys.stackedBars;

        for(var i = 0; i<divAndChartsArray.length; i++){
            if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    
                //measuresArray = newtargetElementAndOptionsArray[i].options.keys.lines;

                if(newtargetElementAndOptionsArray[i].options.keys.areas == undefined){
                    measuresArray = newtargetElementAndOptionsArray[i].options.keys.valueForLines;
                }
                else{
                    measuresArray = newtargetElementAndOptionsArray[i].options.keys.areas;
                }
            }
        }
        
        // filter process
        var uniqueMeasuresArrayKeys = [];
        $.each(measuresArray, function(i, el){
            if($.inArray(el, uniqueMeasuresArrayKeys) === -1){
                uniqueMeasuresArrayKeys.push(el);
            }
        });

        var uniqueDimensionArrayKeys = [];
        $.each(dimensionArray, function(i, el){
            if($.inArray(el, uniqueDimensionArrayKeys) === -1){
                uniqueDimensionArrayKeys.push(el);
            }
        });
        
        // setting lenght for arrays
        for(var i = 0; i<uniqueMeasuresArrayKeys.length; i++){
            measuresArrayLength.push(i);
        }

        for(var i = 0; i<uniqueDimensionArrayKeys.length; i++){
            dimensionsArrayLength.push(i);
        }

        var measuresVariables1 = measuresVariables.selectAll("li") .data(measuresArrayLength).enter().append("li")
        .style("width","130px") .style("max-height","22px").style("cursor","move")
        .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#bcf1bc").style("font-weight","Normal")
        .style("list-style-type","none").style("border","1px #89e789 solid").style("color","#006600").style("font-family","Verdana,sans-serif")
        .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
        .text(function(d) {return uniqueMeasuresArrayKeys[d]})
        measuresVariables1.attr("class","MeasuresClass"+targetElement[0][0].id)
        
        var measuresColumnReceivedUI_TableTitle = filterPanelForColAndLinesChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','180px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:14px; font-family:inter;  color:#606060; font-weight:Normal; text-align:left; ">Selected Measures</div>');

        var measuresColumnReceivedUI_Table = filterPanelForColAndLinesChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable3"+targetElement[0][0].id)
        .style('background-color',"#ffffff").style('margin-left','180px').style('margin-top', '78px')
        .style("width","155px").style('position','absolute').style("padding","2px").style("min-height","190px")
        .style("border","1px #c1c1c1 dashed") .style("max-height","190px") .style("overflow-x","hidden") .style("overflow-y","auto")
        //.html('<div class=unsortable  style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:65.0%; font-size:14px; font-family:inter;  color:#99ea99; font-weight:Normal; text-align:center;">Drag and Drop Measures here from Available Measures List. </div>');
        .html('<img class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' src="images/dragIcon.png" style=" width:36px; height:36px; position:absolute; margin-left:65px; margin-top:60px; opacity:0.6"/>' 
        + '<div class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:60.0%; font-size:12px; font-family:inter;  color:#89d289; font-weight:Normal; text-align:center;">Drop Measures here. </div>');
        //.html('<div style="background-image: url(images/dragIcon.png); height: 64px; width: 64px; border: 1px solid black;"> </div>');

        var cancelButton = filterPanelForColAndLinesChart.append("div") .style("width","23px").style("height","21px").style('position','absolute')
        .style('margin-left','320px').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
        .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.9; background-color:#fcfcff")
        cancelButton[0][0].appendChild(cancelBtnImgVar)

        cancelButton.on("click", function(){
            filterPanelForColAndLinesChart.style("display","none")

            if ((showOrHideTableForColAndLinesChart == false) && (showOrHideCommentsForColAndLinesChart == true)){
                divLegendPanelForColAndLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                svgPanelForColAndLinesChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute");
            }
            else if ((showOrHideTableForColAndLinesChart == true) && (showOrHideCommentsForColAndLinesChart == false)){
                divLegendPanelForColAndLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                svgPanelForColAndLinesChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute");
            }
            else if ((showOrHideTableForColAndLinesChart == false) && (showOrHideCommentsForColAndLinesChart == false)){
                divLegendPanelForColAndLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                svgPanelForColAndLinesChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute");
            }
        })

        var reRenderChartAndTableButton = filterPanelForColAndLinesChart.append("button").style("width","120px").style("height","25px").style('position','absolute')
        .style('margin-left','112px').style('margin-top','298px') .style("border-style", "none").style('background-color',"#2196f3")
        .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','15px').style("border-style", "solid").style('color','#ffffff')
        .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 1px #9b9b9b").style("border-radius","0px")
        var textForReRenderButton = document.createTextNode("Apply Changes");
        reRenderChartAndTableButton[0][0].appendChild(textForReRenderButton)

        reRenderChartAndTableButton.on("click", function(){
            
            if( $("#sortable3"+targetElement[0][0].id).children("li").length == 0 )
            {

                var alertPageDisabledDivForColAndLinesChart =targetElement.append('div').style('width',100 + '%')
                .style('height',100 + "%").style('position','absolute').style('margin-left', '0px').style('top', '0px')
                .style("background-color",'#f3f3f3').style("z-index",99)//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("opacity",0.2).style("display","block")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")

                var alertDivForColAndLinesChart = targetElement.append('div').style('width','350px')
                .style('height',"150px").style('position','absolute').style('left', ((targetElement[0][0].clientWidth/2) - 175) + "px").style('top', '1px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "solid").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","0px")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
                //.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Bold;">Sorry, no result found for selected' + 'range!'+ '</br>' + '<label style=text-indent:10px;> Hello</label' +'</div>')
                .html('<p  style="width: 340px; height:0%; background-color:#c7c7c7; position: absolute; top:40.0%; font-size:14px; font-family:inter; font-weight:Bold; margin-left:10px;  color:#f8f8f8; font-weight:Normal;">Check whether the Selected Measures box is not empty!</p>')

                var alertDivTitleForColAndLinesChart = alertDivForColAndLinesChart.append('div').style('width','340px')
                .style('height',"30px").style('position','absolute').style('margin-left', "0px").style('top', '0px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "none").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","2px")
                .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; font-weight:Bold; text-indent:5px;  color:#e5e5e5; font-weight:Normal;">TimeBound</div>')

                var ColAndLinesChartAlertOKButton = alertDivForColAndLinesChart.append("button") .style("width","40px") .style("height","20px") .style('position','absolute') .style("box-shadow", "0px 1px 1px #B8B8B8") 
                .style('background-color',"#7cc15e") .style('margin-left','300px') .style('top', "120px").style("color","#ffffff")
                .style("display","block").style('padding-top',"0px").style("cursor","pointer").style("box-shadow", "1px 1px 1px #56973a") .style("border-style", "none")
                .style("font-family","Verdana,sans-serif").style("font-size","14px").style("text-align","center").style("vertical-align","middle").style("border-radius","0px")
                .style("z-index",999)
            
                var textForColAndLinesChartAlertOKButton = document.createTextNode("OK");
                lineChartAlertOKButton[0][0].appendChild(textForLineChartAlertOKButton)

                $("#"+targetElement[0][0].id).resizable('disable');

                ColAndLinesChartAlertOKButton.on('click', function() {
                    alertDivForColAndLinesChart.remove();
                    alertPageDisabledDivForColAndLinesChart.remove()
                    $("#"+targetElement[0][0].id).resizable('enable');
                })

                filterButtonForColAndLinesChart.style("cursor","pointer")
                
                if(showOrHideTableForColAndLinesChart == false){ 
                    svgPanelForColAndLinesChart.style('width', 75 + "%") .style('height', 85 + "%").style("position","absolute")
                    divLegendPanelForColAndLinesChart.style('width', 25 + "%") .style('height', 85 + "%").style("position","absolute")
                }   
                else if(showOrHideTableForColAndLinesChart == true){ 
                    svgPanelForColAndLinesChart.style('width', 75 + "%") .style('height', 52 + "%").style("position","absolute")
                    divLegendPanelForColAndLinesChart.style('width', 25 + "%") .style('height', 52 + "%").style("position","absolute")
                } 

                resizedFunctionForColAndLinesChart();
            }

            else{

                var selectedLineMeasures = [];
                for(var i=0; i<$("#sortable3"+targetElement[0][0].id).children("li").length;i++){
                    selectedLineMeasures.push($("#sortable3"+targetElement[0][0].id).children("li")[i].textContent)
                }
            
                var newOptions = {
                           data: options.data,
                           dataForTable: options.dataForTable,
                           isDataDetailedForTable: options.isDataDetailedForTable,
                           keys: {
                               label: options.keys.label,
                               valueForColumn: options.keys.valueForColumn,
                               valueForLines: selectedLineMeasures,
                           },
                           chartTitle:options.chartTitle,
                           xAxisLable: options.keys.label,
                           yAxisLable: "",
                           //dimensions: options.dimensions,
                           //measures: options.measures,
                           showTitle: true,
                           BGcolor:options.BGcolor,
                           series:options.series,
                           legend:options.legend,
                           colorSet: options.colorSet,
                           lineStyle: options.lineStyle,
                           drillDownColumnName:options.drillDownColumnName,
                           showTable: options.showTable,
                           showComments: options.showComments,
                           comments: options.comments,
                           resizeButtonID: options.resizeButtonID
                        }
                        
                        d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                        acinfotech.colAndLinesChart(targetElement,newOptions)
                }
        })

        var textBoxForMeasureColumnFrom;
        var textBoxForMeasureColumnTo;
        var selectTitleDivForEachDimension;

        $( "ul.droptrue"+targetElement[0][0].id ).sortable({
            appendTo: document.body,
            helper: "clone",
            connectWith: ".droptrue"+targetElement[0][0].id,
            scroll: false,
            cancel: '.unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+','+' .unMoveableIconAndTextClassDimensions'+targetElement[0][0].id,
            revertDuration: 10,
            scrollSensitivity: 10,
            scrollSpeed: 1,
            dynamic: true,

            receive: function(e, ui) { 
                 
                if (($(this)[0].id == "sortable3"+targetElement[0][0].id) || ($(this)[0].id == "sortable1"+targetElement[0][0].id)) {

                        if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                            if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                                 (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                            }
                            else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                                (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                            }

                        }
                } // if (($(this)[0].id == "sortable3") || ($(this)[0].id == "sortable1")) 

                else if (($(this)[0].id == "sortable2"+targetElement[0][0].id) || ($(this)[0].id == "sortable4"+targetElement[0][0].id)) {
                    if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                            //ui.sender.sortable("cancel");

                            if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                                 (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                            }
                            else if(  ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                                (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                            }
                        }
                } //if (($(this)[0].id == "sortable2") || ($(this)[0].id == "sortable4")) {

                $(ui.item).css({ 'position': 'relative' });

                if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                    ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                }
                 
                else if ($(this)[0].id == "sortable3"+targetElement[0][0].id) { // checking if the dropped element is in Measures drop area
                    
                    if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                        ui.sender.sortable("cancel");
                    }
                    else {
                        //ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                    }

                } // else if ($(this)[0].id == "sortable3") // checking if the dropped element is in Measures drop area ends here.

                else if ($(this)[0].id == "sortable4"+targetElement[0][0].id) { // checking if the dropped element is in Dimension drop area

                    if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                        ui.sender.sortable("cancel");
                    }
                    else {
                        ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                    }
                } //else if ($(this)[0].id == "sortable4")  // checking if the dropped element is in Dimension drop area ends here

                    if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                        
                        if ($(this)[0].id == "sortable1"+targetElement[0][0].id){
                            if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                            
                                if( ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                                    ui.sender.sortable("cancel");
                                } // if(  ui.sender.attr("id") === "sortable4")

                                else if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                                    ui.sender.sortable("cancel");
                                }
                            
                            } // if(ui.item.hasClass("DimesionsClass"))
                        }
                    if ($(this)[0].id == "sortable2"+targetElement[0][0].id){
                        if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                            
                            if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                                ui.sender.sortable("cancel");
                            }
                            else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                                ui.sender.sortable("cancel");
                               
                            }
                        }
                    }

                } //if ($(this)[0].id == "sortable1")

                if ($(this)[0].id == "sortable4"+targetElement[0][0].id){
                    if ($(this).children('li').length > 1 ){
                        ui.sender.sortable("cancel");
                        ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                    }    
                }

            }, //receive ends here

            start:function(ev, ui) { },
            stop:function(ev, ui) { },
        });
      
        //----------------- Filter panel and everything within it section ends here -----------------
		
        // Refreshing Chart and Table 
        refreshButtonForColAndLinesChart.on('click', function() {
			
			d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData;
				}
            }
            acinfotech.columnAndLinesChart(targetElement,options)

        })

        // showing/hidding chart comments 
        commentsBtnForColAndLinesChart.on('click', function() {

            if(options.showComments == false){ 
                options.showComments = true;
            }
            else if(options.showComments == true){ 
                options.showComments = false;
            }

            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                    options.showTable = false;
                }
            }
            acinfotech.columnAndLinesChart(targetElement,options)

        })

        // showing/hidding chart table
        tableButtonForColAndLinesChart.on('click', function() {

            if(showOrHideTableForColAndLinesChart == false){
                options.showTable = true;
            }
            else if(showOrHideTableForColAndLinesChart == true){
                options.showTable = false;
            }

            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                    options.showComments = false;
                }
            }
            acinfotech.columnAndLinesChart(targetElement,options)

        })

        settingBtnForColAndLinesChart.on('click', function() {
                
                ismenuBtnOfColAndLinesChartClicked = false; // Menu toggle button variable
                optsBtnPanelForColAndLinesChart.style("display","none") // To hide options button panel

                iconButtonTooltipForColAndLinesChart.style("display","none") // Removing options button ToolTip
                settingBtnForColAndLinesChart.style("cursor","pointer")
                
                stgPanDivForColAndLinesChart.style("display","block") // Showing settings panel

                svgPanelForColAndLinesChart.style('width', 75 + "%") .style('height', 52 + "%") .style('top', 8 + "%") .style("position","absolute"); // Decreasing chart panel
                divLegendPanelForColAndLinesChart.style('width', 25 + "%") .style('height', 52 + "%") .style('top', 8 + "%") .style("position","absolute"); // Decreasing chart panel

                resizedFunctionForColAndLinesChart(); // Calling resize function()

        })
        
        downloadBtnForColAndLinesChart.on('click', function() {
                                  
              ismenuBtnOfColAndLinesChartClicked = false; // Changing menu button value to false
              optsBtnPanelForColAndLinesChart.style("display","none") // Hiding option buttons panel
                                  
        })
        
        var svg = svgPanelForColAndLinesChart.append("svg") .append("g") .attr("width", width + margin.left + margin.right) .attr("height", height + margin.top + margin.bottom)
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")")
        
        var labelArray = [];
        var leftValueArray = [];
        var rightValueArray = [];
        
        options.data.forEach(function(d, i) {
                             
             d[options.keys.valueForColumn] = +d[options.keys.valueForColumn];
        })
        
        
        // Adding left Y-Axis label
        var yLeftAxisLabVar = svg.append("text") .attr("transform", "rotate(-90)") .attr("y", -70) .attr("x",0 - (height / 2)) .attr("dy", "1em") .style("text-anchor", "middle")
        .style("font-family","Verdana,sans-serif") .style("font-weight","Bold") .style("font-size","12px") .text(options.keys.valueForColumn) .style('fill',"#d1af40") .style("text-transform","capitalize")
        .style("font-style","normal")
        
        var yBar = d3.scale.linear() .domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.valueForColumn]; }))]) .range([height, 0]);
        
        var yAxisBar = d3.svg.axis() .scale(yBar) .orient("left") .ticks(5)//.tickFormat(d3.format(".2s"));
        
        var xScale = d3.scale.ordinal() .domain(d3.range(options.data.map(function(d) { return +d[options.keys.valueForColumn]; }).length)).rangeBands([0, width], 0.4); //.rangeRoundBands([0, width], 0.25);
        
        var yScale = d3.scale.linear() .domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.valueForColumn]; }), function(d) { return d; })]) .range([0, height]);
        
        svg.append("g") .attr("class", "y axis leftclass").attr("transform", "translate("+ 0 +",0)") .call(yAxisBar) .selectAll("text") .style('fill','#d1af45') .style("font-family","Verdana,sans-serif")
        .style("font-weight","normal")
        d3.select(svg[0][0]).select(".y.axis.leftclass").select("path").style("display","none")
        
        //Creating bars
        var verticalBars = svg.selectAll(".bar") .data(options.data.map(function(d) { return +d[options.keys.valueForColumn]; })) 
		.enter() .append("rect") .attr("class", "bar")
        
		verticalBars.attr("x", function (d,i) {  return xScale(i);  })
		.attr("width", xScale.rangeBand())
		.attr("y", function (d) { return height; })
		.attr("height", function (d) { return 0; })
		.transition() .delay(400) .duration(800)
		.attr("y", function (d) { return height - yScale(d); })
		.attr("height", function (d) { return yScale(d); })
        
        verticalBars.style("fill",function(d,i){ return  "#d1af45"; }).style("cursor","auto")
        
        svg.selectAll(".bar") .data(options.data.map(function(d) { return +d[options.keys.valueForColumn]; })).on("click", function(d) { selectedItem = d });
        
		var columnNames = d3.keys(options.data[0])
        var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
        
        for(var i = 0; i < columnNames.length ; i++){
            for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                    for(var k = 0; k < verticalBars[0].length; k++){
                        d3.select(verticalBars[0][k]).attr('data-drilldownkey', function(d,index){
                            return JSON.stringify(options.data[k]).slice(1, -1).split('"').join("").split(':').join("|")
                        })
                    }
                }
                else {
                }
            }
        }
		
        // Converting normal json array to nested json array
        var dataArray = [];

        options.data.forEach(function(d, i) {
            var temp = {};
            for (i = 0; i < options.keys.valueForLines.length; i++) {
                
                for (j = 0; j < Object.keys(d).length; j++) {
                     
                    if(options.keys.valueForLines[i] === Object.keys(d)[j]){
                        temp[Object.keys(d)[j]] = d[Object.keys(d)[j]]
                    }
                 }
            }
            
            dataArray.push(temp)
        });

        var finalArray = [];
        options.data.forEach(function(d, i) {
    
            var finalArrayTemp = {};
            finalArrayTemp[options.keys.label] = d[options.keys.label]
            finalArrayTemp["Data"] = dataArray[i];
            finalArray.push(finalArrayTemp)
        })
        
        var finalArrayNew = [];
        options.keys.valueForLines.forEach(function(d, i) {
    
            var temp1 = {};
            temp1["line"] = options.keys.valueForLines[i]
    
            finalArrayNew.push(temp1)
        })
        
        var finalNewNewArray = [];
        var dataArray1 = [];
        finalArrayNew.forEach(function(d, i) {
    
			var temp1 = {};
			temp1["line"] = options.keys.valueForLines[i]
			
			for (j = 0; j < options.data.length; j++) {
		   
				var tempTemp = {};
				tempTemp["label"] = options.data[j][options.keys.label];
				tempTemp["value"] = options.data[j][options.keys.valueForLines[i]];

				dataArray1.push(tempTemp)
			}
		 
			temp1["Data"] = dataArray1;
			dataArray1 = []
			finalNewNewArray.push(temp1)
		})

        var x = d3.scale.ordinal().domain(options.data.map(function(d,i) { return d[options.keys.label];})).rangePoints([0, width],1.35);

        var x1 = d3.scale.ordinal() .domain(options.data.map(function(d) { return d[options.keys.label]; })) .rangePoints([0, width], 1.35);

        var max = d3.max(finalArray, function(d) {
			return d.Data[options.keys.valueForLines[0]]
        });
    
    var maxArray = [];
    for (i = 0; i < options.keys.valueForLines.length; i++) {
        var max = d3.max(finalArray, function(d) {
                    return +d.Data[options.keys.valueForLines[i]]
        });

        maxArray.push(max)
    }

    var finallyMaxValue = d3.max(maxArray, function(d) { return +d; })

    var y = d3.scale.linear() .domain([0, d3.max(maxArray, function(d) { return +d; })] ) .range([height, 0]);
        
    var color = d3.scale.category10();

    var xAxis = d3.svg.axis() .scale(x) .orient("bottom");
    
    var yAxis = d3.svg.axis() .scale(y) .ticks(5) .orient("right");
    let key=options.xAxisLable;
    let array=options.data.map(value => value[key]);
    let ArrayValue=[];
    var RotateValue;
    for(let i=0;i<array.length;i++){
            ArrayValue[i]=array[i].length;
    }
    const numberGreaterThanLimit = ArrayValue.filter((v) => v > 5);
    var xAxisLineAndMarginLabels = svg.append("g") .attr("class", "x axis") .attr("transform", "translate(0," + height + ")") .call(xAxis)
   
    // Add the X Axis margin labels
    .selectAll("text") .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') 
    .attr("transform", function(d) { 
        if(numberGreaterThanLimit.length>0){return "rotate(-45)"}
        else{
        return "rotate(0)" } })
    .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
    .text(function(d,i) {
        if(d.length > 9)
        return d.substring(0,9)+'...';
        else
        return d;
        })

    svg.append("g") .attr("class", "y axis rightclass").attr("transform", "translate("+ width +",0)") .call(yAxis) .selectAll("text") .style('fill','#00001c') .style("font-family","Verdana,sans-serif")

    color.domain(options.keys.valueForLines.map(function (d) { return d; }));
      
    var minX = d3.min(finalNewNewArray, function (kv) { return d3.min(kv.Data, function (d) { return +d.value; }) });
    var maxX = d3.max(finalNewNewArray, function (kv) { return d3.max(kv.Data, function (d) { return +d.value; }) });
    var minY = d3.min(finalNewNewArray, function (kv) { return d3.min(kv.Data, function (d) { return +d.value; }) });
    var maxY = d3.max(finalNewNewArray, function (kv) { return d3.max(kv.Data, function (d) { return +d.value; }) });

    x.domain([minX, maxX]);
    y.domain([minY, maxY]);

    // Creating line data
	var line = d3.svg.line() .interpolate(options.lineStyle) .x(function (d) { return x1(d['label']); }) .y(function (d) { return y(+d["value"]); });

    // Creating lines
    var lines = svg.selectAll(".line") .data(finalNewNewArray) .enter() .append("g") .append("path") .attr("class", "line")
    .attr("d", function (d,i) { return line(d.Data); }) .style("stroke", function (d,i) { return colorscale(i); })
    .style("stroke-width",1.0) .style('fill','none') .style("stroke-linecap", "butt")
    
    // Creating circles on lines
    var colorCount = 0;
    var circle1 = svg.selectAll("g.dot") .data(finalNewNewArray) .enter() .append("g")
    .attr("class", "dot") .selectAll("circle") .data(function(d) { return d.Data; }) .enter() .append("circle") .attr("r", 4.5)
    .attr("cx", function(d,i) {  return x1(d['label']); }) .attr("cy", function(d,i) {  return y(+d["value"]); })
    .style("fill", function (d,i) {
        if(i == 0){
            colorCount++;
        }
        return colorscale(colorCount - 1);
    })

        var columnNames = d3.keys(options.data[0])
        var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
        
        for(var i = 0; i < columnNames.length ; i++){
            for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                    for(var k = 0; k < options.keys.valueForLines.length; k++){
                        var len = d3.select(svg[0][0]).selectAll('g.dot')
                        for(var l = 0; l < d3.select(len[0][k]).selectAll('circle')[0].length; l++){
                            var cir = d3.select(len[0][k]).selectAll('circle')[0][l];
                            d3.select(cir).attr('data-drilldownkey', function(d,index){
                                    return JSON.stringify(options.data[l]).slice(1, -1).split('"').join("").split(':').join("|")
                                })
                        }
                    }
                }
                else {
                }
            }
        }
    
    // Adding the text label for the X axis
    var xAxisVariable =  svg.append("text") .attr("transform", "translate(" + ((width/2) - 0) + " ," + (height+margin.bottom - 2) + ")")
    .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif") .style("font-weight","Bold") .style("font-size","12px") .text(options.xAxisLable) .style('fill','#00001c') 
    .style("text-transform","capitalize") .style("font-style","normal")

    legend.selectAll('rect').on('mouseover',function(d,i){
        d3.select(lines[0][i]).style('stroke-width',2)

        var lineLen = lines.node().getTotalLength();
        var dashLen = options.data.length;
        var ddLen = dashLen ;
        var darray = dashLen;
        while(ddLen < lineLen){
            darray+=","+dashLen+","+dashLen;
            ddLen+=dashLen;
        }

        d3.select(lines[0][i]).attr("stroke-linecap", "round").attr("stroke-dasharray", darray + ","+lineLen) .attr("stroke-dashoffset", lineLen)
        .transition().duration(5000).ease("linear").attr("stroke-dashoffset", 0);
    })

    legend.selectAll('rect').on('mouseout',function(d,i){
        d3.select(lines[0][i]).style('stroke-width',1) .transition().duration(0)
        d3.select(lines[0][i]).attr("stroke-dasharray", options.data.length + ","+ 0)  .attr("stroke-dashoffset", 0)
    })

    var tooltipForColAndLinesChart = targetElement .append('div') .attr('class', 'tooltipPie') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
        .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
        .style("padding-right", "7px") .style("background", "#ffffff") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style("z-index",1000)
        .style("border", "1.0px") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","60px")
        tooltipForColAndLinesChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'label').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "14px") .style("font-weight", "normal");
        tooltipForColAndLinesChart.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
        tooltipForColAndLinesChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");
        
        if(options.keys.toolTipLabel.length > 0){
            
            for(toolTipInd = 0; toolTipInd < options.keys.toolTipLabel.length; toolTipInd++){
                tooltipForColAndLinesChart.append('hr').style("height","1px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
                tooltipForColAndLinesChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'tooltip-additional-label-columnandlines-chart' + toolTipInd + '-class' ).style("color","#000000") .style("text-transform","capitalize").style("padding","1px").style("font-size", "12px").style("font-weight", "Bold");
            }
        }

        
    
    circle1.on('mousemove', function (d,i){
               
            var root = targetElement
            var m = d3.mouse(root.node());
            m[0] += 0
            m[1] += 0
            
            var valueForColAndLinesChartToolTip;
            if(d.value.toString().indexOf('.') === -1)
            {
                valueForColAndLinesChartToolTip = d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            else{
                    
                valueForColAndLinesChartToolTip = d.value;
            }

            tooltipForColAndLinesChart.select('.label').html(d.label)
            //tooltipForColAndLinesChart.select('.count').html(d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
            tooltipForColAndLinesChart.select('.count').html(valueForColAndLinesChartToolTip)
            tooltipForColAndLinesChart.style('visibility', 'visible')
            tooltipForColAndLinesChart.select('hr').style("background-color", d3.select(this).style("fill") )
            tooltipForColAndLinesChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-20) + "px").style("display","block")
               
           if(options.keys.toolTipLabel.length > 0){
               for(ind = 0; ind < options.keys.toolTipLabel.length; ind++){
                   tooltipForColAndLinesChart.select('.tooltip-additional-label-columnandlines-chart' + ind + '-class')
                   .html(options.keys.toolTipLabel[ind] + " : " + options.data[i][options.keys.toolTipLabel[ind]])
               }
           }

    })
    .on('mouseout', function(){ tooltipForColAndLinesChart.style("display","none"); })
        
        verticalBars.on('mousemove', function (d,i){
                        
            var root = targetElement
            var m = d3.mouse(root.node());
            m[0] += 0
            m[1] += 0
            
            var valueForColAndLinesToolTip;
            if(d.toString().indexOf('.') === -1)
            {
                valueForColAndLinesToolTip = d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            else{
            
                valueForColAndLinesToolTip = d;
            }
            
            tooltipForColAndLinesChart.select('.label').html(options.keys.label + " : " + options.data[i][options.keys.label] )
            //tooltipForColAndLinesChart.select('.count').html(d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
            tooltipForColAndLinesChart.select('.count').html(options.keys.valueForColumn + " : " + valueForColAndLinesToolTip)
            tooltipForColAndLinesChart.style('visibility', 'visible')
            tooltipForColAndLinesChart.select('hr').style("background-color", d3.select(this).style("fill") )
            tooltipForColAndLinesChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-20) + "px").style("display","block")
                        
            if(options.keys.toolTipLabel.length > 0){
                for(ind = 0; ind < options.keys.toolTipLabel.length; ind++){
                    tooltipForColAndLinesChart.select('.tooltip-additional-label-columnandlines-chart' + ind + '-class')
                    .html(options.keys.toolTipLabel[ind] + " : " + options.data[i][options.keys.toolTipLabel[ind]])
                }
            }
        })
        .on('mouseout', function(){ tooltipForColAndLinesChart.style("display","none"); })

        
        var tableDivForColAndLinesChart = targetElement .append('div')
        .attr("class","scrollingDivForTable-Class tableDivForColAndLinesChart" + targetElement[0][0].id) .style('background-color',"#ffffff") .style("position","absolute")
        .style("display","block") .style("overflow","hidden") //.style("border-right","1px solid #e2e2e2").style("border-bottom","1px solid #e2e2e2")

        $( '.tableDivForColAndLinesChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });
            
        if(options.showTitle == true){
            tableDivForColAndLinesChart.style("width", 100 + "%") .style("height", 40 + "%") .style("top",60 + "%") 
                       
        }
        else if(options.showTitle == false){
            tableDivForColAndLinesChart.style("width", 100 + "%") .style("height", 40 + "%") .style("top",60 + "%") 
        }

        tableDivForColAndLinesChart.html('<table class = "tableClassForColAndLinesChart' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                  '<thead class = "theadClassForColAndLinesChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForColAndLinesChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                                  '<tbody class = "tBodyClassForColAndLinesChart' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                  '</table>'
                                  )
        
        tableDivForColAndLinesChart.select('table').attr("id",targetElement[0][0].id + "tableID")

        // Show or Hide Table scroll when mouseover on widget
        targetElement.on('mouseover',function(){ tableDivForColAndLinesChart.style("overflow","auto") })
        targetElement.on('mouseout',function(d){ tableDivForColAndLinesChart.style("overflow","hidden") })
        
        var tableDataForColAndLinesChart = [];
        if(options.dataForTable.length > 0){
            tableDataForColAndLinesChart = options.dataForTable;
        }
        else {
            tableDataForColAndLinesChart = options.data;
        }

        
        var thead = tableDivForColAndLinesChart.select("thead").selectAll("th") .data(d3.keys(tableDataForColAndLinesChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#fefdfd")//f6f6f6
        .style("position","relative").style("top","2px")
        
        var thead1 = d3.select(".thead1ClassForColAndLinesChart" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tableDataForColAndLinesChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#fefdfd")//f6f6f6
        .style("position","relative").style("top","2px")
        
        var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
        .attr("id", "ascendingIconIDForColAndLinesChart") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
        
        var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
        .attr("id", "descendingIconIDForColAndLinesChart") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
        
        var tr = tableDivForColAndLinesChart.select("tbody").selectAll("tr") .data(tableDataForColAndLinesChart).enter().append("tr")
        .attr("id", function(d,i) { return "slice" + i })
        
        // cells
        var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter() .append("td") .text(function(d) { return d})
        .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
        
        var $table = $('.tableClassForColAndLinesChart' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
        
        d3.select(".theadClassForColAndLinesChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
			d.forEach(function(dd,j){
				colWidth[j] = d3.select(dd).node().getBoundingClientRect().width;
			})
        })
        
        $(".thead1ClassForColAndLinesChart" + targetElement[0][0].id).insertAfter('.tBodyClassForColAndLinesChart' + targetElement[0][0].id)
        
        $(".thead1ClassForColAndLinesChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForColAndLinesChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
        
        tableDivForColAndLinesChart.select(".thead1ClassForColAndLinesChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                    d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
        })
        
        $('.tableDivForColAndLinesChart' + targetElement[0][0].id).scroll(function () {
                                                                  
            $(".thead1ClassForColAndLinesChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForColAndLinesChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
                                                                  
        })
        
        var sortOrder = false;
        thead1.on("click",function(k,index){
                 
             sortOrder = !sortOrder;
             
             tableDivForColAndLinesChart.select(".thead1ClassForColAndLinesChart" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                                                
                    if (sortOrder) {
                                      
                        if(i == index){
                            d3.select(this).select('svg').select('#descendingIconIDForColAndLinesChart').style("visibility", "hidden")
                            d3.select(this).select('svg').select('#ascendingIconIDForColAndLinesChart').style("visibility", "visible")
                        }
                        else {
                            d3.select(this).select('svg').select('#descendingIconIDForColAndLinesChart').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForColAndLinesChart').style("visibility", "visible")
                        }
                    }
                    else{
                                      
                        if(i == index){
                            d3.select(this).select('svg').select('#descendingIconIDForColAndLinesChart').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForColAndLinesChart').style("visibility", "hidden")
                        }
                        else {
                            d3.select(this).select('svg').select('#descendingIconIDForColAndLinesChart').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForColAndLinesChart').style("visibility", "visible")
                        }
                    }
                })
             
              var monthTruOrFalAryForColAndLinesChart = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
              
              tr.sort(function(a, b) {
                      
                      if (sortOrder) {
                      var monthsArrayForColAndLinesChart = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                      } else {
                      var monthsArrayForColAndLinesChart = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                      }
                      
                      monthTruOrFalAryForColAndLinesChart = []; gotMonthArray = [];
                      tableDataForColAndLinesChart.forEach(function(d,i){
                          var da = d[k].toString().substring(0,3).toLowerCase()
                          if(monthsArrayForColAndLinesChart.indexOf(da) >= 0){
                              monthTruOrFalAryForColAndLinesChart.push(true)
                              gotMonthArray.push(da);
                          }
                          else {
                              monthTruOrFalAryForColAndLinesChart.push(false)
                          }
                      })
                      
                      if(monthTruOrFalAryForColAndLinesChart.indexOf(false) == -1){ // true
                      
                      monthArray = []; monthArrayCount = [];
                      gotMonthArray.forEach(function(dd,j){
                            var index1 = monthsArrayForColAndLinesChart.indexOf(dd.substring(0,3))
                            if(monthArrayCount.indexOf(index1) >= 0){
                                index1 = 12 + index1;
                            }
                            monthArray.push(index1);
                            monthArrayCount.push(index1)
                       })
                      returnArray = []
                      monthArray.sort(function(aa, bb) {
                          returnArray.push(+aa - +bb)
                          return +aa - +bb;
                      })
                      
                      sortTableFunc()
                      return returnArray[ind++];
                      } //  if true (if jan feb if block)
                      else {
                      var data = +a[k];
                      
                      if(!isNaN(data)){
                      
                      if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                      else { return d3.descending(+a[k], +b[k]); }
                      }
                      else if(!isNaN(Date.parse(a[k]))){
                      
                      if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                      else { return new Date(b[k]) - new Date(a[k]) }
                      }
                      else {
                      
                      if (sortOrder) { return d3.ascending(a[k], b[k]); }
                      else { return d3.descending(a[k], b[k]); }
                      }
                      } // if not jan feb else block
            }); // tr
            
         })
        
        function sortTableFunc(){
            
            var table = tableDivForColAndLinesChart.select('table');
            var rows = table.selectAll('tr').data(tableDataForColAndLinesChart);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0).style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr')
            .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500) .style('opacity', 1.0).style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
        }
        
        // Main Table Styling
        tableDivForColAndLinesChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
        .style("color","#00001c")
        .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4")
        tableDivForColAndLinesChart.selectAll('td').style("height","25px") .style("border", "1px solid #ffffff") .style("font-size","12px").style("font-weight","Normal").style("color","#00001c")

        //additionally 
        tableDivForColAndLinesChart.selectAll('th').style('background-color',"#ffffff").style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
        tableDivForColAndLinesChart.selectAll('td').style("border-style","none").style("color","#00001c")
        //tablePanelForPieChart.selectAll('td').style("height","25px") .style("border", "1px solid #fcfcfc") .style("font-size","12px").style("font-weight","Normal")

        //b1da9f
        tableDivForColAndLinesChart.selectAll('table') . style("border-collapse","collapse")
        tableDivForColAndLinesChart.selectAll('table tr:first-child th').style("border-top","0px")
        tableDivForColAndLinesChart.selectAll('table tr:last-child td').style("border-bottom","0px")
        tableDivForColAndLinesChart.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
        tableDivForColAndLinesChart.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")

        if(showOrHideTableForColAndLinesChart == false){
            tableDivForColAndLinesChart.style("display","none")
        }
        else if(showOrHideTableForColAndLinesChart == true){
            tableDivForColAndLinesChart.style("display","block")
        }
        
        if(options.isDataDetailedForTable == false){
        
            var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
        
            // Adding underlines for selected drill-down column text
            var drillDownSectionsForColAndLinesChart = tableDivForColAndLinesChart.select('table').selectAll('th')
        
            var foundResult = [];
            for(var i = 0; i<drillDownSectionsForColAndLinesChart[0].length; i++){
                for(var j = 0; j<drillDownColumnNamesArray.length; j++){
                    if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForColAndLinesChart[0][i].__data__.toString().toLowerCase() ){
                        foundResult.push(i)
                    }
                }
            }
        
            var r = tableDivForColAndLinesChart.select('table').selectAll('tr').selectAll('td')
            for(var i = 0; i<r.length; i++){
                for(var j = 0; j < foundResult.length; j++){
                    var row = r[i][foundResult[j]]
                    $(row).css("text-decoration", "underline")
                }
            }
        }

        // calling resized function for the first time.
		setTimeout(function(){ resizedFunctionForColAndLinesChart() },1000)
        
        window.addEventListener('resize', function(event){ resizedFunctionForColAndLinesChart() });
        
        $(function() {
           $("#" + targetElement[0][0].id).resizable({
			resize: function(event, ui) {
					divWidth = ui.size.width;
					divHeight = ui.size.height;
					resizedFunctionForColAndLinesChart();
				}	
			});
		});

        function resizedFunctionForColAndLinesChart()
        {

            if((svgPanelForColAndLinesChart.node().getBoundingClientRect().width) && (svgPanelForColAndLinesChart.node().getBoundingClientRect().height) > 0){
                
                if(showOrHideCommentsBtnForColAndLinesChart == true){
                    areaButtonForColAndLinesChart.style('right', '0')
                    filterButtonForColAndLinesChart.style('right', '0')
                    refreshButtonForColAndLinesChart.style('right', '0')
                    commentsBtnForColAndLinesChart.style('margin-left', "2px")
                    menuButtonForColAndLinesChart.style('right', '0')
                }
                else if(showOrHideCommentsBtnForColAndLinesChart == false){
                    areaButtonForColAndLinesChart.style('right', '0')
                    filterButtonForColAndLinesChart.style('right', '0')
                    refreshButtonForColAndLinesChart.style('right', '0')
                    //commentsBtnForColAndLinesChart.style('right', '0')
                    commentsBtnForColAndLinesChart.style('display','none')
                    menuButtonForColAndLinesChart.style('right', '0')
                }

                optsBtnPanelForColAndLinesChart.style('right', '0')

                stgPanCanBtnForColAndLinesChart.style('right', '0') // setting panel cancel button.
            
                var margin1 = {top: 30 , right: 50, bottom: 80, left: 75}, //originally top: 42, left: 80
                width1 = (svgPanelForColAndLinesChart.node().getBoundingClientRect().width) - margin1.left - margin1.right,
                height1 = (svgPanelForColAndLinesChart.node().getBoundingClientRect().height) - margin1.top - margin1.bottom;
                
                var svg1 = svg;
                
                yLeftAxisLabVar.attr("transform", "rotate(-90)") .attr("y", -70) .attr("x",0 - (height1 / 2)) .attr("dy", "1em")
                
                yBar.domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.valueForColumn]; }))]) .range([height1, 0]);
                
                yAxisBar.scale(yBar) .orient("left") .ticks(5)//.tickFormat(d3.format(".2s"));
                
                xScale.domain(d3.range(options.data.map(function(d) { return +d[options.keys.valueForColumn]; }).length)) .rangeBands([0, width1], 0.4); //.rangeRoundBands([0, width1], 0.25)
                
                yScale.domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.valueForColumn]; }), function(d) { return d; })]) .range([0, height1]);
                
                //svg.append("g") .attr("class", "y axis leftclass").attr("transform", "translate("+ 0 +",0)") .call(yAxisBar) .selectAll("text") .style('fill','#00001c') .style("font-family","Verdana,sans-serif")
                
                d3.select(svg1[0][0]).select(".y.axis.leftclass").attr("transform", "translate("+ 0 +",0)").call(yAxisBar)
                
                //Creating bars
                //var verticalBars = svg.selectAll(".bar") .data(options.data.map(function(d) { return +d[options.keys.valueForColumn]; })) .enter() .append("rect") .attr("class", "bar")
                
                svg1 .selectAll(".bar").attr("x", function (d,i) {  return xScale(i);  }) .attr("y", function (d) { return height1 - yScale(d); })
                .attr("width", xScale.rangeBand())  .attr("height", function (d) { return yScale(d); });
                
                x.domain(options.data.map(function(d,i) { return d[options.keys.label];})).rangePoints([0, width1],1.35);

                x1.domain(options.data.map(function(d) { return d[options.keys.label]; })) .rangePoints([0, width1], 1.35);

                var yy = d3.scale.linear().domain([0, d3.max(maxArray, function(d) { return +d; })] ).range([height1, 0]);

                yAxis.scale(yy) .orient("right");

                xAxis.scale(x) .orient("bottom")
                
                line.x(function (d) { return x(d['label']); }) .y(function (d) { return yy(+d["value"]); });

                svg1.select("svg") .attr("width", width1 + margin1.left + margin1.right) .attr("height", height1 + margin1.top + margin1.bottom)
                
                //svg1.select(".y.axis") .attr("transform", "translate("+width1+",0)") //.call(yAxis)
                
                d3.select(svg1[0][0]).select(".y.axis.rightclass").attr("transform", "translate("+width1+",0)").call(yAxis)

                svg1.select(".x.axis") .attr("transform", "translate(0," + height1 + ")") .call(xAxis)
            
                // Add the X Axis margin labels
                .selectAll("text") .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') 
                .attr("transform", function(d)  {
                    if(numberGreaterThanLimit.length>0){return "rotate(-45)"}
                    else{
                    return "rotate(0)" }})
                .text(function(d,i) {
                      if(d.length > 9)
                      return d.substring(0,9)+'...';
                      else
                      return d;
                  })
            
                xAxisVariable.attr("transform", "translate(" + ((width1/2) - 0) + " ," + (height1+margin1.bottom - 2) + ")")

                svg1.selectAll("circle") .transition() .delay(function (d, i) { return i / options.data.length * 50; }) .duration(900).ease("bounce")
                .attr("cx", function(d,i) {  return x1(d['label']); }) .attr("cy", function(d,i) {  return yy(+d["value"]); })
            
                svg1.selectAll(".line")
                .attr("d", function (d,i) { return line(d.Data); })
        
                // Aligning Legend (vertically)
                var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelForColAndLinesChart[0][0].style.width) / 100)
                var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelForColAndLinesChart[0][0].style.height) / 100)

                var legendRectSize = 11;
                var legendSpacing = 6;
            
                legend.attr('transform', function(d, i) {
                var eachRectHeight = legendRectSize + legendSpacing;
                var offset =  eachRectHeight * colorscale.domain().length / 2;
                var horz = 5;
                var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.valueForLines.length))/2.0; // originally 2.0
            
                    return 'translate(' + horz + ',' + vert + ')';
                })
                
                colWidth = []; 
				
                d3.select(".theadClassForColAndLinesChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                        d.forEach(function(dd,j){
                                colWidth[j] = d3.select(dd).node().getBoundingClientRect().width;
                        })
                })
                tableDivForColAndLinesChart.select(".thead1ClassForColAndLinesChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                        d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
                })
                


            } // checking svg panel width & height is greater than zero  
        }
    }, //columnAndLinesChart
    
     // ************************************************** Bell Curve Chart with Min and Max Range **************************************************

    bellCurveChartWithMinAndMaxRange: function(targetElement,options){
    
        //targetElement.style("min-width", "92%").style("min-height", "350px").style("max-width", "92%").style("max-height", "350px")
        
        var chartName = "BELLCURVECHARTWITHMINANDMAXRANGE";
        
        acinfotech.allCharts(targetElement,options,chartName);
        
        targetElement.style("min-width", "350px").style("min-height", "350px").style("background-color", options.BGcolor)
        
        var titlePanelForBellCurveChartWithMinAndMax =  targetElement.append("div") .style("background-color","#ffffff") .style("position","absolute")
        .style("padding","0px") .style("text-align", "left") .style("background-color", options.BGcolor) .style("text-indent","6px")
        
        var minAndMaxRangeBtnForBellCurveChartWithMinAndMax = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style("background-color", options.BGcolor).style("z-index",10).style('right', '0')
        .style('top','1px') .style("cursor","pointer").style("display","none")
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var minAndMaxRangeBtnImgVar = document.createElement("IMG");
        minAndMaxRangeBtnImgVar.src = "images/minAndMaxRangeIcon.png";
        minAndMaxRangeBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:18px; height:16px; opacity:0.95;")
        minAndMaxRangeBtnForBellCurveChartWithMinAndMax[0][0].appendChild(minAndMaxRangeBtnImgVar)
        
        var filterButtonForBellCurveChartWithMinAndMax = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10).style('right', '0')
        .style('top','1px') .style("cursor","pointer").style("display","none")
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var filterBtnImgVar = document.createElement("IMG");
        filterBtnImgVar.src = "images/filterIcon.png";
        filterBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.8;")
        filterButtonForBellCurveChartWithMinAndMax[0][0].appendChild(filterBtnImgVar)
        
        var refreshButtonForBellCurveChartWithMinAndMax = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10).style('right', '0')
        .style('top','1px') .style("cursor","pointer").style("display","none")
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var refreshBtnImgVar = document.createElement("IMG");
        refreshBtnImgVar.src = "images/refreshIcon.png";
        refreshBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.8;")
        refreshButtonForBellCurveChartWithMinAndMax[0][0].appendChild(refreshBtnImgVar)
        
        var downloadBtnForBellCurveChartWithMinAndMax = targetElement.append("div").attr("id","downloadBtnForBellCurveChartWithMinAndMax-ID-" + targetElement[0][0].id)
        .style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff")
        .style('right', '0').style('top','1px').style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8")
        .style("border", "1px solid #f8f8f8")
        
        acinfotech.downloadFunctionality("downloadBtnForBellCurveChartWithMinAndMax-ID-" + targetElement[0][0].id,targetElement)
        
        var svgPanelForBellCurveChartWithMinAndMax = targetElement .append('svg') 
        .attr("class","bellCurve") .style("background-color", options.BGcolor) .style("position","absolute")
        
        if(options.showTitle == true){
            
            titlePanelForBellCurveChartWithMinAndMax.style("width", function(d) {  return 100.00 + "%"; }) .style("background-color", options.BGcolor).style("height", function(d) { return 8 + "%"; })
            .html('<div  style="width: 100%; height:0%; position: absolute; top:25.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')
            svgPanelForBellCurveChartWithMinAndMax.attr('width', 100 + "%") .attr('height', 92 + "%") .style("top",8 + "%") .append('g')
            
            var margin = {top: 10 , right: 40, bottom: 80, left: 45}, //originally top: 42, left: 80
            width = (svgPanelForBellCurveChartWithMinAndMax.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = (svgPanelForBellCurveChartWithMinAndMax.node().getBoundingClientRect().height) - margin.top - margin.bottom;
            
        }
        else if(options.showTitle == false){
            titlePanelForBellCurveChartWithMinAndMax.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });
            svgPanelForBellCurveChartWithMinAndMax.attr('width', 100 + "%") .attr('height', 100 + "%") .style("left",0 + "%") .append('g')
            
            var margin = {top: 10, right: 40, bottom: 80, left: 45}, //originally top: 42, left: 80
            width = (svgPanelForBellCurveChartWithMinAndMax.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = svgPanelForBellCurveChartWithMinAndMax.node().getBoundingClientRect().height - margin.top - margin.bottom;
        }
        
        var colors;
        // checking color set for curves and dots
        if(options.colorSet === undefined){
            options.colorSet = "one"
            colors = ["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"];
        }
        else if(options.colorSet.toString().toLowerCase() === "one"){
            options.colorSet = "one"
            colors = ["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"];
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            options.colorSet = "two"
            colors =  ["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"];
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            options.colorSet = "three"
            colors = ["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"];
        }
        else
        {
            options.colorSet = "one"
            colors = ["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"];
        }
        
        var data = [];
        options.data.forEach(function(d){
             data.push(+d[options.keys.value])
		})
        
        var normal = function(mean, variance) {
            var predicate = 1 / Math.sqrt(variance * 2 * Math.PI);
            
            return function(x) {
                return predicate * Math.exp( -Math.pow(x - mean, 2) / (2 * variance));
            };
        };
        
        // Calculate the sample variance of a data series.
        var variance = function(series) {
            var mean = d3.mean(series);
            return d3.sum(series.map(function(element) {
                 return Math.pow(element - mean, 2);
             })) / (series.length - 1);
        };
        
        min = Math.floor(d3.min(data)),
        max = Math.ceil(d3.max(data));
        
        var normalTransform = normal(d3.mean(data), variance(data));
        var xSeries = [];
        
        if((max-min).toString().length < 4){
            for (var i = min; i <= max; i++) { xSeries.push(i); }
        }
        else if(((max-min).toString().length >= 4) && (max-min).toString().length < 5){
            var increment=(max-min)/100;
            for (var i = min; i <= max; i = i + increment) { xSeries.push(i); }
        }
        else if(((max-min).toString().length >= 5) && (max-min).toString().length < 6){
            var increment=(max-min)/100;
            for (var i = min; i <= max; i = i + increment) { xSeries.push(i); }
        }
        else if(((max-min).toString().length >= 6) && (max-min).toString().length < 7){
            var increment=(max-min)/100;
            for (var i = min; i <= max; i = i + increment) { xSeries.push(i); }
        }
        else if((max-min).toString().length >= 7){
            var increment=(max-min)/1000;
            for (var i = min; i <= max; i = i + increment) { xSeries.push(i); }
        }
        
        var ySeries = xSeries.map(normalTransform);
        
        var combinedSeries = d3.zip(xSeries, ySeries);
        
        var width = targetElement[0][0].clientWidth - margin.left - margin.right,
        height = targetElement[0][0].clientHeight - margin.top - margin.bottom;
        
        var x = d3.scale.linear().range([0, width]);
        
        var y = d3.scale.linear().range([height, 0]);
        
        var xAxis = d3.svg.axis().scale(x).orient("bottom").tickFormat(d3.format(".3s")).ticks(0)//.tickSize(6, 0, 0)//.tickSubdivide(1).tickSize(0, 6, 0);
        
        var yAxis = d3.svg.axis().scale(y).orient("left").tickFormat(d3.format(".2s")).ticks(0)
        
        var line = d3.svg.line()
        .x(function(d) {
			return x(d[0]);
		})
        .y(function(d) {
			return y(d[1]);
		});
        
        var svgForBellCurveChartWithMinAndMax = svgPanelForBellCurveChartWithMinAndMax.append("svg") .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom) .append("g") .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
        
        var xAxisMinAndMaxValArr = [];
        xAxisMinAndMaxValArr.push(d3.min(options.data,function(d){ return +d[options.keys.value]; } ))
        xAxisMinAndMaxValArr.push(d3.max(options.data,function(d){ return +d[options.keys.value]; } ))
        xAxisMinAndMaxValArr.push(d3.min(options.data,function(d){ return +d[options.keys.minValue]; } ))
        xAxisMinAndMaxValArr.push(d3.max(options.data,function(d){ return +d[options.keys.minValue]; } ))
        xAxisMinAndMaxValArr.push(d3.min(options.data,function(d){ return +d[options.keys.maxValue]; } ))
        xAxisMinAndMaxValArr.push(d3.max(options.data,function(d){ return +d[options.keys.maxValue]; } ))
        
        //x.domain(d3.extent(combinedSeries, function(d) { return d[0]; }));
        x.domain([d3.min(xAxisMinAndMaxValArr),d3.max(xAxisMinAndMaxValArr)])
        y.domain(d3.extent(combinedSeries, function(d) { return d[1]; }));
        
        var tip = d3.tip() .attr('class', 'd3-tip') .offset([-10, 0]) .style("font-family","Verdana,sans-serif").style("padding","4px").style("text-transform","capitalize")
		.style("font-weight","Bold").style("font-size","12px").style("color","#00001c").style("z-index",1000);
        
        svgForBellCurveChartWithMinAndMax.call(tip);
        
        var width1 = svgPanelForBellCurveChartWithMinAndMax[0][0].clientWidth;
        var height1 = svgPanelForBellCurveChartWithMinAndMax[0][0].clientHeight;
        
        var root = targetElement;
        var scr = { x: window.scrollX, y: window.scrollY, w: svgPanelForBellCurveChartWithMinAndMax[0][0].clientWidth, h: svgPanelForBellCurveChartWithMinAndMax[0][0].clientHeight };
        var body_sel = d3.select('body');
        var body = { w: body_sel.node().offsetWidth, h: body_sel.node().offsetHeight };
        //var doc = { w: width, h: height };
        var svgpos = root.node().parentNode
        
        var dist = { x: 20, y: 20 };
        
        //Finding min and max lines
        var minAndMaxLinesArray = [];
        
        options.data.forEach(function(d,i){
             minAndMaxLinesArray.push(d[options.keys.minAndMaxLines])
         })
        
        
        var uniqueMinAndMaxLinesArray = [];
        $.each(minAndMaxLinesArray, function(i, el){
               if($.inArray(el, uniqueMinAndMaxLinesArray) === -1){
               uniqueMinAndMaxLinesArray.push(el);
               }
       });
        
        
        var ticks = x.ticks()
        ticks = x.ticks()
        
        var linesMinAndMaxValArr = [];
        var tempArray = [];
        for(var i = 0; i < uniqueMinAndMaxLinesArray.length; i++){
            tempArray = [];
            options.data.forEach(function(d, j) {
                 
                 
                 for(var k = 0; k < Object.keys(d).length; k++) {
                    if(d[options.keys.label].toString().toLowerCase() === uniqueMinAndMaxLinesArray[i].toString().toLowerCase()){
                        tempArray.push(d)
                         break;
                     }
                 }
            });
            linesMinAndMaxValArr.push(tempArray)
            
        }
        
        var linesMinAndMaxValArr1 = [];
        var minAndMax = []
        var minAndMax1 = []
        
        for(var i = 0; i < linesMinAndMaxValArr.length; i++){
            linesMinAndMaxValArr[i].forEach(function(d, j) {
                for(var k = 0; k < Object.keys(d).length; k++) {
                     if(d[options.keys.label].toString().toLowerCase() === uniqueMinAndMaxLinesArray[i].toString().toLowerCase()){
                        linesMinAndMaxValArr1.push(+d[options.keys.minValue])
                        linesMinAndMaxValArr1.push(+d[options.keys.maxValue])
                        break;
                     }
                 }
             });
            
            minAndMax.push({"lab":options.keys.minValue,"val":d3.min(linesMinAndMaxValArr1),"toolTipLab":uniqueMinAndMaxLinesArray[i]})
            minAndMax.push({"lab":options.keys.maxValue,"val":d3.max(linesMinAndMaxValArr1),"toolTipLab":uniqueMinAndMaxLinesArray[i]})
            
            minAndMax1.push(d3.min(linesMinAndMaxValArr1))
            minAndMax1.push(d3.max(linesMinAndMaxValArr1))
            
            ticks.push(d3.min(linesMinAndMaxValArr1))
            ticks.push(d3.max(linesMinAndMaxValArr1))
            xAxis.tickValues(ticks)
            
            for(var l = 0; l < 2; l++){
                
                var zerothAxis = 0;
                var s = svgForBellCurveChartWithMinAndMax.call(xAxis).selectAll(".tick")
                .each(function(data) {
                      
                      var tick = d3.select(this);
                      var transform = d3.transform(tick.attr("transform")).translate;
                      if(data === minAndMax[l]["val"]){
                      zerothAxis = transform[0] - 1
                      
                      }
                  })
                
               svgForBellCurveChartWithMinAndMax.append("g").append("rect").attr("width",2).attr("height",height).style("fill",colors[2 + i]).attr("transform", "translate("+zerothAxis+",0)")
                .style("pointer","default")
                
                var minAndMaxLinesDots = svgForBellCurveChartWithMinAndMax.append('g').selectAll('circle')
                .data([minAndMax[l]])
                .enter()
                .append('circle').attr('fill',colors[2 + i])
                .attr('cx', function (d) { return zerothAxis+1; })
                //.attr('cy', function (d) { return 0;})
                //.transition().duration(2000).ease("bounce")
                .attr('cy', function (d) { return height-5; })
                .attr('r', 4).style("pointer","default")
                
                tip.html(function(d, i) {
                  var valueForBellCurveChartWithMinAndMaxToolTip;
                  if(d["val"].toString().indexOf('.') === -1)
                  {
                      valueForBellCurveChartWithMinAndMaxToolTip = d["val"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  }
                  else {
                  
                      valueForBellCurveChartWithMinAndMaxToolTip = d["val"];
                  }
                  
                  //return options.keys.label + " : " + d["toolTipLab"] + "<br>" + '<hr style="height:2px; width:100%px; margin:2px; border:none;color:#333;background-color:#E0E0E0;" />'+ d["lab"] +" : " + valueForBellCurveChartWithMinAndMaxToolTip;
                         
                 return d["lab"] +" : " + valueForBellCurveChartWithMinAndMaxToolTip;
                      
                });
                minAndMaxLinesDots.on('mouseover', tip.show)  .on('mouseout', tip.hide)
                
                minAndMaxLinesDots.on("mousemove", function(d,i){
                     var m = d3.mouse(root.node());
                     scr.x = window.scrollX;
                     scr.y = window.scrollY;
                     m[0] += 0
                     m[1] += 0
                     tip.style("right", "");
                     tip.style("left", "");
                     tip.style("bottom", "");
                     tip.style("top", "");
                     
                     tip.style("border-color", d3.select(this).style("fill"))
                     if(d3.mouse(this)[0] < scr.w/2){
                     
                     tip.style("left", (d3.event.pageX + 12 )  + "px");
                     tip.style("top", (d3.event.pageY - ( parseFloat(tip.style("height")) /2  ) )+ "px");
                     }
                     else if(d3.mouse(this)[0] > scr.w/2){
                     
                     tip.style("left", (d3.event.pageX) - (parseFloat(tip.style("width"), 10) + 20) + "px");
                     tip.style("top", (d3.event.pageY - ( parseFloat(tip.style("height")) /2  ) ) + "px");
                     }
                     else if(d3.mouse(this)[0] == scr.w/2){
                     
                     tip.style("left", (d3.event.pageX) - (parseFloat(tip.style("width"), 10) + 20) + "px");
                     tip.style("top", (d3.event.pageY - ( parseFloat(tip.style("height")) /2  ) ) + "px");
                     }
                 });
            }
            
            linesMinAndMaxValArr1 = []
            minAndMax = []
        }
        
        
        var meanArray = [];
        for(var i = 0; i < options.data.length; i++){
            meanArray.push(options.data[i][options.keys.value])
        }
        
        ticks.push(d3.sum(meanArray)/options.data.length)
        xAxis.tickValues(ticks)
        
        var zerothAxis = 0;
        var s = svgForBellCurveChartWithMinAndMax.call(xAxis).selectAll(".tick")
        .each(function(data) {
              
              var tick = d3.select(this);
              var transform = d3.transform(tick.attr("transform")).translate;
              if(data === d3.sum(meanArray)/options.data.length){
                  zerothAxis = transform[0]
              }
        })
        
        var y1 = d3.scale.linear().range([height, 0]);
        var yAxis1 = d3.svg.axis().scale(y1).orient("left").tickFormat(d3.format(".2s")).ticks(0)
        y1.domain([0, d3.max(options.data, function(d) { return +d[options.keys.label]; })] ).range([height, 0]);
        svgForBellCurveChartWithMinAndMax.append("g") .attr("transform", "translate("+zerothAxis+",0)")
        .attr("class", ".y axis") .call(yAxis1) .style("font-weight","normal").style("fill","#00001c")
        svgForBellCurveChartWithMinAndMax.select(".axis").select("path").style("stroke-width","2px") // manually setting the thickness of y-axis
        svgPanelForBellCurveChartWithMinAndMax.select('path').remove();
        s.remove();
        
        //svgForBellCurveChartWithMinAndMax.append("g").append("rect").attr("width",2).attr("height",height).style("fill","#007aff").attr("transform", "translate("+zerothAxis+",0)")
        
        svgForBellCurveChartWithMinAndMax.append("g") .attr("class", ".x axis") .attr("transform", "translate(0," + height + ")") .call(xAxis).selectAll("text").style("font-family","Verdana,sans-serif").style("font-weight","Normal").style("fill","#00001c");
        var xx = svgForBellCurveChartWithMinAndMax.selectAll(".axis")
        d3.select(xx[0][1]).select("path").style("stroke-width","2px")
        svgForBellCurveChartWithMinAndMax.append("g") .attr("transform", "translate("+zerothAxis+",0)") .attr("class", ".y axis")
        .style("font-weight","normal").style("font-size","12px").style("fill","#00001c")
        
        svgForBellCurveChartWithMinAndMax.append("path") .datum(combinedSeries) .attr("class", "line") .attr("d", line) .style("stroke",colors[0]) // 009966
        .style("stroke-width","2px") .style("fill","none")
        
        
        for(i = 0; i < minAndMax1.length; i++){
            var tickColor = d3.select(svgForBellCurveChartWithMinAndMax.selectAll("rect")[0][i]).style("fill")
            svgForBellCurveChartWithMinAndMax.selectAll(".tick").filter(function(d){ return d === minAndMax1[i]; } ).select('line').style("stroke",tickColor).style("stroke-width","2px")
            .attr('y2',function(d){ return 20 ;})
            svgForBellCurveChartWithMinAndMax.selectAll(".tick").filter(function(d){ return d === minAndMax1[i]; } ).select('text') .attr('y',function(d){ return 24 ;})
        }
        
        svgForBellCurveChartWithMinAndMax.selectAll(".tick")
        .filter(function(d){ return d == d3.sum(meanArray)/options.data.length;} ) .select('line').style("stroke-width","2px") .attr('y2',function(d){ return 20 ;})
        
        svgForBellCurveChartWithMinAndMax.selectAll(".tick")
        .filter(function(d){ return d == d3.sum(meanArray)/options.data.length;} ).select('text') .attr('y',function(d){ return 24 ;})
        
        var curveDots = svgForBellCurveChartWithMinAndMax.append('g').selectAll('circle')
        .data(options.data)
        .enter()
        .append('circle').attr('fill',colors[1])
        .attr('cx', function (d) { return x(+d[options.keys.value]);})
        .attr('cy', function (d) { return y(normalTransform(+d[options.keys.value]));})
        .attr('r', 4).style("pointer","default")
        
        // Creating ToolTip for options button.
        var iconButtonTooltipForBellCurveChartWithMinAndMax = targetElement.append('div').style('width','240px').attr("id","too")
        .style('height',"25px").style('position','absolute')//.style('margin-left', "0px").style('top','25px')
        .style("background-color",'#404040 ').style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid") // 004b9d
        .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none").attr("border", 0.0)
        
        minAndMaxRangeBtnForBellCurveChartWithMinAndMax.on('mousemove', function(d,i) {
             var root = targetElement
             var m = d3.mouse(root.node());
             m[0] += 0
             m[1] += 0
             var filterButtonTooltipText = "Find Min and Max";
             iconButtonTooltipForBellCurveChartWithMinAndMax.style("width","115px").style("margin-left", (m[0] - 125) + "px").style("margin-top",(m[1]) + "px").style("display","block")
             iconButtonTooltipForBellCurveChartWithMinAndMax.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')
                                         
         })
        minAndMaxRangeBtnForBellCurveChartWithMinAndMax.on('mouseout', function(d,i) {
             iconButtonTooltipForBellCurveChartWithMinAndMax.style("display","none")
        })
        
        filterButtonForBellCurveChartWithMinAndMax.on('mousemove', function(d,i) {
             var root = targetElement
             var m = d3.mouse(root.node());
             m[0] += 0
             m[1] += 0
             var filterButtonTooltipText = "Filter";
             iconButtonTooltipForBellCurveChartWithMinAndMax.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
             iconButtonTooltipForBellCurveChartWithMinAndMax.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')
                                         
         })
        filterButtonForBellCurveChartWithMinAndMax.on('mouseout', function(d,i) {
             iconButtonTooltipForBellCurveChartWithMinAndMax.style("display","none")
        })
        
        refreshButtonForBellCurveChartWithMinAndMax.on('mousemove', function(d,i) {
              var root = targetElement
              var m = d3.mouse(root.node());
              m[0] += 0
              m[1] += 0
              var refreshButtonTooltipText = "Refresh";
              iconButtonTooltipForBellCurveChartWithMinAndMax.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
              iconButtonTooltipForBellCurveChartWithMinAndMax.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ refreshButtonTooltipText +'</div>')
              
          })
        refreshButtonForBellCurveChartWithMinAndMax.on('mouseout', function(d,i) {
              iconButtonTooltipForBellCurveChartWithMinAndMax.style("display","none")
        })
        
        downloadBtnForBellCurveChartWithMinAndMax.on('mousemove', function(d,i) {
           var root = targetElement
           var m = d3.mouse(root.node());
           m[0] += 0
           m[1] += 0
           var downloadButtonTooltipText = "Download";
           iconButtonTooltipForBellCurveChartWithMinAndMax.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
           iconButtonTooltipForBellCurveChartWithMinAndMax.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
        })
        downloadBtnForBellCurveChartWithMinAndMax.on('mouseout', function(d,i) {
           iconButtonTooltipForBellCurveChartWithMinAndMax.style("display","none")
        })
        
        // ----------------- Filter panel and everything within it section begins here ----------------
        var filterPanelForBellCurveChartWithMinAndMax = targetElement.append('div') .style('width',350 + "px") .attr("class","filterPanelForBellCurveChartWithMinAndMaxClass" + targetElement[0][0].id)
        .style('position','absolute') .style('margin-left', "0px") .style("background-color",'#fefefe') .style("z-index",11)
        .style("border-color", "#ffffff").style("border-right", "solid #e5e5e5 1px")  .style("border-style", "solid") .style("box-shadow", "2px 0px 1px #eff8ec")
        .style("display","none").style("border-top", "solid #fdfdfd 1px").style("border-left","0px").style("border-bottom", "0px")
        .style('top', 0.0 + "%").style('height', 100 + "%").style('overflow-y',"hidden").style("overflow-x","hidden")
        .style("border-bottom", "solid #e5e5e5 1px") .style("box-sizing","border-box")
        
        var filterPanelForStkBarChartTitle = filterPanelForBellCurveChartWithMinAndMax.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif").style("font-weight", "Bold")
        .style('margin-left','0px').style('margin-top','20px').style('text-indent','5px').style("font-size", "14px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #007aff").style("width","350px").style("color","#000000")
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; top:25.0%; font-size:16px; font-family:inter;  color:#585858; font-weight:Bold;">'+ "Filter" +'</div>')
        
        var measuresColumnTitle = filterPanelForBellCurveChartWithMinAndMax.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:14px; font-family:inter;  color:#606060; font-weight:Normal; text-align:left; text-indent:3px;">Available Measures</div>');
        
        var measuresVariables = filterPanelForBellCurveChartWithMinAndMax.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable1"+targetElement[0][0].id)
        .style("list-style-type","none")
        .style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '78px')
        .style('position','absolute')
        .style("width","155px").style("min-height","190px").style("max-height","190px").style("border", "#f0f0f0 1px solid")
        .style("max-width","155px").style("overflow-x","hidden").style("overflow-y","auto")
        measuresVariables.style("left",0.0 + "px").style("padding","2px")
        
        $( ".filterPanelForBellCurveChartWithMinAndMaxClass" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
              var e0 = e.originalEvent,
              delta = e0.wheelDelta || -e0.detail;
              
              this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
              e.preventDefault();
        });
        
        
        var measuresArray = ["Below the mean","Above the mean"];
        var measuresArrayLength = [0,1];
        
        var measuresVariables1 = measuresVariables.selectAll("li") .data(measuresArrayLength).enter().append("li")
        .style("width","130px") .style("max-height","22px").style("cursor","move")
        .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#bcf1bc").style("font-weight","Normal")
        .style("list-style-type","none").style("border","1px #89e789 solid").style("color","#006600").style("font-family","Verdana,sans-serif")
        .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
        .text(function(d) {return measuresArray[d]})
        measuresVariables1.attr("class","MeasuresClass"+targetElement[0][0].id)
        
        var measuresColumnReceivedUI_TableTitle = filterPanelForBellCurveChartWithMinAndMax.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','180px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:14px; font-family:inter;  color:#606060; font-weight:Normal; text-align:left; ">Selected Measures</div>');
        
        var measuresColumnReceivedUI_Table = filterPanelForBellCurveChartWithMinAndMax.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable3"+targetElement[0][0].id)
        .style('background-color',"#ffffff").style('margin-left','180px').style('margin-top', '78px')
        .style("width","155px").style('position','absolute').style("padding","2px").style("min-height","190px")
        .style("border","1px #c1c1c1 dashed") .style("max-height","190px") .style("overflow-x","hidden") .style("overflow-y","auto")
        //.html('<div class=unsortable  style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:65.0%; font-size:14px; font-family:inter;  color:#99ea99; font-weight:Normal; text-align:center;">Drag and Drop Measures here from Available Measures List. </div>');
        .html('<img class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' src="images/dragIcon.png" style=" width:36px; height:36px; position:absolute; margin-left:65px; margin-top:60px; opacity:0.6"/>'
              + '<div class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:60.0%; font-size:12px; font-family:inter;  color:#89d289; font-weight:Normal; text-align:center;">Drop Measures here. </div>');
        //.html('<div style="background-image: url(images/dragIcon.png); height: 64px; width: 64px; border: 1px solid black;"> </div>');
        
        var cancelButton = filterPanelForBellCurveChartWithMinAndMax.append("div") .style("width","23px").style("height","21px").style('position','absolute')
        .style('margin-left','320px').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white')
        .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.9; background-color:#fcfcff")
        cancelButton[0][0].appendChild(cancelBtnImgVar)
        
        cancelButton.on("click", function(){
            filterPanelForBellCurveChartWithMinAndMax.style("display","none")
        })
        
        var reRenderChartAndTableButton = filterPanelForBellCurveChartWithMinAndMax.append("button").style("width","120px").style("height","25px").style('position','absolute')
        .style('margin-left','112px').style('margin-top','298px') .style("border-style", "none").style('background-color',"#2196f3")
        .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','15px').style("border-style", "solid").style('color','#ffffff')
        .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 1px #9b9b9b").style("border-radius","0px")
        var textForReRenderButton = document.createTextNode("Apply Changes");
        reRenderChartAndTableButton[0][0].appendChild(textForReRenderButton)
        
        reRenderChartAndTableButton.on("click", function(){
                                       
           if( $("#sortable3"+targetElement[0][0].id).children("li").length == 0 )
           {
           
               var alertPageDisabledDivForBellCurveChartWithMinAndMax =targetElement.append('div').style('width',100 + '%')
               .style('height',100 + "%").style('position','absolute').style('margin-left', '0px').style('top', '0px')
               .style("background-color",'#f3f3f3').style("z-index",99)//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
               .style("opacity",0.2).style("display","block")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
               
               var alertDivForBellCurveChartWithMinAndMax = targetElement.append('div').style('width','350px')
               .style('height',"150px").style('position','absolute').style('left', ((targetElement[0][0].clientWidth/2) - 175) + "px").style('top', '1px')
               .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "solid").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
               .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","0px")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
               //.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Bold;">Sorry, no result found for selected' + 'range!'+ '</br>' + '<label style=text-indent:10px;> Hello</label' +'</div>')
               .html('<p  style="width: 340px; height:0%; background-color:#c7c7c7; position: absolute; top:40.0%; font-size:14px; font-family:inter; font-weight:Bold; margin-left:10px;  color:#f8f8f8; font-weight:Normal;">Check whether the Selected Measures box is not empty!</p>')
               
               var alertDivTitleForBellCurveChartWithMinAndMax = alertDivForBellCurveChartWithMinAndMax.append('div').style('width','340px')
               .style('height',"30px").style('position','absolute').style('margin-left', "0px").style('top', '0px')
               .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "none").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
               .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","2px")
               .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; font-weight:Bold; text-indent:5px;  color:#e5e5e5; font-weight:Normal;">TimeBound</div>')
               
               var BellCurveChartWithMinAndMaxAlertOKButton = alertDivForBellCurveChartWithMinAndMax.append("button") .style("width","40px") .style("height","20px") .style('position','absolute') .style("box-shadow", "0px 1px 1px #B8B8B8")
               .style('background-color',"#7cc15e") .style('margin-left','300px') .style('top', "120px").style("color","#ffffff")
               .style("display","block").style('padding-top',"0px").style("cursor","pointer").style("box-shadow", "1px 1px 1px #56973a") .style("border-style", "none")
               .style("font-family","Verdana,sans-serif").style("font-size","14px").style("text-align","center").style("vertical-align","middle").style("border-radius","0px")
               .style("z-index",999)
               
               var textForBellCurveChartWithMinAndMaxAlertOKButton = document.createTextNode("OK");
               BellCurveChartWithMinAndMaxAlertOKButton[0][0].appendChild(textForBellCurveChartWithMinAndMaxAlertOKButton)
               
               $("#"+targetElement[0][0].id).resizable('disable');
               
               BellCurveChartWithMinAndMaxAlertOKButton.on('click', function() {
                     alertDivForBellCurveChartWithMinAndMax.remove();
                     alertPageDisabledDivForBellCurveChartWithMinAndMax.remove()
                     $("#"+targetElement[0][0].id).resizable('enable');
                 })
               
               filterButtonForBellCurveChartWithMinAndMax.style("cursor","pointer")
           
           }
                                       
           else {
           
               var selectedLineMeasures = [];
               for(var i=0; i<$("#sortable3"+targetElement[0][0].id).children("li").length;i++){
                   selectedLineMeasures.push($("#sortable3"+targetElement[0][0].id).children("li")[i].textContent)
               }
               
               var meanArray = [];
               for(var i = 0; i < options.data.length; i++){
                   meanArray.push(+options.data[i][options.keys.value])
               }
               
               var filteredDataArray = []
               if(selectedLineMeasures.length == 1){
                   if(selectedLineMeasures[0].toString().toLowerCase() === "below the mean"){
                   options.data.forEach(function(d, i) {
                        if(+d[options.keys.value] <= d3.mean(meanArray)){
                            filteredDataArray.push(d)
                        }
                        
                    });
                   
                   }
                   else if(selectedLineMeasures.toString().toLowerCase() === "above the mean"){
                       options.data.forEach(function(d, i) {
                            if(+d[options.keys.value] >= d3.mean(meanArray)){
                                filteredDataArray.push(d)
                            }
                        });
                   }
               }
               else {
               filteredDataArray = options.data;
               }
               
               var newOptions = {
                   data: filteredDataArray,
                   keys: {
                       label: options.keys.label,
                       value: options.keys.value,
                       minValue: options.keys.minValue,
                       maxValue: options.keys.maxValue,
                       minAndMaxLines: options.keys.minAndMaxLines,
                       toolTipLabel: options.keys.toolTipLabel
                   },
                   chartTitle: options.chartTitle,
                   showTitle: options.showTitle,
                   BGcolor:options.BGcolor,
                   series:options.series,
                   legend:options.legend,
                   colorSet: options.colorSet, //"one" or "two" or "three";
                   resizeButtonID: options.resizeButtonID
               }
               
               d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
               acinfotech.bellCurveChartWithMinAndMaxRange(targetElement, newOptions)
           }
       })
        
        var textBoxForMeasureColumnFrom;
        var textBoxForMeasureColumnTo;
        var selectTitleDivForEachDimension;
        
        $( "ul.droptrue"+targetElement[0][0].id ).sortable({
                   appendTo: document.body,
                   helper: "clone",
                   connectWith: ".droptrue"+targetElement[0][0].id,
                   scroll: false,
                   cancel: '.unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+','+' .unMoveableIconAndTextClassDimensions'+targetElement[0][0].id,
                   revertDuration: 10,
                   scrollSensitivity: 10,
                   scrollSpeed: 1,
                   dynamic: true,
                   
                   receive: function(e, ui) {
                   
                   if (($(this)[0].id == "sortable3"+targetElement[0][0].id) || ($(this)[0].id == "sortable1"+targetElement[0][0].id)) {
                   
                   if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                   if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                   (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                   }
                   else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                   (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                   }
                   
                   }
                   } // if (($(this)[0].id == "sortable3") || ($(this)[0].id == "sortable1"))
                   
                   else if (($(this)[0].id == "sortable2"+targetElement[0][0].id) || ($(this)[0].id == "sortable4"+targetElement[0][0].id)) {
                   if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                   //ui.sender.sortable("cancel");
                   
                   if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                   (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                   }
                   else if(  ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                   (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                   }
                   }
                   } //if (($(this)[0].id == "sortable2") || ($(this)[0].id == "sortable4")) {
                   
                   $(ui.item).css({ 'position': 'relative' });
                   
                   if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                   ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                   }
                   
                   else if ($(this)[0].id == "sortable3"+targetElement[0][0].id) { // checking if the dropped element is in Measures drop area
                   
                   if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                   ui.sender.sortable("cancel");
                   }
                   else {
                   //ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                   }
                   
                   } // else if ($(this)[0].id == "sortable3") // checking if the dropped element is in Measures drop area ends here.
                   
                   else if ($(this)[0].id == "sortable4"+targetElement[0][0].id) { // checking if the dropped element is in Dimension drop area
                   
                   if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                   ui.sender.sortable("cancel");
                   }
                   else {
                   ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                   }
                   } //else if ($(this)[0].id == "sortable4")  // checking if the dropped element is in Dimension drop area ends here
                   
                   if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                   
                   if ($(this)[0].id == "sortable1"+targetElement[0][0].id){
                   if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                   
                   if( ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                   ui.sender.sortable("cancel");
                   } // if(  ui.sender.attr("id") === "sortable4")
                   
                   else if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                   ui.sender.sortable("cancel");
                   }
                   
                   } // if(ui.item.hasClass("DimesionsClass"))
                   }
                   if ($(this)[0].id == "sortable2"+targetElement[0][0].id){
                   if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                   
                   if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                   ui.sender.sortable("cancel");
                   }
                   else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                   ui.sender.sortable("cancel");
                   
                   }
                   }
                   }
                   
                   } //if ($(this)[0].id == "sortable1")
                   
                   if ($(this)[0].id == "sortable4"+targetElement[0][0].id){
                   if ($(this).children('li').length > 1 ){
                   ui.sender.sortable("cancel");
                   ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                   }    
                   }
                   
                   }, //receive ends here
                   
                   start:function(ev, ui) { },
                   stop:function(ev, ui) { },
		});
        
        /* ----------------- Filter panel and everything within it section ends here -----------------*/
        
        // ----------------- Find Min and Max range panel and everything within it section begins here ----------------
        var minAndMaxRangePanelForBellCurveChartWithMinAndMax = targetElement.append('div') .style('width',350 + "px") .attr("class","minAndMaxRangePanelForBellCurveChartWithMinAndMaxClass" + targetElement[0][0].id)
        .style('position','absolute') .style('margin-left', "0px") .style("background-color",'#fefefe') .style("z-index",11)
        .style("border-color", "#ffffff").style("border-right", "solid #e5e5e5 1px")  .style("border-style", "solid") .style("box-shadow", "2px 0px 1px #eff8ec")
        .style("display","none").style("border-top", "solid #fdfdfd 1px").style("border-left","0px").style("border-bottom", "0px")
        .style('top', 0.0 + "%").style('height', 100 + "%").style('overflow-y',"hidden").style("overflow-x","hidden")
        .style("border-bottom", "solid #e5e5e5 1px") .style("box-sizing","border-box")
        
        var filterPanelForStkBarChartTitle = minAndMaxRangePanelForBellCurveChartWithMinAndMax.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif").style("font-weight", "Bold")
        .style('margin-left','0px').style('margin-top','20px').style('text-indent','5px').style("font-size", "14px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #007aff").style("width","350px").style("color","#000000")
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; top:25.0%; font-size:16px; font-family:inter;  color:#585858; font-weight:Bold;">'+ "Find Min and Max" +'</div>')
        
        var measuresColumnTitle = minAndMaxRangePanelForBellCurveChartWithMinAndMax.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:14px; font-family:inter;  color:#606060; font-weight:Normal; text-align:left; text-indent:3px;">Available '+ options.keys.label +'</div>');
        
        var measuresVariables = minAndMaxRangePanelForBellCurveChartWithMinAndMax.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable1"+targetElement[0][0].id)
        .style("list-style-type","none")
        .style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '78px')
        .style('position','absolute')
        .style("width","155px").style("min-height","190px").style("max-height","190px").style("border", "#f0f0f0 1px solid")
        .style("max-width","155px").style("overflow-x","hidden").style("overflow-y","auto")
        measuresVariables.style("left",0.0 + "px").style("padding","2px")
        
        $( ".minAndMaxRangePanelForBellCurveChartWithMinAndMaxClass" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
              var e0 = e.originalEvent,
              delta = e0.wheelDelta || -e0.detail;
              
              this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
              e.preventDefault();
          });
        
        
        var dimensionArray = [];
        var dimensionsArrayLength = [];
        
        options.data.forEach(function(d,i){
            dimensionArray.push(d[options.keys.label])
        })
        
        var uniqueDimensionArrayKeys = [];
        $.each(dimensionArray, function(i, el){
           if($.inArray(el, uniqueDimensionArrayKeys) === -1){
               uniqueDimensionArrayKeys.push(el);
           }
        });
        
        for(var i = 0; i<uniqueDimensionArrayKeys.length; i++){
            dimensionsArrayLength.push(i);
        }
        
        var measuresVariables1 = measuresVariables.selectAll("li") .data(dimensionsArrayLength).enter().append("li")
        .style("width","130px") .style("max-height","22px").style("cursor","move")
        .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#f8e9cd").style("font-weight","Normal")
        .style("list-style-type","none").style("border","1px #f2d199 solid").style("color","#9e6c14").style("font-family","Verdana,sans-serif")
        .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
        .text(function(d) {return uniqueDimensionArrayKeys[d]})
        measuresVariables1.attr("class","MeasuresClass"+targetElement[0][0].id)
        
        var measuresColumnReceivedUI_TableTitle = minAndMaxRangePanelForBellCurveChartWithMinAndMax.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','180px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:14px; font-family:inter;  color:#606060; font-weight:Normal; text-align:left; ">Selected '+ options.keys.label +'</div>');
        
        var measuresColumnReceivedUI_Table = minAndMaxRangePanelForBellCurveChartWithMinAndMax.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable30"+targetElement[0][0].id)
        .style('background-color',"#ffffff").style('margin-left','180px').style('margin-top', '78px')
        .style("width","155px").style('position','absolute').style("padding","2px").style("min-height","190px")
        .style("border","1px #c1c1c1 dashed") .style("max-height","190px") .style("overflow-x","hidden") .style("overflow-y","auto")
        //.html('<div class=unsortable  style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:65.0%; font-size:14px; font-family:inter;  color:#99ea99; font-weight:Normal; text-align:center;">Drag and Drop Measures here from Available Measures List. </div>');
        .html('<img class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' src="images/dragIcon.png" style=" width:36px; height:36px; position:absolute; margin-left:65px; margin-top:60px; opacity:0.6"/>'
              + '<div class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:60.0%; font-size:12px; font-family:inter;  color:#d8b479; font-weight:Normal; text-align:center;">Drop Dimensions here. </div>');
        //.html('<div style="background-image: url(images/dragIcon.png); height: 64px; width: 64px; border: 1px solid black;"> </div>');
        
        var cancelButton = minAndMaxRangePanelForBellCurveChartWithMinAndMax.append("div") .style("width","23px").style("height","21px").style('position','absolute')
        .style('margin-left','320px').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white')
        .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
		
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.9; background-color:#fcfcff")
        cancelButton[0][0].appendChild(cancelBtnImgVar)
        
        cancelButton.on("click", function(){
            minAndMaxRangePanelForBellCurveChartWithMinAndMax.style("display","none")
        })
        
        var reRenderChartAndTableButton = minAndMaxRangePanelForBellCurveChartWithMinAndMax.append("button").style("width","120px").style("height","25px").style('position','absolute')
        .style('margin-left','112px').style('margin-top','298px') .style("border-style", "none").style('background-color',"#2196f3")
        .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','15px').style("border-style", "solid").style('color','#ffffff')
        .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 1px #9b9b9b").style("border-radius","0px")
        var textForReRenderButton = document.createTextNode("Apply Changes");
        reRenderChartAndTableButton[0][0].appendChild(textForReRenderButton)
        
        reRenderChartAndTableButton.on("click", function(){
                                       
           if( $("#sortable30"+targetElement[0][0].id).children("li").length == 0 )
           {
           
               var alertPageDisabledDivForBellCurveChartWithMinAndMax =targetElement.append('div').style('width',100 + '%')
               .style('height',100 + "%").style('position','absolute').style('margin-left', '0px').style('top', '0px')
               .style("background-color",'#f3f3f3').style("z-index",99)//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
               .style("opacity",0.2).style("display","block")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
               
               var alertDivForBellCurveChartWithMinAndMax = targetElement.append('div').style('width','350px')
               .style('height',"150px").style('position','absolute').style('left', ((targetElement[0][0].clientWidth/2) - 175) + "px").style('top', '1px')
               .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "solid").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
               .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","0px")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
               //.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Bold;">Sorry, no result found for selected' + 'range!'+ '</br>' + '<label style=text-indent:10px;> Hello</label' +'</div>')
               .html('<p  style="width: 340px; height:0%; background-color:#c7c7c7; position: absolute; top:40.0%; font-size:14px; font-family:inter; font-weight:Bold; margin-left:10px;  color:#f8f8f8; font-weight:Normal;">Check whether the Selected '+ options.keys.label +' box is not empty!</p>')
               
               var alertDivTitleForBellCurveChartWithMinAndMax = alertDivForBellCurveChartWithMinAndMax.append('div').style('width','340px')
               .style('height',"30px").style('position','absolute').style('margin-left', "0px").style('top', '0px')
               .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "none").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
               .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","2px")
               .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; font-weight:Bold; text-indent:5px;  color:#e5e5e5; font-weight:Normal;">TimeBound</div>')
               
               var BellCurveChartWithMinAndMaxAlertOKButton = alertDivForBellCurveChartWithMinAndMax.append("button") .style("width","40px") .style("height","20px") .style('position','absolute') .style("box-shadow", "0px 1px 1px #B8B8B8")
               .style('background-color',"#7cc15e") .style('margin-left','300px') .style('top', "120px").style("color","#ffffff")
               .style("display","block").style('padding-top',"0px").style("cursor","pointer").style("box-shadow", "1px 1px 1px #56973a") .style("border-style", "none")
               .style("font-family","Verdana,sans-serif").style("font-size","14px").style("text-align","center").style("vertical-align","middle").style("border-radius","0px")
               .style("z-index",999)
               
               var textForBellCurveChartWithMinAndMaxAlertOKButton = document.createTextNode("OK");
               BellCurveChartWithMinAndMaxAlertOKButton[0][0].appendChild(textForBellCurveChartWithMinAndMaxAlertOKButton)
               
               $("#"+targetElement[0][0].id).resizable('disable');
               
               BellCurveChartWithMinAndMaxAlertOKButton.on('click', function() {
                     alertDivForBellCurveChartWithMinAndMax.remove();
                     alertPageDisabledDivForBellCurveChartWithMinAndMax.remove()
                     $("#"+targetElement[0][0].id).resizable('enable');
                })
               
               filterButtonForBellCurveChartWithMinAndMax.style("cursor","pointer")
           
           }
           
           else {
           
               var selectedDimensions = [];
               for(var i=0; i<$("#sortable30"+targetElement[0][0].id).children("li").length;i++){
                   selectedDimensions.push($("#sortable30"+targetElement[0][0].id).children("li")[i].textContent)
               }
               
               var newOptions = {
                   data: options.data,
                   keys: {
                       label: options.keys.label,
                       value: options.keys.value,
                       minValue: options.keys.minValue,
                       maxValue: options.keys.maxValue,
                       minAndMaxLines: selectedDimensions,
                       toolTipLabel: options.keys.toolTipLabel
                   },
                   chartTitle: options.chartTitle,
                   showTitle: options.showTitle,
                   BGcolor:options.BGcolor,
                   series:options.series,
                   legend:series.legend,
                   colorSet: options.colorSet, //"one" or "two" or "three";
                   resizeButtonID: options.resizeButtonID
               }
               
               d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
               acinfotech.bellCurveChartWithMinAndMaxRange(targetElement, newOptions)
           }
        })
        
        var textBoxForMeasureColumnFrom;
        var textBoxForMeasureColumnTo;
        var selectTitleDivForEachDimension;
        
        $( "ul.droptrue"+targetElement[0][0].id ).sortable({
               appendTo: document.body,
               helper: "clone",
               connectWith: ".droptrue"+targetElement[0][0].id,
               scroll: false,
               cancel: '.unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+','+' .unMoveableIconAndTextClassDimensions'+targetElement[0][0].id,
               revertDuration: 10,
               scrollSensitivity: 10,
               scrollSpeed: 1,
               dynamic: true,
               
               receive: function(e, ui) {
               
               if (($(this)[0].id == "sortable30"+targetElement[0][0].id) || ($(this)[0].id == "sortable1"+targetElement[0][0].id)) {
               
               if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
               if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
               (($('#sortable30'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
               }
               else if(  ui.sender.attr("id") === "sortable30"+targetElement[0][0].id){
               (($('#sortable30'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
               }
               
               }
               } // if (($(this)[0].id == "sortable30") || ($(this)[0].id == "sortable1"))
               
               else if (($(this)[0].id == "sortable2"+targetElement[0][0].id) || ($(this)[0].id == "sortable4"+targetElement[0][0].id)) {
               if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
               //ui.sender.sortable("cancel");
               
               if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
               (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
               }
               else if(  ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
               (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
               }
               }
               } //if (($(this)[0].id == "sortable2") || ($(this)[0].id == "sortable4")) {
               
               $(ui.item).css({ 'position': 'relative' });
               
               if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
               ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
               }
               
               else if ($(this)[0].id == "sortable30"+targetElement[0][0].id) { // checking if the dropped element is in Measures drop area
               
               if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
               ui.sender.sortable("cancel");
               }
               else {
               //ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
               }
               
               } // else if ($(this)[0].id == "sortable30") // checking if the dropped element is in Measures drop area ends here.
               
               else if ($(this)[0].id == "sortable4"+targetElement[0][0].id) { // checking if the dropped element is in Dimension drop area
               
               if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
               ui.sender.sortable("cancel");
               }
               else {
               ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
               }
               } //else if ($(this)[0].id == "sortable4")  // checking if the dropped element is in Dimension drop area ends here
               
               if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
               
               if ($(this)[0].id == "sortable1"+targetElement[0][0].id){
               if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
               
               if( ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
               ui.sender.sortable("cancel");
               } // if(  ui.sender.attr("id") === "sortable4")
               
               else if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
               ui.sender.sortable("cancel");
               }
               
               } // if(ui.item.hasClass("DimesionsClass"))
               }
               if ($(this)[0].id == "sortable2"+targetElement[0][0].id){
               if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
               
               if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
               ui.sender.sortable("cancel");
               }
               else if(  ui.sender.attr("id") === "sortable30"+targetElement[0][0].id){
               ui.sender.sortable("cancel");
               
               }
               }
               }
               
               } //if ($(this)[0].id == "sortable1")
               
               if ($(this)[0].id == "sortable4"+targetElement[0][0].id){
               if ($(this).children('li').length > 1 ){
               ui.sender.sortable("cancel");
               ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
               }    
               }
               
               }, //receive ends here
               
               start:function(ev, ui) { },
               stop:function(ev, ui) { },
        });
        
        /* ----------------- Find Min and Max range panel and everything within it section ends here -----------------*/
        
        minAndMaxRangeBtnForBellCurveChartWithMinAndMax.on('click', function() {
            filterPanelForBellCurveChartWithMinAndMax.style("display","none");
            minAndMaxRangePanelForBellCurveChartWithMinAndMax.style("display","block");
                                         
        })
        
        filterButtonForBellCurveChartWithMinAndMax.on('click', function() {
            minAndMaxRangePanelForBellCurveChartWithMinAndMax.style("display","none");
            filterPanelForBellCurveChartWithMinAndMax.style("display","block");
                                         
        })
        
        // Refreshing Chart and Table
        refreshButtonForBellCurveChartWithMinAndMax.on('click', function() {
                                          
              d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
              
              for(var i = 0; i<divAndChartsArray.length; i++){
              
                  if(targetElement[0][0].id === divAndChartsArray[i].divID){
                      options.data = divAndChartsArray[i].optionsData;
                      options.keys.minAndMaxLines = newtargetElementAndOptionsArray[i].options.keys.minAndMaxLines;
                  }
              }
              acinfotech.bellCurveChartWithMinAndMaxRange(targetElement,options)
                                          
		})
        
        downloadBtnForBellCurveChartWithMinAndMax.on('click', function() {
                                                     
             minAndMaxRangePanelForBellCurveChartWithMinAndMax.style("display","none");
             filterPanelForBellCurveChartWithMinAndMax.style("display","none");
                                                     
        })
        
        var curveDotsToolTip = d3.tip() .attr('class', 'd3-tip') .offset([-10, 0]) .style("font-family","Verdana,sans-serif").style("padding","4px").style("text-transform","capitalize")
		.style("font-weight","Bold").style("font-size","12px").style("color","#00001c").style("z-index",1000)
        
        curveDotsToolTip.html(function(d, i) {
			var valueForBellCurveChartWithMinAndMaxToolTip;
			if(d[options.keys.value].toString().indexOf('.') === -1)
			{
				valueForBellCurveChartWithMinAndMaxToolTip = d[options.keys.value].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			}
			else {
				valueForBellCurveChartWithMinAndMaxToolTip = d[options.keys.value];
			}

			if(options.keys.toolTipLabel.length === 0){
				return options.keys.label + " : " + options.data[i][options.keys.label] + "<br>" + '<hr style="height:2px; width:100%px; margin:2px; border:none;color:#333;background-color:#E0E0E0;" />'+ options.keys.value +" : " + valueForBellCurveChartWithMinAndMaxToolTip;
			}
			else {

				var toolTipInfoStrForBellCurveChartWithMinAndMax = "";
				for(var ind = 0; ind < options.keys.toolTipLabel.length; ind++){
					toolTipInfoStrForBellCurveChartWithMinAndMax += "<br>" + '<hr style="height:1px; width:100%px; margin:2px; border:none;color:#333;background-color:#E0E0E0;" />' + options.keys.toolTipLabel[ind] + " : " + options.data[i][options.keys.toolTipLabel[ind]]
				}

				return options.keys.label + " : " + options.data[i][options.keys.label] + "<br>" + '<hr style="height:2px; width:100%px; margin:2px; border:none;color:#333;background-color:#E0E0E0;" />'+ options.keys.value +" : " + valueForBellCurveChartWithMinAndMaxToolTip + toolTipInfoStrForBellCurveChartWithMinAndMax;
			}
              
		});
        
        svgForBellCurveChartWithMinAndMax.call(curveDotsToolTip);
        curveDots.on('mouseover', curveDotsToolTip.show)  .on('mouseout', curveDotsToolTip.hide);
        
        curveDots.on("mousemove", function(d,i){
             var m = d3.mouse(root.node());
             scr.x = window.scrollX;
             scr.y = window.scrollY;
             m[0] += 0
             m[1] += 0
             curveDotsToolTip.style("right", "");
             curveDotsToolTip.style("left", "");
             curveDotsToolTip.style("bottom", "");
             curveDotsToolTip.style("top", "");
             
             curveDotsToolTip.style("border-color", colors[1])
             if(d3.mouse(this)[0] < scr.w/2){
             
                 curveDotsToolTip.style("left", (d3.event.pageX + 12 )  + "px");
                 curveDotsToolTip.style("top", (d3.event.pageY - ( parseFloat(curveDotsToolTip.style("height")) /2  ) )+ "px");
             }
             else if(d3.mouse(this)[0] > scr.w/2){
             
                 curveDotsToolTip.style("left", (d3.event.pageX) - (parseFloat(curveDotsToolTip.style("width"), 10) + 20) + "px");
                 curveDotsToolTip.style("top", (d3.event.pageY - ( parseFloat(curveDotsToolTip.style("height")) /2  ) ) + "px");
             }
             else if(d3.mouse(this)[0] == scr.w/2){
             
                 curveDotsToolTip.style("left", (d3.event.pageX) - (parseFloat(curveDotsToolTip.style("width"), 10) + 20) + "px");
                 curveDotsToolTip.style("top", (d3.event.pageY - ( parseFloat(curveDotsToolTip.style("height")) /2  ) ) + "px");
             }
		});
        
        // Adding the text label for the Y axis
        var yAxisVariable = svgPanelForBellCurveChartWithMinAndMax.append("text") .attr("transform", "rotate(-90)") .attr("y", 5) .attr("x",0 - (height / 2.0)) .attr("dy", "1em") .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif")
        .style("font-size","12px") .text(options.yAxisLable) .style('fill','#00001c') .style("text-transform","capitalize") .style("font-weight","Bold")
        .style("font-style","normal")
        
        // Adding the text label for the X axis
        var xAxisVariable =  svgPanelForBellCurveChartWithMinAndMax.append("text") .attr("transform", "translate(" + ((width/2)+20) + " ," + (height + 50) + ")")
        .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif") .style("font-weight","Bold") .style("font-size","12px") .text(options.xAxisLable) .style('fill','#00001c')
        .style("text-transform","capitalize") .style("font-style","normal")
        
        var sampleIDForStackedBarChart=targetElement[0];
        
        window.addEventListener('resize', function(event){ resizedFuctionForBellCurve(); });
        
        $(function() {
          
          $("#" + sampleIDForStackedBarChart[0].id).resizable({
                  resize: function(event, ui) {
                  resizedFuctionForBellCurve();
                  }
              });
          });
        
        function resizedFuctionForBellCurve()
        {
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            acinfotech.bellCurveChartWithMinAndMaxRange(targetElement,options)
        }

    }, // Bell Curve chart with Min and Max Range

    // ************************************************** Grouped Bar with Line Chart  **************************************************
groupedBarsWithLineChart: function(targetElement, options){
    
    isChartCalled++;
    
    var chartName = "GROUPEDBARSWITHLINECHART";
    
    acinfotech.allCharts(targetElement,options,chartName)
    
    targetElement.style("min-width", "350px").style("min-height", "350px").style("background-color", options.BGcolor)
    
    var showOrHideTableForGrpBarsAndLineChart;
    var showOrHideCommentsForGrpBarsAndLineChart;
    var showOrHideCommentsBtnForGrpBarsAndLineChart = true;
    
    if((options.showTable == false) || (options.showTable == true)){
        showOrHideTableForGrpBarsAndLineChart = options.showTable
    }
    else{
        showOrHideTableForGrpBarsAndLineChart = false;
    }
    
    // Show or Hide comments
    if (options.showComments == true || false) {
        showOrHideCommentsForGrpBarsAndLineChart = options.showComments;
    }
    else {
        showOrHideCommentsForGrpBarsAndLineChart = false;
    }
    
    if (options.comments.length == 0){
        showOrHideCommentsForGrpBarsAndLineChart = false;
        showOrHideCommentsBtnForGrpBarsAndLineChart = false;
    }
    
    if ((showOrHideTableForGrpBarsAndLineChart == true) && (showOrHideCommentsForGrpBarsAndLineChart == true)){
        showOrHideTableForGrpBarsAndLineChart = true;
        showOrHideCommentsForGrpBarsAndLineChart = false;
    }
    else if ((showOrHideTableForGrpBarsAndLineChart == false) && (showOrHideCommentsForGrpBarsAndLineChart == false)){
        showOrHideTableForGrpBarsAndLineChart = false;
        showOrHideCommentsForGrpBarsAndLineChart = false;
    }
    
    var chartTitlePanelForGrpBarsAndLineChart =  targetElement.append("div") .style("background-color", options.BGcolor) .style("position","absolute").style("text-indent","6px")
    
	var optsBtnPanelForGrpBarsAndLineChart = targetElement.append('div').style('width',"25px").style('height',"130px").style('position','absolute')
    .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px")
    .style('right', '0')
    .style("min-width","25px")
    .style("border-style","none").style("border-left", "solid #fcfcfc  1px")
	
    var stkCirAreaBtnForGrpBarChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
    .style('background-color',"#ffffff").style("z-index",10)
    .style('top','1px') .style("cursor","pointer").style("display","none")
    .style("border-style", "none").style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px") .style("box-sizing","border-box")
    var stkCirAreaBtnImgVar = document.createElement("IMG");
    stkCirAreaBtnImgVar.src = "images/circularAreaIcon.png";
    stkCirAreaBtnImgVar.setAttribute("style","position:absolute; left:4px; top:2px; width:16px; height:16px; opacity:0.76;")
    stkCirAreaBtnForGrpBarChart[0][0].appendChild(stkCirAreaBtnImgVar)
    
    //If data set length is one
    if(options.data.length <= 1){
        stkCirAreaBtnForGrpBarChart.style("display","none")
    }
    
    var horiGrpBarBtnForGrpBarChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
    .style('background-color',"#ffffff").style("z-index",10)
    .style('top','1px') .style("cursor","pointer").style("display","none")
    .style("border-style", "none").style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px") .style("box-sizing","border-box")
    var horiGrpBarBtnImgVar = document.createElement("IMG");
    horiGrpBarBtnImgVar.src = "images/horiGrpBarIcon.png";
    horiGrpBarBtnImgVar.setAttribute("style","position:absolute; left:4px; top:2px; width:18px; height:16px; opacity:0.9;")
    horiGrpBarBtnForGrpBarChart[0][0].appendChild(horiGrpBarBtnImgVar)
    
    var filterBtnForGrpBarsAndLineChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
    .style('background-color',"#ffffff").style("z-index",10)
    .style('top','1px') .style("cursor","pointer").style("display","none")
    .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
    var filterBtnImgVar = document.createElement("IMG");
    filterBtnImgVar.src = "images/filterIcon.png";
    filterBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.8;")
    filterBtnForGrpBarsAndLineChart[0][0].appendChild(filterBtnImgVar)
    
    var refreshBtnForGrpBarsAndLineChart = optsBtnPanelForGrpBarsAndLineChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
    .style('background-color',"#ffffff").style("z-index",10)
    .style('top','80px') .style("cursor","pointer").style("display","block")
    .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
    var refreshBtnImgVar = document.createElement("IMG");
    refreshBtnImgVar.src = "images/refreshIcon.png";
    refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
    refreshBtnForGrpBarsAndLineChart[0][0].appendChild(refreshBtnImgVar)
    
    var commentsBtnForGrpBarsAndLineChart = optsBtnPanelForGrpBarsAndLineChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
    .style('background-color',"#ffffff").style("z-index",10)
    .style('top','105px') .style("cursor","pointer").style("display","block")
    .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
    var commentsBtnImgVariable = document.createElement("IMG");
    if(options.showComments == false){
        commentsBtnImgVariable.src = "images/showCommentsIcon.png";
    }
    else if(options.showComments == true){
        commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
    }
    commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
    commentsBtnForGrpBarsAndLineChart[0][0].appendChild(commentsBtnImgVariable)
    
    var menuBtnForGrpBarsAndLineChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
    .style('background-color',"#ffffff").style("z-index",10)
    .style('top','1px') .style("cursor","pointer").style("display","block")
    .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
    var menuBtnImgVar = document.createElement("IMG");
    menuBtnImgVar.src = "images/menuIcon.png";
    menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
    menuBtnForGrpBarsAndLineChart[0][0].appendChild(menuBtnImgVar)
    
    if(showOrHideCommentsBtnForGrpBarsAndLineChart == true){
        stkCirAreaBtnForGrpBarChart.style('right', '0')
        horiGrpBarBtnForGrpBarChart.style('right', '0')
        filterBtnForGrpBarsAndLineChart.style('right', '0')
        refreshBtnForGrpBarsAndLineChart.style('margin-left', "2px")
        commentsBtnForGrpBarsAndLineChart.style('margin-left', "2px")
        menuBtnForGrpBarsAndLineChart.style('right', '0')
    }
    else if(showOrHideCommentsBtnForGrpBarsAndLineChart == false){
        stkCirAreaBtnForGrpBarChart.style('right', '0')
        horiGrpBarBtnForGrpBarChart.style('right', '0')
        filterBtnForGrpBarsAndLineChart.style('right', '0')
        refreshBtnForGrpBarsAndLineChart.style('margin-left', "2px")
        //commentsBtnForGrpBarsAndLineChart.style('right', '0')
        commentsBtnForGrpBarsAndLineChart.style('display','none')
        menuBtnForGrpBarsAndLineChart.style('right', '0')
    }
    
    var ismenuBtnOfGrpBarsAndLineChartClicked = false;
    menuBtnForGrpBarsAndLineChart.on('click', function() {
                                 
             filterPanelForGrpBarsAndLineChart.style("display","none");
             stgPanDivForGrpBarsAndLineChart.style("display","none");
             
             stgPanDivForGrpBarsAndLineChart.style("display","none");
             
             if ((showOrHideTableForGrpBarsAndLineChart == false) && (showOrHideCommentsForGrpBarsAndLineChart == true)){
             divLegendPanelForGrpBarsAndLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
             .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
             
             svgPanelForGrpBarsAndLineChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
             .style("position","absolute").style("background-color", options.BGcolor);
             }
             else if ((showOrHideTableForGrpBarsAndLineChart == true) && (showOrHideCommentsForGrpBarsAndLineChart == false)){
             divLegendPanelForGrpBarsAndLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
             .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
             
             svgPanelForGrpBarsAndLineChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
             .style("position","absolute").style("background-color", options.BGcolor);
             }
             else if ((showOrHideTableForGrpBarsAndLineChart == false) && (showOrHideCommentsForGrpBarsAndLineChart == false)){
             divLegendPanelForGrpBarsAndLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
             .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
             
             svgPanelForGrpBarsAndLineChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
             .style("position","absolute").style("background-color", options.BGcolor);
             }
             
             if(ismenuBtnOfGrpBarsAndLineChartClicked == false){
             ismenuBtnOfGrpBarsAndLineChartClicked = true;
             optsBtnPanelForGrpBarsAndLineChart.style("display","block")
             
             }
             else if(ismenuBtnOfGrpBarsAndLineChartClicked == true){
             ismenuBtnOfGrpBarsAndLineChartClicked = false
             optsBtnPanelForGrpBarsAndLineChart.style("display","none")
             }
             
             resizedFuctionForGrpBarsAndLineChart();
     })
    
    var tableButtonForGrpBarsAndLineChart = optsBtnPanelForGrpBarsAndLineChart.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
    .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top','1px')
    .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
    var tableBtnImgVar = document.createElement("IMG");
    if(showOrHideTableForGrpBarsAndLineChart == false){
        tableBtnImgVar.src = "images/showTableIcon.png";
        tableButtonForGrpBarsAndLineChart.attr("class","showTableClassForChartTable")
    }
    else if(showOrHideTableForGrpBarsAndLineChart == true){
        tableBtnImgVar.src = "images/cancelTableIcon.png";
        tableButtonForGrpBarsAndLineChart.attr("class","hideTableClassForChartTable")
    }
    tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
    tableButtonForGrpBarsAndLineChart[0][0].appendChild(tableBtnImgVar)
    
    var settingBtnForGrpBarsAndLineChart = optsBtnPanelForGrpBarsAndLineChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
    .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 28 + 'px')
    .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
    var settingBtnImgVar = document.createElement("IMG");
    settingBtnImgVar.src = "images/settingsIcon.png";
    settingBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.82;")
    settingBtnForGrpBarsAndLineChart[0][0].appendChild(settingBtnImgVar)
    
    var downloadBtnForGrpBarsAndLineChart = optsBtnPanelForGrpBarsAndLineChart.append("div").attr("id","downloadBtnForGrpBarsAndLineChart-ID-" + targetElement[0][0].id).style("width","20px")
    .style("height","20px").style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff").style('margin-left','2px')
    .style('top', 54 + 'px').style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
    
    acinfotech.downloadFunctionality("downloadBtnForGrpBarsAndLineChart-ID-" + targetElement[0][0].id,targetElement)
    
    var svgPanelForGrpBarsAndLineChart = targetElement .append('svg') 
    .attr("id","svgPanelIDForGrpBarsAndLineChart" + targetElement[0][0].id) .style("background-color", options.BGcolor) .style("position","absolute")
    .style("border","0px solid #d0d0d0")
    
    var commentsPanelDivForGrpBarsAndLineChart = targetElement.append("div") .attr("class","commentsPanelClassForGBLChart")
    .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
	.style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
    .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)
    
    commentsPanelDivForGrpBarsAndLineChart.on('click',function(d){
          $('.commentsClassForGrpBarsAndLineChart' + targetElement[0][0].id).focus()
      })
    
    if(options.showTitle == true){
        
        chartTitlePanelForGrpBarsAndLineChart.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 8 + "%"; })
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')
        
        if ((showOrHideTableForGrpBarsAndLineChart == false) && (showOrHideCommentsForGrpBarsAndLineChart == true)){
            
            var commentsForGrpBarsAndLineChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
            .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
            .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
            .css('line-height','1.1em').css('text-align','justify') .attr('class','commentsClassForGrpBarsAndLineChart' + targetElement[0][0].id)
            
            svgPanelForGrpBarsAndLineChart.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .append('g')
            commentsPanelDivForGrpBarsAndLineChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
            .style("top",78 + "%")
            .html(commentsForGrpBarsAndLineChart[0].outerHTML.toString())
            
        }
        else if ((showOrHideTableForGrpBarsAndLineChart == true) && (showOrHideCommentsForGrpBarsAndLineChart == false)){
            
            svgPanelForGrpBarsAndLineChart.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .append('g')
            commentsPanelDivForGrpBarsAndLineChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
        }
        else if ((showOrHideTableForGrpBarsAndLineChart == false) && (showOrHideCommentsForGrpBarsAndLineChart == false)){
            
            svgPanelForGrpBarsAndLineChart.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .append('g')
            commentsPanelDivForGrpBarsAndLineChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
        }
        
        var margin = {top: 30 , right: 20, bottom: 80, left: 20}, //originally top: 42, left: 80
        width = (svgPanelForGrpBarsAndLineChart.node().getBoundingClientRect().width) - margin.left - margin.right,
        height = (svgPanelForGrpBarsAndLineChart.node().getBoundingClientRect().height) - margin.top - margin.bottom;
        
    }
    else if(options.showTitle == false){
        chartTitlePanelForGrpBarsAndLineChart.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });
        
        if ((showOrHideTableForGrpBarsAndLineChart == false) && (showOrHideCommentsForGrpBarsAndLineChart == true)){
            
            var commentsForGrpBarsAndLineChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
            .attr('contenteditable',false).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
            .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
            .css('line-height','1.1em').css('text-align','justify')
            
            svgPanelForGrpBarsAndLineChart.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .append('g')
            commentsPanelDivForGrpBarsAndLineChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
            .style("top",78 + "%")
            .html(commentsForGrpBarsAndLineChart[0].outerHTML.toString())
            
        }
        else if ((showOrHideTableForGrpBarsAndLineChart == true) && (showOrHideCommentsForGrpBarsAndLineChart == false)){
            
            svgPanelForGrpBarsAndLineChart.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .append('g')
            commentsPanelDivForGrpBarsAndLineChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
        }
        else if ((showOrHideTableForGrpBarsAndLineChart == false) && (showOrHideCommentsForGrpBarsAndLineChart == false)){
            
            svgPanelForGrpBarsAndLineChart.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .append('g')
            commentsPanelDivForGrpBarsAndLineChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
        }
        
        var margin = {top: 30, right: 20, bottom: 80, left: 20}, //originally top: 42, left: 80
        width = (svgPanelForGrpBarsAndLineChart.node().getBoundingClientRect().width) - margin.left - margin.right,
        height = svgPanelForGrpBarsAndLineChart.node().getBoundingClientRect().height - margin.top - margin.bottom;
    }
    
    var colours;
    
    // checking color set for bars and legend dots
    if(options.colorSet === undefined){
        options.colorSet = "one"
        colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
    }
    else if(options.colorSet.toString().toLowerCase() === "one"){
        options.colorSet = "one"
        colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
    }
    else if(options.colorSet.toString().toLowerCase() === "two"){
        options.colorSet = "two"
        colours = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
    }
    else if(options.colorSet.toString().toLowerCase() === "three"){
        options.colorSet = "three"
        colours = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
    }
    else
    {
        options.colorSet = "one"
        colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
    }
    
    //------------------ Settings panel DIV and everything within it section begins here ------------------
    
    var stgPanDivForGrpBarsAndLineChart = targetElement.append('div').style('width',"100%").style('height',"40%").attr("class","stgPanDivForGrpBarsAndLineChart" + targetElement[0][0].id)
    .style('position','absolute').style('margin-left', "0px").style('border-top',"1px solid #f0f0f0").style('border-bottom',"1px solid #e5e5e5")
    .style("background-color",'#fcfcfc').style("z-index",90) .style("display","none") .style('top', 60.0 + "%") .style('height',40 + "%")
    
    $( '.stgPanDivForGrpBarsAndLineChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
         var e0 = e.originalEvent,
         delta = e0.wheelDelta || -e0.detail;
         
         this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
         e.preventDefault();
     });
    
    var settingPanelTitle = stgPanDivForGrpBarsAndLineChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
    .style('margin-left','0px').style('margin-top','10px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
    .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
    .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; color:#00001c;">'+ "Settings" +'</div>')
    
    var stgPanDivForGrpChangeColorTitle = stgPanDivForGrpBarsAndLineChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
    .style('margin-left','0px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
    .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
    .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Select color set " +'</div>')
    
    var stgPanCanBtnForGrpBarsAndLineChart = stgPanDivForGrpBarsAndLineChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
    .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
    .style('background-color',"#FCFCFF")
    .style("border", "0.0px") .style("border-style", "solid").style('color','white')
    .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
    var cancelBtnImgVar = document.createElement("IMG");
    cancelBtnImgVar.src = "images/closeIcon.png";
    cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.9; background-color:#fcfcff")
    stgPanCanBtnForGrpBarsAndLineChart[0][0].appendChild(cancelBtnImgVar)
    
    stgPanCanBtnForGrpBarsAndLineChart.on('click', function() {
          stgPanDivForGrpBarsAndLineChart.style("display","none") // Hiding setting panel
          
          if ((showOrHideTableForGrpBarsAndLineChart == false) && (showOrHideCommentsForGrpBarsAndLineChart == true)){
          divLegendPanelForGrpBarsAndLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
          .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
          
          svgPanelForGrpBarsAndLineChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
          .style("position","absolute");
          }
          else if ((showOrHideTableForGrpBarsAndLineChart == true) && (showOrHideCommentsForGrpBarsAndLineChart == false)){
          divLegendPanelForGrpBarsAndLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
          .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
          
          svgPanelForGrpBarsAndLineChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
          .style("position","absolute");
          }
          else if ((showOrHideTableForGrpBarsAndLineChart == false) && (showOrHideCommentsForGrpBarsAndLineChart == false)){
          divLegendPanelForGrpBarsAndLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
          .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
          
          svgPanelForGrpBarsAndLineChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
          .style("position","absolute");
          }
          
          resizedFuctionForGrpBarsAndLineChart();
      })
    
    var formForChangeSettingsPanel = stgPanDivForGrpBarsAndLineChart.append("form");
    formForChangeSettingsPanel.style("background-color","#fcfcfc").style("margin-top","67px").style("font-family","Verdana,sans-serif").style("font-size","12px")
    .style("position","absolute").attr("id","formForChangeColorSettingsPanel" + targetElement[0][0].id).style("font-weight","Bold").style("width","180px")
    .style("height","58px").style("padding","0px").style("border-radius","0px") .style("margin-left","10px")
    
    var svgPanelForCrSetOne = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
    .style("width","160px").style("height","18px").style("margin-top","1px").style("margin-left","0px") .style("box-sizing","border-box")
    
    var colorSetOne = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
    var colorSetOneRange = d3.range(12);
    
    var colorSetOneDots = svgPanelForCrSetOne.append("g")
    colorSetOneDots.selectAll('rect') .data(colorSetOneRange) .enter() .append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
    .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("fill", function(d,i){return colorSetOne(i)})
    .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetOne(i); })
    .style("cursor","auto") .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
    
    var svgPanelForCrSetTwo = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
    .style("width","160px") .style("height","18px") .style("margin-top","20px") .style("margin-left","0px") .style("box-sizing","border-box")
    
    var colorSetTwo = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
    var colorSetTwoRange = d3.range(12);
    
    var colorSetTwoDots = svgPanelForCrSetTwo.append("g")
    colorSetTwoDots.selectAll('rect') .data(colorSetTwoRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
    .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto")
    .style("fill", function(d,i){return colorSetTwo(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
    .style("stroke",function(d,i){  return colorSetTwo(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
    
    var svgPanelForCrSetThree = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
    .style("width","160px") .style("height","18px") .style("margin-top","39px") .style("margin-left","0px") .style("box-sizing","border-box")
    
    var colorSetThree = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
    var colorSetThreeRange = d3.range(12);
    
    var colorSetThreeDots = svgPanelForCrSetThree.append("g")
    colorSetThreeDots.selectAll('rect') .data(colorSetThreeRange) .enter().append('rect')
    .attr('transform', 'translate(' + (2) + ',' + (1) + ')') .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10)
    .attr("height",10) .style("cursor","auto") .style("fill", function(d,i){return colorSetThree(i)}) .style("fill-opacity",0.93)
    .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetThree(i);  })
    .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")
    
    if(options.colorSet.toString().toLowerCase() === "one"){
        svgPanelForCrSetOne.style('border',"1px solid #808080")
        svgPanelForCrSetTwo.style('border',"0px solid #808080")
        svgPanelForCrSetThree.style('border',"0px solid #808080")
    }
    else if(options.colorSet.toString().toLowerCase() === "two"){
        svgPanelForCrSetOne.style('border',"0px solid #808080")
        svgPanelForCrSetTwo.style('border',"1px solid #808080")
        svgPanelForCrSetThree.style('border',"0px solid #808080")
    }
    else if(options.colorSet.toString().toLowerCase() === "three"){
        svgPanelForCrSetOne.style('border',"0px solid #808080")
        svgPanelForCrSetTwo.style('border',"0px solid #808080")
        svgPanelForCrSetThree.style('border',"1px solid #808080")
    }
    else
    {
        svgPanelForCrSetOne.style('border',"1px solid #808080")
        svgPanelForCrSetTwo.style('border',"0px solid #808080")
        svgPanelForCrSetThree.style('border',"0px solid #808080")
    }
    
    svgPanelForCrSetOne.on('click',function(d){
       options.colorSet = "one"
       svgPanelForCrSetOne.style('border',"1px solid #808080")
       svgPanelForCrSetTwo.style('border',"0px solid #808080")
       svgPanelForCrSetThree.style('border',"0px solid #808080")
       
       colours = "";
       colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
       
       colorCountVarForCircle = 0;
       colorCountVarForLine = 0;
                           
       groups.style("fill", function(d, i) { colorCountVarForCircle++; colorCountVarForLine++; return colours(i); })
                           
       lines.style("stroke", function (d,i) { return colours(colorCountVarForLine++); })
       
        circle1.style("fill", function (d,i) {
        if(i == 0){ colorCountVarForCircle++; }
             return colours(colorCountVarForCircle - 1);
         })
       
       legendGroup.style("fill", function(d, i){ return colours(i);})
                           
    })
    svgPanelForCrSetTwo.on('click',function(d){
       options.colorSet = "two"
       svgPanelForCrSetOne.style('border',"0px solid #808080")
       svgPanelForCrSetTwo.style('border',"1px solid #808080")
       svgPanelForCrSetThree.style('border',"0px solid #808080")
       
       colours = "";
       colours = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
       
       colorCountVarForCircle = 0;
       colorCountVarForLine = 0;
       
       groups.style("fill", function(d, i) { colorCountVarForCircle++; colorCountVarForLine++; return colours(i); })
       
       lines.style("stroke", function (d,i) { return colours(colorCountVarForLine++); })
       
       circle1.style("fill", function (d,i) {
         if(i == 0){ colorCountVarForCircle++; }
             return colours(colorCountVarForCircle - 1);
         })
         
        legendGroup.style("fill", function(d, i){ return colours(i);})
    })
    svgPanelForCrSetThree.on('click',function(d){
         options.colorSet = "three"
         svgPanelForCrSetOne.style('border',"0px solid #808080")
         svgPanelForCrSetTwo.style('border',"0px solid #808080")
         svgPanelForCrSetThree.style('border',"1px solid #808080")
         
         colours = "";
         colours = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
         
         colorCountVarForCircle = 0;
         colorCountVarForLine = 0;
         
         groups.style("fill", function(d, i) { colorCountVarForCircle++; colorCountVarForLine++; return colours(i); })
         
         lines.style("stroke", function (d,i) { return colours(colorCountVarForLine++); })
         
         circle1.style("fill", function (d,i) {
           if(i == 0){ colorCountVarForCircle++; }
               return colours(colorCountVarForCircle - 1);
           })
                             
         legendGroup.style("fill", function(d, i){ return colours(i);})
     })
    // setting panel ends here
    
    stkCirAreaBtnForGrpBarChart.on('click', function() {
                                   
           //isFilterClicked = false
           d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
           
           var newOptions = {
           data: options.data,
           dataForDrillDown: options.dataForDrillDown,
           dataForTable: options.dataForTable,
           isDataDetailedForTable: options.isDataDetailedForTable,
           keys: {
           label: options.keys.label,
           stackedAreas: options.keys.groupBars,
           },
           chartTitle: options.chartTitle,
           //xAxisLable: options.xAxisLable,
           //yAxisLable: "",
           showTitle: options.showTitle,
           BGcolor:options.BGcolor,
           series:options.series,
            legend:options.legend,
           colorSet: options.colorSet,
           drillDownColumnName:options.drillDownColumnName,
           showTable: false,
           showComments: false,
           comments: options.comments,
           resizeButtonID: options.resizeButtonID
           
           }
           
           acinfotech.stackedCircularAreaChart(targetElement, newOptions)
       })
    
    // Horizontal Grouped Bar Chart and Table
    horiGrpBarBtnForGrpBarChart.on('click', function() {
                                   
           //isFilterClicked = false
           d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
           
           for(var i = 0; i<divAndChartsArray.length; i++){
           
           if(targetElement[0][0].id === divAndChartsArray[i].divID){
           options.data = divAndChartsArray[i].optionsData;
           //options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.groupBars;
           if(newtargetElementAndOptionsArray[i].options.keys.groupBars == undefined){
           options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.stackedAreas;
           }
           else {
           options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.groupBars;
           }
           options.yAxisLable = options.xAxisLable;
           options.xAxisLable = "";
           options.showTable = false;
           options.showComments = false;
           }
           }
           
           acinfotech.horizontalGrpBarsAndLineChart(targetElement,options)
                                   
       })
    
    // Filter
    filterBtnForGrpBarsAndLineChart.on('click', function() {
                                   
           filterPanelForGrpBarsAndLineChart.style("display","block");
           
           ismenuBtnOfGrpBarsAndLineChartClicked = false;
           optsBtnPanelForGrpBarsAndLineChart.style("display","none");
           
           stgPanDivForGrpBarsAndLineChart.style("display","none");
           
           if ((showOrHideTableForGrpBarsAndLineChart == false) && (showOrHideCommentsForGrpBarsAndLineChart == true)){
           divLegendPanelForGrpBarsAndLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
           .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
           
           svgPanelForGrpBarsAndLineChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
           .style("position","absolute");
           }
           else if ((showOrHideTableForGrpBarsAndLineChart == true) && (showOrHideCommentsForGrpBarsAndLineChart == false)){
           divLegendPanelForGrpBarsAndLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
           .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
           
           svgPanelForGrpBarsAndLineChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
           .style("position","absolute");
           }
           else if ((showOrHideTableForGrpBarsAndLineChart == false) && (showOrHideCommentsForGrpBarsAndLineChart == false)){
           divLegendPanelForGrpBarsAndLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
           .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
           
           svgPanelForGrpBarsAndLineChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
           .style("position","absolute");
           }
           
           resizedFuctionForGrpBarsAndLineChart();
                                   
       })
    
    // Refreshing Chart and Table
    refreshBtnForGrpBarsAndLineChart.on('click', function() {
                                    
            //isFilterClicked = false
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){
            
            if(targetElement[0][0].id === divAndChartsArray[i].divID){
            options.data = divAndChartsArray[i].optionsData;
            //options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.groupBars;
            
            if(newtargetElementAndOptionsArray[i].options.keys.groupBars == undefined){
            options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.stackedAreas;
            }
            else {
            options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.groupBars;
            }
            }
            }
            acinfotech.groupedBarsWithLineChart(targetElement,options)
                                    
    })
    
    commentsBtnForGrpBarsAndLineChart.on('click', function() {
                                     
         if(options.showComments == false){
         options.showComments = true;
         }
         else if(options.showComments == true){
         options.showComments = false;
         }
         
         d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
         
         for(var i = 0; i<divAndChartsArray.length; i++){
         
         if(targetElement[0][0].id === divAndChartsArray[i].divID){
         options.data = divAndChartsArray[i].optionsData
         
         if(newtargetElementAndOptionsArray[i].options.keys.groupBars == undefined){
         options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.stackedAreas;
         }
         else {
         options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.groupBars;
         }
         options.showTable = false;
         }
         }
         acinfotech.groupedBarsWithLineChart(targetElement,options)
         
     })
    
    // showing/hidding chart table
    tableButtonForGrpBarsAndLineChart.on('click', function() {
         
         if(showOrHideTableForGrpBarsAndLineChart == false){
         options.showTable = true;
         //showOrHideTableForPieChart = true
         }
         else if(showOrHideTableForGrpBarsAndLineChart == true){
         //showOrHideTableForPieChart = false
         options.showTable = false;
         }
         
         d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
         
         for(var i = 0; i<divAndChartsArray.length; i++){
         
         if(targetElement[0][0].id === divAndChartsArray[i].divID){
         options.data = divAndChartsArray[i].optionsData
         
         if(newtargetElementAndOptionsArray[i].options.keys.groupBars == undefined){
         options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.stackedAreas;
         }
         else {
         options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.groupBars;
         }
         
         options.showComments = false;
         }
         }
         acinfotech.groupedBarsWithLineChart(targetElement,options)
         
     })
    
    
    settingBtnForGrpBarsAndLineChart.on('click', function() {
                                    
        ismenuBtnOfGrpBarsAndLineChartClicked = false; // Menu toggle button variable
        optsBtnPanelForGrpBarsAndLineChart.style("display","none") // To hide options button panel
        
        iconButtonTooltipForGrpBarsAndLineChart.style("display","none") // Removing options button ToolTip
        settingBtnForGrpBarsAndLineChart.style("cursor","pointer")
        
        stgPanDivForGrpBarsAndLineChart.style("display","block") // Showing settings panel
        
        svgPanelForGrpBarsAndLineChart.style('width', 75 + "%") .style('height', 52 + "%").style("position","absolute"); // Decreasing chart panel
        divLegendPanelForGrpBarsAndLineChart.style('width', 25 + "%") .style('height', 52 + "%").style("position","absolute"); // Decreasing chart panel
        
        resizedFuctionForGrpBarsAndLineChart(); // Calling resize function()
                                    
    })
    
    downloadBtnForGrpBarsAndLineChart.on('click', function() {
                              
          ismenuBtnOfGrpBarsAndLineChartClicked = false; // Changing menu button value to false
          optsBtnPanelForGrpBarsAndLineChart.style("display","none") // Hiding option buttons panel
                              
    })
    
    // Creating ToolTip for options button.
    var iconButtonTooltipForGrpBarsAndLineChart = targetElement.append('div').style('width','240px').attr("id","too")
    .style('height',"25px").style('position','absolute')//.style('margin-left', "0px").style('top','25px')
    .style("background-color",'#404040 ').style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid") // 004b9d
    .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none").attr("border", 0.0)
    
    refreshBtnForGrpBarsAndLineChart.on('mousemove', function(d,i) {
        var root = targetElement
        var m = d3.mouse(root.node());
        m[0] += 0
        m[1] += 0
        var refreshButtonTooltipText = "Refresh";
        
        iconButtonTooltipForGrpBarsAndLineChart.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
        iconButtonTooltipForGrpBarsAndLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ refreshButtonTooltipText +'</div>')
        
    })
    refreshBtnForGrpBarsAndLineChart.on('mouseout', function(d,i) {
        iconButtonTooltipForGrpBarsAndLineChart.style("display","none")
    })
    
    commentsBtnForGrpBarsAndLineChart.on('mousemove', function(d,i) {
         commentsPanelDivForGrpBarsAndLineChart.style('background-color','#fafafa')
         var root = targetElement
         var m = d3.mouse(root.node());
         m[0] += 0
         m[1] += 0
         if(options.showComments == false){
         var commentButtonTooltipText = "Show Comments";
         }
         else if(options.showComments == true){
         var commentButtonTooltipText = "Hide Comments";
         }
         
         
         iconButtonTooltipForGrpBarsAndLineChart.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
         iconButtonTooltipForGrpBarsAndLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ commentButtonTooltipText +'</div>')
     })
    commentsBtnForGrpBarsAndLineChart.on('mouseout', function(d,i) {
         commentsPanelDivForGrpBarsAndLineChart.style('background-color','#ffffff')
         iconButtonTooltipForGrpBarsAndLineChart.style("display","none")
     })
    
    menuBtnForGrpBarsAndLineChart.on('mousemove', function(d,i) {
         var root = targetElement
         var m = d3.mouse(root.node());
         m[0] += 0
         m[1] += 0
         var menuButtonTooltipText = "Menu";
         
         iconButtonTooltipForGrpBarsAndLineChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
         iconButtonTooltipForGrpBarsAndLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ menuButtonTooltipText +'</div>')
                         
     })
    menuBtnForGrpBarsAndLineChart.on('mouseout', function(d,i) {
         iconButtonTooltipForGrpBarsAndLineChart.style("display","none")
    })
    
    tableButtonForGrpBarsAndLineChart.on('mousemove', function(d,i) {
         var root = targetElement
         var m = d3.mouse(root.node());
         m[0] += 0
         m[1] += 0
         if(showOrHideTableForGrpBarsAndLineChart ==  false){
         var tableButtonTooltipText = "Show Table";
         }
         else if(showOrHideTableForGrpBarsAndLineChart == true){
         var tableButtonTooltipText = "Hide Table";
         }
         
         
         iconButtonTooltipForGrpBarsAndLineChart.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
         iconButtonTooltipForGrpBarsAndLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ tableButtonTooltipText +'</div>')
                                     
     })
    tableButtonForGrpBarsAndLineChart.on('mouseout', function(d,i) {
         iconButtonTooltipForGrpBarsAndLineChart.style("display","none")
     })
    
    settingBtnForGrpBarsAndLineChart.on('mousemove', function(d,i) {
        var root = targetElement
        var m = d3.mouse(root.node());
        m[0] += 0
        m[1] += 0
        var settingTooltipText = "Settings";
        
        iconButtonTooltipForGrpBarsAndLineChart.style("width","67px").style("margin-left", (m[0] - 77) + "px").style("margin-top",(m[1]) + "px").style("display","block")
        iconButtonTooltipForGrpBarsAndLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ settingTooltipText +'</div>')
    })
    settingBtnForGrpBarsAndLineChart.on('mouseout', function(d,i) {
        iconButtonTooltipForGrpBarsAndLineChart.style("display","none")
    })
    
    downloadBtnForGrpBarsAndLineChart.on('mousemove', function(d,i) {
          var root = targetElement
          var m = d3.mouse(root.node());
          m[0] += 0
          m[1] += 0
          var downloadButtonTooltipText = "Download";
          
          iconButtonTooltipForGrpBarsAndLineChart.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
          iconButtonTooltipForGrpBarsAndLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
    })
    downloadBtnForGrpBarsAndLineChart.on('mouseout', function(d,i) {
          iconButtonTooltipForGrpBarsAndLineChart.style("display","none")
    })
    
    // ----------------- Filter panel and everything within it section begins here ----------------
    var filterPanelForGrpBarsAndLineChart = targetElement.append('div').style('width',350 + "px") .attr("class","filterPanelForGrpBarChartClass" + targetElement[0][0].id)
    .style('position','absolute').style('margin-left', "0px")
    .style("background-color",'#fefefe').style("z-index",11).style("border-color", "#ffffff").style("border-right", "solid #e5e5e5 1px")  .style("border-style", "solid") // 004b9d
    .style("box-shadow", "2px 0px 1px #eff8ec").style("display","none").style("border-top", "solid #fdfdfd 1px").style("border-left","0px").style("border-bottom", "0px")
    .style('top', 0.0 + "%").style('height', 100 + "%").style('overflow-y',"hidden").style("overflow-x","hidden")
    .style("border-bottom", "solid #e5e5e5 1px") .style("box-sizing","border-box")
    
    var filterPanelForGrpBarChartTitle = filterPanelForGrpBarsAndLineChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif").style("font-weight", "Bold")
    .style('margin-left','0px').style('margin-top','20px').style('text-indent','5px').style("font-size", "14px").style('position',"absolute")
    .style("box-shadow", "1px 1px 1px #007aff").style("width","350px").style("color","#000000")
    .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; top:25.0%; font-size:16px; font-family:inter;  color:#585858; font-weight:Bold;">'+ "Filter" +'</div>')
    
    var measuresColumnTitle = filterPanelForGrpBarsAndLineChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
    .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '60px')
    .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:14px; font-family:inter;  color:#606060; font-weight:Normal; text-align:left; text-indent:3px;">Available Measures</div>');
    
    var measuresVariables = filterPanelForGrpBarsAndLineChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable1"+targetElement[0][0].id)
    .style("list-style-type","none")
    .style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '78px')
    .style('position','absolute')
    .style("width","155px").style("min-height","190px").style("max-height","190px").style("border", "#f0f0f0 1px solid")
    .style("max-width","155px").style("overflow-x","hidden").style("overflow-y","auto")
    measuresVariables.style("left",0.0 + "px").style("padding","2px")
    
    
    $( ".filterPanelForGrpBarChartClass" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
            
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
    });
    
    
    //------------------- creating tooltip -------------------
    
    var tooltipForGrpBarsAndLineChart = targetElement .append('div') .attr('class', '') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
    .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
    .style("padding-right", "7px") .style("background", "#F8F8F8") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style('z-index',1000)
    .style("border", "1.0px") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","80px")
    tooltipForGrpBarsAndLineChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'label').style("color","#000000") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "12px") .style("font-weight", "Bold");
    tooltipForGrpBarsAndLineChart.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
    tooltipForGrpBarsAndLineChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#000000") .style("text-transform","capitalize").style("padding","1px").style("font-size", "12px").style("font-weight", "Bold");
    
    
    // if chart is changed (before or after resize button click)
    var optionsKey = {};
    if(options.keys.groupBars == undefined){
        optionsKey["label"] = options.keys.label;
        optionsKey["groupBars"] = options.keys.stackedAreas;
        
        options.keys = {};
        options.keys["label"] = optionsKey.label;
        options.keys["groupBars"] = optionsKey.groupBars;
        options.xAxisLable = optionsKey.label;
    }
    
    
    var finalArrayNew = [];
    options.keys.groupBars.forEach(function(d, i) {
                                   
           var temp1 = {};
           temp1["name"] = options.keys.groupBars[i]
           
           finalArrayNew.push(temp1)
    })
    
    var finalNewNewArray = [];
    var dataArray1 = [];
    finalArrayNew.forEach(function(d, i) {
                          
          var temp1 = {};
          temp1["name"] = options.keys.groupBars[i]
          
          for (j = 0; j < options.data.length; j++) {
          
          var tempTemp = {};
          tempTemp["label"] = options.data[j][options.keys.label];
          tempTemp["value"] = +options.data[j][options.keys.groupBars[i]];
          
          dataArray1.push(tempTemp)
          }
          
          temp1["data"] = dataArray1;
          dataArray1 = []
          finalNewNewArray.push(temp1)
      })
    
    
    var dataset = finalNewNewArray.map(function (d) {
               return d.data.map(function (o, i) {
                     // Structure it so that your numeric
                     // axis (the stacked amount) is y
                     return {
                     y: o.value,
                     x: o.label
                 };
            });
                                       }),
    xMax = d3.max(dataset, function (group) {
        return d3.max(group, function (d) {
            return d.y
            });
      })
    
    var xAxisLabels = dataset[0].map(function (d) { return d.x; });
    
    var y = d3.scale.linear() .domain([0, xMax]) .range([height, 0]);
    
    var x0 = d3.scale.ordinal() .domain(d3.range(xAxisLabels.length)) .rangeBands([0, width], .28);
    
    var x1 = d3.scale.ordinal() .domain(d3.range(finalNewNewArray.length)) .rangeBands([0, x0.rangeBand()]);
    
    var xAxis = d3.svg.axis() .scale(x0) .orient("bottom");
    
    var yAxis = d3.svg.axis() .scale(y) .ticks(5) .orient("left");
    
    var hasDecimalPoint = false;
    for(var i = 0; i < options.keys.groupBars.length; i++){
        for(var j = 0; j < options.data.length; j++){
            if(options.data[j][options.keys.groupBars[i]].toString().indexOf('.') > -1){ hasDecimalPoint = true; break; }
        }
    }
    if(hasDecimalPoint == false){ yAxis.tickFormat(d3.format(".2s")) }
    
    var svg = svgPanelForGrpBarsAndLineChart.append("svg:g") .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
    
    //svg.append("g") .attr("class", "y axis") .call(yAxis).selectAll("text") .style("fill","#00001c").style("font-family","Verdana,sans-serif");
    let key=options.xAxisLable;
        let array=options.data.map(value => value[key]);
        let ArrayValue=[];
        var RotateValue;
        for(let i=0;i<array.length;i++){
                ArrayValue[i]=array[i].length;
        }
        const numberGreaterThanLimit = ArrayValue.filter((v) => v > 5);
    svg.append('g') .attr("class", "x axis") .attr('transform', 'translate(0,' + height + ')') .call(xAxis)
    
    .selectAll("text").data(xAxisLabels) .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') 
    .attr("transform", function(d) { 
        if(numberGreaterThanLimit.length>0){return "rotate(-45)"}
        else{
        return "rotate(0)" }})
    .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
    .text(function(d,i) {
		if(d.length > 9){
			return d.substring(0,9)+'...';
		}
		else{
			return d;
		}
	})
    
    var colorCountVarForCircle = 0;
    var colorCountVarForLine = 0;
    
    var groups = svg.append("g").selectAll("g") .data(dataset)
    
	var groups1 = groups.enter().append("g")
    .style("fill", function(d, i) { colorCountVarForCircle++; colorCountVarForLine++; return colours(i); })
    .attr("transform", function(d, i) {return "translate(" + x1(i) + ",0)"; })
    .selectAll("rect")//.attr("class", 'groupedBars')
    .data(function(d) { return d; })
    .enter().append("rect")
	.attr("x", function(d, i) {   return x0(i); })
    .attr("y", height)
	.attr("width", x1.rangeBand())
	.attr("height", 0)
	.transition().delay(400).duration(800)
	.attr("y", function(d) { return  y(d.y); })
	.attr("height", function(d) { return height - y(d.y) })
	.style('cursor','auto')
	
    // adding drill down column values to bars
    var columnNames = d3.keys(options.data[0])
    var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
    
    for(var i = 0; i < columnNames.length ; i++){
        for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
            if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                for(var k = 0; k < options.keys.groupBars.length; k++){
                    var len = d3.select(groups[0][k]).selectAll('rect')
                    for(var l = 0; l < len[0].length; l++){
                        d3.select(len[0][l]).attr('data-drilldownkey', function(d,index){
                              return JSON.stringify(options.data[l]).slice(1, -1).split('"').join("").split(':').join("|")
                        })
                    }
                }
            }
            else {
            }
        }
    }
    
    var format1 = d3.format('.3s')
    var textOnGroupBarChart = groups.selectAll("text")
    .data(function(d) { return d; })
    .enter().append("text").attr("class","text")
    .text(function(d, i) {
		if(d.y.toString().indexOf('.') === -1)
		{
			if(d.y.toString().length <= 3){
				return d.y;
			}
			else{
				return format1(d.y);
			}
		}
		else{
			return format1(d.y);
		}
    })
    .attr("x", function(d,i) { return 4 - y(d.y); })
    .attr("y", function(d,i) {textWidth = d3.select("text").node().getBoundingClientRect().height;
          computedWidth =  (x1.rangeBand() / 1.5) - (textWidth / 2)
          if(computedWidth > 0){
              return (x0(i)) + (computedWidth + textWidth / 1.4);
          }
          else {
              return (x0(i)) + 10.0;
          
          }
      }).attr("transform", "rotate(-90)")
    .style("font-family", "Verdana,sans-serif")  .style("font-size", "12px").style("text-anchor", "start")
    .style("fill", "#00001c").style('display','none').transition().delay(2000).style('display','none').attr("class","series_value").style("display",options.series)
    
    
    //-------------------------- Creating lines ---------------------------
    
    var dataArrayForLine = [];
    
    options.data.forEach(function(d, i) {
         var temp = {};
         for (i = 0; i < options.keys.lines.length; i++) {
         
             for (j = 0; j < Object.keys(d).length; j++) {
         
                 if(options.keys.lines[i] === Object.keys(d)[j]){
                     temp[Object.keys(d)[j]] = d[Object.keys(d)[j]]
                 }
             }
         }
         
         dataArrayForLine.push(temp)
     });
    
    
    var finalArrayForLine = [];
    options.data.forEach(function(d, i) {
                         
         var finalArrayForLineTemp = {};
         finalArrayForLineTemp[options.keys.label] = d[options.keys.label]
         finalArrayForLineTemp["Data"] = dataArrayForLine[i];
         finalArrayForLine.push(finalArrayForLineTemp)
     })
    
    var finalArrayNewForLine = [];
    options.keys.lines.forEach(function(d, i) {
                               
       var temp1 = {};
       temp1["line"] = options.keys.lines[i]
       
       finalArrayNewForLine.push(temp1)
    })
    
    var finalNewNewArrayForLine = [];
    var dataArrayForLine1 = [];
    finalArrayNewForLine.forEach(function(d, i) {
                          
          var temp1 = {};
          temp1["line"] = options.keys.lines[i]
          
          
          for (j = 0; j < options.data.length; j++) {
          
          var tempTemp = {};
          tempTemp["label"] = options.data[j][options.keys.label];
          tempTemp["value"] = options.data[j][options.keys.lines[i]];
          
          dataArrayForLine1.push(tempTemp)
          }
          
          temp1["Data"] = dataArrayForLine1;
          dataArrayForLine1 = []
          finalNewNewArrayForLine.push(temp1)
    })
    
    var xForLine = d3.scale.ordinal().domain(options.data.map(function(d,i) { return d[options.keys.label];})).rangePoints([0, width],1.31);
    
    var x1ForLine = d3.scale.ordinal() .domain(options.data.map(function(d) { return d[options.keys.label]; })) .rangePoints([0, width], 1.31);
    
    var maxForLine = d3.max(finalArrayForLine, function(d) { return d.Data[options.keys.lines[0]] });
    
    var maxArrayForLine = [];
    for (i = 0; i < options.keys.lines.length; i++) {
        var max = d3.max(finalArrayForLine, function(d) {
         return +d.Data[options.keys.lines[i]]
         });
        
        maxArrayForLine.push(max)
    }
    
    var finallyMaxValueForLine = d3.max(maxArrayForLine, function(d) { return +d; })
    
    var yForLine = d3.scale.linear() .domain([0, d3.max(maxArrayForLine, function(d) { return +d; })] ) .range([height, 0]);
    
    var color = d3.scale.category10();
    
    var xAxisForLine = d3.svg.axis() .scale(xForLine) .orient("bottom");
    
    var yAxisForLine = d3.svg.axis() .scale(yForLine) .ticks(5) .orient("left");
    
    
    color.domain(options.keys.lines.map(function (d) { return d; }));
    
    var minX = d3.min(finalNewNewArrayForLine, function (kv) { return d3.min(kv.Data, function (d) { return +d.value; }) });
    var maxX = d3.max(finalNewNewArrayForLine, function (kv) { return d3.max(kv.Data, function (d) { return +d.value; }) });
    var minY = d3.min(finalNewNewArrayForLine, function (kv) { return d3.min(kv.Data, function (d) { return +d.value; }) });
    var maxY = d3.max(finalNewNewArrayForLine, function (kv) { return d3.max(kv.Data, function (d) { return +d.value; }) });
    
    xForLine.domain([minX, maxX]);
    yForLine.domain([minY, maxY]);
    
    // Creating line data
    var line = d3.svg.line() .interpolate("cardinal") .x(function (d) { return x1ForLine(d['label']); }) .y(function (d) { return yForLine(+d["value"]); });
    
	// Creating lines
    var lines = svg.selectAll(".line") .data(finalNewNewArrayForLine) .enter() .append("g") .append("path") .attr("class", "line")
	
	//.attr("d", function (d,i) { return line(d.Data); }) 
    .style("stroke", function (d,i) { return colours(colorCountVarForLine++); })
    .style("stroke-width",2.5) .style('fill','none') .style("stroke-linecap", "butt")
    
    // Creating circles on lines
    var circle1 = svg.selectAll("g.dot") .data(finalNewNewArrayForLine) .enter() .append("g")
    .attr("class", "dot") .selectAll("circle") .data(function(d) { return d.Data; }) .enter() .append("circle") .attr("r", 4.5)
    .attr("cx", function(d,i) {  return x1ForLine(d['label']); }) .attr("cy", function(d,i) {  return height; })
	//.attr("cy", function(d,i) {  return yForLine(+d["value"]); })
    .style("fill", function (d,i) {
           if(i == 0){ colorCountVarForCircle++; }
           return colours(colorCountVarForCircle - 1);
    })
    
    var columnNames = d3.keys(options.data[0])
    var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
    
    for(var i = 0; i < columnNames.length ; i++){
        for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
            if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                for(var k = 0; k < options.keys.lines.length; k++){
                    var len = d3.select(svg[0][0]).selectAll('g.dot')
                    for(var l = 0; l < d3.select(len[0][k]).selectAll('circle')[0].length; l++){
                        var cir = d3.select(len[0][k]).selectAll('circle')[0][l];
                        d3.select(cir).attr('data-drilldownkey', function(d,index){
                            return JSON.stringify(options.data[l]).slice(1, -1).split('"').join("").split(':').join("|")
                        })
                    }
                }
            }
            else {
            }
        }
    }
    
    //-----------------------------------------------------------------
    
    // Adding the text label for the x axis
    var xAxisVariable =  svg.append("text") .attr("transform", "translate(" + ((width/2) - 20) + " ," + (height+margin.bottom - 2) + ")")
    .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif") .style("font-weight","Bold") .style("font-size","12px") .text(options.xAxisLable) .style('fill','#00001c')
    .style("text-transform","capitalize") .style("font-style","normal")
    
    groups.selectAll('.text').on('mousemove', function (d,i){
                                 
         var root = targetElement
         var m = d3.mouse(root.node());
         m[0] += 0
         m[1] += 0
         
         var valueForGrpBarChartToolTip;
         if(d.y.toString().indexOf('.') === -1)
         {
             valueForGrpBarChartToolTip = d.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
         }
         else{
         
             valueForGrpBarChartToolTip = d.y;
         }
         
         groups.on('mousemove', function (dd,j){
                   
           tooltipForGrpBarsAndLineChart.select('.label').html(finalNewNewArray[j].name)
           tooltipForGrpBarsAndLineChart.select('.count').html(valueForGrpBarChartToolTip)
           tooltipForGrpBarsAndLineChart.style('visibility', 'visible')
           tooltipForGrpBarsAndLineChart.select('hr').style("background-color", function(d){ return colours(j) })
           tooltipForGrpBarsAndLineChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-20) + "px").style("display","block")
         })
     })
    .on('mouseout', function(){ tooltipForGrpBarsAndLineChart.style("display","none") })
    
    groups.selectAll('rect').on('mousemove', function (d,i){
                                
        var root = targetElement
        var m = d3.mouse(root.node());
        m[0] += 0
        m[1] += 0
        
        var valueForGrpBarChartToolTip;
        if(d.y.toString().indexOf('.') === -1)
        {
        valueForGrpBarChartToolTip = d.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        else{
        
        valueForGrpBarChartToolTip = d.y;
        }
        
        groups.on('mousemove', function (dd,j){
                  
              tooltipForGrpBarsAndLineChart.select('.label').html(finalNewNewArray[j].name)
              tooltipForGrpBarsAndLineChart.select('.count').html(valueForGrpBarChartToolTip)
              tooltipForGrpBarsAndLineChart.style('visibility', 'visible')
              tooltipForGrpBarsAndLineChart.select('hr').style("background-color", function(d){ return colours(j) })
              tooltipForGrpBarsAndLineChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-20) + "px").style("display","block")
          })
        // textOnGroupBarChart.on('mousemove', function (d,i){
        
        //     tooltipForGrpBarsAndLineChart.style('visibility', 'hidden')
        // })
        
    })
    .on('mouseout', function(){ tooltipForGrpBarsAndLineChart.style("display","none") })
    
    circle1.on('mousemove', function (d,i){
               
           var root = targetElement
           var m = d3.mouse(root.node());
           m[0] += 0
           m[1] += 0
           
           var valueForLineChartToolTip;
           if(d.value.toString().indexOf('.') === -1)
           {
               valueForLineChartToolTip = d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
           }
           else{
           
               valueForLineChartToolTip = d.value;
           }
           
           tooltipForGrpBarsAndLineChart.select('.label').html(d.label)
           //tooltipForLineChart.select('.count').html(d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
           tooltipForGrpBarsAndLineChart.select('.count').html(valueForLineChartToolTip)
           tooltipForGrpBarsAndLineChart.style('visibility', 'visible')
           tooltipForGrpBarsAndLineChart.select('hr').style("background-color", d3.select(this).style("fill") )
           tooltipForGrpBarsAndLineChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-20) + "px").style("display","block")
               
       })
    .on('mouseout', function(){ tooltipForGrpBarsAndLineChart.style("display","none"); })
    
    //----------------- Adding legend section ----------------
    var divLegendPanelForGrpBarsAndLineChart = targetElement .append('div')  .attr("class","divLegendPanelClassForGrpBarsAndLineChart")
    .style("background-color", options.BGcolor).style('position',"absolute")
    //.style('width', 25 + "%") .style('height', 92 + "%") .style("left",75 + "%").style("top",8 + "%")
    
    if ((showOrHideTableForGrpBarsAndLineChart == false) && (showOrHideCommentsForGrpBarsAndLineChart == true)){
        divLegendPanelForGrpBarsAndLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
        .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
        
        svgPanelForGrpBarsAndLineChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
        .style("position","absolute").style("background-color", options.BGcolor);
    }
    else if ((showOrHideTableForGrpBarsAndLineChart == true) && (showOrHideCommentsForGrpBarsAndLineChart == false)){
        divLegendPanelForGrpBarsAndLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
        .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
        
        svgPanelForGrpBarsAndLineChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
        .style("position","absolute").style("background-color", options.BGcolor);
    }
    else if ((showOrHideTableForGrpBarsAndLineChart == false) && (showOrHideCommentsForGrpBarsAndLineChart == false)){
        divLegendPanelForGrpBarsAndLineChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
        .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
        
        svgPanelForGrpBarsAndLineChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
        .style("position","absolute").style("background-color", options.BGcolor);
    }
    
    var legendItems = [];
    var legendItemsArrayLen = 0;
    for(var i = 0; i < options.keys.groupBars.length; i++){ legendItems.push(options.keys.groupBars[i]); legendItemsArrayLen = legendItems.length; }
    for(var i = 0; i < options.keys.lines.length; i++){ legendItems.push(options.keys.lines[i]) }
    
    var legendPanelSvgForGrpBarsAndLineChart = divLegendPanelForGrpBarsAndLineChart .append('svg')  .attr("class","").style("background-color", options.BGcolor) .style('position',"absolute")
    .style('width', 100 + "%") .style('height', 100 + "%") .style("left",0 + "%").style("top",0 + "%")
    
    var legend = legendPanelSvgForGrpBarsAndLineChart.append("g") .attr("class", "legend") .attr("height", "100%") .attr("width", "100%").attr('transform', 'translate(0,20)')
    
    //Create colour squares
    var legendGroup = legend.selectAll('rect') .data(legendItems) .enter() .append("rect") .attr("x", 5)
    .attr("y", function(d, i){ return i * 16;}) .attr("width", 14) .attr("height", 14) .attr("rx",10) .attr("ry",10)
    .style("fill", function(d, i){ return colours(i);}) .style("cursor","auto").attr("legenddotcount",function(d,i){ if(i >= legendItemsArrayLen){ return i - legendItemsArrayLen; } })
    
    //Create text next to squares
    legend.selectAll('text') .data(legendItems) .enter() .append("text") .attr("x", 25) .attr("y", function(d, i){ return i * 16 + 11.8;})
    .attr("fill", "#00001c") .text(function(d,i) {  if(d.length > 10)
        return d.substring(0,10)+'...';
        else
        return d; }) .style('font-size', '14px') .attr("fill","#00001c") .style("font-family","Verdana,sans-serif")
    
    // Aligning Legend (vertically)
    var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelForGrpBarsAndLineChart[0][0].style.width) / 100)
    var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelForGrpBarsAndLineChart[0][0].style.height) / 100)
    
    var legendRectSize = 11;
    var legendSpacing = 4;
    
    legend.transition().duration(0).attr('transform', function(d, i) {
         var eachRectHeight = legendRectSize + legendSpacing;
         var offset =  eachRectHeight * colours.domain().length / 2;
         var horz = 0;
         var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * (options.keys.groupBars.length + options.keys.lines.length) ))/2.0; // originally 2.0
         
         return 'translate(' + horz + ',' + vert + ')';
     })
    
    legendGroup.on('mouseover',function(d,i){
                   
       groups.selectAll('rect').transition().style('fill-opacity',0.04)
       d3.select(groups[0][i]).selectAll('rect').transition().duration(400).style('fill-opacity',0.95)
                   
    })
    legendGroup.on('mouseout',function(d,i){
       groups.selectAll('rect').transition().style('fill-opacity',1).style('stroke-width',0)
    })
    
    legendGroup.on('mouseover',function(d,i){
                   
        var legDotCountVar = d3.select(legend[0][0]).selectAll("rect")
           
        
       if(xScale1GlobalVar == undefined){ // to check whether the widget is being resized or not (to save new xScale)
           xScale1GlobalVar = x0;
       }
       
       groups.selectAll('.text').style('display','none')
       
       d3.select(groups[0][i]).selectAll('text').style('display','block')
       .transition().duration(0).ease('bounce') .attr("x", function(d,i) { return 4 - y(d.y); })
       .attr("y", function(d,i) {textWidth = d3.select("text").node().getBoundingClientRect().height;
             computedWidth =  (x1.rangeBand() / 2) - (textWidth / 2)
             if(computedWidth > 0){
             return (x0(i)) + (computedWidth + textWidth / 1.4);
             }
             else {
             return (x0(i)) + 10.0;
             }
         }) .style("fill", "#00001c")
       .text(function(d,i){
             if(d.y.toString().indexOf('.') === -1)
             {
             return d.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
             }
             else{
             
             return d.y;
             }
         })
       
       groups.selectAll('rect').transition().style('fill-opacity',0.035)
       d3.select(groups[0][i]).selectAll('rect').transition().duration(400).style('fill-opacity',0.95)
   
           
       if(parseInt(d3.select(legDotCountVar[0][i]).attr("legenddotcount")) >= 0 && d3.select(legDotCountVar[0][i]).attr("legenddotcount") !== null){
           
           d3.select(lines[0][parseInt(d3.select(legDotCountVar[0][i]).attr("legenddotcount"))]).style('stroke-width',2.5)
           
           var lineLen = lines.node().getTotalLength();
           var dashLen = options.data.length;
           var ddLen = dashLen ;
           var darray = dashLen;
           while(ddLen < lineLen){
           darray+=","+dashLen+","+dashLen;
           ddLen+=dashLen;
           }
           
           d3.select(lines[0][parseInt(d3.select(legDotCountVar[0][i]).attr("legenddotcount"))]).attr("stroke-linecap", "round").attr("stroke-dasharray", darray + ","+lineLen) .attr("stroke-dashoffset", lineLen)
           .transition().duration(5000).ease("linear").attr("stroke-dashoffset", 0);
           
       }
                   
     })
    
    legendGroup.on('mouseout',function(d,i){
                 
           var legDotCountVar = d3.select(legend[0][0]).selectAll("rect")
           
   
           if(xScale1GlobalVar == undefined){
               xScale1GlobalVar = x0;
           }
           
           groups.selectAll('.text').style('display','block').transition().duration(0).attr("x", function(d,i) { return 4 - y(d.y); })
           .attr("y", function(d,i) {textWidth = d3.select("text").node().getBoundingClientRect().height;
                 computedWidth =  (x1.rangeBand() / 2) - (textWidth / 2)
                 if(computedWidth > 0){
                     return (x0(i)) + (computedWidth + textWidth / 1.4);
                 }
                 else {
                     return (x0(i)) + 10.0;
                 }
             })
           .text(function(d,i){
                 if(d.y.toString().indexOf('.') === -1)
                 {
                     if(d.y.toString().length <= 3){
                         return d.y;
                     }
                     else{
                         return format1(d.y);
                     }
                 }
                 else{
                     return d.y;
                 }
             })
           groups.selectAll('rect').transition().style('fill-opacity',0.88).style('stroke-width',0)
           
           if(parseInt(d3.select(legDotCountVar[0][i]).attr("legenddotcount")) >= 0 && d3.select(legDotCountVar[0][i]).attr("legenddotcount") !== null){
               d3.select(lines[0][parseInt(d3.select(legDotCountVar[0][i]).attr("legenddotcount"))]).style('stroke-width',2.5) .transition().duration(0)
               d3.select(lines[0][parseInt(d3.select(legDotCountVar[0][i]).attr("legenddotcount"))]).attr("stroke-dasharray", options.data.length + ","+ 0)  .attr("stroke-dashoffset", 0)
           }
                   
           
    })
    
    // ----------------------- adding table section ------------------------
    var tablePanelForGrpBarsAndLineChart =  targetElement.append("div") .attr("id",targetElement[0][0].id + "holderForGroupedChartTableID")
    .attr("class","scrollingDivForTable-Class tableDivForGrpBarsAndLineChart" + targetElement[0][0].id) .style('background-color',"#ffffff") .style('position','absolute')
    .style("display","block") .style("overflow","hidden") .style("width", function(d) {  return 100.0 + "%"; })
    .style("height", function(d) { return 40 + "%"; }) .style("left",0 + "%").style("z-index",10)
    
    $( '.tableDivForGrpBarsAndLineChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
            
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
    });
    
    if(options.showTitle == true ){
        tablePanelForGrpBarsAndLineChart.style("top",60.0  + "%")
    }
    else if(options.showTitle == false  ){
        tablePanelForGrpBarsAndLineChart.style("top",60.0  + "%")
        
    }
    tablePanelForGrpBarsAndLineChart.html('<table class = "tableClassForGrpBarsAndLineChart' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                      '<thead class = "theadClassForGrpBarsAndLineChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForGrpBarsAndLineChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                                      '<tbody class = "tBodyClassForGrpBarsAndLineChart' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                      '</table>'
                                      )
    
    tablePanelForGrpBarsAndLineChart.select('table').attr("id",targetElement[0][0].id + "tableID")
    
    // Show or Hide Table scroll bar when mouseover on widget
    targetElement.on('mouseover',function(){ tablePanelForGrpBarsAndLineChart.style("overflow","auto") })
    targetElement.on('mouseout',function(d){ tablePanelForGrpBarsAndLineChart.style("overflow","hidden") })
    
    var tableDataForGrpBarChart = [];
    if(options.dataForTable.length > 0){
        tableDataForGrpBarChart = options.dataForTable;
    }
    else {
        tableDataForGrpBarChart = options.data;
    }
    
    var thead = tablePanelForGrpBarsAndLineChart.select("thead").selectAll("th") .data(d3.keys(tableDataForGrpBarChart[0]))
    .enter().append("th") .text(function(d){return d.charAt(0) .toUpperCase() + d.substr(1)}) .style("cursor","pointer") .style("min-width","100px")
    
    var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff") //f4f4f4
    .style("position","relative")
    
    var thead1 = d3.select(".thead1ClassForGrpBarsAndLineChart" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tableDataForGrpBarChart[0]))
    .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
    
    var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff") //f4f4f4
    .style("position","relative")
    
    var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
    .attr("id", "ascendingIconIDForGrpBarsAndLineChart") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
    
    var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
    .attr("id", "descendingIconIDForGrpBarsAndLineChart") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
    
    var tr = tablePanelForGrpBarsAndLineChart.select("tbody").selectAll("tr") .data(tableDataForGrpBarChart).enter().append("tr")
    .attr("id", function(d,i) { return "slice" + i })
    
    // cells
    var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d})
    .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
    
    var $table = $('.tableClassForGrpBarsAndLineChart' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
    
    d3.select(".theadClassForGrpBarsAndLineChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
        d.forEach(function(dd,j){
			colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
		})
    })
    
    $(".thead1ClassForGrpBarsAndLineChart" + targetElement[0][0].id).insertAfter('.tBodyClassForGrpBarsAndLineChart' + targetElement[0][0].id)
    
    $(".thead1ClassForGrpBarsAndLineChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForGrpBarsAndLineChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
    
    tablePanelForGrpBarsAndLineChart.select(".thead1ClassForGrpBarsAndLineChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
       d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
    })
    
    $('.tableDivForGrpBarsAndLineChart' + targetElement[0][0].id).scroll(function () {
                                                                     
         $(".thead1ClassForGrpBarsAndLineChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForGrpBarsAndLineChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
         
     })
    
    var sortOrder = false;
    thead1.on("click",function(k,index){
              
              sortOrder = !sortOrder;
              
              tablePanelForGrpBarsAndLineChart.select(".thead1ClassForGrpBarsAndLineChart" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                                                                                                                                  
              if (sortOrder) {
                  
                  if(i == index){
                  d3.select(this).select('svg').select('#descendingIconIDForGrpBarsAndLineChart').style("visibility", "hidden")
                  d3.select(this).select('svg').select('#ascendingIconIDForGrpBarsAndLineChart').style("visibility", "visible")
                  }
                  else {
                  d3.select(this).select('svg').select('#descendingIconIDForGrpBarsAndLineChart').style("visibility", "visible")
                  d3.select(this).select('svg').select('#ascendingIconIDForGrpBarsAndLineChart').style("visibility", "visible")
                  }
                  }
                  else{
                  
                  if(i == index){
                  d3.select(this).select('svg').select('#descendingIconIDForGrpBarsAndLineChart').style("visibility", "visible")
                  d3.select(this).select('svg').select('#ascendingIconIDForGrpBarsAndLineChart').style("visibility", "hidden")
                  }
                  else {
                  d3.select(this).select('svg').select('#descendingIconIDForGrpBarsAndLineChart').style("visibility", "visible")
                  d3.select(this).select('svg').select('#ascendingIconIDForGrpBarsAndLineChart').style("visibility", "visible")
                  }
                  }
              })
              
              
              var monthTruOrFalAryForGrpBarChart = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
              
              tr.sort(function(a, b) {
                      
                      if (sortOrder) {
                      var monthsArrayForGrpBarChart = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                      } else {
                      var monthsArrayForGrpBarChart = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                      }
                      
                      monthTruOrFalAryForGrpBarChart = []; gotMonthArray = [];
                      tableDataForGrpBarChart.forEach(function(d,i){
                                                      var da = d[k].toString().substring(0,3).toLowerCase()
                                                      if(monthsArrayForGrpBarChart.indexOf(da) >= 0){
                                                      monthTruOrFalAryForGrpBarChart.push(true)
                                                      gotMonthArray.push(da);
                                                      }
                                                      else {
                                                      monthTruOrFalAryForGrpBarChart.push(false)
                                                      }
                      })
                      
                      if(monthTruOrFalAryForGrpBarChart.indexOf(false) == -1){ // true
                      
                      monthArray = []; monthArrayCount = [];
                      gotMonthArray.forEach(function(dd,j){
                                            var index1 = monthsArrayForGrpBarChart.indexOf(dd.substring(0,3))
                                            if(monthArrayCount.indexOf(index1) >= 0){
                                            index1 = 12 + index1;
                                            }
                                            monthArray.push(index1);
                                            monthArrayCount.push(index1)
                                            })
                      returnArray = []
                      monthArray.sort(function(aa, bb) {
                                      returnArray.push(+aa - +bb)
                                      return +aa - +bb;
                                      })
                      
                      sortTableFunc()
                      return returnArray[ind++];
                      } //  if true (if jan feb if block)
                      else {
                      var data = +a[k];
                      
                      if(!isNaN(data)){
                      
                      if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                      else { return d3.descending(+a[k], +b[k]); }
                      }
                      else if(!isNaN(Date.parse(a[k]))){
                      
                      if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                      else { return new Date(b[k]) - new Date(a[k]) }
                      }
                      else {
                      
                      if (sortOrder) { return d3.ascending(a[k], b[k]); }
                      else { return d3.descending(a[k], b[k]); }
                      }
                      } // if not jan feb else block
                      }); // tr
    })
    
    function sortTableFunc(){
        
        var table = tablePanelForGrpBarsAndLineChart.select('table');
        var rows = table.selectAll('tr').data(tableDataForGrpBarChart);
        var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
        cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0).style("color","#00001c");
        
        cells.text(function(d,i) {return d});
        
        // Cells exit selection
        cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
        
        var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
        
        cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500)
        .style('opacity', 1.0).style("color","#00001c");
        
        cells_in_new_rows.text(function(d,i) {return d});
        
        rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
    }
    
    // Main Table Styling
    tablePanelForGrpBarsAndLineChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
    .style("color","#00001c")
    .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4") //.style("box-shadow","10px 10px 50px #007aff").style("z-index",9999)
    tablePanelForGrpBarsAndLineChart.selectAll('td').style("height","25px") .style("border", "1px solid #dddddd") .style("font-size","12px").style("font-weight","Normal").style("color","#00001c")
    
    //additionally 
    tablePanelForGrpBarsAndLineChart.selectAll('th').style('background-color',"#ffffff").style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
    tablePanelForGrpBarsAndLineChart.selectAll('td').style('background-color',"#ffffff").style("border-style","none").style("color","#00001c")
    
    //b1da9f
    tablePanelForGrpBarsAndLineChart.selectAll('table') . style("border-collapse","collapse")
    tablePanelForGrpBarsAndLineChart.selectAll('table tr:first-child th').style("border-top","0px")
    tablePanelForGrpBarsAndLineChart.selectAll('table tr:last-child td').style("border-bottom","0px")
    tablePanelForGrpBarsAndLineChart.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
    tablePanelForGrpBarsAndLineChart.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")
    
    if(showOrHideTableForGrpBarsAndLineChart == false){
        tablePanelForGrpBarsAndLineChart.style("display","none")
    }
    else if(showOrHideTableForGrpBarsAndLineChart == true){
        tablePanelForGrpBarsAndLineChart.style("display","block")
    }
    
    if(options.isDataDetailedForTable == false){
        
        var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
        
        // Adding underlines for selected drill-down column text
        var drillDownSectionsForGrpBarsAndLineChart = tablePanelForGrpBarsAndLineChart.select('table').selectAll('th')
        
        var foundResult = [];
        for(var i = 0; i<drillDownSectionsForGrpBarsAndLineChart[0].length; i++){
            for(var j = 0; j<drillDownColumnNamesArray.length; j++){
                if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForGrpBarsAndLineChart[0][i].__data__.toString().toLowerCase() ){
                    foundResult.push(i)
                }
            }
        }
        
        var r = tablePanelForGrpBarsAndLineChart.select('table').selectAll('tr').selectAll('td')
        for(var i = 0; i<r.length; i++){
            for(var j = 0; j < foundResult.length; j++){
                var row = r[i][foundResult[j]]
                $(row).css("text-decoration", "underline")
            }
        }
    }
    
    //By default calling the resized function first time (to align table's th and td).
    setTimeout(function(){ resizedFuctionForGrpBarsAndLineChart() },1000)
    
    window.addEventListener('resize', function(event){ resizedFuctionForGrpBarsAndLineChart() });
    
    var xScale1GlobalVar;
    var yScale1GlobalVar;
    var newHeightVar; // storing the new height when parent div is resized.
    
    $(function() {
      
      $("#" + targetElement[0][0].id).resizable({
            resize: function(event, ui) {
            //divWidthForHoriChart = ui.size.width;
            //divHeightForHoriChart = ui.size.height;
            resizedFuctionForGrpBarsAndLineChart();
            }
        });
      });
    
    function resizedFuctionForGrpBarsAndLineChart()
    {
        
        if((svgPanelForGrpBarsAndLineChart.node().getBoundingClientRect().width) && (svgPanelForGrpBarsAndLineChart.node().getBoundingClientRect().height) > 0){
            
            if(showOrHideCommentsBtnForGrpBarsAndLineChart == true){
                stkCirAreaBtnForGrpBarChart.style('right', '0')
                horiGrpBarBtnForGrpBarChart.style('right', '0')
                filterBtnForGrpBarsAndLineChart.style('right', '0')
                refreshBtnForGrpBarsAndLineChart.style('margin-left', "2px")
                commentsBtnForGrpBarsAndLineChart.style('margin-left', "2px")
                menuBtnForGrpBarsAndLineChart.style('right', '0')
            }
            else if(showOrHideCommentsBtnForGrpBarsAndLineChart == false){
                stkCirAreaBtnForGrpBarChart.style('right', '0')
                horiGrpBarBtnForGrpBarChart.style('right', '0')
                filterBtnForGrpBarsAndLineChart.style('right', '0')
                refreshBtnForGrpBarsAndLineChart.style('margin-left', "2px")
                //commentsBtnForGrpBarsAndLineChart.style('right', '0')
                commentsBtnForGrpBarsAndLineChart.style('display','none')
                menuBtnForGrpBarsAndLineChart.style('right', '0')
            }
            
            optsBtnPanelForGrpBarsAndLineChart.style('right', '0')
            
            stgPanCanBtnForGrpBarsAndLineChart.style('right', '0')
            
            if(options.showTitle == true){
                
                var margin1 = {top: 50 , right: 20, bottom: 80, left: 20}, //originally top: 42, left: 80
                width1 = (svgPanelForGrpBarsAndLineChart.node().getBoundingClientRect().width) - margin.left - margin.right,
                height1 = (svgPanelForGrpBarsAndLineChart.node().getBoundingClientRect().height) - margin.top - margin.bottom;
                newHeightVar = height1
            }
            else if(options.showTitle == false){
                
                var margin1 = {top: 50 , right: 20, bottom: 80, left: 20}, //originally top: 42, left: 80
                width1 = (svgPanelForGrpBarsAndLineChart.node().getBoundingClientRect().width) - margin.left - margin.right,
                height1 = svgPanelForGrpBarsAndLineChart.node().getBoundingClientRect().height - margin.top - margin.bottom;
                newHeightVar = height1
            }
            
            
            var xMax1 =  d3.max(dataset, function (group) { return d3.max(group, function (d) { return d.y; }); })
            
            //var xAxisLabels1 = dataset[0].map(function (d) { return d.x; });
            
            xScale1GlobalVar = x0 .domain(d3.range(xAxisLabels.length)) .rangeBands([0, width1], .28);
            
            x1.domain(d3.range(finalNewNewArray.length)) .rangeBands([0, x0.rangeBand()]);
            
            yScale1GlobalVar = y.domain([0, xMax]) .range([height1, 0]);
            
            xAxis.scale(x0) .orient("bottom");
            
            yAxis.scale(y) .orient("left");
            
            var svg1 = svg;
            
            svg1.select("svg") .attr("width", width1 + margin1.left + margin1.right) .attr("height", height1 + margin1.top + margin1.bottom)
            
            svg1.select(".y.axis") .call(yAxis)
            
            svg1.select(".x.axis") .attr("transform", "translate(0," + height1 + ")") .call(xAxis)
            
            .selectAll("text").data(xAxisLabels) .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') .attr("transform", function(d) { 
                if(numberGreaterThanLimit.length>0){return "rotate(-45)"}
                else{
                return "rotate(0)" }})
            .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
            .text(function(d,i) {
                      if(d.length > 9)
                      return d.substring(0,9)+'...';
                      else
                      return d;
                  })
            
            var groupsArray = [];
            groups.selectAll('rect').data(function(d,i) { groupsArray[i] = x1(i); return d; })
            .attr("width", x1.rangeBand())
            .attr("height", function(d) { return height1 - y(d.y) })
            .attr("x", function(d, i) { return x0(i); })
            .attr("y", function(d) { return  y(d.y); })//.select('g')
            
            for(var i=0;i<groups[0].length;i++){
                var gg = groupsArray[i];
                d3.select(groups[0][i])
                .attr("transform", function(d, i) { return "translate(" + gg + ",0)"; })
            }
            
            groups.selectAll('.text') .attr("x", function(d,i) { return 4 - y(d.y); })
            .attr("y", function(d,i) {textWidth = d3.select("text").node().getBoundingClientRect().height; 
                  computedWidth =  (x1.rangeBand() / 1.5) - (textWidth / 2)
                  if(computedWidth > 0){
                  return (x0(i)) + (computedWidth + textWidth / 1.4);
                  }
                  else {
                  return (x0(i)) + 10.0;
                  }
                  })
            
            xAxisVariable.attr("transform", "translate(" + ((width1/2) - 20) + " ," + (height1+margin1.bottom - 2) + ")")
            
            
            //---------------------- Resizing lines -----------------------
            
            xForLine.domain(options.data.map(function(d,i) { return d[options.keys.label];})).rangePoints([0, width1],1.31);
            
            x1ForLine.domain(options.data.map(function(d) { return d[options.keys.label]; })) .rangePoints([0, width1], 1.31);
            
            var yyForLine = d3.scale.linear().domain([0, d3.max(maxArrayForLine, function(d) { return +d; })] ).range([height1, 0]);
            
            yAxisForLine.scale(yyForLine) .orient("left");
            
            xAxisForLine.scale(xForLine) .orient("bottom");
            
            line.x(function (d) { return xForLine(d['label']); }) .y(function (d) { return yyForLine(+d["value"]); });
            
            var svg1 = svg;
            
            //svg1.select("svg") .attr("width", width1 + margin1.left + margin1.right) .attr("height", height1 + margin1.top + margin1.bottom)
            
            //svg1.select(".y.axis") .call(yAxis)
            
            //svg1.select(".x.axis") .attr("transform", "translate(0," + height1 + ")") .call(xAxis)
            
            svg1.selectAll("circle") .transition() .delay(function (d, i) { return i / options.data.length * 50; }) .duration(800)
            .attr("cx", function(d,i) {  return x1ForLine(d['label']); }) .attr("cy", function(d,i) {  return yyForLine(+d["value"]); })
            
			svg1.selectAll(".line").transition() .delay(function (d, i) { return i / options.data.length * 50; }) .duration(800).attr("d", function (d,i) { return line(d.Data); })
            
            //-------------------------------------------------------------
            
            
            
            // Aligning Legend (vertically)
            var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelForGrpBarsAndLineChart[0][0].style.width) / 100)
            var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelForGrpBarsAndLineChart[0][0].style.height) / 100)
            
            var legendRectSize = 11;
            var legendSpacing = 4;
            
            legend.attr('transform', function(d, i) {
				var eachRectHeight = legendRectSize + legendSpacing;
				var offset =  eachRectHeight * colours.domain().length / 2;
				var horz = 0;
				var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * (options.keys.groupBars.length + options.keys.lines.length) ))/2.0; // originally 2.0
				
				return 'translate(' + horz + ',' + vert + ')';
			})
            
            colWidth = []; 
			
            d3.select(".theadClassForGrpBarsAndLineChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                        d.forEach(function(dd,j){
                                  colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                                  })
                        })
            tablePanelForGrpBarsAndLineChart.select(".thead1ClassForGrpBarsAndLineChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
               d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
            })
            
        }// checking svg panel width & height greater than zero function
    }
}, //groupedBarsWithLineChart

    //************************************************** Stacked Grouped Bar Chart  **************************************************
    stackedGroupedBarChart: function(targetElement, options){
        
        isChartCalled++;
        
        var chartName = "STACKEDGROUPEDBARCHART";
        
        acinfotech.allCharts(targetElement,options,chartName);
        
        var reversedDimsLabelArray = options.keys.labels.reverse()
        
        var selectedDimensionsArray = reversedDimsLabelArray;
        var selectedDimsValueArray = [];
        var tempArray = [];
        var finalSelectedDimsValueArray = []
        
        for(var i = 0; i < selectedDimensionsArray.length; i++){
            tempArray = []
            options.data.forEach(function(d,j){
                for(var k = 0; k<Object.keys(d).length; k++){
                    var lower = d3.keys(d)[k].toString().toLowerCase()
                        if (lower === selectedDimensionsArray[i].toString().toLowerCase()) {
                            tempArray.push(d3.values(d)[k])
                        }
                }
            })
            finalSelectedDimsValueArray.push(tempArray)
        }
        
        var finalSelectedDimsUniqueValuesArray = []
        for(var i = 0; i < finalSelectedDimsValueArray.length; i++){
            tempArray = []
            $.each(finalSelectedDimsValueArray[i], function(i, el){
                if($.inArray(el, tempArray) === -1) tempArray.push(el);
            });
           finalSelectedDimsUniqueValuesArray.push(tempArray)
        }
        
        var finalArray = [];
        var tempArray = [];
        
        var setOfDataArray = []; // Two hold each data
        
        for(var i = 0; i < finalSelectedDimsUniqueValuesArray[0].length; i++){
            tempArray = []
            for(var j = 0; j < finalSelectedDimsUniqueValuesArray[1].length; j++){
                options.data.forEach(function(d,l){
                    for(var n = 0; n < Object.keys(d).length; n++){
                        var lower = d3.keys(d)[n].toString().toLowerCase();
                            if(lower === selectedDimensionsArray[0].toString().toLowerCase()){
                                if(d3.values(d)[n].toString().toLowerCase() === finalSelectedDimsUniqueValuesArray[0][i].toString().toLowerCase()){
                                    for(var p = 0; p < Object.keys(d).length; p++){
                                        var lower = d3.keys(d)[p].toString().toLowerCase()
                                            if(lower === selectedDimensionsArray[1].toString().toLowerCase()){
                                                if(d3.values(d)[p].toString().toLowerCase() === finalSelectedDimsUniqueValuesArray[1][j].toString().toLowerCase()){
                                                    tempArray.push(d)
                                                    break;
                                                } // if
                                            } // if(lower)
                                    } // for(var p)
                                } //if(d3.values(d[n])
                            }// if(lower)
                    } // for(var n)
                }) // options.data
            } // for(var j)
            setOfDataArray.push(tempArray)
        }// for(var i)
        
        targetElement.style("min-width","350px").style("min-height","350px").style("background-color", options.BGcolor)
        
        var showOrHideTableForStkGrpBarChart;
        var showOrHideCommentsForStkGrpBarChart;
        var showOrHideCommentsBtnForStkGrpBarChart = true;
        
        if((options.showTable == false) || (options.showTable == true)){
            showOrHideTableForStkGrpBarChart = options.showTable
        }
        else{
            showOrHideTableForStkGrpBarChart = false;
        }
        
        // Show or Hide comments
        if (options.showComments == true || false) {
            showOrHideCommentsForStkGrpBarChart = options.showComments;
        }
        else {
            showOrHideCommentsForStkGrpBarChart = false;
        }
        
        if (options.comments.length == 0){
            showOrHideCommentsForStkGrpBarChart = false;
            showOrHideCommentsBtnForStkGrpBarChart = false;
        }
        
        if ((showOrHideTableForStkGrpBarChart == true) && (showOrHideCommentsForStkGrpBarChart == true)){
            showOrHideTableForStkGrpBarChart = true;
            showOrHideCommentsForStkGrpBarChart = false;
        }
        else if ((showOrHideTableForStkGrpBarChart == false) && (showOrHideCommentsForStkGrpBarChart == false)){
            showOrHideTableForStkGrpBarChart = false;
            showOrHideCommentsForStkGrpBarChart = false;
        }
        
        var yAxisDivForStkGrpBarChart = targetElement.append("div").style("position","absolute").style("background-color", options.BGcolor)
        .style("width", function(d) {  return 10.00 + "%"; }) .style("height", function(d) { return 80 + "%"; }).style("top", function(d) {  return 10.00 + "%"; })
        .style("left", function(d) {  return 0.00 + "%"; })
        .style("border","none").style("border-bottom","0px solid #e6e6e6").style("box-sizing","border-box")
        
        var chartDivForStkGrpBarChart = targetElement.append("div").style("position","absolute").style("background-color", options.BGcolor)
        .style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 80 + "%"; }).style("top", function(d) {  return 10.00 + "%"; })
        .style("left", function(d) {  return 10.00 + "%"; })
        .style("border","none").style("border-right","0px solid #808080").style("box-sizing","border-box")
        
        var legendDivForStkGrpBarChart = targetElement.append("div").style("position","absolute").style("background-color", options.BGcolor)
        .style("width", function(d) {  return 20.00 + "%"; }) .style("height", function(d) { return 80 + "%"; }).style("top", function(d) {  return 10.00 + "%"; })
        .style("left", function(d) {  return 80.00 + "%"; })
        .style("border","none").style("border-bottom","0px solid #e6e6e6").style("box-sizing","border-box")
        
        var chartTitlePanelForStkGrpBarChart =  targetElement.append("div").style("position","absolute").style("background-color", options.BGcolor).style("text-indent","10px")
        .style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 5 + "%"; }).style("top", function(d) {  return 0.00 + "%"; })
        .style("border","none").style("box-sizing","border-box")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:20.0%; font-size:14px; font-family:inter;color:#00001c;">'+ options.chartTitle +'</div>')
        
        //Reverse the order of options.keys.labels
        options.keys.labels.reverse()
        
        var chartTopPanelForStkGrpBarChart =  targetElement.append("div").style("position","absolute").style("text-align", "center").style("background-color", options.BGcolor)
        .style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 5 + "%"; }).style("top", function(d) {  return 5.00 + "%"; })
        .style("left", function(d) {  return 10.00 + "%"; }).style("border","none").style("border-bottom","0px solid #e6e6e6").style("box-sizing","border-box")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:20.0%; font-size:12px; font-family:inter; text-transform:uppercase; color:#00001c; font-weight:Bold;">'+ options.keys.labels[1] +'</div>')
        
        var chartBottomPanelForStkGrpBarChart =  targetElement.append("div").style("position","absolute").style("text-align", "center").style("background-color", options.BGcolor)
        .style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 5 + "%"; }).style("top", function(d) {  return 90.00 + "%"; })
        .style("left", function(d) {  return 10.00 + "%"; }).style("border","none").style("border-top","0px solid #e6e6e6").style("box-sizing","border-box")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:20.0%; font-size:12px; font-family:inter; text-transform:uppercase; color:#00001c; font-weight:Bold;">'+ options.keys.labels[0] +'</div>')
        
        //Reverse the order of options.keys.labels
        options.keys.labels.reverse()
        
		var optionsButtonPanelForStkGrpBarChart = targetElement.append('div').style('width',"25px").style('height',"130px").style('position','absolute')
        .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px")
        .style('right', '0').style("min-width","25px")
        .style("border-style","none").style("border-left", "solid #fcfcfc  1px")//.style("top",71.5 + "px")
		
        //-------- adding shuffle and refresh button --------
        var shuffleBtnForStkGrpBarChart = optionsButtonPanelForStkGrpBarChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','55px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var filterBtnImgVar = document.createElement("IMG");
        filterBtnImgVar.src = "images/shuffleIcon.png";
        filterBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.9;")
        shuffleBtnForStkGrpBarChart[0][0].appendChild(filterBtnImgVar)
        
        var refreshBtnForStkGrpBarChart = optionsButtonPanelForStkGrpBarChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','80px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var refreshBtnImgVar = document.createElement("IMG");
        refreshBtnImgVar.src = "images/refreshIcon.png";
        refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.9;")
        refreshBtnForStkGrpBarChart[0][0].appendChild(refreshBtnImgVar)
        
        var commentsPanelDivForStkGrpBarChart = targetElement.append("div") //.attr("class","commentsPanelClassForcommentsPanelDivForStkGrpBarChart")
        .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
		.style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
        .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)
        
        commentsPanelDivForStkGrpBarChart.on('click',function(d){
            $('.commentsClassForcommentsPanelDivForStkGrpBarChart' + targetElement[0][0].id).focus()
        })
        
        var commentsBtnForStkGrpBarChart = optionsButtonPanelForStkGrpBarChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','105px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var commentsBtnImgVariable = document.createElement("IMG");
        if(options.showComments == false){
            commentsBtnImgVariable.src = "images/showCommentsIcon.png";
        }
        else if(options.showComments == true){
            commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
        }
        commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        commentsBtnForStkGrpBarChart[0][0].appendChild(commentsBtnImgVariable)
        
        var menuButtonForStkGrpBarChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','1px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var menuBtnImgVar = document.createElement("IMG");
        menuBtnImgVar.src = "images/menuIcon.png";
        menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
        menuButtonForStkGrpBarChart[0][0].appendChild(menuBtnImgVar)
        
        var ismenuButtonOfStkGrpBarChartClicked = false; // Menu toggle button variable
        menuButtonForStkGrpBarChart.on('click', function() {
                
            shufflePanelForTwoXAxisesGrpBarChart.style("display","none");
                                             
            if(ismenuButtonOfStkGrpBarChartClicked == false){ // Checking if menu button is clicked
                ismenuButtonOfStkGrpBarChartClicked = true; // Menu toggle button variable
                optionsButtonPanelForStkGrpBarChart.style("display","block") // Showing option buttons menu panel
            }
            else if(ismenuButtonOfStkGrpBarChartClicked == true){ // Checking if menu button is clicked
                ismenuButtonOfStkGrpBarChartClicked = false
                optionsButtonPanelForStkGrpBarChart.style("display","none") // Hiding option buttons panel
            }
                                    
        })
        
        var tableButtonForStkGrpBarChart = optionsButtonPanelForStkGrpBarChart.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top','1px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
        var tableBtnImgVar = document.createElement("IMG");
        if(showOrHideTableForStkGrpBarChart == false){
            tableBtnImgVar.src = "images/showTableIcon.png";
            tableButtonForStkGrpBarChart.attr("class","showTableClassForChartTable")
        }
        else if(showOrHideTableForStkGrpBarChart == true){
            tableBtnImgVar.src = "images/cancelTableIcon.png";
            tableButtonForStkGrpBarChart.attr("class","hideTableClassForChartTable")
        }
        tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
        tableButtonForStkGrpBarChart[0][0].appendChild(tableBtnImgVar)
        
        var downloadBtnForStkGrpBarChart = optionsButtonPanelForStkGrpBarChart.append("div").attr("id","downloadBtnForStkGrpBarChart-ID-" + targetElement[0][0].id)
        .style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff")
        .style('margin-left','2px').style('top', 28 + 'px').style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        
        acinfotech.downloadFunctionality("downloadBtnForStkGrpBarChart-ID-" + targetElement[0][0].id,targetElement)
        
        if ((showOrHideTableForStkGrpBarChart == false) && (showOrHideCommentsForStkGrpBarChart == true)){
            
            yAxisDivForStkGrpBarChart.style("left", function(d) {  return 0.00 + "%"; }).style("top", function(d) {  return 10.00 + "%"; }).style("width", function(d) {  return 10.00 + "%"; }) .style("height", function(d) { return 65 + "%"; })
            
            chartDivForStkGrpBarChart.style("left", function(d) {  return 10.00 + "%"; }).style("top", function(d) {  return 10.00 + "%"; })
            .style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 65 + "%"; })
            
            chartBottomPanelForStkGrpBarChart.style("left", function(d) {  return 10.00 + "%"; }).style("top", function(d) {  return 75.00 + "%"; }).style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 5 + "%"; })
            
            legendDivForStkGrpBarChart.style("left", function(d) {  return 80.00 + "%"; }).style("top", function(d) {  return 10.00 + "%"; }).style("width", function(d) {  return 20.00 + "%"; }) .style("height", function(d) { return 65 + "%"; })
            
            var commentsForStkGrpBarChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
            .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
            .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
            .css('line-height','1.1em').css('text-align','justify') .attr('class','commentsClassForStkGrpBarChart' + targetElement[0][0].id)
            
            commentsPanelDivForStkGrpBarChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 20 + "%"; })
            .style("top",80 + "%")
            .html(commentsForStkGrpBarChart[0].outerHTML.toString())
            
        }
        else if ((showOrHideTableForStkGrpBarChart == true) && (showOrHideCommentsForStkGrpBarChart == false)){
            
            yAxisDivForStkGrpBarChart.style("left", function(d) {  return 0.00 + "%"; }).style("top", function(d) {  return 10.00 + "%"; }).style("width", function(d) {  return 10.00 + "%"; }) .style("height", function(d) { return 55 + "%"; })
            
            chartDivForStkGrpBarChart.style("left", function(d) {  return 10.00 + "%"; }).style("top", function(d) {  return 10.00 + "%"; })
            .style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 55 + "%"; })
            
            chartBottomPanelForStkGrpBarChart.style("left", function(d) {  return 10.00 + "%"; }).style("top", function(d) {  return 65.00 + "%"; }).style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 5 + "%"; })
            
            legendDivForStkGrpBarChart.style("left", function(d) {  return 80.00 + "%"; }).style("top", function(d) {  return 10.00 + "%"; }).style("width", function(d) {  return 20.00 + "%"; }) .style("height", function(d) { return 55 + "%"; })
            
            commentsPanelDivForStkGrpBarChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            
        }
        else if ((showOrHideTableForStkGrpBarChart == false) && (showOrHideCommentsForStkGrpBarChart == false)){
            
            yAxisDivForStkGrpBarChart.style("left", function(d) {  return 0.00 + "%"; }).style("top", function(d) {  return 10.00 + "%"; }).style("width", function(d) {  return 10.00 + "%"; }) .style("height", function(d) { return 80 + "%"; })
            
            chartDivForStkGrpBarChart.style("left", function(d) {  return 10.00 + "%"; }).style("top", function(d) {  return 10.00 + "%"; })
            .style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 80 + "%"; })
            
            chartBottomPanelForStkGrpBarChart.style("left", function(d) {  return 10.00 + "%"; }).style("top", function(d) {  return 90.00 + "%"; }).style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 5 + "%"; })
            
            legendDivForStkGrpBarChart.style("left", function(d) {  return 80.00 + "%"; }).style("top", function(d) {  return 10.00 + "%"; }).style("width", function(d) {  return 20.00 + "%"; }) .style("height", function(d) { return 80 + "%"; })
            
            commentsPanelDivForStkGrpBarChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
        }
        
        
        if(showOrHideCommentsBtnForStkGrpBarChart == true){
            shuffleBtnForStkGrpBarChart.style('margin-left', "2px")
            refreshBtnForStkGrpBarChart.style('margin-left', "2px")
            commentsBtnForStkGrpBarChart.style('margin-left', "2px")
            menuButtonForStkGrpBarChart.style('right', '0')
        }
        else if(showOrHideCommentsBtnForStkGrpBarChart == false){
            //commentsBtnForGroupedBarChart.style('right', '0')
            shuffleBtnForStkGrpBarChart.style('margin-left', "2px")
            refreshBtnForStkGrpBarChart.style('margin-left', "2px")
            commentsBtnForStkGrpBarChart.style('display','none')
			menuButtonForStkGrpBarChart.style('right', '0')
        }
        
        var colours;
        
        // checking color set for Grouped Bars and legend dots
        if(options.colorSet === undefined){
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "one"){
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            options.colorSet = "two"
            colours = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            options.colorSet = "three"
            colours = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        }
        else
        {
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        
        
        var leftMar = 100/(setOfDataArray.length)
        
        var svgArray = [];
        var rectsGroupArray = [];
        var xAxisLabelsArray = [];
        var x0Array = [];
        var x1Array = [];
        var yArray = [];
        var monthsArrayForStkGrpBarChart = [];
        
        var yMaxValueArray = [];
        var maxArray = []
        for(var ii = 0; ii < options.keys.groupBars.length; ii++){
            maxArray = [];
            for(var jj = 0; jj < setOfDataArray.length; jj++){
                setOfDataArray[jj].forEach(function(d) { maxArray.push(+d[options.keys.groupBars[ii]])  })
            }
            yMaxValueArray.push(d3.max(maxArray))
			
        }
        
        //Adding svg for yAxis in Y-Axis div panel
        var svgPanelForYAxis = yAxisDivForStkGrpBarChart .append('svg').style("background-color", options.BGcolor)
        .style('border-color',"#e1e1e1") .style('border-style',"none") .style("position","absolute")
        .attr('width', 100 + "%") .attr('height', 100 + "%")
        .style("top",0 + "%").style("left",0 + "%").style("border","none").style("border","0px solid #e6e6e6").style("box-sizing","border-box") //.append('g')
        
        var margin = {top: 60 , right: 0, bottom: 80, left: svgPanelForYAxis.node().getBoundingClientRect().width - 1}, //originally top: 42, left: 80
        width = (svgPanelForYAxis.node().getBoundingClientRect().width) - margin.left - margin.right,
        height = svgPanelForYAxis.node().getBoundingClientRect().height - margin.top - margin.bottom;
        
        var yForYAxis = d3.scale.linear() .domain([0, d3.sum(yMaxValueArray)]) .range([height, 0]); // for margin.top: 35 d3.max(yMaxValueArray) * 1.31
        
        var yAxis = d3.svg.axis() .scale(yForYAxis) .ticks(5) .orient("left");
        
        var hasDecimalPoint = false;
        for(var i = 0; i < options.keys.groupBars.length; i++){
            for(var indx = 0; indx < setOfDataArray.length; indx++){
                for(var j = 0; j < setOfDataArray[indx].length; j++){
                    if(setOfDataArray[indx][j][options.keys.groupBars[i]].toString().indexOf('.') > -1){ hasDecimalPoint = true; break; }
                }
            }
        }
        
        if(hasDecimalPoint == false){ yAxis.tickFormat(d3.format(".2s")) }
        
        var svgForYAxis = svgPanelForYAxis.append("svg:g") .style("position","absolute").attr("transform", "translate(" + margin.left + "," + margin.top + ")");
        svgForYAxis.append("g") .attr("class", "y axis") .call(yAxis).selectAll("text") .style("fill","#00001c").style("font-family","Verdana,sans-serif");
        
        //Reverse the order of options.keys.labels
        options.keys.labels.reverse()
        
        commentsBtnForStkGrpBarChart.on('click', function() {
                                         
             if(options.showComments == false){
                 options.showComments = true;
             }
             else if(options.showComments == true){
                 options.showComments = false;
             }
             
             d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
             
             for(var i = 0; i<divAndChartsArray.length; i++){
             
                 if(targetElement[0][0].id === divAndChartsArray[i].divID){
                     options.data = divAndChartsArray[i].optionsData
                     options.showTable = false;
                 }
             }
             acinfotech.stackedGroupedBarChart(targetElement,options)
                                         
         })
        
        var iconButtonTooltipForStkGrpBarChart = targetElement.append('div').style('width','240px').attr("id","too")
        .style('height',"25px").style('position','absolute')//.style('margin-left', "0px").style('top','25px')
        .style("background-color",'#404040 ').style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid") // 004b9d
        .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none").attr("border", 0.0)
        
        commentsBtnForStkGrpBarChart.on('mousemove', function(d,i) {
             commentsPanelDivForStkGrpBarChart.style('background-color','#fafafa')
             var root = targetElement
             var m = d3.mouse(root.node());
             m[0] += 0
             m[1] += 0
             if(options.showComments == false){
             var commentButtonTooltipText = "Show Comments";
             }
             else if(options.showComments == true){
             var commentButtonTooltipText = "Hide Comments";
             }
             
             
             iconButtonTooltipForStkGrpBarChart.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
             iconButtonTooltipForStkGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ commentButtonTooltipText +'</div>')
         })
        commentsBtnForStkGrpBarChart.on('mouseout', function(d,i) {
             commentsPanelDivForStkGrpBarChart.style('background-color','#ffffff')
             iconButtonTooltipForStkGrpBarChart.style("display","none")
         })
        
        tableButtonForStkGrpBarChart.on('mousemove', function(d,i) {
             var root = targetElement
             var m = d3.mouse(root.node());
             m[0] += 0
             m[1] += 0
             if(showOrHideTableForStkGrpBarChart ==  false){
             var tableButtonTooltipText = "Show Table";
             }
             else if(showOrHideTableForStkGrpBarChart == true){
             var tableButtonTooltipText = "Hide Table";
             }
             
             
             iconButtonTooltipForStkGrpBarChart.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
             iconButtonTooltipForStkGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ tableButtonTooltipText +'</div>')
                                         
         })
        tableButtonForStkGrpBarChart.on('mouseout', function(d,i) {
             iconButtonTooltipForStkGrpBarChart.style("display","none")
        })
        
        downloadBtnForStkGrpBarChart.on('mousemove', function(d,i) {
              var root = targetElement
              var m = d3.mouse(root.node());
              m[0] += 0
              m[1] += 0
              var downloadButtonTooltipText = "Download";
              
              iconButtonTooltipForStkGrpBarChart.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
              iconButtonTooltipForStkGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
        })
        downloadBtnForStkGrpBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForStkGrpBarChart.style("display","none")
        })
        
        //---------------- creating tooltip ----------------
        var tooltipForStkGrpBarChart = targetElement .append('div') .attr('class', 'tooltipForStkGrpBarChartClass') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
        .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
        .style("padding-right", "7px") .style("background", "#ffffff") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style('z-index',1000)
        .style("border", "1.0px") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","80px")
        tooltipForStkGrpBarChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'tooltip-label1-class').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "14px") .style("font-weight", "normal");
        tooltipForStkGrpBarChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'tooltip-label2-class').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "14px") .style("font-weight", "normal");
        tooltipForStkGrpBarChart.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
        tooltipForStkGrpBarChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");
        
        if(options.keys.toolTipLabel.length > 0){
            
            for(toolTipInd = 0; toolTipInd < options.keys.toolTipLabel.length; toolTipInd++){
                tooltipForStkGrpBarChart.append('hr').style("height","1px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
                tooltipForStkGrpBarChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'tooltip-additional-label' + toolTipInd + '-class' ).style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");
            }
        }
        
        // ----------------- Shuffle panel and everything within it section begins here ----------------
        var shufflePanelForTwoXAxisesGrpBarChart = targetElement.append('div').style('width',350 + "px") .attr("class","shufflePanelForTwoXAxisesGrpBarChartClass" + targetElement[0][0].id)
        .style('position','absolute').style('margin-left', "0px")
        .style("background-color",'#fefefe').style("z-index",11).style("border-color", "#ffffff").style("border-right", "solid #e5e5e5 1px")  .style("border-style", "solid") // 004b9d
        .style("box-shadow", "2px 0px 1px #eff8ec").style("display","none").style("border-top", "solid #fdfdfd 1px").style("border-left","0px").style("border-bottom", "0px")
        .style('top', 0.0 + "%").style('height', 100 + "%").style('overflow-y',"hidden").style("overflow-x","hidden")
        .style("border-bottom", "solid #e5e5e5 1px") .style("box-sizing","border-box")
        
        var filterPanelTwoXAxisesGrpBarChartTitle = shufflePanelForTwoXAxisesGrpBarChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style("font-weight", "Bold")
        .style('margin-left','0px').style('margin-top','20px').style('text-indent','5px').style("font-size", "14px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #007aff").style("width","350px").style("color","#000000")
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; top:25.0%; font-size:16px; font-family:inter;  color:#585858; font-weight:Bold;">'+ "Shuffle" +'</div>')
        
        var dimensionsColumnTitle = shufflePanelForTwoXAxisesGrpBarChart.append("div") .style("width","170px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:14px; font-family:inter;  color:#606060; font-weight:Normal; text-align:left; text-indent:3px;">Bottom X-Axis, Top X-Axis.</div>');
        
        var dimensionsVariables = shufflePanelForTwoXAxisesGrpBarChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable1"+targetElement[0][0].id)
        .style("list-style-type","none")
        .style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '78px')
        .style('position','absolute')
        .style("width","332px").style("min-height","57px").style("max-height","57px").style("border", "#f0f0f0 1px solid")
        .style("max-width","332px").style("overflow-x","hidden").style("overflow-y","auto")
        dimensionsVariables.style("left",0.0 + "px").style("padding","2px").style("padding-top","7px")
        
        $( ".shufflePanelForTwoXAxisesGrpBarChartClass" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
             var e0 = e.originalEvent,
             delta = e0.wheelDelta || -e0.detail;
             
             this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
             e.preventDefault();
         });
        
        var optionsLabels = options.keys.labels;
        //var shuffle = optionsLabels[0]
        var reversedLabels = [];
        reversedLabels.push(optionsLabels[1])
        reversedLabels.push(optionsLabels[0])
        
        var dimensionsVariables1 = dimensionsVariables.selectAll("li") .data(reversedLabels).enter().append("li")
        .style("width","324px") .style("max-height","22px").style("cursor","move")
        .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#f8e9cd").style("font-weight","Normal")
        .style("list-style-type","none").style("border","1px #f2d199 solid").style("color","#9e6c14").style("font-family","Verdana,sans-serif")
        .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
        .text(function(d,i) {return reversedLabels[i]})
        dimensionsVariables1.attr("class","DimensionsClass"+targetElement[0][0].id)
        
        var cancelButton = shufflePanelForTwoXAxisesGrpBarChart.append("div") .style("width","23px").style("height","21px").style('position','absolute')
        .style('margin-left','320px').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white')
        .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.9; background-color:#fcfcff")
        cancelButton[0][0].appendChild(cancelBtnImgVar)
        
        cancelButton.on("click", function(){
            shufflePanelForTwoXAxisesGrpBarChart.style("display","none")
        })
        
        var reRenderChartAndTableButton = shufflePanelForTwoXAxisesGrpBarChart.append("button").style("width","120px").style("height","25px").style('position','absolute')
        .style('margin-left','112px').style('margin-top','185px') .style("border-style", "none").style('background-color',"#2196f3")
        .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','15px').style("border-style", "solid").style('color','#ffffff')
        .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 1px #9b9b9b").style("border-radius","0px")
        var textForReRenderButton = document.createTextNode("Apply Changes");
        reRenderChartAndTableButton[0][0].appendChild(textForReRenderButton)
        
        
        reRenderChartAndTableButton.on("click", function(){
                                       
               var shuffledDimensions = [];
               for(var i=0; i<$("#sortable1"+targetElement[0][0].id).children("li").length;i++){
                   shuffledDimensions.push($("#sortable1"+targetElement[0][0].id).children("li")[i].textContent)
               }
                 
               var newOptions = {
               data: options.data,
               keys: {
                   labels: shuffledDimensions.reverse(),
                   groupBars: options.keys.groupBars,
                   toolTipLabel: options.keys.toolTipLabel
               },
               chartTitle: options.chartTitle,
               xAxisLables: shuffledDimensions,
               //yAxisLable: options.yAxisLables,
               showTitle: options.showTitle,
               series:options.series,
               legend:options.legend,
               BGcolor:options.BGcolor,
               colorSet: options.colorSet, //"one" or "two" or "three";
               drillDownColumnName: options.drillDownColumnName,
               showComments: options.showComments,
               showTable: options.showTable,
               comments: options.comments,
               resizeButtonID: options.resizeButtonID
               
               }
               d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
               acinfotech.stackedGroupedBarChart(targetElement, newOptions)
               
           })
        
        $( "ul.droptrue"+targetElement[0][0].id ).sortable({
               appendTo: document.body,
               helper: "clone",
               connectWith: ".droptrue"+targetElement[0][0].id,
               scroll: false,
               cancel: '.unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+','+' .unMoveableIconAndTextClassDimensions'+targetElement[0][0].id,
               revertDuration: 10,
               scrollSensitivity: 10,
               scrollSpeed: 1,
               dynamic: true,
       });
        
        // ----------------- Shuffle panel and everything within it section ends here -----------------
        
        // Calling the shuffle panel on shuffle button click
        shuffleBtnForStkGrpBarChart.on('click', function() {
                                              
              ismenuButtonOfStkGrpBarChartClicked = false
              optionsButtonPanelForStkGrpBarChart.style("display","none") // Hiding options buttons panel
              iconButtonTooltipForStkGrpBarChart.style("display","none") // Hiding options tool-tip
                                              
            shufflePanelForTwoXAxisesGrpBarChart.style("display","block");
        })
        
        // Refreshing Chart and Table
        refreshBtnForStkGrpBarChart.on('click', function() {
                                                
            //isFilterClicked = false
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){
                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData;
                    options.keys.labels = newtargetElementAndOptionsArray[i].options.keys.labels;
                }
            }
            acinfotech.stackedGroupedBarChart(targetElement,options)
            
        })
        
        // showing/hidding chart table
        tableButtonForStkGrpBarChart.on('click', function() {
                                         
             if(showOrHideTableForStkGrpBarChart == false){
                 options.showTable = true;
             }
             else if(showOrHideTableForStkGrpBarChart == true){
                options.showTable = false;
             }
             
             d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
             
             for(var i = 0; i<divAndChartsArray.length; i++){
             
                 if(targetElement[0][0].id === divAndChartsArray[i].divID){
                     options.data = divAndChartsArray[i].optionsData
                     
                     if(newtargetElementAndOptionsArray[i].options.keys.groupBars == undefined){
                         options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.stackedAreas;
                     }
                     else {
                         options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.groupBars;
                     }
                     
                     options.showComments = false;
                 }
             }
             acinfotech.stackedGroupedBarChart(targetElement,options)
                                         
         })
        
        downloadBtnForStkGrpBarChart.on('click', function() {
                                  
              ismenuButtonOfStkGrpBarChartClicked = false; // Changing menu button value to false
              optionsButtonPanelForStkGrpBarChart.style("display","none") // Hiding option buttons panel
                                  
        })
        
        shuffleBtnForStkGrpBarChart.on('mousemove', function(d,i) {
            var root = targetElement
            var m = d3.mouse(root.node());
            m[0] += 0
            m[1] += 0
            var filterButtonTooltipText = "Shuffle";
            
            iconButtonTooltipForStkGrpBarChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForStkGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')
            
        })
        shuffleBtnForStkGrpBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForStkGrpBarChart.style("display","none")
        })
        
        refreshBtnForStkGrpBarChart.on('mousemove', function(d,i) {
            var root = targetElement
            var m = d3.mouse(root.node());
            m[0] += 0
            m[1] += 0
            var refreshButtonTooltipText = "Refresh";
            
            iconButtonTooltipForStkGrpBarChart.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForStkGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center; ">'+ refreshButtonTooltipText +'</div>')
            
        })
        refreshBtnForStkGrpBarChart.on('mouseout', function(d,i) {
            iconButtonTooltipForStkGrpBarChart.style("display","none")
        })
        
        menuButtonForStkGrpBarChart.on('mousemove', function(d,i) {
           var root = targetElement
           var m = d3.mouse(root.node());
           m[0] += 0
           m[1] += 0
           var menuButtonTooltipText = "Menu";
           
           iconButtonTooltipForStkGrpBarChart.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
           iconButtonTooltipForStkGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center; ">'+ menuButtonTooltipText +'</div>')
                                       
        })
        menuButtonForStkGrpBarChart.on('mouseout', function(d,i) {
           iconButtonTooltipForStkGrpBarChart.style("display","none")
        })
        
        /*searchChartButton.on('mousemove', function(d,i) {
             var root = targetElement
             var m = d3.mouse(root.node());
             m[0] += 0
             m[1] += 0
             var searchChartButtonTooltipText = "Search in Chart";
         
             iconButtonTooltipForStkGrpBarChart.style("width","110px").style("margin-left", (m[0] - 120) + "px").style("margin-top",(m[1]) + "px").style("display","block")
             iconButtonTooltipForStkGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ searchChartButtonTooltipText +'</div>')
         })
        searchChartButton.on('mouseout', function(d,i) {
             iconButtonTooltipForStkGrpBarChart.style("display","none")
         })
        
        searchTableButton.on('mousemove', function(d,i) {
             var root = targetElement
             var m = d3.mouse(root.node());
             m[0] += 0
             m[1] += 0
             var searchTableButtonTooltipText = "Search in Table";
         
             iconButtonTooltipForStkGrpBarChart.style("width","110px").style("margin-left", (m[0] - 120) + "px").style("margin-top",(m[1]) + "px").style("display","block")
             iconButtonTooltipForStkGrpBarChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ searchTableButtonTooltipText +'</div>')
         })
        searchTableButton.on('mouseout', function(d,i) {
             iconButtonTooltipForStkGrpBarChart.style("display","none")
         })*/
        
        var xMaxArray = []
        
        for(var ind = 0; ind < setOfDataArray.length; ind++){
            
            var finalArrayNew = [];
            options.keys.groupBars.forEach(function(d, i) { var temp1 = {}; temp1["name"] = options.keys.groupBars[i]; finalArrayNew.push(temp1); })
            
            var finalNewNewArray = [];
            var dataArray1 = [];
            finalArrayNew.forEach(function(d, i) {
                                  
                  var temp1 = {};
                  temp1["name"] = options.keys.groupBars[i]
                  
                  for (j = 0; j < setOfDataArray[ind].length; j++) {
                  
                      var tempTemp = {};
                      tempTemp["label"] = setOfDataArray[ind][j][options.keys.labels[0]];
                      tempTemp["value"] = +setOfDataArray[ind][j][options.keys.groupBars[i]];
                      
                      dataArray1.push(tempTemp)
                  }
                  
                  temp1["data"] = dataArray1;
                  dataArray1 = []
                  finalNewNewArray.push(temp1)
              })
            
            var dataset = finalNewNewArray,
            series = dataset.map(function (d) { return d.name; }),
            dataset = dataset.map(function (d) { return d.data.map(function (o, index) { return { y: o.value, x: o.label}; }); }),
            stack = d3.layout.stack();
            
            stack(dataset);
            
            var dataset = dataset.map(function (group) { return group.map(function (d) { return { x: +d.y, y: d.x, x0: +d.y0 }; }); }),
            
            xMax = d3.max(dataset, function (group) { return d3.max(group, function (d) { return (+d.x) + (+d.x0); }); })
            
            xMaxArray.push(xMax)
            
        } // for(var ind = 0; ind < setOfDataArray.length; ind++) Creating SVGs for loop
        
		for(var ind = 0; ind < setOfDataArray.length; ind++){
            
            //Creating SVG Div holder for chart
            var svgDivPanelForStkGrpBarChart = chartDivForStkGrpBarChart .append('div') .style("position","absolute").style("left",function(d,index){ return (leftMar * ind )+ "%"; })
            .style("top",0 + "%").style('width', (100/(setOfDataArray.length)) + "%").style('height', 100 + "%").style("background-color", options.BGcolor)
            .style("border","none").style("border-right","0px solid #e6e6e6").style("box-sizing","border-box")
            
            //Creating SVG holder for chart
            var svgPanelForStkGrpBarChart = svgDivPanelForStkGrpBarChart .append('svg') .style("position","absolute").style("left",function(d,index){ return 0 + "%"; })
            .style("top",0 + "%").attr('width', 101 + "%").attr('height', 100 + "%").style("background-color", options.BGcolor)
            .style("border-right","0px solid #e6e6e6").style("box-sizing","border-box") //.append('g')
            
            var margin = {top: 60 , right: 0, bottom: 80, left: -1}, //originally top: 42, left: 80
            width = (svgPanelForStkGrpBarChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = svgPanelForStkGrpBarChart.node().getBoundingClientRect().height - margin.top - margin.bottom;
            
            var finalArrayNew = [];
            options.keys.groupBars.forEach(function(d, i) {
                                             
                 var temp1 = {};
                 temp1["name"] = options.keys.groupBars[i]
                 
                 finalArrayNew.push(temp1)
             })
            
            var finalNewNewArray = [];
            var dataArray1 = [];
            finalArrayNew.forEach(function(d, i) {
                                  
                  var temp1 = {};
                  temp1["name"] = options.keys.groupBars[i]
                  
                  for (j = 0; j < setOfDataArray[ind].length; j++) {
                  
                      var tempTemp = {};
                      tempTemp["label"] = setOfDataArray[ind][j][options.keys.labels[0]];
                      tempTemp["value"] = +setOfDataArray[ind][j][options.keys.groupBars[i]];
                      
                      dataArray1.push(tempTemp)
                  }
                  
                  temp1["data"] = dataArray1;
                  dataArray1 = []
                  finalNewNewArray.push(temp1)
              })
            
            var dataset = finalNewNewArray,
            series = dataset.map(function (d) { return d.name; }),
            dataset = dataset.map(function (d,outterIndex) {
                  return d.data.map(function (o, index) {
                        // Structure it so that your numeric
                        // axis (the stacked amount) is y
                        return {
                            y: o.value,
                            x: o.label,
                            rectTopLabel: setOfDataArray[ind][index][options.keys.labels[1]], // additionally added
                            rectBottomLabel: setOfDataArray[ind][index][options.keys.labels[0]], // additionally added
                            rectColor: colours(outterIndex), // additionally added
                            rectName: d.name, // additionally added
                            rectValue: o.value, // additionally added
                            groupIndex: ind // additionally added*/
                        };
                    });
              }),
            stack = d3.layout.stack();
            
            stack(dataset);
            
            var dataset = dataset.map(function (group,outterIndex) {
                                      return group.map(function (d, index) {
                   // Invert the x and y values, and y0 becomes x0
                                                       
                   return {
                   x: +d.y,
                   y: d.x,
                   x0: +d.y0,
                               rectTopLabel: setOfDataArray[ind][index][options.keys.labels[1]], // additionally added
                               rectBottomLabel: setOfDataArray[ind][index][options.keys.labels[0]], // additionally added
                               rectColor: colours(outterIndex), // additionally added
                               rectName: d.rectName, // additionally added
                               rectValue: d.rectValue,
                               groupIndex: ind // additionally added
                   };
               });
              }),
            
            months = dataset[0].map(function (d) { return d.y; })
            
            monthsArrayForStkGrpBarChart.push(months)
            
            var xAxisLabels = dataset[0].map(function (d) { return d.y; });
            
            var y = d3.scale.linear() .domain([0, d3.sum(yMaxValueArray)]) .range([0, height]);
            
            var x0 = d3.scale.ordinal() .domain(months) .rangeRoundBands([0, width], 0.08,0.35); // originally 0.25
            
            var x1 = d3.scale.ordinal() .domain(d3.range(finalNewNewArray.length)) .rangeBands([0, x0.rangeBand()]);
            
            var xAxis = d3.svg.axis() .scale(x0) .orient("bottom");
            
            var svg = svgPanelForStkGrpBarChart.append("svg").append("g") .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            svg.append('g') .attr("class", "x axis bottomclass") .attr('transform', 'translate(0,' + height + ')') .call(xAxis)
            
            .selectAll("text").data(xAxisLabels) .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c')
            .attr("transform", function(d) { return "rotate(-50)" }) .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
            .text(function(d,i) { if(d.length > 9){ return d.substring(0,9)+'...'; } else { return d; } })
            
            var groups = svg.append("g").selectAll("g") .data(dataset)
            
			var groups1 = groups.enter().append("g").attr("class","each-bargrouped-class").style("fill", function(d, i) { return colours(i); })
            .selectAll("rect").data(function(d) { return d; }).enter().append("rect")
			.attr("x", function(d, i) {   return x0(d.y); })
			.attr("width", x0.rangeBand())
			.attr("y", function (d) { return height; })
			.attr("height", function (d) { return 0; })
			.transition() .delay(400) .duration(800)
			.attr("y", function(d) { return  height - y(d.x0) - y(d.x); })
			.attr("height", function (d) { return y(d.x); }).style("cursor","auto")
            
            //-------------------- Drill down --------------------
            var columnNames = d3.keys(options.data[0])
            var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
            
            for(var i = 0; i < columnNames.length ; i++){
                for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                    if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                        for(var k = 0; k < options.keys.groupBars.length; k++){
                            var len = d3.select(groups[0][k]).selectAll('rect')
                            for(var l = 0; l < len[0].length; l++){
                                d3.select(len[0][l]).attr('data-drilldownkey', function(d,index){
                                      return JSON.stringify(setOfDataArray[ind][l]).slice(1, -1).split('"').join("").split(':').join("|")
                                })
                            }
                        }
                    }
                    else {
                    }
                }
            }
            //-----------------------------------------------------
            
            var yTextPadding = 10;
            var format1 = d3.format('.2s')
            var textOnStackedBarChart = groups.selectAll(".text") .data(function (d) { return d; })
            
            textOnStackedBarChart.attr("class","text series_value").style('display','block')

            
            textOnStackedBarChart .transition() .duration(250) .style("text-anchor", "middle")
            .attr("x", function(d,i) { return x0(d.y) + x0.rangeBand()/2; })
			.attr("y", function (d) { return height; })
			.transition() .delay(400) .duration(800)
			.attr("y", function(d) { return (height - y(d.x0) - y(d.x))+(y(d.x)/1.5);}) .style("font-family", "Verdana,sans-serif")
			.style("font-size", "12px") .style("fill", "#ffffff") .style("text-shadow","1px 0px 1px rgba(34,34,34,0.6)")
			.text(function(d){
                if(d.x.toString().indexOf('.') === -1)
				{
					if(d.x.toString().length <= 3){ return d.x; }
					else { return format1(d.x) }
				}
				else{
					return d.x.toString();
				}
            })
            
            var x2 = d3.scale.ordinal() .domain(setOfDataArray[ind].map(function(d) { return d[options.keys.labels[1]]; })) .rangeRoundBands([0, width], 0.25);
            var xAxisTop = d3.svg.axis() .scale(x2) .orient("top")
            
            // Adding the Top X Axis
            var topAxis = svg.append("g").attr("class", "x axis topclass").attr("transform", "translate(0," + -25 + ")") .call(xAxisTop)
            
            // Add the Top X Axis margin labels
            .selectAll("text") .style("text-anchor", "end") .style('fill','#00001c') .attr("transform", function(d) { return "rotate(0)" })
            .style("font-size","12px").style("font-family","Verdana,sans-serif") .style('text-anchor','middle')
            .style("font-family","Verdana,sans-serif").style("font-weight","Bold")
            .text(function(d,i) { if(d.length > 9) return d.substring(0,9)+'...'; else return d; })
            
            groups.selectAll('text').on('mousemove', function (d,i){
                                         
                 var root = targetElement
                 var m = d3.mouse(root.node());
                 m[0] += 0
                 m[1] += 0
                 
                 var valueForGrpBarChartToolTip;
                 if(d.y.toString().indexOf('.') === -1)
                 {
                     valueForGrpBarChartToolTip = d.rectValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                 }
                 else{
                     valueForGrpBarChartToolTip = d.rectValue;
                 }
                 
                tooltipForStkGrpBarChart.select('.tooltip-label1-class').html(options.keys.labels[1] + " : " + d.rectTopLabel)
                tooltipForStkGrpBarChart.select('.tooltip-label2-class').html(options.keys.labels[0] + " : " + d.rectBottomLabel)
                tooltipForStkGrpBarChart.select('.count').html(d.rectName + " : " + valueForGrpBarChartToolTip)
                tooltipForStkGrpBarChart.style('visibility', 'visible')
                tooltipForStkGrpBarChart.select('hr').style("background-color", d.rectColor)
                tooltipForStkGrpBarChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-20) + "px").style("display","block")
                                        
                if(options.keys.toolTipLabel.length > 0){
                    for(ind = 0; ind < options.keys.toolTipLabel.length; ind++){
                        tooltipForStkGrpBarChart.select('.tooltip-additional-label' + ind + '-class')
                        .html(options.keys.toolTipLabel[ind] + " : " + setOfDataArray[d.groupIndex][i][options.keys.toolTipLabel[ind]])
                    }
                }
                                        
            })
            .on('mouseout', function(){ tooltipForStkGrpBarChart.style("display","none") })
            
            groups.selectAll('rect').on('mousemove', function (d,i){
                   
                var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                
                var valueForGrpBarChartToolTip;
                if(d.y.toString().indexOf('.') === -1)
                {
                    valueForGrpBarChartToolTip = d.rectValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
                else{
                
                    valueForGrpBarChartToolTip = d.rectValue;
                }
                    
                tooltipForStkGrpBarChart.select('.tooltip-label1-class').html(options.keys.labels[1] + " : " + d.rectTopLabel)
                tooltipForStkGrpBarChart.select('.tooltip-label2-class').html(options.keys.labels[0] + " : " + d.rectBottomLabel)
                tooltipForStkGrpBarChart.select('.count').html(d.rectName + " : " + valueForGrpBarChartToolTip)
                tooltipForStkGrpBarChart.style('visibility', 'visible')
                tooltipForStkGrpBarChart.select('hr').style("background-color", d.rectColor)
                tooltipForStkGrpBarChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-20) + "px").style("display","block")
                                        
                if(options.keys.toolTipLabel.length > 0){
                    for(ind = 0; ind < options.keys.toolTipLabel.length; ind++){
                        tooltipForStkGrpBarChart.select('.tooltip-additional-label' + ind + '-class')
                        .html(options.keys.toolTipLabel[ind] + " : " + setOfDataArray[d.groupIndex][i][options.keys.toolTipLabel[ind]])
                    }
                }
                                        
            })
            .on('mouseout', function(){ tooltipForStkGrpBarChart.style("display","none") })
            
            svgArray.push(svgPanelForStkGrpBarChart)
            rectsGroupArray.push(groups)
            xAxisLabelsArray.push(xAxisLabels)
            
            x0Array.push(x0)
            x1Array.push(x1)
            yArray.push(y)
            
            var xScale1GlobalVar; // storing the new yScale when parent div is resized.
            var yScale1GlobalVar; // storing the new yScale when parent div is resized.
            var newHeightVar; // storing the new height when parent div is resized.
            
            window.addEventListener('resize', function(event){  resizedFuctionForStkGrpBarChart()   });
            
            $(function() {
              $("#" + targetElement[0][0].id).resizable({
                    resize: function(event, ui) {
                            divWidth = ui.size.width;
                            divHeight = ui.size.height;
                            resizedFuctionForStkGrpBarChart();
                    }
                });
            });
            
            function resizedFuctionForStkGrpBarChart()
            {
                
                if((svgPanelForYAxis.node().getBoundingClientRect().width) && (svgPanelForYAxis.node().getBoundingClientRect().height) > 0){
                    var marginsForYAxis = {top: 60 , right: 0, bottom: 80, left: svgPanelForYAxis.node().getBoundingClientRect().width - 1}, //originally top: 42, left: 80
                    widthsForYAxis = (svgPanelForYAxis.node().getBoundingClientRect().width) - marginsForYAxis.left - marginsForYAxis.right,
                    heightsForYAxis = (svgPanelForYAxis.node().getBoundingClientRect().height) - marginsForYAxis.top - marginsForYAxis.bottom;
                    
                    yForYAxis.domain([0, d3.sum(yMaxValueArray)]) .range([heightsForYAxis, 0]); // for margin.top: 35 d3.max(yMaxValueArray) * 1.31
                    yAxis.scale(yForYAxis) .orient("left");
                    
                    svgPanelForYAxis.select("g") .attr("transform", "translate(" + marginsForYAxis.left + "," + marginsForYAxis.top + ")").style("position","absolute")
                    .call(yAxis)
                }
                
                if((svgPanelForStkGrpBarChart.node().getBoundingClientRect().width) && (svgPanelForStkGrpBarChart.node().getBoundingClientRect().height) > 0){
                    
                    if(showOrHideCommentsBtnForStkGrpBarChart == true){
                        shuffleBtnForStkGrpBarChart.style('margin-left', "2px")
                        refreshBtnForStkGrpBarChart.style('margin-left', "2px")
                        commentsBtnForStkGrpBarChart.style('margin-left', "2px")
                        menuButtonForStkGrpBarChart.style('right', '0')
                    }
                    else if(showOrHideCommentsBtnForStkGrpBarChart == false){
                        shuffleBtnForStkGrpBarChart.style('margin-left', "2px")
                        refreshBtnForStkGrpBarChart.style('margin-left', "2px")
                        commentsBtnForStkGrpBarChart.style('display','none')
						menuButtonForStkGrpBarChart.style('right', '0')
                    }
                    
                    optionsButtonPanelForStkGrpBarChart.style('right', '0')
                    
                    for(var j = 0; j < svgArray.length; j++){
                        var s = d3.select(svgArray[j][0][0])
                        var ss = svgArray[j][0][0]
                        
                        var margin1 = {top: 60 , right: 0, bottom: 80, left: -1}, //originally top: 42, left: 80
                        width1 = (svgPanelForStkGrpBarChart.node().getBoundingClientRect().width) - margin1.left - margin1.right,
                        height1 = svgPanelForStkGrpBarChart.node().getBoundingClientRect().height - margin1.top - margin1.bottom;
                        newHeightVar = height1;
                        
                        y.domain([0, d3.max(xMaxArray)]) .range([0, height1]);
                        
                        x0 .domain(monthsArrayForStkGrpBarChart[j]) .rangeRoundBands([0, width1], 0.08,0.35);
                        
                        x1.domain(d3.range(finalNewNewArray.length)) .rangeBands([0, x0.rangeBand()]);
                        
                        xAxis.scale(x0) .orient("bottom");
                        
                        xScale1GlobalVar = x0;
                        yScale1GlobalVar = y;
                        
                        var svg1 = s
                        
                        d3.select(svgArray[j][0][0]).select("svg").select(".x.axis.bottomclass") .attr('transform', 'translate(0,' + height1 + ')') .call(xAxis)
                        .selectAll("text").data(xAxisLabelsArray[j]) .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') .attr("transform", function(d) { return "rotate(-50)" })
                        .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
                        .text(function(d,i) {
                              if(d.length > 9){
                                return d.substring(0,9)+'...';
                              }
                              else{
                                return d;
                              }
                        })
                        
                        x2.domain(setOfDataArray[j].map(function(d) { return d[options.keys.labels[1]]; })) .rangeRoundBands([0, width1], 0.25);
                        
                        xAxisTop.scale(x2) .orient("top")
                        
                        d3.select(svgArray[j][0][0]).select("svg").select(".x.axis.topclass").attr("transform", "translate(0," + -25 + ")") .call(xAxisTop)
                        
                        var groupsArray = [];
                        
                        var grp = rectsGroupArray[j][0]
                        
                        for(var ii = 0; ii < grp.length; ii++){
                            
                            d3.select(grp[ii]).selectAll("rect").data(function(d,i) { groupsArray[ii] = x1(ii); return d; })
                            .attr("width", x0.rangeBand())
                            .attr("height", function (d) { return y(d.x); })
                            .attr("x", function(d, i) {   return x0(d.y); })
                            .attr("y", function(d) { return  height1 - y(d.x0) - y(d.x); })
                            
                            d3.select(grp[ii]).selectAll("text") .attr("x", function(d,i) { return x0(d.y) + x0.rangeBand()/2; })
                            .attr("y", function(d) { return (height1 - y(d.x0) - y(d.x))+(y(d.x)/1.5);})
                            
                        }
                        
                        // Aligning Legend (vertically)
                        var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(legendDivForStkGrpBarChart[0][0].style.width) / 100)
                        var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(legendDivForStkGrpBarChart[0][0].style.height) / 100)
                        
                        var legendRectSize = 11;
                        var legendSpacing = 4;
                        
                        legend.transition().duration(0).attr('transform', function(d, i) {
                                 var eachRectHeight = legendRectSize + legendSpacing;
                                 var offset =  eachRectHeight * colours.domain().length / 2;
                                 var horz = 5;
                                 var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.groupBars.length))/2.0; // originally 2.0
                                 
                                 return 'translate(' + horz + ',' + vert + ')';
                         })
                        
                        
                    } // svgArrary for loop
                    
                    colWidth = []; 
					
                    d3.select(".theadClassForStkGrpBarChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                       d.forEach(function(dd,j){
                                 colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                         })
                    })
                    tablePanelForStkGrpBarChart.select(".thead1ClassForStkGrpBarChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                         d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
                    })
                    
                } // checking svgPanelForColumnChart width & height panel size function ends here.
            } // resizedFuctionForStkGrpBarChart
            
        } // for(var ind = 0; ind < setOfDataArray.length; ind++) Creating SVGs for loop
        
        
        //-------------- Adding legend section ---------------
        var legendPanelSVGForStackedBarChart = legendDivForStkGrpBarChart .append('svg')  .attr("class","")
        .style("background-color", options.BGcolor).style('position',"absolute").style('width', 100 + "%") .style('height', 100 + "%") .style("left",0 + "%").style("top",0 + "%")
        
        var legend = legendPanelSVGForStackedBarChart.append("g") .attr("class", "legend") .attr("height", "100%") .attr("width", "100%")
        .attr('transform', 'translate(0,20)')
        
        //Create colour squares
        var legendGroup = legend.selectAll('rect') .data(options.keys.groupBars) .enter() .append("rect") .attr("x", 5)
        .attr("y", function(d, i){ return i * 16;}) .attr("width", 14) .attr("height", 14) .attr("rx",10) .attr("ry",10)
        .style("fill", function(d, i){ return colours(i);}) .style("cursor","auto")
        
        //Create text next to squares
        legend.selectAll('text') .data(options.keys.groupBars) .enter() .append("text") .attr("x", 25) .attr("y", function(d, i){ return i * 16 + 11.8;})
        .attr("fill", "#00001c") .text(function(d,i) {  if(d.length > 10)
            return d.substring(0,10)+'...';
            else
            return d; }) .style('font-size', '14px') .attr("fill","#00001c") .style("font-family","Verdana,sans-serif")
        
        // Aligning Legend (vertically)
        var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(legendDivForStkGrpBarChart[0][0].style.width) / 100)
        var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(legendDivForStkGrpBarChart[0][0].style.height) / 100)
        
        var legendRectSize = 11;
        var legendSpacing = 4;
        
        legend.transition().duration(0).attr('transform', function(d, i) {
             var eachRectHeight = legendRectSize + legendSpacing;
             var offset =  eachRectHeight * colours.domain().length / 2;
             var horz = 5;
             var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.groupBars.length))/2.0; // originally 2.0
             
             return 'translate(' + horz + ',' + vert + ')';
         })

        legendGroup.on('mouseover',function(d,index){
                       
           if(options.keys.groupBars.length > 1){ // To check if the stack set is more than 1
           
           // To check whether the widget is being resized or not (to save new xScale)
           if(yScale1GlobalVar == undefined){ yScale1GlobalVar = y; }
           
           if(newHeightVar == undefined){ newHeightVar = height }
           
               for(var i = 0; i<rectsGroupArray.length; i++){
                   var grp = rectsGroupArray[i][0]
                   for(var ii = 0; ii < grp.length; ii++){
                       
                       d3.select(grp[ii]).selectAll("text").style('display','none')
                       
                       d3.select(grp[index]).selectAll("text").style('display','block')
                       .transition().duration(1000).ease('bounce').attr("y", function(d,i) { return (newHeightVar - yScale1GlobalVar(d.x) - 6) })
                       .style("fill", "#00001c") .style("text-shadow","0px 0px 0px rgba(34,34,34,0.6)") .style('font-size',"12px")
                       
                       d3.select(grp[ii]).selectAll("rect").style('display','none')
                       
                       d3.select(grp[index]).selectAll('rect').style('display','block')
                       .transition().duration(1000).ease('bounce')
                       .attr("y", function(d,i) { return newHeightVar - yScale1GlobalVar(d.x) })
                   }
               }
                       
           }
        })
        
        legendGroup.on('mouseout',function(d,index){
                       
           if(yScale1GlobalVar == undefined){ yScale1GlobalVar = y; }
           
           if(newHeightVar == undefined){ newHeightVar = height; }
           
            for(var i = 0; i<rectsGroupArray.length; i++){
                   var grp = rectsGroupArray[i][0]
                   for(var ii = 0; ii < grp.length; ii++){
                       
                       d3.select(grp[ii]).selectAll("text").style('display','block')
                       
                       d3.select(grp[index]).selectAll("text").style('display','block').transition().duration(1000).ease('bounce')
                       .attr("y", function(d) { return (newHeightVar - yScale1GlobalVar(d.x0) - yScale1GlobalVar(d.x))+(yScale1GlobalVar(d.x)/1.5);})
                       .style("fill", "#ffffff") .style("text-shadow","1px 0px 1px rgba(34,34,34,0.6)") .style('font-size',"12px")
                       
                       d3.select(grp[ii]).selectAll("rect").style('display','block')
                       
                       d3.select(grp[index]).selectAll('rect').style('display','block').transition().duration(1000).ease('bounce')
                       .attr("y", function(d) { return  newHeightVar - yScale1GlobalVar(d.x0) - yScale1GlobalVar(d.x); })
                    }
               }
        })
        
        // ----------------------- adding table section ------------------
        var tablePanelForStkGrpBarChart =  targetElement.append("div") .attr("id",targetElement[0][0].id + "holderForStkGrpBarChartTableID")
        .attr("class","scrollingDivForTable-Class tableDivForStkGrpBarChart" + targetElement[0][0].id) .style('background-color',"#ffffff") .style('position','absolute')
        .style("display","block") .style("overflow","hidden") .style("width", function(d) {  return 100.0 + "%"; })
        .style("height", function(d) { return 30 + "%"; }) .style("left",0 + "%").style("z-index",10)
        
        $( '.scrollingDivForTable-Class').bind( 'mousewheel DOMMouseScroll', function ( e ) {
                    var e0 = e.originalEvent,
                    delta = e0.wheelDelta || -e0.detail;
                    
                    this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
                    e.preventDefault();
            });
        
        if(options.showTitle == true ){
            tablePanelForStkGrpBarChart.style("top",70.0  + "%")
        }
        else if(options.showTitle == false  ){
            tablePanelForStkGrpBarChart.style("top",70.0  + "%")
            
        }
        tablePanelForStkGrpBarChart.html('<table class = "tableClassForStkGrpBarChart' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                          '<thead class = "theadClassForStkGrpBarChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForStkGrpBarChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                                          '<tbody class = "tBodyClassForStkGrpBarChart' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                          '</table>'
                                          )
        
        tablePanelForStkGrpBarChart.select('table').attr("id",targetElement[0][0].id + "tableID")
        
        // Show or Hide Table scroll bar when mouseover on widget
        targetElement.on('mouseover',function(){ tablePanelForStkGrpBarChart.style("overflow","auto") })
        targetElement.on('mouseout',function(d){ tablePanelForStkGrpBarChart.style("overflow","hidden") })
        
        //var tableDataForStkGrpBarChart = [];
        //if(options.dataForTable.length > 0) { tableDataForStkGrpBarChart = options.dataForTable; }
        //else { tableDataForStkGrpBarChart = options.data; }
        
        tableDataForStkGrpBarChart = options.data;
        
        var thead = tablePanelForStkGrpBarChart.select("thead").selectAll("th") .data(d3.keys(tableDataForStkGrpBarChart[0]))
        .enter().append("th") .text(function(d){return d.charAt(0) .toUpperCase() + d.substr(1)}) .style("cursor","pointer") .style("min-width","100px")
        
        var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff") //f4f4f4
        .style("position","relative")
        
        var thead1 = d3.select(".thead1ClassForStkGrpBarChart" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tableDataForStkGrpBarChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff") //f4f4f4
        .style("position","relative")
        
        var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
        .attr("id", "ascendingIconIDForStkGrpBarChart") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
        
        var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
        .attr("id", "descendingIconIDForStkGrpBarChart") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
        
        var tr = tablePanelForStkGrpBarChart.select("tbody").selectAll("tr") .data(tableDataForStkGrpBarChart).enter().append("tr")
        .attr("id", function(d,i) { return "slice" + i })
        
        // cells
        var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d})
        .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
        
        var $table = $('.tableClassForStkGrpBarChart' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
        
        d3.select(".theadClassForStkGrpBarChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
            d.forEach(function(dd,j){
              colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
          })
        })
        
        $(".thead1ClassForStkGrpBarChart" + targetElement[0][0].id).insertAfter('.tBodyClassForStkGrpBarChart' + targetElement[0][0].id)
        
        $(".thead1ClassForStkGrpBarChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForStkGrpBarChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
        
        tablePanelForStkGrpBarChart.select(".thead1ClassForStkGrpBarChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
               d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
               })
        
        $('.tableDivForStkGrpBarChart' + targetElement[0][0].id).scroll(function () {
                                                                         
             $(".thead1ClassForStkGrpBarChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForStkGrpBarChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
             
             })
        
        var sortOrder = false;
        thead1.on("click",function(k,index){
                  
                  sortOrder = !sortOrder;
                  
                  tablePanelForStkGrpBarChart.select(".thead1ClassForStkGrpBarChart" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                                                                                                                                      
                      if (sortOrder) {
                      
                      if(i == index){
                      d3.select(this).select('svg').select('#descendingIconIDForStkGrpBarChart').style("visibility", "hidden")
                      d3.select(this).select('svg').select('#ascendingIconIDForStkGrpBarChart').style("visibility", "visible")
                      }
                      else {
                      d3.select(this).select('svg').select('#descendingIconIDForStkGrpBarChart').style("visibility", "visible")
                      d3.select(this).select('svg').select('#ascendingIconIDForStkGrpBarChart').style("visibility", "visible")
                      }
                      }
                      else{
                      
                      if(i == index){
                      d3.select(this).select('svg').select('#descendingIconIDForStkGrpBarChart').style("visibility", "visible")
                      d3.select(this).select('svg').select('#ascendingIconIDForStkGrpBarChart').style("visibility", "hidden")
                      }
                      else {
                      d3.select(this).select('svg').select('#descendingIconIDForStkGrpBarChart').style("visibility", "visible")
                      d3.select(this).select('svg').select('#ascendingIconIDForStkGrpBarChart').style("visibility", "visible")
                      }
                      }
                  })
                  
                  
                  var monthTruOrFalAryForStkGrpBarChart = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
                  
                  tr.sort(function(a, b) {
                          
                          if (sortOrder) {
                          var monthsArrayForStkGrpBarChart = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                          } else {
                          var monthsArrayForStkGrpBarChart = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                          }
                          
                          monthTruOrFalAryForStkGrpBarChart = []; gotMonthArray = [];
                          tableDataForStkGrpBarChart.forEach(function(d,i){
                                      var da = d[k].toString().substring(0,3).toLowerCase()
                                      if(monthsArrayForStkGrpBarChart.indexOf(da) >= 0){
                                      monthTruOrFalAryForStkGrpBarChart.push(true)
                                      gotMonthArray.push(da);
                                      }
                                      else {
                                      monthTruOrFalAryForStkGrpBarChart.push(false)
                                      }
                          })
                          
                          if(monthTruOrFalAryForStkGrpBarChart.indexOf(false) == -1){ // true
                          
                          monthArray = []; monthArrayCount = [];
                          gotMonthArray.forEach(function(dd,j){
                                                var index1 = monthsArrayForStkGrpBarChart.indexOf(dd.substring(0,3))
                                                if(monthArrayCount.indexOf(index1) >= 0){
                                                index1 = 12 + index1;
                                                }
                                                monthArray.push(index1);
                                                monthArrayCount.push(index1)
                                                })
                          returnArray = []
                          monthArray.sort(function(aa, bb) {
                                          returnArray.push(+aa - +bb)
                                          return +aa - +bb;
                                          })
                          
                          sortTableFunc()
                          return returnArray[ind++];
                          } //  if true (if jan feb if block)
                          else {
                          var data = +a[k];
                          
                          if(!isNaN(data)){
                          
                          if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                          else { return d3.descending(+a[k], +b[k]); }
                          }
                          else if(!isNaN(Date.parse(a[k]))){
                          
                          if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                          else { return new Date(b[k]) - new Date(a[k]) }
                          }
                          else {
                          
                          if (sortOrder) { return d3.ascending(a[k], b[k]); }
                          else { return d3.descending(a[k], b[k]); }
                          }
                          } // if not jan feb else block
                          }); // tr
                  
		})
        
        function sortTableFunc(){
            
            var table = tablePanelForStkGrpBarChart.select('table');
            var rows = table.selectAll('tr').data(tableDataForStkGrpBarChart);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0).style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500)
            .style('opacity', 1.0).style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
        }
        
        // Main Table Styling
        tablePanelForStkGrpBarChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
        .style("color","#00001c")
        .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4") //.style("box-shadow","10px 10px 50px #007aff").style("z-index",9999)
        tablePanelForStkGrpBarChart.selectAll('td').style("height","25px") .style("border", "1px solid #dddddd") .style("font-size","12px").style("font-weight","Normal").style("color","#00001c")
        
        //additionally 
        tablePanelForStkGrpBarChart.selectAll('th').style('background-color',"#ffffff").style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
        tablePanelForStkGrpBarChart.selectAll('td').style('background-color',"#ffffff").style("border-style","none").style("color","#00001c")
        
        //b1da9f
        tablePanelForStkGrpBarChart.selectAll('table') . style("border-collapse","collapse")
        tablePanelForStkGrpBarChart.selectAll('table tr:first-child th').style("border-top","0px")
        tablePanelForStkGrpBarChart.selectAll('table tr:last-child td').style("border-bottom","0px")
        tablePanelForStkGrpBarChart.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
        tablePanelForStkGrpBarChart.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")
        
        if(showOrHideTableForStkGrpBarChart == false){
            tablePanelForStkGrpBarChart.style("display","none")
        }
        else if(showOrHideTableForStkGrpBarChart == true){
            tablePanelForStkGrpBarChart.style("display","block")
        }
        
        //By default calling the resized function first time (to align table's th and td).
        //resizedFuctionForStkGrpBarChart()
    }, // stackedGroupedBarChart
    
	//************************************************** Stacked Grouped Bar Chart  **************************************************
    stackedGroupedBarsWithLineChart: function(targetElement, options){
        
        isChartCalled++;
        
        var chartName = "STACKEDGROUPEDBARSWITHLINECHART";
        
        acinfotech.allCharts(targetElement,options,chartName);
        
        var reversedDimsLabelArray = options.keys.labels.reverse()
        
        var selectedDimensionsArray = reversedDimsLabelArray;
        var selectedDimsValueArray = [];
        var tempArray = [];
        var finalSelectedDimsValueArray = []
        
        for(var i = 0; i < selectedDimensionsArray.length; i++){
            tempArray = []
            options.data.forEach(function(d,j){
                for(var k = 0; k<Object.keys(d).length; k++){
                    var lower = d3.keys(d)[k].toString().toLowerCase()
                        if (lower === selectedDimensionsArray[i].toString().toLowerCase()) {
                            tempArray.push(d3.values(d)[k])
                        }
                }
            })
            finalSelectedDimsValueArray.push(tempArray)
        }
        
        var finalSelectedDimsUniqueValuesArray = []
        for(var i = 0; i < finalSelectedDimsValueArray.length; i++){
            tempArray = []
            $.each(finalSelectedDimsValueArray[i], function(i, el){
                if($.inArray(el, tempArray) === -1) tempArray.push(el);
            });
           finalSelectedDimsUniqueValuesArray.push(tempArray)
        }
        
        var finalArray = [];
        var tempArray = [];
        
        var setOfDataArray = []; // Two hold each data
        
        for(var i = 0; i < finalSelectedDimsUniqueValuesArray[0].length; i++){
            tempArray = []
            for(var j = 0; j < finalSelectedDimsUniqueValuesArray[1].length; j++){
                options.data.forEach(function(d,l){
                    for(var n = 0; n < Object.keys(d).length; n++){
                        var lower = d3.keys(d)[n].toString().toLowerCase();
                            if(lower === selectedDimensionsArray[0].toString().toLowerCase()){
                                if(d3.values(d)[n].toString().toLowerCase() === finalSelectedDimsUniqueValuesArray[0][i].toString().toLowerCase()){
                                    for(var p = 0; p < Object.keys(d).length; p++){
                                        var lower = d3.keys(d)[p].toString().toLowerCase()
                                            if(lower === selectedDimensionsArray[1].toString().toLowerCase()){
                                                if(d3.values(d)[p].toString().toLowerCase() === finalSelectedDimsUniqueValuesArray[1][j].toString().toLowerCase()){
                                                    tempArray.push(d)
                                                    break;
                                                } // if
                                            } // if(lower)
                                    } // for(var p)
                                } //if(d3.values(d[n])
                            }// if(lower)
                    } // for(var n)
                }) // options.data
            } // for(var j)
            setOfDataArray.push(tempArray)
        }// for(var i)
        
        targetElement.style("min-width","350px").style("min-height","350px").style("background-color", options.BGcolor)
        
        var showOrHideTableForStkGrpBarsWithLineChart;
        var showOrHideCommentsForStkGrpBarsWithLineChart;
        var showOrHideCommentsBtnForStkGrpBarsWithLineChart = true;
        
        if((options.showTable == false) || (options.showTable == true)){
            showOrHideTableForStkGrpBarsWithLineChart = options.showTable
        }
        else{
            showOrHideTableForStkGrpBarChart = false;
        }
        
        // Show or Hide comments
        if (options.showComments == true || false) {
            showOrHideCommentsForStkGrpBarsWithLineChart = options.showComments;
        }
        else {
            showOrHideCommentsForStkGrpBarsWithLineChart = false;
        }
        
        if (options.comments.length == 0){
            showOrHideCommentsForStkGrpBarsWithLineChart = false;
            showOrHideCommentsBtnForStkGrpBarsWithLineChart = false;
        }
        
        if ((showOrHideTableForStkGrpBarsWithLineChart == true) && (showOrHideCommentsForStkGrpBarsWithLineChart == true)){
            showOrHideTableForStkGrpBarsWithLineChart = true;
            showOrHideCommentsForStkGrpBarsWithLineChart = false;
        }
        else if ((showOrHideTableForStkGrpBarsWithLineChart == false) && (showOrHideCommentsForStkGrpBarsWithLineChart == false)){
            showOrHideTableForStkGrpBarsWithLineChart = false;
            showOrHideCommentsForStkGrpBarsWithLineChart = false;
        }
        
        var yAxisDivForStkGrpBarsWithLineChart = targetElement.append("div").style("position","absolute").style("background-color", options.BGcolor)
        .style("width", function(d) {  return 10.00 + "%"; }) .style("height", function(d) { return 80 + "%"; }).style("top", function(d) {  return 10.00 + "%"; })
        .style("left", function(d) {  return 0.00 + "%"; })
        .style("border","none").style("border-bottom","0px solid #e6e6e6").style("box-sizing","border-box")
        
        var chartDivForStkGrpBarsWithLineChart = targetElement.append("div").style("position","absolute").style("background-color", options.BGcolor)
        .style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 80 + "%"; }).style("top", function(d) {  return 10.00 + "%"; })
        .style("left", function(d) {  return 10.00 + "%"; })
        .style("border","none").style("border-right","0px solid #808080").style("box-sizing","border-box")
        
        var lineChartDivForStkGrpBarsWithLineChart = targetElement.append("div").style("position","absolute")//.style('background-color',"rgba(0, 100, 137,0.016)")
        .style("width", function(d) {  return 10.00 + "%"; }) .style("height", function(d) { return 80 + "%"; }).style("top", function(d) {  return 10.00 + "%"; })
        .style("left", function(d) {  return 69.10 + "%"; }).attr("id","u") //69.80
        .style("border","none").style("border","0px solid #d5e8ff").style("box-sizing","border-box")//.style("border-left","none").style("border-radius","0px")//.style('opacity',0.05)
        
        var legendDivForStkGrpBarsWithLineChart = targetElement.append("div").style("position","absolute").style("background-color", options.BGcolor)
        .style("width", function(d) {  return 20.00 + "%"; }) .style("height", function(d) { return 80 + "%"; }).style("top", function(d) {  return 8.00 + "%"; })
        .style("left", function(d) {  return 80.00 + "%"; })
        .style("border","none").style("border-left","0px solid #e6e6e6").style("box-sizing","border-box")
        
        var chartTitlePanelForStkGrpBarsWithLineChart =  targetElement.append("div").style("position","absolute").style("background-color", options.BGcolor).style("text-indent","10px")
        .style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 5 + "%"; }).style("top", function(d) {  return 0.00 + "%"; })
        .style("border","none").style("box-sizing","border-box")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:20.0%; font-size:14px; font-family:inter;color:#00001c;">'+ options.chartTitle +'</div>')
        
        //Reverse the order of options.keys.labels
        options.keys.labels.reverse()
        
        var chartTopPanelForStkGrpBarsWithLineChart =  targetElement.append("div").style("position","absolute").style("text-align", "center").style("background-color", options.BGcolor)
        .style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 5 + "%"; }).style("top", function(d) {  return 5.00 + "%"; })
        .style("left", function(d) {  return 10.00 + "%"; }).style("border","none").style("border-bottom","0px solid #e6e6e6").style("box-sizing","border-box")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:20.0%; font-size:12px; font-family:inter; text-transform:uppercase; color:#00001c; font-weight:Bold;">'+ options.keys.labels[1] +'</div>')
        
        var chartBottomPanelForStkGrpBarsWithLineChart =  targetElement.append("div").style("position","absolute").style("text-align", "center").style("background-color", options.BGcolor)
        .style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 5 + "%"; }).style("top", function(d) {  return 90.00 + "%"; })
        .style("left", function(d) {  return 10.00 + "%"; }).style("border","none").style("border-top","0px solid #e6e6e6").style("box-sizing","border-box")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:20.0%; font-size:12px; font-family:inter; text-transform:uppercase; color:#00001c; font-weight:Bold;">'+ options.keys.labels[0] +'</div>')
        
        //Reverse the order of options.keys.labels
        options.keys.labels.reverse()
        
		var optionsButtonPanelForStkGrpBarsWithLineChart = targetElement.append('div').style('width',"25px").style('height',"130px").style('position','absolute')
        .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px")
        .style('right', '0').style("min-width","25px")
        .style("border-style","none").style("border-left", "solid #fcfcfc  1px")//.style("top",71.5 + "px")
		
        //-------- adding shuffle and refresh button --------
        var shuffleBtnForStkGrpBarsWithLineChart = optionsButtonPanelForStkGrpBarsWithLineChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','55px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var filterBtnImgVar = document.createElement("IMG");
        filterBtnImgVar.src = "images/shuffleIcon.png";
        filterBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.9;")
        shuffleBtnForStkGrpBarsWithLineChart[0][0].appendChild(filterBtnImgVar)
        
        var refreshBtnForStkGrpBarsWithLineChart = optionsButtonPanelForStkGrpBarsWithLineChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','80px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var refreshBtnImgVar = document.createElement("IMG");
        refreshBtnImgVar.src = "images/refreshIcon.png";
        refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.9;")
        refreshBtnForStkGrpBarsWithLineChart[0][0].appendChild(refreshBtnImgVar)
        
        var commentsPanelDivForStkGrpBarsWithLineChart = targetElement.append("div") //.attr("class","commentsPanelClassForcommentsPanelDivForStkGrpBarsWithLineChart")
        .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
		.style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
        .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)
        
        commentsPanelDivForStkGrpBarsWithLineChart.on('click',function(d){
            $('.commentsClassForcommentsPanelDivForStkGrpBarsWithLineChart' + targetElement[0][0].id).focus()
        })
        
        var commentsBtnForStkGrpBarsWithLineChart = optionsButtonPanelForStkGrpBarsWithLineChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','105px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var commentsBtnImgVariable = document.createElement("IMG");
        if(options.showComments == false){
            commentsBtnImgVariable.src = "images/showCommentsIcon.png";
        }
        else if(options.showComments == true){
            commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
        }
        commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        commentsBtnForStkGrpBarsWithLineChart[0][0].appendChild(commentsBtnImgVariable)
        
        var menuButtonForStkGrpBarsWithLineChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','1px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var menuBtnImgVar = document.createElement("IMG");
        menuBtnImgVar.src = "images/menuIcon.png";
        menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
        menuButtonForStkGrpBarsWithLineChart[0][0].appendChild(menuBtnImgVar)
        
        var ismenuButtonOfStkGrpBarsWithLineChartClicked = false; // Menu toggle button variable
        menuButtonForStkGrpBarsWithLineChart.on('click', function() {
                
            shufflePanelForTwoXAxisesGrpBarChart.style("display","none");
                                             
            if(ismenuButtonOfStkGrpBarsWithLineChartClicked == false){ // Checking if menu button is clicked
                ismenuButtonOfStkGrpBarsWithLineChartClicked = true; // Menu toggle button variable
                optionsButtonPanelForStkGrpBarsWithLineChart.style("display","block") // Showing option buttons menu panel
            }
            else if(ismenuButtonOfStkGrpBarsWithLineChartClicked == true){ // Checking if menu button is clicked
                ismenuButtonOfStkGrpBarsWithLineChartClicked = false
                optionsButtonPanelForStkGrpBarsWithLineChart.style("display","none") // Hiding option buttons panel
            }
                                    
        })
        
        var tableButtonForStkGrpBarsWithLineChart = optionsButtonPanelForStkGrpBarsWithLineChart.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top','1px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
        var tableBtnImgVar = document.createElement("IMG");
        if(showOrHideTableForStkGrpBarsWithLineChart == false){
            tableBtnImgVar.src = "images/showTableIcon.png";
            tableButtonForStkGrpBarsWithLineChart.attr("class","showTableClassForChartTable")
        }
        else if(showOrHideTableForStkGrpBarsWithLineChart == true){
            tableBtnImgVar.src = "images/cancelTableIcon.png";
            tableButtonForStkGrpBarsWithLineChart.attr("class","hideTableClassForChartTable")
        }
        tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
        tableButtonForStkGrpBarsWithLineChart[0][0].appendChild(tableBtnImgVar)
        
        var downloadBtnForStkGrpBarsWithLineChart = optionsButtonPanelForStkGrpBarsWithLineChart.append("div").attr("id","downloadBtnForStkGrpBarsWithLineChart-ID-" + targetElement[0][0].id)
        .style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff")
        .style('margin-left','2px').style('top', 28 + 'px').style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        
        acinfotech.downloadFunctionality("downloadBtnForStkGrpBarsWithLineChart-ID-" + targetElement[0][0].id,targetElement)
        
        if ((showOrHideTableForStkGrpBarsWithLineChart == false) && (showOrHideCommentsForStkGrpBarsWithLineChart == true)){
            
            yAxisDivForStkGrpBarsWithLineChart.style("left", function(d) {  return 0.00 + "%"; }).style("top", function(d) {  return 10.00 + "%"; }).style("width", function(d) {  return 10.00 + "%"; }) .style("height", function(d) { return 65 + "%"; })
            
            chartDivForStkGrpBarsWithLineChart.style("left", function(d) {  return 10.00 + "%"; }).style("top", function(d) {  return 10.00 + "%"; })
            .style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 65 + "%"; })
            
            chartBottomPanelForStkGrpBarsWithLineChart.style("left", function(d) {  return 10.00 + "%"; }).style("top", function(d) {  return 75.00 + "%"; }).style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 5 + "%"; })
            
            legendDivForStkGrpBarsWithLineChart.style("left", function(d) {  return 80.00 + "%"; }).style("top", function(d) {  return 10.00 + "%"; }).style("width", function(d) {  return 20.00 + "%"; }) .style("height", function(d) { return 65 + "%"; })
            
            var commentsForStkGrpBarsWithLineChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
            .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
            .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
            .css('line-height','1.1em').css('text-align','justify') .attr('class','commentsClassForStkGrpBarChart' + targetElement[0][0].id)
            
            commentsPanelDivForStkGrpBarsWithLineChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 20 + "%"; })
            .style("top",80 + "%")
            .html(commentsForStkGrpBarsWithLineChart[0].outerHTML.toString())
            
        }
        else if ((showOrHideTableForStkGrpBarsWithLineChart == true) && (showOrHideCommentsForStkGrpBarsWithLineChart == false)){
            
            yAxisDivForStkGrpBarsWithLineChart.style("left", function(d) {  return 0.00 + "%"; }).style("top", function(d) {  return 10.00 + "%"; }).style("width", function(d) {  return 10.00 + "%"; }) .style("height", function(d) { return 55 + "%"; })
            
            chartDivForStkGrpBarsWithLineChart.style("left", function(d) {  return 10.00 + "%"; }).style("top", function(d) {  return 10.00 + "%"; })
            .style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 55 + "%"; })
            
            chartBottomPanelForStkGrpBarsWithLineChart.style("left", function(d) {  return 10.00 + "%"; }).style("top", function(d) {  return 65.00 + "%"; }).style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 5 + "%"; })
            
            legendDivForStkGrpBarsWithLineChart.style("left", function(d) {  return 80.00 + "%"; }).style("top", function(d) {  return 10.00 + "%"; }).style("width", function(d) {  return 20.00 + "%"; }) .style("height", function(d) { return 55 + "%"; })
            
            commentsPanelDivForStkGrpBarsWithLineChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            
        }
        else if ((showOrHideTableForStkGrpBarsWithLineChart == false) && (showOrHideCommentsForStkGrpBarsWithLineChart == false)){
            
            yAxisDivForStkGrpBarsWithLineChart.style("left", function(d) {  return 0.00 + "%"; }).style("top", function(d) {  return 10.00 + "%"; }).style("width", function(d) {  return 10.00 + "%"; }) .style("height", function(d) { return 80 + "%"; })
            
            chartDivForStkGrpBarsWithLineChart.style("left", function(d) {  return 10.00 + "%"; }).style("top", function(d) {  return 10.00 + "%"; })
            .style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 80 + "%"; })
            
            chartBottomPanelForStkGrpBarsWithLineChart.style("left", function(d) {  return 10.00 + "%"; }).style("top", function(d) {  return 90.00 + "%"; }).style("width", function(d) {  return 70.00 + "%"; }) .style("height", function(d) { return 5 + "%"; })
            
            legendDivForStkGrpBarsWithLineChart.style("left", function(d) {  return 80.00 + "%"; }).style("top", function(d) {  return 10.00 + "%"; }).style("width", function(d) {  return 20.00 + "%"; }) .style("height", function(d) { return 80 + "%"; })
            
            commentsPanelDivForStkGrpBarsWithLineChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
        }
        
        if(showOrHideCommentsBtnForStkGrpBarsWithLineChart == true){
            shuffleBtnForStkGrpBarsWithLineChart.style('margin-left', "2px")
            refreshBtnForStkGrpBarsWithLineChart.style('margin-left', "2px")
            commentsBtnForStkGrpBarsWithLineChart.style('margin-left', "2px")
            menuButtonForStkGrpBarsWithLineChart.style('right', '0')
        }
        else if(showOrHideCommentsBtnForStkGrpBarsWithLineChart == false){
            //commentsBtnForGroupedBarChart.style('right', '0')
            shuffleBtnForStkGrpBarsWithLineChart.style('margin-left', "2px")
            refreshBtnForStkGrpBarsWithLineChart.style('margin-left', "2px")
            commentsBtnForStkGrpBarsWithLineChart.style('display','none')
			menuButtonForStkGrpBarsWithLineChart.style('right', '0')
        }
        
        var colours;
        
        // checking color set for Grouped Bars and legend dots
        if(options.colorSet === undefined){
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "one"){
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            options.colorSet = "two"
            colours = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            options.colorSet = "three"
            colours = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        }
        else
        {
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        
        
        var leftMar = 85/(setOfDataArray.length)
        
        var svgArray = [];
        var rectsGroupArray = [];
        var linesGroupArray = [];
        var circlesGroupArray = [];
        var xAxisLabelsArray = [];
        var x0Array = [];
        var x1Array = [];
        var yArray = [];
        var monthsArrayForStkGrpBarsWithLineChart = []
        var linesDataSetArray = [];
        
        //--------------------- Left Y Axis panel ---------------------
        var yMaxValueArray = [];
        var maxArray = []
        for(var ii = 0; ii < options.keys.groupBars.length; ii++){
            maxArray = [];
            for(var jj = 0; jj < setOfDataArray.length; jj++){
                setOfDataArray[jj].forEach(function(d) { maxArray.push(+d[options.keys.groupBars[ii]])  })
            }
            yMaxValueArray.push(d3.max(maxArray))
        }
        
        //Adding svg for yAxis in Y-Axis div panel
        var svgPanelForYAxis = yAxisDivForStkGrpBarsWithLineChart .append('svg') .style("background-color", options.BGcolor)
        .style('border-color',"#e1e1e1") .style('border-style',"none") .style("position","absolute")
        .attr('width', 100 + "%") .attr('height', 100 + "%")
        .style("top",0 + "%").style("left",0 + "%").style("border","none").style("border","0px solid #e6e6e6").style("box-sizing","border-box") //.append('g')
        
        var margin = {top: 60 , right: 0, bottom: 80, left: svgPanelForYAxis.node().getBoundingClientRect().width - 1}, //originally top: 42, left: 80
        width = (svgPanelForYAxis.node().getBoundingClientRect().width) - margin.left - margin.right,
        height = svgPanelForYAxis.node().getBoundingClientRect().height - margin.top - margin.bottom;
        
        var yForYAxis = d3.scale.linear() .domain([0, d3.sum(yMaxValueArray)]) .range([height, 0]); // for margin.top: 35 d3.max(yMaxValueArray) * 1.31
        
        var yAxis = d3.svg.axis() .scale(yForYAxis) .ticks(5) .orient("left");
        
        var hasDecimalPoint = false;
        for(var i = 0; i < options.keys.groupBars.length; i++){
            for(var indx = 0; indx < setOfDataArray.length; indx++){
                for(var j = 0; j < setOfDataArray[indx].length; j++){
                    if(setOfDataArray[indx][j][options.keys.groupBars[i]].toString().indexOf('.') > -1){ hasDecimalPoint = true; break; }
                }
            }
        }
        
        if(hasDecimalPoint == false){ yAxis.tickFormat(d3.format(".2s")) }
        
        var svgForYAxis = svgPanelForYAxis.append("svg:g") .style("position","absolute").attr("transform", "translate(" + margin.left + "," + margin.top + ")");
        svgForYAxis.append("g") .attr("class", "y axis") .call(yAxis).selectAll("text") .style("fill","#00001c").style("font-family","Verdana,sans-serif");
        
        // Changing path (line) color of y axis
        svgForYAxis.select("path").style("stroke","white")
        
        //--------------------------------------------------------------
        
        //--------------------- Right Y Axis panel ---------------------
        // Find max value for line chart (right Y Axis)
        var rgtYAxisYMaxValueArray = [];
        var rgtYAxisMaxArray = []
        for(var ii = 0; ii < options.keys.lines.length; ii++){
            rgtYAxisMaxArray = [];
            for(var jj = 0; jj < setOfDataArray.length; jj++){
                setOfDataArray[jj].forEach(function(d) {  rgtYAxisMaxArray.push(+d[options.keys.lines[ii]])  })
            }
            
            rgtYAxisYMaxValueArray.push(d3.max(rgtYAxisMaxArray))
        }
        
        //Adding svg for right yAxis in Y-Axis div panel
        var svgPanelForRightYAxis = lineChartDivForStkGrpBarsWithLineChart .append('svg') .style("background-color", options.BGcolor).style('border-color',"#e1e1e1") .style('border-style',"none")
        .style("position","absolute").attr('width', 100 + "%") .attr('height', 100 + "%").style("top",0 + "%").style("left",0 + "%")
        .style("border","none").style("border","0px solid #e6e6e6").style("box-sizing","border-box")
        
        var rgtYForYAxis = d3.scale.linear() .domain([0, d3.max(rgtYAxisYMaxValueArray)]) .range([height, 0]); // for margin.top: 35 d3.max(yMaxValueArray) * 1.31
        
        var rgtYAxis = d3.svg.axis() .scale(rgtYForYAxis) .ticks(5) .orient("right");
        
        var hasDecimalPoint = false;
        for(var i = 0; i < options.keys.lines.length; i++){
            for(var indx = 0; indx < setOfDataArray.length; indx++){
                for(var j = 0; j < setOfDataArray[indx].length; j++){
                    if(setOfDataArray[indx][j][options.keys.lines[i]].toString().indexOf('.') > -1){ hasDecimalPoint = true; break; }
                }
            }
        }
        
        if(hasDecimalPoint == false){ rgtYAxis.tickFormat(d3.format(".2s")) }
        
        var svgForRightYAxis = svgPanelForRightYAxis.append("svg:g") .style("position","absolute").attr("transform", "translate(" + 1 + "," + margin.top + ")");
        svgForRightYAxis.append("g") .attr("class", "y axis") .call(rgtYAxis).selectAll("text") .style("fill","#00001c").style("font-family","Verdana,sans-serif");
        
        //-------------------------------------------------------------
        
        //Reverse the order of options.keys.labels
        options.keys.labels.reverse()
        
        commentsBtnForStkGrpBarsWithLineChart.on('click', function() {
                                         
             if(options.showComments == false){
                 options.showComments = true;
             }
             else if(options.showComments == true){
                 options.showComments = false;
             }
             
             d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
             
             for(var i = 0; i<divAndChartsArray.length; i++){
             
                 if(targetElement[0][0].id === divAndChartsArray[i].divID){
                     options.data = divAndChartsArray[i].optionsData;
                     options.showTable = false;
                 }
             }
             acinfotech.stackedGroupedBarsWithLineChart(targetElement,options)
                                         
        })
        
        // showing/hidding chart table
        tableButtonForStkGrpBarsWithLineChart.on('click', function() {
                                        
            if(showOrHideTableForStkGrpBarsWithLineChart == false){
                options.showTable = true;
            }
            else if(showOrHideTableForStkGrpBarsWithLineChart == true){
                options.showTable = false;
            }
            
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){
            
                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                    
                    if(newtargetElementAndOptionsArray[i].options.keys.groupBars == undefined){
                        options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.stackedAreas;
                    }
                    else {
                        options.keys.groupBars = newtargetElementAndOptionsArray[i].options.keys.groupBars;
                    }
                    
                    options.showComments = false;
                }
            }
            acinfotech.stackedGroupedBarsWithLineChart(targetElement,options)
                                        
        })
        
        downloadBtnForStkGrpBarsWithLineChart.on('click', function() {
                                  
              ismenuButtonOfStkGrpBarsWithLineChartClicked = false; // Changing menu button value to false
              optionsButtonPanelForStkGrpBarsWithLineChart.style("display","none") // Hiding option buttons panel
                                  
        })
        
        var iconButtonTooltipForStkGrpBarsWithLineChart = targetElement.append('div').style('width','240px').attr("id","too")
        .style('height',"25px").style('position','absolute')//.style('margin-left', "0px").style('top','25px')
        .style("background-color",'#404040 ').style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid") // 004b9d
        .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none").attr("border", 0.0)
        
        commentsBtnForStkGrpBarsWithLineChart.on('mousemove', function(d,i) {
             commentsPanelDivForStkGrpBarsWithLineChart.style('background-color','#fafafa')
             var root = targetElement
             var m = d3.mouse(root.node());
             m[0] += 0
             m[1] += 0
             if(options.showComments == false){
                 var commentButtonTooltipText = "Show Comments";
             }
             else if(options.showComments == true){
                 var commentButtonTooltipText = "Hide Comments";
             }
             
             
             iconButtonTooltipForStkGrpBarsWithLineChart.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
             iconButtonTooltipForStkGrpBarsWithLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ commentButtonTooltipText +'</div>')
         })
        commentsBtnForStkGrpBarsWithLineChart.on('mouseout', function(d,i) {
             commentsPanelDivForStkGrpBarsWithLineChart.style('background-color','#ffffff')
             iconButtonTooltipForStkGrpBarsWithLineChart.style("display","none")
         })
        
        //-------------- creating tooltip --------------
        var tooltipForStkGrpBarsWithLineChart = targetElement .append('div') .attr('class', 'tooltipForStkGrpBarsWithLineChartClass') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
        .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
        .style("padding-right", "7px") .style("background", "#ffffff") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style('z-index',1000)
        .style("border", "1.0px") .style("border-color", "#ffffff") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","80px")
        tooltipForStkGrpBarsWithLineChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'tooltip-label1-class').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "14px") .style("font-weight", "normal");
        tooltipForStkGrpBarsWithLineChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'tooltip-label2-class').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "14px") .style("font-weight", "normal");
        tooltipForStkGrpBarsWithLineChart.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
        tooltipForStkGrpBarsWithLineChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");
        
        if(options.keys.toolTipLabel.length > 0){
            
            for(toolTipInd = 0; toolTipInd < options.keys.toolTipLabel.length; toolTipInd++){
                tooltipForStkGrpBarsWithLineChart.append('hr').style("height","1px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
                tooltipForStkGrpBarsWithLineChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'tooltip-additional-label' + toolTipInd + '-class' ).style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");
            }
        }
        
        // ----------------- Shuffle panel and everything within it section begins here ----------------
        var shufflePanelForTwoXAxisesGrpBarChart = targetElement.append('div').style('width',350 + "px") .attr("class","shufflePanelForTwoXAxisesGrpBarChartClass" + targetElement[0][0].id)
        .style('position','absolute').style('margin-left', "0px")
        .style("background-color",'#fefefe').style("z-index",11).style("border-color", "#ffffff").style("border-right", "solid #e5e5e5 1px")  .style("border-style", "solid") // 004b9d
        .style("box-shadow", "2px 0px 1px #eff8ec").style("display","none").style("border-top", "solid #fdfdfd 1px").style("border-left","0px").style("border-bottom", "0px")
        .style('top', 0.0 + "%").style('height', 100 + "%").style('overflow-y',"hidden").style("overflow-x","hidden")
        .style("border-bottom", "solid #e5e5e5 1px") .style("box-sizing","border-box")
        
        var filterPanelTwoXAxisesGrpBarChartTitle = shufflePanelForTwoXAxisesGrpBarChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style("font-weight", "Bold")
        .style('margin-left','0px').style('margin-top','20px').style('text-indent','5px').style("font-size", "14px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #007aff").style("width","350px").style("color","#000000")
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; top:25.0%; font-size:16px; font-family:inter;  color:#585858; font-weight:Bold;">'+ "Shuffle" +'</div>')
        
        var dimensionsColumnTitle = shufflePanelForTwoXAxisesGrpBarChart.append("div") .style("width","170px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:14px; font-family:inter;  color:#606060; font-weight:Normal; text-align:left; text-indent:3px;">Bottom X-Axis, Top X-Axis.</div>');
        
        var dimensionsVariables = shufflePanelForTwoXAxisesGrpBarChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable1"+targetElement[0][0].id)
        .style("list-style-type","none")
        .style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '78px')
        .style('position','absolute')
        .style("width","332px").style("min-height","57px").style("max-height","57px").style("border", "#f0f0f0 1px solid")
        .style("max-width","332px").style("overflow-x","hidden").style("overflow-y","auto")
        dimensionsVariables.style("left",0.0 + "px").style("padding","2px").style("padding-top","7px")
        
        $( ".shufflePanelForTwoXAxisesGrpBarChartClass" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
             var e0 = e.originalEvent,
             delta = e0.wheelDelta || -e0.detail;
             
             this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
             e.preventDefault();
         });
        
        var optionsLabels = options.keys.labels;
        //var shuffle = optionsLabels[0]
        var reversedLabels = [];
        reversedLabels.push(optionsLabels[1])
        reversedLabels.push(optionsLabels[0])
        
        var dimensionsVariables1 = dimensionsVariables.selectAll("li") .data(reversedLabels).enter().append("li")
        .style("width","324px") .style("max-height","22px").style("cursor","move")
        .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#f8e9cd").style("font-weight","Normal")
        .style("list-style-type","none").style("border","1px #f2d199 solid").style("color","#9e6c14").style("font-family","Verdana,sans-serif")
        .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
        .text(function(d,i) {return reversedLabels[i]})
        dimensionsVariables1.attr("class","DimensionsClass"+targetElement[0][0].id)
        
        var cancelButton = shufflePanelForTwoXAxisesGrpBarChart.append("div") .style("width","23px").style("height","21px").style('position','absolute')
        .style('margin-left','320px').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white')
        .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.9; background-color:#fcfcff")
        cancelButton[0][0].appendChild(cancelBtnImgVar)
        
        cancelButton.on("click", function(){
            shufflePanelForTwoXAxisesGrpBarChart.style("display","none")
        })
        
        var reRenderChartAndTableButton = shufflePanelForTwoXAxisesGrpBarChart.append("button").style("width","120px").style("height","25px").style('position','absolute')
        .style('margin-left','112px').style('margin-top','185px') .style("border-style", "none").style('background-color',"#2196f3")
        .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','15px').style("border-style", "solid").style('color','#ffffff')
        .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 1px #9b9b9b").style("border-radius","0px")
        var textForReRenderButton = document.createTextNode("Apply Changes");
        reRenderChartAndTableButton[0][0].appendChild(textForReRenderButton)
        
        
        reRenderChartAndTableButton.on("click", function(){
                                       
               var shuffledDimensions = [];
               for(var i=0; i<$("#sortable1"+targetElement[0][0].id).children("li").length;i++){
                   shuffledDimensions.push($("#sortable1"+targetElement[0][0].id).children("li")[i].textContent)
               }
                 
               var newOptions = {
               data: options.data,
               keys: {
                   labels: shuffledDimensions.reverse(),
                   groupBars: options.keys.groupBars,
                   lines: options.keys.lines,
                   toolTipLabel: options.keys.toolTipLabel
               },
               chartTitle: options.chartTitle,
               xAxisLables: shuffledDimensions,
               //yAxisLable: options.yAxisLables,
               showTitle: options.showTitle,
               series:options.series,
               legend:options.legend,
               BGcolor:options.BGcolor,
               colorSet: options.colorSet, //"one" or "two" or "three";
               drillDownColumnName: options.drillDownColumnName,
               showComments: options.showComments,
               showTable: options.showTable,
               comments: options.comments,
               resizeButtonID: options.resizeButtonID
               
               }
               d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
               acinfotech.stackedGroupedBarsWithLineChart(targetElement, newOptions)
               
		})
        
        $( "ul.droptrue"+targetElement[0][0].id ).sortable({
               appendTo: document.body,
               helper: "clone",
               connectWith: ".droptrue"+targetElement[0][0].id,
               scroll: false,
               cancel: '.unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+','+' .unMoveableIconAndTextClassDimensions'+targetElement[0][0].id,
               revertDuration: 10,
               scrollSensitivity: 10,
               scrollSpeed: 1,
               dynamic: true,
       });
        
        // ----------------- Shuffle panel and everything within it section ends here -----------------
        
        // Calling the shuffle panel on shuffle button click
        shuffleBtnForStkGrpBarsWithLineChart.on('click', function() {
                                              
              ismenuButtonOfStkGrpBarsWithLineChartClicked = false
              optionsButtonPanelForStkGrpBarsWithLineChart.style("display","none") // Hiding options buttons panel
              iconButtonTooltipForStkGrpBarsWithLineChart.style("display","none") // Hiding options tool-tip
                                              
            shufflePanelForTwoXAxisesGrpBarChart.style("display","block");
        })
        
        // Refreshing Chart and Table
        refreshBtnForStkGrpBarsWithLineChart.on('click', function() {
                                                
            //isFilterClicked = false
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){
                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData;
                    options.keys.labels = newtargetElementAndOptionsArray[i].options.keys.labels;
                }
            }
            acinfotech.stackedGroupedBarsWithLineChart(targetElement,options)
            
        })
        
        shuffleBtnForStkGrpBarsWithLineChart.on('mousemove', function(d,i) {
            var root = targetElement
            var m = d3.mouse(root.node());
            m[0] += 0
            m[1] += 0
            var filterButtonTooltipText = "Shuffle";
            
            iconButtonTooltipForStkGrpBarsWithLineChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForStkGrpBarsWithLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')
            
        })
        shuffleBtnForStkGrpBarsWithLineChart.on('mouseout', function(d,i) {
            iconButtonTooltipForStkGrpBarsWithLineChart.style("display","none")
        })
        
        refreshBtnForStkGrpBarsWithLineChart.on('mousemove', function(d,i) {
            var root = targetElement
            var m = d3.mouse(root.node());
            m[0] += 0
            m[1] += 0
            var refreshButtonTooltipText = "Refresh";
            
            iconButtonTooltipForStkGrpBarsWithLineChart.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForStkGrpBarsWithLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center; ">'+ refreshButtonTooltipText +'</div>')
            
        })
        refreshBtnForStkGrpBarsWithLineChart.on('mouseout', function(d,i) {
            iconButtonTooltipForStkGrpBarsWithLineChart.style("display","none")
        })
        
        menuButtonForStkGrpBarsWithLineChart.on('mousemove', function(d,i) {
           var root = targetElement
           var m = d3.mouse(root.node());
           m[0] += 0
           m[1] += 0
           var menuButtonTooltipText = "Menu";
           
           iconButtonTooltipForStkGrpBarsWithLineChart.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
           iconButtonTooltipForStkGrpBarsWithLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center; ">'+ menuButtonTooltipText +'</div>')
                                       
        })
        menuButtonForStkGrpBarsWithLineChart.on('mouseout', function(d,i) {
           iconButtonTooltipForStkGrpBarsWithLineChart.style("display","none")
        })
        
        tableButtonForStkGrpBarsWithLineChart.on('mousemove', function(d,i) {
            var root = targetElement
            var m = d3.mouse(root.node());
            m[0] += 0
            m[1] += 0
            if(showOrHideTableForStkGrpBarsWithLineChart ==  false){
                var tableButtonTooltipText = "Show Table";
            }
            else if(showOrHideTableForStkGrpBarsWithLineChart == true){
                var tableButtonTooltipText = "Hide Table";
            }
            
            iconButtonTooltipForStkGrpBarsWithLineChart.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForStkGrpBarsWithLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ tableButtonTooltipText +'</div>')
                                        
        })
        tableButtonForStkGrpBarsWithLineChart.on('mouseout', function(d,i) {
            iconButtonTooltipForStkGrpBarsWithLineChart.style("display","none")
        })
        
        downloadBtnForStkGrpBarsWithLineChart.on('mousemove', function(d,i) {
              var root = targetElement
              var m = d3.mouse(root.node());
              m[0] += 0
              m[1] += 0
              var downloadButtonTooltipText = "Download";
              iconButtonTooltipForStkGrpBarsWithLineChart.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
              iconButtonTooltipForStkGrpBarsWithLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
        })
        downloadBtnForStkGrpBarsWithLineChart.on('mouseout', function(d,i) {
              iconButtonTooltipForStkGrpBarsWithLineChart.style("display","none")
        })
        
        /*searchChartButton.on('mousemove', function(d,i) {
             var root = targetElement
             var m = d3.mouse(root.node());
             m[0] += 0
             m[1] += 0
             var searchChartButtonTooltipText = "Search in Chart";
         
             iconButtonTooltipForStkGrpBarsWithLineChart.style("width","110px").style("margin-left", (m[0] - 120) + "px").style("margin-top",(m[1]) + "px").style("display","block")
             iconButtonTooltipForStkGrpBarsWithLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ searchChartButtonTooltipText +'</div>')
         })
        searchChartButton.on('mouseout', function(d,i) {
             iconButtonTooltipForStkGrpBarsWithLineChart.style("display","none")
         })
        
        searchTableButton.on('mousemove', function(d,i) {
             var root = targetElement
             var m = d3.mouse(root.node());
             m[0] += 0
             m[1] += 0
             var searchTableButtonTooltipText = "Search in Table";
         
             iconButtonTooltipForStkGrpBarsWithLineChart.style("width","110px").style("margin-left", (m[0] - 120) + "px").style("margin-top",(m[1]) + "px").style("display","block")
             iconButtonTooltipForStkGrpBarsWithLineChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ searchTableButtonTooltipText +'</div>')
         })
        searchTableButton.on('mouseout', function(d,i) {
             iconButtonTooltipForStkGrpBarsWithLineChart.style("display","none")
         })*/
        
        //-------------- Getting Max value for bar chart Y Axis --------------
        
        var xMaxArray = []
        
        for(var ind = 0; ind < setOfDataArray.length; ind++){
            
            var finalArrayNew = [];
            options.keys.groupBars.forEach(function(d, i) { var temp1 = {}; temp1["name"] = options.keys.groupBars[i]; finalArrayNew.push(temp1); })
            
            var finalNewNewArray = [];
            var dataArray1 = [];
            finalArrayNew.forEach(function(d, i) {
                                  
                  var temp1 = {};
                  temp1["name"] = options.keys.groupBars[i]
                  
                  for (j = 0; j < setOfDataArray[ind].length; j++) {
                  
                      var tempTemp = {};
                      tempTemp["label"] = setOfDataArray[ind][j][options.keys.labels[0]];
                      tempTemp["value"] = +setOfDataArray[ind][j][options.keys.groupBars[i]];
                      
                      dataArray1.push(tempTemp)
                  }
                  
                  temp1["data"] = dataArray1;
                  dataArray1 = []
                  finalNewNewArray.push(temp1)
              })
            
            var dataset = finalNewNewArray,
            series = dataset.map(function (d) { return d.name; }),
            dataset = dataset.map(function (d) { return d.data.map(function (o, index) { return { y: o.value, x: o.label}; }); }),
            stack = d3.layout.stack();
            
            stack(dataset);
            
            var dataset = dataset.map(function (group) { return group.map(function (d) { return { x: +d.y, y: d.x, x0: +d.y0 }; }); }),
            
            xMax = d3.max(dataset, function (group) { return d3.max(group, function (d) { return (+d.x) + (+d.x0); }); })
            
            xMaxArray.push(xMax)
            
        } // for(var ind = 0; ind < setOfDataArray.length; ind++) Creating SVGs for loop
        
        var dataSetForLineChart = []
        for(var i = 0; i < setOfDataArray.length; i++){
            for(var j = 0; j < setOfDataArray[i].length; j++){
                dataSetForLineChart.push(setOfDataArray[i][j])
            }
        }
        //--------------------------------------------------------------------
        
        //-------------- Getting Max value for line chart Y Axis--------------
        
        var maxValueArrayForLineYAxis = [];
        
        for(var ind = 0; ind < setOfDataArray.length; ind++){
            
            var dataSetForLineChart = []
            for(var j = 0; j < setOfDataArray[ind].length; j++){ dataSetForLineChart.push(setOfDataArray[ind][j]) }
            
            var dataArrayForLine = [];
            
            dataSetForLineChart.forEach(function(d, i) {
                var temp = {};
                for (i = 0; i < options.keys.lines.length; i++) {
                    for (j = 0; j < Object.keys(d).length; j++) { if(options.keys.lines[i] === Object.keys(d)[j]){ temp[Object.keys(d)[j]] = d[Object.keys(d)[j]] } }
                }
                
                dataArrayForLine.push(temp)
            });
            
            
            var finalArrayForLine = [];
            dataSetForLineChart.forEach(function(d, i) {
                                        
                var finalArrayForLineTemp = {};
                finalArrayForLineTemp[options.keys.labels[0]] = d[options.keys.labels[0]];
                finalArrayForLineTemp["Data"] = dataArrayForLine[i];
                finalArrayForLine.push(finalArrayForLineTemp)
            })
            
            var finalArrayNewForLine = [];
            options.keys.lines.forEach(function(d, i) { var temp1 = {}; temp1["line"] = options.keys.lines[i]; finalArrayNewForLine.push(temp1) })
            
            var finalNewNewArrayForLine = [];
            var dataArrayForLine1 = [];
            finalArrayNewForLine.forEach(function(d, i) {
                                         
                 var temp1 = {};
                 temp1["line"] = options.keys.lines[i]
                 
                for (j = 0; j < dataSetForLineChart.length; j++) {
                 
                     var tempTemp = {};
                     tempTemp["label"] = dataSetForLineChart[j][options.keys.labels[0]];
                     tempTemp["value"] = dataSetForLineChart[j][options.keys.lines[i]];
                     maxValueArrayForLineYAxis.push(dataSetForLineChart[j][options.keys.lines[i]]);
                     dataArrayForLine1.push(tempTemp)
                 }
                 
                 temp1["Data"] = dataArrayForLine1;
                 dataArrayForLine1 = []
                 finalNewNewArrayForLine.push(temp1)
             })
        }
        //----------------------------------------------------------------
        
        var coloursForLinesAndCircles = d3.scale.ordinal() .range(["#2fff19", "#ff192f", "#19ffe8", "#19a3ff", "#ffe819", "#18ccff", "#808000","#307D7E","#AF7817","#00cc77","#009bb9","#fbc004"]);
        
        for(var ind = 0; ind < setOfDataArray.length; ind++){
            
            //Creating SVG Div holder for chart
            var svgDivPanelForStkGrpBarsWithLineChart = chartDivForStkGrpBarsWithLineChart .append('div') .style("position","absolute").style("left",function(d,index){ return (leftMar * ind )+ "%"; })
            .style("top",0 + "%").style('width', (85/(setOfDataArray.length)) + "%").style('height', 100 + "%").style("background-color", options.BGcolor)
            .style("border","none").style("border-right","0px solid #e6e6e6").style("box-sizing","border-box")
            
            //Creating SVG holder for chart
            var svgPanelForStkGrpBarsWithLineChart = svgDivPanelForStkGrpBarsWithLineChart .append('svg') .style("position","absolute").style("left",function(d,index){ return 0 + "%"; })
            .style("top",0 + "%").attr('width', 101 + "%").attr('height', 100 + "%").style("background-color", options.BGcolor)
            .style("border-right","0px solid #e6e6e6").style("box-sizing","border-box") //.append('g')
            
            var margin = {top: 60 , right: 0, bottom: 80, left: -1}, //originally top: 42, left: 80
            width = (svgPanelForStkGrpBarsWithLineChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = svgPanelForStkGrpBarsWithLineChart.node().getBoundingClientRect().height - margin.top - margin.bottom;
            
            //------------------------- Creating bars --------------------------
            
            var finalArrayNew = [];
            options.keys.groupBars.forEach(function(d, i) {
                                             
                 var temp1 = {};
                 temp1["name"] = options.keys.groupBars[i]
                 
                 finalArrayNew.push(temp1)
             })
            
            var finalNewNewArray = [];
            var dataArray1 = [];
            finalArrayNew.forEach(function(d, i) {
                                  
                  var temp1 = {};
                  temp1["name"] = options.keys.groupBars[i]
                  
                  for (j = 0; j < setOfDataArray[ind].length; j++) {
                  
                      var tempTemp = {};
                      tempTemp["label"] = setOfDataArray[ind][j][options.keys.labels[0]];
                      tempTemp["value"] = +setOfDataArray[ind][j][options.keys.groupBars[i]];
                      
                      dataArray1.push(tempTemp)
                  }
                  
                  temp1["data"] = dataArray1;
                  dataArray1 = []
                  finalNewNewArray.push(temp1)
              })
            
            var dataset = finalNewNewArray,
            series = dataset.map(function (d) { return d.name; }),
            dataset = dataset.map(function (d,outterIndex) {
                  return d.data.map(function (o, index) {
                        // Structure it so that your numeric
                        // axis (the stacked amount) is y
                        return {
                            y: o.value,
                            x: o.label,
                            rectTopLabel: setOfDataArray[ind][index][options.keys.labels[1]], // additionally added
                            rectBottomLabel: setOfDataArray[ind][index][options.keys.labels[0]], // additionally added
                            rectColor: colours(outterIndex), // additionally added
                            rectName: d.name, // additionally added
                            rectValue: o.value, // additionally added
                            groupIndex: ind // additionally added*/
                        };
                    });
              }),
            stack = d3.layout.stack();
            
            stack(dataset);
            
            var dataset = dataset.map(function (group,outterIndex) {
                  return group.map(function (d, index) {
                   // Invert the x and y values, and y0 becomes x0
                                                       
                   return {
                       x: +d.y,
                       y: d.x,
                       x0: +d.y0,
                       rectTopLabel: setOfDataArray[ind][index][options.keys.labels[1]], // additionally added
                       rectBottomLabel: setOfDataArray[ind][index][options.keys.labels[0]], // additionally added
                       rectColor: colours(outterIndex), // additionally added
                       rectName: d.rectName, // additionally added
                       rectValue: d.rectValue, // additionally added
                       groupIndex: ind // additionally added
                   };
               });
            }),
            
            months = dataset[0].map(function (d) { return d.y; })
            
            monthsArrayForStkGrpBarsWithLineChart.push(months)
            let key=options.xAxisLable;
        let array=options.data.map(value => value[key]);
        let ArrayValue=[];
        var RotateValue;
        for(let i=0;i<array.length;i++){
                ArrayValue[i]=array[i].length;
        }
        const numberGreaterThanLimit = ArrayValue.filter((v) => v > 5);
            
            var xAxisLabels = dataset[0].map(function (d) { return d.y; });
            
            var y = d3.scale.linear() .domain([0, d3.max(xMaxArray)]) .range([0, height]);
            
            var x0 = d3.scale.ordinal() .domain(months) .rangeRoundBands([0, width], 0.08,0.35); //originally 0.25
            
            var x1 = d3.scale.ordinal() .domain(d3.range(finalNewNewArray.length)) .rangeBands([0, x0.rangeBand()]);
            
            var xAxis = d3.svg.axis() .scale(x0) .orient("bottom");
            
            var svg = svgPanelForStkGrpBarsWithLineChart.append("svg").append("g") .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
            
            svg.append('g') .attr("class", "x axis bottomclass") .attr('transform', 'translate(0,' + height + ')') .call(xAxis)
            
            .selectAll("text").data(xAxisLabels) .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c')
            .attr("transform", function(d) { 
                if(numberGreaterThanLimit.length>0){return "rotate(-45)"}
                else{
                return "rotate(0)" } }) .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
                .text(function(d,i) {
                    if(d.length > 9){
                        return d.substring(0,9)+'...';
                    }
                    else{
                        return d;
                    }
                })
            
            var groups = svg.append("g").selectAll("g") .data(dataset)
            
			var groups1 = groups.enter().append("g").attr("class","each-bargrouped-class").style("fill", function(d, i) { return colours(i); })
            .selectAll("rect").data(function(d) { return d; }).enter().append("rect")
			.attr("x", function(d, i) {   return x0(d.y); })
			.attr("width", x0.rangeBand())
			.attr("y", function (d) { return height; })
			.attr("height", function (d) { return 0; })
			.transition() .delay(400) .duration(800)
			.attr("y", function(d) { return  height - y(d.x0) - y(d.x); })
			.attr("height", function (d) { return y(d.x); }).style("cursor","auto")
			
            //-------------------- adding drill down ----------------
            var columnNames = d3.keys(options.data[0])
            var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
            
            for(var i = 0; i < columnNames.length ; i++){
                for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                    if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                        for(var k = 0; k < options.keys.groupBars.length; k++){
                            var len = d3.select(groups[0][k]).selectAll('rect')
                            for(var l = 0; l < len[0].length; l++){
                                d3.select(len[0][l]).attr('data-drilldownkey', function(d,index){
                                  return JSON.stringify(setOfDataArray[ind][l]).slice(1, -1).split('"').join("").split(':').join("|")
                                })
                            }
                        }
                    }
                    else {
                    }
                }
            }
            //-----------------------------------------------------
            
            var yTextPadding = 10;
            var format1 = d3.format('.2s')
            var textOnStackedBarChart = groups.selectAll(".text") .data(function (d) { return d; })
            
            textOnStackedBarChart.enter() .append("text") .attr("class","text");
            
            textOnStackedBarChart.style("text-anchor", "middle").style("font-family", "Verdana,sans-serif").style("font-size", "12px")
            .style("fill", "#ffffff") .style("text-shadow","1px 0px 1px rgba(34,34,34,0.6)")
            .attr("x", function(d,i) { return x0(d.y) + x0.rangeBand()/2; })
			.attr("y", function (d) { return height; })
			.transition() .delay(400) .duration(800)
			.attr("y", function(d) { return (height - y(d.x0) - y(d.x))+(y(d.x)/1.5);})
			.text(function(d){
                  if(d.x.toString().indexOf('.') === -1) { if(d.x.toString().length <= 3) { return d.x; } else { return format1(d.x) } }
                  else { return d.x.toString(); }
			})
            
            var x2 = d3.scale.ordinal() .domain(setOfDataArray[ind].map(function(d) { return d[options.keys.labels[1]]; })) .rangeRoundBands([0, width], 0.25);
            var xAxisTop = d3.svg.axis() .scale(x2) .orient("top")
            
            // Adding the Top X Axis
            var topAxis = svg.append("g").attr("class", "x axis topclass").attr("transform", "translate(0," + -25 + ")") .call(xAxisTop)
            
            // Add the Top X Axis margin labels
            .selectAll("text") .style("text-anchor", "end") .style('fill','#00001c') .attr("transform", function(d) { return "rotate(0)" })
            .style("font-size","12px").style("font-family","Verdana,sans-serif") .style('text-anchor','middle').style("font-family","Verdana,sans-serif").style("font-weight","normal")
            .text(function(d,i) { if(d.length > 9) return d.substring(0,9)+'...'; else return d; })
            
            //d3.select(topAxis[0][0].parentNode).select("line").style("stroke","white")
            //d3.select(topAxis[0][0].parentNode.nextSibling).style("stroke","white")
            
            //-----------------------------------------------------------------------
            
            //---------------------------- Creating lines ---------------------------
            
            var dataSetForLineChart = []
            for(var j = 0; j < setOfDataArray[ind].length; j++){
                dataSetForLineChart.push(setOfDataArray[ind][j])
            }
            
            var dataArrayForLine = [];
            
            dataSetForLineChart.forEach(function(d, i) {
                var temp = {};
                for (i = 0; i < options.keys.lines.length; i++) {
                
                    for (j = 0; j < Object.keys(d).length; j++) {
                    
                        if(options.keys.lines[i] === Object.keys(d)[j]){ temp[Object.keys(d)[j]] = d[Object.keys(d)[j]] }
                    }
                }
                
                dataArrayForLine.push(temp)
            });
            
            
            var finalArrayForLine = [];
            dataSetForLineChart.forEach(function(d, i) {
                                        
                var finalArrayForLineTemp = {};
                finalArrayForLineTemp[options.keys.labels[0]] = d[options.keys.labels[0]];
                finalArrayForLineTemp["Data"] = dataArrayForLine[i];
                finalArrayForLine.push(finalArrayForLineTemp)
            })
            
            var finalArrayNewForLine = [];
            options.keys.lines.forEach(function(d, i) {
                                       
               var temp1 = {};
               temp1["line"] = options.keys.lines[i]
               
               finalArrayNewForLine.push(temp1)
            })
            
            var finalNewNewArrayForLine = [];
            var dataArrayForLine1 = [];
            finalArrayNewForLine.forEach(function(d, i) {
                                         
                 var temp1 = {};
                 temp1["line"] = options.keys.lines[i]
                 
                 for (j = 0; j < dataSetForLineChart.length; j++) {
                 
                     var tempTemp = {};
                     tempTemp["label"] = dataSetForLineChart[j][options.keys.labels[0]];
                     tempTemp["value"] = dataSetForLineChart[j][options.keys.lines[i]];
                     tempTemp["groupIndex"] = ind // additionally added
                                         
                     dataArrayForLine1.push(tempTemp)
                 }
                 
                 temp1["Data"] = dataArrayForLine1;
                 dataArrayForLine1 = []
                 finalNewNewArrayForLine.push(temp1)
             })
            
            var xForLine = d3.scale.ordinal().domain(dataSetForLineChart.map(function(d,i) { return d[options.keys.labels[0]];})).rangePoints([0, width],0.0);
            
            var x1ForLine = d3.scale.ordinal() .domain(dataSetForLineChart.map(function(d,i) { return d[options.keys.labels[0]]; })) .rangePoints([0, width], 1.70);
            
            var maxForLine = d3.max(finalArrayForLine, function(d) { return d.Data[options.keys.lines[0]] });
            
            var maxArrayForLine = [];
            for (i = 0; i < options.keys.lines.length; i++) {
                var max = d3.max(finalArrayForLine, function(d) {
                     return +d.Data[options.keys.lines[i]]
                 });
                
                maxArrayForLine.push(max)
            }
            
            var finallyMaxValueForLine = d3.max(maxArrayForLine, function(d) { return +d; })
            
            var yForLine = d3.scale.linear() .domain([0, d3.max(maxValueArrayForLineYAxis, function(d) { return +d; })] ) .range([height, 0]);
            
            var color = d3.scale.category10();
            
            var xAxisForLine = d3.svg.axis() .scale(xForLine) .orient("bottom");
            
            var yAxisForLine = d3.svg.axis() .scale(yForLine) .ticks(5) .orient("left");
            
            
            color.domain(options.keys.lines.map(function (d) { return d; }));
            
            var minX = d3.min(finalNewNewArrayForLine, function (kv) { return d3.min(kv.Data, function (d) { return +d.value; }) });
            var maxX = d3.max(finalNewNewArrayForLine, function (kv) { return d3.max(kv.Data, function (d) { return +d.value; }) });
            var minY = d3.min(finalNewNewArrayForLine, function (kv) { return d3.min(kv.Data, function (d) { return +d.value; }) });
            var maxY = d3.max(finalNewNewArrayForLine, function (kv) { return d3.max(kv.Data, function (d) { return +d.value; }) });
            
            xForLine.domain([minX, maxX]);
            yForLine.domain([minY, maxY]);
            
            //var svg = lineChartSvgForStkGrpBarsWithLineChart.append("svg:g") .attr("transform", "translate(" + -1 + "," + 55 + ")");
            
            // Creating line data
            var line = d3.svg.line() .interpolate("linear") .x(function (d) { return x1ForLine(d['label']); }) .y(function (d) { return yForLine(+d["value"]); });
            
            // Creating lines
            var lines = svg.selectAll(".line") .data(finalNewNewArrayForLine) .enter() .append("g") .append("path") .attr("class", "line")
            .attr("d", function (d,i) { return line(d.Data); }) .style("stroke", function (d,i) { return coloursForLinesAndCircles(i); })
            .style("stroke-width",2.5) .style('fill','none') .style("stroke-linecap", "butt")
            
            var colorCount = 0;
            // Creating circles on lines
            var circles = svg.selectAll("g.dot") .data(finalNewNewArrayForLine) .enter() .append("g")
            .attr("class", "dot") .selectAll("circle") .data(function(d) { return d.Data; }) .enter() .append("circle") .attr("r", 4.5)
            .attr("cx", function(d,i) {  return x1ForLine(d['label']); }) .attr("cy", function(d,i) {  return yForLine(+d["value"]); })
            .style("fill", function (d,i) { if(i == 0){ colorCount++; } return coloursForLinesAndCircles(colorCount - 1); })
            
            //-------------------- adding drill down --------------------
            
            var columnNames = d3.keys(options.data[0])
            var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
            
            for(var i = 0; i < columnNames.length ; i++){
                for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                    if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                        for(var k = 0; k < options.keys.lines.length; k++){
                            var len = d3.select(svg[0][0]).selectAll('g.dot')
                            for(var l = 0; l < d3.select(len[0][k]).selectAll('circle')[0].length; l++){
                                var cir = d3.select(len[0][k]).selectAll('circle')[0][l];
                                d3.select(cir).attr('data-drilldownkey', function(d,index){
                                    return JSON.stringify(setOfDataArray[ind][l]).slice(1, -1).split('"').join("").split(':').join("|")
                                })
                            }
                        }
                    }
                    else {
                    }
                }
            }
            
            //--------------------------------------------------------
            
            groups.selectAll('text').on('mousemove', function (d,i){
                                         
                 var root = targetElement
                 var m = d3.mouse(root.node());
                 m[0] += 0
                 m[1] += 0
                 
                 var valueForGrpBarChartToolTip;
                 if(d.y.toString().indexOf('.') === -1) { valueForGrpBarChartToolTip = d.rectValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); }
                 else { valueForGrpBarChartToolTip = d.rectValue; }
                 
                tooltipForStkGrpBarsWithLineChart.select('.tooltip-label1-class').html(options.keys.labels[1] + " : " + d.rectTopLabel)
                tooltipForStkGrpBarsWithLineChart.select('.tooltip-label2-class').html(options.keys.labels[0] + " : " + d.rectBottomLabel)
                tooltipForStkGrpBarsWithLineChart.select('.count').html(d.rectName + " : " + valueForGrpBarChartToolTip)
                tooltipForStkGrpBarsWithLineChart.style('visibility', 'visible')
                tooltipForStkGrpBarsWithLineChart.select('hr').style("background-color", d.rectColor)
                tooltipForStkGrpBarsWithLineChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-20) + "px").style("display","block")
                                        
                if(options.keys.toolTipLabel.length > 0){
                    for(ind = 0; ind < options.keys.toolTipLabel.length; ind++){
                        tooltipForStkGrpBarsWithLineChart.select('.tooltip-additional-label' + ind + '-class')
                        .html(options.keys.toolTipLabel[ind] + " : " + setOfDataArray[d.groupIndex][i][options.keys.toolTipLabel[ind]])
                    }
                }
                                        
             })
            .on('mouseout', function(){ tooltipForStkGrpBarsWithLineChart.style("display","none") })
            
            groups.selectAll('rect').on('mousemove', function (d,i){
                   
                var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                
                var valueForGrpBarChartToolTip;
                if(d.y.toString().indexOf('.') === -1) { valueForGrpBarChartToolTip = d.rectValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); }
                else { valueForGrpBarChartToolTip = d.rectValue; }
                    
                tooltipForStkGrpBarsWithLineChart.select('.tooltip-label1-class').html(options.keys.labels[1] + " : " + d.rectTopLabel)
                tooltipForStkGrpBarsWithLineChart.select('.tooltip-label2-class').html(options.keys.labels[0] + " : " + d.rectBottomLabel)
                tooltipForStkGrpBarsWithLineChart.select('.count').html(d.rectName + " : " + valueForGrpBarChartToolTip)
                tooltipForStkGrpBarsWithLineChart.style('visibility', 'visible')
                tooltipForStkGrpBarsWithLineChart.select('hr').style("background-color", d.rectColor)
                tooltipForStkGrpBarsWithLineChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-20) + "px").style("display","block")
                                        
                if(options.keys.toolTipLabel.length > 0){
                    for(ind = 0; ind < options.keys.toolTipLabel.length; ind++){
                        tooltipForStkGrpBarsWithLineChart.select('.tooltip-additional-label' + ind + '-class')
                        .html(options.keys.toolTipLabel[ind] + " : " + setOfDataArray[d.groupIndex][i][options.keys.toolTipLabel[ind]])
                    }
                }
                                        
            })
            .on('mouseout', function(){ tooltipForStkGrpBarsWithLineChart.style("display","none") })
            
            circles.on('mousemove', function (d,i){
                       
                   var root = targetElement
                   var m = d3.mouse(root.node());
                   m[0] += 0
                   m[1] += 0
                   
                   var valueForLineChartToolTip;
                   if(d.value.toString().indexOf('.') === -1) { valueForLineChartToolTip = d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); }
                   else { valueForLineChartToolTip = d.value; }
                   
                   tooltipForStkGrpBarsWithLineChart.select('.tooltip-label2-class').html(options.keys.labels[0] + " : " + d.label)
                   tooltipForStkGrpBarsWithLineChart.select('.count').html(valueForLineChartToolTip)
                   tooltipForStkGrpBarsWithLineChart.style('visibility', 'visible')
                   tooltipForStkGrpBarsWithLineChart.select('hr').style("background-color", d3.select(this).style("fill") )
                   tooltipForStkGrpBarsWithLineChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-20) + "px").style("display","block")
                   
                   if(options.keys.toolTipLabel.length > 0){
                       for(ind = 0; ind < options.keys.toolTipLabel.length; ind++){
                           tooltipForStkGrpBarsWithLineChart.select('.tooltip-additional-label' + ind + '-class')
                           .html(options.keys.toolTipLabel[ind] + " : " + setOfDataArray[d.groupIndex][i][options.keys.toolTipLabel[ind]])
                       }
                   }
            })
            .on('mouseout', function(){ tooltipForStkGrpBarsWithLineChart.style("display","none"); })
            
            svgArray.push(svgPanelForStkGrpBarsWithLineChart)
            rectsGroupArray.push(groups)
            linesGroupArray.push(lines)
            circlesGroupArray.push(circles)
            xAxisLabelsArray.push(xAxisLabels)
            linesDataSetArray.push(dataSetForLineChart)
            
            x0Array.push(x0)
            x1Array.push(x1)
            yArray.push(y)
            
            var xScale1GlobalVar; // storing the new yScale when parent div is resized.
            var yScale1GlobalVar; // storing the new yScale when parent div is resized.
            var newHeightVar; // storing the new height when parent div is resized.
            
			//setTimeout(function(){ resizedFuctionForStkGrpBarsWithLineChart() },1000)
			
            window.addEventListener('resize', function(event){  resizedFuctionForStkGrpBarsWithLineChart()   });
            
            $(function() {
              $("#" + targetElement[0][0].id).resizable({
                    resize: function(event, ui) {
                            divWidth = ui.size.width;
                            divHeight = ui.size.height;
                            resizedFuctionForStkGrpBarsWithLineChart();
                    }
                });
            });
            
            function resizedFuctionForStkGrpBarsWithLineChart()
            {
                
                if((svgPanelForYAxis.node().getBoundingClientRect().width) && (svgPanelForYAxis.node().getBoundingClientRect().height) > 0){
                    var marginsForYAxis = {top: 60 , right: 0, bottom: 80, left: svgPanelForYAxis.node().getBoundingClientRect().width - 1}, //originally top: 42, left: 80
                    widthsForYAxis = (svgPanelForYAxis.node().getBoundingClientRect().width) - marginsForYAxis.left - marginsForYAxis.right,
                    heightsForYAxis = (svgPanelForYAxis.node().getBoundingClientRect().height) - marginsForYAxis.top - marginsForYAxis.bottom;
                    
                    // Left Y Axis
                    yForYAxis.domain([0, d3.sum(yMaxValueArray)]) .range([heightsForYAxis, 0]); // for margin.top: 35 d3.max(yMaxValueArray) * 1.31
                    yAxis.scale(yForYAxis) .orient("left");
                    
                    svgPanelForYAxis.select("g") .attr("transform", "translate(" + marginsForYAxis.left + "," + marginsForYAxis.top + ")").style("position","absolute")
                    .call(yAxis)
                    
                    
                    // Right Y Axis
                    rgtYForYAxis.domain([0, d3.max(rgtYAxisYMaxValueArray)]) .range([heightsForYAxis, 0]); // for margin.top: 35 d3.max(yMaxValueArray) * 1.31
                    rgtYAxis.scale(rgtYForYAxis).orient("right");
                    
                    svgPanelForRightYAxis.select("g").attr("transform", "translate(" + 1 + "," + marginsForYAxis.top + ")").style("position","absolute")
                    .call(rgtYAxis)
                }
                
                if((svgPanelForStkGrpBarsWithLineChart.node().getBoundingClientRect().width) && (svgPanelForStkGrpBarsWithLineChart.node().getBoundingClientRect().height) > 0){
                    
                    if(showOrHideCommentsBtnForStkGrpBarsWithLineChart == true){
                        shuffleBtnForStkGrpBarsWithLineChart.style('margin-left', "2px")
                        refreshBtnForStkGrpBarsWithLineChart.style('margin-left', "2px")
                        commentsBtnForStkGrpBarsWithLineChart.style('margin-left', "2px")
                        menuButtonForStkGrpBarsWithLineChart.style('right', '0')
                    }
                    else if(showOrHideCommentsBtnForStkGrpBarsWithLineChart == false){
                        //commentsBtnForGroupedBarChart.style('right', '0')
                        shuffleBtnForStkGrpBarsWithLineChart.style('margin-left', "2px")
                        refreshBtnForStkGrpBarsWithLineChart.style('margin-left', "2px")
                        commentsBtnForStkGrpBarsWithLineChart.style('display','none')
						menuButtonForStkGrpBarsWithLineChart.style('right', '0')
                    }
                    
                    optionsButtonPanelForStkGrpBarsWithLineChart.style('right', '0')
                    
                    for(var j = 0; j < svgArray.length; j++){
                        var s = d3.select(svgArray[j][0][0])
                        var ss = svgArray[j][0][0]
                        
                        var margin1 = {top: 60 , right: 0, bottom: 80, left: -1}, //originally top: 42, left: 80
                        width1 = (svgPanelForStkGrpBarsWithLineChart.node().getBoundingClientRect().width) - margin1.left - margin1.right,
                        height1 = svgPanelForStkGrpBarsWithLineChart.node().getBoundingClientRect().height - margin1.top - margin1.bottom;
                        newHeightVar = height1;
                        
                        y.domain([0, d3.max(xMaxArray)]) .range([0, height1]);
                        
                        x0 .domain(monthsArrayForStkGrpBarsWithLineChart[j]) .rangeRoundBands([0, width1], 0.08,0.35); //originally 0.25
                        
                        x1.domain(d3.range(finalNewNewArray.length)) .rangeBands([0, x0.rangeBand()]);
                        
                        xAxis.scale(x0) .orient("bottom");
                        
                        xScale1GlobalVar = x0;
                        yScale1GlobalVar = y;
                        
                        var svg1 = s
                        
                        d3.select(svgArray[j][0][0]).select("svg").select(".x.axis.bottomclass") .attr('transform', 'translate(0,' + height1 + ')') .call(xAxis)
                        .selectAll("text").data(xAxisLabelsArray[j]) .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') .attr("transform", function(d) { return "rotate(-50)" })
                        .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
                        .text(function(d,i) { if(d.length > 9) { return d.substring(0,9)+'...'; } else { return d; } })
                        
                        x2.domain(setOfDataArray[j].map(function(d) { return d[options.keys.labels[1]]; })) .rangeRoundBands([0, width1], 0.25);
                        
                        xAxisTop.scale(x2) .orient("top")
                        
                        d3.select(svgArray[j][0][0]).select("svg").select(".x.axis.topclass").attr("transform", "translate(0," + -25 + ")") .call(xAxisTop)
                        
                        var groupsArray = [];
                        
                        var grp = rectsGroupArray[j][0]
                        
                        var newX0 = x0Array[j].domain(months) .rangeRoundBands([0, width1], 0.08,0.35); // originally 0.25
                        
                        
                        for(var ii = 0; ii < grp.length; ii++){
                            
                            d3.select(grp[ii]).selectAll("rect").data(function(d,i) { groupsArray[ii] = x1(ii); return d; })
                            .attr("width", x0.rangeBand())
                            .attr("height", function (d) { return y(d.x); })
                            .attr("x", function(d, i) {   return x0(d.y); })
                            .attr("y", function(d) { return  height1 - y(d.x0) - y(d.x); })
                            
                            d3.select(grp[ii]).selectAll("text") .attr("x", function(d,i) { return x0(d.y) + x0.rangeBand()/2; })
                            .attr("y", function(d) { return (height1 - y(d.x0) - y(d.x))+(y(d.x)/1.5);})
                            
                        }
                        
                        //---------------------- Resizing lines -----------------------
                        
                        xForLine.domain(linesDataSetArray[j].map(function(d,i) { return d[options.keys.labels[0]];})).rangePoints([0, width1],0.0);
                        
                        x1ForLine.domain(linesDataSetArray[j].map(function(d,i) { return d[options.keys.labels[0]]; })) .rangePoints([0, width1], 1.70)
                        
                        var yyForLine = d3.scale.linear() .domain([0, d3.max(maxValueArrayForLineYAxis, function(d) { return +d; })] ) .range([height1, 0]);
                        
                        //yAxisForLine.scale(yyForLine) .orient("left");
                        
                        //xAxisForLine.scale(xForLine) .orient("bottom");
                        
                        line.x(function (d) { return x1ForLine(d['label']); }) .y(function (d) { return yyForLine(+d["value"]); });
                        
                        var linesGrp = linesGroupArray[j][0]
                        var circlesGrp = circlesGroupArray[j]
                        
                        
                        for(var ii = 0; ii < linesGrp.length; ii++){
                            d3.select(linesGrp[ii]).attr("d", function (d,i) { return line(d.Data); })
                        }
                        
                        for(var ii = 0; ii < circlesGrp.length; ii++){
                            for(var iii = 0; iii < circlesGrp[ii].length; iii++){
                                d3.select(circlesGrp[ii][iii]).attr("cx", function(d,i) { return x1ForLine(d['label']); }) .attr("cy", function(d,i) {  return yyForLine(+d["value"]); })
                            }
                        }
                        
                        //-------------------------------------------------------------
                        
                        
                        // Aligning Legend (vertically)
                        var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(legendDivForStkGrpBarsWithLineChart[0][0].style.width) / 100)
                        var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(legendDivForStkGrpBarsWithLineChart[0][0].style.height) / 100)
                        
                        var legendRectSize = 11;
                        var legendSpacing = 4;
                        
                        legend.transition().duration(0).attr('transform', function(d, i) {
                             var eachRectHeight = legendRectSize + legendSpacing;
                             var offset =  eachRectHeight * colours.domain().length / 2;
                             var horz = 5;
                             var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * legendItems.length))/2.0; // originally 2.0
                             
                             return 'translate(' + horz + ',' + vert + ')';
                         })
                        
                        
                    } // svgArrary for loop
                    
                    colWidth = []; 
					
                    d3.select(".theadClassForStkGrpBarsWithLineChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                           d.forEach(function(dd,j){
                                 colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                         })
                                                                                                               })
                    tablePanelForStkGrpBarsWithLineChart.select(".thead1ClassForStkGrpBarsWithLineChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                         d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
                    })
                    
                } // checking svgPanelForColumnChart width & height panel size function ends here.
            } // resizedFuctionForStkGrpBarsWithLineChart*/
            
        } // for(var ind = 0; ind < setOfDataArray.length; ind++) Creating SVGs for loop
        
        //------------------ Adding legend section ----------------
        
        var legendItems = [];
        var legendItemsArrayLen = 0;
        var legendDotColors = []
        for(var i = 0; i < options.keys.groupBars.length; i++){ legendItems.push(options.keys.groupBars[i]); legendItemsArrayLen = legendItems.length; legendDotColors.push(colours(i))  }
        for(var i = 0; i < options.keys.lines.length; i++){ legendItems.push(options.keys.lines[i]); legendDotColors.push(coloursForLinesAndCircles(i)); }
        
        //-------------- Adding legend section ---------------
        var svgLegendPanelForStkGrpBarsWithLineChart = legendDivForStkGrpBarsWithLineChart .append('svg')  .attr("class","")
        .style("background-color", options.BGcolor) .style('position',"absolute").style('width', 100 + "%") .style('height', 100 + "%") .style("left",0 + "%").style("top",0 + "%")
        
        var legend = svgLegendPanelForStkGrpBarsWithLineChart.append("g") .attr("class", "legend") .attr("height", "100%") .attr("width", "100%")
        .attr('transform', 'translate(0,20)') .style("background-color", options.BGcolor)
        
        //Create colour squares
        var legendGroup = legend.selectAll('rect') .data(legendItems) .enter() .append("rect") .attr("x", 5)
        .attr("y", function(d, i){ return i * 16;}) .attr("width", 14) .attr("height", 14) .attr("rx",10) .attr("ry",10)
        .style("fill", function(d, i){ return legendDotColors[i];}) .style("cursor","auto").attr("legenddotcount",function(d,i){ if(i >= legendItemsArrayLen){ return i - legendItemsArrayLen; } })
        
        //Create text next to squares
        legend.selectAll('text') .data(legendItems) .enter() .append("text") .attr("x", 25) .attr("y", function(d, i){ return i * 16 + 11.8;})
        .attr("fill", "#00001c") .text(function(d,i) { if(d.length > 10)
            return d.substring(0,10)+'...';
            else
            return d; }) .style('font-size', '14px') .attr("fill","#00001c") .style("font-family","Verdana,sans-serif")
        
        // Aligning Legend (vertically)
        var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(legendDivForStkGrpBarsWithLineChart[0][0].style.width) / 100)
        var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(legendDivForStkGrpBarsWithLineChart[0][0].style.height) / 100)
        
        var legendRectSize = 11;
        var legendSpacing = 4;
        
        legend.transition().duration(0).attr('transform', function(d, i) {
             var eachRectHeight = legendRectSize + legendSpacing;
             var offset =  eachRectHeight * colours.domain().length / 2;
             var horz = 5;
             var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * legendItems.length))/2.0; // originally 2.0
             
             return 'translate(' + horz + ',' + vert + ')';
         })
        
        
        
        legendGroup.on('mouseover',function(d,index){
                      
            var legDotCountVar = d3.select(legend[0][0]).selectAll("rect")
                       
           if(options.keys.groupBars.length > 1){ // to check if the stack set is more than 1
           
               // to check whether the widget is being resized or not (to save new xScale)
               if(yScale1GlobalVar == undefined){ yScale1GlobalVar = y; }
               
               if(newHeightVar == undefined){ newHeightVar = height }
               
                   for(var i = 0; i<rectsGroupArray.length; i++){
                       var grp = rectsGroupArray[i][0]
                       for(var ii = 0; ii < grp.length; ii++){
                           
                           d3.select(grp[ii]).selectAll("text").style('display','none')
                           
                           d3.select(grp[index]).selectAll("text").style('display','block')
                           .transition().duration(1000).ease('bounce').attr("y", function(d,i) { return (newHeightVar - yScale1GlobalVar(d.x) - 6) })
                           .style("fill", "#00001c") .style("text-shadow","0px 0px 0px rgba(34,34,34,0.6)") .style('font-size',"12px")
                           
                           d3.select(grp[ii]).selectAll("rect").style('display','none')
                           
                           d3.select(grp[index]).selectAll('rect').style('display','block')
                           .transition().duration(1000).ease('bounce')
                           .attr("y", function(d,i) { return newHeightVar - yScale1GlobalVar(d.x) })
                       }
                   }
            }
              
           if(parseInt(d3.select(legDotCountVar[0][index]).attr("legenddotcount")) >= 0 && d3.select(legDotCountVar[0][index]).attr("legenddotcount") !== null){
                       
               var lineLen = lines.node().getTotalLength();
               var dashLen = options.data.length;
               var ddLen = dashLen;
               var darray = dashLen;
               while(ddLen < lineLen){
                   darray+=","+dashLen+","+dashLen;
                   ddLen+=dashLen;
               }
                       
               for(var lineIndex = 0; lineIndex < linesGroupArray.length; lineIndex++){
                   
                   d3.select(linesGroupArray[lineIndex][0][parseInt(d3.select(legDotCountVar[0][index]).attr("legenddotcount"))]).style('stroke-width',2.5)
                   .attr("stroke-linecap", "round").attr("stroke-dasharray", darray + ","+lineLen) .attr("stroke-dashoffset", lineLen)
                   .transition().duration(5000).ease("linear").attr("stroke-dashoffset", 0);
               }
            }
        })
        
        legendGroup.on('mouseout',function(d,index){
                
            var legDotCountVar = d3.select(legend[0][0]).selectAll("rect")
                       
           if(yScale1GlobalVar == undefined){ yScale1GlobalVar = y; }
           
           if(newHeightVar == undefined){ newHeightVar = height; }
           
            for(var i = 0; i<rectsGroupArray.length; i++){
               var grp = rectsGroupArray[i][0]
               for(var ii = 0; ii < grp.length; ii++){
                   
                   d3.select(grp[ii]).selectAll("text").style('display','block')
                   
                   d3.select(grp[index]).selectAll("text").style('display','block').transition().duration(1000).ease('bounce')
                   .attr("y", function(d) { return (newHeightVar - yScale1GlobalVar(d.x0) - yScale1GlobalVar(d.x))+(yScale1GlobalVar(d.x)/1.5);})
                   .style("fill", "#ffffff") .style("text-shadow","1px 0px 1px rgba(34,34,34,0.6)") .style('font-size',"12px")
                   
                   d3.select(grp[ii]).selectAll("rect").style('display','block')
                   
                   d3.select(grp[index]).selectAll('rect').style('display','block').transition().duration(1000).ease('bounce')
                   .attr("y", function(d) { return  newHeightVar - yScale1GlobalVar(d.x0) - yScale1GlobalVar(d.x); })
                }
            }
                       
           if(parseInt(d3.select(legDotCountVar[0][index]).attr("legenddotcount")) >= 0 && d3.select(legDotCountVar[0][index]).attr("legenddotcount") !== null){
               for(var lineIndex = 0; lineIndex < linesGroupArray.length; lineIndex++){
                   d3.select(linesGroupArray[lineIndex][0][parseInt(d3.select(legDotCountVar[0][index]).attr("legenddotcount"))]).style('stroke-width',2.5) .transition().duration(0)
                   .attr("stroke-dasharray", options.data.length + ","+ 0)  .attr("stroke-dashoffset", 0)
               }
           }
        })
        
        // ----------------------- adding table section ------------------
        var tablePanelForStkGrpBarsWithLineChart =  targetElement.append("div") .attr("id",targetElement[0][0].id + "holderForStkGrpBarsWithLineChartTableID")
        .attr("class","scrollingDivForTable-Class tableDivForStkGrpBarsWithLineChart" + targetElement[0][0].id) .style('background-color',"#ffffff") .style('position','absolute')
        .style("display","block") .style("overflow","hidden") .style("width", function(d) {  return 100.0 + "%"; })
        .style("height", function(d) { return 30 + "%"; }) .style("left",0 + "%").style("z-index",10)
        
        $( '.scrollingDivForTable-Class').bind( 'mousewheel DOMMouseScroll', function ( e ) {
               var e0 = e.originalEvent,
               delta = e0.wheelDelta || -e0.detail;
               
               this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
               e.preventDefault();
           });
        
        if(options.showTitle == true ){
            tablePanelForStkGrpBarsWithLineChart.style("top",70.0  + "%")
        }
        else if(options.showTitle == false  ){
            tablePanelForStkGrpBarsWithLineChart.style("top",70.0  + "%")
            
        }
        tablePanelForStkGrpBarsWithLineChart.html('<table class = "tableClassForStkGrpBarsWithLineChart' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                         '<thead class = "theadClassForStkGrpBarsWithLineChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForStkGrpBarsWithLineChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                                         '<tbody class = "tBodyClassForStkGrpBarsWithLineChart' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                         '</table>'
                                         )
        
        tablePanelForStkGrpBarsWithLineChart.select('table').attr("id",targetElement[0][0].id + "tableID")
        
        // Show or Hide Table scroll bar when mouseover on widget
        targetElement.on('mouseover',function(){ tablePanelForStkGrpBarsWithLineChart.style("overflow","auto") })
        targetElement.on('mouseout',function(d){ tablePanelForStkGrpBarsWithLineChart.style("overflow","hidden") })
        
        //var tableDataForStkGrpBarChart = [];
        //if(options.dataForTable.length > 0) { tableDataForStkGrpBarChart = options.dataForTable; }
        //else { tableDataForStkGrpBarChart = options.data; }
        
        tableDataForStkGrpBarsWithLineChart = options.data;
        
        var thead = tablePanelForStkGrpBarsWithLineChart.select("thead").selectAll("th") .data(d3.keys(tableDataForStkGrpBarsWithLineChart[0]))
        .enter().append("th") .text(function(d){return d.charAt(0) .toUpperCase() + d.substr(1)}) .style("cursor","pointer") .style("min-width","100px")
        
        var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff") //f4f4f4
        .style("position","relative")
        
        var thead1 = d3.select(".thead1ClassForStkGrpBarsWithLineChart" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tableDataForStkGrpBarsWithLineChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff") //f4f4f4
        .style("position","relative")
        
        var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
        .attr("id", "ascendingIconIDForStkGrpBarsWithLineChart") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
        
        var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
        .attr("id", "descendingIconIDForStkGrpBarsWithLineChart") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
        
        var tr = tablePanelForStkGrpBarsWithLineChart.select("tbody").selectAll("tr") .data(tableDataForStkGrpBarsWithLineChart).enter().append("tr")
        .attr("id", function(d,i) { return "slice" + i })
        
        // cells
        var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d})
        .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
        
        var $table = $('.tableClassForStkGrpBarsWithLineChart' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
        
        d3.select(".theadClassForStkGrpBarsWithLineChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
            d.forEach(function(dd,j){
				colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
			})
		})
        
        $(".thead1ClassForStkGrpBarsWithLineChart" + targetElement[0][0].id).insertAfter('.tBodyClassForStkGrpBarsWithLineChart' + targetElement[0][0].id)
        
        $(".thead1ClassForStkGrpBarsWithLineChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForStkGrpBarsWithLineChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
        
        tablePanelForStkGrpBarsWithLineChart.select(".thead1ClassForStkGrpBarsWithLineChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                 d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
             })
        
        $('.tableDivForStkGrpBarsWithLineChart' + targetElement[0][0].id).scroll(function () {
                                                                        
                $(".thead1ClassForStkGrpBarsWithLineChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForStkGrpBarsWithLineChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
                
        })
        
        var sortOrder = false;
        thead1.on("click",function(k,index){
                  
                  sortOrder = !sortOrder;
                  
                  tablePanelForStkGrpBarsWithLineChart.select(".thead1ClassForStkGrpBarsWithLineChart" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                                                                                                                                    
                        if (sortOrder) {
                        
                            if(i == index){
                            d3.select(this).select('svg').select('#descendingIconIDForStkGrpBarsWithLineChart').style("visibility", "hidden")
                            d3.select(this).select('svg').select('#ascendingIconIDForStkGrpBarsWithLineChart').style("visibility", "visible")
                            }
                            else {
                            d3.select(this).select('svg').select('#descendingIconIDForStkGrpBarsWithLineChart').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForStkGrpBarsWithLineChart').style("visibility", "visible")
                            }
                            }
                            else{
                            
                            if(i == index){
                            d3.select(this).select('svg').select('#descendingIconIDForStkGrpBarsWithLineChart').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForStkGrpBarsWithLineChart').style("visibility", "hidden")
                            }
                            else {
                            d3.select(this).select('svg').select('#descendingIconIDForStkGrpBarsWithLineChart').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForStkGrpBarsWithLineChart').style("visibility", "visible")
                            }
                        }
                    })
                  
                  
                  var monthTruOrFalAryForStkGrpBarsWithLineChart = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
                  
                  tr.sort(function(a, b) {
                          
                          if (sortOrder) {
                          var monthsArrayForStkGrpBarsWithLineChart = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                          } else {
                          var monthsArrayForStkGrpBarsWithLineChart = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                          }
                          
                          monthTruOrFalAryForStkGrpBarsWithLineChart = []; gotMonthArray = [];
                          tableDataForStkGrpBarsWithLineChart.forEach(function(d,i){
                                 var da = d[k].toString().substring(0,3).toLowerCase()
                                 if(monthsArrayForStkGrpBarsWithLineChart.indexOf(da) >= 0){
                                 monthTruOrFalAryForStkGrpBarsWithLineChart.push(true)
                                 gotMonthArray.push(da);
                                 }
                                 else {
                                 monthTruOrFalAryForStkGrpBarsWithLineChart.push(false)
                                 }
                             })
                          
                          if(monthTruOrFalAryForStkGrpBarsWithLineChart.indexOf(false) == -1){ // true
                          
                          monthArray = []; monthArrayCount = [];
                          gotMonthArray.forEach(function(dd,j){
                                                var index1 = monthsArrayForStkGrpBarsWithLineChart.indexOf(dd.substring(0,3))
                                                if(monthArrayCount.indexOf(index1) >= 0){
                                                index1 = 12 + index1;
                                                }
                                                monthArray.push(index1);
                                                monthArrayCount.push(index1)
                                                })
                          returnArray = []
                          monthArray.sort(function(aa, bb) {
                                          returnArray.push(+aa - +bb)
                                          return +aa - +bb;
                                          })
                          
                          sortTableFunc()
                          return returnArray[ind++];
                          } //  if true (if jan feb if block)
                          else {
                          var data = +a[k];
                          
                          if(!isNaN(data)){
                          
                          if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                          else { return d3.descending(+a[k], +b[k]); }
                          }
                          else if(!isNaN(Date.parse(a[k]))){
                          
                          if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                          else { return new Date(b[k]) - new Date(a[k]) }
                          }
                          else {
                          
                          if (sortOrder) { return d3.ascending(a[k], b[k]); }
                          else { return d3.descending(a[k], b[k]); }
                          }
                          } // if not jan feb else block
                          }); // tr
                  
		})
        
        function sortTableFunc(){
            
            var table = tablePanelForStkGrpBarsWithLineChart.select('table');
            var rows = table.selectAll('tr').data(tableDataForStkGrpBarsWithLineChart);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0).style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500)
            .style('opacity', 1.0).style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
        }
        
        // Main Table Styling
        tablePanelForStkGrpBarsWithLineChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
        .style("color","#00001c")
        .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4") 
        tablePanelForStkGrpBarsWithLineChart.selectAll('td').style("height","25px") .style("border", "1px solid #dddddd") .style("font-size","12px").style("font-weight","Normal").style("color","#00001c")
        
        //additionally 
        tablePanelForStkGrpBarsWithLineChart.selectAll('th').style('background-color',"#ffffff").style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
        tablePanelForStkGrpBarsWithLineChart.selectAll('td').style('background-color',"#ffffff").style("border-style","none").style("color","#00001c")
        
        //b1da9f
        tablePanelForStkGrpBarsWithLineChart.selectAll('table') . style("border-collapse","collapse")
        tablePanelForStkGrpBarsWithLineChart.selectAll('table tr:first-child th').style("border-top","0px")
        tablePanelForStkGrpBarsWithLineChart.selectAll('table tr:last-child td').style("border-bottom","0px")
        tablePanelForStkGrpBarsWithLineChart.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
        tablePanelForStkGrpBarsWithLineChart.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")
        
        if(showOrHideTableForStkGrpBarsWithLineChart == false){
            tablePanelForStkGrpBarsWithLineChart.style("display","none")
        }
        else if(showOrHideTableForStkGrpBarsWithLineChart == true){
            tablePanelForStkGrpBarsWithLineChart.style("display","block")
        }

        
        //By default calling the resized function first time (to align table's th and td).
        setTimeout(function(){ resizedFuctionForStkGrpBarsWithLineChart() },1000) //resizedFuctionForStkGrpBarsWithLineChart()
    }, // stackedGroupedBarsWithLineChart
    
    // ************************************************** Stacked Bar with Line Chart  **************************************************
    stackedBarWithLinesChart: function(targetElement, options){
        
        isChartCalled++;

        var chartName = "STACKEDBARWITHLINESCHART";
       
        acinfotech.allCharts(targetElement,options,chartName)

        targetElement.style("min-width", "350px").style("min-height", "350px").style("background-color", options.BGcolor)

        var showOrHideTableForStkBarWithLinesChart;
        var showOrHideCommentsForStkBarWithLinesChart;
        var showOrHideCommentsBtnForStkBarWithLinesChart = true;

        if((options.showTable == false) || (options.showTable == true)){
            showOrHideTableForStkBarWithLinesChart = options.showTable    
        }
        else{
            showOrHideTableForStkBarWithLinesChart = false;
        }

        // Show or Hide comments
        if (options.showComments == true || false) {
            showOrHideCommentsForStkBarWithLinesChart = options.showComments;
        }
        else {
            showOrHideCommentsForStkBarWithLinesChart = false;
        }
        
        if (options.comments.length == 0){ 
            showOrHideCommentsForStkBarWithLinesChart = false;
            showOrHideCommentsBtnForStkBarWithLinesChart = false;
        }

        if ((showOrHideTableForStkBarWithLinesChart == true) && (showOrHideCommentsForStkBarWithLinesChart == true)){
            showOrHideTableForStkBarWithLinesChart = true;
            showOrHideCommentsForStkBarWithLinesChart = false;
        }
        else if ((showOrHideTableForStkBarWithLinesChart == false) && (showOrHideCommentsForStkBarWithLinesChart == false)){
            showOrHideTableForStkBarWithLinesChart = false;
            showOrHideCommentsForStkBarWithLinesChart = false;
        }

        var chartTitlePanelForStkBarWithLinesChart =  targetElement.append("div").style("background-color", options.BGcolor) .style("position","absolute").style('background-color',"#ffffff")
        .style("text-indent","6px")
        
		var optsBtnPanelForStkBarWithLinesChart = targetElement.append('div').style('width',"25px").style('height',"130px").style('position','absolute')
        .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px")
        .style('right', '0')
        .style("min-width","25px")
        .style("border-style","none").style("border-left", "solid #fcfcfc  1px")
		
        var filterBtnForStkBarWithLinesChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','80px') .style("cursor","pointer").style("display","none")
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var filterBtnImgVar = document.createElement("IMG");
        filterBtnImgVar.src = "images/filterIcon.png";
        filterBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.8;")
        filterBtnForStkBarWithLinesChart[0][0].appendChild(filterBtnImgVar)

        var refreshBtnForStkBarWithLinesChart = optsBtnPanelForStkBarWithLinesChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','105px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var refreshBtnImgVar = document.createElement("IMG");
        refreshBtnImgVar.src = "images/refreshIcon.png";
        refreshBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        refreshBtnForStkBarWithLinesChart[0][0].appendChild(refreshBtnImgVar)

        var commentsBtnForStkBarWithLinesChart = optsBtnPanelForStkBarWithLinesChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','1px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var commentsBtnImgVariable = document.createElement("IMG");
        if(options.showComments == false){
            commentsBtnImgVariable.src = "images/showCommentsIcon.png";
        }
        else if(options.showComments == true){
            commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
        }
        commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        commentsBtnForStkBarWithLinesChart[0][0].appendChild(commentsBtnImgVariable)

        var menuBtnForStkBarWithLinesChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','1px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var menuBtnImgVar = document.createElement("IMG");
        menuBtnImgVar.src = "images/menuIcon.png";
        menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
        menuBtnForStkBarWithLinesChart[0][0].appendChild(menuBtnImgVar)

        if(showOrHideCommentsBtnForStkBarWithLinesChart == true){
            filterBtnForStkBarWithLinesChart.style('margin-left', "2px")
            refreshBtnForStkBarWithLinesChart.style('margin-left', "2px")
            commentsBtnForStkBarWithLinesChart.style('margin-left', "2px")
            menuBtnForStkBarWithLinesChart.style('right', '0')
        }
        else if(showOrHideCommentsBtnForStkBarWithLinesChart == false){
            filterBtnForStkBarWithLinesChart.style('margin-left', "2px")
            refreshBtnForStkBarWithLinesChart.style('margin-left', "2px")
            //commentsBtnForStkBarWithLinesChart.style('right', '0')
            commentsBtnForStkBarWithLinesChart.style('display','none')
            menuBtnForStkBarWithLinesChart.style('right', '0')
        }

        var ismenuBtnOfStkBarWithLinesChartClicked = false;
        menuBtnForStkBarWithLinesChart.on('click', function() {

            filterPanelForStkBarWithLinesChart.style("display","none");

            stgPanDivForStkBarWithLinesChart.style("display","none") // Hiding setting panel

            if ((showOrHideTableForStkBarWithLinesChart == false) && (showOrHideCommentsForStkBarWithLinesChart == true)){
                    divLegendPanelStkBarWithLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForStkBarWithLinesChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                    .style("position","absolute");
            }
            else if ((showOrHideTableForStkBarWithLinesChart == true) && (showOrHideCommentsForStkBarWithLinesChart == false)){
                    divLegendPanelStkBarWithLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForStkBarWithLinesChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute");
            }
            else if ((showOrHideTableForStkBarWithLinesChart == false) && (showOrHideCommentsForStkBarWithLinesChart == false)){
                    divLegendPanelStkBarWithLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForStkBarWithLinesChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute");
            }


            if(ismenuBtnOfStkBarWithLinesChartClicked == false){
                ismenuBtnOfStkBarWithLinesChartClicked = true;
                optsBtnPanelForStkBarWithLinesChart.style("display","block")

            }
            else if(ismenuBtnOfStkBarWithLinesChartClicked == true){
                ismenuBtnOfStkBarWithLinesChartClicked = false
                optsBtnPanelForStkBarWithLinesChart.style("display","none")
            }

            resizedFuctionForStkBarWithLinesChart();
        })

        var tableButtonForStkBarWithLinesChart = optsBtnPanelForStkBarWithLinesChart.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top','1px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
        var tableBtnImgVar = document.createElement("IMG");
        if(showOrHideTableForStkBarWithLinesChart == false){
            tableBtnImgVar.src = "images/showTableIcon.png";
            tableButtonForStkBarWithLinesChart.attr("class","showTableClassForChartTable")
        }
        else if(showOrHideTableForStkBarWithLinesChart == true){
            tableBtnImgVar.src = "images/cancelTableIcon.png";
            tableButtonForStkBarWithLinesChart.attr("class","hideTableClassForChartTable")
        }
        tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
        tableButtonForStkBarWithLinesChart[0][0].appendChild(tableBtnImgVar)

        var settingBtnForStkBarWithLinesChart = optsBtnPanelForStkBarWithLinesChart.append("div").style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top', 28 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        var settingBtnImgVar = document.createElement("IMG");
        settingBtnImgVar.src = "images/settingsIcon.png";
        settingBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:18px; opacity:0.82;")
        settingBtnForStkBarWithLinesChart[0][0].appendChild(settingBtnImgVar)
        
        var downloadBtnForStkBarWithLinesChart = optsBtnPanelForStkBarWithLinesChart.append("div").attr("id","downloadBtnForStkBarWithLinesChart-ID-" + targetElement[0][0].id)
        .style("width","20px").style("height","20px").style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff")
        .style('margin-left','2px').style('top', 54 + 'px').style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        
        acinfotech.downloadFunctionality("downloadBtnForStkBarWithLinesChart-ID-" + targetElement[0][0].id,targetElement)
        
        var svgPanelForStkBarWithLinesChart = targetElement .append('svg') 
        .attr("id","svgPanelIDForStkBarWithLinesChart" + targetElement[0][0].id).style("background-color", options.BGcolor).style("position","absolute")
        .style("border","0px solid #d0d0d0")

        var commentsPanelDivForStkBarWithLinesChart = targetElement.append("div") .attr("class","commentsPanelClassForSBLChart") 
        .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
		.style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
        .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)

        commentsPanelDivForStkBarWithLinesChart.on('click',function(d){
            $('.commentsClassForStkBarWithLinesChart' + targetElement[0][0].id).focus()
        })

        if(options.showTitle == true){
            
            chartTitlePanelForStkBarWithLinesChart.style("width", function(d) {  return 100.00 + "%"; }) .style("background-color", options.BGcolor).style("height", function(d) { return 8 + "%"; })
            .html('<div  style="width: 100%; height:0%;  position: absolute; top:25.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')
                
            if ((showOrHideTableForStkBarWithLinesChart == false) && (showOrHideCommentsForStkBarWithLinesChart == true)){

                var commentsForStkBarWithLinesChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify') .attr('class','commentsClassForStkBarWithLinesChart' + targetElement[0][0].id)

                   svgPanelForStkBarWithLinesChart.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .append('g')
                   commentsPanelDivForStkBarWithLinesChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForStkBarWithLinesChart[0].outerHTML.toString())

            }
            else if ((showOrHideTableForStkBarWithLinesChart == true) && (showOrHideCommentsForStkBarWithLinesChart == false)){

                    svgPanelForStkBarWithLinesChart.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .append('g')
                    commentsPanelDivForStkBarWithLinesChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForStkBarWithLinesChart == false) && (showOrHideCommentsForStkBarWithLinesChart == false)){
                    svgPanelForStkBarWithLinesChart.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .append('g')
                    commentsPanelDivForStkBarWithLinesChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            
            var margin = {top: 10 , right: 20, bottom: 80, left: 20}, //originally top: 42, left: 80
            width = (svgPanelForStkBarWithLinesChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = (svgPanelForStkBarWithLinesChart.node().getBoundingClientRect().height) - margin.top - margin.bottom;
            
        }
        else if(options.showTitle == false){
            chartTitlePanelForStkBarWithLinesChart.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });
            
            if ((showOrHideTableForStkBarWithLinesChart == false) && (showOrHideCommentsForStkBarWithLinesChart == true)){

                var commentsForStkBarWithLinesChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify')

                   svgPanelForStkBarWithLinesChart.attr('width', 75 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .append('g')
                   commentsPanelDivForStkBarWithLinesChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForStkBarWithLinesChart[0].outerHTML.toString())

            }
            else if ((showOrHideTableForStkBarWithLinesChart == true) && (showOrHideCommentsForStkBarWithLinesChart == false)){

                    svgPanelForStkBarWithLinesChart.attr('width', 75 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .append('g')
                    commentsPanelDivForStkBarWithLinesChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForStkBarWithLinesChart == false) && (showOrHideCommentsForStkBarWithLinesChart == false)){
                    svgPanelForStkBarWithLinesChart.attr('width', 75 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .append('g')
                    commentsPanelDivForStkBarWithLinesChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }

            var margin = {top: 10 , right: 20, bottom: 80, left: 20}, //originally top: 42, left: 80
            width = (svgPanelForStkBarWithLinesChart.node().getBoundingClientRect().width) - margin.left - margin.right,
            height = svgPanelForStkBarWithLinesChart.node().getBoundingClientRect().height - margin.top - margin.bottom;
        }

        var colours;

        // checking color set for bubbles and legend dots
        if(options.colorSet === undefined){
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#2bc65a", "#ea0b0b", "#2a7bb2", "#ba912a", "#9a270c", "#339966", "#808000","#307D7E","#AF7817","#00cc77","#009bb9","#fbc004"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "one"){
            options.colorSet = "one" // green 49ac2d
            colours = d3.scale.ordinal() .range(["#2bc65a", "#ea0b0b", "#2a7bb2", "#ba912a", "#9a270c", "#339966", "#808000","#307D7E","#AF7817","#00cc77","#009bb9","#fbc004"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            options.colorSet = "two"
            colours = d3.scale.ordinal().range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            options.colorSet = "three"
            colours = d3.scale.ordinal().range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        }
        else
        {
            options.colorSet = "one"
            colours = d3.scale.ordinal() .range(["#2bc65a", "#ea0b0b", "#2a7bb2", "#ba912a", "#9a270c", "#339966", "#808000","#307D7E","#AF7817","#00cc77","#009bb9","#fbc004"]);
        }

        //------------------ Settings panel DIV and everything within it section begins here ------------------
        
        var stgPanDivForStkBarWithLinesChart = targetElement.append('div').style('width',"100%").style('height',"40%").attr("class","stgPanDivForStkHoriChart" + targetElement[0][0].id)
        .style('position','absolute').style('margin-left', "0px").style('border-top',"1px solid #f0f0f0").style('border-bottom',"1px solid #e5e5e5")
        .style("background-color",'#fcfcfc').style("z-index",90) .style("display","none") .style('top', 60.0 + "%") .style('height',40 + "%")

        $( '.stgPanDivForStkHoriChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        var settingPanelTitle = stgPanDivForStkBarWithLinesChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','10px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute").style("text-transform","capitalize")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; color:#00001c;">'+ "Settings" +'</div>')

        var stgPanDivForStkChangeColorTitle = stgPanDivForStkBarWithLinesChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif")
        .style('margin-left','0px').style('margin-top','50px').style('text-indent','10px').style("font-size", "17px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #ffffff").style("width","200px").style("color","#000000")
        .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:12px; font-family:inter; color:#00001c;">'+ "Select color set " +'</div>')

        var stgPanCanBtnForStkBarWithLinesChart = stgPanDivForStkBarWithLinesChart.append("div") .style("width","18px").style("height","17px").style('position','absolute')
        .style('right', '0').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
        .style('padding',"0px") .style("border", "0px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:2px; top:1px; width:14px; height:14px; opacity:0.9; background-color:#fcfcff")
        stgPanCanBtnForStkBarWithLinesChart[0][0].appendChild(cancelBtnImgVar)

        stgPanCanBtnForStkBarWithLinesChart.on('click', function() {
            stgPanDivForStkBarWithLinesChart.style("display","none") // Hiding setting panel

            if ((showOrHideTableForStkBarWithLinesChart == false) && (showOrHideCommentsForStkBarWithLinesChart == true)){
                    divLegendPanelStkBarWithLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForStkBarWithLinesChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                    .style("position","absolute");
            }
            else if ((showOrHideTableForStkBarWithLinesChart == true) && (showOrHideCommentsForStkBarWithLinesChart == false)){
                    divLegendPanelStkBarWithLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForStkBarWithLinesChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute");
            }
            else if ((showOrHideTableForStkBarWithLinesChart == false) && (showOrHideCommentsForStkBarWithLinesChart == false)){
                    divLegendPanelStkBarWithLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                    svgPanelForStkBarWithLinesChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute");
            }

            resizedFuctionForStkBarWithLinesChart();
        })

        var formForChangeSettingsPanel = stgPanDivForStkBarWithLinesChart.append("form");
        formForChangeSettingsPanel.style("background-color","#fcfcfc").style("margin-top","67px").style("font-family","Verdana,sans-serif").style("font-size","12px")
        .style("position","absolute").attr("id","formForChangeColorSettingsPanel" + targetElement[0][0].id).style("font-weight","Bold").style("width","180px")
        .style("height","58px").style("padding","0px").style("border-radius","0px") .style("margin-left","10px")

        var svgPanelForCrSetOne = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px").style("height","18px").style("margin-top","1px").style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetOne = d3.scale.ordinal() .range(["#2bc65a", "#f23a3a", "#2a7bb2", "#ba912a", "#9a270c", "#339966", "#808000","#307D7E","#AF7817","#00cc77","#009bb9","#fbc004"]);
        var colorSetOneRange = d3.range(12);

        var colorSetOneDots = svgPanelForCrSetOne.append("g")
        colorSetOneDots.selectAll('rect') .data(colorSetOneRange) .enter() .append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("fill", function(d,i){return colorSetOne(i)})
        .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetOne(i); })
        .style("cursor","auto") .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        var svgPanelForCrSetTwo = formForChangeSettingsPanel.append("svg").style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px") .style("margin-top","20px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetTwo = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        var colorSetTwoRange = d3.range(12);

        var colorSetTwoDots = svgPanelForCrSetTwo.append("g")
        colorSetTwoDots.selectAll('rect') .data(colorSetTwoRange) .enter().append('rect') .attr('transform', 'translate(' + (2) + ',' + (1) + ')')
        .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10) .attr("height",10) .style("cursor","auto")
        .style("fill", function(d,i){return colorSetTwo(i)}) .style("fill-opacity",0.93) .attr("stroke-width", 0.1) .style("stroke-opacity",0.88)
        .style("stroke",function(d,i){  return colorSetTwo(i);  }) .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        var svgPanelForCrSetThree = formForChangeSettingsPanel.append("svg") .style("position","absolute") .style("background-color","#fefefe")
        .style("width","160px") .style("height","18px") .style("margin-top","39px") .style("margin-left","0px") .style("box-sizing","border-box")
        
        var colorSetThree = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        var colorSetThreeRange = d3.range(12);

        var colorSetThreeDots = svgPanelForCrSetThree.append("g")
        colorSetThreeDots.selectAll('rect') .data(colorSetThreeRange) .enter().append('rect')
        .attr('transform', 'translate(' + (2) + ',' + (1) + ')') .attr("x",function(d,i){ return i*13;}) .attr("y",2) .attr("width",10)
        .attr("height",10) .style("cursor","auto") .style("fill", function(d,i){return colorSetThree(i)}) .style("fill-opacity",0.93)
        .attr("stroke-width", 0.1) .style("stroke-opacity",0.88) .style("stroke",function(d,i){  return colorSetThree(i);  })
        .attr("rx", 0.0) .attr("ry", 0.0) .style("cursor","pointer")

        if(options.colorSet.toString().toLowerCase() === "one"){
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"1px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"1px solid #808080")
        }
        else 
        {
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")
        }

        svgPanelForCrSetOne.on('click',function(d){
            options.colorSet = "one"
            svgPanelForCrSetOne.style('border',"1px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")

            colours = "";
            colours = d3.scale.ordinal() .range(["#2bc65a", "#f23a3a", "#2a7bb2", "#ba912a", "#9a270c", "#339966", "#808000","#307D7E","#AF7817","#00cc77","#009bb9","#fbc004"]);
            
            colorCountVarForCircle = 0;
            colorCountVarForLine = 0;
                               
            groupsForStkBarWithLinesChart.style('fill', function (d, i) { colorCountVarForCircle++; colorCountVarForLine++; return colours(i); })

            legendGroup.style("fill", function(d, i){ return colours(i);})
                               
                               
            lines.style("stroke", function (d,i) { return colours(colorCountVarForLine++); })
           
            circle1.style("fill", function (d,i) {
             if(i == 0){ colorCountVarForCircle++; }
                 return colours(colorCountVarForCircle - 1);
            })
        
        })
        svgPanelForCrSetTwo.on('click',function(d){
            options.colorSet = "two"
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"1px solid #808080")
            svgPanelForCrSetThree.style('border',"0px solid #808080")

            colours = "";
            colours = d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);

           colorCountVarForCircle = 0;
           colorCountVarForLine = 0;
           
           groupsForStkBarWithLinesChart.style('fill', function (d, i) { colorCountVarForCircle++; colorCountVarForLine++; return colours(i); })
           
           legendGroup.style("fill", function(d, i){ return colours(i);})
           
           
           lines.style("stroke", function (d,i) { return colours(colorCountVarForLine++); })
           
           circle1.style("fill", function (d,i) {
             if(i == 0){ colorCountVarForCircle++; }
                 return colours(colorCountVarForCircle - 1);
            })
        })
        svgPanelForCrSetThree.on('click',function(d){
            options.colorSet = "three"
            svgPanelForCrSetOne.style('border',"0px solid #808080")
            svgPanelForCrSetTwo.style('border',"0px solid #808080")
            svgPanelForCrSetThree.style('border',"1px solid #808080")

            colours = "";
            colours = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);

             colorCountVarForCircle = 0;
             colorCountVarForLine = 0;
             
             groupsForStkBarWithLinesChart.style('fill', function (d, i) { colorCountVarForCircle++; colorCountVarForLine++; return colours(i); })
             
             legendGroup.style("fill", function(d, i){ return colours(i);})
             
             
             lines.style("stroke", function (d,i) { return colours(colorCountVarForLine++); })
             
             circle1.style("fill", function (d,i) {
               if(i == 0){ colorCountVarForCircle++; }
                return colours(colorCountVarForCircle - 1);
             })
        })

        
        //------------------ Settings panel DIV and everything inside it section ends here ------------------

        // Filter
        filterBtnForStkBarWithLinesChart.on('click', function() {

            filterPanelForStkBarWithLinesChart.style("display","block");

            ismenuBtnOfStkBarWithLinesChartClicked = false;
            optsBtnPanelForStkBarWithLinesChart.style("display","none");

            stgPanDivForStkBarWithLinesChart.style("display","none");

            if ((showOrHideTableForStkBarWithLinesChart == false) && (showOrHideCommentsForStkBarWithLinesChart == true)){
                divLegendPanelStkBarWithLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                svgPanelForStkBarWithLinesChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute");
            }
            else if ((showOrHideTableForStkBarWithLinesChart == true) && (showOrHideCommentsForStkBarWithLinesChart == false)){
                divLegendPanelStkBarWithLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                svgPanelForStkBarWithLinesChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute");
            }
            else if ((showOrHideTableForStkBarWithLinesChart == false) && (showOrHideCommentsForStkBarWithLinesChart == false)){
                divLegendPanelStkBarWithLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                svgPanelForStkBarWithLinesChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute");
            }

            resizedFuctionForStkBarWithLinesChart();

        })

        // Refreshing Chart and Table 
        refreshBtnForStkBarWithLinesChart.on('click', function() {

            //isFilterClicked = false
           d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData;
                    options.keys.stackedBars = newtargetElementAndOptionsArray[i].options.keys.stackedBars;
                    options.keys.lines = newtargetElementAndOptionsArray[i].options.keys.lines;
                    options.keys.toolTipLabel = newtargetElementAndOptionsArray[i].options.keys.toolTipLabel;
                }
            }
            acinfotech.stackedBarWithLinesChart(targetElement,options)

        })

        // Refreshing Chart and Table 
        commentsBtnForStkBarWithLinesChart.on('click', function() {

            if(options.showComments == false){ 
                options.showComments = true;
            }
            else if(options.showComments == true){ 
                options.showComments = false;
            }

            //isFilterClicked = false
           d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData;
                    options.keys.stackedBars = newtargetElementAndOptionsArray[i].options.keys.stackedBars;
                    options.keys.lines = newtargetElementAndOptionsArray[i].options.keys.lines;
                    options.keys.toolTipLabel = newtargetElementAndOptionsArray[i].options.keys.toolTipLabel;
                    options.showTable = false;
                }
            }
            acinfotech.stackedBarWithLinesChart(targetElement,options)

        })

        // showing/hidding chart table
        tableButtonForStkBarWithLinesChart.on('click', function() {

            if(showOrHideTableForStkBarWithLinesChart == false){
                options.showTable = true;
                //showOrHideTableForPieChart = true
            }
            else if(showOrHideTableForStkBarWithLinesChart == true){
                //showOrHideTableForPieChart = false
                options.showTable = false;
            }

            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                    options.showComments = false;
                }
            }
            acinfotech.stackedBarWithLinesChart(targetElement,options)

        })

        
        settingBtnForStkBarWithLinesChart.on('click', function() {
                
            ismenuBtnOfStkBarWithLinesChartClicked = false; // Menu toggle button variable
            optsBtnPanelForStkBarWithLinesChart.style("display","none") // To hide options button panel

            iconButtonTooltipForStkBarWithLinesChart.style("display","none") // Removing options button ToolTip
            settingBtnForStkBarWithLinesChart.style("cursor","pointer")
            
            stgPanDivForStkBarWithLinesChart.style("display","block") // Showing settings panel

            svgPanelForStkBarWithLinesChart.style('width', 75 + "%") .style('height', 52 + "%").style("position","absolute"); // Decreasing chart panel
            divLegendPanelStkBarWithLinesChart.style('width', 25 + "%") .style('height', 52 + "%").style("position","absolute"); // Decreasing chart panel

            resizedFuctionForStkBarWithLinesChart(); // Calling resize function()

        })
        
        downloadBtnForStkBarWithLinesChart.on('click', function() {
                                  
              ismenuBtnOfStkBarWithLinesChartClicked = false; // Changing menu button value to false
              optsBtnPanelForStkBarWithLinesChart.style("display","none") // Hiding option buttons panel
                                  
        })
        
        // Creating ToolTip for options button.
        var iconButtonTooltipForStkBarWithLinesChart = targetElement.append('div').style('width','240px').attr("id","too")
        .style('height',"25px").style('position','absolute')//.style('margin-left', "0px").style('top','25px')
        .style("background-color",'#404040 ').style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") .style("border-style", "solid") // 004b9d
        .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none").attr("border", 0.0)

        filterBtnForStkBarWithLinesChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var filterButtonTooltipText = "Filter";
            
            iconButtonTooltipForStkBarWithLinesChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForStkBarWithLinesChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ filterButtonTooltipText +'</div>')

        })
        filterBtnForStkBarWithLinesChart.on('mouseout', function(d,i) {
            iconButtonTooltipForStkBarWithLinesChart.style("display","none")
        })

        refreshBtnForStkBarWithLinesChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var refreshButtonTooltipText = "Refresh";
            
            iconButtonTooltipForStkBarWithLinesChart.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForStkBarWithLinesChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center; ">'+ refreshButtonTooltipText +'</div>')

        })
        refreshBtnForStkBarWithLinesChart.on('mouseout', function(d,i) {
            iconButtonTooltipForStkBarWithLinesChart.style("display","none")
        })

        commentsBtnForStkBarWithLinesChart.on('mousemove', function(d,i) {
            commentsPanelDivForStkBarWithLinesChart.style('background-color','#fafafa')
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                if(options.showComments == false){
                    var commentButtonTooltipText = "Show Comments";
                }
                else if(options.showComments == true){
                    var commentButtonTooltipText = "Hide Comments";
                }
            
            
            iconButtonTooltipForStkBarWithLinesChart.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForStkBarWithLinesChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center; ">'+ commentButtonTooltipText +'</div>')
        })
        commentsBtnForStkBarWithLinesChart.on('mouseout', function(d,i) {
            commentsPanelDivForStkBarWithLinesChart.style('background-color','#ffffff')
            iconButtonTooltipForStkBarWithLinesChart.style("display","none")
        })

        menuBtnForStkBarWithLinesChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var menuButtonTooltipText = "Menu";
            
            iconButtonTooltipForStkBarWithLinesChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForStkBarWithLinesChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center; ">'+ menuButtonTooltipText +'</div>')

        })
        menuBtnForStkBarWithLinesChart.on('mouseout', function(d,i) {
            iconButtonTooltipForStkBarWithLinesChart.style("display","none")
        })

        tableButtonForStkBarWithLinesChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                if(showOrHideTableForStkBarWithLinesChart ==  false){
                    var refreshButtonTooltipText = "Show Table";
                }
                else if(showOrHideTableForStkBarWithLinesChart == true){
                    var refreshButtonTooltipText = "Hide Table";
                }
            
            
            iconButtonTooltipForStkBarWithLinesChart.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForStkBarWithLinesChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ refreshButtonTooltipText +'</div>')

        })
        tableButtonForStkBarWithLinesChart.on('mouseout', function(d,i) {
            iconButtonTooltipForStkBarWithLinesChart.style("display","none")
        })

        settingBtnForStkBarWithLinesChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var settingTooltipText = "Settings";
            
            iconButtonTooltipForStkBarWithLinesChart.style("width","67px").style("margin-left", (m[0] - 77) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForStkBarWithLinesChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ settingTooltipText +'</div>')
        })
        settingBtnForStkBarWithLinesChart.on('mouseout', function(d,i) {
            iconButtonTooltipForStkBarWithLinesChart.style("display","none")
        })
        
        downloadBtnForStkBarWithLinesChart.on('mousemove', function(d,i) {
           var root = targetElement
           var m = d3.mouse(root.node());
           m[0] += 0
           m[1] += 0
           var downloadButtonTooltipText = "Download";
           iconButtonTooltipForStkBarWithLinesChart.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
           iconButtonTooltipForStkBarWithLinesChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
        })
        downloadBtnForStkBarWithLinesChart.on('mouseout', function(d,i) {
           iconButtonTooltipForStkBarWithLinesChart.style("display","none")
        })
        
        // ----------------- Filter panel and everything within it section begins here ----------------
        var filterPanelForStkBarWithLinesChart = targetElement.append('div').style('width',350 + "px") .attr("class","filterPanelForStkBarWithLinesChartClass" + targetElement[0][0].id)
        .style('position','absolute').style('margin-left', "0px")
        .style("background-color",'#fefefe').style("z-index",11).style("border-color", "#ffffff").style("border-right", "solid #e5e5e5 1px")  .style("border-style", "solid") // 004b9d
        .style("box-shadow", "2px 0px 1px #eff8ec").style("display","none").style("border-top", "solid #fdfdfd 1px").style("border-left","0px").style("border-bottom", "0px")
        .style('top', 0.0 + "%").style('height', 100 + "%").style('overflow-y',"hidden").style("overflow-x","hidden")
        .style("border-bottom", "solid #e5e5e5 1px") .style("box-sizing","border-box")

        var filterPanelForStkBarWithLinesChartTitle = filterPanelForStkBarWithLinesChart.append('div').style('background-color',"#ffffff").attr("fant-family", "Verdana,sans-serif").style("font-weight", "Bold")
        .style('margin-left','0px').style('margin-top','20px').style('text-indent','5px').style("font-size", "14px").style('position',"absolute")
        .style("box-shadow", "1px 1px 1px #007aff").style("width","350px").style("color","#000000")
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; top:25.0%; font-size:16px; font-family:inter;  color:#585858; font-weight:Bold;">'+ "Filter" +'</div>')

        var measuresColumnTitle = filterPanelForStkBarWithLinesChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','4px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:0%; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:14px; font-family:inter;  color:#606060; font-weight:Normal; text-align:left; text-indent:3px;">Available Measures</div>');

        var measuresVariables = filterPanelForStkBarWithLinesChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable1"+targetElement[0][0].id)
        .style("list-style-type","none")
        .style('background-color',"#fdfdfd").style('margin-left','4px').style('margin-top', '78px')
        .style('position','absolute')
        .style("width","155px").style("min-height","190px").style("max-height","190px").style("border", "#f0f0f0 1px solid")
        .style("max-width","155px").style("overflow-x","hidden").style("overflow-y","auto")
        measuresVariables.style("left",0.0 + "px").style("padding","2px")

        $( ".filterPanelForStkBarWithLinesChartClass" + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });


        var measuresArray = [];
        var dimensionArray = [];

        var measuresArrayLength = [];
        var dimensionsArrayLength = [];

        dimensionArray.push(options.keys.label);
        //measuresArray = options.keys.stackedBars;

        for(var i = 0; i<divAndChartsArray.length; i++){
            if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    
                measuresArray = newtargetElementAndOptionsArray[i].options.keys.stackedBars;
            }
        }
        
        // filter process
        var uniqueMeasuresArrayKeys = [];
        $.each(measuresArray, function(i, el){
            if($.inArray(el, uniqueMeasuresArrayKeys) === -1){
                uniqueMeasuresArrayKeys.push(el);
            }
        });

        var uniqueDimensionArrayKeys = [];
        $.each(dimensionArray, function(i, el){
            if($.inArray(el, uniqueDimensionArrayKeys) === -1){
                uniqueDimensionArrayKeys.push(el);
            }
        });
        
        // setting lenght for arrays
        for(var i = 0; i<uniqueMeasuresArrayKeys.length; i++){
            measuresArrayLength.push(i);
        }

        for(var i = 0; i<uniqueDimensionArrayKeys.length; i++){
            dimensionsArrayLength.push(i);
        }

        var measuresVariables1 = measuresVariables.selectAll("li") .data(measuresArrayLength).enter().append("li")
        .style("width","130px") .style("max-height","22px").style("cursor","move")
        .style("margin-top","2px") .style("padding","3px") .style("font-size","14px").style("background-color","#bcf1bc").style("font-weight","Normal")
        .style("list-style-type","none").style("border","1px #89e789 solid").style("color","#006600").style("font-family","Verdana,sans-serif")
        .style("position","relative").style('margin-left','0px').style('margin-top','2px').style('line-height',"normal")
        .text(function(d) {return uniqueMeasuresArrayKeys[d]})
        measuresVariables1.attr("class","MeasuresClass"+targetElement[0][0].id)
        
        var measuresColumnReceivedUI_TableTitle = filterPanelForStkBarWithLinesChart.append("div") .style("width","140px").style("height","18px").style('position','absolute')
        .style('background-color',"#fefefe").style('margin-left','180px').style('margin-top', '60px')
        .html('<div  style="width: 100%; height:auto; background-color:#fefefe; position: absolute; left: 0px; top:0.0%; font-size:14px; font-family:inter;  color:#606060; font-weight:Normal; text-align:left; ">Selected Measures</div>');

        var measuresColumnReceivedUI_Table = filterPanelForStkBarWithLinesChart.append("ul") .attr("class","droptrue"+targetElement[0][0].id) .attr("id","sortable3"+targetElement[0][0].id)
        .style('background-color',"#ffffff").style('margin-left','180px').style('margin-top', '78px')
        .style("width","155px").style('position','absolute').style("padding","2px").style("min-height","190px")
        .style("border","1px #c1c1c1 dashed") .style("max-height","190px") .style("overflow-x","hidden") .style("overflow-y","auto")
        //.html('<div class=unsortable  style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:65.0%; font-size:14px; font-family:inter;  color:#99ea99; font-weight:Normal; text-align:center;">Drag and Drop Measures here from Available Measures List. </div>');
        .html('<img class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' src="images/dragIcon.png" style=" width:36px; height:36px; position:absolute; margin-left:65px; margin-top:60px; opacity:0.6"/>' 
        + '<div class=unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+' style="width: 100%; height:auto; background-color:#ffffff; position: absolute; left: 0px; top:60.0%; font-size:12px; font-family:inter;  color:#89d289; font-weight:Normal; text-align:center;">Drop Measures here. </div>');
        //.html('<div style="background-image: url(images/dragIcon.png); height: 64px; width: 64px; border: 1px solid black;"> </div>');

        var cancelButton = filterPanelForStkBarWithLinesChart.append("div") .style("width","23px").style("height","21px").style('position','absolute')
        .style('margin-left','320px').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white') 
        .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.9; background-color:#fcfcff")
        cancelButton[0][0].appendChild(cancelBtnImgVar)

        cancelButton.on("click", function(){
            filterPanelForStkBarWithLinesChart.style("display","none")

            if ((showOrHideTableForStkBarWithLinesChart == false) && (showOrHideCommentsForStkBarWithLinesChart == true)){
                divLegendPanelStkBarWithLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                svgPanelForStkBarWithLinesChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                .style("position","absolute");
            }
            else if ((showOrHideTableForStkBarWithLinesChart == true) && (showOrHideCommentsForStkBarWithLinesChart == false)){
                divLegendPanelStkBarWithLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                svgPanelForStkBarWithLinesChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute");
            }
            else if ((showOrHideTableForStkBarWithLinesChart == false) && (showOrHideCommentsForStkBarWithLinesChart == false)){
                divLegendPanelStkBarWithLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%");
                    
                svgPanelForStkBarWithLinesChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                .style("position","absolute");
            }
        })

        var reRenderChartAndTableButton = filterPanelForStkBarWithLinesChart.append("button").style("width","120px").style("height","25px").style('position','absolute')
        .style('margin-left','112px').style('margin-top','298px') .style("border-style", "none").style('background-color',"#2196f3")
        .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','15px').style("border-style", "solid").style('color','#ffffff')
        .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 1px #9b9b9b").style("border-radius","0px")
        var textForReRenderButton = document.createTextNode("Apply Changes");
        reRenderChartAndTableButton[0][0].appendChild(textForReRenderButton)

        reRenderChartAndTableButton.on("click", function(){

            if( $("#sortable3"+targetElement[0][0].id).children("li").length == 0 )
            {

                var alertPageDisabledDivForStkBarWithLinesChart =targetElement.append('div').style('width',100 + '%')
                .style('height',100 + "%").style('position','absolute').style('margin-left', '0px').style('top', '0px')
                .style("background-color",'#f3f3f3').style("z-index",99)//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("opacity",0.2).style("display","block")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")

                var alertDivForStkBarWithLinesChart = targetElement.append('div').style('width','350px')
                .style('height',"150px").style('position','absolute').style('left', ((targetElement[0][0].clientWidth/2) - 175) + "px").style('top', '1px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "solid").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","0px")//.style("border-top", "0px").style("border-left", "0px").style("border-bottom", "0px")
                //.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:45.0%; font-size:14px; font-family:inter; font-weight:Bold; text-indent:10px;  color:#f8f8f8; font-weight:Bold;">Sorry, no result found for selected' + 'range!'+ '</br>' + '<label style=text-indent:10px;> Hello</label' +'</div>')
                .html('<p  style="width: 340px; height:0%; background-color:#c7c7c7; position: absolute; top:40.0%; font-size:14px; font-family:inter; font-weight:Bold; margin-left:10px;  color:#f8f8f8; font-weight:Normal;">Check whether the Selected Measures box is not empty!</p>')

                var alertDivTitleForStkBarWithLinesChart = alertDivForStkBarWithLinesChart.append('div').style('width','340px')
                .style('height',"30px").style('position','absolute').style('margin-left', "0px").style('top', '0px')
                .style("background-color",'#313131').style("z-index",99).style("border-color", "#181818").style("border-style", "none").style("border-width","2px")//.style("border-right", "solid #c1e2b3 1px")  .style("border-style", "solid") // 004b9d
                .style("box-shadow", "0px 0px 0px #eff8ec").style("display","block").style("border-radius","2px")
                .html('<div  style="width: 100%; height:0%; background-color:#c7c7c7; position: absolute; top:25.0%; font-size:15px; font-family:inter; font-weight:Bold; text-indent:5px;  color:#e5e5e5; font-weight:Normal;">TimeBound</div>')

                var StkBarWithLinesChartAlertOKButton = alertDivForStkBarWithLinesChart.append("button") .style("width","40px") .style("height","20px") .style('position','absolute') .style("box-shadow", "0px 1px 1px #B8B8B8") 
                .style('background-color',"#7cc15e") .style('margin-left','300px') .style('top', "120px").style("color","#ffffff")
                .style("display","block").style('padding-top',"0px").style("cursor","pointer").style("box-shadow", "1px 1px 1px #56973a") .style("border-style", "none")
                .style("font-family","Verdana,sans-serif").style("font-size","14px").style("text-align","center").style("vertical-align","middle").style("border-radius","0px")
                .style("z-index",999)
            
                var textForStkBarWithLinesChartAlertOKButton = document.createTextNode("OK");
                StkBarWithLinesChartAlertOKButton[0][0].appendChild(textForStkBarWithLinesChartAlertOKButton)

                $("#"+targetElement[0][0].id).resizable('disable');

                StkBarWithLinesChartAlertOKButton.on('click', function() {
                    alertDivForStkBarWithLinesChart.remove();
                    alertPageDisabledDivForStkBarWithLinesChart.remove()
                    $("#"+targetElement[0][0].id).resizable('enable');
                })

                filterBtnForStkBarWithLinesChart.style("cursor","pointer")
                
                if(showOrHideTableForStkBarWithLinesChart == false){ 
                    svgPanelForStkBarWithLinesChart.style('width', 75 + "%") .style('height', 85 + "%").style("position","absolute")
                    divLegendPanelStkBarWithLinesChart.style('width', 25 + "%") .style('height', 85 + "%").style("position","absolute")
                }   
                else if(showOrHideTableForStkBarWithLinesChart == true){ 
                    svgPanelForStkBarWithLinesChart.style('width', 75 + "%") .style('height', 52 + "%").style("position","absolute")
                    divLegendPanelStkBarWithLinesChart.style('width', 25 + "%") .style('height', 52 + "%").style("position","absolute")
                } 

                resizedFuctionForStkBarWithLinesChart();
            }

            else{

                var selectedStackMeasures = [];
                for(var i=0; i<$("#sortable3"+targetElement[0][0].id).children("li").length;i++){
                    selectedStackMeasures.push($("#sortable3"+targetElement[0][0].id).children("li")[i].textContent)
                }
            
                var newOptions = {
                           data: options.data,
                           //dataForDrillDown:options.dataForDrillDown,
                           dataForTable:options.dataForTable,
                           isDataDetailedForTable: options.isDataDetailedForTable,
                           keys: {
                               label: options.keys.label,//$("#sortable4"+targetElement[0][0].id).children("li")[0].textContent.toString(),
                               stackedBars: selectedStackMeasures,
                               lines: options.keys.lines,
                               toolTipLabel: options.keys.toolTipLabel
                           },
                           chartTitle:options.chartTitle,
                           xAxisLable: options.keys.label,//$("#sortable4"+targetElement[0][0].id).children("li")[0].textContent,
                           yAxisLable: "",
                           showTitle: true,
                           colorSet: options.colorSet,
                           series:options.series,
                           legend:options.legend,
                           BGcolor:options.BGcolor,
                           drillDownColumnName:options.drillDownColumnName,
                           showTable: options.showTable,
                           showComments: options.showComments,
                           comments: options.comments,
                           resizeButtonID: options.resizeButtonID //document.getElementById("resizeBtn").id
                        }
                        
                        d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
                        //acinfotech.stackedBarWithLinesChart(targetElement,newOptions)
                }
            
            })

        var textBoxForMeasureColumnFrom;
        var textBoxForMeasureColumnTo;
        var selectTitleDivForEachDimension;

       
        $( "ul.droptrue"+targetElement[0][0].id ).sortable({
            appendTo: document.body,
            helper: "clone",
            connectWith: ".droptrue"+targetElement[0][0].id,
            scroll: false,
            cancel: '.unMoveableIconAndTextClassMeasures'+targetElement[0][0].id+','+' .unMoveableIconAndTextClassDimensions'+targetElement[0][0].id,
            revertDuration: 10,
            scrollSensitivity: 10,
            scrollSpeed: 1,
            dynamic: true,

            receive: function(e, ui) { 
                 
                if (($(this)[0].id == "sortable3"+targetElement[0][0].id) || ($(this)[0].id == "sortable1"+targetElement[0][0].id)) {

                        if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                            if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                                 (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                            }
                            else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                                (($('#sortable3'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassMeasures"+targetElement[0][0].id).show();
                            }

                        }
                } // if (($(this)[0].id == "sortable3") || ($(this)[0].id == "sortable1")) 

                else if (($(this)[0].id == "sortable2"+targetElement[0][0].id) || ($(this)[0].id == "sortable4"+targetElement[0][0].id)) {
                    if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                            //ui.sender.sortable("cancel");

                            if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                                 (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                            }
                            else if(  ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                                (($('#sortable4'+targetElement[0][0].id+' li').length) > 0) ? $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).hide() : $(".unMoveableIconAndTextClassDimensions"+targetElement[0][0].id).show();
                            }
                        }
                } //if (($(this)[0].id == "sortable2") || ($(this)[0].id == "sortable4")) {

                $(ui.item).css({ 'position': 'relative' });

                if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                    ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                }
                 
                else if ($(this)[0].id == "sortable3"+targetElement[0][0].id) { // checking if the dropped element is in Measures drop area
                    
                    if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                        ui.sender.sortable("cancel");
                    }
                    else {
                        //ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                    }

                } // else if ($(this)[0].id == "sortable3") // checking if the dropped element is in Measures drop area ends here.

                else if ($(this)[0].id == "sortable4"+targetElement[0][0].id) { // checking if the dropped element is in Dimension drop area

                    if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                        ui.sender.sortable("cancel");
                    }
                    else {
                        ui.item.css( { marginLeft : "9px", marginTop : "38px" } );
                    }
                } //else if ($(this)[0].id == "sortable4")  // checking if the dropped element is in Dimension drop area ends here

                    if ( ($(this)[0].id == "sortable1"+targetElement[0][0].id) || ($(this)[0].id == "sortable2"+targetElement[0][0].id) ){
                        
                        if ($(this)[0].id == "sortable1"+targetElement[0][0].id){
                            if(ui.item.hasClass("DimesionsClass"+targetElement[0][0].id)){
                            
                                if( ui.sender.attr("id") === "sortable4"+targetElement[0][0].id){
                                    ui.sender.sortable("cancel");
                                } // if(  ui.sender.attr("id") === "sortable4")

                                else if(  ui.sender.attr("id") === "sortable2"+targetElement[0][0].id){
                                    ui.sender.sortable("cancel");
                                }
                            
                            } // if(ui.item.hasClass("DimesionsClass"))
                        }
                    if ($(this)[0].id == "sortable2"+targetElement[0][0].id){
                        if(ui.item.hasClass("MeasuresClass"+targetElement[0][0].id)){
                            
                            if(  ui.sender.attr("id") === "sortable1"+targetElement[0][0].id){
                                ui.sender.sortable("cancel");
                            }
                            else if(  ui.sender.attr("id") === "sortable3"+targetElement[0][0].id){
                                ui.sender.sortable("cancel");
                               
                            }
                        }
                    }

                } //if ($(this)[0].id == "sortable1")

                if ($(this)[0].id == "sortable4"+targetElement[0][0].id){
                    if ($(this).children('li').length > 1 ){
                        ui.sender.sortable("cancel");
                        ui.item.css( { marginLeft : "0px", marginTop : "2px" } );
                    }    
                }

            }, //receive ends here

            start:function(ev, ui) {
                
            },
            stop:function(ev, ui) {
               
            },
        });
      
        // ----------------- Filter panel and everything within it section ends here -----------------

        var finalArrayNew = [];
        options.keys.stackedBars.forEach(function(d, i) {
    
            var temp1 = {};
            temp1["name"] = options.keys.stackedBars[i]
    
            finalArrayNew.push(temp1)
        })
        
        var finalNewNewArray = [];
        var dataArray1 = [];
        finalArrayNew.forEach(function(d, i) {
    
            var temp1 = {};
            temp1["name"] = options.keys.stackedBars[i]
    
            for (j = 0; j < options.data.length; j++) {
                
                var tempTemp = {};
                tempTemp["label"] = options.data[j][options.keys.label];
                tempTemp["value"] = +options.data[j][options.keys.stackedBars[i]];

                dataArray1.push(tempTemp)
            }
            
                temp1["data"] = dataArray1;
                dataArray1 = []
                finalNewNewArray.push(temp1)
        })
        
        var margins = {
            top: 12,
            left: 48,
            right: 24,
            bottom: 24
        },
    
    width = (svgPanelForStkBarWithLinesChart.node().getBoundingClientRect().width) - margin.left - margin.right,
    height = (svgPanelForStkBarWithLinesChart.node().getBoundingClientRect().height) - margin.top - margin.bottom
    
    dataset = finalNewNewArray,
    series = dataset.map(function (d) { return d.name; }),
    dataset = dataset.map(function (d) {
        return d.data.map(function (o, i) {
            // Structure it so that your numeric
            // axis (the stacked amount) is y
            return {
                y: o.value,
                x: o.label
            };
        });
    }),
    stack = d3.layout.stack();

    stack(dataset);

    var dataset = dataset.map(function (group) {
        return group.map(function (d) {
            // Invert the x and y values, and y0 becomes x0
        
            return {
                x: +d.y,
                y: d.x,
                x0: +d.y0
            };
        });
    }),
    svgStkBarWithLinesChart = svgPanelForStkBarWithLinesChart  .append('svg') .append('g') 
    .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'),
    xMax = d3.max(dataset, function (group) {
        
        return d3.max(group, function (d) {
            return (+d.x) + (+d.x0);
        });
    }),
    months = dataset[0].map(function (d) { return d.y; }),

    xScale = d3.scale.ordinal() .domain(months) .rangeRoundBands([0, width], .20),
    
    yScale = d3.scale.linear() .domain([0, xMax]) .range([height, 0]),
    
    xAxis = d3.svg.axis() .scale(xScale) .orient('bottom'),
    yAxis = d3.svg.axis() .scale(yScale) .orient('left')
    
    var colorCountVarForCircle = 0;
    var colorCountVarForLine = 0;
    
        
    var groupsForStkBarWithLinesChart = svgStkBarWithLinesChart.selectAll('g') .data(dataset) .enter() .append('g')
    .style('fill', function (d, i) { colorCountVarForCircle++; colorCountVarForLine++; return colours(i); }),
    
    xScale1 = d3.scale.ordinal() .domain(months) .rangeRoundBands([0, width], .20),
        
    yScale1 = d3.scale.linear() .domain([0, xMax]) .range([0, height]),
    months = dataset[0].map(function (d) { return d.y; }),

    rectsForStkBarWithLinesChart = groupsForStkBarWithLinesChart.selectAll('rect') .data(function (d) { return d; }) .enter() .append('rect')
    
	groupsForStkBarWithLinesChart.selectAll('rect')
	.attr('x', function (d,i) { return xScale1(d.y); })
	.attr("width", xScale1.rangeBand())
	.attr("y", function (d) { return height; })
	.attr("height", function (d) { return 0; })
	.transition() .delay(400) .duration(800)
	.attr('y', function (d, i) { return height -yScale1(d.x0) - yScale1(d.x) })
	.attr("height", function (d) { return yScale1(d.x); }) .style("cursor","auto")
        
        var columnNames = d3.keys(options.data[0])
        var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
        
        for(var i = 0; i < columnNames.length ; i++){
            for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                    for(var k = 0; k < options.keys.stackedBars.length; k++){
                        var len = d3.select(groupsForStkBarWithLinesChart[0][k]).selectAll('rect')
                        for(var l = 0; l < len[0].length; l++){
                            d3.select(len[0][l]).attr('data-drilldownkey', function(d,index){
                                  return JSON.stringify(options.data[l]).slice(1, -1).split('"').join("").split(':').join("|")
                            })
                        }
                    }
                }
                else {
                }
            }
        }
            
        
    var yTextPadding = 10;
    var format1 = d3.format('.2s')
    var textOnStkBarWithLinesChart = groupsForStkBarWithLinesChart.selectAll(".text") .data(function (d) { return d; })

    textOnStkBarWithLinesChart.enter() .append("text") .attr("class","text");

    textOnStkBarWithLinesChart .transition() .duration(250) .style("text-anchor", "middle")
    .attr("x", function(d,i) { return xScale1(d.y)+xScale1.rangeBand()/2; })
	.attr("y", function (d) { return height; })
	.transition() .delay(400) .duration(800)
	.attr("y", function(d) { return (height -yScale1(d.x0) - yScale1(d.x))+(yScale1(d.x)/1.5);})
	.style("font-family", "Verdana,sans-serif")
    .style("font-size", "12px") .style("fill", "#ffffff") .style("text-shadow","1px 0px 1px rgba(34,34,34,0.6)")
    .text(function(d){
        
        if(d.x.toString().indexOf('.') === -1)
        {
          if(d.x.toString().length <= 3){
            return d.x;
          }
          else{
            return format1(d.x)
          }
        }
        else{
          
            return d.x.toString();
        }
    })
    let key=options.xAxisLable;
    let array=options.data.map(value => value[key]);
    let ArrayValue=[];
    var RotateValue;
    for(let i=0;i<array.length;i++){
            ArrayValue[i]=array[i].length;
    }
    const numberGreaterThanLimit = ArrayValue.filter((v) => v > 5);
    svgStkBarWithLinesChart.append('g') .attr("class", "x axis") .attr('transform', 'translate(0,' + height + ')') .call(xAxis)
    
    .selectAll("text") .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') .attr("transform", function(d) { 
        if(numberGreaterThanLimit.length>0){return "rotate(-45)"}
        else{
        return "rotate(0)" }})
    .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
    .text(function(d,i) {
        if(d.length > 9)
        return d.substring(0,9)+'...';
        else
        return d;
    })
        
        
        //-------------------------- Creating lines ---------------------------
        
        var dataArrayForLine = [];
        
        options.data.forEach(function(d, i) {
             var temp = {};
             for (i = 0; i < options.keys.lines.length; i++) {
             
                 for (j = 0; j < Object.keys(d).length; j++) {
                 
                     if(options.keys.lines[i] === Object.keys(d)[j]){
                         temp[Object.keys(d)[j]] = d[Object.keys(d)[j]]
                     }
                 }
             }
             
             dataArrayForLine.push(temp)
         });
        
        
        var finalArrayForLine = [];
        options.data.forEach(function(d, i) {
                             
             var finalArrayForLineTemp = {};
             finalArrayForLineTemp[options.keys.label] = d[options.keys.label];
             finalArrayForLineTemp["Data"] = dataArrayForLine[i];
             finalArrayForLine.push(finalArrayForLineTemp)
         })
        
        var finalArrayNewForLine = [];
        options.keys.lines.forEach(function(d, i) {
                                   
           var temp1 = {};
           temp1["line"] = options.keys.lines[i]
           
           finalArrayNewForLine.push(temp1)
        })
        
        var finalNewNewArrayForLine = [];
        var dataArrayForLine1 = [];
        finalArrayNewForLine.forEach(function(d, i) {
                                     
             var temp1 = {};
             temp1["line"] = options.keys.lines[i]
             
             
             for (j = 0; j < options.data.length; j++) {
             
             var tempTemp = {};
             tempTemp["label"] = options.data[j][options.keys.label];
             tempTemp["value"] = options.data[j][options.keys.lines[i]];
             
             dataArrayForLine1.push(tempTemp)
             }
             
             temp1["Data"] = dataArrayForLine1;
             dataArrayForLine1 = []
             finalNewNewArrayForLine.push(temp1)
         })
        
        var xForLine = d3.scale.ordinal().domain(options.data.map(function(d,i) { return d[options.keys.label];})).rangePoints([0, width],1.31);
        
        var x1ForLine = d3.scale.ordinal() .domain(options.data.map(function(d) { return d[options.keys.label]; })) .rangePoints([0, width], 1.31);
        
        var maxForLine = d3.max(finalArrayForLine, function(d) { return d.Data[options.keys.lines[0]] });
        
        /*var maxArrayForLine = [];
        for (i = 0; i < options.keys.lines.length; i++) {
            var max = d3.max(finalArrayForLine, function(d) {
                             return +d.Data[options.keys.stackedBars[i]]
                             });
            
            maxArrayForLine.push(max)
        }*/
        
        var finallyMaxValueForLine = xMax;
        
        var yForLine = d3.scale.linear() .domain([0, d3.max(xMax, function(d) { return +d; })] ) .range([height, 0]);
        
        var color = d3.scale.category10();
        
        var xAxisForLine = d3.svg.axis() .scale(xForLine) .orient("bottom");
        
        var yAxisForLine = d3.svg.axis() .scale(yForLine) .ticks(5) .orient("left");
        
        
        color.domain(options.keys.lines.map(function (d) { return d; }));
        
        var minX = d3.min(finalNewNewArrayForLine, function (kv) { return d3.min(kv.Data, function (d) { return +d.value; }) });
        var maxX = d3.max(finalNewNewArrayForLine, function (kv) { return d3.max(kv.Data, function (d) { return +d.value; }) });
        var minY = d3.min(finalNewNewArrayForLine, function (kv) { return d3.min(kv.Data, function (d) { return +d.value; }) });
        var maxY = d3.max(finalNewNewArrayForLine, function (kv) { return d3.max(kv.Data, function (d) { return +d.value; }) });
        
        xForLine.domain([minX, maxX]);
        yForLine.domain([minY, maxY]);
        
        // Creating line data
        var line = d3.svg.line() .interpolate("cardinal") .x(function (d) { return x1ForLine(d['label']); }) .y(function (d) { return yForLine(+d["value"]); });
        
        // Creating lines
        var lines = svgStkBarWithLinesChart.selectAll(".line") .data(finalNewNewArrayForLine) .enter() .append("g") .append("path") .attr("class", "line")
        .attr("d", function (d,i) { return line(d.Data); }) .style("stroke", function (d,i) { return colours(colorCountVarForLine++); })
        .style("stroke-width",2.5) .style('fill','none') .style("stroke-linecap", "butt")
        
        // Creating circles on lines
        var circle1 = svgStkBarWithLinesChart.selectAll("g.dot") .data(finalNewNewArrayForLine) .enter() .append("g")
        .attr("class", "dot") .selectAll("circle") .data(function(d) { return d.Data; }) .enter() .append("circle") .attr("r", 4.5)
        .attr("cx", function(d,i) {  return x1ForLine(d['label']); }) .attr("cy", function(d,i) {  return yForLine(+d["value"]); })
        .style("fill", function (d,i) {
               if(i == 0){ colorCountVarForCircle++; }
               return colours(colorCountVarForCircle - 1);
               })
        
        var columnNames = d3.keys(options.data[0])
        var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
        
        for(var i = 0; i < columnNames.length ; i++){
            for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                    for(var k = 0; k < options.keys.lines.length; k++){
                        var len = d3.select(svgStkBarWithLinesChart[0][0]).selectAll('g.dot')
                        for(var l = 0; l < d3.select(len[0][k]).selectAll('circle')[0].length; l++){
                            var cir = d3.select(len[0][k]).selectAll('circle')[0][l];
                            d3.select(cir).attr('data-drilldownkey', function(d,index){
                                return JSON.stringify(options.data[l]).slice(1, -1).split('"').join("").split(':').join("|")
                            })
                        }
                    }
                }
                else {
                }
            }
        }
        
        //-----------------------------------------------------------------
        
        // Adding the text label for the x axis
        var xAxisVariable =  svgStkBarWithLinesChart.append("text") .attr("transform", "translate(" + ((width/2) - 0) + " ," + (height+margin.bottom - 2) + ")")
        .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif") .style("font-weight","Bold") .style("font-size","12px") .text(options.xAxisLable) .style('fill','#00001c') 
        .style("text-transform","capitalize") .style("font-style","normal")


        //------------ adding legend section -----------
        var divLegendPanelStkBarWithLinesChart = targetElement .append('div')  .attr("class","divLegendPanelClassForStkBarWithLinesChart")
        .style("background-color", options.BGcolor) .style('position',"absolute") 
        //.style('width', 25 + "%") .style('height', 92 + "%") .style("left",75 + "%").style("top",8 + "%") 

        if(options.showTitle == true){

            if ((showOrHideTableForStkBarWithLinesChart == false) && (showOrHideCommentsForStkBarWithLinesChart == true)){
                    divLegendPanelStkBarWithLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanelForStkBarWithLinesChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                    .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForStkBarWithLinesChart == true) && (showOrHideCommentsForStkBarWithLinesChart == false)){
                    divLegendPanelStkBarWithLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanelForStkBarWithLinesChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForStkBarWithLinesChart == false) && (showOrHideCommentsForStkBarWithLinesChart == false)){
                    divLegendPanelStkBarWithLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanelForStkBarWithLinesChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute").style("background-color", options.BGcolor);
            }
            
        }
        else if(options.showTitle == false){

            if ((showOrHideTableForStkBarWithLinesChart == false) && (showOrHideCommentsForStkBarWithLinesChart == true)){
                    divLegendPanelStkBarWithLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 70  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanelForStkBarWithLinesChart.style('width', 75 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                    .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForStkBarWithLinesChart == true) && (showOrHideCommentsForStkBarWithLinesChart == false)){
                    divLegendPanelStkBarWithLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 52  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanelForStkBarWithLinesChart.style('width', 75 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute").style("background-color", options.BGcolor);
            }
            else if ((showOrHideTableForStkBarWithLinesChart == false) && (showOrHideCommentsForStkBarWithLinesChart == false)){
                    divLegendPanelStkBarWithLinesChart.style("width", function(d) { return 25.0 + "%"; }) .style("height", function(d) { return 85  + "%"; })
                    .style("position","absolute") .style("left",75 + "%") .style("top",8.0  + "%").style("background-color", options.BGcolor);
                    
                    svgPanelForStkBarWithLinesChart.style('width', 75 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute").style("background-color", options.BGcolor);
            }
        }
        
        var legendItems = [];
        var legendItemsArrayLen = 0;
        for(var i = 0; i < options.keys.stackedBars.length; i++){ legendItems.push(options.keys.stackedBars[i]); legendItemsArrayLen = legendItems.length; }
        for(var i = 0; i < options.keys.lines.length; i++){ legendItems.push(options.keys.lines[i]) }
        
        
        var legendPanelSVGForStkBarWithLinesChart = divLegendPanelStkBarWithLinesChart .append('svg')  .attr("class","")
        .style("background-color", options.BGcolor) .style('position',"absolute").style('width', 100 + "%") .style('height', 100 + "%") .style("left",0 + "%").style("top",0 + "%")
        
        var legend = legendPanelSVGForStkBarWithLinesChart.append("g") .attr("class", "legend") .attr("height", "100%") .attr("width", "100%")
        .attr('transform', 'translate(0,20)') 
        
        //Create colour squares
        var legendGroup = legend.selectAll('rect') .data(legendItems) .enter() .append("rect") .attr("x", 5)
        .attr("y", function(d, i){ return i * 16;}) .attr("width", 14) .attr("height", 14) .attr("rx",10) .attr("ry",10)
        .style("fill", function(d, i){ return colours(i);}) .style("cursor","auto") .style("cursor","auto").attr("legenddotcount",function(d,i){ if(i >= legendItemsArrayLen){ return i - legendItemsArrayLen; } })
      

        //Create text next to squares
        legend.selectAll('text') .data(legendItems) .enter() .append("text") .attr("x", 25) .attr("y", function(d, i){ return i * 16 + 11.4;})
        .attr("fill", "#00001c") .text(function(d,i) {  if(d.length > 10)
            return d.substring(0,10)+'...';
            else
            return d; }) .style('font-size', '14px') .attr("fill","#00001c") .style("font-family","Verdana,sans-serif")

        // Aligning Legend (vertically)
        var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelStkBarWithLinesChart[0][0].style.width) / 100)
        var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelStkBarWithLinesChart[0][0].style.height) / 100)

        var legendRectSize = 11;
        var legendSpacing = 4;
            
        legend.transition().duration(0).attr('transform', function(d, i) {
        var eachRectHeight = legendRectSize + legendSpacing;
        var offset =  eachRectHeight * colours.domain().length / 2;
        var horz = 5;
        var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.stackedBars.length))/2.0; // originally 2.0
            
            return 'translate(' + horz + ',' + vert + ')';
        })

        legendGroup.on('mouseover',function(d,i){
                
                var legDotCountVar = d3.select(legend[0][0]).selectAll("rect")
                       
               if(options.keys.stackedBars.length > 1){ // to check if the stack set is more than 1
               
                   // to check whether the widget is being resized or not (to save new xScale)
                   if(yScale1GlobalVar == undefined){ yScale1GlobalVar = yScale1; }
                   
                   if(newHeightVar == undefined){ newHeightVar = height }
                   
                   textOnStkBarWithLinesChart.style('display','none')
                   
                   d3.select(groupsForStkBarWithLinesChart[0][i]).selectAll('text').style('display','block')
                   .transition().duration(1000).ease('bounce').attr("y", function(d,i) { return (newHeightVar - yScale1GlobalVar(d.x)) - 6 })
                   .style("fill", "#00001c") .style("text-shadow","0px 0px 0px rgba(34,34,34,0.6)") .style('font-size',"12px")
                   
                   
                   groupsForStkBarWithLinesChart.selectAll('rect').style('display','none')
                   var g = d3.select(groupsForStkBarWithLinesChart[0][i]).selectAll('rect').style('display','block')
                   .transition().duration(1000).ease('bounce')
                   .attr("y", function(d,i) { return newHeightVar - yScale1GlobalVar(d.x) })
               }
               
               
               if(parseInt(d3.select(legDotCountVar[0][i]).attr("legenddotcount")) >= 0 && d3.select(legDotCountVar[0][i]).attr("legenddotcount") !== null) {
               
                   d3.select(lines[0][parseInt(d3.select(legDotCountVar[0][i]).attr("legenddotcount"))]).style('stroke-width',2.5)
                   
                   var lineLen = lines.node().getTotalLength();
                   var dashLen = options.data.length;
                   var ddLen = dashLen ;
                   var darray = dashLen;
                   while(ddLen < lineLen){
                   darray+=","+dashLen+","+dashLen;
                   ddLen+=dashLen;
                   }
                   
                   d3.select(lines[0][parseInt(d3.select(legDotCountVar[0][i]).attr("legenddotcount"))]).attr("stroke-linecap", "round").attr("stroke-dasharray", darray + ","+lineLen) .attr("stroke-dashoffset", lineLen)
                   .transition().duration(5000).ease("linear").attr("stroke-dashoffset", 0);
               
               }
                       
        })
        
        legendGroup.on('mouseout',function(d,i){
                       
            var legDotCountVar = d3.select(legend[0][0]).selectAll("rect")
                       
           if(yScale1GlobalVar == undefined){ yScale1GlobalVar = yScale1; }
           
           if(newHeightVar == undefined){ newHeightVar = height; }
           
           textOnStkBarWithLinesChart.style('display','block')
           
           d3.select(groupsForStkBarWithLinesChart[0][i]).selectAll('text').style('display','block').style('font-size',"12px")
           .transition().duration(1000).ease('bounce') .style("fill", "#ffffff") .style("text-shadow","1px 0px 1px rgba(34,34,34,0.6)")
           .attr("y", function(d) { return (newHeightVar - yScale1GlobalVar(d.x0) - yScale1GlobalVar(d.x))+(yScale1GlobalVar(d.x)/1.5);})
           
           
           groupsForStkBarWithLinesChart.selectAll('rect').style('display','block')
           var g = d3.select(groupsForStkBarWithLinesChart[0][i]).selectAll('rect').transition().duration(1000).ease('bounce')
           .attr("y", function(d,i) { return newHeightVar - yScale1GlobalVar(d.x0) - yScale1GlobalVar(d.x) })
           
           if(parseInt(d3.select(legDotCountVar[0][i]).attr("legenddotcount")) >= 0 && d3.select(legDotCountVar[0][i]).attr("legenddotcount") !== null){
               d3.select(lines[0][parseInt(d3.select(legDotCountVar[0][i]).attr("legenddotcount"))]).style('stroke-width',2.5) .transition().duration(0)
               d3.select(lines[0][parseInt(d3.select(legDotCountVar[0][i]).attr("legenddotcount"))]).attr("stroke-dasharray", options.data.length + ","+ 0)  .attr("stroke-dashoffset", 0)
           }
                       
                       
       })
        
        //---------- creating tooltip ----------
        var tooltipForStkBarWithLinesChart = targetElement .append('div') .attr('class', 'tooltipPie') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
        .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
        .style("padding-right", "7px") .style("background", "#ffffff") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style("z-index",1000)
        .style("border", "1.0px") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","60px")
        //tooltipForStkBarWithLinesChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'label').style("color","#000000") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "12px") .style("font-weight", "Bold");
        tooltipForStkBarWithLinesChart.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
        tooltipForStkBarWithLinesChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");
        
        if(options.keys.toolTipLabel.length > 0){
            
            for(toolTipInd = 0; toolTipInd < options.keys.toolTipLabel.length; toolTipInd++){
                tooltipForStkBarWithLinesChart.append('hr').style("height","1px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
                tooltipForStkBarWithLinesChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'tooltip-additional-label' + toolTipInd + '-class' ).style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");
            }
        }
        
    
        rectsForStkBarWithLinesChart.on('mousemove', function (d,i){
               
                var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                
                //tooltipForStkBarWithLinesChart.select('.label').html(options.keys.label + " : " + d.y)
                tooltipForStkBarWithLinesChart.select('.count').html(d.x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
                tooltipForStkBarWithLinesChart.style('visibility', 'visible')
                tooltipForStkBarWithLinesChart.select('hr').style("background-color", d3.select(this).style("fill") )
                tooltipForStkBarWithLinesChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-10) + "px").style("display","block")
                                        
                if(options.keys.toolTipLabel.length > 0){
                    for(ind = 0; ind < options.keys.toolTipLabel.length; ind++){
                        tooltipForStkBarWithLinesChart.select('.tooltip-additional-label' + ind + '-class')
                        .html(options.keys.toolTipLabel[ind] + " : " + options.data[i][options.keys.toolTipLabel[ind]])
                    }
                }

        })
        .on('mouseout', function(){ tooltipForStkBarWithLinesChart.style("display","none") })

        textOnStkBarWithLinesChart.on('mousemove', function (d,i){
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                
                //tooltipForStackedHoriChart.select('.label').html(options.keys.label + " : " + d.y)
                tooltipForStkBarWithLinesChart.select('.count').html(d.x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
                tooltipForStkBarWithLinesChart.style('visibility', 'visible')
                //tooltipForStackedHoriChart.select('hr').style("background-color", d3.select(this).style("fill") )
                tooltipForStkBarWithLinesChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-10) + "px").style("display","block")
                                      
                if(options.keys.toolTipLabel.length > 0){
                    for(ind = 0; ind < options.keys.toolTipLabel.length; ind++){
                        tooltipForStkBarWithLinesChart.select('.tooltip-additional-label' + ind + '-class')
                        .html(options.keys.toolTipLabel[ind] + " : " + options.data[i][options.keys.toolTipLabel[ind]])
                    }
                }
        })
        .on('mouseout', function(){ tooltipForStkBarWithLinesChart.style("display","none") })
        
        circle1.on('mousemove', function (d,i){
                   
               var root = targetElement
               var m = d3.mouse(root.node());
               m[0] += 0
               m[1] += 0
               
               var valueForLineChartToolTip;
               if(d.value.toString().indexOf('.') === -1)
               {
               valueForLineChartToolTip = d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
               }
               else{
               
               valueForLineChartToolTip = d.value;
               }
               
               tooltipForStkBarWithLinesChart.select('.label').html(d.label)
               //tooltipForStkBarWithLinesChart.select('.count').html(d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
               tooltipForStkBarWithLinesChart.select('.count').html(valueForLineChartToolTip)
               tooltipForStkBarWithLinesChart.style('visibility', 'visible')
               tooltipForStkBarWithLinesChart.select('hr').style("background-color", d3.select(this).style("fill") )
               tooltipForStkBarWithLinesChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-20) + "px").style("display","block")
                   
               if(options.keys.toolTipLabel.length > 0){
                   for(ind = 0; ind < options.keys.toolTipLabel.length; ind++){
                        tooltipForStkBarWithLinesChart.select('.tooltip-additional-label' + ind + '-class')
                        .html(options.keys.toolTipLabel[ind] + " : " + options.data[i][options.keys.toolTipLabel[ind]])
                   }
               }
                   
        })
        .on('mouseout', function(){ tooltipForStkBarWithLinesChart.style("display","none"); })
        
        // ----------------------- adding table section ------------------
        var tablePanelForStackedChart =  targetElement.append("div") .attr("id",targetElement[0][0].id + "holderForStackedChartTableID")
        .attr("class","scrollingDivForTable-Class tableDivForStkBarWithLinesChart" + targetElement[0][0].id)  .style('background-color',options.BGcolor)  .style('position','absolute')
        .style("display","block") .style("overflow","hidden") .style("width", function(d) {  return 100.0 + "%"; })
        .style("height", function(d) { return 40 + "%"; }) .style("left",0 + "%").style("z-index",10)
        
        $( '.tableDivForStkBarWithLinesChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        if(options.showTitle == true ){
            tablePanelForStackedChart.style("top",60.0  + "%")
        }
        else if(options.showTitle == false  ){
            tablePanelForStackedChart.style("top",60.0  + "%")
            
        }
        tablePanelForStackedChart.html('<table class = "tableClassForStackedChart' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                       '<thead class = "theadClassForStackedChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForStackedChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                                       '<tbody class = "tBodyClassForStackedChart' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                       '</table>'
                                       )
        
        tablePanelForStackedChart.select('table').attr("id",targetElement[0][0].id + "tableID")

        // Show or Hide Table scroll bar when mouseover on widget
        targetElement.on('mouseover',function(){ tablePanelForStackedChart.style("overflow","auto") })
        targetElement.on('mouseout',function(d){ tablePanelForStackedChart.style("overflow","hidden") })
        
        var tableDataForStkBarWithLinesChart = [];
        if(options.dataForTable.length > 0){
            tableDataForStkBarWithLinesChart = options.dataForTable;
        }
        else {
            tableDataForStkBarWithLinesChart = options.data;
        }
        
        var thead = tablePanelForStackedChart.select("thead").selectAll("th") .data(d3.keys(tableDataForStkBarWithLinesChart[0]))
        .enter().append("th") .text(function(d){return d.charAt(0) .toUpperCase() + d.substr(1)}) .style("cursor","pointer") .style("min-width","100px")
        
        var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style('background-color',options.BGcolor) //f4f4f4
        .style("position","relative")
        
        var thead1 = d3.select(".thead1ClassForStackedChart" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tableDataForStkBarWithLinesChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style('background-color',options.BGcolor) //f4f4f4
        .style("position","relative")
        
        var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
        .attr("id", "ascendingIconIDForStkBarWithLinesChart") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
        
        var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
        .attr("id", "descendingIconIDForStkBarWithLinesChart") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
        
        var tr = tablePanelForStackedChart.select("tbody").selectAll("tr") .data(tableDataForStkBarWithLinesChart).enter().append("tr")
        .attr("id", function(d,i) { return "slice" + i })
        
        // cells
        var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d})
        .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
        
        var $table = $('.tableClassForStackedChart' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
        
        d3.select(".theadClassForStackedChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
            d.forEach(function(dd,j){
                    colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
            })
        })
        
        $(".thead1ClassForStackedChart" + targetElement[0][0].id).insertAfter('.tBodyClassForStackedChart' + targetElement[0][0].id)
        
        $(".thead1ClassForStackedChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForStkBarWithLinesChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
        
        tablePanelForStackedChart.select(".thead1ClassForStackedChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                        d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
        })
        
        $('.tableDivForStkBarWithLinesChart' + targetElement[0][0].id).scroll(function () {
                                                                   
            $(".thead1ClassForStackedChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForStkBarWithLinesChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
                                                                   
        })
        
        var sortOrder = false;
        thead1.on("click",function(k,index){
                 
                 sortOrder = !sortOrder;
                 
                 tablePanelForStackedChart.select(".thead1ClassForStackedChart" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                                                              
                    if (sortOrder) {
                                      
                        if(i == index){
                            d3.select(this).select('svg').select('#descendingIconIDForStkBarWithLinesChart').style("visibility", "hidden")
                            d3.select(this).select('svg').select('#ascendingIconIDForStkBarWithLinesChart').style("visibility", "visible")
                        }
                        else {
                            d3.select(this).select('svg').select('#descendingIconIDForStkBarWithLinesChart').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForStkBarWithLinesChart').style("visibility", "visible")
                        }
                    }
                    else{
                                      
                        if(i == index){
                            d3.select(this).select('svg').select('#descendingIconIDForStkBarWithLinesChart').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForStkBarWithLinesChart').style("visibility", "hidden")
                        }
                        else {
                            d3.select(this).select('svg').select('#descendingIconIDForStkBarWithLinesChart').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForStkBarWithLinesChart').style("visibility", "visible")
                        }
                    }
                })
                 
                  var monthTruOrFalAryForStkBarWithLinesChart = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
                  
                  tr.sort(function(a, b) {
                          
                          if (sortOrder) {
                          var monthsArrayForStkBarWithLinesChart = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                          } else {
                          var monthsArrayForStkBarWithLinesChart = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                          }
                          
                          monthTruOrFalAryForStkBarWithLinesChart = []; gotMonthArray = [];
                          tableDataForStkBarWithLinesChart.forEach(function(d,i){
                                  var da = d[k].toString().substring(0,3).toLowerCase()
                                  if(monthsArrayForStkBarWithLinesChart.indexOf(da) >= 0){
                                      monthTruOrFalAryForStkBarWithLinesChart.push(true)
                                      gotMonthArray.push(da);
                                  }
                                  else {
                                      monthTruOrFalAryForStkBarWithLinesChart.push(false)
                                  }
                           })
                          
                          if(monthTruOrFalAryForStkBarWithLinesChart.indexOf(false) == -1){ // true
                          
                          monthArray = []; monthArrayCount = [];
                          gotMonthArray.forEach(function(dd,j){
                                var index1 = monthsArrayForStkBarWithLinesChart.indexOf(dd.substring(0,3))
                                if(monthArrayCount.indexOf(index1) >= 0){
                                    index1 = 12 + index1;
                                }
                                monthArray.push(index1);
                                monthArrayCount.push(index1)
                          })
                          returnArray = []
                          monthArray.sort(function(aa, bb) {
                                          returnArray.push(+aa - +bb)
                                          return +aa - +bb;
                                          })
                          
                          sortTableFunc()
                          return returnArray[ind++];
                          } //  if true (if jan feb if block)
                          else {
                          var data = +a[k];
                          
                          if(!isNaN(data)){
                          
                          if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                          else { return d3.descending(+a[k], +b[k]); }
                          }
                          else if(!isNaN(Date.parse(a[k]))){
                          
                          if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                          else { return new Date(b[k]) - new Date(a[k]) }
                          }
                          else {
                          
                          if (sortOrder) { return d3.ascending(a[k], b[k]); }
                          else { return d3.descending(a[k], b[k]); }
                          }
                          } // if not jan feb else block
                    }); // tr
                
		})
        
        function sortTableFunc(){
            
            var table = tablePanelForStackedChart.select('table');
            var rows = table.selectAll('tr').data(tableDataForStkBarWithLinesChart);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0).style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500)
            .style('opacity', 1.0).style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
        }
        
        // Main Table Styling
        tablePanelForStackedChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
        .style("color","#00001c")
        .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4")
        tablePanelForStackedChart.selectAll('td').style("height","25px") .style("border", "1px solid #dddddd") .style("font-size","12px").style("font-weight","Normal").style("color","#00001c")

        //additionally 
        tablePanelForStackedChart.selectAll('th').style('background-color',options.BGcolor).style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
        tablePanelForStackedChart.selectAll('td').style('background-color',options.BGcolor).style("border-style","none").style("color","#00001c")

        //b1da9f
        tablePanelForStackedChart.selectAll('table') . style("border-collapse","collapse")
        tablePanelForStackedChart.selectAll('table tr:first-child th').style("border-top","0px")
        tablePanelForStackedChart.selectAll('table tr:last-child td').style("border-bottom","0px")
        tablePanelForStackedChart.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
        tablePanelForStackedChart.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")

        if(showOrHideTableForStkBarWithLinesChart == false){
            tablePanelForStackedChart.style("display","none")
        }
        else if(showOrHideTableForStkBarWithLinesChart == true){
            tablePanelForStackedChart.style("display","block")
        }

        if(options.isDataDetailedForTable == false){

            var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
        
            // Adding underlines for selected drill-down column text
            var drillDownSectionsForStackedChart = tablePanelForStackedChart.select('table').selectAll('th')
        
            var foundResult = [];
            for(var i = 0; i<drillDownSectionsForStackedChart[0].length; i++){
            
                for(var j = 0; j<drillDownColumnNamesArray.length; j++){
                    if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForStackedChart[0][i].__data__.toString().toLowerCase() ){
                        foundResult.push(i)
                    }
                }
            }
        
            var r = tablePanelForStackedChart.select('table').selectAll('tr').selectAll('td')
            for(var i = 0; i<r.length; i++){
                for(var j = 0; j < foundResult.length; j++){
                    var row = r[i][foundResult[j]]
                    $(row).css("text-decoration", "underline")
                }
            }
        }
        
        //By default calling the resized function first time (to align table's th and td).
        setTimeout(function(){ resizedFuctionForStkBarWithLinesChart() },1000)
        
        window.addEventListener('resize', function(event){ resizedFuctionForStkBarWithLinesChart() });
        
		var xScale1GlobalVar; // storing the new yScale when parent div is resized.
        var yScale1GlobalVar; // storing the new yScale when parent div is resized.
        var newHeightVar; // storing the new height when parent div is resized.

        $(function() {
          
			$("#" + targetElement[0][0].id).resizable({
				resize: function(event, ui) {
					//divWidthForHoriChart = ui.size.width;
					//divHeightForHoriChart = ui.size.height;
					resizedFuctionForStkBarWithLinesChart();
				}
			});
		});
        
        function resizedFuctionForStkBarWithLinesChart()
        {
            
            if((svgPanelForStkBarWithLinesChart.node().getBoundingClientRect().width) && (svgPanelForStkBarWithLinesChart.node().getBoundingClientRect().height) > 0){

                if(showOrHideCommentsBtnForStkBarWithLinesChart == true){
                    filterBtnForStkBarWithLinesChart.style('margin-left', "2px")
                    refreshBtnForStkBarWithLinesChart.style('margin-left', "2px")
                    commentsBtnForStkBarWithLinesChart.style('margin-left', "2px")
                    menuBtnForStkBarWithLinesChart.style('right', '0')
                }
                else if(showOrHideCommentsBtnForStkBarWithLinesChart == false){
                    filterBtnForStkBarWithLinesChart.style('margin-left', "2px")
                    refreshBtnForStkBarWithLinesChart.style('margin-left', "2px")
                    //commentsBtnForStkBarWithLinesChart.style('right', '0')
                    commentsBtnForStkBarWithLinesChart.style('display','none')
                    menuBtnForStkBarWithLinesChart.style('right', '0')
                }

                optsBtnPanelForStkBarWithLinesChart.style('right', '0')

                stgPanCanBtnForStkBarWithLinesChart.style('right', '0')

               if(options.showTitle == true){
                
                    var margin1 = {top: 10 , right: 20, bottom: 80, left: 20}, //originally top: 42, left: 80
                    width1 = (svgPanelForStkBarWithLinesChart.node().getBoundingClientRect().width) - margin.left - margin.right,
                    height1 = (svgPanelForStkBarWithLinesChart.node().getBoundingClientRect().height) - margin.top - margin.bottom;
                    newHeightVar = height1
                }
                else if(options.showTitle == false){
                
                    var margin1 = {top: 10 , right: 20, bottom: 80, left: 20}, //originally top: 42, left: 80
                    width1 = (svgPanelForStkBarWithLinesChart.node().getBoundingClientRect().width) - margin.left - margin.right,
                    height1 = svgPanelForStkBarWithLinesChart.node().getBoundingClientRect().height - margin.top - margin.bottom;
                    newHeightVar = height1
                }

                var xMax1 =  d3.max(dataset, function (group) {
                    
                    return d3.max(group, function (d) {
                        return (+d.x) + (+d.x0);
                    });
                })

                var xScale2 = d3.scale.ordinal() .domain(months) .rangeRoundBands([0, width1], .20)
            
                var yScale2 = d3.scale.linear() .domain([0, xMax1]) .range([0, height1])
            
                xScale1GlobalVar = xScale2;
                yScale1GlobalVar = yScale2;

                xAxis.scale(xScale2) .orient('bottom')

                var svg1 = svgPanelForStkBarWithLinesChart;

                svg1.select("svg")
                //.attr("width", width1 + margin1.left + margin1.right)
                //.attr("height", height1 + margin1.top + margin1.bottom);

                svg1.select(".x.axis") .attr('transform', 'translate(0,' + height1 + ')') .call(xAxis)
                .selectAll("text") .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') .attr("transform", function(d) {
                    if(numberGreaterThanLimit.length>0){return "rotate(-45)"}
                    else{
                    return "rotate(0)" } })
                .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
                .text(function(d,i) {
                    if(d.length > 9){
                        return d.substring(0,9)+'...';
                    }
                    else{
                        return d;
                    }
                })

                xAxisVariable.attr("transform", "translate(" + ((width1/2) - 0) + " ," + (height1+margin1.bottom - 2) + ")")

                //rectsForStkBarWithLinesChart = groupsForStkBarWithLinesChart.selectAll('rect')
                //svg1.selectAll(".bar")
                groupsForStkBarWithLinesChart.selectAll('rect')
                .attr('x', function (d,i) { return xScale2(d.y); })
                .attr('y', function (d, i) { return height1 -yScale2(d.x0) - yScale2(d.x) })
                .attr("width", xScale2.rangeBand())
                .attr("height", function (d) { return yScale2(d.x); });

                textOnStkBarWithLinesChart
                .attr("x", function(d,i) { return xScale2(d.y)+xScale2.rangeBand()/2; })
                .attr("y", function(d) { return (height1 -yScale2(d.x0) - yScale2(d.x))+(yScale2(d.x)/1.5);})
                
                
                //---------------------- Resizing lines -----------------------
                
                xForLine.domain(options.data.map(function(d,i) { return d[options.keys.label];})).rangePoints([0, width1],1.31);
                
                x1ForLine.domain(options.data.map(function(d) { return d[options.keys.label]; })) .rangePoints([0, width1], 1.31);
                
                var yyForLine = d3.scale.linear().domain([0, xMax1] ).range([height1, 0]);
                
                yAxisForLine.scale(yyForLine) .orient("left");
                
                xAxisForLine.scale(xForLine) .orient("bottom");
                
                line.x(function (d) { return xForLine(d['label']); }) .y(function (d) { return yyForLine(+d["value"]); });
                
                var svg1 = svgPanelForStkBarWithLinesChart;
                
                //svg1.select("svg") .attr("width", width1 + margin1.left + margin1.right) .attr("height", height1 + margin1.top + margin1.bottom)
                
                //svg1.select(".y.axis") .call(yAxis)
                
                //svg1.select(".x.axis") .attr("transform", "translate(0," + height1 + ")") .call(xAxis)
                
                svg1.selectAll("circle") .transition() .delay(function (d, i) { return i / options.data.length * 50; }) .duration(900).ease("bounce")
                .attr("cx", function(d,i) {  return x1ForLine(d['label']); }) .attr("cy", function(d,i) {  return yyForLine(+d["value"]); })
                
                svg1.selectAll(".line").attr("d", function (d,i) { return line(d.Data); })
                
                //-------------------------------------------------------------
            
                // Aligning Legend (vertically)
                var legendPanelWidth = targetElement[0][0].clientWidth * (parseFloat(divLegendPanelStkBarWithLinesChart[0][0].style.width) / 100)
                var legendPanelHeight = targetElement[0][0].clientHeight * (parseFloat(divLegendPanelStkBarWithLinesChart[0][0].style.height) / 100)

                var legendRectSize = 11;
                var legendSpacing = 4;
                
                legend.attr('transform', function(d, i) {
                var eachRectHeight = legendRectSize + legendSpacing;
                var offset =  eachRectHeight * colours.domain().length / 2;
                var horz = 5;
                var vert = (i * eachRectHeight) + (legendPanelHeight - (eachRectHeight * options.keys.stackedBars.length))/2.0; // originally 2.0
                    
                    return 'translate(' + horz + ',' + vert + ')';
                })
                
                colWidth = []; 
				
                d3.select(".theadClassForStackedChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
					d.forEach(function(dd,j){
						colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
					})
                })
                tablePanelForStackedChart.select(".thead1ClassForStackedChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                        d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
                })
                
            }// checking svg panel width & height greater than zero function

        }
        
    }, //stackedBarWithLinesChart
	// ************************************************ Traffic Chart Chart  **************************************************
    trafficLightsChart: function(targetElement, options){

        isChartCalled++;

        var chartName = "TRAFFICLIGHTSCHART";
        
        acinfotech.allCharts(targetElement,options,chartName);

        var newJson = [];
        options.data.forEach(function(d, i) {
            
			if(d[options.keys.label].toString().toLowerCase() == "red"){
				newJson[0] = d;
			}
			else if(d[options.keys.label].toString().toLowerCase() == "yellow"){
				newJson[1] = d;
			}
			else if(d[options.keys.label].toString().toLowerCase() == "green"){
				newJson[2] = d;
			}
            
		});

        targetElement.style("min-width","350px").style("min-height","350px").style("background-color", options.BGcolor)

        var showOrHideTableForTrafficLightsChart;
        var showOrHideCommentsForTrafficLightsChart;
        var showOrHideCommentsBtnForTrafficLightsChart = true;

        if((options.showTable == false) || (options.showTable == true)){
            showOrHideTableForTrafficLightsChart = options.showTable    
        }
        else{
            showOrHideTableForTrafficLightsChart = false;
        }

        // Show or Hide comments
        if (options.showComments == true || false) {
            showOrHideCommentsForTrafficLightsChart = options.showComments;
        }
        else {
            showOrHideCommentsForTrafficLightsChart = false;
        }
        
        if (options.comments.length == 0){ 
            showOrHideCommentsForTrafficLightsChart = false;
            showOrHideCommentsBtnForTrafficLightsChart = false;
        }

        if ((showOrHideTableForTrafficLightsChart == true) && (showOrHideCommentsForTrafficLightsChart == true)){
            showOrHideTableForTrafficLightsChart = true;
            showOrHideCommentsForTrafficLightsChart = false;
        }
        else if ((showOrHideTableForTrafficLightsChart == false) && (showOrHideCommentsForTrafficLightsChart == false)){
            showOrHideTableForTrafficLightsChart = false;
            showOrHideCommentsForTrafficLightsChart = false;
        }

        var chartTitlePanelForTrafficLightsChart =  targetElement.append("div") .style("position","absolute").style("background-color", options.BGcolor) .style("text-indent","6px") .style("border", "none")
        
		var optionsBtnPanelForTrafficLightsChart = targetElement.append('div').style('width',"25px").style('height',"80px").style('position','absolute')
        .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px")
        .style('right', '0') .style("min-width","25px") .style("border-style","none") 
        .style("border-left", "solid #fcfcfc  1px")
		
        var commentsBtnForTrafficLightsChart = optionsBtnPanelForTrafficLightsChart.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','55px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var commentsBtnImgVariable = document.createElement("IMG");
        if(options.showComments == false){
            commentsBtnImgVariable.src = "images/showCommentsIcon.png";
        }
        else if(options.showComments == true){
            commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
        }
        commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        commentsBtnForTrafficLightsChart[0][0].appendChild(commentsBtnImgVariable)

        var menuBtnForTrafficLightsChart = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','1px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var menuBtnImgVar = document.createElement("IMG");
        menuBtnImgVar.src = "images/menuIcon.png";
        menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
        menuBtnForTrafficLightsChart[0][0].appendChild(menuBtnImgVar)

        if(showOrHideCommentsBtnForTrafficLightsChart == true){
            commentsBtnForTrafficLightsChart.style('margin-left', "2px")
            menuBtnForTrafficLightsChart.style('right', '0')
        }
        else if(showOrHideCommentsBtnForTrafficLightsChart == false){
            //commentsBtnForTrafficLightsChart.style('right', '0')
            commentsBtnForTrafficLightsChart.style('display','none')
            menuBtnForTrafficLightsChart.style('right', '0')
        }

        var ismenuBtnOfTrafficLightsChartClicked = false;
        menuBtnForTrafficLightsChart.on('click', function() {

            if(ismenuBtnOfTrafficLightsChartClicked == false){
                ismenuBtnOfTrafficLightsChartClicked = true;
                optionsBtnPanelForTrafficLightsChart.style("display","block")

                if ((showOrHideTableForTrafficLightsChart == false) && (showOrHideCommentsForTrafficLightsChart == true)){
                    svgLegendPanelTrafficLightsChart.style('width', 30 + "%") .style('height', 70 + "%") .style("left",70 + "%").style("top",8 + "%") .style('position',"absolute")
                    ligthsBackgroundDiv .style("top", "8%") .style("height", "70%")
                    svgPanelForTrafficLightsChart.style('width', 100 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                    .style("position","absolute");
                }
                else if ((showOrHideTableForTrafficLightsChart == true) && (showOrHideCommentsForTrafficLightsChart == false)){
                    svgLegendPanelTrafficLightsChart.style('width', 30 + "%") .style('height', 52 + "%") .style("left",70 + "%").style("top",8 + "%") .style('position',"absolute")       
                    ligthsBackgroundDiv .style("top", "8%") .style("height", "52%")
                    svgPanelForTrafficLightsChart.style('width', 100 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute");
                }
                else if ((showOrHideTableForTrafficLightsChart == false) && (showOrHideCommentsForTrafficLightsChart == false)){
                    svgLegendPanelTrafficLightsChart.style('width', 30 + "%") .style('height', 85 + "%") .style("left",70 + "%").style("top",8 + "%") .style('position',"absolute")       
                    ligthsBackgroundDiv .style("top", "8%") .style("height", "85%")
                    svgPanelForTrafficLightsChart.style('width', 100 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute");
                }

            }
            else if(ismenuBtnOfTrafficLightsChartClicked == true){
                ismenuBtnOfTrafficLightsChartClicked = false
                optionsBtnPanelForTrafficLightsChart.style("display","none")

                if ((showOrHideTableForTrafficLightsChart == false) && (showOrHideCommentsForTrafficLightsChart == true)){
                    svgLegendPanelTrafficLightsChart.style('width', 30 + "%") .style('height', 70 + "%") .style("left",70 + "%").style("top",8 + "%") .style('position',"absolute")
                    ligthsBackgroundDiv .style("top", "8%") .style("height", "70%")
                    svgPanelForTrafficLightsChart.style('width', 100 + "%") .style('height', 70 + "%") .style("left", 0 + "%") .style("top", 8.0  + "%")
                    .style("position","absolute");
                }
                else if ((showOrHideTableForTrafficLightsChart == true) && (showOrHideCommentsForTrafficLightsChart == false)){
                    svgLegendPanelTrafficLightsChart.style('width', 30 + "%") .style('height', 52 + "%") .style("left",70 + "%").style("top",8 + "%") .style('position',"absolute")       
                    ligthsBackgroundDiv .style("top", "8%") .style("height", "52%")
                    svgPanelForTrafficLightsChart.style('width', 100 + "%") .style('height', 52 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute");
                }
                else if ((showOrHideTableForTrafficLightsChart == false) && (showOrHideCommentsForTrafficLightsChart == false)){
                    svgLegendPanelTrafficLightsChart.style('width', 30 + "%") .style('height', 85 + "%") .style("left",70 + "%").style("top",8 + "%") .style('position',"absolute")       
                    ligthsBackgroundDiv .style("top", "8%") .style("height", "85%")
                    svgPanelForTrafficLightsChart.style('width', 100 + "%") .style('height', 85 + "%") .style("left",0 + "%") .style("top",8.0  + "%")
                    .style("position","absolute");
                }
            }

            resizedFuctionForTrafficLightsChart();
        })

        var tableButtonForTrafficLightsChart = optionsBtnPanelForTrafficLightsChart.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top','1px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
        var tableBtnImgVar = document.createElement("IMG");
        if(showOrHideTableForTrafficLightsChart == false){
            tableBtnImgVar.src = "images/showTableIcon.png";
            tableButtonForTrafficLightsChart.attr("class","showTableClassForChartTable")
        }
        else if(showOrHideTableForTrafficLightsChart == true){
            tableBtnImgVar.src = "images/cancelTableIcon.png";
            tableButtonForTrafficLightsChart.attr("class","hideTableClassForChartTable")
        }
        tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
        tableButtonForTrafficLightsChart[0][0].appendChild(tableBtnImgVar)

        var downloadBtnForTrafficLightsChart = optionsBtnPanelForTrafficLightsChart.append("div").attr("id","downloadBtnForTrafficLightsChart-ID-" + targetElement[0][0].id).style("width","20px").style("height","20px")
        .style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff").style('margin-left','2px').style('top', 28 + 'px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        
        acinfotech.downloadFunctionality("downloadBtnForTrafficLightsChart-ID-" + targetElement[0][0].id,targetElement)
        
		var ligthsBackgroundDiv = targetElement .append('div') .style("position", "absolute") //.style("left", "25px") 
		.style("top", "8%") .style("width", "35%") .style("height", "85%") .style("background-color", "#161616")
		
		
        var svgPanelForTrafficLightsChart = targetElement .append('svg') .attr("id","svgPanelIDForTrafficLightsChart" + targetElement[0][0].id)
        .style("position","absolute")
        
        var commentsPanelDivForTrafficLightsChart = targetElement.append("div") .attr("class","commentsPanelClassForTLChart") 
        .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
		.style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
        .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)

        commentsPanelDivForTrafficLightsChart.on('click',function(d){
            $('.commentsClassForTrafficLightsChart' + targetElement[0][0].id).focus()
        })

        if(options.showTitle == true){
            
            chartTitlePanelForTrafficLightsChart.style("width", function(d) {  return 100.0 + "%"; }).style("background-color", options.BGcolor) .style("height", function(d) { return 8 + "%"; })
            .html('<div  style="width: 100%; height:0%; position: absolute; top:10.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>') //color 325922

            if ((showOrHideTableForTrafficLightsChart == false) && (showOrHideCommentsForTrafficLightsChart == true)){

                var commentsForTrafficLightsChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify').attr('class','commentsClassForTrafficLightsChart' + targetElement[0][0].id)
					
				   ligthsBackgroundDiv .style("top", "8%") .style("height", "70%")
					
                   svgPanelForTrafficLightsChart.attr('width', 100 + "%") .attr('height', 70 + "%") .style("top",8 + "%") 
                   commentsPanelDivForTrafficLightsChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForTrafficLightsChart[0].outerHTML.toString())

            }
            else if ((showOrHideTableForTrafficLightsChart == true) && (showOrHideCommentsForTrafficLightsChart == false)){
					ligthsBackgroundDiv .style("top", "8%") .style("height", "52%")
			
                    svgPanelForTrafficLightsChart.attr('width', 100 + "%") .attr('height', 52 + "%") .style("top",8 + "%") 
                    commentsPanelDivForTrafficLightsChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForTrafficLightsChart == false) && (showOrHideCommentsForTrafficLightsChart == false)){
					ligthsBackgroundDiv .style("top", "8%") .style("height", "85%")
                    svgPanelForTrafficLightsChart.attr('width', 100 + "%") .attr('height', 85 + "%") .style("top",8 + "%") 
                    commentsPanelDivForTrafficLightsChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            
        }
        else if(options.showTitle == false){

            chartTitlePanelForTrafficLightsChart.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });

            if ((showOrHideTableForTrafficLightsChart == false) && (showOrHideCommentsForTrafficLightsChart == true)){

                var commentsForTrafficLightsChart = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify')
					
				   ligthsBackgroundDiv .style("top", "8%") .style("height", "70%")
                   svgPanelForTrafficLightsChart.attr('width', 100 + "%") .attr('height', 70 + "%") .style("top",8 + "%") 
                   commentsPanelDivForTrafficLightsChart.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForTrafficLightsChart[0].outerHTML.toString())

            }
            else if ((showOrHideTableForTrafficLightsChart == true) && (showOrHideCommentsForTrafficLightsChart == false)){
					ligthsBackgroundDiv .style("top", "8%") .style("height", "52%")
                    svgPanelForTrafficLightsChart.attr('width', 100 + "%") .attr('height', 52 + "%") .style("top",8 + "%") 
                    commentsPanelDivForTrafficLightsChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForTrafficLightsChart == false) && (showOrHideCommentsForTrafficLightsChart == false)){
					ligthsBackgroundDiv .style("top", "8%") .style("height", "85%")
                    svgPanelForTrafficLightsChart.attr('width', 100 + "%") .attr('height', 85 + "%") .style("top",8 + "%") 
                    commentsPanelDivForTrafficLightsChart.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
        }
        
		var svgLegendPanelTrafficLightsChart = targetElement .append('div')  .attr("class","svgLegendPanelClassForTrafficLightsChart").style("background-color", options.BGcolor) .style('position',"absolute")
         .style('width', 30 + "%") .style('height', 92 + "%") .style("left",70 + "%").style("top",8 + "%")
		 .style("display","none")

            if ((showOrHideTableForTrafficLightsChart == false) && (showOrHideCommentsForTrafficLightsChart == true)){

                svgLegendPanelTrafficLightsChart.style('width', 30 + "%") .style('height', 70 + "%") .style("left",70 + "%").style("top",8 + "%") 
            }
            else if ((showOrHideTableForTrafficLightsChart == true) && (showOrHideCommentsForTrafficLightsChart == false)){

                svgLegendPanelTrafficLightsChart.style('width', 30 + "%") .style('height', 52 + "%") .style("left",70 + "%").style("top",8 + "%")        
            }
            else if ((showOrHideTableForTrafficLightsChart == false) && (showOrHideCommentsForTrafficLightsChart == false)){
               
                svgLegendPanelTrafficLightsChart.style('width', 30 + "%") .style('height', 85 + "%") .style("left",70 + "%").style("top",8 + "%") 
            }
        
        var colors = d3.scale.ordinal() .range(["#f92030", "#efe709", "#049e25"])
		
		commentsBtnForTrafficLightsChart.on('click', function() {

            if(options.showComments == false){ 
                options.showComments = true;
            }
            else if(options.showComments == true){ 
                options.showComments = false;
            }

            //isFilterClicked = false
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                    options.showTable = false;
                }
            }
            acinfotech.trafficLightsChart(targetElement,options) 
        })

        // showing/hidding chart table
        tableButtonForTrafficLightsChart.on('click', function() {

            if(showOrHideTableForTrafficLightsChart == false){
                options.showTable = true;
            }
            else if(showOrHideTableForTrafficLightsChart == true){
                options.showTable = false;
            }

            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,button').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){

                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                    options.showComments = false;
                }
            }
            acinfotech.trafficLightsChart(targetElement,options)
        })

        
        downloadBtnForTrafficLightsChart.on('click', function() {
                                  
            ismenuBtnOfTrafficLightsChartClicked = false; // Changing menu button value to false
            optionsBtnPanelForTrafficLightsChart.style("display","none") // Hiding option buttons panel
                                  
        })
        
        // Creating ToolTip for options button.
        var iconButtonTooltipForTrafficLightsChart = targetElement.append('div').style('width','240px').attr("id","too") .style('height',"25px")
        .style('position','absolute') .style("background-color",'#404040 ') .style("z-index",999).style("border", "0.0px") 
        .style("border-color", "#278eff") .style("border-style", "solid") .style("border-radius","0px") .style("box-shadow", "1px 1px 2px #d8d8d8")
        .style("display","none").attr("border", 0.0)

        commentsBtnForTrafficLightsChart.on('mousemove', function(d,i) {
            commentsPanelDivForTrafficLightsChart.style('background-color','#fafafa')
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                if(options.showComments == false){
                    var commentButtonTooltipText = "Show Comments";
                }
                else if(options.showComments == true){
                    var commentButtonTooltipText = "Hide Comments";
                }
            
            iconButtonTooltipForTrafficLightsChart.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForTrafficLightsChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ commentButtonTooltipText +'</div>')
        })
        commentsBtnForTrafficLightsChart.on('mouseout', function(d,i) {
            commentsPanelDivForTrafficLightsChart.style('background-color','#ffffff')
            iconButtonTooltipForTrafficLightsChart.style("display","none")
        })

        tableButtonForTrafficLightsChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            if(showOrHideTableForTrafficLightsChart == false){
                var tableBtnTooltipText = "Show Table";
            }
            else if(showOrHideTableForTrafficLightsChart == true){
                var tableBtnTooltipText = "Hide Table";
            }
            
            
            iconButtonTooltipForTrafficLightsChart.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForTrafficLightsChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ tableBtnTooltipText +'</div>')

        })
        tableButtonForTrafficLightsChart.on('mouseout', function(d,i) {
            iconButtonTooltipForTrafficLightsChart.style("display","none")
        })
        
        downloadBtnForTrafficLightsChart.on('mousemove', function(d,i) {
          var root = targetElement
          var m = d3.mouse(root.node());
          m[0] += 0
          m[1] += 0
          var downloadButtonTooltipText = "Download";
          
          iconButtonTooltipForTrafficLightsChart.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
          iconButtonTooltipForTrafficLightsChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
        })
        downloadBtnForTrafficLightsChart.on('mouseout', function(d,i) {
          iconButtonTooltipForTrafficLightsChart.style("display","none")
        })
        
         menuBtnForTrafficLightsChart.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var menuButtonTooltipText = "Menu";
            
            iconButtonTooltipForTrafficLightsChart.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltipForTrafficLightsChart.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter;  color:#ffffff; text-align:center;">'+ menuButtonTooltipText +'</div>')
        })
        menuBtnForTrafficLightsChart.on('mouseout', function(d,i) {
            iconButtonTooltipForTrafficLightsChart.style("display","none")
        })

        //-------- creating tooltip --------

        var tooltipForTrafficLightsChart = targetElement .append('div') .attr('class', 'tooltipbubble') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
        .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
        .style("padding-right", "7px") .style("background", "#ffffff") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style("z-index",1000)
        .style("border", "1.0px") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","80px")
        tooltipForTrafficLightsChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'label').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "14px") .style("font-weight", "normal");
        tooltipForTrafficLightsChart.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
        tooltipForTrafficLightsChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'count').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");
		
		if(options.keys.toolTipLabel.length > 0){
            
            for(toolTipInd = 0; toolTipInd < options.keys.toolTipLabel.length; toolTipInd++){
                tooltipForTrafficLightsChart.append('hr').style("height","1px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
                tooltipForTrafficLightsChart.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'tooltip-additional-label-of-traffic-lights-chart' + toolTipInd + '-class' ).style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");
            }
        }

        var diameterWidth = document.getElementById("svgPanelIDForTrafficLightsChart" + targetElement[0][0].id).getBoundingClientRect().width;//svgPanelForTrafficLightsChart[0][0].clientWidth;
        var diameterHeight = document.getElementById("svgPanelIDForTrafficLightsChart" + targetElement[0][0].id).getBoundingClientRect().height;//svgPanelForTrafficLightsChart[0][0].clientHeight;
		
		//ligthsBackgroundDiv.style("margin-left", (diameterWidth/3.8) + "px")
		ligthsBackgroundDiv.style("left", "25%")
	
        var bubbleLayout = d3.layout.pack().sort(null).size([diameterWidth,diameterHeight])
        .padding(1.5);
        
		var trafficLightsChartSVG = svgPanelForTrafficLightsChart.append("svg")//.style("background","#606060")
        .attr("width" , diameterWidth).attr("height", diameterHeight)
        
		
		var filteredArray = [], circlesStaticValueArr = [33,33,33];
        newJson.forEach(function(d,i){ 
            var temp = {};
            temp[options.keys.label] = d[options.keys.label]
            temp["value"] = circlesStaticValueArr[i];
			temp["circlesLabel"] = d["Label"] || d["label"]
			filteredArray.push(temp)
		})
        
        var selection = trafficLightsChartSVG.selectAll("g.node")
        .data(bubbleLayout.nodes({children: filteredArray}).filter(function(d) { return !d.children; }) );
		
		
		//var circlesLeftMargin = parseFloat(ligthsBackgroundDiv.style("left")) + (parseFloat(ligthsBackgroundDiv.style("width"))/2)
		
		var circlesLeftMargin = parseFloat(ligthsBackgroundDiv.style("left"))
		var marginYArr = [(diameterHeight/4.95),(diameterHeight/1.98),(diameterHeight/1.239)] // 60 150 240 
		var blackBackgroundWidth = 0;
		
        var node = selection.enter().append("g").attr("class", "node")
        .attr("transform", function(d,i) { return "translate(" + (circlesLeftMargin + d.r) + ", " + marginYArr[i] + ")"; }).filter( function(d,i){if(d.value == 0){ d.value = 0.000000000000001;
        d3.select(selection[0][i]).style("display","none"); }; return d.value > 0; }) //HERE
        
        var bubbles = node.append("circle").filter(function(d) { return !d.children; }) //.transition()
        //.delay(function (d, i) { return i / bubbleLayout.nodes({children: filteredArray}).filter(function(d) { return !d.children; }).length * 300; }) .duration(10)
        .attr("r", function(d) { blackBackgroundWidth = d.r; return (d.r/1.8); }) .style("fill", function(d,i) { return colors(i) })
		.style('fill-opacity', 0.5).transition().delay(400).duration(800).style('fill-opacity', 1)
        
        node.append("text").filter(function(d) { return !d.children; }) //.transition()
        //.delay(function (d, i) { return i / bubbleLayout.nodes({children: filteredArray}).filter(function(d) { return !d.children; }).length * 300; }) .duration(10)
        .attr("dy", ".3em").attr("x",(blackBackgroundWidth + 10) + "px") .style("text-anchor", "start") .style("font-size", "15px") .style("fill",function(d,i){ return "#00001c" })
        .style("font-weight","normal") .text(function(d,i) { return " " + newJson[i][options.keys.value] + " " + d["circlesLabel"]; }) .style("font-family", "Verdana,sans-serif");
		
		node.on('mousemove', function (d,i){
                    
            var root = targetElement
            var m = d3.mouse(root.node());
            m[0] += 0
            m[1] += 0
            
            var valueForTrafficLightsChartToolTip;
            if(newJson[i][options.keys.value].toString().indexOf('.') === -1)
            {
                valueForTrafficLightsChartToolTip = newJson[i][options.keys.value].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				valueForTrafficLightsChartToolTip += " " + filteredArray[i]["circlesLabel"];
            }
            else{
                    
                valueForTrafficLightsChartToolTip = newJson[i][options.keys.value];
				valueForTrafficLightsChartToolTip += " " + filteredArray[i]["circlesLabel"];
            }
			
            tooltipForTrafficLightsChart.select('.label').html(options.keys.label + " : " + d[options.keys.label])
            //tooltipForTrafficLightsChart.select('.count').html(options.keys.value + " : " + options.data[i][options.keys.value].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
            tooltipForTrafficLightsChart.select('.count').html(options.keys.value + " : " + valueForTrafficLightsChartToolTip)
            tooltipForTrafficLightsChart.style('visibility', 'visible')
            tooltipForTrafficLightsChart.select('hr').style("background-color", function(d){ return colors(i) })
            tooltipForTrafficLightsChart.style("margin-left", (m[0]+15) + "px").style("margin-top",(m[1]-20) + "px").style("display","block")
			
			if(options.keys.toolTipLabel.length > 0){
				for(ind = 0; ind < options.keys.toolTipLabel.length; ind++){
					tooltipForTrafficLightsChart.select('.tooltip-additional-label-of-traffic-lights-chart' + ind + '-class')
					.html(options.keys.toolTipLabel[ind] + " : " + newJson[i][options.keys.toolTipLabel[ind]])
				}
			}

        })
        .on('mouseout', function(){ tooltipForTrafficLightsChart.style("display","none") })

        var columnNames = d3.keys(options.data[0])
        var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
        
        for(var i = 0; i < columnNames.length ; i++){
            for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                    for(var k = 0; k < node[0].length; k++){
                        d3.select(node[0][k]).attr('data-drilldownkey', function(d,index){
                            return JSON.stringify(newJson[k]).slice(1, -1).split('"').join("").split(':').join("|")
                        })
                        d3.select(node[0][k]).select('circle').attr('data-drilldownkey', function(d,index){
                            return JSON.stringify(newJson[k]).slice(1, -1).split('"').join("").split(':').join("|")
                        })
                    }
                }
                else {
                }
            }
        }

        var tableDivForTrafficLightsChart = targetElement .append('div') 
            .attr("class","scrollingDivForTable-Class tableDivForTrafficLightsChart" + targetElement[0][0].id) .style('background-color',"#ffffff") .style("position","absolute")
            .style("display","block") .style("overflow","hidden") //.style("border-right","1px solid #e2e2e2").style("border-bottom","1px solid #e2e2e2")

            $( '.tableDivForTrafficLightsChart' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
                var e0 = e.originalEvent,
                delta = e0.wheelDelta || -e0.detail;
    
                this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
                e.preventDefault();
            });
            
            if(options.showTitle == true){
                tableDivForTrafficLightsChart.style("width", 100 + "%") .style("height", 40 + "%") .style("top",60 + "%") 
            }
            else if(options.showTitle == false){
                tableDivForTrafficLightsChart.style("width", 100 + "%") .style("height", 40 + "%") .style("top",60 + "%") 
            }

        tableDivForTrafficLightsChart.html('<table class = "tableClassForTrafficLightsChart' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                    '<thead class = "theadClassForTrafficLightsChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForTrafficLightsChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                                    '<tbody class = "tBodyClassForTrafficLightsChart' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                    '</table>'
                                    )
        
        tableDivForTrafficLightsChart.select('table').attr("id",targetElement[0][0].id + "tableID")

        // Show or Hide Table scroll bar when mouseover on widget
        targetElement.on('mouseover',function(){ tableDivForTrafficLightsChart.style("overflow","auto") })
        targetElement.on('mouseout',function(d){ tableDivForTrafficLightsChart.style("overflow","hidden") })
        
        var tableDataForTrafficLightsChart = [];
        if(options.dataForTable.length > 0){
            tableDataForTrafficLightsChart = options.dataForTable;
        }
        else {
            tableDataForTrafficLightsChart = newJson;
        }
        
        var thead = tableDivForTrafficLightsChart.select("thead").selectAll("th") .data(d3.keys(tableDataForTrafficLightsChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#fefdfd")//f6f6f6
        .style("position","relative").style("top","2px")
        
        var thead1 = d3.select(".thead1ClassForTrafficLightsChart" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tableDataForTrafficLightsChart[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#fefdfd")//f6f6f6
        .style("position","relative").style("top","2px")
        
        var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
        .attr("id", "ascendingIconIDForTrafficLightsChart") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
        
        var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
        .attr("id", "descendingIconIDForTrafficLightsChart") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
        
        var tr = tableDivForTrafficLightsChart.select("tbody").selectAll("tr") .data(tableDataForTrafficLightsChart).enter().append("tr")
        .attr("id", function(d,i) { return "slice" + i })
        
        // cells
        var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d; })
        .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
        
        var $table = $('.tableClassForTrafficLightsChart' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];

        d3.select(".theadClassForTrafficLightsChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                d.forEach(function(dd,j){
                    colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                })
        })
        
        $(".thead1ClassForTrafficLightsChart" + targetElement[0][0].id).insertAfter('.tBodyClassForTrafficLightsChart' + targetElement[0][0].id)
        
        $(".thead1ClassForTrafficLightsChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForTrafficLightsChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
        
        tableDivForTrafficLightsChart.select(".thead1ClassForTrafficLightsChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                                                                                                                 d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
                                                                                                                 })
        
        $('.tableDivForTrafficLightsChart' + targetElement[0][0].id).scroll(function () {
                                                                  
            $(".thead1ClassForTrafficLightsChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForTrafficLightsChart' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
                                                                  
        })
        
        var sortOrder = false;
        thead1.on("click",function(k,index){
                 
             sortOrder = !sortOrder;
             
             tableDivForTrafficLightsChart.select(".thead1ClassForTrafficLightsChart" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                                                
                    if (sortOrder) {
                                      
                        if(i == index){
                            d3.select(this).select('svg').select('#descendingIconIDForTrafficLightsChart').style("visibility", "hidden")
                            d3.select(this).select('svg').select('#ascendingIconIDForTrafficLightsChart').style("visibility", "visible")
                        }
                        else {
                            d3.select(this).select('svg').select('#descendingIconIDForTrafficLightsChart').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForTrafficLightsChart').style("visibility", "visible")
                        }
                    }
                    else{
                                      
                        if(i == index){
                            d3.select(this).select('svg').select('#descendingIconIDForTrafficLightsChart').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForTrafficLightsChart').style("visibility", "hidden")
                        }
                        else {
                            d3.select(this).select('svg').select('#descendingIconIDForTrafficLightsChart').style("visibility", "visible")
                            d3.select(this).select('svg').select('#ascendingIconIDForTrafficLightsChart').style("visibility", "visible")
                        }
                    }
                })
             
              var monthTruOrFalAryForTrafficLightsChart = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
              
              tr.sort(function(a, b) {
                      
                      if (sortOrder) {
                      var monthsArrayForTrafficLightsChart = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                      } else {
                      var monthsArrayForTrafficLightsChart = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                      }
                      
                      monthTruOrFalAryForTrafficLightsChart = []; gotMonthArray = [];
                      tableDataForTrafficLightsChart.forEach(function(d,i){
                          var da = d[k].toString().substring(0,3).toLowerCase()
                          if(monthsArrayForTrafficLightsChart.indexOf(da) >= 0){
                              monthTruOrFalAryForTrafficLightsChart.push(true)
                              gotMonthArray.push(da);
                          }
                          else {
                              monthTruOrFalAryForTrafficLightsChart.push(false)
                          }
                      })
                      
                      if(monthTruOrFalAryForTrafficLightsChart.indexOf(false) == -1){ // true
                      
                      monthArray = []; monthArrayCount = [];
                      gotMonthArray.forEach(function(dd,j){
                            var index1 = monthsArrayForTrafficLightsChart.indexOf(dd.substring(0,3))
                            if(monthArrayCount.indexOf(index1) >= 0){
                                index1 = 12 + index1;
                            }
                            monthArray.push(index1);
                            monthArrayCount.push(index1)
                      })
                      returnArray = []
                      monthArray.sort(function(aa, bb) {
                          returnArray.push(+aa - +bb)
                          return +aa - +bb;
                      })
                      
                      sortTableFunc()
                      return returnArray[ind++];
                      } //  if true (if jan feb if block)
                      else {
                      var data = +a[k];
                      
                      if(!isNaN(data)){
                      
                      if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                      else { return d3.descending(+a[k], +b[k]); }
                      }
                      else if(!isNaN(Date.parse(a[k]))){
                      
                      if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                      else { return new Date(b[k]) - new Date(a[k]) }
                      }
                      else {
                      
                      if (sortOrder) { return d3.ascending(a[k], b[k]); }
                      else { return d3.descending(a[k], b[k]); }
                      }
                      } // if not jan feb else block
                      }); // tr
		})
        
        function sortTableFunc(){
            
            var table = tableDivForTrafficLightsChart.select('table');
            var rows = table.selectAll('tr').data(tableDataForTrafficLightsChart);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0).style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500)
            .style('opacity', 1.0).style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
        }
        
        // Main Table Styling
        tableDivForTrafficLightsChart.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
        .style("color","#00001c")
        .style("height","25px").style("border", "1px solid #dddddd").style("background-color","#f4f4f4") //.style("box-shadow","10px 10px 50px #007aff").style("z-index",9999)
        tableDivForTrafficLightsChart.selectAll('td').style("height","25px") .style("border", "1px solid #ffffff") .style("font-size","12px").style("font-weight","Normal") .style("color","#00001c")

        //additionally 
        tableDivForTrafficLightsChart.selectAll('th').style('background-color',"#ffffff").style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
        tableDivForTrafficLightsChart.selectAll('td').style("border-style","none").style("color","#00001c")
        //tablePanelForPieChart.selectAll('td').style("height","25px") .style("border", "1px solid #fcfcfc") .style("font-size","12px").style("font-weight","Normal")

        //b1da9f
        tableDivForTrafficLightsChart.selectAll('table') . style("border-collapse","collapse")
        tableDivForTrafficLightsChart.selectAll('table tr:first-child th').style("border-top","0px")
        tableDivForTrafficLightsChart.selectAll('table tr:last-child td').style("border-bottom","0px")
        tableDivForTrafficLightsChart.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
        tableDivForTrafficLightsChart.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")

        if(showOrHideTableForTrafficLightsChart == false){
            tableDivForTrafficLightsChart.style("display","none")
        }
        else if(showOrHideTableForTrafficLightsChart == true){
            tableDivForTrafficLightsChart.style("display","block")
        }
        
        
        if(options.isDataDetailedForTable == false){
        
            var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
        
            // Adding underlines for selected drill-down column text
            var drillDownSectionsForTrafficLightsChart = tableDivForTrafficLightsChart.select('table').selectAll('th')
        
            var foundResult = [];
            for(var i = 0; i<drillDownSectionsForTrafficLightsChart[0].length; i++){
                for(var j = 0; j<drillDownColumnNamesArray.length; j++){
                    if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForTrafficLightsChart[0][i].__data__.toString().toLowerCase() ){
                        foundResult.push(i)
                    }
                }
            }
        
            var r = tableDivForTrafficLightsChart.select('table').selectAll('tr').selectAll('td')
            for(var i = 0; i<r.length; i++){
                for(var j = 0; j < foundResult.length; j++){
                    var row = r[i][foundResult[j]]
                    $(row).css("text-decoration", "underline")
                }
            }
        }
        
        //By default calling the resized function first time (to align table's th and td).
        resizedFuctionForTrafficLightsChart()
		
        window.addEventListener('resize', function(event){ resizedFuctionForTrafficLightsChart() });
        
        $(function() {
          
          $("#" + targetElement[0][0].id).resizable({
                resize: function(event, ui) {
                    resizedFuctionForTrafficLightsChart();
                }
             });
          });
        
        function resizedFuctionForTrafficLightsChart()
        {
            
            if((svgPanelForTrafficLightsChart.node().getBoundingClientRect().width) && (svgPanelForTrafficLightsChart.node().getBoundingClientRect().height) > 0){
				
				if(showOrHideCommentsBtnForTrafficLightsChart == true){
					commentsBtnForTrafficLightsChart.style('margin-left', "2px")
                    menuBtnForTrafficLightsChart.style('right', '0')
                }
                else if(showOrHideCommentsBtnForTrafficLightsChart == false){
                    //commentsBtnForTrafficLightsChart.style('right', '0')
                    commentsBtnForTrafficLightsChart.style('display','none')
                    menuBtnForTrafficLightsChart.style('right', '0')
                }

                optionsBtnPanelForTrafficLightsChart.style('right', '0')

				var diameterWidthNew = document.getElementById("svgPanelIDForTrafficLightsChart" + targetElement[0][0].id).getBoundingClientRect().width//svgPanelForTrafficLightsChart[0][0].clientWidth;
                var diameterHeightNew = document.getElementById("svgPanelIDForTrafficLightsChart" + targetElement[0][0].id).getBoundingClientRect().height//svgPanelForTrafficLightsChart[0][0].clientHeight;
				
				// var diameterWidthNew = ($('#svgPanelIDForTrafficLightsChart' + targetElement[0][0].id)[0].getBoundingClientRect().width)
                // var diameterHeightNew = ($('#svgPanelIDForTrafficLightsChart' + targetElement[0][0].id)[0].getBoundingClientRect().height)
				
                var bubbleLayoutNew = d3.layout.pack() .sort(null) .size([(diameterWidthNew),(diameterHeightNew)]) .padding(1.5);
				
                //var trafficLightsChartSVG = svgPanelForTrafficLightsChart.append("svg")//.style("background","#606060")
                trafficLightsChartSVG .attr("width" , diameterWidthNew) .attr("height", diameterHeightNew)

                var filteredArrayNew = [];
                newJson.forEach(function(d,i){ 
					var temp = {};
					temp[options.keys.label] = d[options.keys.label]
					temp["value"] = circlesStaticValueArr[i];
					temp["circlesLabel"] = d["Label"]
					filteredArrayNew.push(temp)
				})

                var selectionNew = trafficLightsChartSVG.selectAll("g.node")
                .data(bubbleLayoutNew.nodes({children: filteredArrayNew}).filter(function(d) { return !d.children; }) ); 

                //node .attr("transform", function(d) { return "translate(" + d.x + ", " + d.y + ")"; }).filter(function(d){ return d.value > 0;})
                //.select("circle") .attr("r", function(d) { return d.r; })
				
				//var circlesLeftMargin = parseFloat(ligthsBackgroundDiv.style("left")) + (parseFloat(ligthsBackgroundDiv.style("width"))/2)
				
				var circlesLeftMargin = parseFloat(ligthsBackgroundDiv.style("left")) 
				var marginYArr = [(diameterHeightNew/4.95),(diameterHeightNew/1.98),(diameterHeightNew/1.239)] // 60 150 240 
				var blackBackgroundWidth = 0;
				
                node .attr("transform", function(d,i) { return "translate(" + (circlesLeftMargin + d.r) + ", " + marginYArr[i] + ")"; }).filter( function(d,i){if(d.value == 0){ d.value = 0.000000000000001;
                d3.select(selection[0][i]).style("display","none"); }; return d.value > 0; }).select("circle") .attr("r", function(d) {blackBackgroundWidth = d.r; return d.r/1.8; })
				
				node.selectAll("text").attr("x",(blackBackgroundWidth + 10) + "px")
				
				ligthsBackgroundDiv.style("width",(blackBackgroundWidth * 1.98) + "px")
				
				colWidth = []; 
				
                d3.select(".theadClassForTrafficLightsChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                    d.forEach(function(dd,j){
                            colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                    })
                })
                tableDivForTrafficLightsChart.select(".thead1ClassForTrafficLightsChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                    d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
                })

            }// checking svg panel width & height greater that zero function

        }

    }, //TrafficLightsChart
    
	// ***************************************** Column Chart With Negative Values  *******************************************
    columnChartWithNegativeValues: function(targetElement, options){

        isChartCalled++;
        var chartName = "COLUMNCHARTWITHNEGATIVEVALUES";
        
        acinfotech.allCharts(targetElement,options,chartName);
        
        var newJson = [];
        options.data.forEach(function(d, i) {
            var temp = {};
            
            for(var i = 0; i < Object.keys(d).length; i++) {
                delete d['enabled'];
                temp[Object.keys(d)[i]] = d[Object.keys(d)[i]]
            }
            
            newJson.push(temp)
        });
	
		var isThereNegativeValue = false;
		options.data.forEach(function(d, i) {
            if(+d[options.keys.value] < 0){
				isThereNegativeValue = true;
			}
        })
	
        targetElement.style("min-width", "350px").style("min-height", "350px").style("background-color", options.BGcolor)

        var showOrHideTableForColChartWithNegVals;
        var showOrHideCommentsForColChartWithNegVals;
        var showOrHideCommentsBtnForColChartWithNegVals = true;

        // Show or Hide Table
        if((options.showTable == false) || (options.showTable == true)){
            showOrHideTableForColChartWithNegVals = options.showTable    
        }
        else{
            showOrHideTableForColChartWithNegVals = false;
        }
        
        // Show or Hide comments
        if (options.showComments == true || false) {
            showOrHideCommentsForColChartWithNegVals = options.showComments;
        }
        else {
            showOrHideCommentsForColChartWithNegVals = false;
        }
        
        if (options.comments.length == 0){ // checking whether there is a comment or not
            showOrHideCommentsForColChartWithNegVals = false;
            showOrHideCommentsBtnForColChartWithNegVals = false;
        }

        if ((showOrHideTableForColChartWithNegVals == true) && (showOrHideCommentsForColChartWithNegVals == true)){
            showOrHideTableForColChartWithNegVals = true;
            showOrHideCommentsForColChartWithNegVals = false;
        }
        else if ((showOrHideTableForColChartWithNegVals == false) && (showOrHideCommentsForColChartWithNegVals == false)){
            showOrHideTableForColChartWithNegVals = false;
            showOrHideCommentsForColChartWithNegVals = false;
        }

        var divWidth, divHeight;
        
        var chartTitlePanelForColChartWithNegVals =  targetElement.append("div").style('position',"absolute") .style("background-color", options.BGcolor) .style("text-indent","6px") .style("border", "none")
        
		var optionsButtonPanelForColChartWithNegVals = targetElement.append('div').style('width',"25px").style('height',"80px").style('position','absolute')
        .style("background-color",'#ffffff').style("z-index",2).style("display","none").style('top',"25px")
        .style('right', '0').style("min-width","25px")
        .style("border-style","none").style("border-left", "solid #fcfcfc  1px")//.style("top",71.5 + "px")
		
        var commentsBtnForColChartWithNegVals = optionsButtonPanelForColChartWithNegVals.append("div") .style("width","20px").style("height","20px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','55px') .style("cursor","pointer").style("display","block") 
        .style('padding',"0px") .style("border", "0px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var commentsBtnImgVariable = document.createElement("IMG");
        if(options.showComments == false){
            commentsBtnImgVariable.src = "images/showCommentsIcon.png";
        }
        else if(options.showComments == true){
            commentsBtnImgVariable.src = "images/hideCommentsIcon.png";
        }
        commentsBtnImgVariable.setAttribute("style","position:absolute; left:1px; top:1px; width:17px; height:17px; opacity:0.8;")
        commentsBtnForColChartWithNegVals[0][0].appendChild(commentsBtnImgVariable)

        var menuButtonForColChartWithNegVals = targetElement.append("div") .style("width","27px").style("height","22px").style('position','absolute')
        .style('background-color',"#ffffff").style("z-index",10)
        .style('top','1px') .style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var menuBtnImgVar = document.createElement("IMG");
        menuBtnImgVar.src = "images/menuIcon.png";
        menuBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.85;")
        menuButtonForColChartWithNegVals[0][0].appendChild(menuBtnImgVar)
        
        if(showOrHideCommentsBtnForColChartWithNegVals == true){
			commentsBtnForColChartWithNegVals.style('margin-left', "2px")
            menuButtonForColChartWithNegVals.style('right', '0')
        }
        else if(showOrHideCommentsBtnForColChartWithNegVals == false){
            //commentsBtnForColChartWithNegVals.style('right', '0')
            commentsBtnForColChartWithNegVals.style('display','none')
            menuButtonForColChartWithNegVals.style('right', '0')
        }

        var ismenuButtonOfColChartWithNegValsClicked = false; // Menu toggle button variable
        menuButtonForColChartWithNegVals.on('click', function() {
            if(ismenuButtonOfColChartWithNegValsClicked == false){ // Checking if menu button is clicked
                ismenuButtonOfColChartWithNegValsClicked = true; // Menu toggle button variable
                optionsButtonPanelForColChartWithNegVals.style("display","block") // Showing option buttons menu panel

				//settingPanelDivForColChartWithNegVals.style("display","none") // Hiding setting panel

            if(options.showTitle == true){
            
                if ((showOrHideTableForColChartWithNegVals == false) && (showOrHideCommentsForColChartWithNegVals == true)){
                    
                    svgPanelForColChartWithNegVals.style('width', 100 + "%") .style('height', 70 + "%").style("position","absolute"); 
                }
                else if ((showOrHideTableForColChartWithNegVals == true) && (showOrHideCommentsForColChartWithNegVals == false)){
                    
                    svgPanelForColChartWithNegVals.style('width', 100 + "%") .style('height', 52 + "%") .style("position","absolute");
                }
                else if ((showOrHideTableForColChartWithNegVals == false) && (showOrHideCommentsForColChartWithNegVals == false)){
                     
                    svgPanelForColChartWithNegVals.style('width', 100 + "%") .style('height', 85 + "%").style("position","absolute"); 
                }

            }
            else if(options.showTitle == false){
           
                if ((showOrHideTableForColChartWithNegVals == false) && (showOrHideCommentsForColChartWithNegVals == true)){
                    
                    svgPanelForColChartWithNegVals.style('width', 100 + "%") .style('height', 70 + "%").style("position","absolute"); 
                }
                else if ((showOrHideTableForColChartWithNegVals == true) && (showOrHideCommentsForColChartWithNegVals == false)){
                    
                    svgPanelForColChartWithNegVals.style('width', 100 + "%") .style('height', 52 + "%").style("position","absolute"); 
                }
                else if ((showOrHideTableForColChartWithNegVals == false) && (showOrHideCommentsForColChartWithNegVals == false)){
                     
                    svgPanelForColChartWithNegVals.style('width', 100 + "%") .style('height', 85 + "%").style("position","absolute"); 
                }
            }
        

                resizedFuctionForColChartWithNegVals(); // Calling resize function
            }
            else if(ismenuButtonOfColChartWithNegValsClicked == true){ // Checking if menu button is clicked
                ismenuButtonOfColChartWithNegValsClicked = false
                optionsButtonPanelForColChartWithNegVals.style("display","none") // Hiding option buttons panel 
            }
        })
        
        var svgPanelForColChartWithNegVals = targetElement .append('svg') 
        .attr("id","svgPanelIDForColChartWithNegVals" + targetElement[0][0].id) .style("background-color", options.BGcolor) .style("position","absolute")
        
        var commentsPanelDivForColChartWithNegVals = targetElement.append("div") .attr("class","commentsPanelClassForCwNPieChart") 
        .style('background-color',"#ffffff") .style('position',"absolute").style("text-indent","8px")
		.style("border-top","1px solid #f6f6f6").style("border-bottom","1px solid #eaeaea")
        .style('box-sizing','border-box').attr('contenteditable',false).style('outline-width',0)

        commentsPanelDivForColChartWithNegVals.on('click',function(d){
            $('.commentsClassForColChartWithNegVals' + targetElement[0][0].id).focus()
        })

        if(options.showTitle == true){ 
            
            chartTitlePanelForColChartWithNegVals.style("width", function(d) {  return 100.00 + "%"; }) .style("height", function(d) { return 8 + "%"; })
            .html('<div style="width: 100%; height:0%; background-color:#ffffff; position: absolute; top:10.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>') //color 325922

            if ((showOrHideTableForColChartWithNegVals == false) && (showOrHideCommentsForColChartWithNegVals == true)){

                var commentsForColChartWithNegVals = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify').attr('class','commentsClassForColChartWithNegVals' + targetElement[0][0].id)

                   svgPanelForColChartWithNegVals.attr('width', 100 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .append('g')
                   commentsPanelDivForColChartWithNegVals.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForColChartWithNegVals[0].outerHTML.toString())

            }
            else if ((showOrHideTableForColChartWithNegVals == true) && (showOrHideCommentsForColChartWithNegVals == false)){

                    svgPanelForColChartWithNegVals.attr('width', 100 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .append('g')
                    commentsPanelDivForColChartWithNegVals.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForColChartWithNegVals == false) && (showOrHideCommentsForColChartWithNegVals == false)){
                    svgPanelForColChartWithNegVals.attr('width', 100 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .append('g')
                    commentsPanelDivForColChartWithNegVals.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }

			if(isThereNegativeValue == true){
				var margin = {top: 30 , right: 40, bottom: 100, left: 40}, //originally top: 42, left: 80
				width = (svgPanelForColChartWithNegVals.node().getBoundingClientRect().width) - margin.left - margin.right,
				height = svgPanelForColChartWithNegVals.node().getBoundingClientRect().height - margin.top - margin.bottom;
			}
			else {
				var margin = {top: 30 , right: 40, bottom: 80, left: 40}, //originally top: 42, left: 80
				width = (svgPanelForColChartWithNegVals.node().getBoundingClientRect().width) - margin.left - margin.right,
				height = svgPanelForColChartWithNegVals.node().getBoundingClientRect().height - margin.top - margin.bottom;
			}
			
        }
        else if(options.showTitle == false){

            chartTitlePanelForColChartWithNegVals.style("width", function(d) {  return 0.00 + "%"; }) .style("height", function(d) { return 0 + "%"; });
            
            if ((showOrHideTableForColChartWithNegVals == false) && (showOrHideCommentsForColChartWithNegVals == true)){

                var commentsForColChartWithNegVals = $(options.comments).css('overflow-x','hidden').css('overflow-y','hidden').css('max-height','100%')
                   .attr('contenteditable',true).css('outline-width',0).css('margin-top','0px').css('display','inline-block')
                   .css('text-indent','0px').css('padding-right','15px').css('padding-top','3px').css('padding-bottom','5px').css('box-sizing','border-box')
                   .css('line-height','1.1em').css('text-align','justify')

                   svgPanelForColChartWithNegVals.attr('width', 100 + "%") .attr('height', 70 + "%") .style("top",8 + "%") .append('g')
                   commentsPanelDivForColChartWithNegVals.style("width", function(d) {  return 100.0 + "%"; }) .style("height", function(d) { return 22 + "%"; })
                   .style("top",78 + "%")
                   .html(commentsForColChartWithNegVals[0].outerHTML.toString())

            }
            else if ((showOrHideTableForColChartWithNegVals == true) && (showOrHideCommentsForColChartWithNegVals == false)){

                    svgPanelForColChartWithNegVals.attr('width', 100 + "%") .attr('height', 52 + "%") .style("top",8 + "%") .append('g')
                    commentsPanelDivForColChartWithNegVals.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
            else if ((showOrHideTableForColChartWithNegVals == false) && (showOrHideCommentsForColChartWithNegVals == false)){
                    svgPanelForColChartWithNegVals.attr('width', 100 + "%") .attr('height', 85 + "%") .style("top",8 + "%") .append('g')
                    commentsPanelDivForColChartWithNegVals.style("width", function(d) {  return 0 + "%"; }) .style("height", function(d) { return 0 + "%"; }) .style("display","none")
            }
			
			if(isThereNegativeValue == true){
				var margin = {top: 30 , right: 40, bottom: 100, left: 40}, //originally top: 42, left: 80
				width = (svgPanelForColChartWithNegVals.node().getBoundingClientRect().width) - margin.left - margin.right,
				height = svgPanelForColChartWithNegVals.node().getBoundingClientRect().height - margin.top - margin.bottom;
			}
			else {
				var margin = {top: 30 , right: 40, bottom: 80, left: 40}, //originally top: 42, left: 80
				width = (svgPanelForColChartWithNegVals.node().getBoundingClientRect().width) - margin.left - margin.right,
				height = svgPanelForColChartWithNegVals.node().getBoundingClientRect().height - margin.top - margin.bottom;
			}
		}
			
        var colors;
        // checking color set for bars
        if(options.colorSet === undefined){
            options.colorSet = "one"
            colors = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "one"){
            options.colorSet = "one"
            colors = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "two"){
            options.colorSet = "two"
            colors =  d3.scale.ordinal() .range(["#E95044","#F28A4C","#F0D444","#A2DF9C","#93DBE4","#B091D8","#DD1D24","#E35724","#EFE60C","#39A654","#0C9FDC","#812888"]);
        }
        else if(options.colorSet.toString().toLowerCase() === "three"){
            options.colorSet = "three"
            colors = d3.scale.ordinal() .range(["#01204F","#006A8D","#03848C","#64A79D","#E9CFA1","#F2A465","#EF6727","#F03113","#E6DCAB","#E6DCAB","#DDBD36","#926A00"]);
        }
        else
        {
            options.colorSet = "one"
            colors = d3.scale.ordinal() .range(["#00A9E9" ,"#BC851C" ,"#004990" ,"#87189D" ,"#C5003E" ,"#28724F" ,"#92C1E9" ,"#CEB888" ,"678787" ,"#B884CB" ,"#EF6079" ,"#85B09A"]);
        }

		var jsonData = options.data
        var valueArray = [];
        var labelArray = [];
        
        options.data.forEach(function(d, i) {
            d[options.keys.value] = d[options.keys.value];
            valueArray.push(d[options.keys.value])
            labelArray.push(d[options.keys.label])
        })
        
        var tip = d3.tip() .attr('class', 'd3-tip') .offset([-10, 0]) .style("font-family","Verdana,sans-serif").style("padding","4px").style("text-transform","capitalize")
		.style("font-weight","Bold").style("font-size","12px").style("color","#00001c").style("z-index",1000)
        .html(function(d, i) {
            var valueForColChartToolTip;
            if(valueArray[i].toString().indexOf('.') === -1)
            {
                valueForColChartToolTip = valueArray[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			}
            else{
                        
                valueForColChartToolTip = valueArray[i];
            }
              return options.keys.label + " : " + labelArray[i] + "<br>" + '<hr style="height:2px; width:100%px; margin:2px; border:none;color:#333;background-color:#E0E0E0;" />'+ options.keys.value +" : " + valueForColChartToolTip }); //valueArray[i] ; });
        
        var minAndMaxValuesArrayForColChartWithNegVals = []
            newJson.forEach(function(d, i) {
                var dd = parseFloat(d[options.keys.value])
                minAndMaxValuesArrayForColChartWithNegVals.push(dd) 
            });
        
        var low = d3.min(minAndMaxValuesArrayForColChartWithNegVals);
        var hig = d3.max(minAndMaxValuesArrayForColChartWithNegVals);
        
        var tableButtonForColChartWithNegVals = optionsButtonPanelForColChartWithNegVals.append("div").style("width","20px").style("height","22px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top','1px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none").attr("class","hideTableClassForChartTable")
        var tableBtnImgVar = document.createElement("IMG");
        if(showOrHideTableForColChartWithNegVals == false){
            tableBtnImgVar.src = "images/showTableIcon.png";
            tableButtonForColChartWithNegVals.attr("class","showTableClassForChartTable")
        }
        else if(showOrHideTableForColChartWithNegVals == true){
            tableBtnImgVar.src = "images/cancelTableIcon.png";
            tableButtonForColChartWithNegVals.attr("class","hideTableClassForChartTable")
        }
        tableBtnImgVar.setAttribute("style","position:absolute; left:1px; top:1px; width:18px; height:20px; opacity:0.68;")
        tableButtonForColChartWithNegVals[0][0].appendChild(tableBtnImgVar)

        var downloadBtnForColChart = optionsButtonPanelForColChartWithNegVals.append("div").attr("id","downloadBtnForColChartWithNegVals-ID-" + targetElement[0][0].id).style("width","20px").style("height","20px")
        .style('position','absolute').style('padding',"0px").style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#fdfdfd").style('margin-left','2px').style('top','27px')
        .style("cursor","pointer").style("display","block").style("box-shadow", "0px 0px 0px #B8B8B8") .style("border-style", "none")
        
        acinfotech.downloadFunctionality("downloadBtnForColChartWithNegVals-ID-" + targetElement[0][0].id,targetElement)
        
        tableButtonForColChartWithNegVals.on('click', function() {
            
            if(options.showTable == false){ // Checking if table is shown or hidden
                options.showTable = true;
            }
            else if(options.showTable == true){ // Checking if table is shown or hidden
                options.showTable = false;
            }

            isFilterClickedForColChartWithNegVals = false; 
            
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){
                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                    options.showComments = false;
                }
            }
            acinfotech.columnChartWithNegativeValues(targetElement,options)

        })

        // showing/hidding chart comment panel
        commentsBtnForColChartWithNegVals.on('click', function() {

            if(options.showComments == false){ 
                options.showComments = true;
            }
            else if(options.showComments == true){ 
                options.showComments = false;
            }

            isFilterClickedForColChartWithNegVals = false; 
            
            d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){
                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                    options.showTable = false;
                }
            }
            acinfotech.columnChartWithNegativeValues(targetElement,options)

        })
        
        downloadBtnForColChart.on('click', function() {
                                  
			ismenuButtonOfColChartWithNegValsClicked = false; // Changing menu button value to false
			optionsButtonPanelForColChartWithNegVals.style("display","none") // Hiding option buttons panel

			iconButtonTooltip.style("display","none") // Hiding button tooltip
              
			//settingPanelDivForColChartWithNegVals.style("display","none") //Hiding setting panel
                                  
            //downloadOptionsPanelDiv.style("display","block")
                                  
        })
        
        // Creating icon tool tip
        var iconButtonTooltip = targetElement.append('div').style('width','240px') .style('height',"25px").style('position','absolute')
        .style("background-color",'#404040 ') .style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") 
        .style("border-style", "solid") .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none")
		
		tableButtonForColChartWithNegVals.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                if(showOrHideTableForColChartWithNegVals == false){
                    var tableButtonTooltipText = "Show Table";
                }
                else if(showOrHideTableForColChartWithNegVals == true){
                    var tableButtonTooltipText = "Hide Table";
                }
            
            
            iconButtonTooltip.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ tableButtonTooltipText +'</div>')
        })
        tableButtonForColChartWithNegVals.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })
		
        downloadBtnForColChart.on('mousemove', function(d,i) {
			var root = targetElement
			var m = d3.mouse(root.node());
			m[0] += 0
			m[1] += 0
			var downloadButtonTooltipText = "Download";

			iconButtonTooltip.style("width","74px").style("margin-left", (m[0] - 84) + "px").style("margin-top",(m[1]) + "px").style("display","block")
			iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ downloadButtonTooltipText +'</div>')
        })
        downloadBtnForColChart.on('mouseout', function(d,i) {
			iconButtonTooltip.style("display","none")
        })
        
        commentsBtnForColChartWithNegVals.on('mousemove', function(d,i) {
            commentsPanelDivForColChartWithNegVals.style('background-color','#fafafa')
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                if(options.showComments == false){
                    var commentButtonTooltipText = "Show Comments";
                }
                else if(options.showComments == true){
                    var commentButtonTooltipText = "Hide Comments";
                }
            
            iconButtonTooltip.style("width","109px").style("margin-left", (m[0] - 119) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ commentButtonTooltipText +'</div>')
        })
        commentsBtnForColChartWithNegVals.on('mouseout', function(d,i) {
            commentsPanelDivForColChartWithNegVals.style('background-color','#ffffff')
            iconButtonTooltip.style("display","none")
        })

        menuButtonForColChartWithNegVals.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var reloadButtonTooltipText = "Menu";
            
            iconButtonTooltip.style("width","58px").style("margin-left", (m[0] - 68) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ reloadButtonTooltipText +'</div>')
        })
        menuButtonForColChartWithNegVals.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })

		// Creating SVG panel to hold columns
        var svg = svgPanelForColChartWithNegVals .append("svg") .style("background-color", options.BGcolor) .style("border-radius","0px")
        .style("border-width","1px") .style("border-color","#d4d4d4") .style("border-style","solid") .append("g") .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
        
        svg.call(tip);
        
		//----------------------------------
		var yAxisVariable = svg.append("text") .attr("transform", "rotate(-90)") .attr("y", -25) .attr("x",0 - (height / 2)) .attr("dy", "1em") .style("text-anchor", "middle")
        .style("font-family","Verdana,sans-serif") .style("font-weight","Bold") .style("font-size","12px") .text(options.yAxisLable) .style('fill','#00001c') .style("text-transform","capitalize")
        .style("font-style","normal")        
        
        var x1 = d3.scale.ordinal() .domain(options.data.map(function(d) { return d[options.keys.label]; })) .rangeRoundBands([0, width], 0.25);
        
        var xAxis = d3.svg.axis() .scale(x1) .orient("bottom")
        
        // Adding the X Axis
        svg.append("g").attr("class", "x axis").attr("transform", "translate(0," + (svgPanelForColChartWithNegVals.node().getBoundingClientRect().height - 110) + ")") .call(xAxis)
        
        // Adding the X Axis margin labels
        .selectAll("text") .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') .attr("transform", function(d) { return "rotate(0)" })
        .style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
        .text(function(d,i) {
            if(d.length > 9)
                return d.substring(0,9)+'...';
            else
                return d;
        })
		
		// Adding the text label for the X axis
        var xAxisVariable =  svg.append("text") .attr("transform", "translate(" + ((width/2)) + " ," + (height+margin.bottom - 2) + ")")
        .style("text-anchor", "middle") .style("font-family","Verdana,sans-serif") .style("font-weight","Bold") .style("font-size","12px") .text(options.xAxisLable) .style('fill','#00001c') 
        .style("text-transform","capitalize") .style("font-style","normal")
		
		//---------------------------------
		
		var dataArrayForMaxValue = [];
		options.data.forEach(function(d, i) {
            dataArrayForMaxValue.push(+d[options.keys.value]);
		})
		
		if(isThereNegativeValue == true){
			
			var y0 = Math.max(Math.abs(d3.min(dataArrayForMaxValue)), Math.abs(d3.max(dataArrayForMaxValue)));
			
			var y = d3.scale.linear().domain([-y0, y0]).range([height,0]).nice();

			//var x = d3.scale.ordinal().domain(d3.range(options.data.length)).rangeRoundBands([0, width], .2);
			var x = d3.scale.ordinal() .domain(d3.range(options.data.map(function(d) { return +d[options.keys.value]; }).length)) .rangeRoundBands([0, width], 0.25);
		
			//var yScale = d3.scale.linear() .domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.value]; }), function(d) { return d; })]) .range([0, height]);
		
			var yAxis = d3.svg.axis().scale(y).orient("left");

			//Creating bars
			/*var verticalBars = svg.selectAll(".bar").data(options.data.map(function(d) { return +d[options.keys.value]; }))
			.enter().append("rect").attr("class", "bar").attr("x", function(d, i) { return x(i); }).attr("y", function(d) { return y(Math.max(0, d)); })
			.attr("width", x.rangeBand()).attr("height", function(d) { return Math.abs(y(d) - y(0)); })
			.style("fill", function(d,i) { return d > 0 ? colors(i) : "#d4343f"; }).style("cursor","default").on('mouseover',tip.show)
			.on('mouseout', tip.hide);*/

			var verticalBars = svg.selectAll(".bar").data(options.data.map(function(d) { return +d[options.keys.value]; }))
			.enter().append("rect").attr("class", "bar").style("fill", function(d,i) { return d > 0 ? colors(i) : "#d4343f"; })
			.style("cursor","default").on('mouseover',tip.show).on('mouseout', tip.hide);
			
			verticalBars.attr("x", function (d,i) {  return x(i);  }).attr("width", x.rangeBand())
			.attr("y", function (d) { return y(0); })
			.attr("height", function (d) { return 0; })
			.transition() .delay(400) .duration(800)
			.attr("y", function(d) { return y(Math.max(0, d)); })
			.attr("height", function(d) { return Math.abs(y(d) - y(0)); })
			
			svg.append("g").attr("class", "x axis")//.call(yAxis);

			var zeroValueLine = svg.append("g").append("line").attr("class", "line").style("stroke",function(d,i){  return "#000000"; }).style("stroke-width","0.03em")
			.attr("y1", y(0)).attr("y2", y(0)).attr("x1", 0).attr("x2", width);
			
			var yTextPadding = -3;
			var format = d3.format(".2s")
			var textOnBarsForColChartWithNegVals = svg.selectAll(".bartext") .data(options.data.map(function(d) { return +d[options.keys.value]; }))
			.enter() .append("text") .attr("class", "bartext") .style("text-anchor", "middle") .style("fill", "#00001c") .style("font-weight","Normal")
			.style("font-size","12px") .style("font-family","Verdana,sans-serif") .style("position","absolute").attr("class","series_value").style("display",options.series)
			textOnBarsForColChartWithNegVals.attr("x", function(d,i) { return x(i) + x.rangeBand()/2; })
			.attr("y", function (d) { return y(0); })
			.transition().delay(400).duration(800)
			.attr("y", function(d) { return d > 0 ? y(d) - 3 : y(d) + 13; })
			.text(function(d){ 
				if(d.toString().indexOf('.') === -1)
				{
					return d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				}
				else{
							
					return d;
				}
			})
		}
		else {
			
			var x = d3.scale.linear() .domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.value]; }))]) .range([0, width]);
        
			var y = d3.scale.linear() .domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.value]; }))]) .range([height, 0]);
			
			var yAxis = d3.svg.axis() .scale(y) .orient("left") .ticks(5);
			
			var xScale = d3.scale.ordinal() .domain(d3.range(options.data.map(function(d) { return +d[options.keys.value]; }).length)) .rangeRoundBands([0, width], 0.25);
        
			var yScale = d3.scale.linear() .domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.value]; }), function(d) { return d; })]) .range([0, height]);
			
			//Creating bars
			var verticalBars = svg.selectAll(".bar") .data(options.data.map(function(d) { return +d[options.keys.value]; })) .enter() .append("rect") .attr("class", "bar") 
			.style("fill",function(d,i){ return  colors(i) }).style("cursor","default").on('mouseover',tip.show).on('mouseout', tip.hide)
			
			//verticalBars.transition() .delay(function (d, i) { return i / valueArray.length * 750; }) .duration(500) .attr("x", function (d,i) {  return xScale(i);  }) .attr("y", function (d) { return height - yScale(d); }) .attr("width", xScale.rangeBand())  .attr("height", function (d) { return yScale(d); });
			
			verticalBars.attr("x", function (d,i) {  return xScale(i);  }).attr("width", xScale.rangeBand())
			.attr("y", function (d) { return height; })
			.attr("height", function (d) { return 0; })
			.transition() .delay(400) .duration(800)
			.attr("y", function (d) { return height - yScale(d); })
			.attr("height", function (d) { return yScale(d); })

			var yTextPadding = -3;
			var format = d3.format(".2s")
			var textOnBarsForColumnChart = svg.selectAll(".bartext") .data(options.data.map(function(d) { return +d[options.keys.value]; }))
			.enter() .append("text") .attr("class", "bartext") .style("text-anchor", "middle") .style("fill", "#00001c") .style("font-weight","Normal")
			.style("font-size","12px") .style("font-family","Verdana,sans-serif") .style("position","absolute").attr("class","series_value").style("display",options.series)
			textOnBarsForColumnChart.attr("x", function(d,i) { return xScale(i)+xScale.rangeBand()/2; })
			.attr("y", function (d) { return y(0); })
			.transition() .delay(400) .duration(800)
			.attr("y", function (d) { return height - yScale(d)+yTextPadding; })
			.text(function(d){ 
				if(d.toString().indexOf('.') === -1)
				{
					return d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				}
				else{
							
					return d;
				}
			})
			
		} // else block 
		
		var newArrForDrillDownCol = []
        var columnNames = d3.keys(newJson[0])
        var drillDownColumnNamesInArray = options.drillDownColumnName.split(",")
        
        for(var i = 0; i < columnNames.length ; i++){
            for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                    
                    for(var k = 0; k < verticalBars[0].length; k++){
                        d3.select(verticalBars[0][k]).attr('data-drilldownkey', function(d,index){
                           var arr = JSON.stringify(newJson[k]).slice(1, -1).split('"'), arr1 = d3.select(arr)[0]
                           
                           for(var j = 0; j < arr1[0].length; j++){
                               if(arr1[0][j].toString() == ":"){
                                   var ch = arr1[0][j].toString().replace(":","|")
                                     newArrForDrillDownCol.push(ch)
                               }
                               else {
                                     newArrForDrillDownCol.push(arr1[0][j])
                               }
                           }
                           
                               //return JSON.stringify(newJson[k]).slice(1, -1).split('"').join("").split(':').join("|")
                               return newArrForDrillDownCol.join("");
                           })
                        newArrForDrillDownCol = [];
                    }
                }
                else {
                }
            }
        }

        svg.selectAll(".bar") .data(options.data.map(function(d) { return +d[options.keys.value]; })).on("click", function(d) {    
            selectedItem = d });
		
		var width1 = svgPanelForColChartWithNegVals[0][0].clientWidth;
        var height1 = svgPanelForColChartWithNegVals[0][0].clientHeight;

        var root = targetElement;
        var scr = { x: window.scrollX, y: window.scrollY, w: svgPanelForColChartWithNegVals[0][0].clientWidth, h: svgPanelForColChartWithNegVals[0][0].clientHeight };
        var body_sel = d3.select('body');
        var body = { w: body_sel.node().offsetWidth, h: body_sel.node().offsetHeight };
        var doc = { w: width, h: height };
        var svgpos = root.node().parentNode
        
        var dist = { x: 20, y: 20 };
        
        verticalBars.on("mousemove", function(d,i){
                        
            tip.style("display","block")
                        
            var m = d3.mouse(root.node());
            scr.x = window.scrollX;
            scr.y = window.scrollY;
            m[0] += 0
            m[1] += 0
            tip.style("right", "");
            tip.style("left", "");
            tip.style("bottom", "");
            tip.style("top", "");
            
            tip.style("border-color", d3.select(verticalBars[0][i]).style("fill"))
			
			if(d3.mouse(this)[0] < scr.w/2){
				
				tip.style("left", (d3.event.pageX + 12 )  + "px");
				tip.style("top", (d3.event.pageY - ( parseFloat(tip.style("height")) /2  ) )+ "px");
			}
			else if(d3.mouse(this)[0] > scr.w/2){
				
				tip.style("left", (d3.event.pageX) - (parseFloat(tip.style("width"), 10) + 20) + "px");
				tip.style("top", (d3.event.pageY - ( parseFloat(tip.style("height")) /2  ) ) + "px");
			}
			else if(d3.mouse(this)[0] == scr.w/2){
				
				tip.style("left", (d3.event.pageX) - (parseFloat(tip.style("width"), 10) + 20) + "px");
				tip.style("top", (d3.event.pageY - ( parseFloat(tip.style("height")) /2  ) ) + "px");
			}
        });
        
        
        //------------------------Creating table begins here----------------------

        var tablePanelForColChartWithNegVals =  targetElement.append("div") .attr("id",targetElement[0][0].id + "holderForColChartWithNegValsTableID")
        .attr("class","scrollingDivForTable-Class tableDivForColChartWithNegVals" + targetElement[0][0].id) .style('background-color',"#ffffff") .style('position','absolute')
        .style("display","block") .style("overflow","hidden") .style("width", function(d) {  return 100+ "%"; })
        .style("height", function(d) { return 40 + "%"; }) .style("left",0 + "%")//.style("border-right","1px solid #e2e2e2")
        //.style("border-bottom","1px solid #e2e2e2")
        
        $( '.tableDivForColChartWithNegVals' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
    
            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });

        if(options.showTitle == true ){
            tablePanelForColChartWithNegVals.style("top",60  + "%")
        }
        else if(options.showTitle == false  ){
            tablePanelForColChartWithNegVals.style("top",60  + "%")
            
        }
        tablePanelForColChartWithNegVals.html('<table class = "tableClassForColChartWithNegVals' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
                                      '<thead class = "theadClassForColChartWithNegVals' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForColChartWithNegVals' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
                                      '<tbody class = "tBodyClassForColChartWithNegVals' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
                                      '</table>'
                                      )
        
        tablePanelForColChartWithNegVals.select('table').attr('id',targetElement[0][0].id + 'tableID')

        // Show or Hide Table scroll bar when mouseover on widget
        targetElement.on('mouseover',function(){ tablePanelForColChartWithNegVals.style("overflow","auto") })
        targetElement.on('mouseout',function(d){ tablePanelForColChartWithNegVals.style("overflow","hidden") })
        
        var tableDataForColChartWithNegVals = [];
        if(options.dataForTable.length > 0){
            tableDataForColChartWithNegVals = options.dataForTable;
        }
        else {
            tableDataForColChartWithNegVals = newJson;
        }
        
        var thead = tablePanelForColChartWithNegVals.select("thead").selectAll("th") .data(d3.keys(tableDataForColChartWithNegVals[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff")//f4f4f4
        .style("position","relative")
        
        var thead1 = d3.select(".thead1ClassForColChartWithNegVals" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tableDataForColChartWithNegVals[0]))
        .enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
        
        var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff")//f4f4f4
        .style("position","relative")
        
        var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
        .attr("id", "ascendingIconIDForColChartWithNegVals") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
        
        var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
        .attr("id", "descendingIconIDForColChartWithNegVals") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
        
        var tr = tablePanelForColChartWithNegVals.select("tbody").selectAll("tr") .data(tableDataForColChartWithNegVals).enter().append("tr")
        .attr("id", function(d,i) { return "slice" + i })
        
        // cells
        var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d}) 
        .style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
        
        var $table = $('.tableClassForColChartWithNegVals' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
        
        d3.select(".theadClassForColChartWithNegVals" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
                d.forEach(function(dd,j){
                    colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
                })
        })
        
        
        $(".thead1ClassForColChartWithNegVals" + targetElement[0][0].id).insertAfter('.tBodyClassForColChartWithNegVals' + targetElement[0][0].id)
        
        $(".thead1ClassForColChartWithNegVals" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForColChartWithNegVals' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
        
        
        tablePanelForColChartWithNegVals.select(".theadClassForColChartWithNegVals" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
			d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
        })
        
        tablePanelForColChartWithNegVals.select(".thead1ClassForColChartWithNegVals" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
			d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
        })
        
        
        $('.tableDivForColChartWithNegVals' + targetElement[0][0].id).scroll(function () {
                                                                  
            $(".thead1ClassForColChartWithNegVals" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForColChartWithNegVals' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
                                                                  
        })
        
        
        var sortOrder = false;
        thead1.on("click",function(k, index){
                 
                 sortOrder = !sortOrder;
                 
                 tablePanelForColChartWithNegVals.select(".thead1ClassForColChartWithNegVals" + targetElement[0][0].id).selectAll("th").each( function(d, i){
                                                 
                        if (sortOrder) {
                                                 
                            if(i == index){
                                d3.select(this).select('svg').select('#descendingIconIDForColChartWithNegVals').style("visibility", "hidden")
                                d3.select(this).select('svg').select('#ascendingIconIDForColChartWithNegVals').style("visibility", "visible")
                            }
                            else {
                                d3.select(this).select('svg').select('#descendingIconIDForColChartWithNegVals').style("visibility", "visible")
                                d3.select(this).select('svg').select('#ascendingIconIDForColChartWithNegVals').style("visibility", "visible")
                            }
                        }
                        else{
                                                 
                            if(i == index){
                                d3.select(this).select('svg').select('#descendingIconIDForColChartWithNegVals').style("visibility", "visible")
                                d3.select(this).select('svg').select('#ascendingIconIDForColChartWithNegVals').style("visibility", "hidden")
                            }
                            else {
                                d3.select(this).select('svg').select('#descendingIconIDForColChartWithNegVals').style("visibility", "visible")
                                d3.select(this).select('svg').select('#ascendingIconIDForColChartWithNegVals').style("visibility", "visible")
                            }
                        }
                 })
                 
                  var monthTruOrFalAryForColChartWithNegVals = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];
                  
                  tr.sort(function(a, b) {
                          
                          if (sortOrder) {
                          var monthsArrayForColChartWithNegVals = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
                          } else {
                          var monthsArrayForColChartWithNegVals = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
                          }
                          
                          monthTruOrFalAryForColChartWithNegVals = []; gotMonthArray = [];
                          tableDataForColChartWithNegVals.forEach(function(d,i){
                               var da = d[k].toString().substring(0,3).toLowerCase()
                               if(monthsArrayForColChartWithNegVals.indexOf(da) >= 0){
                                   monthTruOrFalAryForColChartWithNegVals.push(true)
                                   gotMonthArray.push(da);
                               }
                               else {
                                   monthTruOrFalAryForColChartWithNegVals.push(false)
                               }
                           })
                          
                          if(monthTruOrFalAryForColChartWithNegVals.indexOf(false) == -1){ // true
                          
                          monthArray = []; monthArrayCount = [];
                          gotMonthArray.forEach(function(dd,j){
                                var index1 = monthsArrayForColChartWithNegVals.indexOf(dd.substring(0,3))
                                if(monthArrayCount.indexOf(index1) >= 0){
                                    index1 = 12 + index1;
                                }
                                monthArray.push(index1);
                                monthArrayCount.push(index1)
                            })
                          returnArray = []
                          monthArray.sort(function(aa, bb) {
                              returnArray.push(+aa - +bb)
                              return +aa - +bb;
                          })
                          
                          sortTableFunc()
                          return returnArray[ind++];
                          } //  if true (if jan feb if block)
                          else {
                          var data = +a[k];
                          
                          if(!isNaN(data)){
                          
                          if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
                          else { return d3.descending(+a[k], +b[k]); }
                          }
                          else if(!isNaN(Date.parse(a[k]))){
                          
                          if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
                          else { return new Date(b[k]) - new Date(a[k]) }
                          }
                          else {
                          
                          if (sortOrder) { return d3.ascending(a[k], b[k]); }
                          else { return d3.descending(a[k], b[k]); }
                          }
                          } // if not jan feb else block
                    }); // tr

        })
        
        function sortTableFunc(){
            
            var table = tablePanelForColChartWithNegVals.select('table');
            var rows = table.selectAll('tr').data(tableDataForColChartWithNegVals);
            var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
            cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0).style("color","#00001c");
            
            cells.text(function(d,i) {return d});
            
            // Cells exit selection
            cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();
            
            var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})
            
            cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500)
            .style('opacity', 1.0).style("color","#00001c");
            
            cells_in_new_rows.text(function(d,i) {return d});
            
            rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
        }
        
        tablePanelForColChartWithNegVals.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
        .style("color","#00001c")
        .style("height","25px").style("border", "1px solid #dddddd").style('background-color',"#ffffff") 
        tablePanelForColChartWithNegVals.selectAll('td').style("height","25px") .style("border", "1px solid #ffffff") .style("font-size","12px").style("font-weight","Normal").style("color","#00001c")
        

        //additionally 
        tablePanelForColChartWithNegVals.selectAll('th').style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
        tablePanelForColChartWithNegVals.selectAll('td').style("border-style","none").style("color","#00001c")

        tablePanelForColChartWithNegVals.selectAll('table') . style("border-collapse","collapse")
        tablePanelForColChartWithNegVals.selectAll('table tr:first-child th').style("border-top","0px")
        tablePanelForColChartWithNegVals.selectAll('table tr:last-child td').style("border-bottom","0px")
        tablePanelForColChartWithNegVals.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
        tablePanelForColChartWithNegVals.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")

        if(showOrHideTableForColChartWithNegVals == false){
            tablePanelForColChartWithNegVals.style("display","none")
        }
        else if(showOrHideTableForColChartWithNegVals == true){
            tablePanelForColChartWithNegVals.style("display","block")
        }
        
        if(options.isDataDetailedForTable == false){
        
            var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
        
            // Adding underlines for selected drill-down column text
            var drillDownSectionsForColChartWithNegVals = tablePanelForColChartWithNegVals.select('table').selectAll('th')
            var drillDownSectionsFor_ColChartWithNegVals = drillDownSectionsForColChartWithNegVals[0]
        
            var foundResult = [];
            for(var i = 0; i<drillDownSectionsForColChartWithNegVals[0].length; i++){
                for(var j = 0; j<drillDownColumnNamesArray.length; j++){
                    if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForColChartWithNegVals[0][i].__data__.toString().toLowerCase() ){
                        foundResult.push(i)
                    }
                }
            }
        
            var r = tablePanelForColChartWithNegVals.select('table').selectAll('tr').selectAll('td')
            for(var i = 0; i<r.length; i++){
                for(var j = 0; j < foundResult.length; j++){
                    var row = r[i][foundResult[j]]
                    $(row).css("text-decoration", "underline")
                }
            }
        }
        
        if(options.dataForTable.length == 0){
            
            // Scrolling table based on column click
            var selectedItem = "";
            verticalBars.on("click", function(d,i) {
                            
                tip.style("display","none");
                            
                thead1.select('svg').select('#descendingIconIDForColChartWithNegVals').style("visibility", "visible")
                thead1.select('svg').select('#ascendingIconIDForColChartWithNegVals').style("visibility", "visible")
                        
                sortTableFunc()
                
                selectedItem = i
                
                var val = d.value;
                var selectedSlice = i
                options.data.forEach(function(d,i) {
                                   
					if(i == selectedItem){
						 tablePanelForColChartWithNegVals.select("tbody").selectAll("tr")
						 
						 .style("background-color", function(dTr, iTr) {
							
								return i == iTr ? "#808080" : null;
								})
						 .style("color", function(dTr, iTr) {
							
								return i == iTr ? "#FFFFFF" : null;
								})
							var row = $('#' + targetElement[0][0].id + "tableID").find('tr');
							if((row[0].clientHeight * selectedItem) > tablePanelForColChartWithNegVals[0][0].clientHeight - 56 ){
								$("#" + targetElement[0][0].id + "holderForColChartWithNegValsTableID").animate({
									scrollTop: row[0].clientHeight * selectedItem }, 350);
								}
						  else{
			
								$("#" + targetElement[0][0].id + "holderForColChartWithNegValsTableID").animate({
								scrollTop: 0 }, 350);
						}
							
					} //if(i == selectedItem)
                });
            })
        }
        else{
            verticalBars.on("click", function(d,i) {
                tip.style("display","none")
            })
        }
        
        //By default calling the resized function first time (to align table's th and td).
        setTimeout(function(){ resizedFuctionForColChartWithNegVals() },1000)
        
        window.addEventListener('resize', function(event){ resizedFuctionForColChartWithNegVals() });
        
        $(function() {
			$("#" + targetElement[0][0].id).resizable({
				resize: function(event, ui) {
                    divWidth = ui.size.width;
                    divHeight = ui.size.height;
                    resizedFuctionForColChartWithNegVals();
                }
            });
         });
        
        function resizedFuctionForColChartWithNegVals()
        {
            
            if((svgPanelForColChartWithNegVals.node().getBoundingClientRect().width) && (svgPanelForColChartWithNegVals.node().getBoundingClientRect().height) > 0){

                
                if(showOrHideCommentsBtnForColChartWithNegVals == true){
                    commentsBtnForColChartWithNegVals.style('margin-left', "2px")
                    menuButtonForColChartWithNegVals.style('right', '0')
                }
                else if(showOrHideCommentsBtnForColChartWithNegVals == false){
                    //commentsBtnForColChartWithNegVals.style('right', '0')
                    commentsBtnForColChartWithNegVals.style('display','none')
                    menuButtonForColChartWithNegVals.style('right', '0')
                }

                optionsButtonPanelForColChartWithNegVals.style('right', '0')
                
                //downloadOptionsPanelDiv.style('right', '0')

				if(isThereNegativeValue == true){
					
					var margin1 = {top: 30, right: 40, bottom: 100, left: 40}, // originally top: 42, left: 80
					width1 = (svgPanelForColChartWithNegVals.node().getBoundingClientRect().width) - margin1.left - margin1.right,
					height1 = (svgPanelForColChartWithNegVals.node().getBoundingClientRect().height) - margin1.top - margin1.bottom;
            
					yAxisVariable.attr("transform", "rotate(-90)") .attr("y", -25) .attr("x",0 - (height1 / 2))
				
					xAxisVariable.attr("transform", "translate(" + ((width1/2)) + " ," + (height1+margin1.bottom - 2) + ")")
					
					x1.domain(options.data.map(function(d) { return d[options.keys.label]; })) .rangeRoundBands([0, width1], 0.25);
				
					xAxis.scale(x1)
				
					svg.select(".x.axis").attr("transform", "translate(0," + (svgPanelForColChartWithNegVals.node().getBoundingClientRect().height - 110) + ")") .call(xAxis)
					.selectAll("text") .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') .attr("transform", function(d) { return "rotate(0)" })
					.style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
					.text(function(d,i) {
						if(d.length >10)
							return d.substring(0,10)+'...';
						else
							return d;
					})
					
					y.domain([-y0, y0]).range([height1,0]).nice();

					x.domain(d3.range(options.data.map(function(d) { return +d[options.keys.value]; }).length)) .rangeRoundBands([0, width1], 0.25);
				
					yAxis.scale(y).orient("left");
					
					svg.selectAll(".bar").attr("x", function(d, i) { return x(i); }).attr("y", function(d) { return y(Math.max(0, d)); })
					.attr("width", x.rangeBand()).attr("height", function(d) { return Math.abs(y(d) - y(0)); })

                    svg.selectAll(".series_value").attr("x", function(d, i) { return x(i); }).attr("y", function(d) { return y(Math.max(0, d)); })
					.attr("width", x.rangeBand()).attr("height", function(d) { return Math.abs(y(d) - y(0)); })

					//svg.append("g").attr("class", "x axis")//.call(yAxis);

					svg.select(".line").attr("y1", y(0)).attr("y2", y(0)).attr("x1", 0).attr("x2", width1);
			
					textOnBarsForColChartWithNegVals .attr("x", function(d,i) { return x(i)+x.rangeBand()/2; })
					.attr("y", function(d) { return d > 0 ? y(d) - 3 : y(d) + 13; })
				}
				else {
					
					var margin1 = {top: 30, right: 40, bottom: 80, left: 40}, // originally top: 42, left: 80
					width1 = (svgPanelForColChartWithNegVals.node().getBoundingClientRect().width) - margin1.left - margin1.right,
					height1 = (svgPanelForColChartWithNegVals.node().getBoundingClientRect().height) - margin1.top - margin1.bottom;
            
					yAxisVariable.attr("transform", "rotate(-90)") .attr("y", -25) .attr("x",0 - (height1 / 2))
				
					xAxisVariable.attr("transform", "translate(" + ((width1/2)) + " ," + (height1+margin1.bottom - 2) + ")")
					
					var xx =  x.domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.value]; }))]) .range([0, width1]);
					var yy = y.domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.value]; }))]) .range([height1, 0]);
				
					yAxis.scale(yy) .orient("left");
				
					x1.domain(options.data.map(function(d) { return d[options.keys.label]; })) .rangeRoundBands([0, width1], 0.25);
				
					xAxis.scale(x1) .orient("bottom");
				
					//var svg1 = svg;
				
					svg.select("svg") .attr("width", width1 + margin1.left + margin1.right) .attr("height", height1 + margin1.top + margin1.bottom);
				
					svg.select(".y.axis") .call(yAxis)
				
					svg.select(".x.axis") .attr("transform", "translate(0," + height1 + ")") .call(xAxis)
			
					// Add the X Axis margin labels
					.selectAll("text") .style("text-anchor", "end").attr("dx", "0.4em") .attr("dy", "1.15em") .style('fill','#00001c') .attr("transform", function(d) { return "rotate(0)" })
					.style("font-family","Verdana,sans-serif").style("font-weight","normal").style("font-size","12px")
					.text(function(d,i) {
						if(d.length > 9)
							return d.substring(0,9)+'...';
						else
							return d;
					})       
				
					xScale.domain(d3.range(options.data.map(function(d) { return +d[options.keys.value]; }).length)) .rangeRoundBands([0, width1], 0.25);
				
					yScale.domain([0, d3.max(options.data.map(function(d) { return +d[options.keys.value]; }), function(d) { return d; })]) .range([0, height1]);
				
					svg.selectAll(".bar") .attr("x", function(d, i) { return xScale(i); }) .attr("width", xScale.rangeBand())
					.attr("y", function(d) { return height1 - yScale(d); }) .attr("height", function(d) { return yScale(d); })

                    svg.selectAll(".series_value") .attr("x", function(d, i) { return xScale(i); }) .attr("width", xScale.rangeBand())
					.attr("y", function(d) { return height1 - yScale(d); }) .attr("height", function(d) { return yScale(d); })

					 .attr("x", function(d,i) { return xScale(i)+xScale.rangeBand()/2; })
					.attr("y", function(d,i) { return height1-yScale(d)+yTextPadding; })
				}
				
                colWidth = []; 
				
                d3.select(".theadClassForColChartWithNegVals" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
					d.forEach(function(dd,j){
						colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
					})
                })
                
                tablePanelForColChartWithNegVals.select(".thead1ClassForColChartWithNegVals" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
                            d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
                })
                
            } // checking svgPanelForColChartWithNegVals width & height panel size function ends here.
            
        } //resizedFuction() ends here
    }, //columnChartWithNegativeValues
	// ************************************************** US map with pins  **************************************************
	USMapWithPins: function(targetElement, options){
        
        isChartCalled++;
        var chartName = "USMAPWITHPINS"
        
        acinfotech.allCharts(targetElement,options,chartName)
        
        targetElement.style("min-width","800px").style("min-height","600px").style("background-color", options.BGcolor)
        
        var chartTitlePanelForUSMapWithPins =  targetElement.append("div").style('position',"absolute")
		.style("left","0%").style("top","0%").style("width","100%").style("height","5%").style("text-align", "left")
        .style("text-indent","6px").style("background-color", options.BGcolor).style("border-style","none")
		.html('<div  style="width: 100%; height:0%; background-color:#ffffff; position: absolute; top:10.0%; font-size:16px; font-family:inter; color:#00001c;">'+ options.chartTitle + '</div>')
		
		var refreshBtnForUSMapWithPins = targetElement.append("div").style('position','absolute')
		.style('left',(targetElement[0][0].clientWidth - 53) + "px").style('top','1px')
		.style("width","27px").style("height","22px").style('background-color',"#ffffff").style("z-index",10)
		.style("cursor","pointer").style("display","block")
        .style('padding',"0px") .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
        var refreshBtnImgVar = document.createElement("IMG");
        refreshBtnImgVar.src = "images/refreshIcon.png";
        refreshBtnImgVar.setAttribute("style","position:absolute; left:5px; top:2px; width:14px; height:14px; opacity:0.8;")
        refreshBtnForUSMapWithPins[0][0].appendChild(refreshBtnImgVar)
		
		var tableBtnForUSMapWithPins = targetElement.append("div").style('position','absolute')
		.style('left',(targetElement[0][0].clientWidth - 28) + "px").style('top','1px')
		.style("width","27px").style("height","22px").style('background-color',"#ffffff").style("z-index",10)
		.style("cursor","pointer").style("display","block").style('padding',"0px")
        .style("border", "1px solid #f8f8f8").style("line-height","0px").style("box-sizing","border-box")
		var tableBtnImgVar = document.createElement("IMG");
        if(options.showTable == false){
            tableBtnImgVar.src = "images/showTableIcon.png";
            tableBtnForUSMapWithPins.attr("class","showTableClassForChartTable")
        }
        else if(options.showTable == true){
            tableBtnImgVar.src = "images/cancelTableIcon.png";
            tableBtnForUSMapWithPins.attr("class","hideTableClassForChartTable")
        }
        tableBtnImgVar.setAttribute("style","position:absolute; left:4px; top:1px; width:17px; height:17px; opacity:0.68;")
        tableBtnForUSMapWithPins[0][0].appendChild(tableBtnImgVar)
        
		refreshBtnForUSMapWithPins.on('click', function() {

			d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,input').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){
                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                }
            }
            acinfotech.USMapWithPins(targetElement,options)

        })
		
		tableBtnForUSMapWithPins.on('click', function() {
            
            if(options.showTable == false){ 
                options.showTable = true;
            }
            else if(options.showTable == true){ 
                options.showTable = false;
            }

			d3.select(targetElement[0][0]).selectAll('div:not(.ui-resizable-handle),svg,select,input').remove();
            
            for(var i = 0; i<divAndChartsArray.length; i++){
                if(targetElement[0][0].id === divAndChartsArray[i].divID){
                    options.data = divAndChartsArray[i].optionsData
                }
            }
            acinfotech.USMapWithPins(targetElement,options)

        })
		
		// Creating icon tool tip
        var iconButtonTooltip = targetElement.append('div').style('position','absolute').style('width','240px') .style('height',"25px")
        .style("background-color",'#404040 ') .style("z-index",999).style("border", "0.0px") .style("border-color", "#278eff") 
        .style("border-style", "solid") .style("border-radius","0px").style("box-shadow", "1px 1px 2px #d8d8d8").style("display","none")
		
		refreshBtnForUSMapWithPins.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
            var refreshButtonTooltipText = "Refresh";
            
            iconButtonTooltip.style("width","63px").style("margin-left", (m[0] - 73) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ refreshButtonTooltipText +'</div>')
        })
        refreshBtnForUSMapWithPins.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })
		
		tableBtnForUSMapWithPins.on('mousemove', function(d,i) {
            var root = targetElement
                var m = d3.mouse(root.node());
                m[0] += 0
                m[1] += 0
                if(options.showTable == false){
                    var tableButtonTooltipText = "Show Table";
                }
                else if(options.showTable == true){
                    var tableButtonTooltipText = "Hide Table";
                }
            
			iconButtonTooltip.style("width","85px").style("margin-left", (m[0] - 95) + "px").style("margin-top",(m[1]) + "px").style("display","block")
            iconButtonTooltip.html('<div  style="width: 100%; height:0%; background-color:#c7c7c7;  position: absolute; top:20.0%; font-size:12px; font-family:inter; color:#ffffff; text-align:center;">'+ tableButtonTooltipText +'</div>')
        })
        tableBtnForUSMapWithPins.on('mouseout', function(d,i) {
            iconButtonTooltip.style("display","none")
        })
		
		var svgPanelForUSMapWithPins = targetElement .append('svg').attr("id","stateSvgID" + targetElement[0][0].id)
        .attr("class","svgPanelClassForUSMapWithPins") .style("background-color", options.BGcolor) .style("position","absolute")
        
		if(options.showTable == true){
			svgPanelForUSMapWithPins.attr('width', 100 + "%") .attr('height', 55 + "%") .style("top",5 + "%") .append('g')
		}
        else if(options.showTable == false){
            svgPanelForUSMapWithPins.attr('width', 100 + "%") .attr('height', 95 + "%") .style("left",0 + "%").style("top",5 + "%") .append('g')
		}
        
        // Creating ToolTip DIV
        var tooltipForUSMapWithPins = targetElement .append('div') .attr('class', 'tooltipPie') .style("visibility", "hidden") .style("position", "absolute") .style("text-align","left")
        .style("color","#000000") .style("font-size", "12px") .style("width", "auto") .style("height", "auto") .style("padding-top", "5px") .style("padding-bottom", "3px") .style("padding-left", "7px")
        .style("padding-right", "7px") .style("background", "#F8F8F8") .style("fant-family", "Verdana,sans-serif") .style("box-shadow", "1px 1px 1px #888888").style("z-index",1000)
        .style("border", "1.0px") .style("border-color", "#F0F0F0") .style("border-style", "solid") .style("border-radius", "1px") .style("min-width","80px")
        tooltipForUSMapWithPins.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'stateNameLableClass').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px") .style("font-size", "14px") .style("font-weight", "normal");
        tooltipForUSMapWithPins.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
        tooltipForUSMapWithPins.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'placeNameLableClass').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");
        tooltipForUSMapWithPins.append('hr').style("height","2px").style("width","100%").style("margin","2px").style("border","none").style("color","#333").style("background-color","#E0E0E0")
        tooltipForUSMapWithPins.append('div') .style("font-family","Verdana,sans-serif") .attr('class', 'valueLableClass').style("color","#00001c") .style("text-transform","capitalize").style("padding","1px").style("font-size", "14px").style("font-weight", "normal");
        
        var topoJson = function(){function t(t,e){function n(e){var n=t.arcs[e],r=n[0],o=[0,0];return n.forEach(function(t){o[0]+=t[0],o[1]+=t[1]}),[r,o]}var r={},o={},a={};e.forEach(function(t){var e=n(t);(r[e[0]]||(r[e[0]]=[])).push(t),(r[e[1]]||(r[e[1]]=[])).push(~t)}),e.forEach(function(t){var e,r,i=n(t),c=i[0],s=i[1];if(e=a[c])if(delete a[e.end],e.push(t),e.end=s,r=o[s]){delete o[r.start];var u=r===e?e:e.concat(r);o[u.start=e.start]=a[u.end=r.end]=u}else if(r=a[s]){delete o[r.start],delete a[r.end];var u=e.concat(r.map(function(t){return~t}).reverse());o[u.start=e.start]=a[u.end=r.start]=u}else o[e.start]=a[e.end]=e;else if(e=o[s])if(delete o[e.start],e.unshift(t),e.start=c,r=a[c]){delete a[r.end];var f=r===e?e:r.concat(e);o[f.start=r.start]=a[f.end=e.end]=f}else if(r=o[c]){delete o[r.start],delete a[r.end];var f=r.map(function(t){return~t}).reverse().concat(e);o[f.start=r.end]=a[f.end=e.end]=f}else o[e.start]=a[e.end]=e;else if(e=o[c])if(delete o[e.start],e.unshift(~t),e.start=s,r=a[s]){delete a[r.end];var f=r===e?e:r.concat(e);o[f.start=r.start]=a[f.end=e.end]=f}else if(r=o[s]){delete o[r.start],delete a[r.end];var f=r.map(function(t){return~t}).reverse().concat(e);o[f.start=r.end]=a[f.end=e.end]=f}else o[e.start]=a[e.end]=e;else if(e=a[s])if(delete a[e.end],e.push(~t),e.end=c,r=a[c]){delete o[r.start];var u=r===e?e:e.concat(r);o[u.start=e.start]=a[u.end=r.end]=u}else if(r=o[c]){delete o[r.start],delete a[r.end];var u=e.concat(r.map(function(t){return~t}).reverse());o[u.start=e.start]=a[u.end=r.start]=u}else o[e.start]=a[e.end]=e;else e=[t],o[e.start=c]=a[e.end=s]=e});var i=[];for(var c in a)i.push(a[c]);return i}function e(e,r,o){function a(t){0>t&&(t=~t),(l[t]||(l[t]=[])).push(f)}function i(t){t.forEach(a)}function c(t){t.forEach(i)}function s(t){"GeometryCollection"===t.type?t.geometries.forEach(s):t.type in d&&(f=t,d[t.type](t.arcs))}var u=[];if(arguments.length>1){var f,l=[],d={LineString:i,MultiLineString:c,Polygon:c,MultiPolygon:function(t){t.forEach(c)}};s(r),l.forEach(3>arguments.length?function(t,e){u.push([e])}:function(t,e){o(t[0],t[t.length-1])&&u.push([e])})}else for(var p=0,h=e.arcs.length;h>p;++p)u.push([p]);return n(e,{type:"MultiLineString",arcs:t(e,u)})}function n(t,e){function n(t,e){e.length&&e.pop();for(var n,o=h[0>t?~t:t],a=0,i=o.length,c=0,s=0;i>a;++a)e.push([(c+=(n=o[a])[0])*f+d,(s+=n[1])*l+p]);0>t&&r(e,i)}function o(t){return[t[0]*f+d,t[1]*l+p]}function a(t){for(var e=[],r=0,o=t.length;o>r;++r)n(t[r],e);return 2>e.length&&e.push(e[0]),e}function i(t){for(var e=a(t);4>e.length;)e.push(e[0]);return e}function c(t){return t.map(i)}function s(t){var e=t.type,n="GeometryCollection"===e?{type:e,geometries:t.geometries.map(s)}:e in v?{type:e,coordinates:v[e](t)}:{type:null};return"id"in t&&(n.id=t.id),"properties"in t&&(n.properties=t.properties),n}var u=t.transform,f=u.scale[0],l=u.scale[1],d=u.translate[0],p=u.translate[1],h=t.arcs,v={Point:function(t){return o(t.coordinates)},MultiPoint:function(t){return t.coordinates.map(o)},LineString:function(t){return a(t.arcs)},MultiLineString:function(t){return t.arcs.map(a)},Polygon:function(t){return c(t.arcs)},MultiPolygon:function(t){return t.arcs.map(c)}};return s(e)}function r(t,e){for(var n,r=t.length,o=r-e;--r>o;)n=t[o],t[o++]=t[r],t[r]=n}function o(t,e){for(var n=0,r=t.length;r>n;){var o=n+r>>>1;e>t[o]?n=o+1:r=o}return n}function a(t){function e(t,e){t.forEach(function(t){0>t&&(t=~t);var n=a[t]||(a[t]=[]);n[e]||(n.forEach(function(t){var n,r;r=o(n=i[e],t),n[r]!==t&&n.splice(r,0,t),r=o(n=i[t],e),n[r]!==e&&n.splice(r,0,e)}),n[e]=e)})}function n(t,n){t.forEach(function(t){e(t,n)})}function r(t,e){"GeometryCollection"===t.type?t.geometries.forEach(function(t){r(t,e)}):t.type in c&&c[t.type](t.arcs,e)}var a=[],i=t.map(function(){return[]}),c={LineString:e,MultiLineString:n,Polygon:n,MultiPolygon:function(t,e){t.forEach(function(t){n(t,e)})}};return t.forEach(r),i}return{version:"0.0.32",mesh:e,object:n,neighbors:a}}();
        
        var latitudeAndLongitudeData = {"type":"Topology","objects":{"counties":{"type":"GeometryCollection","bbox":[-179.1473399999999,17.67439566600018,179.7784800000003,71.38921046500008],"geometries":[{"type":"MultiPolygon","id":53073,"arcs":[[[0,1,2]]]},{"type":"Polygon","id":30105,"arcs":[[3,4,5,6,7,8]]},{"type":"Polygon","id":30029,"arcs":[[9,10,11,12,13,14,15,16,17,18]]},{"type":"Polygon","id":16021,"arcs":[[19,20,21,22]]},{"type":"Polygon","id":30071,"arcs":[[-8,23,24,25,26,27]]},{"type":"Polygon","id":38079,"arcs":[[28,29,30,31]]},{"type":"Polygon","id":30053,"arcs":[[-18,32,33,-20,34]]},{"type":"Polygon","id":38009,"arcs":[[-30,35,36,37,38]]},{"type":"Polygon","id":30035,"arcs":[[39,40,-10,41]]},{"type":"Polygon","id":30041,"arcs":[[42,43,44,45]]},{"type":"Polygon","id":30005,"arcs":[[-27,46,47,-46,48]]},{"type":"Polygon","id":30019,"arcs":[[49,50,-4,51]]},{"type":"Polygon","id":38067,"arcs":[[52,53,54,55]]},{"type":"Polygon","id":27069,"arcs":[[56,57,-53,58]]},{"type":"Polygon","id":38095,"arcs":[[59,60,61,-32,62,63]]},{"type":"Polygon","id":38019,"arcs":[[-55,64,65,-64,66]]},{"type":"Polygon","id":53047,"arcs":[[67,68,69,70,71,72,-1,73]]},{"type":"Polygon","id":53065,"arcs":[[74,75,76,77,78]]},{"type":"Polygon","id":53051,"arcs":[[-22,79,80,-75,81]]},{"type":"Polygon","id":53019,"arcs":[[-78,82,-68,83]]},{"type":"Polygon","id":30051,"arcs":[[84,85,86,-44,87]]},{"type":"Polygon","id":38023,"arcs":[[88,89,90,91]]},{"type":"Polygon","id":38013,"arcs":[[92,93,94,95,-89,96]]},{"type":"Polygon","id":30101,"arcs":[[97,-86,98,-40]]},{"type":"Polygon","id":38075,"arcs":[[99,100,-93,101,-38]]},{"type":"Polygon","id":27135,"arcs":[[102,103,-57,104,105]]},{"type":"Polygon","id":30091,"arcs":[[-91,106,107,-50,108]]},{"type":"Polygon","id":16017,"arcs":[[-34,109,110,111,112,-80,-21]]},{"type":"Polygon","id":38101,"arcs":[[-101,113,114,115,-94]]},{"type":"MultiPolygon","id":53055,"arcs":[[[116]],[[117]],[[118]]]},{"type":"Polygon","id":27071,"arcs":[[119,120,121,122,123]]},{"type":"MultiPolygon","id":53057,"arcs":[[[124,-2,-73,125,126,127]]]},{"type":"Polygon","id":38105,"arcs":[[-96,128,129,130,-107,-90]]},{"type":"Polygon","id":38049,"arcs":[[131,132,133,-114,-100,-37]]},{"type":"Polygon","id":27137,"arcs":[[134,135,136,137,138,139,-120,140]]},{"type":"Polygon","id":30085,"arcs":[[-108,-131,141,142,-5,-51]]},{"type":"Polygon","id":53007,"arcs":[[-72,143,144,145,146,-126]]},{"type":"Polygon","id":38061,"arcs":[[147,148,149,-129,-95,-116]]},{"type":"Polygon","id":27089,"arcs":[[150,151,152,153,154,-58,-104]]},{"type":"Polygon","id":38069,"arcs":[[-62,155,156,157,-132,-36,-29]]},{"type":"MultiPolygon","id":38071,"arcs":[[[158]],[[159,160,161,-60,-66]]]},{"type":"Polygon","id":38099,"arcs":[[-54,-155,162,163,-160,-65]]},{"type":"Polygon","id":27007,"arcs":[[-122,164,165,166,167,168,-151,-103,169]]},{"type":"Polygon","id":30073,"arcs":[[-99,-85,170,171,-11,-41]]},{"type":"MultiPolygon","id":53029,"arcs":[[[172,173]],[[174]]]},{"type":"MultiPolygon","id":53009,"arcs":[[[175,176]]]},{"type":"Polygon","id":38005,"arcs":[[-61,-162,177,178,179,-156],[-159]]},{"type":"Polygon","id":30015,"arcs":[[-48,180,181,182,183,-171,-88,-43]]},{"type":"MultiPolygon","id":53061,"arcs":[[[-147,184,185,-173,186,-127]]]},{"type":"Polygon","id":30089,"arcs":[[-17,187,188,189,190,-110,-33]]},{"type":"Polygon","id":27075,"arcs":[[191,192,-135,193]]},{"type":"Polygon","id":38063,"arcs":[[194,195,196,197,-178,-161,-164]]},{"type":"Polygon","id":38035,"arcs":[[-154,198,199,200,-195,-163]]},{"type":"Polygon","id":27119,"arcs":[[201,202,203,204,205,206,207,-199,-153]]},{"type":"Polygon","id":27113,"arcs":[[-169,208,-204,209,-202,-152]]},{"type":"Polygon","id":30083,"arcs":[[210,211,212,213,-142]]},{"type":"Polygon","id":53017,"arcs":[[214,215,-144,-71]]},{"type":"Polygon","id":38053,"arcs":[[-150,216,217,218,219,-211,-130]]},{"type":"MultiPolygon","id":53031,"arcs":[[[220,221,222,-176,223]]]},{"type":"Polygon","id":30099,"arcs":[[-184,224,225,-12,-172]]},{"type":"Polygon","id":30055,"arcs":[[-214,226,227,228,-6,-143]]},{"type":"Polygon","id":16079,"arcs":[[-191,229,230,231,232,233,-111]]},{"type":"Polygon","id":30047,"arcs":[[234,-188,-16]]},{"type":"Polygon","id":53063,"arcs":[[-81,-113,235,236,237,238,-76]]},{"type":"Polygon","id":27029,"arcs":[[239,240,241,-205,-209,-168]]},{"type":"Polygon","id":16055,"arcs":[[-234,242,-236,-112]]},{"type":"Polygon","id":30033,"arcs":[[-229,243,244,245,246,-24,-7]]},{"type":"Polygon","id":27125,"arcs":[[-203,-210]]},{"type":"Polygon","id":53025,"arcs":[[-70,247,248,249,250,251,252,-215]]},{"type":"Polygon","id":53043,"arcs":[[-83,-77,-239,253,254,-248,-69]]},{"type":"Polygon","id":30049,"arcs":[[255,256,257,258,259,-13,-226]]},{"type":"MultiPolygon","id":53035,"arcs":[[[260]],[[261,262,263,264,265]]]},{"type":"Polygon","id":27061,"arcs":[[-140,266,267,-165,-121]]},{"type":"Polygon","id":38055,"arcs":[[268,269,270,271,272,-148,-115,-134]]},{"type":"Polygon","id":38027,"arcs":[[-198,273,274,275,-179]]},{"type":"Polygon","id":38103,"arcs":[[-180,-276,276,277,278,279,-157]]},{"type":"Polygon","id":38083,"arcs":[[-158,-280,280,281,-269,-133]]},{"type":"Polygon","id":38025,"arcs":[[-273,282,283,284,-217,-149]]},{"type":"Polygon","id":30027,"arcs":[[-26,285,286,287,288,289,-181,-47]]},{"type":"Polygon","id":30021,"arcs":[[-213,290,291,-227]]},{"type":"MultiPolygon","id":53033,"arcs":[[[292]],[[-146,293,294,295,-185]]]},{"type":"Polygon","id":30013,"arcs":[[296,297,-256,-225,-183]]},{"type":"Polygon","id":38091,"arcs":[[-201,298,299,300,301,-196]]},{"type":"Polygon","id":38039,"arcs":[[-302,302,303,304,-274,-197]]},{"type":"Polygon","id":38097,"arcs":[[305,306,-299,-200,-208]]},{"type":"MultiPolygon","id":53045,"arcs":[[[307,-265,308,309,310,311,-221]]]},{"type":"Polygon","id":30063,"arcs":[[-15,312,313,314,315,316,317,-189,-235]]},{"type":"Polygon","id":30077,"arcs":[[-260,318,319,320,-313,-14]]},{"type":"Polygon","id":30069,"arcs":[[-247,321,322,-286,-25]]},{"type":"Polygon","id":53037,"arcs":[[-216,-253,323,-294,-145]]},{"type":"Polygon","id":38031,"arcs":[[-305,324,-277,-275]]},{"type":"Polygon","id":38057,"arcs":[[325,326,327,-283,-272]]},{"type":"MultiPolygon","id":53027,"arcs":[[[-312,328,329,330,331,-222]]]},{"type":"Polygon","id":27087,"arcs":[[332,333,-206,-242]]},{"type":"Polygon","id":27107,"arcs":[[-207,-334,334,335,336,-306]]},{"type":"Polygon","id":30061,"arcs":[[-318,337,-230,-190]]},{"type":"Polygon","id":27021,"arcs":[[338,339,340,341,342,343,-166,-268]]},{"type":"Polygon","id":23003,"arcs":[[344,345,346,347,348]]},{"type":"Polygon","id":30045,"arcs":[[-290,349,350,-297,-182]]},{"type":"Polygon","id":16009,"arcs":[[-233,351,352,-237,-243]]},{"type":"Polygon","id":27057,"arcs":[[-344,353,354,-240,-167]]},{"type":"MultiPolygon","id":53053,"arcs":[[[-295,355,356,357,358]],[[-262,359]],[[-309,-264,360]]]},{"type":"Polygon","id":30109,"arcs":[[-220,361,362,363,-291,-212]]},{"type":"Polygon","id":38007,"arcs":[[-285,364,365,366,-218]]},{"type":"Polygon","id":38033,"arcs":[[-367,367,368,-362,-219]]},{"type":"Polygon","id":38043,"arcs":[[369,370,371,372,-281,-279]]},{"type":"Polygon","id":38093,"arcs":[[-304,373,374,375,-370,-278,-325]]},{"type":"Polygon","id":38015,"arcs":[[-373,376,377,378,-270,-282]]},{"type":"Polygon","id":38065,"arcs":[[-379,379,-326,-271]]},{"type":"Polygon","id":53001,"arcs":[[380,381,-249,-255]]},{"type":"Polygon","id":53075,"arcs":[[-238,-353,382,383,384,385,386,387,-381,-254]]},{"type":"Polygon","id":38003,"arcs":[[-301,388,389,390,-374,-303]]},{"type":"Polygon","id":38017,"arcs":[[-307,-337,391,392,393,-389,-300]]},{"type":"Polygon","id":53067,"arcs":[[-358,394,-329,-311,395]]},{"type":"Polygon","id":30079,"arcs":[[-364,396,397,-244,-228,-292]]},{"type":"Polygon","id":27005,"arcs":[[-355,398,399,400,-335,-333,-241]]},{"type":"Polygon","id":27027,"arcs":[[-401,401,402,403,-392,-336]]},{"type":"Polygon","id":16057,"arcs":[[-232,404,405,-383,-352]]},{"type":"Polygon","id":53077,"arcs":[[-252,406,407,408,409,-356,-324]]},{"type":"Polygon","id":30059,"arcs":[[-351,410,411,412,413,414,-257,-298]]},{"type":"Polygon","id":27001,"arcs":[[-139,415,416,417,418,419,-339,-267]]},{"type":"Polygon","id":26131,"arcs":[[420,421,422,423]]},{"type":"Polygon","id":38089,"arcs":[[-328,424,425,426,427,-365,-284]]},{"type":"Polygon","id":38059,"arcs":[[-378,428,429,430,-425,-327,-380]]},{"type":"Polygon","id":26013,"arcs":[[431,432,433,434]]},{"type":"Polygon","id":16035,"arcs":[[-338,-317,435,436,437,-405,-231]]},{"type":"Polygon","id":30017,"arcs":[[438,439,440,441,-245,-398]]},{"type":"Polygon","id":30087,"arcs":[[-442,442,443,444,445,446,-322,-246]]},{"type":"Polygon","id":30039,"arcs":[[447,448,-314,-321]]},{"type":"Polygon","id":27159,"arcs":[[-343,449,450,-399,-354]]},{"type":"Polygon","id":27035,"arcs":[[-420,451,452,-340]]},{"type":"MultiPolygon","id":53049,"arcs":[[[453,454,455,-331]]]},{"type":"Polygon","id":53041,"arcs":[[-395,-357,-410,456,457,458,-454,-330]]},{"type":"Polygon","id":30007,"arcs":[[-415,459,460,-258]]},{"type":"Polygon","id":27017,"arcs":[[461,462,-416,-138]]},{"type":"Polygon","id":26053,"arcs":[[463,464,465,466,-422]]},{"type":"Polygon","id":30065,"arcs":[[-447,467,468,-287,-323]]},{"type":"Polygon","id":26095,"arcs":[[469,470,471,472,473]]},{"type":"Polygon","id":30037,"arcs":[[-469,474,475,476,477,-288]]},{"type":"Polygon","id":30107,"arcs":[[-289,-478,478,-411,-350]]},{"type":"Polygon","id":53021,"arcs":[[479,480,481,-250,-382,-388]]},{"type":"Polygon","id":53005,"arcs":[[482,483,484,485,-407,-251,-482]]},{"type":"Polygon","id":27111,"arcs":[[-451,486,487,488,489,-402,-400]]},{"type":"Polygon","id":38037,"arcs":[[490,491,492,-426,-431]]},{"type":"Polygon","id":53023,"arcs":[[493,494,495,-386]]},{"type":"Polygon","id":30025,"arcs":[[-369,496,497,498,499,-439,-397,-363]]},{"type":"Polygon","id":16049,"arcs":[[500,501,502,503,504,505,506,-436,-316]]},{"type":"Polygon","id":30081,"arcs":[[-449,507,508,509,-501,-315]]},{"type":"Polygon","id":38029,"arcs":[[-372,510,511,512,513,-429,-377]]},{"type":"Polygon","id":38047,"arcs":[[-376,514,515,-511,-371]]},{"type":"Polygon","id":16069,"arcs":[[-438,516,-506,517,518,-384,-406]]},{"type":"Polygon","id":38087,"arcs":[[519,520,521,-497,-368,-366,-428]]},{"type":"Polygon","id":38045,"arcs":[[522,523,524,-515,-375,-391]]},{"type":"Polygon","id":38041,"arcs":[[-493,525,-520,-427]]},{"type":"Polygon","id":27167,"arcs":[[-490,526,527,528,-403]]},{"type":"Polygon","id":38073,"arcs":[[-394,529,530,531,-523,-390]]},{"type":"Polygon","id":38077,"arcs":[[-529,532,533,534,-530,-393,-404]]},{"type":"Polygon","id":53013,"arcs":[[535,536,537,-480,-387,-496]]},{"type":"Polygon","id":53071,"arcs":[[-538,538,-483,-481]]},{"type":"Polygon","id":55051,"arcs":[[-466,539,540,541,542]]},{"type":"Polygon","id":23025,"arcs":[[543,544,545,546,547,548,-348]]},{"type":"Polygon","id":23021,"arcs":[[549,-544,-347]]},{"type":"Polygon","id":30043,"arcs":[[-461,550,551,552,553,-319,-259]]},{"type":"Polygon","id":26153,"arcs":[[-472,554,555,556,557]]},{"type":"Polygon","id":30111,"arcs":[[558,559,560,561,-475,-468,-446]]},{"type":"Polygon","id":30103,"arcs":[[562,-559,-445]]},{"type":"Polygon","id":16061,"arcs":[[-437,-507,-517]]},{"type":"Polygon","id":53003,"arcs":[[-519,563,-494,-385]]},{"type":"Polygon","id":38085,"arcs":[[-514,564,565,-491,-430]]},{"type":"Polygon","id":26071,"arcs":[[-433,566,567,568,569,570,-464,-421,571]]},{"type":"Polygon","id":27115,"arcs":[[572,573,574,575,-417,-463]]},{"type":"Polygon","id":23019,"arcs":[[576,577,578,579,-545,-550,-346]]},{"type":"Polygon","id":53059,"arcs":[[-409,580,581,582,583,584,-457]]},{"type":"Polygon","id":53015,"arcs":[[-585,585,586,587,588,-458]]},{"type":"MultiPolygon","id":53069,"arcs":[[[-459,-589,589,-455]]]},{"type":"Polygon","id":27153,"arcs":[[-342,590,591,592,-487,-450]]},{"type":"Polygon","id":27097,"arcs":[[-453,593,594,595,-591,-341]]},{"type":"Polygon","id":55125,"arcs":[[596,597,-540,-465,-571,598]]},{"type":"MultiPolygon","id":41007,"arcs":[[[599,600,601]]]},{"type":"Polygon","id":38001,"arcs":[[-492,-566,602,603,604,605,-521,-526]]},{"type":"Polygon","id":38081,"arcs":[[-535,606,607,608,-531]]},{"type":"Polygon","id":38051,"arcs":[[-525,609,610,611,-512,-516]]},{"type":"Polygon","id":38021,"arcs":[[-532,-609,612,613,-610,-524]]},{"type":"Polygon","id":38011,"arcs":[[-606,614,-498,-522]]},{"type":"Polygon","id":30023,"arcs":[[-554,615,616,-508,-448,-320]]},{"type":"Polygon","id":26043,"arcs":[[617,618,619,-568,620]]},{"type":"Polygon","id":27095,"arcs":[[621,622,623,624,-594,-452,-419]]},{"type":"Polygon","id":30097,"arcs":[[-477,625,626,-412,-479]]},{"type":"Polygon","id":30031,"arcs":[[-414,627,628,629,630,631,-551,-460]]},{"type":"Polygon","id":30067,"arcs":[[-627,632,633,634,-628,-413]]},{"type":"Polygon","id":30093,"arcs":[[635,636,-616,-553]]},{"type":"MultiPolygon","id":41009,"arcs":[[[637,638,639,-600,640,-587]]]},{"type":"Polygon","id":27065,"arcs":[[-576,641,-622,-418]]},{"type":"Polygon","id":55013,"arcs":[[642,643,644,645,-574,646]]},{"type":"Polygon","id":55113,"arcs":[[647,648,649,650,651]]},{"type":"Polygon","id":55129,"arcs":[[-651,652,-643,653]]},{"type":"Polygon","id":30011,"arcs":[[654,655,656,657,-440,-500]]},{"type":"Polygon","id":30095,"arcs":[[-562,658,-633,-626,-476]]},{"type":"Polygon","id":27051,"arcs":[[-489,659,660,661,-527]]},{"type":"Polygon","id":27041,"arcs":[[-593,662,663,-660,-488]]},{"type":"Polygon","id":55041,"arcs":[[664,665,666,667,668,-599,-570]]},{"type":"Polygon","id":53011,"arcs":[[-584,669,-638,-586]]},{"type":"Polygon","id":53039,"arcs":[[-486,670,671,672,673,674,-581,-408]]},{"type":"Polygon","id":30003,"arcs":[[-444,675,676,677,678,-560,-563]]},{"type":"Polygon","id":27155,"arcs":[[-662,679,680,681,-533,-528]]},{"type":"Polygon","id":55037,"arcs":[[-620,682,-665,-569]]},{"type":"Polygon","id":41059,"arcs":[[-537,683,684,685,686,-484,-539]]},{"type":"Polygon","id":41063,"arcs":[[-495,-564,-518,-505,687,688,689,-684,-536]]},{"type":"Polygon","id":26109,"arcs":[[690,691,692,-618,693]]},{"type":"Polygon","id":55099,"arcs":[[-598,694,695,696,697,-649,698,-541]]},{"type":"Polygon","id":46105,"arcs":[[699,700,701,702,703,-604]]},{"type":"Polygon","id":46031,"arcs":[[704,705,706,707,-700,-603,-565]]},{"type":"Polygon","id":46063,"arcs":[[-605,-704,708,-655,-499,-615]]},{"type":"Polygon","id":46021,"arcs":[[-612,709,710,-705,-513]]},{"type":"Polygon","id":30001,"arcs":[[-637,711,712,713,714,-509,-617]]},{"type":"Polygon","id":46089,"arcs":[[-614,715,716,717,-710,-611]]},{"type":"Polygon","id":46013,"arcs":[[-608,718,719,720,721,722,-716,-613]]},{"type":"Polygon","id":46109,"arcs":[[-682,723,724,725,726,-534]]},{"type":"Polygon","id":46091,"arcs":[[-727,727,-719,-607]]},{"type":"Polygon","id":41049,"arcs":[[-687,728,729,730,-671,-485]]},{"type":"Polygon","id":55085,"arcs":[[-669,731,732,-695,-597]]},{"type":"Polygon","id":41061,"arcs":[[733,734,-685,-690]]},{"type":"Polygon","id":30057,"arcs":[[-632,735,-712,-636,-552]]},{"type":"Polygon","id":27009,"arcs":[[-625,736,737,-595]]},{"type":"Polygon","id":41021,"arcs":[[738,739,740,-672,-731]]},{"type":"Polygon","id":30075,"arcs":[[-658,741,742,743,-676,-443,-441]]},{"type":"Polygon","id":26031,"arcs":[[744,745,746,747,748,749]]},{"type":"MultiPolygon","id":41057,"arcs":[[[750,751,752,753,754,-601]]]},{"type":"Polygon","id":41067,"arcs":[[755,756,757,-751,-640]]},{"type":"Polygon","id":27145,"arcs":[[-738,758,759,760,761,762,-663,-592,-596]]},{"type":"Polygon","id":27149,"arcs":[[763,764,765,-680,-661]]},{"type":"Polygon","id":27121,"arcs":[[-763,766,767,-764,-664]]},{"type":"Polygon","id":41055,"arcs":[[768,-673,-741]]},{"type":"Polygon","id":27059,"arcs":[[769,770,771,-623,-642]]},{"type":"Polygon","id":27025,"arcs":[[-646,772,773,774,-770,-575]]},{"type":"Polygon","id":55095,"arcs":[[775,776,777,-773,-645]]},{"type":"Polygon","id":41051,"arcs":[[-670,-583,778,779,-756,-639]]},{"type":"Polygon","id":41027,"arcs":[[780,781,-779,-582,-675]]},{"type":"Polygon","id":41065,"arcs":[[-769,-740,782,783,784,785,-781,-674]]},{"type":"Polygon","id":16059,"arcs":[[-715,786,787,788,789,-502,-510]]},{"type":"MultiPolygon","id":23029,"arcs":[[[790,-577,-345,791]]]},{"type":"Polygon","id":23007,"arcs":[[792,793,794,795,-548]]},{"type":"Polygon","id":26141,"arcs":[[796,797,-745,798]]},{"type":"Polygon","id":55005,"arcs":[[-653,799,800,801,-776,-644]]},{"type":"Polygon","id":55107,"arcs":[[-698,802,803,-800,-650]]},{"type":"Polygon","id":30009,"arcs":[[-679,804,805,-634,-659,-561]]},{"type":"Polygon","id":46129,"arcs":[[-718,806,807,808,-706,-711]]},{"type":"Polygon","id":46045,"arcs":[[-723,809,810,-807,-717]]},{"type":"Polygon","id":46037,"arcs":[[-728,-726,811,812,813,814,-720]]},{"type":"Polygon","id":27011,"arcs":[[-681,-766,815,816,817,-724]]},{"type":"Polygon","id":27141,"arcs":[[-624,-772,818,819,820,-759,-737]]},{"type":"Polygon","id":55069,"arcs":[[821,822,823,-696,-733]]},{"type":"Polygon","id":46041,"arcs":[[-809,824,825,826,827,-707]]},{"type":"Polygon","id":46137,"arcs":[[-828,828,829,-701,-708]]},{"type":"Polygon","id":55067,"arcs":[[-668,830,831,832,833,-822,-732]]},{"type":"Polygon","id":41005,"arcs":[[-782,-786,834,835,-757,-780]]},{"type":"Polygon","id":41071,"arcs":[[-836,836,837,-752,-758]]},{"type":"Polygon","id":27171,"arcs":[[-821,838,839,840,841,-760]]},{"type":"Polygon","id":27003,"arcs":[[-775,842,843,844,-819,-771]]},{"type":"Polygon","id":27067,"arcs":[[845,846,847,848,-767,-762]]},{"type":"Polygon","id":27151,"arcs":[[-849,849,850,-816,-765,-768]]},{"type":"Polygon","id":55119,"arcs":[[-824,851,852,853,-803,-697]]},{"type":"Polygon","id":55083,"arcs":[[854,855,856,857,858,859,860,-831,-667]]},{"type":"Polygon","id":23017,"arcs":[[-795,861,862,863,864,865,866]]},{"type":"Polygon","id":46051,"arcs":[[-818,867,868,869,-812,-725]]},{"type":"Polygon","id":27093,"arcs":[[-842,870,871,-846,-761]]},{"type":"Polygon","id":33007,"arcs":[[872,873,874,875,-866]]},{"type":"Polygon","id":27163,"arcs":[[-778,876,877,878,879,-843,-774]]},{"type":"Polygon","id":55017,"arcs":[[-854,880,881,882,-801,-804]]},{"type":"Polygon","id":41047,"arcs":[[-835,-785,883,884,885,-837]]},{"type":"Polygon","id":16003,"arcs":[[886,887,888,889,-688,-504]]},{"type":"Polygon","id":27073,"arcs":[[-851,890,891,892,-868,-817]]},{"type":"MultiPolygon","id":23009,"arcs":[[[893]],[[894]],[[895,-578,-791]]]},{"type":"Polygon","id":46107,"arcs":[[-811,896,897,898,-825,-808]]},{"type":"Polygon","id":46049,"arcs":[[-722,899,900,901,-897,-810]]},{"type":"Polygon","id":27053,"arcs":[[-820,-845,902,903,904,905,-839]]},{"type":"Polygon","id":46115,"arcs":[[-815,906,907,908,-900,-721]]},{"type":"Polygon","id":16085,"arcs":[[-790,909,910,911,-887,-503]]},{"type":"Polygon","id":46019,"arcs":[[-703,912,913,914,-656,-709]]},{"type":"Polygon","id":55109,"arcs":[[915,916,-877,-777]]},{"type":"Polygon","id":55033,"arcs":[[-883,917,918,919,-916,-802]]},{"type":"Polygon","id":26009,"arcs":[[920,921,922,923,924]]},{"type":"Polygon","id":26137,"arcs":[[925,926,-921,927,-747]]},{"type":"Polygon","id":26119,"arcs":[[928,929,-926,-746,-798]]},{"type":"Polygon","id":46025,"arcs":[[930,931,932,933,-907,-814]]},{"type":"Polygon","id":46029,"arcs":[[-870,934,935,-931,-813]]},{"type":"Polygon","id":27023,"arcs":[[-848,936,937,-891,-850]]},{"type":"Polygon","id":27123,"arcs":[[-880,938,-903,-844]]},{"type":"Polygon","id":55073,"arcs":[[-823,-834,939,940,941,942,-852]]},{"type":"Polygon","id":55078,"arcs":[[-861,943,-832]]},{"type":"Polygon","id":41001,"arcs":[[-890,944,945,946,-734,-689]]},{"type":"Polygon","id":41053,"arcs":[[-886,947,948,949,-753,-838]]},{"type":"Polygon","id":41069,"arcs":[[-730,950,951,952,-783,-739]]},{"type":"Polygon","id":41041,"arcs":[[-950,953,954,955,-754]]},{"type":"Polygon","id":46093,"arcs":[[-830,956,957,958,-913,-702]]},{"type":"Polygon","id":55019,"arcs":[[-943,959,960,961,-881,-853]]},{"type":"Polygon","id":55115,"arcs":[[-944,-860,962,963,964,-940,-833]]},{"type":"Polygon","id":50011,"arcs":[[965,966,967,968,969]]},{"type":"Polygon","id":50009,"arcs":[[970,971,972,973,-875]]},{"type":"Polygon","id":50013,"arcs":[[974,975,976,-969]]},{"type":"Polygon","id":36019,"arcs":[[977,978,979,980,-976]]},{"type":"Polygon","id":50019,"arcs":[[-973,981,982,-966,983]]},{"type":"Polygon","id":56029,"arcs":[[984,985,986,987,988,-629,-635,-806]]},{"type":"Polygon","id":36089,"arcs":[[989,990,991,992,993,994]]},{"type":"Polygon","id":56003,"arcs":[[995,996,997,-985,-805,-678]]},{"type":"Polygon","id":56005,"arcs":[[998,999,1000,1001,1002,-743]]},{"type":"Polygon","id":56033,"arcs":[[-744,-1003,1003,-996,-677]]},{"type":"Polygon","id":36033,"arcs":[[-980,1004,1005,-990,1006]]},{"type":"Polygon","id":56011,"arcs":[[-657,-915,1007,1008,-999,-742]]},{"type":"Polygon","id":41023,"arcs":[[-735,-947,1009,1010,1011,-951,-729,-686]]},{"type":"Polygon","id":27085,"arcs":[[-841,1012,1013,1014,-871]]},{"type":"Polygon","id":27019,"arcs":[[-906,1015,1016,-1013,-840]]},{"type":"Polygon","id":46039,"arcs":[[-893,1017,1018,1019,1020,-935,-869]]},{"type":"Polygon","id":27173,"arcs":[[1021,1022,1023,1024,-1018,-892,-938]]},{"type":"Polygon","id":27037,"arcs":[[-879,1025,1026,1027,1028,-904,-939]]},{"type":"Polygon","id":46119,"arcs":[[1029,1030,1031,-826,-899]]},{"type":"Polygon","id":46069,"arcs":[[-902,1032,1033,1034,1035,-1030,-898]]},{"type":"Polygon","id":46059,"arcs":[[-909,1036,1037,1038,-1033,-901]]},{"type":"Polygon","id":27129,"arcs":[[-872,-1015,1039,1040,1041,1042,-1022,-937,-847]]},{"type":"Polygon","id":16037,"arcs":[[1043,1044,1045,1046,-910,-789]]},{"type":"Polygon","id":55093,"arcs":[[-920,1047,1048,-1026,-878,-917]]},{"type":"Polygon","id":26001,"arcs":[[1049,1050,1051,1052]]},{"type":"Polygon","id":26079,"arcs":[[1053,1054,1055,-922]]},{"type":"Polygon","id":26039,"arcs":[[1056,1057,-1054,-927]]},{"type":"Polygon","id":55035,"arcs":[[-962,1058,1059,1060,1061,-918,-882]]},{"type":"Polygon","id":26135,"arcs":[[-1052,1062,-1057,-930]]},{"type":"Polygon","id":16087,"arcs":[[1063,1064,1065,-945,-889]]},{"type":"Polygon","id":41031,"arcs":[[-953,1066,1067,1068,-884,-784]]},{"type":"Polygon","id":27139,"arcs":[[-1029,1069,1070,1071,-1016,-905]]},{"type":"Polygon","id":46057,"arcs":[[-1021,1072,1073,-932,-936]]},{"type":"Polygon","id":50015,"arcs":[[1074,1075,1076,-967,-983]]},{"type":"Polygon","id":41043,"arcs":[[-1069,1077,1078,1079,-948,-885]]},{"type":"Polygon","id":46117,"arcs":[[-1032,1080,1081,1082,1083,-827]]},{"type":"Polygon","id":26019,"arcs":[[1084,1085,1086,1087]]},{"type":"Polygon","id":50005,"arcs":[[1088,1089,1090,-1075,-982,-972]]},{"type":"MultiPolygon","id":23027,"arcs":[[[-580,1091,1092,1093,1094,-546]]]},{"type":"Polygon","id":16043,"arcs":[[1095,1096,1097,1098,1099,-713,-736,-631]]},{"type":"Polygon","id":46055,"arcs":[[1100,1101,1102,-957,-829,-1084]]},{"type":"Polygon","id":50007,"arcs":[[-1077,1103,1104,1105,-978,-975,-968]]},{"type":"Polygon","id":41003,"arcs":[[-1080,1106,-954,-949]]},{"type":"Polygon","id":23011,"arcs":[[1107,1108,1109,1110,-793,-547,-1095]]},{"type":"Polygon","id":27143,"arcs":[[-1017,-1072,1111,1112,-1040,-1014]]},{"type":"Polygon","id":27049,"arcs":[[1113,1114,1115,1116,1117,-1027,-1049]]},{"type":"Polygon","id":27127,"arcs":[[1118,1119,1120,1121,-1023,-1043]]},{"type":"Polygon","id":55097,"arcs":[[1122,1123,1124,1125,-941]]},{"type":"Polygon","id":55141,"arcs":[[-1126,1126,1127,1128,-960,-942]]},{"type":"MultiPolygon","id":55009,"arcs":[[[-857,1129]],[[-859,1130,1131,1132,1133,1134,-963]]]},{"type":"Polygon","id":55091,"arcs":[[-1062,1135,1136,-1114,-1048,-919]]},{"type":"Polygon","id":55135,"arcs":[[1137,1138,1139,-1123,-965]]},{"type":"Polygon","id":55061,"arcs":[[1140,1141,-1132,1142,1143]]},{"type":"Polygon","id":56039,"arcs":[[1144,1145,1146,1147,1148,-1096,-630,-989]]},{"type":"Polygon","id":46005,"arcs":[[-934,1149,1150,1151,-1037,-908]]},{"type":"Polygon","id":27081,"arcs":[[1152,1153,1154,-1019,-1025]]},{"type":"Polygon","id":27083,"arcs":[[-1122,1155,1156,-1153,-1024]]},{"type":"Polygon","id":46081,"arcs":[[-959,1157,1158,-1008,-914]]},{"type":"Polygon","id":55011,"arcs":[[-1061,1159,1160,1161,-1136]]},{"type":"Polygon","id":55121,"arcs":[[1162,1163,1164,-1160,-1060]]},{"type":"Polygon","id":55053,"arcs":[[-961,-1129,1165,1166,1167,-1163,-1059]]},{"type":"Polygon","id":55087,"arcs":[[-964,-1135,1168,1169,-1138]]},{"type":"Polygon","id":16033,"arcs":[[-1100,1170,1171,-787,-714]]},{"type":"Polygon","id":56019,"arcs":[[-1002,1172,1173,1174,-997,-1004]]},{"type":"Polygon","id":41013,"arcs":[[-952,-1012,1175,1176,-1067]]},{"type":"Polygon","id":46065,"arcs":[[-1036,1177,-1081,-1031]]},{"type":"Polygon","id":36031,"arcs":[[1178,1179,1180,1181,-1005,-979,-1106]]},{"type":"Polygon","id":27079,"arcs":[[1182,1183,1184,1185,-1112,-1071]]},{"type":"Polygon","id":27131,"arcs":[[-1028,-1118,1186,1187,1188,-1183,-1070]]},{"type":"Polygon","id":46077,"arcs":[[-1074,1189,1190,1191,1192,-1150,-933]]},{"type":"Polygon","id":46011,"arcs":[[-1155,1193,1194,1195,-1190,-1073,-1020]]},{"type":"Polygon","id":26101,"arcs":[[1196,1197,1198,1199,-1086]]},{"type":"Polygon","id":26165,"arcs":[[1200,1201,1202,-1197,1203]]},{"type":"Polygon","id":26143,"arcs":[[1204,1205,1206,1207,-1058]]},{"type":"Polygon","id":26113,"arcs":[[-1208,1208,1209,-1201,-1055]]},{"type":"Polygon","id":26069,"arcs":[[1210,1211,1212,-1051]]},{"type":"Polygon","id":26129,"arcs":[[-1213,1213,1214,-1205,-1063]]},{"type":"Polygon","id":16045,"arcs":[[-912,1215,1216,1217,1218,-1064,-888]]},{"type":"Polygon","id":46103,"arcs":[[-1103,1219,1220,1221,1222,-1158,-958]]},{"type":"Polygon","id":50023,"arcs":[[1223,1224,-1104,-1076,-1091]]},{"type":"Polygon","id":27015,"arcs":[[1225,1226,1227,1228,-1119,-1042]]},{"type":"Polygon","id":23001,"arcs":[[1229,1230,-862,-794,-1111]]},{"type":"Polygon","id":27103,"arcs":[[1231,-1226,-1041,-1113,-1186]]},{"type":"Polygon","id":27157,"arcs":[[-1137,-1162,1232,1233,-1115]]},{"type":"Polygon","id":41045,"arcs":[[-1066,1234,1235,1236,1237,1238,-1010,-946]]},{"type":"Polygon","id":33009,"arcs":[[1239,1240,1241,1242,1243,1244,-1089,-971,-874]]},{"type":"Polygon","id":41017,"arcs":[[-1177,1245,1246,1247,1248,-1078,-1068]]},{"type":"MultiPolygon","id":36045,"arcs":[[[1249,-994,1250,1251,1252,1253,1254]]]},{"type":"MultiPolygon","id":23013,"arcs":[[[1255,1256,-1093]]]},{"type":"Polygon","id":16015,"arcs":[[-1047,1257,1258,-1216,-911]]},{"type":"MultiPolygon","id":23015,"arcs":[[[-1094,-1257,1259,1260,1261,-1108]]]},{"type":"Polygon","id":55071,"arcs":[[-1142,1262,1263,1264,-1133]]},{"type":"Polygon","id":50001,"arcs":[[-1225,1265,1266,1267,1268,-1179,-1105]]},{"type":"MultiPolygon","id":41039,"arcs":[[[-1249,1269,1270,1271,-955,-1107,-1079]]]},{"type":"Polygon","id":33003,"arcs":[[-865,1272,1273,1274,-1240,-873]]},{"type":"Polygon","id":27013,"arcs":[[-1185,1275,1276,1277,1278,-1227,-1232]]},{"type":"Polygon","id":55057,"arcs":[[1279,1280,1281,1282,-1166,-1128]]},{"type":"Polygon","id":55001,"arcs":[[-1125,1283,1284,1285,-1280,-1127]]},{"type":"Polygon","id":55137,"arcs":[[-1140,1286,1287,1288,-1284,-1124]]},{"type":"Polygon","id":55139,"arcs":[[1289,1290,1291,-1287,-1139,-1170]]},{"type":"Polygon","id":55015,"arcs":[[-1134,-1265,1292,1293,-1290,-1169]]},{"type":"Polygon","id":16023,"arcs":[[-1172,1294,1295,1296,-1044,-788]]},{"type":"Polygon","id":50017,"arcs":[[-1245,1297,-1266,-1224,-1090]]},{"type":"Polygon","id":36049,"arcs":[[1298,1299,-1251,-993,1300]]},{"type":"Polygon","id":46085,"arcs":[[1301,1302,1303,1304,1305,-1082,-1178,-1035,1306]]},{"type":"Polygon","id":27117,"arcs":[[-1157,1307,1308,1309,-1194,-1154]]},{"type":"Polygon","id":27101,"arcs":[[-1121,1310,1311,1312,-1308,-1156]]},{"type":"Polygon","id":46073,"arcs":[[-1152,1313,1314,1315,1316,-1038]]},{"type":"Polygon","id":27147,"arcs":[[1317,1318,1319,1320,-1188]]},{"type":"Polygon","id":27039,"arcs":[[1321,1322,-1318,-1187,-1117]]},{"type":"Polygon","id":46101,"arcs":[[-1310,1323,1324,-1195]]},{"type":"Polygon","id":27161,"arcs":[[-1321,1325,1326,-1276,-1184,-1189]]},{"type":"Polygon","id":46017,"arcs":[[-1317,1327,-1307,-1034,-1039]]},{"type":"Polygon","id":46111,"arcs":[[-1193,1328,1329,1330,1331,-1314,-1151]]},{"type":"Polygon","id":27109,"arcs":[[-1234,1332,1333,1334,-1322,-1116]]},{"type":"Polygon","id":27033,"arcs":[[-1229,1335,1336,1337,-1311,-1120]]},{"type":"Polygon","id":46079,"arcs":[[-1196,-1325,1338,1339,1340,-1191]]},{"type":"Polygon","id":46097,"arcs":[[-1341,1341,1342,-1329,-1192]]},{"type":"Polygon","id":27169,"arcs":[[-1161,-1165,1343,1344,1345,-1333,-1233]]},{"type":"Polygon","id":56045,"arcs":[[-1159,-1223,1346,1347,1348,-1000,-1009]]},{"type":"Polygon","id":26105,"arcs":[[1349,1350,1351,-1199]]},{"type":"MultiPolygon","id":23005,"arcs":[[[-1231,1352,1353,1354,1355,1356,-863]]]},{"type":"Polygon","id":46075,"arcs":[[-1306,1357,1358,-1101,-1083]]},{"type":"Polygon","id":56043,"arcs":[[-1175,1359,1360,1361,-986,-998]]},{"type":"MultiPolygon","id":23023,"arcs":[[[-1355,1362]],[[1363,1364,-1261,1365]],[[1366,-1353,-1230,-1110]]]},{"type":"Polygon","id":26085,"arcs":[[-1198,-1203,1367,1368,-1350]]},{"type":"Polygon","id":26133,"arcs":[[-1210,1369,1370,-1368,-1202]]},{"type":"Polygon","id":26035,"arcs":[[-1207,1371,1372,-1370,-1209]]},{"type":"Polygon","id":26051,"arcs":[[1373,1374,1375,-1372,-1206,-1215]]},{"type":"Polygon","id":55081,"arcs":[[-1283,1376,1377,-1167]]},{"type":"Polygon","id":16075,"arcs":[[-1219,1378,-1235,-1065]]},{"type":"Polygon","id":36041,"arcs":[[1379,1380,1381,1382,-991,-1006,-1182]]},{"type":"Polygon","id":27165,"arcs":[[-1279,1383,1384,-1336,-1228]]},{"type":"Polygon","id":16039,"arcs":[[-1046,1385,1386,1387,1388,1389,1390,-1258]]},{"type":"Polygon","id":36043,"arcs":[[-1383,1391,1392,1393,1394,-1301,-992]]},{"type":"Polygon","id":55063,"arcs":[[-1168,-1378,1395,1396,-1344,-1164]]},{"type":"Polygon","id":56017,"arcs":[[-1362,1397,-987]]},{"type":"Polygon","id":16051,"arcs":[[-1099,1398,1399,1400,-1295,-1171]]},{"type":"Polygon","id":41025,"arcs":[[-1239,1401,1402,1403,-1246,-1176,-1011]]},{"type":"Polygon","id":56013,"arcs":[[-1398,-1361,1404,1405,1406,1407,-1145,-988]]},{"type":"Polygon","id":26017,"arcs":[[1408,1409,1410,1411,-1375,1412]]},{"type":"Polygon","id":46071,"arcs":[[-1359,1413,1414,1415,-1220,-1102]]},{"type":"Polygon","id":16013,"arcs":[[-1297,1416,1417,1418,1419,1420,1421,-1386,-1045]]},{"type":"Polygon","id":16081,"arcs":[[-1149,1422,1423,-1097]]},{"type":"Polygon","id":55047,"arcs":[[-1292,1424,1425,1426,1427,-1288]]},{"type":"Polygon","id":55077,"arcs":[[-1428,1428,-1285,-1289]]},{"type":"Polygon","id":50027,"arcs":[[-1244,1429,1430,1431,1432,-1267,-1298]]},{"type":"MultiPolygon","id":41019,"arcs":[[[1433,1434,1435,1436,1437,1438,-1271]]]},{"type":"Polygon","id":55039,"arcs":[[1439,1440,1441,-1425,-1291,-1294]]},{"type":"Polygon","id":46003,"arcs":[[-1332,1442,1443,1444,1445,-1315]]},{"type":"Polygon","id":46015,"arcs":[[-1446,1446,-1302,-1328,-1316]]},{"type":"Polygon","id":16065,"arcs":[[-1424,1447,-1399,-1098]]},{"type":"Polygon","id":55117,"arcs":[[1448,1449,1450,-1440,-1293,-1264]]},{"type":"Polygon","id":16027,"arcs":[[-1218,1451,1452,-1236,-1379]]},{"type":"Polygon","id":46095,"arcs":[[-1305,1453,1454,-1414,-1358]]},{"type":"Polygon","id":16025,"arcs":[[1455,1456,-1387,-1422]]},{"type":"Polygon","id":50021,"arcs":[[1457,1458,-1268,-1433]]},{"type":"Polygon","id":46033,"arcs":[[1459,1460,1461,-1347,-1222]]},{"type":"Polygon","id":27133,"arcs":[[-1313,1462,1463,1464,-1309]]},{"type":"Polygon","id":27105,"arcs":[[-1338,1465,1466,1467,-1463,-1312]]},{"type":"Polygon","id":27047,"arcs":[[1468,1469,1470,1471,-1326,-1320]]},{"type":"Polygon","id":27099,"arcs":[[-1335,1472,1473,1474,1475,-1469,-1319,-1323]]},{"type":"Polygon","id":27055,"arcs":[[-1397,1476,1477,1478,1479,-1345]]},{"type":"Polygon","id":46035,"arcs":[[1480,1481,1482,-1443,-1331]]},{"type":"Polygon","id":46061,"arcs":[[-1343,1483,1484,-1481,-1330]]},{"type":"Polygon","id":27045,"arcs":[[-1346,-1480,1485,1486,-1473,-1334]]},{"type":"Polygon","id":27063,"arcs":[[-1385,1487,1488,1489,1490,-1466,-1337]]},{"type":"Polygon","id":27043,"arcs":[[-1327,-1472,1491,1492,1493,-1277]]},{"type":"Polygon","id":46099,"arcs":[[1494,1495,1496,1497,-1339,-1324,-1465]]},{"type":"Polygon","id":27091,"arcs":[[-1278,-1494,1498,1499,-1488,-1384]]},{"type":"Polygon","id":46087,"arcs":[[-1340,-1498,1500,1501,-1484,-1342]]},{"type":"Polygon","id":26111,"arcs":[[-1412,1502,1503,1504,-1376]]},{"type":"Polygon","id":26127,"arcs":[[1505,1506,1507,-1351]]},{"type":"Polygon","id":26073,"arcs":[[-1505,1508,1509,1510,-1373]]},{"type":"MultiPolygon","id":23031,"arcs":[[[1511,1512,-1273,-864,-1357]]]},{"type":"Polygon","id":26107,"arcs":[[-1511,1513,1514,-1371]]},{"type":"Polygon","id":26123,"arcs":[[-1515,1515,1516,1517,-1506,-1369]]},{"type":"Polygon","id":36115,"arcs":[[-1459,1518,1519,1520,1521,-1180,-1269]]},{"type":"Polygon","id":16001,"arcs":[[-1259,-1391,1522,-1452,-1217]]},{"type":"Polygon","id":36113,"arcs":[[1523,-1380,-1181,-1522]]},{"type":"Polygon","id":46123,"arcs":[[1524,1525,1526,-1454,-1304]]},{"type":"Polygon","id":33001,"arcs":[[1527,1528,-1241,-1275]]},{"type":"Polygon","id":26157,"arcs":[[1529,1530,1531,1532,1533,-1410,1534]]},{"type":"Polygon","id":55123,"arcs":[[1535,1536,1537,1538,-1477,-1396,-1377,-1282]]},{"type":"MultiPolygon","id":36075,"arcs":[[[-1254,1539]],[[-1300,1540,1541,1542,1543,1544,-1252]]]},{"type":"Polygon","id":46113,"arcs":[[1545,1546,1547,1548,-1460,-1221,-1416]]},{"type":"Polygon","id":26151,"arcs":[[1549,1550,-1531,1551,1552]]},{"type":"Polygon","id":16073,"arcs":[[-1523,-1390,1553,1554,1555,-1237,-1453]]},{"type":"Polygon","id":55021,"arcs":[[1556,1557,1558,-1286,-1429,-1427]]},{"type":"Polygon","id":55111,"arcs":[[-1559,1559,1560,1561,-1536,-1281]]},{"type":"Polygon","id":55027,"arcs":[[1562,1563,1564,1565,-1557,-1426,-1442]]},{"type":"Polygon","id":16019,"arcs":[[-1448,-1423,-1148,1566,1567,1568,-1400]]},{"type":"Polygon","id":16011,"arcs":[[1569,1570,1571,-1417,-1296,-1401,-1569]]},{"type":"Polygon","id":41035,"arcs":[[1572,1573,1574,1575,-1434,-1270,-1248]]},{"type":"Polygon","id":41037,"arcs":[[1576,1577,-1573,-1247,-1404]]},{"type":"Polygon","id":36065,"arcs":[[1578,1579,-1541,-1299,-1395]]},{"type":"Polygon","id":33013,"arcs":[[-1529,1580,1581,1582,1583,-1242]]},{"type":"MultiPolygon","id":41011,"arcs":[[[1584,1585,-1438]]]},{"type":"Polygon","id":33019,"arcs":[[-1584,1586,1587,1588,-1430,-1243]]},{"type":"Polygon","id":33017,"arcs":[[-1513,1589,1590,-1581,-1528,-1274]]},{"type":"Polygon","id":26145,"arcs":[[-1534,1591,1592,1593,-1503,-1411]]},{"type":"Polygon","id":55103,"arcs":[[1594,1595,1596,-1537,-1562]]},{"type":"Polygon","id":55089,"arcs":[[1597,1598,1599,-1450]]},{"type":"Polygon","id":55131,"arcs":[[-1451,-1600,1600,-1563,-1441]]},{"type":"Polygon","id":19189,"arcs":[[1601,1602,1603,-1492,-1471]]},{"type":"Polygon","id":19109,"arcs":[[1604,1605,1606,-1499,-1493,-1604,1607]]},{"type":"Polygon","id":19059,"arcs":[[1608,1609,-1490,1610]]},{"type":"Polygon","id":19063,"arcs":[[1611,-1611,-1489,-1500,-1607]]},{"type":"Polygon","id":19195,"arcs":[[1612,-1602,-1470,-1476,1613]]},{"type":"Polygon","id":19143,"arcs":[[1614,1615,-1467,-1491,-1610]]},{"type":"Polygon","id":56027,"arcs":[[-1462,1616,1617,1618,1619,1620,-1348]]},{"type":"Polygon","id":19131,"arcs":[[1621,1622,-1614,-1475,1623]]},{"type":"Polygon","id":19119,"arcs":[[1624,1625,-1495,-1464,-1468,-1616]]},{"type":"Polygon","id":19089,"arcs":[[1626,1627,-1624,-1474,-1487]]},{"type":"Polygon","id":19005,"arcs":[[-1539,1628,1629,1630,-1478]]},{"type":"Polygon","id":19191,"arcs":[[1631,1632,-1627,-1486,-1479,-1631]]},{"type":"Polygon","id":46083,"arcs":[[-1626,1633,1634,1635,1636,-1496]]},{"type":"Polygon","id":56009,"arcs":[[-1621,1637,1638,1639,1640,-1173,-1001,-1349]]},{"type":"Polygon","id":46023,"arcs":[[-1445,1641,1642,1643,1644,1645,1646,-1447]]},{"type":"Polygon","id":46125,"arcs":[[-1497,-1637,1647,1648,1649,-1501]]},{"type":"Polygon","id":46067,"arcs":[[-1502,-1650,1650,1651,-1643,1652,-1482,-1485]]},{"type":"Polygon","id":56025,"arcs":[[-1174,-1641,1653,-1405,-1360]]},{"type":"Polygon","id":46043,"arcs":[[-1483,-1653,-1642,-1444]]},{"type":"Polygon","id":46053,"arcs":[[-1647,1654,1655,-1525,-1303]]},{"type":"Polygon","id":46047,"arcs":[[-1549,1656,1657,-1617,-1461]]},{"type":"Polygon","id":26121,"arcs":[[-1518,1658,1659,1660,-1507]]},{"type":"Polygon","id":26117,"arcs":[[-1510,1661,1662,1663,-1516,-1514]]},{"type":"Polygon","id":56035,"arcs":[[1664,1665,-1146,-1408]]},{"type":"Polygon","id":26057,"arcs":[[-1504,-1594,1666,1667,-1662,-1509]]},{"type":"Polygon","id":55023,"arcs":[[-1597,1668,1669,-1629,-1538]]},{"type":"Polygon","id":36011,"arcs":[[1670,1671,1672,1673,1674,1675,-1544]]},{"type":"Polygon","id":36091,"arcs":[[-1521,1676,1677,1678,1679,1680,-1381,-1524]]},{"type":"Polygon","id":46007,"arcs":[[1681,1682,-1546,-1415]]},{"type":"Polygon","id":46121,"arcs":[[-1527,1683,-1682,-1455]]},{"type":"Polygon","id":36073,"arcs":[[1684,1685,1686,1687]]},{"type":"Polygon","id":36063,"arcs":[[-1687,1688,1689,1690]]},{"type":"Polygon","id":36055,"arcs":[[1691,1692,1693,1694,-1685,1695]]},{"type":"MultiPolygon","id":36117,"arcs":[[[1696,1697,-1692,1698,-1675]]]},{"type":"Polygon","id":26087,"arcs":[[1699,1700,1701,1702,-1532,-1551]]},{"type":"Polygon","id":56023,"arcs":[[-1666,1703,1704,1705,1706,1707,-1567,-1147]]},{"type":"Polygon","id":50003,"arcs":[[-1432,1708,1709,1710,1711,-1519,-1458]]},{"type":"Polygon","id":55025,"arcs":[[-1566,1712,1713,1714,1715,-1560,-1558]]},{"type":"Polygon","id":26081,"arcs":[[1716,1717,1718,1719,-1659,-1517,-1664]]},{"type":"Polygon","id":36035,"arcs":[[-1681,1720,-1392,-1382]]},{"type":"MultiPolygon","id":33015,"arcs":[[[1721,1722,1723,-1582,-1591]]]},{"type":"Polygon","id":36067,"arcs":[[1724,1725,-1671,-1543]]},{"type":"Polygon","id":50025,"arcs":[[-1589,1726,1727,-1709,-1431]]},{"type":"Polygon","id":19167,"arcs":[[1728,1729,1730,-1634,-1625]]},{"type":"Polygon","id":19141,"arcs":[[1731,1732,-1729,-1615]]},{"type":"Polygon","id":19033,"arcs":[[-1623,1733,1734,1735,-1613]]},{"type":"Polygon","id":19081,"arcs":[[-1736,1736,-1608,-1603]]},{"type":"Polygon","id":19147,"arcs":[[-1606,1737,1738,-1612]]},{"type":"Polygon","id":19041,"arcs":[[-1739,1739,-1732,-1609]]},{"type":"Polygon","id":26049,"arcs":[[-1703,1740,1741,1742,-1592,-1533]]},{"type":"Polygon","id":19037,"arcs":[[-1633,1743,1744,1745,-1628]]},{"type":"Polygon","id":19067,"arcs":[[-1746,1746,-1734,-1622]]},{"type":"Polygon","id":55049,"arcs":[[-1561,-1716,1747,1748,1749,-1595]]},{"type":"Polygon","id":55043,"arcs":[[-1750,1750,1751,1752,1753,-1669,-1596]]},{"type":"Polygon","id":33011,"arcs":[[-1724,1754,1755,1756,1757,-1587,-1583]]},{"type":"Polygon","id":26139,"arcs":[[-1720,1758,1759,-1660]]},{"type":"Polygon","id":16063,"arcs":[[1760,1761,1762,-1456,-1421]]},{"type":"Polygon","id":16047,"arcs":[[-1763,1763,1764,-1388,-1457]]},{"type":"Polygon","id":55055,"arcs":[[1765,1766,1767,-1713,-1565]]},{"type":"Polygon","id":16067,"arcs":[[1768,1769,-1761,-1420]]},{"type":"Polygon","id":55133,"arcs":[[-1601,1770,1771,1772,-1766,-1564]]},{"type":"Polygon","id":55079,"arcs":[[1773,1774,-1771,-1599]]},{"type":"Polygon","id":36053,"arcs":[[-1580,1775,1776,1777,-1725,-1542]]},{"type":"Polygon","id":33005,"arcs":[[-1758,1778,1779,-1727,-1588]]},{"type":"Polygon","id":46135,"arcs":[[1780,1781,1782,1783,-1651,-1649]]},{"type":"Polygon","id":46009,"arcs":[[-1784,1784,-1644,-1652]]},{"type":"Polygon","id":26155,"arcs":[[-1743,1785,1786,1787,-1667,-1593]]},{"type":"Polygon","id":36037,"arcs":[[1788,1789,1790,-1689,-1686,-1695]]},{"type":"Polygon","id":26067,"arcs":[[1791,1792,1793,-1717,-1663]]},{"type":"Polygon","id":26037,"arcs":[[-1788,1794,1795,-1792,-1668]]},{"type":"Polygon","id":16077,"arcs":[[-1572,1796,1797,1798,-1418]]},{"type":"MultiPolygon","id":36029,"arcs":[[[1799]],[[-1791,1800,1801,1802,1803,-1690]]]},{"type":"Polygon","id":46127,"arcs":[[-1731,1804,1805,1806,1807,1808,-1635]]},{"type":"Polygon","id":46027,"arcs":[[-1809,1809,1810,-1781,-1648,-1636]]},{"type":"Polygon","id":19065,"arcs":[[1811,1812,1813,-1744,-1632]]},{"type":"Polygon","id":19043,"arcs":[[-1670,-1754,1814,1815,-1812,-1630]]},{"type":"Polygon","id":36057,"arcs":[[-1680,1816,1817,1818,-1393,-1721]]},{"type":"Polygon","id":36069,"arcs":[[1819,1820,1821,1822,-1693,-1698]]},{"type":"Polygon","id":16005,"arcs":[[1823,1824,1825,-1797,-1571]]},{"type":"Polygon","id":16029,"arcs":[[-1568,-1708,1826,1827,-1824,-1570]]},{"type":"Polygon","id":36099,"arcs":[[1828,1829,1830,-1820,-1697,-1674]]},{"type":"Polygon","id":31165,"arcs":[[1831,1832,1833,-1618,-1658,1834]]},{"type":"Polygon","id":31161,"arcs":[[1835,1836,1837,1838,1839,-1547,1840]]},{"type":"Polygon","id":31045,"arcs":[[1841,-1835,-1657,-1548,-1840]]},{"type":"Polygon","id":31015,"arcs":[[1842,1843,1844,-1655,-1646]]},{"type":"Polygon","id":31103,"arcs":[[-1845,1845,1846,1847,-1526,-1656]]},{"type":"Polygon","id":31031,"arcs":[[-1684,-1848,1848,1849,1850,1851,1852,-1841,-1683]]},{"type":"Polygon","id":41029,"arcs":[[-1576,1853,1854,-1435]]},{"type":"Polygon","id":36051,"arcs":[[-1823,1855,1856,1857,-1789,-1694]]},{"type":"Polygon","id":36083,"arcs":[[-1712,1858,1859,1860,-1677,-1520]]},{"type":"Polygon","id":36093,"arcs":[[1861,1862,-1817,-1679]]},{"type":"Polygon","id":41015,"arcs":[[-1437,1863,1864,1865,-1585]]},{"type":"Polygon","id":16083,"arcs":[[1866,1867,1868,-1554,-1389,-1765]]},{"type":"Polygon","id":19149,"arcs":[[1869,1870,-1805,-1730]]},{"type":"Polygon","id":19021,"arcs":[[1871,1872,1873,-1740]]},{"type":"Polygon","id":19035,"arcs":[[-1874,1874,1875,-1870,-1733]]},{"type":"Polygon","id":19151,"arcs":[[1876,1877,1878,-1872,-1738]]},{"type":"Polygon","id":19197,"arcs":[[1879,1880,1881,1882,-1737]]},{"type":"Polygon","id":19091,"arcs":[[-1883,1883,-1877,-1605]]},{"type":"Polygon","id":19069,"arcs":[[1884,1885,-1880,-1735]]},{"type":"Polygon","id":19023,"arcs":[[1886,1887,1888,-1885,-1747]]},{"type":"Polygon","id":19017,"arcs":[[-1814,1889,-1887,-1745]]},{"type":"Polygon","id":36077,"arcs":[[-1819,1890,1891,1892,-1776,-1579,-1394]]},{"type":"Polygon","id":31089,"arcs":[[1893,1894,1895,1896,1897,1898,-1844]]},{"type":"Polygon","id":26099,"arcs":[[1899,1900,1901,-1701,1902]]},{"type":"Polygon","id":26125,"arcs":[[1903,1904,1905,-1741,-1702,-1902]]},{"type":"MultiPolygon","id":25009,"arcs":[[[1906,1907,1908,-1755,-1723]]]},{"type":"Polygon","id":31107,"arcs":[[-1785,-1783,1909,1910,1911,-1894,-1843,-1645]]},{"type":"Polygon","id":31027,"arcs":[[-1811,1912,1913,1914,-1910,-1782]]},{"type":"Polygon","id":36121,"arcs":[[-1858,1915,1916,-1801,-1790]]},{"type":"Polygon","id":55045,"arcs":[[1917,1918,1919,1920,-1748,-1715]]},{"type":"Polygon","id":16053,"arcs":[[-1770,1921,-1867,-1764,-1762]]},{"type":"Polygon","id":55105,"arcs":[[-1768,1922,1923,1924,-1918,-1714]]},{"type":"Polygon","id":31017,"arcs":[[1925,1926,1927,-1849,-1847]]},{"type":"Polygon","id":55127,"arcs":[[-1773,1928,1929,1930,1931,-1923,-1767]]},{"type":"Polygon","id":55101,"arcs":[[1932,1933,-1929,-1772,-1775]]},{"type":"Polygon","id":36095,"arcs":[[-1863,1934,1935,1936,-1891,-1818]]},{"type":"Polygon","id":36001,"arcs":[[-1861,1937,-1935,-1862,-1678]]},{"type":"Polygon","id":55065,"arcs":[[-1921,1938,1939,-1751,-1749]]},{"type":"Polygon","id":31149,"arcs":[[1940,-1926,-1846,-1899]]},{"type":"Polygon","id":36023,"arcs":[[1941,1942,-1672,-1726,-1778,1943,1944]]},{"type":"Polygon","id":41033,"arcs":[[-1436,-1855,1945,1946,-1864]]},{"type":"Polygon","id":26093,"arcs":[[-1906,1947,1948,1949,-1786,-1742]]},{"type":"Polygon","id":26065,"arcs":[[-1950,1950,1951,-1795,-1787]]},{"type":"Polygon","id":26045,"arcs":[[-1796,-1952,1952,1953,1954,-1793]]},{"type":"Polygon","id":26015,"arcs":[[-1955,1955,1956,1957,-1718,-1794]]},{"type":"Polygon","id":26005,"arcs":[[-1719,-1958,1958,1959,1960,-1759]]},{"type":"Polygon","id":36123,"arcs":[[1961,1962,-1821,-1831]]},{"type":"Polygon","id":31051,"arcs":[[-1808,1963,1964,1965,-1913,-1810]]},{"type":"Polygon","id":25003,"arcs":[[1966,1967,1968,1969,1970,1971,-1859,-1711]]},{"type":"Polygon","id":36017,"arcs":[[-1893,1972,1973,-1944,-1777]]},{"type":"Polygon","id":25011,"arcs":[[1974,-1967,-1710,-1728,-1780,1975]]},{"type":"Polygon","id":25017,"arcs":[[1976,1977,1978,1979,1980,1981,1982,1983,1984,-1756,-1909]]},{"type":"Polygon","id":25027,"arcs":[[-1757,-1985,1985,1986,1987,1988,1989,1990,-1976,-1779]]},{"type":"Polygon","id":16031,"arcs":[[-1799,1991,1992,1993,-1868,-1922,-1769,-1419]]},{"type":"Polygon","id":19061,"arcs":[[1994,1995,1996,1997,-1815,-1753]]},{"type":"Polygon","id":55059,"arcs":[[1998,1999,2000,-1930,-1934]]},{"type":"Polygon","id":19055,"arcs":[[-1998,2001,2002,2003,-1816]]},{"type":"Polygon","id":19187,"arcs":[[-1882,2004,2005,2006,2007,-1878,-1884]]},{"type":"Polygon","id":19019,"arcs":[[-2004,2008,2009,2010,-1813]]},{"type":"Polygon","id":19013,"arcs":[[-2011,2011,2012,2013,-1888,-1890]]},{"type":"Polygon","id":36109,"arcs":[[-1943,2014,2015,2016,-1829,-1673]]},{"type":"Polygon","id":56015,"arcs":[[-1834,2017,2018,2019,2020,-1619]]},{"type":"Polygon","id":56031,"arcs":[[-2021,2021,2022,-1638,-1620]]},{"type":"Polygon","id":16007,"arcs":[[-1707,2023,2024,-1827]]},{"type":"Polygon","id":36101,"arcs":[[-1822,-1963,2025,2026,2027,2028,2029,-1856]]},{"type":"Polygon","id":36013,"arcs":[[2030,2031,2032,2033,-1803]]},{"type":"Polygon","id":19193,"arcs":[[-1876,2034,2035,2036,2037,-1806,-1871]]},{"type":"Polygon","id":19161,"arcs":[[2038,2039,2040,2041,-1873]]},{"type":"Polygon","id":19093,"arcs":[[-2042,2042,-2035,-1875]]},{"type":"Polygon","id":19025,"arcs":[[-2008,2043,2044,-2039,-1879]]},{"type":"Polygon","id":19079,"arcs":[[2045,2046,2047,-2005,-1881]]},{"type":"Polygon","id":19083,"arcs":[[-1886,2048,2049,2050,-2046]]},{"type":"Polygon","id":19075,"arcs":[[-2014,2051,2052,-2049,-1889]]},{"type":"Polygon","id":25015,"arcs":[[-1991,2053,-1968,-1975]]},{"type":"Polygon","id":36097,"arcs":[[-2017,2054,-2026,-1962,-1830]]},{"type":"Polygon","id":36009,"arcs":[[-1917,2055,2056,2057,-2031,-1802]]},{"type":"Polygon","id":31043,"arcs":[[-1807,-2038,2058,-1964]]},{"type":"Polygon","id":36003,"arcs":[[-1857,-2030,2059,2060,-2056,-1916]]},{"type":"Polygon","id":36025,"arcs":[[-1937,2061,2062,2063,2064,2065,-1973,-1892]]},{"type":"Polygon","id":17085,"arcs":[[-1940,2066,2067,2068,-1995,-1752]]},{"type":"Polygon","id":36021,"arcs":[[2069,2070,2071,-1860,-1972]]},{"type":"Polygon","id":17177,"arcs":[[2072,-2067,-1939,-1920,2073,2074]]},{"type":"Polygon","id":17201,"arcs":[[2075,2076,-2074,-1919,-1925]]},{"type":"Polygon","id":16071,"arcs":[[-1826,2077,2078,2079,-1992,-1798]]},{"type":"Polygon","id":17111,"arcs":[[2080,2081,2082,2083,2084,-1931,-2001]]},{"type":"Polygon","id":17007,"arcs":[[-1932,-2085,2085,-2076,-1924]]},{"type":"Polygon","id":17097,"arcs":[[2086,-2081,-2000,2087]]},{"type":"Polygon","id":36039,"arcs":[[2088,-2062,-1936,-1938,-2072]]},{"type":"MultiPolygon","id":25025,"arcs":[[[2089,2090,-1983,2091,-1981]],[[-1979,2092]],[[2093,-1977,-1908]]]},{"type":"Polygon","id":31139,"arcs":[[2094,2095,2096,-1911,-1915]]},{"type":"Polygon","id":31013,"arcs":[[2097,2098,-1832,-1842,-1839]]},{"type":"Polygon","id":31003,"arcs":[[-2097,2099,2100,2101,-1895,-1912]]},{"type":"Polygon","id":26161,"arcs":[[2102,2103,2104,-1948,-1905,2105]]},{"type":"Polygon","id":56007,"arcs":[[-1640,2106,2107,2108,2109,2110,-1406,-1654]]},{"type":"Polygon","id":56001,"arcs":[[-2023,2111,2112,2113,-2107,-1639]]},{"type":"Polygon","id":16041,"arcs":[[-2025,2114,-2078,-1825,-1828]]},{"type":"Polygon","id":26075,"arcs":[[-1949,-2105,2115,2116,2117,-1953,-1951]]},{"type":"Polygon","id":26025,"arcs":[[-2118,2118,2119,2120,-1956,-1954]]},{"type":"Polygon","id":26159,"arcs":[[2121,2122,2123,2124,-1960]]},{"type":"Polygon","id":26077,"arcs":[[-2121,2125,-2122,-1959,-1957]]},{"type":"Polygon","id":36007,"arcs":[[-2066,2126,2127,2128,-1945,-1974]]},{"type":"Polygon","id":36107,"arcs":[[-2129,2129,2130,2131,-2015,-1942]]},{"type":"Polygon","id":19097,"arcs":[[-2069,2132,2133,2134,-1996]]},{"type":"Polygon","id":31179,"arcs":[[-1966,2135,2136,2137,-2095,-1914]]},{"type":"MultiPolygon","id":25021,"arcs":[[[2138,2139]],[[-2091,2140,2141,2142,2143,-1986,-1984]],[[-1982,-2092]]]},{"type":"Polygon","id":25013,"arcs":[[-1990,2144,2145,2146,-1969,-2054]]},{"type":"MultiPolygon","id":25023,"arcs":[[[-2140,2147,2148,2149,2150,-2142,2151]]]},{"type":"Polygon","id":19011,"arcs":[[2152,2153,2154,-2012,-2010]]},{"type":"Polygon","id":19113,"arcs":[[-2003,2155,2156,2157,-2153,-2009]]},{"type":"Polygon","id":19171,"arcs":[[-2155,2158,2159,-2052,-2013]]},{"type":"Polygon","id":19105,"arcs":[[-1997,-2135,2160,2161,-2156,-2002]]},{"type":"Polygon","id":36015,"arcs":[[-2016,-2132,2162,2163,-2027,-2055]]},{"type":"Polygon","id":31173,"arcs":[[-2037,2164,2165,2166,-2136,-1965,-2059]]},{"type":"Polygon","id":56037,"arcs":[[-1407,-2111,2167,2168,2169,2170,-1704,-1665]]},{"type":"Polygon","id":42049,"arcs":[[2171,2172,2173,2174,-2033]]},{"type":"Polygon","id":26021,"arcs":[[2175,2176,2177,2178,-2124]]},{"type":"Polygon","id":19133,"arcs":[[2179,2180,2181,-2165,-2036]]},{"type":"Polygon","id":19127,"arcs":[[-2160,2182,2183,-2050,-2053]]},{"type":"Polygon","id":19027,"arcs":[[-2045,2184,2185,2186,2187,-2040]]},{"type":"Polygon","id":19047,"arcs":[[-2043,-2041,-2188,2188,2189,-2180]]},{"type":"Polygon","id":19015,"arcs":[[-2048,2190,2191,2192,2193,-2006]]},{"type":"Polygon","id":19073,"arcs":[[-2194,2194,2195,-2185,-2044,-2007]]},{"type":"Polygon","id":19169,"arcs":[[-2051,-2184,2196,2197,-2191,-2047]]},{"type":"Polygon","id":17141,"arcs":[[2198,2199,2200,2201,-2075,-2077]]},{"type":"Polygon","id":17015,"arcs":[[-2202,2202,2203,-2133,-2068,-2073]]},{"type":"Polygon","id":36111,"arcs":[[-2071,2204,2205,2206,-2063,-2089]]},{"type":"Polygon","id":17031,"arcs":[[-2087,2207,2208,2209,2210,2211,-2082]]},{"type":"Polygon","id":17037,"arcs":[[2212,2213,2214,2215,-2199,-2086,-2084]]},{"type":"Polygon","id":17089,"arcs":[[-2212,2216,2217,-2213,-2083]]},{"type":"Polygon","id":31075,"arcs":[[2218,2219,2220,-1836,-1853]]},{"type":"MultiPolygon","id":25005,"arcs":[[[2221,2222,2223,2224,2225,-2143,-2151]]]},{"type":"Polygon","id":31091,"arcs":[[2226,2227,2228,-2219,-1852]]},{"type":"Polygon","id":31039,"arcs":[[-2167,2229,2230,2231,2232,-2137]]},{"type":"Polygon","id":31119,"arcs":[[2233,2234,2235,-2100,-2096]]},{"type":"Polygon","id":31167,"arcs":[[-2233,2236,2237,-2234,-2138]]},{"type":"Polygon","id":31171,"arcs":[[2238,2239,2240,-2227,-1851]]},{"type":"Polygon","id":31183,"arcs":[[2241,2242,2243,2244,-1896,-2102]]},{"type":"Polygon","id":31009,"arcs":[[-1850,-1928,2245,2246,2247,-2239]]},{"type":"Polygon","id":31115,"arcs":[[2248,2249,-2246,-1927,-1941,-1898]]},{"type":"Polygon","id":31071,"arcs":[[-2245,2250,2251,-2249,-1897]]},{"type":"Polygon","id":26091,"arcs":[[2252,2253,2254,2255,-2116,-2104]]},{"type":"Polygon","id":36027,"arcs":[[-1971,2256,2257,2258,2259,-2205,-2070]]},{"type":"MultiPolygon","id":25001,"arcs":[[[2260,-2149,2261]]]},{"type":"Polygon","id":26023,"arcs":[[2262,2263,2264,2265,-2120]]},{"type":"Polygon","id":26059,"arcs":[[-2256,2266,2267,2268,-2263,-2119,-2117]]},{"type":"Polygon","id":26149,"arcs":[[-2266,2269,2270,2271,-2126]]},{"type":"Polygon","id":26027,"arcs":[[-2272,2272,2273,-2176,-2123]]},{"type":"Polygon","id":9005,"arcs":[[-2147,2274,2275,2276,-2257,-1970]]},{"type":"Polygon","id":31021,"arcs":[[2277,2278,2279,-2230,-2166,-2182]]},{"type":"Polygon","id":9003,"arcs":[[2280,2281,2282,2283,-2275,-2146]]},{"type":"Polygon","id":9013,"arcs":[[-1989,2284,2285,-2281,-2145]]},{"type":"Polygon","id":19045,"arcs":[[-2204,2286,2287,2288,2289,-2161,-2134]]},{"type":"Polygon","id":9015,"arcs":[[2290,2291,2292,-2285,-1988]]},{"type":"Polygon","id":44007,"arcs":[[-2226,2293,2294,2295,-2291,-1987,-2144]]},{"type":"Polygon","id":36105,"arcs":[[2296,2297,2298,-2064,-2207]]},{"type":"Polygon","id":6093,"arcs":[[-1575,2299,2300,2301,2302,2303,-1946,-1854]]},{"type":"Polygon","id":31069,"arcs":[[-2221,2304,2305,2306,2307,2308,-1837]]},{"type":"Polygon","id":31123,"arcs":[[-2309,2309,2310,2311,-2098,-1838]]},{"type":"Polygon","id":49005,"arcs":[[2312,2313,2314,-2079,-2115]]},{"type":"Polygon","id":31157,"arcs":[[-2312,2315,-2018,-1833,-2099]]},{"type":"Polygon","id":49033,"arcs":[[-1706,2316,2317,2318,2319,-2313,-2024]]},{"type":"Polygon","id":42015,"arcs":[[-2163,-2131,2320,2321,2322,2323,2324]]},{"type":"Polygon","id":42117,"arcs":[[-2164,-2325,2325,2326,-2028]]},{"type":"Polygon","id":49003,"arcs":[[2327,2328,2329,-1993,-2080,-2315]]},{"type":"Polygon","id":32013,"arcs":[[2330,2331,2332,-1402,-1238,-1556,2333]]},{"type":"Polygon","id":32007,"arcs":[[-1994,-2330,2334,2335,2336,2337,-2334,-1555,-1869]]},{"type":"Polygon","id":42083,"arcs":[[-2061,2338,2339,2340,2341,-2057]]},{"type":"Polygon","id":42105,"arcs":[[-2029,-2327,2342,2343,2344,-2339,-2060]]},{"type":"Polygon","id":6015,"arcs":[[-2304,2345,2346,-1865,-1947]]},{"type":"Polygon","id":42127,"arcs":[[-2065,-2299,2347,2348,2349,2350,-2127]]},{"type":"Polygon","id":42115,"arcs":[[2351,2352,-2321,-2130,-2128,-2351]]},{"type":"Polygon","id":42123,"arcs":[[-2342,2353,2354,2355,-2172,-2032,-2058]]},{"type":"Polygon","id":6049,"arcs":[[-1578,2356,2357,2358,-2300,-1574]]},{"type":"Polygon","id":32031,"arcs":[[2359,2360,2361,2362,2363,2364,2365,2366,2367,-2357,-1577,-1403,-2333]]},{"type":"Polygon","id":17043,"arcs":[[2368,2369,-2217,-2211]]},{"type":"Polygon","id":39007,"arcs":[[2370,2371,2372,2373,2374,-2174]]},{"type":"Polygon","id":19031,"arcs":[[-2162,-2290,2375,2376,2377,-2157]]},{"type":"Polygon","id":17195,"arcs":[[-2201,2378,2379,2380,2381,-2287,-2203]]},{"type":"Polygon","id":31011,"arcs":[[-2236,2382,2383,2384,-2242,-2101]]},{"type":"Polygon","id":17103,"arcs":[[-2216,2385,2386,-2379,-2200]]},{"type":"Polygon","id":19085,"arcs":[[-2190,2387,2388,2389,-2278,-2181]]},{"type":"Polygon","id":19095,"arcs":[[2390,2391,2392,2393,-2154]]},{"type":"Polygon","id":19049,"arcs":[[2394,2395,2396,-2195,-2193]]},{"type":"Polygon","id":19165,"arcs":[[2397,2398,2399,-2388,-2189]]},{"type":"Polygon","id":19009,"arcs":[[2400,2401,-2398,-2187]]},{"type":"Polygon","id":19157,"arcs":[[-2394,2402,2403,2404,-2159]]},{"type":"Polygon","id":19153,"arcs":[[-2198,2405,2406,2407,-2395,-2192]]},{"type":"Polygon","id":19099,"arcs":[[-2183,-2405,2408,2409,-2406,-2197]]},{"type":"Polygon","id":19077,"arcs":[[-2397,2410,-2401,-2186,-2196]]},{"type":"Polygon","id":19103,"arcs":[[-2378,2411,2412,2413,-2391,-2158]]},{"type":"Polygon","id":39085,"arcs":[[2414,2415,2416,-2374]]},{"type":"Polygon","id":42039,"arcs":[[-2356,2417,2418,2419,-2371,-2173]]},{"type":"Polygon","id":17161,"arcs":[[2420,2421,2422,2423,2424,-2288,-2382]]},{"type":"Polygon","id":44001,"arcs":[[2425,-2294,-2225]]},{"type":"Polygon","id":19163,"arcs":[[-2425,2426,-2376,-2289]]},{"type":"Polygon","id":44003,"arcs":[[2427,2428,2429,-2292,-2296]]},{"type":"Polygon","id":18039,"arcs":[[2430,2431,2432,2433,2434,-2273,-2271]]},{"type":"Polygon","id":18141,"arcs":[[2435,2436,2437,-2177,-2274,-2435]]},{"type":"Polygon","id":18091,"arcs":[[2438,2439,2440,-2178,-2438]]},{"type":"Polygon","id":18151,"arcs":[[2441,2442,-2264,-2269,2443]]},{"type":"Polygon","id":18087,"arcs":[[2444,-2431,-2270,-2265,-2443]]},{"type":"Polygon","id":31037,"arcs":[[-2232,2445,2446,2447,-2237]]},{"type":"Polygon","id":31141,"arcs":[[-2448,2448,2449,2450,2451,-2383,-2235,-2238]]},{"type":"Polygon","id":31053,"arcs":[[-2280,2452,2453,2454,2455,-2446,-2231]]},{"type":"Polygon","id":31117,"arcs":[[-2241,2456,2457,2458,2459,-2228]]},{"type":"Polygon","id":31005,"arcs":[[-2460,2460,-2305,-2220,-2229]]},{"type":"Polygon","id":31077,"arcs":[[2461,2462,2463,2464,-2243,-2385]]},{"type":"Polygon","id":31041,"arcs":[[-2252,2465,2466,2467,2468,2469,2470,-2247,-2250]]},{"type":"Polygon","id":31113,"arcs":[[-2248,-2471,2471,-2457,-2240]]},{"type":"Polygon","id":31175,"arcs":[[-2244,-2465,2472,-2466,-2251]]},{"type":"MultiPolygon","id":39095,"arcs":[[[2473,2474,2475,2476,-2254,2477,2478,2479,2480,2481,2482]]]},{"type":"Polygon","id":17197,"arcs":[[-2210,2483,2484,2485,2486,-2369]]},{"type":"MultiPolygon","id":39123,"arcs":[[[2487,2488,2489,2490,2491,-2474]]]},{"type":"Polygon","id":17093,"arcs":[[-2487,2492,2493,-2214,-2218,-2370]]},{"type":"Polygon","id":39051,"arcs":[[2494,2495,-2267,-2255,-2477]]},{"type":"Polygon","id":39055,"arcs":[[2496,2497,2498,-2415,-2373]]},{"type":"MultiPolygon","id":9011,"arcs":[[[-2430,2499,2500,2501,-2282,-2286,-2293]]]},{"type":"Polygon","id":18089,"arcs":[[2502,2503,2504,2505,-2484,-2209,2506]]},{"type":"Polygon","id":18127,"arcs":[[2507,-2503,2508,-2440]]},{"type":"Polygon","id":39171,"arcs":[[2509,2510,2511,-2444,-2268,-2496]]},{"type":"Polygon","id":31007,"arcs":[[-2311,2512,2513,2514,-2019,-2316]]},{"type":"Polygon","id":31177,"arcs":[[-2390,2515,2516,-2453,-2279]]},{"type":"MultiPolygon","id":44005,"arcs":[[[2517]],[[2518,-2223]]]},{"type":"MultiPolygon","id":9001,"arcs":[[[2519,2520,2521,2522,-2258,-2277]]]},{"type":"Polygon","id":56021,"arcs":[[-2020,-2515,2523,2524,2525,-2112,-2022]]},{"type":"MultiPolygon","id":44009,"arcs":[[[-2500,-2429,2526]]]},{"type":"Polygon","id":42131,"arcs":[[-2353,2527,2528,2529,-2322]]},{"type":"MultiPolygon","id":9007,"arcs":[[[2530,2531]],[[-2502,2532,2533,-2283]]]},{"type":"Polygon","id":9009,"arcs":[[-2534,2534,-2531,2535,-2520,-2276,-2284]]},{"type":"Polygon","id":42069,"arcs":[[-2350,2536,2537,-2528,-2352]]},{"type":"Polygon","id":36071,"arcs":[[-2260,2538,2539,2540,2541,2542,-2297,-2206]]},{"type":"Polygon","id":17099,"arcs":[[-2494,2543,2544,2545,2546,2547,2548,-2386,-2215]]},{"type":"Polygon","id":39035,"arcs":[[-2499,2549,2550,2551,2552,2553,-2416]]},{"type":"Polygon","id":42047,"arcs":[[2554,2555,2556,2557,-2341]]},{"type":"Polygon","id":42053,"arcs":[[-2558,2558,2559,2560,-2354]]},{"type":"Polygon","id":42121,"arcs":[[2561,2562,2563,-2418,-2355,-2561]]},{"type":"MultiPolygon","id":39043,"arcs":[[[2564,2565,2566,2567]]]},{"type":"Polygon","id":39173,"arcs":[[-2492,2568,2569,2570,2571,-2475]]},{"type":"Polygon","id":42023,"arcs":[[-2345,2572,2573,-2555,-2340]]},{"type":"Polygon","id":42103,"arcs":[[-2543,2574,2575,-2348,-2298]]},{"type":"Polygon","id":19139,"arcs":[[-2377,-2427,-2424,2576,-2412]]},{"type":"Polygon","id":42081,"arcs":[[2577,2578,2579,2580,2581,2582,-2343,-2326,-2324]]},{"type":"Polygon","id":42113,"arcs":[[-2578,-2323,-2530,2583,2584]]},{"type":"Polygon","id":17011,"arcs":[[-2549,2585,2586,2587,2588,-2380,-2387]]},{"type":"Polygon","id":17073,"arcs":[[-2589,2589,2590,2591,-2421,-2381]]},{"type":"Polygon","id":56041,"arcs":[[-2171,2592,-2317,-1705]]},{"type":"Polygon","id":18033,"arcs":[[2593,2594,2595,-2442,-2512]]},{"type":"Polygon","id":18113,"arcs":[[-2596,2596,2597,2598,-2432,-2445]]},{"type":"Polygon","id":31125,"arcs":[[2599,2600,-2462,-2384,-2452]]},{"type":"Polygon","id":36079,"arcs":[[2601,2602,-2539,-2259,-2523,2603]]},{"type":"MultiPolygon","id":25007,"arcs":[[[2604]]]},{"type":"Polygon","id":39093,"arcs":[[-2553,2605,2606,2607,-2565,2608]]},{"type":"Polygon","id":19183,"arcs":[[2609,2610,2611,2612,-2392,-2414]]},{"type":"Polygon","id":19181,"arcs":[[2613,2614,2615,2616,-2408]]},{"type":"Polygon","id":19107,"arcs":[[-2613,2617,2618,2619,-2403,-2393]]},{"type":"Polygon","id":19121,"arcs":[[2620,2621,2622,-2396,-2617]]},{"type":"Polygon","id":19123,"arcs":[[-2620,2623,2624,2625,-2409,-2404]]},{"type":"Polygon","id":19125,"arcs":[[-2626,2626,2627,-2614,-2407,-2410]]},{"type":"Polygon","id":19155,"arcs":[[-2400,2628,2629,2630,2631,2632,-2516,-2389]]},{"type":"Polygon","id":19029,"arcs":[[-2402,2633,2634,2635,-2629,-2399]]},{"type":"Polygon","id":19001,"arcs":[[-2411,-2623,2636,2637,-2634]]},{"type":"Polygon","id":39155,"arcs":[[-2420,2638,2639,2640,-2497,-2372]]},{"type":"MultiPolygon","id":39143,"arcs":[[[-2489,2641]],[[2642,-2567,2643,2644,-2569,-2491]]]},{"type":"Polygon","id":42085,"arcs":[[-2564,2645,2646,2647,-2639,-2419]]},{"type":"Polygon","id":39069,"arcs":[[-2476,-2572,2648,2649,-2510,-2495]]},{"type":"Polygon","id":18099,"arcs":[[-2434,2650,2651,2652,-2436]]},{"type":"Polygon","id":42035,"arcs":[[-2583,2653,2654,2655,-2573,-2344]]},{"type":"MultiPolygon","id":6023,"arcs":[[[-2303,2656,2657,2658,-2346]]]},{"type":"Polygon","id":17063,"arcs":[[2659,2660,-2544,-2493,-2486]]},{"type":"Polygon","id":31023,"arcs":[[-2456,2661,2662,2663,2664,-2449,-2447]]},{"type":"Polygon","id":31155,"arcs":[[2665,2666,2667,2668,-2662,-2455]]},{"type":"Polygon","id":18085,"arcs":[[-2599,2669,2670,2671,-2651,-2433]]},{"type":"Polygon","id":31033,"arcs":[[-2308,2672,2673,2674,2675,-2513,-2310]]},{"type":"Polygon","id":42031,"arcs":[[2676,2677,2678,-2562,-2560]]},{"type":"Polygon","id":49057,"arcs":[[-2314,-2320,2679,2680,-2328]]},{"type":"Polygon","id":18149,"arcs":[[-2653,2681,2682,-2439,-2437]]},{"type":"Polygon","id":42079,"arcs":[[2683,2684,2685,2686,-2584,-2529,-2538]]},{"type":"Polygon","id":39039,"arcs":[[2687,2688,2689,-2594,-2511,-2650]]},{"type":"Polygon","id":19115,"arcs":[[-2577,-2423,2690,2691,2692,-2610,-2413]]},{"type":"Polygon","id":31101,"arcs":[[2693,2694,2695,-2306,-2461,-2459]]},{"type":"Polygon","id":31111,"arcs":[[-2472,-2470,2696,2697,2698,2699,-2694,-2458]]},{"type":"MultiPolygon","id":25019,"arcs":[[[2700]]]},{"type":"Polygon","id":31143,"arcs":[[2701,2702,2703,-2450,-2665]]},{"type":"Polygon","id":31105,"arcs":[[-2676,2704,2705,-2524,-2514]]},{"type":"Polygon","id":31121,"arcs":[[-2704,2706,2707,2708,-2600,-2451]]},{"type":"Polygon","id":31093,"arcs":[[-2601,-2709,2709,2710,2711,-2463]]},{"type":"Polygon","id":31163,"arcs":[[-2464,-2712,2712,-2467,-2473]]},{"type":"Polygon","id":31055,"arcs":[[-2517,-2633,2713,-2666,-2454]]},{"type":"Polygon","id":49029,"arcs":[[2714,2715,2716,-2680,-2319]]},{"type":"Polygon","id":42065,"arcs":[[2717,2718,2719,-2677,-2559,-2557]]},{"type":"Polygon","id":6105,"arcs":[[2720,2721,2722,-2657,-2302]]},{"type":"MultiPolygon","id":36119,"arcs":[[[2723,2724,2725,-2604,-2522,2726]]]},{"type":"Polygon","id":34037,"arcs":[[2727,2728,2729,2730,-2575,-2542]]},{"type":"Polygon","id":39153,"arcs":[[2731,2732,2733,2734,-2551]]},{"type":"Polygon","id":39133,"arcs":[[-2641,2735,2736,-2732,-2550,-2498]]},{"type":"Polygon","id":17131,"arcs":[[-2592,2737,2738,2739,2740,-2691,-2422]]},{"type":"Polygon","id":17155,"arcs":[[-2548,2741,-2586]]},{"type":"Polygon","id":36087,"arcs":[[2742,2743,-2540,-2603,2744]]},{"type":"Polygon","id":42037,"arcs":[[2745,2746,2747,-2579,-2585,-2687]]},{"type":"Polygon","id":17091,"arcs":[[-2506,2748,2749,2750,2751,-2660,-2485]]},{"type":"Polygon","id":18183,"arcs":[[2752,2753,2754,-2670,-2598]]},{"type":"MultiPolygon","id":36103,"arcs":[[[2755,2756]],[[2757,2758]]]},{"type":"Polygon","id":39077,"arcs":[[-2608,2759,2760,2761,2762,-2644,-2566]]},{"type":"Polygon","id":18073,"arcs":[[-2683,2763,2764,2765,2766,-2504,-2508]]},{"type":"Polygon","id":39103,"arcs":[[-2735,2767,2768,-2606,-2552]]},{"type":"Polygon","id":18003,"arcs":[[2769,2770,2771,2772,2773,-2753,-2597,-2595,-2690]]},{"type":"Polygon","id":39147,"arcs":[[-2763,2774,2775,2776,-2570,-2645]]},{"type":"Polygon","id":42033,"arcs":[[2777,2778,2779,2780,-2718,-2556,-2574,-2656]]},{"type":"Polygon","id":49043,"arcs":[[-2593,-2170,2781,2782,2783,2784,-2715,-2318]]},{"type":"Polygon","id":42027,"arcs":[[2785,2786,2787,2788,-2778,-2655]]},{"type":"Polygon","id":42089,"arcs":[[-2731,2789,2790,2791,-2684,-2537,-2349,-2576]]},{"type":"Polygon","id":39125,"arcs":[[2792,2793,-2770,-2689]]},{"type":"Polygon","id":17175,"arcs":[[-2588,2794,2795,2796,-2590]]},{"type":"Polygon","id":31049,"arcs":[[-2696,2797,2798,-2673,-2307]]},{"type":"Polygon","id":18111,"arcs":[[2799,2800,-2749,-2505,-2767]]},{"type":"Polygon","id":34031,"arcs":[[2801,2802,-2728,-2541,-2744,2803]]},{"type":"Polygon","id":31153,"arcs":[[-2632,2804,2805,-2667,-2714]]},{"type":"Polygon","id":6035,"arcs":[[-2368,2806,2807,2808,-2358]]},{"type":"Polygon","id":6089,"arcs":[[-2359,-2809,2809,2810,-2721,-2301]]},{"type":"Polygon","id":42097,"arcs":[[2811,-2747,2812,2813,2814,2815,2816,-2581]]},{"type":"Polygon","id":18049,"arcs":[[2817,2818,2819,2820,-2652,-2672]]},{"type":"Polygon","id":31081,"arcs":[[2821,2822,2823,2824,-2707,-2703]]},{"type":"Polygon","id":18131,"arcs":[[-2821,2825,2826,-2764,-2682]]},{"type":"Polygon","id":42093,"arcs":[[-2748,-2812,-2580]]},{"type":"Polygon","id":42019,"arcs":[[-2679,2827,2828,2829,2830,-2646,-2563]]},{"type":"Polygon","id":42005,"arcs":[[-2720,2831,2832,2833,-2828,-2678]]},{"type":"Polygon","id":39063,"arcs":[[-2777,2834,2835,2836,2837,-2571]]},{"type":"Polygon","id":39137,"arcs":[[-2838,2838,2839,-2793,-2688,-2649]]},{"type":"Polygon","id":19101,"arcs":[[-2612,2840,2841,2842,-2618]]},{"type":"Polygon","id":19087,"arcs":[[-2693,2843,2844,2845,-2841,-2611]]},{"type":"Polygon","id":19179,"arcs":[[-2843,2846,2847,-2624,-2619]]},{"type":"Polygon","id":19039,"arcs":[[2848,2849,2850,-2621,-2616]]},{"type":"Polygon","id":19117,"arcs":[[-2628,2851,2852,-2849,-2615]]},{"type":"Polygon","id":19135,"arcs":[[-2848,2853,-2852,-2627,-2625]]},{"type":"Polygon","id":19129,"arcs":[[2854,2855,2856,-2805,-2631]]},{"type":"Polygon","id":19137,"arcs":[[-2636,2857,2858,-2855,-2630]]},{"type":"Polygon","id":19003,"arcs":[[-2638,2859,2860,-2858,-2635]]},{"type":"Polygon","id":19175,"arcs":[[-2622,-2851,2861,-2860,-2637]]},{"type":"Polygon","id":49011,"arcs":[[-2717,2862,2863,-2681]]},{"type":"Polygon","id":17095,"arcs":[[-2797,2864,2865,2866,-2738,-2591]]},{"type":"Polygon","id":42119,"arcs":[[2867,2868,-2786,-2654,-2582,-2817]]},{"type":"Polygon","id":17123,"arcs":[[-2742,-2547,2869,2870,-2795,-2587]]},{"type":"Polygon","id":34003,"arcs":[[2871,2872,-2804,-2743,2873]]},{"type":"Polygon","id":39099,"arcs":[[-2648,2874,2875,2876,-2736,-2640]]},{"type":"Polygon","id":42025,"arcs":[[-2792,2877,2878,2879,-2685]]},{"type":"Polygon","id":42073,"arcs":[[-2831,2880,2881,-2875,-2647]]},{"type":"Polygon","id":17105,"arcs":[[-2752,2882,2883,2884,-2545,-2661]]},{"type":"Polygon","id":34041,"arcs":[[2885,2886,2887,2888,-2790,-2730]]},{"type":"Polygon","id":34027,"arcs":[[2889,2890,2891,2892,-2886,-2729,-2803]]},{"type":"Polygon","id":49045,"arcs":[[2893,2894,2895,2896,-2335,-2329,-2864]]},{"type":"Polygon","id":19057,"arcs":[[-2741,2897,2898,-2844,-2692]]},{"type":"Polygon","id":17071,"arcs":[[2899,2900,2901,2902,-2898,-2740]]},{"type":"Polygon","id":17187,"arcs":[[-2867,2903,2904,-2900,-2739]]},{"type":"Polygon","id":39005,"arcs":[[-2769,2905,2906,2907,2908,-2760,-2607]]},{"type":"Polygon","id":31025,"arcs":[[-2857,2909,2910,2911,-2668,-2806]]},{"type":"Polygon","id":31185,"arcs":[[2912,2913,2914,-2822,-2702]]},{"type":"Polygon","id":31079,"arcs":[[-2708,-2825,2915,2916,-2710]]},{"type":"Polygon","id":31047,"arcs":[[2917,2918,2919,2920,-2697,-2469]]},{"type":"Polygon","id":31019,"arcs":[[-2711,-2917,2921,2922,2923,-2918,-2468,-2713]]},{"type":"Polygon","id":31159,"arcs":[[2924,2925,-2913,-2664]]},{"type":"Polygon","id":31109,"arcs":[[-2912,2926,2927,2928,-2925,-2663,-2669]]},{"type":"Polygon","id":18169,"arcs":[[-2755,2929,2930,2931,-2818,-2671]]},{"type":"Polygon","id":17075,"arcs":[[-2801,2932,2933,2934,-2750]]},{"type":"Polygon","id":18069,"arcs":[[-2774,2935,2936,-2930,-2754]]},{"type":"MultiPolygon","id":8123,"arcs":[[[2937]],[[2938,2939,2940,2941,2942,-2525,-2706,2943]]]},{"type":"Polygon","id":31135,"arcs":[[-2700,2944,2945,2946,2947,-2798,-2695]]},{"type":"Polygon","id":8107,"arcs":[[2948,2949,2950,2951,2952,-2109,2953]]},{"type":"Polygon","id":8057,"arcs":[[2954,-2954,-2108,-2114,2955]]},{"type":"Polygon","id":8081,"arcs":[[-2953,2956,2957,2958,-2168,-2110]]},{"type":"Polygon","id":8075,"arcs":[[2959,2960,2961,-2944,-2705,-2675,2962,2963]]},{"type":"Polygon","id":8115,"arcs":[[2964,-2963,-2674,-2799,-2948]]},{"type":"Polygon","id":49009,"arcs":[[2965,2966,-2782,-2169,-2959]]},{"type":"Polygon","id":32011,"arcs":[[2967,2968,2969,-2337]]},{"type":"Polygon","id":32015,"arcs":[[-2970,2970,2971,2972,-2331,-2338]]},{"type":"Polygon","id":8069,"arcs":[[2973,2974,-2956,-2113,-2526,-2943]]},{"type":"Polygon","id":18103,"arcs":[[-2932,2975,2976,2977,-2819]]},{"type":"Polygon","id":39033,"arcs":[[2978,2979,2980,2981,-2775,-2762]]},{"type":"Polygon","id":17053,"arcs":[[2982,2983,2984,-2883,-2751,-2935]]},{"type":"Polygon","id":39139,"arcs":[[-2909,2985,2986,-2979,-2761]]},{"type":"Polygon","id":39175,"arcs":[[-2982,2987,2988,-2835,-2776]]},{"type":"Polygon","id":39169,"arcs":[[-2734,2989,2990,-2906,-2768]]},{"type":"Polygon","id":39161,"arcs":[[-2840,2991,2992,2993,2994,-2771,-2794]]},{"type":"Polygon","id":39151,"arcs":[[-2877,2995,2996,2997,2998,-2990,-2733,-2737]]},{"type":"Polygon","id":17143,"arcs":[[-2871,2999,3000,3001,-2865,-2796]]},{"type":"Polygon","id":42095,"arcs":[[3002,3003,-2878,-2791,-2889]]},{"type":"Polygon","id":32027,"arcs":[[-2973,3004,-2360,-2332]]},{"type":"Polygon","id":42107,"arcs":[[-2880,3005,3006,3007,3008,-2813,-2746,-2686]]},{"type":"Polygon","id":39029,"arcs":[[-2882,3009,3010,3011,3012,-2996,-2876]]},{"type":"Polygon","id":17203,"arcs":[[3013,3014,-3000,-2870,-2546,-2885]]},{"type":"Polygon","id":18001,"arcs":[[3015,3016,3017,-2772,-2995]]},{"type":"Polygon","id":39003,"arcs":[[-2837,3018,3019,-2992,-2839]]},{"type":"Polygon","id":49035,"arcs":[[-2716,-2785,3020,3021,-2894,-2863]]},{"type":"MultiPolygon","id":36005,"arcs":[[[3022,3023,3024,-2725]]]},{"type":"Polygon","id":18179,"arcs":[[-3018,3025,3026,3027,-2936,-2773]]},{"type":"MultiPolygon","id":36059,"arcs":[[[-2756,3028]],[[-2758,3029,3030,3031,3032,3033]]]},{"type":"Polygon","id":18181,"arcs":[[3034,3035,3036,3037,-2765,-2827]]},{"type":"Polygon","id":18017,"arcs":[[-2820,-2978,3038,3039,-3035,-2826]]},{"type":"Polygon","id":42063,"arcs":[[-2781,3040,3041,-2832,-2719]]},{"type":"Polygon","id":34013,"arcs":[[-2802,-2873,3042,3043,3044,-2890]]},{"type":"Polygon","id":19071,"arcs":[[3045,3046,3047,-2910,-2856]]},{"type":"Polygon","id":19145,"arcs":[[3048,3049,3050,-3046,-2859]]},{"type":"Polygon","id":19173,"arcs":[[3051,3052,3053,-3049,-2861]]},{"type":"Polygon","id":19177,"arcs":[[-2846,3054,3055,3056,3057,-2842]]},{"type":"Polygon","id":19051,"arcs":[[-3058,3058,3059,3060,-2847]]},{"type":"Polygon","id":19159,"arcs":[[3061,3062,3063,-3052,-2862]]},{"type":"Polygon","id":19053,"arcs":[[3064,3065,3066,-3062,-2850]]},{"type":"Polygon","id":19185,"arcs":[[3067,3068,3069,-3065,-2853]]},{"type":"Polygon","id":19007,"arcs":[[-3061,3070,3071,-3068,-2854]]},{"type":"Polygon","id":42109,"arcs":[[-2816,3072,3073,-2868]]},{"type":"Polygon","id":36061,"arcs":[[3074,-3024]]},{"type":"Polygon","id":49047,"arcs":[[-2958,3075,3076,3077,3078,3079,3080,-2966]]},{"type":"Polygon","id":42007,"arcs":[[-2830,3081,3082,3083,-3010,-2881]]},{"type":"Polygon","id":42087,"arcs":[[3084,-2787,-2869,-3074,3085]]},{"type":"Polygon","id":49013,"arcs":[[-2967,-3081,3086,3087,3088,-2783]]},{"type":"Polygon","id":39065,"arcs":[[-2989,3089,3090,3091,3092,-3019,-2836]]},{"type":"Polygon","id":34017,"arcs":[[3093,-3043,-2872]]},{"type":"Polygon","id":19111,"arcs":[[-2899,-2903,3094,3095,-3055,-2845]]},{"type":"MultiPolygon","id":36081,"arcs":[[[3096,-3031]],[[3097,3098]],[[-3033,3099,3100,3101]]]},{"type":"Polygon","id":34019,"arcs":[[3102,3103,3104,-2887,-2893]]},{"type":"Polygon","id":42077,"arcs":[[3105,3106,3107,-3006,-2879,-3004]]},{"type":"Polygon","id":31131,"arcs":[[-3048,3108,3109,3110,-2927,-2911]]},{"type":"Polygon","id":34035,"arcs":[[3111,3112,3113,-3103,-2892]]},{"type":"Polygon","id":17113,"arcs":[[-2985,3114,3115,3116,3117,3118,-3014,-2884]]},{"type":"Polygon","id":8095,"arcs":[[-2947,3119,3120,-2964,-2965]]},{"type":"Polygon","id":17179,"arcs":[[-3119,3121,3122,3123,-3001,-3015]]},{"type":"Polygon","id":42061,"arcs":[[-3085,3124,3125,3126,3127,3128,-2788]]},{"type":"Polygon","id":42013,"arcs":[[3129,3130,-2779,-2789,-3129]]},{"type":"MultiPolygon","id":36047,"arcs":[[[3131,-3098]],[[3132,-3101]]]},{"type":"Polygon","id":18007,"arcs":[[-2766,-3038,3133,3134,3135,-2933,-2800]]},{"type":"Polygon","id":34039,"arcs":[[3136,3137,-3112,-2891,-3045]]},{"type":"Polygon","id":18015,"arcs":[[-3040,3138,3139,3140,-3036]]},{"type":"Polygon","id":39019,"arcs":[[-3013,3141,3142,3143,-2997]]},{"type":"Polygon","id":39107,"arcs":[[3144,3145,3146,3147,-3016,-2994]]},{"type":"Polygon","id":42021,"arcs":[[-3131,3148,3149,3150,-3041,-2780]]},{"type":"Polygon","id":17057,"arcs":[[-3002,-3124,3151,3152,3153,-2904,-2866]]},{"type":"Polygon","id":39117,"arcs":[[-2987,3154,3155,3156,-2980]]},{"type":"Polygon","id":39101,"arcs":[[-3157,3157,3158,-3090,-2988,-2981]]},{"type":"Polygon","id":31063,"arcs":[[-2921,3159,3160,3161,3162,3163,-2698]]},{"type":"Polygon","id":31001,"arcs":[[-2824,3164,3165,3166,-2922,-2916]]},{"type":"Polygon","id":31073,"arcs":[[3167,3168,-3160,-2920]]},{"type":"Polygon","id":31085,"arcs":[[-3164,3169,3170,3171,-2945,-2699]]},{"type":"Polygon","id":31029,"arcs":[[-3172,3172,3173,-3120,-2946]]},{"type":"Polygon","id":31059,"arcs":[[3174,3175,3176,3177,-2914]]},{"type":"Polygon","id":31151,"arcs":[[-2926,-2929,3178,3179,-3175]]},{"type":"Polygon","id":31035,"arcs":[[-3178,3180,3181,-3165,-2823,-2915]]},{"type":"Polygon","id":42067,"arcs":[[-2815,3182,3183,-3125,-3086,-3073]]},{"type":"Polygon","id":49051,"arcs":[[-3089,3184,-3021,-2784]]},{"type":"Polygon","id":31099,"arcs":[[3185,3186,3187,-2923,-3167]]},{"type":"Polygon","id":39011,"arcs":[[-3093,3188,3189,-3145,-2993,-3020]]},{"type":"Polygon","id":31137,"arcs":[[-2924,-3188,3190,3191,-3168,-2919]]},{"type":"Polygon","id":42129,"arcs":[[-3042,-3151,3192,3193,3194,3195,-2833]]},{"type":"Polygon","id":42011,"arcs":[[3196,3197,3198,3199,-3007,-3108]]},{"type":"Polygon","id":42003,"arcs":[[-2834,-3196,3200,-3082,-2829]]},{"type":"Polygon","id":39075,"arcs":[[-2999,3201,3202,3203,-2907,-2991]]},{"type":"Polygon","id":39157,"arcs":[[-3144,3204,3205,3206,-3202,-2998]]},{"type":"Polygon","id":42043,"arcs":[[-3009,3207,3208,3209,3210,3211,-2814]]},{"type":"Polygon","id":18053,"arcs":[[-3028,3212,3213,3214,3215,3216,-2976,-2931,-2937]]},{"type":"Polygon","id":36085,"arcs":[[3217]]},{"type":"Polygon","id":17067,"arcs":[[3218,3219,3220,3221,3222,-3095,-2902]]},{"type":"Polygon","id":54029,"arcs":[[3223,3224,3225,-3011,-3084]]},{"type":"Polygon","id":17109,"arcs":[[-3154,3226,-3219,-2901,-2905]]},{"type":"Polygon","id":42099,"arcs":[[3227,3228,-3183,-3212]]},{"type":"Polygon","id":29045,"arcs":[[-3223,3229,3230,3231,-3056,-3096]]},{"type":"Polygon","id":42017,"arcs":[[3232,3233,3234,3235,-3106,-3003,-2888,-3105]]},{"type":"Polygon","id":34023,"arcs":[[3236,3237,3238,-3113,-3138]]},{"type":"Polygon","id":29199,"arcs":[[-3232,3239,3240,3241,-3059,-3057]]},{"type":"Polygon","id":39081,"arcs":[[-3226,3242,3243,3244,3245,-3142,-3012]]},{"type":"Polygon","id":29197,"arcs":[[3246,3247,-3071,-3060,-3242]]},{"type":"Polygon","id":29171,"arcs":[[-3248,3248,3249,3250,-3069,-3072]]},{"type":"Polygon","id":29005,"arcs":[[-3051,3251,3252,3253,-3109,-3047]]},{"type":"Polygon","id":29129,"arcs":[[-3251,3254,3255,3256,-3066,-3070]]},{"type":"Polygon","id":29147,"arcs":[[-3054,3257,3258,3259,3260,-3252,-3050]]},{"type":"Polygon","id":49049,"arcs":[[-3088,3261,3262,3263,-2895,-3022,-3185]]},{"type":"Polygon","id":29081,"arcs":[[-3257,3264,3265,3266,3267,-3063,-3067]]},{"type":"Polygon","id":39083,"arcs":[[3268,3269,3270,-3155,-2986,-2908,-3204]]},{"type":"Polygon","id":18075,"arcs":[[3271,3272,3273,3274,-3026,-3017,-3148]]},{"type":"Polygon","id":29227,"arcs":[[-3268,3275,-3258,-3053,-3064]]},{"type":"Polygon","id":18009,"arcs":[[-3275,3276,-3213,-3027]]},{"type":"Polygon","id":18067,"arcs":[[3277,3278,-3139,-3039,-2977,-3217]]},{"type":"Polygon","id":18157,"arcs":[[-3141,3279,3280,3281,3282,-3134,-3037]]},{"type":"Polygon","id":31127,"arcs":[[3283,3284,3285,3286,-3110,-3254]]},{"type":"Polygon","id":42075,"arcs":[[-3208,-3008,-3200,3287]]},{"type":"Polygon","id":39091,"arcs":[[-3092,3288,3289,3290,-3189]]},{"type":"Polygon","id":8087,"arcs":[[-2962,3291,3292,-2939]]},{"type":"Polygon","id":31067,"arcs":[[3293,3294,3295,3296,3297,-3179,-2928]]},{"type":"Polygon","id":31097,"arcs":[[-3287,3298,-3294,-3111]]},{"type":"Polygon","id":39159,"arcs":[[3299,3300,3301,-3289,-3091,-3159,3302]]},{"type":"Polygon","id":17183,"arcs":[[-3136,3303,3304,3305,3306,-2983,-2934]]},{"type":"Polygon","id":8049,"arcs":[[3307,3308,3309,3310,3311,-2949,-2955,-2975]]},{"type":"Polygon","id":39149,"arcs":[[-3291,3312,3313,3314,-3146,-3190]]},{"type":"Polygon","id":42125,"arcs":[[-3201,-3195,3315,3316,3317,3318,3319,-3224,-3083]]},{"type":"Polygon","id":18171,"arcs":[[-3283,3320,3321,-3304,-3135]]},{"type":"Polygon","id":34025,"arcs":[[3322,3323,3324,-3238,3325]]},{"type":"Polygon","id":39031,"arcs":[[-3207,3326,3327,3328,-3269,-3203]]},{"type":"Polygon","id":42091,"arcs":[[3329,3330,3331,-3197,-3107,-3236]]},{"type":"Polygon","id":6103,"arcs":[[3332,3333,3334,3335,-2722,-2811]]},{"type":"Polygon","id":6063,"arcs":[[-2808,3336,3337,3338,-3333,-2810]]},{"type":"Polygon","id":39041,"arcs":[[-3271,3339,3340,-3303,-3158,-3156]]},{"type":"Polygon","id":8125,"arcs":[[-3174,3341,3342,3343,3344,-2960,-3121]]},{"type":"Polygon","id":8121,"arcs":[[-3345,3345,3346,3347,3348,-3292,-2961]]},{"type":"Polygon","id":17125,"arcs":[[3349,3350,3351,3352,-3152,-3123]]},{"type":"Polygon","id":39067,"arcs":[[-3246,3353,3354,-3205,-3143]]},{"type":"Polygon","id":18023,"arcs":[[-3279,3355,3356,3357,3358,-3280,-3140]]},{"type":"Polygon","id":34021,"arcs":[[-3239,-3325,3359,-3233,-3104,-3114]]},{"type":"Polygon","id":18159,"arcs":[[-3216,3360,3361,-3356,-3278]]},{"type":"Polygon","id":54009,"arcs":[[-3320,3362,-3243,-3225]]},{"type":"Polygon","id":17019,"arcs":[[-3307,3363,3364,-3115,-2984]]},{"type":"Polygon","id":29211,"arcs":[[3365,3366,3367,-3255,-3250]]},{"type":"Polygon","id":29075,"arcs":[[-3267,3368,3369,3370,-3259,-3276]]},{"type":"Polygon","id":18095,"arcs":[[3371,3372,3373,3374,-3361,-3215]]},{"type":"Polygon","id":18035,"arcs":[[-3277,-3274,3375,3376,-3372,-3214]]},{"type":"Polygon","id":18045,"arcs":[[-3282,3377,3378,3379,-3321]]},{"type":"Polygon","id":39037,"arcs":[[-3315,3380,3381,3382,3383,3384,-3272,-3147]]},{"type":"Polygon","id":31181,"arcs":[[-3182,3385,3386,3387,3388,-3186,-3166]]},{"type":"Polygon","id":31061,"arcs":[[-3389,3389,3390,3391,-3187]]},{"type":"Polygon","id":31129,"arcs":[[-3177,3392,3393,3394,-3386,-3181]]},{"type":"Polygon","id":31057,"arcs":[[3395,3396,3397,-3342,-3173,-3171]]},{"type":"Polygon","id":31065,"arcs":[[-3192,3398,3399,3400,3401,-3161,-3169]]},{"type":"Polygon","id":31169,"arcs":[[3402,3403,-3393,-3176]]},{"type":"Polygon","id":31095,"arcs":[[-3180,-3298,3404,-3403]]},{"type":"Polygon","id":31145,"arcs":[[-3402,3405,3406,3407,-3162]]},{"type":"Polygon","id":31087,"arcs":[[-3163,-3408,3408,-3396,-3170]]},{"type":"Polygon","id":31083,"arcs":[[-3392,3409,3410,-3399,-3191]]},{"type":"Polygon","id":29001,"arcs":[[-3241,3411,3412,3413,-3366,-3249,-3247]]},{"type":"Polygon","id":42041,"arcs":[[3414,3415,3416,-3228,-3211]]},{"type":"Polygon","id":17107,"arcs":[[3417,3418,3419,3420,-3350,-3122,-3118]]},{"type":"Polygon","id":42009,"arcs":[[-3128,3421,3422,3423,-3149,-3130]]},{"type":"Polygon","id":42071,"arcs":[[3424,3425,3426,3427,-3209,-3288,-3199]]},{"type":"Polygon","id":18135,"arcs":[[-3385,3428,3429,-3376,-3273]]},{"type":"Polygon","id":29103,"arcs":[[-3231,3430,3431,3432,-3412,-3240]]},{"type":"Polygon","id":42055,"arcs":[[-3417,3433,3434,3435,3436,-3126,-3184,-3229]]},{"type":"Polygon","id":42111,"arcs":[[-3424,3437,3438,3439,-3193,-3150]]},{"type":"Polygon","id":17039,"arcs":[[3440,3441,-3418,-3117]]},{"type":"Polygon","id":17169,"arcs":[[-3153,-3353,3442,3443,3444,-3220,-3227]]},{"type":"Polygon","id":17147,"arcs":[[-3365,3445,3446,3447,-3441,-3116]]},{"type":"Polygon","id":39089,"arcs":[[-3329,3448,3449,3450,3451,-3340,-3270]]},{"type":"Polygon","id":39021,"arcs":[[-3302,3452,3453,3454,-3313,-3290]]},{"type":"Polygon","id":29079,"arcs":[[-3368,3455,3456,3457,-3265,-3256]]},{"type":"Polygon","id":8013,"arcs":[[-2942,3458,3459,3460,-3308,-2974]]},{"type":"Polygon","id":31133,"arcs":[[-3286,3461,3462,3463,-3295,-3299]]},{"type":"Polygon","id":31147,"arcs":[[3464,3465,3466,3467,-3462,-3285]]},{"type":"Polygon","id":29087,"arcs":[[-3261,3468,3469,-3465,-3284,-3253]]},{"type":"Polygon","id":29111,"arcs":[[-3222,3470,3471,3472,-3431,-3230]]},{"type":"MultiPolygon","id":42029,"arcs":[[[3473,3474]],[[3475,3476,3477,-3425,-3198,-3332]]]},{"type":"Polygon","id":42133,"arcs":[[-3428,3478,3479,3480,3481,-3415,-3210]]},{"type":"Polygon","id":8103,"arcs":[[3482,-3076,-2957,-2952]]},{"type":"Polygon","id":39059,"arcs":[[3483,3484,-3327,-3206,-3355,3485]]},{"type":"Polygon","id":18057,"arcs":[[3486,3487,3488,-3357,-3362,-3375]]},{"type":"Polygon","id":18107,"arcs":[[-3359,3489,3490,3491,3492,-3378,-3281]]},{"type":"Polygon","id":17001,"arcs":[[-3445,3493,3494,3495,-3471,-3221]]},{"type":"Polygon","id":39109,"arcs":[[-3455,3496,3497,-3381,-3314]]},{"type":"Polygon","id":54069,"arcs":[[-3319,3498,3499,-3244,-3363]]},{"type":"Polygon","id":34005,"arcs":[[-3324,3500,3501,3502,3503,3504,3505,-3234,-3360]]},{"type":"Polygon","id":18011,"arcs":[[-3489,3506,3507,-3490,-3358]]},{"type":"Polygon","id":39013,"arcs":[[-3245,-3500,3508,3509,3510,-3486,-3354]]},{"type":"MultiPolygon","id":34029,"arcs":[[[3511,-3501,-3323]]]},{"type":"Polygon","id":39119,"arcs":[[-3485,3512,3513,3514,-3449,-3328]]},{"type":"Polygon","id":42057,"arcs":[[-3437,3515,3516,-3422,-3127]]},{"type":"Polygon","id":17129,"arcs":[[-3421,3517,3518,-3351]]},{"type":"Polygon","id":6007,"arcs":[[3519,3520,3521,3522,-3334,-3339]]},{"type":"Polygon","id":18165,"arcs":[[-3380,3523,3524,3525,-3305,-3322]]},{"type":"Polygon","id":42051,"arcs":[[-3440,3526,3527,3528,3529,-3316,-3194]]},{"type":"Polygon","id":39049,"arcs":[[-3452,3530,3531,3532,-3300,-3341]]},{"type":"Polygon","id":42101,"arcs":[[-3506,3533,3534,-3330,-3235]]},{"type":"Polygon","id":29061,"arcs":[[-3266,-3458,3535,3536,3537,-3369]]},{"type":"Polygon","id":29003,"arcs":[[-3371,3538,3539,3540,-3469,-3260]]},{"type":"Polygon","id":32033,"arcs":[[-2897,3541,3542,3543,3544,-2968,-2336]]},{"type":"Polygon","id":17017,"arcs":[[-3352,-3519,3545,3546,3547,-3443]]},{"type":"Polygon","id":39097,"arcs":[[3548,3549,3550,3551,-3453,-3301,-3533]]},{"type":"Polygon","id":17009,"arcs":[[-3548,3552,3553,-3494,-3444]]},{"type":"Polygon","id":8045,"arcs":[[-2951,3554,3555,3556,3557,-3077,-3483]]},{"type":"Polygon","id":18065,"arcs":[[-3430,3558,3559,3560,3561,-3373,-3377]]},{"type":"Polygon","id":42001,"arcs":[[3562,3563,-3434,-3416,-3482]]},{"type":"Polygon","id":42045,"arcs":[[-3535,3564,3565,-3474,3566,-3476,-3331]]},{"type":"Polygon","id":17115,"arcs":[[-3448,3567,3568,3569,3570,-3419,-3442]]},{"type":"Polygon","id":8014,"arcs":[[3571,3572,-3459,-2941],[-2938]]},{"type":"Polygon","id":29121,"arcs":[[-3433,3573,3574,3575,3576,3577,-3413]]},{"type":"Polygon","id":39023,"arcs":[[-3552,3578,3579,-3497,-3454]]},{"type":"Polygon","id":29115,"arcs":[[-3578,3580,3581,-3456,-3367,-3414]]},{"type":"Polygon","id":29063,"arcs":[[-3538,3582,3583,3584,-3539,-3370]]},{"type":"Polygon","id":54051,"arcs":[[3585,3586,-3509,-3499,-3318,3587]]},{"type":"Polygon","id":42059,"arcs":[[-3530,3588,3589,-3588,-3317]]},{"type":"Polygon","id":49023,"arcs":[[-3264,3590,3591,-3542,-2896]]},{"type":"Polygon","id":18177,"arcs":[[-3384,3592,3593,3594,-3559,-3429]]},{"type":"Polygon","id":20023,"arcs":[[3595,3596,3597,-3343,-3398]]},{"type":"Polygon","id":20153,"arcs":[[-3407,3598,3599,3600,-3596,-3397,-3409]]},{"type":"Polygon","id":6045,"arcs":[[-2723,-3336,3601,3602,3603,3604,-2658]]},{"type":"Polygon","id":20089,"arcs":[[3605,3606,3607,3608,3609,-3387,-3395]]},{"type":"Polygon","id":20183,"arcs":[[-3610,3610,3611,3612,-3390,-3388]]},{"type":"Polygon","id":20157,"arcs":[[3613,3614,-3606,-3394,-3404]]},{"type":"Polygon","id":20201,"arcs":[[-3297,3615,3616,3617,3618,-3614,-3405]]},{"type":"Polygon","id":20039,"arcs":[[-3401,3619,3620,3621,-3599,-3406]]},{"type":"Polygon","id":32001,"arcs":[[-2972,3622,3623,3624,-2361,-3005]]},{"type":"Polygon","id":20137,"arcs":[[3625,3626,3627,-3620,-3400,-3411]]},{"type":"Polygon","id":20147,"arcs":[[-3613,3628,3629,-3626,-3410,-3391]]},{"type":"Polygon","id":20117,"arcs":[[-3464,3630,3631,3632,-3616,-3296]]},{"type":"Polygon","id":8001,"arcs":[[-3349,3633,3634,3635,-3572,-2940,-3293]]},{"type":"Polygon","id":20013,"arcs":[[3636,3637,3638,3639,-3467]]},{"type":"Polygon","id":20131,"arcs":[[-3468,-3640,3640,3641,-3631,-3463]]},{"type":"Polygon","id":20043,"arcs":[[-3470,-3541,3642,3643,-3637,-3466]]},{"type":"MultiPolygon","id":34007,"arcs":[[[3644,3645,3646,-3504]]]},{"type":"Polygon","id":17167,"arcs":[[-3571,3647,3648,3649,3650,-3546,-3518,-3420]]},{"type":"Polygon","id":29117,"arcs":[[3651,3652,3653,-3536,-3457,-3582]]},{"type":"Polygon","id":29205,"arcs":[[-3473,3654,3655,-3574,-3432]]},{"type":"Polygon","id":18121,"arcs":[[-3493,3656,3657,3658,-3524,-3379]]},{"type":"Polygon","id":39121,"arcs":[[-3511,3659,3660,3661,-3513,-3484]]},{"type":"Polygon","id":29127,"arcs":[[-3496,3662,3663,3664,-3655,-3472]]},{"type":"Polygon","id":18059,"arcs":[[-3562,3665,3666,3667,-3487,-3374]]},{"type":"Polygon","id":39045,"arcs":[[-3451,3668,3669,3670,-3531]]},{"type":"Polygon","id":8047,"arcs":[[3671,3672,-3309,-3461]]},{"type":"Polygon","id":39127,"arcs":[[3673,3674,3675,-3669,-3450,-3515]]},{"type":"Polygon","id":18097,"arcs":[[-3668,3676,3677,3678,3679,-3507,-3488]]},{"type":"Polygon","id":8037,"arcs":[[3680,3681,3682,-3555,-2950,-3312]]},{"type":"Polygon","id":8117,"arcs":[[3683,3684,3685,-3681,-3311]]},{"type":"Polygon","id":18063,"arcs":[[-3680,3686,3687,-3491,-3508]]},{"type":"Polygon","id":39113,"arcs":[[-3580,3688,3689,3690,3691,-3382,-3498]]},{"type":"Polygon","id":39135,"arcs":[[-3692,3692,3693,-3593,-3383]]},{"type":"Polygon","id":8059,"arcs":[[-3636,3694,3695,3696,3697,3698,3699,-3672,-3460,-3573]]},{"type":"Polygon","id":8031,"arcs":[[3700,-3695,-3635]]},{"type":"MultiPolygon","id":34015,"arcs":[[[3701,3702,3703,3704,-3646]]]},{"type":"Polygon","id":17045,"arcs":[[3705,3706,3707,3708,-3306,-3526]]},{"type":"Polygon","id":17041,"arcs":[[-3709,3709,3710,-3446,-3364]]},{"type":"Polygon","id":17137,"arcs":[[-3651,3711,3712,3713,3714,-3553,-3547]]},{"type":"Polygon","id":39111,"arcs":[[-3587,3715,3716,3717,-3660,-3510]]},{"type":"Polygon","id":18133,"arcs":[[-3688,3718,3719,3720,-3657,-3492]]},{"type":"Polygon","id":8019,"arcs":[[-3700,3721,-3684,-3310,-3673]]},{"type":"Polygon","id":39057,"arcs":[[-3551,3722,3723,3724,-3689,-3579]]},{"type":"Polygon","id":17149,"arcs":[[-3715,3725,3726,3727,3728,3729,-3663,-3495,-3554]]},{"type":"MultiPolygon","id":10003,"arcs":[[[3730,3731]],[[3732,3733]],[[3734,3735,3736,3737,-3477,-3567,-3475,-3566]]]},{"type":"Polygon","id":17021,"arcs":[[-3570,3738,3739,-3648]]},{"type":"Polygon","id":29021,"arcs":[[-3585,3740,3741,3742,-3643,-3540]]},{"type":"Polygon","id":49007,"arcs":[[-3087,-3080,3743,3744,-3262]]},{"type":"Polygon","id":49039,"arcs":[[-3745,3745,3746,3747,-3591,-3263]]},{"type":"Polygon","id":39129,"arcs":[[-3671,3748,3749,3750,-3549,-3532]]},{"type":"Polygon","id":6021,"arcs":[[-3523,3751,3752,-3602,-3335]]},{"type":"Polygon","id":17139,"arcs":[[-3711,3753,3754,-3568,-3447]]},{"type":"Polygon","id":18041,"arcs":[[3755,3756,3757,-3560,-3595]]},{"type":"Polygon","id":18139,"arcs":[[-3758,3758,3759,3760,-3666,-3561]]},{"type":"Polygon","id":17171,"arcs":[[3761,-3726,-3714]]},{"type":"Polygon","id":29025,"arcs":[[-3654,3762,3763,3764,-3583,-3537]]},{"type":"MultiPolygon","id":34033,"arcs":[[[3765,3766]],[[3767,3768,-3732,3769,-3734,3770,-3704]]]},{"type":"Polygon","id":6091,"arcs":[[-2807,-2367,3771,3772,-3337]]},{"type":"Polygon","id":39115,"arcs":[[-3662,3773,3774,-3674,-3514]]},{"type":"Polygon","id":29049,"arcs":[[-3765,3775,3776,3777,-3741,-3584]]},{"type":"Polygon","id":8005,"arcs":[[-3348,3778,3779,3780,-3696,-3701,-3634]]},{"type":"Polygon","id":32019,"arcs":[[3781,3782,3783,3784,3785,-2362,-3625]]},{"type":"MultiPolygon","id":34001,"arcs":[[[3786,3787,3788,-3702,-3645,-3503]]]},{"type":"Polygon","id":18161,"arcs":[[-3694,3789,3790,-3756,-3594]]},{"type":"Polygon","id":24043,"arcs":[[-3436,3791,3792,3793,3794,3795,3796,-3516]]},{"type":"Polygon","id":24001,"arcs":[[-3517,-3797,3797,3798,3799,3800,-3438,-3423]]},{"type":"Polygon","id":24023,"arcs":[[-3801,3801,3802,3803,-3527,-3439]]},{"type":"MultiPolygon","id":24015,"arcs":[[[-3738,3804,3805,3806,-3426,-3478]]]},{"type":"Polygon","id":54061,"arcs":[[-3529,3807,3808,3809,3810,-3589]]},{"type":"Polygon","id":54077,"arcs":[[-3804,3811,3812,3813,3814,-3808,-3528]]},{"type":"MultiPolygon","id":24025,"arcs":[[[-3427,-3807,3815,3816,-3479]]]},{"type":"Polygon","id":54103,"arcs":[[-3590,-3811,3817,3818,3819,3820,-3716,-3586]]},{"type":"MultiPolygon","id":24005,"arcs":[[[-3817,3821,3822,3823,3824,3825,-3480]]]},{"type":"Polygon","id":24013,"arcs":[[-3826,3826,3827,-3563,-3481]]},{"type":"Polygon","id":24021,"arcs":[[-3828,3828,3829,3830,-3792,-3435,-3564]]},{"type":"Polygon","id":39047,"arcs":[[-3751,3831,3832,3833,-3723,-3550]]},{"type":"Polygon","id":49015,"arcs":[[-3079,3834,3835,3836,-3746,-3744]]},{"type":"Polygon","id":29041,"arcs":[[-3577,3837,3838,3839,3840,-3652,-3581]]},{"type":"Polygon","id":18145,"arcs":[[-3761,3841,3842,3843,-3677,-3667]]},{"type":"Polygon","id":54065,"arcs":[[3844,3845,3846,-3798,-3796]]},{"type":"Polygon","id":29173,"arcs":[[-3730,3847,3848,3849,-3664]]},{"type":"Polygon","id":17029,"arcs":[[-3708,3850,3851,3852,-3754,-3710]]},{"type":"Polygon","id":29137,"arcs":[[-3665,-3850,3853,3854,-3575,-3656]]},{"type":"Polygon","id":39073,"arcs":[[3855,3856,3857,-3749,-3670,-3676]]},{"type":"Polygon","id":20029,"arcs":[[-3619,3858,3859,3860,-3607,-3615]]},{"type":"Polygon","id":20085,"arcs":[[3861,3862,3863,3864,-3641,-3639]]},{"type":"Polygon","id":20005,"arcs":[[-3743,3865,3866,3867,-3862,-3638,-3644]]},{"type":"Polygon","id":17173,"arcs":[[-3755,-3853,3868,3869,3870,3871,-3739,-3569]]},{"type":"Polygon","id":54057,"arcs":[[3872,3873,-3802,-3800]]},{"type":"Polygon","id":39167,"arcs":[[-3718,3874,3875,3876,3877,-3774,-3661]]},{"type":"Polygon","id":54049,"arcs":[[-3810,3878,3879,-3818]]},{"type":"Polygon","id":18081,"arcs":[[-3844,3880,3881,3882,-3678]]},{"type":"Polygon","id":6115,"arcs":[[-3773,3883,3884,3885,-3520,-3338]]},{"type":"Polygon","id":18109,"arcs":[[-3883,3886,3887,3888,-3719,-3687,-3679]]},{"type":"Polygon","id":32029,"arcs":[[-2363,-3786]]},{"type":"Polygon","id":54003,"arcs":[[-3795,3889,3890,-3845]]},{"type":"Polygon","id":29033,"arcs":[[-3841,3891,3892,3893,-3763,-3653]]},{"type":"Polygon","id":29175,"arcs":[[-3855,3894,3895,3896,-3838,-3576]]},{"type":"Polygon","id":18167,"arcs":[[3897,3898,3899,-3706,-3525,-3659]]},{"type":"Polygon","id":18021,"arcs":[[-3721,3900,3901,3902,-3898,-3658]]},{"type":"Polygon","id":54095,"arcs":[[3903,3904,3905,-3875,-3717,-3821]]},{"type":"Polygon","id":29163,"arcs":[[3906,3907,3908,-3848,-3729,3909]]},{"type":"Polygon","id":39017,"arcs":[[3910,3911,3912,-3790,-3693,-3691]]},{"type":"Polygon","id":39165,"arcs":[[-3725,3913,3914,3915,-3911,-3690]]},{"type":"Polygon","id":6033,"arcs":[[3916,3917,3918,3919,-3603,-3753]]},{"type":"Polygon","id":8063,"arcs":[[-3598,3920,3921,3922,3923,-3346,-3344]]},{"type":"MultiPolygon","id":34011,"arcs":[[[3924,-3767,3925,-3768,-3703,-3789,3926,3927]]]},{"type":"Polygon","id":20163,"arcs":[[3928,3929,3930,3931,-3629,-3612]]},{"type":"Polygon","id":39027,"arcs":[[3932,3933,-3914,-3724,-3834,3934]]},{"type":"Polygon","id":20181,"arcs":[[-3601,3935,3936,3937,-3921,-3597]]},{"type":"Polygon","id":20193,"arcs":[[-3622,3938,3939,3940,-3936,-3600]]},{"type":"Polygon","id":20141,"arcs":[[-3609,3941,3942,3943,3944,-3929,-3611]]},{"type":"Polygon","id":20179,"arcs":[[-3628,3945,3946,-3939,-3621]]},{"type":"Polygon","id":20027,"arcs":[[3947,3948,3949,3950,-3859,-3618]]},{"type":"Polygon","id":20123,"arcs":[[-3861,3951,3952,-3942,-3608]]},{"type":"Polygon","id":20065,"arcs":[[-3932,3953,3954,-3946,-3627,-3630]]},{"type":"Polygon","id":20161,"arcs":[[3955,3956,3957,-3948,-3617,-3633]]},{"type":"Polygon","id":8035,"arcs":[[3958,3959,3960,-3697,-3781]]},{"type":"Polygon","id":8039,"arcs":[[3961,3962,-3959,-3780]]},{"type":"Polygon","id":20149,"arcs":[[-3642,-3865,3963,3964,-3956,-3632]]},{"type":"Polygon","id":8073,"arcs":[[-3924,3965,3966,3967,3968,-3962,-3779,-3347]]},{"type":"Polygon","id":8093,"arcs":[[-3699,3969,3970,3971,3972,-3685,-3722]]},{"type":"Polygon","id":39009,"arcs":[[-3878,3973,3974,3975,-3856,-3675,-3775]]},{"type":"Polygon","id":49027,"arcs":[[-3748,3976,3977,3978,-3543,-3592]]},{"type":"Polygon","id":54027,"arcs":[[-3847,3979,3980,-3873,-3799]]},{"type":"Polygon","id":29165,"arcs":[[-3742,-3778,3981,3982,3983,-3866]]},{"type":"Polygon","id":18047,"arcs":[[-3791,-3913,3984,3985,3986,-3759,-3757]]},{"type":"Polygon","id":29177,"arcs":[[-3894,3987,3988,3989,-3776,-3764]]},{"type":"Polygon","id":17135,"arcs":[[-3740,-3872,3990,3991,3992,3993,-3649]]},{"type":"Polygon","id":17117,"arcs":[[-3994,3994,3995,3996,-3712,-3650]]},{"type":"Polygon","id":6057,"arcs":[[-2366,3997,-3884,-3772]]},{"type":"Polygon","id":17061,"arcs":[[-3713,-3997,3998,3999,-3727,-3762]]},{"type":"Polygon","id":39141,"arcs":[[-3858,4000,4001,4002,4003,-3832,-3750]]},{"type":"Polygon","id":54037,"arcs":[[4004,4005,-3890,-3794]]},{"type":"Polygon","id":49019,"arcs":[[-3558,4006,4007,-3835,-3078]]},{"type":"Polygon","id":17023,"arcs":[[-3900,4008,4009,4010,4011,-3851,-3707]]},{"type":"Polygon","id":54073,"arcs":[[4012,4013,-3876,-3906]]},{"type":"Polygon","id":18119,"arcs":[[-3889,4014,4015,-3901,-3720]]},{"type":"Polygon","id":54033,"arcs":[[4016,4017,4018,4019,4020,-3819,-3880]]},{"type":"Polygon","id":51069,"arcs":[[4021,4022,4023,4024,-3980,-3846,-3891],[4025]]},{"type":"Polygon","id":29047,"arcs":[[-3777,-3990,4026,4027,-3982]]},{"type":"Polygon","id":18031,"arcs":[[-3987,4028,4029,4030,-3842,-3760]]},{"type":"Polygon","id":54091,"arcs":[[4031,-4017,-3879,-3809,-3815]]},{"type":"Polygon","id":54017,"arcs":[[-4021,4032,4033,4034,-3904,-3820]]},{"type":"Polygon","id":20087,"arcs":[[4035,4036,4037,-3863,-3868]]},{"type":"Polygon","id":20103,"arcs":[[-3984,4038,4039,4040,-4036,-3867]]},{"type":"Polygon","id":6011,"arcs":[[-3522,4041,4042,-3917,-3752]]},{"type":"Polygon","id":29195,"arcs":[[-3840,4043,4044,4045,4046,-3892]]},{"type":"Polygon","id":54107,"arcs":[[-4014,4047,4048,4049,4050,-3974,-3877]]},{"type":"Polygon","id":17013,"arcs":[[-4000,4051,4052,4053,-3910,-3728]]},{"type":"Polygon","id":39163,"arcs":[[-3976,4054,4055,4056,-4001,-3857]]},{"type":"Polygon","id":54085,"arcs":[[-4035,4057,4058,4059,-4048,-4013,-3905]]},{"type":"MultiPolygon","id":24029,"arcs":[[[-3737,4060,4061,4062,-3805]]]},{"type":"Polygon","id":8065,"arcs":[[-3686,-3973,4063,4064,-3682]]},{"type":"Polygon","id":17035,"arcs":[[-4012,4065,4066,-3869,-3852]]},{"type":"Polygon","id":39071,"arcs":[[-4004,4067,4068,4069,-3935,-3833]]},{"type":"MultiPolygon","id":24510,"arcs":[[[4070,4071]],[[4072,4073,-3823]]]},{"type":"Polygon","id":24027,"arcs":[[-3825,4074,4075,4076,-3829,-3827]]},{"type":"Polygon","id":8077,"arcs":[[4077,4078,4079,4080,-4007,-3557]]},{"type":"Polygon","id":8097,"arcs":[[-4065,4081,4082,-4078,-3556,-3683]]},{"type":"Polygon","id":10001,"arcs":[[4083,4084,4085,-4061,-3736,4086]]},{"type":"Polygon","id":18105,"arcs":[[4087,4088,4089,4090,-4015,-3888]]},{"type":"Polygon","id":18005,"arcs":[[-4031,4091,4092,4093,-3881,-3843]]},{"type":"Polygon","id":29007,"arcs":[[-3849,-3909,4094,4095,4096,-3895,-3854]]},{"type":"Polygon","id":24031,"arcs":[[4097,4098,4099,4100,-3830,-4077]]},{"type":"Polygon","id":18013,"arcs":[[-4094,4101,-4088,-3887,-3882]]},{"type":"Polygon","id":29089,"arcs":[[4102,-4044,-3839,-3897,4103]]},{"type":"Polygon","id":54023,"arcs":[[4104,4105,4106,4107,-3812,-3803,-3874]]},{"type":"MultiPolygon","id":34009,"arcs":[[[4108,-3927,-3788]]]},{"type":"Polygon","id":51107,"arcs":[[-4101,4109,4110,4111,4112,-4005,-3793,-3831]]},{"type":"Polygon","id":6061,"arcs":[[-2365,4113,4114,4115,4116,4117,-3885,-3998]]},{"type":"Polygon","id":39061,"arcs":[[-3916,4118,4119,4120,4121,4122,-3912]]},{"type":"Polygon","id":18137,"arcs":[[4123,4124,4125,4126,4127,-4029,-3986]]},{"type":"Polygon","id":18029,"arcs":[[-3985,-4123,4128,4129,-4124]]},{"type":"Polygon","id":20143,"arcs":[[-3951,4130,4131,4132,-3952,-3860]]},{"type":"Polygon","id":6101,"arcs":[[-3886,-4118,4133,4134,-4042,-3521]]},{"type":"Polygon","id":54001,"arcs":[[4135,4136,4137,-4018,-4032,-3814]]},{"type":"Polygon","id":29107,"arcs":[[4138,4139,4140,-3988,-3893,-4047]]},{"type":"Polygon","id":54093,"arcs":[[4141,-4136,-3813,-4108]]},{"type":"Polygon","id":39025,"arcs":[[4142,4143,4144,-4119,-3915,-3934,4145]]},{"type":"Polygon","id":51043,"arcs":[[-4113,4146,4147,-4022,-4006]]},{"type":"Polygon","id":17083,"arcs":[[-3996,4148,4149,-4052,-3999]]},{"type":"MultiPolygon","id":24035,"arcs":[[[4150]],[[-4086,4151,4152,4153,-4062]]]},{"type":"Polygon","id":18153,"arcs":[[-3903,4154,4155,4156,-4009,-3899]]},{"type":"Polygon","id":8051,"arcs":[[-4083,4157,4158,4159,4160,4161,4162,-4079]]},{"type":"Polygon","id":39015,"arcs":[[4163,4164,4165,-4146,-3933,-4070]]},{"type":"Polygon","id":29019,"arcs":[[-4097,4166,4167,4168,4169,-4104,-3896]]},{"type":"Polygon","id":32510,"arcs":[[4170,-4114,-2364,-3785]]},{"type":"Polygon","id":54031,"arcs":[[-4025,4171,4172,4173,-4105,-3981]]},{"type":"MultiPolygon","id":24003,"arcs":[[[4174,4175,4176,-4075,-3824,-4074,4177,-4071,4178]]]},{"type":"Polygon","id":29095,"arcs":[[-3989,-4141,4179,4180,4181,4182,-4027]]},{"type":"Polygon","id":29113,"arcs":[[-4054,4183,4184,4185,-3907]]},{"type":"Polygon","id":20061,"arcs":[[4186,4187,4188,-3949,-3958]]},{"type":"Polygon","id":8029,"arcs":[[-4163,4189,-4080]]},{"type":"Polygon","id":20105,"arcs":[[-4133,4190,4191,4192,-3943,-3953]]},{"type":"Polygon","id":20177,"arcs":[[-4038,4193,4194,4195,-3964,-3864]]},{"type":"Polygon","id":17051,"arcs":[[-3871,4196,4197,4198,4199,4200,-3991]]},{"type":"Polygon","id":17049,"arcs":[[-4067,4201,4202,-4197,-3870]]},{"type":"Polygon","id":20197,"arcs":[[-4196,4203,4204,4205,-4187,-3957,-3965]]},{"type":"Polygon","id":39079,"arcs":[[4206,4207,4208,4209,-4002,-4057]]},{"type":"Polygon","id":39105,"arcs":[[4210,4211,-4055,-3975,-4051,4212]]},{"type":"Polygon","id":51840,"arcs":[[-4026]]},{"type":"Polygon","id":20209,"arcs":[[-3983,-4028,-4183,4213,-4039]]},{"type":"Polygon","id":39131,"arcs":[[4214,4215,-4068,-4003,-4210]]},{"type":"Polygon","id":18079,"arcs":[[4216,4217,4218,-4092,-4030,-4128]]},{"type":"Polygon","id":54105,"arcs":[[4219,4220,4221,-4049,-4060]]},{"type":"Polygon","id":17033,"arcs":[[-4157,4222,4223,4224,4225,-4010]]},{"type":"Polygon","id":17079,"arcs":[[-4226,4226,4227,-4202,-4066,-4011]]},{"type":"Polygon","id":18055,"arcs":[[-4016,-4091,4228,4229,4230,4231,-4155,-3902]]},{"type":"Polygon","id":54041,"arcs":[[4232,4233,4234,4235,-4033,-4020]]},{"type":"Polygon","id":32023,"arcs":[[-2969,-3545,4236,4237,4238,4239,4240,-3623,-2971]]},{"type":"Polygon","id":29139,"arcs":[[-3908,-4186,4241,4242,4243,4244,-4095]]},{"type":"Polygon","id":21015,"arcs":[[4245,4246,4247,4248,4249,-4129,-4122]]},{"type":"Polygon","id":24011,"arcs":[[4250,4251,4252,4253,-4152,-4085]]},{"type":"Polygon","id":20109,"arcs":[[4254,4255,4256,4257,-3937,-3941]]},{"type":"Polygon","id":20199,"arcs":[[-4258,4258,4259,4260,-3922,-3938]]},{"type":"Polygon","id":20051,"arcs":[[-3945,4261,4262,4263,4264,-3930]]},{"type":"Polygon","id":20063,"arcs":[[-3947,-3955,4265,4266,4267,4268,-4255,-3940]]},{"type":"Polygon","id":20041,"arcs":[[-4189,4269,4270,4271,-4131,-3950]]},{"type":"Polygon","id":20167,"arcs":[[-4193,4272,4273,4274,-4262,-3944]]},{"type":"Polygon","id":20195,"arcs":[[-3931,-4265,4275,-4266,-3954]]},{"type":"Polygon","id":24033,"arcs":[[-4177,4276,4277,4278,4279,4280,-4098,-4076]]},{"type":"Polygon","id":8119,"arcs":[[4281,4282,-3970,-3698,-3961]]},{"type":"Polygon","id":8041,"arcs":[[-3963,-3969,4283,4284,-4282,-3960]]},{"type":"Polygon","id":21037,"arcs":[[-4145,4285,4286,-4120]]},{"type":"Polygon","id":54083,"arcs":[[-4107,4287,4288,4289,4290,-4137,-4142]]},{"type":"Polygon","id":32005,"arcs":[[-3784,4291,4292,4293,-4115,-4171]]},{"type":"Polygon","id":54097,"arcs":[[-4138,-4291,4294,-4233,-4019]]},{"type":"Polygon","id":54021,"arcs":[[-4236,4295,4296,-4058,-4034]]},{"type":"Polygon","id":51171,"arcs":[[4297,4298,4299,-4172,-4024]]},{"type":"Polygon","id":21117,"arcs":[[-4287,4300,4301,-4246,-4121]]},{"type":"Polygon","id":54035,"arcs":[[-4222,4302,4303,4304,4305,-4213,-4050]]},{"type":"Polygon","id":32021,"arcs":[[-4241,4306,4307,-3782,-3624]]},{"type":"Polygon","id":18071,"arcs":[[-4219,4308,4309,4310,-4089,-4102,-4093]]},{"type":"Polygon","id":20045,"arcs":[[-4041,4311,4312,4313,-4194,-4037]]},{"type":"Polygon","id":6017,"arcs":[[-4294,4314,4315,4316,-4116]]},{"type":"Polygon","id":29027,"arcs":[[-4096,-4245,4317,4318,-4167]]},{"type":"Polygon","id":29053,"arcs":[[-4170,4319,4320,4321,-4045,-4103]]},{"type":"MultiPolygon","id":51059,"arcs":[[[4322,4323,4324,4325,4326,4327,-4110,-4100],[4328]],[[4329]]]},{"type":"Polygon","id":8015,"arcs":[[-3972,4330,4331,-4158,-4082,-4064]]},{"type":"Polygon","id":20091,"arcs":[[-4182,4332,4333,-4312,-4040,-4214]]},{"type":"Polygon","id":39001,"arcs":[[4334,4335,4336,-4164,-4069,-4216]]},{"type":"Polygon","id":49041,"arcs":[[-3837,4337,4338,4339,-3977,-3747]]},{"type":"Polygon","id":8017,"arcs":[[-4261,4340,4341,-3966,-3923]]},{"type":"Polygon","id":54013,"arcs":[[-4297,4342,4343,4344,-4220,-4059]]},{"type":"Polygon","id":51187,"arcs":[[4345,4346,4347,-4298,-4023,-4148]]},{"type":"Polygon","id":39053,"arcs":[[4348,4349,4350,-4207,-4056,-4212]]},{"type":"Polygon","id":18115,"arcs":[[4351,-4125,-4130,-4250]]},{"type":"Polygon","id":54053,"arcs":[[-4306,4352,4353,-4349,-4211]]},{"type":"Polygon","id":17005,"arcs":[[-4201,4354,4355,-3992]]},{"type":"Polygon","id":39145,"arcs":[[-4209,4356,4357,4358,-4335,-4215]]},{"type":"Polygon","id":51061,"arcs":[[4359,4360,4361,4362,-4346,-4147,-4112]]},{"type":"Polygon","id":17119,"arcs":[[-3995,-3993,-4356,4363,4364,4365,4366,4367,-4149]]},{"type":"Polygon","id":29219,"arcs":[[4368,4369,4370,-4242,-4185]]},{"type":"MultiPolygon","id":11001,"arcs":[[[4371,4372,-4099,-4281]]]},{"type":"Polygon","id":18093,"arcs":[[-4311,4373,4374,4375,-4229,-4090]]},{"type":"Polygon","id":29183,"arcs":[[-4368,4376,4377,-4369,-4184,-4053,-4150]]},{"type":"Polygon","id":10005,"arcs":[[4378,4379,4380,4381,4382,4383,-4251,-4084]]},{"type":"Polygon","id":20169,"arcs":[[-4272,4384,4385,-4191,-4132]]},{"type":"Polygon","id":54071,"arcs":[[-4174,4386,4387,4388,4389,-4288,-4106]]},{"type":"Polygon","id":29159,"arcs":[[-4322,4390,4391,4392,4393,-4139,-4046]]},{"type":"MultiPolygon","id":24041,"arcs":[[[-4254,4394,-4153]]]},{"type":"Polygon","id":51153,"arcs":[[-4328,4395,4396,-4360,-4111],[4397,4398]]},{"type":"Polygon","id":54087,"arcs":[[-4345,4399,4400,-4303,-4221]]},{"type":"Polygon","id":29101,"arcs":[[-4394,4401,4402,-4180,-4140]]},{"type":"Polygon","id":51013,"arcs":[[4403,-4325,4404,-4323,-4373,4405]]},{"type":"Polygon","id":6003,"arcs":[[4406,4407,4408,4409,-4315,-4293]]},{"type":"Polygon","id":18155,"arcs":[[-4249,4410,4411,4412,-4126,-4352]]},{"type":"Polygon","id":29135,"arcs":[[4413,4414,4415,-4320,-4169]]},{"type":"Polygon","id":6113,"arcs":[[-4135,4416,4417,4418,-3918,-4043]]},{"type":"Polygon","id":18077,"arcs":[[-4413,4419,4420,4421,4422,-4217,-4127]]},{"type":"Polygon","id":17025,"arcs":[[-4228,4423,4424,4425,-4198,-4203]]},{"type":"Polygon","id":18083,"arcs":[[4426,4427,4428,4429,4430,-4223,-4156,-4232]]},{"type":"Polygon","id":18101,"arcs":[[-4376,4431,4432,4433,-4230]]},{"type":"Polygon","id":18027,"arcs":[[4434,4435,-4427,-4231,-4434]]},{"type":"Polygon","id":54007,"arcs":[[-4235,4436,4437,4438,-4343,-4296]]},{"type":"Polygon","id":51610,"arcs":[[-4324,-4405]]},{"type":"Polygon","id":29189,"arcs":[[-4367,4439,4440,4441,4442,4443,-4377]]},{"type":"Polygon","id":21191,"arcs":[[4444,4445,-4301,-4286,-4144,4446]]},{"type":"Polygon","id":20127,"arcs":[[-4206,4447,4448,4449,-4270,-4188]]},{"type":"Polygon","id":20053,"arcs":[[-4386,4450,4451,4452,-4273,-4192]]},{"type":"Polygon","id":20139,"arcs":[[-4314,4453,4454,4455,-4204,-4195]]},{"type":"Polygon","id":51600,"arcs":[[-4329],[-4330]]},{"type":"Polygon","id":6055,"arcs":[[4456,4457,4458,4459,4460,-3919,-4419]]},{"type":"Polygon","id":51157,"arcs":[[4461,4462,4463,-4347,-4363]]},{"type":"Polygon","id":21077,"arcs":[[4464,4465,4466,-4411,-4248]]},{"type":"Polygon","id":6097,"arcs":[[-3920,-4461,4467,4468,4469,-3604]]},{"type":"Polygon","id":17101,"arcs":[[4470,4471,-4224,-4431]]},{"type":"Polygon","id":51165,"arcs":[[-4300,4472,4473,4474,4475,-4387,-4173],[4476]]},{"type":"Polygon","id":17159,"arcs":[[-4225,-4472,4477,4478,4479,-4424,-4227]]},{"type":"Polygon","id":39087,"arcs":[[4480,4481,4482,4483,-4357,-4208,-4351]]},{"type":"Polygon","id":29037,"arcs":[[-4403,4484,4485,4486,-4333,-4181]]},{"type":"Polygon","id":51510,"arcs":[[4487,-4326,-4404]]},{"type":"Polygon","id":51139,"arcs":[[-4464,4488,4489,-4473,-4299,-4348]]},{"type":"Polygon","id":18143,"arcs":[[-4423,4490,4491,-4309,-4218]]},{"type":"Polygon","id":21023,"arcs":[[-4166,4492,4493,4494,-4447,-4143]]},{"type":"Polygon","id":17121,"arcs":[[-4426,4495,4496,4497,4498,-4199]]},{"type":"Polygon","id":21081,"arcs":[[-4302,-4446,4499,4500,4501,-4465,-4247]]},{"type":"Polygon","id":51685,"arcs":[[4502,-4398]]},{"type":"Polygon","id":18175,"arcs":[[-4492,4503,4504,4505,4506,4507,-4374,-4310]]},{"type":"Polygon","id":51683,"arcs":[[-4503,-4399]]},{"type":"Polygon","id":29510,"arcs":[[-4440,-4366,4508]]},{"type":"Polygon","id":24009,"arcs":[[4509,-4277,-4176]]},{"type":"Polygon","id":21161,"arcs":[[-4337,4510,4511,4512,-4493,-4165]]},{"type":"Polygon","id":21041,"arcs":[[4513,4514,4515,-4420,-4412,-4467]]},{"type":"Polygon","id":21089,"arcs":[[-4484,4516,4517,4518,-4358]]},{"type":"Polygon","id":17027,"arcs":[[-4200,-4499,4519,4520,-4364,-4355]]},{"type":"Polygon","id":54075,"arcs":[[-4390,4521,4522,4523,4524,-4289]]},{"type":"Polygon","id":29051,"arcs":[[-4319,4525,4526,-4414,-4168]]},{"type":"Polygon","id":20111,"arcs":[[-4456,4527,4528,4529,-4448,-4205]]},{"type":"Polygon","id":20059,"arcs":[[4530,4531,4532,-4454,-4313]]},{"type":"Polygon","id":20121,"arcs":[[-4487,4533,4534,-4531,-4334]]},{"type":"Polygon","id":54101,"arcs":[[-4295,-4290,-4525,4535,4536,-4437,-4234]]},{"type":"MultiPolygon","id":6067,"arcs":[[[4537,4538,4539,4540,-4417,-4134,-4117,-4317]]]},{"type":"Polygon","id":21223,"arcs":[[-4516,4541,4542,4543,-4421]]},{"type":"Polygon","id":21187,"arcs":[[-4502,4544,4545,4546,-4514,-4466]]},{"type":"Polygon","id":21135,"arcs":[[4547,4548,4549,-4511,-4336,-4359,-4519]]},{"type":"Polygon","id":29073,"arcs":[[-4371,4550,4551,4552,4553,4554,-4243]]},{"type":"Polygon","id":6051,"arcs":[[-3783,-4308,4555,4556,4557,4558,4559,-4407,-4292]]},{"type":"Polygon","id":29071,"arcs":[[-4378,-4444,4560,4561,4562,-4551,-4370]]},{"type":"Polygon","id":29151,"arcs":[[-4244,-4555,4563,4564,-4526,-4318]]},{"type":"Polygon","id":6005,"arcs":[[-4410,4565,4566,-4538,-4316]]},{"type":"MultiPolygon","id":24019,"arcs":[[[4567,-4252,-4384,4568,4569]]]},{"type":"Polygon","id":20171,"arcs":[[-4269,4570,4571,4572,4573,-4256]]},{"type":"Polygon","id":20101,"arcs":[[4574,4575,-4571,-4268]]},{"type":"Polygon","id":20071,"arcs":[[4576,4577,4578,4579,-4341,-4260]]},{"type":"Polygon","id":20203,"arcs":[[-4574,4580,4581,-4577,-4259,-4257]]},{"type":"Polygon","id":51047,"arcs":[[4582,4583,4584,4585,-4462,-4362]]},{"type":"Polygon","id":20135,"arcs":[[-4276,-4264,4586,4587,4588,4589,-4575,-4267]]},{"type":"Polygon","id":29141,"arcs":[[-4416,4590,4591,4592,-4391,-4321]]},{"type":"Polygon","id":20009,"arcs":[[-4453,4593,4594,4595,4596,-4274]]},{"type":"Polygon","id":8043,"arcs":[[-4285,4597,4598,4599,-4331,-3971,-4283]]},{"type":"Polygon","id":20165,"arcs":[[-4275,-4597,4600,-4587,-4263]]},{"type":"MultiPolygon","id":24017,"arcs":[[[-4279,4601,4602,4603]]]},{"type":"Polygon","id":18117,"arcs":[[-4508,4604,4605,-4432,-4375]]},{"type":"Polygon","id":54079,"arcs":[[4606,4607,-4353,-4305,4608]]},{"type":"Polygon","id":32017,"arcs":[[-3979,4609,4610,4611,4612,4613,-4237,-3544]]},{"type":"Polygon","id":8085,"arcs":[[-4162,4614,4615,4616,-4081,-4190]]},{"type":"Polygon","id":54015,"arcs":[[4617,4618,-4400,-4344,-4439]]},{"type":"Polygon","id":17163,"arcs":[[-4521,4619,4620,4621,-4441,-4509,-4365]]},{"type":"Polygon","id":51113,"arcs":[[-4586,4622,4623,-4489,-4463]]},{"type":"Polygon","id":54039,"arcs":[[-4401,-4619,4624,4625,4626,4627,4628,-4609,-4304]]},{"type":"Polygon","id":8061,"arcs":[[-4580,4629,4630,4631,4632,-3967,-4342]]},{"type":"Polygon","id":20113,"arcs":[[4633,4634,4635,4636,-4451,-4385]]},{"type":"Polygon","id":20115,"arcs":[[-4450,4637,4638,4639,-4634,-4271]]},{"type":"Polygon","id":21201,"arcs":[[-4513,4640,4641,4642,-4494]]},{"type":"Polygon","id":17191,"arcs":[[-4480,4643,4644,4645,4646,-4496,-4425]]},{"type":"Polygon","id":18019,"arcs":[[-4544,4647,4648,4649,-4504,-4491,-4422]]},{"type":"Polygon","id":54011,"arcs":[[-4354,-4608,4650,4651,-4481,-4350]]},{"type":"Polygon","id":21103,"arcs":[[4652,4653,4654,-4542,-4515,-4547]]},{"type":"Polygon","id":51091,"arcs":[[4655,4656,-4522,-4389]]},{"type":"Polygon","id":51179,"arcs":[[4657,4658,4659,4660,4661,4662,-4583,-4361,-4397]]},{"type":"Polygon","id":21097,"arcs":[[-4643,4663,4664,4665,-4500,-4445,-4495]]},{"type":"Polygon","id":49001,"arcs":[[-4340,4666,4667,4668,-4610,-3978]]},{"type":"Polygon","id":17047,"arcs":[[4669,4670,-4644,-4479]]},{"type":"Polygon","id":17185,"arcs":[[-4478,-4471,-4430,4671,4672,-4670]]},{"type":"Polygon","id":29083,"arcs":[[-4393,4673,4674,4675,-4485,-4402]]},{"type":"Polygon","id":24045,"arcs":[[4676,4677,4678,-4569,-4383]]},{"type":"Polygon","id":54067,"arcs":[[-4537,4679,4680,-4625,-4618,-4438]]},{"type":"Polygon","id":18125,"arcs":[[4681,4682,4683,-4428,-4436]]},{"type":"MultiPolygon","id":6095,"arcs":[[[4684,-4459]],[[-4541,4685,-4457,-4418]]]},{"type":"Polygon","id":29015,"arcs":[[-4593,4686,4687,4688,-4674,-4392]]},{"type":"Polygon","id":18051,"arcs":[[4689,4690,4691,4692,-4672,-4429,-4684]]},{"type":"Polygon","id":18037,"arcs":[[-4606,4693,4694,4695,4696,-4682,-4435,-4433]]},{"type":"Polygon","id":21069,"arcs":[[4697,4698,4699,-4641,-4512,-4550]]},{"type":"Polygon","id":21185,"arcs":[[-4655,4700,4701,-4648,-4543]]},{"type":"Polygon","id":20017,"arcs":[[-4530,4702,4703,-4638,-4449]]},{"type":"Polygon","id":8101,"arcs":[[4704,4705,4706,4707,4708,-4598,-4284]]},{"type":"Polygon","id":8025,"arcs":[[-4633,4709,-4705,-3968]]},{"type":"Polygon","id":20159,"arcs":[[-4637,4710,4711,-4594,-4452]]},{"type":"Polygon","id":17133,"arcs":[[4712,4713,4714,-4442,-4622]]},{"type":"Polygon","id":17189,"arcs":[[-4498,4715,4716,4717,-4620,-4520]]},{"type":"MultiPolygon","id":24037,"arcs":[[[4718,-4603,4719]]]},{"type":"Polygon","id":6009,"arcs":[[4720,4721,4722,-4566,-4409]]},{"type":"Polygon","id":49031,"arcs":[[4723,4724,-4667,-4339]]},{"type":"Polygon","id":49055,"arcs":[[-3836,4725,4726,-4724,-4338]]},{"type":"Polygon","id":29099,"arcs":[[-4715,4727,4728,4729,-4561,-4443]]},{"type":"Polygon","id":21019,"arcs":[[4730,4731,-4517,-4483,4732]]},{"type":"Polygon","id":21043,"arcs":[[-4732,4733,4734,4735,-4548,-4518]]},{"type":"Polygon","id":49037,"arcs":[[-4617,4736,4737,4738,4739,4740,4741,4742,4743,-4726,-4008]]},{"type":"Polygon","id":21209,"arcs":[[4744,4745,4746,4747,-4545,-4501,-4666]]},{"type":"Polygon","id":51660,"arcs":[[-4477]]},{"type":"Polygon","id":51079,"arcs":[[4748,4749,-4474,-4490,-4624]]},{"type":"Polygon","id":51015,"arcs":[[4750,4751,4752,4753,-4656,-4388,-4476],[4754],[4755]]},{"type":"Polygon","id":17081,"arcs":[[-4647,4756,4757,4758,-4716,-4497]]},{"type":"Polygon","id":29013,"arcs":[[-4676,4759,4760,4761,-4534,-4486]]},{"type":"Polygon","id":32009,"arcs":[[4762,-4556,-4307,-4240]]},{"type":"Polygon","id":21181,"arcs":[[-4700,4763,4764,-4664,-4642]]},{"type":"Polygon","id":8109,"arcs":[[-4600,4765,4766,4767,4768,4769,4770,-4159,-4332]]},{"type":"MultiPolygon","id":24047,"arcs":[[[4771,4772]],[[-4380,4773]],[[4774,4775,4776,4777,-4677,-4382,4778]]]},{"type":"Polygon","id":6109,"arcs":[[-4560,4779,4780,4781,-4721,-4408]]},{"type":"Polygon","id":20031,"arcs":[[-4533,4782,4783,4784,-4528,-4455]]},{"type":"Polygon","id":29131,"arcs":[[-4527,-4565,4785,4786,4787,-4591,-4415]]},{"type":"Polygon","id":18025,"arcs":[[4788,4789,4790,-4694,-4605,-4507]]},{"type":"Polygon","id":18061,"arcs":[[4791,4792,4793,4794,-4789,-4506]]},{"type":"Polygon","id":54099,"arcs":[[-4652,4795,4796,4797,4798,-4733,-4482]]},{"type":"Polygon","id":18043,"arcs":[[-4650,4799,-4792,-4505]]},{"type":"Polygon","id":51099,"arcs":[[4800,4801,4802,4803,-4659,4804]]},{"type":"Polygon","id":21205,"arcs":[[-4736,4805,4806,4807,4808,-4698,-4549]]},{"type":"Polygon","id":51137,"arcs":[[4809,4810,4811,-4749,-4623,-4585]]},{"type":"Polygon","id":20003,"arcs":[[4812,4813,-4783,-4532]]},{"type":"Polygon","id":20107,"arcs":[[-4762,4814,4815,-4813,-4535]]},{"type":"Polygon","id":21111,"arcs":[[4816,4817,4818,4819,-4793,-4800,-4649,-4702]]},{"type":"Polygon","id":51177,"arcs":[[-4663,4820,-4661,4821,4822,4823,-4810,-4584]]},{"type":"Polygon","id":54043,"arcs":[[-4607,-4629,4824,4825,4826,-4796,-4651]]},{"type":"Polygon","id":21073,"arcs":[[-4546,-4748,4827,4828,4829,-4653]]},{"type":"Polygon","id":21017,"arcs":[[4830,4831,4832,-4745,-4665,-4765]]},{"type":"Polygon","id":21211,"arcs":[[4833,4834,-4817,-4701,-4654,-4830]]},{"type":"Polygon","id":20145,"arcs":[[-4596,4835,4836,4837,-4588,-4601]]},{"type":"Polygon","id":8091,"arcs":[[-4161,4838,4839,4840,-4615]]},{"type":"Polygon","id":51630,"arcs":[[-4821,-4662]]},{"type":"MultiPolygon","id":6041,"arcs":[[[4841,-4469]]]},{"type":"Polygon","id":21011,"arcs":[[-4809,4842,4843,-4764,-4699]]},{"type":"Polygon","id":6077,"arcs":[[-4567,-4723,4844,4845,4846,4847,-4539]]},{"type":"Polygon","id":29125,"arcs":[[-4554,4848,4849,-4786,-4564]]},{"type":"MultiPolygon","id":24039,"arcs":[[[4850,4851]],[[4852,4853,4854,4855]],[[4856,4857,4858]],[[4859,-4678,-4778,4860]]]},{"type":"Polygon","id":51003,"arcs":[[-4812,4861,4862,4863,4864,-4751,-4475,-4750],[4865]]},{"type":"MultiPolygon","id":51193,"arcs":[[[4866,4867,4868,-4801,4869]]]},{"type":"Polygon","id":29029,"arcs":[[-4788,4870,4871,4872,4873,-4687,-4592]]},{"type":"Polygon","id":21127,"arcs":[[-4799,4874,4875,4876,4877,-4734,-4731]]},{"type":"Polygon","id":51017,"arcs":[[-4657,-4754,4878,4879,4880,-4523]]},{"type":"Polygon","id":8099,"arcs":[[-4579,4881,4882,4883,4884,-4630]]},{"type":"Polygon","id":54025,"arcs":[[-4881,4885,4886,4887,4888,-4680,-4536,-4524]]},{"type":"Polygon","id":21063,"arcs":[[-4878,4889,-4806,-4735]]},{"type":"Polygon","id":8027,"arcs":[[-4709,4890,-4766,-4599]]},{"type":"Polygon","id":8011,"arcs":[[-4885,4891,4892,4893,-4631]]},{"type":"Polygon","id":8089,"arcs":[[-4894,4894,-4706,-4710,-4632]]},{"type":"Polygon","id":18123,"arcs":[[4895,4896,4897,4898,-4695,-4791]]},{"type":"Polygon","id":54019,"arcs":[[-4681,-4889,4899,4900,-4626]]},{"type":"Polygon","id":20093,"arcs":[[4901,4902,4903,-4581,-4573]]},{"type":"Polygon","id":20055,"arcs":[[-4576,-4590,4904,4905,4906,-4902,-4572]]},{"type":"Polygon","id":20075,"arcs":[[-4904,4907,-4882,-4578,-4582]]},{"type":"Polygon","id":17193,"arcs":[[-4673,-4693,4908,4909,4910,-4645,-4671]]},{"type":"Polygon","id":20185,"arcs":[[-4712,4911,4912,4913,-4836,-4595]]},{"type":"Polygon","id":20083,"arcs":[[-4838,4914,4915,4916,-4905,-4589]]},{"type":"Polygon","id":17065,"arcs":[[-4911,4917,4918,4919,-4757,-4646]]},{"type":"Polygon","id":51033,"arcs":[[-4804,4920,4921,4922,4923,-4822,-4660]]},{"type":"Polygon","id":18173,"arcs":[[-4697,4924,4925,4926,4927,-4690,-4683]]},{"type":"Polygon","id":18129,"arcs":[[4928,4929,4930,4931,-4909,-4692]]},{"type":"Polygon","id":54005,"arcs":[[4932,4933,4934,-4825,-4628]]},{"type":"Polygon","id":17157,"arcs":[[-4621,-4718,4935,4936,4937,4938,-4713]]},{"type":"Polygon","id":29185,"arcs":[[-4689,4939,4940,4941,4942,-4760,-4675]]},{"type":"Polygon","id":17145,"arcs":[[-4717,-4759,4943,4944,-4936]]},{"type":"Polygon","id":29055,"arcs":[[-4563,4945,4946,4947,4948,-4552]]},{"type":"Polygon","id":21067,"arcs":[[4949,4950,4951,4952,-4746,-4833]]},{"type":"Polygon","id":29221,"arcs":[[-4730,4953,4954,-4946,-4562]]},{"type":"Polygon","id":18147,"arcs":[[-4899,4955,4956,-4925,-4696]]},{"type":"Polygon","id":21163,"arcs":[[4957,4958,-4896,-4790,-4795]]},{"type":"Polygon","id":51790,"arcs":[[-4755]]},{"type":"Polygon","id":21239,"arcs":[[-4953,4959,4960,4961,-4828,-4747]]},{"type":"Polygon","id":21173,"arcs":[[4962,4963,4964,-4831,-4844]]},{"type":"Polygon","id":20079,"arcs":[[4965,4966,4967,-4635,-4640]]},{"type":"Polygon","id":20073,"arcs":[[-4529,-4785,4968,4969,4970,4971,-4703]]},{"type":"Polygon","id":20155,"arcs":[[-4636,-4968,4972,4973,4974,-4912,-4711]]},{"type":"Polygon","id":18163,"arcs":[[-4928,4975,-4929,-4691]]},{"type":"Polygon","id":29161,"arcs":[[-4949,4976,4977,4978,-4849,-4553]]},{"type":"Polygon","id":49017,"arcs":[[-4744,4979,4980,-4668,-4725,-4727]]},{"type":"Polygon","id":51057,"arcs":[[4981,4982,-4921,-4803,4983]]},{"type":"Polygon","id":8113,"arcs":[[-4841,4984,4985,-4737,-4616]]},{"type":"Polygon","id":51109,"arcs":[[-4824,4986,4987,4988,-4862,-4811]]},{"type":"Polygon","id":49021,"arcs":[[-4981,4989,4990,-4611,-4669]]},{"type":"Polygon","id":21215,"arcs":[[4991,4992,4993,-4818,-4835]]},{"type":"Polygon","id":8053,"arcs":[[-4771,4994,4995,4996,4997,-4839,-4160]]},{"type":"Polygon","id":21005,"arcs":[[-4962,4998,4999,5000,-4992,-4834,-4829]]},{"type":"Polygon","id":17055,"arcs":[[-4920,5001,5002,5003,-4944,-4758]]},{"type":"Polygon","id":51159,"arcs":[[5004,5005,5006,-4868]]},{"type":"Polygon","id":29186,"arcs":[[-4939,5007,5008,-4728,-4714]]},{"type":"Polygon","id":21029,"arcs":[[5009,5010,-4819,-4994]]},{"type":"Polygon","id":21175,"arcs":[[-4877,5011,5012,5013,5014,-4807,-4890]]},{"type":"Polygon","id":21049,"arcs":[[5015,5016,5017,-4950,-4832,-4965]]},{"type":"MultiPolygon","id":6013,"arcs":[[[-4847,5018,5019]]]},{"type":"Polygon","id":51820,"arcs":[[-4756]]},{"type":"Polygon","id":20015,"arcs":[[-4704,-4972,5020,5021,5022,-4966,-4639]]},{"type":"Polygon","id":20047,"arcs":[[-4914,5023,5024,5025,-4915,-4837]]},{"type":"Polygon","id":51163,"arcs":[[5026,5027,5028,5029,-4879,-4753,5030],[5031],[5032]]},{"type":"Polygon","id":29187,"arcs":[[-5009,5033,5034,5035,-4954,-4729]]},{"type":"Polygon","id":6099,"arcs":[[5036,5037,5038,-4845,-4722,-4782]]},{"type":"Polygon","id":29085,"arcs":[[-4874,5039,5040,-4940,-4688]]},{"type":"Polygon","id":51540,"arcs":[[-4866]]},{"type":"Polygon","id":29217,"arcs":[[-4943,5041,5042,5043,5044,-4815,-4761]]},{"type":"Polygon","id":21165,"arcs":[[-4808,-5015,5045,5046,-4963,-4843]]},{"type":"Polygon","id":51125,"arcs":[[5047,5048,5049,-5031,-4752,-4865]]},{"type":"Polygon","id":21027,"arcs":[[5050,5051,5052,5053,-4897,-4959]]},{"type":"Polygon","id":20207,"arcs":[[5054,5055,-4969,-4784]]},{"type":"Polygon","id":20001,"arcs":[[5056,5057,-5055,-4814]]},{"type":"Polygon","id":20011,"arcs":[[-5045,5058,5059,-5057,-4816]]},{"type":"MultiPolygon","id":51001,"arcs":[[[5060,-4854]],[[5061,-4858]],[[-4851,5062]],[[5063,5064,5065,5066,-4776,5067]],[[-4772,5068]]]},{"type":"Polygon","id":54045,"arcs":[[-4935,5069,5070,-4826]]},{"type":"Polygon","id":51133,"arcs":[[5071,-5005,-4867,5072]]},{"type":"Polygon","id":29169,"arcs":[[-4850,-4979,5073,5074,-4871,-4787]]},{"type":"Polygon","id":8055,"arcs":[[-4708,5075,5076,5077,-4767,-4891]]},{"type":"Polygon","id":51085,"arcs":[[-4924,5078,5079,5080,5081,-4987,-4823]]},{"type":"Polygon","id":51065,"arcs":[[5082,5083,-4863,-4989,5084]]},{"type":"Polygon","id":21093,"arcs":[[5085,5086,5087,5088,-5051,-4958,-4794,-4820,-5011]]},{"type":"Polygon","id":21113,"arcs":[[5089,5090,5091,-4960,-4952]]},{"type":"Polygon","id":21115,"arcs":[[5092,5093,5094,-5012,-4876]]},{"type":"Polygon","id":20069,"arcs":[[-4917,5095,5096,5097,-4906]]},{"type":"Polygon","id":21091,"arcs":[[-5054,5098,5099,-4956,-4898]]},{"type":"Polygon","id":54081,"arcs":[[-4627,-4901,5100,5101,5102,-4933]]},{"type":"Polygon","id":21179,"arcs":[[-5001,5103,5104,5105,-5086,-5010,-4993]]},{"type":"Polygon","id":54059,"arcs":[[5106,5107,5108,5109,5110,-4797,-4827,-5071]]},{"type":"Polygon","id":21101,"arcs":[[-4927,5111,5112,5113,5114,-4930,-4976]]},{"type":"Polygon","id":51097,"arcs":[[-4983,5115,5116,5117,5118,-4922]]},{"type":"Polygon","id":8111,"arcs":[[-4998,5119,5120,-4985,-4840]]},{"type":"Polygon","id":21167,"arcs":[[-5092,5121,5122,5123,-4999,-4961]]},{"type":"Polygon","id":8079,"arcs":[[5124,5125,-4995,-4770]]},{"type":"Polygon","id":21159,"arcs":[[-4798,-5111,5126,5127,-5093,-4875]]},{"type":"Polygon","id":51005,"arcs":[[-5030,5128,5129,5130,-4886,-4880],[5131]]},{"type":"Polygon","id":17077,"arcs":[[-5004,5132,5133,5134,-4937,-4945]]},{"type":"Polygon","id":21197,"arcs":[[-5047,5135,5136,5137,-5016,-4964]]},{"type":"Polygon","id":21059,"arcs":[[5138,5139,-5112,-4926,-4957,-5100]]},{"type":"Polygon","id":21151,"arcs":[[5140,5141,5142,5143,-5090,-4951,-5018]]},{"type":"Polygon","id":17059,"arcs":[[-4932,5144,5145,5146,-4918,-4910]]},{"type":"Polygon","id":21229,"arcs":[[-5124,5147,5148,-5104,-5000]]},{"type":"Polygon","id":20057,"arcs":[[-5026,5149,5150,5151,-5096,-4916]]},{"type":"Polygon","id":20173,"arcs":[[-5023,5152,5153,-4973,-4967]]},{"type":"Polygon","id":17165,"arcs":[[-5147,5154,5155,5156,-5002,-4919]]},{"type":"Polygon","id":51101,"arcs":[[-5119,5157,5158,-5079,-4923]]},{"type":"Polygon","id":29059,"arcs":[[-4873,5159,5160,5161,5162,-5040]]},{"type":"MultiPolygon","id":6001,"arcs":[[[-4846,-5039,5163,5164,-5019]]]},{"type":"Polygon","id":51075,"arcs":[[5165,5166,5167,-5085,-4988,-5082]]},{"type":"Polygon","id":29157,"arcs":[[-5135,5168,5169,5170,5171,-5034,-5008,-4938]]},{"type":"Polygon","id":29039,"arcs":[[5172,5173,5174,-5042,-4942]]},{"type":"Polygon","id":6043,"arcs":[[5175,5176,-4781]]},{"type":"Polygon","id":21225,"arcs":[[5177,5178,5179,-5145,-4931,-5115]]},{"type":"Polygon","id":29105,"arcs":[[-5075,5180,5181,5182,-5160,-4872]]},{"type":"Polygon","id":8033,"arcs":[[-5121,5183,-4738,-4986]]},{"type":"Polygon","id":21153,"arcs":[[-5095,5184,5185,5186,5187,-5013]]},{"type":"Polygon","id":54089,"arcs":[[5188,5189,-5101,-4900,-4888,5190]]},{"type":"Polygon","id":17199,"arcs":[[-5157,5191,5192,-5133,-5003]]},{"type":"Polygon","id":21237,"arcs":[[-5188,5193,5194,-5136,-5046,-5014]]},{"type":"Polygon","id":21065,"arcs":[[-5138,5195,5196,-5141,-5017]]},{"type":"MultiPolygon","id":51103,"arcs":[[[5197,-5006,-5072,5198]]]},{"type":"Polygon","id":8105,"arcs":[[-4769,5199,5200,5201,-5125]]},{"type":"MultiPolygon","id":6075,"arcs":[[[5202,5203]]]},{"type":"Polygon","id":29167,"arcs":[[-5041,-5163,5204,5205,-5173,-4941]]},{"type":"Polygon","id":21079,"arcs":[[-5144,5206,5207,5208,-5122,-5091]]},{"type":"Polygon","id":20151,"arcs":[[-4975,5209,5210,5211,-5024,-4913]]},{"type":"Polygon","id":51580,"arcs":[[-5132]]},{"type":"Polygon","id":51009,"arcs":[[5212,5213,5214,5215,-5027,-5050]]},{"type":"Polygon","id":8071,"arcs":[[-4893,5216,5217,5218,5219,-5076,-4707,-4895]]},{"type":"Polygon","id":51023,"arcs":[[5220,5221,5222,-5129,-5029]]},{"type":"Polygon","id":51678,"arcs":[[-5032]]},{"type":"Polygon","id":29065,"arcs":[[-4948,5223,5224,5225,5226,-4977]]},{"type":"Polygon","id":54109,"arcs":[[5227,5228,-5107,-5070,-4934,-5103]]},{"type":"Polygon","id":51029,"arcs":[[5229,5230,5231,-5048,-4864,-5084]]},{"type":"Polygon","id":6039,"arcs":[[-4559,5232,5233,-5176,-4780]]},{"type":"MultiPolygon","id":51119,"arcs":[[[5234,-5116,-4982,5235]]]},{"type":"Polygon","id":51530,"arcs":[[-5033]]},{"type":"Polygon","id":21071,"arcs":[[-5128,5236,5237,-5185,-5094]]},{"type":"Polygon","id":8003,"arcs":[[-5078,5238,5239,-5200,-4768]]},{"type":"Polygon","id":51049,"arcs":[[-5168,5240,5241,5242,-5230,-5083]]},{"type":"Polygon","id":21195,"arcs":[[5243,5244,5245,5246,5247,-5237,-5127,-5110]]},{"type":"Polygon","id":29093,"arcs":[[-5036,5248,5249,5250,-5224,-4947,-4955]]},{"type":"Polygon","id":20187,"arcs":[[5251,5252,5253,5254,-4883,-4908]]},{"type":"Polygon","id":21183,"arcs":[[-5053,5255,5256,5257,5258,-5139,-5099]]},{"type":"Polygon","id":20067,"arcs":[[5259,5260,-5252,-4903]]},{"type":"Polygon","id":20081,"arcs":[[-5098,5261,5262,5263,-5260,-4907]]},{"type":"Polygon","id":20097,"arcs":[[-5212,5264,5265,5266,-5150,-5025]]},{"type":"Polygon","id":20095,"arcs":[[-5154,5267,5268,5269,-5210,-4974]]},{"type":"Polygon","id":20205,"arcs":[[5270,5271,5272,-4970,-5056]]},{"type":"Polygon","id":20133,"arcs":[[-5060,5273,5274,5275,-5271,-5058]]},{"type":"Polygon","id":21123,"arcs":[[5276,5277,5278,5279,-5087,-5106]]},{"type":"Polygon","id":21155,"arcs":[[-5149,5280,5281,5282,-5277,-5105]]},{"type":"Polygon","id":54063,"arcs":[[-5131,5283,5284,-5191,-4887]]},{"type":"Polygon","id":21129,"arcs":[[-5195,5285,5286,5287,-5196,-5137]]},{"type":"Polygon","id":21021,"arcs":[[-5209,5288,5289,-5281,-5148,-5123]]},{"type":"Polygon","id":51087,"arcs":[[5290,5291,5292,5293,5294,5295,-5166,-5081]]},{"type":"Polygon","id":6081,"arcs":[[5296,5297,5298,5299,-5203]]},{"type":"Polygon","id":21025,"arcs":[[-5187,5300,5301,5302,-5286,-5194]]},{"type":"Polygon","id":51145,"arcs":[[5303,5304,-5241,-5167]]},{"type":"Polygon","id":21149,"arcs":[[-5259,5305,5306,5307,-5113,-5140]]},{"type":"Polygon","id":20037,"arcs":[[-5044,5308,5309,5310,5311,-5274,-5059]]},{"type":"Polygon","id":51045,"arcs":[[5312,5313,5314,-5284,-5130,-5223]]},{"type":"Polygon","id":8023,"arcs":[[-5220,5315,5316,5317,-5239,-5077]]},{"type":"Polygon","id":29011,"arcs":[[-5175,5318,5319,-5309,-5043]]},{"type":"Polygon","id":21233,"arcs":[[5320,5321,5322,-5178,-5114,-5308]]},{"type":"Polygon","id":29123,"arcs":[[-5172,5323,5324,-5249,-5035]]},{"type":"Polygon","id":8009,"arcs":[[-5255,5325,5326,5327,-5217,-4892,-4884]]},{"type":"Polygon","id":8083,"arcs":[[5328,5329,-4739,-5184]]},{"type":"Polygon","id":8067,"arcs":[[-4997,5330,5331,-5329,-5120]]},{"type":"Polygon","id":6047,"arcs":[[-5234,5332,5333,5334,-5037,-5177]]},{"type":"Polygon","id":21137,"arcs":[[5335,5336,5337,-5289,-5208]]},{"type":"Polygon","id":51127,"arcs":[[5338,5339,5340,-5291,-5080,-5159]]},{"type":"Polygon","id":21085,"arcs":[[-5089,5341,5342,5343,-5256,-5052]]},{"type":"Polygon","id":51019,"arcs":[[5344,5345,5346,5347,5348,-5221,-5028,-5216],[5349]]},{"type":"Polygon","id":49053,"arcs":[[5350,5351,-4612,-4991]]},{"type":"Polygon","id":20049,"arcs":[[-5273,5352,5353,5354,-5021,-4971]]},{"type":"Polygon","id":29179,"arcs":[[5355,5356,5357,-5225,-5251]]},{"type":"Polygon","id":29031,"arcs":[[5358,5359,5360,5361,5362,-5170]]},{"type":"Polygon","id":29215,"arcs":[[-4978,-5227,5363,5364,5365,5366,-5181,-5074]]},{"type":"Polygon","id":17069,"arcs":[[-5146,-5180,5367,5368,5369,-5155]]},{"type":"Polygon","id":17151,"arcs":[[-5370,5370,5371,5372,-5156]]},{"type":"Polygon","id":51760,"arcs":[[5373,-5295]]},{"type":"Polygon","id":17087,"arcs":[[-5373,5374,5375,5376,-5192]]},{"type":"Polygon","id":17181,"arcs":[[-5193,-5377,5377,5378,-5359,-5169,-5134]]},{"type":"MultiPolygon","id":51073,"arcs":[[[5379,5380,5381,-5117,-5235]]]},{"type":"Polygon","id":29017,"arcs":[[-5363,5382,5383,-5324,-5171]]},{"type":"Polygon","id":54055,"arcs":[[-5190,5384,5385,5386,5387,-5228,-5102]]},{"type":"Polygon","id":6019,"arcs":[[5388,5389,5390,5391,5392,-5333,-5233,-4558]]},{"type":"Polygon","id":29057,"arcs":[[-5206,5393,5394,5395,-5319,-5174]]},{"type":"Polygon","id":21109,"arcs":[[-5288,5396,5397,5398,5399,-5142,-5197]]},{"type":"Polygon","id":21107,"arcs":[[5400,5401,5402,-5321,-5307]]},{"type":"MultiPolygon","id":51041,"arcs":[[[-5374,-5294,5403,5404,5405,5406,5407,5408,5409,5410,-5304,-5296]]]},{"type":"Polygon","id":51011,"arcs":[[5411,5412,5413,-5213,-5049,-5232]]},{"type":"MultiPolygon","id":51131,"arcs":[[[5414,-5065]]]},{"type":"Polygon","id":21045,"arcs":[[-5338,5415,5416,5417,5418,-5282,-5290]]},{"type":"Polygon","id":54047,"arcs":[[-5388,5419,5420,-5108,-5229]]},{"type":"Polygon","id":21055,"arcs":[[-5323,5421,5422,5423,-5368,-5179]]},{"type":"Polygon","id":49025,"arcs":[[-4980,-4743,5424,5425,-5351,-4990]]},{"type":"Polygon","id":21189,"arcs":[[-5303,5426,5427,-5397,-5287]]},{"type":"Polygon","id":21203,"arcs":[[-5400,5428,5429,-5336,-5207,-5143]]},{"type":"Polygon","id":51027,"arcs":[[-5421,5430,5431,5432,-5244,-5109]]},{"type":"MultiPolygon","id":51115,"arcs":[[[-5381,5433]]]},{"type":"Polygon","id":21119,"arcs":[[-5186,-5238,-5248,5434,5435,-5301]]},{"type":"Polygon","id":51007,"arcs":[[-5411,5436,5437,5438,-5242,-5305]]},{"type":"Polygon","id":51036,"arcs":[[5439,5440,-5292,-5341]]},{"type":"Polygon","id":29225,"arcs":[[-5183,5441,5442,5443,5444,-5161]]},{"type":"Polygon","id":6085,"arcs":[[-5038,-5335,5445,5446,-5298,5447,-5164]]},{"type":"Polygon","id":21217,"arcs":[[-5283,-5419,5448,5449,-5278]]},{"type":"Polygon","id":29229,"arcs":[[-5367,5450,-5442,-5182]]},{"type":"Polygon","id":51071,"arcs":[[-5315,5451,5452,5453,-5385,-5189,-5285]]},{"type":"Polygon","id":20035,"arcs":[[-5355,5454,5455,5456,5457,-5022]]},{"type":"Polygon","id":20191,"arcs":[[-5458,5458,5459,5460,-5268,-5153]]},{"type":"Polygon","id":20119,"arcs":[[-5152,5461,5462,5463,-5262,-5097]]},{"type":"Polygon","id":20025,"arcs":[[-5267,5464,5465,5466,-5462,-5151]]},{"type":"Polygon","id":20007,"arcs":[[-5270,5467,5468,5469,5470,-5265,-5211]]},{"type":"Polygon","id":21087,"arcs":[[-5450,5471,5472,5473,-5279]]},{"type":"Polygon","id":51680,"arcs":[[-5215,5474,-5345]]},{"type":"Polygon","id":6027,"arcs":[[-4763,-4239,5475,5476,5477,5478,-5389,-4557]]},{"type":"MultiPolygon","id":51095,"arcs":[[[5479,5480,5481,5482,-5440,-5340,5483,5484,5485]]]},{"type":"Polygon","id":21099,"arcs":[[-5280,-5474,5486,5487,5488,-5342,-5088]]},{"type":"Polygon","id":21193,"arcs":[[-5436,5489,5490,5491,5492,-5427,-5302]]},{"type":"Polygon","id":51031,"arcs":[[-5414,5493,5494,5495,-5346,-5475,-5214]]},{"type":"Polygon","id":29077,"arcs":[[-5162,-5445,5496,5497,-5394,-5205]]},{"type":"Polygon","id":21139,"arcs":[[-5424,5498,5499,5500,5501,-5371,-5369]]},{"type":"Polygon","id":29203,"arcs":[[-5358,5502,5503,5504,-5364,-5226]]},{"type":"Polygon","id":8007,"arcs":[[-5126,-5202,5505,5506,5507,-5331,-4996]]},{"type":"Polygon","id":51161,"arcs":[[-5349,5508,5509,5510,-5313,-5222],[5511,5512]]},{"type":"Polygon","id":21177,"arcs":[[5513,5514,5515,5516,-5401,-5306,-5258]]},{"type":"Polygon","id":51147,"arcs":[[-5243,-5439,5517,5518,5519,-5412,-5231]]},{"type":"Polygon","id":8021,"arcs":[[-5201,-5240,-5318,5520,5521,-5506]]},{"type":"Polygon","id":21031,"arcs":[[5522,5523,-5514,-5257,-5344,5524]]},{"type":"Polygon","id":20129,"arcs":[[5525,5526,5527,-5326,-5254]]},{"type":"Polygon","id":20189,"arcs":[[-5264,5528,5529,-5526,-5253,-5261]]},{"type":"Polygon","id":20175,"arcs":[[-5464,5530,5531,-5529,-5263]]},{"type":"Polygon","id":20125,"arcs":[[-5272,-5276,5532,5533,5534,5535,-5353]]},{"type":"Polygon","id":20077,"arcs":[[5536,5537,-5468,-5269,-5461]]},{"type":"Polygon","id":20033,"arcs":[[5538,5539,-5465,-5266,-5471]]},{"type":"Polygon","id":20099,"arcs":[[-5312,5540,5541,5542,-5533,-5275]]},{"type":"Polygon","id":21033,"arcs":[[-5403,5543,5544,5545,-5422,-5322]]},{"type":"MultiPolygon","id":51199,"arcs":[[[5546,5547,5548,5549,-5481,5550,-5485]]]},{"type":"Polygon","id":29097,"arcs":[[-5396,5551,5552,5553,-5310,-5320]]},{"type":"Polygon","id":51121,"arcs":[[5554,5555,5556,5557,-5452,-5314,-5511]]},{"type":"Polygon","id":51515,"arcs":[[-5350]]},{"type":"Polygon","id":21051,"arcs":[[-5493,5558,5559,5560,5561,-5398,-5428]]},{"type":"Polygon","id":21199,"arcs":[[5562,5563,5564,-5416,-5337,-5430,5565]]},{"type":"Polygon","id":20021,"arcs":[[-5554,5566,5567,5568,-5541,-5311]]},{"type":"Polygon","id":21061,"arcs":[[-5489,5569,5570,-5525,-5343]]},{"type":"Polygon","id":51770,"arcs":[[5571,-5513]]},{"type":"Polygon","id":17127,"arcs":[[-5502,5572,5573,-5375,-5372]]},{"type":"Polygon","id":51185,"arcs":[[-5387,5574,5575,5576,-5431,-5420]]},{"type":"Polygon","id":17003,"arcs":[[5577,5578,5579,5580,-5360,-5379]]},{"type":"Polygon","id":21125,"arcs":[[-5562,5581,5582,5583,-5566,-5429,-5399]]},{"type":"Polygon","id":17153,"arcs":[[-5376,-5574,5584,5585,-5578,-5378]]},{"type":"Polygon","id":51775,"arcs":[[-5572,-5512]]},{"type":"Polygon","id":21131,"arcs":[[5586,5587,-5559,-5492]]},{"type":"Polygon","id":51670,"arcs":[[5588,-5405,5589]]},{"type":"Polygon","id":29223,"arcs":[[-5384,5590,5591,5592,-5356,-5250,-5325]]},{"type":"Polygon","id":51149,"arcs":[[5593,5594,5595,5596,5597,-5406,-5589]]},{"type":"Polygon","id":51830,"arcs":[[5598,-5486,-5551,-5480]]},{"type":"Polygon","id":21001,"arcs":[[-5418,5599,5600,5601,-5472,-5449]]},{"type":"Polygon","id":51051,"arcs":[[5602,5603,-5245,-5433]]},{"type":"Polygon","id":20019,"arcs":[[-5536,5604,5605,-5455,-5354]]},{"type":"Polygon","id":51021,"arcs":[[5606,5607,5608,-5575,-5386,-5454]]},{"type":"Polygon","id":51570,"arcs":[[5609,-5408]]},{"type":"Polygon","id":51135,"arcs":[[5610,5611,-5518,-5438,5612]]},{"type":"Polygon","id":29109,"arcs":[[-5498,5613,5614,5615,5616,-5552,-5395]]},{"type":"Polygon","id":6087,"arcs":[[5617,5618,5619,-5299,-5447]]},{"type":"Polygon","id":51053,"arcs":[[5620,-5597,5621,5622,5623,-5613,-5437,-5410]]},{"type":"Polygon","id":21133,"arcs":[[-5247,5624,5625,-5490,-5435]]},{"type":"Polygon","id":29201,"arcs":[[5626,5627,5628,-5361,-5581]]},{"type":"Polygon","id":51037,"arcs":[[5629,5630,5631,-5494,-5413,-5520]]},{"type":"Polygon","id":51155,"arcs":[[5632,-5556,5633,5634,5635,-5607,-5453,-5558]]},{"type":"Polygon","id":51730,"arcs":[[-5621,-5409,-5610,-5407,-5598]]},{"type":"Polygon","id":51181,"arcs":[[5636,5637,5638,-5595,5639]]},{"type":"Polygon","id":51067,"arcs":[[5640,5641,5642,5643,-5509,-5348]]},{"type":"Polygon","id":21007,"arcs":[[5644,5645,-5579,-5586,5646]]},{"type":"Polygon","id":21145,"arcs":[[-5501,5647,5648,5649,-5647,-5585,-5573]]},{"type":"Polygon","id":51700,"arcs":[[5650,5651,-5482,-5550]]},{"type":"Polygon","id":51195,"arcs":[[5652,5653,5654,5655,-5625,-5246,-5604],[5656]]},{"type":"Polygon","id":21227,"arcs":[[-5571,5657,5658,5659,5660,-5523]]},{"type":"Polygon","id":21207,"arcs":[[-5565,5661,5662,5663,-5600,-5417]]},{"type":"Polygon","id":21169,"arcs":[[-5602,5664,5665,5666,-5487,-5473]]},{"type":"Polygon","id":21143,"arcs":[[-5546,5667,5668,-5499,-5423]]},{"type":"MultiPolygon","id":51735,"arcs":[[[5669,5670,-5548,5671]]]},{"type":"Polygon","id":21009,"arcs":[[5672,5673,-5658,-5570,-5488,-5667]]},{"type":"Polygon","id":21047,"arcs":[[-5517,5674,5675,5676,5677,-5544,-5402]]},{"type":"Polygon","id":51750,"arcs":[[-5633,-5557]]},{"type":"Polygon","id":51093,"arcs":[[5678,5679,5680,5681,-5637,5682]]},{"type":"Polygon","id":51167,"arcs":[[5683,5684,5685,-5653,-5603,-5432,-5577]]},{"type":"Polygon","id":51143,"arcs":[[5686,5687,5688,5689,5690,5691,-5641,-5347,-5496]]},{"type":"Polygon","id":51063,"arcs":[[-5644,5692,5693,-5634,-5555,-5510]]},{"type":"Polygon","id":29207,"arcs":[[-5362,-5629,5694,5695,5696,-5591,-5383]]},{"type":"Polygon","id":51111,"arcs":[[-5612,5697,5698,-5630,-5519]]},{"type":"Polygon","id":51650,"arcs":[[-5651,-5549,-5671,5699]]},{"type":"Polygon","id":51183,"arcs":[[5700,5701,-5622,-5596,-5639]]},{"type":"Polygon","id":29035,"arcs":[[-5593,5702,5703,5704,-5503,-5357]]},{"type":"Polygon","id":29043,"arcs":[[-5444,5705,5706,5707,-5614,-5497]]},{"type":"Polygon","id":51197,"arcs":[[5708,5709,5710,-5608,-5636]]},{"type":"Polygon","id":21141,"arcs":[[5711,5712,5713,-5515,-5524,-5661]]},{"type":"Polygon","id":21219,"arcs":[[-5714,5714,5715,-5675,-5516]]},{"type":"Polygon","id":29067,"arcs":[[-5451,-5366,5716,5717,5718,-5706,-5443]]},{"type":"Polygon","id":21157,"arcs":[[-5669,5719,5720,5721,-5648,-5500]]},{"type":"Polygon","id":29133,"arcs":[[-5646,5722,5723,5724,5725,-5627,-5580]]},{"type":"Polygon","id":51083,"arcs":[[-5632,5726,5727,5728,5729,-5687,-5495]]},{"type":"Polygon","id":29091,"arcs":[[-5505,5730,5731,5732,-5717,-5365]]},{"type":"Polygon","id":29145,"arcs":[[-5617,5733,5734,5735,-5567,-5553]]},{"type":"Polygon","id":21121,"arcs":[[5736,5737,-5582,-5561]]},{"type":"Polygon","id":51025,"arcs":[[-5624,5738,5739,5740,5741,-5698,-5611]]},{"type":"Polygon","id":21095,"arcs":[[-5626,-5656,5742,5743,-5587,-5491]]},{"type":"Polygon","id":51173,"arcs":[[-5609,-5711,5744,5745,-5684,-5576]]},{"type":"Polygon","id":4017,"arcs":[[5746,5747,5748,5749,-4741]]},{"type":"Polygon","id":4005,"arcs":[[-5750,5750,5751,5752,-5425,-4742]]},{"type":"Polygon","id":21221,"arcs":[[5753,5754,-5720,-5668,-5545,-5678]]},{"type":"Polygon","id":40105,"arcs":[[-5543,5755,5756,5757,-5534]]},{"type":"Polygon","id":40113,"arcs":[[5758,5759,5760,5761,5762,-5456,-5606]]},{"type":"Polygon","id":40151,"arcs":[[-5470,5763,5764,5765,5766,-5539]]},{"type":"Polygon","id":40035,"arcs":[[-5569,5767,5768,5769,5770,-5756,-5542]]},{"type":"Polygon","id":40147,"arcs":[[-5758,5771,5772,-5759,-5605,-5535]]},{"type":"Polygon","id":40053,"arcs":[[5773,5774,5775,-5537,-5460]]},{"type":"Polygon","id":40003,"arcs":[[-5538,-5776,5776,5777,-5764,-5469]]},{"type":"Polygon","id":40071,"arcs":[[-5763,5778,5779,-5774,-5459,-5457]]},{"type":"Polygon","id":40115,"arcs":[[-5736,5780,5781,-5768,-5568]]},{"type":"Polygon","id":40059,"arcs":[[-5540,-5767,5782,5783,5784,-5466]]},{"type":"Polygon","id":35039,"arcs":[[-5522,5785,5786,5787,5788,5789,5790,-5507]]},{"type":"Polygon","id":35045,"arcs":[[-5791,5791,5792,5793,-5330,-5332,-5508]]},{"type":"Polygon","id":4001,"arcs":[[-5794,5794,5795,5796,5797,5798,-5747,-4740]]},{"type":"Polygon","id":35059,"arcs":[[5799,5800,5801,5802,5803,5804,-5218,-5328]]},{"type":"Polygon","id":40025,"arcs":[[-5528,5805,5806,5807,-5800,-5327]]},{"type":"Polygon","id":40139,"arcs":[[5808,5809,5810,5811,-5806,-5527,-5530,-5532]]},{"type":"Polygon","id":40007,"arcs":[[-5467,-5785,5812,5813,5814,-5809,-5531,-5463]]},{"type":"Polygon","id":51175,"arcs":[[5815,-5680,5816,5817,5818,5819,5820,-5701,-5638,-5682]]},{"type":"Polygon","id":21231,"arcs":[[5821,5822,5823,5824,-5662,-5564]]},{"type":"Polygon","id":35055,"arcs":[[5825,5826,-5786,-5521,-5317]]},{"type":"Polygon","id":35007,"arcs":[[-5805,5827,5828,-5826,-5316,-5219]]},{"type":"Polygon","id":29209,"arcs":[[5829,5830,5831,-5615,-5708]]},{"type":"Polygon","id":6069,"arcs":[[-5334,-5393,5832,-5618,-5446]]},{"type":"Polygon","id":21235,"arcs":[[-5738,5833,5834,5835,5836,-5583]]},{"type":"MultiPolygon","id":51710,"arcs":[[[5837,5838,5839]],[[5840,5841]]]},{"type":"Polygon","id":21147,"arcs":[[-5837,5842,5843,-5822,-5563,-5584]]},{"type":"Polygon","id":51720,"arcs":[[-5657]]},{"type":"Polygon","id":21013,"arcs":[[-5588,-5744,5844,5845,-5834,-5737,-5560]]},{"type":"Polygon","id":21039,"arcs":[[-5650,5846,5847,-5723,-5645]]},{"type":"Polygon","id":21083,"arcs":[[-5722,5848,5849,5850,5851,-5847,-5649]]},{"type":"Polygon","id":21057,"arcs":[[5852,5853,5854,-5665,-5601,-5664]]},{"type":"Polygon","id":21003,"arcs":[[-5674,5855,5856,5857,5858,-5659]]},{"type":"Polygon","id":29009,"arcs":[[-5832,5859,5860,5861,-5734,-5616]]},{"type":"MultiPolygon","id":51810,"arcs":[[[5862,5863,5864]],[[5865,5866,5867,5868,5869,5870,5871,-5841,5872]]]},{"type":"Polygon","id":51035,"arcs":[[5873,5874,5875,5876,5877,-5709,-5635,-5694]]},{"type":"Polygon","id":51191,"arcs":[[5878,5879,5880,5881,-5685,-5746,5882,5883,5884,5885]]},{"type":"Polygon","id":29023,"arcs":[[-5697,5886,5887,5888,-5703,-5592]]},{"type":"MultiPolygon","id":51740,"arcs":[[[-5839,5889,5890]],[[5891,5892,5893]]]},{"type":"Polygon","id":51800,"arcs":[[-5893,5894,5895,5896,-5817,-5679,5897]]},{"type":"Polygon","id":6053,"arcs":[[-5833,-5392,5898,5899,5900,-5619]]},{"type":"Polygon","id":51081,"arcs":[[-5702,-5821,5901,-5739,-5623],[5902]]},{"type":"Polygon","id":51105,"arcs":[[5903,5904,5905,-5845,-5743,-5655]]},{"type":"Polygon","id":51117,"arcs":[[-5742,5906,5907,5908,-5727,-5631,-5699]]},{"type":"Polygon","id":21053,"arcs":[[-5825,5909,5910,-5853,-5663]]},{"type":"Polygon","id":29149,"arcs":[[-5705,5911,5912,5913,5914,-5731,-5504]]},{"type":"Polygon","id":51169,"arcs":[[-5686,-5882,5915,5916,5917,-5904,-5654]]},{"type":"Polygon","id":21213,"arcs":[[5918,5919,-5712,-5660,-5859]]},{"type":"Polygon","id":51141,"arcs":[[5920,5921,5922,-5874,-5693,-5643]]},{"type":"Polygon","id":29143,"arcs":[[-5726,5923,5924,5925,5926,5927,5928,-5695,-5628]]},{"type":"Polygon","id":51550,"arcs":[[5929,-5890,-5838,5930,-5871,5931,5932,-5895,-5892]]},{"type":"Polygon","id":51089,"arcs":[[5933,5934,-5921,-5642,-5692],[5935]]},{"type":"Polygon","id":32003,"arcs":[[5936,5937,-5476,-4238,-4614]]},{"type":"Polygon","id":21171,"arcs":[[-5855,5938,5939,-5856,-5673,-5666]]},{"type":"Polygon","id":29181,"arcs":[[-5889,5940,5941,-5912,-5704]]},{"type":"Polygon","id":29213,"arcs":[[-5719,5942,5943,5944,5945,-5830,-5707]]},{"type":"Polygon","id":40153,"arcs":[[5946,5947,5948,-5783,-5766]]},{"type":"Polygon","id":51077,"arcs":[[-5878,5949,-5876,5950,5951,5952,5953,-5883,-5745,-5710]]},{"type":"Polygon","id":29153,"arcs":[[-5733,5954,5955,5956,-5943,-5718]]},{"type":"Polygon","id":21105,"arcs":[[-5852,5957,5958,5959,-5724,-5848]]},{"type":"Polygon","id":29119,"arcs":[[-5862,5960,5961,-5781,-5735]]},{"type":"Polygon","id":21035,"arcs":[[-5755,5962,5963,-5849,-5721]]},{"type":"Polygon","id":6107,"arcs":[[5964,5965,-5390,-5479]]},{"type":"Polygon","id":51595,"arcs":[[-5903]]},{"type":"Polygon","id":51690,"arcs":[[-5936]]},{"type":"Polygon","id":51620,"arcs":[[-5816,-5681]]},{"type":"Polygon","id":51640,"arcs":[[-5950,-5877]]},{"type":"Polygon","id":47161,"arcs":[[-5677,5966,5967,5968,5969,-5963,-5754]]},{"type":"Polygon","id":40041,"arcs":[[-5962,5970,5971,5972,5973,-5769,-5782]]},{"type":"Polygon","id":47147,"arcs":[[5974,5975,5976,-5715,-5713,-5920,5977]]},{"type":"Polygon","id":47165,"arcs":[[5978,5979,5980,5981,-5978,-5919,-5858]]},{"type":"MultiPolygon","id":21075,"arcs":[[[5982,-5926]],[[5983,5984,-5924,-5725,-5960]]]},{"type":"Polygon","id":47125,"arcs":[[-5977,5985,5986,5987,-5967,-5676,-5716]]},{"type":"Polygon","id":51590,"arcs":[[5988,-5689]]},{"type":"Polygon","id":47111,"arcs":[[5989,5990,5991,-5979,-5857,-5940,5992]]},{"type":"MultiPolygon","id":51520,"arcs":[[[-5879]],[[-5886,5993,-5880]]]},{"type":"Polygon","id":29069,"arcs":[[-5929,5994,5995,5996,5997,5998,-5887,-5696]]},{"type":"Polygon","id":47137,"arcs":[[5999,6000,6001,6002,-5910,-5824]]},{"type":"Polygon","id":47027,"arcs":[[6003,6004,-5993,-5939,-5854,-5911,-6003]]},{"type":"Polygon","id":47163,"arcs":[[6005,6006,6007,-5916,-5881,-5994,-5885,6008]]},{"type":"Polygon","id":47091,"arcs":[[-5954,6009,6010,6011,6012,-6009,-5884]]},{"type":"Polygon","id":47151,"arcs":[[6013,6014,6015,6016,-6000,-5823,-5844]]},{"type":"Polygon","id":47025,"arcs":[[6017,6018,6019,6020,-5835,-5846,-5906]]},{"type":"Polygon","id":40103,"arcs":[[6021,6022,6023,6024,-5779,-5762]]},{"type":"Polygon","id":47067,"arcs":[[-5918,6025,6026,-6018,-5905]]},{"type":"Polygon","id":40131,"arcs":[[6027,6028,6029,-5772,-5757,-5771]]},{"type":"Polygon","id":47013,"arcs":[[6030,6031,-6014,-5843,-5836,-6021]]},{"type":"Polygon","id":47073,"arcs":[[-6008,6032,6033,6034,6035,-6026,-5917]]},{"type":"Polygon","id":40047,"arcs":[[-5780,-6025,6036,6037,6038,-5777,-5775]]},{"type":"Polygon","id":40045,"arcs":[[-5949,6039,6040,6041,6042,-5813,-5784]]},{"type":"Polygon","id":37009,"arcs":[[6043,6044,6045,-6010,-5953]]},{"type":"Polygon","id":47049,"arcs":[[-6017,6046,6047,6048,6049,-6001]]},{"type":"Polygon","id":37005,"arcs":[[6050,6051,-6044,-5952]]},{"type":"Polygon","id":40117,"arcs":[[6052,6053,6054,-6022,-5761]]},{"type":"Polygon","id":37171,"arcs":[[-5923,6055,6056,6057,6058,-6051,-5951,-5875]]},{"type":"Polygon","id":37073,"arcs":[[6059,6060,6061,6062,6063,6064,-5818,-5897]]},{"type":"MultiPolygon","id":37053,"arcs":[[[6065,6066,-5932,-5870,6067]],[[-5866,6068,6069,6070]],[[-6072,5863,-6073,5867]]]},{"type":"Polygon","id":37169,"arcs":[[-5935,6073,6074,-6056,-5922]]},{"type":"Polygon","id":37029,"arcs":[[-5896,-5933,-6067,6075,6076,-6060]]},{"type":"Polygon","id":37185,"arcs":[[6077,6078,6079,6080,-5907,-5741]]},{"type":"Polygon","id":37131,"arcs":[[6081,6082,-6078,-5740,-5902,-5820,6083]]},{"type":"Polygon","id":37091,"arcs":[[-6065,6084,6085,-6084,-5819]]},{"type":"Polygon","id":37145,"arcs":[[6086,6087,6088,6089,-5729]]},{"type":"Polygon","id":37181,"arcs":[[-6081,6090,6091,-5908]]},{"type":"Polygon","id":37077,"arcs":[[6092,6093,6094,-6087,-5728,-5909,-6092]]},{"type":"Polygon","id":37157,"arcs":[[-5691,6095,6096,6097,-6074,-5934]]},{"type":"Polygon","id":37033,"arcs":[[-6090,6098,6099,-6096,-5690,-5989,-5688,-5730]]},{"type":"Polygon","id":47133,"arcs":[[-6050,6100,6101,-6004,-6002]]},{"type":"Polygon","id":47087,"arcs":[[-6102,6102,6103,-5990,-6005]]},{"type":"Polygon","id":37083,"arcs":[[6104,6105,6106,6107,-6079,-6083]]},{"type":"Polygon","id":40097,"arcs":[[-5974,6108,6109,-6028,-5770]]},{"type":"Polygon","id":47019,"arcs":[[6110,6111,6112,6113,-6006,-6013]]},{"type":"Polygon","id":37139,"arcs":[[6114,6115,-6061,-6077]]},{"type":"Polygon","id":47131,"arcs":[[-5959,6116,6117,6118,6119,-5984]]},{"type":"Polygon","id":40093,"arcs":[[-5778,-6039,6120,6121,6122,-5947,-5765]]},{"type":"Polygon","id":47183,"arcs":[[6123,6124,6125,-6117,-5958,-5851]]},{"type":"Polygon","id":47095,"arcs":[[6126,6127,-5927,-5983,-5925,-5985,-6120]]},{"type":"Polygon","id":48421,"arcs":[[6128,6129,-5807,-5812,6130]]},{"type":"Polygon","id":47079,"arcs":[[-5970,6131,6132,-6124,-5850,-5964]]},{"type":"Polygon","id":48195,"arcs":[[6133,6134,-6131,-5811,6135]]},{"type":"Polygon","id":48111,"arcs":[[-5808,-6130,6136,-5801]]},{"type":"Polygon","id":48357,"arcs":[[6137,6138,-6136,-5810,-5815]]},{"type":"Polygon","id":48295,"arcs":[[6139,6140,-6138,-5814,-6043]]},{"type":"Polygon","id":5007,"arcs":[[-5861,6141,6142,6143,6144,-5971,-5961]]},{"type":"Polygon","id":5049,"arcs":[[6145,6146,6147,-5955,-5732,-5915]]},{"type":"Polygon","id":5015,"arcs":[[-5831,-5946,6148,6149,6150,-6142,-5860]]},{"type":"Polygon","id":5135,"arcs":[[-5914,6151,6152,6153,6154,-6146]]},{"type":"Polygon","id":5121,"arcs":[[6155,6156,-6152,-5913,-5942,6157]]},{"type":"Polygon","id":5009,"arcs":[[6158,6159,6160,-6149,-5945]]},{"type":"Polygon","id":5089,"arcs":[[6161,6162,-6159,-5944,-5957]]},{"type":"Polygon","id":5005,"arcs":[[-6148,6163,6164,6165,-6162,-5956]]},{"type":"Polygon","id":5021,"arcs":[[-5888,-5999,6166,-6158,-5941]]},{"type":"Polygon","id":6031,"arcs":[[6167,6168,-5899,-5391,-5966]]},{"type":"Polygon","id":47169,"arcs":[[-5992,6169,6170,-5980]]},{"type":"Polygon","id":47021,"arcs":[[6171,6172,6173,-5986,-5976],[6174]]},{"type":"Polygon","id":47179,"arcs":[[-6114,6175,6176,-6033,-6007]]},{"type":"Polygon","id":37193,"arcs":[[-6059,6177,6178,6179,6180,6181,-6045,-6052]]},{"type":"Polygon","id":47173,"arcs":[[6182,6183,6184,-6031,-6020]]},{"type":"Polygon","id":47159,"arcs":[[-6104,6185,6186,6187,-6170,-5991]]},{"type":"Polygon","id":29155,"arcs":[[-6128,6188,6189,-5995,-5928]]},{"type":"Polygon","id":40143,"arcs":[[-6030,6190,6191,6192,-6053,-5760,-5773]]},{"type":"Polygon","id":47057,"arcs":[[-6027,-6036,6193,6194,6195,-6183,-6019]]},{"type":"Polygon","id":47037,"arcs":[[-5982,6196,6197,6198,-6172,-5975]]},{"type":"Polygon","id":47059,"arcs":[[6199,6200,6201,6202,-6034,-6177]]},{"type":"Polygon","id":37189,"arcs":[[-6182,6203,6204,-6011,-6046]]},{"type":"Polygon","id":37143,"arcs":[[6205,6206,-6062,-6116]]},{"type":"Polygon","id":47129,"arcs":[[-6016,6207,6208,6209,-6047]]},{"type":"Polygon","id":47083,"arcs":[[-5988,6210,6211,6212,-5968]]},{"type":"Polygon","id":47005,"arcs":[[-6213,6213,6214,6215,6216,-6132,-5969]]},{"type":"Polygon","id":47189,"arcs":[[-6171,-6188,6217,6218,6219,-6197,-5981]]},{"type":"MultiPolygon","id":37041,"arcs":[[[6220,-6063,-6207]]]},{"type":"Polygon","id":47063,"arcs":[[-6203,6221,6222,-6194,-6035]]},{"type":"MultiPolygon","id":47043,"arcs":[[[-6175]],[[-6174,6223,6224,6225,-6211,-5987]]]},{"type":"Polygon","id":5087,"arcs":[[6226,6227,6228,6229,6230,-6143,-6151]]},{"type":"Polygon","id":47141,"arcs":[[-6049,6231,6232,6233,-6186,-6103,-6101]]},{"type":"Polygon","id":47001,"arcs":[[-6185,6234,6235,-6208,-6015,-6032]]},{"type":"Polygon","id":37197,"arcs":[[6236,6237,6238,-6178,-6058]]},{"type":"Polygon","id":37011,"arcs":[[6239,6240,6241,6242,-6111,-6012,-6205]]},{"type":"Polygon","id":37069,"arcs":[[6243,6244,-6093,-6091,-6080]]},{"type":"Polygon","id":5055,"arcs":[[-5998,6245,6246,-6156,-6167]]},{"type":"Polygon","id":35033,"arcs":[[-5829,6247,6248,6249,-5787,-5827]]},{"type":"Polygon","id":37067,"arcs":[[6250,6251,6252,-6237,-6057,-6075]]},{"type":"Polygon","id":5065,"arcs":[[-6155,6253,6254,-6164,-6147]]},{"type":"Polygon","id":47171,"arcs":[[6255,6256,6257,-6200,-6176,-6113]]},{"type":"Polygon","id":5075,"arcs":[[-6247,6258,6259,6260,-6153,-6157]]},{"type":"Polygon","id":37081,"arcs":[[6261,6262,6263,-6251,-6098]]},{"type":"Polygon","id":37001,"arcs":[[6264,6265,6266,-6262,-6097,-6100]]},{"type":"Polygon","id":40119,"arcs":[[6267,6268,6269,-6023,-6055]]},{"type":"Polygon","id":47085,"arcs":[[-6226,6270,6271,-6214,-6212]]},{"type":"Polygon","id":37015,"arcs":[[6272,6273,6274,-6105,-6082,-6086]]},{"type":"Polygon","id":37135,"arcs":[[-6089,6275,6276,-6265,-6099]]},{"type":"Polygon","id":37063,"arcs":[[-6095,6277,6278,-6276,-6088]]},{"type":"Polygon","id":5143,"arcs":[[6279,6280,-6144,-6231]]},{"type":"MultiPolygon","id":37055,"arcs":[[[6281,6282,6283]],[[6284,6285]],[[-6070,6286]]]},{"type":"Polygon","id":47053,"arcs":[[6287,6288,6289,6290,-6118,-6126]]},{"type":"MultiPolygon","id":35043,"arcs":[[[6291,6292]],[[6293,6294,6295,6296,6297,-5792,-5790]]]},{"type":"Polygon","id":35021,"arcs":[[-5804,6298,6299,-6248,-5828]]},{"type":"Polygon","id":47045,"arcs":[[6300,6301,6302,-6189,-6127,-6119,-6291]]},{"type":"Polygon","id":37127,"arcs":[[-6108,6303,6304,6305,-6244]]},{"type":"Polygon","id":47089,"arcs":[[-6223,6306,6307,6308,-6195]]},{"type":"Polygon","id":47093,"arcs":[[-6309,6309,6310,6311,6312,-6235,-6184,-6196]]},{"type":"Polygon","id":47029,"arcs":[[6313,6314,6315,-6307,-6222,-6202]]},{"type":"Polygon","id":47035,"arcs":[[-6210,6316,6317,6318,6319,6320,6321,6322,-6232,-6048]]},{"type":"Polygon","id":40073,"arcs":[[6323,6324,6325,-6121,-6038]]},{"type":"Polygon","id":40083,"arcs":[[-6024,-6270,6326,6327,-6324,-6037]]},{"type":"Polygon","id":40011,"arcs":[[-6326,6328,6329,6330,6331,-6122]]},{"type":"Polygon","id":40043,"arcs":[[6332,6333,-6040,-5948,-6123,-6332]]},{"type":"Polygon","id":40037,"arcs":[[-6193,6334,6335,6336,-6268,-6054]]},{"type":"Polygon","id":40145,"arcs":[[-6110,6337,6338,6339,-6191,-6029]]},{"type":"Polygon","id":40021,"arcs":[[-5973,6340,6341,6342,-6338,-6109]]},{"type":"Polygon","id":40001,"arcs":[[-6145,-6281,6343,6344,-6341,-5972]]},{"type":"Polygon","id":37121,"arcs":[[-6243,6345,6346,-6256,-6112]]},{"type":"Polygon","id":37065,"arcs":[[6347,6348,6349,-6304,-6107]]},{"type":"Polygon","id":47017,"arcs":[[-6217,6350,6351,6352,-6288,-6125,-6133]]},{"type":"Polygon","id":47041,"arcs":[[6353,6354,6355,-6218,-6187,-6234]]},{"type":"Polygon","id":5137,"arcs":[[6356,6357,6358,6359,-6165,-6255]]},{"type":"Polygon","id":5101,"arcs":[[-6161,6360,6361,6362,-6227,-6150]]},{"type":"Polygon","id":37027,"arcs":[[-6181,6363,6364,6365,-6240,-6204]]},{"type":"Polygon","id":5129,"arcs":[[-6166,-6360,6366,6367,-6361,-6160,-6163]]},{"type":"Polygon","id":47149,"arcs":[[6368,6369,6370,6371,6372,-6198,-6220]]},{"type":"Polygon","id":37199,"arcs":[[6373,6374,6375,-6257,-6347]]},{"type":"MultiPolygon","id":47185,"arcs":[[[6376,-6321]],[[-6323,6377,6378,-6354,-6233]]]},{"type":"Polygon","id":37183,"arcs":[[-6245,6379,6380,6381,-6278,-6094]]},{"type":"Polygon","id":37117,"arcs":[[6382,6383,6384,-6348,-6106,-6275]]},{"type":"Polygon","id":37115,"arcs":[[-6258,-6376,6385,6386,-6314,-6201]]},{"type":"Polygon","id":37059,"arcs":[[6387,6388,6389,-6238,-6253]]},{"type":"Polygon","id":48393,"arcs":[[-6141,6390,6391,6392,6393,-6134,-6139]]},{"type":"Polygon","id":48211,"arcs":[[-6140,-6042,6394,6395,-6391]]},{"type":"Polygon","id":48233,"arcs":[[-6135,-6394,6396,6397]]},{"type":"Polygon","id":48205,"arcs":[[6398,6399,6400,-5802,-6137]]},{"type":"Polygon","id":37097,"arcs":[[-6239,-6390,6401,6402,6403,6404,6405,6406,-6179]]},{"type":"Polygon","id":48341,"arcs":[[-6398,6407,6408,6409,-6399,-6129]]},{"type":"Polygon","id":47187,"arcs":[[-6373,6410,6411,6412,-6224,-6173,-6199]]},{"type":"Polygon","id":37003,"arcs":[[6413,-6364,-6180,-6407]]},{"type":"Polygon","id":47145,"arcs":[[6414,6415,6416,6417,6418,-6317,-6209,-6236,-6313,6419]]},{"type":"Polygon","id":47155,"arcs":[[-6316,6420,6421,6422,-6310,-6308]]},{"type":"Polygon","id":37057,"arcs":[[-6264,6423,6424,6425,-6388,-6252]]},{"type":"Polygon","id":40129,"arcs":[[-6334,6426,6427,6428,-6395,-6041]]},{"type":"Polygon","id":35031,"arcs":[[-6298,6429,-5795,-5793]]},{"type":"Polygon","id":35049,"arcs":[[-6250,6430,6431,6432,-6295,6433,-6293,6434,-5788]]},{"type":"Polygon","id":5093,"arcs":[[6435,6436,6437,6438,6439,6440,6441,-5996,-6190,-6303]]},{"type":"Polygon","id":37023,"arcs":[[-6366,6442,6443,6444,6445,6446,-6241]]},{"type":"Polygon","id":47033,"arcs":[[6447,6448,6449,-6301,-6290]]},{"type":"Polygon","id":5031,"arcs":[[-6442,6450,6451,-6259,-6246,-5997]]},{"type":"Polygon","id":37177,"arcs":[[6452,6453,6454]]},{"type":"Polygon","id":47081,"arcs":[[-6413,6455,6456,6457,-6271,-6225]]},{"type":"Polygon","id":37187,"arcs":[[-6454,6458,6459,-6383,-6274,6460]]},{"type":"Polygon","id":35028,"arcs":[[-5789,-6435,-6292,-6434,-6294]]},{"type":"Polygon","id":47015,"arcs":[[6461,6462,-6369,-6219,-6356]]},{"type":"Polygon","id":37111,"arcs":[[6463,6464,-6374,-6346,-6242,-6447]]},{"type":"Polygon","id":47097,"arcs":[[-6450,6465,6466,-6436,-6302]]},{"type":"Polygon","id":40081,"arcs":[[-6337,6467,6468,6469,-6327,-6269]]},{"type":"Polygon","id":5063,"arcs":[[-6261,6470,6471,6472,-6357,-6254,-6154]]},{"type":"Polygon","id":37151,"arcs":[[-6267,6473,6474,6475,-6424,-6263]]},{"type":"MultiPolygon","id":47105,"arcs":[[[6476,6477]],[[-6415]],[[-6420,-6312,6478,6479,6480,-6416]]]},{"type":"Polygon","id":5067,"arcs":[[-6260,-6452,6481,6482,6483,6484,-6471]]},{"type":"Polygon","id":47009,"arcs":[[6485,6486,6487,-6479,-6311,-6423]]},{"type":"Polygon","id":37037,"arcs":[[-6279,-6382,6488,6489,6490,-6474,-6266,-6277]]},{"type":"Polygon","id":35047,"arcs":[[-6300,6491,6492,6493,-6431,-6249]]},{"type":"Polygon","id":37195,"arcs":[[6494,6495,6496,6497,-6305,-6350]]},{"type":"Polygon","id":37159,"arcs":[[-6426,6498,6499,-6402,-6389]]},{"type":"Polygon","id":40111,"arcs":[[-6192,-6340,6500,6501,6502,-6335]]},{"type":"Polygon","id":40101,"arcs":[[-6343,6503,6504,6505,-6501,-6339]]},{"type":"Polygon","id":47177,"arcs":[[-6379,6506,6507,6508,6509,-6462,-6355]]},{"type":"Polygon","id":47119,"arcs":[[6510,6511,6512,6513,-6456,-6412]]},{"type":"Polygon","id":47039,"arcs":[[6514,6515,6516,6517,-6351,-6216]]},{"type":"Polygon","id":47135,"arcs":[[-6458,6518,6519,-6515,-6215,-6272]]},{"type":"Polygon","id":37147,"arcs":[[-6385,6520,6521,6522,6523,6524,6525,-6495,-6349]]},{"type":"Polygon","id":37035,"arcs":[[-6406,6526,-6443,-6365,-6414]]},{"type":"Polygon","id":37021,"arcs":[[-6465,6527,6528,6529,-6386,-6375]]},{"type":"Polygon","id":47143,"arcs":[[6530,6531,6532,-6318,-6419]]},{"type":"Polygon","id":47175,"arcs":[[-6322,-6377,-6320,6533,6534,-6507,-6378]]},{"type":"Polygon","id":47077,"arcs":[[-6518,6535,6536,6537,-6352]]},{"type":"Polygon","id":47075,"arcs":[[6538,6539,6540,6541,-6466,-6449]]},{"type":"Polygon","id":37101,"arcs":[[-6498,6542,6543,6544,-6380,-6306]]},{"type":"Polygon","id":40039,"arcs":[[-6331,6545,6546,6547,-6427,-6333]]},{"type":"Polygon","id":6071,"arcs":[[6548,6549,6550,6551,6552,6553,-5477,-5938]]},{"type":"Polygon","id":6079,"arcs":[[-6169,6554,6555,6556,-5900]]},{"type":"Polygon","id":6029,"arcs":[[-6554,6557,6558,6559,-6555,-6168,-5965,-5478]]},{"type":"Polygon","id":47113,"arcs":[[-6353,-6538,6560,6561,-6539,-6448,-6289]]},{"type":"Polygon","id":5141,"arcs":[[-6359,6562,6563,6564,6565,-6367]]},{"type":"Polygon","id":37087,"arcs":[[-6530,6566,6567,6568,-6421,-6315,-6387]]},{"type":"Polygon","id":5047,"arcs":[[6569,6570,6571,-6229,6572]]},{"type":"Polygon","id":47007,"arcs":[[-6533,6573,6574,-6534,-6319]]},{"type":"Polygon","id":5071,"arcs":[[-6228,-6363,6575,6576,-6573]]},{"type":"Polygon","id":5033,"arcs":[[6577,6578,-6344,-6280,-6230,-6572]]},{"type":"Polygon","id":47121,"arcs":[[6579,6580,6581,-6531,-6418]]},{"type":"Polygon","id":35037,"arcs":[[-6401,6582,6583,6584,6585,6586,6587,-6492,-6299,-5803]]},{"type":"MultiPolygon","id":37013,"arcs":[[[6588,6589,6590,-6523]],[[-6460,6591,6592,-6521,-6384]]]},{"type":"Polygon","id":5115,"arcs":[[-6368,-6566,6593,6594,6595,-6576,-6362]]},{"type":"Polygon","id":40017,"arcs":[[6596,6597,6598,6599,6600,-6329,-6325]]},{"type":"Polygon","id":40109,"arcs":[[-6470,6601,6602,-6597,-6328]]},{"type":"Polygon","id":5023,"arcs":[[-6473,6603,6604,-6563,-6358]]},{"type":"Polygon","id":47117,"arcs":[[6605,6606,6607,-6511,-6411,-6372]]},{"type":"Polygon","id":5111,"arcs":[[-6441,6608,6609,-6482,-6451]]},{"type":"MultiPolygon","id":37095,"arcs":[[[-6283,6610]],[[-6453,6611,-6285,6612,-6592,-6459]]]},{"type":"Polygon","id":47031,"arcs":[[-6463,-6510,6613,6614,6615,6616,-6370]]},{"type":"Polygon","id":47003,"arcs":[[-6617,6617,6618,-6606,-6371]]},{"type":"Polygon","id":37173,"arcs":[[6619,6620,6621,-6486,-6422,-6569]]},{"type":"Polygon","id":47123,"arcs":[[-6488,6622,6623,6624,6625,-6478,6626,-6480]]},{"type":"Polygon","id":47101,"arcs":[[-6514,6627,6628,-6519,-6457]]},{"type":"Polygon","id":37079,"arcs":[[6629,6630,-6496,-6526]]},{"type":"MultiPolygon","id":47167,"arcs":[[[6631,6632,-6439]],[[-6542,6633,6634,-6437,-6467]]]},{"type":"Polygon","id":47107,"arcs":[[-6481,-6627,-6477,-6626,6635,6636,-6580,-6417]]},{"type":"Polygon","id":40135,"arcs":[[-6345,-6579,6637,6638,6639,-6504,-6342]]},{"type":"Polygon","id":40107,"arcs":[[-6503,6640,6641,6642,6643,-6468,-6336]]},{"type":"Polygon","id":37105,"arcs":[[6644,6645,-6490]]},{"type":"Polygon","id":48359,"arcs":[[-6410,6646,6647,-6583,-6400]]},{"type":"Polygon","id":48065,"arcs":[[-6393,6648,6649,6650,-6408,-6397]]},{"type":"Polygon","id":48179,"arcs":[[6651,6652,-6649,-6392]]},{"type":"Polygon","id":48483,"arcs":[[-6429,6653,6654,-6652,-6396]]},{"type":"Polygon","id":48375,"arcs":[[-6651,6655,-6647,-6409]]},{"type":"Polygon","id":37161,"arcs":[[6656,6657,6658,6659,6660,-6528,-6464,-6446]]},{"type":"Polygon","id":37191,"arcs":[[-6631,6661,6662,6663,-6543,-6497]]},{"type":"Polygon","id":47023,"arcs":[[6664,6665,6666,-6561,-6537]]},{"type":"Polygon","id":37085,"arcs":[[-6545,6667,6668,6669,-6645,-6489,-6381]]},{"type":"Polygon","id":37045,"arcs":[[6670,6671,6672,6673,-6657,-6445]]},{"type":"Polygon","id":37109,"arcs":[[-6405,6674,6675,-6671,-6444,-6527]]},{"type":"Polygon","id":47153,"arcs":[[6676,6677,6678,-6508,-6535,-6575]]},{"type":"Polygon","id":40091,"arcs":[[6679,6680,6681,-6641,-6502,-6506]]},{"type":"Polygon","id":40015,"arcs":[[-6601,6682,6683,6684,6685,-6546,-6330]]},{"type":"Polygon","id":5145,"arcs":[[-6485,6686,6687,6688,6689,-6604,-6472]]},{"type":"Polygon","id":47061,"arcs":[[6690,6691,-6614,-6509,-6679]]},{"type":"Polygon","id":4025,"arcs":[[6692,6693,6694,6695,-5752]]},{"type":"Polygon","id":37099,"arcs":[[-6568,6696,6697,6698,6699,-6620]]},{"type":"Polygon","id":37119,"arcs":[[6700,6701,6702,6703,6704,-6675,-6404]]},{"type":"Polygon","id":37125,"arcs":[[-6646,-6670,6705,6706,6707,6708,-6475,-6491]]},{"type":"Polygon","id":37123,"arcs":[[-6709,6709,6710,-6425,-6476]]},{"type":"Polygon","id":37025,"arcs":[[6711,6712,-6701,-6403,-6500]]},{"type":"Polygon","id":40009,"arcs":[[-6548,6713,6714,6715,6716,6717,-6654,-6428]]},{"type":"Polygon","id":37167,"arcs":[[-6711,6718,6719,-6712,-6499]]},{"type":"Polygon","id":37089,"arcs":[[-6661,6720,6721,6722,-6529]]},{"type":"Polygon","id":47181,"arcs":[[6723,6724,6725,-6516,-6520,-6629]]},{"type":"Polygon","id":40133,"arcs":[[6726,6727,6728,-6643]]},{"type":"Polygon","id":37075,"arcs":[[6729,6730,-6623,-6487,-6622]]},{"type":"Polygon","id":40149,"arcs":[[-6686,6731,-6714,-6547]]},{"type":"Polygon","id":40125,"arcs":[[-6644,-6729,6732,6733,6734,-6602,-6469]]},{"type":"Polygon","id":5029,"arcs":[[6735,6736,6737,-6594,-6565]]},{"type":"Polygon","id":47099,"arcs":[[-6513,6738,6739,-6724,-6628]]},{"type":"Polygon","id":40061,"arcs":[[6740,6741,6742,-6680,-6505,-6640]]},{"type":"Polygon","id":47065,"arcs":[[-6582,6743,6744,6745,6746,6747,-6677,-6574,-6532]]},{"type":"Polygon","id":47055,"arcs":[[-6608,6748,6749,6750,-6739,-6512]]},{"type":"Polygon","id":5131,"arcs":[[-6571,6751,6752,6753,-6638,-6578]]},{"type":"Polygon","id":5037,"arcs":[[6754,6755,6756,-6483,-6610]]},{"type":"Polygon","id":5147,"arcs":[[-6757,6757,6758,6759,-6687,-6484]]},{"type":"Polygon","id":5035,"arcs":[[-6440,-6633,6760,6761,6762,6763,6764,-6755,-6609]]},{"type":"Polygon","id":47069,"arcs":[[-6562,-6667,6765,6766,6767,6768,6769,-6540]]},{"type":"Polygon","id":37107,"arcs":[[6770,6771,6772,-6662,-6630,-6525]]},{"type":"Polygon","id":5083,"arcs":[[-6577,-6596,6773,6774,-6752,-6570]]},{"type":"Polygon","id":37175,"arcs":[[6775,6776,6777,-6697,-6567,-6723]]},{"type":"Polygon","id":47071,"arcs":[[-6726,6778,6779,6780,6781,-6665,-6536,-6517]]},{"type":"Polygon","id":37071,"arcs":[[-6705,6782,-6672,-6676]]},{"type":"MultiPolygon","id":37049,"arcs":[[[6783,6784,6785]],[[-6591,6786,6787,6788,-6771,-6524]]]},{"type":"Polygon","id":47127,"arcs":[[6789,6790,-6618,-6616]]},{"type":"Polygon","id":47157,"arcs":[[6791,6792,6793,-6761,-6632,-6438,-6635]]},{"type":"Polygon","id":37149,"arcs":[[6794,6795,-6721,-6660]]},{"type":"Polygon","id":47047,"arcs":[[-6770,6796,6797,-6792,-6634,-6541]]},{"type":"Polygon","id":47109,"arcs":[[-6782,6798,-6766,-6666]]},{"type":"Polygon","id":40079,"arcs":[[6799,6800,6801,6802,6803,-6741,-6639,-6754]]},{"type":"Polygon","id":40051,"arcs":[[6804,6805,6806,6807,-6683,-6600]]},{"type":"Polygon","id":40027,"arcs":[[-6735,6808,-6598,-6603]]},{"type":"Polygon","id":47103,"arcs":[[-6791,6809,6810,6811,-6749,-6607,-6619]]},{"type":"Polygon","id":5045,"arcs":[[-6605,-6690,6812,6813,6814,-6736,-6564]]},{"type":"Polygon","id":47051,"arcs":[[-6692,6815,6816,6817,-6810,-6790,-6615]]},{"type":"Polygon","id":47011,"arcs":[[6818,6819,6820,-6744,-6581,-6637]]},{"type":"Polygon","id":35006,"arcs":[[-6297,6821,6822,6823,6824,-5796,-6430]]},{"type":"Polygon","id":40087,"arcs":[[-6734,6825,6826,-6805,-6599,-6809]]},{"type":"Polygon","id":37113,"arcs":[[6827,6828,6829,-6730,-6621,-6700]]},{"type":"MultiPolygon","id":37137,"arcs":[[[-6787,-6590,6830]]]},{"type":"Polygon","id":47115,"arcs":[[-6748,6831,6832,-6816,-6691,-6678]]},{"type":"Polygon","id":37163,"arcs":[[-6664,6833,6834,6835,6836,-6668,-6544]]},{"type":"Polygon","id":5149,"arcs":[[-6738,6837,6838,6839,6840,-6774,-6595]]},{"type":"Polygon","id":40121,"arcs":[[-6743,6841,6842,6843,6844,6845,-6681]]},{"type":"Polygon","id":37039,"arcs":[[-6830,6846,6847,6848,6849,-6624,-6731]]},{"type":"Polygon","id":40063,"arcs":[[-6682,-6846,6850,6851,-6727,-6642]]},{"type":"Polygon","id":47139,"arcs":[[-6850,6852,6853,-6819,-6636,-6625]]},{"type":"Polygon","id":37051,"arcs":[[-6837,6854,6855,6856,-6706,-6669]]},{"type":"Polygon","id":37103,"arcs":[[6857,-6785,6858,6859,6860,-6772,-6789]]},{"type":"Polygon","id":35001,"arcs":[[-6433,6861,6862,-6822,-6296]]},{"type":"Polygon","id":35019,"arcs":[[-6588,6863,6864,6865,-6493]]},{"type":"Polygon","id":45045,"arcs":[[-6796,6866,6867,6868,6869,-6776,-6722]]},{"type":"Polygon","id":37007,"arcs":[[6870,6871,6872,6873,-6719]]},{"type":"Polygon","id":37093,"arcs":[[-6857,6874,6875,-6707]]},{"type":"Polygon","id":37179,"arcs":[[-6874,6876,6877,-6702,-6713,-6720]]},{"type":"Polygon","id":45083,"arcs":[[6878,6879,-6867,-6795,-6659,6880]]},{"type":"Polygon","id":37061,"arcs":[[-6773,-6861,6881,6882,-6834,-6663]]},{"type":"Polygon","id":48117,"arcs":[[6883,6884,6885,6886,-6584,-6648]]},{"type":"Polygon","id":45021,"arcs":[[6887,-6881,-6658,-6674,6888]]},{"type":"Polygon","id":48129,"arcs":[[6889,6890,6891,6892,-6653]]},{"type":"Polygon","id":48087,"arcs":[[-6718,6893,6894,6895,-6890,-6655]]},{"type":"Polygon","id":48381,"arcs":[[6896,6897,6898,-6884,-6656]]},{"type":"Polygon","id":37153,"arcs":[[-6708,6899,6900,-6871,-6710]]},{"type":"Polygon","id":48011,"arcs":[[-6893,6901,6902,-6897,-6650]]},{"type":"Polygon","id":45091,"arcs":[[6903,6904,6905,-6889,-6673,-6783,-6704]]},{"type":"Polygon","id":37043,"arcs":[[-6829,6906,6907,6908,-6847]]},{"type":"Polygon","id":5123,"arcs":[[-6765,6909,6910,-6758,-6756]]},{"type":"Polygon","id":40075,"arcs":[[-6685,6911,6912,6913,6914,-6715,-6732]]},{"type":"MultiPolygon","id":37031,"arcs":[[[6915,-6859,-6784,6916]]]},{"type":"Polygon","id":40055,"arcs":[[-6915,6917,6918,-6716]]},{"type":"MultiPolygon","id":6083,"arcs":[[[6919]],[[6920]],[[-6560,6921,6922,-6556]]]},{"type":"Polygon","id":5105,"arcs":[[6923,6924,6925,-6838,-6737,-6815]]},{"type":"Polygon","id":5127,"arcs":[[-6841,6926,6927,-6800,-6753,-6775]]},{"type":"Polygon","id":5117,"arcs":[[-6760,6928,6929,6930,-6688]]},{"type":"Polygon","id":45077,"arcs":[[-6870,6931,6932,-6777]]},{"type":"Polygon","id":5085,"arcs":[[-6931,6933,6934,6935,-6813,-6689]]},{"type":"Polygon","id":45057,"arcs":[[-6878,6936,6937,6938,6939,-6904,-6703]]},{"type":"Polygon","id":40077,"arcs":[[-6804,6940,-6842,-6742]]},{"type":"Polygon","id":45073,"arcs":[[6941,6942,6943,6944,6945,6946,-6698,-6778,-6933]]},{"type":"Polygon","id":35057,"arcs":[[-6866,6947,6948,6949,-6862,-6432,-6494]]},{"type":"Polygon","id":37165,"arcs":[[6950,6951,-6900,-6876]]},{"type":"Polygon","id":40057,"arcs":[[-6919,6952,6953,6954,-6894,-6717]]},{"type":"Polygon","id":5119,"arcs":[[-6936,6955,6956,6957,-6924,-6814]]},{"type":"Polygon","id":1077,"arcs":[[6958,6959,6960,-6779,-6725,-6740,-6751,6961]]},{"type":"Polygon","id":5095,"arcs":[[-6911,6962,6963,6964,-6929,-6759]]},{"type":"Polygon","id":13241,"arcs":[[6965,6966,-6907,-6828,-6699,-6947]]},{"type":"Polygon","id":1083,"arcs":[[-6812,6967,6968,6969,-6962,-6750]]},{"type":"Polygon","id":28003,"arcs":[[6970,6971,-6767,-6799,-6781,6972]]},{"type":"Polygon","id":28141,"arcs":[[6973,6974,6975,-6973,-6780,-6961,6976]]},{"type":"Polygon","id":28139,"arcs":[[6977,6978,6979,-6768,-6972]]},{"type":"Polygon","id":28033,"arcs":[[6980,6981,-6762,-6794,6982]]},{"type":"Polygon","id":28009,"arcs":[[6983,6984,-6797,-6769,-6980]]},{"type":"Polygon","id":28093,"arcs":[[6985,6986,6987,-6983,-6793,-6798,-6985]]},{"type":"Polygon","id":13281,"arcs":[[-6967,6988,6989,6990,-6908]]},{"type":"Polygon","id":1089,"arcs":[[-6818,6991,6992,6993,-6968,-6811]]},{"type":"Polygon","id":1071,"arcs":[[6994,6995,-6992,-6817,-6833,6996]]},{"type":"Polygon","id":13213,"arcs":[[6997,6998,6999,-6820,-6854,7000]]},{"type":"Polygon","id":13111,"arcs":[[-6849,7001,7002,7003,7004,-7001,-6853]]},{"type":"Polygon","id":13313,"arcs":[[7005,7006,7007,-6821,-7000]]},{"type":"Polygon","id":13047,"arcs":[[7008,-6745,-7008]]},{"type":"Polygon","id":13291,"arcs":[[-6909,-6991,7009,7010,-7002,-6848]]},{"type":"MultiPolygon","id":37133,"arcs":[[[-6916,7011,7012,-6882,-6860]]]},{"type":"Polygon","id":13083,"arcs":[[-6832,-6747,7013,7014,-6997]]},{"type":"Polygon","id":13295,"arcs":[[-7007,7015,7016,7017,7018,-7014,-6746,-7009]]},{"type":"Polygon","id":40123,"arcs":[[-6728,-6852,7019,7020,7021,7022,-6826,-6733]]},{"type":"Polygon","id":35061,"arcs":[[-6863,-6950,7023,-6823]]},{"type":"Polygon","id":37155,"arcs":[[7024,7025,7026,7027,7028,-6951,-6875,-6856]]},{"type":"Polygon","id":35009,"arcs":[[-6887,7029,7030,7031,-6585]]},{"type":"Polygon","id":45087,"arcs":[[-6906,7032,7033,7034,7035,-6879,-6888]]},{"type":"Polygon","id":5077,"arcs":[[-6764,7036,7037,-6963,-6910]]},{"type":"Polygon","id":1033,"arcs":[[7038,7039,-6977,-6960]]},{"type":"MultiPolygon","id":6111,"arcs":[[[7040]],[[7041,-6922,-6559,7042]]]},{"type":"Polygon","id":28143,"arcs":[[-6763,-6982,7043,7044,7045,7046,7047,-7037]]},{"type":"Polygon","id":1049,"arcs":[[-7019,7048,7049,7050,7051,-6995,-7015]]},{"type":"Polygon","id":37017,"arcs":[[7052,7053,-7025,-6855,-6836]]},{"type":"Polygon","id":40065,"arcs":[[7054,7055,7056,-6953,-6918,-6914]]},{"type":"Polygon","id":5125,"arcs":[[-6958,7057,7058,7059,-6925]]},{"type":"Polygon","id":40031,"arcs":[[-6684,-6808,7060,7061,7062,-6912]]},{"type":"Polygon","id":40049,"arcs":[[-7023,7063,7064,7065,-6806,-6827]]},{"type":"Polygon","id":13123,"arcs":[[7066,7067,7068,-6998,-7005]]},{"type":"Polygon","id":13137,"arcs":[[-6946,7069,7070,7071,7072,-6989,-6966]]},{"type":"MultiPolygon","id":6037,"arcs":[[[7073]],[[7074]],[[-6553,7075,7076,-7043,-6558]]]},{"type":"Polygon","id":45023,"arcs":[[-6940,7077,-7033,-6905]]},{"type":"Polygon","id":45007,"arcs":[[7078,7079,7080,-6942,-6932,-6869]]},{"type":"Polygon","id":45025,"arcs":[[7081,7082,-6937,-6877,-6873,7083]]},{"type":"Polygon","id":45069,"arcs":[[-7029,7084,7085,7086,-7084,-6872,-6901,-6952]]},{"type":"Polygon","id":1079,"arcs":[[-6970,7087,7088,7089,7090,-7039,-6959]]},{"type":"Polygon","id":13311,"arcs":[[7091,7092,-7010,-6990,-7073]]},{"type":"Polygon","id":45059,"arcs":[[-7036,7093,7094,7095,-6868,-6880]]},{"type":"Polygon","id":35011,"arcs":[[7096,7097,7098,-6864,-6587]]},{"type":"Polygon","id":28137,"arcs":[[-6988,7099,7100,-7044,-6981]]},{"type":"Polygon","id":5051,"arcs":[[-7060,7101,7102,-6839,-6926]]},{"type":"Polygon","id":40029,"arcs":[[-6845,7103,7104,-7020,-6851]]},{"type":"Polygon","id":28117,"arcs":[[-6976,7105,7106,7107,-6978,-6971]]},{"type":"Polygon","id":48437,"arcs":[[-6903,7108,7109,7110,7111,-6898]]},{"type":"Polygon","id":48045,"arcs":[[-6892,7112,7113,7114,-7109,-6902]]},{"type":"Polygon","id":48069,"arcs":[[-7112,7115,7116,7117,-6885,-6899]]},{"type":"Polygon","id":48191,"arcs":[[-6896,7118,7119,7120,-7113,-6891]]},{"type":"Polygon","id":48075,"arcs":[[-6955,7121,7122,-7119,-6895]]},{"type":"Polygon","id":5097,"arcs":[[-7103,7123,7124,7125,7126,-6927,-6840]]},{"type":"Polygon","id":48369,"arcs":[[-7118,7127,7128,-7030,-6886]]},{"type":"Polygon","id":13187,"arcs":[[-7093,7129,7130,-7003,-7011]]},{"type":"MultiPolygon","id":37141,"arcs":[[[7131,7132]],[[-7013,7133,7134,7135,7136,-7053,-6835,-6883]]]},{"type":"Polygon","id":5113,"arcs":[[7137,7138,7139,-6801,-6928,-7127]]},{"type":"Polygon","id":1103,"arcs":[[-6994,7140,7141,-7088,-6969]]},{"type":"Polygon","id":13257,"arcs":[[7142,7143,-7070,-6945]]},{"type":"Polygon","id":40137,"arcs":[[-7066,7144,7145,7146,-7061,-6807]]},{"type":"Polygon","id":40005,"arcs":[[7147,7148,7149,7150,-7104,-6844]]},{"type":"Polygon","id":40127,"arcs":[[-6803,7151,7152,-7148,-6843,-6941]]},{"type":"Polygon","id":5107,"arcs":[[-7048,7153,7154,7155,7156,-6964,-7038]]},{"type":"Polygon","id":40099,"arcs":[[-7022,7157,7158,-7064]]},{"type":"Polygon","id":40141,"arcs":[[-7063,7159,7160,7161,-7055,-6913]]},{"type":"Polygon","id":13129,"arcs":[[-7069,7162,7163,7164,-7016,-7006,-6999]]},{"type":"Polygon","id":45033,"arcs":[[7165,7166,7167,-7085,-7028]]},{"type":"Polygon","id":13085,"arcs":[[-7131,7168,7169,7170,7171,-7067,-7004]]},{"type":"Polygon","id":45055,"arcs":[[7172,7173,7174,7175,7176,-6938,-7083]]},{"type":"Polygon","id":35041,"arcs":[[-7032,7177,7178,7179,7180,-7097,-6586]]},{"type":"Polygon","id":28145,"arcs":[[-7108,7181,7182,7183,-6986,-6984,-6979]]},{"type":"Polygon","id":1095,"arcs":[[-7052,7184,7185,7186,-7141,-6993,-6996]]},{"type":"Polygon","id":13055,"arcs":[[7187,7188,-7049,-7018]]},{"type":"Polygon","id":13115,"arcs":[[-7165,7189,7190,7191,-7188,-7017]]},{"type":"Polygon","id":35053,"arcs":[[-6949,7192,7193,7194,-6824,-7024]]},{"type":"Polygon","id":35003,"arcs":[[-7195,7195,7196,7197,-5797,-6825]]},{"type":"Polygon","id":1059,"arcs":[[-7091,7198,7199,7200,-6974,-7040]]},{"type":"Polygon","id":48197,"arcs":[[-7057,7201,7202,7203,-7122,-6954]]},{"type":"Polygon","id":45039,"arcs":[[-6939,-7177,7204,7205,-7034,-7078]]},{"type":"Polygon","id":5001,"arcs":[[-6965,-7157,7206,7207,7208,-6934,-6930]]},{"type":"Polygon","id":13227,"arcs":[[-7172,7209,-7163,-7068]]},{"type":"Polygon","id":28071,"arcs":[[-7184,7210,7211,7212,7213,-7100,-6987]]},{"type":"Polygon","id":28107,"arcs":[[-7214,7214,7215,7216,-7045,-7101]]},{"type":"Polygon","id":13119,"arcs":[[7217,7218,7219,-7143,-6944]]},{"type":"Polygon","id":45031,"arcs":[[-7087,7220,7221,-7173,-7082]]},{"type":"Polygon","id":45071,"arcs":[[-7206,7222,7223,7224,7225,-7094,-7035]]},{"type":"Polygon","id":1019,"arcs":[[-7192,7226,7227,7228,7229,-7050,-7189]]},{"type":"Polygon","id":28027,"arcs":[[7230,7231,7232,-7154,-7047,7233]]},{"type":"Polygon","id":28119,"arcs":[[-7217,7234,-7234,-7046]]},{"type":"Polygon","id":13139,"arcs":[[-7072,7235,7236,7237,7238,-7169,-7130,-7092]]},{"type":"Polygon","id":28081,"arcs":[[7239,7240,7241,7242,-7182,-7107]]},{"type":"Polygon","id":40019,"arcs":[[-7159,7243,7244,7245,7246,-7145,-7065]]},{"type":"Polygon","id":40069,"arcs":[[-7021,-7105,-7151,7247,7248,-7244,-7158]]},{"type":"Polygon","id":40033,"arcs":[[-7147,7249,7250,7251,-7160,-7062]]},{"type":"Polygon","id":40089,"arcs":[[-7140,7252,7253,7254,7255,7256,-7152,-6802]]},{"type":"Polygon","id":5059,"arcs":[[-7059,7257,7258,7259,-7124,-7102]]},{"type":"Polygon","id":4007,"arcs":[[-5749,7260,7261,7262,-6693,-5751]]},{"type":"Polygon","id":13147,"arcs":[[-7081,7263,7264,-7218,-6943]]},{"type":"Polygon","id":5053,"arcs":[[-6957,7265,7266,7267,-7258,-7058]]},{"type":"Polygon","id":5069,"arcs":[[-6935,-7209,7268,7269,-7266,-6956]]},{"type":"Polygon","id":13011,"arcs":[[7270,7271,-7236,-7071,-7144,-7220]]},{"type":"Polygon","id":37047,"arcs":[[-7137,7272,7273,-7026,-7054]]},{"type":"Polygon","id":45001,"arcs":[[7274,7275,7276,-7079,-7096]]},{"type":"Polygon","id":28057,"arcs":[[-6975,-7201,7277,7278,-7240,-7106]]},{"type":"Polygon","id":48487,"arcs":[[-7162,7279,7280,7281,-7202,-7056]]},{"type":"Polygon","id":13015,"arcs":[[7282,7283,7284,-7190,-7164,7285]]},{"type":"Polygon","id":13057,"arcs":[[-7171,7286,7287,7288,-7286,-7210]]},{"type":"Polygon","id":45047,"arcs":[[-7226,7289,7290,7291,-7275,-7095]]},{"type":"MultiPolygon","id":37129,"arcs":[[[7292,7293]],[[7294,-7132,7295,7296,-7135]]]},{"type":"Polygon","id":28115,"arcs":[[-7243,7297,7298,-7211,-7183]]},{"type":"Polygon","id":45061,"arcs":[[7299,7300,-7174,-7222]]},{"type":"MultiPolygon","id":37019,"arcs":[[[7301,7302]],[[-7293,7303]],[[-7297,7304,7305,7306,7307,-7273,-7136]]]},{"type":"Polygon","id":5061,"arcs":[[7308,7309,7310,7311,-7138]]},{"type":"Polygon","id":5109,"arcs":[[7312,7313,7314,-7309,-7126]]},{"type":"Polygon","id":35027,"arcs":[[-7099,7315,7316,7317,-7193,-6948,-6865]]},{"type":"Polygon","id":5019,"arcs":[[-7260,7318,7319,7320,-7313,-7125]]},{"type":"Polygon","id":13117,"arcs":[[-7239,7321,7322,-7287,-7170]]},{"type":"Polygon","id":1093,"arcs":[[7323,7324,7325,7326,7327,-7278,-7200]]},{"type":"Polygon","id":4012,"arcs":[[-6695,7328,7329,7330,7331,-6550,7332]]},{"type":"Polygon","id":48345,"arcs":[[7333,7334,7335,-7114,-7121]]},{"type":"Polygon","id":48101,"arcs":[[-7123,-7204,7336,7337,-7334,-7120]]},{"type":"Polygon","id":1043,"arcs":[[-7187,7338,7339,7340,-7089,-7142]]},{"type":"Polygon","id":48153,"arcs":[[-7336,7341,7342,-7110,-7115]]},{"type":"Polygon","id":48189,"arcs":[[-7116,-7111,-7343,7343,7344]]},{"type":"Polygon","id":48279,"arcs":[[-7345,7345,7346,-7128,-7117]]},{"type":"Polygon","id":45041,"arcs":[[7347,7348,7349,7350,-7300,-7221,-7086,-7168]]},{"type":"Polygon","id":48017,"arcs":[[-7347,7351,-7178,-7031,-7129]]},{"type":"Polygon","id":1133,"arcs":[[-7090,-7341,7352,-7324,-7199]]},{"type":"MultiPolygon","id":45051,"arcs":[[[-7302,7353]],[[-7306,7354]],[[-7274,-7308,7355,7356,7357,-7166,-7027]]]},{"type":"Polygon","id":45067,"arcs":[[-7358,7358,7359,-7348,-7167]]},{"type":"Polygon","id":13157,"arcs":[[7360,7361,7362,-7237,-7272]]},{"type":"Polygon","id":40067,"arcs":[[-7247,7363,7364,7365,-7250,-7146]]},{"type":"Polygon","id":13105,"arcs":[[-7277,7366,7367,7368,7369,7370,-7264,-7080]]},{"type":"Polygon","id":13195,"arcs":[[-7371,7371,7372,-7361,-7271,-7219,-7265]]},{"type":"Polygon","id":45079,"arcs":[[7373,7374,7375,-7223,-7205,-7176]]},{"type":"Polygon","id":1009,"arcs":[[-7186,7376,7377,7378,7379,-7339]]},{"type":"Polygon","id":48155,"arcs":[[-7203,-7282,7380,7381,7382,-7337]]},{"type":"Polygon","id":48485,"arcs":[[-7252,7383,7384,-7280,-7161]]},{"type":"Polygon","id":1055,"arcs":[[-7230,7385,7386,-7377,-7185,-7051]]},{"type":"Polygon","id":45063,"arcs":[[7387,7388,7389,7390,-7224,-7376]]},{"type":"Polygon","id":28161,"arcs":[[7391,7392,7393,-7215,-7213]]},{"type":"Polygon","id":5133,"arcs":[[7394,-7253,-7139,-7312]]},{"type":"Polygon","id":45081,"arcs":[[-7391,7395,7396,-7290,-7225]]},{"type":"Polygon","id":13121,"arcs":[[-7323,7397,7398,7399,7400,7401,7402,7403,7404,-7288]]},{"type":"Polygon","id":40095,"arcs":[[7405,7406,7407,-7245,-7249]]},{"type":"Polygon","id":5079,"arcs":[[-7208,7408,7409,7410,-7269]]},{"type":"Polygon","id":45085,"arcs":[[-7351,7411,7412,-7374,-7175,-7301]]},{"type":"Polygon","id":13135,"arcs":[[7413,7414,7415,7416,-7398,-7322,-7238]]},{"type":"Polygon","id":28135,"arcs":[[-7394,7417,7418,7419,-7231,-7235,-7216]]},{"type":"Polygon","id":28013,"arcs":[[-7299,7420,7421,7422,-7392,-7212]]},{"type":"Polygon","id":40013,"arcs":[[7423,7424,7425,7426,-7406,-7248,-7150]]},{"type":"Polygon","id":40023,"arcs":[[-7257,7427,7428,-7424,-7149,-7153]]},{"type":"Polygon","id":5039,"arcs":[[-7268,7429,7430,7431,-7319,-7259]]},{"type":"Polygon","id":48077,"arcs":[[-7366,7432,7433,7434,-7384,-7251]]},{"type":"Polygon","id":13013,"arcs":[[7435,7436,-7414,-7363]]},{"type":"Polygon","id":28011,"arcs":[[7437,7438,7439,7440,-7155,-7233]]},{"type":"Polygon","id":5041,"arcs":[[-7441,7441,7442,-7409,-7207,-7156]]},{"type":"Polygon","id":13233,"arcs":[[-7285,7443,7444,7445,-7227,-7191]]},{"type":"Polygon","id":28095,"arcs":[[-7279,-7328,7446,7447,7448,7449,-7241]]},{"type":"Polygon","id":35005,"arcs":[[-7181,7450,7451,7452,-7316,-7098]]},{"type":"Polygon","id":13067,"arcs":[[-7405,7453,7454,-7283,-7289]]},{"type":"Polygon","id":6065,"arcs":[[7455,7456,7457,-6551,-7332]]},{"type":"Polygon","id":13223,"arcs":[[-7455,7458,7459,7460,-7444,-7284]]},{"type":"Polygon","id":45065,"arcs":[[-7292,7461,7462,7463,-7367,-7276]]},{"type":"Polygon","id":28017,"arcs":[[-7242,-7450,7464,7465,-7421,-7298]]},{"type":"Polygon","id":40085,"arcs":[[-7408,7466,7467,7468,-7364,-7246]]},{"type":"Polygon","id":5025,"arcs":[[-7411,7469,7470,7471,-7430,-7267,-7270]]},{"type":"Polygon","id":1075,"arcs":[[7472,7473,7474,-7447,-7327]]},{"type":"Polygon","id":13221,"arcs":[[-7370,7475,7476,7477,7478,7479,-7372]]},{"type":"Polygon","id":4013,"arcs":[[-7263,7480,7481,7482,-7329,-6694]]},{"type":"Polygon","id":13059,"arcs":[[-7480,7483,-7362,-7373]]},{"type":"Polygon","id":5057,"arcs":[[7484,7485,7486,7487,-7310,-7315]]},{"type":"Polygon","id":1127,"arcs":[[-7340,-7380,7488,7489,7490,-7325,-7353]]},{"type":"Polygon","id":13317,"arcs":[[7491,7492,7493,7494,-7476,-7369]]},{"type":"Polygon","id":48337,"arcs":[[-7469,7495,7496,7497,-7433,-7365]]},{"type":"Polygon","id":1115,"arcs":[[7498,7499,7500,7501,-7378,-7387]]},{"type":"Polygon","id":28133,"arcs":[[-7420,7502,7503,7504,-7438,-7232]]},{"type":"Polygon","id":13181,"arcs":[[-7464,7505,7506,-7492,-7368]]},{"type":"Polygon","id":45037,"arcs":[[7507,7508,7509,-7462,-7291,-7397]]},{"type":"Polygon","id":13089,"arcs":[[-7417,7510,7511,7512,-7399]]},{"type":"Polygon","id":1015,"arcs":[[7513,-7499,-7386,-7229,7514]]},{"type":"Polygon","id":13219,"arcs":[[-7479,7515,7516,7517,-7436,-7484]]},{"type":"Polygon","id":1029,"arcs":[[-7446,7518,7519,7520,7521,7522,-7515,-7228]]},{"type":"Polygon","id":48387,"arcs":[[-7256,7523,7524,7525,7526,7527,7528,-7428]]},{"type":"Polygon","id":5099,"arcs":[[-7321,7529,7530,7531,-7485,-7314]]},{"type":"Polygon","id":48181,"arcs":[[-7427,7532,7533,7534,7535,-7467,-7407]]},{"type":"Polygon","id":48097,"arcs":[[-7536,7536,7537,-7496,-7468]]},{"type":"Polygon","id":5081,"arcs":[[-7311,-7488,7538,7539,-7254,-7395]]},{"type":"Polygon","id":45027,"arcs":[[7540,7541,7542,7543,-7412,-7350]]},{"type":"MultiPolygon","id":6059,"arcs":[[[-6552,-7458,7544,7545,-7076]]]},{"type":"Polygon","id":48277,"arcs":[[-7529,7546,7547,-7425,-7429]]},{"type":"Polygon","id":13297,"arcs":[[-7518,7548,7549,7550,-7415,-7437]]},{"type":"Polygon","id":1057,"arcs":[[-7491,7551,7552,-7473,-7326]]},{"type":"Polygon","id":13143,"arcs":[[7553,-7519,-7445,-7461]]},{"type":"Polygon","id":28043,"arcs":[[-7423,7554,7555,7556,7557,-7418,-7393]]},{"type":"Polygon","id":45089,"arcs":[[-7360,7558,7559,-7541,-7349]]},{"type":"Polygon","id":48147,"arcs":[[-7548,7560,7561,7562,-7533,-7426]]},{"type":"Polygon","id":45017,"arcs":[[-7413,-7544,7563,-7388,-7375]]},{"type":"Polygon","id":45003,"arcs":[[7564,7565,7566,7567,-7508,-7396,-7390]]},{"type":"Polygon","id":1073,"arcs":[[-7502,7568,7569,7570,-7489,-7379]]},{"type":"Polygon","id":48269,"arcs":[[-7383,7571,7572,7573,-7338]]},{"type":"Polygon","id":48275,"arcs":[[7574,7575,-7572,-7382]]},{"type":"Polygon","id":48009,"arcs":[[-7435,7576,7577,7578,-7385]]},{"type":"Polygon","id":48125,"arcs":[[-7574,7579,7580,-7335]]},{"type":"Polygon","id":48107,"arcs":[[-7581,7581,7582,-7342]]},{"type":"Polygon","id":48023,"arcs":[[-7579,7583,-7575,-7381,-7281]]},{"type":"Polygon","id":48303,"arcs":[[-7583,7584,7585,-7344]]},{"type":"Polygon","id":48079,"arcs":[[7586,7587,7588,-7179,-7352]]},{"type":"Polygon","id":48219,"arcs":[[-7586,7589,-7587,-7346]]},{"type":"Polygon","id":5103,"arcs":[[-7432,7590,7591,7592,-7530,-7320]]},{"type":"Polygon","id":13211,"arcs":[[7593,7594,7595,7596,-7549,-7517]]},{"type":"Polygon","id":13045,"arcs":[[-7403,7597,7598,7599,-7520,-7554,-7460,7600]]},{"type":"Polygon","id":28083,"arcs":[[-7558,7601,7602,7603,-7503,-7419]]},{"type":"Polygon","id":28025,"arcs":[[-7449,7604,7605,7606,-7465]]},{"type":"Polygon","id":13097,"arcs":[[-7404,-7601,-7459,-7454]]},{"type":"Polygon","id":5013,"arcs":[[7607,7608,-7591,-7431,-7472]]},{"type":"Polygon","id":5043,"arcs":[[-7443,7609,7610,7611,-7470,-7410]]},{"type":"Polygon","id":13247,"arcs":[[7612,-7511,-7416,-7551,7613]]},{"type":"MultiPolygon","id":45043,"arcs":[[[7614,7615]],[[-7357,7616,7617,7618,-7559,-7359]]]},{"type":"Polygon","id":4011,"arcs":[[-7198,7619,7620,7621,7622,-5798]]},{"type":"Polygon","id":13133,"arcs":[[7623,7624,7625,-7594,-7516,-7478]]},{"type":"Polygon","id":28087,"arcs":[[-7475,7626,7627,7628,-7605,-7448]]},{"type":"Polygon","id":13217,"arcs":[[-7597,7629,7630,7631,-7614,-7550]]},{"type":"Polygon","id":28155,"arcs":[[-7607,7632,7633,7634,-7555,-7422,-7466]]},{"type":"Polygon","id":13265,"arcs":[[7635,7636,-7624,-7477,-7495]]},{"type":"Polygon","id":48037,"arcs":[[-7540,7637,7638,7639,-7524,-7255]]},{"type":"Polygon","id":45075,"arcs":[[-7543,7640,7641,7642,7643,7644,-7565,-7389,-7564]]},{"type":"Polygon","id":5011,"arcs":[[-7612,7645,7646,-7608,-7471]]},{"type":"Polygon","id":13073,"arcs":[[-7463,-7510,7647,7648,-7506]]},{"type":"Polygon","id":1121,"arcs":[[-7514,-7523,7649,7650,7651,-7500]]},{"type":"Polygon","id":28097,"arcs":[[-7635,7652,7653,7654,-7556]]},{"type":"Polygon","id":28015,"arcs":[[-7655,7655,7656,-7602,-7557]]},{"type":"Polygon","id":13189,"arcs":[[-7507,-7649,7657,7658,7659,-7493]]},{"type":"Polygon","id":4009,"arcs":[[-7623,7660,7661,7662,-7261,-5748,-5799]]},{"type":"Polygon","id":13063,"arcs":[[-7513,7663,7664,7665,-7400]]},{"type":"Polygon","id":13151,"arcs":[[-7613,-7632,7666,7667,-7664,-7512]]},{"type":"Polygon","id":5091,"arcs":[[7668,7669,7670,7671,-7638,-7539,-7487]]},{"type":"Polygon","id":13301,"arcs":[[7672,7673,7674,-7636,-7494,-7660]]},{"type":"Polygon","id":1125,"arcs":[[-7490,-7571,7675,7676,7677,7678,-7552]]},{"type":"Polygon","id":35025,"arcs":[[-7589,7679,7680,7681,7682,7683,7684,-7451,-7180]]},{"type":"Polygon","id":28105,"arcs":[[-7629,7685,7686,7687,-7633,-7606]]},{"type":"Polygon","id":5017,"arcs":[[-7440,7688,7689,7690,7691,7692,7693,-7610,-7442]]},{"type":"Polygon","id":13113,"arcs":[[7694,7695,-7401,-7666]]},{"type":"Polygon","id":1117,"arcs":[[-7652,7696,7697,7698,-7569,-7501]]},{"type":"Polygon","id":13245,"arcs":[[7699,7700,-7658,-7648,-7509,-7568]]},{"type":"Polygon","id":1107,"arcs":[[-7553,-7679,7701,7702,7703,-7627,-7474]]},{"type":"Polygon","id":28019,"arcs":[[-7688,7704,7705,-7653,-7634]]},{"type":"Polygon","id":28151,"arcs":[[-7505,7706,7707,7708,-7689,-7439]]},{"type":"Polygon","id":13159,"arcs":[[7709,7710,7711,7712,-7630,-7596]]},{"type":"Polygon","id":13077,"arcs":[[-7696,7713,7714,7715,7716,-7598,-7402]]},{"type":"Polygon","id":45015,"arcs":[[-7619,7717,7718,7719,7720,-7641,-7542,-7560]]},{"type":"MultiPolygon","id":6073,"arcs":[[[7721,7722,-7545,-7457]]]},{"type":"Polygon","id":1111,"arcs":[[-7600,7723,7724,7725,7726,7727,-7521]]},{"type":"Polygon","id":1027,"arcs":[[-7728,7728,7729,-7650,-7522]]},{"type":"Polygon","id":48119,"arcs":[[-7528,7730,7731,7732,-7561,-7547]]},{"type":"Polygon","id":45011,"arcs":[[7733,7734,7735,-7566,-7645]]},{"type":"Polygon","id":13237,"arcs":[[7736,7737,7738,-7710,-7595,-7626]]},{"type":"Polygon","id":35051,"arcs":[[-7318,7739,7740,7741,7742,-7196,-7194]]},{"type":"Polygon","id":5073,"arcs":[[-7532,7743,7744,7745,-7669,-7486]]},{"type":"Polygon","id":13141,"arcs":[[-7675,7746,7747,7748,-7737,-7625,-7637]]},{"type":"Polygon","id":4027,"arcs":[[-7483,7749,7750,7751,-7330]]},{"type":"Polygon","id":4021,"arcs":[[-7262,-7663,7752,-7481]]},{"type":"Polygon","id":48237,"arcs":[[-7498,7753,7754,7755,7756,-7577,-7434]]},{"type":"Polygon","id":5027,"arcs":[[-7593,7757,7758,7759,-7744,-7531]]},{"type":"Polygon","id":13035,"arcs":[[-7713,7760,7761,7762,-7667,-7631]]},{"type":"Polygon","id":45009,"arcs":[[7763,7764,-7734,-7644]]},{"type":"Polygon","id":6025,"arcs":[[-7752,7765,-7722,-7456,-7331]]},{"type":"Polygon","id":48497,"arcs":[[-7538,7766,7767,7768,-7754,-7497]]},{"type":"Polygon","id":48121,"arcs":[[7769,7770,7771,-7767,-7537,-7535]]},{"type":"Polygon","id":13149,"arcs":[[-7717,7772,-7724,-7599]]},{"type":"Polygon","id":48231,"arcs":[[7773,7774,7775,7776,7777,-7562,-7733,7778]]},{"type":"Polygon","id":48085,"arcs":[[-7563,-7778,7779,7780,-7770,-7534]]},{"type":"Polygon","id":48263,"arcs":[[7781,7782,7783,7784,-7580]]},{"type":"Polygon","id":48433,"arcs":[[7785,7786,7787,-7782,-7573]]},{"type":"Polygon","id":48449,"arcs":[[7788,7789,7790,-7526]]},{"type":"Polygon","id":48169,"arcs":[[-7785,7791,7792,7793,-7582]]},{"type":"Polygon","id":48447,"arcs":[[7794,7795,7796,7797,-7584]]},{"type":"Polygon","id":48503,"arcs":[[-7757,7798,7799,-7795,-7578]]},{"type":"Polygon","id":48207,"arcs":[[-7798,7800,7801,-7786,-7576]]},{"type":"Polygon","id":5003,"arcs":[[-7694,7802,7803,-7646,-7611]]},{"type":"Polygon","id":48305,"arcs":[[-7794,7804,7805,7806,-7585]]},{"type":"Polygon","id":35035,"arcs":[[-7453,7807,7808,7809,7810,7811,-7740,-7317]]},{"type":"Polygon","id":48501,"arcs":[[7812,7813,-7680,-7588]]},{"type":"Polygon","id":48445,"arcs":[[-7807,7814,7815,-7813,-7590]]},{"type":"Polygon","id":48159,"arcs":[[-7791,7816,7817,7818,-7731,-7527]]},{"type":"Polygon","id":5139,"arcs":[[-7609,-7647,-7804,7819,7820,-7758,-7592]]},{"type":"Polygon","id":48223,"arcs":[[-7819,7821,7822,-7779,-7732]]},{"type":"Polygon","id":48343,"arcs":[[-7640,7823,7824,7825,7826,-7789,-7525]]},{"type":"Polygon","id":28051,"arcs":[[-7657,7827,7828,7829,-7603]]},{"type":"Polygon","id":13255,"arcs":[[-7763,7830,7831,7832,-7714,-7695,-7665,-7668]]},{"type":"Polygon","id":45035,"arcs":[[-7721,7833,7834,-7642]]},{"type":"Polygon","id":28053,"arcs":[[-7604,-7830,7835,7836,-7707,-7504]]},{"type":"Polygon","id":13125,"arcs":[[7837,7838,-7747,-7674]]},{"type":"Polygon","id":13163,"arcs":[[7839,7840,7841,7842,-7838,-7673,-7659,-7701]]},{"type":"Polygon","id":48067,"arcs":[[-7672,7843,7844,-7824,-7639]]},{"type":"Polygon","id":13033,"arcs":[[-7567,-7736,7845,7846,7847,7848,-7840,-7700]]},{"type":"Polygon","id":28103,"arcs":[[-7704,7849,7850,7851,-7686,-7628]]},{"type":"Polygon","id":28159,"arcs":[[-7852,7852,7853,7854,-7705,-7687]]},{"type":"Polygon","id":28007,"arcs":[[-7855,7855,7856,-7828,-7656,-7654,-7706]]},{"type":"Polygon","id":1007,"arcs":[[7857,7858,7859,-7676,-7570,-7699]]},{"type":"Polygon","id":13303,"arcs":[[-7839,-7843,7860,7861,7862,-7748]]},{"type":"Polygon","id":13199,"arcs":[[-7833,7863,7864,7865,7866,7867,-7715]]},{"type":"Polygon","id":13285,"arcs":[[-7868,7868,7869,-7725,-7773,-7716]]},{"type":"Polygon","id":35017,"arcs":[[-7743,7870,7871,-7620,-7197]]},{"type":"Polygon","id":13231,"arcs":[[7872,7873,-7864,-7832]]},{"type":"Polygon","id":13171,"arcs":[[7874,7875,-7873,-7831,-7762]]},{"type":"Polygon","id":13207,"arcs":[[-7712,7876,7877,7878,7879,-7875,-7761]]},{"type":"Polygon","id":13009,"arcs":[[-7749,-7863,7880,7881,-7738]]},{"type":"Polygon","id":13169,"arcs":[[-7882,7882,7883,7884,-7877,-7711,-7739]]},{"type":"MultiPolygon","id":45029,"arcs":[[[7885,7886]],[[-7835,7887,7888,7889,7890,-7764,-7643]]]},{"type":"Polygon","id":45005,"arcs":[[-7765,7891,7892,-7846,-7735]]},{"type":"Polygon","id":1063,"arcs":[[7893,7894,7895,-7702,-7678]]},{"type":"Polygon","id":1017,"arcs":[[-7870,7896,7897,7898,-7726]]},{"type":"Polygon","id":1123,"arcs":[[-7899,7899,7900,7901,7902,-7729,-7727]]},{"type":"Polygon","id":1037,"arcs":[[-7903,7903,7904,-7697,-7651,-7730]]},{"type":"Polygon","id":28125,"arcs":[[-7837,7905,7906,-7708]]},{"type":"Polygon","id":48063,"arcs":[[-7827,7907,7908,-7817,-7790]]},{"type":"Polygon","id":1021,"arcs":[[-7905,7909,7910,7911,7912,-7858,-7698]]},{"type":"Polygon","id":35013,"arcs":[[7913,7914,7915,-7741,-7812]]},{"type":"Polygon","id":13251,"arcs":[[7916,7917,7918,7919,-7847,-7893]]},{"type":"Polygon","id":45049,"arcs":[[7920,7921,7922,-7917,-7892,-7891]]},{"type":"Polygon","id":28163,"arcs":[[7923,7924,7925,7926,-7906,-7836,-7829]]},{"type":"Polygon","id":22017,"arcs":[[7927,7928,7929,7930,7931,-7844,-7671,7932]]},{"type":"Polygon","id":22015,"arcs":[[7933,7934,7935,-7933,-7670,-7746]]},{"type":"Polygon","id":22119,"arcs":[[7936,-7934,-7745,-7760,7937]]},{"type":"Polygon","id":22027,"arcs":[[7938,7939,-7938,-7759,-7821,7940]]},{"type":"Polygon","id":22111,"arcs":[[7941,7942,-7941,-7820,7943]]},{"type":"Polygon","id":48499,"arcs":[[7944,7945,7946,7947,-7822,-7818,-7909]]},{"type":"Polygon","id":28055,"arcs":[[-7907,-7927,7948,7949,-7690,-7709]]},{"type":"Polygon","id":13319,"arcs":[[-7862,7950,7951,7952,-7883,-7881]]},{"type":"Polygon","id":22067,"arcs":[[-7693,7953,7954,7955,-7944,-7803]]},{"type":"Polygon","id":1065,"arcs":[[-7860,7956,7957,-7894,-7677]]},{"type":"Polygon","id":22123,"arcs":[[7958,7959,-7954,-7692]]},{"type":"Polygon","id":48363,"arcs":[[7960,7961,7962,7963,7964,-7799,-7756]]},{"type":"Polygon","id":22035,"arcs":[[7965,7966,7967,-7959,-7691,-7950]]},{"type":"Polygon","id":48367,"arcs":[[7968,7969,7970,-7961,-7755,-7769]]},{"type":"Polygon","id":13293,"arcs":[[-7876,-7880,7971,7972,7973,-7865,-7874]]},{"type":"Polygon","id":1119,"arcs":[[7974,7975,7976,7977,-7850,-7703,-7896]]},{"type":"Polygon","id":48439,"arcs":[[-7768,-7772,7978,7979,7980,-7969]]},{"type":"Polygon","id":48113,"arcs":[[-7781,7981,7982,7983,-7979,-7771]]},{"type":"Polygon","id":48397,"arcs":[[-7777,7984,-7982,-7780]]},{"type":"Polygon","id":48379,"arcs":[[-7948,7985,-7774,-7823]]},{"type":"Polygon","id":48415,"arcs":[[7986,7987,7988,-7792,-7784]]},{"type":"Polygon","id":35015,"arcs":[[-7685,7989,7990,7991,-7808,-7452]]},{"type":"Polygon","id":48151,"arcs":[[-7788,7992,7993,-7987,-7783]]},{"type":"Polygon","id":48033,"arcs":[[-7989,7994,7995,7996,-7805,-7793]]},{"type":"Polygon","id":48115,"arcs":[[-7997,7997,7998,-7815,-7806]]},{"type":"Polygon","id":48165,"arcs":[[-7816,-7999,7999,8000,-7681,-7814]]},{"type":"Polygon","id":48253,"arcs":[[-7802,8001,8002,8003,-7993,-7787]]},{"type":"Polygon","id":48417,"arcs":[[8004,8005,8006,-8002,-7801,-7797]]},{"type":"Polygon","id":48429,"arcs":[[-7965,8007,-8005,-7796,-7800]]},{"type":"Polygon","id":13165,"arcs":[[-7920,8008,8009,-7848]]},{"type":"Polygon","id":13021,"arcs":[[8010,8011,8012,-7878,-7885]]},{"type":"Polygon","id":28099,"arcs":[[8013,8014,8015,-7854]]},{"type":"Polygon","id":28079,"arcs":[[-8016,8016,8017,8018,-7856]]},{"type":"Polygon","id":28069,"arcs":[[-7978,8019,-8014,-7853,-7851]]},{"type":"Polygon","id":48459,"arcs":[[-7826,8020,8021,8022,8023,-7945,-7908]]},{"type":"Polygon","id":13289,"arcs":[[8024,8025,-8011,-7884,-7953]]},{"type":"Polygon","id":13263,"arcs":[[8026,8027,8028,8029,8030,-7866,-7974]]},{"type":"Polygon","id":48315,"arcs":[[-7932,8031,-8021,-7825,-7845]]},{"type":"Polygon","id":28089,"arcs":[[-8019,8032,8033,8034,-7924,-7857]]},{"type":"Polygon","id":1105,"arcs":[[-7913,8035,8036,-7957,-7859]]},{"type":"Polygon","id":13145,"arcs":[[-8031,8037,8038,-7897,-7869,-7867]]},{"type":"Polygon","id":13079,"arcs":[[-8013,8039,8040,8041,-7972,-7879]]},{"type":"Polygon","id":48257,"arcs":[[8042,8043,8044,-7983,-7985,-7776]]},{"type":"Polygon","id":13107,"arcs":[[-7849,-8010,8045,8046,8047,8048,8049,8050,-7841]]},{"type":"Polygon","id":48467,"arcs":[[-7986,-7947,8051,8052,-8043,-7775]]},{"type":"Polygon","id":13167,"arcs":[[-8051,8053,-7951,-7861,-7842]]},{"type":"Polygon","id":48203,"arcs":[[-7931,8054,8055,8056,-8022,-8032]]},{"type":"Polygon","id":35023,"arcs":[[8057,8058,8059,-7621,-7872]]},{"type":"Polygon","id":1051,"arcs":[[8060,8061,8062,-7910,-7904,-7902]]},{"type":"Polygon","id":22061,"arcs":[[8063,8064,8065,-7939,-7943]]},{"type":"MultiPolygon","id":45053,"arcs":[[[8066,8067,8068,8069,8070,8071,8072,8073,8074,8075,-7922]]]},{"type":"Polygon","id":13269,"arcs":[[-8042,8076,8077,8078,8079,-8027,-7973]]},{"type":"Polygon","id":1081,"arcs":[[-8039,8080,8081,8082,-7900,-7898]]},{"type":"Polygon","id":1047,"arcs":[[8083,8084,8085,8086,-8036,-7912]]},{"type":"Polygon","id":22073,"arcs":[[8087,8088,8089,-8064,-7942,-7956]]},{"type":"Polygon","id":13175,"arcs":[[8090,8091,8092,-7952,-8054,8093]]},{"type":"Polygon","id":1001,"arcs":[[-8063,8094,8095,-8084,-7911]]},{"type":"MultiPolygon","id":45013,"arcs":[[[8096]],[[-8073,8097]],[[-8071,8098]],[[-8069,8099]],[[8100]],[[8101]],[[8102,-8067,-7921,-7890]]]},{"type":"Polygon","id":13225,"arcs":[[8103,-8077,-8041,8104]]},{"type":"Polygon","id":13153,"arcs":[[-8026,8105,8106,8107,8108,-8105,-8040,-8012]]},{"type":"Polygon","id":48423,"arcs":[[-8024,8109,8110,8111,8112,-8052,-7946]]},{"type":"Polygon","id":22083,"arcs":[[-7968,8113,8114,8115,-8088,-7955,-7960]]},{"type":"Polygon","id":48183,"arcs":[[-8057,8116,-8110,-8023]]},{"type":"Polygon","id":13031,"arcs":[[8117,8118,8119,8120,-8046,-8009,-7919]]},{"type":"Polygon","id":28123,"arcs":[[-8018,8121,8122,8123,-8033]]},{"type":"Polygon","id":28149,"arcs":[[8124,8125,8126,8127,8128,8129,-7966,-7949,-7926]]},{"type":"Polygon","id":13215,"arcs":[[-8030,8130,8131,-8081,-8038]]},{"type":"Polygon","id":35029,"arcs":[[-7916,8132,-8058,-7871,-7742]]},{"type":"Polygon","id":13103,"arcs":[[-8076,8133,8134,-8118,-7918,-7923]]},{"type":"Polygon","id":1087,"arcs":[[8135,8136,8137,-8061,-7901,-8083]]},{"type":"Polygon","id":28121,"arcs":[[-8124,8138,8139,8140,-8034]]},{"type":"Polygon","id":22013,"arcs":[[-8066,8141,8142,8143,8144,-7935,-7937,-7940]]},{"type":"Polygon","id":13023,"arcs":[[8145,8146,-8106,-8025,-8093]]},{"type":"Polygon","id":28075,"arcs":[[-7977,8147,8148,8149,-8020]]},{"type":"Polygon","id":28101,"arcs":[[-8150,8150,-8122,-8017,-8015]]},{"type":"Polygon","id":28049,"arcs":[[-8141,8151,8152,-8125,-7925,-8035]]},{"type":"MultiPolygon","id":22065,"arcs":[[[8153,-8128]],[[8154,8155,-8114,-7967,-8130]]]},{"type":"Polygon","id":13197,"arcs":[[8156,8157,8158,8159,8160,-8028,-8080]]},{"type":"Polygon","id":13043,"arcs":[[8161,8162,-8047,-8121]]},{"type":"Polygon","id":48221,"arcs":[[8163,8164,8165,-7962,-7971]]},{"type":"Polygon","id":48251,"arcs":[[8166,8167,8168,8169,-8164,-7970,-7981]]},{"type":"Polygon","id":48139,"arcs":[[-7984,-8045,8170,8171,8172,-8167,-7980]]},{"type":"Polygon","id":1091,"arcs":[[-7958,-8037,-8087,8173,8174,8175,-7975,-7895]]},{"type":"Polygon","id":13053,"arcs":[[-8161,8176,8177,-8131,-8029]]},{"type":"Polygon","id":48227,"arcs":[[8178,8179,8180,8181,-7996]]},{"type":"Polygon","id":48335,"arcs":[[8182,8183,8184,-8179,-7995,-7988]]},{"type":"Polygon","id":48353,"arcs":[[8185,8186,8187,-8183,-7994]]},{"type":"Polygon","id":48317,"arcs":[[-8182,8188,8189,8190,-8000,-7998]]},{"type":"Polygon","id":48003,"arcs":[[-8191,8191,8192,8193,-7682,-8001]]},{"type":"Polygon","id":13193,"arcs":[[-8104,-8109,8194,8195,8196,-8078]]},{"type":"Polygon","id":48441,"arcs":[[8197,8198,8199,-8186,-8004]]},{"type":"Polygon","id":48133,"arcs":[[-7964,8200,8201,8202,8203,-8006,-8008]]},{"type":"Polygon","id":48143,"arcs":[[-7963,-8166,8204,8205,8206,8207,-8201]]},{"type":"Polygon","id":48059,"arcs":[[-8204,8208,8209,-8198,-8003,-8007]]},{"type":"Polygon","id":4019,"arcs":[[-7662,8210,8211,8212,-7750,-7482,-7753]]},{"type":"Polygon","id":13283,"arcs":[[8213,8214,-8094,-8050]]},{"type":"Polygon","id":1113,"arcs":[[-8132,-8178,8215,8216,8217,-8136,-8082]]},{"type":"Polygon","id":1101,"arcs":[[-8138,8218,8219,8220,8221,-8095,-8062]]},{"type":"Polygon","id":22049,"arcs":[[-8090,8222,8223,-8142,-8065]]},{"type":"Polygon","id":13091,"arcs":[[8224,8225,8226,8227,-8146,-8092]]},{"type":"Polygon","id":13249,"arcs":[[-8197,8228,-8157,-8079]]},{"type":"Polygon","id":4003,"arcs":[[-7622,-8060,8229,8230,-8211,-7661]]},{"type":"Polygon","id":1085,"arcs":[[-8222,8231,8232,8233,-8085,-8096]]},{"type":"Polygon","id":48401,"arcs":[[8234,8235,8236,8237,-8111,-8117,-8056]]},{"type":"Polygon","id":22041,"arcs":[[-8156,8238,8239,8240,-8115]]},{"type":"Polygon","id":13235,"arcs":[[-8147,-8228,8241,8242,-8107]]},{"type":"Polygon","id":48365,"arcs":[[-7930,8243,8244,-8235,-8055]]},{"type":"Polygon","id":48213,"arcs":[[-8053,-8113,8245,8246,8247,8248,-8171,-8044]]},{"type":"Polygon","id":13209,"arcs":[[8249,8250,-8214,8251]]},{"type":"Polygon","id":13279,"arcs":[[-8049,8252,8253,8254,-8252]]},{"type":"Polygon","id":22031,"arcs":[[8255,8256,8257,8258,-8244,-7929]]},{"type":"Polygon","id":48349,"arcs":[[8259,8260,8261,-8172,-8249]]},{"type":"Polygon","id":48425,"arcs":[[-8170,8262,-8205,-8165]]},{"type":"Polygon","id":13267,"arcs":[[8263,8264,8265,8266,8267,-8253,-8048,-8163]]},{"type":"Polygon","id":1023,"arcs":[[8268,8269,8270,8271,-8148,-7976,-8176]]},{"type":"Polygon","id":13309,"arcs":[[-8251,8272,8273,-8225,-8091,-8215]]},{"type":"Polygon","id":1011,"arcs":[[-8218,8274,8275,-8219,-8137]]},{"type":"Polygon","id":13093,"arcs":[[-8243,8276,8277,8278,-8195,-8108]]},{"type":"Polygon","id":13109,"arcs":[[-8120,8279,8280,-8264,-8162]]},{"type":"Polygon","id":22021,"arcs":[[-8116,-8241,8281,8282,8283,-8223,-8089]]},{"type":"Polygon","id":1131,"arcs":[[-8086,-8234,8284,8285,8286,-8174]]},{"type":"Polygon","id":48217,"arcs":[[-8262,8287,8288,8289,-8168,-8173]]},{"type":"Polygon","id":48093,"arcs":[[8290,8291,8292,-8202,-8208]]},{"type":"Polygon","id":22107,"arcs":[[-8129,-8154,-8127,8293,8294,8295,8296,8297,-8239,-8155]]},{"type":"MultiPolygon","id":13029,"arcs":[[[8298,8299,8300,-8280,-8119,-8135]]]},{"type":"Polygon","id":22081,"arcs":[[-7936,-8145,8301,-8256,-7928]]},{"type":"MultiPolygon","id":13051,"arcs":[[[8302]],[[8303]],[[8304,-8299,-8134,-8075]]]},{"type":"Polygon","id":13307,"arcs":[[8305,8306,8307,8308,-8159]]},{"type":"Polygon","id":13259,"arcs":[[-8309,8309,8310,8311,-8216,-8177,-8160]]},{"type":"Polygon","id":13261,"arcs":[[-8279,8312,8313,8314,-8306,-8158,-8229,-8196]]},{"type":"Polygon","id":28023,"arcs":[[-8272,8315,8316,-8149]]},{"type":"Polygon","id":28021,"arcs":[[-8153,8317,8318,-8294,-8126]]},{"type":"Polygon","id":28061,"arcs":[[-8317,8319,8320,8321,-8151]]},{"type":"Polygon","id":28129,"arcs":[[-8322,8322,8323,8324,-8139,-8123]]},{"type":"Polygon","id":48035,"arcs":[[-8169,-8290,8325,8326,8327,-8206,-8263]]},{"type":"Polygon","id":13271,"arcs":[[8328,8329,8330,8331,-8226,-8274]]},{"type":"Polygon","id":22127,"arcs":[[-8224,-8284,8332,8333,8334,-8143]]},{"type":"Polygon","id":22069,"arcs":[[-8335,8335,8336,8337,8338,-8257,-8302,-8144]]},{"type":"Polygon","id":1005,"arcs":[[-8312,8339,8340,8341,8342,8343,-8275,-8217]]},{"type":"Polygon","id":48073,"arcs":[[-8238,8344,8345,8346,8347,-8246,-8112]]},{"type":"Polygon","id":13315,"arcs":[[-8227,-8332,8348,8349,8350,-8277,-8242]]},{"type":"MultiPolygon","id":13179,"arcs":[[[8351]],[[8352,8353,8354,-8265,-8281,-8301,8355]]]},{"type":"Polygon","id":48431,"arcs":[[-8185,8356,8357,8358,8359,-8180]]},{"type":"Polygon","id":48173,"arcs":[[-8360,8360,8361,-8189,-8181]]},{"type":"Polygon","id":48329,"arcs":[[-8362,8362,8363,-8192,-8190]]},{"type":"Polygon","id":48135,"arcs":[[-8364,8364,8365,8366,8367,-8193]]},{"type":"Polygon","id":48495,"arcs":[[-8368,8368,8369,-7683,-8194]]},{"type":"Polygon","id":48081,"arcs":[[-8188,8370,8371,-8357,-8184]]},{"type":"Polygon","id":48001,"arcs":[[8372,8373,8374,-8247,-8348]]},{"type":"Polygon","id":48083,"arcs":[[-8210,8375,8376,8377,8378,-8199]]},{"type":"Polygon","id":48399,"arcs":[[-8379,8379,8380,-8371,-8187,-8200]]},{"type":"Polygon","id":48049,"arcs":[[-8293,8381,8382,8383,-8376,-8209,-8203]]},{"type":"Polygon","id":1109,"arcs":[[-8344,8384,8385,8386,-8220,-8276]]},{"type":"Polygon","id":1041,"arcs":[[-8387,8387,8388,8389,-8232,-8221]]},{"type":"Polygon","id":28029,"arcs":[[8390,8391,8392,8393,-8318,-8152]]},{"type":"Polygon","id":28127,"arcs":[[-8325,8394,8395,8396,-8391,-8140]]},{"type":"Polygon","id":13081,"arcs":[[-8351,8397,8398,8399,-8313,-8278]]},{"type":"Polygon","id":48193,"arcs":[[8400,-8291,-8207,-8328,8401,8402]]},{"type":"Polygon","id":13183,"arcs":[[8403,8404,-8266,-8355]]},{"type":"Polygon","id":48161,"arcs":[[8405,8406,-8260,-8248,-8375]]},{"type":"Polygon","id":48109,"arcs":[[8407,8408,8409,-7809,-7992]]},{"type":"Polygon","id":48229,"arcs":[[8410,8411,8412,-7810,-8410]]},{"type":"Polygon","id":48141,"arcs":[[8413,-7914,-7811,-8413]]},{"type":"Polygon","id":48301,"arcs":[[8414,8415,-7990,-7684,-8370]]},{"type":"Polygon","id":48389,"arcs":[[8416,8417,8418,-8408,-7991,-8416]]},{"type":"Polygon","id":13239,"arcs":[[8419,8420,-8340,-8311]]},{"type":"Polygon","id":1025,"arcs":[[-8287,8421,8422,8423,-8269,-8175]]},{"type":"Polygon","id":48419,"arcs":[[8424,8425,8426,8427,-8236,-8245,-8259]]},{"type":"Polygon","id":22025,"arcs":[[-8298,8428,8429,8430,-8282,-8240]]},{"type":"Polygon","id":13161,"arcs":[[8431,8432,8433,-8329,-8273,-8250,-8255]]},{"type":"Polygon","id":13273,"arcs":[[8434,8435,8436,8437,-8307,-8315]]},{"type":"Polygon","id":13001,"arcs":[[-8268,8438,8439,8440,-8432,-8254]]},{"type":"Polygon","id":1013,"arcs":[[-8390,8441,8442,8443,-8285,-8233]]},{"type":"Polygon","id":13243,"arcs":[[-8308,-8438,8444,8445,-8420,-8310]]},{"type":"Polygon","id":22059,"arcs":[[-8431,8446,8447,8448,-8333,-8283]]},{"type":"Polygon","id":13177,"arcs":[[-8400,8449,8450,-8435,-8314]]},{"type":"Polygon","id":28153,"arcs":[[8451,8452,8453,-8320,-8316,-8271,8454]]},{"type":"Polygon","id":28063,"arcs":[[-8394,8455,8456,8457,-8295,-8319]]},{"type":"Polygon","id":48309,"arcs":[[8458,-8326,-8289,8459,8460,8461]]},{"type":"Polygon","id":13287,"arcs":[[8462,8463,8464,8465,-8398,-8350]]},{"type":"Polygon","id":13017,"arcs":[[-8331,8466,8467,-8463,-8349]]},{"type":"Polygon","id":13321,"arcs":[[-8399,-8466,8468,8469,8470,8471,-8450]]},{"type":"Polygon","id":48347,"arcs":[[-8428,8472,8473,-8345,-8237]]},{"type":"Polygon","id":22085,"arcs":[[-8339,8474,8475,8476,-8425,-8258]]},{"type":"Polygon","id":13305,"arcs":[[-8267,-8405,8477,8478,8479,8480,-8439]]},{"type":"Polygon","id":1099,"arcs":[[-8444,8481,8482,8483,-8422,-8286]]},{"type":"Polygon","id":28067,"arcs":[[8484,8485,8486,-8323,-8321,-8454]]},{"type":"Polygon","id":48293,"arcs":[[8487,-8460,-8288,-8261,-8407,8488,8489]]},{"type":"Polygon","id":13069,"arcs":[[8490,8491,8492,8493,8494,-8467,-8330,-8434]]},{"type":"Polygon","id":22043,"arcs":[[-8449,8495,-8336,-8334]]},{"type":"Polygon","id":28031,"arcs":[[-8487,8496,8497,8498,-8395,-8324]]},{"type":"Polygon","id":13061,"arcs":[[-8446,8499,8500,8501,-8341,-8421]]},{"type":"Polygon","id":1067,"arcs":[[-8502,8502,8503,8504,-8342]]},{"type":"Polygon","id":28065,"arcs":[[8505,8506,8507,-8396,-8499]]},{"type":"Polygon","id":13155,"arcs":[[-8495,8508,8509,-8464,-8468]]},{"type":"Polygon","id":22029,"arcs":[[-8297,8510,8511,8512,8513,8514,8515,-8429]]},{"type":"Polygon","id":28077,"arcs":[[8516,8517,8518,-8392,-8397,-8508]]},{"type":"Polygon","id":1035,"arcs":[[8519,8520,-8482,-8443]]},{"type":"Polygon","id":28001,"arcs":[[8521,8522,-8511,-8296,-8458]]},{"type":"Polygon","id":4023,"arcs":[[-8231,8523,-8212]]},{"type":"Polygon","id":48333,"arcs":[[8524,8525,-8382,-8292,-8401]]},{"type":"Polygon","id":28085,"arcs":[[8526,8527,8528,8529,-8456,-8393,-8519]]},{"type":"Polygon","id":13005,"arcs":[[8530,8531,-8491,-8433,-8441]]},{"type":"Polygon","id":48099,"arcs":[[8532,-8402,-8327,-8459,8533]]},{"type":"Polygon","id":48451,"arcs":[[-8381,8534,8535,8536,8537,-8358,-8372]]},{"type":"Polygon","id":1129,"arcs":[[-8424,8538,8539,8540,-8455,-8270]]},{"type":"MultiPolygon","id":13191,"arcs":[[[8541,8542]],[[8543,8544]],[[8545]],[[8546,8547,-8478,-8404,-8354]]]},{"type":"Polygon","id":48289,"arcs":[[8548,8549,8550,-8489,-8406,-8374]]},{"type":"Polygon","id":48461,"arcs":[[8551,8552,8553,-8365,-8363]]},{"type":"Polygon","id":48103,"arcs":[[-8554,8554,8555,8556,-8366]]},{"type":"Polygon","id":48405,"arcs":[[8557,8558,8559,-8473,-8427]]},{"type":"Polygon","id":48383,"arcs":[[-8359,-8538,8560,8561,-8552,-8361]]},{"type":"Polygon","id":48475,"arcs":[[-8415,-8369,-8367,-8557,8562,-8417]]},{"type":"Polygon","id":13095,"arcs":[[-8472,8563,8564,8565,-8436,-8451]]},{"type":"Polygon","id":13037,"arcs":[[-8437,-8566,8566,8567,-8500,-8445]]},{"type":"Polygon","id":1045,"arcs":[[-8505,8568,8569,8570,-8385,-8343]]},{"type":"Polygon","id":1031,"arcs":[[8571,8572,-8388,-8386,-8571]]},{"type":"Polygon","id":28037,"arcs":[[-8530,8573,8574,-8522,-8457]]},{"type":"Polygon","id":48403,"arcs":[[-8477,8575,8576,-8558,-8426]]},{"type":"Polygon","id":13277,"arcs":[[-8510,8577,8578,8579,-8469,-8465]]},{"type":"Polygon","id":48225,"arcs":[[8580,8581,8582,8583,-8549,-8373,-8347]]},{"type":"Polygon","id":48095,"arcs":[[-8378,8584,8585,-8535,-8380]]},{"type":"Polygon","id":13229,"arcs":[[-8481,8586,8587,-8531,-8440]]},{"type":"Polygon","id":1039,"arcs":[[-8573,8588,8589,8590,8591,-8520,-8442,-8389]]},{"type":"Polygon","id":48235,"arcs":[[8592,8593,-8561,-8537]]},{"type":"Polygon","id":48005,"arcs":[[-8560,8594,8595,8596,8597,-8581,-8346,-8474]]},{"type":"Polygon","id":13099,"arcs":[[-8568,8598,8599,8600,8601,-8503,-8501]]},{"type":"Polygon","id":48145,"arcs":[[8602,8603,-8461,-8488,8604]]},{"type":"Polygon","id":22079,"arcs":[[-8448,8605,8606,8607,8608,-8337,-8496]]},{"type":"Polygon","id":48307,"arcs":[[-8384,8609,8610,8611,-8585,-8377]]},{"type":"Polygon","id":48411,"arcs":[[-8526,8612,8613,8614,8615,-8610,-8383]]},{"type":"Polygon","id":13019,"arcs":[[-8494,8616,8617,8618,8619,-8578,-8509]]},{"type":"Polygon","id":13299,"arcs":[[-8588,8620,8621,8622,8623,8624,-8492,-8532]]},{"type":"Polygon","id":48281,"arcs":[[8625,8626,-8613,-8525,-8403,-8533]]},{"type":"MultiPolygon","id":13127,"arcs":[[[-8542,8627]],[[8628,-8544,8629,8630,8631,-8479,-8548]]]},{"type":"Polygon","id":13007,"arcs":[[-8565,8632,8633,8634,-8599,-8567]]},{"type":"Polygon","id":13205,"arcs":[[-8471,8635,8636,8637,8638,-8633,-8564]]},{"type":"Polygon","id":28041,"arcs":[[-8541,8639,8640,8641,-8452]]},{"type":"Polygon","id":28035,"arcs":[[8642,8643,8644,8645,-8497,-8486]]},{"type":"Polygon","id":28073,"arcs":[[-8498,-8646,8646,8647,-8506]]},{"type":"Polygon","id":28111,"arcs":[[-8453,-8642,8648,8649,-8643,-8485]]},{"type":"Polygon","id":28091,"arcs":[[-8648,8650,8651,8652,-8517,-8507]]},{"type":"Polygon","id":13003,"arcs":[[-8625,8653,8654,-8617,-8493]]},{"type":"Polygon","id":48455,"arcs":[[8655,8656,8657,-8582,-8598]]},{"type":"Polygon","id":48371,"arcs":[[-8556,8658,8659,8660,8661,-8418,-8563]]},{"type":"Polygon","id":13025,"arcs":[[-8632,8662,8663,-8621,-8587,-8480]]},{"type":"Polygon","id":28157,"arcs":[[-8575,8664,8665,8666,-8512,-8523]]},{"type":"Polygon","id":22115,"arcs":[[-8609,8667,8668,8669,-8475,-8338]]},{"type":"Polygon","id":48395,"arcs":[[8670,8671,8672,-8605,-8490,-8551]]},{"type":"Polygon","id":13075,"arcs":[[8673,8674,8675,-8579,-8620]]},{"type":"Polygon","id":28005,"arcs":[[-8529,8676,8677,8678,8679,-8665,-8574]]},{"type":"Polygon","id":28113,"arcs":[[8680,8681,8682,-8677,-8528]]},{"type":"Polygon","id":28147,"arcs":[[-8653,8683,-8681,-8527,-8518]]},{"type":"Polygon","id":22009,"arcs":[[-8430,-8516,8684,8685,8686,8687,-8606,-8447]]},{"type":"Polygon","id":13071,"arcs":[[-8580,-8676,8688,8689,-8636,-8470]]},{"type":"Polygon","id":48027,"arcs":[[-8604,8690,8691,8692,-8626,-8534,-8462]]},{"type":"MultiPolygon","id":1003,"arcs":[[[8693,8694]],[[-8484,8695,8696,8697,8698,8699,8700,-8539,-8423]]]},{"type":"Polygon","id":1069,"arcs":[[-8602,8701,8702,8703,-8569,-8504]]},{"type":"Polygon","id":1053,"arcs":[[-8592,8704,8705,8706,-8696,-8483,-8521]]},{"type":"Polygon","id":13201,"arcs":[[-8635,8707,8708,-8600]]},{"type":"Polygon","id":1061,"arcs":[[8709,8710,8711,-8589,-8572,-8570,-8704]]},{"type":"Polygon","id":48351,"arcs":[[8712,8713,8714,8715,-8576,-8476,-8670]]},{"type":"Polygon","id":13065,"arcs":[[-8624,8716,8717,8718,8719,-8654]]},{"type":"Polygon","id":13173,"arcs":[[-8720,8720,8721,-8618,-8655]]},{"type":"MultiPolygon","id":1097,"arcs":[[[-8699,8722]],[[8723,8724,8725,-8640,-8540,-8701]]]},{"type":"MultiPolygon","id":13039,"arcs":[[[8726]],[[8727,8728,8729,-8663,-8631]]]},{"type":"Polygon","id":48241,"arcs":[[8730,8731,8732,-8595,-8559,-8577,-8716]]},{"type":"Polygon","id":48373,"arcs":[[8733,8734,8735,8736,-8656,-8597]]},{"type":"Polygon","id":48331,"arcs":[[8737,8738,8739,-8691,-8603,-8673]]},{"type":"Polygon","id":48243,"arcs":[[8740,-8411,-8409,-8419,-8662,8741]]},{"type":"Polygon","id":48313,"arcs":[[8742,8743,8744,-8550,-8584]]},{"type":"Polygon","id":48327,"arcs":[[-8612,8745,8746,8747,-8586]]},{"type":"Polygon","id":48413,"arcs":[[-8748,8748,8749,-8593,-8536]]},{"type":"Polygon","id":48105,"arcs":[[-8553,-8562,-8594,-8750,8750,8751,8752,-8659,-8555]]},{"type":"Polygon","id":13087,"arcs":[[-8634,-8639,8753,8754,8755,-8708]]},{"type":"Polygon","id":13131,"arcs":[[8756,8757,8758,-8754,-8638]]},{"type":"MultiPolygon","id":13027,"arcs":[[[8759,8760]],[[8761,8762,8763,8764,-8689,-8675]]]},{"type":"Polygon","id":13275,"arcs":[[-8690,-8765,8765,8766,-8757,-8637]]},{"type":"Polygon","id":13253,"arcs":[[-8756,8767,8768,-8702,-8601,-8709]]},{"type":"Polygon","id":13049,"arcs":[[8769,8770,-8622,-8664,-8730]]},{"type":"Polygon","id":48457,"arcs":[[-8733,8771,-8734,-8596]]},{"type":"Polygon","id":48471,"arcs":[[8772,8773,8774,-8743,-8583,-8658]]},{"type":"MultiPolygon","id":22125,"arcs":[[[8775,8776,-8513,-8667,8777]],[[8778,-8685,-8515]]]},{"type":"Polygon","id":48053,"arcs":[[-8693,8779,8780,8781,8782,-8614,-8627]]},{"type":"Polygon","id":13185,"arcs":[[-8619,-8722,8783,8784,-8761,8785,-8762,-8674]]},{"type":"Polygon","id":22077,"arcs":[[-8514,-8777,8786,8787,8788,8789,-8686,-8779]]},{"type":"Polygon","id":28109,"arcs":[[-8645,8790,8791,8792,8793,-8651,-8647]]},{"type":"Polygon","id":22117,"arcs":[[-8794,8794,8795,-8682,-8684,-8652]]},{"type":"Polygon","id":22039,"arcs":[[-8688,8796,8797,8798,8799,-8607]]},{"type":"Polygon","id":12063,"arcs":[[-8769,8800,8801,8802,8803,8804,-8710,-8703]]},{"type":"Polygon","id":22105,"arcs":[[-8796,8805,8806,8807,8808,8809,-8678,-8683]]},{"type":"MultiPolygon","id":12033,"arcs":[[[-8695,8810]],[[8811,8812]],[[8813,-8697,-8707,8814]]]},{"type":"MultiPolygon","id":12113,"arcs":[[[8815,-8812,8816,8817]],[[8818,8819,-8815,-8706]]]},{"type":"Polygon","id":28039,"arcs":[[-8726,8820,8821,-8649,-8641]]},{"type":"Polygon","id":22091,"arcs":[[-8810,8822,8823,8824,-8679]]},{"type":"MultiPolygon","id":12091,"arcs":[[[-8818,8825]],[[8826,8827]],[[-8591,8828,8829,-8819,-8705]]]},{"type":"Polygon","id":22037,"arcs":[[-8825,8830,8831,-8778,-8666,-8680]]},{"type":"Polygon","id":12059,"arcs":[[-8805,8832,8833,-8711]]},{"type":"Polygon","id":12131,"arcs":[[-8712,-8834,8834,8835,8836,-8827,8837,-8829,-8590]]},{"type":"Polygon","id":48041,"arcs":[[8838,8839,8840,-8671,-8745]]},{"type":"Polygon","id":48319,"arcs":[[-8616,8841,8842,8843,-8746,-8611]]},{"type":"Polygon","id":48299,"arcs":[[-8783,8844,8845,-8842,-8615]]},{"type":"Polygon","id":28131,"arcs":[[-8822,8846,8847,-8791,-8644,-8650]]},{"type":"Polygon","id":48491,"arcs":[[8848,8849,8850,-8780,-8692,-8740]]},{"type":"Polygon","id":48407,"arcs":[[-8737,8851,8852,-8773,-8657]]},{"type":"Polygon","id":22003,"arcs":[[-8800,8853,8854,-8668,-8608]]},{"type":"Polygon","id":22011,"arcs":[[-8855,8855,8856,-8713,-8669]]},{"type":"Polygon","id":13101,"arcs":[[8857,8858,-8784,-8721,-8719]]},{"type":"Polygon","id":48185,"arcs":[[-8775,8859,8860,8861,-8839,-8744]]},{"type":"Polygon","id":22097,"arcs":[[-8790,8862,8863,8864,-8797,-8687]]},{"type":"Polygon","id":12133,"arcs":[[8865,-8835,-8833,-8804]]},{"type":"MultiPolygon","id":12089,"arcs":[[[-8729,8866,8867,8868,-8770]]]},{"type":"MultiPolygon","id":28059,"arcs":[[[-8725,8869,8870,-8847,-8821]]]},{"type":"Polygon","id":48051,"arcs":[[-8841,8871,8872,-8738,-8672]]},{"type":"Polygon","id":22033,"arcs":[[8873,8874,8875,8876,-8831,-8824]]},{"type":"Polygon","id":22103,"arcs":[[-8793,8877,8878,8879,8880,-8806,-8795]]},{"type":"Polygon","id":12039,"arcs":[[-8759,8881,8882,-8801,-8768,-8755]]},{"type":"Polygon","id":48267,"arcs":[[8883,8884,8885,8886,-8747,-8844]]},{"type":"Polygon","id":48435,"arcs":[[-8887,8887,8888,-8751,-8749]]},{"type":"Polygon","id":12073,"arcs":[[-8767,8889,8890,8891,-8882,-8758]]},{"type":"MultiPolygon","id":28047,"arcs":[[[-8871,8892,8893,-8848]]]},{"type":"Polygon","id":12065,"arcs":[[-8764,8894,8895,8896,8897,-8890,-8766]]},{"type":"Polygon","id":48043,"arcs":[[8898,-8742,-8661,8899,8900]]},{"type":"Polygon","id":22121,"arcs":[[8901,-8787,-8776,-8832,-8877]]},{"type":"Polygon","id":48443,"arcs":[[8902,8903,-8900,-8660,-8753]]},{"type":"Polygon","id":22063,"arcs":[[-8809,8904,8905,-8874,-8823]]},{"type":"Polygon","id":12079,"arcs":[[-8786,-8760,8906,8907,8908,8909,-8895,-8763]]},{"type":"Polygon","id":28045,"arcs":[[-8894,8910,-8878,-8792]]},{"type":"Polygon","id":12047,"arcs":[[-8859,8911,8912,-8907,-8785]]},{"type":"Polygon","id":48377,"arcs":[[-8899,8913,-8741]]},{"type":"Polygon","id":48339,"arcs":[[-8853,8914,8915,8916,-8860,-8774]]},{"type":"Polygon","id":48453,"arcs":[[8917,8918,8919,8920,-8781,-8851]]},{"type":"Polygon","id":12013,"arcs":[[8921,8922,8923,-8802]]},{"type":"Polygon","id":12077,"arcs":[[-8892,8924,8925,8926,-8922,-8883]]},{"type":"Polygon","id":12023,"arcs":[[-8718,8927,8928,8929,8930,8931,-8912,-8858]]},{"type":"MultiPolygon","id":12031,"arcs":[[[8932,8933]],[[8934,8935]],[[8936,8937,8938,-8868]]]},{"type":"Polygon","id":12003,"arcs":[[-8869,-8939,8939,8940,8941,-8928,-8717,-8623,-8771]]},{"type":"MultiPolygon","id":12005,"arcs":[[[8942,8943]],[[-8924,8944,8945,-8836,-8866,-8803]]]},{"type":"Polygon","id":48287,"arcs":[[8946,8947,8948,-8849,-8739,-8873]]},{"type":"Polygon","id":48199,"arcs":[[-8732,8949,8950,8951,-8735,-8772]]},{"type":"Polygon","id":48171,"arcs":[[-8846,8952,8953,8954,-8884,-8843]]},{"type":"Polygon","id":48031,"arcs":[[-8782,-8921,8955,8956,8957,-8953,-8845]]},{"type":"MultiPolygon","id":22099,"arcs":[[[8958,8959,8960]],[[8961,8962,-8863,-8789,8963]]]},{"type":"Polygon","id":22047,"arcs":[[-8902,-8876,8964,8965,8966,-8964,-8788]]},{"type":"Polygon","id":48291,"arcs":[[-8952,8967,8968,8969,-8915,-8852,-8736]]},{"type":"Polygon","id":22019,"arcs":[[8970,8971,8972,-8714,-8857]]},{"type":"Polygon","id":22053,"arcs":[[-8799,8973,8974,8975,-8971,-8856,-8854]]},{"type":"Polygon","id":22001,"arcs":[[-8865,8976,8977,-8974,-8798]]},{"type":"Polygon","id":12121,"arcs":[[-8932,8978,8979,-8908,-8913]]},{"type":"Polygon","id":48021,"arcs":[[8980,8981,-8918,-8850,-8949]]},{"type":"Polygon","id":48477,"arcs":[[-8862,8982,8983,8984,-8947,-8872,-8840]]},{"type":"Polygon","id":22055,"arcs":[[-8963,8985,8986,-8977,-8864]]},{"type":"Polygon","id":48209,"arcs":[[8987,8988,-8956,-8920,8989]]},{"type":"Polygon","id":22005,"arcs":[[-8906,8990,8991,8992,-8965,-8875]]},{"type":"Polygon","id":12123,"arcs":[[8993,8994,8995,-8896,-8910]]},{"type":"MultiPolygon","id":12129,"arcs":[[[-8898,8996,8997,-8925,-8891]]]},{"type":"Polygon","id":22095,"arcs":[[8998,8999,9000,-8991,-8905,-8808]]},{"type":"Polygon","id":48465,"arcs":[[-8889,9001,9002,9003,-8903,-8752]]},{"type":"Polygon","id":48137,"arcs":[[9004,9005,9006,9007,-9002,-8888,-8886]]},{"type":"Polygon","id":48265,"arcs":[[9008,9009,9010,-9005,-8885,-8955]]},{"type":"Polygon","id":12067,"arcs":[[-8980,9011,9012,-8994,-8909]]},{"type":"MultiPolygon","id":12109,"arcs":[[[9013,9014]],[[9015,9016,9017,9018,9019,-8933,9020]],[[-8935,9021]]]},{"type":"Polygon","id":48361,"arcs":[[-8973,9022,9023,-8950,-8731,-8715]]},{"type":"Polygon","id":48473,"arcs":[[9024,9025,9026,-8983,-8861,-8917]]},{"type":"Polygon","id":22089,"arcs":[[9027,-8999,9028]]},{"type":"MultiPolygon","id":22051,"arcs":[[[9029,9030]],[[9031,9032,9033,9034,-9029,-8807,-8881]]]},{"type":"Polygon","id":12045,"arcs":[[-8927,9035,9036,9037,9038,-8943,9039,-8945,-8923]]},{"type":"Polygon","id":22071,"arcs":[[9040,9041,9042,-9032,-8880]]},{"type":"Polygon","id":12019,"arcs":[[9043,9044,9045,-8940,-8938]]},{"type":"Polygon","id":48245,"arcs":[[-9024,9046,9047,9048,-8968,-8951]]},{"type":"MultiPolygon","id":48201,"arcs":[[[9049,9050]],[[-8970,9051,9052,9053,9054,9055,-9025,-8916]]]},{"type":"MultiPolygon","id":22087,"arcs":[[[-9057,-9058,-9059,-9060]],[[9060,9061,9062,9063,9064,9065,9066,-9042,9067]]]},{"type":"Polygon","id":22093,"arcs":[[9068,9069,-8992,-9001]]},{"type":"Polygon","id":48149,"arcs":[[9070,9071,9072,9073,9074,-8981,-8948,-8985]]},{"type":"Polygon","id":22113,"arcs":[[-8987,9075,9076,9077,-8975,-8978]]},{"type":"Polygon","id":12007,"arcs":[[-9046,9078,9079,9080,-8941]]},{"type":"Polygon","id":12125,"arcs":[[-9081,9081,-8929,-8942]]},{"type":"Polygon","id":48259,"arcs":[[-8958,9082,9083,9084,-9009,-8954]]},{"type":"MultiPolygon","id":22045,"arcs":[[[9085]],[[-8967,9086,-8960,9087,9088,-9076,-8986,-8962]]]},{"type":"Polygon","id":48015,"arcs":[[-9027,9089,9090,9091,-9071,-8984]]},{"type":"Polygon","id":22007,"arcs":[[-9070,9092,9093,9094,-8961,-9087,-8966,-8993]]},{"type":"Polygon","id":48385,"arcs":[[-9011,9095,9096,-9006]]},{"type":"Polygon","id":48055,"arcs":[[-8982,-9075,9097,9098,-8990,-8919]]},{"type":"Polygon","id":22023,"arcs":[[-8976,-9078,9099,-9047,-9023,-8972]]},{"type":"Polygon","id":48091,"arcs":[[9100,9101,-9083,-8957,-8989]]},{"type":"MultiPolygon","id":12037,"arcs":[[[9102]],[[-9038,9103]],[[-8998,9104,-9036,-8926]]]},{"type":"Polygon","id":48089,"arcs":[[9105,9106,9107,-9072,-9092]]},{"type":"MultiPolygon","id":22101,"arcs":[[[-9095,9108,9109,-9088,-8959]]]},{"type":"Polygon","id":12001,"arcs":[[-9080,9110,9111,9112,9113,-8930,-9082]]},{"type":"Polygon","id":12041,"arcs":[[-9114,9114,9115,-9012,-8979,-8931]]},{"type":"MultiPolygon","id":22057,"arcs":[[[9116,9117]],[[9118,9119,9120,-9030,9121,9122,9123,9124,9125,9126,9127,-9093,-9069,-9000,-9028,-9035,9128]]]},{"type":"Polygon","id":48019,"arcs":[[9129,-9096,-9010,-9085,9130,9131]]},{"type":"MultiPolygon","id":22075,"arcs":[[[9132]],[[-9059,9133]],[[9134,-9058]],[[9135,-9065]],[[9136,9137,9138,9139,-9033,-9043,-9067,9140]]]},{"type":"MultiPolygon","id":48071,"arcs":[[[-9050,9141]],[[-9049,9142,9143,9144,-9052,-8969]]]},{"type":"Polygon","id":48187,"arcs":[[9145,9146,9147,-9101,-8988,-9099]]},{"type":"MultiPolygon","id":12107,"arcs":[[[-9019,9148,9149,9150]],[[9151,9152,-9111,-9079,-9045]]]},{"type":"Polygon","id":48157,"arcs":[[9153,9154,-9090,-9026,-9056]]},{"type":"Polygon","id":48177,"arcs":[[9155,9156,9157,9158,-9146,-9098,-9074]]},{"type":"MultiPolygon","id":22109,"arcs":[[[9159,-9117]],[[9160,-9124]],[[9161,-9126]],[[9162]],[[9163,9164,9165,9166,9167,-9109,-9094,-9128,9168]]]},{"type":"Polygon","id":48029,"arcs":[[-9148,9169,9170,9171,-9131,-9084,-9102]]},{"type":"Polygon","id":48325,"arcs":[[9172,9173,9174,-9132,-9172]]},{"type":"MultiPolygon","id":12035,"arcs":[[[9175,9176,-9149,-9018]],[[-9016,9177]],[[9178,9179,9180,-9015]]]},{"type":"Polygon","id":48481,"arcs":[[-9155,9181,9182,9183,-9106,-9091]]},{"type":"Polygon","id":48285,"arcs":[[9184,9185,9186,-9156,-9073,-9108]]},{"type":"Polygon","id":48463,"arcs":[[-9175,9187,9188,-9007,-9097,-9130]]},{"type":"Polygon","id":48271,"arcs":[[-9189,9189,9190,-9003,-9008]]},{"type":"MultiPolygon","id":48167,"arcs":[[[9191]],[[9192,9193,-9054,9194]],[[9195,-9144]]]},{"type":"MultiPolygon","id":48039,"arcs":[[[-9194,9196,9197,-9182,-9154,-9055]]]},{"type":"MultiPolygon","id":12075,"arcs":[[[-9113,9198,9199,9200,9201,9202,-9115]]]},{"type":"Polygon","id":12083,"arcs":[[9203,9204,9205,9206,-9199,-9112,-9153]]},{"type":"Polygon","id":48493,"arcs":[[-9159,9207,9208,-9170,-9147]]},{"type":"MultiPolygon","id":12127,"arcs":[[[9209,9210]],[[9211,9212,9213,9214,9215,9216,-9150,-9177,9217]],[[9218,-9180]]]},{"type":"Polygon","id":48123,"arcs":[[9219,9220,-9157,-9187,9221]]},{"type":"Polygon","id":12069,"arcs":[[-9216,9222,9223,9224,9225,-9205,9226]]},{"type":"Polygon","id":48239,"arcs":[[9227,9228,9229,9230,9231,9232,9233,9234,-9185,-9107,-9184]]},{"type":"Polygon","id":48013,"arcs":[[9235,9236,-9173,-9171,-9209,9237,9238]]},{"type":"MultiPolygon","id":48321,"arcs":[[[9239,9240,-9228,-9183,-9198,9241]]]},{"type":"Polygon","id":48255,"arcs":[[9242,9243,-9238,-9208,-9158,-9221,9244]]},{"type":"MultiPolygon","id":48469,"arcs":[[[-9233,9245]],[[-9235,9246,9247,9248,9249,-9222,-9186]]]},{"type":"Polygon","id":48163,"arcs":[[-9237,9250,9251,9252,-9174]]},{"type":"Polygon","id":48507,"arcs":[[-9253,9253,9254,-9188]]},{"type":"Polygon","id":48323,"arcs":[[-9255,9255,9256,9257,-9190]]},{"type":"MultiPolygon","id":12017,"arcs":[[[9258,-9201]],[[-9200,-9207,9259,9260,9261]]]},{"type":"Polygon","id":12119,"arcs":[[-9226,9262,9263,9264,-9260,-9206]]},{"type":"Polygon","id":48175,"arcs":[[-9250,9265,9266,-9245,-9220]]},{"type":"Polygon","id":12117,"arcs":[[9267,-9223,-9215]]},{"type":"MultiPolygon","id":12009,"arcs":[[[9268,9269,9270,9271,-9214]],[[9272,-9210,9273,-9212]]]},{"type":"Polygon","id":48297,"arcs":[[9274,9275,9276,-9239,-9244,9277,9278]]},{"type":"Polygon","id":12095,"arcs":[[-9268,-9272,9279,-9224]]},{"type":"MultiPolygon","id":48057,"arcs":[[[9280,9281,9282]],[[9283,9284,9285]],[[-9241,9286,-9229]],[[9287,-9248,9288]],[[9289,-9231,9290]]]},{"type":"Polygon","id":48025,"arcs":[[-9267,9291,9292,-9278,-9243]]},{"type":"Polygon","id":12053,"arcs":[[-9265,9293,9294,-9261]]},{"type":"Polygon","id":48283,"arcs":[[9295,9296,9297,-9251]]},{"type":"Polygon","id":48311,"arcs":[[-9277,9298,-9296,-9236]]},{"type":"Polygon","id":48127,"arcs":[[-9252,-9298,9299,-9256,-9254]]},{"type":"Polygon","id":48391,"arcs":[[-9288,9300,9301,9302,9303,9304,-9292,-9266,-9249]]},{"type":"MultiPolygon","id":12101,"arcs":[[[9305,9306]],[[-9264,9307,9308,9309,9310,-9294]]]},{"type":"Polygon","id":12105,"arcs":[[9311,9312,9313,9314,-9308,-9263,-9225]]},{"type":"Polygon","id":12097,"arcs":[[-9271,9315,9316,-9312,-9280]]},{"type":"MultiPolygon","id":48007,"arcs":[[[9317,9318]],[[9319]],[[9320,9321,-9304]],[[9322,9323]],[[-9285,9324]],[[9325,-9302,9326,-9282,9327]]]},{"type":"Polygon","id":48479,"arcs":[[9328,9329,9330,9331,-9257,-9300,-9297]]},{"type":"Polygon","id":48409,"arcs":[[-9322,9332,-9323,9333,9334,9335,9336,9337,-9279,-9293,-9305]]},{"type":"MultiPolygon","id":12103,"arcs":[[[-9306,9338]],[[9339,9340,-9310]]]},{"type":"MultiPolygon","id":12057,"arcs":[[[-9315,9341,9342,-9340,-9309]]]},{"type":"Polygon","id":48131,"arcs":[[9343,9344,9345,-9329,-9299,-9276]]},{"type":"Polygon","id":48249,"arcs":[[-9338,9346,9347,9348,-9344,-9275]]},{"type":"MultiPolygon","id":48355,"arcs":[[[9349,9350]],[[9351]],[[-9318,9352]],[[-9335,9353]],[[9354,9355,-9347,-9337,9356]]]},{"type":"MultiPolygon","id":12061,"arcs":[[[9357,9358,-9316,-9270,9359]],[[9360,9361]]]},{"type":"Polygon","id":12055,"arcs":[[9362,9363,9364,9365,-9313]]},{"type":"Polygon","id":12049,"arcs":[[-9366,9366,9367,-9314]]},{"type":"MultiPolygon","id":12081,"arcs":[[[9368,9369]],[[-9368,9370,9371,9372,-9342]]]},{"type":"Polygon","id":12093,"arcs":[[-9359,9373,9374,9375,-9363,-9317]]},{"type":"MultiPolygon","id":48273,"arcs":[[[9376,9377,-9350,9378]],[[9379,9380,9381,-9348,-9356]]]},{"type":"MultiPolygon","id":12111,"arcs":[[[9382,9383]],[[9384,-9361]],[[9385,9386,9387,9388,-9374,-9358]]]},{"type":"MultiPolygon","id":12115,"arcs":[[[9389,9390]],[[-9372,9391,9392,9393,9394,9395]],[[-9369,9396]]]},{"type":"Polygon","id":48247,"arcs":[[9397,9398,9399,-9330,-9346]]},{"type":"Polygon","id":12027,"arcs":[[-9365,9400,-9392,-9371,-9367]]},{"type":"Polygon","id":48505,"arcs":[[-9400,9401,9402,-9331]]},{"type":"MultiPolygon","id":48261,"arcs":[[[9403,9404]],[[9405,9406,9407,9408]],[[9409,9410,9411,9412]],[[9413,9414,-9377,9415]],[[9416,9417,9418,9419,9420,-9381,9421]]]},{"type":"Polygon","id":48047,"arcs":[[-9349,-9382,-9421,9422,9423,-9398,-9345]]},{"type":"MultiPolygon","id":12085,"arcs":[[[9424,9425]],[[9426,9427,9428,9429,9430,-9375,-9389,9431]],[[9432,-9383]],[[9433,-9387]]]},{"type":"Polygon","id":12043,"arcs":[[9434,9435,-9364,-9376]]},{"type":"MultiPolygon","id":12015,"arcs":[[[9436,9437]],[[-9390,9438]],[[-9395,9439]],[[-9436,9440,9441,-9393,-9401]]]},{"type":"MultiPolygon","id":12099,"arcs":[[[-9425,9442]],[[9443,-9427]],[[9444,-9429]],[[9445,9446,9447,-9431]]]},{"type":"Polygon","id":12051,"arcs":[[9448,9449,9450,-9435,-9448]]},{"type":"MultiPolygon","id":12071,"arcs":[[[9451]],[[-9451,9452,9453,-9441]],[[-9438,9454]]]},{"type":"Polygon","id":48427,"arcs":[[-9424,9455,9456,-9402,-9399]]},{"type":"Polygon","id":48215,"arcs":[[-9420,9457,9458,9459,-9456,-9423]]},{"type":"MultiPolygon","id":48489,"arcs":[[[9460,9461]],[[-9404,9462]],[[9463,9464,9465,-9407,9466]],[[9467,9468,9469,9470,-9458,-9419,9471]]]},{"type":"MultiPolygon","id":12021,"arcs":[[[9472,9473]],[[9474,9475,9476,9477,-9453,-9450]]]},{"type":"MultiPolygon","id":48061,"arcs":[[[9478,-9459,-9471,9479]],[[-9461,9480]]]},{"type":"Polygon","id":12011,"arcs":[[9481,9482,-9475,-9449,-9447]]},{"type":"MultiPolygon","id":12086,"arcs":[[[9483,9484,9485,9486,9487,9488,-9476,-9483,9489]]]},{"type":"MultiPolygon","id":12087,"arcs":[[[-9487,9490]],[[-9485,9491]],[[9492]],[[9493,-9474]],[[-9489,9494,-9477]]]},{"type":"Polygon","id":4015,"arcs":[[-5753,-6696,-7333,-6549,-5937,-4613,-5352,-5426]]},{"type":"Polygon","id":12029,"arcs":[[-9116,-9203,9495,-8995,-9013]]},{"type":"Polygon","id":27077,"arcs":[[-123,-170,-106,9496]]},{"type":"Polygon","id":27031,"arcs":[[-192,9497]]},{"type":"Polygon","id":55031,"arcs":[[9498,-654,-647,-573,-462,-137,9499]]},{"type":"Polygon","id":55007,"arcs":[[9500,-652,-9499,9501]]},{"id":55003,"type":"MultiPolygon","arcs":[[[-542,-699,-648,-9501,9502]],[[9503]]]},{"id":26083,"type":"MultiPolygon","arcs":[[[9504,9505,9506]],[[9507]]]},{"id":26061,"type":"MultiPolygon","arcs":[[[-434,-572,-424,9508]],[[9509,-9506]]]},{"type":"Polygon","id":26103,"arcs":[[9510,9511,-694,-621,-567,-432,9512]]},{"type":"Polygon","id":26003,"arcs":[[-558,9513,-9511,9514,-473]]},{"type":"Polygon","id":26041,"arcs":[[-9514,-557,9515,-691,-9512]]},{"type":"Polygon","id":55075,"arcs":[[-693,9516,-855,-666,-683,-619]]},{"type":"Polygon","id":55029,"arcs":[[-1144,9517]]},{"id":26033,"type":"MultiPolygon","arcs":[[[9518,9519]],[[9520]],[[9521,9522,9523,-470,9524]]]},{"id":26097,"type":"MultiPolygon","arcs":[[[9525]],[[9526,-9522]],[[9527,-555,-471,-9524]]]},{"type":"Polygon","id":26047,"arcs":[[-749,9528,9529]]},{"id":26029,"type":"MultiPolygon","arcs":[[[-9529,-748,-928,-925,9530]],[[9531]]]},{"id":26089,"type":"MultiPolygon","arcs":[[[9532]],[[9533,-1088,9534]]]},{"type":"Polygon","id":26055,"arcs":[[-923,-1056,-1204,-1085,-9534,9535]]},{"type":"Polygon","id":26007,"arcs":[[9536,-1053,-929,-797]]},{"type":"Polygon","id":26011,"arcs":[[9537,-1413,-1374,-1214,-1212]]},{"type":"Polygon","id":26063,"arcs":[[-1552,-1530,9538]]},{"type":"Polygon","id":26147,"arcs":[[-1903,-1700,-1550,9539]]},{"type":"Polygon","id":26163,"arcs":[[9540,9541,-2106,-1904,-1901]]},{"id":26115,"type":"MultiPolygon","arcs":[[[-2482,9542]],[[9543,-2480]],[[9544,-2478,-2253,-2103,-9542]]]},{"type":"MultiPolygon","id":45019,"arcs":[[[9545,-7886,9546,-7888,-7834,-7720]],[[9547,-7615]],[[9548,-7718,-7618,9549]]]},{"type":"Polygon","id":15005,"arcs":[[9550,9551]]},{"type":"Polygon","id":15001,"arcs":[[9552]]},{"id":15007,"type":"MultiPolygon","arcs":[[[9553]],[[9554]]]},{"id":15009,"type":"MultiPolygon","arcs":[[[-9551,9555]],[[9556]],[[9557]],[[9558]]]},{"type":"Polygon","id":15003,"arcs":[[9559]]},{"type":"MultiPolygon","id":2016,"arcs":[[[9560]],[[9561]],[[9562]],[[9563]],[[9564]],[[9565]],[[9566]],[[9567]],[[9568]],[[9569]],[[9570]],[[9571]],[[9572]],[[9573]],[[9574]],[[9575]],[[9576]],[[9577]],[[9578]],[[9579]],[[9580]],[[9581]],[[9582]],[[9583]]]},{"type":"MultiPolygon","id":2013,"arcs":[[[9584]],[[9585]],[[9586]],[[9587]],[[9588]],[[9589]],[[9590]],[[9591]],[[9592]],[[9593]],[[9594]],[[9595]],[[9596,9597,9598,9599]]]},{"type":"MultiPolygon","id":2130,"arcs":[[[9600]],[[9601]]]},{"type":"Polygon","id":2060,"arcs":[[9602,9603]]},{"type":"MultiPolygon","id":2070,"arcs":[[[9604]],[[9605,9606]],[[9607,9608,9609,9610,9611,9612]]]},{"type":"MultiPolygon","id":2164,"arcs":[[[9613]],[[-9597,9614]],[[9615,9616,9617,-9599,9618,-9604,9619,-9612,9620]]]},{"type":"MultiPolygon","id":2150,"arcs":[[[9621]],[[9622]],[[9623]],[[9624]],[[9625]],[[9626]],[[9627]],[[9628]],[[9629]],[[9630]],[[9631,-9617,9632,9633]]]},{"type":"MultiPolygon","id":2110,"arcs":[[[9634,9635]],[[9636,9637]],[[9638,9639,9640,9641]],[[9642]],[[9643,9644,9645,9646,9647,9648]],[[9649,9650]]]},{"type":"MultiPolygon","id":2280,"arcs":[[[9651]],[[9652,9653]],[[9654]],[[9655]],[[9656]],[[9657]],[[9658]],[[9659]],[[9660,9661,9662,9663]]]},{"type":"MultiPolygon","id":2232,"arcs":[[[-9647,9664]],[[9665,9666,9667,9668]],[[9669]],[[-9664,9670,-9635,9671,-9645,9672]],[[-9639,9673,-9637,9674]],[[9675,9676,9677,9678,9679]],[[9680,9681]],[[-9641,9682]],[[9683,9684,9685,9686,9687]],[[9688,9689,9690,9691]]]},{"type":"MultiPolygon","id":2100,"arcs":[[[-9681,9692]],[[-9649,9693,-9650,9694,-9689,9695]],[[9696,-9687,9697,-9691]]]},{"type":"MultiPolygon","id":2220,"arcs":[[[9698]],[[9699,-9653,9700]],[[-9668,9701]],[[9702,-9666,9703,-9679,9704]]]},{"type":"MultiPolygon","id":2270,"arcs":[[[9705]],[[9706]],[[9707]],[[9708,9709,9710,9711]]]},{"type":"MultiPolygon","id":2050,"arcs":[[[9712]],[[9713]],[[9714]],[[9715]],[[9716,-9711,9717,9718,9719,-9621,-9611,9720,-9607,9721]]]},{"type":"Polygon","id":2170,"arcs":[[9722,9723,9724,9725,-9719,9726,9727,9728]]},{"type":"Polygon","id":2068,"arcs":[[9729,9730,-9728,9731]]},{"type":"MultiPolygon","id":2020,"arcs":[[[-9724,9732,9733,9734]]]},{"type":"MultiPolygon","id":2261,"arcs":[[[9735]],[[9736]],[[9737]],[[9738]],[[9739]],[[9740]],[[9741]],[[9742]],[[9743,9744]],[[9745]],[[9746]],[[9747,9748]],[[9749]],[[9750,9751]],[[9752]],[[9753,9754,-9733,-9723,9755,9756,9757,9758]]]},{"type":"MultiPolygon","id":2122,"arcs":[[[9759,-9634]],[[9760]],[[9761]],[[9762]],[[9763,-9748]],[[-9734,-9755,9764,-9751,9765,-9744,9766]],[[-9633,-9616,-9720,-9726,9767]]]},{"type":"MultiPolygon","id":2282,"arcs":[[[9768,9769,-9758,9770,-9685,9771]]]},{"type":"Polygon","id":2290,"arcs":[[9772,9773,9774,-9732,-9727,-9718,-9710,9775,9776,9777]]},{"type":"Polygon","id":2090,"arcs":[[9778,-9730,-9775]]},{"type":"Polygon","id":2240,"arcs":[[-9756,-9729,-9731,-9779,-9774,9779]]},{"type":"MultiPolygon","id":2185,"arcs":[[[9780]],[[9781,-9778,9782,9783]]]},{"type":"MultiPolygon","id":2188,"arcs":[[[-9777,9784,9785,-9783]]]},{"type":"MultiPolygon","id":2180,"arcs":[[[9786]],[[9787]],[[9788]],[[9789,-9785,-9776,-9709,9790]]]},{"id":2201,"type":"MultiPolygon","arcs":[[[9791]],[[9792]],[[9793]],[[9794]],[[9795]],[[9796]],[[9797]],[[9798]],[[9799]],[[9800]],[[9801]],[[9802]],[[9803]],[[9804]],[[9805]],[[-9662,9806]]]},{"type":"Polygon","id":72125,"arcs":[[9807,9808,9809,9810,9811,9812]]},{"type":"Polygon","id":72003,"arcs":[[9813,9814,9815,9816,9817]]},{"type":"Polygon","id":72097,"arcs":[[9818,9819,-9813,9820,9821,9822,9823]]},{"type":"Polygon","id":72065,"arcs":[[9824,9825,9826,9827,9828]]},{"type":"Polygon","id":72055,"arcs":[[9829,9830,9831,9832]]},{"type":"Polygon","id":72083,"arcs":[[9833,9834,-9819,9835,9836]]},{"type":"Polygon","id":72025,"arcs":[[9837,9838,9839,9840,9841,9842,9843]]},{"type":"Polygon","id":72045,"arcs":[[9844,9845,9846,9847,9848]]},{"type":"Polygon","id":72133,"arcs":[[9849,9850,9851,9852]]},{"type":"Polygon","id":72121,"arcs":[[-9833,9853,-9809,9854,9855]]},{"type":"Polygon","id":72027,"arcs":[[-9828,9856,9857,9858,9859]]},{"type":"Polygon","id":72033,"arcs":[[9860,9861,9862,9863]]},{"type":"Polygon","id":72001,"arcs":[[9864,9865,9866,9867,9868,9869]]},{"type":"Polygon","id":72111,"arcs":[[9870,9871,9872,-9866]]},{"type":"Polygon","id":72047,"arcs":[[9873,9874,9875,9876,9877,9878]]},{"type":"Polygon","id":72091,"arcs":[[9879,9880,9881,9882,9883,9884]]},{"type":"Polygon","id":72013,"arcs":[[9885,9886,9887,9888,-9825,9889]]},{"type":"Polygon","id":72145,"arcs":[[9890,9891,-9880,9892]]},{"type":"Polygon","id":72031,"arcs":[[9893,9894,9895,9896,9897,9898]]},{"type":"Polygon","id":72061,"arcs":[[9899,9900,9901,-9861,9902]]},{"type":"Polygon","id":72129,"arcs":[[9903,9904,9905,9906,9907,-9840,9908]]},{"type":"MultiPolygon","id":72075,"arcs":[[[9909,9910,-9853,9911,9912,9913,9914]]]},{"type":"Polygon","id":72063,"arcs":[[-9895,9915,-9909,-9839,9916]]},{"type":"Polygon","id":72073,"arcs":[[9917,-9914,9918,9919,9920]]},{"type":"Polygon","id":72143,"arcs":[[9921,9922,-9878,9923,-9891,9924]]},{"type":"Polygon","id":72011,"arcs":[[9925,-9836,-9824,9926,9927,-9815,9928]]},{"type":"Polygon","id":72081,"arcs":[[-9827,9929,-9869,9930,9931,-9834,9932,-9857]]},{"type":"Polygon","id":72015,"arcs":[[9933,9934,9935]]},{"type":"Polygon","id":72079,"arcs":[[-9854,-9832,9936,9937,-9810]]},{"type":"Polygon","id":72009,"arcs":[[9938,9939,9940,9941,9942]]},{"type":"Polygon","id":72099,"arcs":[[9943,9944,-9929,-9814,9945]]},{"type":"Polygon","id":72023,"arcs":[[9946,-9811,-9938,9947,-9822]]},{"type":"Polygon","id":72109,"arcs":[[9948,9949,9950,-9936,9951,9952,-9907]]},{"type":"Polygon","id":72101,"arcs":[[-9924,-9877,9953,9954,-9881,-9892]]},{"type":"Polygon","id":72117,"arcs":[[-9928,9955,-9816]]},{"type":"Polygon","id":72005,"arcs":[[-9946,-9818,9956,9957]]},{"type":"Polygon","id":72059,"arcs":[[-9873,9958,9959,-9867]]},{"type":"Polygon","id":72021,"arcs":[[-9902,9960,-9845,9961,9962,9963,-9862]]},{"type":"Polygon","id":72141,"arcs":[[9964,-9920,9965,-9870,-9930,-9826,-9889]]},{"type":"Polygon","id":72041,"arcs":[[-9842,9966,-9943,9967,-9847,9968]]},{"type":"Polygon","id":72123,"arcs":[[9969,9970,-9851,9971,-9940,9972]]},{"type":"Polygon","id":72131,"arcs":[[9973,-9858,-9933,-9837,-9926,-9945,9974]]},{"type":"Polygon","id":72035,"arcs":[[-9908,-9953,9975,-9973,-9939,-9967,-9841]]},{"type":"Polygon","id":72135,"arcs":[[-9963,9976,-9879,-9923,9977,9978]]},{"type":"Polygon","id":72115,"arcs":[[-9859,-9974,9979,9980]]},{"type":"Polygon","id":72054,"arcs":[[-9883,9981,-9887,9982]]},{"type":"Polygon","id":72105,"arcs":[[-9962,-9849,9983,-9874,-9977]]},{"type":"Polygon","id":72017,"arcs":[[-9884,-9983,-9886,9984]]},{"type":"Polygon","id":72127,"arcs":[[-9897,9985,-9844,9986,-9900,9987]]},{"type":"Polygon","id":72139,"arcs":[[-9896,-9917,-9838,-9986]]},{"type":"Polygon","id":72057,"arcs":[[-9952,-9935,9988,-9970,-9976]]},{"type":"Polygon","id":72153,"arcs":[[-9868,-9960,9989,-9830,-9856,9990,-9931]]},{"type":"Polygon","id":72043,"arcs":[[9991,9992,-9941,-9972,-9850,-9911,9993]]},{"type":"Polygon","id":72149,"arcs":[[-9994,-9910,9994]]},{"type":"Polygon","id":72039,"arcs":[[-9955,9995,-9921,-9965,-9888,-9982,-9882]]},{"type":"MultiPolygon","id":72113,"arcs":[[[-9913,9996,-9871,-9865,-9966,-9919]]]},{"type":"Polygon","id":72107,"arcs":[[9997,-9992,-9995,-9915,-9918,-9996,-9954,-9876]]},{"type":"Polygon","id":72067,"arcs":[[-9812,-9947,-9821]]},{"type":"Polygon","id":72071,"arcs":[[-9980,-9975,-9944,-9958,9998]]},{"type":"Polygon","id":72007,"arcs":[[-9843,-9969,-9846,-9961,-9901,-9987]]},{"type":"Polygon","id":72019,"arcs":[[-9848,-9968,-9942,-9993,-9998,-9875,-9984]]},{"type":"Polygon","id":72093,"arcs":[[-9932,-9991,-9855,-9808,-9820,-9835]]},{"type":"Polygon","id":72151,"arcs":[[9999,10000,10001,-9949,-9906,10002]]},{"type":"Polygon","id":72137,"arcs":[[-9863,-9964,-9979,10003,10004]]},{"type":"Polygon","id":78030,"arcs":[[10005]]},{"type":"Polygon","id":72089,"arcs":[[10006,10007,10008,10009]]},{"type":"Polygon","id":72087,"arcs":[[10010,10011,-9899,10012]]},{"type":"Polygon","id":72095,"arcs":[[10013,-9950,-10002]]},{"type":"Polygon","id":72119,"arcs":[[-10009,10014,10015,10016,10017,-10011,10018]]},{"type":"Polygon","id":72103,"arcs":[[10019,10020,10021,10022,-10016]]},{"type":"Polygon","id":72085,"arcs":[[-10023,10023,-10003,-9905,10024,10025,-10017]]},{"type":"Polygon","id":72029,"arcs":[[-10018,-10026,10026,-9894,-10012]]},{"type":"MultiPolygon","id":72053,"arcs":[[[10027,-10007,10028]]]},{"type":"Polygon","id":72077,"arcs":[[-10025,-9904,-9916,-10027]]},{"type":"MultiPolygon","id":72037,"arcs":[[[10029,-10020,-10015,-10008,-10028]]]},{"type":"Polygon","id":72069,"arcs":[[10030,-10000,-10024,-10022]]},{"type":"Polygon","id":72147,"arcs":[[10031]]},{"type":"Polygon","id":78010,"arcs":[[10032]]},{"type":"Polygon","id":72051,"arcs":[[-10004,-9978,-9922,10033]]}]},"states":{"type":"GeometryCollection","geometries":[{"type":"MultiPolygon","arcs":[[[6960,-6779,-6725,-6740,-6751,-6750,-6812,-6811,-6818,-6817,-6833,6996,-7015,-7019,7048,-7189,-7192,7226,-7446,7518,7519,-7600,7723,7724,-7870,7896,-8039,8080,-8132,-8178,8215,-8312,8339,8340,-8502,8502,-8602,8701,8702,8709,8710,8711,8589,8590,8704,8705,8706,8696,8697,8722,8699,8723,8724,8725,-8640,8540,-8455,8270,8271,-8148,7976,7977,-7850,7703,-7627,7474,-7447,7327,-7278,7200,-6974,-6977]],[[8693,8694]]],"id":1},{"type":"MultiPolygon","arcs":[[[9560]],[[9561]],[[9562]],[[9563]],[[9564]],[[9565]],[[9566]],[[9567]],[[9568]],[[9569]],[[9570]],[[9571]],[[9572]],[[9573]],[[9574]],[[9575]],[[9576]],[[9577]],[[9578]],[[9579]],[[9580]],[[9581]],[[9582]],[[9583]],[[9584]],[[9585]],[[9586]],[[9587]],[[9588]],[[9589]],[[9590]],[[9591]],[[9592]],[[9593]],[[9594]],[[9595]],[[9597,9618,9602,9619,9612,9607,9608,9609,9720,9605,9721,9716,9711,9790,9789,9785,9783,9781,9772,9779,9756,9770,9685,9697,9691,9695,9643,9672,9660,9806,9662,9670,9635,9671,9645,9664,9647,9693,9650,9694,9689,9696,9687,9683,9771,9768,9769,9758,9753,9764,9751,9765,9744,9766,9734,9724,9767,9759,9631,9617,9599,9614]],[[9600]],[[9601]],[[9604]],[[9613]],[[9621]],[[9622]],[[9623]],[[9624]],[[9625]],[[9626]],[[9627]],[[9628]],[[9629]],[[9630]],[[9641,9673,9637,9674,9639,9682]],[[9642]],[[9651]],[[9699,9653,9700]],[[9654]],[[9655]],[[9656]],[[9657]],[[9658]],[[9659]],[[9675,9676,9677,9704,9702,9666,9701,9668,9703,9679]],[[9669]],[[9681,9692]],[[9698]],[[9705]],[[9706]],[[9707]],[[9712]],[[9713]],[[9714]],[[9715]],[[9735]],[[9736]],[[9737]],[[9738]],[[9739]],[[9740]],[[9741]],[[9742]],[[9745]],[[9746]],[[9748,9763]],[[9749]],[[9752]],[[9760]],[[9761]],[[9762]],[[9780]],[[9786]],[[9787]],[[9788]],[[9791]],[[9792]],[[9793]],[[9794]],[[9795]],[[9796]],[[9797]],[[9798]],[[9799]],[[9800]],[[9801]],[[9802]],[[9803]],[[9804]],[[9805]]],"id":2},{"type":"MultiPolygon","arcs":[[[-5794,5794,5795,5796,-7198,7619,7620,-8060,8229,8523,8212,7750,7751,7330,7331,-6550,-6549,-5937,-4613,-5352,-5426,-5425,-4742,-4741,-4740]]],"id":4},{"type":"MultiPolygon","arcs":[[[-5831,-5946,-5945,-5944,-5957,-5956,-5955,-5732,-5915,-5914,-5913,-5942,-5941,-5888,-5999,-5998,-5997,-5996,-6190,-6303,6435,6436,6437,6438,-6633,6760,6761,6762,7036,-7048,7153,7154,-7441,-7440,7688,7689,7690,7691,7692,7802,7819,7820,7758,7759,7744,7745,7669,7670,7671,-7638,7539,-7254,-7253,7139,-6801,-6800,6753,-6638,6578,-6344,6280,6144,-5971,-5961,-5861,-5860]]],"id":5},{"type":"MultiPolygon","arcs":[[[-1578,2356,-2368,-2367,-2366,-2365,4113,4114,-4294,-4293,-4292,-3783,-4308,4555,-4763,-4239,5475,-5938,6548,6549,-7332,-7331,-7752,7765,7722,7545,7076,7041,6922,6556,5900,5619,5299,5203,5296,5447,5164,5019,4847,4539,4685,4457,4684,4459,4467,4841,4469,3604,2658,2346,-1865,-1947,-1946,-1854,-1575,-1574]],[[6919]],[[6920]],[[7040]],[[7073]],[[7074]]],"id":6},{"type":"MultiPolygon","arcs":[[[-2525,-2706,-2705,-2675,-2674,-2799,-2948,-2947,3119,-3174,3341,3342,-3598,3920,3921,-4261,4340,-4580,-4579,4881,4882,-5255,5325,5326,5327,5217,5218,5315,5316,5520,5521,5506,5507,5331,5329,-4739,-4738,-4737,4616,-4007,3557,-3077,-3076,2957,2958,-2168,-2110,-2109,-2108,-2114,-2113,-2526]]],"id":8},{"type":"MultiPolygon","arcs":[[[-2145,-1989,-1988,2290,2291,-2430,2499,2500,2532,2534,2531,2535,2520,2521,2522,-2258,-2257,-1970,-2147,-2146]]],"id":9},{"type":"MultiPolygon","arcs":[[[3730,3731]],[[3732,3733]],[[4084,4085,-4061,3736,3737,-3477,-3567,-3475,-3566,3734,4086,4378,4379,4380,4381,4382,4383,-4251]]],"id":10},{"type":"MultiPolygon","arcs":[[[4371,4372,-4099,-4281]]],"id":11},{"type":"MultiPolygon","arcs":[[[-8759,-8758,-8767,-8766,-8764,-8763,-8786,-8760,-8785,-8859,-8858,-8718,-8717,-8623,-8771,-8770,-8729,8866,8936,9043,9151,9203,9226,9216,9150,9019,8933,9020,9177,9016,9175,9217,9272,9210,9273,9212,9268,9359,9385,9433,9387,9431,9443,9427,9444,9429,9445,9481,9489,9483,9491,9485,9490,9487,9494,9477,9453,9441,9393,9439,9395,9372,9342,9340,9310,9294,9261,9258,9201,9495,8995,8896,8996,9104,9036,9103,9038,8943,9039,8945,8836,8827,8837,8829,8819,8813,-8697,-8707,-8706,-8705,-8591,-8590,-8712,-8711,-8710,-8703,-8769,-8768,-8755]],[[-8695,8810]],[[8815,8812,8816,8825]],[[8935,9021]],[[9180,9013,9178,9218]],[[9102]],[[9306,9338]],[[9361,9384]],[[9369,9396]],[[9383,9432]],[[9390,9438]],[[9425,9442]],[[9436,9454]],[[9451]],[[9472,9493]],[[9492]]],"id":12},{"type":"MultiPolygon","arcs":[[[-6945,-6944,-6943,-7081,-7080,-7277,7366,-7464,-7463,-7510,-7509,-7568,-7567,-7736,7845,-7893,7916,-7923,-8076,-8075,8304,8299,8355,8352,8546,8628,8544,8629,8727,8728,8769,8770,8622,8716,8717,8857,8858,8784,8759,8785,8762,8763,8765,8766,8757,8758,8754,8767,8768,-8702,8601,-8503,8501,-8341,-8340,8311,-8216,8177,8131,-8081,8038,-7897,7869,-7725,-7724,7599,-7520,-7519,7445,-7227,7191,7188,-7049,7018,7014,-6997,-6832,-6747,-6746,-6745,-6821,-6820,-6854,-6853,-6849,-6848,-6909,-6908,-6907,-6828,-6699,-6947,-6946]],[[8302]],[[8303]],[[8351]],[[8542,8627]],[[8545]],[[8726]]],"id":13},{"type":"MultiPolygon","arcs":[[[9551,9555]],[[9552]],[[9553]],[[9554]],[[9556]],[[9557]],[[9558]],[[9559]]],"id":15},{"type":"MultiPolygon","arcs":[[[-338,-317,-316,500,-510,-715,-714,-713,-736,-631,1095,-1149,-1148,1566,-1708,-1707,2023,2114,2078,2079,1992,1993,1868,1554,1555,-1237,-1236,-1235,1065,-945,889,-688,504,517,518,-384,-383,352,-237,-236,112,-80,21,22,19,-34,109,-191,229]]],"id":16},{"type":"MultiPolygon","arcs":[[[-1919,-1925,-1924,-1932,-1931,-2001,-2000,2087,2207,2208,2483,-2506,2748,-2801,2932,-3136,3303,3304,-3526,3705,-3900,4008,-4157,4222,-4431,-4430,4671,-4693,4908,-4932,5144,-5180,5367,5368,5370,-5502,5572,5584,5585,5578,5579,5580,-5360,-5359,-5169,5134,4937,4938,4713,4714,-4442,-4441,-4509,4365,4366,4367,4149,4052,4053,-3910,3728,3729,-3663,3495,-3471,3221,3222,-3095,2902,-2898,2740,-2691,2422,2423,2424,-2288,-2287,2203,-2133,2068,-1995,-1752,-1940,-1939,-1920]]],"id":17},{"type":"MultiPolygon","arcs":[[[-2264,-2269,2443,-2512,2593,-2690,2769,2770,-2995,3015,-3148,3271,-3385,-3384,3592,-3694,3789,-3913,-4123,4128,-4250,-4249,4410,4411,4419,4420,-4544,4647,4648,4799,4792,4793,4794,4789,4895,4896,4897,4955,4956,4925,4926,4975,4929,4930,4931,-4909,4692,-4672,4429,4430,-4223,4156,-4009,3899,-3706,3525,-3305,-3304,3135,-2933,2800,-2749,2505,-2484,-2209,2506,2508,2440,-2178,-2177,-2274,-2273,-2271,-2270,-2265]]],"id":18},{"type":"MultiPolygon","arcs":[[[-1475,-1474,-1487,-1486,-1479,-1478,-1539,1628,-1670,-1754,-1753,1994,-2069,2132,-2204,2286,2287,-2425,-2424,-2423,2690,-2741,2897,-2903,3094,3095,3055,3056,3058,3059,3070,3071,3068,3069,3065,3066,3062,3063,3052,3053,3049,3050,3046,3047,-2910,2856,-2805,2631,2632,-2516,2389,-2278,2181,-2165,2036,2037,-1806,-1805,1730,-1634,1625,-1495,-1464,-1468,-1467,-1491,-1490,-1489,-1500,-1499,-1493,-1492,-1471,-1470,-1476]]],"id":19},{"type":"MultiPolygon","arcs":[[[-3407,-3406,-3401,-3400,-3411,-3410,-3391,-3390,-3388,-3387,-3395,-3394,-3404,-3405,-3297,-3296,-3464,-3463,-3468,-3467,-3466,-3470,-3541,3642,-3743,3865,-3984,-3983,-4028,-4183,-4182,4332,-4487,4533,-4762,4814,-5045,-5044,5308,5309,-5554,5566,5567,5568,5541,5542,5533,5534,5604,5605,5455,5456,5458,5459,5536,5537,5468,5469,5538,5539,5465,5466,5462,5530,5531,5529,5526,5527,-5326,5254,-4883,-4882,4578,4579,-4341,4260,-3922,-3921,3597,-3343,-3398,-3397,-3409]]],"id":20},{"type":"MultiPolygon","arcs":[[[-4120,-4145,-4144,-4143,-4166,-4165,-4337,-4336,-4359,-4358,-4484,-4483,4732,-4799,-4798,-5111,-5110,5243,5244,5245,5624,-5656,5742,5844,5845,5834,5835,5842,5843,5822,5823,5909,5910,5853,5938,5939,5856,5857,5918,5919,5712,5714,5715,5675,5676,5753,5962,5963,5849,5850,5957,5958,5983,5984,-5924,-5725,-5724,-5723,5645,-5579,-5586,-5585,-5573,5501,-5371,-5369,-5368,5179,-5145,-4931,-4930,-4976,-4927,-4926,-4957,-4956,-4898,-4897,-4896,-4790,-4795,-4794,-4793,-4800,-4649,-4648,4543,-4421,-4420,-4412,-4411,4248,4249,-4129,-4122,-4121]],[[5982,-5926]]],"id":21},{"type":"MultiPolygon","arcs":[[[7929,7930,7931,-7844,-7671,-7670,-7746,-7745,-7760,-7759,-7821,-7820,-7803,-7693,-7692,-7691,-7950,7965,-8130,-8129,-8128,-8127,8293,8294,8295,8510,8511,-8667,-8666,-8680,-8679,-8678,-8683,-8682,-8684,-8652,-8794,-8793,8877,8878,9040,9067,9060,9061,9062,9063,9135,9065,9140,9136,9137,9138,9139,9033,9128,9118,9119,9120,9030,9121,9122,9160,9124,9161,9126,9168,9163,9164,9165,9166,9167,9109,9088,9076,9099,-9047,-9023,8972,-8714,-8713,8669,8475,8476,-8425,8258,-8244]],[[9133,9134],[-9057],[-9060]],[[9085]],[[9117,9159]],[[9132]],[[9162]]],"id":22},{"type":"MultiPolygon","arcs":[[[895,578,1091,1255,1259,1365,1363,1364,1261,1108,1366,1353,1362,1355,1511,1512,-1273,864,865,866,795,548,348,791]],[[893]],[[894]]],"id":23},{"type":"MultiPolygon","arcs":[[[-3480,-3479,-3427,-3426,-3478,-3738,-3737,4060,-4086,-4085,4250,-4384,-4383,-4382,4778,4774,4775,4776,4860,4859,4678,4569,4567,4252,4394,4153,4062,3805,3815,3821,4072,4177,4071,4178,4174,4509,4277,4601,4719,4718,4603,4279,4280,4098,4099,4100,3830,3792,3793,3794,3795,3797,3798,3799,3801,3802,3803,-3527,-3439,-3438,-3423,-3517,-3516,-3436,-3435,-3564,-3563,-3481]],[[4150]],[[4771,4772]],[[-4380,4773]],[[4850,4851]],[[4852,4853,4854,4855]],[[4856,4857,4858]]],"id":24},{"type":"MultiPolygon","arcs":[[[1977,2092,1979,2089,2140,2151,2138,2147,2261,2260,2149,2221,2222,2223,2224,2225,2143,1986,1987,1988,2144,2145,2146,1969,1970,1971,-1859,-1711,-1710,-1728,-1780,-1779,-1757,-1756,-1755,-1723,1906,2093]],[[2604]],[[2700]]],"id":25},{"type":"MultiPolygon","arcs":[[[464,465,466,422,9508,434,9512,9514,473,9524,9526,9522,9527,555,9515,691,692,618,619,568,569,570]],[[9536,1049,1210,9537,1408,1534,9538,1552,9539,1899,9540,9544,-2478,2253,2254,2266,2267,2268,2263,2264,2269,2270,2272,2273,2176,2177,2178,2124,1960,1759,1660,1507,1351,1199,1086,9534,9535,923,9530,9529,749,798]],[[9506,9504,9509]],[[9507]],[[9518,9519]],[[9520]],[[9525]],[[9531]],[[9532]],[[-2482,9542]],[[9543,-2480]]],"id":26},{"type":"MultiPolygon","arcs":[[[9496,123,140,193,9497,192,135,136,461,572,573,-646,772,-778,876,877,1025,-1049,1113,-1137,-1162,-1161,-1165,1343,-1397,1476,1477,1478,1485,1486,1473,1474,1475,1469,1470,1491,1492,1498,1499,1488,1489,1490,1466,1467,1463,1464,1309,-1194,1154,-1019,-1018,892,-868,817,-724,681,-533,528,403,-392,336,-306,207,-199,153,154,-53,58,104]]],"id":27},{"type":"MultiPolygon","arcs":[[[-6767,-6799,-6781,-6780,-6961,6976,6973,-7201,7277,-7328,7446,-7475,7626,-7704,7849,-7978,-7977,8147,-8272,-8271,8454,-8541,8639,-8726,-8725,8869,8892,8910,-8878,8792,8793,8651,8683,8681,8682,8677,8678,8679,8665,8666,-8512,-8511,-8296,-8295,-8294,8126,8127,8128,8129,-7966,7949,-7690,-7689,7439,7440,-7155,-7154,7047,-7037,-6763,-6762,-6794,-6793,-6798,-6797,-6769,-6768]]],"id":28},{"type":"MultiPolygon","arcs":[[[-3496,3662,-3730,-3729,3909,-4054,-4053,-4150,-4368,-4367,-4366,4508,4440,4441,-4715,-4714,-4939,-4938,-5135,5168,5358,5359,-5581,-5580,-5646,5722,5723,5724,5923,5924,5925,5926,-6128,6188,6189,5995,5996,5997,5998,5887,5940,5941,5912,5913,5914,5731,5954,5955,5956,5943,5944,5945,5830,5859,5860,5960,5961,-5781,5735,-5567,5553,-5310,-5309,5043,5044,-4815,4761,-4534,4486,-4333,4181,4182,4027,3982,3983,-3866,3742,-3643,3540,3469,-3465,-3284,3253,-3109,-3047,-3051,-3050,-3054,-3053,-3064,-3063,-3067,-3066,-3070,-3069,-3072,-3071,-3060,-3059,-3057,-3056,-3096,-3223,-3222,3470]]],"id":29},{"type":"MultiPolygon","arcs":[[[108,-91,106,-131,210,-220,361,-369,496,497,498,654,655,656,741,742,743,676,677,804,805,634,628,629,630,735,712,713,714,509,-501,315,316,337,-230,190,-110,33,-20,34,18,41,97,86,44,48,27,8,51]]],"id":30},{"type":"MultiPolygon","arcs":[[[1833,-1618,-1658,-1657,-1548,-1547,-1683,-1684,-1526,-1656,-1655,-1646,-1645,-1785,-1783,-1782,-1811,-1810,-1808,-1807,-2038,-2037,2164,-2182,2277,-2390,2515,-2633,-2632,2804,-2857,2909,-3048,3108,-3254,3283,3464,3465,3466,3467,3462,3463,3295,3296,3404,3403,3393,3394,3386,3387,3389,3390,3409,3410,3399,3400,3405,3406,3408,3396,3397,-3342,3173,-3120,2946,2947,2798,2673,2674,2704,2705,-2524,2514,-2019,-2018]]],"id":31},{"type":"MultiPolygon","arcs":[[[-1402,-1238,-1556,-1555,-1869,-1994,-2330,2334,-2897,3541,3542,-3979,4609,4610,4611,4612,5936,5937,-5476,4238,4762,-4556,4307,3782,4291,4292,4293,-4115,-4114,2364,2365,2366,2367,-2357,-1577,-1403]]],"id":32},{"type":"MultiPolygon","arcs":[[[-1513,1589,1721,1722,1754,1755,1756,1778,1779,-1727,1588,-1430,1243,1244,-1089,-971,874,875,-866,-865,1272]]],"id":33},{"type":"MultiPolygon","arcs":[[[-2743,2873,3093,3043,3136,3236,3325,3511,3501,3786,4108,3927,3924,3765,3925,3768,-3732,3769,-3734,3770,3704,3646,3504,3505,-3234,-3233,3104,2887,2888,-2790,2730,-2575,-2542,-2541,-2744]]],"id":34},{"type":"MultiPolygon","arcs":[[[-5316,-5219,-5218,-5328,5799,5800,5801,-6401,6582,6583,-6887,7029,7030,7177,7178,-7589,7679,7680,7681,7682,7683,7989,7990,7991,7808,7809,7810,7913,7914,8132,8058,8059,-7621,-7620,7197,-5797,-5796,-5795,5793,-5330,-5332,-5508,-5507,-5522,-5521,-5317]]],"id":35},{"type":"MultiPolygon","arcs":[[[1178,-1269,-1459,1518,-1712,1858,-1972,-1971,2256,2257,-2523,-2522,2726,2723,3022,3074,3024,2725,2601,2744,2742,2743,2540,2541,2542,2297,2298,2064,2126,2127,2129,2130,2162,2163,2027,2028,2059,2060,2056,2057,2031,2032,2033,1803,1690,1687,1695,1698,1675,1544,1252,1539,1254,1249,994,1006,980,-976,977,-1106]],[[1799]],[[2756,3028]],[[3031,3099,3132,3101,3033,2758,3029,3096]],[[3098,3131]],[[3217]]],"id":36},{"type":"MultiPolygon","arcs":[[[-5951,-5875,-5923,-5922,-5935,-5934,-5691,-5690,-5989,-5688,-5730,-5729,-5728,-5909,-5908,-5907,-5741,-5740,-5902,-5820,-5819,-5818,-5897,-5896,-5933,-5932,-5870,6067,6065,6075,6114,6205,6220,6063,6084,6272,6460,6454,6611,6285,6612,6592,6521,6588,6830,6787,6857,6785,6916,7011,7133,7294,7132,7295,7304,7305,7306,7307,7273,7026,7027,7028,6951,6900,6871,6872,6876,6877,6702,6703,6782,6672,6673,6657,6658,6794,6795,6721,6775,6776,6777,6697,6698,6827,6906,6907,6908,6847,6848,6849,-6624,-6623,-6487,-6486,-6422,-6421,-6315,-6314,-6201,-6258,-6257,-6256,-6112,-6111,-6012,-6011,-6010,-5953,-5952]],[[6070,-5866,6068,6286]],[[-6072,5863,-6073,5867]],[[6283,6281,6610]],[[7293,7303]],[[7301,7302]]],"id":37},{"type":"MultiPolygon","arcs":[[[30,62,66,55,52,-155,-154,198,-208,305,-337,391,-404,-529,532,533,606,607,612,613,610,611,512,564,602,603,604,614,-498,-497,368,-362,219,-211,130,-107,90,91,96,101,38]]],"id":38},{"type":"MultiPolygon","arcs":[[[-2648,2874,-2882,3009,3010,-3226,3242,3243,-3500,3508,-3587,3715,3716,3874,3875,3876,3973,-4051,4212,4210,4348,4349,4480,4481,4482,4483,4357,4358,4335,4336,4164,4165,4142,4143,4144,4119,4120,4121,4122,3912,-3790,3693,-3593,3383,3384,-3272,3147,-3016,2994,-2771,-2770,2689,-2594,2511,-2444,-2268,-2267,-2255,-2254,2477,2478,2479,2480,2481,2482,2487,2641,2489,2642,2567,2608,2553,2416,2374,-2174,2370,-2420,2638]]],"id":39},{"type":"MultiPolygon","arcs":[[[-5569,-5568,-5736,5780,-5962,5970,-6145,-6281,6343,-6579,6637,-6754,6799,6800,-7140,7252,7253,7254,7255,7427,7428,7424,7425,7426,7406,7466,7467,7468,7364,7365,7250,7251,7160,7161,7055,7056,6953,6954,-6894,6717,-6654,6428,-6395,6041,6042,5813,5814,5809,5810,5811,5806,5807,-5800,-5327,-5528,-5527,-5530,-5532,-5531,-5463,-5467,-5466,-5540,-5539,-5470,-5469,-5538,-5537,-5460,-5459,-5457,-5456,-5606,-5605,-5535,-5534,-5543,-5542]]],"id":40},{"type":"MultiPolygon","arcs":[[[637,-670,-583,-582,-675,-674,-673,-672,-671,-485,-484,-539,-537,-536,-495,-564,-518,-505,687,-890,944,-1066,1234,1235,1236,1237,1401,1402,1576,1577,1573,1574,1853,1945,1946,1864,1865,1585,1438,1271,955,754,601,640,-587]]],"id":41},{"type":"MultiPolygon","arcs":[[[-2057,-2061,-2060,-2029,-2028,-2164,-2163,-2131,-2130,-2128,-2127,-2065,-2299,-2298,-2543,2574,-2731,2789,-2889,-2888,-3105,3232,3233,-3506,3533,3564,3565,3474,3566,3476,3477,3425,3426,3478,3479,3480,3562,3563,3434,3435,3515,3516,3422,3437,3438,3526,3527,3528,3588,3589,-3588,3317,3318,3319,-3224,3083,-3010,2881,-2875,2647,-2639,2419,-2371,2173,2174,-2033,-2032,-2058]]],"id":42},{"type":"MultiPolygon","arcs":[[[2425,2294,2427,2526,-2500,2429,-2292,-2291,-1987,-2144,-2226,-2225]],[[2517]],[[2518,-2223]]],"id":44},{"type":"MultiPolygon","arcs":[[[-6658,-6674,-6673,-6783,-6704,-6703,-6878,-6877,-6873,-6872,-6901,-6952,-7029,-7028,-7027,-7274,-7308,7355,7616,9549,9548,7718,9545,7886,9546,7888,8102,8067,8099,8069,8098,8071,8097,8073,8074,8075,7922,-7917,7892,-7846,7735,7566,7567,7508,7509,7462,7463,-7367,7276,7079,7080,6942,6943,6944,6945,6946,-6698,-6778,-6777,-6776,-6722,-6796,-6795,-6659]],[[-7302,7353]],[[-7306,7354]],[[7615,9547]],[[8096]],[[8100]],[[8101]]],"id":45},{"type":"MultiPolygon","arcs":[[[-513,-612,-611,-614,-613,-608,-607,-534,-682,723,-818,867,-893,1017,1018,-1155,1193,-1310,-1465,1494,-1626,1633,-1731,1804,1805,1806,1807,1809,1810,1781,1782,1784,1644,1645,1654,1655,1525,1683,1682,1546,1547,1656,1657,-1617,1461,-1347,1222,1158,-1008,914,-656,-655,-499,-615,-605,-604,-603,-565]]],"id":46},{"type":"MultiPolygon","arcs":[[[-5715,-5713,-5920,-5919,-5858,-5857,-5940,-5939,-5854,-5911,-5910,-5824,-5823,-5844,-5843,-5836,-5835,-5846,-5906,-5905,-5918,-5917,-5916,-5881,-5994,-5885,-5884,-5954,6009,6010,6011,6110,6111,6255,6256,6257,6200,6313,6314,6420,6421,6485,6486,6622,6623,-6850,6852,6853,6819,6820,6744,6745,6746,6831,6832,6816,6817,6810,6811,6749,6750,6739,6724,6778,6779,6780,6798,6766,6767,6768,6796,6797,6792,6793,-6761,6632,-6439,-6438,-6437,-6436,6302,-6189,6127,-5927,-5983,-5925,-5985,-5984,-5959,-5958,-5851,-5850,-5964,-5963,-5754,-5677,-5676,-5716]]],"id":47},{"type":"MultiPolygon","arcs":[[[-5808,-5807,-5812,-5811,-5810,-5815,-5814,-6043,-6042,6394,-6429,6653,-6718,6893,-6955,-6954,-7057,-7056,-7162,-7161,-7252,-7251,-7366,-7365,-7469,-7468,-7467,-7407,-7427,-7426,-7425,-7429,-7428,-7256,-7255,-7540,7637,-7672,7843,-7932,-7931,-7930,8243,-8259,8424,-8477,-8476,-8670,8712,8713,-8973,9022,9046,9047,9142,9195,9144,9052,9194,9192,9196,9241,9239,9286,9229,9290,9289,9231,9245,9233,9246,9288,9300,9326,9282,9280,9327,9325,9302,9320,9332,9323,9333,9353,9335,9356,9354,9379,9421,9416,9417,9471,9467,9468,9469,9479,9478,9459,9456,9402,9331,9257,9190,9003,8903,8900,8913,8411,8413,-7914,-7811,-7810,-7809,-7992,-7991,-7990,-7684,-7683,-7682,-7681,-7680,7588,-7179,-7178,-7031,-7030,6886,-6584,-6583,6400,-5802,-5801]],[[9050,9141]],[[9191]],[[9285,9283,9324]],[[9318,9352]],[[9319]],[[9413,9414,9377,9350,9378,9415]],[[9351]],[[9404,9462]],[[9463,9464,9465,9407,9408,9405,9466]],[[9409,9410,9411,9412]],[[9461,9480]]],"id":48},{"type":"MultiPolygon","arcs":[[[-1706,2316,-2593,-2170,-2169,-2959,-2958,3075,3076,-3558,4006,-4617,4736,4737,4738,4739,4740,4741,5424,5425,5351,-4612,-4611,-4610,3978,-3543,-3542,2896,-2335,2329,-1993,-2080,-2079,-2115,-2024]]],"id":49},{"type":"MultiPolygon","arcs":[[[973,-875,970,1088,-1245,-1244,1429,-1589,1726,1727,1709,1710,1711,-1519,1458,1268,-1179,1105,-978,975,976,969,983]]],"id":50},{"type":"MultiPolygon","arcs":[[[-4005,-3793,-3831,-4101,-4100,-4373,4405,4487,4326,4395,4657,4804,4869,5072,5198,5197,5006,4868,4801,4983,5235,5379,5433,5381,5117,5157,5338,5483,5546,5671,5669,5699,5651,5482,5440,5292,5403,5589,5593,5639,5682,5897,5893,5929,5890,5839,5930,5871,5841,5872,5865,5866,5867,5868,5869,5931,5932,5895,5896,5817,5818,5819,5901,5739,5740,5906,5907,5908,5727,5728,5729,5687,5988,5689,5690,5933,5934,5921,5922,5874,5950,5951,5952,5953,5883,5884,5993,5880,5915,5916,5917,5904,5905,-5845,-5743,5655,-5625,-5246,-5245,-5244,-5109,-5421,-5420,-5387,-5386,-5385,-5189,-5285,-5284,5130,-4886,4880,-4523,-4522,-4389,-4388,-4387,-4173,-4172,4024,-3980,-3846,-3891,-4006],[5598]],[[5060,-4854]],[[5061,-4858]],[[-4851,5062]],[[5065,5066,-4776,5067,5063,5414]],[[-4772,5068]],[[5862,5863,5864]]],"id":51},{"type":"MultiPolygon","arcs":[[[83,78,81,-22,79,-113,235,236,-353,382,383,-519,563,494,535,536,538,483,484,670,671,672,673,674,581,582,669,-638,586,587,589,455,331,222,176,223,307,265,359,262,360,309,395,358,295,185,173,186,127,124,2,73]],[[116]],[[117]],[[118]],[[174]],[[260]],[[292]]],"id":53},{"type":"MultiPolygon","arcs":[[[-3529,-3528,-3804,-3803,-3802,-3800,-3799,-3798,-3796,-3795,-3794,4004,4005,3890,3845,3979,-4025,4171,4172,4386,4387,4388,4521,4522,-4881,4885,-5131,5283,5284,5188,5384,5385,5386,5419,5420,5108,5109,5110,4797,4798,-4733,-4482,-4481,-4350,-4349,-4211,-4213,4050,-3974,-3877,-3876,-3875,-3717,-3716,3586,-3509,3499,-3244,-3243,3225,-3011,-3084,3223,-3320,-3319,-3318,3587,-3590,-3589]]],"id":54},{"type":"MultiPolygon","arcs":[[[-570,-569,-620,-619,-693,9516,855,1129,857,1130,1142,9517,1140,1262,1448,1597,1773,1932,1998,1999,2000,1930,1931,1923,1924,1918,1919,1938,1939,1751,1752,1753,1669,-1629,1538,-1477,1396,-1344,1164,1160,1161,1136,-1114,1048,-1026,-878,-877,777,-773,645,-574,-573,-462,-137,9499,9501,9502,542,-466,-465,-571]],[[9503]]],"id":55},{"type":"MultiPolygon","arcs":[[[-677,-744,-743,-742,-657,-915,1007,-1159,-1223,1346,-1462,1616,1617,-1834,2017,2018,-2515,2523,2524,2525,2112,2113,2107,2108,2109,2167,2168,2169,2592,-2317,1705,1706,1707,-1567,1147,1148,-1096,-630,-629,-635,-806,-805,-678]]],"id":56},{"type":"MultiPolygon","arcs":[[[9947,9822,9926,9955,9816,9956,9998,9980,9859,9828,9889,9984,9884,9892,9924,10033,10004,9863,9902,9987,9897,10012,10018,10009,10028,10029,10020,10030,10000,10013,9950,9933,9988,9970,9851,9911,9996,9871,9958,9989,9830,9936]],[[10031]]],"id":72},{"type":"MultiPolygon","arcs":[[[10005]],[[10032]]],"id":78}]},"land":{"type":"MultiPolygon","arcs":[[[5868,6067,6065,6075,6114,6205,6220,6063,6084,6272,6460,6454,6611,6285,6612,6592,6521,6588,6830,6787,6857,6785,6916,7011,7133,7294,7132,7295,7304,7354,7306,7355,7616,9549,9548,7718,9545,7886,9546,7888,8102,8067,8099,8069,8098,8071,8097,8073,8304,8299,8355,8352,8546,8628,8544,8629,8727,8866,8936,9043,9151,9203,9226,9216,9150,9019,8933,9020,9177,9016,9175,9217,9272,9210,9273,9212,9268,9359,9385,9433,9387,9431,9443,9427,9444,9429,9445,9481,9489,9483,9491,9485,9490,9487,9494,9477,9453,9441,9393,9439,9395,9372,9342,9340,9310,9294,9261,9258,9201,9495,8995,8896,8996,9104,9036,9103,9038,8943,9039,8945,8836,8827,8837,8829,8819,8813,8697,8722,8699,8723,8869,8892,8910,8878,9040,9067,9060,9061,9062,9063,9135,9065,9140,9136,9137,9138,9139,9033,9128,9118,9119,9120,9030,9121,9122,9160,9124,9161,9126,9168,9163,9164,9165,9166,9167,9109,9088,9076,9099,9047,9142,9195,9144,9052,9194,9192,9196,9241,9239,9286,9229,9290,9289,9231,9245,9233,9246,9288,9300,9326,9282,9280,9327,9325,9302,9320,9332,9323,9333,9353,9335,9356,9354,9379,9421,9416,9417,9471,9467,9468,9469,9479,9478,9459,9456,9402,9331,9257,9190,9003,8903,8900,8913,8411,8413,7914,8132,8058,8229,8523,8212,7750,7765,7722,7545,7076,7041,6922,6556,5900,5619,5299,5203,5296,5447,5164,5019,4847,4539,4685,4457,4684,4459,4467,4841,4469,3604,2658,2346,1865,1585,1438,1271,955,754,601,640,587,589,455,331,222,176,223,307,265,359,262,360,309,395,358,295,185,173,186,127,124,2,73,83,78,81,22,34,18,41,97,86,44,48,27,8,51,108,91,96,101,38,30,62,66,55,58,104,9496,123,140,193,9497,192,135,9499,9501,9502,542,466,422,9508,434,9512,9514,473,9524,9526,9522,9527,555,9515,691,9516,855,1129,857,1130,1142,9517,1140,1262,1448,1597,1773,1932,1998,2087,2207,2506,2508,2440,2178,2124,1960,1759,1660,1507,1351,1199,1086,9534,9535,923,9530,9529,749,798,9536,1049,1210,9537,1408,1534,9538,1552,9539,1899,9540,9544,2478,9543,2480,9542,2482,2487,2641,2489,2642,2567,2608,2553,2416,2374,2174,2033,1803,1690,1687,1695,1698,1675,1544,1252,1539,1254,1249,994,1006,980,976,969,983,973,875,866,795,548,348,791,895,578,1091,1255,1259,1365,1363,1364,1261,1108,1366,1353,1362,1355,1511,1589,1721,1906,2093,1977,2092,1979,2089,2140,2151,2138,2147,2261,2260,2149,2221,2518,2223,2425,2294,2427,2526,2500,2532,2534,2531,2535,2520,2726,2723,3022,3074,3024,2725,2601,2744,2873,3093,3043,3136,3236,3325,3511,3501,3786,4108,3927,3924,3765,3925,3768,3730,3769,3732,3770,3704,3646,3504,3533,3564,3734,4086,4378,4773,4380,4778,4774,5067,5063,5414,5065,5066,4776,4860,4859,4678,4569,4567,4252,4394,4153,4062,3805,3815,3821,4072,4177,4071,4178,4174,4509,4277,4601,4719,4718,4603,4279,4371,4405,4487,4326,4395,4657,4804,4869,5072,5198,5197,5006,4868,4801,4983,5235,5379,5433,5381,5117,5157,5338,5483,5546,5671,5669,5699,5651,5482,5440,5292,5403,5589,5593,5639,5682,5897,5893,5929,5890,5839,5930,5871,5841,5872,6068,6286,6070,5866],[5598],[5864,5862],[-6072],[-6073]],[[8693,8810]],[[9560]],[[9561]],[[9562]],[[9563]],[[9564]],[[9565]],[[9566]],[[9567]],[[9568]],[[9569]],[[9570]],[[9571]],[[9572]],[[9573]],[[9574]],[[9575]],[[9576]],[[9577]],[[9578]],[[9579]],[[9580]],[[9581]],[[9582]],[[9583]],[[9584]],[[9585]],[[9586]],[[9587]],[[9588]],[[9589]],[[9590]],[[9591]],[[9592]],[[9593]],[[9594]],[[9595]],[[9597,9618,9602,9619,9612,9607,9608,9609,9720,9605,9721,9716,9711,9790,9789,9785,9783,9781,9772,9779,9756,9770,9685,9697,9691,9695,9643,9672,9660,9806,9662,9670,9635,9671,9645,9664,9647,9693,9650,9694,9689,9696,9687,9683,9771,9768,9769,9758,9753,9764,9751,9765,9744,9766,9734,9724,9767,9759,9631,9617,9599,9614]],[[9600]],[[9601]],[[9604]],[[9613]],[[9621]],[[9622]],[[9623]],[[9624]],[[9625]],[[9626]],[[9627]],[[9628]],[[9629]],[[9630]],[[9641,9673,9637,9674,9639,9682]],[[9642]],[[9651]],[[9699,9653,9700]],[[9654]],[[9655]],[[9656]],[[9657]],[[9658]],[[9659]],[[9675,9676,9677,9704,9702,9666,9701,9668,9703,9679]],[[9669]],[[9681,9692]],[[9698]],[[9705]],[[9706]],[[9707]],[[9712]],[[9713]],[[9714]],[[9715]],[[9735]],[[9736]],[[9737]],[[9738]],[[9739]],[[9740]],[[9741]],[[9742]],[[9745]],[[9746]],[[9748,9763]],[[9749]],[[9752]],[[9760]],[[9761]],[[9762]],[[9780]],[[9786]],[[9787]],[[9788]],[[9791]],[[9792]],[[9793]],[[9794]],[[9795]],[[9796]],[[9797]],[[9798]],[[9799]],[[9800]],[[9801]],[[9802]],[[9803]],[[9804]],[[9805]],[[6919]],[[6920]],[[7040]],[[7073]],[[7074]],[[8815,8812,8816,8825]],[[8935,9021]],[[9180,9013,9178,9218]],[[9102]],[[9306,9338]],[[9361,9384]],[[9369,9396]],[[9383,9432]],[[9390,9438]],[[9425,9442]],[[9436,9454]],[[9451]],[[9472,9493]],[[9492]],[[8302]],[[8303]],[[8351]],[[8542,8627]],[[8545]],[[8726]],[[9551,9555]],[[9552]],[[9553]],[[9554]],[[9556]],[[9557]],[[9558]],[[9559]],[[-9060,-9057],[9133],[9134]],[[9085]],[[9117,9159]],[[9132]],[[9162]],[[893]],[[894]],[[4150]],[[4772,5068]],[[4851,5062]],[[4854,4855,4852,5060]],[[4858,4856,5061]],[[2604]],[[2700]],[[9506,9504,9509]],[[9507]],[[9518,9519]],[[9520]],[[9525]],[[9531]],[[9532]],[[1799]],[[2756,3028]],[[3031,3099,3132,3101,3033,2758,3029,3096]],[[3098,3131]],[[3217]],[[6283,6281,6610]],[[7293,7303]],[[7302,7353]],[[2517]],[[7615,9547]],[[8096]],[[8100]],[[8101]],[[9050,9141]],[[9191]],[[9285,9283,9324]],[[9318,9352]],[[9319]],[[9413,9414,9377,9350,9378,9415]],[[9351]],[[9404,9462]],[[9463,9464,9465,9407,9408,9405,9466]],[[9409,9410,9411,9412]],[[9461,9480]],[[116]],[[117]],[[118]],[[174]],[[260]],[[292]],[[9503]],[[9947,9822,9926,9955,9816,9956,9998,9980,9859,9828,9889,9984,9884,9892,9924,10033,10004,9863,9902,9987,9897,10012,10018,10009,10028,10029,10020,10030,10000,10013,9950,9933,9988,9970,9851,9911,9996,9871,9958,9989,9830,9936]],[[10031]],[[10005]],[[10032]]]}},"arcs":[[[162416,583189],[236,-863],[95,-3199],[219,-1079],[-271,-1241]],[[162695,576807],[-442,-309],[-4397,83]],[[157856,576581],[-6,1800],[-436,606],[-476,3062],[168,1173],[2781,-89],[2529,56]],[[203483,583173],[-111,-3268],[363,0],[1,-4838],[604,-14]],[[204340,575053],[0,-6406],[-109,-3],[-1,-3886]],[[204230,564758],[-1074,300],[-477,661],[-50,-1946]],[[202629,563773],[-411,-2654],[-860,-2419],[-1043,-435],[-462,561]],[[199853,558826],[29,9804],[98,1617],[303,-7],[-114,3279],[302,529],[-36,7508],[73,1628]],[[200508,583184],[2975,-11]],[[181317,583162],[311,-3373],[318,707],[389,-2530],[-133,-1970],[788,-1235],[-38,-1636],[347,-662],[20,-2123]],[[183319,570340],[343,-1416],[-25,-1101],[608,-791]],[[184245,567032],[386,-2907],[-296,-415]],[[184335,563710],[-284,-667],[56,-2638],[-277,-1038],[59,-2315]],[[183889,557052],[-896,67]],[[182993,557119],[-467,-2]],[[182526,557117],[100,1562],[-233,2072],[31,1860],[-477,1550],[-122,1357],[-537,-515],[111,-1134],[-1263,-12],[41,-3203],[-354,-5]],[[179823,560649],[-1,1601],[-1073,-52],[-59,2655]],[[178690,564853],[-26,3920],[480,4],[-5,6467],[-109,1580],[659,10],[112,1730],[-222,1681],[-105,2947]],[[179474,583192],[1843,-30]],[[175797,583199],[0,-9287]],[[175797,573912],[-2052,-27],[-1,6456],[-689,-16]],[[173055,580325],[0,2843]],[[173055,583168],[2742,31]],[[199853,558826],[-98,-1296],[-681,144],[-597,-3335]],[[198477,554339],[-62,2205],[-374,544],[-689,-277]],[[197352,556811],[-1279,1156],[-333,1654]],[[195740,559621],[8,3507],[732,-36],[49,1308],[485,-270],[63,8718],[182,-420],[75,5957],[166,-2],[64,4793]],[[197564,583176],[2944,8]],[[221924,574709],[-1819,8]],[[220105,574717],[-103,3252],[0,5201]],[[220002,583170],[1831,2]],[[221833,583172],[2,-5232],[89,-3231]],[[178690,564853],[-400,43],[-118,-1893],[-228,-480],[-676,326],[-47,1381],[-616,5246],[-698,-1924],[-112,1019]],[[175795,568571],[2,5341]],[[175797,583199],[3677,-7]],[[220105,574717],[-364,-10]],[[219741,574707],[-362,-1],[-1,1624],[-1819,10],[0,-1619]],[[217559,574721],[-1091,11],[0,3239],[-126,10],[-1,5192]],[[216341,583173],[3661,-3]],[[186539,583158],[26,-9701]],[[186565,573457],[-1094,108],[-10,-3230],[-2142,5]],[[181317,583162],[5222,-4]],[[193948,567081],[-537,-46],[0,1653],[-331,-43],[0,1617],[-2172,10],[0,-1617],[-363,1]],[[190545,568656],[35,14501]],[[190580,583157],[3492,32]],[[194072,583189],[-44,-7981],[115,-2218],[-242,-2960],[47,-2949]],[[195740,559621],[-133,1040],[-934,56],[-434,-1362],[-302,350]],[[193937,559705],[11,7376]],[[194072,583189],[3492,-13]],[[206421,583169],[53,-6498],[181,-1619]],[[206655,575052],[-2315,1]],[[203483,583173],[2938,-4]],[[228232,583191],[206,-4516],[166,-1312],[-187,-2686]],[[228417,574677],[-2130,0]],[[226287,574677],[-64,8514]],[[226223,583191],[2009,0]],[[230526,583184],[49,-8486]],[[230575,574698],[-2158,-21]],[[228232,583191],[2294,-7]],[[223380,574698],[-1,-3220],[-639,-11]],[[222740,571467],[-816,5]],[[221924,571472],[0,3237]],[[221833,583172],[1465,10]],[[223298,583182],[0,-5247],[82,-3237]],[[226287,574677],[-1090,12]],[[225197,574689],[-1817,9]],[[223298,583182],[2925,9]],[[168030,583185],[-42,-19407]],[[167988,563778],[-338,-262]],[[167650,563516],[-25,343]],[[167625,563859],[88,1056],[-308,2218],[-250,148],[-799,-1281],[-586,-1450],[-104,1726],[-570,-649],[55,-1799]],[[165151,563828],[-497,4],[-263,1945],[-611,1931],[-82,1381],[-532,1417],[-331,3957]],[[162835,574463],[-140,2344]],[[162416,583189],[2209,-15],[3405,11]],[[171951,583192],[-373,-3049],[-183,-3367],[361,7],[-7,-9706],[182,-1632]],[[171931,565445],[-274,12],[-1,-4693],[-435,1680],[-360,-1132]],[[170861,561312],[-166,418],[-548,-890],[-371,2707],[-364,-947]],[[169412,562600],[-132,2358],[406,757],[-5,1210],[289,2381],[-186,3288],[316,4420],[-332,3951],[45,2219]],[[169813,583184],[2138,8]],[[173055,580325],[-26,-14911]],[[173029,565414],[-1098,31]],[[171951,583192],[1104,-24]],[[169412,562600],[-45,-983],[-485,620],[-109,1069],[-446,-598],[-339,1070]],[[168030,583185],[1783,-1]],[[188725,567028],[0,1624]],[[188725,568652],[374,0],[11,14480]],[[189110,583132],[1470,25]],[[190545,568656],[-199,-1611],[-1621,-17]],[[212324,583170],[-3,-5175],[150,-1639]],[[212471,576356],[-3238,15]],[[209233,576371],[-1,6810]],[[209232,583181],[3092,-11]],[[214880,583162],[-1,-3570]],[[214879,579592],[-364,-1],[-1,-1615],[-226,0],[0,-3239]],[[214288,574737],[-1816,1]],[[212472,574738],[-1,1618]],[[212324,583170],[2556,-8]],[[186539,583158],[2571,-26]],[[188725,568652],[-718,-1],[2,2422],[-362,804],[-543,30],[-81,1075],[-458,475]],[[217559,574721],[0,-1621]],[[217559,573100],[-2179,21],[-1,4852],[-499,6],[-1,1613]],[[214880,583162],[1461,11]],[[233488,574623],[-724,-26]],[[232764,574597],[-2189,101]],[[230526,583184],[3019,-21]],[[233545,583163],[240,-2188],[403,729],[4,-3863],[-704,-3],[0,-3215]],[[209233,576371],[4,-4555]],[[209237,571816],[-1620,-3],[1,1621],[-362,4],[0,1612],[-601,2]],[[206421,583169],[2811,12]],[[175795,568571],[0,-4401]],[[175795,564170],[-503,1655],[-278,-929],[18,-2373]],[[175032,562523],[-508,-3],[3,1886],[-1500,-263]],[[173027,564143],[2,1271]],[[217559,573100],[127,-1619],[-2,-6492],[124,-2],[-3,-3238]],[[217805,561749],[-2509,-20]],[[215296,561729],[1,3269],[-141,0],[0,6485],[-143,10],[1,3259],[-726,-15]],[[156776,574866],[145,-2337],[-336,700],[191,1637]],[[156018,576189],[368,-1161],[-54,-1922],[-275,764],[-39,2319]],[[156711,577874],[437,-1002],[-571,-1183],[-175,1060],[309,1125]],[[239768,576252],[-26,-7172],[46,-6527]],[[239788,562553],[-1935,132],[-2,-978],[-1789,-11]],[[236062,561696],[-28,9709]],[[236034,571405],[-5,6210]],[[236029,577615],[339,174],[235,-1132],[1048,-348],[153,-2131],[908,561],[5,841],[719,948],[332,-276]],[[157403,572219],[-141,1501],[247,575],[362,-1247],[-15,3533]],[[162835,574463],[-341,252],[-585,-931],[-105,-3299],[196,-417]],[[162000,570068],[-3852,30]],[[158148,570098],[-745,2121]],[[212472,574738],[0,-3235],[160,6],[-1,-4641]],[[212631,566868],[-1040,215],[-261,-1783],[-494,-877],[-372,2569],[-383,-709],[-219,-2109],[-618,321]],[[209244,564495],[-7,7321]],[[219741,574707],[109,-3230],[1,-6504],[110,0],[-1,-3243]],[[219960,561730],[-1079,-3]],[[218881,561727],[-1076,22]],[[243362,568345],[29,-12216],[-17,-11281]],[[243374,544848],[-834,-2840],[-305,-2385]],[[242235,539623],[-249,57]],[[241986,539680],[-26,1879],[-2117,44]],[[239843,541603],[15,4838]],[[239858,546441],[-15,12916],[-55,3196]],[[239768,576252],[1003,-1644],[260,59],[-216,-1482],[572,-281],[382,-4206],[280,489],[20,1987],[577,82],[136,-1749],[580,-1162]],[[209244,564495],[-258,1115],[-593,-179],[-307,1362],[-1057,19],[-145,560],[-288,-1582],[-558,-1]],[[206038,565789],[-93,497],[-752,103],[-963,-1631]],[[165151,563828],[-358,-3363],[-516,-331],[-140,-2995],[-194,-1515],[49,-2367],[561,-1042],[-26,-1385]],[[164527,550830],[-822,-17],[-768,1528],[-383,1475],[-339,202],[-528,3048]],[[161687,557066],[130,2031],[-145,1372]],[[161672,560469],[136,875],[-308,1331],[76,2649],[386,643],[303,1650],[-265,2451]],[[215296,561729],[-1431,3],[-1,-1673]],[[213864,560059],[-714,1226]],[[213150,561285],[-16,1450],[265,1806],[-308,1452],[-460,875]],[[232764,574597],[24,-6811]],[[232788,567786],[-2527,21]],[[230261,567807],[-1798,-6]],[[228463,567801],[13,367]],[[228476,568168],[71,2441],[-130,4068]],[[221924,571472],[-985,7],[-4,-6507],[100,-3249]],[[221035,561723],[-716,0]],[[220319,561723],[-359,7]],[[223962,564053],[0,0]],[[225197,574689],[73,-6488]],[[225270,568201],[-362,-8],[-2,-3234],[-287,1],[0,-1975]],[[224619,562985],[-263,25],[-571,2718],[-293,-1216],[-752,3114],[0,3841]],[[228476,568168],[-2123,27]],[[226353,568195],[-1083,6]],[[236062,561696],[6,-7465]],[[236068,554231],[0,-615],[-707,-31]],[[235361,553585],[-1430,49]],[[233931,553634],[-29,8560],[-224,1564],[125,1180],[-985,11]],[[232818,564949],[-30,2837]],[[233488,574623],[363,-5],[3,-3239],[2180,26]],[[188725,567028],[1,-2703]],[[188726,564325],[-1602,-42],[-179,1901],[-362,820],[-2338,28]],[[158090,569229],[27,-389]],[[158117,568840],[-233,-1009],[277,-1641],[-369,861],[-55,2156],[353,22]],[[157569,571941],[242,-1775],[-417,-308],[-219,-1058],[350,-340],[186,-3597],[44,1501],[415,-1154],[-2,-2382],[-642,2318],[-19,2344],[-435,1258],[298,3297],[199,-104]],[[156635,565779],[-61,-3686],[-1563,-8],[-1,265],[-3066,-4]],[[151944,562346],[-337,5364],[262,4073],[685,-1863],[396,-423],[748,-1863],[763,57],[868,-995],[776,701],[530,-1618]],[[224619,562985],[0,-1281]],[[224619,561704],[-2150,10]],[[222469,561714],[-1434,9]],[[193937,559705],[-803,-422],[-50,-3212],[-1028,-2365]],[[192056,553706],[-1187,-7]],[[190869,553699],[-361,553],[1,1468],[-266,4],[-517,1364],[204,1867],[-1205,-7]],[[188725,558948],[1,5377]],[[161672,560469],[-3555,-37]],[[158117,560432],[249,3191],[302,1598],[-408,1180],[-143,2439]],[[158090,569229],[58,869]],[[179823,560649],[58,-3498],[649,4],[-91,-2233],[239,252],[-155,-1950],[417,-649],[44,-4053]],[[180984,548522],[-292,-237],[-171,1187],[-551,1163],[-685,298]],[[179285,550933],[-478,836],[-38,1569],[-836,1676],[-964,-135]],[[176969,554879],[-353,1336],[183,799],[-96,1863],[-283,1074],[-625,4219]],[[245498,568092],[24,-13481]],[[245522,554611],[-1265,-6316],[-883,-3447]],[[243362,568345],[243,-1594],[424,-163],[-24,-1207],[886,751],[607,1960]],[[226353,568195],[59,-3242],[-1,-6490]],[[226411,558463],[-285,2]],[[226126,558465],[-1436,0]],[[224690,558465],[-71,3239]],[[228463,567801],[349,-5611],[345,-3679]],[[229157,558511],[-1604,-50]],[[227553,558461],[-1142,2]],[[230261,567807],[50,-3920]],[[230311,563887],[2,-2161],[360,-5],[3,-1615],[1434,5],[0,1629],[356,7],[-1,1624]],[[232465,563371],[355,-34]],[[232820,563337],[78,-8073]],[[232898,555264],[-1430,-21]],[[231468,555243],[-2182,14]],[[229286,555257],[-129,3254]],[[232818,564949],[2,-1612]],[[232465,563371],[-1,531],[-2153,-15]],[[209244,564495],[-2,-11146]],[[209242,553349],[-241,-807],[-805,9]],[[208196,552551],[-259,2],[1,3249],[-225,-5],[0,1619],[-1072,7],[1,1622],[-715,4],[0,1622]],[[205927,560671],[111,1441],[0,3677]],[[167625,563859],[-339,-5],[-301,-1380],[-1,-1619],[-240,-1347],[-120,-2159],[-533,-1577],[-2,-1607],[-954,-85],[-359,-2172],[-6,-1862]],[[164770,550046],[-243,784]],[[213150,561285],[-1,-2790],[-1274,10],[2,-6436]],[[211877,552069],[-1581,12]],[[210296,552081],[-1055,15]],[[209241,552096],[1,1253]],[[156466,557234],[-1440,16],[0,-1664]],[[155026,555586],[-1512,9],[-856,299]],[[152658,555894],[-216,4014],[-498,2438]],[[156635,565779],[272,1293],[567,-4576],[-189,-395],[-250,-3034],[-106,2479],[-245,-3231],[-218,-1081]],[[188725,558948],[-718,-7],[0,-1612],[-713,3],[0,-1972],[-347,194]],[[186947,555554],[-644,-185],[-425,1863],[-410,507],[-656,-490],[-280,1680],[6,2406],[-203,2375]],[[205927,560671],[-357,-7],[-2,-4859],[-120,-3],[1,-6473]],[[205449,549329],[-1188,-10],[0,-1636],[-355,-3],[0,1641],[-353,-3]],[[203553,549318],[-233,0],[-1,3235],[-355,-6],[105,3251],[-1,6317],[-271,1],[-168,1657]],[[176969,554879],[-257,-1008],[473,-1408],[60,-942],[526,-680],[549,-2997],[263,-2458],[251,-686]],[[178834,544700],[-3821,28]],[[175013,544728],[0,1637]],[[175013,546365],[0,7286]],[[175013,553651],[19,8872]],[[182526,557117],[-825,-26],[-59,-2280],[224,-1574],[136,-3906],[-311,-808],[-707,-1]],[[173027,564143],[7,-11380]],[[173034,552763],[0,-1987]],[[173034,550776],[-2181,21]],[[170853,550797],[8,10515]],[[233931,553634],[40,-4845]],[[233971,548789],[-1065,-20]],[[232906,548769],[-8,6495]],[[175013,553651],[-714,16],[-121,-799],[-1144,-105]],[[203553,549318],[1,-5970]],[[203554,543348],[0,-266]],[[203554,543082],[-1766,-14],[-2,268],[-3263,-151]],[[198523,543185],[-142,488],[173,2154],[-209,2560],[-11,4245],[143,1707]],[[167650,563516],[-17,-12699]],[[167633,550817],[-9,-6519],[-1075,22],[-3,-3262]],[[166546,541058],[-233,-1080]],[[166313,539978],[-187,856],[-295,-1494],[-690,-305]],[[165141,539035],[-276,2021]],[[164865,541056],[127,1141],[-311,5065],[89,2784]],[[170853,550797],[-380,1]],[[170473,550798],[-2840,19]],[[186947,555554],[7,-6012],[711,-1191],[-2,-4004],[368,-11]],[[188031,544336],[35,-1329],[411,-1480]],[[188477,541527],[-392,-449],[14,-3150],[-430,-3]],[[187669,537925],[-672,2],[-784,-2757]],[[186213,535170],[46,3441],[-325,1748],[-347,-22],[-1,2529],[-723,-49],[-4,6432],[-731,40],[-1,5728],[-238,2035]],[[157723,558953],[153,-2103],[-264,244],[111,1859]],[[157679,553460],[-209,2]],[[157470,553462],[-20,-1]],[[157450,553461],[-465,10]],[[156985,553471],[3,2162],[-620,2]],[[156368,555635],[296,1874],[456,872],[192,2438],[440,2118],[103,-3143],[-199,148],[-132,-3407],[313,-1094],[-158,-1981]],[[239858,546441],[-2004,75]],[[237854,546516],[-5,4597],[-695,1379],[-255,2407],[-570,-1212],[-261,544]],[[218881,561727],[0,-3232],[-241,5],[-5,-6449]],[[218635,552051],[-211,-1],[0,-3173],[-602,-11]],[[217822,548866],[-251,2540],[-562,-513]],[[217009,550893],[-256,567],[-257,3108],[37,1844],[-852,-555],[-223,-664],[-1091,1452]],[[214367,556645],[-155,784],[-3,3079],[-345,-449]],[[224690,558465],[0,-1585]],[[224690,556880],[-2133,9]],[[222557,556889],[-88,4825]],[[222557,556889],[-1,-4848]],[[222556,552041],[-598,-4]],[[221958,552037],[-1539,4]],[[220419,552041],[1,6449],[-101,3233]],[[220419,552041],[-222,0]],[[220197,552041],[-1562,10]],[[214367,556645],[0,-4588],[170,0],[-1,-5915]],[[214536,546142],[-1061,-2],[0,-539],[-1412,-13]],[[212063,545588],[-1,6481],[-185,0]],[[197352,556811],[-7,-4999],[-769,-161],[-357,-670],[-49,-3204],[357,-6],[-62,-6487]],[[196465,541284],[-1055,22]],[[195410,541306],[-1057,8],[-1,-1068]],[[194352,540246],[-993,3]],[[193359,540249],[-235,2015],[208,1753],[-4,5387],[-1034,1609],[0,1620],[-238,1073]],[[208196,552551],[219,-2029],[101,-3785],[-297,-2572],[-534,-806]],[[207685,543359],[-1181,12],[-117,1073],[-355,1],[1,1079],[-357,1],[0,3802],[-227,2]],[[157999,553531],[-252,-1157],[151,3089],[101,-1932]],[[161687,557066],[-282,-523],[-596,-2846],[-98,-1164],[461,-3838],[-226,-1130]],[[160946,547565],[-1160,1607],[-393,-641],[-440,1038],[-133,1180],[-534,2],[-231,1165]],[[158055,551916],[258,528],[-269,4233],[225,530],[-269,1061],[117,2164]],[[190869,553699],[1,-1066],[-357,2],[-14,-4901],[354,-2],[-21,-5066]],[[190832,542666],[-725,2921],[-441,463],[-27,1540],[-216,-1427],[-1062,-215],[1,-1610],[-331,-2]],[[227553,558461],[-3,-6470],[62,-1591]],[[227612,550400],[-709,17]],[[226903,550417],[-711,10]],[[226192,550427],[-71,1593],[5,6445]],[[226192,550427],[-1411,-1]],[[224781,550426],[-88,1602]],[[224693,552028],[-3,4852]],[[229286,555257],[52,-4884]],[[229338,550373],[-1726,27]],[[156466,557234],[-98,-1599]],[[156985,553471],[-2,-836]],[[156983,552635],[-348,-1456],[-55,-1446],[-357,-1953]],[[156223,547780],[-354,-250]],[[155869,547530],[-800,-41],[-43,8097]],[[182993,557119],[1,-7838],[455,9],[-1,-6466]],[[183448,542824],[-493,-547],[1,-1076],[-524,-538],[1,-1073],[-447,49]],[[181986,539639],[-1407,-5]],[[180579,539634],[-732,-499]],[[179847,539135],[-221,1916]],[[179626,541051],[351,195],[-48,4029],[320,549],[-90,1379],[-636,2137],[-238,1593]],[[186213,535170],[-690,-2887]],[[185523,532283],[-1333,17]],[[184190,532300],[-6,8737],[-214,-420],[-522,2207]],[[198523,543185],[180,-1781]],[[198703,541404],[-2238,-120]],[[164865,541056],[-1495,18],[1,1609],[-349,24],[-1,1604],[-1091,-12],[-177,1484],[-533,1821],[-274,-39]],[[224693,552028],[-2137,13]],[[217009,550893],[-2,-451],[-1411,-2],[0,-4839]],[[215596,545601],[-927,-4]],[[214669,545597],[-133,545]],[[155869,547530],[121,-1651],[-6,-3776]],[[155984,542103],[-586,-24]],[[155398,542079],[-2026,38]],[[153372,542117],[-109,2053],[252,-202],[623,1195],[-914,1191],[-230,4847],[-241,1362],[-95,3331]],[[232906,548769],[-1437,4]],[[231469,548773],[-1,6470]],[[231469,548773],[-356,-11]],[[231113,548762],[-1799,-4]],[[229314,548758],[24,1615]],[[179626,541051],[-762,2278],[-30,1371]],[[237854,546516],[-2,-4236]],[[237852,542280],[-1578,49],[42,-9604],[-40,-223]],[[236276,532502],[-231,1007],[-307,-539],[-331,854]],[[235407,533824],[-217,373]],[[235190,534197],[-133,485],[-22,7620]],[[235035,542302],[354,-11],[-28,11294]],[[310206,521389],[-674,-758]],[[309532,520631],[-1071,-1126],[-11,14937],[-1066,257]],[[307384,534699],[-8,3291],[-2505,26]],[[304871,538016],[-841,2]],[[304030,538018],[72,2263],[2153,14229],[505,-617],[6,-3382],[393,-1252],[815,1288],[76,747],[564,5],[41,1253],[358,12],[783,-2953],[455,-2410],[25,-20921],[-70,-4891]],[[193359,540249],[-620,1062],[-850,-749]],[[191889,540562],[-514,-597],[-543,2701]],[[175013,546365],[-1409,188],[-569,1764]],[[173035,548317],[-1,2459]],[[235035,542302],[-1047,14]],[[233988,542316],[-17,6473]],[[160946,547565],[-214,-3054],[-186,-928],[190,-1670]],[[160736,541913],[-846,11],[-206,-1039],[-1032,653]],[[158652,541538],[-352,1507],[-447,420],[-411,2054],[-166,2243]],[[157276,547762],[314,1630],[142,2452],[323,72]],[[157679,553460],[-93,-2779],[-243,609],[127,2172]],[[157450,553461],[-258,-1218],[-95,-3180],[-195,1415],[81,2157]],[[209241,552096],[0,-12822]],[[209241,539274],[-860,0],[-178,809],[-527,0]],[[207676,540083],[9,3276]],[[212063,545588],[-553,-13],[-2,-6517]],[[211508,539058],[-1052,-1]],[[210456,539057],[-1,6518],[-160,-2],[1,6508]],[[210456,539057],[-534,-4],[0,-1653],[-681,3]],[[209241,537403],[0,1871]],[[221958,552037],[-1,-6447],[97,4],[-9,-6501]],[[222045,539093],[-1299,23]],[[220746,539116],[-461,8]],[[220285,539124],[17,6480],[-110,4],[5,6433]],[[224781,550426],[0,-4857],[78,2],[1,-6489]],[[224860,539082],[-1665,-10]],[[223195,539072],[-1150,21]],[[220285,539124],[-1617,18]],[[218668,539142],[-334,973],[-96,2185],[-334,3330]],[[217904,545630],[153,619],[-235,2617]],[[217904,545630],[-2308,-29]],[[170473,550798],[4,-6433],[-150,-2316],[-550,-960]],[[169777,541089],[-3231,-31]],[[173035,548317],[0,-10900]],[[173035,537417],[-1,-2156]],[[173034,535261],[-434,-110],[-90,788]],[[172510,535939],[-70,1545],[-616,2886],[-768,-191],[-281,-1215]],[[170775,538964],[-894,-1263],[-120,595]],[[169761,538296],[16,2793]],[[226903,550417],[68,-4868],[-1,-6487]],[[226970,539062],[-981,13]],[[225989,539075],[-1129,7]],[[229314,548758],[6,-2652],[212,-1371],[-110,-2548],[11,-3117]],[[229433,539070],[-1343,-23]],[[228090,539047],[-1120,15]],[[158652,541538],[-2669,24],[1,541]],[[156223,547780],[371,1366],[-165,-1817],[270,11],[248,1910],[329,-1488]],[[207676,540083],[-351,-1344]],[[207325,538739],[-350,-4],[-351,-1338],[-710,7],[-584,557],[-128,1621],[-225,-2],[-117,3243],[-599,530],[-707,-5]],[[233988,542316],[-2,-1623]],[[233986,540693],[-2817,4]],[[231169,540697],[-56,8065]],[[231169,540697],[7,-1623],[-303,3]],[[230873,539077],[-1399,-8]],[[229474,539069],[-41,1]],[[175013,544728],[1,-5708],[-353,22]],[[174661,539042],[-461,-3],[-274,-1604],[-891,-18]],[[165141,539035],[21,-10945]],[[165162,528090],[-2024,0],[-2594,63]],[[160544,528153],[1,6416]],[[160545,534569],[358,11],[-157,2684],[251,3313],[-261,1336]],[[191889,540562],[-24,-9124]],[[191865,531438],[0,-676]],[[191865,530762],[-1399,153]],[[190466,530915],[-776,9]],[[189690,530924],[-179,1515],[195,2306],[-474,569],[-329,2182],[-426,4031]],[[239843,541603],[18,-6465]],[[239861,535138],[3,-4862]],[[239864,530276],[-1053,-77]],[[238811,530199],[4,1716],[-1019,-55]],[[237796,531860],[-43,6341],[94,109],[5,3970]],[[251183,535146],[2,-1610]],[[251185,533536],[-1045,-5],[1,3215],[-1046,-7],[1,1617],[-346,12],[-67,3222]],[[248683,541590],[281,994],[1035,453],[493,1189],[335,1615],[517,690]],[[251344,546531],[2,-4942],[190,-1609],[-348,14],[-5,-4848]],[[214669,545597],[2,-4901]],[[214671,540696],[-1,-1616]],[[214670,539080],[-2316,-18]],[[212354,539062],[-846,-4]],[[218668,539142],[261,-751],[-62,-3093]],[[218867,535298],[-369,-883],[-548,257],[-360,-2040]],[[217590,532632],[0,1615],[-698,1],[0,4816],[-1166,16],[-1,1620],[-1054,-4]],[[253820,544308],[0,-2727],[148,-1606],[-346,-13],[-2,-4818]],[[253620,535144],[-1568,10]],[[252052,535154],[1,8036],[354,0],[-1,1615],[281,8]],[[252687,544813],[-46,-3488],[634,3347],[545,-364]],[[179847,539135],[-2884,-2989],[-518,-3856],[-988,1959]],[[175457,534249],[-555,1774]],[[174902,536023],[-221,561],[-20,2458]],[[207325,538739],[0,-2429],[-482,-1],[56,-6431]],[[206899,529878],[-149,-3],[0,-6509],[-119,1]],[[206631,523367],[-3371,30]],[[203260,523397],[2,6486],[106,4],[-6,6446],[97,2],[-1,6474],[96,273]],[[203260,523397],[-118,-5],[-3,-8127],[-123,-28],[0,-3172]],[[203016,512065],[-1361,-4],[-1,3224],[108,-22],[0,5982],[-511,206],[100,2748],[-172,715]],[[201179,524914],[0,4963],[-191,-48],[-58,4865],[-348,2],[-60,1616],[-1571,-11]],[[198951,536301],[-119,265]],[[198832,536566],[-129,4838]],[[184190,532300],[-1,-814],[-687,-6],[16,-3298],[-667,-1968]],[[182851,526214],[-255,180],[-219,1599],[-324,48],[141,1392],[-197,1673],[207,1275],[-352,4420],[134,2838]],[[235190,534197],[-1182,4]],[[234008,534201],[-22,6492]],[[237796,531860],[-40,-1612]],[[237756,530248],[-1572,9],[92,2245]],[[155398,542079],[35,-7597]],[[155433,534482],[-1024,26],[-6,-1764]],[[154403,532744],[-413,-941],[-401,1402],[-173,-854],[164,5827],[40,-3886],[155,66],[162,3197],[-178,1201],[335,1945],[-444,-237],[-278,1653]],[[160545,534569],[-1999,-62]],[[158546,534507],[-2721,-5]],[[155825,534502],[-392,-20]],[[189690,530924],[-791,-90],[-193,-3456],[-681,-3145]],[[188025,524233],[-1,4020],[-345,10],[-10,9662]],[[241986,539680],[-2,-4580]],[[241984,535100],[-2123,38]],[[251185,533536],[-1,-4392]],[[251184,529144],[-281,766],[-2333,3002],[1,-217]],[[248571,532695],[-534,909],[-308,3219],[-519,1035]],[[247210,537858],[1092,2058],[381,1674]],[[198832,536566],[-2,-1875],[-408,1],[-281,-2448],[-812,5],[-234,-521],[0,-1925],[-1045,-3]],[[196050,529800],[2,2684],[-229,1641],[-121,3955],[-233,24],[-59,3202]],[[261640,541399],[0,-9498]],[[261640,531901],[-1747,-14]],[[259893,531887],[0,4842]],[[259893,536729],[1,3447]],[[259894,540176],[1066,-173],[680,1396]],[[196050,529800],[-402,-6]],[[195648,529794],[-1369,1],[-5,-1634]],[[194274,528161],[-523,16],[-137,3240]],[[193614,531417],[700,2],[38,8827]],[[193614,531417],[-1749,21]],[[169761,538296],[-37,88]],[[169724,538384],[-623,62],[-454,-1720],[-56,-1736],[-390,-2246],[-741,-1821]],[[167460,530923],[-633,1584],[-9,4567],[-505,2904]],[[167460,530923],[206,-1170],[-54,-2423]],[[167612,527330],[-388,-1247],[-851,-272]],[[166373,525811],[-390,134],[-274,-1277],[-552,-389]],[[165157,524279],[5,3811]],[[234008,534201],[28,-4881]],[[234036,529320],[-1739,14]],[[232297,529334],[-1380,21]],[[230917,529355],[-44,9722]],[[217590,532632],[-397,-2552],[-436,-1343],[-920,-1191],[-478,1151],[-416,-370]],[[214943,528327],[2,2829]],[[214945,531156],[-136,1457],[-12,6465],[-127,2]],[[172510,535939],[1,-949],[-532,-522],[0,-4866],[-168,2],[-1,-2311]],[[171810,527293],[-342,19]],[[171468,527312],[-25,6322],[-176,-16],[-173,2490],[-351,-8],[32,2864]],[[209241,537403],[-1,-4854]],[[209240,532549],[1,-6235]],[[209241,526314],[3,-1180]],[[209244,525134],[-252,2],[0,1618],[-714,26],[2,1575],[-351,-6],[1,1522],[-1031,7]],[[180579,539634],[-28,-2628],[-263,-4539],[-67,-3326],[-131,-1223],[266,-995],[6,-2349],[-249,-34],[-187,-1419],[188,-1950],[-181,-2072]],[[179933,519099],[-282,-1616],[-344,766],[-14,-1410],[527,-2617],[-250,-1838]],[[179570,512384],[-3571,-27],[-470,-1640]],[[175529,510717],[-390,423],[-163,2564],[-956,-4]],[[174020,513700],[363,4438],[258,2020],[-237,2562],[-686,1930]],[[173718,524650],[258,2609]],[[173976,527259],[447,45],[75,2435],[241,1363],[664,-892],[157,1127],[336,203],[-439,2709]],[[182851,526214],[3,-24]],[[182854,526190],[-34,-1070],[-471,-700],[-670,-2752]],[[181679,521668],[-944,-3979],[-194,-400],[-349,1947],[-259,-137]],[[220746,539116],[-2,-6512],[106,-6]],[[220850,532598],[-4,-6356]],[[220846,526242],[-1761,43]],[[219085,526285],[-327,3734],[198,1955],[-89,3324]],[[223195,539072],[-2,-6466]],[[223193,532606],[-2343,-8]],[[174902,536023],[1,-2306],[-958,-326],[31,-6132]],[[173718,524650],[-339,2599]],[[173379,527249],[-121,1925],[103,1310],[-372,3279],[45,1498]],[[212354,539062],[9,-6488]],[[212363,532574],[-197,-15]],[[212166,532559],[-2926,-10]],[[225989,539075],[-2,-6477]],[[225987,532598],[-2698,1]],[[223289,532599],[-96,7]],[[214945,531156],[-1392,13],[0,1436],[-1190,-31]],[[230917,529355],[-1,-1621]],[[230916,527734],[-866,4]],[[230050,527738],[45,1765],[-114,3994],[-380,2927],[-127,2645]],[[228090,539047],[-2,-6457]],[[228088,532590],[-2023,4]],[[226065,532594],[-78,4]],[[230050,527738],[35,-1611]],[[230085,526127],[-1851,-1]],[[228234,526126],[-88,1154],[-58,5310]],[[171468,527312],[-1044,34]],[[170424,527346],[-53,1]],[[170371,527347],[15,3855],[-349,1],[1,1630],[-349,-7],[35,5558]],[[170371,527347],[-2759,-17]],[[248571,532695],[0,-5698],[-321,-1]],[[248250,526996],[-719,-11]],[[247531,526985],[-3,3230],[-343,-15],[1,1609],[-352,7],[6,6374]],[[246840,538190],[370,-332]],[[304871,538016],[-24,-11134],[233,-2084],[-240,-2015],[-258,-234],[344,-2135],[-221,-1593],[445,-9902],[739,1165]],[[305889,510084],[248,-6544]],[[306137,503540],[-330,591],[-241,-1132]],[[305566,502999],[-450,139],[79,-2294],[-907,626]],[[304288,501470],[-183,1243],[-102,3478],[-276,-236],[62,1778],[-139,3374],[-376,-344],[-347,651],[-372,9721]],[[302555,521135],[466,1247],[-87,1101],[431,1781],[-152,2424],[219,2372],[-153,837],[286,2948],[372,1242],[93,2931]],[[307384,534699],[-16,-13241],[-374,-414],[-14,-2791],[297,275],[227,-5338],[-292,-285],[68,-1530],[-1391,-1291]],[[188025,524233],[-403,-667]],[[187622,523566],[-350,1101],[-489,-286],[-234,-1731]],[[186549,522650],[-588,1548],[-293,6521],[-197,-56]],[[185471,530663],[52,1620]],[[259893,531887],[-1,-5145]],[[259892,526742],[-133,-900],[-413,823],[-697,-828],[-157,-2486],[-258,-539]],[[258234,522812],[-83,2590],[0,4874],[-349,11]],[[257802,530287],[0,3250],[698,-25],[0,3238],[1393,-21]],[[198951,536301],[351,-3235],[408,-2428],[-126,-2500]],[[199584,528138],[-454,7],[0,-1079],[-345,0],[-232,-1614],[-462,6],[-62,-7075],[-689,-1094],[-914,67]],[[196426,517356],[-551,2735]],[[195875,520091],[-174,1330],[10,5160],[-63,3213]],[[201179,524914],[-661,1614],[-693,2],[0,1610],[-241,-2]],[[173379,527249],[-1569,44]],[[219085,526285],[-4142,17]],[[214943,526302],[0,2025]],[[253620,535144],[-3,-3220]],[[253617,531924],[2,-6051]],[[253619,525873],[-836,1000],[-325,853],[-417,-133]],[[252041,527593],[-695,1110]],[[251346,528703],[-162,441]],[[251183,535146],[869,8]],[[241984,535100],[-2,-4839]],[[241982,530261],[-158,-2624],[-996,-2261],[-371,-3070]],[[240457,522306],[-838,12]],[[239619,522318],[-4,4660],[246,5],[3,3293]],[[309532,520631],[304,-6937],[-325,-226]],[[309511,513468],[-690,-627],[93,-2259],[-353,-313],[61,-1593],[-355,-303],[157,-4051],[-1023,-1482]],[[307401,502840],[-7,-12]],[[307394,502828],[-61,340],[-964,-1079],[-232,1451]],[[160544,528153],[-247,-4],[10,-4864],[241,-1078]],[[160548,522207],[-795,-346],[-319,-1061]],[[159434,520800],[-910,-1887]],[[158524,518913],[9,9424]],[[158533,528337],[13,6170]],[[158533,528337],[-318,-1795],[-454,495],[-601,-1309],[-131,-1178]],[[157029,524550],[-330,4340],[-600,1895],[-259,-235]],[[155840,530550],[-2,54]],[[155838,530604],[-13,3898]],[[155838,530604],[-183,-462],[-495,2189],[-757,413]],[[235407,533824],[27,-10700]],[[235434,523124],[-1381,-10]],[[234053,523114],[-17,6206]],[[237756,530248],[0,-3231],[116,-9],[14,-2987]],[[237886,524021],[-1641,-2],[226,-871]],[[236471,523148],[-1037,-24]],[[251026,525384],[-2773,34]],[[248253,525418],[-3,1578]],[[251346,528703],[-2,-1704],[-318,2],[0,-1617]],[[155418,529962],[8,-6731]],[[155426,523231],[-1689,63]],[[153737,523294],[-68,3037],[184,1181],[-261,4092],[308,-881],[393,424],[493,-351],[259,901],[373,-1735]],[[214943,526302],[-5,-2]],[[214938,526300],[-2623,9]],[[212315,526309],[-150,2]],[[212165,526311],[1,6248]],[[228234,526126],[-2091,12]],[[226143,526138],[-82,1]],[[226061,526139],[4,6455]],[[223289,532599],[-7,-6388]],[[223282,526211],[-1985,21]],[[221297,526232],[-451,10]],[[226061,526139],[-1995,51]],[[224066,526190],[-784,21]],[[212165,526311],[-2924,3]],[[185471,530663],[-559,-802],[1,-1628],[-449,-1027],[40,-1092],[-450,-1375]],[[184054,524739],[-389,162],[-477,-1895],[-334,3184]],[[255011,527072],[0,-1623],[-222,0],[-1,-3274],[-416,-8]],[[254372,522167],[-588,1081]],[[253784,523248],[-213,795],[48,1830]],[[253617,531924],[1399,-8],[-5,-4844]],[[238811,530199],[-2,-3213],[-238,7],[12,-4605]],[[238583,522388],[8,-3269]],[[238591,519119],[-693,16]],[[237898,519135],[-12,4886]],[[194274,528161],[-17,-1569],[-232,-20],[-118,-1642],[-36,-4874],[-1029,-1611],[-3,-3240],[-365,3],[-1,-3288]],[[192473,511920],[-459,14],[21,11394],[-200,2],[30,7432]],[[190466,530915],[-30,-11210],[-346,-1209],[4,-3243],[-336,0],[-17,-6512]],[[189741,508741],[-31,-6238]],[[189710,502503],[18,-3578]],[[189728,498925],[-493,1904],[19,851],[-442,2414]],[[188812,504094],[13,11149],[64,-1],[-3,5424],[-517,4],[-342,1882],[-405,1014]],[[192473,511920],[740,-88]],[[193213,511832],[-2,-3076]],[[193211,508756],[-2525,-183],[-945,168]],[[186549,522650],[-756,-105],[-628,-2189]],[[185165,520356],[-202,2287],[-909,2096]],[[157029,524550],[64,-2277]],[[157093,522273],[-464,-110]],[[156629,522163],[-284,1059],[-919,9]],[[155418,529962],[422,588]],[[239619,522318],[-1036,70]],[[242662,530269],[51,-9640]],[[242713,520629],[-344,-3]],[[242369,520626],[1,1598],[-1042,58],[-2,-1612],[-997,38]],[[240329,520708],[128,1598]],[[241982,530261],[680,8]],[[245796,530213],[-1,-3233],[691,9]],[[246486,526989],[-5,-6391]],[[246481,520598],[-2400,-12]],[[244081,520586],[-31,9670]],[[244050,530256],[1746,-43]],[[244081,520586],[-1368,43]],[[242662,530269],[1388,-13]],[[209244,525134],[12,-12455]],[[209256,512679],[-50,-4012]],[[209206,508667],[-2732,55]],[[206474,508722],[1,6548],[142,-1],[14,8098]],[[195875,520091],[-795,-463],[-177,-2269],[-459,3],[-573,-1889],[-130,-1894],[-228,1],[-2,-1751],[-298,3]],[[232297,529334],[32,-6470]],[[232329,522864],[-1381,-3]],[[230948,522861],[-32,4873]],[[234053,523114],[0,-270]],[[234053,522844],[-1724,20]],[[252041,527593],[20,-5420],[699,-8]],[[252760,522165],[-8,-6431]],[[252752,515734],[-696,32]],[[252056,515766],[-691,-1],[8,1610],[-344,-7]],[[251029,517368],[-3,8016]],[[158524,518913],[-1068,1088],[-329,768],[-34,1504]],[[165157,524279],[-366,-437]],[[164791,523842],[-599,-1643],[-746,-545],[-477,787]],[[162969,522441],[-731,-1785]],[[162238,520656],[-782,-457],[-46,928],[-635,569]],[[160775,521696],[-227,511]],[[203016,512065],[45,-3465]],[[203061,508600],[-4592,140]],[[198469,508740],[-941,-34]],[[197528,508706],[338,4067],[-1592,0],[48,4005],[104,578]],[[230948,522861],[3,-3246]],[[230951,519615],[-1623,13]],[[229328,519628],[-7,1157],[513,1813],[251,3529]],[[253784,523248],[-5,-1257],[-1019,174]],[[170424,527346],[13,-2609]],[[170437,524737],[-401,-3204],[0,-4053],[-226,-812],[-642,33],[1,-1373],[-751,-187],[117,-2760],[304,1],[77,-3742]],[[168916,508640],[-1797,-1]],[[167119,508639],[49,1621],[3,8063],[-287,1],[0,1597],[-519,16],[8,5874]],[[174020,513700],[-270,-3513]],[[173750,510187],[-1345,33]],[[172405,510220],[-1,1583],[-585,-10],[-295,3221],[-170,-21],[-112,3313],[-288,3247],[112,3192],[-629,-8]],[[255706,527059],[117,-1614],[-5,-6481],[175,-7]],[[255993,518957],[-480,-4770],[-502,-3587]],[[255011,510600],[-348,1798],[263,2652],[-666,243],[263,2751],[-117,1109],[148,2102],[-182,912]],[[255011,527072],[695,-13]],[[248253,525418],[-2,-6368]],[[248251,519050],[4,-3225]],[[248255,515825],[-1774,-76]],[[246481,515749],[0,4849]],[[246486,526989],[1045,-4]],[[214938,526300],[2,-8789]],[[214940,517511],[-1,-8089]],[[214939,509422],[-2667,29]],[[212272,509451],[0,3227]],[[212272,512678],[43,13631]],[[219085,526285],[420,-1613],[146,-2779],[-338,-2104]],[[219313,519789],[-136,-1298],[382,-971]],[[219559,517520],[-3144,-9]],[[216415,517511],[-1475,0]],[[212272,512678],[-3016,1]],[[221297,526232],[2,-6469]],[[221299,519763],[-1986,26]],[[185165,520356],[-3,-2744],[506,-651],[135,-1730],[3,-4866],[343,-1],[-2,-1637],[399,-13],[67,-3224],[282,-800],[791,-49],[1,-1346],[860,8]],[[188547,503303],[-98,-3225],[-306,273]],[[188143,500351],[-567,-771],[-129,1023],[-637,-764],[-533,835],[-280,-2222],[-237,583],[-858,91],[-96,-2022]],[[184806,497104],[-526,1386],[-10,1397],[-347,4611],[-317,914],[-262,-705],[-322,1502],[12,3599],[-287,1010],[-383,2793],[-233,2701],[-86,3614],[-272,360],[-94,1382]],[[224066,526190],[-2,-6467]],[[224064,519723],[-2738,40]],[[221326,519763],[-27,0]],[[226143,526138],[-2,-6467]],[[226141,519671],[-6,-6480]],[[226135,513191],[-2051,62]],[[224084,513253],[-13,1]],[[224071,513254],[-7,6469]],[[229328,519628],[389,-3087],[628,-1746]],[[230345,514795],[-1456,6],[-40,-559],[-610,15]],[[228239,514257],[-2,4850]],[[228237,519107],[-3,7019]],[[228237,519107],[-408,549],[-1688,15]],[[167119,508639],[-1415,-27]],[[165704,508612],[-332,4],[2,1361]],[[165374,509977],[84,1859],[-342,38],[2,1607],[-347,28],[20,10333]],[[251029,517368],[-1054,47]],[[249975,517415],[-10,1640],[-1714,-5]],[[172405,510220],[-826,-23],[-2,-1616],[-596,-11],[-301,1240],[-304,-1199],[-378,943],[-318,-1615]],[[169680,507939],[-764,701]],[[188812,504094],[-265,-791]],[[237898,519135],[-1086,-11]],[[236812,519124],[-341,4024]],[[165374,509977],[-1964,15]],[[163410,509992],[-23,268]],[[163387,510260],[-111,2406],[144,4765],[366,767],[-140,1600],[-677,2643]],[[206474,508722],[-142,2]],[[206332,508724],[-2606,-128]],[[203726,508596],[-665,4]],[[264518,520374],[-131,-4],[15,-7955]],[[264402,512415],[-335,1]],[[264067,512416],[-1024,59]],[[263043,512475],[5,1628]],[[263048,514103],[0,9278]],[[263048,523381],[752,-2509],[718,-498]],[[155426,523231],[0,-1322],[-345,8],[171,-1358],[345,-537],[-450,-2154],[-11,-1076]],[[155136,516792],[5,-4050],[-895,-4],[-1,-2602],[169,-4]],[[154414,510132],[-4,-597]],[[154410,509535],[-766,17]],[[153644,509552],[191,6726],[-98,7016]],[[156629,522163],[0,-1647],[515,-2132],[2,-1597]],[[157146,516787],[-2,-1893],[-345,-270]],[[156799,514624],[-745,2158],[-918,10]],[[236812,519124],[284,-2536]],[[237096,516588],[-222,-1934],[-373,-651]],[[236501,514003],[-342,795],[-1058,-11]],[[235101,514787],[1,1614],[-1027,-8]],[[234075,516393],[-22,6451]],[[232329,522864],[30,-6471]],[[232359,516393],[-1029,-8]],[[231330,516385],[-347,13],[-32,3217]],[[234075,516393],[-344,3]],[[233731,516396],[-1372,-3]],[[163387,510260],[-630,17],[17,875],[-376,1202],[-462,444],[26,1607],[414,1539],[112,2268],[-250,2444]],[[239619,522318],[0,-3212],[334,-17],[7,-2705]],[[239960,516384],[-1367,54]],[[238593,516438],[-2,2681]],[[240329,520708],[8,-1269],[308,-145],[354,-2359],[-276,-2708]],[[240723,514227],[-762,15]],[[239961,514242],[-1,2142]],[[242369,520626],[-5,-8010]],[[242364,512616],[-1676,1]],[[240688,512617],[35,1610]],[[159434,520800],[0,-1906],[284,-1586]],[[159718,517308],[-2287,-7],[-285,-514]],[[160775,521696],[1,-3313],[-117,6],[3,-4865],[-600,-5]],[[160062,513519],[3,2150],[-347,1639]],[[163410,509992],[120,-3800],[224,-797]],[[163754,505395],[-3866,75]],[[159888,505470],[69,1165]],[[159957,506635],[-195,2311],[405,1008],[-240,2616],[135,949]],[[184806,497104],[3,-2717],[-506,66]],[[184303,494453],[-906,-18]],[[183397,494435],[-56,1597],[-348,2544],[-106,-613],[-845,1224],[-633,3399],[-141,1577],[-365,-188],[52,2182],[-181,-234],[-402,-2430],[55,-904],[-491,-1772],[-716,3193],[20,1138]],[[179240,505148],[217,1309],[9,5102],[104,825]],[[309697,499440],[-326,8144],[343,308],[-203,5576]],[[310206,521389],[551,-1389],[510,-516],[-213,-1646],[200,-1811],[-163,-2048],[408,-2916],[145,1141],[349,-534],[352,-3817],[161,-2744],[-592,-2997],[-880,-140],[-164,-1985],[-252,636],[-149,-1354],[-202,2089],[-181,-786],[-141,-3116],[-248,1984]],[[304288,501470],[-305,-405],[-9,-1933],[-241,39]],[[303733,499171],[-304,-528]],[[303429,498643],[-117,2061],[-640,1070],[-291,3136],[-430,-1180],[-152,5250],[122,81],[-151,4819]],[[301770,513880],[26,2282],[518,-340],[-235,2392],[476,2921]],[[266792,512571],[-1372,-94]],[[265420,512477],[-1018,-62]],[[264518,520374],[261,-2226],[563,-388],[377,-1459],[555,-1119],[218,171],[319,-1624],[-19,-1158]],[[244081,520586],[-3,-6434]],[[244078,514152],[-2,-1591],[-344,26]],[[243732,512587],[-1368,29]],[[246481,515749],[-686,31],[0,-1629]],[[245795,514151],[-1717,1]],[[197528,508706],[-1036,15]],[[196492,508721],[-3281,35]],[[221326,519763],[-4,-6470]],[[221322,513293],[-1536,18]],[[219786,513311],[-157,1348],[119,1153],[-189,1708]],[[224071,513254],[-2371,30]],[[221700,513284],[-378,9]],[[228239,514257],[0,-2714]],[[228239,511543],[-746,-4]],[[227493,511539],[-1359,31]],[[226134,511570],[1,1621]],[[231330,516385],[37,-4380]],[[231367,512005],[-502,1311],[-471,406]],[[230394,513722],[-49,1073]],[[238593,516438],[-6,-3148]],[[238587,513290],[-26,17]],[[238561,513307],[-163,844],[-522,100],[-780,2337]],[[249975,517415],[-3,-6481]],[[249972,510934],[-1721,19]],[[248251,510953],[4,4872]],[[219786,513311],[-178,-2703],[123,-1549],[-311,141],[-36,-2389]],[[219384,506811],[-387,-2543],[-370,1156],[-115,-973]],[[218512,504451],[-583,56],[-208,-833],[-377,334]],[[217344,504008],[2,4597],[-1015,-5],[84,8911]],[[217344,504008],[-269,-1031],[-620,-1015],[-211,-1237],[-503,175],[-264,-1034],[-539,-243]],[[214938,499623],[1,9799]],[[252056,515766],[-6,-3234],[108,-1632]],[[252158,510900],[-950,13],[2,-1662]],[[251210,509251],[-675,9]],[[250535,509260],[-1,1663],[-562,11]],[[159957,506635],[-1845,-55],[-388,968],[-168,1539],[-534,2059],[129,2389],[-301,15]],[[156850,513550],[-51,1074]],[[156850,513550],[-529,-701],[118,-1993],[-202,-742]],[[156237,510114],[-1823,18]],[[238561,513307],[-382,-977],[-277,-2080],[-23,-1945]],[[237879,508305],[-685,14]],[[237194,508319],[-679,14]],[[236515,508333],[-14,5670]],[[239961,514242],[-4,-3220]],[[239957,511022],[-577,12],[2,-1654]],[[239382,509380],[-216,1966],[-579,1944]],[[235101,514787],[15,-8081]],[[235116,506706],[-1366,-14]],[[233750,506692],[5,4861]],[[233755,511553],[-24,4843]],[[233755,511553],[-2201,-4]],[[231554,511549],[-187,456]],[[248251,510953],[-430,7],[1,-1618],[-327,3]],[[247495,509345],[-1695,-50]],[[245800,509295],[-5,4856]],[[252752,515734],[340,-45],[-9,-3220],[342,-69],[182,-3245],[999,-1069]],[[254606,508086],[-385,-2583],[-242,-2789]],[[253979,502714],[-8,-1]],[[253971,502713],[-10,-1]],[[253961,502712],[-693,39]],[[253268,502751],[-16,3220],[-670,52]],[[252582,506023],[15,4858],[-439,19]],[[303429,498643],[-266,-4622],[-406,-3326]],[[302757,490695],[-370,576],[-32,2012],[-647,-2107],[393,-1789],[-189,-2754]],[[301912,486633],[-573,-442]],[[301339,486191],[-59,9209]],[[301280,495400],[-86,9641],[-121,9365]],[[301073,514406],[217,752],[480,-1278]],[[230394,513722],[3,-5426]],[[230397,508296],[-1199,-11]],[[229198,508285],[-5,3227],[-954,31]],[[236515,508333],[-686,5],[-1,-1627]],[[235828,506711],[-712,-5]],[[301280,495400],[-90,-874],[-585,120],[-254,-2830],[-201,2231]],[[300150,494047],[-446,794],[-524,2812]],[[299180,497653],[520,1849],[112,1481],[-264,3053],[383,3039],[-19,1891]],[[299912,508966],[388,4731],[214,622],[386,-1122],[173,1209]],[[240688,512617],[-96,-2433],[64,-4037]],[[240656,506147],[-95,-2136]],[[240561,504011],[-562,444],[-37,2206]],[[239962,506661],[96,22],[-1,4337],[-100,2]],[[245800,509295],[3,-3236]],[[245803,506059],[-2029,-25]],[[243774,506034],[-42,6553]],[[159888,505470],[-166,-669],[69,-1969]],[[159791,502832],[-1153,206],[-233,1075],[-632,10],[-781,720],[-578,-1960],[-382,1172]],[[156032,504055],[-98,1558],[388,2207],[-85,2294]],[[175529,510717],[154,-826],[-339,-5246],[150,-1455],[0,-3804]],[[175494,499386],[-398,-1021]],[[175096,498365],[-633,867],[-4,2312],[-267,893],[-1,3275],[-764,34]],[[173427,505746],[188,1739],[-44,1635],[179,1067]],[[231554,511549],[662,-3749],[173,-272]],[[232389,507528],[-309,-828],[-3,-1608],[-1679,19]],[[230398,505111],[-1,3185]],[[307819,495119],[63,-2040],[-255,1149],[192,891]],[[308823,498240],[322,-1211],[-422,-2791],[-256,1683],[356,2319]],[[309697,499440],[-194,-3153],[-121,2655],[-613,1159],[154,-1191],[-465,-1334],[31,1761],[-402,-1706],[118,-3275],[-828,3345],[180,1912],[-237,2131],[81,1096]],[[221700,513284],[1,-6478]],[[221701,506806],[-279,1]],[[221422,506807],[-2038,4]],[[224084,513253],[3,-6454]],[[224087,506799],[-1658,3]],[[222429,506802],[-728,4]],[[239382,509380],[135,-2743]],[[239517,506637],[-427,-1841]],[[239090,504796],[-535,227]],[[238555,505023],[9,1658],[-687,3],[2,1621]],[[226134,511570],[12,-9713]],[[226146,501857],[-2029,50]],[[224117,501907],[-30,4892]],[[179240,505148],[-395,-1629],[-367,938],[-230,-2310],[-308,-656],[142,-3508],[-185,-1567]],[[177897,496416],[-297,-1464],[-332,-476],[-1622,26],[-30,-1654],[-276,67]],[[175340,492915],[1,3219],[164,2],[-11,3250]],[[212272,509451],[-19,-8102],[-1681,-4]],[[210572,501345],[-701,13],[-660,-630]],[[209211,500728],[-5,7939]],[[242364,512616],[56,-6547]],[[242420,506069],[-1764,78]],[[243774,506034],[0,-3209]],[[243774,502825],[-1350,15]],[[242424,502840],[-4,3229]],[[262700,510888],[28,-4815]],[[262728,506073],[-1239,26],[-114,-876]],[[261375,505223],[-304,883]],[[261071,506106],[219,4694],[-69,1784]],[[261221,512584],[458,-41],[1,-1633],[1020,-22]],[[264067,512416],[-14,-6399]],[[264053,506017],[-1325,56]],[[262700,510888],[342,-33],[1,1620]],[[265420,512477],[-20,-6430]],[[265400,506047],[-1347,-30]],[[227493,511539],[8,-6473]],[[227501,505066],[-3,-4842]],[[227498,500224],[-1005,10]],[[226493,500234],[-9,1613],[-338,10]],[[229198,508285],[-7,-3210]],[[229191,505075],[-1690,-9]],[[233750,506692],[-653,-11],[0,-2565]],[[233097,504116],[-708,3412]],[[239962,506661],[-445,-24]],[[250535,509260],[0,-6476]],[[250535,502784],[-1731,66]],[[248804,502850],[-1313,5]],[[247491,502855],[4,6490]],[[252582,506023],[-689,19],[2,1616],[-685,-6],[0,1599]],[[173427,505746],[-386,-1718],[-295,-3771],[-220,-1145],[9,-3402]],[[172535,495710],[-741,0],[0,1607],[-293,1056],[-1060,-21],[-726,-3486]],[[169715,494866],[-738,-18],[245,2193],[-29,1556],[315,2472],[-553,1434],[612,1573],[-28,2092],[141,1771]],[[156032,504055],[-16,-547]],[[156016,503508],[-1263,17]],[[154753,503525],[-341,333],[-2,5677]],[[165704,508612],[55,-3188],[-10,-9610]],[[165749,495814],[-676,-6],[-2,1543],[-342,912],[-1014,-18],[1,2353]],[[163716,500598],[38,4797]],[[154753,503525],[15,-5367],[-344,3],[15,-1349],[-284,-294],[116,-1140]],[[154271,495378],[-947,-136]],[[153324,495242],[89,2630],[44,7616],[170,1569],[17,2495]],[[214938,499623],[-2,-12]],[[214936,499611],[-312,-1407],[-473,240],[-223,-2776],[-71,-2959],[-2964,11]],[[210893,492720],[-2,2156],[-338,-10],[19,6479]],[[247491,502855],[1,-4850]],[[247492,498005],[-1354,-31],[0,1610],[-337,6],[2,1612]],[[245803,501202],[0,4857]],[[253268,502751],[-7,-1765]],[[253261,500986],[-1005,106]],[[252256,501092],[3,1635],[-1724,57]],[[296979,508865],[60,-3256],[-127,-959]],[[296912,504650],[-471,86],[-134,-1750],[-359,-1101]],[[295948,501885],[-849,1672]],[[295099,503557],[103,5409]],[[295202,508966],[1777,-101]],[[299180,497653],[-205,-1076]],[[298975,496577],[-266,1736],[213,1023],[-144,949],[183,1193],[-188,668],[204,1295],[-286,976]],[[298691,504417],[181,2000],[-64,2447]],[[298808,508864],[1104,102]],[[295099,503557],[-145,-2596],[-226,-367]],[[294728,500594],[-75,974],[149,3512],[-119,604],[97,3231]],[[294780,508915],[422,51]],[[294728,500594],[65,-314]],[[294793,500280],[-930,-2004],[-662,-178]],[[293201,498098],[-213,5177],[-115,5361]],[[292873,508636],[1907,279]],[[298691,504417],[-203,-1307],[-284,945],[-413,-3859],[-312,778]],[[297479,500974],[-299,925],[174,1659],[-442,1092]],[[296979,508865],[1829,-1]],[[196492,508721],[81,-2399],[-1,-6525],[53,-2],[-1,-6560],[65,0]],[[196689,493235],[-1,-1658]],[[196688,491577],[-673,4],[0,-1649],[-344,-3],[9,-1603],[-502,-5],[2,-1644],[-615,-56]],[[194565,486621],[-361,2183],[-278,575],[-277,-718],[-66,-1424],[-340,-839],[-198,2909],[-377,-147],[-166,1088]],[[192502,490248],[0,2320],[-270,2958],[-406,2562],[50,1662],[-272,1203],[-814,-4],[0,1554],[-1080,0]],[[290927,508616],[234,-782],[324,-14558],[-26,-1329]],[[291459,491947],[-889,-543]],[[290570,491404],[-581,-367],[-299,867]],[[289690,491904],[-769,2247]],[[288921,494151],[-1154,3457]],[[287767,497608],[260,2084],[1343,6200],[870,2516],[687,208]],[[198469,508740],[221,-3931],[453,-2059],[152,401],[684,-2630]],[[199979,500521],[185,-1796],[287,-397],[154,-2197],[-5,-2948]],[[200600,493183],[-3911,52]],[[206332,508724],[28,-15345]],[[206360,493379],[-1,-12617]],[[206359,480762],[-2612,-65]],[[203747,480697],[21,19901]],[[203768,500598],[-42,7998]],[[203768,500598],[-1168,-134],[-2621,57]],[[293201,498098],[-645,-417],[133,-5013],[-525,-325]],[[292164,492343],[-705,-396]],[[290927,508616],[1946,20]],[[209211,500728],[4,-7271]],[[209215,493457],[-2855,-78]],[[169715,494866],[13,-4023]],[[169728,490843],[-1637,144],[-4,-1633],[-2343,-17]],[[165744,489337],[5,6477]],[[237194,508319],[5,-4865]],[[237199,503454],[-679,9],[-2,-1632],[-677,-5],[-1,1626]],[[235840,503452],[-12,3259]],[[238555,505023],[-264,-1739],[-417,-1265]],[[237874,502019],[-336,1431],[-339,4]],[[230398,505111],[0,-3258]],[[230398,501853],[-1,-1635]],[[230397,500218],[-1208,4]],[[229189,500222],[2,4853]],[[233097,504116],[341,-1014]],[[233438,503102],[0,-2921],[-654,12]],[[232784,500193],[-25,1633],[-1362,10]],[[231397,501836],[-999,17]],[[240561,504011],[200,-613]],[[240761,503398],[-169,-3191],[-689,-567],[1,-756]],[[239904,498884],[-675,2],[1,1340]],[[239230,500226],[-140,4570]],[[221422,506807],[-9,-6504]],[[221413,500303],[-2368,-13]],[[219045,500290],[-317,676],[77,2216],[-293,1269]],[[222429,506802],[32,-13076]],[[222461,493726],[-769,-45]],[[221692,493681],[-243,467]],[[221449,494148],[-36,6155]],[[224117,501907],[15,-8146]],[[224132,493761],[-628,-3]],[[223504,493758],[-1043,-32]],[[235840,503452],[-367,-8],[16,-4852]],[[235489,498592],[-437,8]],[[235052,498600],[-236,772]],[[234816,499372],[-1378,3730]],[[183397,494435],[-268,4],[1,-3240],[-116,1],[10,-3445],[227,-983],[-559,-2336],[-480,-1253],[-145,-1113]],[[182067,482070],[-654,3911],[-113,-749],[-563,1718],[-9,880],[-657,321],[-39,-921],[-426,1522],[-370,1],[1,1213],[-439,-1021]],[[178798,488945],[-55,216]],[[178743,489161],[-155,1983],[62,1848],[-398,879],[-33,1744],[-322,801]],[[242424,502840],[-1,-2696],[-504,27]],[[241919,500171],[-648,507],[-510,2720]],[[266980,506081],[138,-2704],[-131,-3751]],[[266987,499626],[-1582,-52]],[[265405,499574],[-5,6473]],[[265400,506047],[1580,34]],[[262728,506073],[-10,-6460]],[[262718,499613],[-1346,23]],[[261372,499636],[3,5587]],[[264053,506017],[3,-6475]],[[264056,499542],[-1338,71]],[[245803,501202],[-678,11]],[[245125,501213],[-1013,-15]],[[244112,501198],[-337,9]],[[243775,501207],[-1,1618]],[[265405,499574],[-1349,-32]],[[175096,498365],[-132,-2276],[-32,-3180],[-260,7]],[[174672,492916],[-1240,21]],[[173432,492937],[-217,1683],[-680,1090]],[[163716,500598],[-1231,-21],[0,-1605],[-450,-3],[1,-1609],[-331,10]],[[161705,497370],[-2049,35]],[[159656,497405],[135,5427]],[[239230,500226],[-677,-7]],[[238553,500219],[-1077,-8]],[[237476,500211],[398,1808]],[[229189,500222],[-676,-12]],[[228513,500210],[-1015,14]],[[297479,500974],[-166,-1452]],[[297313,499522],[-157,-1497],[-296,998],[-160,-1509],[-420,995]],[[296280,498509],[-67,1872],[-265,1504]],[[159656,497405],[121,-2500]],[[159777,494905],[-1469,-90],[-166,-673],[-532,204],[-411,1118],[-498,-542],[-6,-1095],[-722,-4],[-54,1557]],[[155919,495380],[-124,1127],[44,2998],[-133,924],[521,1787],[-211,1292]],[[219045,500290],[-133,-1712],[523,-288],[58,-1572],[781,-877],[538,-1239],[-128,-869]],[[220684,493733],[-1196,-11],[0,-483]],[[219488,493239],[-1893,-6]],[[217595,493233],[-334,-5],[34,9715],[49,1065]],[[260032,504518],[-8,-4869]],[[260024,499649],[-1160,99]],[[258864,499748],[-13,3454],[458,1388]],[[259309,504590],[723,-72]],[[298975,496577],[-544,-513],[-20,-3063]],[[298411,493001],[-914,898]],[[297497,493899],[402,4107],[-586,1516]],[[307394,502828],[-140,-1574],[180,-625],[-64,-1886],[-523,-588],[177,-1427],[-225,-1985]],[[306799,494743],[-257,114],[-412,2029],[-390,-679]],[[305740,496207],[-272,275]],[[305468,496482],[309,2126],[8,3412],[-219,979]],[[189728,498925],[5,-9134]],[[189733,489791],[-389,-951],[-593,-175]],[[188751,488665],[-448,-740],[-1162,821]],[[187141,488746],[-1,810],[-499,8],[1,1607]],[[186642,491171],[339,-6],[1,1607],[490,821],[16,2405],[169,1558],[484,18],[2,2777]],[[217595,493233],[-48,-3229]],[[217547,490004],[-2628,-7]],[[214919,489997],[17,9614]],[[296280,498509],[-410,-5407]],[[295870,493102],[-68,2573],[-938,-658]],[[294864,495017],[48,3057],[-119,2206]],[[155919,495380],[-1648,-2]],[[305468,496482],[-133,-1504],[-266,328],[-18,-2929],[-277,308]],[[304774,492685],[-7,9]],[[304767,492694],[-269,530],[-119,-1120],[-300,314]],[[304079,492418],[-196,1521],[-150,5232]],[[237476,500211],[-51,-1567]],[[237425,498644],[-1936,-52]],[[241919,500171],[207,-1615]],[[242126,498556],[-525,16],[0,-1617],[-335,5],[-1,-3232]],[[241265,493728],[-356,11]],[[240909,493739],[-1010,22]],[[239899,493761],[5,5123]],[[234816,499372],[-1,-4019],[-672,-9],[-4,-1614]],[[234139,493730],[-985,19]],[[233154,493749],[-366,-7]],[[232788,493742],[-4,6451]],[[250535,502784],[-3,-8151]],[[250532,494633],[-1040,40]],[[249492,494673],[-353,36]],[[249139,494709],[-5,4907],[-328,5],[-2,3229]],[[249139,494709],[-495,34]],[[248644,494743],[-1141,-13]],[[247503,494730],[-11,3275]],[[253979,502714],[-8,-1]],[[253961,502712],[-152,-2104],[333,-531],[464,2017]],[[254606,502094],[-10,-5904]],[[254596,496190],[-339,8],[-1,-1624],[-432,11]],[[253824,494585],[-416,19]],[[253408,494604],[6,6419],[-153,-37]],[[243775,501207],[-1056,-193],[-152,-3332]],[[242567,497682],[-441,874]],[[252256,501092],[-364,1],[-9,-6465]],[[251883,494628],[-409,-12]],[[251474,494616],[-942,17]],[[255685,502676],[-302,-3068],[-168,-3412]],[[255215,496196],[-619,-6]],[[254606,502094],[73,609]],[[254679,502703],[1006,-27]],[[192502,490248],[5,-10113]],[[192507,480135],[-16,-1620],[-799,3],[0,-1615],[-653,8],[-1,-1050]],[[191038,475861],[-655,-1],[0,1503],[-643,-3]],[[189740,477360],[-2,3452]],[[189738,480812],[-5,8979]],[[226493,500234],[-2,-6499]],[[226491,493735],[-1332,24]],[[225159,493759],[-1027,2]],[[231397,501836],[40,-8076]],[[231437,493760],[-1042,2]],[[230395,493762],[2,6456]],[[232788,493742],[-1310,16]],[[231478,493758],[-41,2]],[[210893,492720],[-1678,5]],[[209215,492725],[0,732]],[[244112,501198],[-2,-6505],[-219,-856],[207,-1949],[-69,-1318]],[[244029,490570],[-834,3122]],[[243195,493692],[-279,3080],[-349,910]],[[245125,501213],[38,-9631]],[[245163,491582],[-433,-275],[-41,-1497],[-287,-3]],[[244402,489807],[-373,763]],[[247503,494730],[-1,-1740]],[[247502,492990],[-1654,56],[-187,-1630]],[[245661,491416],[-498,166]],[[253408,494604],[-589,39]],[[252819,494643],[-936,-15]],[[186642,491171],[-1501,14],[-1,-1610]],[[185140,489575],[-834,8],[-3,4870]],[[203747,480697],[-170,-9]],[[203577,480688],[-2877,-40],[0,148]],[[200700,480796],[-49,12388],[-51,-1]],[[165744,489337],[-329,0],[-5,-4859],[-337,5]],[[165073,484483],[-1002,8],[0,1610],[-336,-4],[-1,1618],[-1028,-13],[-1,1606],[-664,64],[-2,3219],[-321,78],[-13,4701]],[[221449,494148],[180,-1780],[-748,46],[-197,1319]],[[294864,495017],[-214,-1345],[-132,-2763],[162,-4374]],[[294680,486535],[-165,-91]],[[294515,486444],[-1724,-1102]],[[292791,485342],[28,960],[-465,275],[-343,2130],[225,833],[-72,2803]],[[238553,500219],[-2,-6472]],[[238551,493747],[-677,-2]],[[237874,493745],[1,808],[-680,-7]],[[237195,494546],[220,1969],[10,2129]],[[239899,493761],[-13,0]],[[239886,493761],[-1005,-6]],[[238881,493755],[-330,-8]],[[228513,500210],[-4,-6463]],[[228509,493747],[-670,-20]],[[227839,493727],[-1336,7]],[[226503,493734],[-12,1]],[[230395,493762],[0,-2]],[[230395,493760],[-1217,-20]],[[229178,493740],[-669,7]],[[260024,499649],[-9,-6493]],[[260015,493156],[-615,54]],[[259400,493210],[-964,215]],[[258436,493425],[364,3555],[64,2768]],[[261372,499636],[-2,-6463]],[[261370,493173],[-640,-4]],[[260730,493169],[-715,-13]],[[260024,499649],[1348,-13]],[[264056,499542],[8,-6454]],[[264064,493088],[-669,-1]],[[263395,493087],[-679,16]],[[262716,493103],[2,6510]],[[262716,493103],[-656,53]],[[262060,493156],[-690,17]],[[266987,499626],[-62,-3377],[-470,-1067],[-157,-2039]],[[266298,493143],[-886,-32]],[[265412,493111],[-7,6463]],[[265412,493111],[-786,0]],[[264626,493111],[-562,-23]],[[175340,492915],[-169,-3],[-24,-6409]],[[175147,486503],[-644,5]],[[174503,486508],[-557,-1]],[[173946,486507],[0,3241],[391,-17],[114,1595],[220,-13],[1,1603]],[[214919,489997],[-32,-5323],[-335,-145]],[[214552,484529],[-104,-245],[-1766,9]],[[212682,484293],[343,3116],[-3812,-38]],[[209213,487371],[2,5354]],[[297497,493899],[-208,-1404],[-408,589],[-262,-2738],[-163,304]],[[296456,490650],[-487,788],[-99,1664]],[[235052,498600],[862,-2186],[274,-1379]],[[236188,495035],[12,-2914]],[[236200,492121],[-1368,-13]],[[234832,492108],[-669,3],[-24,1619]],[[304079,492418],[-79,-2770]],[[304000,489648],[-229,-1286],[-556,2438],[-134,-953],[-324,848]],[[237195,494546],[-163,-1485],[-844,1974]],[[243195,493692],[-616,1],[0,-1602]],[[242579,492091],[-668,7],[-1,1620],[-645,10]],[[173432,492937],[-215,-1207],[111,-1864],[-135,-2003]],[[173193,487863],[-118,-728],[-1,-2989]],[[173074,484146],[-2,-31285]],[[173072,452861],[-3259,-52]],[[169813,452809],[-49,5195],[-6,11887],[-34,1],[4,20951]],[[300150,494047],[150,-5520],[-565,-418],[90,-2385]],[[299825,485724],[28,-1263],[-360,-305],[-213,-2183]],[[299280,481973],[-251,-348],[-88,1240],[-239,-1545]],[[298702,481320],[-1098,1335]],[[297604,482655],[73,1782],[273,1403]],[[297950,485840],[461,7161]],[[165073,484483],[-1,-1675]],[[165072,482808],[-3996,131]],[[161076,482939],[-1866,-3]],[[159210,482936],[77,4514],[296,1024],[283,3754],[-89,2677]],[[286590,490299],[-326,1891],[242,1614],[1261,3804]],[[288921,494151],[-278,-2135],[171,-536],[-163,-1981],[-600,-1657],[-229,97],[184,-3632]],[[288006,484307],[-698,337],[-439,-516]],[[286869,484128],[-30,11]],[[286839,484139],[-17,6]],[[286822,484145],[-93,2653],[-183,296],[473,1068],[-221,1527],[192,1727],[-400,-1117]],[[306799,494743],[-208,-3179],[83,-579],[-394,-2171],[-422,631],[40,936]],[[305898,490381],[198,677],[-157,2939],[-190,25],[-9,2185]],[[178743,489161],[-409,649],[-97,1866],[-374,-2892],[-523,-708],[-420,-3555],[-517,-1774],[-404,-258]],[[175999,482489],[-852,4014]],[[305898,490381],[-88,1150],[-333,-4457],[-153,1112],[-294,-802],[27,3033],[-191,-1421]],[[304866,488996],[63,1228],[-293,335]],[[304636,490559],[138,2126]],[[255215,496196],[9,-3137],[-283,-948],[-251,-4019]],[[254690,488092],[-862,-9]],[[253828,488083],[-4,6502]],[[296456,490650],[-138,-1260]],[[296318,489390],[-526,-1476],[60,-1043]],[[295852,486871],[-725,197],[35,-1310],[-435,-258]],[[294727,485500],[-47,1035]],[[159210,482936],[-357,-1082],[-3,-2172]],[[158850,479682],[-1696,-62],[-3,2000],[-1023,-131],[-80,4508],[-585,9],[-506,918],[-251,1688],[-580,464],[-273,-1479],[-649,-39]],[[153204,487558],[120,7684]],[[301339,486191],[74,-4637]],[[301413,481554],[-561,-31]],[[300852,481523],[-271,609],[-756,3592]],[[237874,493745],[1,-6477]],[[237875,487268],[-1335,-3]],[[236540,487265],[-340,-1]],[[236200,487264],[0,4857]],[[248644,494743],[4,-1204],[-356,-1774],[167,-1778],[17,-2211],[271,-1702],[222,-2658]],[[248969,483416],[-1467,-1]],[[247502,483415],[1,1682]],[[247503,485097],[-1,7893]],[[249492,494673],[0,-4905]],[[249492,489768],[-4,-6323]],[[249488,483445],[-519,-29]],[[251474,494616],[2,-4829]],[[251476,489787],[-786,-8]],[[250690,489779],[-1198,-11]],[[252819,494643],[-1,-5695]],[[252818,488948],[3,-842],[-1344,42]],[[251477,488148],[-1,1639]],[[253828,488083],[-336,-5]],[[253492,488078],[2,861],[-676,9]],[[185140,489575],[-7,-6496]],[[185133,483079],[-5,-1541],[-325,-81],[-2,-1617],[-333,6],[-31,-3058],[-167,-6]],[[184270,476782],[-988,-2],[0,1537],[-762,6],[71,2286],[-253,1758],[-271,-297]],[[297950,485840],[-1609,2938],[-23,612]],[[289857,482936],[-1180,-3639],[-620,942]],[[288057,480239],[-51,4068]],[[289690,491904],[167,-8968]],[[222306,488875],[139,-1400],[-276,-1472],[-156,-2285],[239,-7],[215,-2925]],[[222467,480786],[-656,1]],[[221811,480787],[-251,2],[-1,4521],[-205,287],[-400,-1289],[-686,-69],[-402,533]],[[219866,484772],[-299,60]],[[219567,484832],[-76,2418],[-3,5989]],[[221692,493681],[38,-1692],[582,-1978],[-6,-1136]],[[231478,493758],[-2,-6467]],[[231476,487291],[-1083,9]],[[230393,487300],[2,6460]],[[233154,493749],[0,-6482]],[[233154,487267],[-1644,21]],[[231510,487288],[-34,3]],[[225159,493759],[1,-4821]],[[225160,488938],[-1327,-45]],[[223833,488893],[-332,-2]],[[223501,488891],[3,4867]],[[239886,493761],[1,-6484]],[[239887,487277],[-11,1]],[[239876,487278],[-995,-7]],[[238881,487271],[0,6484]],[[240909,493739],[-31,-6461]],[[240878,487278],[-991,-1]],[[230393,487300],[-1213,-24]],[[229180,487276],[-2,6464]],[[238881,487271],[-673,1]],[[238208,487272],[-333,-4]],[[223501,488891],[-1195,-16]],[[226503,493734],[-5,-6430]],[[226498,487304],[-323,15]],[[226175,487319],[-997,7]],[[225178,487326],[-18,1612]],[[242579,492091],[0,-4839]],[[242579,487252],[-1030,-242]],[[241549,487010],[-671,268]],[[234832,492108],[2,-4840]],[[234834,487268],[-1653,0]],[[233181,487268],[-27,-1]],[[229180,487276],[-670,-7]],[[228510,487269],[-670,12]],[[227840,487281],[-1,6446]],[[227840,487281],[-666,8]],[[227174,487289],[-676,15]],[[244402,489807],[393,-2555]],[[244795,487252],[-1244,-3]],[[243551,487249],[-972,3]],[[209213,487371],[2,-6521]],[[209215,480850],[-2355,-66]],[[206860,480784],[-501,-22]],[[259400,493210],[11,-6544]],[[259411,486666],[-1095,71]],[[258316,486737],[-227,4106],[347,2582]],[[304000,489648],[314,-1030]],[[304314,488618],[155,528]],[[304469,489146],[-41,-1011]],[[304428,488135],[-42,-1969],[-144,1439],[-555,-1235],[-307,-2322],[164,-2049],[-435,-545]],[[303109,481454],[-386,1325],[-161,2029],[-306,-177],[3,1605],[-347,397]],[[219567,484832],[-690,962],[-260,-1067],[-280,233],[-415,1974],[-376,206]],[[217546,487140],[1,2864]],[[200700,480796],[-1181,20]],[[199519,480816],[-168,0]],[[199351,480816],[0,2700],[-338,-12],[1,1631],[-670,1],[0,1587],[-984,520],[1,1055],[-333,2],[5,1651],[-345,1626]],[[304469,489146],[96,425],[146,-4224],[-211,-752],[-72,3540]],[[304747,485718],[-31,9]],[[304716,485727],[-143,4024],[63,808]],[[304866,488996],[-144,-864],[186,-1284],[-161,-1130]],[[304767,492694],[-187,-2521],[-266,-1555]],[[260730,493169],[6,-6502]],[[260736,486667],[-1325,-1]],[[262060,493156],[-5,-6526]],[[262055,486630],[-1319,37]],[[263395,493087],[5,-6428]],[[263400,486659],[-1345,-29]],[[264626,493111],[-1,-3070]],[[264625,490041],[-2,-3183]],[[264623,486858],[-1223,-199]],[[247503,485097],[-1667,-111]],[[245836,484986],[-8,6442],[-167,-12]],[[173946,486507],[-392,-271],[-361,1627]],[[292791,485342],[-439,-294],[152,-6649]],[[292504,478399],[55,-2189]],[[292559,476210],[-1099,-481],[-496,1080]],[[290964,476809],[-432,1000],[257,2733],[-219,10862]],[[236200,487264],[-1352,5]],[[234848,487269],[-14,-1]],[[178798,488945],[-51,-1480]],[[178747,487465],[-147,-2107],[27,-2295],[-141,-364],[-9,-7525]],[[178477,475174],[-1,-5281],[148,-48]],[[178624,469845],[-11,-2675]],[[178613,467170],[-1161,-3],[35,3027],[-978,384],[-398,937],[-84,-1083],[-654,1956],[-183,1187]],[[175190,473575],[801,17],[8,8897]],[[290964,476809],[48,-2086],[-179,-2358]],[[290833,472365],[-10,-3429]],[[290823,468936],[-322,652],[-79,-1360],[-540,1548],[-309,-528]],[[289573,469248],[-20,3211],[418,3255],[-260,632],[239,1293],[-93,5297]],[[245836,484986],[-965,56]],[[244871,485042],[-76,2210]],[[199351,480816],[0,-542],[-2070,-233],[-331,808],[-664,542],[-332,1359],[-995,270],[0,1479],[-394,2122]],[[187141,488746],[-18,-3230],[156,229],[838,-2596]],[[188117,483149],[-2489,-4]],[[185628,483145],[-495,-66]],[[169813,452809],[-3140,-58]],[[166673,452751],[-101,8]],[[166572,452759],[-14,14051],[-1606,-147],[6,8084],[116,22],[-2,8039]],[[199519,480816],[49,-535],[44,-12867],[-117,0],[4,-6462],[53,0]],[[199552,460952],[1,-3214]],[[199553,457738],[-4238,36]],[[195315,457774],[-81,8002],[-208,644],[-621,4049],[-508,1246],[-388,4712],[-175,3678],[-827,30]],[[265345,488432],[-13,-4364],[594,-1608]],[[265926,482460],[2,-2061]],[[265928,480399],[-330,807],[-651,39],[-327,828]],[[264620,482073],[3,4785]],[[264625,490041],[337,2],[2,-1583],[381,-28]],[[217546,487140],[-458,-847],[2,-7566]],[[217090,478727],[-2459,14]],[[214631,478741],[-79,1615],[0,4173]],[[184270,476782],[-1,-3235]],[[184269,473547],[-657,2],[18,-6493],[161,-1616],[-161,-936]],[[183630,464504],[-371,1135],[-285,-316]],[[182974,465323],[1,3350],[164,1],[-2,6526],[-838,4]],[[182299,475204],[-1840,-8]],[[180459,475196],[-55,2307],[-389,209],[74,2719],[-486,2041],[-29,3598],[-455,236],[-372,1159]],[[189738,480812],[-430,715],[-125,1527],[-435,6]],[[188748,483060],[3,5605]],[[251477,488148],[-1,-4871]],[[251476,483277],[-337,-10]],[[251139,483267],[-664,187]],[[250475,483454],[215,6325]],[[250475,483454],[-987,-9]],[[297604,482655],[-139,-531],[-150,-6298]],[[297315,475826],[-695,-198],[-380,612]],[[296240,476240],[-135,842]],[[296105,477082],[40,1310],[261,-316],[91,2133],[-178,490],[251,3496],[-332,633],[104,1629],[-255,1002],[-235,-588]],[[158850,479682],[187,-616],[253,-2714],[-330,-3406],[-529,-206],[-3,-1355]],[[158428,471385],[-330,3],[-438,-1061],[-659,-2952],[-995,-473],[-214,-851]],[[155792,466051],[-606,-122],[-747,708],[-3,820]],[[154436,467457],[-267,105]],[[154169,467562],[-22,3823],[330,1722],[-6,3184],[-170,-24],[1,3264],[-310,1556],[0,1719],[-955,38]],[[153037,482844],[167,4714]],[[253492,488078],[4,-6488]],[[253496,481590],[-667,11]],[[252829,481601],[-2,1626],[-1351,50]],[[225178,487326],[13,-6561]],[[225191,480765],[-1074,13]],[[224117,480778],[-247,-3]],[[223870,480775],[-37,8118]],[[223870,480775],[-1403,11]],[[188748,483060],[-631,89]],[[254690,488092],[83,-3796],[-251,-2704]],[[254522,481592],[-691,-13]],[[253831,481579],[-335,11]],[[174503,486508],[-1,-3222],[108,-1],[2,-3245],[-111,-9],[5,-3147]],[[174506,476884],[-750,3480],[-170,2161],[-512,1621]],[[219866,484772],[49,-6023]],[[219915,478749],[-2825,-22]],[[180459,475196],[-612,-24]],[[179847,475172],[-1370,2]],[[296105,477082],[-1078,260]],[[295027,477342],[17,4427],[-151,1362],[-345,331],[179,2038]],[[212682,484293],[-532,-1540],[1,-2394]],[[212151,480359],[-2937,18]],[[209214,480377],[1,473]],[[231510,487288],[-2,-6495]],[[231508,480793],[-1114,5]],[[230394,480798],[-1,6502]],[[233181,487268],[-6,-6467]],[[233175,480801],[-1132,-10]],[[232043,480791],[-535,2]],[[239876,487278],[3,-6493]],[[239879,480785],[-1250,-4]],[[238629,480781],[-422,3]],[[238207,480784],[1,6488]],[[241549,487010],[0,-6211]],[[241549,480799],[-290,-4]],[[241259,480795],[-1313,-10]],[[239946,480785],[-67,0]],[[244871,485042],[-34,-2081],[143,-2160]],[[244980,480801],[-1096,2]],[[243884,480803],[-334,1]],[[243550,480804],[1,6445]],[[226175,487319],[6,-6546]],[[226181,480773],[-417,-14]],[[225764,480759],[-573,6]],[[227174,487289],[5,-6502]],[[227179,480787],[-998,-14]],[[243550,480804],[-972,-1]],[[242578,480803],[-1029,-4]],[[234848,487269],[-4,-6462]],[[234844,480807],[-164,-8]],[[234680,480799],[-1319,-4]],[[233361,480795],[-186,6]],[[238207,480784],[-898,-1]],[[237309,480783],[-772,10]],[[236537,480793],[3,6472]],[[230394,480798],[-407,0]],[[229987,480798],[-908,-8]],[[229079,480790],[-570,-5]],[[228509,480785],[1,6484]],[[236537,480793],[-543,5]],[[235994,480798],[-1150,9]],[[228509,480785],[-758,1]],[[227751,480786],[-572,1]],[[264620,482073],[-6,-1618],[-556,-297]],[[264058,480158],[-662,0]],[[263396,480158],[4,6501]],[[259411,486666],[-4,-6482]],[[259407,480184],[-1174,91]],[[258233,480275],[-220,3394],[303,3068]],[[263396,480158],[-664,2]],[[262732,480160],[-666,1]],[[262066,480161],[-11,6469]],[[303109,481454],[-237,-3363],[-309,-544],[-343,-4752],[-437,1186]],[[301783,473981],[56,1698],[-493,2897],[67,2978]],[[262066,480161],[-1330,38]],[[260736,480199],[0,6468]],[[260736,480199],[0,-3239]],[[260736,476960],[-635,-23]],[[260101,476937],[-693,9],[-1,3238]],[[295027,477342],[-54,-6909]],[[294973,470433],[-1008,-44]],[[293965,470389],[167,2590],[-54,4202]],[[294078,477181],[-94,3357],[378,3143],[153,2763]],[[175190,473575],[-334,1506],[-129,1914],[-221,-111]],[[294078,477181],[-671,-975],[-134,2686],[-769,-493]],[[221811,480787],[-2,-9342]],[[221809,471445],[-1850,12]],[[219959,471457],[-44,7292]],[[300852,481523],[10,-3416],[-211,-1324]],[[300651,476783],[-895,3174],[-123,-380],[-353,2396]],[[266573,485031],[2,-1115],[972,142]],[[267547,484058],[-7,-6487]],[[267540,477571],[-652,-90],[7,-1620],[-304,-225]],[[266591,475636],[-654,-32]],[[265937,475604],[-9,4795]],[[265926,482460],[509,2703],[138,-132]],[[247502,483415],[4,-1619]],[[247506,481796],[-1005,-19],[9,-2420]],[[246510,479357],[-1496,-1]],[[245014,479356],[-34,1445]],[[286839,484139],[-17,6]],[[288057,480239],[-163,246],[-201,-2952],[7,-3154]],[[287700,474379],[-304,517]],[[287396,474896],[-580,1634],[-156,-692],[-618,-120]],[[286042,475718],[-350,485],[-33,3060]],[[285659,479263],[575,1959],[489,118],[146,2788]],[[214631,478741],[5,-4840],[73,-2431]],[[214709,471470],[-1977,12]],[[212732,471482],[-581,14]],[[212151,471496],[0,8863]],[[269259,474627],[-1374,-276]],[[267885,474351],[-11,2435],[-334,785]],[[267547,484058],[1423,278]],[[268970,484336],[189,-4720],[100,-4989]],[[178613,467170],[-2,-14381]],[[178611,452789],[-3086,40],[-2428,19]],[[173097,452848],[-25,13]],[[251139,483267],[-6,-6482]],[[251133,476785],[-1981,150]],[[249152,476935],[333,1631],[5,3332],[-358,175],[-163,1343]],[[249152,476935],[-329,-1617]],[[248823,475318],[-991,-774]],[[247832,474544],[6,7270],[-332,-18]],[[252829,481601],[-49,-6494]],[[252780,475107],[-328,25]],[[252452,475132],[-1318,30]],[[251134,475162],[-1,1623]],[[189740,477360],[2,-5505]],[[189742,471855],[-1522,-1]],[[188220,471854],[5,4870],[-654,10],[0,1563],[-614,10],[-169,1087],[-1161,0],[1,3751]],[[188220,471854],[-1319,43]],[[186901,471897],[-1652,-8],[-264,-1313]],[[184985,470576],[-183,-1641],[-532,-4],[-1,4616]],[[161076,482939],[-46,-16196],[1299,-29],[10,-13964]],[[162339,452750],[-1582,69]],[[160757,452819],[-2346,191]],[[158411,453010],[17,18375]],[[166572,452759],[-1780,10]],[[164792,452769],[-2453,-19]],[[289573,469248],[-100,-158]],[[289473,469090],[-527,-153],[-20,1299],[-279,-24],[-23,1969],[-519,2369],[-405,-171]],[[300651,476783],[-32,-196]],[[300619,476587],[-404,-4938]],[[300215,471649],[-352,1116],[-342,-274],[-74,1832],[-524,-693],[-159,1711],[-267,-361]],[[298497,474980],[-226,2507],[101,2207],[330,1626]],[[154169,467562],[-316,-270],[-199,-1662],[-396,-276],[-61,3940],[-268,1346],[-619,4]],[[152310,470644],[269,5889],[458,6311]],[[298497,474980],[-81,-1100]],[[298416,473880],[-391,59],[61,931],[-822,-384]],[[297264,474486],[51,1340]],[[301783,473981],[-163,-963]],[[301620,473018],[-513,-14],[127,1049],[-615,2534]],[[265937,475604],[-658,-19],[7,-1631]],[[265286,473954],[-1222,-81]],[[264064,473873],[-6,6285]],[[247832,474544],[-657,679]],[[247175,475223],[-660,-543]],[[246515,474680],[-5,4677]],[[254522,481592],[-329,-5331],[50,-1204]],[[254243,475057],[-476,2]],[[253767,475059],[64,6520]],[[253767,475059],[-987,48]],[[238629,480781],[-1,-4543]],[[238628,476238],[-1318,-2]],[[237310,476236],[-1,4547]],[[237308,469765],[-1314,6]],[[235994,469771],[-1,6459]],[[235993,476230],[1,4568]],[[237310,476236],[-2,-6471]],[[234682,476230],[-1321,3]],[[233361,476233],[0,4562]],[[234680,480799],[2,-4569]],[[235993,476230],[-1311,0]],[[239947,476239],[-1319,-1]],[[239946,480785],[1,-4546]],[[233361,476233],[-1320,44]],[[232041,476277],[2,4514]],[[209214,480377],[5,-8812]],[[209219,471565],[1,-7313]],[[209220,464252],[-1680,-40]],[[207540,464212],[-659,-10]],[[206881,464202],[-21,16582]],[[241256,475444],[-1309,0]],[[239947,475444],[0,795]],[[241259,480795],[-3,-5351]],[[232041,476277],[-1932,42]],[[230109,476319],[87,2489],[-209,1990]],[[242578,480803],[-3,-5357]],[[242575,475446],[-1319,-2]],[[245014,479356],[4,-1361],[405,-1716],[-330,-3303]],[[245093,472976],[-1193,26]],[[243900,473002],[-16,7801]],[[243900,473002],[-1326,21]],[[242574,473023],[1,2423]],[[230109,476319],[223,-746],[59,-2539]],[[230391,473034],[-980,6]],[[229411,473040],[-330,1]],[[229081,473041],[-2,7749]],[[206881,464202],[-1098,-58],[7,-3247]],[[205790,460897],[-134,-6],[-121,-2624],[-664,266],[161,2348],[-1442,50]],[[203590,460931],[-6,-1]],[[203584,460930],[-7,19758]],[[224117,480778],[91,-2392],[1571,-3239]],[[225779,475147],[90,-531]],[[225869,474616],[-47,-3529],[-165,-2602]],[[225657,468485],[-436,812]],[[225221,469297],[-526,2161]],[[224695,471458],[-1032,3040],[-78,1581],[-470,1324],[-243,2027],[-405,1356]],[[229081,473041],[-659,-11]],[[228422,473030],[0,1617],[-664,-11]],[[227758,474636],[-7,6150]],[[227758,474636],[-664,-12]],[[227094,474624],[-1225,-8]],[[225779,475147],[-15,5612]],[[203584,460930],[-1530,-50],[-2502,72]],[[224695,471458],[-2109,-11]],[[222586,471447],[-777,-2]],[[212151,471496],[-1401,0]],[[210750,471496],[-1531,69]],[[260101,476937],[-1,-1635]],[[260100,475302],[-328,14],[3,-1620],[-1016,-10]],[[258759,473686],[-526,6589]],[[262732,480160],[25,-6465]],[[262757,473695],[-1325,-1]],[[261432,473694],[1,3265],[-697,1]],[[195315,457774],[-2814,132]],[[192501,457906],[-1359,125],[-5,3185],[-131,-2],[32,14647]],[[264064,473873],[0,-195]],[[264064,473678],[-1307,17]],[[246515,474680],[-1111,-3346],[-255,-72]],[[245149,471262],[-56,1714]],[[286042,475718],[-35,-4144],[115,-2963],[261,68],[229,-1455]],[[286612,467224],[26,-2750]],[[286638,464474],[-1117,-2]],[[285521,464472],[-187,1944],[55,5513]],[[285389,471929],[-24,5904]],[[285365,477833],[294,1430]],[[293965,470389],[-115,-2942]],[[293850,467447],[-369,-82]],[[293481,467365],[-266,2463],[-523,831]],[[292692,470659],[-14,505]],[[292678,471164],[-119,5046]],[[217090,478727],[0,-7284]],[[217090,471443],[-2381,27]],[[219959,471457],[-2869,-14]],[[281818,478275],[-5,-4317]],[[281813,473958],[-1305,-81]],[[280508,473877],[0,4511]],[[280508,478388],[1310,-113]],[[280508,473877],[4,-838]],[[280512,473039],[-752,7],[-414,-1124]],[[279346,471922],[-518,1158],[12,3306],[719,1122],[949,880]],[[283548,476628],[9,-4500]],[[283557,472128],[-318,-2],[8,-1702],[-272,15]],[[282975,470439],[-429,33],[9,794],[-498,-12]],[[282057,471254],[10,2715],[-254,-11]],[[281818,478275],[657,-443],[527,-1887],[546,683]],[[285389,471929],[-697,-202]],[[284692,471727],[-474,498],[-661,-97]],[[283548,476628],[635,251],[429,-526],[753,1480]],[[267885,474351],[36,-4847]],[[267921,469504],[-333,-95]],[[267588,469409],[-976,-153]],[[266612,469256],[-21,6380]],[[192501,457906],[16,-12908]],[[192517,444998],[-2780,45]],[[189737,445043],[-3,7851]],[[189734,452894],[0,9524]],[[189734,462418],[8,9437]],[[296240,476240],[-137,-2650],[-357,111],[-31,-3519],[241,-61],[-25,-3493]],[[295931,466628],[-259,36]],[[295672,466664],[-674,89]],[[294998,466753],[-25,3680]],[[251134,475162],[-13,-6522]],[[251121,468640],[-991,-43]],[[250130,468597],[-1307,230]],[[248823,468827],[0,6491]],[[261432,473694],[8,-6496]],[[261440,467198],[-657,-32]],[[260783,467166],[-660,1]],[[260123,467167],[-23,8135]],[[292678,471164],[-1239,48],[-606,1153]],[[301620,473018],[189,655],[301,-1389],[-295,-3187]],[[301815,469097],[-594,-238],[-94,-983],[-503,-1186]],[[300624,466690],[-506,1532],[-67,1970],[164,1457]],[[287396,474896],[215,-2006],[56,-5300]],[[287667,467590],[-1055,-366]],[[297264,474486],[21,-2797],[-310,-2919],[270,-2371]],[[297245,466399],[-1314,229]],[[232041,476277],[7,-6487]],[[232048,469790],[-1892,-6]],[[230156,469784],[78,2629],[157,621]],[[233361,476233],[0,-6428]],[[233361,469805],[-1313,-15]],[[239947,475444],[-3,-5679]],[[239944,469765],[-1319,14]],[[238625,469779],[3,6459]],[[238625,469779],[-1317,-14]],[[235994,469771],[-1312,30]],[[234682,469801],[0,6429]],[[234682,469801],[-1321,4]],[[266612,469256],[-658,-171],[8,-1638]],[[265962,467447],[-657,-45]],[[265305,467402],[-19,6552]],[[242574,473023],[-1,-3272]],[[242573,469751],[-1317,2]],[[241256,469753],[0,5691]],[[241256,469753],[-1312,12]],[[248823,468827],[0,-811]],[[248823,468016],[-1640,-18]],[[247183,467998],[-8,7225]],[[247183,467998],[1,-5693]],[[247184,462305],[-597,23]],[[246587,462328],[-172,2280],[-542,826]],[[245873,465434],[-469,1434],[-255,4394]],[[300624,466690],[-29,-121]],[[300595,466569],[-107,-728],[-1684,269]],[[298804,466110],[-84,15]],[[298720,466125],[-215,4313],[-157,17],[68,3425]],[[260123,467167],[-1187,-13]],[[258936,467154],[-49,4105],[-128,2427]],[[182299,475204],[2,-6521],[-141,-1591],[-469,14]],[[181691,467106],[-326,810],[-824,10],[-55,777],[-638,0]],[[179848,468703],[-1,6469]],[[179848,468703],[-62,-3750]],[[179786,464953],[-566,398],[-337,2246],[112,1245],[-371,1003]],[[252452,475132],[-16,-6574]],[[252436,468558],[-656,-5]],[[251780,468553],[-659,87]],[[182974,465323],[-238,-239],[-275,-2258],[-767,3]],[[181694,462829],[-3,4277]],[[253767,475059],[-17,-6494]],[[253750,468565],[-659,-23]],[[253091,468542],[-655,16]],[[254243,475057],[184,-6512]],[[254427,468545],[-677,20]],[[289473,469090],[-133,-2371]],[[289340,466719],[-1655,-378]],[[287685,466341],[-18,1249]],[[298720,466125],[-986,173]],[[297734,466298],[-489,101]],[[228422,473030],[1,-5277]],[[228423,467753],[-411,1263],[-493,-320]],[[227519,468696],[-420,21]],[[227099,468717],[-5,5907]],[[227099,468717],[-647,152],[-239,-1688],[-225,-92],[-331,1396]],[[265305,467402],[-657,-78]],[[264648,467324],[-572,-16]],[[264076,467308],[-12,6370]],[[282057,471254],[-126,-2331]],[[281931,468923],[-1419,92]],[[280512,469015],[0,4024]],[[262757,473695],[0,-6486]],[[262757,467209],[-661,6]],[[262096,467215],[-656,-17]],[[264076,467308],[-666,-110]],[[263410,467198],[-653,11]],[[184985,470576],[7,-702],[463,1104],[183,-1173],[54,-3295],[326,-1616],[-112,-2669]],[[185906,462225],[-218,4],[1,-1621],[-435,0],[0,-1622],[-966,-26]],[[184288,458960],[-6,4851],[-652,693]],[[279029,472686],[285,-724],[-124,-1251],[-161,1975]],[[280512,469015],[1,-6165]],[[280513,462850],[-1172,-1823],[-491,1851]],[[278850,462878],[-210,586]],[[278640,463464],[245,2249],[543,1799],[-163,3148],[81,1262]],[[230156,469784],[-257,-2656],[18,-1098],[319,-1424],[30,-1300]],[[230266,463306],[144,-1321]],[[230410,461985],[-513,642]],[[229897,462627],[-186,2346],[-301,1001]],[[229410,465974],[1,7066]],[[229410,465974],[-586,1070]],[[228824,467044],[-401,709]],[[243900,473002],[-5,-8148]],[[243895,464854],[-1322,-36]],[[242573,464818],[0,4933]],[[245873,465434],[-1,-548],[-656,3]],[[245216,464889],[-1321,-35]],[[292692,470659],[24,-1088],[-500,-1877]],[[292216,467694],[-534,-438],[-538,1053]],[[291144,468309],[-321,627]],[[284692,471727],[-24,-4635]],[[284668,467092],[-949,-54],[-149,-3443]],[[283570,463595],[-344,17]],[[283226,463612],[9,1732],[-312,31],[52,5064]],[[186901,471897],[-242,-2320],[147,-3747],[355,398],[147,-1874],[115,-3739]],[[187423,460615],[-60,-2973],[-639,534]],[[186724,458176],[-179,1226],[-381,-494],[84,2410],[-342,907]],[[189734,462418],[-524,-640],[35,1742],[-1063,342],[13,-3257]],[[188195,460605],[-772,10]],[[285521,464472],[224,-1369],[-308,-60]],[[285437,463043],[-555,-96]],[[284882,462947],[2,2099],[-216,2046]],[[210915,461007],[1,-6453],[118,-1623]],[[211034,452931],[-1814,-34]],[[209220,452897],[0,11355]],[[210750,471496],[65,-4017],[1,-6473],[99,1]],[[214922,454659],[-168,-1623]],[[214754,453036],[-1702,-72]],[[213052,452964],[-57,-9]],[[212995,452955],[-124,1630],[-20,6470],[-66,0]],[[212785,461055],[0,6429],[-53,3998]],[[214709,471470],[45,-10349],[76,-3],[-3,-6452],[95,-7]],[[212785,461055],[-1870,-48]],[[225221,469297],[13,-2261]],[[225234,467036],[-777,345],[-862,1235],[-166,869],[-848,-1646]],[[222581,467839],[5,3608]],[[222581,467839],[-781,-1614],[-391,247]],[[221409,466472],[-1271,1432],[-179,713]],[[219959,468617],[0,2840]],[[219959,468617],[86,-14154]],[[220045,454463],[-279,6]],[[219766,454469],[-1612,38]],[[218154,454507],[-1617,75]],[[216537,454582],[-1615,77]],[[158411,453010],[-2621,-73]],[[155790,452937],[2,13114]],[[283226,463612],[-473,57],[-176,-2031]],[[282577,461638],[-328,866],[-551,60]],[[281698,462564],[229,2735],[4,3624]],[[294998,466753],[-244,-4393]],[[294754,462360],[-1202,-852]],[[293552,461508],[61,2653],[237,3286]],[[293481,467365],[-1033,-910]],[[292448,466455],[-257,-292],[25,1531]],[[154436,467457],[-322,-2815],[-164,-2462],[-328,-79],[-48,-2548],[372,-119],[282,-2180],[-184,-1761],[99,-2712]],[[154143,452781],[-1087,56]],[[153056,452837],[-394,1953],[-208,4302],[105,4473],[-70,1599],[-265,1356],[-113,2029],[199,2095]],[[179786,464953],[673,-952],[683,-1920],[360,583]],[[181502,462664],[-185,-222],[-6,-1813],[-601,5],[9,-7878]],[[180719,452756],[-2108,33]],[[232048,469790],[-2,-6488]],[[232046,463302],[-1780,4]],[[234682,469801],[-2,-6505]],[[234680,463296],[-1319,27]],[[233361,463323],[0,6482]],[[233361,463323],[-985,-8]],[[232376,463315],[-330,-13]],[[235994,469771],[0,-4895]],[[235994,464876],[0,-1607]],[[235994,463269],[-1314,27]],[[238625,469779],[-2,-6531]],[[238623,463248],[-1316,8]],[[237307,463256],[0,1612]],[[237307,464868],[1,4897]],[[237307,464868],[-1313,8]],[[239944,469765],[-5,-6533]],[[239939,463232],[-1316,16]],[[241256,469753],[-1,-4930]],[[241255,464823],[1,-1610]],[[241256,463213],[-1317,19]],[[242573,464818],[-1318,5]],[[291144,468309],[49,-3777],[-226,-2027]],[[290967,462505],[-369,-97],[-984,-2871],[-607,-823]],[[289007,458714],[112,1789],[-67,1881],[190,1044],[98,3291]],[[225234,467036],[13,-6037]],[[225247,460999],[-1,-6480]],[[225246,454519],[-1283,-6]],[[223963,454513],[-1286,-11]],[[222677,454502],[-33,1]],[[222644,454503],[-31,12930],[-32,406]],[[268694,465642],[-316,-1304],[-142,-3077]],[[268236,461261],[-593,-71]],[[267643,461190],[-55,8219]],[[267921,469504],[681,71],[92,-3933]],[[267643,461190],[-1306,-223]],[[266337,460967],[-314,-75]],[[266023,460892],[-61,6555]],[[301815,469097],[129,-3011],[504,-1290],[-172,-917],[-656,-1010],[-20,-1435],[-247,-532]],[[301353,460902],[-115,246]],[[301238,461148],[-90,2974],[-550,962],[-3,1485]],[[227519,468696],[-1,-7666]],[[227518,461030],[-973,-16]],[[226545,461014],[-1298,-15]],[[228824,467044],[-4,-7638]],[[228820,459406],[-975,10]],[[227845,459416],[1,1618],[-328,-4]],[[281698,462564],[-753,1]],[[280945,462565],[-432,285]],[[250130,468597],[9,-6418]],[[250139,462179],[-99,3]],[[250040,462182],[-1215,98]],[[248825,462280],[-2,5736]],[[181694,462829],[-192,-165]],[[251780,468553],[1,-6528]],[[251781,462025],[-456,57]],[[251325,462082],[-1186,97]],[[221409,466472],[43,-12006]],[[221452,454466],[-68,2]],[[221384,454468],[-1339,-5]],[[253091,468542],[1,-4305]],[[253092,464237],[4,-2164]],[[253096,462073],[-1122,-19]],[[251974,462054],[-193,-29]],[[254427,468545],[185,-1078],[-127,-2165]],[[254485,465302],[-1064,31],[0,-1088],[-329,-8]],[[292448,466455],[-171,-3336],[-36,-2654]],[[292241,460465],[-527,-990]],[[291714,459475],[-489,1291],[-258,1739]],[[293552,461508],[-1311,-1043]],[[248825,462280],[-247,1]],[[248578,462281],[-1394,24]],[[222644,454503],[-1192,-37]],[[287015,460504],[-343,-51]],[[286672,460453],[-34,4021]],[[287685,466341],[71,-5737]],[[287756,460604],[-741,-100]],[[155790,452937],[-801,-56]],[[154989,452881],[-846,-100]],[[266023,460892],[-1299,-123]],[[264724,460769],[-27,1]],[[264697,460770],[-49,6554]],[[264697,460770],[-1281,-49]],[[263416,460721],[-6,6477]],[[263416,460721],[-329,-8]],[[263087,460713],[-984,-2]],[[262103,460711],[-7,6504]],[[262103,460711],[-633,-30]],[[261470,460681],[-681,30]],[[260789,460711],[-6,6455]],[[260789,460711],[-616,-16]],[[260173,460695],[-1419,-24]],[[258754,460671],[182,6483]],[[284882,462947],[17,-1461],[-606,385]],[[284293,461871],[-102,1734],[-621,-10]],[[229897,462627],[-253,6],[-13,-4592]],[[229631,458041],[-267,-255]],[[229364,457786],[-544,3],[0,1617]],[[295672,466664],[201,-1870],[-69,-1579]],[[295804,463215],[-69,-4535]],[[295735,458680],[-148,-5073]],[[295587,453607],[-1209,182]],[[294378,453789],[-26,1]],[[294352,453790],[-31,692],[433,7878]],[[289007,458714],[-9,-2218]],[[288998,456496],[-609,11],[-4,988],[-572,205],[-57,2904]],[[297645,459261],[-169,1431],[-916,-277],[9,882],[-474,582],[-291,1336]],[[297734,466298],[148,-1092],[-43,-2780],[-194,-3165]],[[301238,461148],[-70,-969]],[[301168,460179],[-67,-41]],[[301101,460138],[28,-398]],[[301129,459740],[-2,-4]],[[301127,459736],[-256,-725]],[[300871,459011],[-22,-492]],[[300849,458519],[-74,-391]],[[300775,458128],[-385,553],[-40,-2081],[-373,-818]],[[299977,455782],[-294,713],[-11,1199],[281,1311],[-388,367],[185,1163],[57,2437],[-390,-234],[39,1513],[-540,411],[-112,1448]],[[299977,455782],[-56,-2597]],[[299921,453185],[-840,-170]],[[299081,453015],[-844,386]],[[298237,453401],[-93,27]],[[298144,453428],[2,2448],[-359,413],[119,1141]],[[297906,457430],[27,1226],[-288,605]],[[184288,458960],[0,-6128]],[[184288,452832],[-2898,-85]],[[181390,452747],[-671,9]],[[246587,462328],[-37,-555],[502,-1806]],[[247052,459967],[-532,14],[-2,-1629],[-648,10]],[[245870,458362],[-646,9]],[[245224,458371],[-8,6518]],[[254485,465302],[3,-3266]],[[254488,462036],[-1092,47]],[[253396,462083],[-300,-10]],[[245224,458371],[-650,13]],[[244574,458384],[-651,-1]],[[243923,458383],[-28,6471]],[[237307,463256],[111,-1603],[1,-4876]],[[237419,456777],[-650,-3]],[[236769,456774],[-649,-15]],[[236120,456759],[0,4918],[-126,1592]],[[243923,458383],[-652,50]],[[243271,458433],[-651,-34]],[[242620,458399],[-47,6419]],[[242620,458399],[-652,5]],[[241968,458404],[-654,-10]],[[241314,458394],[-58,4819]],[[286672,460453],[9,-2065],[-460,404],[-3,-1031],[-340,350]],[[285878,458111],[-226,20]],[[285652,458131],[-201,28],[-14,4884]],[[209220,452897],[0,-5655]],[[209220,447242],[1,-2489]],[[209221,444753],[-1673,14],[-1,1638]],[[207547,446405],[-7,17807]],[[207547,446405],[-1741,68]],[[205806,446473],[-16,14424]],[[189734,452894],[-1285,-39]],[[188449,452855],[-244,1757],[-87,2140],[178,1265],[-101,2588]],[[284293,461871],[21,-3935],[375,114]],[[284689,458050],[-2,-5187]],[[284687,452863],[-1795,-1]],[[282892,452862],[-390,-48]],[[282502,452814],[75,8824]],[[278850,462878],[-1,-10015]],[[278849,452863],[-1529,-47]],[[277320,452816],[-423,27],[0,5035]],[[276897,457878],[602,1757],[633,2570],[508,1259]],[[232376,463315],[-1,-1600],[202,-13],[-4,-4901]],[[232573,456801],[-1911,67]],[[230662,456868],[1,1145]],[[230663,458013],[-154,1202],[39,2678],[-138,92]],[[234680,463296],[161,-1607],[-5,-4920]],[[234836,456769],[-647,13]],[[234189,456782],[-648,10]],[[233541,456792],[3,4901],[-183,1630]],[[233541,456792],[-968,9]],[[236120,456759],[-644,5]],[[235476,456764],[-640,5]],[[238623,463248],[102,-1618],[-1,-4868]],[[238724,456762],[-656,0]],[[238068,456762],[-649,15]],[[239939,463232],[70,-6471]],[[240009,456761],[-640,-7]],[[239369,456754],[-645,8]],[[241314,458394],[-654,-6],[2,-1611]],[[240662,456777],[-653,-16]],[[297906,457430],[-486,-1106],[-24,857],[-523,-375],[-118,1160],[-154,-1681],[-621,1035],[76,1737],[-321,-377]],[[285652,458131],[-963,-81]],[[280945,462565],[4,-9702]],[[280949,452863],[-1704,-50]],[[279245,452813],[-396,50]],[[230663,458013],[-1032,28]],[[282502,452814],[-1272,49]],[[281230,452863],[-281,0]],[[291714,459475],[-261,-2860],[238,-599]],[[291691,456016],[-916,-2846]],[[290775,453170],[-1003,-3057]],[[289772,450113],[-329,184],[-290,2566]],[[289153,452863],[-165,772],[10,2861]],[[248578,462281],[18,-5761]],[[248596,456520],[-1109,-47]],[[247487,456473],[-210,622],[-225,2872]],[[294352,453790],[-85,-1335],[-514,519],[-607,1358]],[[293146,454332],[53,903]],[[293199,455235],[352,2852],[1,3421]],[[249240,456572],[-644,-52]],[[250040,462182],[14,-5553]],[[250054,456629],[-814,-57]],[[251325,462082],[1,-6381]],[[251326,455701],[-650,-38],[2,1005],[-624,-39]],[[186724,458176],[47,-5357]],[[186771,452819],[-155,1]],[[186616,452820],[-2328,12]],[[253396,462083],[-8,-6346]],[[253388,455737],[-108,0]],[[253280,455737],[-976,-13]],[[252304,455724],[-325,0]],[[251979,455724],[-5,6330]],[[251979,455724],[-653,-23]],[[254614,455702],[-1226,35]],[[254488,462036],[-82,-3532],[208,-2802]],[[293199,455235],[-367,802],[-92,-1373],[-647,330],[-402,1022]],[[301127,459736],[69,-1616]],[[301196,458120],[-253,-1012],[-168,1020]],[[300849,458519],[22,492]],[[301101,460138],[28,-398]],[[301353,460902],[-185,-723]],[[227845,459416],[-2,-4858]],[[227843,454558],[-1298,-22]],[[226545,454536],[0,6478]],[[212995,452955],[-1853,-35]],[[211142,452920],[-108,11]],[[226545,454536],[3,-3229]],[[226548,451307],[-1288,-25]],[[225260,451282],[-14,3237]],[[266372,454459],[-653,-59]],[[265719,454400],[-998,-202]],[[264721,454198],[3,6571]],[[266337,460967],[35,-6508]],[[203590,460931],[14,-19328],[-709,2],[8,-7373]],[[202903,434232],[-1501,66]],[[201402,434298],[-1279,5]],[[200123,434303],[-1673,-17]],[[198450,434286],[-31,12242],[1170,-40],[16,8015],[-52,3235]],[[205806,446473],[3,-12257]],[[205809,434216],[-2545,-6]],[[203264,434210],[-361,22]],[[188449,452855],[-1678,-36]],[[264721,454198],[-644,35]],[[264077,454233],[-965,-58]],[[263112,454175],[-25,6538]],[[263112,454175],[-326,39]],[[262786,454214],[-1301,-17]],[[261485,454197],[-15,6484]],[[260173,460695],[4,-6539]],[[260177,454156],[-1281,40]],[[258896,454196],[-2,3200],[-392,-4]],[[258502,457392],[252,3279]],[[261485,454197],[-1308,-41]],[[289153,452863],[-334,-23]],[[288819,452840],[-1736,23]],[[287083,452863],[-29,3458],[98,835],[-137,3348]],[[287083,452863],[-115,0]],[[286968,452863],[-1145,0]],[[285823,452863],[55,5248]],[[247487,456473],[432,-1435],[26,-1576]],[[247945,453462],[-2076,28]],[[245869,453490],[1,4872]],[[229364,457786],[-3,-3238]],[[229361,454548],[-545,3]],[[228816,454551],[-973,7]],[[301793,457791],[116,-445]],[[301909,457346],[-116,445]],[[301196,458120],[304,-647]],[[301500,457473],[18,-1676],[-433,-1150]],[[301085,454647],[-839,-2061]],[[300246,452586],[-325,599]],[[298144,453428],[-1041,73]],[[297103,453501],[-1391,88]],[[295712,453589],[-125,18]],[[301909,457346],[403,-2846],[-196,-1500],[475,-1515],[5,-2151]],[[302596,449334],[-234,-1189]],[[302362,448145],[-280,-204],[-97,-1527],[-241,-453]],[[301744,445961],[-218,3011],[-291,-217],[146,1519],[-214,1940],[-82,2433]],[[301500,457473],[293,318]],[[243271,458433],[-1,-8140]],[[243270,450293],[-1301,18]],[[241969,450311],[-1,8093]],[[244574,458384],[-7,-6498]],[[244567,451886],[-1,-1626]],[[244566,450260],[-1296,33]],[[241969,450311],[-1303,-7]],[[240666,450304],[-4,6473]],[[245869,453490],[0,-1629]],[[245869,451861],[-1302,25]],[[285823,452863],[-1027,0]],[[284796,452863],[-109,0]],[[230662,456868],[249,-1941],[-15,-1182]],[[230896,453745],[-107,-597],[-679,13]],[[230110,453161],[-2,1379],[-747,8]],[[198450,434286],[-3153,-25]],[[195297,434261],[-2648,-56]],[[192649,434205],[-133,0]],[[192516,434205],[1,10793]],[[277320,452816],[-6,-2742]],[[277314,450074],[-2528,-14]],[[274786,450060],[0,2383]],[[274786,452443],[526,1090],[1585,4345]],[[258896,454196],[-9,-5791]],[[258887,448405],[-831,-14]],[[258056,448391],[-837,12]],[[257219,448403],[579,2539],[358,3965],[346,2485]],[[232573,456801],[-5,-6484]],[[232568,450317],[-1299,59]],[[231269,450376],[19,2011],[-392,1358]],[[240666,450304],[-1298,5]],[[239368,450309],[1,6445]],[[235476,456764],[0,-6454]],[[235476,450310],[-323,-7]],[[235153,450303],[-970,19]],[[234183,450322],[6,6460]],[[234183,450322],[-1294,1]],[[232889,450323],[-321,-6]],[[238068,456762],[1,-6440]],[[238069,450322],[-327,1]],[[237742,450323],[-971,-4]],[[236771,450319],[-2,6455]],[[236771,450319],[-324,-4]],[[236447,450315],[-971,-5]],[[239368,450309],[-323,8]],[[239045,450317],[-976,5]],[[251326,455701],[-4,-4851]],[[251322,450850],[-1168,-69],[-750,255]],[[249404,451036],[-159,538]],[[249245,451574],[-5,4998]],[[249245,451574],[-1296,-32]],[[247949,451542],[-4,1920]],[[293146,454332],[-66,-9100]],[[293080,445232],[-482,-138],[-384,934],[-288,-777]],[[291926,445251],[-77,1003],[-501,1869],[338,2426],[-911,2621]],[[254614,455702],[218,-1446],[203,-4308],[236,-2529]],[[255271,447419],[-5,-4485]],[[255266,442934],[-738,66],[-9,1648],[-322,-35],[-7,1623],[-327,775]],[[253863,447011],[320,581],[-17,5162],[-954,-145]],[[253212,452609],[68,3128]],[[252304,455724],[-36,-8080]],[[252268,447644],[-1,-1641]],[[252267,446003],[-938,-57]],[[251329,445946],[-7,4904]],[[253212,452609],[3,-4870]],[[253215,447739],[-947,-95]],[[216537,454582],[2,-6500]],[[216539,448082],[-1559,-14]],[[214980,448068],[-230,-4],[4,4972]],[[301744,445961],[-236,-1674],[-533,-780]],[[300975,443507],[-36,3035],[-176,276]],[[300763,446818],[-87,707]],[[300676,447525],[-253,1172]],[[300423,448697],[-177,3889]],[[218154,454507],[10,-6475]],[[218164,448032],[-1571,52]],[[216593,448084],[-54,-2]],[[230110,453161],[-1,-5099]],[[230109,448062],[-977,14]],[[229132,448076],[-318,4]],[[228814,448080],[2,6471]],[[227843,454558],[1,-6473]],[[227844,448085],[-1288,-18]],[[226556,448067],[-8,3240]],[[228814,448080],[-648,2]],[[228166,448082],[-322,3]],[[219766,454469],[6,-6447]],[[219772,448022],[-1243,-2]],[[218529,448020],[-365,12]],[[225260,451282],[0,-3235]],[[225260,448047],[-1272,-15]],[[223988,448032],[-19,0]],[[223969,448032],[-6,6481]],[[221384,454468],[0,-6437]],[[221384,448031],[-1572,-10]],[[219812,448021],[-40,1]],[[222677,454502],[3,-6462]],[[222680,448040],[-1296,-9]],[[223969,448032],[-1262,4]],[[222707,448036],[-27,4]],[[265719,454400],[30,-6681]],[[265749,447719],[-327,-65]],[[265422,447654],[-1337,-251]],[[264085,447403],[-8,6830]],[[294378,453789],[-86,-7126]],[[294292,446663],[-33,-2600]],[[294259,444063],[-1125,-724],[-133,-918]],[[293001,442421],[79,2811]],[[302989,445850],[-269,-1329],[-502,-404],[144,4028]],[[302596,449334],[321,-1189],[408,-370],[764,1511],[-341,4569],[401,-2137],[107,-3239],[-210,-1768],[-1057,-861]],[[262786,454214],[4,-5817]],[[262790,448397],[-1035,-6]],[[261755,448391],[-266,4]],[[261489,448395],[-4,5802]],[[264085,447403],[-109,-15]],[[263976,447388],[-1133,-180]],[[262843,447208],[-53,1189]],[[261489,448395],[-1024,-15]],[[260465,448380],[-348,0]],[[260117,448380],[68,740],[-8,5036]],[[260117,448380],[-775,27]],[[259342,448407],[-455,-2]],[[295712,453589],[-58,-1345],[397,121],[-173,-3103],[-189,-154],[94,-2952]],[[295783,446156],[-481,-2335],[-431,-845]],[[294871,442976],[-365,419],[-214,3268]],[[231269,450376],[205,-1282],[-160,-2130]],[[231314,446964],[-897,11]],[[230417,446975],[1,1083],[-309,4]],[[297103,453501],[5,-4179],[88,62],[182,-3932]],[[297378,445452],[-156,-333]],[[297222,445119],[-108,1174],[-581,-359],[-107,-908]],[[296426,445026],[-541,-412],[-102,1542]],[[298237,453401],[8,-1300],[-328,-15],[-2,-2289],[170,-1516],[-230,-737]],[[297855,447544],[-477,-2092]],[[247949,451542],[-252,-2717]],[[247697,448825],[-205,-1009]],[[247492,447816],[-439,832],[-669,-719],[-515,680]],[[245869,448609],[0,3252]],[[299081,453015],[27,-5278]],[[299108,447737],[6,-1575]],[[299114,446162],[-459,-103],[-560,582],[-240,903]],[[300423,448697],[-95,-429]],[[300328,448268],[-110,206]],[[300218,448474],[-189,-592],[-921,-145]],[[291926,445251],[-301,-1608],[-771,-203],[-6,-1281]],[[290848,442159],[-634,1016],[-245,2280]],[[289969,445455],[47,2798],[-244,1860]],[[160757,452819],[3,-15155]],[[160760,437664],[-2931,-15]],[[157829,437649],[51,2566],[-254,887],[-643,-3073],[-236,35],[-241,-1729],[155,-2198],[-334,193],[-289,1393],[-274,-64],[-470,1939]],[[155294,437598],[-187,3492],[-518,272]],[[154589,441362],[110,941],[-260,2964],[146,1892],[-112,2512],[386,1397],[130,1813]],[[214980,448068],[2,-6471]],[[214982,441597],[-197,8],[0,-3232]],[[214785,438373],[-1546,1]],[[213239,438374],[-74,4048]],[[213165,442422],[1,5661],[-117,1089],[3,3792]],[[213165,442422],[-2040,-26]],[[211125,442396],[-4,4869]],[[211121,447265],[21,5655]],[[188449,452855],[1,-2742],[226,-3238],[-46,-2736],[-189,-2015]],[[188441,442124],[-433,106],[-167,-982],[-443,939]],[[187398,442187],[-88,2092],[-182,-89],[-193,3079],[-3,3037],[-316,2514]],[[211121,447265],[-1901,-23]],[[189737,445043],[-2,-6108]],[[189735,438935],[-608,-2001]],[[189127,436934],[120,1271],[-305,2684],[-249,88]],[[188693,440977],[-252,1147]],[[286968,452863],[88,-6473]],[[287056,446390],[-234,-101],[-57,-1949]],[[286765,444340],[-1655,896]],[[285110,445236],[-170,121]],[[284940,445357],[-144,7506]],[[284940,445357],[-238,-844],[-1781,-169]],[[282921,444344],[-29,8518]],[[187398,442187],[-205,138],[-194,-1813],[-583,5],[-712,-4840]],[[185704,435677],[-852,-1424],[-3463,-5]],[[181389,434248],[1,18499]],[[173097,434253],[-1,-6650],[-636,-11],[-149,-2165]],[[172311,425427],[-25,2930],[-933,15],[0,3230],[-3183,-36],[0,1954],[-1457,-9]],[[166713,433511],[-56,0],[16,19240]],[[173097,452848],[0,-18595]],[[181389,434248],[-13,-16439]],[[181376,417809],[-3391,104],[-1591,99]],[[176394,418012],[-462,-9],[-438,10035],[-1,6209],[-1194,9]],[[174299,434256],[-1202,-3]],[[281230,452863],[9,-7106]],[[281239,445757],[-601,-298]],[[280638,445459],[-179,516],[-1317,-112]],[[279142,445863],[103,6950]],[[282921,444344],[4,-1186]],[[282925,443158],[-1089,-70]],[[281836,443088],[-171,12],[-426,2657]],[[154589,441362],[-304,-18],[-3,1572],[-819,-16]],[[153463,442900],[-268,5082],[-262,812],[123,4043]],[[289969,445455],[-804,-6747]],[[289165,438708],[-411,-131]],[[288754,438577],[180,478],[-59,7138]],[[288875,446193],[-56,6647]],[[288875,446193],[-721,12]],[[288154,446205],[-1098,185]],[[279142,445863],[-1549,13]],[[277593,445876],[-281,-13]],[[277312,445863],[2,4211]],[[164792,452769],[-2,-15096]],[[164790,437673],[-3709,-1]],[[161081,437672],[-321,-8]],[[166713,433511],[-9,-8230],[-71,-9],[-2,-9666],[318,14]],[[166949,415620],[46,-3526],[105,-404],[-51,-2899]],[[167049,408791],[-263,-205]],[[166786,408586],[-506,-709],[-437,-1338],[-205,182],[103,-3534],[-151,-1502]],[[165590,401685],[-468,-1589],[-344,2]],[[164778,400098],[-9,2800]],[[164769,402898],[12,2458]],[[164781,405356],[6,5108]],[[164787,410464],[3,27209]],[[253863,447011],[-4,808],[-643,-82]],[[253216,447737],[-1,2]],[[274786,450060],[0,-6513]],[[274786,443547],[-1348,41]],[[273438,443588],[-1,3974]],[[273437,447562],[3,2573]],[[273440,450135],[1346,2308]],[[245869,448609],[-4,-3244]],[[245865,445365],[-1300,23]],[[244565,445388],[1,4872]],[[249404,451036],[-5,-5897]],[[249399,445139],[-643,-17]],[[248756,445122],[-901,11]],[[247855,445133],[-158,3692]],[[226556,448067],[2,-4023]],[[226558,444044],[-753,-845],[-533,-1]],[[225272,443198],[-12,4849]],[[251329,445946],[-636,7],[1,-813]],[[250694,445140],[-1295,-1]],[[232889,450323],[0,-4862],[165,-1791]],[[233054,443670],[-1388,16]],[[231666,443686],[-257,439],[-95,2839]],[[243270,450293],[6,-6523]],[[243276,443770],[-325,-13]],[[242951,443757],[-980,-18]],[[241971,443739],[-2,6572]],[[237742,450323],[69,-6544]],[[237811,443779],[-1256,-154]],[[236555,443625],[-107,1818],[-1,4872]],[[234183,450322],[1,-4860],[144,-1818]],[[234328,443644],[-317,10]],[[234011,443654],[-957,16]],[[235153,450303],[2,-4797],[121,-1872]],[[235276,443634],[-948,10]],[[241971,443739],[-319,-4]],[[241652,443735],[-960,-14]],[[240692,443721],[-26,6583]],[[239045,450317],[54,-6615]],[[239099,443702],[0,-314]],[[239099,443388],[-1288,391]],[[240692,443721],[-320,-6]],[[240372,443715],[-1273,-13]],[[236555,443625],[-1279,9]],[[244565,445388],[-5,-3262]],[[244560,442126],[-322,13]],[[244238,442139],[-104,1623],[-858,8]],[[273437,447562],[-275,-15],[3,-1357],[-539,-11],[-3,-1320],[-265,-4]],[[272358,444855],[-272,1147]],[[272086,446002],[570,2451],[784,1682]],[[277312,445863],[-602,-34],[-476,-2457]],[[276234,443372],[-1448,-20]],[[274786,443352],[0,195]],[[247855,445133],[-29,-825],[-657,-1555],[-5,-2417]],[[247164,440336],[-1778,119]],[[245386,440455],[0,4]],[[245386,440459],[89,1581],[707,640]],[[246182,442680],[363,172],[871,2340],[76,2624]],[[300676,447525],[-94,-1308],[-254,2051]],[[246182,442680],[7,2674],[-324,11]],[[300218,448474],[-108,-2110]],[[300110,446364],[-154,-894],[-847,-110]],[[299109,445360],[5,802]],[[260465,448380],[14,-4389]],[[260479,443991],[3,-1610]],[[260482,442381],[-1130,-19]],[[259352,442362],[-1,806]],[[259351,443168],[-9,5239]],[[259351,443168],[-1136,-49],[2,-810]],[[258217,442309],[-162,-2]],[[258055,442307],[103,4030],[-102,2054]],[[258055,442307],[-491,-569],[-231,-2173],[-408,-905]],[[256925,438660],[-7,8809]],[[256918,447469],[301,934]],[[262847,444118],[-1085,-69]],[[261762,444049],[-7,4342]],[[262843,447208],[4,-3090]],[[261762,444049],[-1283,-58]],[[229132,448076],[0,-5330]],[[229132,442746],[-759,-1482],[-210,137]],[[228163,441401],[3,6681]],[[228163,441401],[-319,227]],[[227844,441628],[-642,-1180]],[[227202,440448],[0,1151],[-293,1]],[[226909,441600],[0,2456],[-351,-12]],[[230417,446975],[2,-2973],[320,-2435]],[[230739,441567],[-395,2]],[[230344,441569],[-276,747],[-936,373]],[[229132,442689],[0,57]],[[218529,448020],[-5,-6446]],[[218524,441574],[-1550,27]],[[216974,441601],[-383,9]],[[216591,441610],[2,6474]],[[216591,441610],[-1609,-13]],[[225272,443198],[0,-1617]],[[225272,441581],[-1262,6]],[[224010,441587],[-20,-2]],[[223990,441585],[-2,6447]],[[222707,448036],[24,-6450]],[[222731,441586],[-12,-6463]],[[222719,435123],[-608,-9]],[[222111,435114],[-2224,2]],[[219887,435116],[-75,6454]],[[219812,441570],[0,6451]],[[219812,441570],[-1288,4]],[[223990,441585],[-1259,1]],[[267414,445851],[-697,-80]],[[266717,445771],[-430,-33],[-394,-2264],[-479,-1509]],[[265414,441965],[1,1360]],[[265415,443325],[7,4329]],[[265749,447719],[781,160]],[[266530,447879],[6,1]],[[266536,447880],[30,6]],[[266566,447886],[16,1]],[[266582,447887],[26,6]],[[266608,447893],[806,-2042]],[[255266,442934],[-3,-3134]],[[255263,439800],[-1357,-110],[6,-1614],[-648,-79]],[[253264,437997],[-22,4868]],[[253242,442865],[-26,4872]],[[267414,445851],[546,-1925],[381,1255],[294,-1579],[-868,-836]],[[267767,442766],[-50,-4]],[[267717,442762],[-15,-1]],[[267702,442761],[-769,5],[-213,795]],[[266720,443561],[-3,2210]],[[253242,442865],[-957,-108]],[[252285,442757],[-18,3246]],[[265415,443325],[-1279,-38]],[[264136,443287],[-108,529],[-52,3572]],[[273438,443588],[0,-2864]],[[273438,440724],[-1081,8]],[[272357,440732],[1,4123]],[[299109,445360],[-23,-3357],[-140,-1618]],[[298946,440385],[-436,-421],[-482,288],[-416,-839],[-291,2723]],[[297321,442136],[350,235],[-50,1823],[-299,-180],[-100,1105]],[[256110,445861],[11,-7107]],[[256121,438754],[-158,-435]],[[255963,438319],[-386,-1051],[-314,72]],[[255263,437340],[0,2460]],[[255271,447419],[248,-1015],[591,-543]],[[256925,438660],[-559,918],[-245,-824]],[[256110,445861],[808,1608]],[[264136,443287],[1,-1079]],[[264137,442208],[-1288,-28]],[[262849,442180],[-2,1938]],[[211125,442396],[-24,-801]],[[211101,441595],[-1879,-26]],[[209222,441569],[-1,3184]],[[231666,443686],[163,-2163]],[[231829,441523],[-1090,44]],[[300704,446133],[-85,-2792],[-210,504],[295,2288]],[[300975,443507],[-208,-748],[-4,4059]],[[294871,442976],[348,-1153],[336,-2034],[-121,-1229]],[[295434,438560],[-200,-1187],[-705,-2090],[-626,-1184]],[[293903,434099],[-195,2024],[683,2086],[-173,2860]],[[294218,441069],[41,2994]],[[209222,441569],[-4,-7295]],[[209218,434274],[-2479,-59]],[[206739,434215],[-930,1]],[[300110,446364],[27,-3366],[-179,-1833],[-1042,-1242],[30,462]],[[288154,446205],[-316,-4003]],[[287838,442202],[-487,-794],[-761,-135]],[[286590,441273],[175,3067]],[[297027,438996],[-21,79]],[[297006,439075],[21,-79]],[[297321,442136],[207,-2885],[-531,-113]],[[296997,439138],[-298,3270],[-256,-279],[-17,2897]],[[296997,439138],[9,-63]],[[297027,438996],[-1112,58],[-473,-1600],[-8,1106]],[[288754,438577],[-264,-1321]],[[288490,437256],[-133,486],[-104,2828],[-415,1632]],[[293001,442421],[-13,-2191]],[[292988,440230],[-683,-3302]],[[292305,436928],[-373,1054]],[[291932,437982],[-934,2867]],[[290998,440849],[-150,1310]],[[252285,442757],[26,-6500]],[[252311,436257],[-960,-39],[-1,-3314]],[[251350,432904],[-324,-34]],[[251026,432870],[0,3329],[-319,-13]],[[250707,436186],[-5,3837]],[[250702,440023],[-8,5117]],[[272357,440732],[-1,0]],[[272356,440732],[-569,48],[73,-1359],[-321,-13]],[[271539,439408],[-538,-38]],[[271001,439370],[3,1405],[-263,14],[8,2860]],[[270749,443649],[623,-331],[714,2684]],[[280638,445459],[-3,-3672],[463,-4],[46,-3243]],[[281144,438540],[-1140,433],[-177,-967]],[[279827,438006],[-70,1137],[-624,1848],[-379,-397]],[[278754,440594],[88,2092],[292,-301],[8,3478]],[[278754,440594],[-317,-166]],[[278437,440428],[5,1839],[-538,104],[-216,-927]],[[277688,441444],[-95,4432]],[[277688,441444],[-1,-946],[-351,-263],[-253,-2768]],[[277083,437467],[-849,-19]],[[276234,437448],[0,5924]],[[269692,442196],[16,-2669]],[[269708,439527],[-1391,121]],[[268317,439648],[-18,2604],[-150,10]],[[268149,442262],[561,621],[551,-1528],[431,841]],[[266720,443561],[-15,-4584]],[[266705,438977],[-3,-1624]],[[266702,437353],[-1282,19]],[[265420,437372],[-6,4593]],[[281836,443088],[1,-1968],[-292,-2833]],[[281545,438287],[-401,253]],[[290998,440849],[-384,-1438],[-427,-3445]],[[290187,435966],[-461,1078],[82,1910],[-643,-246]],[[245386,440459],[-829,46],[3,1621]],[[285110,445236],[175,-3416],[441,-1905],[405,-535]],[[286131,439380],[-539,-2233]],[[285592,437147],[-256,304]],[[285336,437451],[-455,-614]],[[284881,436837],[-228,-952],[-463,-355]],[[284190,435530],[-1068,5402],[-197,2226]],[[286590,441273],[-78,-1278]],[[286512,439995],[-381,-615]],[[250702,440023],[-480,-175],[-57,-1257],[-306,11],[0,-1588]],[[249859,437014],[-479,1]],[[249380,437015],[-1,1587],[-610,12]],[[248769,438614],[-13,6508]],[[248769,438614],[-31,-1592],[-323,7]],[[248415,437029],[-1262,35]],[[247153,437064],[11,3272]],[[192516,434205],[-2782,5],[1,4725]],[[262849,442180],[1,-2881]],[[262850,439299],[-1082,-132]],[[261768,439167],[-6,4882]],[[261768,439167],[-323,-1]],[[261445,439166],[-639,37],[-320,533]],[[260486,439736],[-4,2645]],[[226909,441600],[-5,-1596],[-968,-299],[-620,-535],[-31,2412]],[[225285,441582],[-13,-1]],[[293006,440243],[-18,-18]],[[292988,440225],[0,5]],[[294218,441069],[-1212,-826]],[[302428,442673],[372,-1939],[-773,-264],[113,1841],[288,362]],[[271001,439370],[-263,5],[-6,-1404],[-273,-2],[-271,-1169],[-5,-1369]],[[270183,435431],[-459,42]],[[269724,435473],[-16,4054]],[[269692,442196],[936,1652],[121,-199]],[[244238,442139],[-5,-4867]],[[244233,437272],[-641,8]],[[243592,437280],[-640,14]],[[242952,437294],[-1,6463]],[[239099,443388],[2,-6149]],[[239101,437239],[-640,12]],[[238461,437251],[-646,14]],[[237815,437265],[-4,6514]],[[242952,437294],[-653,-17]],[[242299,437277],[-642,-14]],[[241657,437263],[-5,6472]],[[237815,437265],[-627,-98]],[[237188,437167],[-633,7]],[[236555,437174],[0,6451]],[[241657,437263],[-641,-12]],[[241016,437251],[-639,-8]],[[240377,437243],[-5,6472]],[[240377,437243],[-639,-2]],[[239738,437241],[-637,-2]],[[234011,443654],[-3,-6441]],[[234008,437213],[-637,14]],[[233371,437227],[-1382,-2]],[[231989,437225],[-120,576]],[[231869,437801],[88,2412],[-128,1310]],[[235276,443634],[0,-6443]],[[235276,437191],[-632,8]],[[234644,437199],[-636,14]],[[236555,437174],[-638,8]],[[235917,437182],[-641,9]],[[274786,443352],[1,-6623]],[[274787,436729],[-1339,18]],[[273448,436747],[-10,3977]],[[267767,442766],[-50,-4]],[[267702,442761],[447,-499]],[[268317,439648],[3,-646]],[[268320,439002],[-1615,-25]],[[276234,437448],[-271,-1900]],[[275963,435548],[-140,819],[-1037,201]],[[274786,436568],[1,161]],[[265420,437372],[-967,-36]],[[264453,437336],[-1,4877],[-315,-5]],[[259352,442362],[14,-4890],[-65,-5]],[[259301,437467],[-1086,-27]],[[258215,437440],[2,4869]],[[284190,435530],[0,-456]],[[284190,435074],[-1015,-1516],[-180,1961],[-470,731],[-132,1393],[-289,-76],[-14,1365],[-389,-1859]],[[281701,437073],[-156,1214]],[[155294,437598],[-138,-2080],[141,-716],[-208,-2139],[-386,312],[219,-3715],[-7,-13593]],[[154915,415667],[-1334,-12]],[[153581,415655],[-243,1900],[-703,2915],[-128,3411],[386,4770],[132,-280],[309,6363],[-132,874],[261,7292]],[[253264,437997],[-21,-1627]],[[253243,436370],[-932,-113]],[[229132,442689],[-7,-7583]],[[229125,435106],[-7,1]],[[229118,435107],[-1274,15]],[[227844,435122],[0,6506]],[[230344,441569],[400,-3783]],[[230744,437786],[23,-2700]],[[230767,435086],[-404,-539]],[[230363,434547],[0,541],[-1238,18]],[[260486,439736],[-89,-4618]],[[260397,435118],[-729,-71]],[[259668,435047],[-363,782],[-4,1638]],[[213239,438374],[-30,-4080]],[[213209,434294],[-90,-2]],[[213119,434292],[-2031,-1]],[[211088,434291],[13,7304]],[[278437,440428],[-17,-5242]],[[278420,435186],[-185,-771],[-669,-629],[-401,1395],[-70,2246]],[[277095,437427],[-12,40]],[[188693,440977],[-212,-2505],[-448,-762],[-414,553],[-140,-1426]],[[187479,436837],[-928,257],[-847,-1417]],[[258215,437440],[-1290,17]],[[256925,437457],[0,1203]],[[288490,437256],[-135,-732]],[[288355,436524],[-329,-580],[98,-1544],[-739,-1772]],[[287385,432628],[-586,685]],[[286799,433313],[-59,3513],[-251,1238],[23,1931]],[[264453,437336],[-316,-6]],[[264137,437330],[-325,1637],[-962,-17]],[[262850,438950],[0,349]],[[245386,440455],[-115,-1739],[344,-1569],[113,-1545]],[[245728,435602],[-1175,26]],[[244553,435628],[2,1613],[-322,31]],[[216974,441601],[-2,-6470],[57,-809]],[[217029,434322],[-2234,-1]],[[214795,434321],[-10,4052]],[[219887,435116],[2,-6448]],[[219889,428668],[-1545,-2]],[[218344,428666],[-1309,-44]],[[217035,428622],[-6,5700]],[[304069,440803],[121,-1847],[-424,-198],[303,2045]],[[227844,435122],[-1276,-6]],[[226568,435116],[-6,2365]],[[226562,437481],[640,2967]],[[211088,434291],[-535,-10]],[[210553,434281],[-1335,-7]],[[226562,437481],[-534,-2004],[-732,-3606]],[[225296,431871],[-12,3241]],[[225284,435112],[1,6470]],[[225284,435112],[-1212,5]],[[224072,435117],[-74,0]],[[223998,435117],[12,6470]],[[223998,435117],[-1279,6]],[[231869,437801],[-1125,-15]],[[189127,436934],[-680,-1517],[-235,-1306],[316,-2475],[-193,-1470],[-256,342]],[[188079,430508],[-272,1154]],[[187807,431662],[-214,1796],[-114,3379]],[[279827,438006],[-264,-1318],[-1,-4190]],[[279562,432498],[-1143,100]],[[278419,432598],[1,2588]],[[157829,437649],[146,-436],[-429,-4820],[-421,-4012],[146,-2151],[-836,-2814],[-186,-2443]],[[156249,420973],[222,-710],[144,-5038]],[[156615,415225],[-1701,-21],[1,463]],[[293900,433789],[-376,-1707]],[[293524,432082],[-325,588]],[[293199,432670],[123,2992],[-28,2071],[-288,2510]],[[293903,434099],[-3,-310]],[[291932,437982],[-383,-2133]],[[291549,435849],[-417,-3054],[-322,-187]],[[290810,432608],[-554,3400]],[[290256,436008],[-69,-42]],[[272356,440732],[-5,-6697]],[[272351,434035],[-74,-1524],[-634,144]],[[271643,432655],[-114,1381]],[[271529,434036],[10,5372]],[[273448,436747],[0,-2714],[-243,-5]],[[273205,434028],[-854,7]],[[247153,437064],[-5,-1624]],[[247148,435440],[-963,88]],[[246185,435528],[-457,35]],[[245728,435563],[0,39]],[[250707,436186],[-548,-8],[-300,836]],[[293219,434221],[-863,2534]],[[292356,436755],[-51,173]],[[292988,440225],[220,-3323],[11,-2681]],[[286799,433313],[-277,-2754],[-204,-490]],[[286318,430069],[-412,1992]],[[285906,432061],[44,1187],[-292,2181],[-66,1718]],[[255263,437340],[2,-2899]],[[255265,434441],[-1688,-234]],[[253577,434207],[-321,-56]],[[253256,434151],[-13,2219]],[[261445,439166],[-77,-4820]],[[261368,434346],[-859,-55]],[[260509,434291],[-112,827]],[[294555,427007],[-1,231]],[[294554,427238],[1,-231]],[[294554,427873],[-111,3760]],[[294443,431633],[-93,1192],[769,-305],[174,1129],[1072,-46],[376,297],[903,2986],[-441,-2839],[-371,-1388],[292,-372],[379,1926],[532,898],[205,-1022],[552,1761],[82,-626],[-1554,-3633],[-192,472],[-405,-1606],[-231,346],[-428,-1335],[-389,98],[-351,-945],[-238,353],[-532,-1101]],[[269724,435473],[-278,-7],[9,-1349]],[[269455,434117],[-813,50]],[[268642,434167],[-292,19]],[[268350,434186],[-30,4816]],[[256925,437457],[-1,-4839]],[[256924,432618],[-156,-1387],[-315,-5],[3,-1882]],[[256456,429344],[-470,-1]],[[255986,429343],[-23,8976]],[[271529,434036],[-1228,60]],[[270301,434096],[-118,1335]],[[262850,438950],[1,-4899]],[[262851,434051],[1,-1244]],[[262852,432807],[-755,-88]],[[262097,432719],[-730,-14]],[[261367,432705],[1,1641]],[[268350,434186],[-789,-60]],[[267561,434126],[-857,-29]],[[266704,434097],[-2,3256]],[[281701,437073],[-194,-835],[74,-2824],[-363,-706],[-462,-3036],[47,-402]],[[280803,429270],[26,-144]],[[280829,429126],[-1257,-6]],[[279572,429120],[-10,3378]],[[192649,434205],[0,-3424]],[[192649,430781],[-728,405],[-315,-879],[-787,-888],[-261,131],[-420,-1293]],[[190138,428257],[-340,-1865],[-343,-530],[-618,1479],[-69,1143],[-267,-1698],[-177,190]],[[188324,426976],[-245,3532]],[[284190,435074],[-613,-3675]],[[283577,431399],[-884,-2182]],[[282693,429217],[-399,260],[-333,-971],[-479,890]],[[281482,429396],[-679,-126]],[[290256,436008],[-428,-2350]],[[289828,433658],[-466,-1941],[-519,-917]],[[288843,430800],[-280,2542],[218,671],[-426,2511]],[[264137,437330],[-1,-3255],[-160,-7]],[[263976,434068],[-1125,-17]],[[249380,437015],[-1,-3256]],[[249379,433759],[-966,19]],[[248413,433778],[2,3251]],[[214795,434321],[-2,-29]],[[214793,434292],[-1584,2]],[[255986,429343],[-721,8]],[[255265,429351],[0,5090]],[[292587,430897],[-395,1442]],[[292192,432339],[-104,1880],[-539,1630]],[[292356,436755],[-165,-2166],[367,-970],[29,-2722]],[[231989,437225],[3,-1984]],[[231992,435241],[-431,236],[-484,-1310],[-310,919]],[[164787,410464],[-407,-275]],[[164380,410189],[102,1082],[5,3235],[-258,1376],[-23,1351],[-367,544],[-472,2489],[-707,1249],[-457,-2310],[-371,1200],[1,3540],[-743,-22]],[[161090,423923],[22,8573],[-31,5176]],[[161090,423923],[-473,4]],[[160617,423927],[-1427,-350],[-831,-1031],[-549,335],[-407,-1138],[-270,689],[-884,-1459]],[[285336,437451],[-167,-4196],[366,398],[371,-1592]],[[286318,430069],[-895,-2187]],[[285423,427882],[-525,-888],[-165,332]],[[284733,427326],[26,188]],[[284759,427514],[265,1448],[124,3090]],[[285148,432052],[-223,1660],[-44,3125]],[[259668,435047],[-2,-813]],[[259666,434234],[-619,-58],[-1,-1610]],[[259046,432566],[-835,5]],[[258211,432571],[4,4869]],[[226568,435116],[1,-6480]],[[226569,428636],[-1260,-4]],[[225309,428632],[-13,-1]],[[225296,428631],[0,3240]],[[258211,432571],[-314,19]],[[257897,432590],[-973,28]],[[277095,437427],[-6,-9327]],[[277089,428100],[-1270,89]],[[275819,428189],[-27,3363]],[[275792,431552],[-19,2705],[190,1291]],[[278419,432598],[1,-2521],[-655,-4576]],[[277765,425501],[-675,2581]],[[277090,428082],[-1,18]],[[266704,434097],[-266,-3234]],[[266438,430863],[-1015,33]],[[265423,430896],[-1,1871]],[[265422,432767],[-2,4605]],[[265422,432767],[-638,-292],[0,-814],[-644,-36]],[[264140,431625],[-164,2443]],[[243592,437280],[-7,-4878]],[[243585,432402],[-1284,-20]],[[242301,432382],[-2,4895]],[[244553,435628],[-3,-4868],[-104,1]],[[244446,430761],[-862,16]],[[243584,430777],[1,1625]],[[242301,432382],[-1281,-16]],[[241020,432366],[-4,4885]],[[238461,437251],[3,-4896]],[[238464,432355],[-1277,-24]],[[237187,432331],[1,4836]],[[239738,437241],[4,-4883]],[[239742,432358],[-1278,-3]],[[241020,432366],[-1278,-8]],[[233371,437227],[-2,-4811]],[[233369,432416],[-1193,2]],[[232176,432418],[-184,2823]],[[234644,437199],[-3,-4800]],[[234641,432399],[-1272,17]],[[235917,437182],[-1,-4805]],[[235916,432377],[-1275,22]],[[237187,432331],[-1271,46]],[[187807,431662],[-565,-723],[-182,1854],[-716,-2763]],[[186344,430030],[-640,5647]],[[248413,433778],[-2,-4886]],[[248411,428892],[-1277,44]],[[247134,428936],[14,6504]],[[285148,432052],[-398,108],[-1152,-1498]],[[283598,430662],[-21,737]],[[251026,432870],[-1183,-88]],[[249843,432782],[68,968],[-532,9]],[[292970,430541],[-431,-269]],[[292539,430272],[48,625]],[[293219,434221],[-249,-3680]],[[274786,436568],[0,-4189]],[[274786,432379],[-1580,38]],[[273206,432417],[-1,1611]],[[288843,430800],[-376,-510]],[[288467,430290],[-415,-967]],[[288052,429323],[-667,3305]],[[275792,431552],[-1004,-69]],[[274788,431483],[-2,896]],[[253256,434151],[34,-7012],[-625,-15]],[[252665,427124],[-321,-16],[-27,2627],[-962,-80]],[[251355,429655],[-5,3249]],[[290810,432608],[-339,-2310]],[[290471,430298],[-220,-1439],[-616,-2210]],[[289635,426649],[-20,312]],[[289615,426961],[68,3154],[341,1723],[-196,1820]],[[292192,432339],[-162,208],[-116,-3152]],[[291914,429395],[-248,-1212]],[[291666,428183],[-265,1560],[-471,-722]],[[290930,429021],[-459,1277]],[[186344,430030],[155,-1074],[97,-4631]],[[186596,424325],[-109,-153],[38,-2825],[149,-2529],[-96,-2970]],[[186578,415848],[-452,-1999],[-1271,-19],[-3480,52]],[[181375,413882],[1,3927]],[[245728,435563],[-37,-2695],[-356,-1884],[-62,-2389]],[[245273,428595],[-827,2166]],[[246185,435528],[-13,-8061]],[[246172,427467],[-319,64]],[[245853,427531],[-783,-26]],[[245070,427505],[203,1090]],[[247134,428936],[-3,-1616]],[[247131,427320],[-959,147]],[[270301,434096],[8,-6024]],[[270309,428072],[-263,-12],[2,-1850]],[[270048,426210],[-326,-246]],[[269722,425964],[-6,3196],[-215,1864],[-46,3093]],[[232176,432418],[-58,-2195]],[[232118,430223],[-1754,3]],[[230364,430226],[-1,4321]],[[227844,435122],[-1,-6484]],[[227843,428638],[-1271,-2]],[[226572,428636],[-3,0]],[[225296,428631],[-1222,12]],[[224074,428643],[-2,6474]],[[222111,435114],[24,-6994]],[[222135,428120],[-630,262]],[[221505,428382],[-943,281]],[[220562,428663],[-673,5]],[[224074,428643],[-9,-170]],[[224065,428473],[-506,-690],[-761,186]],[[222798,427969],[-663,151]],[[229118,435107],[-7,-6481]],[[229111,428626],[-1268,12]],[[230364,430226],[0,-4858]],[[230364,425368],[-1251,12]],[[229113,425380],[-2,3246]],[[260509,434291],[15,-6500]],[[260524,427791],[-631,-27]],[[259893,427764],[-208,-13],[-19,6483]],[[255265,429351],[-1,-4574]],[[255264,424777],[-1140,-99]],[[254124,424678],[-508,40],[-39,9489]],[[261367,432705],[3,-4890],[-318,-15]],[[261052,427800],[-528,-9]],[[206643,416247],[0,0]],[[210532,425375],[-1577,18],[-7,-9745]],[[208948,415648],[-2259,-10]],[[206689,415638],[-255,-1]],[[206434,415637],[-6,4869]],[[206428,420506],[-5,1628],[310,-3],[6,12084]],[[210553,434281],[-21,-8906]],[[217035,428622],[-272,6]],[[216763,428628],[-1967,-10]],[[214796,428618],[0,969]],[[214796,429587],[-3,4705]],[[201978,423908],[55,-1918],[16,-7759]],[[202049,414231],[-1129,-109]],[[200920,414122],[-15,3214]],[[200905,417336],[-2,2480],[-1118,-26]],[[199785,419790],[29,5936],[320,1081],[-11,7496]],[[201402,434298],[27,-1460],[436,-670],[158,-1783],[-185,-3986],[140,-2491]],[[204199,424684],[-292,-2571],[-164,468],[-589,-929],[-98,691],[-519,-163],[-107,1114],[-340,-603],[-112,1217]],[[203264,434210],[15,-1191],[530,-3757],[390,-4578]],[[199785,419790],[-1878,-32],[-2612,19]],[[195295,419777],[7,8023]],[[195302,427800],[-5,6461]],[[213087,423794],[-321,0]],[[212766,423794],[-1909,-39]],[[210857,423755],[-6,1618],[-319,2]],[[213119,434292],[6,-4708]],[[213125,429584],[-38,-5790]],[[214796,429587],[-1671,-3]],[[195302,427800],[-314,562],[-118,3255],[-532,-11],[-250,-2208],[-269,1599],[-807,-1145],[-299,856]],[[192713,430708],[-64,73]],[[176394,418012],[112,-5115],[-101,-2198],[49,-2635],[-263,-2403],[2,-5633]],[[176193,400028],[-1933,-7]],[[174260,400021],[29,16934],[-18,16297],[28,1004]],[[174260,400021],[-2037,36],[-1236,-1303]],[[170987,398754],[153,2224],[-118,2607],[482,3074],[266,297],[87,1838],[-89,2169],[75,3206],[-204,1482]],[[171639,415651],[672,9776]],[[206428,420506],[-1667,-25]],[[204761,420481],[-562,4203]],[[259893,427764],[3,-1603]],[[259896,426161],[-839,-54]],[[259057,426107],[-11,6459]],[[268642,434167],[-7,-5295]],[[268635,428872],[-365,-115]],[[268270,428757],[-705,-40]],[[267565,428717],[-4,5409]],[[254124,424678],[8,-1608]],[[254132,423070],[-1470,-13]],[[252662,423057],[3,4067]],[[269722,425964],[-798,-95]],[[268924,425869],[-10,2970],[-279,33]],[[267565,428717],[-860,-299]],[[266705,428418],[-211,275],[-56,2170]],[[271643,432655],[-7,-4585]],[[271636,428070],[-1327,2]],[[264140,431625],[-158,-803],[1,-2439]],[[263983,428383],[-165,-1]],[[263818,428382],[0,807],[-964,-2]],[[262854,429187],[-2,3620]],[[273206,432417],[-2,-3235]],[[273204,429182],[-418,-80],[-224,-1340]],[[272562,427762],[-923,-316]],[[271639,427446],[-3,624]],[[249843,432782],[-231,-3232]],[[249612,429550],[-356,-3635],[-528,-731]],[[248728,425184],[-3,2060],[-321,38],[7,1610]],[[289615,426961],[-382,-1336]],[[289233,425625],[-268,2542],[-150,-335],[-348,2458]],[[171639,415651],[-2673,-44],[-2017,13]],[[288052,429323],[-372,-1083]],[[287680,428240],[-781,-2649],[-748,-726]],[[286151,424865],[-265,1102]],[[285886,425967],[-463,1915]],[[274788,431483],[-1,-3962]],[[274787,427521],[-415,-1046]],[[274372,426475],[-540,316]],[[273832,426791],[-154,2374],[-474,17]],[[251355,429655],[-154,-1644],[-415,-1270],[-378,-46]],[[250408,426695],[-162,393],[-9,2476],[-625,-14]],[[262854,429187],[-1,-2903]],[[262853,426284],[-741,-74]],[[262112,426210],[-15,6509]],[[265423,430896],[0,-3262]],[[265423,427634],[-634,-31],[-321,799],[-485,-19]],[[188324,426976],[-114,-601]],[[188210,426375],[-465,-891],[-618,-2134],[-142,895],[-389,80]],[[293524,432082],[-12,-1259],[-325,-351]],[[293187,430472],[-27,1525]],[[293160,431997],[39,673]],[[262112,426210],[-370,-18]],[[261742,426192],[-685,-6]],[[261057,426186],[-5,1614]],[[294555,427007],[-1,231]],[[294554,427873],[-875,-1167]],[[293679,426706],[-79,470]],[[293600,427176],[63,322]],[[293663,427498],[119,2121],[-126,536]],[[293656,430155],[90,1669],[410,855],[287,-1046]],[[257897,432590],[-1,-3261]],[[257896,429329],[-463,33],[-65,-3266]],[[257368,426096],[-903,15]],[[256465,426111],[-9,3233]],[[259057,426107],[-583,-24]],[[258474,426083],[2,2440],[-422,-1],[-158,807]],[[279572,429120],[-482,-6117]],[[279090,423003],[-351,-509],[-158,819],[-661,807],[-155,1381]],[[292539,430272],[83,-963]],[[292622,429309],[-118,-889]],[[292504,428420],[-590,975]],[[233369,432416],[31,-5977]],[[233400,426439],[-1091,87]],[[232309,426526],[-329,3028],[138,669]],[[234641,432399],[38,-6061]],[[234679,426338],[-801,63]],[[233878,426401],[-478,38]],[[235916,432377],[-1,-6118]],[[235915,426259],[-448,10]],[[235467,426269],[-788,69]],[[243584,430777],[5,-4003]],[[243589,426774],[-630,136]],[[242959,426910],[-660,-98]],[[242299,426812],[2,5570]],[[242299,426812],[-476,-61]],[[241823,426751],[-800,-120]],[[241023,426631],[-3,5735]],[[237187,432331],[-2,-6015]],[[237185,426316],[-604,-37]],[[236581,426279],[-666,-20]],[[238464,432355],[-1,-5921]],[[238463,426434],[-606,-50]],[[237857,426384],[-672,-68]],[[239742,432358],[1,-5854]],[[239743,426504],[-772,-68]],[[238971,426436],[-508,-2]],[[241023,426631],[-213,-26]],[[240810,426605],[-1067,-101]],[[284759,427514],[-273,768],[-697,262]],[[283789,428544],[-185,150],[-6,1968]],[[293187,430472],[-271,-1807],[244,3332]],[[195295,419777],[-1,-10466]],[[195294,409311],[0,-3031]],[[195294,406280],[-155,-665],[-2556,-5]],[[192583,405610],[1,136]],[[192584,405746],[-39,1805],[122,2542],[304,1922],[-230,5]],[[192741,412020],[-28,18688]],[[275819,428189],[-81,-1216],[-510,-2451]],[[275228,424522],[-441,-3]],[[274787,424519],[0,3002]],[[282497,422685],[-451,360],[271,1887],[-71,939],[431,2360],[16,986]],[[283789,428544],[-584,-2082],[-708,-3777]],[[192741,412020],[-2481,120]],[[190260,412140],[-94,1614]],[[190166,413754],[-28,14503]],[[266705,428418],[4,-3381]],[[266709,425037],[-283,-21]],[[266426,425016],[-1003,645]],[[265423,425661],[0,1973]],[[292970,430541],[-211,-2552],[-210,-377],[73,1697]],[[245070,427505],[-470,-581],[-146,-1017],[115,-2813],[-151,-420]],[[244418,422674],[-829,4100]],[[293679,426706],[-79,470]],[[293412,427055],[2,251]],[[293414,427306],[-2,-251]],[[293663,427498],[-315,245]],[[293348,427743],[-288,1615]],[[293060,429358],[139,999],[457,-202]],[[290930,429021],[33,-2516],[-174,-1500],[76,-1477]],[[290865,423528],[-301,-1442],[-241,-93]],[[290323,421993],[-332,1497],[-16,2219],[-340,940]],[[289233,425625],[-418,-2203]],[[288815,423422],[-127,533]],[[288688,423955],[-1008,4285]],[[232309,426526],[155,-1143]],[[232464,425383],[-995,-12]],[[231469,425371],[-1105,-3]],[[291666,428183],[-6,-1402]],[[291660,426781],[-177,-792],[187,-1218],[-446,-2170]],[[291224,422601],[-359,927]],[[252662,423057],[2,-2183]],[[252664,420874],[-322,-1]],[[252342,420873],[-1598,9]],[[250744,420882],[-320,803]],[[250424,421685],[-16,5010]],[[214796,428618],[0,-4795]],[[214796,423823],[-1709,-29]],[[250424,421685],[-946,-94]],[[249478,421591],[-311,-17],[-6,2160],[-579,13]],[[248582,423747],[146,1437]],[[282497,422685],[136,-2142]],[[282633,420543],[-450,-3765]],[[282183,416778],[-753,1928]],[[281430,418706],[-282,1105],[-60,1366]],[[281088,421177],[343,3265],[-239,3445],[290,1509]],[[281088,421177],[-85,-1011],[-408,1093],[-38,-1088],[-480,1549]],[[280077,421720],[157,811],[68,2529],[527,4066]],[[293412,427055],[2,251]],[[293348,427743],[-53,-1236],[-451,496],[216,2355]],[[256465,426111],[5,-1623]],[[256470,424488],[-1206,27]],[[255264,424515],[0,262]],[[292504,428420],[-134,-1704]],[[292370,426716],[-710,65]],[[258474,426083],[-4,-2412]],[[258470,423671],[-889,5]],[[257581,423676],[-2,2416],[-211,4]],[[273832,426791],[-165,-803],[-57,-2450]],[[273610,423538],[-915,164]],[[272695,423702],[15,2449],[-148,1611]],[[263818,428382],[2,-6070],[59,-80]],[[263879,422232],[-1,-5]],[[263878,422227],[-1029,-28]],[[262849,422199],[4,4085]],[[280077,421720],[-106,-1566]],[[279971,420154],[-653,121],[-455,659]],[[278863,420934],[227,2069]],[[248582,423747],[-330,-1227],[-73,-1405],[-363,-2059]],[[247816,419056],[-702,92],[4,1628]],[[247118,420776],[13,6544]],[[268924,425869],[-64,-3813],[-274,84]],[[268586,422140],[-515,159],[-254,1409]],[[267817,423708],[174,1058],[2,2876],[277,1115]],[[267817,423708],[-635,189]],[[267182,423897],[2,1174],[-475,-34]],[[220562,428663],[2,-4872],[-317,7],[0,-1627]],[[220247,422171],[-287,-23]],[[219960,422148],[-1562,-10]],[[218398,422138],[-52,0]],[[218346,422138],[-2,6528]],[[225309,428632],[0,-6478]],[[225309,422154],[-1242,1]],[[224067,422155],[-2,6318]],[[221505,428382],[3,-6212]],[[221508,422170],[-1261,1]],[[218346,422138],[-1521,20]],[[216825,422158],[-55,-2]],[[216770,422156],[-7,6472]],[[216770,422156],[-1974,-23]],[[214796,422133],[0,1690]],[[227843,428638],[0,-6483]],[[227843,422155],[-1260,3]],[[226583,422158],[-9,0]],[[226574,422158],[-2,6478]],[[229113,425380],[-7,-3237]],[[229106,422143],[-1263,12]],[[226574,422158],[-1253,-4]],[[225321,422154],[-12,0]],[[284733,427326],[-651,-855],[-995,-3407],[-367,-2037]],[[282720,421027],[-87,-484]],[[190166,413754],[-531,19],[-2,801],[-456,2164],[59,2009],[-250,2239],[-310,-13],[-356,1411],[-184,1615],[74,2376]],[[224067,422155],[-8,0]],[[224059,422155],[-1261,5]],[[222798,422160],[0,5809]],[[265423,425661],[-341,-1035]],[[265082,424626],[-938,-41],[1,-1903],[-266,-450]],[[222798,422160],[-1257,8]],[[221541,422168],[-33,2]],[[278863,420934],[-360,-3257],[-302,-1293]],[[278201,416384],[-562,1959],[-401,-1171],[-297,845],[-366,-25]],[[276575,417992],[19,1315]],[[276594,419307],[179,811],[290,5227],[-200,1083],[227,1654]],[[288688,423955],[-466,-3821]],[[288222,420134],[-493,-1945]],[[287729,418189],[-773,3320]],[[286956,421509],[-805,3356]],[[276594,419307],[-123,1028],[-749,1490],[-494,2697]],[[271639,427446],[-58,-3551],[-110,17]],[[271471,423912],[-1324,214]],[[270147,424126],[-99,2084]],[[272695,423702],[-15,-2421],[-175,-1661]],[[272505,419620],[-793,132]],[[271712,419752],[19,2733],[-268,50],[8,1377]],[[285886,425967],[-397,-1498],[304,-5190]],[[285793,419279],[-424,-1382]],[[285369,417897],[-35,1119],[-345,857]],[[284989,419873],[-161,1874]],[[284828,421747],[-318,1084],[208,1376],[-107,1919],[122,1200]],[[261057,426186],[8,-3496]],[[261065,422690],[-374,7]],[[260691,422697],[-791,-21]],[[259900,422676],[1,530]],[[259901,423206],[-5,2955]],[[292731,427719],[-75,-1794],[-401,-1051],[179,2726],[297,119]],[[245853,427531],[-15,-6605]],[[245838,420926],[-7,-1699]],[[245831,419227],[-1653,137]],[[244178,419364],[23,899]],[[244201,420263],[217,2411]],[[274787,424519],[3,-1461]],[[274790,423058],[-309,-65]],[[274481,422993],[90,1246],[-199,2236]],[[247118,420776],[-1280,150]],[[284828,421747],[-989,-927],[-267,651],[-693,-2143]],[[282879,419328],[-159,1699]],[[244201,420263],[-1264,157]],[[242937,420420],[3,812]],[[242940,421232],[19,5678]],[[290323,421993],[609,-3619]],[[290932,418374],[-696,-1838]],[[290236,416536],[-114,1663]],[[290122,418199],[-1307,5223]],[[292370,426716],[-184,-1986],[143,-700]],[[292329,424030],[-474,-3179],[-254,-504]],[[291601,420347],[-383,1322],[6,932]],[[242940,421232],[-1109,36]],[[241831,421268],[-6,814]],[[241825,422082],[-2,4669]],[[274481,422993],[82,-1389],[-230,-2518]],[[274333,419086],[-58,-528]],[[274275,418558],[-502,43]],[[273773,418601],[49,4904],[-212,33]],[[241825,422082],[-931,-56]],[[240894,422026],[22,2915],[-106,1664]],[[240894,422026],[-478,-14]],[[240416,422012],[1,804],[-1425,-54]],[[238992,422762],[-21,3674]],[[233878,426401],[61,-5897]],[[233939,420504],[-1043,57]],[[232896,420561],[-163,921],[-269,3901]],[[238992,422762],[-1,-2172]],[[238991,420590],[-1104,-44]],[[237887,420546],[-30,5838]],[[235467,426269],[94,-3438]],[[235561,422831],[-21,-4851]],[[235540,417980],[-1218,74]],[[234322,418054],[-79,2429],[-304,21]],[[190260,412140],[-1085,15]],[[189175,412155],[-1095,-4]],[[188080,412151],[-519,2498],[-397,-2608],[-336,-472],[101,2059],[-351,2220]],[[237887,420546],[-2,-2440]],[[237885,418106],[-1261,69]],[[236624,418175],[7,4610]],[[236631,422785],[-50,3494]],[[270147,424126],[-32,-4044]],[[270115,420082],[-784,126],[-762,580]],[[268569,420788],[17,1352]],[[262849,422199],[1,-795]],[[262850,421404],[-1157,-63]],[[261693,421341],[-3,1350]],[[261690,422691],[52,3501]],[[236631,422785],[-1070,46]],[[261690,422691],[-625,-1]],[[259901,423206],[-1061,-73],[0,-541]],[[258840,422592],[-370,1079]],[[257581,423676],[-3,-4054]],[[257578,419622],[-1105,9]],[[256473,419631],[1,2822]],[[256474,422453],[-4,2035]],[[232896,420561],[7,-54]],[[232903,420507],[-1276,-7]],[[231627,420500],[-157,10]],[[231470,420510],[-1,4861]],[[286956,421509],[-435,-1129],[-728,-1101]],[[266426,425016],[-87,-5114]],[[266339,419902],[-1291,821]],[[265048,420723],[34,3903]],[[210857,423755],[-19,-8095],[-651,-3]],[[210187,415657],[-1239,-9]],[[230364,425368],[0,-4856]],[[230364,420512],[0,-4861]],[[230364,415651],[-953,8]],[[229411,415659],[-308,1]],[[229103,415660],[3,6483]],[[231470,420510],[-1106,2]],[[267401,418295],[-101,-658]],[[267300,417637],[-828,70]],[[266472,417707],[25,2122],[-158,73]],[[267182,423897],[1,-3714],[212,-4],[6,-1884]],[[255264,424515],[-14,-6128]],[[255250,418387],[-5,-4934]],[[255245,413453],[-1127,-59]],[[254118,413394],[14,9676]],[[204761,420481],[44,-3996],[-107,-2111]],[[204698,414374],[-40,-1498]],[[204658,412876],[-515,-983],[-138,-1866]],[[204005,410027],[-269,-196],[-186,2235],[-440,1922],[-526,246]],[[202584,414234],[-535,-3]],[[265048,420723],[-23,-1667]],[[265025,419056],[-1141,244]],[[263884,419300],[-6,2927]],[[276575,417992],[2,-1689],[-338,-982]],[[276239,415321],[-807,668],[-645,-1056]],[[274787,414933],[1,1005]],[[274788,415938],[-1,2668]],[[274787,418606],[3,4452]],[[256474,422453],[-391,-1025],[-571,-2641],[86,-782]],[[255598,418005],[-348,382]],[[292681,417934],[-413,-100],[-60,940],[-392,66],[-407,-1735]],[[291409,417105],[-97,1100]],[[291312,418205],[289,2142]],[[292329,424030],[617,-741],[71,-1974],[-164,-3756],[-172,375]],[[271712,419752],[-260,-1288]],[[271452,418464],[-1312,274]],[[270140,418738],[-25,1344]],[[290122,418199],[-264,-1711],[-318,871],[49,-1505],[-196,-651]],[[289393,415203],[-235,1649]],[[289158,416852],[-265,414],[-399,2752],[-272,116]],[[160617,423927],[82,-1784],[340,-681],[-60,-1870],[-213,-1153]],[[160766,418439],[-393,-946],[-168,-2180],[-363,-1739],[-738,-95],[-16,-1615]],[[159088,411864],[-2483,10]],[[156605,411874],[10,3351]],[[164380,410189],[-1412,-44],[-74,-532],[-534,1856],[-382,-2585]],[[161978,408884],[-186,-741]],[[161792,408143],[-928,5114],[-31,2656],[120,1726],[-187,800]],[[268569,420788],[-30,-2813]],[[268539,417975],[-1138,320]],[[214796,422133],[-1,-6444]],[[214795,415689],[6,-7987]],[[214801,407702],[-2099,-115]],[[212702,407587],[-2,8092],[66,8115]],[[212702,407587],[-979,-41]],[[211723,407546],[-1540,11]],[[210183,407557],[2,3232]],[[210185,410789],[2,4868]],[[249478,421591],[4,-3680]],[[249482,417911],[-1008,385],[-87,-647]],[[248387,417649],[-390,-863],[-421,-126],[-193,1285]],[[247383,417945],[433,1111]],[[273773,418601],[-955,197]],[[272818,418798],[-313,822]],[[258840,422592],[0,-2942]],[[258840,419650],[1,-653]],[[258841,418997],[-1263,-39]],[[257578,418958],[0,664]],[[291312,418205],[-380,169]],[[259900,422676],[1,-2968]],[[259901,419708],[-1061,-58]],[[274787,418606],[-454,480]],[[254118,413394],[-1462,-13]],[[252656,413381],[8,7493]],[[240416,422012],[-1,-5687]],[[240415,416325],[-1409,-77]],[[239006,416248],[-15,4342]],[[236624,418175],[-6,-1894]],[[236618,416281],[-1077,81]],[[235541,416362],[-1,1618]],[[260691,422697],[7,-5629]],[[260698,417068],[-1,-2446]],[[260697,414622],[-797,-40]],[[259900,414582],[1,5126]],[[261693,421341],[13,-4278]],[[261706,417063],[-1008,5]],[[256473,419631],[4,-4874]],[[256477,414757],[-917,-11]],[[255560,414746],[38,3259]],[[263884,419300],[17,-5165]],[[263901,414135],[-164,-21]],[[263737,414114],[-912,-29]],[[262825,414085],[5,1641]],[[262830,415726],[20,5678]],[[225321,422154],[-1,-6473]],[[225320,415681],[-642,-7]],[[224678,415674],[-618,2]],[[224060,415676],[-1,6479]],[[224060,415676],[-949,-1]],[[223111,415675],[-312,-4]],[[222799,415671],[-1,6489]],[[226583,422158],[-2,-6488]],[[226581,415670],[-307,0]],[[226274,415670],[-954,11]],[[216825,422158],[-7,-6476]],[[216818,415682],[-238,-3]],[[216580,415679],[-1785,10]],[[221541,422168],[6,-6502]],[[221547,415666],[-1531,-5]],[[220016,415661],[-44,2]],[[219972,415663],[-12,6485]],[[227843,422155],[-2,-6487]],[[227841,415668],[-1260,2]],[[229103,415660],[-1262,8]],[[219972,415663],[-1519,8]],[[218453,415671],[-56,3]],[[218397,415674],[1,6464]],[[218397,415674],[-1579,8]],[[222799,415671],[-1244,-5]],[[221555,415666],[-8,0]],[[241831,421268],[8,-4944]],[[241839,416324],[-1400,2]],[[240439,416326],[-24,-1]],[[284989,419873],[-135,-1158],[-365,-437],[-280,-1344]],[[284209,416934],[-135,-749],[-607,-656],[-188,-939]],[[283279,414590],[-400,4738]],[[250744,420882],[11,-4341]],[[250755,416541],[4,-2438],[-208,-17]],[[250551,414086],[-739,301],[-265,800]],[[249547,415187],[-65,2724]],[[281430,418706],[-459,-6339],[-226,-1900]],[[280745,410467],[-1192,6]],[[279553,410473],[143,1890],[-17,4331],[292,3460]],[[287729,418189],[-193,-523],[-134,-4476],[-402,-2750]],[[287000,410440],[-272,4]],[[286728,410444],[-19,0]],[[286709,410444],[-635,4132],[-197,2069],[-508,1252]],[[262830,415726],[-1089,-10]],[[261741,415716],[-35,1347]],[[242937,420420],[-5,-5730]],[[242932,414690],[-935,53]],[[241997,414743],[-158,1581]],[[283279,414590],[33,-4171]],[[283312,410419],[-28,0]],[[283284,410419],[-1756,39]],[[281528,410458],[270,1945],[385,4375]],[[279553,410473],[-342,-2]],[[279211,410471],[-1285,-23]],[[277926,410448],[-70,2461],[345,3475]],[[252342,420873],[-474,-4214]],[[251868,416659],[-1113,-118]],[[247383,417945],[-442,-2539]],[[246941,415406],[-262,-107],[-245,2264],[-607,13]],[[245827,417576],[4,1651]],[[252656,413381],[-30,-1626]],[[252626,411755],[-760,5]],[[251866,411760],[2,4899]],[[270140,418738],[-33,-4033],[-98,-688]],[[270009,414017],[-637,318]],[[269372,414335],[-891,173]],[[268481,414508],[58,3467]],[[266472,417707],[-35,-1886]],[[266437,415821],[-1449,559]],[[264988,416380],[37,2676]],[[239006,416248],[0,-1219]],[[239006,415029],[-1115,-150]],[[237891,414879],[-6,3227]],[[206434,415637],[-263,-1609]],[[206171,414028],[-698,-18]],[[205473,414010],[-2,411],[-773,-47]],[[231627,420500],[-1,-4856]],[[231626,415644],[-637,4]],[[230989,415648],[-625,3]],[[232903,420507],[433,-2548],[-67,-1277],[314,-1050]],[[233583,415632],[-88,0]],[[233495,415632],[-1249,8]],[[232246,415640],[-620,4]],[[234322,418054],[138,-4323]],[[234460,413731],[-255,-671],[-622,2572]],[[244178,419364],[30,-3036],[165,-1716]],[[244373,414612],[-1128,56]],[[243245,414668],[-313,22]],[[288510,412605],[38,24]],[[288548,412629],[-38,-24]],[[289158,416852],[-454,-2262],[-196,-1986]],[[288508,412604],[-541,-2144]],[[287967,410460],[-967,-20]],[[286709,410444],[-918,-3]],[[285791,410441],[-606,-7]],[[285185,410434],[-592,-13]],[[284593,410421],[124,2546],[-179,2927],[-329,1040]],[[200905,417336],[-779,-15],[-5,-3272],[-315,51],[0,-1663],[-1412,-63],[0,-2430],[-1717,-16],[1,-809],[-1384,192]],[[272795,414724],[-423,-10],[-218,-1046],[-319,59],[-5,-1091],[-317,66]],[[271513,412702],[-96,1662],[35,4100]],[[272818,418798],[-23,-4074]],[[259900,414582],[-209,-307]],[[259691,414275],[-842,-20]],[[258849,414255],[-8,4742]],[[257578,418958],[2,-4763]],[[257580,414195],[0,-1080]],[[257580,413115],[-876,35]],[[256704,413150],[-228,10],[1,1597]],[[245827,417576],[-8,-4829]],[[245819,412747],[1,-1636],[-1253,29]],[[244567,411140],[-193,1581],[-1,1891]],[[264988,416380],[-41,-2986]],[[264947,413394],[-298,808],[-748,-67]],[[274788,415938],[-600,318]],[[274188,416256],[87,2302]],[[291409,417105],[453,-5673],[-67,-3974]],[[291795,407458],[-8,-68]],[[291787,407390],[-674,1374],[-215,1839]],[[290898,410603],[-464,1138],[-81,1797],[-341,1920]],[[290012,415458],[-13,49]],[[289999,415507],[237,1029]],[[258849,414255],[-241,-37]],[[258608,414218],[-1028,-23]],[[274188,416256],[-53,-2244],[-194,-1196]],[[273941,412816],[-1155,355]],[[272786,413171],[9,1553]],[[292681,417934],[179,-419],[-159,-5398],[-46,2228],[-255,-3465],[103,-762],[-505,-2576],[-203,-84]],[[271513,412702],[-9,-1621]],[[271504,411081],[-1056,287]],[[270448,411368],[-261,927],[22,1648],[-200,74]],[[281528,410458],[-678,3]],[[280850,410461],[-105,6]],[[249547,415187],[-334,-14],[-10,-1089],[-815,-275]],[[248388,413809],[-1,3840]],[[161792,408143],[-202,-1300],[-433,-150],[-282,-3312],[-609,-862]],[[160266,402519],[-794,178]],[[159472,402697],[52,1462]],[[159524,404159],[106,2863],[-397,-48],[-8,2486],[153,591],[-290,1813]],[[255560,414746],[183,-1654],[-78,-4759]],[[255665,408333],[-417,-12]],[[255248,408321],[-3,5132]],[[277926,410448],[-234,-9]],[[277692,410439],[-800,-6]],[[276892,410433],[-426,0]],[[276466,410433],[-22,3775],[-205,1113]],[[268481,414508],[-116,-2693]],[[268365,411815],[-1169,326]],[[267196,412141],[-43,3579],[147,1917]],[[289999,415507],[-235,-1942],[-206,-351]],[[289558,413214],[-165,1989]],[[237891,414879],[8,-3256]],[[237899,411623],[-1244,80]],[[236655,411703],[-37,4578]],[[235541,416362],[8,-4089]],[[235549,412273],[-763,19]],[[234786,412292],[-326,1439]],[[181375,413882],[-2,-6763]],[[181373,407119],[-6,-16111]],[[181367,391008],[-2649,0]],[[178718,391008],[-2525,9020]],[[248388,413809],[0,-545]],[[248388,413264],[-1641,73]],[[246747,413337],[194,2069]],[[267196,412141],[-24,-2179]],[[267172,409962],[-1117,399]],[[266055,410361],[17,1045]],[[266072,411406],[162,-81],[203,4496]],[[246747,413337],[32,-697]],[[246779,412640],[-960,107]],[[200920,414122],[-228,4],[1,-10296]],[[200693,403830],[-885,2]],[[199808,403832],[-4513,9]],[[195295,403841],[-1,2439]],[[261741,415716],[-54,-4022]],[[261687,411694],[-224,-18]],[[261463,411676],[-823,-18]],[[260640,411658],[57,2964]],[[284593,410421],[-604,-5]],[[283989,410416],[-677,3]],[[289558,413214],[-576,-1173]],[[288982,412041],[-434,588]],[[288510,412605],[-2,-1]],[[251866,411760],[-181,-2586]],[[251685,409174],[-598,19]],[[251087,409193],[-316,20],[-8,2709],[-211,269]],[[250552,412191],[-1,1895]],[[206689,415638],[-255,-1611]],[[206434,414027],[-263,1]],[[241997,414743],[-31,-6459]],[[241966,408284],[-4,0]],[[241962,408284],[-1090,93]],[[240872,408377],[8,1624],[-470,45]],[[240410,410046],[29,6280]],[[266072,411406],[-502,924],[-631,518]],[[264939,412848],[8,546]],[[240410,410046],[-1140,67]],[[239270,410113],[-272,4],[8,4912]],[[236655,411703],[-1,-803]],[[236654,410900],[-1104,25]],[[235550,410925],[-1,1348]],[[274786,410447],[-874,-18]],[[273912,410429],[29,2387]],[[274787,414933],[-1,-4486]],[[276466,410433],[-1406,8]],[[275060,410441],[-274,6]],[[188080,412151],[154,-1357],[-372,-848],[15,-4365],[-94,-1439],[-489,-26],[-259,-1247]],[[187035,402869],[-501,282],[-67,4178],[-5094,-210]],[[262825,414085],[-5,-3543]],[[262820,410542],[-613,-224]],[[262207,410318],[-419,17],[-101,1359]],[[216580,415679],[-8,-8083]],[[216572,407596],[-1771,-3]],[[214801,407593],[0,109]],[[218453,415671],[-6,-8081]],[[218447,407590],[-1806,6]],[[216641,407596],[-69,0]],[[156605,411874],[135,-4012]],[[156740,407862],[1,-963],[-483,-512],[-37,-1772],[224,-3191],[-238,-1152],[-36,-1898],[296,-1404],[110,-1804],[361,-938]],[[156938,394228],[-728,41],[-164,-808],[-645,-63],[-455,-694]],[[154946,392704],[-541,2801],[109,2093],[-386,5926],[150,3428],[-35,2229],[-193,3367],[-469,3107]],[[226274,415670],[1,-6484]],[[226275,409186],[-1,-1617]],[[226274,407569],[-1548,10]],[[224726,407579],[-50,3]],[[224676,407582],[2,8092]],[[224676,407582],[-1502,8]],[[223174,407590],[-61,1]],[[223113,407591],[-2,8084]],[[227841,415668],[2,-6477]],[[227843,409191],[-1568,-5]],[[229411,415659],[-2,-8099]],[[229409,407560],[-425,-1]],[[228984,407559],[-1141,12]],[[227843,407571],[0,1620]],[[220016,415661],[-7,-8093]],[[220009,407568],[-1504,22]],[[218505,407590],[-58,0]],[[170987,398754],[-249,-368]],[[170738,398386],[-2476,18]],[[168262,398404],[-1,696],[-1014,5148],[112,6216],[-310,-1673]],[[221555,415666],[-7,-8087]],[[221548,407579],[-1487,-3]],[[220061,407576],[-52,-8]],[[223113,407591],[-1493,-14]],[[221620,407577],[-72,2]],[[230989,415648],[1,-8092]],[[230990,407556],[-955,2]],[[230035,407558],[-626,2]],[[210185,410789],[-3283,6]],[[206902,410795],[415,544],[-67,968],[390,100],[54,1353],[-365,-16],[-165,-1868],[-731,-134]],[[206433,411742],[1,2285]],[[233495,415632],[0,-6461]],[[233495,409171],[-625,0]],[[232870,409171],[-626,1]],[[232244,409172],[2,6468]],[[232244,409172],[-1,-1611],[-687,-7]],[[231556,407554],[-566,2]],[[234786,412292],[-21,-1747],[-200,349],[-276,-2271]],[[234289,408623],[-168,540],[-626,8]],[[290898,410603],[-392,-2264]],[[290506,408339],[-409,2275],[-302,2865]],[[289795,413479],[217,1979]],[[250552,412191],[-498,-1356],[-386,-1884],[4,-2170]],[[249672,406781],[-468,-23]],[[249204,406758],[-626,-24]],[[248578,406734],[-164,3649],[-26,2881]],[[239270,410113],[-31,-1637]],[[239239,408476],[-1338,-79]],[[237901,408397],[-2,3226]],[[243245,414668],[-18,-5394]],[[243227,409274],[-942,82],[-5,-1095],[-314,23]],[[256704,413150],[-10,-4876]],[[256694,408274],[-518,44]],[[256176,408318],[-511,15]],[[272786,413171],[-213,31],[-15,-3018],[100,-1891]],[[272658,408293],[-850,-351]],[[271808,407942],[-304,3139]],[[244567,411140],[169,-1392]],[[244736,409748],[-1143,47],[1,-537]],[[243594,409258],[-367,16]],[[260640,411658],[-101,-1640]],[[260539,410018],[-888,-25]],[[259651,409993],[40,4282]],[[269372,414335],[-25,-1734],[207,-77],[64,-3316]],[[269618,409208],[-318,123],[-21,-1093],[-338,107],[-318,-1008]],[[268623,407337],[-310,141],[52,4337]],[[205473,414010],[-1,-3087]],[[205472,410923],[-407,495],[-407,1458]],[[270448,411368],[146,-862],[-65,-3237]],[[270529,407269],[-311,107]],[[270218,407376],[-615,748],[15,1084]],[[259651,409993],[-1,-1094]],[[259650,408899],[-829,-88]],[[258821,408811],[-213,-27]],[[258608,408784],[0,5434]],[[202584,414234],[137,-2937],[562,-2151],[-209,-2932],[145,-2132]],[[203219,404082],[-612,-330]],[[202607,403752],[-1914,78]],[[204005,410027],[367,-1170],[-102,-1326]],[[204270,407531],[-525,-3718],[-328,268]],[[203417,404081],[-198,1]],[[258608,408784],[-389,-585],[-532,8]],[[257687,408207],[-86,542],[-21,4366]],[[264939,412848],[-109,-226],[-59,-4847]],[[264771,407775],[-700,214]],[[264071,407989],[-317,29]],[[263754,408018],[-17,6096]],[[263754,408018],[1,-414],[-936,-23]],[[262819,407581],[1,2961]],[[206433,411742],[-1,-3288]],[[206432,408454],[13,-902]],[[206445,407552],[-516,-5958],[-264,-2165]],[[205665,399429],[-5,0]],[[205660,399429],[-187,-2],[-3,8128]],[[205470,407555],[2,3368]],[[206902,410795],[-80,-2162],[-167,812],[-223,-991]],[[290506,408339],[-301,-1740]],[[290205,406599],[-214,1002]],[[289991,407601],[-385,1832],[-352,446],[-281,1742]],[[288973,411621],[822,1858]],[[255248,408321],[1,-2424]],[[255249,405897],[-1194,78]],[[254055,405975],[-17,3810]],[[254038,409785],[80,3609]],[[254038,409785],[-270,-622],[-1139,-18]],[[252629,409145],[-3,2610]],[[248578,406734],[-634,-33]],[[247944,406701],[-412,-2]],[[247532,406699],[3,2166],[-202,555],[5,1620],[-635,683]],[[246703,411723],[76,917]],[[273912,410429],[-309,-2118]],[[273603,408311],[-264,-1244]],[[273339,407067],[6,599],[-687,627]],[[257687,408207],[-84,-2441]],[[257603,405766],[-705,61]],[[256898,405827],[-209,8],[5,2439]],[[205470,407555],[-1200,-24]],[[266055,410361],[-47,-3102]],[[266008,407259],[-855,352]],[[265153,407611],[-382,164]],[[246703,411723],[-131,-1726],[182,-3269]],[[246754,406728],[-91,-2345]],[[246663,404383],[-901,73]],[[245762,404456],[-253,772],[-419,2923]],[[245090,408151],[-354,1597]],[[288652,406259],[12,7]],[[288664,406266],[-12,-7]],[[288613,408309],[-8,431]],[[288605,408740],[8,-431]],[[288982,412041],[-534,-3559],[147,-1016],[-73,-1880],[204,-1804]],[[288726,403782],[-376,-1333],[-304,88]],[[288046,402537],[-18,1506]],[[288028,404043],[-61,6417]],[[251087,409193],[1,-5735],[-319,52]],[[250769,403510],[-1089,3],[-8,3268]],[[235550,410925],[3,-4036]],[[235553,406889],[-1398,55]],[[234155,406944],[134,1679]],[[192584,405746],[-2935,11],[-153,2687],[-321,1687]],[[189175,410131],[0,2024]],[[189175,410131],[1,-4419],[-151,2],[5,-8099]],[[189030,397615],[-1544,14],[-447,229]],[[187039,397858],[-4,5011]],[[268623,407337],[-26,-1603]],[[268597,405734],[-717,218],[40,495],[-788,179]],[[267132,406626],[40,3336]],[[159524,404159],[-693,578],[2,-532],[-1674,-52]],[[157159,404153],[10,3692],[-429,17]],[[252629,409145],[5,-3808]],[[252634,405337],[-317,9],[-372,2453],[-255,17],[-5,1358]],[[262207,410318],[-5,-3507]],[[262202,406811],[-729,-13]],[[261473,406798],[-10,4878]],[[261473,406798],[1,-1345]],[[261474,405453],[-925,-9]],[[260549,405444],[-10,4574]],[[247532,406699],[-778,29]],[[237901,408397],[-2,-1616]],[[237899,406781],[-1252,49]],[[236647,406830],[7,4070]],[[289029,404123],[-16,44]],[[289013,404167],[16,-44]],[[289991,407601],[-61,-2065],[-434,1889],[-494,-3193]],[[289002,404232],[-350,2027]],[[288664,406266],[-51,2043]],[[288605,408740],[368,2881]],[[164781,405356],[-1401,-15],[-152,1284],[-273,169],[-234,-1182],[-772,-1245]],[[161949,404367],[29,4517]],[[271808,407942],[-352,-103],[16,-1873],[-379,-570]],[[271093,405396],[-587,184],[23,1689]],[[236647,406830],[-6,-1350]],[[236641,405480],[-1087,27]],[[235554,405507],[-1,1382]],[[210183,407557],[-20,1]],[[210163,407558],[-2636,-8]],[[207527,407550],[-1082,2]],[[168262,398404],[-491,-22],[-237,-2422],[1,-1714],[314,16],[-14,-8144],[-697,1]],[[167138,386119],[-481,2256]],[[166657,388375],[-56,3727],[-157,-51],[-41,4121],[307,670],[-3,1729],[-666,41]],[[166041,398612],[-32,2040],[-419,1033]],[[165590,401685],[652,1617],[544,5284]],[[291787,407390],[22,-3591],[-686,-1401]],[[291123,402398],[-572,644]],[[290551,403042],[14,1877],[-360,1680]],[[262819,407581],[-2,-849]],[[262817,406732],[-615,79]],[[283284,410419],[-281,-1862],[-298,-5500]],[[282705,403057],[-115,-74]],[[282590,402983],[-298,3218]],[[282292,406201],[-167,1077],[132,1025],[-513,247]],[[281744,408550],[-440,1436],[-237,-1383],[-192,274]],[[280875,408877],[-25,1584]],[[280875,408877],[-278,-307],[-96,-1936]],[[280501,406634],[-526,344]],[[279975,406978],[-386,1376],[-475,-3170],[-283,768]],[[278831,405952],[380,4519]],[[278831,405952],[-568,-2832]],[[278263,403120],[-600,-2269]],[[277663,400851],[29,9588]],[[288028,404043],[-186,-68]],[[287842,403975],[-578,293],[198,3147],[-296,-282]],[[287166,407133],[-438,3311]],[[276892,410433],[-365,-5307]],[[276527,405126],[-123,314]],[[276404,405440],[-598,2940],[-675,502]],[[275131,408882],[-71,1559]],[[277663,400851],[0,-206]],[[277663,400645],[-557,1423],[-342,-760]],[[276764,401308],[-239,1284]],[[276525,402592],[2,2534]],[[287166,407133],[-74,-2015],[-419,-1266],[83,1880],[-379,-1384]],[[286377,404348],[-194,1933],[-292,888],[-100,3272]],[[275131,408882],[-285,-1378],[11,-1745]],[[274857,405759],[-140,-754]],[[274717,405005],[-207,396]],[[274510,405401],[-283,562],[-368,2260],[-256,88]],[[286377,404348],[69,-1032],[-251,-2456],[-293,639]],[[285902,401499],[0,2434],[-506,6],[2,-1756],[256,-748]],[[285654,401435],[-221,-442]],[[285433,400993],[-513,2542]],[[284920,403535],[-27,1753],[292,5146]],[[284920,403535],[-797,69]],[[284123,403604],[171,2562],[-558,2377],[253,1873]],[[284123,403604],[-2,-8]],[[284121,403596],[-805,-2420]],[[283316,401176],[-301,1527],[-310,354]],[[267132,406626],[-296,-2586]],[[266836,404040],[-607,26]],[[266229,404066],[40,3087],[-261,106]],[[192583,405610],[37,-824],[-294,-4892],[-129,-5401],[227,-2018],[156,-4769]],[[192580,387706],[-3568,0],[0,190]],[[189012,387896],[18,9719]],[[240872,408377],[-43,-5375]],[[240829,403002],[-231,409],[-164,-2185]],[[240434,401226],[-711,2931]],[[239723,404157],[-346,980],[-138,3339]],[[260549,405444],[-153,-1912]],[[260396,403532],[-746,-50]],[[259650,403482],[0,5417]],[[281744,408550],[-325,-479],[-251,-3773]],[[281168,404298],[-330,1392]],[[280838,405690],[-337,944]],[[245090,408151],[-786,-2744],[61,-2459]],[[244365,402948],[-779,380]],[[243586,403328],[8,5930]],[[254055,405975],[-144,-1905]],[[253911,404070],[-1278,-83]],[[252633,403987],[1,1350]],[[243586,403328],[-1650,162]],[[241936,403490],[26,4794]],[[270218,407376],[-23,-1680],[-315,123],[-26,-1652]],[[269854,404167],[-626,216],[-9,-490],[-644,-24]],[[268575,403869],[22,1865]],[[227843,407571],[-4,-4859]],[[227839,402712],[-1559,8]],[[226280,402720],[-6,4849]],[[232870,409171],[-17,-4355]],[[232853,404816],[-53,-3775]],[[232800,401041],[-1243,5]],[[231557,401046],[-1,6508]],[[234155,406944],[373,-2131]],[[234528,404813],[-590,6]],[[233938,404819],[-1085,-3]],[[252633,403987],[0,-2969]],[[252633,401018],[-933,23]],[[251700,401041],[-932,31]],[[250768,401072],[1,2438]],[[279975,406978],[-539,-3797],[-360,-1740]],[[279076,401441],[-431,1393],[-382,286]],[[273339,407067],[-230,-1522]],[[273109,405545],[-695,-2160]],[[272414,403385],[-195,1248],[-314,-1222],[-55,-1446],[-293,114],[-131,-1044]],[[271426,401035],[10,998],[-367,905],[24,2458]],[[276404,405440],[-240,-950],[-479,-155]],[[275685,404335],[-828,1424]],[[259650,403482],[-372,-60]],[[259278,403422],[-462,-46]],[[258816,403376],[5,5435]],[[161949,404367],[-299,-279],[-425,-2782],[0,-3647]],[[161225,397659],[-377,-706]],[[160848,396953],[-363,-449],[-90,-982],[-129,6997]],[[258816,403376],[-362,-36]],[[258454,403340],[-695,149]],[[257759,403489],[-4,2280],[-152,-3]],[[282292,406201],[-394,-2354],[-185,-1907]],[[281713,401940],[-545,2358]],[[239723,404157],[-203,523],[-147,-1561],[-300,-405],[-194,-1442],[-195,1194]],[[238684,402466],[-29,-1190],[-453,360],[-301,-767]],[[237901,400869],[-2,5912]],[[241936,403490],[-12,-1887]],[[241924,401603],[-322,44]],[[241602,401647],[-773,1355]],[[256176,408318],[-109,-1613],[-6,-4868]],[[256061,401837],[-1014,8]],[[255047,401845],[202,1649],[0,2403]],[[256898,405827],[-7,-2442],[-310,8],[-2,-3249]],[[256579,400144],[-519,69]],[[256060,400213],[1,1624]],[[274510,405401],[-752,-2906]],[[273758,402495],[-136,1718],[-196,-664]],[[273426,403549],[-49,2100],[-268,-104]],[[246361,401187],[-1284,58],[-7,-1638],[-209,11]],[[244861,399618],[-414,50]],[[244447,399668],[-82,3280]],[[245762,404456],[468,-1904],[131,-1365]],[[264071,407989],[93,-711],[-59,-4822]],[[264105,402456],[-1299,241]],[[262806,402697],[11,4035]],[[265153,407611],[-83,-5848]],[[265070,401763],[-704,293]],[[264366,402056],[-261,400]],[[157159,404153],[-102,-1293],[315,-1811],[516,-796],[-42,-2231],[424,-2417]],[[158270,395605],[-153,-1117]],[[158117,394488],[-192,-2961],[-455,-702]],[[157470,390825],[-532,3403]],[[214801,407593],[7,-8099]],[[214808,399494],[2,-1604]],[[214810,397890],[-3111,-175]],[[211699,397715],[24,9831]],[[289145,403438],[-116,685]],[[289013,404167],[-11,65]],[[290551,403042],[-150,-2724]],[[290401,400318],[-713,1073],[-543,2047]],[[223174,407590],[-9,-8099]],[[223165,399491],[-1516,-10]],[[221649,399481],[-38,0]],[[221611,399481],[9,8096]],[[265463,401619],[-346,126]],[[265117,401745],[-47,18]],[[266229,404066],[-541,-2162],[-225,-285]],[[216641,407596],[-7,-8066]],[[216634,399530],[-241,-6]],[[216393,399524],[-1585,-30]],[[218505,407590],[-3,-8092]],[[218502,399498],[-252,0]],[[218250,399498],[-1616,32]],[[224726,407579],[-8,-6473]],[[224718,401106],[0,-1621]],[[224718,399485],[-1525,8]],[[223193,399493],[-28,-2]],[[220061,407576],[-7,-8104]],[[220054,399472],[-1552,26]],[[228984,407559],[-7,-6447]],[[228977,401112],[-5,-1634]],[[228972,399478],[-1136,-7]],[[227836,399471],[3,3241]],[[226280,402720],[-2,-1625]],[[226278,401095],[-1560,11]],[[221611,399481],[-1512,-5]],[[220099,399476],[-45,-4]],[[230035,407558],[-404,-3029],[469,-4113],[472,-186]],[[230572,400230],[-5,-2410],[-307,8]],[[230260,397828],[0,542],[-974,290],[4,2434],[-313,18]],[[207527,407550],[-7,-8123]],[[207520,399427],[-1032,5]],[[206488,399432],[-823,-3]],[[210163,407558],[-15,-13022],[-936,36]],[[209212,394572],[12,4831],[-1704,24]],[[231557,401046],[-18,-1625]],[[231539,399421],[-119,1201],[-442,280],[-406,-672]],[[211699,397715],[-28,-7915]],[[211671,389800],[1,-1622],[-925,-166]],[[210747,388012],[-1530,111]],[[209217,388123],[-5,6449]],[[205660,399429],[4,-8051]],[[205664,391378],[-1785,-68]],[[203879,391310],[176,2110],[-338,2531],[-236,-28],[-218,2136]],[[203263,398059],[20,4732],[134,1290]],[[271426,401035],[-87,-662]],[[271339,400373],[-1426,435]],[[269913,400808],[-59,3359]],[[187039,397858],[-587,-3354],[17,-2559],[-254,-958],[-384,92],[-188,-2026]],[[185643,389053],[-4276,11]],[[181367,389064],[0,1944]],[[280838,405690],[20,-2092],[-220,-1798],[43,-1668],[-291,-1467]],[[280390,398665],[-1091,2059],[-223,717]],[[235554,405507],[-2,-5521]],[[235552,399986],[-482,732]],[[235070,400718],[-348,1876],[57,1415],[-251,804]],[[262806,402697],[-686,37]],[[262120,402734],[-425,21],[-218,-745]],[[261477,402010],[-3,3443]],[[237901,400869],[-183,146],[-782,-1329]],[[236936,399686],[-300,1184]],[[236636,400870],[5,4610]],[[250768,401072],[-307,-8],[0,-3525]],[[250461,397539],[-935,2],[-151,-542]],[[249375,396999],[-163,-3]],[[249212,396996],[-8,9762]],[[249212,396996],[-1246,20]],[[247966,397016],[-6,4876]],[[247960,401892],[-16,4809]],[[164769,402898],[-1778,-16],[-231,-508],[-693,-3277],[-169,-1785],[-673,347]],[[247960,401892],[-463,-687],[1,-945],[-743,197],[-64,-1253]],[[246691,399204],[-28,5179]],[[268575,403869],[-39,-2983]],[[268536,400886],[-64,-729]],[[268472,400157],[-1582,536]],[[266890,400693],[-54,3347]],[[282590,402983],[-306,-3505]],[[282284,399478],[-571,2462]],[[195295,403841],[-25,-16135]],[[195270,387706],[-2690,0]],[[255047,401845],[-68,-1899]],[[254979,399946],[-896,325]],[[254083,400271],[-160,-18]],[[253923,400253],[-12,3817]],[[273426,403549],[-646,-1537]],[[272780,402012],[-366,1373]],[[257759,403489],[-152,-219],[7,-3170]],[[257614,400100],[-1035,44]],[[275685,404335],[85,-2808]],[[275770,401527],[-169,-2411]],[[275601,399116],[-203,-165]],[[275398,398951],[-825,1176]],[[274573,400127],[195,794],[-216,1514],[165,2570]],[[281713,401940],[-331,-4250]],[[281382,397690],[-453,-529]],[[280929,397161],[-54,1696],[-336,-1326],[-249,538]],[[280290,398069],[100,596]],[[281262,400644],[0,0]],[[236636,400870],[-257,453],[-437,-2067],[-406,-129]],[[235536,399127],[16,859]],[[261477,402010],[-400,-1353]],[[261077,400657],[-346,-1150],[-342,-60]],[[260389,399447],[7,4085]],[[276525,402592],[-354,-957],[-401,-108]],[[274573,400127],[-368,-1329]],[[274205,398798],[-236,255]],[[273969,399053],[-281,3045],[70,397]],[[233938,404819],[-17,-6983]],[[233921,397836],[-873,234]],[[233048,398070],[-272,169],[24,2802]],[[235070,400718],[-349,74],[-25,-3937]],[[234696,396855],[-411,-173]],[[234285,396682],[-361,-327],[-3,1481]],[[159472,402697],[-103,-2316],[298,-2192],[10,-2579]],[[159677,395610],[-1407,-5]],[[240434,401226],[-265,-1911],[27,-1099]],[[240196,398216],[-322,-2537]],[[239874,395679],[-1243,272]],[[238631,395951],[53,6515]],[[272780,402012],[-162,-1544]],[[272618,400468],[-357,-942],[-433,-2022]],[[271828,397504],[-465,1316]],[[271363,398820],[-24,1553]],[[246691,399204],[104,-2426],[318,-370]],[[247113,396408],[-268,-1766],[-327,1147]],[[246518,395789],[-157,5398]],[[269913,400808],[-106,32],[-45,-3310]],[[269762,397530],[-314,138]],[[269448,397668],[30,1912],[-311,800],[-631,506]],[[273969,399053],[-615,-1858]],[[273354,397195],[-359,391]],[[272995,397586],[-242,75],[-135,2807]],[[288046,402537],[11,-941]],[[288057,401596],[-639,-5]],[[287418,401591],[-372,-2533],[-163,577],[-139,-1618],[-138,1747],[461,4160],[775,51]],[[203263,398059],[-1078,34]],[[202185,398093],[231,2578],[24,2142],[167,939]],[[253923,400253],[-983,-52]],[[252940,400201],[-307,817]],[[266890,400693],[-89,-2651]],[[266801,398042],[-801,-647]],[[266000,397395],[-555,16],[18,4208]],[[285892,400881],[-123,-38]],[[285769,400843],[123,38]],[[285902,401499],[-150,-621]],[[285752,400878],[-98,557]],[[285433,400993],[-397,-2058]],[[285036,398935],[-134,518]],[[284902,399453],[-167,-26],[-614,4169]],[[199808,403832],[102,-2045]],[[199910,401787],[-296,-715]],[[199614,401072],[-738,-3251],[-270,662],[-334,-353],[-440,-2814],[-665,-1481],[1,-2999]],[[197168,390836],[-2,-3130],[-1896,0]],[[202185,398093],[-59,-1116]],[[202126,396977],[-415,808],[-150,-1174],[-541,1040],[-198,1576],[-600,-2],[-312,2562]],[[289289,396094],[-480,-882],[-190,-1250],[-469,-136]],[[288150,393826],[-70,5854]],[[288080,399680],[-23,1916]],[[288726,403782],[311,-1994],[21,-3695],[231,-1999]],[[258454,403340],[32,-5425],[144,8]],[[258630,397923],[2,-1078]],[[258632,396845],[-1016,28]],[[257616,396873],[-2,3227]],[[260389,399447],[-315,-33],[3,-1128]],[[260077,398286],[-173,-511],[-611,176]],[[259293,397951],[-15,5471]],[[244447,399668],[-615,99],[-12,-1653]],[[243820,398114],[-1327,96]],[[242493,398210],[15,3270],[-584,123]],[[284902,399453],[-317,-3074]],[[284585,396379],[-327,-587]],[[284258,395792],[-575,2284]],[[283683,398076],[-376,336],[-185,1328],[194,1436]],[[259293,397951],[-663,-28]],[[241246,396474],[-791,165],[-259,1577]],[[241602,401647],[-356,-5173]],[[279076,401441],[-306,-3713],[122,-2044],[-246,-2142]],[[278646,393542],[-601,2684]],[[278045,396226],[-22,130]],[[278023,396356],[164,2029],[-157,242],[174,1961],[-541,57]],[[291123,402398],[69,-688],[-433,-4686],[-217,-1125],[-299,-2],[197,2821],[-39,1600]],[[283683,398076],[-584,-3904]],[[283099,394172],[-333,1775]],[[282766,395947],[-855,1322]],[[281911,397269],[373,2209]],[[164778,400098],[2,-985]],[[164780,399113],[3,-842]],[[164783,398271],[-389,10],[-272,-829],[-495,64],[-430,-2100],[-547,1773],[-795,-2035],[-254,-3501]],[[161601,391653],[-949,430]],[[160652,392083],[47,3550],[149,1320]],[[264366,402056],[-167,-4639]],[[264199,397417],[-520,1367]],[[263679,398784],[-327,-385]],[[263352,398399],[-336,1361],[-212,-782]],[[262804,398978],[2,3719]],[[262120,402734],[-186,-6686]],[[261934,396048],[-10,-344]],[[261924,395704],[-187,-294]],[[261737,395410],[-674,-15]],[[261063,395395],[14,5262]],[[262804,398978],[-161,-1387]],[[262643,397591],[-709,-1543]],[[227836,399471],[-2,-3241]],[[227834,396230],[-1551,10]],[[226283,396240],[-5,4855]],[[160652,392083],[-329,7]],[[160323,392090],[-249,594],[-92,1588],[-305,1338]],[[276764,401308],[-43,-2135]],[[276721,399173],[-197,-2651],[-527,-488]],[[275997,396034],[78,1670],[-474,1412]],[[238631,395951],[-2,-269]],[[238629,395682],[-940,177],[-5,-541],[-774,157]],[[236910,395475],[26,4211]],[[278023,396356],[-421,199],[-771,1158],[-110,1460]],[[264942,392757],[-495,1045]],[[264447,393802],[-4,881]],[[264443,394683],[-244,2734]],[[265117,401745],[-175,-8988]],[[281911,397269],[-117,-636]],[[281794,396633],[-412,1057]],[[247966,397016],[-356,-13],[-6,-1412]],[[247604,395591],[-491,817]],[[286601,396690],[-270,-2438],[180,3428],[90,-990]],[[288080,399680],[-243,-644],[-318,-3542]],[[287519,395494],[-452,119]],[[287067,395613],[-237,-813],[-18,1649],[166,2200],[440,2942]],[[256060,400213],[0,-4914]],[[256060,395299],[-786,-99]],[[255274,395200],[-295,4746]],[[202126,396977],[391,-1636],[384,-265],[-241,-1240],[-125,-2429],[202,-1122],[71,-1957],[299,-2059]],[[203107,386269],[-2100,53],[-1,-5186]],[[201006,381136],[-1581,2]],[[199425,381138],[-185,2880]],[[199240,384018],[376,1],[-2,6825]],[[199614,390844],[0,10228]],[[266000,397395],[-90,-7128]],[[265910,390267],[-554,2429]],[[265356,392696],[-414,61]],[[242493,398210],[-120,-2235],[32,-2529],[-220,-3074]],[[242185,390372],[-394,741],[-91,1045]],[[241700,392158],[-288,3406]],[[241412,395564],[-166,910]],[[166041,398612],[-586,525],[-675,-24]],[[280290,398069],[-483,-2836],[-192,-318],[-231,-2313]],[[279384,392602],[-347,1620],[-177,-1640]],[[278860,392582],[-214,960]],[[286072,395357],[-240,-2629],[72,-1051]],[[285904,391677],[-438,652]],[[285466,392329],[40,2579],[-96,1946],[-374,2081]],[[285752,400878],[17,-35]],[[285892,400881],[302,-2196],[-274,-289],[359,-1162],[-228,-562],[21,-1315]],[[236910,395475],[-14,-1566]],[[236896,393909],[-1362,261]],[[235534,394170],[2,3666]],[[235536,397836],[0,1291]],[[246518,395789],[-459,-1048],[-357,-130]],[[245702,394611],[-426,37],[-426,2232]],[[244850,396880],[11,2738]],[[230260,397828],[-2,-3239]],[[230258,394589],[-1082,7]],[[229176,394596],[-204,1767],[0,3115]],[[199614,390844],[-2446,-8]],[[226283,396240],[-1,-1625]],[[226282,394615],[-1549,-6]],[[224733,394609],[-15,4876]],[[233048,398070],[-1,-3479]],[[233047,394591],[-1242,3]],[[231805,394594],[-1,4258],[-265,569]],[[251700,401041],[-3,-5671],[315,56]],[[252012,395426],[-4,-1645]],[[252008,393781],[-1234,-54],[-1,-1621]],[[250773,392106],[-323,106]],[[250450,392212],[11,5327]],[[252940,400201],[-3,-4846]],[[252937,395355],[-925,71]],[[231805,394594],[2,-2436]],[[231807,392158],[-1134,-2]],[[230673,392156],[-105,1611],[-310,822]],[[269448,397668],[-55,-3547],[-336,-2]],[[269057,394119],[-207,86]],[[268850,394205],[-308,108],[-130,1735]],[[268412,396048],[60,4109]],[[270916,394754],[20,1086],[-281,1702],[-269,-1234]],[[270386,396308],[9,758],[-633,464]],[[271363,398820],[-98,-3219],[-349,-847]],[[235536,397836],[-739,279],[-101,-1260]],[[268412,396048],[-1128,225],[-164,1036]],[[267120,397309],[-319,733]],[[261063,395395],[-665,-1817]],[[260398,393578],[-311,-147]],[[260087,393431],[-10,4855]],[[272995,397586],[-322,-2153]],[[272673,395433],[-626,51]],[[272047,395484],[-219,2020]],[[255274,395200],[-23,-931]],[[255251,394269],[-1050,-45]],[[254201,394224],[-106,0]],[[254095,394224],[-12,6047]],[[254095,394224],[-871,-48]],[[253224,394176],[-287,83],[0,1096]],[[257616,396873],[-2,-1632]],[[257614,395241],[-617,-10]],[[256997,395231],[-542,-4]],[[256455,395227],[-395,72]],[[275398,398951],[-49,-2704],[-193,-1561],[-17,-2747]],[[275139,391939],[-179,223]],[[274960,392162],[-177,2250],[-237,820]],[[274546,395232],[-309,1941],[-32,1625]],[[178718,391008],[0,-11659],[-2488,-10],[-9,-22497]],[[176221,356842],[9,-15661]],[[176230,341181],[-3544,18062]],[[172686,359243],[1,19187],[-1464,8789]],[[171223,387219],[-1407,8282],[-1,1512],[923,1373]],[[244850,396880],[-2,-2773],[-420,28],[-8,-2523]],[[244420,391612],[-356,-627],[-262,515]],[[243802,391500],[-19,-7]],[[243783,391493],[37,6621]],[[263352,398399],[22,-5065]],[[263374,393334],[-124,-465]],[[263250,392869],[-377,1491]],[[262873,394360],[-210,810]],[[262663,395170],[-20,2421]],[[288150,393826],[43,-3599]],[[288193,390227],[-151,927],[-491,-152]],[[287551,391002],[-166,1427],[180,785]],[[287565,393214],[-46,2280]],[[218250,399498],[-19,-8071]],[[218231,391427],[-863,14]],[[217368,391441],[-992,-7]],[[216376,391434],[17,8090]],[[216376,391434],[-231,-10]],[[216145,391424],[-1332,-40]],[[214813,391384],[-3,6506]],[[223193,399493],[-14,-8123]],[[223179,391370],[-1512,-4]],[[221667,391366],[-36,-1]],[[221631,391365],[18,8116]],[[220099,399476],[-16,-8096]],[[220083,391380],[-260,16]],[[219823,391396],[-1228,34]],[[218595,391430],[-364,-3]],[[229176,394596],[-104,-1078],[-8,-3776]],[[229064,389742],[-1230,0]],[[227834,389742],[0,6488]],[[224733,394609],[-4,-3237]],[[224729,391372],[-1523,-3]],[[223206,391369],[-27,1]],[[221631,391365],[-1548,15]],[[285466,392329],[-31,-1557]],[[285435,390772],[-7,-2276]],[[285428,388496],[-134,1401],[-606,810],[-230,-838],[-81,1376]],[[284377,391245],[169,2220]],[[284546,393465],[298,1555],[-259,1359]],[[206488,399432],[13,-4858],[-121,-1294],[371,-47],[-10,-2736]],[[206741,390497],[-830,-43],[-247,924]],[[209217,388123],[-2473,-52]],[[206744,388071],[-3,2426]],[[264443,394683],[-524,-1279]],[[263919,393404],[-110,900],[24,2588],[-154,1892]],[[278045,396226],[-294,-514],[-232,-1659],[80,-1120],[-325,-2167]],[[277274,390766],[-416,1407],[-243,-3512],[-463,-1712],[-244,275],[-358,-1592]],[[275550,385632],[171,2537],[-267,3167]],[[275454,391336],[428,949],[115,3749]],[[166657,388375],[-699,3239]],[[165958,391614],[-902,4160]],[[165056,395774],[-269,1239],[-4,1258]],[[275454,391336],[-315,603]],[[274546,395232],[-268,-471],[-788,-2996]],[[273490,391765],[-200,1393],[150,994],[-86,3043]],[[280929,397161],[39,-1198],[-240,-2110]],[[280728,393853],[-452,-1704],[-259,-2493]],[[280017,389656],[-633,2946]],[[263919,393404],[-308,-258]],[[263611,393146],[-237,188]],[[272047,395484],[-122,-4567],[68,-1110]],[[271993,389807],[-308,-1085],[-178,1340]],[[271507,390062],[-213,1013]],[[271294,391075],[-378,3679]],[[171223,387219],[-1840,-10800],[-214,47]],[[169169,376466],[-2031,9653]],[[260087,393431],[-260,-1361]],[[259827,392070],[-266,627],[-811,-80]],[[258750,392617],[-16,4231],[-102,-3]],[[234285,396682],[0,-4534]],[[234285,392148],[-1238,4]],[[233047,392152],[0,2439]],[[165056,395774],[67,-1277],[-535,-3016]],[[164588,391481],[-682,-2964],[-866,-752],[-371,962],[-735,-860]],[[161934,387867],[-256,3852],[-77,-66]],[[243783,391493],[-601,-672],[-237,-1354]],[[242945,389467],[-301,-675],[-459,1580]],[[241412,395564],[-331,-4506],[-621,73]],[[240460,391131],[-613,170]],[[239847,391301],[27,4378]],[[284258,395792],[-146,-763]],[[284112,395029],[62,-330]],[[284174,394699],[109,-599]],[[284283,394100],[166,-999]],[[284449,393101],[22,-1315],[-319,-1468],[-235,541]],[[283917,390859],[-818,3313]],[[283747,394572],[0,0]],[[283737,394153],[0,0]],[[203879,391310],[232,-1351],[-62,-2148],[-284,-1101]],[[203765,386710],[-658,-441]],[[235534,394170],[-3,-2031]],[[235531,392139],[-1246,9]],[[267120,397309],[10,-7398]],[[267130,389911],[-689,1521],[-363,-1183]],[[266078,390249],[-168,18]],[[189012,387896],[-1284,-153]],[[187728,387743],[-2094,147]],[[185634,387890],[9,1163]],[[214813,391384],[1,-1534]],[[214814,389850],[-3143,-50]],[[273490,391765],[-131,-932]],[[273359,390833],[-145,-1040]],[[273214,389793],[-209,605],[-29,1581],[-303,3454]],[[281794,396633],[-352,-2134]],[[281442,394499],[-181,-1569],[-249,-398]],[[281012,392532],[-284,1321]],[[270386,396308],[-126,-2312],[-210,-922],[124,-3421],[-112,-240]],[[270062,389413],[-201,-166]],[[269861,389247],[-208,45],[20,1692],[-328,120],[-31,1671],[-276,127],[19,1217]],[[262663,395170],[-751,43],[12,491]],[[271294,391075],[-509,-437],[-303,-920],[26,-2484]],[[270508,387234],[-446,2179]],[[250450,392212],[-956,23]],[[249494,392235],[-119,4764]],[[268850,394205],[-252,-4690],[-210,-491]],[[268388,389024],[-201,3414],[-398,-532]],[[267789,391906],[-350,-1992],[-309,-3]],[[282766,395947],[-168,-2056],[513,-5136]],[[283111,388755],[-288,-2729]],[[282823,386026],[-280,59],[-558,5268]],[[281985,391353],[-543,3146]],[[249494,392235],[6,-1626],[-311,-14]],[[249189,390595],[-1322,102]],[[247867,390697],[42,2085]],[[247909,392782],[135,616]],[[248044,393398],[7,862],[-447,1331]],[[245702,394611],[-17,-6019]],[[245685,388592],[-299,1157],[-435,348],[-393,1320]],[[244558,391417],[-138,195]],[[284546,393465],[-223,1828]],[[284323,395293],[-65,499]],[[258750,392617],[-93,-1409]],[[258657,391208],[-1043,-28]],[[257614,391180],[0,4061]],[[248044,393398],[-494,1528],[-406,-1104],[-259,-2536],[-553,-983]],[[246332,390303],[-514,-1949],[-133,238]],[[289289,396094],[351,-2735],[270,-53],[-16,-3322],[132,-3185]],[[290026,386799],[-57,0]],[[289969,386799],[-44,0]],[[289925,386799],[-712,13]],[[289213,386812],[-982,152],[-22,1873]],[[288209,388837],[-16,1390]],[[227834,389742],[-1541,10]],[[226293,389752],[-11,4863]],[[278860,392582],[-466,-5288]],[[278394,387294],[-254,-1223]],[[278140,386071],[-449,839],[-166,1724],[-310,767]],[[277215,389401],[59,1365]],[[239847,391301],[-20,-3034]],[[239827,388267],[-622,98],[-4,-541],[-615,115]],[[238586,387939],[4,814]],[[238590,388753],[39,6929]],[[287565,393214],[-230,-1317],[167,-933],[-195,-1782],[-402,1980],[-480,1174],[215,1899],[256,-1835],[-68,1744],[239,1469]],[[283917,390859],[-162,-3064]],[[283755,387795],[-414,1424],[-230,-464]],[[283312,392781],[-46,161]],[[283266,392942],[46,-161]],[[273214,389793],[-307,-1570]],[[272907,388223],[-755,414],[-159,1170]],[[238590,388753],[-1541,208]],[[237049,388961],[-152,25],[-1,4923]],[[284458,394060],[-175,40]],[[284174,394699],[-62,330]],[[284323,395293],[135,-1233]],[[165958,391614],[-111,-1811],[216,-2119],[-268,-3201]],[[165795,384483],[-318,1674],[-351,-1063],[-391,1452]],[[164735,386546],[-147,1346]],[[164588,387892],[0,3589]],[[262873,394360],[-58,-1367],[-578,-417]],[[262237,392576],[-496,-1309]],[[261741,391267],[-4,4143]],[[241700,392158],[-279,-5795]],[[241421,386363],[-363,55]],[[241058,386418],[-603,3090],[5,1623]],[[160323,392090],[-77,-1063],[333,-1451],[-117,-1633],[136,-803],[-47,-1999],[-216,-907]],[[160335,384234],[-267,44],[0,3908],[-681,142],[-457,-373]],[[158930,387955],[-515,6080],[-298,453]],[[261741,391267],[-366,838]],[[261375,392105],[-331,-490],[66,-2302]],[[261110,389313],[-395,370]],[[260715,389683],[-3,1350],[-313,1081],[-1,1464]],[[253224,394176],[-108,-3961],[133,-657]],[[253249,389558],[-1250,127]],[[251999,389685],[9,4096]],[[256455,395227],[-410,-1812],[-93,-2129],[104,-2737]],[[256056,388549],[-615,-232]],[[255441,388317],[-373,-1489],[-409,-715]],[[254659,386113],[-35,905],[308,954],[-17,1004]],[[254915,388976],[435,3214],[-99,2079]],[[257614,391180],[2,-2983]],[[257616,388197],[-674,-392]],[[256942,387805],[55,7426]],[[256942,387805],[-413,172]],[[256529,387977],[-473,572]],[[274960,392162],[-143,-1744],[-396,-2215]],[[274421,388203],[-376,576],[-266,-940]],[[273779,387839],[-420,2994]],[[247909,392782],[-238,-999],[-192,-2324],[176,-1160]],[[247655,388299],[-25,-168]],[[247630,388131],[-211,-2528]],[[247419,385603],[-176,2125],[-512,9],[-410,-651]],[[246321,387086],[11,3217]],[[264517,389239],[-755,-736]],[[263762,388503],[-151,4643]],[[264447,393802],[70,-4563]],[[230673,392156],[-3,-4046]],[[230670,388110],[-1298,15]],[[229372,388125],[-307,-1],[-1,1618]],[[226293,389752],[2,-1622]],[[226295,388130],[-1550,-17]],[[224745,388113],[-16,3259]],[[233047,392152],[-21,-5676]],[[233026,386476],[-1232,4]],[[231794,386480],[13,5678]],[[158930,387955],[-62,-1644],[169,-2032],[-400,3],[-19,-2538],[-216,-435]],[[158402,381309],[-24,5]],[[158378,381314],[-291,-20]],[[158087,381294],[-3,44]],[[158084,381338],[140,477],[-107,2272],[-521,4539],[-126,2199]],[[281985,391353],[-669,-3258],[-157,217]],[[281159,388312],[-296,1764]],[[280863,390076],[149,2456]],[[263250,392869],[-350,-1063]],[[262900,391806],[-413,-1089]],[[262487,390717],[-250,1859]],[[158084,381338],[-237,-852],[-152,858]],[[157695,381344],[-539,908],[-435,1971],[-295,-310]],[[156426,383913],[-354,2862],[-569,2151],[-557,3778]],[[254915,388976],[-726,35]],[[254189,389011],[12,5213]],[[280017,389656],[-138,-1763],[572,-1648]],[[280451,386245],[-493,-2673]],[[279958,383572],[-240,-1326]],[[279718,382246],[-1324,5048]],[[279335,387009],[0,0]],[[254189,389011],[-119,3]],[[254070,389014],[-537,-21]],[[253533,388993],[-284,565]],[[269861,389247],[-95,-2476],[-512,-708]],[[269254,386063],[-253,186]],[[269001,386249],[-194,1565]],[[268807,387814],[-419,1210]],[[237049,388961],[-4,-2241]],[[237045,386720],[-1525,569]],[[235520,387289],[11,4850]],[[284458,394060],[-9,-959]],[[280863,390076],[-319,-2826]],[[280544,387250],[-93,-1005]],[[260715,389683],[-623,-25],[-151,-811]],[[259941,388847],[-106,263],[-8,2960]],[[265356,392696],[-244,-3246]],[[265112,389450],[-475,-738]],[[264637,388712],[-120,527]],[[251999,389685],[-2,-2446]],[[251997,387239],[-1241,-18]],[[250756,387221],[2,543]],[[250758,387764],[15,4342]],[[263762,388503],[-226,-927]],[[263536,387576],[-64,-376]],[[263472,387200],[-541,2720],[-31,1886]],[[283312,392781],[-46,161]],[[259941,388847],[-406,-1354],[-3,-1307]],[[259532,386186],[-107,-8]],[[259425,386178],[-618,89]],[[258807,386267],[-150,4]],[[258657,386271],[0,4937]],[[247867,390697],[-212,-2398]],[[285904,391677],[33,-3346],[377,-2749],[-110,-1238],[-607,2727],[-162,3701]],[[266078,390249],[8,-2072]],[[266086,388177],[-605,-1280],[-198,665]],[[265283,387562],[-171,1888]],[[262487,390717],[-392,-1208]],[[262095,389509],[-261,-210]],[[261834,389299],[-459,2806]],[[268807,387814],[-424,-2456]],[[268383,385358],[-426,367],[-546,2055]],[[267411,387780],[397,3341],[-19,785]],[[250758,387764],[-585,209],[-360,-847],[-369,60],[-248,-998]],[[249196,386188],[-7,4407]],[[277215,389401],[-117,-2971],[-334,-2300],[41,-776]],[[276805,383354],[-350,-1566],[-111,-2182]],[[276344,379606],[-848,-338],[-274,1261],[9,2076]],[[275231,382605],[22,2224],[297,803]],[[242945,389467],[-266,-2385],[-345,60],[127,-1459],[-203,-1038]],[[242258,384645],[-596,108],[14,1563],[-255,47]],[[231794,386480],[-23,-4900]],[[231771,381580],[-1110,51]],[[230661,381631],[9,6479]],[[234285,392148],[-26,-6490]],[[234259,385658],[-1233,6]],[[233026,385664],[0,812]],[[235520,387289],[0,-1654]],[[235520,385635],[-1261,23]],[[275231,382605],[-213,772]],[[275018,383377],[-482,1699],[-115,3127]],[[161934,387867],[6,-3922]],[[161940,383945],[-1040,-1302],[-210,590],[-282,-2812]],[[160408,380421],[-311,-431],[76,1800]],[[160173,381790],[162,2444]],[[261834,389299],[-406,-1730]],[[261428,387569],[-332,583]],[[261096,388152],[14,1161]],[[263472,387200],[-446,-2245]],[[263026,384955],[-363,79]],[[262663,385034],[-258,1507],[-110,2136],[-200,832]],[[267411,387780],[-197,-1448],[23,-1522],[-313,-464]],[[266924,384346],[-311,1158]],[[266613,385504],[-354,897],[-173,1776]],[[244558,391417],[4,-9114]],[[244562,382303],[-467,23],[2,-1087]],[[244097,381239],[-267,17]],[[243830,381256],[-40,2513]],[[243790,383769],[12,7731]],[[169169,376466],[1659,-8029]],[[170828,368437],[-2625,-35]],[[168203,368402],[-689,2284]],[[167514,370686],[-267,2691],[-421,166]],[[166826,373543],[187,2774],[-291,1077],[-121,2597],[-312,216],[-475,1906],[-19,2370]],[[246321,387086],[-122,-4888]],[[246199,382198],[-880,-1]],[[245319,382197],[-757,106]],[[243790,383769],[-1535,69]],[[242255,383838],[3,807]],[[164588,387892],[-720,-833],[-260,132],[-515,-1390],[-61,-1061],[-1009,-2142]],[[162023,382598],[-83,1347]],[[286908,384389],[-189,474],[-264,2363],[218,1227],[-54,1256],[301,244],[335,-1095],[296,2144]],[[288209,388837],[-340,-1484],[-14,-1069]],[[287855,386284],[-365,-3226],[-582,1331]],[[218595,391430],[0,-8114]],[[218595,383316],[-1157,7]],[[217438,383323],[-62,-1]],[[217376,383322],[-8,8119]],[[219823,391396],[8,-8115]],[[219831,383281],[-1236,35]],[[216145,391424],[-1,-8127]],[[216144,383297],[-1330,-14]],[[214814,383283],[1,118]],[[214815,383401],[-1,6449]],[[217376,383322],[-1162,-24]],[[216214,383298],[-70,-1]],[[282823,386026],[45,-780]],[[282868,385246],[-236,-135]],[[282632,385111],[-191,603],[-899,-1519]],[[281542,384195],[7,1474],[-390,2643]],[[221667,391366],[1,-6464]],[[221668,384902],[2,-1623]],[[221670,383279],[-1791,1]],[[219879,383280],[-48,1]],[[241058,386418],[-180,-1533],[-17,-2354]],[[240861,382531],[-192,-605],[-545,142],[-327,1182]],[[239797,383250],[30,5017]],[[224745,388113],[2,-4860]],[[224747,383253],[-1206,6]],[[223541,383259],[-334,2],[0,1622]],[[223207,384883],[-1,6486]],[[206744,388071],[3,-4865],[-303,-5]],[[206444,383201],[-2083,131]],[[204361,383332],[-596,3378]],[[223207,384883],[-1539,19]],[[285428,388496],[2,-844]],[[285430,387652],[-211,220],[-263,-2217]],[[284956,385655],[81,-2289],[-234,434],[-329,2868],[-459,-1568],[-187,2280],[549,3865]],[[258657,386271],[-1,-537],[-1038,13]],[[257618,385747],[-2,2450]],[[270898,384461],[-214,-1052],[-154,1960]],[[270530,385369],[-22,1865]],[[271507,390062],[-150,-656],[68,-2319],[-484,-1260],[-43,-1366]],[[181367,389064],[0,-7900]],[[181367,381164],[-7,-10123]],[[181360,371041],[5,-11252]],[[181365,359789],[1,-2928]],[[181366,356861],[-1984,13],[0,179],[-2726,-7],[-435,-204]],[[199240,384018],[-2,564],[-1384,-11],[128,-1422],[415,-674],[-79,-1241]],[[198318,381234],[-2999,13]],[[195319,381247],[-49,6459]],[[273779,387839],[177,-533],[-261,-1184],[-892,-2813]],[[272803,383309],[-146,3878],[250,1036]],[[249196,386188],[3,-3707]],[[249199,382481],[-545,27]],[[248654,382508],[-40,1621],[-342,19],[-642,3983]],[[281542,384195],[-437,-1435],[-99,693]],[[281006,383453],[-396,1782],[-66,2015]],[[272803,383309],[-1,-6]],[[272802,383303],[-272,-1508],[-143,-3970]],[[272387,377825],[-212,339]],[[272175,378164],[-165,2328],[-356,2011],[-528,-202]],[[271126,382301],[46,1977],[-274,183]],[[214815,383401],[-1944,-33]],[[212871,383368],[-1832,-28]],[[211039,383340],[-284,-8]],[[210755,383332],[-8,4680]],[[227834,389742],[0,-8111]],[[227834,381631],[-920,3]],[[226914,381634],[-613,-2]],[[226301,381632],[-6,6498]],[[229372,388125],[-59,-8133]],[[229313,379992],[-869,39]],[[228444,380031],[-1,1618],[-609,-18]],[[265283,387562],[-139,-988]],[[265144,386574],[-341,378]],[[264803,386952],[-166,1760]],[[253533,388993],[-9,-5827]],[[253524,383166],[-611,-14]],[[252913,383152],[-925,24]],[[251988,383176],[9,4063]],[[261096,388152],[-572,-2670]],[[260524,385482],[-286,-2089],[-141,377]],[[260097,383770],[-46,2157],[-519,259]],[[270530,385369],[-363,-644],[-243,-2058]],[[269924,382667],[-670,3396]],[[262663,385034],[-353,-388]],[[262310,384646],[-796,417]],[[261514,385063],[-86,2506]],[[278140,386071],[-341,-3643],[-207,-671]],[[277592,381757],[-787,1597]],[[283755,387795],[-68,-3119]],[[283687,384676],[-6,-1714]],[[283681,382962],[-121,26]],[[283560,382988],[-214,707]],[[283346,383695],[-232,459]],[[283114,384154],[-246,1092]],[[264803,386952],[-255,-1635]],[[264548,385317],[-418,-1608],[-274,-40]],[[263856,383669],[-44,1680],[-276,2227]],[[185634,387890],[509,-3310],[-59,-2002],[-242,-1389]],[[185842,381189],[-97,-48]],[[185745,381141],[-4378,23]],[[254070,389014],[36,-2006],[-137,-3776]],[[253969,383232],[-445,-66]],[[254659,386113],[-464,-2724],[-218,-213]],[[253977,383176],[-8,56]],[[238586,387939],[-30,-5630]],[[238556,382309],[-1467,73]],[[237089,382382],[-71,9],[27,4329]],[[289213,386812],[95,-1817],[-160,-1191],[-692,-216]],[[288456,383588],[-506,-230]],[[287950,383358],[-283,-697],[-32,1164],[220,2459]],[[275018,383377],[-768,-3504],[-473,452]],[[273777,380325],[-279,2236],[-256,-553],[-440,1295]],[[256529,387977],[-2,-5249]],[[256527,382728],[-679,251]],[[255848,382979],[3,2497],[-256,-92],[-154,2933]],[[158378,381314],[146,-1463],[-437,1443]],[[160173,381790],[-408,-2224],[-354,-188],[-351,1518],[-215,-1697],[-283,501],[-160,1609]],[[239797,383250],[35,-3689]],[[239832,379561],[-1222,173]],[[238610,379734],[-54,2575]],[[255848,382979],[-1,-825],[-418,-676]],[[255429,381478],[-616,57]],[[254813,381535],[-309,1119],[-517,33]],[[253987,382687],[-10,489]],[[257618,385747],[6,-2451]],[[257624,383296],[-312,-1079]],[[257312,382217],[-630,-29]],[[256682,382188],[-155,540]],[[266613,385504],[-146,-2035],[-362,-1580]],[[266105,381889],[-246,1825],[-347,209]],[[265512,383923],[-368,2651]],[[261514,385063],[-513,-1353]],[[261001,383710],[-477,1772]],[[230661,381631],[-3,-1635],[-459,10]],[[230199,380006],[-886,-14]],[[209217,388123],[-12,-6998]],[[209205,381125],[-8,-7666]],[[209197,373459],[-808,1541]],[[208389,375000],[-823,1546],[-1023,-358],[-101,636]],[[206442,376824],[2,6377]],[[210755,383332],[-21,-1722],[-306,-20],[0,-1082],[-596,-8],[-627,625]],[[226301,381632],[-1535,-18]],[[224766,381614],[-19,1639]],[[248654,382508],[-383,35],[1,-1620],[-477,-883]],[[247795,380040],[-127,737]],[[247668,380777],[-303,1892],[54,2934]],[[250756,387221],[-8,-4860]],[[250748,382361],[-1241,119]],[[249507,382480],[-308,1]],[[286032,384373],[445,-3369],[-10,-1655],[-344,2010],[-710,2346],[-112,-1068],[-345,3018]],[[285430,387652],[602,-3279]],[[164735,386546],[-435,-1185],[-950,-7856],[-381,-2238]],[[162969,375267],[-759,4580]],[[162210,379847],[-187,2751]],[[187728,387743],[-228,-1435],[16,-5094]],[[187516,381214],[-1674,-25]],[[192580,387706],[28,-2493],[350,-3273],[-106,-714]],[[192852,381226],[-4142,-34],[-1194,22]],[[247668,380777],[-455,-1591]],[[247213,379186],[-466,-723],[-158,1359]],[[246589,379822],[-390,2376]],[[268978,383008],[-530,-70]],[[268448,382938],[-65,2420]],[[269001,386249],[-23,-3241]],[[268448,382938],[-363,-1281]],[[268085,381657],[-378,306],[-289,1389],[-223,-1372]],[[267195,381980],[-271,2366]],[[195319,381247],[2,-5061]],[[195321,376186],[-5,-7382]],[[195316,368804],[-5,-9040]],[[195311,359764],[-2662,-21]],[[192649,359743],[-2090,98]],[[190559,359841],[-1844,-32]],[[188715,359809],[653,1883],[604,385],[346,3276],[287,901],[-33,1955],[278,1645]],[[190850,369854],[446,2473],[227,3836],[527,219],[571,4056],[231,788]],[[263856,383669],[113,-1403]],[[263969,382266],[-621,-1697]],[[263348,380569],[-281,1464]],[[263067,382033],[-41,2922]],[[281006,383453],[-231,-1615]],[[280775,381838],[-817,1734]],[[279718,382246],[-89,-2345],[-162,-618]],[[279467,379283],[-168,-1840],[-296,-1250],[-422,176]],[[278581,376369],[-906,3632]],[[277675,380001],[127,1436],[-210,320]],[[278910,381985],[0,0]],[[279286,380244],[0,0]],[[251988,383176],[-7,-2447]],[[251981,380729],[-1184,-9]],[[250797,380720],[-49,1641]],[[237089,382382],[-23,-3302]],[[237066,379080],[-1549,436]],[[235517,379516],[3,6119]],[[172686,359243],[-1858,9194]],[[265512,383923],[-362,-1945]],[[265150,381978],[-326,1244],[-276,2095]],[[204361,383332],[336,-2213],[254,-3271],[312,-1387]],[[205263,376461],[44,-2691]],[[205307,373770],[-1620,-57]],[[203687,373713],[-1526,-10],[-2,1613],[-297,15]],[[201862,375331],[0,678],[-568,1791],[-287,-220]],[[201007,377580],[-1,3556]],[[289490,378912],[-53,-34]],[[289437,378878],[53,34]],[[290026,386799],[-57,0]],[[289865,385833],[-126,-2836],[-305,-809],[-323,-3508]],[[289111,378680],[-677,-383]],[[288434,378297],[-6,31]],[[288428,378328],[-108,835],[337,901],[-201,3524]],[[289925,386799],[-60,-966]],[[166826,373543],[-111,722]],[[166715,374265],[-627,2326],[-334,-1722],[-421,-936],[-390,89],[-379,1183],[-853,-3609]],[[163711,371596],[-742,3671]],[[233026,385664],[-30,-6554]],[[232996,379110],[-1226,36]],[[231770,379146],[1,2434]],[[242255,383838],[29,-5136]],[[242284,378702],[-616,90]],[[241668,378792],[-305,22],[-346,3550],[-156,167]],[[258807,386267],[-62,-3639],[-147,-850]],[[258598,381778],[-366,-1124]],[[258232,380654],[2,1594],[-308,13],[2,1095],[-304,-60]],[[259425,386178],[1,-1624],[368,-2836]],[[259794,381718],[-134,-3193]],[[259660,378525],[-140,-132]],[[259520,378393],[-502,215],[-245,853],[-175,2317]],[[269924,382667],[-59,-1572],[261,-1815],[-318,-1929]],[[269808,377351],[-304,-1660]],[[269504,375691],[-230,1692]],[[269274,377383],[-144,2308],[-237,1273],[85,2044]],[[260097,383770],[-303,-2052]],[[284512,383385],[-92,-1945]],[[284420,381440],[-8,-27]],[[284412,381413],[-144,-224]],[[284268,381189],[-437,1843],[-150,-70]],[[283687,384676],[250,-96],[535,1273],[40,-2468]],[[267195,381980],[-57,-1465]],[[267138,380515],[-472,-1482]],[[266666,379033],[-181,318]],[[266485,379351],[-380,2538]],[[282632,385111],[-701,-4527]],[[281931,380584],[-408,649],[-297,-356]],[[281226,380877],[-451,961]],[[234259,385658],[-34,-6558]],[[234225,379100],[-1229,10]],[[235517,379516],[0,-428]],[[235517,379088],[-1292,12]],[[261001,383710],[173,-405],[-53,-2162]],[[261121,381143],[-14,-545]],[[261107,380598],[-354,-821],[-435,244],[-629,-1650]],[[259689,378371],[-29,154]],[[283114,384154],[232,-459]],[[283560,382988],[-758,-4755]],[[282802,378233],[-126,314]],[[282676,378547],[-383,1648],[-362,389]],[[271126,382301],[-263,-1062],[-13,-2367]],[[270850,378872],[-720,-942]],[[270130,377930],[-322,-579]],[[263067,382033],[-389,-1466]],[[262678,380567],[-442,233]],[[262236,380800],[74,3846]],[[265150,381978],[-286,-1441]],[[264864,380537],[-573,-891]],[[264291,379646],[-263,849],[-59,1771]],[[262236,380800],[-219,-1713]],[[262017,379087],[-896,2056]],[[223541,383259],[-1,-4853],[-304,-4]],[[223236,378402],[-914,10],[-1,1609],[-610,4]],[[221711,380025],[-41,3254]],[[199425,381138],[158,-1618],[-159,-1773]],[[199424,377747],[-472,-1109]],[[198952,376638],[-30,887],[-420,1384],[23,1648],[-207,677]],[[157695,381344],[163,-971],[-42,-3300],[179,-855],[-251,-1183],[-370,1730],[-114,-335],[-478,2413],[-374,-283],[164,2872],[317,-1457],[-463,3938]],[[266485,379351],[-223,-717],[-503,-259]],[[265759,378375],[-341,2566],[-268,1037]],[[162210,379847],[3,-6325],[-189,423],[-596,-1236],[-739,-3959]],[[160689,368750],[-239,1114],[0,5132]],[[160450,374996],[-70,4168]],[[160380,379164],[28,1257]],[[243830,381256],[-6,-1909],[-732,4],[-351,-755]],[[242741,378596],[-457,106]],[[287272,377541],[-21,-6]],[[287251,377535],[21,6]],[[287356,378030],[36,-498]],[[287392,377532],[-31,2]],[[287361,377534],[-41,379]],[[287320,377913],[36,117]],[[287320,377913],[-5,-375]],[[287315,377538],[-19,-1]],[[287296,377537],[24,376]],[[287781,379692],[-1,1870],[-264,-794],[434,2590]],[[288428,378328],[-760,-1368],[113,2732]],[[281226,380877],[-275,-2360]],[[280951,378517],[-515,-3904]],[[280436,374613],[-425,-1183]],[[280011,373430],[-544,5853]],[[280484,379686],[0,0]],[[285766,378696],[-155,-919]],[[285611,377777],[-363,656],[-314,2280],[-163,-800]],[[284771,379913],[-351,1527]],[[284512,383385],[528,-1942],[635,-277],[253,-1943],[-162,-527]],[[241668,378792],[-8,-3016]],[[241660,375776],[-363,-1063],[-225,1684],[-655,60]],[[240417,376457],[-605,128]],[[239812,376585],[20,2976]],[[269274,377383],[-231,160],[-89,-1393]],[[268954,376150],[-910,2229],[-138,-652]],[[267906,377727],[-93,803]],[[267813,378530],[371,1947],[-99,1180]],[[277675,380001],[-469,-3994]],[[277206,376007],[-657,396],[-135,1144],[-337,-43]],[[276077,377504],[267,2102]],[[214814,383283],[8,-9753]],[[214822,373530],[1,-1754]],[[214823,371776],[-1967,-12]],[[212856,371764],[15,11604]],[[276077,377504],[-296,-1431],[-373,-3413]],[[275408,372660],[-430,-145],[-592,890]],[[274386,373405],[-399,2555]],[[273987,375960],[102,2168],[-312,2197]],[[267813,378530],[-479,65],[-196,1920]],[[206442,376824],[-331,1927],[-322,-2224],[-84,711],[-442,-777]],[[212856,371764],[-914,-4]],[[211942,371760],[-915,4]],[[211027,371764],[12,11576]],[[211027,371764],[-1822,7],[-8,1688]],[[258232,380654],[-83,-1403]],[[258149,379251],[-55,-2224],[-404,-1554]],[[257690,375473],[32,1004],[-294,274],[-178,1615]],[[257250,378366],[113,-4],[-51,3855]],[[273987,375960],[-386,-927]],[[273601,375033],[-357,1056],[-619,250],[-238,1486]],[[217438,383323],[-2,-8108],[40,-1726]],[[217476,373489],[-1219,0]],[[216257,373489],[-44,1699],[1,8110]],[[219879,383280],[1,-4863]],[[219880,378417],[-1219,28],[33,-4957]],[[218694,373488],[-1218,1]],[[216257,373489],[-1435,41]],[[253987,382687],[206,-1256],[-505,-5063]],[[253688,376368],[-787,325]],[[252901,376693],[12,6459]],[[224766,381614],[1,-6484]],[[224767,375130],[-1507,16]],[[223260,375146],[-24,3256]],[[221711,380025],[-1,-3246]],[[221710,376779],[-1831,18]],[[219879,376797],[1,1620]],[[252901,376693],[0,-14]],[[252901,376679],[-925,-16]],[[251976,376663],[5,4066]],[[284268,381189],[-150,-1310],[278,-2137]],[[284396,377742],[-309,-256],[-1,-1105]],[[284086,376381],[-456,-1904]],[[283630,374477],[-165,-177],[-222,1929],[-441,2004]],[[256682,382188],[-153,-1592],[-544,-3576],[-2,-876]],[[255983,376144],[-94,369]],[[255889,376513],[-415,787]],[[255474,377300],[-45,4178]],[[254813,381535],[-35,-5040]],[[254778,376495],[-630,72]],[[254148,376567],[55,-1760],[-337,-147]],[[253866,374660],[-178,1708]],[[272175,378164],[-318,-1099],[158,-2552]],[[272015,374513],[-260,-47]],[[271755,374466],[-295,397],[-169,2098],[-573,1279],[132,632]],[[249507,382480],[-6,-4914]],[[249501,377566],[-221,-2833]],[[249280,374733],[-473,1904],[-262,-566]],[[248545,376071],[-165,1642],[-585,2327]],[[238610,379734],[-22,-2902],[-171,-1635]],[[238417,375197],[-154,26]],[[238263,375223],[-509,95],[7,1075],[-716,162]],[[237045,376555],[21,2525]],[[250797,380720],[-133,-3247]],[[250664,377473],[-1163,93]],[[245319,382197],[-11,-8639]],[[245308,373558],[-149,-795]],[[245159,372763],[-438,51],[5,1622],[-613,34]],[[244113,374470],[-16,6769]],[[264291,379646],[-143,-3261]],[[264148,376385],[-273,-833]],[[263875,375552],[-122,1730],[-504,1186]],[[263249,378468],[99,2101]],[[246589,379822],[-14,-6361]],[[246575,373461],[-1267,97]],[[257250,378366],[-461,-1267]],[[256789,377099],[-280,-2533],[-526,1578]],[[259520,378393],[-23,-3366],[-403,-372]],[[259094,374655],[-945,4596]],[[263249,378468],[-138,-2639]],[[263111,375829],[-141,-279],[-100,2291]],[[262870,377841],[-192,2726]],[[265759,378375],[-26,-1496]],[[265733,376879],[-550,230]],[[265183,377109],[-319,3428]],[[228444,380031],[1,-3258]],[[228445,376773],[-1531,-4]],[[226914,376769],[0,4865]],[[231770,379146],[-5,-5694]],[[231765,373452],[0,-2431]],[[231765,371021],[-1573,61]],[[230192,371082],[7,8924]],[[226914,376769],[9,-3303],[-304,-23]],[[226619,373443],[-1830,-22]],[[224789,373421],[-22,1709]],[[255474,377300],[-169,-642],[-244,1256],[-44,-2642],[-239,1223]],[[244113,374470],[-771,42],[-10,-3582]],[[243332,370930],[-613,69]],[[242719,370999],[22,7597]],[[190850,369854],[-4778,-85],[-897,125]],[[185175,369894],[-17,4889],[309,-24],[-28,1599],[335,1],[-29,4782]],[[285474,374122],[-189,-777]],[[285285,373345],[-143,1233],[-392,-213],[-211,1145],[-143,2232]],[[284412,381413],[24,-1012],[357,-714],[24,-1757],[347,-1480],[310,-2328]],[[198952,376638],[-341,-2419]],[[198611,374219],[-359,1512],[-614,-665],[-130,1368],[-1561,19],[-626,-267]],[[282676,378547],[-305,-5181]],[[282371,373366],[-288,724],[-132,1442],[-320,1092]],[[281631,376624],[-680,1893]],[[185175,369894],[-607,4],[0,-813]],[[184568,369085],[-378,-469],[-604,143],[1,868],[-616,2],[-2,1663],[-315,-252],[-1294,1]],[[262017,379087],[-182,-1209]],[[261835,377878],[-646,-598],[-256,977]],[[260933,378257],[174,2341]],[[201007,377580],[-383,-320],[-19,-4903],[45,-4702]],[[200650,367655],[-984,-5]],[[199666,367650],[-1,4037]],[[199665,371687],[0,2392],[-241,3668]],[[262870,377841],[-381,-296],[-271,-1166]],[[262218,376379],[-341,113]],[[261877,376492],[-42,1386]],[[251976,376663],[-1,-809]],[[251975,375854],[-1238,-25]],[[250737,375829],[-73,1644]],[[285611,377777],[352,-2380]],[[285963,375397],[-300,-591]],[[285663,374806],[-240,292],[-546,3121],[-106,1694]],[[248545,376071],[-481,-3792]],[[248064,372279],[-249,-32],[-722,3897],[380,1914],[-260,1128]],[[260933,378257],[-419,-2943],[-266,-430]],[[260248,374884],[-559,3487]],[[267906,377727],[-44,-1950]],[[267862,375777],[-303,91],[-437,-1812],[23,-1008]],[[267145,373048],[-650,2775]],[[266495,375823],[171,3210]],[[265183,377109],[-100,-1733]],[[265083,375376],[-218,283]],[[264865,375659],[-717,726]],[[160450,374996],[-1124,-1844],[-235,1488],[-259,115],[-483,1735]],[[158349,376490],[-209,1238],[349,1656],[315,-572],[373,668],[783,-708],[357,1506],[63,-1114]],[[230192,371082],[-1,-2432]],[[230191,368650],[-1748,-16]],[[228443,368634],[2,8139]],[[223260,375146],[0,-1719]],[[223260,373427],[-1521,35]],[[221739,373462],[-29,3317]],[[278540,374733],[-257,-157],[-226,-2495],[-255,-813]],[[277802,371268],[-172,-1566]],[[277630,369702],[-515,2397],[26,1888]],[[277141,373987],[65,2020]],[[278581,376369],[-41,-1636]],[[277790,374553],[0,0]],[[278042,373830],[0,0]],[[248064,372279],[-101,-553]],[[247963,371726],[-1081,38]],[[246882,371764],[-315,-16],[8,1713]],[[163711,371596],[-1656,-4356],[43,-1065],[-726,-3845]],[[161372,362330],[-155,871],[-328,-611],[-162,2473],[145,499],[-185,3196]],[[160687,368758],[2,-8]],[[239812,376585],[-307,30],[-14,-1889]],[[239491,374726],[-1074,471]],[[237045,376555],[-22,-4864]],[[237023,371691],[-1516,258]],[[235507,371949],[0,363]],[[235507,372312],[10,6776]],[[266495,375823],[-378,-675]],[[266117,375148],[-384,1731]],[[280011,373430],[-196,-1764],[-242,63],[-67,-1661]],[[279506,370068],[-122,-195]],[[279384,369873],[-552,4225],[-292,635]],[[259094,374655],[-345,-3823]],[[258749,370832],[-373,-503],[-265,1039],[-246,-1076]],[[257865,370292],[-128,1809]],[[257737,372101],[-47,3372]],[[232996,379110],[-18,-5687]],[[232978,373423],[-1213,29]],[[234225,379100],[-28,-5680]],[[234197,373420],[-1219,3]],[[235507,372312],[-1310,27]],[[234197,372339],[0,1081]],[[287392,377532],[-31,2]],[[287315,377538],[-19,-1]],[[287272,377541],[-21,-6]],[[288876,376511],[119,-271],[-517,-3407],[-55,-2435],[-470,-1281]],[[287953,369117],[-126,1004]],[[287827,370121],[-283,134],[408,3843]],[[287952,374098],[291,1243],[191,2956]],[[289111,378680],[-235,-2169]],[[289490,378912],[-53,-34]],[[271755,374466],[-438,-677],[176,-948],[-282,-761]],[[271211,372080],[-347,406],[-184,-777],[-249,1135],[-83,2839],[-218,2247]],[[286401,372837],[-192,2274],[-246,286]],[[285766,378696],[289,-8],[647,-2450],[-301,-3401]],[[242719,370999],[-614,37]],[[242105,371036],[2,817],[-459,1220],[12,2703]],[[208389,375000],[-289,-1427],[-261,-3093],[-562,-3167],[-508,-171],[-617,-1904]],[[206152,365238],[46,2010],[-135,4024],[-310,765],[-525,-1497]],[[205228,370540],[79,3230]],[[283630,374477],[147,-1396],[514,-1037],[-44,-592]],[[284247,371452],[-292,-1688]],[[283955,369764],[-489,1286],[-105,1395],[-525,504]],[[282836,372949],[-465,417]],[[281362,373717],[-225,-1081]],[[281137,372636],[-621,1278],[-80,699]],[[281631,376624],[-269,-2907]],[[260248,374884],[159,-1472]],[[260407,373412],[-544,-3501],[-48,-1933]],[[259815,367978],[-430,176]],[[259385,368154],[-185,2177],[-451,501]],[[263875,375552],[-250,-1450]],[[263625,374102],[-126,-754],[-407,1614]],[[263092,374962],[19,867]],[[268954,376150],[-162,-516],[84,-2448]],[[268876,373186],[-340,667],[-495,-734]],[[268041,373119],[-179,2658]],[[219879,376797],[30,-8169]],[[219909,368628],[-1216,-7]],[[218693,368621],[1,4867]],[[257737,372101],[-515,1415]],[[257222,373516],[-85,1915],[-348,1668]],[[273601,375033],[187,-2460],[-193,530],[-410,-2364]],[[273185,370739],[-292,-249],[-64,-1204]],[[272829,369286],[-281,1662],[-394,3474],[-139,91]],[[261877,376492],[-288,-708],[-405,-2399]],[[261184,373385],[-333,-3287]],[[260851,370098],[-285,-39],[141,1604],[-300,1749]],[[271211,372080],[-148,-2078]],[[271063,370002],[-199,-676]],[[270864,369326],[-114,472]],[[270750,369798],[-437,240],[-582,3546]],[[269731,373584],[-227,2107]],[[255889,376513],[81,-2236],[-378,-1770]],[[255592,372507],[-241,-671]],[[255351,371836],[-666,-173]],[[254685,371663],[-57,1803],[-480,3101]],[[285285,373345],[270,-2335]],[[285555,371010],[-138,-2862]],[[285417,368148],[-256,2601]],[[285161,370749],[-819,3092],[-256,2540]],[[199665,371687],[-1364,1]],[[198301,371688],[8,1041],[302,1490]],[[263092,374962],[-79,-1906]],[[263013,373056],[-780,-638]],[[262233,372418],[68,3271],[-83,690]],[[201862,375331],[-47,-8024]],[[201815,367307],[-1165,-220],[0,568]],[[269731,373584],[-340,-1357],[-300,302]],[[269091,372529],[-215,657]],[[277141,373987],[-397,706],[-568,-2858]],[[276176,371835],[-345,-947],[-213,580]],[[275618,371468],[-210,1192]],[[276253,374852],[0,0]],[[250737,375829],[-7,-4869]],[[250730,370960],[-827,-8],[-198,-519]],[[249705,370433],[27,2110],[-434,1361],[-18,829]],[[266117,375148],[-215,-2029]],[[265902,373119],[-39,-3]],[[265863,373116],[-510,789],[-270,1471]],[[257222,373516],[17,-1185],[-615,-2106]],[[256624,370225],[-1032,2282]],[[264865,375659],[-28,-5332]],[[264837,370327],[-303,-812]],[[264534,369515],[-414,300]],[[264120,369815],[-495,4287]],[[253866,374660],[-364,-2527],[71,-1661]],[[253573,370472],[-674,471]],[[252899,370943],[2,5736]],[[262233,372418],[-14,-886]],[[262219,371532],[-865,379],[-170,1474]],[[221739,373462],[9,-4974]],[[221748,368488],[-1535,133]],[[220213,368621],[-304,7]],[[228443,368634],[-1823,-25]],[[226620,368609],[-1,4834]],[[252899,370943],[-103,7]],[[252796,370950],[-826,-12]],[[251970,370938],[5,4916]],[[285161,370749],[-468,-116]],[[284693,370633],[-446,819]],[[240417,376457],[5,-7664]],[[240422,368793],[-607,46],[-5,-1332]],[[239810,367507],[-304,42]],[[239506,367549],[-15,7177]],[[160687,368758],[-1094,45],[-338,-405]],[[159255,368398],[-342,754],[-149,3107],[-463,2405],[48,1826]],[[282836,372949],[-67,-2693]],[[282769,370256],[-815,2165],[-30,-1006],[-320,604]],[[281604,372019],[-242,1698]],[[249705,370433],[0,-111]],[[249705,370322],[-946,616]],[[248759,370938],[-796,-35]],[[247963,370903],[0,823]],[[238263,375223],[35,-4780]],[[238298,370443],[-1280,165]],[[237018,370608],[5,1083]],[[166715,374265],[-765,-4052],[-188,-2676],[-313,4],[-790,-4320]],[[164659,363221],[-270,1013],[-380,3367],[-298,3995]],[[254685,371663],[-553,-2946]],[[254132,368717],[-234,1247],[-124,-777]],[[253774,369187],[-201,1285]],[[242105,371036],[-8,-2450]],[[242097,368586],[-1210,160]],[[240887,368746],[-465,47]],[[198301,371688],[-2633,-143],[-352,-2741]],[[268041,373119],[135,-3677],[-93,-602]],[[268083,368840],[-64,308]],[[268019,369148],[-398,2375],[-439,725]],[[267182,372248],[-37,800]],[[273842,367755],[-4,20]],[[273838,367775],[-653,2964]],[[274386,373405],[-544,-5650]],[[251970,370938],[-927,-50]],[[251043,370888],[-313,72]],[[267182,372248],[-389,563],[-373,-1145]],[[266420,371666],[-518,1453]],[[265863,373116],[-284,-991],[-227,-2237]],[[265352,369888],[-515,439]],[[286401,371346],[-510,730],[-228,2730]],[[286401,372837],[0,-1491]],[[203687,373713],[-2,-6471]],[[203685,367242],[-1780,53]],[[201905,367295],[-90,12]],[[158120,372966],[-303,-2]],[[157817,372964],[-33,1343],[287,552],[49,-1893]],[[239506,367549],[-1222,189]],[[238284,367738],[14,2705]],[[264120,369815],[-276,-991]],[[263844,368824],[-589,2769]],[[263255,371593],[-242,1463]],[[224789,373421],[0,-4871]],[[224789,368550],[-1527,-11]],[[223262,368539],[-2,4888]],[[279384,369873],[-416,-2088]],[[278968,367785],[-186,-655]],[[278782,367130],[-282,1313]],[[278500,368443],[-442,1075],[-256,1750]],[[211942,371760],[-29,-11974]],[[211913,359786],[-2568,-75]],[[209345,359711],[-3196,-18]],[[206149,359693],[3,5545]],[[277630,369702],[-234,-1502],[-213,614],[-430,-1508],[-95,-1769]],[[276658,365537],[-630,2109]],[[276028,367646],[291,2274],[-143,1915]],[[245159,372763],[-5,-2033]],[[245154,370730],[-438,88],[-5,-1633],[288,-71],[-3,-1602]],[[244996,367512],[-1211,139]],[[243785,367651],[-302,26],[0,3251],[-151,2]],[[272829,369286],[-248,-1600]],[[272581,367686],[-815,1322],[-628,339],[-75,655]],[[281137,372636],[-25,-1023],[-602,-5508]],[[280510,366105],[-361,1085]],[[280149,367190],[-643,2878]],[[167514,370686],[-806,-4323],[-52,-2727],[-160,-1066],[-478,-109],[49,-889],[-436,-1628],[-318,-2892],[-1553,-1283],[-242,1461],[-239,3370]],[[163279,360600],[183,976],[522,1046],[675,599]],[[285850,370354],[-295,656]],[[285474,374122],[422,-2949],[651,-1010],[-346,-836],[-351,1027]],[[269091,372529],[-167,-3366],[109,-686],[-352,-3384]],[[268681,365093],[-160,2648],[-438,1099]],[[205228,370540],[-718,-4116]],[[204510,366424],[-823,2],[-2,816]],[[281604,372019],[-166,-3773]],[[281438,368246],[-287,-1612]],[[281151,366634],[-415,-1159],[-226,630]],[[270750,369798],[-954,-4451]],[[269796,365347],[-678,-1793]],[[269118,363554],[-32,-122]],[[269086,363432],[-466,1404]],[[268620,364836],[61,257]],[[246882,371764],[-41,-6070]],[[246841,365694],[-3,-838],[-515,-29]],[[246323,364827],[-104,1910],[11,4270],[-1076,-277]],[[216257,373489],[3,-6477]],[[216260,367012],[-85,2]],[[216175,367014],[-1352,13]],[[214823,367027],[0,4749]],[[257865,370292],[-200,-146],[146,-3006]],[[257811,367140],[-547,-1924],[-253,-1483]],[[257011,363733],[-559,3793]],[[256452,367526],[172,2699]],[[217476,373489],[0,-6490]],[[217476,366999],[-1216,13]],[[218693,368621],[0,-1623]],[[218693,366998],[-1157,2]],[[217536,367000],[-60,-1]],[[223262,368539],[4,-1604]],[[223266,366935],[-1482,-59]],[[221784,366876],[-36,1612]],[[226620,368609],[1,-1636]],[[226621,366973],[-1512,-42]],[[225109,366931],[-321,1],[1,1618]],[[232978,373423],[0,-6493]],[[232978,366930],[-1215,50]],[[231763,366980],[2,4041]],[[234197,372339],[-1,-5412]],[[234196,366927],[-1206,3]],[[232990,366930],[-12,0]],[[260851,370098],[153,-1651]],[[261004,368447],[-327,81]],[[260677,368528],[-206,-891]],[[260471,367637],[-656,341]],[[262219,371532],[-27,-1601]],[[262192,369931],[-95,-2448]],[[262097,367483],[-273,950],[-278,-893],[-215,1026],[-327,-119]],[[275618,371468],[-300,-1181],[80,-1043],[-490,-1589]],[[274908,367655],[-100,1093],[-720,-2035],[-246,1042]],[[266420,371666],[-159,-2460]],[[266261,369206],[-144,586],[-553,-948],[-155,569]],[[265409,369413],[-57,475]],[[263255,371593],[-527,-1618]],[[262728,369975],[-536,-44]],[[283955,369764],[143,-836]],[[284098,368928],[-199,-2026]],[[283899,366902],[-182,63]],[[283717,366965],[-298,1139]],[[283419,368104],[99,1639],[-146,1184],[-444,-782]],[[282928,370145],[-159,111]],[[158120,372966],[96,-2154],[271,-373],[409,-1982]],[[158896,368457],[-209,-644],[106,-2701]],[[158793,365112],[-4,-1305],[-464,-534],[77,-1486]],[[158402,361787],[-314,1660],[11,3041],[-319,2975],[37,3501]],[[268019,369148],[-408,283],[-84,-2105]],[[267527,367326],[-252,703],[-463,-1951],[-186,747],[-277,-815]],[[266349,366010],[-88,3196]],[[282769,370256],[-560,-2686]],[[282209,367570],[-433,1403],[-338,-727]],[[256452,367526],[-546,-453]],[[255906,367073],[-158,651],[-62,2672]],[[255686,370396],[-335,1440]],[[235507,371949],[0,-5388]],[[235507,366561],[0,-480]],[[235507,366081],[-1274,28]],[[234233,366109],[-37,818]],[[276028,367646],[-525,-1522]],[[275503,366124],[-183,485],[-294,-965]],[[275026,365644],[-118,2011]],[[206149,359693],[-183,-2]],[[205966,359691],[-1386,13]],[[204580,359704],[-148,938],[143,4467],[-65,1315]],[[237018,370608],[-19,-4324]],[[236999,366284],[-1492,277]],[[255686,370396],[-1221,-4086]],[[254465,366310],[33,525]],[[254498,366835],[-359,564],[-7,1318]],[[247963,370903],[3,-5312],[-200,54]],[[247766,365645],[-925,49]],[[214823,367027],[-1,-7366]],[[214822,359661],[-2675,122]],[[212147,359783],[-234,3]],[[198301,371688],[-141,-896],[-30,-2362],[-478,-2240],[-241,-2267],[2,-1425],[-247,-2726]],[[197166,359772],[-1855,-8]],[[199666,367650],[1,-7869]],[[199667,359781],[-2501,-9]],[[163279,360600],[-1048,-5633]],[[162231,354967],[-622,1773],[-205,2320]],[[161404,359060],[-32,3270]],[[263844,368824],[-156,-2928]],[[263688,365896],[-150,509],[-457,-2190]],[[263081,364215],[-5,2272],[-355,1235],[7,2253]],[[284693,370633],[402,-619],[175,-1717]],[[285270,368297],[-384,-511],[-28,-974]],[[284858,366812],[-760,2116]],[[259385,368154],[-66,-2032],[-241,-91]],[[259078,366031],[-868,-274]],[[258210,365757],[-399,1383]],[[278500,368443],[-229,-637],[32,-1405]],[[278303,366401],[-518,-5580]],[[277785,360821],[-108,-926],[-313,672]],[[277364,360567],[-363,2794],[-342,618]],[[276659,363979],[-1,1558]],[[277509,366213],[0,0]],[[184568,369085],[5,-9297]],[[184573,359788],[-3208,1]],[[231763,366980],[-8,-1628]],[[231755,365352],[-1561,65]],[[230194,365417],[-3,3233]],[[246323,364827],[-123,-4109]],[[246200,360718],[-515,61],[-148,783]],[[245537,361562],[-46,1372],[-349,1595],[-44,2975],[-102,8]],[[249705,370322],[275,-3107],[-171,-1185]],[[249809,366030],[-12,-1568]],[[249797,364462],[-367,-344],[-403,-1990]],[[249027,362128],[-283,3]],[[248744,362131],[15,8807]],[[243785,367651],[-25,-6959]],[[243760,360692],[-1207,136]],[[242553,360828],[-453,64]],[[242100,360892],[-3,7694]],[[253774,369187],[-63,-597],[-543,-371],[-221,-906]],[[252947,367313],[-159,351]],[[252788,367664],[8,3286]],[[252788,367664],[-169,-666],[-98,-2357],[240,-2056],[-183,-1538]],[[252578,361047],[0,1701],[-613,3309]],[[251965,366057],[5,4881]],[[283419,368104],[-491,2041]],[[251965,366057],[-546,-28],[-63,-614]],[[251356,365415],[-322,507]],[[251034,365922],[9,4966]],[[251034,365922],[-568,98]],[[250466,366020],[-657,10]],[[285850,370354],[308,-1052]],[[286158,369302],[-18,-1124]],[[286140,368178],[152,-3489],[-321,-310],[-554,3769]],[[248744,362131],[-259,19],[1,-1356],[-424,-246]],[[248062,360548],[-312,844],[16,4253]],[[273838,367775],[29,-1536],[-368,-994]],[[273499,365245],[-679,-1091]],[[272820,364154],[-382,1914]],[[272438,366068],[143,1618]],[[168203,368402],[-33,-2228],[201,-311],[167,-3441],[606,-1527],[213,-3239],[-23,-2583]],[[169334,355073],[-1716,-81],[-1,-1561],[-890,26],[-3,-1596],[-459,20],[-299,-1621]],[[165966,350260],[-246,-1295],[-814,-376],[-3,-4045],[-991,-5108]],[[163912,339436],[-929,3751],[57,1792],[-141,1162]],[[162899,346141],[229,1144],[-1,2966],[-896,4716]],[[238284,367738],[-14,-2706]],[[238270,365032],[-1188,149]],[[237082,365181],[-83,1103]],[[265409,369413],[279,-3141]],[[265688,366272],[-442,-1825]],[[265246,364447],[-535,1286]],[[264711,365733],[-177,3782]],[[255906,367073],[-251,-1811],[146,-2557]],[[255801,362705],[-529,-954],[-438,810]],[[254834,362561],[-346,1710],[-23,2039]],[[283717,366965],[-7,-1437]],[[283710,365528],[-51,70]],[[283659,365598],[-117,-1256]],[[283542,364342],[-75,-142]],[[283467,364200],[-36,-78]],[[283431,364122],[-87,-195]],[[283344,363927],[-565,790]],[[282779,364717],[-265,34],[-366,1828],[61,991]],[[280149,367190],[-243,-2778]],[[279906,364412],[-397,-808]],[[279509,363604],[-259,695],[-282,3486]],[[287953,369117],[-346,-3597],[-150,-3563],[-151,2650],[266,5441],[255,73]],[[263081,364215],[-502,-2274]],[[262579,361941],[-398,1305]],[[262181,363246],[-37,1321],[-302,1000]],[[261842,365567],[255,1916]],[[272438,366068],[-555,-2440],[-498,579]],[[271385,364207],[-316,930],[-383,3657],[178,532]],[[254498,366835],[-802,-2923],[-19,-787]],[[253677,363125],[-271,-607]],[[253406,362518],[-71,2345],[-388,2450]],[[188715,359809],[-3142,-15]],[[185573,359794],[-1000,-6]],[[266349,366010],[57,-1413]],[[266406,364597],[-349,1839],[-369,-164]],[[264711,365733],[-224,-683],[-203,-2440]],[[264284,362610],[-596,3286]],[[271385,364207],[-448,-1772]],[[270937,362435],[-326,-1378],[-364,-500]],[[270247,360557],[-283,4288],[-168,502]],[[286158,369302],[207,216],[310,-1576],[-73,-2371],[-462,2607]],[[268620,364836],[-243,-50],[-502,-1356]],[[267875,363430],[-354,1381],[6,2515]],[[282779,364717],[-405,-1350]],[[282374,363367],[-1213,1929]],[[281161,365296],[-10,1338]],[[284858,366812],[77,-164]],[[284935,366648],[-7,-2000],[-380,948],[-673,136],[24,1170]],[[240887,368746],[2,-7717]],[[240889,361029],[-605,67]],[[240284,361096],[-452,336]],[[239832,361432],[-22,6075]],[[161404,359060],[-763,407],[-257,-1537]],[[160384,357930],[-486,2766],[-658,1780],[-447,2636]],[[158896,368457],[359,-59]],[[261842,365567],[-522,-2203]],[[261320,363364],[-643,5164]],[[242100,360892],[-1211,137]],[[275026,365644],[-484,-1303]],[[274542,364341],[-690,-1814]],[[273852,362527],[-445,2381],[92,337]],[[230194,365417],[-2,-5660]],[[230192,359757],[-625,5]],[[229567,359762],[-1109,1]],[[228458,359763],[-15,8871]],[[228458,359763],[-876,-6]],[[227582,359757],[-948,0]],[[226634,359757],[-13,7216]],[[220213,368621],[49,-8798]],[[220262,359823],[-1515,-40]],[[218747,359783],[-1,7214],[-53,1]],[[221784,366876],[6,-7102]],[[221790,359774],[-1286,39]],[[220504,359813],[-242,10]],[[225109,366931],[7,-7184]],[[225116,359747],[-550,11]],[[224566,359758],[-1269,13]],[[223297,359771],[-31,7164]],[[261320,363364],[-485,-1545]],[[260835,361819],[-445,1353]],[[260390,363172],[-31,2226],[112,2239]],[[278782,367130],[-479,-729]],[[176230,341181],[676,-3534]],[[176906,337647],[-237,-294],[-2130,-6],[-3164,16]],[[171375,337363],[-1036,-167]],[[170339,337196],[74,1515],[-404,8051],[81,567],[-422,2802],[-73,2163],[-261,2779]],[[285316,364880],[167,-151]],[[285483,364729],[247,-950]],[[285730,363779],[-49,-868]],[[285681,362911],[-94,912],[-633,479],[-19,2346]],[[285270,368297],[233,-1659]],[[285503,366638],[-153,-1180]],[[285350,365458],[-34,-578]],[[260390,363172],[-160,-225]],[[260230,362947],[-453,-403],[-418,352]],[[259359,362896],[21,897],[-302,2238]],[[267875,363430],[-170,-1501],[19,-1797],[-189,-330]],[[267535,359802],[-167,367]],[[267368,360169],[-60,2883],[-338,936],[-80,1342],[-349,-222],[-82,-931]],[[266459,364177],[-53,420]],[[279509,363604],[-224,-3408]],[[279285,360196],[-519,776]],[[278766,360972],[-292,-176],[-159,1424],[-530,-1399]],[[239832,361432],[-1514,176]],[[238318,361608],[-48,3424]],[[253406,362518],[-128,-3094]],[[253278,359424],[-344,1548],[-334,-767]],[[252600,360205],[-233,1071]],[[252367,361276],[211,-229]],[[245537,361562],[-556,-176],[-16,-3767]],[[244965,357619],[-1212,98]],[[243753,357717],[7,2975]],[[201905,367295],[0,-3259],[563,-4371]],[[202468,359665],[-2632,116]],[[199836,359781],[-169,0]],[[276659,363979],[-321,-1646],[-128,662],[-334,-926]],[[275876,362069],[-139,-176]],[[275737,361893],[-37,2240],[-197,1991]],[[276171,365518],[-31,-844]],[[276140,364674],[211,-935],[217,1689],[-397,90]],[[257011,363733],[-117,-2666]],[[256894,361067],[-312,-151]],[[256582,360916],[-548,-371],[-28,566]],[[256006,361111],[-205,1594]],[[281161,365296],[-22,-3279]],[[281139,362017],[-569,-758]],[[280570,361259],[-694,2327],[30,826]],[[204580,359704],[-804,-10]],[[203776,359694],[-1308,-29]],[[258405,362945],[-625,205],[-142,-3375]],[[257638,359775],[-744,1292]],[[258210,365757],[195,-2812]],[[216175,367014],[3,-7320]],[[216178,359694],[-1317,-41]],[[214861,359653],[-39,8]],[[217536,367000],[3,-7258]],[[217539,359742],[-1361,-48]],[[218747,359783],[-870,-31]],[[217877,359752],[-338,-10]],[[232990,366930],[-4,-7162]],[[232986,359768],[-736,0]],[[232250,359768],[-495,-4]],[[231755,359764],[0,5588]],[[226634,359757],[-862,-11]],[[225772,359746],[-656,1]],[[223297,359771],[-1270,0]],[[222027,359771],[-237,3]],[[234233,366109],[4,-6336]],[[234237,359773],[-931,-5]],[[233306,359768],[-320,0]],[[254834,362561],[-147,-2742]],[[254687,359819],[-400,-773]],[[254287,359046],[-460,3989],[-150,90]],[[285503,366638],[154,-1165],[635,-2093],[-66,-1011]],[[286226,362369],[53,-610]],[[286279,361759],[-115,-211]],[[286164,361548],[-434,2231]],[[285483,364729],[-133,729]],[[237082,365181],[-19,-4504]],[[237063,360677],[-1556,162]],[[235507,360839],[0,5242]],[[275737,361893],[-473,-1710],[-546,-688]],[[274718,359495],[-101,1954]],[[274617,361449],[153,1098]],[[274770,362547],[-228,1794]],[[266459,364177],[-121,-2912],[119,-2629]],[[266457,358636],[-224,321]],[[266233,358957],[-784,1845]],[[265449,360802],[-274,2103],[71,1542]],[[264091,359038],[-613,-1731]],[[263478,357307],[-281,2109],[-435,319]],[[262762,359735],[-183,2206]],[[264284,362610],[-193,-3572]],[[235507,360839],[-1,-1078]],[[235506,359761],[-1085,11]],[[234421,359772],[-184,1]],[[259359,362896],[-159,-1977]],[[259200,360919],[-468,373],[-327,1653]],[[276140,364674],[31,844]],[[252367,361276],[-1008,2722]],[[251359,363998],[-3,1417]],[[272820,364154],[-287,-1785],[161,-863],[-535,-1063],[70,-474]],[[272229,359969],[-685,-1435],[-271,477]],[[271273,359011],[-336,3424]],[[250466,366020],[-48,-4181],[274,-849]],[[250692,360990],[92,-1565]],[[250784,359425],[-347,1557],[-155,-1006]],[[250282,359976],[-177,540],[-308,3946]],[[265449,360802],[-249,-1447],[-375,-411]],[[264825,358944],[-564,-169]],[[264261,358775],[-170,263]],[[251359,363998],[-14,-28]],[[251345,363970],[-427,-1200],[-226,-1780]],[[267368,360169],[-217,-969],[-641,-1367]],[[266510,357833],[-53,803]],[[283884,365227],[-225,371]],[[283710,365528],[174,-301]],[[248062,360548],[-410,-2218]],[[247652,358330],[-1170,83]],[[246482,358413],[-282,2305]],[[283884,365227],[441,266],[239,-1372]],[[284564,364121],[-405,-2254]],[[284159,361867],[-678,-2216]],[[283481,359651],[-2,3311]],[[283479,362962],[63,1380]],[[285316,364880],[0,0]],[[262181,363246],[-452,-3530],[-71,-1327]],[[261658,358389],[-614,241]],[[261044,358630],[-209,3189]],[[270247,360557],[-500,-1318]],[[269747,359239],[-387,951],[-242,3364]],[[231755,359764],[-101,-4]],[[231654,359760],[-1462,-3]],[[273852,362527],[-162,-1380]],[[273690,361147],[-561,-945],[-310,462],[-429,-1769]],[[272390,358895],[-161,1074]],[[283467,364200],[-36,-78]],[[282112,359573],[-317,632]],[[281795,360205],[-220,-114],[-436,1926]],[[282374,363367],[-290,-906],[28,-2888]],[[238318,361608],[-4,-1905]],[[238314,359703],[-2,-1358]],[[238312,358345],[-1259,166]],[[237053,358511],[10,2166]],[[160384,357930],[-174,-102]],[[160210,357828],[-281,264],[-163,-998]],[[159766,357094],[-380,2272],[-464,-405],[-520,2826]],[[283344,363927],[135,-965]],[[283481,359651],[-614,-2144]],[[282867,357507],[-109,310]],[[282758,357817],[-299,1492],[-347,264]],[[269086,363432],[-450,-1508],[10,-1311],[-407,-1312]],[[268239,359301],[-193,765],[-584,-1128],[73,864]],[[250282,359976],[-572,-2622]],[[249710,357354],[-478,-188]],[[249232,357166],[10,1268],[-274,2899],[59,795]],[[280570,361259],[-138,-3503]],[[280432,357756],[-433,-3599]],[[279999,354157],[-48,2703],[-666,3336]],[[274770,362547],[-153,-1098]],[[274718,359495],[-251,-984]],[[274467,358511],[-297,-982]],[[274170,357529],[-480,3618]],[[285497,362381],[-63,-1487],[-424,-1183]],[[285010,359711],[-289,-964]],[[284721,358747],[-34,2055],[-528,1065]],[[284564,364121],[581,-507],[352,-1233]],[[277364,360567],[-130,-3464]],[[277234,357103],[-337,-1260],[-663,787],[-116,-677]],[[276118,355953],[-70,869],[-471,579]],[[275577,357401],[360,2851],[-61,1817]],[[251671,358926],[-486,-648],[-308,443]],[[250877,358721],[-93,704]],[[251345,363970],[326,-5044]],[[252600,360205],[-4,-1497]],[[252596,358708],[-916,78]],[[251680,358786],[-9,140]],[[286164,361548],[133,-1959]],[[286297,359589],[-664,2557],[48,765]],[[269747,359239],[82,-1209],[-301,-551]],[[269528,357479],[-635,40],[-381,-1463]],[[268512,356056],[-298,1723]],[[268214,357779],[25,1522]],[[268976,359021],[0,0]],[[259200,360919],[-148,-2366]],[[259052,358553],[-666,-2939]],[[258386,355614],[14,578],[-508,429],[-79,979]],[[257813,357600],[-175,2175]],[[262762,359735],[-638,-2584]],[[262124,357151],[-421,-77]],[[261703,357074],[-45,1315]],[[261044,358630],[-402,-2235]],[[260642,356395],[-399,433]],[[260243,356828],[-13,6119]],[[254287,359046],[-781,-1739]],[[253506,357307],[-228,2117]],[[286374,362810],[-59,-945]],[[286315,361865],[-36,-106]],[[286226,362369],[148,441]],[[260243,356828],[-662,-2213]],[[259581,354615],[-529,3938]],[[256006,361111],[-211,-8003]],[[255795,353108],[-851,-65]],[[254944,353043],[-147,-18]],[[254797,353025],[95,6137],[-205,657]],[[285916,358061],[-1039,-4907]],[[284877,353154],[-34,77]],[[284843,353231],[-42,1109]],[[284801,354340],[305,3818],[-96,1553]],[[285497,362381],[59,-1872],[467,-1558],[-107,-890]],[[271273,359011],[-157,-551]],[[271116,358460],[-308,-1198],[-364,-180],[-73,-1054],[-635,-1658]],[[269736,354370],[-208,3109]],[[278766,360972],[-356,-9724]],[[278410,351248],[-345,-5]],[[278065,351243],[106,760],[-263,1161],[-285,-492],[86,-1439]],[[277709,351233],[-112,-1]],[[277597,351232],[-569,22]],[[277028,351254],[206,5849]],[[275577,357401],[-419,-1374],[-218,-1669]],[[274940,354358],[-473,4153]],[[249232,357166],[-26,-4320],[-719,34]],[[248487,352880],[-528,25]],[[247959,352905],[-9,1582],[-298,3843]],[[281795,360205],[-66,-4559]],[[281729,355646],[-596,560],[-701,1550]],[[286315,361865],[307,-510],[-325,-1766]],[[284721,358747],[-1328,-4408]],[[283393,354339],[-167,252],[88,2639],[-447,277]],[[246482,358413],[44,-2142]],[[246526,356271],[-1263,227]],[[245263,356498],[-303,38],[5,1083]],[[240284,361096],[-17,-4867]],[[240267,356229],[-1101,143]],[[239166,356372],[-105,8],[12,3261],[-759,62]],[[274170,357529],[-841,-1352]],[[273329,356177],[-156,-696],[-455,-110]],[[272718,355371],[-328,3524]],[[257813,357600],[-221,-728],[-202,-3628]],[[257390,353244],[-829,-106]],[[256561,353138],[21,7778]],[[256561,353138],[-151,-14]],[[256410,353124],[-615,-16]],[[242553,360828],[-66,-4878]],[[242487,355950],[-1818,221]],[[240669,356171],[-402,58]],[[253506,357307],[130,-2237]],[[253636,355070],[-1045,64]],[[252591,355134],[5,3574]],[[250877,358721],[-61,-2945]],[[250816,355776],[-215,-1257],[64,-1203]],[[250665,353316],[-203,-1647],[-216,1259]],[[250246,352928],[-536,4426]],[[279999,354157],[-151,-412],[-88,-2491]],[[279760,351254],[-173,-5]],[[279587,351249],[-953,1]],[[278634,351250],[-224,-2]],[[243753,357717],[-40,-7254]],[[243713,350463],[-1248,-11]],[[242465,350452],[22,5498]],[[237053,358511],[-17,-3425]],[[237036,355086],[-1531,349]],[[235505,355435],[1,4326]],[[266233,358957],[17,-975],[-599,-2206],[-221,-1817]],[[265430,353959],[-521,3091],[-84,1894]],[[282758,357817],[6,-3369],[-310,-3129]],[[282454,351319],[-369,-15]],[[282085,351304],[-408,-9]],[[281677,351295],[52,4351]],[[268214,357779],[-540,-707],[-177,-2081],[-906,-1449]],[[266591,353542],[-141,2662],[60,1629]],[[272718,355371],[-733,-1028],[-226,-1288]],[[271759,353055],[-261,2814],[-382,2591]],[[192649,359743],[0,-24859],[484,-3],[-47,-2692],[-3,-12919],[-57,-4901],[47,-1624],[-30,-12942],[-91,-9],[0,-3908]],[[192952,295886],[-303,170]],[[192649,296056],[0,7876],[-2090,0],[0,4901]],[[190559,308833],[0,51008]],[[190559,308833],[-267,68],[-549,2097],[-586,1352],[-625,-722],[-214,1094]],[[188318,312722],[8,6149],[-629,15],[-1,3314],[-1550,-155],[-3,3263],[-297,21],[4,2068],[-380,-318],[-149,1053],[-899,1045],[-616,2799],[-445,402]],[[183361,332378],[1,5119],[67,1656],[-123,2775],[363,944],[70,1118],[518,1618],[615,865],[469,2332],[-89,1927],[91,1456],[24,3833],[237,2875],[-31,898]],[[254797,353025],[-1049,764]],[[253748,353789],[-112,1281]],[[233306,359768],[-67,-1052],[1,-6427]],[[233240,352289],[-1054,-2]],[[232186,352287],[-1,6412],[65,1069]],[[231654,359760],[-1,-10708]],[[231653,349052],[-2,-4884],[-743,12]],[[230908,344180],[41,1148],[-278,232],[-357,1844],[-191,-673],[-230,2345],[-236,377],[-144,2237],[-300,-1766],[-371,678]],[[228842,350602],[273,1700],[-394,-68]],[[228721,352234],[-27,1706],[357,-36],[129,1256],[379,564],[8,4038]],[[224566,359758],[31,-9970]],[[224597,349788],[-210,-1342],[-482,1078],[-172,1065],[-325,12]],[[223408,350601],[-47,1717],[-453,3424],[-433,680]],[[222475,356422],[-448,3349]],[[234421,359772],[22,-6122]],[[234443,353650],[-17,-2995]],[[234426,350655],[-898,9]],[[233528,350664],[-1,1625],[-287,0]],[[232186,352287],[-8,-3237]],[[232178,349050],[-525,2]],[[227582,359757],[-1,-7541]],[[227581,352216],[-1788,-1]],[[225793,352215],[-21,7531]],[[225793,352215],[0,-2429]],[[225793,349786],[-1196,2]],[[228721,352234],[-1137,-18]],[[227584,352216],[-3,0]],[[235505,355435],[1,-1837]],[[235506,353598],[-1063,52]],[[222475,356422],[0,-4178],[-865,-44]],[[221610,352200],[-1107,8]],[[220503,352208],[1,7605]],[[203776,359694],[98,-2074],[-26,-3169],[117,-4650],[-91,-2221],[-239,-893],[559,-1234],[337,-2424],[573,-1622]],[[205104,341407],[-115,-752],[-407,114]],[[204582,340769],[2,439],[-988,-6],[48,-1326],[-533,2]],[[203111,339878],[-7,660]],[[203104,340538],[2,655],[-1777,-48],[0,4051],[-2059,60]],[[199270,345256],[16,10890],[481,2044],[69,1591]],[[199270,345256],[-7,-4086]],[[199263,341170],[-3954,38]],[[195309,341208],[2,18556]],[[195309,341208],[0,-19410]],[[195309,321798],[-1,-7083]],[[195308,314715],[-2,-14913]],[[195306,299802],[-838,-13],[-15,-899],[-397,-1422]],[[194056,297468],[-882,-3135],[-222,1553]],[[212147,359783],[-1,-9303]],[[212146,350480],[-110,1],[3,-8288]],[[212039,342193],[-1,-5881]],[[212038,336312],[-930,12]],[[211108,336324],[28,6448],[-1196,-11],[1,1643],[-599,9],[0,810]],[[209342,345223],[3,14488]],[[214861,359653],[-12,-9170]],[[214849,350483],[-362,-4]],[[214487,350479],[-2341,1]],[[217877,359752],[-24,-9286]],[[217853,350466],[-365,-7]],[[217488,350459],[-1501,5]],[[215987,350464],[-1138,19]],[[220503,352208],[-3,-1741]],[[220500,350467],[-1510,-6]],[[218990,350461],[-1137,5]],[[284801,354340],[42,-1109]],[[284877,353154],[-51,-1711]],[[284826,351443],[-1,-152]],[[284825,351291],[-691,43]],[[284134,351334],[-370,-26]],[[283764,351308],[-248,1790],[-323,549],[200,692]],[[263478,357307],[2,-789],[-559,-4123]],[[262921,352395],[-20,2]],[[262901,352397],[-528,227]],[[262373,352624],[-249,4527]],[[205966,359691],[58,-1481],[-86,-3571],[-387,-996],[-22,-2199],[163,-1117],[-61,-4280]],[[205631,346047],[-183,-448],[-37,-1983],[-307,-2209]],[[209342,345223],[-1191,14]],[[208151,345237],[-1195,-14],[1,803],[-1326,21]],[[239166,356372],[-30,-5934]],[[239136,350438],[-750,14]],[[238386,350452],[29,5979],[-103,1914]],[[162899,346141],[-231,-1190],[-456,1973],[-261,-927],[-61,1184],[-572,3412],[-183,-61],[-19,1981],[-417,1414],[44,778],[-533,3123]],[[265430,353959],[-148,-1854]],[[265282,352105],[-222,46]],[[265060,352151],[-603,36]],[[264457,352187],[-224,1543],[-135,2569],[163,2476]],[[286694,356681],[-124,-213]],[[286570,356468],[-12,177]],[[286558,356645],[136,36]],[[286870,358327],[-79,-1657]],[[286791,356670],[-328,768],[3,1657],[404,-768]],[[264457,352187],[-96,-2]],[[264361,352185],[-1440,210]],[[266591,353542],[-596,-1193]],[[265995,352349],[-713,-244]],[[251680,358786],[-1,-3231]],[[251679,355555],[-863,221]],[[252591,355134],[-9,-4639]],[[252582,350495],[-78,9]],[[252504,350504],[-835,20]],[[251669,350524],[10,5031]],[[261703,357074],[-225,-4257]],[[261478,352817],[-392,-140]],[[261086,352677],[-444,3718]],[[259581,354615],[12,-1748]],[[259593,352867],[-646,209]],[[258947,353076],[-577,206]],[[258370,353282],[16,2332]],[[238386,350452],[-787,-3]],[[237599,350449],[-586,0]],[[237013,350449],[23,4637]],[[287471,351575],[127,-159]],[[287598,351416],[-118,-4]],[[287480,351412],[-9,163]],[[287748,351418],[-69,0]],[[287679,351418],[-139,3115],[-110,-3119]],[[287430,351414],[-90,0]],[[287340,351414],[-61,2]],[[287279,351416],[-242,-2]],[[287037,351414],[1,2144],[150,496],[-378,1440],[-61,1239]],[[286749,356733],[42,-63]],[[286870,358327],[530,-179],[348,-6730]],[[274940,354358],[-364,-882],[-48,-1926]],[[274528,351550],[-629,24]],[[273899,351574],[-213,1696]],[[273686,353270],[-50,397]],[[273636,353667],[-307,2510]],[[270321,353193],[0,0]],[[270321,353193],[-338,-940]],[[269983,352253],[-141,1]],[[269842,352254],[-106,2116]],[[271759,353055],[-114,-499]],[[271645,352556],[-501,43]],[[271144,352599],[-890,-363]],[[270254,352236],[67,957]],[[247959,352905],[-202,-2472]],[[247757,350433],[-990,13]],[[246767,350446],[-44,3366],[-197,2459]],[[286570,356468],[-316,-133]],[[286254,356335],[304,310]],[[286305,356801],[-99,492]],[[286206,357293],[36,564]],[[286242,357857],[63,-1056]],[[286206,357293],[-103,-959],[-95,-4918]],[[286008,351416],[-140,0]],[[285868,351416],[-1042,27]],[[285916,358061],[-22,-1249],[348,1045]],[[163912,339436],[276,-2209]],[[164188,337227],[-3150,124]],[[161038,337351],[-326,1746],[-77,1735],[-231,787],[-396,3161],[-503,2053],[-222,5106],[442,1738],[41,3417]],[[283764,351308],[-1310,11]],[[283158,354580],[0,0]],[[268512,356056],[-491,-2310],[-105,-1528]],[[267916,352218],[-1356,66]],[[266560,352284],[-565,65]],[[281677,351295],[-774,-7]],[[280903,351288],[-371,-27]],[[280532,351261],[-772,-7]],[[262373,352624],[-838,204]],[[261535,352828],[-57,-11]],[[245263,356498],[-29,-6068]],[[245234,350430],[-782,-12]],[[244452,350418],[-119,11]],[[244333,350429],[-620,34]],[[269842,352254],[-878,-30]],[[268964,352224],[-617,-6]],[[268347,352218],[-431,0]],[[258370,353282],[-422,-315]],[[257948,352967],[-558,277]],[[276118,355953],[-148,-276],[114,-4413]],[[276084,351264],[-1077,151]],[[275007,351415],[-479,135]],[[250246,352928],[-253,-2473]],[[249993,350455],[-185,-21]],[[249808,350434],[-152,5]],[[249656,350439],[-17,-3004]],[[249639,347435],[-129,1228],[-367,441],[-80,-746],[-583,45]],[[248480,348403],[7,4477]],[[286305,356801],[-51,-466]],[[286694,356681],[55,52]],[[287037,351414],[-532,-2]],[[286505,351412],[-497,4]],[[277028,351254],[-871,10]],[[276157,351264],[-73,0]],[[276536,353676],[0,0]],[[181366,356861],[18,-12097],[-305,-3168],[-223,-193],[-381,2417],[-725,-8],[-350,-1052],[144,-4363],[76,-6300],[227,-3470],[73,-3058],[-216,-1125],[36,-1876]],[[179740,322568],[-2834,15079]],[[261086,352677],[-980,64]],[[260106,352741],[-513,126]],[[246767,350446],[-580,-1]],[[246187,350445],[-953,-15]],[[240669,356171],[-21,-5742]],[[240648,350429],[-227,4]],[[240421,350433],[-1233,7]],[[239188,350440],[-52,-2]],[[223408,350601],[13,-6429]],[[223421,344172],[-1188,51]],[[222233,344223],[-596,-4],[-27,7981]],[[273636,353667],[50,-397]],[[273899,351574],[-178,50]],[[273721,351624],[-1258,239]],[[272463,351863],[-903,251]],[[271560,352114],[85,442]],[[242465,350452],[-84,-5]],[[242381,350447],[-1055,0]],[[241326,350447],[-678,-18]],[[251669,350524],[-28,4]],[[251641,350528],[-22,-4]],[[251619,350524],[-191,1382],[-763,1410]],[[237013,350449],[-1507,13]],[[235506,350462],[0,3136]],[[253748,353789],[47,-3359]],[[253795,350430],[-1213,65]],[[170339,337196],[-4266,59]],[[166073,337255],[29,8918],[143,-17],[5,2474],[-284,1630]],[[254944,353043],[136,-5034]],[[255080,348009],[-639,-725],[-444,466]],[[253997,347750],[-26,131]],[[253971,347881],[-176,2549]],[[235506,350462],[154,-6283]],[[235660,344179],[-653,-10]],[[235007,344169],[-597,8]],[[234410,344177],[16,6478]],[[257414,348713],[-201,-1048],[-241,622]],[[256972,348287],[-208,-250],[-369,1607]],[[256395,349644],[15,3480]],[[257948,352967],[-373,-4226],[-161,-28]],[[258947,353076],[-67,-2837]],[[258880,350239],[-152,-2605]],[[258728,347634],[-470,-221],[-397,-1686]],[[257861,345727],[-447,2986]],[[249808,350434],[-152,5]],[[251619,350524],[-1425,9]],[[250194,350533],[-201,-78]],[[256395,349644],[-463,-2486]],[[255932,347158],[-632,238]],[[255300,347396],[-220,613]],[[278065,351243],[-356,-10]],[[260035,350463],[-39,-1632]],[[259996,348831],[-420,265]],[[259576,349096],[-528,340],[-168,803]],[[260106,352741],[-71,-2278]],[[270254,352236],[-271,17]],[[248480,348403],[6,-7255]],[[248486,341148],[-919,-50]],[[247567,341098],[-247,-14]],[[247320,341084],[522,3829]],[[247842,344913],[352,1893],[-43,1810],[-210,1819],[-184,-2]],[[262901,352397],[149,-1465]],[[263050,350932],[-592,1051],[-298,-537],[-193,-2702]],[[261967,348744],[-458,2312]],[[261509,351056],[26,1772]],[[261509,351056],[-433,-574],[-153,-1811]],[[260923,348671],[-582,2219],[-306,-427]],[[270706,350628],[-572,-2009],[-308,-73]],[[269826,348546],[-389,913],[-672,-256]],[[268765,349203],[199,3021]],[[271144,352599],[-438,-1971]],[[271560,352114],[-142,-3666]],[[271418,348448],[-528,-1943]],[[270890,346505],[-41,-397]],[[270849,346108],[-351,1893],[300,1976],[-92,651]],[[264361,352185],[5,-1439],[-252,-900],[56,-3382],[-120,-1264]],[[264050,345200],[-190,-992]],[[263860,344208],[-474,1990],[-250,1871]],[[263136,348069],[117,454],[-203,2409]],[[266560,352284],[206,-1169],[31,-2258]],[[266797,348857],[-174,-720],[-607,-561]],[[266016,347576],[-183,13],[-202,1690],[-279,-296]],[[265352,348983],[-292,3168]],[[228842,350602],[-61,-3232],[298,0],[0,-1617]],[[229079,345753],[-602,-1],[-1,-1624],[-593,-2]],[[227883,344126],[-297,100]],[[227586,344226],[-2,7990]],[[268347,352218],[-502,-560],[-752,-3146]],[[267093,348512],[-296,345]],[[233528,350664],[-299,-2],[-13,-8097]],[[233216,342565],[-366,1],[-131,1627],[-399,1]],[[232320,344194],[-150,-1],[8,4857]],[[265352,348983],[-275,-2785]],[[265077,346198],[-193,-791],[-429,316],[-38,-1253],[-367,730]],[[268765,349203],[-61,-398]],[[268704,348805],[-665,-1447],[-393,-1683]],[[267646,345675],[-224,1918],[-258,-1047]],[[267164,346546],[-71,1966]],[[227586,344226],[-599,4]],[[226987,344230],[-1193,4]],[[225794,344234],[-1,5552]],[[222233,344223],[3,-2818]],[[222236,341405],[-225,-158],[-276,-2614],[-162,-422],[-441,842],[-101,2155],[-521,-2268]],[[220510,338940],[0,3261]],[[220510,342201],[-10,8266]],[[272463,351863],[277,-3899]],[[272740,347964],[-622,-2325]],[[272118,345639],[-700,2809]],[[263136,348069],[-494,-1685],[-81,-2308]],[[262561,344076],[-537,-332]],[[262024,343744],[-54,115]],[[261970,343859],[103,957],[-106,3928]],[[273721,351624],[-182,-2986]],[[273539,348638],[-167,-516],[-189,1242],[-443,-1400]],[[230908,344180],[-82,5]],[[230826,344185],[-902,-43]],[[229924,344142],[-550,-15],[0,1626],[-295,0]],[[275007,351415],[-33,-5379]],[[274974,346036],[-1,-378]],[[274973,345658],[-247,763],[-926,-860]],[[273800,345561],[12,1685],[-273,1392]],[[285868,351416],[140,-749]],[[286008,350667],[106,-2464]],[[286114,348203],[-296,-486]],[[285818,347717],[-335,-961]],[[285483,346756],[-266,1180],[-452,775]],[[284765,348711],[60,2580]],[[287518,346134],[-187,1417]],[[287331,347551],[-272,272],[-554,3589]],[[287279,351416],[112,-2597],[320,-2366],[229,-3945],[-422,3626]],[[287748,351418],[261,-5943]],[[288009,345475],[-7,-9]],[[288002,345466],[-124,1107],[-199,4845]],[[287598,351416],[-258,-2]],[[287430,351414],[50,-2]],[[276157,351264],[-22,-5309]],[[276135,345955],[-1161,81]],[[287331,347551],[294,-3319],[-296,418],[-595,3435]],[[286734,348085],[-726,2582]],[[282085,351304],[5,-704]],[[282090,350600],[-40,-2323],[-263,-3338]],[[281787,344939],[-837,1178]],[[280950,346117],[82,751],[-129,4420]],[[284010,345760],[-232,-1458]],[[283778,344302],[-264,840],[-153,2057],[-292,-389],[-26,2141],[-250,1169],[-703,480]],[[284134,351334],[123,-1350],[-247,-4224]],[[284765,348711],[428,-836],[170,-2171]],[[285363,345704],[-1353,56]],[[279587,351249],[-16,-5692]],[[279571,345557],[-415,60]],[[279156,345617],[-565,56]],[[278591,345673],[43,5577]],[[280950,346117],[-322,-1897],[-207,205]],[[280421,344425],[-40,5196],[151,1640]],[[280421,344425],[-138,-2848]],[[280283,341577],[-564,914]],[[279719,342491],[-155,441],[7,2625]],[[277597,351232],[-60,-5440]],[[277537,345792],[-1,-133]],[[277536,345659],[-1401,296]],[[278591,345673],[-288,31]],[[278303,345704],[-766,88]],[[261970,343859],[-836,1715],[-211,1218]],[[260923,346792],[0,1879]],[[260923,346792],[-350,-1703],[-444,506]],[[260129,345595],[-184,949],[51,2287]],[[283778,344302],[137,-1340],[-235,-399]],[[283680,342563],[-211,-1306]],[[283469,341257],[-343,603],[-21,992],[-459,1162]],[[282646,344014],[-526,-168],[-333,1093]],[[234410,344177],[-298,-3],[1,-1624],[-250,5]],[[233863,342555],[-647,10]],[[270849,346108],[-412,-3021]],[[270437,343087],[-395,999]],[[270042,344086],[-95,1420],[-234,365]],[[269713,345871],[113,2675]],[[286734,348085],[37,-1381],[441,-2720],[-295,-510],[-337,1726]],[[286580,345200],[-247,782],[-219,2221]],[[251641,350528],[29,-1722],[-373,-22],[-27,-3471]],[[251270,345313],[-542,-338]],[[250728,344975],[-915,150]],[[249813,345125],[342,3659],[39,1749]],[[225794,344234],[-297,0]],[[225497,344234],[-1188,0]],[[224309,344234],[-888,-62]],[[252504,350504],[-37,-6508]],[[252467,343996],[-452,-1664]],[[252015,342332],[-416,1162],[-329,1819]],[[249813,345125],[-408,-509]],[[249405,344616],[-184,1254],[448,35],[-218,1039],[188,491]],[[215988,342196],[-1503,-3]],[[214485,342193],[2,8286]],[[215987,350464],[1,-8268]],[[253971,347881],[-287,-10],[29,-1851],[-361,-2613]],[[253352,343407],[3,475],[-888,114]],[[217487,342236],[0,-43]],[[217487,342193],[-1499,3]],[[217488,350459],[-1,-8223]],[[214485,342193],[-2446,0]],[[218990,350461],[-2,-8244]],[[218988,342217],[-1501,19]],[[220510,342201],[-1504,15]],[[219006,342216],[-18,1]],[[237599,350449],[-66,-2391],[209,-1186]],[[237742,346872],[-201,-1332]],[[237541,345540],[-237,-554],[-1005,172],[-161,-2143],[-448,53]],[[235690,343068],[-30,1111]],[[244333,350429],[-13,-3019],[-310,36],[-1,-1628],[-349,62]],[[243660,345880],[-1297,148]],[[242363,346028],[18,4419]],[[239188,350440],[-10,-7018]],[[239178,343422],[-500,71]],[[238678,343493],[-199,24],[-297,3290],[-440,65]],[[244452,350418],[274,-1428],[139,-3024]],[[244865,345966],[-253,-502],[-21,-6336]],[[244591,339128],[-295,861],[-689,91]],[[243607,340080],[78,1094],[-25,4706]],[[246125,346133],[-9,-2184]],[[246116,343949],[-922,327],[-329,1690]],[[246187,350445],[91,-4019],[-153,-293]],[[240421,350433],[-86,-130],[-16,-7014]],[[240319,343289],[-151,19]],[[240168,343308],[-990,114]],[[241326,350447],[-51,-4301],[214,-302],[163,-1657],[2,-1854]],[[241654,342333],[-1188,137],[-147,819]],[[242363,346028],[-108,-2388]],[[242255,343640],[-5,-1372],[-299,33],[-7,-1620],[-298,34]],[[241646,340715],[8,1618]],[[247842,344913],[-364,-14],[3,1093],[-1356,141]],[[166073,337255],[-1825,-23]],[[164248,337232],[-60,-5]],[[259576,349096],[-440,-2424]],[[259136,346672],[-408,962]],[[256972,348287],[-235,-4733],[-157,-1542]],[[256580,342012],[-358,78]],[[256222,342090],[89,2409],[-69,2509],[-310,150]],[[256334,346649],[0,0]],[[269713,345871],[-270,-1826],[-440,-1090]],[[269003,342955],[-147,935],[39,5066],[-191,-151]],[[273800,345561],[-24,-3359]],[[273776,342202],[-410,-186]],[[273366,342016],[-834,-920]],[[272532,341096],[-604,2255]],[[271928,343351],[190,2288]],[[266016,347576],[-182,-3348]],[[265834,344228],[-583,406]],[[265251,344634],[-174,1564]],[[260129,345595],[-76,-1981]],[[260053,343614],[-159,-706],[-544,-142]],[[259350,342766],[-214,3906]],[[249405,344616],[100,-1066],[-238,-810],[-78,-1541]],[[249189,341199],[-703,-51]],[[232320,344194],[0,-4873],[-163,-839]],[[232157,338482],[-593,17]],[[231564,338499],[9,4068],[-746,8],[-1,1610]],[[267164,346546],[-203,142],[-387,-2272]],[[266574,344416],[-254,92],[-305,-1843]],[[266015,342665],[-181,1563]],[[257861,345727],[219,-2690]],[[258080,343037],[-288,-2464]],[[257792,340573],[-469,1262],[-395,311],[-275,-1179],[-73,1045]],[[269003,342955],[-22,-1049]],[[268981,341906],[-95,483],[-414,-1436],[-99,-1242],[-215,431]],[[268158,340142],[-746,4390]],[[267412,344532],[234,1143]],[[271928,343351],[-738,-110]],[[271190,343241],[-274,1942],[-26,1322]],[[286580,345200],[260,-2059],[-166,-58],[-563,1793],[417,-1963],[-516,-158]],[[286012,342755],[-231,471],[37,4491]],[[263860,344208],[277,-2132]],[[264137,342076],[-291,-1173],[-653,-1443]],[[263193,339460],[-112,1610],[-520,3006]],[[255300,347396],[-148,-2919]],[[255152,344477],[-646,1244],[-421,-30]],[[254085,345691],[-88,2059]],[[254085,345691],[76,-2249],[-252,-3271],[243,-246],[-104,-1722]],[[254048,338203],[-22,-470]],[[254026,337733],[-577,561]],[[253449,338294],[-110,14],[13,5099]],[[259350,342766],[125,-2327]],[[259475,340439],[-385,-124]],[[259090,340315],[-438,450],[-572,2272]],[[286012,342755],[225,-327],[-290,-1136],[-496,1123],[-83,1530],[115,2811]],[[267412,344532],[-191,-1783]],[[267221,342749],[-165,989],[-482,678]],[[256222,342090],[-60,-1685]],[[256162,340405],[-921,637]],[[255241,341042],[-89,3435]],[[238678,343493],[80,-2934],[-203,-1599],[13,-2198]],[[238568,336762],[-493,95]],[[238075,336857],[-599,-165]],[[237476,336692],[-145,22]],[[237331,336714],[53,6146],[157,2680]],[[262024,343744],[-408,-705],[-49,-2263]],[[261567,340776],[-127,977],[-554,938],[-379,-1246]],[[260507,341445],[-454,2169]],[[265251,344634],[-424,-2187],[97,-598],[-378,-805],[-214,-1552]],[[264332,339492],[-195,2584]],[[274973,345658],[38,-1939],[-162,-1684]],[[274849,342035],[-546,78]],[[274303,342113],[-527,89]],[[271190,343241],[205,-849],[-197,-1934]],[[271198,340458],[-379,-47]],[[270819,340411],[-107,-893]],[[270712,339518],[-146,571],[-129,2998]],[[281787,344939],[-692,-7162]],[[281095,337777],[-139,1398],[-673,2402]],[[247320,341084],[-33,-576],[-1289,60]],[[245998,340568],[118,3381]],[[208151,345237],[293,-4777],[-163,-1891],[63,-1473]],[[208344,337096],[-1781,-187],[-951,1848],[-1038,6]],[[204574,338763],[8,2006]],[[276135,345955],[-22,-4592]],[[276113,341363],[-980,-698]],[[275133,340665],[-284,1370]],[[243607,340080],[-387,-1384]],[[243220,338696],[-296,1224],[-438,79],[156,1793],[-387,1848]],[[270042,344086],[-542,-1569]],[[269500,342517],[-247,-1769]],[[269253,340748],[-294,-190],[22,1348]],[[245998,340568],[-64,-1620],[-438,77]],[[245496,339025],[-463,92]],[[245033,339117],[-442,11]],[[277536,345659],[-27,-6363]],[[277509,339296],[-1406,391]],[[276103,339687],[10,1676]],[[278303,345704],[22,-6834]],[[278325,338870],[33,-603],[-850,-17]],[[277508,338250],[1,1046]],[[229924,344142],[1,-4066]],[[229925,340076],[-1447,8]],[[228478,340084],[-594,801],[-1,3241]],[[255241,341042],[-480,-1635],[-27,-1245]],[[254734,338162],[-379,-650],[-307,691]],[[285363,345704],[-90,-1720],[200,-3016],[-54,-1229]],[[285419,339739],[-161,-1091]],[[285258,338648],[-207,365],[-191,-1125],[-97,1432],[-186,-785],[-144,1522],[-394,-15],[-22,1229],[-337,1292]],[[279156,345617],[-183,-6998]],[[278973,338619],[-648,251]],[[279719,342491],[139,-1156],[-370,-2640],[-207,11]],[[279281,338706],[-308,-87]],[[237331,336714],[-1477,-33]],[[235854,336681],[-164,6387]],[[288818,335050],[63,-1480],[-197,-6894],[-610,-638]],[[288074,326038],[-5,98]],[[288069,326136],[643,1434],[149,5776],[-43,1704]],[[287690,334443],[-349,562]],[[287341,335005],[74,4092],[488,661],[174,-763],[41,-4813],[-337,-752],[-91,1013]],[[288009,345475],[568,-6869],[-469,3338],[-106,3522]],[[252015,342332],[-40,-5057]],[[251975,337275],[-583,117]],[[251392,337392],[-539,1205],[-221,2559]],[[250632,341156],[96,3819]],[[203103,338170],[0,312]],[[203103,338482],[0,-312]],[[203104,340538],[-422,-117],[-2,-2838],[423,-966]],[[203103,336617],[9,-10066]],[[203112,326551],[-2650,80]],[[200462,326631],[-119,1602],[-198,-3]],[[200145,328230],[5,12910],[-887,30]],[[211108,336324],[-13,-6367],[-717,-154]],[[210378,329803],[-244,605],[-702,7065],[-124,-377],[-964,0]],[[250632,341156],[-254,-2106],[-174,-102]],[[250204,338948],[-181,1222],[-661,-786]],[[249362,339384],[-173,1815]],[[282646,344014],[-362,-5323]],[[282284,338691],[-1014,-2547]],[[281270,336144],[-175,1633]],[[267221,342749],[-212,-3524]],[[267009,339225],[-457,518],[-553,2138]],[[265999,341881],[16,784]],[[265999,341881],[52,-1239],[-389,-1579]],[[265662,339063],[-165,-856],[-257,652],[-539,-385],[-75,-938]],[[264626,337536],[-271,1710]],[[264355,339246],[-23,246]],[[268158,340142],[-176,-2868]],[[267982,337274],[-326,-27],[-492,-1365]],[[267164,335882],[-155,3343]],[[263193,339460],[-282,-1554]],[[262911,337906],[-375,-1179]],[[262536,336727],[-941,74]],[[261595,336801],[1,25]],[[261596,336826],[-53,386]],[[261543,337212],[10,105]],[[261553,337317],[156,2179],[-142,1280]],[[226987,344230],[5,-8167]],[[226992,336063],[-1485,-16]],[[225507,336047],[-10,8187]],[[228478,340084],[-1,-4053]],[[228477,336031],[-1485,32]],[[225507,336047],[-296,-3],[0,-3229]],[[225211,332815],[-863,2]],[[224348,332817],[-25,4855]],[[224323,337672],[-14,6562]],[[224323,337672],[-2072,-4]],[[222251,337668],[-15,3737]],[[231564,338499],[-444,4],[-1,-4058]],[[231119,334445],[-1192,-1]],[[229927,334444],[-2,5632]],[[233863,342555],[-208,-1974],[146,-1820],[-99,-1073]],[[233702,337688],[-1043,-409],[-29,1219],[-323,-7]],[[232307,338491],[-150,-9]],[[235007,344169],[-28,-9733]],[[234979,334436],[-892,6]],[[234087,334442],[1,3236],[-386,10]],[[235854,336681],[57,-2246]],[[235911,334435],[-932,1]],[[270712,339518],[-422,-1622]],[[270290,337896],[-183,3519],[-607,1102]],[[283469,341257],[168,-1847],[-22,-1611]],[[283615,337799],[-112,244],[-755,-2883]],[[282748,335160],[-250,2798],[-214,733]],[[253449,338294],[-4,-541]],[[253445,337753],[-1088,149],[-103,-659]],[[252254,337243],[-279,32]],[[260507,341445],[21,-2479],[-126,-943]],[[260402,338023],[-565,156]],[[259837,338179],[-362,2260]],[[243220,338696],[34,-3025]],[[243254,335671],[-1124,135]],[[242130,335806],[-496,71],[5,1352]],[[241639,337229],[7,3486]],[[240168,343308],[-18,-7270]],[[240150,336038],[-594,78]],[[239556,336116],[-989,104],[1,542]],[[272532,341096],[-16,-3721]],[[272516,337375],[-83,-532]],[[272433,336843],[-535,176],[-700,3439]],[[241639,337229],[-594,41],[-3,-1349],[-498,75]],[[240544,335996],[-394,42]],[[259090,340315],[-150,-4665]],[[258940,335650],[-106,-1338]],[[258834,334312],[-300,532],[-141,-775],[-313,1294],[-345,-46]],[[257735,335317],[-130,449]],[[257605,335766],[203,1497],[-16,3310]],[[270290,337896],[-396,-2234]],[[269894,335662],[-202,1972],[-170,143]],[[269522,337777],[-269,2971]],[[261596,336826],[-53,386]],[[261553,337317],[-455,475],[-475,-445]],[[260623,337347],[-221,676]],[[281095,337777],[-585,-2047],[-679,-3519]],[[279831,332211],[-571,1186]],[[279260,333397],[-227,517],[248,4792]],[[285258,338648],[-235,-2967]],[[285023,335681],[-392,-875],[-524,1391]],[[284107,336197],[-492,1602]],[[269522,337777],[-293,-274],[-813,-2185],[-219,-149]],[[268197,335169],[-215,2105]],[[275133,340665],[83,-1449],[-296,-1328],[32,-1468]],[[274952,336420],[-480,1873],[-210,137]],[[274262,338430],[41,3683]],[[219006,342216],[1,-8139]],[[219007,334077],[-1521,-4]],[[217486,334073],[0,115]],[[217486,334188],[1,8005]],[[220510,338940],[0,-4867]],[[220510,334073],[-1503,4]],[[217486,334188],[-1496,-23]],[[215990,334165],[-2,8031]],[[214485,342193],[1,-7963]],[[214486,334230],[-2449,-96]],[[212037,334134],[1,2178]],[[274262,338430],[-178,-3319],[96,-3116]],[[274180,331995],[-135,-24]],[[274045,331971],[-450,-339]],[[273595,331632],[-36,1117]],[[273559,332749],[96,1381],[-522,2938]],[[273133,337068],[300,3340],[-67,1608]],[[215990,334165],[0,-71]],[[215990,334094],[-1504,-3]],[[214486,334091],[0,139]],[[257605,335766],[-267,-59]],[[257338,335707],[-1207,2677]],[[256131,338384],[31,2021]],[[273133,337068],[-79,883],[-538,-576]],[[263585,335029],[0,0]],[[263585,335029],[-124,-484]],[[263461,334545],[-99,4]],[[263362,334549],[-9,1250],[-281,765]],[[263072,336564],[-161,1342]],[[264355,339246],[-770,-4217]],[[267164,335882],[3,-378]],[[267167,335504],[-680,-2475],[-459,115]],[[266028,333144],[-109,2607],[-257,3312]],[[276103,339687],[-56,-7726]],[[276047,331961],[-323,-24]],[[275724,331937],[-70,1389],[-359,2653],[-343,441]],[[222251,337668],[32,-5648]],[[222283,332020],[-589,1],[-1,-1624],[-1183,13]],[[220510,330410],[0,3663]],[[200145,328230],[-3228,28],[-2,-6474],[-1606,14]],[[204574,338763],[16,-15442]],[[204590,323321],[-1474,-28]],[[203116,323293],[-4,3258]],[[203103,336617],[208,1297],[-208,256]],[[203103,338482],[8,1396]],[[249362,339384],[-275,31],[115,-1382],[-335,-1404],[-366,-377],[270,-1926],[-281,-846],[135,-918]],[[248625,332562],[-364,175],[-4,-2806]],[[248257,329931],[-36,-136]],[[248221,329795],[-36,1334],[-212,-483]],[[247973,330646],[-400,66]],[[247573,330712],[0,4866]],[[247573,335578],[-6,5520]],[[272433,336843],[-475,-3705]],[[271958,333138],[-10,-82]],[[271948,333056],[-430,281]],[[271518,333337],[-367,-86]],[[271151,333251],[-126,2692],[-326,1639],[222,1422],[-102,1407]],[[251392,337392],[-291,-2345],[-136,397]],[[250965,335444],[-553,1154],[-246,1169]],[[250166,337767],[38,1181]],[[247573,335578],[-2090,161]],[[245483,335739],[13,3286]],[[286926,335502],[-145,-1822],[-233,206],[79,1506],[-351,140]],[[286276,335532],[78,4358]],[[286354,339890],[552,1171],[303,-80],[50,-5635],[-333,156]],[[256131,338384],[-53,-2345],[-292,-1221]],[[255786,334818],[-336,-819],[-354,711],[-199,-818]],[[254897,333892],[-239,1016],[76,3254]],[[286276,335532],[-676,145]],[[285600,335677],[-577,4]],[[285419,339739],[847,1101],[88,-950]],[[259837,338179],[-278,-1956],[-1,-1386]],[[259558,334837],[-289,-248],[-329,1061]],[[271151,333251],[-416,-936],[-546,61]],[[270189,332376],[-338,1183],[43,2103]],[[250166,337767],[-127,96],[-281,-4503]],[[249758,333360],[-308,1168],[-405,125],[-420,-2091]],[[229927,334444],[-12,-3282]],[[229915,331162],[-1439,23]],[[228476,331185],[1,4846]],[[245033,339117],[-93,-1439],[-340,-1930],[-43,-3401],[-592,76]],[[243965,332423],[-591,68]],[[243374,332491],[12,3307],[-132,-127]],[[277508,338250],[-37,-6114]],[[277471,332136],[-595,-67]],[[276876,332069],[-829,-108]],[[263633,333862],[1,202]],[[263634,334064],[-1,-202]],[[264626,337536],[88,-2616],[-150,-1006]],[[264564,333914],[-285,822],[-464,206],[-191,-774]],[[263624,334168],[-163,377]],[[245483,335739],[-6,-4945]],[[245477,330794],[-2,-1650]],[[245475,329144],[-590,62],[-3,1642],[-263,-126]],[[244619,330722],[-662,63],[8,1638]],[[266028,333144],[-304,-143],[-504,-1878]],[[265220,331123],[-22,59]],[[265198,331182],[-124,1693],[-214,-288],[-296,1327]],[[279260,333397],[-157,-1140]],[[279103,332257],[-411,1984],[-648,-2053]],[[278044,332188],[-573,-52]],[[210378,329803],[0,-2771],[-614,432],[-745,-2269]],[[209019,325195],[-2,1368],[-3247,12],[1,-3244]],[[205771,323331],[-1181,-10]],[[282748,335160],[-108,-470]],[[282640,334690],[-343,-1480]],[[282297,333210],[-672,237]],[[281625,333447],[-169,331],[-186,2366]],[[275724,331937],[-313,-26]],[[275411,331911],[-1231,84]],[[232307,338491],[0,-2432],[148,-23],[1,-3216]],[[232456,332820],[-305,-2],[-149,-3257],[-294,2]],[[231708,329563],[-296,1],[-1,3262],[-292,-4],[0,1623]],[[234087,334442],[-14,-2089],[230,-1262]],[[234303,331091],[-538,-3686],[-283,599]],[[233482,328004],[-1,4815],[-1025,1]],[[260623,337347],[23,-3296],[103,-1581]],[[260749,332470],[-138,-25]],[[260611,332445],[-752,-140]],[[259859,332305],[-301,2532]],[[257338,335707],[-156,-2904],[-342,-2492]],[[256840,330311],[-446,715],[-239,-414]],[[256155,330612],[-245,215]],[[255910,330827],[24,1814],[-148,2177]],[[254026,337733],[-164,-1607],[-17,-2092],[167,-1717],[-89,-1887]],[[253923,330430],[-47,-579]],[[253876,329851],[-478,-216],[-127,792]],[[253271,330427],[-4,1966],[147,1494],[31,3866]],[[254897,333892],[-166,-2346]],[[254731,331546],[-712,-436],[-96,-680]],[[284107,336197],[0,-1816],[235,-1426]],[[284342,332955],[-25,-149]],[[284317,332806],[-216,-595],[-40,-1864]],[[284061,330347],[-198,-1249],[-361,-216]],[[283502,328882],[-237,1612]],[[283265,330494],[-76,1698],[-549,2498]],[[273559,332749],[-1601,389]],[[270189,332376],[-269,-1122]],[[269920,331254],[-1335,-829]],[[268585,330425],[-153,883],[95,1791],[-330,2070]],[[263072,336564],[-195,-3681],[-172,-21],[-175,-2136],[-273,-559]],[[262257,330167],[-331,919]],[[261926,331086],[77,2096],[533,3545]],[[261595,336801],[-473,-3690]],[[261122,333111],[-373,-641]],[[253271,330427],[-332,-80]],[[252939,330347],[-8,1375],[-394,358],[-302,1418]],[[252235,333498],[19,3745]],[[250965,335444],[-26,-4865]],[[250939,330579],[-293,-638]],[[250646,329941],[-809,110]],[[249837,330051],[-79,3309]],[[281625,333447],[-251,-3124],[4,-1252],[-421,-1196]],[[280957,327875],[-522,-413],[-138,955]],[[280297,328417],[-332,3369],[-134,425]],[[224348,332817],[-1,-1627]],[[224347,331190],[-2064,20]],[[222283,331210],[0,810]],[[179740,322568],[3,-2451],[444,-2895],[104,-2181],[266,-2705],[564,-2760]],[[181121,309576],[-326,-2417],[-494,-1592]],[[180301,305567],[-2460,-124],[1,-805],[-4499,-63],[2,-553],[-829,-8],[-928,527],[-315,-3026]],[[171273,301515],[-312,1400]],[[170961,302915],[145,1407],[238,4959],[-64,9968]],[[171280,319249],[98,4],[-3,18110]],[[164248,337232],[-2,-3233],[300,-23],[0,-1605],[244,-1640],[325,-34],[5,-1631],[193,12],[3,-1614],[397,-45],[3,-1614],[314,78],[-22,-1691],[246,-211],[0,-3299]],[[166254,320682],[-755,1375],[-936,2625],[-284,-1411],[-421,-724],[101,-1703],[-443,1647],[-537,-409]],[[162979,322082],[-5,3222],[-296,222],[-393,1772],[197,1534],[-165,1791],[-326,509],[-445,3198],[-340,589],[-168,2432]],[[171280,319249],[-3410,-90],[36,-551]],[[167906,318608],[-267,446],[-750,39],[-88,1202],[-462,376]],[[166339,320671],[-85,11]],[[252235,333498],[-176,-1852],[-459,-1134]],[[251600,330512],[-661,67]],[[242130,335806],[-34,-6487]],[[242096,329319],[-637,87]],[[241459,329406],[3,1623],[-1032,137]],[[240430,331166],[104,1602],[10,3228]],[[268585,330425],[-242,-1949],[-248,-495]],[[268095,327981],[-738,4146]],[[267357,332127],[82,739],[-272,2638]],[[238036,329533],[-270,1020],[-9,-2177],[-298,111],[-9,-1668],[-302,-291]],[[237148,326528],[-149,21],[20,4291]],[[237019,330840],[145,2397],[-141,1639],[249,-27],[204,1843]],[[238075,336857],[-39,-7324]],[[261926,331086],[-253,-1943]],[[261673,329143],[-493,2571],[-58,1397]],[[239556,336116],[-9,-2441],[-149,23],[-7,-2427],[-201,25],[-9,-2653]],[[239181,328643],[-294,242],[-94,1575],[-757,-927]],[[237019,330840],[-164,-1085],[-525,-532],[-176,1675],[-128,-957]],[[236026,329941],[-115,4494]],[[263362,334549],[-670,-5484]],[[262692,329065],[-240,-1164]],[[262452,327901],[-195,2266]],[[212037,334134],[-2,-8177]],[[212035,325957],[-1,-4264]],[[212034,321693],[-669,4],[-3,-1665],[-294,7],[-2,-1619],[-293,8],[-1,-1623],[-585,17],[-91,-1634]],[[210096,315188],[-586,7]],[[209510,315195],[-502,3],[-1,3241]],[[209007,318439],[12,6756]],[[284317,332806],[371,-2176],[955,-1729],[26,-1207]],[[285669,327694],[-54,-767],[-593,-357],[-140,698]],[[284882,327268],[-821,3079]],[[285600,335677],[126,-1604],[273,-883]],[[285999,333190],[-398,-1100],[175,-2296],[-1124,1767],[-310,1394]],[[240430,331166],[-12,-5402],[-114,-39]],[[240304,325725],[-549,-592],[-186,1872],[-330,1452]],[[239239,328457],[-58,186]],[[226992,336063],[8,-6492]],[[227000,329571],[-1,-750]],[[226999,328821],[0,-19]],[[226999,328802],[-475,-44],[-290,766],[-418,56]],[[225816,329580],[-586,-9],[-19,3244]],[[228476,331185],[-1,-1622]],[[228475,329563],[-1475,8]],[[243374,332491],[-161,-3273],[-723,82]],[[242490,329300],[-394,19]],[[257735,335317],[-73,-4276],[185,-1699]],[[257847,329342],[-411,-2087],[-227,201]],[[257209,327456],[-369,2855]],[[247573,330712],[-600,59]],[[246973,330771],[-1496,23]],[[288074,326038],[-5,98]],[[286926,335502],[415,-497]],[[287690,334443],[20,-1175],[-419,-3066],[-333,-1394],[-288,214],[-380,1513],[-221,-1048],[-325,2540],[265,-142],[-10,1305]],[[259859,332305],[-102,-4380]],[[259757,327925],[-680,1377],[-289,-544]],[[258788,328758],[11,1469]],[[258799,330227],[35,4085]],[[258799,330227],[-519,-1708],[-227,633]],[[258053,329152],[-206,190]],[[267357,332127],[-461,-864],[33,-2552]],[[266929,328711],[-948,-959]],[[265981,327752],[263,2891],[-1024,480]],[[265198,331182],[-169,-1111],[-21,-2086]],[[265008,327985],[-272,-947],[-243,467],[-219,-1110]],[[264274,326395],[-566,1467]],[[263708,327862],[264,836],[-23,1266],[-316,3898]],[[263634,334064],[-10,104]],[[255910,330827],[-429,244],[-353,-1106]],[[255128,329965],[-397,1581]],[[283265,330494],[-572,-1459],[-346,398]],[[282347,329433],[-50,3777]],[[248221,329795],[-58,-96]],[[248163,329699],[-190,947]],[[249837,330051],[-442,-508]],[[249395,329543],[-1138,388]],[[263708,327862],[-580,-827]],[[263128,327035],[-436,2030]],[[236026,329941],[-3,-304]],[[236023,329637],[-176,-1477],[-443,-194],[-252,1213],[-191,-612]],[[234961,328567],[-77,886],[-581,1638]],[[231708,329563],[0,-1618]],[[231708,327945],[-1282,3]],[[230426,327948],[0,3298],[-261,-1413],[-247,175]],[[229918,330008],[-3,1154]],[[279103,332257],[-595,-3991]],[[278508,328266],[-251,856],[-213,3066]],[[214486,334091],[-13,-8132]],[[214473,325959],[-2438,-2]],[[217486,334073],[-1,-8135]],[[217485,325938],[-1495,19]],[[215990,325957],[0,8137]],[[219007,334077],[3,-8124]],[[219010,325953],[-1525,-15]],[[220510,330410],[0,-4461]],[[220510,325949],[-1500,4]],[[215990,325957],[-1517,2]],[[271518,333337],[-29,-4139],[-182,-3290]],[[271307,325908],[-296,67]],[[271011,325975],[-264,59]],[[270747,326034],[1,1307],[-511,2796],[-304,-278]],[[269933,329859],[-13,1395]],[[282347,329433],[-80,-3574]],[[282267,325859],[-165,-563],[-420,838],[-332,-61]],[[281350,326073],[-393,1802]],[[252939,330347],[-5,-701]],[[252934,329646],[-672,-91],[-323,-2399],[-173,1]],[[251766,327157],[-166,3355]],[[280297,328417],[-211,-1294]],[[280086,327123],[-581,255],[-754,-1251]],[[278751,326127],[-353,1413],[110,726]],[[271948,333056],[227,-2696]],[[272175,330360],[382,-2967],[-24,-1802]],[[272533,325591],[-107,26]],[[272426,325617],[-1119,291]],[[273595,331632],[-24,-1620]],[[273571,330012],[-1396,348]],[[261673,329143],[-449,-3852]],[[261224,325291],[-188,2237],[-289,964]],[[260747,328492],[203,1622],[-339,2331]],[[233482,328004],[-312,226]],[[233170,328230],[-399,-1549],[-1070,-1312]],[[231701,325369],[7,2576]],[[225816,329580],[10,-9733]],[[225826,319847],[-1469,0]],[[224357,319847],[-4,4513]],[[224353,324360],[-6,6830]],[[244619,330722],[-212,-1147],[105,-2459],[-222,-2903]],[[244290,324213],[-331,36],[-3,-1236],[-368,689],[-238,-588]],[[243350,323114],[-586,854],[-297,-184]],[[242467,323784],[23,5516]],[[260747,328492],[-421,-561],[-85,-1375],[-371,150]],[[259870,326706],[-113,1219]],[[188318,312722],[-291,-1597],[-147,-4378],[653,-3],[-47,-2817]],[[188486,303927],[-642,1],[-1224,898],[-311,-3086],[-1306,2189],[-1641,-13]],[[183362,303916],[1,5933]],[[183363,309849],[-2,22529]],[[268095,327981],[-175,-2988],[-203,-1445],[134,-484]],[[267851,323064],[-277,-501]],[[267574,322563],[-1,-3]],[[267573,322560],[-644,6151]],[[274045,331971],[332,-4442],[324,-1103]],[[274701,326426],[-806,-3867]],[[273895,322559],[-185,1400]],[[273710,323959],[-377,-575],[22,1921]],[[273355,325305],[216,4707]],[[278751,326127],[-5,-339]],[[278746,325788],[-367,682],[-294,-913],[-345,-2208]],[[277740,323349],[-312,426],[-120,1819]],[[277308,325594],[-233,1635],[-199,4840]],[[277308,325594],[-662,369],[-623,-752]],[[276023,325211],[-58,1791],[126,2469],[-367,2466]],[[275411,331911],[-586,-5937]],[[274825,325974],[-124,452]],[[222283,331210],[11,-6489]],[[222294,324721],[-137,-42]],[[222157,324679],[-1040,43],[-1,-1614],[-294,3]],[[220822,323111],[-312,20]],[[220510,323131],[0,2818]],[[276023,325211],[-562,988]],[[275461,326199],[-228,-565],[-408,340]],[[269933,329859],[-238,-2103],[-19,-1656]],[[269676,326100],[-619,-853]],[[269057,325247],[-122,2959],[-350,2219]],[[255128,329965],[-90,-7353]],[[255038,322612],[-1051,46]],[[253987,322658],[9,5394],[-120,1799]],[[230426,327948],[0,-3245],[-137,1],[-1,-3821]],[[230288,320883],[-666,-983],[-127,785]],[[229495,320685],[-3,9491],[426,-168]],[[265981,327752],[-64,-577]],[[265917,327175],[-396,128],[-315,-711],[-198,1393]],[[224353,324360],[-360,353],[-1699,8]],[[229495,320685],[-432,1199]],[[229063,321884],[-238,-1061],[-352,454]],[[228473,321277],[2,8286]],[[241459,329406],[-204,-4750]],[[241255,324656],[-448,-779],[-906,103]],[[239901,323980],[403,1745]],[[256155,330612],[-49,-8076]],[[256106,322536],[-1068,76]],[[234961,328567],[-3,-2253],[-315,-6],[0,-2676]],[[234643,323632],[-1174,5]],[[233469,323637],[0,1895],[-295,3],[-4,2695]],[[262452,327901],[-222,-2978],[129,-2605]],[[262359,322318],[-796,-48]],[[261563,322270],[-276,-32]],[[261287,322238],[-305,-7]],[[260982,322231],[247,1083],[-5,1977]],[[257209,327456],[-20,-5059]],[[257189,322397],[-1046,132]],[[256143,322529],[-37,7]],[[237148,326528],[-7,-1358],[-305,-767]],[[236836,324403],[-229,-383],[-21,-2058],[-606,-644]],[[235980,321318],[43,8319]],[[246973,330771],[-2,-5539]],[[246971,325232],[-1504,74]],[[245467,325306],[8,3838]],[[245467,325306],[-7,-2742],[-291,30]],[[245169,322594],[-399,-324],[-210,-1347]],[[244560,320923],[13,2577],[-283,713]],[[248163,329699],[-214,-2386],[219,-628],[20,-1533],[-293,-394],[-116,-1726],[-268,-565]],[[247511,322467],[186,-1297],[-172,-1230]],[[247525,319940],[-289,-502]],[[247236,319438],[-2,1325]],[[247234,320763],[22,4543],[-285,-74]],[[251766,327157],[-13,-4698]],[[251753,322459],[-101,0]],[[251652,322459],[-541,-5]],[[251111,322454],[-505,-9]],[[250606,322445],[40,7496]],[[283502,328882],[-231,-2074]],[[283271,326808],[-356,-2934],[-358,-1180]],[[282557,322694],[-108,2561],[-182,604]],[[239239,328457],[-5,-1942],[-493,50],[-203,-1310],[-493,-195],[5,-2145]],[[238050,322915],[-1029,135],[-185,1353]],[[269057,325247],[-524,-1429]],[[268533,323818],[-371,-223]],[[268162,323595],[-311,-531]],[[253987,322658],[-600,-192]],[[253387,322466],[-453,-3]],[[252934,322463],[-50,3]],[[252884,322466],[50,7180]],[[273355,325305],[-822,286]],[[285469,320638],[-203,-947],[-926,-817]],[[284340,318874],[-64,5013]],[[284276,323887],[204,503],[398,-2748],[591,-1004]],[[284882,327268],[-235,-2199],[118,-897]],[[284765,324172],[-259,864],[-282,-1162]],[[284224,323874],[-953,2934]],[[258788,328758],[-158,-3843]],[[258630,324915],[-206,2015],[-376,1415],[5,807]],[[249395,329543],[-32,-7083]],[[249363,322460],[-223,-9]],[[249140,322451],[-1629,16]],[[270747,326034],[-688,163]],[[270059,326197],[-383,-97]],[[250606,322445],[-430,-12]],[[250176,322433],[-813,27]],[[252884,322466],[-1131,-7]],[[235980,321318],[-18,-3816]],[[235962,317502],[-19,-4124]],[[235943,313378],[-1327,-11]],[[234616,313367],[-1,3239],[-339,-2]],[[234276,316604],[0,3244],[171,1607],[196,17],[0,2160]],[[226999,328802],[9,-8951]],[[227008,319851],[-1,-3236]],[[227007,316615],[-1172,1]],[[225835,316616],[-9,3231]],[[228473,321277],[-555,610],[-74,2247],[-845,4687]],[[258630,324915],[-1,-2532]],[[258629,322383],[-1296,15]],[[257333,322398],[-144,-1]],[[242467,323784],[-5,-1009]],[[242462,322775],[-296,42],[-6,-1618],[-876,479]],[[241284,321678],[-150,871],[121,2107]],[[259870,326706],[26,-4377]],[[259896,322329],[-1243,53]],[[258653,322382],[-24,1]],[[263128,327035],[11,-1304],[-212,-3409]],[[262927,322322],[-101,-5]],[[262826,322317],[-467,1]],[[200462,326631],[361,-4880]],[[200823,321751],[-379,16],[-5,-7061]],[[200439,314706],[-1450,-14]],[[198989,314692],[-3681,23]],[[229063,321884],[-6,-2046]],[[229057,319838],[-2049,13]],[[267573,322560],[-1043,-136]],[[266530,322424],[-489,3117],[-223,-90]],[[265818,325451],[99,1724]],[[285669,327694],[310,747],[30,-1789],[-452,-994],[295,-347],[-138,-1387],[-575,-2025],[-396,1478],[22,795]],[[260982,322231],[-365,31]],[[260617,322262],[-721,67]],[[281350,326073],[46,-5342],[-149,-3077],[243,-283]],[[281490,317371],[-394,-3133]],[[281096,314238],[-204,2185],[-465,3448]],[[280427,319871],[-419,2517],[-71,1883],[149,2852]],[[239901,323980],[-690,-4023],[1,-1632]],[[239212,318325],[-296,-555]],[[238916,317770],[-881,36]],[[238035,317806],[15,5109]],[[233469,323637],[-441,-557],[-20,-6469]],[[233008,316611],[1,-1619],[-439,-6]],[[232570,314986],[-586,-6],[0,1619],[-585,2]],[[231399,316601],[1,1620]],[[231400,318221],[8,5253],[293,1895]],[[265818,325451],[-331,-348],[-413,-2793]],[[265074,322310],[-349,6]],[[264725,322316],[-533,16]],[[264192,322332],[82,4063]],[[231400,318221],[-877,0]],[[230523,318221],[1,2621],[-236,41]],[[264192,322332],[-835,-2]],[[263357,322330],[-430,-8]],[[280427,319871],[-1132,-400]],[[279295,319471],[-372,2212]],[[278923,321683],[-155,1648],[-22,2457]],[[284224,323874],[52,13]],[[284340,318874],[-211,-330]],[[284129,318544],[-198,2127],[-360,239],[-380,1073],[-481,70]],[[282710,322053],[-153,641]],[[203116,323293],[0,-1615],[261,2],[1,-1549],[-728,1]],[[202650,320132],[-59,615],[-705,54],[-101,-673],[-844,4],[-118,1619]],[[209007,318439],[-587,-6],[1,-1615],[-293,-11],[-4,-1617],[-1242,-7],[0,-4792]],[[206882,310391],[-1173,-5]],[[205709,310386],[1,4846],[62,-6],[-1,8105]],[[270059,326197],[-28,-6431],[221,-1212]],[[270252,318554],[-254,-3696],[-212,-1916]],[[269786,312942],[-390,2635],[-91,3609]],[[269305,319186],[-142,3644],[-154,854],[-476,134]],[[276023,325211],[227,-1073],[186,598],[147,-1356],[71,-2680],[-218,-1752]],[[276436,318948],[-6,0]],[[276430,318948],[-1089,137]],[[275341,319085],[120,7114]],[[278923,321683],[-437,-2238],[-436,97]],[[278050,319542],[-14,1963],[-296,1844]],[[275341,319085],[-679,65]],[[274662,319150],[-651,43],[43,2131],[-159,1235]],[[271464,320921],[-199,-1405],[-198,-4516]],[[271067,315000],[-604,2049],[-211,1505]],[[271011,325975],[333,-4681],[120,-373]],[[282710,322053],[66,-1014],[-81,-3692]],[[282695,317347],[-1205,24]],[[214473,325959],[-4,-8114]],[[214469,317845],[-993,-9]],[[213476,317836],[-1442,8]],[[212034,317844],[0,3849]],[[272173,319555],[-709,1366]],[[272426,325617],[-120,-2206],[-216,-215],[83,-3641]],[[219010,325953],[-5,-8102]],[[219005,317851],[-1126,10]],[[217879,317861],[-406,0]],[[217473,317861],[12,8077]],[[220510,323131],[0,-5304]],[[220510,317827],[-1157,20]],[[219353,317847],[-348,4]],[[215990,325957],[-18,-8107]],[[215972,317850],[-1028,10]],[[214944,317860],[-475,-15]],[[277740,323349],[-316,-946],[31,-1526],[-351,-1962]],[[277104,318915],[-668,33]],[[217473,317861],[-1061,-15]],[[216412,317846],[-440,4]],[[273710,323959],[112,-2797],[-91,-1952]],[[273731,319210],[-1617,15]],[[272114,319225],[59,330]],[[266530,322424],[-186,-15]],[[266344,322409],[-1079,-93]],[[265265,322316],[-191,-6]],[[247234,320763],[-1924,142],[-2,-829]],[[245308,320076],[-139,2518]],[[224357,319847],[-575,10],[0,-4860]],[[223782,314997],[-488,-1],[-284,811]],[[223010,315807],[139,1188],[-267,11],[14,2697],[-285,-467]],[[222611,319236],[-167,661],[-83,3112],[-204,1670]],[[284158,318179],[-29,365]],[[285469,320638],[29,1356],[695,560],[-107,-1081],[521,322],[-484,-2668],[-165,-1717],[-182,-43],[-131,1683],[-204,-1777],[-551,162],[-575,-954],[-157,1698]],[[222611,319236],[-441,-169],[-51,-1639],[-679,-8]],[[221440,317420],[-149,817],[-33,3269],[-436,-2],[0,1607]],[[164640,304627],[231,-1774],[-418,-878],[-322,2121],[509,531]],[[165055,305328],[975,-1440],[-461,-704],[-359,132],[-155,2012]],[[166339,320671],[-2,-7969],[-90,-1806]],[[166247,310896],[-249,759],[-867,-159],[-358,995],[-804,201],[-490,-415],[-116,1396],[-372,1055],[123,2396],[-24,2470],[-170,1150],[59,1338]],[[241284,321678],[-584,-794],[39,-1065]],[[240739,319819],[-931,87],[-3,-1605]],[[239805,318301],[-593,24]],[[238035,317806],[-613,-1484]],[[237422,316322],[-245,500],[-834,92],[-381,588]],[[244560,320923],[-20,-4593],[-199,26],[193,-1935]],[[244534,314421],[-604,81],[-3,-1622],[-230,23]],[[243697,312903],[96,2891],[-159,661],[20,4598],[-307,35],[3,2026]],[[269305,319186],[-840,-2741],[-145,-912]],[[268320,315533],[-168,2206],[10,5856]],[[243697,312903],[-75,13]],[[243622,312916],[-905,125]],[[242717,313041],[1,2458],[-234,29],[98,2072],[20,5167],[-140,8]],[[274662,319150],[434,-3775]],[[275096,315375],[-397,-1018],[74,-879],[-605,-586],[-6,1090],[-378,-1531]],[[273784,312451],[4,1591]],[[273788,314042],[49,2842],[-106,2326]],[[234276,316604],[-1268,7]],[[268320,315533],[-415,-2629]],[[267905,312904],[-174,218]],[[267731,313122],[-145,796]],[[267586,313918],[-653,2805]],[[266933,316723],[-40,540]],[[266893,317263],[305,3008],[323,1133],[53,1159]],[[205709,310386],[-1,-1614],[-1701,0]],[[204007,308772],[-1371,-6],[-3,3352]],[[202633,312118],[-147,1515],[16,6497],[148,2]],[[278050,319542],[43,-1241],[-360,-2634]],[[277733,315667],[-629,3248]],[[221440,317420],[1,-4034],[-493,-32]],[[220948,313354],[-223,1274],[-207,-261]],[[220518,314367],[-8,3460]],[[242717,313041],[-496,63]],[[242221,313104],[-106,14]],[[242115,313118],[5,1627],[-291,31],[-264,1666],[-303,324],[6,1345],[-291,53],[9,1622],[-247,33]],[[256004,318054],[-462,771]],[[255542,318825],[-243,556],[-714,-1852],[-404,1290],[-162,1542],[-347,180]],[[253672,320541],[-285,1925]],[[256143,322529],[-11,-3407],[-128,-1068]],[[245308,320076],[-7,-2463],[141,-1661]],[[245442,315952],[-8,-3255],[151,-26],[-6,-2480],[-150,6]],[[245429,310197],[-103,135],[-579,3570],[-213,519]],[[266893,317263],[-555,643],[-280,1346]],[[266058,319252],[-12,1037],[298,2120]],[[257333,322398],[-17,-8213]],[[257316,314185],[-332,545],[-546,1973]],[[256438,316703],[-434,1351]],[[252925,317998],[-982,22]],[[251943,318020],[-96,1898],[-197,-2],[2,2543]],[[252934,322463],[-9,-4465]],[[253555,314761],[-46,-2207]],[[253509,312554],[-482,7]],[[253027,312561],[-4,5160],[-98,277]],[[253672,320541],[-117,-5780]],[[251943,318020],[-47,-2985]],[[251896,315035],[-984,33]],[[250912,315068],[1,4041],[197,808],[1,2537]],[[249142,318305],[-519,9],[-331,-1193],[-263,918],[-215,-624]],[[247814,317415],[-5,2533],[-284,-8]],[[249140,322451],[2,-4146]],[[250912,315068],[-438,-279]],[[250474,314789],[-147,-6],[-2,4868],[-149,0],[0,2782]],[[250474,314789],[-1,-1631]],[[250473,313158],[-643,1090],[-534,3]],[[249296,314251],[-2,2447],[-152,1607]],[[266058,319252],[-82,-420]],[[265976,318832],[-275,-140]],[[265701,318692],[-106,2241],[-330,1383]],[[258653,322382],[-137,-6674],[89,-612]],[[258605,315096],[-29,-1678],[-447,-519],[-145,1195]],[[257984,314094],[-428,804],[-240,-713]],[[260678,319948],[-562,-4378],[-610,-2702],[-150,-76]],[[259356,312792],[-223,839],[-30,1452],[-498,13]],[[260617,322262],[61,-2314]],[[263365,319856],[101,-595],[-208,-1794],[7,-2679]],[[263265,314788],[-172,734],[-550,214]],[[262543,315736],[264,4518],[19,2063]],[[263357,322330],[8,-2474]],[[264725,322316],[-135,-684],[239,-2782],[-180,-2852]],[[264649,315998],[-86,-842]],[[264563,315156],[-22,278]],[[264541,315434],[-329,3527],[-293,881],[-554,14]],[[262543,315736],[-381,-217]],[[262162,315519],[-1,1815],[-262,888]],[[261899,318222],[232,965],[228,3131]],[[261899,318222],[-334,1613],[-2,2435]],[[265701,318692],[-212,-1318]],[[265489,317374],[-231,350],[-271,-1838],[-338,112]],[[284158,318179],[119,-1091],[-640,-3358],[-489,-1594]],[[283148,312136],[-159,657],[-294,4554]],[[261287,322238],[-239,-2821],[0,-1352],[-233,-2520]],[[260815,315545],[-137,4403]],[[262162,315519],[-52,-657]],[[262110,314862],[-107,4]],[[262003,314866],[-1169,24]],[[260834,314890],[-19,655]],[[230523,318221],[0,-1628],[-294,-3],[-5,-3251]],[[230224,313339],[-873,12]],[[229351,313351],[0,1623],[-293,811]],[[229058,315785],[-1,4053]],[[202633,312118],[-979,1703],[-317,896],[-898,-11]],[[279295,319471],[266,-2709],[-183,-3842]],[[279378,312920],[-224,-635],[-333,-2783]],[[278821,309502],[-4,24]],[[278817,309526],[-1052,5966]],[[277765,315492],[-32,175]],[[212034,317844],[-3,-8091]],[[212031,309753],[0,-189]],[[212031,309564],[-1940,9],[5,5615]],[[272114,319225],[155,-4645]],[[272269,314580],[-1,-1446]],[[272268,313134],[-327,-920],[-286,1648]],[[271655,313862],[-588,1138]],[[247236,319438],[-213,564],[88,-2171],[-320,-435],[282,-923],[-325,-596]],[[246748,315877],[-1306,75]],[[255542,318825],[30,-628],[-317,-3711]],[[255255,314486],[-1700,275]],[[166087,290612],[275,-966],[-300,-16],[25,982]],[[167726,304768],[-743,1873],[-183,2255],[-553,2000]],[[167906,318608],[691,-9433],[-103,-2110],[-329,6],[-439,-2303]],[[247814,317415],[-121,-2322],[126,-841]],[[247819,314252],[0,-806]],[[247819,313446],[-294,-28],[6,-1584],[-272,-13]],[[247259,311821],[-473,1881]],[[246786,313702],[-38,2175]],[[260834,314890],[37,-1199]],[[260871,313691],[-340,-2930],[-579,-3106]],[[259952,307655],[-731,14]],[[259221,307669],[-12,4226],[147,897]],[[281096,314238],[217,-1643],[-222,-1224]],[[281091,311371],[-528,-426],[-618,1727],[-567,248]],[[223010,315807],[-167,-929],[-209,-3035],[76,-1642]],[[222710,310201],[-463,2267],[-58,-1528],[-215,361]],[[221974,311301],[-292,391],[-321,-718],[-413,2380]],[[242115,313118],[-438,43],[-4,-817],[-514,69],[-222,-771]],[[240937,311642],[-45,1095],[-302,569]],[[240590,313306],[-41,1616],[-479,872],[30,2514],[-295,-7]],[[225835,316616],[-146,-4],[-1,-3243]],[[225688,313369],[-284,3],[-145,-1082],[-582,7],[-438,-809]],[[224239,311488],[-1,1890],[-456,-2],[0,1621]],[[229058,315785],[-744,-261],[154,-2163],[-579,4]],[[227889,313365],[-586,3]],[[227303,313368],[-1,3244],[-295,3]],[[264541,315434],[-415,-1027]],[[264126,314407],[-860,-257]],[[263266,314150],[-1,638]],[[266933,316723],[-339,-3833]],[[266594,312890],[-433,-921]],[[266161,311969],[-142,1338]],[[266019,313307],[139,814],[-135,1989],[115,1470],[-162,1252]],[[168718,285870],[613,-3552],[-361,241],[-252,3311]],[[168676,294217],[663,-1336],[118,-1995],[-366,419],[-148,2046],[-267,866]],[[170961,302915],[-533,9],[-383,-3729]],[[170045,299195],[-299,468],[-188,-1225],[-342,666],[55,1824],[-185,2349],[-237,1371],[-531,-107],[-202,-603],[-390,830]],[[273788,314042],[-1519,538]],[[269786,312942],[-1189,-5125]],[[268597,307817],[-93,1503]],[[268504,309320],[-251,3127],[-348,457]],[[276707,313833],[-152,-754],[-450,18],[-676,-2348]],[[275429,310749],[-117,2670],[-216,1956]],[[276430,318948],[164,-2140],[207,-808],[-94,-2167]],[[277765,315492],[-510,-6014]],[[277255,309478],[-68,132]],[[277187,309610],[-190,3520],[-290,703]],[[256438,316703],[-14,-6930]],[[256424,309773],[0,-270]],[[256424,309503],[-1169,98]],[[255255,309601],[0,4885]],[[266019,313307],[-494,36]],[[265525,313343],[-95,2291],[59,1740]],[[271655,313862],[-387,-3128],[-316,-1220],[-138,-1801]],[[270814,307713],[-619,2360],[-220,1485]],[[269975,311558],[-189,1384]],[[209510,315195],[8,-9723]],[[209518,305472],[-585,10],[-1,-1637],[-1755,87],[0,1633],[-298,10]],[[206879,305575],[3,4816]],[[249296,314251],[-147,-1]],[[249149,314250],[-1330,2]],[[240590,313306],[-339,47],[-92,-2176],[-1279,142]],[[238880,311319],[36,6451]],[[231399,316601],[1,-3247],[-148,-1629],[-731,-2]],[[230521,311723],[-297,20],[0,1596]],[[253027,312561],[-593,32]],[[252434,312593],[1,817],[-542,-5]],[[251893,313405],[3,1630]],[[216412,317846],[0,-8101]],[[216412,309745],[-260,3]],[[216152,309748],[-1207,11]],[[214945,309759],[-1,8101]],[[217879,317861],[-4,-8108]],[[217875,309753],[-265,-6]],[[217610,309747],[-1198,-2]],[[214945,309759],[-258,1]],[[214687,309760],[-1212,-2]],[[213475,309758],[1,8078]],[[219353,317847],[-5,-8079]],[[219348,309768],[-278,10]],[[219070,309778],[-1195,-25]],[[220518,314367],[0,-4631]],[[220518,309736],[-1170,32]],[[238880,311319],[-3,-1067]],[[238877,310252],[-196,24]],[[238681,310276],[-1273,172]],[[237408,310448],[14,5874]],[[213475,309758],[-250,-2]],[[213225,309756],[-1194,-3]],[[265525,313343],[-379,-1617]],[[265146,311726],[-589,2243],[6,1187]],[[282602,309349],[-10,65]],[[282592,309414],[10,-65]],[[283148,312136],[-617,-2746]],[[282531,309390],[-232,1787],[-388,-117],[-188,-953]],[[281723,310107],[-370,469]],[[281353,310576],[-262,795]],[[237408,310448],[-890,101],[31,-3035]],[[236549,307514],[-631,-49]],[[235918,307465],[25,5913]],[[257984,314094],[-89,-4491]],[[257895,309603],[-1471,170]],[[267586,313918],[-206,-1092],[-615,-311]],[[266765,312515],[-171,375]],[[227303,313368],[-1,-4054]],[[227302,309314],[-1606,11]],[[225696,309325],[-8,4044]],[[232570,314986],[1,-1620],[-301,-10],[2,-6508]],[[232272,306848],[-593,2]],[[231679,306850],[-1159,9]],[[230520,306859],[1,4864]],[[234616,313367],[-304,7],[0,-4907],[-291,4],[-15,-1618]],[[234006,306853],[-1734,-5]],[[246786,313702],[-19,-2055],[-497,-863],[38,-1147],[-293,-1723],[-253,398],[310,-1738],[-363,-407]],[[245709,306167],[2,-24]],[[245711,306143],[-453,5]],[[245258,306148],[93,410],[78,3639]],[[229351,313351],[-149,-2],[-1,-3219],[-146,-6]],[[229055,310124],[-301,798],[-865,13],[0,2430]],[[224239,311488],[147,-1345],[-2,-3288]],[[224384,306855],[-433,-385],[-521,1416]],[[223430,307886],[-657,27],[-63,2288]],[[263266,314150],[3,-2538]],[[263269,311612],[-982,-375]],[[262287,311237],[-273,215],[96,3410]],[[278817,309526],[-155,-873]],[[278662,308653],[-702,873],[-466,-1309]],[[277494,308217],[-239,1261]],[[265146,311726],[62,-1577]],[[265208,310149],[-838,21]],[[264370,310170],[1,855]],[[264371,311025],[-245,3382]],[[275429,310749],[0,-38]],[[275429,310711],[-371,-1301],[-162,-2339]],[[274896,307071],[-379,-1286]],[[274517,305785],[-288,-570],[-418,2121],[121,1598]],[[273932,308934],[155,2002],[-303,1515]],[[212031,309564],[-10,-8889]],[[212021,300675],[-14,-4738]],[[212007,295937],[-1275,-7]],[[210732,295930],[1,1618],[-581,-19],[4,3038],[-348,-1],[0,4885],[-290,21]],[[251893,313405],[-148,-262],[-98,-2422]],[[251647,310721],[-1175,275]],[[250472,310996],[1,2162]],[[259221,307669],[-550,-1893]],[[258671,305776],[-416,2982]],[[258255,308758],[-360,845]],[[262003,314866],[-203,-2819],[-428,-1224],[-148,-1566],[-209,5]],[[261015,309262],[-144,4429]],[[262287,311237],[-115,-5511]],[[262172,305726],[-1045,-291]],[[261127,305435],[-112,3827]],[[204007,308772],[-2,-8089],[-357,6],[0,-3269],[-895,189],[3,-3357]],[[202756,294252],[-282,-80],[-3451,20]],[[199023,294192],[-10,14576],[-24,5924]],[[199023,294192],[-802,21],[0,-5147]],[[198221,289066],[-2916,138]],[[195305,289204],[1,10598]],[[255255,309601],[-293,45]],[[254962,309646],[-1501,262]],[[253461,309908],[48,2646]],[[221974,311301],[-1,-5776]],[[221973,305525],[-842,203],[-613,2379]],[[220518,308107],[0,1629]],[[273932,308934],[-751,-1022],[-232,-720],[-385,1197]],[[272564,308389],[-296,4745]],[[245258,306148],[-220,-1243],[179,-1808],[-328,48],[-478,1055]],[[244411,304200],[-66,1223]],[[244345,305423],[-235,2560],[-507,303],[19,4630]],[[264371,311025],[-903,8],[-199,579]],[[250472,310996],[3,-4065]],[[250475,306931],[-737,17]],[[249738,306948],[1,538],[-589,29]],[[249150,307515],[-1,6735]],[[249150,307515],[-2,-540],[-585,15]],[[248563,306990],[-568,-79]],[[247995,306911],[2,1971],[-165,660],[-13,3904]],[[267731,313122],[-172,-4100]],[[267559,309022],[-165,-649],[-348,481],[-159,-756]],[[266887,308098],[-122,4417]],[[277187,309610],[-200,-184],[-957,-3894]],[[276030,305532],[-239,1408],[128,659],[-179,3128],[-311,-16]],[[272564,308389],[-61,-778]],[[272503,307611],[-371,-2255]],[[272132,305356],[-182,81],[-533,1971],[-394,-959]],[[271023,306449],[-209,1264]],[[261127,305435],[65,-2172]],[[261192,303263],[-366,-423]],[[260826,302840],[-582,504]],[[260244,303344],[-292,4311]],[[247116,305288],[0,-1624]],[[247116,303664],[-574,36]],[[246542,303700],[-7,2441],[-826,26]],[[247259,311821],[2,-3022],[-144,17],[-1,-3528]],[[247995,306911],[-1,-1623],[-878,0]],[[266161,311969],[-151,-1209],[137,-1333]],[[266147,309427],[-550,-3123]],[[265597,306304],[-143,-537],[-540,1289]],[[264914,307056],[377,2075],[-83,1018]],[[252434,312593],[-3,-7005]],[[252431,305588],[-490,-270]],[[251941,305318],[-294,8]],[[251647,305326],[0,5395]],[[229055,310124],[0,-2981]],[[229055,307143],[-102,-1894]],[[228953,305249],[-1646,5]],[[227307,305254],[-5,4060]],[[230520,306859],[-129,-798],[-366,1]],[[230025,306062],[-236,1076],[-734,5]],[[225696,309325],[4,-2728]],[[225700,306597],[-87,-539],[-544,798],[-165,-1383]],[[224904,305473],[-175,-372],[-345,1754]],[[235918,307465],[-20,-4634]],[[235898,302831],[-24,-5642]],[[235874,297189],[-725,1210]],[[235149,298399],[-86,1119],[-236,-357],[-301,2194],[-518,1395]],[[234008,302750],[-2,4103]],[[240937,311642],[-27,-4926]],[[240910,306716],[-579,117]],[[240331,306833],[-388,76],[-25,1423],[-898,817],[-143,1103]],[[192649,296056],[0,-2068],[-471,-21],[-761,-1597],[-17,-3435]],[[191400,288935],[-518,-982],[-412,-2924],[-457,4942],[-260,4020]],[[189753,293991],[-316,3938],[-198,-1382],[-452,2730],[42,1284],[-343,3366]],[[268504,309320],[-576,-1453],[-270,224]],[[267658,308091],[-99,931]],[[242221,313104],[-71,-8013]],[[242150,305091],[-288,-50]],[[241862,305041],[-455,1583],[-497,92]],[[244345,305423],[-785,1742],[-49,-1484],[-582,-12],[0,-544]],[[242929,305125],[-779,-34]],[[266887,308098],[-133,-492]],[[266754,307606],[-217,1203],[-390,618]],[[281353,310576],[-256,-2617],[-334,-211],[-135,-1225],[-339,131],[-50,-1711],[-247,-2039]],[[279992,302904],[-1171,6598]],[[269975,311558],[-244,-1242],[240,-2297],[-54,-2071],[-167,-824]],[[269750,305124],[-567,147],[-179,-1082]],[[269004,304189],[-407,3628]],[[253461,309908],[-84,-4366]],[[253377,305542],[-946,46]],[[223430,307886],[-2,-7046]],[[223428,300840],[-1456,0]],[[221972,300840],[1,4685]],[[263252,305383],[-219,26]],[[263033,305409],[-515,58]],[[262518,305467],[-346,259]],[[263269,311612],[-17,-6229]],[[264370,310170],[-2,-2778]],[[264368,307392],[-267,-203],[-179,-1894]],[[263922,305295],[-670,88]],[[271023,306449],[-385,-3232]],[[270638,303217],[-108,-157]],[[270530,303060],[5,560],[-727,-210],[-58,1714]],[[281981,302597],[-3,82]],[[281978,302679],[3,-82]],[[282531,309390],[61,24]],[[282602,309349],[-405,-2625],[-165,-1820],[-109,2614]],[[281923,307518],[-200,2589]],[[251647,305326],[-876,-15]],[[250771,305311],[-294,-4],[-2,1624]],[[276030,305532],[200,-730]],[[276230,304802],[-500,-1758],[-394,2382],[-444,601],[4,1044]],[[280269,301329],[-18,102]],[[280251,301431],[18,-102]],[[281981,302597],[-3,82]],[[281923,307518],[8,-4063],[-186,-1610],[-387,486],[-737,-285],[-373,-588]],[[280248,301458],[-33,175]],[[280215,301633],[-11,68]],[[280204,301701],[-212,1203]],[[237408,310448],[27,-3045],[293,-50],[-7,-3257]],[[237721,304096],[-23,-4862],[-351,60]],[[237347,299294],[-4,1]],[[237343,299295],[-252,2449],[-133,5739],[-409,31]],[[238681,310276],[-66,-2357],[143,-159],[46,-2922],[169,-1709]],[[238973,303129],[-231,-2]],[[238742,303127],[-202,-247],[-819,1216]],[[206879,305575],[2,-12857],[-37,-4822],[-1146,-121]],[[205698,287775],[-6,3219],[-1134,-5],[-3,1595],[-1724,6]],[[202831,292590],[-75,1662]],[[240331,306833],[-20,-6441]],[[240311,300392],[-587,-612]],[[239724,299780],[-512,1234],[-239,2115]],[[264914,307056],[-97,-2181]],[[264817,304875],[-449,1093],[0,1424]],[[254962,309646],[-4,-5674]],[[254958,303972],[1,-1619]],[[254959,302353],[-880,88]],[[254079,302441],[-98,2460],[-614,116]],[[253367,305017],[10,525]],[[183362,303916],[0,-11575]],[[183362,292341],[-1739,3],[0,1620],[-863,-20],[-2,-8075],[-687,-61]],[[180071,285808],[-439,260],[-94,887],[82,3389],[-151,600],[21,1938],[272,564]],[[179762,293446],[283,2149],[77,2691],[-106,4262],[275,1900],[10,1119]],[[181121,309576],[282,-790],[1201,-586],[252,1502],[507,147]],[[219070,309778],[-4,-8907]],[[219066,300871],[-1455,-38]],[[217611,300833],[-1,8914]],[[220518,308107],[-138,101],[-4,-7331]],[[220376,300877],[-1310,-6]],[[258255,308758],[-186,-143],[-223,-2439],[-292,-747],[-162,-1946],[-429,-1122],[-130,-1067]],[[256833,301294],[-358,591],[-165,1920]],[[256310,303805],[109,-16],[5,5714]],[[217611,300833],[-1456,-59]],[[216155,300774],[-3,8974]],[[216155,300774],[-1454,-107]],[[214701,300667],[-14,9093]],[[214701,300667],[-1476,8]],[[213225,300675],[0,9081]],[[277494,308217],[-65,-785],[217,-4446],[468,-2796]],[[278114,300190],[-479,-436],[-840,1115],[-215,922]],[[276580,301791],[-276,1144]],[[276304,302935],[225,772],[-299,1095]],[[213225,300675],[-1204,0]],[[256310,303805],[-1352,167]],[[280269,301329],[-18,102]],[[280248,301458],[-33,175]],[[280204,301701],[21,-471],[-685,-2076],[-529,-3189]],[[279011,295965],[-269,-6],[-253,2494]],[[278489,298453],[-185,3127],[-229,1784],[245,1596],[342,3693]],[[278489,298453],[-265,205],[-88,1174]],[[278136,299832],[-22,358]],[[266754,307606],[118,-2920]],[[266872,304686],[-494,-1390]],[[266378,303296],[-72,1226],[-571,652],[-138,1130]],[[227307,305254],[-1,-3184]],[[227306,302070],[-352,1622],[-507,-2568],[-302,758]],[[226145,301882],[90,1860],[-381,232],[-154,2623]],[[269004,304189],[84,-1082]],[[269088,303107],[-225,529]],[[268863,303636],[-374,-245]],[[268489,303391],[-548,1345]],[[267941,304736],[-283,3355]],[[267941,304736],[-418,57],[-368,-881]],[[267155,303912],[-283,774]],[[274517,305785],[-85,-1864],[134,-4155],[-61,-615]],[[274505,299151],[-581,663],[-511,1884]],[[273413,301698],[-135,2326],[-372,1680],[-227,40],[-176,1867]],[[258671,305776],[-62,-2960]],[[258609,302816],[-230,-1971],[-471,-601],[9,-685]],[[257917,299559],[-515,1404],[-542,-471]],[[256860,300492],[-27,802]],[[221972,300840],[4,-1864]],[[221976,298976],[-229,1201],[-392,509],[-834,191]],[[220521,300877],[-145,0]],[[224904,305473],[0,-4595]],[[224904,300878],[-1476,-38]],[[260244,303344],[-448,-474],[-461,-1877]],[[259335,300993],[-374,2733],[-352,-910]],[[273413,301698],[-85,-3220]],[[273328,298478],[-403,-1011]],[[272925,297467],[-503,1412],[-567,2766]],[[271855,301645],[277,3711]],[[249738,306948],[7,-5485]],[[249745,301463],[-730,-2],[-437,570]],[[248578,302031],[-15,4959]],[[237343,299295],[-645,694],[-800,2842]],[[271855,301645],[-224,-1169]],[[271631,300476],[-514,965],[-162,2030],[-317,-254]],[[264817,304875],[-499,-1732]],[[264318,303143],[-198,104],[-7,-5871]],[[264113,297376],[-299,18],[-3,-1823]],[[263811,295571],[-420,-901]],[[263391,294670],[-672,167]],[[262719,294837],[116,1165]],[[262835,296002],[415,1552],[228,1602]],[[263478,299156],[298,1538],[245,2560],[-99,2041]],[[230025,306062],[101,-882],[-211,-1084],[101,-2120]],[[230016,301976],[-185,350],[-328,-1482],[-268,388],[-184,1849]],[[229051,303081],[-98,2168]],[[244411,304200],[-353,-701],[-25,-3601]],[[244033,299898],[-1166,156]],[[242867,300054],[62,5071]],[[276304,302935],[-783,-2653],[-394,-674],[-382,-2307]],[[274745,297301],[-240,1850]],[[265597,306304],[-143,-2280],[195,-1399]],[[265649,302625],[-510,-2676]],[[265139,299949],[-116,-620]],[[265023,299329],[-659,3103],[-46,711]],[[248578,302031],[0,-1380],[-586,-270],[-1,-1632]],[[247991,298749],[-443,543],[316,1089],[-750,38]],[[247114,300419],[2,3245]],[[250771,305311],[3,-4878],[-150,-1369]],[[250624,299064],[-878,-312]],[[249746,298752],[-1,2711]],[[231679,306850],[149,-590],[1,-3198],[271,-1475],[224,-5]],[[232324,301582],[-241,-630]],[[232083,300952],[-247,888],[-429,-565],[-250,-1798],[-558,-651]],[[230599,298826],[-125,948],[-568,1263],[110,939]],[[234008,302750],[-177,481],[-257,-1569]],[[233574,301662],[-669,200],[-133,968],[-448,-1248]],[[241862,305041],[-376,-48],[-11,-1571],[394,-3307]],[[241869,300115],[-693,133]],[[241176,300248],[-865,144]],[[226145,301882],[-3,-7872]],[[226142,294010],[-1232,-6]],[[224910,294004],[-6,6874]],[[266378,303296],[-305,-1111]],[[266073,302185],[-424,440]],[[246542,303700],[-5,-6913],[-292,-2],[0,-1616]],[[246245,295169],[-1257,-5]],[[244988,295164],[-45,601]],[[244943,295765],[269,600],[-236,1264],[282,816],[-40,1454],[303,-381],[-185,3715],[560,1252],[-185,1658]],[[244943,295765],[-41,-823],[-579,866]],[[244323,295808],[8,4035],[-298,55]],[[262518,305467],[-156,-2441],[-200,-873]],[[262162,302153],[-936,-51]],[[261226,302102],[-34,1161]],[[253367,305017],[-116,-5834]],[[253251,299183],[-738,-1766]],[[252513,297417],[38,555],[-611,6],[-2,2435]],[[251938,300413],[3,4905]],[[210732,295930],[-587,-11],[-3,-3235],[-124,-7],[0,-8009],[-134,-3]],[[209884,284665],[-2861,-34],[-28,-8244]],[[206995,276387],[-1400,-32],[4,8251],[101,1],[-2,3168]],[[263478,299156],[-127,1132],[-280,33]],[[263071,300321],[-38,5088]],[[179762,293446],[-4058,-181]],[[175704,293265],[-2642,-5],[-586,89],[-362,1122],[-386,245]],[[171728,294716],[266,2870],[-339,971],[-382,2958]],[[263071,300321],[-494,-473]],[[262577,299848],[-380,581]],[[262197,300429],[-35,1724]],[[270530,303060],[-303,-446],[112,-1814],[-159,-1241],[160,-3138]],[[270340,296421],[-326,1802]],[[270014,298223],[-319,2645],[-607,2239]],[[251938,300413],[-588,25],[-1,-1081],[-287,-277]],[[251062,299080],[-438,-16]],[[229051,303081],[-27,-98]],[[229024,302983],[-420,-2885],[-33,-1359],[-271,1490],[50,1869],[-342,-239],[-177,-1289],[-249,388],[-61,1401]],[[227521,302359],[-215,-289]],[[242867,300054],[0,-1626]],[[242867,298428],[-989,63]],[[241878,298491],[-9,1624]],[[254079,302441],[15,-7371]],[[254094,295070],[-915,185]],[[253179,295255],[72,3928]],[[268489,303391],[-191,-579],[-387,-2963],[106,-885]],[[268017,298964],[-130,-738]],[[267887,298226],[-343,98],[-450,1171]],[[267094,299495],[12,1605]],[[267106,301100],[49,2812]],[[189753,293991],[-1506,-3],[-6,-4849],[-1376,-18],[-349,1600],[-5,-14590]],[[186511,276131],[-3149,-34]],[[183362,276097],[0,16244]],[[267106,301100],[-728,2196]],[[238742,303127],[-74,-8950]],[[238668,294177],[-668,110]],[[238000,294287],[-287,2380]],[[237713,296667],[-388,1099],[22,1528]],[[256860,300492],[-290,-2959],[-338,-792],[-245,-1878]],[[255987,294863],[-144,1386],[-293,274]],[[255550,296523],[0,1620],[-291,55],[-9,3268],[-291,887]],[[268863,303636],[139,-2860],[323,-3556]],[[269325,297220],[-471,-581]],[[268854,296639],[-87,-160]],[[268767,296479],[-371,1043],[-216,-422],[-163,1864]],[[227521,302359],[-8,-8969]],[[227513,293390],[-1201,1]],[[226312,293391],[-170,619]],[[259335,300993],[56,-1317],[-280,-1720]],[[259111,297956],[-212,-1709],[70,-886],[-507,-2769]],[[258462,292592],[1,2075],[-386,811]],[[258077,295478],[-160,4081]],[[247114,300419],[-4,-8971]],[[247110,291448],[-285,-6],[1,-1092],[-449,-9]],[[246377,290341],[-133,6],[1,4822]],[[270014,298223],[-538,-798]],[[269476,297425],[-151,-205]],[[271631,300476],[-1005,-5255]],[[270626,295221],[-44,238]],[[270582,295459],[-242,962]],[[265023,299329],[-257,-2572],[-190,585]],[[264576,297342],[-271,24]],[[264305,297366],[-192,10]],[[260085,295669],[3,546],[-557,17],[-158,1641],[-262,83]],[[260826,302840],[-296,-1219],[-6,-4236],[-439,-1716]],[[267094,299495],[-351,-1180]],[[266743,298315],[-277,2223]],[[266466,300538],[-393,1647]],[[261226,302102],[134,-4629]],[[261360,297473],[95,-3169]],[[261455,294304],[-945,242]],[[260510,294546],[-581,51]],[[259929,294597],[156,1072]],[[235149,298399],[-2,-6961]],[[235147,291438],[-172,646]],[[234975,292084],[-223,645],[-660,-165]],[[234092,292564],[-504,-211]],[[233588,292353],[-6,48]],[[233582,292401],[-8,9261]],[[239724,299780],[-34,-6034]],[[239690,293746],[-694,-158]],[[238996,293588],[-328,589]],[[230599,298826],[-15,-6106]],[[230584,292720],[-1252,143]],[[229332,292863],[-306,203]],[[229026,293066],[-2,9917]],[[229026,293066],[-1224,262]],[[227802,293328],[-289,62]],[[237713,296667],[-606,-1072]],[[237107,295595],[-319,701],[-638,-836],[-276,1729]],[[276580,301791],[-335,-2181],[7,-1181],[-302,-3864]],[[275950,294565],[-336,-991]],[[275614,293574],[-478,40],[-285,2097]],[[274851,295711],[-106,1590]],[[171728,294716],[-240,-2194]],[[171488,292522],[-527,2873],[-607,2125],[-309,1675]],[[233582,292401],[-515,1393],[-746,743],[-269,-627]],[[232052,293910],[31,7042]],[[266466,300538],[-488,-4111]],[[265978,296427],[-652,2741]],[[265326,299168],[-187,781]],[[255550,296523],[-579,144],[-98,-1641],[-485,59]],[[254388,295085],[-294,-15]],[[262197,300429],[-36,-1811],[-801,-1145]],[[249746,298752],[0,-823]],[[249746,297929],[-780,-17]],[[248966,297912],[-952,5]],[[248014,297917],[-23,832]],[[278136,299832],[-261,-1730],[-65,-2062],[-295,-1491],[-382,-3556]],[[277133,290993],[-221,469],[-599,3177],[-363,-74]],[[232052,293910],[-3,-967]],[[232049,292943],[-1216,-1077]],[[230833,291866],[-249,854]],[[274851,295711],[-156,130],[-298,-1759],[-415,2480],[-367,85],[-287,1831]],[[272925,297467],[-517,-3023]],[[272408,294444],[-1070,-5441]],[[271338,289003],[-265,919]],[[271073,289922],[-257,2318],[43,1727],[-233,1254]],[[258077,295478],[-439,-1479],[-435,-2504],[-547,-1593]],[[256656,289902],[-109,9]],[[256547,289911],[-268,1111],[-470,3450],[178,391]],[[220521,300877],[16,-8165]],[[220537,292712],[-1467,9]],[[219070,292721],[-4,8150]],[[221976,298976],[5,-6234]],[[221981,292742],[-1444,-30]],[[224910,294004],[2,-1314]],[[224912,292690],[-1486,25]],[[223426,292715],[2,8125]],[[219070,292721],[-1453,-12]],[[217617,292709],[-6,8124]],[[217617,292709],[-1443,-46]],[[216174,292663],[-19,8111]],[[223426,292715],[-1445,27]],[[216174,292663],[-1446,-96]],[[214728,292567],[-27,8100]],[[213225,300675],[57,-8129]],[[213282,292546],[-1287,-1]],[[211995,292545],[12,3392]],[[214728,292567],[-1446,-21]],[[241176,300248],[-11,-1320],[-519,-4119],[192,-1475],[382,-1184]],[[241220,292150],[-1146,188]],[[240074,292338],[-391,56],[7,1352]],[[266743,298315],[382,-3066],[-30,-933]],[[267095,294316],[-707,-913]],[[266388,293403],[-414,1707]],[[265974,295110],[4,1317]],[[262719,294837],[-459,-1602]],[[262260,293235],[-776,49]],[[261484,293284],[-29,1020]],[[262577,299848],[-12,-3860],[270,14]],[[248014,297917],[76,-4059],[-205,-781],[1,-1557]],[[247886,291520],[-437,-568]],[[247449,290952],[-227,-1244],[-112,1740]],[[252513,297417],[69,-2402],[-508,-278]],[[252074,294737],[0,1098],[-967,-56]],[[251107,295779],[-45,3301]],[[241878,298491],[54,-3824],[-182,-2390],[74,-1398]],[[241824,290879],[-230,-523],[-374,1794]],[[244323,295808],[-11,-3253]],[[244312,292555],[-1484,172]],[[242828,292727],[39,5701]],[[264965,295106],[-389,2236]],[[265326,299168],[-46,-1734],[-315,-2328]],[[278269,287761],[-76,264]],[[278193,288025],[76,-264]],[[279011,295965],[-403,-3616],[-92,-2363],[-262,1132],[231,-2620],[-212,-589],[-375,805]],[[277898,288714],[-123,574]],[[277775,289288],[-642,1705]],[[195305,289204],[0,-8031]],[[195305,281173],[-1,-6538]],[[195304,274635],[-185,-4]],[[195119,274631],[-313,2178],[43,3573],[-198,582],[-595,5810],[0,10694]],[[267887,298226],[124,-662],[-175,-1445],[3,-2070]],[[267839,294049],[-421,-2128]],[[267418,291921],[-323,2395]],[[253179,295255],[-83,-4574]],[[253096,290681],[-1016,-26]],[[252080,290655],[-6,4082]],[[265974,295110],[21,-726],[-419,-926],[-105,-1288]],[[265471,292170],[-170,1415]],[[265301,293585],[-336,1521]],[[251107,295779],[-195,-539]],[[250912,295240],[-465,-211],[-350,-1146]],[[250097,293883],[-350,16],[-1,4030]],[[268767,296479],[-480,-2909]],[[268287,293570],[-448,479]],[[237107,295595],[1,-5232]],[[237108,290363],[-341,756],[-196,-1322],[-639,965],[-521,-443]],[[235411,290319],[-264,1119]],[[275614,293574],[-88,-2688],[-301,-779]],[[275225,290107],[-353,382],[-40,1052],[-800,-2861]],[[274032,288680],[-22,-72]],[[274010,288608],[-398,2352],[-785,2546]],[[272827,293506],[-419,938]],[[242828,292727],[23,-1854],[-369,-1417],[-65,-1108]],[[242417,288348],[-241,1667],[-352,864]],[[270582,295459],[-741,-3542]],[[269841,291917],[-395,3623],[30,1885]],[[259929,294597],[-147,0],[-210,-3806],[-384,39],[-157,-3572]],[[259031,287258],[-882,-28]],[[258149,287230],[-35,1334],[210,2007],[198,283],[-60,1738]],[[250097,293883],[-203,-504],[0,-2742]],[[249894,290637],[-533,-8]],[[249361,290629],[-5,2179],[-385,256],[-5,4848]],[[249361,290629],[-291,-1322]],[[249070,289307],[-1184,2213]],[[269841,291917],[-165,-789]],[[269676,291128],[-84,-4]],[[269592,291124],[-424,845],[-314,4670]],[[195119,274631],[-3726,22]],[[191393,274653],[0,1610]],[[191393,276263],[7,12672]],[[264305,297366],[79,-1214],[-282,-4275]],[[264102,291877],[-95,1]],[[264007,291878],[19,2058],[-215,1635]],[[265301,293585],[-113,-1287],[-385,-1433]],[[264803,290865],[-134,697],[-567,315]],[[238000,294287],[55,-4237],[-203,-2133],[-208,87],[128,-2330]],[[237772,285674],[-29,1]],[[237743,285675],[-635,-3]],[[237108,285672],[0,4691]],[[269592,291124],[-134,-694]],[[269458,290430],[-356,976],[-547,-1372]],[[268555,290034],[-268,3536]],[[256547,289911],[-602,-2120],[-102,-2362],[-288,-52]],[[255555,285377],[-818,64]],[[254737,285441],[-325,194],[-15,2539]],[[254397,288174],[-9,6911]],[[211995,292545],[-22,-7993]],[[211973,284552],[0,-8133]],[[211973,276419],[1,-8101]],[[211974,268318],[0,-1611],[-730,-3]],[[211244,266704],[-1105,-3]],[[210139,266701],[0,9724],[-254,-1],[-1,8241]],[[252080,290655],[-401,-9]],[[251679,290646],[-766,-8]],[[250913,290638],[-1,4602]],[[244988,295164],[-59,-1673],[289,734],[-25,-3356],[150,-2943],[-317,-598],[225,-984],[-128,-819]],[[245123,285525],[1,-135]],[[245124,285390],[-272,18]],[[244852,285408],[-481,19]],[[244371,285427],[-67,-3]],[[244304,285424],[8,7131]],[[264007,291878],[-125,-1789],[-179,18]],[[263703,290107],[-245,1867],[-67,2696]],[[258149,287230],[-73,-1530]],[[258076,285700],[-259,915],[-757,37],[2,-409]],[[257062,286243],[-403,2157],[-3,1502]],[[271073,289922],[-669,-320],[-229,1237],[-260,-547]],[[269915,290292],[-239,836]],[[254397,288174],[-931,-2937]],[[253466,285237],[-470,-87]],[[252996,285150],[100,5531]],[[250913,290638],[-58,-1637],[-291,-9],[-2,-1641],[-289,-10]],[[250273,287341],[4,3290],[-383,6]],[[246377,290341],[40,-3234]],[[246417,287107],[-592,20],[0,-1670]],[[245825,285457],[-702,68]],[[266388,293403],[-34,-4888]],[[266354,288515],[-753,-748]],[[265601,287767],[-17,902]],[[265584,288669],[-113,3501]],[[263703,290107],[-14,-676]],[[263689,289431],[-975,45],[-28,-605]],[[262686,288871],[-213,626]],[[262473,289497],[-213,3738]],[[277775,289288],[-200,-1209],[-345,-446],[-431,-3537]],[[276799,284096],[-357,-1958],[-73,1501]],[[276369,283639],[-170,-184],[-119,1854],[-263,408]],[[275817,285717],[-479,2444],[-113,1946]],[[175704,293265],[8,-6545],[-64,-13],[-10,-8499]],[[175638,278208],[-2839,-1564],[17,2580],[-320,834],[-131,1949],[82,972],[-206,4489],[-531,4208],[-222,846]],[[261484,293284],[160,-5558]],[[261644,287726],[11,-400]],[[261655,287326],[-1005,-14]],[[260650,287312],[-168,-13]],[[260482,287299],[28,7247]],[[260482,287299],[-991,-305]],[[259491,286994],[-460,264]],[[233588,292353],[-6,-56]],[[233582,292297],[-853,-556],[-398,-899],[-290,-1445]],[[232041,289397],[8,3546]],[[272827,293506],[-15,-5200],[98,-784]],[[272910,287522],[-478,-196],[-495,933],[-201,-1171]],[[271736,287088],[-363,872],[-35,1043]],[[267418,291921],[45,-835],[-297,-951],[-55,-1335]],[[267111,288800],[-431,-34]],[[266680,288766],[-326,-251]],[[202831,292590],[15,-6293]],[[202846,286297],[-1525,-4281],[1,-811],[-1146,18],[-2,-3253]],[[200174,277970],[-860,-3]],[[199314,277967],[-358,449],[43,2766],[-165,3253],[-161,393],[-104,4257],[-348,-19]],[[238996,293588],[-214,-3466],[-110,32],[-25,-4497]],[[238647,285657],[-84,3]],[[238563,285660],[-791,14]],[[268555,290034],[21,-284]],[[268576,289750],[-391,-1856],[-455,-1078]],[[267730,286816],[-127,1308],[-492,676]],[[183362,276097],[1,-8677]],[[183363,267420],[-4124,8475],[12,2285],[251,1897]],[[179502,280077],[536,715],[179,2808],[-146,2208]],[[191393,276263],[-1966,-35],[0,-192],[-2916,95]],[[226312,293391],[-10,-8053]],[[226302,285338],[-375,38]],[[225927,285376],[-1032,85]],[[224895,285461],[17,7229]],[[240074,292338],[-28,-6700]],[[240046,285638],[-697,10]],[[239349,285648],[-702,9]],[[265584,288669],[-611,417]],[[264973,289086],[-229,4]],[[264744,289090],[59,1775]],[[274010,288608],[-793,-2802]],[[273217,285806],[-307,1716]],[[179502,280077],[-3864,-1869]],[[227802,293328],[-42,-8197]],[[227760,285131],[-406,74]],[[227354,285205],[-1052,133]],[[229332,292863],[-28,-7781]],[[229304,285082],[-524,-54]],[[228780,285028],[-1020,103]],[[262473,289497],[-829,-1771]],[[232039,284934],[-231,5],[-115,-1982],[146,-674]],[[231839,282283],[-397,24]],[[231442,282307],[-615,60]],[[230827,282367],[1,2607]],[[230828,284974],[5,6892]],[[232041,289397],[-2,-4463]],[[230828,284974],[-612,11]],[[230216,284985],[-912,97]],[[219070,292721],[-5,-8097]],[[219065,284624],[-381,10]],[[218684,284634],[-1066,126]],[[217618,284760],[-1,7949]],[[220537,292712],[6,-8141]],[[220543,284571],[-433,-2]],[[220110,284569],[-1045,55]],[[234975,292084],[-31,-7088]],[[234944,284996],[-291,1575],[-562,-613]],[[234091,285958],[1,6606]],[[217618,284760],[-376,-124]],[[217242,284636],[-1070,-48]],[[216172,284588],[2,8075]],[[223426,292715],[8,-8203]],[[223434,284512],[-404,2]],[[223030,284514],[-1045,0]],[[221985,284514],[-4,8228]],[[224895,285461],[-2,-1035],[-413,38]],[[224480,284464],[-1046,48]],[[221985,284514],[-393,-1]],[[221592,284513],[-1049,58]],[[244304,285424],[-1696,42]],[[242608,285466],[-191,2882]],[[216172,284588],[-373,15]],[[215799,284603],[-1072,-39]],[[214727,284564],[1,8003]],[[206995,276387],[10,-9680]],[[207005,266707],[-196,-1]],[[206809,266706],[-3008,34]],[[203801,266740],[-1057,-19]],[[202744,266721],[2,17810],[100,1766]],[[213282,292546],[0,-7999]],[[213282,284547],[-1309,5]],[[214727,284564],[-369,-14]],[[214358,284550],[-1076,-3]],[[234091,285958],[-73,-393]],[[234018,285565],[-60,-960],[-377,12]],[[233581,284617],[1,7680]],[[242608,285466],[-1828,115]],[[240780,285581],[-734,57]],[[233581,284617],[-993,-40]],[[232588,284577],[-549,357]],[[235411,290319],[-5,-7248]],[[235406,283071],[-145,-6]],[[235261,283065],[-39,471]],[[235222,283536],[-278,1460]],[[249070,289307],[-205,-1883],[-209,-3399],[-189,-953]],[[248467,283072],[-1109,2439]],[[247358,285511],[-151,1938],[245,381],[-3,3122]],[[264744,289090],[-346,-257]],[[264398,288833],[-567,369],[-126,-463]],[[263705,288739],[-16,692]],[[275817,285717],[197,-1750],[-222,-2037],[-677,748]],[[275115,282678],[4,3610],[-520,96],[-567,2296]],[[247358,285511],[-237,-29],[-2,-1592],[-572,-19]],[[246547,283871],[-8,3240],[-122,-4]],[[269458,290430],[-641,-2764]],[[268817,287666],[-241,2084]],[[269915,290292],[98,-679],[-163,-3128],[52,-2327],[-122,-1900]],[[269780,282258],[-329,-1370]],[[269451,280888],[-242,1119]],[[269209,282007],[-81,3666],[-311,1993]],[[237108,285672],[0,-2572]],[[237108,283100],[-1702,-29]],[[271736,287088],[202,-924]],[[271938,286164],[-630,-2537]],[[271308,283627],[-251,828],[-618,-687],[-182,-1941]],[[270257,281827],[-477,431]],[[252996,285150],[-21,-1156]],[[252975,283994],[-1295,-58]],[[251680,283936],[-1,6710]],[[251680,283936],[-283,11]],[[251397,283947],[-1128,95]],[[250269,284042],[4,3299]],[[250269,284042],[-1132,-33],[-12,-840]],[[249125,283169],[-658,-97]],[[257062,286243],[14,-3977],[-399,14]],[[256677,282280],[-836,-103],[-284,801]],[[255557,282978],[-2,2399]],[[269209,282007],[-689,-991],[-95,755],[-402,-936]],[[268023,280835],[-353,3484]],[[267670,284319],[60,2497]],[[263705,288739],[-84,-3973]],[[263621,284766],[55,-1652]],[[263676,283114],[-539,-692]],[[263137,282422],[-449,518]],[[262688,282940],[-2,5931]],[[262688,282940],[-898,-37]],[[261790,282903],[-135,4423]],[[199314,277967],[-878,-18],[0,-1622],[-852,-5],[-2,-8136],[36,-4019]],[[197618,264167],[-857,-7],[-37,4023],[3,8134],[-307,3],[2,1614],[-576,1],[-4,3232],[-537,6]],[[264398,288833],[-62,-3686]],[[264336,285147],[-715,-381]],[[264973,289086],[-7,-4742],[-221,-293]],[[264745,284051],[2,1069],[-411,27]],[[265601,287767],[265,-1985],[29,-1347]],[[265895,284435],[-506,-1945]],[[265389,282490],[-646,23]],[[264743,282513],[2,1538]],[[267670,284319],[-205,1161],[-587,-1541]],[[266878,283939],[-198,4827]],[[266878,283939],[-137,-520]],[[266741,283419],[-297,-993]],[[266444,282426],[-403,800],[-146,1209]],[[275274,275950],[263,628]],[[275537,276578],[-263,-628]],[[275115,282678],[-128,-2424],[77,-2306]],[[275064,277948],[21,-1800],[-453,1074]],[[274632,277222],[-397,2101],[-304,486]],[[273931,279809],[-206,2389],[-508,3608]],[[273217,285806],[-382,-1361],[-117,-2127],[-399,-1752]],[[272319,280566],[-381,5598]],[[254737,285441],[-323,-2640],[122,-3923],[141,-1191],[-210,-1224]],[[254467,276463],[-114,140]],[[254353,276603],[-184,1820],[-373,-689],[-63,3380],[-367,2778],[100,1345]],[[261790,282903],[136,-2308]],[[261926,280595],[-1276,-335]],[[260650,280260],[0,7052]],[[260650,280260],[-288,-579],[2,-1890]],[[260364,277791],[-286,-278],[4,-1615],[-248,-23]],[[259834,275875],[-17,4870],[-320,8]],[[259497,280753],[-6,6241]],[[259497,280753],[-1025,-27]],[[258472,280726],[-231,1150],[-165,3824]],[[246547,283871],[-291,-1615],[175,-342],[-73,-2890]],[[246358,279024],[-674,12],[3,3264],[138,3157]],[[235222,283536],[-1204,-38]],[[234018,283498],[0,2067]],[[258472,280726],[-106,-860]],[[258366,279866],[-839,-31],[-2,-819],[-563,46]],[[256962,279062],[-281,-17],[0,1226]],[[256681,280271],[-4,2009]],[[202744,266721],[-672,-16],[-49,-2499],[301,-1532]],[[202324,262674],[-2142,-5]],[[200182,262669],[-8,15301]],[[272319,280566],[44,-2784]],[[272363,277782],[-442,-1977]],[[271921,275805],[-817,2977]],[[271104,278782],[-65,752],[269,4093]],[[273931,279809],[-121,-807]],[[273810,279002],[-90,-725],[-314,2440],[-742,-3662]],[[272664,277055],[-301,727]],[[248467,283072],[-232,-2682],[-637,-1400],[-479,-1603]],[[247119,277387],[-290,-1241]],[[246829,276146],[-463,2072]],[[246366,278218],[-8,806]],[[238701,271113],[-400,6]],[[238301,271119],[-149,1514],[-322,444],[-466,-2739],[-255,8]],[[237109,270346],[-1,3654]],[[237108,274000],[0,5599]],[[237108,279599],[0,3501]],[[237743,285675],[-72,-1365],[156,-1652],[-2,-3964],[475,-5512],[401,-2069]],[[238563,285660],[193,-3037],[29,-8285],[191,-5]],[[238976,274333],[-155,-3244]],[[238821,271089],[-120,24]],[[239516,277586],[89,-2415],[-250,-840],[-379,2]],[[239349,285648],[4,-5606],[141,-1],[22,-2455]],[[240779,280837],[-287,-13],[-146,-3236]],[[240346,277588],[-830,-2]],[[240780,285581],[-1,-4744]],[[242619,280157],[-575,-2639],[-400,30]],[[241644,277548],[0,1623],[-290,937],[-575,729]],[[242608,285466],[11,-5309]],[[234018,283498],[-3,-6187]],[[234015,277311],[-896,740],[-334,1437]],[[232785,279488],[-113,619]],[[232672,280107],[-84,4470]],[[246366,278218],[-28,-988],[-363,175],[-2,-2477],[-251,41],[-36,2444],[-221,12]],[[245465,277425],[-297,1279],[258,1421],[-227,255],[-6,1864],[185,934],[-62,1883],[-223,-1603],[31,1932]],[[268023,280835],[-29,-951]],[[267994,279884],[-750,-2311]],[[267244,277573],[-503,5846]],[[244371,285427],[-163,-2146],[-308,-2022],[-90,-2138]],[[243810,279121],[-368,-2106],[-400,-900]],[[243042,276115],[-26,3010],[-397,1032]],[[255557,282978],[-142,-817],[-5,-3254],[-143,-3],[2,-3233]],[[255269,275671],[-569,-21],[-233,813]],[[244852,285408],[-216,-2699],[-7,-2066],[-283,-3112]],[[244346,277531],[-420,5],[-116,1585]],[[225927,285376],[-30,-8275]],[[225897,277101],[-4,-879]],[[225893,276222],[-1133,26]],[[224760,276248],[-282,40]],[[224478,276288],[2,8176]],[[245465,277425],[-76,-261]],[[245389,277164],[-175,-453],[-903,-2]],[[244311,276709],[35,822]],[[227354,285205],[-18,-8168]],[[227336,277037],[-185,1]],[[227151,277038],[-1254,63]],[[264743,282513],[-219,-2967]],[[264524,279546],[-235,1091]],[[264289,280637],[-264,580],[-349,1897]],[[254353,276603],[-497,-1834],[-41,-1059],[323,-1231]],[[254138,272479],[-1368,-35]],[[252770,272444],[91,5016]],[[252861,277460],[114,6534]],[[228780,285028],[-17,-8117]],[[228763,276911],[-135,15]],[[228628,276926],[-1292,111]],[[230216,284985],[-6,-3141]],[[230210,281844],[-31,-4996]],[[230179,276848],[-1416,63]],[[230827,282367],[0,-512],[-617,-11]],[[232672,280107],[-600,940],[-233,1236]],[[218684,284634],[-13,-8157]],[[218671,276477],[-1432,44]],[[217239,276521],[3,8115]],[[210139,266701],[-717,-2]],[[209422,266699],[-123,-1]],[[209299,266698],[-2294,9]],[[220110,284569],[-7,-8139]],[[220103,276430],[-1432,47]],[[217239,276521],[0,-67]],[[217239,276454],[-1432,21]],[[215807,276475],[-8,8128]],[[215807,276475],[-1432,-36]],[[214375,276439],[-17,8111]],[[214375,276439],[-24,-1]],[[214351,276438],[-2378,-19]],[[221592,284513],[0,-8235]],[[221592,276278],[-48,0]],[[221544,276278],[-1441,152]],[[223030,284514],[0,-8234]],[[223030,276280],[-51,1]],[[222979,276281],[-1387,-3]],[[224478,276288],[-1448,-8]],[[271104,278782],[-447,-786]],[[270657,277996],[-226,1046],[-174,2785]],[[266444,282426],[-235,-3362]],[[266209,279064],[-288,518]],[[265921,279582],[-345,931],[-187,1977]],[[251397,283947],[0,-6509]],[[251397,277438],[-1123,-9]],[[250274,277429],[-5,6613]],[[250274,277429],[-14,-1]],[[250260,277428],[-1136,16],[0,1060]],[[249124,278504],[1,4665]],[[252861,277460],[-1464,-22]],[[235261,283065],[11,-1603]],[[235272,281462],[1,-2617]],[[235273,278845],[-795,-2144]],[[234478,276701],[-463,610]],[[267244,277573],[-756,-2456]],[[266488,275117],[-124,3123],[-155,824]],[[264289,280637],[-142,-524],[-197,-2955],[-99,3]],[[263851,277161],[-538,-506]],[[263313,276655],[-159,-301]],[[263154,276354],[0,1215]],[[263154,277569],[-17,4853]],[[237108,279599],[-280,902],[-87,-872],[-299,1007],[-286,-1037],[-341,13],[-543,1850]],[[249124,278504],[-150,-881]],[[248974,277623],[-206,-33],[-579,-3455]],[[248189,274135],[-495,8],[0,1630],[-575,8],[0,1606]],[[256681,280271],[-69,-2498],[-191,-1960],[-869,-125],[4,-3255],[-143,-9]],[[255413,272424],[-143,-6],[-1,3253]],[[263154,277569],[-1076,448]],[[262078,278017],[-152,2578]],[[265921,279582],[1,-27]],[[265922,279555],[-184,34],[-659,-3026]],[[265079,276563],[-284,2687],[-271,296]],[[231442,282307],[2,-8954]],[[231444,273353],[-1048,21]],[[230396,273374],[-217,3474]],[[270657,277996],[-80,-1269]],[[270577,276727],[-329,-341],[-291,-3111],[55,-642]],[[270012,272633],[0,-5]],[[270012,272628],[-338,-491],[-153,1147]],[[269521,273284],[74,1606],[-301,1073],[-437,275]],[[268857,276238],[507,2501],[87,2149]],[[232785,279488],[1,-3857],[404,-2322]],[[233190,273309],[-1746,44]],[[268857,276238],[-59,1856],[-542,1928],[-262,-138]],[[237108,274000],[-848,-1143],[-402,1182]],[[235858,274039],[-244,1]],[[235614,274040],[-342,532],[1,4273]],[[197618,264167],[24,-1497]],[[197642,262670],[0,-8383],[-2345,-24]],[[195297,254263],[7,20372]],[[259834,275875],[18,-769],[-399,-590]],[[259453,274516],[-479,386],[-118,1013],[-485,-1586]],[[258371,274329],[-5,5537]],[[241644,277548],[-1,-1627]],[[241643,275921],[-577,18],[2,-798],[-433,-2]],[[240635,275139],[-285,12],[-4,2437]],[[273810,279002],[98,-1654]],[[273908,277348],[8,-2098]],[[273916,275250],[-11,-827]],[[273905,274423],[15,-90]],[[273920,274333],[-20,-184]],[[273900,274149],[-60,-391]],[[273840,273758],[-438,-2518],[192,-2128]],[[273594,269112],[-42,-1026],[-431,800]],[[273121,268886],[-76,2025]],[[273045,270911],[44,2084],[-425,4060]],[[265079,276563],[-41,-438]],[[265038,276125],[-259,143],[-399,-2644]],[[264380,273624],[-384,781]],[[263996,274405],[-145,2756]],[[262078,278017],[222,-1817]],[[262300,276200],[-162,-699],[-765,-79],[10,-1076],[-289,-21]],[[261094,274325],[-155,1623],[-575,1843]],[[256962,279062],[29,-2257],[255,-3763]],[[257246,273042],[-260,-2156],[4,-3296]],[[256990,267590],[-755,-8],[-206,1771],[-614,2276]],[[255415,271629],[-2,795]],[[243042,276115],[-252,-2319],[-86,-1941]],[[242704,271855],[-773,7]],[[241931,271862],[-288,2425],[0,1634]],[[268650,272453],[-454,-2106]],[[268196,270347],[-296,-908],[-412,5134]],[[267488,274573],[-244,3000]],[[268857,276238],[-273,-3364],[66,-421]],[[258371,274329],[-238,-1220]],[[258133,273109],[-631,1134],[-256,-1201]],[[274213,271739],[154,-1026],[-395,-1964],[241,2990]],[[273840,273758],[261,-1594],[-185,-2613],[-322,-439]],[[273920,274333],[-20,-184]],[[273916,275250],[-11,-827]],[[274414,275982],[264,-153],[280,-1525],[-294,-989],[-167,-1799],[-139,1959],[56,2507]],[[274160,276707],[170,-315],[46,-4156],[-277,1436],[-122,1905],[183,1130]],[[274632,277222],[33,-1172],[-536,816],[-157,-984],[-64,1466]],[[265516,275419],[-478,706]],[[265922,279555],[-53,-2958],[-353,-1178]],[[266488,275117],[0,-942]],[[266488,274175],[-328,-2106]],[[266160,272069],[-649,44]],[[265511,272113],[5,3306]],[[234478,276701],[5,-3100]],[[234483,273601],[0,-4335]],[[234483,269266],[-1322,-45]],[[233161,269221],[-81,1801],[110,2287]],[[244311,276709],[-53,-2457]],[[244258,274252],[-441,-8],[-351,-1304],[-29,-1625],[-344,-1797]],[[243093,269518],[-234,271],[-155,2066]],[[235614,274040],[-175,-434],[-956,-5]],[[271921,275805],[37,-1771],[275,-2845]],[[272233,271189],[-961,-1642]],[[271272,269547],[-98,1564],[-427,592]],[[270747,271703],[140,2716],[-310,2308]],[[250260,277428],[-1,-6571]],[[250259,270857],[-1135,-31]],[[249124,270826],[0,2438],[-150,4359]],[[246829,276146],[-140,-526],[-66,-2601],[-184,267],[-97,-2398]],[[246342,270888],[-114,-1301],[-411,-1386],[-315,625]],[[245502,268826],[-2,115]],[[245500,268941],[-62,69]],[[245438,269010],[-314,191],[117,1426]],[[245241,270627],[337,223],[252,2167],[-256,411],[68,1606],[-306,123],[53,2007]],[[263154,276354],[-211,-1787],[-562,-838]],[[262381,273729],[-81,2471]],[[200182,262669],[-2540,1]],[[273045,270911],[-142,208],[-547,-2636]],[[272356,268483],[-123,2706]],[[261094,274325],[1,-3262]],[[261095,271063],[-1173,-45],[-180,787]],[[259742,271805],[-289,2711]],[[249124,270826],[0,-3253]],[[249124,267573],[-1393,50]],[[247731,267623],[-42,2293],[500,4219]],[[240635,275139],[6,-4082],[-110,-1625]],[[240531,269432],[-347,19]],[[240184,269451],[-691,9]],[[239493,269460],[-75,1632],[-597,-3]],[[267488,274573],[-96,548],[-482,-3351]],[[266910,271770],[-422,2405]],[[252770,272444],[-27,-1509]],[[252743,270935],[-1345,-64]],[[251398,270871],[-1,6567]],[[251398,270871],[-1139,-14]],[[247731,267623],[-1360,-26]],[[246371,267597],[-29,3291]],[[245500,268941],[-62,69]],[[245241,270627],[-1027,-144]],[[244214,270483],[-102,1786],[146,1983]],[[263996,274405],[-106,-4613]],[[263890,269792],[-3,-599]],[[263887,269193],[-267,9],[-340,1832]],[[263280,271034],[-27,-2]],[[263253,271032],[60,5623]],[[270747,271703],[-157,186]],[[270590,271889],[-578,744]],[[227151,277038],[5,-4409]],[[227156,272629],[-469,-48],[-452,-1537]],[[226235,271044],[-342,5178]],[[228628,276926],[2,-5287]],[[228630,271639],[-1087,-1713]],[[227543,269926],[-107,-742],[-280,1303]],[[227156,270487],[0,2142]],[[230396,273374],[193,-555]],[[230589,272819],[-1430,-4745]],[[229159,268074],[-124,-407],[-405,3972]],[[255415,271629],[-143,-188],[4,-2272],[-284,-8],[4,-2362],[-126,-263]],[[254870,266536],[-1130,-22]],[[253740,266514],[-126,1159],[208,569],[68,3760],[248,477]],[[263253,271032],[-736,-37]],[[262517,270995],[98,588],[-330,1226],[96,920]],[[217239,276454],[-26,-8133]],[[217213,268321],[-224,-2]],[[216989,268319],[-1200,8]],[[215789,268327],[18,8148]],[[218671,276477],[-13,-8190]],[[218658,268287],[-436,22]],[[218222,268309],[-1009,12]],[[220103,276430],[-15,-8194]],[[220088,268236],[-232,-5]],[[219856,268231],[-1198,56]],[[215789,268327],[-226,-12]],[[215563,268315],[-1212,-2]],[[214351,268313],[0,8125]],[[214351,268313],[-211,4]],[[214140,268317],[-1427,-23]],[[212713,268294],[-739,24]],[[265511,272113],[-316,-756],[-183,-1475]],[[265012,269882],[-430,1091]],[[264582,270973],[-206,1238],[4,1413]],[[221544,276278],[-6,-8068]],[[221538,268210],[-230,15]],[[221308,268225],[-1220,11]],[[224760,276248],[1,-3983],[-213,-701]],[[224548,271564],[-1040,-3414]],[[223508,268150],[-541,29]],[[222967,268179],[12,8102]],[[226235,271044],[225,-2721]],[[226460,268323],[-392,-1293]],[[226068,267030],[-565,-1869]],[[225503,265161],[-119,1166],[-213,-723],[-623,5960]],[[222967,268179],[-215,-7]],[[222752,268172],[-1214,38]],[[191393,274653],[-1,-12959]],[[191392,261694],[-1985,-98],[1,-3801],[-565,-10],[0,-1773]],[[188843,256012],[-5480,11408]],[[269521,273284],[-686,-1046]],[[268835,272238],[-185,215]],[[262517,270995],[-386,-1847],[16,-1277]],[[262147,267871],[-360,-24],[-203,1604],[-424,-24]],[[261160,269427],[-65,1636]],[[259742,271805],[-223,-444],[6,-3714]],[[259525,267647],[5,-1554],[-546,-20]],[[258984,266073],[-309,-26],[-4,1611],[-286,-16]],[[258385,267642],[-7,3608],[-245,1859]],[[241931,271862],[-1,-2445]],[[241930,269417],[-1399,15]],[[268196,270347],[-120,-1132]],[[268076,269215],[-774,-4371]],[[267302,264844],[-222,1408],[-144,2418]],[[266936,268670],[128,1356],[-154,1744]],[[264582,270973],[-5,-1325],[-687,144]],[[195297,254263],[-3928,9]],[[191369,254272],[23,7422]],[[258385,267642],[-117,-1603]],[[258268,266039],[-1141,-46]],[[257127,265993],[-137,1597]],[[235858,274039],[-247,-3594],[-55,-4247],[247,15]],[[235803,266213],[165,-2415]],[[235968,263798],[-1351,24]],[[234617,263822],[-133,12],[-1,5432]],[[244214,270483],[8,-2105],[-240,-3867]],[[243982,264511],[-59,1623],[-511,-1824],[-304,1856]],[[243108,266166],[-15,3352]],[[266936,268670],[-756,231]],[[266180,268901],[-20,3168]],[[237109,270346],[75,-4024]],[[237184,266322],[-1381,-109]],[[233161,269221],[87,-951]],[[233248,268270],[-1739,-1463]],[[231509,266807],[-6,123]],[[231503,266930],[-162,2702],[-752,3187]],[[269315,266119],[-168,-187]],[[269147,265932],[-152,1040],[-160,5266]],[[269521,273284],[-206,-7165]],[[270012,272628],[143,-2844],[-121,-4705]],[[270034,265079],[-575,986]],[[269459,266065],[-144,54]],[[238301,271119],[215,-817],[-12,-1665],[522,-3202]],[[239026,265435],[-240,-345],[-1,-1274]],[[238785,263816],[-1220,-19]],[[237565,263797],[-381,2525]],[[231503,266930],[-1231,-4027]],[[230272,262903],[-620,348]],[[229652,263251],[-493,4823]],[[227156,270487],[-696,-2164]],[[270590,271889],[127,-3675],[608,-624]],[[271325,267590],[-175,-616]],[[271150,266974],[-403,-4200]],[[270747,262774],[-221,704]],[[270526,263478],[-177,1370],[-315,231]],[[253740,266514],[-294,-3348],[252,-2067]],[[253698,261099],[-1047,-27]],[[252651,261072],[-25,3649]],[[252626,264721],[117,6214]],[[269147,265932],[-285,-745]],[[268862,265187],[-233,1642],[-442,1367],[-111,1019]],[[261160,269427],[-51,-2452],[-440,-328],[-199,-2179]],[[260470,264468],[-371,2],[3,1617],[-263,0],[-26,1492],[-288,68]],[[266180,268901],[-4,-1685]],[[266176,267216],[-979,51]],[[265197,267267],[-185,2615]],[[271272,269547],[173,-1187]],[[271445,268360],[-120,-770]],[[243108,266166],[-323,-822]],[[242785,265344],[-856,1]],[[241929,265345],[1,4072]],[[257127,265993],[-143,-9],[6,-2440]],[[256990,263544],[-1655,-26]],[[255335,263518],[-332,-39],[-133,3057]],[[229652,263251],[-593,-1974]],[[229059,261277],[-293,2871],[-669,-2188]],[[228097,261960],[2,1607],[-452,1892],[172,815],[-272,611],[-4,3041]],[[225503,265161],[144,-1411],[-855,-2936]],[[224792,260814],[-81,738],[-490,-430]],[[224221,261122],[-713,7028]],[[245502,268826],[-127,-1816],[-313,-1032],[-167,-1704]],[[244895,264274],[-271,-484],[77,-1751]],[[244701,262039],[-172,-288]],[[244529,261751],[-462,332]],[[244067,262083],[-85,2428]],[[272356,268483],[444,-3810]],[[272800,264673],[248,-709],[-50,-2336],[-442,1524]],[[272556,263152],[-244,2510],[-518,507],[-349,2191]],[[239493,269460],[179,-3272],[-322,2],[-3,-1287],[-321,532]],[[273103,263918],[241,-619],[-261,-1765],[-124,1738],[144,646]],[[273429,267956],[229,-1122],[-211,-969],[-18,2091]],[[273121,268886],[209,-711],[80,-2196],[219,-966],[-158,-953],[-438,1416],[-233,-803]],[[263887,269193],[-34,-3123]],[[263853,266070],[-27,-877],[-408,18]],[[263418,265211],[-156,2]],[[263262,265213],[18,5821]],[[263262,265213],[-700,78]],[[262562,265291],[-449,1252]],[[262113,266543],[34,1328]],[[265197,267267],[107,-2251]],[[265304,265016],[-1157,121],[0,-795]],[[264147,264342],[-294,1728]],[[252626,264721],[-415,-683],[-803,-568]],[[251408,263470],[-10,7401]],[[246371,267597],[-50,-4881]],[[246321,262716],[-773,1409],[-653,149]],[[251408,263470],[-92,-39]],[[251316,263431],[-1040,-418]],[[250276,263013],[-17,7844]],[[250276,263013],[-235,-98]],[[250041,262915],[-702,-302]],[[249339,262613],[-25,4964],[-190,-4]],[[228097,261960],[-913,-2937]],[[227184,259023],[-236,2294],[-214,-718]],[[226734,260599],[-666,6431]],[[268862,265187],[-531,-2010]],[[268331,263177],[-444,-557]],[[267887,262620],[-507,1246]],[[267380,263866],[-78,978]],[[241929,265345],[-139,-2434]],[[241790,262911],[-715,10],[-2,-1631],[-985,-12]],[[240088,261278],[65,2739],[214,1718],[-183,3716]],[[240088,261278],[187,-1588],[292,-495],[230,-1479]],[[240797,257716],[-541,-2780],[-190,-402]],[[240066,254534],[-710,332]],[[239356,254866],[-1,3236],[-281,-4],[-4,3279],[-287,5],[2,2434]],[[262113,266543],[-202,-2490],[-1,-1443]],[[261910,262610],[38,-331]],[[261948,262279],[-247,-1122],[-557,79],[-1,-1623]],[[261143,259613],[-925,-27]],[[260218,259586],[239,3100],[13,1782]],[[234617,263822],[-104,-1184],[69,-2704],[234,-2043]],[[234816,257891],[-383,-1878]],[[234433,256013],[-270,786],[-111,1768],[-372,550]],[[233680,259117],[-7,1203],[-351,1944],[-118,1559],[44,4447]],[[267380,263866],[-842,-12]],[[266538,263854],[-369,127]],[[266169,263981],[7,3235]],[[273082,261033],[-133,-2580],[-38,2027],[171,553]],[[272823,261759],[40,-1068],[-396,-433]],[[272467,260258],[-390,846]],[[272077,261104],[-418,1229],[-343,2022],[41,1842],[-207,777]],[[272556,263152],[267,-1393]],[[218222,268309],[-10,-7269]],[[218212,261040],[-111,-2492],[-1121,-108]],[[216980,258440],[1,1757]],[[216981,260197],[8,8122]],[[216981,260197],[-1417,9]],[[215564,260206],[-1,8109]],[[215564,260206],[-1425,-1]],[[214139,260205],[1,8112]],[[214139,260205],[-86,1]],[[214053,260206],[-1251,7]],[[212802,260213],[-89,1]],[[212713,260214],[0,8080]],[[212713,260214],[-1472,-6]],[[211241,260208],[3,6496]],[[219856,268231],[-1,-7250]],[[219855,260981],[-1643,59]],[[233680,259117],[-1054,-950],[-246,-706]],[[232380,257461],[15,2779],[-147,-648]],[[232248,259592],[-249,2566],[-298,601],[38,1653],[-230,2395]],[[222752,268172],[-19,-11396]],[[222733,256776],[-311,-1069],[-354,1218],[-198,-944],[-249,1262]],[[221621,257243],[-334,1575]],[[221287,258818],[21,9407]],[[221287,258818],[-1085,65]],[[220202,258883],[-344,21],[-3,2077]],[[224221,261122],[-255,-235],[-56,-1438],[-589,-2355]],[[223321,257094],[-276,-434]],[[223045,256660],[-312,116]],[[260218,259586],[-114,-1]],[[260104,259585],[-994,-4]],[[259110,259581],[-7,3224],[-142,-9],[23,3277]],[[259110,259581],[-134,-3309]],[[258976,256272],[-231,290],[-9,1358],[-330,-1424],[-4,1398],[-276,-34]],[[258126,257860],[-1,2419],[142,7],[1,5753]],[[247731,267623],[274,-3564],[26,-1966]],[[248031,262093],[-342,-655]],[[247689,261438],[-106,-329],[-1263,-25]],[[246320,261084],[1,1632]],[[249339,262613],[-284,-111]],[[249055,262502],[-612,-242]],[[248443,262260],[-412,-167]],[[266169,263981],[-1,-930],[-528,-12]],[[265640,263039],[-382,825]],[[265258,263864],[46,1152]],[[225328,255832],[-536,4982]],[[226734,260599],[-1152,-3886]],[[225582,256713],[-254,-881]],[[272077,261104],[-207,-2290],[-271,-705]],[[271599,258109],[-852,4665]],[[232248,259592],[-1251,-3816]],[[230997,255776],[-725,7127]],[[209299,266698],[-217,-16660]],[[209082,250038],[-2270,-8220]],[[206812,241818],[27,3208],[-30,21680]],[[206812,241818],[-175,-639]],[[206637,241179],[-655,3287],[-500,980],[-452,2433],[-137,1784],[-466,1523],[-267,2269],[-357,1834]],[[203803,255289],[-2,11451]],[[203803,255289],[-617,1714],[-455,4718],[-407,953]],[[211241,260208],[-789,7]],[[210452,260215],[-226,1786],[-294,419],[-120,2210],[-127,-359],[-263,2428]],[[210452,260215],[261,-433],[176,-3774],[535,32],[186,-1031],[512,-16]],[[212122,254993],[-1599,-11260]],[[210523,243733],[-1441,6305]],[[262562,265291],[-9,-2748],[-135,18]],[[262418,262561],[-508,49]],[[255335,263518],[-42,-2446],[-142,-14],[4,-2674],[-156,-741],[132,-1479],[-365,-603],[-167,-1944]],[[254599,253617],[-506,-1945]],[[254093,251672],[-63,1221],[229,2447],[-147,-275],[95,2172],[-484,2051],[-25,1811]],[[237565,263797],[235,-2648],[-112,-2155]],[[237688,258994],[-417,-313]],[[237271,258681],[-296,953],[-858,614]],[[236117,260248],[-149,3550]],[[244067,262083],[-416,-314],[-35,-1776],[-277,-170],[-1,-3574],[-157,-1570],[81,-1640]],[[243262,253039],[-258,530],[-178,-1296],[-48,1873]],[[242778,254146],[7,11198]],[[269459,266065],[0,-2384],[-247,7],[-4,-2375]],[[269208,261313],[-295,-710]],[[268913,260603],[-583,-23],[1,2597]],[[264147,264342],[212,-842],[-100,-3841]],[[264259,259659],[-425,-12]],[[263834,259647],[-269,0]],[[263565,259647],[-156,2805],[9,2759]],[[270526,263478],[-236,-999],[1,-5623]],[[270291,256856],[-262,1105]],[[270029,257961],[-821,3352]],[[258126,257860],[-564,-26]],[[257562,257834],[-384,25],[-188,2000],[3,2240]],[[256993,262099],[-3,1445]],[[263565,259647],[-754,-29]],[[262811,259618],[-348,-20],[-45,2963]],[[242778,254146],[-219,178]],[[242559,254324],[-305,2653]],[[242254,256977],[-195,277],[-241,2436],[-28,3221]],[[265258,263864],[-181,-812],[-39,-2866]],[[265038,260186],[-69,-497],[-710,-30]],[[252692,256194],[-1093,-40]],[[251599,256154],[-283,-4]],[[251316,256150],[0,7281]],[[252651,261072],[41,-4878]],[[246320,261084],[-2,-1627]],[[246318,259457],[-1160,-19]],[[245158,259438],[-408,1159],[-49,1442]],[[227703,254041],[-519,4982]],[[229059,261277],[365,-3474]],[[229424,257803],[-1329,-4514]],[[228095,253289],[-182,-662],[-210,1414]],[[266538,263854],[73,-1664]],[[266611,262190],[-131,-3052]],[[266480,259138],[-414,-483]],[[266066,258655],[-411,1022],[-15,3362]],[[267887,262620],[-7,-2008]],[[267880,260612],[-912,139],[0,1414],[-357,25]],[[266066,258655],[-13,-4419]],[[266053,254236],[-962,80]],[[265091,254316],[4,2024]],[[265095,256340],[-57,3846]],[[236117,260248],[245,-1198],[-44,-6786]],[[236318,252264],[-313,1644],[-176,1815],[-632,881],[-381,1287]],[[239356,254866],[-430,-7],[-146,-1627],[-240,7],[-65,-1704]],[[238475,251535],[-133,-175]],[[238342,251360],[-234,2339],[-88,3955],[-332,1340]],[[271599,258109],[109,-1596]],[[271708,256513],[-299,-2289]],[[271409,254224],[-861,806]],[[270548,255030],[-29,1448],[-228,378]],[[256993,262099],[-405,-644],[-234,-1414],[-90,-2314],[-724,-4799]],[[255540,252928],[-525,-297]],[[255015,252631],[-416,986]],[[251316,256150],[-565,11]],[[250751,256161],[-705,0]],[[250046,256161],[-5,6754]],[[229993,252193],[-569,5610]],[[230997,255776],[-230,-1047]],[[230767,254729],[-774,-2536]],[[268913,260603],[84,-3784]],[[268997,256819],[-88,-1964]],[[268909,254855],[-525,11],[-61,691],[-839,350]],[[267484,255907],[-15,965]],[[267469,256872],[411,3740]],[[242254,256977],[-1212,-1624],[-245,2363]],[[250046,256161],[-146,0]],[[249900,256161],[-376,-7]],[[249524,256154],[-46,1959],[-425,1319],[2,3070]],[[262811,259618],[-6,-2207]],[[262805,257411],[-584,-282],[-45,579]],[[262176,257708],[-228,4571]],[[262176,257708],[-117,-3881]],[[262059,253827],[-919,118]],[[261140,253945],[3,5668]],[[249524,256154],[-188,2]],[[249336,256156],[-474,-1],[3,-814],[-378,9]],[[248487,255350],[-44,6910]],[[267469,256872],[-538,70]],[[266931,256942],[-451,2196]],[[244529,261751],[-61,-2123],[-259,460],[229,-1495],[-276,-598],[18,-3120],[-205,749],[175,-2364],[-388,-522],[182,-1099]],[[243944,251639],[-102,-1383],[173,-932],[-202,-1255]],[[243813,248069],[-73,-541]],[[243740,247528],[12,447]],[[243752,247975],[-182,929]],[[243570,248904],[129,2677],[-437,1458]],[[248487,255350],[-226,-1014]],[[248261,254336],[-568,265]],[[247693,254601],[-4,6837]],[[257562,257834],[96,-2877],[-99,-436],[7,-2858]],[[257566,251663],[-178,1282],[-1848,-17]],[[245158,259438],[-12,-4903]],[[245146,254535],[-217,450],[-648,-955],[-50,-1687],[-287,-704]],[[191369,254272],[-1713,-9],[-813,1749]],[[225328,255832],[-812,-3459]],[[224516,252373],[-177,743],[-194,2530],[-443,142],[-381,1306]],[[247693,254601],[-46,0]],[[247647,254601],[-802,-13]],[[246845,254588],[-237,-7]],[[246608,254581],[0,4882],[-290,-6]],[[270029,257961],[-328,-1873],[-203,-243]],[[269498,255845],[-501,974]],[[226342,249372],[-760,7341]],[[227703,254041],[-1361,-4669]],[[220202,258883],[-12,-9165]],[[220190,249718],[-1597,-26]],[[218593,249692],[-12,8143],[-1602,88]],[[216979,257923],[1,517]],[[254093,251672],[-73,-563]],[[254020,251109],[-140,-343],[-854,-8],[-285,-550]],[[252741,250208],[-49,5986]],[[272538,253809],[-20,-18]],[[272518,253791],[20,18]],[[272206,254211],[-81,132]],[[272125,254343],[81,-132]],[[272895,258076],[-221,-2947],[-140,1837],[361,1110]],[[272467,260258],[359,-497],[69,-954],[-372,-537],[-14,-3438],[142,-738],[-530,300]],[[272121,254394],[-413,2119]],[[232380,257461],[233,-3410],[-191,-919],[-110,-3298]],[[232312,249834],[-586,-39],[-742,-2204]],[[230984,247591],[-246,5282],[29,1856]],[[215564,260206],[-1,-10640]],[[215563,249566],[-1463,119]],[[214100,249685],[-47,10521]],[[214100,249685],[-245,18]],[[213855,249703],[-113,1973],[-687,2489],[-254,-616]],[[212801,253549],[1,6664]],[[237271,258681],[4,-1923],[-170,-1045],[14,-5133]],[[237119,250580],[-252,-651]],[[236867,249929],[-549,2335]],[[216979,257923],[-19,-8365]],[[216960,249558],[-1397,8]],[[212801,253549],[-158,-489],[-521,1933]],[[265095,256340],[-399,-66]],[[264696,256274],[-805,-62]],[[263891,256212],[-57,3435]],[[263891,256212],[-578,-53]],[[263313,256159],[-423,45],[-85,1207]],[[261140,253945],[-191,-1283],[-485,462],[-142,-1410]],[[260322,251714],[-224,22]],[[260098,251736],[6,7849]],[[260098,251736],[-1120,-77]],[[258978,251659],[-2,4613]],[[246608,254581],[-1058,-7],[-230,-518]],[[245320,254056],[-174,479]],[[238342,251360],[-866,-337]],[[237476,251023],[-357,-443]],[[266931,256942],[-267,-2339]],[[266664,254603],[-217,-427]],[[266447,254176],[-394,60]],[[234433,256013],[126,-728]],[[234559,255285],[-1328,-6123]],[[233231,249162],[-511,-2377]],[[232720,246785],[-160,1025],[32,1830],[-280,194]],[[221621,257243],[-4,-7538]],[[221617,249705],[-1427,13]],[[270548,255030],[135,-1217],[-559,-1966],[-260,400]],[[269864,252247],[-282,1361],[-84,2237]],[[258978,251659],[17,-3690]],[[258995,247969],[-561,3]],[[258434,247972],[-835,6]],[[257599,247978],[-33,3685]],[[218593,249692],[-762,-76]],[[217831,249616],[-871,-58]],[[236867,249929],[-914,-1226]],[[235953,248703],[-290,477]],[[235663,249180],[-783,1632]],[[234880,250812],[-186,3541],[-135,932]],[[263313,256159],[-12,-3258]],[[263301,252901],[-768,-60],[-14,-3409]],[[262519,249432],[-296,57]],[[262223,249489],[-201,1664],[37,2674]],[[229346,250051],[-672,-2227]],[[228674,247824],[-579,5465]],[[229993,252193],[-647,-2142]],[[242559,254324],[-409,-313],[69,-6633],[-201,52]],[[242018,247430],[-298,679],[-277,-1715],[-308,-248]],[[241135,246146],[-630,-114]],[[240505,246032],[-16,6745],[-423,1757]],[[223045,256660],[-5,-9678]],[[223040,246982],[-1093,-7]],[[221947,246975],[-331,2],[1,2728]],[[224516,252373],[110,-2638],[233,-1105]],[[224859,248630],[-17,-2012]],[[224842,246618],[-1446,-2]],[[223396,246616],[-356,366]],[[267484,255907],[289,-2604],[-29,-1804]],[[267744,251499],[-329,-678],[-91,-2266]],[[267324,248555],[-270,35]],[[267054,248590],[-114,4038],[-276,1975]],[[269864,252247],[216,-986],[1,-1604],[213,-1377]],[[270294,248280],[-791,53],[-15,-4065],[756,-203],[-181,-4018]],[[270063,240047],[-569,247]],[[269494,240294],[-47,4436],[-166,-9],[13,2675],[-283,1029],[-221,3071]],[[268790,251496],[-78,1759],[195,-14],[2,1614]],[[226342,249372],[-12,-642]],[[226330,248730],[-1471,-100]],[[272538,253809],[99,-1698],[-281,-1545],[-109,1279],[124,2060],[147,-114]],[[272121,254394],[4,-51]],[[272206,254211],[155,-844],[-204,-1997],[71,-2599],[-325,802]],[[271903,249573],[-591,1665]],[[271312,251238],[97,2986]],[[264696,256274],[-167,-1562],[-391,-949],[-69,-1200],[-328,-1574],[-68,-1447]],[[263673,249542],[-96,10]],[[263577,249552],[15,3293],[-291,56]],[[265091,254316],[-12,-4797]],[[265079,249519],[-315,12]],[[264764,249531],[-724,18]],[[264040,249549],[-367,-7]],[[252741,250208],[18,-2159]],[[252759,248049],[-1139,-6]],[[251620,248043],[-21,8111]],[[250751,256161],[23,-9759]],[[250774,246402],[-565,1]],[[250209,246403],[-23,1870]],[[250186,248273],[3,6262],[-287,-6],[-2,1632]],[[250186,248273],[-850,-146]],[[249336,248127],[0,8029]],[[251620,248043],[-141,-1624]],[[251479,246419],[-705,-17]],[[249336,248127],[-206,-4]],[[249130,248123],[-300,-5]],[[248830,248118],[0,1358],[-237,-5],[-309,1881],[-23,2984]],[[268790,251496],[-833,9]],[[267957,251505],[-213,-6]],[[234880,250812],[-269,-1952],[-727,-4046]],[[233884,244814],[-145,1530],[-209,-879]],[[233530,245465],[-193,-34],[-106,3731]],[[213855,249703],[556,-1561],[548,-266],[329,-1468],[180,-3868],[116,-913]],[[215584,241627],[-1029,49],[-1,-1089],[-570,23],[-1,-5857],[-623,-16],[0,-4293]],[[213360,230444],[-2433,11417]],[[210927,241861],[-404,1872]],[[271312,251238],[-472,-2257]],[[270840,248981],[-349,502],[-197,-1203]],[[245320,254056],[101,-734],[-2,-5262]],[[245419,248060],[-324,3]],[[245095,248063],[-1282,6]],[[240505,246032],[-431,-220]],[[240074,245812],[-1233,93],[-383,-267]],[[238458,245638],[138,2981],[-121,2916]],[[230984,247591],[-297,-1132],[-306,-3133],[-307,-918]],[[230074,242408],[-150,659]],[[229924,243067],[-83,1791],[-230,1423],[-92,2593],[-173,1177]],[[267054,248590],[-504,85]],[[266550,248675],[-277,858]],[[266273,249533],[181,2384],[-7,2259]],[[246845,254588],[1,-6513]],[[246846,248075],[-54,0]],[[246792,248075],[-721,-7]],[[246071,248068],[-652,-8]],[[247647,254601],[2,-6508]],[[247649,248093],[-244,-5]],[[247405,248088],[-559,-13]],[[248830,248118],[-1181,-25]],[[243570,248904],[-74,-473]],[[243496,248431],[-155,-910],[-26,-2268]],[[243315,245253],[-1107,9]],[[242208,245262],[-190,2168]],[[266273,249533],[3,-822],[-452,71]],[[265824,248782],[-746,72],[1,665]],[[228674,247824],[-526,-1799],[-157,-2555]],[[227991,243470],[-863,2198],[-567,666]],[[226561,246334],[-231,2396]],[[255287,234666],[-1,83]],[[255286,234749],[1,-83]],[[255015,252631],[47,-4598]],[[255062,248033],[-100,-2449],[293,-2293],[342,-1258],[-72,-3553]],[[255525,238480],[118,-709],[-472,-3244],[-776,-834],[-363,138],[618,1003],[-446,2270],[13,2456],[-99,3217],[-227,556]],[[253891,243333],[-3,423]],[[253888,243756],[51,358]],[[253939,244114],[171,4893],[-90,2102]],[[262223,249489],[73,-1396]],[[262296,248093],[-1354,-67]],[[260942,248026],[7,3775],[-627,-87]],[[257599,247978],[-271,46]],[[257328,248024],[-1052,38]],[[256276,248062],[-1214,-29]],[[263577,249552],[-524,-184]],[[263053,249368],[-534,64]],[[260942,248026],[-27,-3]],[[260915,248023],[-1496,-67]],[[259419,247956],[-424,13]],[[238458,245638],[-203,-3553],[-301,-2557],[116,-1802],[-122,-774]],[[237948,236952],[-67,-1096],[157,-1846]],[[238038,234010],[-535,-29]],[[237503,233981],[99,13117],[-126,3925]],[[269494,240294],[-114,46]],[[269380,240340],[-346,136]],[[269034,240476],[-18,2136],[-493,493],[-222,1907],[-346,637]],[[267955,245649],[2,5856]],[[267955,245649],[-134,-371]],[[267821,245278],[-66,1821],[-380,53],[-51,1403]],[[253891,243333],[-3,423]],[[253939,244114],[-283,-5327],[-10,-2293],[-805,175]],[[252841,236669],[-46,6489]],[[252795,243158],[-36,4891]],[[272307,246842],[-203,-3711],[-81,2743],[284,968]],[[271903,249573],[306,-2479],[-160,-4072],[-292,-203]],[[271757,242819],[-831,2065]],[[270926,244884],[0,3896],[-86,201]],[[237503,233981],[-603,-19]],[[236900,233962],[97,1937],[-94,1644],[125,1714]],[[237028,239257],[58,2123],[-200,796],[-363,6258],[-570,269]],[[235663,249180],[-268,-876],[313,-9030]],[[235708,239274],[21,-669],[-542,-18]],[[235187,238587],[-329,77]],[[234858,238664],[56,883],[-384,657],[-240,1922],[-168,-357],[-46,2247],[-192,798]],[[229924,243067],[-953,-3232]],[[228971,239835],[-534,-1857]],[[228437,237978],[-325,5186],[-121,306]],[[209922,237143],[-279,-6],[-3006,4042]],[[210927,241861],[-1005,-4718]],[[232720,246785],[-683,-1234]],[[232037,245551],[-850,-766]],[[231187,244785],[-203,2806]],[[221947,246975],[2,-4279]],[[221949,242696],[-1761,-8]],[[220188,242688],[2,7030]],[[220188,242688],[-2353,-80]],[[217835,242608],[-4,7008]],[[217835,242608],[0,-7787]],[[217835,234821],[-2223,5]],[[215612,234826],[279,1284],[-229,1216],[263,2566],[-18,1121],[-323,614]],[[264040,249549],[-12,-7240]],[[264028,242309],[-1345,402]],[[262683,242711],[300,3247],[70,3410]],[[264764,249531],[114,-3092],[-22,-4394]],[[264856,242045],[-554,176]],[[264302,242221],[-274,88]],[[267013,241274],[-88,36]],[[266925,241310],[88,-36]],[[266550,248675],[98,-2368],[249,-1172],[-274,-444],[-99,-1221],[356,-2142]],[[266880,241328],[-709,260]],[[266171,241588],[-368,135]],[[265803,241723],[21,7059]],[[265803,241723],[-735,253]],[[265068,241976],[-212,69]],[[262683,242711],[-3,0]],[[262680,242711],[-384,5382]],[[270926,244884],[-366,-1369],[-37,-1852],[123,-1709],[-124,-3745]],[[270522,236209],[-335,-64],[-107,1022],[-17,2880]],[[237028,239257],[-1320,17]],[[233530,245465],[-89,-6609]],[[233441,238856],[-666,83],[-646,2258]],[[232129,241197],[-92,4354]],[[244740,241602],[-76,124]],[[244664,241726],[-138,1864],[-596,-161],[213,1884],[-298,-207],[-105,2422]],[[245095,248063],[-355,-6461]],[[243752,247975],[-256,456]],[[226561,246334],[-375,-2253],[-241,-2998]],[[225945,241083],[-211,-3685]],[[225734,237398],[-625,1109]],[[225109,238507],[-245,3502],[174,1353],[-6,1659],[-190,1597]],[[267821,245278],[-326,-1351],[-1,-2847]],[[267494,241080],[-481,194]],[[266925,241310],[-45,18]],[[244664,241726],[-233,-2740],[-196,-267]],[[244235,238719],[-602,5]],[[243633,238724],[-154,6]],[[243479,238730],[63,3797],[-227,2726]],[[250209,246403],[-2,-4881]],[[250207,241522],[-565,12],[0,-2448],[-406,-1072]],[[249236,238014],[-349,2359],[-75,1498]],[[248812,241871],[318,6252]],[[248812,241871],[-426,-21],[-726,869]],[[247660,242719],[-255,5369]],[[242208,245262],[112,-1502],[-109,-3720],[-661,-627],[-124,-1004]],[[241426,238409],[-387,12]],[[241039,238421],[5,125]],[[241044,238546],[92,1719],[-1,5881]],[[262680,242711],[-189,-1959]],[[262491,240752],[-656,31],[-11,-813],[-591,47]],[[261233,240017],[-142,13]],[[261091,240030],[7,4056],[-466,837]],[[260632,244923],[283,3100]],[[247660,242719],[35,-9077]],[[247695,233642],[-97,120]],[[247598,233762],[-55,1170],[-290,-154]],[[247253,234778],[-284,1435],[-176,2313],[-1,3039]],[[246792,241565],[0,6510]],[[255286,234749],[1,-83]],[[256955,236440],[0,-65]],[[256955,236375],[0,65]],[[256232,239600],[16,-2077],[-262,-1642],[-543,-650],[107,1726],[233,526],[-258,997]],[[256276,248062],[-334,-1385],[-81,-3537],[371,-3540]],[[257287,236666],[-332,-291]],[[256955,236440],[333,330]],[[257288,236770],[-1,-104]],[[257328,248024],[-38,-10998]],[[257290,237026],[-1052,-1037],[665,1910],[-226,962],[-136,-1053],[-250,2450],[-59,-658]],[[252795,243158],[-1315,0]],[[251480,243158],[-1,3261]],[[246792,241565],[-957,-12]],[[245835,241553],[167,1301]],[[246002,242854],[-21,4096],[90,1118]],[[257288,236770],[-1,-104]],[[258411,236876],[-1,-356]],[[258410,236520],[1,356]],[[258434,247972],[-17,-10056]],[[258417,237916],[-166,1066],[-410,-2043],[-551,87]],[[246002,242854],[-1125,-260],[-120,-1038]],[[244757,241556],[-17,46]],[[260632,244923],[-55,-1607],[-562,869],[-66,-1633]],[[259949,242552],[-537,37],[7,5367]],[[259949,242552],[-196,-1239],[99,-2458],[-315,-2141]],[[259537,236714],[-9,-2239]],[[259528,234475],[-1118,2045]],[[258411,236876],[815,-134],[-426,1780],[-383,-606]],[[231187,244785],[-45,-4378],[221,-3089],[-139,-1696]],[[231224,235622],[12,736],[-414,181]],[[230822,236539],[-165,3013],[-358,1437],[-319,392],[94,1027]],[[223396,246616],[1,-7872]],[[223397,238744],[-946,25]],[[222451,238769],[-503,-4],[1,3931]],[[225109,238507],[-674,263]],[[224435,238770],[-1038,-26]],[[251480,243158],[0,-1086]],[[251480,242072],[-990,-2],[-283,-548]],[[228437,237978],[-499,-1008]],[[227938,236970],[-97,304]],[[227841,237274],[-634,1522],[-437,-1264],[-263,727],[-303,2900],[-259,-76]],[[234858,238664],[-878,-2778]],[[233980,235886],[-396,1125],[-143,1845]],[[241044,238546],[-396,8],[-9,-943],[-990,-261]],[[239649,237350],[2,3244],[421,9],[2,5209]],[[239649,237350],[0,-383]],[[239649,236967],[-708,-8],[1,1629],[-283,7],[1,-1638],[-712,-5]],[[269034,240476],[-293,114]],[[268741,240590],[-1247,490]],[[232129,241197],[72,-7162]],[[232201,234035],[-806,-383]],[[231395,233652],[-171,1970]],[[243479,238730],[216,-1918],[-535,412],[-328,-898]],[[242832,236326],[-172,208],[-256,-1508]],[[242404,235026],[-95,2568],[-194,809],[-689,6]],[[261091,240030],[-143,0],[-5,-2437],[-1018,73],[-388,-952]],[[271757,242819],[498,-308],[-34,-3431],[-155,926],[-295,-107]],[[271771,239899],[-322,203],[-925,-5549]],[[270524,234553],[-2,1656]],[[252841,236669],[-233,-1277],[-178,1270],[-575,-702],[-371,1452]],[[251484,237412],[-4,4660]],[[230822,236539],[-952,-1550]],[[229870,234989],[-278,410],[-621,4436]],[[245835,241553],[-210,-1460],[-15,-2061],[278,-2141]],[[245888,235891],[-360,-439]],[[245528,235452],[-338,30]],[[245190,235482],[-277,639],[124,2784],[-183,-36],[-97,2687]],[[249236,238014],[203,-4319],[261,-907]],[[249700,232788],[-283,-440]],[[249417,232348],[-471,-67],[-254,868],[-304,-894],[-309,779]],[[248079,233034],[-384,608]],[[264302,242221],[-267,-2074],[-54,-1701],[-693,-1753]],[[263288,236693],[-375,1330],[-2,1097],[-281,268],[-139,1364]],[[222451,238769],[6,-3969]],[[222457,234800],[-1261,75]],[[221196,234875],[-1009,-7]],[[220187,234868],[1,7820]],[[220187,234868],[-1627,-38]],[[218560,234830],[-725,-9]],[[265068,241976],[85,-2795],[-178,-1],[-97,-4623]],[[264878,234557],[-479,557],[-1297,-62]],[[263102,235052],[186,1641]],[[251484,237412],[-1134,-2305],[-141,1298]],[[250209,236405],[-2,5117]],[[266171,241588],[21,-1291],[-370,-1383],[42,-1369],[-274,-2432]],[[265590,235113],[-266,-1103],[-213,-2775]],[[265111,231235],[-234,65]],[[264877,231300],[1,3257]],[[209945,215738],[-23,21405]],[[213360,230444],[686,-3232]],[[214046,227212],[-190,-2193],[-356,427],[-421,-724],[-394,-4187],[-190,-3082],[-26,-2697],[-288,-495],[-452,-3923],[-784,1354],[-338,2103],[-458,443],[-204,1500]],[[245190,235482],[-472,-15],[-483,3252]],[[215612,234826],[-8,-9436]],[[215604,225390],[-988,210],[-570,1612]],[[247253,234778],[-437,-1708],[-207,515]],[[246609,233585],[-184,-840],[-537,3146]],[[267013,241274],[105,-135],[78,-2865],[203,-1638]],[[267399,236636],[-213,-2319]],[[267186,234317],[-334,-5]],[[266852,234312],[-283,815],[-979,-14]],[[250209,236405],[34,-1301],[-543,-2316]],[[268741,240590],[-104,-715],[226,-2818],[-101,-1193],[-315,-129]],[[268447,235735],[-586,1763],[-462,-862]],[[209945,215738],[-500,620],[-308,933],[-500,3116],[-209,112],[-481,2313],[-467,5014],[-27,4955],[-481,3934],[-34,2231],[-301,2213]],[[233980,235886],[192,-3310]],[[234172,232576],[-466,-2513],[-754,2533],[-380,-1252],[-368,-202]],[[232204,231142],[-3,2893]],[[227841,237274],[-343,-3901],[-438,-2646]],[[227060,230727],[-169,-807]],[[226891,229920],[-1289,6177]],[[225602,236097],[132,1301]],[[262491,240752],[-511,-7566]],[[261980,233186],[-763,18]],[[261217,233204],[16,6813]],[[263102,235052],[119,-3212],[349,-2174]],[[263570,229666],[-1288,56],[-50,-791]],[[262232,228931],[-307,1350],[55,2905]],[[269380,240340],[4,-8336]],[[269384,232004],[-309,-3002],[110,-639]],[[269185,228363],[-359,-2063]],[[268826,226300],[-394,1903]],[[268432,228203],[15,7532]],[[272248,234159],[-9,-2722],[-434,369]],[[271805,231806],[-186,99],[91,1895],[-113,886],[151,2028],[471,-633],[29,-1922]],[[272388,234172],[-135,-12]],[[272253,234160],[-2,2672],[137,-2660]],[[271771,239899],[387,-696],[23,-1979],[-488,-402],[1,-1429],[-265,-959],[92,-1411]],[[271521,233023],[-998,-79]],[[270523,232944],[1,1609]],[[270523,232944],[0,-816]],[[270523,232128],[-259,0]],[[270264,232128],[-880,-124]],[[261213,230026],[7,-1939]],[[261220,228087],[-832,3622],[181,87],[319,-1693],[325,-77]],[[261217,233204],[-4,-3056]],[[261213,230148],[-256,-46],[-113,1656],[-199,-122],[-386,1289],[-6,-1143],[-725,2693]],[[229870,234989],[-428,-2537]],[[229442,232452],[-640,-2031]],[[228802,230421],[-160,3871],[-704,2678]],[[236900,233962],[5,-1513]],[[236905,232449],[-444,185],[-185,-1246],[-288,179]],[[235988,231567],[-421,-17],[-380,7037]],[[224435,238770],[11,-6720]],[[224446,232050],[-926,-12]],[[223520,232038],[-1061,-74],[-2,2836]],[[225602,236097],[-347,-5926]],[[225255,230171],[-325,-1870]],[[224930,228301],[-484,3749]],[[245308,223867],[-799,1569],[36,945],[-274,2263]],[[244271,228644],[604,288]],[[244875,228932],[202,-2332],[251,-831],[-20,-1902]],[[244559,230559],[-645,-478],[-352,1661],[-258,-1459],[-367,543]],[[242937,230826],[126,1509],[-231,3991]],[[243633,238724],[170,-1018],[53,-2472],[406,-1498],[39,-2365],[258,-812]],[[245528,235452],[-237,-4825]],[[245291,230627],[-330,-692]],[[244961,229935],[-402,624]],[[235988,231567],[8,-4160]],[[235996,227407],[-1499,-99]],[[234497,227308],[-325,5268]],[[239649,236967],[279,-441],[96,-4141],[287,-11],[13,-1373],[-300,-819]],[[240024,230182],[-368,260],[-1652,-19]],[[238004,230423],[34,3587]],[[241039,238421],[19,-7239]],[[241058,231182],[-312,-1023]],[[240746,230159],[-722,23]],[[242404,235026],[-397,-2818]],[[242007,232208],[-408,-1799],[-382,1123],[-159,-350]],[[268432,228203],[-222,-845]],[[268210,227358],[-526,3596],[-439,645],[-59,2718]],[[228802,230421],[-812,-4931]],[[227990,225490],[-930,5237]],[[231395,233652],[-274,-1644],[130,-1237]],[[231251,230771],[-412,482],[-916,-965]],[[229923,230288],[-71,1867],[-410,297]],[[242937,230826],[-38,-675]],[[242899,230151],[-457,1472],[-435,585]],[[226432,226825],[-346,-1970]],[[226086,224855],[-87,1789],[-744,3527]],[[226891,229920],[-512,-2621],[53,-474]],[[246609,233585],[-25,-1023]],[[246584,232562],[-762,-995],[-135,-866]],[[245687,230701],[-396,-74]],[[266852,234312],[-10,-6935],[145,-1216]],[[266987,226161],[-200,-2815]],[[266787,223346],[-399,936],[-283,2980],[-405,1944],[-589,2029]],[[264877,231300],[-794,-652],[8,-1736],[-255,55]],[[263836,228967],[-266,699]],[[247598,233762],[-477,-3687],[-248,-295],[-10,-2337]],[[246863,227443],[-319,-37]],[[246544,227406],[-91,2727],[131,2429]],[[218560,234830],[1,-12368]],[[218561,222462],[3,-3801],[-131,-3065],[-135,-246]],[[218298,215350],[-586,2295],[-155,1738],[-559,1472],[-109,1937],[-428,2706],[-230,-539],[-627,431]],[[221196,234875],[-9,-4031]],[[221187,230844],[-585,153],[-126,-5326],[-4,-3217]],[[220472,222454],[-273,-4]],[[220199,222450],[-1638,12]],[[223520,232038],[7,-6644]],[[223527,225394],[-721,2115],[-1182,235]],[[221624,227744],[-252,18],[4,3078],[-189,4]],[[268210,227358],[-114,-1168]],[[268096,226190],[-1109,-29]],[[272842,223332],[13,0]],[[272855,223332],[-13,0]],[[272837,223331],[-14,0]],[[272823,223331],[-64,-213]],[[272759,223118],[-215,-625],[-556,-55]],[[271988,222438],[-4,2546]],[[271984,224984],[-177,2427],[99,1442],[-322,1680],[221,1273]],[[272248,234159],[350,-6434],[-19,-1080],[258,-3314]],[[272388,234172],[216,-5656],[-351,5644]],[[238004,230423],[-370,-3472]],[[237634,226951],[-15,2086],[-480,948],[-234,2464]],[[232204,231142],[-439,1364],[375,-6984]],[[232140,225522],[-575,-1123]],[[231565,224399],[-195,1521],[-119,4851]],[[247737,223730],[-329,24],[-91,1327],[-454,2362]],[[247598,233762],[-7,-4806],[112,-2059],[203,-840],[-169,-2327]],[[248125,213951],[70,748]],[[248195,214699],[-70,-748]],[[248079,233034],[-93,-5082],[223,493],[141,-926]],[[248350,227519],[-169,-1242],[4,-1676],[243,-2463],[7,-2735]],[[248435,219403],[-412,1680],[32,1883],[-166,601]],[[247889,223567],[-152,163]],[[262232,228931],[-64,-3572]],[[262168,225359],[-1,-32]],[[262167,225327],[-471,-1559]],[[261696,223768],[-261,-97],[30,2044],[-245,2372]],[[261213,230026],[0,122]],[[249417,232348],[-288,-1735],[-365,-1099]],[[248764,229514],[-363,-244],[-62,-812],[282,-1441]],[[248621,227017],[-271,502]],[[271521,233023],[-209,-1367],[211,19],[-61,-1459],[280,-1434],[17,-2305]],[[271759,226477],[-575,-58],[-356,-1657],[-304,-536]],[[270524,224226],[-1,7902]],[[237634,226951],[-209,-1156],[251,-2060]],[[237676,223735],[-488,-232],[-947,-2205]],[[236241,221298],[-10,6070],[-235,39]],[[234522,223522],[-12,-43]],[[234510,223479],[12,43]],[[234497,227308],[188,-999],[-40,-2779]],[[234645,223530],[-248,563],[-164,2138],[-76,-1074],[334,-1692],[-100,-2415]],[[234391,221050],[-400,-946],[-152,1095]],[[233839,221199],[-128,697],[-451,-247]],[[233260,221649],[-1120,3873]],[[249700,222967],[-38,168]],[[249749,222685],[-49,282]],[[249760,222644],[-11,41]],[[249662,223135],[98,-491]],[[249979,228312],[58,-697]],[[250037,227615],[219,-583],[-251,-835],[182,-672]],[[250187,225525],[-339,382],[73,-1088]],[[249921,224819],[-580,0],[296,-1820]],[[249637,222999],[-31,137]],[[249606,223136],[-17,-11]],[[249589,223125],[-854,2530],[-114,1362]],[[248764,229514],[179,-1315],[188,485],[62,-1578],[278,-40],[74,2258],[374,1265],[60,-2277]],[[246544,227406],[-360,598],[-279,-303]],[[245905,227701],[-207,1351],[-11,1649]],[[229923,230288],[145,-1541]],[[230068,228747],[-848,-6121]],[[229220,222626],[-748,-86]],[[228472,222540],[-488,2914]],[[227984,225454],[6,36]],[[242899,230151],[-21,-3786]],[[242878,226365],[-34,-727],[-509,-1743],[181,-15],[-22,-1563],[-530,-1558],[-885,887]],[[241079,221646],[6,8528],[-339,-15]],[[270524,224226],[-18,-8]],[[270506,224218],[-216,2191],[-389,132],[-406,1491]],[[269495,228032],[311,620],[458,3476]],[[269495,228032],[-310,331]],[[224930,228301],[-647,-3579]],[[224283,224722],[-370,-472]],[[223913,224250],[-386,1144]],[[243094,222650],[507,-1497],[-373,-1379],[-504,1635],[370,1241]],[[244961,229935],[-86,-1003]],[[244271,228644],[-426,-208],[-645,-3854]],[[243200,224582],[80,1698],[-402,85]],[[231565,224399],[21,-2330],[-178,-21]],[[231408,222048],[-241,599]],[[231167,222647],[-226,618],[-208,2751],[-251,273],[-414,2458]],[[245905,227701],[-338,-3548]],[[245567,224153],[-211,-1645]],[[245356,222508],[-48,1359]],[[221624,227744],[-7,-5221]],[[221617,222523],[-1145,-69]],[[227984,225454],[-780,-2865],[-98,357]],[[227106,222946],[-308,893],[-366,2986]],[[241079,221646],[-915,2301],[-643,1244],[-860,-33],[-722,-624],[-263,-799]],[[226086,224855],[-251,-1276],[-617,-1664]],[[225218,221915],[-189,1265],[72,1338],[-818,204]],[[261985,223666],[47,-1027],[-349,843],[302,184]],[[262167,225327],[153,-1172],[-624,-387]],[[263836,228967],[267,-1311],[-501,150],[-1029,-3275],[-405,828]],[[231167,222647],[-368,-2222],[-114,-1978],[-813,-2987]],[[229872,215460],[-51,299]],[[229821,215759],[273,1332],[-648,4505],[-226,1030]],[[245356,222508],[-369,-725]],[[244987,221783],[-279,-1858],[-257,1227],[-396,-628],[-7,2090],[-205,-84],[-21,2141],[-622,-89]],[[270506,224218],[-1,-4598]],[[270505,219620],[-384,-936],[-50,1175],[-543,18]],[[269528,219877],[-418,-93],[-2,1071],[-275,504]],[[268833,221359],[-7,4941]],[[268833,221359],[-783,495]],[[268050,221854],[-36,3076],[82,1260]],[[247232,214624],[0,134]],[[247232,214758],[0,-134]],[[248242,218852],[-13,-1967]],[[248229,216885],[-87,-464]],[[248142,216421],[53,-1722]],[[248125,213951],[-368,-1498],[-122,993]],[[247635,213446],[-258,3162],[-145,-1654]],[[247232,214954],[0,261]],[[247232,215215],[0,103]],[[247232,215318],[15,317]],[[247247,215635],[13,86]],[[247260,215721],[55,1625],[-668,4635],[-413,1833],[-106,1452],[-208,-1075],[-353,-38]],[[247889,223567],[32,-2068],[-180,-981],[501,-1666]],[[222150,222529],[-533,-6]],[[223913,224250],[-73,-520]],[[223840,223730],[-339,-2416],[-158,1139],[-1193,76]],[[249173,217874],[111,-1305],[-399,135],[288,1170]],[[249760,222644],[-11,41]],[[249749,222685],[-49,282]],[[249637,222999],[-31,137]],[[249372,222960],[-16,-479]],[[249356,222481],[-255,-314],[203,-1847],[362,-1191],[-111,-778],[530,-230],[375,-1687],[141,832],[308,-3040],[-51,-1666],[-254,-1183],[-172,580],[-446,-2430],[421,3793],[-138,1557],[-368,-602],[-133,2619],[-305,1183],[-511,-71],[-60,606]],[[248892,218612],[-160,571]],[[248732,219183],[-297,220]],[[249589,223125],[-217,-165]],[[234522,223522],[-12,-43]],[[236241,221298],[-46,-111]],[[236195,221187],[-276,34]],[[235919,221221],[-211,269],[-540,-841],[124,4279],[-301,699],[-199,-2304],[-147,207]],[[227106,222946],[-578,-5085]],[[226528,217861],[-680,52],[-139,1116]],[[225709,219029],[23,814],[-514,2072]],[[271988,222438],[9,-2348],[241,-1825]],[[272238,218265],[-390,-928]],[[271848,217337],[-291,1592],[-5,2835],[246,455],[-91,1669],[277,1096]],[[271759,226477],[138,-1241],[-266,-1803],[-119,-4400],[73,-1266]],[[271585,217767],[-204,-13],[-96,2167],[-186,605],[-594,-906]],[[233260,221649],[-107,-2625],[-243,-15],[-79,-1781],[-212,-962],[-275,622],[-264,-1152]],[[232080,215736],[-403,3185],[-269,3127]],[[228472,222540],[-171,-902],[-100,-3633]],[[228201,218005],[-1039,-5115]],[[227162,212890],[-322,2085]],[[226840,214975],[-363,2441],[51,445]],[[247232,214624],[0,134]],[[247232,214954],[0,261]],[[247232,215318],[15,317]],[[244928,217715],[211,-933],[-106,-1819],[-306,1568],[201,1184]],[[246757,215344],[-84,-582]],[[246673,214762],[-79,239]],[[246594,215001],[-200,-1714]],[[246394,213287],[-354,101]],[[246040,213388],[-298,518],[376,1325],[-332,809],[-84,1095],[-260,-2776],[-234,825],[15,1953],[-358,1999],[122,2647]],[[247260,215721],[-525,940],[22,-1317]],[[225709,219029],[-760,-6052]],[[224949,212977],[-1107,2536]],[[223842,215513],[-2,8217]],[[223842,215513],[-1,-2983]],[[223841,212530],[-1697,17]],[[222144,212547],[6,9982]],[[272759,223118],[386,-4323]],[[273145,218795],[-132,-298],[16,-2699],[-744,-89],[-47,2556]],[[272837,223331],[-14,0]],[[272855,223332],[309,-4535]],[[273164,218797],[-14,-2]],[[273150,218795],[-308,4537]],[[232080,215736],[-73,-613]],[[232007,215123],[-254,-1542],[-959,-3418]],[[230794,210163],[-922,5297]],[[229821,215759],[-780,-3735]],[[229041,212024],[-105,760]],[[228936,212784],[-735,5221]],[[222144,212547],[-1943,-93]],[[220201,212454],[-2,9996]],[[220201,212454],[-1549,-37]],[[218652,212417],[-301,1679],[-53,1254]],[[235183,217123],[-168,-987],[-897,-3581],[738,3847],[327,721]],[[234707,216436],[-103,255],[-320,-2118]],[[234284,214573],[-491,4941],[46,1685]],[[234391,221050],[302,-994],[-118,-528],[193,-1648],[-61,-1444]],[[236195,221187],[-1084,-2978],[545,2519],[263,493]],[[234284,214573],[-259,-341],[-244,-3555],[-457,-2355],[-295,-718]],[[233029,207604],[-168,76],[-313,2527],[-238,32],[-6,1604],[-193,733],[-104,2547]],[[269528,219877],[10,-5016],[-370,-17],[1,-3162]],[[269169,211682],[-610,-874]],[[268559,210808],[-4,-27]],[[268555,210781],[11,1181],[-229,1768],[-631,424],[-130,2752]],[[267576,216906],[349,3016],[125,1932]],[[271585,217767],[74,-1764]],[[271659,216003],[-47,-5893],[-823,-7]],[[270789,210103],[-996,7]],[[269793,210110],[-470,1716],[-154,-144]],[[226840,214975],[-1288,-6319]],[[225552,208656],[-603,4321]],[[274192,206960],[-19,0]],[[274173,206960],[19,0]],[[274038,206958],[-133,1]],[[273905,206959],[-39,-1]],[[273866,206958],[-329,-17],[-54,-3299]],[[273483,203642],[-228,3745],[-313,-578],[-517,1780]],[[272425,208589],[33,1991],[-410,2090],[-148,1729]],[[271900,214399],[73,2025],[-125,913]],[[273145,218795],[71,-1438],[822,-10399]],[[273164,218797],[-14,-2]],[[228017,208315],[-310,1140],[-438,-2084]],[[227269,207371],[-501,3616],[394,1903]],[[228936,212784],[-919,-4469]],[[272425,208589],[-133,-1746]],[[272292,206843],[-680,-113],[4,-8038]],[[271616,198692],[-837,-36]],[[270779,198656],[10,11447]],[[271659,216003],[241,-1604]],[[230794,210163],[-40,-5356]],[[230754,204807],[-187,-17]],[[230567,204790],[-105,612]],[[230462,205402],[-405,-38]],[[230057,205364],[-229,273]],[[229828,205637],[-8,-8]],[[229820,205629],[-3,31]],[[229817,205660],[-203,3106],[-295,2552],[-278,706]],[[225150,203636],[-1,663],[-1297,-17]],[[223852,204282],[-11,8248]],[[225552,208656],[258,-1776]],[[225810,206880],[-660,-3244]],[[231528,203108],[198,1338],[-526,-948],[-443,705]],[[230757,204203],[-3,604]],[[233029,207604],[-514,-1808],[-270,336],[-408,-941],[-74,-1321],[716,1769],[-1754,-5264],[803,2733]],[[226700,204666],[-381,956],[-250,-542]],[[226069,205080],[-259,1800]],[[227269,207371],[-569,-2705]],[[229828,205637],[-8,-8]],[[229817,205660],[1,-375]],[[229818,205285],[-753,-2127],[109,-1486]],[[229174,201672],[-68,-398],[-684,1260]],[[228422,202534],[5,4145],[-122,1447],[-288,189]],[[223852,204282],[-1657,-123]],[[222195,204159],[-37,-4]],[[222158,204155],[-14,8392]],[[222158,204155],[-1965,141]],[[220193,204296],[8,8158]],[[220193,204296],[2,-8383]],[[220195,195913],[-275,-20]],[[219920,195893],[-228,1634],[-299,5632],[-269,1346],[-138,3111],[-290,2181],[-44,2620]],[[268559,210808],[-4,-27]],[[269793,210110],[391,-3170],[-256,-2281]],[[269928,204659],[-433,507],[-598,-8]],[[268897,205158],[-149,697],[-6,3294],[-183,1659]],[[270779,198656],[-274,-620]],[[270505,198036],[2,3100]],[[270507,201136],[2,765],[-428,978],[-153,1780]],[[228422,202534],[-599,-3072]],[[227823,199462],[-496,1216],[-66,1281],[-333,364],[-228,2343]],[[273483,203642],[-949,-51],[-367,555],[125,2697]],[[273866,206958],[152,-4434],[384,-6703],[460,-6126],[-21,-546]],[[274841,189149],[-1029,-223]],[[273812,188926],[17,9773]],[[273829,198699],[-61,3007],[-285,1936]],[[274038,206958],[411,-2425],[-276,2427]],[[274192,206960],[437,-3794],[144,-2446],[-167,-836],[-12,3069],[-288,-3646],[-72,101],[-11,3804],[-174,605],[153,1506],[-297,1636]],[[226409,193289],[-981,20]],[[225428,193309],[-276,-3]],[[225152,193306],[-2,10330]],[[226069,205080],[-235,-508],[782,-8928],[-25,-123]],[[226591,195521],[-240,-1164],[58,-1068]],[[273829,198699],[-2213,-7]],[[229435,196419],[-34,-86]],[[229401,196333],[30,1032]],[[229431,197365],[4,-946]],[[229989,197536],[539,1175],[-1215,-4810]],[[229313,193901],[29,366]],[[229342,194267],[112,1478],[226,125],[309,1666]],[[230757,204203],[-190,587]],[[229467,200563],[-293,1109]],[[229818,205285],[138,-1955],[593,-2863],[-702,-2229],[-380,2325]],[[230125,204170],[-68,1194]],[[230462,205402],[-19,-1857],[-318,625]],[[227823,199462],[-461,-4167]],[[227362,195295],[-76,-648],[-695,874]],[[270507,201136],[-552,2],[0,-813],[-1166,-24]],[[268789,200301],[108,4857]],[[223852,204282],[-6,-10982]],[[223846,193300],[-1632,-504],[-15,3243]],[[222199,196039],[-4,8120]],[[225152,193306],[-1306,-6]],[[222199,196039],[-2004,-126]],[[229467,200563],[-206,-609],[192,-1783]],[[229453,198171],[-927,-863],[295,-1303]],[[228821,196005],[-626,-2605]],[[228195,193400],[-52,240]],[[228143,193640],[-159,1151],[-622,504]],[[268308,195427],[-9,-1]],[[268299,195426],[9,1]],[[270505,198036],[-139,-2611]],[[270366,195425],[-1519,30]],[[268847,195455],[-374,-12]],[[268473,195443],[316,4858]],[[271616,198692],[0,-1636],[277,2],[94,-2170],[192,-1069],[303,-12],[-262,-959],[585,-3549],[246,-3711]],[[273051,185588],[-1173,63]],[[271878,185651],[-1368,-4]],[[270510,185647],[-6,9777],[-138,1]],[[273812,188926],[-11,-3355]],[[273801,185571],[-750,17]],[[228693,189439],[13,358]],[[228706,189797],[-13,-358]],[[229222,193536],[-326,-2723],[39,1456],[287,1267]],[[228195,193400],[229,-263],[-76,-1380]],[[228348,191757],[-205,1883]],[[228490,190446],[-134,1236]],[[228356,191682],[444,2664],[-7,-1493],[-303,-2407]],[[229313,193901],[29,366]],[[229311,195731],[-328,-1201],[-162,1475]],[[229453,198171],[-22,-806]],[[229401,196333],[-90,-602]],[[223846,193300],[13,-13096]],[[223859,180204],[1,-1601],[-436,25]],[[223424,178628],[-1056,72],[-103,855],[-232,-1006]],[[222033,178549],[-140,1379],[71,2611],[-322,2960],[-327,370],[-463,2627],[-155,3393],[-154,197],[-278,2896],[-345,911]],[[228348,191757],[8,-75]],[[228490,190446],[-3,-28]],[[228487,190418],[-15,-156]],[[228472,190262],[-134,-1330],[-231,1091],[-604,-773]],[[227503,189250],[-412,475],[-458,1287],[12,1137]],[[226645,192149],[-236,1140]],[[268308,195427],[-9,-1]],[[268847,195455],[7,-2885]],[[268854,192570],[-198,-1538],[342,-1334],[-115,-2958],[-287,863],[-300,2065],[148,2365],[29,3410]],[[270510,185647],[-1388,-18]],[[269122,185629],[467,3253],[-294,1838],[49,-1786],[-175,308],[19,1798],[-334,1530]],[[225428,193309],[8,-14809]],[[225436,178500],[-811,49]],[[224625,178549],[3,1455],[-769,200]],[[226645,192149],[-378,-2056],[-22,-4641]],[[226245,185452],[-328,-1],[5,-6979]],[[225922,178472],[-486,28]],[[228250,184343],[-70,94]],[[228180,184437],[70,-94]],[[228402,187096],[249,1941],[-343,-3973],[94,2032]],[[228693,189439],[13,358]],[[228487,190418],[-15,-156]],[[227948,186969],[214,-388],[-199,-2526]],[[227963,184055],[-1437,-47],[-281,1444]],[[227503,189250],[288,8],[157,-2289]],[[275241,183987],[-902,23]],[[274339,184010],[-271,5],[-3,1572],[-264,-16]],[[274841,189149],[341,-3281],[59,-1881]],[[275339,183990],[-31,-2]],[[275308,183988],[31,2]],[[273051,185588],[-176,-2846],[396,-2050],[334,-3158]],[[273605,177534],[-628,-17],[1,-1638],[-277,-12],[2,-1650],[-824,23]],[[271879,174240],[-2,5716]],[[271877,179956],[1,5695]],[[271877,179956],[-1371,-46]],[[270506,179910],[4,5737]],[[268884,180868],[-11,1]],[[268873,180869],[11,-1]],[[270506,179910],[-2,-2429]],[[270504,177481],[-549,21],[3,3302],[-874,53]],[[269084,180857],[-345,1646],[240,735],[143,2391]],[[274339,184010],[6,-6562]],[[274345,177448],[1,-1562],[-580,-3038]],[[273766,172848],[42,3614],[-203,1072]],[[227901,178788],[-37,1]],[[227864,178789],[9,1767],[307,3881]],[[228250,184343],[-349,-5555]],[[227963,184055],[-251,-4476],[-258,-852],[114,2439],[-407,-1627],[-336,1829],[200,-2388],[-320,-89]],[[226705,178891],[-582,-1386]],[[226123,177505],[-201,967]],[[275676,178510],[-28,1]],[[275648,178511],[28,-1]],[[275339,183990],[-31,-2]],[[275241,183987],[343,-5477]],[[275584,178510],[-145,-585]],[[275439,177925],[-1,-410]],[[275438,177515],[-1093,-67]],[[269628,172609],[-7,-1]],[[269621,172608],[7,1]],[[270504,177481],[-3,-3270]],[[270501,174211],[-551,16],[0,-506]],[[269950,173721],[0,-130]],[[269950,173591],[-1,-995],[-273,11]],[[269676,172607],[-254,2093],[-338,6157]],[[268884,180868],[-11,1]],[[224625,178549],[159,-3917],[135,10],[-13,-5059]],[[224906,169583],[-1481,40]],[[223425,169623],[-1,9005]],[[271879,174240],[-1378,-29]],[[223425,169623],[-158,-2060],[-441,-1923]],[[222826,165640],[-276,5054],[-494,3303],[54,2886],[-77,1666]],[[227998,166171],[-12,1]],[[227986,166172],[12,-1]],[[228016,167093],[52,-920]],[[228068,166173],[-55,-2]],[[228013,166171],[-73,1392]],[[227940,167563],[76,-470]],[[228016,167093],[-141,1392]],[[227875,168485],[-65,3026]],[[227810,171511],[31,176]],[[227841,171687],[175,-4594]],[[227841,171687],[-58,4800],[50,1667]],[[227833,178154],[31,635]],[[227901,178788],[-82,-3294],[22,-3807]],[[227619,175770],[-62,-1844],[-237,-795]],[[227320,173131],[22,-2788],[212,-1258],[78,-2921]],[[227632,166164],[-1163,-35],[-267,256]],[[226202,166385],[-78,3149]],[[226124,169534],[-1,7971]],[[226705,178891],[360,-136],[284,-872],[340,626],[-70,-2739]],[[226124,169534],[-934,41]],[[225190,169575],[-284,8]],[[276009,173064],[-4,0]],[[276005,173064],[4,0]],[[275994,173067],[-63,2]],[[275931,173069],[-9,1]],[[275922,173070],[-37,2]],[[275885,173072],[-22,0]],[[275863,173072],[-26,-266],[-2071,42]],[[275438,177515],[375,-1551],[181,-2897]],[[275676,178510],[-28,1]],[[275584,178510],[-145,-585]],[[273766,172848],[-167,-3535],[-1729,10]],[[271870,169323],[9,4917]],[[269903,169694],[11,1]],[[269914,169695],[-11,-1]],[[269628,172609],[-7,-1]],[[269950,173591],[197,-1158],[100,-2595],[-427,921],[-144,1848]],[[271870,169323],[-1374,16]],[[270496,169339],[-105,2644],[304,1032],[-368,4],[-94,-803],[-283,1505]],[[276009,173064],[-4,0]],[[275994,173067],[-63,2]],[[275922,173070],[-37,2]],[[275863,173072],[173,-517],[58,-7156],[-69,-4426]],[[276025,160973],[-424,253],[-1823,-65]],[[273778,161161],[-12,11687]],[[273778,161161],[4,-1335]],[[273782,159826],[-1083,-119],[-9,4915],[-814,-69]],[[271876,164553],[-6,4770]],[[270224,168130],[277,-3878],[-101,-153],[-176,4031]],[[271876,164553],[5,-1689],[-271,-30],[4,-1925],[-522,237]],[[271092,161146],[-65,2473],[-474,1226],[-124,2786],[67,1708]],[[269914,169695],[-11,-1]],[[225190,169575],[-740,-9780]],[[224450,159795],[-249,-323],[-357,2361],[-856,1101],[54,932],[-216,1774]],[[226202,166385],[-130,-3036],[396,-281],[0,-1592]],[[226468,161476],[1,-5174]],[[226469,156302],[-921,-316],[-541,1945],[-163,1244],[-394,620]],[[228232,162657],[-37,0]],[[228195,162657],[37,0]],[[227998,166171],[-12,1]],[[228159,164435],[-24,128]],[[228135,164563],[-188,861]],[[227947,165424],[66,747]],[[228068,166173],[91,-1738]],[[227684,164584],[-2,-1373]],[[227682,163211],[-57,-570]],[[227625,162641],[156,-4]],[[227781,162637],[-161,-1600],[-220,-469],[-932,908]],[[227632,166164],[52,-1580]],[[272238,151333],[13,1]],[[272251,151334],[-13,-1]],[[273782,159826],[19,-5213]],[[273801,154613],[0,-3238]],[[273801,151375],[-1312,-39]],[[272489,151336],[-461,1867],[-228,-193],[-395,1936],[-191,1815],[-122,4385]],[[228287,156177],[-113,-1804],[-350,-1094],[6,-1266],[-410,861],[-516,2813],[-435,615]],[[227781,162637],[266,-4006],[-45,-1341],[285,-1113]],[[228232,162657],[-37,0]],[[276025,160973],[-123,-6439]],[[275902,154534],[-491,-343],[-1072,2],[-538,420]],[[275887,153137],[-181,-2634],[-305,-2456],[-117,-2922],[81,-1855],[-329,-2502]],[[275036,140768],[-16,1]],[[275020,140769],[-149,-433]],[[274871,140336],[3,-77]],[[274874,140259],[-199,601],[-388,-1467],[-445,274]],[[273842,139667],[-42,3489],[1,8219]],[[275902,154534],[-15,-1397]],[[274871,140336],[3,-77]],[[275036,140768],[-16,1]],[[275491,142866],[-401,-4416],[-362,-2015],[523,3742],[240,2689]],[[272251,151334],[-13,-1]],[[273842,139667],[-118,-686],[-512,-438],[-244,1966],[102,2255],[184,-1642],[296,-971],[166,920],[-246,1771],[-349,147],[-259,2833],[-188,3420],[234,599],[-210,869],[-82,-1356],[-127,1982]],[[267576,216906],[-181,85],[-177,1931],[-468,2015],[37,2409]],[[233545,583163],[470,-1],[0,7179],[546,-266],[367,-1412],[396,-7637],[-21,-1976],[288,-1125],[438,-310]],[[245498,568092],[407,1053],[402,-2818],[1697,311],[722,-2325],[297,673],[566,-549],[-1155,-3041],[-1287,-1848],[-816,-1938],[-809,-2999]],[[244050,541402],[0,-11146]],[[242235,539623],[262,1550],[296,-1143],[509,151],[748,1221]],[[245789,538230],[7,-8017]],[[244050,541402],[832,1558],[406,334],[672,1956],[311,-1206],[-365,-2639],[91,-1053],[-208,-2122]],[[245789,538230],[629,1480],[422,-1520]],[[246668,543604],[119,-491],[-601,-1771],[482,2262]],[[254361,554779],[386,-1343],[-682,-275],[51,-770],[-806,-2719]],[[253310,549672],[-198,1604],[-595,-3]],[[252517,551273],[244,1548],[576,1487],[1024,471]],[[252129,567028],[638,1076],[-743,-3451],[-872,-1784],[142,-551],[-582,-1037],[-166,1627],[1583,4120]],[[251344,546531],[128,1308],[718,2354],[11,-1815],[317,-391],[169,-3174]],[[253310,549672],[-511,-4124],[-63,2158],[-506,612],[-29,1852],[316,1103]],[[256406,536544],[1,-6252]],[[256407,530292],[-349,-1],[-4,-3236],[-348,4]],[[253820,544308],[634,-392],[509,-1456],[171,-1720],[674,-4188],[598,-8]],[[257802,530287],[-1395,5]],[[256406,536544],[265,725],[573,-1784],[182,767],[315,-1250],[489,2628],[901,2228],[763,318]],[[258234,522812],[-689,-1999],[491,3712],[-698,206],[-249,-2796],[-468,641],[-361,-1503],[-267,-2116]],[[255011,510600],[-34,-2168],[-371,-346]],[[254679,502703],[345,2967],[570,1286],[473,4865],[330,489],[143,1897],[235,8],[-572,-6085],[-44,-1741],[-319,-1641],[-155,-2072]],[[266291,525882],[-781,768]],[[265510,526650],[490,1336],[-121,1234],[374,-217],[304,-1926],[-266,-1195]],[[264534,537282],[192,-119],[-169,-2149],[-263,1387],[240,881]],[[264771,527003],[-281,50]],[[264490,527053],[-48,-2]],[[264442,527051],[-19,1612],[-346,2],[-1,1612],[-2086,1],[-3,1628],[-347,-5]],[[261640,541399],[788,243],[-207,-1485],[-13,-3740],[568,-816],[557,744],[103,-1308],[702,1641],[226,-1324],[215,-3356],[-110,-1628],[279,286],[140,-1587],[477,-2056],[-594,-10]],[[263518,523913],[579,-847],[-387,-679],[-192,1526]],[[264771,527003],[-281,50]],[[264442,527051],[-1182,1275],[-230,-2015],[-35,-1966],[-708,3125],[-1172,1762],[-254,-167],[-380,-2334],[-589,11]],[[263048,514103],[-754,-309],[-259,1733]],[[262035,515527],[484,1049],[-316,238],[-233,2467],[498,2960],[580,1140]],[[261221,512584],[62,1278],[458,1591],[294,74]],[[260809,522685],[124,-2642],[-358,-487],[234,3129]],[[259619,509895],[-266,698],[189,945],[77,-1643]],[[260516,504530],[-484,-12]],[[259309,504590],[9,2169],[372,1309],[375,-215],[515,4334],[144,-2358],[-222,-3318],[14,-1981]],[[260516,504530],[127,-152],[342,4121],[-150,-4480],[236,2087]],[[266792,512571],[208,-2838],[-312,125],[-6,-2477],[298,-1300]],[[266298,493143],[-35,-2126],[-276,-1071],[-460,39],[-182,-1553]],[[266573,485031],[572,4601],[580,621],[347,1131],[524,-1430],[297,-2969],[77,-2649]],[[269259,474627],[236,-3606],[-157,-1606],[-122,-4884],[-353,82],[-169,1029]],[[268236,461261],[-80,-1234],[-498,-1330],[-248,-2668],[-87,-2522]],[[267323,453507],[-275,1113],[-676,-161]],[[266582,447887],[26,6]],[[266536,447880],[30,6]],[[267323,453507],[-736,-4608],[-57,-1020]],[[276369,283639],[51,-2897],[155,-81],[-317,-2464],[-721,-1619]],[[275274,275950],[-210,1998]],[[278269,287761],[-76,264]],[[276907,282488],[-285,-1501],[-132,340],[309,2769]],[[277898,288714],[355,-1067],[-412,-2026],[-412,-58],[-522,-3075]],[[61945,65039],[-273,273]],[[61672,65312],[273,-273]],[[64909,48285],[736,-2763],[362,-391],[488,-1482],[554,-3197],[-24,-2084],[243,12],[55,-1737],[491,-2285],[-473,-3219],[-429,-1374],[-452,-185],[-605,-2496],[-405,-3858],[-627,2125],[-104,1501],[90,4218],[-292,5440],[-196,1716],[344,2264],[318,3335],[-188,1774],[-22,2014],[136,672]],[[55029,84761],[232,-813],[-50,-4138],[-317,-1725],[-532,857],[-340,1190],[-70,1626],[168,1566],[391,1358],[518,79]],[[53118,80469],[25,-1794],[-232,-683],[-127,-1603],[-75,1953],[409,2127]],[[61945,65039],[564,-356],[-456,-1900],[-525,1011],[-688,11],[160,2281],[672,-774]],[[61752,60573],[247,-292],[244,-1961],[-83,-859],[-351,-533],[-258,3325],[201,320]],[[62905,54516],[44,-1245],[-350,-600],[8,965],[298,880]],[[62814,62496],[341,-2480],[438,902],[263,-353],[321,-1916],[311,-600],[36,-1558],[-161,-1021],[-712,-1317],[-390,412],[-55,3221],[-459,617],[-171,1326],[59,2293],[179,474]],[[58972,75139],[409,-3431],[-19,-1219],[215,22],[315,-3032],[-404,-786],[-271,1419],[-580,-705],[-493,5220],[435,169],[393,2343]],[[996993,632383],[817,-1163],[91,-906],[715,-2639],[-620,1211],[-351,1710],[-879,1732],[227,55]],[[950,635992],[99,-1643],[-281,619],[182,1024]],[[7984,636500],[-23,-2275],[-307,-73],[-67,2101],[397,247]],[[8255,636861],[429,-729],[-176,-971],[-344,386],[91,1314]],[[8792,637399],[78,-1228],[-422,750],[344,478]],[[2944,637533],[354,-28],[110,-1138],[763,-730],[-472,-573],[-85,-1947],[-423,-823],[-299,1293],[443,1084],[-738,1715],[347,1147]],[[5406,633633],[-183,-598],[-329,1038],[-855,-380],[1116,1264],[255,737],[16,1940],[428,-501],[-230,-1193],[22,-1774],[-240,-533]],[[996377,638802],[311,-784],[-244,-853],[-67,1637]],[[7153,639094],[-123,-3160],[551,52],[-111,-1993],[-621,-692],[-248,-1116],[-149,1715],[-276,-2445],[-149,1181],[345,1636],[-141,1180],[574,-355],[-294,2579],[642,1418]],[[999634,639522],[333,-975],[-327,-1865],[-356,430],[-110,1602],[460,808]],[[8394,641129],[361,-843],[-150,-1151],[-356,-113],[145,2107]],[[993962,641501],[134,-1164],[-300,-1591],[4,-1345],[-561,-90],[-112,-1517],[-310,1266],[482,1562],[297,123],[366,2756]],[[15681,641867],[-88,-644],[552,-599],[499,441],[599,-277],[-1373,-851],[-663,468],[-397,-613],[-511,1117],[345,752],[244,-725],[793,931]],[[18717,646240],[354,-1060],[-312,-984],[-542,-452],[87,1790],[413,706]],[[13937,646817],[445,-1871],[-209,-1713],[-378,-563],[294,-1046],[-846,-838],[-954,-1616],[-415,665],[-937,-680],[1038,1800],[664,138],[756,1388],[293,1606],[-346,796],[247,1637],[348,297]],[[983194,648582],[-58,-2897],[-305,734],[-723,157],[686,1802],[400,204]],[[23639,652034],[278,-453],[-114,-1345],[-515,-1145],[-82,1788],[433,1155]],[[26147,655623],[247,-1330],[-168,-813],[-713,1495],[634,648]],[[980647,657671],[765,-147],[436,-2390],[462,-235],[-708,-1136],[-317,775],[-432,-1614],[-470,872],[166,1668],[-517,-336],[77,1140],[-541,-71],[552,1546],[527,-72]],[[28035,654543],[906,4624],[-94,1472],[528,2186],[746,66],[-272,830],[81,1805],[502,2014],[613,648],[608,-970],[-156,-2372],[-1194,-2675],[-517,-3466],[-1751,-4162]],[[36358,673363],[-391,-2467],[-196,1415],[587,1052]],[[34798,676523],[212,-3286],[496,2734],[387,-122],[70,-1818],[-314,-391],[-519,-2697],[580,1301],[182,-1595],[-674,-869],[-156,-1539],[-279,591],[46,-1877],[-401,265],[-1841,-3579],[-466,-1377],[-652,1241],[1054,2460],[1095,1206],[-225,1759],[468,337],[-151,1493],[938,464],[-874,524],[-341,2033],[352,1704],[1013,1038]],[[26198,724966],[755,-263],[-288,-1191],[-467,1454]],[[25148,736553],[-442,-1992],[-390,1137],[832,855]],[[39421,678834],[125,-1114],[-549,-30],[-135,746],[559,398]],[[36826,680387],[730,-1661],[-578,-1781],[-480,150],[-103,2381],[431,911]],[[38083,681762],[-169,-1483],[356,-62],[-384,-1861],[-335,2175],[179,1214],[353,17]],[[45572,685391],[687,-1487],[-645,-37],[-42,1524]],[[46952,694607],[167,-1890],[-230,-1028],[-301,1739],[364,1179]],[[42854,695877],[634,14],[266,-1568],[336,-4089],[372,437],[215,-1478],[-488,52],[-124,932],[-254,-1722],[-453,-779],[-609,441],[-826,-359],[-642,-1585],[-62,-1249],[-802,-1375],[-569,492],[-278,2147],[72,1348],[583,1047],[405,3984],[356,1064],[528,-514],[981,2495],[359,265]],[[48298,698203],[503,-1314],[-281,-971],[-458,2013],[236,272]],[[54720,699114],[34,-1697],[-430,-1611],[396,3308]],[[53769,699716],[-57,-3065],[-690,-2054],[15,3270],[392,-758],[86,2465],[254,142]],[[52387,701641],[20,-2213],[-523,1390],[503,823]],[[51367,702388],[94,-1872],[270,219],[342,-2313],[-186,-1094],[-922,1412],[40,2470],[362,1178]],[[52632,703466],[225,-1137],[-483,351],[258,786]],[[56429,729876],[0,-164]],[[56429,729712],[1,-1271]],[[56430,728441],[-377,-902],[0,-1576],[-688,44],[0,-1691],[-884,0],[-2,-1609],[-853,-47],[-11,-3153],[262,-17],[12,-6313],[-174,-1752],[844,0],[1,-4664]],[[54560,706761],[-221,3583],[-466,487],[-226,-1331],[-227,543],[-128,-1791],[-941,-1953],[-502,-2559],[-203,1961],[-156,-2246],[-321,-160],[-388,1335],[-213,-1550],[-895,-1527],[-527,87],[101,2154],[312,2133],[-634,501],[-315,-1612],[37,-2336],[-533,-3433],[-423,296],[235,-2134],[-319,-953],[-327,1503],[-197,-2494],[-614,575],[-125,3742],[-386,953],[-195,-965],[304,-1471],[136,-4091],[-323,1731],[-86,-1650],[-582,-104],[-228,2389],[-557,961],[-44,-1927],[533,-1473],[-912,-2585],[204,4150],[-78,1484],[292,977],[935,318],[218,2402],[379,1261],[396,-106],[-126,1804],[846,4218],[1241,3632],[1202,1198],[763,131],[637,709],[-430,-1918],[671,-3199],[315,-565],[-272,3532],[663,-283],[157,-1434],[615,-516],[79,1328],[-802,1925],[-146,1183],[588,5125],[1474,4921],[1403,2354],[1201,3895]],[[131840,702693],[477,-1814],[-260,-3591],[-338,3444],[121,1961]],[[133475,712615],[472,-2306],[365,-3908],[-109,-3956],[-237,-2723],[-412,-1256],[-725,1926],[513,3110],[-666,-3077],[-841,2748],[552,2915],[-269,716],[-19,1677],[520,1253],[-148,1905],[1004,976]],[[60957,762087],[579,2152],[206,3039]],[[61742,767278],[1862,118],[1,-5313],[-2648,4]],[[51410,765657],[-524,-4199],[-535,-542],[51,2808],[1008,1933]],[[50362,766039],[-742,-1613]],[[49620,764426],[-84,1634],[826,-21]],[[55886,766355],[508,-1408],[386,-3700]],[[56780,761247],[192,-1494],[-550,-1757],[-437,893],[-941,6038],[-709,1488],[71,1756],[-304,-417],[-190,-2035],[-311,-514],[-283,1932],[-661,238],[-84,2398],[-286,617],[-1293,-3499]],[[50994,766891],[-530,-524]],[[50464,766367],[-1,3048],[447,4],[154,1512],[-5,3289],[475,13],[-1,1619],[475,67],[154,1547],[2,3270],[484,-4],[7,3225],[637,43],[12,3203],[445,89],[14,3067],[183,1579],[477,25],[0,3225],[492,-12],[187,1563],[7,3225],[507,4],[6,1610],[466,16],[198,3194],[2957,4],[8,-1469],[509,-22],[-8,1633],[498,0],[-1,1661],[983,-7],[4,-1637],[3363,-86]],[[64599,804865],[7,-22904],[-456,-40],[-3,-1619],[-951,22],[-1,-1609],[-472,19],[-265,-3261],[-958,50],[-2,-1622],[-474,33],[7,-3299],[225,-22],[8,-3864]],[[61264,766749],[-1094,-1968],[-1643,-2597],[-487,694],[-101,1404],[-594,1396],[199,3649],[-345,-1592],[-443,-553],[-69,-2804],[-801,1977]],[[61034,724293],[684,-546],[-930,-219],[246,765]],[[56429,729876],[0,-164]],[[71634,804882],[114,-1587],[1,-6528],[-371,-12],[-9,-6508],[-349,-18],[4,-6265],[-357,2],[-2,-1646],[-479,-10],[4,-3277],[-474,-9],[9,-1643],[-817,-49],[14,-3240],[-942,-29],[6,-3278],[148,-20],[-1,-6355],[154,-1634],[923,0]],[[69210,762776],[7,-3471],[-452,-1843],[-737,-1056],[-774,-256],[-138,-1018],[-764,-799],[5,-5901],[-324,-916],[-689,-542],[-207,-2415],[-364,-3],[218,-1278],[-365,-813],[-334,533],[-169,-1391],[-664,236],[-689,-3490],[-376,-3218],[1106,-40]],[[63500,735095],[-534,-3229],[-497,991],[-283,-2643],[-165,1250],[-876,-3730],[-514,1840],[-92,-1738],[-418,-1466],[296,-1221],[-476,-272],[-290,1208],[-837,-1435],[-237,-1294],[834,518],[-97,-1512],[-773,886],[47,-1061],[-586,328],[-1007,-4054],[729,1416],[657,-1055],[-889,-5668],[-359,2476],[4,-2388],[-569,564],[-201,-1660],[-1171,-915],[-207,-1647],[-123,1992],[-209,-168],[97,-2311],[-194,-2336]],[[56430,728441],[767,-812],[-200,4018],[209,1634],[848,4197],[641,1528],[417,1983],[585,1663],[449,-1863],[-119,2913],[-249,-206],[-34,2059],[291,6723],[197,1491],[338,172],[-417,2930],[210,2814],[594,2402]],[[61742,767278],[-122,1251],[-356,-1780]],[[64599,804865],[4288,-12],[2747,29]],[[65700,709070],[-505,743],[539,1338],[-34,-2081]],[[70400,724037],[-203,-1087],[-508,-19],[711,1106]],[[68718,724702],[-248,-2013],[-522,-1694],[196,2303],[574,1404]],[[69851,724354],[-436,-1711],[-362,958],[373,1309],[425,-556]],[[72264,735888],[653,-276],[179,-1133],[-749,-602],[-369,-1913],[-212,2137],[498,1787]],[[71588,750055],[467,-1112],[219,-1969],[-712,1537],[26,1544]],[[72121,750653],[752,-1609],[143,801],[402,-896],[-318,-1580],[497,-23],[268,1873],[865,-1804],[-645,-1899],[255,-25],[-10,-2224],[879,340],[-526,-3652],[-487,209],[-629,1356],[-203,-635],[516,-1217],[-217,-2411],[-309,-183],[-529,1368],[-252,-544],[428,-942],[-369,-902],[-532,226],[-639,-2935],[-448,348],[323,-1679],[-994,-4198],[-692,-436],[210,1779],[607,2267],[-321,-122],[144,1970],[-434,-1663],[-185,436],[447,2279],[-692,794],[-670,-678],[120,-1421],[343,1135],[575,213],[-522,-3914],[-671,1507],[-37,3723],[-598,1836],[85,2427],[257,1668],[757,2434],[973,102],[64,-1861],[627,-4463],[-146,2063],[78,2795],[-204,1554],[706,-247],[-927,1791],[7,1470],[588,1559],[420,-1165],[70,-2442],[173,2478],[786,-908],[-90,1984],[526,-1432],[-620,2635],[25,690]],[[72294,752633],[298,-243],[385,-2001],[-772,1279],[-524,168],[436,1600],[177,-803]],[[74768,758553],[203,-1495],[404,602],[-150,-1955],[513,1173],[-64,-2164],[-263,-1096],[-683,1715],[168,-2076],[-474,81],[-333,-1022],[-38,2484],[-167,-2623],[-421,-227],[-1,-1319],[-1063,2147],[-115,1830],[591,-260],[-305,1148],[155,946],[718,-477],[-71,2281],[416,1422],[495,-330],[341,-2521],[144,1736]],[[73815,761335],[866,1186],[-377,-3031],[-416,471],[-73,1374]],[[72145,766667],[-257,-165],[-279,-2562],[-648,-1819],[-613,-91],[-175,-2212],[-343,-44],[106,-2403],[-387,-650],[216,-848],[-603,-2221],[-49,-1387],[-356,1779],[54,-1574],[-325,275],[-478,-1769],[-794,237],[-110,-2260],[-820,-2014],[-130,-1038],[-600,883],[68,-2348],[-395,-579],[8,-1505],[-775,384],[-34,-2432],[-520,654],[-902,-2724],[-22,-1053],[572,813],[-196,-1902],[142,-997]],[[69210,762776],[1368,8],[-4,1620],[1015,10],[-8,2250],[405,-14]],[[71986,766650],[159,17]],[[127092,749125],[-107,-525]],[[126985,748600],[107,525]],[[125289,753706],[-418,-538]],[[124871,753168],[418,538]],[[124853,753145],[-548,-606],[-395,-1297],[-254,1284]],[[123656,752526],[58,1721]],[[123714,754247],[93,682]],[[123807,754929],[27,-1188],[797,113],[222,-709]],[[124293,757146],[750,-2547],[-1015,763],[-163,962],[428,822]],[[124853,768717],[212,-1953],[1164,-2450],[371,-2181],[919,-3383],[-234,-797],[807,-4371]],[[128092,753582],[-944,-4191]],[[127148,749391],[-329,-1604]],[[126819,747787],[-267,-754]],[[126552,747033],[-348,2791],[-601,2743],[-35,3375],[303,711],[-120,1531],[-569,-3645],[-842,2824],[-590,340],[-225,2827],[-376,2538],[-7,5750]],[[123142,768818],[1711,-101]],[[122508,768865],[608,-35]],[[123116,768830],[93,-1237],[-284,-3190],[-328,1968],[-89,2494]],[[125029,711856],[427,56],[-445,-1309],[18,1253]],[[123927,716625],[1,1610]],[[123928,718235],[-1,-1610]],[[130216,719801],[107,-2063],[755,-2315],[-337,-626],[254,-2100],[-618,-805],[-299,1242],[210,718],[-488,1319],[-280,-690],[-164,3076],[325,413],[163,1718],[372,113]],[[129378,721918],[250,-1134],[-116,-2167],[-589,-788],[-541,1882],[182,1807],[814,400]],[[130831,716911],[-489,1839],[73,2204],[-143,1693],[379,-777],[303,-2037],[326,197],[294,-2758],[-436,-1557],[-307,1196]],[[128816,728558],[1033,-4174],[-771,-1663],[-361,265],[62,2359],[-148,3100],[185,113]],[[126153,727422],[-66,1104],[447,-558],[-459,-4949],[-272,-4761],[207,396],[-145,-3602],[-197,615],[-111,3651],[-136,-5807],[-278,1260],[-135,3642],[146,2920],[525,49],[-191,2101],[-591,341],[100,963],[-331,2219],[-28,2428],[338,-758],[185,2186],[563,-1046],[429,-2394]],[[126097,733937],[1280,-1597],[902,-116],[343,-1458],[135,-4906],[-200,-1131],[-500,1925],[-370,3180],[208,-4438],[379,-383],[50,-1490],[-321,-1688],[-659,1031],[14,-897],[-617,-308],[-202,4527],[181,2218],[-303,119],[-132,1682],[-636,2448],[448,1282]],[[130329,738612],[337,-2561],[-337,-2230],[902,-864],[-219,-3192],[699,-1259],[104,-3850],[709,243],[1430,-3886]],[[133954,721013],[215,-2256],[-268,-1574],[-450,60],[-522,-1243],[216,-2328],[-366,57],[-534,1418],[-527,-1313],[-52,-1739],[-416,-1188],[273,-1077],[-70,-1917],[-375,-1020],[-347,1785]],[[130731,708678],[461,1375],[54,2694],[202,40],[-10,3932],[574,625],[-464,526],[-186,2188],[-505,719],[-71,1280],[-436,1390],[254,2614],[-501,-62],[-115,1369],[-778,1724],[-462,2944],[355,-607],[-84,2467],[-160,-1289],[-1098,1537],[-631,1283]],[[127130,735427],[606,1116],[481,-957],[392,2691],[952,1778],[768,-1443]],[[126819,747787],[-267,-754]],[[120135,747679],[-911,-75]],[[119224,747604],[-113,-8]],[[119111,747596],[-67,-5]],[[119044,747591],[175,3135],[916,-3047]],[[118825,752542],[435,-1596],[-323,-3068],[-279,1218],[167,3446]],[[127130,735427],[-12,1829],[1070,643],[-784,626],[-296,2733],[132,1559],[-542,1078],[246,1825],[1153,-2770],[-708,2710],[-429,722],[25,2218]],[[127092,749125],[56,266]],[[128092,753582],[283,-2841],[560,-2991],[879,-6389],[515,-2749]],[[124853,753145],[18,23]],[[125289,753706],[-147,-677],[908,-5880],[23,-2256],[-213,92],[-809,7066],[78,-1904],[-258,510],[590,-4994],[507,-2211],[51,-2144],[-521,218],[645,-2298],[-310,-1473],[-532,1666],[52,-3416],[-404,-716],[-196,-1446],[-545,-1275],[-190,2104],[51,2518],[366,839],[-3,1567],[-686,5962],[70,2065],[-287,4181],[127,722]],[[121078,751604],[-275,-1102]],[[120803,750502],[345,-330],[594,2364],[321,432]],[[122063,752968],[1024,-1345],[153,-1323],[-236,-1608],[-621,1179],[756,-2767],[-774,-493],[-453,1349],[-1420,2800]],[[120492,750760],[-345,-2996]],[[120147,747764],[-1106,4388],[167,2241],[347,-765],[278,1062],[445,-194],[426,1507],[913,-2103],[-539,-2296]],[[121729,756782],[0,-124]],[[121729,756658],[0,124]],[[123714,754247],[-96,-1670],[-340,1775],[-157,4018],[686,-3441]],[[120619,759891],[-327,4038],[-329,1992],[900,1274],[-791,545],[-394,2927],[235,-3862],[-190,-2032],[-886,1580],[-102,2460],[-279,-1505],[-689,1343],[-390,-1137],[761,-460],[670,-1418],[-346,-493],[775,-1580],[-470,-1770],[538,847],[341,-512],[456,-4298],[-640,-1196],[-13,909],[-620,-1129],[-299,1069],[42,-2620],[-717,2665],[-654,322],[-1471,4078],[-935,3744]],[[114795,765672],[1165,1936]],[[115960,767608],[1943,4721],[681,110],[264,1748]],[[118848,774187],[1665,-1619],[530,-1279],[325,-2198],[-479,-4537],[582,-819],[408,-1530],[232,-2152],[-489,-12]],[[121622,760041],[48,-2295],[-405,960],[-824,-873],[178,2058]],[[122913,775799],[-901,-103]],[[122012,775696],[-90,222]],[[121922,775918],[-935,7001]],[[120987,782919],[676,1289],[684,-1897],[571,-2466],[-201,-2534],[196,-1512]],[[121729,756782],[0,-124]],[[123142,768818],[-26,12]],[[122508,768865],[-496,6831]],[[122913,775799],[197,-1218],[722,-594],[60,-1056],[546,-1130],[415,-3084]],[[121922,775918],[-144,-2315],[-359,301],[514,-2662],[-51,-2482],[722,-6540],[-70,-1017],[303,-3963],[-99,-2100],[-512,-56],[-321,1677],[-283,3280]],[[118848,774187],[35,3836],[479,-24],[182,1767],[-318,752],[1118,1161],[643,1240]],[[120877,738496],[390,-2216],[136,-2451],[-166,-1458],[-605,-381],[12,6413],[233,93]],[[122849,727161],[-438,-147],[77,1437],[-514,245],[-60,2351],[447,1679],[-481,1224],[98,2801],[-465,-185],[-451,2135],[588,60],[-327,842],[146,1990],[629,564],[-76,-1197],[394,257],[557,-1676],[491,7],[-82,-2391],[464,-6886],[222,-4906],[-140,-7130]],[[123927,716625],[-394,1362],[-697,5371],[278,1647],[-447,-368],[182,2524]],[[119111,747596],[-67,-5]],[[119342,746836],[-118,768]],[[120135,747679],[12,85]],[[120492,750760],[1454,-3708],[395,-1834],[350,1018],[503,16],[258,-5147],[-689,-337],[-264,1058],[-1794,4643],[718,-3300],[32,-2583],[-442,-1626],[-366,435],[-451,2590],[538,-1592],[-959,3723],[85,790],[-518,1930]],[[40063,839903],[771,-536],[-860,-2772],[-124,3412],[213,-104]],[[40964,844347],[884,-2223],[78,-1915],[441,-2171],[-39,-1740],[-705,2419],[-1774,1536],[91,1825],[445,2301],[579,-32]],[[42066,848667],[903,-976],[562,-1663],[-706,-1821],[-339,-2285],[-563,-2],[-711,2401],[-621,812],[15,1297],[651,1761],[809,476]],[[46154,848898],[568,1],[10,-1610],[528,1],[19,-1676],[523,-12],[-3,-1547],[3176,0]],[[50975,844055],[-396,-2136],[-20,-6445],[-125,-25],[-7,-6437],[383,-5],[-10,-4748],[1058,-39]],[[51858,824220],[180,-1451],[604,-215],[-1456,-2220],[-979,-2588],[-900,-571],[-1213,-1602],[-1235,662],[-494,709],[-1854,-1999],[-659,648],[-690,-2756],[-940,669],[31,-2392],[-390,-2165],[-92,-1943],[-1046,-1523],[-745,776],[-936,-1159]],[[39044,805100],[-171,1112],[663,830],[-1128,3201],[-12,-2176],[-520,182],[-235,2567],[116,849],[-614,571],[-206,2123],[418,1187],[-482,1394],[-545,-1187],[-96,2644],[1074,795],[-527,599],[-413,1924],[1381,582],[-440,3023],[250,2550],[1109,5288],[620,2101],[570,-118],[933,3976],[823,-896],[964,-4031],[-209,4581],[-456,1793],[11,1197],[848,640],[79,1725],[725,1785],[524,-1399],[777,464],[611,2670],[668,1252]],[[46897,791982],[260,-1285],[-269,-665],[9,1950]],[[36192,795959],[181,-1952],[581,363],[562,-947],[-124,-4413],[449,-2402],[-1266,-1162],[-486,-2126],[-685,2000],[-493,-131],[-1055,2670],[-324,-89],[-643,1570],[-207,2198],[273,857],[1285,-624],[56,1282],[1009,2111],[904,-187],[-17,982]],[[17304,799216],[127,-1745],[803,-2158],[617,-183],[448,-1365],[-1029,65],[-1000,3083],[-322,373],[356,1930]],[[39655,805231],[135,-1106],[641,589],[-100,-1482],[648,41],[525,-808],[140,-1889],[-483,-1833],[-425,-534],[212,-1308],[-375,-571],[-318,-2845],[-422,135],[-776,2413],[439,1980],[-611,-774],[-640,997],[1251,2977],[-199,1359],[401,589],[-43,2070]],[[49028,771386],[-724,158],[-208,-907],[-383,2903],[195,2895],[687,2210],[-440,2484],[-274,3082],[-346,1471],[-415,3726],[137,1138],[-768,3115],[394,1259],[285,3791],[-130,577],[-402,-4189],[-433,-1001],[310,-2534],[-69,-3036],[-405,-1085],[-1628,-2447],[-1521,-851],[-1011,789],[-258,2086],[267,429],[-760,1956],[-694,3087],[-88,1177],[383,1597],[-109,1291],[397,379],[-183,1458],[364,50],[277,1573],[410,342],[229,1752],[701,-118],[-15,-3249],[424,240],[608,2498],[-385,1562],[-1050,843],[630,147],[399,1002],[-599,266],[-481,-1345],[-126,3490],[-457,-1833],[194,-1308],[-1242,-569],[-216,1520],[-537,-627],[-175,927],[-743,-457]],[[51858,824220],[3536,-32],[11,1610],[2034,-6],[-4,1618],[4083,202],[1,-1838],[5892,-29],[3388,4],[-14,1716],[962,60],[3,1570],[903,-11],[192,1616]],[[72845,830700],[-2,-16190]],[[72843,814510],[-1303,45],[-15,-5422],[125,-21],[-16,-4230]],[[50464,766367],[-102,-328]],[[49620,764426],[-138,-1468],[-1062,-1905],[-96,1293],[-1035,446],[861,1205],[617,1650],[-307,160],[-106,3181],[674,2398]],[[91002,847056],[9,-3988],[146,-1795],[7,-11469],[-1548,27],[56,-1647],[46,-12768],[-726,13],[-1,-927],[-3493,32]],[[85498,814534],[-2027,-32],[-140,995]],[[83331,815497],[-404,601],[-736,-459],[-672,-2022],[-282,-2604],[-1336,126],[-327,2166],[-16,-1517],[-1058,-1636]],[[78500,810152],[-3,1152],[-1003,21],[-4,3165],[-4647,20]],[[72845,830700],[0,8044]],[[72845,838744],[3088,-82],[11,1347],[6637,9993],[4096,-25],[11,2587],[2946,186]],[[89634,852750],[1354,59],[14,-5753]],[[86653,868811],[757,-1569],[2146,14]],[[89556,867256],[86,-6324],[-8,-8182]],[[72845,838744],[1580,8236],[-1,2534],[-535,-83],[-516,926],[-152,2433],[36,3161],[1704,93],[23,3109],[497,-4],[22,3291],[619,95],[96,1432],[589,58],[151,-985],[624,-419],[1536,6612],[4539,-401],[2996,-21]],[[85498,814534],[-38,-10730],[-759,-83],[1,-2090]],[[84702,801631],[-828,17],[8,1987]],[[83882,803635],[-434,1931],[-461,-308],[-1061,1669],[-902,2471],[707,3049],[1129,2748],[471,302]],[[97244,787641],[-970,-3439],[64,996],[906,2443]],[[87222,789210],[-180,-1772],[-422,-410],[602,2182]],[[86635,788749],[223,2200],[233,-961],[-456,-1239]],[[86658,791573],[-368,-3115],[-331,1166],[699,1949]],[[89188,794370],[360,-14],[-242,-1523],[503,637],[-807,-2688],[-814,-3927],[157,-1241],[-672,-1392],[-694,-249],[129,1479],[1250,4306],[686,2953],[144,1659]],[[86770,795107],[-72,-1859],[-323,817],[395,1042]],[[90857,797012],[511,-366],[-56,-1276],[665,500],[124,-712],[-949,-1371],[-533,-1467],[-219,828],[596,1566],[-651,-377],[-24,893],[536,1782]],[[87021,792777],[237,3392],[601,-294],[-413,-4995],[-425,1897]],[[84911,786500],[233,323],[68,9012],[-286,661]],[[84926,796496],[584,1622],[519,-1019],[524,1881],[285,-1347],[30,-1922],[-996,-2869],[605,-1030],[-718,-2215],[-215,-2677],[-633,-420]],[[92921,798974],[-9,-545],[-1146,-2071],[-222,1208],[1377,1408]],[[88340,800844],[382,-576],[-511,-770],[129,1346]],[[84952,800675],[-2,141]],[[84950,800816],[2,-141]],[[86236,802132],[283,-1843],[-420,600],[137,1243]],[[84952,797243],[-2,3142]],[[84950,800385],[697,2105],[-36,-2998],[388,2501],[244,-2671],[-389,-1481],[-418,814],[-484,-1412]],[[86677,805210],[324,-2117],[-624,-286],[300,2403]],[[87480,803390],[-299,-138],[-586,2075],[324,2591],[505,2085],[122,1742],[-770,-3524],[-194,-1549],[-274,1236],[-413,-4415],[-943,-1986]],[[84952,801507],[-250,124]],[[91002,847056],[976,234],[64,648],[2681,18],[1,-1651],[1594,-292],[4038,-37],[350,-2273],[-454,-2972],[436,-1269],[-270,-2840],[731,-302],[296,1951],[1174,-336],[-16,-1588],[538,-65],[-11,-1550],[467,-24],[-41,-6434],[413,-697],[4,-4218],[2304,16]],[[106277,823375],[-1,-28115]],[[106276,795260],[-590,822],[-1600,-31],[4,1610],[-3846,-34],[-2014,-8871],[13,-855]],[[98243,787901],[-1022,2714],[47,774],[-1004,-33],[-277,1650],[-683,426],[369,3141],[18,2628],[-611,-1565],[-178,-1401],[-660,-2022],[-456,1505],[-715,1071],[-573,-359],[943,3800],[-1115,-764],[259,1691],[-925,-1558],[532,2101],[-1009,-888],[-678,62],[-94,801],[1014,956],[446,1115],[-1049,-704],[-517,1833],[318,3213],[1053,57],[-177,903],[-745,-283],[-1115,-3389],[-359,1426],[-193,-1467],[-586,-1116],[-377,408],[6,3472],[-279,-1340],[36,-2946],[-407,-423]],[[71986,766650],[159,17]],[[71670,777076],[234,-1111],[-578,-409],[344,1520]],[[79473,776784],[-278,-2074],[90,2387],[188,-313]],[[75949,796147],[-337,-1236],[224,2635],[113,-1399]],[[84952,800675],[-2,141]],[[84952,801507],[-2,-1122]],[[84952,797243],[-26,-747]],[[84911,786500],[-1246,807],[241,1474],[-372,-167],[-386,-2037],[-206,3701],[-28,-2396],[-481,-1666],[-173,-1732],[-183,2620],[-198,-5326],[-848,3357],[-38,-1545],[419,-800],[-370,-1104],[-68,-1569],[-635,-858],[207,3841],[-673,-5212],[-363,1475],[21,-2088],[-388,-20],[-756,-4011],[-73,2111],[-348,-2231],[-660,934],[-173,-858],[-798,-888],[-19,1049],[-622,715],[205,2741],[545,1203],[719,24],[16,1316],[737,963],[-66,842],[764,2927],[-371,25],[-1227,-2967],[-387,246],[-630,2275],[461,4880],[786,3381],[112,2715],[231,475],[102,3025],[-411,3227],[967,1254],[994,2799],[846,1832],[515,-1977],[449,-352],[796,1052],[345,-814],[1491,-887],[199,-646]],[[78500,810152],[-529,-2655],[-888,-709],[-892,-2927],[269,-2258],[-403,43],[-549,-1340],[-154,-1303],[-581,-1608],[-230,-3803],[-475,-1478],[-1034,410],[707,-1448],[308,-1772],[-382,-2913],[-286,-680],[-1150,-274],[-158,-989],[796,2],[-164,-2224],[-453,-1067],[-563,295],[228,1314],[-337,1411],[32,-1983],[-397,-2577],[-671,-197],[278,-1966],[-1055,-1700],[-60,-2764],[-263,-488],[166,-2860],[276,1050],[1025,35],[413,-1681],[604,-1165],[58,-1233]],[[110730,776964],[-495,571],[-783,1959],[461,898]],[[109913,780392],[89,-474],[542,2604],[-420,3603],[332,1618],[530,-2532],[165,177],[-480,2635],[-360,838],[-174,-1871],[-464,-2242],[-1472,-2407],[-1544,735],[-1623,2726],[527,2089],[-370,3153],[-376,-856],[438,-1616],[-624,-1272],[-2761,2302],[-2697,-711],[-928,-990]],[[106276,795260],[0,-1588],[1342,-1612],[173,1644],[1330,-2348],[802,2853],[1723,322],[-346,-4919],[404,-1740],[965,-1648],[226,-2564],[2839,-9770],[299,-4811],[-73,-1471]],[[114795,765672],[-74,1821],[-694,2541],[-828,1292],[164,1473],[-569,-631],[-2064,4796]],[[106279,946180],[-1,-49413]],[[106278,896767],[-929,-2456],[-130,-1601],[-1321,-3359],[-906,419],[-784,-1692],[-450,407],[-348,-3372],[-325,-1449],[-654,-436],[-1189,-2953],[59,-3793],[-686,-1989],[-822,655]],[[97793,875148],[-204,2150],[357,3326],[-316,718],[514,846],[-159,1080],[-964,-156],[-338,-900],[-1243,1394],[-887,-1195],[-579,221],[-638,-953],[-287,1202],[374,853],[-1289,1884],[-166,1203],[399,1801],[-515,869],[-625,-618],[-460,-1403],[-1060,-1320],[-1074,-10],[-601,-1159],[-3102,6],[49,-11364],[273,317],[853,-2473],[548,-2656]],[[50975,844055],[10,4776],[491,30],[-58,4948],[549,10],[4,1425],[1102,13],[-16,1635],[486,23],[-4,1682],[645,-27],[-89,4840],[-627,-25],[-61,12985],[569,33],[-9,3217],[558,13],[-5,6310],[540,-19],[-5,4867],[-576,-8]],[[54479,890783],[-5,8106],[1752,-15],[3,3093],[2984,34],[5,6544],[2342,37],[1,-3290],[1183,54],[7,3236],[1193,13],[-3,-1577],[601,61],[1,-1630],[1167,-18],[135,4836],[1805,-29],[9,2778],[1841,-6],[168,1643],[-10,6647],[-438,-21],[-10,1684],[-1233,59],[3,4809],[170,1665],[-625,-6],[17,1605],[-634,-27],[7,1645],[-620,11],[151,4212]],[[66446,936936],[6419,-3],[8315,-30],[7299,19],[3887,5],[-10,9096],[4663,309],[4791,-300],[4469,148]],[[97793,875148],[-1158,-1861],[-1436,-203],[-263,-1097],[-803,-486],[-476,-1290],[-577,796],[-731,-1428],[-434,44],[-567,-2104],[-1792,-263]],[[106278,896767],[-1,-73392]],[[79659,983425],[-186,-1457],[-394,1372],[580,85]],[[47581,977020],[610,-136],[635,1731],[830,26],[1623,2411],[1469,3493],[883,527],[-302,-3710],[454,-2621],[-62,3461],[379,971],[-494,2434],[-541,45],[1261,3273],[1370,1209],[-524,-1007],[415,-852],[3298,1404],[1420,2118],[705,1934],[1322,4592],[408,808],[628,-1392],[914,-472],[118,-1342],[1297,-97],[154,-1576],[-590,-1821],[-1263,-1269],[607,-390],[-400,-1319],[1303,-54],[455,606],[-99,1673],[703,1368],[285,1695],[248,-1304],[705,927],[682,-1755],[-272,-1974],[1375,-2190],[693,2096],[1211,87],[987,692],[971,-831],[278,-2575],[299,2682],[990,-1071],[-562,-2518],[6,-1533],[1009,-524],[-1483,-682],[2475,170],[-500,-2281],[1552,-378],[327,-1080],[240,1607],[1279,271],[-194,-2495],[904,1574],[844,524],[665,1465],[1963,-425],[887,-1703],[687,50],[281,-1515],[1082,464],[877,-2131],[2068,-1578],[1438,784],[1494,-1037],[432,637],[1637,-3240],[1773,-386],[359,911],[3399,1866],[1397,-1343],[1103,-2166],[387,-1504],[1266,-1052],[1132,-2959],[449,853],[588,-630],[-1,-21361]],[[66446,936936],[-2,524],[-2610,-22],[-7,1899],[-2541,-186],[-16,1669],[-3117,28],[-4016,91],[-18,1253],[-1129,59],[26,-1251],[-2705,21],[-18,1269],[-1182,3],[11,-1280],[-1329,46],[-6,1283],[-2021,165],[0,-1272],[-4957,-97],[16,-3782],[-2411,69]],[[38414,937425],[-1696,2109],[-331,1546],[-1319,2644],[530,804],[402,3101],[39,5653],[2425,-416],[2905,1305],[906,1070],[1221,2916],[1185,4350],[538,5905],[-330,649],[1231,3476],[365,2385],[846,2065],[658,2578],[522,-1587],[-930,-958]],[[54479,890783],[-578,0],[-10,-1617],[-6226,43],[-4789,-36],[-2,3199],[-592,6],[1,3250],[-769,-9],[7,6455],[-205,26],[-5,6430],[-226,1957]],[[41085,910487],[1578,205],[202,-2555],[-310,-1226],[120,-2178],[-264,-1027],[216,-1764],[590,-1196],[375,540],[1137,-445],[966,699],[320,-1177],[667,-159],[982,798],[546,-2005],[189,2045],[811,3513],[796,-959],[609,527],[-496,1902],[-1494,1020],[-695,-1271],[195,3234],[-840,3465],[-836,788],[-421,2411],[385,1580],[446,30],[876,-3094],[-153,-2498],[447,-1913],[932,-1943],[1113,1832],[1075,-3147],[1510,331],[132,1770],[-332,2163],[-931,-161],[-461,1240],[-884,-262],[-254,-1861],[-716,-284],[-1100,3517],[232,3055],[871,1517],[-974,1716],[-1121,-1075],[-1025,-154],[-390,1249],[-528,-563],[-2240,1824],[-398,5492],[-677,3577],[-1096,2080],[-2353,5735]],[[46592,855663],[132,-1524],[-911,379],[779,1145]],[[20847,858392],[154,-1917],[1767,-2170],[1395,2515],[527,-233],[506,-1478],[154,-2243],[1092,-1044],[302,-1308],[1484,-327],[899,-741],[-444,-2851],[-1263,664],[-756,-2937],[125,-925],[-598,-398],[121,1508],[-580,2032],[-993,769],[95,1587],[-981,2254],[-776,1164],[-1179,-1499],[-406,-1269],[-853,1089],[-307,2233],[515,5525]],[[40155,909679],[-378,-812],[-1697,-1707],[2075,2519]],[[50525,879793],[-440,-60],[-575,-2906],[-898,82],[-597,-1411],[-710,-398],[-195,-1163],[-840,-1617],[-253,-2635],[-445,-1194],[-161,3173],[-951,2836],[-459,-1140],[679,-1515],[9,-1792],[-1367,2870],[-2018,-58],[-2018,-2251],[-808,901],[-2508,1784],[-688,2790],[278,1486],[-107,1445],[-748,1760],[-608,2843],[665,-528],[574,1254],[301,1828],[875,-777],[601,-2903],[499,-323],[641,1345],[-382,829],[-829,195],[-166,-711],[-668,2577],[-1942,1613],[-1533,482],[-1421,2817],[-464,461],[785,2442],[579,22],[-1,1594],[845,1740],[325,-909],[992,2482],[419,1887],[1043,1672],[644,-1027],[1215,98],[319,783],[-1042,1554],[505,1845],[720,1193],[1099,506],[107,-679],[853,2834],[830,668]],[[46154,848898],[640,3384],[127,1617],[836,-1042],[-393,-958],[1743,358],[1079,995],[1027,4968],[-512,5797],[-74,2808],[-782,2761],[-730,205],[138,2075],[1090,-246],[769,2178],[52,1989],[-320,1964],[-701,1681],[382,361]],[[129336,693546],[270,-1010],[-141,-1955],[-386,2864],[257,101]],[[133465,694933],[144,-1619],[-433,-1116],[-420,1401],[709,1334]],[[129051,698432],[384,-3029],[-187,-665],[-381,868],[234,1060],[-50,1766]],[[128271,699419],[265,-2151],[-73,-1620],[898,-5179],[112,-1526],[-465,199],[-650,4105],[-450,3522],[52,2603],[311,47]],[[132791,699517],[330,-1553],[-34,-2741],[-744,304],[318,2136],[-199,1261],[329,593]],[[127590,701351],[341,-1447],[-98,-960],[-490,-120],[13,2204],[234,323]],[[126996,702605],[286,-601],[-587,-1676],[301,2277]],[[127349,703974],[-507,-707],[254,1440],[253,-733]],[[126550,705223],[399,-333],[-240,-1814],[-293,1014],[134,1133]],[[127577,705503],[193,-1280],[-213,-947],[-253,1520],[273,707]],[[126975,710441],[673,-1209],[-593,136],[47,-1542],[-470,1638],[343,977]],[[127739,711890],[119,-2595],[-287,1329],[168,1266]],[[132952,712558],[-518,-394],[514,1289],[4,-895]],[[127378,716539],[386,-260],[-15,-2495],[-236,369],[-705,-1255],[-241,-1211],[-256,709],[518,3076],[549,1067]],[[126879,720141],[451,-580],[749,57],[385,-2788],[-192,-1469],[384,-1822],[434,266],[497,-1761],[457,-2620],[47,-3196],[267,734],[169,-1960],[371,-1718],[-850,2044],[-552,-1434],[684,586],[160,-2342],[298,487],[445,-2791],[-464,-922],[454,-352],[205,1480],[89,-3147],[-430,-827],[396,-512],[100,-2502],[-397,-59],[420,-1193],[-182,-2479],[-613,702],[-449,4336],[-562,-35],[258,2640],[-329,-710],[132,1822],[-300,-502],[-724,2251],[-726,264],[28,1948],[514,-22],[-360,1667],[235,2818],[-438,-873],[-449,796],[644,3530],[-239,1458],[-150,5160],[-813,306],[-187,1878],[133,1386]],[[133954,721013],[796,-683],[442,-1861],[433,-443],[117,-1890],[501,-840],[397,491],[279,-2136],[-1,-1873],[-414,-2628],[68,-3449],[429,-5569],[-359,-1662],[-236,-2416],[-441,-2702],[-867,-2699],[-213,1932],[-286,-2060],[-268,663],[-208,4192],[490,1686],[-537,-477],[-156,1948],[582,2169],[-76,7458],[-887,5088],[-486,-470],[-72,869],[-949,-2430],[-397,-118],[344,-1651],[-544,-5283],[-589,1664],[-115,2845]],[[312327,9345],[187,-606]],[[312514,8739],[-15,-1700]],[[312499,7039],[-350,67]],[[312149,7106],[17,912]],[[312166,8018],[43,812]],[[312209,8830],[118,515]],[[312084,13311],[6,-1330]],[[312090,11981],[-147,-92]],[[311943,11889],[-157,1158]],[[311786,13047],[223,739]],[[312009,13786],[75,-475]],[[312224,10808],[178,-1248]],[[312402,9560],[-75,-215]],[[312209,8830],[-202,84]],[[312007,8914],[-56,275]],[[311951,9189],[-19,1837]],[[311932,11026],[292,-218]],[[313107,15065],[-14,-2951]],[[313093,12114],[-156,-32]],[[312937,12082],[5,365]],[[312942,12447],[-35,2686]],[[312907,15133],[200,-68]],[[312774,6524],[70,-1308]],[[312844,5216],[-339,-41]],[[312505,5175],[62,1491]],[[312567,6666],[207,-142]],[[312709,10760],[26,-1200]],[[312735,9560],[-333,0]],[[312224,10808],[123,646]],[[312347,11454],[362,-694]],[[315123,11876],[54,-128]],[[315177,11748],[78,-1804]],[[315255,9944],[-163,-1769]],[[315092,8175],[-119,1033]],[[314973,9208],[-63,762]],[[314910,9970],[144,1736]],[[315054,11706],[69,170]],[[314670,11208],[37,-329]],[[314707,10879],[60,-642]],[[314767,10237],[-199,-737]],[[314568,9500],[-72,1128]],[[314496,10628],[174,580]],[[314052,6833],[264,-476]],[[314316,6357],[-19,-702]],[[314297,5655],[-318,75]],[[313979,5730],[73,1103]],[[312567,6666],[-68,373]],[[312514,8739],[144,137]],[[312658,8876],[116,-2352]],[[312942,12447],[-192,449]],[[312750,12896],[-16,-18]],[[312734,12878],[-7,2191]],[[312727,15069],[180,64]],[[314923,14259],[-51,-292]],[[314872,13967],[-106,119]],[[314766,14086],[83,583]],[[314849,14669],[74,-410]],[[313370,8907],[-65,-415]],[[313305,8492],[-209,83]],[[313096,8575],[-80,-29]],[[313016,8546],[-82,705]],[[312934,9251],[27,1093]],[[312961,10344],[345,-244],[64,-1193]],[[313305,8492],[-14,-2846]],[[313291,5646],[-154,398]],[[313137,6044],[-41,2531]],[[314464,12205],[-98,-1501]],[[314366,10704],[-105,-151]],[[314261,10553],[-75,982]],[[314186,11535],[35,730]],[[314221,12265],[129,637]],[[314350,12902],[114,-697]],[[314016,15105],[-14,-2136]],[[314002,12969],[-54,8]],[[313948,12977],[-196,-375]],[[313752,12602],[-27,1007]],[[313725,13609],[25,1393]],[[313750,15002],[266,103]],[[313604,15086],[-4,-1775]],[[313600,13311],[-8,-956]],[[313592,12355],[-45,-184]],[[313547,12171],[-454,-57]],[[313107,15065],[497,21]],[[314264,15070],[-76,-2600]],[[314188,12470],[-186,499]],[[314016,15105],[248,-35]],[[315464,13512],[1,-2420]],[[315465,11092],[-66,435]],[[315399,11527],[-159,1610]],[[315240,13137],[-103,1306]],[[315137,14443],[122,139]],[[315259,14582],[205,-1070]],[[314938,14054],[76,-2458]],[[315014,11596],[-176,-329]],[[314838,11267],[34,2700]],[[314923,14259],[15,-205]],[[315375,10330],[63,-1609]],[[315438,8721],[6,-426]],[[315444,8295],[-234,-827]],[[315210,7468],[-116,640]],[[315094,8108],[-2,67]],[[315255,9944],[120,386]],[[313784,8891],[255,-1302]],[[314039,7589],[13,-756]],[[313979,5730],[-242,-149]],[[313737,5581],[-39,3312]],[[313698,8893],[16,20]],[[313714,8913],[70,-22]],[[315465,11092],[-90,-762]],[[315177,11748],[222,-221]],[[313725,9098],[-11,-185]],[[313698,8893],[-269,126]],[[313429,9019],[231,2603]],[[313660,11622],[65,-2524]],[[314361,14912],[31,-1700]],[[314392,13212],[-42,-310]],[[314221,12265],[-33,205]],[[314264,15070],[97,-158]],[[312306,11771],[41,-317]],[[311932,11026],[-107,569]],[[311825,11595],[118,294]],[[312090,11981],[216,-210]],[[312937,12082],[24,-1738]],[[312934,9251],[-27,-13]],[[312907,9238],[-172,322]],[[312709,10760],[41,2136]],[[315183,5666],[-140,-215]],[[315043,5451],[-34,1224]],[[315009,6675],[174,-1009]],[[312505,5175],[-359,-115]],[[312146,5060],[3,2046]],[[314634,8728],[-21,-892]],[[314613,7836],[-92,-362]],[[314521,7474],[-160,1419]],[[314361,8893],[201,525]],[[314562,9418],[72,-690]],[[312295,14640],[81,-1252]],[[312376,13388],[-70,-1617]],[[312084,13311],[211,1329]],[[312007,8914],[159,-896]],[[312146,5060],[-281,902],[86,3227]],[[315210,7468],[60,-309]],[[315270,7159],[221,-1460]],[[315491,5699],[-308,-33]],[[315009,6675],[81,1384]],[[315090,8059],[4,49]],[[314186,11535],[-217,-675]],[[313969,10860],[-21,2117]],[[311825,11595],[-39,1452]],[[312009,13786],[157,1825]],[[312166,15611],[129,-971]],[[313137,6044],[-273,-821]],[[312864,5223],[152,3323]],[[314838,11267],[-131,-388]],[[314670,11208],[-8,753]],[[314662,11961],[28,1347]],[[314690,13308],[76,778]],[[313547,12171],[113,-549]],[[313429,9019],[-59,-112]],[[314973,9208],[-339,-480]],[[314562,9418],[6,82]],[[314767,10237],[143,-267]],[[314776,6994],[-112,-1631]],[[314664,5363],[-367,292]],[[314316,6357],[205,1117]],[[314613,7836],[163,-842]],[[312679,13385],[55,-507]],[[312376,13388],[303,-3]],[[315090,8059],[-314,-1065]],[[314662,11961],[-198,244]],[[314392,13212],[143,201]],[[314535,13413],[155,-105]],[[312679,13385],[-109,1773]],[[312570,15158],[157,-89]],[[313752,12602],[-160,-247]],[[313600,13311],[125,298]],[[314496,10628],[-130,76]],[[313604,15086],[146,-84]],[[315240,13137],[-117,-1261]],[[315054,11706],[-40,-110]],[[314938,14054],[199,389]],[[315043,5451],[-379,-88]],[[312864,5223],[-20,-7]],[[312658,8876],[249,362]],[[314001,9350],[196,-57]],[[314197,9293],[164,-400]],[[314039,7589],[-38,1761]],[[313784,8891],[217,459]],[[313969,10860],[-244,-1762]],[[313737,5581],[-446,65]],[[314261,10553],[-64,-1260]],[[312166,15611],[404,-453]],[[315579,8262],[226,-900]],[[315805,7362],[-150,-1087]],[[315655,6275],[-385,884]],[[315444,8295],[135,-33]],[[314535,13413],[108,1311]],[[314643,14724],[206,-55]],[[318309,12804],[169,-865],[-544,829],[375,36]],[[316158,12801],[-233,-1215]],[[315925,11586],[-15,-114]],[[315910,11472],[23,1756]],[[315933,13228],[225,-427]],[[315714,13936],[-106,-833]],[[315608,13103],[-144,409]],[[315259,14582],[455,-646]],[[315655,6275],[-164,-576]],[[315910,11472],[-22,-197]],[[315888,11275],[-160,-130]],[[315728,11145],[-34,41]],[[315694,11186],[-86,1917]],[[315714,13936],[219,-708]],[[315888,11275],[293,-1349]],[[316181,9926],[-216,-625]],[[315965,9301],[-242,492]],[[315723,9793],[5,1352]],[[315723,9793],[-144,-1531]],[[315438,8721],[211,2085]],[[315649,10806],[45,380]],[[315649,10806],[-184,286]],[[316256,11347],[-331,239]],[[316158,12801],[154,393],[-56,-1847]],[[316256,11347],[125,-1005],[-200,-416]],[[315965,9301],[-160,-1939]],[[316936,9055],[328,-560],[-757,-908],[-91,684],[520,784]],[[318661,1986],[376,-1084],[-740,-782],[24,1182],[340,684]],[[314361,14912],[282,-188]]],"transform":{"scale":[0.0003589261789261791,0.0000537148685138684],"translate":[-179.1473399999999,17.67439566600018]}}
        
		var projection = d3.geo.albersUsa().scale(((targetElement[0][0].clientWidth) + (targetElement[0][0].clientHeight))/2)
		.translate([targetElement[0][0].clientWidth/2, targetElement[0][0].clientHeight/3.7]);
		
		// positioning the map's top position based on table show or hide
		if(options.showTable == true){
			projection.scale(((targetElement[0][0].clientWidth) + (targetElement[0][0].clientHeight))/2.4)
			.translate([targetElement[0][0].clientWidth/1.9, targetElement[0][0].clientHeight/3.7]);
		}
		else if(options.showTable == false){
			projection.scale(((targetElement[0][0].clientWidth) + (targetElement[0][0].clientHeight))/2.4)
			.translate([targetElement[0][0].clientWidth/1.9, targetElement[0][0].clientHeight/2.2]);
		}
		
		var path = d3.geo.path().projection(projection);
		svgPanelForUSMapWithPins.style("background-color","#ffffff").style("cursor","move")
		
		var stateCodeArray = [];
		options.data.forEach(function(d,i){ stateCodeArray.push(+d[options.keys.stateCode])})
	
		var uniqueStateCodeArray = [];
		stateCodeArray.forEach(function(item) { if(uniqueStateCodeArray.indexOf(item) < 0) { uniqueStateCodeArray.push(item); } });
		
		var totalValue = 0, temp = {}, colorInterpolationArr = [];
		uniqueStateCodeArray.forEach(function(d) { 
			options.data.forEach(function(obj){
				
				if(Number(d) === Number(obj[options.keys.stateCode])){
					totalValue += Number(obj[options.keys.value])
				}
				
			})
			temp["stateCode"] = d;
			temp["totalValue"] = totalValue;
			temp["fillColor"] = d3.interpolate("#ABEBC6", "#239B56")(totalValue/500)
			colorInterpolationArr.push(temp)
			temp = {};
			totalValue = 0;
		});
		
		var trueOrFalse = false;
		var map = svgPanelForUSMapWithPins.select("g").selectAll("path").data(topoJson.object(latitudeAndLongitudeData, latitudeAndLongitudeData.objects.states).geometries).enter()
		.append("path").attr("d", path).style("stroke","#767878" ).style("stroke-width","0.25px" )
		.style("fill",function(d,i){
			for(var j = 0; j < colorInterpolationArr.length; j++){
				if(colorInterpolationArr[j]["stateCode"] == d.id){
					return colorInterpolationArr[j]["fillColor"];
				}
			}
			return "#d3d3d3";
		})
		
        var circles, circleTexts;
		
		function plotDotsFun(){
	   
			circles = svgPanelForUSMapWithPins.select('g').selectAll("circle").data(options.data).enter()
			.append("circle").attr("class","dot").style("fill", "#C83624").style("cursor","default").attr("r", 4)
			
			circles.attr("cx", function(d) { return targetElement[0][0].clientWidth/2; })
			.attr("cy", function(d) { 
							if(options.showTable == true){
									return targetElement[0][0].clientHeight/3.7; 
							}
							else if(options.showTable == false){
									return targetElement[0][0].clientHeight/2.2; 
							}
			})
			.style("display","none").transition().delay(500).duration(2000).style("display","block")
			.attr("cx", function(d) { return projection([+d[options.keys.longitude], +d[options.keys.latitude]])[0]; })
			.attr("cy", function(d) { return projection([+d[options.keys.longitude], +d[options.keys.latitude]])[1]; })
			
		}
	
		plotDotsFun();
		
		var zoom = d3.behavior.zoom()
		.on("zoom",function() {
			
			svgPanelForUSMapWithPins.select('g').attr("transform","translate("+d3.event.translate.join(",")+")scale("+d3.event.scale+")");
												 
			svgPanelForUSMapWithPins.select('g').selectAll("circle")
			.attr("r", function(){ var self = d3.select(this); var r = 4 / d3.event.scale; self.style("stroke-width", r < 6 ? (r < 2 ? 0.5 : 1) : 2); return r; });
		});
	
		svgPanelForUSMapWithPins.call(zoom)
        
        circles.on("mousemove", mousemove).on("mouseout", mouseout)
		
		var columnNames = d3.keys(options.data[0])
        var drillDownColumnNamesInArray = options.drillDownColumnName.split(",");
        
        for(var i = 0; i < columnNames.length ; i++){
            for(var j = 0; j < drillDownColumnNamesInArray.length ; j++){
                if(columnNames[i].toLowerCase() === drillDownColumnNamesInArray[j].toLowerCase()){
                    var foundKey = columnNames[i];
                    for(var k = 0; k < circles[0].length; k++){
                        for(l = 0; l < options.data.length; l++){
                            if(options.data[l][options.keys.latitude].toString() === circles[0][k].__data__[options.keys.latitude].toString() && options.data[l][options.keys.longitude].toString() === circles[0][k].__data__[options.keys.longitude].toString()){
                                d3.select(circles[0][k]).attr('data-drilldownkey', function(d,index){
                                  return JSON.stringify(options.data[l]).slice(1, -1).split('"').join("").split(':').join("|")
                                })
							}
                        }
                    }
                }
                else {
                }
            }
        }
        
        function mousemove(d,i){
            
            var root = targetElement
			var m = d3.mouse(root.node());
			m[0] += 0
			m[1] += 0

			var valueForUSMapWithPinsTooltip;
			if(d[options.keys.value].toString().indexOf('.') === -1) { valueForUSMapWithPinsTooltip = d[options.keys.value].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); }
			else{ valueForUSMapWithPinsTooltip = d[options.keys.value]; }

			tooltipForUSMapWithPins.select('.stateNameLableClass').html('<div>State: ' + d[options.keys.state] + '</div>');
			tooltipForUSMapWithPins.select('.placeNameLableClass').html('<div>Place: ' + d[options.keys.place] + '</div>');
			tooltipForUSMapWithPins.select('.valueLableClass').html('<div>' + options.keys.value + ': ' + valueForUSMapWithPinsTooltip + '</div>');
			tooltipForUSMapWithPins.style('visibility', 'visible');
			tooltipForUSMapWithPins.selectAll('hr').style("background-color", "#c83624")
			tooltipForUSMapWithPins.style("margin-left", (m[0] + 15) + "px").style("margin-top",(m[1] - 35) + "px").style("display","block")
			//.transition().duration(400)
        }
        
        function mouseout(d,i){ tooltipForUSMapWithPins.style("display","none") }
        
		//-------------------------------------------------------------------------------------
		
		if(options.showTable == true){
			var leftLegendPanel = targetElement .append('div').style("position", "absolute").attr("id","leftlegendpanelid-"+targetElement[0][0].id)
			.style("left","0%").style("top","10%").style("width","20%").style("height","55%").style("background-color","white")
		
			var rightLegendPanel = targetElement .append('div').style("position", "absolute").attr("id","rightlegendpanelid-"+targetElement[0][0].id)
			.style("left","80%").style("top","10%").style("width","20%").style("height","49%").style("background-color","white")
		}
		else if(options.showTable == false){
			var leftLegendPanel = targetElement .append('div').style("position", "absolute").attr("id","leftlegendpanelid-"+targetElement[0][0].id)
			.style("left","0%").style("top","10%").style("width","20%").style("height","90%").style("background-color","white")
		
			var rightLegendPanel = targetElement .append('div').style("position", "absolute").attr("id","rightlegendpanelid-"+targetElement[0][0].id)
			.style("left","80%").style("top","10%").style("width","20%").style("height","90%").style("background-color","white")
		}
		
		var leftLegendArray = [], rightLegendArray = [];
		
		if(options.data.length <= 25){
			options.data.forEach(function(d,ind){
				rightLegendArray.push(d)
			})
		}
		else {
			var balanceLine = Math.round(options.data.length/2)
			options.data.forEach(function(d,ind){
				if(ind >= balanceLine){
					rightLegendArray.push(d)
				}
				else {
					leftLegendArray.push(d)
				}
			})
		}
		
		
		var leftLegendPanelUL = leftLegendPanel.append("ul").style('position','absolute')
		.style("left","0%").style("top","0%").style("width","100%").style("height","100%")
		.style("margin","0px")
		.style("list-style-type","none").style("background-color", options.BGcolor).style("padding","0px")
		.style("overflow","hidden").style("box-sizing","border-box")
		
		var leftLegendPanelLIs = leftLegendPanelUL.selectAll("li") 
        .data(leftLegendArray)
        .enter().append("li").style('margin','0px').style("margin-top","1px") .style("padding","3px")
        .style("width","100%") 
        .style("font-size","12px").style("background-color", options.BGcolor).style("font-weight","normal")
        .style("list-style-type","none").style("color","#00001c").style("font-family","Verdana,sans-serif")
        .style("position","relative").style('line-height',"normal").style("box-sizing","border-box")
		.style("border","none").style("border-bottom","1px solid #f4f4f4").style("text-indent","2px")
        .text(function(d) {
			return d[options.keys.place]+", "+d[options.keys.state];
		})
		.append("span").style("position","absolute").style("right","4px")
		.style("text-anchor", "end").html(function(d){return d[options.keys.value]})
		
		var rightLegendPanelUL = rightLegendPanel.append("ul").style('position','absolute')
		.style("left","0%").style("top","0%").style("width","100%").style("height","100%")
		.style("margin","0px")
		.style("list-style-type","none").style("background-color", options.BGcolor).style("padding","0px")
		.style("overflow","hidden").style("box-sizing","border-box")
		
		var rightLegendPanelLIs = rightLegendPanelUL.selectAll("li") 
        .data(rightLegendArray)
        .enter().append("li").style('margin','0px').style("margin-top","1px") .style("padding","3px")
        .style("width","100%") 
        .style("font-size","12px").style("background-color", options.BGcolor).style("font-weight","normal")
        .style("list-style-type","none").style("color","#00001c").style("font-family","Verdana,sans-serif")
        .style("position","relative").style('line-height',"normal").style("box-sizing","border-box")
		.style("border","none").style("border-bottom","1px solid #f4f4f4")
        .text(function(d) {
			return d[options.keys.place]+", "+d[options.keys.state];
		})
		.append("span").style("position","absolute").style("right","5px")
		.style("text-anchor", "end").html(function(d){return d[options.keys.value]})
        
		
		//-------------------------------------------------------------------------------------
		
		var tableDataForUSMapWithPinsChart = [];
		if(options.dataForTable.length > 0){
			tableDataForUSMapWithPinsChart = options.dataForTable;
		}
		else {
			tableDataForUSMapWithPinsChart = options.data;
		}
		
		if(options.showTable == true){
			
			var searchTextBoxForPieChart = targetElement.append('input').style("width","200px").style('right','1px').style('bottom','35.5%')
			.style('position',"absolute").style('height',"26px").style("border", "1px solid #dab17e").style('text-indent','28px')
			.attr("placeholder","search in table").attr("class","autoSearchTextBoxForUSMapWithPinsChart" + targetElement[0][0].id).style("font-size","14px").style("box-sizing","border-box")
			.style("background-image","url('images/searchChart2.png')").style("background-repeat","no-repeat").style("font-weight","Normal") 
			.style("background-size",'14px 14px').style("background-position",'8px 5px').style("display","block").style("line-height","Normal")
			.style('outline-width',"0px").style("border-radius","15px")
			
			$(document).ready(function(){
				$(".autoSearchTextBoxForUSMapWithPinsChart" + targetElement[0][0].id).off('input');
				$(".autoSearchTextBoxForUSMapWithPinsChart" + targetElement[0][0].id).on('keyup', function(){
					textChangedFunction(this.value)
				});
			});
			
			function textChangedFunction(val) {
				
				var textBoxValueLowerCased = val //this.value
				searchTextBoxArrayForUSMapWithPinsChart = [];

				tableDataForUSMapWithPinsChart.forEach(function(d, i) {
					
					var dd = d3.values(d);
					var eachObjectArray = [];
					eachObjectArray.push(d3.values(d))
					//d[options.keys.value] = d[options.keys.value].toString();

					for(var i = 0; i<Object.keys(d).length; i++){
						var lower = d3.values(d)[i].toString().toLowerCase()
						if ( lower.toLowerCase().indexOf(textBoxValueLowerCased.toLowerCase()) > -1 ) {
							searchTextBoxArrayForUSMapWithPinsChart.push(d)
							break;
						}
					}
				});
				
				tablePanelForUSMapWithPins.select("table").remove()
				
				if(searchTextBoxArrayForUSMapWithPinsChart.length == 0){
					var temp = {};
					Object.keys(tableDataForUSMapWithPinsChart[0]).forEach(function(d,i){
						temp[d] = ""
					})
					searchTextBoxArrayForUSMapWithPinsChart.push(temp)
					temp = {};
				}
				createTableFunc(searchTextBoxArrayForUSMapWithPinsChart)
				
			}
		}
		
		var tablePanelForUSMapWithPins =  targetElement.append("div") .attr("id",targetElement[0][0].id + "holderForUSMapWithPinsChartTableID")
        .attr("class","scrollingDivForTable-Class tableDivForUSMapWithPins" + targetElement[0][0].id) .style('background-color',"#ffffff") .style('position','absolute')
        .style("display","block") .style("overflow","hidden") .style("width", function(d) {  return 100+ "%"; })
        .style("height", function(d) { return 35 + "%"; }) .style("left",0 + "%") .style("top",65 + "%")
		//.style("border-right","1px solid #e2e2e2").style("border-bottom","1px solid #e2e2e2")
        
		//create table in table holder div
		createTableFunc(tableDataForUSMapWithPinsChart)
		
		function createTableFunc(tabledataparameter){
		
			$( '.tableDivForUSMapWithPins' + targetElement[0][0].id).bind( 'mousewheel DOMMouseScroll', function ( e ) {
				var e0 = e.originalEvent,
				delta = e0.wheelDelta || -e0.detail;
		
				this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
				e.preventDefault();
			});
			
			tablePanelForUSMapWithPins.html('<table class = "tableClassForUSMapWithPinsChart' + targetElement[0][0].id + '"' + 'style=" width:100%; height:auto; position:absolute; background-color:white; margin-top:0px; font-family: Verdana,sans-serif; font-size:9pt; border-collapse:collapse; border-color:#ebf5e6; " >'+
										  '<thead class = "theadClassForUSMapWithPinsChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' + '<thead class = "thead1ClassForUSMapWithPinsChart' + targetElement[0][0].id + '"' +'style="background-color:#f4f4f4;">'+'</thead>' +
										  '<tbody class = "tBodyClassForUSMapWithPinsChart' + targetElement[0][0].id + '"' + 'style="background-color:white; width:100%; height:auto; ">'+'</tbody>'+
										  '</table>'
										  )
			
			tablePanelForUSMapWithPins.select('table').attr('id',targetElement[0][0].id + 'tableID')

			// Show or Hide Table scroll bar when mouseover on widget
			targetElement.on('mouseover',function(){ 
				tablePanelForUSMapWithPins.style("overflow","auto")
				leftLegendPanelUL.style("overflow-y","auto")
				rightLegendPanelUL.style("overflow-y","auto")
			})
			targetElement.on('mouseout',function(d){ 
				tablePanelForUSMapWithPins.style("overflow","hidden")
				leftLegendPanelUL.style("overflow","hidden")
				rightLegendPanelUL.style("overflow","hidden")				
			})
			
			
			
			var thead = tablePanelForUSMapWithPins.select("thead").selectAll("th") .data(d3.keys(tabledataparameter[0]))
			.enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
			
			var svgSelection = thead.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff")//f4f4f4
			.style("position","relative")
			
			var thead1 = d3.select(".thead1ClassForUSMapWithPinsChart" + targetElement[0][0].id).selectAll("th") .data(d3.keys(tabledataparameter[0]))
			.enter().append("th").text(function(d){return d.charAt(0).toUpperCase() + d.substr(1)}).style("cursor","pointer").style("min-width","100px")
			
			var svgSelection1 = thead1.append("svg") .attr("width", 14) .attr("height", 14) .style("float","right") .style("background-color","#ffffff")//f4f4f4
			.style("position","relative")
			
			var ascendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/ascending.png") .attr({ width: 10,height: 7 })
			.attr("id", "ascendingIconIDForUSMapWithPinsChart") .attr('transform', 'translate(' + (2.5) + ',' + (0.0) + ')')
			
			var descendingIcon = svgSelection1.append("image") .attr("xlink:href", "images/descending.png") .attr({ width: 10,height: 7 })
			.attr("id", "descendingIconIDForUSMapWithPinsChart") .attr('transform', 'translate(' + (2.5) + ',' + (6.0) + ')')
			
			var tr = tablePanelForUSMapWithPins.select("tbody").selectAll("tr") .data(tabledataparameter).enter().append("tr")
			.attr("id", function(d,i) { return "slice" + i })
			
			// cells
			var td = tr.selectAll("td") .data(function(d){ return d3.values(d)}) .enter().append("td") .text(function(d) { return d}) 
			.style("text-align","left") .style("padding-left","6px") .style("color","#00001c")
			
			var $table = $('.tableClassForUSMapWithPinsChart' + targetElement[0][0].id ), $bodyCells = $table.find('tbody tr:first').children(), colWidth = [];
			
			d3.select(".theadClassForUSMapWithPinsChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
				d.forEach(function(dd,j){
					colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
				})
			})
			
			
			$(".thead1ClassForUSMapWithPinsChart" + targetElement[0][0].id).insertAfter('.tBodyClassForUSMapWithPinsChart' + targetElement[0][0].id)
			
			$(".thead1ClassForUSMapWithPinsChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForUSMapWithPins' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
			
			
			tablePanelForUSMapWithPins.select(".theadClassForUSMapWithPinsChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
				d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
			})
			
			tablePanelForUSMapWithPins.select(".thead1ClassForUSMapWithPinsChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
				d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
			})
			
			
			$('.tableDivForUSMapWithPins' + targetElement[0][0].id).scroll(function () {
																	  
				$(".thead1ClassForUSMapWithPinsChart" + targetElement[0][0].id).css({ position:'absolute' }) .animate({ top: $('.tableDivForUSMapWithPins' + targetElement[0][0].id).scrollTop() + 'px'},0, function() { });
																	  
			})
			
			var sortOrder = false;
			thead1.on("click",function(k, index){
				 
				sortOrder = !sortOrder;

				tablePanelForUSMapWithPins.select(".thead1ClassForUSMapWithPinsChart" + targetElement[0][0].id).selectAll("th").each( function(d, i){
											 
					if (sortOrder) {
											 
						if(i == index){
							d3.select(this).select('svg').select('#descendingIconIDForUSMapWithPinsChart').style("visibility", "hidden")
							d3.select(this).select('svg').select('#ascendingIconIDForUSMapWithPinsChart').style("visibility", "visible")
						}
						else {
							d3.select(this).select('svg').select('#descendingIconIDForUSMapWithPinsChart').style("visibility", "visible")
							d3.select(this).select('svg').select('#ascendingIconIDForUSMapWithPinsChart').style("visibility", "visible")
						}
					}
					else{
											 
						if(i == index){
							d3.select(this).select('svg').select('#descendingIconIDForUSMapWithPinsChart').style("visibility", "visible")
							d3.select(this).select('svg').select('#ascendingIconIDForUSMapWithPinsChart').style("visibility", "hidden")
						}
						else {
							d3.select(this).select('svg').select('#descendingIconIDForUSMapWithPinsChart').style("visibility", "visible")
							d3.select(this).select('svg').select('#ascendingIconIDForUSMapWithPinsChart').style("visibility", "visible")
						}
					}
				})
			 
				var monthTruOrFalAryForUSMapWithPinsChart = [], monthArray = [], monthArrayCount = [], gotMonthArray = [], ind = 0, returnArray = [];

				tr.sort(function(a, b) {
					  
					if (sortOrder) {
					var monthsArrayForUSMapWithPinsChart = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
					} else {
					var monthsArrayForUSMapWithPinsChart = ["dec","nov","oct","sep","aug","jul","jun","may","apr","mar","feb","jan"];
					}

					monthTruOrFalAryForUSMapWithPinsChart = []; gotMonthArray = [];
					tabledataparameter.forEach(function(d,i){
					   var da = d[k].toString().substring(0,3).toLowerCase()
					   if(monthsArrayForUSMapWithPinsChart.indexOf(da) >= 0){
						   monthTruOrFalAryForUSMapWithPinsChart.push(true)
						   gotMonthArray.push(da);
					   }
					   else {
						   monthTruOrFalAryForUSMapWithPinsChart.push(false)
					   }
					})

					if(monthTruOrFalAryForUSMapWithPinsChart.indexOf(false) == -1){ // true

					monthArray = []; monthArrayCount = [];
					gotMonthArray.forEach(function(dd,j){
						var index1 = monthsArrayForUSMapWithPinsChart.indexOf(dd.substring(0,3))
						if(monthArrayCount.indexOf(index1) >= 0){
							index1 = 12 + index1;
						}
						monthArray.push(index1);
						monthArrayCount.push(index1)
					})
					returnArray = []
					monthArray.sort(function(aa, bb) {
					  returnArray.push(+aa - +bb)
					  return +aa - +bb;
					})

					sortTableFunc()
					return returnArray[ind++];
					} //  if true (if jan feb if block)
					else {
					var data = +a[k];

					if(!isNaN(data)){

					if (sortOrder) { return d3.ascending(+a[k], +b[k]); }
					else { return d3.descending(+a[k], +b[k]); }
					}
					else if(!isNaN(Date.parse(a[k]))){

					if (sortOrder) { return new Date(a[k]) - new Date(b[k]) }
					else { return new Date(b[k]) - new Date(a[k]) }
					}
					else {

					if (sortOrder) { return d3.ascending(a[k], b[k]); }
					else { return d3.descending(a[k], b[k]); }
					}
					} // if not jan feb else block
				}); // tr

					  
					 
			})
			
			function sortTableFunc(){
				
				var table = tablePanelForUSMapWithPins.select('table');
				var rows = table.selectAll('tr').data(tabledataparameter);
				var cells = tr.selectAll('td').data(function(d){ return d3.values(d)})
				cells.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(2900) .duration(500) .style('opacity', 1.0).style("color","#00001c");

				cells.text(function(d,i) {return d});

				// Cells exit selection
				cells.exit() .attr('class', 'exit') .transition() .delay(2200) .duration(500) .style('opacity', 0.0) .remove();

				var cells_in_new_rows = rows.enter().append('tr') .selectAll('td') .data(function(d){ return d3.values(d)})

				cells_in_new_rows.enter().append('td') .style('opacity', 0.0) .attr('class', 'enter') .transition() .delay(900) .duration(500)
				.style('opacity', 1.0).style("color","#00001c");

				cells_in_new_rows.text(function(d,i) {return d});

				rows.exit() .attr('class', 'exit') .transition() .delay(200) .duration(500) .style('opacity', 0.0) .remove();
			}
			
			tablePanelForUSMapWithPins.selectAll('th').style("font-size","12px").style("font-family", "Verdana,sans-serif").style("font-weight","Bold").style("text-align","left").style("padding-left","6px")
			.style("color","#00001c")
			.style("height","25px").style("border", "1px solid #dddddd").style('background-color',"#ffffff") 
			tablePanelForUSMapWithPins.selectAll('td').style("height","25px") .style("border", "1px solid #ffffff") .style("font-size","12px").style("font-weight","Normal").style("color","#00001c")
			

			//additionally 
			tablePanelForUSMapWithPins.selectAll('th').style("border", "1px solid #f5f5f5").style("color","#00001c").style("font-weight","Bold")
			tablePanelForUSMapWithPins.selectAll('td').style("border-style","none").style("color","#00001c")

			tablePanelForUSMapWithPins.selectAll('table') . style("border-collapse","collapse")
			tablePanelForUSMapWithPins.selectAll('table tr:first-child th').style("border-top","0px")
			tablePanelForUSMapWithPins.selectAll('table tr:last-child td').style("border-bottom","0px")
			tablePanelForUSMapWithPins.selectAll('table tr td:first-child,table tr th:first-child').style("border-left","0px")
			tablePanelForUSMapWithPins.selectAll('table tr td:last-child,table tr th:last-child').style("border-right","0px")

			if(options.showTable == false){
				tablePanelForUSMapWithPins.style("display","none")
			}
			else if(options.showTable == true){
				tablePanelForUSMapWithPins.style("display","block")
			}
			
			if(options.dataForTable.length == 0){
			
				var drillDownColumnNamesArray = options.drillDownColumnName.split(",");
			
				// Adding underlines for selected drill-down column text
				var drillDownSectionsForUSMapWithPinsChart = tablePanelForUSMapWithPins.select('table').selectAll('th')
				var drillDownSectionsFor_USMapWithPinsChart = drillDownSectionsForUSMapWithPinsChart[0]
			
				var foundResult = [];
				for(var i = 0; i<drillDownSectionsForUSMapWithPinsChart[0].length; i++){
					for(var j = 0; j<drillDownColumnNamesArray.length; j++){
						if(drillDownColumnNamesArray[j].toString().toLowerCase() ===  drillDownSectionsForUSMapWithPinsChart[0][i].__data__.toString().toLowerCase() ){
							foundResult.push(i)
						}
					}
				}
			
				var r = tablePanelForUSMapWithPins.select('table').selectAll('tr').selectAll('td')
				for(var i = 0; i<r.length; i++){
					for(var j = 0; j < foundResult.length; j++){
						var row = r[i][foundResult[j]]
						$(row).css("text-decoration", "underline")
					}
				}
			}
		}// createTableFunc
		//------------------------------------------------------------------------------------------------
		
        window.addEventListener('resize', function(event){ resizedFuctionForMap() });
     
        $(function() {
			$("#" + targetElement[0][0].id).resizable({
                resize: function(event, ui) {
					resizedFuctionForMap();
                }
            });
        });
        
        function resizedFuctionForMap(val)
        {
			refreshBtnForUSMapWithPins.style('left',(targetElement[0][0].clientWidth - 53) + "px")
			tableBtnForUSMapWithPins.style('left',(targetElement[0][0].clientWidth - 28) + "px")
			
            // positioning the map's top position based on table show or hide
			if(options.showTable == true){
				projection.scale(((targetElement[0][0].clientWidth) + (targetElement[0][0].clientHeight))/2.4)
				.translate([targetElement[0][0].clientWidth/1.9, targetElement[0][0].clientHeight/3.7]);
			}
			else if(options.showTable == false){
				projection.scale(((targetElement[0][0].clientWidth) + (targetElement[0][0].clientHeight))/2.4)
				.translate([targetElement[0][0].clientWidth/1.9, targetElement[0][0].clientHeight/2.2]);
			}
            
            svgPanelForUSMapWithPins.select("g").selectAll("path").attr('d', path);
            
            svgPanelForUSMapWithPins.select("g").selectAll("circle").attr("cx", function(d) { return projection([+d[options.keys.longitude], +d[options.keys.latitude]])[0]; })
            .attr("cy", function(d) { return projection([+d[options.keys.longitude], +d[options.keys.latitude]])[1]; })
			
			
			colWidth = []; 
			d3.select(".theadClassForUSMapWithPinsChart" + targetElement[0][0].id).selectAll("th").forEach(function(d,i){
					d.forEach(function(dd,j){
						colWidth[j] = d3.select(dd).node().getBoundingClientRect().width
					})
			})
			
			tablePanelForUSMapWithPins.select(".thead1ClassForUSMapWithPinsChart" + targetElement[0][0].id).selectAll('th').forEach(function(d,i){
						d.forEach(function(dd,j){ d3.select(dd).style("width",colWidth[j] + "px") })
			})
            
        }
 
    }, // US map with pins
	
	// ************************************************** Download Functionality  **************************************************
	downloadFunctionality: function(elementID,targetElement) {
        
         var downloadBtnImgVariable = document.createElement("IMG");
         downloadBtnImgVariable.src = "images/downloadIcon.png";
         downloadBtnImgVariable.style.width = "18px"
         downloadBtnImgVariable.style.height = "18px"
         downloadBtnImgVariable.style.marginLeft = "1px"
         downloadBtnImgVariable.style.marginTop = "1px"
        //  downloadBtnImgVariable.style.position = "absolute"
        //  downloadBtnImgVariable.style.top = "-122px"
        //  downloadBtnImgVariable.style.left = "1433px"
         downloadBtnImgVariable.style.opacity = 0.78;
         d3.select("#"+elementID)[0][0].appendChild(downloadBtnImgVariable)
        
        
        var downloadOptionsPanelDiv = targetElement.append("div").style("width","150px").style("height","190px").style('position','absolute').style('padding',"0px")
        .style("box-shadow", "0px 1px 1px #888888") .style('background-color',"#ffffff").style('top', 0 + 'px').style('right', '0')
        .style("display","none").style("box-shadow", "0px 0px 0px 0px #f3f3f3") .style("border", "1px solid #787878").style("box-sizing", "border-box").style("z-index", 1000)
        
        downloadOptionsPanelDiv.style('right', '0')
        
        downloadOptionsPanelDiv.append("p").style("width","100%").style("height","auto").style('position','absolute').style('margin-top',"20px").style('background-color',"#ffffff").style("font-size","14px").style("font-family","Verdana,sans-serif").style("text-indent","6px").style("color","#00001c").style("box-sizing","border-box").text("Download as:")
        
        var dwnOptPanDivCanBtn = downloadOptionsPanelDiv.append("div") .style("width","22px").style("height","21px").style('position','absolute')
        .style('margin-left','120px').style('margin-top','5px').style("box-shadow", "0px 0px 0px #ffffff") .style("border-style", "none")
        .style('background-color',"#FCFCFF")
        .style("border", "0.0px") .style("border-style", "solid").style('color','white')
        .style('padding',"0px") .style("border", "1px solid #f6f6f6").style("line-height","0px").style("box-sizing","border-box")
        var cancelBtnImgVar = document.createElement("IMG");
        cancelBtnImgVar.src = "images/closeIcon.png";
        cancelBtnImgVar.setAttribute("style","position:absolute; left:3px; top:2px; width:15px; height:15px; opacity:0.9; background-color:#fcfcff")
        dwnOptPanDivCanBtn[0][0].appendChild(cancelBtnImgVar)
        
        dwnOptPanDivCanBtn.on("click", function(){
			downloadOptionsPanelDiv.style("display", "none")
		})
        
        var downloadPNGBtn = downloadOptionsPanelDiv.append("button").attr("class","download-chart-as-PNG-image-button-class download-chart-as-PNG-image-button-class-"+targetElement[0][0].id).style("width","120px").style("height","20px").style('position','absolute')
        .style('margin-left','15px').style('margin-top','48px') .style("border-style", "none").style('background-color',"#b1d6ff")
        .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','12px').style("border-style", "solid").style('color','#303030')
        .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 0.1px #9f9f9f").style("border-radius","0px").style("cursor","pointer")
        var textForReRenderButton = document.createTextNode("PNG Image");
        downloadPNGBtn[0][0].appendChild(textForReRenderButton)
        
        var downloadJPEGBtn = downloadOptionsPanelDiv.append("button").attr("class","download-chart-as-JPEG-image-button-class download-chart-as-JPEG-image-button-class-"+targetElement[0][0].id).style("width","120px").style("height","20px").style('position','absolute')
        .style('margin-left','15px').style('margin-top','74px') .style("border-style", "none").style('background-color',"#b1d6ff")
        .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','12px').style("border-style", "solid").style('color','#303030')
        .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 0.1px #9f9f9f").style("border-radius","0px").style("cursor","pointer")
        var textForReRenderButton = document.createTextNode("JPEG Image");
        downloadJPEGBtn[0][0].appendChild(textForReRenderButton)
        
        var downloadPDFDocBtn = downloadOptionsPanelDiv.append("button").attr("class","download-chart-as-PDF-document-button-class download-chart-as-PDF-document-button-class-"+targetElement[0][0].id).style("width","120px").style("height","20px").style('position','absolute')
        .style('margin-left','15px').style('margin-top','100px') .style("border-style", "none").style('background-color',"#b1d6ff")
        .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','12px').style("border-style", "solid").style('color','#303030')
        .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 0.1px #9f9f9f").style("border-radius","0px").style("cursor","pointer")
        var textForReRenderButton = document.createTextNode("PDF Document");
        downloadPDFDocBtn[0][0].appendChild(textForReRenderButton)
        
        var downloadSVGVectorImgBtn = downloadOptionsPanelDiv.append("button").attr("class","download-chart-as-SVG-vector-image-button-class download-chart-as-SVG-vector-image-button-class-"+targetElement[0][0].id).style("width","120px").style("height","20px").style('position','absolute')
        .style('margin-left','15px').style('margin-top','126px') .style("border-style", "none").style('background-color',"#b1d6ff")
        .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','12px').style("border-style", "solid").style('color','#303030').style("display","none")
        .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 0.1px #9f9f9f").style("border-radius","0px").style("cursor","pointer")
        var textForReRenderButton = document.createTextNode("SVG Vector Image");
        downloadSVGVectorImgBtn[0][0].appendChild(textForReRenderButton)
        
        var downloadOptionsOrDiv = downloadOptionsPanelDiv.append("p").style("width","100%").style("height","auto").style('position','absolute').style('margin-top',"129px").style('background-color',"#ffffff").style("font-size","14px").style("font-family","Verdana,sans-serif").style("font-weight","Bold").style("text-align","center").style("color","#00001c").style("box-sizing","border-box").text("or")
        
        var printChartBtn = downloadOptionsPanelDiv.append("button").attr("class","print-chart-as-Image-button-class print-chart-as-Image-button-class-"+targetElement[0][0].id).style("width","120px").style("height","20px").style('position','absolute').style('margin-left','15px')
        .style('margin-top','152px') .style("border-style", "none").style('background-color',"#b1d6ff").style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','12px')
        .style("border-style", "solid").style('color','#303030').style("padding","0px").style("font-style","Normal").style("margin-bottom","10px")
        .style("box-shadow", "1px 1px 0.1px #9f9f9f").style("border-radius","0px").style("cursor","pointer")
        var textForReRenderButton = document.createTextNode("Print Chart");
        printChartBtn[0][0].appendChild(textForReRenderButton)

        var downloadXLSBtn = downloadOptionsPanelDiv.append("button").attr("class","download-chart-as-PNG-image-button-class download-chart-as-PNG-image-button-class-"+targetElement[0][0].id).style("width","120px").style("height","20px").style('position','absolute')
        .style('margin-left','15px').style('margin-top','48px') .style("border-style", "none").style('background-color',"#b1d6ff")
        .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','12px').style("border-style", "solid").style('color','#303030')
        .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 0.1px #9f9f9f").style("border-radius","0px").style("cursor","pointer")
        var textForReRenderButton = document.createTextNode("PNG Image");
        downloadXLSBtn[0][0].appendChild(textForReRenderButton)
        
        var downloadXLSXBtn = downloadOptionsPanelDiv.append("button").attr("class","download-chart-as-PNG-image-button-class download-chart-as-PNG-image-button-class-"+targetElement[0][0].id).style("width","120px").style("height","20px").style('position','absolute')
        .style('margin-left','15px').style('margin-top','48px') .style("border-style", "none").style('background-color',"#b1d6ff")
        .style("border", "0.0px") .style("border-color", "#4ea3ff") .style('font-size','12px').style("border-style", "solid").style('color','#303030')
        .style("padding","0px").style("font-style","Normal").style("margin-bottom","10px") .style("box-shadow", "1px 1px 0.1px #9f9f9f").style("border-radius","0px").style("cursor","pointer")
        var textForReRenderButton = document.createTextNode("PNG Image");
        downloadXLSXBtn[0][0].appendChild(textForReRenderButton)

        $("#" + elementID).on('click', function() {
            downloadOptionsPanelDiv.style("display","block")
        })
        
        d3.selectAll(".download-chart-as-PNG-image-button-class-"+targetElement[0][0].id+ ", .download-chart-as-JPEG-image-button-class-"+targetElement[0][0].id+ ", .download-chart-as-PDF-document-button-class-"+targetElement[0][0].id+ ", .download-chart-as-SVG-vector-image-button-class-"+targetElement[0][0].id+ ", .print-chart-as-Image-button-class-"+targetElement[0][0].id).on('click', function() {
            downloadOptionsPanelDiv.style("display","none")
        })
        
        window.addEventListener('resize', function(event){ resizeFunction() });
        
        $("#" + targetElement[0][0].id).bind('resize', function() { resizeFunction() });
        
        function resizeFunction() {
            downloadOptionsPanelDiv.style('right', '0')
        }
        
        //return downloadOptionsPanelDiv;
    },
    // maximizeFunctionality: function(elementID,targetElement){
       
    //     var width = $(window).width();
    //     var height = $(window).height(); 
      
    //     var svgContainer = targetElement.append("svg")                                  
    //       .attr("width", width)
    //       .attr("height", height);
    // }
} 

